
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

      var $parcel$global = globalThis;
    
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire0b5f"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire0b5f"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("ilwiq", function(module, exports) {

$parcel$export(module.exports, "ShaderChunk", () => $d5b33d7c30034067$export$955f9f2e84c43c8b);
$parcel$export(module.exports, "UniformsLib", () => $d5b33d7c30034067$export$6643083551874bf5);
$parcel$export(module.exports, "ShaderLib", () => $d5b33d7c30034067$export$bee4a7d47f8f5014);
$parcel$export(module.exports, "PMREMGenerator", () => $d5b33d7c30034067$export$6add42717753e221);
$parcel$export(module.exports, "WebGLUtils", () => $d5b33d7c30034067$export$ddaebcad857649a8);
$parcel$export(module.exports, "WebGLRenderer", () => $d5b33d7c30034067$export$f6cc00ef28d7cf97);
$parcel$export(module.exports, "AdditiveAnimationBlendMode", () => (parcelRequire("dyjou")).AdditiveAnimationBlendMode);
$parcel$export(module.exports, "AlwaysStencilFunc", () => (parcelRequire("dyjou")).AlwaysStencilFunc);
$parcel$export(module.exports, "AmbientLight", () => (parcelRequire("dyjou")).AmbientLight);
$parcel$export(module.exports, "AnimationAction", () => (parcelRequire("dyjou")).AnimationAction);
$parcel$export(module.exports, "AnimationClip", () => (parcelRequire("dyjou")).AnimationClip);
$parcel$export(module.exports, "AnimationLoader", () => (parcelRequire("dyjou")).AnimationLoader);
$parcel$export(module.exports, "AnimationMixer", () => (parcelRequire("dyjou")).AnimationMixer);
$parcel$export(module.exports, "AnimationObjectGroup", () => (parcelRequire("dyjou")).AnimationObjectGroup);
$parcel$export(module.exports, "AnimationUtils", () => (parcelRequire("dyjou")).AnimationUtils);
$parcel$export(module.exports, "ArcCurve", () => (parcelRequire("dyjou")).ArcCurve);
$parcel$export(module.exports, "ArrowHelper", () => (parcelRequire("dyjou")).ArrowHelper);
$parcel$export(module.exports, "AttachedBindMode", () => (parcelRequire("dyjou")).AttachedBindMode);
$parcel$export(module.exports, "Audio", () => (parcelRequire("dyjou")).Audio);
$parcel$export(module.exports, "AudioAnalyser", () => (parcelRequire("dyjou")).AudioAnalyser);
$parcel$export(module.exports, "AudioContext", () => (parcelRequire("dyjou")).AudioContext);
$parcel$export(module.exports, "AudioListener", () => (parcelRequire("dyjou")).AudioListener);
$parcel$export(module.exports, "AudioLoader", () => (parcelRequire("dyjou")).AudioLoader);
$parcel$export(module.exports, "AxesHelper", () => (parcelRequire("dyjou")).AxesHelper);
$parcel$export(module.exports, "BasicDepthPacking", () => (parcelRequire("dyjou")).BasicDepthPacking);
$parcel$export(module.exports, "BasicShadowMap", () => (parcelRequire("dyjou")).BasicShadowMap);
$parcel$export(module.exports, "BatchedMesh", () => (parcelRequire("dyjou")).BatchedMesh);
$parcel$export(module.exports, "Bone", () => (parcelRequire("dyjou")).Bone);
$parcel$export(module.exports, "BooleanKeyframeTrack", () => (parcelRequire("dyjou")).BooleanKeyframeTrack);
$parcel$export(module.exports, "Box2", () => (parcelRequire("dyjou")).Box2);
$parcel$export(module.exports, "Box3", () => (parcelRequire("dyjou")).Box3);
$parcel$export(module.exports, "Box3Helper", () => (parcelRequire("dyjou")).Box3Helper);
$parcel$export(module.exports, "BoxHelper", () => (parcelRequire("dyjou")).BoxHelper);
$parcel$export(module.exports, "BufferGeometryLoader", () => (parcelRequire("dyjou")).BufferGeometryLoader);
$parcel$export(module.exports, "Cache", () => (parcelRequire("dyjou")).Cache);
$parcel$export(module.exports, "Camera", () => (parcelRequire("dyjou")).Camera);
$parcel$export(module.exports, "CameraHelper", () => (parcelRequire("dyjou")).CameraHelper);
$parcel$export(module.exports, "CanvasTexture", () => (parcelRequire("dyjou")).CanvasTexture);
$parcel$export(module.exports, "CapsuleGeometry", () => (parcelRequire("dyjou")).CapsuleGeometry);
$parcel$export(module.exports, "CatmullRomCurve3", () => (parcelRequire("dyjou")).CatmullRomCurve3);
$parcel$export(module.exports, "CircleGeometry", () => (parcelRequire("dyjou")).CircleGeometry);
$parcel$export(module.exports, "Clock", () => (parcelRequire("dyjou")).Clock);
$parcel$export(module.exports, "ColorKeyframeTrack", () => (parcelRequire("dyjou")).ColorKeyframeTrack);
$parcel$export(module.exports, "CompressedArrayTexture", () => (parcelRequire("dyjou")).CompressedArrayTexture);
$parcel$export(module.exports, "CompressedCubeTexture", () => (parcelRequire("dyjou")).CompressedCubeTexture);
$parcel$export(module.exports, "CompressedTexture", () => (parcelRequire("dyjou")).CompressedTexture);
$parcel$export(module.exports, "CompressedTextureLoader", () => (parcelRequire("dyjou")).CompressedTextureLoader);
$parcel$export(module.exports, "ConeGeometry", () => (parcelRequire("dyjou")).ConeGeometry);
$parcel$export(module.exports, "Controls", () => (parcelRequire("dyjou")).Controls);
$parcel$export(module.exports, "CubeCamera", () => (parcelRequire("dyjou")).CubeCamera);
$parcel$export(module.exports, "CubeTextureLoader", () => (parcelRequire("dyjou")).CubeTextureLoader);
$parcel$export(module.exports, "CubicBezierCurve", () => (parcelRequire("dyjou")).CubicBezierCurve);
$parcel$export(module.exports, "CubicBezierCurve3", () => (parcelRequire("dyjou")).CubicBezierCurve3);
$parcel$export(module.exports, "CubicInterpolant", () => (parcelRequire("dyjou")).CubicInterpolant);
$parcel$export(module.exports, "CullFaceFrontBack", () => (parcelRequire("dyjou")).CullFaceFrontBack);
$parcel$export(module.exports, "Curve", () => (parcelRequire("dyjou")).Curve);
$parcel$export(module.exports, "CurvePath", () => (parcelRequire("dyjou")).CurvePath);
$parcel$export(module.exports, "CylinderGeometry", () => (parcelRequire("dyjou")).CylinderGeometry);
$parcel$export(module.exports, "Cylindrical", () => (parcelRequire("dyjou")).Cylindrical);
$parcel$export(module.exports, "DataTexture", () => (parcelRequire("dyjou")).DataTexture);
$parcel$export(module.exports, "DataTextureLoader", () => (parcelRequire("dyjou")).DataTextureLoader);
$parcel$export(module.exports, "DataUtils", () => (parcelRequire("dyjou")).DataUtils);
$parcel$export(module.exports, "DecrementStencilOp", () => (parcelRequire("dyjou")).DecrementStencilOp);
$parcel$export(module.exports, "DecrementWrapStencilOp", () => (parcelRequire("dyjou")).DecrementWrapStencilOp);
$parcel$export(module.exports, "DefaultLoadingManager", () => (parcelRequire("dyjou")).DefaultLoadingManager);
$parcel$export(module.exports, "DetachedBindMode", () => (parcelRequire("dyjou")).DetachedBindMode);
$parcel$export(module.exports, "DirectionalLight", () => (parcelRequire("dyjou")).DirectionalLight);
$parcel$export(module.exports, "DirectionalLightHelper", () => (parcelRequire("dyjou")).DirectionalLightHelper);
$parcel$export(module.exports, "DiscreteInterpolant", () => (parcelRequire("dyjou")).DiscreteInterpolant);
$parcel$export(module.exports, "DodecahedronGeometry", () => (parcelRequire("dyjou")).DodecahedronGeometry);
$parcel$export(module.exports, "DynamicCopyUsage", () => (parcelRequire("dyjou")).DynamicCopyUsage);
$parcel$export(module.exports, "DynamicDrawUsage", () => (parcelRequire("dyjou")).DynamicDrawUsage);
$parcel$export(module.exports, "DynamicReadUsage", () => (parcelRequire("dyjou")).DynamicReadUsage);
$parcel$export(module.exports, "EdgesGeometry", () => (parcelRequire("dyjou")).EdgesGeometry);
$parcel$export(module.exports, "EllipseCurve", () => (parcelRequire("dyjou")).EllipseCurve);
$parcel$export(module.exports, "EqualStencilFunc", () => (parcelRequire("dyjou")).EqualStencilFunc);
$parcel$export(module.exports, "ExtrudeGeometry", () => (parcelRequire("dyjou")).ExtrudeGeometry);
$parcel$export(module.exports, "FileLoader", () => (parcelRequire("dyjou")).FileLoader);
$parcel$export(module.exports, "Float16BufferAttribute", () => (parcelRequire("dyjou")).Float16BufferAttribute);
$parcel$export(module.exports, "Float32BufferAttribute", () => (parcelRequire("dyjou")).Float32BufferAttribute);
$parcel$export(module.exports, "Fog", () => (parcelRequire("dyjou")).Fog);
$parcel$export(module.exports, "FogExp2", () => (parcelRequire("dyjou")).FogExp2);
$parcel$export(module.exports, "FramebufferTexture", () => (parcelRequire("dyjou")).FramebufferTexture);
$parcel$export(module.exports, "GLBufferAttribute", () => (parcelRequire("dyjou")).GLBufferAttribute);
$parcel$export(module.exports, "GLSL1", () => (parcelRequire("dyjou")).GLSL1);
$parcel$export(module.exports, "GreaterEqualStencilFunc", () => (parcelRequire("dyjou")).GreaterEqualStencilFunc);
$parcel$export(module.exports, "GreaterStencilFunc", () => (parcelRequire("dyjou")).GreaterStencilFunc);
$parcel$export(module.exports, "GridHelper", () => (parcelRequire("dyjou")).GridHelper);
$parcel$export(module.exports, "Group", () => (parcelRequire("dyjou")).Group);
$parcel$export(module.exports, "HemisphereLight", () => (parcelRequire("dyjou")).HemisphereLight);
$parcel$export(module.exports, "HemisphereLightHelper", () => (parcelRequire("dyjou")).HemisphereLightHelper);
$parcel$export(module.exports, "IcosahedronGeometry", () => (parcelRequire("dyjou")).IcosahedronGeometry);
$parcel$export(module.exports, "ImageBitmapLoader", () => (parcelRequire("dyjou")).ImageBitmapLoader);
$parcel$export(module.exports, "ImageLoader", () => (parcelRequire("dyjou")).ImageLoader);
$parcel$export(module.exports, "ImageUtils", () => (parcelRequire("dyjou")).ImageUtils);
$parcel$export(module.exports, "IncrementStencilOp", () => (parcelRequire("dyjou")).IncrementStencilOp);
$parcel$export(module.exports, "IncrementWrapStencilOp", () => (parcelRequire("dyjou")).IncrementWrapStencilOp);
$parcel$export(module.exports, "InstancedBufferAttribute", () => (parcelRequire("dyjou")).InstancedBufferAttribute);
$parcel$export(module.exports, "InstancedBufferGeometry", () => (parcelRequire("dyjou")).InstancedBufferGeometry);
$parcel$export(module.exports, "InstancedInterleavedBuffer", () => (parcelRequire("dyjou")).InstancedInterleavedBuffer);
$parcel$export(module.exports, "InstancedMesh", () => (parcelRequire("dyjou")).InstancedMesh);
$parcel$export(module.exports, "Int16BufferAttribute", () => (parcelRequire("dyjou")).Int16BufferAttribute);
$parcel$export(module.exports, "Int32BufferAttribute", () => (parcelRequire("dyjou")).Int32BufferAttribute);
$parcel$export(module.exports, "Int8BufferAttribute", () => (parcelRequire("dyjou")).Int8BufferAttribute);
$parcel$export(module.exports, "InterleavedBuffer", () => (parcelRequire("dyjou")).InterleavedBuffer);
$parcel$export(module.exports, "InterleavedBufferAttribute", () => (parcelRequire("dyjou")).InterleavedBufferAttribute);
$parcel$export(module.exports, "Interpolant", () => (parcelRequire("dyjou")).Interpolant);
$parcel$export(module.exports, "InterpolateDiscrete", () => (parcelRequire("dyjou")).InterpolateDiscrete);
$parcel$export(module.exports, "InterpolateLinear", () => (parcelRequire("dyjou")).InterpolateLinear);
$parcel$export(module.exports, "InterpolateSmooth", () => (parcelRequire("dyjou")).InterpolateSmooth);
$parcel$export(module.exports, "InvertStencilOp", () => (parcelRequire("dyjou")).InvertStencilOp);
$parcel$export(module.exports, "KeepStencilOp", () => (parcelRequire("dyjou")).KeepStencilOp);
$parcel$export(module.exports, "KeyframeTrack", () => (parcelRequire("dyjou")).KeyframeTrack);
$parcel$export(module.exports, "LOD", () => (parcelRequire("dyjou")).LOD);
$parcel$export(module.exports, "LatheGeometry", () => (parcelRequire("dyjou")).LatheGeometry);
$parcel$export(module.exports, "LessEqualStencilFunc", () => (parcelRequire("dyjou")).LessEqualStencilFunc);
$parcel$export(module.exports, "LessStencilFunc", () => (parcelRequire("dyjou")).LessStencilFunc);
$parcel$export(module.exports, "Light", () => (parcelRequire("dyjou")).Light);
$parcel$export(module.exports, "LightProbe", () => (parcelRequire("dyjou")).LightProbe);
$parcel$export(module.exports, "Line", () => (parcelRequire("dyjou")).Line);
$parcel$export(module.exports, "Line3", () => (parcelRequire("dyjou")).Line3);
$parcel$export(module.exports, "LineBasicMaterial", () => (parcelRequire("dyjou")).LineBasicMaterial);
$parcel$export(module.exports, "LineCurve", () => (parcelRequire("dyjou")).LineCurve);
$parcel$export(module.exports, "LineCurve3", () => (parcelRequire("dyjou")).LineCurve3);
$parcel$export(module.exports, "LineDashedMaterial", () => (parcelRequire("dyjou")).LineDashedMaterial);
$parcel$export(module.exports, "LineLoop", () => (parcelRequire("dyjou")).LineLoop);
$parcel$export(module.exports, "LineSegments", () => (parcelRequire("dyjou")).LineSegments);
$parcel$export(module.exports, "LinearInterpolant", () => (parcelRequire("dyjou")).LinearInterpolant);
$parcel$export(module.exports, "LinearMipMapLinearFilter", () => (parcelRequire("dyjou")).LinearMipMapLinearFilter);
$parcel$export(module.exports, "LinearMipMapNearestFilter", () => (parcelRequire("dyjou")).LinearMipMapNearestFilter);
$parcel$export(module.exports, "Loader", () => (parcelRequire("dyjou")).Loader);
$parcel$export(module.exports, "LoaderUtils", () => (parcelRequire("dyjou")).LoaderUtils);
$parcel$export(module.exports, "LoadingManager", () => (parcelRequire("dyjou")).LoadingManager);
$parcel$export(module.exports, "LoopOnce", () => (parcelRequire("dyjou")).LoopOnce);
$parcel$export(module.exports, "LoopPingPong", () => (parcelRequire("dyjou")).LoopPingPong);
$parcel$export(module.exports, "LoopRepeat", () => (parcelRequire("dyjou")).LoopRepeat);
$parcel$export(module.exports, "MOUSE", () => (parcelRequire("dyjou")).MOUSE);
$parcel$export(module.exports, "Material", () => (parcelRequire("dyjou")).Material);
$parcel$export(module.exports, "MaterialLoader", () => (parcelRequire("dyjou")).MaterialLoader);
$parcel$export(module.exports, "MathUtils", () => (parcelRequire("dyjou")).MathUtils);
$parcel$export(module.exports, "Matrix2", () => (parcelRequire("dyjou")).Matrix2);
$parcel$export(module.exports, "MeshLambertMaterial", () => (parcelRequire("dyjou")).MeshLambertMaterial);
$parcel$export(module.exports, "MeshMatcapMaterial", () => (parcelRequire("dyjou")).MeshMatcapMaterial);
$parcel$export(module.exports, "MeshNormalMaterial", () => (parcelRequire("dyjou")).MeshNormalMaterial);
$parcel$export(module.exports, "MeshPhongMaterial", () => (parcelRequire("dyjou")).MeshPhongMaterial);
$parcel$export(module.exports, "MeshPhysicalMaterial", () => (parcelRequire("dyjou")).MeshPhysicalMaterial);
$parcel$export(module.exports, "MeshStandardMaterial", () => (parcelRequire("dyjou")).MeshStandardMaterial);
$parcel$export(module.exports, "MeshToonMaterial", () => (parcelRequire("dyjou")).MeshToonMaterial);
$parcel$export(module.exports, "NearestMipMapLinearFilter", () => (parcelRequire("dyjou")).NearestMipMapLinearFilter);
$parcel$export(module.exports, "NearestMipMapNearestFilter", () => (parcelRequire("dyjou")).NearestMipMapNearestFilter);
$parcel$export(module.exports, "NeverStencilFunc", () => (parcelRequire("dyjou")).NeverStencilFunc);
$parcel$export(module.exports, "NormalAnimationBlendMode", () => (parcelRequire("dyjou")).NormalAnimationBlendMode);
$parcel$export(module.exports, "NotEqualStencilFunc", () => (parcelRequire("dyjou")).NotEqualStencilFunc);
$parcel$export(module.exports, "NumberKeyframeTrack", () => (parcelRequire("dyjou")).NumberKeyframeTrack);
$parcel$export(module.exports, "Object3D", () => (parcelRequire("dyjou")).Object3D);
$parcel$export(module.exports, "ObjectLoader", () => (parcelRequire("dyjou")).ObjectLoader);
$parcel$export(module.exports, "OctahedronGeometry", () => (parcelRequire("dyjou")).OctahedronGeometry);
$parcel$export(module.exports, "Path", () => (parcelRequire("dyjou")).Path);
$parcel$export(module.exports, "PlaneHelper", () => (parcelRequire("dyjou")).PlaneHelper);
$parcel$export(module.exports, "PointLight", () => (parcelRequire("dyjou")).PointLight);
$parcel$export(module.exports, "PointLightHelper", () => (parcelRequire("dyjou")).PointLightHelper);
$parcel$export(module.exports, "Points", () => (parcelRequire("dyjou")).Points);
$parcel$export(module.exports, "PointsMaterial", () => (parcelRequire("dyjou")).PointsMaterial);
$parcel$export(module.exports, "PolarGridHelper", () => (parcelRequire("dyjou")).PolarGridHelper);
$parcel$export(module.exports, "PolyhedronGeometry", () => (parcelRequire("dyjou")).PolyhedronGeometry);
$parcel$export(module.exports, "PositionalAudio", () => (parcelRequire("dyjou")).PositionalAudio);
$parcel$export(module.exports, "PropertyBinding", () => (parcelRequire("dyjou")).PropertyBinding);
$parcel$export(module.exports, "PropertyMixer", () => (parcelRequire("dyjou")).PropertyMixer);
$parcel$export(module.exports, "QuadraticBezierCurve", () => (parcelRequire("dyjou")).QuadraticBezierCurve);
$parcel$export(module.exports, "QuadraticBezierCurve3", () => (parcelRequire("dyjou")).QuadraticBezierCurve3);
$parcel$export(module.exports, "Quaternion", () => (parcelRequire("dyjou")).Quaternion);
$parcel$export(module.exports, "QuaternionKeyframeTrack", () => (parcelRequire("dyjou")).QuaternionKeyframeTrack);
$parcel$export(module.exports, "QuaternionLinearInterpolant", () => (parcelRequire("dyjou")).QuaternionLinearInterpolant);
$parcel$export(module.exports, "RGBDepthPacking", () => (parcelRequire("dyjou")).RGBDepthPacking);
$parcel$export(module.exports, "RGBIntegerFormat", () => (parcelRequire("dyjou")).RGBIntegerFormat);
$parcel$export(module.exports, "RGDepthPacking", () => (parcelRequire("dyjou")).RGDepthPacking);
$parcel$export(module.exports, "RawShaderMaterial", () => (parcelRequire("dyjou")).RawShaderMaterial);
$parcel$export(module.exports, "Ray", () => (parcelRequire("dyjou")).Ray);
$parcel$export(module.exports, "Raycaster", () => (parcelRequire("dyjou")).Raycaster);
$parcel$export(module.exports, "RectAreaLight", () => (parcelRequire("dyjou")).RectAreaLight);
$parcel$export(module.exports, "RenderTarget", () => (parcelRequire("dyjou")).RenderTarget);
$parcel$export(module.exports, "RenderTarget3D", () => (parcelRequire("dyjou")).RenderTarget3D);
$parcel$export(module.exports, "RenderTargetArray", () => (parcelRequire("dyjou")).RenderTargetArray);
$parcel$export(module.exports, "ReplaceStencilOp", () => (parcelRequire("dyjou")).ReplaceStencilOp);
$parcel$export(module.exports, "RingGeometry", () => (parcelRequire("dyjou")).RingGeometry);
$parcel$export(module.exports, "Scene", () => (parcelRequire("dyjou")).Scene);
$parcel$export(module.exports, "ShadowMaterial", () => (parcelRequire("dyjou")).ShadowMaterial);
$parcel$export(module.exports, "Shape", () => (parcelRequire("dyjou")).Shape);
$parcel$export(module.exports, "ShapeGeometry", () => (parcelRequire("dyjou")).ShapeGeometry);
$parcel$export(module.exports, "ShapePath", () => (parcelRequire("dyjou")).ShapePath);
$parcel$export(module.exports, "ShapeUtils", () => (parcelRequire("dyjou")).ShapeUtils);
$parcel$export(module.exports, "Skeleton", () => (parcelRequire("dyjou")).Skeleton);
$parcel$export(module.exports, "SkeletonHelper", () => (parcelRequire("dyjou")).SkeletonHelper);
$parcel$export(module.exports, "SkinnedMesh", () => (parcelRequire("dyjou")).SkinnedMesh);
$parcel$export(module.exports, "Source", () => (parcelRequire("dyjou")).Source);
$parcel$export(module.exports, "Sphere", () => (parcelRequire("dyjou")).Sphere);
$parcel$export(module.exports, "SphereGeometry", () => (parcelRequire("dyjou")).SphereGeometry);
$parcel$export(module.exports, "Spherical", () => (parcelRequire("dyjou")).Spherical);
$parcel$export(module.exports, "SphericalHarmonics3", () => (parcelRequire("dyjou")).SphericalHarmonics3);
$parcel$export(module.exports, "SplineCurve", () => (parcelRequire("dyjou")).SplineCurve);
$parcel$export(module.exports, "SpotLight", () => (parcelRequire("dyjou")).SpotLight);
$parcel$export(module.exports, "SpotLightHelper", () => (parcelRequire("dyjou")).SpotLightHelper);
$parcel$export(module.exports, "Sprite", () => (parcelRequire("dyjou")).Sprite);
$parcel$export(module.exports, "SpriteMaterial", () => (parcelRequire("dyjou")).SpriteMaterial);
$parcel$export(module.exports, "StaticCopyUsage", () => (parcelRequire("dyjou")).StaticCopyUsage);
$parcel$export(module.exports, "StaticDrawUsage", () => (parcelRequire("dyjou")).StaticDrawUsage);
$parcel$export(module.exports, "StaticReadUsage", () => (parcelRequire("dyjou")).StaticReadUsage);
$parcel$export(module.exports, "StereoCamera", () => (parcelRequire("dyjou")).StereoCamera);
$parcel$export(module.exports, "StreamCopyUsage", () => (parcelRequire("dyjou")).StreamCopyUsage);
$parcel$export(module.exports, "StreamDrawUsage", () => (parcelRequire("dyjou")).StreamDrawUsage);
$parcel$export(module.exports, "StreamReadUsage", () => (parcelRequire("dyjou")).StreamReadUsage);
$parcel$export(module.exports, "StringKeyframeTrack", () => (parcelRequire("dyjou")).StringKeyframeTrack);
$parcel$export(module.exports, "TOUCH", () => (parcelRequire("dyjou")).TOUCH);
$parcel$export(module.exports, "TetrahedronGeometry", () => (parcelRequire("dyjou")).TetrahedronGeometry);
$parcel$export(module.exports, "TextureLoader", () => (parcelRequire("dyjou")).TextureLoader);
$parcel$export(module.exports, "TextureUtils", () => (parcelRequire("dyjou")).TextureUtils);
$parcel$export(module.exports, "TimestampQuery", () => (parcelRequire("dyjou")).TimestampQuery);
$parcel$export(module.exports, "TorusGeometry", () => (parcelRequire("dyjou")).TorusGeometry);
$parcel$export(module.exports, "TorusKnotGeometry", () => (parcelRequire("dyjou")).TorusKnotGeometry);
$parcel$export(module.exports, "Triangle", () => (parcelRequire("dyjou")).Triangle);
$parcel$export(module.exports, "TriangleFanDrawMode", () => (parcelRequire("dyjou")).TriangleFanDrawMode);
$parcel$export(module.exports, "TriangleStripDrawMode", () => (parcelRequire("dyjou")).TriangleStripDrawMode);
$parcel$export(module.exports, "TrianglesDrawMode", () => (parcelRequire("dyjou")).TrianglesDrawMode);
$parcel$export(module.exports, "TubeGeometry", () => (parcelRequire("dyjou")).TubeGeometry);
$parcel$export(module.exports, "UVMapping", () => (parcelRequire("dyjou")).UVMapping);
$parcel$export(module.exports, "Uint8BufferAttribute", () => (parcelRequire("dyjou")).Uint8BufferAttribute);
$parcel$export(module.exports, "Uint8ClampedBufferAttribute", () => (parcelRequire("dyjou")).Uint8ClampedBufferAttribute);
$parcel$export(module.exports, "Uniform", () => (parcelRequire("dyjou")).Uniform);
$parcel$export(module.exports, "UniformsGroup", () => (parcelRequire("dyjou")).UniformsGroup);
$parcel$export(module.exports, "VectorKeyframeTrack", () => (parcelRequire("dyjou")).VectorKeyframeTrack);
$parcel$export(module.exports, "VideoFrameTexture", () => (parcelRequire("dyjou")).VideoFrameTexture);
$parcel$export(module.exports, "VideoTexture", () => (parcelRequire("dyjou")).VideoTexture);
$parcel$export(module.exports, "WebGL3DRenderTarget", () => (parcelRequire("dyjou")).WebGL3DRenderTarget);
$parcel$export(module.exports, "WebGLArrayRenderTarget", () => (parcelRequire("dyjou")).WebGLArrayRenderTarget);
$parcel$export(module.exports, "WebGPUCoordinateSystem", () => (parcelRequire("dyjou")).WebGPUCoordinateSystem);
$parcel$export(module.exports, "WireframeGeometry", () => (parcelRequire("dyjou")).WireframeGeometry);
$parcel$export(module.exports, "WrapAroundEnding", () => (parcelRequire("dyjou")).WrapAroundEnding);
$parcel$export(module.exports, "ZeroCurvatureEnding", () => (parcelRequire("dyjou")).ZeroCurvatureEnding);
$parcel$export(module.exports, "ZeroSlopeEnding", () => (parcelRequire("dyjou")).ZeroSlopeEnding);
$parcel$export(module.exports, "ZeroStencilOp", () => (parcelRequire("dyjou")).ZeroStencilOp);
$parcel$export(module.exports, "ACESFilmicToneMapping", () => (parcelRequire("dyjou")).ACESFilmicToneMapping);
$parcel$export(module.exports, "AddEquation", () => (parcelRequire("dyjou")).AddEquation);
$parcel$export(module.exports, "AddOperation", () => (parcelRequire("dyjou")).AddOperation);
$parcel$export(module.exports, "AdditiveBlending", () => (parcelRequire("dyjou")).AdditiveBlending);
$parcel$export(module.exports, "AgXToneMapping", () => (parcelRequire("dyjou")).AgXToneMapping);
$parcel$export(module.exports, "AlphaFormat", () => (parcelRequire("dyjou")).AlphaFormat);
$parcel$export(module.exports, "AlwaysCompare", () => (parcelRequire("dyjou")).AlwaysCompare);
$parcel$export(module.exports, "AlwaysDepth", () => (parcelRequire("dyjou")).AlwaysDepth);
$parcel$export(module.exports, "ArrayCamera", () => (parcelRequire("dyjou")).ArrayCamera);
$parcel$export(module.exports, "BackSide", () => (parcelRequire("dyjou")).BackSide);
$parcel$export(module.exports, "BoxGeometry", () => (parcelRequire("dyjou")).BoxGeometry);
$parcel$export(module.exports, "BufferAttribute", () => (parcelRequire("dyjou")).BufferAttribute);
$parcel$export(module.exports, "BufferGeometry", () => (parcelRequire("dyjou")).BufferGeometry);
$parcel$export(module.exports, "ByteType", () => (parcelRequire("dyjou")).ByteType);
$parcel$export(module.exports, "CineonToneMapping", () => (parcelRequire("dyjou")).CineonToneMapping);
$parcel$export(module.exports, "ClampToEdgeWrapping", () => (parcelRequire("dyjou")).ClampToEdgeWrapping);
$parcel$export(module.exports, "Color", () => (parcelRequire("dyjou")).Color);
$parcel$export(module.exports, "ColorManagement", () => (parcelRequire("dyjou")).ColorManagement);
$parcel$export(module.exports, "ConstantAlphaFactor", () => (parcelRequire("dyjou")).ConstantAlphaFactor);
$parcel$export(module.exports, "ConstantColorFactor", () => (parcelRequire("dyjou")).ConstantColorFactor);
$parcel$export(module.exports, "CubeReflectionMapping", () => (parcelRequire("dyjou")).CubeReflectionMapping);
$parcel$export(module.exports, "CubeRefractionMapping", () => (parcelRequire("dyjou")).CubeRefractionMapping);
$parcel$export(module.exports, "CubeTexture", () => (parcelRequire("dyjou")).CubeTexture);
$parcel$export(module.exports, "CubeUVReflectionMapping", () => (parcelRequire("dyjou")).CubeUVReflectionMapping);
$parcel$export(module.exports, "CullFaceBack", () => (parcelRequire("dyjou")).CullFaceBack);
$parcel$export(module.exports, "CullFaceFront", () => (parcelRequire("dyjou")).CullFaceFront);
$parcel$export(module.exports, "CullFaceNone", () => (parcelRequire("dyjou")).CullFaceNone);
$parcel$export(module.exports, "CustomBlending", () => (parcelRequire("dyjou")).CustomBlending);
$parcel$export(module.exports, "CustomToneMapping", () => (parcelRequire("dyjou")).CustomToneMapping);
$parcel$export(module.exports, "Data3DTexture", () => (parcelRequire("dyjou")).Data3DTexture);
$parcel$export(module.exports, "DataArrayTexture", () => (parcelRequire("dyjou")).DataArrayTexture);
$parcel$export(module.exports, "DepthFormat", () => (parcelRequire("dyjou")).DepthFormat);
$parcel$export(module.exports, "DepthStencilFormat", () => (parcelRequire("dyjou")).DepthStencilFormat);
$parcel$export(module.exports, "DepthTexture", () => (parcelRequire("dyjou")).DepthTexture);
$parcel$export(module.exports, "DoubleSide", () => (parcelRequire("dyjou")).DoubleSide);
$parcel$export(module.exports, "DstAlphaFactor", () => (parcelRequire("dyjou")).DstAlphaFactor);
$parcel$export(module.exports, "DstColorFactor", () => (parcelRequire("dyjou")).DstColorFactor);
$parcel$export(module.exports, "EqualCompare", () => (parcelRequire("dyjou")).EqualCompare);
$parcel$export(module.exports, "EqualDepth", () => (parcelRequire("dyjou")).EqualDepth);
$parcel$export(module.exports, "EquirectangularReflectionMapping", () => (parcelRequire("dyjou")).EquirectangularReflectionMapping);
$parcel$export(module.exports, "EquirectangularRefractionMapping", () => (parcelRequire("dyjou")).EquirectangularRefractionMapping);
$parcel$export(module.exports, "Euler", () => (parcelRequire("dyjou")).Euler);
$parcel$export(module.exports, "EventDispatcher", () => (parcelRequire("dyjou")).EventDispatcher);
$parcel$export(module.exports, "FloatType", () => (parcelRequire("dyjou")).FloatType);
$parcel$export(module.exports, "FrontSide", () => (parcelRequire("dyjou")).FrontSide);
$parcel$export(module.exports, "Frustum", () => (parcelRequire("dyjou")).Frustum);
$parcel$export(module.exports, "GLSL3", () => (parcelRequire("dyjou")).GLSL3);
$parcel$export(module.exports, "GreaterCompare", () => (parcelRequire("dyjou")).GreaterCompare);
$parcel$export(module.exports, "GreaterDepth", () => (parcelRequire("dyjou")).GreaterDepth);
$parcel$export(module.exports, "GreaterEqualCompare", () => (parcelRequire("dyjou")).GreaterEqualCompare);
$parcel$export(module.exports, "GreaterEqualDepth", () => (parcelRequire("dyjou")).GreaterEqualDepth);
$parcel$export(module.exports, "HalfFloatType", () => (parcelRequire("dyjou")).HalfFloatType);
$parcel$export(module.exports, "IntType", () => (parcelRequire("dyjou")).IntType);
$parcel$export(module.exports, "Layers", () => (parcelRequire("dyjou")).Layers);
$parcel$export(module.exports, "LessCompare", () => (parcelRequire("dyjou")).LessCompare);
$parcel$export(module.exports, "LessDepth", () => (parcelRequire("dyjou")).LessDepth);
$parcel$export(module.exports, "LessEqualCompare", () => (parcelRequire("dyjou")).LessEqualCompare);
$parcel$export(module.exports, "LessEqualDepth", () => (parcelRequire("dyjou")).LessEqualDepth);
$parcel$export(module.exports, "LinearFilter", () => (parcelRequire("dyjou")).LinearFilter);
$parcel$export(module.exports, "LinearMipmapLinearFilter", () => (parcelRequire("dyjou")).LinearMipmapLinearFilter);
$parcel$export(module.exports, "LinearMipmapNearestFilter", () => (parcelRequire("dyjou")).LinearMipmapNearestFilter);
$parcel$export(module.exports, "LinearSRGBColorSpace", () => (parcelRequire("dyjou")).LinearSRGBColorSpace);
$parcel$export(module.exports, "LinearToneMapping", () => (parcelRequire("dyjou")).LinearToneMapping);
$parcel$export(module.exports, "LinearTransfer", () => (parcelRequire("dyjou")).LinearTransfer);
$parcel$export(module.exports, "LuminanceAlphaFormat", () => (parcelRequire("dyjou")).LuminanceAlphaFormat);
$parcel$export(module.exports, "LuminanceFormat", () => (parcelRequire("dyjou")).LuminanceFormat);
$parcel$export(module.exports, "Matrix3", () => (parcelRequire("dyjou")).Matrix3);
$parcel$export(module.exports, "Matrix4", () => (parcelRequire("dyjou")).Matrix4);
$parcel$export(module.exports, "MaxEquation", () => (parcelRequire("dyjou")).MaxEquation);
$parcel$export(module.exports, "Mesh", () => (parcelRequire("dyjou")).Mesh);
$parcel$export(module.exports, "MeshBasicMaterial", () => (parcelRequire("dyjou")).MeshBasicMaterial);
$parcel$export(module.exports, "MeshDepthMaterial", () => (parcelRequire("dyjou")).MeshDepthMaterial);
$parcel$export(module.exports, "MeshDistanceMaterial", () => (parcelRequire("dyjou")).MeshDistanceMaterial);
$parcel$export(module.exports, "MinEquation", () => (parcelRequire("dyjou")).MinEquation);
$parcel$export(module.exports, "MirroredRepeatWrapping", () => (parcelRequire("dyjou")).MirroredRepeatWrapping);
$parcel$export(module.exports, "MixOperation", () => (parcelRequire("dyjou")).MixOperation);
$parcel$export(module.exports, "MultiplyBlending", () => (parcelRequire("dyjou")).MultiplyBlending);
$parcel$export(module.exports, "MultiplyOperation", () => (parcelRequire("dyjou")).MultiplyOperation);
$parcel$export(module.exports, "NearestFilter", () => (parcelRequire("dyjou")).NearestFilter);
$parcel$export(module.exports, "NearestMipmapLinearFilter", () => (parcelRequire("dyjou")).NearestMipmapLinearFilter);
$parcel$export(module.exports, "NearestMipmapNearestFilter", () => (parcelRequire("dyjou")).NearestMipmapNearestFilter);
$parcel$export(module.exports, "NeutralToneMapping", () => (parcelRequire("dyjou")).NeutralToneMapping);
$parcel$export(module.exports, "NeverCompare", () => (parcelRequire("dyjou")).NeverCompare);
$parcel$export(module.exports, "NeverDepth", () => (parcelRequire("dyjou")).NeverDepth);
$parcel$export(module.exports, "NoBlending", () => (parcelRequire("dyjou")).NoBlending);
$parcel$export(module.exports, "NoColorSpace", () => (parcelRequire("dyjou")).NoColorSpace);
$parcel$export(module.exports, "NoToneMapping", () => (parcelRequire("dyjou")).NoToneMapping);
$parcel$export(module.exports, "NormalBlending", () => (parcelRequire("dyjou")).NormalBlending);
$parcel$export(module.exports, "NotEqualCompare", () => (parcelRequire("dyjou")).NotEqualCompare);
$parcel$export(module.exports, "NotEqualDepth", () => (parcelRequire("dyjou")).NotEqualDepth);
$parcel$export(module.exports, "ObjectSpaceNormalMap", () => (parcelRequire("dyjou")).ObjectSpaceNormalMap);
$parcel$export(module.exports, "OneFactor", () => (parcelRequire("dyjou")).OneFactor);
$parcel$export(module.exports, "OneMinusConstantAlphaFactor", () => (parcelRequire("dyjou")).OneMinusConstantAlphaFactor);
$parcel$export(module.exports, "OneMinusConstantColorFactor", () => (parcelRequire("dyjou")).OneMinusConstantColorFactor);
$parcel$export(module.exports, "OneMinusDstAlphaFactor", () => (parcelRequire("dyjou")).OneMinusDstAlphaFactor);
$parcel$export(module.exports, "OneMinusDstColorFactor", () => (parcelRequire("dyjou")).OneMinusDstColorFactor);
$parcel$export(module.exports, "OneMinusSrcAlphaFactor", () => (parcelRequire("dyjou")).OneMinusSrcAlphaFactor);
$parcel$export(module.exports, "OneMinusSrcColorFactor", () => (parcelRequire("dyjou")).OneMinusSrcColorFactor);
$parcel$export(module.exports, "OrthographicCamera", () => (parcelRequire("dyjou")).OrthographicCamera);
$parcel$export(module.exports, "PCFShadowMap", () => (parcelRequire("dyjou")).PCFShadowMap);
$parcel$export(module.exports, "PCFSoftShadowMap", () => (parcelRequire("dyjou")).PCFSoftShadowMap);
$parcel$export(module.exports, "PerspectiveCamera", () => (parcelRequire("dyjou")).PerspectiveCamera);
$parcel$export(module.exports, "Plane", () => (parcelRequire("dyjou")).Plane);
$parcel$export(module.exports, "PlaneGeometry", () => (parcelRequire("dyjou")).PlaneGeometry);
$parcel$export(module.exports, "RED_GREEN_RGTC2_Format", () => (parcelRequire("dyjou")).RED_GREEN_RGTC2_Format);
$parcel$export(module.exports, "RED_RGTC1_Format", () => (parcelRequire("dyjou")).RED_RGTC1_Format);
$parcel$export(module.exports, "REVISION", () => (parcelRequire("dyjou")).REVISION);
$parcel$export(module.exports, "RGBADepthPacking", () => (parcelRequire("dyjou")).RGBADepthPacking);
$parcel$export(module.exports, "RGBAFormat", () => (parcelRequire("dyjou")).RGBAFormat);
$parcel$export(module.exports, "RGBAIntegerFormat", () => (parcelRequire("dyjou")).RGBAIntegerFormat);
$parcel$export(module.exports, "RGBA_ASTC_10x10_Format", () => (parcelRequire("dyjou")).RGBA_ASTC_10x10_Format);
$parcel$export(module.exports, "RGBA_ASTC_10x5_Format", () => (parcelRequire("dyjou")).RGBA_ASTC_10x5_Format);
$parcel$export(module.exports, "RGBA_ASTC_10x6_Format", () => (parcelRequire("dyjou")).RGBA_ASTC_10x6_Format);
$parcel$export(module.exports, "RGBA_ASTC_10x8_Format", () => (parcelRequire("dyjou")).RGBA_ASTC_10x8_Format);
$parcel$export(module.exports, "RGBA_ASTC_12x10_Format", () => (parcelRequire("dyjou")).RGBA_ASTC_12x10_Format);
$parcel$export(module.exports, "RGBA_ASTC_12x12_Format", () => (parcelRequire("dyjou")).RGBA_ASTC_12x12_Format);
$parcel$export(module.exports, "RGBA_ASTC_4x4_Format", () => (parcelRequire("dyjou")).RGBA_ASTC_4x4_Format);
$parcel$export(module.exports, "RGBA_ASTC_5x4_Format", () => (parcelRequire("dyjou")).RGBA_ASTC_5x4_Format);
$parcel$export(module.exports, "RGBA_ASTC_5x5_Format", () => (parcelRequire("dyjou")).RGBA_ASTC_5x5_Format);
$parcel$export(module.exports, "RGBA_ASTC_6x5_Format", () => (parcelRequire("dyjou")).RGBA_ASTC_6x5_Format);
$parcel$export(module.exports, "RGBA_ASTC_6x6_Format", () => (parcelRequire("dyjou")).RGBA_ASTC_6x6_Format);
$parcel$export(module.exports, "RGBA_ASTC_8x5_Format", () => (parcelRequire("dyjou")).RGBA_ASTC_8x5_Format);
$parcel$export(module.exports, "RGBA_ASTC_8x6_Format", () => (parcelRequire("dyjou")).RGBA_ASTC_8x6_Format);
$parcel$export(module.exports, "RGBA_ASTC_8x8_Format", () => (parcelRequire("dyjou")).RGBA_ASTC_8x8_Format);
$parcel$export(module.exports, "RGBA_BPTC_Format", () => (parcelRequire("dyjou")).RGBA_BPTC_Format);
$parcel$export(module.exports, "RGBA_ETC2_EAC_Format", () => (parcelRequire("dyjou")).RGBA_ETC2_EAC_Format);
$parcel$export(module.exports, "RGBA_PVRTC_2BPPV1_Format", () => (parcelRequire("dyjou")).RGBA_PVRTC_2BPPV1_Format);
$parcel$export(module.exports, "RGBA_PVRTC_4BPPV1_Format", () => (parcelRequire("dyjou")).RGBA_PVRTC_4BPPV1_Format);
$parcel$export(module.exports, "RGBA_S3TC_DXT1_Format", () => (parcelRequire("dyjou")).RGBA_S3TC_DXT1_Format);
$parcel$export(module.exports, "RGBA_S3TC_DXT3_Format", () => (parcelRequire("dyjou")).RGBA_S3TC_DXT3_Format);
$parcel$export(module.exports, "RGBA_S3TC_DXT5_Format", () => (parcelRequire("dyjou")).RGBA_S3TC_DXT5_Format);
$parcel$export(module.exports, "RGBFormat", () => (parcelRequire("dyjou")).RGBFormat);
$parcel$export(module.exports, "RGB_BPTC_SIGNED_Format", () => (parcelRequire("dyjou")).RGB_BPTC_SIGNED_Format);
$parcel$export(module.exports, "RGB_BPTC_UNSIGNED_Format", () => (parcelRequire("dyjou")).RGB_BPTC_UNSIGNED_Format);
$parcel$export(module.exports, "RGB_ETC1_Format", () => (parcelRequire("dyjou")).RGB_ETC1_Format);
$parcel$export(module.exports, "RGB_ETC2_Format", () => (parcelRequire("dyjou")).RGB_ETC2_Format);
$parcel$export(module.exports, "RGB_PVRTC_2BPPV1_Format", () => (parcelRequire("dyjou")).RGB_PVRTC_2BPPV1_Format);
$parcel$export(module.exports, "RGB_PVRTC_4BPPV1_Format", () => (parcelRequire("dyjou")).RGB_PVRTC_4BPPV1_Format);
$parcel$export(module.exports, "RGB_S3TC_DXT1_Format", () => (parcelRequire("dyjou")).RGB_S3TC_DXT1_Format);
$parcel$export(module.exports, "RGFormat", () => (parcelRequire("dyjou")).RGFormat);
$parcel$export(module.exports, "RGIntegerFormat", () => (parcelRequire("dyjou")).RGIntegerFormat);
$parcel$export(module.exports, "RedFormat", () => (parcelRequire("dyjou")).RedFormat);
$parcel$export(module.exports, "RedIntegerFormat", () => (parcelRequire("dyjou")).RedIntegerFormat);
$parcel$export(module.exports, "ReinhardToneMapping", () => (parcelRequire("dyjou")).ReinhardToneMapping);
$parcel$export(module.exports, "RepeatWrapping", () => (parcelRequire("dyjou")).RepeatWrapping);
$parcel$export(module.exports, "ReverseSubtractEquation", () => (parcelRequire("dyjou")).ReverseSubtractEquation);
$parcel$export(module.exports, "SIGNED_RED_GREEN_RGTC2_Format", () => (parcelRequire("dyjou")).SIGNED_RED_GREEN_RGTC2_Format);
$parcel$export(module.exports, "SIGNED_RED_RGTC1_Format", () => (parcelRequire("dyjou")).SIGNED_RED_RGTC1_Format);
$parcel$export(module.exports, "SRGBColorSpace", () => (parcelRequire("dyjou")).SRGBColorSpace);
$parcel$export(module.exports, "SRGBTransfer", () => (parcelRequire("dyjou")).SRGBTransfer);
$parcel$export(module.exports, "ShaderMaterial", () => (parcelRequire("dyjou")).ShaderMaterial);
$parcel$export(module.exports, "ShortType", () => (parcelRequire("dyjou")).ShortType);
$parcel$export(module.exports, "SrcAlphaFactor", () => (parcelRequire("dyjou")).SrcAlphaFactor);
$parcel$export(module.exports, "SrcAlphaSaturateFactor", () => (parcelRequire("dyjou")).SrcAlphaSaturateFactor);
$parcel$export(module.exports, "SrcColorFactor", () => (parcelRequire("dyjou")).SrcColorFactor);
$parcel$export(module.exports, "SubtractEquation", () => (parcelRequire("dyjou")).SubtractEquation);
$parcel$export(module.exports, "SubtractiveBlending", () => (parcelRequire("dyjou")).SubtractiveBlending);
$parcel$export(module.exports, "TangentSpaceNormalMap", () => (parcelRequire("dyjou")).TangentSpaceNormalMap);
$parcel$export(module.exports, "Texture", () => (parcelRequire("dyjou")).Texture);
$parcel$export(module.exports, "Uint16BufferAttribute", () => (parcelRequire("dyjou")).Uint16BufferAttribute);
$parcel$export(module.exports, "Uint32BufferAttribute", () => (parcelRequire("dyjou")).Uint32BufferAttribute);
$parcel$export(module.exports, "UniformsUtils", () => (parcelRequire("dyjou")).UniformsUtils);
$parcel$export(module.exports, "UnsignedByteType", () => (parcelRequire("dyjou")).UnsignedByteType);
$parcel$export(module.exports, "UnsignedInt248Type", () => (parcelRequire("dyjou")).UnsignedInt248Type);
$parcel$export(module.exports, "UnsignedInt5999Type", () => (parcelRequire("dyjou")).UnsignedInt5999Type);
$parcel$export(module.exports, "UnsignedIntType", () => (parcelRequire("dyjou")).UnsignedIntType);
$parcel$export(module.exports, "UnsignedShort4444Type", () => (parcelRequire("dyjou")).UnsignedShort4444Type);
$parcel$export(module.exports, "UnsignedShort5551Type", () => (parcelRequire("dyjou")).UnsignedShort5551Type);
$parcel$export(module.exports, "UnsignedShortType", () => (parcelRequire("dyjou")).UnsignedShortType);
$parcel$export(module.exports, "VSMShadowMap", () => (parcelRequire("dyjou")).VSMShadowMap);
$parcel$export(module.exports, "Vector2", () => (parcelRequire("dyjou")).Vector2);
$parcel$export(module.exports, "Vector3", () => (parcelRequire("dyjou")).Vector3);
$parcel$export(module.exports, "Vector4", () => (parcelRequire("dyjou")).Vector4);
$parcel$export(module.exports, "WebGLCoordinateSystem", () => (parcelRequire("dyjou")).WebGLCoordinateSystem);
$parcel$export(module.exports, "WebGLCubeRenderTarget", () => (parcelRequire("dyjou")).WebGLCubeRenderTarget);
$parcel$export(module.exports, "WebGLRenderTarget", () => (parcelRequire("dyjou")).WebGLRenderTarget);
$parcel$export(module.exports, "WebXRController", () => (parcelRequire("dyjou")).WebXRController);
$parcel$export(module.exports, "ZeroFactor", () => (parcelRequire("dyjou")).ZeroFactor);
$parcel$export(module.exports, "createCanvasElement", () => (parcelRequire("dyjou")).createCanvasElement);
/**
 * @license
 * Copyright 2010-2025 Three.js Authors
 * SPDX-License-Identifier: MIT
 */ 
var $dyjou = parcelRequire("dyjou");
function $d5b33d7c30034067$var$WebGLAnimation() {
    let context = null;
    let isAnimating = false;
    let animationLoop = null;
    let requestId = null;
    function onAnimationFrame(time, frame) {
        animationLoop(time, frame);
        requestId = context.requestAnimationFrame(onAnimationFrame);
    }
    return {
        start: function() {
            if (isAnimating === true) return;
            if (animationLoop === null) return;
            requestId = context.requestAnimationFrame(onAnimationFrame);
            isAnimating = true;
        },
        stop: function() {
            context.cancelAnimationFrame(requestId);
            isAnimating = false;
        },
        setAnimationLoop: function(callback) {
            animationLoop = callback;
        },
        setContext: function(value) {
            context = value;
        }
    };
}
function $d5b33d7c30034067$var$WebGLAttributes(gl) {
    const buffers = new WeakMap();
    function createBuffer(attribute, bufferType) {
        const array = attribute.array;
        const usage = attribute.usage;
        const size = array.byteLength;
        const buffer = gl.createBuffer();
        gl.bindBuffer(bufferType, buffer);
        gl.bufferData(bufferType, array, usage);
        attribute.onUploadCallback();
        let type;
        if (array instanceof Float32Array) type = gl.FLOAT;
        else if (array instanceof Uint16Array) {
            if (attribute.isFloat16BufferAttribute) type = gl.HALF_FLOAT;
            else type = gl.UNSIGNED_SHORT;
        } else if (array instanceof Int16Array) type = gl.SHORT;
        else if (array instanceof Uint32Array) type = gl.UNSIGNED_INT;
        else if (array instanceof Int32Array) type = gl.INT;
        else if (array instanceof Int8Array) type = gl.BYTE;
        else if (array instanceof Uint8Array) type = gl.UNSIGNED_BYTE;
        else if (array instanceof Uint8ClampedArray) type = gl.UNSIGNED_BYTE;
        else throw new Error('THREE.WebGLAttributes: Unsupported buffer data format: ' + array);
        return {
            buffer: buffer,
            type: type,
            bytesPerElement: array.BYTES_PER_ELEMENT,
            version: attribute.version,
            size: size
        };
    }
    function updateBuffer(buffer, attribute, bufferType) {
        const array = attribute.array;
        const updateRanges = attribute.updateRanges;
        gl.bindBuffer(bufferType, buffer);
        if (updateRanges.length === 0) // Not using update ranges
        gl.bufferSubData(bufferType, 0, array);
        else {
            // Before applying update ranges, we merge any adjacent / overlapping
            // ranges to reduce load on `gl.bufferSubData`. Empirically, this has led
            // to performance improvements for applications which make heavy use of
            // update ranges. Likely due to GPU command overhead.
            //
            // Note that to reduce garbage collection between frames, we merge the
            // update ranges in-place. This is safe because this method will clear the
            // update ranges once updated.
            updateRanges.sort((a, b)=>a.start - b.start);
            // To merge the update ranges in-place, we work from left to right in the
            // existing updateRanges array, merging ranges. This may result in a final
            // array which is smaller than the original. This index tracks the last
            // index representing a merged range, any data after this index can be
            // trimmed once the merge algorithm is completed.
            let mergeIndex = 0;
            for(let i = 1; i < updateRanges.length; i++){
                const previousRange = updateRanges[mergeIndex];
                const range = updateRanges[i];
                // We add one here to merge adjacent ranges. This is safe because ranges
                // operate over positive integers.
                if (range.start <= previousRange.start + previousRange.count + 1) previousRange.count = Math.max(previousRange.count, range.start + range.count - previousRange.start);
                else {
                    ++mergeIndex;
                    updateRanges[mergeIndex] = range;
                }
            }
            // Trim the array to only contain the merged ranges.
            updateRanges.length = mergeIndex + 1;
            for(let i = 0, l = updateRanges.length; i < l; i++){
                const range = updateRanges[i];
                gl.bufferSubData(bufferType, range.start * array.BYTES_PER_ELEMENT, array, range.start, range.count);
            }
            attribute.clearUpdateRanges();
        }
        attribute.onUploadCallback();
    }
    //
    function get(attribute) {
        if (attribute.isInterleavedBufferAttribute) attribute = attribute.data;
        return buffers.get(attribute);
    }
    function remove(attribute) {
        if (attribute.isInterleavedBufferAttribute) attribute = attribute.data;
        const data = buffers.get(attribute);
        if (data) {
            gl.deleteBuffer(data.buffer);
            buffers.delete(attribute);
        }
    }
    function update(attribute, bufferType) {
        if (attribute.isInterleavedBufferAttribute) attribute = attribute.data;
        if (attribute.isGLBufferAttribute) {
            const cached = buffers.get(attribute);
            if (!cached || cached.version < attribute.version) buffers.set(attribute, {
                buffer: attribute.buffer,
                type: attribute.type,
                bytesPerElement: attribute.elementSize,
                version: attribute.version
            });
            return;
        }
        const data = buffers.get(attribute);
        if (data === undefined) buffers.set(attribute, createBuffer(attribute, bufferType));
        else if (data.version < attribute.version) {
            if (data.size !== attribute.array.byteLength) throw new Error('THREE.WebGLAttributes: The size of the buffer attribute\'s array buffer does not match the original size. Resizing buffer attributes is not supported.');
            updateBuffer(data.buffer, attribute, bufferType);
            data.version = attribute.version;
        }
    }
    return {
        get: get,
        remove: remove,
        update: update
    };
}
var $d5b33d7c30034067$var$alphahash_fragment = "#ifdef USE_ALPHAHASH\n\tif ( diffuseColor.a < getAlphaHashThreshold( vPosition ) ) discard;\n#endif";
var $d5b33d7c30034067$var$alphahash_pars_fragment = "#ifdef USE_ALPHAHASH\n\tconst float ALPHA_HASH_SCALE = 0.05;\n\tfloat hash2D( vec2 value ) {\n\t\treturn fract( 1.0e4 * sin( 17.0 * value.x + 0.1 * value.y ) * ( 0.1 + abs( sin( 13.0 * value.y + value.x ) ) ) );\n\t}\n\tfloat hash3D( vec3 value ) {\n\t\treturn hash2D( vec2( hash2D( value.xy ), value.z ) );\n\t}\n\tfloat getAlphaHashThreshold( vec3 position ) {\n\t\tfloat maxDeriv = max(\n\t\t\tlength( dFdx( position.xyz ) ),\n\t\t\tlength( dFdy( position.xyz ) )\n\t\t);\n\t\tfloat pixScale = 1.0 / ( ALPHA_HASH_SCALE * maxDeriv );\n\t\tvec2 pixScales = vec2(\n\t\t\texp2( floor( log2( pixScale ) ) ),\n\t\t\texp2( ceil( log2( pixScale ) ) )\n\t\t);\n\t\tvec2 alpha = vec2(\n\t\t\thash3D( floor( pixScales.x * position.xyz ) ),\n\t\t\thash3D( floor( pixScales.y * position.xyz ) )\n\t\t);\n\t\tfloat lerpFactor = fract( log2( pixScale ) );\n\t\tfloat x = ( 1.0 - lerpFactor ) * alpha.x + lerpFactor * alpha.y;\n\t\tfloat a = min( lerpFactor, 1.0 - lerpFactor );\n\t\tvec3 cases = vec3(\n\t\t\tx * x / ( 2.0 * a * ( 1.0 - a ) ),\n\t\t\t( x - 0.5 * a ) / ( 1.0 - a ),\n\t\t\t1.0 - ( ( 1.0 - x ) * ( 1.0 - x ) / ( 2.0 * a * ( 1.0 - a ) ) )\n\t\t);\n\t\tfloat threshold = ( x < ( 1.0 - a ) )\n\t\t\t? ( ( x < a ) ? cases.x : cases.y )\n\t\t\t: cases.z;\n\t\treturn clamp( threshold , 1.0e-6, 1.0 );\n\t}\n#endif";
var $d5b33d7c30034067$var$alphamap_fragment = "#ifdef USE_ALPHAMAP\n\tdiffuseColor.a *= texture2D( alphaMap, vAlphaMapUv ).g;\n#endif";
var $d5b33d7c30034067$var$alphamap_pars_fragment = "#ifdef USE_ALPHAMAP\n\tuniform sampler2D alphaMap;\n#endif";
var $d5b33d7c30034067$var$alphatest_fragment = "#ifdef USE_ALPHATEST\n\t#ifdef ALPHA_TO_COVERAGE\n\tdiffuseColor.a = smoothstep( alphaTest, alphaTest + fwidth( diffuseColor.a ), diffuseColor.a );\n\tif ( diffuseColor.a == 0.0 ) discard;\n\t#else\n\tif ( diffuseColor.a < alphaTest ) discard;\n\t#endif\n#endif";
var $d5b33d7c30034067$var$alphatest_pars_fragment = "#ifdef USE_ALPHATEST\n\tuniform float alphaTest;\n#endif";
var $d5b33d7c30034067$var$aomap_fragment = "#ifdef USE_AOMAP\n\tfloat ambientOcclusion = ( texture2D( aoMap, vAoMapUv ).r - 1.0 ) * aoMapIntensity + 1.0;\n\treflectedLight.indirectDiffuse *= ambientOcclusion;\n\t#if defined( USE_CLEARCOAT ) \n\t\tclearcoatSpecularIndirect *= ambientOcclusion;\n\t#endif\n\t#if defined( USE_SHEEN ) \n\t\tsheenSpecularIndirect *= ambientOcclusion;\n\t#endif\n\t#if defined( USE_ENVMAP ) && defined( STANDARD )\n\t\tfloat dotNV = saturate( dot( geometryNormal, geometryViewDir ) );\n\t\treflectedLight.indirectSpecular *= computeSpecularOcclusion( dotNV, ambientOcclusion, material.roughness );\n\t#endif\n#endif";
var $d5b33d7c30034067$var$aomap_pars_fragment = "#ifdef USE_AOMAP\n\tuniform sampler2D aoMap;\n\tuniform float aoMapIntensity;\n#endif";
var $d5b33d7c30034067$var$batching_pars_vertex = "#ifdef USE_BATCHING\n\t#if ! defined( GL_ANGLE_multi_draw )\n\t#define gl_DrawID _gl_DrawID\n\tuniform int _gl_DrawID;\n\t#endif\n\tuniform highp sampler2D batchingTexture;\n\tuniform highp usampler2D batchingIdTexture;\n\tmat4 getBatchingMatrix( const in float i ) {\n\t\tint size = textureSize( batchingTexture, 0 ).x;\n\t\tint j = int( i ) * 4;\n\t\tint x = j % size;\n\t\tint y = j / size;\n\t\tvec4 v1 = texelFetch( batchingTexture, ivec2( x, y ), 0 );\n\t\tvec4 v2 = texelFetch( batchingTexture, ivec2( x + 1, y ), 0 );\n\t\tvec4 v3 = texelFetch( batchingTexture, ivec2( x + 2, y ), 0 );\n\t\tvec4 v4 = texelFetch( batchingTexture, ivec2( x + 3, y ), 0 );\n\t\treturn mat4( v1, v2, v3, v4 );\n\t}\n\tfloat getIndirectIndex( const in int i ) {\n\t\tint size = textureSize( batchingIdTexture, 0 ).x;\n\t\tint x = i % size;\n\t\tint y = i / size;\n\t\treturn float( texelFetch( batchingIdTexture, ivec2( x, y ), 0 ).r );\n\t}\n#endif\n#ifdef USE_BATCHING_COLOR\n\tuniform sampler2D batchingColorTexture;\n\tvec3 getBatchingColor( const in float i ) {\n\t\tint size = textureSize( batchingColorTexture, 0 ).x;\n\t\tint j = int( i );\n\t\tint x = j % size;\n\t\tint y = j / size;\n\t\treturn texelFetch( batchingColorTexture, ivec2( x, y ), 0 ).rgb;\n\t}\n#endif";
var $d5b33d7c30034067$var$batching_vertex = "#ifdef USE_BATCHING\n\tmat4 batchingMatrix = getBatchingMatrix( getIndirectIndex( gl_DrawID ) );\n#endif";
var $d5b33d7c30034067$var$begin_vertex = "vec3 transformed = vec3( position );\n#ifdef USE_ALPHAHASH\n\tvPosition = vec3( position );\n#endif";
var $d5b33d7c30034067$var$beginnormal_vertex = "vec3 objectNormal = vec3( normal );\n#ifdef USE_TANGENT\n\tvec3 objectTangent = vec3( tangent.xyz );\n#endif";
var $d5b33d7c30034067$var$bsdfs = "float G_BlinnPhong_Implicit( ) {\n\treturn 0.25;\n}\nfloat D_BlinnPhong( const in float shininess, const in float dotNH ) {\n\treturn RECIPROCAL_PI * ( shininess * 0.5 + 1.0 ) * pow( dotNH, shininess );\n}\nvec3 BRDF_BlinnPhong( const in vec3 lightDir, const in vec3 viewDir, const in vec3 normal, const in vec3 specularColor, const in float shininess ) {\n\tvec3 halfDir = normalize( lightDir + viewDir );\n\tfloat dotNH = saturate( dot( normal, halfDir ) );\n\tfloat dotVH = saturate( dot( viewDir, halfDir ) );\n\tvec3 F = F_Schlick( specularColor, 1.0, dotVH );\n\tfloat G = G_BlinnPhong_Implicit( );\n\tfloat D = D_BlinnPhong( shininess, dotNH );\n\treturn F * ( G * D );\n} // validated";
var $d5b33d7c30034067$var$iridescence_fragment = "#ifdef USE_IRIDESCENCE\n\tconst mat3 XYZ_TO_REC709 = mat3(\n\t\t 3.2404542, -0.9692660,  0.0556434,\n\t\t-1.5371385,  1.8760108, -0.2040259,\n\t\t-0.4985314,  0.0415560,  1.0572252\n\t);\n\tvec3 Fresnel0ToIor( vec3 fresnel0 ) {\n\t\tvec3 sqrtF0 = sqrt( fresnel0 );\n\t\treturn ( vec3( 1.0 ) + sqrtF0 ) / ( vec3( 1.0 ) - sqrtF0 );\n\t}\n\tvec3 IorToFresnel0( vec3 transmittedIor, float incidentIor ) {\n\t\treturn pow2( ( transmittedIor - vec3( incidentIor ) ) / ( transmittedIor + vec3( incidentIor ) ) );\n\t}\n\tfloat IorToFresnel0( float transmittedIor, float incidentIor ) {\n\t\treturn pow2( ( transmittedIor - incidentIor ) / ( transmittedIor + incidentIor ));\n\t}\n\tvec3 evalSensitivity( float OPD, vec3 shift ) {\n\t\tfloat phase = 2.0 * PI * OPD * 1.0e-9;\n\t\tvec3 val = vec3( 5.4856e-13, 4.4201e-13, 5.2481e-13 );\n\t\tvec3 pos = vec3( 1.6810e+06, 1.7953e+06, 2.2084e+06 );\n\t\tvec3 var = vec3( 4.3278e+09, 9.3046e+09, 6.6121e+09 );\n\t\tvec3 xyz = val * sqrt( 2.0 * PI * var ) * cos( pos * phase + shift ) * exp( - pow2( phase ) * var );\n\t\txyz.x += 9.7470e-14 * sqrt( 2.0 * PI * 4.5282e+09 ) * cos( 2.2399e+06 * phase + shift[ 0 ] ) * exp( - 4.5282e+09 * pow2( phase ) );\n\t\txyz /= 1.0685e-7;\n\t\tvec3 rgb = XYZ_TO_REC709 * xyz;\n\t\treturn rgb;\n\t}\n\tvec3 evalIridescence( float outsideIOR, float eta2, float cosTheta1, float thinFilmThickness, vec3 baseF0 ) {\n\t\tvec3 I;\n\t\tfloat iridescenceIOR = mix( outsideIOR, eta2, smoothstep( 0.0, 0.03, thinFilmThickness ) );\n\t\tfloat sinTheta2Sq = pow2( outsideIOR / iridescenceIOR ) * ( 1.0 - pow2( cosTheta1 ) );\n\t\tfloat cosTheta2Sq = 1.0 - sinTheta2Sq;\n\t\tif ( cosTheta2Sq < 0.0 ) {\n\t\t\treturn vec3( 1.0 );\n\t\t}\n\t\tfloat cosTheta2 = sqrt( cosTheta2Sq );\n\t\tfloat R0 = IorToFresnel0( iridescenceIOR, outsideIOR );\n\t\tfloat R12 = F_Schlick( R0, 1.0, cosTheta1 );\n\t\tfloat T121 = 1.0 - R12;\n\t\tfloat phi12 = 0.0;\n\t\tif ( iridescenceIOR < outsideIOR ) phi12 = PI;\n\t\tfloat phi21 = PI - phi12;\n\t\tvec3 baseIOR = Fresnel0ToIor( clamp( baseF0, 0.0, 0.9999 ) );\t\tvec3 R1 = IorToFresnel0( baseIOR, iridescenceIOR );\n\t\tvec3 R23 = F_Schlick( R1, 1.0, cosTheta2 );\n\t\tvec3 phi23 = vec3( 0.0 );\n\t\tif ( baseIOR[ 0 ] < iridescenceIOR ) phi23[ 0 ] = PI;\n\t\tif ( baseIOR[ 1 ] < iridescenceIOR ) phi23[ 1 ] = PI;\n\t\tif ( baseIOR[ 2 ] < iridescenceIOR ) phi23[ 2 ] = PI;\n\t\tfloat OPD = 2.0 * iridescenceIOR * thinFilmThickness * cosTheta2;\n\t\tvec3 phi = vec3( phi21 ) + phi23;\n\t\tvec3 R123 = clamp( R12 * R23, 1e-5, 0.9999 );\n\t\tvec3 r123 = sqrt( R123 );\n\t\tvec3 Rs = pow2( T121 ) * R23 / ( vec3( 1.0 ) - R123 );\n\t\tvec3 C0 = R12 + Rs;\n\t\tI = C0;\n\t\tvec3 Cm = Rs - T121;\n\t\tfor ( int m = 1; m <= 2; ++ m ) {\n\t\t\tCm *= r123;\n\t\t\tvec3 Sm = 2.0 * evalSensitivity( float( m ) * OPD, float( m ) * phi );\n\t\t\tI += Cm * Sm;\n\t\t}\n\t\treturn max( I, vec3( 0.0 ) );\n\t}\n#endif";
var $d5b33d7c30034067$var$bumpmap_pars_fragment = "#ifdef USE_BUMPMAP\n\tuniform sampler2D bumpMap;\n\tuniform float bumpScale;\n\tvec2 dHdxy_fwd() {\n\t\tvec2 dSTdx = dFdx( vBumpMapUv );\n\t\tvec2 dSTdy = dFdy( vBumpMapUv );\n\t\tfloat Hll = bumpScale * texture2D( bumpMap, vBumpMapUv ).x;\n\t\tfloat dBx = bumpScale * texture2D( bumpMap, vBumpMapUv + dSTdx ).x - Hll;\n\t\tfloat dBy = bumpScale * texture2D( bumpMap, vBumpMapUv + dSTdy ).x - Hll;\n\t\treturn vec2( dBx, dBy );\n\t}\n\tvec3 perturbNormalArb( vec3 surf_pos, vec3 surf_norm, vec2 dHdxy, float faceDirection ) {\n\t\tvec3 vSigmaX = normalize( dFdx( surf_pos.xyz ) );\n\t\tvec3 vSigmaY = normalize( dFdy( surf_pos.xyz ) );\n\t\tvec3 vN = surf_norm;\n\t\tvec3 R1 = cross( vSigmaY, vN );\n\t\tvec3 R2 = cross( vN, vSigmaX );\n\t\tfloat fDet = dot( vSigmaX, R1 ) * faceDirection;\n\t\tvec3 vGrad = sign( fDet ) * ( dHdxy.x * R1 + dHdxy.y * R2 );\n\t\treturn normalize( abs( fDet ) * surf_norm - vGrad );\n\t}\n#endif";
var $d5b33d7c30034067$var$clipping_planes_fragment = "#if NUM_CLIPPING_PLANES > 0\n\tvec4 plane;\n\t#ifdef ALPHA_TO_COVERAGE\n\t\tfloat distanceToPlane, distanceGradient;\n\t\tfloat clipOpacity = 1.0;\n\t\t#pragma unroll_loop_start\n\t\tfor ( int i = 0; i < UNION_CLIPPING_PLANES; i ++ ) {\n\t\t\tplane = clippingPlanes[ i ];\n\t\t\tdistanceToPlane = - dot( vClipPosition, plane.xyz ) + plane.w;\n\t\t\tdistanceGradient = fwidth( distanceToPlane ) / 2.0;\n\t\t\tclipOpacity *= smoothstep( - distanceGradient, distanceGradient, distanceToPlane );\n\t\t\tif ( clipOpacity == 0.0 ) discard;\n\t\t}\n\t\t#pragma unroll_loop_end\n\t\t#if UNION_CLIPPING_PLANES < NUM_CLIPPING_PLANES\n\t\t\tfloat unionClipOpacity = 1.0;\n\t\t\t#pragma unroll_loop_start\n\t\t\tfor ( int i = UNION_CLIPPING_PLANES; i < NUM_CLIPPING_PLANES; i ++ ) {\n\t\t\t\tplane = clippingPlanes[ i ];\n\t\t\t\tdistanceToPlane = - dot( vClipPosition, plane.xyz ) + plane.w;\n\t\t\t\tdistanceGradient = fwidth( distanceToPlane ) / 2.0;\n\t\t\t\tunionClipOpacity *= 1.0 - smoothstep( - distanceGradient, distanceGradient, distanceToPlane );\n\t\t\t}\n\t\t\t#pragma unroll_loop_end\n\t\t\tclipOpacity *= 1.0 - unionClipOpacity;\n\t\t#endif\n\t\tdiffuseColor.a *= clipOpacity;\n\t\tif ( diffuseColor.a == 0.0 ) discard;\n\t#else\n\t\t#pragma unroll_loop_start\n\t\tfor ( int i = 0; i < UNION_CLIPPING_PLANES; i ++ ) {\n\t\t\tplane = clippingPlanes[ i ];\n\t\t\tif ( dot( vClipPosition, plane.xyz ) > plane.w ) discard;\n\t\t}\n\t\t#pragma unroll_loop_end\n\t\t#if UNION_CLIPPING_PLANES < NUM_CLIPPING_PLANES\n\t\t\tbool clipped = true;\n\t\t\t#pragma unroll_loop_start\n\t\t\tfor ( int i = UNION_CLIPPING_PLANES; i < NUM_CLIPPING_PLANES; i ++ ) {\n\t\t\t\tplane = clippingPlanes[ i ];\n\t\t\t\tclipped = ( dot( vClipPosition, plane.xyz ) > plane.w ) && clipped;\n\t\t\t}\n\t\t\t#pragma unroll_loop_end\n\t\t\tif ( clipped ) discard;\n\t\t#endif\n\t#endif\n#endif";
var $d5b33d7c30034067$var$clipping_planes_pars_fragment = "#if NUM_CLIPPING_PLANES > 0\n\tvarying vec3 vClipPosition;\n\tuniform vec4 clippingPlanes[ NUM_CLIPPING_PLANES ];\n#endif";
var $d5b33d7c30034067$var$clipping_planes_pars_vertex = "#if NUM_CLIPPING_PLANES > 0\n\tvarying vec3 vClipPosition;\n#endif";
var $d5b33d7c30034067$var$clipping_planes_vertex = "#if NUM_CLIPPING_PLANES > 0\n\tvClipPosition = - mvPosition.xyz;\n#endif";
var $d5b33d7c30034067$var$color_fragment = "#if defined( USE_COLOR_ALPHA )\n\tdiffuseColor *= vColor;\n#elif defined( USE_COLOR )\n\tdiffuseColor.rgb *= vColor;\n#endif";
var $d5b33d7c30034067$var$color_pars_fragment = "#if defined( USE_COLOR_ALPHA )\n\tvarying vec4 vColor;\n#elif defined( USE_COLOR )\n\tvarying vec3 vColor;\n#endif";
var $d5b33d7c30034067$var$color_pars_vertex = "#if defined( USE_COLOR_ALPHA )\n\tvarying vec4 vColor;\n#elif defined( USE_COLOR ) || defined( USE_INSTANCING_COLOR ) || defined( USE_BATCHING_COLOR )\n\tvarying vec3 vColor;\n#endif";
var $d5b33d7c30034067$var$color_vertex = "#if defined( USE_COLOR_ALPHA )\n\tvColor = vec4( 1.0 );\n#elif defined( USE_COLOR ) || defined( USE_INSTANCING_COLOR ) || defined( USE_BATCHING_COLOR )\n\tvColor = vec3( 1.0 );\n#endif\n#ifdef USE_COLOR\n\tvColor *= color;\n#endif\n#ifdef USE_INSTANCING_COLOR\n\tvColor.xyz *= instanceColor.xyz;\n#endif\n#ifdef USE_BATCHING_COLOR\n\tvec3 batchingColor = getBatchingColor( getIndirectIndex( gl_DrawID ) );\n\tvColor.xyz *= batchingColor.xyz;\n#endif";
var $d5b33d7c30034067$var$common = "#define PI 3.141592653589793\n#define PI2 6.283185307179586\n#define PI_HALF 1.5707963267948966\n#define RECIPROCAL_PI 0.3183098861837907\n#define RECIPROCAL_PI2 0.15915494309189535\n#define EPSILON 1e-6\n#ifndef saturate\n#define saturate( a ) clamp( a, 0.0, 1.0 )\n#endif\n#define whiteComplement( a ) ( 1.0 - saturate( a ) )\nfloat pow2( const in float x ) { return x*x; }\nvec3 pow2( const in vec3 x ) { return x*x; }\nfloat pow3( const in float x ) { return x*x*x; }\nfloat pow4( const in float x ) { float x2 = x*x; return x2*x2; }\nfloat max3( const in vec3 v ) { return max( max( v.x, v.y ), v.z ); }\nfloat average( const in vec3 v ) { return dot( v, vec3( 0.3333333 ) ); }\nhighp float rand( const in vec2 uv ) {\n\tconst highp float a = 12.9898, b = 78.233, c = 43758.5453;\n\thighp float dt = dot( uv.xy, vec2( a,b ) ), sn = mod( dt, PI );\n\treturn fract( sin( sn ) * c );\n}\n#ifdef HIGH_PRECISION\n\tfloat precisionSafeLength( vec3 v ) { return length( v ); }\n#else\n\tfloat precisionSafeLength( vec3 v ) {\n\t\tfloat maxComponent = max3( abs( v ) );\n\t\treturn length( v / maxComponent ) * maxComponent;\n\t}\n#endif\nstruct IncidentLight {\n\tvec3 color;\n\tvec3 direction;\n\tbool visible;\n};\nstruct ReflectedLight {\n\tvec3 directDiffuse;\n\tvec3 directSpecular;\n\tvec3 indirectDiffuse;\n\tvec3 indirectSpecular;\n};\n#ifdef USE_ALPHAHASH\n\tvarying vec3 vPosition;\n#endif\nvec3 transformDirection( in vec3 dir, in mat4 matrix ) {\n\treturn normalize( ( matrix * vec4( dir, 0.0 ) ).xyz );\n}\nvec3 inverseTransformDirection( in vec3 dir, in mat4 matrix ) {\n\treturn normalize( ( vec4( dir, 0.0 ) * matrix ).xyz );\n}\nmat3 transposeMat3( const in mat3 m ) {\n\tmat3 tmp;\n\ttmp[ 0 ] = vec3( m[ 0 ].x, m[ 1 ].x, m[ 2 ].x );\n\ttmp[ 1 ] = vec3( m[ 0 ].y, m[ 1 ].y, m[ 2 ].y );\n\ttmp[ 2 ] = vec3( m[ 0 ].z, m[ 1 ].z, m[ 2 ].z );\n\treturn tmp;\n}\nbool isPerspectiveMatrix( mat4 m ) {\n\treturn m[ 2 ][ 3 ] == - 1.0;\n}\nvec2 equirectUv( in vec3 dir ) {\n\tfloat u = atan( dir.z, dir.x ) * RECIPROCAL_PI2 + 0.5;\n\tfloat v = asin( clamp( dir.y, - 1.0, 1.0 ) ) * RECIPROCAL_PI + 0.5;\n\treturn vec2( u, v );\n}\nvec3 BRDF_Lambert( const in vec3 diffuseColor ) {\n\treturn RECIPROCAL_PI * diffuseColor;\n}\nvec3 F_Schlick( const in vec3 f0, const in float f90, const in float dotVH ) {\n\tfloat fresnel = exp2( ( - 5.55473 * dotVH - 6.98316 ) * dotVH );\n\treturn f0 * ( 1.0 - fresnel ) + ( f90 * fresnel );\n}\nfloat F_Schlick( const in float f0, const in float f90, const in float dotVH ) {\n\tfloat fresnel = exp2( ( - 5.55473 * dotVH - 6.98316 ) * dotVH );\n\treturn f0 * ( 1.0 - fresnel ) + ( f90 * fresnel );\n} // validated";
var $d5b33d7c30034067$var$cube_uv_reflection_fragment = "#ifdef ENVMAP_TYPE_CUBE_UV\n\t#define cubeUV_minMipLevel 4.0\n\t#define cubeUV_minTileSize 16.0\n\tfloat getFace( vec3 direction ) {\n\t\tvec3 absDirection = abs( direction );\n\t\tfloat face = - 1.0;\n\t\tif ( absDirection.x > absDirection.z ) {\n\t\t\tif ( absDirection.x > absDirection.y )\n\t\t\t\tface = direction.x > 0.0 ? 0.0 : 3.0;\n\t\t\telse\n\t\t\t\tface = direction.y > 0.0 ? 1.0 : 4.0;\n\t\t} else {\n\t\t\tif ( absDirection.z > absDirection.y )\n\t\t\t\tface = direction.z > 0.0 ? 2.0 : 5.0;\n\t\t\telse\n\t\t\t\tface = direction.y > 0.0 ? 1.0 : 4.0;\n\t\t}\n\t\treturn face;\n\t}\n\tvec2 getUV( vec3 direction, float face ) {\n\t\tvec2 uv;\n\t\tif ( face == 0.0 ) {\n\t\t\tuv = vec2( direction.z, direction.y ) / abs( direction.x );\n\t\t} else if ( face == 1.0 ) {\n\t\t\tuv = vec2( - direction.x, - direction.z ) / abs( direction.y );\n\t\t} else if ( face == 2.0 ) {\n\t\t\tuv = vec2( - direction.x, direction.y ) / abs( direction.z );\n\t\t} else if ( face == 3.0 ) {\n\t\t\tuv = vec2( - direction.z, direction.y ) / abs( direction.x );\n\t\t} else if ( face == 4.0 ) {\n\t\t\tuv = vec2( - direction.x, direction.z ) / abs( direction.y );\n\t\t} else {\n\t\t\tuv = vec2( direction.x, direction.y ) / abs( direction.z );\n\t\t}\n\t\treturn 0.5 * ( uv + 1.0 );\n\t}\n\tvec3 bilinearCubeUV( sampler2D envMap, vec3 direction, float mipInt ) {\n\t\tfloat face = getFace( direction );\n\t\tfloat filterInt = max( cubeUV_minMipLevel - mipInt, 0.0 );\n\t\tmipInt = max( mipInt, cubeUV_minMipLevel );\n\t\tfloat faceSize = exp2( mipInt );\n\t\thighp vec2 uv = getUV( direction, face ) * ( faceSize - 2.0 ) + 1.0;\n\t\tif ( face > 2.0 ) {\n\t\t\tuv.y += faceSize;\n\t\t\tface -= 3.0;\n\t\t}\n\t\tuv.x += face * faceSize;\n\t\tuv.x += filterInt * 3.0 * cubeUV_minTileSize;\n\t\tuv.y += 4.0 * ( exp2( CUBEUV_MAX_MIP ) - faceSize );\n\t\tuv.x *= CUBEUV_TEXEL_WIDTH;\n\t\tuv.y *= CUBEUV_TEXEL_HEIGHT;\n\t\t#ifdef texture2DGradEXT\n\t\t\treturn texture2DGradEXT( envMap, uv, vec2( 0.0 ), vec2( 0.0 ) ).rgb;\n\t\t#else\n\t\t\treturn texture2D( envMap, uv ).rgb;\n\t\t#endif\n\t}\n\t#define cubeUV_r0 1.0\n\t#define cubeUV_m0 - 2.0\n\t#define cubeUV_r1 0.8\n\t#define cubeUV_m1 - 1.0\n\t#define cubeUV_r4 0.4\n\t#define cubeUV_m4 2.0\n\t#define cubeUV_r5 0.305\n\t#define cubeUV_m5 3.0\n\t#define cubeUV_r6 0.21\n\t#define cubeUV_m6 4.0\n\tfloat roughnessToMip( float roughness ) {\n\t\tfloat mip = 0.0;\n\t\tif ( roughness >= cubeUV_r1 ) {\n\t\t\tmip = ( cubeUV_r0 - roughness ) * ( cubeUV_m1 - cubeUV_m0 ) / ( cubeUV_r0 - cubeUV_r1 ) + cubeUV_m0;\n\t\t} else if ( roughness >= cubeUV_r4 ) {\n\t\t\tmip = ( cubeUV_r1 - roughness ) * ( cubeUV_m4 - cubeUV_m1 ) / ( cubeUV_r1 - cubeUV_r4 ) + cubeUV_m1;\n\t\t} else if ( roughness >= cubeUV_r5 ) {\n\t\t\tmip = ( cubeUV_r4 - roughness ) * ( cubeUV_m5 - cubeUV_m4 ) / ( cubeUV_r4 - cubeUV_r5 ) + cubeUV_m4;\n\t\t} else if ( roughness >= cubeUV_r6 ) {\n\t\t\tmip = ( cubeUV_r5 - roughness ) * ( cubeUV_m6 - cubeUV_m5 ) / ( cubeUV_r5 - cubeUV_r6 ) + cubeUV_m5;\n\t\t} else {\n\t\t\tmip = - 2.0 * log2( 1.16 * roughness );\t\t}\n\t\treturn mip;\n\t}\n\tvec4 textureCubeUV( sampler2D envMap, vec3 sampleDir, float roughness ) {\n\t\tfloat mip = clamp( roughnessToMip( roughness ), cubeUV_m0, CUBEUV_MAX_MIP );\n\t\tfloat mipF = fract( mip );\n\t\tfloat mipInt = floor( mip );\n\t\tvec3 color0 = bilinearCubeUV( envMap, sampleDir, mipInt );\n\t\tif ( mipF == 0.0 ) {\n\t\t\treturn vec4( color0, 1.0 );\n\t\t} else {\n\t\t\tvec3 color1 = bilinearCubeUV( envMap, sampleDir, mipInt + 1.0 );\n\t\t\treturn vec4( mix( color0, color1, mipF ), 1.0 );\n\t\t}\n\t}\n#endif";
var $d5b33d7c30034067$var$defaultnormal_vertex = "vec3 transformedNormal = objectNormal;\n#ifdef USE_TANGENT\n\tvec3 transformedTangent = objectTangent;\n#endif\n#ifdef USE_BATCHING\n\tmat3 bm = mat3( batchingMatrix );\n\ttransformedNormal /= vec3( dot( bm[ 0 ], bm[ 0 ] ), dot( bm[ 1 ], bm[ 1 ] ), dot( bm[ 2 ], bm[ 2 ] ) );\n\ttransformedNormal = bm * transformedNormal;\n\t#ifdef USE_TANGENT\n\t\ttransformedTangent = bm * transformedTangent;\n\t#endif\n#endif\n#ifdef USE_INSTANCING\n\tmat3 im = mat3( instanceMatrix );\n\ttransformedNormal /= vec3( dot( im[ 0 ], im[ 0 ] ), dot( im[ 1 ], im[ 1 ] ), dot( im[ 2 ], im[ 2 ] ) );\n\ttransformedNormal = im * transformedNormal;\n\t#ifdef USE_TANGENT\n\t\ttransformedTangent = im * transformedTangent;\n\t#endif\n#endif\ntransformedNormal = normalMatrix * transformedNormal;\n#ifdef FLIP_SIDED\n\ttransformedNormal = - transformedNormal;\n#endif\n#ifdef USE_TANGENT\n\ttransformedTangent = ( modelViewMatrix * vec4( transformedTangent, 0.0 ) ).xyz;\n\t#ifdef FLIP_SIDED\n\t\ttransformedTangent = - transformedTangent;\n\t#endif\n#endif";
var $d5b33d7c30034067$var$displacementmap_pars_vertex = "#ifdef USE_DISPLACEMENTMAP\n\tuniform sampler2D displacementMap;\n\tuniform float displacementScale;\n\tuniform float displacementBias;\n#endif";
var $d5b33d7c30034067$var$displacementmap_vertex = "#ifdef USE_DISPLACEMENTMAP\n\ttransformed += normalize( objectNormal ) * ( texture2D( displacementMap, vDisplacementMapUv ).x * displacementScale + displacementBias );\n#endif";
var $d5b33d7c30034067$var$emissivemap_fragment = "#ifdef USE_EMISSIVEMAP\n\tvec4 emissiveColor = texture2D( emissiveMap, vEmissiveMapUv );\n\t#ifdef DECODE_VIDEO_TEXTURE_EMISSIVE\n\t\temissiveColor = sRGBTransferEOTF( emissiveColor );\n\t#endif\n\ttotalEmissiveRadiance *= emissiveColor.rgb;\n#endif";
var $d5b33d7c30034067$var$emissivemap_pars_fragment = "#ifdef USE_EMISSIVEMAP\n\tuniform sampler2D emissiveMap;\n#endif";
var $d5b33d7c30034067$var$colorspace_fragment = "gl_FragColor = linearToOutputTexel( gl_FragColor );";
var $d5b33d7c30034067$var$colorspace_pars_fragment = "vec4 LinearTransferOETF( in vec4 value ) {\n\treturn value;\n}\nvec4 sRGBTransferEOTF( in vec4 value ) {\n\treturn vec4( mix( pow( value.rgb * 0.9478672986 + vec3( 0.0521327014 ), vec3( 2.4 ) ), value.rgb * 0.0773993808, vec3( lessThanEqual( value.rgb, vec3( 0.04045 ) ) ) ), value.a );\n}\nvec4 sRGBTransferOETF( in vec4 value ) {\n\treturn vec4( mix( pow( value.rgb, vec3( 0.41666 ) ) * 1.055 - vec3( 0.055 ), value.rgb * 12.92, vec3( lessThanEqual( value.rgb, vec3( 0.0031308 ) ) ) ), value.a );\n}";
var $d5b33d7c30034067$var$envmap_fragment = "#ifdef USE_ENVMAP\n\t#ifdef ENV_WORLDPOS\n\t\tvec3 cameraToFrag;\n\t\tif ( isOrthographic ) {\n\t\t\tcameraToFrag = normalize( vec3( - viewMatrix[ 0 ][ 2 ], - viewMatrix[ 1 ][ 2 ], - viewMatrix[ 2 ][ 2 ] ) );\n\t\t} else {\n\t\t\tcameraToFrag = normalize( vWorldPosition - cameraPosition );\n\t\t}\n\t\tvec3 worldNormal = inverseTransformDirection( normal, viewMatrix );\n\t\t#ifdef ENVMAP_MODE_REFLECTION\n\t\t\tvec3 reflectVec = reflect( cameraToFrag, worldNormal );\n\t\t#else\n\t\t\tvec3 reflectVec = refract( cameraToFrag, worldNormal, refractionRatio );\n\t\t#endif\n\t#else\n\t\tvec3 reflectVec = vReflect;\n\t#endif\n\t#ifdef ENVMAP_TYPE_CUBE\n\t\tvec4 envColor = textureCube( envMap, envMapRotation * vec3( flipEnvMap * reflectVec.x, reflectVec.yz ) );\n\t#else\n\t\tvec4 envColor = vec4( 0.0 );\n\t#endif\n\t#ifdef ENVMAP_BLENDING_MULTIPLY\n\t\toutgoingLight = mix( outgoingLight, outgoingLight * envColor.xyz, specularStrength * reflectivity );\n\t#elif defined( ENVMAP_BLENDING_MIX )\n\t\toutgoingLight = mix( outgoingLight, envColor.xyz, specularStrength * reflectivity );\n\t#elif defined( ENVMAP_BLENDING_ADD )\n\t\toutgoingLight += envColor.xyz * specularStrength * reflectivity;\n\t#endif\n#endif";
var $d5b33d7c30034067$var$envmap_common_pars_fragment = "#ifdef USE_ENVMAP\n\tuniform float envMapIntensity;\n\tuniform float flipEnvMap;\n\tuniform mat3 envMapRotation;\n\t#ifdef ENVMAP_TYPE_CUBE\n\t\tuniform samplerCube envMap;\n\t#else\n\t\tuniform sampler2D envMap;\n\t#endif\n\t\n#endif";
var $d5b33d7c30034067$var$envmap_pars_fragment = "#ifdef USE_ENVMAP\n\tuniform float reflectivity;\n\t#if defined( USE_BUMPMAP ) || defined( USE_NORMALMAP ) || defined( PHONG ) || defined( LAMBERT )\n\t\t#define ENV_WORLDPOS\n\t#endif\n\t#ifdef ENV_WORLDPOS\n\t\tvarying vec3 vWorldPosition;\n\t\tuniform float refractionRatio;\n\t#else\n\t\tvarying vec3 vReflect;\n\t#endif\n#endif";
var $d5b33d7c30034067$var$envmap_pars_vertex = "#ifdef USE_ENVMAP\n\t#if defined( USE_BUMPMAP ) || defined( USE_NORMALMAP ) || defined( PHONG ) || defined( LAMBERT )\n\t\t#define ENV_WORLDPOS\n\t#endif\n\t#ifdef ENV_WORLDPOS\n\t\t\n\t\tvarying vec3 vWorldPosition;\n\t#else\n\t\tvarying vec3 vReflect;\n\t\tuniform float refractionRatio;\n\t#endif\n#endif";
var $d5b33d7c30034067$var$envmap_vertex = "#ifdef USE_ENVMAP\n\t#ifdef ENV_WORLDPOS\n\t\tvWorldPosition = worldPosition.xyz;\n\t#else\n\t\tvec3 cameraToVertex;\n\t\tif ( isOrthographic ) {\n\t\t\tcameraToVertex = normalize( vec3( - viewMatrix[ 0 ][ 2 ], - viewMatrix[ 1 ][ 2 ], - viewMatrix[ 2 ][ 2 ] ) );\n\t\t} else {\n\t\t\tcameraToVertex = normalize( worldPosition.xyz - cameraPosition );\n\t\t}\n\t\tvec3 worldNormal = inverseTransformDirection( transformedNormal, viewMatrix );\n\t\t#ifdef ENVMAP_MODE_REFLECTION\n\t\t\tvReflect = reflect( cameraToVertex, worldNormal );\n\t\t#else\n\t\t\tvReflect = refract( cameraToVertex, worldNormal, refractionRatio );\n\t\t#endif\n\t#endif\n#endif";
var $d5b33d7c30034067$var$fog_vertex = "#ifdef USE_FOG\n\tvFogDepth = - mvPosition.z;\n#endif";
var $d5b33d7c30034067$var$fog_pars_vertex = "#ifdef USE_FOG\n\tvarying float vFogDepth;\n#endif";
var $d5b33d7c30034067$var$fog_fragment = "#ifdef USE_FOG\n\t#ifdef FOG_EXP2\n\t\tfloat fogFactor = 1.0 - exp( - fogDensity * fogDensity * vFogDepth * vFogDepth );\n\t#else\n\t\tfloat fogFactor = smoothstep( fogNear, fogFar, vFogDepth );\n\t#endif\n\tgl_FragColor.rgb = mix( gl_FragColor.rgb, fogColor, fogFactor );\n#endif";
var $d5b33d7c30034067$var$fog_pars_fragment = "#ifdef USE_FOG\n\tuniform vec3 fogColor;\n\tvarying float vFogDepth;\n\t#ifdef FOG_EXP2\n\t\tuniform float fogDensity;\n\t#else\n\t\tuniform float fogNear;\n\t\tuniform float fogFar;\n\t#endif\n#endif";
var $d5b33d7c30034067$var$gradientmap_pars_fragment = "#ifdef USE_GRADIENTMAP\n\tuniform sampler2D gradientMap;\n#endif\nvec3 getGradientIrradiance( vec3 normal, vec3 lightDirection ) {\n\tfloat dotNL = dot( normal, lightDirection );\n\tvec2 coord = vec2( dotNL * 0.5 + 0.5, 0.0 );\n\t#ifdef USE_GRADIENTMAP\n\t\treturn vec3( texture2D( gradientMap, coord ).r );\n\t#else\n\t\tvec2 fw = fwidth( coord ) * 0.5;\n\t\treturn mix( vec3( 0.7 ), vec3( 1.0 ), smoothstep( 0.7 - fw.x, 0.7 + fw.x, coord.x ) );\n\t#endif\n}";
var $d5b33d7c30034067$var$lightmap_pars_fragment = "#ifdef USE_LIGHTMAP\n\tuniform sampler2D lightMap;\n\tuniform float lightMapIntensity;\n#endif";
var $d5b33d7c30034067$var$lights_lambert_fragment = "LambertMaterial material;\nmaterial.diffuseColor = diffuseColor.rgb;\nmaterial.specularStrength = specularStrength;";
var $d5b33d7c30034067$var$lights_lambert_pars_fragment = "varying vec3 vViewPosition;\nstruct LambertMaterial {\n\tvec3 diffuseColor;\n\tfloat specularStrength;\n};\nvoid RE_Direct_Lambert( const in IncidentLight directLight, const in vec3 geometryPosition, const in vec3 geometryNormal, const in vec3 geometryViewDir, const in vec3 geometryClearcoatNormal, const in LambertMaterial material, inout ReflectedLight reflectedLight ) {\n\tfloat dotNL = saturate( dot( geometryNormal, directLight.direction ) );\n\tvec3 irradiance = dotNL * directLight.color;\n\treflectedLight.directDiffuse += irradiance * BRDF_Lambert( material.diffuseColor );\n}\nvoid RE_IndirectDiffuse_Lambert( const in vec3 irradiance, const in vec3 geometryPosition, const in vec3 geometryNormal, const in vec3 geometryViewDir, const in vec3 geometryClearcoatNormal, const in LambertMaterial material, inout ReflectedLight reflectedLight ) {\n\treflectedLight.indirectDiffuse += irradiance * BRDF_Lambert( material.diffuseColor );\n}\n#define RE_Direct\t\t\t\tRE_Direct_Lambert\n#define RE_IndirectDiffuse\t\tRE_IndirectDiffuse_Lambert";
var $d5b33d7c30034067$var$lights_pars_begin = "uniform bool receiveShadow;\nuniform vec3 ambientLightColor;\n#if defined( USE_LIGHT_PROBES )\n\tuniform vec3 lightProbe[ 9 ];\n#endif\nvec3 shGetIrradianceAt( in vec3 normal, in vec3 shCoefficients[ 9 ] ) {\n\tfloat x = normal.x, y = normal.y, z = normal.z;\n\tvec3 result = shCoefficients[ 0 ] * 0.886227;\n\tresult += shCoefficients[ 1 ] * 2.0 * 0.511664 * y;\n\tresult += shCoefficients[ 2 ] * 2.0 * 0.511664 * z;\n\tresult += shCoefficients[ 3 ] * 2.0 * 0.511664 * x;\n\tresult += shCoefficients[ 4 ] * 2.0 * 0.429043 * x * y;\n\tresult += shCoefficients[ 5 ] * 2.0 * 0.429043 * y * z;\n\tresult += shCoefficients[ 6 ] * ( 0.743125 * z * z - 0.247708 );\n\tresult += shCoefficients[ 7 ] * 2.0 * 0.429043 * x * z;\n\tresult += shCoefficients[ 8 ] * 0.429043 * ( x * x - y * y );\n\treturn result;\n}\nvec3 getLightProbeIrradiance( const in vec3 lightProbe[ 9 ], const in vec3 normal ) {\n\tvec3 worldNormal = inverseTransformDirection( normal, viewMatrix );\n\tvec3 irradiance = shGetIrradianceAt( worldNormal, lightProbe );\n\treturn irradiance;\n}\nvec3 getAmbientLightIrradiance( const in vec3 ambientLightColor ) {\n\tvec3 irradiance = ambientLightColor;\n\treturn irradiance;\n}\nfloat getDistanceAttenuation( const in float lightDistance, const in float cutoffDistance, const in float decayExponent ) {\n\tfloat distanceFalloff = 1.0 / max( pow( lightDistance, decayExponent ), 0.01 );\n\tif ( cutoffDistance > 0.0 ) {\n\t\tdistanceFalloff *= pow2( saturate( 1.0 - pow4( lightDistance / cutoffDistance ) ) );\n\t}\n\treturn distanceFalloff;\n}\nfloat getSpotAttenuation( const in float coneCosine, const in float penumbraCosine, const in float angleCosine ) {\n\treturn smoothstep( coneCosine, penumbraCosine, angleCosine );\n}\n#if NUM_DIR_LIGHTS > 0\n\tstruct DirectionalLight {\n\t\tvec3 direction;\n\t\tvec3 color;\n\t};\n\tuniform DirectionalLight directionalLights[ NUM_DIR_LIGHTS ];\n\tvoid getDirectionalLightInfo( const in DirectionalLight directionalLight, out IncidentLight light ) {\n\t\tlight.color = directionalLight.color;\n\t\tlight.direction = directionalLight.direction;\n\t\tlight.visible = true;\n\t}\n#endif\n#if NUM_POINT_LIGHTS > 0\n\tstruct PointLight {\n\t\tvec3 position;\n\t\tvec3 color;\n\t\tfloat distance;\n\t\tfloat decay;\n\t};\n\tuniform PointLight pointLights[ NUM_POINT_LIGHTS ];\n\tvoid getPointLightInfo( const in PointLight pointLight, const in vec3 geometryPosition, out IncidentLight light ) {\n\t\tvec3 lVector = pointLight.position - geometryPosition;\n\t\tlight.direction = normalize( lVector );\n\t\tfloat lightDistance = length( lVector );\n\t\tlight.color = pointLight.color;\n\t\tlight.color *= getDistanceAttenuation( lightDistance, pointLight.distance, pointLight.decay );\n\t\tlight.visible = ( light.color != vec3( 0.0 ) );\n\t}\n#endif\n#if NUM_SPOT_LIGHTS > 0\n\tstruct SpotLight {\n\t\tvec3 position;\n\t\tvec3 direction;\n\t\tvec3 color;\n\t\tfloat distance;\n\t\tfloat decay;\n\t\tfloat coneCos;\n\t\tfloat penumbraCos;\n\t};\n\tuniform SpotLight spotLights[ NUM_SPOT_LIGHTS ];\n\tvoid getSpotLightInfo( const in SpotLight spotLight, const in vec3 geometryPosition, out IncidentLight light ) {\n\t\tvec3 lVector = spotLight.position - geometryPosition;\n\t\tlight.direction = normalize( lVector );\n\t\tfloat angleCos = dot( light.direction, spotLight.direction );\n\t\tfloat spotAttenuation = getSpotAttenuation( spotLight.coneCos, spotLight.penumbraCos, angleCos );\n\t\tif ( spotAttenuation > 0.0 ) {\n\t\t\tfloat lightDistance = length( lVector );\n\t\t\tlight.color = spotLight.color * spotAttenuation;\n\t\t\tlight.color *= getDistanceAttenuation( lightDistance, spotLight.distance, spotLight.decay );\n\t\t\tlight.visible = ( light.color != vec3( 0.0 ) );\n\t\t} else {\n\t\t\tlight.color = vec3( 0.0 );\n\t\t\tlight.visible = false;\n\t\t}\n\t}\n#endif\n#if NUM_RECT_AREA_LIGHTS > 0\n\tstruct RectAreaLight {\n\t\tvec3 color;\n\t\tvec3 position;\n\t\tvec3 halfWidth;\n\t\tvec3 halfHeight;\n\t};\n\tuniform sampler2D ltc_1;\tuniform sampler2D ltc_2;\n\tuniform RectAreaLight rectAreaLights[ NUM_RECT_AREA_LIGHTS ];\n#endif\n#if NUM_HEMI_LIGHTS > 0\n\tstruct HemisphereLight {\n\t\tvec3 direction;\n\t\tvec3 skyColor;\n\t\tvec3 groundColor;\n\t};\n\tuniform HemisphereLight hemisphereLights[ NUM_HEMI_LIGHTS ];\n\tvec3 getHemisphereLightIrradiance( const in HemisphereLight hemiLight, const in vec3 normal ) {\n\t\tfloat dotNL = dot( normal, hemiLight.direction );\n\t\tfloat hemiDiffuseWeight = 0.5 * dotNL + 0.5;\n\t\tvec3 irradiance = mix( hemiLight.groundColor, hemiLight.skyColor, hemiDiffuseWeight );\n\t\treturn irradiance;\n\t}\n#endif";
var $d5b33d7c30034067$var$envmap_physical_pars_fragment = "#ifdef USE_ENVMAP\n\tvec3 getIBLIrradiance( const in vec3 normal ) {\n\t\t#ifdef ENVMAP_TYPE_CUBE_UV\n\t\t\tvec3 worldNormal = inverseTransformDirection( normal, viewMatrix );\n\t\t\tvec4 envMapColor = textureCubeUV( envMap, envMapRotation * worldNormal, 1.0 );\n\t\t\treturn PI * envMapColor.rgb * envMapIntensity;\n\t\t#else\n\t\t\treturn vec3( 0.0 );\n\t\t#endif\n\t}\n\tvec3 getIBLRadiance( const in vec3 viewDir, const in vec3 normal, const in float roughness ) {\n\t\t#ifdef ENVMAP_TYPE_CUBE_UV\n\t\t\tvec3 reflectVec = reflect( - viewDir, normal );\n\t\t\treflectVec = normalize( mix( reflectVec, normal, roughness * roughness) );\n\t\t\treflectVec = inverseTransformDirection( reflectVec, viewMatrix );\n\t\t\tvec4 envMapColor = textureCubeUV( envMap, envMapRotation * reflectVec, roughness );\n\t\t\treturn envMapColor.rgb * envMapIntensity;\n\t\t#else\n\t\t\treturn vec3( 0.0 );\n\t\t#endif\n\t}\n\t#ifdef USE_ANISOTROPY\n\t\tvec3 getIBLAnisotropyRadiance( const in vec3 viewDir, const in vec3 normal, const in float roughness, const in vec3 bitangent, const in float anisotropy ) {\n\t\t\t#ifdef ENVMAP_TYPE_CUBE_UV\n\t\t\t\tvec3 bentNormal = cross( bitangent, viewDir );\n\t\t\t\tbentNormal = normalize( cross( bentNormal, bitangent ) );\n\t\t\t\tbentNormal = normalize( mix( bentNormal, normal, pow2( pow2( 1.0 - anisotropy * ( 1.0 - roughness ) ) ) ) );\n\t\t\t\treturn getIBLRadiance( viewDir, bentNormal, roughness );\n\t\t\t#else\n\t\t\t\treturn vec3( 0.0 );\n\t\t\t#endif\n\t\t}\n\t#endif\n#endif";
var $d5b33d7c30034067$var$lights_toon_fragment = "ToonMaterial material;\nmaterial.diffuseColor = diffuseColor.rgb;";
var $d5b33d7c30034067$var$lights_toon_pars_fragment = "varying vec3 vViewPosition;\nstruct ToonMaterial {\n\tvec3 diffuseColor;\n};\nvoid RE_Direct_Toon( const in IncidentLight directLight, const in vec3 geometryPosition, const in vec3 geometryNormal, const in vec3 geometryViewDir, const in vec3 geometryClearcoatNormal, const in ToonMaterial material, inout ReflectedLight reflectedLight ) {\n\tvec3 irradiance = getGradientIrradiance( geometryNormal, directLight.direction ) * directLight.color;\n\treflectedLight.directDiffuse += irradiance * BRDF_Lambert( material.diffuseColor );\n}\nvoid RE_IndirectDiffuse_Toon( const in vec3 irradiance, const in vec3 geometryPosition, const in vec3 geometryNormal, const in vec3 geometryViewDir, const in vec3 geometryClearcoatNormal, const in ToonMaterial material, inout ReflectedLight reflectedLight ) {\n\treflectedLight.indirectDiffuse += irradiance * BRDF_Lambert( material.diffuseColor );\n}\n#define RE_Direct\t\t\t\tRE_Direct_Toon\n#define RE_IndirectDiffuse\t\tRE_IndirectDiffuse_Toon";
var $d5b33d7c30034067$var$lights_phong_fragment = "BlinnPhongMaterial material;\nmaterial.diffuseColor = diffuseColor.rgb;\nmaterial.specularColor = specular;\nmaterial.specularShininess = shininess;\nmaterial.specularStrength = specularStrength;";
var $d5b33d7c30034067$var$lights_phong_pars_fragment = "varying vec3 vViewPosition;\nstruct BlinnPhongMaterial {\n\tvec3 diffuseColor;\n\tvec3 specularColor;\n\tfloat specularShininess;\n\tfloat specularStrength;\n};\nvoid RE_Direct_BlinnPhong( const in IncidentLight directLight, const in vec3 geometryPosition, const in vec3 geometryNormal, const in vec3 geometryViewDir, const in vec3 geometryClearcoatNormal, const in BlinnPhongMaterial material, inout ReflectedLight reflectedLight ) {\n\tfloat dotNL = saturate( dot( geometryNormal, directLight.direction ) );\n\tvec3 irradiance = dotNL * directLight.color;\n\treflectedLight.directDiffuse += irradiance * BRDF_Lambert( material.diffuseColor );\n\treflectedLight.directSpecular += irradiance * BRDF_BlinnPhong( directLight.direction, geometryViewDir, geometryNormal, material.specularColor, material.specularShininess ) * material.specularStrength;\n}\nvoid RE_IndirectDiffuse_BlinnPhong( const in vec3 irradiance, const in vec3 geometryPosition, const in vec3 geometryNormal, const in vec3 geometryViewDir, const in vec3 geometryClearcoatNormal, const in BlinnPhongMaterial material, inout ReflectedLight reflectedLight ) {\n\treflectedLight.indirectDiffuse += irradiance * BRDF_Lambert( material.diffuseColor );\n}\n#define RE_Direct\t\t\t\tRE_Direct_BlinnPhong\n#define RE_IndirectDiffuse\t\tRE_IndirectDiffuse_BlinnPhong";
var $d5b33d7c30034067$var$lights_physical_fragment = "PhysicalMaterial material;\nmaterial.diffuseColor = diffuseColor.rgb * ( 1.0 - metalnessFactor );\nvec3 dxy = max( abs( dFdx( nonPerturbedNormal ) ), abs( dFdy( nonPerturbedNormal ) ) );\nfloat geometryRoughness = max( max( dxy.x, dxy.y ), dxy.z );\nmaterial.roughness = max( roughnessFactor, 0.0525 );material.roughness += geometryRoughness;\nmaterial.roughness = min( material.roughness, 1.0 );\n#ifdef IOR\n\tmaterial.ior = ior;\n\t#ifdef USE_SPECULAR\n\t\tfloat specularIntensityFactor = specularIntensity;\n\t\tvec3 specularColorFactor = specularColor;\n\t\t#ifdef USE_SPECULAR_COLORMAP\n\t\t\tspecularColorFactor *= texture2D( specularColorMap, vSpecularColorMapUv ).rgb;\n\t\t#endif\n\t\t#ifdef USE_SPECULAR_INTENSITYMAP\n\t\t\tspecularIntensityFactor *= texture2D( specularIntensityMap, vSpecularIntensityMapUv ).a;\n\t\t#endif\n\t\tmaterial.specularF90 = mix( specularIntensityFactor, 1.0, metalnessFactor );\n\t#else\n\t\tfloat specularIntensityFactor = 1.0;\n\t\tvec3 specularColorFactor = vec3( 1.0 );\n\t\tmaterial.specularF90 = 1.0;\n\t#endif\n\tmaterial.specularColor = mix( min( pow2( ( material.ior - 1.0 ) / ( material.ior + 1.0 ) ) * specularColorFactor, vec3( 1.0 ) ) * specularIntensityFactor, diffuseColor.rgb, metalnessFactor );\n#else\n\tmaterial.specularColor = mix( vec3( 0.04 ), diffuseColor.rgb, metalnessFactor );\n\tmaterial.specularF90 = 1.0;\n#endif\n#ifdef USE_CLEARCOAT\n\tmaterial.clearcoat = clearcoat;\n\tmaterial.clearcoatRoughness = clearcoatRoughness;\n\tmaterial.clearcoatF0 = vec3( 0.04 );\n\tmaterial.clearcoatF90 = 1.0;\n\t#ifdef USE_CLEARCOATMAP\n\t\tmaterial.clearcoat *= texture2D( clearcoatMap, vClearcoatMapUv ).x;\n\t#endif\n\t#ifdef USE_CLEARCOAT_ROUGHNESSMAP\n\t\tmaterial.clearcoatRoughness *= texture2D( clearcoatRoughnessMap, vClearcoatRoughnessMapUv ).y;\n\t#endif\n\tmaterial.clearcoat = saturate( material.clearcoat );\tmaterial.clearcoatRoughness = max( material.clearcoatRoughness, 0.0525 );\n\tmaterial.clearcoatRoughness += geometryRoughness;\n\tmaterial.clearcoatRoughness = min( material.clearcoatRoughness, 1.0 );\n#endif\n#ifdef USE_DISPERSION\n\tmaterial.dispersion = dispersion;\n#endif\n#ifdef USE_IRIDESCENCE\n\tmaterial.iridescence = iridescence;\n\tmaterial.iridescenceIOR = iridescenceIOR;\n\t#ifdef USE_IRIDESCENCEMAP\n\t\tmaterial.iridescence *= texture2D( iridescenceMap, vIridescenceMapUv ).r;\n\t#endif\n\t#ifdef USE_IRIDESCENCE_THICKNESSMAP\n\t\tmaterial.iridescenceThickness = (iridescenceThicknessMaximum - iridescenceThicknessMinimum) * texture2D( iridescenceThicknessMap, vIridescenceThicknessMapUv ).g + iridescenceThicknessMinimum;\n\t#else\n\t\tmaterial.iridescenceThickness = iridescenceThicknessMaximum;\n\t#endif\n#endif\n#ifdef USE_SHEEN\n\tmaterial.sheenColor = sheenColor;\n\t#ifdef USE_SHEEN_COLORMAP\n\t\tmaterial.sheenColor *= texture2D( sheenColorMap, vSheenColorMapUv ).rgb;\n\t#endif\n\tmaterial.sheenRoughness = clamp( sheenRoughness, 0.07, 1.0 );\n\t#ifdef USE_SHEEN_ROUGHNESSMAP\n\t\tmaterial.sheenRoughness *= texture2D( sheenRoughnessMap, vSheenRoughnessMapUv ).a;\n\t#endif\n#endif\n#ifdef USE_ANISOTROPY\n\t#ifdef USE_ANISOTROPYMAP\n\t\tmat2 anisotropyMat = mat2( anisotropyVector.x, anisotropyVector.y, - anisotropyVector.y, anisotropyVector.x );\n\t\tvec3 anisotropyPolar = texture2D( anisotropyMap, vAnisotropyMapUv ).rgb;\n\t\tvec2 anisotropyV = anisotropyMat * normalize( 2.0 * anisotropyPolar.rg - vec2( 1.0 ) ) * anisotropyPolar.b;\n\t#else\n\t\tvec2 anisotropyV = anisotropyVector;\n\t#endif\n\tmaterial.anisotropy = length( anisotropyV );\n\tif( material.anisotropy == 0.0 ) {\n\t\tanisotropyV = vec2( 1.0, 0.0 );\n\t} else {\n\t\tanisotropyV /= material.anisotropy;\n\t\tmaterial.anisotropy = saturate( material.anisotropy );\n\t}\n\tmaterial.alphaT = mix( pow2( material.roughness ), 1.0, pow2( material.anisotropy ) );\n\tmaterial.anisotropyT = tbn[ 0 ] * anisotropyV.x + tbn[ 1 ] * anisotropyV.y;\n\tmaterial.anisotropyB = tbn[ 1 ] * anisotropyV.x - tbn[ 0 ] * anisotropyV.y;\n#endif";
var $d5b33d7c30034067$var$lights_physical_pars_fragment = "struct PhysicalMaterial {\n\tvec3 diffuseColor;\n\tfloat roughness;\n\tvec3 specularColor;\n\tfloat specularF90;\n\tfloat dispersion;\n\t#ifdef USE_CLEARCOAT\n\t\tfloat clearcoat;\n\t\tfloat clearcoatRoughness;\n\t\tvec3 clearcoatF0;\n\t\tfloat clearcoatF90;\n\t#endif\n\t#ifdef USE_IRIDESCENCE\n\t\tfloat iridescence;\n\t\tfloat iridescenceIOR;\n\t\tfloat iridescenceThickness;\n\t\tvec3 iridescenceFresnel;\n\t\tvec3 iridescenceF0;\n\t#endif\n\t#ifdef USE_SHEEN\n\t\tvec3 sheenColor;\n\t\tfloat sheenRoughness;\n\t#endif\n\t#ifdef IOR\n\t\tfloat ior;\n\t#endif\n\t#ifdef USE_TRANSMISSION\n\t\tfloat transmission;\n\t\tfloat transmissionAlpha;\n\t\tfloat thickness;\n\t\tfloat attenuationDistance;\n\t\tvec3 attenuationColor;\n\t#endif\n\t#ifdef USE_ANISOTROPY\n\t\tfloat anisotropy;\n\t\tfloat alphaT;\n\t\tvec3 anisotropyT;\n\t\tvec3 anisotropyB;\n\t#endif\n};\nvec3 clearcoatSpecularDirect = vec3( 0.0 );\nvec3 clearcoatSpecularIndirect = vec3( 0.0 );\nvec3 sheenSpecularDirect = vec3( 0.0 );\nvec3 sheenSpecularIndirect = vec3(0.0 );\nvec3 Schlick_to_F0( const in vec3 f, const in float f90, const in float dotVH ) {\n    float x = clamp( 1.0 - dotVH, 0.0, 1.0 );\n    float x2 = x * x;\n    float x5 = clamp( x * x2 * x2, 0.0, 0.9999 );\n    return ( f - vec3( f90 ) * x5 ) / ( 1.0 - x5 );\n}\nfloat V_GGX_SmithCorrelated( const in float alpha, const in float dotNL, const in float dotNV ) {\n\tfloat a2 = pow2( alpha );\n\tfloat gv = dotNL * sqrt( a2 + ( 1.0 - a2 ) * pow2( dotNV ) );\n\tfloat gl = dotNV * sqrt( a2 + ( 1.0 - a2 ) * pow2( dotNL ) );\n\treturn 0.5 / max( gv + gl, EPSILON );\n}\nfloat D_GGX( const in float alpha, const in float dotNH ) {\n\tfloat a2 = pow2( alpha );\n\tfloat denom = pow2( dotNH ) * ( a2 - 1.0 ) + 1.0;\n\treturn RECIPROCAL_PI * a2 / pow2( denom );\n}\n#ifdef USE_ANISOTROPY\n\tfloat V_GGX_SmithCorrelated_Anisotropic( const in float alphaT, const in float alphaB, const in float dotTV, const in float dotBV, const in float dotTL, const in float dotBL, const in float dotNV, const in float dotNL ) {\n\t\tfloat gv = dotNL * length( vec3( alphaT * dotTV, alphaB * dotBV, dotNV ) );\n\t\tfloat gl = dotNV * length( vec3( alphaT * dotTL, alphaB * dotBL, dotNL ) );\n\t\tfloat v = 0.5 / ( gv + gl );\n\t\treturn saturate(v);\n\t}\n\tfloat D_GGX_Anisotropic( const in float alphaT, const in float alphaB, const in float dotNH, const in float dotTH, const in float dotBH ) {\n\t\tfloat a2 = alphaT * alphaB;\n\t\thighp vec3 v = vec3( alphaB * dotTH, alphaT * dotBH, a2 * dotNH );\n\t\thighp float v2 = dot( v, v );\n\t\tfloat w2 = a2 / v2;\n\t\treturn RECIPROCAL_PI * a2 * pow2 ( w2 );\n\t}\n#endif\n#ifdef USE_CLEARCOAT\n\tvec3 BRDF_GGX_Clearcoat( const in vec3 lightDir, const in vec3 viewDir, const in vec3 normal, const in PhysicalMaterial material) {\n\t\tvec3 f0 = material.clearcoatF0;\n\t\tfloat f90 = material.clearcoatF90;\n\t\tfloat roughness = material.clearcoatRoughness;\n\t\tfloat alpha = pow2( roughness );\n\t\tvec3 halfDir = normalize( lightDir + viewDir );\n\t\tfloat dotNL = saturate( dot( normal, lightDir ) );\n\t\tfloat dotNV = saturate( dot( normal, viewDir ) );\n\t\tfloat dotNH = saturate( dot( normal, halfDir ) );\n\t\tfloat dotVH = saturate( dot( viewDir, halfDir ) );\n\t\tvec3 F = F_Schlick( f0, f90, dotVH );\n\t\tfloat V = V_GGX_SmithCorrelated( alpha, dotNL, dotNV );\n\t\tfloat D = D_GGX( alpha, dotNH );\n\t\treturn F * ( V * D );\n\t}\n#endif\nvec3 BRDF_GGX( const in vec3 lightDir, const in vec3 viewDir, const in vec3 normal, const in PhysicalMaterial material ) {\n\tvec3 f0 = material.specularColor;\n\tfloat f90 = material.specularF90;\n\tfloat roughness = material.roughness;\n\tfloat alpha = pow2( roughness );\n\tvec3 halfDir = normalize( lightDir + viewDir );\n\tfloat dotNL = saturate( dot( normal, lightDir ) );\n\tfloat dotNV = saturate( dot( normal, viewDir ) );\n\tfloat dotNH = saturate( dot( normal, halfDir ) );\n\tfloat dotVH = saturate( dot( viewDir, halfDir ) );\n\tvec3 F = F_Schlick( f0, f90, dotVH );\n\t#ifdef USE_IRIDESCENCE\n\t\tF = mix( F, material.iridescenceFresnel, material.iridescence );\n\t#endif\n\t#ifdef USE_ANISOTROPY\n\t\tfloat dotTL = dot( material.anisotropyT, lightDir );\n\t\tfloat dotTV = dot( material.anisotropyT, viewDir );\n\t\tfloat dotTH = dot( material.anisotropyT, halfDir );\n\t\tfloat dotBL = dot( material.anisotropyB, lightDir );\n\t\tfloat dotBV = dot( material.anisotropyB, viewDir );\n\t\tfloat dotBH = dot( material.anisotropyB, halfDir );\n\t\tfloat V = V_GGX_SmithCorrelated_Anisotropic( material.alphaT, alpha, dotTV, dotBV, dotTL, dotBL, dotNV, dotNL );\n\t\tfloat D = D_GGX_Anisotropic( material.alphaT, alpha, dotNH, dotTH, dotBH );\n\t#else\n\t\tfloat V = V_GGX_SmithCorrelated( alpha, dotNL, dotNV );\n\t\tfloat D = D_GGX( alpha, dotNH );\n\t#endif\n\treturn F * ( V * D );\n}\nvec2 LTC_Uv( const in vec3 N, const in vec3 V, const in float roughness ) {\n\tconst float LUT_SIZE = 64.0;\n\tconst float LUT_SCALE = ( LUT_SIZE - 1.0 ) / LUT_SIZE;\n\tconst float LUT_BIAS = 0.5 / LUT_SIZE;\n\tfloat dotNV = saturate( dot( N, V ) );\n\tvec2 uv = vec2( roughness, sqrt( 1.0 - dotNV ) );\n\tuv = uv * LUT_SCALE + LUT_BIAS;\n\treturn uv;\n}\nfloat LTC_ClippedSphereFormFactor( const in vec3 f ) {\n\tfloat l = length( f );\n\treturn max( ( l * l + f.z ) / ( l + 1.0 ), 0.0 );\n}\nvec3 LTC_EdgeVectorFormFactor( const in vec3 v1, const in vec3 v2 ) {\n\tfloat x = dot( v1, v2 );\n\tfloat y = abs( x );\n\tfloat a = 0.8543985 + ( 0.4965155 + 0.0145206 * y ) * y;\n\tfloat b = 3.4175940 + ( 4.1616724 + y ) * y;\n\tfloat v = a / b;\n\tfloat theta_sintheta = ( x > 0.0 ) ? v : 0.5 * inversesqrt( max( 1.0 - x * x, 1e-7 ) ) - v;\n\treturn cross( v1, v2 ) * theta_sintheta;\n}\nvec3 LTC_Evaluate( const in vec3 N, const in vec3 V, const in vec3 P, const in mat3 mInv, const in vec3 rectCoords[ 4 ] ) {\n\tvec3 v1 = rectCoords[ 1 ] - rectCoords[ 0 ];\n\tvec3 v2 = rectCoords[ 3 ] - rectCoords[ 0 ];\n\tvec3 lightNormal = cross( v1, v2 );\n\tif( dot( lightNormal, P - rectCoords[ 0 ] ) < 0.0 ) return vec3( 0.0 );\n\tvec3 T1, T2;\n\tT1 = normalize( V - N * dot( V, N ) );\n\tT2 = - cross( N, T1 );\n\tmat3 mat = mInv * transposeMat3( mat3( T1, T2, N ) );\n\tvec3 coords[ 4 ];\n\tcoords[ 0 ] = mat * ( rectCoords[ 0 ] - P );\n\tcoords[ 1 ] = mat * ( rectCoords[ 1 ] - P );\n\tcoords[ 2 ] = mat * ( rectCoords[ 2 ] - P );\n\tcoords[ 3 ] = mat * ( rectCoords[ 3 ] - P );\n\tcoords[ 0 ] = normalize( coords[ 0 ] );\n\tcoords[ 1 ] = normalize( coords[ 1 ] );\n\tcoords[ 2 ] = normalize( coords[ 2 ] );\n\tcoords[ 3 ] = normalize( coords[ 3 ] );\n\tvec3 vectorFormFactor = vec3( 0.0 );\n\tvectorFormFactor += LTC_EdgeVectorFormFactor( coords[ 0 ], coords[ 1 ] );\n\tvectorFormFactor += LTC_EdgeVectorFormFactor( coords[ 1 ], coords[ 2 ] );\n\tvectorFormFactor += LTC_EdgeVectorFormFactor( coords[ 2 ], coords[ 3 ] );\n\tvectorFormFactor += LTC_EdgeVectorFormFactor( coords[ 3 ], coords[ 0 ] );\n\tfloat result = LTC_ClippedSphereFormFactor( vectorFormFactor );\n\treturn vec3( result );\n}\n#if defined( USE_SHEEN )\nfloat D_Charlie( float roughness, float dotNH ) {\n\tfloat alpha = pow2( roughness );\n\tfloat invAlpha = 1.0 / alpha;\n\tfloat cos2h = dotNH * dotNH;\n\tfloat sin2h = max( 1.0 - cos2h, 0.0078125 );\n\treturn ( 2.0 + invAlpha ) * pow( sin2h, invAlpha * 0.5 ) / ( 2.0 * PI );\n}\nfloat V_Neubelt( float dotNV, float dotNL ) {\n\treturn saturate( 1.0 / ( 4.0 * ( dotNL + dotNV - dotNL * dotNV ) ) );\n}\nvec3 BRDF_Sheen( const in vec3 lightDir, const in vec3 viewDir, const in vec3 normal, vec3 sheenColor, const in float sheenRoughness ) {\n\tvec3 halfDir = normalize( lightDir + viewDir );\n\tfloat dotNL = saturate( dot( normal, lightDir ) );\n\tfloat dotNV = saturate( dot( normal, viewDir ) );\n\tfloat dotNH = saturate( dot( normal, halfDir ) );\n\tfloat D = D_Charlie( sheenRoughness, dotNH );\n\tfloat V = V_Neubelt( dotNV, dotNL );\n\treturn sheenColor * ( D * V );\n}\n#endif\nfloat IBLSheenBRDF( const in vec3 normal, const in vec3 viewDir, const in float roughness ) {\n\tfloat dotNV = saturate( dot( normal, viewDir ) );\n\tfloat r2 = roughness * roughness;\n\tfloat a = roughness < 0.25 ? -339.2 * r2 + 161.4 * roughness - 25.9 : -8.48 * r2 + 14.3 * roughness - 9.95;\n\tfloat b = roughness < 0.25 ? 44.0 * r2 - 23.7 * roughness + 3.26 : 1.97 * r2 - 3.27 * roughness + 0.72;\n\tfloat DG = exp( a * dotNV + b ) + ( roughness < 0.25 ? 0.0 : 0.1 * ( roughness - 0.25 ) );\n\treturn saturate( DG * RECIPROCAL_PI );\n}\nvec2 DFGApprox( const in vec3 normal, const in vec3 viewDir, const in float roughness ) {\n\tfloat dotNV = saturate( dot( normal, viewDir ) );\n\tconst vec4 c0 = vec4( - 1, - 0.0275, - 0.572, 0.022 );\n\tconst vec4 c1 = vec4( 1, 0.0425, 1.04, - 0.04 );\n\tvec4 r = roughness * c0 + c1;\n\tfloat a004 = min( r.x * r.x, exp2( - 9.28 * dotNV ) ) * r.x + r.y;\n\tvec2 fab = vec2( - 1.04, 1.04 ) * a004 + r.zw;\n\treturn fab;\n}\nvec3 EnvironmentBRDF( const in vec3 normal, const in vec3 viewDir, const in vec3 specularColor, const in float specularF90, const in float roughness ) {\n\tvec2 fab = DFGApprox( normal, viewDir, roughness );\n\treturn specularColor * fab.x + specularF90 * fab.y;\n}\n#ifdef USE_IRIDESCENCE\nvoid computeMultiscatteringIridescence( const in vec3 normal, const in vec3 viewDir, const in vec3 specularColor, const in float specularF90, const in float iridescence, const in vec3 iridescenceF0, const in float roughness, inout vec3 singleScatter, inout vec3 multiScatter ) {\n#else\nvoid computeMultiscattering( const in vec3 normal, const in vec3 viewDir, const in vec3 specularColor, const in float specularF90, const in float roughness, inout vec3 singleScatter, inout vec3 multiScatter ) {\n#endif\n\tvec2 fab = DFGApprox( normal, viewDir, roughness );\n\t#ifdef USE_IRIDESCENCE\n\t\tvec3 Fr = mix( specularColor, iridescenceF0, iridescence );\n\t#else\n\t\tvec3 Fr = specularColor;\n\t#endif\n\tvec3 FssEss = Fr * fab.x + specularF90 * fab.y;\n\tfloat Ess = fab.x + fab.y;\n\tfloat Ems = 1.0 - Ess;\n\tvec3 Favg = Fr + ( 1.0 - Fr ) * 0.047619;\tvec3 Fms = FssEss * Favg / ( 1.0 - Ems * Favg );\n\tsingleScatter += FssEss;\n\tmultiScatter += Fms * Ems;\n}\n#if NUM_RECT_AREA_LIGHTS > 0\n\tvoid RE_Direct_RectArea_Physical( const in RectAreaLight rectAreaLight, const in vec3 geometryPosition, const in vec3 geometryNormal, const in vec3 geometryViewDir, const in vec3 geometryClearcoatNormal, const in PhysicalMaterial material, inout ReflectedLight reflectedLight ) {\n\t\tvec3 normal = geometryNormal;\n\t\tvec3 viewDir = geometryViewDir;\n\t\tvec3 position = geometryPosition;\n\t\tvec3 lightPos = rectAreaLight.position;\n\t\tvec3 halfWidth = rectAreaLight.halfWidth;\n\t\tvec3 halfHeight = rectAreaLight.halfHeight;\n\t\tvec3 lightColor = rectAreaLight.color;\n\t\tfloat roughness = material.roughness;\n\t\tvec3 rectCoords[ 4 ];\n\t\trectCoords[ 0 ] = lightPos + halfWidth - halfHeight;\t\trectCoords[ 1 ] = lightPos - halfWidth - halfHeight;\n\t\trectCoords[ 2 ] = lightPos - halfWidth + halfHeight;\n\t\trectCoords[ 3 ] = lightPos + halfWidth + halfHeight;\n\t\tvec2 uv = LTC_Uv( normal, viewDir, roughness );\n\t\tvec4 t1 = texture2D( ltc_1, uv );\n\t\tvec4 t2 = texture2D( ltc_2, uv );\n\t\tmat3 mInv = mat3(\n\t\t\tvec3( t1.x, 0, t1.y ),\n\t\t\tvec3(    0, 1,    0 ),\n\t\t\tvec3( t1.z, 0, t1.w )\n\t\t);\n\t\tvec3 fresnel = ( material.specularColor * t2.x + ( vec3( 1.0 ) - material.specularColor ) * t2.y );\n\t\treflectedLight.directSpecular += lightColor * fresnel * LTC_Evaluate( normal, viewDir, position, mInv, rectCoords );\n\t\treflectedLight.directDiffuse += lightColor * material.diffuseColor * LTC_Evaluate( normal, viewDir, position, mat3( 1.0 ), rectCoords );\n\t}\n#endif\nvoid RE_Direct_Physical( const in IncidentLight directLight, const in vec3 geometryPosition, const in vec3 geometryNormal, const in vec3 geometryViewDir, const in vec3 geometryClearcoatNormal, const in PhysicalMaterial material, inout ReflectedLight reflectedLight ) {\n\tfloat dotNL = saturate( dot( geometryNormal, directLight.direction ) );\n\tvec3 irradiance = dotNL * directLight.color;\n\t#ifdef USE_CLEARCOAT\n\t\tfloat dotNLcc = saturate( dot( geometryClearcoatNormal, directLight.direction ) );\n\t\tvec3 ccIrradiance = dotNLcc * directLight.color;\n\t\tclearcoatSpecularDirect += ccIrradiance * BRDF_GGX_Clearcoat( directLight.direction, geometryViewDir, geometryClearcoatNormal, material );\n\t#endif\n\t#ifdef USE_SHEEN\n\t\tsheenSpecularDirect += irradiance * BRDF_Sheen( directLight.direction, geometryViewDir, geometryNormal, material.sheenColor, material.sheenRoughness );\n\t#endif\n\treflectedLight.directSpecular += irradiance * BRDF_GGX( directLight.direction, geometryViewDir, geometryNormal, material );\n\treflectedLight.directDiffuse += irradiance * BRDF_Lambert( material.diffuseColor );\n}\nvoid RE_IndirectDiffuse_Physical( const in vec3 irradiance, const in vec3 geometryPosition, const in vec3 geometryNormal, const in vec3 geometryViewDir, const in vec3 geometryClearcoatNormal, const in PhysicalMaterial material, inout ReflectedLight reflectedLight ) {\n\treflectedLight.indirectDiffuse += irradiance * BRDF_Lambert( material.diffuseColor );\n}\nvoid RE_IndirectSpecular_Physical( const in vec3 radiance, const in vec3 irradiance, const in vec3 clearcoatRadiance, const in vec3 geometryPosition, const in vec3 geometryNormal, const in vec3 geometryViewDir, const in vec3 geometryClearcoatNormal, const in PhysicalMaterial material, inout ReflectedLight reflectedLight) {\n\t#ifdef USE_CLEARCOAT\n\t\tclearcoatSpecularIndirect += clearcoatRadiance * EnvironmentBRDF( geometryClearcoatNormal, geometryViewDir, material.clearcoatF0, material.clearcoatF90, material.clearcoatRoughness );\n\t#endif\n\t#ifdef USE_SHEEN\n\t\tsheenSpecularIndirect += irradiance * material.sheenColor * IBLSheenBRDF( geometryNormal, geometryViewDir, material.sheenRoughness );\n\t#endif\n\tvec3 singleScattering = vec3( 0.0 );\n\tvec3 multiScattering = vec3( 0.0 );\n\tvec3 cosineWeightedIrradiance = irradiance * RECIPROCAL_PI;\n\t#ifdef USE_IRIDESCENCE\n\t\tcomputeMultiscatteringIridescence( geometryNormal, geometryViewDir, material.specularColor, material.specularF90, material.iridescence, material.iridescenceFresnel, material.roughness, singleScattering, multiScattering );\n\t#else\n\t\tcomputeMultiscattering( geometryNormal, geometryViewDir, material.specularColor, material.specularF90, material.roughness, singleScattering, multiScattering );\n\t#endif\n\tvec3 totalScattering = singleScattering + multiScattering;\n\tvec3 diffuse = material.diffuseColor * ( 1.0 - max( max( totalScattering.r, totalScattering.g ), totalScattering.b ) );\n\treflectedLight.indirectSpecular += radiance * singleScattering;\n\treflectedLight.indirectSpecular += multiScattering * cosineWeightedIrradiance;\n\treflectedLight.indirectDiffuse += diffuse * cosineWeightedIrradiance;\n}\n#define RE_Direct\t\t\t\tRE_Direct_Physical\n#define RE_Direct_RectArea\t\tRE_Direct_RectArea_Physical\n#define RE_IndirectDiffuse\t\tRE_IndirectDiffuse_Physical\n#define RE_IndirectSpecular\t\tRE_IndirectSpecular_Physical\nfloat computeSpecularOcclusion( const in float dotNV, const in float ambientOcclusion, const in float roughness ) {\n\treturn saturate( pow( dotNV + ambientOcclusion, exp2( - 16.0 * roughness - 1.0 ) ) - 1.0 + ambientOcclusion );\n}";
var $d5b33d7c30034067$var$lights_fragment_begin = "\nvec3 geometryPosition = - vViewPosition;\nvec3 geometryNormal = normal;\nvec3 geometryViewDir = ( isOrthographic ) ? vec3( 0, 0, 1 ) : normalize( vViewPosition );\nvec3 geometryClearcoatNormal = vec3( 0.0 );\n#ifdef USE_CLEARCOAT\n\tgeometryClearcoatNormal = clearcoatNormal;\n#endif\n#ifdef USE_IRIDESCENCE\n\tfloat dotNVi = saturate( dot( normal, geometryViewDir ) );\n\tif ( material.iridescenceThickness == 0.0 ) {\n\t\tmaterial.iridescence = 0.0;\n\t} else {\n\t\tmaterial.iridescence = saturate( material.iridescence );\n\t}\n\tif ( material.iridescence > 0.0 ) {\n\t\tmaterial.iridescenceFresnel = evalIridescence( 1.0, material.iridescenceIOR, dotNVi, material.iridescenceThickness, material.specularColor );\n\t\tmaterial.iridescenceF0 = Schlick_to_F0( material.iridescenceFresnel, 1.0, dotNVi );\n\t}\n#endif\nIncidentLight directLight;\n#if ( NUM_POINT_LIGHTS > 0 ) && defined( RE_Direct )\n\tPointLight pointLight;\n\t#if defined( USE_SHADOWMAP ) && NUM_POINT_LIGHT_SHADOWS > 0\n\tPointLightShadow pointLightShadow;\n\t#endif\n\t#pragma unroll_loop_start\n\tfor ( int i = 0; i < NUM_POINT_LIGHTS; i ++ ) {\n\t\tpointLight = pointLights[ i ];\n\t\tgetPointLightInfo( pointLight, geometryPosition, directLight );\n\t\t#if defined( USE_SHADOWMAP ) && ( UNROLLED_LOOP_INDEX < NUM_POINT_LIGHT_SHADOWS )\n\t\tpointLightShadow = pointLightShadows[ i ];\n\t\tdirectLight.color *= ( directLight.visible && receiveShadow ) ? getPointShadow( pointShadowMap[ i ], pointLightShadow.shadowMapSize, pointLightShadow.shadowIntensity, pointLightShadow.shadowBias, pointLightShadow.shadowRadius, vPointShadowCoord[ i ], pointLightShadow.shadowCameraNear, pointLightShadow.shadowCameraFar ) : 1.0;\n\t\t#endif\n\t\tRE_Direct( directLight, geometryPosition, geometryNormal, geometryViewDir, geometryClearcoatNormal, material, reflectedLight );\n\t}\n\t#pragma unroll_loop_end\n#endif\n#if ( NUM_SPOT_LIGHTS > 0 ) && defined( RE_Direct )\n\tSpotLight spotLight;\n\tvec4 spotColor;\n\tvec3 spotLightCoord;\n\tbool inSpotLightMap;\n\t#if defined( USE_SHADOWMAP ) && NUM_SPOT_LIGHT_SHADOWS > 0\n\tSpotLightShadow spotLightShadow;\n\t#endif\n\t#pragma unroll_loop_start\n\tfor ( int i = 0; i < NUM_SPOT_LIGHTS; i ++ ) {\n\t\tspotLight = spotLights[ i ];\n\t\tgetSpotLightInfo( spotLight, geometryPosition, directLight );\n\t\t#if ( UNROLLED_LOOP_INDEX < NUM_SPOT_LIGHT_SHADOWS_WITH_MAPS )\n\t\t#define SPOT_LIGHT_MAP_INDEX UNROLLED_LOOP_INDEX\n\t\t#elif ( UNROLLED_LOOP_INDEX < NUM_SPOT_LIGHT_SHADOWS )\n\t\t#define SPOT_LIGHT_MAP_INDEX NUM_SPOT_LIGHT_MAPS\n\t\t#else\n\t\t#define SPOT_LIGHT_MAP_INDEX ( UNROLLED_LOOP_INDEX - NUM_SPOT_LIGHT_SHADOWS + NUM_SPOT_LIGHT_SHADOWS_WITH_MAPS )\n\t\t#endif\n\t\t#if ( SPOT_LIGHT_MAP_INDEX < NUM_SPOT_LIGHT_MAPS )\n\t\t\tspotLightCoord = vSpotLightCoord[ i ].xyz / vSpotLightCoord[ i ].w;\n\t\t\tinSpotLightMap = all( lessThan( abs( spotLightCoord * 2. - 1. ), vec3( 1.0 ) ) );\n\t\t\tspotColor = texture2D( spotLightMap[ SPOT_LIGHT_MAP_INDEX ], spotLightCoord.xy );\n\t\t\tdirectLight.color = inSpotLightMap ? directLight.color * spotColor.rgb : directLight.color;\n\t\t#endif\n\t\t#undef SPOT_LIGHT_MAP_INDEX\n\t\t#if defined( USE_SHADOWMAP ) && ( UNROLLED_LOOP_INDEX < NUM_SPOT_LIGHT_SHADOWS )\n\t\tspotLightShadow = spotLightShadows[ i ];\n\t\tdirectLight.color *= ( directLight.visible && receiveShadow ) ? getShadow( spotShadowMap[ i ], spotLightShadow.shadowMapSize, spotLightShadow.shadowIntensity, spotLightShadow.shadowBias, spotLightShadow.shadowRadius, vSpotLightCoord[ i ] ) : 1.0;\n\t\t#endif\n\t\tRE_Direct( directLight, geometryPosition, geometryNormal, geometryViewDir, geometryClearcoatNormal, material, reflectedLight );\n\t}\n\t#pragma unroll_loop_end\n#endif\n#if ( NUM_DIR_LIGHTS > 0 ) && defined( RE_Direct )\n\tDirectionalLight directionalLight;\n\t#if defined( USE_SHADOWMAP ) && NUM_DIR_LIGHT_SHADOWS > 0\n\tDirectionalLightShadow directionalLightShadow;\n\t#endif\n\t#pragma unroll_loop_start\n\tfor ( int i = 0; i < NUM_DIR_LIGHTS; i ++ ) {\n\t\tdirectionalLight = directionalLights[ i ];\n\t\tgetDirectionalLightInfo( directionalLight, directLight );\n\t\t#if defined( USE_SHADOWMAP ) && ( UNROLLED_LOOP_INDEX < NUM_DIR_LIGHT_SHADOWS )\n\t\tdirectionalLightShadow = directionalLightShadows[ i ];\n\t\tdirectLight.color *= ( directLight.visible && receiveShadow ) ? getShadow( directionalShadowMap[ i ], directionalLightShadow.shadowMapSize, directionalLightShadow.shadowIntensity, directionalLightShadow.shadowBias, directionalLightShadow.shadowRadius, vDirectionalShadowCoord[ i ] ) : 1.0;\n\t\t#endif\n\t\tRE_Direct( directLight, geometryPosition, geometryNormal, geometryViewDir, geometryClearcoatNormal, material, reflectedLight );\n\t}\n\t#pragma unroll_loop_end\n#endif\n#if ( NUM_RECT_AREA_LIGHTS > 0 ) && defined( RE_Direct_RectArea )\n\tRectAreaLight rectAreaLight;\n\t#pragma unroll_loop_start\n\tfor ( int i = 0; i < NUM_RECT_AREA_LIGHTS; i ++ ) {\n\t\trectAreaLight = rectAreaLights[ i ];\n\t\tRE_Direct_RectArea( rectAreaLight, geometryPosition, geometryNormal, geometryViewDir, geometryClearcoatNormal, material, reflectedLight );\n\t}\n\t#pragma unroll_loop_end\n#endif\n#if defined( RE_IndirectDiffuse )\n\tvec3 iblIrradiance = vec3( 0.0 );\n\tvec3 irradiance = getAmbientLightIrradiance( ambientLightColor );\n\t#if defined( USE_LIGHT_PROBES )\n\t\tirradiance += getLightProbeIrradiance( lightProbe, geometryNormal );\n\t#endif\n\t#if ( NUM_HEMI_LIGHTS > 0 )\n\t\t#pragma unroll_loop_start\n\t\tfor ( int i = 0; i < NUM_HEMI_LIGHTS; i ++ ) {\n\t\t\tirradiance += getHemisphereLightIrradiance( hemisphereLights[ i ], geometryNormal );\n\t\t}\n\t\t#pragma unroll_loop_end\n\t#endif\n#endif\n#if defined( RE_IndirectSpecular )\n\tvec3 radiance = vec3( 0.0 );\n\tvec3 clearcoatRadiance = vec3( 0.0 );\n#endif";
var $d5b33d7c30034067$var$lights_fragment_maps = "#if defined( RE_IndirectDiffuse )\n\t#ifdef USE_LIGHTMAP\n\t\tvec4 lightMapTexel = texture2D( lightMap, vLightMapUv );\n\t\tvec3 lightMapIrradiance = lightMapTexel.rgb * lightMapIntensity;\n\t\tirradiance += lightMapIrradiance;\n\t#endif\n\t#if defined( USE_ENVMAP ) && defined( STANDARD ) && defined( ENVMAP_TYPE_CUBE_UV )\n\t\tiblIrradiance += getIBLIrradiance( geometryNormal );\n\t#endif\n#endif\n#if defined( USE_ENVMAP ) && defined( RE_IndirectSpecular )\n\t#ifdef USE_ANISOTROPY\n\t\tradiance += getIBLAnisotropyRadiance( geometryViewDir, geometryNormal, material.roughness, material.anisotropyB, material.anisotropy );\n\t#else\n\t\tradiance += getIBLRadiance( geometryViewDir, geometryNormal, material.roughness );\n\t#endif\n\t#ifdef USE_CLEARCOAT\n\t\tclearcoatRadiance += getIBLRadiance( geometryViewDir, geometryClearcoatNormal, material.clearcoatRoughness );\n\t#endif\n#endif";
var $d5b33d7c30034067$var$lights_fragment_end = "#if defined( RE_IndirectDiffuse )\n\tRE_IndirectDiffuse( irradiance, geometryPosition, geometryNormal, geometryViewDir, geometryClearcoatNormal, material, reflectedLight );\n#endif\n#if defined( RE_IndirectSpecular )\n\tRE_IndirectSpecular( radiance, iblIrradiance, clearcoatRadiance, geometryPosition, geometryNormal, geometryViewDir, geometryClearcoatNormal, material, reflectedLight );\n#endif";
var $d5b33d7c30034067$var$logdepthbuf_fragment = "#if defined( USE_LOGDEPTHBUF )\n\tgl_FragDepth = vIsPerspective == 0.0 ? gl_FragCoord.z : log2( vFragDepth ) * logDepthBufFC * 0.5;\n#endif";
var $d5b33d7c30034067$var$logdepthbuf_pars_fragment = "#if defined( USE_LOGDEPTHBUF )\n\tuniform float logDepthBufFC;\n\tvarying float vFragDepth;\n\tvarying float vIsPerspective;\n#endif";
var $d5b33d7c30034067$var$logdepthbuf_pars_vertex = "#ifdef USE_LOGDEPTHBUF\n\tvarying float vFragDepth;\n\tvarying float vIsPerspective;\n#endif";
var $d5b33d7c30034067$var$logdepthbuf_vertex = "#ifdef USE_LOGDEPTHBUF\n\tvFragDepth = 1.0 + gl_Position.w;\n\tvIsPerspective = float( isPerspectiveMatrix( projectionMatrix ) );\n#endif";
var $d5b33d7c30034067$var$map_fragment = "#ifdef USE_MAP\n\tvec4 sampledDiffuseColor = texture2D( map, vMapUv );\n\t#ifdef DECODE_VIDEO_TEXTURE\n\t\tsampledDiffuseColor = sRGBTransferEOTF( sampledDiffuseColor );\n\t#endif\n\tdiffuseColor *= sampledDiffuseColor;\n#endif";
var $d5b33d7c30034067$var$map_pars_fragment = "#ifdef USE_MAP\n\tuniform sampler2D map;\n#endif";
var $d5b33d7c30034067$var$map_particle_fragment = "#if defined( USE_MAP ) || defined( USE_ALPHAMAP )\n\t#if defined( USE_POINTS_UV )\n\t\tvec2 uv = vUv;\n\t#else\n\t\tvec2 uv = ( uvTransform * vec3( gl_PointCoord.x, 1.0 - gl_PointCoord.y, 1 ) ).xy;\n\t#endif\n#endif\n#ifdef USE_MAP\n\tdiffuseColor *= texture2D( map, uv );\n#endif\n#ifdef USE_ALPHAMAP\n\tdiffuseColor.a *= texture2D( alphaMap, uv ).g;\n#endif";
var $d5b33d7c30034067$var$map_particle_pars_fragment = "#if defined( USE_POINTS_UV )\n\tvarying vec2 vUv;\n#else\n\t#if defined( USE_MAP ) || defined( USE_ALPHAMAP )\n\t\tuniform mat3 uvTransform;\n\t#endif\n#endif\n#ifdef USE_MAP\n\tuniform sampler2D map;\n#endif\n#ifdef USE_ALPHAMAP\n\tuniform sampler2D alphaMap;\n#endif";
var $d5b33d7c30034067$var$metalnessmap_fragment = "float metalnessFactor = metalness;\n#ifdef USE_METALNESSMAP\n\tvec4 texelMetalness = texture2D( metalnessMap, vMetalnessMapUv );\n\tmetalnessFactor *= texelMetalness.b;\n#endif";
var $d5b33d7c30034067$var$metalnessmap_pars_fragment = "#ifdef USE_METALNESSMAP\n\tuniform sampler2D metalnessMap;\n#endif";
var $d5b33d7c30034067$var$morphinstance_vertex = "#ifdef USE_INSTANCING_MORPH\n\tfloat morphTargetInfluences[ MORPHTARGETS_COUNT ];\n\tfloat morphTargetBaseInfluence = texelFetch( morphTexture, ivec2( 0, gl_InstanceID ), 0 ).r;\n\tfor ( int i = 0; i < MORPHTARGETS_COUNT; i ++ ) {\n\t\tmorphTargetInfluences[i] =  texelFetch( morphTexture, ivec2( i + 1, gl_InstanceID ), 0 ).r;\n\t}\n#endif";
var $d5b33d7c30034067$var$morphcolor_vertex = "#if defined( USE_MORPHCOLORS )\n\tvColor *= morphTargetBaseInfluence;\n\tfor ( int i = 0; i < MORPHTARGETS_COUNT; i ++ ) {\n\t\t#if defined( USE_COLOR_ALPHA )\n\t\t\tif ( morphTargetInfluences[ i ] != 0.0 ) vColor += getMorph( gl_VertexID, i, 2 ) * morphTargetInfluences[ i ];\n\t\t#elif defined( USE_COLOR )\n\t\t\tif ( morphTargetInfluences[ i ] != 0.0 ) vColor += getMorph( gl_VertexID, i, 2 ).rgb * morphTargetInfluences[ i ];\n\t\t#endif\n\t}\n#endif";
var $d5b33d7c30034067$var$morphnormal_vertex = "#ifdef USE_MORPHNORMALS\n\tobjectNormal *= morphTargetBaseInfluence;\n\tfor ( int i = 0; i < MORPHTARGETS_COUNT; i ++ ) {\n\t\tif ( morphTargetInfluences[ i ] != 0.0 ) objectNormal += getMorph( gl_VertexID, i, 1 ).xyz * morphTargetInfluences[ i ];\n\t}\n#endif";
var $d5b33d7c30034067$var$morphtarget_pars_vertex = "#ifdef USE_MORPHTARGETS\n\t#ifndef USE_INSTANCING_MORPH\n\t\tuniform float morphTargetBaseInfluence;\n\t\tuniform float morphTargetInfluences[ MORPHTARGETS_COUNT ];\n\t#endif\n\tuniform sampler2DArray morphTargetsTexture;\n\tuniform ivec2 morphTargetsTextureSize;\n\tvec4 getMorph( const in int vertexIndex, const in int morphTargetIndex, const in int offset ) {\n\t\tint texelIndex = vertexIndex * MORPHTARGETS_TEXTURE_STRIDE + offset;\n\t\tint y = texelIndex / morphTargetsTextureSize.x;\n\t\tint x = texelIndex - y * morphTargetsTextureSize.x;\n\t\tivec3 morphUV = ivec3( x, y, morphTargetIndex );\n\t\treturn texelFetch( morphTargetsTexture, morphUV, 0 );\n\t}\n#endif";
var $d5b33d7c30034067$var$morphtarget_vertex = "#ifdef USE_MORPHTARGETS\n\ttransformed *= morphTargetBaseInfluence;\n\tfor ( int i = 0; i < MORPHTARGETS_COUNT; i ++ ) {\n\t\tif ( morphTargetInfluences[ i ] != 0.0 ) transformed += getMorph( gl_VertexID, i, 0 ).xyz * morphTargetInfluences[ i ];\n\t}\n#endif";
var $d5b33d7c30034067$var$normal_fragment_begin = "float faceDirection = gl_FrontFacing ? 1.0 : - 1.0;\n#ifdef FLAT_SHADED\n\tvec3 fdx = dFdx( vViewPosition );\n\tvec3 fdy = dFdy( vViewPosition );\n\tvec3 normal = normalize( cross( fdx, fdy ) );\n#else\n\tvec3 normal = normalize( vNormal );\n\t#ifdef DOUBLE_SIDED\n\t\tnormal *= faceDirection;\n\t#endif\n#endif\n#if defined( USE_NORMALMAP_TANGENTSPACE ) || defined( USE_CLEARCOAT_NORMALMAP ) || defined( USE_ANISOTROPY )\n\t#ifdef USE_TANGENT\n\t\tmat3 tbn = mat3( normalize( vTangent ), normalize( vBitangent ), normal );\n\t#else\n\t\tmat3 tbn = getTangentFrame( - vViewPosition, normal,\n\t\t#if defined( USE_NORMALMAP )\n\t\t\tvNormalMapUv\n\t\t#elif defined( USE_CLEARCOAT_NORMALMAP )\n\t\t\tvClearcoatNormalMapUv\n\t\t#else\n\t\t\tvUv\n\t\t#endif\n\t\t);\n\t#endif\n\t#if defined( DOUBLE_SIDED ) && ! defined( FLAT_SHADED )\n\t\ttbn[0] *= faceDirection;\n\t\ttbn[1] *= faceDirection;\n\t#endif\n#endif\n#ifdef USE_CLEARCOAT_NORMALMAP\n\t#ifdef USE_TANGENT\n\t\tmat3 tbn2 = mat3( normalize( vTangent ), normalize( vBitangent ), normal );\n\t#else\n\t\tmat3 tbn2 = getTangentFrame( - vViewPosition, normal, vClearcoatNormalMapUv );\n\t#endif\n\t#if defined( DOUBLE_SIDED ) && ! defined( FLAT_SHADED )\n\t\ttbn2[0] *= faceDirection;\n\t\ttbn2[1] *= faceDirection;\n\t#endif\n#endif\nvec3 nonPerturbedNormal = normal;";
var $d5b33d7c30034067$var$normal_fragment_maps = "#ifdef USE_NORMALMAP_OBJECTSPACE\n\tnormal = texture2D( normalMap, vNormalMapUv ).xyz * 2.0 - 1.0;\n\t#ifdef FLIP_SIDED\n\t\tnormal = - normal;\n\t#endif\n\t#ifdef DOUBLE_SIDED\n\t\tnormal = normal * faceDirection;\n\t#endif\n\tnormal = normalize( normalMatrix * normal );\n#elif defined( USE_NORMALMAP_TANGENTSPACE )\n\tvec3 mapN = texture2D( normalMap, vNormalMapUv ).xyz * 2.0 - 1.0;\n\tmapN.xy *= normalScale;\n\tnormal = normalize( tbn * mapN );\n#elif defined( USE_BUMPMAP )\n\tnormal = perturbNormalArb( - vViewPosition, normal, dHdxy_fwd(), faceDirection );\n#endif";
var $d5b33d7c30034067$var$normal_pars_fragment = "#ifndef FLAT_SHADED\n\tvarying vec3 vNormal;\n\t#ifdef USE_TANGENT\n\t\tvarying vec3 vTangent;\n\t\tvarying vec3 vBitangent;\n\t#endif\n#endif";
var $d5b33d7c30034067$var$normal_pars_vertex = "#ifndef FLAT_SHADED\n\tvarying vec3 vNormal;\n\t#ifdef USE_TANGENT\n\t\tvarying vec3 vTangent;\n\t\tvarying vec3 vBitangent;\n\t#endif\n#endif";
var $d5b33d7c30034067$var$normal_vertex = "#ifndef FLAT_SHADED\n\tvNormal = normalize( transformedNormal );\n\t#ifdef USE_TANGENT\n\t\tvTangent = normalize( transformedTangent );\n\t\tvBitangent = normalize( cross( vNormal, vTangent ) * tangent.w );\n\t#endif\n#endif";
var $d5b33d7c30034067$var$normalmap_pars_fragment = "#ifdef USE_NORMALMAP\n\tuniform sampler2D normalMap;\n\tuniform vec2 normalScale;\n#endif\n#ifdef USE_NORMALMAP_OBJECTSPACE\n\tuniform mat3 normalMatrix;\n#endif\n#if ! defined ( USE_TANGENT ) && ( defined ( USE_NORMALMAP_TANGENTSPACE ) || defined ( USE_CLEARCOAT_NORMALMAP ) || defined( USE_ANISOTROPY ) )\n\tmat3 getTangentFrame( vec3 eye_pos, vec3 surf_norm, vec2 uv ) {\n\t\tvec3 q0 = dFdx( eye_pos.xyz );\n\t\tvec3 q1 = dFdy( eye_pos.xyz );\n\t\tvec2 st0 = dFdx( uv.st );\n\t\tvec2 st1 = dFdy( uv.st );\n\t\tvec3 N = surf_norm;\n\t\tvec3 q1perp = cross( q1, N );\n\t\tvec3 q0perp = cross( N, q0 );\n\t\tvec3 T = q1perp * st0.x + q0perp * st1.x;\n\t\tvec3 B = q1perp * st0.y + q0perp * st1.y;\n\t\tfloat det = max( dot( T, T ), dot( B, B ) );\n\t\tfloat scale = ( det == 0.0 ) ? 0.0 : inversesqrt( det );\n\t\treturn mat3( T * scale, B * scale, N );\n\t}\n#endif";
var $d5b33d7c30034067$var$clearcoat_normal_fragment_begin = "#ifdef USE_CLEARCOAT\n\tvec3 clearcoatNormal = nonPerturbedNormal;\n#endif";
var $d5b33d7c30034067$var$clearcoat_normal_fragment_maps = "#ifdef USE_CLEARCOAT_NORMALMAP\n\tvec3 clearcoatMapN = texture2D( clearcoatNormalMap, vClearcoatNormalMapUv ).xyz * 2.0 - 1.0;\n\tclearcoatMapN.xy *= clearcoatNormalScale;\n\tclearcoatNormal = normalize( tbn2 * clearcoatMapN );\n#endif";
var $d5b33d7c30034067$var$clearcoat_pars_fragment = "#ifdef USE_CLEARCOATMAP\n\tuniform sampler2D clearcoatMap;\n#endif\n#ifdef USE_CLEARCOAT_NORMALMAP\n\tuniform sampler2D clearcoatNormalMap;\n\tuniform vec2 clearcoatNormalScale;\n#endif\n#ifdef USE_CLEARCOAT_ROUGHNESSMAP\n\tuniform sampler2D clearcoatRoughnessMap;\n#endif";
var $d5b33d7c30034067$var$iridescence_pars_fragment = "#ifdef USE_IRIDESCENCEMAP\n\tuniform sampler2D iridescenceMap;\n#endif\n#ifdef USE_IRIDESCENCE_THICKNESSMAP\n\tuniform sampler2D iridescenceThicknessMap;\n#endif";
var $d5b33d7c30034067$var$opaque_fragment = "#ifdef OPAQUE\ndiffuseColor.a = 1.0;\n#endif\n#ifdef USE_TRANSMISSION\ndiffuseColor.a *= material.transmissionAlpha;\n#endif\ngl_FragColor = vec4( outgoingLight, diffuseColor.a );";
var $d5b33d7c30034067$var$packing = "vec3 packNormalToRGB( const in vec3 normal ) {\n\treturn normalize( normal ) * 0.5 + 0.5;\n}\nvec3 unpackRGBToNormal( const in vec3 rgb ) {\n\treturn 2.0 * rgb.xyz - 1.0;\n}\nconst float PackUpscale = 256. / 255.;const float UnpackDownscale = 255. / 256.;const float ShiftRight8 = 1. / 256.;\nconst float Inv255 = 1. / 255.;\nconst vec4 PackFactors = vec4( 1.0, 256.0, 256.0 * 256.0, 256.0 * 256.0 * 256.0 );\nconst vec2 UnpackFactors2 = vec2( UnpackDownscale, 1.0 / PackFactors.g );\nconst vec3 UnpackFactors3 = vec3( UnpackDownscale / PackFactors.rg, 1.0 / PackFactors.b );\nconst vec4 UnpackFactors4 = vec4( UnpackDownscale / PackFactors.rgb, 1.0 / PackFactors.a );\nvec4 packDepthToRGBA( const in float v ) {\n\tif( v <= 0.0 )\n\t\treturn vec4( 0., 0., 0., 0. );\n\tif( v >= 1.0 )\n\t\treturn vec4( 1., 1., 1., 1. );\n\tfloat vuf;\n\tfloat af = modf( v * PackFactors.a, vuf );\n\tfloat bf = modf( vuf * ShiftRight8, vuf );\n\tfloat gf = modf( vuf * ShiftRight8, vuf );\n\treturn vec4( vuf * Inv255, gf * PackUpscale, bf * PackUpscale, af );\n}\nvec3 packDepthToRGB( const in float v ) {\n\tif( v <= 0.0 )\n\t\treturn vec3( 0., 0., 0. );\n\tif( v >= 1.0 )\n\t\treturn vec3( 1., 1., 1. );\n\tfloat vuf;\n\tfloat bf = modf( v * PackFactors.b, vuf );\n\tfloat gf = modf( vuf * ShiftRight8, vuf );\n\treturn vec3( vuf * Inv255, gf * PackUpscale, bf );\n}\nvec2 packDepthToRG( const in float v ) {\n\tif( v <= 0.0 )\n\t\treturn vec2( 0., 0. );\n\tif( v >= 1.0 )\n\t\treturn vec2( 1., 1. );\n\tfloat vuf;\n\tfloat gf = modf( v * 256., vuf );\n\treturn vec2( vuf * Inv255, gf );\n}\nfloat unpackRGBAToDepth( const in vec4 v ) {\n\treturn dot( v, UnpackFactors4 );\n}\nfloat unpackRGBToDepth( const in vec3 v ) {\n\treturn dot( v, UnpackFactors3 );\n}\nfloat unpackRGToDepth( const in vec2 v ) {\n\treturn v.r * UnpackFactors2.r + v.g * UnpackFactors2.g;\n}\nvec4 pack2HalfToRGBA( const in vec2 v ) {\n\tvec4 r = vec4( v.x, fract( v.x * 255.0 ), v.y, fract( v.y * 255.0 ) );\n\treturn vec4( r.x - r.y / 255.0, r.y, r.z - r.w / 255.0, r.w );\n}\nvec2 unpackRGBATo2Half( const in vec4 v ) {\n\treturn vec2( v.x + ( v.y / 255.0 ), v.z + ( v.w / 255.0 ) );\n}\nfloat viewZToOrthographicDepth( const in float viewZ, const in float near, const in float far ) {\n\treturn ( viewZ + near ) / ( near - far );\n}\nfloat orthographicDepthToViewZ( const in float depth, const in float near, const in float far ) {\n\treturn depth * ( near - far ) - near;\n}\nfloat viewZToPerspectiveDepth( const in float viewZ, const in float near, const in float far ) {\n\treturn ( ( near + viewZ ) * far ) / ( ( far - near ) * viewZ );\n}\nfloat perspectiveDepthToViewZ( const in float depth, const in float near, const in float far ) {\n\treturn ( near * far ) / ( ( far - near ) * depth - far );\n}";
var $d5b33d7c30034067$var$premultiplied_alpha_fragment = "#ifdef PREMULTIPLIED_ALPHA\n\tgl_FragColor.rgb *= gl_FragColor.a;\n#endif";
var $d5b33d7c30034067$var$project_vertex = "vec4 mvPosition = vec4( transformed, 1.0 );\n#ifdef USE_BATCHING\n\tmvPosition = batchingMatrix * mvPosition;\n#endif\n#ifdef USE_INSTANCING\n\tmvPosition = instanceMatrix * mvPosition;\n#endif\nmvPosition = modelViewMatrix * mvPosition;\ngl_Position = projectionMatrix * mvPosition;";
var $d5b33d7c30034067$var$dithering_fragment = "#ifdef DITHERING\n\tgl_FragColor.rgb = dithering( gl_FragColor.rgb );\n#endif";
var $d5b33d7c30034067$var$dithering_pars_fragment = "#ifdef DITHERING\n\tvec3 dithering( vec3 color ) {\n\t\tfloat grid_position = rand( gl_FragCoord.xy );\n\t\tvec3 dither_shift_RGB = vec3( 0.25 / 255.0, -0.25 / 255.0, 0.25 / 255.0 );\n\t\tdither_shift_RGB = mix( 2.0 * dither_shift_RGB, -2.0 * dither_shift_RGB, grid_position );\n\t\treturn color + dither_shift_RGB;\n\t}\n#endif";
var $d5b33d7c30034067$var$roughnessmap_fragment = "float roughnessFactor = roughness;\n#ifdef USE_ROUGHNESSMAP\n\tvec4 texelRoughness = texture2D( roughnessMap, vRoughnessMapUv );\n\troughnessFactor *= texelRoughness.g;\n#endif";
var $d5b33d7c30034067$var$roughnessmap_pars_fragment = "#ifdef USE_ROUGHNESSMAP\n\tuniform sampler2D roughnessMap;\n#endif";
var $d5b33d7c30034067$var$shadowmap_pars_fragment = "#if NUM_SPOT_LIGHT_COORDS > 0\n\tvarying vec4 vSpotLightCoord[ NUM_SPOT_LIGHT_COORDS ];\n#endif\n#if NUM_SPOT_LIGHT_MAPS > 0\n\tuniform sampler2D spotLightMap[ NUM_SPOT_LIGHT_MAPS ];\n#endif\n#ifdef USE_SHADOWMAP\n\t#if NUM_DIR_LIGHT_SHADOWS > 0\n\t\tuniform sampler2D directionalShadowMap[ NUM_DIR_LIGHT_SHADOWS ];\n\t\tvarying vec4 vDirectionalShadowCoord[ NUM_DIR_LIGHT_SHADOWS ];\n\t\tstruct DirectionalLightShadow {\n\t\t\tfloat shadowIntensity;\n\t\t\tfloat shadowBias;\n\t\t\tfloat shadowNormalBias;\n\t\t\tfloat shadowRadius;\n\t\t\tvec2 shadowMapSize;\n\t\t};\n\t\tuniform DirectionalLightShadow directionalLightShadows[ NUM_DIR_LIGHT_SHADOWS ];\n\t#endif\n\t#if NUM_SPOT_LIGHT_SHADOWS > 0\n\t\tuniform sampler2D spotShadowMap[ NUM_SPOT_LIGHT_SHADOWS ];\n\t\tstruct SpotLightShadow {\n\t\t\tfloat shadowIntensity;\n\t\t\tfloat shadowBias;\n\t\t\tfloat shadowNormalBias;\n\t\t\tfloat shadowRadius;\n\t\t\tvec2 shadowMapSize;\n\t\t};\n\t\tuniform SpotLightShadow spotLightShadows[ NUM_SPOT_LIGHT_SHADOWS ];\n\t#endif\n\t#if NUM_POINT_LIGHT_SHADOWS > 0\n\t\tuniform sampler2D pointShadowMap[ NUM_POINT_LIGHT_SHADOWS ];\n\t\tvarying vec4 vPointShadowCoord[ NUM_POINT_LIGHT_SHADOWS ];\n\t\tstruct PointLightShadow {\n\t\t\tfloat shadowIntensity;\n\t\t\tfloat shadowBias;\n\t\t\tfloat shadowNormalBias;\n\t\t\tfloat shadowRadius;\n\t\t\tvec2 shadowMapSize;\n\t\t\tfloat shadowCameraNear;\n\t\t\tfloat shadowCameraFar;\n\t\t};\n\t\tuniform PointLightShadow pointLightShadows[ NUM_POINT_LIGHT_SHADOWS ];\n\t#endif\n\tfloat texture2DCompare( sampler2D depths, vec2 uv, float compare ) {\n\t\treturn step( compare, unpackRGBAToDepth( texture2D( depths, uv ) ) );\n\t}\n\tvec2 texture2DDistribution( sampler2D shadow, vec2 uv ) {\n\t\treturn unpackRGBATo2Half( texture2D( shadow, uv ) );\n\t}\n\tfloat VSMShadow (sampler2D shadow, vec2 uv, float compare ){\n\t\tfloat occlusion = 1.0;\n\t\tvec2 distribution = texture2DDistribution( shadow, uv );\n\t\tfloat hard_shadow = step( compare , distribution.x );\n\t\tif (hard_shadow != 1.0 ) {\n\t\t\tfloat distance = compare - distribution.x ;\n\t\t\tfloat variance = max( 0.00000, distribution.y * distribution.y );\n\t\t\tfloat softness_probability = variance / (variance + distance * distance );\t\t\tsoftness_probability = clamp( ( softness_probability - 0.3 ) / ( 0.95 - 0.3 ), 0.0, 1.0 );\t\t\tocclusion = clamp( max( hard_shadow, softness_probability ), 0.0, 1.0 );\n\t\t}\n\t\treturn occlusion;\n\t}\n\tfloat getShadow( sampler2D shadowMap, vec2 shadowMapSize, float shadowIntensity, float shadowBias, float shadowRadius, vec4 shadowCoord ) {\n\t\tfloat shadow = 1.0;\n\t\tshadowCoord.xyz /= shadowCoord.w;\n\t\tshadowCoord.z += shadowBias;\n\t\tbool inFrustum = shadowCoord.x >= 0.0 && shadowCoord.x <= 1.0 && shadowCoord.y >= 0.0 && shadowCoord.y <= 1.0;\n\t\tbool frustumTest = inFrustum && shadowCoord.z <= 1.0;\n\t\tif ( frustumTest ) {\n\t\t#if defined( SHADOWMAP_TYPE_PCF )\n\t\t\tvec2 texelSize = vec2( 1.0 ) / shadowMapSize;\n\t\t\tfloat dx0 = - texelSize.x * shadowRadius;\n\t\t\tfloat dy0 = - texelSize.y * shadowRadius;\n\t\t\tfloat dx1 = + texelSize.x * shadowRadius;\n\t\t\tfloat dy1 = + texelSize.y * shadowRadius;\n\t\t\tfloat dx2 = dx0 / 2.0;\n\t\t\tfloat dy2 = dy0 / 2.0;\n\t\t\tfloat dx3 = dx1 / 2.0;\n\t\t\tfloat dy3 = dy1 / 2.0;\n\t\t\tshadow = (\n\t\t\t\ttexture2DCompare( shadowMap, shadowCoord.xy + vec2( dx0, dy0 ), shadowCoord.z ) +\n\t\t\t\ttexture2DCompare( shadowMap, shadowCoord.xy + vec2( 0.0, dy0 ), shadowCoord.z ) +\n\t\t\t\ttexture2DCompare( shadowMap, shadowCoord.xy + vec2( dx1, dy0 ), shadowCoord.z ) +\n\t\t\t\ttexture2DCompare( shadowMap, shadowCoord.xy + vec2( dx2, dy2 ), shadowCoord.z ) +\n\t\t\t\ttexture2DCompare( shadowMap, shadowCoord.xy + vec2( 0.0, dy2 ), shadowCoord.z ) +\n\t\t\t\ttexture2DCompare( shadowMap, shadowCoord.xy + vec2( dx3, dy2 ), shadowCoord.z ) +\n\t\t\t\ttexture2DCompare( shadowMap, shadowCoord.xy + vec2( dx0, 0.0 ), shadowCoord.z ) +\n\t\t\t\ttexture2DCompare( shadowMap, shadowCoord.xy + vec2( dx2, 0.0 ), shadowCoord.z ) +\n\t\t\t\ttexture2DCompare( shadowMap, shadowCoord.xy, shadowCoord.z ) +\n\t\t\t\ttexture2DCompare( shadowMap, shadowCoord.xy + vec2( dx3, 0.0 ), shadowCoord.z ) +\n\t\t\t\ttexture2DCompare( shadowMap, shadowCoord.xy + vec2( dx1, 0.0 ), shadowCoord.z ) +\n\t\t\t\ttexture2DCompare( shadowMap, shadowCoord.xy + vec2( dx2, dy3 ), shadowCoord.z ) +\n\t\t\t\ttexture2DCompare( shadowMap, shadowCoord.xy + vec2( 0.0, dy3 ), shadowCoord.z ) +\n\t\t\t\ttexture2DCompare( shadowMap, shadowCoord.xy + vec2( dx3, dy3 ), shadowCoord.z ) +\n\t\t\t\ttexture2DCompare( shadowMap, shadowCoord.xy + vec2( dx0, dy1 ), shadowCoord.z ) +\n\t\t\t\ttexture2DCompare( shadowMap, shadowCoord.xy + vec2( 0.0, dy1 ), shadowCoord.z ) +\n\t\t\t\ttexture2DCompare( shadowMap, shadowCoord.xy + vec2( dx1, dy1 ), shadowCoord.z )\n\t\t\t) * ( 1.0 / 17.0 );\n\t\t#elif defined( SHADOWMAP_TYPE_PCF_SOFT )\n\t\t\tvec2 texelSize = vec2( 1.0 ) / shadowMapSize;\n\t\t\tfloat dx = texelSize.x;\n\t\t\tfloat dy = texelSize.y;\n\t\t\tvec2 uv = shadowCoord.xy;\n\t\t\tvec2 f = fract( uv * shadowMapSize + 0.5 );\n\t\t\tuv -= f * texelSize;\n\t\t\tshadow = (\n\t\t\t\ttexture2DCompare( shadowMap, uv, shadowCoord.z ) +\n\t\t\t\ttexture2DCompare( shadowMap, uv + vec2( dx, 0.0 ), shadowCoord.z ) +\n\t\t\t\ttexture2DCompare( shadowMap, uv + vec2( 0.0, dy ), shadowCoord.z ) +\n\t\t\t\ttexture2DCompare( shadowMap, uv + texelSize, shadowCoord.z ) +\n\t\t\t\tmix( texture2DCompare( shadowMap, uv + vec2( -dx, 0.0 ), shadowCoord.z ),\n\t\t\t\t\t texture2DCompare( shadowMap, uv + vec2( 2.0 * dx, 0.0 ), shadowCoord.z ),\n\t\t\t\t\t f.x ) +\n\t\t\t\tmix( texture2DCompare( shadowMap, uv + vec2( -dx, dy ), shadowCoord.z ),\n\t\t\t\t\t texture2DCompare( shadowMap, uv + vec2( 2.0 * dx, dy ), shadowCoord.z ),\n\t\t\t\t\t f.x ) +\n\t\t\t\tmix( texture2DCompare( shadowMap, uv + vec2( 0.0, -dy ), shadowCoord.z ),\n\t\t\t\t\t texture2DCompare( shadowMap, uv + vec2( 0.0, 2.0 * dy ), shadowCoord.z ),\n\t\t\t\t\t f.y ) +\n\t\t\t\tmix( texture2DCompare( shadowMap, uv + vec2( dx, -dy ), shadowCoord.z ),\n\t\t\t\t\t texture2DCompare( shadowMap, uv + vec2( dx, 2.0 * dy ), shadowCoord.z ),\n\t\t\t\t\t f.y ) +\n\t\t\t\tmix( mix( texture2DCompare( shadowMap, uv + vec2( -dx, -dy ), shadowCoord.z ),\n\t\t\t\t\t\t  texture2DCompare( shadowMap, uv + vec2( 2.0 * dx, -dy ), shadowCoord.z ),\n\t\t\t\t\t\t  f.x ),\n\t\t\t\t\t mix( texture2DCompare( shadowMap, uv + vec2( -dx, 2.0 * dy ), shadowCoord.z ),\n\t\t\t\t\t\t  texture2DCompare( shadowMap, uv + vec2( 2.0 * dx, 2.0 * dy ), shadowCoord.z ),\n\t\t\t\t\t\t  f.x ),\n\t\t\t\t\t f.y )\n\t\t\t) * ( 1.0 / 9.0 );\n\t\t#elif defined( SHADOWMAP_TYPE_VSM )\n\t\t\tshadow = VSMShadow( shadowMap, shadowCoord.xy, shadowCoord.z );\n\t\t#else\n\t\t\tshadow = texture2DCompare( shadowMap, shadowCoord.xy, shadowCoord.z );\n\t\t#endif\n\t\t}\n\t\treturn mix( 1.0, shadow, shadowIntensity );\n\t}\n\tvec2 cubeToUV( vec3 v, float texelSizeY ) {\n\t\tvec3 absV = abs( v );\n\t\tfloat scaleToCube = 1.0 / max( absV.x, max( absV.y, absV.z ) );\n\t\tabsV *= scaleToCube;\n\t\tv *= scaleToCube * ( 1.0 - 2.0 * texelSizeY );\n\t\tvec2 planar = v.xy;\n\t\tfloat almostATexel = 1.5 * texelSizeY;\n\t\tfloat almostOne = 1.0 - almostATexel;\n\t\tif ( absV.z >= almostOne ) {\n\t\t\tif ( v.z > 0.0 )\n\t\t\t\tplanar.x = 4.0 - v.x;\n\t\t} else if ( absV.x >= almostOne ) {\n\t\t\tfloat signX = sign( v.x );\n\t\t\tplanar.x = v.z * signX + 2.0 * signX;\n\t\t} else if ( absV.y >= almostOne ) {\n\t\t\tfloat signY = sign( v.y );\n\t\t\tplanar.x = v.x + 2.0 * signY + 2.0;\n\t\t\tplanar.y = v.z * signY - 2.0;\n\t\t}\n\t\treturn vec2( 0.125, 0.25 ) * planar + vec2( 0.375, 0.75 );\n\t}\n\tfloat getPointShadow( sampler2D shadowMap, vec2 shadowMapSize, float shadowIntensity, float shadowBias, float shadowRadius, vec4 shadowCoord, float shadowCameraNear, float shadowCameraFar ) {\n\t\tfloat shadow = 1.0;\n\t\tvec3 lightToPosition = shadowCoord.xyz;\n\t\t\n\t\tfloat lightToPositionLength = length( lightToPosition );\n\t\tif ( lightToPositionLength - shadowCameraFar <= 0.0 && lightToPositionLength - shadowCameraNear >= 0.0 ) {\n\t\t\tfloat dp = ( lightToPositionLength - shadowCameraNear ) / ( shadowCameraFar - shadowCameraNear );\t\t\tdp += shadowBias;\n\t\t\tvec3 bd3D = normalize( lightToPosition );\n\t\t\tvec2 texelSize = vec2( 1.0 ) / ( shadowMapSize * vec2( 4.0, 2.0 ) );\n\t\t\t#if defined( SHADOWMAP_TYPE_PCF ) || defined( SHADOWMAP_TYPE_PCF_SOFT ) || defined( SHADOWMAP_TYPE_VSM )\n\t\t\t\tvec2 offset = vec2( - 1, 1 ) * shadowRadius * texelSize.y;\n\t\t\t\tshadow = (\n\t\t\t\t\ttexture2DCompare( shadowMap, cubeToUV( bd3D + offset.xyy, texelSize.y ), dp ) +\n\t\t\t\t\ttexture2DCompare( shadowMap, cubeToUV( bd3D + offset.yyy, texelSize.y ), dp ) +\n\t\t\t\t\ttexture2DCompare( shadowMap, cubeToUV( bd3D + offset.xyx, texelSize.y ), dp ) +\n\t\t\t\t\ttexture2DCompare( shadowMap, cubeToUV( bd3D + offset.yyx, texelSize.y ), dp ) +\n\t\t\t\t\ttexture2DCompare( shadowMap, cubeToUV( bd3D, texelSize.y ), dp ) +\n\t\t\t\t\ttexture2DCompare( shadowMap, cubeToUV( bd3D + offset.xxy, texelSize.y ), dp ) +\n\t\t\t\t\ttexture2DCompare( shadowMap, cubeToUV( bd3D + offset.yxy, texelSize.y ), dp ) +\n\t\t\t\t\ttexture2DCompare( shadowMap, cubeToUV( bd3D + offset.xxx, texelSize.y ), dp ) +\n\t\t\t\t\ttexture2DCompare( shadowMap, cubeToUV( bd3D + offset.yxx, texelSize.y ), dp )\n\t\t\t\t) * ( 1.0 / 9.0 );\n\t\t\t#else\n\t\t\t\tshadow = texture2DCompare( shadowMap, cubeToUV( bd3D, texelSize.y ), dp );\n\t\t\t#endif\n\t\t}\n\t\treturn mix( 1.0, shadow, shadowIntensity );\n\t}\n#endif";
var $d5b33d7c30034067$var$shadowmap_pars_vertex = "#if NUM_SPOT_LIGHT_COORDS > 0\n\tuniform mat4 spotLightMatrix[ NUM_SPOT_LIGHT_COORDS ];\n\tvarying vec4 vSpotLightCoord[ NUM_SPOT_LIGHT_COORDS ];\n#endif\n#ifdef USE_SHADOWMAP\n\t#if NUM_DIR_LIGHT_SHADOWS > 0\n\t\tuniform mat4 directionalShadowMatrix[ NUM_DIR_LIGHT_SHADOWS ];\n\t\tvarying vec4 vDirectionalShadowCoord[ NUM_DIR_LIGHT_SHADOWS ];\n\t\tstruct DirectionalLightShadow {\n\t\t\tfloat shadowIntensity;\n\t\t\tfloat shadowBias;\n\t\t\tfloat shadowNormalBias;\n\t\t\tfloat shadowRadius;\n\t\t\tvec2 shadowMapSize;\n\t\t};\n\t\tuniform DirectionalLightShadow directionalLightShadows[ NUM_DIR_LIGHT_SHADOWS ];\n\t#endif\n\t#if NUM_SPOT_LIGHT_SHADOWS > 0\n\t\tstruct SpotLightShadow {\n\t\t\tfloat shadowIntensity;\n\t\t\tfloat shadowBias;\n\t\t\tfloat shadowNormalBias;\n\t\t\tfloat shadowRadius;\n\t\t\tvec2 shadowMapSize;\n\t\t};\n\t\tuniform SpotLightShadow spotLightShadows[ NUM_SPOT_LIGHT_SHADOWS ];\n\t#endif\n\t#if NUM_POINT_LIGHT_SHADOWS > 0\n\t\tuniform mat4 pointShadowMatrix[ NUM_POINT_LIGHT_SHADOWS ];\n\t\tvarying vec4 vPointShadowCoord[ NUM_POINT_LIGHT_SHADOWS ];\n\t\tstruct PointLightShadow {\n\t\t\tfloat shadowIntensity;\n\t\t\tfloat shadowBias;\n\t\t\tfloat shadowNormalBias;\n\t\t\tfloat shadowRadius;\n\t\t\tvec2 shadowMapSize;\n\t\t\tfloat shadowCameraNear;\n\t\t\tfloat shadowCameraFar;\n\t\t};\n\t\tuniform PointLightShadow pointLightShadows[ NUM_POINT_LIGHT_SHADOWS ];\n\t#endif\n#endif";
var $d5b33d7c30034067$var$shadowmap_vertex = "#if ( defined( USE_SHADOWMAP ) && ( NUM_DIR_LIGHT_SHADOWS > 0 || NUM_POINT_LIGHT_SHADOWS > 0 ) ) || ( NUM_SPOT_LIGHT_COORDS > 0 )\n\tvec3 shadowWorldNormal = inverseTransformDirection( transformedNormal, viewMatrix );\n\tvec4 shadowWorldPosition;\n#endif\n#if defined( USE_SHADOWMAP )\n\t#if NUM_DIR_LIGHT_SHADOWS > 0\n\t\t#pragma unroll_loop_start\n\t\tfor ( int i = 0; i < NUM_DIR_LIGHT_SHADOWS; i ++ ) {\n\t\t\tshadowWorldPosition = worldPosition + vec4( shadowWorldNormal * directionalLightShadows[ i ].shadowNormalBias, 0 );\n\t\t\tvDirectionalShadowCoord[ i ] = directionalShadowMatrix[ i ] * shadowWorldPosition;\n\t\t}\n\t\t#pragma unroll_loop_end\n\t#endif\n\t#if NUM_POINT_LIGHT_SHADOWS > 0\n\t\t#pragma unroll_loop_start\n\t\tfor ( int i = 0; i < NUM_POINT_LIGHT_SHADOWS; i ++ ) {\n\t\t\tshadowWorldPosition = worldPosition + vec4( shadowWorldNormal * pointLightShadows[ i ].shadowNormalBias, 0 );\n\t\t\tvPointShadowCoord[ i ] = pointShadowMatrix[ i ] * shadowWorldPosition;\n\t\t}\n\t\t#pragma unroll_loop_end\n\t#endif\n#endif\n#if NUM_SPOT_LIGHT_COORDS > 0\n\t#pragma unroll_loop_start\n\tfor ( int i = 0; i < NUM_SPOT_LIGHT_COORDS; i ++ ) {\n\t\tshadowWorldPosition = worldPosition;\n\t\t#if ( defined( USE_SHADOWMAP ) && UNROLLED_LOOP_INDEX < NUM_SPOT_LIGHT_SHADOWS )\n\t\t\tshadowWorldPosition.xyz += shadowWorldNormal * spotLightShadows[ i ].shadowNormalBias;\n\t\t#endif\n\t\tvSpotLightCoord[ i ] = spotLightMatrix[ i ] * shadowWorldPosition;\n\t}\n\t#pragma unroll_loop_end\n#endif";
var $d5b33d7c30034067$var$shadowmask_pars_fragment = "float getShadowMask() {\n\tfloat shadow = 1.0;\n\t#ifdef USE_SHADOWMAP\n\t#if NUM_DIR_LIGHT_SHADOWS > 0\n\tDirectionalLightShadow directionalLight;\n\t#pragma unroll_loop_start\n\tfor ( int i = 0; i < NUM_DIR_LIGHT_SHADOWS; i ++ ) {\n\t\tdirectionalLight = directionalLightShadows[ i ];\n\t\tshadow *= receiveShadow ? getShadow( directionalShadowMap[ i ], directionalLight.shadowMapSize, directionalLight.shadowIntensity, directionalLight.shadowBias, directionalLight.shadowRadius, vDirectionalShadowCoord[ i ] ) : 1.0;\n\t}\n\t#pragma unroll_loop_end\n\t#endif\n\t#if NUM_SPOT_LIGHT_SHADOWS > 0\n\tSpotLightShadow spotLight;\n\t#pragma unroll_loop_start\n\tfor ( int i = 0; i < NUM_SPOT_LIGHT_SHADOWS; i ++ ) {\n\t\tspotLight = spotLightShadows[ i ];\n\t\tshadow *= receiveShadow ? getShadow( spotShadowMap[ i ], spotLight.shadowMapSize, spotLight.shadowIntensity, spotLight.shadowBias, spotLight.shadowRadius, vSpotLightCoord[ i ] ) : 1.0;\n\t}\n\t#pragma unroll_loop_end\n\t#endif\n\t#if NUM_POINT_LIGHT_SHADOWS > 0\n\tPointLightShadow pointLight;\n\t#pragma unroll_loop_start\n\tfor ( int i = 0; i < NUM_POINT_LIGHT_SHADOWS; i ++ ) {\n\t\tpointLight = pointLightShadows[ i ];\n\t\tshadow *= receiveShadow ? getPointShadow( pointShadowMap[ i ], pointLight.shadowMapSize, pointLight.shadowIntensity, pointLight.shadowBias, pointLight.shadowRadius, vPointShadowCoord[ i ], pointLight.shadowCameraNear, pointLight.shadowCameraFar ) : 1.0;\n\t}\n\t#pragma unroll_loop_end\n\t#endif\n\t#endif\n\treturn shadow;\n}";
var $d5b33d7c30034067$var$skinbase_vertex = "#ifdef USE_SKINNING\n\tmat4 boneMatX = getBoneMatrix( skinIndex.x );\n\tmat4 boneMatY = getBoneMatrix( skinIndex.y );\n\tmat4 boneMatZ = getBoneMatrix( skinIndex.z );\n\tmat4 boneMatW = getBoneMatrix( skinIndex.w );\n#endif";
var $d5b33d7c30034067$var$skinning_pars_vertex = "#ifdef USE_SKINNING\n\tuniform mat4 bindMatrix;\n\tuniform mat4 bindMatrixInverse;\n\tuniform highp sampler2D boneTexture;\n\tmat4 getBoneMatrix( const in float i ) {\n\t\tint size = textureSize( boneTexture, 0 ).x;\n\t\tint j = int( i ) * 4;\n\t\tint x = j % size;\n\t\tint y = j / size;\n\t\tvec4 v1 = texelFetch( boneTexture, ivec2( x, y ), 0 );\n\t\tvec4 v2 = texelFetch( boneTexture, ivec2( x + 1, y ), 0 );\n\t\tvec4 v3 = texelFetch( boneTexture, ivec2( x + 2, y ), 0 );\n\t\tvec4 v4 = texelFetch( boneTexture, ivec2( x + 3, y ), 0 );\n\t\treturn mat4( v1, v2, v3, v4 );\n\t}\n#endif";
var $d5b33d7c30034067$var$skinning_vertex = "#ifdef USE_SKINNING\n\tvec4 skinVertex = bindMatrix * vec4( transformed, 1.0 );\n\tvec4 skinned = vec4( 0.0 );\n\tskinned += boneMatX * skinVertex * skinWeight.x;\n\tskinned += boneMatY * skinVertex * skinWeight.y;\n\tskinned += boneMatZ * skinVertex * skinWeight.z;\n\tskinned += boneMatW * skinVertex * skinWeight.w;\n\ttransformed = ( bindMatrixInverse * skinned ).xyz;\n#endif";
var $d5b33d7c30034067$var$skinnormal_vertex = "#ifdef USE_SKINNING\n\tmat4 skinMatrix = mat4( 0.0 );\n\tskinMatrix += skinWeight.x * boneMatX;\n\tskinMatrix += skinWeight.y * boneMatY;\n\tskinMatrix += skinWeight.z * boneMatZ;\n\tskinMatrix += skinWeight.w * boneMatW;\n\tskinMatrix = bindMatrixInverse * skinMatrix * bindMatrix;\n\tobjectNormal = vec4( skinMatrix * vec4( objectNormal, 0.0 ) ).xyz;\n\t#ifdef USE_TANGENT\n\t\tobjectTangent = vec4( skinMatrix * vec4( objectTangent, 0.0 ) ).xyz;\n\t#endif\n#endif";
var $d5b33d7c30034067$var$specularmap_fragment = "float specularStrength;\n#ifdef USE_SPECULARMAP\n\tvec4 texelSpecular = texture2D( specularMap, vSpecularMapUv );\n\tspecularStrength = texelSpecular.r;\n#else\n\tspecularStrength = 1.0;\n#endif";
var $d5b33d7c30034067$var$specularmap_pars_fragment = "#ifdef USE_SPECULARMAP\n\tuniform sampler2D specularMap;\n#endif";
var $d5b33d7c30034067$var$tonemapping_fragment = "#if defined( TONE_MAPPING )\n\tgl_FragColor.rgb = toneMapping( gl_FragColor.rgb );\n#endif";
var $d5b33d7c30034067$var$tonemapping_pars_fragment = "#ifndef saturate\n#define saturate( a ) clamp( a, 0.0, 1.0 )\n#endif\nuniform float toneMappingExposure;\nvec3 LinearToneMapping( vec3 color ) {\n\treturn saturate( toneMappingExposure * color );\n}\nvec3 ReinhardToneMapping( vec3 color ) {\n\tcolor *= toneMappingExposure;\n\treturn saturate( color / ( vec3( 1.0 ) + color ) );\n}\nvec3 CineonToneMapping( vec3 color ) {\n\tcolor *= toneMappingExposure;\n\tcolor = max( vec3( 0.0 ), color - 0.004 );\n\treturn pow( ( color * ( 6.2 * color + 0.5 ) ) / ( color * ( 6.2 * color + 1.7 ) + 0.06 ), vec3( 2.2 ) );\n}\nvec3 RRTAndODTFit( vec3 v ) {\n\tvec3 a = v * ( v + 0.0245786 ) - 0.000090537;\n\tvec3 b = v * ( 0.983729 * v + 0.4329510 ) + 0.238081;\n\treturn a / b;\n}\nvec3 ACESFilmicToneMapping( vec3 color ) {\n\tconst mat3 ACESInputMat = mat3(\n\t\tvec3( 0.59719, 0.07600, 0.02840 ),\t\tvec3( 0.35458, 0.90834, 0.13383 ),\n\t\tvec3( 0.04823, 0.01566, 0.83777 )\n\t);\n\tconst mat3 ACESOutputMat = mat3(\n\t\tvec3(  1.60475, -0.10208, -0.00327 ),\t\tvec3( -0.53108,  1.10813, -0.07276 ),\n\t\tvec3( -0.07367, -0.00605,  1.07602 )\n\t);\n\tcolor *= toneMappingExposure / 0.6;\n\tcolor = ACESInputMat * color;\n\tcolor = RRTAndODTFit( color );\n\tcolor = ACESOutputMat * color;\n\treturn saturate( color );\n}\nconst mat3 LINEAR_REC2020_TO_LINEAR_SRGB = mat3(\n\tvec3( 1.6605, - 0.1246, - 0.0182 ),\n\tvec3( - 0.5876, 1.1329, - 0.1006 ),\n\tvec3( - 0.0728, - 0.0083, 1.1187 )\n);\nconst mat3 LINEAR_SRGB_TO_LINEAR_REC2020 = mat3(\n\tvec3( 0.6274, 0.0691, 0.0164 ),\n\tvec3( 0.3293, 0.9195, 0.0880 ),\n\tvec3( 0.0433, 0.0113, 0.8956 )\n);\nvec3 agxDefaultContrastApprox( vec3 x ) {\n\tvec3 x2 = x * x;\n\tvec3 x4 = x2 * x2;\n\treturn + 15.5 * x4 * x2\n\t\t- 40.14 * x4 * x\n\t\t+ 31.96 * x4\n\t\t- 6.868 * x2 * x\n\t\t+ 0.4298 * x2\n\t\t+ 0.1191 * x\n\t\t- 0.00232;\n}\nvec3 AgXToneMapping( vec3 color ) {\n\tconst mat3 AgXInsetMatrix = mat3(\n\t\tvec3( 0.856627153315983, 0.137318972929847, 0.11189821299995 ),\n\t\tvec3( 0.0951212405381588, 0.761241990602591, 0.0767994186031903 ),\n\t\tvec3( 0.0482516061458583, 0.101439036467562, 0.811302368396859 )\n\t);\n\tconst mat3 AgXOutsetMatrix = mat3(\n\t\tvec3( 1.1271005818144368, - 0.1413297634984383, - 0.14132976349843826 ),\n\t\tvec3( - 0.11060664309660323, 1.157823702216272, - 0.11060664309660294 ),\n\t\tvec3( - 0.016493938717834573, - 0.016493938717834257, 1.2519364065950405 )\n\t);\n\tconst float AgxMinEv = - 12.47393;\tconst float AgxMaxEv = 4.026069;\n\tcolor *= toneMappingExposure;\n\tcolor = LINEAR_SRGB_TO_LINEAR_REC2020 * color;\n\tcolor = AgXInsetMatrix * color;\n\tcolor = max( color, 1e-10 );\tcolor = log2( color );\n\tcolor = ( color - AgxMinEv ) / ( AgxMaxEv - AgxMinEv );\n\tcolor = clamp( color, 0.0, 1.0 );\n\tcolor = agxDefaultContrastApprox( color );\n\tcolor = AgXOutsetMatrix * color;\n\tcolor = pow( max( vec3( 0.0 ), color ), vec3( 2.2 ) );\n\tcolor = LINEAR_REC2020_TO_LINEAR_SRGB * color;\n\tcolor = clamp( color, 0.0, 1.0 );\n\treturn color;\n}\nvec3 NeutralToneMapping( vec3 color ) {\n\tconst float StartCompression = 0.8 - 0.04;\n\tconst float Desaturation = 0.15;\n\tcolor *= toneMappingExposure;\n\tfloat x = min( color.r, min( color.g, color.b ) );\n\tfloat offset = x < 0.08 ? x - 6.25 * x * x : 0.04;\n\tcolor -= offset;\n\tfloat peak = max( color.r, max( color.g, color.b ) );\n\tif ( peak < StartCompression ) return color;\n\tfloat d = 1. - StartCompression;\n\tfloat newPeak = 1. - d * d / ( peak + d - StartCompression );\n\tcolor *= newPeak / peak;\n\tfloat g = 1. - 1. / ( Desaturation * ( peak - newPeak ) + 1. );\n\treturn mix( color, vec3( newPeak ), g );\n}\nvec3 CustomToneMapping( vec3 color ) { return color; }";
var $d5b33d7c30034067$var$transmission_fragment = "#ifdef USE_TRANSMISSION\n\tmaterial.transmission = transmission;\n\tmaterial.transmissionAlpha = 1.0;\n\tmaterial.thickness = thickness;\n\tmaterial.attenuationDistance = attenuationDistance;\n\tmaterial.attenuationColor = attenuationColor;\n\t#ifdef USE_TRANSMISSIONMAP\n\t\tmaterial.transmission *= texture2D( transmissionMap, vTransmissionMapUv ).r;\n\t#endif\n\t#ifdef USE_THICKNESSMAP\n\t\tmaterial.thickness *= texture2D( thicknessMap, vThicknessMapUv ).g;\n\t#endif\n\tvec3 pos = vWorldPosition;\n\tvec3 v = normalize( cameraPosition - pos );\n\tvec3 n = inverseTransformDirection( normal, viewMatrix );\n\tvec4 transmitted = getIBLVolumeRefraction(\n\t\tn, v, material.roughness, material.diffuseColor, material.specularColor, material.specularF90,\n\t\tpos, modelMatrix, viewMatrix, projectionMatrix, material.dispersion, material.ior, material.thickness,\n\t\tmaterial.attenuationColor, material.attenuationDistance );\n\tmaterial.transmissionAlpha = mix( material.transmissionAlpha, transmitted.a, material.transmission );\n\ttotalDiffuse = mix( totalDiffuse, transmitted.rgb, material.transmission );\n#endif";
var $d5b33d7c30034067$var$transmission_pars_fragment = "#ifdef USE_TRANSMISSION\n\tuniform float transmission;\n\tuniform float thickness;\n\tuniform float attenuationDistance;\n\tuniform vec3 attenuationColor;\n\t#ifdef USE_TRANSMISSIONMAP\n\t\tuniform sampler2D transmissionMap;\n\t#endif\n\t#ifdef USE_THICKNESSMAP\n\t\tuniform sampler2D thicknessMap;\n\t#endif\n\tuniform vec2 transmissionSamplerSize;\n\tuniform sampler2D transmissionSamplerMap;\n\tuniform mat4 modelMatrix;\n\tuniform mat4 projectionMatrix;\n\tvarying vec3 vWorldPosition;\n\tfloat w0( float a ) {\n\t\treturn ( 1.0 / 6.0 ) * ( a * ( a * ( - a + 3.0 ) - 3.0 ) + 1.0 );\n\t}\n\tfloat w1( float a ) {\n\t\treturn ( 1.0 / 6.0 ) * ( a *  a * ( 3.0 * a - 6.0 ) + 4.0 );\n\t}\n\tfloat w2( float a ){\n\t\treturn ( 1.0 / 6.0 ) * ( a * ( a * ( - 3.0 * a + 3.0 ) + 3.0 ) + 1.0 );\n\t}\n\tfloat w3( float a ) {\n\t\treturn ( 1.0 / 6.0 ) * ( a * a * a );\n\t}\n\tfloat g0( float a ) {\n\t\treturn w0( a ) + w1( a );\n\t}\n\tfloat g1( float a ) {\n\t\treturn w2( a ) + w3( a );\n\t}\n\tfloat h0( float a ) {\n\t\treturn - 1.0 + w1( a ) / ( w0( a ) + w1( a ) );\n\t}\n\tfloat h1( float a ) {\n\t\treturn 1.0 + w3( a ) / ( w2( a ) + w3( a ) );\n\t}\n\tvec4 bicubic( sampler2D tex, vec2 uv, vec4 texelSize, float lod ) {\n\t\tuv = uv * texelSize.zw + 0.5;\n\t\tvec2 iuv = floor( uv );\n\t\tvec2 fuv = fract( uv );\n\t\tfloat g0x = g0( fuv.x );\n\t\tfloat g1x = g1( fuv.x );\n\t\tfloat h0x = h0( fuv.x );\n\t\tfloat h1x = h1( fuv.x );\n\t\tfloat h0y = h0( fuv.y );\n\t\tfloat h1y = h1( fuv.y );\n\t\tvec2 p0 = ( vec2( iuv.x + h0x, iuv.y + h0y ) - 0.5 ) * texelSize.xy;\n\t\tvec2 p1 = ( vec2( iuv.x + h1x, iuv.y + h0y ) - 0.5 ) * texelSize.xy;\n\t\tvec2 p2 = ( vec2( iuv.x + h0x, iuv.y + h1y ) - 0.5 ) * texelSize.xy;\n\t\tvec2 p3 = ( vec2( iuv.x + h1x, iuv.y + h1y ) - 0.5 ) * texelSize.xy;\n\t\treturn g0( fuv.y ) * ( g0x * textureLod( tex, p0, lod ) + g1x * textureLod( tex, p1, lod ) ) +\n\t\t\tg1( fuv.y ) * ( g0x * textureLod( tex, p2, lod ) + g1x * textureLod( tex, p3, lod ) );\n\t}\n\tvec4 textureBicubic( sampler2D sampler, vec2 uv, float lod ) {\n\t\tvec2 fLodSize = vec2( textureSize( sampler, int( lod ) ) );\n\t\tvec2 cLodSize = vec2( textureSize( sampler, int( lod + 1.0 ) ) );\n\t\tvec2 fLodSizeInv = 1.0 / fLodSize;\n\t\tvec2 cLodSizeInv = 1.0 / cLodSize;\n\t\tvec4 fSample = bicubic( sampler, uv, vec4( fLodSizeInv, fLodSize ), floor( lod ) );\n\t\tvec4 cSample = bicubic( sampler, uv, vec4( cLodSizeInv, cLodSize ), ceil( lod ) );\n\t\treturn mix( fSample, cSample, fract( lod ) );\n\t}\n\tvec3 getVolumeTransmissionRay( const in vec3 n, const in vec3 v, const in float thickness, const in float ior, const in mat4 modelMatrix ) {\n\t\tvec3 refractionVector = refract( - v, normalize( n ), 1.0 / ior );\n\t\tvec3 modelScale;\n\t\tmodelScale.x = length( vec3( modelMatrix[ 0 ].xyz ) );\n\t\tmodelScale.y = length( vec3( modelMatrix[ 1 ].xyz ) );\n\t\tmodelScale.z = length( vec3( modelMatrix[ 2 ].xyz ) );\n\t\treturn normalize( refractionVector ) * thickness * modelScale;\n\t}\n\tfloat applyIorToRoughness( const in float roughness, const in float ior ) {\n\t\treturn roughness * clamp( ior * 2.0 - 2.0, 0.0, 1.0 );\n\t}\n\tvec4 getTransmissionSample( const in vec2 fragCoord, const in float roughness, const in float ior ) {\n\t\tfloat lod = log2( transmissionSamplerSize.x ) * applyIorToRoughness( roughness, ior );\n\t\treturn textureBicubic( transmissionSamplerMap, fragCoord.xy, lod );\n\t}\n\tvec3 volumeAttenuation( const in float transmissionDistance, const in vec3 attenuationColor, const in float attenuationDistance ) {\n\t\tif ( isinf( attenuationDistance ) ) {\n\t\t\treturn vec3( 1.0 );\n\t\t} else {\n\t\t\tvec3 attenuationCoefficient = -log( attenuationColor ) / attenuationDistance;\n\t\t\tvec3 transmittance = exp( - attenuationCoefficient * transmissionDistance );\t\t\treturn transmittance;\n\t\t}\n\t}\n\tvec4 getIBLVolumeRefraction( const in vec3 n, const in vec3 v, const in float roughness, const in vec3 diffuseColor,\n\t\tconst in vec3 specularColor, const in float specularF90, const in vec3 position, const in mat4 modelMatrix,\n\t\tconst in mat4 viewMatrix, const in mat4 projMatrix, const in float dispersion, const in float ior, const in float thickness,\n\t\tconst in vec3 attenuationColor, const in float attenuationDistance ) {\n\t\tvec4 transmittedLight;\n\t\tvec3 transmittance;\n\t\t#ifdef USE_DISPERSION\n\t\t\tfloat halfSpread = ( ior - 1.0 ) * 0.025 * dispersion;\n\t\t\tvec3 iors = vec3( ior - halfSpread, ior, ior + halfSpread );\n\t\t\tfor ( int i = 0; i < 3; i ++ ) {\n\t\t\t\tvec3 transmissionRay = getVolumeTransmissionRay( n, v, thickness, iors[ i ], modelMatrix );\n\t\t\t\tvec3 refractedRayExit = position + transmissionRay;\n\t\t\t\tvec4 ndcPos = projMatrix * viewMatrix * vec4( refractedRayExit, 1.0 );\n\t\t\t\tvec2 refractionCoords = ndcPos.xy / ndcPos.w;\n\t\t\t\trefractionCoords += 1.0;\n\t\t\t\trefractionCoords /= 2.0;\n\t\t\t\tvec4 transmissionSample = getTransmissionSample( refractionCoords, roughness, iors[ i ] );\n\t\t\t\ttransmittedLight[ i ] = transmissionSample[ i ];\n\t\t\t\ttransmittedLight.a += transmissionSample.a;\n\t\t\t\ttransmittance[ i ] = diffuseColor[ i ] * volumeAttenuation( length( transmissionRay ), attenuationColor, attenuationDistance )[ i ];\n\t\t\t}\n\t\t\ttransmittedLight.a /= 3.0;\n\t\t#else\n\t\t\tvec3 transmissionRay = getVolumeTransmissionRay( n, v, thickness, ior, modelMatrix );\n\t\t\tvec3 refractedRayExit = position + transmissionRay;\n\t\t\tvec4 ndcPos = projMatrix * viewMatrix * vec4( refractedRayExit, 1.0 );\n\t\t\tvec2 refractionCoords = ndcPos.xy / ndcPos.w;\n\t\t\trefractionCoords += 1.0;\n\t\t\trefractionCoords /= 2.0;\n\t\t\ttransmittedLight = getTransmissionSample( refractionCoords, roughness, ior );\n\t\t\ttransmittance = diffuseColor * volumeAttenuation( length( transmissionRay ), attenuationColor, attenuationDistance );\n\t\t#endif\n\t\tvec3 attenuatedColor = transmittance * transmittedLight.rgb;\n\t\tvec3 F = EnvironmentBRDF( n, v, specularColor, specularF90, roughness );\n\t\tfloat transmittanceFactor = ( transmittance.r + transmittance.g + transmittance.b ) / 3.0;\n\t\treturn vec4( ( 1.0 - F ) * attenuatedColor, 1.0 - ( 1.0 - transmittedLight.a ) * transmittanceFactor );\n\t}\n#endif";
var $d5b33d7c30034067$var$uv_pars_fragment = "#if defined( USE_UV ) || defined( USE_ANISOTROPY )\n\tvarying vec2 vUv;\n#endif\n#ifdef USE_MAP\n\tvarying vec2 vMapUv;\n#endif\n#ifdef USE_ALPHAMAP\n\tvarying vec2 vAlphaMapUv;\n#endif\n#ifdef USE_LIGHTMAP\n\tvarying vec2 vLightMapUv;\n#endif\n#ifdef USE_AOMAP\n\tvarying vec2 vAoMapUv;\n#endif\n#ifdef USE_BUMPMAP\n\tvarying vec2 vBumpMapUv;\n#endif\n#ifdef USE_NORMALMAP\n\tvarying vec2 vNormalMapUv;\n#endif\n#ifdef USE_EMISSIVEMAP\n\tvarying vec2 vEmissiveMapUv;\n#endif\n#ifdef USE_METALNESSMAP\n\tvarying vec2 vMetalnessMapUv;\n#endif\n#ifdef USE_ROUGHNESSMAP\n\tvarying vec2 vRoughnessMapUv;\n#endif\n#ifdef USE_ANISOTROPYMAP\n\tvarying vec2 vAnisotropyMapUv;\n#endif\n#ifdef USE_CLEARCOATMAP\n\tvarying vec2 vClearcoatMapUv;\n#endif\n#ifdef USE_CLEARCOAT_NORMALMAP\n\tvarying vec2 vClearcoatNormalMapUv;\n#endif\n#ifdef USE_CLEARCOAT_ROUGHNESSMAP\n\tvarying vec2 vClearcoatRoughnessMapUv;\n#endif\n#ifdef USE_IRIDESCENCEMAP\n\tvarying vec2 vIridescenceMapUv;\n#endif\n#ifdef USE_IRIDESCENCE_THICKNESSMAP\n\tvarying vec2 vIridescenceThicknessMapUv;\n#endif\n#ifdef USE_SHEEN_COLORMAP\n\tvarying vec2 vSheenColorMapUv;\n#endif\n#ifdef USE_SHEEN_ROUGHNESSMAP\n\tvarying vec2 vSheenRoughnessMapUv;\n#endif\n#ifdef USE_SPECULARMAP\n\tvarying vec2 vSpecularMapUv;\n#endif\n#ifdef USE_SPECULAR_COLORMAP\n\tvarying vec2 vSpecularColorMapUv;\n#endif\n#ifdef USE_SPECULAR_INTENSITYMAP\n\tvarying vec2 vSpecularIntensityMapUv;\n#endif\n#ifdef USE_TRANSMISSIONMAP\n\tuniform mat3 transmissionMapTransform;\n\tvarying vec2 vTransmissionMapUv;\n#endif\n#ifdef USE_THICKNESSMAP\n\tuniform mat3 thicknessMapTransform;\n\tvarying vec2 vThicknessMapUv;\n#endif";
var $d5b33d7c30034067$var$uv_pars_vertex = "#if defined( USE_UV ) || defined( USE_ANISOTROPY )\n\tvarying vec2 vUv;\n#endif\n#ifdef USE_MAP\n\tuniform mat3 mapTransform;\n\tvarying vec2 vMapUv;\n#endif\n#ifdef USE_ALPHAMAP\n\tuniform mat3 alphaMapTransform;\n\tvarying vec2 vAlphaMapUv;\n#endif\n#ifdef USE_LIGHTMAP\n\tuniform mat3 lightMapTransform;\n\tvarying vec2 vLightMapUv;\n#endif\n#ifdef USE_AOMAP\n\tuniform mat3 aoMapTransform;\n\tvarying vec2 vAoMapUv;\n#endif\n#ifdef USE_BUMPMAP\n\tuniform mat3 bumpMapTransform;\n\tvarying vec2 vBumpMapUv;\n#endif\n#ifdef USE_NORMALMAP\n\tuniform mat3 normalMapTransform;\n\tvarying vec2 vNormalMapUv;\n#endif\n#ifdef USE_DISPLACEMENTMAP\n\tuniform mat3 displacementMapTransform;\n\tvarying vec2 vDisplacementMapUv;\n#endif\n#ifdef USE_EMISSIVEMAP\n\tuniform mat3 emissiveMapTransform;\n\tvarying vec2 vEmissiveMapUv;\n#endif\n#ifdef USE_METALNESSMAP\n\tuniform mat3 metalnessMapTransform;\n\tvarying vec2 vMetalnessMapUv;\n#endif\n#ifdef USE_ROUGHNESSMAP\n\tuniform mat3 roughnessMapTransform;\n\tvarying vec2 vRoughnessMapUv;\n#endif\n#ifdef USE_ANISOTROPYMAP\n\tuniform mat3 anisotropyMapTransform;\n\tvarying vec2 vAnisotropyMapUv;\n#endif\n#ifdef USE_CLEARCOATMAP\n\tuniform mat3 clearcoatMapTransform;\n\tvarying vec2 vClearcoatMapUv;\n#endif\n#ifdef USE_CLEARCOAT_NORMALMAP\n\tuniform mat3 clearcoatNormalMapTransform;\n\tvarying vec2 vClearcoatNormalMapUv;\n#endif\n#ifdef USE_CLEARCOAT_ROUGHNESSMAP\n\tuniform mat3 clearcoatRoughnessMapTransform;\n\tvarying vec2 vClearcoatRoughnessMapUv;\n#endif\n#ifdef USE_SHEEN_COLORMAP\n\tuniform mat3 sheenColorMapTransform;\n\tvarying vec2 vSheenColorMapUv;\n#endif\n#ifdef USE_SHEEN_ROUGHNESSMAP\n\tuniform mat3 sheenRoughnessMapTransform;\n\tvarying vec2 vSheenRoughnessMapUv;\n#endif\n#ifdef USE_IRIDESCENCEMAP\n\tuniform mat3 iridescenceMapTransform;\n\tvarying vec2 vIridescenceMapUv;\n#endif\n#ifdef USE_IRIDESCENCE_THICKNESSMAP\n\tuniform mat3 iridescenceThicknessMapTransform;\n\tvarying vec2 vIridescenceThicknessMapUv;\n#endif\n#ifdef USE_SPECULARMAP\n\tuniform mat3 specularMapTransform;\n\tvarying vec2 vSpecularMapUv;\n#endif\n#ifdef USE_SPECULAR_COLORMAP\n\tuniform mat3 specularColorMapTransform;\n\tvarying vec2 vSpecularColorMapUv;\n#endif\n#ifdef USE_SPECULAR_INTENSITYMAP\n\tuniform mat3 specularIntensityMapTransform;\n\tvarying vec2 vSpecularIntensityMapUv;\n#endif\n#ifdef USE_TRANSMISSIONMAP\n\tuniform mat3 transmissionMapTransform;\n\tvarying vec2 vTransmissionMapUv;\n#endif\n#ifdef USE_THICKNESSMAP\n\tuniform mat3 thicknessMapTransform;\n\tvarying vec2 vThicknessMapUv;\n#endif";
var $d5b33d7c30034067$var$uv_vertex = "#if defined( USE_UV ) || defined( USE_ANISOTROPY )\n\tvUv = vec3( uv, 1 ).xy;\n#endif\n#ifdef USE_MAP\n\tvMapUv = ( mapTransform * vec3( MAP_UV, 1 ) ).xy;\n#endif\n#ifdef USE_ALPHAMAP\n\tvAlphaMapUv = ( alphaMapTransform * vec3( ALPHAMAP_UV, 1 ) ).xy;\n#endif\n#ifdef USE_LIGHTMAP\n\tvLightMapUv = ( lightMapTransform * vec3( LIGHTMAP_UV, 1 ) ).xy;\n#endif\n#ifdef USE_AOMAP\n\tvAoMapUv = ( aoMapTransform * vec3( AOMAP_UV, 1 ) ).xy;\n#endif\n#ifdef USE_BUMPMAP\n\tvBumpMapUv = ( bumpMapTransform * vec3( BUMPMAP_UV, 1 ) ).xy;\n#endif\n#ifdef USE_NORMALMAP\n\tvNormalMapUv = ( normalMapTransform * vec3( NORMALMAP_UV, 1 ) ).xy;\n#endif\n#ifdef USE_DISPLACEMENTMAP\n\tvDisplacementMapUv = ( displacementMapTransform * vec3( DISPLACEMENTMAP_UV, 1 ) ).xy;\n#endif\n#ifdef USE_EMISSIVEMAP\n\tvEmissiveMapUv = ( emissiveMapTransform * vec3( EMISSIVEMAP_UV, 1 ) ).xy;\n#endif\n#ifdef USE_METALNESSMAP\n\tvMetalnessMapUv = ( metalnessMapTransform * vec3( METALNESSMAP_UV, 1 ) ).xy;\n#endif\n#ifdef USE_ROUGHNESSMAP\n\tvRoughnessMapUv = ( roughnessMapTransform * vec3( ROUGHNESSMAP_UV, 1 ) ).xy;\n#endif\n#ifdef USE_ANISOTROPYMAP\n\tvAnisotropyMapUv = ( anisotropyMapTransform * vec3( ANISOTROPYMAP_UV, 1 ) ).xy;\n#endif\n#ifdef USE_CLEARCOATMAP\n\tvClearcoatMapUv = ( clearcoatMapTransform * vec3( CLEARCOATMAP_UV, 1 ) ).xy;\n#endif\n#ifdef USE_CLEARCOAT_NORMALMAP\n\tvClearcoatNormalMapUv = ( clearcoatNormalMapTransform * vec3( CLEARCOAT_NORMALMAP_UV, 1 ) ).xy;\n#endif\n#ifdef USE_CLEARCOAT_ROUGHNESSMAP\n\tvClearcoatRoughnessMapUv = ( clearcoatRoughnessMapTransform * vec3( CLEARCOAT_ROUGHNESSMAP_UV, 1 ) ).xy;\n#endif\n#ifdef USE_IRIDESCENCEMAP\n\tvIridescenceMapUv = ( iridescenceMapTransform * vec3( IRIDESCENCEMAP_UV, 1 ) ).xy;\n#endif\n#ifdef USE_IRIDESCENCE_THICKNESSMAP\n\tvIridescenceThicknessMapUv = ( iridescenceThicknessMapTransform * vec3( IRIDESCENCE_THICKNESSMAP_UV, 1 ) ).xy;\n#endif\n#ifdef USE_SHEEN_COLORMAP\n\tvSheenColorMapUv = ( sheenColorMapTransform * vec3( SHEEN_COLORMAP_UV, 1 ) ).xy;\n#endif\n#ifdef USE_SHEEN_ROUGHNESSMAP\n\tvSheenRoughnessMapUv = ( sheenRoughnessMapTransform * vec3( SHEEN_ROUGHNESSMAP_UV, 1 ) ).xy;\n#endif\n#ifdef USE_SPECULARMAP\n\tvSpecularMapUv = ( specularMapTransform * vec3( SPECULARMAP_UV, 1 ) ).xy;\n#endif\n#ifdef USE_SPECULAR_COLORMAP\n\tvSpecularColorMapUv = ( specularColorMapTransform * vec3( SPECULAR_COLORMAP_UV, 1 ) ).xy;\n#endif\n#ifdef USE_SPECULAR_INTENSITYMAP\n\tvSpecularIntensityMapUv = ( specularIntensityMapTransform * vec3( SPECULAR_INTENSITYMAP_UV, 1 ) ).xy;\n#endif\n#ifdef USE_TRANSMISSIONMAP\n\tvTransmissionMapUv = ( transmissionMapTransform * vec3( TRANSMISSIONMAP_UV, 1 ) ).xy;\n#endif\n#ifdef USE_THICKNESSMAP\n\tvThicknessMapUv = ( thicknessMapTransform * vec3( THICKNESSMAP_UV, 1 ) ).xy;\n#endif";
var $d5b33d7c30034067$var$worldpos_vertex = "#if defined( USE_ENVMAP ) || defined( DISTANCE ) || defined ( USE_SHADOWMAP ) || defined ( USE_TRANSMISSION ) || NUM_SPOT_LIGHT_COORDS > 0\n\tvec4 worldPosition = vec4( transformed, 1.0 );\n\t#ifdef USE_BATCHING\n\t\tworldPosition = batchingMatrix * worldPosition;\n\t#endif\n\t#ifdef USE_INSTANCING\n\t\tworldPosition = instanceMatrix * worldPosition;\n\t#endif\n\tworldPosition = modelMatrix * worldPosition;\n#endif";
const $d5b33d7c30034067$var$vertex$h = "varying vec2 vUv;\nuniform mat3 uvTransform;\nvoid main() {\n\tvUv = ( uvTransform * vec3( uv, 1 ) ).xy;\n\tgl_Position = vec4( position.xy, 1.0, 1.0 );\n}";
const $d5b33d7c30034067$var$fragment$h = "uniform sampler2D t2D;\nuniform float backgroundIntensity;\nvarying vec2 vUv;\nvoid main() {\n\tvec4 texColor = texture2D( t2D, vUv );\n\t#ifdef DECODE_VIDEO_TEXTURE\n\t\ttexColor = vec4( mix( pow( texColor.rgb * 0.9478672986 + vec3( 0.0521327014 ), vec3( 2.4 ) ), texColor.rgb * 0.0773993808, vec3( lessThanEqual( texColor.rgb, vec3( 0.04045 ) ) ) ), texColor.w );\n\t#endif\n\ttexColor.rgb *= backgroundIntensity;\n\tgl_FragColor = texColor;\n\t#include <tonemapping_fragment>\n\t#include <colorspace_fragment>\n}";
const $d5b33d7c30034067$var$vertex$g = "varying vec3 vWorldDirection;\n#include <common>\nvoid main() {\n\tvWorldDirection = transformDirection( position, modelMatrix );\n\t#include <begin_vertex>\n\t#include <project_vertex>\n\tgl_Position.z = gl_Position.w;\n}";
const $d5b33d7c30034067$var$fragment$g = "#ifdef ENVMAP_TYPE_CUBE\n\tuniform samplerCube envMap;\n#elif defined( ENVMAP_TYPE_CUBE_UV )\n\tuniform sampler2D envMap;\n#endif\nuniform float flipEnvMap;\nuniform float backgroundBlurriness;\nuniform float backgroundIntensity;\nuniform mat3 backgroundRotation;\nvarying vec3 vWorldDirection;\n#include <cube_uv_reflection_fragment>\nvoid main() {\n\t#ifdef ENVMAP_TYPE_CUBE\n\t\tvec4 texColor = textureCube( envMap, backgroundRotation * vec3( flipEnvMap * vWorldDirection.x, vWorldDirection.yz ) );\n\t#elif defined( ENVMAP_TYPE_CUBE_UV )\n\t\tvec4 texColor = textureCubeUV( envMap, backgroundRotation * vWorldDirection, backgroundBlurriness );\n\t#else\n\t\tvec4 texColor = vec4( 0.0, 0.0, 0.0, 1.0 );\n\t#endif\n\ttexColor.rgb *= backgroundIntensity;\n\tgl_FragColor = texColor;\n\t#include <tonemapping_fragment>\n\t#include <colorspace_fragment>\n}";
const $d5b33d7c30034067$var$vertex$f = "varying vec3 vWorldDirection;\n#include <common>\nvoid main() {\n\tvWorldDirection = transformDirection( position, modelMatrix );\n\t#include <begin_vertex>\n\t#include <project_vertex>\n\tgl_Position.z = gl_Position.w;\n}";
const $d5b33d7c30034067$var$fragment$f = "uniform samplerCube tCube;\nuniform float tFlip;\nuniform float opacity;\nvarying vec3 vWorldDirection;\nvoid main() {\n\tvec4 texColor = textureCube( tCube, vec3( tFlip * vWorldDirection.x, vWorldDirection.yz ) );\n\tgl_FragColor = texColor;\n\tgl_FragColor.a *= opacity;\n\t#include <tonemapping_fragment>\n\t#include <colorspace_fragment>\n}";
const $d5b33d7c30034067$var$vertex$e = "#include <common>\n#include <batching_pars_vertex>\n#include <uv_pars_vertex>\n#include <displacementmap_pars_vertex>\n#include <morphtarget_pars_vertex>\n#include <skinning_pars_vertex>\n#include <logdepthbuf_pars_vertex>\n#include <clipping_planes_pars_vertex>\nvarying vec2 vHighPrecisionZW;\nvoid main() {\n\t#include <uv_vertex>\n\t#include <batching_vertex>\n\t#include <skinbase_vertex>\n\t#include <morphinstance_vertex>\n\t#ifdef USE_DISPLACEMENTMAP\n\t\t#include <beginnormal_vertex>\n\t\t#include <morphnormal_vertex>\n\t\t#include <skinnormal_vertex>\n\t#endif\n\t#include <begin_vertex>\n\t#include <morphtarget_vertex>\n\t#include <skinning_vertex>\n\t#include <displacementmap_vertex>\n\t#include <project_vertex>\n\t#include <logdepthbuf_vertex>\n\t#include <clipping_planes_vertex>\n\tvHighPrecisionZW = gl_Position.zw;\n}";
const $d5b33d7c30034067$var$fragment$e = "#if DEPTH_PACKING == 3200\n\tuniform float opacity;\n#endif\n#include <common>\n#include <packing>\n#include <uv_pars_fragment>\n#include <map_pars_fragment>\n#include <alphamap_pars_fragment>\n#include <alphatest_pars_fragment>\n#include <alphahash_pars_fragment>\n#include <logdepthbuf_pars_fragment>\n#include <clipping_planes_pars_fragment>\nvarying vec2 vHighPrecisionZW;\nvoid main() {\n\tvec4 diffuseColor = vec4( 1.0 );\n\t#include <clipping_planes_fragment>\n\t#if DEPTH_PACKING == 3200\n\t\tdiffuseColor.a = opacity;\n\t#endif\n\t#include <map_fragment>\n\t#include <alphamap_fragment>\n\t#include <alphatest_fragment>\n\t#include <alphahash_fragment>\n\t#include <logdepthbuf_fragment>\n\tfloat fragCoordZ = 0.5 * vHighPrecisionZW[0] / vHighPrecisionZW[1] + 0.5;\n\t#if DEPTH_PACKING == 3200\n\t\tgl_FragColor = vec4( vec3( 1.0 - fragCoordZ ), opacity );\n\t#elif DEPTH_PACKING == 3201\n\t\tgl_FragColor = packDepthToRGBA( fragCoordZ );\n\t#elif DEPTH_PACKING == 3202\n\t\tgl_FragColor = vec4( packDepthToRGB( fragCoordZ ), 1.0 );\n\t#elif DEPTH_PACKING == 3203\n\t\tgl_FragColor = vec4( packDepthToRG( fragCoordZ ), 0.0, 1.0 );\n\t#endif\n}";
const $d5b33d7c30034067$var$vertex$d = "#define DISTANCE\nvarying vec3 vWorldPosition;\n#include <common>\n#include <batching_pars_vertex>\n#include <uv_pars_vertex>\n#include <displacementmap_pars_vertex>\n#include <morphtarget_pars_vertex>\n#include <skinning_pars_vertex>\n#include <clipping_planes_pars_vertex>\nvoid main() {\n\t#include <uv_vertex>\n\t#include <batching_vertex>\n\t#include <skinbase_vertex>\n\t#include <morphinstance_vertex>\n\t#ifdef USE_DISPLACEMENTMAP\n\t\t#include <beginnormal_vertex>\n\t\t#include <morphnormal_vertex>\n\t\t#include <skinnormal_vertex>\n\t#endif\n\t#include <begin_vertex>\n\t#include <morphtarget_vertex>\n\t#include <skinning_vertex>\n\t#include <displacementmap_vertex>\n\t#include <project_vertex>\n\t#include <worldpos_vertex>\n\t#include <clipping_planes_vertex>\n\tvWorldPosition = worldPosition.xyz;\n}";
const $d5b33d7c30034067$var$fragment$d = "#define DISTANCE\nuniform vec3 referencePosition;\nuniform float nearDistance;\nuniform float farDistance;\nvarying vec3 vWorldPosition;\n#include <common>\n#include <packing>\n#include <uv_pars_fragment>\n#include <map_pars_fragment>\n#include <alphamap_pars_fragment>\n#include <alphatest_pars_fragment>\n#include <alphahash_pars_fragment>\n#include <clipping_planes_pars_fragment>\nvoid main () {\n\tvec4 diffuseColor = vec4( 1.0 );\n\t#include <clipping_planes_fragment>\n\t#include <map_fragment>\n\t#include <alphamap_fragment>\n\t#include <alphatest_fragment>\n\t#include <alphahash_fragment>\n\tfloat dist = length( vWorldPosition - referencePosition );\n\tdist = ( dist - nearDistance ) / ( farDistance - nearDistance );\n\tdist = saturate( dist );\n\tgl_FragColor = packDepthToRGBA( dist );\n}";
const $d5b33d7c30034067$var$vertex$c = "varying vec3 vWorldDirection;\n#include <common>\nvoid main() {\n\tvWorldDirection = transformDirection( position, modelMatrix );\n\t#include <begin_vertex>\n\t#include <project_vertex>\n}";
const $d5b33d7c30034067$var$fragment$c = "uniform sampler2D tEquirect;\nvarying vec3 vWorldDirection;\n#include <common>\nvoid main() {\n\tvec3 direction = normalize( vWorldDirection );\n\tvec2 sampleUV = equirectUv( direction );\n\tgl_FragColor = texture2D( tEquirect, sampleUV );\n\t#include <tonemapping_fragment>\n\t#include <colorspace_fragment>\n}";
const $d5b33d7c30034067$var$vertex$b = "uniform float scale;\nattribute float lineDistance;\nvarying float vLineDistance;\n#include <common>\n#include <uv_pars_vertex>\n#include <color_pars_vertex>\n#include <fog_pars_vertex>\n#include <morphtarget_pars_vertex>\n#include <logdepthbuf_pars_vertex>\n#include <clipping_planes_pars_vertex>\nvoid main() {\n\tvLineDistance = scale * lineDistance;\n\t#include <uv_vertex>\n\t#include <color_vertex>\n\t#include <morphinstance_vertex>\n\t#include <morphcolor_vertex>\n\t#include <begin_vertex>\n\t#include <morphtarget_vertex>\n\t#include <project_vertex>\n\t#include <logdepthbuf_vertex>\n\t#include <clipping_planes_vertex>\n\t#include <fog_vertex>\n}";
const $d5b33d7c30034067$var$fragment$b = "uniform vec3 diffuse;\nuniform float opacity;\nuniform float dashSize;\nuniform float totalSize;\nvarying float vLineDistance;\n#include <common>\n#include <color_pars_fragment>\n#include <uv_pars_fragment>\n#include <map_pars_fragment>\n#include <fog_pars_fragment>\n#include <logdepthbuf_pars_fragment>\n#include <clipping_planes_pars_fragment>\nvoid main() {\n\tvec4 diffuseColor = vec4( diffuse, opacity );\n\t#include <clipping_planes_fragment>\n\tif ( mod( vLineDistance, totalSize ) > dashSize ) {\n\t\tdiscard;\n\t}\n\tvec3 outgoingLight = vec3( 0.0 );\n\t#include <logdepthbuf_fragment>\n\t#include <map_fragment>\n\t#include <color_fragment>\n\toutgoingLight = diffuseColor.rgb;\n\t#include <opaque_fragment>\n\t#include <tonemapping_fragment>\n\t#include <colorspace_fragment>\n\t#include <fog_fragment>\n\t#include <premultiplied_alpha_fragment>\n}";
const $d5b33d7c30034067$var$vertex$a = "#include <common>\n#include <batching_pars_vertex>\n#include <uv_pars_vertex>\n#include <envmap_pars_vertex>\n#include <color_pars_vertex>\n#include <fog_pars_vertex>\n#include <morphtarget_pars_vertex>\n#include <skinning_pars_vertex>\n#include <logdepthbuf_pars_vertex>\n#include <clipping_planes_pars_vertex>\nvoid main() {\n\t#include <uv_vertex>\n\t#include <color_vertex>\n\t#include <morphinstance_vertex>\n\t#include <morphcolor_vertex>\n\t#include <batching_vertex>\n\t#if defined ( USE_ENVMAP ) || defined ( USE_SKINNING )\n\t\t#include <beginnormal_vertex>\n\t\t#include <morphnormal_vertex>\n\t\t#include <skinbase_vertex>\n\t\t#include <skinnormal_vertex>\n\t\t#include <defaultnormal_vertex>\n\t#endif\n\t#include <begin_vertex>\n\t#include <morphtarget_vertex>\n\t#include <skinning_vertex>\n\t#include <project_vertex>\n\t#include <logdepthbuf_vertex>\n\t#include <clipping_planes_vertex>\n\t#include <worldpos_vertex>\n\t#include <envmap_vertex>\n\t#include <fog_vertex>\n}";
const $d5b33d7c30034067$var$fragment$a = "uniform vec3 diffuse;\nuniform float opacity;\n#ifndef FLAT_SHADED\n\tvarying vec3 vNormal;\n#endif\n#include <common>\n#include <dithering_pars_fragment>\n#include <color_pars_fragment>\n#include <uv_pars_fragment>\n#include <map_pars_fragment>\n#include <alphamap_pars_fragment>\n#include <alphatest_pars_fragment>\n#include <alphahash_pars_fragment>\n#include <aomap_pars_fragment>\n#include <lightmap_pars_fragment>\n#include <envmap_common_pars_fragment>\n#include <envmap_pars_fragment>\n#include <fog_pars_fragment>\n#include <specularmap_pars_fragment>\n#include <logdepthbuf_pars_fragment>\n#include <clipping_planes_pars_fragment>\nvoid main() {\n\tvec4 diffuseColor = vec4( diffuse, opacity );\n\t#include <clipping_planes_fragment>\n\t#include <logdepthbuf_fragment>\n\t#include <map_fragment>\n\t#include <color_fragment>\n\t#include <alphamap_fragment>\n\t#include <alphatest_fragment>\n\t#include <alphahash_fragment>\n\t#include <specularmap_fragment>\n\tReflectedLight reflectedLight = ReflectedLight( vec3( 0.0 ), vec3( 0.0 ), vec3( 0.0 ), vec3( 0.0 ) );\n\t#ifdef USE_LIGHTMAP\n\t\tvec4 lightMapTexel = texture2D( lightMap, vLightMapUv );\n\t\treflectedLight.indirectDiffuse += lightMapTexel.rgb * lightMapIntensity * RECIPROCAL_PI;\n\t#else\n\t\treflectedLight.indirectDiffuse += vec3( 1.0 );\n\t#endif\n\t#include <aomap_fragment>\n\treflectedLight.indirectDiffuse *= diffuseColor.rgb;\n\tvec3 outgoingLight = reflectedLight.indirectDiffuse;\n\t#include <envmap_fragment>\n\t#include <opaque_fragment>\n\t#include <tonemapping_fragment>\n\t#include <colorspace_fragment>\n\t#include <fog_fragment>\n\t#include <premultiplied_alpha_fragment>\n\t#include <dithering_fragment>\n}";
const $d5b33d7c30034067$var$vertex$9 = "#define LAMBERT\nvarying vec3 vViewPosition;\n#include <common>\n#include <batching_pars_vertex>\n#include <uv_pars_vertex>\n#include <displacementmap_pars_vertex>\n#include <envmap_pars_vertex>\n#include <color_pars_vertex>\n#include <fog_pars_vertex>\n#include <normal_pars_vertex>\n#include <morphtarget_pars_vertex>\n#include <skinning_pars_vertex>\n#include <shadowmap_pars_vertex>\n#include <logdepthbuf_pars_vertex>\n#include <clipping_planes_pars_vertex>\nvoid main() {\n\t#include <uv_vertex>\n\t#include <color_vertex>\n\t#include <morphinstance_vertex>\n\t#include <morphcolor_vertex>\n\t#include <batching_vertex>\n\t#include <beginnormal_vertex>\n\t#include <morphnormal_vertex>\n\t#include <skinbase_vertex>\n\t#include <skinnormal_vertex>\n\t#include <defaultnormal_vertex>\n\t#include <normal_vertex>\n\t#include <begin_vertex>\n\t#include <morphtarget_vertex>\n\t#include <skinning_vertex>\n\t#include <displacementmap_vertex>\n\t#include <project_vertex>\n\t#include <logdepthbuf_vertex>\n\t#include <clipping_planes_vertex>\n\tvViewPosition = - mvPosition.xyz;\n\t#include <worldpos_vertex>\n\t#include <envmap_vertex>\n\t#include <shadowmap_vertex>\n\t#include <fog_vertex>\n}";
const $d5b33d7c30034067$var$fragment$9 = "#define LAMBERT\nuniform vec3 diffuse;\nuniform vec3 emissive;\nuniform float opacity;\n#include <common>\n#include <packing>\n#include <dithering_pars_fragment>\n#include <color_pars_fragment>\n#include <uv_pars_fragment>\n#include <map_pars_fragment>\n#include <alphamap_pars_fragment>\n#include <alphatest_pars_fragment>\n#include <alphahash_pars_fragment>\n#include <aomap_pars_fragment>\n#include <lightmap_pars_fragment>\n#include <emissivemap_pars_fragment>\n#include <envmap_common_pars_fragment>\n#include <envmap_pars_fragment>\n#include <fog_pars_fragment>\n#include <bsdfs>\n#include <lights_pars_begin>\n#include <normal_pars_fragment>\n#include <lights_lambert_pars_fragment>\n#include <shadowmap_pars_fragment>\n#include <bumpmap_pars_fragment>\n#include <normalmap_pars_fragment>\n#include <specularmap_pars_fragment>\n#include <logdepthbuf_pars_fragment>\n#include <clipping_planes_pars_fragment>\nvoid main() {\n\tvec4 diffuseColor = vec4( diffuse, opacity );\n\t#include <clipping_planes_fragment>\n\tReflectedLight reflectedLight = ReflectedLight( vec3( 0.0 ), vec3( 0.0 ), vec3( 0.0 ), vec3( 0.0 ) );\n\tvec3 totalEmissiveRadiance = emissive;\n\t#include <logdepthbuf_fragment>\n\t#include <map_fragment>\n\t#include <color_fragment>\n\t#include <alphamap_fragment>\n\t#include <alphatest_fragment>\n\t#include <alphahash_fragment>\n\t#include <specularmap_fragment>\n\t#include <normal_fragment_begin>\n\t#include <normal_fragment_maps>\n\t#include <emissivemap_fragment>\n\t#include <lights_lambert_fragment>\n\t#include <lights_fragment_begin>\n\t#include <lights_fragment_maps>\n\t#include <lights_fragment_end>\n\t#include <aomap_fragment>\n\tvec3 outgoingLight = reflectedLight.directDiffuse + reflectedLight.indirectDiffuse + totalEmissiveRadiance;\n\t#include <envmap_fragment>\n\t#include <opaque_fragment>\n\t#include <tonemapping_fragment>\n\t#include <colorspace_fragment>\n\t#include <fog_fragment>\n\t#include <premultiplied_alpha_fragment>\n\t#include <dithering_fragment>\n}";
const $d5b33d7c30034067$var$vertex$8 = "#define MATCAP\nvarying vec3 vViewPosition;\n#include <common>\n#include <batching_pars_vertex>\n#include <uv_pars_vertex>\n#include <color_pars_vertex>\n#include <displacementmap_pars_vertex>\n#include <fog_pars_vertex>\n#include <normal_pars_vertex>\n#include <morphtarget_pars_vertex>\n#include <skinning_pars_vertex>\n#include <logdepthbuf_pars_vertex>\n#include <clipping_planes_pars_vertex>\nvoid main() {\n\t#include <uv_vertex>\n\t#include <color_vertex>\n\t#include <morphinstance_vertex>\n\t#include <morphcolor_vertex>\n\t#include <batching_vertex>\n\t#include <beginnormal_vertex>\n\t#include <morphnormal_vertex>\n\t#include <skinbase_vertex>\n\t#include <skinnormal_vertex>\n\t#include <defaultnormal_vertex>\n\t#include <normal_vertex>\n\t#include <begin_vertex>\n\t#include <morphtarget_vertex>\n\t#include <skinning_vertex>\n\t#include <displacementmap_vertex>\n\t#include <project_vertex>\n\t#include <logdepthbuf_vertex>\n\t#include <clipping_planes_vertex>\n\t#include <fog_vertex>\n\tvViewPosition = - mvPosition.xyz;\n}";
const $d5b33d7c30034067$var$fragment$8 = "#define MATCAP\nuniform vec3 diffuse;\nuniform float opacity;\nuniform sampler2D matcap;\nvarying vec3 vViewPosition;\n#include <common>\n#include <dithering_pars_fragment>\n#include <color_pars_fragment>\n#include <uv_pars_fragment>\n#include <map_pars_fragment>\n#include <alphamap_pars_fragment>\n#include <alphatest_pars_fragment>\n#include <alphahash_pars_fragment>\n#include <fog_pars_fragment>\n#include <normal_pars_fragment>\n#include <bumpmap_pars_fragment>\n#include <normalmap_pars_fragment>\n#include <logdepthbuf_pars_fragment>\n#include <clipping_planes_pars_fragment>\nvoid main() {\n\tvec4 diffuseColor = vec4( diffuse, opacity );\n\t#include <clipping_planes_fragment>\n\t#include <logdepthbuf_fragment>\n\t#include <map_fragment>\n\t#include <color_fragment>\n\t#include <alphamap_fragment>\n\t#include <alphatest_fragment>\n\t#include <alphahash_fragment>\n\t#include <normal_fragment_begin>\n\t#include <normal_fragment_maps>\n\tvec3 viewDir = normalize( vViewPosition );\n\tvec3 x = normalize( vec3( viewDir.z, 0.0, - viewDir.x ) );\n\tvec3 y = cross( viewDir, x );\n\tvec2 uv = vec2( dot( x, normal ), dot( y, normal ) ) * 0.495 + 0.5;\n\t#ifdef USE_MATCAP\n\t\tvec4 matcapColor = texture2D( matcap, uv );\n\t#else\n\t\tvec4 matcapColor = vec4( vec3( mix( 0.2, 0.8, uv.y ) ), 1.0 );\n\t#endif\n\tvec3 outgoingLight = diffuseColor.rgb * matcapColor.rgb;\n\t#include <opaque_fragment>\n\t#include <tonemapping_fragment>\n\t#include <colorspace_fragment>\n\t#include <fog_fragment>\n\t#include <premultiplied_alpha_fragment>\n\t#include <dithering_fragment>\n}";
const $d5b33d7c30034067$var$vertex$7 = "#define NORMAL\n#if defined( FLAT_SHADED ) || defined( USE_BUMPMAP ) || defined( USE_NORMALMAP_TANGENTSPACE )\n\tvarying vec3 vViewPosition;\n#endif\n#include <common>\n#include <batching_pars_vertex>\n#include <uv_pars_vertex>\n#include <displacementmap_pars_vertex>\n#include <normal_pars_vertex>\n#include <morphtarget_pars_vertex>\n#include <skinning_pars_vertex>\n#include <logdepthbuf_pars_vertex>\n#include <clipping_planes_pars_vertex>\nvoid main() {\n\t#include <uv_vertex>\n\t#include <batching_vertex>\n\t#include <beginnormal_vertex>\n\t#include <morphinstance_vertex>\n\t#include <morphnormal_vertex>\n\t#include <skinbase_vertex>\n\t#include <skinnormal_vertex>\n\t#include <defaultnormal_vertex>\n\t#include <normal_vertex>\n\t#include <begin_vertex>\n\t#include <morphtarget_vertex>\n\t#include <skinning_vertex>\n\t#include <displacementmap_vertex>\n\t#include <project_vertex>\n\t#include <logdepthbuf_vertex>\n\t#include <clipping_planes_vertex>\n#if defined( FLAT_SHADED ) || defined( USE_BUMPMAP ) || defined( USE_NORMALMAP_TANGENTSPACE )\n\tvViewPosition = - mvPosition.xyz;\n#endif\n}";
const $d5b33d7c30034067$var$fragment$7 = "#define NORMAL\nuniform float opacity;\n#if defined( FLAT_SHADED ) || defined( USE_BUMPMAP ) || defined( USE_NORMALMAP_TANGENTSPACE )\n\tvarying vec3 vViewPosition;\n#endif\n#include <packing>\n#include <uv_pars_fragment>\n#include <normal_pars_fragment>\n#include <bumpmap_pars_fragment>\n#include <normalmap_pars_fragment>\n#include <logdepthbuf_pars_fragment>\n#include <clipping_planes_pars_fragment>\nvoid main() {\n\tvec4 diffuseColor = vec4( 0.0, 0.0, 0.0, opacity );\n\t#include <clipping_planes_fragment>\n\t#include <logdepthbuf_fragment>\n\t#include <normal_fragment_begin>\n\t#include <normal_fragment_maps>\n\tgl_FragColor = vec4( packNormalToRGB( normal ), diffuseColor.a );\n\t#ifdef OPAQUE\n\t\tgl_FragColor.a = 1.0;\n\t#endif\n}";
const $d5b33d7c30034067$var$vertex$6 = "#define PHONG\nvarying vec3 vViewPosition;\n#include <common>\n#include <batching_pars_vertex>\n#include <uv_pars_vertex>\n#include <displacementmap_pars_vertex>\n#include <envmap_pars_vertex>\n#include <color_pars_vertex>\n#include <fog_pars_vertex>\n#include <normal_pars_vertex>\n#include <morphtarget_pars_vertex>\n#include <skinning_pars_vertex>\n#include <shadowmap_pars_vertex>\n#include <logdepthbuf_pars_vertex>\n#include <clipping_planes_pars_vertex>\nvoid main() {\n\t#include <uv_vertex>\n\t#include <color_vertex>\n\t#include <morphcolor_vertex>\n\t#include <batching_vertex>\n\t#include <beginnormal_vertex>\n\t#include <morphinstance_vertex>\n\t#include <morphnormal_vertex>\n\t#include <skinbase_vertex>\n\t#include <skinnormal_vertex>\n\t#include <defaultnormal_vertex>\n\t#include <normal_vertex>\n\t#include <begin_vertex>\n\t#include <morphtarget_vertex>\n\t#include <skinning_vertex>\n\t#include <displacementmap_vertex>\n\t#include <project_vertex>\n\t#include <logdepthbuf_vertex>\n\t#include <clipping_planes_vertex>\n\tvViewPosition = - mvPosition.xyz;\n\t#include <worldpos_vertex>\n\t#include <envmap_vertex>\n\t#include <shadowmap_vertex>\n\t#include <fog_vertex>\n}";
const $d5b33d7c30034067$var$fragment$6 = "#define PHONG\nuniform vec3 diffuse;\nuniform vec3 emissive;\nuniform vec3 specular;\nuniform float shininess;\nuniform float opacity;\n#include <common>\n#include <packing>\n#include <dithering_pars_fragment>\n#include <color_pars_fragment>\n#include <uv_pars_fragment>\n#include <map_pars_fragment>\n#include <alphamap_pars_fragment>\n#include <alphatest_pars_fragment>\n#include <alphahash_pars_fragment>\n#include <aomap_pars_fragment>\n#include <lightmap_pars_fragment>\n#include <emissivemap_pars_fragment>\n#include <envmap_common_pars_fragment>\n#include <envmap_pars_fragment>\n#include <fog_pars_fragment>\n#include <bsdfs>\n#include <lights_pars_begin>\n#include <normal_pars_fragment>\n#include <lights_phong_pars_fragment>\n#include <shadowmap_pars_fragment>\n#include <bumpmap_pars_fragment>\n#include <normalmap_pars_fragment>\n#include <specularmap_pars_fragment>\n#include <logdepthbuf_pars_fragment>\n#include <clipping_planes_pars_fragment>\nvoid main() {\n\tvec4 diffuseColor = vec4( diffuse, opacity );\n\t#include <clipping_planes_fragment>\n\tReflectedLight reflectedLight = ReflectedLight( vec3( 0.0 ), vec3( 0.0 ), vec3( 0.0 ), vec3( 0.0 ) );\n\tvec3 totalEmissiveRadiance = emissive;\n\t#include <logdepthbuf_fragment>\n\t#include <map_fragment>\n\t#include <color_fragment>\n\t#include <alphamap_fragment>\n\t#include <alphatest_fragment>\n\t#include <alphahash_fragment>\n\t#include <specularmap_fragment>\n\t#include <normal_fragment_begin>\n\t#include <normal_fragment_maps>\n\t#include <emissivemap_fragment>\n\t#include <lights_phong_fragment>\n\t#include <lights_fragment_begin>\n\t#include <lights_fragment_maps>\n\t#include <lights_fragment_end>\n\t#include <aomap_fragment>\n\tvec3 outgoingLight = reflectedLight.directDiffuse + reflectedLight.indirectDiffuse + reflectedLight.directSpecular + reflectedLight.indirectSpecular + totalEmissiveRadiance;\n\t#include <envmap_fragment>\n\t#include <opaque_fragment>\n\t#include <tonemapping_fragment>\n\t#include <colorspace_fragment>\n\t#include <fog_fragment>\n\t#include <premultiplied_alpha_fragment>\n\t#include <dithering_fragment>\n}";
const $d5b33d7c30034067$var$vertex$5 = "#define STANDARD\nvarying vec3 vViewPosition;\n#ifdef USE_TRANSMISSION\n\tvarying vec3 vWorldPosition;\n#endif\n#include <common>\n#include <batching_pars_vertex>\n#include <uv_pars_vertex>\n#include <displacementmap_pars_vertex>\n#include <color_pars_vertex>\n#include <fog_pars_vertex>\n#include <normal_pars_vertex>\n#include <morphtarget_pars_vertex>\n#include <skinning_pars_vertex>\n#include <shadowmap_pars_vertex>\n#include <logdepthbuf_pars_vertex>\n#include <clipping_planes_pars_vertex>\nvoid main() {\n\t#include <uv_vertex>\n\t#include <color_vertex>\n\t#include <morphinstance_vertex>\n\t#include <morphcolor_vertex>\n\t#include <batching_vertex>\n\t#include <beginnormal_vertex>\n\t#include <morphnormal_vertex>\n\t#include <skinbase_vertex>\n\t#include <skinnormal_vertex>\n\t#include <defaultnormal_vertex>\n\t#include <normal_vertex>\n\t#include <begin_vertex>\n\t#include <morphtarget_vertex>\n\t#include <skinning_vertex>\n\t#include <displacementmap_vertex>\n\t#include <project_vertex>\n\t#include <logdepthbuf_vertex>\n\t#include <clipping_planes_vertex>\n\tvViewPosition = - mvPosition.xyz;\n\t#include <worldpos_vertex>\n\t#include <shadowmap_vertex>\n\t#include <fog_vertex>\n#ifdef USE_TRANSMISSION\n\tvWorldPosition = worldPosition.xyz;\n#endif\n}";
const $d5b33d7c30034067$var$fragment$5 = "#define STANDARD\n#ifdef PHYSICAL\n\t#define IOR\n\t#define USE_SPECULAR\n#endif\nuniform vec3 diffuse;\nuniform vec3 emissive;\nuniform float roughness;\nuniform float metalness;\nuniform float opacity;\n#ifdef IOR\n\tuniform float ior;\n#endif\n#ifdef USE_SPECULAR\n\tuniform float specularIntensity;\n\tuniform vec3 specularColor;\n\t#ifdef USE_SPECULAR_COLORMAP\n\t\tuniform sampler2D specularColorMap;\n\t#endif\n\t#ifdef USE_SPECULAR_INTENSITYMAP\n\t\tuniform sampler2D specularIntensityMap;\n\t#endif\n#endif\n#ifdef USE_CLEARCOAT\n\tuniform float clearcoat;\n\tuniform float clearcoatRoughness;\n#endif\n#ifdef USE_DISPERSION\n\tuniform float dispersion;\n#endif\n#ifdef USE_IRIDESCENCE\n\tuniform float iridescence;\n\tuniform float iridescenceIOR;\n\tuniform float iridescenceThicknessMinimum;\n\tuniform float iridescenceThicknessMaximum;\n#endif\n#ifdef USE_SHEEN\n\tuniform vec3 sheenColor;\n\tuniform float sheenRoughness;\n\t#ifdef USE_SHEEN_COLORMAP\n\t\tuniform sampler2D sheenColorMap;\n\t#endif\n\t#ifdef USE_SHEEN_ROUGHNESSMAP\n\t\tuniform sampler2D sheenRoughnessMap;\n\t#endif\n#endif\n#ifdef USE_ANISOTROPY\n\tuniform vec2 anisotropyVector;\n\t#ifdef USE_ANISOTROPYMAP\n\t\tuniform sampler2D anisotropyMap;\n\t#endif\n#endif\nvarying vec3 vViewPosition;\n#include <common>\n#include <packing>\n#include <dithering_pars_fragment>\n#include <color_pars_fragment>\n#include <uv_pars_fragment>\n#include <map_pars_fragment>\n#include <alphamap_pars_fragment>\n#include <alphatest_pars_fragment>\n#include <alphahash_pars_fragment>\n#include <aomap_pars_fragment>\n#include <lightmap_pars_fragment>\n#include <emissivemap_pars_fragment>\n#include <iridescence_fragment>\n#include <cube_uv_reflection_fragment>\n#include <envmap_common_pars_fragment>\n#include <envmap_physical_pars_fragment>\n#include <fog_pars_fragment>\n#include <lights_pars_begin>\n#include <normal_pars_fragment>\n#include <lights_physical_pars_fragment>\n#include <transmission_pars_fragment>\n#include <shadowmap_pars_fragment>\n#include <bumpmap_pars_fragment>\n#include <normalmap_pars_fragment>\n#include <clearcoat_pars_fragment>\n#include <iridescence_pars_fragment>\n#include <roughnessmap_pars_fragment>\n#include <metalnessmap_pars_fragment>\n#include <logdepthbuf_pars_fragment>\n#include <clipping_planes_pars_fragment>\nvoid main() {\n\tvec4 diffuseColor = vec4( diffuse, opacity );\n\t#include <clipping_planes_fragment>\n\tReflectedLight reflectedLight = ReflectedLight( vec3( 0.0 ), vec3( 0.0 ), vec3( 0.0 ), vec3( 0.0 ) );\n\tvec3 totalEmissiveRadiance = emissive;\n\t#include <logdepthbuf_fragment>\n\t#include <map_fragment>\n\t#include <color_fragment>\n\t#include <alphamap_fragment>\n\t#include <alphatest_fragment>\n\t#include <alphahash_fragment>\n\t#include <roughnessmap_fragment>\n\t#include <metalnessmap_fragment>\n\t#include <normal_fragment_begin>\n\t#include <normal_fragment_maps>\n\t#include <clearcoat_normal_fragment_begin>\n\t#include <clearcoat_normal_fragment_maps>\n\t#include <emissivemap_fragment>\n\t#include <lights_physical_fragment>\n\t#include <lights_fragment_begin>\n\t#include <lights_fragment_maps>\n\t#include <lights_fragment_end>\n\t#include <aomap_fragment>\n\tvec3 totalDiffuse = reflectedLight.directDiffuse + reflectedLight.indirectDiffuse;\n\tvec3 totalSpecular = reflectedLight.directSpecular + reflectedLight.indirectSpecular;\n\t#include <transmission_fragment>\n\tvec3 outgoingLight = totalDiffuse + totalSpecular + totalEmissiveRadiance;\n\t#ifdef USE_SHEEN\n\t\tfloat sheenEnergyComp = 1.0 - 0.157 * max3( material.sheenColor );\n\t\toutgoingLight = outgoingLight * sheenEnergyComp + sheenSpecularDirect + sheenSpecularIndirect;\n\t#endif\n\t#ifdef USE_CLEARCOAT\n\t\tfloat dotNVcc = saturate( dot( geometryClearcoatNormal, geometryViewDir ) );\n\t\tvec3 Fcc = F_Schlick( material.clearcoatF0, material.clearcoatF90, dotNVcc );\n\t\toutgoingLight = outgoingLight * ( 1.0 - material.clearcoat * Fcc ) + ( clearcoatSpecularDirect + clearcoatSpecularIndirect ) * material.clearcoat;\n\t#endif\n\t#include <opaque_fragment>\n\t#include <tonemapping_fragment>\n\t#include <colorspace_fragment>\n\t#include <fog_fragment>\n\t#include <premultiplied_alpha_fragment>\n\t#include <dithering_fragment>\n}";
const $d5b33d7c30034067$var$vertex$4 = "#define TOON\nvarying vec3 vViewPosition;\n#include <common>\n#include <batching_pars_vertex>\n#include <uv_pars_vertex>\n#include <displacementmap_pars_vertex>\n#include <color_pars_vertex>\n#include <fog_pars_vertex>\n#include <normal_pars_vertex>\n#include <morphtarget_pars_vertex>\n#include <skinning_pars_vertex>\n#include <shadowmap_pars_vertex>\n#include <logdepthbuf_pars_vertex>\n#include <clipping_planes_pars_vertex>\nvoid main() {\n\t#include <uv_vertex>\n\t#include <color_vertex>\n\t#include <morphinstance_vertex>\n\t#include <morphcolor_vertex>\n\t#include <batching_vertex>\n\t#include <beginnormal_vertex>\n\t#include <morphnormal_vertex>\n\t#include <skinbase_vertex>\n\t#include <skinnormal_vertex>\n\t#include <defaultnormal_vertex>\n\t#include <normal_vertex>\n\t#include <begin_vertex>\n\t#include <morphtarget_vertex>\n\t#include <skinning_vertex>\n\t#include <displacementmap_vertex>\n\t#include <project_vertex>\n\t#include <logdepthbuf_vertex>\n\t#include <clipping_planes_vertex>\n\tvViewPosition = - mvPosition.xyz;\n\t#include <worldpos_vertex>\n\t#include <shadowmap_vertex>\n\t#include <fog_vertex>\n}";
const $d5b33d7c30034067$var$fragment$4 = "#define TOON\nuniform vec3 diffuse;\nuniform vec3 emissive;\nuniform float opacity;\n#include <common>\n#include <packing>\n#include <dithering_pars_fragment>\n#include <color_pars_fragment>\n#include <uv_pars_fragment>\n#include <map_pars_fragment>\n#include <alphamap_pars_fragment>\n#include <alphatest_pars_fragment>\n#include <alphahash_pars_fragment>\n#include <aomap_pars_fragment>\n#include <lightmap_pars_fragment>\n#include <emissivemap_pars_fragment>\n#include <gradientmap_pars_fragment>\n#include <fog_pars_fragment>\n#include <bsdfs>\n#include <lights_pars_begin>\n#include <normal_pars_fragment>\n#include <lights_toon_pars_fragment>\n#include <shadowmap_pars_fragment>\n#include <bumpmap_pars_fragment>\n#include <normalmap_pars_fragment>\n#include <logdepthbuf_pars_fragment>\n#include <clipping_planes_pars_fragment>\nvoid main() {\n\tvec4 diffuseColor = vec4( diffuse, opacity );\n\t#include <clipping_planes_fragment>\n\tReflectedLight reflectedLight = ReflectedLight( vec3( 0.0 ), vec3( 0.0 ), vec3( 0.0 ), vec3( 0.0 ) );\n\tvec3 totalEmissiveRadiance = emissive;\n\t#include <logdepthbuf_fragment>\n\t#include <map_fragment>\n\t#include <color_fragment>\n\t#include <alphamap_fragment>\n\t#include <alphatest_fragment>\n\t#include <alphahash_fragment>\n\t#include <normal_fragment_begin>\n\t#include <normal_fragment_maps>\n\t#include <emissivemap_fragment>\n\t#include <lights_toon_fragment>\n\t#include <lights_fragment_begin>\n\t#include <lights_fragment_maps>\n\t#include <lights_fragment_end>\n\t#include <aomap_fragment>\n\tvec3 outgoingLight = reflectedLight.directDiffuse + reflectedLight.indirectDiffuse + totalEmissiveRadiance;\n\t#include <opaque_fragment>\n\t#include <tonemapping_fragment>\n\t#include <colorspace_fragment>\n\t#include <fog_fragment>\n\t#include <premultiplied_alpha_fragment>\n\t#include <dithering_fragment>\n}";
const $d5b33d7c30034067$var$vertex$3 = "uniform float size;\nuniform float scale;\n#include <common>\n#include <color_pars_vertex>\n#include <fog_pars_vertex>\n#include <morphtarget_pars_vertex>\n#include <logdepthbuf_pars_vertex>\n#include <clipping_planes_pars_vertex>\n#ifdef USE_POINTS_UV\n\tvarying vec2 vUv;\n\tuniform mat3 uvTransform;\n#endif\nvoid main() {\n\t#ifdef USE_POINTS_UV\n\t\tvUv = ( uvTransform * vec3( uv, 1 ) ).xy;\n\t#endif\n\t#include <color_vertex>\n\t#include <morphinstance_vertex>\n\t#include <morphcolor_vertex>\n\t#include <begin_vertex>\n\t#include <morphtarget_vertex>\n\t#include <project_vertex>\n\tgl_PointSize = size;\n\t#ifdef USE_SIZEATTENUATION\n\t\tbool isPerspective = isPerspectiveMatrix( projectionMatrix );\n\t\tif ( isPerspective ) gl_PointSize *= ( scale / - mvPosition.z );\n\t#endif\n\t#include <logdepthbuf_vertex>\n\t#include <clipping_planes_vertex>\n\t#include <worldpos_vertex>\n\t#include <fog_vertex>\n}";
const $d5b33d7c30034067$var$fragment$3 = "uniform vec3 diffuse;\nuniform float opacity;\n#include <common>\n#include <color_pars_fragment>\n#include <map_particle_pars_fragment>\n#include <alphatest_pars_fragment>\n#include <alphahash_pars_fragment>\n#include <fog_pars_fragment>\n#include <logdepthbuf_pars_fragment>\n#include <clipping_planes_pars_fragment>\nvoid main() {\n\tvec4 diffuseColor = vec4( diffuse, opacity );\n\t#include <clipping_planes_fragment>\n\tvec3 outgoingLight = vec3( 0.0 );\n\t#include <logdepthbuf_fragment>\n\t#include <map_particle_fragment>\n\t#include <color_fragment>\n\t#include <alphatest_fragment>\n\t#include <alphahash_fragment>\n\toutgoingLight = diffuseColor.rgb;\n\t#include <opaque_fragment>\n\t#include <tonemapping_fragment>\n\t#include <colorspace_fragment>\n\t#include <fog_fragment>\n\t#include <premultiplied_alpha_fragment>\n}";
const $d5b33d7c30034067$var$vertex$2 = "#include <common>\n#include <batching_pars_vertex>\n#include <fog_pars_vertex>\n#include <morphtarget_pars_vertex>\n#include <skinning_pars_vertex>\n#include <logdepthbuf_pars_vertex>\n#include <shadowmap_pars_vertex>\nvoid main() {\n\t#include <batching_vertex>\n\t#include <beginnormal_vertex>\n\t#include <morphinstance_vertex>\n\t#include <morphnormal_vertex>\n\t#include <skinbase_vertex>\n\t#include <skinnormal_vertex>\n\t#include <defaultnormal_vertex>\n\t#include <begin_vertex>\n\t#include <morphtarget_vertex>\n\t#include <skinning_vertex>\n\t#include <project_vertex>\n\t#include <logdepthbuf_vertex>\n\t#include <worldpos_vertex>\n\t#include <shadowmap_vertex>\n\t#include <fog_vertex>\n}";
const $d5b33d7c30034067$var$fragment$2 = "uniform vec3 color;\nuniform float opacity;\n#include <common>\n#include <packing>\n#include <fog_pars_fragment>\n#include <bsdfs>\n#include <lights_pars_begin>\n#include <logdepthbuf_pars_fragment>\n#include <shadowmap_pars_fragment>\n#include <shadowmask_pars_fragment>\nvoid main() {\n\t#include <logdepthbuf_fragment>\n\tgl_FragColor = vec4( color, opacity * ( 1.0 - getShadowMask() ) );\n\t#include <tonemapping_fragment>\n\t#include <colorspace_fragment>\n\t#include <fog_fragment>\n}";
const $d5b33d7c30034067$var$vertex$1 = "uniform float rotation;\nuniform vec2 center;\n#include <common>\n#include <uv_pars_vertex>\n#include <fog_pars_vertex>\n#include <logdepthbuf_pars_vertex>\n#include <clipping_planes_pars_vertex>\nvoid main() {\n\t#include <uv_vertex>\n\tvec4 mvPosition = modelViewMatrix[ 3 ];\n\tvec2 scale = vec2( length( modelMatrix[ 0 ].xyz ), length( modelMatrix[ 1 ].xyz ) );\n\t#ifndef USE_SIZEATTENUATION\n\t\tbool isPerspective = isPerspectiveMatrix( projectionMatrix );\n\t\tif ( isPerspective ) scale *= - mvPosition.z;\n\t#endif\n\tvec2 alignedPosition = ( position.xy - ( center - vec2( 0.5 ) ) ) * scale;\n\tvec2 rotatedPosition;\n\trotatedPosition.x = cos( rotation ) * alignedPosition.x - sin( rotation ) * alignedPosition.y;\n\trotatedPosition.y = sin( rotation ) * alignedPosition.x + cos( rotation ) * alignedPosition.y;\n\tmvPosition.xy += rotatedPosition;\n\tgl_Position = projectionMatrix * mvPosition;\n\t#include <logdepthbuf_vertex>\n\t#include <clipping_planes_vertex>\n\t#include <fog_vertex>\n}";
const $d5b33d7c30034067$var$fragment$1 = "uniform vec3 diffuse;\nuniform float opacity;\n#include <common>\n#include <uv_pars_fragment>\n#include <map_pars_fragment>\n#include <alphamap_pars_fragment>\n#include <alphatest_pars_fragment>\n#include <alphahash_pars_fragment>\n#include <fog_pars_fragment>\n#include <logdepthbuf_pars_fragment>\n#include <clipping_planes_pars_fragment>\nvoid main() {\n\tvec4 diffuseColor = vec4( diffuse, opacity );\n\t#include <clipping_planes_fragment>\n\tvec3 outgoingLight = vec3( 0.0 );\n\t#include <logdepthbuf_fragment>\n\t#include <map_fragment>\n\t#include <alphamap_fragment>\n\t#include <alphatest_fragment>\n\t#include <alphahash_fragment>\n\toutgoingLight = diffuseColor.rgb;\n\t#include <opaque_fragment>\n\t#include <tonemapping_fragment>\n\t#include <colorspace_fragment>\n\t#include <fog_fragment>\n}";
const $d5b33d7c30034067$export$955f9f2e84c43c8b = {
    alphahash_fragment: $d5b33d7c30034067$var$alphahash_fragment,
    alphahash_pars_fragment: $d5b33d7c30034067$var$alphahash_pars_fragment,
    alphamap_fragment: $d5b33d7c30034067$var$alphamap_fragment,
    alphamap_pars_fragment: $d5b33d7c30034067$var$alphamap_pars_fragment,
    alphatest_fragment: $d5b33d7c30034067$var$alphatest_fragment,
    alphatest_pars_fragment: $d5b33d7c30034067$var$alphatest_pars_fragment,
    aomap_fragment: $d5b33d7c30034067$var$aomap_fragment,
    aomap_pars_fragment: $d5b33d7c30034067$var$aomap_pars_fragment,
    batching_pars_vertex: $d5b33d7c30034067$var$batching_pars_vertex,
    batching_vertex: $d5b33d7c30034067$var$batching_vertex,
    begin_vertex: $d5b33d7c30034067$var$begin_vertex,
    beginnormal_vertex: $d5b33d7c30034067$var$beginnormal_vertex,
    bsdfs: $d5b33d7c30034067$var$bsdfs,
    iridescence_fragment: $d5b33d7c30034067$var$iridescence_fragment,
    bumpmap_pars_fragment: $d5b33d7c30034067$var$bumpmap_pars_fragment,
    clipping_planes_fragment: $d5b33d7c30034067$var$clipping_planes_fragment,
    clipping_planes_pars_fragment: $d5b33d7c30034067$var$clipping_planes_pars_fragment,
    clipping_planes_pars_vertex: $d5b33d7c30034067$var$clipping_planes_pars_vertex,
    clipping_planes_vertex: $d5b33d7c30034067$var$clipping_planes_vertex,
    color_fragment: $d5b33d7c30034067$var$color_fragment,
    color_pars_fragment: $d5b33d7c30034067$var$color_pars_fragment,
    color_pars_vertex: $d5b33d7c30034067$var$color_pars_vertex,
    color_vertex: $d5b33d7c30034067$var$color_vertex,
    common: $d5b33d7c30034067$var$common,
    cube_uv_reflection_fragment: $d5b33d7c30034067$var$cube_uv_reflection_fragment,
    defaultnormal_vertex: $d5b33d7c30034067$var$defaultnormal_vertex,
    displacementmap_pars_vertex: $d5b33d7c30034067$var$displacementmap_pars_vertex,
    displacementmap_vertex: $d5b33d7c30034067$var$displacementmap_vertex,
    emissivemap_fragment: $d5b33d7c30034067$var$emissivemap_fragment,
    emissivemap_pars_fragment: $d5b33d7c30034067$var$emissivemap_pars_fragment,
    colorspace_fragment: $d5b33d7c30034067$var$colorspace_fragment,
    colorspace_pars_fragment: $d5b33d7c30034067$var$colorspace_pars_fragment,
    envmap_fragment: $d5b33d7c30034067$var$envmap_fragment,
    envmap_common_pars_fragment: $d5b33d7c30034067$var$envmap_common_pars_fragment,
    envmap_pars_fragment: $d5b33d7c30034067$var$envmap_pars_fragment,
    envmap_pars_vertex: $d5b33d7c30034067$var$envmap_pars_vertex,
    envmap_physical_pars_fragment: $d5b33d7c30034067$var$envmap_physical_pars_fragment,
    envmap_vertex: $d5b33d7c30034067$var$envmap_vertex,
    fog_vertex: $d5b33d7c30034067$var$fog_vertex,
    fog_pars_vertex: $d5b33d7c30034067$var$fog_pars_vertex,
    fog_fragment: $d5b33d7c30034067$var$fog_fragment,
    fog_pars_fragment: $d5b33d7c30034067$var$fog_pars_fragment,
    gradientmap_pars_fragment: $d5b33d7c30034067$var$gradientmap_pars_fragment,
    lightmap_pars_fragment: $d5b33d7c30034067$var$lightmap_pars_fragment,
    lights_lambert_fragment: $d5b33d7c30034067$var$lights_lambert_fragment,
    lights_lambert_pars_fragment: $d5b33d7c30034067$var$lights_lambert_pars_fragment,
    lights_pars_begin: $d5b33d7c30034067$var$lights_pars_begin,
    lights_toon_fragment: $d5b33d7c30034067$var$lights_toon_fragment,
    lights_toon_pars_fragment: $d5b33d7c30034067$var$lights_toon_pars_fragment,
    lights_phong_fragment: $d5b33d7c30034067$var$lights_phong_fragment,
    lights_phong_pars_fragment: $d5b33d7c30034067$var$lights_phong_pars_fragment,
    lights_physical_fragment: $d5b33d7c30034067$var$lights_physical_fragment,
    lights_physical_pars_fragment: $d5b33d7c30034067$var$lights_physical_pars_fragment,
    lights_fragment_begin: $d5b33d7c30034067$var$lights_fragment_begin,
    lights_fragment_maps: $d5b33d7c30034067$var$lights_fragment_maps,
    lights_fragment_end: $d5b33d7c30034067$var$lights_fragment_end,
    logdepthbuf_fragment: $d5b33d7c30034067$var$logdepthbuf_fragment,
    logdepthbuf_pars_fragment: $d5b33d7c30034067$var$logdepthbuf_pars_fragment,
    logdepthbuf_pars_vertex: $d5b33d7c30034067$var$logdepthbuf_pars_vertex,
    logdepthbuf_vertex: $d5b33d7c30034067$var$logdepthbuf_vertex,
    map_fragment: $d5b33d7c30034067$var$map_fragment,
    map_pars_fragment: $d5b33d7c30034067$var$map_pars_fragment,
    map_particle_fragment: $d5b33d7c30034067$var$map_particle_fragment,
    map_particle_pars_fragment: $d5b33d7c30034067$var$map_particle_pars_fragment,
    metalnessmap_fragment: $d5b33d7c30034067$var$metalnessmap_fragment,
    metalnessmap_pars_fragment: $d5b33d7c30034067$var$metalnessmap_pars_fragment,
    morphinstance_vertex: $d5b33d7c30034067$var$morphinstance_vertex,
    morphcolor_vertex: $d5b33d7c30034067$var$morphcolor_vertex,
    morphnormal_vertex: $d5b33d7c30034067$var$morphnormal_vertex,
    morphtarget_pars_vertex: $d5b33d7c30034067$var$morphtarget_pars_vertex,
    morphtarget_vertex: $d5b33d7c30034067$var$morphtarget_vertex,
    normal_fragment_begin: $d5b33d7c30034067$var$normal_fragment_begin,
    normal_fragment_maps: $d5b33d7c30034067$var$normal_fragment_maps,
    normal_pars_fragment: $d5b33d7c30034067$var$normal_pars_fragment,
    normal_pars_vertex: $d5b33d7c30034067$var$normal_pars_vertex,
    normal_vertex: $d5b33d7c30034067$var$normal_vertex,
    normalmap_pars_fragment: $d5b33d7c30034067$var$normalmap_pars_fragment,
    clearcoat_normal_fragment_begin: $d5b33d7c30034067$var$clearcoat_normal_fragment_begin,
    clearcoat_normal_fragment_maps: $d5b33d7c30034067$var$clearcoat_normal_fragment_maps,
    clearcoat_pars_fragment: $d5b33d7c30034067$var$clearcoat_pars_fragment,
    iridescence_pars_fragment: $d5b33d7c30034067$var$iridescence_pars_fragment,
    opaque_fragment: $d5b33d7c30034067$var$opaque_fragment,
    packing: $d5b33d7c30034067$var$packing,
    premultiplied_alpha_fragment: $d5b33d7c30034067$var$premultiplied_alpha_fragment,
    project_vertex: $d5b33d7c30034067$var$project_vertex,
    dithering_fragment: $d5b33d7c30034067$var$dithering_fragment,
    dithering_pars_fragment: $d5b33d7c30034067$var$dithering_pars_fragment,
    roughnessmap_fragment: $d5b33d7c30034067$var$roughnessmap_fragment,
    roughnessmap_pars_fragment: $d5b33d7c30034067$var$roughnessmap_pars_fragment,
    shadowmap_pars_fragment: $d5b33d7c30034067$var$shadowmap_pars_fragment,
    shadowmap_pars_vertex: $d5b33d7c30034067$var$shadowmap_pars_vertex,
    shadowmap_vertex: $d5b33d7c30034067$var$shadowmap_vertex,
    shadowmask_pars_fragment: $d5b33d7c30034067$var$shadowmask_pars_fragment,
    skinbase_vertex: $d5b33d7c30034067$var$skinbase_vertex,
    skinning_pars_vertex: $d5b33d7c30034067$var$skinning_pars_vertex,
    skinning_vertex: $d5b33d7c30034067$var$skinning_vertex,
    skinnormal_vertex: $d5b33d7c30034067$var$skinnormal_vertex,
    specularmap_fragment: $d5b33d7c30034067$var$specularmap_fragment,
    specularmap_pars_fragment: $d5b33d7c30034067$var$specularmap_pars_fragment,
    tonemapping_fragment: $d5b33d7c30034067$var$tonemapping_fragment,
    tonemapping_pars_fragment: $d5b33d7c30034067$var$tonemapping_pars_fragment,
    transmission_fragment: $d5b33d7c30034067$var$transmission_fragment,
    transmission_pars_fragment: $d5b33d7c30034067$var$transmission_pars_fragment,
    uv_pars_fragment: $d5b33d7c30034067$var$uv_pars_fragment,
    uv_pars_vertex: $d5b33d7c30034067$var$uv_pars_vertex,
    uv_vertex: $d5b33d7c30034067$var$uv_vertex,
    worldpos_vertex: $d5b33d7c30034067$var$worldpos_vertex,
    background_vert: $d5b33d7c30034067$var$vertex$h,
    background_frag: $d5b33d7c30034067$var$fragment$h,
    backgroundCube_vert: $d5b33d7c30034067$var$vertex$g,
    backgroundCube_frag: $d5b33d7c30034067$var$fragment$g,
    cube_vert: $d5b33d7c30034067$var$vertex$f,
    cube_frag: $d5b33d7c30034067$var$fragment$f,
    depth_vert: $d5b33d7c30034067$var$vertex$e,
    depth_frag: $d5b33d7c30034067$var$fragment$e,
    distanceRGBA_vert: $d5b33d7c30034067$var$vertex$d,
    distanceRGBA_frag: $d5b33d7c30034067$var$fragment$d,
    equirect_vert: $d5b33d7c30034067$var$vertex$c,
    equirect_frag: $d5b33d7c30034067$var$fragment$c,
    linedashed_vert: $d5b33d7c30034067$var$vertex$b,
    linedashed_frag: $d5b33d7c30034067$var$fragment$b,
    meshbasic_vert: $d5b33d7c30034067$var$vertex$a,
    meshbasic_frag: $d5b33d7c30034067$var$fragment$a,
    meshlambert_vert: $d5b33d7c30034067$var$vertex$9,
    meshlambert_frag: $d5b33d7c30034067$var$fragment$9,
    meshmatcap_vert: $d5b33d7c30034067$var$vertex$8,
    meshmatcap_frag: $d5b33d7c30034067$var$fragment$8,
    meshnormal_vert: $d5b33d7c30034067$var$vertex$7,
    meshnormal_frag: $d5b33d7c30034067$var$fragment$7,
    meshphong_vert: $d5b33d7c30034067$var$vertex$6,
    meshphong_frag: $d5b33d7c30034067$var$fragment$6,
    meshphysical_vert: $d5b33d7c30034067$var$vertex$5,
    meshphysical_frag: $d5b33d7c30034067$var$fragment$5,
    meshtoon_vert: $d5b33d7c30034067$var$vertex$4,
    meshtoon_frag: $d5b33d7c30034067$var$fragment$4,
    points_vert: $d5b33d7c30034067$var$vertex$3,
    points_frag: $d5b33d7c30034067$var$fragment$3,
    shadow_vert: $d5b33d7c30034067$var$vertex$2,
    shadow_frag: $d5b33d7c30034067$var$fragment$2,
    sprite_vert: $d5b33d7c30034067$var$vertex$1,
    sprite_frag: $d5b33d7c30034067$var$fragment$1
};
// Uniforms library for shared webgl shaders
const $d5b33d7c30034067$export$6643083551874bf5 = {
    common: {
        diffuse: {
            value: /*@__PURE__*/ new (0, $dyjou.Color)(0xffffff)
        },
        opacity: {
            value: 1.0
        },
        map: {
            value: null
        },
        mapTransform: {
            value: /*@__PURE__*/ new (0, $dyjou.Matrix3)()
        },
        alphaMap: {
            value: null
        },
        alphaMapTransform: {
            value: /*@__PURE__*/ new (0, $dyjou.Matrix3)()
        },
        alphaTest: {
            value: 0
        }
    },
    specularmap: {
        specularMap: {
            value: null
        },
        specularMapTransform: {
            value: /*@__PURE__*/ new (0, $dyjou.Matrix3)()
        }
    },
    envmap: {
        envMap: {
            value: null
        },
        envMapRotation: {
            value: /*@__PURE__*/ new (0, $dyjou.Matrix3)()
        },
        flipEnvMap: {
            value: -1
        },
        reflectivity: {
            value: 1.0
        },
        ior: {
            value: 1.5
        },
        refractionRatio: {
            value: 0.98
        }
    },
    aomap: {
        aoMap: {
            value: null
        },
        aoMapIntensity: {
            value: 1
        },
        aoMapTransform: {
            value: /*@__PURE__*/ new (0, $dyjou.Matrix3)()
        }
    },
    lightmap: {
        lightMap: {
            value: null
        },
        lightMapIntensity: {
            value: 1
        },
        lightMapTransform: {
            value: /*@__PURE__*/ new (0, $dyjou.Matrix3)()
        }
    },
    bumpmap: {
        bumpMap: {
            value: null
        },
        bumpMapTransform: {
            value: /*@__PURE__*/ new (0, $dyjou.Matrix3)()
        },
        bumpScale: {
            value: 1
        }
    },
    normalmap: {
        normalMap: {
            value: null
        },
        normalMapTransform: {
            value: /*@__PURE__*/ new (0, $dyjou.Matrix3)()
        },
        normalScale: {
            value: /*@__PURE__*/ new (0, $dyjou.Vector2)(1, 1)
        }
    },
    displacementmap: {
        displacementMap: {
            value: null
        },
        displacementMapTransform: {
            value: /*@__PURE__*/ new (0, $dyjou.Matrix3)()
        },
        displacementScale: {
            value: 1
        },
        displacementBias: {
            value: 0
        }
    },
    emissivemap: {
        emissiveMap: {
            value: null
        },
        emissiveMapTransform: {
            value: /*@__PURE__*/ new (0, $dyjou.Matrix3)()
        }
    },
    metalnessmap: {
        metalnessMap: {
            value: null
        },
        metalnessMapTransform: {
            value: /*@__PURE__*/ new (0, $dyjou.Matrix3)()
        }
    },
    roughnessmap: {
        roughnessMap: {
            value: null
        },
        roughnessMapTransform: {
            value: /*@__PURE__*/ new (0, $dyjou.Matrix3)()
        }
    },
    gradientmap: {
        gradientMap: {
            value: null
        }
    },
    fog: {
        fogDensity: {
            value: 0.00025
        },
        fogNear: {
            value: 1
        },
        fogFar: {
            value: 2000
        },
        fogColor: {
            value: /*@__PURE__*/ new (0, $dyjou.Color)(0xffffff)
        }
    },
    lights: {
        ambientLightColor: {
            value: []
        },
        lightProbe: {
            value: []
        },
        directionalLights: {
            value: [],
            properties: {
                direction: {},
                color: {}
            }
        },
        directionalLightShadows: {
            value: [],
            properties: {
                shadowIntensity: 1,
                shadowBias: {},
                shadowNormalBias: {},
                shadowRadius: {},
                shadowMapSize: {}
            }
        },
        directionalShadowMap: {
            value: []
        },
        directionalShadowMatrix: {
            value: []
        },
        spotLights: {
            value: [],
            properties: {
                color: {},
                position: {},
                direction: {},
                distance: {},
                coneCos: {},
                penumbraCos: {},
                decay: {}
            }
        },
        spotLightShadows: {
            value: [],
            properties: {
                shadowIntensity: 1,
                shadowBias: {},
                shadowNormalBias: {},
                shadowRadius: {},
                shadowMapSize: {}
            }
        },
        spotLightMap: {
            value: []
        },
        spotShadowMap: {
            value: []
        },
        spotLightMatrix: {
            value: []
        },
        pointLights: {
            value: [],
            properties: {
                color: {},
                position: {},
                decay: {},
                distance: {}
            }
        },
        pointLightShadows: {
            value: [],
            properties: {
                shadowIntensity: 1,
                shadowBias: {},
                shadowNormalBias: {},
                shadowRadius: {},
                shadowMapSize: {},
                shadowCameraNear: {},
                shadowCameraFar: {}
            }
        },
        pointShadowMap: {
            value: []
        },
        pointShadowMatrix: {
            value: []
        },
        hemisphereLights: {
            value: [],
            properties: {
                direction: {},
                skyColor: {},
                groundColor: {}
            }
        },
        // TODO (abelnation): RectAreaLight BRDF data needs to be moved from example to main src
        rectAreaLights: {
            value: [],
            properties: {
                color: {},
                position: {},
                width: {},
                height: {}
            }
        },
        ltc_1: {
            value: null
        },
        ltc_2: {
            value: null
        }
    },
    points: {
        diffuse: {
            value: /*@__PURE__*/ new (0, $dyjou.Color)(0xffffff)
        },
        opacity: {
            value: 1.0
        },
        size: {
            value: 1.0
        },
        scale: {
            value: 1.0
        },
        map: {
            value: null
        },
        alphaMap: {
            value: null
        },
        alphaMapTransform: {
            value: /*@__PURE__*/ new (0, $dyjou.Matrix3)()
        },
        alphaTest: {
            value: 0
        },
        uvTransform: {
            value: /*@__PURE__*/ new (0, $dyjou.Matrix3)()
        }
    },
    sprite: {
        diffuse: {
            value: /*@__PURE__*/ new (0, $dyjou.Color)(0xffffff)
        },
        opacity: {
            value: 1.0
        },
        center: {
            value: /*@__PURE__*/ new (0, $dyjou.Vector2)(0.5, 0.5)
        },
        rotation: {
            value: 0.0
        },
        map: {
            value: null
        },
        mapTransform: {
            value: /*@__PURE__*/ new (0, $dyjou.Matrix3)()
        },
        alphaMap: {
            value: null
        },
        alphaMapTransform: {
            value: /*@__PURE__*/ new (0, $dyjou.Matrix3)()
        },
        alphaTest: {
            value: 0
        }
    }
};
const $d5b33d7c30034067$export$bee4a7d47f8f5014 = {
    basic: {
        uniforms: /*@__PURE__*/ (0, $dyjou.mergeUniforms)([
            $d5b33d7c30034067$export$6643083551874bf5.common,
            $d5b33d7c30034067$export$6643083551874bf5.specularmap,
            $d5b33d7c30034067$export$6643083551874bf5.envmap,
            $d5b33d7c30034067$export$6643083551874bf5.aomap,
            $d5b33d7c30034067$export$6643083551874bf5.lightmap,
            $d5b33d7c30034067$export$6643083551874bf5.fog
        ]),
        vertexShader: $d5b33d7c30034067$export$955f9f2e84c43c8b.meshbasic_vert,
        fragmentShader: $d5b33d7c30034067$export$955f9f2e84c43c8b.meshbasic_frag
    },
    lambert: {
        uniforms: /*@__PURE__*/ (0, $dyjou.mergeUniforms)([
            $d5b33d7c30034067$export$6643083551874bf5.common,
            $d5b33d7c30034067$export$6643083551874bf5.specularmap,
            $d5b33d7c30034067$export$6643083551874bf5.envmap,
            $d5b33d7c30034067$export$6643083551874bf5.aomap,
            $d5b33d7c30034067$export$6643083551874bf5.lightmap,
            $d5b33d7c30034067$export$6643083551874bf5.emissivemap,
            $d5b33d7c30034067$export$6643083551874bf5.bumpmap,
            $d5b33d7c30034067$export$6643083551874bf5.normalmap,
            $d5b33d7c30034067$export$6643083551874bf5.displacementmap,
            $d5b33d7c30034067$export$6643083551874bf5.fog,
            $d5b33d7c30034067$export$6643083551874bf5.lights,
            {
                emissive: {
                    value: /*@__PURE__*/ new (0, $dyjou.Color)(0x000000)
                }
            }
        ]),
        vertexShader: $d5b33d7c30034067$export$955f9f2e84c43c8b.meshlambert_vert,
        fragmentShader: $d5b33d7c30034067$export$955f9f2e84c43c8b.meshlambert_frag
    },
    phong: {
        uniforms: /*@__PURE__*/ (0, $dyjou.mergeUniforms)([
            $d5b33d7c30034067$export$6643083551874bf5.common,
            $d5b33d7c30034067$export$6643083551874bf5.specularmap,
            $d5b33d7c30034067$export$6643083551874bf5.envmap,
            $d5b33d7c30034067$export$6643083551874bf5.aomap,
            $d5b33d7c30034067$export$6643083551874bf5.lightmap,
            $d5b33d7c30034067$export$6643083551874bf5.emissivemap,
            $d5b33d7c30034067$export$6643083551874bf5.bumpmap,
            $d5b33d7c30034067$export$6643083551874bf5.normalmap,
            $d5b33d7c30034067$export$6643083551874bf5.displacementmap,
            $d5b33d7c30034067$export$6643083551874bf5.fog,
            $d5b33d7c30034067$export$6643083551874bf5.lights,
            {
                emissive: {
                    value: /*@__PURE__*/ new (0, $dyjou.Color)(0x000000)
                },
                specular: {
                    value: /*@__PURE__*/ new (0, $dyjou.Color)(0x111111)
                },
                shininess: {
                    value: 30
                }
            }
        ]),
        vertexShader: $d5b33d7c30034067$export$955f9f2e84c43c8b.meshphong_vert,
        fragmentShader: $d5b33d7c30034067$export$955f9f2e84c43c8b.meshphong_frag
    },
    standard: {
        uniforms: /*@__PURE__*/ (0, $dyjou.mergeUniforms)([
            $d5b33d7c30034067$export$6643083551874bf5.common,
            $d5b33d7c30034067$export$6643083551874bf5.envmap,
            $d5b33d7c30034067$export$6643083551874bf5.aomap,
            $d5b33d7c30034067$export$6643083551874bf5.lightmap,
            $d5b33d7c30034067$export$6643083551874bf5.emissivemap,
            $d5b33d7c30034067$export$6643083551874bf5.bumpmap,
            $d5b33d7c30034067$export$6643083551874bf5.normalmap,
            $d5b33d7c30034067$export$6643083551874bf5.displacementmap,
            $d5b33d7c30034067$export$6643083551874bf5.roughnessmap,
            $d5b33d7c30034067$export$6643083551874bf5.metalnessmap,
            $d5b33d7c30034067$export$6643083551874bf5.fog,
            $d5b33d7c30034067$export$6643083551874bf5.lights,
            {
                emissive: {
                    value: /*@__PURE__*/ new (0, $dyjou.Color)(0x000000)
                },
                roughness: {
                    value: 1.0
                },
                metalness: {
                    value: 0.0
                },
                envMapIntensity: {
                    value: 1
                }
            }
        ]),
        vertexShader: $d5b33d7c30034067$export$955f9f2e84c43c8b.meshphysical_vert,
        fragmentShader: $d5b33d7c30034067$export$955f9f2e84c43c8b.meshphysical_frag
    },
    toon: {
        uniforms: /*@__PURE__*/ (0, $dyjou.mergeUniforms)([
            $d5b33d7c30034067$export$6643083551874bf5.common,
            $d5b33d7c30034067$export$6643083551874bf5.aomap,
            $d5b33d7c30034067$export$6643083551874bf5.lightmap,
            $d5b33d7c30034067$export$6643083551874bf5.emissivemap,
            $d5b33d7c30034067$export$6643083551874bf5.bumpmap,
            $d5b33d7c30034067$export$6643083551874bf5.normalmap,
            $d5b33d7c30034067$export$6643083551874bf5.displacementmap,
            $d5b33d7c30034067$export$6643083551874bf5.gradientmap,
            $d5b33d7c30034067$export$6643083551874bf5.fog,
            $d5b33d7c30034067$export$6643083551874bf5.lights,
            {
                emissive: {
                    value: /*@__PURE__*/ new (0, $dyjou.Color)(0x000000)
                }
            }
        ]),
        vertexShader: $d5b33d7c30034067$export$955f9f2e84c43c8b.meshtoon_vert,
        fragmentShader: $d5b33d7c30034067$export$955f9f2e84c43c8b.meshtoon_frag
    },
    matcap: {
        uniforms: /*@__PURE__*/ (0, $dyjou.mergeUniforms)([
            $d5b33d7c30034067$export$6643083551874bf5.common,
            $d5b33d7c30034067$export$6643083551874bf5.bumpmap,
            $d5b33d7c30034067$export$6643083551874bf5.normalmap,
            $d5b33d7c30034067$export$6643083551874bf5.displacementmap,
            $d5b33d7c30034067$export$6643083551874bf5.fog,
            {
                matcap: {
                    value: null
                }
            }
        ]),
        vertexShader: $d5b33d7c30034067$export$955f9f2e84c43c8b.meshmatcap_vert,
        fragmentShader: $d5b33d7c30034067$export$955f9f2e84c43c8b.meshmatcap_frag
    },
    points: {
        uniforms: /*@__PURE__*/ (0, $dyjou.mergeUniforms)([
            $d5b33d7c30034067$export$6643083551874bf5.points,
            $d5b33d7c30034067$export$6643083551874bf5.fog
        ]),
        vertexShader: $d5b33d7c30034067$export$955f9f2e84c43c8b.points_vert,
        fragmentShader: $d5b33d7c30034067$export$955f9f2e84c43c8b.points_frag
    },
    dashed: {
        uniforms: /*@__PURE__*/ (0, $dyjou.mergeUniforms)([
            $d5b33d7c30034067$export$6643083551874bf5.common,
            $d5b33d7c30034067$export$6643083551874bf5.fog,
            {
                scale: {
                    value: 1
                },
                dashSize: {
                    value: 1
                },
                totalSize: {
                    value: 2
                }
            }
        ]),
        vertexShader: $d5b33d7c30034067$export$955f9f2e84c43c8b.linedashed_vert,
        fragmentShader: $d5b33d7c30034067$export$955f9f2e84c43c8b.linedashed_frag
    },
    depth: {
        uniforms: /*@__PURE__*/ (0, $dyjou.mergeUniforms)([
            $d5b33d7c30034067$export$6643083551874bf5.common,
            $d5b33d7c30034067$export$6643083551874bf5.displacementmap
        ]),
        vertexShader: $d5b33d7c30034067$export$955f9f2e84c43c8b.depth_vert,
        fragmentShader: $d5b33d7c30034067$export$955f9f2e84c43c8b.depth_frag
    },
    normal: {
        uniforms: /*@__PURE__*/ (0, $dyjou.mergeUniforms)([
            $d5b33d7c30034067$export$6643083551874bf5.common,
            $d5b33d7c30034067$export$6643083551874bf5.bumpmap,
            $d5b33d7c30034067$export$6643083551874bf5.normalmap,
            $d5b33d7c30034067$export$6643083551874bf5.displacementmap,
            {
                opacity: {
                    value: 1.0
                }
            }
        ]),
        vertexShader: $d5b33d7c30034067$export$955f9f2e84c43c8b.meshnormal_vert,
        fragmentShader: $d5b33d7c30034067$export$955f9f2e84c43c8b.meshnormal_frag
    },
    sprite: {
        uniforms: /*@__PURE__*/ (0, $dyjou.mergeUniforms)([
            $d5b33d7c30034067$export$6643083551874bf5.sprite,
            $d5b33d7c30034067$export$6643083551874bf5.fog
        ]),
        vertexShader: $d5b33d7c30034067$export$955f9f2e84c43c8b.sprite_vert,
        fragmentShader: $d5b33d7c30034067$export$955f9f2e84c43c8b.sprite_frag
    },
    background: {
        uniforms: {
            uvTransform: {
                value: /*@__PURE__*/ new (0, $dyjou.Matrix3)()
            },
            t2D: {
                value: null
            },
            backgroundIntensity: {
                value: 1
            }
        },
        vertexShader: $d5b33d7c30034067$export$955f9f2e84c43c8b.background_vert,
        fragmentShader: $d5b33d7c30034067$export$955f9f2e84c43c8b.background_frag
    },
    backgroundCube: {
        uniforms: {
            envMap: {
                value: null
            },
            flipEnvMap: {
                value: -1
            },
            backgroundBlurriness: {
                value: 0
            },
            backgroundIntensity: {
                value: 1
            },
            backgroundRotation: {
                value: /*@__PURE__*/ new (0, $dyjou.Matrix3)()
            }
        },
        vertexShader: $d5b33d7c30034067$export$955f9f2e84c43c8b.backgroundCube_vert,
        fragmentShader: $d5b33d7c30034067$export$955f9f2e84c43c8b.backgroundCube_frag
    },
    cube: {
        uniforms: {
            tCube: {
                value: null
            },
            tFlip: {
                value: -1
            },
            opacity: {
                value: 1.0
            }
        },
        vertexShader: $d5b33d7c30034067$export$955f9f2e84c43c8b.cube_vert,
        fragmentShader: $d5b33d7c30034067$export$955f9f2e84c43c8b.cube_frag
    },
    equirect: {
        uniforms: {
            tEquirect: {
                value: null
            }
        },
        vertexShader: $d5b33d7c30034067$export$955f9f2e84c43c8b.equirect_vert,
        fragmentShader: $d5b33d7c30034067$export$955f9f2e84c43c8b.equirect_frag
    },
    distanceRGBA: {
        uniforms: /*@__PURE__*/ (0, $dyjou.mergeUniforms)([
            $d5b33d7c30034067$export$6643083551874bf5.common,
            $d5b33d7c30034067$export$6643083551874bf5.displacementmap,
            {
                referencePosition: {
                    value: /*@__PURE__*/ new (0, $dyjou.Vector3)()
                },
                nearDistance: {
                    value: 1
                },
                farDistance: {
                    value: 1000
                }
            }
        ]),
        vertexShader: $d5b33d7c30034067$export$955f9f2e84c43c8b.distanceRGBA_vert,
        fragmentShader: $d5b33d7c30034067$export$955f9f2e84c43c8b.distanceRGBA_frag
    },
    shadow: {
        uniforms: /*@__PURE__*/ (0, $dyjou.mergeUniforms)([
            $d5b33d7c30034067$export$6643083551874bf5.lights,
            $d5b33d7c30034067$export$6643083551874bf5.fog,
            {
                color: {
                    value: /*@__PURE__*/ new (0, $dyjou.Color)(0x00000)
                },
                opacity: {
                    value: 1.0
                }
            }
        ]),
        vertexShader: $d5b33d7c30034067$export$955f9f2e84c43c8b.shadow_vert,
        fragmentShader: $d5b33d7c30034067$export$955f9f2e84c43c8b.shadow_frag
    }
};
$d5b33d7c30034067$export$bee4a7d47f8f5014.physical = {
    uniforms: /*@__PURE__*/ (0, $dyjou.mergeUniforms)([
        $d5b33d7c30034067$export$bee4a7d47f8f5014.standard.uniforms,
        {
            clearcoat: {
                value: 0
            },
            clearcoatMap: {
                value: null
            },
            clearcoatMapTransform: {
                value: /*@__PURE__*/ new (0, $dyjou.Matrix3)()
            },
            clearcoatNormalMap: {
                value: null
            },
            clearcoatNormalMapTransform: {
                value: /*@__PURE__*/ new (0, $dyjou.Matrix3)()
            },
            clearcoatNormalScale: {
                value: /*@__PURE__*/ new (0, $dyjou.Vector2)(1, 1)
            },
            clearcoatRoughness: {
                value: 0
            },
            clearcoatRoughnessMap: {
                value: null
            },
            clearcoatRoughnessMapTransform: {
                value: /*@__PURE__*/ new (0, $dyjou.Matrix3)()
            },
            dispersion: {
                value: 0
            },
            iridescence: {
                value: 0
            },
            iridescenceMap: {
                value: null
            },
            iridescenceMapTransform: {
                value: /*@__PURE__*/ new (0, $dyjou.Matrix3)()
            },
            iridescenceIOR: {
                value: 1.3
            },
            iridescenceThicknessMinimum: {
                value: 100
            },
            iridescenceThicknessMaximum: {
                value: 400
            },
            iridescenceThicknessMap: {
                value: null
            },
            iridescenceThicknessMapTransform: {
                value: /*@__PURE__*/ new (0, $dyjou.Matrix3)()
            },
            sheen: {
                value: 0
            },
            sheenColor: {
                value: /*@__PURE__*/ new (0, $dyjou.Color)(0x000000)
            },
            sheenColorMap: {
                value: null
            },
            sheenColorMapTransform: {
                value: /*@__PURE__*/ new (0, $dyjou.Matrix3)()
            },
            sheenRoughness: {
                value: 1
            },
            sheenRoughnessMap: {
                value: null
            },
            sheenRoughnessMapTransform: {
                value: /*@__PURE__*/ new (0, $dyjou.Matrix3)()
            },
            transmission: {
                value: 0
            },
            transmissionMap: {
                value: null
            },
            transmissionMapTransform: {
                value: /*@__PURE__*/ new (0, $dyjou.Matrix3)()
            },
            transmissionSamplerSize: {
                value: /*@__PURE__*/ new (0, $dyjou.Vector2)()
            },
            transmissionSamplerMap: {
                value: null
            },
            thickness: {
                value: 0
            },
            thicknessMap: {
                value: null
            },
            thicknessMapTransform: {
                value: /*@__PURE__*/ new (0, $dyjou.Matrix3)()
            },
            attenuationDistance: {
                value: 0
            },
            attenuationColor: {
                value: /*@__PURE__*/ new (0, $dyjou.Color)(0x000000)
            },
            specularColor: {
                value: /*@__PURE__*/ new (0, $dyjou.Color)(1, 1, 1)
            },
            specularColorMap: {
                value: null
            },
            specularColorMapTransform: {
                value: /*@__PURE__*/ new (0, $dyjou.Matrix3)()
            },
            specularIntensity: {
                value: 1
            },
            specularIntensityMap: {
                value: null
            },
            specularIntensityMapTransform: {
                value: /*@__PURE__*/ new (0, $dyjou.Matrix3)()
            },
            anisotropyVector: {
                value: /*@__PURE__*/ new (0, $dyjou.Vector2)()
            },
            anisotropyMap: {
                value: null
            },
            anisotropyMapTransform: {
                value: /*@__PURE__*/ new (0, $dyjou.Matrix3)()
            }
        }
    ]),
    vertexShader: $d5b33d7c30034067$export$955f9f2e84c43c8b.meshphysical_vert,
    fragmentShader: $d5b33d7c30034067$export$955f9f2e84c43c8b.meshphysical_frag
};
const $d5b33d7c30034067$var$_rgb = {
    r: 0,
    b: 0,
    g: 0
};
const $d5b33d7c30034067$var$_e1$1 = /*@__PURE__*/ new (0, $dyjou.Euler)();
const $d5b33d7c30034067$var$_m1$1 = /*@__PURE__*/ new (0, $dyjou.Matrix4)();
function $d5b33d7c30034067$var$WebGLBackground(renderer, cubemaps, cubeuvmaps, state, objects, alpha, premultipliedAlpha) {
    const clearColor = new (0, $dyjou.Color)(0x000000);
    let clearAlpha = alpha === true ? 0 : 1;
    let planeMesh;
    let boxMesh;
    let currentBackground = null;
    let currentBackgroundVersion = 0;
    let currentTonemapping = null;
    function getBackground(scene) {
        let background = scene.isScene === true ? scene.background : null;
        if (background && background.isTexture) {
            const usePMREM = scene.backgroundBlurriness > 0; // use PMREM if the user wants to blur the background
            background = (usePMREM ? cubeuvmaps : cubemaps).get(background);
        }
        return background;
    }
    function render(scene) {
        let forceClear = false;
        const background = getBackground(scene);
        if (background === null) setClear(clearColor, clearAlpha);
        else if (background && background.isColor) {
            setClear(background, 1);
            forceClear = true;
        }
        const environmentBlendMode = renderer.xr.getEnvironmentBlendMode();
        if (environmentBlendMode === 'additive') state.buffers.color.setClear(0, 0, 0, 1, premultipliedAlpha);
        else if (environmentBlendMode === 'alpha-blend') state.buffers.color.setClear(0, 0, 0, 0, premultipliedAlpha);
        if (renderer.autoClear || forceClear) {
            // buffers might not be writable which is required to ensure a correct clear
            state.buffers.depth.setTest(true);
            state.buffers.depth.setMask(true);
            state.buffers.color.setMask(true);
            renderer.clear(renderer.autoClearColor, renderer.autoClearDepth, renderer.autoClearStencil);
        }
    }
    function addToRenderList(renderList, scene) {
        const background = getBackground(scene);
        if (background && (background.isCubeTexture || background.mapping === (0, $dyjou.CubeUVReflectionMapping))) {
            if (boxMesh === undefined) {
                boxMesh = new (0, $dyjou.Mesh)(new (0, $dyjou.BoxGeometry)(1, 1, 1), new (0, $dyjou.ShaderMaterial)({
                    name: 'BackgroundCubeMaterial',
                    uniforms: (0, $dyjou.cloneUniforms)($d5b33d7c30034067$export$bee4a7d47f8f5014.backgroundCube.uniforms),
                    vertexShader: $d5b33d7c30034067$export$bee4a7d47f8f5014.backgroundCube.vertexShader,
                    fragmentShader: $d5b33d7c30034067$export$bee4a7d47f8f5014.backgroundCube.fragmentShader,
                    side: (0, $dyjou.BackSide),
                    depthTest: false,
                    depthWrite: false,
                    fog: false,
                    allowOverride: false
                }));
                boxMesh.geometry.deleteAttribute('normal');
                boxMesh.geometry.deleteAttribute('uv');
                boxMesh.onBeforeRender = function(renderer, scene, camera) {
                    this.matrixWorld.copyPosition(camera.matrixWorld);
                };
                // add "envMap" material property so the renderer can evaluate it like for built-in materials
                Object.defineProperty(boxMesh.material, 'envMap', {
                    get: function() {
                        return this.uniforms.envMap.value;
                    }
                });
                objects.update(boxMesh);
            }
            $d5b33d7c30034067$var$_e1$1.copy(scene.backgroundRotation);
            // accommodate left-handed frame
            $d5b33d7c30034067$var$_e1$1.x *= -1;
            $d5b33d7c30034067$var$_e1$1.y *= -1;
            $d5b33d7c30034067$var$_e1$1.z *= -1;
            if (background.isCubeTexture && background.isRenderTargetTexture === false) {
                // environment maps which are not cube render targets or PMREMs follow a different convention
                $d5b33d7c30034067$var$_e1$1.y *= -1;
                $d5b33d7c30034067$var$_e1$1.z *= -1;
            }
            boxMesh.material.uniforms.envMap.value = background;
            boxMesh.material.uniforms.flipEnvMap.value = background.isCubeTexture && background.isRenderTargetTexture === false ? -1 : 1;
            boxMesh.material.uniforms.backgroundBlurriness.value = scene.backgroundBlurriness;
            boxMesh.material.uniforms.backgroundIntensity.value = scene.backgroundIntensity;
            boxMesh.material.uniforms.backgroundRotation.value.setFromMatrix4($d5b33d7c30034067$var$_m1$1.makeRotationFromEuler($d5b33d7c30034067$var$_e1$1));
            boxMesh.material.toneMapped = (0, $dyjou.ColorManagement).getTransfer(background.colorSpace) !== (0, $dyjou.SRGBTransfer);
            if (currentBackground !== background || currentBackgroundVersion !== background.version || currentTonemapping !== renderer.toneMapping) {
                boxMesh.material.needsUpdate = true;
                currentBackground = background;
                currentBackgroundVersion = background.version;
                currentTonemapping = renderer.toneMapping;
            }
            boxMesh.layers.enableAll();
            // push to the pre-sorted opaque render list
            renderList.unshift(boxMesh, boxMesh.geometry, boxMesh.material, 0, 0, null);
        } else if (background && background.isTexture) {
            if (planeMesh === undefined) {
                planeMesh = new (0, $dyjou.Mesh)(new (0, $dyjou.PlaneGeometry)(2, 2), new (0, $dyjou.ShaderMaterial)({
                    name: 'BackgroundMaterial',
                    uniforms: (0, $dyjou.cloneUniforms)($d5b33d7c30034067$export$bee4a7d47f8f5014.background.uniforms),
                    vertexShader: $d5b33d7c30034067$export$bee4a7d47f8f5014.background.vertexShader,
                    fragmentShader: $d5b33d7c30034067$export$bee4a7d47f8f5014.background.fragmentShader,
                    side: (0, $dyjou.FrontSide),
                    depthTest: false,
                    depthWrite: false,
                    fog: false,
                    allowOverride: false
                }));
                planeMesh.geometry.deleteAttribute('normal');
                // add "map" material property so the renderer can evaluate it like for built-in materials
                Object.defineProperty(planeMesh.material, 'map', {
                    get: function() {
                        return this.uniforms.t2D.value;
                    }
                });
                objects.update(planeMesh);
            }
            planeMesh.material.uniforms.t2D.value = background;
            planeMesh.material.uniforms.backgroundIntensity.value = scene.backgroundIntensity;
            planeMesh.material.toneMapped = (0, $dyjou.ColorManagement).getTransfer(background.colorSpace) !== (0, $dyjou.SRGBTransfer);
            if (background.matrixAutoUpdate === true) background.updateMatrix();
            planeMesh.material.uniforms.uvTransform.value.copy(background.matrix);
            if (currentBackground !== background || currentBackgroundVersion !== background.version || currentTonemapping !== renderer.toneMapping) {
                planeMesh.material.needsUpdate = true;
                currentBackground = background;
                currentBackgroundVersion = background.version;
                currentTonemapping = renderer.toneMapping;
            }
            planeMesh.layers.enableAll();
            // push to the pre-sorted opaque render list
            renderList.unshift(planeMesh, planeMesh.geometry, planeMesh.material, 0, 0, null);
        }
    }
    function setClear(color, alpha) {
        color.getRGB($d5b33d7c30034067$var$_rgb, (0, $dyjou.getUnlitUniformColorSpace)(renderer));
        state.buffers.color.setClear($d5b33d7c30034067$var$_rgb.r, $d5b33d7c30034067$var$_rgb.g, $d5b33d7c30034067$var$_rgb.b, alpha, premultipliedAlpha);
    }
    function dispose() {
        if (boxMesh !== undefined) {
            boxMesh.geometry.dispose();
            boxMesh.material.dispose();
            boxMesh = undefined;
        }
        if (planeMesh !== undefined) {
            planeMesh.geometry.dispose();
            planeMesh.material.dispose();
            planeMesh = undefined;
        }
    }
    return {
        getClearColor: function() {
            return clearColor;
        },
        setClearColor: function(color, alpha = 1) {
            clearColor.set(color);
            clearAlpha = alpha;
            setClear(clearColor, clearAlpha);
        },
        getClearAlpha: function() {
            return clearAlpha;
        },
        setClearAlpha: function(alpha) {
            clearAlpha = alpha;
            setClear(clearColor, clearAlpha);
        },
        render: render,
        addToRenderList: addToRenderList,
        dispose: dispose
    };
}
function $d5b33d7c30034067$var$WebGLBindingStates(gl, attributes) {
    const maxVertexAttributes = gl.getParameter(gl.MAX_VERTEX_ATTRIBS);
    const bindingStates = {};
    const defaultState = createBindingState(null);
    let currentState = defaultState;
    let forceUpdate = false;
    function setup(object, material, program, geometry, index) {
        let updateBuffers = false;
        const state = getBindingState(geometry, program, material);
        if (currentState !== state) {
            currentState = state;
            bindVertexArrayObject(currentState.object);
        }
        updateBuffers = needsUpdate(object, geometry, program, index);
        if (updateBuffers) saveCache(object, geometry, program, index);
        if (index !== null) attributes.update(index, gl.ELEMENT_ARRAY_BUFFER);
        if (updateBuffers || forceUpdate) {
            forceUpdate = false;
            setupVertexAttributes(object, material, program, geometry);
            if (index !== null) gl.bindBuffer(gl.ELEMENT_ARRAY_BUFFER, attributes.get(index).buffer);
        }
    }
    function createVertexArrayObject() {
        return gl.createVertexArray();
    }
    function bindVertexArrayObject(vao) {
        return gl.bindVertexArray(vao);
    }
    function deleteVertexArrayObject(vao) {
        return gl.deleteVertexArray(vao);
    }
    function getBindingState(geometry, program, material) {
        const wireframe = material.wireframe === true;
        let programMap = bindingStates[geometry.id];
        if (programMap === undefined) {
            programMap = {};
            bindingStates[geometry.id] = programMap;
        }
        let stateMap = programMap[program.id];
        if (stateMap === undefined) {
            stateMap = {};
            programMap[program.id] = stateMap;
        }
        let state = stateMap[wireframe];
        if (state === undefined) {
            state = createBindingState(createVertexArrayObject());
            stateMap[wireframe] = state;
        }
        return state;
    }
    function createBindingState(vao) {
        const newAttributes = [];
        const enabledAttributes = [];
        const attributeDivisors = [];
        for(let i = 0; i < maxVertexAttributes; i++){
            newAttributes[i] = 0;
            enabledAttributes[i] = 0;
            attributeDivisors[i] = 0;
        }
        return {
            // for backward compatibility on non-VAO support browser
            geometry: null,
            program: null,
            wireframe: false,
            newAttributes: newAttributes,
            enabledAttributes: enabledAttributes,
            attributeDivisors: attributeDivisors,
            object: vao,
            attributes: {},
            index: null
        };
    }
    function needsUpdate(object, geometry, program, index) {
        const cachedAttributes = currentState.attributes;
        const geometryAttributes = geometry.attributes;
        let attributesNum = 0;
        const programAttributes = program.getAttributes();
        for(const name in programAttributes){
            const programAttribute = programAttributes[name];
            if (programAttribute.location >= 0) {
                const cachedAttribute = cachedAttributes[name];
                let geometryAttribute = geometryAttributes[name];
                if (geometryAttribute === undefined) {
                    if (name === 'instanceMatrix' && object.instanceMatrix) geometryAttribute = object.instanceMatrix;
                    if (name === 'instanceColor' && object.instanceColor) geometryAttribute = object.instanceColor;
                }
                if (cachedAttribute === undefined) return true;
                if (cachedAttribute.attribute !== geometryAttribute) return true;
                if (geometryAttribute && cachedAttribute.data !== geometryAttribute.data) return true;
                attributesNum++;
            }
        }
        if (currentState.attributesNum !== attributesNum) return true;
        if (currentState.index !== index) return true;
        return false;
    }
    function saveCache(object, geometry, program, index) {
        const cache = {};
        const attributes = geometry.attributes;
        let attributesNum = 0;
        const programAttributes = program.getAttributes();
        for(const name in programAttributes){
            const programAttribute = programAttributes[name];
            if (programAttribute.location >= 0) {
                let attribute = attributes[name];
                if (attribute === undefined) {
                    if (name === 'instanceMatrix' && object.instanceMatrix) attribute = object.instanceMatrix;
                    if (name === 'instanceColor' && object.instanceColor) attribute = object.instanceColor;
                }
                const data = {};
                data.attribute = attribute;
                if (attribute && attribute.data) data.data = attribute.data;
                cache[name] = data;
                attributesNum++;
            }
        }
        currentState.attributes = cache;
        currentState.attributesNum = attributesNum;
        currentState.index = index;
    }
    function initAttributes() {
        const newAttributes = currentState.newAttributes;
        for(let i = 0, il = newAttributes.length; i < il; i++)newAttributes[i] = 0;
    }
    function enableAttribute(attribute) {
        enableAttributeAndDivisor(attribute, 0);
    }
    function enableAttributeAndDivisor(attribute, meshPerAttribute) {
        const newAttributes = currentState.newAttributes;
        const enabledAttributes = currentState.enabledAttributes;
        const attributeDivisors = currentState.attributeDivisors;
        newAttributes[attribute] = 1;
        if (enabledAttributes[attribute] === 0) {
            gl.enableVertexAttribArray(attribute);
            enabledAttributes[attribute] = 1;
        }
        if (attributeDivisors[attribute] !== meshPerAttribute) {
            gl.vertexAttribDivisor(attribute, meshPerAttribute);
            attributeDivisors[attribute] = meshPerAttribute;
        }
    }
    function disableUnusedAttributes() {
        const newAttributes = currentState.newAttributes;
        const enabledAttributes = currentState.enabledAttributes;
        for(let i = 0, il = enabledAttributes.length; i < il; i++)if (enabledAttributes[i] !== newAttributes[i]) {
            gl.disableVertexAttribArray(i);
            enabledAttributes[i] = 0;
        }
    }
    function vertexAttribPointer(index, size, type, normalized, stride, offset, integer) {
        if (integer === true) gl.vertexAttribIPointer(index, size, type, stride, offset);
        else gl.vertexAttribPointer(index, size, type, normalized, stride, offset);
    }
    function setupVertexAttributes(object, material, program, geometry) {
        initAttributes();
        const geometryAttributes = geometry.attributes;
        const programAttributes = program.getAttributes();
        const materialDefaultAttributeValues = material.defaultAttributeValues;
        for(const name in programAttributes){
            const programAttribute = programAttributes[name];
            if (programAttribute.location >= 0) {
                let geometryAttribute = geometryAttributes[name];
                if (geometryAttribute === undefined) {
                    if (name === 'instanceMatrix' && object.instanceMatrix) geometryAttribute = object.instanceMatrix;
                    if (name === 'instanceColor' && object.instanceColor) geometryAttribute = object.instanceColor;
                }
                if (geometryAttribute !== undefined) {
                    const normalized = geometryAttribute.normalized;
                    const size = geometryAttribute.itemSize;
                    const attribute = attributes.get(geometryAttribute);
                    // TODO Attribute may not be available on context restore
                    if (attribute === undefined) continue;
                    const buffer = attribute.buffer;
                    const type = attribute.type;
                    const bytesPerElement = attribute.bytesPerElement;
                    // check for integer attributes
                    const integer = type === gl.INT || type === gl.UNSIGNED_INT || geometryAttribute.gpuType === (0, $dyjou.IntType);
                    if (geometryAttribute.isInterleavedBufferAttribute) {
                        const data = geometryAttribute.data;
                        const stride = data.stride;
                        const offset = geometryAttribute.offset;
                        if (data.isInstancedInterleavedBuffer) {
                            for(let i = 0; i < programAttribute.locationSize; i++)enableAttributeAndDivisor(programAttribute.location + i, data.meshPerAttribute);
                            if (object.isInstancedMesh !== true && geometry._maxInstanceCount === undefined) geometry._maxInstanceCount = data.meshPerAttribute * data.count;
                        } else for(let i = 0; i < programAttribute.locationSize; i++)enableAttribute(programAttribute.location + i);
                        gl.bindBuffer(gl.ARRAY_BUFFER, buffer);
                        for(let i = 0; i < programAttribute.locationSize; i++)vertexAttribPointer(programAttribute.location + i, size / programAttribute.locationSize, type, normalized, stride * bytesPerElement, (offset + size / programAttribute.locationSize * i) * bytesPerElement, integer);
                    } else {
                        if (geometryAttribute.isInstancedBufferAttribute) {
                            for(let i = 0; i < programAttribute.locationSize; i++)enableAttributeAndDivisor(programAttribute.location + i, geometryAttribute.meshPerAttribute);
                            if (object.isInstancedMesh !== true && geometry._maxInstanceCount === undefined) geometry._maxInstanceCount = geometryAttribute.meshPerAttribute * geometryAttribute.count;
                        } else for(let i = 0; i < programAttribute.locationSize; i++)enableAttribute(programAttribute.location + i);
                        gl.bindBuffer(gl.ARRAY_BUFFER, buffer);
                        for(let i = 0; i < programAttribute.locationSize; i++)vertexAttribPointer(programAttribute.location + i, size / programAttribute.locationSize, type, normalized, size * bytesPerElement, size / programAttribute.locationSize * i * bytesPerElement, integer);
                    }
                } else if (materialDefaultAttributeValues !== undefined) {
                    const value = materialDefaultAttributeValues[name];
                    if (value !== undefined) switch(value.length){
                        case 2:
                            gl.vertexAttrib2fv(programAttribute.location, value);
                            break;
                        case 3:
                            gl.vertexAttrib3fv(programAttribute.location, value);
                            break;
                        case 4:
                            gl.vertexAttrib4fv(programAttribute.location, value);
                            break;
                        default:
                            gl.vertexAttrib1fv(programAttribute.location, value);
                    }
                }
            }
        }
        disableUnusedAttributes();
    }
    function dispose() {
        reset();
        for(const geometryId in bindingStates){
            const programMap = bindingStates[geometryId];
            for(const programId in programMap){
                const stateMap = programMap[programId];
                for(const wireframe in stateMap){
                    deleteVertexArrayObject(stateMap[wireframe].object);
                    delete stateMap[wireframe];
                }
                delete programMap[programId];
            }
            delete bindingStates[geometryId];
        }
    }
    function releaseStatesOfGeometry(geometry) {
        if (bindingStates[geometry.id] === undefined) return;
        const programMap = bindingStates[geometry.id];
        for(const programId in programMap){
            const stateMap = programMap[programId];
            for(const wireframe in stateMap){
                deleteVertexArrayObject(stateMap[wireframe].object);
                delete stateMap[wireframe];
            }
            delete programMap[programId];
        }
        delete bindingStates[geometry.id];
    }
    function releaseStatesOfProgram(program) {
        for(const geometryId in bindingStates){
            const programMap = bindingStates[geometryId];
            if (programMap[program.id] === undefined) continue;
            const stateMap = programMap[program.id];
            for(const wireframe in stateMap){
                deleteVertexArrayObject(stateMap[wireframe].object);
                delete stateMap[wireframe];
            }
            delete programMap[program.id];
        }
    }
    function reset() {
        resetDefaultState();
        forceUpdate = true;
        if (currentState === defaultState) return;
        currentState = defaultState;
        bindVertexArrayObject(currentState.object);
    }
    // for backward-compatibility
    function resetDefaultState() {
        defaultState.geometry = null;
        defaultState.program = null;
        defaultState.wireframe = false;
    }
    return {
        setup: setup,
        reset: reset,
        resetDefaultState: resetDefaultState,
        dispose: dispose,
        releaseStatesOfGeometry: releaseStatesOfGeometry,
        releaseStatesOfProgram: releaseStatesOfProgram,
        initAttributes: initAttributes,
        enableAttribute: enableAttribute,
        disableUnusedAttributes: disableUnusedAttributes
    };
}
function $d5b33d7c30034067$var$WebGLBufferRenderer(gl, extensions, info) {
    let mode;
    function setMode(value) {
        mode = value;
    }
    function render(start, count) {
        gl.drawArrays(mode, start, count);
        info.update(count, mode, 1);
    }
    function renderInstances(start, count, primcount) {
        if (primcount === 0) return;
        gl.drawArraysInstanced(mode, start, count, primcount);
        info.update(count, mode, primcount);
    }
    function renderMultiDraw(starts, counts, drawCount) {
        if (drawCount === 0) return;
        const extension = extensions.get('WEBGL_multi_draw');
        extension.multiDrawArraysWEBGL(mode, starts, 0, counts, 0, drawCount);
        let elementCount = 0;
        for(let i = 0; i < drawCount; i++)elementCount += counts[i];
        info.update(elementCount, mode, 1);
    }
    function renderMultiDrawInstances(starts, counts, drawCount, primcount) {
        if (drawCount === 0) return;
        const extension = extensions.get('WEBGL_multi_draw');
        if (extension === null) for(let i = 0; i < starts.length; i++)renderInstances(starts[i], counts[i], primcount[i]);
        else {
            extension.multiDrawArraysInstancedWEBGL(mode, starts, 0, counts, 0, primcount, 0, drawCount);
            let elementCount = 0;
            for(let i = 0; i < drawCount; i++)elementCount += counts[i] * primcount[i];
            info.update(elementCount, mode, 1);
        }
    }
    //
    this.setMode = setMode;
    this.render = render;
    this.renderInstances = renderInstances;
    this.renderMultiDraw = renderMultiDraw;
    this.renderMultiDrawInstances = renderMultiDrawInstances;
}
function $d5b33d7c30034067$var$WebGLCapabilities(gl, extensions, parameters, utils) {
    let maxAnisotropy;
    function getMaxAnisotropy() {
        if (maxAnisotropy !== undefined) return maxAnisotropy;
        if (extensions.has('EXT_texture_filter_anisotropic') === true) {
            const extension = extensions.get('EXT_texture_filter_anisotropic');
            maxAnisotropy = gl.getParameter(extension.MAX_TEXTURE_MAX_ANISOTROPY_EXT);
        } else maxAnisotropy = 0;
        return maxAnisotropy;
    }
    function textureFormatReadable(textureFormat) {
        if (textureFormat !== (0, $dyjou.RGBAFormat) && utils.convert(textureFormat) !== gl.getParameter(gl.IMPLEMENTATION_COLOR_READ_FORMAT)) return false;
        return true;
    }
    function textureTypeReadable(textureType) {
        const halfFloatSupportedByExt = textureType === (0, $dyjou.HalfFloatType) && (extensions.has('EXT_color_buffer_half_float') || extensions.has('EXT_color_buffer_float'));
        if (textureType !== (0, $dyjou.UnsignedByteType) && utils.convert(textureType) !== gl.getParameter(gl.IMPLEMENTATION_COLOR_READ_TYPE) && // Edge and Chrome Mac < 52 (#9513)
        textureType !== (0, $dyjou.FloatType) && !halfFloatSupportedByExt) return false;
        return true;
    }
    function getMaxPrecision(precision) {
        if (precision === 'highp') {
            if (gl.getShaderPrecisionFormat(gl.VERTEX_SHADER, gl.HIGH_FLOAT).precision > 0 && gl.getShaderPrecisionFormat(gl.FRAGMENT_SHADER, gl.HIGH_FLOAT).precision > 0) return 'highp';
            precision = 'mediump';
        }
        if (precision === 'mediump') {
            if (gl.getShaderPrecisionFormat(gl.VERTEX_SHADER, gl.MEDIUM_FLOAT).precision > 0 && gl.getShaderPrecisionFormat(gl.FRAGMENT_SHADER, gl.MEDIUM_FLOAT).precision > 0) return 'mediump';
        }
        return 'lowp';
    }
    let precision = parameters.precision !== undefined ? parameters.precision : 'highp';
    const maxPrecision = getMaxPrecision(precision);
    if (maxPrecision !== precision) {
        console.warn('THREE.WebGLRenderer:', precision, 'not supported, using', maxPrecision, 'instead.');
        precision = maxPrecision;
    }
    const logarithmicDepthBuffer = parameters.logarithmicDepthBuffer === true;
    const reverseDepthBuffer = parameters.reverseDepthBuffer === true && extensions.has('EXT_clip_control');
    const maxTextures = gl.getParameter(gl.MAX_TEXTURE_IMAGE_UNITS);
    const maxVertexTextures = gl.getParameter(gl.MAX_VERTEX_TEXTURE_IMAGE_UNITS);
    const maxTextureSize = gl.getParameter(gl.MAX_TEXTURE_SIZE);
    const maxCubemapSize = gl.getParameter(gl.MAX_CUBE_MAP_TEXTURE_SIZE);
    const maxAttributes = gl.getParameter(gl.MAX_VERTEX_ATTRIBS);
    const maxVertexUniforms = gl.getParameter(gl.MAX_VERTEX_UNIFORM_VECTORS);
    const maxVaryings = gl.getParameter(gl.MAX_VARYING_VECTORS);
    const maxFragmentUniforms = gl.getParameter(gl.MAX_FRAGMENT_UNIFORM_VECTORS);
    const vertexTextures = maxVertexTextures > 0;
    const maxSamples = gl.getParameter(gl.MAX_SAMPLES);
    return {
        isWebGL2: true,
        getMaxAnisotropy: getMaxAnisotropy,
        getMaxPrecision: getMaxPrecision,
        textureFormatReadable: textureFormatReadable,
        textureTypeReadable: textureTypeReadable,
        precision: precision,
        logarithmicDepthBuffer: logarithmicDepthBuffer,
        reverseDepthBuffer: reverseDepthBuffer,
        maxTextures: maxTextures,
        maxVertexTextures: maxVertexTextures,
        maxTextureSize: maxTextureSize,
        maxCubemapSize: maxCubemapSize,
        maxAttributes: maxAttributes,
        maxVertexUniforms: maxVertexUniforms,
        maxVaryings: maxVaryings,
        maxFragmentUniforms: maxFragmentUniforms,
        vertexTextures: vertexTextures,
        maxSamples: maxSamples
    };
}
function $d5b33d7c30034067$var$WebGLClipping(properties) {
    const scope = this;
    let globalState = null, numGlobalPlanes = 0, localClippingEnabled = false, renderingShadows = false;
    const plane = new (0, $dyjou.Plane)(), viewNormalMatrix = new (0, $dyjou.Matrix3)(), uniform = {
        value: null,
        needsUpdate: false
    };
    this.uniform = uniform;
    this.numPlanes = 0;
    this.numIntersection = 0;
    this.init = function(planes, enableLocalClipping) {
        const enabled = planes.length !== 0 || enableLocalClipping || // enable state of previous frame - the clipping code has to
        // run another frame in order to reset the state:
        numGlobalPlanes !== 0 || localClippingEnabled;
        localClippingEnabled = enableLocalClipping;
        numGlobalPlanes = planes.length;
        return enabled;
    };
    this.beginShadows = function() {
        renderingShadows = true;
        projectPlanes(null);
    };
    this.endShadows = function() {
        renderingShadows = false;
    };
    this.setGlobalState = function(planes, camera) {
        globalState = projectPlanes(planes, camera, 0);
    };
    this.setState = function(material, camera, useCache) {
        const planes = material.clippingPlanes, clipIntersection = material.clipIntersection, clipShadows = material.clipShadows;
        const materialProperties = properties.get(material);
        if (!localClippingEnabled || planes === null || planes.length === 0 || renderingShadows && !clipShadows) {
            // there's no local clipping
            if (renderingShadows) // there's no global clipping
            projectPlanes(null);
            else resetGlobalState();
        } else {
            const nGlobal = renderingShadows ? 0 : numGlobalPlanes, lGlobal = nGlobal * 4;
            let dstArray = materialProperties.clippingState || null;
            uniform.value = dstArray; // ensure unique state
            dstArray = projectPlanes(planes, camera, lGlobal, useCache);
            for(let i = 0; i !== lGlobal; ++i)dstArray[i] = globalState[i];
            materialProperties.clippingState = dstArray;
            this.numIntersection = clipIntersection ? this.numPlanes : 0;
            this.numPlanes += nGlobal;
        }
    };
    function resetGlobalState() {
        if (uniform.value !== globalState) {
            uniform.value = globalState;
            uniform.needsUpdate = numGlobalPlanes > 0;
        }
        scope.numPlanes = numGlobalPlanes;
        scope.numIntersection = 0;
    }
    function projectPlanes(planes, camera, dstOffset, skipTransform) {
        const nPlanes = planes !== null ? planes.length : 0;
        let dstArray = null;
        if (nPlanes !== 0) {
            dstArray = uniform.value;
            if (skipTransform !== true || dstArray === null) {
                const flatSize = dstOffset + nPlanes * 4, viewMatrix = camera.matrixWorldInverse;
                viewNormalMatrix.getNormalMatrix(viewMatrix);
                if (dstArray === null || dstArray.length < flatSize) dstArray = new Float32Array(flatSize);
                for(let i = 0, i4 = dstOffset; i !== nPlanes; ++i, i4 += 4){
                    plane.copy(planes[i]).applyMatrix4(viewMatrix, viewNormalMatrix);
                    plane.normal.toArray(dstArray, i4);
                    dstArray[i4 + 3] = plane.constant;
                }
            }
            uniform.value = dstArray;
            uniform.needsUpdate = true;
        }
        scope.numPlanes = nPlanes;
        scope.numIntersection = 0;
        return dstArray;
    }
}
function $d5b33d7c30034067$var$WebGLCubeMaps(renderer) {
    let cubemaps = new WeakMap();
    function mapTextureMapping(texture, mapping) {
        if (mapping === (0, $dyjou.EquirectangularReflectionMapping)) texture.mapping = (0, $dyjou.CubeReflectionMapping);
        else if (mapping === (0, $dyjou.EquirectangularRefractionMapping)) texture.mapping = (0, $dyjou.CubeRefractionMapping);
        return texture;
    }
    function get(texture) {
        if (texture && texture.isTexture) {
            const mapping = texture.mapping;
            if (mapping === (0, $dyjou.EquirectangularReflectionMapping) || mapping === (0, $dyjou.EquirectangularRefractionMapping)) {
                if (cubemaps.has(texture)) {
                    const cubemap = cubemaps.get(texture).texture;
                    return mapTextureMapping(cubemap, texture.mapping);
                } else {
                    const image = texture.image;
                    if (image && image.height > 0) {
                        const renderTarget = new (0, $dyjou.WebGLCubeRenderTarget)(image.height);
                        renderTarget.fromEquirectangularTexture(renderer, texture);
                        cubemaps.set(texture, renderTarget);
                        texture.addEventListener('dispose', onTextureDispose);
                        return mapTextureMapping(renderTarget.texture, texture.mapping);
                    } else // image not yet ready. try the conversion next frame
                    return null;
                }
            }
        }
        return texture;
    }
    function onTextureDispose(event) {
        const texture = event.target;
        texture.removeEventListener('dispose', onTextureDispose);
        const cubemap = cubemaps.get(texture);
        if (cubemap !== undefined) {
            cubemaps.delete(texture);
            cubemap.dispose();
        }
    }
    function dispose() {
        cubemaps = new WeakMap();
    }
    return {
        get: get,
        dispose: dispose
    };
}
const $d5b33d7c30034067$var$LOD_MIN = 4;
// The standard deviations (radians) associated with the extra mips. These are
// chosen to approximate a Trowbridge-Reitz distribution function times the
// geometric shadowing function. These sigma values squared must match the
// variance #defines in cube_uv_reflection_fragment.glsl.js.
const $d5b33d7c30034067$var$EXTRA_LOD_SIGMA = [
    0.125,
    0.215,
    0.35,
    0.446,
    0.526,
    0.582
];
// The maximum length of the blur for loop. Smaller sigmas will use fewer
// samples and exit early, but not recompile the shader.
const $d5b33d7c30034067$var$MAX_SAMPLES = 20;
const $d5b33d7c30034067$var$_flatCamera = /*@__PURE__*/ new (0, $dyjou.OrthographicCamera)();
const $d5b33d7c30034067$var$_clearColor = /*@__PURE__*/ new (0, $dyjou.Color)();
let $d5b33d7c30034067$var$_oldTarget = null;
let $d5b33d7c30034067$var$_oldActiveCubeFace = 0;
let $d5b33d7c30034067$var$_oldActiveMipmapLevel = 0;
let $d5b33d7c30034067$var$_oldXrEnabled = false;
// Golden Ratio
const $d5b33d7c30034067$var$PHI = (1 + Math.sqrt(5)) / 2;
const $d5b33d7c30034067$var$INV_PHI = 1 / $d5b33d7c30034067$var$PHI;
// Vertices of a dodecahedron (except the opposites, which represent the
// same axis), used as axis directions evenly spread on a sphere.
const $d5b33d7c30034067$var$_axisDirections = [
    /*@__PURE__*/ new (0, $dyjou.Vector3)(-$d5b33d7c30034067$var$PHI, $d5b33d7c30034067$var$INV_PHI, 0),
    /*@__PURE__*/ new (0, $dyjou.Vector3)($d5b33d7c30034067$var$PHI, $d5b33d7c30034067$var$INV_PHI, 0),
    /*@__PURE__*/ new (0, $dyjou.Vector3)(-$d5b33d7c30034067$var$INV_PHI, 0, $d5b33d7c30034067$var$PHI),
    /*@__PURE__*/ new (0, $dyjou.Vector3)($d5b33d7c30034067$var$INV_PHI, 0, $d5b33d7c30034067$var$PHI),
    /*@__PURE__*/ new (0, $dyjou.Vector3)(0, $d5b33d7c30034067$var$PHI, -$d5b33d7c30034067$var$INV_PHI),
    /*@__PURE__*/ new (0, $dyjou.Vector3)(0, $d5b33d7c30034067$var$PHI, $d5b33d7c30034067$var$INV_PHI),
    /*@__PURE__*/ new (0, $dyjou.Vector3)(-1, 1, -1),
    /*@__PURE__*/ new (0, $dyjou.Vector3)(1, 1, -1),
    /*@__PURE__*/ new (0, $dyjou.Vector3)(-1, 1, 1),
    /*@__PURE__*/ new (0, $dyjou.Vector3)(1, 1, 1)
];
const $d5b33d7c30034067$var$_origin = /*@__PURE__*/ new (0, $dyjou.Vector3)();
/**
 * This class generates a Prefiltered, Mipmapped Radiance Environment Map
 * (PMREM) from a cubeMap environment texture. This allows different levels of
 * blur to be quickly accessed based on material roughness. It is packed into a
 * special CubeUV format that allows us to perform custom interpolation so that
 * we can support nonlinear formats such as RGBE. Unlike a traditional mipmap
 * chain, it only goes down to the LOD_MIN level (above), and then creates extra
 * even more filtered 'mips' at the same LOD_MIN resolution, associated with
 * higher roughness levels. In this way we maintain resolution to smoothly
 * interpolate diffuse lighting while limiting sampling computation.
 *
 * Paper: Fast, Accurate Image-Based Lighting:
 * {@link https://drive.google.com/file/d/15y8r_UpKlU9SvV4ILb0C3qCPecS8pvLz/view}
*/ class $d5b33d7c30034067$export$6add42717753e221 {
    /**
	 * Constructs a new PMREM generator.
	 *
	 * @param {WebGLRenderer} renderer - The renderer.
	 */ constructor(renderer){
        this._renderer = renderer;
        this._pingPongRenderTarget = null;
        this._lodMax = 0;
        this._cubeSize = 0;
        this._lodPlanes = [];
        this._sizeLods = [];
        this._sigmas = [];
        this._blurMaterial = null;
        this._cubemapMaterial = null;
        this._equirectMaterial = null;
        this._compileMaterial(this._blurMaterial);
    }
    /**
	 * Generates a PMREM from a supplied Scene, which can be faster than using an
	 * image if networking bandwidth is low. Optional sigma specifies a blur radius
	 * in radians to be applied to the scene before PMREM generation. Optional near
	 * and far planes ensure the scene is rendered in its entirety.
	 *
	 * @param {Scene} scene - The scene to be captured.
	 * @param {number} [sigma=0] - The blur radius in radians.
	 * @param {number} [near=0.1] - The near plane distance.
	 * @param {number} [far=100] - The far plane distance.
	 * @param {Object} [options={}] - The configuration options.
	 * @param {number} [options.size=256] - The texture size of the PMREM.
	 * @param {Vector3} [options.renderTarget=origin] - The position of the internal cube camera that renders the scene.
	 * @return {WebGLRenderTarget} The resulting PMREM.
	 */ fromScene(scene, sigma = 0, near = 0.1, far = 100, options = {}) {
        const { size: size = 256, position: position = $d5b33d7c30034067$var$_origin } = options;
        $d5b33d7c30034067$var$_oldTarget = this._renderer.getRenderTarget();
        $d5b33d7c30034067$var$_oldActiveCubeFace = this._renderer.getActiveCubeFace();
        $d5b33d7c30034067$var$_oldActiveMipmapLevel = this._renderer.getActiveMipmapLevel();
        $d5b33d7c30034067$var$_oldXrEnabled = this._renderer.xr.enabled;
        this._renderer.xr.enabled = false;
        this._setSize(size);
        const cubeUVRenderTarget = this._allocateTargets();
        cubeUVRenderTarget.depthBuffer = true;
        this._sceneToCubeUV(scene, near, far, cubeUVRenderTarget, position);
        if (sigma > 0) this._blur(cubeUVRenderTarget, 0, 0, sigma);
        this._applyPMREM(cubeUVRenderTarget);
        this._cleanup(cubeUVRenderTarget);
        return cubeUVRenderTarget;
    }
    /**
	 * Generates a PMREM from an equirectangular texture, which can be either LDR
	 * or HDR. The ideal input image size is 1k (1024 x 512),
	 * as this matches best with the 256 x 256 cubemap output.
	 *
	 * @param {Texture} equirectangular - The equirectangular texture to be converted.
	 * @param {?WebGLRenderTarget} [renderTarget=null] - The render target to use.
	 * @return {WebGLRenderTarget} The resulting PMREM.
	 */ fromEquirectangular(equirectangular, renderTarget = null) {
        return this._fromTexture(equirectangular, renderTarget);
    }
    /**
	 * Generates a PMREM from an cubemap texture, which can be either LDR
	 * or HDR. The ideal input cube size is 256 x 256,
	 * as this matches best with the 256 x 256 cubemap output.
	 *
	 * @param {Texture} cubemap - The cubemap texture to be converted.
	 * @param {?WebGLRenderTarget} [renderTarget=null] - The render target to use.
	 * @return {WebGLRenderTarget} The resulting PMREM.
	 */ fromCubemap(cubemap, renderTarget = null) {
        return this._fromTexture(cubemap, renderTarget);
    }
    /**
	 * Pre-compiles the cubemap shader. You can get faster start-up by invoking this method during
	 * your texture's network fetch for increased concurrency.
	 */ compileCubemapShader() {
        if (this._cubemapMaterial === null) {
            this._cubemapMaterial = $d5b33d7c30034067$var$_getCubemapMaterial();
            this._compileMaterial(this._cubemapMaterial);
        }
    }
    /**
	 * Pre-compiles the equirectangular shader. You can get faster start-up by invoking this method during
	 * your texture's network fetch for increased concurrency.
	 */ compileEquirectangularShader() {
        if (this._equirectMaterial === null) {
            this._equirectMaterial = $d5b33d7c30034067$var$_getEquirectMaterial();
            this._compileMaterial(this._equirectMaterial);
        }
    }
    /**
	 * Disposes of the PMREMGenerator's internal memory. Note that PMREMGenerator is a static class,
	 * so you should not need more than one PMREMGenerator object. If you do, calling dispose() on
	 * one of them will cause any others to also become unusable.
	 */ dispose() {
        this._dispose();
        if (this._cubemapMaterial !== null) this._cubemapMaterial.dispose();
        if (this._equirectMaterial !== null) this._equirectMaterial.dispose();
    }
    // private interface
    _setSize(cubeSize) {
        this._lodMax = Math.floor(Math.log2(cubeSize));
        this._cubeSize = Math.pow(2, this._lodMax);
    }
    _dispose() {
        if (this._blurMaterial !== null) this._blurMaterial.dispose();
        if (this._pingPongRenderTarget !== null) this._pingPongRenderTarget.dispose();
        for(let i = 0; i < this._lodPlanes.length; i++)this._lodPlanes[i].dispose();
    }
    _cleanup(outputTarget) {
        this._renderer.setRenderTarget($d5b33d7c30034067$var$_oldTarget, $d5b33d7c30034067$var$_oldActiveCubeFace, $d5b33d7c30034067$var$_oldActiveMipmapLevel);
        this._renderer.xr.enabled = $d5b33d7c30034067$var$_oldXrEnabled;
        outputTarget.scissorTest = false;
        $d5b33d7c30034067$var$_setViewport(outputTarget, 0, 0, outputTarget.width, outputTarget.height);
    }
    _fromTexture(texture, renderTarget) {
        if (texture.mapping === (0, $dyjou.CubeReflectionMapping) || texture.mapping === (0, $dyjou.CubeRefractionMapping)) this._setSize(texture.image.length === 0 ? 16 : texture.image[0].width || texture.image[0].image.width);
        else this._setSize(texture.image.width / 4);
        $d5b33d7c30034067$var$_oldTarget = this._renderer.getRenderTarget();
        $d5b33d7c30034067$var$_oldActiveCubeFace = this._renderer.getActiveCubeFace();
        $d5b33d7c30034067$var$_oldActiveMipmapLevel = this._renderer.getActiveMipmapLevel();
        $d5b33d7c30034067$var$_oldXrEnabled = this._renderer.xr.enabled;
        this._renderer.xr.enabled = false;
        const cubeUVRenderTarget = renderTarget || this._allocateTargets();
        this._textureToCubeUV(texture, cubeUVRenderTarget);
        this._applyPMREM(cubeUVRenderTarget);
        this._cleanup(cubeUVRenderTarget);
        return cubeUVRenderTarget;
    }
    _allocateTargets() {
        const width = 3 * Math.max(this._cubeSize, 112);
        const height = 4 * this._cubeSize;
        const params = {
            magFilter: (0, $dyjou.LinearFilter),
            minFilter: (0, $dyjou.LinearFilter),
            generateMipmaps: false,
            type: (0, $dyjou.HalfFloatType),
            format: (0, $dyjou.RGBAFormat),
            colorSpace: (0, $dyjou.LinearSRGBColorSpace),
            depthBuffer: false
        };
        const cubeUVRenderTarget = $d5b33d7c30034067$var$_createRenderTarget(width, height, params);
        if (this._pingPongRenderTarget === null || this._pingPongRenderTarget.width !== width || this._pingPongRenderTarget.height !== height) {
            if (this._pingPongRenderTarget !== null) this._dispose();
            this._pingPongRenderTarget = $d5b33d7c30034067$var$_createRenderTarget(width, height, params);
            const { _lodMax: _lodMax } = this;
            ({ sizeLods: this._sizeLods, lodPlanes: this._lodPlanes, sigmas: this._sigmas } = $d5b33d7c30034067$var$_createPlanes(_lodMax));
            this._blurMaterial = $d5b33d7c30034067$var$_getBlurShader(_lodMax, width, height);
        }
        return cubeUVRenderTarget;
    }
    _compileMaterial(material) {
        const tmpMesh = new (0, $dyjou.Mesh)(this._lodPlanes[0], material);
        this._renderer.compile(tmpMesh, $d5b33d7c30034067$var$_flatCamera);
    }
    _sceneToCubeUV(scene, near, far, cubeUVRenderTarget, position) {
        const fov = 90;
        const aspect = 1;
        const cubeCamera = new (0, $dyjou.PerspectiveCamera)(fov, aspect, near, far);
        const upSign = [
            1,
            -1,
            1,
            1,
            1,
            1
        ];
        const forwardSign = [
            1,
            1,
            1,
            -1,
            -1,
            -1
        ];
        const renderer = this._renderer;
        const originalAutoClear = renderer.autoClear;
        const toneMapping = renderer.toneMapping;
        renderer.getClearColor($d5b33d7c30034067$var$_clearColor);
        renderer.toneMapping = (0, $dyjou.NoToneMapping);
        renderer.autoClear = false;
        const backgroundMaterial = new (0, $dyjou.MeshBasicMaterial)({
            name: 'PMREM.Background',
            side: (0, $dyjou.BackSide),
            depthWrite: false,
            depthTest: false
        });
        const backgroundBox = new (0, $dyjou.Mesh)(new (0, $dyjou.BoxGeometry)(), backgroundMaterial);
        let useSolidColor = false;
        const background = scene.background;
        if (background) {
            if (background.isColor) {
                backgroundMaterial.color.copy(background);
                scene.background = null;
                useSolidColor = true;
            }
        } else {
            backgroundMaterial.color.copy($d5b33d7c30034067$var$_clearColor);
            useSolidColor = true;
        }
        for(let i = 0; i < 6; i++){
            const col = i % 3;
            if (col === 0) {
                cubeCamera.up.set(0, upSign[i], 0);
                cubeCamera.position.set(position.x, position.y, position.z);
                cubeCamera.lookAt(position.x + forwardSign[i], position.y, position.z);
            } else if (col === 1) {
                cubeCamera.up.set(0, 0, upSign[i]);
                cubeCamera.position.set(position.x, position.y, position.z);
                cubeCamera.lookAt(position.x, position.y + forwardSign[i], position.z);
            } else {
                cubeCamera.up.set(0, upSign[i], 0);
                cubeCamera.position.set(position.x, position.y, position.z);
                cubeCamera.lookAt(position.x, position.y, position.z + forwardSign[i]);
            }
            const size = this._cubeSize;
            $d5b33d7c30034067$var$_setViewport(cubeUVRenderTarget, col * size, i > 2 ? size : 0, size, size);
            renderer.setRenderTarget(cubeUVRenderTarget);
            if (useSolidColor) renderer.render(backgroundBox, cubeCamera);
            renderer.render(scene, cubeCamera);
        }
        backgroundBox.geometry.dispose();
        backgroundBox.material.dispose();
        renderer.toneMapping = toneMapping;
        renderer.autoClear = originalAutoClear;
        scene.background = background;
    }
    _textureToCubeUV(texture, cubeUVRenderTarget) {
        const renderer = this._renderer;
        const isCubeTexture = texture.mapping === (0, $dyjou.CubeReflectionMapping) || texture.mapping === (0, $dyjou.CubeRefractionMapping);
        if (isCubeTexture) {
            if (this._cubemapMaterial === null) this._cubemapMaterial = $d5b33d7c30034067$var$_getCubemapMaterial();
            this._cubemapMaterial.uniforms.flipEnvMap.value = texture.isRenderTargetTexture === false ? -1 : 1;
        } else if (this._equirectMaterial === null) this._equirectMaterial = $d5b33d7c30034067$var$_getEquirectMaterial();
        const material = isCubeTexture ? this._cubemapMaterial : this._equirectMaterial;
        const mesh = new (0, $dyjou.Mesh)(this._lodPlanes[0], material);
        const uniforms = material.uniforms;
        uniforms['envMap'].value = texture;
        const size = this._cubeSize;
        $d5b33d7c30034067$var$_setViewport(cubeUVRenderTarget, 0, 0, 3 * size, 2 * size);
        renderer.setRenderTarget(cubeUVRenderTarget);
        renderer.render(mesh, $d5b33d7c30034067$var$_flatCamera);
    }
    _applyPMREM(cubeUVRenderTarget) {
        const renderer = this._renderer;
        const autoClear = renderer.autoClear;
        renderer.autoClear = false;
        const n = this._lodPlanes.length;
        for(let i = 1; i < n; i++){
            const sigma = Math.sqrt(this._sigmas[i] * this._sigmas[i] - this._sigmas[i - 1] * this._sigmas[i - 1]);
            const poleAxis = $d5b33d7c30034067$var$_axisDirections[(n - i - 1) % $d5b33d7c30034067$var$_axisDirections.length];
            this._blur(cubeUVRenderTarget, i - 1, i, sigma, poleAxis);
        }
        renderer.autoClear = autoClear;
    }
    /**
	 * This is a two-pass Gaussian blur for a cubemap. Normally this is done
	 * vertically and horizontally, but this breaks down on a cube. Here we apply
	 * the blur latitudinally (around the poles), and then longitudinally (towards
	 * the poles) to approximate the orthogonally-separable blur. It is least
	 * accurate at the poles, but still does a decent job.
	 *
	 * @private
	 * @param {WebGLRenderTarget} cubeUVRenderTarget
	 * @param {number} lodIn
	 * @param {number} lodOut
	 * @param {number} sigma
	 * @param {Vector3} [poleAxis]
	 */ _blur(cubeUVRenderTarget, lodIn, lodOut, sigma, poleAxis) {
        const pingPongRenderTarget = this._pingPongRenderTarget;
        this._halfBlur(cubeUVRenderTarget, pingPongRenderTarget, lodIn, lodOut, sigma, 'latitudinal', poleAxis);
        this._halfBlur(pingPongRenderTarget, cubeUVRenderTarget, lodOut, lodOut, sigma, 'longitudinal', poleAxis);
    }
    _halfBlur(targetIn, targetOut, lodIn, lodOut, sigmaRadians, direction, poleAxis) {
        const renderer = this._renderer;
        const blurMaterial = this._blurMaterial;
        if (direction !== 'latitudinal' && direction !== 'longitudinal') console.error('blur direction must be either latitudinal or longitudinal!');
        // Number of standard deviations at which to cut off the discrete approximation.
        const STANDARD_DEVIATIONS = 3;
        const blurMesh = new (0, $dyjou.Mesh)(this._lodPlanes[lodOut], blurMaterial);
        const blurUniforms = blurMaterial.uniforms;
        const pixels = this._sizeLods[lodIn] - 1;
        const radiansPerPixel = isFinite(sigmaRadians) ? Math.PI / (2 * pixels) : 2 * Math.PI / (2 * $d5b33d7c30034067$var$MAX_SAMPLES - 1);
        const sigmaPixels = sigmaRadians / radiansPerPixel;
        const samples = isFinite(sigmaRadians) ? 1 + Math.floor(STANDARD_DEVIATIONS * sigmaPixels) : $d5b33d7c30034067$var$MAX_SAMPLES;
        if (samples > $d5b33d7c30034067$var$MAX_SAMPLES) console.warn(`sigmaRadians, ${sigmaRadians}, is too large and will clip, as it requested ${samples} samples when the maximum is set to ${$d5b33d7c30034067$var$MAX_SAMPLES}`);
        const weights = [];
        let sum = 0;
        for(let i = 0; i < $d5b33d7c30034067$var$MAX_SAMPLES; ++i){
            const x = i / sigmaPixels;
            const weight = Math.exp(-x * x / 2);
            weights.push(weight);
            if (i === 0) sum += weight;
            else if (i < samples) sum += 2 * weight;
        }
        for(let i = 0; i < weights.length; i++)weights[i] = weights[i] / sum;
        blurUniforms['envMap'].value = targetIn.texture;
        blurUniforms['samples'].value = samples;
        blurUniforms['weights'].value = weights;
        blurUniforms['latitudinal'].value = direction === 'latitudinal';
        if (poleAxis) blurUniforms['poleAxis'].value = poleAxis;
        const { _lodMax: _lodMax } = this;
        blurUniforms['dTheta'].value = radiansPerPixel;
        blurUniforms['mipInt'].value = _lodMax - lodIn;
        const outputSize = this._sizeLods[lodOut];
        const x = 3 * outputSize * (lodOut > _lodMax - $d5b33d7c30034067$var$LOD_MIN ? lodOut - _lodMax + $d5b33d7c30034067$var$LOD_MIN : 0);
        const y = 4 * (this._cubeSize - outputSize);
        $d5b33d7c30034067$var$_setViewport(targetOut, x, y, 3 * outputSize, 2 * outputSize);
        renderer.setRenderTarget(targetOut);
        renderer.render(blurMesh, $d5b33d7c30034067$var$_flatCamera);
    }
}
function $d5b33d7c30034067$var$_createPlanes(lodMax) {
    const lodPlanes = [];
    const sizeLods = [];
    const sigmas = [];
    let lod = lodMax;
    const totalLods = lodMax - $d5b33d7c30034067$var$LOD_MIN + 1 + $d5b33d7c30034067$var$EXTRA_LOD_SIGMA.length;
    for(let i = 0; i < totalLods; i++){
        const sizeLod = Math.pow(2, lod);
        sizeLods.push(sizeLod);
        let sigma = 1.0 / sizeLod;
        if (i > lodMax - $d5b33d7c30034067$var$LOD_MIN) sigma = $d5b33d7c30034067$var$EXTRA_LOD_SIGMA[i - lodMax + $d5b33d7c30034067$var$LOD_MIN - 1];
        else if (i === 0) sigma = 0;
        sigmas.push(sigma);
        const texelSize = 1.0 / (sizeLod - 2);
        const min = -texelSize;
        const max = 1 + texelSize;
        const uv1 = [
            min,
            min,
            max,
            min,
            max,
            max,
            min,
            min,
            max,
            max,
            min,
            max
        ];
        const cubeFaces = 6;
        const vertices = 6;
        const positionSize = 3;
        const uvSize = 2;
        const faceIndexSize = 1;
        const position = new Float32Array(positionSize * vertices * cubeFaces);
        const uv = new Float32Array(uvSize * vertices * cubeFaces);
        const faceIndex = new Float32Array(faceIndexSize * vertices * cubeFaces);
        for(let face = 0; face < cubeFaces; face++){
            const x = face % 3 * 2 / 3 - 1;
            const y = face > 2 ? 0 : -1;
            const coordinates = [
                x,
                y,
                0,
                x + 2 / 3,
                y,
                0,
                x + 2 / 3,
                y + 1,
                0,
                x,
                y,
                0,
                x + 2 / 3,
                y + 1,
                0,
                x,
                y + 1,
                0
            ];
            position.set(coordinates, positionSize * vertices * face);
            uv.set(uv1, uvSize * vertices * face);
            const fill = [
                face,
                face,
                face,
                face,
                face,
                face
            ];
            faceIndex.set(fill, faceIndexSize * vertices * face);
        }
        const planes = new (0, $dyjou.BufferGeometry)();
        planes.setAttribute('position', new (0, $dyjou.BufferAttribute)(position, positionSize));
        planes.setAttribute('uv', new (0, $dyjou.BufferAttribute)(uv, uvSize));
        planes.setAttribute('faceIndex', new (0, $dyjou.BufferAttribute)(faceIndex, faceIndexSize));
        lodPlanes.push(planes);
        if (lod > $d5b33d7c30034067$var$LOD_MIN) lod--;
    }
    return {
        lodPlanes: lodPlanes,
        sizeLods: sizeLods,
        sigmas: sigmas
    };
}
function $d5b33d7c30034067$var$_createRenderTarget(width, height, params) {
    const cubeUVRenderTarget = new (0, $dyjou.WebGLRenderTarget)(width, height, params);
    cubeUVRenderTarget.texture.mapping = (0, $dyjou.CubeUVReflectionMapping);
    cubeUVRenderTarget.texture.name = 'PMREM.cubeUv';
    cubeUVRenderTarget.scissorTest = true;
    return cubeUVRenderTarget;
}
function $d5b33d7c30034067$var$_setViewport(target, x, y, width, height) {
    target.viewport.set(x, y, width, height);
    target.scissor.set(x, y, width, height);
}
function $d5b33d7c30034067$var$_getBlurShader(lodMax, width, height) {
    const weights = new Float32Array($d5b33d7c30034067$var$MAX_SAMPLES);
    const poleAxis = new (0, $dyjou.Vector3)(0, 1, 0);
    const shaderMaterial = new (0, $dyjou.ShaderMaterial)({
        name: 'SphericalGaussianBlur',
        defines: {
            'n': $d5b33d7c30034067$var$MAX_SAMPLES,
            'CUBEUV_TEXEL_WIDTH': 1.0 / width,
            'CUBEUV_TEXEL_HEIGHT': 1.0 / height,
            'CUBEUV_MAX_MIP': `${lodMax}.0`
        },
        uniforms: {
            'envMap': {
                value: null
            },
            'samples': {
                value: 1
            },
            'weights': {
                value: weights
            },
            'latitudinal': {
                value: false
            },
            'dTheta': {
                value: 0
            },
            'mipInt': {
                value: 0
            },
            'poleAxis': {
                value: poleAxis
            }
        },
        vertexShader: $d5b33d7c30034067$var$_getCommonVertexShader(),
        fragmentShader: /* glsl */ `

			precision mediump float;
			precision mediump int;

			varying vec3 vOutputDirection;

			uniform sampler2D envMap;
			uniform int samples;
			uniform float weights[ n ];
			uniform bool latitudinal;
			uniform float dTheta;
			uniform float mipInt;
			uniform vec3 poleAxis;

			#define ENVMAP_TYPE_CUBE_UV
			#include <cube_uv_reflection_fragment>

			vec3 getSample( float theta, vec3 axis ) {

				float cosTheta = cos( theta );
				// Rodrigues' axis-angle rotation
				vec3 sampleDirection = vOutputDirection * cosTheta
					+ cross( axis, vOutputDirection ) * sin( theta )
					+ axis * dot( axis, vOutputDirection ) * ( 1.0 - cosTheta );

				return bilinearCubeUV( envMap, sampleDirection, mipInt );

			}

			void main() {

				vec3 axis = latitudinal ? poleAxis : cross( poleAxis, vOutputDirection );

				if ( all( equal( axis, vec3( 0.0 ) ) ) ) {

					axis = vec3( vOutputDirection.z, 0.0, - vOutputDirection.x );

				}

				axis = normalize( axis );

				gl_FragColor = vec4( 0.0, 0.0, 0.0, 1.0 );
				gl_FragColor.rgb += weights[ 0 ] * getSample( 0.0, axis );

				for ( int i = 1; i < n; i++ ) {

					if ( i >= samples ) {

						break;

					}

					float theta = dTheta * float( i );
					gl_FragColor.rgb += weights[ i ] * getSample( -1.0 * theta, axis );
					gl_FragColor.rgb += weights[ i ] * getSample( theta, axis );

				}

			}
		`,
        blending: (0, $dyjou.NoBlending),
        depthTest: false,
        depthWrite: false
    });
    return shaderMaterial;
}
function $d5b33d7c30034067$var$_getEquirectMaterial() {
    return new (0, $dyjou.ShaderMaterial)({
        name: 'EquirectangularToCubeUV',
        uniforms: {
            'envMap': {
                value: null
            }
        },
        vertexShader: $d5b33d7c30034067$var$_getCommonVertexShader(),
        fragmentShader: /* glsl */ `

			precision mediump float;
			precision mediump int;

			varying vec3 vOutputDirection;

			uniform sampler2D envMap;

			#include <common>

			void main() {

				vec3 outputDirection = normalize( vOutputDirection );
				vec2 uv = equirectUv( outputDirection );

				gl_FragColor = vec4( texture2D ( envMap, uv ).rgb, 1.0 );

			}
		`,
        blending: (0, $dyjou.NoBlending),
        depthTest: false,
        depthWrite: false
    });
}
function $d5b33d7c30034067$var$_getCubemapMaterial() {
    return new (0, $dyjou.ShaderMaterial)({
        name: 'CubemapToCubeUV',
        uniforms: {
            'envMap': {
                value: null
            },
            'flipEnvMap': {
                value: -1
            }
        },
        vertexShader: $d5b33d7c30034067$var$_getCommonVertexShader(),
        fragmentShader: /* glsl */ `

			precision mediump float;
			precision mediump int;

			uniform float flipEnvMap;

			varying vec3 vOutputDirection;

			uniform samplerCube envMap;

			void main() {

				gl_FragColor = textureCube( envMap, vec3( flipEnvMap * vOutputDirection.x, vOutputDirection.yz ) );

			}
		`,
        blending: (0, $dyjou.NoBlending),
        depthTest: false,
        depthWrite: false
    });
}
function $d5b33d7c30034067$var$_getCommonVertexShader() {
    return /* glsl */ `

		precision mediump float;
		precision mediump int;

		attribute float faceIndex;

		varying vec3 vOutputDirection;

		// RH coordinate system; PMREM face-indexing convention
		vec3 getDirection( vec2 uv, float face ) {

			uv = 2.0 * uv - 1.0;

			vec3 direction = vec3( uv, 1.0 );

			if ( face == 0.0 ) {

				direction = direction.zyx; // ( 1, v, u ) pos x

			} else if ( face == 1.0 ) {

				direction = direction.xzy;
				direction.xz *= -1.0; // ( -u, 1, -v ) pos y

			} else if ( face == 2.0 ) {

				direction.x *= -1.0; // ( -u, v, 1 ) pos z

			} else if ( face == 3.0 ) {

				direction = direction.zyx;
				direction.xz *= -1.0; // ( -1, v, -u ) neg x

			} else if ( face == 4.0 ) {

				direction = direction.xzy;
				direction.xy *= -1.0; // ( -u, -1, v ) neg y

			} else if ( face == 5.0 ) {

				direction.z *= -1.0; // ( u, v, -1 ) neg z

			}

			return direction;

		}

		void main() {

			vOutputDirection = getDirection( uv, faceIndex );
			gl_Position = vec4( position, 1.0 );

		}
	`;
}
function $d5b33d7c30034067$var$WebGLCubeUVMaps(renderer) {
    let cubeUVmaps = new WeakMap();
    let pmremGenerator = null;
    function get(texture) {
        if (texture && texture.isTexture) {
            const mapping = texture.mapping;
            const isEquirectMap = mapping === (0, $dyjou.EquirectangularReflectionMapping) || mapping === (0, $dyjou.EquirectangularRefractionMapping);
            const isCubeMap = mapping === (0, $dyjou.CubeReflectionMapping) || mapping === (0, $dyjou.CubeRefractionMapping);
            // equirect/cube map to cubeUV conversion
            if (isEquirectMap || isCubeMap) {
                let renderTarget = cubeUVmaps.get(texture);
                const currentPMREMVersion = renderTarget !== undefined ? renderTarget.texture.pmremVersion : 0;
                if (texture.isRenderTargetTexture && texture.pmremVersion !== currentPMREMVersion) {
                    if (pmremGenerator === null) pmremGenerator = new $d5b33d7c30034067$export$6add42717753e221(renderer);
                    renderTarget = isEquirectMap ? pmremGenerator.fromEquirectangular(texture, renderTarget) : pmremGenerator.fromCubemap(texture, renderTarget);
                    renderTarget.texture.pmremVersion = texture.pmremVersion;
                    cubeUVmaps.set(texture, renderTarget);
                    return renderTarget.texture;
                } else {
                    if (renderTarget !== undefined) return renderTarget.texture;
                    else {
                        const image = texture.image;
                        if (isEquirectMap && image && image.height > 0 || isCubeMap && image && isCubeTextureComplete(image)) {
                            if (pmremGenerator === null) pmremGenerator = new $d5b33d7c30034067$export$6add42717753e221(renderer);
                            renderTarget = isEquirectMap ? pmremGenerator.fromEquirectangular(texture) : pmremGenerator.fromCubemap(texture);
                            renderTarget.texture.pmremVersion = texture.pmremVersion;
                            cubeUVmaps.set(texture, renderTarget);
                            texture.addEventListener('dispose', onTextureDispose);
                            return renderTarget.texture;
                        } else // image not yet ready. try the conversion next frame
                        return null;
                    }
                }
            }
        }
        return texture;
    }
    function isCubeTextureComplete(image) {
        let count = 0;
        const length = 6;
        for(let i = 0; i < length; i++)if (image[i] !== undefined) count++;
        return count === length;
    }
    function onTextureDispose(event) {
        const texture = event.target;
        texture.removeEventListener('dispose', onTextureDispose);
        const cubemapUV = cubeUVmaps.get(texture);
        if (cubemapUV !== undefined) {
            cubeUVmaps.delete(texture);
            cubemapUV.dispose();
        }
    }
    function dispose() {
        cubeUVmaps = new WeakMap();
        if (pmremGenerator !== null) {
            pmremGenerator.dispose();
            pmremGenerator = null;
        }
    }
    return {
        get: get,
        dispose: dispose
    };
}
function $d5b33d7c30034067$var$WebGLExtensions(gl) {
    const extensions = {};
    function getExtension(name) {
        if (extensions[name] !== undefined) return extensions[name];
        let extension;
        switch(name){
            case 'WEBGL_depth_texture':
                extension = gl.getExtension('WEBGL_depth_texture') || gl.getExtension('MOZ_WEBGL_depth_texture') || gl.getExtension('WEBKIT_WEBGL_depth_texture');
                break;
            case 'EXT_texture_filter_anisotropic':
                extension = gl.getExtension('EXT_texture_filter_anisotropic') || gl.getExtension('MOZ_EXT_texture_filter_anisotropic') || gl.getExtension('WEBKIT_EXT_texture_filter_anisotropic');
                break;
            case 'WEBGL_compressed_texture_s3tc':
                extension = gl.getExtension('WEBGL_compressed_texture_s3tc') || gl.getExtension('MOZ_WEBGL_compressed_texture_s3tc') || gl.getExtension('WEBKIT_WEBGL_compressed_texture_s3tc');
                break;
            case 'WEBGL_compressed_texture_pvrtc':
                extension = gl.getExtension('WEBGL_compressed_texture_pvrtc') || gl.getExtension('WEBKIT_WEBGL_compressed_texture_pvrtc');
                break;
            default:
                extension = gl.getExtension(name);
        }
        extensions[name] = extension;
        return extension;
    }
    return {
        has: function(name) {
            return getExtension(name) !== null;
        },
        init: function() {
            getExtension('EXT_color_buffer_float');
            getExtension('WEBGL_clip_cull_distance');
            getExtension('OES_texture_float_linear');
            getExtension('EXT_color_buffer_half_float');
            getExtension('WEBGL_multisampled_render_to_texture');
            getExtension('WEBGL_render_shared_exponent');
        },
        get: function(name) {
            const extension = getExtension(name);
            if (extension === null) (0, $dyjou.warnOnce)('THREE.WebGLRenderer: ' + name + ' extension not supported.');
            return extension;
        }
    };
}
function $d5b33d7c30034067$var$WebGLGeometries(gl, attributes, info, bindingStates) {
    const geometries = {};
    const wireframeAttributes = new WeakMap();
    function onGeometryDispose(event) {
        const geometry = event.target;
        if (geometry.index !== null) attributes.remove(geometry.index);
        for(const name in geometry.attributes)attributes.remove(geometry.attributes[name]);
        geometry.removeEventListener('dispose', onGeometryDispose);
        delete geometries[geometry.id];
        const attribute = wireframeAttributes.get(geometry);
        if (attribute) {
            attributes.remove(attribute);
            wireframeAttributes.delete(geometry);
        }
        bindingStates.releaseStatesOfGeometry(geometry);
        if (geometry.isInstancedBufferGeometry === true) delete geometry._maxInstanceCount;
        //
        info.memory.geometries--;
    }
    function get(object, geometry) {
        if (geometries[geometry.id] === true) return geometry;
        geometry.addEventListener('dispose', onGeometryDispose);
        geometries[geometry.id] = true;
        info.memory.geometries++;
        return geometry;
    }
    function update(geometry) {
        const geometryAttributes = geometry.attributes;
        // Updating index buffer in VAO now. See WebGLBindingStates.
        for(const name in geometryAttributes)attributes.update(geometryAttributes[name], gl.ARRAY_BUFFER);
    }
    function updateWireframeAttribute(geometry) {
        const indices = [];
        const geometryIndex = geometry.index;
        const geometryPosition = geometry.attributes.position;
        let version = 0;
        if (geometryIndex !== null) {
            const array = geometryIndex.array;
            version = geometryIndex.version;
            for(let i = 0, l = array.length; i < l; i += 3){
                const a = array[i + 0];
                const b = array[i + 1];
                const c = array[i + 2];
                indices.push(a, b, b, c, c, a);
            }
        } else if (geometryPosition !== undefined) {
            const array = geometryPosition.array;
            version = geometryPosition.version;
            for(let i = 0, l = array.length / 3 - 1; i < l; i += 3){
                const a = i + 0;
                const b = i + 1;
                const c = i + 2;
                indices.push(a, b, b, c, c, a);
            }
        } else return;
        const attribute = new ((0, $dyjou.arrayNeedsUint32)(indices) ? (0, $dyjou.Uint32BufferAttribute) : (0, $dyjou.Uint16BufferAttribute))(indices, 1);
        attribute.version = version;
        // Updating index buffer in VAO now. See WebGLBindingStates
        //
        const previousAttribute = wireframeAttributes.get(geometry);
        if (previousAttribute) attributes.remove(previousAttribute);
        //
        wireframeAttributes.set(geometry, attribute);
    }
    function getWireframeAttribute(geometry) {
        const currentAttribute = wireframeAttributes.get(geometry);
        if (currentAttribute) {
            const geometryIndex = geometry.index;
            if (geometryIndex !== null) // if the attribute is obsolete, create a new one
            {
                if (currentAttribute.version < geometryIndex.version) updateWireframeAttribute(geometry);
            }
        } else updateWireframeAttribute(geometry);
        return wireframeAttributes.get(geometry);
    }
    return {
        get: get,
        update: update,
        getWireframeAttribute: getWireframeAttribute
    };
}
function $d5b33d7c30034067$var$WebGLIndexedBufferRenderer(gl, extensions, info) {
    let mode;
    function setMode(value) {
        mode = value;
    }
    let type, bytesPerElement;
    function setIndex(value) {
        type = value.type;
        bytesPerElement = value.bytesPerElement;
    }
    function render(start, count) {
        gl.drawElements(mode, count, type, start * bytesPerElement);
        info.update(count, mode, 1);
    }
    function renderInstances(start, count, primcount) {
        if (primcount === 0) return;
        gl.drawElementsInstanced(mode, count, type, start * bytesPerElement, primcount);
        info.update(count, mode, primcount);
    }
    function renderMultiDraw(starts, counts, drawCount) {
        if (drawCount === 0) return;
        const extension = extensions.get('WEBGL_multi_draw');
        extension.multiDrawElementsWEBGL(mode, counts, 0, type, starts, 0, drawCount);
        let elementCount = 0;
        for(let i = 0; i < drawCount; i++)elementCount += counts[i];
        info.update(elementCount, mode, 1);
    }
    function renderMultiDrawInstances(starts, counts, drawCount, primcount) {
        if (drawCount === 0) return;
        const extension = extensions.get('WEBGL_multi_draw');
        if (extension === null) for(let i = 0; i < starts.length; i++)renderInstances(starts[i] / bytesPerElement, counts[i], primcount[i]);
        else {
            extension.multiDrawElementsInstancedWEBGL(mode, counts, 0, type, starts, 0, primcount, 0, drawCount);
            let elementCount = 0;
            for(let i = 0; i < drawCount; i++)elementCount += counts[i] * primcount[i];
            info.update(elementCount, mode, 1);
        }
    }
    //
    this.setMode = setMode;
    this.setIndex = setIndex;
    this.render = render;
    this.renderInstances = renderInstances;
    this.renderMultiDraw = renderMultiDraw;
    this.renderMultiDrawInstances = renderMultiDrawInstances;
}
function $d5b33d7c30034067$var$WebGLInfo(gl) {
    const memory = {
        geometries: 0,
        textures: 0
    };
    const render = {
        frame: 0,
        calls: 0,
        triangles: 0,
        points: 0,
        lines: 0
    };
    function update(count, mode, instanceCount) {
        render.calls++;
        switch(mode){
            case gl.TRIANGLES:
                render.triangles += instanceCount * (count / 3);
                break;
            case gl.LINES:
                render.lines += instanceCount * (count / 2);
                break;
            case gl.LINE_STRIP:
                render.lines += instanceCount * (count - 1);
                break;
            case gl.LINE_LOOP:
                render.lines += instanceCount * count;
                break;
            case gl.POINTS:
                render.points += instanceCount * count;
                break;
            default:
                console.error('THREE.WebGLInfo: Unknown draw mode:', mode);
                break;
        }
    }
    function reset() {
        render.calls = 0;
        render.triangles = 0;
        render.points = 0;
        render.lines = 0;
    }
    return {
        memory: memory,
        render: render,
        programs: null,
        autoReset: true,
        reset: reset,
        update: update
    };
}
function $d5b33d7c30034067$var$WebGLMorphtargets(gl, capabilities, textures) {
    const morphTextures = new WeakMap();
    const morph = new (0, $dyjou.Vector4)();
    function update(object, geometry, program) {
        const objectInfluences = object.morphTargetInfluences;
        // the following encodes morph targets into an array of data textures. Each layer represents a single morph target.
        const morphAttribute = geometry.morphAttributes.position || geometry.morphAttributes.normal || geometry.morphAttributes.color;
        const morphTargetsCount = morphAttribute !== undefined ? morphAttribute.length : 0;
        let entry = morphTextures.get(geometry);
        if (entry === undefined || entry.count !== morphTargetsCount) {
            if (entry !== undefined) entry.texture.dispose();
            const hasMorphPosition = geometry.morphAttributes.position !== undefined;
            const hasMorphNormals = geometry.morphAttributes.normal !== undefined;
            const hasMorphColors = geometry.morphAttributes.color !== undefined;
            const morphTargets = geometry.morphAttributes.position || [];
            const morphNormals = geometry.morphAttributes.normal || [];
            const morphColors = geometry.morphAttributes.color || [];
            let vertexDataCount = 0;
            if (hasMorphPosition === true) vertexDataCount = 1;
            if (hasMorphNormals === true) vertexDataCount = 2;
            if (hasMorphColors === true) vertexDataCount = 3;
            let width = geometry.attributes.position.count * vertexDataCount;
            let height = 1;
            if (width > capabilities.maxTextureSize) {
                height = Math.ceil(width / capabilities.maxTextureSize);
                width = capabilities.maxTextureSize;
            }
            const buffer = new Float32Array(width * height * 4 * morphTargetsCount);
            const texture = new (0, $dyjou.DataArrayTexture)(buffer, width, height, morphTargetsCount);
            texture.type = (0, $dyjou.FloatType);
            texture.needsUpdate = true;
            // fill buffer
            const vertexDataStride = vertexDataCount * 4;
            for(let i = 0; i < morphTargetsCount; i++){
                const morphTarget = morphTargets[i];
                const morphNormal = morphNormals[i];
                const morphColor = morphColors[i];
                const offset = width * height * 4 * i;
                for(let j = 0; j < morphTarget.count; j++){
                    const stride = j * vertexDataStride;
                    if (hasMorphPosition === true) {
                        morph.fromBufferAttribute(morphTarget, j);
                        buffer[offset + stride + 0] = morph.x;
                        buffer[offset + stride + 1] = morph.y;
                        buffer[offset + stride + 2] = morph.z;
                        buffer[offset + stride + 3] = 0;
                    }
                    if (hasMorphNormals === true) {
                        morph.fromBufferAttribute(morphNormal, j);
                        buffer[offset + stride + 4] = morph.x;
                        buffer[offset + stride + 5] = morph.y;
                        buffer[offset + stride + 6] = morph.z;
                        buffer[offset + stride + 7] = 0;
                    }
                    if (hasMorphColors === true) {
                        morph.fromBufferAttribute(morphColor, j);
                        buffer[offset + stride + 8] = morph.x;
                        buffer[offset + stride + 9] = morph.y;
                        buffer[offset + stride + 10] = morph.z;
                        buffer[offset + stride + 11] = morphColor.itemSize === 4 ? morph.w : 1;
                    }
                }
            }
            entry = {
                count: morphTargetsCount,
                texture: texture,
                size: new (0, $dyjou.Vector2)(width, height)
            };
            morphTextures.set(geometry, entry);
            function disposeTexture() {
                texture.dispose();
                morphTextures.delete(geometry);
                geometry.removeEventListener('dispose', disposeTexture);
            }
            geometry.addEventListener('dispose', disposeTexture);
        }
        //
        if (object.isInstancedMesh === true && object.morphTexture !== null) program.getUniforms().setValue(gl, 'morphTexture', object.morphTexture, textures);
        else {
            let morphInfluencesSum = 0;
            for(let i = 0; i < objectInfluences.length; i++)morphInfluencesSum += objectInfluences[i];
            const morphBaseInfluence = geometry.morphTargetsRelative ? 1 : 1 - morphInfluencesSum;
            program.getUniforms().setValue(gl, 'morphTargetBaseInfluence', morphBaseInfluence);
            program.getUniforms().setValue(gl, 'morphTargetInfluences', objectInfluences);
        }
        program.getUniforms().setValue(gl, 'morphTargetsTexture', entry.texture, textures);
        program.getUniforms().setValue(gl, 'morphTargetsTextureSize', entry.size);
    }
    return {
        update: update
    };
}
function $d5b33d7c30034067$var$WebGLObjects(gl, geometries, attributes, info) {
    let updateMap = new WeakMap();
    function update(object) {
        const frame = info.render.frame;
        const geometry = object.geometry;
        const buffergeometry = geometries.get(object, geometry);
        // Update once per frame
        if (updateMap.get(buffergeometry) !== frame) {
            geometries.update(buffergeometry);
            updateMap.set(buffergeometry, frame);
        }
        if (object.isInstancedMesh) {
            if (object.hasEventListener('dispose', onInstancedMeshDispose) === false) object.addEventListener('dispose', onInstancedMeshDispose);
            if (updateMap.get(object) !== frame) {
                attributes.update(object.instanceMatrix, gl.ARRAY_BUFFER);
                if (object.instanceColor !== null) attributes.update(object.instanceColor, gl.ARRAY_BUFFER);
                updateMap.set(object, frame);
            }
        }
        if (object.isSkinnedMesh) {
            const skeleton = object.skeleton;
            if (updateMap.get(skeleton) !== frame) {
                skeleton.update();
                updateMap.set(skeleton, frame);
            }
        }
        return buffergeometry;
    }
    function dispose() {
        updateMap = new WeakMap();
    }
    function onInstancedMeshDispose(event) {
        const instancedMesh = event.target;
        instancedMesh.removeEventListener('dispose', onInstancedMeshDispose);
        attributes.remove(instancedMesh.instanceMatrix);
        if (instancedMesh.instanceColor !== null) attributes.remove(instancedMesh.instanceColor);
    }
    return {
        update: update,
        dispose: dispose
    };
}
/**
 * Uniforms of a program.
 * Those form a tree structure with a special top-level container for the root,
 * which you get by calling 'new WebGLUniforms( gl, program )'.
 *
 *
 * Properties of inner nodes including the top-level container:
 *
 * .seq - array of nested uniforms
 * .map - nested uniforms by name
 *
 *
 * Methods of all nodes except the top-level container:
 *
 * .setValue( gl, value, [textures] )
 *
 * 		uploads a uniform value(s)
 *  	the 'textures' parameter is needed for sampler uniforms
 *
 *
 * Static methods of the top-level container (textures factorizations):
 *
 * .upload( gl, seq, values, textures )
 *
 * 		sets uniforms in 'seq' to 'values[id].value'
 *
 * .seqWithValue( seq, values ) : filteredSeq
 *
 * 		filters 'seq' entries with corresponding entry in values
 *
 *
 * Methods of the top-level container (textures factorizations):
 *
 * .setValue( gl, name, value, textures )
 *
 * 		sets uniform with  name 'name' to 'value'
 *
 * .setOptional( gl, obj, prop )
 *
 * 		like .set for an optional property of the object
 *
 */ const $d5b33d7c30034067$var$emptyTexture = /*@__PURE__*/ new (0, $dyjou.Texture)();
const $d5b33d7c30034067$var$emptyShadowTexture = /*@__PURE__*/ new (0, $dyjou.DepthTexture)(1, 1);
const $d5b33d7c30034067$var$emptyArrayTexture = /*@__PURE__*/ new (0, $dyjou.DataArrayTexture)();
const $d5b33d7c30034067$var$empty3dTexture = /*@__PURE__*/ new (0, $dyjou.Data3DTexture)();
const $d5b33d7c30034067$var$emptyCubeTexture = /*@__PURE__*/ new (0, $dyjou.CubeTexture)();
// --- Utilities ---
// Array Caches (provide typed arrays for temporary by size)
const $d5b33d7c30034067$var$arrayCacheF32 = [];
const $d5b33d7c30034067$var$arrayCacheI32 = [];
// Float32Array caches used for uploading Matrix uniforms
const $d5b33d7c30034067$var$mat4array = new Float32Array(16);
const $d5b33d7c30034067$var$mat3array = new Float32Array(9);
const $d5b33d7c30034067$var$mat2array = new Float32Array(4);
// Flattening for arrays of vectors and matrices
function $d5b33d7c30034067$var$flatten(array, nBlocks, blockSize) {
    const firstElem = array[0];
    if (firstElem <= 0 || firstElem > 0) return array;
    // unoptimized: ! isNaN( firstElem )
    // see http://jacksondunstan.com/articles/983
    const n = nBlocks * blockSize;
    let r = $d5b33d7c30034067$var$arrayCacheF32[n];
    if (r === undefined) {
        r = new Float32Array(n);
        $d5b33d7c30034067$var$arrayCacheF32[n] = r;
    }
    if (nBlocks !== 0) {
        firstElem.toArray(r, 0);
        for(let i = 1, offset = 0; i !== nBlocks; ++i){
            offset += blockSize;
            array[i].toArray(r, offset);
        }
    }
    return r;
}
function $d5b33d7c30034067$var$arraysEqual(a, b) {
    if (a.length !== b.length) return false;
    for(let i = 0, l = a.length; i < l; i++){
        if (a[i] !== b[i]) return false;
    }
    return true;
}
function $d5b33d7c30034067$var$copyArray(a, b) {
    for(let i = 0, l = b.length; i < l; i++)a[i] = b[i];
}
// Texture unit allocation
function $d5b33d7c30034067$var$allocTexUnits(textures, n) {
    let r = $d5b33d7c30034067$var$arrayCacheI32[n];
    if (r === undefined) {
        r = new Int32Array(n);
        $d5b33d7c30034067$var$arrayCacheI32[n] = r;
    }
    for(let i = 0; i !== n; ++i)r[i] = textures.allocateTextureUnit();
    return r;
}
// --- Setters ---
// Note: Defining these methods externally, because they come in a bunch
// and this way their names minify.
// Single scalar
function $d5b33d7c30034067$var$setValueV1f(gl, v) {
    const cache = this.cache;
    if (cache[0] === v) return;
    gl.uniform1f(this.addr, v);
    cache[0] = v;
}
// Single float vector (from flat array or THREE.VectorN)
function $d5b33d7c30034067$var$setValueV2f(gl, v) {
    const cache = this.cache;
    if (v.x !== undefined) {
        if (cache[0] !== v.x || cache[1] !== v.y) {
            gl.uniform2f(this.addr, v.x, v.y);
            cache[0] = v.x;
            cache[1] = v.y;
        }
    } else {
        if ($d5b33d7c30034067$var$arraysEqual(cache, v)) return;
        gl.uniform2fv(this.addr, v);
        $d5b33d7c30034067$var$copyArray(cache, v);
    }
}
function $d5b33d7c30034067$var$setValueV3f(gl, v) {
    const cache = this.cache;
    if (v.x !== undefined) {
        if (cache[0] !== v.x || cache[1] !== v.y || cache[2] !== v.z) {
            gl.uniform3f(this.addr, v.x, v.y, v.z);
            cache[0] = v.x;
            cache[1] = v.y;
            cache[2] = v.z;
        }
    } else if (v.r !== undefined) {
        if (cache[0] !== v.r || cache[1] !== v.g || cache[2] !== v.b) {
            gl.uniform3f(this.addr, v.r, v.g, v.b);
            cache[0] = v.r;
            cache[1] = v.g;
            cache[2] = v.b;
        }
    } else {
        if ($d5b33d7c30034067$var$arraysEqual(cache, v)) return;
        gl.uniform3fv(this.addr, v);
        $d5b33d7c30034067$var$copyArray(cache, v);
    }
}
function $d5b33d7c30034067$var$setValueV4f(gl, v) {
    const cache = this.cache;
    if (v.x !== undefined) {
        if (cache[0] !== v.x || cache[1] !== v.y || cache[2] !== v.z || cache[3] !== v.w) {
            gl.uniform4f(this.addr, v.x, v.y, v.z, v.w);
            cache[0] = v.x;
            cache[1] = v.y;
            cache[2] = v.z;
            cache[3] = v.w;
        }
    } else {
        if ($d5b33d7c30034067$var$arraysEqual(cache, v)) return;
        gl.uniform4fv(this.addr, v);
        $d5b33d7c30034067$var$copyArray(cache, v);
    }
}
// Single matrix (from flat array or THREE.MatrixN)
function $d5b33d7c30034067$var$setValueM2(gl, v) {
    const cache = this.cache;
    const elements = v.elements;
    if (elements === undefined) {
        if ($d5b33d7c30034067$var$arraysEqual(cache, v)) return;
        gl.uniformMatrix2fv(this.addr, false, v);
        $d5b33d7c30034067$var$copyArray(cache, v);
    } else {
        if ($d5b33d7c30034067$var$arraysEqual(cache, elements)) return;
        $d5b33d7c30034067$var$mat2array.set(elements);
        gl.uniformMatrix2fv(this.addr, false, $d5b33d7c30034067$var$mat2array);
        $d5b33d7c30034067$var$copyArray(cache, elements);
    }
}
function $d5b33d7c30034067$var$setValueM3(gl, v) {
    const cache = this.cache;
    const elements = v.elements;
    if (elements === undefined) {
        if ($d5b33d7c30034067$var$arraysEqual(cache, v)) return;
        gl.uniformMatrix3fv(this.addr, false, v);
        $d5b33d7c30034067$var$copyArray(cache, v);
    } else {
        if ($d5b33d7c30034067$var$arraysEqual(cache, elements)) return;
        $d5b33d7c30034067$var$mat3array.set(elements);
        gl.uniformMatrix3fv(this.addr, false, $d5b33d7c30034067$var$mat3array);
        $d5b33d7c30034067$var$copyArray(cache, elements);
    }
}
function $d5b33d7c30034067$var$setValueM4(gl, v) {
    const cache = this.cache;
    const elements = v.elements;
    if (elements === undefined) {
        if ($d5b33d7c30034067$var$arraysEqual(cache, v)) return;
        gl.uniformMatrix4fv(this.addr, false, v);
        $d5b33d7c30034067$var$copyArray(cache, v);
    } else {
        if ($d5b33d7c30034067$var$arraysEqual(cache, elements)) return;
        $d5b33d7c30034067$var$mat4array.set(elements);
        gl.uniformMatrix4fv(this.addr, false, $d5b33d7c30034067$var$mat4array);
        $d5b33d7c30034067$var$copyArray(cache, elements);
    }
}
// Single integer / boolean
function $d5b33d7c30034067$var$setValueV1i(gl, v) {
    const cache = this.cache;
    if (cache[0] === v) return;
    gl.uniform1i(this.addr, v);
    cache[0] = v;
}
// Single integer / boolean vector (from flat array or THREE.VectorN)
function $d5b33d7c30034067$var$setValueV2i(gl, v) {
    const cache = this.cache;
    if (v.x !== undefined) {
        if (cache[0] !== v.x || cache[1] !== v.y) {
            gl.uniform2i(this.addr, v.x, v.y);
            cache[0] = v.x;
            cache[1] = v.y;
        }
    } else {
        if ($d5b33d7c30034067$var$arraysEqual(cache, v)) return;
        gl.uniform2iv(this.addr, v);
        $d5b33d7c30034067$var$copyArray(cache, v);
    }
}
function $d5b33d7c30034067$var$setValueV3i(gl, v) {
    const cache = this.cache;
    if (v.x !== undefined) {
        if (cache[0] !== v.x || cache[1] !== v.y || cache[2] !== v.z) {
            gl.uniform3i(this.addr, v.x, v.y, v.z);
            cache[0] = v.x;
            cache[1] = v.y;
            cache[2] = v.z;
        }
    } else {
        if ($d5b33d7c30034067$var$arraysEqual(cache, v)) return;
        gl.uniform3iv(this.addr, v);
        $d5b33d7c30034067$var$copyArray(cache, v);
    }
}
function $d5b33d7c30034067$var$setValueV4i(gl, v) {
    const cache = this.cache;
    if (v.x !== undefined) {
        if (cache[0] !== v.x || cache[1] !== v.y || cache[2] !== v.z || cache[3] !== v.w) {
            gl.uniform4i(this.addr, v.x, v.y, v.z, v.w);
            cache[0] = v.x;
            cache[1] = v.y;
            cache[2] = v.z;
            cache[3] = v.w;
        }
    } else {
        if ($d5b33d7c30034067$var$arraysEqual(cache, v)) return;
        gl.uniform4iv(this.addr, v);
        $d5b33d7c30034067$var$copyArray(cache, v);
    }
}
// Single unsigned integer
function $d5b33d7c30034067$var$setValueV1ui(gl, v) {
    const cache = this.cache;
    if (cache[0] === v) return;
    gl.uniform1ui(this.addr, v);
    cache[0] = v;
}
// Single unsigned integer vector (from flat array or THREE.VectorN)
function $d5b33d7c30034067$var$setValueV2ui(gl, v) {
    const cache = this.cache;
    if (v.x !== undefined) {
        if (cache[0] !== v.x || cache[1] !== v.y) {
            gl.uniform2ui(this.addr, v.x, v.y);
            cache[0] = v.x;
            cache[1] = v.y;
        }
    } else {
        if ($d5b33d7c30034067$var$arraysEqual(cache, v)) return;
        gl.uniform2uiv(this.addr, v);
        $d5b33d7c30034067$var$copyArray(cache, v);
    }
}
function $d5b33d7c30034067$var$setValueV3ui(gl, v) {
    const cache = this.cache;
    if (v.x !== undefined) {
        if (cache[0] !== v.x || cache[1] !== v.y || cache[2] !== v.z) {
            gl.uniform3ui(this.addr, v.x, v.y, v.z);
            cache[0] = v.x;
            cache[1] = v.y;
            cache[2] = v.z;
        }
    } else {
        if ($d5b33d7c30034067$var$arraysEqual(cache, v)) return;
        gl.uniform3uiv(this.addr, v);
        $d5b33d7c30034067$var$copyArray(cache, v);
    }
}
function $d5b33d7c30034067$var$setValueV4ui(gl, v) {
    const cache = this.cache;
    if (v.x !== undefined) {
        if (cache[0] !== v.x || cache[1] !== v.y || cache[2] !== v.z || cache[3] !== v.w) {
            gl.uniform4ui(this.addr, v.x, v.y, v.z, v.w);
            cache[0] = v.x;
            cache[1] = v.y;
            cache[2] = v.z;
            cache[3] = v.w;
        }
    } else {
        if ($d5b33d7c30034067$var$arraysEqual(cache, v)) return;
        gl.uniform4uiv(this.addr, v);
        $d5b33d7c30034067$var$copyArray(cache, v);
    }
}
// Single texture (2D / Cube)
function $d5b33d7c30034067$var$setValueT1(gl, v, textures) {
    const cache = this.cache;
    const unit = textures.allocateTextureUnit();
    if (cache[0] !== unit) {
        gl.uniform1i(this.addr, unit);
        cache[0] = unit;
    }
    let emptyTexture2D;
    if (this.type === gl.SAMPLER_2D_SHADOW) {
        $d5b33d7c30034067$var$emptyShadowTexture.compareFunction = (0, $dyjou.LessEqualCompare); // #28670
        emptyTexture2D = $d5b33d7c30034067$var$emptyShadowTexture;
    } else emptyTexture2D = $d5b33d7c30034067$var$emptyTexture;
    textures.setTexture2D(v || emptyTexture2D, unit);
}
function $d5b33d7c30034067$var$setValueT3D1(gl, v, textures) {
    const cache = this.cache;
    const unit = textures.allocateTextureUnit();
    if (cache[0] !== unit) {
        gl.uniform1i(this.addr, unit);
        cache[0] = unit;
    }
    textures.setTexture3D(v || $d5b33d7c30034067$var$empty3dTexture, unit);
}
function $d5b33d7c30034067$var$setValueT6(gl, v, textures) {
    const cache = this.cache;
    const unit = textures.allocateTextureUnit();
    if (cache[0] !== unit) {
        gl.uniform1i(this.addr, unit);
        cache[0] = unit;
    }
    textures.setTextureCube(v || $d5b33d7c30034067$var$emptyCubeTexture, unit);
}
function $d5b33d7c30034067$var$setValueT2DArray1(gl, v, textures) {
    const cache = this.cache;
    const unit = textures.allocateTextureUnit();
    if (cache[0] !== unit) {
        gl.uniform1i(this.addr, unit);
        cache[0] = unit;
    }
    textures.setTexture2DArray(v || $d5b33d7c30034067$var$emptyArrayTexture, unit);
}
// Helper to pick the right setter for the singular case
function $d5b33d7c30034067$var$getSingularSetter(type) {
    switch(type){
        case 0x1406:
            return $d5b33d7c30034067$var$setValueV1f; // FLOAT
        case 0x8b50:
            return $d5b33d7c30034067$var$setValueV2f; // _VEC2
        case 0x8b51:
            return $d5b33d7c30034067$var$setValueV3f; // _VEC3
        case 0x8b52:
            return $d5b33d7c30034067$var$setValueV4f; // _VEC4
        case 0x8b5a:
            return $d5b33d7c30034067$var$setValueM2; // _MAT2
        case 0x8b5b:
            return $d5b33d7c30034067$var$setValueM3; // _MAT3
        case 0x8b5c:
            return $d5b33d7c30034067$var$setValueM4; // _MAT4
        case 0x1404:
        case 0x8b56:
            return $d5b33d7c30034067$var$setValueV1i; // INT, BOOL
        case 0x8b53:
        case 0x8b57:
            return $d5b33d7c30034067$var$setValueV2i; // _VEC2
        case 0x8b54:
        case 0x8b58:
            return $d5b33d7c30034067$var$setValueV3i; // _VEC3
        case 0x8b55:
        case 0x8b59:
            return $d5b33d7c30034067$var$setValueV4i; // _VEC4
        case 0x1405:
            return $d5b33d7c30034067$var$setValueV1ui; // UINT
        case 0x8dc6:
            return $d5b33d7c30034067$var$setValueV2ui; // _VEC2
        case 0x8dc7:
            return $d5b33d7c30034067$var$setValueV3ui; // _VEC3
        case 0x8dc8:
            return $d5b33d7c30034067$var$setValueV4ui; // _VEC4
        case 0x8b5e:
        case 0x8d66:
        case 0x8dca:
        case 0x8dd2:
        case 0x8b62:
            return $d5b33d7c30034067$var$setValueT1;
        case 0x8b5f:
        case 0x8dcb:
        case 0x8dd3:
            return $d5b33d7c30034067$var$setValueT3D1;
        case 0x8b60:
        case 0x8dcc:
        case 0x8dd4:
        case 0x8dc5:
            return $d5b33d7c30034067$var$setValueT6;
        case 0x8dc1:
        case 0x8dcf:
        case 0x8dd7:
        case 0x8dc4:
            return $d5b33d7c30034067$var$setValueT2DArray1;
    }
}
// Array of scalars
function $d5b33d7c30034067$var$setValueV1fArray(gl, v) {
    gl.uniform1fv(this.addr, v);
}
// Array of vectors (from flat array or array of THREE.VectorN)
function $d5b33d7c30034067$var$setValueV2fArray(gl, v) {
    const data = $d5b33d7c30034067$var$flatten(v, this.size, 2);
    gl.uniform2fv(this.addr, data);
}
function $d5b33d7c30034067$var$setValueV3fArray(gl, v) {
    const data = $d5b33d7c30034067$var$flatten(v, this.size, 3);
    gl.uniform3fv(this.addr, data);
}
function $d5b33d7c30034067$var$setValueV4fArray(gl, v) {
    const data = $d5b33d7c30034067$var$flatten(v, this.size, 4);
    gl.uniform4fv(this.addr, data);
}
// Array of matrices (from flat array or array of THREE.MatrixN)
function $d5b33d7c30034067$var$setValueM2Array(gl, v) {
    const data = $d5b33d7c30034067$var$flatten(v, this.size, 4);
    gl.uniformMatrix2fv(this.addr, false, data);
}
function $d5b33d7c30034067$var$setValueM3Array(gl, v) {
    const data = $d5b33d7c30034067$var$flatten(v, this.size, 9);
    gl.uniformMatrix3fv(this.addr, false, data);
}
function $d5b33d7c30034067$var$setValueM4Array(gl, v) {
    const data = $d5b33d7c30034067$var$flatten(v, this.size, 16);
    gl.uniformMatrix4fv(this.addr, false, data);
}
// Array of integer / boolean
function $d5b33d7c30034067$var$setValueV1iArray(gl, v) {
    gl.uniform1iv(this.addr, v);
}
// Array of integer / boolean vectors (from flat array)
function $d5b33d7c30034067$var$setValueV2iArray(gl, v) {
    gl.uniform2iv(this.addr, v);
}
function $d5b33d7c30034067$var$setValueV3iArray(gl, v) {
    gl.uniform3iv(this.addr, v);
}
function $d5b33d7c30034067$var$setValueV4iArray(gl, v) {
    gl.uniform4iv(this.addr, v);
}
// Array of unsigned integer
function $d5b33d7c30034067$var$setValueV1uiArray(gl, v) {
    gl.uniform1uiv(this.addr, v);
}
// Array of unsigned integer vectors (from flat array)
function $d5b33d7c30034067$var$setValueV2uiArray(gl, v) {
    gl.uniform2uiv(this.addr, v);
}
function $d5b33d7c30034067$var$setValueV3uiArray(gl, v) {
    gl.uniform3uiv(this.addr, v);
}
function $d5b33d7c30034067$var$setValueV4uiArray(gl, v) {
    gl.uniform4uiv(this.addr, v);
}
// Array of textures (2D / 3D / Cube / 2DArray)
function $d5b33d7c30034067$var$setValueT1Array(gl, v, textures) {
    const cache = this.cache;
    const n = v.length;
    const units = $d5b33d7c30034067$var$allocTexUnits(textures, n);
    if (!$d5b33d7c30034067$var$arraysEqual(cache, units)) {
        gl.uniform1iv(this.addr, units);
        $d5b33d7c30034067$var$copyArray(cache, units);
    }
    for(let i = 0; i !== n; ++i)textures.setTexture2D(v[i] || $d5b33d7c30034067$var$emptyTexture, units[i]);
}
function $d5b33d7c30034067$var$setValueT3DArray(gl, v, textures) {
    const cache = this.cache;
    const n = v.length;
    const units = $d5b33d7c30034067$var$allocTexUnits(textures, n);
    if (!$d5b33d7c30034067$var$arraysEqual(cache, units)) {
        gl.uniform1iv(this.addr, units);
        $d5b33d7c30034067$var$copyArray(cache, units);
    }
    for(let i = 0; i !== n; ++i)textures.setTexture3D(v[i] || $d5b33d7c30034067$var$empty3dTexture, units[i]);
}
function $d5b33d7c30034067$var$setValueT6Array(gl, v, textures) {
    const cache = this.cache;
    const n = v.length;
    const units = $d5b33d7c30034067$var$allocTexUnits(textures, n);
    if (!$d5b33d7c30034067$var$arraysEqual(cache, units)) {
        gl.uniform1iv(this.addr, units);
        $d5b33d7c30034067$var$copyArray(cache, units);
    }
    for(let i = 0; i !== n; ++i)textures.setTextureCube(v[i] || $d5b33d7c30034067$var$emptyCubeTexture, units[i]);
}
function $d5b33d7c30034067$var$setValueT2DArrayArray(gl, v, textures) {
    const cache = this.cache;
    const n = v.length;
    const units = $d5b33d7c30034067$var$allocTexUnits(textures, n);
    if (!$d5b33d7c30034067$var$arraysEqual(cache, units)) {
        gl.uniform1iv(this.addr, units);
        $d5b33d7c30034067$var$copyArray(cache, units);
    }
    for(let i = 0; i !== n; ++i)textures.setTexture2DArray(v[i] || $d5b33d7c30034067$var$emptyArrayTexture, units[i]);
}
// Helper to pick the right setter for a pure (bottom-level) array
function $d5b33d7c30034067$var$getPureArraySetter(type) {
    switch(type){
        case 0x1406:
            return $d5b33d7c30034067$var$setValueV1fArray; // FLOAT
        case 0x8b50:
            return $d5b33d7c30034067$var$setValueV2fArray; // _VEC2
        case 0x8b51:
            return $d5b33d7c30034067$var$setValueV3fArray; // _VEC3
        case 0x8b52:
            return $d5b33d7c30034067$var$setValueV4fArray; // _VEC4
        case 0x8b5a:
            return $d5b33d7c30034067$var$setValueM2Array; // _MAT2
        case 0x8b5b:
            return $d5b33d7c30034067$var$setValueM3Array; // _MAT3
        case 0x8b5c:
            return $d5b33d7c30034067$var$setValueM4Array; // _MAT4
        case 0x1404:
        case 0x8b56:
            return $d5b33d7c30034067$var$setValueV1iArray; // INT, BOOL
        case 0x8b53:
        case 0x8b57:
            return $d5b33d7c30034067$var$setValueV2iArray; // _VEC2
        case 0x8b54:
        case 0x8b58:
            return $d5b33d7c30034067$var$setValueV3iArray; // _VEC3
        case 0x8b55:
        case 0x8b59:
            return $d5b33d7c30034067$var$setValueV4iArray; // _VEC4
        case 0x1405:
            return $d5b33d7c30034067$var$setValueV1uiArray; // UINT
        case 0x8dc6:
            return $d5b33d7c30034067$var$setValueV2uiArray; // _VEC2
        case 0x8dc7:
            return $d5b33d7c30034067$var$setValueV3uiArray; // _VEC3
        case 0x8dc8:
            return $d5b33d7c30034067$var$setValueV4uiArray; // _VEC4
        case 0x8b5e:
        case 0x8d66:
        case 0x8dca:
        case 0x8dd2:
        case 0x8b62:
            return $d5b33d7c30034067$var$setValueT1Array;
        case 0x8b5f:
        case 0x8dcb:
        case 0x8dd3:
            return $d5b33d7c30034067$var$setValueT3DArray;
        case 0x8b60:
        case 0x8dcc:
        case 0x8dd4:
        case 0x8dc5:
            return $d5b33d7c30034067$var$setValueT6Array;
        case 0x8dc1:
        case 0x8dcf:
        case 0x8dd7:
        case 0x8dc4:
            return $d5b33d7c30034067$var$setValueT2DArrayArray;
    }
}
// --- Uniform Classes ---
class $d5b33d7c30034067$var$SingleUniform {
    constructor(id, activeInfo, addr){
        this.id = id;
        this.addr = addr;
        this.cache = [];
        this.type = activeInfo.type;
        this.setValue = $d5b33d7c30034067$var$getSingularSetter(activeInfo.type);
    // this.path = activeInfo.name; // DEBUG
    }
}
class $d5b33d7c30034067$var$PureArrayUniform {
    constructor(id, activeInfo, addr){
        this.id = id;
        this.addr = addr;
        this.cache = [];
        this.type = activeInfo.type;
        this.size = activeInfo.size;
        this.setValue = $d5b33d7c30034067$var$getPureArraySetter(activeInfo.type);
    // this.path = activeInfo.name; // DEBUG
    }
}
class $d5b33d7c30034067$var$StructuredUniform {
    constructor(id){
        this.id = id;
        this.seq = [];
        this.map = {};
    }
    setValue(gl, value, textures) {
        const seq = this.seq;
        for(let i = 0, n = seq.length; i !== n; ++i){
            const u = seq[i];
            u.setValue(gl, value[u.id], textures);
        }
    }
}
// --- Top-level ---
// Parser - builds up the property tree from the path strings
const $d5b33d7c30034067$var$RePathPart = /(\w+)(\])?(\[|\.)?/g;
// extracts
// 	- the identifier (member name or array index)
//  - followed by an optional right bracket (found when array index)
//  - followed by an optional left bracket or dot (type of subscript)
//
// Note: These portions can be read in a non-overlapping fashion and
// allow straightforward parsing of the hierarchy that WebGL encodes
// in the uniform names.
function $d5b33d7c30034067$var$addUniform(container, uniformObject) {
    container.seq.push(uniformObject);
    container.map[uniformObject.id] = uniformObject;
}
function $d5b33d7c30034067$var$parseUniform(activeInfo, addr, container) {
    const path = activeInfo.name, pathLength = path.length;
    // reset RegExp object, because of the early exit of a previous run
    $d5b33d7c30034067$var$RePathPart.lastIndex = 0;
    while(true){
        const match = $d5b33d7c30034067$var$RePathPart.exec(path), matchEnd = $d5b33d7c30034067$var$RePathPart.lastIndex;
        let id = match[1];
        const idIsIndex = match[2] === ']', subscript = match[3];
        if (idIsIndex) id = id | 0; // convert to integer
        if (subscript === undefined || subscript === '[' && matchEnd + 2 === pathLength) {
            // bare name or "pure" bottom-level array "[0]" suffix
            $d5b33d7c30034067$var$addUniform(container, subscript === undefined ? new $d5b33d7c30034067$var$SingleUniform(id, activeInfo, addr) : new $d5b33d7c30034067$var$PureArrayUniform(id, activeInfo, addr));
            break;
        } else {
            // step into inner node / create it in case it doesn't exist
            const map = container.map;
            let next = map[id];
            if (next === undefined) {
                next = new $d5b33d7c30034067$var$StructuredUniform(id);
                $d5b33d7c30034067$var$addUniform(container, next);
            }
            container = next;
        }
    }
}
// Root Container
class $d5b33d7c30034067$var$WebGLUniforms {
    constructor(gl, program){
        this.seq = [];
        this.map = {};
        const n = gl.getProgramParameter(program, gl.ACTIVE_UNIFORMS);
        for(let i = 0; i < n; ++i){
            const info = gl.getActiveUniform(program, i), addr = gl.getUniformLocation(program, info.name);
            $d5b33d7c30034067$var$parseUniform(info, addr, this);
        }
    }
    setValue(gl, name, value, textures) {
        const u = this.map[name];
        if (u !== undefined) u.setValue(gl, value, textures);
    }
    setOptional(gl, object, name) {
        const v = object[name];
        if (v !== undefined) this.setValue(gl, name, v);
    }
    static upload(gl, seq, values, textures) {
        for(let i = 0, n = seq.length; i !== n; ++i){
            const u = seq[i], v = values[u.id];
            if (v.needsUpdate !== false) // note: always updating when .needsUpdate is undefined
            u.setValue(gl, v.value, textures);
        }
    }
    static seqWithValue(seq, values) {
        const r = [];
        for(let i = 0, n = seq.length; i !== n; ++i){
            const u = seq[i];
            if (u.id in values) r.push(u);
        }
        return r;
    }
}
function $d5b33d7c30034067$var$WebGLShader(gl, type, string) {
    const shader = gl.createShader(type);
    gl.shaderSource(shader, string);
    gl.compileShader(shader);
    return shader;
}
// From https://www.khronos.org/registry/webgl/extensions/KHR_parallel_shader_compile/
const $d5b33d7c30034067$var$COMPLETION_STATUS_KHR = 0x91B1;
let $d5b33d7c30034067$var$programIdCount = 0;
function $d5b33d7c30034067$var$handleSource(string, errorLine) {
    const lines = string.split('\n');
    const lines2 = [];
    const from = Math.max(errorLine - 6, 0);
    const to = Math.min(errorLine + 6, lines.length);
    for(let i = from; i < to; i++){
        const line = i + 1;
        lines2.push(`${line === errorLine ? '>' : ' '} ${line}: ${lines[i]}`);
    }
    return lines2.join('\n');
}
const $d5b33d7c30034067$var$_m0 = /*@__PURE__*/ new (0, $dyjou.Matrix3)();
function $d5b33d7c30034067$var$getEncodingComponents(colorSpace) {
    (0, $dyjou.ColorManagement)._getMatrix($d5b33d7c30034067$var$_m0, (0, $dyjou.ColorManagement).workingColorSpace, colorSpace);
    const encodingMatrix = `mat3( ${$d5b33d7c30034067$var$_m0.elements.map((v)=>v.toFixed(4))} )`;
    switch((0, $dyjou.ColorManagement).getTransfer(colorSpace)){
        case 0, $dyjou.LinearTransfer:
            return [
                encodingMatrix,
                'LinearTransferOETF'
            ];
        case 0, $dyjou.SRGBTransfer:
            return [
                encodingMatrix,
                'sRGBTransferOETF'
            ];
        default:
            console.warn('THREE.WebGLProgram: Unsupported color space: ', colorSpace);
            return [
                encodingMatrix,
                'LinearTransferOETF'
            ];
    }
}
function $d5b33d7c30034067$var$getShaderErrors(gl, shader, type) {
    const status = gl.getShaderParameter(shader, gl.COMPILE_STATUS);
    const errors = gl.getShaderInfoLog(shader).trim();
    if (status && errors === '') return '';
    const errorMatches = /ERROR: 0:(\d+)/.exec(errors);
    if (errorMatches) {
        // --enable-privileged-webgl-extension
        // console.log( '**' + type + '**', gl.getExtension( 'WEBGL_debug_shaders' ).getTranslatedShaderSource( shader ) );
        const errorLine = parseInt(errorMatches[1]);
        return type.toUpperCase() + '\n\n' + errors + '\n\n' + $d5b33d7c30034067$var$handleSource(gl.getShaderSource(shader), errorLine);
    } else return errors;
}
function $d5b33d7c30034067$var$getTexelEncodingFunction(functionName, colorSpace) {
    const components = $d5b33d7c30034067$var$getEncodingComponents(colorSpace);
    return [
        `vec4 ${functionName}( vec4 value ) {`,
        `	return ${components[1]}( vec4( value.rgb * ${components[0]}, value.a ) );`,
        '}'
    ].join('\n');
}
function $d5b33d7c30034067$var$getToneMappingFunction(functionName, toneMapping) {
    let toneMappingName;
    switch(toneMapping){
        case 0, $dyjou.LinearToneMapping:
            toneMappingName = 'Linear';
            break;
        case 0, $dyjou.ReinhardToneMapping:
            toneMappingName = 'Reinhard';
            break;
        case 0, $dyjou.CineonToneMapping:
            toneMappingName = 'Cineon';
            break;
        case 0, $dyjou.ACESFilmicToneMapping:
            toneMappingName = 'ACESFilmic';
            break;
        case 0, $dyjou.AgXToneMapping:
            toneMappingName = 'AgX';
            break;
        case 0, $dyjou.NeutralToneMapping:
            toneMappingName = 'Neutral';
            break;
        case 0, $dyjou.CustomToneMapping:
            toneMappingName = 'Custom';
            break;
        default:
            console.warn('THREE.WebGLProgram: Unsupported toneMapping:', toneMapping);
            toneMappingName = 'Linear';
    }
    return 'vec3 ' + functionName + '( vec3 color ) { return ' + toneMappingName + 'ToneMapping( color ); }';
}
const $d5b33d7c30034067$var$_v0 = /*@__PURE__*/ new (0, $dyjou.Vector3)();
function $d5b33d7c30034067$var$getLuminanceFunction() {
    (0, $dyjou.ColorManagement).getLuminanceCoefficients($d5b33d7c30034067$var$_v0);
    const r = $d5b33d7c30034067$var$_v0.x.toFixed(4);
    const g = $d5b33d7c30034067$var$_v0.y.toFixed(4);
    const b = $d5b33d7c30034067$var$_v0.z.toFixed(4);
    return [
        'float luminance( const in vec3 rgb ) {',
        `	const vec3 weights = vec3( ${r}, ${g}, ${b} );`,
        '	return dot( weights, rgb );',
        '}'
    ].join('\n');
}
function $d5b33d7c30034067$var$generateVertexExtensions(parameters) {
    const chunks = [
        parameters.extensionClipCullDistance ? '#extension GL_ANGLE_clip_cull_distance : require' : '',
        parameters.extensionMultiDraw ? '#extension GL_ANGLE_multi_draw : require' : ''
    ];
    return chunks.filter($d5b33d7c30034067$var$filterEmptyLine).join('\n');
}
function $d5b33d7c30034067$var$generateDefines(defines) {
    const chunks = [];
    for(const name in defines){
        const value = defines[name];
        if (value === false) continue;
        chunks.push('#define ' + name + ' ' + value);
    }
    return chunks.join('\n');
}
function $d5b33d7c30034067$var$fetchAttributeLocations(gl, program) {
    const attributes = {};
    const n = gl.getProgramParameter(program, gl.ACTIVE_ATTRIBUTES);
    for(let i = 0; i < n; i++){
        const info = gl.getActiveAttrib(program, i);
        const name = info.name;
        let locationSize = 1;
        if (info.type === gl.FLOAT_MAT2) locationSize = 2;
        if (info.type === gl.FLOAT_MAT3) locationSize = 3;
        if (info.type === gl.FLOAT_MAT4) locationSize = 4;
        // console.log( 'THREE.WebGLProgram: ACTIVE VERTEX ATTRIBUTE:', name, i );
        attributes[name] = {
            type: info.type,
            location: gl.getAttribLocation(program, name),
            locationSize: locationSize
        };
    }
    return attributes;
}
function $d5b33d7c30034067$var$filterEmptyLine(string) {
    return string !== '';
}
function $d5b33d7c30034067$var$replaceLightNums(string, parameters) {
    const numSpotLightCoords = parameters.numSpotLightShadows + parameters.numSpotLightMaps - parameters.numSpotLightShadowsWithMaps;
    return string.replace(/NUM_DIR_LIGHTS/g, parameters.numDirLights).replace(/NUM_SPOT_LIGHTS/g, parameters.numSpotLights).replace(/NUM_SPOT_LIGHT_MAPS/g, parameters.numSpotLightMaps).replace(/NUM_SPOT_LIGHT_COORDS/g, numSpotLightCoords).replace(/NUM_RECT_AREA_LIGHTS/g, parameters.numRectAreaLights).replace(/NUM_POINT_LIGHTS/g, parameters.numPointLights).replace(/NUM_HEMI_LIGHTS/g, parameters.numHemiLights).replace(/NUM_DIR_LIGHT_SHADOWS/g, parameters.numDirLightShadows).replace(/NUM_SPOT_LIGHT_SHADOWS_WITH_MAPS/g, parameters.numSpotLightShadowsWithMaps).replace(/NUM_SPOT_LIGHT_SHADOWS/g, parameters.numSpotLightShadows).replace(/NUM_POINT_LIGHT_SHADOWS/g, parameters.numPointLightShadows);
}
function $d5b33d7c30034067$var$replaceClippingPlaneNums(string, parameters) {
    return string.replace(/NUM_CLIPPING_PLANES/g, parameters.numClippingPlanes).replace(/UNION_CLIPPING_PLANES/g, parameters.numClippingPlanes - parameters.numClipIntersection);
}
// Resolve Includes
const $d5b33d7c30034067$var$includePattern = /^[ \t]*#include +<([\w\d./]+)>/gm;
function $d5b33d7c30034067$var$resolveIncludes(string) {
    return string.replace($d5b33d7c30034067$var$includePattern, $d5b33d7c30034067$var$includeReplacer);
}
const $d5b33d7c30034067$var$shaderChunkMap = new Map();
function $d5b33d7c30034067$var$includeReplacer(match, include) {
    let string = $d5b33d7c30034067$export$955f9f2e84c43c8b[include];
    if (string === undefined) {
        const newInclude = $d5b33d7c30034067$var$shaderChunkMap.get(include);
        if (newInclude !== undefined) {
            string = $d5b33d7c30034067$export$955f9f2e84c43c8b[newInclude];
            console.warn('THREE.WebGLRenderer: Shader chunk "%s" has been deprecated. Use "%s" instead.', include, newInclude);
        } else throw new Error('Can not resolve #include <' + include + '>');
    }
    return $d5b33d7c30034067$var$resolveIncludes(string);
}
// Unroll Loops
const $d5b33d7c30034067$var$unrollLoopPattern = /#pragma unroll_loop_start\s+for\s*\(\s*int\s+i\s*=\s*(\d+)\s*;\s*i\s*<\s*(\d+)\s*;\s*i\s*\+\+\s*\)\s*{([\s\S]+?)}\s+#pragma unroll_loop_end/g;
function $d5b33d7c30034067$var$unrollLoops(string) {
    return string.replace($d5b33d7c30034067$var$unrollLoopPattern, $d5b33d7c30034067$var$loopReplacer);
}
function $d5b33d7c30034067$var$loopReplacer(match, start, end, snippet) {
    let string = '';
    for(let i = parseInt(start); i < parseInt(end); i++)string += snippet.replace(/\[\s*i\s*\]/g, '[ ' + i + ' ]').replace(/UNROLLED_LOOP_INDEX/g, i);
    return string;
}
//
function $d5b33d7c30034067$var$generatePrecision(parameters) {
    let precisionstring = `precision ${parameters.precision} float;
	precision ${parameters.precision} int;
	precision ${parameters.precision} sampler2D;
	precision ${parameters.precision} samplerCube;
	precision ${parameters.precision} sampler3D;
	precision ${parameters.precision} sampler2DArray;
	precision ${parameters.precision} sampler2DShadow;
	precision ${parameters.precision} samplerCubeShadow;
	precision ${parameters.precision} sampler2DArrayShadow;
	precision ${parameters.precision} isampler2D;
	precision ${parameters.precision} isampler3D;
	precision ${parameters.precision} isamplerCube;
	precision ${parameters.precision} isampler2DArray;
	precision ${parameters.precision} usampler2D;
	precision ${parameters.precision} usampler3D;
	precision ${parameters.precision} usamplerCube;
	precision ${parameters.precision} usampler2DArray;
	`;
    if (parameters.precision === 'highp') precisionstring += '\n#define HIGH_PRECISION';
    else if (parameters.precision === 'mediump') precisionstring += '\n#define MEDIUM_PRECISION';
    else if (parameters.precision === 'lowp') precisionstring += '\n#define LOW_PRECISION';
    return precisionstring;
}
function $d5b33d7c30034067$var$generateShadowMapTypeDefine(parameters) {
    let shadowMapTypeDefine = 'SHADOWMAP_TYPE_BASIC';
    if (parameters.shadowMapType === (0, $dyjou.PCFShadowMap)) shadowMapTypeDefine = 'SHADOWMAP_TYPE_PCF';
    else if (parameters.shadowMapType === (0, $dyjou.PCFSoftShadowMap)) shadowMapTypeDefine = 'SHADOWMAP_TYPE_PCF_SOFT';
    else if (parameters.shadowMapType === (0, $dyjou.VSMShadowMap)) shadowMapTypeDefine = 'SHADOWMAP_TYPE_VSM';
    return shadowMapTypeDefine;
}
function $d5b33d7c30034067$var$generateEnvMapTypeDefine(parameters) {
    let envMapTypeDefine = 'ENVMAP_TYPE_CUBE';
    if (parameters.envMap) switch(parameters.envMapMode){
        case 0, $dyjou.CubeReflectionMapping:
        case 0, $dyjou.CubeRefractionMapping:
            envMapTypeDefine = 'ENVMAP_TYPE_CUBE';
            break;
        case 0, $dyjou.CubeUVReflectionMapping:
            envMapTypeDefine = 'ENVMAP_TYPE_CUBE_UV';
            break;
    }
    return envMapTypeDefine;
}
function $d5b33d7c30034067$var$generateEnvMapModeDefine(parameters) {
    let envMapModeDefine = 'ENVMAP_MODE_REFLECTION';
    if (parameters.envMap) switch(parameters.envMapMode){
        case 0, $dyjou.CubeRefractionMapping:
            envMapModeDefine = 'ENVMAP_MODE_REFRACTION';
            break;
    }
    return envMapModeDefine;
}
function $d5b33d7c30034067$var$generateEnvMapBlendingDefine(parameters) {
    let envMapBlendingDefine = 'ENVMAP_BLENDING_NONE';
    if (parameters.envMap) switch(parameters.combine){
        case 0, $dyjou.MultiplyOperation:
            envMapBlendingDefine = 'ENVMAP_BLENDING_MULTIPLY';
            break;
        case 0, $dyjou.MixOperation:
            envMapBlendingDefine = 'ENVMAP_BLENDING_MIX';
            break;
        case 0, $dyjou.AddOperation:
            envMapBlendingDefine = 'ENVMAP_BLENDING_ADD';
            break;
    }
    return envMapBlendingDefine;
}
function $d5b33d7c30034067$var$generateCubeUVSize(parameters) {
    const imageHeight = parameters.envMapCubeUVHeight;
    if (imageHeight === null) return null;
    const maxMip = Math.log2(imageHeight) - 2;
    const texelHeight = 1.0 / imageHeight;
    const texelWidth = 1.0 / (3 * Math.max(Math.pow(2, maxMip), 112));
    return {
        texelWidth: texelWidth,
        texelHeight: texelHeight,
        maxMip: maxMip
    };
}
function $d5b33d7c30034067$var$WebGLProgram(renderer, cacheKey, parameters, bindingStates) {
    // TODO Send this event to Three.js DevTools
    // console.log( 'WebGLProgram', cacheKey );
    const gl = renderer.getContext();
    const defines = parameters.defines;
    let vertexShader = parameters.vertexShader;
    let fragmentShader = parameters.fragmentShader;
    const shadowMapTypeDefine = $d5b33d7c30034067$var$generateShadowMapTypeDefine(parameters);
    const envMapTypeDefine = $d5b33d7c30034067$var$generateEnvMapTypeDefine(parameters);
    const envMapModeDefine = $d5b33d7c30034067$var$generateEnvMapModeDefine(parameters);
    const envMapBlendingDefine = $d5b33d7c30034067$var$generateEnvMapBlendingDefine(parameters);
    const envMapCubeUVSize = $d5b33d7c30034067$var$generateCubeUVSize(parameters);
    const customVertexExtensions = $d5b33d7c30034067$var$generateVertexExtensions(parameters);
    const customDefines = $d5b33d7c30034067$var$generateDefines(defines);
    const program = gl.createProgram();
    let prefixVertex, prefixFragment;
    let versionString = parameters.glslVersion ? '#version ' + parameters.glslVersion + '\n' : '';
    if (parameters.isRawShaderMaterial) {
        prefixVertex = [
            '#define SHADER_TYPE ' + parameters.shaderType,
            '#define SHADER_NAME ' + parameters.shaderName,
            customDefines
        ].filter($d5b33d7c30034067$var$filterEmptyLine).join('\n');
        if (prefixVertex.length > 0) prefixVertex += '\n';
        prefixFragment = [
            '#define SHADER_TYPE ' + parameters.shaderType,
            '#define SHADER_NAME ' + parameters.shaderName,
            customDefines
        ].filter($d5b33d7c30034067$var$filterEmptyLine).join('\n');
        if (prefixFragment.length > 0) prefixFragment += '\n';
    } else {
        prefixVertex = [
            $d5b33d7c30034067$var$generatePrecision(parameters),
            '#define SHADER_TYPE ' + parameters.shaderType,
            '#define SHADER_NAME ' + parameters.shaderName,
            customDefines,
            parameters.extensionClipCullDistance ? '#define USE_CLIP_DISTANCE' : '',
            parameters.batching ? '#define USE_BATCHING' : '',
            parameters.batchingColor ? '#define USE_BATCHING_COLOR' : '',
            parameters.instancing ? '#define USE_INSTANCING' : '',
            parameters.instancingColor ? '#define USE_INSTANCING_COLOR' : '',
            parameters.instancingMorph ? '#define USE_INSTANCING_MORPH' : '',
            parameters.useFog && parameters.fog ? '#define USE_FOG' : '',
            parameters.useFog && parameters.fogExp2 ? '#define FOG_EXP2' : '',
            parameters.map ? '#define USE_MAP' : '',
            parameters.envMap ? '#define USE_ENVMAP' : '',
            parameters.envMap ? '#define ' + envMapModeDefine : '',
            parameters.lightMap ? '#define USE_LIGHTMAP' : '',
            parameters.aoMap ? '#define USE_AOMAP' : '',
            parameters.bumpMap ? '#define USE_BUMPMAP' : '',
            parameters.normalMap ? '#define USE_NORMALMAP' : '',
            parameters.normalMapObjectSpace ? '#define USE_NORMALMAP_OBJECTSPACE' : '',
            parameters.normalMapTangentSpace ? '#define USE_NORMALMAP_TANGENTSPACE' : '',
            parameters.displacementMap ? '#define USE_DISPLACEMENTMAP' : '',
            parameters.emissiveMap ? '#define USE_EMISSIVEMAP' : '',
            parameters.anisotropy ? '#define USE_ANISOTROPY' : '',
            parameters.anisotropyMap ? '#define USE_ANISOTROPYMAP' : '',
            parameters.clearcoatMap ? '#define USE_CLEARCOATMAP' : '',
            parameters.clearcoatRoughnessMap ? '#define USE_CLEARCOAT_ROUGHNESSMAP' : '',
            parameters.clearcoatNormalMap ? '#define USE_CLEARCOAT_NORMALMAP' : '',
            parameters.iridescenceMap ? '#define USE_IRIDESCENCEMAP' : '',
            parameters.iridescenceThicknessMap ? '#define USE_IRIDESCENCE_THICKNESSMAP' : '',
            parameters.specularMap ? '#define USE_SPECULARMAP' : '',
            parameters.specularColorMap ? '#define USE_SPECULAR_COLORMAP' : '',
            parameters.specularIntensityMap ? '#define USE_SPECULAR_INTENSITYMAP' : '',
            parameters.roughnessMap ? '#define USE_ROUGHNESSMAP' : '',
            parameters.metalnessMap ? '#define USE_METALNESSMAP' : '',
            parameters.alphaMap ? '#define USE_ALPHAMAP' : '',
            parameters.alphaHash ? '#define USE_ALPHAHASH' : '',
            parameters.transmission ? '#define USE_TRANSMISSION' : '',
            parameters.transmissionMap ? '#define USE_TRANSMISSIONMAP' : '',
            parameters.thicknessMap ? '#define USE_THICKNESSMAP' : '',
            parameters.sheenColorMap ? '#define USE_SHEEN_COLORMAP' : '',
            parameters.sheenRoughnessMap ? '#define USE_SHEEN_ROUGHNESSMAP' : '',
            //
            parameters.mapUv ? '#define MAP_UV ' + parameters.mapUv : '',
            parameters.alphaMapUv ? '#define ALPHAMAP_UV ' + parameters.alphaMapUv : '',
            parameters.lightMapUv ? '#define LIGHTMAP_UV ' + parameters.lightMapUv : '',
            parameters.aoMapUv ? '#define AOMAP_UV ' + parameters.aoMapUv : '',
            parameters.emissiveMapUv ? '#define EMISSIVEMAP_UV ' + parameters.emissiveMapUv : '',
            parameters.bumpMapUv ? '#define BUMPMAP_UV ' + parameters.bumpMapUv : '',
            parameters.normalMapUv ? '#define NORMALMAP_UV ' + parameters.normalMapUv : '',
            parameters.displacementMapUv ? '#define DISPLACEMENTMAP_UV ' + parameters.displacementMapUv : '',
            parameters.metalnessMapUv ? '#define METALNESSMAP_UV ' + parameters.metalnessMapUv : '',
            parameters.roughnessMapUv ? '#define ROUGHNESSMAP_UV ' + parameters.roughnessMapUv : '',
            parameters.anisotropyMapUv ? '#define ANISOTROPYMAP_UV ' + parameters.anisotropyMapUv : '',
            parameters.clearcoatMapUv ? '#define CLEARCOATMAP_UV ' + parameters.clearcoatMapUv : '',
            parameters.clearcoatNormalMapUv ? '#define CLEARCOAT_NORMALMAP_UV ' + parameters.clearcoatNormalMapUv : '',
            parameters.clearcoatRoughnessMapUv ? '#define CLEARCOAT_ROUGHNESSMAP_UV ' + parameters.clearcoatRoughnessMapUv : '',
            parameters.iridescenceMapUv ? '#define IRIDESCENCEMAP_UV ' + parameters.iridescenceMapUv : '',
            parameters.iridescenceThicknessMapUv ? '#define IRIDESCENCE_THICKNESSMAP_UV ' + parameters.iridescenceThicknessMapUv : '',
            parameters.sheenColorMapUv ? '#define SHEEN_COLORMAP_UV ' + parameters.sheenColorMapUv : '',
            parameters.sheenRoughnessMapUv ? '#define SHEEN_ROUGHNESSMAP_UV ' + parameters.sheenRoughnessMapUv : '',
            parameters.specularMapUv ? '#define SPECULARMAP_UV ' + parameters.specularMapUv : '',
            parameters.specularColorMapUv ? '#define SPECULAR_COLORMAP_UV ' + parameters.specularColorMapUv : '',
            parameters.specularIntensityMapUv ? '#define SPECULAR_INTENSITYMAP_UV ' + parameters.specularIntensityMapUv : '',
            parameters.transmissionMapUv ? '#define TRANSMISSIONMAP_UV ' + parameters.transmissionMapUv : '',
            parameters.thicknessMapUv ? '#define THICKNESSMAP_UV ' + parameters.thicknessMapUv : '',
            //
            parameters.vertexTangents && parameters.flatShading === false ? '#define USE_TANGENT' : '',
            parameters.vertexColors ? '#define USE_COLOR' : '',
            parameters.vertexAlphas ? '#define USE_COLOR_ALPHA' : '',
            parameters.vertexUv1s ? '#define USE_UV1' : '',
            parameters.vertexUv2s ? '#define USE_UV2' : '',
            parameters.vertexUv3s ? '#define USE_UV3' : '',
            parameters.pointsUvs ? '#define USE_POINTS_UV' : '',
            parameters.flatShading ? '#define FLAT_SHADED' : '',
            parameters.skinning ? '#define USE_SKINNING' : '',
            parameters.morphTargets ? '#define USE_MORPHTARGETS' : '',
            parameters.morphNormals && parameters.flatShading === false ? '#define USE_MORPHNORMALS' : '',
            parameters.morphColors ? '#define USE_MORPHCOLORS' : '',
            parameters.morphTargetsCount > 0 ? '#define MORPHTARGETS_TEXTURE_STRIDE ' + parameters.morphTextureStride : '',
            parameters.morphTargetsCount > 0 ? '#define MORPHTARGETS_COUNT ' + parameters.morphTargetsCount : '',
            parameters.doubleSided ? '#define DOUBLE_SIDED' : '',
            parameters.flipSided ? '#define FLIP_SIDED' : '',
            parameters.shadowMapEnabled ? '#define USE_SHADOWMAP' : '',
            parameters.shadowMapEnabled ? '#define ' + shadowMapTypeDefine : '',
            parameters.sizeAttenuation ? '#define USE_SIZEATTENUATION' : '',
            parameters.numLightProbes > 0 ? '#define USE_LIGHT_PROBES' : '',
            parameters.logarithmicDepthBuffer ? '#define USE_LOGDEPTHBUF' : '',
            parameters.reverseDepthBuffer ? '#define USE_REVERSEDEPTHBUF' : '',
            'uniform mat4 modelMatrix;',
            'uniform mat4 modelViewMatrix;',
            'uniform mat4 projectionMatrix;',
            'uniform mat4 viewMatrix;',
            'uniform mat3 normalMatrix;',
            'uniform vec3 cameraPosition;',
            'uniform bool isOrthographic;',
            '#ifdef USE_INSTANCING',
            '	attribute mat4 instanceMatrix;',
            '#endif',
            '#ifdef USE_INSTANCING_COLOR',
            '	attribute vec3 instanceColor;',
            '#endif',
            '#ifdef USE_INSTANCING_MORPH',
            '	uniform sampler2D morphTexture;',
            '#endif',
            'attribute vec3 position;',
            'attribute vec3 normal;',
            'attribute vec2 uv;',
            '#ifdef USE_UV1',
            '	attribute vec2 uv1;',
            '#endif',
            '#ifdef USE_UV2',
            '	attribute vec2 uv2;',
            '#endif',
            '#ifdef USE_UV3',
            '	attribute vec2 uv3;',
            '#endif',
            '#ifdef USE_TANGENT',
            '	attribute vec4 tangent;',
            '#endif',
            '#if defined( USE_COLOR_ALPHA )',
            '	attribute vec4 color;',
            '#elif defined( USE_COLOR )',
            '	attribute vec3 color;',
            '#endif',
            '#ifdef USE_SKINNING',
            '	attribute vec4 skinIndex;',
            '	attribute vec4 skinWeight;',
            '#endif',
            '\n'
        ].filter($d5b33d7c30034067$var$filterEmptyLine).join('\n');
        prefixFragment = [
            $d5b33d7c30034067$var$generatePrecision(parameters),
            '#define SHADER_TYPE ' + parameters.shaderType,
            '#define SHADER_NAME ' + parameters.shaderName,
            customDefines,
            parameters.useFog && parameters.fog ? '#define USE_FOG' : '',
            parameters.useFog && parameters.fogExp2 ? '#define FOG_EXP2' : '',
            parameters.alphaToCoverage ? '#define ALPHA_TO_COVERAGE' : '',
            parameters.map ? '#define USE_MAP' : '',
            parameters.matcap ? '#define USE_MATCAP' : '',
            parameters.envMap ? '#define USE_ENVMAP' : '',
            parameters.envMap ? '#define ' + envMapTypeDefine : '',
            parameters.envMap ? '#define ' + envMapModeDefine : '',
            parameters.envMap ? '#define ' + envMapBlendingDefine : '',
            envMapCubeUVSize ? '#define CUBEUV_TEXEL_WIDTH ' + envMapCubeUVSize.texelWidth : '',
            envMapCubeUVSize ? '#define CUBEUV_TEXEL_HEIGHT ' + envMapCubeUVSize.texelHeight : '',
            envMapCubeUVSize ? '#define CUBEUV_MAX_MIP ' + envMapCubeUVSize.maxMip + '.0' : '',
            parameters.lightMap ? '#define USE_LIGHTMAP' : '',
            parameters.aoMap ? '#define USE_AOMAP' : '',
            parameters.bumpMap ? '#define USE_BUMPMAP' : '',
            parameters.normalMap ? '#define USE_NORMALMAP' : '',
            parameters.normalMapObjectSpace ? '#define USE_NORMALMAP_OBJECTSPACE' : '',
            parameters.normalMapTangentSpace ? '#define USE_NORMALMAP_TANGENTSPACE' : '',
            parameters.emissiveMap ? '#define USE_EMISSIVEMAP' : '',
            parameters.anisotropy ? '#define USE_ANISOTROPY' : '',
            parameters.anisotropyMap ? '#define USE_ANISOTROPYMAP' : '',
            parameters.clearcoat ? '#define USE_CLEARCOAT' : '',
            parameters.clearcoatMap ? '#define USE_CLEARCOATMAP' : '',
            parameters.clearcoatRoughnessMap ? '#define USE_CLEARCOAT_ROUGHNESSMAP' : '',
            parameters.clearcoatNormalMap ? '#define USE_CLEARCOAT_NORMALMAP' : '',
            parameters.dispersion ? '#define USE_DISPERSION' : '',
            parameters.iridescence ? '#define USE_IRIDESCENCE' : '',
            parameters.iridescenceMap ? '#define USE_IRIDESCENCEMAP' : '',
            parameters.iridescenceThicknessMap ? '#define USE_IRIDESCENCE_THICKNESSMAP' : '',
            parameters.specularMap ? '#define USE_SPECULARMAP' : '',
            parameters.specularColorMap ? '#define USE_SPECULAR_COLORMAP' : '',
            parameters.specularIntensityMap ? '#define USE_SPECULAR_INTENSITYMAP' : '',
            parameters.roughnessMap ? '#define USE_ROUGHNESSMAP' : '',
            parameters.metalnessMap ? '#define USE_METALNESSMAP' : '',
            parameters.alphaMap ? '#define USE_ALPHAMAP' : '',
            parameters.alphaTest ? '#define USE_ALPHATEST' : '',
            parameters.alphaHash ? '#define USE_ALPHAHASH' : '',
            parameters.sheen ? '#define USE_SHEEN' : '',
            parameters.sheenColorMap ? '#define USE_SHEEN_COLORMAP' : '',
            parameters.sheenRoughnessMap ? '#define USE_SHEEN_ROUGHNESSMAP' : '',
            parameters.transmission ? '#define USE_TRANSMISSION' : '',
            parameters.transmissionMap ? '#define USE_TRANSMISSIONMAP' : '',
            parameters.thicknessMap ? '#define USE_THICKNESSMAP' : '',
            parameters.vertexTangents && parameters.flatShading === false ? '#define USE_TANGENT' : '',
            parameters.vertexColors || parameters.instancingColor || parameters.batchingColor ? '#define USE_COLOR' : '',
            parameters.vertexAlphas ? '#define USE_COLOR_ALPHA' : '',
            parameters.vertexUv1s ? '#define USE_UV1' : '',
            parameters.vertexUv2s ? '#define USE_UV2' : '',
            parameters.vertexUv3s ? '#define USE_UV3' : '',
            parameters.pointsUvs ? '#define USE_POINTS_UV' : '',
            parameters.gradientMap ? '#define USE_GRADIENTMAP' : '',
            parameters.flatShading ? '#define FLAT_SHADED' : '',
            parameters.doubleSided ? '#define DOUBLE_SIDED' : '',
            parameters.flipSided ? '#define FLIP_SIDED' : '',
            parameters.shadowMapEnabled ? '#define USE_SHADOWMAP' : '',
            parameters.shadowMapEnabled ? '#define ' + shadowMapTypeDefine : '',
            parameters.premultipliedAlpha ? '#define PREMULTIPLIED_ALPHA' : '',
            parameters.numLightProbes > 0 ? '#define USE_LIGHT_PROBES' : '',
            parameters.decodeVideoTexture ? '#define DECODE_VIDEO_TEXTURE' : '',
            parameters.decodeVideoTextureEmissive ? '#define DECODE_VIDEO_TEXTURE_EMISSIVE' : '',
            parameters.logarithmicDepthBuffer ? '#define USE_LOGDEPTHBUF' : '',
            parameters.reverseDepthBuffer ? '#define USE_REVERSEDEPTHBUF' : '',
            'uniform mat4 viewMatrix;',
            'uniform vec3 cameraPosition;',
            'uniform bool isOrthographic;',
            parameters.toneMapping !== (0, $dyjou.NoToneMapping) ? '#define TONE_MAPPING' : '',
            parameters.toneMapping !== (0, $dyjou.NoToneMapping) ? $d5b33d7c30034067$export$955f9f2e84c43c8b['tonemapping_pars_fragment'] : '',
            parameters.toneMapping !== (0, $dyjou.NoToneMapping) ? $d5b33d7c30034067$var$getToneMappingFunction('toneMapping', parameters.toneMapping) : '',
            parameters.dithering ? '#define DITHERING' : '',
            parameters.opaque ? '#define OPAQUE' : '',
            $d5b33d7c30034067$export$955f9f2e84c43c8b['colorspace_pars_fragment'],
            $d5b33d7c30034067$var$getTexelEncodingFunction('linearToOutputTexel', parameters.outputColorSpace),
            $d5b33d7c30034067$var$getLuminanceFunction(),
            parameters.useDepthPacking ? '#define DEPTH_PACKING ' + parameters.depthPacking : '',
            '\n'
        ].filter($d5b33d7c30034067$var$filterEmptyLine).join('\n');
    }
    vertexShader = $d5b33d7c30034067$var$resolveIncludes(vertexShader);
    vertexShader = $d5b33d7c30034067$var$replaceLightNums(vertexShader, parameters);
    vertexShader = $d5b33d7c30034067$var$replaceClippingPlaneNums(vertexShader, parameters);
    fragmentShader = $d5b33d7c30034067$var$resolveIncludes(fragmentShader);
    fragmentShader = $d5b33d7c30034067$var$replaceLightNums(fragmentShader, parameters);
    fragmentShader = $d5b33d7c30034067$var$replaceClippingPlaneNums(fragmentShader, parameters);
    vertexShader = $d5b33d7c30034067$var$unrollLoops(vertexShader);
    fragmentShader = $d5b33d7c30034067$var$unrollLoops(fragmentShader);
    if (parameters.isRawShaderMaterial !== true) {
        // GLSL 3.0 conversion for built-in materials and ShaderMaterial
        versionString = '#version 300 es\n';
        prefixVertex = [
            customVertexExtensions,
            '#define attribute in',
            '#define varying out',
            '#define texture2D texture'
        ].join('\n') + '\n' + prefixVertex;
        prefixFragment = [
            '#define varying in',
            parameters.glslVersion === (0, $dyjou.GLSL3) ? '' : 'layout(location = 0) out highp vec4 pc_fragColor;',
            parameters.glslVersion === (0, $dyjou.GLSL3) ? '' : '#define gl_FragColor pc_fragColor',
            '#define gl_FragDepthEXT gl_FragDepth',
            '#define texture2D texture',
            '#define textureCube texture',
            '#define texture2DProj textureProj',
            '#define texture2DLodEXT textureLod',
            '#define texture2DProjLodEXT textureProjLod',
            '#define textureCubeLodEXT textureLod',
            '#define texture2DGradEXT textureGrad',
            '#define texture2DProjGradEXT textureProjGrad',
            '#define textureCubeGradEXT textureGrad'
        ].join('\n') + '\n' + prefixFragment;
    }
    const vertexGlsl = versionString + prefixVertex + vertexShader;
    const fragmentGlsl = versionString + prefixFragment + fragmentShader;
    // console.log( '*VERTEX*', vertexGlsl );
    // console.log( '*FRAGMENT*', fragmentGlsl );
    const glVertexShader = $d5b33d7c30034067$var$WebGLShader(gl, gl.VERTEX_SHADER, vertexGlsl);
    const glFragmentShader = $d5b33d7c30034067$var$WebGLShader(gl, gl.FRAGMENT_SHADER, fragmentGlsl);
    gl.attachShader(program, glVertexShader);
    gl.attachShader(program, glFragmentShader);
    // Force a particular attribute to index 0.
    if (parameters.index0AttributeName !== undefined) gl.bindAttribLocation(program, 0, parameters.index0AttributeName);
    else if (parameters.morphTargets === true) // programs with morphTargets displace position out of attribute 0
    gl.bindAttribLocation(program, 0, 'position');
    gl.linkProgram(program);
    function onFirstUse(self1) {
        // check for link errors
        if (renderer.debug.checkShaderErrors) {
            const programLog = gl.getProgramInfoLog(program).trim();
            const vertexLog = gl.getShaderInfoLog(glVertexShader).trim();
            const fragmentLog = gl.getShaderInfoLog(glFragmentShader).trim();
            let runnable = true;
            let haveDiagnostics = true;
            if (gl.getProgramParameter(program, gl.LINK_STATUS) === false) {
                runnable = false;
                if (typeof renderer.debug.onShaderError === 'function') renderer.debug.onShaderError(gl, program, glVertexShader, glFragmentShader);
                else {
                    // default error reporting
                    const vertexErrors = $d5b33d7c30034067$var$getShaderErrors(gl, glVertexShader, 'vertex');
                    const fragmentErrors = $d5b33d7c30034067$var$getShaderErrors(gl, glFragmentShader, 'fragment');
                    console.error('THREE.WebGLProgram: Shader Error ' + gl.getError() + ' - ' + 'VALIDATE_STATUS ' + gl.getProgramParameter(program, gl.VALIDATE_STATUS) + '\n\n' + 'Material Name: ' + self1.name + '\n' + 'Material Type: ' + self1.type + '\n\n' + 'Program Info Log: ' + programLog + '\n' + vertexErrors + '\n' + fragmentErrors);
                }
            } else if (programLog !== '') console.warn('THREE.WebGLProgram: Program Info Log:', programLog);
            else if (vertexLog === '' || fragmentLog === '') haveDiagnostics = false;
            if (haveDiagnostics) self1.diagnostics = {
                runnable: runnable,
                programLog: programLog,
                vertexShader: {
                    log: vertexLog,
                    prefix: prefixVertex
                },
                fragmentShader: {
                    log: fragmentLog,
                    prefix: prefixFragment
                }
            };
        }
        // Clean up
        // Crashes in iOS9 and iOS10. #18402
        // gl.detachShader( program, glVertexShader );
        // gl.detachShader( program, glFragmentShader );
        gl.deleteShader(glVertexShader);
        gl.deleteShader(glFragmentShader);
        cachedUniforms = new $d5b33d7c30034067$var$WebGLUniforms(gl, program);
        cachedAttributes = $d5b33d7c30034067$var$fetchAttributeLocations(gl, program);
    }
    // set up caching for uniform locations
    let cachedUniforms;
    this.getUniforms = function() {
        if (cachedUniforms === undefined) // Populates cachedUniforms and cachedAttributes
        onFirstUse(this);
        return cachedUniforms;
    };
    // set up caching for attribute locations
    let cachedAttributes;
    this.getAttributes = function() {
        if (cachedAttributes === undefined) // Populates cachedAttributes and cachedUniforms
        onFirstUse(this);
        return cachedAttributes;
    };
    // indicate when the program is ready to be used. if the KHR_parallel_shader_compile extension isn't supported,
    // flag the program as ready immediately. It may cause a stall when it's first used.
    let programReady = parameters.rendererExtensionParallelShaderCompile === false;
    this.isReady = function() {
        if (programReady === false) programReady = gl.getProgramParameter(program, $d5b33d7c30034067$var$COMPLETION_STATUS_KHR);
        return programReady;
    };
    // free resource
    this.destroy = function() {
        bindingStates.releaseStatesOfProgram(this);
        gl.deleteProgram(program);
        this.program = undefined;
    };
    //
    this.type = parameters.shaderType;
    this.name = parameters.shaderName;
    this.id = $d5b33d7c30034067$var$programIdCount++;
    this.cacheKey = cacheKey;
    this.usedTimes = 1;
    this.program = program;
    this.vertexShader = glVertexShader;
    this.fragmentShader = glFragmentShader;
    return this;
}
let $d5b33d7c30034067$var$_id = 0;
class $d5b33d7c30034067$var$WebGLShaderCache {
    constructor(){
        this.shaderCache = new Map();
        this.materialCache = new Map();
    }
    update(material) {
        const vertexShader = material.vertexShader;
        const fragmentShader = material.fragmentShader;
        const vertexShaderStage = this._getShaderStage(vertexShader);
        const fragmentShaderStage = this._getShaderStage(fragmentShader);
        const materialShaders = this._getShaderCacheForMaterial(material);
        if (materialShaders.has(vertexShaderStage) === false) {
            materialShaders.add(vertexShaderStage);
            vertexShaderStage.usedTimes++;
        }
        if (materialShaders.has(fragmentShaderStage) === false) {
            materialShaders.add(fragmentShaderStage);
            fragmentShaderStage.usedTimes++;
        }
        return this;
    }
    remove(material) {
        const materialShaders = this.materialCache.get(material);
        for (const shaderStage of materialShaders){
            shaderStage.usedTimes--;
            if (shaderStage.usedTimes === 0) this.shaderCache.delete(shaderStage.code);
        }
        this.materialCache.delete(material);
        return this;
    }
    getVertexShaderID(material) {
        return this._getShaderStage(material.vertexShader).id;
    }
    getFragmentShaderID(material) {
        return this._getShaderStage(material.fragmentShader).id;
    }
    dispose() {
        this.shaderCache.clear();
        this.materialCache.clear();
    }
    _getShaderCacheForMaterial(material) {
        const cache = this.materialCache;
        let set = cache.get(material);
        if (set === undefined) {
            set = new Set();
            cache.set(material, set);
        }
        return set;
    }
    _getShaderStage(code) {
        const cache = this.shaderCache;
        let stage = cache.get(code);
        if (stage === undefined) {
            stage = new $d5b33d7c30034067$var$WebGLShaderStage(code);
            cache.set(code, stage);
        }
        return stage;
    }
}
class $d5b33d7c30034067$var$WebGLShaderStage {
    constructor(code){
        this.id = $d5b33d7c30034067$var$_id++;
        this.code = code;
        this.usedTimes = 0;
    }
}
function $d5b33d7c30034067$var$WebGLPrograms(renderer, cubemaps, cubeuvmaps, extensions, capabilities, bindingStates, clipping) {
    const _programLayers = new (0, $dyjou.Layers)();
    const _customShaders = new $d5b33d7c30034067$var$WebGLShaderCache();
    const _activeChannels = new Set();
    const programs = [];
    const logarithmicDepthBuffer = capabilities.logarithmicDepthBuffer;
    const SUPPORTS_VERTEX_TEXTURES = capabilities.vertexTextures;
    let precision = capabilities.precision;
    const shaderIDs = {
        MeshDepthMaterial: 'depth',
        MeshDistanceMaterial: 'distanceRGBA',
        MeshNormalMaterial: 'normal',
        MeshBasicMaterial: 'basic',
        MeshLambertMaterial: 'lambert',
        MeshPhongMaterial: 'phong',
        MeshToonMaterial: 'toon',
        MeshStandardMaterial: 'physical',
        MeshPhysicalMaterial: 'physical',
        MeshMatcapMaterial: 'matcap',
        LineBasicMaterial: 'basic',
        LineDashedMaterial: 'dashed',
        PointsMaterial: 'points',
        ShadowMaterial: 'shadow',
        SpriteMaterial: 'sprite'
    };
    function getChannel(value) {
        _activeChannels.add(value);
        if (value === 0) return 'uv';
        return `uv${value}`;
    }
    function getParameters(material, lights, shadows, scene, object) {
        const fog = scene.fog;
        const geometry = object.geometry;
        const environment = material.isMeshStandardMaterial ? scene.environment : null;
        const envMap = (material.isMeshStandardMaterial ? cubeuvmaps : cubemaps).get(material.envMap || environment);
        const envMapCubeUVHeight = !!envMap && envMap.mapping === (0, $dyjou.CubeUVReflectionMapping) ? envMap.image.height : null;
        const shaderID = shaderIDs[material.type];
        // heuristics to create shader parameters according to lights in the scene
        // (not to blow over maxLights budget)
        if (material.precision !== null) {
            precision = capabilities.getMaxPrecision(material.precision);
            if (precision !== material.precision) console.warn('THREE.WebGLProgram.getParameters:', material.precision, 'not supported, using', precision, 'instead.');
        }
        //
        const morphAttribute = geometry.morphAttributes.position || geometry.morphAttributes.normal || geometry.morphAttributes.color;
        const morphTargetsCount = morphAttribute !== undefined ? morphAttribute.length : 0;
        let morphTextureStride = 0;
        if (geometry.morphAttributes.position !== undefined) morphTextureStride = 1;
        if (geometry.morphAttributes.normal !== undefined) morphTextureStride = 2;
        if (geometry.morphAttributes.color !== undefined) morphTextureStride = 3;
        //
        let vertexShader, fragmentShader;
        let customVertexShaderID, customFragmentShaderID;
        if (shaderID) {
            const shader = $d5b33d7c30034067$export$bee4a7d47f8f5014[shaderID];
            vertexShader = shader.vertexShader;
            fragmentShader = shader.fragmentShader;
        } else {
            vertexShader = material.vertexShader;
            fragmentShader = material.fragmentShader;
            _customShaders.update(material);
            customVertexShaderID = _customShaders.getVertexShaderID(material);
            customFragmentShaderID = _customShaders.getFragmentShaderID(material);
        }
        const currentRenderTarget = renderer.getRenderTarget();
        const reverseDepthBuffer = renderer.state.buffers.depth.getReversed();
        const IS_INSTANCEDMESH = object.isInstancedMesh === true;
        const IS_BATCHEDMESH = object.isBatchedMesh === true;
        const HAS_MAP = !!material.map;
        const HAS_MATCAP = !!material.matcap;
        const HAS_ENVMAP = !!envMap;
        const HAS_AOMAP = !!material.aoMap;
        const HAS_LIGHTMAP = !!material.lightMap;
        const HAS_BUMPMAP = !!material.bumpMap;
        const HAS_NORMALMAP = !!material.normalMap;
        const HAS_DISPLACEMENTMAP = !!material.displacementMap;
        const HAS_EMISSIVEMAP = !!material.emissiveMap;
        const HAS_METALNESSMAP = !!material.metalnessMap;
        const HAS_ROUGHNESSMAP = !!material.roughnessMap;
        const HAS_ANISOTROPY = material.anisotropy > 0;
        const HAS_CLEARCOAT = material.clearcoat > 0;
        const HAS_DISPERSION = material.dispersion > 0;
        const HAS_IRIDESCENCE = material.iridescence > 0;
        const HAS_SHEEN = material.sheen > 0;
        const HAS_TRANSMISSION = material.transmission > 0;
        const HAS_ANISOTROPYMAP = HAS_ANISOTROPY && !!material.anisotropyMap;
        const HAS_CLEARCOATMAP = HAS_CLEARCOAT && !!material.clearcoatMap;
        const HAS_CLEARCOAT_NORMALMAP = HAS_CLEARCOAT && !!material.clearcoatNormalMap;
        const HAS_CLEARCOAT_ROUGHNESSMAP = HAS_CLEARCOAT && !!material.clearcoatRoughnessMap;
        const HAS_IRIDESCENCEMAP = HAS_IRIDESCENCE && !!material.iridescenceMap;
        const HAS_IRIDESCENCE_THICKNESSMAP = HAS_IRIDESCENCE && !!material.iridescenceThicknessMap;
        const HAS_SHEEN_COLORMAP = HAS_SHEEN && !!material.sheenColorMap;
        const HAS_SHEEN_ROUGHNESSMAP = HAS_SHEEN && !!material.sheenRoughnessMap;
        const HAS_SPECULARMAP = !!material.specularMap;
        const HAS_SPECULAR_COLORMAP = !!material.specularColorMap;
        const HAS_SPECULAR_INTENSITYMAP = !!material.specularIntensityMap;
        const HAS_TRANSMISSIONMAP = HAS_TRANSMISSION && !!material.transmissionMap;
        const HAS_THICKNESSMAP = HAS_TRANSMISSION && !!material.thicknessMap;
        const HAS_GRADIENTMAP = !!material.gradientMap;
        const HAS_ALPHAMAP = !!material.alphaMap;
        const HAS_ALPHATEST = material.alphaTest > 0;
        const HAS_ALPHAHASH = !!material.alphaHash;
        const HAS_EXTENSIONS = !!material.extensions;
        let toneMapping = (0, $dyjou.NoToneMapping);
        if (material.toneMapped) {
            if (currentRenderTarget === null || currentRenderTarget.isXRRenderTarget === true) toneMapping = renderer.toneMapping;
        }
        const parameters = {
            shaderID: shaderID,
            shaderType: material.type,
            shaderName: material.name,
            vertexShader: vertexShader,
            fragmentShader: fragmentShader,
            defines: material.defines,
            customVertexShaderID: customVertexShaderID,
            customFragmentShaderID: customFragmentShaderID,
            isRawShaderMaterial: material.isRawShaderMaterial === true,
            glslVersion: material.glslVersion,
            precision: precision,
            batching: IS_BATCHEDMESH,
            batchingColor: IS_BATCHEDMESH && object._colorsTexture !== null,
            instancing: IS_INSTANCEDMESH,
            instancingColor: IS_INSTANCEDMESH && object.instanceColor !== null,
            instancingMorph: IS_INSTANCEDMESH && object.morphTexture !== null,
            supportsVertexTextures: SUPPORTS_VERTEX_TEXTURES,
            outputColorSpace: currentRenderTarget === null ? renderer.outputColorSpace : currentRenderTarget.isXRRenderTarget === true ? currentRenderTarget.texture.colorSpace : (0, $dyjou.LinearSRGBColorSpace),
            alphaToCoverage: !!material.alphaToCoverage,
            map: HAS_MAP,
            matcap: HAS_MATCAP,
            envMap: HAS_ENVMAP,
            envMapMode: HAS_ENVMAP && envMap.mapping,
            envMapCubeUVHeight: envMapCubeUVHeight,
            aoMap: HAS_AOMAP,
            lightMap: HAS_LIGHTMAP,
            bumpMap: HAS_BUMPMAP,
            normalMap: HAS_NORMALMAP,
            displacementMap: SUPPORTS_VERTEX_TEXTURES && HAS_DISPLACEMENTMAP,
            emissiveMap: HAS_EMISSIVEMAP,
            normalMapObjectSpace: HAS_NORMALMAP && material.normalMapType === (0, $dyjou.ObjectSpaceNormalMap),
            normalMapTangentSpace: HAS_NORMALMAP && material.normalMapType === (0, $dyjou.TangentSpaceNormalMap),
            metalnessMap: HAS_METALNESSMAP,
            roughnessMap: HAS_ROUGHNESSMAP,
            anisotropy: HAS_ANISOTROPY,
            anisotropyMap: HAS_ANISOTROPYMAP,
            clearcoat: HAS_CLEARCOAT,
            clearcoatMap: HAS_CLEARCOATMAP,
            clearcoatNormalMap: HAS_CLEARCOAT_NORMALMAP,
            clearcoatRoughnessMap: HAS_CLEARCOAT_ROUGHNESSMAP,
            dispersion: HAS_DISPERSION,
            iridescence: HAS_IRIDESCENCE,
            iridescenceMap: HAS_IRIDESCENCEMAP,
            iridescenceThicknessMap: HAS_IRIDESCENCE_THICKNESSMAP,
            sheen: HAS_SHEEN,
            sheenColorMap: HAS_SHEEN_COLORMAP,
            sheenRoughnessMap: HAS_SHEEN_ROUGHNESSMAP,
            specularMap: HAS_SPECULARMAP,
            specularColorMap: HAS_SPECULAR_COLORMAP,
            specularIntensityMap: HAS_SPECULAR_INTENSITYMAP,
            transmission: HAS_TRANSMISSION,
            transmissionMap: HAS_TRANSMISSIONMAP,
            thicknessMap: HAS_THICKNESSMAP,
            gradientMap: HAS_GRADIENTMAP,
            opaque: material.transparent === false && material.blending === (0, $dyjou.NormalBlending) && material.alphaToCoverage === false,
            alphaMap: HAS_ALPHAMAP,
            alphaTest: HAS_ALPHATEST,
            alphaHash: HAS_ALPHAHASH,
            combine: material.combine,
            //
            mapUv: HAS_MAP && getChannel(material.map.channel),
            aoMapUv: HAS_AOMAP && getChannel(material.aoMap.channel),
            lightMapUv: HAS_LIGHTMAP && getChannel(material.lightMap.channel),
            bumpMapUv: HAS_BUMPMAP && getChannel(material.bumpMap.channel),
            normalMapUv: HAS_NORMALMAP && getChannel(material.normalMap.channel),
            displacementMapUv: HAS_DISPLACEMENTMAP && getChannel(material.displacementMap.channel),
            emissiveMapUv: HAS_EMISSIVEMAP && getChannel(material.emissiveMap.channel),
            metalnessMapUv: HAS_METALNESSMAP && getChannel(material.metalnessMap.channel),
            roughnessMapUv: HAS_ROUGHNESSMAP && getChannel(material.roughnessMap.channel),
            anisotropyMapUv: HAS_ANISOTROPYMAP && getChannel(material.anisotropyMap.channel),
            clearcoatMapUv: HAS_CLEARCOATMAP && getChannel(material.clearcoatMap.channel),
            clearcoatNormalMapUv: HAS_CLEARCOAT_NORMALMAP && getChannel(material.clearcoatNormalMap.channel),
            clearcoatRoughnessMapUv: HAS_CLEARCOAT_ROUGHNESSMAP && getChannel(material.clearcoatRoughnessMap.channel),
            iridescenceMapUv: HAS_IRIDESCENCEMAP && getChannel(material.iridescenceMap.channel),
            iridescenceThicknessMapUv: HAS_IRIDESCENCE_THICKNESSMAP && getChannel(material.iridescenceThicknessMap.channel),
            sheenColorMapUv: HAS_SHEEN_COLORMAP && getChannel(material.sheenColorMap.channel),
            sheenRoughnessMapUv: HAS_SHEEN_ROUGHNESSMAP && getChannel(material.sheenRoughnessMap.channel),
            specularMapUv: HAS_SPECULARMAP && getChannel(material.specularMap.channel),
            specularColorMapUv: HAS_SPECULAR_COLORMAP && getChannel(material.specularColorMap.channel),
            specularIntensityMapUv: HAS_SPECULAR_INTENSITYMAP && getChannel(material.specularIntensityMap.channel),
            transmissionMapUv: HAS_TRANSMISSIONMAP && getChannel(material.transmissionMap.channel),
            thicknessMapUv: HAS_THICKNESSMAP && getChannel(material.thicknessMap.channel),
            alphaMapUv: HAS_ALPHAMAP && getChannel(material.alphaMap.channel),
            //
            vertexTangents: !!geometry.attributes.tangent && (HAS_NORMALMAP || HAS_ANISOTROPY),
            vertexColors: material.vertexColors,
            vertexAlphas: material.vertexColors === true && !!geometry.attributes.color && geometry.attributes.color.itemSize === 4,
            pointsUvs: object.isPoints === true && !!geometry.attributes.uv && (HAS_MAP || HAS_ALPHAMAP),
            fog: !!fog,
            useFog: material.fog === true,
            fogExp2: !!fog && fog.isFogExp2,
            flatShading: material.flatShading === true,
            sizeAttenuation: material.sizeAttenuation === true,
            logarithmicDepthBuffer: logarithmicDepthBuffer,
            reverseDepthBuffer: reverseDepthBuffer,
            skinning: object.isSkinnedMesh === true,
            morphTargets: geometry.morphAttributes.position !== undefined,
            morphNormals: geometry.morphAttributes.normal !== undefined,
            morphColors: geometry.morphAttributes.color !== undefined,
            morphTargetsCount: morphTargetsCount,
            morphTextureStride: morphTextureStride,
            numDirLights: lights.directional.length,
            numPointLights: lights.point.length,
            numSpotLights: lights.spot.length,
            numSpotLightMaps: lights.spotLightMap.length,
            numRectAreaLights: lights.rectArea.length,
            numHemiLights: lights.hemi.length,
            numDirLightShadows: lights.directionalShadowMap.length,
            numPointLightShadows: lights.pointShadowMap.length,
            numSpotLightShadows: lights.spotShadowMap.length,
            numSpotLightShadowsWithMaps: lights.numSpotLightShadowsWithMaps,
            numLightProbes: lights.numLightProbes,
            numClippingPlanes: clipping.numPlanes,
            numClipIntersection: clipping.numIntersection,
            dithering: material.dithering,
            shadowMapEnabled: renderer.shadowMap.enabled && shadows.length > 0,
            shadowMapType: renderer.shadowMap.type,
            toneMapping: toneMapping,
            decodeVideoTexture: HAS_MAP && material.map.isVideoTexture === true && (0, $dyjou.ColorManagement).getTransfer(material.map.colorSpace) === (0, $dyjou.SRGBTransfer),
            decodeVideoTextureEmissive: HAS_EMISSIVEMAP && material.emissiveMap.isVideoTexture === true && (0, $dyjou.ColorManagement).getTransfer(material.emissiveMap.colorSpace) === (0, $dyjou.SRGBTransfer),
            premultipliedAlpha: material.premultipliedAlpha,
            doubleSided: material.side === (0, $dyjou.DoubleSide),
            flipSided: material.side === (0, $dyjou.BackSide),
            useDepthPacking: material.depthPacking >= 0,
            depthPacking: material.depthPacking || 0,
            index0AttributeName: material.index0AttributeName,
            extensionClipCullDistance: HAS_EXTENSIONS && material.extensions.clipCullDistance === true && extensions.has('WEBGL_clip_cull_distance'),
            extensionMultiDraw: (HAS_EXTENSIONS && material.extensions.multiDraw === true || IS_BATCHEDMESH) && extensions.has('WEBGL_multi_draw'),
            rendererExtensionParallelShaderCompile: extensions.has('KHR_parallel_shader_compile'),
            customProgramCacheKey: material.customProgramCacheKey()
        };
        // the usage of getChannel() determines the active texture channels for this shader
        parameters.vertexUv1s = _activeChannels.has(1);
        parameters.vertexUv2s = _activeChannels.has(2);
        parameters.vertexUv3s = _activeChannels.has(3);
        _activeChannels.clear();
        return parameters;
    }
    function getProgramCacheKey(parameters) {
        const array = [];
        if (parameters.shaderID) array.push(parameters.shaderID);
        else {
            array.push(parameters.customVertexShaderID);
            array.push(parameters.customFragmentShaderID);
        }
        if (parameters.defines !== undefined) for(const name in parameters.defines){
            array.push(name);
            array.push(parameters.defines[name]);
        }
        if (parameters.isRawShaderMaterial === false) {
            getProgramCacheKeyParameters(array, parameters);
            getProgramCacheKeyBooleans(array, parameters);
            array.push(renderer.outputColorSpace);
        }
        array.push(parameters.customProgramCacheKey);
        return array.join();
    }
    function getProgramCacheKeyParameters(array, parameters) {
        array.push(parameters.precision);
        array.push(parameters.outputColorSpace);
        array.push(parameters.envMapMode);
        array.push(parameters.envMapCubeUVHeight);
        array.push(parameters.mapUv);
        array.push(parameters.alphaMapUv);
        array.push(parameters.lightMapUv);
        array.push(parameters.aoMapUv);
        array.push(parameters.bumpMapUv);
        array.push(parameters.normalMapUv);
        array.push(parameters.displacementMapUv);
        array.push(parameters.emissiveMapUv);
        array.push(parameters.metalnessMapUv);
        array.push(parameters.roughnessMapUv);
        array.push(parameters.anisotropyMapUv);
        array.push(parameters.clearcoatMapUv);
        array.push(parameters.clearcoatNormalMapUv);
        array.push(parameters.clearcoatRoughnessMapUv);
        array.push(parameters.iridescenceMapUv);
        array.push(parameters.iridescenceThicknessMapUv);
        array.push(parameters.sheenColorMapUv);
        array.push(parameters.sheenRoughnessMapUv);
        array.push(parameters.specularMapUv);
        array.push(parameters.specularColorMapUv);
        array.push(parameters.specularIntensityMapUv);
        array.push(parameters.transmissionMapUv);
        array.push(parameters.thicknessMapUv);
        array.push(parameters.combine);
        array.push(parameters.fogExp2);
        array.push(parameters.sizeAttenuation);
        array.push(parameters.morphTargetsCount);
        array.push(parameters.morphAttributeCount);
        array.push(parameters.numDirLights);
        array.push(parameters.numPointLights);
        array.push(parameters.numSpotLights);
        array.push(parameters.numSpotLightMaps);
        array.push(parameters.numHemiLights);
        array.push(parameters.numRectAreaLights);
        array.push(parameters.numDirLightShadows);
        array.push(parameters.numPointLightShadows);
        array.push(parameters.numSpotLightShadows);
        array.push(parameters.numSpotLightShadowsWithMaps);
        array.push(parameters.numLightProbes);
        array.push(parameters.shadowMapType);
        array.push(parameters.toneMapping);
        array.push(parameters.numClippingPlanes);
        array.push(parameters.numClipIntersection);
        array.push(parameters.depthPacking);
    }
    function getProgramCacheKeyBooleans(array, parameters) {
        _programLayers.disableAll();
        if (parameters.supportsVertexTextures) _programLayers.enable(0);
        if (parameters.instancing) _programLayers.enable(1);
        if (parameters.instancingColor) _programLayers.enable(2);
        if (parameters.instancingMorph) _programLayers.enable(3);
        if (parameters.matcap) _programLayers.enable(4);
        if (parameters.envMap) _programLayers.enable(5);
        if (parameters.normalMapObjectSpace) _programLayers.enable(6);
        if (parameters.normalMapTangentSpace) _programLayers.enable(7);
        if (parameters.clearcoat) _programLayers.enable(8);
        if (parameters.iridescence) _programLayers.enable(9);
        if (parameters.alphaTest) _programLayers.enable(10);
        if (parameters.vertexColors) _programLayers.enable(11);
        if (parameters.vertexAlphas) _programLayers.enable(12);
        if (parameters.vertexUv1s) _programLayers.enable(13);
        if (parameters.vertexUv2s) _programLayers.enable(14);
        if (parameters.vertexUv3s) _programLayers.enable(15);
        if (parameters.vertexTangents) _programLayers.enable(16);
        if (parameters.anisotropy) _programLayers.enable(17);
        if (parameters.alphaHash) _programLayers.enable(18);
        if (parameters.batching) _programLayers.enable(19);
        if (parameters.dispersion) _programLayers.enable(20);
        if (parameters.batchingColor) _programLayers.enable(21);
        array.push(_programLayers.mask);
        _programLayers.disableAll();
        if (parameters.fog) _programLayers.enable(0);
        if (parameters.useFog) _programLayers.enable(1);
        if (parameters.flatShading) _programLayers.enable(2);
        if (parameters.logarithmicDepthBuffer) _programLayers.enable(3);
        if (parameters.reverseDepthBuffer) _programLayers.enable(4);
        if (parameters.skinning) _programLayers.enable(5);
        if (parameters.morphTargets) _programLayers.enable(6);
        if (parameters.morphNormals) _programLayers.enable(7);
        if (parameters.morphColors) _programLayers.enable(8);
        if (parameters.premultipliedAlpha) _programLayers.enable(9);
        if (parameters.shadowMapEnabled) _programLayers.enable(10);
        if (parameters.doubleSided) _programLayers.enable(11);
        if (parameters.flipSided) _programLayers.enable(12);
        if (parameters.useDepthPacking) _programLayers.enable(13);
        if (parameters.dithering) _programLayers.enable(14);
        if (parameters.transmission) _programLayers.enable(15);
        if (parameters.sheen) _programLayers.enable(16);
        if (parameters.opaque) _programLayers.enable(17);
        if (parameters.pointsUvs) _programLayers.enable(18);
        if (parameters.decodeVideoTexture) _programLayers.enable(19);
        if (parameters.decodeVideoTextureEmissive) _programLayers.enable(20);
        if (parameters.alphaToCoverage) _programLayers.enable(21);
        array.push(_programLayers.mask);
    }
    function getUniforms(material) {
        const shaderID = shaderIDs[material.type];
        let uniforms;
        if (shaderID) {
            const shader = $d5b33d7c30034067$export$bee4a7d47f8f5014[shaderID];
            uniforms = (0, $dyjou.UniformsUtils).clone(shader.uniforms);
        } else uniforms = material.uniforms;
        return uniforms;
    }
    function acquireProgram(parameters, cacheKey) {
        let program;
        // Check if code has been already compiled
        for(let p = 0, pl = programs.length; p < pl; p++){
            const preexistingProgram = programs[p];
            if (preexistingProgram.cacheKey === cacheKey) {
                program = preexistingProgram;
                ++program.usedTimes;
                break;
            }
        }
        if (program === undefined) {
            program = new $d5b33d7c30034067$var$WebGLProgram(renderer, cacheKey, parameters, bindingStates);
            programs.push(program);
        }
        return program;
    }
    function releaseProgram(program) {
        if (--program.usedTimes === 0) {
            // Remove from unordered set
            const i = programs.indexOf(program);
            programs[i] = programs[programs.length - 1];
            programs.pop();
            // Free WebGL resources
            program.destroy();
        }
    }
    function releaseShaderCache(material) {
        _customShaders.remove(material);
    }
    function dispose() {
        _customShaders.dispose();
    }
    return {
        getParameters: getParameters,
        getProgramCacheKey: getProgramCacheKey,
        getUniforms: getUniforms,
        acquireProgram: acquireProgram,
        releaseProgram: releaseProgram,
        releaseShaderCache: releaseShaderCache,
        // Exposed for resource monitoring & error feedback via renderer.info:
        programs: programs,
        dispose: dispose
    };
}
function $d5b33d7c30034067$var$WebGLProperties() {
    let properties = new WeakMap();
    function has(object) {
        return properties.has(object);
    }
    function get(object) {
        let map = properties.get(object);
        if (map === undefined) {
            map = {};
            properties.set(object, map);
        }
        return map;
    }
    function remove(object) {
        properties.delete(object);
    }
    function update(object, key, value) {
        properties.get(object)[key] = value;
    }
    function dispose() {
        properties = new WeakMap();
    }
    return {
        has: has,
        get: get,
        remove: remove,
        update: update,
        dispose: dispose
    };
}
function $d5b33d7c30034067$var$painterSortStable(a, b) {
    if (a.groupOrder !== b.groupOrder) return a.groupOrder - b.groupOrder;
    else if (a.renderOrder !== b.renderOrder) return a.renderOrder - b.renderOrder;
    else if (a.material.id !== b.material.id) return a.material.id - b.material.id;
    else if (a.z !== b.z) return a.z - b.z;
    else return a.id - b.id;
}
function $d5b33d7c30034067$var$reversePainterSortStable(a, b) {
    if (a.groupOrder !== b.groupOrder) return a.groupOrder - b.groupOrder;
    else if (a.renderOrder !== b.renderOrder) return a.renderOrder - b.renderOrder;
    else if (a.z !== b.z) return b.z - a.z;
    else return a.id - b.id;
}
function $d5b33d7c30034067$var$WebGLRenderList() {
    const renderItems = [];
    let renderItemsIndex = 0;
    const opaque = [];
    const transmissive = [];
    const transparent = [];
    function init() {
        renderItemsIndex = 0;
        opaque.length = 0;
        transmissive.length = 0;
        transparent.length = 0;
    }
    function getNextRenderItem(object, geometry, material, groupOrder, z, group) {
        let renderItem = renderItems[renderItemsIndex];
        if (renderItem === undefined) {
            renderItem = {
                id: object.id,
                object: object,
                geometry: geometry,
                material: material,
                groupOrder: groupOrder,
                renderOrder: object.renderOrder,
                z: z,
                group: group
            };
            renderItems[renderItemsIndex] = renderItem;
        } else {
            renderItem.id = object.id;
            renderItem.object = object;
            renderItem.geometry = geometry;
            renderItem.material = material;
            renderItem.groupOrder = groupOrder;
            renderItem.renderOrder = object.renderOrder;
            renderItem.z = z;
            renderItem.group = group;
        }
        renderItemsIndex++;
        return renderItem;
    }
    function push(object, geometry, material, groupOrder, z, group) {
        const renderItem = getNextRenderItem(object, geometry, material, groupOrder, z, group);
        if (material.transmission > 0.0) transmissive.push(renderItem);
        else if (material.transparent === true) transparent.push(renderItem);
        else opaque.push(renderItem);
    }
    function unshift(object, geometry, material, groupOrder, z, group) {
        const renderItem = getNextRenderItem(object, geometry, material, groupOrder, z, group);
        if (material.transmission > 0.0) transmissive.unshift(renderItem);
        else if (material.transparent === true) transparent.unshift(renderItem);
        else opaque.unshift(renderItem);
    }
    function sort(customOpaqueSort, customTransparentSort) {
        if (opaque.length > 1) opaque.sort(customOpaqueSort || $d5b33d7c30034067$var$painterSortStable);
        if (transmissive.length > 1) transmissive.sort(customTransparentSort || $d5b33d7c30034067$var$reversePainterSortStable);
        if (transparent.length > 1) transparent.sort(customTransparentSort || $d5b33d7c30034067$var$reversePainterSortStable);
    }
    function finish() {
        // Clear references from inactive renderItems in the list
        for(let i = renderItemsIndex, il = renderItems.length; i < il; i++){
            const renderItem = renderItems[i];
            if (renderItem.id === null) break;
            renderItem.id = null;
            renderItem.object = null;
            renderItem.geometry = null;
            renderItem.material = null;
            renderItem.group = null;
        }
    }
    return {
        opaque: opaque,
        transmissive: transmissive,
        transparent: transparent,
        init: init,
        push: push,
        unshift: unshift,
        finish: finish,
        sort: sort
    };
}
function $d5b33d7c30034067$var$WebGLRenderLists() {
    let lists = new WeakMap();
    function get(scene, renderCallDepth) {
        const listArray = lists.get(scene);
        let list;
        if (listArray === undefined) {
            list = new $d5b33d7c30034067$var$WebGLRenderList();
            lists.set(scene, [
                list
            ]);
        } else if (renderCallDepth >= listArray.length) {
            list = new $d5b33d7c30034067$var$WebGLRenderList();
            listArray.push(list);
        } else list = listArray[renderCallDepth];
        return list;
    }
    function dispose() {
        lists = new WeakMap();
    }
    return {
        get: get,
        dispose: dispose
    };
}
function $d5b33d7c30034067$var$UniformsCache() {
    const lights = {};
    return {
        get: function(light) {
            if (lights[light.id] !== undefined) return lights[light.id];
            let uniforms;
            switch(light.type){
                case 'DirectionalLight':
                    uniforms = {
                        direction: new (0, $dyjou.Vector3)(),
                        color: new (0, $dyjou.Color)()
                    };
                    break;
                case 'SpotLight':
                    uniforms = {
                        position: new (0, $dyjou.Vector3)(),
                        direction: new (0, $dyjou.Vector3)(),
                        color: new (0, $dyjou.Color)(),
                        distance: 0,
                        coneCos: 0,
                        penumbraCos: 0,
                        decay: 0
                    };
                    break;
                case 'PointLight':
                    uniforms = {
                        position: new (0, $dyjou.Vector3)(),
                        color: new (0, $dyjou.Color)(),
                        distance: 0,
                        decay: 0
                    };
                    break;
                case 'HemisphereLight':
                    uniforms = {
                        direction: new (0, $dyjou.Vector3)(),
                        skyColor: new (0, $dyjou.Color)(),
                        groundColor: new (0, $dyjou.Color)()
                    };
                    break;
                case 'RectAreaLight':
                    uniforms = {
                        color: new (0, $dyjou.Color)(),
                        position: new (0, $dyjou.Vector3)(),
                        halfWidth: new (0, $dyjou.Vector3)(),
                        halfHeight: new (0, $dyjou.Vector3)()
                    };
                    break;
            }
            lights[light.id] = uniforms;
            return uniforms;
        }
    };
}
function $d5b33d7c30034067$var$ShadowUniformsCache() {
    const lights = {};
    return {
        get: function(light) {
            if (lights[light.id] !== undefined) return lights[light.id];
            let uniforms;
            switch(light.type){
                case 'DirectionalLight':
                    uniforms = {
                        shadowIntensity: 1,
                        shadowBias: 0,
                        shadowNormalBias: 0,
                        shadowRadius: 1,
                        shadowMapSize: new (0, $dyjou.Vector2)()
                    };
                    break;
                case 'SpotLight':
                    uniforms = {
                        shadowIntensity: 1,
                        shadowBias: 0,
                        shadowNormalBias: 0,
                        shadowRadius: 1,
                        shadowMapSize: new (0, $dyjou.Vector2)()
                    };
                    break;
                case 'PointLight':
                    uniforms = {
                        shadowIntensity: 1,
                        shadowBias: 0,
                        shadowNormalBias: 0,
                        shadowRadius: 1,
                        shadowMapSize: new (0, $dyjou.Vector2)(),
                        shadowCameraNear: 1,
                        shadowCameraFar: 1000
                    };
                    break;
            }
            lights[light.id] = uniforms;
            return uniforms;
        }
    };
}
let $d5b33d7c30034067$var$nextVersion = 0;
function $d5b33d7c30034067$var$shadowCastingAndTexturingLightsFirst(lightA, lightB) {
    return (lightB.castShadow ? 2 : 0) - (lightA.castShadow ? 2 : 0) + (lightB.map ? 1 : 0) - (lightA.map ? 1 : 0);
}
function $d5b33d7c30034067$var$WebGLLights(extensions) {
    const cache = new $d5b33d7c30034067$var$UniformsCache();
    const shadowCache = $d5b33d7c30034067$var$ShadowUniformsCache();
    const state = {
        version: 0,
        hash: {
            directionalLength: -1,
            pointLength: -1,
            spotLength: -1,
            rectAreaLength: -1,
            hemiLength: -1,
            numDirectionalShadows: -1,
            numPointShadows: -1,
            numSpotShadows: -1,
            numSpotMaps: -1,
            numLightProbes: -1
        },
        ambient: [
            0,
            0,
            0
        ],
        probe: [],
        directional: [],
        directionalShadow: [],
        directionalShadowMap: [],
        directionalShadowMatrix: [],
        spot: [],
        spotLightMap: [],
        spotShadow: [],
        spotShadowMap: [],
        spotLightMatrix: [],
        rectArea: [],
        rectAreaLTC1: null,
        rectAreaLTC2: null,
        point: [],
        pointShadow: [],
        pointShadowMap: [],
        pointShadowMatrix: [],
        hemi: [],
        numSpotLightShadowsWithMaps: 0,
        numLightProbes: 0
    };
    for(let i = 0; i < 9; i++)state.probe.push(new (0, $dyjou.Vector3)());
    const vector3 = new (0, $dyjou.Vector3)();
    const matrix4 = new (0, $dyjou.Matrix4)();
    const matrix42 = new (0, $dyjou.Matrix4)();
    function setup(lights) {
        let r = 0, g = 0, b = 0;
        for(let i = 0; i < 9; i++)state.probe[i].set(0, 0, 0);
        let directionalLength = 0;
        let pointLength = 0;
        let spotLength = 0;
        let rectAreaLength = 0;
        let hemiLength = 0;
        let numDirectionalShadows = 0;
        let numPointShadows = 0;
        let numSpotShadows = 0;
        let numSpotMaps = 0;
        let numSpotShadowsWithMaps = 0;
        let numLightProbes = 0;
        // ordering : [shadow casting + map texturing, map texturing, shadow casting, none ]
        lights.sort($d5b33d7c30034067$var$shadowCastingAndTexturingLightsFirst);
        for(let i = 0, l = lights.length; i < l; i++){
            const light = lights[i];
            const color = light.color;
            const intensity = light.intensity;
            const distance = light.distance;
            const shadowMap = light.shadow && light.shadow.map ? light.shadow.map.texture : null;
            if (light.isAmbientLight) {
                r += color.r * intensity;
                g += color.g * intensity;
                b += color.b * intensity;
            } else if (light.isLightProbe) {
                for(let j = 0; j < 9; j++)state.probe[j].addScaledVector(light.sh.coefficients[j], intensity);
                numLightProbes++;
            } else if (light.isDirectionalLight) {
                const uniforms = cache.get(light);
                uniforms.color.copy(light.color).multiplyScalar(light.intensity);
                if (light.castShadow) {
                    const shadow = light.shadow;
                    const shadowUniforms = shadowCache.get(light);
                    shadowUniforms.shadowIntensity = shadow.intensity;
                    shadowUniforms.shadowBias = shadow.bias;
                    shadowUniforms.shadowNormalBias = shadow.normalBias;
                    shadowUniforms.shadowRadius = shadow.radius;
                    shadowUniforms.shadowMapSize = shadow.mapSize;
                    state.directionalShadow[directionalLength] = shadowUniforms;
                    state.directionalShadowMap[directionalLength] = shadowMap;
                    state.directionalShadowMatrix[directionalLength] = light.shadow.matrix;
                    numDirectionalShadows++;
                }
                state.directional[directionalLength] = uniforms;
                directionalLength++;
            } else if (light.isSpotLight) {
                const uniforms = cache.get(light);
                uniforms.position.setFromMatrixPosition(light.matrixWorld);
                uniforms.color.copy(color).multiplyScalar(intensity);
                uniforms.distance = distance;
                uniforms.coneCos = Math.cos(light.angle);
                uniforms.penumbraCos = Math.cos(light.angle * (1 - light.penumbra));
                uniforms.decay = light.decay;
                state.spot[spotLength] = uniforms;
                const shadow = light.shadow;
                if (light.map) {
                    state.spotLightMap[numSpotMaps] = light.map;
                    numSpotMaps++;
                    // make sure the lightMatrix is up to date
                    // TODO : do it if required only
                    shadow.updateMatrices(light);
                    if (light.castShadow) numSpotShadowsWithMaps++;
                }
                state.spotLightMatrix[spotLength] = shadow.matrix;
                if (light.castShadow) {
                    const shadowUniforms = shadowCache.get(light);
                    shadowUniforms.shadowIntensity = shadow.intensity;
                    shadowUniforms.shadowBias = shadow.bias;
                    shadowUniforms.shadowNormalBias = shadow.normalBias;
                    shadowUniforms.shadowRadius = shadow.radius;
                    shadowUniforms.shadowMapSize = shadow.mapSize;
                    state.spotShadow[spotLength] = shadowUniforms;
                    state.spotShadowMap[spotLength] = shadowMap;
                    numSpotShadows++;
                }
                spotLength++;
            } else if (light.isRectAreaLight) {
                const uniforms = cache.get(light);
                uniforms.color.copy(color).multiplyScalar(intensity);
                uniforms.halfWidth.set(light.width * 0.5, 0.0, 0.0);
                uniforms.halfHeight.set(0.0, light.height * 0.5, 0.0);
                state.rectArea[rectAreaLength] = uniforms;
                rectAreaLength++;
            } else if (light.isPointLight) {
                const uniforms = cache.get(light);
                uniforms.color.copy(light.color).multiplyScalar(light.intensity);
                uniforms.distance = light.distance;
                uniforms.decay = light.decay;
                if (light.castShadow) {
                    const shadow = light.shadow;
                    const shadowUniforms = shadowCache.get(light);
                    shadowUniforms.shadowIntensity = shadow.intensity;
                    shadowUniforms.shadowBias = shadow.bias;
                    shadowUniforms.shadowNormalBias = shadow.normalBias;
                    shadowUniforms.shadowRadius = shadow.radius;
                    shadowUniforms.shadowMapSize = shadow.mapSize;
                    shadowUniforms.shadowCameraNear = shadow.camera.near;
                    shadowUniforms.shadowCameraFar = shadow.camera.far;
                    state.pointShadow[pointLength] = shadowUniforms;
                    state.pointShadowMap[pointLength] = shadowMap;
                    state.pointShadowMatrix[pointLength] = light.shadow.matrix;
                    numPointShadows++;
                }
                state.point[pointLength] = uniforms;
                pointLength++;
            } else if (light.isHemisphereLight) {
                const uniforms = cache.get(light);
                uniforms.skyColor.copy(light.color).multiplyScalar(intensity);
                uniforms.groundColor.copy(light.groundColor).multiplyScalar(intensity);
                state.hemi[hemiLength] = uniforms;
                hemiLength++;
            }
        }
        if (rectAreaLength > 0) {
            if (extensions.has('OES_texture_float_linear') === true) {
                state.rectAreaLTC1 = $d5b33d7c30034067$export$6643083551874bf5.LTC_FLOAT_1;
                state.rectAreaLTC2 = $d5b33d7c30034067$export$6643083551874bf5.LTC_FLOAT_2;
            } else {
                state.rectAreaLTC1 = $d5b33d7c30034067$export$6643083551874bf5.LTC_HALF_1;
                state.rectAreaLTC2 = $d5b33d7c30034067$export$6643083551874bf5.LTC_HALF_2;
            }
        }
        state.ambient[0] = r;
        state.ambient[1] = g;
        state.ambient[2] = b;
        const hash = state.hash;
        if (hash.directionalLength !== directionalLength || hash.pointLength !== pointLength || hash.spotLength !== spotLength || hash.rectAreaLength !== rectAreaLength || hash.hemiLength !== hemiLength || hash.numDirectionalShadows !== numDirectionalShadows || hash.numPointShadows !== numPointShadows || hash.numSpotShadows !== numSpotShadows || hash.numSpotMaps !== numSpotMaps || hash.numLightProbes !== numLightProbes) {
            state.directional.length = directionalLength;
            state.spot.length = spotLength;
            state.rectArea.length = rectAreaLength;
            state.point.length = pointLength;
            state.hemi.length = hemiLength;
            state.directionalShadow.length = numDirectionalShadows;
            state.directionalShadowMap.length = numDirectionalShadows;
            state.pointShadow.length = numPointShadows;
            state.pointShadowMap.length = numPointShadows;
            state.spotShadow.length = numSpotShadows;
            state.spotShadowMap.length = numSpotShadows;
            state.directionalShadowMatrix.length = numDirectionalShadows;
            state.pointShadowMatrix.length = numPointShadows;
            state.spotLightMatrix.length = numSpotShadows + numSpotMaps - numSpotShadowsWithMaps;
            state.spotLightMap.length = numSpotMaps;
            state.numSpotLightShadowsWithMaps = numSpotShadowsWithMaps;
            state.numLightProbes = numLightProbes;
            hash.directionalLength = directionalLength;
            hash.pointLength = pointLength;
            hash.spotLength = spotLength;
            hash.rectAreaLength = rectAreaLength;
            hash.hemiLength = hemiLength;
            hash.numDirectionalShadows = numDirectionalShadows;
            hash.numPointShadows = numPointShadows;
            hash.numSpotShadows = numSpotShadows;
            hash.numSpotMaps = numSpotMaps;
            hash.numLightProbes = numLightProbes;
            state.version = $d5b33d7c30034067$var$nextVersion++;
        }
    }
    function setupView(lights, camera) {
        let directionalLength = 0;
        let pointLength = 0;
        let spotLength = 0;
        let rectAreaLength = 0;
        let hemiLength = 0;
        const viewMatrix = camera.matrixWorldInverse;
        for(let i = 0, l = lights.length; i < l; i++){
            const light = lights[i];
            if (light.isDirectionalLight) {
                const uniforms = state.directional[directionalLength];
                uniforms.direction.setFromMatrixPosition(light.matrixWorld);
                vector3.setFromMatrixPosition(light.target.matrixWorld);
                uniforms.direction.sub(vector3);
                uniforms.direction.transformDirection(viewMatrix);
                directionalLength++;
            } else if (light.isSpotLight) {
                const uniforms = state.spot[spotLength];
                uniforms.position.setFromMatrixPosition(light.matrixWorld);
                uniforms.position.applyMatrix4(viewMatrix);
                uniforms.direction.setFromMatrixPosition(light.matrixWorld);
                vector3.setFromMatrixPosition(light.target.matrixWorld);
                uniforms.direction.sub(vector3);
                uniforms.direction.transformDirection(viewMatrix);
                spotLength++;
            } else if (light.isRectAreaLight) {
                const uniforms = state.rectArea[rectAreaLength];
                uniforms.position.setFromMatrixPosition(light.matrixWorld);
                uniforms.position.applyMatrix4(viewMatrix);
                // extract local rotation of light to derive width/height half vectors
                matrix42.identity();
                matrix4.copy(light.matrixWorld);
                matrix4.premultiply(viewMatrix);
                matrix42.extractRotation(matrix4);
                uniforms.halfWidth.set(light.width * 0.5, 0.0, 0.0);
                uniforms.halfHeight.set(0.0, light.height * 0.5, 0.0);
                uniforms.halfWidth.applyMatrix4(matrix42);
                uniforms.halfHeight.applyMatrix4(matrix42);
                rectAreaLength++;
            } else if (light.isPointLight) {
                const uniforms = state.point[pointLength];
                uniforms.position.setFromMatrixPosition(light.matrixWorld);
                uniforms.position.applyMatrix4(viewMatrix);
                pointLength++;
            } else if (light.isHemisphereLight) {
                const uniforms = state.hemi[hemiLength];
                uniforms.direction.setFromMatrixPosition(light.matrixWorld);
                uniforms.direction.transformDirection(viewMatrix);
                hemiLength++;
            }
        }
    }
    return {
        setup: setup,
        setupView: setupView,
        state: state
    };
}
function $d5b33d7c30034067$var$WebGLRenderState(extensions) {
    const lights = new $d5b33d7c30034067$var$WebGLLights(extensions);
    const lightsArray = [];
    const shadowsArray = [];
    function init(camera) {
        state.camera = camera;
        lightsArray.length = 0;
        shadowsArray.length = 0;
    }
    function pushLight(light) {
        lightsArray.push(light);
    }
    function pushShadow(shadowLight) {
        shadowsArray.push(shadowLight);
    }
    function setupLights() {
        lights.setup(lightsArray);
    }
    function setupLightsView(camera) {
        lights.setupView(lightsArray, camera);
    }
    const state = {
        lightsArray: lightsArray,
        shadowsArray: shadowsArray,
        camera: null,
        lights: lights,
        transmissionRenderTarget: {}
    };
    return {
        init: init,
        state: state,
        setupLights: setupLights,
        setupLightsView: setupLightsView,
        pushLight: pushLight,
        pushShadow: pushShadow
    };
}
function $d5b33d7c30034067$var$WebGLRenderStates(extensions) {
    let renderStates = new WeakMap();
    function get(scene, renderCallDepth = 0) {
        const renderStateArray = renderStates.get(scene);
        let renderState;
        if (renderStateArray === undefined) {
            renderState = new $d5b33d7c30034067$var$WebGLRenderState(extensions);
            renderStates.set(scene, [
                renderState
            ]);
        } else if (renderCallDepth >= renderStateArray.length) {
            renderState = new $d5b33d7c30034067$var$WebGLRenderState(extensions);
            renderStateArray.push(renderState);
        } else renderState = renderStateArray[renderCallDepth];
        return renderState;
    }
    function dispose() {
        renderStates = new WeakMap();
    }
    return {
        get: get,
        dispose: dispose
    };
}
const $d5b33d7c30034067$var$vertex = "void main() {\n\tgl_Position = vec4( position, 1.0 );\n}";
const $d5b33d7c30034067$var$fragment = "uniform sampler2D shadow_pass;\nuniform vec2 resolution;\nuniform float radius;\n#include <packing>\nvoid main() {\n\tconst float samples = float( VSM_SAMPLES );\n\tfloat mean = 0.0;\n\tfloat squared_mean = 0.0;\n\tfloat uvStride = samples <= 1.0 ? 0.0 : 2.0 / ( samples - 1.0 );\n\tfloat uvStart = samples <= 1.0 ? 0.0 : - 1.0;\n\tfor ( float i = 0.0; i < samples; i ++ ) {\n\t\tfloat uvOffset = uvStart + i * uvStride;\n\t\t#ifdef HORIZONTAL_PASS\n\t\t\tvec2 distribution = unpackRGBATo2Half( texture2D( shadow_pass, ( gl_FragCoord.xy + vec2( uvOffset, 0.0 ) * radius ) / resolution ) );\n\t\t\tmean += distribution.x;\n\t\t\tsquared_mean += distribution.y * distribution.y + distribution.x * distribution.x;\n\t\t#else\n\t\t\tfloat depth = unpackRGBAToDepth( texture2D( shadow_pass, ( gl_FragCoord.xy + vec2( 0.0, uvOffset ) * radius ) / resolution ) );\n\t\t\tmean += depth;\n\t\t\tsquared_mean += depth * depth;\n\t\t#endif\n\t}\n\tmean = mean / samples;\n\tsquared_mean = squared_mean / samples;\n\tfloat std_dev = sqrt( squared_mean - mean * mean );\n\tgl_FragColor = pack2HalfToRGBA( vec2( mean, std_dev ) );\n}";
function $d5b33d7c30034067$var$WebGLShadowMap(renderer, objects, capabilities) {
    let _frustum = new (0, $dyjou.Frustum)();
    const _shadowMapSize = new (0, $dyjou.Vector2)(), _viewportSize = new (0, $dyjou.Vector2)(), _viewport = new (0, $dyjou.Vector4)(), _depthMaterial = new (0, $dyjou.MeshDepthMaterial)({
        depthPacking: (0, $dyjou.RGBADepthPacking)
    }), _distanceMaterial = new (0, $dyjou.MeshDistanceMaterial)(), _materialCache = {}, _maxTextureSize = capabilities.maxTextureSize;
    const shadowSide = {
        [(0, $dyjou.FrontSide)]: (0, $dyjou.BackSide),
        [(0, $dyjou.BackSide)]: (0, $dyjou.FrontSide),
        [(0, $dyjou.DoubleSide)]: (0, $dyjou.DoubleSide)
    };
    const shadowMaterialVertical = new (0, $dyjou.ShaderMaterial)({
        defines: {
            VSM_SAMPLES: 8
        },
        uniforms: {
            shadow_pass: {
                value: null
            },
            resolution: {
                value: new (0, $dyjou.Vector2)()
            },
            radius: {
                value: 4.0
            }
        },
        vertexShader: $d5b33d7c30034067$var$vertex,
        fragmentShader: $d5b33d7c30034067$var$fragment
    });
    const shadowMaterialHorizontal = shadowMaterialVertical.clone();
    shadowMaterialHorizontal.defines.HORIZONTAL_PASS = 1;
    const fullScreenTri = new (0, $dyjou.BufferGeometry)();
    fullScreenTri.setAttribute('position', new (0, $dyjou.BufferAttribute)(new Float32Array([
        -1,
        -1,
        0.5,
        3,
        -1,
        0.5,
        -1,
        3,
        0.5
    ]), 3));
    const fullScreenMesh = new (0, $dyjou.Mesh)(fullScreenTri, shadowMaterialVertical);
    const scope = this;
    this.enabled = false;
    this.autoUpdate = true;
    this.needsUpdate = false;
    this.type = (0, $dyjou.PCFShadowMap);
    let _previousType = this.type;
    this.render = function(lights, scene, camera) {
        if (scope.enabled === false) return;
        if (scope.autoUpdate === false && scope.needsUpdate === false) return;
        if (lights.length === 0) return;
        const currentRenderTarget = renderer.getRenderTarget();
        const activeCubeFace = renderer.getActiveCubeFace();
        const activeMipmapLevel = renderer.getActiveMipmapLevel();
        const _state = renderer.state;
        // Set GL state for depth map.
        _state.setBlending((0, $dyjou.NoBlending));
        _state.buffers.color.setClear(1, 1, 1, 1);
        _state.buffers.depth.setTest(true);
        _state.setScissorTest(false);
        // check for shadow map type changes
        const toVSM = _previousType !== (0, $dyjou.VSMShadowMap) && this.type === (0, $dyjou.VSMShadowMap);
        const fromVSM = _previousType === (0, $dyjou.VSMShadowMap) && this.type !== (0, $dyjou.VSMShadowMap);
        // render depth map
        for(let i = 0, il = lights.length; i < il; i++){
            const light = lights[i];
            const shadow = light.shadow;
            if (shadow === undefined) {
                console.warn('THREE.WebGLShadowMap:', light, 'has no shadow.');
                continue;
            }
            if (shadow.autoUpdate === false && shadow.needsUpdate === false) continue;
            _shadowMapSize.copy(shadow.mapSize);
            const shadowFrameExtents = shadow.getFrameExtents();
            _shadowMapSize.multiply(shadowFrameExtents);
            _viewportSize.copy(shadow.mapSize);
            if (_shadowMapSize.x > _maxTextureSize || _shadowMapSize.y > _maxTextureSize) {
                if (_shadowMapSize.x > _maxTextureSize) {
                    _viewportSize.x = Math.floor(_maxTextureSize / shadowFrameExtents.x);
                    _shadowMapSize.x = _viewportSize.x * shadowFrameExtents.x;
                    shadow.mapSize.x = _viewportSize.x;
                }
                if (_shadowMapSize.y > _maxTextureSize) {
                    _viewportSize.y = Math.floor(_maxTextureSize / shadowFrameExtents.y);
                    _shadowMapSize.y = _viewportSize.y * shadowFrameExtents.y;
                    shadow.mapSize.y = _viewportSize.y;
                }
            }
            if (shadow.map === null || toVSM === true || fromVSM === true) {
                const pars = this.type !== (0, $dyjou.VSMShadowMap) ? {
                    minFilter: (0, $dyjou.NearestFilter),
                    magFilter: (0, $dyjou.NearestFilter)
                } : {};
                if (shadow.map !== null) shadow.map.dispose();
                shadow.map = new (0, $dyjou.WebGLRenderTarget)(_shadowMapSize.x, _shadowMapSize.y, pars);
                shadow.map.texture.name = light.name + '.shadowMap';
                shadow.camera.updateProjectionMatrix();
            }
            renderer.setRenderTarget(shadow.map);
            renderer.clear();
            const viewportCount = shadow.getViewportCount();
            for(let vp = 0; vp < viewportCount; vp++){
                const viewport = shadow.getViewport(vp);
                _viewport.set(_viewportSize.x * viewport.x, _viewportSize.y * viewport.y, _viewportSize.x * viewport.z, _viewportSize.y * viewport.w);
                _state.viewport(_viewport);
                shadow.updateMatrices(light, vp);
                _frustum = shadow.getFrustum();
                renderObject(scene, camera, shadow.camera, light, this.type);
            }
            // do blur pass for VSM
            if (shadow.isPointLightShadow !== true && this.type === (0, $dyjou.VSMShadowMap)) VSMPass(shadow, camera);
            shadow.needsUpdate = false;
        }
        _previousType = this.type;
        scope.needsUpdate = false;
        renderer.setRenderTarget(currentRenderTarget, activeCubeFace, activeMipmapLevel);
    };
    function VSMPass(shadow, camera) {
        const geometry = objects.update(fullScreenMesh);
        if (shadowMaterialVertical.defines.VSM_SAMPLES !== shadow.blurSamples) {
            shadowMaterialVertical.defines.VSM_SAMPLES = shadow.blurSamples;
            shadowMaterialHorizontal.defines.VSM_SAMPLES = shadow.blurSamples;
            shadowMaterialVertical.needsUpdate = true;
            shadowMaterialHorizontal.needsUpdate = true;
        }
        if (shadow.mapPass === null) shadow.mapPass = new (0, $dyjou.WebGLRenderTarget)(_shadowMapSize.x, _shadowMapSize.y);
        // vertical pass
        shadowMaterialVertical.uniforms.shadow_pass.value = shadow.map.texture;
        shadowMaterialVertical.uniforms.resolution.value = shadow.mapSize;
        shadowMaterialVertical.uniforms.radius.value = shadow.radius;
        renderer.setRenderTarget(shadow.mapPass);
        renderer.clear();
        renderer.renderBufferDirect(camera, null, geometry, shadowMaterialVertical, fullScreenMesh, null);
        // horizontal pass
        shadowMaterialHorizontal.uniforms.shadow_pass.value = shadow.mapPass.texture;
        shadowMaterialHorizontal.uniforms.resolution.value = shadow.mapSize;
        shadowMaterialHorizontal.uniforms.radius.value = shadow.radius;
        renderer.setRenderTarget(shadow.map);
        renderer.clear();
        renderer.renderBufferDirect(camera, null, geometry, shadowMaterialHorizontal, fullScreenMesh, null);
    }
    function getDepthMaterial(object, material, light, type) {
        let result = null;
        const customMaterial = light.isPointLight === true ? object.customDistanceMaterial : object.customDepthMaterial;
        if (customMaterial !== undefined) result = customMaterial;
        else {
            result = light.isPointLight === true ? _distanceMaterial : _depthMaterial;
            if (renderer.localClippingEnabled && material.clipShadows === true && Array.isArray(material.clippingPlanes) && material.clippingPlanes.length !== 0 || material.displacementMap && material.displacementScale !== 0 || material.alphaMap && material.alphaTest > 0 || material.map && material.alphaTest > 0) {
                // in this case we need a unique material instance reflecting the
                // appropriate state
                const keyA = result.uuid, keyB = material.uuid;
                let materialsForVariant = _materialCache[keyA];
                if (materialsForVariant === undefined) {
                    materialsForVariant = {};
                    _materialCache[keyA] = materialsForVariant;
                }
                let cachedMaterial = materialsForVariant[keyB];
                if (cachedMaterial === undefined) {
                    cachedMaterial = result.clone();
                    materialsForVariant[keyB] = cachedMaterial;
                    material.addEventListener('dispose', onMaterialDispose);
                }
                result = cachedMaterial;
            }
        }
        result.visible = material.visible;
        result.wireframe = material.wireframe;
        if (type === (0, $dyjou.VSMShadowMap)) result.side = material.shadowSide !== null ? material.shadowSide : material.side;
        else result.side = material.shadowSide !== null ? material.shadowSide : shadowSide[material.side];
        result.alphaMap = material.alphaMap;
        result.alphaTest = material.alphaTest;
        result.map = material.map;
        result.clipShadows = material.clipShadows;
        result.clippingPlanes = material.clippingPlanes;
        result.clipIntersection = material.clipIntersection;
        result.displacementMap = material.displacementMap;
        result.displacementScale = material.displacementScale;
        result.displacementBias = material.displacementBias;
        result.wireframeLinewidth = material.wireframeLinewidth;
        result.linewidth = material.linewidth;
        if (light.isPointLight === true && result.isMeshDistanceMaterial === true) {
            const materialProperties = renderer.properties.get(result);
            materialProperties.light = light;
        }
        return result;
    }
    function renderObject(object, camera, shadowCamera, light, type) {
        if (object.visible === false) return;
        const visible = object.layers.test(camera.layers);
        if (visible && (object.isMesh || object.isLine || object.isPoints)) {
            if ((object.castShadow || object.receiveShadow && type === (0, $dyjou.VSMShadowMap)) && (!object.frustumCulled || _frustum.intersectsObject(object))) {
                object.modelViewMatrix.multiplyMatrices(shadowCamera.matrixWorldInverse, object.matrixWorld);
                const geometry = objects.update(object);
                const material = object.material;
                if (Array.isArray(material)) {
                    const groups = geometry.groups;
                    for(let k = 0, kl = groups.length; k < kl; k++){
                        const group = groups[k];
                        const groupMaterial = material[group.materialIndex];
                        if (groupMaterial && groupMaterial.visible) {
                            const depthMaterial = getDepthMaterial(object, groupMaterial, light, type);
                            object.onBeforeShadow(renderer, object, camera, shadowCamera, geometry, depthMaterial, group);
                            renderer.renderBufferDirect(shadowCamera, null, geometry, depthMaterial, object, group);
                            object.onAfterShadow(renderer, object, camera, shadowCamera, geometry, depthMaterial, group);
                        }
                    }
                } else if (material.visible) {
                    const depthMaterial = getDepthMaterial(object, material, light, type);
                    object.onBeforeShadow(renderer, object, camera, shadowCamera, geometry, depthMaterial, null);
                    renderer.renderBufferDirect(shadowCamera, null, geometry, depthMaterial, object, null);
                    object.onAfterShadow(renderer, object, camera, shadowCamera, geometry, depthMaterial, null);
                }
            }
        }
        const children = object.children;
        for(let i = 0, l = children.length; i < l; i++)renderObject(children[i], camera, shadowCamera, light, type);
    }
    function onMaterialDispose(event) {
        const material = event.target;
        material.removeEventListener('dispose', onMaterialDispose);
        // make sure to remove the unique distance/depth materials used for shadow map rendering
        for(const id in _materialCache){
            const cache = _materialCache[id];
            const uuid = event.target.uuid;
            if (uuid in cache) {
                const shadowMaterial = cache[uuid];
                shadowMaterial.dispose();
                delete cache[uuid];
            }
        }
    }
}
const $d5b33d7c30034067$var$reversedFuncs = {
    [(0, $dyjou.NeverDepth)]: (0, $dyjou.AlwaysDepth),
    [(0, $dyjou.LessDepth)]: (0, $dyjou.GreaterDepth),
    [(0, $dyjou.EqualDepth)]: (0, $dyjou.NotEqualDepth),
    [(0, $dyjou.LessEqualDepth)]: (0, $dyjou.GreaterEqualDepth),
    [(0, $dyjou.AlwaysDepth)]: (0, $dyjou.NeverDepth),
    [(0, $dyjou.GreaterDepth)]: (0, $dyjou.LessDepth),
    [(0, $dyjou.NotEqualDepth)]: (0, $dyjou.EqualDepth),
    [(0, $dyjou.GreaterEqualDepth)]: (0, $dyjou.LessEqualDepth)
};
function $d5b33d7c30034067$var$WebGLState(gl, extensions) {
    function ColorBuffer() {
        let locked = false;
        const color = new (0, $dyjou.Vector4)();
        let currentColorMask = null;
        const currentColorClear = new (0, $dyjou.Vector4)(0, 0, 0, 0);
        return {
            setMask: function(colorMask) {
                if (currentColorMask !== colorMask && !locked) {
                    gl.colorMask(colorMask, colorMask, colorMask, colorMask);
                    currentColorMask = colorMask;
                }
            },
            setLocked: function(lock) {
                locked = lock;
            },
            setClear: function(r, g, b, a, premultipliedAlpha) {
                if (premultipliedAlpha === true) {
                    r *= a;
                    g *= a;
                    b *= a;
                }
                color.set(r, g, b, a);
                if (currentColorClear.equals(color) === false) {
                    gl.clearColor(r, g, b, a);
                    currentColorClear.copy(color);
                }
            },
            reset: function() {
                locked = false;
                currentColorMask = null;
                currentColorClear.set(-1, 0, 0, 0); // set to invalid state
            }
        };
    }
    function DepthBuffer() {
        let locked = false;
        let currentReversed = false;
        let currentDepthMask = null;
        let currentDepthFunc = null;
        let currentDepthClear = null;
        return {
            setReversed: function(reversed) {
                if (currentReversed !== reversed) {
                    const ext = extensions.get('EXT_clip_control');
                    if (reversed) ext.clipControlEXT(ext.LOWER_LEFT_EXT, ext.ZERO_TO_ONE_EXT);
                    else ext.clipControlEXT(ext.LOWER_LEFT_EXT, ext.NEGATIVE_ONE_TO_ONE_EXT);
                    currentReversed = reversed;
                    const oldDepth = currentDepthClear;
                    currentDepthClear = null;
                    this.setClear(oldDepth);
                }
            },
            getReversed: function() {
                return currentReversed;
            },
            setTest: function(depthTest) {
                if (depthTest) enable(gl.DEPTH_TEST);
                else disable(gl.DEPTH_TEST);
            },
            setMask: function(depthMask) {
                if (currentDepthMask !== depthMask && !locked) {
                    gl.depthMask(depthMask);
                    currentDepthMask = depthMask;
                }
            },
            setFunc: function(depthFunc) {
                if (currentReversed) depthFunc = $d5b33d7c30034067$var$reversedFuncs[depthFunc];
                if (currentDepthFunc !== depthFunc) {
                    switch(depthFunc){
                        case 0, $dyjou.NeverDepth:
                            gl.depthFunc(gl.NEVER);
                            break;
                        case 0, $dyjou.AlwaysDepth:
                            gl.depthFunc(gl.ALWAYS);
                            break;
                        case 0, $dyjou.LessDepth:
                            gl.depthFunc(gl.LESS);
                            break;
                        case 0, $dyjou.LessEqualDepth:
                            gl.depthFunc(gl.LEQUAL);
                            break;
                        case 0, $dyjou.EqualDepth:
                            gl.depthFunc(gl.EQUAL);
                            break;
                        case 0, $dyjou.GreaterEqualDepth:
                            gl.depthFunc(gl.GEQUAL);
                            break;
                        case 0, $dyjou.GreaterDepth:
                            gl.depthFunc(gl.GREATER);
                            break;
                        case 0, $dyjou.NotEqualDepth:
                            gl.depthFunc(gl.NOTEQUAL);
                            break;
                        default:
                            gl.depthFunc(gl.LEQUAL);
                    }
                    currentDepthFunc = depthFunc;
                }
            },
            setLocked: function(lock) {
                locked = lock;
            },
            setClear: function(depth) {
                if (currentDepthClear !== depth) {
                    if (currentReversed) depth = 1 - depth;
                    gl.clearDepth(depth);
                    currentDepthClear = depth;
                }
            },
            reset: function() {
                locked = false;
                currentDepthMask = null;
                currentDepthFunc = null;
                currentDepthClear = null;
                currentReversed = false;
            }
        };
    }
    function StencilBuffer() {
        let locked = false;
        let currentStencilMask = null;
        let currentStencilFunc = null;
        let currentStencilRef = null;
        let currentStencilFuncMask = null;
        let currentStencilFail = null;
        let currentStencilZFail = null;
        let currentStencilZPass = null;
        let currentStencilClear = null;
        return {
            setTest: function(stencilTest) {
                if (!locked) {
                    if (stencilTest) enable(gl.STENCIL_TEST);
                    else disable(gl.STENCIL_TEST);
                }
            },
            setMask: function(stencilMask) {
                if (currentStencilMask !== stencilMask && !locked) {
                    gl.stencilMask(stencilMask);
                    currentStencilMask = stencilMask;
                }
            },
            setFunc: function(stencilFunc, stencilRef, stencilMask) {
                if (currentStencilFunc !== stencilFunc || currentStencilRef !== stencilRef || currentStencilFuncMask !== stencilMask) {
                    gl.stencilFunc(stencilFunc, stencilRef, stencilMask);
                    currentStencilFunc = stencilFunc;
                    currentStencilRef = stencilRef;
                    currentStencilFuncMask = stencilMask;
                }
            },
            setOp: function(stencilFail, stencilZFail, stencilZPass) {
                if (currentStencilFail !== stencilFail || currentStencilZFail !== stencilZFail || currentStencilZPass !== stencilZPass) {
                    gl.stencilOp(stencilFail, stencilZFail, stencilZPass);
                    currentStencilFail = stencilFail;
                    currentStencilZFail = stencilZFail;
                    currentStencilZPass = stencilZPass;
                }
            },
            setLocked: function(lock) {
                locked = lock;
            },
            setClear: function(stencil) {
                if (currentStencilClear !== stencil) {
                    gl.clearStencil(stencil);
                    currentStencilClear = stencil;
                }
            },
            reset: function() {
                locked = false;
                currentStencilMask = null;
                currentStencilFunc = null;
                currentStencilRef = null;
                currentStencilFuncMask = null;
                currentStencilFail = null;
                currentStencilZFail = null;
                currentStencilZPass = null;
                currentStencilClear = null;
            }
        };
    }
    //
    const colorBuffer = new ColorBuffer();
    const depthBuffer = new DepthBuffer();
    const stencilBuffer = new StencilBuffer();
    const uboBindings = new WeakMap();
    const uboProgramMap = new WeakMap();
    let enabledCapabilities = {};
    let currentBoundFramebuffers = {};
    let currentDrawbuffers = new WeakMap();
    let defaultDrawbuffers = [];
    let currentProgram = null;
    let currentBlendingEnabled = false;
    let currentBlending = null;
    let currentBlendEquation = null;
    let currentBlendSrc = null;
    let currentBlendDst = null;
    let currentBlendEquationAlpha = null;
    let currentBlendSrcAlpha = null;
    let currentBlendDstAlpha = null;
    let currentBlendColor = new (0, $dyjou.Color)(0, 0, 0);
    let currentBlendAlpha = 0;
    let currentPremultipledAlpha = false;
    let currentFlipSided = null;
    let currentCullFace = null;
    let currentLineWidth = null;
    let currentPolygonOffsetFactor = null;
    let currentPolygonOffsetUnits = null;
    const maxTextures = gl.getParameter(gl.MAX_COMBINED_TEXTURE_IMAGE_UNITS);
    let lineWidthAvailable = false;
    let version = 0;
    const glVersion = gl.getParameter(gl.VERSION);
    if (glVersion.indexOf('WebGL') !== -1) {
        version = parseFloat(/^WebGL (\d)/.exec(glVersion)[1]);
        lineWidthAvailable = version >= 1.0;
    } else if (glVersion.indexOf('OpenGL ES') !== -1) {
        version = parseFloat(/^OpenGL ES (\d)/.exec(glVersion)[1]);
        lineWidthAvailable = version >= 2.0;
    }
    let currentTextureSlot = null;
    let currentBoundTextures = {};
    const scissorParam = gl.getParameter(gl.SCISSOR_BOX);
    const viewportParam = gl.getParameter(gl.VIEWPORT);
    const currentScissor = new (0, $dyjou.Vector4)().fromArray(scissorParam);
    const currentViewport = new (0, $dyjou.Vector4)().fromArray(viewportParam);
    function createTexture(type, target, count, dimensions) {
        const data = new Uint8Array(4); // 4 is required to match default unpack alignment of 4.
        const texture = gl.createTexture();
        gl.bindTexture(type, texture);
        gl.texParameteri(type, gl.TEXTURE_MIN_FILTER, gl.NEAREST);
        gl.texParameteri(type, gl.TEXTURE_MAG_FILTER, gl.NEAREST);
        for(let i = 0; i < count; i++)if (type === gl.TEXTURE_3D || type === gl.TEXTURE_2D_ARRAY) gl.texImage3D(target, 0, gl.RGBA, 1, 1, dimensions, 0, gl.RGBA, gl.UNSIGNED_BYTE, data);
        else gl.texImage2D(target + i, 0, gl.RGBA, 1, 1, 0, gl.RGBA, gl.UNSIGNED_BYTE, data);
        return texture;
    }
    const emptyTextures = {};
    emptyTextures[gl.TEXTURE_2D] = createTexture(gl.TEXTURE_2D, gl.TEXTURE_2D, 1);
    emptyTextures[gl.TEXTURE_CUBE_MAP] = createTexture(gl.TEXTURE_CUBE_MAP, gl.TEXTURE_CUBE_MAP_POSITIVE_X, 6);
    emptyTextures[gl.TEXTURE_2D_ARRAY] = createTexture(gl.TEXTURE_2D_ARRAY, gl.TEXTURE_2D_ARRAY, 1, 1);
    emptyTextures[gl.TEXTURE_3D] = createTexture(gl.TEXTURE_3D, gl.TEXTURE_3D, 1, 1);
    // init
    colorBuffer.setClear(0, 0, 0, 1);
    depthBuffer.setClear(1);
    stencilBuffer.setClear(0);
    enable(gl.DEPTH_TEST);
    depthBuffer.setFunc((0, $dyjou.LessEqualDepth));
    setFlipSided(false);
    setCullFace((0, $dyjou.CullFaceBack));
    enable(gl.CULL_FACE);
    setBlending((0, $dyjou.NoBlending));
    //
    function enable(id) {
        if (enabledCapabilities[id] !== true) {
            gl.enable(id);
            enabledCapabilities[id] = true;
        }
    }
    function disable(id) {
        if (enabledCapabilities[id] !== false) {
            gl.disable(id);
            enabledCapabilities[id] = false;
        }
    }
    function bindFramebuffer(target, framebuffer) {
        if (currentBoundFramebuffers[target] !== framebuffer) {
            gl.bindFramebuffer(target, framebuffer);
            currentBoundFramebuffers[target] = framebuffer;
            // gl.DRAW_FRAMEBUFFER is equivalent to gl.FRAMEBUFFER
            if (target === gl.DRAW_FRAMEBUFFER) currentBoundFramebuffers[gl.FRAMEBUFFER] = framebuffer;
            if (target === gl.FRAMEBUFFER) currentBoundFramebuffers[gl.DRAW_FRAMEBUFFER] = framebuffer;
            return true;
        }
        return false;
    }
    function drawBuffers(renderTarget, framebuffer) {
        let drawBuffers = defaultDrawbuffers;
        let needsUpdate = false;
        if (renderTarget) {
            drawBuffers = currentDrawbuffers.get(framebuffer);
            if (drawBuffers === undefined) {
                drawBuffers = [];
                currentDrawbuffers.set(framebuffer, drawBuffers);
            }
            const textures = renderTarget.textures;
            if (drawBuffers.length !== textures.length || drawBuffers[0] !== gl.COLOR_ATTACHMENT0) {
                for(let i = 0, il = textures.length; i < il; i++)drawBuffers[i] = gl.COLOR_ATTACHMENT0 + i;
                drawBuffers.length = textures.length;
                needsUpdate = true;
            }
        } else if (drawBuffers[0] !== gl.BACK) {
            drawBuffers[0] = gl.BACK;
            needsUpdate = true;
        }
        if (needsUpdate) gl.drawBuffers(drawBuffers);
    }
    function useProgram(program) {
        if (currentProgram !== program) {
            gl.useProgram(program);
            currentProgram = program;
            return true;
        }
        return false;
    }
    const equationToGL = {
        [(0, $dyjou.AddEquation)]: gl.FUNC_ADD,
        [(0, $dyjou.SubtractEquation)]: gl.FUNC_SUBTRACT,
        [(0, $dyjou.ReverseSubtractEquation)]: gl.FUNC_REVERSE_SUBTRACT
    };
    equationToGL[0, $dyjou.MinEquation] = gl.MIN;
    equationToGL[0, $dyjou.MaxEquation] = gl.MAX;
    const factorToGL = {
        [(0, $dyjou.ZeroFactor)]: gl.ZERO,
        [(0, $dyjou.OneFactor)]: gl.ONE,
        [(0, $dyjou.SrcColorFactor)]: gl.SRC_COLOR,
        [(0, $dyjou.SrcAlphaFactor)]: gl.SRC_ALPHA,
        [(0, $dyjou.SrcAlphaSaturateFactor)]: gl.SRC_ALPHA_SATURATE,
        [(0, $dyjou.DstColorFactor)]: gl.DST_COLOR,
        [(0, $dyjou.DstAlphaFactor)]: gl.DST_ALPHA,
        [(0, $dyjou.OneMinusSrcColorFactor)]: gl.ONE_MINUS_SRC_COLOR,
        [(0, $dyjou.OneMinusSrcAlphaFactor)]: gl.ONE_MINUS_SRC_ALPHA,
        [(0, $dyjou.OneMinusDstColorFactor)]: gl.ONE_MINUS_DST_COLOR,
        [(0, $dyjou.OneMinusDstAlphaFactor)]: gl.ONE_MINUS_DST_ALPHA,
        [(0, $dyjou.ConstantColorFactor)]: gl.CONSTANT_COLOR,
        [(0, $dyjou.OneMinusConstantColorFactor)]: gl.ONE_MINUS_CONSTANT_COLOR,
        [(0, $dyjou.ConstantAlphaFactor)]: gl.CONSTANT_ALPHA,
        [(0, $dyjou.OneMinusConstantAlphaFactor)]: gl.ONE_MINUS_CONSTANT_ALPHA
    };
    function setBlending(blending, blendEquation, blendSrc, blendDst, blendEquationAlpha, blendSrcAlpha, blendDstAlpha, blendColor, blendAlpha, premultipliedAlpha) {
        if (blending === (0, $dyjou.NoBlending)) {
            if (currentBlendingEnabled === true) {
                disable(gl.BLEND);
                currentBlendingEnabled = false;
            }
            return;
        }
        if (currentBlendingEnabled === false) {
            enable(gl.BLEND);
            currentBlendingEnabled = true;
        }
        if (blending !== (0, $dyjou.CustomBlending)) {
            if (blending !== currentBlending || premultipliedAlpha !== currentPremultipledAlpha) {
                if (currentBlendEquation !== (0, $dyjou.AddEquation) || currentBlendEquationAlpha !== (0, $dyjou.AddEquation)) {
                    gl.blendEquation(gl.FUNC_ADD);
                    currentBlendEquation = (0, $dyjou.AddEquation);
                    currentBlendEquationAlpha = (0, $dyjou.AddEquation);
                }
                if (premultipliedAlpha) switch(blending){
                    case 0, $dyjou.NormalBlending:
                        gl.blendFuncSeparate(gl.ONE, gl.ONE_MINUS_SRC_ALPHA, gl.ONE, gl.ONE_MINUS_SRC_ALPHA);
                        break;
                    case 0, $dyjou.AdditiveBlending:
                        gl.blendFunc(gl.ONE, gl.ONE);
                        break;
                    case 0, $dyjou.SubtractiveBlending:
                        gl.blendFuncSeparate(gl.ZERO, gl.ONE_MINUS_SRC_COLOR, gl.ZERO, gl.ONE);
                        break;
                    case 0, $dyjou.MultiplyBlending:
                        gl.blendFuncSeparate(gl.ZERO, gl.SRC_COLOR, gl.ZERO, gl.SRC_ALPHA);
                        break;
                    default:
                        console.error('THREE.WebGLState: Invalid blending: ', blending);
                        break;
                }
                else switch(blending){
                    case 0, $dyjou.NormalBlending:
                        gl.blendFuncSeparate(gl.SRC_ALPHA, gl.ONE_MINUS_SRC_ALPHA, gl.ONE, gl.ONE_MINUS_SRC_ALPHA);
                        break;
                    case 0, $dyjou.AdditiveBlending:
                        gl.blendFunc(gl.SRC_ALPHA, gl.ONE);
                        break;
                    case 0, $dyjou.SubtractiveBlending:
                        gl.blendFuncSeparate(gl.ZERO, gl.ONE_MINUS_SRC_COLOR, gl.ZERO, gl.ONE);
                        break;
                    case 0, $dyjou.MultiplyBlending:
                        gl.blendFunc(gl.ZERO, gl.SRC_COLOR);
                        break;
                    default:
                        console.error('THREE.WebGLState: Invalid blending: ', blending);
                        break;
                }
                currentBlendSrc = null;
                currentBlendDst = null;
                currentBlendSrcAlpha = null;
                currentBlendDstAlpha = null;
                currentBlendColor.set(0, 0, 0);
                currentBlendAlpha = 0;
                currentBlending = blending;
                currentPremultipledAlpha = premultipliedAlpha;
            }
            return;
        }
        // custom blending
        blendEquationAlpha = blendEquationAlpha || blendEquation;
        blendSrcAlpha = blendSrcAlpha || blendSrc;
        blendDstAlpha = blendDstAlpha || blendDst;
        if (blendEquation !== currentBlendEquation || blendEquationAlpha !== currentBlendEquationAlpha) {
            gl.blendEquationSeparate(equationToGL[blendEquation], equationToGL[blendEquationAlpha]);
            currentBlendEquation = blendEquation;
            currentBlendEquationAlpha = blendEquationAlpha;
        }
        if (blendSrc !== currentBlendSrc || blendDst !== currentBlendDst || blendSrcAlpha !== currentBlendSrcAlpha || blendDstAlpha !== currentBlendDstAlpha) {
            gl.blendFuncSeparate(factorToGL[blendSrc], factorToGL[blendDst], factorToGL[blendSrcAlpha], factorToGL[blendDstAlpha]);
            currentBlendSrc = blendSrc;
            currentBlendDst = blendDst;
            currentBlendSrcAlpha = blendSrcAlpha;
            currentBlendDstAlpha = blendDstAlpha;
        }
        if (blendColor.equals(currentBlendColor) === false || blendAlpha !== currentBlendAlpha) {
            gl.blendColor(blendColor.r, blendColor.g, blendColor.b, blendAlpha);
            currentBlendColor.copy(blendColor);
            currentBlendAlpha = blendAlpha;
        }
        currentBlending = blending;
        currentPremultipledAlpha = false;
    }
    function setMaterial(material, frontFaceCW) {
        material.side === (0, $dyjou.DoubleSide) ? disable(gl.CULL_FACE) : enable(gl.CULL_FACE);
        let flipSided = material.side === (0, $dyjou.BackSide);
        if (frontFaceCW) flipSided = !flipSided;
        setFlipSided(flipSided);
        material.blending === (0, $dyjou.NormalBlending) && material.transparent === false ? setBlending((0, $dyjou.NoBlending)) : setBlending(material.blending, material.blendEquation, material.blendSrc, material.blendDst, material.blendEquationAlpha, material.blendSrcAlpha, material.blendDstAlpha, material.blendColor, material.blendAlpha, material.premultipliedAlpha);
        depthBuffer.setFunc(material.depthFunc);
        depthBuffer.setTest(material.depthTest);
        depthBuffer.setMask(material.depthWrite);
        colorBuffer.setMask(material.colorWrite);
        const stencilWrite = material.stencilWrite;
        stencilBuffer.setTest(stencilWrite);
        if (stencilWrite) {
            stencilBuffer.setMask(material.stencilWriteMask);
            stencilBuffer.setFunc(material.stencilFunc, material.stencilRef, material.stencilFuncMask);
            stencilBuffer.setOp(material.stencilFail, material.stencilZFail, material.stencilZPass);
        }
        setPolygonOffset(material.polygonOffset, material.polygonOffsetFactor, material.polygonOffsetUnits);
        material.alphaToCoverage === true ? enable(gl.SAMPLE_ALPHA_TO_COVERAGE) : disable(gl.SAMPLE_ALPHA_TO_COVERAGE);
    }
    //
    function setFlipSided(flipSided) {
        if (currentFlipSided !== flipSided) {
            if (flipSided) gl.frontFace(gl.CW);
            else gl.frontFace(gl.CCW);
            currentFlipSided = flipSided;
        }
    }
    function setCullFace(cullFace) {
        if (cullFace !== (0, $dyjou.CullFaceNone)) {
            enable(gl.CULL_FACE);
            if (cullFace !== currentCullFace) {
                if (cullFace === (0, $dyjou.CullFaceBack)) gl.cullFace(gl.BACK);
                else if (cullFace === (0, $dyjou.CullFaceFront)) gl.cullFace(gl.FRONT);
                else gl.cullFace(gl.FRONT_AND_BACK);
            }
        } else disable(gl.CULL_FACE);
        currentCullFace = cullFace;
    }
    function setLineWidth(width) {
        if (width !== currentLineWidth) {
            if (lineWidthAvailable) gl.lineWidth(width);
            currentLineWidth = width;
        }
    }
    function setPolygonOffset(polygonOffset, factor, units) {
        if (polygonOffset) {
            enable(gl.POLYGON_OFFSET_FILL);
            if (currentPolygonOffsetFactor !== factor || currentPolygonOffsetUnits !== units) {
                gl.polygonOffset(factor, units);
                currentPolygonOffsetFactor = factor;
                currentPolygonOffsetUnits = units;
            }
        } else disable(gl.POLYGON_OFFSET_FILL);
    }
    function setScissorTest(scissorTest) {
        if (scissorTest) enable(gl.SCISSOR_TEST);
        else disable(gl.SCISSOR_TEST);
    }
    // texture
    function activeTexture(webglSlot) {
        if (webglSlot === undefined) webglSlot = gl.TEXTURE0 + maxTextures - 1;
        if (currentTextureSlot !== webglSlot) {
            gl.activeTexture(webglSlot);
            currentTextureSlot = webglSlot;
        }
    }
    function bindTexture(webglType, webglTexture, webglSlot) {
        if (webglSlot === undefined) {
            if (currentTextureSlot === null) webglSlot = gl.TEXTURE0 + maxTextures - 1;
            else webglSlot = currentTextureSlot;
        }
        let boundTexture = currentBoundTextures[webglSlot];
        if (boundTexture === undefined) {
            boundTexture = {
                type: undefined,
                texture: undefined
            };
            currentBoundTextures[webglSlot] = boundTexture;
        }
        if (boundTexture.type !== webglType || boundTexture.texture !== webglTexture) {
            if (currentTextureSlot !== webglSlot) {
                gl.activeTexture(webglSlot);
                currentTextureSlot = webglSlot;
            }
            gl.bindTexture(webglType, webglTexture || emptyTextures[webglType]);
            boundTexture.type = webglType;
            boundTexture.texture = webglTexture;
        }
    }
    function unbindTexture() {
        const boundTexture = currentBoundTextures[currentTextureSlot];
        if (boundTexture !== undefined && boundTexture.type !== undefined) {
            gl.bindTexture(boundTexture.type, null);
            boundTexture.type = undefined;
            boundTexture.texture = undefined;
        }
    }
    function compressedTexImage2D() {
        try {
            gl.compressedTexImage2D(...arguments);
        } catch (error) {
            console.error('THREE.WebGLState:', error);
        }
    }
    function compressedTexImage3D() {
        try {
            gl.compressedTexImage3D(...arguments);
        } catch (error) {
            console.error('THREE.WebGLState:', error);
        }
    }
    function texSubImage2D() {
        try {
            gl.texSubImage2D(...arguments);
        } catch (error) {
            console.error('THREE.WebGLState:', error);
        }
    }
    function texSubImage3D() {
        try {
            gl.texSubImage3D(...arguments);
        } catch (error) {
            console.error('THREE.WebGLState:', error);
        }
    }
    function compressedTexSubImage2D() {
        try {
            gl.compressedTexSubImage2D(...arguments);
        } catch (error) {
            console.error('THREE.WebGLState:', error);
        }
    }
    function compressedTexSubImage3D() {
        try {
            gl.compressedTexSubImage3D(...arguments);
        } catch (error) {
            console.error('THREE.WebGLState:', error);
        }
    }
    function texStorage2D() {
        try {
            gl.texStorage2D(...arguments);
        } catch (error) {
            console.error('THREE.WebGLState:', error);
        }
    }
    function texStorage3D() {
        try {
            gl.texStorage3D(...arguments);
        } catch (error) {
            console.error('THREE.WebGLState:', error);
        }
    }
    function texImage2D() {
        try {
            gl.texImage2D(...arguments);
        } catch (error) {
            console.error('THREE.WebGLState:', error);
        }
    }
    function texImage3D() {
        try {
            gl.texImage3D(...arguments);
        } catch (error) {
            console.error('THREE.WebGLState:', error);
        }
    }
    //
    function scissor(scissor) {
        if (currentScissor.equals(scissor) === false) {
            gl.scissor(scissor.x, scissor.y, scissor.z, scissor.w);
            currentScissor.copy(scissor);
        }
    }
    function viewport(viewport) {
        if (currentViewport.equals(viewport) === false) {
            gl.viewport(viewport.x, viewport.y, viewport.z, viewport.w);
            currentViewport.copy(viewport);
        }
    }
    function updateUBOMapping(uniformsGroup, program) {
        let mapping = uboProgramMap.get(program);
        if (mapping === undefined) {
            mapping = new WeakMap();
            uboProgramMap.set(program, mapping);
        }
        let blockIndex = mapping.get(uniformsGroup);
        if (blockIndex === undefined) {
            blockIndex = gl.getUniformBlockIndex(program, uniformsGroup.name);
            mapping.set(uniformsGroup, blockIndex);
        }
    }
    function uniformBlockBinding(uniformsGroup, program) {
        const mapping = uboProgramMap.get(program);
        const blockIndex = mapping.get(uniformsGroup);
        if (uboBindings.get(program) !== blockIndex) {
            // bind shader specific block index to global block point
            gl.uniformBlockBinding(program, blockIndex, uniformsGroup.__bindingPointIndex);
            uboBindings.set(program, blockIndex);
        }
    }
    //
    function reset() {
        // reset state
        gl.disable(gl.BLEND);
        gl.disable(gl.CULL_FACE);
        gl.disable(gl.DEPTH_TEST);
        gl.disable(gl.POLYGON_OFFSET_FILL);
        gl.disable(gl.SCISSOR_TEST);
        gl.disable(gl.STENCIL_TEST);
        gl.disable(gl.SAMPLE_ALPHA_TO_COVERAGE);
        gl.blendEquation(gl.FUNC_ADD);
        gl.blendFunc(gl.ONE, gl.ZERO);
        gl.blendFuncSeparate(gl.ONE, gl.ZERO, gl.ONE, gl.ZERO);
        gl.blendColor(0, 0, 0, 0);
        gl.colorMask(true, true, true, true);
        gl.clearColor(0, 0, 0, 0);
        gl.depthMask(true);
        gl.depthFunc(gl.LESS);
        depthBuffer.setReversed(false);
        gl.clearDepth(1);
        gl.stencilMask(0xffffffff);
        gl.stencilFunc(gl.ALWAYS, 0, 0xffffffff);
        gl.stencilOp(gl.KEEP, gl.KEEP, gl.KEEP);
        gl.clearStencil(0);
        gl.cullFace(gl.BACK);
        gl.frontFace(gl.CCW);
        gl.polygonOffset(0, 0);
        gl.activeTexture(gl.TEXTURE0);
        gl.bindFramebuffer(gl.FRAMEBUFFER, null);
        gl.bindFramebuffer(gl.DRAW_FRAMEBUFFER, null);
        gl.bindFramebuffer(gl.READ_FRAMEBUFFER, null);
        gl.useProgram(null);
        gl.lineWidth(1);
        gl.scissor(0, 0, gl.canvas.width, gl.canvas.height);
        gl.viewport(0, 0, gl.canvas.width, gl.canvas.height);
        // reset internals
        enabledCapabilities = {};
        currentTextureSlot = null;
        currentBoundTextures = {};
        currentBoundFramebuffers = {};
        currentDrawbuffers = new WeakMap();
        defaultDrawbuffers = [];
        currentProgram = null;
        currentBlendingEnabled = false;
        currentBlending = null;
        currentBlendEquation = null;
        currentBlendSrc = null;
        currentBlendDst = null;
        currentBlendEquationAlpha = null;
        currentBlendSrcAlpha = null;
        currentBlendDstAlpha = null;
        currentBlendColor = new (0, $dyjou.Color)(0, 0, 0);
        currentBlendAlpha = 0;
        currentPremultipledAlpha = false;
        currentFlipSided = null;
        currentCullFace = null;
        currentLineWidth = null;
        currentPolygonOffsetFactor = null;
        currentPolygonOffsetUnits = null;
        currentScissor.set(0, 0, gl.canvas.width, gl.canvas.height);
        currentViewport.set(0, 0, gl.canvas.width, gl.canvas.height);
        colorBuffer.reset();
        depthBuffer.reset();
        stencilBuffer.reset();
    }
    return {
        buffers: {
            color: colorBuffer,
            depth: depthBuffer,
            stencil: stencilBuffer
        },
        enable: enable,
        disable: disable,
        bindFramebuffer: bindFramebuffer,
        drawBuffers: drawBuffers,
        useProgram: useProgram,
        setBlending: setBlending,
        setMaterial: setMaterial,
        setFlipSided: setFlipSided,
        setCullFace: setCullFace,
        setLineWidth: setLineWidth,
        setPolygonOffset: setPolygonOffset,
        setScissorTest: setScissorTest,
        activeTexture: activeTexture,
        bindTexture: bindTexture,
        unbindTexture: unbindTexture,
        compressedTexImage2D: compressedTexImage2D,
        compressedTexImage3D: compressedTexImage3D,
        texImage2D: texImage2D,
        texImage3D: texImage3D,
        updateUBOMapping: updateUBOMapping,
        uniformBlockBinding: uniformBlockBinding,
        texStorage2D: texStorage2D,
        texStorage3D: texStorage3D,
        texSubImage2D: texSubImage2D,
        texSubImage3D: texSubImage3D,
        compressedTexSubImage2D: compressedTexSubImage2D,
        compressedTexSubImage3D: compressedTexSubImage3D,
        scissor: scissor,
        viewport: viewport,
        reset: reset
    };
}
function $d5b33d7c30034067$var$WebGLTextures(_gl, extensions, state, properties, capabilities, utils, info) {
    const multisampledRTTExt = extensions.has('WEBGL_multisampled_render_to_texture') ? extensions.get('WEBGL_multisampled_render_to_texture') : null;
    const supportsInvalidateFramebuffer = typeof navigator === 'undefined' ? false : /OculusBrowser/g.test(navigator.userAgent);
    const _imageDimensions = new (0, $dyjou.Vector2)();
    const _videoTextures = new WeakMap();
    let _canvas;
    const _sources = new WeakMap(); // maps WebglTexture objects to instances of Source
    // cordova iOS (as of 5.0) still uses UIWebView, which provides OffscreenCanvas,
    // also OffscreenCanvas.getContext("webgl"), but not OffscreenCanvas.getContext("2d")!
    // Some implementations may only implement OffscreenCanvas partially (e.g. lacking 2d).
    let useOffscreenCanvas = false;
    try {
        useOffscreenCanvas = typeof OffscreenCanvas !== 'undefined' && new OffscreenCanvas(1, 1).getContext('2d') !== null;
    } catch (err) {
    // Ignore any errors
    }
    function createCanvas(width, height) {
        // Use OffscreenCanvas when available. Specially needed in web workers
        return useOffscreenCanvas ? // eslint-disable-next-line compat/compat
        new OffscreenCanvas(width, height) : (0, $dyjou.createElementNS)('canvas');
    }
    function resizeImage(image, needsNewCanvas, maxSize) {
        let scale = 1;
        const dimensions = getDimensions(image);
        // handle case if texture exceeds max size
        if (dimensions.width > maxSize || dimensions.height > maxSize) scale = maxSize / Math.max(dimensions.width, dimensions.height);
        // only perform resize if necessary
        if (scale < 1) {
            // only perform resize for certain image types
            if (typeof HTMLImageElement !== 'undefined' && image instanceof HTMLImageElement || typeof HTMLCanvasElement !== 'undefined' && image instanceof HTMLCanvasElement || typeof ImageBitmap !== 'undefined' && image instanceof ImageBitmap || typeof VideoFrame !== 'undefined' && image instanceof VideoFrame) {
                const width = Math.floor(scale * dimensions.width);
                const height = Math.floor(scale * dimensions.height);
                if (_canvas === undefined) _canvas = createCanvas(width, height);
                // cube textures can't reuse the same canvas
                const canvas = needsNewCanvas ? createCanvas(width, height) : _canvas;
                canvas.width = width;
                canvas.height = height;
                const context = canvas.getContext('2d');
                context.drawImage(image, 0, 0, width, height);
                console.warn('THREE.WebGLRenderer: Texture has been resized from (' + dimensions.width + 'x' + dimensions.height + ') to (' + width + 'x' + height + ').');
                return canvas;
            } else {
                if ('data' in image) console.warn('THREE.WebGLRenderer: Image in DataTexture is too big (' + dimensions.width + 'x' + dimensions.height + ').');
                return image;
            }
        }
        return image;
    }
    function textureNeedsGenerateMipmaps(texture) {
        return texture.generateMipmaps;
    }
    function generateMipmap(target) {
        _gl.generateMipmap(target);
    }
    function getTargetType(texture) {
        if (texture.isWebGLCubeRenderTarget) return _gl.TEXTURE_CUBE_MAP;
        if (texture.isWebGL3DRenderTarget) return _gl.TEXTURE_3D;
        if (texture.isWebGLArrayRenderTarget || texture.isCompressedArrayTexture) return _gl.TEXTURE_2D_ARRAY;
        return _gl.TEXTURE_2D;
    }
    function getInternalFormat(internalFormatName, glFormat, glType, colorSpace, forceLinearTransfer = false) {
        if (internalFormatName !== null) {
            if (_gl[internalFormatName] !== undefined) return _gl[internalFormatName];
            console.warn('THREE.WebGLRenderer: Attempt to use non-existing WebGL internal format \'' + internalFormatName + '\'');
        }
        let internalFormat = glFormat;
        if (glFormat === _gl.RED) {
            if (glType === _gl.FLOAT) internalFormat = _gl.R32F;
            if (glType === _gl.HALF_FLOAT) internalFormat = _gl.R16F;
            if (glType === _gl.UNSIGNED_BYTE) internalFormat = _gl.R8;
        }
        if (glFormat === _gl.RED_INTEGER) {
            if (glType === _gl.UNSIGNED_BYTE) internalFormat = _gl.R8UI;
            if (glType === _gl.UNSIGNED_SHORT) internalFormat = _gl.R16UI;
            if (glType === _gl.UNSIGNED_INT) internalFormat = _gl.R32UI;
            if (glType === _gl.BYTE) internalFormat = _gl.R8I;
            if (glType === _gl.SHORT) internalFormat = _gl.R16I;
            if (glType === _gl.INT) internalFormat = _gl.R32I;
        }
        if (glFormat === _gl.RG) {
            if (glType === _gl.FLOAT) internalFormat = _gl.RG32F;
            if (glType === _gl.HALF_FLOAT) internalFormat = _gl.RG16F;
            if (glType === _gl.UNSIGNED_BYTE) internalFormat = _gl.RG8;
        }
        if (glFormat === _gl.RG_INTEGER) {
            if (glType === _gl.UNSIGNED_BYTE) internalFormat = _gl.RG8UI;
            if (glType === _gl.UNSIGNED_SHORT) internalFormat = _gl.RG16UI;
            if (glType === _gl.UNSIGNED_INT) internalFormat = _gl.RG32UI;
            if (glType === _gl.BYTE) internalFormat = _gl.RG8I;
            if (glType === _gl.SHORT) internalFormat = _gl.RG16I;
            if (glType === _gl.INT) internalFormat = _gl.RG32I;
        }
        if (glFormat === _gl.RGB_INTEGER) {
            if (glType === _gl.UNSIGNED_BYTE) internalFormat = _gl.RGB8UI;
            if (glType === _gl.UNSIGNED_SHORT) internalFormat = _gl.RGB16UI;
            if (glType === _gl.UNSIGNED_INT) internalFormat = _gl.RGB32UI;
            if (glType === _gl.BYTE) internalFormat = _gl.RGB8I;
            if (glType === _gl.SHORT) internalFormat = _gl.RGB16I;
            if (glType === _gl.INT) internalFormat = _gl.RGB32I;
        }
        if (glFormat === _gl.RGBA_INTEGER) {
            if (glType === _gl.UNSIGNED_BYTE) internalFormat = _gl.RGBA8UI;
            if (glType === _gl.UNSIGNED_SHORT) internalFormat = _gl.RGBA16UI;
            if (glType === _gl.UNSIGNED_INT) internalFormat = _gl.RGBA32UI;
            if (glType === _gl.BYTE) internalFormat = _gl.RGBA8I;
            if (glType === _gl.SHORT) internalFormat = _gl.RGBA16I;
            if (glType === _gl.INT) internalFormat = _gl.RGBA32I;
        }
        if (glFormat === _gl.RGB) {
            if (glType === _gl.UNSIGNED_INT_5_9_9_9_REV) internalFormat = _gl.RGB9_E5;
        }
        if (glFormat === _gl.RGBA) {
            const transfer = forceLinearTransfer ? (0, $dyjou.LinearTransfer) : (0, $dyjou.ColorManagement).getTransfer(colorSpace);
            if (glType === _gl.FLOAT) internalFormat = _gl.RGBA32F;
            if (glType === _gl.HALF_FLOAT) internalFormat = _gl.RGBA16F;
            if (glType === _gl.UNSIGNED_BYTE) internalFormat = transfer === (0, $dyjou.SRGBTransfer) ? _gl.SRGB8_ALPHA8 : _gl.RGBA8;
            if (glType === _gl.UNSIGNED_SHORT_4_4_4_4) internalFormat = _gl.RGBA4;
            if (glType === _gl.UNSIGNED_SHORT_5_5_5_1) internalFormat = _gl.RGB5_A1;
        }
        if (internalFormat === _gl.R16F || internalFormat === _gl.R32F || internalFormat === _gl.RG16F || internalFormat === _gl.RG32F || internalFormat === _gl.RGBA16F || internalFormat === _gl.RGBA32F) extensions.get('EXT_color_buffer_float');
        return internalFormat;
    }
    function getInternalDepthFormat(useStencil, depthType) {
        let glInternalFormat;
        if (useStencil) {
            if (depthType === null || depthType === (0, $dyjou.UnsignedIntType) || depthType === (0, $dyjou.UnsignedInt248Type)) glInternalFormat = _gl.DEPTH24_STENCIL8;
            else if (depthType === (0, $dyjou.FloatType)) glInternalFormat = _gl.DEPTH32F_STENCIL8;
            else if (depthType === (0, $dyjou.UnsignedShortType)) {
                glInternalFormat = _gl.DEPTH24_STENCIL8;
                console.warn('DepthTexture: 16 bit depth attachment is not supported with stencil. Using 24-bit attachment.');
            }
        } else {
            if (depthType === null || depthType === (0, $dyjou.UnsignedIntType) || depthType === (0, $dyjou.UnsignedInt248Type)) glInternalFormat = _gl.DEPTH_COMPONENT24;
            else if (depthType === (0, $dyjou.FloatType)) glInternalFormat = _gl.DEPTH_COMPONENT32F;
            else if (depthType === (0, $dyjou.UnsignedShortType)) glInternalFormat = _gl.DEPTH_COMPONENT16;
        }
        return glInternalFormat;
    }
    function getMipLevels(texture, image) {
        if (textureNeedsGenerateMipmaps(texture) === true || texture.isFramebufferTexture && texture.minFilter !== (0, $dyjou.NearestFilter) && texture.minFilter !== (0, $dyjou.LinearFilter)) return Math.log2(Math.max(image.width, image.height)) + 1;
        else if (texture.mipmaps !== undefined && texture.mipmaps.length > 0) // user-defined mipmaps
        return texture.mipmaps.length;
        else if (texture.isCompressedTexture && Array.isArray(texture.image)) return image.mipmaps.length;
        else // texture without mipmaps (only base level)
        return 1;
    }
    //
    function onTextureDispose(event) {
        const texture = event.target;
        texture.removeEventListener('dispose', onTextureDispose);
        deallocateTexture(texture);
        if (texture.isVideoTexture) _videoTextures.delete(texture);
    }
    function onRenderTargetDispose(event) {
        const renderTarget = event.target;
        renderTarget.removeEventListener('dispose', onRenderTargetDispose);
        deallocateRenderTarget(renderTarget);
    }
    //
    function deallocateTexture(texture) {
        const textureProperties = properties.get(texture);
        if (textureProperties.__webglInit === undefined) return;
        // check if it's necessary to remove the WebGLTexture object
        const source = texture.source;
        const webglTextures = _sources.get(source);
        if (webglTextures) {
            const webglTexture = webglTextures[textureProperties.__cacheKey];
            webglTexture.usedTimes--;
            // the WebGLTexture object is not used anymore, remove it
            if (webglTexture.usedTimes === 0) deleteTexture(texture);
            // remove the weak map entry if no WebGLTexture uses the source anymore
            if (Object.keys(webglTextures).length === 0) _sources.delete(source);
        }
        properties.remove(texture);
    }
    function deleteTexture(texture) {
        const textureProperties = properties.get(texture);
        _gl.deleteTexture(textureProperties.__webglTexture);
        const source = texture.source;
        const webglTextures = _sources.get(source);
        delete webglTextures[textureProperties.__cacheKey];
        info.memory.textures--;
    }
    function deallocateRenderTarget(renderTarget) {
        const renderTargetProperties = properties.get(renderTarget);
        if (renderTarget.depthTexture) {
            renderTarget.depthTexture.dispose();
            properties.remove(renderTarget.depthTexture);
        }
        if (renderTarget.isWebGLCubeRenderTarget) for(let i = 0; i < 6; i++){
            if (Array.isArray(renderTargetProperties.__webglFramebuffer[i])) for(let level = 0; level < renderTargetProperties.__webglFramebuffer[i].length; level++)_gl.deleteFramebuffer(renderTargetProperties.__webglFramebuffer[i][level]);
            else _gl.deleteFramebuffer(renderTargetProperties.__webglFramebuffer[i]);
            if (renderTargetProperties.__webglDepthbuffer) _gl.deleteRenderbuffer(renderTargetProperties.__webglDepthbuffer[i]);
        }
        else {
            if (Array.isArray(renderTargetProperties.__webglFramebuffer)) for(let level = 0; level < renderTargetProperties.__webglFramebuffer.length; level++)_gl.deleteFramebuffer(renderTargetProperties.__webglFramebuffer[level]);
            else _gl.deleteFramebuffer(renderTargetProperties.__webglFramebuffer);
            if (renderTargetProperties.__webglDepthbuffer) _gl.deleteRenderbuffer(renderTargetProperties.__webglDepthbuffer);
            if (renderTargetProperties.__webglMultisampledFramebuffer) _gl.deleteFramebuffer(renderTargetProperties.__webglMultisampledFramebuffer);
            if (renderTargetProperties.__webglColorRenderbuffer) {
                for(let i = 0; i < renderTargetProperties.__webglColorRenderbuffer.length; i++)if (renderTargetProperties.__webglColorRenderbuffer[i]) _gl.deleteRenderbuffer(renderTargetProperties.__webglColorRenderbuffer[i]);
            }
            if (renderTargetProperties.__webglDepthRenderbuffer) _gl.deleteRenderbuffer(renderTargetProperties.__webglDepthRenderbuffer);
        }
        const textures = renderTarget.textures;
        for(let i = 0, il = textures.length; i < il; i++){
            const attachmentProperties = properties.get(textures[i]);
            if (attachmentProperties.__webglTexture) {
                _gl.deleteTexture(attachmentProperties.__webglTexture);
                info.memory.textures--;
            }
            properties.remove(textures[i]);
        }
        properties.remove(renderTarget);
    }
    //
    let textureUnits = 0;
    function resetTextureUnits() {
        textureUnits = 0;
    }
    function allocateTextureUnit() {
        const textureUnit = textureUnits;
        if (textureUnit >= capabilities.maxTextures) console.warn('THREE.WebGLTextures: Trying to use ' + textureUnit + ' texture units while this GPU supports only ' + capabilities.maxTextures);
        textureUnits += 1;
        return textureUnit;
    }
    function getTextureCacheKey(texture) {
        const array = [];
        array.push(texture.wrapS);
        array.push(texture.wrapT);
        array.push(texture.wrapR || 0);
        array.push(texture.magFilter);
        array.push(texture.minFilter);
        array.push(texture.anisotropy);
        array.push(texture.internalFormat);
        array.push(texture.format);
        array.push(texture.type);
        array.push(texture.generateMipmaps);
        array.push(texture.premultiplyAlpha);
        array.push(texture.flipY);
        array.push(texture.unpackAlignment);
        array.push(texture.colorSpace);
        return array.join();
    }
    //
    function setTexture2D(texture, slot) {
        const textureProperties = properties.get(texture);
        if (texture.isVideoTexture) updateVideoTexture(texture);
        if (texture.isRenderTargetTexture === false && texture.version > 0 && textureProperties.__version !== texture.version) {
            const image = texture.image;
            if (image === null) console.warn('THREE.WebGLRenderer: Texture marked for update but no image data found.');
            else if (image.complete === false) console.warn('THREE.WebGLRenderer: Texture marked for update but image is incomplete');
            else {
                uploadTexture(textureProperties, texture, slot);
                return;
            }
        }
        state.bindTexture(_gl.TEXTURE_2D, textureProperties.__webglTexture, _gl.TEXTURE0 + slot);
    }
    function setTexture2DArray(texture, slot) {
        const textureProperties = properties.get(texture);
        if (texture.version > 0 && textureProperties.__version !== texture.version) {
            uploadTexture(textureProperties, texture, slot);
            return;
        }
        state.bindTexture(_gl.TEXTURE_2D_ARRAY, textureProperties.__webglTexture, _gl.TEXTURE0 + slot);
    }
    function setTexture3D(texture, slot) {
        const textureProperties = properties.get(texture);
        if (texture.version > 0 && textureProperties.__version !== texture.version) {
            uploadTexture(textureProperties, texture, slot);
            return;
        }
        state.bindTexture(_gl.TEXTURE_3D, textureProperties.__webglTexture, _gl.TEXTURE0 + slot);
    }
    function setTextureCube(texture, slot) {
        const textureProperties = properties.get(texture);
        if (texture.version > 0 && textureProperties.__version !== texture.version) {
            uploadCubeTexture(textureProperties, texture, slot);
            return;
        }
        state.bindTexture(_gl.TEXTURE_CUBE_MAP, textureProperties.__webglTexture, _gl.TEXTURE0 + slot);
    }
    const wrappingToGL = {
        [(0, $dyjou.RepeatWrapping)]: _gl.REPEAT,
        [(0, $dyjou.ClampToEdgeWrapping)]: _gl.CLAMP_TO_EDGE,
        [(0, $dyjou.MirroredRepeatWrapping)]: _gl.MIRRORED_REPEAT
    };
    const filterToGL = {
        [(0, $dyjou.NearestFilter)]: _gl.NEAREST,
        [(0, $dyjou.NearestMipmapNearestFilter)]: _gl.NEAREST_MIPMAP_NEAREST,
        [(0, $dyjou.NearestMipmapLinearFilter)]: _gl.NEAREST_MIPMAP_LINEAR,
        [(0, $dyjou.LinearFilter)]: _gl.LINEAR,
        [(0, $dyjou.LinearMipmapNearestFilter)]: _gl.LINEAR_MIPMAP_NEAREST,
        [(0, $dyjou.LinearMipmapLinearFilter)]: _gl.LINEAR_MIPMAP_LINEAR
    };
    const compareToGL = {
        [(0, $dyjou.NeverCompare)]: _gl.NEVER,
        [(0, $dyjou.AlwaysCompare)]: _gl.ALWAYS,
        [(0, $dyjou.LessCompare)]: _gl.LESS,
        [(0, $dyjou.LessEqualCompare)]: _gl.LEQUAL,
        [(0, $dyjou.EqualCompare)]: _gl.EQUAL,
        [(0, $dyjou.GreaterEqualCompare)]: _gl.GEQUAL,
        [(0, $dyjou.GreaterCompare)]: _gl.GREATER,
        [(0, $dyjou.NotEqualCompare)]: _gl.NOTEQUAL
    };
    function setTextureParameters(textureType, texture) {
        if (texture.type === (0, $dyjou.FloatType) && extensions.has('OES_texture_float_linear') === false && (texture.magFilter === (0, $dyjou.LinearFilter) || texture.magFilter === (0, $dyjou.LinearMipmapNearestFilter) || texture.magFilter === (0, $dyjou.NearestMipmapLinearFilter) || texture.magFilter === (0, $dyjou.LinearMipmapLinearFilter) || texture.minFilter === (0, $dyjou.LinearFilter) || texture.minFilter === (0, $dyjou.LinearMipmapNearestFilter) || texture.minFilter === (0, $dyjou.NearestMipmapLinearFilter) || texture.minFilter === (0, $dyjou.LinearMipmapLinearFilter))) console.warn('THREE.WebGLRenderer: Unable to use linear filtering with floating point textures. OES_texture_float_linear not supported on this device.');
        _gl.texParameteri(textureType, _gl.TEXTURE_WRAP_S, wrappingToGL[texture.wrapS]);
        _gl.texParameteri(textureType, _gl.TEXTURE_WRAP_T, wrappingToGL[texture.wrapT]);
        if (textureType === _gl.TEXTURE_3D || textureType === _gl.TEXTURE_2D_ARRAY) _gl.texParameteri(textureType, _gl.TEXTURE_WRAP_R, wrappingToGL[texture.wrapR]);
        _gl.texParameteri(textureType, _gl.TEXTURE_MAG_FILTER, filterToGL[texture.magFilter]);
        _gl.texParameteri(textureType, _gl.TEXTURE_MIN_FILTER, filterToGL[texture.minFilter]);
        if (texture.compareFunction) {
            _gl.texParameteri(textureType, _gl.TEXTURE_COMPARE_MODE, _gl.COMPARE_REF_TO_TEXTURE);
            _gl.texParameteri(textureType, _gl.TEXTURE_COMPARE_FUNC, compareToGL[texture.compareFunction]);
        }
        if (extensions.has('EXT_texture_filter_anisotropic') === true) {
            if (texture.magFilter === (0, $dyjou.NearestFilter)) return;
            if (texture.minFilter !== (0, $dyjou.NearestMipmapLinearFilter) && texture.minFilter !== (0, $dyjou.LinearMipmapLinearFilter)) return;
            if (texture.type === (0, $dyjou.FloatType) && extensions.has('OES_texture_float_linear') === false) return; // verify extension
            if (texture.anisotropy > 1 || properties.get(texture).__currentAnisotropy) {
                const extension = extensions.get('EXT_texture_filter_anisotropic');
                _gl.texParameterf(textureType, extension.TEXTURE_MAX_ANISOTROPY_EXT, Math.min(texture.anisotropy, capabilities.getMaxAnisotropy()));
                properties.get(texture).__currentAnisotropy = texture.anisotropy;
            }
        }
    }
    function initTexture(textureProperties, texture) {
        let forceUpload = false;
        if (textureProperties.__webglInit === undefined) {
            textureProperties.__webglInit = true;
            texture.addEventListener('dispose', onTextureDispose);
        }
        // create Source <-> WebGLTextures mapping if necessary
        const source = texture.source;
        let webglTextures = _sources.get(source);
        if (webglTextures === undefined) {
            webglTextures = {};
            _sources.set(source, webglTextures);
        }
        // check if there is already a WebGLTexture object for the given texture parameters
        const textureCacheKey = getTextureCacheKey(texture);
        if (textureCacheKey !== textureProperties.__cacheKey) {
            // if not, create a new instance of WebGLTexture
            if (webglTextures[textureCacheKey] === undefined) {
                // create new entry
                webglTextures[textureCacheKey] = {
                    texture: _gl.createTexture(),
                    usedTimes: 0
                };
                info.memory.textures++;
                // when a new instance of WebGLTexture was created, a texture upload is required
                // even if the image contents are identical
                forceUpload = true;
            }
            webglTextures[textureCacheKey].usedTimes++;
            // every time the texture cache key changes, it's necessary to check if an instance of
            // WebGLTexture can be deleted in order to avoid a memory leak.
            const webglTexture = webglTextures[textureProperties.__cacheKey];
            if (webglTexture !== undefined) {
                webglTextures[textureProperties.__cacheKey].usedTimes--;
                if (webglTexture.usedTimes === 0) deleteTexture(texture);
            }
            // store references to cache key and WebGLTexture object
            textureProperties.__cacheKey = textureCacheKey;
            textureProperties.__webglTexture = webglTextures[textureCacheKey].texture;
        }
        return forceUpload;
    }
    function uploadTexture(textureProperties, texture, slot) {
        let textureType = _gl.TEXTURE_2D;
        if (texture.isDataArrayTexture || texture.isCompressedArrayTexture) textureType = _gl.TEXTURE_2D_ARRAY;
        if (texture.isData3DTexture) textureType = _gl.TEXTURE_3D;
        const forceUpload = initTexture(textureProperties, texture);
        const source = texture.source;
        state.bindTexture(textureType, textureProperties.__webglTexture, _gl.TEXTURE0 + slot);
        const sourceProperties = properties.get(source);
        if (source.version !== sourceProperties.__version || forceUpload === true) {
            state.activeTexture(_gl.TEXTURE0 + slot);
            const workingPrimaries = (0, $dyjou.ColorManagement).getPrimaries((0, $dyjou.ColorManagement).workingColorSpace);
            const texturePrimaries = texture.colorSpace === (0, $dyjou.NoColorSpace) ? null : (0, $dyjou.ColorManagement).getPrimaries(texture.colorSpace);
            const unpackConversion = texture.colorSpace === (0, $dyjou.NoColorSpace) || workingPrimaries === texturePrimaries ? _gl.NONE : _gl.BROWSER_DEFAULT_WEBGL;
            _gl.pixelStorei(_gl.UNPACK_FLIP_Y_WEBGL, texture.flipY);
            _gl.pixelStorei(_gl.UNPACK_PREMULTIPLY_ALPHA_WEBGL, texture.premultiplyAlpha);
            _gl.pixelStorei(_gl.UNPACK_ALIGNMENT, texture.unpackAlignment);
            _gl.pixelStorei(_gl.UNPACK_COLORSPACE_CONVERSION_WEBGL, unpackConversion);
            let image = resizeImage(texture.image, false, capabilities.maxTextureSize);
            image = verifyColorSpace(texture, image);
            const glFormat = utils.convert(texture.format, texture.colorSpace);
            const glType = utils.convert(texture.type);
            let glInternalFormat = getInternalFormat(texture.internalFormat, glFormat, glType, texture.colorSpace, texture.isVideoTexture);
            setTextureParameters(textureType, texture);
            let mipmap;
            const mipmaps = texture.mipmaps;
            const useTexStorage = texture.isVideoTexture !== true;
            const allocateMemory = sourceProperties.__version === undefined || forceUpload === true;
            const dataReady = source.dataReady;
            const levels = getMipLevels(texture, image);
            if (texture.isDepthTexture) {
                glInternalFormat = getInternalDepthFormat(texture.format === (0, $dyjou.DepthStencilFormat), texture.type);
                //
                if (allocateMemory) {
                    if (useTexStorage) state.texStorage2D(_gl.TEXTURE_2D, 1, glInternalFormat, image.width, image.height);
                    else state.texImage2D(_gl.TEXTURE_2D, 0, glInternalFormat, image.width, image.height, 0, glFormat, glType, null);
                }
            } else if (texture.isDataTexture) {
                // use manually created mipmaps if available
                // if there are no manual mipmaps
                // set 0 level mipmap and then use GL to generate other mipmap levels
                if (mipmaps.length > 0) {
                    if (useTexStorage && allocateMemory) state.texStorage2D(_gl.TEXTURE_2D, levels, glInternalFormat, mipmaps[0].width, mipmaps[0].height);
                    for(let i = 0, il = mipmaps.length; i < il; i++){
                        mipmap = mipmaps[i];
                        if (useTexStorage) {
                            if (dataReady) state.texSubImage2D(_gl.TEXTURE_2D, i, 0, 0, mipmap.width, mipmap.height, glFormat, glType, mipmap.data);
                        } else state.texImage2D(_gl.TEXTURE_2D, i, glInternalFormat, mipmap.width, mipmap.height, 0, glFormat, glType, mipmap.data);
                    }
                    texture.generateMipmaps = false;
                } else if (useTexStorage) {
                    if (allocateMemory) state.texStorage2D(_gl.TEXTURE_2D, levels, glInternalFormat, image.width, image.height);
                    if (dataReady) state.texSubImage2D(_gl.TEXTURE_2D, 0, 0, 0, image.width, image.height, glFormat, glType, image.data);
                } else state.texImage2D(_gl.TEXTURE_2D, 0, glInternalFormat, image.width, image.height, 0, glFormat, glType, image.data);
            } else if (texture.isCompressedTexture) {
                if (texture.isCompressedArrayTexture) {
                    if (useTexStorage && allocateMemory) state.texStorage3D(_gl.TEXTURE_2D_ARRAY, levels, glInternalFormat, mipmaps[0].width, mipmaps[0].height, image.depth);
                    for(let i = 0, il = mipmaps.length; i < il; i++){
                        mipmap = mipmaps[i];
                        if (texture.format !== (0, $dyjou.RGBAFormat)) {
                            if (glFormat !== null) {
                                if (useTexStorage) {
                                    if (dataReady) {
                                        if (texture.layerUpdates.size > 0) {
                                            const layerByteLength = (0, $dyjou.getByteLength)(mipmap.width, mipmap.height, texture.format, texture.type);
                                            for (const layerIndex of texture.layerUpdates){
                                                const layerData = mipmap.data.subarray(layerIndex * layerByteLength / mipmap.data.BYTES_PER_ELEMENT, (layerIndex + 1) * layerByteLength / mipmap.data.BYTES_PER_ELEMENT);
                                                state.compressedTexSubImage3D(_gl.TEXTURE_2D_ARRAY, i, 0, 0, layerIndex, mipmap.width, mipmap.height, 1, glFormat, layerData);
                                            }
                                            texture.clearLayerUpdates();
                                        } else state.compressedTexSubImage3D(_gl.TEXTURE_2D_ARRAY, i, 0, 0, 0, mipmap.width, mipmap.height, image.depth, glFormat, mipmap.data);
                                    }
                                } else state.compressedTexImage3D(_gl.TEXTURE_2D_ARRAY, i, glInternalFormat, mipmap.width, mipmap.height, image.depth, 0, mipmap.data, 0, 0);
                            } else console.warn('THREE.WebGLRenderer: Attempt to load unsupported compressed texture format in .uploadTexture()');
                        } else {
                            if (useTexStorage) {
                                if (dataReady) state.texSubImage3D(_gl.TEXTURE_2D_ARRAY, i, 0, 0, 0, mipmap.width, mipmap.height, image.depth, glFormat, glType, mipmap.data);
                            } else state.texImage3D(_gl.TEXTURE_2D_ARRAY, i, glInternalFormat, mipmap.width, mipmap.height, image.depth, 0, glFormat, glType, mipmap.data);
                        }
                    }
                } else {
                    if (useTexStorage && allocateMemory) state.texStorage2D(_gl.TEXTURE_2D, levels, glInternalFormat, mipmaps[0].width, mipmaps[0].height);
                    for(let i = 0, il = mipmaps.length; i < il; i++){
                        mipmap = mipmaps[i];
                        if (texture.format !== (0, $dyjou.RGBAFormat)) {
                            if (glFormat !== null) {
                                if (useTexStorage) {
                                    if (dataReady) state.compressedTexSubImage2D(_gl.TEXTURE_2D, i, 0, 0, mipmap.width, mipmap.height, glFormat, mipmap.data);
                                } else state.compressedTexImage2D(_gl.TEXTURE_2D, i, glInternalFormat, mipmap.width, mipmap.height, 0, mipmap.data);
                            } else console.warn('THREE.WebGLRenderer: Attempt to load unsupported compressed texture format in .uploadTexture()');
                        } else {
                            if (useTexStorage) {
                                if (dataReady) state.texSubImage2D(_gl.TEXTURE_2D, i, 0, 0, mipmap.width, mipmap.height, glFormat, glType, mipmap.data);
                            } else state.texImage2D(_gl.TEXTURE_2D, i, glInternalFormat, mipmap.width, mipmap.height, 0, glFormat, glType, mipmap.data);
                        }
                    }
                }
            } else if (texture.isDataArrayTexture) {
                if (useTexStorage) {
                    if (allocateMemory) state.texStorage3D(_gl.TEXTURE_2D_ARRAY, levels, glInternalFormat, image.width, image.height, image.depth);
                    if (dataReady) {
                        if (texture.layerUpdates.size > 0) {
                            const layerByteLength = (0, $dyjou.getByteLength)(image.width, image.height, texture.format, texture.type);
                            for (const layerIndex of texture.layerUpdates){
                                const layerData = image.data.subarray(layerIndex * layerByteLength / image.data.BYTES_PER_ELEMENT, (layerIndex + 1) * layerByteLength / image.data.BYTES_PER_ELEMENT);
                                state.texSubImage3D(_gl.TEXTURE_2D_ARRAY, 0, 0, 0, layerIndex, image.width, image.height, 1, glFormat, glType, layerData);
                            }
                            texture.clearLayerUpdates();
                        } else state.texSubImage3D(_gl.TEXTURE_2D_ARRAY, 0, 0, 0, 0, image.width, image.height, image.depth, glFormat, glType, image.data);
                    }
                } else state.texImage3D(_gl.TEXTURE_2D_ARRAY, 0, glInternalFormat, image.width, image.height, image.depth, 0, glFormat, glType, image.data);
            } else if (texture.isData3DTexture) {
                if (useTexStorage) {
                    if (allocateMemory) state.texStorage3D(_gl.TEXTURE_3D, levels, glInternalFormat, image.width, image.height, image.depth);
                    if (dataReady) state.texSubImage3D(_gl.TEXTURE_3D, 0, 0, 0, 0, image.width, image.height, image.depth, glFormat, glType, image.data);
                } else state.texImage3D(_gl.TEXTURE_3D, 0, glInternalFormat, image.width, image.height, image.depth, 0, glFormat, glType, image.data);
            } else if (texture.isFramebufferTexture) {
                if (allocateMemory) {
                    if (useTexStorage) state.texStorage2D(_gl.TEXTURE_2D, levels, glInternalFormat, image.width, image.height);
                    else {
                        let width = image.width, height = image.height;
                        for(let i = 0; i < levels; i++){
                            state.texImage2D(_gl.TEXTURE_2D, i, glInternalFormat, width, height, 0, glFormat, glType, null);
                            width >>= 1;
                            height >>= 1;
                        }
                    }
                }
            } else {
                // regular Texture (image, video, canvas)
                // use manually created mipmaps if available
                // if there are no manual mipmaps
                // set 0 level mipmap and then use GL to generate other mipmap levels
                if (mipmaps.length > 0) {
                    if (useTexStorage && allocateMemory) {
                        const dimensions = getDimensions(mipmaps[0]);
                        state.texStorage2D(_gl.TEXTURE_2D, levels, glInternalFormat, dimensions.width, dimensions.height);
                    }
                    for(let i = 0, il = mipmaps.length; i < il; i++){
                        mipmap = mipmaps[i];
                        if (useTexStorage) {
                            if (dataReady) state.texSubImage2D(_gl.TEXTURE_2D, i, 0, 0, glFormat, glType, mipmap);
                        } else state.texImage2D(_gl.TEXTURE_2D, i, glInternalFormat, glFormat, glType, mipmap);
                    }
                    texture.generateMipmaps = false;
                } else if (useTexStorage) {
                    if (allocateMemory) {
                        const dimensions = getDimensions(image);
                        state.texStorage2D(_gl.TEXTURE_2D, levels, glInternalFormat, dimensions.width, dimensions.height);
                    }
                    if (dataReady) state.texSubImage2D(_gl.TEXTURE_2D, 0, 0, 0, glFormat, glType, image);
                } else state.texImage2D(_gl.TEXTURE_2D, 0, glInternalFormat, glFormat, glType, image);
            }
            if (textureNeedsGenerateMipmaps(texture)) generateMipmap(textureType);
            sourceProperties.__version = source.version;
            if (texture.onUpdate) texture.onUpdate(texture);
        }
        textureProperties.__version = texture.version;
    }
    function uploadCubeTexture(textureProperties, texture, slot) {
        if (texture.image.length !== 6) return;
        const forceUpload = initTexture(textureProperties, texture);
        const source = texture.source;
        state.bindTexture(_gl.TEXTURE_CUBE_MAP, textureProperties.__webglTexture, _gl.TEXTURE0 + slot);
        const sourceProperties = properties.get(source);
        if (source.version !== sourceProperties.__version || forceUpload === true) {
            state.activeTexture(_gl.TEXTURE0 + slot);
            const workingPrimaries = (0, $dyjou.ColorManagement).getPrimaries((0, $dyjou.ColorManagement).workingColorSpace);
            const texturePrimaries = texture.colorSpace === (0, $dyjou.NoColorSpace) ? null : (0, $dyjou.ColorManagement).getPrimaries(texture.colorSpace);
            const unpackConversion = texture.colorSpace === (0, $dyjou.NoColorSpace) || workingPrimaries === texturePrimaries ? _gl.NONE : _gl.BROWSER_DEFAULT_WEBGL;
            _gl.pixelStorei(_gl.UNPACK_FLIP_Y_WEBGL, texture.flipY);
            _gl.pixelStorei(_gl.UNPACK_PREMULTIPLY_ALPHA_WEBGL, texture.premultiplyAlpha);
            _gl.pixelStorei(_gl.UNPACK_ALIGNMENT, texture.unpackAlignment);
            _gl.pixelStorei(_gl.UNPACK_COLORSPACE_CONVERSION_WEBGL, unpackConversion);
            const isCompressed = texture.isCompressedTexture || texture.image[0].isCompressedTexture;
            const isDataTexture = texture.image[0] && texture.image[0].isDataTexture;
            const cubeImage = [];
            for(let i = 0; i < 6; i++){
                if (!isCompressed && !isDataTexture) cubeImage[i] = resizeImage(texture.image[i], true, capabilities.maxCubemapSize);
                else cubeImage[i] = isDataTexture ? texture.image[i].image : texture.image[i];
                cubeImage[i] = verifyColorSpace(texture, cubeImage[i]);
            }
            const image = cubeImage[0], glFormat = utils.convert(texture.format, texture.colorSpace), glType = utils.convert(texture.type), glInternalFormat = getInternalFormat(texture.internalFormat, glFormat, glType, texture.colorSpace);
            const useTexStorage = texture.isVideoTexture !== true;
            const allocateMemory = sourceProperties.__version === undefined || forceUpload === true;
            const dataReady = source.dataReady;
            let levels = getMipLevels(texture, image);
            setTextureParameters(_gl.TEXTURE_CUBE_MAP, texture);
            let mipmaps;
            if (isCompressed) {
                if (useTexStorage && allocateMemory) state.texStorage2D(_gl.TEXTURE_CUBE_MAP, levels, glInternalFormat, image.width, image.height);
                for(let i = 0; i < 6; i++){
                    mipmaps = cubeImage[i].mipmaps;
                    for(let j = 0; j < mipmaps.length; j++){
                        const mipmap = mipmaps[j];
                        if (texture.format !== (0, $dyjou.RGBAFormat)) {
                            if (glFormat !== null) {
                                if (useTexStorage) {
                                    if (dataReady) state.compressedTexSubImage2D(_gl.TEXTURE_CUBE_MAP_POSITIVE_X + i, j, 0, 0, mipmap.width, mipmap.height, glFormat, mipmap.data);
                                } else state.compressedTexImage2D(_gl.TEXTURE_CUBE_MAP_POSITIVE_X + i, j, glInternalFormat, mipmap.width, mipmap.height, 0, mipmap.data);
                            } else console.warn('THREE.WebGLRenderer: Attempt to load unsupported compressed texture format in .setTextureCube()');
                        } else {
                            if (useTexStorage) {
                                if (dataReady) state.texSubImage2D(_gl.TEXTURE_CUBE_MAP_POSITIVE_X + i, j, 0, 0, mipmap.width, mipmap.height, glFormat, glType, mipmap.data);
                            } else state.texImage2D(_gl.TEXTURE_CUBE_MAP_POSITIVE_X + i, j, glInternalFormat, mipmap.width, mipmap.height, 0, glFormat, glType, mipmap.data);
                        }
                    }
                }
            } else {
                mipmaps = texture.mipmaps;
                if (useTexStorage && allocateMemory) {
                    // TODO: Uniformly handle mipmap definitions
                    // Normal textures and compressed cube textures define base level + mips with their mipmap array
                    // Uncompressed cube textures use their mipmap array only for mips (no base level)
                    if (mipmaps.length > 0) levels++;
                    const dimensions = getDimensions(cubeImage[0]);
                    state.texStorage2D(_gl.TEXTURE_CUBE_MAP, levels, glInternalFormat, dimensions.width, dimensions.height);
                }
                for(let i = 0; i < 6; i++)if (isDataTexture) {
                    if (useTexStorage) {
                        if (dataReady) state.texSubImage2D(_gl.TEXTURE_CUBE_MAP_POSITIVE_X + i, 0, 0, 0, cubeImage[i].width, cubeImage[i].height, glFormat, glType, cubeImage[i].data);
                    } else state.texImage2D(_gl.TEXTURE_CUBE_MAP_POSITIVE_X + i, 0, glInternalFormat, cubeImage[i].width, cubeImage[i].height, 0, glFormat, glType, cubeImage[i].data);
                    for(let j = 0; j < mipmaps.length; j++){
                        const mipmap = mipmaps[j];
                        const mipmapImage = mipmap.image[i].image;
                        if (useTexStorage) {
                            if (dataReady) state.texSubImage2D(_gl.TEXTURE_CUBE_MAP_POSITIVE_X + i, j + 1, 0, 0, mipmapImage.width, mipmapImage.height, glFormat, glType, mipmapImage.data);
                        } else state.texImage2D(_gl.TEXTURE_CUBE_MAP_POSITIVE_X + i, j + 1, glInternalFormat, mipmapImage.width, mipmapImage.height, 0, glFormat, glType, mipmapImage.data);
                    }
                } else {
                    if (useTexStorage) {
                        if (dataReady) state.texSubImage2D(_gl.TEXTURE_CUBE_MAP_POSITIVE_X + i, 0, 0, 0, glFormat, glType, cubeImage[i]);
                    } else state.texImage2D(_gl.TEXTURE_CUBE_MAP_POSITIVE_X + i, 0, glInternalFormat, glFormat, glType, cubeImage[i]);
                    for(let j = 0; j < mipmaps.length; j++){
                        const mipmap = mipmaps[j];
                        if (useTexStorage) {
                            if (dataReady) state.texSubImage2D(_gl.TEXTURE_CUBE_MAP_POSITIVE_X + i, j + 1, 0, 0, glFormat, glType, mipmap.image[i]);
                        } else state.texImage2D(_gl.TEXTURE_CUBE_MAP_POSITIVE_X + i, j + 1, glInternalFormat, glFormat, glType, mipmap.image[i]);
                    }
                }
            }
            if (textureNeedsGenerateMipmaps(texture)) // We assume images for cube map have the same size.
            generateMipmap(_gl.TEXTURE_CUBE_MAP);
            sourceProperties.__version = source.version;
            if (texture.onUpdate) texture.onUpdate(texture);
        }
        textureProperties.__version = texture.version;
    }
    // Render targets
    // Setup storage for target texture and bind it to correct framebuffer
    function setupFrameBufferTexture(framebuffer, renderTarget, texture, attachment, textureTarget, level) {
        const glFormat = utils.convert(texture.format, texture.colorSpace);
        const glType = utils.convert(texture.type);
        const glInternalFormat = getInternalFormat(texture.internalFormat, glFormat, glType, texture.colorSpace);
        const renderTargetProperties = properties.get(renderTarget);
        const textureProperties = properties.get(texture);
        textureProperties.__renderTarget = renderTarget;
        if (!renderTargetProperties.__hasExternalTextures) {
            const width = Math.max(1, renderTarget.width >> level);
            const height = Math.max(1, renderTarget.height >> level);
            if (textureTarget === _gl.TEXTURE_3D || textureTarget === _gl.TEXTURE_2D_ARRAY) state.texImage3D(textureTarget, level, glInternalFormat, width, height, renderTarget.depth, 0, glFormat, glType, null);
            else state.texImage2D(textureTarget, level, glInternalFormat, width, height, 0, glFormat, glType, null);
        }
        state.bindFramebuffer(_gl.FRAMEBUFFER, framebuffer);
        if (useMultisampledRTT(renderTarget)) multisampledRTTExt.framebufferTexture2DMultisampleEXT(_gl.FRAMEBUFFER, attachment, textureTarget, textureProperties.__webglTexture, 0, getRenderTargetSamples(renderTarget));
        else if (textureTarget === _gl.TEXTURE_2D || textureTarget >= _gl.TEXTURE_CUBE_MAP_POSITIVE_X && textureTarget <= _gl.TEXTURE_CUBE_MAP_NEGATIVE_Z) _gl.framebufferTexture2D(_gl.FRAMEBUFFER, attachment, textureTarget, textureProperties.__webglTexture, level);
        state.bindFramebuffer(_gl.FRAMEBUFFER, null);
    }
    // Setup storage for internal depth/stencil buffers and bind to correct framebuffer
    function setupRenderBufferStorage(renderbuffer, renderTarget, isMultisample) {
        _gl.bindRenderbuffer(_gl.RENDERBUFFER, renderbuffer);
        if (renderTarget.depthBuffer) {
            // retrieve the depth attachment types
            const depthTexture = renderTarget.depthTexture;
            const depthType = depthTexture && depthTexture.isDepthTexture ? depthTexture.type : null;
            const glInternalFormat = getInternalDepthFormat(renderTarget.stencilBuffer, depthType);
            const glAttachmentType = renderTarget.stencilBuffer ? _gl.DEPTH_STENCIL_ATTACHMENT : _gl.DEPTH_ATTACHMENT;
            // set up the attachment
            const samples = getRenderTargetSamples(renderTarget);
            const isUseMultisampledRTT = useMultisampledRTT(renderTarget);
            if (isUseMultisampledRTT) multisampledRTTExt.renderbufferStorageMultisampleEXT(_gl.RENDERBUFFER, samples, glInternalFormat, renderTarget.width, renderTarget.height);
            else if (isMultisample) _gl.renderbufferStorageMultisample(_gl.RENDERBUFFER, samples, glInternalFormat, renderTarget.width, renderTarget.height);
            else _gl.renderbufferStorage(_gl.RENDERBUFFER, glInternalFormat, renderTarget.width, renderTarget.height);
            _gl.framebufferRenderbuffer(_gl.FRAMEBUFFER, glAttachmentType, _gl.RENDERBUFFER, renderbuffer);
        } else {
            const textures = renderTarget.textures;
            for(let i = 0; i < textures.length; i++){
                const texture = textures[i];
                const glFormat = utils.convert(texture.format, texture.colorSpace);
                const glType = utils.convert(texture.type);
                const glInternalFormat = getInternalFormat(texture.internalFormat, glFormat, glType, texture.colorSpace);
                const samples = getRenderTargetSamples(renderTarget);
                if (isMultisample && useMultisampledRTT(renderTarget) === false) _gl.renderbufferStorageMultisample(_gl.RENDERBUFFER, samples, glInternalFormat, renderTarget.width, renderTarget.height);
                else if (useMultisampledRTT(renderTarget)) multisampledRTTExt.renderbufferStorageMultisampleEXT(_gl.RENDERBUFFER, samples, glInternalFormat, renderTarget.width, renderTarget.height);
                else _gl.renderbufferStorage(_gl.RENDERBUFFER, glInternalFormat, renderTarget.width, renderTarget.height);
            }
        }
        _gl.bindRenderbuffer(_gl.RENDERBUFFER, null);
    }
    // Setup resources for a Depth Texture for a FBO (needs an extension)
    function setupDepthTexture(framebuffer, renderTarget) {
        const isCube = renderTarget && renderTarget.isWebGLCubeRenderTarget;
        if (isCube) throw new Error('Depth Texture with cube render targets is not supported');
        state.bindFramebuffer(_gl.FRAMEBUFFER, framebuffer);
        if (!(renderTarget.depthTexture && renderTarget.depthTexture.isDepthTexture)) throw new Error('renderTarget.depthTexture must be an instance of THREE.DepthTexture');
        const textureProperties = properties.get(renderTarget.depthTexture);
        textureProperties.__renderTarget = renderTarget;
        // upload an empty depth texture with framebuffer size
        if (!textureProperties.__webglTexture || renderTarget.depthTexture.image.width !== renderTarget.width || renderTarget.depthTexture.image.height !== renderTarget.height) {
            renderTarget.depthTexture.image.width = renderTarget.width;
            renderTarget.depthTexture.image.height = renderTarget.height;
            renderTarget.depthTexture.needsUpdate = true;
        }
        setTexture2D(renderTarget.depthTexture, 0);
        const webglDepthTexture = textureProperties.__webglTexture;
        const samples = getRenderTargetSamples(renderTarget);
        if (renderTarget.depthTexture.format === (0, $dyjou.DepthFormat)) {
            if (useMultisampledRTT(renderTarget)) multisampledRTTExt.framebufferTexture2DMultisampleEXT(_gl.FRAMEBUFFER, _gl.DEPTH_ATTACHMENT, _gl.TEXTURE_2D, webglDepthTexture, 0, samples);
            else _gl.framebufferTexture2D(_gl.FRAMEBUFFER, _gl.DEPTH_ATTACHMENT, _gl.TEXTURE_2D, webglDepthTexture, 0);
        } else if (renderTarget.depthTexture.format === (0, $dyjou.DepthStencilFormat)) {
            if (useMultisampledRTT(renderTarget)) multisampledRTTExt.framebufferTexture2DMultisampleEXT(_gl.FRAMEBUFFER, _gl.DEPTH_STENCIL_ATTACHMENT, _gl.TEXTURE_2D, webglDepthTexture, 0, samples);
            else _gl.framebufferTexture2D(_gl.FRAMEBUFFER, _gl.DEPTH_STENCIL_ATTACHMENT, _gl.TEXTURE_2D, webglDepthTexture, 0);
        } else throw new Error('Unknown depthTexture format');
    }
    // Setup GL resources for a non-texture depth buffer
    function setupDepthRenderbuffer(renderTarget) {
        const renderTargetProperties = properties.get(renderTarget);
        const isCube = renderTarget.isWebGLCubeRenderTarget === true;
        // if the bound depth texture has changed
        if (renderTargetProperties.__boundDepthTexture !== renderTarget.depthTexture) {
            // fire the dispose event to get rid of stored state associated with the previously bound depth buffer
            const depthTexture = renderTarget.depthTexture;
            if (renderTargetProperties.__depthDisposeCallback) renderTargetProperties.__depthDisposeCallback();
            // set up dispose listeners to track when the currently attached buffer is implicitly unbound
            if (depthTexture) {
                const disposeEvent = ()=>{
                    delete renderTargetProperties.__boundDepthTexture;
                    delete renderTargetProperties.__depthDisposeCallback;
                    depthTexture.removeEventListener('dispose', disposeEvent);
                };
                depthTexture.addEventListener('dispose', disposeEvent);
                renderTargetProperties.__depthDisposeCallback = disposeEvent;
            }
            renderTargetProperties.__boundDepthTexture = depthTexture;
        }
        if (renderTarget.depthTexture && !renderTargetProperties.__autoAllocateDepthBuffer) {
            if (isCube) throw new Error('target.depthTexture not supported in Cube render targets');
            setupDepthTexture(renderTargetProperties.__webglFramebuffer, renderTarget);
        } else if (isCube) {
            renderTargetProperties.__webglDepthbuffer = [];
            for(let i = 0; i < 6; i++){
                state.bindFramebuffer(_gl.FRAMEBUFFER, renderTargetProperties.__webglFramebuffer[i]);
                if (renderTargetProperties.__webglDepthbuffer[i] === undefined) {
                    renderTargetProperties.__webglDepthbuffer[i] = _gl.createRenderbuffer();
                    setupRenderBufferStorage(renderTargetProperties.__webglDepthbuffer[i], renderTarget, false);
                } else {
                    // attach buffer if it's been created already
                    const glAttachmentType = renderTarget.stencilBuffer ? _gl.DEPTH_STENCIL_ATTACHMENT : _gl.DEPTH_ATTACHMENT;
                    const renderbuffer = renderTargetProperties.__webglDepthbuffer[i];
                    _gl.bindRenderbuffer(_gl.RENDERBUFFER, renderbuffer);
                    _gl.framebufferRenderbuffer(_gl.FRAMEBUFFER, glAttachmentType, _gl.RENDERBUFFER, renderbuffer);
                }
            }
        } else {
            state.bindFramebuffer(_gl.FRAMEBUFFER, renderTargetProperties.__webglFramebuffer);
            if (renderTargetProperties.__webglDepthbuffer === undefined) {
                renderTargetProperties.__webglDepthbuffer = _gl.createRenderbuffer();
                setupRenderBufferStorage(renderTargetProperties.__webglDepthbuffer, renderTarget, false);
            } else {
                // attach buffer if it's been created already
                const glAttachmentType = renderTarget.stencilBuffer ? _gl.DEPTH_STENCIL_ATTACHMENT : _gl.DEPTH_ATTACHMENT;
                const renderbuffer = renderTargetProperties.__webglDepthbuffer;
                _gl.bindRenderbuffer(_gl.RENDERBUFFER, renderbuffer);
                _gl.framebufferRenderbuffer(_gl.FRAMEBUFFER, glAttachmentType, _gl.RENDERBUFFER, renderbuffer);
            }
        }
        state.bindFramebuffer(_gl.FRAMEBUFFER, null);
    }
    // rebind framebuffer with external textures
    function rebindTextures(renderTarget, colorTexture, depthTexture) {
        const renderTargetProperties = properties.get(renderTarget);
        if (colorTexture !== undefined) setupFrameBufferTexture(renderTargetProperties.__webglFramebuffer, renderTarget, renderTarget.texture, _gl.COLOR_ATTACHMENT0, _gl.TEXTURE_2D, 0);
        if (depthTexture !== undefined) setupDepthRenderbuffer(renderTarget);
    }
    // Set up GL resources for the render target
    function setupRenderTarget(renderTarget) {
        const texture = renderTarget.texture;
        const renderTargetProperties = properties.get(renderTarget);
        const textureProperties = properties.get(texture);
        renderTarget.addEventListener('dispose', onRenderTargetDispose);
        const textures = renderTarget.textures;
        const isCube = renderTarget.isWebGLCubeRenderTarget === true;
        const isMultipleRenderTargets = textures.length > 1;
        if (!isMultipleRenderTargets) {
            if (textureProperties.__webglTexture === undefined) textureProperties.__webglTexture = _gl.createTexture();
            textureProperties.__version = texture.version;
            info.memory.textures++;
        }
        // Setup framebuffer
        if (isCube) {
            renderTargetProperties.__webglFramebuffer = [];
            for(let i = 0; i < 6; i++)if (texture.mipmaps && texture.mipmaps.length > 0) {
                renderTargetProperties.__webglFramebuffer[i] = [];
                for(let level = 0; level < texture.mipmaps.length; level++)renderTargetProperties.__webglFramebuffer[i][level] = _gl.createFramebuffer();
            } else renderTargetProperties.__webglFramebuffer[i] = _gl.createFramebuffer();
        } else {
            if (texture.mipmaps && texture.mipmaps.length > 0) {
                renderTargetProperties.__webglFramebuffer = [];
                for(let level = 0; level < texture.mipmaps.length; level++)renderTargetProperties.__webglFramebuffer[level] = _gl.createFramebuffer();
            } else renderTargetProperties.__webglFramebuffer = _gl.createFramebuffer();
            if (isMultipleRenderTargets) for(let i = 0, il = textures.length; i < il; i++){
                const attachmentProperties = properties.get(textures[i]);
                if (attachmentProperties.__webglTexture === undefined) {
                    attachmentProperties.__webglTexture = _gl.createTexture();
                    info.memory.textures++;
                }
            }
            if (renderTarget.samples > 0 && useMultisampledRTT(renderTarget) === false) {
                renderTargetProperties.__webglMultisampledFramebuffer = _gl.createFramebuffer();
                renderTargetProperties.__webglColorRenderbuffer = [];
                state.bindFramebuffer(_gl.FRAMEBUFFER, renderTargetProperties.__webglMultisampledFramebuffer);
                for(let i = 0; i < textures.length; i++){
                    const texture = textures[i];
                    renderTargetProperties.__webglColorRenderbuffer[i] = _gl.createRenderbuffer();
                    _gl.bindRenderbuffer(_gl.RENDERBUFFER, renderTargetProperties.__webglColorRenderbuffer[i]);
                    const glFormat = utils.convert(texture.format, texture.colorSpace);
                    const glType = utils.convert(texture.type);
                    const glInternalFormat = getInternalFormat(texture.internalFormat, glFormat, glType, texture.colorSpace, renderTarget.isXRRenderTarget === true);
                    const samples = getRenderTargetSamples(renderTarget);
                    _gl.renderbufferStorageMultisample(_gl.RENDERBUFFER, samples, glInternalFormat, renderTarget.width, renderTarget.height);
                    _gl.framebufferRenderbuffer(_gl.FRAMEBUFFER, _gl.COLOR_ATTACHMENT0 + i, _gl.RENDERBUFFER, renderTargetProperties.__webglColorRenderbuffer[i]);
                }
                _gl.bindRenderbuffer(_gl.RENDERBUFFER, null);
                if (renderTarget.depthBuffer) {
                    renderTargetProperties.__webglDepthRenderbuffer = _gl.createRenderbuffer();
                    setupRenderBufferStorage(renderTargetProperties.__webglDepthRenderbuffer, renderTarget, true);
                }
                state.bindFramebuffer(_gl.FRAMEBUFFER, null);
            }
        }
        // Setup color buffer
        if (isCube) {
            state.bindTexture(_gl.TEXTURE_CUBE_MAP, textureProperties.__webglTexture);
            setTextureParameters(_gl.TEXTURE_CUBE_MAP, texture);
            for(let i = 0; i < 6; i++){
                if (texture.mipmaps && texture.mipmaps.length > 0) for(let level = 0; level < texture.mipmaps.length; level++)setupFrameBufferTexture(renderTargetProperties.__webglFramebuffer[i][level], renderTarget, texture, _gl.COLOR_ATTACHMENT0, _gl.TEXTURE_CUBE_MAP_POSITIVE_X + i, level);
                else setupFrameBufferTexture(renderTargetProperties.__webglFramebuffer[i], renderTarget, texture, _gl.COLOR_ATTACHMENT0, _gl.TEXTURE_CUBE_MAP_POSITIVE_X + i, 0);
            }
            if (textureNeedsGenerateMipmaps(texture)) generateMipmap(_gl.TEXTURE_CUBE_MAP);
            state.unbindTexture();
        } else if (isMultipleRenderTargets) {
            for(let i = 0, il = textures.length; i < il; i++){
                const attachment = textures[i];
                const attachmentProperties = properties.get(attachment);
                state.bindTexture(_gl.TEXTURE_2D, attachmentProperties.__webglTexture);
                setTextureParameters(_gl.TEXTURE_2D, attachment);
                setupFrameBufferTexture(renderTargetProperties.__webglFramebuffer, renderTarget, attachment, _gl.COLOR_ATTACHMENT0 + i, _gl.TEXTURE_2D, 0);
                if (textureNeedsGenerateMipmaps(attachment)) generateMipmap(_gl.TEXTURE_2D);
            }
            state.unbindTexture();
        } else {
            let glTextureType = _gl.TEXTURE_2D;
            if (renderTarget.isWebGL3DRenderTarget || renderTarget.isWebGLArrayRenderTarget) glTextureType = renderTarget.isWebGL3DRenderTarget ? _gl.TEXTURE_3D : _gl.TEXTURE_2D_ARRAY;
            state.bindTexture(glTextureType, textureProperties.__webglTexture);
            setTextureParameters(glTextureType, texture);
            if (texture.mipmaps && texture.mipmaps.length > 0) for(let level = 0; level < texture.mipmaps.length; level++)setupFrameBufferTexture(renderTargetProperties.__webglFramebuffer[level], renderTarget, texture, _gl.COLOR_ATTACHMENT0, glTextureType, level);
            else setupFrameBufferTexture(renderTargetProperties.__webglFramebuffer, renderTarget, texture, _gl.COLOR_ATTACHMENT0, glTextureType, 0);
            if (textureNeedsGenerateMipmaps(texture)) generateMipmap(glTextureType);
            state.unbindTexture();
        }
        // Setup depth and stencil buffers
        if (renderTarget.depthBuffer) setupDepthRenderbuffer(renderTarget);
    }
    function updateRenderTargetMipmap(renderTarget) {
        const textures = renderTarget.textures;
        for(let i = 0, il = textures.length; i < il; i++){
            const texture = textures[i];
            if (textureNeedsGenerateMipmaps(texture)) {
                const targetType = getTargetType(renderTarget);
                const webglTexture = properties.get(texture).__webglTexture;
                state.bindTexture(targetType, webglTexture);
                generateMipmap(targetType);
                state.unbindTexture();
            }
        }
    }
    const invalidationArrayRead = [];
    const invalidationArrayDraw = [];
    function updateMultisampleRenderTarget(renderTarget) {
        if (renderTarget.samples > 0) {
            if (useMultisampledRTT(renderTarget) === false) {
                const textures = renderTarget.textures;
                const width = renderTarget.width;
                const height = renderTarget.height;
                let mask = _gl.COLOR_BUFFER_BIT;
                const depthStyle = renderTarget.stencilBuffer ? _gl.DEPTH_STENCIL_ATTACHMENT : _gl.DEPTH_ATTACHMENT;
                const renderTargetProperties = properties.get(renderTarget);
                const isMultipleRenderTargets = textures.length > 1;
                // If MRT we need to remove FBO attachments
                if (isMultipleRenderTargets) for(let i = 0; i < textures.length; i++){
                    state.bindFramebuffer(_gl.FRAMEBUFFER, renderTargetProperties.__webglMultisampledFramebuffer);
                    _gl.framebufferRenderbuffer(_gl.FRAMEBUFFER, _gl.COLOR_ATTACHMENT0 + i, _gl.RENDERBUFFER, null);
                    state.bindFramebuffer(_gl.FRAMEBUFFER, renderTargetProperties.__webglFramebuffer);
                    _gl.framebufferTexture2D(_gl.DRAW_FRAMEBUFFER, _gl.COLOR_ATTACHMENT0 + i, _gl.TEXTURE_2D, null, 0);
                }
                state.bindFramebuffer(_gl.READ_FRAMEBUFFER, renderTargetProperties.__webglMultisampledFramebuffer);
                state.bindFramebuffer(_gl.DRAW_FRAMEBUFFER, renderTargetProperties.__webglFramebuffer);
                for(let i = 0; i < textures.length; i++){
                    if (renderTarget.resolveDepthBuffer) {
                        if (renderTarget.depthBuffer) mask |= _gl.DEPTH_BUFFER_BIT;
                        // resolving stencil is slow with a D3D backend. disable it for all transmission render targets (see #27799)
                        if (renderTarget.stencilBuffer && renderTarget.resolveStencilBuffer) mask |= _gl.STENCIL_BUFFER_BIT;
                    }
                    if (isMultipleRenderTargets) {
                        _gl.framebufferRenderbuffer(_gl.READ_FRAMEBUFFER, _gl.COLOR_ATTACHMENT0, _gl.RENDERBUFFER, renderTargetProperties.__webglColorRenderbuffer[i]);
                        const webglTexture = properties.get(textures[i]).__webglTexture;
                        _gl.framebufferTexture2D(_gl.DRAW_FRAMEBUFFER, _gl.COLOR_ATTACHMENT0, _gl.TEXTURE_2D, webglTexture, 0);
                    }
                    _gl.blitFramebuffer(0, 0, width, height, 0, 0, width, height, mask, _gl.NEAREST);
                    if (supportsInvalidateFramebuffer === true) {
                        invalidationArrayRead.length = 0;
                        invalidationArrayDraw.length = 0;
                        invalidationArrayRead.push(_gl.COLOR_ATTACHMENT0 + i);
                        if (renderTarget.depthBuffer && renderTarget.resolveDepthBuffer === false) {
                            invalidationArrayRead.push(depthStyle);
                            invalidationArrayDraw.push(depthStyle);
                            _gl.invalidateFramebuffer(_gl.DRAW_FRAMEBUFFER, invalidationArrayDraw);
                        }
                        _gl.invalidateFramebuffer(_gl.READ_FRAMEBUFFER, invalidationArrayRead);
                    }
                }
                state.bindFramebuffer(_gl.READ_FRAMEBUFFER, null);
                state.bindFramebuffer(_gl.DRAW_FRAMEBUFFER, null);
                // If MRT since pre-blit we removed the FBO we need to reconstruct the attachments
                if (isMultipleRenderTargets) for(let i = 0; i < textures.length; i++){
                    state.bindFramebuffer(_gl.FRAMEBUFFER, renderTargetProperties.__webglMultisampledFramebuffer);
                    _gl.framebufferRenderbuffer(_gl.FRAMEBUFFER, _gl.COLOR_ATTACHMENT0 + i, _gl.RENDERBUFFER, renderTargetProperties.__webglColorRenderbuffer[i]);
                    const webglTexture = properties.get(textures[i]).__webglTexture;
                    state.bindFramebuffer(_gl.FRAMEBUFFER, renderTargetProperties.__webglFramebuffer);
                    _gl.framebufferTexture2D(_gl.DRAW_FRAMEBUFFER, _gl.COLOR_ATTACHMENT0 + i, _gl.TEXTURE_2D, webglTexture, 0);
                }
                state.bindFramebuffer(_gl.DRAW_FRAMEBUFFER, renderTargetProperties.__webglMultisampledFramebuffer);
            } else if (renderTarget.depthBuffer && renderTarget.resolveDepthBuffer === false && supportsInvalidateFramebuffer) {
                const depthStyle = renderTarget.stencilBuffer ? _gl.DEPTH_STENCIL_ATTACHMENT : _gl.DEPTH_ATTACHMENT;
                _gl.invalidateFramebuffer(_gl.DRAW_FRAMEBUFFER, [
                    depthStyle
                ]);
            }
        }
    }
    function getRenderTargetSamples(renderTarget) {
        return Math.min(capabilities.maxSamples, renderTarget.samples);
    }
    function useMultisampledRTT(renderTarget) {
        const renderTargetProperties = properties.get(renderTarget);
        return renderTarget.samples > 0 && extensions.has('WEBGL_multisampled_render_to_texture') === true && renderTargetProperties.__useRenderToTexture !== false;
    }
    function updateVideoTexture(texture) {
        const frame = info.render.frame;
        // Check the last frame we updated the VideoTexture
        if (_videoTextures.get(texture) !== frame) {
            _videoTextures.set(texture, frame);
            texture.update();
        }
    }
    function verifyColorSpace(texture, image) {
        const colorSpace = texture.colorSpace;
        const format = texture.format;
        const type = texture.type;
        if (texture.isCompressedTexture === true || texture.isVideoTexture === true) return image;
        if (colorSpace !== (0, $dyjou.LinearSRGBColorSpace) && colorSpace !== (0, $dyjou.NoColorSpace)) {
            // sRGB
            if ((0, $dyjou.ColorManagement).getTransfer(colorSpace) === (0, $dyjou.SRGBTransfer)) // in WebGL 2 uncompressed textures can only be sRGB encoded if they have the RGBA8 format
            {
                if (format !== (0, $dyjou.RGBAFormat) || type !== (0, $dyjou.UnsignedByteType)) console.warn('THREE.WebGLTextures: sRGB encoded textures have to use RGBAFormat and UnsignedByteType.');
            } else console.error('THREE.WebGLTextures: Unsupported texture color space:', colorSpace);
        }
        return image;
    }
    function getDimensions(image) {
        if (typeof HTMLImageElement !== 'undefined' && image instanceof HTMLImageElement) {
            // if intrinsic data are not available, fallback to width/height
            _imageDimensions.width = image.naturalWidth || image.width;
            _imageDimensions.height = image.naturalHeight || image.height;
        } else if (typeof VideoFrame !== 'undefined' && image instanceof VideoFrame) {
            _imageDimensions.width = image.displayWidth;
            _imageDimensions.height = image.displayHeight;
        } else {
            _imageDimensions.width = image.width;
            _imageDimensions.height = image.height;
        }
        return _imageDimensions;
    }
    //
    this.allocateTextureUnit = allocateTextureUnit;
    this.resetTextureUnits = resetTextureUnits;
    this.setTexture2D = setTexture2D;
    this.setTexture2DArray = setTexture2DArray;
    this.setTexture3D = setTexture3D;
    this.setTextureCube = setTextureCube;
    this.rebindTextures = rebindTextures;
    this.setupRenderTarget = setupRenderTarget;
    this.updateRenderTargetMipmap = updateRenderTargetMipmap;
    this.updateMultisampleRenderTarget = updateMultisampleRenderTarget;
    this.setupDepthRenderbuffer = setupDepthRenderbuffer;
    this.setupFrameBufferTexture = setupFrameBufferTexture;
    this.useMultisampledRTT = useMultisampledRTT;
}
function $d5b33d7c30034067$export$ddaebcad857649a8(gl, extensions) {
    function convert(p, colorSpace = (0, $dyjou.NoColorSpace)) {
        let extension;
        const transfer = (0, $dyjou.ColorManagement).getTransfer(colorSpace);
        if (p === (0, $dyjou.UnsignedByteType)) return gl.UNSIGNED_BYTE;
        if (p === (0, $dyjou.UnsignedShort4444Type)) return gl.UNSIGNED_SHORT_4_4_4_4;
        if (p === (0, $dyjou.UnsignedShort5551Type)) return gl.UNSIGNED_SHORT_5_5_5_1;
        if (p === (0, $dyjou.UnsignedInt5999Type)) return gl.UNSIGNED_INT_5_9_9_9_REV;
        if (p === (0, $dyjou.ByteType)) return gl.BYTE;
        if (p === (0, $dyjou.ShortType)) return gl.SHORT;
        if (p === (0, $dyjou.UnsignedShortType)) return gl.UNSIGNED_SHORT;
        if (p === (0, $dyjou.IntType)) return gl.INT;
        if (p === (0, $dyjou.UnsignedIntType)) return gl.UNSIGNED_INT;
        if (p === (0, $dyjou.FloatType)) return gl.FLOAT;
        if (p === (0, $dyjou.HalfFloatType)) return gl.HALF_FLOAT;
        if (p === (0, $dyjou.AlphaFormat)) return gl.ALPHA;
        if (p === (0, $dyjou.RGBFormat)) return gl.RGB;
        if (p === (0, $dyjou.RGBAFormat)) return gl.RGBA;
        if (p === (0, $dyjou.LuminanceFormat)) return gl.LUMINANCE;
        if (p === (0, $dyjou.LuminanceAlphaFormat)) return gl.LUMINANCE_ALPHA;
        if (p === (0, $dyjou.DepthFormat)) return gl.DEPTH_COMPONENT;
        if (p === (0, $dyjou.DepthStencilFormat)) return gl.DEPTH_STENCIL;
        // WebGL2 formats.
        if (p === (0, $dyjou.RedFormat)) return gl.RED;
        if (p === (0, $dyjou.RedIntegerFormat)) return gl.RED_INTEGER;
        if (p === (0, $dyjou.RGFormat)) return gl.RG;
        if (p === (0, $dyjou.RGIntegerFormat)) return gl.RG_INTEGER;
        if (p === (0, $dyjou.RGBAIntegerFormat)) return gl.RGBA_INTEGER;
        // S3TC
        if (p === (0, $dyjou.RGB_S3TC_DXT1_Format) || p === (0, $dyjou.RGBA_S3TC_DXT1_Format) || p === (0, $dyjou.RGBA_S3TC_DXT3_Format) || p === (0, $dyjou.RGBA_S3TC_DXT5_Format)) {
            if (transfer === (0, $dyjou.SRGBTransfer)) {
                extension = extensions.get('WEBGL_compressed_texture_s3tc_srgb');
                if (extension !== null) {
                    if (p === (0, $dyjou.RGB_S3TC_DXT1_Format)) return extension.COMPRESSED_SRGB_S3TC_DXT1_EXT;
                    if (p === (0, $dyjou.RGBA_S3TC_DXT1_Format)) return extension.COMPRESSED_SRGB_ALPHA_S3TC_DXT1_EXT;
                    if (p === (0, $dyjou.RGBA_S3TC_DXT3_Format)) return extension.COMPRESSED_SRGB_ALPHA_S3TC_DXT3_EXT;
                    if (p === (0, $dyjou.RGBA_S3TC_DXT5_Format)) return extension.COMPRESSED_SRGB_ALPHA_S3TC_DXT5_EXT;
                } else return null;
            } else {
                extension = extensions.get('WEBGL_compressed_texture_s3tc');
                if (extension !== null) {
                    if (p === (0, $dyjou.RGB_S3TC_DXT1_Format)) return extension.COMPRESSED_RGB_S3TC_DXT1_EXT;
                    if (p === (0, $dyjou.RGBA_S3TC_DXT1_Format)) return extension.COMPRESSED_RGBA_S3TC_DXT1_EXT;
                    if (p === (0, $dyjou.RGBA_S3TC_DXT3_Format)) return extension.COMPRESSED_RGBA_S3TC_DXT3_EXT;
                    if (p === (0, $dyjou.RGBA_S3TC_DXT5_Format)) return extension.COMPRESSED_RGBA_S3TC_DXT5_EXT;
                } else return null;
            }
        }
        // PVRTC
        if (p === (0, $dyjou.RGB_PVRTC_4BPPV1_Format) || p === (0, $dyjou.RGB_PVRTC_2BPPV1_Format) || p === (0, $dyjou.RGBA_PVRTC_4BPPV1_Format) || p === (0, $dyjou.RGBA_PVRTC_2BPPV1_Format)) {
            extension = extensions.get('WEBGL_compressed_texture_pvrtc');
            if (extension !== null) {
                if (p === (0, $dyjou.RGB_PVRTC_4BPPV1_Format)) return extension.COMPRESSED_RGB_PVRTC_4BPPV1_IMG;
                if (p === (0, $dyjou.RGB_PVRTC_2BPPV1_Format)) return extension.COMPRESSED_RGB_PVRTC_2BPPV1_IMG;
                if (p === (0, $dyjou.RGBA_PVRTC_4BPPV1_Format)) return extension.COMPRESSED_RGBA_PVRTC_4BPPV1_IMG;
                if (p === (0, $dyjou.RGBA_PVRTC_2BPPV1_Format)) return extension.COMPRESSED_RGBA_PVRTC_2BPPV1_IMG;
            } else return null;
        }
        // ETC
        if (p === (0, $dyjou.RGB_ETC1_Format) || p === (0, $dyjou.RGB_ETC2_Format) || p === (0, $dyjou.RGBA_ETC2_EAC_Format)) {
            extension = extensions.get('WEBGL_compressed_texture_etc');
            if (extension !== null) {
                if (p === (0, $dyjou.RGB_ETC1_Format) || p === (0, $dyjou.RGB_ETC2_Format)) return transfer === (0, $dyjou.SRGBTransfer) ? extension.COMPRESSED_SRGB8_ETC2 : extension.COMPRESSED_RGB8_ETC2;
                if (p === (0, $dyjou.RGBA_ETC2_EAC_Format)) return transfer === (0, $dyjou.SRGBTransfer) ? extension.COMPRESSED_SRGB8_ALPHA8_ETC2_EAC : extension.COMPRESSED_RGBA8_ETC2_EAC;
            } else return null;
        }
        // ASTC
        if (p === (0, $dyjou.RGBA_ASTC_4x4_Format) || p === (0, $dyjou.RGBA_ASTC_5x4_Format) || p === (0, $dyjou.RGBA_ASTC_5x5_Format) || p === (0, $dyjou.RGBA_ASTC_6x5_Format) || p === (0, $dyjou.RGBA_ASTC_6x6_Format) || p === (0, $dyjou.RGBA_ASTC_8x5_Format) || p === (0, $dyjou.RGBA_ASTC_8x6_Format) || p === (0, $dyjou.RGBA_ASTC_8x8_Format) || p === (0, $dyjou.RGBA_ASTC_10x5_Format) || p === (0, $dyjou.RGBA_ASTC_10x6_Format) || p === (0, $dyjou.RGBA_ASTC_10x8_Format) || p === (0, $dyjou.RGBA_ASTC_10x10_Format) || p === (0, $dyjou.RGBA_ASTC_12x10_Format) || p === (0, $dyjou.RGBA_ASTC_12x12_Format)) {
            extension = extensions.get('WEBGL_compressed_texture_astc');
            if (extension !== null) {
                if (p === (0, $dyjou.RGBA_ASTC_4x4_Format)) return transfer === (0, $dyjou.SRGBTransfer) ? extension.COMPRESSED_SRGB8_ALPHA8_ASTC_4x4_KHR : extension.COMPRESSED_RGBA_ASTC_4x4_KHR;
                if (p === (0, $dyjou.RGBA_ASTC_5x4_Format)) return transfer === (0, $dyjou.SRGBTransfer) ? extension.COMPRESSED_SRGB8_ALPHA8_ASTC_5x4_KHR : extension.COMPRESSED_RGBA_ASTC_5x4_KHR;
                if (p === (0, $dyjou.RGBA_ASTC_5x5_Format)) return transfer === (0, $dyjou.SRGBTransfer) ? extension.COMPRESSED_SRGB8_ALPHA8_ASTC_5x5_KHR : extension.COMPRESSED_RGBA_ASTC_5x5_KHR;
                if (p === (0, $dyjou.RGBA_ASTC_6x5_Format)) return transfer === (0, $dyjou.SRGBTransfer) ? extension.COMPRESSED_SRGB8_ALPHA8_ASTC_6x5_KHR : extension.COMPRESSED_RGBA_ASTC_6x5_KHR;
                if (p === (0, $dyjou.RGBA_ASTC_6x6_Format)) return transfer === (0, $dyjou.SRGBTransfer) ? extension.COMPRESSED_SRGB8_ALPHA8_ASTC_6x6_KHR : extension.COMPRESSED_RGBA_ASTC_6x6_KHR;
                if (p === (0, $dyjou.RGBA_ASTC_8x5_Format)) return transfer === (0, $dyjou.SRGBTransfer) ? extension.COMPRESSED_SRGB8_ALPHA8_ASTC_8x5_KHR : extension.COMPRESSED_RGBA_ASTC_8x5_KHR;
                if (p === (0, $dyjou.RGBA_ASTC_8x6_Format)) return transfer === (0, $dyjou.SRGBTransfer) ? extension.COMPRESSED_SRGB8_ALPHA8_ASTC_8x6_KHR : extension.COMPRESSED_RGBA_ASTC_8x6_KHR;
                if (p === (0, $dyjou.RGBA_ASTC_8x8_Format)) return transfer === (0, $dyjou.SRGBTransfer) ? extension.COMPRESSED_SRGB8_ALPHA8_ASTC_8x8_KHR : extension.COMPRESSED_RGBA_ASTC_8x8_KHR;
                if (p === (0, $dyjou.RGBA_ASTC_10x5_Format)) return transfer === (0, $dyjou.SRGBTransfer) ? extension.COMPRESSED_SRGB8_ALPHA8_ASTC_10x5_KHR : extension.COMPRESSED_RGBA_ASTC_10x5_KHR;
                if (p === (0, $dyjou.RGBA_ASTC_10x6_Format)) return transfer === (0, $dyjou.SRGBTransfer) ? extension.COMPRESSED_SRGB8_ALPHA8_ASTC_10x6_KHR : extension.COMPRESSED_RGBA_ASTC_10x6_KHR;
                if (p === (0, $dyjou.RGBA_ASTC_10x8_Format)) return transfer === (0, $dyjou.SRGBTransfer) ? extension.COMPRESSED_SRGB8_ALPHA8_ASTC_10x8_KHR : extension.COMPRESSED_RGBA_ASTC_10x8_KHR;
                if (p === (0, $dyjou.RGBA_ASTC_10x10_Format)) return transfer === (0, $dyjou.SRGBTransfer) ? extension.COMPRESSED_SRGB8_ALPHA8_ASTC_10x10_KHR : extension.COMPRESSED_RGBA_ASTC_10x10_KHR;
                if (p === (0, $dyjou.RGBA_ASTC_12x10_Format)) return transfer === (0, $dyjou.SRGBTransfer) ? extension.COMPRESSED_SRGB8_ALPHA8_ASTC_12x10_KHR : extension.COMPRESSED_RGBA_ASTC_12x10_KHR;
                if (p === (0, $dyjou.RGBA_ASTC_12x12_Format)) return transfer === (0, $dyjou.SRGBTransfer) ? extension.COMPRESSED_SRGB8_ALPHA8_ASTC_12x12_KHR : extension.COMPRESSED_RGBA_ASTC_12x12_KHR;
            } else return null;
        }
        // BPTC
        if (p === (0, $dyjou.RGBA_BPTC_Format) || p === (0, $dyjou.RGB_BPTC_SIGNED_Format) || p === (0, $dyjou.RGB_BPTC_UNSIGNED_Format)) {
            extension = extensions.get('EXT_texture_compression_bptc');
            if (extension !== null) {
                if (p === (0, $dyjou.RGBA_BPTC_Format)) return transfer === (0, $dyjou.SRGBTransfer) ? extension.COMPRESSED_SRGB_ALPHA_BPTC_UNORM_EXT : extension.COMPRESSED_RGBA_BPTC_UNORM_EXT;
                if (p === (0, $dyjou.RGB_BPTC_SIGNED_Format)) return extension.COMPRESSED_RGB_BPTC_SIGNED_FLOAT_EXT;
                if (p === (0, $dyjou.RGB_BPTC_UNSIGNED_Format)) return extension.COMPRESSED_RGB_BPTC_UNSIGNED_FLOAT_EXT;
            } else return null;
        }
        // RGTC
        if (p === (0, $dyjou.RED_RGTC1_Format) || p === (0, $dyjou.SIGNED_RED_RGTC1_Format) || p === (0, $dyjou.RED_GREEN_RGTC2_Format) || p === (0, $dyjou.SIGNED_RED_GREEN_RGTC2_Format)) {
            extension = extensions.get('EXT_texture_compression_rgtc');
            if (extension !== null) {
                if (p === (0, $dyjou.RGBA_BPTC_Format)) return extension.COMPRESSED_RED_RGTC1_EXT;
                if (p === (0, $dyjou.SIGNED_RED_RGTC1_Format)) return extension.COMPRESSED_SIGNED_RED_RGTC1_EXT;
                if (p === (0, $dyjou.RED_GREEN_RGTC2_Format)) return extension.COMPRESSED_RED_GREEN_RGTC2_EXT;
                if (p === (0, $dyjou.SIGNED_RED_GREEN_RGTC2_Format)) return extension.COMPRESSED_SIGNED_RED_GREEN_RGTC2_EXT;
            } else return null;
        }
        //
        if (p === (0, $dyjou.UnsignedInt248Type)) return gl.UNSIGNED_INT_24_8;
        // if "p" can't be resolved, assume the user defines a WebGL constant as a string (fallback/workaround for packed RGB formats)
        return gl[p] !== undefined ? gl[p] : null;
    }
    return {
        convert: convert
    };
}
const $d5b33d7c30034067$var$_occlusion_vertex = `
void main() {

	gl_Position = vec4( position, 1.0 );

}`;
const $d5b33d7c30034067$var$_occlusion_fragment = `
uniform sampler2DArray depthColor;
uniform float depthWidth;
uniform float depthHeight;

void main() {

	vec2 coord = vec2( gl_FragCoord.x / depthWidth, gl_FragCoord.y / depthHeight );

	if ( coord.x >= 1.0 ) {

		gl_FragDepth = texture( depthColor, vec3( coord.x - 1.0, coord.y, 1 ) ).r;

	} else {

		gl_FragDepth = texture( depthColor, vec3( coord.x, coord.y, 0 ) ).r;

	}

}`;
/**
 * A XR module that manages the access to the Depth Sensing API.
 */ class $d5b33d7c30034067$var$WebXRDepthSensing {
    /**
	 * Constructs a new depth sensing module.
	 */ constructor(){
        /**
		 * A texture representing the depth of the user's environment.
		 *
		 * @type {?Texture}
		 */ this.texture = null;
        /**
		 * A plane mesh for visualizing the depth texture.
		 *
		 * @type {?Mesh}
		 */ this.mesh = null;
        /**
		 * The depth near value.
		 *
		 * @type {number}
		 */ this.depthNear = 0;
        /**
		 * The depth near far.
		 *
		 * @type {number}
		 */ this.depthFar = 0;
    }
    /**
	 * Inits the depth sensing module
	 *
	 * @param {WebGLRenderer} renderer - The renderer.
	 * @param {XRWebGLDepthInformation} depthData - The XR depth data.
	 * @param {XRRenderState} renderState - The XR render state.
	 */ init(renderer, depthData, renderState) {
        if (this.texture === null) {
            const texture = new (0, $dyjou.Texture)();
            const texProps = renderer.properties.get(texture);
            texProps.__webglTexture = depthData.texture;
            if (depthData.depthNear !== renderState.depthNear || depthData.depthFar !== renderState.depthFar) {
                this.depthNear = depthData.depthNear;
                this.depthFar = depthData.depthFar;
            }
            this.texture = texture;
        }
    }
    /**
	 * Returns a plane mesh that visualizes the depth texture.
	 *
	 * @param {ArrayCamera} cameraXR - The XR camera.
	 * @return {?Mesh} The plane mesh.
	 */ getMesh(cameraXR) {
        if (this.texture !== null) {
            if (this.mesh === null) {
                const viewport = cameraXR.cameras[0].viewport;
                const material = new (0, $dyjou.ShaderMaterial)({
                    vertexShader: $d5b33d7c30034067$var$_occlusion_vertex,
                    fragmentShader: $d5b33d7c30034067$var$_occlusion_fragment,
                    uniforms: {
                        depthColor: {
                            value: this.texture
                        },
                        depthWidth: {
                            value: viewport.z
                        },
                        depthHeight: {
                            value: viewport.w
                        }
                    }
                });
                this.mesh = new (0, $dyjou.Mesh)(new (0, $dyjou.PlaneGeometry)(20, 20), material);
            }
        }
        return this.mesh;
    }
    /**
	 * Resets the module
	 */ reset() {
        this.texture = null;
        this.mesh = null;
    }
    /**
	 * Returns a texture representing the depth of the user's environment.
	 *
	 * @return {?Texture} The depth texture.
	 */ getDepthTexture() {
        return this.texture;
    }
}
/**
 * This class represents an abstraction of the WebXR Device API and is
 * internally used by {@link WebGLRenderer}. `WebXRManager` also provides a public
 * interface that allows users to enable/disable XR and perform XR related
 * tasks like for instance retrieving controllers.
 *
 * @augments EventDispatcher
 * @hideconstructor
 */ class $d5b33d7c30034067$var$WebXRManager extends (0, $dyjou.EventDispatcher) {
    /**
	 * Constructs a new WebGL renderer.
	 *
	 * @param {WebGLRenderer} renderer - The renderer.
	 * @param {WebGL2RenderingContext} gl - The rendering context.
	 */ constructor(renderer, gl){
        super();
        const scope = this;
        let session = null;
        let framebufferScaleFactor = 1.0;
        let referenceSpace = null;
        let referenceSpaceType = 'local-floor';
        // Set default foveation to maximum.
        let foveation = 1.0;
        let customReferenceSpace = null;
        let pose = null;
        let glBinding = null;
        let glProjLayer = null;
        let glBaseLayer = null;
        let xrFrame = null;
        const depthSensing = new $d5b33d7c30034067$var$WebXRDepthSensing();
        const attributes = gl.getContextAttributes();
        let initialRenderTarget = null;
        let newRenderTarget = null;
        const controllers = [];
        const controllerInputSources = [];
        const currentSize = new (0, $dyjou.Vector2)();
        let currentPixelRatio = null;
        //
        const cameraL = new (0, $dyjou.PerspectiveCamera)();
        cameraL.viewport = new (0, $dyjou.Vector4)();
        const cameraR = new (0, $dyjou.PerspectiveCamera)();
        cameraR.viewport = new (0, $dyjou.Vector4)();
        const cameras = [
            cameraL,
            cameraR
        ];
        const cameraXR = new (0, $dyjou.ArrayCamera)();
        let _currentDepthNear = null;
        let _currentDepthFar = null;
        //
        /**
		 * Whether the manager's XR camera should be automatically updated or not.
		 *
		 * @type {boolean}
		 * @default true
		 */ this.cameraAutoUpdate = true;
        /**
		 * This flag notifies the renderer to be ready for XR rendering. Set it to `true`
		 * if you are going to use XR in your app.
		 *
		 * @type {boolean}
		 * @default false
		 */ this.enabled = false;
        /**
		 * Whether XR presentation is active or not.
		 *
		 * @type {boolean}
		 * @readonly
		 * @default false
		 */ this.isPresenting = false;
        /**
		 * Returns a group representing the `target ray` space of the XR controller.
		 * Use this space for visualizing 3D objects that support the user in pointing
		 * tasks like UI interaction.
		 *
		 * @param {number} index - The index of the controller.
		 * @return {Group} A group representing the `target ray` space.
		 */ this.getController = function(index) {
            let controller = controllers[index];
            if (controller === undefined) {
                controller = new (0, $dyjou.WebXRController)();
                controllers[index] = controller;
            }
            return controller.getTargetRaySpace();
        };
        /**
		 * Returns a group representing the `grip` space of the XR controller.
		 * Use this space for visualizing 3D objects that support the user in pointing
		 * tasks like UI interaction.
		 *
		 * Note: If you want to show something in the user's hand AND offer a
		 * pointing ray at the same time, you'll want to attached the handheld object
		 * to the group returned by `getControllerGrip()` and the ray to the
		 * group returned by `getController()`. The idea is to have two
		 * different groups in two different coordinate spaces for the same WebXR
		 * controller.
		 *
		 * @param {number} index - The index of the controller.
		 * @return {Group} A group representing the `grip` space.
		 */ this.getControllerGrip = function(index) {
            let controller = controllers[index];
            if (controller === undefined) {
                controller = new (0, $dyjou.WebXRController)();
                controllers[index] = controller;
            }
            return controller.getGripSpace();
        };
        /**
		 * Returns a group representing the `hand` space of the XR controller.
		 * Use this space for visualizing 3D objects that support the user in pointing
		 * tasks like UI interaction.
		 *
		 * @param {number} index - The index of the controller.
		 * @return {Group} A group representing the `hand` space.
		 */ this.getHand = function(index) {
            let controller = controllers[index];
            if (controller === undefined) {
                controller = new (0, $dyjou.WebXRController)();
                controllers[index] = controller;
            }
            return controller.getHandSpace();
        };
        //
        function onSessionEvent(event) {
            const controllerIndex = controllerInputSources.indexOf(event.inputSource);
            if (controllerIndex === -1) return;
            const controller = controllers[controllerIndex];
            if (controller !== undefined) {
                controller.update(event.inputSource, event.frame, customReferenceSpace || referenceSpace);
                controller.dispatchEvent({
                    type: event.type,
                    data: event.inputSource
                });
            }
        }
        function onSessionEnd() {
            session.removeEventListener('select', onSessionEvent);
            session.removeEventListener('selectstart', onSessionEvent);
            session.removeEventListener('selectend', onSessionEvent);
            session.removeEventListener('squeeze', onSessionEvent);
            session.removeEventListener('squeezestart', onSessionEvent);
            session.removeEventListener('squeezeend', onSessionEvent);
            session.removeEventListener('end', onSessionEnd);
            session.removeEventListener('inputsourceschange', onInputSourcesChange);
            for(let i = 0; i < controllers.length; i++){
                const inputSource = controllerInputSources[i];
                if (inputSource === null) continue;
                controllerInputSources[i] = null;
                controllers[i].disconnect(inputSource);
            }
            _currentDepthNear = null;
            _currentDepthFar = null;
            depthSensing.reset();
            // restore framebuffer/rendering state
            renderer.setRenderTarget(initialRenderTarget);
            glBaseLayer = null;
            glProjLayer = null;
            glBinding = null;
            session = null;
            newRenderTarget = null;
            //
            animation.stop();
            scope.isPresenting = false;
            renderer.setPixelRatio(currentPixelRatio);
            renderer.setSize(currentSize.width, currentSize.height, false);
            scope.dispatchEvent({
                type: 'sessionend'
            });
        }
        /**
		 * Sets the framebuffer scale factor.
		 *
		 * This method can not be used during a XR session.
		 *
		 * @param {number} value - The framebuffer scale factor.
		 */ this.setFramebufferScaleFactor = function(value) {
            framebufferScaleFactor = value;
            if (scope.isPresenting === true) console.warn('THREE.WebXRManager: Cannot change framebuffer scale while presenting.');
        };
        /**
		 * Sets the reference space type. Can be used to configure a spatial relationship with the user's physical
		 * environment. Depending on how the user moves in 3D space, setting an appropriate reference space can
		 * improve tracking. Default is `local-floor`.
		 *
		 * This method can not be used during a XR session.
		 *
		 * @param {string} value - The reference space type.
		 */ this.setReferenceSpaceType = function(value) {
            referenceSpaceType = value;
            if (scope.isPresenting === true) console.warn('THREE.WebXRManager: Cannot change reference space type while presenting.');
        };
        /**
		 * Returns the XR reference space.
		 *
		 * @return {XRReferenceSpace} The XR reference space.
		 */ this.getReferenceSpace = function() {
            return customReferenceSpace || referenceSpace;
        };
        /**
		 * Sets a custom XR reference space.
		 *
		 * @param {XRReferenceSpace} space - The XR reference space.
		 */ this.setReferenceSpace = function(space) {
            customReferenceSpace = space;
        };
        /**
		 * Returns the current base layer.
		 *
		 * @return {?(XRWebGLLayer|XRProjectionLayer)} The XR base layer.
		 */ this.getBaseLayer = function() {
            return glProjLayer !== null ? glProjLayer : glBaseLayer;
        };
        /**
		 * Returns the current XR binding.
		 *
		 * @return {?XRWebGLBinding} The XR binding.
		 */ this.getBinding = function() {
            return glBinding;
        };
        /**
		 * Returns the current XR frame.
		 *
		 * @return {?XRFrame} The XR frame. Returns `null` when used outside a XR session.
		 */ this.getFrame = function() {
            return xrFrame;
        };
        /**
		 * Returns the current XR session.
		 *
		 * @return {?XRSession} The XR session. Returns `null` when used outside a XR session.
		 */ this.getSession = function() {
            return session;
        };
        /**
		 * After a XR session has been requested usually with one of the `*Button` modules, it
		 * is injected into the renderer with this method. This method triggers the start of
		 * the actual XR rendering.
		 *
		 * @async
		 * @param {XRSession} value - The XR session to set.
		 * @return {Promise} A Promise that resolves when the session has been set.
		 */ this.setSession = async function(value) {
            session = value;
            if (session !== null) {
                initialRenderTarget = renderer.getRenderTarget();
                session.addEventListener('select', onSessionEvent);
                session.addEventListener('selectstart', onSessionEvent);
                session.addEventListener('selectend', onSessionEvent);
                session.addEventListener('squeeze', onSessionEvent);
                session.addEventListener('squeezestart', onSessionEvent);
                session.addEventListener('squeezeend', onSessionEvent);
                session.addEventListener('end', onSessionEnd);
                session.addEventListener('inputsourceschange', onInputSourcesChange);
                if (attributes.xrCompatible !== true) await gl.makeXRCompatible();
                currentPixelRatio = renderer.getPixelRatio();
                renderer.getSize(currentSize);
                // Check that the browser implements the necessary APIs to use an
                // XRProjectionLayer rather than an XRWebGLLayer
                const useLayers = typeof XRWebGLBinding !== 'undefined' && 'createProjectionLayer' in XRWebGLBinding.prototype;
                if (!useLayers) {
                    const layerInit = {
                        antialias: attributes.antialias,
                        alpha: true,
                        depth: attributes.depth,
                        stencil: attributes.stencil,
                        framebufferScaleFactor: framebufferScaleFactor
                    };
                    glBaseLayer = new XRWebGLLayer(session, gl, layerInit);
                    session.updateRenderState({
                        baseLayer: glBaseLayer
                    });
                    renderer.setPixelRatio(1);
                    renderer.setSize(glBaseLayer.framebufferWidth, glBaseLayer.framebufferHeight, false);
                    newRenderTarget = new (0, $dyjou.WebGLRenderTarget)(glBaseLayer.framebufferWidth, glBaseLayer.framebufferHeight, {
                        format: (0, $dyjou.RGBAFormat),
                        type: (0, $dyjou.UnsignedByteType),
                        colorSpace: renderer.outputColorSpace,
                        stencilBuffer: attributes.stencil,
                        resolveDepthBuffer: glBaseLayer.ignoreDepthValues === false,
                        resolveStencilBuffer: glBaseLayer.ignoreDepthValues === false
                    });
                } else {
                    let depthFormat = null;
                    let depthType = null;
                    let glDepthFormat = null;
                    if (attributes.depth) {
                        glDepthFormat = attributes.stencil ? gl.DEPTH24_STENCIL8 : gl.DEPTH_COMPONENT24;
                        depthFormat = attributes.stencil ? (0, $dyjou.DepthStencilFormat) : (0, $dyjou.DepthFormat);
                        depthType = attributes.stencil ? (0, $dyjou.UnsignedInt248Type) : (0, $dyjou.UnsignedIntType);
                    }
                    const projectionlayerInit = {
                        colorFormat: gl.RGBA8,
                        depthFormat: glDepthFormat,
                        scaleFactor: framebufferScaleFactor
                    };
                    glBinding = new XRWebGLBinding(session, gl);
                    glProjLayer = glBinding.createProjectionLayer(projectionlayerInit);
                    session.updateRenderState({
                        layers: [
                            glProjLayer
                        ]
                    });
                    renderer.setPixelRatio(1);
                    renderer.setSize(glProjLayer.textureWidth, glProjLayer.textureHeight, false);
                    newRenderTarget = new (0, $dyjou.WebGLRenderTarget)(glProjLayer.textureWidth, glProjLayer.textureHeight, {
                        format: (0, $dyjou.RGBAFormat),
                        type: (0, $dyjou.UnsignedByteType),
                        depthTexture: new (0, $dyjou.DepthTexture)(glProjLayer.textureWidth, glProjLayer.textureHeight, depthType, undefined, undefined, undefined, undefined, undefined, undefined, depthFormat),
                        stencilBuffer: attributes.stencil,
                        colorSpace: renderer.outputColorSpace,
                        samples: attributes.antialias ? 4 : 0,
                        resolveDepthBuffer: glProjLayer.ignoreDepthValues === false,
                        resolveStencilBuffer: glProjLayer.ignoreDepthValues === false
                    });
                }
                newRenderTarget.isXRRenderTarget = true; // TODO Remove this when possible, see #23278
                this.setFoveation(foveation);
                customReferenceSpace = null;
                referenceSpace = await session.requestReferenceSpace(referenceSpaceType);
                animation.setContext(session);
                animation.start();
                scope.isPresenting = true;
                scope.dispatchEvent({
                    type: 'sessionstart'
                });
            }
        };
        /**
		 * Returns the environment blend mode from the current XR session.
		 *
		 * @return {'opaque'|'additive'|'alpha-blend'|undefined} The environment blend mode. Returns `undefined` when used outside of a XR session.
		 */ this.getEnvironmentBlendMode = function() {
            if (session !== null) return session.environmentBlendMode;
        };
        /**
		 * Returns the current depth texture computed via depth sensing.
		 *
		 * @return {?Texture} The depth texture.
		 */ this.getDepthTexture = function() {
            return depthSensing.getDepthTexture();
        };
        function onInputSourcesChange(event) {
            // Notify disconnected
            for(let i = 0; i < event.removed.length; i++){
                const inputSource = event.removed[i];
                const index = controllerInputSources.indexOf(inputSource);
                if (index >= 0) {
                    controllerInputSources[index] = null;
                    controllers[index].disconnect(inputSource);
                }
            }
            // Notify connected
            for(let i = 0; i < event.added.length; i++){
                const inputSource = event.added[i];
                let controllerIndex = controllerInputSources.indexOf(inputSource);
                if (controllerIndex === -1) {
                    // Assign input source a controller that currently has no input source
                    for(let i = 0; i < controllers.length; i++){
                        if (i >= controllerInputSources.length) {
                            controllerInputSources.push(inputSource);
                            controllerIndex = i;
                            break;
                        } else if (controllerInputSources[i] === null) {
                            controllerInputSources[i] = inputSource;
                            controllerIndex = i;
                            break;
                        }
                    }
                    // If all controllers do currently receive input we ignore new ones
                    if (controllerIndex === -1) break;
                }
                const controller = controllers[controllerIndex];
                if (controller) controller.connect(inputSource);
            }
        }
        //
        const cameraLPos = new (0, $dyjou.Vector3)();
        const cameraRPos = new (0, $dyjou.Vector3)();
        /**
		 * Assumes 2 cameras that are parallel and share an X-axis, and that
		 * the cameras' projection and world matrices have already been set.
		 * And that near and far planes are identical for both cameras.
		 * Visualization of this technique: https://computergraphics.stackexchange.com/a/4765
		 *
		 * @param {ArrayCamera} camera - The camera to update.
		 * @param {PerspectiveCamera} cameraL - The left camera.
		 * @param {PerspectiveCamera} cameraR - The right camera.
		 */ function setProjectionFromUnion(camera, cameraL, cameraR) {
            cameraLPos.setFromMatrixPosition(cameraL.matrixWorld);
            cameraRPos.setFromMatrixPosition(cameraR.matrixWorld);
            const ipd = cameraLPos.distanceTo(cameraRPos);
            const projL = cameraL.projectionMatrix.elements;
            const projR = cameraR.projectionMatrix.elements;
            // VR systems will have identical far and near planes, and
            // most likely identical top and bottom frustum extents.
            // Use the left camera for these values.
            const near = projL[14] / (projL[10] - 1);
            const far = projL[14] / (projL[10] + 1);
            const topFov = (projL[9] + 1) / projL[5];
            const bottomFov = (projL[9] - 1) / projL[5];
            const leftFov = (projL[8] - 1) / projL[0];
            const rightFov = (projR[8] + 1) / projR[0];
            const left = near * leftFov;
            const right = near * rightFov;
            // Calculate the new camera's position offset from the
            // left camera. xOffset should be roughly half `ipd`.
            const zOffset = ipd / (-leftFov + rightFov);
            const xOffset = zOffset * -leftFov;
            // TODO: Better way to apply this offset?
            cameraL.matrixWorld.decompose(camera.position, camera.quaternion, camera.scale);
            camera.translateX(xOffset);
            camera.translateZ(zOffset);
            camera.matrixWorld.compose(camera.position, camera.quaternion, camera.scale);
            camera.matrixWorldInverse.copy(camera.matrixWorld).invert();
            // Check if the projection uses an infinite far plane.
            if (projL[10] === -1) {
                // Use the projection matrix from the left eye.
                // The camera offset is sufficient to include the view volumes
                // of both eyes (assuming symmetric projections).
                camera.projectionMatrix.copy(cameraL.projectionMatrix);
                camera.projectionMatrixInverse.copy(cameraL.projectionMatrixInverse);
            } else {
                // Find the union of the frustum values of the cameras and scale
                // the values so that the near plane's position does not change in world space,
                // although must now be relative to the new union camera.
                const near2 = near + zOffset;
                const far2 = far + zOffset;
                const left2 = left - xOffset;
                const right2 = right + (ipd - xOffset);
                const top2 = topFov * far / far2 * near2;
                const bottom2 = bottomFov * far / far2 * near2;
                camera.projectionMatrix.makePerspective(left2, right2, top2, bottom2, near2, far2);
                camera.projectionMatrixInverse.copy(camera.projectionMatrix).invert();
            }
        }
        function updateCamera(camera, parent) {
            if (parent === null) camera.matrixWorld.copy(camera.matrix);
            else camera.matrixWorld.multiplyMatrices(parent.matrixWorld, camera.matrix);
            camera.matrixWorldInverse.copy(camera.matrixWorld).invert();
        }
        /**
		 * Updates the state of the XR camera. Use this method on app level if you
		 * set cameraAutoUpdate` to `false`. The method requires the non-XR
		 * camera of the scene as a parameter. The passed in camera's transformation
		 * is automatically adjusted to the position of the XR camera when calling
		 * this method.
		 *
		 * @param {Camera} camera - The camera.
		 */ this.updateCamera = function(camera) {
            if (session === null) return;
            let depthNear = camera.near;
            let depthFar = camera.far;
            if (depthSensing.texture !== null) {
                if (depthSensing.depthNear > 0) depthNear = depthSensing.depthNear;
                if (depthSensing.depthFar > 0) depthFar = depthSensing.depthFar;
            }
            cameraXR.near = cameraR.near = cameraL.near = depthNear;
            cameraXR.far = cameraR.far = cameraL.far = depthFar;
            if (_currentDepthNear !== cameraXR.near || _currentDepthFar !== cameraXR.far) {
                // Note that the new renderState won't apply until the next frame. See #18320
                session.updateRenderState({
                    depthNear: cameraXR.near,
                    depthFar: cameraXR.far
                });
                _currentDepthNear = cameraXR.near;
                _currentDepthFar = cameraXR.far;
            }
            cameraL.layers.mask = camera.layers.mask | 2;
            cameraR.layers.mask = camera.layers.mask | 4;
            cameraXR.layers.mask = cameraL.layers.mask | cameraR.layers.mask;
            const parent = camera.parent;
            const cameras = cameraXR.cameras;
            updateCamera(cameraXR, parent);
            for(let i = 0; i < cameras.length; i++)updateCamera(cameras[i], parent);
            // update projection matrix for proper view frustum culling
            if (cameras.length === 2) setProjectionFromUnion(cameraXR, cameraL, cameraR);
            else // assume single camera setup (AR)
            cameraXR.projectionMatrix.copy(cameraL.projectionMatrix);
            // update user camera and its children
            updateUserCamera(camera, cameraXR, parent);
        };
        function updateUserCamera(camera, cameraXR, parent) {
            if (parent === null) camera.matrix.copy(cameraXR.matrixWorld);
            else {
                camera.matrix.copy(parent.matrixWorld);
                camera.matrix.invert();
                camera.matrix.multiply(cameraXR.matrixWorld);
            }
            camera.matrix.decompose(camera.position, camera.quaternion, camera.scale);
            camera.updateMatrixWorld(true);
            camera.projectionMatrix.copy(cameraXR.projectionMatrix);
            camera.projectionMatrixInverse.copy(cameraXR.projectionMatrixInverse);
            if (camera.isPerspectiveCamera) {
                camera.fov = (0, $dyjou.RAD2DEG) * 2 * Math.atan(1 / camera.projectionMatrix.elements[5]);
                camera.zoom = 1;
            }
        }
        /**
		 * Returns an instance of {@link ArrayCamera} which represents the XR camera
		 * of the active XR session. For each view it holds a separate camera object.
		 *
		 * The camera's `fov` is currently not used and does not reflect the fov of
		 * the XR camera. If you need the fov on app level, you have to compute in
		 * manually from the XR camera's projection matrices.
		 *
		 * @return {ArrayCamera} The XR camera.
		 */ this.getCamera = function() {
            return cameraXR;
        };
        /**
		 * Returns the amount of foveation used by the XR compositor for the projection layer.
		 *
		 * @return {number} The amount of foveation.
		 */ this.getFoveation = function() {
            if (glProjLayer === null && glBaseLayer === null) return undefined;
            return foveation;
        };
        /**
		 * Sets the foveation value.
		 *
		 * @param {number} value - A number in the range `[0,1]` where `0` means no foveation (full resolution)
		 * and `1` means maximum foveation (the edges render at lower resolution).
		 */ this.setFoveation = function(value) {
            // 0 = no foveation = full resolution
            // 1 = maximum foveation = the edges render at lower resolution
            foveation = value;
            if (glProjLayer !== null) glProjLayer.fixedFoveation = value;
            if (glBaseLayer !== null && glBaseLayer.fixedFoveation !== undefined) glBaseLayer.fixedFoveation = value;
        };
        /**
		 * Returns `true` if depth sensing is supported.
		 *
		 * @return {boolean} Whether depth sensing is supported or not.
		 */ this.hasDepthSensing = function() {
            return depthSensing.texture !== null;
        };
        /**
		 * Returns the depth sensing mesh.
		 *
		 * @return {Mesh} The depth sensing mesh.
		 */ this.getDepthSensingMesh = function() {
            return depthSensing.getMesh(cameraXR);
        };
        // Animation Loop
        let onAnimationFrameCallback = null;
        function onAnimationFrame(time, frame) {
            pose = frame.getViewerPose(customReferenceSpace || referenceSpace);
            xrFrame = frame;
            if (pose !== null) {
                const views = pose.views;
                if (glBaseLayer !== null) {
                    renderer.setRenderTargetFramebuffer(newRenderTarget, glBaseLayer.framebuffer);
                    renderer.setRenderTarget(newRenderTarget);
                }
                let cameraXRNeedsUpdate = false;
                // check if it's necessary to rebuild cameraXR's camera list
                if (views.length !== cameraXR.cameras.length) {
                    cameraXR.cameras.length = 0;
                    cameraXRNeedsUpdate = true;
                }
                for(let i = 0; i < views.length; i++){
                    const view = views[i];
                    let viewport = null;
                    if (glBaseLayer !== null) viewport = glBaseLayer.getViewport(view);
                    else {
                        const glSubImage = glBinding.getViewSubImage(glProjLayer, view);
                        viewport = glSubImage.viewport;
                        // For side-by-side projection, we only produce a single texture for both eyes.
                        if (i === 0) {
                            renderer.setRenderTargetTextures(newRenderTarget, glSubImage.colorTexture, glSubImage.depthStencilTexture);
                            renderer.setRenderTarget(newRenderTarget);
                        }
                    }
                    let camera = cameras[i];
                    if (camera === undefined) {
                        camera = new (0, $dyjou.PerspectiveCamera)();
                        camera.layers.enable(i);
                        camera.viewport = new (0, $dyjou.Vector4)();
                        cameras[i] = camera;
                    }
                    camera.matrix.fromArray(view.transform.matrix);
                    camera.matrix.decompose(camera.position, camera.quaternion, camera.scale);
                    camera.projectionMatrix.fromArray(view.projectionMatrix);
                    camera.projectionMatrixInverse.copy(camera.projectionMatrix).invert();
                    camera.viewport.set(viewport.x, viewport.y, viewport.width, viewport.height);
                    if (i === 0) {
                        cameraXR.matrix.copy(camera.matrix);
                        cameraXR.matrix.decompose(cameraXR.position, cameraXR.quaternion, cameraXR.scale);
                    }
                    if (cameraXRNeedsUpdate === true) cameraXR.cameras.push(camera);
                }
                //
                const enabledFeatures = session.enabledFeatures;
                const gpuDepthSensingEnabled = enabledFeatures && enabledFeatures.includes('depth-sensing') && session.depthUsage == 'gpu-optimized';
                if (gpuDepthSensingEnabled && glBinding) {
                    const depthData = glBinding.getDepthInformation(views[0]);
                    if (depthData && depthData.isValid && depthData.texture) depthSensing.init(renderer, depthData, session.renderState);
                }
            }
            //
            for(let i = 0; i < controllers.length; i++){
                const inputSource = controllerInputSources[i];
                const controller = controllers[i];
                if (inputSource !== null && controller !== undefined) controller.update(inputSource, frame, customReferenceSpace || referenceSpace);
            }
            if (onAnimationFrameCallback) onAnimationFrameCallback(time, frame);
            if (frame.detectedPlanes) scope.dispatchEvent({
                type: 'planesdetected',
                data: frame
            });
            xrFrame = null;
        }
        const animation = new $d5b33d7c30034067$var$WebGLAnimation();
        animation.setAnimationLoop(onAnimationFrame);
        this.setAnimationLoop = function(callback) {
            onAnimationFrameCallback = callback;
        };
        this.dispose = function() {};
    }
}
const $d5b33d7c30034067$var$_e1 = /*@__PURE__*/ new (0, $dyjou.Euler)();
const $d5b33d7c30034067$var$_m1 = /*@__PURE__*/ new (0, $dyjou.Matrix4)();
function $d5b33d7c30034067$var$WebGLMaterials(renderer, properties) {
    function refreshTransformUniform(map, uniform) {
        if (map.matrixAutoUpdate === true) map.updateMatrix();
        uniform.value.copy(map.matrix);
    }
    function refreshFogUniforms(uniforms, fog) {
        fog.color.getRGB(uniforms.fogColor.value, (0, $dyjou.getUnlitUniformColorSpace)(renderer));
        if (fog.isFog) {
            uniforms.fogNear.value = fog.near;
            uniforms.fogFar.value = fog.far;
        } else if (fog.isFogExp2) uniforms.fogDensity.value = fog.density;
    }
    function refreshMaterialUniforms(uniforms, material, pixelRatio, height, transmissionRenderTarget) {
        if (material.isMeshBasicMaterial) refreshUniformsCommon(uniforms, material);
        else if (material.isMeshLambertMaterial) refreshUniformsCommon(uniforms, material);
        else if (material.isMeshToonMaterial) {
            refreshUniformsCommon(uniforms, material);
            refreshUniformsToon(uniforms, material);
        } else if (material.isMeshPhongMaterial) {
            refreshUniformsCommon(uniforms, material);
            refreshUniformsPhong(uniforms, material);
        } else if (material.isMeshStandardMaterial) {
            refreshUniformsCommon(uniforms, material);
            refreshUniformsStandard(uniforms, material);
            if (material.isMeshPhysicalMaterial) refreshUniformsPhysical(uniforms, material, transmissionRenderTarget);
        } else if (material.isMeshMatcapMaterial) {
            refreshUniformsCommon(uniforms, material);
            refreshUniformsMatcap(uniforms, material);
        } else if (material.isMeshDepthMaterial) refreshUniformsCommon(uniforms, material);
        else if (material.isMeshDistanceMaterial) {
            refreshUniformsCommon(uniforms, material);
            refreshUniformsDistance(uniforms, material);
        } else if (material.isMeshNormalMaterial) refreshUniformsCommon(uniforms, material);
        else if (material.isLineBasicMaterial) {
            refreshUniformsLine(uniforms, material);
            if (material.isLineDashedMaterial) refreshUniformsDash(uniforms, material);
        } else if (material.isPointsMaterial) refreshUniformsPoints(uniforms, material, pixelRatio, height);
        else if (material.isSpriteMaterial) refreshUniformsSprites(uniforms, material);
        else if (material.isShadowMaterial) {
            uniforms.color.value.copy(material.color);
            uniforms.opacity.value = material.opacity;
        } else if (material.isShaderMaterial) material.uniformsNeedUpdate = false; // #15581
    }
    function refreshUniformsCommon(uniforms, material) {
        uniforms.opacity.value = material.opacity;
        if (material.color) uniforms.diffuse.value.copy(material.color);
        if (material.emissive) uniforms.emissive.value.copy(material.emissive).multiplyScalar(material.emissiveIntensity);
        if (material.map) {
            uniforms.map.value = material.map;
            refreshTransformUniform(material.map, uniforms.mapTransform);
        }
        if (material.alphaMap) {
            uniforms.alphaMap.value = material.alphaMap;
            refreshTransformUniform(material.alphaMap, uniforms.alphaMapTransform);
        }
        if (material.bumpMap) {
            uniforms.bumpMap.value = material.bumpMap;
            refreshTransformUniform(material.bumpMap, uniforms.bumpMapTransform);
            uniforms.bumpScale.value = material.bumpScale;
            if (material.side === (0, $dyjou.BackSide)) uniforms.bumpScale.value *= -1;
        }
        if (material.normalMap) {
            uniforms.normalMap.value = material.normalMap;
            refreshTransformUniform(material.normalMap, uniforms.normalMapTransform);
            uniforms.normalScale.value.copy(material.normalScale);
            if (material.side === (0, $dyjou.BackSide)) uniforms.normalScale.value.negate();
        }
        if (material.displacementMap) {
            uniforms.displacementMap.value = material.displacementMap;
            refreshTransformUniform(material.displacementMap, uniforms.displacementMapTransform);
            uniforms.displacementScale.value = material.displacementScale;
            uniforms.displacementBias.value = material.displacementBias;
        }
        if (material.emissiveMap) {
            uniforms.emissiveMap.value = material.emissiveMap;
            refreshTransformUniform(material.emissiveMap, uniforms.emissiveMapTransform);
        }
        if (material.specularMap) {
            uniforms.specularMap.value = material.specularMap;
            refreshTransformUniform(material.specularMap, uniforms.specularMapTransform);
        }
        if (material.alphaTest > 0) uniforms.alphaTest.value = material.alphaTest;
        const materialProperties = properties.get(material);
        const envMap = materialProperties.envMap;
        const envMapRotation = materialProperties.envMapRotation;
        if (envMap) {
            uniforms.envMap.value = envMap;
            $d5b33d7c30034067$var$_e1.copy(envMapRotation);
            // accommodate left-handed frame
            $d5b33d7c30034067$var$_e1.x *= -1;
            $d5b33d7c30034067$var$_e1.y *= -1;
            $d5b33d7c30034067$var$_e1.z *= -1;
            if (envMap.isCubeTexture && envMap.isRenderTargetTexture === false) {
                // environment maps which are not cube render targets or PMREMs follow a different convention
                $d5b33d7c30034067$var$_e1.y *= -1;
                $d5b33d7c30034067$var$_e1.z *= -1;
            }
            uniforms.envMapRotation.value.setFromMatrix4($d5b33d7c30034067$var$_m1.makeRotationFromEuler($d5b33d7c30034067$var$_e1));
            uniforms.flipEnvMap.value = envMap.isCubeTexture && envMap.isRenderTargetTexture === false ? -1 : 1;
            uniforms.reflectivity.value = material.reflectivity;
            uniforms.ior.value = material.ior;
            uniforms.refractionRatio.value = material.refractionRatio;
        }
        if (material.lightMap) {
            uniforms.lightMap.value = material.lightMap;
            uniforms.lightMapIntensity.value = material.lightMapIntensity;
            refreshTransformUniform(material.lightMap, uniforms.lightMapTransform);
        }
        if (material.aoMap) {
            uniforms.aoMap.value = material.aoMap;
            uniforms.aoMapIntensity.value = material.aoMapIntensity;
            refreshTransformUniform(material.aoMap, uniforms.aoMapTransform);
        }
    }
    function refreshUniformsLine(uniforms, material) {
        uniforms.diffuse.value.copy(material.color);
        uniforms.opacity.value = material.opacity;
        if (material.map) {
            uniforms.map.value = material.map;
            refreshTransformUniform(material.map, uniforms.mapTransform);
        }
    }
    function refreshUniformsDash(uniforms, material) {
        uniforms.dashSize.value = material.dashSize;
        uniforms.totalSize.value = material.dashSize + material.gapSize;
        uniforms.scale.value = material.scale;
    }
    function refreshUniformsPoints(uniforms, material, pixelRatio, height) {
        uniforms.diffuse.value.copy(material.color);
        uniforms.opacity.value = material.opacity;
        uniforms.size.value = material.size * pixelRatio;
        uniforms.scale.value = height * 0.5;
        if (material.map) {
            uniforms.map.value = material.map;
            refreshTransformUniform(material.map, uniforms.uvTransform);
        }
        if (material.alphaMap) {
            uniforms.alphaMap.value = material.alphaMap;
            refreshTransformUniform(material.alphaMap, uniforms.alphaMapTransform);
        }
        if (material.alphaTest > 0) uniforms.alphaTest.value = material.alphaTest;
    }
    function refreshUniformsSprites(uniforms, material) {
        uniforms.diffuse.value.copy(material.color);
        uniforms.opacity.value = material.opacity;
        uniforms.rotation.value = material.rotation;
        if (material.map) {
            uniforms.map.value = material.map;
            refreshTransformUniform(material.map, uniforms.mapTransform);
        }
        if (material.alphaMap) {
            uniforms.alphaMap.value = material.alphaMap;
            refreshTransformUniform(material.alphaMap, uniforms.alphaMapTransform);
        }
        if (material.alphaTest > 0) uniforms.alphaTest.value = material.alphaTest;
    }
    function refreshUniformsPhong(uniforms, material) {
        uniforms.specular.value.copy(material.specular);
        uniforms.shininess.value = Math.max(material.shininess, 1e-4); // to prevent pow( 0.0, 0.0 )
    }
    function refreshUniformsToon(uniforms, material) {
        if (material.gradientMap) uniforms.gradientMap.value = material.gradientMap;
    }
    function refreshUniformsStandard(uniforms, material) {
        uniforms.metalness.value = material.metalness;
        if (material.metalnessMap) {
            uniforms.metalnessMap.value = material.metalnessMap;
            refreshTransformUniform(material.metalnessMap, uniforms.metalnessMapTransform);
        }
        uniforms.roughness.value = material.roughness;
        if (material.roughnessMap) {
            uniforms.roughnessMap.value = material.roughnessMap;
            refreshTransformUniform(material.roughnessMap, uniforms.roughnessMapTransform);
        }
        if (material.envMap) //uniforms.envMap.value = material.envMap; // part of uniforms common
        uniforms.envMapIntensity.value = material.envMapIntensity;
    }
    function refreshUniformsPhysical(uniforms, material, transmissionRenderTarget) {
        uniforms.ior.value = material.ior; // also part of uniforms common
        if (material.sheen > 0) {
            uniforms.sheenColor.value.copy(material.sheenColor).multiplyScalar(material.sheen);
            uniforms.sheenRoughness.value = material.sheenRoughness;
            if (material.sheenColorMap) {
                uniforms.sheenColorMap.value = material.sheenColorMap;
                refreshTransformUniform(material.sheenColorMap, uniforms.sheenColorMapTransform);
            }
            if (material.sheenRoughnessMap) {
                uniforms.sheenRoughnessMap.value = material.sheenRoughnessMap;
                refreshTransformUniform(material.sheenRoughnessMap, uniforms.sheenRoughnessMapTransform);
            }
        }
        if (material.clearcoat > 0) {
            uniforms.clearcoat.value = material.clearcoat;
            uniforms.clearcoatRoughness.value = material.clearcoatRoughness;
            if (material.clearcoatMap) {
                uniforms.clearcoatMap.value = material.clearcoatMap;
                refreshTransformUniform(material.clearcoatMap, uniforms.clearcoatMapTransform);
            }
            if (material.clearcoatRoughnessMap) {
                uniforms.clearcoatRoughnessMap.value = material.clearcoatRoughnessMap;
                refreshTransformUniform(material.clearcoatRoughnessMap, uniforms.clearcoatRoughnessMapTransform);
            }
            if (material.clearcoatNormalMap) {
                uniforms.clearcoatNormalMap.value = material.clearcoatNormalMap;
                refreshTransformUniform(material.clearcoatNormalMap, uniforms.clearcoatNormalMapTransform);
                uniforms.clearcoatNormalScale.value.copy(material.clearcoatNormalScale);
                if (material.side === (0, $dyjou.BackSide)) uniforms.clearcoatNormalScale.value.negate();
            }
        }
        if (material.dispersion > 0) uniforms.dispersion.value = material.dispersion;
        if (material.iridescence > 0) {
            uniforms.iridescence.value = material.iridescence;
            uniforms.iridescenceIOR.value = material.iridescenceIOR;
            uniforms.iridescenceThicknessMinimum.value = material.iridescenceThicknessRange[0];
            uniforms.iridescenceThicknessMaximum.value = material.iridescenceThicknessRange[1];
            if (material.iridescenceMap) {
                uniforms.iridescenceMap.value = material.iridescenceMap;
                refreshTransformUniform(material.iridescenceMap, uniforms.iridescenceMapTransform);
            }
            if (material.iridescenceThicknessMap) {
                uniforms.iridescenceThicknessMap.value = material.iridescenceThicknessMap;
                refreshTransformUniform(material.iridescenceThicknessMap, uniforms.iridescenceThicknessMapTransform);
            }
        }
        if (material.transmission > 0) {
            uniforms.transmission.value = material.transmission;
            uniforms.transmissionSamplerMap.value = transmissionRenderTarget.texture;
            uniforms.transmissionSamplerSize.value.set(transmissionRenderTarget.width, transmissionRenderTarget.height);
            if (material.transmissionMap) {
                uniforms.transmissionMap.value = material.transmissionMap;
                refreshTransformUniform(material.transmissionMap, uniforms.transmissionMapTransform);
            }
            uniforms.thickness.value = material.thickness;
            if (material.thicknessMap) {
                uniforms.thicknessMap.value = material.thicknessMap;
                refreshTransformUniform(material.thicknessMap, uniforms.thicknessMapTransform);
            }
            uniforms.attenuationDistance.value = material.attenuationDistance;
            uniforms.attenuationColor.value.copy(material.attenuationColor);
        }
        if (material.anisotropy > 0) {
            uniforms.anisotropyVector.value.set(material.anisotropy * Math.cos(material.anisotropyRotation), material.anisotropy * Math.sin(material.anisotropyRotation));
            if (material.anisotropyMap) {
                uniforms.anisotropyMap.value = material.anisotropyMap;
                refreshTransformUniform(material.anisotropyMap, uniforms.anisotropyMapTransform);
            }
        }
        uniforms.specularIntensity.value = material.specularIntensity;
        uniforms.specularColor.value.copy(material.specularColor);
        if (material.specularColorMap) {
            uniforms.specularColorMap.value = material.specularColorMap;
            refreshTransformUniform(material.specularColorMap, uniforms.specularColorMapTransform);
        }
        if (material.specularIntensityMap) {
            uniforms.specularIntensityMap.value = material.specularIntensityMap;
            refreshTransformUniform(material.specularIntensityMap, uniforms.specularIntensityMapTransform);
        }
    }
    function refreshUniformsMatcap(uniforms, material) {
        if (material.matcap) uniforms.matcap.value = material.matcap;
    }
    function refreshUniformsDistance(uniforms, material) {
        const light = properties.get(material).light;
        uniforms.referencePosition.value.setFromMatrixPosition(light.matrixWorld);
        uniforms.nearDistance.value = light.shadow.camera.near;
        uniforms.farDistance.value = light.shadow.camera.far;
    }
    return {
        refreshFogUniforms: refreshFogUniforms,
        refreshMaterialUniforms: refreshMaterialUniforms
    };
}
function $d5b33d7c30034067$var$WebGLUniformsGroups(gl, info, capabilities, state) {
    let buffers = {};
    let updateList = {};
    let allocatedBindingPoints = [];
    const maxBindingPoints = gl.getParameter(gl.MAX_UNIFORM_BUFFER_BINDINGS); // binding points are global whereas block indices are per shader program
    function bind(uniformsGroup, program) {
        const webglProgram = program.program;
        state.uniformBlockBinding(uniformsGroup, webglProgram);
    }
    function update(uniformsGroup, program) {
        let buffer = buffers[uniformsGroup.id];
        if (buffer === undefined) {
            prepareUniformsGroup(uniformsGroup);
            buffer = createBuffer(uniformsGroup);
            buffers[uniformsGroup.id] = buffer;
            uniformsGroup.addEventListener('dispose', onUniformsGroupsDispose);
        }
        // ensure to update the binding points/block indices mapping for this program
        const webglProgram = program.program;
        state.updateUBOMapping(uniformsGroup, webglProgram);
        // update UBO once per frame
        const frame = info.render.frame;
        if (updateList[uniformsGroup.id] !== frame) {
            updateBufferData(uniformsGroup);
            updateList[uniformsGroup.id] = frame;
        }
    }
    function createBuffer(uniformsGroup) {
        // the setup of an UBO is independent of a particular shader program but global
        const bindingPointIndex = allocateBindingPointIndex();
        uniformsGroup.__bindingPointIndex = bindingPointIndex;
        const buffer = gl.createBuffer();
        const size = uniformsGroup.__size;
        const usage = uniformsGroup.usage;
        gl.bindBuffer(gl.UNIFORM_BUFFER, buffer);
        gl.bufferData(gl.UNIFORM_BUFFER, size, usage);
        gl.bindBuffer(gl.UNIFORM_BUFFER, null);
        gl.bindBufferBase(gl.UNIFORM_BUFFER, bindingPointIndex, buffer);
        return buffer;
    }
    function allocateBindingPointIndex() {
        for(let i = 0; i < maxBindingPoints; i++)if (allocatedBindingPoints.indexOf(i) === -1) {
            allocatedBindingPoints.push(i);
            return i;
        }
        console.error('THREE.WebGLRenderer: Maximum number of simultaneously usable uniforms groups reached.');
        return 0;
    }
    function updateBufferData(uniformsGroup) {
        const buffer = buffers[uniformsGroup.id];
        const uniforms = uniformsGroup.uniforms;
        const cache = uniformsGroup.__cache;
        gl.bindBuffer(gl.UNIFORM_BUFFER, buffer);
        for(let i = 0, il = uniforms.length; i < il; i++){
            const uniformArray = Array.isArray(uniforms[i]) ? uniforms[i] : [
                uniforms[i]
            ];
            for(let j = 0, jl = uniformArray.length; j < jl; j++){
                const uniform = uniformArray[j];
                if (hasUniformChanged(uniform, i, j, cache) === true) {
                    const offset = uniform.__offset;
                    const values = Array.isArray(uniform.value) ? uniform.value : [
                        uniform.value
                    ];
                    let arrayOffset = 0;
                    for(let k = 0; k < values.length; k++){
                        const value = values[k];
                        const info = getUniformSize(value);
                        // TODO add integer and struct support
                        if (typeof value === 'number' || typeof value === 'boolean') {
                            uniform.__data[0] = value;
                            gl.bufferSubData(gl.UNIFORM_BUFFER, offset + arrayOffset, uniform.__data);
                        } else if (value.isMatrix3) {
                            // manually converting 3x3 to 3x4
                            uniform.__data[0] = value.elements[0];
                            uniform.__data[1] = value.elements[1];
                            uniform.__data[2] = value.elements[2];
                            uniform.__data[3] = 0;
                            uniform.__data[4] = value.elements[3];
                            uniform.__data[5] = value.elements[4];
                            uniform.__data[6] = value.elements[5];
                            uniform.__data[7] = 0;
                            uniform.__data[8] = value.elements[6];
                            uniform.__data[9] = value.elements[7];
                            uniform.__data[10] = value.elements[8];
                            uniform.__data[11] = 0;
                        } else {
                            value.toArray(uniform.__data, arrayOffset);
                            arrayOffset += info.storage / Float32Array.BYTES_PER_ELEMENT;
                        }
                    }
                    gl.bufferSubData(gl.UNIFORM_BUFFER, offset, uniform.__data);
                }
            }
        }
        gl.bindBuffer(gl.UNIFORM_BUFFER, null);
    }
    function hasUniformChanged(uniform, index, indexArray, cache) {
        const value = uniform.value;
        const indexString = index + '_' + indexArray;
        if (cache[indexString] === undefined) {
            // cache entry does not exist so far
            if (typeof value === 'number' || typeof value === 'boolean') cache[indexString] = value;
            else cache[indexString] = value.clone();
            return true;
        } else {
            const cachedObject = cache[indexString];
            // compare current value with cached entry
            if (typeof value === 'number' || typeof value === 'boolean') {
                if (cachedObject !== value) {
                    cache[indexString] = value;
                    return true;
                }
            } else if (cachedObject.equals(value) === false) {
                cachedObject.copy(value);
                return true;
            }
        }
        return false;
    }
    function prepareUniformsGroup(uniformsGroup) {
        // determine total buffer size according to the STD140 layout
        // Hint: STD140 is the only supported layout in WebGL 2
        const uniforms = uniformsGroup.uniforms;
        let offset = 0; // global buffer offset in bytes
        const chunkSize = 16; // size of a chunk in bytes
        for(let i = 0, l = uniforms.length; i < l; i++){
            const uniformArray = Array.isArray(uniforms[i]) ? uniforms[i] : [
                uniforms[i]
            ];
            for(let j = 0, jl = uniformArray.length; j < jl; j++){
                const uniform = uniformArray[j];
                const values = Array.isArray(uniform.value) ? uniform.value : [
                    uniform.value
                ];
                for(let k = 0, kl = values.length; k < kl; k++){
                    const value = values[k];
                    const info = getUniformSize(value);
                    const chunkOffset = offset % chunkSize; // offset in the current chunk
                    const chunkPadding = chunkOffset % info.boundary; // required padding to match boundary
                    const chunkStart = chunkOffset + chunkPadding; // the start position in the current chunk for the data
                    offset += chunkPadding;
                    // Check for chunk overflow
                    if (chunkStart !== 0 && chunkSize - chunkStart < info.storage) // Add padding and adjust offset
                    offset += chunkSize - chunkStart;
                    // the following two properties will be used for partial buffer updates
                    uniform.__data = new Float32Array(info.storage / Float32Array.BYTES_PER_ELEMENT);
                    uniform.__offset = offset;
                    // Update the global offset
                    offset += info.storage;
                }
            }
        }
        // ensure correct final padding
        const chunkOffset = offset % chunkSize;
        if (chunkOffset > 0) offset += chunkSize - chunkOffset;
        //
        uniformsGroup.__size = offset;
        uniformsGroup.__cache = {};
        return this;
    }
    function getUniformSize(value) {
        const info = {
            boundary: 0,
            storage: 0 // bytes
        };
        // determine sizes according to STD140
        if (typeof value === 'number' || typeof value === 'boolean') {
            // float/int/bool
            info.boundary = 4;
            info.storage = 4;
        } else if (value.isVector2) {
            // vec2
            info.boundary = 8;
            info.storage = 8;
        } else if (value.isVector3 || value.isColor) {
            // vec3
            info.boundary = 16;
            info.storage = 12; // evil: vec3 must start on a 16-byte boundary but it only consumes 12 bytes
        } else if (value.isVector4) {
            // vec4
            info.boundary = 16;
            info.storage = 16;
        } else if (value.isMatrix3) {
            // mat3 (in STD140 a 3x3 matrix is represented as 3x4)
            info.boundary = 48;
            info.storage = 48;
        } else if (value.isMatrix4) {
            // mat4
            info.boundary = 64;
            info.storage = 64;
        } else if (value.isTexture) console.warn('THREE.WebGLRenderer: Texture samplers can not be part of an uniforms group.');
        else console.warn('THREE.WebGLRenderer: Unsupported uniform value type.', value);
        return info;
    }
    function onUniformsGroupsDispose(event) {
        const uniformsGroup = event.target;
        uniformsGroup.removeEventListener('dispose', onUniformsGroupsDispose);
        const index = allocatedBindingPoints.indexOf(uniformsGroup.__bindingPointIndex);
        allocatedBindingPoints.splice(index, 1);
        gl.deleteBuffer(buffers[uniformsGroup.id]);
        delete buffers[uniformsGroup.id];
        delete updateList[uniformsGroup.id];
    }
    function dispose() {
        for(const id in buffers)gl.deleteBuffer(buffers[id]);
        allocatedBindingPoints = [];
        buffers = {};
        updateList = {};
    }
    return {
        bind: bind,
        update: update,
        dispose: dispose
    };
}
/**
 * This renderer uses WebGL 2 to display scenes.
 *
 * WebGL 1 is not supported since `r163`.
 */ class $d5b33d7c30034067$export$f6cc00ef28d7cf97 {
    /**
	 * Constructs a new WebGL renderer.
	 *
	 * @param {WebGLRenderer~Options} [parameters] - The configuration parameter.
	 */ constructor(parameters = {}){
        const { canvas: canvas = (0, $dyjou.createCanvasElement)(), context: context = null, depth: depth = true, stencil: stencil = false, alpha: alpha = false, antialias: antialias = false, premultipliedAlpha: premultipliedAlpha = true, preserveDrawingBuffer: preserveDrawingBuffer = false, powerPreference: powerPreference = 'default', failIfMajorPerformanceCaveat: failIfMajorPerformanceCaveat = false, reverseDepthBuffer: reverseDepthBuffer = false } = parameters;
        /**
		 * This flag can be used for type testing.
		 *
		 * @type {boolean}
		 * @readonly
		 * @default true
		 */ this.isWebGLRenderer = true;
        let _alpha;
        if (context !== null) {
            if (typeof WebGLRenderingContext !== 'undefined' && context instanceof WebGLRenderingContext) throw new Error('THREE.WebGLRenderer: WebGL 1 is not supported since r163.');
            _alpha = context.getContextAttributes().alpha;
        } else _alpha = alpha;
        const uintClearColor = new Uint32Array(4);
        const intClearColor = new Int32Array(4);
        let currentRenderList = null;
        let currentRenderState = null;
        // render() can be called from within a callback triggered by another render.
        // We track this so that the nested render call gets its list and state isolated from the parent render call.
        const renderListStack = [];
        const renderStateStack = [];
        // public properties
        /**
		 * A canvas where the renderer draws its output.This is automatically created by the renderer
		 * in the constructor (if not provided already); you just need to add it to your page like so:
		 * ```js
		 * document.body.appendChild( renderer.domElement );
		 * ```
		 *
		 * @type {DOMElement}
		 */ this.domElement = canvas;
        /**
		 * A object with debug configuration settings.
		 *
		 * - `checkShaderErrors`: If it is `true`, defines whether material shader programs are
		 * checked for errors during compilation and linkage process. It may be useful to disable
		 * this check in production for performance gain. It is strongly recommended to keep these
		 * checks enabled during development. If the shader does not compile and link - it will not
		 * work and associated material will not render.
		 * - `onShaderError(gl, program, glVertexShader,glFragmentShader)`: A callback function that
		 * can be used for custom error reporting. The callback receives the WebGL context, an instance
		 * of WebGLProgram as well two instances of WebGLShader representing the vertex and fragment shader.
		 * Assigning a custom function disables the default error reporting.
		 *
		 * @type {Object}
		 */ this.debug = {
            /**
			 * Enables error checking and reporting when shader programs are being compiled.
			 * @type {boolean}
			 */ checkShaderErrors: true,
            /**
			 * Callback for custom error reporting.
			 * @type {?Function}
			 */ onShaderError: null
        };
        // clearing
        /**
		 * Whether the renderer should automatically clear its output before rendering a frame or not.
		 *
		 * @type {boolean}
		 * @default true
		 */ this.autoClear = true;
        /**
		 * If {@link WebGLRenderer#autoClear} set to `true`, whether the renderer should clear
		 * the color buffer or not.
		 *
		 * @type {boolean}
		 * @default true
		 */ this.autoClearColor = true;
        /**
		 * If {@link WebGLRenderer#autoClear} set to `true`, whether the renderer should clear
		 * the depth buffer or not.
		 *
		 * @type {boolean}
		 * @default true
		 */ this.autoClearDepth = true;
        /**
		 * If {@link WebGLRenderer#autoClear} set to `true`, whether the renderer should clear
		 * the stencil buffer or not.
		 *
		 * @type {boolean}
		 * @default true
		 */ this.autoClearStencil = true;
        // scene graph
        /**
		 * Whether the renderer should sort objects or not.
		 *
		 * Note: Sorting is used to attempt to properly render objects that have some
		 * degree of transparency. By definition, sorting objects may not work in all
		 * cases. Depending on the needs of application, it may be necessary to turn
		 * off sorting and use other methods to deal with transparency rendering e.g.
		 * manually determining each object's rendering order.
		 *
		 * @type {boolean}
		 * @default true
		 */ this.sortObjects = true;
        // user-defined clipping
        /**
		 * User-defined clipping planes specified in world space. These planes apply globally.
		 * Points in space whose dot product with the plane is negative are cut away.
		 *
		 * @type {Array<Plane>}
		 */ this.clippingPlanes = [];
        /**
		 * Whether the renderer respects object-level clipping planes or not.
		 *
		 * @type {boolean}
		 * @default false
		 */ this.localClippingEnabled = false;
        // tone mapping
        /**
		 * The tone mapping technique of the renderer.
		 *
		 * @type {(NoToneMapping|LinearToneMapping|ReinhardToneMapping|CineonToneMapping|ACESFilmicToneMapping|CustomToneMapping|AgXToneMapping|NeutralToneMapping)}
		 * @default NoToneMapping
		 */ this.toneMapping = (0, $dyjou.NoToneMapping);
        /**
		 * Exposure level of tone mapping.
		 *
		 * @type {number}
		 * @default 1
		 */ this.toneMappingExposure = 1.0;
        // transmission
        /**
		 * The normalized resolution scale for the transmission render target, measured in percentage
		 * of viewport dimensions. Lowering this value can result in significant performance improvements
		 * when using {@link MeshPhysicalMaterial#transmission}.
		 *
		 * @type {number}
		 * @default 1
		 */ this.transmissionResolutionScale = 1.0;
        // internal properties
        const _this = this;
        let _isContextLost = false;
        // internal state cache
        this._outputColorSpace = (0, $dyjou.SRGBColorSpace);
        let _currentActiveCubeFace = 0;
        let _currentActiveMipmapLevel = 0;
        let _currentRenderTarget = null;
        let _currentMaterialId = -1;
        let _currentCamera = null;
        const _currentViewport = new (0, $dyjou.Vector4)();
        const _currentScissor = new (0, $dyjou.Vector4)();
        let _currentScissorTest = null;
        const _currentClearColor = new (0, $dyjou.Color)(0x000000);
        let _currentClearAlpha = 0;
        //
        let _width = canvas.width;
        let _height = canvas.height;
        let _pixelRatio = 1;
        let _opaqueSort = null;
        let _transparentSort = null;
        const _viewport = new (0, $dyjou.Vector4)(0, 0, _width, _height);
        const _scissor = new (0, $dyjou.Vector4)(0, 0, _width, _height);
        let _scissorTest = false;
        // frustum
        const _frustum = new (0, $dyjou.Frustum)();
        // clipping
        let _clippingEnabled = false;
        let _localClippingEnabled = false;
        // camera matrices cache
        const _currentProjectionMatrix = new (0, $dyjou.Matrix4)();
        const _projScreenMatrix = new (0, $dyjou.Matrix4)();
        const _vector3 = new (0, $dyjou.Vector3)();
        const _vector4 = new (0, $dyjou.Vector4)();
        const _emptyScene = {
            background: null,
            fog: null,
            environment: null,
            overrideMaterial: null,
            isScene: true
        };
        let _renderBackground = false;
        function getTargetPixelRatio() {
            return _currentRenderTarget === null ? _pixelRatio : 1;
        }
        // initialize
        let _gl = context;
        function getContext(contextName, contextAttributes) {
            return canvas.getContext(contextName, contextAttributes);
        }
        try {
            const contextAttributes = {
                alpha: true,
                depth: depth,
                stencil: stencil,
                antialias: antialias,
                premultipliedAlpha: premultipliedAlpha,
                preserveDrawingBuffer: preserveDrawingBuffer,
                powerPreference: powerPreference,
                failIfMajorPerformanceCaveat: failIfMajorPerformanceCaveat
            };
            // OffscreenCanvas does not have setAttribute, see #22811
            if ('setAttribute' in canvas) canvas.setAttribute('data-engine', `three.js r${(0, $dyjou.REVISION)}`);
            // event listeners must be registered before WebGL context is created, see #12753
            canvas.addEventListener('webglcontextlost', onContextLost, false);
            canvas.addEventListener('webglcontextrestored', onContextRestore, false);
            canvas.addEventListener('webglcontextcreationerror', onContextCreationError, false);
            if (_gl === null) {
                const contextName = 'webgl2';
                _gl = getContext(contextName, contextAttributes);
                if (_gl === null) {
                    if (getContext(contextName)) throw new Error('Error creating WebGL context with your selected attributes.');
                    else throw new Error('Error creating WebGL context.');
                }
            }
        } catch (error) {
            console.error('THREE.WebGLRenderer: ' + error.message);
            throw error;
        }
        let extensions, capabilities, state, info;
        let properties, textures, cubemaps, cubeuvmaps, attributes, geometries, objects;
        let programCache, materials, renderLists, renderStates, clipping, shadowMap;
        let background, morphtargets, bufferRenderer, indexedBufferRenderer;
        let utils, bindingStates, uniformsGroups;
        function initGLContext() {
            extensions = new $d5b33d7c30034067$var$WebGLExtensions(_gl);
            extensions.init();
            utils = new $d5b33d7c30034067$export$ddaebcad857649a8(_gl, extensions);
            capabilities = new $d5b33d7c30034067$var$WebGLCapabilities(_gl, extensions, parameters, utils);
            state = new $d5b33d7c30034067$var$WebGLState(_gl, extensions);
            if (capabilities.reverseDepthBuffer && reverseDepthBuffer) state.buffers.depth.setReversed(true);
            info = new $d5b33d7c30034067$var$WebGLInfo(_gl);
            properties = new $d5b33d7c30034067$var$WebGLProperties();
            textures = new $d5b33d7c30034067$var$WebGLTextures(_gl, extensions, state, properties, capabilities, utils, info);
            cubemaps = new $d5b33d7c30034067$var$WebGLCubeMaps(_this);
            cubeuvmaps = new $d5b33d7c30034067$var$WebGLCubeUVMaps(_this);
            attributes = new $d5b33d7c30034067$var$WebGLAttributes(_gl);
            bindingStates = new $d5b33d7c30034067$var$WebGLBindingStates(_gl, attributes);
            geometries = new $d5b33d7c30034067$var$WebGLGeometries(_gl, attributes, info, bindingStates);
            objects = new $d5b33d7c30034067$var$WebGLObjects(_gl, geometries, attributes, info);
            morphtargets = new $d5b33d7c30034067$var$WebGLMorphtargets(_gl, capabilities, textures);
            clipping = new $d5b33d7c30034067$var$WebGLClipping(properties);
            programCache = new $d5b33d7c30034067$var$WebGLPrograms(_this, cubemaps, cubeuvmaps, extensions, capabilities, bindingStates, clipping);
            materials = new $d5b33d7c30034067$var$WebGLMaterials(_this, properties);
            renderLists = new $d5b33d7c30034067$var$WebGLRenderLists();
            renderStates = new $d5b33d7c30034067$var$WebGLRenderStates(extensions);
            background = new $d5b33d7c30034067$var$WebGLBackground(_this, cubemaps, cubeuvmaps, state, objects, _alpha, premultipliedAlpha);
            shadowMap = new $d5b33d7c30034067$var$WebGLShadowMap(_this, objects, capabilities);
            uniformsGroups = new $d5b33d7c30034067$var$WebGLUniformsGroups(_gl, info, capabilities, state);
            bufferRenderer = new $d5b33d7c30034067$var$WebGLBufferRenderer(_gl, extensions, info);
            indexedBufferRenderer = new $d5b33d7c30034067$var$WebGLIndexedBufferRenderer(_gl, extensions, info);
            info.programs = programCache.programs;
            /**
			 * Holds details about the capabilities of the current rendering context.
			 *
			 * @name WebGLRenderer#capabilities
			 * @type {WebGLRenderer~Capabilities}
			 */ _this.capabilities = capabilities;
            /**
			 * Provides methods for retrieving and testing WebGL extensions.
			 *
			 * - `get(extensionName:string)`: Used to check whether a WebGL extension is supported
			 * and return the extension object if available.
			 * - `has(extensionName:string)`: returns `true` if the extension is supported.
			 *
			 * @name WebGLRenderer#extensions
			 * @type {Object}
			 */ _this.extensions = extensions;
            /**
			 * Used to track properties of other objects like native WebGL objects.
			 *
			 * @name WebGLRenderer#properties
			 * @type {Object}
			 */ _this.properties = properties;
            /**
			 * Manages the render lists of the renderer.
			 *
			 * @name WebGLRenderer#renderLists
			 * @type {Object}
			 */ _this.renderLists = renderLists;
            /**
			 * Interface for managing shadows.
			 *
			 * @name WebGLRenderer#shadowMap
			 * @type {WebGLRenderer~ShadowMap}
			 */ _this.shadowMap = shadowMap;
            /**
			 * Interface for managing the WebGL state.
			 *
			 * @name WebGLRenderer#state
			 * @type {Object}
			 */ _this.state = state;
            /**
			 * Holds a series of statistical information about the GPU memory
			 * and the rendering process. Useful for debugging and monitoring.
			 *
			 * By default these data are reset at each render call but when having
			 * multiple render passes per frame (e.g. when using post processing) it can
			 * be preferred to reset with a custom pattern. First, set `autoReset` to
			 * `false`.
			 * ```js
			 * renderer.info.autoReset = false;
			 * ```
			 * Call `reset()` whenever you have finished to render a single frame.
			 * ```js
			 * renderer.info.reset();
			 * ```
			 *
			 * @name WebGLRenderer#info
			 * @type {WebGLRenderer~Info}
			 */ _this.info = info;
        }
        initGLContext();
        // xr
        const xr = new $d5b33d7c30034067$var$WebXRManager(_this, _gl);
        /**
		 * A reference to the XR manager.
		 *
		 * @type {WebXRManager}
		 */ this.xr = xr;
        /**
		 * Returns the rendering context.
		 *
		 * @return {WebGL2RenderingContext} The rendering context.
		 */ this.getContext = function() {
            return _gl;
        };
        /**
		 * Returns the rendering context attributes.
		 *
		 * @return {WebGLContextAttributes} The rendering context attributes.
		 */ this.getContextAttributes = function() {
            return _gl.getContextAttributes();
        };
        /**
		 * Simulates a loss of the WebGL context. This requires support for the `WEBGL_lose_context` extension.
		 */ this.forceContextLoss = function() {
            const extension = extensions.get('WEBGL_lose_context');
            if (extension) extension.loseContext();
        };
        /**
		 * Simulates a restore of the WebGL context. This requires support for the `WEBGL_lose_context` extension.
		 */ this.forceContextRestore = function() {
            const extension = extensions.get('WEBGL_lose_context');
            if (extension) extension.restoreContext();
        };
        /**
		 * Returns the pixel ratio.
		 *
		 * @return {number} The pixel ratio.
		 */ this.getPixelRatio = function() {
            return _pixelRatio;
        };
        /**
		 * Sets the given pixel ratio and resizes the canvas if necessary.
		 *
		 * @param {number} value - The pixel ratio.
		 */ this.setPixelRatio = function(value) {
            if (value === undefined) return;
            _pixelRatio = value;
            this.setSize(_width, _height, false);
        };
        /**
		 * Returns the renderer's size in logical pixels. This method does not honor the pixel ratio.
		 *
		 * @param {Vector2} target - The method writes the result in this target object.
		 * @return {Vector2} The renderer's size in logical pixels.
		 */ this.getSize = function(target) {
            return target.set(_width, _height);
        };
        /**
		 * Resizes the output canvas to (width, height) with device pixel ratio taken
		 * into account, and also sets the viewport to fit that size, starting in (0,
		 * 0). Setting `updateStyle` to false prevents any style changes to the output canvas.
		 *
		 * @param {number} width - The width in logical pixels.
		 * @param {number} height - The height in logical pixels.
		 * @param {boolean} [updateStyle=true] - Whether to update the `style` attribute of the canvas or not.
		 */ this.setSize = function(width, height, updateStyle = true) {
            if (xr.isPresenting) {
                console.warn('THREE.WebGLRenderer: Can\'t change size while VR device is presenting.');
                return;
            }
            _width = width;
            _height = height;
            canvas.width = Math.floor(width * _pixelRatio);
            canvas.height = Math.floor(height * _pixelRatio);
            if (updateStyle === true) {
                canvas.style.width = width + 'px';
                canvas.style.height = height + 'px';
            }
            this.setViewport(0, 0, width, height);
        };
        /**
		 * Returns the drawing buffer size in physical pixels. This method honors the pixel ratio.
		 *
		 * @param {Vector2} target - The method writes the result in this target object.
		 * @return {Vector2} The drawing buffer size.
		 */ this.getDrawingBufferSize = function(target) {
            return target.set(_width * _pixelRatio, _height * _pixelRatio).floor();
        };
        /**
		 * This method allows to define the drawing buffer size by specifying
		 * width, height and pixel ratio all at once. The size of the drawing
		 * buffer is computed with this formula:
		 * ```js
		 * size.x = width * pixelRatio;
		 * size.y = height * pixelRatio;
		 * ```
		 *
		 * @param {number} width - The width in logical pixels.
		 * @param {number} height - The height in logical pixels.
		 * @param {number} pixelRatio - The pixel ratio.
		 */ this.setDrawingBufferSize = function(width, height, pixelRatio) {
            _width = width;
            _height = height;
            _pixelRatio = pixelRatio;
            canvas.width = Math.floor(width * pixelRatio);
            canvas.height = Math.floor(height * pixelRatio);
            this.setViewport(0, 0, width, height);
        };
        /**
		 * Returns the current viewport definition.
		 *
		 * @param {Vector2} target - The method writes the result in this target object.
		 * @return {Vector2} The current viewport definition.
		 */ this.getCurrentViewport = function(target) {
            return target.copy(_currentViewport);
        };
        /**
		 * Returns the viewport definition.
		 *
		 * @param {Vector4} target - The method writes the result in this target object.
		 * @return {Vector4} The viewport definition.
		 */ this.getViewport = function(target) {
            return target.copy(_viewport);
        };
        /**
		 * Sets the viewport to render from `(x, y)` to `(x + width, y + height)`.
		 *
		 * @param {number | Vector4} x - The horizontal coordinate for the lower left corner of the viewport origin in logical pixel unit.
		 * Or alternatively a four-component vector specifying all the parameters of the viewport.
		 * @param {number} y - The vertical coordinate for the lower left corner of the viewport origin  in logical pixel unit.
		 * @param {number} width - The width of the viewport in logical pixel unit.
		 * @param {number} height - The height of the viewport in logical pixel unit.
		 */ this.setViewport = function(x, y, width, height) {
            if (x.isVector4) _viewport.set(x.x, x.y, x.z, x.w);
            else _viewport.set(x, y, width, height);
            state.viewport(_currentViewport.copy(_viewport).multiplyScalar(_pixelRatio).round());
        };
        /**
		 * Returns the scissor region.
		 *
		 * @param {Vector4} target - The method writes the result in this target object.
		 * @return {Vector4} The scissor region.
		 */ this.getScissor = function(target) {
            return target.copy(_scissor);
        };
        /**
		 * Sets the scissor region to render from `(x, y)` to `(x + width, y + height)`.
		 *
		 * @param {number | Vector4} x - The horizontal coordinate for the lower left corner of the scissor region origin in logical pixel unit.
		 * Or alternatively a four-component vector specifying all the parameters of the scissor region.
		 * @param {number} y - The vertical coordinate for the lower left corner of the scissor region origin  in logical pixel unit.
		 * @param {number} width - The width of the scissor region in logical pixel unit.
		 * @param {number} height - The height of the scissor region in logical pixel unit.
		 */ this.setScissor = function(x, y, width, height) {
            if (x.isVector4) _scissor.set(x.x, x.y, x.z, x.w);
            else _scissor.set(x, y, width, height);
            state.scissor(_currentScissor.copy(_scissor).multiplyScalar(_pixelRatio).round());
        };
        /**
		 * Returns `true` if the scissor test is enabled.
		 *
		 * @return {boolean} Whether the scissor test is enabled or not.
		 */ this.getScissorTest = function() {
            return _scissorTest;
        };
        /**
		 * Enable or disable the scissor test. When this is enabled, only the pixels
		 * within the defined scissor area will be affected by further renderer
		 * actions.
		 *
		 * @param {boolean} boolean - Whether the scissor test is enabled or not.
		 */ this.setScissorTest = function(boolean) {
            state.setScissorTest(_scissorTest = boolean);
        };
        /**
		 * Sets a custom opaque sort function for the render lists. Pass `null`
		 * to use the default `painterSortStable` function.
		 *
		 * @param {?Function} method - The opaque sort function.
		 */ this.setOpaqueSort = function(method) {
            _opaqueSort = method;
        };
        /**
		 * Sets a custom transparent sort function for the render lists. Pass `null`
		 * to use the default `reversePainterSortStable` function.
		 *
		 * @param {?Function} method - The opaque sort function.
		 */ this.setTransparentSort = function(method) {
            _transparentSort = method;
        };
        // Clearing
        /**
		 * Returns the clear color.
		 *
		 * @param {Color} target - The method writes the result in this target object.
		 * @return {Color} The clear color.
		 */ this.getClearColor = function(target) {
            return target.copy(background.getClearColor());
        };
        /**
		 * Sets the clear color and alpha.
		 *
		 * @param {Color} color - The clear color.
		 * @param {number} [alpha=1] - The clear alpha.
		 */ this.setClearColor = function() {
            background.setClearColor(...arguments);
        };
        /**
		 * Returns the clear alpha. Ranges within `[0,1]`.
		 *
		 * @return {number} The clear alpha.
		 */ this.getClearAlpha = function() {
            return background.getClearAlpha();
        };
        /**
		 * Sets the clear alpha.
		 *
		 * @param {number} alpha - The clear alpha.
		 */ this.setClearAlpha = function() {
            background.setClearAlpha(...arguments);
        };
        /**
		 * Tells the renderer to clear its color, depth or stencil drawing buffer(s).
		 * This method initializes the buffers to the current clear color values.
		 *
		 * @param {boolean} [color=true] - Whether the color buffer should be cleared or not.
		 * @param {boolean} [depth=true] - Whether the depth buffer should be cleared or not.
		 * @param {boolean} [stencil=true] - Whether the stencil buffer should be cleared or not.
		 */ this.clear = function(color = true, depth = true, stencil = true) {
            let bits = 0;
            if (color) {
                // check if we're trying to clear an integer target
                let isIntegerFormat = false;
                if (_currentRenderTarget !== null) {
                    const targetFormat = _currentRenderTarget.texture.format;
                    isIntegerFormat = targetFormat === (0, $dyjou.RGBAIntegerFormat) || targetFormat === (0, $dyjou.RGIntegerFormat) || targetFormat === (0, $dyjou.RedIntegerFormat);
                }
                // use the appropriate clear functions to clear the target if it's a signed
                // or unsigned integer target
                if (isIntegerFormat) {
                    const targetType = _currentRenderTarget.texture.type;
                    const isUnsignedType = targetType === (0, $dyjou.UnsignedByteType) || targetType === (0, $dyjou.UnsignedIntType) || targetType === (0, $dyjou.UnsignedShortType) || targetType === (0, $dyjou.UnsignedInt248Type) || targetType === (0, $dyjou.UnsignedShort4444Type) || targetType === (0, $dyjou.UnsignedShort5551Type);
                    const clearColor = background.getClearColor();
                    const a = background.getClearAlpha();
                    const r = clearColor.r;
                    const g = clearColor.g;
                    const b = clearColor.b;
                    if (isUnsignedType) {
                        uintClearColor[0] = r;
                        uintClearColor[1] = g;
                        uintClearColor[2] = b;
                        uintClearColor[3] = a;
                        _gl.clearBufferuiv(_gl.COLOR, 0, uintClearColor);
                    } else {
                        intClearColor[0] = r;
                        intClearColor[1] = g;
                        intClearColor[2] = b;
                        intClearColor[3] = a;
                        _gl.clearBufferiv(_gl.COLOR, 0, intClearColor);
                    }
                } else bits |= _gl.COLOR_BUFFER_BIT;
            }
            if (depth) bits |= _gl.DEPTH_BUFFER_BIT;
            if (stencil) {
                bits |= _gl.STENCIL_BUFFER_BIT;
                this.state.buffers.stencil.setMask(0xffffffff);
            }
            _gl.clear(bits);
        };
        /**
		 * Clears the color buffer. Equivalent to calling `renderer.clear( true, false, false )`.
		 */ this.clearColor = function() {
            this.clear(true, false, false);
        };
        /**
		 * Clears the depth buffer. Equivalent to calling `renderer.clear( false, true, false )`.
		 */ this.clearDepth = function() {
            this.clear(false, true, false);
        };
        /**
		 * Clears the stencil buffer. Equivalent to calling `renderer.clear( false, false, true )`.
		 */ this.clearStencil = function() {
            this.clear(false, false, true);
        };
        /**
		 * Frees the GPU-related resources allocated by this instance. Call this
		 * method whenever this instance is no longer used in your app.
		 */ this.dispose = function() {
            canvas.removeEventListener('webglcontextlost', onContextLost, false);
            canvas.removeEventListener('webglcontextrestored', onContextRestore, false);
            canvas.removeEventListener('webglcontextcreationerror', onContextCreationError, false);
            background.dispose();
            renderLists.dispose();
            renderStates.dispose();
            properties.dispose();
            cubemaps.dispose();
            cubeuvmaps.dispose();
            objects.dispose();
            bindingStates.dispose();
            uniformsGroups.dispose();
            programCache.dispose();
            xr.dispose();
            xr.removeEventListener('sessionstart', onXRSessionStart);
            xr.removeEventListener('sessionend', onXRSessionEnd);
            animation.stop();
        };
        // Events
        function onContextLost(event) {
            event.preventDefault();
            console.log('THREE.WebGLRenderer: Context Lost.');
            _isContextLost = true;
        }
        function onContextRestore() {
            console.log('THREE.WebGLRenderer: Context Restored.');
            _isContextLost = false;
            const infoAutoReset = info.autoReset;
            const shadowMapEnabled = shadowMap.enabled;
            const shadowMapAutoUpdate = shadowMap.autoUpdate;
            const shadowMapNeedsUpdate = shadowMap.needsUpdate;
            const shadowMapType = shadowMap.type;
            initGLContext();
            info.autoReset = infoAutoReset;
            shadowMap.enabled = shadowMapEnabled;
            shadowMap.autoUpdate = shadowMapAutoUpdate;
            shadowMap.needsUpdate = shadowMapNeedsUpdate;
            shadowMap.type = shadowMapType;
        }
        function onContextCreationError(event) {
            console.error('THREE.WebGLRenderer: A WebGL context could not be created. Reason: ', event.statusMessage);
        }
        function onMaterialDispose(event) {
            const material = event.target;
            material.removeEventListener('dispose', onMaterialDispose);
            deallocateMaterial(material);
        }
        // Buffer deallocation
        function deallocateMaterial(material) {
            releaseMaterialProgramReferences(material);
            properties.remove(material);
        }
        function releaseMaterialProgramReferences(material) {
            const programs = properties.get(material).programs;
            if (programs !== undefined) {
                programs.forEach(function(program) {
                    programCache.releaseProgram(program);
                });
                if (material.isShaderMaterial) programCache.releaseShaderCache(material);
            }
        }
        // Buffer rendering
        this.renderBufferDirect = function(camera, scene, geometry, material, object, group) {
            if (scene === null) scene = _emptyScene; // renderBufferDirect second parameter used to be fog (could be null)
            const frontFaceCW = object.isMesh && object.matrixWorld.determinant() < 0;
            const program = setProgram(camera, scene, geometry, material, object);
            state.setMaterial(material, frontFaceCW);
            //
            let index = geometry.index;
            let rangeFactor = 1;
            if (material.wireframe === true) {
                index = geometries.getWireframeAttribute(geometry);
                if (index === undefined) return;
                rangeFactor = 2;
            }
            //
            const drawRange = geometry.drawRange;
            const position = geometry.attributes.position;
            let drawStart = drawRange.start * rangeFactor;
            let drawEnd = (drawRange.start + drawRange.count) * rangeFactor;
            if (group !== null) {
                drawStart = Math.max(drawStart, group.start * rangeFactor);
                drawEnd = Math.min(drawEnd, (group.start + group.count) * rangeFactor);
            }
            if (index !== null) {
                drawStart = Math.max(drawStart, 0);
                drawEnd = Math.min(drawEnd, index.count);
            } else if (position !== undefined && position !== null) {
                drawStart = Math.max(drawStart, 0);
                drawEnd = Math.min(drawEnd, position.count);
            }
            const drawCount = drawEnd - drawStart;
            if (drawCount < 0 || drawCount === Infinity) return;
            //
            bindingStates.setup(object, material, program, geometry, index);
            let attribute;
            let renderer = bufferRenderer;
            if (index !== null) {
                attribute = attributes.get(index);
                renderer = indexedBufferRenderer;
                renderer.setIndex(attribute);
            }
            //
            if (object.isMesh) {
                if (material.wireframe === true) {
                    state.setLineWidth(material.wireframeLinewidth * getTargetPixelRatio());
                    renderer.setMode(_gl.LINES);
                } else renderer.setMode(_gl.TRIANGLES);
            } else if (object.isLine) {
                let lineWidth = material.linewidth;
                if (lineWidth === undefined) lineWidth = 1; // Not using Line*Material
                state.setLineWidth(lineWidth * getTargetPixelRatio());
                if (object.isLineSegments) renderer.setMode(_gl.LINES);
                else if (object.isLineLoop) renderer.setMode(_gl.LINE_LOOP);
                else renderer.setMode(_gl.LINE_STRIP);
            } else if (object.isPoints) renderer.setMode(_gl.POINTS);
            else if (object.isSprite) renderer.setMode(_gl.TRIANGLES);
            if (object.isBatchedMesh) {
                if (object._multiDrawInstances !== null) {
                    // @deprecated, r174
                    (0, $dyjou.warnOnce)('THREE.WebGLRenderer: renderMultiDrawInstances has been deprecated and will be removed in r184. Append to renderMultiDraw arguments and use indirection.');
                    renderer.renderMultiDrawInstances(object._multiDrawStarts, object._multiDrawCounts, object._multiDrawCount, object._multiDrawInstances);
                } else if (!extensions.get('WEBGL_multi_draw')) {
                    const starts = object._multiDrawStarts;
                    const counts = object._multiDrawCounts;
                    const drawCount = object._multiDrawCount;
                    const bytesPerElement = index ? attributes.get(index).bytesPerElement : 1;
                    const uniforms = properties.get(material).currentProgram.getUniforms();
                    for(let i = 0; i < drawCount; i++){
                        uniforms.setValue(_gl, '_gl_DrawID', i);
                        renderer.render(starts[i] / bytesPerElement, counts[i]);
                    }
                } else renderer.renderMultiDraw(object._multiDrawStarts, object._multiDrawCounts, object._multiDrawCount);
            } else if (object.isInstancedMesh) renderer.renderInstances(drawStart, drawCount, object.count);
            else if (geometry.isInstancedBufferGeometry) {
                const maxInstanceCount = geometry._maxInstanceCount !== undefined ? geometry._maxInstanceCount : Infinity;
                const instanceCount = Math.min(geometry.instanceCount, maxInstanceCount);
                renderer.renderInstances(drawStart, drawCount, instanceCount);
            } else renderer.render(drawStart, drawCount);
        };
        // Compile
        function prepareMaterial(material, scene, object) {
            if (material.transparent === true && material.side === (0, $dyjou.DoubleSide) && material.forceSinglePass === false) {
                material.side = (0, $dyjou.BackSide);
                material.needsUpdate = true;
                getProgram(material, scene, object);
                material.side = (0, $dyjou.FrontSide);
                material.needsUpdate = true;
                getProgram(material, scene, object);
                material.side = (0, $dyjou.DoubleSide);
            } else getProgram(material, scene, object);
        }
        /**
		 * Compiles all materials in the scene with the camera. This is useful to precompile shaders
		 * before the first rendering. If you want to add a 3D object to an existing scene, use the third
		 * optional parameter for applying the target scene.
		 *
		 * Note that the (target) scene's lighting and environment must be configured before calling this method.
		 *
		 * @param {Object3D} scene - The scene or another type of 3D object to precompile.
		 * @param {Camera} camera - The camera.
		 * @param {?Scene} [targetScene=null] - The target scene.
		 * @return {?Set} The precompiled materials.
		 */ this.compile = function(scene, camera, targetScene = null) {
            if (targetScene === null) targetScene = scene;
            currentRenderState = renderStates.get(targetScene);
            currentRenderState.init(camera);
            renderStateStack.push(currentRenderState);
            // gather lights from both the target scene and the new object that will be added to the scene.
            targetScene.traverseVisible(function(object) {
                if (object.isLight && object.layers.test(camera.layers)) {
                    currentRenderState.pushLight(object);
                    if (object.castShadow) currentRenderState.pushShadow(object);
                }
            });
            if (scene !== targetScene) scene.traverseVisible(function(object) {
                if (object.isLight && object.layers.test(camera.layers)) {
                    currentRenderState.pushLight(object);
                    if (object.castShadow) currentRenderState.pushShadow(object);
                }
            });
            currentRenderState.setupLights();
            // Only initialize materials in the new scene, not the targetScene.
            const materials = new Set();
            scene.traverse(function(object) {
                if (!(object.isMesh || object.isPoints || object.isLine || object.isSprite)) return;
                const material = object.material;
                if (material) {
                    if (Array.isArray(material)) for(let i = 0; i < material.length; i++){
                        const material2 = material[i];
                        prepareMaterial(material2, targetScene, object);
                        materials.add(material2);
                    }
                    else {
                        prepareMaterial(material, targetScene, object);
                        materials.add(material);
                    }
                }
            });
            currentRenderState = renderStateStack.pop();
            return materials;
        };
        // compileAsync
        /**
		 * Asynchronous version of {@link WebGLRenderer#compile}.
		 *
		 * This method makes use of the `KHR_parallel_shader_compile` WebGL extension. Hence,
		 * it is recommended to use this version of `compile()` whenever possible.
		 *
		 * @async
		 * @param {Object3D} scene - The scene or another type of 3D object to precompile.
		 * @param {Camera} camera - The camera.
		 * @param {?Scene} [targetScene=null] - The target scene.
		 * @return {Promise} A Promise that resolves when the given scene can be rendered without unnecessary stalling due to shader compilation.
		 */ this.compileAsync = function(scene, camera, targetScene = null) {
            const materials = this.compile(scene, camera, targetScene);
            // Wait for all the materials in the new object to indicate that they're
            // ready to be used before resolving the promise.
            return new Promise((resolve)=>{
                function checkMaterialsReady() {
                    materials.forEach(function(material) {
                        const materialProperties = properties.get(material);
                        const program = materialProperties.currentProgram;
                        if (program.isReady()) // remove any programs that report they're ready to use from the list
                        materials.delete(material);
                    });
                    // once the list of compiling materials is empty, call the callback
                    if (materials.size === 0) {
                        resolve(scene);
                        return;
                    }
                    // if some materials are still not ready, wait a bit and check again
                    setTimeout(checkMaterialsReady, 10);
                }
                if (extensions.get('KHR_parallel_shader_compile') !== null) // If we can check the compilation status of the materials without
                // blocking then do so right away.
                checkMaterialsReady();
                else // Otherwise start by waiting a bit to give the materials we just
                // initialized a chance to finish.
                setTimeout(checkMaterialsReady, 10);
            });
        };
        // Animation Loop
        let onAnimationFrameCallback = null;
        function onAnimationFrame(time) {
            if (onAnimationFrameCallback) onAnimationFrameCallback(time);
        }
        function onXRSessionStart() {
            animation.stop();
        }
        function onXRSessionEnd() {
            animation.start();
        }
        const animation = new $d5b33d7c30034067$var$WebGLAnimation();
        animation.setAnimationLoop(onAnimationFrame);
        if (typeof self !== 'undefined') animation.setContext(self);
        this.setAnimationLoop = function(callback) {
            onAnimationFrameCallback = callback;
            xr.setAnimationLoop(callback);
            callback === null ? animation.stop() : animation.start();
        };
        xr.addEventListener('sessionstart', onXRSessionStart);
        xr.addEventListener('sessionend', onXRSessionEnd);
        // Rendering
        /**
		 * Renders the given scene (or other type of 3D object) using the given camera.
		 *
		 * The render is done to a previously specified render target set by calling {@link WebGLRenderer#setRenderTarget}
		 * or to the canvas as usual.
		 *
		 * By default render buffers are cleared before rendering but you can prevent
		 * this by setting the property `autoClear` to `false`. If you want to prevent
		 * only certain buffers being cleared you can `autoClearColor`, `autoClearDepth`
		 * or `autoClearStencil` to `false`. To force a clear, use {@link WebGLRenderer#clear}.
		 *
		 * @param {Object3D} scene - The scene to render.
		 * @param {Camera} camera - The camera.
		 */ this.render = function(scene, camera) {
            if (camera !== undefined && camera.isCamera !== true) {
                console.error('THREE.WebGLRenderer.render: camera is not an instance of THREE.Camera.');
                return;
            }
            if (_isContextLost === true) return;
            // update scene graph
            if (scene.matrixWorldAutoUpdate === true) scene.updateMatrixWorld();
            // update camera matrices and frustum
            if (camera.parent === null && camera.matrixWorldAutoUpdate === true) camera.updateMatrixWorld();
            if (xr.enabled === true && xr.isPresenting === true) {
                if (xr.cameraAutoUpdate === true) xr.updateCamera(camera);
                camera = xr.getCamera(); // use XR camera for rendering
            }
            //
            if (scene.isScene === true) scene.onBeforeRender(_this, scene, camera, _currentRenderTarget);
            currentRenderState = renderStates.get(scene, renderStateStack.length);
            currentRenderState.init(camera);
            renderStateStack.push(currentRenderState);
            _projScreenMatrix.multiplyMatrices(camera.projectionMatrix, camera.matrixWorldInverse);
            _frustum.setFromProjectionMatrix(_projScreenMatrix);
            _localClippingEnabled = this.localClippingEnabled;
            _clippingEnabled = clipping.init(this.clippingPlanes, _localClippingEnabled);
            currentRenderList = renderLists.get(scene, renderListStack.length);
            currentRenderList.init();
            renderListStack.push(currentRenderList);
            if (xr.enabled === true && xr.isPresenting === true) {
                const depthSensingMesh = _this.xr.getDepthSensingMesh();
                if (depthSensingMesh !== null) projectObject(depthSensingMesh, camera, -Infinity, _this.sortObjects);
            }
            projectObject(scene, camera, 0, _this.sortObjects);
            currentRenderList.finish();
            if (_this.sortObjects === true) currentRenderList.sort(_opaqueSort, _transparentSort);
            _renderBackground = xr.enabled === false || xr.isPresenting === false || xr.hasDepthSensing() === false;
            if (_renderBackground) background.addToRenderList(currentRenderList, scene);
            //
            this.info.render.frame++;
            if (_clippingEnabled === true) clipping.beginShadows();
            const shadowsArray = currentRenderState.state.shadowsArray;
            shadowMap.render(shadowsArray, scene, camera);
            if (_clippingEnabled === true) clipping.endShadows();
            //
            if (this.info.autoReset === true) this.info.reset();
            // render scene
            const opaqueObjects = currentRenderList.opaque;
            const transmissiveObjects = currentRenderList.transmissive;
            currentRenderState.setupLights();
            if (camera.isArrayCamera) {
                const cameras = camera.cameras;
                if (transmissiveObjects.length > 0) for(let i = 0, l = cameras.length; i < l; i++){
                    const camera2 = cameras[i];
                    renderTransmissionPass(opaqueObjects, transmissiveObjects, scene, camera2);
                }
                if (_renderBackground) background.render(scene);
                for(let i = 0, l = cameras.length; i < l; i++){
                    const camera2 = cameras[i];
                    renderScene(currentRenderList, scene, camera2, camera2.viewport);
                }
            } else {
                if (transmissiveObjects.length > 0) renderTransmissionPass(opaqueObjects, transmissiveObjects, scene, camera);
                if (_renderBackground) background.render(scene);
                renderScene(currentRenderList, scene, camera);
            }
            //
            if (_currentRenderTarget !== null && _currentActiveMipmapLevel === 0) {
                // resolve multisample renderbuffers to a single-sample texture if necessary
                textures.updateMultisampleRenderTarget(_currentRenderTarget);
                // Generate mipmap if we're using any kind of mipmap filtering
                textures.updateRenderTargetMipmap(_currentRenderTarget);
            }
            //
            if (scene.isScene === true) scene.onAfterRender(_this, scene, camera);
            // _gl.finish();
            bindingStates.resetDefaultState();
            _currentMaterialId = -1;
            _currentCamera = null;
            renderStateStack.pop();
            if (renderStateStack.length > 0) {
                currentRenderState = renderStateStack[renderStateStack.length - 1];
                if (_clippingEnabled === true) clipping.setGlobalState(_this.clippingPlanes, currentRenderState.state.camera);
            } else currentRenderState = null;
            renderListStack.pop();
            if (renderListStack.length > 0) currentRenderList = renderListStack[renderListStack.length - 1];
            else currentRenderList = null;
        };
        function projectObject(object, camera, groupOrder, sortObjects) {
            if (object.visible === false) return;
            const visible = object.layers.test(camera.layers);
            if (visible) {
                if (object.isGroup) groupOrder = object.renderOrder;
                else if (object.isLOD) {
                    if (object.autoUpdate === true) object.update(camera);
                } else if (object.isLight) {
                    currentRenderState.pushLight(object);
                    if (object.castShadow) currentRenderState.pushShadow(object);
                } else if (object.isSprite) {
                    if (!object.frustumCulled || _frustum.intersectsSprite(object)) {
                        if (sortObjects) _vector4.setFromMatrixPosition(object.matrixWorld).applyMatrix4(_projScreenMatrix);
                        const geometry = objects.update(object);
                        const material = object.material;
                        if (material.visible) currentRenderList.push(object, geometry, material, groupOrder, _vector4.z, null);
                    }
                } else if (object.isMesh || object.isLine || object.isPoints) {
                    if (!object.frustumCulled || _frustum.intersectsObject(object)) {
                        const geometry = objects.update(object);
                        const material = object.material;
                        if (sortObjects) {
                            if (object.boundingSphere !== undefined) {
                                if (object.boundingSphere === null) object.computeBoundingSphere();
                                _vector4.copy(object.boundingSphere.center);
                            } else {
                                if (geometry.boundingSphere === null) geometry.computeBoundingSphere();
                                _vector4.copy(geometry.boundingSphere.center);
                            }
                            _vector4.applyMatrix4(object.matrixWorld).applyMatrix4(_projScreenMatrix);
                        }
                        if (Array.isArray(material)) {
                            const groups = geometry.groups;
                            for(let i = 0, l = groups.length; i < l; i++){
                                const group = groups[i];
                                const groupMaterial = material[group.materialIndex];
                                if (groupMaterial && groupMaterial.visible) currentRenderList.push(object, geometry, groupMaterial, groupOrder, _vector4.z, group);
                            }
                        } else if (material.visible) currentRenderList.push(object, geometry, material, groupOrder, _vector4.z, null);
                    }
                }
            }
            const children = object.children;
            for(let i = 0, l = children.length; i < l; i++)projectObject(children[i], camera, groupOrder, sortObjects);
        }
        function renderScene(currentRenderList, scene, camera, viewport) {
            const opaqueObjects = currentRenderList.opaque;
            const transmissiveObjects = currentRenderList.transmissive;
            const transparentObjects = currentRenderList.transparent;
            currentRenderState.setupLightsView(camera);
            if (_clippingEnabled === true) clipping.setGlobalState(_this.clippingPlanes, camera);
            if (viewport) state.viewport(_currentViewport.copy(viewport));
            if (opaqueObjects.length > 0) renderObjects(opaqueObjects, scene, camera);
            if (transmissiveObjects.length > 0) renderObjects(transmissiveObjects, scene, camera);
            if (transparentObjects.length > 0) renderObjects(transparentObjects, scene, camera);
            // Ensure depth buffer writing is enabled so it can be cleared on next render
            state.buffers.depth.setTest(true);
            state.buffers.depth.setMask(true);
            state.buffers.color.setMask(true);
            state.setPolygonOffset(false);
        }
        function renderTransmissionPass(opaqueObjects, transmissiveObjects, scene, camera) {
            const overrideMaterial = scene.isScene === true ? scene.overrideMaterial : null;
            if (overrideMaterial !== null) return;
            if (currentRenderState.state.transmissionRenderTarget[camera.id] === undefined) currentRenderState.state.transmissionRenderTarget[camera.id] = new (0, $dyjou.WebGLRenderTarget)(1, 1, {
                generateMipmaps: true,
                type: extensions.has('EXT_color_buffer_half_float') || extensions.has('EXT_color_buffer_float') ? (0, $dyjou.HalfFloatType) : (0, $dyjou.UnsignedByteType),
                minFilter: (0, $dyjou.LinearMipmapLinearFilter),
                samples: 4,
                stencilBuffer: stencil,
                resolveDepthBuffer: false,
                resolveStencilBuffer: false,
                colorSpace: (0, $dyjou.ColorManagement).workingColorSpace
            });
            const transmissionRenderTarget = currentRenderState.state.transmissionRenderTarget[camera.id];
            const activeViewport = camera.viewport || _currentViewport;
            transmissionRenderTarget.setSize(activeViewport.z * _this.transmissionResolutionScale, activeViewport.w * _this.transmissionResolutionScale);
            //
            const currentRenderTarget = _this.getRenderTarget();
            _this.setRenderTarget(transmissionRenderTarget);
            _this.getClearColor(_currentClearColor);
            _currentClearAlpha = _this.getClearAlpha();
            if (_currentClearAlpha < 1) _this.setClearColor(0xffffff, 0.5);
            _this.clear();
            if (_renderBackground) background.render(scene);
            // Turn off the features which can affect the frag color for opaque objects pass.
            // Otherwise they are applied twice in opaque objects pass and transmission objects pass.
            const currentToneMapping = _this.toneMapping;
            _this.toneMapping = (0, $dyjou.NoToneMapping);
            // Remove viewport from camera to avoid nested render calls resetting viewport to it (e.g Reflector).
            // Transmission render pass requires viewport to match the transmissionRenderTarget.
            const currentCameraViewport = camera.viewport;
            if (camera.viewport !== undefined) camera.viewport = undefined;
            currentRenderState.setupLightsView(camera);
            if (_clippingEnabled === true) clipping.setGlobalState(_this.clippingPlanes, camera);
            renderObjects(opaqueObjects, scene, camera);
            textures.updateMultisampleRenderTarget(transmissionRenderTarget);
            textures.updateRenderTargetMipmap(transmissionRenderTarget);
            if (extensions.has('WEBGL_multisampled_render_to_texture') === false) {
                let renderTargetNeedsUpdate = false;
                for(let i = 0, l = transmissiveObjects.length; i < l; i++){
                    const renderItem = transmissiveObjects[i];
                    const object = renderItem.object;
                    const geometry = renderItem.geometry;
                    const material = renderItem.material;
                    const group = renderItem.group;
                    if (material.side === (0, $dyjou.DoubleSide) && object.layers.test(camera.layers)) {
                        const currentSide = material.side;
                        material.side = (0, $dyjou.BackSide);
                        material.needsUpdate = true;
                        renderObject(object, scene, camera, geometry, material, group);
                        material.side = currentSide;
                        material.needsUpdate = true;
                        renderTargetNeedsUpdate = true;
                    }
                }
                if (renderTargetNeedsUpdate === true) {
                    textures.updateMultisampleRenderTarget(transmissionRenderTarget);
                    textures.updateRenderTargetMipmap(transmissionRenderTarget);
                }
            }
            _this.setRenderTarget(currentRenderTarget);
            _this.setClearColor(_currentClearColor, _currentClearAlpha);
            if (currentCameraViewport !== undefined) camera.viewport = currentCameraViewport;
            _this.toneMapping = currentToneMapping;
        }
        function renderObjects(renderList, scene, camera) {
            const overrideMaterial = scene.isScene === true ? scene.overrideMaterial : null;
            for(let i = 0, l = renderList.length; i < l; i++){
                const renderItem = renderList[i];
                const object = renderItem.object;
                const geometry = renderItem.geometry;
                const group = renderItem.group;
                let material = renderItem.material;
                if (material.allowOverride === true && overrideMaterial !== null) material = overrideMaterial;
                if (object.layers.test(camera.layers)) renderObject(object, scene, camera, geometry, material, group);
            }
        }
        function renderObject(object, scene, camera, geometry, material, group) {
            object.onBeforeRender(_this, scene, camera, geometry, material, group);
            object.modelViewMatrix.multiplyMatrices(camera.matrixWorldInverse, object.matrixWorld);
            object.normalMatrix.getNormalMatrix(object.modelViewMatrix);
            material.onBeforeRender(_this, scene, camera, geometry, object, group);
            if (material.transparent === true && material.side === (0, $dyjou.DoubleSide) && material.forceSinglePass === false) {
                material.side = (0, $dyjou.BackSide);
                material.needsUpdate = true;
                _this.renderBufferDirect(camera, scene, geometry, material, object, group);
                material.side = (0, $dyjou.FrontSide);
                material.needsUpdate = true;
                _this.renderBufferDirect(camera, scene, geometry, material, object, group);
                material.side = (0, $dyjou.DoubleSide);
            } else _this.renderBufferDirect(camera, scene, geometry, material, object, group);
            object.onAfterRender(_this, scene, camera, geometry, material, group);
        }
        function getProgram(material, scene, object) {
            if (scene.isScene !== true) scene = _emptyScene; // scene could be a Mesh, Line, Points, ...
            const materialProperties = properties.get(material);
            const lights = currentRenderState.state.lights;
            const shadowsArray = currentRenderState.state.shadowsArray;
            const lightsStateVersion = lights.state.version;
            const parameters = programCache.getParameters(material, lights.state, shadowsArray, scene, object);
            const programCacheKey = programCache.getProgramCacheKey(parameters);
            let programs = materialProperties.programs;
            // always update environment and fog - changing these trigger an getProgram call, but it's possible that the program doesn't change
            materialProperties.environment = material.isMeshStandardMaterial ? scene.environment : null;
            materialProperties.fog = scene.fog;
            materialProperties.envMap = (material.isMeshStandardMaterial ? cubeuvmaps : cubemaps).get(material.envMap || materialProperties.environment);
            materialProperties.envMapRotation = materialProperties.environment !== null && material.envMap === null ? scene.environmentRotation : material.envMapRotation;
            if (programs === undefined) {
                // new material
                material.addEventListener('dispose', onMaterialDispose);
                programs = new Map();
                materialProperties.programs = programs;
            }
            let program = programs.get(programCacheKey);
            if (program !== undefined) // early out if program and light state is identical
            {
                if (materialProperties.currentProgram === program && materialProperties.lightsStateVersion === lightsStateVersion) {
                    updateCommonMaterialProperties(material, parameters);
                    return program;
                }
            } else {
                parameters.uniforms = programCache.getUniforms(material);
                material.onBeforeCompile(parameters, _this);
                program = programCache.acquireProgram(parameters, programCacheKey);
                programs.set(programCacheKey, program);
                materialProperties.uniforms = parameters.uniforms;
            }
            const uniforms = materialProperties.uniforms;
            if (!material.isShaderMaterial && !material.isRawShaderMaterial || material.clipping === true) uniforms.clippingPlanes = clipping.uniform;
            updateCommonMaterialProperties(material, parameters);
            // store the light setup it was created for
            materialProperties.needsLights = materialNeedsLights(material);
            materialProperties.lightsStateVersion = lightsStateVersion;
            if (materialProperties.needsLights) {
                // wire up the material to this renderer's lighting state
                uniforms.ambientLightColor.value = lights.state.ambient;
                uniforms.lightProbe.value = lights.state.probe;
                uniforms.directionalLights.value = lights.state.directional;
                uniforms.directionalLightShadows.value = lights.state.directionalShadow;
                uniforms.spotLights.value = lights.state.spot;
                uniforms.spotLightShadows.value = lights.state.spotShadow;
                uniforms.rectAreaLights.value = lights.state.rectArea;
                uniforms.ltc_1.value = lights.state.rectAreaLTC1;
                uniforms.ltc_2.value = lights.state.rectAreaLTC2;
                uniforms.pointLights.value = lights.state.point;
                uniforms.pointLightShadows.value = lights.state.pointShadow;
                uniforms.hemisphereLights.value = lights.state.hemi;
                uniforms.directionalShadowMap.value = lights.state.directionalShadowMap;
                uniforms.directionalShadowMatrix.value = lights.state.directionalShadowMatrix;
                uniforms.spotShadowMap.value = lights.state.spotShadowMap;
                uniforms.spotLightMatrix.value = lights.state.spotLightMatrix;
                uniforms.spotLightMap.value = lights.state.spotLightMap;
                uniforms.pointShadowMap.value = lights.state.pointShadowMap;
                uniforms.pointShadowMatrix.value = lights.state.pointShadowMatrix;
            // TODO (abelnation): add area lights shadow info to uniforms
            }
            materialProperties.currentProgram = program;
            materialProperties.uniformsList = null;
            return program;
        }
        function getUniformList(materialProperties) {
            if (materialProperties.uniformsList === null) {
                const progUniforms = materialProperties.currentProgram.getUniforms();
                materialProperties.uniformsList = $d5b33d7c30034067$var$WebGLUniforms.seqWithValue(progUniforms.seq, materialProperties.uniforms);
            }
            return materialProperties.uniformsList;
        }
        function updateCommonMaterialProperties(material, parameters) {
            const materialProperties = properties.get(material);
            materialProperties.outputColorSpace = parameters.outputColorSpace;
            materialProperties.batching = parameters.batching;
            materialProperties.batchingColor = parameters.batchingColor;
            materialProperties.instancing = parameters.instancing;
            materialProperties.instancingColor = parameters.instancingColor;
            materialProperties.instancingMorph = parameters.instancingMorph;
            materialProperties.skinning = parameters.skinning;
            materialProperties.morphTargets = parameters.morphTargets;
            materialProperties.morphNormals = parameters.morphNormals;
            materialProperties.morphColors = parameters.morphColors;
            materialProperties.morphTargetsCount = parameters.morphTargetsCount;
            materialProperties.numClippingPlanes = parameters.numClippingPlanes;
            materialProperties.numIntersection = parameters.numClipIntersection;
            materialProperties.vertexAlphas = parameters.vertexAlphas;
            materialProperties.vertexTangents = parameters.vertexTangents;
            materialProperties.toneMapping = parameters.toneMapping;
        }
        function setProgram(camera, scene, geometry, material, object) {
            if (scene.isScene !== true) scene = _emptyScene; // scene could be a Mesh, Line, Points, ...
            textures.resetTextureUnits();
            const fog = scene.fog;
            const environment = material.isMeshStandardMaterial ? scene.environment : null;
            const colorSpace = _currentRenderTarget === null ? _this.outputColorSpace : _currentRenderTarget.isXRRenderTarget === true ? _currentRenderTarget.texture.colorSpace : (0, $dyjou.LinearSRGBColorSpace);
            const envMap = (material.isMeshStandardMaterial ? cubeuvmaps : cubemaps).get(material.envMap || environment);
            const vertexAlphas = material.vertexColors === true && !!geometry.attributes.color && geometry.attributes.color.itemSize === 4;
            const vertexTangents = !!geometry.attributes.tangent && (!!material.normalMap || material.anisotropy > 0);
            const morphTargets = !!geometry.morphAttributes.position;
            const morphNormals = !!geometry.morphAttributes.normal;
            const morphColors = !!geometry.morphAttributes.color;
            let toneMapping = (0, $dyjou.NoToneMapping);
            if (material.toneMapped) {
                if (_currentRenderTarget === null || _currentRenderTarget.isXRRenderTarget === true) toneMapping = _this.toneMapping;
            }
            const morphAttribute = geometry.morphAttributes.position || geometry.morphAttributes.normal || geometry.morphAttributes.color;
            const morphTargetsCount = morphAttribute !== undefined ? morphAttribute.length : 0;
            const materialProperties = properties.get(material);
            const lights = currentRenderState.state.lights;
            if (_clippingEnabled === true) {
                if (_localClippingEnabled === true || camera !== _currentCamera) {
                    const useCache = camera === _currentCamera && material.id === _currentMaterialId;
                    // we might want to call this function with some ClippingGroup
                    // object instead of the material, once it becomes feasible
                    // (#8465, #8379)
                    clipping.setState(material, camera, useCache);
                }
            }
            //
            let needsProgramChange = false;
            if (material.version === materialProperties.__version) {
                if (materialProperties.needsLights && materialProperties.lightsStateVersion !== lights.state.version) needsProgramChange = true;
                else if (materialProperties.outputColorSpace !== colorSpace) needsProgramChange = true;
                else if (object.isBatchedMesh && materialProperties.batching === false) needsProgramChange = true;
                else if (!object.isBatchedMesh && materialProperties.batching === true) needsProgramChange = true;
                else if (object.isBatchedMesh && materialProperties.batchingColor === true && object.colorTexture === null) needsProgramChange = true;
                else if (object.isBatchedMesh && materialProperties.batchingColor === false && object.colorTexture !== null) needsProgramChange = true;
                else if (object.isInstancedMesh && materialProperties.instancing === false) needsProgramChange = true;
                else if (!object.isInstancedMesh && materialProperties.instancing === true) needsProgramChange = true;
                else if (object.isSkinnedMesh && materialProperties.skinning === false) needsProgramChange = true;
                else if (!object.isSkinnedMesh && materialProperties.skinning === true) needsProgramChange = true;
                else if (object.isInstancedMesh && materialProperties.instancingColor === true && object.instanceColor === null) needsProgramChange = true;
                else if (object.isInstancedMesh && materialProperties.instancingColor === false && object.instanceColor !== null) needsProgramChange = true;
                else if (object.isInstancedMesh && materialProperties.instancingMorph === true && object.morphTexture === null) needsProgramChange = true;
                else if (object.isInstancedMesh && materialProperties.instancingMorph === false && object.morphTexture !== null) needsProgramChange = true;
                else if (materialProperties.envMap !== envMap) needsProgramChange = true;
                else if (material.fog === true && materialProperties.fog !== fog) needsProgramChange = true;
                else if (materialProperties.numClippingPlanes !== undefined && (materialProperties.numClippingPlanes !== clipping.numPlanes || materialProperties.numIntersection !== clipping.numIntersection)) needsProgramChange = true;
                else if (materialProperties.vertexAlphas !== vertexAlphas) needsProgramChange = true;
                else if (materialProperties.vertexTangents !== vertexTangents) needsProgramChange = true;
                else if (materialProperties.morphTargets !== morphTargets) needsProgramChange = true;
                else if (materialProperties.morphNormals !== morphNormals) needsProgramChange = true;
                else if (materialProperties.morphColors !== morphColors) needsProgramChange = true;
                else if (materialProperties.toneMapping !== toneMapping) needsProgramChange = true;
                else if (materialProperties.morphTargetsCount !== morphTargetsCount) needsProgramChange = true;
            } else {
                needsProgramChange = true;
                materialProperties.__version = material.version;
            }
            //
            let program = materialProperties.currentProgram;
            if (needsProgramChange === true) program = getProgram(material, scene, object);
            let refreshProgram = false;
            let refreshMaterial = false;
            let refreshLights = false;
            const p_uniforms = program.getUniforms(), m_uniforms = materialProperties.uniforms;
            if (state.useProgram(program.program)) {
                refreshProgram = true;
                refreshMaterial = true;
                refreshLights = true;
            }
            if (material.id !== _currentMaterialId) {
                _currentMaterialId = material.id;
                refreshMaterial = true;
            }
            if (refreshProgram || _currentCamera !== camera) {
                // common camera uniforms
                const reverseDepthBuffer = state.buffers.depth.getReversed();
                if (reverseDepthBuffer) {
                    _currentProjectionMatrix.copy(camera.projectionMatrix);
                    (0, $dyjou.toNormalizedProjectionMatrix)(_currentProjectionMatrix);
                    (0, $dyjou.toReversedProjectionMatrix)(_currentProjectionMatrix);
                    p_uniforms.setValue(_gl, 'projectionMatrix', _currentProjectionMatrix);
                } else p_uniforms.setValue(_gl, 'projectionMatrix', camera.projectionMatrix);
                p_uniforms.setValue(_gl, 'viewMatrix', camera.matrixWorldInverse);
                const uCamPos = p_uniforms.map.cameraPosition;
                if (uCamPos !== undefined) uCamPos.setValue(_gl, _vector3.setFromMatrixPosition(camera.matrixWorld));
                if (capabilities.logarithmicDepthBuffer) p_uniforms.setValue(_gl, 'logDepthBufFC', 2.0 / (Math.log(camera.far + 1.0) / Math.LN2));
                // consider moving isOrthographic to UniformLib and WebGLMaterials, see https://github.com/mrdoob/three.js/pull/26467#issuecomment-1645185067
                if (material.isMeshPhongMaterial || material.isMeshToonMaterial || material.isMeshLambertMaterial || material.isMeshBasicMaterial || material.isMeshStandardMaterial || material.isShaderMaterial) p_uniforms.setValue(_gl, 'isOrthographic', camera.isOrthographicCamera === true);
                if (_currentCamera !== camera) {
                    _currentCamera = camera;
                    // lighting uniforms depend on the camera so enforce an update
                    // now, in case this material supports lights - or later, when
                    // the next material that does gets activated:
                    refreshMaterial = true; // set to true on material change
                    refreshLights = true; // remains set until update done
                }
            }
            // skinning and morph target uniforms must be set even if material didn't change
            // auto-setting of texture unit for bone and morph texture must go before other textures
            // otherwise textures used for skinning and morphing can take over texture units reserved for other material textures
            if (object.isSkinnedMesh) {
                p_uniforms.setOptional(_gl, object, 'bindMatrix');
                p_uniforms.setOptional(_gl, object, 'bindMatrixInverse');
                const skeleton = object.skeleton;
                if (skeleton) {
                    if (skeleton.boneTexture === null) skeleton.computeBoneTexture();
                    p_uniforms.setValue(_gl, 'boneTexture', skeleton.boneTexture, textures);
                }
            }
            if (object.isBatchedMesh) {
                p_uniforms.setOptional(_gl, object, 'batchingTexture');
                p_uniforms.setValue(_gl, 'batchingTexture', object._matricesTexture, textures);
                p_uniforms.setOptional(_gl, object, 'batchingIdTexture');
                p_uniforms.setValue(_gl, 'batchingIdTexture', object._indirectTexture, textures);
                p_uniforms.setOptional(_gl, object, 'batchingColorTexture');
                if (object._colorsTexture !== null) p_uniforms.setValue(_gl, 'batchingColorTexture', object._colorsTexture, textures);
            }
            const morphAttributes = geometry.morphAttributes;
            if (morphAttributes.position !== undefined || morphAttributes.normal !== undefined || morphAttributes.color !== undefined) morphtargets.update(object, geometry, program);
            if (refreshMaterial || materialProperties.receiveShadow !== object.receiveShadow) {
                materialProperties.receiveShadow = object.receiveShadow;
                p_uniforms.setValue(_gl, 'receiveShadow', object.receiveShadow);
            }
            // https://github.com/mrdoob/three.js/pull/24467#issuecomment-1209031512
            if (material.isMeshGouraudMaterial && material.envMap !== null) {
                m_uniforms.envMap.value = envMap;
                m_uniforms.flipEnvMap.value = envMap.isCubeTexture && envMap.isRenderTargetTexture === false ? -1 : 1;
            }
            if (material.isMeshStandardMaterial && material.envMap === null && scene.environment !== null) m_uniforms.envMapIntensity.value = scene.environmentIntensity;
            if (refreshMaterial) {
                p_uniforms.setValue(_gl, 'toneMappingExposure', _this.toneMappingExposure);
                if (materialProperties.needsLights) // the current material requires lighting info
                // note: all lighting uniforms are always set correctly
                // they simply reference the renderer's state for their
                // values
                //
                // use the current material's .needsUpdate flags to set
                // the GL state when required
                markUniformsLightsNeedsUpdate(m_uniforms, refreshLights);
                // refresh uniforms common to several materials
                if (fog && material.fog === true) materials.refreshFogUniforms(m_uniforms, fog);
                materials.refreshMaterialUniforms(m_uniforms, material, _pixelRatio, _height, currentRenderState.state.transmissionRenderTarget[camera.id]);
                $d5b33d7c30034067$var$WebGLUniforms.upload(_gl, getUniformList(materialProperties), m_uniforms, textures);
            }
            if (material.isShaderMaterial && material.uniformsNeedUpdate === true) {
                $d5b33d7c30034067$var$WebGLUniforms.upload(_gl, getUniformList(materialProperties), m_uniforms, textures);
                material.uniformsNeedUpdate = false;
            }
            if (material.isSpriteMaterial) p_uniforms.setValue(_gl, 'center', object.center);
            // common matrices
            p_uniforms.setValue(_gl, 'modelViewMatrix', object.modelViewMatrix);
            p_uniforms.setValue(_gl, 'normalMatrix', object.normalMatrix);
            p_uniforms.setValue(_gl, 'modelMatrix', object.matrixWorld);
            // UBOs
            if (material.isShaderMaterial || material.isRawShaderMaterial) {
                const groups = material.uniformsGroups;
                for(let i = 0, l = groups.length; i < l; i++){
                    const group = groups[i];
                    uniformsGroups.update(group, program);
                    uniformsGroups.bind(group, program);
                }
            }
            return program;
        }
        // If uniforms are marked as clean, they don't need to be loaded to the GPU.
        function markUniformsLightsNeedsUpdate(uniforms, value) {
            uniforms.ambientLightColor.needsUpdate = value;
            uniforms.lightProbe.needsUpdate = value;
            uniforms.directionalLights.needsUpdate = value;
            uniforms.directionalLightShadows.needsUpdate = value;
            uniforms.pointLights.needsUpdate = value;
            uniforms.pointLightShadows.needsUpdate = value;
            uniforms.spotLights.needsUpdate = value;
            uniforms.spotLightShadows.needsUpdate = value;
            uniforms.rectAreaLights.needsUpdate = value;
            uniforms.hemisphereLights.needsUpdate = value;
        }
        function materialNeedsLights(material) {
            return material.isMeshLambertMaterial || material.isMeshToonMaterial || material.isMeshPhongMaterial || material.isMeshStandardMaterial || material.isShadowMaterial || material.isShaderMaterial && material.lights === true;
        }
        /**
		 * Returns the active cube face.
		 *
		 * @return {number} The active cube face.
		 */ this.getActiveCubeFace = function() {
            return _currentActiveCubeFace;
        };
        /**
		 * Returns the active mipmap level.
		 *
		 * @return {number} The active mipmap level.
		 */ this.getActiveMipmapLevel = function() {
            return _currentActiveMipmapLevel;
        };
        /**
		 * Returns the active render target.
		 *
		 * @return {?WebGLRenderTarget} The active render target. Returns `null` if no render target
		 * is currently set.
		 */ this.getRenderTarget = function() {
            return _currentRenderTarget;
        };
        this.setRenderTargetTextures = function(renderTarget, colorTexture, depthTexture) {
            const renderTargetProperties = properties.get(renderTarget);
            renderTargetProperties.__autoAllocateDepthBuffer = renderTarget.resolveDepthBuffer === false;
            if (renderTargetProperties.__autoAllocateDepthBuffer === false) // The multisample_render_to_texture extension doesn't work properly if there
            // are midframe flushes and an external depth buffer. Disable use of the extension.
            renderTargetProperties.__useRenderToTexture = false;
            properties.get(renderTarget.texture).__webglTexture = colorTexture;
            properties.get(renderTarget.depthTexture).__webglTexture = renderTargetProperties.__autoAllocateDepthBuffer ? undefined : depthTexture;
            renderTargetProperties.__hasExternalTextures = true;
        };
        this.setRenderTargetFramebuffer = function(renderTarget, defaultFramebuffer) {
            const renderTargetProperties = properties.get(renderTarget);
            renderTargetProperties.__webglFramebuffer = defaultFramebuffer;
            renderTargetProperties.__useDefaultFramebuffer = defaultFramebuffer === undefined;
        };
        const _scratchFrameBuffer = _gl.createFramebuffer();
        /**
		 * Sets the active rendertarget.
		 *
		 * @param {?WebGLRenderTarget} renderTarget - The render target to set. When `null` is given,
		 * the canvas is set as the active render target instead.
		 * @param {number} [activeCubeFace=0] - The active cube face when using a cube render target.
		 * Indicates the z layer to render in to when using 3D or array render targets.
		 * @param {number} [activeMipmapLevel=0] - The active mipmap level.
		 */ this.setRenderTarget = function(renderTarget, activeCubeFace = 0, activeMipmapLevel = 0) {
            _currentRenderTarget = renderTarget;
            _currentActiveCubeFace = activeCubeFace;
            _currentActiveMipmapLevel = activeMipmapLevel;
            let useDefaultFramebuffer = true;
            let framebuffer = null;
            let isCube = false;
            let isRenderTarget3D = false;
            if (renderTarget) {
                const renderTargetProperties = properties.get(renderTarget);
                if (renderTargetProperties.__useDefaultFramebuffer !== undefined) {
                    // We need to make sure to rebind the framebuffer.
                    state.bindFramebuffer(_gl.FRAMEBUFFER, null);
                    useDefaultFramebuffer = false;
                } else if (renderTargetProperties.__webglFramebuffer === undefined) textures.setupRenderTarget(renderTarget);
                else if (renderTargetProperties.__hasExternalTextures) // Color and depth texture must be rebound in order for the swapchain to update.
                textures.rebindTextures(renderTarget, properties.get(renderTarget.texture).__webglTexture, properties.get(renderTarget.depthTexture).__webglTexture);
                else if (renderTarget.depthBuffer) {
                    // check if the depth texture is already bound to the frame buffer and that it's been initialized
                    const depthTexture = renderTarget.depthTexture;
                    if (renderTargetProperties.__boundDepthTexture !== depthTexture) {
                        // check if the depth texture is compatible
                        if (depthTexture !== null && properties.has(depthTexture) && (renderTarget.width !== depthTexture.image.width || renderTarget.height !== depthTexture.image.height)) throw new Error('WebGLRenderTarget: Attached DepthTexture is initialized to the incorrect size.');
                        // Swap the depth buffer to the currently attached one
                        textures.setupDepthRenderbuffer(renderTarget);
                    }
                }
                const texture = renderTarget.texture;
                if (texture.isData3DTexture || texture.isDataArrayTexture || texture.isCompressedArrayTexture) isRenderTarget3D = true;
                const __webglFramebuffer = properties.get(renderTarget).__webglFramebuffer;
                if (renderTarget.isWebGLCubeRenderTarget) {
                    if (Array.isArray(__webglFramebuffer[activeCubeFace])) framebuffer = __webglFramebuffer[activeCubeFace][activeMipmapLevel];
                    else framebuffer = __webglFramebuffer[activeCubeFace];
                    isCube = true;
                } else if (renderTarget.samples > 0 && textures.useMultisampledRTT(renderTarget) === false) framebuffer = properties.get(renderTarget).__webglMultisampledFramebuffer;
                else if (Array.isArray(__webglFramebuffer)) framebuffer = __webglFramebuffer[activeMipmapLevel];
                else framebuffer = __webglFramebuffer;
                _currentViewport.copy(renderTarget.viewport);
                _currentScissor.copy(renderTarget.scissor);
                _currentScissorTest = renderTarget.scissorTest;
            } else {
                _currentViewport.copy(_viewport).multiplyScalar(_pixelRatio).floor();
                _currentScissor.copy(_scissor).multiplyScalar(_pixelRatio).floor();
                _currentScissorTest = _scissorTest;
            }
            // Use a scratch frame buffer if rendering to a mip level to avoid depth buffers
            // being bound that are different sizes.
            if (activeMipmapLevel !== 0) framebuffer = _scratchFrameBuffer;
            const framebufferBound = state.bindFramebuffer(_gl.FRAMEBUFFER, framebuffer);
            if (framebufferBound && useDefaultFramebuffer) state.drawBuffers(renderTarget, framebuffer);
            state.viewport(_currentViewport);
            state.scissor(_currentScissor);
            state.setScissorTest(_currentScissorTest);
            if (isCube) {
                const textureProperties = properties.get(renderTarget.texture);
                _gl.framebufferTexture2D(_gl.FRAMEBUFFER, _gl.COLOR_ATTACHMENT0, _gl.TEXTURE_CUBE_MAP_POSITIVE_X + activeCubeFace, textureProperties.__webglTexture, activeMipmapLevel);
            } else if (isRenderTarget3D) {
                const textureProperties = properties.get(renderTarget.texture);
                const layer = activeCubeFace;
                _gl.framebufferTextureLayer(_gl.FRAMEBUFFER, _gl.COLOR_ATTACHMENT0, textureProperties.__webglTexture, activeMipmapLevel, layer);
            } else if (renderTarget !== null && activeMipmapLevel !== 0) {
                // Only bind the frame buffer if we are using a scratch frame buffer to render to a mipmap.
                // If we rebind the texture when using a multi sample buffer then an error about inconsistent samples will be thrown.
                const textureProperties = properties.get(renderTarget.texture);
                _gl.framebufferTexture2D(_gl.FRAMEBUFFER, _gl.COLOR_ATTACHMENT0, _gl.TEXTURE_2D, textureProperties.__webglTexture, activeMipmapLevel);
            }
            _currentMaterialId = -1; // reset current material to ensure correct uniform bindings
        };
        /**
		 * Reads the pixel data from the given render target into the given buffer.
		 *
		 * @param {WebGLRenderTarget} renderTarget - The render target to read from.
		 * @param {number} x - The `x` coordinate of the copy region's origin.
		 * @param {number} y - The `y` coordinate of the copy region's origin.
		 * @param {number} width - The width of the copy region.
		 * @param {number} height - The height of the copy region.
		 * @param {TypedArray} buffer - The result buffer.
		 * @param {number} [activeCubeFaceIndex] - The active cube face index.
		 */ this.readRenderTargetPixels = function(renderTarget, x, y, width, height, buffer, activeCubeFaceIndex) {
            if (!(renderTarget && renderTarget.isWebGLRenderTarget)) {
                console.error('THREE.WebGLRenderer.readRenderTargetPixels: renderTarget is not THREE.WebGLRenderTarget.');
                return;
            }
            let framebuffer = properties.get(renderTarget).__webglFramebuffer;
            if (renderTarget.isWebGLCubeRenderTarget && activeCubeFaceIndex !== undefined) framebuffer = framebuffer[activeCubeFaceIndex];
            if (framebuffer) {
                state.bindFramebuffer(_gl.FRAMEBUFFER, framebuffer);
                try {
                    const texture = renderTarget.texture;
                    const textureFormat = texture.format;
                    const textureType = texture.type;
                    if (!capabilities.textureFormatReadable(textureFormat)) {
                        console.error('THREE.WebGLRenderer.readRenderTargetPixels: renderTarget is not in RGBA or implementation defined format.');
                        return;
                    }
                    if (!capabilities.textureTypeReadable(textureType)) {
                        console.error('THREE.WebGLRenderer.readRenderTargetPixels: renderTarget is not in UnsignedByteType or implementation defined type.');
                        return;
                    }
                    // the following if statement ensures valid read requests (no out-of-bounds pixels, see #8604)
                    if (x >= 0 && x <= renderTarget.width - width && y >= 0 && y <= renderTarget.height - height) _gl.readPixels(x, y, width, height, utils.convert(textureFormat), utils.convert(textureType), buffer);
                } finally{
                    // restore framebuffer of current render target if necessary
                    const framebuffer = _currentRenderTarget !== null ? properties.get(_currentRenderTarget).__webglFramebuffer : null;
                    state.bindFramebuffer(_gl.FRAMEBUFFER, framebuffer);
                }
            }
        };
        /**
		 * Asynchronous, non-blocking version of {@link WebGLRenderer#readRenderTargetPixels}.
		 *
		 * It is recommended to use this version of `readRenderTargetPixels()` whenever possible.
		 *
		 * @async
		 * @param {WebGLRenderTarget} renderTarget - The render target to read from.
		 * @param {number} x - The `x` coordinate of the copy region's origin.
		 * @param {number} y - The `y` coordinate of the copy region's origin.
		 * @param {number} width - The width of the copy region.
		 * @param {number} height - The height of the copy region.
		 * @param {TypedArray} buffer - The result buffer.
		 * @param {number} [activeCubeFaceIndex] - The active cube face index.
		 * @return {Promise<TypedArray>} A Promise that resolves when the read has been finished. The resolve provides the read data as a typed array.
		 */ this.readRenderTargetPixelsAsync = async function(renderTarget, x, y, width, height, buffer, activeCubeFaceIndex) {
            if (!(renderTarget && renderTarget.isWebGLRenderTarget)) throw new Error('THREE.WebGLRenderer.readRenderTargetPixels: renderTarget is not THREE.WebGLRenderTarget.');
            let framebuffer = properties.get(renderTarget).__webglFramebuffer;
            if (renderTarget.isWebGLCubeRenderTarget && activeCubeFaceIndex !== undefined) framebuffer = framebuffer[activeCubeFaceIndex];
            if (framebuffer) {
                // the following if statement ensures valid read requests (no out-of-bounds pixels, see #8604)
                if (x >= 0 && x <= renderTarget.width - width && y >= 0 && y <= renderTarget.height - height) {
                    // set the active frame buffer to the one we want to read
                    state.bindFramebuffer(_gl.FRAMEBUFFER, framebuffer);
                    const texture = renderTarget.texture;
                    const textureFormat = texture.format;
                    const textureType = texture.type;
                    if (!capabilities.textureFormatReadable(textureFormat)) throw new Error('THREE.WebGLRenderer.readRenderTargetPixelsAsync: renderTarget is not in RGBA or implementation defined format.');
                    if (!capabilities.textureTypeReadable(textureType)) throw new Error('THREE.WebGLRenderer.readRenderTargetPixelsAsync: renderTarget is not in UnsignedByteType or implementation defined type.');
                    const glBuffer = _gl.createBuffer();
                    _gl.bindBuffer(_gl.PIXEL_PACK_BUFFER, glBuffer);
                    _gl.bufferData(_gl.PIXEL_PACK_BUFFER, buffer.byteLength, _gl.STREAM_READ);
                    _gl.readPixels(x, y, width, height, utils.convert(textureFormat), utils.convert(textureType), 0);
                    // reset the frame buffer to the currently set buffer before waiting
                    const currFramebuffer = _currentRenderTarget !== null ? properties.get(_currentRenderTarget).__webglFramebuffer : null;
                    state.bindFramebuffer(_gl.FRAMEBUFFER, currFramebuffer);
                    // check if the commands have finished every 8 ms
                    const sync = _gl.fenceSync(_gl.SYNC_GPU_COMMANDS_COMPLETE, 0);
                    _gl.flush();
                    await (0, $dyjou.probeAsync)(_gl, sync, 4);
                    // read the data and delete the buffer
                    _gl.bindBuffer(_gl.PIXEL_PACK_BUFFER, glBuffer);
                    _gl.getBufferSubData(_gl.PIXEL_PACK_BUFFER, 0, buffer);
                    _gl.deleteBuffer(glBuffer);
                    _gl.deleteSync(sync);
                    return buffer;
                } else throw new Error('THREE.WebGLRenderer.readRenderTargetPixelsAsync: requested read bounds are out of range.');
            }
        };
        /**
		 * Copies pixels from the current bound framebuffer into the given texture.
		 *
		 * @param {FramebufferTexture} texture - The texture.
		 * @param {Vector2} position - The start position of the copy operation.
		 * @param {number} [level=0] - The mip level. The default represents the base mip.
		 */ this.copyFramebufferToTexture = function(texture, position = null, level = 0) {
            const levelScale = Math.pow(2, -level);
            const width = Math.floor(texture.image.width * levelScale);
            const height = Math.floor(texture.image.height * levelScale);
            const x = position !== null ? position.x : 0;
            const y = position !== null ? position.y : 0;
            textures.setTexture2D(texture, 0);
            _gl.copyTexSubImage2D(_gl.TEXTURE_2D, level, 0, 0, x, y, width, height);
            state.unbindTexture();
        };
        const _srcFramebuffer = _gl.createFramebuffer();
        const _dstFramebuffer = _gl.createFramebuffer();
        /**
		 * Copies data of the given source texture into a destination texture.
		 *
		 * When using render target textures as `srcTexture` and `dstTexture`, you must make sure both render targets are initialized
		 * {@link WebGLRenderer#initRenderTarget}.
		 *
		 * @param {Texture} srcTexture - The source texture.
		 * @param {Texture} dstTexture - The destination texture.
		 * @param {Box2|Box3} [srcRegion=null] - A bounding box which describes the source region. Can be two or three-dimensional.
		 * @param {Vector2|Vector3} [dstPosition=null] - A vector that represents the origin of the destination region. Can be two or three-dimensional.
		 * @param {number} srcLevel - The source mipmap level to copy.
		 * @param {number} dstLevel - The destination mipmap level.
		 */ this.copyTextureToTexture = function(srcTexture, dstTexture, srcRegion = null, dstPosition = null, srcLevel = 0, dstLevel = null) {
            // support the previous signature with just a single dst mipmap level
            if (dstLevel === null) {
                if (srcLevel !== 0) {
                    // @deprecated, r171
                    (0, $dyjou.warnOnce)('WebGLRenderer: copyTextureToTexture function signature has changed to support src and dst mipmap levels.');
                    dstLevel = srcLevel;
                    srcLevel = 0;
                } else dstLevel = 0;
            }
            // gather the necessary dimensions to copy
            let width, height, depth, minX, minY, minZ;
            let dstX, dstY, dstZ;
            const image = srcTexture.isCompressedTexture ? srcTexture.mipmaps[dstLevel] : srcTexture.image;
            if (srcRegion !== null) {
                width = srcRegion.max.x - srcRegion.min.x;
                height = srcRegion.max.y - srcRegion.min.y;
                depth = srcRegion.isBox3 ? srcRegion.max.z - srcRegion.min.z : 1;
                minX = srcRegion.min.x;
                minY = srcRegion.min.y;
                minZ = srcRegion.isBox3 ? srcRegion.min.z : 0;
            } else {
                const levelScale = Math.pow(2, -srcLevel);
                width = Math.floor(image.width * levelScale);
                height = Math.floor(image.height * levelScale);
                if (srcTexture.isDataArrayTexture) depth = image.depth;
                else if (srcTexture.isData3DTexture) depth = Math.floor(image.depth * levelScale);
                else depth = 1;
                minX = 0;
                minY = 0;
                minZ = 0;
            }
            if (dstPosition !== null) {
                dstX = dstPosition.x;
                dstY = dstPosition.y;
                dstZ = dstPosition.z;
            } else {
                dstX = 0;
                dstY = 0;
                dstZ = 0;
            }
            // Set up the destination target
            const glFormat = utils.convert(dstTexture.format);
            const glType = utils.convert(dstTexture.type);
            let glTarget;
            if (dstTexture.isData3DTexture) {
                textures.setTexture3D(dstTexture, 0);
                glTarget = _gl.TEXTURE_3D;
            } else if (dstTexture.isDataArrayTexture || dstTexture.isCompressedArrayTexture) {
                textures.setTexture2DArray(dstTexture, 0);
                glTarget = _gl.TEXTURE_2D_ARRAY;
            } else {
                textures.setTexture2D(dstTexture, 0);
                glTarget = _gl.TEXTURE_2D;
            }
            _gl.pixelStorei(_gl.UNPACK_FLIP_Y_WEBGL, dstTexture.flipY);
            _gl.pixelStorei(_gl.UNPACK_PREMULTIPLY_ALPHA_WEBGL, dstTexture.premultiplyAlpha);
            _gl.pixelStorei(_gl.UNPACK_ALIGNMENT, dstTexture.unpackAlignment);
            // used for copying data from cpu
            const currentUnpackRowLen = _gl.getParameter(_gl.UNPACK_ROW_LENGTH);
            const currentUnpackImageHeight = _gl.getParameter(_gl.UNPACK_IMAGE_HEIGHT);
            const currentUnpackSkipPixels = _gl.getParameter(_gl.UNPACK_SKIP_PIXELS);
            const currentUnpackSkipRows = _gl.getParameter(_gl.UNPACK_SKIP_ROWS);
            const currentUnpackSkipImages = _gl.getParameter(_gl.UNPACK_SKIP_IMAGES);
            _gl.pixelStorei(_gl.UNPACK_ROW_LENGTH, image.width);
            _gl.pixelStorei(_gl.UNPACK_IMAGE_HEIGHT, image.height);
            _gl.pixelStorei(_gl.UNPACK_SKIP_PIXELS, minX);
            _gl.pixelStorei(_gl.UNPACK_SKIP_ROWS, minY);
            _gl.pixelStorei(_gl.UNPACK_SKIP_IMAGES, minZ);
            // set up the src texture
            const isSrc3D = srcTexture.isDataArrayTexture || srcTexture.isData3DTexture;
            const isDst3D = dstTexture.isDataArrayTexture || dstTexture.isData3DTexture;
            if (srcTexture.isDepthTexture) {
                const srcTextureProperties = properties.get(srcTexture);
                const dstTextureProperties = properties.get(dstTexture);
                const srcRenderTargetProperties = properties.get(srcTextureProperties.__renderTarget);
                const dstRenderTargetProperties = properties.get(dstTextureProperties.__renderTarget);
                state.bindFramebuffer(_gl.READ_FRAMEBUFFER, srcRenderTargetProperties.__webglFramebuffer);
                state.bindFramebuffer(_gl.DRAW_FRAMEBUFFER, dstRenderTargetProperties.__webglFramebuffer);
                for(let i = 0; i < depth; i++){
                    // if the source or destination are a 3d target then a layer needs to be bound
                    if (isSrc3D) {
                        _gl.framebufferTextureLayer(_gl.READ_FRAMEBUFFER, _gl.COLOR_ATTACHMENT0, properties.get(srcTexture).__webglTexture, srcLevel, minZ + i);
                        _gl.framebufferTextureLayer(_gl.DRAW_FRAMEBUFFER, _gl.COLOR_ATTACHMENT0, properties.get(dstTexture).__webglTexture, dstLevel, dstZ + i);
                    }
                    _gl.blitFramebuffer(minX, minY, width, height, dstX, dstY, width, height, _gl.DEPTH_BUFFER_BIT, _gl.NEAREST);
                }
                state.bindFramebuffer(_gl.READ_FRAMEBUFFER, null);
                state.bindFramebuffer(_gl.DRAW_FRAMEBUFFER, null);
            } else if (srcLevel !== 0 || srcTexture.isRenderTargetTexture || properties.has(srcTexture)) {
                // get the appropriate frame buffers
                const srcTextureProperties = properties.get(srcTexture);
                const dstTextureProperties = properties.get(dstTexture);
                // bind the frame buffer targets
                state.bindFramebuffer(_gl.READ_FRAMEBUFFER, _srcFramebuffer);
                state.bindFramebuffer(_gl.DRAW_FRAMEBUFFER, _dstFramebuffer);
                for(let i = 0; i < depth; i++){
                    // assign the correct layers and mip maps to the frame buffers
                    if (isSrc3D) _gl.framebufferTextureLayer(_gl.READ_FRAMEBUFFER, _gl.COLOR_ATTACHMENT0, srcTextureProperties.__webglTexture, srcLevel, minZ + i);
                    else _gl.framebufferTexture2D(_gl.READ_FRAMEBUFFER, _gl.COLOR_ATTACHMENT0, _gl.TEXTURE_2D, srcTextureProperties.__webglTexture, srcLevel);
                    if (isDst3D) _gl.framebufferTextureLayer(_gl.DRAW_FRAMEBUFFER, _gl.COLOR_ATTACHMENT0, dstTextureProperties.__webglTexture, dstLevel, dstZ + i);
                    else _gl.framebufferTexture2D(_gl.DRAW_FRAMEBUFFER, _gl.COLOR_ATTACHMENT0, _gl.TEXTURE_2D, dstTextureProperties.__webglTexture, dstLevel);
                    // copy the data using the fastest function that can achieve the copy
                    if (srcLevel !== 0) _gl.blitFramebuffer(minX, minY, width, height, dstX, dstY, width, height, _gl.COLOR_BUFFER_BIT, _gl.NEAREST);
                    else if (isDst3D) _gl.copyTexSubImage3D(glTarget, dstLevel, dstX, dstY, dstZ + i, minX, minY, width, height);
                    else _gl.copyTexSubImage2D(glTarget, dstLevel, dstX, dstY, minX, minY, width, height);
                }
                // unbind read, draw buffers
                state.bindFramebuffer(_gl.READ_FRAMEBUFFER, null);
                state.bindFramebuffer(_gl.DRAW_FRAMEBUFFER, null);
            } else if (isDst3D) {
                // copy data into the 3d texture
                if (srcTexture.isDataTexture || srcTexture.isData3DTexture) _gl.texSubImage3D(glTarget, dstLevel, dstX, dstY, dstZ, width, height, depth, glFormat, glType, image.data);
                else if (dstTexture.isCompressedArrayTexture) _gl.compressedTexSubImage3D(glTarget, dstLevel, dstX, dstY, dstZ, width, height, depth, glFormat, image.data);
                else _gl.texSubImage3D(glTarget, dstLevel, dstX, dstY, dstZ, width, height, depth, glFormat, glType, image);
            } else {
                // copy data into the 2d texture
                if (srcTexture.isDataTexture) _gl.texSubImage2D(_gl.TEXTURE_2D, dstLevel, dstX, dstY, width, height, glFormat, glType, image.data);
                else if (srcTexture.isCompressedTexture) _gl.compressedTexSubImage2D(_gl.TEXTURE_2D, dstLevel, dstX, dstY, image.width, image.height, glFormat, image.data);
                else _gl.texSubImage2D(_gl.TEXTURE_2D, dstLevel, dstX, dstY, width, height, glFormat, glType, image);
            }
            // reset values
            _gl.pixelStorei(_gl.UNPACK_ROW_LENGTH, currentUnpackRowLen);
            _gl.pixelStorei(_gl.UNPACK_IMAGE_HEIGHT, currentUnpackImageHeight);
            _gl.pixelStorei(_gl.UNPACK_SKIP_PIXELS, currentUnpackSkipPixels);
            _gl.pixelStorei(_gl.UNPACK_SKIP_ROWS, currentUnpackSkipRows);
            _gl.pixelStorei(_gl.UNPACK_SKIP_IMAGES, currentUnpackSkipImages);
            // Generate mipmaps only when copying level 0
            if (dstLevel === 0 && dstTexture.generateMipmaps) _gl.generateMipmap(glTarget);
            state.unbindTexture();
        };
        this.copyTextureToTexture3D = function(srcTexture, dstTexture, srcRegion = null, dstPosition = null, level = 0) {
            // @deprecated, r170
            (0, $dyjou.warnOnce)('WebGLRenderer: copyTextureToTexture3D function has been deprecated. Use "copyTextureToTexture" instead.');
            return this.copyTextureToTexture(srcTexture, dstTexture, srcRegion, dstPosition, level);
        };
        /**
		 * Initializes the given WebGLRenderTarget memory. Useful for initializing a render target so data
		 * can be copied into it using {@link WebGLRenderer#copyTextureToTexture} before it has been
		 * rendered to.
		 *
		 * @param {WebGLRenderTarget} target - The render target.
		 */ this.initRenderTarget = function(target) {
            if (properties.get(target).__webglFramebuffer === undefined) textures.setupRenderTarget(target);
        };
        /**
		 * Initializes the given texture. Useful for preloading a texture rather than waiting until first
		 * render (which can cause noticeable lags due to decode and GPU upload overhead).
		 *
		 * @param {Texture} texture - The texture.
		 */ this.initTexture = function(texture) {
            if (texture.isCubeTexture) textures.setTextureCube(texture, 0);
            else if (texture.isData3DTexture) textures.setTexture3D(texture, 0);
            else if (texture.isDataArrayTexture || texture.isCompressedArrayTexture) textures.setTexture2DArray(texture, 0);
            else textures.setTexture2D(texture, 0);
            state.unbindTexture();
        };
        /**
		 * Can be used to reset the internal WebGL state. This method is mostly
		 * relevant for applications which share a single WebGL context across
		 * multiple WebGL libraries.
		 */ this.resetState = function() {
            _currentActiveCubeFace = 0;
            _currentActiveMipmapLevel = 0;
            _currentRenderTarget = null;
            state.reset();
            bindingStates.reset();
        };
        if (typeof __THREE_DEVTOOLS__ !== 'undefined') __THREE_DEVTOOLS__.dispatchEvent(new CustomEvent('observe', {
            detail: this
        }));
    }
    /**
	 * Defines the coordinate system of the renderer.
	 *
	 * In `WebGLRenderer`, the value is always `WebGLCoordinateSystem`.
	 *
	 * @type {WebGLCoordinateSystem|WebGPUCoordinateSystem}
	 * @default WebGLCoordinateSystem
	 * @readonly
	 */ get coordinateSystem() {
        return 0, $dyjou.WebGLCoordinateSystem;
    }
    /**
	 * Defines the output color space of the renderer.
	 *
	 * @type {SRGBColorSpace|LinearSRGBColorSpace}
	 * @default SRGBColorSpace
	 */ get outputColorSpace() {
        return this._outputColorSpace;
    }
    set outputColorSpace(colorSpace) {
        this._outputColorSpace = colorSpace;
        const gl = this.getContext();
        gl.drawingBufferColorSpace = (0, $dyjou.ColorManagement)._getDrawingBufferColorSpace(colorSpace);
        gl.unpackColorSpace = (0, $dyjou.ColorManagement)._getUnpackColorSpace();
    }
}

});
parcelRegister("dyjou", function(module, exports) {

$parcel$export(module.exports, "REVISION", () => $9ddd7e9b53f7a2d4$export$3545e07a80636437);
$parcel$export(module.exports, "MOUSE", () => $9ddd7e9b53f7a2d4$export$7177b3e430c2d7ca);
$parcel$export(module.exports, "TOUCH", () => $9ddd7e9b53f7a2d4$export$d46bd3ead7cc759b);
$parcel$export(module.exports, "CullFaceNone", () => $9ddd7e9b53f7a2d4$export$3237e1f2c1ea1f44);
$parcel$export(module.exports, "CullFaceBack", () => $9ddd7e9b53f7a2d4$export$b9a7b4fc5cb15f9b);
$parcel$export(module.exports, "CullFaceFront", () => $9ddd7e9b53f7a2d4$export$b8058bcc7037d3f3);
$parcel$export(module.exports, "CullFaceFrontBack", () => $9ddd7e9b53f7a2d4$export$f24be24dcddeac0d);
$parcel$export(module.exports, "BasicShadowMap", () => $9ddd7e9b53f7a2d4$export$346307dbae2b7447);
$parcel$export(module.exports, "PCFShadowMap", () => $9ddd7e9b53f7a2d4$export$5813f879eee7cd88);
$parcel$export(module.exports, "PCFSoftShadowMap", () => $9ddd7e9b53f7a2d4$export$a47c4b43a1be34f0);
$parcel$export(module.exports, "VSMShadowMap", () => $9ddd7e9b53f7a2d4$export$896ae1ade6c829c4);
$parcel$export(module.exports, "FrontSide", () => $9ddd7e9b53f7a2d4$export$2ede184fc2998901);
$parcel$export(module.exports, "BackSide", () => $9ddd7e9b53f7a2d4$export$d9f0486e75b5ace);
$parcel$export(module.exports, "DoubleSide", () => $9ddd7e9b53f7a2d4$export$3b296b6f144d5b03);
$parcel$export(module.exports, "NoBlending", () => $9ddd7e9b53f7a2d4$export$63b8d6b580fc65ba);
$parcel$export(module.exports, "NormalBlending", () => $9ddd7e9b53f7a2d4$export$5b29a26d96ee6af0);
$parcel$export(module.exports, "AdditiveBlending", () => $9ddd7e9b53f7a2d4$export$777d8f9551c2216b);
$parcel$export(module.exports, "SubtractiveBlending", () => $9ddd7e9b53f7a2d4$export$cdfa06f868e2e467);
$parcel$export(module.exports, "MultiplyBlending", () => $9ddd7e9b53f7a2d4$export$4138e1c684b46a20);
$parcel$export(module.exports, "CustomBlending", () => $9ddd7e9b53f7a2d4$export$eda4864c68df1fa2);
$parcel$export(module.exports, "AddEquation", () => $9ddd7e9b53f7a2d4$export$20183a0484ce21a0);
$parcel$export(module.exports, "SubtractEquation", () => $9ddd7e9b53f7a2d4$export$73e0df5177988548);
$parcel$export(module.exports, "ReverseSubtractEquation", () => $9ddd7e9b53f7a2d4$export$28e582859cbec660);
$parcel$export(module.exports, "MinEquation", () => $9ddd7e9b53f7a2d4$export$c8c1508da8d0600c);
$parcel$export(module.exports, "MaxEquation", () => $9ddd7e9b53f7a2d4$export$99948c02fb51055f);
$parcel$export(module.exports, "ZeroFactor", () => $9ddd7e9b53f7a2d4$export$2110f05edf778d3d);
$parcel$export(module.exports, "OneFactor", () => $9ddd7e9b53f7a2d4$export$8805bad65e24940e);
$parcel$export(module.exports, "SrcColorFactor", () => $9ddd7e9b53f7a2d4$export$7fbe15b28d28cf52);
$parcel$export(module.exports, "OneMinusSrcColorFactor", () => $9ddd7e9b53f7a2d4$export$947829af9f2c17f6);
$parcel$export(module.exports, "SrcAlphaFactor", () => $9ddd7e9b53f7a2d4$export$d5773124e86cf28c);
$parcel$export(module.exports, "OneMinusSrcAlphaFactor", () => $9ddd7e9b53f7a2d4$export$11d468cc7f19e971);
$parcel$export(module.exports, "DstAlphaFactor", () => $9ddd7e9b53f7a2d4$export$a78aed1ca2a87192);
$parcel$export(module.exports, "OneMinusDstAlphaFactor", () => $9ddd7e9b53f7a2d4$export$5d0fe17fd8773bac);
$parcel$export(module.exports, "DstColorFactor", () => $9ddd7e9b53f7a2d4$export$ef5f2dd8ffac5574);
$parcel$export(module.exports, "OneMinusDstColorFactor", () => $9ddd7e9b53f7a2d4$export$56b85b2686ab16);
$parcel$export(module.exports, "SrcAlphaSaturateFactor", () => $9ddd7e9b53f7a2d4$export$c05e2a1fc8609506);
$parcel$export(module.exports, "ConstantColorFactor", () => $9ddd7e9b53f7a2d4$export$7dd8f434fd59075);
$parcel$export(module.exports, "OneMinusConstantColorFactor", () => $9ddd7e9b53f7a2d4$export$99c8d898a9afbcee);
$parcel$export(module.exports, "ConstantAlphaFactor", () => $9ddd7e9b53f7a2d4$export$310cd2be38d13b56);
$parcel$export(module.exports, "OneMinusConstantAlphaFactor", () => $9ddd7e9b53f7a2d4$export$db77b8fbcf45dbf4);
$parcel$export(module.exports, "NeverDepth", () => $9ddd7e9b53f7a2d4$export$69025ce147cee220);
$parcel$export(module.exports, "AlwaysDepth", () => $9ddd7e9b53f7a2d4$export$7182eb52ea3b3f04);
$parcel$export(module.exports, "LessDepth", () => $9ddd7e9b53f7a2d4$export$eedccec66ab7ebe);
$parcel$export(module.exports, "LessEqualDepth", () => $9ddd7e9b53f7a2d4$export$296f78a0b892f81a);
$parcel$export(module.exports, "EqualDepth", () => $9ddd7e9b53f7a2d4$export$a60d398fc7b7590e);
$parcel$export(module.exports, "GreaterEqualDepth", () => $9ddd7e9b53f7a2d4$export$7d7234c1240a1fc4);
$parcel$export(module.exports, "GreaterDepth", () => $9ddd7e9b53f7a2d4$export$c5e2c52991f30937);
$parcel$export(module.exports, "NotEqualDepth", () => $9ddd7e9b53f7a2d4$export$2f843afa843d8916);
$parcel$export(module.exports, "MultiplyOperation", () => $9ddd7e9b53f7a2d4$export$e50ac29801f1774d);
$parcel$export(module.exports, "MixOperation", () => $9ddd7e9b53f7a2d4$export$9f9d94f963c85479);
$parcel$export(module.exports, "AddOperation", () => $9ddd7e9b53f7a2d4$export$e641dc52bc3494aa);
$parcel$export(module.exports, "NoToneMapping", () => $9ddd7e9b53f7a2d4$export$9fcb6b4294603b2);
$parcel$export(module.exports, "LinearToneMapping", () => $9ddd7e9b53f7a2d4$export$98f52c2a46c598ca);
$parcel$export(module.exports, "ReinhardToneMapping", () => $9ddd7e9b53f7a2d4$export$74b25e54b3bcd548);
$parcel$export(module.exports, "CineonToneMapping", () => $9ddd7e9b53f7a2d4$export$932b3dd283d4a366);
$parcel$export(module.exports, "ACESFilmicToneMapping", () => $9ddd7e9b53f7a2d4$export$a0d98fe6d7e4af64);
$parcel$export(module.exports, "CustomToneMapping", () => $9ddd7e9b53f7a2d4$export$2c7b09c1e9abfb5e);
$parcel$export(module.exports, "AgXToneMapping", () => $9ddd7e9b53f7a2d4$export$212d53a513a325b2);
$parcel$export(module.exports, "NeutralToneMapping", () => $9ddd7e9b53f7a2d4$export$f2863e1668a8e317);
$parcel$export(module.exports, "AttachedBindMode", () => $9ddd7e9b53f7a2d4$export$2595a3798997538);
$parcel$export(module.exports, "DetachedBindMode", () => $9ddd7e9b53f7a2d4$export$d7e7dc2e114517a0);
$parcel$export(module.exports, "UVMapping", () => $9ddd7e9b53f7a2d4$export$1beec6768cbb3d2d);
$parcel$export(module.exports, "CubeReflectionMapping", () => $9ddd7e9b53f7a2d4$export$8759762a6477f2c4);
$parcel$export(module.exports, "CubeRefractionMapping", () => $9ddd7e9b53f7a2d4$export$dc59f8aed047f61d);
$parcel$export(module.exports, "EquirectangularReflectionMapping", () => $9ddd7e9b53f7a2d4$export$d64030b316d3b087);
$parcel$export(module.exports, "EquirectangularRefractionMapping", () => $9ddd7e9b53f7a2d4$export$ee99d97d46898098);
$parcel$export(module.exports, "CubeUVReflectionMapping", () => $9ddd7e9b53f7a2d4$export$dbf3e70ff37af79);
$parcel$export(module.exports, "RepeatWrapping", () => $9ddd7e9b53f7a2d4$export$533346c8e8dac0f5);
$parcel$export(module.exports, "ClampToEdgeWrapping", () => $9ddd7e9b53f7a2d4$export$9d9334239a5a5e06);
$parcel$export(module.exports, "MirroredRepeatWrapping", () => $9ddd7e9b53f7a2d4$export$c7e7c00b14f51a4f);
$parcel$export(module.exports, "NearestFilter", () => $9ddd7e9b53f7a2d4$export$727aa5ec3fe39bf0);
$parcel$export(module.exports, "NearestMipmapNearestFilter", () => $9ddd7e9b53f7a2d4$export$d129e38cf6feaa8c);
$parcel$export(module.exports, "NearestMipMapNearestFilter", () => $9ddd7e9b53f7a2d4$export$14a4936464a36496);
$parcel$export(module.exports, "NearestMipmapLinearFilter", () => $9ddd7e9b53f7a2d4$export$d2327c1afe5bfdf2);
$parcel$export(module.exports, "NearestMipMapLinearFilter", () => $9ddd7e9b53f7a2d4$export$cbc5b7f5647595d8);
$parcel$export(module.exports, "LinearFilter", () => $9ddd7e9b53f7a2d4$export$8a72f490b25c56c8);
$parcel$export(module.exports, "LinearMipmapNearestFilter", () => $9ddd7e9b53f7a2d4$export$19a719f377145a13);
$parcel$export(module.exports, "LinearMipMapNearestFilter", () => $9ddd7e9b53f7a2d4$export$dbe96bee3fe9dbf0);
$parcel$export(module.exports, "LinearMipmapLinearFilter", () => $9ddd7e9b53f7a2d4$export$5d8599b6a933fb1b);
$parcel$export(module.exports, "LinearMipMapLinearFilter", () => $9ddd7e9b53f7a2d4$export$90d80f1e3506775f);
$parcel$export(module.exports, "UnsignedByteType", () => $9ddd7e9b53f7a2d4$export$2e8ce08d3f6f5e10);
$parcel$export(module.exports, "ByteType", () => $9ddd7e9b53f7a2d4$export$545fce0311a9796a);
$parcel$export(module.exports, "ShortType", () => $9ddd7e9b53f7a2d4$export$88572337f312435f);
$parcel$export(module.exports, "UnsignedShortType", () => $9ddd7e9b53f7a2d4$export$c63dc51868b06a9d);
$parcel$export(module.exports, "IntType", () => $9ddd7e9b53f7a2d4$export$5c612977753abe2);
$parcel$export(module.exports, "UnsignedIntType", () => $9ddd7e9b53f7a2d4$export$c3c7fc4518ebba96);
$parcel$export(module.exports, "FloatType", () => $9ddd7e9b53f7a2d4$export$f6d331659b644596);
$parcel$export(module.exports, "HalfFloatType", () => $9ddd7e9b53f7a2d4$export$2697304443f382bc);
$parcel$export(module.exports, "UnsignedShort4444Type", () => $9ddd7e9b53f7a2d4$export$b3969b01faf587f2);
$parcel$export(module.exports, "UnsignedShort5551Type", () => $9ddd7e9b53f7a2d4$export$18886f8ae33e90de);
$parcel$export(module.exports, "UnsignedInt248Type", () => $9ddd7e9b53f7a2d4$export$6c8ea339bfab1301);
$parcel$export(module.exports, "UnsignedInt5999Type", () => $9ddd7e9b53f7a2d4$export$5a4c329b7e2092d3);
$parcel$export(module.exports, "AlphaFormat", () => $9ddd7e9b53f7a2d4$export$988473390501ed4b);
$parcel$export(module.exports, "RGBFormat", () => $9ddd7e9b53f7a2d4$export$7c67423a5ee6f5eb);
$parcel$export(module.exports, "RGBAFormat", () => $9ddd7e9b53f7a2d4$export$3f8bb04b555a363c);
$parcel$export(module.exports, "LuminanceFormat", () => $9ddd7e9b53f7a2d4$export$cc09ccbf6d1ed449);
$parcel$export(module.exports, "LuminanceAlphaFormat", () => $9ddd7e9b53f7a2d4$export$9053a81c4a69c289);
$parcel$export(module.exports, "DepthFormat", () => $9ddd7e9b53f7a2d4$export$c1b6b5136be58045);
$parcel$export(module.exports, "DepthStencilFormat", () => $9ddd7e9b53f7a2d4$export$1e113ac2d0905829);
$parcel$export(module.exports, "RedFormat", () => $9ddd7e9b53f7a2d4$export$4e041a7967d15c4b);
$parcel$export(module.exports, "RedIntegerFormat", () => $9ddd7e9b53f7a2d4$export$aa92e870a709d190);
$parcel$export(module.exports, "RGFormat", () => $9ddd7e9b53f7a2d4$export$6cdf0b461c7ce8a0);
$parcel$export(module.exports, "RGIntegerFormat", () => $9ddd7e9b53f7a2d4$export$1ba1c45f9f77d4d7);
$parcel$export(module.exports, "RGBIntegerFormat", () => $9ddd7e9b53f7a2d4$export$d1fd40c11bfa798e);
$parcel$export(module.exports, "RGBAIntegerFormat", () => $9ddd7e9b53f7a2d4$export$c200e7d26f592f21);
$parcel$export(module.exports, "RGB_S3TC_DXT1_Format", () => $9ddd7e9b53f7a2d4$export$21d1799c6d552fc0);
$parcel$export(module.exports, "RGBA_S3TC_DXT1_Format", () => $9ddd7e9b53f7a2d4$export$afa304c3e981b668);
$parcel$export(module.exports, "RGBA_S3TC_DXT3_Format", () => $9ddd7e9b53f7a2d4$export$d2a1a68024a3e56c);
$parcel$export(module.exports, "RGBA_S3TC_DXT5_Format", () => $9ddd7e9b53f7a2d4$export$9a79c424327dacf9);
$parcel$export(module.exports, "RGB_PVRTC_4BPPV1_Format", () => $9ddd7e9b53f7a2d4$export$19ada9bbb1af3573);
$parcel$export(module.exports, "RGB_PVRTC_2BPPV1_Format", () => $9ddd7e9b53f7a2d4$export$d0f0355bb3d948e4);
$parcel$export(module.exports, "RGBA_PVRTC_4BPPV1_Format", () => $9ddd7e9b53f7a2d4$export$b82296714358084c);
$parcel$export(module.exports, "RGBA_PVRTC_2BPPV1_Format", () => $9ddd7e9b53f7a2d4$export$b71692456c47b6c3);
$parcel$export(module.exports, "RGB_ETC1_Format", () => $9ddd7e9b53f7a2d4$export$6ab91af2d757aee7);
$parcel$export(module.exports, "RGB_ETC2_Format", () => $9ddd7e9b53f7a2d4$export$7800993ef8106a6a);
$parcel$export(module.exports, "RGBA_ETC2_EAC_Format", () => $9ddd7e9b53f7a2d4$export$23ed8300a860e7d8);
$parcel$export(module.exports, "RGBA_ASTC_4x4_Format", () => $9ddd7e9b53f7a2d4$export$dc5570b4a2b92d48);
$parcel$export(module.exports, "RGBA_ASTC_5x4_Format", () => $9ddd7e9b53f7a2d4$export$68880cd325f8b2fb);
$parcel$export(module.exports, "RGBA_ASTC_5x5_Format", () => $9ddd7e9b53f7a2d4$export$7d2c0be323373d95);
$parcel$export(module.exports, "RGBA_ASTC_6x5_Format", () => $9ddd7e9b53f7a2d4$export$22b52da301fc3a3e);
$parcel$export(module.exports, "RGBA_ASTC_6x6_Format", () => $9ddd7e9b53f7a2d4$export$c009e2cb4a66485e);
$parcel$export(module.exports, "RGBA_ASTC_8x5_Format", () => $9ddd7e9b53f7a2d4$export$118fff5afa255b63);
$parcel$export(module.exports, "RGBA_ASTC_8x6_Format", () => $9ddd7e9b53f7a2d4$export$120713c829ae0667);
$parcel$export(module.exports, "RGBA_ASTC_8x8_Format", () => $9ddd7e9b53f7a2d4$export$c79eeabbf53313e9);
$parcel$export(module.exports, "RGBA_ASTC_10x5_Format", () => $9ddd7e9b53f7a2d4$export$443cf6567cdd6424);
$parcel$export(module.exports, "RGBA_ASTC_10x6_Format", () => $9ddd7e9b53f7a2d4$export$6573984fc9840780);
$parcel$export(module.exports, "RGBA_ASTC_10x8_Format", () => $9ddd7e9b53f7a2d4$export$e7aee563f30091de);
$parcel$export(module.exports, "RGBA_ASTC_10x10_Format", () => $9ddd7e9b53f7a2d4$export$2eb8634622ddeab7);
$parcel$export(module.exports, "RGBA_ASTC_12x10_Format", () => $9ddd7e9b53f7a2d4$export$202b1ce7b5d25742);
$parcel$export(module.exports, "RGBA_ASTC_12x12_Format", () => $9ddd7e9b53f7a2d4$export$18ab77abd087e467);
$parcel$export(module.exports, "RGBA_BPTC_Format", () => $9ddd7e9b53f7a2d4$export$ce40b115e188bc81);
$parcel$export(module.exports, "RGB_BPTC_SIGNED_Format", () => $9ddd7e9b53f7a2d4$export$d279c5c4bac5121e);
$parcel$export(module.exports, "RGB_BPTC_UNSIGNED_Format", () => $9ddd7e9b53f7a2d4$export$cde52d17225fdbd3);
$parcel$export(module.exports, "RED_RGTC1_Format", () => $9ddd7e9b53f7a2d4$export$b1688df4c4c21670);
$parcel$export(module.exports, "SIGNED_RED_RGTC1_Format", () => $9ddd7e9b53f7a2d4$export$fc15e5d8261eed58);
$parcel$export(module.exports, "RED_GREEN_RGTC2_Format", () => $9ddd7e9b53f7a2d4$export$d220f6ade8463a0f);
$parcel$export(module.exports, "SIGNED_RED_GREEN_RGTC2_Format", () => $9ddd7e9b53f7a2d4$export$768646d09dc1b6ef);
$parcel$export(module.exports, "LoopOnce", () => $9ddd7e9b53f7a2d4$export$d62fdc9d1b1cccad);
$parcel$export(module.exports, "LoopRepeat", () => $9ddd7e9b53f7a2d4$export$dfaf4422ce096e29);
$parcel$export(module.exports, "LoopPingPong", () => $9ddd7e9b53f7a2d4$export$f8f6f2041b78e210);
$parcel$export(module.exports, "InterpolateDiscrete", () => $9ddd7e9b53f7a2d4$export$995b32462a65e855);
$parcel$export(module.exports, "InterpolateLinear", () => $9ddd7e9b53f7a2d4$export$30fac1aace31cf4d);
$parcel$export(module.exports, "InterpolateSmooth", () => $9ddd7e9b53f7a2d4$export$198b11ff4c72bb30);
$parcel$export(module.exports, "ZeroCurvatureEnding", () => $9ddd7e9b53f7a2d4$export$7f795934b84ab523);
$parcel$export(module.exports, "ZeroSlopeEnding", () => $9ddd7e9b53f7a2d4$export$24a4ccb5099273b5);
$parcel$export(module.exports, "WrapAroundEnding", () => $9ddd7e9b53f7a2d4$export$8e8c3ecdcd8e1fee);
$parcel$export(module.exports, "NormalAnimationBlendMode", () => $9ddd7e9b53f7a2d4$export$bcfbbdcf8de7f8cd);
$parcel$export(module.exports, "AdditiveAnimationBlendMode", () => $9ddd7e9b53f7a2d4$export$d875e029ef558d3);
$parcel$export(module.exports, "TrianglesDrawMode", () => $9ddd7e9b53f7a2d4$export$4c28c87c2dc84758);
$parcel$export(module.exports, "TriangleStripDrawMode", () => $9ddd7e9b53f7a2d4$export$b23a071aa286eb29);
$parcel$export(module.exports, "TriangleFanDrawMode", () => $9ddd7e9b53f7a2d4$export$f0d8293634f88842);
$parcel$export(module.exports, "BasicDepthPacking", () => $9ddd7e9b53f7a2d4$export$deeb383078690b50);
$parcel$export(module.exports, "RGBADepthPacking", () => $9ddd7e9b53f7a2d4$export$8f910f4c4f73df11);
$parcel$export(module.exports, "RGBDepthPacking", () => $9ddd7e9b53f7a2d4$export$be2e2ddbc3983173);
$parcel$export(module.exports, "RGDepthPacking", () => $9ddd7e9b53f7a2d4$export$1a54198784742f80);
$parcel$export(module.exports, "TangentSpaceNormalMap", () => $9ddd7e9b53f7a2d4$export$2852a58ebdac27b8);
$parcel$export(module.exports, "ObjectSpaceNormalMap", () => $9ddd7e9b53f7a2d4$export$9990ad26f9db5b2c);
$parcel$export(module.exports, "NoColorSpace", () => $9ddd7e9b53f7a2d4$export$bfcb490c2dd3db51);
$parcel$export(module.exports, "SRGBColorSpace", () => $9ddd7e9b53f7a2d4$export$561f394b24edfcaa);
$parcel$export(module.exports, "LinearSRGBColorSpace", () => $9ddd7e9b53f7a2d4$export$42429b3acfb233a4);
$parcel$export(module.exports, "LinearTransfer", () => $9ddd7e9b53f7a2d4$export$f197347d588c1b4a);
$parcel$export(module.exports, "SRGBTransfer", () => $9ddd7e9b53f7a2d4$export$8d0a61916cc26abb);
$parcel$export(module.exports, "ZeroStencilOp", () => $9ddd7e9b53f7a2d4$export$69433f11f42d5527);
$parcel$export(module.exports, "KeepStencilOp", () => $9ddd7e9b53f7a2d4$export$9f542ae4b5baca34);
$parcel$export(module.exports, "ReplaceStencilOp", () => $9ddd7e9b53f7a2d4$export$8a4f28336ef203d3);
$parcel$export(module.exports, "IncrementStencilOp", () => $9ddd7e9b53f7a2d4$export$2928c0231297c036);
$parcel$export(module.exports, "DecrementStencilOp", () => $9ddd7e9b53f7a2d4$export$c0e9611c8a15f9a8);
$parcel$export(module.exports, "IncrementWrapStencilOp", () => $9ddd7e9b53f7a2d4$export$9c2c08927385dcc4);
$parcel$export(module.exports, "DecrementWrapStencilOp", () => $9ddd7e9b53f7a2d4$export$7c74ea00fa1315e6);
$parcel$export(module.exports, "InvertStencilOp", () => $9ddd7e9b53f7a2d4$export$22e2e5726612443);
$parcel$export(module.exports, "NeverStencilFunc", () => $9ddd7e9b53f7a2d4$export$1343870698229224);
$parcel$export(module.exports, "LessStencilFunc", () => $9ddd7e9b53f7a2d4$export$8e1d8ed281997fa6);
$parcel$export(module.exports, "EqualStencilFunc", () => $9ddd7e9b53f7a2d4$export$55648a1cde8329a7);
$parcel$export(module.exports, "LessEqualStencilFunc", () => $9ddd7e9b53f7a2d4$export$2dff107857e6aca2);
$parcel$export(module.exports, "GreaterStencilFunc", () => $9ddd7e9b53f7a2d4$export$6f93765ab2f451a2);
$parcel$export(module.exports, "NotEqualStencilFunc", () => $9ddd7e9b53f7a2d4$export$6f3fb2d2440f2b76);
$parcel$export(module.exports, "GreaterEqualStencilFunc", () => $9ddd7e9b53f7a2d4$export$4119cf7b4c98fd5a);
$parcel$export(module.exports, "AlwaysStencilFunc", () => $9ddd7e9b53f7a2d4$export$14cf96713ddd97a8);
$parcel$export(module.exports, "NeverCompare", () => $9ddd7e9b53f7a2d4$export$d9e2d19a747baaab);
$parcel$export(module.exports, "LessCompare", () => $9ddd7e9b53f7a2d4$export$36bcf49c713b3eb7);
$parcel$export(module.exports, "EqualCompare", () => $9ddd7e9b53f7a2d4$export$66f28d946fc6a0d5);
$parcel$export(module.exports, "LessEqualCompare", () => $9ddd7e9b53f7a2d4$export$64eea11eb407ddf1);
$parcel$export(module.exports, "GreaterCompare", () => $9ddd7e9b53f7a2d4$export$155af022118f3a38);
$parcel$export(module.exports, "NotEqualCompare", () => $9ddd7e9b53f7a2d4$export$67ab95dde6bed156);
$parcel$export(module.exports, "GreaterEqualCompare", () => $9ddd7e9b53f7a2d4$export$1cdcb70d53d65f61);
$parcel$export(module.exports, "AlwaysCompare", () => $9ddd7e9b53f7a2d4$export$187b73a3e352c145);
$parcel$export(module.exports, "StaticDrawUsage", () => $9ddd7e9b53f7a2d4$export$763e8360f4d7f77d);
$parcel$export(module.exports, "DynamicDrawUsage", () => $9ddd7e9b53f7a2d4$export$8505d14ac8546ca);
$parcel$export(module.exports, "StreamDrawUsage", () => $9ddd7e9b53f7a2d4$export$721e63549e51d81e);
$parcel$export(module.exports, "StaticReadUsage", () => $9ddd7e9b53f7a2d4$export$415731dc4f48e299);
$parcel$export(module.exports, "DynamicReadUsage", () => $9ddd7e9b53f7a2d4$export$9e809946455f13bc);
$parcel$export(module.exports, "StreamReadUsage", () => $9ddd7e9b53f7a2d4$export$2ed9499a35b5f832);
$parcel$export(module.exports, "StaticCopyUsage", () => $9ddd7e9b53f7a2d4$export$32ab2503ea19469a);
$parcel$export(module.exports, "DynamicCopyUsage", () => $9ddd7e9b53f7a2d4$export$ab4022c2c3f86315);
$parcel$export(module.exports, "StreamCopyUsage", () => $9ddd7e9b53f7a2d4$export$ba7f1db36a76a970);
$parcel$export(module.exports, "GLSL1", () => $9ddd7e9b53f7a2d4$export$43600cc67fabd9f);
$parcel$export(module.exports, "GLSL3", () => $9ddd7e9b53f7a2d4$export$f63012db5506e7dd);
$parcel$export(module.exports, "WebGLCoordinateSystem", () => $9ddd7e9b53f7a2d4$export$5a0e9190d10875d3);
$parcel$export(module.exports, "WebGPUCoordinateSystem", () => $9ddd7e9b53f7a2d4$export$cc83beedcb9be9ac);
$parcel$export(module.exports, "TimestampQuery", () => $9ddd7e9b53f7a2d4$export$f97db56e2b647801);
$parcel$export(module.exports, "EventDispatcher", () => $9ddd7e9b53f7a2d4$export$ec8b666c5fe2c75a);
$parcel$export(module.exports, "RAD2DEG", () => $9ddd7e9b53f7a2d4$export$914076c8150813e5);
$parcel$export(module.exports, "MathUtils", () => $9ddd7e9b53f7a2d4$export$6a7ef315a0d1ef07);
$parcel$export(module.exports, "Vector2", () => $9ddd7e9b53f7a2d4$export$c977b3e384af9ae1);
$parcel$export(module.exports, "Matrix3", () => $9ddd7e9b53f7a2d4$export$8ff26dafa08918);
$parcel$export(module.exports, "arrayNeedsUint32", () => $9ddd7e9b53f7a2d4$export$bc6f937da07eae17);
$parcel$export(module.exports, "createElementNS", () => $9ddd7e9b53f7a2d4$export$7094a064528c7fee);
$parcel$export(module.exports, "createCanvasElement", () => $9ddd7e9b53f7a2d4$export$1033a2df66368859);
$parcel$export(module.exports, "warnOnce", () => $9ddd7e9b53f7a2d4$export$5b28268982f175ba);
$parcel$export(module.exports, "probeAsync", () => $9ddd7e9b53f7a2d4$export$d43f91ebeafb2c7);
$parcel$export(module.exports, "toNormalizedProjectionMatrix", () => $9ddd7e9b53f7a2d4$export$5238391f68c729b);
$parcel$export(module.exports, "toReversedProjectionMatrix", () => $9ddd7e9b53f7a2d4$export$f8cf97d08da9bc86);
$parcel$export(module.exports, "ColorManagement", () => $9ddd7e9b53f7a2d4$export$5e6fd513f44698c);
$parcel$export(module.exports, "ImageUtils", () => $9ddd7e9b53f7a2d4$export$698882cf06df44aa);
$parcel$export(module.exports, "Source", () => $9ddd7e9b53f7a2d4$export$1d2df86270c81ecb);
$parcel$export(module.exports, "Texture", () => $9ddd7e9b53f7a2d4$export$5431306cf43de24a);
$parcel$export(module.exports, "Vector4", () => $9ddd7e9b53f7a2d4$export$fa7daccca11cdbe3);
$parcel$export(module.exports, "RenderTarget", () => $9ddd7e9b53f7a2d4$export$efcb1f8bf367cbfb);
$parcel$export(module.exports, "WebGLRenderTarget", () => $9ddd7e9b53f7a2d4$export$3c052beb2e51e23f);
$parcel$export(module.exports, "DataArrayTexture", () => $9ddd7e9b53f7a2d4$export$dfac6c8e811406a3);
$parcel$export(module.exports, "WebGLArrayRenderTarget", () => $9ddd7e9b53f7a2d4$export$c77a02c11ed180c7);
$parcel$export(module.exports, "Data3DTexture", () => $9ddd7e9b53f7a2d4$export$d7a3086320f856db);
$parcel$export(module.exports, "WebGL3DRenderTarget", () => $9ddd7e9b53f7a2d4$export$7ee06591009639df);
$parcel$export(module.exports, "Quaternion", () => $9ddd7e9b53f7a2d4$export$23d6a54f0bbc85a3);
$parcel$export(module.exports, "Vector3", () => $9ddd7e9b53f7a2d4$export$64b5c384219d3699);
$parcel$export(module.exports, "Box3", () => $9ddd7e9b53f7a2d4$export$6f7d5a9418ab2aa3);
$parcel$export(module.exports, "Sphere", () => $9ddd7e9b53f7a2d4$export$805e8b72413ccaba);
$parcel$export(module.exports, "Ray", () => $9ddd7e9b53f7a2d4$export$a186db52eed6d40e);
$parcel$export(module.exports, "Matrix4", () => $9ddd7e9b53f7a2d4$export$2ae72fc923e5eb5);
$parcel$export(module.exports, "Euler", () => $9ddd7e9b53f7a2d4$export$d93cc409a0768c5f);
$parcel$export(module.exports, "Layers", () => $9ddd7e9b53f7a2d4$export$89312ce47c0ca777);
$parcel$export(module.exports, "Object3D", () => $9ddd7e9b53f7a2d4$export$e4dd07dff30cc924);
$parcel$export(module.exports, "Triangle", () => $9ddd7e9b53f7a2d4$export$5a465592bfe74b48);
$parcel$export(module.exports, "Color", () => $9ddd7e9b53f7a2d4$export$892596cec99bc70e);
$parcel$export(module.exports, "Material", () => $9ddd7e9b53f7a2d4$export$a2d8b23205c25948);
$parcel$export(module.exports, "MeshBasicMaterial", () => $9ddd7e9b53f7a2d4$export$55cbcc9b622fe1f5);
$parcel$export(module.exports, "DataUtils", () => $9ddd7e9b53f7a2d4$export$11ce8b759162cc80);
$parcel$export(module.exports, "BufferAttribute", () => $9ddd7e9b53f7a2d4$export$8dea267bd6bde117);
$parcel$export(module.exports, "Int8BufferAttribute", () => $9ddd7e9b53f7a2d4$export$f9ff2d6a20248cbf);
$parcel$export(module.exports, "Uint8BufferAttribute", () => $9ddd7e9b53f7a2d4$export$cacc90cf35d11cdd);
$parcel$export(module.exports, "Uint8ClampedBufferAttribute", () => $9ddd7e9b53f7a2d4$export$baaa85a1a812c157);
$parcel$export(module.exports, "Int16BufferAttribute", () => $9ddd7e9b53f7a2d4$export$2b755a102ccdcefe);
$parcel$export(module.exports, "Uint16BufferAttribute", () => $9ddd7e9b53f7a2d4$export$640a853f68025f2e);
$parcel$export(module.exports, "Int32BufferAttribute", () => $9ddd7e9b53f7a2d4$export$46b369aed2968a0a);
$parcel$export(module.exports, "Uint32BufferAttribute", () => $9ddd7e9b53f7a2d4$export$7eb8c9fa25cd5bd6);
$parcel$export(module.exports, "Float16BufferAttribute", () => $9ddd7e9b53f7a2d4$export$dbd3698c64958d69);
$parcel$export(module.exports, "Float32BufferAttribute", () => $9ddd7e9b53f7a2d4$export$cbe7a62641830ebd);
$parcel$export(module.exports, "BufferGeometry", () => $9ddd7e9b53f7a2d4$export$b7be63a67df8959);
$parcel$export(module.exports, "Mesh", () => $9ddd7e9b53f7a2d4$export$e176487c05830cc5);
$parcel$export(module.exports, "BoxGeometry", () => $9ddd7e9b53f7a2d4$export$33e43285f7406bd5);
$parcel$export(module.exports, "cloneUniforms", () => $9ddd7e9b53f7a2d4$export$acda854380553452);
$parcel$export(module.exports, "mergeUniforms", () => $9ddd7e9b53f7a2d4$export$8916ce6879271f43);
$parcel$export(module.exports, "getUnlitUniformColorSpace", () => $9ddd7e9b53f7a2d4$export$a630742c640528c1);
$parcel$export(module.exports, "UniformsUtils", () => $9ddd7e9b53f7a2d4$export$d8ecdf8615bfea69);
$parcel$export(module.exports, "ShaderMaterial", () => $9ddd7e9b53f7a2d4$export$83c7d75d550a8b0d);
$parcel$export(module.exports, "Camera", () => $9ddd7e9b53f7a2d4$export$79f141de891a5fed);
$parcel$export(module.exports, "PerspectiveCamera", () => $9ddd7e9b53f7a2d4$export$74e4ae24825f68d7);
$parcel$export(module.exports, "CubeCamera", () => $9ddd7e9b53f7a2d4$export$d0cdd0bd804995de);
$parcel$export(module.exports, "CubeTexture", () => $9ddd7e9b53f7a2d4$export$ee2e5a18258a4049);
$parcel$export(module.exports, "WebGLCubeRenderTarget", () => $9ddd7e9b53f7a2d4$export$ac386671d651941e);
$parcel$export(module.exports, "Group", () => $9ddd7e9b53f7a2d4$export$eb2fcfdbd7ba97d4);
$parcel$export(module.exports, "WebXRController", () => $9ddd7e9b53f7a2d4$export$cb626c57dcc48b9f);
$parcel$export(module.exports, "FogExp2", () => $9ddd7e9b53f7a2d4$export$6f1519f023b8d0f6);
$parcel$export(module.exports, "Fog", () => $9ddd7e9b53f7a2d4$export$3c890837b09508d4);
$parcel$export(module.exports, "Scene", () => $9ddd7e9b53f7a2d4$export$38af1803e3442a7f);
$parcel$export(module.exports, "InterleavedBuffer", () => $9ddd7e9b53f7a2d4$export$3d5cd879f108f53f);
$parcel$export(module.exports, "InterleavedBufferAttribute", () => $9ddd7e9b53f7a2d4$export$920b6d07334599c7);
$parcel$export(module.exports, "SpriteMaterial", () => $9ddd7e9b53f7a2d4$export$5ec7dd1c6994bf8e);
$parcel$export(module.exports, "Sprite", () => $9ddd7e9b53f7a2d4$export$3075603db8e6204c);
$parcel$export(module.exports, "LOD", () => $9ddd7e9b53f7a2d4$export$112e7237be0c5f30);
$parcel$export(module.exports, "SkinnedMesh", () => $9ddd7e9b53f7a2d4$export$b303577035157ecf);
$parcel$export(module.exports, "Bone", () => $9ddd7e9b53f7a2d4$export$b127726e56765aa4);
$parcel$export(module.exports, "DataTexture", () => $9ddd7e9b53f7a2d4$export$b691f601014eabe1);
$parcel$export(module.exports, "Skeleton", () => $9ddd7e9b53f7a2d4$export$8f31e4c4a37b8e9c);
$parcel$export(module.exports, "InstancedBufferAttribute", () => $9ddd7e9b53f7a2d4$export$32ea87a8b54d744a);
$parcel$export(module.exports, "InstancedMesh", () => $9ddd7e9b53f7a2d4$export$f3c979c331175ad7);
$parcel$export(module.exports, "Plane", () => $9ddd7e9b53f7a2d4$export$7ff5ac152ef991b0);
$parcel$export(module.exports, "Frustum", () => $9ddd7e9b53f7a2d4$export$35efe6f4c85463d2);
$parcel$export(module.exports, "BatchedMesh", () => $9ddd7e9b53f7a2d4$export$6e01c5ee52ed8f7b);
$parcel$export(module.exports, "LineBasicMaterial", () => $9ddd7e9b53f7a2d4$export$fbaaa33907730a0c);
$parcel$export(module.exports, "Line", () => $9ddd7e9b53f7a2d4$export$17d680238e50603e);
$parcel$export(module.exports, "LineSegments", () => $9ddd7e9b53f7a2d4$export$ff1ed10fedfdd604);
$parcel$export(module.exports, "LineLoop", () => $9ddd7e9b53f7a2d4$export$f85a24d745e4f17d);
$parcel$export(module.exports, "PointsMaterial", () => $9ddd7e9b53f7a2d4$export$a178c45366ce5d6b);
$parcel$export(module.exports, "Points", () => $9ddd7e9b53f7a2d4$export$1c787534cb11aa3e);
$parcel$export(module.exports, "VideoTexture", () => $9ddd7e9b53f7a2d4$export$6e09d1edf8d5a25c);
$parcel$export(module.exports, "VideoFrameTexture", () => $9ddd7e9b53f7a2d4$export$68498d200b825382);
$parcel$export(module.exports, "FramebufferTexture", () => $9ddd7e9b53f7a2d4$export$9270d786f73ce6fe);
$parcel$export(module.exports, "CompressedTexture", () => $9ddd7e9b53f7a2d4$export$3466bac9141a5cc4);
$parcel$export(module.exports, "CompressedArrayTexture", () => $9ddd7e9b53f7a2d4$export$5fe6b8e34b274fcb);
$parcel$export(module.exports, "CompressedCubeTexture", () => $9ddd7e9b53f7a2d4$export$d80173634de65bff);
$parcel$export(module.exports, "CanvasTexture", () => $9ddd7e9b53f7a2d4$export$f7189e49152d1c13);
$parcel$export(module.exports, "DepthTexture", () => $9ddd7e9b53f7a2d4$export$fc830aa069cc8c2f);
$parcel$export(module.exports, "Curve", () => $9ddd7e9b53f7a2d4$export$b0e83c3ef8d2db1);
$parcel$export(module.exports, "EllipseCurve", () => $9ddd7e9b53f7a2d4$export$3f87a931616cde04);
$parcel$export(module.exports, "ArcCurve", () => $9ddd7e9b53f7a2d4$export$b1eedc9aab6300e8);
$parcel$export(module.exports, "CatmullRomCurve3", () => $9ddd7e9b53f7a2d4$export$b9146b27c24b744c);
$parcel$export(module.exports, "CubicBezierCurve", () => $9ddd7e9b53f7a2d4$export$e36650d36468bb39);
$parcel$export(module.exports, "CubicBezierCurve3", () => $9ddd7e9b53f7a2d4$export$13d5f1c9525f246c);
$parcel$export(module.exports, "LineCurve", () => $9ddd7e9b53f7a2d4$export$ab2e07e76531a47e);
$parcel$export(module.exports, "LineCurve3", () => $9ddd7e9b53f7a2d4$export$1fdfd9d9cf487600);
$parcel$export(module.exports, "QuadraticBezierCurve", () => $9ddd7e9b53f7a2d4$export$5938c4ee491a43ad);
$parcel$export(module.exports, "QuadraticBezierCurve3", () => $9ddd7e9b53f7a2d4$export$bf3f4c7e459f90fc);
$parcel$export(module.exports, "SplineCurve", () => $9ddd7e9b53f7a2d4$export$d3bdd77da77afc1b);
$parcel$export(module.exports, "CurvePath", () => $9ddd7e9b53f7a2d4$export$4aaf9b66af1bbf2c);
$parcel$export(module.exports, "Path", () => $9ddd7e9b53f7a2d4$export$4b2950bdac9b6ee9);
$parcel$export(module.exports, "LatheGeometry", () => $9ddd7e9b53f7a2d4$export$6d839803fcd1882c);
$parcel$export(module.exports, "CapsuleGeometry", () => $9ddd7e9b53f7a2d4$export$41680e8551036033);
$parcel$export(module.exports, "CircleGeometry", () => $9ddd7e9b53f7a2d4$export$d5c0e8d607467193);
$parcel$export(module.exports, "CylinderGeometry", () => $9ddd7e9b53f7a2d4$export$68f745719dbe5198);
$parcel$export(module.exports, "ConeGeometry", () => $9ddd7e9b53f7a2d4$export$a7a48974f285c9b3);
$parcel$export(module.exports, "PolyhedronGeometry", () => $9ddd7e9b53f7a2d4$export$60e57a7d3f20ff65);
$parcel$export(module.exports, "DodecahedronGeometry", () => $9ddd7e9b53f7a2d4$export$c0babfeb8708fc9c);
$parcel$export(module.exports, "EdgesGeometry", () => $9ddd7e9b53f7a2d4$export$4730b1542707547f);
$parcel$export(module.exports, "Shape", () => $9ddd7e9b53f7a2d4$export$6428a7f2611ef1fa);
$parcel$export(module.exports, "ShapeUtils", () => $9ddd7e9b53f7a2d4$export$96bdf6d9c66d7ba8);
$parcel$export(module.exports, "ExtrudeGeometry", () => $9ddd7e9b53f7a2d4$export$598697a1efa63ca7);
$parcel$export(module.exports, "IcosahedronGeometry", () => $9ddd7e9b53f7a2d4$export$9567cc828c9535da);
$parcel$export(module.exports, "OctahedronGeometry", () => $9ddd7e9b53f7a2d4$export$1954e2b809fe361e);
$parcel$export(module.exports, "PlaneGeometry", () => $9ddd7e9b53f7a2d4$export$967d831af31f69ce);
$parcel$export(module.exports, "RingGeometry", () => $9ddd7e9b53f7a2d4$export$68cb731f50f614af);
$parcel$export(module.exports, "ShapeGeometry", () => $9ddd7e9b53f7a2d4$export$57a29a1c803e9065);
$parcel$export(module.exports, "SphereGeometry", () => $9ddd7e9b53f7a2d4$export$1b417fc3b307a251);
$parcel$export(module.exports, "TetrahedronGeometry", () => $9ddd7e9b53f7a2d4$export$fb3f7adc68bd6e02);
$parcel$export(module.exports, "TorusGeometry", () => $9ddd7e9b53f7a2d4$export$a2312a2a1fa56495);
$parcel$export(module.exports, "TorusKnotGeometry", () => $9ddd7e9b53f7a2d4$export$77e9bfadfb9ab8c8);
$parcel$export(module.exports, "TubeGeometry", () => $9ddd7e9b53f7a2d4$export$7897d9d48904490c);
$parcel$export(module.exports, "WireframeGeometry", () => $9ddd7e9b53f7a2d4$export$4b739da06d24892b);
$parcel$export(module.exports, "ShadowMaterial", () => $9ddd7e9b53f7a2d4$export$e8564da406055a3);
$parcel$export(module.exports, "RawShaderMaterial", () => $9ddd7e9b53f7a2d4$export$21c421a2e1df9d22);
$parcel$export(module.exports, "MeshStandardMaterial", () => $9ddd7e9b53f7a2d4$export$f2980790215acccd);
$parcel$export(module.exports, "MeshPhysicalMaterial", () => $9ddd7e9b53f7a2d4$export$28d04986c4269c9f);
$parcel$export(module.exports, "MeshPhongMaterial", () => $9ddd7e9b53f7a2d4$export$24c72f71cbaf0678);
$parcel$export(module.exports, "MeshToonMaterial", () => $9ddd7e9b53f7a2d4$export$df893cf97e765622);
$parcel$export(module.exports, "MeshNormalMaterial", () => $9ddd7e9b53f7a2d4$export$bfe8c0a091f41ae7);
$parcel$export(module.exports, "MeshLambertMaterial", () => $9ddd7e9b53f7a2d4$export$5023a9a8114806b8);
$parcel$export(module.exports, "MeshDepthMaterial", () => $9ddd7e9b53f7a2d4$export$2698c22ec13825db);
$parcel$export(module.exports, "MeshDistanceMaterial", () => $9ddd7e9b53f7a2d4$export$33e187ed002f2a19);
$parcel$export(module.exports, "MeshMatcapMaterial", () => $9ddd7e9b53f7a2d4$export$6f5fef6235ec12ee);
$parcel$export(module.exports, "LineDashedMaterial", () => $9ddd7e9b53f7a2d4$export$327886a3efaeaebe);
$parcel$export(module.exports, "AnimationUtils", () => $9ddd7e9b53f7a2d4$export$7ee8caa573e71ad1);
$parcel$export(module.exports, "Interpolant", () => $9ddd7e9b53f7a2d4$export$b558baee9c0f72d3);
$parcel$export(module.exports, "CubicInterpolant", () => $9ddd7e9b53f7a2d4$export$3646682e7a3959);
$parcel$export(module.exports, "LinearInterpolant", () => $9ddd7e9b53f7a2d4$export$a8e6009059f51e1a);
$parcel$export(module.exports, "DiscreteInterpolant", () => $9ddd7e9b53f7a2d4$export$fb9758ef7ef8d5cc);
$parcel$export(module.exports, "KeyframeTrack", () => $9ddd7e9b53f7a2d4$export$b0e479f45b7006d6);
$parcel$export(module.exports, "BooleanKeyframeTrack", () => $9ddd7e9b53f7a2d4$export$d3a344b98cf0b775);
$parcel$export(module.exports, "ColorKeyframeTrack", () => $9ddd7e9b53f7a2d4$export$83444c5d885347d8);
$parcel$export(module.exports, "NumberKeyframeTrack", () => $9ddd7e9b53f7a2d4$export$d45f0d1a4d9a9314);
$parcel$export(module.exports, "QuaternionLinearInterpolant", () => $9ddd7e9b53f7a2d4$export$2db1cfb7923d931e);
$parcel$export(module.exports, "QuaternionKeyframeTrack", () => $9ddd7e9b53f7a2d4$export$b8043f12b5aafbd7);
$parcel$export(module.exports, "StringKeyframeTrack", () => $9ddd7e9b53f7a2d4$export$6ce41d4f3a8df9cd);
$parcel$export(module.exports, "VectorKeyframeTrack", () => $9ddd7e9b53f7a2d4$export$5ce2dcb4cc9f2bff);
$parcel$export(module.exports, "AnimationClip", () => $9ddd7e9b53f7a2d4$export$d942c706bf23829c);
$parcel$export(module.exports, "Cache", () => $9ddd7e9b53f7a2d4$export$94affb487e701bf2);
$parcel$export(module.exports, "LoadingManager", () => $9ddd7e9b53f7a2d4$export$99cc795e99919eed);
$parcel$export(module.exports, "DefaultLoadingManager", () => $9ddd7e9b53f7a2d4$export$b033c3f9a95c6a16);
$parcel$export(module.exports, "Loader", () => $9ddd7e9b53f7a2d4$export$3b0d6d7590275603);
$parcel$export(module.exports, "FileLoader", () => $9ddd7e9b53f7a2d4$export$98435a25b5cf7b2b);
$parcel$export(module.exports, "AnimationLoader", () => $9ddd7e9b53f7a2d4$export$29711c7e14f61db);
$parcel$export(module.exports, "CompressedTextureLoader", () => $9ddd7e9b53f7a2d4$export$bd73ce947a280350);
$parcel$export(module.exports, "ImageLoader", () => $9ddd7e9b53f7a2d4$export$8905ce1c7a2464a1);
$parcel$export(module.exports, "CubeTextureLoader", () => $9ddd7e9b53f7a2d4$export$2ec114afc2cf6308);
$parcel$export(module.exports, "DataTextureLoader", () => $9ddd7e9b53f7a2d4$export$792d8a18f2c55855);
$parcel$export(module.exports, "TextureLoader", () => $9ddd7e9b53f7a2d4$export$fd1bfc71f64c538c);
$parcel$export(module.exports, "Light", () => $9ddd7e9b53f7a2d4$export$6ecadb6ed240d696);
$parcel$export(module.exports, "HemisphereLight", () => $9ddd7e9b53f7a2d4$export$8d474f55edbb9624);
$parcel$export(module.exports, "SpotLight", () => $9ddd7e9b53f7a2d4$export$81495cbb73897362);
$parcel$export(module.exports, "PointLight", () => $9ddd7e9b53f7a2d4$export$4c9c1cb3f0b6f455);
$parcel$export(module.exports, "OrthographicCamera", () => $9ddd7e9b53f7a2d4$export$9ebf355ee4ed261b);
$parcel$export(module.exports, "DirectionalLight", () => $9ddd7e9b53f7a2d4$export$3fea33cc9972c868);
$parcel$export(module.exports, "AmbientLight", () => $9ddd7e9b53f7a2d4$export$af279bfef9ec2c96);
$parcel$export(module.exports, "RectAreaLight", () => $9ddd7e9b53f7a2d4$export$61db2d908bbd2429);
$parcel$export(module.exports, "SphericalHarmonics3", () => $9ddd7e9b53f7a2d4$export$ba61ce607e1f405a);
$parcel$export(module.exports, "LightProbe", () => $9ddd7e9b53f7a2d4$export$e7ef036e309b38d2);
$parcel$export(module.exports, "MaterialLoader", () => $9ddd7e9b53f7a2d4$export$3bd6d323353dcf96);
$parcel$export(module.exports, "LoaderUtils", () => $9ddd7e9b53f7a2d4$export$b5d2dc08d867e41a);
$parcel$export(module.exports, "InstancedBufferGeometry", () => $9ddd7e9b53f7a2d4$export$231f009cbe414146);
$parcel$export(module.exports, "BufferGeometryLoader", () => $9ddd7e9b53f7a2d4$export$dc275bb96327833a);
$parcel$export(module.exports, "ObjectLoader", () => $9ddd7e9b53f7a2d4$export$40110c8505c5ad19);
$parcel$export(module.exports, "ImageBitmapLoader", () => $9ddd7e9b53f7a2d4$export$52286b55c4a9b51f);
$parcel$export(module.exports, "AudioContext", () => $9ddd7e9b53f7a2d4$export$fcbc63750ec2a81f);
$parcel$export(module.exports, "AudioLoader", () => $9ddd7e9b53f7a2d4$export$d8d5fccfbf47714e);
$parcel$export(module.exports, "StereoCamera", () => $9ddd7e9b53f7a2d4$export$bc7f73a1065bee0c);
$parcel$export(module.exports, "ArrayCamera", () => $9ddd7e9b53f7a2d4$export$56b937d9e5581166);
$parcel$export(module.exports, "Clock", () => $9ddd7e9b53f7a2d4$export$9735c82c4bae3302);
$parcel$export(module.exports, "AudioListener", () => $9ddd7e9b53f7a2d4$export$8a1b810c6fde8951);
$parcel$export(module.exports, "Audio", () => $9ddd7e9b53f7a2d4$export$153755f98d9861de);
$parcel$export(module.exports, "PositionalAudio", () => $9ddd7e9b53f7a2d4$export$4b3e397ef1832507);
$parcel$export(module.exports, "AudioAnalyser", () => $9ddd7e9b53f7a2d4$export$d47da1ef3d382827);
$parcel$export(module.exports, "PropertyMixer", () => $9ddd7e9b53f7a2d4$export$dfe0af1ca1acb78a);
$parcel$export(module.exports, "PropertyBinding", () => $9ddd7e9b53f7a2d4$export$7bf70fcf9f891893);
$parcel$export(module.exports, "AnimationObjectGroup", () => $9ddd7e9b53f7a2d4$export$30619c2afd3f34db);
$parcel$export(module.exports, "AnimationAction", () => $9ddd7e9b53f7a2d4$export$6946940a69e799e);
$parcel$export(module.exports, "AnimationMixer", () => $9ddd7e9b53f7a2d4$export$fbd77e5aefaa0102);
$parcel$export(module.exports, "RenderTarget3D", () => $9ddd7e9b53f7a2d4$export$6b116d2fdfef087c);
$parcel$export(module.exports, "RenderTargetArray", () => $9ddd7e9b53f7a2d4$export$eb4d196341728d65);
$parcel$export(module.exports, "Uniform", () => $9ddd7e9b53f7a2d4$export$2947cebfe91c02f8);
$parcel$export(module.exports, "UniformsGroup", () => $9ddd7e9b53f7a2d4$export$c412d5ffe1f79209);
$parcel$export(module.exports, "InstancedInterleavedBuffer", () => $9ddd7e9b53f7a2d4$export$25ec0e1af1389358);
$parcel$export(module.exports, "GLBufferAttribute", () => $9ddd7e9b53f7a2d4$export$6b7339ae8dbddf73);
$parcel$export(module.exports, "Raycaster", () => $9ddd7e9b53f7a2d4$export$8b7aaceff00bd2f);
$parcel$export(module.exports, "Spherical", () => $9ddd7e9b53f7a2d4$export$d712cd887b4a00f7);
$parcel$export(module.exports, "Cylindrical", () => $9ddd7e9b53f7a2d4$export$287165bb2177f4fd);
$parcel$export(module.exports, "Matrix2", () => $9ddd7e9b53f7a2d4$export$cbcc6560bf79fb38);
$parcel$export(module.exports, "Box2", () => $9ddd7e9b53f7a2d4$export$60f553fa130f08b0);
$parcel$export(module.exports, "Line3", () => $9ddd7e9b53f7a2d4$export$e0ba6359f1954fd3);
$parcel$export(module.exports, "SpotLightHelper", () => $9ddd7e9b53f7a2d4$export$4b14638ffdd81e68);
$parcel$export(module.exports, "SkeletonHelper", () => $9ddd7e9b53f7a2d4$export$5277df3c9e732259);
$parcel$export(module.exports, "PointLightHelper", () => $9ddd7e9b53f7a2d4$export$9a9291685b9e4023);
$parcel$export(module.exports, "HemisphereLightHelper", () => $9ddd7e9b53f7a2d4$export$8dca15f13f4f8172);
$parcel$export(module.exports, "GridHelper", () => $9ddd7e9b53f7a2d4$export$3875d39926561055);
$parcel$export(module.exports, "PolarGridHelper", () => $9ddd7e9b53f7a2d4$export$361430a10f533cd3);
$parcel$export(module.exports, "DirectionalLightHelper", () => $9ddd7e9b53f7a2d4$export$f8e434dc14203e7d);
$parcel$export(module.exports, "CameraHelper", () => $9ddd7e9b53f7a2d4$export$ed8e93f853cd795);
$parcel$export(module.exports, "BoxHelper", () => $9ddd7e9b53f7a2d4$export$38a664cc862a6a9d);
$parcel$export(module.exports, "Box3Helper", () => $9ddd7e9b53f7a2d4$export$ce39f4bb96c9a290);
$parcel$export(module.exports, "PlaneHelper", () => $9ddd7e9b53f7a2d4$export$a34fe8156c66e5d7);
$parcel$export(module.exports, "ArrowHelper", () => $9ddd7e9b53f7a2d4$export$a3008e7bd8d2cbe7);
$parcel$export(module.exports, "AxesHelper", () => $9ddd7e9b53f7a2d4$export$6c8303f35b8578fd);
$parcel$export(module.exports, "ShapePath", () => $9ddd7e9b53f7a2d4$export$148534a3c727230b);
$parcel$export(module.exports, "Controls", () => $9ddd7e9b53f7a2d4$export$c7c44baae9d9f25f);
$parcel$export(module.exports, "getByteLength", () => $9ddd7e9b53f7a2d4$export$cc8c3b705bb8e6e2);
$parcel$export(module.exports, "TextureUtils", () => $9ddd7e9b53f7a2d4$export$ec276d39f33d4b7);
/**
 * @license
 * Copyright 2010-2025 Three.js Authors
 * SPDX-License-Identifier: MIT
 */ const $9ddd7e9b53f7a2d4$export$3545e07a80636437 = '175';
/**
 * Represents mouse buttons and interaction types in context of controls.
 *
 * @type {ConstantsMouse}
 * @constant
 */ const $9ddd7e9b53f7a2d4$export$7177b3e430c2d7ca = {
    LEFT: 0,
    MIDDLE: 1,
    RIGHT: 2,
    ROTATE: 0,
    DOLLY: 1,
    PAN: 2
};
/**
 * Represents touch interaction types in context of controls.
 *
 * @type {ConstantsTouch}
 * @constant
 */ const $9ddd7e9b53f7a2d4$export$d46bd3ead7cc759b = {
    ROTATE: 0,
    PAN: 1,
    DOLLY_PAN: 2,
    DOLLY_ROTATE: 3
};
/**
 * Disables face culling.
 *
 * @type {number}
 * @constant
 */ const $9ddd7e9b53f7a2d4$export$3237e1f2c1ea1f44 = 0;
/**
 * Culls back faces.
 *
 * @type {number}
 * @constant
 */ const $9ddd7e9b53f7a2d4$export$b9a7b4fc5cb15f9b = 1;
/**
 * Culls front faces.
 *
 * @type {number}
 * @constant
 */ const $9ddd7e9b53f7a2d4$export$b8058bcc7037d3f3 = 2;
/**
 * Culls both front and back faces.
 *
 * @type {number}
 * @constant
 */ const $9ddd7e9b53f7a2d4$export$f24be24dcddeac0d = 3;
/**
 * Gives unfiltered shadow maps - fastest, but lowest quality.
 *
 * @type {number}
 * @constant
 */ const $9ddd7e9b53f7a2d4$export$346307dbae2b7447 = 0;
/**
 * Filters shadow maps using the Percentage-Closer Filtering (PCF) algorithm.
 *
 * @type {number}
 * @constant
 */ const $9ddd7e9b53f7a2d4$export$5813f879eee7cd88 = 1;
/**
 * Filters shadow maps using the Percentage-Closer Filtering (PCF) algorithm with
 * better soft shadows especially when using low-resolution shadow maps.
 *
 * @type {number}
 * @constant
 */ const $9ddd7e9b53f7a2d4$export$a47c4b43a1be34f0 = 2;
/**
 * Filters shadow maps using the Variance Shadow Map (VSM) algorithm.
 * When using VSMShadowMap all shadow receivers will also cast shadows.
 *
 * @type {number}
 * @constant
 */ const $9ddd7e9b53f7a2d4$export$896ae1ade6c829c4 = 3;
/**
 * Only front faces are rendered.
 *
 * @type {number}
 * @constant
 */ const $9ddd7e9b53f7a2d4$export$2ede184fc2998901 = 0;
/**
 * Only back faces are rendered.
 *
 * @type {number}
 * @constant
 */ const $9ddd7e9b53f7a2d4$export$d9f0486e75b5ace = 1;
/**
 * Both front and back faces are rendered.
 *
 * @type {number}
 * @constant
 */ const $9ddd7e9b53f7a2d4$export$3b296b6f144d5b03 = 2;
/**
 * No blending is performed which effectively disables
 * alpha transparency.
 *
 * @type {number}
 * @constant
 */ const $9ddd7e9b53f7a2d4$export$63b8d6b580fc65ba = 0;
/**
 * The default blending.
 *
 * @type {number}
 * @constant
 */ const $9ddd7e9b53f7a2d4$export$5b29a26d96ee6af0 = 1;
/**
 * Represents additive blending.
 *
 * @type {number}
 * @constant
 */ const $9ddd7e9b53f7a2d4$export$777d8f9551c2216b = 2;
/**
 * Represents subtractive blending.
 *
 * @type {number}
 * @constant
 */ const $9ddd7e9b53f7a2d4$export$cdfa06f868e2e467 = 3;
/**
 * Represents multiply blending.
 *
 * @type {number}
 * @constant
 */ const $9ddd7e9b53f7a2d4$export$4138e1c684b46a20 = 4;
/**
 * Represents custom blending.
 *
 * @type {number}
 * @constant
 */ const $9ddd7e9b53f7a2d4$export$eda4864c68df1fa2 = 5;
/**
 * A `source + destination` blending equation.
 *
 * @type {number}
 * @constant
 */ const $9ddd7e9b53f7a2d4$export$20183a0484ce21a0 = 100;
/**
 * A `source - destination` blending equation.
 *
 * @type {number}
 * @constant
 */ const $9ddd7e9b53f7a2d4$export$73e0df5177988548 = 101;
/**
 * A `destination - source` blending equation.
 *
 * @type {number}
 * @constant
 */ const $9ddd7e9b53f7a2d4$export$28e582859cbec660 = 102;
/**
 * A blend equation that uses the minimum of source and destination.
 *
 * @type {number}
 * @constant
 */ const $9ddd7e9b53f7a2d4$export$c8c1508da8d0600c = 103;
/**
 * A blend equation that uses the maximum of source and destination.
 *
 * @type {number}
 * @constant
 */ const $9ddd7e9b53f7a2d4$export$99948c02fb51055f = 104;
/**
 * Multiplies all colors by `0`.
 *
 * @type {number}
 * @constant
 */ const $9ddd7e9b53f7a2d4$export$2110f05edf778d3d = 200;
/**
 * Multiplies all colors by `1`.
 *
 * @type {number}
 * @constant
 */ const $9ddd7e9b53f7a2d4$export$8805bad65e24940e = 201;
/**
 * Multiplies all colors by the source colors.
 *
 * @type {number}
 * @constant
 */ const $9ddd7e9b53f7a2d4$export$7fbe15b28d28cf52 = 202;
/**
 * Multiplies all colors by `1` minus each source color.
 *
 * @type {number}
 * @constant
 */ const $9ddd7e9b53f7a2d4$export$947829af9f2c17f6 = 203;
/**
 * Multiplies all colors by the source alpha value.
 *
 * @type {number}
 * @constant
 */ const $9ddd7e9b53f7a2d4$export$d5773124e86cf28c = 204;
/**
 * Multiplies all colors by 1 minus the source alpha value.
 *
 * @type {number}
 * @constant
 */ const $9ddd7e9b53f7a2d4$export$11d468cc7f19e971 = 205;
/**
 * Multiplies all colors by the destination alpha value.
 *
 * @type {number}
 * @constant
 */ const $9ddd7e9b53f7a2d4$export$a78aed1ca2a87192 = 206;
/**
 * Multiplies all colors by `1` minus the destination alpha value.
 *
 * @type {number}
 * @constant
 */ const $9ddd7e9b53f7a2d4$export$5d0fe17fd8773bac = 207;
/**
 * Multiplies all colors by the destination color.
 *
 * @type {number}
 * @constant
 */ const $9ddd7e9b53f7a2d4$export$ef5f2dd8ffac5574 = 208;
/**
 * Multiplies all colors by `1` minus each destination color.
 *
 * @type {number}
 * @constant
 */ const $9ddd7e9b53f7a2d4$export$56b85b2686ab16 = 209;
/**
 * Multiplies the RGB colors by the smaller of either the source alpha
 * value or the value of `1` minus the destination alpha value. The alpha
 * value is multiplied by `1`.
 *
 * @type {number}
 * @constant
 */ const $9ddd7e9b53f7a2d4$export$c05e2a1fc8609506 = 210;
/**
 * Multiplies all colors by a constant color.
 *
 * @type {number}
 * @constant
 */ const $9ddd7e9b53f7a2d4$export$7dd8f434fd59075 = 211;
/**
 * Multiplies all colors by `1` minus a constant color.
 *
 * @type {number}
 * @constant
 */ const $9ddd7e9b53f7a2d4$export$99c8d898a9afbcee = 212;
/**
 * Multiplies all colors by a constant alpha value.
 *
 * @type {number}
 * @constant
 */ const $9ddd7e9b53f7a2d4$export$310cd2be38d13b56 = 213;
/**
 * Multiplies all colors by 1 minus a constant alpha value.
 *
 * @type {number}
 * @constant
 */ const $9ddd7e9b53f7a2d4$export$db77b8fbcf45dbf4 = 214;
/**
 * Never pass.
 *
 * @type {number}
 * @constant
 */ const $9ddd7e9b53f7a2d4$export$69025ce147cee220 = 0;
/**
 * Always pass.
 *
 * @type {number}
 * @constant
 */ const $9ddd7e9b53f7a2d4$export$7182eb52ea3b3f04 = 1;
/**
 * Pass if the incoming value is less than the depth buffer value.
 *
 * @type {number}
 * @constant
 */ const $9ddd7e9b53f7a2d4$export$eedccec66ab7ebe = 2;
/**
 * Pass if the incoming value is less than or equal to the depth buffer value.
 *
 * @type {number}
 * @constant
 */ const $9ddd7e9b53f7a2d4$export$296f78a0b892f81a = 3;
/**
 * Pass if the incoming value equals the depth buffer value.
 *
 * @type {number}
 * @constant
 */ const $9ddd7e9b53f7a2d4$export$a60d398fc7b7590e = 4;
/**
 * Pass if the incoming value is greater than or equal to the depth buffer value.
 *
 * @type {number}
 * @constant
 */ const $9ddd7e9b53f7a2d4$export$7d7234c1240a1fc4 = 5;
/**
 * Pass if the incoming value is greater than the depth buffer value.
 *
 * @type {number}
 * @constant
 */ const $9ddd7e9b53f7a2d4$export$c5e2c52991f30937 = 6;
/**
 * Pass if the incoming value is not equal to the depth buffer value.
 *
 * @type {number}
 * @constant
 */ const $9ddd7e9b53f7a2d4$export$2f843afa843d8916 = 7;
/**
 * Multiplies the environment map color with the surface color.
 *
 * @type {number}
 * @constant
 */ const $9ddd7e9b53f7a2d4$export$e50ac29801f1774d = 0;
/**
 * Uses reflectivity to blend between the two colors.
 *
 * @type {number}
 * @constant
 */ const $9ddd7e9b53f7a2d4$export$9f9d94f963c85479 = 1;
/**
 * Adds the two colors.
 *
 * @type {number}
 * @constant
 */ const $9ddd7e9b53f7a2d4$export$e641dc52bc3494aa = 2;
/**
 * No tone mapping is applied.
 *
 * @type {number}
 * @constant
 */ const $9ddd7e9b53f7a2d4$export$9fcb6b4294603b2 = 0;
/**
 * Linear tone mapping.
 *
 * @type {number}
 * @constant
 */ const $9ddd7e9b53f7a2d4$export$98f52c2a46c598ca = 1;
/**
 * Reinhard tone mapping.
 *
 * @type {number}
 * @constant
 */ const $9ddd7e9b53f7a2d4$export$74b25e54b3bcd548 = 2;
/**
 * Cineon tone mapping.
 *
 * @type {number}
 * @constant
 */ const $9ddd7e9b53f7a2d4$export$932b3dd283d4a366 = 3;
/**
 * ACES Filmic tone mapping.
 *
 * @type {number}
 * @constant
 */ const $9ddd7e9b53f7a2d4$export$a0d98fe6d7e4af64 = 4;
/**
 * Custom tone mapping.
 *
 * Expects a custom implementation by modifying shader code of the material's fragment shader.
 *
 * @type {number}
 * @constant
 */ const $9ddd7e9b53f7a2d4$export$2c7b09c1e9abfb5e = 5;
/**
 * AgX tone mapping.
 *
 * @type {number}
 * @constant
 */ const $9ddd7e9b53f7a2d4$export$212d53a513a325b2 = 6;
/**
 * Neutral tone mapping.
 *
 * Implementation based on the Khronos 3D Commerce Group standard tone mapping.
 *
 * @type {number}
 * @constant
 */ const $9ddd7e9b53f7a2d4$export$f2863e1668a8e317 = 7;
/**
 * The skinned mesh shares the same world space as the skeleton.
 *
 * @type {string}
 * @constant
 */ const $9ddd7e9b53f7a2d4$export$2595a3798997538 = 'attached';
/**
 * The skinned mesh does not share the same world space as the skeleton.
 * This is useful when a skeleton is shared across multiple skinned meshes.
 *
 * @type {string}
 * @constant
 */ const $9ddd7e9b53f7a2d4$export$d7e7dc2e114517a0 = 'detached';
/**
 * Maps textures using the geometry's UV coordinates.
 *
 * @type {number}
 * @constant
 */ const $9ddd7e9b53f7a2d4$export$1beec6768cbb3d2d = 300;
/**
 * Reflection mapping for cube textures.
 *
 * @type {number}
 * @constant
 */ const $9ddd7e9b53f7a2d4$export$8759762a6477f2c4 = 301;
/**
 * Refraction mapping for cube textures.
 *
 * @type {number}
 * @constant
 */ const $9ddd7e9b53f7a2d4$export$dc59f8aed047f61d = 302;
/**
 * Reflection mapping for equirectangular textures.
 *
 * @type {number}
 * @constant
 */ const $9ddd7e9b53f7a2d4$export$d64030b316d3b087 = 303;
/**
 * Refraction mapping for equirectangular textures.
 *
 * @type {number}
 * @constant
 */ const $9ddd7e9b53f7a2d4$export$ee99d97d46898098 = 304;
/**
 * Reflection mapping for PMREM textures.
 *
 * @type {number}
 * @constant
 */ const $9ddd7e9b53f7a2d4$export$dbf3e70ff37af79 = 306;
/**
 * The texture will simply repeat to infinity.
 *
 * @type {number}
 * @constant
 */ const $9ddd7e9b53f7a2d4$export$533346c8e8dac0f5 = 1000;
/**
 * The last pixel of the texture stretches to the edge of the mesh.
 *
 * @type {number}
 * @constant
 */ const $9ddd7e9b53f7a2d4$export$9d9334239a5a5e06 = 1001;
/**
 * The texture will repeats to infinity, mirroring on each repeat.
 *
 * @type {number}
 * @constant
 */ const $9ddd7e9b53f7a2d4$export$c7e7c00b14f51a4f = 1002;
/**
 * Returns the value of the texture element that is nearest (in Manhattan distance)
 * to the specified texture coordinates.
 *
 * @type {number}
 * @constant
 */ const $9ddd7e9b53f7a2d4$export$727aa5ec3fe39bf0 = 1003;
/**
 * Chooses the mipmap that most closely matches the size of the pixel being textured
 * and uses the `NearestFilter` criterion (the texel nearest to the center of the pixel)
 * to produce a texture value.
 *
 * @type {number}
 * @constant
 */ const $9ddd7e9b53f7a2d4$export$d129e38cf6feaa8c = 1004;
const $9ddd7e9b53f7a2d4$export$14a4936464a36496 = 1004; // legacy
/**
 * Chooses the two mipmaps that most closely match the size of the pixel being textured and
 * uses the `NearestFilter` criterion to produce a texture value from each mipmap.
 * The final texture value is a weighted average of those two values.
 *
 * @type {number}
 * @constant
 */ const $9ddd7e9b53f7a2d4$export$d2327c1afe5bfdf2 = 1005;
const $9ddd7e9b53f7a2d4$export$cbc5b7f5647595d8 = 1005; // legacy
/**
 * Returns the weighted average of the four texture elements that are closest to the specified
 * texture coordinates, and can include items wrapped or repeated from other parts of a texture,
 * depending on the values of `wrapS` and `wrapT`, and on the exact mapping.
 *
 * @type {number}
 * @constant
 */ const $9ddd7e9b53f7a2d4$export$8a72f490b25c56c8 = 1006;
/**
 * Chooses the mipmap that most closely matches the size of the pixel being textured and uses
 * the `LinearFilter` criterion (a weighted average of the four texels that are closest to the
 * center of the pixel) to produce a texture value.
 *
 * @type {number}
 * @constant
 */ const $9ddd7e9b53f7a2d4$export$19a719f377145a13 = 1007;
const $9ddd7e9b53f7a2d4$export$dbe96bee3fe9dbf0 = 1007; // legacy
/**
 * Chooses the two mipmaps that most closely match the size of the pixel being textured and uses
 * the `LinearFilter` criterion to produce a texture value from each mipmap. The final texture value
 * is a weighted average of those two values.
 *
 * @type {number}
 * @constant
 */ const $9ddd7e9b53f7a2d4$export$5d8599b6a933fb1b = 1008;
const $9ddd7e9b53f7a2d4$export$90d80f1e3506775f = 1008; // legacy
/**
 * An unsigned byte data type for textures.
 *
 * @type {number}
 * @constant
 */ const $9ddd7e9b53f7a2d4$export$2e8ce08d3f6f5e10 = 1009;
/**
 * A byte data type for textures.
 *
 * @type {number}
 * @constant
 */ const $9ddd7e9b53f7a2d4$export$545fce0311a9796a = 1010;
/**
 * A short data type for textures.
 *
 * @type {number}
 * @constant
 */ const $9ddd7e9b53f7a2d4$export$88572337f312435f = 1011;
/**
 * An unsigned short data type for textures.
 *
 * @type {number}
 * @constant
 */ const $9ddd7e9b53f7a2d4$export$c63dc51868b06a9d = 1012;
/**
 * An int data type for textures.
 *
 * @type {number}
 * @constant
 */ const $9ddd7e9b53f7a2d4$export$5c612977753abe2 = 1013;
/**
 * An unsigned int data type for textures.
 *
 * @type {number}
 * @constant
 */ const $9ddd7e9b53f7a2d4$export$c3c7fc4518ebba96 = 1014;
/**
 * A float data type for textures.
 *
 * @type {number}
 * @constant
 */ const $9ddd7e9b53f7a2d4$export$f6d331659b644596 = 1015;
/**
 * A half float data type for textures.
 *
 * @type {number}
 * @constant
 */ const $9ddd7e9b53f7a2d4$export$2697304443f382bc = 1016;
/**
 * An unsigned short 4_4_4_4 (packed) data type for textures.
 *
 * @type {number}
 * @constant
 */ const $9ddd7e9b53f7a2d4$export$b3969b01faf587f2 = 1017;
/**
 * An unsigned short 5_5_5_1 (packed) data type for textures.
 *
 * @type {number}
 * @constant
 */ const $9ddd7e9b53f7a2d4$export$18886f8ae33e90de = 1018;
/**
 * An unsigned int 24_8 data type for textures.
 *
 * @type {number}
 * @constant
 */ const $9ddd7e9b53f7a2d4$export$6c8ea339bfab1301 = 1020;
/**
 * An unsigned int 5_9_9_9 (packed) data type for textures.
 *
 * @type {number}
 * @constant
 */ const $9ddd7e9b53f7a2d4$export$5a4c329b7e2092d3 = 35902;
/**
 * Discards the red, green and blue components and reads just the alpha component.
 *
 * @type {number}
 * @constant
 */ const $9ddd7e9b53f7a2d4$export$988473390501ed4b = 1021;
/**
 * Discards the alpha component and reads the red, green and blue component.
 *
 * @type {number}
 * @constant
 */ const $9ddd7e9b53f7a2d4$export$7c67423a5ee6f5eb = 1022;
/**
 * Reads the red, green, blue and alpha components.
 *
 * @type {number}
 * @constant
 */ const $9ddd7e9b53f7a2d4$export$3f8bb04b555a363c = 1023;
/**
 * reads each element as a single luminance component. This is then converted to a floating point,
 * clamped to the range `[0,1]`, and then assembled into an RGBA element by placing the luminance value
 * in the red, green and blue channels, and attaching 1.0 to the alpha channel.
 *
 * @type {number}
 * @constant
 */ const $9ddd7e9b53f7a2d4$export$cc09ccbf6d1ed449 = 1024;
/**
 * Reads each element as a luminance/alpha double. The same process occurs as for the `LuminanceFormat`,
 * except that the alpha channel may have values other than `1.0`.
 *
 * @type {number}
 * @constant
 */ const $9ddd7e9b53f7a2d4$export$9053a81c4a69c289 = 1025;
/**
 * Reads each element as a single depth value, converts it to floating point, and clamps to the range `[0,1]`.
 *
 * @type {number}
 * @constant
 */ const $9ddd7e9b53f7a2d4$export$c1b6b5136be58045 = 1026;
/**
 * Reads each element is a pair of depth and stencil values. The depth component of the pair is interpreted as
 * in `DepthFormat`. The stencil component is interpreted based on the depth + stencil internal format.
 *
 * @type {number}
 * @constant
 */ const $9ddd7e9b53f7a2d4$export$1e113ac2d0905829 = 1027;
/**
 * Discards the green, blue and alpha components and reads just the red component.
 *
 * @type {number}
 * @constant
 */ const $9ddd7e9b53f7a2d4$export$4e041a7967d15c4b = 1028;
/**
 * Discards the green, blue and alpha components and reads just the red component. The texels are read as integers instead of floating point.
 *
 * @type {number}
 * @constant
 */ const $9ddd7e9b53f7a2d4$export$aa92e870a709d190 = 1029;
/**
 * Discards the alpha, and blue components and reads the red, and green components.
 *
 * @type {number}
 * @constant
 */ const $9ddd7e9b53f7a2d4$export$6cdf0b461c7ce8a0 = 1030;
/**
 * Discards the alpha, and blue components and reads the red, and green components. The texels are read as integers instead of floating point.
 *
 * @type {number}
 * @constant
 */ const $9ddd7e9b53f7a2d4$export$1ba1c45f9f77d4d7 = 1031;
/**
 * Discards the alpha component and reads the red, green and blue component. The texels are read as integers instead of floating point.
 *
 * @type {number}
 * @constant
 */ const $9ddd7e9b53f7a2d4$export$d1fd40c11bfa798e = 1032;
/**
 * Reads the red, green, blue and alpha components. The texels are read as integers instead of floating point.
 *
 * @type {number}
 * @constant
 */ const $9ddd7e9b53f7a2d4$export$c200e7d26f592f21 = 1033;
/**
 * A DXT1-compressed image in an RGB image format.
 *
 * @type {number}
 * @constant
 */ const $9ddd7e9b53f7a2d4$export$21d1799c6d552fc0 = 33776;
/**
 * A DXT1-compressed image in an RGB image format with a simple on/off alpha value.
 *
 * @type {number}
 * @constant
 */ const $9ddd7e9b53f7a2d4$export$afa304c3e981b668 = 33777;
/**
 * A DXT3-compressed image in an RGBA image format. Compared to a 32-bit RGBA texture, it offers 4:1 compression.
 *
 * @type {number}
 * @constant
 */ const $9ddd7e9b53f7a2d4$export$d2a1a68024a3e56c = 33778;
/**
 * A DXT5-compressed image in an RGBA image format. It also provides a 4:1 compression, but differs to the DXT3
 * compression in how the alpha compression is done.
 *
 * @type {number}
 * @constant
 */ const $9ddd7e9b53f7a2d4$export$9a79c424327dacf9 = 33779;
/**
 * PVRTC RGB compression in 4-bit mode. One block for each 4×4 pixels.
 *
 * @type {number}
 * @constant
 */ const $9ddd7e9b53f7a2d4$export$19ada9bbb1af3573 = 35840;
/**
 * PVRTC RGB compression in 2-bit mode. One block for each 8×4 pixels.
 *
 * @type {number}
 * @constant
 */ const $9ddd7e9b53f7a2d4$export$d0f0355bb3d948e4 = 35841;
/**
 * PVRTC RGBA compression in 4-bit mode. One block for each 4×4 pixels.
 *
 * @type {number}
 * @constant
 */ const $9ddd7e9b53f7a2d4$export$b82296714358084c = 35842;
/**
 * PVRTC RGBA compression in 2-bit mode. One block for each 8×4 pixels.
 *
 * @type {number}
 * @constant
 */ const $9ddd7e9b53f7a2d4$export$b71692456c47b6c3 = 35843;
/**
 * ETC1 RGB format.
 *
 * @type {number}
 * @constant
 */ const $9ddd7e9b53f7a2d4$export$6ab91af2d757aee7 = 36196;
/**
 * ETC2 RGB format.
 *
 * @type {number}
 * @constant
 */ const $9ddd7e9b53f7a2d4$export$7800993ef8106a6a = 37492;
/**
 * ETC2 RGBA format.
 *
 * @type {number}
 * @constant
 */ const $9ddd7e9b53f7a2d4$export$23ed8300a860e7d8 = 37496;
/**
 * ASTC RGBA 4x4 format.
 *
 * @type {number}
 * @constant
 */ const $9ddd7e9b53f7a2d4$export$dc5570b4a2b92d48 = 37808;
/**
 * ASTC RGBA 5x4 format.
 *
 * @type {number}
 * @constant
 */ const $9ddd7e9b53f7a2d4$export$68880cd325f8b2fb = 37809;
/**
 * ASTC RGBA 5x5 format.
 *
 * @type {number}
 * @constant
 */ const $9ddd7e9b53f7a2d4$export$7d2c0be323373d95 = 37810;
/**
 * ASTC RGBA 6x5 format.
 *
 * @type {number}
 * @constant
 */ const $9ddd7e9b53f7a2d4$export$22b52da301fc3a3e = 37811;
/**
 * ASTC RGBA 6x6 format.
 *
 * @type {number}
 * @constant
 */ const $9ddd7e9b53f7a2d4$export$c009e2cb4a66485e = 37812;
/**
 * ASTC RGBA 8x5 format.
 *
 * @type {number}
 * @constant
 */ const $9ddd7e9b53f7a2d4$export$118fff5afa255b63 = 37813;
/**
 * ASTC RGBA 8x6 format.
 *
 * @type {number}
 * @constant
 */ const $9ddd7e9b53f7a2d4$export$120713c829ae0667 = 37814;
/**
 * ASTC RGBA 8x8 format.
 *
 * @type {number}
 * @constant
 */ const $9ddd7e9b53f7a2d4$export$c79eeabbf53313e9 = 37815;
/**
 * ASTC RGBA 10x5 format.
 *
 * @type {number}
 * @constant
 */ const $9ddd7e9b53f7a2d4$export$443cf6567cdd6424 = 37816;
/**
 * ASTC RGBA 10x6 format.
 *
 * @type {number}
 * @constant
 */ const $9ddd7e9b53f7a2d4$export$6573984fc9840780 = 37817;
/**
 * ASTC RGBA 10x8 format.
 *
 * @type {number}
 * @constant
 */ const $9ddd7e9b53f7a2d4$export$e7aee563f30091de = 37818;
/**
 * ASTC RGBA 10x10 format.
 *
 * @type {number}
 * @constant
 */ const $9ddd7e9b53f7a2d4$export$2eb8634622ddeab7 = 37819;
/**
 * ASTC RGBA 12x10 format.
 *
 * @type {number}
 * @constant
 */ const $9ddd7e9b53f7a2d4$export$202b1ce7b5d25742 = 37820;
/**
 * ASTC RGBA 12x12 format.
 *
 * @type {number}
 * @constant
 */ const $9ddd7e9b53f7a2d4$export$18ab77abd087e467 = 37821;
/**
 * BPTC RGBA format.
 *
 * @type {number}
 * @constant
 */ const $9ddd7e9b53f7a2d4$export$ce40b115e188bc81 = 36492;
/**
 * BPTC Signed RGB format.
 *
 * @type {number}
 * @constant
 */ const $9ddd7e9b53f7a2d4$export$d279c5c4bac5121e = 36494;
/**
 * BPTC Unsigned RGB format.
 *
 * @type {number}
 * @constant
 */ const $9ddd7e9b53f7a2d4$export$cde52d17225fdbd3 = 36495;
/**
 * RGTC1 Red format.
 *
 * @type {number}
 * @constant
 */ const $9ddd7e9b53f7a2d4$export$b1688df4c4c21670 = 36283;
/**
 * RGTC1 Signed Red format.
 *
 * @type {number}
 * @constant
 */ const $9ddd7e9b53f7a2d4$export$fc15e5d8261eed58 = 36284;
/**
 * RGTC2 Red Green format.
 *
 * @type {number}
 * @constant
 */ const $9ddd7e9b53f7a2d4$export$d220f6ade8463a0f = 36285;
/**
 * RGTC2 Signed Red Green format.
 *
 * @type {number}
 * @constant
 */ const $9ddd7e9b53f7a2d4$export$768646d09dc1b6ef = 36286;
/**
 * Animations are played once.
 *
 * @type {number}
 * @constant
 */ const $9ddd7e9b53f7a2d4$export$d62fdc9d1b1cccad = 2200;
/**
 * Animations are played with a chosen number of repetitions, each time jumping from
 * the end of the clip directly to its beginning.
 *
 * @type {number}
 * @constant
 */ const $9ddd7e9b53f7a2d4$export$dfaf4422ce096e29 = 2201;
/**
 * Animations are played with a chosen number of repetitions, alternately playing forward
 * and backward.
 *
 * @type {number}
 * @constant
 */ const $9ddd7e9b53f7a2d4$export$f8f6f2041b78e210 = 2202;
/**
 * Discrete interpolation mode for keyframe tracks.
 *
 * @type {number}
 * @constant
 */ const $9ddd7e9b53f7a2d4$export$995b32462a65e855 = 2300;
/**
 * Linear interpolation mode for keyframe tracks.
 *
 * @type {number}
 * @constant
 */ const $9ddd7e9b53f7a2d4$export$30fac1aace31cf4d = 2301;
/**
 * Smooth interpolation mode for keyframe tracks.
 *
 * @type {number}
 * @constant
 */ const $9ddd7e9b53f7a2d4$export$198b11ff4c72bb30 = 2302;
/**
 * Zero curvature ending for animations.
 *
 * @type {number}
 * @constant
 */ const $9ddd7e9b53f7a2d4$export$7f795934b84ab523 = 2400;
/**
 * Zero slope ending for animations.
 *
 * @type {number}
 * @constant
 */ const $9ddd7e9b53f7a2d4$export$24a4ccb5099273b5 = 2401;
/**
 * Wrap around ending for animations.
 *
 * @type {number}
 * @constant
 */ const $9ddd7e9b53f7a2d4$export$8e8c3ecdcd8e1fee = 2402;
/**
 * Default animation blend mode.
 *
 * @type {number}
 * @constant
 */ const $9ddd7e9b53f7a2d4$export$bcfbbdcf8de7f8cd = 2500;
/**
 * Additive animation blend mode. Can be used to layer motions on top of
 * each other to build complex performances from smaller re-usable assets.
 *
 * @type {number}
 * @constant
 */ const $9ddd7e9b53f7a2d4$export$d875e029ef558d3 = 2501;
/**
 * For every three vertices draw a single triangle.
 *
 * @type {number}
 * @constant
 */ const $9ddd7e9b53f7a2d4$export$4c28c87c2dc84758 = 0;
/**
 * For each vertex draw a triangle from the last three vertices.
 *
 * @type {number}
 * @constant
 */ const $9ddd7e9b53f7a2d4$export$b23a071aa286eb29 = 1;
/**
 * For each vertex draw a triangle from the first vertex and the last two vertices.
 *
 * @type {number}
 * @constant
 */ const $9ddd7e9b53f7a2d4$export$f0d8293634f88842 = 2;
/**
 * Basic depth packing.
 *
 * @type {number}
 * @constant
 */ const $9ddd7e9b53f7a2d4$export$deeb383078690b50 = 3200;
/**
 * A depth value is packed into 32 bit RGBA.
 *
 * @type {number}
 * @constant
 */ const $9ddd7e9b53f7a2d4$export$8f910f4c4f73df11 = 3201;
/**
 * A depth value is packed into 24 bit RGB.
 *
 * @type {number}
 * @constant
 */ const $9ddd7e9b53f7a2d4$export$be2e2ddbc3983173 = 3202;
/**
 * A depth value is packed into 16 bit RG.
 *
 * @type {number}
 * @constant
 */ const $9ddd7e9b53f7a2d4$export$1a54198784742f80 = 3203;
/**
 * Normal information is relative to the underlying surface.
 *
 * @type {number}
 * @constant
 */ const $9ddd7e9b53f7a2d4$export$2852a58ebdac27b8 = 0;
/**
 * Normal information is relative to the object orientation.
 *
 * @type {number}
 * @constant
 */ const $9ddd7e9b53f7a2d4$export$9990ad26f9db5b2c = 1;
// Color space string identifiers, matching CSS Color Module Level 4 and WebGPU names where available.
/**
 * No color space.
 *
 * @type {string}
 * @constant
 */ const $9ddd7e9b53f7a2d4$export$bfcb490c2dd3db51 = '';
/**
 * sRGB color space.
 *
 * @type {string}
 * @constant
 */ const $9ddd7e9b53f7a2d4$export$561f394b24edfcaa = 'srgb';
/**
 * sRGB-linear color space.
 *
 * @type {string}
 * @constant
 */ const $9ddd7e9b53f7a2d4$export$42429b3acfb233a4 = 'srgb-linear';
/**
 * Linear transfer function.
 *
 * @type {string}
 * @constant
 */ const $9ddd7e9b53f7a2d4$export$f197347d588c1b4a = 'linear';
/**
 * sRGB transfer function.
 *
 * @type {string}
 * @constant
 */ const $9ddd7e9b53f7a2d4$export$8d0a61916cc26abb = 'srgb';
/**
 * Sets the stencil buffer value to `0`.
 *
 * @type {number}
 * @constant
 */ const $9ddd7e9b53f7a2d4$export$69433f11f42d5527 = 0;
/**
 * Keeps the current value.
 *
 * @type {number}
 * @constant
 */ const $9ddd7e9b53f7a2d4$export$9f542ae4b5baca34 = 7680;
/**
 * Sets the stencil buffer value to the specified reference value.
 *
 * @type {number}
 * @constant
 */ const $9ddd7e9b53f7a2d4$export$8a4f28336ef203d3 = 7681;
/**
 * Increments the current stencil buffer value. Clamps to the maximum representable unsigned value.
 *
 * @type {number}
 * @constant
 */ const $9ddd7e9b53f7a2d4$export$2928c0231297c036 = 7682;
/**
 * Decrements the current stencil buffer value. Clamps to `0`.
 *
 * @type {number}
 * @constant
 */ const $9ddd7e9b53f7a2d4$export$c0e9611c8a15f9a8 = 7683;
/**
 * Increments the current stencil buffer value. Wraps stencil buffer value to zero when incrementing
 * the maximum representable unsigned value.
 *
 * @type {number}
 * @constant
 */ const $9ddd7e9b53f7a2d4$export$9c2c08927385dcc4 = 34055;
/**
 * Decrements the current stencil buffer value. Wraps stencil buffer value to the maximum representable
 * unsigned value when decrementing a stencil buffer value of `0`.
 *
 * @type {number}
 * @constant
 */ const $9ddd7e9b53f7a2d4$export$7c74ea00fa1315e6 = 34056;
/**
 * Inverts the current stencil buffer value bitwise.
 *
 * @type {number}
 * @constant
 */ const $9ddd7e9b53f7a2d4$export$22e2e5726612443 = 5386;
/**
 * Will never return true.
 *
 * @type {number}
 * @constant
 */ const $9ddd7e9b53f7a2d4$export$1343870698229224 = 512;
/**
 * Will return true if the stencil reference value is less than the current stencil value.
 *
 * @type {number}
 * @constant
 */ const $9ddd7e9b53f7a2d4$export$8e1d8ed281997fa6 = 513;
/**
 * Will return true if the stencil reference value is equal to the current stencil value.
 *
 * @type {number}
 * @constant
 */ const $9ddd7e9b53f7a2d4$export$55648a1cde8329a7 = 514;
/**
 * Will return true if the stencil reference value is less than or equal to the current stencil value.
 *
 * @type {number}
 * @constant
 */ const $9ddd7e9b53f7a2d4$export$2dff107857e6aca2 = 515;
/**
 * Will return true if the stencil reference value is greater than the current stencil value.
 *
 * @type {number}
 * @constant
 */ const $9ddd7e9b53f7a2d4$export$6f93765ab2f451a2 = 516;
/**
 * Will return true if the stencil reference value is not equal to the current stencil value.
 *
 * @type {number}
 * @constant
 */ const $9ddd7e9b53f7a2d4$export$6f3fb2d2440f2b76 = 517;
/**
 * Will return true if the stencil reference value is greater than or equal to the current stencil value.
 *
 * @type {number}
 * @constant
 */ const $9ddd7e9b53f7a2d4$export$4119cf7b4c98fd5a = 518;
/**
 * Will always return true.
 *
 * @type {number}
 * @constant
 */ const $9ddd7e9b53f7a2d4$export$14cf96713ddd97a8 = 519;
/**
 * Never pass.
 *
 * @type {number}
 * @constant
 */ const $9ddd7e9b53f7a2d4$export$d9e2d19a747baaab = 512;
/**
 * Pass if the incoming value is less than the texture value.
 *
 * @type {number}
 * @constant
 */ const $9ddd7e9b53f7a2d4$export$36bcf49c713b3eb7 = 513;
/**
 * Pass if the incoming value equals the texture value.
 *
 * @type {number}
 * @constant
 */ const $9ddd7e9b53f7a2d4$export$66f28d946fc6a0d5 = 514;
/**
 * Pass if the incoming value is less than or equal to the texture value.
 *
 * @type {number}
 * @constant
 */ const $9ddd7e9b53f7a2d4$export$64eea11eb407ddf1 = 515;
/**
 * Pass if the incoming value is greater than the texture value.
 *
 * @type {number}
 * @constant
 */ const $9ddd7e9b53f7a2d4$export$155af022118f3a38 = 516;
/**
 * Pass if the incoming value is not equal to the texture value.
 *
 * @type {number}
 * @constant
 */ const $9ddd7e9b53f7a2d4$export$67ab95dde6bed156 = 517;
/**
 * Pass if the incoming value is greater than or equal to the texture value.
 *
 * @type {number}
 * @constant
 */ const $9ddd7e9b53f7a2d4$export$1cdcb70d53d65f61 = 518;
/**
 * Always pass.
 *
 * @type {number}
 * @constant
 */ const $9ddd7e9b53f7a2d4$export$187b73a3e352c145 = 519;
/**
 * The contents are intended to be specified once by the application, and used many
 * times as the source for drawing and image specification commands.
 *
 * @type {number}
 * @constant
 */ const $9ddd7e9b53f7a2d4$export$763e8360f4d7f77d = 35044;
/**
 * The contents are intended to be respecified repeatedly by the application, and
 * used many times as the source for drawing and image specification commands.
 *
 * @type {number}
 * @constant
 */ const $9ddd7e9b53f7a2d4$export$8505d14ac8546ca = 35048;
/**
 * The contents are intended to be specified once by the application, and used at most
 * a few times as the source for drawing and image specification commands.
 *
 * @type {number}
 * @constant
 */ const $9ddd7e9b53f7a2d4$export$721e63549e51d81e = 35040;
/**
 * The contents are intended to be specified once by reading data from the 3D API, and queried
 * many times by the application.
 *
 * @type {number}
 * @constant
 */ const $9ddd7e9b53f7a2d4$export$415731dc4f48e299 = 35045;
/**
 * The contents are intended to be respecified repeatedly by reading data from the 3D API, and queried
 * many times by the application.
 *
 * @type {number}
 * @constant
 */ const $9ddd7e9b53f7a2d4$export$9e809946455f13bc = 35049;
/**
 * The contents are intended to be specified once by reading data from the 3D API, and queried at most
 * a few times by the application
 *
 * @type {number}
 * @constant
 */ const $9ddd7e9b53f7a2d4$export$2ed9499a35b5f832 = 35041;
/**
 * The contents are intended to be specified once by reading data from the 3D API, and used many times as
 * the source for WebGL drawing and image specification commands.
 *
 * @type {number}
 * @constant
 */ const $9ddd7e9b53f7a2d4$export$32ab2503ea19469a = 35046;
/**
 * The contents are intended to be respecified repeatedly by reading data from the 3D API, and used many times
 * as the source for WebGL drawing and image specification commands.
 *
 * @type {number}
 * @constant
 */ const $9ddd7e9b53f7a2d4$export$ab4022c2c3f86315 = 35050;
/**
 * The contents are intended to be specified once by reading data from the 3D API, and used at most a few times
 * as the source for WebGL drawing and image specification commands.
 *
 * @type {number}
 * @constant
 */ const $9ddd7e9b53f7a2d4$export$ba7f1db36a76a970 = 35042;
/**
 * GLSL 1 shader code.
 *
 * @type {string}
 * @constant
 */ const $9ddd7e9b53f7a2d4$export$43600cc67fabd9f = '100';
/**
 * GLSL 3 shader code.
 *
 * @type {string}
 * @constant
 */ const $9ddd7e9b53f7a2d4$export$f63012db5506e7dd = '300 es';
/**
 * WebGL coordinate system.
 *
 * @type {number}
 * @constant
 */ const $9ddd7e9b53f7a2d4$export$5a0e9190d10875d3 = 2000;
/**
 * WebGPU coordinate system.
 *
 * @type {number}
 * @constant
 */ const $9ddd7e9b53f7a2d4$export$cc83beedcb9be9ac = 2001;
/**
 * Represents the different timestamp query types.
 *
 * @type {ConstantsTimestampQuery}
 * @constant
 */ const $9ddd7e9b53f7a2d4$export$f97db56e2b647801 = {
    COMPUTE: 'compute',
    RENDER: 'render'
};
/**
 * This type represents mouse buttons and interaction types in context of controls.
 *
 * @typedef {Object} ConstantsMouse
 * @property {number} MIDDLE - The left mouse button.
 * @property {number} LEFT - The middle mouse button.
 * @property {number} RIGHT - The right mouse button.
 * @property {number} ROTATE - A rotate interaction.
 * @property {number} DOLLY - A dolly interaction.
 * @property {number} PAN - A pan interaction.
 **/ /**
 * This type represents touch interaction types in context of controls.
 *
 * @typedef {Object} ConstantsTouch
 * @property {number} ROTATE - A rotate interaction.
 * @property {number} PAN - A pan interaction.
 * @property {number} DOLLY_PAN - The dolly-pan interaction.
 * @property {number} DOLLY_ROTATE - A dolly-rotate interaction.
 **/ /**
 * This type represents the different timestamp query types.
 *
 * @typedef {Object} ConstantsTimestampQuery
 * @property {string} COMPUTE - A `compute` timestamp query.
 * @property {string} RENDER - A `render` timestamp query.
 **/ /**
 * This modules allows to dispatch event objects on custom JavaScript objects.
 *
 * Main repository: [eventdispatcher.js]{@link https://github.com/mrdoob/eventdispatcher.js/}
 *
 * Code Example:
 * ```js
 * class Car extends EventDispatcher {
 * 	start() {
 *		this.dispatchEvent( { type: 'start', message: 'vroom vroom!' } );
 *	}
 *};
 *
 * // Using events with the custom object
 * const car = new Car();
 * car.addEventListener( 'start', function ( event ) {
 * 	alert( event.message );
 * } );
 *
 * car.start();
 * ```
 */ class $9ddd7e9b53f7a2d4$export$ec8b666c5fe2c75a {
    /**
	 * Adds the given event listener to the given event type.
	 *
	 * @param {string} type - The type of event to listen to.
	 * @param {Function} listener - The function that gets called when the event is fired.
	 */ addEventListener(type, listener) {
        if (this._listeners === undefined) this._listeners = {};
        const listeners = this._listeners;
        if (listeners[type] === undefined) listeners[type] = [];
        if (listeners[type].indexOf(listener) === -1) listeners[type].push(listener);
    }
    /**
	 * Returns `true` if the given event listener has been added to the given event type.
	 *
	 * @param {string} type - The type of event.
	 * @param {Function} listener - The listener to check.
	 * @return {boolean} Whether the given event listener has been added to the given event type.
	 */ hasEventListener(type, listener) {
        const listeners = this._listeners;
        if (listeners === undefined) return false;
        return listeners[type] !== undefined && listeners[type].indexOf(listener) !== -1;
    }
    /**
	 * Removes the given event listener from the given event type.
	 *
	 * @param {string} type - The type of event.
	 * @param {Function} listener - The listener to remove.
	 */ removeEventListener(type, listener) {
        const listeners = this._listeners;
        if (listeners === undefined) return;
        const listenerArray = listeners[type];
        if (listenerArray !== undefined) {
            const index = listenerArray.indexOf(listener);
            if (index !== -1) listenerArray.splice(index, 1);
        }
    }
    /**
	 * Dispatches an event object.
	 *
	 * @param {Object} event - The event that gets fired.
	 */ dispatchEvent(event) {
        const listeners = this._listeners;
        if (listeners === undefined) return;
        const listenerArray = listeners[event.type];
        if (listenerArray !== undefined) {
            event.target = this;
            // Make a copy, in case listeners are removed while iterating.
            const array = listenerArray.slice(0);
            for(let i = 0, l = array.length; i < l; i++)array[i].call(this, event);
            event.target = null;
        }
    }
}
const $9ddd7e9b53f7a2d4$var$_lut = [
    '00',
    '01',
    '02',
    '03',
    '04',
    '05',
    '06',
    '07',
    '08',
    '09',
    '0a',
    '0b',
    '0c',
    '0d',
    '0e',
    '0f',
    '10',
    '11',
    '12',
    '13',
    '14',
    '15',
    '16',
    '17',
    '18',
    '19',
    '1a',
    '1b',
    '1c',
    '1d',
    '1e',
    '1f',
    '20',
    '21',
    '22',
    '23',
    '24',
    '25',
    '26',
    '27',
    '28',
    '29',
    '2a',
    '2b',
    '2c',
    '2d',
    '2e',
    '2f',
    '30',
    '31',
    '32',
    '33',
    '34',
    '35',
    '36',
    '37',
    '38',
    '39',
    '3a',
    '3b',
    '3c',
    '3d',
    '3e',
    '3f',
    '40',
    '41',
    '42',
    '43',
    '44',
    '45',
    '46',
    '47',
    '48',
    '49',
    '4a',
    '4b',
    '4c',
    '4d',
    '4e',
    '4f',
    '50',
    '51',
    '52',
    '53',
    '54',
    '55',
    '56',
    '57',
    '58',
    '59',
    '5a',
    '5b',
    '5c',
    '5d',
    '5e',
    '5f',
    '60',
    '61',
    '62',
    '63',
    '64',
    '65',
    '66',
    '67',
    '68',
    '69',
    '6a',
    '6b',
    '6c',
    '6d',
    '6e',
    '6f',
    '70',
    '71',
    '72',
    '73',
    '74',
    '75',
    '76',
    '77',
    '78',
    '79',
    '7a',
    '7b',
    '7c',
    '7d',
    '7e',
    '7f',
    '80',
    '81',
    '82',
    '83',
    '84',
    '85',
    '86',
    '87',
    '88',
    '89',
    '8a',
    '8b',
    '8c',
    '8d',
    '8e',
    '8f',
    '90',
    '91',
    '92',
    '93',
    '94',
    '95',
    '96',
    '97',
    '98',
    '99',
    '9a',
    '9b',
    '9c',
    '9d',
    '9e',
    '9f',
    'a0',
    'a1',
    'a2',
    'a3',
    'a4',
    'a5',
    'a6',
    'a7',
    'a8',
    'a9',
    'aa',
    'ab',
    'ac',
    'ad',
    'ae',
    'af',
    'b0',
    'b1',
    'b2',
    'b3',
    'b4',
    'b5',
    'b6',
    'b7',
    'b8',
    'b9',
    'ba',
    'bb',
    'bc',
    'bd',
    'be',
    'bf',
    'c0',
    'c1',
    'c2',
    'c3',
    'c4',
    'c5',
    'c6',
    'c7',
    'c8',
    'c9',
    'ca',
    'cb',
    'cc',
    'cd',
    'ce',
    'cf',
    'd0',
    'd1',
    'd2',
    'd3',
    'd4',
    'd5',
    'd6',
    'd7',
    'd8',
    'd9',
    'da',
    'db',
    'dc',
    'dd',
    'de',
    'df',
    'e0',
    'e1',
    'e2',
    'e3',
    'e4',
    'e5',
    'e6',
    'e7',
    'e8',
    'e9',
    'ea',
    'eb',
    'ec',
    'ed',
    'ee',
    'ef',
    'f0',
    'f1',
    'f2',
    'f3',
    'f4',
    'f5',
    'f6',
    'f7',
    'f8',
    'f9',
    'fa',
    'fb',
    'fc',
    'fd',
    'fe',
    'ff'
];
let $9ddd7e9b53f7a2d4$var$_seed = 1234567;
const $9ddd7e9b53f7a2d4$var$DEG2RAD = Math.PI / 180;
const $9ddd7e9b53f7a2d4$export$914076c8150813e5 = 180 / Math.PI;
/**
 * Generate a [UUID]{@link https://en.wikipedia.org/wiki/Universally_unique_identifier}
 * (universally unique identifier).
 *
 * @return {string} The UUID.
 */ function $9ddd7e9b53f7a2d4$var$generateUUID() {
    // http://stackoverflow.com/questions/105034/how-to-create-a-guid-uuid-in-javascript/21963136#21963136
    const d0 = Math.random() * 0xffffffff | 0;
    const d1 = Math.random() * 0xffffffff | 0;
    const d2 = Math.random() * 0xffffffff | 0;
    const d3 = Math.random() * 0xffffffff | 0;
    const uuid = $9ddd7e9b53f7a2d4$var$_lut[d0 & 0xff] + $9ddd7e9b53f7a2d4$var$_lut[d0 >> 8 & 0xff] + $9ddd7e9b53f7a2d4$var$_lut[d0 >> 16 & 0xff] + $9ddd7e9b53f7a2d4$var$_lut[d0 >> 24 & 0xff] + '-' + $9ddd7e9b53f7a2d4$var$_lut[d1 & 0xff] + $9ddd7e9b53f7a2d4$var$_lut[d1 >> 8 & 0xff] + '-' + $9ddd7e9b53f7a2d4$var$_lut[d1 >> 16 & 0x0f | 0x40] + $9ddd7e9b53f7a2d4$var$_lut[d1 >> 24 & 0xff] + '-' + $9ddd7e9b53f7a2d4$var$_lut[d2 & 0x3f | 0x80] + $9ddd7e9b53f7a2d4$var$_lut[d2 >> 8 & 0xff] + '-' + $9ddd7e9b53f7a2d4$var$_lut[d2 >> 16 & 0xff] + $9ddd7e9b53f7a2d4$var$_lut[d2 >> 24 & 0xff] + $9ddd7e9b53f7a2d4$var$_lut[d3 & 0xff] + $9ddd7e9b53f7a2d4$var$_lut[d3 >> 8 & 0xff] + $9ddd7e9b53f7a2d4$var$_lut[d3 >> 16 & 0xff] + $9ddd7e9b53f7a2d4$var$_lut[d3 >> 24 & 0xff];
    // .toLowerCase() here flattens concatenated strings to save heap memory space.
    return uuid.toLowerCase();
}
/**
 * Clamps the given value between min and max.
 *
 * @param {number} value - The value to clamp.
 * @param {number} min - The min value.
 * @param {number} max - The max value.
 * @return {number} The clamped value.
 */ function $9ddd7e9b53f7a2d4$var$clamp(value, min, max) {
    return Math.max(min, Math.min(max, value));
}
/**
 * Computes the Euclidean modulo of the given parameters that
 * is `( ( n % m ) + m ) % m`.
 *
 * @param {number} n - The first parameter.
 * @param {number} m - The second parameter.
 * @return {number} The Euclidean modulo.
 */ function $9ddd7e9b53f7a2d4$var$euclideanModulo(n, m) {
    // https://en.wikipedia.org/wiki/Modulo_operation
    return (n % m + m) % m;
}
/**
 * Performs a linear mapping from range `<a1, a2>` to range `<b1, b2>`
 * for the given value.
 *
 * @param {number} x - The value to be mapped.
 * @param {number} a1 - Minimum value for range A.
 * @param {number} a2 - Maximum value for range A.
 * @param {number} b1 - Minimum value for range B.
 * @param {number} b2 - Maximum value for range B.
 * @return {number} The mapped value.
 */ function $9ddd7e9b53f7a2d4$var$mapLinear(x, a1, a2, b1, b2) {
    return b1 + (x - a1) * (b2 - b1) / (a2 - a1);
}
/**
 * Returns the percentage in the closed interval `[0, 1]` of the given value
 * between the start and end point.
 *
 * @param {number} x - The start point
 * @param {number} y - The end point.
 * @param {number} value - A value between start and end.
 * @return {number} The interpolation factor.
 */ function $9ddd7e9b53f7a2d4$var$inverseLerp(x, y, value) {
    // https://www.gamedev.net/tutorials/programming/general-and-gameplay-programming/inverse-lerp-a-super-useful-yet-often-overlooked-function-r5230/
    if (x !== y) return (value - x) / (y - x);
    else return 0;
}
/**
 * Returns a value linearly interpolated from two known points based on the given interval -
 * `t = 0` will return `x` and `t = 1` will return `y`.
 *
 * @param {number} x - The start point
 * @param {number} y - The end point.
 * @param {number} t - The interpolation factor in the closed interval `[0, 1]`.
 * @return {number} The interpolated value.
 */ function $9ddd7e9b53f7a2d4$var$lerp(x, y, t) {
    return (1 - t) * x + t * y;
}
/**
 * Smoothly interpolate a number from `x` to `y` in  a spring-like manner using a delta
 * time to maintain frame rate independent movement. For details, see
 * [Frame rate independent damping using lerp]{@link http://www.rorydriscoll.com/2016/03/07/frame-rate-independent-damping-using-lerp/}.
 *
 * @param {number} x - The current point.
 * @param {number} y - The target point.
 * @param {number} lambda - A higher lambda value will make the movement more sudden,
 * and a lower value will make the movement more gradual.
 * @param {number} dt - Delta time in seconds.
 * @return {number} The interpolated value.
 */ function $9ddd7e9b53f7a2d4$var$damp(x, y, lambda, dt) {
    return $9ddd7e9b53f7a2d4$var$lerp(x, y, 1 - Math.exp(-lambda * dt));
}
/**
 * Returns a value that alternates between `0` and the given `length` parameter.
 *
 * @param {number} x - The value to pingpong.
 * @param {number} [length=1] - The positive value the function will pingpong to.
 * @return {number} The alternated value.
 */ function $9ddd7e9b53f7a2d4$var$pingpong(x, length = 1) {
    // https://www.desmos.com/calculator/vcsjnyz7x4
    return length - Math.abs($9ddd7e9b53f7a2d4$var$euclideanModulo(x, length * 2) - length);
}
/**
 * Returns a value in the range `[0,1]` that represents the percentage that `x` has
 * moved between `min` and `max`, but smoothed or slowed down the closer `x` is to
 * the `min` and `max`.
 *
 * See [Smoothstep]{@link http://en.wikipedia.org/wiki/Smoothstep} for more details.
 *
 * @param {number} x - The value to evaluate based on its position between min and max.
 * @param {number} min - The min value. Any x value below min will be `0`.
 * @param {number} max - The max value. Any x value above max will be `1`.
 * @return {number} The alternated value.
 */ function $9ddd7e9b53f7a2d4$var$smoothstep(x, min, max) {
    if (x <= min) return 0;
    if (x >= max) return 1;
    x = (x - min) / (max - min);
    return x * x * (3 - 2 * x);
}
/**
 * A [variation on smoothstep]{@link https://en.wikipedia.org/wiki/Smoothstep#Variations}
 * that has zero 1st and 2nd order derivatives at x=0 and x=1.
 *
 * @param {number} x - The value to evaluate based on its position between min and max.
 * @param {number} min - The min value. Any x value below min will be `0`.
 * @param {number} max - The max value. Any x value above max will be `1`.
 * @return {number} The alternated value.
 */ function $9ddd7e9b53f7a2d4$var$smootherstep(x, min, max) {
    if (x <= min) return 0;
    if (x >= max) return 1;
    x = (x - min) / (max - min);
    return x * x * x * (x * (x * 6 - 15) + 10);
}
/**
 * Returns a random integer from `<low, high>` interval.
 *
 * @param {number} low - The lower value boundary.
 * @param {number} high - The upper value boundary
 * @return {number} A random integer.
 */ function $9ddd7e9b53f7a2d4$var$randInt(low, high) {
    return low + Math.floor(Math.random() * (high - low + 1));
}
/**
 * Returns a random float from `<low, high>` interval.
 *
 * @param {number} low - The lower value boundary.
 * @param {number} high - The upper value boundary
 * @return {number} A random float.
 */ function $9ddd7e9b53f7a2d4$var$randFloat(low, high) {
    return low + Math.random() * (high - low);
}
/**
 * Returns a random integer from `<-range/2, range/2>` interval.
 *
 * @param {number} range - Defines the value range.
 * @return {number} A random float.
 */ function $9ddd7e9b53f7a2d4$var$randFloatSpread(range) {
    return range * (0.5 - Math.random());
}
/**
 * Returns a deterministic pseudo-random float in the interval `[0, 1]`.
 *
 * @param {number} [s] - The integer seed.
 * @return {number} A random float.
 */ function $9ddd7e9b53f7a2d4$var$seededRandom(s) {
    if (s !== undefined) $9ddd7e9b53f7a2d4$var$_seed = s;
    // Mulberry32 generator
    let t = $9ddd7e9b53f7a2d4$var$_seed += 0x6D2B79F5;
    t = Math.imul(t ^ t >>> 15, t | 1);
    t ^= t + Math.imul(t ^ t >>> 7, t | 61);
    return ((t ^ t >>> 14) >>> 0) / 4294967296;
}
/**
 * Converts degrees to radians.
 *
 * @param {number} degrees - A value in degrees.
 * @return {number} The converted value in radians.
 */ function $9ddd7e9b53f7a2d4$var$degToRad(degrees) {
    return degrees * $9ddd7e9b53f7a2d4$var$DEG2RAD;
}
/**
 * Converts radians to degrees.
 *
 * @param {number} radians - A value in radians.
 * @return {number} The converted value in degrees.
 */ function $9ddd7e9b53f7a2d4$var$radToDeg(radians) {
    return radians * $9ddd7e9b53f7a2d4$export$914076c8150813e5;
}
/**
 * Returns `true` if the given number is a power of two.
 *
 * @param {number} value - The value to check.
 * @return {boolean} Whether the given number is a power of two or not.
 */ function $9ddd7e9b53f7a2d4$var$isPowerOfTwo(value) {
    return (value & value - 1) === 0 && value !== 0;
}
/**
 * Returns the smallest power of two that is greater than or equal to the given number.
 *
 * @param {number} value - The value to find a POT for.
 * @return {number} The smallest power of two that is greater than or equal to the given number.
 */ function $9ddd7e9b53f7a2d4$var$ceilPowerOfTwo(value) {
    return Math.pow(2, Math.ceil(Math.log(value) / Math.LN2));
}
/**
 * Returns the largest power of two that is less than or equal to the given number.
 *
 * @param {number} value - The value to find a POT for.
 * @return {number} The largest power of two that is less than or equal to the given number.
 */ function $9ddd7e9b53f7a2d4$var$floorPowerOfTwo(value) {
    return Math.pow(2, Math.floor(Math.log(value) / Math.LN2));
}
/**
 * Sets the given quaternion from the [Intrinsic Proper Euler Angles]{@link https://en.wikipedia.org/wiki/Euler_angles}
 * defined by the given angles and order.
 *
 * Rotations are applied to the axes in the order specified by order:
 * rotation by angle `a` is applied first, then by angle `b`, then by angle `c`.
 *
 * @param {Quaternion} q - The quaternion to set.
 * @param {number} a - The rotation applied to the first axis, in radians.
 * @param {number} b - The rotation applied to the second axis, in radians.
 * @param {number} c - The rotation applied to the third axis, in radians.
 * @param {('XYX'|'XZX'|'YXY'|'YZY'|'ZXZ'|'ZYZ')} order - A string specifying the axes order.
 */ function $9ddd7e9b53f7a2d4$var$setQuaternionFromProperEuler(q, a, b, c, order) {
    const cos = Math.cos;
    const sin = Math.sin;
    const c2 = cos(b / 2);
    const s2 = sin(b / 2);
    const c13 = cos((a + c) / 2);
    const s13 = sin((a + c) / 2);
    const c1_3 = cos((a - c) / 2);
    const s1_3 = sin((a - c) / 2);
    const c3_1 = cos((c - a) / 2);
    const s3_1 = sin((c - a) / 2);
    switch(order){
        case 'XYX':
            q.set(c2 * s13, s2 * c1_3, s2 * s1_3, c2 * c13);
            break;
        case 'YZY':
            q.set(s2 * s1_3, c2 * s13, s2 * c1_3, c2 * c13);
            break;
        case 'ZXZ':
            q.set(s2 * c1_3, s2 * s1_3, c2 * s13, c2 * c13);
            break;
        case 'XZX':
            q.set(c2 * s13, s2 * s3_1, s2 * c3_1, c2 * c13);
            break;
        case 'YXY':
            q.set(s2 * c3_1, c2 * s13, s2 * s3_1, c2 * c13);
            break;
        case 'ZYZ':
            q.set(s2 * s3_1, s2 * c3_1, c2 * s13, c2 * c13);
            break;
        default:
            console.warn('THREE.MathUtils: .setQuaternionFromProperEuler() encountered an unknown order: ' + order);
    }
}
/**
 * Denormalizes the given value according to the given typed array.
 *
 * @param {number} value - The value to denormalize.
 * @param {TypedArray} array - The typed array that defines the data type of the value.
 * @return {number} The denormalize (float) value in the range `[0,1]`.
 */ function $9ddd7e9b53f7a2d4$var$denormalize(value, array) {
    switch(array.constructor){
        case Float32Array:
            return value;
        case Uint32Array:
            return value / 4294967295.0;
        case Uint16Array:
            return value / 65535.0;
        case Uint8Array:
            return value / 255.0;
        case Int32Array:
            return Math.max(value / 2147483647.0, -1);
        case Int16Array:
            return Math.max(value / 32767.0, -1);
        case Int8Array:
            return Math.max(value / 127.0, -1);
        default:
            throw new Error('Invalid component type.');
    }
}
/**
 * Normalizes the given value according to the given typed array.
 *
 * @param {number} value - The float value in the range `[0,1]` to normalize.
 * @param {TypedArray} array - The typed array that defines the data type of the value.
 * @return {number} The normalize value.
 */ function $9ddd7e9b53f7a2d4$var$normalize(value, array) {
    switch(array.constructor){
        case Float32Array:
            return value;
        case Uint32Array:
            return Math.round(value * 4294967295.0);
        case Uint16Array:
            return Math.round(value * 65535.0);
        case Uint8Array:
            return Math.round(value * 255.0);
        case Int32Array:
            return Math.round(value * 2147483647.0);
        case Int16Array:
            return Math.round(value * 32767.0);
        case Int8Array:
            return Math.round(value * 127.0);
        default:
            throw new Error('Invalid component type.');
    }
}
/**
 * @class
 * @classdesc A collection of math utility functions.
 * @hideconstructor
 */ const $9ddd7e9b53f7a2d4$export$6a7ef315a0d1ef07 = {
    DEG2RAD: $9ddd7e9b53f7a2d4$var$DEG2RAD,
    RAD2DEG: $9ddd7e9b53f7a2d4$export$914076c8150813e5,
    /**
	 * Generate a [UUID]{@link https://en.wikipedia.org/wiki/Universally_unique_identifier}
	 * (universally unique identifier).
	 *
	 * @static
	 * @method
	 * @return {string} The UUID.
	 */ generateUUID: $9ddd7e9b53f7a2d4$var$generateUUID,
    /**
	 * Clamps the given value between min and max.
	 *
	 * @static
	 * @method
	 * @param {number} value - The value to clamp.
	 * @param {number} min - The min value.
	 * @param {number} max - The max value.
	 * @return {number} The clamped value.
	 */ clamp: $9ddd7e9b53f7a2d4$var$clamp,
    /**
	 * Computes the Euclidean modulo of the given parameters that
	 * is `( ( n % m ) + m ) % m`.
	 *
	 * @static
	 * @method
	 * @param {number} n - The first parameter.
	 * @param {number} m - The second parameter.
	 * @return {number} The Euclidean modulo.
	 */ euclideanModulo: $9ddd7e9b53f7a2d4$var$euclideanModulo,
    /**
	 * Performs a linear mapping from range `<a1, a2>` to range `<b1, b2>`
	 * for the given value.
	 *
	 * @static
	 * @method
	 * @param {number} x - The value to be mapped.
	 * @param {number} a1 - Minimum value for range A.
	 * @param {number} a2 - Maximum value for range A.
	 * @param {number} b1 - Minimum value for range B.
	 * @param {number} b2 - Maximum value for range B.
	 * @return {number} The mapped value.
	 */ mapLinear: $9ddd7e9b53f7a2d4$var$mapLinear,
    /**
	 * Returns the percentage in the closed interval `[0, 1]` of the given value
	 * between the start and end point.
	 *
	 * @static
	 * @method
	 * @param {number} x - The start point
	 * @param {number} y - The end point.
	 * @param {number} value - A value between start and end.
	 * @return {number} The interpolation factor.
	 */ inverseLerp: $9ddd7e9b53f7a2d4$var$inverseLerp,
    /**
	 * Returns a value linearly interpolated from two known points based on the given interval -
	 * `t = 0` will return `x` and `t = 1` will return `y`.
	 *
	 * @static
	 * @method
	 * @param {number} x - The start point
	 * @param {number} y - The end point.
	 * @param {number} t - The interpolation factor in the closed interval `[0, 1]`.
	 * @return {number} The interpolated value.
	 */ lerp: $9ddd7e9b53f7a2d4$var$lerp,
    /**
	 * Smoothly interpolate a number from `x` to `y` in  a spring-like manner using a delta
	 * time to maintain frame rate independent movement. For details, see
	 * [Frame rate independent damping using lerp]{@link http://www.rorydriscoll.com/2016/03/07/frame-rate-independent-damping-using-lerp/}.
	 *
	 * @static
	 * @method
	 * @param {number} x - The current point.
	 * @param {number} y - The target point.
	 * @param {number} lambda - A higher lambda value will make the movement more sudden,
	 * and a lower value will make the movement more gradual.
	 * @param {number} dt - Delta time in seconds.
	 * @return {number} The interpolated value.
	 */ damp: $9ddd7e9b53f7a2d4$var$damp,
    /**
	 * Returns a value that alternates between `0` and the given `length` parameter.
	 *
	 * @static
	 * @method
	 * @param {number} x - The value to pingpong.
	 * @param {number} [length=1] - The positive value the function will pingpong to.
	 * @return {number} The alternated value.
	 */ pingpong: $9ddd7e9b53f7a2d4$var$pingpong,
    /**
	 * Returns a value in the range `[0,1]` that represents the percentage that `x` has
	 * moved between `min` and `max`, but smoothed or slowed down the closer `x` is to
	 * the `min` and `max`.
	 *
	 * See [Smoothstep]{@link http://en.wikipedia.org/wiki/Smoothstep} for more details.
	 *
	 * @static
	 * @method
	 * @param {number} x - The value to evaluate based on its position between min and max.
	 * @param {number} min - The min value. Any x value below min will be `0`.
	 * @param {number} max - The max value. Any x value above max will be `1`.
	 * @return {number} The alternated value.
	 */ smoothstep: $9ddd7e9b53f7a2d4$var$smoothstep,
    /**
	 * A [variation on smoothstep]{@link https://en.wikipedia.org/wiki/Smoothstep#Variations}
	 * that has zero 1st and 2nd order derivatives at x=0 and x=1.
	 *
	 * @static
	 * @method
	 * @param {number} x - The value to evaluate based on its position between min and max.
	 * @param {number} min - The min value. Any x value below min will be `0`.
	 * @param {number} max - The max value. Any x value above max will be `1`.
	 * @return {number} The alternated value.
	 */ smootherstep: $9ddd7e9b53f7a2d4$var$smootherstep,
    /**
	 * Returns a random integer from `<low, high>` interval.
	 *
	 * @static
	 * @method
	 * @param {number} low - The lower value boundary.
	 * @param {number} high - The upper value boundary
	 * @return {number} A random integer.
	 */ randInt: $9ddd7e9b53f7a2d4$var$randInt,
    /**
	 * Returns a random float from `<low, high>` interval.
	 *
	 * @static
	 * @method
	 * @param {number} low - The lower value boundary.
	 * @param {number} high - The upper value boundary
	 * @return {number} A random float.
	 */ randFloat: $9ddd7e9b53f7a2d4$var$randFloat,
    /**
	 * Returns a random integer from `<-range/2, range/2>` interval.
	 *
	 * @static
	 * @method
	 * @param {number} range - Defines the value range.
	 * @return {number} A random float.
	 */ randFloatSpread: $9ddd7e9b53f7a2d4$var$randFloatSpread,
    /**
	 * Returns a deterministic pseudo-random float in the interval `[0, 1]`.
	 *
	 * @static
	 * @method
	 * @param {number} [s] - The integer seed.
	 * @return {number} A random float.
	 */ seededRandom: $9ddd7e9b53f7a2d4$var$seededRandom,
    /**
	 * Converts degrees to radians.
	 *
	 * @static
	 * @method
	 * @param {number} degrees - A value in degrees.
	 * @return {number} The converted value in radians.
	 */ degToRad: $9ddd7e9b53f7a2d4$var$degToRad,
    /**
	 * Converts radians to degrees.
	 *
	 * @static
	 * @method
	 * @param {number} radians - A value in radians.
	 * @return {number} The converted value in degrees.
	 */ radToDeg: $9ddd7e9b53f7a2d4$var$radToDeg,
    /**
	 * Returns `true` if the given number is a power of two.
	 *
	 * @static
	 * @method
	 * @param {number} value - The value to check.
	 * @return {boolean} Whether the given number is a power of two or not.
	 */ isPowerOfTwo: $9ddd7e9b53f7a2d4$var$isPowerOfTwo,
    /**
	 * Returns the smallest power of two that is greater than or equal to the given number.
	 *
	 * @static
	 * @method
	 * @param {number} value - The value to find a POT for.
	 * @return {number} The smallest power of two that is greater than or equal to the given number.
	 */ ceilPowerOfTwo: $9ddd7e9b53f7a2d4$var$ceilPowerOfTwo,
    /**
	 * Returns the largest power of two that is less than or equal to the given number.
	 *
	 * @static
	 * @method
	 * @param {number} value - The value to find a POT for.
	 * @return {number} The largest power of two that is less than or equal to the given number.
	 */ floorPowerOfTwo: $9ddd7e9b53f7a2d4$var$floorPowerOfTwo,
    /**
	 * Sets the given quaternion from the [Intrinsic Proper Euler Angles]{@link https://en.wikipedia.org/wiki/Euler_angles}
	 * defined by the given angles and order.
	 *
	 * Rotations are applied to the axes in the order specified by order:
	 * rotation by angle `a` is applied first, then by angle `b`, then by angle `c`.
	 *
	 * @static
	 * @method
	 * @param {Quaternion} q - The quaternion to set.
	 * @param {number} a - The rotation applied to the first axis, in radians.
	 * @param {number} b - The rotation applied to the second axis, in radians.
	 * @param {number} c - The rotation applied to the third axis, in radians.
	 * @param {('XYX'|'XZX'|'YXY'|'YZY'|'ZXZ'|'ZYZ')} order - A string specifying the axes order.
	 */ setQuaternionFromProperEuler: $9ddd7e9b53f7a2d4$var$setQuaternionFromProperEuler,
    /**
	 * Normalizes the given value according to the given typed array.
	 *
	 * @static
	 * @method
	 * @param {number} value - The float value in the range `[0,1]` to normalize.
	 * @param {TypedArray} array - The typed array that defines the data type of the value.
	 * @return {number} The normalize value.
	 */ normalize: $9ddd7e9b53f7a2d4$var$normalize,
    /**
	 * Denormalizes the given value according to the given typed array.
	 *
	 * @static
	 * @method
	 * @param {number} value - The value to denormalize.
	 * @param {TypedArray} array - The typed array that defines the data type of the value.
	 * @return {number} The denormalize (float) value in the range `[0,1]`.
	 */ denormalize: $9ddd7e9b53f7a2d4$var$denormalize
};
/**
 * Class representing a 2D vector. A 2D vector is an ordered pair of numbers
 * (labeled x and y), which can be used to represent a number of things, such as:
 *
 * - A point in 2D space (i.e. a position on a plane).
 * - A direction and length across a plane. In three.js the length will
 * always be the Euclidean distance(straight-line distance) from `(0, 0)` to `(x, y)`
 * and the direction is also measured from `(0, 0)` towards `(x, y)`.
 * - Any arbitrary ordered pair of numbers.
 *
 * There are other things a 2D vector can be used to represent, such as
 * momentum vectors, complex numbers and so on, however these are the most
 * common uses in three.js.
 *
 * Iterating through a vector instance will yield its components `(x, y)` in
 * the corresponding order.
 * ```js
 * const a = new THREE.Vector2( 0, 1 );
 *
 * //no arguments; will be initialised to (0, 0)
 * const b = new THREE.Vector2( );
 *
 * const d = a.distanceTo( b );
 * ```
 */ class $9ddd7e9b53f7a2d4$export$c977b3e384af9ae1 {
    /**
	 * Constructs a new 2D vector.
	 *
	 * @param {number} [x=0] - The x value of this vector.
	 * @param {number} [y=0] - The y value of this vector.
	 */ constructor(x = 0, y = 0){
        /**
		 * This flag can be used for type testing.
		 *
		 * @type {boolean}
		 * @readonly
		 * @default true
		 */ $9ddd7e9b53f7a2d4$export$c977b3e384af9ae1.prototype.isVector2 = true;
        /**
		 * The x value of this vector.
		 *
		 * @type {number}
		 */ this.x = x;
        /**
		 * The y value of this vector.
		 *
		 * @type {number}
		 */ this.y = y;
    }
    /**
	 * Alias for {@link Vector2#x}.
	 *
	 * @type {number}
	 */ get width() {
        return this.x;
    }
    set width(value) {
        this.x = value;
    }
    /**
	 * Alias for {@link Vector2#y}.
	 *
	 * @type {number}
	 */ get height() {
        return this.y;
    }
    set height(value) {
        this.y = value;
    }
    /**
	 * Sets the vector components.
	 *
	 * @param {number} x - The value of the x component.
	 * @param {number} y - The value of the y component.
	 * @return {Vector2} A reference to this vector.
	 */ set(x, y) {
        this.x = x;
        this.y = y;
        return this;
    }
    /**
	 * Sets the vector components to the same value.
	 *
	 * @param {number} scalar - The value to set for all vector components.
	 * @return {Vector2} A reference to this vector.
	 */ setScalar(scalar) {
        this.x = scalar;
        this.y = scalar;
        return this;
    }
    /**
	 * Sets the vector's x component to the given value
	 *
	 * @param {number} x - The value to set.
	 * @return {Vector2} A reference to this vector.
	 */ setX(x) {
        this.x = x;
        return this;
    }
    /**
	 * Sets the vector's y component to the given value
	 *
	 * @param {number} y - The value to set.
	 * @return {Vector2} A reference to this vector.
	 */ setY(y) {
        this.y = y;
        return this;
    }
    /**
	 * Allows to set a vector component with an index.
	 *
	 * @param {number} index - The component index. `0` equals to x, `1` equals to y.
	 * @param {number} value - The value to set.
	 * @return {Vector2} A reference to this vector.
	 */ setComponent(index, value) {
        switch(index){
            case 0:
                this.x = value;
                break;
            case 1:
                this.y = value;
                break;
            default:
                throw new Error('index is out of range: ' + index);
        }
        return this;
    }
    /**
	 * Returns the value of the vector component which matches the given index.
	 *
	 * @param {number} index - The component index. `0` equals to x, `1` equals to y.
	 * @return {number} A vector component value.
	 */ getComponent(index) {
        switch(index){
            case 0:
                return this.x;
            case 1:
                return this.y;
            default:
                throw new Error('index is out of range: ' + index);
        }
    }
    /**
	 * Returns a new vector with copied values from this instance.
	 *
	 * @return {Vector2} A clone of this instance.
	 */ clone() {
        return new this.constructor(this.x, this.y);
    }
    /**
	 * Copies the values of the given vector to this instance.
	 *
	 * @param {Vector2} v - The vector to copy.
	 * @return {Vector2} A reference to this vector.
	 */ copy(v) {
        this.x = v.x;
        this.y = v.y;
        return this;
    }
    /**
	 * Adds the given vector to this instance.
	 *
	 * @param {Vector2} v - The vector to add.
	 * @return {Vector2} A reference to this vector.
	 */ add(v) {
        this.x += v.x;
        this.y += v.y;
        return this;
    }
    /**
	 * Adds the given scalar value to all components of this instance.
	 *
	 * @param {number} s - The scalar to add.
	 * @return {Vector2} A reference to this vector.
	 */ addScalar(s) {
        this.x += s;
        this.y += s;
        return this;
    }
    /**
	 * Adds the given vectors and stores the result in this instance.
	 *
	 * @param {Vector2} a - The first vector.
	 * @param {Vector2} b - The second vector.
	 * @return {Vector2} A reference to this vector.
	 */ addVectors(a, b) {
        this.x = a.x + b.x;
        this.y = a.y + b.y;
        return this;
    }
    /**
	 * Adds the given vector scaled by the given factor to this instance.
	 *
	 * @param {Vector2} v - The vector.
	 * @param {number} s - The factor that scales `v`.
	 * @return {Vector2} A reference to this vector.
	 */ addScaledVector(v, s) {
        this.x += v.x * s;
        this.y += v.y * s;
        return this;
    }
    /**
	 * Subtracts the given vector from this instance.
	 *
	 * @param {Vector2} v - The vector to subtract.
	 * @return {Vector2} A reference to this vector.
	 */ sub(v) {
        this.x -= v.x;
        this.y -= v.y;
        return this;
    }
    /**
	 * Subtracts the given scalar value from all components of this instance.
	 *
	 * @param {number} s - The scalar to subtract.
	 * @return {Vector2} A reference to this vector.
	 */ subScalar(s) {
        this.x -= s;
        this.y -= s;
        return this;
    }
    /**
	 * Subtracts the given vectors and stores the result in this instance.
	 *
	 * @param {Vector2} a - The first vector.
	 * @param {Vector2} b - The second vector.
	 * @return {Vector2} A reference to this vector.
	 */ subVectors(a, b) {
        this.x = a.x - b.x;
        this.y = a.y - b.y;
        return this;
    }
    /**
	 * Multiplies the given vector with this instance.
	 *
	 * @param {Vector2} v - The vector to multiply.
	 * @return {Vector2} A reference to this vector.
	 */ multiply(v) {
        this.x *= v.x;
        this.y *= v.y;
        return this;
    }
    /**
	 * Multiplies the given scalar value with all components of this instance.
	 *
	 * @param {number} scalar - The scalar to multiply.
	 * @return {Vector2} A reference to this vector.
	 */ multiplyScalar(scalar) {
        this.x *= scalar;
        this.y *= scalar;
        return this;
    }
    /**
	 * Divides this instance by the given vector.
	 *
	 * @param {Vector2} v - The vector to divide.
	 * @return {Vector2} A reference to this vector.
	 */ divide(v) {
        this.x /= v.x;
        this.y /= v.y;
        return this;
    }
    /**
	 * Divides this vector by the given scalar.
	 *
	 * @param {number} scalar - The scalar to divide.
	 * @return {Vector2} A reference to this vector.
	 */ divideScalar(scalar) {
        return this.multiplyScalar(1 / scalar);
    }
    /**
	 * Multiplies this vector (with an implicit 1 as the 3rd component) by
	 * the given 3x3 matrix.
	 *
	 * @param {Matrix3} m - The matrix to apply.
	 * @return {Vector2} A reference to this vector.
	 */ applyMatrix3(m) {
        const x = this.x, y = this.y;
        const e = m.elements;
        this.x = e[0] * x + e[3] * y + e[6];
        this.y = e[1] * x + e[4] * y + e[7];
        return this;
    }
    /**
	 * If this vector's x or y value is greater than the given vector's x or y
	 * value, replace that value with the corresponding min value.
	 *
	 * @param {Vector2} v - The vector.
	 * @return {Vector2} A reference to this vector.
	 */ min(v) {
        this.x = Math.min(this.x, v.x);
        this.y = Math.min(this.y, v.y);
        return this;
    }
    /**
	 * If this vector's x or y value is less than the given vector's x or y
	 * value, replace that value with the corresponding max value.
	 *
	 * @param {Vector2} v - The vector.
	 * @return {Vector2} A reference to this vector.
	 */ max(v) {
        this.x = Math.max(this.x, v.x);
        this.y = Math.max(this.y, v.y);
        return this;
    }
    /**
	 * If this vector's x or y value is greater than the max vector's x or y
	 * value, it is replaced by the corresponding value.
	 * If this vector's x or y value is less than the min vector's x or y value,
	 * it is replaced by the corresponding value.
	 *
	 * @param {Vector2} min - The minimum x and y values.
	 * @param {Vector2} max - The maximum x and y values in the desired range.
	 * @return {Vector2} A reference to this vector.
	 */ clamp(min, max) {
        // assumes min < max, componentwise
        this.x = $9ddd7e9b53f7a2d4$var$clamp(this.x, min.x, max.x);
        this.y = $9ddd7e9b53f7a2d4$var$clamp(this.y, min.y, max.y);
        return this;
    }
    /**
	 * If this vector's x or y values are greater than the max value, they are
	 * replaced by the max value.
	 * If this vector's x or y values are less than the min value, they are
	 * replaced by the min value.
	 *
	 * @param {number} minVal - The minimum value the components will be clamped to.
	 * @param {number} maxVal - The maximum value the components will be clamped to.
	 * @return {Vector2} A reference to this vector.
	 */ clampScalar(minVal, maxVal) {
        this.x = $9ddd7e9b53f7a2d4$var$clamp(this.x, minVal, maxVal);
        this.y = $9ddd7e9b53f7a2d4$var$clamp(this.y, minVal, maxVal);
        return this;
    }
    /**
	 * If this vector's length is greater than the max value, it is replaced by
	 * the max value.
	 * If this vector's length is less than the min value, it is replaced by the
	 * min value.
	 *
	 * @param {number} min - The minimum value the vector length will be clamped to.
	 * @param {number} max - The maximum value the vector length will be clamped to.
	 * @return {Vector2} A reference to this vector.
	 */ clampLength(min, max) {
        const length = this.length();
        return this.divideScalar(length || 1).multiplyScalar($9ddd7e9b53f7a2d4$var$clamp(length, min, max));
    }
    /**
	 * The components of this vector are rounded down to the nearest integer value.
	 *
	 * @return {Vector2} A reference to this vector.
	 */ floor() {
        this.x = Math.floor(this.x);
        this.y = Math.floor(this.y);
        return this;
    }
    /**
	 * The components of this vector are rounded up to the nearest integer value.
	 *
	 * @return {Vector2} A reference to this vector.
	 */ ceil() {
        this.x = Math.ceil(this.x);
        this.y = Math.ceil(this.y);
        return this;
    }
    /**
	 * The components of this vector are rounded to the nearest integer value
	 *
	 * @return {Vector2} A reference to this vector.
	 */ round() {
        this.x = Math.round(this.x);
        this.y = Math.round(this.y);
        return this;
    }
    /**
	 * The components of this vector are rounded towards zero (up if negative,
	 * down if positive) to an integer value.
	 *
	 * @return {Vector2} A reference to this vector.
	 */ roundToZero() {
        this.x = Math.trunc(this.x);
        this.y = Math.trunc(this.y);
        return this;
    }
    /**
	 * Inverts this vector - i.e. sets x = -x and y = -y.
	 *
	 * @return {Vector2} A reference to this vector.
	 */ negate() {
        this.x = -this.x;
        this.y = -this.y;
        return this;
    }
    /**
	 * Calculates the dot product of the given vector with this instance.
	 *
	 * @param {Vector2} v - The vector to compute the dot product with.
	 * @return {number} The result of the dot product.
	 */ dot(v) {
        return this.x * v.x + this.y * v.y;
    }
    /**
	 * Calculates the cross product of the given vector with this instance.
	 *
	 * @param {Vector2} v - The vector to compute the cross product with.
	 * @return {number} The result of the cross product.
	 */ cross(v) {
        return this.x * v.y - this.y * v.x;
    }
    /**
	 * Computes the square of the Euclidean length (straight-line length) from
	 * (0, 0) to (x, y). If you are comparing the lengths of vectors, you should
	 * compare the length squared instead as it is slightly more efficient to calculate.
	 *
	 * @return {number} The square length of this vector.
	 */ lengthSq() {
        return this.x * this.x + this.y * this.y;
    }
    /**
	 * Computes the  Euclidean length (straight-line length) from (0, 0) to (x, y).
	 *
	 * @return {number} The length of this vector.
	 */ length() {
        return Math.sqrt(this.x * this.x + this.y * this.y);
    }
    /**
	 * Computes the Manhattan length of this vector.
	 *
	 * @return {number} The length of this vector.
	 */ manhattanLength() {
        return Math.abs(this.x) + Math.abs(this.y);
    }
    /**
	 * Converts this vector to a unit vector - that is, sets it equal to a vector
	 * with the same direction as this one, but with a vector length of `1`.
	 *
	 * @return {Vector2} A reference to this vector.
	 */ normalize() {
        return this.divideScalar(this.length() || 1);
    }
    /**
	 * Computes the angle in radians of this vector with respect to the positive x-axis.
	 *
	 * @return {number} The angle in radians.
	 */ angle() {
        const angle = Math.atan2(-this.y, -this.x) + Math.PI;
        return angle;
    }
    /**
	 * Returns the angle between the given vector and this instance in radians.
	 *
	 * @param {Vector2} v - The vector to compute the angle with.
	 * @return {number} The angle in radians.
	 */ angleTo(v) {
        const denominator = Math.sqrt(this.lengthSq() * v.lengthSq());
        if (denominator === 0) return Math.PI / 2;
        const theta = this.dot(v) / denominator;
        // clamp, to handle numerical problems
        return Math.acos($9ddd7e9b53f7a2d4$var$clamp(theta, -1, 1));
    }
    /**
	 * Computes the distance from the given vector to this instance.
	 *
	 * @param {Vector2} v - The vector to compute the distance to.
	 * @return {number} The distance.
	 */ distanceTo(v) {
        return Math.sqrt(this.distanceToSquared(v));
    }
    /**
	 * Computes the squared distance from the given vector to this instance.
	 * If you are just comparing the distance with another distance, you should compare
	 * the distance squared instead as it is slightly more efficient to calculate.
	 *
	 * @param {Vector2} v - The vector to compute the squared distance to.
	 * @return {number} The squared distance.
	 */ distanceToSquared(v) {
        const dx = this.x - v.x, dy = this.y - v.y;
        return dx * dx + dy * dy;
    }
    /**
	 * Computes the Manhattan distance from the given vector to this instance.
	 *
	 * @param {Vector2} v - The vector to compute the Manhattan distance to.
	 * @return {number} The Manhattan distance.
	 */ manhattanDistanceTo(v) {
        return Math.abs(this.x - v.x) + Math.abs(this.y - v.y);
    }
    /**
	 * Sets this vector to a vector with the same direction as this one, but
	 * with the specified length.
	 *
	 * @param {number} length - The new length of this vector.
	 * @return {Vector2} A reference to this vector.
	 */ setLength(length) {
        return this.normalize().multiplyScalar(length);
    }
    /**
	 * Linearly interpolates between the given vector and this instance, where
	 * alpha is the percent distance along the line - alpha = 0 will be this
	 * vector, and alpha = 1 will be the given one.
	 *
	 * @param {Vector2} v - The vector to interpolate towards.
	 * @param {number} alpha - The interpolation factor, typically in the closed interval `[0, 1]`.
	 * @return {Vector2} A reference to this vector.
	 */ lerp(v, alpha) {
        this.x += (v.x - this.x) * alpha;
        this.y += (v.y - this.y) * alpha;
        return this;
    }
    /**
	 * Linearly interpolates between the given vectors, where alpha is the percent
	 * distance along the line - alpha = 0 will be first vector, and alpha = 1 will
	 * be the second one. The result is stored in this instance.
	 *
	 * @param {Vector2} v1 - The first vector.
	 * @param {Vector2} v2 - The second vector.
	 * @param {number} alpha - The interpolation factor, typically in the closed interval `[0, 1]`.
	 * @return {Vector2} A reference to this vector.
	 */ lerpVectors(v1, v2, alpha) {
        this.x = v1.x + (v2.x - v1.x) * alpha;
        this.y = v1.y + (v2.y - v1.y) * alpha;
        return this;
    }
    /**
	 * Returns `true` if this vector is equal with the given one.
	 *
	 * @param {Vector2} v - The vector to test for equality.
	 * @return {boolean} Whether this vector is equal with the given one.
	 */ equals(v) {
        return v.x === this.x && v.y === this.y;
    }
    /**
	 * Sets this vector's x value to be `array[ offset ]` and y
	 * value to be `array[ offset + 1 ]`.
	 *
	 * @param {Array<number>} array - An array holding the vector component values.
	 * @param {number} [offset=0] - The offset into the array.
	 * @return {Vector2} A reference to this vector.
	 */ fromArray(array, offset = 0) {
        this.x = array[offset];
        this.y = array[offset + 1];
        return this;
    }
    /**
	 * Writes the components of this vector to the given array. If no array is provided,
	 * the method returns a new instance.
	 *
	 * @param {Array<number>} [array=[]] - The target array holding the vector components.
	 * @param {number} [offset=0] - Index of the first element in the array.
	 * @return {Array<number>} The vector components.
	 */ toArray(array = [], offset = 0) {
        array[offset] = this.x;
        array[offset + 1] = this.y;
        return array;
    }
    /**
	 * Sets the components of this vector from the given buffer attribute.
	 *
	 * @param {BufferAttribute} attribute - The buffer attribute holding vector data.
	 * @param {number} index - The index into the attribute.
	 * @return {Vector2} A reference to this vector.
	 */ fromBufferAttribute(attribute, index) {
        this.x = attribute.getX(index);
        this.y = attribute.getY(index);
        return this;
    }
    /**
	 * Rotates this vector around the given center by the given angle.
	 *
	 * @param {Vector2} center - The point around which to rotate.
	 * @param {number} angle - The angle to rotate, in radians.
	 * @return {Vector2} A reference to this vector.
	 */ rotateAround(center, angle) {
        const c = Math.cos(angle), s = Math.sin(angle);
        const x = this.x - center.x;
        const y = this.y - center.y;
        this.x = x * c - y * s + center.x;
        this.y = x * s + y * c + center.y;
        return this;
    }
    /**
	 * Sets each component of this vector to a pseudo-random value between `0` and
	 * `1`, excluding `1`.
	 *
	 * @return {Vector2} A reference to this vector.
	 */ random() {
        this.x = Math.random();
        this.y = Math.random();
        return this;
    }
    *[Symbol.iterator]() {
        yield this.x;
        yield this.y;
    }
}
/**
 * Represents a 3x3 matrix.
 *
 * A Note on Row-Major and Column-Major Ordering:
 *
 * The constructor and {@link Matrix3#set} method take arguments in
 * [row-major]{@link https://en.wikipedia.org/wiki/Row-_and_column-major_order#Column-major_order}
 * order, while internally they are stored in the {@link Matrix3#elements} array in column-major order.
 * This means that calling:
 * ```js
 * const m = new THREE.Matrix();
 * m.set( 11, 12, 13,
 *        21, 22, 23,
 *        31, 32, 33 );
 * ```
 * will result in the elements array containing:
 * ```js
 * m.elements = [ 11, 21, 31,
 *                12, 22, 32,
 *                13, 23, 33 ];
 * ```
 * and internally all calculations are performed using column-major ordering.
 * However, as the actual ordering makes no difference mathematically and
 * most people are used to thinking about matrices in row-major order, the
 * three.js documentation shows matrices in row-major order. Just bear in
 * mind that if you are reading the source code, you'll have to take the
 * transpose of any matrices outlined here to make sense of the calculations.
 */ class $9ddd7e9b53f7a2d4$export$8ff26dafa08918 {
    /**
	 * Constructs a new 3x3 matrix. The arguments are supposed to be
	 * in row-major order. If no arguments are provided, the constructor
	 * initializes the matrix as an identity matrix.
	 *
	 * @param {number} [n11] - 1-1 matrix element.
	 * @param {number} [n12] - 1-2 matrix element.
	 * @param {number} [n13] - 1-3 matrix element.
	 * @param {number} [n21] - 2-1 matrix element.
	 * @param {number} [n22] - 2-2 matrix element.
	 * @param {number} [n23] - 2-3 matrix element.
	 * @param {number} [n31] - 3-1 matrix element.
	 * @param {number} [n32] - 3-2 matrix element.
	 * @param {number} [n33] - 3-3 matrix element.
	 */ constructor(n11, n12, n13, n21, n22, n23, n31, n32, n33){
        /**
		 * This flag can be used for type testing.
		 *
		 * @type {boolean}
		 * @readonly
		 * @default true
		 */ $9ddd7e9b53f7a2d4$export$8ff26dafa08918.prototype.isMatrix3 = true;
        /**
		 * A column-major list of matrix values.
		 *
		 * @type {Array<number>}
		 */ this.elements = [
            1,
            0,
            0,
            0,
            1,
            0,
            0,
            0,
            1
        ];
        if (n11 !== undefined) this.set(n11, n12, n13, n21, n22, n23, n31, n32, n33);
    }
    /**
	 * Sets the elements of the matrix.The arguments are supposed to be
	 * in row-major order.
	 *
	 * @param {number} [n11] - 1-1 matrix element.
	 * @param {number} [n12] - 1-2 matrix element.
	 * @param {number} [n13] - 1-3 matrix element.
	 * @param {number} [n21] - 2-1 matrix element.
	 * @param {number} [n22] - 2-2 matrix element.
	 * @param {number} [n23] - 2-3 matrix element.
	 * @param {number} [n31] - 3-1 matrix element.
	 * @param {number} [n32] - 3-2 matrix element.
	 * @param {number} [n33] - 3-3 matrix element.
	 * @return {Matrix3} A reference to this matrix.
	 */ set(n11, n12, n13, n21, n22, n23, n31, n32, n33) {
        const te = this.elements;
        te[0] = n11;
        te[1] = n21;
        te[2] = n31;
        te[3] = n12;
        te[4] = n22;
        te[5] = n32;
        te[6] = n13;
        te[7] = n23;
        te[8] = n33;
        return this;
    }
    /**
	 * Sets this matrix to the 3x3 identity matrix.
	 *
	 * @return {Matrix3} A reference to this matrix.
	 */ identity() {
        this.set(1, 0, 0, 0, 1, 0, 0, 0, 1);
        return this;
    }
    /**
	 * Copies the values of the given matrix to this instance.
	 *
	 * @param {Matrix3} m - The matrix to copy.
	 * @return {Matrix3} A reference to this matrix.
	 */ copy(m) {
        const te = this.elements;
        const me = m.elements;
        te[0] = me[0];
        te[1] = me[1];
        te[2] = me[2];
        te[3] = me[3];
        te[4] = me[4];
        te[5] = me[5];
        te[6] = me[6];
        te[7] = me[7];
        te[8] = me[8];
        return this;
    }
    /**
	 * Extracts the basis of this matrix into the three axis vectors provided.
	 *
	 * @param {Vector3} xAxis - The basis's x axis.
	 * @param {Vector3} yAxis - The basis's y axis.
	 * @param {Vector3} zAxis - The basis's z axis.
	 * @return {Matrix3} A reference to this matrix.
	 */ extractBasis(xAxis, yAxis, zAxis) {
        xAxis.setFromMatrix3Column(this, 0);
        yAxis.setFromMatrix3Column(this, 1);
        zAxis.setFromMatrix3Column(this, 2);
        return this;
    }
    /**
	 * Set this matrix to the upper 3x3 matrix of the given 4x4 matrix.
	 *
	 * @param {Matrix4} m - The 4x4 matrix.
	 * @return {Matrix3} A reference to this matrix.
	 */ setFromMatrix4(m) {
        const me = m.elements;
        this.set(me[0], me[4], me[8], me[1], me[5], me[9], me[2], me[6], me[10]);
        return this;
    }
    /**
	 * Post-multiplies this matrix by the given 3x3 matrix.
	 *
	 * @param {Matrix3} m - The matrix to multiply with.
	 * @return {Matrix3} A reference to this matrix.
	 */ multiply(m) {
        return this.multiplyMatrices(this, m);
    }
    /**
	 * Pre-multiplies this matrix by the given 3x3 matrix.
	 *
	 * @param {Matrix3} m - The matrix to multiply with.
	 * @return {Matrix3} A reference to this matrix.
	 */ premultiply(m) {
        return this.multiplyMatrices(m, this);
    }
    /**
	 * Multiples the given 3x3 matrices and stores the result
	 * in this matrix.
	 *
	 * @param {Matrix3} a - The first matrix.
	 * @param {Matrix3} b - The second matrix.
	 * @return {Matrix3} A reference to this matrix.
	 */ multiplyMatrices(a, b) {
        const ae = a.elements;
        const be = b.elements;
        const te = this.elements;
        const a11 = ae[0], a12 = ae[3], a13 = ae[6];
        const a21 = ae[1], a22 = ae[4], a23 = ae[7];
        const a31 = ae[2], a32 = ae[5], a33 = ae[8];
        const b11 = be[0], b12 = be[3], b13 = be[6];
        const b21 = be[1], b22 = be[4], b23 = be[7];
        const b31 = be[2], b32 = be[5], b33 = be[8];
        te[0] = a11 * b11 + a12 * b21 + a13 * b31;
        te[3] = a11 * b12 + a12 * b22 + a13 * b32;
        te[6] = a11 * b13 + a12 * b23 + a13 * b33;
        te[1] = a21 * b11 + a22 * b21 + a23 * b31;
        te[4] = a21 * b12 + a22 * b22 + a23 * b32;
        te[7] = a21 * b13 + a22 * b23 + a23 * b33;
        te[2] = a31 * b11 + a32 * b21 + a33 * b31;
        te[5] = a31 * b12 + a32 * b22 + a33 * b32;
        te[8] = a31 * b13 + a32 * b23 + a33 * b33;
        return this;
    }
    /**
	 * Multiplies every component of the matrix by the given scalar.
	 *
	 * @param {number} s - The scalar.
	 * @return {Matrix3} A reference to this matrix.
	 */ multiplyScalar(s) {
        const te = this.elements;
        te[0] *= s;
        te[3] *= s;
        te[6] *= s;
        te[1] *= s;
        te[4] *= s;
        te[7] *= s;
        te[2] *= s;
        te[5] *= s;
        te[8] *= s;
        return this;
    }
    /**
	 * Computes and returns the determinant of this matrix.
	 *
	 * @return {number} The determinant.
	 */ determinant() {
        const te = this.elements;
        const a = te[0], b = te[1], c = te[2], d = te[3], e = te[4], f = te[5], g = te[6], h = te[7], i = te[8];
        return a * e * i - a * f * h - b * d * i + b * f * g + c * d * h - c * e * g;
    }
    /**
	 * Inverts this matrix, using the [analytic method]{@link https://en.wikipedia.org/wiki/Invertible_matrix#Analytic_solution}.
	 * You can not invert with a determinant of zero. If you attempt this, the method produces
	 * a zero matrix instead.
	 *
	 * @return {Matrix3} A reference to this matrix.
	 */ invert() {
        const te = this.elements, n11 = te[0], n21 = te[1], n31 = te[2], n12 = te[3], n22 = te[4], n32 = te[5], n13 = te[6], n23 = te[7], n33 = te[8], t11 = n33 * n22 - n32 * n23, t12 = n32 * n13 - n33 * n12, t13 = n23 * n12 - n22 * n13, det = n11 * t11 + n21 * t12 + n31 * t13;
        if (det === 0) return this.set(0, 0, 0, 0, 0, 0, 0, 0, 0);
        const detInv = 1 / det;
        te[0] = t11 * detInv;
        te[1] = (n31 * n23 - n33 * n21) * detInv;
        te[2] = (n32 * n21 - n31 * n22) * detInv;
        te[3] = t12 * detInv;
        te[4] = (n33 * n11 - n31 * n13) * detInv;
        te[5] = (n31 * n12 - n32 * n11) * detInv;
        te[6] = t13 * detInv;
        te[7] = (n21 * n13 - n23 * n11) * detInv;
        te[8] = (n22 * n11 - n21 * n12) * detInv;
        return this;
    }
    /**
	 * Transposes this matrix in place.
	 *
	 * @return {Matrix3} A reference to this matrix.
	 */ transpose() {
        let tmp;
        const m = this.elements;
        tmp = m[1];
        m[1] = m[3];
        m[3] = tmp;
        tmp = m[2];
        m[2] = m[6];
        m[6] = tmp;
        tmp = m[5];
        m[5] = m[7];
        m[7] = tmp;
        return this;
    }
    /**
	 * Computes the normal matrix which is the inverse transpose of the upper
	 * left 3x3 portion of the given 4x4 matrix.
	 *
	 * @param {Matrix4} matrix4 - The 4x4 matrix.
	 * @return {Matrix3} A reference to this matrix.
	 */ getNormalMatrix(matrix4) {
        return this.setFromMatrix4(matrix4).invert().transpose();
    }
    /**
	 * Transposes this matrix into the supplied array, and returns itself unchanged.
	 *
	 * @param {Array<number>} r - An array to store the transposed matrix elements.
	 * @return {Matrix3} A reference to this matrix.
	 */ transposeIntoArray(r) {
        const m = this.elements;
        r[0] = m[0];
        r[1] = m[3];
        r[2] = m[6];
        r[3] = m[1];
        r[4] = m[4];
        r[5] = m[7];
        r[6] = m[2];
        r[7] = m[5];
        r[8] = m[8];
        return this;
    }
    /**
	 * Sets the UV transform matrix from offset, repeat, rotation, and center.
	 *
	 * @param {number} tx - Offset x.
	 * @param {number} ty - Offset y.
	 * @param {number} sx - Repeat x.
	 * @param {number} sy - Repeat y.
	 * @param {number} rotation - Rotation, in radians. Positive values rotate counterclockwise.
	 * @param {number} cx - Center x of rotation.
	 * @param {number} cy - Center y of rotation
	 * @return {Matrix3} A reference to this matrix.
	 */ setUvTransform(tx, ty, sx, sy, rotation, cx, cy) {
        const c = Math.cos(rotation);
        const s = Math.sin(rotation);
        this.set(sx * c, sx * s, -sx * (c * cx + s * cy) + cx + tx, -sy * s, sy * c, -sy * (-s * cx + c * cy) + cy + ty, 0, 0, 1);
        return this;
    }
    /**
	 * Scales this matrix with the given scalar values.
	 *
	 * @param {number} sx - The amount to scale in the X axis.
	 * @param {number} sy - The amount to scale in the Y axis.
	 * @return {Matrix3} A reference to this matrix.
	 */ scale(sx, sy) {
        this.premultiply($9ddd7e9b53f7a2d4$var$_m3.makeScale(sx, sy));
        return this;
    }
    /**
	 * Rotates this matrix by the given angle.
	 *
	 * @param {number} theta - The rotation in radians.
	 * @return {Matrix3} A reference to this matrix.
	 */ rotate(theta) {
        this.premultiply($9ddd7e9b53f7a2d4$var$_m3.makeRotation(-theta));
        return this;
    }
    /**
	 * Translates this matrix by the given scalar values.
	 *
	 * @param {number} tx - The amount to translate in the X axis.
	 * @param {number} ty - The amount to translate in the Y axis.
	 * @return {Matrix3} A reference to this matrix.
	 */ translate(tx, ty) {
        this.premultiply($9ddd7e9b53f7a2d4$var$_m3.makeTranslation(tx, ty));
        return this;
    }
    // for 2D Transforms
    /**
	 * Sets this matrix as a 2D translation transform.
	 *
	 * @param {number|Vector2} x - The amount to translate in the X axis or alternatively a translation vector.
	 * @param {number} y - The amount to translate in the Y axis.
	 * @return {Matrix3} A reference to this matrix.
	 */ makeTranslation(x, y) {
        if (x.isVector2) this.set(1, 0, x.x, 0, 1, x.y, 0, 0, 1);
        else this.set(1, 0, x, 0, 1, y, 0, 0, 1);
        return this;
    }
    /**
	 * Sets this matrix as a 2D rotational transformation.
	 *
	 * @param {number} theta - The rotation in radians.
	 * @return {Matrix3} A reference to this matrix.
	 */ makeRotation(theta) {
        // counterclockwise
        const c = Math.cos(theta);
        const s = Math.sin(theta);
        this.set(c, -s, 0, s, c, 0, 0, 0, 1);
        return this;
    }
    /**
	 * Sets this matrix as a 2D scale transform.
	 *
	 * @param {number} x - The amount to scale in the X axis.
	 * @param {number} y - The amount to scale in the Y axis.
	 * @return {Matrix3} A reference to this matrix.
	 */ makeScale(x, y) {
        this.set(x, 0, 0, 0, y, 0, 0, 0, 1);
        return this;
    }
    /**
	 * Returns `true` if this matrix is equal with the given one.
	 *
	 * @param {Matrix3} matrix - The matrix to test for equality.
	 * @return {boolean} Whether this matrix is equal with the given one.
	 */ equals(matrix) {
        const te = this.elements;
        const me = matrix.elements;
        for(let i = 0; i < 9; i++){
            if (te[i] !== me[i]) return false;
        }
        return true;
    }
    /**
	 * Sets the elements of the matrix from the given array.
	 *
	 * @param {Array<number>} array - The matrix elements in column-major order.
	 * @param {number} [offset=0] - Index of the first element in the array.
	 * @return {Matrix3} A reference to this matrix.
	 */ fromArray(array, offset = 0) {
        for(let i = 0; i < 9; i++)this.elements[i] = array[i + offset];
        return this;
    }
    /**
	 * Writes the elements of this matrix to the given array. If no array is provided,
	 * the method returns a new instance.
	 *
	 * @param {Array<number>} [array=[]] - The target array holding the matrix elements in column-major order.
	 * @param {number} [offset=0] - Index of the first element in the array.
	 * @return {Array<number>} The matrix elements in column-major order.
	 */ toArray(array = [], offset = 0) {
        const te = this.elements;
        array[offset] = te[0];
        array[offset + 1] = te[1];
        array[offset + 2] = te[2];
        array[offset + 3] = te[3];
        array[offset + 4] = te[4];
        array[offset + 5] = te[5];
        array[offset + 6] = te[6];
        array[offset + 7] = te[7];
        array[offset + 8] = te[8];
        return array;
    }
    /**
	 * Returns a matrix with copied values from this instance.
	 *
	 * @return {Matrix3} A clone of this instance.
	 */ clone() {
        return new this.constructor().fromArray(this.elements);
    }
}
const $9ddd7e9b53f7a2d4$var$_m3 = /*@__PURE__*/ new $9ddd7e9b53f7a2d4$export$8ff26dafa08918();
function $9ddd7e9b53f7a2d4$export$bc6f937da07eae17(array) {
    // assumes larger values usually on last
    for(let i = array.length - 1; i >= 0; --i){
        if (array[i] >= 65535) return true; // account for PRIMITIVE_RESTART_FIXED_INDEX, #24565
    }
    return false;
}
const $9ddd7e9b53f7a2d4$var$TYPED_ARRAYS = {
    Int8Array: Int8Array,
    Uint8Array: Uint8Array,
    Uint8ClampedArray: Uint8ClampedArray,
    Int16Array: Int16Array,
    Uint16Array: Uint16Array,
    Int32Array: Int32Array,
    Uint32Array: Uint32Array,
    Float32Array: Float32Array,
    Float64Array: Float64Array
};
function $9ddd7e9b53f7a2d4$var$getTypedArray(type, buffer) {
    return new $9ddd7e9b53f7a2d4$var$TYPED_ARRAYS[type](buffer);
}
function $9ddd7e9b53f7a2d4$export$7094a064528c7fee(name) {
    return document.createElementNS('http://www.w3.org/1999/xhtml', name);
}
function $9ddd7e9b53f7a2d4$export$1033a2df66368859() {
    const canvas = $9ddd7e9b53f7a2d4$export$7094a064528c7fee('canvas');
    canvas.style.display = 'block';
    return canvas;
}
const $9ddd7e9b53f7a2d4$var$_cache = {};
function $9ddd7e9b53f7a2d4$export$5b28268982f175ba(message) {
    if (message in $9ddd7e9b53f7a2d4$var$_cache) return;
    $9ddd7e9b53f7a2d4$var$_cache[message] = true;
    console.warn(message);
}
function $9ddd7e9b53f7a2d4$export$d43f91ebeafb2c7(gl, sync, interval) {
    return new Promise(function(resolve, reject) {
        function probe() {
            switch(gl.clientWaitSync(sync, gl.SYNC_FLUSH_COMMANDS_BIT, 0)){
                case gl.WAIT_FAILED:
                    reject();
                    break;
                case gl.TIMEOUT_EXPIRED:
                    setTimeout(probe, interval);
                    break;
                default:
                    resolve();
            }
        }
        setTimeout(probe, interval);
    });
}
function $9ddd7e9b53f7a2d4$export$5238391f68c729b(projectionMatrix) {
    const m = projectionMatrix.elements;
    // Convert [-1, 1] to [0, 1] projection matrix
    m[2] = 0.5 * m[2] + 0.5 * m[3];
    m[6] = 0.5 * m[6] + 0.5 * m[7];
    m[10] = 0.5 * m[10] + 0.5 * m[11];
    m[14] = 0.5 * m[14] + 0.5 * m[15];
}
function $9ddd7e9b53f7a2d4$export$f8cf97d08da9bc86(projectionMatrix) {
    const m = projectionMatrix.elements;
    const isPerspectiveMatrix = m[11] === -1;
    // Reverse [0, 1] projection matrix
    if (isPerspectiveMatrix) {
        m[10] = -m[10] - 1;
        m[14] = -m[14];
    } else {
        m[10] = -m[10];
        m[14] = -m[14] + 1;
    }
}
const $9ddd7e9b53f7a2d4$var$LINEAR_REC709_TO_XYZ = /*@__PURE__*/ new $9ddd7e9b53f7a2d4$export$8ff26dafa08918().set(0.4123908, 0.3575843, 0.1804808, 0.2126390, 0.7151687, 0.0721923, 0.0193308, 0.1191948, 0.9505322);
const $9ddd7e9b53f7a2d4$var$XYZ_TO_LINEAR_REC709 = /*@__PURE__*/ new $9ddd7e9b53f7a2d4$export$8ff26dafa08918().set(3.2409699, -1.5373832, -0.4986108, -0.9692436, 1.8759675, 0.0415551, 0.0556301, -0.203977, 1.0569715);
function $9ddd7e9b53f7a2d4$var$createColorManagement() {
    const ColorManagement = {
        enabled: true,
        workingColorSpace: $9ddd7e9b53f7a2d4$export$42429b3acfb233a4,
        /**
		 * Implementations of supported color spaces.
		 *
		 * Required:
		 *	- primaries: chromaticity coordinates [ rx ry gx gy bx by ]
		 *	- whitePoint: reference white [ x y ]
		 *	- transfer: transfer function (pre-defined)
		 *	- toXYZ: Matrix3 RGB to XYZ transform
		 *	- fromXYZ: Matrix3 XYZ to RGB transform
		 *	- luminanceCoefficients: RGB luminance coefficients
		 *
		 * Optional:
		 *  - outputColorSpaceConfig: { drawingBufferColorSpace: ColorSpace }
		 *  - workingColorSpaceConfig: { unpackColorSpace: ColorSpace }
		 *
		 * Reference:
		 * - https://www.russellcottrell.com/photo/matrixCalculator.htm
		 */ spaces: {},
        convert: function(color, sourceColorSpace, targetColorSpace) {
            if (this.enabled === false || sourceColorSpace === targetColorSpace || !sourceColorSpace || !targetColorSpace) return color;
            if (this.spaces[sourceColorSpace].transfer === $9ddd7e9b53f7a2d4$export$8d0a61916cc26abb) {
                color.r = $9ddd7e9b53f7a2d4$var$SRGBToLinear(color.r);
                color.g = $9ddd7e9b53f7a2d4$var$SRGBToLinear(color.g);
                color.b = $9ddd7e9b53f7a2d4$var$SRGBToLinear(color.b);
            }
            if (this.spaces[sourceColorSpace].primaries !== this.spaces[targetColorSpace].primaries) {
                color.applyMatrix3(this.spaces[sourceColorSpace].toXYZ);
                color.applyMatrix3(this.spaces[targetColorSpace].fromXYZ);
            }
            if (this.spaces[targetColorSpace].transfer === $9ddd7e9b53f7a2d4$export$8d0a61916cc26abb) {
                color.r = $9ddd7e9b53f7a2d4$var$LinearToSRGB(color.r);
                color.g = $9ddd7e9b53f7a2d4$var$LinearToSRGB(color.g);
                color.b = $9ddd7e9b53f7a2d4$var$LinearToSRGB(color.b);
            }
            return color;
        },
        fromWorkingColorSpace: function(color, targetColorSpace) {
            return this.convert(color, this.workingColorSpace, targetColorSpace);
        },
        toWorkingColorSpace: function(color, sourceColorSpace) {
            return this.convert(color, sourceColorSpace, this.workingColorSpace);
        },
        getPrimaries: function(colorSpace) {
            return this.spaces[colorSpace].primaries;
        },
        getTransfer: function(colorSpace) {
            if (colorSpace === $9ddd7e9b53f7a2d4$export$bfcb490c2dd3db51) return $9ddd7e9b53f7a2d4$export$f197347d588c1b4a;
            return this.spaces[colorSpace].transfer;
        },
        getLuminanceCoefficients: function(target, colorSpace = this.workingColorSpace) {
            return target.fromArray(this.spaces[colorSpace].luminanceCoefficients);
        },
        define: function(colorSpaces) {
            Object.assign(this.spaces, colorSpaces);
        },
        // Internal APIs
        _getMatrix: function(targetMatrix, sourceColorSpace, targetColorSpace) {
            return targetMatrix.copy(this.spaces[sourceColorSpace].toXYZ).multiply(this.spaces[targetColorSpace].fromXYZ);
        },
        _getDrawingBufferColorSpace: function(colorSpace) {
            return this.spaces[colorSpace].outputColorSpaceConfig.drawingBufferColorSpace;
        },
        _getUnpackColorSpace: function(colorSpace = this.workingColorSpace) {
            return this.spaces[colorSpace].workingColorSpaceConfig.unpackColorSpace;
        }
    };
    /******************************************************************************
	 * sRGB definitions
	 */ const REC709_PRIMARIES = [
        0.640,
        0.330,
        0.300,
        0.600,
        0.150,
        0.060
    ];
    const REC709_LUMINANCE_COEFFICIENTS = [
        0.2126,
        0.7152,
        0.0722
    ];
    const D65 = [
        0.3127,
        0.3290
    ];
    ColorManagement.define({
        [$9ddd7e9b53f7a2d4$export$42429b3acfb233a4]: {
            primaries: REC709_PRIMARIES,
            whitePoint: D65,
            transfer: $9ddd7e9b53f7a2d4$export$f197347d588c1b4a,
            toXYZ: $9ddd7e9b53f7a2d4$var$LINEAR_REC709_TO_XYZ,
            fromXYZ: $9ddd7e9b53f7a2d4$var$XYZ_TO_LINEAR_REC709,
            luminanceCoefficients: REC709_LUMINANCE_COEFFICIENTS,
            workingColorSpaceConfig: {
                unpackColorSpace: $9ddd7e9b53f7a2d4$export$561f394b24edfcaa
            },
            outputColorSpaceConfig: {
                drawingBufferColorSpace: $9ddd7e9b53f7a2d4$export$561f394b24edfcaa
            }
        },
        [$9ddd7e9b53f7a2d4$export$561f394b24edfcaa]: {
            primaries: REC709_PRIMARIES,
            whitePoint: D65,
            transfer: $9ddd7e9b53f7a2d4$export$8d0a61916cc26abb,
            toXYZ: $9ddd7e9b53f7a2d4$var$LINEAR_REC709_TO_XYZ,
            fromXYZ: $9ddd7e9b53f7a2d4$var$XYZ_TO_LINEAR_REC709,
            luminanceCoefficients: REC709_LUMINANCE_COEFFICIENTS,
            outputColorSpaceConfig: {
                drawingBufferColorSpace: $9ddd7e9b53f7a2d4$export$561f394b24edfcaa
            }
        }
    });
    return ColorManagement;
}
const $9ddd7e9b53f7a2d4$export$5e6fd513f44698c = /*@__PURE__*/ $9ddd7e9b53f7a2d4$var$createColorManagement();
function $9ddd7e9b53f7a2d4$var$SRGBToLinear(c) {
    return c < 0.04045 ? c * 0.0773993808 : Math.pow(c * 0.9478672986 + 0.0521327014, 2.4);
}
function $9ddd7e9b53f7a2d4$var$LinearToSRGB(c) {
    return c < 0.0031308 ? c * 12.92 : 1.055 * Math.pow(c, 0.41666) - 0.055;
}
let $9ddd7e9b53f7a2d4$var$_canvas;
/**
 * A class containing utility functions for images.
 *
 * @hideconstructor
 */ class $9ddd7e9b53f7a2d4$export$698882cf06df44aa {
    /**
	 * Returns a data URI containing a representation of the given image.
	 *
	 * @param {(HTMLImageElement|HTMLCanvasElement)} image - The image object.
	 * @param {string} [type='image/png'] - Indicates the image format.
	 * @return {string} The data URI.
	 */ static getDataURL(image, type = 'image/png') {
        if (/^data:/i.test(image.src)) return image.src;
        if (typeof HTMLCanvasElement === 'undefined') return image.src;
        let canvas;
        if (image instanceof HTMLCanvasElement) canvas = image;
        else {
            if ($9ddd7e9b53f7a2d4$var$_canvas === undefined) $9ddd7e9b53f7a2d4$var$_canvas = $9ddd7e9b53f7a2d4$export$7094a064528c7fee('canvas');
            $9ddd7e9b53f7a2d4$var$_canvas.width = image.width;
            $9ddd7e9b53f7a2d4$var$_canvas.height = image.height;
            const context = $9ddd7e9b53f7a2d4$var$_canvas.getContext('2d');
            if (image instanceof ImageData) context.putImageData(image, 0, 0);
            else context.drawImage(image, 0, 0, image.width, image.height);
            canvas = $9ddd7e9b53f7a2d4$var$_canvas;
        }
        return canvas.toDataURL(type);
    }
    /**
	 * Converts the given sRGB image data to linear color space.
	 *
	 * @param {(HTMLImageElement|HTMLCanvasElement|ImageBitmap|Object)} image - The image object.
	 * @return {HTMLCanvasElement|Object} The converted image.
	 */ static sRGBToLinear(image) {
        if (typeof HTMLImageElement !== 'undefined' && image instanceof HTMLImageElement || typeof HTMLCanvasElement !== 'undefined' && image instanceof HTMLCanvasElement || typeof ImageBitmap !== 'undefined' && image instanceof ImageBitmap) {
            const canvas = $9ddd7e9b53f7a2d4$export$7094a064528c7fee('canvas');
            canvas.width = image.width;
            canvas.height = image.height;
            const context = canvas.getContext('2d');
            context.drawImage(image, 0, 0, image.width, image.height);
            const imageData = context.getImageData(0, 0, image.width, image.height);
            const data = imageData.data;
            for(let i = 0; i < data.length; i++)data[i] = $9ddd7e9b53f7a2d4$var$SRGBToLinear(data[i] / 255) * 255;
            context.putImageData(imageData, 0, 0);
            return canvas;
        } else if (image.data) {
            const data = image.data.slice(0);
            for(let i = 0; i < data.length; i++)if (data instanceof Uint8Array || data instanceof Uint8ClampedArray) data[i] = Math.floor($9ddd7e9b53f7a2d4$var$SRGBToLinear(data[i] / 255) * 255);
            else // assuming float
            data[i] = $9ddd7e9b53f7a2d4$var$SRGBToLinear(data[i]);
            return {
                data: data,
                width: image.width,
                height: image.height
            };
        } else {
            console.warn('THREE.ImageUtils.sRGBToLinear(): Unsupported image type. No color space conversion applied.');
            return image;
        }
    }
}
let $9ddd7e9b53f7a2d4$var$_sourceId = 0;
/**
 * Represents the data source of a texture.
 *
 * The main purpose of this class is to decouple the data definition from the texture
 * definition so the same data can be used with multiple texture instances.
 */ class $9ddd7e9b53f7a2d4$export$1d2df86270c81ecb {
    /**
	 * Constructs a new video texture.
	 *
	 * @param {any} [data=null] - The data definition of a texture.
	 */ constructor(data = null){
        /**
		 * This flag can be used for type testing.
		 *
		 * @type {boolean}
		 * @readonly
		 * @default true
		 */ this.isSource = true;
        /**
		 * The ID of the source.
		 *
		 * @name Source#id
		 * @type {number}
		 * @readonly
		 */ Object.defineProperty(this, 'id', {
            value: $9ddd7e9b53f7a2d4$var$_sourceId++
        });
        /**
		 * The UUID of the source.
		 *
		 * @type {string}
		 * @readonly
		 */ this.uuid = $9ddd7e9b53f7a2d4$var$generateUUID();
        /**
		 * The data definition of a texture.
		 *
		 * @type {any}
		 */ this.data = data;
        /**
		 * This property is only relevant when {@link Source#needsUpdate} is set to `true` and
		 * provides more control on how texture data should be processed. When `dataReady` is set
		 * to `false`, the engine performs the memory allocation (if necessary) but does not transfer
		 * the data into the GPU memory.
		 *
		 * @type {boolean}
		 * @default true
		 */ this.dataReady = true;
        /**
		 * This starts at `0` and counts how many times {@link Source#needsUpdate} is set to `true`.
		 *
		 * @type {number}
		 * @readonly
		 * @default 0
		 */ this.version = 0;
    }
    /**
	 * When the property is set to `true`, the engine allocates the memory
	 * for the texture (if necessary) and triggers the actual texture upload
	 * to the GPU next time the source is used.
	 *
	 * @type {boolean}
	 * @default false
	 * @param {boolean} value
	 */ set needsUpdate(value) {
        if (value === true) this.version++;
    }
    /**
	 * Serializes the source into JSON.
	 *
	 * @param {?(Object|string)} meta - An optional value holding meta information about the serialization.
	 * @return {Object} A JSON object representing the serialized source.
	 * @see {@link ObjectLoader#parse}
	 */ toJSON(meta) {
        const isRootObject = meta === undefined || typeof meta === 'string';
        if (!isRootObject && meta.images[this.uuid] !== undefined) return meta.images[this.uuid];
        const output = {
            uuid: this.uuid,
            url: ''
        };
        const data = this.data;
        if (data !== null) {
            let url;
            if (Array.isArray(data)) {
                // cube texture
                url = [];
                for(let i = 0, l = data.length; i < l; i++)if (data[i].isDataTexture) url.push($9ddd7e9b53f7a2d4$var$serializeImage(data[i].image));
                else url.push($9ddd7e9b53f7a2d4$var$serializeImage(data[i]));
            } else // texture
            url = $9ddd7e9b53f7a2d4$var$serializeImage(data);
            output.url = url;
        }
        if (!isRootObject) meta.images[this.uuid] = output;
        return output;
    }
}
function $9ddd7e9b53f7a2d4$var$serializeImage(image) {
    if (typeof HTMLImageElement !== 'undefined' && image instanceof HTMLImageElement || typeof HTMLCanvasElement !== 'undefined' && image instanceof HTMLCanvasElement || typeof ImageBitmap !== 'undefined' && image instanceof ImageBitmap) // default images
    return $9ddd7e9b53f7a2d4$export$698882cf06df44aa.getDataURL(image);
    else {
        if (image.data) // images of DataTexture
        return {
            data: Array.from(image.data),
            width: image.width,
            height: image.height,
            type: image.data.constructor.name
        };
        else {
            console.warn('THREE.Texture: Unable to serialize Texture.');
            return {};
        }
    }
}
let $9ddd7e9b53f7a2d4$var$_textureId = 0;
/**
 * Base class for all textures.
 *
 * Note: After the initial use of a texture, its dimensions, format, and type
 * cannot be changed. Instead, call {@link Texture#dispose} on the texture and instantiate a new one.
 *
 * @augments EventDispatcher
 */ class $9ddd7e9b53f7a2d4$export$5431306cf43de24a extends $9ddd7e9b53f7a2d4$export$ec8b666c5fe2c75a {
    /**
	 * Constructs a new texture.
	 *
	 * @param {?Object} [image=Texture.DEFAULT_IMAGE] - The image holding the texture data.
	 * @param {number} [mapping=Texture.DEFAULT_MAPPING] - The texture mapping.
	 * @param {number} [wrapS=ClampToEdgeWrapping] - The wrapS value.
	 * @param {number} [wrapT=ClampToEdgeWrapping] - The wrapT value.
	 * @param {number} [magFilter=LinearFilter] - The mag filter value.
	 * @param {number} [minFilter=LinearMipmapLinearFilter] - The min filter value.
	 * @param {number} [format=RGBAFormat] - The texture format.
	 * @param {number} [type=UnsignedByteType] - The texture type.
	 * @param {number} [anisotropy=Texture.DEFAULT_ANISOTROPY] - The anisotropy value.
	 * @param {string} [colorSpace=NoColorSpace] - The color space.
	 */ constructor(image = $9ddd7e9b53f7a2d4$export$5431306cf43de24a.DEFAULT_IMAGE, mapping = $9ddd7e9b53f7a2d4$export$5431306cf43de24a.DEFAULT_MAPPING, wrapS = $9ddd7e9b53f7a2d4$export$9d9334239a5a5e06, wrapT = $9ddd7e9b53f7a2d4$export$9d9334239a5a5e06, magFilter = $9ddd7e9b53f7a2d4$export$8a72f490b25c56c8, minFilter = $9ddd7e9b53f7a2d4$export$5d8599b6a933fb1b, format = $9ddd7e9b53f7a2d4$export$3f8bb04b555a363c, type = $9ddd7e9b53f7a2d4$export$2e8ce08d3f6f5e10, anisotropy = $9ddd7e9b53f7a2d4$export$5431306cf43de24a.DEFAULT_ANISOTROPY, colorSpace = $9ddd7e9b53f7a2d4$export$bfcb490c2dd3db51){
        super();
        /**
		 * This flag can be used for type testing.
		 *
		 * @type {boolean}
		 * @readonly
		 * @default true
		 */ this.isTexture = true;
        /**
		 * The ID of the texture.
		 *
		 * @name Texture#id
		 * @type {number}
		 * @readonly
		 */ Object.defineProperty(this, 'id', {
            value: $9ddd7e9b53f7a2d4$var$_textureId++
        });
        /**
		 * The UUID of the material.
		 *
		 * @type {string}
		 * @readonly
		 */ this.uuid = $9ddd7e9b53f7a2d4$var$generateUUID();
        /**
		 * The name of the material.
		 *
		 * @type {string}
		 */ this.name = '';
        /**
		 * The data definition of a texture. A reference to the data source can be
		 * shared across textures. This is often useful in context of spritesheets
		 * where multiple textures render the same data but with different texture
		 * transformations.
		 *
		 * @type {Source}
		 */ this.source = new $9ddd7e9b53f7a2d4$export$1d2df86270c81ecb(image);
        /**
		 * An array holding user-defined mipmaps.
		 *
		 * @type {Array<Object>}
		 */ this.mipmaps = [];
        /**
		 * How the texture is applied to the object. The value `UVMapping`
		 * is the default, where texture or uv coordinates are used to apply the map.
		 *
		 * @type {(UVMapping|CubeReflectionMapping|CubeRefractionMapping|EquirectangularReflectionMapping|EquirectangularRefractionMapping|CubeUVReflectionMapping)}
		 * @default UVMapping
		*/ this.mapping = mapping;
        /**
		 * Lets you select the uv attribute to map the texture to. `0` for `uv`,
		 * `1` for `uv1`, `2` for `uv2` and `3` for `uv3`.
		 *
		 * @type {number}
		 * @default 0
		 */ this.channel = 0;
        /**
		 * This defines how the texture is wrapped horizontally and corresponds to
		 * *U* in UV mapping.
		 *
		 * @type {(RepeatWrapping|ClampToEdgeWrapping|MirroredRepeatWrapping)}
		 * @default ClampToEdgeWrapping
		 */ this.wrapS = wrapS;
        /**
		 * This defines how the texture is wrapped horizontally and corresponds to
		 * *V* in UV mapping.
		 *
		 * @type {(RepeatWrapping|ClampToEdgeWrapping|MirroredRepeatWrapping)}
		 * @default ClampToEdgeWrapping
		 */ this.wrapT = wrapT;
        /**
		 * How the texture is sampled when a texel covers more than one pixel.
		 *
		 * @type {(NearestFilter|NearestMipmapNearestFilter|NearestMipmapLinearFilter|LinearFilter|LinearMipmapNearestFilter|LinearMipmapLinearFilter)}
		 * @default LinearFilter
		 */ this.magFilter = magFilter;
        /**
		 * How the texture is sampled when a texel covers less than one pixel.
		 *
		 * @type {(NearestFilter|NearestMipmapNearestFilter|NearestMipmapLinearFilter|LinearFilter|LinearMipmapNearestFilter|LinearMipmapLinearFilter)}
		 * @default LinearMipmapLinearFilter
		 */ this.minFilter = minFilter;
        /**
		 * The number of samples taken along the axis through the pixel that has the
		 * highest density of texels. By default, this value is `1`. A higher value
		 * gives a less blurry result than a basic mipmap, at the cost of more
		 * texture samples being used.
		 *
		 * @type {number}
		 * @default 0
		 */ this.anisotropy = anisotropy;
        /**
		 * The format of the texture.
		 *
		 * @type {number}
		 * @default RGBAFormat
		 */ this.format = format;
        /**
		 * The default internal format is derived from {@link Texture#format} and {@link Texture#type} and
		 * defines how the texture data is going to be stored on the GPU.
		 *
		 * This property allows to overwrite the default format.
		 *
		 * @type {?string}
		 * @default null
		 */ this.internalFormat = null;
        /**
		 * The data type of the texture.
		 *
		 * @type {number}
		 * @default UnsignedByteType
		 */ this.type = type;
        /**
		 * How much a single repetition of the texture is offset from the beginning,
		 * in each direction U and V. Typical range is `0.0` to `1.0`.
		 *
		 * @type {Vector2}
		 * @default (0,0)
		 */ this.offset = new $9ddd7e9b53f7a2d4$export$c977b3e384af9ae1(0, 0);
        /**
		 * How many times the texture is repeated across the surface, in each
		 * direction U and V. If repeat is set greater than `1` in either direction,
		 * the corresponding wrap parameter should also be set to `RepeatWrapping`
		 * or `MirroredRepeatWrapping` to achieve the desired tiling effect.
		 *
		 * @type {Vector2}
		 * @default (1,1)
		 */ this.repeat = new $9ddd7e9b53f7a2d4$export$c977b3e384af9ae1(1, 1);
        /**
		 * The point around which rotation occurs. A value of `(0.5, 0.5)` corresponds
		 * to the center of the texture. Default is `(0, 0)`, the lower left.
		 *
		 * @type {Vector2}
		 * @default (0,0)
		 */ this.center = new $9ddd7e9b53f7a2d4$export$c977b3e384af9ae1(0, 0);
        /**
		 * How much the texture is rotated around the center point, in radians.
		 * Positive values are counter-clockwise.
		 *
		 * @type {number}
		 * @default 0
		 */ this.rotation = 0;
        /**
		 * Whether to update the texture's uv-transformation {@link Texture#matrix}
		 * from the properties {@link Texture#offset}, {@link Texture#repeat},
		 * {@link Texture#rotation}, and {@link Texture#center}.
		 *
		 * Set this to `false` if you are specifying the uv-transform matrix directly.
		 *
		 * @type {boolean}
		 * @default true
		 */ this.matrixAutoUpdate = true;
        /**
		 * The uv-transformation matrix of the texture.
		 *
		 * @type {Matrix3}
		 */ this.matrix = new $9ddd7e9b53f7a2d4$export$8ff26dafa08918();
        /**
		 * Whether to generate mipmaps (if possible) for a texture.
		 *
		 * Set this to `false` if you are creating mipmaps manually.
		 *
		 * @type {boolean}
		 * @default true
		 */ this.generateMipmaps = true;
        /**
		 * If set to `true`, the alpha channel, if present, is multiplied into the
		 * color channels when the texture is uploaded to the GPU.
		 *
		 * Note that this property has no effect when using `ImageBitmap`. You need to
		 * configure premultiply alpha on bitmap creation instead.
		 *
		 * @type {boolean}
		 * @default false
		 */ this.premultiplyAlpha = false;
        /**
		 * If set to `true`, the texture is flipped along the vertical axis when
		 * uploaded to the GPU.
		 *
		 * Note that this property has no effect when using `ImageBitmap`. You need to
		 * configure the flip on bitmap creation instead.
		 *
		 * @type {boolean}
		 * @default true
		 */ this.flipY = true;
        /**
		 * Specifies the alignment requirements for the start of each pixel row in memory.
		 * The allowable values are `1` (byte-alignment), `2` (rows aligned to even-numbered bytes),
		 * `4` (word-alignment), and `8` (rows start on double-word boundaries).
		 *
		 * @type {number}
		 * @default 4
		 */ this.unpackAlignment = 4; // valid values: 1, 2, 4, 8 (see http://www.khronos.org/opengles/sdk/docs/man/xhtml/glPixelStorei.xml)
        /**
		 * Textures containing color data should be annotated with `SRGBColorSpace` or `LinearSRGBColorSpace`.
		 *
		 * @type {string}
		 * @default NoColorSpace
		 */ this.colorSpace = colorSpace;
        /**
		 * An object that can be used to store custom data about the texture. It
		 * should not hold references to functions as these will not be cloned.
		 *
		 * @type {Object}
		 */ this.userData = {};
        /**
		 * This starts at `0` and counts how many times {@link Texture#needsUpdate} is set to `true`.
		 *
		 * @type {number}
		 * @readonly
		 * @default 0
		 */ this.version = 0;
        /**
		 * A callback function, called when the texture is updated (e.g., when
		 * {@link Texture#needsUpdate} has been set to true and then the texture is used).
		 *
		 * @type {?Function}
		 * @default null
		 */ this.onUpdate = null;
        /**
		 * An optional back reference to the textures render target.
		 *
		 * @type {?(RenderTarget|WebGLRenderTarget)}
		 * @default null
		 */ this.renderTarget = null;
        /**
		 * Indicates whether a texture belongs to a render target or not.
		 *
		 * @type {boolean}
		 * @readonly
		 * @default false
		 */ this.isRenderTargetTexture = false;
        /**
		 * Indicates whether this texture should be processed by `PMREMGenerator` or not
		 * (only relevant for render target textures).
		 *
		 * @type {number}
		 * @readonly
		 * @default 0
		 */ this.pmremVersion = 0;
    }
    /**
	 * The image object holding the texture data.
	 *
	 * @type {?Object}
	 */ get image() {
        return this.source.data;
    }
    set image(value = null) {
        this.source.data = value;
    }
    /**
	 * Updates the texture transformation matrix from the from the properties {@link Texture#offset},
	 * {@link Texture#repeat}, {@link Texture#rotation}, and {@link Texture#center}.
	 */ updateMatrix() {
        this.matrix.setUvTransform(this.offset.x, this.offset.y, this.repeat.x, this.repeat.y, this.rotation, this.center.x, this.center.y);
    }
    /**
	 * Returns a new texture with copied values from this instance.
	 *
	 * @return {Texture} A clone of this instance.
	 */ clone() {
        return new this.constructor().copy(this);
    }
    /**
	 * Copies the values of the given texture to this instance.
	 *
	 * @param {Texture} source - The texture to copy.
	 * @return {Texture} A reference to this instance.
	 */ copy(source) {
        this.name = source.name;
        this.source = source.source;
        this.mipmaps = source.mipmaps.slice(0);
        this.mapping = source.mapping;
        this.channel = source.channel;
        this.wrapS = source.wrapS;
        this.wrapT = source.wrapT;
        this.magFilter = source.magFilter;
        this.minFilter = source.minFilter;
        this.anisotropy = source.anisotropy;
        this.format = source.format;
        this.internalFormat = source.internalFormat;
        this.type = source.type;
        this.offset.copy(source.offset);
        this.repeat.copy(source.repeat);
        this.center.copy(source.center);
        this.rotation = source.rotation;
        this.matrixAutoUpdate = source.matrixAutoUpdate;
        this.matrix.copy(source.matrix);
        this.generateMipmaps = source.generateMipmaps;
        this.premultiplyAlpha = source.premultiplyAlpha;
        this.flipY = source.flipY;
        this.unpackAlignment = source.unpackAlignment;
        this.colorSpace = source.colorSpace;
        this.renderTarget = source.renderTarget;
        this.isRenderTargetTexture = source.isRenderTargetTexture;
        this.userData = JSON.parse(JSON.stringify(source.userData));
        this.needsUpdate = true;
        return this;
    }
    /**
	 * Serializes the texture into JSON.
	 *
	 * @param {?(Object|string)} meta - An optional value holding meta information about the serialization.
	 * @return {Object} A JSON object representing the serialized texture.
	 * @see {@link ObjectLoader#parse}
	 */ toJSON(meta) {
        const isRootObject = meta === undefined || typeof meta === 'string';
        if (!isRootObject && meta.textures[this.uuid] !== undefined) return meta.textures[this.uuid];
        const output = {
            metadata: {
                version: 4.6,
                type: 'Texture',
                generator: 'Texture.toJSON'
            },
            uuid: this.uuid,
            name: this.name,
            image: this.source.toJSON(meta).uuid,
            mapping: this.mapping,
            channel: this.channel,
            repeat: [
                this.repeat.x,
                this.repeat.y
            ],
            offset: [
                this.offset.x,
                this.offset.y
            ],
            center: [
                this.center.x,
                this.center.y
            ],
            rotation: this.rotation,
            wrap: [
                this.wrapS,
                this.wrapT
            ],
            format: this.format,
            internalFormat: this.internalFormat,
            type: this.type,
            colorSpace: this.colorSpace,
            minFilter: this.minFilter,
            magFilter: this.magFilter,
            anisotropy: this.anisotropy,
            flipY: this.flipY,
            generateMipmaps: this.generateMipmaps,
            premultiplyAlpha: this.premultiplyAlpha,
            unpackAlignment: this.unpackAlignment
        };
        if (Object.keys(this.userData).length > 0) output.userData = this.userData;
        if (!isRootObject) meta.textures[this.uuid] = output;
        return output;
    }
    /**
	 * Frees the GPU-related resources allocated by this instance. Call this
	 * method whenever this instance is no longer used in your app.
	 *
	 * @fires Texture#dispose
	 */ dispose() {
        /**
		 * Fires when the texture has been disposed of.
		 *
		 * @event Texture#dispose
		 * @type {Object}
		 */ this.dispatchEvent({
            type: 'dispose'
        });
    }
    /**
	 * Transforms the given uv vector with the textures uv transformation matrix.
	 *
	 * @param {Vector2} uv - The uv vector.
	 * @return {Vector2} The transformed uv vector.
	 */ transformUv(uv) {
        if (this.mapping !== $9ddd7e9b53f7a2d4$export$1beec6768cbb3d2d) return uv;
        uv.applyMatrix3(this.matrix);
        if (uv.x < 0 || uv.x > 1) switch(this.wrapS){
            case $9ddd7e9b53f7a2d4$export$533346c8e8dac0f5:
                uv.x = uv.x - Math.floor(uv.x);
                break;
            case $9ddd7e9b53f7a2d4$export$9d9334239a5a5e06:
                uv.x = uv.x < 0 ? 0 : 1;
                break;
            case $9ddd7e9b53f7a2d4$export$c7e7c00b14f51a4f:
                if (Math.abs(Math.floor(uv.x) % 2) === 1) uv.x = Math.ceil(uv.x) - uv.x;
                else uv.x = uv.x - Math.floor(uv.x);
                break;
        }
        if (uv.y < 0 || uv.y > 1) switch(this.wrapT){
            case $9ddd7e9b53f7a2d4$export$533346c8e8dac0f5:
                uv.y = uv.y - Math.floor(uv.y);
                break;
            case $9ddd7e9b53f7a2d4$export$9d9334239a5a5e06:
                uv.y = uv.y < 0 ? 0 : 1;
                break;
            case $9ddd7e9b53f7a2d4$export$c7e7c00b14f51a4f:
                if (Math.abs(Math.floor(uv.y) % 2) === 1) uv.y = Math.ceil(uv.y) - uv.y;
                else uv.y = uv.y - Math.floor(uv.y);
                break;
        }
        if (this.flipY) uv.y = 1 - uv.y;
        return uv;
    }
    /**
	 * Setting this property to `true` indicates the engine the texture
	 * must be updated in the next render. This triggers a texture upload
	 * to the GPU and ensures correct texture parameter configuration.
	 *
	 * @type {boolean}
	 * @default false
	 * @param {boolean} value
	 */ set needsUpdate(value) {
        if (value === true) {
            this.version++;
            this.source.needsUpdate = true;
        }
    }
    /**
	 * Setting this property to `true` indicates the engine the PMREM
	 * must be regenerated.
	 *
	 * @type {boolean}
	 * @default false
	 * @param {boolean} value
	 */ set needsPMREMUpdate(value) {
        if (value === true) this.pmremVersion++;
    }
}
/**
 * The default image for all textures.
 *
 * @static
 * @type {?Image}
 * @default null
 */ $9ddd7e9b53f7a2d4$export$5431306cf43de24a.DEFAULT_IMAGE = null;
/**
 * The default mapping for all textures.
 *
 * @static
 * @type {number}
 * @default UVMapping
 */ $9ddd7e9b53f7a2d4$export$5431306cf43de24a.DEFAULT_MAPPING = $9ddd7e9b53f7a2d4$export$1beec6768cbb3d2d;
/**
 * The default anisotropy value for all textures.
 *
 * @static
 * @type {number}
 * @default 1
 */ $9ddd7e9b53f7a2d4$export$5431306cf43de24a.DEFAULT_ANISOTROPY = 1;
/**
 * Class representing a 4D vector. A 4D vector is an ordered quadruplet of numbers
 * (labeled x, y, z and w), which can be used to represent a number of things, such as:
 *
 * - A point in 4D space.
 * - A direction and length in 4D space. In three.js the length will
 * always be the Euclidean distance(straight-line distance) from `(0, 0, 0, 0)` to `(x, y, z, w)`
 * and the direction is also measured from `(0, 0, 0, 0)` towards `(x, y, z, w)`.
 * - Any arbitrary ordered quadruplet of numbers.
 *
 * There are other things a 4D vector can be used to represent, however these
 * are the most common uses in *three.js*.
 *
 * Iterating through a vector instance will yield its components `(x, y, z, w)` in
 * the corresponding order.
 * ```js
 * const a = new THREE.Vector4( 0, 1, 0, 0 );
 *
 * //no arguments; will be initialised to (0, 0, 0, 1)
 * const b = new THREE.Vector4( );
 *
 * const d = a.dot( b );
 * ```
 */ class $9ddd7e9b53f7a2d4$export$fa7daccca11cdbe3 {
    /**
	 * Constructs a new 4D vector.
	 *
	 * @param {number} [x=0] - The x value of this vector.
	 * @param {number} [y=0] - The y value of this vector.
	 * @param {number} [z=0] - The z value of this vector.
	 * @param {number} [w=1] - The w value of this vector.
	 */ constructor(x = 0, y = 0, z = 0, w = 1){
        /**
		 * This flag can be used for type testing.
		 *
		 * @type {boolean}
		 * @readonly
		 * @default true
		 */ $9ddd7e9b53f7a2d4$export$fa7daccca11cdbe3.prototype.isVector4 = true;
        /**
		 * The x value of this vector.
		 *
		 * @type {number}
		 */ this.x = x;
        /**
		 * The y value of this vector.
		 *
		 * @type {number}
		 */ this.y = y;
        /**
		 * The z value of this vector.
		 *
		 * @type {number}
		 */ this.z = z;
        /**
		 * The w value of this vector.
		 *
		 * @type {number}
		 */ this.w = w;
    }
    /**
	 * Alias for {@link Vector4#z}.
	 *
	 * @type {number}
	 */ get width() {
        return this.z;
    }
    set width(value) {
        this.z = value;
    }
    /**
	 * Alias for {@link Vector4#w}.
	 *
	 * @type {number}
	 */ get height() {
        return this.w;
    }
    set height(value) {
        this.w = value;
    }
    /**
	 * Sets the vector components.
	 *
	 * @param {number} x - The value of the x component.
	 * @param {number} y - The value of the y component.
	 * @param {number} z - The value of the z component.
	 * @param {number} w - The value of the w component.
	 * @return {Vector4} A reference to this vector.
	 */ set(x, y, z, w) {
        this.x = x;
        this.y = y;
        this.z = z;
        this.w = w;
        return this;
    }
    /**
	 * Sets the vector components to the same value.
	 *
	 * @param {number} scalar - The value to set for all vector components.
	 * @return {Vector4} A reference to this vector.
	 */ setScalar(scalar) {
        this.x = scalar;
        this.y = scalar;
        this.z = scalar;
        this.w = scalar;
        return this;
    }
    /**
	 * Sets the vector's x component to the given value
	 *
	 * @param {number} x - The value to set.
	 * @return {Vector4} A reference to this vector.
	 */ setX(x) {
        this.x = x;
        return this;
    }
    /**
	 * Sets the vector's y component to the given value
	 *
	 * @param {number} y - The value to set.
	 * @return {Vector4} A reference to this vector.
	 */ setY(y) {
        this.y = y;
        return this;
    }
    /**
	 * Sets the vector's z component to the given value
	 *
	 * @param {number} z - The value to set.
	 * @return {Vector4} A reference to this vector.
	 */ setZ(z) {
        this.z = z;
        return this;
    }
    /**
	 * Sets the vector's w component to the given value
	 *
	 * @param {number} w - The value to set.
	 * @return {Vector4} A reference to this vector.
	 */ setW(w) {
        this.w = w;
        return this;
    }
    /**
	 * Allows to set a vector component with an index.
	 *
	 * @param {number} index - The component index. `0` equals to x, `1` equals to y,
	 * `2` equals to z, `3` equals to w.
	 * @param {number} value - The value to set.
	 * @return {Vector4} A reference to this vector.
	 */ setComponent(index, value) {
        switch(index){
            case 0:
                this.x = value;
                break;
            case 1:
                this.y = value;
                break;
            case 2:
                this.z = value;
                break;
            case 3:
                this.w = value;
                break;
            default:
                throw new Error('index is out of range: ' + index);
        }
        return this;
    }
    /**
	 * Returns the value of the vector component which matches the given index.
	 *
	 * @param {number} index - The component index. `0` equals to x, `1` equals to y,
	 * `2` equals to z, `3` equals to w.
	 * @return {number} A vector component value.
	 */ getComponent(index) {
        switch(index){
            case 0:
                return this.x;
            case 1:
                return this.y;
            case 2:
                return this.z;
            case 3:
                return this.w;
            default:
                throw new Error('index is out of range: ' + index);
        }
    }
    /**
	 * Returns a new vector with copied values from this instance.
	 *
	 * @return {Vector4} A clone of this instance.
	 */ clone() {
        return new this.constructor(this.x, this.y, this.z, this.w);
    }
    /**
	 * Copies the values of the given vector to this instance.
	 *
	 * @param {Vector3|Vector4} v - The vector to copy.
	 * @return {Vector4} A reference to this vector.
	 */ copy(v) {
        this.x = v.x;
        this.y = v.y;
        this.z = v.z;
        this.w = v.w !== undefined ? v.w : 1;
        return this;
    }
    /**
	 * Adds the given vector to this instance.
	 *
	 * @param {Vector4} v - The vector to add.
	 * @return {Vector4} A reference to this vector.
	 */ add(v) {
        this.x += v.x;
        this.y += v.y;
        this.z += v.z;
        this.w += v.w;
        return this;
    }
    /**
	 * Adds the given scalar value to all components of this instance.
	 *
	 * @param {number} s - The scalar to add.
	 * @return {Vector4} A reference to this vector.
	 */ addScalar(s) {
        this.x += s;
        this.y += s;
        this.z += s;
        this.w += s;
        return this;
    }
    /**
	 * Adds the given vectors and stores the result in this instance.
	 *
	 * @param {Vector4} a - The first vector.
	 * @param {Vector4} b - The second vector.
	 * @return {Vector4} A reference to this vector.
	 */ addVectors(a, b) {
        this.x = a.x + b.x;
        this.y = a.y + b.y;
        this.z = a.z + b.z;
        this.w = a.w + b.w;
        return this;
    }
    /**
	 * Adds the given vector scaled by the given factor to this instance.
	 *
	 * @param {Vector4} v - The vector.
	 * @param {number} s - The factor that scales `v`.
	 * @return {Vector4} A reference to this vector.
	 */ addScaledVector(v, s) {
        this.x += v.x * s;
        this.y += v.y * s;
        this.z += v.z * s;
        this.w += v.w * s;
        return this;
    }
    /**
	 * Subtracts the given vector from this instance.
	 *
	 * @param {Vector4} v - The vector to subtract.
	 * @return {Vector4} A reference to this vector.
	 */ sub(v) {
        this.x -= v.x;
        this.y -= v.y;
        this.z -= v.z;
        this.w -= v.w;
        return this;
    }
    /**
	 * Subtracts the given scalar value from all components of this instance.
	 *
	 * @param {number} s - The scalar to subtract.
	 * @return {Vector4} A reference to this vector.
	 */ subScalar(s) {
        this.x -= s;
        this.y -= s;
        this.z -= s;
        this.w -= s;
        return this;
    }
    /**
	 * Subtracts the given vectors and stores the result in this instance.
	 *
	 * @param {Vector4} a - The first vector.
	 * @param {Vector4} b - The second vector.
	 * @return {Vector4} A reference to this vector.
	 */ subVectors(a, b) {
        this.x = a.x - b.x;
        this.y = a.y - b.y;
        this.z = a.z - b.z;
        this.w = a.w - b.w;
        return this;
    }
    /**
	 * Multiplies the given vector with this instance.
	 *
	 * @param {Vector4} v - The vector to multiply.
	 * @return {Vector4} A reference to this vector.
	 */ multiply(v) {
        this.x *= v.x;
        this.y *= v.y;
        this.z *= v.z;
        this.w *= v.w;
        return this;
    }
    /**
	 * Multiplies the given scalar value with all components of this instance.
	 *
	 * @param {number} scalar - The scalar to multiply.
	 * @return {Vector4} A reference to this vector.
	 */ multiplyScalar(scalar) {
        this.x *= scalar;
        this.y *= scalar;
        this.z *= scalar;
        this.w *= scalar;
        return this;
    }
    /**
	 * Multiplies this vector with the given 4x4 matrix.
	 *
	 * @param {Matrix4} m - The 4x4 matrix.
	 * @return {Vector4} A reference to this vector.
	 */ applyMatrix4(m) {
        const x = this.x, y = this.y, z = this.z, w = this.w;
        const e = m.elements;
        this.x = e[0] * x + e[4] * y + e[8] * z + e[12] * w;
        this.y = e[1] * x + e[5] * y + e[9] * z + e[13] * w;
        this.z = e[2] * x + e[6] * y + e[10] * z + e[14] * w;
        this.w = e[3] * x + e[7] * y + e[11] * z + e[15] * w;
        return this;
    }
    /**
	 * Divides this instance by the given vector.
	 *
	 * @param {Vector4} v - The vector to divide.
	 * @return {Vector4} A reference to this vector.
	 */ divide(v) {
        this.x /= v.x;
        this.y /= v.y;
        this.z /= v.z;
        this.w /= v.w;
        return this;
    }
    /**
	 * Divides this vector by the given scalar.
	 *
	 * @param {number} scalar - The scalar to divide.
	 * @return {Vector4} A reference to this vector.
	 */ divideScalar(scalar) {
        return this.multiplyScalar(1 / scalar);
    }
    /**
	 * Sets the x, y and z components of this
	 * vector to the quaternion's axis and w to the angle.
	 *
	 * @param {Quaternion} q - The Quaternion to set.
	 * @return {Vector4} A reference to this vector.
	 */ setAxisAngleFromQuaternion(q) {
        // http://www.euclideanspace.com/maths/geometry/rotations/conversions/quaternionToAngle/index.htm
        // q is assumed to be normalized
        this.w = 2 * Math.acos(q.w);
        const s = Math.sqrt(1 - q.w * q.w);
        if (s < 0.0001) {
            this.x = 1;
            this.y = 0;
            this.z = 0;
        } else {
            this.x = q.x / s;
            this.y = q.y / s;
            this.z = q.z / s;
        }
        return this;
    }
    /**
	 * Sets the x, y and z components of this
	 * vector to the axis of rotation and w to the angle.
	 *
	 * @param {Matrix4} m - A 4x4 matrix of which the upper left 3x3 matrix is a pure rotation matrix.
	 * @return {Vector4} A reference to this vector.
	 */ setAxisAngleFromRotationMatrix(m) {
        // http://www.euclideanspace.com/maths/geometry/rotations/conversions/matrixToAngle/index.htm
        // assumes the upper 3x3 of m is a pure rotation matrix (i.e, unscaled)
        let angle, x, y, z; // variables for result
        const epsilon = 0.01, epsilon2 = 0.1, te = m.elements, m11 = te[0], m12 = te[4], m13 = te[8], m21 = te[1], m22 = te[5], m23 = te[9], m31 = te[2], m32 = te[6], m33 = te[10];
        if (Math.abs(m12 - m21) < epsilon && Math.abs(m13 - m31) < epsilon && Math.abs(m23 - m32) < epsilon) {
            // singularity found
            // first check for identity matrix which must have +1 for all terms
            // in leading diagonal and zero in other terms
            if (Math.abs(m12 + m21) < epsilon2 && Math.abs(m13 + m31) < epsilon2 && Math.abs(m23 + m32) < epsilon2 && Math.abs(m11 + m22 + m33 - 3) < epsilon2) {
                // this singularity is identity matrix so angle = 0
                this.set(1, 0, 0, 0);
                return this; // zero angle, arbitrary axis
            }
            // otherwise this singularity is angle = 180
            angle = Math.PI;
            const xx = (m11 + 1) / 2;
            const yy = (m22 + 1) / 2;
            const zz = (m33 + 1) / 2;
            const xy = (m12 + m21) / 4;
            const xz = (m13 + m31) / 4;
            const yz = (m23 + m32) / 4;
            if (xx > yy && xx > zz) {
                // m11 is the largest diagonal term
                if (xx < epsilon) {
                    x = 0;
                    y = 0.707106781;
                    z = 0.707106781;
                } else {
                    x = Math.sqrt(xx);
                    y = xy / x;
                    z = xz / x;
                }
            } else if (yy > zz) {
                // m22 is the largest diagonal term
                if (yy < epsilon) {
                    x = 0.707106781;
                    y = 0;
                    z = 0.707106781;
                } else {
                    y = Math.sqrt(yy);
                    x = xy / y;
                    z = yz / y;
                }
            } else // m33 is the largest diagonal term so base result on this
            if (zz < epsilon) {
                x = 0.707106781;
                y = 0.707106781;
                z = 0;
            } else {
                z = Math.sqrt(zz);
                x = xz / z;
                y = yz / z;
            }
            this.set(x, y, z, angle);
            return this; // return 180 deg rotation
        }
        // as we have reached here there are no singularities so we can handle normally
        let s = Math.sqrt((m32 - m23) * (m32 - m23) + (m13 - m31) * (m13 - m31) + (m21 - m12) * (m21 - m12)); // used to normalize
        if (Math.abs(s) < 0.001) s = 1;
        // prevent divide by zero, should not happen if matrix is orthogonal and should be
        // caught by singularity test above, but I've left it in just in case
        this.x = (m32 - m23) / s;
        this.y = (m13 - m31) / s;
        this.z = (m21 - m12) / s;
        this.w = Math.acos((m11 + m22 + m33 - 1) / 2);
        return this;
    }
    /**
	 * Sets the vector components to the position elements of the
	 * given transformation matrix.
	 *
	 * @param {Matrix4} m - The 4x4 matrix.
	 * @return {Vector4} A reference to this vector.
	 */ setFromMatrixPosition(m) {
        const e = m.elements;
        this.x = e[12];
        this.y = e[13];
        this.z = e[14];
        this.w = e[15];
        return this;
    }
    /**
	 * If this vector's x, y, z or w value is greater than the given vector's x, y, z or w
	 * value, replace that value with the corresponding min value.
	 *
	 * @param {Vector4} v - The vector.
	 * @return {Vector4} A reference to this vector.
	 */ min(v) {
        this.x = Math.min(this.x, v.x);
        this.y = Math.min(this.y, v.y);
        this.z = Math.min(this.z, v.z);
        this.w = Math.min(this.w, v.w);
        return this;
    }
    /**
	 * If this vector's x, y, z or w value is less than the given vector's x, y, z or w
	 * value, replace that value with the corresponding max value.
	 *
	 * @param {Vector4} v - The vector.
	 * @return {Vector4} A reference to this vector.
	 */ max(v) {
        this.x = Math.max(this.x, v.x);
        this.y = Math.max(this.y, v.y);
        this.z = Math.max(this.z, v.z);
        this.w = Math.max(this.w, v.w);
        return this;
    }
    /**
	 * If this vector's x, y, z or w value is greater than the max vector's x, y, z or w
	 * value, it is replaced by the corresponding value.
	 * If this vector's x, y, z or w value is less than the min vector's x, y, z or w value,
	 * it is replaced by the corresponding value.
	 *
	 * @param {Vector4} min - The minimum x, y and z values.
	 * @param {Vector4} max - The maximum x, y and z values in the desired range.
	 * @return {Vector4} A reference to this vector.
	 */ clamp(min, max) {
        // assumes min < max, componentwise
        this.x = $9ddd7e9b53f7a2d4$var$clamp(this.x, min.x, max.x);
        this.y = $9ddd7e9b53f7a2d4$var$clamp(this.y, min.y, max.y);
        this.z = $9ddd7e9b53f7a2d4$var$clamp(this.z, min.z, max.z);
        this.w = $9ddd7e9b53f7a2d4$var$clamp(this.w, min.w, max.w);
        return this;
    }
    /**
	 * If this vector's x, y, z or w values are greater than the max value, they are
	 * replaced by the max value.
	 * If this vector's x, y, z or w values are less than the min value, they are
	 * replaced by the min value.
	 *
	 * @param {number} minVal - The minimum value the components will be clamped to.
	 * @param {number} maxVal - The maximum value the components will be clamped to.
	 * @return {Vector4} A reference to this vector.
	 */ clampScalar(minVal, maxVal) {
        this.x = $9ddd7e9b53f7a2d4$var$clamp(this.x, minVal, maxVal);
        this.y = $9ddd7e9b53f7a2d4$var$clamp(this.y, minVal, maxVal);
        this.z = $9ddd7e9b53f7a2d4$var$clamp(this.z, minVal, maxVal);
        this.w = $9ddd7e9b53f7a2d4$var$clamp(this.w, minVal, maxVal);
        return this;
    }
    /**
	 * If this vector's length is greater than the max value, it is replaced by
	 * the max value.
	 * If this vector's length is less than the min value, it is replaced by the
	 * min value.
	 *
	 * @param {number} min - The minimum value the vector length will be clamped to.
	 * @param {number} max - The maximum value the vector length will be clamped to.
	 * @return {Vector4} A reference to this vector.
	 */ clampLength(min, max) {
        const length = this.length();
        return this.divideScalar(length || 1).multiplyScalar($9ddd7e9b53f7a2d4$var$clamp(length, min, max));
    }
    /**
	 * The components of this vector are rounded down to the nearest integer value.
	 *
	 * @return {Vector4} A reference to this vector.
	 */ floor() {
        this.x = Math.floor(this.x);
        this.y = Math.floor(this.y);
        this.z = Math.floor(this.z);
        this.w = Math.floor(this.w);
        return this;
    }
    /**
	 * The components of this vector are rounded up to the nearest integer value.
	 *
	 * @return {Vector4} A reference to this vector.
	 */ ceil() {
        this.x = Math.ceil(this.x);
        this.y = Math.ceil(this.y);
        this.z = Math.ceil(this.z);
        this.w = Math.ceil(this.w);
        return this;
    }
    /**
	 * The components of this vector are rounded to the nearest integer value
	 *
	 * @return {Vector4} A reference to this vector.
	 */ round() {
        this.x = Math.round(this.x);
        this.y = Math.round(this.y);
        this.z = Math.round(this.z);
        this.w = Math.round(this.w);
        return this;
    }
    /**
	 * The components of this vector are rounded towards zero (up if negative,
	 * down if positive) to an integer value.
	 *
	 * @return {Vector4} A reference to this vector.
	 */ roundToZero() {
        this.x = Math.trunc(this.x);
        this.y = Math.trunc(this.y);
        this.z = Math.trunc(this.z);
        this.w = Math.trunc(this.w);
        return this;
    }
    /**
	 * Inverts this vector - i.e. sets x = -x, y = -y, z = -z, w = -w.
	 *
	 * @return {Vector4} A reference to this vector.
	 */ negate() {
        this.x = -this.x;
        this.y = -this.y;
        this.z = -this.z;
        this.w = -this.w;
        return this;
    }
    /**
	 * Calculates the dot product of the given vector with this instance.
	 *
	 * @param {Vector4} v - The vector to compute the dot product with.
	 * @return {number} The result of the dot product.
	 */ dot(v) {
        return this.x * v.x + this.y * v.y + this.z * v.z + this.w * v.w;
    }
    /**
	 * Computes the square of the Euclidean length (straight-line length) from
	 * (0, 0, 0, 0) to (x, y, z, w). If you are comparing the lengths of vectors, you should
	 * compare the length squared instead as it is slightly more efficient to calculate.
	 *
	 * @return {number} The square length of this vector.
	 */ lengthSq() {
        return this.x * this.x + this.y * this.y + this.z * this.z + this.w * this.w;
    }
    /**
	 * Computes the  Euclidean length (straight-line length) from (0, 0, 0, 0) to (x, y, z, w).
	 *
	 * @return {number} The length of this vector.
	 */ length() {
        return Math.sqrt(this.x * this.x + this.y * this.y + this.z * this.z + this.w * this.w);
    }
    /**
	 * Computes the Manhattan length of this vector.
	 *
	 * @return {number} The length of this vector.
	 */ manhattanLength() {
        return Math.abs(this.x) + Math.abs(this.y) + Math.abs(this.z) + Math.abs(this.w);
    }
    /**
	 * Converts this vector to a unit vector - that is, sets it equal to a vector
	 * with the same direction as this one, but with a vector length of `1`.
	 *
	 * @return {Vector4} A reference to this vector.
	 */ normalize() {
        return this.divideScalar(this.length() || 1);
    }
    /**
	 * Sets this vector to a vector with the same direction as this one, but
	 * with the specified length.
	 *
	 * @param {number} length - The new length of this vector.
	 * @return {Vector4} A reference to this vector.
	 */ setLength(length) {
        return this.normalize().multiplyScalar(length);
    }
    /**
	 * Linearly interpolates between the given vector and this instance, where
	 * alpha is the percent distance along the line - alpha = 0 will be this
	 * vector, and alpha = 1 will be the given one.
	 *
	 * @param {Vector4} v - The vector to interpolate towards.
	 * @param {number} alpha - The interpolation factor, typically in the closed interval `[0, 1]`.
	 * @return {Vector4} A reference to this vector.
	 */ lerp(v, alpha) {
        this.x += (v.x - this.x) * alpha;
        this.y += (v.y - this.y) * alpha;
        this.z += (v.z - this.z) * alpha;
        this.w += (v.w - this.w) * alpha;
        return this;
    }
    /**
	 * Linearly interpolates between the given vectors, where alpha is the percent
	 * distance along the line - alpha = 0 will be first vector, and alpha = 1 will
	 * be the second one. The result is stored in this instance.
	 *
	 * @param {Vector4} v1 - The first vector.
	 * @param {Vector4} v2 - The second vector.
	 * @param {number} alpha - The interpolation factor, typically in the closed interval `[0, 1]`.
	 * @return {Vector4} A reference to this vector.
	 */ lerpVectors(v1, v2, alpha) {
        this.x = v1.x + (v2.x - v1.x) * alpha;
        this.y = v1.y + (v2.y - v1.y) * alpha;
        this.z = v1.z + (v2.z - v1.z) * alpha;
        this.w = v1.w + (v2.w - v1.w) * alpha;
        return this;
    }
    /**
	 * Returns `true` if this vector is equal with the given one.
	 *
	 * @param {Vector4} v - The vector to test for equality.
	 * @return {boolean} Whether this vector is equal with the given one.
	 */ equals(v) {
        return v.x === this.x && v.y === this.y && v.z === this.z && v.w === this.w;
    }
    /**
	 * Sets this vector's x value to be `array[ offset ]`, y value to be `array[ offset + 1 ]`,
	 * z value to be `array[ offset + 2 ]`, w value to be `array[ offset + 3 ]`.
	 *
	 * @param {Array<number>} array - An array holding the vector component values.
	 * @param {number} [offset=0] - The offset into the array.
	 * @return {Vector4} A reference to this vector.
	 */ fromArray(array, offset = 0) {
        this.x = array[offset];
        this.y = array[offset + 1];
        this.z = array[offset + 2];
        this.w = array[offset + 3];
        return this;
    }
    /**
	 * Writes the components of this vector to the given array. If no array is provided,
	 * the method returns a new instance.
	 *
	 * @param {Array<number>} [array=[]] - The target array holding the vector components.
	 * @param {number} [offset=0] - Index of the first element in the array.
	 * @return {Array<number>} The vector components.
	 */ toArray(array = [], offset = 0) {
        array[offset] = this.x;
        array[offset + 1] = this.y;
        array[offset + 2] = this.z;
        array[offset + 3] = this.w;
        return array;
    }
    /**
	 * Sets the components of this vector from the given buffer attribute.
	 *
	 * @param {BufferAttribute} attribute - The buffer attribute holding vector data.
	 * @param {number} index - The index into the attribute.
	 * @return {Vector4} A reference to this vector.
	 */ fromBufferAttribute(attribute, index) {
        this.x = attribute.getX(index);
        this.y = attribute.getY(index);
        this.z = attribute.getZ(index);
        this.w = attribute.getW(index);
        return this;
    }
    /**
	 * Sets each component of this vector to a pseudo-random value between `0` and
	 * `1`, excluding `1`.
	 *
	 * @return {Vector4} A reference to this vector.
	 */ random() {
        this.x = Math.random();
        this.y = Math.random();
        this.z = Math.random();
        this.w = Math.random();
        return this;
    }
    *[Symbol.iterator]() {
        yield this.x;
        yield this.y;
        yield this.z;
        yield this.w;
    }
}
/**
 * A render target is a buffer where the video card draws pixels for a scene
 * that is being rendered in the background. It is used in different effects,
 * such as applying postprocessing to a rendered image before displaying it
 * on the screen.
 *
 * @augments EventDispatcher
 */ class $9ddd7e9b53f7a2d4$export$efcb1f8bf367cbfb extends $9ddd7e9b53f7a2d4$export$ec8b666c5fe2c75a {
    /**
	 * Render target options.
	 *
	 * @typedef {Object} RenderTarget~Options
	 * @property {boolean} [generateMipmaps=false] - Whether to generate mipmaps or not.
	 * @property {number} [magFilter=LinearFilter] - The mag filter.
	 * @property {number} [minFilter=LinearFilter] - The min filter.
	 * @property {number} [format=RGBAFormat] - The texture format.
	 * @property {number} [type=UnsignedByteType] - The texture type.
	 * @property {?string} [internalFormat=null] - The texture's internal format.
	 * @property {number} [wrapS=ClampToEdgeWrapping] - The texture's uv wrapping mode.
	 * @property {number} [wrapT=ClampToEdgeWrapping] - The texture's uv wrapping mode.
	 * @property {number} [anisotropy=1] - The texture's anisotropy value.
	 * @property {string} [colorSpace=NoColorSpace] - The texture's color space.
	 * @property {boolean} [depthBuffer=true] - Whether to allocate a depth buffer or not.
	 * @property {boolean} [stencilBuffer=false] - Whether to allocate a stencil buffer or not.
	 * @property {boolean} [resolveDepthBuffer=true] - Whether to resolve the depth buffer or not.
	 * @property {boolean} [resolveStencilBuffer=true] - Whether  to resolve the stencil buffer or not.
	 * @property {?Texture} [depthTexture=null] - Reference to a depth texture.
	 * @property {number} [samples=0] - The MSAA samples count.
	 * @property {number} [count=1] - Defines the number of color attachments . Must be at least `1`.
	 */ /**
	 * Constructs a new render target.
	 *
	 * @param {number} [width=1] - The width of the render target.
	 * @param {number} [height=1] - The height of the render target.
	 * @param {RenderTarget~Options} [options] - The configuration object.
	 */ constructor(width = 1, height = 1, options = {}){
        super();
        /**
		 * This flag can be used for type testing.
		 *
		 * @type {boolean}
		 * @readonly
		 * @default true
		 */ this.isRenderTarget = true;
        /**
		 * The width of the render target.
		 *
		 * @type {number}
		 * @default 1
		 */ this.width = width;
        /**
		 * The height of the render target.
		 *
		 * @type {number}
		 * @default 1
		 */ this.height = height;
        /**
		 * The depth of the render target.
		 *
		 * @type {number}
		 * @default 1
		 */ this.depth = 1;
        /**
		 * A rectangular area inside the render target's viewport. Fragments that are
		 * outside the area will be discarded.
		 *
		 * @type {Vector4}
		 * @default (0,0,width,height)
		 */ this.scissor = new $9ddd7e9b53f7a2d4$export$fa7daccca11cdbe3(0, 0, width, height);
        /**
		 * Indicates whether the scissor test should be enabled when rendering into
		 * this render target or not.
		 *
		 * @type {boolean}
		 * @default false
		 */ this.scissorTest = false;
        /**
		 * A rectangular area representing the render target's viewport.
		 *
		 * @type {Vector4}
		 * @default (0,0,width,height)
		 */ this.viewport = new $9ddd7e9b53f7a2d4$export$fa7daccca11cdbe3(0, 0, width, height);
        const image = {
            width: width,
            height: height,
            depth: 1
        };
        options = Object.assign({
            generateMipmaps: false,
            internalFormat: null,
            minFilter: $9ddd7e9b53f7a2d4$export$8a72f490b25c56c8,
            depthBuffer: true,
            stencilBuffer: false,
            resolveDepthBuffer: true,
            resolveStencilBuffer: true,
            depthTexture: null,
            samples: 0,
            count: 1
        }, options);
        const texture = new $9ddd7e9b53f7a2d4$export$5431306cf43de24a(image, options.mapping, options.wrapS, options.wrapT, options.magFilter, options.minFilter, options.format, options.type, options.anisotropy, options.colorSpace);
        texture.flipY = false;
        texture.generateMipmaps = options.generateMipmaps;
        texture.internalFormat = options.internalFormat;
        /**
		 * An array of textures. Each color attachment is represented as a separate texture.
		 * Has at least a single entry for the default color attachment.
		 *
		 * @type {Array<Texture>}
		 */ this.textures = [];
        const count = options.count;
        for(let i = 0; i < count; i++){
            this.textures[i] = texture.clone();
            this.textures[i].isRenderTargetTexture = true;
            this.textures[i].renderTarget = this;
        }
        /**
		 * Whether to allocate a depth buffer or not.
		 *
		 * @type {boolean}
		 * @default true
		 */ this.depthBuffer = options.depthBuffer;
        /**
		 * Whether to allocate a stencil buffer or not.
		 *
		 * @type {boolean}
		 * @default false
		 */ this.stencilBuffer = options.stencilBuffer;
        /**
		 * Whether to resolve the depth buffer or not.
		 *
		 * @type {boolean}
		 * @default true
		 */ this.resolveDepthBuffer = options.resolveDepthBuffer;
        /**
		 * Whether to resolve the stencil buffer or not.
		 *
		 * @type {boolean}
		 * @default true
		 */ this.resolveStencilBuffer = options.resolveStencilBuffer;
        this._depthTexture = options.depthTexture;
        /**
		 * The number of MSAA samples.
		 *
		 * A value of `0` disables MSAA.
		 *
		 * @type {number}
		 * @default 0
		 */ this.samples = options.samples;
    }
    /**
	 * The texture representing the default color attachment.
	 *
	 * @type {Texture}
	 */ get texture() {
        return this.textures[0];
    }
    set texture(value) {
        this.textures[0] = value;
    }
    set depthTexture(current) {
        if (this._depthTexture !== null) this._depthTexture.renderTarget = null;
        if (current !== null) current.renderTarget = this;
        this._depthTexture = current;
    }
    /**
	 * Instead of saving the depth in a renderbuffer, a texture
	 * can be used instead which is useful for further processing
	 * e.g. in context of post-processing.
	 *
	 * @type {?DepthTexture}
	 * @default null
	 */ get depthTexture() {
        return this._depthTexture;
    }
    /**
	 * Sets the size of this render target.
	 *
	 * @param {number} width - The width.
	 * @param {number} height - The height.
	 * @param {number} [depth=1] - The depth.
	 */ setSize(width, height, depth = 1) {
        if (this.width !== width || this.height !== height || this.depth !== depth) {
            this.width = width;
            this.height = height;
            this.depth = depth;
            for(let i = 0, il = this.textures.length; i < il; i++){
                this.textures[i].image.width = width;
                this.textures[i].image.height = height;
                this.textures[i].image.depth = depth;
            }
            this.dispose();
        }
        this.viewport.set(0, 0, width, height);
        this.scissor.set(0, 0, width, height);
    }
    /**
	 * Returns a new render target with copied values from this instance.
	 *
	 * @return {RenderTarget} A clone of this instance.
	 */ clone() {
        return new this.constructor().copy(this);
    }
    /**
	 * Copies the settings of the given render target. This is a structural copy so
	 * no resources are shared between render targets after the copy. That includes
	 * all MRT textures and the depth texture.
	 *
	 * @param {RenderTarget} source - The render target to copy.
	 * @return {RenderTarget} A reference to this instance.
	 */ copy(source) {
        this.width = source.width;
        this.height = source.height;
        this.depth = source.depth;
        this.scissor.copy(source.scissor);
        this.scissorTest = source.scissorTest;
        this.viewport.copy(source.viewport);
        this.textures.length = 0;
        for(let i = 0, il = source.textures.length; i < il; i++){
            this.textures[i] = source.textures[i].clone();
            this.textures[i].isRenderTargetTexture = true;
            this.textures[i].renderTarget = this;
            // ensure image object is not shared, see #20328
            const image = Object.assign({}, source.textures[i].image);
            this.textures[i].source = new $9ddd7e9b53f7a2d4$export$1d2df86270c81ecb(image);
        }
        this.depthBuffer = source.depthBuffer;
        this.stencilBuffer = source.stencilBuffer;
        this.resolveDepthBuffer = source.resolveDepthBuffer;
        this.resolveStencilBuffer = source.resolveStencilBuffer;
        if (source.depthTexture !== null) this.depthTexture = source.depthTexture.clone();
        this.samples = source.samples;
        return this;
    }
    /**
	 * Frees the GPU-related resources allocated by this instance. Call this
	 * method whenever this instance is no longer used in your app.
	 *
	 * @fires RenderTarget#dispose
	 */ dispose() {
        this.dispatchEvent({
            type: 'dispose'
        });
    }
}
/**
 * A render target used in context of {@link WebGLRenderer}.
 *
 * @augments RenderTarget
 */ class $9ddd7e9b53f7a2d4$export$3c052beb2e51e23f extends $9ddd7e9b53f7a2d4$export$efcb1f8bf367cbfb {
    /**
	 * Constructs a new 3D render target.
	 *
	 * @param {number} [width=1] - The width of the render target.
	 * @param {number} [height=1] - The height of the render target.
	 * @param {RenderTarget~Options} [options] - The configuration object.
	 */ constructor(width = 1, height = 1, options = {}){
        super(width, height, options);
        /**
		 * This flag can be used for type testing.
		 *
		 * @type {boolean}
		 * @readonly
		 * @default true
		 */ this.isWebGLRenderTarget = true;
    }
}
/**
 * Creates an array of textures directly from raw buffer data.
 *
 * @augments Texture
 */ class $9ddd7e9b53f7a2d4$export$dfac6c8e811406a3 extends $9ddd7e9b53f7a2d4$export$5431306cf43de24a {
    /**
	 * Constructs a new data array texture.
	 *
	 * @param {?TypedArray} [data=null] - The buffer data.
	 * @param {number} [width=1] - The width of the texture.
	 * @param {number} [height=1] - The height of the texture.
	 * @param {number} [depth=1] - The depth of the texture.
	 */ constructor(data = null, width = 1, height = 1, depth = 1){
        super(null);
        /**
		 * This flag can be used for type testing.
		 *
		 * @type {boolean}
		 * @readonly
		 * @default true
		 */ this.isDataArrayTexture = true;
        /**
		 * The image definition of a data texture.
		 *
		 * @type {{data:TypedArray,width:number,height:number,depth:number}}
		 */ this.image = {
            data: data,
            width: width,
            height: height,
            depth: depth
        };
        /**
		 * How the texture is sampled when a texel covers more than one pixel.
		 *
		 * Overwritten and set to `NearestFilter` by default.
		 *
		 * @type {(NearestFilter|NearestMipmapNearestFilter|NearestMipmapLinearFilter|LinearFilter|LinearMipmapNearestFilter|LinearMipmapLinearFilter)}
		 * @default NearestFilter
		 */ this.magFilter = $9ddd7e9b53f7a2d4$export$727aa5ec3fe39bf0;
        /**
		 * How the texture is sampled when a texel covers less than one pixel.
		 *
		 * Overwritten and set to `NearestFilter` by default.
		 *
		 * @type {(NearestFilter|NearestMipmapNearestFilter|NearestMipmapLinearFilter|LinearFilter|LinearMipmapNearestFilter|LinearMipmapLinearFilter)}
		 * @default NearestFilter
		 */ this.minFilter = $9ddd7e9b53f7a2d4$export$727aa5ec3fe39bf0;
        /**
		 * This defines how the texture is wrapped in the depth and corresponds to
		 * *W* in UVW mapping.
		 *
		 * @type {(RepeatWrapping|ClampToEdgeWrapping|MirroredRepeatWrapping)}
		 * @default ClampToEdgeWrapping
		 */ this.wrapR = $9ddd7e9b53f7a2d4$export$9d9334239a5a5e06;
        /**
		 * Whether to generate mipmaps (if possible) for a texture.
		 *
		 * Overwritten and set to `false` by default.
		 *
		 * @type {boolean}
		 * @default false
		 */ this.generateMipmaps = false;
        /**
		 * If set to `true`, the texture is flipped along the vertical axis when
		 * uploaded to the GPU.
		 *
		 * Overwritten and set to `false` by default.
		 *
		 * @type {boolean}
		 * @default false
		 */ this.flipY = false;
        /**
		 * Specifies the alignment requirements for the start of each pixel row in memory.
		 *
		 * Overwritten and set to `1` by default.
		 *
		 * @type {boolean}
		 * @default 1
		 */ this.unpackAlignment = 1;
        /**
		 * A set of all layers which need to be updated in the texture.
		 *
		 * @type {Set<number>}
		 */ this.layerUpdates = new Set();
    }
    /**
	 * Describes that a specific layer of the texture needs to be updated.
	 * Normally when {@link Texture#needsUpdate} is set to `true`, the
	 * entire data texture array is sent to the GPU. Marking specific
	 * layers will only transmit subsets of all mipmaps associated with a
	 * specific depth in the array which is often much more performant.
	 *
	 * @param {number} layerIndex - The layer index that should be updated.
	 */ addLayerUpdate(layerIndex) {
        this.layerUpdates.add(layerIndex);
    }
    /**
	 * Resets the layer updates registry.
	 */ clearLayerUpdates() {
        this.layerUpdates.clear();
    }
}
/**
 * An array render target used in context of {@link WebGLRenderer}.
 *
 * @augments WebGLRenderTarget
 */ class $9ddd7e9b53f7a2d4$export$c77a02c11ed180c7 extends $9ddd7e9b53f7a2d4$export$3c052beb2e51e23f {
    /**
	 * Constructs a new array render target.
	 *
	 * @param {number} [width=1] - The width of the render target.
	 * @param {number} [height=1] - The height of the render target.
	 * @param {number} [depth=1] - The height of the render target.
	 * @param {RenderTarget~Options} [options] - The configuration object.
	 */ constructor(width = 1, height = 1, depth = 1, options = {}){
        super(width, height, options);
        /**
		 * This flag can be used for type testing.
		 *
		 * @type {boolean}
		 * @readonly
		 * @default true
		 */ this.isWebGLArrayRenderTarget = true;
        this.depth = depth;
        /**
		 * Overwritten with a different texture type.
		 *
		 * @type {DataArrayTexture}
		 */ this.texture = new $9ddd7e9b53f7a2d4$export$dfac6c8e811406a3(null, width, height, depth);
        this.texture.isRenderTargetTexture = true;
    }
}
/**
 * Creates a three-dimensional texture from raw data, with parameters to
 * divide it into width, height, and depth.
 *
 * @augments Texture
 */ class $9ddd7e9b53f7a2d4$export$d7a3086320f856db extends $9ddd7e9b53f7a2d4$export$5431306cf43de24a {
    /**
	 * Constructs a new data array texture.
	 *
	 * @param {?TypedArray} [data=null] - The buffer data.
	 * @param {number} [width=1] - The width of the texture.
	 * @param {number} [height=1] - The height of the texture.
	 * @param {number} [depth=1] - The depth of the texture.
	 */ constructor(data = null, width = 1, height = 1, depth = 1){
        // We're going to add .setXXX() methods for setting properties later.
        // Users can still set in Data3DTexture directly.
        //
        //	const texture = new THREE.Data3DTexture( data, width, height, depth );
        // 	texture.anisotropy = 16;
        //
        // See #14839
        super(null);
        /**
		 * This flag can be used for type testing.
		 *
		 * @type {boolean}
		 * @readonly
		 * @default true
		 */ this.isData3DTexture = true;
        /**
		 * The image definition of a data texture.
		 *
		 * @type {{data:TypedArray,width:number,height:number,depth:number}}
		 */ this.image = {
            data: data,
            width: width,
            height: height,
            depth: depth
        };
        /**
		 * How the texture is sampled when a texel covers more than one pixel.
		 *
		 * Overwritten and set to `NearestFilter` by default.
		 *
		 * @type {(NearestFilter|NearestMipmapNearestFilter|NearestMipmapLinearFilter|LinearFilter|LinearMipmapNearestFilter|LinearMipmapLinearFilter)}
		 * @default NearestFilter
		 */ this.magFilter = $9ddd7e9b53f7a2d4$export$727aa5ec3fe39bf0;
        /**
		 * How the texture is sampled when a texel covers less than one pixel.
		 *
		 * Overwritten and set to `NearestFilter` by default.
		 *
		 * @type {(NearestFilter|NearestMipmapNearestFilter|NearestMipmapLinearFilter|LinearFilter|LinearMipmapNearestFilter|LinearMipmapLinearFilter)}
		 * @default NearestFilter
		 */ this.minFilter = $9ddd7e9b53f7a2d4$export$727aa5ec3fe39bf0;
        /**
		 * This defines how the texture is wrapped in the depth and corresponds to
		 * *W* in UVW mapping.
		 *
		 * @type {(RepeatWrapping|ClampToEdgeWrapping|MirroredRepeatWrapping)}
		 * @default ClampToEdgeWrapping
		 */ this.wrapR = $9ddd7e9b53f7a2d4$export$9d9334239a5a5e06;
        /**
		 * Whether to generate mipmaps (if possible) for a texture.
		 *
		 * Overwritten and set to `false` by default.
		 *
		 * @type {boolean}
		 * @default false
		 */ this.generateMipmaps = false;
        /**
		 * If set to `true`, the texture is flipped along the vertical axis when
		 * uploaded to the GPU.
		 *
		 * Overwritten and set to `false` by default.
		 *
		 * @type {boolean}
		 * @default false
		 */ this.flipY = false;
        /**
		 * Specifies the alignment requirements for the start of each pixel row in memory.
		 *
		 * Overwritten and set to `1` by default.
		 *
		 * @type {boolean}
		 * @default 1
		 */ this.unpackAlignment = 1;
    }
}
/**
 * A 3D render target used in context of {@link WebGLRenderer}.
 *
 * @augments WebGLRenderTarget
 */ class $9ddd7e9b53f7a2d4$export$7ee06591009639df extends $9ddd7e9b53f7a2d4$export$3c052beb2e51e23f {
    /**
	 * Constructs a new 3D render target.
	 *
	 * @param {number} [width=1] - The width of the render target.
	 * @param {number} [height=1] - The height of the render target.
	 * @param {number} [depth=1] - The height of the render target.
	 * @param {RenderTarget~Options} [options] - The configuration object.
	 */ constructor(width = 1, height = 1, depth = 1, options = {}){
        super(width, height, options);
        /**
		 * This flag can be used for type testing.
		 *
		 * @type {boolean}
		 * @readonly
		 * @default true
		 */ this.isWebGL3DRenderTarget = true;
        this.depth = depth;
        /**
		 * Overwritten with a different texture type.
		 *
		 * @type {Data3DTexture}
		 */ this.texture = new $9ddd7e9b53f7a2d4$export$d7a3086320f856db(null, width, height, depth);
        this.texture.isRenderTargetTexture = true;
    }
}
/**
 * Class for representing a Quaternion. Quaternions are used in three.js to represent rotations.
 *
 * Iterating through a vector instance will yield its components `(x, y, z, w)` in
 * the corresponding order.
 *
 * Note that three.js expects Quaternions to be normalized.
 * ```js
 * const quaternion = new THREE.Quaternion();
 * quaternion.setFromAxisAngle( new THREE.Vector3( 0, 1, 0 ), Math.PI / 2 );
 *
 * const vector = new THREE.Vector3( 1, 0, 0 );
 * vector.applyQuaternion( quaternion );
 * ```
 */ class $9ddd7e9b53f7a2d4$export$23d6a54f0bbc85a3 {
    /**
	 * Constructs a new quaternion.
	 *
	 * @param {number} [x=0] - The x value of this quaternion.
	 * @param {number} [y=0] - The y value of this quaternion.
	 * @param {number} [z=0] - The z value of this quaternion.
	 * @param {number} [w=1] - The w value of this quaternion.
	 */ constructor(x = 0, y = 0, z = 0, w = 1){
        /**
		 * This flag can be used for type testing.
		 *
		 * @type {boolean}
		 * @readonly
		 * @default true
		 */ this.isQuaternion = true;
        this._x = x;
        this._y = y;
        this._z = z;
        this._w = w;
    }
    /**
	 * Interpolates between two quaternions via SLERP. This implementation assumes the
	 * quaternion data are managed  in flat arrays.
	 *
	 * @param {Array<number>} dst - The destination array.
	 * @param {number} dstOffset - An offset into the destination array.
	 * @param {Array<number>} src0 - The source array of the first quaternion.
	 * @param {number} srcOffset0 - An offset into the first source array.
	 * @param {Array<number>} src1 -  The source array of the second quaternion.
	 * @param {number} srcOffset1 - An offset into the second source array.
	 * @param {number} t - The interpolation factor in the range `[0,1]`.
	 * @see {@link Quaternion#slerp}
	 */ static slerpFlat(dst, dstOffset, src0, srcOffset0, src1, srcOffset1, t) {
        // fuzz-free, array-based Quaternion SLERP operation
        let x0 = src0[srcOffset0 + 0], y0 = src0[srcOffset0 + 1], z0 = src0[srcOffset0 + 2], w0 = src0[srcOffset0 + 3];
        const x1 = src1[srcOffset1 + 0], y1 = src1[srcOffset1 + 1], z1 = src1[srcOffset1 + 2], w1 = src1[srcOffset1 + 3];
        if (t === 0) {
            dst[dstOffset + 0] = x0;
            dst[dstOffset + 1] = y0;
            dst[dstOffset + 2] = z0;
            dst[dstOffset + 3] = w0;
            return;
        }
        if (t === 1) {
            dst[dstOffset + 0] = x1;
            dst[dstOffset + 1] = y1;
            dst[dstOffset + 2] = z1;
            dst[dstOffset + 3] = w1;
            return;
        }
        if (w0 !== w1 || x0 !== x1 || y0 !== y1 || z0 !== z1) {
            let s = 1 - t;
            const cos = x0 * x1 + y0 * y1 + z0 * z1 + w0 * w1, dir = cos >= 0 ? 1 : -1, sqrSin = 1 - cos * cos;
            // Skip the Slerp for tiny steps to avoid numeric problems:
            if (sqrSin > Number.EPSILON) {
                const sin = Math.sqrt(sqrSin), len = Math.atan2(sin, cos * dir);
                s = Math.sin(s * len) / sin;
                t = Math.sin(t * len) / sin;
            }
            const tDir = t * dir;
            x0 = x0 * s + x1 * tDir;
            y0 = y0 * s + y1 * tDir;
            z0 = z0 * s + z1 * tDir;
            w0 = w0 * s + w1 * tDir;
            // Normalize in case we just did a lerp:
            if (s === 1 - t) {
                const f = 1 / Math.sqrt(x0 * x0 + y0 * y0 + z0 * z0 + w0 * w0);
                x0 *= f;
                y0 *= f;
                z0 *= f;
                w0 *= f;
            }
        }
        dst[dstOffset] = x0;
        dst[dstOffset + 1] = y0;
        dst[dstOffset + 2] = z0;
        dst[dstOffset + 3] = w0;
    }
    /**
	 * Multiplies two quaternions. This implementation assumes the quaternion data are managed
	 * in flat arrays.
	 *
	 * @param {Array<number>} dst - The destination array.
	 * @param {number} dstOffset - An offset into the destination array.
	 * @param {Array<number>} src0 - The source array of the first quaternion.
	 * @param {number} srcOffset0 - An offset into the first source array.
	 * @param {Array<number>} src1 -  The source array of the second quaternion.
	 * @param {number} srcOffset1 - An offset into the second source array.
	 * @return {Array<number>} The destination array.
	 * @see {@link Quaternion#multiplyQuaternions}.
	 */ static multiplyQuaternionsFlat(dst, dstOffset, src0, srcOffset0, src1, srcOffset1) {
        const x0 = src0[srcOffset0];
        const y0 = src0[srcOffset0 + 1];
        const z0 = src0[srcOffset0 + 2];
        const w0 = src0[srcOffset0 + 3];
        const x1 = src1[srcOffset1];
        const y1 = src1[srcOffset1 + 1];
        const z1 = src1[srcOffset1 + 2];
        const w1 = src1[srcOffset1 + 3];
        dst[dstOffset] = x0 * w1 + w0 * x1 + y0 * z1 - z0 * y1;
        dst[dstOffset + 1] = y0 * w1 + w0 * y1 + z0 * x1 - x0 * z1;
        dst[dstOffset + 2] = z0 * w1 + w0 * z1 + x0 * y1 - y0 * x1;
        dst[dstOffset + 3] = w0 * w1 - x0 * x1 - y0 * y1 - z0 * z1;
        return dst;
    }
    /**
	 * The x value of this quaternion.
	 *
	 * @type {number}
	 * @default 0
	 */ get x() {
        return this._x;
    }
    set x(value) {
        this._x = value;
        this._onChangeCallback();
    }
    /**
	 * The y value of this quaternion.
	 *
	 * @type {number}
	 * @default 0
	 */ get y() {
        return this._y;
    }
    set y(value) {
        this._y = value;
        this._onChangeCallback();
    }
    /**
	 * The z value of this quaternion.
	 *
	 * @type {number}
	 * @default 0
	 */ get z() {
        return this._z;
    }
    set z(value) {
        this._z = value;
        this._onChangeCallback();
    }
    /**
	 * The w value of this quaternion.
	 *
	 * @type {number}
	 * @default 1
	 */ get w() {
        return this._w;
    }
    set w(value) {
        this._w = value;
        this._onChangeCallback();
    }
    /**
	 * Sets the quaternion components.
	 *
	 * @param {number} x - The x value of this quaternion.
	 * @param {number} y - The y value of this quaternion.
	 * @param {number} z - The z value of this quaternion.
	 * @param {number} w - The w value of this quaternion.
	 * @return {Quaternion} A reference to this quaternion.
	 */ set(x, y, z, w) {
        this._x = x;
        this._y = y;
        this._z = z;
        this._w = w;
        this._onChangeCallback();
        return this;
    }
    /**
	 * Returns a new quaternion with copied values from this instance.
	 *
	 * @return {Quaternion} A clone of this instance.
	 */ clone() {
        return new this.constructor(this._x, this._y, this._z, this._w);
    }
    /**
	 * Copies the values of the given quaternion to this instance.
	 *
	 * @param {Quaternion} quaternion - The quaternion to copy.
	 * @return {Quaternion} A reference to this quaternion.
	 */ copy(quaternion) {
        this._x = quaternion.x;
        this._y = quaternion.y;
        this._z = quaternion.z;
        this._w = quaternion.w;
        this._onChangeCallback();
        return this;
    }
    /**
	 * Sets this quaternion from the rotation specified by the given
	 * Euler angles.
	 *
	 * @param {Euler} euler - The Euler angles.
	 * @param {boolean} [update=true] - Whether the internal `onChange` callback should be executed or not.
	 * @return {Quaternion} A reference to this quaternion.
	 */ setFromEuler(euler, update = true) {
        const x = euler._x, y = euler._y, z = euler._z, order = euler._order;
        // http://www.mathworks.com/matlabcentral/fileexchange/
        // 	20696-function-to-convert-between-dcm-euler-angles-quaternions-and-euler-vectors/
        //	content/SpinCalc.m
        const cos = Math.cos;
        const sin = Math.sin;
        const c1 = cos(x / 2);
        const c2 = cos(y / 2);
        const c3 = cos(z / 2);
        const s1 = sin(x / 2);
        const s2 = sin(y / 2);
        const s3 = sin(z / 2);
        switch(order){
            case 'XYZ':
                this._x = s1 * c2 * c3 + c1 * s2 * s3;
                this._y = c1 * s2 * c3 - s1 * c2 * s3;
                this._z = c1 * c2 * s3 + s1 * s2 * c3;
                this._w = c1 * c2 * c3 - s1 * s2 * s3;
                break;
            case 'YXZ':
                this._x = s1 * c2 * c3 + c1 * s2 * s3;
                this._y = c1 * s2 * c3 - s1 * c2 * s3;
                this._z = c1 * c2 * s3 - s1 * s2 * c3;
                this._w = c1 * c2 * c3 + s1 * s2 * s3;
                break;
            case 'ZXY':
                this._x = s1 * c2 * c3 - c1 * s2 * s3;
                this._y = c1 * s2 * c3 + s1 * c2 * s3;
                this._z = c1 * c2 * s3 + s1 * s2 * c3;
                this._w = c1 * c2 * c3 - s1 * s2 * s3;
                break;
            case 'ZYX':
                this._x = s1 * c2 * c3 - c1 * s2 * s3;
                this._y = c1 * s2 * c3 + s1 * c2 * s3;
                this._z = c1 * c2 * s3 - s1 * s2 * c3;
                this._w = c1 * c2 * c3 + s1 * s2 * s3;
                break;
            case 'YZX':
                this._x = s1 * c2 * c3 + c1 * s2 * s3;
                this._y = c1 * s2 * c3 + s1 * c2 * s3;
                this._z = c1 * c2 * s3 - s1 * s2 * c3;
                this._w = c1 * c2 * c3 - s1 * s2 * s3;
                break;
            case 'XZY':
                this._x = s1 * c2 * c3 - c1 * s2 * s3;
                this._y = c1 * s2 * c3 - s1 * c2 * s3;
                this._z = c1 * c2 * s3 + s1 * s2 * c3;
                this._w = c1 * c2 * c3 + s1 * s2 * s3;
                break;
            default:
                console.warn('THREE.Quaternion: .setFromEuler() encountered an unknown order: ' + order);
        }
        if (update === true) this._onChangeCallback();
        return this;
    }
    /**
	 * Sets this quaternion from the given axis and angle.
	 *
	 * @param {Vector3} axis - The normalized axis.
	 * @param {number} angle - The angle in radians.
	 * @return {Quaternion} A reference to this quaternion.
	 */ setFromAxisAngle(axis, angle) {
        // http://www.euclideanspace.com/maths/geometry/rotations/conversions/angleToQuaternion/index.htm
        const halfAngle = angle / 2, s = Math.sin(halfAngle);
        this._x = axis.x * s;
        this._y = axis.y * s;
        this._z = axis.z * s;
        this._w = Math.cos(halfAngle);
        this._onChangeCallback();
        return this;
    }
    /**
	 * Sets this quaternion from the given rotation matrix.
	 *
	 * @param {Matrix4} m - A 4x4 matrix of which the upper 3x3 of matrix is a pure rotation matrix (i.e. unscaled).
	 * @return {Quaternion} A reference to this quaternion.
	 */ setFromRotationMatrix(m) {
        // http://www.euclideanspace.com/maths/geometry/rotations/conversions/matrixToQuaternion/index.htm
        // assumes the upper 3x3 of m is a pure rotation matrix (i.e, unscaled)
        const te = m.elements, m11 = te[0], m12 = te[4], m13 = te[8], m21 = te[1], m22 = te[5], m23 = te[9], m31 = te[2], m32 = te[6], m33 = te[10], trace = m11 + m22 + m33;
        if (trace > 0) {
            const s = 0.5 / Math.sqrt(trace + 1.0);
            this._w = 0.25 / s;
            this._x = (m32 - m23) * s;
            this._y = (m13 - m31) * s;
            this._z = (m21 - m12) * s;
        } else if (m11 > m22 && m11 > m33) {
            const s = 2.0 * Math.sqrt(1.0 + m11 - m22 - m33);
            this._w = (m32 - m23) / s;
            this._x = 0.25 * s;
            this._y = (m12 + m21) / s;
            this._z = (m13 + m31) / s;
        } else if (m22 > m33) {
            const s = 2.0 * Math.sqrt(1.0 + m22 - m11 - m33);
            this._w = (m13 - m31) / s;
            this._x = (m12 + m21) / s;
            this._y = 0.25 * s;
            this._z = (m23 + m32) / s;
        } else {
            const s = 2.0 * Math.sqrt(1.0 + m33 - m11 - m22);
            this._w = (m21 - m12) / s;
            this._x = (m13 + m31) / s;
            this._y = (m23 + m32) / s;
            this._z = 0.25 * s;
        }
        this._onChangeCallback();
        return this;
    }
    /**
	 * Sets this quaternion to the rotation required to rotate the direction vector
	 * `vFrom` to the direction vector `vTo`.
	 *
	 * @param {Vector3} vFrom - The first (normalized) direction vector.
	 * @param {Vector3} vTo - The second (normalized) direction vector.
	 * @return {Quaternion} A reference to this quaternion.
	 */ setFromUnitVectors(vFrom, vTo) {
        // assumes direction vectors vFrom and vTo are normalized
        let r = vFrom.dot(vTo) + 1;
        if (r < Number.EPSILON) {
            // vFrom and vTo point in opposite directions
            r = 0;
            if (Math.abs(vFrom.x) > Math.abs(vFrom.z)) {
                this._x = -vFrom.y;
                this._y = vFrom.x;
                this._z = 0;
                this._w = r;
            } else {
                this._x = 0;
                this._y = -vFrom.z;
                this._z = vFrom.y;
                this._w = r;
            }
        } else {
            // crossVectors( vFrom, vTo ); // inlined to avoid cyclic dependency on Vector3
            this._x = vFrom.y * vTo.z - vFrom.z * vTo.y;
            this._y = vFrom.z * vTo.x - vFrom.x * vTo.z;
            this._z = vFrom.x * vTo.y - vFrom.y * vTo.x;
            this._w = r;
        }
        return this.normalize();
    }
    /**
	 * Returns the angle between this quaternion and the given one in radians.
	 *
	 * @param {Quaternion} q - The quaternion to compute the angle with.
	 * @return {number} The angle in radians.
	 */ angleTo(q) {
        return 2 * Math.acos(Math.abs($9ddd7e9b53f7a2d4$var$clamp(this.dot(q), -1, 1)));
    }
    /**
	 * Rotates this quaternion by a given angular step to the given quaternion.
	 * The method ensures that the final quaternion will not overshoot `q`.
	 *
	 * @param {Quaternion} q - The target quaternion.
	 * @param {number} step - The angular step in radians.
	 * @return {Quaternion} A reference to this quaternion.
	 */ rotateTowards(q, step) {
        const angle = this.angleTo(q);
        if (angle === 0) return this;
        const t = Math.min(1, step / angle);
        this.slerp(q, t);
        return this;
    }
    /**
	 * Sets this quaternion to the identity quaternion; that is, to the
	 * quaternion that represents "no rotation".
	 *
	 * @return {Quaternion} A reference to this quaternion.
	 */ identity() {
        return this.set(0, 0, 0, 1);
    }
    /**
	 * Inverts this quaternion via {@link Quaternion#conjugate}. The
	 * quaternion is assumed to have unit length.
	 *
	 * @return {Quaternion} A reference to this quaternion.
	 */ invert() {
        return this.conjugate();
    }
    /**
	 * Returns the rotational conjugate of this quaternion. The conjugate of a
	 * quaternion represents the same rotation in the opposite direction about
	 * the rotational axis.
	 *
	 * @return {Quaternion} A reference to this quaternion.
	 */ conjugate() {
        this._x *= -1;
        this._y *= -1;
        this._z *= -1;
        this._onChangeCallback();
        return this;
    }
    /**
	 * Calculates the dot product of this quaternion and the given one.
	 *
	 * @param {Quaternion} v - The quaternion to compute the dot product with.
	 * @return {number} The result of the dot product.
	 */ dot(v) {
        return this._x * v._x + this._y * v._y + this._z * v._z + this._w * v._w;
    }
    /**
	 * Computes the squared Euclidean length (straight-line length) of this quaternion,
	 * considered as a 4 dimensional vector. This can be useful if you are comparing the
	 * lengths of two quaternions, as this is a slightly more efficient calculation than
	 * {@link Quaternion#length}.
	 *
	 * @return {number} The squared Euclidean length.
	 */ lengthSq() {
        return this._x * this._x + this._y * this._y + this._z * this._z + this._w * this._w;
    }
    /**
	 * Computes the Euclidean length (straight-line length) of this quaternion,
	 * considered as a 4 dimensional vector.
	 *
	 * @return {number} The Euclidean length.
	 */ length() {
        return Math.sqrt(this._x * this._x + this._y * this._y + this._z * this._z + this._w * this._w);
    }
    /**
	 * Normalizes this quaternion - that is, calculated the quaternion that performs
	 * the same rotation as this one, but has a length equal to `1`.
	 *
	 * @return {Quaternion} A reference to this quaternion.
	 */ normalize() {
        let l = this.length();
        if (l === 0) {
            this._x = 0;
            this._y = 0;
            this._z = 0;
            this._w = 1;
        } else {
            l = 1 / l;
            this._x = this._x * l;
            this._y = this._y * l;
            this._z = this._z * l;
            this._w = this._w * l;
        }
        this._onChangeCallback();
        return this;
    }
    /**
	 * Multiplies this quaternion by the given one.
	 *
	 * @param {Quaternion} q - The quaternion.
	 * @return {Quaternion} A reference to this quaternion.
	 */ multiply(q) {
        return this.multiplyQuaternions(this, q);
    }
    /**
	 * Pre-multiplies this quaternion by the given one.
	 *
	 * @param {Quaternion} q - The quaternion.
	 * @return {Quaternion} A reference to this quaternion.
	 */ premultiply(q) {
        return this.multiplyQuaternions(q, this);
    }
    /**
	 * Multiplies the given quaternions and stores the result in this instance.
	 *
	 * @param {Quaternion} a - The first quaternion.
	 * @param {Quaternion} b - The second quaternion.
	 * @return {Quaternion} A reference to this quaternion.
	 */ multiplyQuaternions(a, b) {
        // from http://www.euclideanspace.com/maths/algebra/realNormedAlgebra/quaternions/code/index.htm
        const qax = a._x, qay = a._y, qaz = a._z, qaw = a._w;
        const qbx = b._x, qby = b._y, qbz = b._z, qbw = b._w;
        this._x = qax * qbw + qaw * qbx + qay * qbz - qaz * qby;
        this._y = qay * qbw + qaw * qby + qaz * qbx - qax * qbz;
        this._z = qaz * qbw + qaw * qbz + qax * qby - qay * qbx;
        this._w = qaw * qbw - qax * qbx - qay * qby - qaz * qbz;
        this._onChangeCallback();
        return this;
    }
    /**
	 * Performs a spherical linear interpolation between quaternions.
	 *
	 * @param {Quaternion} qb - The target quaternion.
	 * @param {number} t - The interpolation factor in the closed interval `[0, 1]`.
	 * @return {Quaternion} A reference to this quaternion.
	 */ slerp(qb, t) {
        if (t === 0) return this;
        if (t === 1) return this.copy(qb);
        const x = this._x, y = this._y, z = this._z, w = this._w;
        // http://www.euclideanspace.com/maths/algebra/realNormedAlgebra/quaternions/slerp/
        let cosHalfTheta = w * qb._w + x * qb._x + y * qb._y + z * qb._z;
        if (cosHalfTheta < 0) {
            this._w = -qb._w;
            this._x = -qb._x;
            this._y = -qb._y;
            this._z = -qb._z;
            cosHalfTheta = -cosHalfTheta;
        } else this.copy(qb);
        if (cosHalfTheta >= 1.0) {
            this._w = w;
            this._x = x;
            this._y = y;
            this._z = z;
            return this;
        }
        const sqrSinHalfTheta = 1.0 - cosHalfTheta * cosHalfTheta;
        if (sqrSinHalfTheta <= Number.EPSILON) {
            const s = 1 - t;
            this._w = s * w + t * this._w;
            this._x = s * x + t * this._x;
            this._y = s * y + t * this._y;
            this._z = s * z + t * this._z;
            this.normalize(); // normalize calls _onChangeCallback()
            return this;
        }
        const sinHalfTheta = Math.sqrt(sqrSinHalfTheta);
        const halfTheta = Math.atan2(sinHalfTheta, cosHalfTheta);
        const ratioA = Math.sin((1 - t) * halfTheta) / sinHalfTheta, ratioB = Math.sin(t * halfTheta) / sinHalfTheta;
        this._w = w * ratioA + this._w * ratioB;
        this._x = x * ratioA + this._x * ratioB;
        this._y = y * ratioA + this._y * ratioB;
        this._z = z * ratioA + this._z * ratioB;
        this._onChangeCallback();
        return this;
    }
    /**
	 * Performs a spherical linear interpolation between the given quaternions
	 * and stores the result in this quaternion.
	 *
	 * @param {Quaternion} qa - The source quaternion.
	 * @param {Quaternion} qb - The target quaternion.
	 * @param {number} t - The interpolation factor in the closed interval `[0, 1]`.
	 * @return {Quaternion} A reference to this quaternion.
	 */ slerpQuaternions(qa, qb, t) {
        return this.copy(qa).slerp(qb, t);
    }
    /**
	 * Sets this quaternion to a uniformly random, normalized quaternion.
	 *
	 * @return {Quaternion} A reference to this quaternion.
	 */ random() {
        // Ken Shoemake
        // Uniform random rotations
        // D. Kirk, editor, Graphics Gems III, pages 124-132. Academic Press, New York, 1992.
        const theta1 = 2 * Math.PI * Math.random();
        const theta2 = 2 * Math.PI * Math.random();
        const x0 = Math.random();
        const r1 = Math.sqrt(1 - x0);
        const r2 = Math.sqrt(x0);
        return this.set(r1 * Math.sin(theta1), r1 * Math.cos(theta1), r2 * Math.sin(theta2), r2 * Math.cos(theta2));
    }
    /**
	 * Returns `true` if this quaternion is equal with the given one.
	 *
	 * @param {Quaternion} quaternion - The quaternion to test for equality.
	 * @return {boolean} Whether this quaternion is equal with the given one.
	 */ equals(quaternion) {
        return quaternion._x === this._x && quaternion._y === this._y && quaternion._z === this._z && quaternion._w === this._w;
    }
    /**
	 * Sets this quaternion's components from the given array.
	 *
	 * @param {Array<number>} array - An array holding the quaternion component values.
	 * @param {number} [offset=0] - The offset into the array.
	 * @return {Quaternion} A reference to this quaternion.
	 */ fromArray(array, offset = 0) {
        this._x = array[offset];
        this._y = array[offset + 1];
        this._z = array[offset + 2];
        this._w = array[offset + 3];
        this._onChangeCallback();
        return this;
    }
    /**
	 * Writes the components of this quaternion to the given array. If no array is provided,
	 * the method returns a new instance.
	 *
	 * @param {Array<number>} [array=[]] - The target array holding the quaternion components.
	 * @param {number} [offset=0] - Index of the first element in the array.
	 * @return {Array<number>} The quaternion components.
	 */ toArray(array = [], offset = 0) {
        array[offset] = this._x;
        array[offset + 1] = this._y;
        array[offset + 2] = this._z;
        array[offset + 3] = this._w;
        return array;
    }
    /**
	 * Sets the components of this quaternion from the given buffer attribute.
	 *
	 * @param {BufferAttribute} attribute - The buffer attribute holding quaternion data.
	 * @param {number} index - The index into the attribute.
	 * @return {Quaternion} A reference to this quaternion.
	 */ fromBufferAttribute(attribute, index) {
        this._x = attribute.getX(index);
        this._y = attribute.getY(index);
        this._z = attribute.getZ(index);
        this._w = attribute.getW(index);
        this._onChangeCallback();
        return this;
    }
    /**
	 * This methods defines the serialization result of this class. Returns the
	 * numerical elements of this quaternion in an array of format `[x, y, z, w]`.
	 *
	 * @return {Array<number>} The serialized quaternion.
	 */ toJSON() {
        return this.toArray();
    }
    _onChange(callback) {
        this._onChangeCallback = callback;
        return this;
    }
    _onChangeCallback() {}
    *[Symbol.iterator]() {
        yield this._x;
        yield this._y;
        yield this._z;
        yield this._w;
    }
}
/**
 * Class representing a 3D vector. A 3D vector is an ordered triplet of numbers
 * (labeled x, y and z), which can be used to represent a number of things, such as:
 *
 * - A point in 3D space.
 * - A direction and length in 3D space. In three.js the length will
 * always be the Euclidean distance(straight-line distance) from `(0, 0, 0)` to `(x, y, z)`
 * and the direction is also measured from `(0, 0, 0)` towards `(x, y, z)`.
 * - Any arbitrary ordered triplet of numbers.
 *
 * There are other things a 3D vector can be used to represent, such as
 * momentum vectors and so on, however these are the most
 * common uses in three.js.
 *
 * Iterating through a vector instance will yield its components `(x, y, z)` in
 * the corresponding order.
 * ```js
 * const a = new THREE.Vector3( 0, 1, 0 );
 *
 * //no arguments; will be initialised to (0, 0, 0)
 * const b = new THREE.Vector3( );
 *
 * const d = a.distanceTo( b );
 * ```
 */ class $9ddd7e9b53f7a2d4$export$64b5c384219d3699 {
    /**
	 * Constructs a new 3D vector.
	 *
	 * @param {number} [x=0] - The x value of this vector.
	 * @param {number} [y=0] - The y value of this vector.
	 * @param {number} [z=0] - The z value of this vector.
	 */ constructor(x = 0, y = 0, z = 0){
        /**
		 * This flag can be used for type testing.
		 *
		 * @type {boolean}
		 * @readonly
		 * @default true
		 */ $9ddd7e9b53f7a2d4$export$64b5c384219d3699.prototype.isVector3 = true;
        /**
		 * The x value of this vector.
		 *
		 * @type {number}
		 */ this.x = x;
        /**
		 * The y value of this vector.
		 *
		 * @type {number}
		 */ this.y = y;
        /**
		 * The z value of this vector.
		 *
		 * @type {number}
		 */ this.z = z;
    }
    /**
	 * Sets the vector components.
	 *
	 * @param {number} x - The value of the x component.
	 * @param {number} y - The value of the y component.
	 * @param {number} z - The value of the z component.
	 * @return {Vector3} A reference to this vector.
	 */ set(x, y, z) {
        if (z === undefined) z = this.z; // sprite.scale.set(x,y)
        this.x = x;
        this.y = y;
        this.z = z;
        return this;
    }
    /**
	 * Sets the vector components to the same value.
	 *
	 * @param {number} scalar - The value to set for all vector components.
	 * @return {Vector3} A reference to this vector.
	 */ setScalar(scalar) {
        this.x = scalar;
        this.y = scalar;
        this.z = scalar;
        return this;
    }
    /**
	 * Sets the vector's x component to the given value
	 *
	 * @param {number} x - The value to set.
	 * @return {Vector3} A reference to this vector.
	 */ setX(x) {
        this.x = x;
        return this;
    }
    /**
	 * Sets the vector's y component to the given value
	 *
	 * @param {number} y - The value to set.
	 * @return {Vector3} A reference to this vector.
	 */ setY(y) {
        this.y = y;
        return this;
    }
    /**
	 * Sets the vector's z component to the given value
	 *
	 * @param {number} z - The value to set.
	 * @return {Vector3} A reference to this vector.
	 */ setZ(z) {
        this.z = z;
        return this;
    }
    /**
	 * Allows to set a vector component with an index.
	 *
	 * @param {number} index - The component index. `0` equals to x, `1` equals to y, `2` equals to z.
	 * @param {number} value - The value to set.
	 * @return {Vector3} A reference to this vector.
	 */ setComponent(index, value) {
        switch(index){
            case 0:
                this.x = value;
                break;
            case 1:
                this.y = value;
                break;
            case 2:
                this.z = value;
                break;
            default:
                throw new Error('index is out of range: ' + index);
        }
        return this;
    }
    /**
	 * Returns the value of the vector component which matches the given index.
	 *
	 * @param {number} index - The component index. `0` equals to x, `1` equals to y, `2` equals to z.
	 * @return {number} A vector component value.
	 */ getComponent(index) {
        switch(index){
            case 0:
                return this.x;
            case 1:
                return this.y;
            case 2:
                return this.z;
            default:
                throw new Error('index is out of range: ' + index);
        }
    }
    /**
	 * Returns a new vector with copied values from this instance.
	 *
	 * @return {Vector3} A clone of this instance.
	 */ clone() {
        return new this.constructor(this.x, this.y, this.z);
    }
    /**
	 * Copies the values of the given vector to this instance.
	 *
	 * @param {Vector3} v - The vector to copy.
	 * @return {Vector3} A reference to this vector.
	 */ copy(v) {
        this.x = v.x;
        this.y = v.y;
        this.z = v.z;
        return this;
    }
    /**
	 * Adds the given vector to this instance.
	 *
	 * @param {Vector3} v - The vector to add.
	 * @return {Vector3} A reference to this vector.
	 */ add(v) {
        this.x += v.x;
        this.y += v.y;
        this.z += v.z;
        return this;
    }
    /**
	 * Adds the given scalar value to all components of this instance.
	 *
	 * @param {number} s - The scalar to add.
	 * @return {Vector3} A reference to this vector.
	 */ addScalar(s) {
        this.x += s;
        this.y += s;
        this.z += s;
        return this;
    }
    /**
	 * Adds the given vectors and stores the result in this instance.
	 *
	 * @param {Vector3} a - The first vector.
	 * @param {Vector3} b - The second vector.
	 * @return {Vector3} A reference to this vector.
	 */ addVectors(a, b) {
        this.x = a.x + b.x;
        this.y = a.y + b.y;
        this.z = a.z + b.z;
        return this;
    }
    /**
	 * Adds the given vector scaled by the given factor to this instance.
	 *
	 * @param {Vector3|Vector4} v - The vector.
	 * @param {number} s - The factor that scales `v`.
	 * @return {Vector3} A reference to this vector.
	 */ addScaledVector(v, s) {
        this.x += v.x * s;
        this.y += v.y * s;
        this.z += v.z * s;
        return this;
    }
    /**
	 * Subtracts the given vector from this instance.
	 *
	 * @param {Vector3} v - The vector to subtract.
	 * @return {Vector3} A reference to this vector.
	 */ sub(v) {
        this.x -= v.x;
        this.y -= v.y;
        this.z -= v.z;
        return this;
    }
    /**
	 * Subtracts the given scalar value from all components of this instance.
	 *
	 * @param {number} s - The scalar to subtract.
	 * @return {Vector3} A reference to this vector.
	 */ subScalar(s) {
        this.x -= s;
        this.y -= s;
        this.z -= s;
        return this;
    }
    /**
	 * Subtracts the given vectors and stores the result in this instance.
	 *
	 * @param {Vector3} a - The first vector.
	 * @param {Vector3} b - The second vector.
	 * @return {Vector3} A reference to this vector.
	 */ subVectors(a, b) {
        this.x = a.x - b.x;
        this.y = a.y - b.y;
        this.z = a.z - b.z;
        return this;
    }
    /**
	 * Multiplies the given vector with this instance.
	 *
	 * @param {Vector3} v - The vector to multiply.
	 * @return {Vector3} A reference to this vector.
	 */ multiply(v) {
        this.x *= v.x;
        this.y *= v.y;
        this.z *= v.z;
        return this;
    }
    /**
	 * Multiplies the given scalar value with all components of this instance.
	 *
	 * @param {number} scalar - The scalar to multiply.
	 * @return {Vector3} A reference to this vector.
	 */ multiplyScalar(scalar) {
        this.x *= scalar;
        this.y *= scalar;
        this.z *= scalar;
        return this;
    }
    /**
	 * Multiplies the given vectors and stores the result in this instance.
	 *
	 * @param {Vector3} a - The first vector.
	 * @param {Vector3} b - The second vector.
	 * @return {Vector3} A reference to this vector.
	 */ multiplyVectors(a, b) {
        this.x = a.x * b.x;
        this.y = a.y * b.y;
        this.z = a.z * b.z;
        return this;
    }
    /**
	 * Applies the given Euler rotation to this vector.
	 *
	 * @param {Euler} euler - The Euler angles.
	 * @return {Vector3} A reference to this vector.
	 */ applyEuler(euler) {
        return this.applyQuaternion($9ddd7e9b53f7a2d4$var$_quaternion$4.setFromEuler(euler));
    }
    /**
	 * Applies a rotation specified by an axis and an angle to this vector.
	 *
	 * @param {Vector3} axis - A normalized vector representing the rotation axis.
	 * @param {number} angle - The angle in radians.
	 * @return {Vector3} A reference to this vector.
	 */ applyAxisAngle(axis, angle) {
        return this.applyQuaternion($9ddd7e9b53f7a2d4$var$_quaternion$4.setFromAxisAngle(axis, angle));
    }
    /**
	 * Multiplies this vector with the given 3x3 matrix.
	 *
	 * @param {Matrix3} m - The 3x3 matrix.
	 * @return {Vector3} A reference to this vector.
	 */ applyMatrix3(m) {
        const x = this.x, y = this.y, z = this.z;
        const e = m.elements;
        this.x = e[0] * x + e[3] * y + e[6] * z;
        this.y = e[1] * x + e[4] * y + e[7] * z;
        this.z = e[2] * x + e[5] * y + e[8] * z;
        return this;
    }
    /**
	 * Multiplies this vector by the given normal matrix and normalizes
	 * the result.
	 *
	 * @param {Matrix3} m - The normal matrix.
	 * @return {Vector3} A reference to this vector.
	 */ applyNormalMatrix(m) {
        return this.applyMatrix3(m).normalize();
    }
    /**
	 * Multiplies this vector (with an implicit 1 in the 4th dimension) by m, and
	 * divides by perspective.
	 *
	 * @param {Matrix4} m - The matrix to apply.
	 * @return {Vector3} A reference to this vector.
	 */ applyMatrix4(m) {
        const x = this.x, y = this.y, z = this.z;
        const e = m.elements;
        const w = 1 / (e[3] * x + e[7] * y + e[11] * z + e[15]);
        this.x = (e[0] * x + e[4] * y + e[8] * z + e[12]) * w;
        this.y = (e[1] * x + e[5] * y + e[9] * z + e[13]) * w;
        this.z = (e[2] * x + e[6] * y + e[10] * z + e[14]) * w;
        return this;
    }
    /**
	 * Applies the given Quaternion to this vector.
	 *
	 * @param {Quaternion} q - The Quaternion.
	 * @return {Vector3} A reference to this vector.
	 */ applyQuaternion(q) {
        // quaternion q is assumed to have unit length
        const vx = this.x, vy = this.y, vz = this.z;
        const qx = q.x, qy = q.y, qz = q.z, qw = q.w;
        // t = 2 * cross( q.xyz, v );
        const tx = 2 * (qy * vz - qz * vy);
        const ty = 2 * (qz * vx - qx * vz);
        const tz = 2 * (qx * vy - qy * vx);
        // v + q.w * t + cross( q.xyz, t );
        this.x = vx + qw * tx + qy * tz - qz * ty;
        this.y = vy + qw * ty + qz * tx - qx * tz;
        this.z = vz + qw * tz + qx * ty - qy * tx;
        return this;
    }
    /**
	 * Projects this vector from world space into the camera's normalized
	 * device coordinate (NDC) space.
	 *
	 * @param {Camera} camera - The camera.
	 * @return {Vector3} A reference to this vector.
	 */ project(camera) {
        return this.applyMatrix4(camera.matrixWorldInverse).applyMatrix4(camera.projectionMatrix);
    }
    /**
	 * Unprojects this vector from the camera's normalized device coordinate (NDC)
	 * space into world space.
	 *
	 * @param {Camera} camera - The camera.
	 * @return {Vector3} A reference to this vector.
	 */ unproject(camera) {
        return this.applyMatrix4(camera.projectionMatrixInverse).applyMatrix4(camera.matrixWorld);
    }
    /**
	 * Transforms the direction of this vector by a matrix (the upper left 3 x 3
	 * subset of the given 4x4 matrix and then normalizes the result.
	 *
	 * @param {Matrix4} m - The matrix.
	 * @return {Vector3} A reference to this vector.
	 */ transformDirection(m) {
        // input: THREE.Matrix4 affine matrix
        // vector interpreted as a direction
        const x = this.x, y = this.y, z = this.z;
        const e = m.elements;
        this.x = e[0] * x + e[4] * y + e[8] * z;
        this.y = e[1] * x + e[5] * y + e[9] * z;
        this.z = e[2] * x + e[6] * y + e[10] * z;
        return this.normalize();
    }
    /**
	 * Divides this instance by the given vector.
	 *
	 * @param {Vector3} v - The vector to divide.
	 * @return {Vector3} A reference to this vector.
	 */ divide(v) {
        this.x /= v.x;
        this.y /= v.y;
        this.z /= v.z;
        return this;
    }
    /**
	 * Divides this vector by the given scalar.
	 *
	 * @param {number} scalar - The scalar to divide.
	 * @return {Vector3} A reference to this vector.
	 */ divideScalar(scalar) {
        return this.multiplyScalar(1 / scalar);
    }
    /**
	 * If this vector's x, y or z value is greater than the given vector's x, y or z
	 * value, replace that value with the corresponding min value.
	 *
	 * @param {Vector3} v - The vector.
	 * @return {Vector3} A reference to this vector.
	 */ min(v) {
        this.x = Math.min(this.x, v.x);
        this.y = Math.min(this.y, v.y);
        this.z = Math.min(this.z, v.z);
        return this;
    }
    /**
	 * If this vector's x, y or z value is less than the given vector's x, y or z
	 * value, replace that value with the corresponding max value.
	 *
	 * @param {Vector3} v - The vector.
	 * @return {Vector3} A reference to this vector.
	 */ max(v) {
        this.x = Math.max(this.x, v.x);
        this.y = Math.max(this.y, v.y);
        this.z = Math.max(this.z, v.z);
        return this;
    }
    /**
	 * If this vector's x, y or z value is greater than the max vector's x, y or z
	 * value, it is replaced by the corresponding value.
	 * If this vector's x, y or z value is less than the min vector's x, y or z value,
	 * it is replaced by the corresponding value.
	 *
	 * @param {Vector3} min - The minimum x, y and z values.
	 * @param {Vector3} max - The maximum x, y and z values in the desired range.
	 * @return {Vector3} A reference to this vector.
	 */ clamp(min, max) {
        // assumes min < max, componentwise
        this.x = $9ddd7e9b53f7a2d4$var$clamp(this.x, min.x, max.x);
        this.y = $9ddd7e9b53f7a2d4$var$clamp(this.y, min.y, max.y);
        this.z = $9ddd7e9b53f7a2d4$var$clamp(this.z, min.z, max.z);
        return this;
    }
    /**
	 * If this vector's x, y or z values are greater than the max value, they are
	 * replaced by the max value.
	 * If this vector's x, y or z values are less than the min value, they are
	 * replaced by the min value.
	 *
	 * @param {number} minVal - The minimum value the components will be clamped to.
	 * @param {number} maxVal - The maximum value the components will be clamped to.
	 * @return {Vector3} A reference to this vector.
	 */ clampScalar(minVal, maxVal) {
        this.x = $9ddd7e9b53f7a2d4$var$clamp(this.x, minVal, maxVal);
        this.y = $9ddd7e9b53f7a2d4$var$clamp(this.y, minVal, maxVal);
        this.z = $9ddd7e9b53f7a2d4$var$clamp(this.z, minVal, maxVal);
        return this;
    }
    /**
	 * If this vector's length is greater than the max value, it is replaced by
	 * the max value.
	 * If this vector's length is less than the min value, it is replaced by the
	 * min value.
	 *
	 * @param {number} min - The minimum value the vector length will be clamped to.
	 * @param {number} max - The maximum value the vector length will be clamped to.
	 * @return {Vector3} A reference to this vector.
	 */ clampLength(min, max) {
        const length = this.length();
        return this.divideScalar(length || 1).multiplyScalar($9ddd7e9b53f7a2d4$var$clamp(length, min, max));
    }
    /**
	 * The components of this vector are rounded down to the nearest integer value.
	 *
	 * @return {Vector3} A reference to this vector.
	 */ floor() {
        this.x = Math.floor(this.x);
        this.y = Math.floor(this.y);
        this.z = Math.floor(this.z);
        return this;
    }
    /**
	 * The components of this vector are rounded up to the nearest integer value.
	 *
	 * @return {Vector3} A reference to this vector.
	 */ ceil() {
        this.x = Math.ceil(this.x);
        this.y = Math.ceil(this.y);
        this.z = Math.ceil(this.z);
        return this;
    }
    /**
	 * The components of this vector are rounded to the nearest integer value
	 *
	 * @return {Vector3} A reference to this vector.
	 */ round() {
        this.x = Math.round(this.x);
        this.y = Math.round(this.y);
        this.z = Math.round(this.z);
        return this;
    }
    /**
	 * The components of this vector are rounded towards zero (up if negative,
	 * down if positive) to an integer value.
	 *
	 * @return {Vector3} A reference to this vector.
	 */ roundToZero() {
        this.x = Math.trunc(this.x);
        this.y = Math.trunc(this.y);
        this.z = Math.trunc(this.z);
        return this;
    }
    /**
	 * Inverts this vector - i.e. sets x = -x, y = -y and z = -z.
	 *
	 * @return {Vector3} A reference to this vector.
	 */ negate() {
        this.x = -this.x;
        this.y = -this.y;
        this.z = -this.z;
        return this;
    }
    /**
	 * Calculates the dot product of the given vector with this instance.
	 *
	 * @param {Vector3} v - The vector to compute the dot product with.
	 * @return {number} The result of the dot product.
	 */ dot(v) {
        return this.x * v.x + this.y * v.y + this.z * v.z;
    }
    // TODO lengthSquared?
    /**
	 * Computes the square of the Euclidean length (straight-line length) from
	 * (0, 0, 0) to (x, y, z). If you are comparing the lengths of vectors, you should
	 * compare the length squared instead as it is slightly more efficient to calculate.
	 *
	 * @return {number} The square length of this vector.
	 */ lengthSq() {
        return this.x * this.x + this.y * this.y + this.z * this.z;
    }
    /**
	 * Computes the  Euclidean length (straight-line length) from (0, 0, 0) to (x, y, z).
	 *
	 * @return {number} The length of this vector.
	 */ length() {
        return Math.sqrt(this.x * this.x + this.y * this.y + this.z * this.z);
    }
    /**
	 * Computes the Manhattan length of this vector.
	 *
	 * @return {number} The length of this vector.
	 */ manhattanLength() {
        return Math.abs(this.x) + Math.abs(this.y) + Math.abs(this.z);
    }
    /**
	 * Converts this vector to a unit vector - that is, sets it equal to a vector
	 * with the same direction as this one, but with a vector length of `1`.
	 *
	 * @return {Vector3} A reference to this vector.
	 */ normalize() {
        return this.divideScalar(this.length() || 1);
    }
    /**
	 * Sets this vector to a vector with the same direction as this one, but
	 * with the specified length.
	 *
	 * @param {number} length - The new length of this vector.
	 * @return {Vector3} A reference to this vector.
	 */ setLength(length) {
        return this.normalize().multiplyScalar(length);
    }
    /**
	 * Linearly interpolates between the given vector and this instance, where
	 * alpha is the percent distance along the line - alpha = 0 will be this
	 * vector, and alpha = 1 will be the given one.
	 *
	 * @param {Vector3} v - The vector to interpolate towards.
	 * @param {number} alpha - The interpolation factor, typically in the closed interval `[0, 1]`.
	 * @return {Vector3} A reference to this vector.
	 */ lerp(v, alpha) {
        this.x += (v.x - this.x) * alpha;
        this.y += (v.y - this.y) * alpha;
        this.z += (v.z - this.z) * alpha;
        return this;
    }
    /**
	 * Linearly interpolates between the given vectors, where alpha is the percent
	 * distance along the line - alpha = 0 will be first vector, and alpha = 1 will
	 * be the second one. The result is stored in this instance.
	 *
	 * @param {Vector3} v1 - The first vector.
	 * @param {Vector3} v2 - The second vector.
	 * @param {number} alpha - The interpolation factor, typically in the closed interval `[0, 1]`.
	 * @return {Vector3} A reference to this vector.
	 */ lerpVectors(v1, v2, alpha) {
        this.x = v1.x + (v2.x - v1.x) * alpha;
        this.y = v1.y + (v2.y - v1.y) * alpha;
        this.z = v1.z + (v2.z - v1.z) * alpha;
        return this;
    }
    /**
	 * Calculates the cross product of the given vector with this instance.
	 *
	 * @param {Vector3} v - The vector to compute the cross product with.
	 * @return {Vector3} The result of the cross product.
	 */ cross(v) {
        return this.crossVectors(this, v);
    }
    /**
	 * Calculates the cross product of the given vectors and stores the result
	 * in this instance.
	 *
	 * @param {Vector3} a - The first vector.
	 * @param {Vector3} b - The second vector.
	 * @return {Vector3} A reference to this vector.
	 */ crossVectors(a, b) {
        const ax = a.x, ay = a.y, az = a.z;
        const bx = b.x, by = b.y, bz = b.z;
        this.x = ay * bz - az * by;
        this.y = az * bx - ax * bz;
        this.z = ax * by - ay * bx;
        return this;
    }
    /**
	 * Projects this vector onto the given one.
	 *
	 * @param {Vector3} v - The vector to project to.
	 * @return {Vector3} A reference to this vector.
	 */ projectOnVector(v) {
        const denominator = v.lengthSq();
        if (denominator === 0) return this.set(0, 0, 0);
        const scalar = v.dot(this) / denominator;
        return this.copy(v).multiplyScalar(scalar);
    }
    /**
	 * Projects this vector onto a plane by subtracting this
	 * vector projected onto the plane's normal from this vector.
	 *
	 * @param {Vector3} planeNormal - The plane normal.
	 * @return {Vector3} A reference to this vector.
	 */ projectOnPlane(planeNormal) {
        $9ddd7e9b53f7a2d4$var$_vector$c.copy(this).projectOnVector(planeNormal);
        return this.sub($9ddd7e9b53f7a2d4$var$_vector$c);
    }
    /**
	 * Reflects this vector off a plane orthogonal to the given normal vector.
	 *
	 * @param {Vector3} normal - The (normalized) normal vector.
	 * @return {Vector3} A reference to this vector.
	 */ reflect(normal) {
        return this.sub($9ddd7e9b53f7a2d4$var$_vector$c.copy(normal).multiplyScalar(2 * this.dot(normal)));
    }
    /**
	 * Returns the angle between the given vector and this instance in radians.
	 *
	 * @param {Vector3} v - The vector to compute the angle with.
	 * @return {number} The angle in radians.
	 */ angleTo(v) {
        const denominator = Math.sqrt(this.lengthSq() * v.lengthSq());
        if (denominator === 0) return Math.PI / 2;
        const theta = this.dot(v) / denominator;
        // clamp, to handle numerical problems
        return Math.acos($9ddd7e9b53f7a2d4$var$clamp(theta, -1, 1));
    }
    /**
	 * Computes the distance from the given vector to this instance.
	 *
	 * @param {Vector3} v - The vector to compute the distance to.
	 * @return {number} The distance.
	 */ distanceTo(v) {
        return Math.sqrt(this.distanceToSquared(v));
    }
    /**
	 * Computes the squared distance from the given vector to this instance.
	 * If you are just comparing the distance with another distance, you should compare
	 * the distance squared instead as it is slightly more efficient to calculate.
	 *
	 * @param {Vector3} v - The vector to compute the squared distance to.
	 * @return {number} The squared distance.
	 */ distanceToSquared(v) {
        const dx = this.x - v.x, dy = this.y - v.y, dz = this.z - v.z;
        return dx * dx + dy * dy + dz * dz;
    }
    /**
	 * Computes the Manhattan distance from the given vector to this instance.
	 *
	 * @param {Vector3} v - The vector to compute the Manhattan distance to.
	 * @return {number} The Manhattan distance.
	 */ manhattanDistanceTo(v) {
        return Math.abs(this.x - v.x) + Math.abs(this.y - v.y) + Math.abs(this.z - v.z);
    }
    /**
	 * Sets the vector components from the given spherical coordinates.
	 *
	 * @param {Spherical} s - The spherical coordinates.
	 * @return {Vector3} A reference to this vector.
	 */ setFromSpherical(s) {
        return this.setFromSphericalCoords(s.radius, s.phi, s.theta);
    }
    /**
	 * Sets the vector components from the given spherical coordinates.
	 *
	 * @param {number} radius - The radius.
	 * @param {number} phi - The phi angle in radians.
	 * @param {number} theta - The theta angle in radians.
	 * @return {Vector3} A reference to this vector.
	 */ setFromSphericalCoords(radius, phi, theta) {
        const sinPhiRadius = Math.sin(phi) * radius;
        this.x = sinPhiRadius * Math.sin(theta);
        this.y = Math.cos(phi) * radius;
        this.z = sinPhiRadius * Math.cos(theta);
        return this;
    }
    /**
	 * Sets the vector components from the given cylindrical coordinates.
	 *
	 * @param {Cylindrical} c - The cylindrical coordinates.
	 * @return {Vector3} A reference to this vector.
	 */ setFromCylindrical(c) {
        return this.setFromCylindricalCoords(c.radius, c.theta, c.y);
    }
    /**
	 * Sets the vector components from the given cylindrical coordinates.
	 *
	 * @param {number} radius - The radius.
	 * @param {number} theta - The theta angle in radians.
	 * @param {number} y - The y value.
	 * @return {Vector3} A reference to this vector.
	 */ setFromCylindricalCoords(radius, theta, y) {
        this.x = radius * Math.sin(theta);
        this.y = y;
        this.z = radius * Math.cos(theta);
        return this;
    }
    /**
	 * Sets the vector components to the position elements of the
	 * given transformation matrix.
	 *
	 * @param {Matrix4} m - The 4x4 matrix.
	 * @return {Vector3} A reference to this vector.
	 */ setFromMatrixPosition(m) {
        const e = m.elements;
        this.x = e[12];
        this.y = e[13];
        this.z = e[14];
        return this;
    }
    /**
	 * Sets the vector components to the scale elements of the
	 * given transformation matrix.
	 *
	 * @param {Matrix4} m - The 4x4 matrix.
	 * @return {Vector3} A reference to this vector.
	 */ setFromMatrixScale(m) {
        const sx = this.setFromMatrixColumn(m, 0).length();
        const sy = this.setFromMatrixColumn(m, 1).length();
        const sz = this.setFromMatrixColumn(m, 2).length();
        this.x = sx;
        this.y = sy;
        this.z = sz;
        return this;
    }
    /**
	 * Sets the vector components from the specified matrix column.
	 *
	 * @param {Matrix4} m - The 4x4 matrix.
	 * @param {number} index - The column index.
	 * @return {Vector3} A reference to this vector.
	 */ setFromMatrixColumn(m, index) {
        return this.fromArray(m.elements, index * 4);
    }
    /**
	 * Sets the vector components from the specified matrix column.
	 *
	 * @param {Matrix3} m - The 3x3 matrix.
	 * @param {number} index - The column index.
	 * @return {Vector3} A reference to this vector.
	 */ setFromMatrix3Column(m, index) {
        return this.fromArray(m.elements, index * 3);
    }
    /**
	 * Sets the vector components from the given Euler angles.
	 *
	 * @param {Euler} e - The Euler angles to set.
	 * @return {Vector3} A reference to this vector.
	 */ setFromEuler(e) {
        this.x = e._x;
        this.y = e._y;
        this.z = e._z;
        return this;
    }
    /**
	 * Sets the vector components from the RGB components of the
	 * given color.
	 *
	 * @param {Color} c - The color to set.
	 * @return {Vector3} A reference to this vector.
	 */ setFromColor(c) {
        this.x = c.r;
        this.y = c.g;
        this.z = c.b;
        return this;
    }
    /**
	 * Returns `true` if this vector is equal with the given one.
	 *
	 * @param {Vector3} v - The vector to test for equality.
	 * @return {boolean} Whether this vector is equal with the given one.
	 */ equals(v) {
        return v.x === this.x && v.y === this.y && v.z === this.z;
    }
    /**
	 * Sets this vector's x value to be `array[ offset ]`, y value to be `array[ offset + 1 ]`
	 * and z value to be `array[ offset + 2 ]`.
	 *
	 * @param {Array<number>} array - An array holding the vector component values.
	 * @param {number} [offset=0] - The offset into the array.
	 * @return {Vector3} A reference to this vector.
	 */ fromArray(array, offset = 0) {
        this.x = array[offset];
        this.y = array[offset + 1];
        this.z = array[offset + 2];
        return this;
    }
    /**
	 * Writes the components of this vector to the given array. If no array is provided,
	 * the method returns a new instance.
	 *
	 * @param {Array<number>} [array=[]] - The target array holding the vector components.
	 * @param {number} [offset=0] - Index of the first element in the array.
	 * @return {Array<number>} The vector components.
	 */ toArray(array = [], offset = 0) {
        array[offset] = this.x;
        array[offset + 1] = this.y;
        array[offset + 2] = this.z;
        return array;
    }
    /**
	 * Sets the components of this vector from the given buffer attribute.
	 *
	 * @param {BufferAttribute} attribute - The buffer attribute holding vector data.
	 * @param {number} index - The index into the attribute.
	 * @return {Vector3} A reference to this vector.
	 */ fromBufferAttribute(attribute, index) {
        this.x = attribute.getX(index);
        this.y = attribute.getY(index);
        this.z = attribute.getZ(index);
        return this;
    }
    /**
	 * Sets each component of this vector to a pseudo-random value between `0` and
	 * `1`, excluding `1`.
	 *
	 * @return {Vector3} A reference to this vector.
	 */ random() {
        this.x = Math.random();
        this.y = Math.random();
        this.z = Math.random();
        return this;
    }
    /**
	 * Sets this vector to a uniformly random point on a unit sphere.
	 *
	 * @return {Vector3} A reference to this vector.
	 */ randomDirection() {
        // https://mathworld.wolfram.com/SpherePointPicking.html
        const theta = Math.random() * Math.PI * 2;
        const u = Math.random() * 2 - 1;
        const c = Math.sqrt(1 - u * u);
        this.x = c * Math.cos(theta);
        this.y = u;
        this.z = c * Math.sin(theta);
        return this;
    }
    *[Symbol.iterator]() {
        yield this.x;
        yield this.y;
        yield this.z;
    }
}
const $9ddd7e9b53f7a2d4$var$_vector$c = /*@__PURE__*/ new $9ddd7e9b53f7a2d4$export$64b5c384219d3699();
const $9ddd7e9b53f7a2d4$var$_quaternion$4 = /*@__PURE__*/ new $9ddd7e9b53f7a2d4$export$23d6a54f0bbc85a3();
/**
 * Represents an axis-aligned bounding box (AABB) in 3D space.
 */ class $9ddd7e9b53f7a2d4$export$6f7d5a9418ab2aa3 {
    /**
	 * Constructs a new bounding box.
	 *
	 * @param {Vector3} [min=(Infinity,Infinity,Infinity)] - A vector representing the lower boundary of the box.
	 * @param {Vector3} [max=(-Infinity,-Infinity,-Infinity)] - A vector representing the upper boundary of the box.
	 */ constructor(min = new $9ddd7e9b53f7a2d4$export$64b5c384219d3699(Infinity, Infinity, Infinity), max = new $9ddd7e9b53f7a2d4$export$64b5c384219d3699(-Infinity, -Infinity, -Infinity)){
        /**
		 * This flag can be used for type testing.
		 *
		 * @type {boolean}
		 * @readonly
		 * @default true
		 */ this.isBox3 = true;
        /**
		 * The lower boundary of the box.
		 *
		 * @type {Vector3}
		 */ this.min = min;
        /**
		 * The upper boundary of the box.
		 *
		 * @type {Vector3}
		 */ this.max = max;
    }
    /**
	 * Sets the lower and upper boundaries of this box.
	 * Please note that this method only copies the values from the given objects.
	 *
	 * @param {Vector3} min - The lower boundary of the box.
	 * @param {Vector3} max - The upper boundary of the box.
	 * @return {Box3} A reference to this bounding box.
	 */ set(min, max) {
        this.min.copy(min);
        this.max.copy(max);
        return this;
    }
    /**
	 * Sets the upper and lower bounds of this box so it encloses the position data
	 * in the given array.
	 *
	 * @param {Array<number>} array - An array holding 3D position data.
	 * @return {Box3} A reference to this bounding box.
	 */ setFromArray(array) {
        this.makeEmpty();
        for(let i = 0, il = array.length; i < il; i += 3)this.expandByPoint($9ddd7e9b53f7a2d4$var$_vector$b.fromArray(array, i));
        return this;
    }
    /**
	 * Sets the upper and lower bounds of this box so it encloses the position data
	 * in the given buffer attribute.
	 *
	 * @param {BufferAttribute} attribute - A buffer attribute holding 3D position data.
	 * @return {Box3} A reference to this bounding box.
	 */ setFromBufferAttribute(attribute) {
        this.makeEmpty();
        for(let i = 0, il = attribute.count; i < il; i++)this.expandByPoint($9ddd7e9b53f7a2d4$var$_vector$b.fromBufferAttribute(attribute, i));
        return this;
    }
    /**
	 * Sets the upper and lower bounds of this box so it encloses the position data
	 * in the given array.
	 *
	 * @param {Array<Vector3>} points - An array holding 3D position data as instances of {@link Vector3}.
	 * @return {Box3} A reference to this bounding box.
	 */ setFromPoints(points) {
        this.makeEmpty();
        for(let i = 0, il = points.length; i < il; i++)this.expandByPoint(points[i]);
        return this;
    }
    /**
	 * Centers this box on the given center vector and sets this box's width, height and
	 * depth to the given size values.
	 *
	 * @param {Vector3} center - The center of the box.
	 * @param {Vector3} size - The x, y and z dimensions of the box.
	 * @return {Box3} A reference to this bounding box.
	 */ setFromCenterAndSize(center, size) {
        const halfSize = $9ddd7e9b53f7a2d4$var$_vector$b.copy(size).multiplyScalar(0.5);
        this.min.copy(center).sub(halfSize);
        this.max.copy(center).add(halfSize);
        return this;
    }
    /**
	 * Computes the world-axis-aligned bounding box for the given 3D object
	 * (including its children), accounting for the object's, and children's,
	 * world transforms. The function may result in a larger box than strictly necessary.
	 *
	 * @param {Object3D} object - The 3D object to compute the bounding box for.
	 * @param {boolean} [precise=false] - If set to `true`, the method computes the smallest
	 * world-axis-aligned bounding box at the expense of more computation.
	 * @return {Box3} A reference to this bounding box.
	 */ setFromObject(object, precise = false) {
        this.makeEmpty();
        return this.expandByObject(object, precise);
    }
    /**
	 * Returns a new box with copied values from this instance.
	 *
	 * @return {Box3} A clone of this instance.
	 */ clone() {
        return new this.constructor().copy(this);
    }
    /**
	 * Copies the values of the given box to this instance.
	 *
	 * @param {Box3} box - The box to copy.
	 * @return {Box3} A reference to this bounding box.
	 */ copy(box) {
        this.min.copy(box.min);
        this.max.copy(box.max);
        return this;
    }
    /**
	 * Makes this box empty which means in encloses a zero space in 3D.
	 *
	 * @return {Box3} A reference to this bounding box.
	 */ makeEmpty() {
        this.min.x = this.min.y = this.min.z = Infinity;
        this.max.x = this.max.y = this.max.z = -Infinity;
        return this;
    }
    /**
	 * Returns true if this box includes zero points within its bounds.
	 * Note that a box with equal lower and upper bounds still includes one
	 * point, the one both bounds share.
	 *
	 * @return {boolean} Whether this box is empty or not.
	 */ isEmpty() {
        // this is a more robust check for empty than ( volume <= 0 ) because volume can get positive with two negative axes
        return this.max.x < this.min.x || this.max.y < this.min.y || this.max.z < this.min.z;
    }
    /**
	 * Returns the center point of this box.
	 *
	 * @param {Vector3} target - The target vector that is used to store the method's result.
	 * @return {Vector3} The center point.
	 */ getCenter(target) {
        return this.isEmpty() ? target.set(0, 0, 0) : target.addVectors(this.min, this.max).multiplyScalar(0.5);
    }
    /**
	 * Returns the dimensions of this box.
	 *
	 * @param {Vector3} target - The target vector that is used to store the method's result.
	 * @return {Vector3} The size.
	 */ getSize(target) {
        return this.isEmpty() ? target.set(0, 0, 0) : target.subVectors(this.max, this.min);
    }
    /**
	 * Expands the boundaries of this box to include the given point.
	 *
	 * @param {Vector3} point - The point that should be included by the bounding box.
	 * @return {Box3} A reference to this bounding box.
	 */ expandByPoint(point) {
        this.min.min(point);
        this.max.max(point);
        return this;
    }
    /**
	 * Expands this box equilaterally by the given vector. The width of this
	 * box will be expanded by the x component of the vector in both
	 * directions. The height of this box will be expanded by the y component of
	 * the vector in both directions. The depth of this box will be
	 * expanded by the z component of the vector in both directions.
	 *
	 * @param {Vector3} vector - The vector that should expand the bounding box.
	 * @return {Box3} A reference to this bounding box.
	 */ expandByVector(vector) {
        this.min.sub(vector);
        this.max.add(vector);
        return this;
    }
    /**
	 * Expands each dimension of the box by the given scalar. If negative, the
	 * dimensions of the box will be contracted.
	 *
	 * @param {number} scalar - The scalar value that should expand the bounding box.
	 * @return {Box3} A reference to this bounding box.
	 */ expandByScalar(scalar) {
        this.min.addScalar(-scalar);
        this.max.addScalar(scalar);
        return this;
    }
    /**
	 * Expands the boundaries of this box to include the given 3D object and
	 * its children, accounting for the object's, and children's, world
	 * transforms. The function may result in a larger box than strictly
	 * necessary (unless the precise parameter is set to true).
	 *
	 * @param {Object3D} object - The 3D object that should expand the bounding box.
	 * @param {boolean} precise - If set to `true`, the method expands the bounding box
	 * as little as necessary at the expense of more computation.
	 * @return {Box3} A reference to this bounding box.
	 */ expandByObject(object, precise = false) {
        // Computes the world-axis-aligned bounding box of an object (including its children),
        // accounting for both the object's, and children's, world transforms
        object.updateWorldMatrix(false, false);
        const geometry = object.geometry;
        if (geometry !== undefined) {
            const positionAttribute = geometry.getAttribute('position');
            // precise AABB computation based on vertex data requires at least a position attribute.
            // instancing isn't supported so far and uses the normal (conservative) code path.
            if (precise === true && positionAttribute !== undefined && object.isInstancedMesh !== true) for(let i = 0, l = positionAttribute.count; i < l; i++){
                if (object.isMesh === true) object.getVertexPosition(i, $9ddd7e9b53f7a2d4$var$_vector$b);
                else $9ddd7e9b53f7a2d4$var$_vector$b.fromBufferAttribute(positionAttribute, i);
                $9ddd7e9b53f7a2d4$var$_vector$b.applyMatrix4(object.matrixWorld);
                this.expandByPoint($9ddd7e9b53f7a2d4$var$_vector$b);
            }
            else {
                if (object.boundingBox !== undefined) {
                    // object-level bounding box
                    if (object.boundingBox === null) object.computeBoundingBox();
                    $9ddd7e9b53f7a2d4$var$_box$4.copy(object.boundingBox);
                } else {
                    // geometry-level bounding box
                    if (geometry.boundingBox === null) geometry.computeBoundingBox();
                    $9ddd7e9b53f7a2d4$var$_box$4.copy(geometry.boundingBox);
                }
                $9ddd7e9b53f7a2d4$var$_box$4.applyMatrix4(object.matrixWorld);
                this.union($9ddd7e9b53f7a2d4$var$_box$4);
            }
        }
        const children = object.children;
        for(let i = 0, l = children.length; i < l; i++)this.expandByObject(children[i], precise);
        return this;
    }
    /**
	 * Returns `true` if the given point lies within or on the boundaries of this box.
	 *
	 * @param {Vector3} point - The point to test.
	 * @return {boolean} Whether the bounding box contains the given point or not.
	 */ containsPoint(point) {
        return point.x >= this.min.x && point.x <= this.max.x && point.y >= this.min.y && point.y <= this.max.y && point.z >= this.min.z && point.z <= this.max.z;
    }
    /**
	 * Returns `true` if this bounding box includes the entirety of the given bounding box.
	 * If this box and the given one are identical, this function also returns `true`.
	 *
	 * @param {Box3} box - The bounding box to test.
	 * @return {boolean} Whether the bounding box contains the given bounding box or not.
	 */ containsBox(box) {
        return this.min.x <= box.min.x && box.max.x <= this.max.x && this.min.y <= box.min.y && box.max.y <= this.max.y && this.min.z <= box.min.z && box.max.z <= this.max.z;
    }
    /**
	 * Returns a point as a proportion of this box's width, height and depth.
	 *
	 * @param {Vector3} point - A point in 3D space.
	 * @param {Vector3} target - The target vector that is used to store the method's result.
	 * @return {Vector3} A point as a proportion of this box's width, height and depth.
	 */ getParameter(point, target) {
        // This can potentially have a divide by zero if the box
        // has a size dimension of 0.
        return target.set((point.x - this.min.x) / (this.max.x - this.min.x), (point.y - this.min.y) / (this.max.y - this.min.y), (point.z - this.min.z) / (this.max.z - this.min.z));
    }
    /**
	 * Returns `true` if the given bounding box intersects with this bounding box.
	 *
	 * @param {Box3} box - The bounding box to test.
	 * @return {boolean} Whether the given bounding box intersects with this bounding box.
	 */ intersectsBox(box) {
        // using 6 splitting planes to rule out intersections.
        return box.max.x >= this.min.x && box.min.x <= this.max.x && box.max.y >= this.min.y && box.min.y <= this.max.y && box.max.z >= this.min.z && box.min.z <= this.max.z;
    }
    /**
	 * Returns `true` if the given bounding sphere intersects with this bounding box.
	 *
	 * @param {Sphere} sphere - The bounding sphere to test.
	 * @return {boolean} Whether the given bounding sphere intersects with this bounding box.
	 */ intersectsSphere(sphere) {
        // Find the point on the AABB closest to the sphere center.
        this.clampPoint(sphere.center, $9ddd7e9b53f7a2d4$var$_vector$b);
        // If that point is inside the sphere, the AABB and sphere intersect.
        return $9ddd7e9b53f7a2d4$var$_vector$b.distanceToSquared(sphere.center) <= sphere.radius * sphere.radius;
    }
    /**
	 * Returns `true` if the given plane intersects with this bounding box.
	 *
	 * @param {Plane} plane - The plane to test.
	 * @return {boolean} Whether the given plane intersects with this bounding box.
	 */ intersectsPlane(plane) {
        // We compute the minimum and maximum dot product values. If those values
        // are on the same side (back or front) of the plane, then there is no intersection.
        let min, max;
        if (plane.normal.x > 0) {
            min = plane.normal.x * this.min.x;
            max = plane.normal.x * this.max.x;
        } else {
            min = plane.normal.x * this.max.x;
            max = plane.normal.x * this.min.x;
        }
        if (plane.normal.y > 0) {
            min += plane.normal.y * this.min.y;
            max += plane.normal.y * this.max.y;
        } else {
            min += plane.normal.y * this.max.y;
            max += plane.normal.y * this.min.y;
        }
        if (plane.normal.z > 0) {
            min += plane.normal.z * this.min.z;
            max += plane.normal.z * this.max.z;
        } else {
            min += plane.normal.z * this.max.z;
            max += plane.normal.z * this.min.z;
        }
        return min <= -plane.constant && max >= -plane.constant;
    }
    /**
	 * Returns `true` if the given triangle intersects with this bounding box.
	 *
	 * @param {Triangle} triangle - The triangle to test.
	 * @return {boolean} Whether the given triangle intersects with this bounding box.
	 */ intersectsTriangle(triangle) {
        if (this.isEmpty()) return false;
        // compute box center and extents
        this.getCenter($9ddd7e9b53f7a2d4$var$_center);
        $9ddd7e9b53f7a2d4$var$_extents.subVectors(this.max, $9ddd7e9b53f7a2d4$var$_center);
        // translate triangle to aabb origin
        $9ddd7e9b53f7a2d4$var$_v0$2.subVectors(triangle.a, $9ddd7e9b53f7a2d4$var$_center);
        $9ddd7e9b53f7a2d4$var$_v1$7.subVectors(triangle.b, $9ddd7e9b53f7a2d4$var$_center);
        $9ddd7e9b53f7a2d4$var$_v2$4.subVectors(triangle.c, $9ddd7e9b53f7a2d4$var$_center);
        // compute edge vectors for triangle
        $9ddd7e9b53f7a2d4$var$_f0.subVectors($9ddd7e9b53f7a2d4$var$_v1$7, $9ddd7e9b53f7a2d4$var$_v0$2);
        $9ddd7e9b53f7a2d4$var$_f1.subVectors($9ddd7e9b53f7a2d4$var$_v2$4, $9ddd7e9b53f7a2d4$var$_v1$7);
        $9ddd7e9b53f7a2d4$var$_f2.subVectors($9ddd7e9b53f7a2d4$var$_v0$2, $9ddd7e9b53f7a2d4$var$_v2$4);
        // test against axes that are given by cross product combinations of the edges of the triangle and the edges of the aabb
        // make an axis testing of each of the 3 sides of the aabb against each of the 3 sides of the triangle = 9 axis of separation
        // axis_ij = u_i x f_j (u0, u1, u2 = face normals of aabb = x,y,z axes vectors since aabb is axis aligned)
        let axes = [
            0,
            -$9ddd7e9b53f7a2d4$var$_f0.z,
            $9ddd7e9b53f7a2d4$var$_f0.y,
            0,
            -$9ddd7e9b53f7a2d4$var$_f1.z,
            $9ddd7e9b53f7a2d4$var$_f1.y,
            0,
            -$9ddd7e9b53f7a2d4$var$_f2.z,
            $9ddd7e9b53f7a2d4$var$_f2.y,
            $9ddd7e9b53f7a2d4$var$_f0.z,
            0,
            -$9ddd7e9b53f7a2d4$var$_f0.x,
            $9ddd7e9b53f7a2d4$var$_f1.z,
            0,
            -$9ddd7e9b53f7a2d4$var$_f1.x,
            $9ddd7e9b53f7a2d4$var$_f2.z,
            0,
            -$9ddd7e9b53f7a2d4$var$_f2.x,
            -$9ddd7e9b53f7a2d4$var$_f0.y,
            $9ddd7e9b53f7a2d4$var$_f0.x,
            0,
            -$9ddd7e9b53f7a2d4$var$_f1.y,
            $9ddd7e9b53f7a2d4$var$_f1.x,
            0,
            -$9ddd7e9b53f7a2d4$var$_f2.y,
            $9ddd7e9b53f7a2d4$var$_f2.x,
            0
        ];
        if (!$9ddd7e9b53f7a2d4$var$satForAxes(axes, $9ddd7e9b53f7a2d4$var$_v0$2, $9ddd7e9b53f7a2d4$var$_v1$7, $9ddd7e9b53f7a2d4$var$_v2$4, $9ddd7e9b53f7a2d4$var$_extents)) return false;
        // test 3 face normals from the aabb
        axes = [
            1,
            0,
            0,
            0,
            1,
            0,
            0,
            0,
            1
        ];
        if (!$9ddd7e9b53f7a2d4$var$satForAxes(axes, $9ddd7e9b53f7a2d4$var$_v0$2, $9ddd7e9b53f7a2d4$var$_v1$7, $9ddd7e9b53f7a2d4$var$_v2$4, $9ddd7e9b53f7a2d4$var$_extents)) return false;
        // finally testing the face normal of the triangle
        // use already existing triangle edge vectors here
        $9ddd7e9b53f7a2d4$var$_triangleNormal.crossVectors($9ddd7e9b53f7a2d4$var$_f0, $9ddd7e9b53f7a2d4$var$_f1);
        axes = [
            $9ddd7e9b53f7a2d4$var$_triangleNormal.x,
            $9ddd7e9b53f7a2d4$var$_triangleNormal.y,
            $9ddd7e9b53f7a2d4$var$_triangleNormal.z
        ];
        return $9ddd7e9b53f7a2d4$var$satForAxes(axes, $9ddd7e9b53f7a2d4$var$_v0$2, $9ddd7e9b53f7a2d4$var$_v1$7, $9ddd7e9b53f7a2d4$var$_v2$4, $9ddd7e9b53f7a2d4$var$_extents);
    }
    /**
	 * Clamps the given point within the bounds of this box.
	 *
	 * @param {Vector3} point - The point to clamp.
	 * @param {Vector3} target - The target vector that is used to store the method's result.
	 * @return {Vector3} The clamped point.
	 */ clampPoint(point, target) {
        return target.copy(point).clamp(this.min, this.max);
    }
    /**
	 * Returns the euclidean distance from any edge of this box to the specified point. If
	 * the given point lies inside of this box, the distance will be `0`.
	 *
	 * @param {Vector3} point - The point to compute the distance to.
	 * @return {number} The euclidean distance.
	 */ distanceToPoint(point) {
        return this.clampPoint(point, $9ddd7e9b53f7a2d4$var$_vector$b).distanceTo(point);
    }
    /**
	 * Returns a bounding sphere that encloses this bounding box.
	 *
	 * @param {Sphere} target - The target sphere that is used to store the method's result.
	 * @return {Sphere} The bounding sphere that encloses this bounding box.
	 */ getBoundingSphere(target) {
        if (this.isEmpty()) target.makeEmpty();
        else {
            this.getCenter(target.center);
            target.radius = this.getSize($9ddd7e9b53f7a2d4$var$_vector$b).length() * 0.5;
        }
        return target;
    }
    /**
	 * Computes the intersection of this bounding box and the given one, setting the upper
	 * bound of this box to the lesser of the two boxes' upper bounds and the
	 * lower bound of this box to the greater of the two boxes' lower bounds. If
	 * there's no overlap, makes this box empty.
	 *
	 * @param {Box3} box - The bounding box to intersect with.
	 * @return {Box3} A reference to this bounding box.
	 */ intersect(box) {
        this.min.max(box.min);
        this.max.min(box.max);
        // ensure that if there is no overlap, the result is fully empty, not slightly empty with non-inf/+inf values that will cause subsequence intersects to erroneously return valid values.
        if (this.isEmpty()) this.makeEmpty();
        return this;
    }
    /**
	 * Computes the union of this box and another and the given one, setting the upper
	 * bound of this box to the greater of the two boxes' upper bounds and the
	 * lower bound of this box to the lesser of the two boxes' lower bounds.
	 *
	 * @param {Box3} box - The bounding box that will be unioned with this instance.
	 * @return {Box3} A reference to this bounding box.
	 */ union(box) {
        this.min.min(box.min);
        this.max.max(box.max);
        return this;
    }
    /**
	 * Transforms this bounding box by the given 4x4 transformation matrix.
	 *
	 * @param {Matrix4} matrix - The transformation matrix.
	 * @return {Box3} A reference to this bounding box.
	 */ applyMatrix4(matrix) {
        // transform of empty box is an empty box.
        if (this.isEmpty()) return this;
        // NOTE: I am using a binary pattern to specify all 2^3 combinations below
        $9ddd7e9b53f7a2d4$var$_points[0].set(this.min.x, this.min.y, this.min.z).applyMatrix4(matrix); // 000
        $9ddd7e9b53f7a2d4$var$_points[1].set(this.min.x, this.min.y, this.max.z).applyMatrix4(matrix); // 001
        $9ddd7e9b53f7a2d4$var$_points[2].set(this.min.x, this.max.y, this.min.z).applyMatrix4(matrix); // 010
        $9ddd7e9b53f7a2d4$var$_points[3].set(this.min.x, this.max.y, this.max.z).applyMatrix4(matrix); // 011
        $9ddd7e9b53f7a2d4$var$_points[4].set(this.max.x, this.min.y, this.min.z).applyMatrix4(matrix); // 100
        $9ddd7e9b53f7a2d4$var$_points[5].set(this.max.x, this.min.y, this.max.z).applyMatrix4(matrix); // 101
        $9ddd7e9b53f7a2d4$var$_points[6].set(this.max.x, this.max.y, this.min.z).applyMatrix4(matrix); // 110
        $9ddd7e9b53f7a2d4$var$_points[7].set(this.max.x, this.max.y, this.max.z).applyMatrix4(matrix); // 111
        this.setFromPoints($9ddd7e9b53f7a2d4$var$_points);
        return this;
    }
    /**
	 * Adds the given offset to both the upper and lower bounds of this bounding box,
	 * effectively moving it in 3D space.
	 *
	 * @param {Vector3} offset - The offset that should be used to translate the bounding box.
	 * @return {Box3} A reference to this bounding box.
	 */ translate(offset) {
        this.min.add(offset);
        this.max.add(offset);
        return this;
    }
    /**
	 * Returns `true` if this bounding box is equal with the given one.
	 *
	 * @param {Box3} box - The box to test for equality.
	 * @return {boolean} Whether this bounding box is equal with the given one.
	 */ equals(box) {
        return box.min.equals(this.min) && box.max.equals(this.max);
    }
}
const $9ddd7e9b53f7a2d4$var$_points = [
    /*@__PURE__*/ new $9ddd7e9b53f7a2d4$export$64b5c384219d3699(),
    /*@__PURE__*/ new $9ddd7e9b53f7a2d4$export$64b5c384219d3699(),
    /*@__PURE__*/ new $9ddd7e9b53f7a2d4$export$64b5c384219d3699(),
    /*@__PURE__*/ new $9ddd7e9b53f7a2d4$export$64b5c384219d3699(),
    /*@__PURE__*/ new $9ddd7e9b53f7a2d4$export$64b5c384219d3699(),
    /*@__PURE__*/ new $9ddd7e9b53f7a2d4$export$64b5c384219d3699(),
    /*@__PURE__*/ new $9ddd7e9b53f7a2d4$export$64b5c384219d3699(),
    /*@__PURE__*/ new $9ddd7e9b53f7a2d4$export$64b5c384219d3699()
];
const $9ddd7e9b53f7a2d4$var$_vector$b = /*@__PURE__*/ new $9ddd7e9b53f7a2d4$export$64b5c384219d3699();
const $9ddd7e9b53f7a2d4$var$_box$4 = /*@__PURE__*/ new $9ddd7e9b53f7a2d4$export$6f7d5a9418ab2aa3();
// triangle centered vertices
const $9ddd7e9b53f7a2d4$var$_v0$2 = /*@__PURE__*/ new $9ddd7e9b53f7a2d4$export$64b5c384219d3699();
const $9ddd7e9b53f7a2d4$var$_v1$7 = /*@__PURE__*/ new $9ddd7e9b53f7a2d4$export$64b5c384219d3699();
const $9ddd7e9b53f7a2d4$var$_v2$4 = /*@__PURE__*/ new $9ddd7e9b53f7a2d4$export$64b5c384219d3699();
// triangle edge vectors
const $9ddd7e9b53f7a2d4$var$_f0 = /*@__PURE__*/ new $9ddd7e9b53f7a2d4$export$64b5c384219d3699();
const $9ddd7e9b53f7a2d4$var$_f1 = /*@__PURE__*/ new $9ddd7e9b53f7a2d4$export$64b5c384219d3699();
const $9ddd7e9b53f7a2d4$var$_f2 = /*@__PURE__*/ new $9ddd7e9b53f7a2d4$export$64b5c384219d3699();
const $9ddd7e9b53f7a2d4$var$_center = /*@__PURE__*/ new $9ddd7e9b53f7a2d4$export$64b5c384219d3699();
const $9ddd7e9b53f7a2d4$var$_extents = /*@__PURE__*/ new $9ddd7e9b53f7a2d4$export$64b5c384219d3699();
const $9ddd7e9b53f7a2d4$var$_triangleNormal = /*@__PURE__*/ new $9ddd7e9b53f7a2d4$export$64b5c384219d3699();
const $9ddd7e9b53f7a2d4$var$_testAxis = /*@__PURE__*/ new $9ddd7e9b53f7a2d4$export$64b5c384219d3699();
function $9ddd7e9b53f7a2d4$var$satForAxes(axes, v0, v1, v2, extents) {
    for(let i = 0, j = axes.length - 3; i <= j; i += 3){
        $9ddd7e9b53f7a2d4$var$_testAxis.fromArray(axes, i);
        // project the aabb onto the separating axis
        const r = extents.x * Math.abs($9ddd7e9b53f7a2d4$var$_testAxis.x) + extents.y * Math.abs($9ddd7e9b53f7a2d4$var$_testAxis.y) + extents.z * Math.abs($9ddd7e9b53f7a2d4$var$_testAxis.z);
        // project all 3 vertices of the triangle onto the separating axis
        const p0 = v0.dot($9ddd7e9b53f7a2d4$var$_testAxis);
        const p1 = v1.dot($9ddd7e9b53f7a2d4$var$_testAxis);
        const p2 = v2.dot($9ddd7e9b53f7a2d4$var$_testAxis);
        // actual test, basically see if either of the most extreme of the triangle points intersects r
        if (Math.max(-Math.max(p0, p1, p2), Math.min(p0, p1, p2)) > r) // points of the projected triangle are outside the projected half-length of the aabb
        // the axis is separating and we can exit
        return false;
    }
    return true;
}
const $9ddd7e9b53f7a2d4$var$_box$3 = /*@__PURE__*/ new $9ddd7e9b53f7a2d4$export$6f7d5a9418ab2aa3();
const $9ddd7e9b53f7a2d4$var$_v1$6 = /*@__PURE__*/ new $9ddd7e9b53f7a2d4$export$64b5c384219d3699();
const $9ddd7e9b53f7a2d4$var$_v2$3 = /*@__PURE__*/ new $9ddd7e9b53f7a2d4$export$64b5c384219d3699();
/**
 * An analytical 3D sphere defined by a center and radius. This class is mainly
 * used as a Bounding Sphere for 3D objects.
 */ class $9ddd7e9b53f7a2d4$export$805e8b72413ccaba {
    /**
	 * Constructs a new sphere.
	 *
	 * @param {Vector3} [center=(0,0,0)] - The center of the sphere
	 * @param {number} [radius=-1] - The radius of the sphere.
	 */ constructor(center = new $9ddd7e9b53f7a2d4$export$64b5c384219d3699(), radius = -1){
        /**
		 * This flag can be used for type testing.
		 *
		 * @type {boolean}
		 * @readonly
		 * @default true
		 */ this.isSphere = true;
        /**
		 * The center of the sphere
		 *
		 * @type {Vector3}
		 */ this.center = center;
        /**
		 * The radius of the sphere.
		 *
		 * @type {number}
		 */ this.radius = radius;
    }
    /**
	 * Sets the sphere's components by copying the given values.
	 *
	 * @param {Vector3} center - The center.
	 * @param {number} radius - The radius.
	 * @return {Sphere} A reference to this sphere.
	 */ set(center, radius) {
        this.center.copy(center);
        this.radius = radius;
        return this;
    }
    /**
	 * Computes the minimum bounding sphere for list of points.
	 * If the optional center point is given, it is used as the sphere's
	 * center. Otherwise, the center of the axis-aligned bounding box
	 * encompassing the points is calculated.
	 *
	 * @param {Array<Vector3>} points - A list of points in 3D space.
	 * @param {Vector3} [optionalCenter] - The center of the sphere.
	 * @return {Sphere} A reference to this sphere.
	 */ setFromPoints(points, optionalCenter) {
        const center = this.center;
        if (optionalCenter !== undefined) center.copy(optionalCenter);
        else $9ddd7e9b53f7a2d4$var$_box$3.setFromPoints(points).getCenter(center);
        let maxRadiusSq = 0;
        for(let i = 0, il = points.length; i < il; i++)maxRadiusSq = Math.max(maxRadiusSq, center.distanceToSquared(points[i]));
        this.radius = Math.sqrt(maxRadiusSq);
        return this;
    }
    /**
	 * Copies the values of the given sphere to this instance.
	 *
	 * @param {Sphere} sphere - The sphere to copy.
	 * @return {Sphere} A reference to this sphere.
	 */ copy(sphere) {
        this.center.copy(sphere.center);
        this.radius = sphere.radius;
        return this;
    }
    /**
	 * Returns `true` if the sphere is empty (the radius set to a negative number).
	 *
	 * Spheres with a radius of `0` contain only their center point and are not
	 * considered to be empty.
	 *
	 * @return {boolean} Whether this sphere is empty or not.
	 */ isEmpty() {
        return this.radius < 0;
    }
    /**
	 * Makes this sphere empty which means in encloses a zero space in 3D.
	 *
	 * @return {Sphere} A reference to this sphere.
	 */ makeEmpty() {
        this.center.set(0, 0, 0);
        this.radius = -1;
        return this;
    }
    /**
	 * Returns `true` if this sphere contains the given point inclusive of
	 * the surface of the sphere.
	 *
	 * @param {Vector3} point - The point to check.
	 * @return {boolean} Whether this sphere contains the given point or not.
	 */ containsPoint(point) {
        return point.distanceToSquared(this.center) <= this.radius * this.radius;
    }
    /**
	 * Returns the closest distance from the boundary of the sphere to the
	 * given point. If the sphere contains the point, the distance will
	 * be negative.
	 *
	 * @param {Vector3} point - The point to compute the distance to.
	 * @return {number} The distance to the point.
	 */ distanceToPoint(point) {
        return point.distanceTo(this.center) - this.radius;
    }
    /**
	 * Returns `true` if this sphere intersects with the given one.
	 *
	 * @param {Sphere} sphere - The sphere to test.
	 * @return {boolean} Whether this sphere intersects with the given one or not.
	 */ intersectsSphere(sphere) {
        const radiusSum = this.radius + sphere.radius;
        return sphere.center.distanceToSquared(this.center) <= radiusSum * radiusSum;
    }
    /**
	 * Returns `true` if this sphere intersects with the given box.
	 *
	 * @param {Box3} box - The box to test.
	 * @return {boolean} Whether this sphere intersects with the given box or not.
	 */ intersectsBox(box) {
        return box.intersectsSphere(this);
    }
    /**
	 * Returns `true` if this sphere intersects with the given plane.
	 *
	 * @param {Plane} plane - The plane to test.
	 * @return {boolean} Whether this sphere intersects with the given plane or not.
	 */ intersectsPlane(plane) {
        return Math.abs(plane.distanceToPoint(this.center)) <= this.radius;
    }
    /**
	 * Clamps a point within the sphere. If the point is outside the sphere, it
	 * will clamp it to the closest point on the edge of the sphere. Points
	 * already inside the sphere will not be affected.
	 *
	 * @param {Vector3} point - The plane to clamp.
	 * @param {Vector3} target - The target vector that is used to store the method's result.
	 * @return {Vector3} The clamped point.
	 */ clampPoint(point, target) {
        const deltaLengthSq = this.center.distanceToSquared(point);
        target.copy(point);
        if (deltaLengthSq > this.radius * this.radius) {
            target.sub(this.center).normalize();
            target.multiplyScalar(this.radius).add(this.center);
        }
        return target;
    }
    /**
	 * Returns a bounding box that encloses this sphere.
	 *
	 * @param {Box3} target - The target box that is used to store the method's result.
	 * @return {Box3} The bounding box that encloses this sphere.
	 */ getBoundingBox(target) {
        if (this.isEmpty()) {
            // Empty sphere produces empty bounding box
            target.makeEmpty();
            return target;
        }
        target.set(this.center, this.center);
        target.expandByScalar(this.radius);
        return target;
    }
    /**
	 * Transforms this sphere with the given 4x4 transformation matrix.
	 *
	 * @param {Matrix4} matrix - The transformation matrix.
	 * @return {Sphere} A reference to this sphere.
	 */ applyMatrix4(matrix) {
        this.center.applyMatrix4(matrix);
        this.radius = this.radius * matrix.getMaxScaleOnAxis();
        return this;
    }
    /**
	 * Translates the sphere's center by the given offset.
	 *
	 * @param {Vector3} offset - The offset.
	 * @return {Sphere} A reference to this sphere.
	 */ translate(offset) {
        this.center.add(offset);
        return this;
    }
    /**
	 * Expands the boundaries of this sphere to include the given point.
	 *
	 * @param {Vector3} point - The point to include.
	 * @return {Sphere} A reference to this sphere.
	 */ expandByPoint(point) {
        if (this.isEmpty()) {
            this.center.copy(point);
            this.radius = 0;
            return this;
        }
        $9ddd7e9b53f7a2d4$var$_v1$6.subVectors(point, this.center);
        const lengthSq = $9ddd7e9b53f7a2d4$var$_v1$6.lengthSq();
        if (lengthSq > this.radius * this.radius) {
            // calculate the minimal sphere
            const length = Math.sqrt(lengthSq);
            const delta = (length - this.radius) * 0.5;
            this.center.addScaledVector($9ddd7e9b53f7a2d4$var$_v1$6, delta / length);
            this.radius += delta;
        }
        return this;
    }
    /**
	 * Expands this sphere to enclose both the original sphere and the given sphere.
	 *
	 * @param {Sphere} sphere - The sphere to include.
	 * @return {Sphere} A reference to this sphere.
	 */ union(sphere) {
        if (sphere.isEmpty()) return this;
        if (this.isEmpty()) {
            this.copy(sphere);
            return this;
        }
        if (this.center.equals(sphere.center) === true) this.radius = Math.max(this.radius, sphere.radius);
        else {
            $9ddd7e9b53f7a2d4$var$_v2$3.subVectors(sphere.center, this.center).setLength(sphere.radius);
            this.expandByPoint($9ddd7e9b53f7a2d4$var$_v1$6.copy(sphere.center).add($9ddd7e9b53f7a2d4$var$_v2$3));
            this.expandByPoint($9ddd7e9b53f7a2d4$var$_v1$6.copy(sphere.center).sub($9ddd7e9b53f7a2d4$var$_v2$3));
        }
        return this;
    }
    /**
	 * Returns `true` if this sphere is equal with the given one.
	 *
	 * @param {Sphere} sphere - The sphere to test for equality.
	 * @return {boolean} Whether this bounding sphere is equal with the given one.
	 */ equals(sphere) {
        return sphere.center.equals(this.center) && sphere.radius === this.radius;
    }
    /**
	 * Returns a new sphere with copied values from this instance.
	 *
	 * @return {Sphere} A clone of this instance.
	 */ clone() {
        return new this.constructor().copy(this);
    }
}
const $9ddd7e9b53f7a2d4$var$_vector$a = /*@__PURE__*/ new $9ddd7e9b53f7a2d4$export$64b5c384219d3699();
const $9ddd7e9b53f7a2d4$var$_segCenter = /*@__PURE__*/ new $9ddd7e9b53f7a2d4$export$64b5c384219d3699();
const $9ddd7e9b53f7a2d4$var$_segDir = /*@__PURE__*/ new $9ddd7e9b53f7a2d4$export$64b5c384219d3699();
const $9ddd7e9b53f7a2d4$var$_diff = /*@__PURE__*/ new $9ddd7e9b53f7a2d4$export$64b5c384219d3699();
const $9ddd7e9b53f7a2d4$var$_edge1 = /*@__PURE__*/ new $9ddd7e9b53f7a2d4$export$64b5c384219d3699();
const $9ddd7e9b53f7a2d4$var$_edge2 = /*@__PURE__*/ new $9ddd7e9b53f7a2d4$export$64b5c384219d3699();
const $9ddd7e9b53f7a2d4$var$_normal$1 = /*@__PURE__*/ new $9ddd7e9b53f7a2d4$export$64b5c384219d3699();
/**
 * A ray that emits from an origin in a certain direction. The class is used by
 * {@link Raycaster} to assist with raycasting. Raycasting is used for
 * mouse picking (working out what objects in the 3D space the mouse is over)
 * amongst other things.
 */ class $9ddd7e9b53f7a2d4$export$a186db52eed6d40e {
    /**
	 * Constructs a new ray.
	 *
	 * @param {Vector3} [origin=(0,0,0)] - The origin of the ray.
	 * @param {Vector3} [direction=(0,0,-1)] - The (normalized) direction of the ray.
	 */ constructor(origin = new $9ddd7e9b53f7a2d4$export$64b5c384219d3699(), direction = new $9ddd7e9b53f7a2d4$export$64b5c384219d3699(0, 0, -1)){
        /**
		 * The origin of the ray.
		 *
		 * @type {Vector3}
		 */ this.origin = origin;
        /**
		 * The (normalized) direction of the ray.
		 *
		 * @type {Vector3}
		 */ this.direction = direction;
    }
    /**
	 * Sets the ray's components by copying the given values.
	 *
	 * @param {Vector3} origin - The origin.
	 * @param {Vector3} direction - The direction.
	 * @return {Ray} A reference to this ray.
	 */ set(origin, direction) {
        this.origin.copy(origin);
        this.direction.copy(direction);
        return this;
    }
    /**
	 * Copies the values of the given ray to this instance.
	 *
	 * @param {Ray} ray - The ray to copy.
	 * @return {Ray} A reference to this ray.
	 */ copy(ray) {
        this.origin.copy(ray.origin);
        this.direction.copy(ray.direction);
        return this;
    }
    /**
	 * Returns a vector that is located at a given distance along this ray.
	 *
	 * @param {number} t - The distance along the ray to retrieve a position for.
	 * @param {Vector3} target - The target vector that is used to store the method's result.
	 * @return {Vector3} A position on the ray.
	 */ at(t, target) {
        return target.copy(this.origin).addScaledVector(this.direction, t);
    }
    /**
	 * Adjusts the direction of the ray to point at the given vector in world space.
	 *
	 * @param {Vector3} v - The target position.
	 * @return {Ray} A reference to this ray.
	 */ lookAt(v) {
        this.direction.copy(v).sub(this.origin).normalize();
        return this;
    }
    /**
	 * Shift the origin of this ray along its direction by the given distance.
	 *
	 * @param {number} t - The distance along the ray to interpolate.
	 * @return {Ray} A reference to this ray.
	 */ recast(t) {
        this.origin.copy(this.at(t, $9ddd7e9b53f7a2d4$var$_vector$a));
        return this;
    }
    /**
	 * Returns the point along this ray that is closest to the given point.
	 *
	 * @param {Vector3} point - A point in 3D space to get the closet location on the ray for.
	 * @param {Vector3} target - The target vector that is used to store the method's result.
	 * @return {Vector3} The closest point on this ray.
	 */ closestPointToPoint(point, target) {
        target.subVectors(point, this.origin);
        const directionDistance = target.dot(this.direction);
        if (directionDistance < 0) return target.copy(this.origin);
        return target.copy(this.origin).addScaledVector(this.direction, directionDistance);
    }
    /**
	 * Returns the distance of the closest approach between this ray and the given point.
	 *
	 * @param {Vector3} point - A point in 3D space to compute the distance to.
	 * @return {number} The distance.
	 */ distanceToPoint(point) {
        return Math.sqrt(this.distanceSqToPoint(point));
    }
    /**
	 * Returns the squared distance of the closest approach between this ray and the given point.
	 *
	 * @param {Vector3} point - A point in 3D space to compute the distance to.
	 * @return {number} The squared distance.
	 */ distanceSqToPoint(point) {
        const directionDistance = $9ddd7e9b53f7a2d4$var$_vector$a.subVectors(point, this.origin).dot(this.direction);
        // point behind the ray
        if (directionDistance < 0) return this.origin.distanceToSquared(point);
        $9ddd7e9b53f7a2d4$var$_vector$a.copy(this.origin).addScaledVector(this.direction, directionDistance);
        return $9ddd7e9b53f7a2d4$var$_vector$a.distanceToSquared(point);
    }
    /**
	 * Returns the squared distance between this ray and the given line segment.
	 *
	 * @param {Vector3} v0 - The start point of the line segment.
	 * @param {Vector3} v1 - The end point of the line segment.
	 * @param {Vector3} [optionalPointOnRay] - When provided, it receives the point on this ray that is closest to the segment.
	 * @param {Vector3} [optionalPointOnSegment] - When provided, it receives the point on the line segment that is closest to this ray.
	 * @return {number} The squared distance.
	 */ distanceSqToSegment(v0, v1, optionalPointOnRay, optionalPointOnSegment) {
        // from https://github.com/pmjoniak/GeometricTools/blob/master/GTEngine/Include/Mathematics/GteDistRaySegment.h
        // It returns the min distance between the ray and the segment
        // defined by v0 and v1
        // It can also set two optional targets :
        // - The closest point on the ray
        // - The closest point on the segment
        $9ddd7e9b53f7a2d4$var$_segCenter.copy(v0).add(v1).multiplyScalar(0.5);
        $9ddd7e9b53f7a2d4$var$_segDir.copy(v1).sub(v0).normalize();
        $9ddd7e9b53f7a2d4$var$_diff.copy(this.origin).sub($9ddd7e9b53f7a2d4$var$_segCenter);
        const segExtent = v0.distanceTo(v1) * 0.5;
        const a01 = -this.direction.dot($9ddd7e9b53f7a2d4$var$_segDir);
        const b0 = $9ddd7e9b53f7a2d4$var$_diff.dot(this.direction);
        const b1 = -$9ddd7e9b53f7a2d4$var$_diff.dot($9ddd7e9b53f7a2d4$var$_segDir);
        const c = $9ddd7e9b53f7a2d4$var$_diff.lengthSq();
        const det = Math.abs(1 - a01 * a01);
        let s0, s1, sqrDist, extDet;
        if (det > 0) {
            // The ray and segment are not parallel.
            s0 = a01 * b1 - b0;
            s1 = a01 * b0 - b1;
            extDet = segExtent * det;
            if (s0 >= 0) {
                if (s1 >= -extDet) {
                    if (s1 <= extDet) {
                        // region 0
                        // Minimum at interior points of ray and segment.
                        const invDet = 1 / det;
                        s0 *= invDet;
                        s1 *= invDet;
                        sqrDist = s0 * (s0 + a01 * s1 + 2 * b0) + s1 * (a01 * s0 + s1 + 2 * b1) + c;
                    } else {
                        // region 1
                        s1 = segExtent;
                        s0 = Math.max(0, -(a01 * s1 + b0));
                        sqrDist = -s0 * s0 + s1 * (s1 + 2 * b1) + c;
                    }
                } else {
                    // region 5
                    s1 = -segExtent;
                    s0 = Math.max(0, -(a01 * s1 + b0));
                    sqrDist = -s0 * s0 + s1 * (s1 + 2 * b1) + c;
                }
            } else {
                if (s1 <= -extDet) {
                    // region 4
                    s0 = Math.max(0, -(-a01 * segExtent + b0));
                    s1 = s0 > 0 ? -segExtent : Math.min(Math.max(-segExtent, -b1), segExtent);
                    sqrDist = -s0 * s0 + s1 * (s1 + 2 * b1) + c;
                } else if (s1 <= extDet) {
                    // region 3
                    s0 = 0;
                    s1 = Math.min(Math.max(-segExtent, -b1), segExtent);
                    sqrDist = s1 * (s1 + 2 * b1) + c;
                } else {
                    // region 2
                    s0 = Math.max(0, -(a01 * segExtent + b0));
                    s1 = s0 > 0 ? segExtent : Math.min(Math.max(-segExtent, -b1), segExtent);
                    sqrDist = -s0 * s0 + s1 * (s1 + 2 * b1) + c;
                }
            }
        } else {
            // Ray and segment are parallel.
            s1 = a01 > 0 ? -segExtent : segExtent;
            s0 = Math.max(0, -(a01 * s1 + b0));
            sqrDist = -s0 * s0 + s1 * (s1 + 2 * b1) + c;
        }
        if (optionalPointOnRay) optionalPointOnRay.copy(this.origin).addScaledVector(this.direction, s0);
        if (optionalPointOnSegment) optionalPointOnSegment.copy($9ddd7e9b53f7a2d4$var$_segCenter).addScaledVector($9ddd7e9b53f7a2d4$var$_segDir, s1);
        return sqrDist;
    }
    /**
	 * Intersects this ray with the given sphere, returning the intersection
	 * point or `null` if there is no intersection.
	 *
	 * @param {Sphere} sphere - The sphere to intersect.
	 * @param {Vector3} target - The target vector that is used to store the method's result.
	 * @return {?Vector3} The intersection point.
	 */ intersectSphere(sphere, target) {
        $9ddd7e9b53f7a2d4$var$_vector$a.subVectors(sphere.center, this.origin);
        const tca = $9ddd7e9b53f7a2d4$var$_vector$a.dot(this.direction);
        const d2 = $9ddd7e9b53f7a2d4$var$_vector$a.dot($9ddd7e9b53f7a2d4$var$_vector$a) - tca * tca;
        const radius2 = sphere.radius * sphere.radius;
        if (d2 > radius2) return null;
        const thc = Math.sqrt(radius2 - d2);
        // t0 = first intersect point - entrance on front of sphere
        const t0 = tca - thc;
        // t1 = second intersect point - exit point on back of sphere
        const t1 = tca + thc;
        // test to see if t1 is behind the ray - if so, return null
        if (t1 < 0) return null;
        // test to see if t0 is behind the ray:
        // if it is, the ray is inside the sphere, so return the second exit point scaled by t1,
        // in order to always return an intersect point that is in front of the ray.
        if (t0 < 0) return this.at(t1, target);
        // else t0 is in front of the ray, so return the first collision point scaled by t0
        return this.at(t0, target);
    }
    /**
	 * Returns `true` if this ray intersects with the given sphere.
	 *
	 * @param {Sphere} sphere - The sphere to intersect.
	 * @return {boolean} Whether this ray intersects with the given sphere or not.
	 */ intersectsSphere(sphere) {
        return this.distanceSqToPoint(sphere.center) <= sphere.radius * sphere.radius;
    }
    /**
	 * Computes the distance from the ray's origin to the given plane. Returns `null` if the ray
	 * does not intersect with the plane.
	 *
	 * @param {Plane} plane - The plane to compute the distance to.
	 * @return {?number} Whether this ray intersects with the given sphere or not.
	 */ distanceToPlane(plane) {
        const denominator = plane.normal.dot(this.direction);
        if (denominator === 0) {
            // line is coplanar, return origin
            if (plane.distanceToPoint(this.origin) === 0) return 0;
            // Null is preferable to undefined since undefined means.... it is undefined
            return null;
        }
        const t = -(this.origin.dot(plane.normal) + plane.constant) / denominator;
        // Return if the ray never intersects the plane
        return t >= 0 ? t : null;
    }
    /**
	 * Intersects this ray with the given plane, returning the intersection
	 * point or `null` if there is no intersection.
	 *
	 * @param {Plane} plane - The plane to intersect.
	 * @param {Vector3} target - The target vector that is used to store the method's result.
	 * @return {?Vector3} The intersection point.
	 */ intersectPlane(plane, target) {
        const t = this.distanceToPlane(plane);
        if (t === null) return null;
        return this.at(t, target);
    }
    /**
	 * Returns `true` if this ray intersects with the given plane.
	 *
	 * @param {Plane} plane - The plane to intersect.
	 * @return {boolean} Whether this ray intersects with the given plane or not.
	 */ intersectsPlane(plane) {
        // check if the ray lies on the plane first
        const distToPoint = plane.distanceToPoint(this.origin);
        if (distToPoint === 0) return true;
        const denominator = plane.normal.dot(this.direction);
        if (denominator * distToPoint < 0) return true;
        // ray origin is behind the plane (and is pointing behind it)
        return false;
    }
    /**
	 * Intersects this ray with the given bounding box, returning the intersection
	 * point or `null` if there is no intersection.
	 *
	 * @param {Box3} box - The box to intersect.
	 * @param {Vector3} target - The target vector that is used to store the method's result.
	 * @return {?Vector3} The intersection point.
	 */ intersectBox(box, target) {
        let tmin, tmax, tymin, tymax, tzmin, tzmax;
        const invdirx = 1 / this.direction.x, invdiry = 1 / this.direction.y, invdirz = 1 / this.direction.z;
        const origin = this.origin;
        if (invdirx >= 0) {
            tmin = (box.min.x - origin.x) * invdirx;
            tmax = (box.max.x - origin.x) * invdirx;
        } else {
            tmin = (box.max.x - origin.x) * invdirx;
            tmax = (box.min.x - origin.x) * invdirx;
        }
        if (invdiry >= 0) {
            tymin = (box.min.y - origin.y) * invdiry;
            tymax = (box.max.y - origin.y) * invdiry;
        } else {
            tymin = (box.max.y - origin.y) * invdiry;
            tymax = (box.min.y - origin.y) * invdiry;
        }
        if (tmin > tymax || tymin > tmax) return null;
        if (tymin > tmin || isNaN(tmin)) tmin = tymin;
        if (tymax < tmax || isNaN(tmax)) tmax = tymax;
        if (invdirz >= 0) {
            tzmin = (box.min.z - origin.z) * invdirz;
            tzmax = (box.max.z - origin.z) * invdirz;
        } else {
            tzmin = (box.max.z - origin.z) * invdirz;
            tzmax = (box.min.z - origin.z) * invdirz;
        }
        if (tmin > tzmax || tzmin > tmax) return null;
        if (tzmin > tmin || tmin !== tmin) tmin = tzmin;
        if (tzmax < tmax || tmax !== tmax) tmax = tzmax;
        //return point closest to the ray (positive side)
        if (tmax < 0) return null;
        return this.at(tmin >= 0 ? tmin : tmax, target);
    }
    /**
	 * Returns `true` if this ray intersects with the given box.
	 *
	 * @param {Box3} box - The box to intersect.
	 * @return {boolean} Whether this ray intersects with the given box or not.
	 */ intersectsBox(box) {
        return this.intersectBox(box, $9ddd7e9b53f7a2d4$var$_vector$a) !== null;
    }
    /**
	 * Intersects this ray with the given triangle, returning the intersection
	 * point or `null` if there is no intersection.
	 *
	 * @param {Vector3} a - The first vertex of the triangle.
	 * @param {Vector3} b - The second vertex of the triangle.
	 * @param {Vector3} c - The third vertex of the triangle.
	 * @param {boolean} backfaceCulling - Whether to use backface culling or not.
	 * @param {Vector3} target - The target vector that is used to store the method's result.
	 * @return {?Vector3} The intersection point.
	 */ intersectTriangle(a, b, c, backfaceCulling, target) {
        // Compute the offset origin, edges, and normal.
        // from https://github.com/pmjoniak/GeometricTools/blob/master/GTEngine/Include/Mathematics/GteIntrRay3Triangle3.h
        $9ddd7e9b53f7a2d4$var$_edge1.subVectors(b, a);
        $9ddd7e9b53f7a2d4$var$_edge2.subVectors(c, a);
        $9ddd7e9b53f7a2d4$var$_normal$1.crossVectors($9ddd7e9b53f7a2d4$var$_edge1, $9ddd7e9b53f7a2d4$var$_edge2);
        // Solve Q + t*D = b1*E1 + b2*E2 (Q = kDiff, D = ray direction,
        // E1 = kEdge1, E2 = kEdge2, N = Cross(E1,E2)) by
        //   |Dot(D,N)|*b1 = sign(Dot(D,N))*Dot(D,Cross(Q,E2))
        //   |Dot(D,N)|*b2 = sign(Dot(D,N))*Dot(D,Cross(E1,Q))
        //   |Dot(D,N)|*t = -sign(Dot(D,N))*Dot(Q,N)
        let DdN = this.direction.dot($9ddd7e9b53f7a2d4$var$_normal$1);
        let sign;
        if (DdN > 0) {
            if (backfaceCulling) return null;
            sign = 1;
        } else if (DdN < 0) {
            sign = -1;
            DdN = -DdN;
        } else return null;
        $9ddd7e9b53f7a2d4$var$_diff.subVectors(this.origin, a);
        const DdQxE2 = sign * this.direction.dot($9ddd7e9b53f7a2d4$var$_edge2.crossVectors($9ddd7e9b53f7a2d4$var$_diff, $9ddd7e9b53f7a2d4$var$_edge2));
        // b1 < 0, no intersection
        if (DdQxE2 < 0) return null;
        const DdE1xQ = sign * this.direction.dot($9ddd7e9b53f7a2d4$var$_edge1.cross($9ddd7e9b53f7a2d4$var$_diff));
        // b2 < 0, no intersection
        if (DdE1xQ < 0) return null;
        // b1+b2 > 1, no intersection
        if (DdQxE2 + DdE1xQ > DdN) return null;
        // Line intersects triangle, check if ray does.
        const QdN = -sign * $9ddd7e9b53f7a2d4$var$_diff.dot($9ddd7e9b53f7a2d4$var$_normal$1);
        // t < 0, no intersection
        if (QdN < 0) return null;
        // Ray intersects triangle.
        return this.at(QdN / DdN, target);
    }
    /**
	 * Transforms this ray with the given 4x4 transformation matrix.
	 *
	 * @param {Matrix4} matrix4 - The transformation matrix.
	 * @return {Ray} A reference to this ray.
	 */ applyMatrix4(matrix4) {
        this.origin.applyMatrix4(matrix4);
        this.direction.transformDirection(matrix4);
        return this;
    }
    /**
	 * Returns `true` if this ray is equal with the given one.
	 *
	 * @param {Ray} ray - The ray to test for equality.
	 * @return {boolean} Whether this ray is equal with the given one.
	 */ equals(ray) {
        return ray.origin.equals(this.origin) && ray.direction.equals(this.direction);
    }
    /**
	 * Returns a new ray with copied values from this instance.
	 *
	 * @return {Ray} A clone of this instance.
	 */ clone() {
        return new this.constructor().copy(this);
    }
}
/**
 * Represents a 4x4 matrix.
 *
 * The most common use of a 4x4 matrix in 3D computer graphics is as a transformation matrix.
 * For an introduction to transformation matrices as used in WebGL, check out [this tutorial]{@link https://www.opengl-tutorial.org/beginners-tutorials/tutorial-3-matrices}
 *
 * This allows a 3D vector representing a point in 3D space to undergo
 * transformations such as translation, rotation, shear, scale, reflection,
 * orthogonal or perspective projection and so on, by being multiplied by the
 * matrix. This is known as `applying` the matrix to the vector.
 *
 * A Note on Row-Major and Column-Major Ordering:
 *
 * The constructor and {@link Matrix3#set} method take arguments in
 * [row-major]{@link https://en.wikipedia.org/wiki/Row-_and_column-major_order#Column-major_order}
 * order, while internally they are stored in the {@link Matrix3#elements} array in column-major order.
 * This means that calling:
 * ```js
 * const m = new THREE.Matrix4();
 * m.set( 11, 12, 13, 14,
 *        21, 22, 23, 24,
 *        31, 32, 33, 34,
 *        41, 42, 43, 44 );
 * ```
 * will result in the elements array containing:
 * ```js
 * m.elements = [ 11, 21, 31, 41,
 *                12, 22, 32, 42,
 *                13, 23, 33, 43,
 *                14, 24, 34, 44 ];
 * ```
 * and internally all calculations are performed using column-major ordering.
 * However, as the actual ordering makes no difference mathematically and
 * most people are used to thinking about matrices in row-major order, the
 * three.js documentation shows matrices in row-major order. Just bear in
 * mind that if you are reading the source code, you'll have to take the
 * transpose of any matrices outlined here to make sense of the calculations.
 */ class $9ddd7e9b53f7a2d4$export$2ae72fc923e5eb5 {
    /**
	 * Constructs a new 4x4 matrix. The arguments are supposed to be
	 * in row-major order. If no arguments are provided, the constructor
	 * initializes the matrix as an identity matrix.
	 *
	 * @param {number} [n11] - 1-1 matrix element.
	 * @param {number} [n12] - 1-2 matrix element.
	 * @param {number} [n13] - 1-3 matrix element.
	 * @param {number} [n14] - 1-4 matrix element.
	 * @param {number} [n21] - 2-1 matrix element.
	 * @param {number} [n22] - 2-2 matrix element.
	 * @param {number} [n23] - 2-3 matrix element.
	 * @param {number} [n24] - 2-4 matrix element.
	 * @param {number} [n31] - 3-1 matrix element.
	 * @param {number} [n32] - 3-2 matrix element.
	 * @param {number} [n33] - 3-3 matrix element.
	 * @param {number} [n34] - 3-4 matrix element.
	 * @param {number} [n41] - 4-1 matrix element.
	 * @param {number} [n42] - 4-2 matrix element.
	 * @param {number} [n43] - 4-3 matrix element.
	 * @param {number} [n44] - 4-4 matrix element.
	 */ constructor(n11, n12, n13, n14, n21, n22, n23, n24, n31, n32, n33, n34, n41, n42, n43, n44){
        /**
		 * This flag can be used for type testing.
		 *
		 * @type {boolean}
		 * @readonly
		 * @default true
		 */ $9ddd7e9b53f7a2d4$export$2ae72fc923e5eb5.prototype.isMatrix4 = true;
        /**
		 * A column-major list of matrix values.
		 *
		 * @type {Array<number>}
		 */ this.elements = [
            1,
            0,
            0,
            0,
            0,
            1,
            0,
            0,
            0,
            0,
            1,
            0,
            0,
            0,
            0,
            1
        ];
        if (n11 !== undefined) this.set(n11, n12, n13, n14, n21, n22, n23, n24, n31, n32, n33, n34, n41, n42, n43, n44);
    }
    /**
	 * Sets the elements of the matrix.The arguments are supposed to be
	 * in row-major order.
	 *
	 * @param {number} [n11] - 1-1 matrix element.
	 * @param {number} [n12] - 1-2 matrix element.
	 * @param {number} [n13] - 1-3 matrix element.
	 * @param {number} [n14] - 1-4 matrix element.
	 * @param {number} [n21] - 2-1 matrix element.
	 * @param {number} [n22] - 2-2 matrix element.
	 * @param {number} [n23] - 2-3 matrix element.
	 * @param {number} [n24] - 2-4 matrix element.
	 * @param {number} [n31] - 3-1 matrix element.
	 * @param {number} [n32] - 3-2 matrix element.
	 * @param {number} [n33] - 3-3 matrix element.
	 * @param {number} [n34] - 3-4 matrix element.
	 * @param {number} [n41] - 4-1 matrix element.
	 * @param {number} [n42] - 4-2 matrix element.
	 * @param {number} [n43] - 4-3 matrix element.
	 * @param {number} [n44] - 4-4 matrix element.
	 * @return {Matrix4} A reference to this matrix.
	 */ set(n11, n12, n13, n14, n21, n22, n23, n24, n31, n32, n33, n34, n41, n42, n43, n44) {
        const te = this.elements;
        te[0] = n11;
        te[4] = n12;
        te[8] = n13;
        te[12] = n14;
        te[1] = n21;
        te[5] = n22;
        te[9] = n23;
        te[13] = n24;
        te[2] = n31;
        te[6] = n32;
        te[10] = n33;
        te[14] = n34;
        te[3] = n41;
        te[7] = n42;
        te[11] = n43;
        te[15] = n44;
        return this;
    }
    /**
	 * Sets this matrix to the 4x4 identity matrix.
	 *
	 * @return {Matrix4} A reference to this matrix.
	 */ identity() {
        this.set(1, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1);
        return this;
    }
    /**
	 * Returns a matrix with copied values from this instance.
	 *
	 * @return {Matrix4} A clone of this instance.
	 */ clone() {
        return new $9ddd7e9b53f7a2d4$export$2ae72fc923e5eb5().fromArray(this.elements);
    }
    /**
	 * Copies the values of the given matrix to this instance.
	 *
	 * @param {Matrix4} m - The matrix to copy.
	 * @return {Matrix4} A reference to this matrix.
	 */ copy(m) {
        const te = this.elements;
        const me = m.elements;
        te[0] = me[0];
        te[1] = me[1];
        te[2] = me[2];
        te[3] = me[3];
        te[4] = me[4];
        te[5] = me[5];
        te[6] = me[6];
        te[7] = me[7];
        te[8] = me[8];
        te[9] = me[9];
        te[10] = me[10];
        te[11] = me[11];
        te[12] = me[12];
        te[13] = me[13];
        te[14] = me[14];
        te[15] = me[15];
        return this;
    }
    /**
	 * Copies the translation component of the given matrix
	 * into this matrix's translation component.
	 *
	 * @param {Matrix4} m - The matrix to copy the translation component.
	 * @return {Matrix4} A reference to this matrix.
	 */ copyPosition(m) {
        const te = this.elements, me = m.elements;
        te[12] = me[12];
        te[13] = me[13];
        te[14] = me[14];
        return this;
    }
    /**
	 * Set the upper 3x3 elements of this matrix to the values of given 3x3 matrix.
	 *
	 * @param {Matrix3} m - The 3x3 matrix.
	 * @return {Matrix4} A reference to this matrix.
	 */ setFromMatrix3(m) {
        const me = m.elements;
        this.set(me[0], me[3], me[6], 0, me[1], me[4], me[7], 0, me[2], me[5], me[8], 0, 0, 0, 0, 1);
        return this;
    }
    /**
	 * Extracts the basis of this matrix into the three axis vectors provided.
	 *
	 * @param {Vector3} xAxis - The basis's x axis.
	 * @param {Vector3} yAxis - The basis's y axis.
	 * @param {Vector3} zAxis - The basis's z axis.
	 * @return {Matrix4} A reference to this matrix.
	 */ extractBasis(xAxis, yAxis, zAxis) {
        xAxis.setFromMatrixColumn(this, 0);
        yAxis.setFromMatrixColumn(this, 1);
        zAxis.setFromMatrixColumn(this, 2);
        return this;
    }
    /**
	 * Sets the given basis vectors to this matrix.
	 *
	 * @param {Vector3} xAxis - The basis's x axis.
	 * @param {Vector3} yAxis - The basis's y axis.
	 * @param {Vector3} zAxis - The basis's z axis.
	 * @return {Matrix4} A reference to this matrix.
	 */ makeBasis(xAxis, yAxis, zAxis) {
        this.set(xAxis.x, yAxis.x, zAxis.x, 0, xAxis.y, yAxis.y, zAxis.y, 0, xAxis.z, yAxis.z, zAxis.z, 0, 0, 0, 0, 1);
        return this;
    }
    /**
	 * Extracts the rotation component of the given matrix
	 * into this matrix's rotation component.
	 *
	 * Note: This method does not support reflection matrices.
	 *
	 * @param {Matrix4} m - The matrix.
	 * @return {Matrix4} A reference to this matrix.
	 */ extractRotation(m) {
        const te = this.elements;
        const me = m.elements;
        const scaleX = 1 / $9ddd7e9b53f7a2d4$var$_v1$5.setFromMatrixColumn(m, 0).length();
        const scaleY = 1 / $9ddd7e9b53f7a2d4$var$_v1$5.setFromMatrixColumn(m, 1).length();
        const scaleZ = 1 / $9ddd7e9b53f7a2d4$var$_v1$5.setFromMatrixColumn(m, 2).length();
        te[0] = me[0] * scaleX;
        te[1] = me[1] * scaleX;
        te[2] = me[2] * scaleX;
        te[3] = 0;
        te[4] = me[4] * scaleY;
        te[5] = me[5] * scaleY;
        te[6] = me[6] * scaleY;
        te[7] = 0;
        te[8] = me[8] * scaleZ;
        te[9] = me[9] * scaleZ;
        te[10] = me[10] * scaleZ;
        te[11] = 0;
        te[12] = 0;
        te[13] = 0;
        te[14] = 0;
        te[15] = 1;
        return this;
    }
    /**
	 * Sets the rotation component (the upper left 3x3 matrix) of this matrix to
	 * the rotation specified by the given Euler angles. The rest of
	 * the matrix is set to the identity. Depending on the {@link Euler#order},
	 * there are six possible outcomes. See [this page]{@link https://en.wikipedia.org/wiki/Euler_angles#Rotation_matrix}
	 * for a complete list.
	 *
	 * @param {Euler} euler - The Euler angles.
	 * @return {Matrix4} A reference to this matrix.
	 */ makeRotationFromEuler(euler) {
        const te = this.elements;
        const x = euler.x, y = euler.y, z = euler.z;
        const a = Math.cos(x), b = Math.sin(x);
        const c = Math.cos(y), d = Math.sin(y);
        const e = Math.cos(z), f = Math.sin(z);
        if (euler.order === 'XYZ') {
            const ae = a * e, af = a * f, be = b * e, bf = b * f;
            te[0] = c * e;
            te[4] = -c * f;
            te[8] = d;
            te[1] = af + be * d;
            te[5] = ae - bf * d;
            te[9] = -b * c;
            te[2] = bf - ae * d;
            te[6] = be + af * d;
            te[10] = a * c;
        } else if (euler.order === 'YXZ') {
            const ce = c * e, cf = c * f, de = d * e, df = d * f;
            te[0] = ce + df * b;
            te[4] = de * b - cf;
            te[8] = a * d;
            te[1] = a * f;
            te[5] = a * e;
            te[9] = -b;
            te[2] = cf * b - de;
            te[6] = df + ce * b;
            te[10] = a * c;
        } else if (euler.order === 'ZXY') {
            const ce = c * e, cf = c * f, de = d * e, df = d * f;
            te[0] = ce - df * b;
            te[4] = -a * f;
            te[8] = de + cf * b;
            te[1] = cf + de * b;
            te[5] = a * e;
            te[9] = df - ce * b;
            te[2] = -a * d;
            te[6] = b;
            te[10] = a * c;
        } else if (euler.order === 'ZYX') {
            const ae = a * e, af = a * f, be = b * e, bf = b * f;
            te[0] = c * e;
            te[4] = be * d - af;
            te[8] = ae * d + bf;
            te[1] = c * f;
            te[5] = bf * d + ae;
            te[9] = af * d - be;
            te[2] = -d;
            te[6] = b * c;
            te[10] = a * c;
        } else if (euler.order === 'YZX') {
            const ac = a * c, ad = a * d, bc = b * c, bd = b * d;
            te[0] = c * e;
            te[4] = bd - ac * f;
            te[8] = bc * f + ad;
            te[1] = f;
            te[5] = a * e;
            te[9] = -b * e;
            te[2] = -d * e;
            te[6] = ad * f + bc;
            te[10] = ac - bd * f;
        } else if (euler.order === 'XZY') {
            const ac = a * c, ad = a * d, bc = b * c, bd = b * d;
            te[0] = c * e;
            te[4] = -f;
            te[8] = d * e;
            te[1] = ac * f + bd;
            te[5] = a * e;
            te[9] = ad * f - bc;
            te[2] = bc * f - ad;
            te[6] = b * e;
            te[10] = bd * f + ac;
        }
        // bottom row
        te[3] = 0;
        te[7] = 0;
        te[11] = 0;
        // last column
        te[12] = 0;
        te[13] = 0;
        te[14] = 0;
        te[15] = 1;
        return this;
    }
    /**
	 * Sets the rotation component of this matrix to the rotation specified by
	 * the given Quaternion as outlined [here]{@link https://en.wikipedia.org/wiki/Rotation_matrix#Quaternion}
	 * The rest of the matrix is set to the identity.
	 *
	 * @param {Quaternion} q - The Quaternion.
	 * @return {Matrix4} A reference to this matrix.
	 */ makeRotationFromQuaternion(q) {
        return this.compose($9ddd7e9b53f7a2d4$var$_zero, q, $9ddd7e9b53f7a2d4$var$_one);
    }
    /**
	 * Sets the rotation component of the transformation matrix, looking from `eye` towards
	 * `target`, and oriented by the up-direction.
	 *
	 * @param {Vector3} eye - The eye vector.
	 * @param {Vector3} target - The target vector.
	 * @param {Vector3} up - The up vector.
	 * @return {Matrix4} A reference to this matrix.
	 */ lookAt(eye, target, up) {
        const te = this.elements;
        $9ddd7e9b53f7a2d4$var$_z.subVectors(eye, target);
        if ($9ddd7e9b53f7a2d4$var$_z.lengthSq() === 0) // eye and target are in the same position
        $9ddd7e9b53f7a2d4$var$_z.z = 1;
        $9ddd7e9b53f7a2d4$var$_z.normalize();
        $9ddd7e9b53f7a2d4$var$_x.crossVectors(up, $9ddd7e9b53f7a2d4$var$_z);
        if ($9ddd7e9b53f7a2d4$var$_x.lengthSq() === 0) {
            // up and z are parallel
            if (Math.abs(up.z) === 1) $9ddd7e9b53f7a2d4$var$_z.x += 0.0001;
            else $9ddd7e9b53f7a2d4$var$_z.z += 0.0001;
            $9ddd7e9b53f7a2d4$var$_z.normalize();
            $9ddd7e9b53f7a2d4$var$_x.crossVectors(up, $9ddd7e9b53f7a2d4$var$_z);
        }
        $9ddd7e9b53f7a2d4$var$_x.normalize();
        $9ddd7e9b53f7a2d4$var$_y.crossVectors($9ddd7e9b53f7a2d4$var$_z, $9ddd7e9b53f7a2d4$var$_x);
        te[0] = $9ddd7e9b53f7a2d4$var$_x.x;
        te[4] = $9ddd7e9b53f7a2d4$var$_y.x;
        te[8] = $9ddd7e9b53f7a2d4$var$_z.x;
        te[1] = $9ddd7e9b53f7a2d4$var$_x.y;
        te[5] = $9ddd7e9b53f7a2d4$var$_y.y;
        te[9] = $9ddd7e9b53f7a2d4$var$_z.y;
        te[2] = $9ddd7e9b53f7a2d4$var$_x.z;
        te[6] = $9ddd7e9b53f7a2d4$var$_y.z;
        te[10] = $9ddd7e9b53f7a2d4$var$_z.z;
        return this;
    }
    /**
	 * Post-multiplies this matrix by the given 4x4 matrix.
	 *
	 * @param {Matrix4} m - The matrix to multiply with.
	 * @return {Matrix4} A reference to this matrix.
	 */ multiply(m) {
        return this.multiplyMatrices(this, m);
    }
    /**
	 * Pre-multiplies this matrix by the given 4x4 matrix.
	 *
	 * @param {Matrix4} m - The matrix to multiply with.
	 * @return {Matrix4} A reference to this matrix.
	 */ premultiply(m) {
        return this.multiplyMatrices(m, this);
    }
    /**
	 * Multiples the given 4x4 matrices and stores the result
	 * in this matrix.
	 *
	 * @param {Matrix4} a - The first matrix.
	 * @param {Matrix4} b - The second matrix.
	 * @return {Matrix4} A reference to this matrix.
	 */ multiplyMatrices(a, b) {
        const ae = a.elements;
        const be = b.elements;
        const te = this.elements;
        const a11 = ae[0], a12 = ae[4], a13 = ae[8], a14 = ae[12];
        const a21 = ae[1], a22 = ae[5], a23 = ae[9], a24 = ae[13];
        const a31 = ae[2], a32 = ae[6], a33 = ae[10], a34 = ae[14];
        const a41 = ae[3], a42 = ae[7], a43 = ae[11], a44 = ae[15];
        const b11 = be[0], b12 = be[4], b13 = be[8], b14 = be[12];
        const b21 = be[1], b22 = be[5], b23 = be[9], b24 = be[13];
        const b31 = be[2], b32 = be[6], b33 = be[10], b34 = be[14];
        const b41 = be[3], b42 = be[7], b43 = be[11], b44 = be[15];
        te[0] = a11 * b11 + a12 * b21 + a13 * b31 + a14 * b41;
        te[4] = a11 * b12 + a12 * b22 + a13 * b32 + a14 * b42;
        te[8] = a11 * b13 + a12 * b23 + a13 * b33 + a14 * b43;
        te[12] = a11 * b14 + a12 * b24 + a13 * b34 + a14 * b44;
        te[1] = a21 * b11 + a22 * b21 + a23 * b31 + a24 * b41;
        te[5] = a21 * b12 + a22 * b22 + a23 * b32 + a24 * b42;
        te[9] = a21 * b13 + a22 * b23 + a23 * b33 + a24 * b43;
        te[13] = a21 * b14 + a22 * b24 + a23 * b34 + a24 * b44;
        te[2] = a31 * b11 + a32 * b21 + a33 * b31 + a34 * b41;
        te[6] = a31 * b12 + a32 * b22 + a33 * b32 + a34 * b42;
        te[10] = a31 * b13 + a32 * b23 + a33 * b33 + a34 * b43;
        te[14] = a31 * b14 + a32 * b24 + a33 * b34 + a34 * b44;
        te[3] = a41 * b11 + a42 * b21 + a43 * b31 + a44 * b41;
        te[7] = a41 * b12 + a42 * b22 + a43 * b32 + a44 * b42;
        te[11] = a41 * b13 + a42 * b23 + a43 * b33 + a44 * b43;
        te[15] = a41 * b14 + a42 * b24 + a43 * b34 + a44 * b44;
        return this;
    }
    /**
	 * Multiplies every component of the matrix by the given scalar.
	 *
	 * @param {number} s - The scalar.
	 * @return {Matrix4} A reference to this matrix.
	 */ multiplyScalar(s) {
        const te = this.elements;
        te[0] *= s;
        te[4] *= s;
        te[8] *= s;
        te[12] *= s;
        te[1] *= s;
        te[5] *= s;
        te[9] *= s;
        te[13] *= s;
        te[2] *= s;
        te[6] *= s;
        te[10] *= s;
        te[14] *= s;
        te[3] *= s;
        te[7] *= s;
        te[11] *= s;
        te[15] *= s;
        return this;
    }
    /**
	 * Computes and returns the determinant of this matrix.
	 *
	 * Based on the method outlined [here]{@link http://www.euclideanspace.com/maths/algebra/matrix/functions/inverse/fourD/index.html}.
	 *
	 * @return {number} The determinant.
	 */ determinant() {
        const te = this.elements;
        const n11 = te[0], n12 = te[4], n13 = te[8], n14 = te[12];
        const n21 = te[1], n22 = te[5], n23 = te[9], n24 = te[13];
        const n31 = te[2], n32 = te[6], n33 = te[10], n34 = te[14];
        const n41 = te[3], n42 = te[7], n43 = te[11], n44 = te[15];
        //TODO: make this more efficient
        return n41 * (+n14 * n23 * n32 - n13 * n24 * n32 - n14 * n22 * n33 + n12 * n24 * n33 + n13 * n22 * n34 - n12 * n23 * n34) + n42 * (+n11 * n23 * n34 - n11 * n24 * n33 + n14 * n21 * n33 - n13 * n21 * n34 + n13 * n24 * n31 - n14 * n23 * n31) + n43 * (+n11 * n24 * n32 - n11 * n22 * n34 - n14 * n21 * n32 + n12 * n21 * n34 + n14 * n22 * n31 - n12 * n24 * n31) + n44 * (-n13 * n22 * n31 - n11 * n23 * n32 + n11 * n22 * n33 + n13 * n21 * n32 - n12 * n21 * n33 + n12 * n23 * n31);
    }
    /**
	 * Transposes this matrix in place.
	 *
	 * @return {Matrix4} A reference to this matrix.
	 */ transpose() {
        const te = this.elements;
        let tmp;
        tmp = te[1];
        te[1] = te[4];
        te[4] = tmp;
        tmp = te[2];
        te[2] = te[8];
        te[8] = tmp;
        tmp = te[6];
        te[6] = te[9];
        te[9] = tmp;
        tmp = te[3];
        te[3] = te[12];
        te[12] = tmp;
        tmp = te[7];
        te[7] = te[13];
        te[13] = tmp;
        tmp = te[11];
        te[11] = te[14];
        te[14] = tmp;
        return this;
    }
    /**
	 * Sets the position component for this matrix from the given vector,
	 * without affecting the rest of the matrix.
	 *
	 * @param {number|Vector3} x - The x component of the vector or alternatively the vector object.
	 * @param {number} y - The y component of the vector.
	 * @param {number} z - The z component of the vector.
	 * @return {Matrix4} A reference to this matrix.
	 */ setPosition(x, y, z) {
        const te = this.elements;
        if (x.isVector3) {
            te[12] = x.x;
            te[13] = x.y;
            te[14] = x.z;
        } else {
            te[12] = x;
            te[13] = y;
            te[14] = z;
        }
        return this;
    }
    /**
	 * Inverts this matrix, using the [analytic method]{@link https://en.wikipedia.org/wiki/Invertible_matrix#Analytic_solution}.
	 * You can not invert with a determinant of zero. If you attempt this, the method produces
	 * a zero matrix instead.
	 *
	 * @return {Matrix4} A reference to this matrix.
	 */ invert() {
        // based on http://www.euclideanspace.com/maths/algebra/matrix/functions/inverse/fourD/index.htm
        const te = this.elements, n11 = te[0], n21 = te[1], n31 = te[2], n41 = te[3], n12 = te[4], n22 = te[5], n32 = te[6], n42 = te[7], n13 = te[8], n23 = te[9], n33 = te[10], n43 = te[11], n14 = te[12], n24 = te[13], n34 = te[14], n44 = te[15], t11 = n23 * n34 * n42 - n24 * n33 * n42 + n24 * n32 * n43 - n22 * n34 * n43 - n23 * n32 * n44 + n22 * n33 * n44, t12 = n14 * n33 * n42 - n13 * n34 * n42 - n14 * n32 * n43 + n12 * n34 * n43 + n13 * n32 * n44 - n12 * n33 * n44, t13 = n13 * n24 * n42 - n14 * n23 * n42 + n14 * n22 * n43 - n12 * n24 * n43 - n13 * n22 * n44 + n12 * n23 * n44, t14 = n14 * n23 * n32 - n13 * n24 * n32 - n14 * n22 * n33 + n12 * n24 * n33 + n13 * n22 * n34 - n12 * n23 * n34;
        const det = n11 * t11 + n21 * t12 + n31 * t13 + n41 * t14;
        if (det === 0) return this.set(0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0);
        const detInv = 1 / det;
        te[0] = t11 * detInv;
        te[1] = (n24 * n33 * n41 - n23 * n34 * n41 - n24 * n31 * n43 + n21 * n34 * n43 + n23 * n31 * n44 - n21 * n33 * n44) * detInv;
        te[2] = (n22 * n34 * n41 - n24 * n32 * n41 + n24 * n31 * n42 - n21 * n34 * n42 - n22 * n31 * n44 + n21 * n32 * n44) * detInv;
        te[3] = (n23 * n32 * n41 - n22 * n33 * n41 - n23 * n31 * n42 + n21 * n33 * n42 + n22 * n31 * n43 - n21 * n32 * n43) * detInv;
        te[4] = t12 * detInv;
        te[5] = (n13 * n34 * n41 - n14 * n33 * n41 + n14 * n31 * n43 - n11 * n34 * n43 - n13 * n31 * n44 + n11 * n33 * n44) * detInv;
        te[6] = (n14 * n32 * n41 - n12 * n34 * n41 - n14 * n31 * n42 + n11 * n34 * n42 + n12 * n31 * n44 - n11 * n32 * n44) * detInv;
        te[7] = (n12 * n33 * n41 - n13 * n32 * n41 + n13 * n31 * n42 - n11 * n33 * n42 - n12 * n31 * n43 + n11 * n32 * n43) * detInv;
        te[8] = t13 * detInv;
        te[9] = (n14 * n23 * n41 - n13 * n24 * n41 - n14 * n21 * n43 + n11 * n24 * n43 + n13 * n21 * n44 - n11 * n23 * n44) * detInv;
        te[10] = (n12 * n24 * n41 - n14 * n22 * n41 + n14 * n21 * n42 - n11 * n24 * n42 - n12 * n21 * n44 + n11 * n22 * n44) * detInv;
        te[11] = (n13 * n22 * n41 - n12 * n23 * n41 - n13 * n21 * n42 + n11 * n23 * n42 + n12 * n21 * n43 - n11 * n22 * n43) * detInv;
        te[12] = t14 * detInv;
        te[13] = (n13 * n24 * n31 - n14 * n23 * n31 + n14 * n21 * n33 - n11 * n24 * n33 - n13 * n21 * n34 + n11 * n23 * n34) * detInv;
        te[14] = (n14 * n22 * n31 - n12 * n24 * n31 - n14 * n21 * n32 + n11 * n24 * n32 + n12 * n21 * n34 - n11 * n22 * n34) * detInv;
        te[15] = (n12 * n23 * n31 - n13 * n22 * n31 + n13 * n21 * n32 - n11 * n23 * n32 - n12 * n21 * n33 + n11 * n22 * n33) * detInv;
        return this;
    }
    /**
	 * Multiplies the columns of this matrix by the given vector.
	 *
	 * @param {Vector3} v - The scale vector.
	 * @return {Matrix4} A reference to this matrix.
	 */ scale(v) {
        const te = this.elements;
        const x = v.x, y = v.y, z = v.z;
        te[0] *= x;
        te[4] *= y;
        te[8] *= z;
        te[1] *= x;
        te[5] *= y;
        te[9] *= z;
        te[2] *= x;
        te[6] *= y;
        te[10] *= z;
        te[3] *= x;
        te[7] *= y;
        te[11] *= z;
        return this;
    }
    /**
	 * Gets the maximum scale value of the three axes.
	 *
	 * @return {number} The maximum scale.
	 */ getMaxScaleOnAxis() {
        const te = this.elements;
        const scaleXSq = te[0] * te[0] + te[1] * te[1] + te[2] * te[2];
        const scaleYSq = te[4] * te[4] + te[5] * te[5] + te[6] * te[6];
        const scaleZSq = te[8] * te[8] + te[9] * te[9] + te[10] * te[10];
        return Math.sqrt(Math.max(scaleXSq, scaleYSq, scaleZSq));
    }
    /**
	 * Sets this matrix as a translation transform from the given vector.
	 *
	 * @param {number|Vector3} x - The amount to translate in the X axis or alternatively a translation vector.
	 * @param {number} y - The amount to translate in the Y axis.
	 * @param {number} z - The amount to translate in the z axis.
	 * @return {Matrix4} A reference to this matrix.
	 */ makeTranslation(x, y, z) {
        if (x.isVector3) this.set(1, 0, 0, x.x, 0, 1, 0, x.y, 0, 0, 1, x.z, 0, 0, 0, 1);
        else this.set(1, 0, 0, x, 0, 1, 0, y, 0, 0, 1, z, 0, 0, 0, 1);
        return this;
    }
    /**
	 * Sets this matrix as a rotational transformation around the X axis by
	 * the given angle.
	 *
	 * @param {number} theta - The rotation in radians.
	 * @return {Matrix4} A reference to this matrix.
	 */ makeRotationX(theta) {
        const c = Math.cos(theta), s = Math.sin(theta);
        this.set(1, 0, 0, 0, 0, c, -s, 0, 0, s, c, 0, 0, 0, 0, 1);
        return this;
    }
    /**
	 * Sets this matrix as a rotational transformation around the Y axis by
	 * the given angle.
	 *
	 * @param {number} theta - The rotation in radians.
	 * @return {Matrix4} A reference to this matrix.
	 */ makeRotationY(theta) {
        const c = Math.cos(theta), s = Math.sin(theta);
        this.set(c, 0, s, 0, 0, 1, 0, 0, -s, 0, c, 0, 0, 0, 0, 1);
        return this;
    }
    /**
	 * Sets this matrix as a rotational transformation around the Z axis by
	 * the given angle.
	 *
	 * @param {number} theta - The rotation in radians.
	 * @return {Matrix4} A reference to this matrix.
	 */ makeRotationZ(theta) {
        const c = Math.cos(theta), s = Math.sin(theta);
        this.set(c, -s, 0, 0, s, c, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1);
        return this;
    }
    /**
	 * Sets this matrix as a rotational transformation around the given axis by
	 * the given angle.
	 *
	 * This is a somewhat controversial but mathematically sound alternative to
	 * rotating via Quaternions. See the discussion [here]{@link https://www.gamedev.net/articles/programming/math-and-physics/do-we-really-need-quaternions-r1199}.
	 *
	 * @param {Vector3} axis - The normalized rotation axis.
	 * @param {number} angle - The rotation in radians.
	 * @return {Matrix4} A reference to this matrix.
	 */ makeRotationAxis(axis, angle) {
        // Based on http://www.gamedev.net/reference/articles/article1199.asp
        const c = Math.cos(angle);
        const s = Math.sin(angle);
        const t = 1 - c;
        const x = axis.x, y = axis.y, z = axis.z;
        const tx = t * x, ty = t * y;
        this.set(tx * x + c, tx * y - s * z, tx * z + s * y, 0, tx * y + s * z, ty * y + c, ty * z - s * x, 0, tx * z - s * y, ty * z + s * x, t * z * z + c, 0, 0, 0, 0, 1);
        return this;
    }
    /**
	 * Sets this matrix as a scale transformation.
	 *
	 * @param {number} x - The amount to scale in the X axis.
	 * @param {number} y - The amount to scale in the Y axis.
	 * @param {number} z - The amount to scale in the Z axis.
	 * @return {Matrix4} A reference to this matrix.
	 */ makeScale(x, y, z) {
        this.set(x, 0, 0, 0, 0, y, 0, 0, 0, 0, z, 0, 0, 0, 0, 1);
        return this;
    }
    /**
	 * Sets this matrix as a shear transformation.
	 *
	 * @param {number} xy - The amount to shear X by Y.
	 * @param {number} xz - The amount to shear X by Z.
	 * @param {number} yx - The amount to shear Y by X.
	 * @param {number} yz - The amount to shear Y by Z.
	 * @param {number} zx - The amount to shear Z by X.
	 * @param {number} zy - The amount to shear Z by Y.
	 * @return {Matrix4} A reference to this matrix.
	 */ makeShear(xy, xz, yx, yz, zx, zy) {
        this.set(1, yx, zx, 0, xy, 1, zy, 0, xz, yz, 1, 0, 0, 0, 0, 1);
        return this;
    }
    /**
	 * Sets this matrix to the transformation composed of the given position,
	 * rotation (Quaternion) and scale.
	 *
	 * @param {Vector3} position - The position vector.
	 * @param {Quaternion} quaternion - The rotation as a Quaternion.
	 * @param {Vector3} scale - The scale vector.
	 * @return {Matrix4} A reference to this matrix.
	 */ compose(position, quaternion, scale) {
        const te = this.elements;
        const x = quaternion._x, y = quaternion._y, z = quaternion._z, w = quaternion._w;
        const x2 = x + x, y2 = y + y, z2 = z + z;
        const xx = x * x2, xy = x * y2, xz = x * z2;
        const yy = y * y2, yz = y * z2, zz = z * z2;
        const wx = w * x2, wy = w * y2, wz = w * z2;
        const sx = scale.x, sy = scale.y, sz = scale.z;
        te[0] = (1 - (yy + zz)) * sx;
        te[1] = (xy + wz) * sx;
        te[2] = (xz - wy) * sx;
        te[3] = 0;
        te[4] = (xy - wz) * sy;
        te[5] = (1 - (xx + zz)) * sy;
        te[6] = (yz + wx) * sy;
        te[7] = 0;
        te[8] = (xz + wy) * sz;
        te[9] = (yz - wx) * sz;
        te[10] = (1 - (xx + yy)) * sz;
        te[11] = 0;
        te[12] = position.x;
        te[13] = position.y;
        te[14] = position.z;
        te[15] = 1;
        return this;
    }
    /**
	 * Decomposes this matrix into its position, rotation and scale components
	 * and provides the result in the given objects.
	 *
	 * Note: Not all matrices are decomposable in this way. For example, if an
	 * object has a non-uniformly scaled parent, then the object's world matrix
	 * may not be decomposable, and this method may not be appropriate.
	 *
	 * @param {Vector3} position - The position vector.
	 * @param {Quaternion} quaternion - The rotation as a Quaternion.
	 * @param {Vector3} scale - The scale vector.
	 * @return {Matrix4} A reference to this matrix.
	 */ decompose(position, quaternion, scale) {
        const te = this.elements;
        let sx = $9ddd7e9b53f7a2d4$var$_v1$5.set(te[0], te[1], te[2]).length();
        const sy = $9ddd7e9b53f7a2d4$var$_v1$5.set(te[4], te[5], te[6]).length();
        const sz = $9ddd7e9b53f7a2d4$var$_v1$5.set(te[8], te[9], te[10]).length();
        // if determine is negative, we need to invert one scale
        const det = this.determinant();
        if (det < 0) sx = -sx;
        position.x = te[12];
        position.y = te[13];
        position.z = te[14];
        // scale the rotation part
        $9ddd7e9b53f7a2d4$var$_m1$2.copy(this);
        const invSX = 1 / sx;
        const invSY = 1 / sy;
        const invSZ = 1 / sz;
        $9ddd7e9b53f7a2d4$var$_m1$2.elements[0] *= invSX;
        $9ddd7e9b53f7a2d4$var$_m1$2.elements[1] *= invSX;
        $9ddd7e9b53f7a2d4$var$_m1$2.elements[2] *= invSX;
        $9ddd7e9b53f7a2d4$var$_m1$2.elements[4] *= invSY;
        $9ddd7e9b53f7a2d4$var$_m1$2.elements[5] *= invSY;
        $9ddd7e9b53f7a2d4$var$_m1$2.elements[6] *= invSY;
        $9ddd7e9b53f7a2d4$var$_m1$2.elements[8] *= invSZ;
        $9ddd7e9b53f7a2d4$var$_m1$2.elements[9] *= invSZ;
        $9ddd7e9b53f7a2d4$var$_m1$2.elements[10] *= invSZ;
        quaternion.setFromRotationMatrix($9ddd7e9b53f7a2d4$var$_m1$2);
        scale.x = sx;
        scale.y = sy;
        scale.z = sz;
        return this;
    }
    /**
	 * Creates a perspective projection matrix. This is used internally by
	 * {@link PerspectiveCamera#updateProjectionMatrix}.

	 * @param {number} left - Left boundary of the viewing frustum at the near plane.
	 * @param {number} right - Right boundary of the viewing frustum at the near plane.
	 * @param {number} top - Top boundary of the viewing frustum at the near plane.
	 * @param {number} bottom - Bottom boundary of the viewing frustum at the near plane.
	 * @param {number} near - The distance from the camera to the near plane.
	 * @param {number} far - The distance from the camera to the far plane.
	 * @param {(WebGLCoordinateSystem|WebGPUCoordinateSystem)} [coordinateSystem=WebGLCoordinateSystem] - The coordinate system.
	 * @return {Matrix4} A reference to this matrix.
	 */ makePerspective(left, right, top, bottom, near, far, coordinateSystem = $9ddd7e9b53f7a2d4$export$5a0e9190d10875d3) {
        const te = this.elements;
        const x = 2 * near / (right - left);
        const y = 2 * near / (top - bottom);
        const a = (right + left) / (right - left);
        const b = (top + bottom) / (top - bottom);
        let c, d;
        if (coordinateSystem === $9ddd7e9b53f7a2d4$export$5a0e9190d10875d3) {
            c = -(far + near) / (far - near);
            d = -2 * far * near / (far - near);
        } else if (coordinateSystem === $9ddd7e9b53f7a2d4$export$cc83beedcb9be9ac) {
            c = -far / (far - near);
            d = -far * near / (far - near);
        } else throw new Error('THREE.Matrix4.makePerspective(): Invalid coordinate system: ' + coordinateSystem);
        te[0] = x;
        te[4] = 0;
        te[8] = a;
        te[12] = 0;
        te[1] = 0;
        te[5] = y;
        te[9] = b;
        te[13] = 0;
        te[2] = 0;
        te[6] = 0;
        te[10] = c;
        te[14] = d;
        te[3] = 0;
        te[7] = 0;
        te[11] = -1;
        te[15] = 0;
        return this;
    }
    /**
	 * Creates a orthographic projection matrix. This is used internally by
	 * {@link OrthographicCamera#updateProjectionMatrix}.

	 * @param {number} left - Left boundary of the viewing frustum at the near plane.
	 * @param {number} right - Right boundary of the viewing frustum at the near plane.
	 * @param {number} top - Top boundary of the viewing frustum at the near plane.
	 * @param {number} bottom - Bottom boundary of the viewing frustum at the near plane.
	 * @param {number} near - The distance from the camera to the near plane.
	 * @param {number} far - The distance from the camera to the far plane.
	 * @param {(WebGLCoordinateSystem|WebGPUCoordinateSystem)} [coordinateSystem=WebGLCoordinateSystem] - The coordinate system.
	 * @return {Matrix4} A reference to this matrix.
	 */ makeOrthographic(left, right, top, bottom, near, far, coordinateSystem = $9ddd7e9b53f7a2d4$export$5a0e9190d10875d3) {
        const te = this.elements;
        const w = 1.0 / (right - left);
        const h = 1.0 / (top - bottom);
        const p = 1.0 / (far - near);
        const x = (right + left) * w;
        const y = (top + bottom) * h;
        let z, zInv;
        if (coordinateSystem === $9ddd7e9b53f7a2d4$export$5a0e9190d10875d3) {
            z = (far + near) * p;
            zInv = -2 * p;
        } else if (coordinateSystem === $9ddd7e9b53f7a2d4$export$cc83beedcb9be9ac) {
            z = near * p;
            zInv = -1 * p;
        } else throw new Error('THREE.Matrix4.makeOrthographic(): Invalid coordinate system: ' + coordinateSystem);
        te[0] = 2 * w;
        te[4] = 0;
        te[8] = 0;
        te[12] = -x;
        te[1] = 0;
        te[5] = 2 * h;
        te[9] = 0;
        te[13] = -y;
        te[2] = 0;
        te[6] = 0;
        te[10] = zInv;
        te[14] = -z;
        te[3] = 0;
        te[7] = 0;
        te[11] = 0;
        te[15] = 1;
        return this;
    }
    /**
	 * Returns `true` if this matrix is equal with the given one.
	 *
	 * @param {Matrix4} matrix - The matrix to test for equality.
	 * @return {boolean} Whether this matrix is equal with the given one.
	 */ equals(matrix) {
        const te = this.elements;
        const me = matrix.elements;
        for(let i = 0; i < 16; i++){
            if (te[i] !== me[i]) return false;
        }
        return true;
    }
    /**
	 * Sets the elements of the matrix from the given array.
	 *
	 * @param {Array<number>} array - The matrix elements in column-major order.
	 * @param {number} [offset=0] - Index of the first element in the array.
	 * @return {Matrix4} A reference to this matrix.
	 */ fromArray(array, offset = 0) {
        for(let i = 0; i < 16; i++)this.elements[i] = array[i + offset];
        return this;
    }
    /**
	 * Writes the elements of this matrix to the given array. If no array is provided,
	 * the method returns a new instance.
	 *
	 * @param {Array<number>} [array=[]] - The target array holding the matrix elements in column-major order.
	 * @param {number} [offset=0] - Index of the first element in the array.
	 * @return {Array<number>} The matrix elements in column-major order.
	 */ toArray(array = [], offset = 0) {
        const te = this.elements;
        array[offset] = te[0];
        array[offset + 1] = te[1];
        array[offset + 2] = te[2];
        array[offset + 3] = te[3];
        array[offset + 4] = te[4];
        array[offset + 5] = te[5];
        array[offset + 6] = te[6];
        array[offset + 7] = te[7];
        array[offset + 8] = te[8];
        array[offset + 9] = te[9];
        array[offset + 10] = te[10];
        array[offset + 11] = te[11];
        array[offset + 12] = te[12];
        array[offset + 13] = te[13];
        array[offset + 14] = te[14];
        array[offset + 15] = te[15];
        return array;
    }
}
const $9ddd7e9b53f7a2d4$var$_v1$5 = /*@__PURE__*/ new $9ddd7e9b53f7a2d4$export$64b5c384219d3699();
const $9ddd7e9b53f7a2d4$var$_m1$2 = /*@__PURE__*/ new $9ddd7e9b53f7a2d4$export$2ae72fc923e5eb5();
const $9ddd7e9b53f7a2d4$var$_zero = /*@__PURE__*/ new $9ddd7e9b53f7a2d4$export$64b5c384219d3699(0, 0, 0);
const $9ddd7e9b53f7a2d4$var$_one = /*@__PURE__*/ new $9ddd7e9b53f7a2d4$export$64b5c384219d3699(1, 1, 1);
const $9ddd7e9b53f7a2d4$var$_x = /*@__PURE__*/ new $9ddd7e9b53f7a2d4$export$64b5c384219d3699();
const $9ddd7e9b53f7a2d4$var$_y = /*@__PURE__*/ new $9ddd7e9b53f7a2d4$export$64b5c384219d3699();
const $9ddd7e9b53f7a2d4$var$_z = /*@__PURE__*/ new $9ddd7e9b53f7a2d4$export$64b5c384219d3699();
const $9ddd7e9b53f7a2d4$var$_matrix$2 = /*@__PURE__*/ new $9ddd7e9b53f7a2d4$export$2ae72fc923e5eb5();
const $9ddd7e9b53f7a2d4$var$_quaternion$3 = /*@__PURE__*/ new $9ddd7e9b53f7a2d4$export$23d6a54f0bbc85a3();
/**
 * A class representing Euler angles.
 *
 * Euler angles describe a rotational transformation by rotating an object on
 * its various axes in specified amounts per axis, and a specified axis
 * order.
 *
 * Iterating through an instance will yield its components (x, y, z,
 * order) in the corresponding order.
 *
 * ```js
 * const a = new THREE.Euler( 0, 1, 1.57, 'XYZ' );
 * const b = new THREE.Vector3( 1, 0, 1 );
 * b.applyEuler(a);
 * ```
 */ class $9ddd7e9b53f7a2d4$export$d93cc409a0768c5f {
    /**
	 * Constructs a new euler instance.
	 *
	 * @param {number} [x=0] - The angle of the x axis in radians.
	 * @param {number} [y=0] - The angle of the y axis in radians.
	 * @param {number} [z=0] - The angle of the z axis in radians.
	 * @param {string} [order=Euler.DEFAULT_ORDER] - A string representing the order that the rotations are applied.
	 */ constructor(x = 0, y = 0, z = 0, order = $9ddd7e9b53f7a2d4$export$d93cc409a0768c5f.DEFAULT_ORDER){
        /**
		 * This flag can be used for type testing.
		 *
		 * @type {boolean}
		 * @readonly
		 * @default true
		 */ this.isEuler = true;
        this._x = x;
        this._y = y;
        this._z = z;
        this._order = order;
    }
    /**
	 * The angle of the x axis in radians.
	 *
	 * @type {number}
	 * @default 0
	 */ get x() {
        return this._x;
    }
    set x(value) {
        this._x = value;
        this._onChangeCallback();
    }
    /**
	 * The angle of the y axis in radians.
	 *
	 * @type {number}
	 * @default 0
	 */ get y() {
        return this._y;
    }
    set y(value) {
        this._y = value;
        this._onChangeCallback();
    }
    /**
	 * The angle of the z axis in radians.
	 *
	 * @type {number}
	 * @default 0
	 */ get z() {
        return this._z;
    }
    set z(value) {
        this._z = value;
        this._onChangeCallback();
    }
    /**
	 * A string representing the order that the rotations are applied.
	 *
	 * @type {string}
	 * @default 'XYZ'
	 */ get order() {
        return this._order;
    }
    set order(value) {
        this._order = value;
        this._onChangeCallback();
    }
    /**
	 * Sets the Euler components.
	 *
	 * @param {number} x - The angle of the x axis in radians.
	 * @param {number} y - The angle of the y axis in radians.
	 * @param {number} z - The angle of the z axis in radians.
	 * @param {string} [order] - A string representing the order that the rotations are applied.
	 * @return {Euler} A reference to this Euler instance.
	 */ set(x, y, z, order = this._order) {
        this._x = x;
        this._y = y;
        this._z = z;
        this._order = order;
        this._onChangeCallback();
        return this;
    }
    /**
	 * Returns a new Euler instance with copied values from this instance.
	 *
	 * @return {Euler} A clone of this instance.
	 */ clone() {
        return new this.constructor(this._x, this._y, this._z, this._order);
    }
    /**
	 * Copies the values of the given Euler instance to this instance.
	 *
	 * @param {Euler} euler - The Euler instance to copy.
	 * @return {Euler} A reference to this Euler instance.
	 */ copy(euler) {
        this._x = euler._x;
        this._y = euler._y;
        this._z = euler._z;
        this._order = euler._order;
        this._onChangeCallback();
        return this;
    }
    /**
	 * Sets the angles of this Euler instance from a pure rotation matrix.
	 *
	 * @param {Matrix4} m - A 4x4 matrix of which the upper 3x3 of matrix is a pure rotation matrix (i.e. unscaled).
	 * @param {string} [order] - A string representing the order that the rotations are applied.
	 * @param {boolean} [update=true] - Whether the internal `onChange` callback should be executed or not.
	 * @return {Euler} A reference to this Euler instance.
	 */ setFromRotationMatrix(m, order = this._order, update = true) {
        const te = m.elements;
        const m11 = te[0], m12 = te[4], m13 = te[8];
        const m21 = te[1], m22 = te[5], m23 = te[9];
        const m31 = te[2], m32 = te[6], m33 = te[10];
        switch(order){
            case 'XYZ':
                this._y = Math.asin($9ddd7e9b53f7a2d4$var$clamp(m13, -1, 1));
                if (Math.abs(m13) < 0.9999999) {
                    this._x = Math.atan2(-m23, m33);
                    this._z = Math.atan2(-m12, m11);
                } else {
                    this._x = Math.atan2(m32, m22);
                    this._z = 0;
                }
                break;
            case 'YXZ':
                this._x = Math.asin(-$9ddd7e9b53f7a2d4$var$clamp(m23, -1, 1));
                if (Math.abs(m23) < 0.9999999) {
                    this._y = Math.atan2(m13, m33);
                    this._z = Math.atan2(m21, m22);
                } else {
                    this._y = Math.atan2(-m31, m11);
                    this._z = 0;
                }
                break;
            case 'ZXY':
                this._x = Math.asin($9ddd7e9b53f7a2d4$var$clamp(m32, -1, 1));
                if (Math.abs(m32) < 0.9999999) {
                    this._y = Math.atan2(-m31, m33);
                    this._z = Math.atan2(-m12, m22);
                } else {
                    this._y = 0;
                    this._z = Math.atan2(m21, m11);
                }
                break;
            case 'ZYX':
                this._y = Math.asin(-$9ddd7e9b53f7a2d4$var$clamp(m31, -1, 1));
                if (Math.abs(m31) < 0.9999999) {
                    this._x = Math.atan2(m32, m33);
                    this._z = Math.atan2(m21, m11);
                } else {
                    this._x = 0;
                    this._z = Math.atan2(-m12, m22);
                }
                break;
            case 'YZX':
                this._z = Math.asin($9ddd7e9b53f7a2d4$var$clamp(m21, -1, 1));
                if (Math.abs(m21) < 0.9999999) {
                    this._x = Math.atan2(-m23, m22);
                    this._y = Math.atan2(-m31, m11);
                } else {
                    this._x = 0;
                    this._y = Math.atan2(m13, m33);
                }
                break;
            case 'XZY':
                this._z = Math.asin(-$9ddd7e9b53f7a2d4$var$clamp(m12, -1, 1));
                if (Math.abs(m12) < 0.9999999) {
                    this._x = Math.atan2(m32, m22);
                    this._y = Math.atan2(m13, m11);
                } else {
                    this._x = Math.atan2(-m23, m33);
                    this._y = 0;
                }
                break;
            default:
                console.warn('THREE.Euler: .setFromRotationMatrix() encountered an unknown order: ' + order);
        }
        this._order = order;
        if (update === true) this._onChangeCallback();
        return this;
    }
    /**
	 * Sets the angles of this Euler instance from a normalized quaternion.
	 *
	 * @param {Quaternion} q - A normalized Quaternion.
	 * @param {string} [order] - A string representing the order that the rotations are applied.
	 * @param {boolean} [update=true] - Whether the internal `onChange` callback should be executed or not.
	 * @return {Euler} A reference to this Euler instance.
	 */ setFromQuaternion(q, order, update) {
        $9ddd7e9b53f7a2d4$var$_matrix$2.makeRotationFromQuaternion(q);
        return this.setFromRotationMatrix($9ddd7e9b53f7a2d4$var$_matrix$2, order, update);
    }
    /**
	 * Sets the angles of this Euler instance from the given vector.
	 *
	 * @param {Vector3} v - The vector.
	 * @param {string} [order] - A string representing the order that the rotations are applied.
	 * @return {Euler} A reference to this Euler instance.
	 */ setFromVector3(v, order = this._order) {
        return this.set(v.x, v.y, v.z, order);
    }
    /**
	 * Resets the euler angle with a new order by creating a quaternion from this
	 * euler angle and then setting this euler angle with the quaternion and the
	 * new order.
	 *
	 * Warning: This discards revolution information.
	 *
	 * @param {string} [newOrder] - A string representing the new order that the rotations are applied.
	 * @return {Euler} A reference to this Euler instance.
	 */ reorder(newOrder) {
        $9ddd7e9b53f7a2d4$var$_quaternion$3.setFromEuler(this);
        return this.setFromQuaternion($9ddd7e9b53f7a2d4$var$_quaternion$3, newOrder);
    }
    /**
	 * Returns `true` if this Euler instance is equal with the given one.
	 *
	 * @param {Euler} euler - The Euler instance to test for equality.
	 * @return {boolean} Whether this Euler instance is equal with the given one.
	 */ equals(euler) {
        return euler._x === this._x && euler._y === this._y && euler._z === this._z && euler._order === this._order;
    }
    /**
	 * Sets this Euler instance's components to values from the given array. The first three
	 * entries of the array are assign to the x,y and z components. An optional fourth entry
	 * defines the Euler order.
	 *
	 * @param {Array<number,number,number,?string>} array - An array holding the Euler component values.
	 * @return {Euler} A reference to this Euler instance.
	 */ fromArray(array) {
        this._x = array[0];
        this._y = array[1];
        this._z = array[2];
        if (array[3] !== undefined) this._order = array[3];
        this._onChangeCallback();
        return this;
    }
    /**
	 * Writes the components of this Euler instance to the given array. If no array is provided,
	 * the method returns a new instance.
	 *
	 * @param {Array<number,number,number,string>} [array=[]] - The target array holding the Euler components.
	 * @param {number} [offset=0] - Index of the first element in the array.
	 * @return {Array<number,number,number,string>} The Euler components.
	 */ toArray(array = [], offset = 0) {
        array[offset] = this._x;
        array[offset + 1] = this._y;
        array[offset + 2] = this._z;
        array[offset + 3] = this._order;
        return array;
    }
    _onChange(callback) {
        this._onChangeCallback = callback;
        return this;
    }
    _onChangeCallback() {}
    *[Symbol.iterator]() {
        yield this._x;
        yield this._y;
        yield this._z;
        yield this._order;
    }
}
/**
 * The default Euler angle order.
 *
 * @static
 * @type {string}
 * @default 'XYZ'
 */ $9ddd7e9b53f7a2d4$export$d93cc409a0768c5f.DEFAULT_ORDER = 'XYZ';
/**
 * A layers object assigns an 3D object to 1 or more of 32
 * layers numbered `0` to `31` - internally the layers are stored as a
 * bit mask], and by default all 3D objects are a member of layer `0`.
 *
 * This can be used to control visibility - an object must share a layer with
 * a camera to be visible when that camera's view is
 * rendered.
 *
 * All classes that inherit from {@link Object3D} have an `layers` property which
 * is an instance of this class.
 */ class $9ddd7e9b53f7a2d4$export$89312ce47c0ca777 {
    /**
	 * Constructs a new layers instance, with membership
	 * initially set to layer `0`.
	 */ constructor(){
        /**
		 * A bit mask storing which of the 32 layers this layers object is currently
		 * a member of.
		 *
		 * @type {number}
		 */ this.mask = 1;
    }
    /**
	 * Sets membership to the given layer, and remove membership all other layers.
	 *
	 * @param {number} layer - The layer to set.
	 */ set(layer) {
        this.mask = (1 << layer | 0) >>> 0;
    }
    /**
	 * Adds membership of the given layer.
	 *
	 * @param {number} layer - The layer to enable.
	 */ enable(layer) {
        this.mask |= 1 << layer | 0;
    }
    /**
	 * Adds membership to all layers.
	 */ enableAll() {
        this.mask = -1;
    }
    /**
	 * Toggles the membership of the given layer.
	 *
	 * @param {number} layer - The layer to toggle.
	 */ toggle(layer) {
        this.mask ^= 1 << layer | 0;
    }
    /**
	 * Removes membership of the given layer.
	 *
	 * @param {number} layer - The layer to enable.
	 */ disable(layer) {
        this.mask &= ~(1 << layer | 0);
    }
    /**
	 * Removes the membership from all layers.
	 */ disableAll() {
        this.mask = 0;
    }
    /**
	 * Returns `true` if this and the given layers object have at least one
	 * layer in common.
	 *
	 * @param {Layers} layers - The layers to test.
	 * @return {boolean } Whether this and the given layers object have at least one layer in common or not.
	 */ test(layers) {
        return (this.mask & layers.mask) !== 0;
    }
    /**
	 * Returns `true` if the given layer is enabled.
	 *
	 * @param {number} layer - The layer to test.
	 * @return {boolean } Whether the given layer is enabled or not.
	 */ isEnabled(layer) {
        return (this.mask & (1 << layer | 0)) !== 0;
    }
}
let $9ddd7e9b53f7a2d4$var$_object3DId = 0;
const $9ddd7e9b53f7a2d4$var$_v1$4 = /*@__PURE__*/ new $9ddd7e9b53f7a2d4$export$64b5c384219d3699();
const $9ddd7e9b53f7a2d4$var$_q1 = /*@__PURE__*/ new $9ddd7e9b53f7a2d4$export$23d6a54f0bbc85a3();
const $9ddd7e9b53f7a2d4$var$_m1$1 = /*@__PURE__*/ new $9ddd7e9b53f7a2d4$export$2ae72fc923e5eb5();
const $9ddd7e9b53f7a2d4$var$_target = /*@__PURE__*/ new $9ddd7e9b53f7a2d4$export$64b5c384219d3699();
const $9ddd7e9b53f7a2d4$var$_position$3 = /*@__PURE__*/ new $9ddd7e9b53f7a2d4$export$64b5c384219d3699();
const $9ddd7e9b53f7a2d4$var$_scale$2 = /*@__PURE__*/ new $9ddd7e9b53f7a2d4$export$64b5c384219d3699();
const $9ddd7e9b53f7a2d4$var$_quaternion$2 = /*@__PURE__*/ new $9ddd7e9b53f7a2d4$export$23d6a54f0bbc85a3();
const $9ddd7e9b53f7a2d4$var$_xAxis = /*@__PURE__*/ new $9ddd7e9b53f7a2d4$export$64b5c384219d3699(1, 0, 0);
const $9ddd7e9b53f7a2d4$var$_yAxis = /*@__PURE__*/ new $9ddd7e9b53f7a2d4$export$64b5c384219d3699(0, 1, 0);
const $9ddd7e9b53f7a2d4$var$_zAxis = /*@__PURE__*/ new $9ddd7e9b53f7a2d4$export$64b5c384219d3699(0, 0, 1);
/**
 * Fires when the object has been added to its parent object.
 *
 * @event Object3D#added
 * @type {Object}
 */ const $9ddd7e9b53f7a2d4$var$_addedEvent = {
    type: 'added'
};
/**
 * Fires when the object has been removed from its parent object.
 *
 * @event Object3D#removed
 * @type {Object}
 */ const $9ddd7e9b53f7a2d4$var$_removedEvent = {
    type: 'removed'
};
/**
 * Fires when a new child object has been added.
 *
 * @event Object3D#childadded
 * @type {Object}
 */ const $9ddd7e9b53f7a2d4$var$_childaddedEvent = {
    type: 'childadded',
    child: null
};
/**
 * Fires when a new child object has been added.
 *
 * @event Object3D#childremoved
 * @type {Object}
 */ const $9ddd7e9b53f7a2d4$var$_childremovedEvent = {
    type: 'childremoved',
    child: null
};
/**
 * This is the base class for most objects in three.js and provides a set of
 * properties and methods for manipulating objects in 3D space.
 *
 * @augments EventDispatcher
 */ class $9ddd7e9b53f7a2d4$export$e4dd07dff30cc924 extends $9ddd7e9b53f7a2d4$export$ec8b666c5fe2c75a {
    /**
	 * Constructs a new 3D object.
	 */ constructor(){
        super();
        /**
		 * This flag can be used for type testing.
		 *
		 * @type {boolean}
		 * @readonly
		 * @default true
		 */ this.isObject3D = true;
        /**
		 * The ID of the 3D object.
		 *
		 * @name Object3D#id
		 * @type {number}
		 * @readonly
		 */ Object.defineProperty(this, 'id', {
            value: $9ddd7e9b53f7a2d4$var$_object3DId++
        });
        /**
		 * The UUID of the 3D object.
		 *
		 * @type {string}
		 * @readonly
		 */ this.uuid = $9ddd7e9b53f7a2d4$var$generateUUID();
        /**
		 * The name of the 3D object.
		 *
		 * @type {string}
		 */ this.name = '';
        /**
		 * The type property is used for detecting the object type
		 * in context of serialization/deserialization.
		 *
		 * @type {string}
		 * @readonly
		 */ this.type = 'Object3D';
        /**
		 * A reference to the parent object.
		 *
		 * @type {?Object3D}
		 * @default null
		 */ this.parent = null;
        /**
		 * An array holding the child 3D objects of this instance.
		 *
		 * @type {Array<Object3D>}
		 */ this.children = [];
        /**
		 * Defines the `up` direction of the 3D object which influences
		 * the orientation via methods like {@link Object3D#lookAt}.
		 *
		 * The default values for all 3D objects is defined by `Object3D.DEFAULT_UP`.
		 *
		 * @type {Vector3}
		 */ this.up = $9ddd7e9b53f7a2d4$export$e4dd07dff30cc924.DEFAULT_UP.clone();
        const position = new $9ddd7e9b53f7a2d4$export$64b5c384219d3699();
        const rotation = new $9ddd7e9b53f7a2d4$export$d93cc409a0768c5f();
        const quaternion = new $9ddd7e9b53f7a2d4$export$23d6a54f0bbc85a3();
        const scale = new $9ddd7e9b53f7a2d4$export$64b5c384219d3699(1, 1, 1);
        function onRotationChange() {
            quaternion.setFromEuler(rotation, false);
        }
        function onQuaternionChange() {
            rotation.setFromQuaternion(quaternion, undefined, false);
        }
        rotation._onChange(onRotationChange);
        quaternion._onChange(onQuaternionChange);
        Object.defineProperties(this, {
            /**
			 * Represents the object's local position.
			 *
			 * @name Object3D#position
			 * @type {Vector3}
			 * @default (0,0,0)
			 */ position: {
                configurable: true,
                enumerable: true,
                value: position
            },
            /**
			 * Represents the object's local rotation as Euler angles, in radians.
			 *
			 * @name Object3D#rotation
			 * @type {Euler}
			 * @default (0,0,0)
			 */ rotation: {
                configurable: true,
                enumerable: true,
                value: rotation
            },
            /**
			 * Represents the object's local rotation as Quaternions.
			 *
			 * @name Object3D#quaternion
			 * @type {Quaternion}
			 */ quaternion: {
                configurable: true,
                enumerable: true,
                value: quaternion
            },
            /**
			 * Represents the object's local scale.
			 *
			 * @name Object3D#scale
			 * @type {Vector3}
			 * @default (1,1,1)
			 */ scale: {
                configurable: true,
                enumerable: true,
                value: scale
            },
            /**
			 * Represents the object's model-view matrix.
			 *
			 * @name Object3D#modelViewMatrix
			 * @type {Matrix4}
			 */ modelViewMatrix: {
                value: new $9ddd7e9b53f7a2d4$export$2ae72fc923e5eb5()
            },
            /**
			 * Represents the object's normal matrix.
			 *
			 * @name Object3D#normalMatrix
			 * @type {Matrix3}
			 */ normalMatrix: {
                value: new $9ddd7e9b53f7a2d4$export$8ff26dafa08918()
            }
        });
        /**
		 * Represents the object's transformation matrix in local space.
		 *
		 * @type {Matrix4}
		 */ this.matrix = new $9ddd7e9b53f7a2d4$export$2ae72fc923e5eb5();
        /**
		 * Represents the object's transformation matrix in world space.
		 * If the 3D object has no parent, then it's identical to the local transformation matrix
		 *
		 * @type {Matrix4}
		 */ this.matrixWorld = new $9ddd7e9b53f7a2d4$export$2ae72fc923e5eb5();
        /**
		 * When set to `true`, the engine automatically computes the local matrix from position,
		 * rotation and scale every frame.
		 *
		 * The default values for all 3D objects is defined by `Object3D.DEFAULT_MATRIX_AUTO_UPDATE`.
		 *
		 * @type {boolean}
		 * @default true
		 */ this.matrixAutoUpdate = $9ddd7e9b53f7a2d4$export$e4dd07dff30cc924.DEFAULT_MATRIX_AUTO_UPDATE;
        /**
		 * When set to `true`, the engine automatically computes the world matrix from the current local
		 * matrix and the object's transformation hierarchy.
		 *
		 * The default values for all 3D objects is defined by `Object3D.DEFAULT_MATRIX_WORLD_AUTO_UPDATE`.
		 *
		 * @type {boolean}
		 * @default true
		 */ this.matrixWorldAutoUpdate = $9ddd7e9b53f7a2d4$export$e4dd07dff30cc924.DEFAULT_MATRIX_WORLD_AUTO_UPDATE; // checked by the renderer
        /**
		 * When set to `true`, it calculates the world matrix in that frame and resets this property
		 * to `false`.
		 *
		 * @type {boolean}
		 * @default false
		 */ this.matrixWorldNeedsUpdate = false;
        /**
		 * The layer membership of the 3D object. The 3D object is only visible if it has
		 * at least one layer in common with the camera in use. This property can also be
		 * used to filter out unwanted objects in ray-intersection tests when using {@link Raycaster}.
		 *
		 * @type {Layers}
		 */ this.layers = new $9ddd7e9b53f7a2d4$export$89312ce47c0ca777();
        /**
		 * When set to `true`, the 3D object gets rendered.
		 *
		 * @type {boolean}
		 * @default true
		 */ this.visible = true;
        /**
		 * When set to `true`, the 3D object gets rendered into shadow maps.
		 *
		 * @type {boolean}
		 * @default false
		 */ this.castShadow = false;
        /**
		 * When set to `true`, the 3D object is affected by shadows in the scene.
		 *
		 * @type {boolean}
		 * @default false
		 */ this.receiveShadow = false;
        /**
		 * When set to `true`, the 3D object is honored by view frustum culling.
		 *
		 * @type {boolean}
		 * @default true
		 */ this.frustumCulled = true;
        /**
		 * This value allows the default rendering order of scene graph objects to be
		 * overridden although opaque and transparent objects remain sorted independently.
		 * When this property is set for an instance of {@link Group},all descendants
		 * objects will be sorted and rendered together. Sorting is from lowest to highest
		 * render order.
		 *
		 * @type {number}
		 * @default 0
		 */ this.renderOrder = 0;
        /**
		 * An array holding the animation clips of the 3D object.
		 *
		 * @type {Array<AnimationClip>}
		 */ this.animations = [];
        /**
		 * Custom depth material to be used when rendering to the depth map. Can only be used
		 * in context of meshes. When shadow-casting with a {@link DirectionalLight} or {@link SpotLight},
		 * if you are modifying vertex positions in the vertex shader you must specify a custom depth
		 * material for proper shadows.
		 *
		 * Only relevant in context of {@link WebGLRenderer}.
		 *
		 * @type {(Material|undefined)}
		 * @default undefined
		 */ this.customDepthMaterial = undefined;
        /**
		 * Same as {@link Object3D#customDepthMaterial}, but used with {@link PointLight}.
		 *
		 * Only relevant in context of {@link WebGLRenderer}.
		 *
		 * @type {(Material|undefined)}
		 * @default undefined
		 */ this.customDistanceMaterial = undefined;
        /**
		 * An object that can be used to store custom data about the 3D object. It
		 * should not hold references to functions as these will not be cloned.
		 *
		 * @type {Object}
		 */ this.userData = {};
    }
    /**
	 * A callback that is executed immediately before a 3D object is rendered to a shadow map.
	 *
	 * @param {Renderer|WebGLRenderer} renderer - The renderer.
	 * @param {Object3D} object - The 3D object.
	 * @param {Camera} camera - The camera that is used to render the scene.
	 * @param {Camera} shadowCamera - The shadow camera.
	 * @param {BufferGeometry} geometry - The 3D object's geometry.
	 * @param {Material} depthMaterial - The depth material.
	 * @param {Object} group - The geometry group data.
	 */ onBeforeShadow() {}
    /**
	 * A callback that is executed immediately after a 3D object is rendered to a shadow map.
	 *
	 * @param {Renderer|WebGLRenderer} renderer - The renderer.
	 * @param {Object3D} object - The 3D object.
	 * @param {Camera} camera - The camera that is used to render the scene.
	 * @param {Camera} shadowCamera - The shadow camera.
	 * @param {BufferGeometry} geometry - The 3D object's geometry.
	 * @param {Material} depthMaterial - The depth material.
	 * @param {Object} group - The geometry group data.
	 */ onAfterShadow() {}
    /**
	 * A callback that is executed immediately before a 3D object is rendered.
	 *
	 * @param {Renderer|WebGLRenderer} renderer - The renderer.
	 * @param {Object3D} object - The 3D object.
	 * @param {Camera} camera - The camera that is used to render the scene.
	 * @param {BufferGeometry} geometry - The 3D object's geometry.
	 * @param {Material} material - The 3D object's material.
	 * @param {Object} group - The geometry group data.
	 */ onBeforeRender() {}
    /**
	 * A callback that is executed immediately after a 3D object is rendered.
	 *
	 * @param {Renderer|WebGLRenderer} renderer - The renderer.
	 * @param {Object3D} object - The 3D object.
	 * @param {Camera} camera - The camera that is used to render the scene.
	 * @param {BufferGeometry} geometry - The 3D object's geometry.
	 * @param {Material} material - The 3D object's material.
	 * @param {Object} group - The geometry group data.
	 */ onAfterRender() {}
    /**
	 * Applies the given transformation matrix to the object and updates the object's position,
	 * rotation and scale.
	 *
	 * @param {Matrix4} matrix - The transformation matrix.
	 */ applyMatrix4(matrix) {
        if (this.matrixAutoUpdate) this.updateMatrix();
        this.matrix.premultiply(matrix);
        this.matrix.decompose(this.position, this.quaternion, this.scale);
    }
    /**
	 * Applies a rotation represented by given the quaternion to the 3D object.
	 *
	 * @param {Quaternion} q - The quaternion.
	 * @return {Object3D} A reference to this instance.
	 */ applyQuaternion(q) {
        this.quaternion.premultiply(q);
        return this;
    }
    /**
	 * Sets the given rotation represented as an axis/angle couple to the 3D object.
	 *
	 * @param {Vector3} axis - The (normalized) axis vector.
	 * @param {number} angle - The angle in radians.
	 */ setRotationFromAxisAngle(axis, angle) {
        // assumes axis is normalized
        this.quaternion.setFromAxisAngle(axis, angle);
    }
    /**
	 * Sets the given rotation represented as Euler angles to the 3D object.
	 *
	 * @param {Euler} euler - The Euler angles.
	 */ setRotationFromEuler(euler) {
        this.quaternion.setFromEuler(euler, true);
    }
    /**
	 * Sets the given rotation represented as rotation matrix to the 3D object.
	 *
	 * @param {Matrix4} m - Although a 4x4 matrix is expected, the upper 3x3 portion must be
	 * a pure rotation matrix (i.e, unscaled).
	 */ setRotationFromMatrix(m) {
        // assumes the upper 3x3 of m is a pure rotation matrix (i.e, unscaled)
        this.quaternion.setFromRotationMatrix(m);
    }
    /**
	 * Sets the given rotation represented as a Quaternion to the 3D object.
	 *
	 * @param {Quaternion} q - The Quaternion
	 */ setRotationFromQuaternion(q) {
        // assumes q is normalized
        this.quaternion.copy(q);
    }
    /**
	 * Rotates the 3D object along an axis in local space.
	 *
	 * @param {Vector3} axis - The (normalized) axis vector.
	 * @param {number} angle - The angle in radians.
	 * @return {Object3D} A reference to this instance.
	 */ rotateOnAxis(axis, angle) {
        // rotate object on axis in object space
        // axis is assumed to be normalized
        $9ddd7e9b53f7a2d4$var$_q1.setFromAxisAngle(axis, angle);
        this.quaternion.multiply($9ddd7e9b53f7a2d4$var$_q1);
        return this;
    }
    /**
	 * Rotates the 3D object along an axis in world space.
	 *
	 * @param {Vector3} axis - The (normalized) axis vector.
	 * @param {number} angle - The angle in radians.
	 * @return {Object3D} A reference to this instance.
	 */ rotateOnWorldAxis(axis, angle) {
        // rotate object on axis in world space
        // axis is assumed to be normalized
        // method assumes no rotated parent
        $9ddd7e9b53f7a2d4$var$_q1.setFromAxisAngle(axis, angle);
        this.quaternion.premultiply($9ddd7e9b53f7a2d4$var$_q1);
        return this;
    }
    /**
	 * Rotates the 3D object around its X axis in local space.
	 *
	 * @param {number} angle - The angle in radians.
	 * @return {Object3D} A reference to this instance.
	 */ rotateX(angle) {
        return this.rotateOnAxis($9ddd7e9b53f7a2d4$var$_xAxis, angle);
    }
    /**
	 * Rotates the 3D object around its Y axis in local space.
	 *
	 * @param {number} angle - The angle in radians.
	 * @return {Object3D} A reference to this instance.
	 */ rotateY(angle) {
        return this.rotateOnAxis($9ddd7e9b53f7a2d4$var$_yAxis, angle);
    }
    /**
	 * Rotates the 3D object around its Z axis in local space.
	 *
	 * @param {number} angle - The angle in radians.
	 * @return {Object3D} A reference to this instance.
	 */ rotateZ(angle) {
        return this.rotateOnAxis($9ddd7e9b53f7a2d4$var$_zAxis, angle);
    }
    /**
	 * Translate the 3D object by a distance along the given axis in local space.
	 *
	 * @param {Vector3} axis - The (normalized) axis vector.
	 * @param {number} distance - The distance in world units.
	 * @return {Object3D} A reference to this instance.
	 */ translateOnAxis(axis, distance) {
        // translate object by distance along axis in object space
        // axis is assumed to be normalized
        $9ddd7e9b53f7a2d4$var$_v1$4.copy(axis).applyQuaternion(this.quaternion);
        this.position.add($9ddd7e9b53f7a2d4$var$_v1$4.multiplyScalar(distance));
        return this;
    }
    /**
	 * Translate the 3D object by a distance along its X-axis in local space.
	 *
	 * @param {number} distance - The distance in world units.
	 * @return {Object3D} A reference to this instance.
	 */ translateX(distance) {
        return this.translateOnAxis($9ddd7e9b53f7a2d4$var$_xAxis, distance);
    }
    /**
	 * Translate the 3D object by a distance along its Y-axis in local space.
	 *
	 * @param {number} distance - The distance in world units.
	 * @return {Object3D} A reference to this instance.
	 */ translateY(distance) {
        return this.translateOnAxis($9ddd7e9b53f7a2d4$var$_yAxis, distance);
    }
    /**
	 * Translate the 3D object by a distance along its Z-axis in local space.
	 *
	 * @param {number} distance - The distance in world units.
	 * @return {Object3D} A reference to this instance.
	 */ translateZ(distance) {
        return this.translateOnAxis($9ddd7e9b53f7a2d4$var$_zAxis, distance);
    }
    /**
	 * Converts the given vector from this 3D object's local space to world space.
	 *
	 * @param {Vector3} vector - The vector to convert.
	 * @return {Vector3} The converted vector.
	 */ localToWorld(vector) {
        this.updateWorldMatrix(true, false);
        return vector.applyMatrix4(this.matrixWorld);
    }
    /**
	 * Converts the given vector from this 3D object's word space to local space.
	 *
	 * @param {Vector3} vector - The vector to convert.
	 * @return {Vector3} The converted vector.
	 */ worldToLocal(vector) {
        this.updateWorldMatrix(true, false);
        return vector.applyMatrix4($9ddd7e9b53f7a2d4$var$_m1$1.copy(this.matrixWorld).invert());
    }
    /**
	 * Rotates the object to face a point in world space.
	 *
	 * This method does not support objects having non-uniformly-scaled parent(s).
	 *
	 * @param {number|Vector3} x - The x coordinate in world space. Alternatively, a vector representing a position in world space
	 * @param {number} [y] - The y coordinate in world space.
	 * @param {number} [z] - The z coordinate in world space.
	 */ lookAt(x, y, z) {
        // This method does not support objects having non-uniformly-scaled parent(s)
        if (x.isVector3) $9ddd7e9b53f7a2d4$var$_target.copy(x);
        else $9ddd7e9b53f7a2d4$var$_target.set(x, y, z);
        const parent = this.parent;
        this.updateWorldMatrix(true, false);
        $9ddd7e9b53f7a2d4$var$_position$3.setFromMatrixPosition(this.matrixWorld);
        if (this.isCamera || this.isLight) $9ddd7e9b53f7a2d4$var$_m1$1.lookAt($9ddd7e9b53f7a2d4$var$_position$3, $9ddd7e9b53f7a2d4$var$_target, this.up);
        else $9ddd7e9b53f7a2d4$var$_m1$1.lookAt($9ddd7e9b53f7a2d4$var$_target, $9ddd7e9b53f7a2d4$var$_position$3, this.up);
        this.quaternion.setFromRotationMatrix($9ddd7e9b53f7a2d4$var$_m1$1);
        if (parent) {
            $9ddd7e9b53f7a2d4$var$_m1$1.extractRotation(parent.matrixWorld);
            $9ddd7e9b53f7a2d4$var$_q1.setFromRotationMatrix($9ddd7e9b53f7a2d4$var$_m1$1);
            this.quaternion.premultiply($9ddd7e9b53f7a2d4$var$_q1.invert());
        }
    }
    /**
	 * Adds the given 3D object as a child to this 3D object. An arbitrary number of
	 * objects may be added. Any current parent on an object passed in here will be
	 * removed, since an object can have at most one parent.
	 *
	 * @fires Object3D#added
	 * @fires Object3D#childadded
	 * @param {Object3D} object - The 3D object to add.
	 * @return {Object3D} A reference to this instance.
	 */ add(object) {
        if (arguments.length > 1) {
            for(let i = 0; i < arguments.length; i++)this.add(arguments[i]);
            return this;
        }
        if (object === this) {
            console.error('THREE.Object3D.add: object can\'t be added as a child of itself.', object);
            return this;
        }
        if (object && object.isObject3D) {
            object.removeFromParent();
            object.parent = this;
            this.children.push(object);
            object.dispatchEvent($9ddd7e9b53f7a2d4$var$_addedEvent);
            $9ddd7e9b53f7a2d4$var$_childaddedEvent.child = object;
            this.dispatchEvent($9ddd7e9b53f7a2d4$var$_childaddedEvent);
            $9ddd7e9b53f7a2d4$var$_childaddedEvent.child = null;
        } else console.error('THREE.Object3D.add: object not an instance of THREE.Object3D.', object);
        return this;
    }
    /**
	 * Removes the given 3D object as child from this 3D object.
	 * An arbitrary number of objects may be removed.
	 *
	 * @fires Object3D#removed
	 * @fires Object3D#childremoved
	 * @param {Object3D} object - The 3D object to remove.
	 * @return {Object3D} A reference to this instance.
	 */ remove(object) {
        if (arguments.length > 1) {
            for(let i = 0; i < arguments.length; i++)this.remove(arguments[i]);
            return this;
        }
        const index = this.children.indexOf(object);
        if (index !== -1) {
            object.parent = null;
            this.children.splice(index, 1);
            object.dispatchEvent($9ddd7e9b53f7a2d4$var$_removedEvent);
            $9ddd7e9b53f7a2d4$var$_childremovedEvent.child = object;
            this.dispatchEvent($9ddd7e9b53f7a2d4$var$_childremovedEvent);
            $9ddd7e9b53f7a2d4$var$_childremovedEvent.child = null;
        }
        return this;
    }
    /**
	 * Removes this 3D object from its current parent.
	 *
	 * @fires Object3D#removed
	 * @fires Object3D#childremoved
	 * @return {Object3D} A reference to this instance.
	 */ removeFromParent() {
        const parent = this.parent;
        if (parent !== null) parent.remove(this);
        return this;
    }
    /**
	 * Removes all child objects.
	 *
	 * @fires Object3D#removed
	 * @fires Object3D#childremoved
	 * @return {Object3D} A reference to this instance.
	 */ clear() {
        return this.remove(...this.children);
    }
    /**
	 * Adds the given 3D object as a child of this 3D object, while maintaining the object's world
	 * transform. This method does not support scene graphs having non-uniformly-scaled nodes(s).
	 *
	 * @fires Object3D#added
	 * @fires Object3D#childadded
	 * @param {Object3D} object - The 3D object to attach.
	 * @return {Object3D} A reference to this instance.
	 */ attach(object) {
        // adds object as a child of this, while maintaining the object's world transform
        // Note: This method does not support scene graphs having non-uniformly-scaled nodes(s)
        this.updateWorldMatrix(true, false);
        $9ddd7e9b53f7a2d4$var$_m1$1.copy(this.matrixWorld).invert();
        if (object.parent !== null) {
            object.parent.updateWorldMatrix(true, false);
            $9ddd7e9b53f7a2d4$var$_m1$1.multiply(object.parent.matrixWorld);
        }
        object.applyMatrix4($9ddd7e9b53f7a2d4$var$_m1$1);
        object.removeFromParent();
        object.parent = this;
        this.children.push(object);
        object.updateWorldMatrix(false, true);
        object.dispatchEvent($9ddd7e9b53f7a2d4$var$_addedEvent);
        $9ddd7e9b53f7a2d4$var$_childaddedEvent.child = object;
        this.dispatchEvent($9ddd7e9b53f7a2d4$var$_childaddedEvent);
        $9ddd7e9b53f7a2d4$var$_childaddedEvent.child = null;
        return this;
    }
    /**
	 * Searches through the 3D object and its children, starting with the 3D object
	 * itself, and returns the first with a matching ID.
	 *
	 * @param {number} id - The id.
	 * @return {Object3D|undefined} The found 3D object. Returns `undefined` if no 3D object has been found.
	 */ getObjectById(id) {
        return this.getObjectByProperty('id', id);
    }
    /**
	 * Searches through the 3D object and its children, starting with the 3D object
	 * itself, and returns the first with a matching name.
	 *
	 * @param {string} name - The name.
	 * @return {Object3D|undefined} The found 3D object. Returns `undefined` if no 3D object has been found.
	 */ getObjectByName(name) {
        return this.getObjectByProperty('name', name);
    }
    /**
	 * Searches through the 3D object and its children, starting with the 3D object
	 * itself, and returns the first with a matching property value.
	 *
	 * @param {string} name - The name of the property.
	 * @param {any} value - The value.
	 * @return {Object3D|undefined} The found 3D object. Returns `undefined` if no 3D object has been found.
	 */ getObjectByProperty(name, value) {
        if (this[name] === value) return this;
        for(let i = 0, l = this.children.length; i < l; i++){
            const child = this.children[i];
            const object = child.getObjectByProperty(name, value);
            if (object !== undefined) return object;
        }
        return undefined;
    }
    /**
	 * Searches through the 3D object and its children, starting with the 3D object
	 * itself, and returns all 3D objects with a matching property value.
	 *
	 * @param {string} name - The name of the property.
	 * @param {any} value - The value.
	 * @param {Array<Object3D>} result - The method stores the result in this array.
	 * @return {Array<Object3D>} The found 3D objects.
	 */ getObjectsByProperty(name, value, result = []) {
        if (this[name] === value) result.push(this);
        const children = this.children;
        for(let i = 0, l = children.length; i < l; i++)children[i].getObjectsByProperty(name, value, result);
        return result;
    }
    /**
	 * Returns a vector representing the position of the 3D object in world space.
	 *
	 * @param {Vector3} target - The target vector the result is stored to.
	 * @return {Vector3} The 3D object's position in world space.
	 */ getWorldPosition(target) {
        this.updateWorldMatrix(true, false);
        return target.setFromMatrixPosition(this.matrixWorld);
    }
    /**
	 * Returns a Quaternion representing the position of the 3D object in world space.
	 *
	 * @param {Quaternion} target - The target Quaternion the result is stored to.
	 * @return {Quaternion} The 3D object's rotation in world space.
	 */ getWorldQuaternion(target) {
        this.updateWorldMatrix(true, false);
        this.matrixWorld.decompose($9ddd7e9b53f7a2d4$var$_position$3, target, $9ddd7e9b53f7a2d4$var$_scale$2);
        return target;
    }
    /**
	 * Returns a vector representing the scale of the 3D object in world space.
	 *
	 * @param {Vector3} target - The target vector the result is stored to.
	 * @return {Vector3} The 3D object's scale in world space.
	 */ getWorldScale(target) {
        this.updateWorldMatrix(true, false);
        this.matrixWorld.decompose($9ddd7e9b53f7a2d4$var$_position$3, $9ddd7e9b53f7a2d4$var$_quaternion$2, target);
        return target;
    }
    /**
	 * Returns a vector representing the ("look") direction of the 3D object in world space.
	 *
	 * @param {Vector3} target - The target vector the result is stored to.
	 * @return {Vector3} The 3D object's direction in world space.
	 */ getWorldDirection(target) {
        this.updateWorldMatrix(true, false);
        const e = this.matrixWorld.elements;
        return target.set(e[8], e[9], e[10]).normalize();
    }
    /**
	 * Abstract method to get intersections between a casted ray and this
	 * 3D object. Renderable 3D objects such as {@link Mesh}, {@link Line} or {@link Points}
	 * implement this method in order to use raycasting.
	 *
	 * @abstract
	 * @param {Raycaster} raycaster - The raycaster.
	 * @param {Array<Object>} intersects - An array holding the result of the method.
	 */ raycast() {}
    /**
	 * Executes the callback on this 3D object and all descendants.
	 *
	 * Note: Modifying the scene graph inside the callback is discouraged.
	 *
	 * @param {Function} callback - A callback function that allows to process the current 3D object.
	 */ traverse(callback) {
        callback(this);
        const children = this.children;
        for(let i = 0, l = children.length; i < l; i++)children[i].traverse(callback);
    }
    /**
	 * Like {@link Object3D#traverse}, but the callback will only be executed for visible 3D objects.
	 * Descendants of invisible 3D objects are not traversed.
	 *
	 * Note: Modifying the scene graph inside the callback is discouraged.
	 *
	 * @param {Function} callback - A callback function that allows to process the current 3D object.
	 */ traverseVisible(callback) {
        if (this.visible === false) return;
        callback(this);
        const children = this.children;
        for(let i = 0, l = children.length; i < l; i++)children[i].traverseVisible(callback);
    }
    /**
	 * Like {@link Object3D#traverse}, but the callback will only be executed for all ancestors.
	 *
	 * Note: Modifying the scene graph inside the callback is discouraged.
	 *
	 * @param {Function} callback - A callback function that allows to process the current 3D object.
	 */ traverseAncestors(callback) {
        const parent = this.parent;
        if (parent !== null) {
            callback(parent);
            parent.traverseAncestors(callback);
        }
    }
    /**
	 * Updates the transformation matrix in local space by computing it from the current
	 * position, rotation and scale values.
	 */ updateMatrix() {
        this.matrix.compose(this.position, this.quaternion, this.scale);
        this.matrixWorldNeedsUpdate = true;
    }
    /**
	 * Updates the transformation matrix in world space of this 3D objects and its descendants.
	 *
	 * To ensure correct results, this method also recomputes the 3D object's transformation matrix in
	 * local space. The computation of the local and world matrix can be controlled with the
	 * {@link Object3D#matrixAutoUpdate} and {@link Object3D#matrixWorldAutoUpdate} flags which are both
	 * `true` by default.  Set these flags to `false` if you need more control over the update matrix process.
	 *
	 * @param {boolean} [force=false] - When set to `true`, a recomputation of world matrices is forced even
	 * when {@link Object3D#matrixWorldAutoUpdate} is set to `false`.
	 */ updateMatrixWorld(force) {
        if (this.matrixAutoUpdate) this.updateMatrix();
        if (this.matrixWorldNeedsUpdate || force) {
            if (this.matrixWorldAutoUpdate === true) {
                if (this.parent === null) this.matrixWorld.copy(this.matrix);
                else this.matrixWorld.multiplyMatrices(this.parent.matrixWorld, this.matrix);
            }
            this.matrixWorldNeedsUpdate = false;
            force = true;
        }
        // make sure descendants are updated if required
        const children = this.children;
        for(let i = 0, l = children.length; i < l; i++){
            const child = children[i];
            child.updateMatrixWorld(force);
        }
    }
    /**
	 * An alternative version of {@link Object3D#updateMatrixWorld} with more control over the
	 * update of ancestor and descendant nodes.
	 *
	 * @param {boolean} [updateParents=false] Whether ancestor nodes should be updated or not.
	 * @param {boolean} [updateChildren=false] Whether descendant nodes should be updated or not.
	 */ updateWorldMatrix(updateParents, updateChildren) {
        const parent = this.parent;
        if (updateParents === true && parent !== null) parent.updateWorldMatrix(true, false);
        if (this.matrixAutoUpdate) this.updateMatrix();
        if (this.matrixWorldAutoUpdate === true) {
            if (this.parent === null) this.matrixWorld.copy(this.matrix);
            else this.matrixWorld.multiplyMatrices(this.parent.matrixWorld, this.matrix);
        }
        // make sure descendants are updated
        if (updateChildren === true) {
            const children = this.children;
            for(let i = 0, l = children.length; i < l; i++){
                const child = children[i];
                child.updateWorldMatrix(false, true);
            }
        }
    }
    /**
	 * Serializes the 3D object into JSON.
	 *
	 * @param {?(Object|string)} meta - An optional value holding meta information about the serialization.
	 * @return {Object} A JSON object representing the serialized 3D object.
	 * @see {@link ObjectLoader#parse}
	 */ toJSON(meta) {
        // meta is a string when called from JSON.stringify
        const isRootObject = meta === undefined || typeof meta === 'string';
        const output = {};
        // meta is a hash used to collect geometries, materials.
        // not providing it implies that this is the root object
        // being serialized.
        if (isRootObject) {
            // initialize meta obj
            meta = {
                geometries: {},
                materials: {},
                textures: {},
                images: {},
                shapes: {},
                skeletons: {},
                animations: {},
                nodes: {}
            };
            output.metadata = {
                version: 4.6,
                type: 'Object',
                generator: 'Object3D.toJSON'
            };
        }
        // standard Object3D serialization
        const object = {};
        object.uuid = this.uuid;
        object.type = this.type;
        if (this.name !== '') object.name = this.name;
        if (this.castShadow === true) object.castShadow = true;
        if (this.receiveShadow === true) object.receiveShadow = true;
        if (this.visible === false) object.visible = false;
        if (this.frustumCulled === false) object.frustumCulled = false;
        if (this.renderOrder !== 0) object.renderOrder = this.renderOrder;
        if (Object.keys(this.userData).length > 0) object.userData = this.userData;
        object.layers = this.layers.mask;
        object.matrix = this.matrix.toArray();
        object.up = this.up.toArray();
        if (this.matrixAutoUpdate === false) object.matrixAutoUpdate = false;
        // object specific properties
        if (this.isInstancedMesh) {
            object.type = 'InstancedMesh';
            object.count = this.count;
            object.instanceMatrix = this.instanceMatrix.toJSON();
            if (this.instanceColor !== null) object.instanceColor = this.instanceColor.toJSON();
        }
        if (this.isBatchedMesh) {
            object.type = 'BatchedMesh';
            object.perObjectFrustumCulled = this.perObjectFrustumCulled;
            object.sortObjects = this.sortObjects;
            object.drawRanges = this._drawRanges;
            object.reservedRanges = this._reservedRanges;
            object.visibility = this._visibility;
            object.active = this._active;
            object.bounds = this._bounds.map((bound)=>({
                    boxInitialized: bound.boxInitialized,
                    boxMin: bound.box.min.toArray(),
                    boxMax: bound.box.max.toArray(),
                    sphereInitialized: bound.sphereInitialized,
                    sphereRadius: bound.sphere.radius,
                    sphereCenter: bound.sphere.center.toArray()
                }));
            object.maxInstanceCount = this._maxInstanceCount;
            object.maxVertexCount = this._maxVertexCount;
            object.maxIndexCount = this._maxIndexCount;
            object.geometryInitialized = this._geometryInitialized;
            object.geometryCount = this._geometryCount;
            object.matricesTexture = this._matricesTexture.toJSON(meta);
            if (this._colorsTexture !== null) object.colorsTexture = this._colorsTexture.toJSON(meta);
            if (this.boundingSphere !== null) object.boundingSphere = {
                center: object.boundingSphere.center.toArray(),
                radius: object.boundingSphere.radius
            };
            if (this.boundingBox !== null) object.boundingBox = {
                min: object.boundingBox.min.toArray(),
                max: object.boundingBox.max.toArray()
            };
        }
        //
        function serialize(library, element) {
            if (library[element.uuid] === undefined) library[element.uuid] = element.toJSON(meta);
            return element.uuid;
        }
        if (this.isScene) {
            if (this.background) {
                if (this.background.isColor) object.background = this.background.toJSON();
                else if (this.background.isTexture) object.background = this.background.toJSON(meta).uuid;
            }
            if (this.environment && this.environment.isTexture && this.environment.isRenderTargetTexture !== true) object.environment = this.environment.toJSON(meta).uuid;
        } else if (this.isMesh || this.isLine || this.isPoints) {
            object.geometry = serialize(meta.geometries, this.geometry);
            const parameters = this.geometry.parameters;
            if (parameters !== undefined && parameters.shapes !== undefined) {
                const shapes = parameters.shapes;
                if (Array.isArray(shapes)) for(let i = 0, l = shapes.length; i < l; i++){
                    const shape = shapes[i];
                    serialize(meta.shapes, shape);
                }
                else serialize(meta.shapes, shapes);
            }
        }
        if (this.isSkinnedMesh) {
            object.bindMode = this.bindMode;
            object.bindMatrix = this.bindMatrix.toArray();
            if (this.skeleton !== undefined) {
                serialize(meta.skeletons, this.skeleton);
                object.skeleton = this.skeleton.uuid;
            }
        }
        if (this.material !== undefined) {
            if (Array.isArray(this.material)) {
                const uuids = [];
                for(let i = 0, l = this.material.length; i < l; i++)uuids.push(serialize(meta.materials, this.material[i]));
                object.material = uuids;
            } else object.material = serialize(meta.materials, this.material);
        }
        //
        if (this.children.length > 0) {
            object.children = [];
            for(let i = 0; i < this.children.length; i++)object.children.push(this.children[i].toJSON(meta).object);
        }
        //
        if (this.animations.length > 0) {
            object.animations = [];
            for(let i = 0; i < this.animations.length; i++){
                const animation = this.animations[i];
                object.animations.push(serialize(meta.animations, animation));
            }
        }
        if (isRootObject) {
            const geometries = extractFromCache(meta.geometries);
            const materials = extractFromCache(meta.materials);
            const textures = extractFromCache(meta.textures);
            const images = extractFromCache(meta.images);
            const shapes = extractFromCache(meta.shapes);
            const skeletons = extractFromCache(meta.skeletons);
            const animations = extractFromCache(meta.animations);
            const nodes = extractFromCache(meta.nodes);
            if (geometries.length > 0) output.geometries = geometries;
            if (materials.length > 0) output.materials = materials;
            if (textures.length > 0) output.textures = textures;
            if (images.length > 0) output.images = images;
            if (shapes.length > 0) output.shapes = shapes;
            if (skeletons.length > 0) output.skeletons = skeletons;
            if (animations.length > 0) output.animations = animations;
            if (nodes.length > 0) output.nodes = nodes;
        }
        output.object = object;
        return output;
        // extract data from the cache hash
        // remove metadata on each item
        // and return as array
        function extractFromCache(cache) {
            const values = [];
            for(const key in cache){
                const data = cache[key];
                delete data.metadata;
                values.push(data);
            }
            return values;
        }
    }
    /**
	 * Returns a new 3D object with copied values from this instance.
	 *
	 * @param {boolean} [recursive=true] - When set to `true`, descendants of the 3D object are also cloned.
	 * @return {Object3D} A clone of this instance.
	 */ clone(recursive) {
        return new this.constructor().copy(this, recursive);
    }
    /**
	 * Copies the values of the given 3D object to this instance.
	 *
	 * @param {Object3D} source - The 3D object to copy.
	 * @param {boolean} [recursive=true] - When set to `true`, descendants of the 3D object are cloned.
	 * @return {Object3D} A reference to this instance.
	 */ copy(source, recursive = true) {
        this.name = source.name;
        this.up.copy(source.up);
        this.position.copy(source.position);
        this.rotation.order = source.rotation.order;
        this.quaternion.copy(source.quaternion);
        this.scale.copy(source.scale);
        this.matrix.copy(source.matrix);
        this.matrixWorld.copy(source.matrixWorld);
        this.matrixAutoUpdate = source.matrixAutoUpdate;
        this.matrixWorldAutoUpdate = source.matrixWorldAutoUpdate;
        this.matrixWorldNeedsUpdate = source.matrixWorldNeedsUpdate;
        this.layers.mask = source.layers.mask;
        this.visible = source.visible;
        this.castShadow = source.castShadow;
        this.receiveShadow = source.receiveShadow;
        this.frustumCulled = source.frustumCulled;
        this.renderOrder = source.renderOrder;
        this.animations = source.animations.slice();
        this.userData = JSON.parse(JSON.stringify(source.userData));
        if (recursive === true) for(let i = 0; i < source.children.length; i++){
            const child = source.children[i];
            this.add(child.clone());
        }
        return this;
    }
}
/**
 * The default up direction for objects, also used as the default
 * position for {@link DirectionalLight} and {@link HemisphereLight}.
 *
 * @static
 * @type {Vector3}
 * @default (0,1,0)
 */ $9ddd7e9b53f7a2d4$export$e4dd07dff30cc924.DEFAULT_UP = /*@__PURE__*/ new $9ddd7e9b53f7a2d4$export$64b5c384219d3699(0, 1, 0);
/**
 * The default setting for {@link Object3D#matrixAutoUpdate} for
 * newly created 3D objects.
 *
 * @static
 * @type {boolean}
 * @default true
 */ $9ddd7e9b53f7a2d4$export$e4dd07dff30cc924.DEFAULT_MATRIX_AUTO_UPDATE = true;
/**
 * The default setting for {@link Object3D#matrixWorldAutoUpdate} for
 * newly created 3D objects.
 *
 * @static
 * @type {boolean}
 * @default true
 */ $9ddd7e9b53f7a2d4$export$e4dd07dff30cc924.DEFAULT_MATRIX_WORLD_AUTO_UPDATE = true;
const $9ddd7e9b53f7a2d4$var$_v0$1 = /*@__PURE__*/ new $9ddd7e9b53f7a2d4$export$64b5c384219d3699();
const $9ddd7e9b53f7a2d4$var$_v1$3 = /*@__PURE__*/ new $9ddd7e9b53f7a2d4$export$64b5c384219d3699();
const $9ddd7e9b53f7a2d4$var$_v2$2 = /*@__PURE__*/ new $9ddd7e9b53f7a2d4$export$64b5c384219d3699();
const $9ddd7e9b53f7a2d4$var$_v3$2 = /*@__PURE__*/ new $9ddd7e9b53f7a2d4$export$64b5c384219d3699();
const $9ddd7e9b53f7a2d4$var$_vab = /*@__PURE__*/ new $9ddd7e9b53f7a2d4$export$64b5c384219d3699();
const $9ddd7e9b53f7a2d4$var$_vac = /*@__PURE__*/ new $9ddd7e9b53f7a2d4$export$64b5c384219d3699();
const $9ddd7e9b53f7a2d4$var$_vbc = /*@__PURE__*/ new $9ddd7e9b53f7a2d4$export$64b5c384219d3699();
const $9ddd7e9b53f7a2d4$var$_vap = /*@__PURE__*/ new $9ddd7e9b53f7a2d4$export$64b5c384219d3699();
const $9ddd7e9b53f7a2d4$var$_vbp = /*@__PURE__*/ new $9ddd7e9b53f7a2d4$export$64b5c384219d3699();
const $9ddd7e9b53f7a2d4$var$_vcp = /*@__PURE__*/ new $9ddd7e9b53f7a2d4$export$64b5c384219d3699();
const $9ddd7e9b53f7a2d4$var$_v40 = /*@__PURE__*/ new $9ddd7e9b53f7a2d4$export$fa7daccca11cdbe3();
const $9ddd7e9b53f7a2d4$var$_v41 = /*@__PURE__*/ new $9ddd7e9b53f7a2d4$export$fa7daccca11cdbe3();
const $9ddd7e9b53f7a2d4$var$_v42 = /*@__PURE__*/ new $9ddd7e9b53f7a2d4$export$fa7daccca11cdbe3();
/**
 * A geometric triangle as defined by three vectors representing its three corners.
 */ class $9ddd7e9b53f7a2d4$export$5a465592bfe74b48 {
    /**
	 * Constructs a new triangle.
	 *
	 * @param {Vector3} [a=(0,0,0)] - The first corner of the triangle.
	 * @param {Vector3} [b=(0,0,0)] - The second corner of the triangle.
	 * @param {Vector3} [c=(0,0,0)] - The third corner of the triangle.
	 */ constructor(a = new $9ddd7e9b53f7a2d4$export$64b5c384219d3699(), b = new $9ddd7e9b53f7a2d4$export$64b5c384219d3699(), c = new $9ddd7e9b53f7a2d4$export$64b5c384219d3699()){
        /**
		 * The first corner of the triangle.
		 *
		 * @type {Vector3}
		 */ this.a = a;
        /**
		 * The second corner of the triangle.
		 *
		 * @type {Vector3}
		 */ this.b = b;
        /**
		 * The third corner of the triangle.
		 *
		 * @type {Vector3}
		 */ this.c = c;
    }
    /**
	 * Computes the normal vector of a triangle.
	 *
	 * @param {Vector3} a - The first corner of the triangle.
	 * @param {Vector3} b - The second corner of the triangle.
	 * @param {Vector3} c - The third corner of the triangle.
	 * @param {Vector3} target - The target vector that is used to store the method's result.
	 * @return {Vector3} The triangle's normal.
	 */ static getNormal(a, b, c, target) {
        target.subVectors(c, b);
        $9ddd7e9b53f7a2d4$var$_v0$1.subVectors(a, b);
        target.cross($9ddd7e9b53f7a2d4$var$_v0$1);
        const targetLengthSq = target.lengthSq();
        if (targetLengthSq > 0) return target.multiplyScalar(1 / Math.sqrt(targetLengthSq));
        return target.set(0, 0, 0);
    }
    /**
	 * Computes a barycentric coordinates from the given vector.
	 * Returns `null` if the triangle is degenerate.
	 *
	 * @param {Vector3} point - A point in 3D space.
	 * @param {Vector3} a - The first corner of the triangle.
	 * @param {Vector3} b - The second corner of the triangle.
	 * @param {Vector3} c - The third corner of the triangle.
	 * @param {Vector3} target - The target vector that is used to store the method's result.
	 * @return {?Vector3} The barycentric coordinates for the given point
	 */ static getBarycoord(point, a, b, c, target) {
        // based on: http://www.blackpawn.com/texts/pointinpoly/default.html
        $9ddd7e9b53f7a2d4$var$_v0$1.subVectors(c, a);
        $9ddd7e9b53f7a2d4$var$_v1$3.subVectors(b, a);
        $9ddd7e9b53f7a2d4$var$_v2$2.subVectors(point, a);
        const dot00 = $9ddd7e9b53f7a2d4$var$_v0$1.dot($9ddd7e9b53f7a2d4$var$_v0$1);
        const dot01 = $9ddd7e9b53f7a2d4$var$_v0$1.dot($9ddd7e9b53f7a2d4$var$_v1$3);
        const dot02 = $9ddd7e9b53f7a2d4$var$_v0$1.dot($9ddd7e9b53f7a2d4$var$_v2$2);
        const dot11 = $9ddd7e9b53f7a2d4$var$_v1$3.dot($9ddd7e9b53f7a2d4$var$_v1$3);
        const dot12 = $9ddd7e9b53f7a2d4$var$_v1$3.dot($9ddd7e9b53f7a2d4$var$_v2$2);
        const denom = dot00 * dot11 - dot01 * dot01;
        // collinear or singular triangle
        if (denom === 0) {
            target.set(0, 0, 0);
            return null;
        }
        const invDenom = 1 / denom;
        const u = (dot11 * dot02 - dot01 * dot12) * invDenom;
        const v = (dot00 * dot12 - dot01 * dot02) * invDenom;
        // barycentric coordinates must always sum to 1
        return target.set(1 - u - v, v, u);
    }
    /**
	 * Returns `true` if the given point, when projected onto the plane of the
	 * triangle, lies within the triangle.
	 *
	 * @param {Vector3} point - The point in 3D space to test.
	 * @param {Vector3} a - The first corner of the triangle.
	 * @param {Vector3} b - The second corner of the triangle.
	 * @param {Vector3} c - The third corner of the triangle.
	 * @return {boolean} Whether the given point, when projected onto the plane of the
	 * triangle, lies within the triangle or not.
	 */ static containsPoint(point, a, b, c) {
        // if the triangle is degenerate then we can't contain a point
        if (this.getBarycoord(point, a, b, c, $9ddd7e9b53f7a2d4$var$_v3$2) === null) return false;
        return $9ddd7e9b53f7a2d4$var$_v3$2.x >= 0 && $9ddd7e9b53f7a2d4$var$_v3$2.y >= 0 && $9ddd7e9b53f7a2d4$var$_v3$2.x + $9ddd7e9b53f7a2d4$var$_v3$2.y <= 1;
    }
    /**
	 * Computes the value barycentrically interpolated for the given point on the
	 * triangle. Returns `null` if the triangle is degenerate.
	 *
	 * @param {Vector3} point - Position of interpolated point.
	 * @param {Vector3} p1 - The first corner of the triangle.
	 * @param {Vector3} p2 - The second corner of the triangle.
	 * @param {Vector3} p3 - The third corner of the triangle.
	 * @param {Vector3} v1 - Value to interpolate of first vertex.
	 * @param {Vector3} v2 - Value to interpolate of second vertex.
	 * @param {Vector3} v3 - Value to interpolate of third vertex.
	 * @param {Vector3} target - The target vector that is used to store the method's result.
	 * @return {?Vector3} The interpolated value.
	 */ static getInterpolation(point, p1, p2, p3, v1, v2, v3, target) {
        if (this.getBarycoord(point, p1, p2, p3, $9ddd7e9b53f7a2d4$var$_v3$2) === null) {
            target.x = 0;
            target.y = 0;
            if ('z' in target) target.z = 0;
            if ('w' in target) target.w = 0;
            return null;
        }
        target.setScalar(0);
        target.addScaledVector(v1, $9ddd7e9b53f7a2d4$var$_v3$2.x);
        target.addScaledVector(v2, $9ddd7e9b53f7a2d4$var$_v3$2.y);
        target.addScaledVector(v3, $9ddd7e9b53f7a2d4$var$_v3$2.z);
        return target;
    }
    /**
	 * Computes the value barycentrically interpolated for the given attribute and indices.
	 *
	 * @param {BufferAttribute} attr - The attribute to interpolate.
	 * @param {number} i1 - Index of first vertex.
	 * @param {number} i2 - Index of second vertex.
	 * @param {number} i3 - Index of third vertex.
	 * @param {Vector3} barycoord - The barycoordinate value to use to interpolate.
	 * @param {Vector3} target - The target vector that is used to store the method's result.
	 * @return {Vector3} The interpolated attribute value.
	 */ static getInterpolatedAttribute(attr, i1, i2, i3, barycoord, target) {
        $9ddd7e9b53f7a2d4$var$_v40.setScalar(0);
        $9ddd7e9b53f7a2d4$var$_v41.setScalar(0);
        $9ddd7e9b53f7a2d4$var$_v42.setScalar(0);
        $9ddd7e9b53f7a2d4$var$_v40.fromBufferAttribute(attr, i1);
        $9ddd7e9b53f7a2d4$var$_v41.fromBufferAttribute(attr, i2);
        $9ddd7e9b53f7a2d4$var$_v42.fromBufferAttribute(attr, i3);
        target.setScalar(0);
        target.addScaledVector($9ddd7e9b53f7a2d4$var$_v40, barycoord.x);
        target.addScaledVector($9ddd7e9b53f7a2d4$var$_v41, barycoord.y);
        target.addScaledVector($9ddd7e9b53f7a2d4$var$_v42, barycoord.z);
        return target;
    }
    /**
	 * Returns `true` if the triangle is oriented towards the given direction.
	 *
	 * @param {Vector3} a - The first corner of the triangle.
	 * @param {Vector3} b - The second corner of the triangle.
	 * @param {Vector3} c - The third corner of the triangle.
	 * @param {Vector3} direction - The (normalized) direction vector.
	 * @return {boolean} Whether the triangle is oriented towards the given direction or not.
	 */ static isFrontFacing(a, b, c, direction) {
        $9ddd7e9b53f7a2d4$var$_v0$1.subVectors(c, b);
        $9ddd7e9b53f7a2d4$var$_v1$3.subVectors(a, b);
        // strictly front facing
        return $9ddd7e9b53f7a2d4$var$_v0$1.cross($9ddd7e9b53f7a2d4$var$_v1$3).dot(direction) < 0 ? true : false;
    }
    /**
	 * Sets the triangle's vertices by copying the given values.
	 *
	 * @param {Vector3} a - The first corner of the triangle.
	 * @param {Vector3} b - The second corner of the triangle.
	 * @param {Vector3} c - The third corner of the triangle.
	 * @return {Triangle} A reference to this triangle.
	 */ set(a, b, c) {
        this.a.copy(a);
        this.b.copy(b);
        this.c.copy(c);
        return this;
    }
    /**
	 * Sets the triangle's vertices by copying the given array values.
	 *
	 * @param {Array<Vector3>} points - An array with 3D points.
	 * @param {number} i0 - The array index representing the first corner of the triangle.
	 * @param {number} i1 - The array index representing the second corner of the triangle.
	 * @param {number} i2 - The array index representing the third corner of the triangle.
	 * @return {Triangle} A reference to this triangle.
	 */ setFromPointsAndIndices(points, i0, i1, i2) {
        this.a.copy(points[i0]);
        this.b.copy(points[i1]);
        this.c.copy(points[i2]);
        return this;
    }
    /**
	 * Sets the triangle's vertices by copying the given attribute values.
	 *
	 * @param {BufferAttribute} attribute - A buffer attribute with 3D points data.
	 * @param {number} i0 - The attribute index representing the first corner of the triangle.
	 * @param {number} i1 - The attribute index representing the second corner of the triangle.
	 * @param {number} i2 - The attribute index representing the third corner of the triangle.
	 * @return {Triangle} A reference to this triangle.
	 */ setFromAttributeAndIndices(attribute, i0, i1, i2) {
        this.a.fromBufferAttribute(attribute, i0);
        this.b.fromBufferAttribute(attribute, i1);
        this.c.fromBufferAttribute(attribute, i2);
        return this;
    }
    /**
	 * Returns a new triangle with copied values from this instance.
	 *
	 * @return {Triangle} A clone of this instance.
	 */ clone() {
        return new this.constructor().copy(this);
    }
    /**
	 * Copies the values of the given triangle to this instance.
	 *
	 * @param {Triangle} triangle - The triangle to copy.
	 * @return {Triangle} A reference to this triangle.
	 */ copy(triangle) {
        this.a.copy(triangle.a);
        this.b.copy(triangle.b);
        this.c.copy(triangle.c);
        return this;
    }
    /**
	 * Computes the area of the triangle.
	 *
	 * @return {number} The triangle's area.
	 */ getArea() {
        $9ddd7e9b53f7a2d4$var$_v0$1.subVectors(this.c, this.b);
        $9ddd7e9b53f7a2d4$var$_v1$3.subVectors(this.a, this.b);
        return $9ddd7e9b53f7a2d4$var$_v0$1.cross($9ddd7e9b53f7a2d4$var$_v1$3).length() * 0.5;
    }
    /**
	 * Computes the midpoint of the triangle.
	 *
	 * @param {Vector3} target - The target vector that is used to store the method's result.
	 * @return {Vector3} The triangle's midpoint.
	 */ getMidpoint(target) {
        return target.addVectors(this.a, this.b).add(this.c).multiplyScalar(1 / 3);
    }
    /**
	 * Computes the normal of the triangle.
	 *
	 * @param {Vector3} target - The target vector that is used to store the method's result.
	 * @return {Vector3} The triangle's normal.
	 */ getNormal(target) {
        return $9ddd7e9b53f7a2d4$export$5a465592bfe74b48.getNormal(this.a, this.b, this.c, target);
    }
    /**
	 * Computes a plane the triangle lies within.
	 *
	 * @param {Plane} target - The target vector that is used to store the method's result.
	 * @return {Plane} The plane the triangle lies within.
	 */ getPlane(target) {
        return target.setFromCoplanarPoints(this.a, this.b, this.c);
    }
    /**
	 * Computes a barycentric coordinates from the given vector.
	 * Returns `null` if the triangle is degenerate.
	 *
	 * @param {Vector3} point - A point in 3D space.
	 * @param {Vector3} target - The target vector that is used to store the method's result.
	 * @return {?Vector3} The barycentric coordinates for the given point
	 */ getBarycoord(point, target) {
        return $9ddd7e9b53f7a2d4$export$5a465592bfe74b48.getBarycoord(point, this.a, this.b, this.c, target);
    }
    /**
	 * Computes the value barycentrically interpolated for the given point on the
	 * triangle. Returns `null` if the triangle is degenerate.
	 *
	 * @param {Vector3} point - Position of interpolated point.
	 * @param {Vector3} v1 - Value to interpolate of first vertex.
	 * @param {Vector3} v2 - Value to interpolate of second vertex.
	 * @param {Vector3} v3 - Value to interpolate of third vertex.
	 * @param {Vector3} target - The target vector that is used to store the method's result.
	 * @return {?Vector3} The interpolated value.
	 */ getInterpolation(point, v1, v2, v3, target) {
        return $9ddd7e9b53f7a2d4$export$5a465592bfe74b48.getInterpolation(point, this.a, this.b, this.c, v1, v2, v3, target);
    }
    /**
	 * Returns `true` if the given point, when projected onto the plane of the
	 * triangle, lies within the triangle.
	 *
	 * @param {Vector3} point - The point in 3D space to test.
	 * @return {boolean} Whether the given point, when projected onto the plane of the
	 * triangle, lies within the triangle or not.
	 */ containsPoint(point) {
        return $9ddd7e9b53f7a2d4$export$5a465592bfe74b48.containsPoint(point, this.a, this.b, this.c);
    }
    /**
	 * Returns `true` if the triangle is oriented towards the given direction.
	 *
	 * @param {Vector3} direction - The (normalized) direction vector.
	 * @return {boolean} Whether the triangle is oriented towards the given direction or not.
	 */ isFrontFacing(direction) {
        return $9ddd7e9b53f7a2d4$export$5a465592bfe74b48.isFrontFacing(this.a, this.b, this.c, direction);
    }
    /**
	 * Returns `true` if this triangle intersects with the given box.
	 *
	 * @param {Box3} box - The box to intersect.
	 * @return {boolean} Whether this triangle intersects with the given box or not.
	 */ intersectsBox(box) {
        return box.intersectsTriangle(this);
    }
    /**
	 * Returns the closest point on the triangle to the given point.
	 *
	 * @param {Vector3} p - The point to compute the closest point for.
	 * @param {Vector3} target - The target vector that is used to store the method's result.
	 * @return {Vector3} The closest point on the triangle.
	 */ closestPointToPoint(p, target) {
        const a = this.a, b = this.b, c = this.c;
        let v, w;
        // algorithm thanks to Real-Time Collision Detection by Christer Ericson,
        // published by Morgan Kaufmann Publishers, (c) 2005 Elsevier Inc.,
        // under the accompanying license; see chapter 5.1.5 for detailed explanation.
        // basically, we're distinguishing which of the voronoi regions of the triangle
        // the point lies in with the minimum amount of redundant computation.
        $9ddd7e9b53f7a2d4$var$_vab.subVectors(b, a);
        $9ddd7e9b53f7a2d4$var$_vac.subVectors(c, a);
        $9ddd7e9b53f7a2d4$var$_vap.subVectors(p, a);
        const d1 = $9ddd7e9b53f7a2d4$var$_vab.dot($9ddd7e9b53f7a2d4$var$_vap);
        const d2 = $9ddd7e9b53f7a2d4$var$_vac.dot($9ddd7e9b53f7a2d4$var$_vap);
        if (d1 <= 0 && d2 <= 0) // vertex region of A; barycentric coords (1, 0, 0)
        return target.copy(a);
        $9ddd7e9b53f7a2d4$var$_vbp.subVectors(p, b);
        const d3 = $9ddd7e9b53f7a2d4$var$_vab.dot($9ddd7e9b53f7a2d4$var$_vbp);
        const d4 = $9ddd7e9b53f7a2d4$var$_vac.dot($9ddd7e9b53f7a2d4$var$_vbp);
        if (d3 >= 0 && d4 <= d3) // vertex region of B; barycentric coords (0, 1, 0)
        return target.copy(b);
        const vc = d1 * d4 - d3 * d2;
        if (vc <= 0 && d1 >= 0 && d3 <= 0) {
            v = d1 / (d1 - d3);
            // edge region of AB; barycentric coords (1-v, v, 0)
            return target.copy(a).addScaledVector($9ddd7e9b53f7a2d4$var$_vab, v);
        }
        $9ddd7e9b53f7a2d4$var$_vcp.subVectors(p, c);
        const d5 = $9ddd7e9b53f7a2d4$var$_vab.dot($9ddd7e9b53f7a2d4$var$_vcp);
        const d6 = $9ddd7e9b53f7a2d4$var$_vac.dot($9ddd7e9b53f7a2d4$var$_vcp);
        if (d6 >= 0 && d5 <= d6) // vertex region of C; barycentric coords (0, 0, 1)
        return target.copy(c);
        const vb = d5 * d2 - d1 * d6;
        if (vb <= 0 && d2 >= 0 && d6 <= 0) {
            w = d2 / (d2 - d6);
            // edge region of AC; barycentric coords (1-w, 0, w)
            return target.copy(a).addScaledVector($9ddd7e9b53f7a2d4$var$_vac, w);
        }
        const va = d3 * d6 - d5 * d4;
        if (va <= 0 && d4 - d3 >= 0 && d5 - d6 >= 0) {
            $9ddd7e9b53f7a2d4$var$_vbc.subVectors(c, b);
            w = (d4 - d3) / (d4 - d3 + (d5 - d6));
            // edge region of BC; barycentric coords (0, 1-w, w)
            return target.copy(b).addScaledVector($9ddd7e9b53f7a2d4$var$_vbc, w); // edge region of BC
        }
        // face region
        const denom = 1 / (va + vb + vc);
        // u = va * denom
        v = vb * denom;
        w = vc * denom;
        return target.copy(a).addScaledVector($9ddd7e9b53f7a2d4$var$_vab, v).addScaledVector($9ddd7e9b53f7a2d4$var$_vac, w);
    }
    /**
	 * Returns `true` if this triangle is equal with the given one.
	 *
	 * @param {Triangle} triangle - The triangle to test for equality.
	 * @return {boolean} Whether this triangle is equal with the given one.
	 */ equals(triangle) {
        return triangle.a.equals(this.a) && triangle.b.equals(this.b) && triangle.c.equals(this.c);
    }
}
const $9ddd7e9b53f7a2d4$var$_colorKeywords = {
    'aliceblue': 0xF0F8FF,
    'antiquewhite': 0xFAEBD7,
    'aqua': 0x00FFFF,
    'aquamarine': 0x7FFFD4,
    'azure': 0xF0FFFF,
    'beige': 0xF5F5DC,
    'bisque': 0xFFE4C4,
    'black': 0x000000,
    'blanchedalmond': 0xFFEBCD,
    'blue': 0x0000FF,
    'blueviolet': 0x8A2BE2,
    'brown': 0xA52A2A,
    'burlywood': 0xDEB887,
    'cadetblue': 0x5F9EA0,
    'chartreuse': 0x7FFF00,
    'chocolate': 0xD2691E,
    'coral': 0xFF7F50,
    'cornflowerblue': 0x6495ED,
    'cornsilk': 0xFFF8DC,
    'crimson': 0xDC143C,
    'cyan': 0x00FFFF,
    'darkblue': 0x00008B,
    'darkcyan': 0x008B8B,
    'darkgoldenrod': 0xB8860B,
    'darkgray': 0xA9A9A9,
    'darkgreen': 0x006400,
    'darkgrey': 0xA9A9A9,
    'darkkhaki': 0xBDB76B,
    'darkmagenta': 0x8B008B,
    'darkolivegreen': 0x556B2F,
    'darkorange': 0xFF8C00,
    'darkorchid': 0x9932CC,
    'darkred': 0x8B0000,
    'darksalmon': 0xE9967A,
    'darkseagreen': 0x8FBC8F,
    'darkslateblue': 0x483D8B,
    'darkslategray': 0x2F4F4F,
    'darkslategrey': 0x2F4F4F,
    'darkturquoise': 0x00CED1,
    'darkviolet': 0x9400D3,
    'deeppink': 0xFF1493,
    'deepskyblue': 0x00BFFF,
    'dimgray': 0x696969,
    'dimgrey': 0x696969,
    'dodgerblue': 0x1E90FF,
    'firebrick': 0xB22222,
    'floralwhite': 0xFFFAF0,
    'forestgreen': 0x228B22,
    'fuchsia': 0xFF00FF,
    'gainsboro': 0xDCDCDC,
    'ghostwhite': 0xF8F8FF,
    'gold': 0xFFD700,
    'goldenrod': 0xDAA520,
    'gray': 0x808080,
    'green': 0x008000,
    'greenyellow': 0xADFF2F,
    'grey': 0x808080,
    'honeydew': 0xF0FFF0,
    'hotpink': 0xFF69B4,
    'indianred': 0xCD5C5C,
    'indigo': 0x4B0082,
    'ivory': 0xFFFFF0,
    'khaki': 0xF0E68C,
    'lavender': 0xE6E6FA,
    'lavenderblush': 0xFFF0F5,
    'lawngreen': 0x7CFC00,
    'lemonchiffon': 0xFFFACD,
    'lightblue': 0xADD8E6,
    'lightcoral': 0xF08080,
    'lightcyan': 0xE0FFFF,
    'lightgoldenrodyellow': 0xFAFAD2,
    'lightgray': 0xD3D3D3,
    'lightgreen': 0x90EE90,
    'lightgrey': 0xD3D3D3,
    'lightpink': 0xFFB6C1,
    'lightsalmon': 0xFFA07A,
    'lightseagreen': 0x20B2AA,
    'lightskyblue': 0x87CEFA,
    'lightslategray': 0x778899,
    'lightslategrey': 0x778899,
    'lightsteelblue': 0xB0C4DE,
    'lightyellow': 0xFFFFE0,
    'lime': 0x00FF00,
    'limegreen': 0x32CD32,
    'linen': 0xFAF0E6,
    'magenta': 0xFF00FF,
    'maroon': 0x800000,
    'mediumaquamarine': 0x66CDAA,
    'mediumblue': 0x0000CD,
    'mediumorchid': 0xBA55D3,
    'mediumpurple': 0x9370DB,
    'mediumseagreen': 0x3CB371,
    'mediumslateblue': 0x7B68EE,
    'mediumspringgreen': 0x00FA9A,
    'mediumturquoise': 0x48D1CC,
    'mediumvioletred': 0xC71585,
    'midnightblue': 0x191970,
    'mintcream': 0xF5FFFA,
    'mistyrose': 0xFFE4E1,
    'moccasin': 0xFFE4B5,
    'navajowhite': 0xFFDEAD,
    'navy': 0x000080,
    'oldlace': 0xFDF5E6,
    'olive': 0x808000,
    'olivedrab': 0x6B8E23,
    'orange': 0xFFA500,
    'orangered': 0xFF4500,
    'orchid': 0xDA70D6,
    'palegoldenrod': 0xEEE8AA,
    'palegreen': 0x98FB98,
    'paleturquoise': 0xAFEEEE,
    'palevioletred': 0xDB7093,
    'papayawhip': 0xFFEFD5,
    'peachpuff': 0xFFDAB9,
    'peru': 0xCD853F,
    'pink': 0xFFC0CB,
    'plum': 0xDDA0DD,
    'powderblue': 0xB0E0E6,
    'purple': 0x800080,
    'rebeccapurple': 0x663399,
    'red': 0xFF0000,
    'rosybrown': 0xBC8F8F,
    'royalblue': 0x4169E1,
    'saddlebrown': 0x8B4513,
    'salmon': 0xFA8072,
    'sandybrown': 0xF4A460,
    'seagreen': 0x2E8B57,
    'seashell': 0xFFF5EE,
    'sienna': 0xA0522D,
    'silver': 0xC0C0C0,
    'skyblue': 0x87CEEB,
    'slateblue': 0x6A5ACD,
    'slategray': 0x708090,
    'slategrey': 0x708090,
    'snow': 0xFFFAFA,
    'springgreen': 0x00FF7F,
    'steelblue': 0x4682B4,
    'tan': 0xD2B48C,
    'teal': 0x008080,
    'thistle': 0xD8BFD8,
    'tomato': 0xFF6347,
    'turquoise': 0x40E0D0,
    'violet': 0xEE82EE,
    'wheat': 0xF5DEB3,
    'white': 0xFFFFFF,
    'whitesmoke': 0xF5F5F5,
    'yellow': 0xFFFF00,
    'yellowgreen': 0x9ACD32
};
const $9ddd7e9b53f7a2d4$var$_hslA = {
    h: 0,
    s: 0,
    l: 0
};
const $9ddd7e9b53f7a2d4$var$_hslB = {
    h: 0,
    s: 0,
    l: 0
};
function $9ddd7e9b53f7a2d4$var$hue2rgb(p, q, t) {
    if (t < 0) t += 1;
    if (t > 1) t -= 1;
    if (t < 1 / 6) return p + (q - p) * 6 * t;
    if (t < 0.5) return q;
    if (t < 2 / 3) return p + (q - p) * 6 * (2 / 3 - t);
    return p;
}
/**
 * A Color instance is represented by RGB components in the linear <i>working
 * color space</i>, which defaults to `LinearSRGBColorSpace`. Inputs
 * conventionally using `SRGBColorSpace` (such as hexadecimals and CSS
 * strings) are converted to the working color space automatically.
 *
 * ```js
 * // converted automatically from SRGBColorSpace to LinearSRGBColorSpace
 * const color = new THREE.Color().setHex( 0x112233 );
 * ```
 * Source color spaces may be specified explicitly, to ensure correct conversions.
 * ```js
 * // assumed already LinearSRGBColorSpace; no conversion
 * const color = new THREE.Color().setRGB( 0.5, 0.5, 0.5 );
 *
 * // converted explicitly from SRGBColorSpace to LinearSRGBColorSpace
 * const color = new THREE.Color().setRGB( 0.5, 0.5, 0.5, SRGBColorSpace );
 * ```
 * If THREE.ColorManagement is disabled, no conversions occur. For details,
 * see <i>Color management</i>. Iterating through a Color instance will yield
 * its components (r, g, b) in the corresponding order. A Color can be initialised
 * in any of the following ways:
 * ```js
 * //empty constructor - will default white
 * const color1 = new THREE.Color();
 *
 * //Hexadecimal color (recommended)
 * const color2 = new THREE.Color( 0xff0000 );
 *
 * //RGB string
 * const color3 = new THREE.Color("rgb(255, 0, 0)");
 * const color4 = new THREE.Color("rgb(100%, 0%, 0%)");
 *
 * //X11 color name - all 140 color names are supported.
 * //Note the lack of CamelCase in the name
 * const color5 = new THREE.Color( 'skyblue' );
 * //HSL string
 * const color6 = new THREE.Color("hsl(0, 100%, 50%)");
 *
 * //Separate RGB values between 0 and 1
 * const color7 = new THREE.Color( 1, 0, 0 );
 * ```
 */ class $9ddd7e9b53f7a2d4$export$892596cec99bc70e {
    /**
	 * Constructs a new color.
	 *
	 * Note that standard method of specifying color in three.js is with a hexadecimal triplet,
	 * and that method is used throughout the rest of the documentation.
	 *
	 * @param {(number|string|Color)} [r] - The red component of the color. If `g` and `b` are
	 * not provided, it can be hexadecimal triplet, a CSS-style string or another `Color` instance.
	 * @param {number} [g] - The green component.
	 * @param {number} [b] - The blue component.
	 */ constructor(r, g, b){
        /**
		 * This flag can be used for type testing.
		 *
		 * @type {boolean}
		 * @readonly
		 * @default true
		 */ this.isColor = true;
        /**
		 * The red component.
		 *
		 * @type {number}
		 * @default 1
		 */ this.r = 1;
        /**
		 * The green component.
		 *
		 * @type {number}
		 * @default 1
		 */ this.g = 1;
        /**
		 * The blue component.
		 *
		 * @type {number}
		 * @default 1
		 */ this.b = 1;
        return this.set(r, g, b);
    }
    /**
	 * Sets the colors's components from the given values.
	 *
	 * @param {(number|string|Color)} [r] - The red component of the color. If `g` and `b` are
	 * not provided, it can be hexadecimal triplet, a CSS-style string or another `Color` instance.
	 * @param {number} [g] - The green component.
	 * @param {number} [b] - The blue component.
	 * @return {Color} A reference to this color.
	 */ set(r, g, b) {
        if (g === undefined && b === undefined) {
            // r is THREE.Color, hex or string
            const value = r;
            if (value && value.isColor) this.copy(value);
            else if (typeof value === 'number') this.setHex(value);
            else if (typeof value === 'string') this.setStyle(value);
        } else this.setRGB(r, g, b);
        return this;
    }
    /**
	 * Sets the colors's components to the given scalar value.
	 *
	 * @param {number} scalar - The scalar value.
	 * @return {Color} A reference to this color.
	 */ setScalar(scalar) {
        this.r = scalar;
        this.g = scalar;
        this.b = scalar;
        return this;
    }
    /**
	 * Sets this color from a hexadecimal value.
	 *
	 * @param {number} hex - The hexadecimal value.
	 * @param {string} [colorSpace=SRGBColorSpace] - The color space.
	 * @return {Color} A reference to this color.
	 */ setHex(hex, colorSpace = $9ddd7e9b53f7a2d4$export$561f394b24edfcaa) {
        hex = Math.floor(hex);
        this.r = (hex >> 16 & 255) / 255;
        this.g = (hex >> 8 & 255) / 255;
        this.b = (hex & 255) / 255;
        $9ddd7e9b53f7a2d4$export$5e6fd513f44698c.toWorkingColorSpace(this, colorSpace);
        return this;
    }
    /**
	 * Sets this color from RGB values.
	 *
	 * @param {number} r - Red channel value between `0.0` and `1.0`.
	 * @param {number} g - Green channel value between `0.0` and `1.0`.
	 * @param {number} b - Blue channel value between `0.0` and `1.0`.
	 * @param {string} [colorSpace=ColorManagement.workingColorSpace] - The color space.
	 * @return {Color} A reference to this color.
	 */ setRGB(r, g, b, colorSpace = $9ddd7e9b53f7a2d4$export$5e6fd513f44698c.workingColorSpace) {
        this.r = r;
        this.g = g;
        this.b = b;
        $9ddd7e9b53f7a2d4$export$5e6fd513f44698c.toWorkingColorSpace(this, colorSpace);
        return this;
    }
    /**
	 * Sets this color from RGB values.
	 *
	 * @param {number} h - Hue value between `0.0` and `1.0`.
	 * @param {number} s - Saturation value between `0.0` and `1.0`.
	 * @param {number} l - Lightness value between `0.0` and `1.0`.
	 * @param {string} [colorSpace=ColorManagement.workingColorSpace] - The color space.
	 * @return {Color} A reference to this color.
	 */ setHSL(h, s, l, colorSpace = $9ddd7e9b53f7a2d4$export$5e6fd513f44698c.workingColorSpace) {
        // h,s,l ranges are in 0.0 - 1.0
        h = $9ddd7e9b53f7a2d4$var$euclideanModulo(h, 1);
        s = $9ddd7e9b53f7a2d4$var$clamp(s, 0, 1);
        l = $9ddd7e9b53f7a2d4$var$clamp(l, 0, 1);
        if (s === 0) this.r = this.g = this.b = l;
        else {
            const p = l <= 0.5 ? l * (1 + s) : l + s - l * s;
            const q = 2 * l - p;
            this.r = $9ddd7e9b53f7a2d4$var$hue2rgb(q, p, h + 1 / 3);
            this.g = $9ddd7e9b53f7a2d4$var$hue2rgb(q, p, h);
            this.b = $9ddd7e9b53f7a2d4$var$hue2rgb(q, p, h - 1 / 3);
        }
        $9ddd7e9b53f7a2d4$export$5e6fd513f44698c.toWorkingColorSpace(this, colorSpace);
        return this;
    }
    /**
	 * Sets this color from a CSS-style string. For example, `rgb(250, 0,0)`,
	 * `rgb(100%, 0%, 0%)`, `hsl(0, 100%, 50%)`, `#ff0000`, `#f00`, or `red` ( or
	 * any [X11 color name]{@link https://en.wikipedia.org/wiki/X11_color_names#Color_name_chart} -
	 * all 140 color names are supported).
	 *
	 * @param {string} style - Color as a CSS-style string.
	 * @param {string} [colorSpace=SRGBColorSpace] - The color space.
	 * @return {Color} A reference to this color.
	 */ setStyle(style, colorSpace = $9ddd7e9b53f7a2d4$export$561f394b24edfcaa) {
        function handleAlpha(string) {
            if (string === undefined) return;
            if (parseFloat(string) < 1) console.warn('THREE.Color: Alpha component of ' + style + ' will be ignored.');
        }
        let m;
        if (m = /^(\w+)\(([^\)]*)\)/.exec(style)) {
            // rgb / hsl
            let color;
            const name = m[1];
            const components = m[2];
            switch(name){
                case 'rgb':
                case 'rgba':
                    if (color = /^\s*(\d+)\s*,\s*(\d+)\s*,\s*(\d+)\s*(?:,\s*(\d*\.?\d+)\s*)?$/.exec(components)) {
                        // rgb(255,0,0) rgba(255,0,0,0.5)
                        handleAlpha(color[4]);
                        return this.setRGB(Math.min(255, parseInt(color[1], 10)) / 255, Math.min(255, parseInt(color[2], 10)) / 255, Math.min(255, parseInt(color[3], 10)) / 255, colorSpace);
                    }
                    if (color = /^\s*(\d+)\%\s*,\s*(\d+)\%\s*,\s*(\d+)\%\s*(?:,\s*(\d*\.?\d+)\s*)?$/.exec(components)) {
                        // rgb(100%,0%,0%) rgba(100%,0%,0%,0.5)
                        handleAlpha(color[4]);
                        return this.setRGB(Math.min(100, parseInt(color[1], 10)) / 100, Math.min(100, parseInt(color[2], 10)) / 100, Math.min(100, parseInt(color[3], 10)) / 100, colorSpace);
                    }
                    break;
                case 'hsl':
                case 'hsla':
                    if (color = /^\s*(\d*\.?\d+)\s*,\s*(\d*\.?\d+)\%\s*,\s*(\d*\.?\d+)\%\s*(?:,\s*(\d*\.?\d+)\s*)?$/.exec(components)) {
                        // hsl(120,50%,50%) hsla(120,50%,50%,0.5)
                        handleAlpha(color[4]);
                        return this.setHSL(parseFloat(color[1]) / 360, parseFloat(color[2]) / 100, parseFloat(color[3]) / 100, colorSpace);
                    }
                    break;
                default:
                    console.warn('THREE.Color: Unknown color model ' + style);
            }
        } else if (m = /^\#([A-Fa-f\d]+)$/.exec(style)) {
            // hex color
            const hex = m[1];
            const size = hex.length;
            if (size === 3) // #ff0
            return this.setRGB(parseInt(hex.charAt(0), 16) / 15, parseInt(hex.charAt(1), 16) / 15, parseInt(hex.charAt(2), 16) / 15, colorSpace);
            else if (size === 6) // #ff0000
            return this.setHex(parseInt(hex, 16), colorSpace);
            else console.warn('THREE.Color: Invalid hex color ' + style);
        } else if (style && style.length > 0) return this.setColorName(style, colorSpace);
        return this;
    }
    /**
	 * Sets this color from a color name. Faster than {@link Color#setStyle} if
	 * you don't need the other CSS-style formats.
	 *
	 * For convenience, the list of names is exposed in `Color.NAMES` as a hash.
	 * ```js
	 * Color.NAMES.aliceblue // returns 0xF0F8FF
	 * ```
	 *
	 * @param {string} style - The color name.
	 * @param {string} [colorSpace=SRGBColorSpace] - The color space.
	 * @return {Color} A reference to this color.
	 */ setColorName(style, colorSpace = $9ddd7e9b53f7a2d4$export$561f394b24edfcaa) {
        // color keywords
        const hex = $9ddd7e9b53f7a2d4$var$_colorKeywords[style.toLowerCase()];
        if (hex !== undefined) // red
        this.setHex(hex, colorSpace);
        else // unknown color
        console.warn('THREE.Color: Unknown color ' + style);
        return this;
    }
    /**
	 * Returns a new color with copied values from this instance.
	 *
	 * @return {Color} A clone of this instance.
	 */ clone() {
        return new this.constructor(this.r, this.g, this.b);
    }
    /**
	 * Copies the values of the given color to this instance.
	 *
	 * @param {Color} color - The color to copy.
	 * @return {Color} A reference to this color.
	 */ copy(color) {
        this.r = color.r;
        this.g = color.g;
        this.b = color.b;
        return this;
    }
    /**
	 * Copies the given color into this color, and then converts this color from
	 * `SRGBColorSpace` to `LinearSRGBColorSpace`.
	 *
	 * @param {Color} color - The color to copy/convert.
	 * @return {Color} A reference to this color.
	 */ copySRGBToLinear(color) {
        this.r = $9ddd7e9b53f7a2d4$var$SRGBToLinear(color.r);
        this.g = $9ddd7e9b53f7a2d4$var$SRGBToLinear(color.g);
        this.b = $9ddd7e9b53f7a2d4$var$SRGBToLinear(color.b);
        return this;
    }
    /**
	 * Copies the given color into this color, and then converts this color from
	 * `LinearSRGBColorSpace` to `SRGBColorSpace`.
	 *
	 * @param {Color} color - The color to copy/convert.
	 * @return {Color} A reference to this color.
	 */ copyLinearToSRGB(color) {
        this.r = $9ddd7e9b53f7a2d4$var$LinearToSRGB(color.r);
        this.g = $9ddd7e9b53f7a2d4$var$LinearToSRGB(color.g);
        this.b = $9ddd7e9b53f7a2d4$var$LinearToSRGB(color.b);
        return this;
    }
    /**
	 * Converts this color from `SRGBColorSpace` to `LinearSRGBColorSpace`.
	 *
	 * @return {Color} A reference to this color.
	 */ convertSRGBToLinear() {
        this.copySRGBToLinear(this);
        return this;
    }
    /**
	 * Converts this color from `LinearSRGBColorSpace` to `SRGBColorSpace`.
	 *
	 * @return {Color} A reference to this color.
	 */ convertLinearToSRGB() {
        this.copyLinearToSRGB(this);
        return this;
    }
    /**
	 * Returns the hexadecimal value of this color.
	 *
	 * @param {string} [colorSpace=SRGBColorSpace] - The color space.
	 * @return {number} The hexadecimal value.
	 */ getHex(colorSpace = $9ddd7e9b53f7a2d4$export$561f394b24edfcaa) {
        $9ddd7e9b53f7a2d4$export$5e6fd513f44698c.fromWorkingColorSpace($9ddd7e9b53f7a2d4$var$_color.copy(this), colorSpace);
        return Math.round($9ddd7e9b53f7a2d4$var$clamp($9ddd7e9b53f7a2d4$var$_color.r * 255, 0, 255)) * 65536 + Math.round($9ddd7e9b53f7a2d4$var$clamp($9ddd7e9b53f7a2d4$var$_color.g * 255, 0, 255)) * 256 + Math.round($9ddd7e9b53f7a2d4$var$clamp($9ddd7e9b53f7a2d4$var$_color.b * 255, 0, 255));
    }
    /**
	 * Returns the hexadecimal value of this color as a string (for example, 'FFFFFF').
	 *
	 * @param {string} [colorSpace=SRGBColorSpace] - The color space.
	 * @return {string} The hexadecimal value as a string.
	 */ getHexString(colorSpace = $9ddd7e9b53f7a2d4$export$561f394b24edfcaa) {
        return ('000000' + this.getHex(colorSpace).toString(16)).slice(-6);
    }
    /**
	 * Converts the colors RGB values into the HSL format and stores them into the
	 * given target object.
	 *
	 * @param {{h:number,s:number,l:number}} target - The target object that is used to store the method's result.
	 * @param {string} [colorSpace=ColorManagement.workingColorSpace] - The color space.
	 * @return {{h:number,s:number,l:number}} The HSL representation of this color.
	 */ getHSL(target, colorSpace = $9ddd7e9b53f7a2d4$export$5e6fd513f44698c.workingColorSpace) {
        // h,s,l ranges are in 0.0 - 1.0
        $9ddd7e9b53f7a2d4$export$5e6fd513f44698c.fromWorkingColorSpace($9ddd7e9b53f7a2d4$var$_color.copy(this), colorSpace);
        const r = $9ddd7e9b53f7a2d4$var$_color.r, g = $9ddd7e9b53f7a2d4$var$_color.g, b = $9ddd7e9b53f7a2d4$var$_color.b;
        const max = Math.max(r, g, b);
        const min = Math.min(r, g, b);
        let hue, saturation;
        const lightness = (min + max) / 2.0;
        if (min === max) {
            hue = 0;
            saturation = 0;
        } else {
            const delta = max - min;
            saturation = lightness <= 0.5 ? delta / (max + min) : delta / (2 - max - min);
            switch(max){
                case r:
                    hue = (g - b) / delta + (g < b ? 6 : 0);
                    break;
                case g:
                    hue = (b - r) / delta + 2;
                    break;
                case b:
                    hue = (r - g) / delta + 4;
                    break;
            }
            hue /= 6;
        }
        target.h = hue;
        target.s = saturation;
        target.l = lightness;
        return target;
    }
    /**
	 * Returns the RGB values of this color and stores them into the given target object.
	 *
	 * @param {Color} target - The target color that is used to store the method's result.
	 * @param {string} [colorSpace=ColorManagement.workingColorSpace] - The color space.
	 * @return {Color} The RGB representation of this color.
	 */ getRGB(target, colorSpace = $9ddd7e9b53f7a2d4$export$5e6fd513f44698c.workingColorSpace) {
        $9ddd7e9b53f7a2d4$export$5e6fd513f44698c.fromWorkingColorSpace($9ddd7e9b53f7a2d4$var$_color.copy(this), colorSpace);
        target.r = $9ddd7e9b53f7a2d4$var$_color.r;
        target.g = $9ddd7e9b53f7a2d4$var$_color.g;
        target.b = $9ddd7e9b53f7a2d4$var$_color.b;
        return target;
    }
    /**
	 * Returns the value of this color as a CSS style string. Example: `rgb(255,0,0)`.
	 *
	 * @param {string} [colorSpace=SRGBColorSpace] - The color space.
	 * @return {string} The CSS representation of this color.
	 */ getStyle(colorSpace = $9ddd7e9b53f7a2d4$export$561f394b24edfcaa) {
        $9ddd7e9b53f7a2d4$export$5e6fd513f44698c.fromWorkingColorSpace($9ddd7e9b53f7a2d4$var$_color.copy(this), colorSpace);
        const r = $9ddd7e9b53f7a2d4$var$_color.r, g = $9ddd7e9b53f7a2d4$var$_color.g, b = $9ddd7e9b53f7a2d4$var$_color.b;
        if (colorSpace !== $9ddd7e9b53f7a2d4$export$561f394b24edfcaa) // Requires CSS Color Module Level 4 (https://www.w3.org/TR/css-color-4/).
        return `color(${colorSpace} ${r.toFixed(3)} ${g.toFixed(3)} ${b.toFixed(3)})`;
        return `rgb(${Math.round(r * 255)},${Math.round(g * 255)},${Math.round(b * 255)})`;
    }
    /**
	 * Adds the given HSL values to this color's values.
	 * Internally, this converts the color's RGB values to HSL, adds HSL
	 * and then converts the color back to RGB.
	 *
	 * @param {number} h - Hue value between `0.0` and `1.0`.
	 * @param {number} s - Saturation value between `0.0` and `1.0`.
	 * @param {number} l - Lightness value between `0.0` and `1.0`.
	 * @return {Color} A reference to this color.
	 */ offsetHSL(h, s, l) {
        this.getHSL($9ddd7e9b53f7a2d4$var$_hslA);
        return this.setHSL($9ddd7e9b53f7a2d4$var$_hslA.h + h, $9ddd7e9b53f7a2d4$var$_hslA.s + s, $9ddd7e9b53f7a2d4$var$_hslA.l + l);
    }
    /**
	 * Adds the RGB values of the given color to the RGB values of this color.
	 *
	 * @param {Color} color - The color to add.
	 * @return {Color} A reference to this color.
	 */ add(color) {
        this.r += color.r;
        this.g += color.g;
        this.b += color.b;
        return this;
    }
    /**
	 * Adds the RGB values of the given colors and stores the result in this instance.
	 *
	 * @param {Color} color1 - The first color.
	 * @param {Color} color2 - The second color.
	 * @return {Color} A reference to this color.
	 */ addColors(color1, color2) {
        this.r = color1.r + color2.r;
        this.g = color1.g + color2.g;
        this.b = color1.b + color2.b;
        return this;
    }
    /**
	 * Adds the given scalar value to the RGB values of this color.
	 *
	 * @param {number} s - The scalar to add.
	 * @return {Color} A reference to this color.
	 */ addScalar(s) {
        this.r += s;
        this.g += s;
        this.b += s;
        return this;
    }
    /**
	 * Subtracts the RGB values of the given color from the RGB values of this color.
	 *
	 * @param {Color} color - The color to subtract.
	 * @return {Color} A reference to this color.
	 */ sub(color) {
        this.r = Math.max(0, this.r - color.r);
        this.g = Math.max(0, this.g - color.g);
        this.b = Math.max(0, this.b - color.b);
        return this;
    }
    /**
	 * Multiplies the RGB values of the given color with the RGB values of this color.
	 *
	 * @param {Color} color - The color to multiply.
	 * @return {Color} A reference to this color.
	 */ multiply(color) {
        this.r *= color.r;
        this.g *= color.g;
        this.b *= color.b;
        return this;
    }
    /**
	 * Multiplies the given scalar value with the RGB values of this color.
	 *
	 * @param {number} s - The scalar to multiply.
	 * @return {Color} A reference to this color.
	 */ multiplyScalar(s) {
        this.r *= s;
        this.g *= s;
        this.b *= s;
        return this;
    }
    /**
	 * Linearly interpolates this color's RGB values toward the RGB values of the
	 * given color. The alpha argument can be thought of as the ratio between
	 * the two colors, where `0.0` is this color and `1.0` is the first argument.
	 *
	 * @param {Color} color - The color to converge on.
	 * @param {number} alpha - The interpolation factor in the closed interval `[0,1]`.
	 * @return {Color} A reference to this color.
	 */ lerp(color, alpha) {
        this.r += (color.r - this.r) * alpha;
        this.g += (color.g - this.g) * alpha;
        this.b += (color.b - this.b) * alpha;
        return this;
    }
    /**
	 * Linearly interpolates between the given colors and stores the result in this instance.
	 * The alpha argument can be thought of as the ratio between the two colors, where `0.0`
	 * is the first and `1.0` is the second color.
	 *
	 * @param {Color} color1 - The first color.
	 * @param {Color} color2 - The second color.
	 * @param {number} alpha - The interpolation factor in the closed interval `[0,1]`.
	 * @return {Color} A reference to this color.
	 */ lerpColors(color1, color2, alpha) {
        this.r = color1.r + (color2.r - color1.r) * alpha;
        this.g = color1.g + (color2.g - color1.g) * alpha;
        this.b = color1.b + (color2.b - color1.b) * alpha;
        return this;
    }
    /**
	 * Linearly interpolates this color's HSL values toward the HSL values of the
	 * given color. It differs from {@link Color#lerp} by not interpolating straight
	 * from one color to the other, but instead going through all the hues in between
	 * those two colors. The alpha argument can be thought of as the ratio between
	 * the two colors, where 0.0 is this color and 1.0 is the first argument.
	 *
	 * @param {Color} color - The color to converge on.
	 * @param {number} alpha - The interpolation factor in the closed interval `[0,1]`.
	 * @return {Color} A reference to this color.
	 */ lerpHSL(color, alpha) {
        this.getHSL($9ddd7e9b53f7a2d4$var$_hslA);
        color.getHSL($9ddd7e9b53f7a2d4$var$_hslB);
        const h = $9ddd7e9b53f7a2d4$var$lerp($9ddd7e9b53f7a2d4$var$_hslA.h, $9ddd7e9b53f7a2d4$var$_hslB.h, alpha);
        const s = $9ddd7e9b53f7a2d4$var$lerp($9ddd7e9b53f7a2d4$var$_hslA.s, $9ddd7e9b53f7a2d4$var$_hslB.s, alpha);
        const l = $9ddd7e9b53f7a2d4$var$lerp($9ddd7e9b53f7a2d4$var$_hslA.l, $9ddd7e9b53f7a2d4$var$_hslB.l, alpha);
        this.setHSL(h, s, l);
        return this;
    }
    /**
	 * Sets the color's RGB components from the given 3D vector.
	 *
	 * @param {Vector3} v - The vector to set.
	 * @return {Color} A reference to this color.
	 */ setFromVector3(v) {
        this.r = v.x;
        this.g = v.y;
        this.b = v.z;
        return this;
    }
    /**
	 * Transforms this color with the given 3x3 matrix.
	 *
	 * @param {Matrix3} m - The matrix.
	 * @return {Color} A reference to this color.
	 */ applyMatrix3(m) {
        const r = this.r, g = this.g, b = this.b;
        const e = m.elements;
        this.r = e[0] * r + e[3] * g + e[6] * b;
        this.g = e[1] * r + e[4] * g + e[7] * b;
        this.b = e[2] * r + e[5] * g + e[8] * b;
        return this;
    }
    /**
	 * Returns `true` if this color is equal with the given one.
	 *
	 * @param {Color} c - The color to test for equality.
	 * @return {boolean} Whether this bounding color is equal with the given one.
	 */ equals(c) {
        return c.r === this.r && c.g === this.g && c.b === this.b;
    }
    /**
	 * Sets this color's RGB components from the given array.
	 *
	 * @param {Array<number>} array - An array holding the RGB values.
	 * @param {number} [offset=0] - The offset into the array.
	 * @return {Color} A reference to this color.
	 */ fromArray(array, offset = 0) {
        this.r = array[offset];
        this.g = array[offset + 1];
        this.b = array[offset + 2];
        return this;
    }
    /**
	 * Writes the RGB components of this color to the given array. If no array is provided,
	 * the method returns a new instance.
	 *
	 * @param {Array<number>} [array=[]] - The target array holding the color components.
	 * @param {number} [offset=0] - Index of the first element in the array.
	 * @return {Array<number>} The color components.
	 */ toArray(array = [], offset = 0) {
        array[offset] = this.r;
        array[offset + 1] = this.g;
        array[offset + 2] = this.b;
        return array;
    }
    /**
	 * Sets the components of this color from the given buffer attribute.
	 *
	 * @param {BufferAttribute} attribute - The buffer attribute holding color data.
	 * @param {number} index - The index into the attribute.
	 * @return {Color} A reference to this color.
	 */ fromBufferAttribute(attribute, index) {
        this.r = attribute.getX(index);
        this.g = attribute.getY(index);
        this.b = attribute.getZ(index);
        return this;
    }
    /**
	 * This methods defines the serialization result of this class. Returns the color
	 * as a hexadecimal value.
	 *
	 * @return {number} The hexadecimal value.
	 */ toJSON() {
        return this.getHex();
    }
    *[Symbol.iterator]() {
        yield this.r;
        yield this.g;
        yield this.b;
    }
}
const $9ddd7e9b53f7a2d4$var$_color = /*@__PURE__*/ new $9ddd7e9b53f7a2d4$export$892596cec99bc70e();
/**
 * A dictionary with X11 color names.
 *
 * Note that multiple words such as Dark Orange become the string 'darkorange'.
 *
 * @static
 * @type {Object}
 */ $9ddd7e9b53f7a2d4$export$892596cec99bc70e.NAMES = $9ddd7e9b53f7a2d4$var$_colorKeywords;
let $9ddd7e9b53f7a2d4$var$_materialId = 0;
/**
 * Abstract base class for materials.
 *
 * Materials define the appearance of renderable 3D objects.
 *
 * @abstract
 * @augments EventDispatcher
 */ class $9ddd7e9b53f7a2d4$export$a2d8b23205c25948 extends $9ddd7e9b53f7a2d4$export$ec8b666c5fe2c75a {
    /**
	 * Constructs a new material.
	 */ constructor(){
        super();
        /**
		 * This flag can be used for type testing.
		 *
		 * @type {boolean}
		 * @readonly
		 * @default true
		 */ this.isMaterial = true;
        /**
		 * The ID of the material.
		 *
		 * @name Material#id
		 * @type {number}
		 * @readonly
		 */ Object.defineProperty(this, 'id', {
            value: $9ddd7e9b53f7a2d4$var$_materialId++
        });
        /**
		 * The UUID of the material.
		 *
		 * @type {string}
		 * @readonly
		 */ this.uuid = $9ddd7e9b53f7a2d4$var$generateUUID();
        /**
		 * The name of the material.
		 *
		 * @type {string}
		 */ this.name = '';
        /**
		 * The type property is used for detecting the object type
		 * in context of serialization/deserialization.
		 *
		 * @type {string}
		 * @readonly
		 */ this.type = 'Material';
        /**
		 * Defines the blending type of the material.
		 *
		 * It must be set to `CustomBlending` if custom blending properties like
		 * {@link Material#blendSrc}, {@link Material#blendDst} or {@link Material#blendEquation}
		 * should have any effect.
		 *
		 * @type {(NoBlending|NormalBlending|AdditiveBlending|SubtractiveBlending|MultiplyBlending|CustomBlending)}
		 * @default NormalBlending
		 */ this.blending = $9ddd7e9b53f7a2d4$export$5b29a26d96ee6af0;
        /**
		 * Defines which side of faces will be rendered - front, back or both.
		 *
		 * @type {(FrontSide|BackSide|DoubleSide)}
		 * @default FrontSide
		 */ this.side = $9ddd7e9b53f7a2d4$export$2ede184fc2998901;
        /**
		 * If set to `true`, vertex colors should be used.
		 *
		 * The engine supports RGB and RGBA vertex colors depending on whether a three (RGB) or
		 * four (RGBA) component color buffer attribute is used.
		 *
		 * @type {boolean}
		 * @default false
		 */ this.vertexColors = false;
        /**
		 * Defines how transparent the material is.
		 * A value of `0.0` indicates fully transparent, `1.0` is fully opaque.
		 *
		 * If the {@link Material#transparent} is not set to `true`,
		 * the material will remain fully opaque and this value will only affect its color.
		 *
		 * @type {number}
		 * @default 1
		 */ this.opacity = 1;
        /**
		 * Defines whether this material is transparent. This has an effect on
		 * rendering as transparent objects need special treatment and are rendered
		 * after non-transparent objects.
		 *
		 * When set to true, the extent to which the material is transparent is
		 * controlled by {@link Material#opacity}.
		 *
		 * @type {boolean}
		 * @default false
		 */ this.transparent = false;
        /**
		 * Enables alpha hashed transparency, an alternative to {@link Material#transparent} or
		 * {@link Material#alphaTest}. The material will not be rendered if opacity is lower than
		 * a random threshold. Randomization introduces some grain or noise, but approximates alpha
		 * blending without the associated problems of sorting. Using TAA can reduce the resulting noise.
		 *
		 * @type {boolean}
		 * @default false
		 */ this.alphaHash = false;
        /**
		 * Defines the blending source factor.
		 *
		 * @type {(ZeroFactor|OneFactor|SrcColorFactor|OneMinusSrcColorFactor|SrcAlphaFactor|OneMinusSrcAlphaFactor|DstAlphaFactor|OneMinusDstAlphaFactor|DstColorFactor|OneMinusDstColorFactor|SrcAlphaSaturateFactor|ConstantColorFactor|OneMinusConstantColorFactor|ConstantAlphaFactor|OneMinusConstantAlphaFactor)}
		 * @default SrcAlphaFactor
		 */ this.blendSrc = $9ddd7e9b53f7a2d4$export$d5773124e86cf28c;
        /**
		 * Defines the blending destination factor.
		 *
		 * @type {(ZeroFactor|OneFactor|SrcColorFactor|OneMinusSrcColorFactor|SrcAlphaFactor|OneMinusSrcAlphaFactor|DstAlphaFactor|OneMinusDstAlphaFactor|DstColorFactor|OneMinusDstColorFactor|SrcAlphaSaturateFactor|ConstantColorFactor|OneMinusConstantColorFactor|ConstantAlphaFactor|OneMinusConstantAlphaFactor)}
		 * @default OneMinusSrcAlphaFactor
		 */ this.blendDst = $9ddd7e9b53f7a2d4$export$11d468cc7f19e971;
        /**
		 * Defines the blending equation.
		 *
		 * @type {(AddEquation|SubtractEquation|ReverseSubtractEquation|MinEquation|MaxEquation)}
		 * @default AddEquation
		 */ this.blendEquation = $9ddd7e9b53f7a2d4$export$20183a0484ce21a0;
        /**
		 * Defines the blending source alpha factor.
		 *
		 * @type {?(ZeroFactor|OneFactor|SrcColorFactor|OneMinusSrcColorFactor|SrcAlphaFactor|OneMinusSrcAlphaFactor|DstAlphaFactor|OneMinusDstAlphaFactor|DstColorFactor|OneMinusDstColorFactor|SrcAlphaSaturateFactor|ConstantColorFactor|OneMinusConstantColorFactor|ConstantAlphaFactor|OneMinusConstantAlphaFactor)}
		 * @default null
		 */ this.blendSrcAlpha = null;
        /**
		 * Defines the blending destination alpha factor.
		 *
		 * @type {?(ZeroFactor|OneFactor|SrcColorFactor|OneMinusSrcColorFactor|SrcAlphaFactor|OneMinusSrcAlphaFactor|DstAlphaFactor|OneMinusDstAlphaFactor|DstColorFactor|OneMinusDstColorFactor|SrcAlphaSaturateFactor|ConstantColorFactor|OneMinusConstantColorFactor|ConstantAlphaFactor|OneMinusConstantAlphaFactor)}
		 * @default null
		 */ this.blendDstAlpha = null;
        /**
		 * Defines the blending equation of the alpha channel.
		 *
		 * @type {?(AddEquation|SubtractEquation|ReverseSubtractEquation|MinEquation|MaxEquation)}
		 * @default null
		 */ this.blendEquationAlpha = null;
        /**
		 * Represents the RGB values of the constant blend color.
		 *
		 * This property has only an effect when using custom blending with `ConstantColor` or `OneMinusConstantColor`.
		 *
		 * @type {Color}
		 * @default (0,0,0)
		 */ this.blendColor = new $9ddd7e9b53f7a2d4$export$892596cec99bc70e(0, 0, 0);
        /**
		 * Represents the alpha value of the constant blend color.
		 *
		 * This property has only an effect when using custom blending with `ConstantAlpha` or `OneMinusConstantAlpha`.
		 *
		 * @type {number}
		 * @default 0
		 */ this.blendAlpha = 0;
        /**
		 * Defines the depth function.
		 *
		 * @type {(NeverDepth|AlwaysDepth|LessDepth|LessEqualDepth|EqualDepth|GreaterEqualDepth|GreaterDepth|NotEqualDepth)}
		 * @default LessEqualDepth
		 */ this.depthFunc = $9ddd7e9b53f7a2d4$export$296f78a0b892f81a;
        /**
		 * Whether to have depth test enabled when rendering this material.
		 * When the depth test is disabled, the depth write will also be implicitly disabled.
		 *
		 * @type {boolean}
		 * @default true
		 */ this.depthTest = true;
        /**
		 * Whether rendering this material has any effect on the depth buffer.
		 *
		 * When drawing 2D overlays it can be useful to disable the depth writing in
		 * order to layer several things together without creating z-index artifacts.
		 *
		 * @type {boolean}
		 * @default true
		 */ this.depthWrite = true;
        /**
		 * The bit mask to use when writing to the stencil buffer.
		 *
		 * @type {number}
		 * @default 0xff
		 */ this.stencilWriteMask = 0xff;
        /**
		 * The stencil comparison function to use.
		 *
		 * @type {NeverStencilFunc|LessStencilFunc|EqualStencilFunc|LessEqualStencilFunc|GreaterStencilFunc|NotEqualStencilFunc|GreaterEqualStencilFunc|AlwaysStencilFunc}
		 * @default AlwaysStencilFunc
		 */ this.stencilFunc = $9ddd7e9b53f7a2d4$export$14cf96713ddd97a8;
        /**
		 * The value to use when performing stencil comparisons or stencil operations.
		 *
		 * @type {number}
		 * @default 0
		 */ this.stencilRef = 0;
        /**
		 * The bit mask to use when comparing against the stencil buffer.
		 *
		 * @type {number}
		 * @default 0xff
		 */ this.stencilFuncMask = 0xff;
        /**
		 * Which stencil operation to perform when the comparison function returns `false`.
		 *
		 * @type {ZeroStencilOp|KeepStencilOp|ReplaceStencilOp|IncrementStencilOp|DecrementStencilOp|IncrementWrapStencilOp|DecrementWrapStencilOp|InvertStencilOp}
		 * @default KeepStencilOp
		 */ this.stencilFail = $9ddd7e9b53f7a2d4$export$9f542ae4b5baca34;
        /**
		 * Which stencil operation to perform when the comparison function returns
		 * `true` but the depth test fails.
		 *
		 * @type {ZeroStencilOp|KeepStencilOp|ReplaceStencilOp|IncrementStencilOp|DecrementStencilOp|IncrementWrapStencilOp|DecrementWrapStencilOp|InvertStencilOp}
		 * @default KeepStencilOp
		 */ this.stencilZFail = $9ddd7e9b53f7a2d4$export$9f542ae4b5baca34;
        /**
		 * Which stencil operation to perform when the comparison function returns
		 * `true` and the depth test passes.
		 *
		 * @type {ZeroStencilOp|KeepStencilOp|ReplaceStencilOp|IncrementStencilOp|DecrementStencilOp|IncrementWrapStencilOp|DecrementWrapStencilOp|InvertStencilOp}
		 * @default KeepStencilOp
		 */ this.stencilZPass = $9ddd7e9b53f7a2d4$export$9f542ae4b5baca34;
        /**
		 * Whether stencil operations are performed against the stencil buffer. In
		 * order to perform writes or comparisons against the stencil buffer this
		 * value must be `true`.
		 *
		 * @type {boolean}
		 * @default false
		 */ this.stencilWrite = false;
        /**
		 * User-defined clipping planes specified as THREE.Plane objects in world
		 * space. These planes apply to the objects this material is attached to.
		 * Points in space whose signed distance to the plane is negative are clipped
		 * (not rendered). This requires {@link WebGLRenderer#localClippingEnabled} to
		 * be `true`.
		 *
		 * @type {?Array<Plane>}
		 * @default null
		 */ this.clippingPlanes = null;
        /**
		 * Changes the behavior of clipping planes so that only their intersection is
		 * clipped, rather than their union.
		 *
		 * @type {boolean}
		 * @default false
		 */ this.clipIntersection = false;
        /**
		 * Defines whether to clip shadows according to the clipping planes specified
		 * on this material.
		 *
		 * @type {boolean}
		 * @default false
		 */ this.clipShadows = false;
        /**
		 * Defines which side of faces cast shadows. If `null`, the side casting shadows
		 * is determined as follows:
		 *
		 * - When {@link Material#side} is set to `FrontSide`, the back side cast shadows.
		 * - When {@link Material#side} is set to `BackSide`, the front side cast shadows.
		 * - When {@link Material#side} is set to `DoubleSide`, both sides cast shadows.
		 *
		 * @type {?(FrontSide|BackSide|DoubleSide)}
		 * @default null
		 */ this.shadowSide = null;
        /**
		 * Whether to render the material's color.
		 *
		 * This can be used in conjunction with {@link Object3D#renderOder} to create invisible
		 * objects that occlude other objects.
		 *
		 * @type {boolean}
		 * @default true
		 */ this.colorWrite = true;
        /**
		 * Override the renderer's default precision for this material.
		 *
		 * @type {?('highp'|'mediump'|'lowp')}
		 * @default null
		 */ this.precision = null;
        /**
		 * Whether to use polygon offset or not. When enabled, each fragment's depth value will
		 * be offset after it is interpolated from the depth values of the appropriate vertices.
		 * The offset is added before the depth test is performed and before the value is written
		 * into the depth buffer.
		 *
		 * Can be useful for rendering hidden-line images, for applying decals to surfaces, and for
		 * rendering solids with highlighted edges.
		 *
		 * @type {boolean}
		 * @default false
		 */ this.polygonOffset = false;
        /**
		 * Specifies a scale factor that is used to create a variable depth offset for each polygon.
		 *
		 * @type {number}
		 * @default 0
		 */ this.polygonOffsetFactor = 0;
        /**
		 * Is multiplied by an implementation-specific value to create a constant depth offset.
		 *
		 * @type {number}
		 * @default 0
		 */ this.polygonOffsetUnits = 0;
        /**
		 * Whether to apply dithering to the color to remove the appearance of banding.
		 *
		 * @type {boolean}
		 * @default false
		 */ this.dithering = false;
        /**
		 * Whether alpha to coverage should be enabled or not. Can only be used with MSAA-enabled contexts
		 * (meaning when the renderer was created with *antialias* parameter set to `true`). Enabling this
		 * will smooth aliasing on clip plane edges and alphaTest-clipped edges.
		 *
		 * @type {boolean}
		 * @default false
		 */ this.alphaToCoverage = false;
        /**
		 * Whether to premultiply the alpha (transparency) value.
		 *
		 * @type {boolean}
		 * @default false
		 */ this.premultipliedAlpha = false;
        /**
		 * Whether double-sided, transparent objects should be rendered with a single pass or not.
		 *
		 * The engine renders double-sided, transparent objects with two draw calls (back faces first,
		 * then front faces) to mitigate transparency artifacts. There are scenarios however where this
		 * approach produces no quality gains but still doubles draw calls e.g. when rendering flat
		 * vegetation like grass sprites. In these cases, set the `forceSinglePass` flag to `true` to
		 * disable the two pass rendering to avoid performance issues.
		 *
		 * @type {boolean}
		 * @default false
		 */ this.forceSinglePass = false;
        /**
		 * Whether it's possible to override the material with {@link Scene#overrideMaterial} or not.
		 *
		 * @type {boolean}
		 * @default true
		 */ this.allowOverride = true;
        /**
		 * Defines whether 3D objects using this material are visible.
		 *
		 * @type {boolean}
		 * @default true
		 */ this.visible = true;
        /**
		 * Defines whether this material is tone mapped according to the renderer's tone mapping setting.
		 *
		 * It is ignored when rendering to a render target or using post processing or when using
		 * `WebGPURenderer`. In all these cases, all materials are honored by tone mapping.
		 *
		 * @type {boolean}
		 * @default true
		 */ this.toneMapped = true;
        /**
		 * An object that can be used to store custom data about the Material. It
		 * should not hold references to functions as these will not be cloned.
		 *
		 * @type {Object}
		 */ this.userData = {};
        /**
		 * This starts at `0` and counts how many times {@link Material#needsUpdate} is set to `true`.
		 *
		 * @type {number}
		 * @readonly
		 * @default 0
		 */ this.version = 0;
        this._alphaTest = 0;
    }
    /**
	 * Sets the alpha value to be used when running an alpha test. The material
	 * will not be rendered if the opacity is lower than this value.
	 *
	 * @type {number}
	 * @readonly
	 * @default 0
	 */ get alphaTest() {
        return this._alphaTest;
    }
    set alphaTest(value) {
        if (this._alphaTest > 0 !== value > 0) this.version++;
        this._alphaTest = value;
    }
    /**
	 * An optional callback that is executed immediately before the material is used to render a 3D object.
	 *
	 * This method can only be used when rendering with {@link WebGLRenderer}.
	 *
	 * @param {WebGLRenderer} renderer - The renderer.
	 * @param {Scene} scene - The scene.
	 * @param {Camera} camera - The camera that is used to render the scene.
	 * @param {BufferGeometry} geometry - The 3D object's geometry.
	 * @param {Object3D} object - The 3D object.
	 * @param {Object} group - The geometry group data.
	 */ onBeforeRender() {}
    /**
	 * An optional callback that is executed immediately before the shader
	 * program is compiled. This function is called with the shader source code
	 * as a parameter. Useful for the modification of built-in materials.
	 *
	 * This method can only be used when rendering with {@link WebGLRenderer}. The
	 * recommended approach when customizing materials is to use `WebGPURenderer` with the new
	 * Node Material system and [TSL]{@link https://github.com/mrdoob/three.js/wiki/Three.js-Shading-Language}.
	 *
	 * @param {{vertexShader:string,fragmentShader:string,uniforms:Object}} shaderobject - The object holds the uniforms and the vertex and fragment shader source.
	 * @param {WebGLRenderer} renderer - A reference to the renderer.
	 */ onBeforeCompile() {}
    /**
	 * In case {@link Material#onBeforeCompile} is used, this callback can be used to identify
	 * values of settings used in `onBeforeCompile()`, so three.js can reuse a cached
	 * shader or recompile the shader for this material as needed.
	 *
	 * This method can only be used when rendering with {@link WebGLRenderer}.
	 *
	 * @return {string} The custom program cache key.
	 */ customProgramCacheKey() {
        return this.onBeforeCompile.toString();
    }
    /**
	 * This method can be used to set default values from parameter objects.
	 * It is a generic implementation so it can be used with different types
	 * of materials.
	 *
	 * @param {Object} [values] - The material values to set.
	 */ setValues(values) {
        if (values === undefined) return;
        for(const key in values){
            const newValue = values[key];
            if (newValue === undefined) {
                console.warn(`THREE.Material: parameter '${key}' has value of undefined.`);
                continue;
            }
            const currentValue = this[key];
            if (currentValue === undefined) {
                console.warn(`THREE.Material: '${key}' is not a property of THREE.${this.type}.`);
                continue;
            }
            if (currentValue && currentValue.isColor) currentValue.set(newValue);
            else if (currentValue && currentValue.isVector3 && newValue && newValue.isVector3) currentValue.copy(newValue);
            else this[key] = newValue;
        }
    }
    /**
	 * Serializes the material into JSON.
	 *
	 * @param {?(Object|string)} meta - An optional value holding meta information about the serialization.
	 * @return {Object} A JSON object representing the serialized material.
	 * @see {@link ObjectLoader#parse}
	 */ toJSON(meta) {
        const isRootObject = meta === undefined || typeof meta === 'string';
        if (isRootObject) meta = {
            textures: {},
            images: {}
        };
        const data = {
            metadata: {
                version: 4.6,
                type: 'Material',
                generator: 'Material.toJSON'
            }
        };
        // standard Material serialization
        data.uuid = this.uuid;
        data.type = this.type;
        if (this.name !== '') data.name = this.name;
        if (this.color && this.color.isColor) data.color = this.color.getHex();
        if (this.roughness !== undefined) data.roughness = this.roughness;
        if (this.metalness !== undefined) data.metalness = this.metalness;
        if (this.sheen !== undefined) data.sheen = this.sheen;
        if (this.sheenColor && this.sheenColor.isColor) data.sheenColor = this.sheenColor.getHex();
        if (this.sheenRoughness !== undefined) data.sheenRoughness = this.sheenRoughness;
        if (this.emissive && this.emissive.isColor) data.emissive = this.emissive.getHex();
        if (this.emissiveIntensity !== undefined && this.emissiveIntensity !== 1) data.emissiveIntensity = this.emissiveIntensity;
        if (this.specular && this.specular.isColor) data.specular = this.specular.getHex();
        if (this.specularIntensity !== undefined) data.specularIntensity = this.specularIntensity;
        if (this.specularColor && this.specularColor.isColor) data.specularColor = this.specularColor.getHex();
        if (this.shininess !== undefined) data.shininess = this.shininess;
        if (this.clearcoat !== undefined) data.clearcoat = this.clearcoat;
        if (this.clearcoatRoughness !== undefined) data.clearcoatRoughness = this.clearcoatRoughness;
        if (this.clearcoatMap && this.clearcoatMap.isTexture) data.clearcoatMap = this.clearcoatMap.toJSON(meta).uuid;
        if (this.clearcoatRoughnessMap && this.clearcoatRoughnessMap.isTexture) data.clearcoatRoughnessMap = this.clearcoatRoughnessMap.toJSON(meta).uuid;
        if (this.clearcoatNormalMap && this.clearcoatNormalMap.isTexture) {
            data.clearcoatNormalMap = this.clearcoatNormalMap.toJSON(meta).uuid;
            data.clearcoatNormalScale = this.clearcoatNormalScale.toArray();
        }
        if (this.dispersion !== undefined) data.dispersion = this.dispersion;
        if (this.iridescence !== undefined) data.iridescence = this.iridescence;
        if (this.iridescenceIOR !== undefined) data.iridescenceIOR = this.iridescenceIOR;
        if (this.iridescenceThicknessRange !== undefined) data.iridescenceThicknessRange = this.iridescenceThicknessRange;
        if (this.iridescenceMap && this.iridescenceMap.isTexture) data.iridescenceMap = this.iridescenceMap.toJSON(meta).uuid;
        if (this.iridescenceThicknessMap && this.iridescenceThicknessMap.isTexture) data.iridescenceThicknessMap = this.iridescenceThicknessMap.toJSON(meta).uuid;
        if (this.anisotropy !== undefined) data.anisotropy = this.anisotropy;
        if (this.anisotropyRotation !== undefined) data.anisotropyRotation = this.anisotropyRotation;
        if (this.anisotropyMap && this.anisotropyMap.isTexture) data.anisotropyMap = this.anisotropyMap.toJSON(meta).uuid;
        if (this.map && this.map.isTexture) data.map = this.map.toJSON(meta).uuid;
        if (this.matcap && this.matcap.isTexture) data.matcap = this.matcap.toJSON(meta).uuid;
        if (this.alphaMap && this.alphaMap.isTexture) data.alphaMap = this.alphaMap.toJSON(meta).uuid;
        if (this.lightMap && this.lightMap.isTexture) {
            data.lightMap = this.lightMap.toJSON(meta).uuid;
            data.lightMapIntensity = this.lightMapIntensity;
        }
        if (this.aoMap && this.aoMap.isTexture) {
            data.aoMap = this.aoMap.toJSON(meta).uuid;
            data.aoMapIntensity = this.aoMapIntensity;
        }
        if (this.bumpMap && this.bumpMap.isTexture) {
            data.bumpMap = this.bumpMap.toJSON(meta).uuid;
            data.bumpScale = this.bumpScale;
        }
        if (this.normalMap && this.normalMap.isTexture) {
            data.normalMap = this.normalMap.toJSON(meta).uuid;
            data.normalMapType = this.normalMapType;
            data.normalScale = this.normalScale.toArray();
        }
        if (this.displacementMap && this.displacementMap.isTexture) {
            data.displacementMap = this.displacementMap.toJSON(meta).uuid;
            data.displacementScale = this.displacementScale;
            data.displacementBias = this.displacementBias;
        }
        if (this.roughnessMap && this.roughnessMap.isTexture) data.roughnessMap = this.roughnessMap.toJSON(meta).uuid;
        if (this.metalnessMap && this.metalnessMap.isTexture) data.metalnessMap = this.metalnessMap.toJSON(meta).uuid;
        if (this.emissiveMap && this.emissiveMap.isTexture) data.emissiveMap = this.emissiveMap.toJSON(meta).uuid;
        if (this.specularMap && this.specularMap.isTexture) data.specularMap = this.specularMap.toJSON(meta).uuid;
        if (this.specularIntensityMap && this.specularIntensityMap.isTexture) data.specularIntensityMap = this.specularIntensityMap.toJSON(meta).uuid;
        if (this.specularColorMap && this.specularColorMap.isTexture) data.specularColorMap = this.specularColorMap.toJSON(meta).uuid;
        if (this.envMap && this.envMap.isTexture) {
            data.envMap = this.envMap.toJSON(meta).uuid;
            if (this.combine !== undefined) data.combine = this.combine;
        }
        if (this.envMapRotation !== undefined) data.envMapRotation = this.envMapRotation.toArray();
        if (this.envMapIntensity !== undefined) data.envMapIntensity = this.envMapIntensity;
        if (this.reflectivity !== undefined) data.reflectivity = this.reflectivity;
        if (this.refractionRatio !== undefined) data.refractionRatio = this.refractionRatio;
        if (this.gradientMap && this.gradientMap.isTexture) data.gradientMap = this.gradientMap.toJSON(meta).uuid;
        if (this.transmission !== undefined) data.transmission = this.transmission;
        if (this.transmissionMap && this.transmissionMap.isTexture) data.transmissionMap = this.transmissionMap.toJSON(meta).uuid;
        if (this.thickness !== undefined) data.thickness = this.thickness;
        if (this.thicknessMap && this.thicknessMap.isTexture) data.thicknessMap = this.thicknessMap.toJSON(meta).uuid;
        if (this.attenuationDistance !== undefined && this.attenuationDistance !== Infinity) data.attenuationDistance = this.attenuationDistance;
        if (this.attenuationColor !== undefined) data.attenuationColor = this.attenuationColor.getHex();
        if (this.size !== undefined) data.size = this.size;
        if (this.shadowSide !== null) data.shadowSide = this.shadowSide;
        if (this.sizeAttenuation !== undefined) data.sizeAttenuation = this.sizeAttenuation;
        if (this.blending !== $9ddd7e9b53f7a2d4$export$5b29a26d96ee6af0) data.blending = this.blending;
        if (this.side !== $9ddd7e9b53f7a2d4$export$2ede184fc2998901) data.side = this.side;
        if (this.vertexColors === true) data.vertexColors = true;
        if (this.opacity < 1) data.opacity = this.opacity;
        if (this.transparent === true) data.transparent = true;
        if (this.blendSrc !== $9ddd7e9b53f7a2d4$export$d5773124e86cf28c) data.blendSrc = this.blendSrc;
        if (this.blendDst !== $9ddd7e9b53f7a2d4$export$11d468cc7f19e971) data.blendDst = this.blendDst;
        if (this.blendEquation !== $9ddd7e9b53f7a2d4$export$20183a0484ce21a0) data.blendEquation = this.blendEquation;
        if (this.blendSrcAlpha !== null) data.blendSrcAlpha = this.blendSrcAlpha;
        if (this.blendDstAlpha !== null) data.blendDstAlpha = this.blendDstAlpha;
        if (this.blendEquationAlpha !== null) data.blendEquationAlpha = this.blendEquationAlpha;
        if (this.blendColor && this.blendColor.isColor) data.blendColor = this.blendColor.getHex();
        if (this.blendAlpha !== 0) data.blendAlpha = this.blendAlpha;
        if (this.depthFunc !== $9ddd7e9b53f7a2d4$export$296f78a0b892f81a) data.depthFunc = this.depthFunc;
        if (this.depthTest === false) data.depthTest = this.depthTest;
        if (this.depthWrite === false) data.depthWrite = this.depthWrite;
        if (this.colorWrite === false) data.colorWrite = this.colorWrite;
        if (this.stencilWriteMask !== 0xff) data.stencilWriteMask = this.stencilWriteMask;
        if (this.stencilFunc !== $9ddd7e9b53f7a2d4$export$14cf96713ddd97a8) data.stencilFunc = this.stencilFunc;
        if (this.stencilRef !== 0) data.stencilRef = this.stencilRef;
        if (this.stencilFuncMask !== 0xff) data.stencilFuncMask = this.stencilFuncMask;
        if (this.stencilFail !== $9ddd7e9b53f7a2d4$export$9f542ae4b5baca34) data.stencilFail = this.stencilFail;
        if (this.stencilZFail !== $9ddd7e9b53f7a2d4$export$9f542ae4b5baca34) data.stencilZFail = this.stencilZFail;
        if (this.stencilZPass !== $9ddd7e9b53f7a2d4$export$9f542ae4b5baca34) data.stencilZPass = this.stencilZPass;
        if (this.stencilWrite === true) data.stencilWrite = this.stencilWrite;
        // rotation (SpriteMaterial)
        if (this.rotation !== undefined && this.rotation !== 0) data.rotation = this.rotation;
        if (this.polygonOffset === true) data.polygonOffset = true;
        if (this.polygonOffsetFactor !== 0) data.polygonOffsetFactor = this.polygonOffsetFactor;
        if (this.polygonOffsetUnits !== 0) data.polygonOffsetUnits = this.polygonOffsetUnits;
        if (this.linewidth !== undefined && this.linewidth !== 1) data.linewidth = this.linewidth;
        if (this.dashSize !== undefined) data.dashSize = this.dashSize;
        if (this.gapSize !== undefined) data.gapSize = this.gapSize;
        if (this.scale !== undefined) data.scale = this.scale;
        if (this.dithering === true) data.dithering = true;
        if (this.alphaTest > 0) data.alphaTest = this.alphaTest;
        if (this.alphaHash === true) data.alphaHash = true;
        if (this.alphaToCoverage === true) data.alphaToCoverage = true;
        if (this.premultipliedAlpha === true) data.premultipliedAlpha = true;
        if (this.forceSinglePass === true) data.forceSinglePass = true;
        if (this.wireframe === true) data.wireframe = true;
        if (this.wireframeLinewidth > 1) data.wireframeLinewidth = this.wireframeLinewidth;
        if (this.wireframeLinecap !== 'round') data.wireframeLinecap = this.wireframeLinecap;
        if (this.wireframeLinejoin !== 'round') data.wireframeLinejoin = this.wireframeLinejoin;
        if (this.flatShading === true) data.flatShading = true;
        if (this.visible === false) data.visible = false;
        if (this.toneMapped === false) data.toneMapped = false;
        if (this.fog === false) data.fog = false;
        if (Object.keys(this.userData).length > 0) data.userData = this.userData;
        // TODO: Copied from Object3D.toJSON
        function extractFromCache(cache) {
            const values = [];
            for(const key in cache){
                const data = cache[key];
                delete data.metadata;
                values.push(data);
            }
            return values;
        }
        if (isRootObject) {
            const textures = extractFromCache(meta.textures);
            const images = extractFromCache(meta.images);
            if (textures.length > 0) data.textures = textures;
            if (images.length > 0) data.images = images;
        }
        return data;
    }
    /**
	 * Returns a new material with copied values from this instance.
	 *
	 * @return {Material} A clone of this instance.
	 */ clone() {
        return new this.constructor().copy(this);
    }
    /**
	 * Copies the values of the given material to this instance.
	 *
	 * @param {Material} source - The material to copy.
	 * @return {Material} A reference to this instance.
	 */ copy(source) {
        this.name = source.name;
        this.blending = source.blending;
        this.side = source.side;
        this.vertexColors = source.vertexColors;
        this.opacity = source.opacity;
        this.transparent = source.transparent;
        this.blendSrc = source.blendSrc;
        this.blendDst = source.blendDst;
        this.blendEquation = source.blendEquation;
        this.blendSrcAlpha = source.blendSrcAlpha;
        this.blendDstAlpha = source.blendDstAlpha;
        this.blendEquationAlpha = source.blendEquationAlpha;
        this.blendColor.copy(source.blendColor);
        this.blendAlpha = source.blendAlpha;
        this.depthFunc = source.depthFunc;
        this.depthTest = source.depthTest;
        this.depthWrite = source.depthWrite;
        this.stencilWriteMask = source.stencilWriteMask;
        this.stencilFunc = source.stencilFunc;
        this.stencilRef = source.stencilRef;
        this.stencilFuncMask = source.stencilFuncMask;
        this.stencilFail = source.stencilFail;
        this.stencilZFail = source.stencilZFail;
        this.stencilZPass = source.stencilZPass;
        this.stencilWrite = source.stencilWrite;
        const srcPlanes = source.clippingPlanes;
        let dstPlanes = null;
        if (srcPlanes !== null) {
            const n = srcPlanes.length;
            dstPlanes = new Array(n);
            for(let i = 0; i !== n; ++i)dstPlanes[i] = srcPlanes[i].clone();
        }
        this.clippingPlanes = dstPlanes;
        this.clipIntersection = source.clipIntersection;
        this.clipShadows = source.clipShadows;
        this.shadowSide = source.shadowSide;
        this.colorWrite = source.colorWrite;
        this.precision = source.precision;
        this.polygonOffset = source.polygonOffset;
        this.polygonOffsetFactor = source.polygonOffsetFactor;
        this.polygonOffsetUnits = source.polygonOffsetUnits;
        this.dithering = source.dithering;
        this.alphaTest = source.alphaTest;
        this.alphaHash = source.alphaHash;
        this.alphaToCoverage = source.alphaToCoverage;
        this.premultipliedAlpha = source.premultipliedAlpha;
        this.forceSinglePass = source.forceSinglePass;
        this.visible = source.visible;
        this.toneMapped = source.toneMapped;
        this.userData = JSON.parse(JSON.stringify(source.userData));
        return this;
    }
    /**
	 * Frees the GPU-related resources allocated by this instance. Call this
	 * method whenever this instance is no longer used in your app.
	 *
	 * @fires Material#dispose
	 */ dispose() {
        /**
		 * Fires when the material has been disposed of.
		 *
		 * @event Material#dispose
		 * @type {Object}
		 */ this.dispatchEvent({
            type: 'dispose'
        });
    }
    /**
	 * Setting this property to `true` indicates the engine the material
	 * needs to be recompiled.
	 *
	 * @type {boolean}
	 * @default false
	 * @param {boolean} value
	 */ set needsUpdate(value) {
        if (value === true) this.version++;
    }
    onBuild() {
        console.warn('Material: onBuild() has been removed.'); // @deprecated, r166
    }
}
/**
 * A material for drawing geometries in a simple shaded (flat or wireframe) way.
 *
 * This material is not affected by lights.
 *
 * @augments Material
 */ class $9ddd7e9b53f7a2d4$export$55cbcc9b622fe1f5 extends $9ddd7e9b53f7a2d4$export$a2d8b23205c25948 {
    /**
	 * Constructs a new mesh basic material.
	 *
	 * @param {Object} [parameters] - An object with one or more properties
	 * defining the material's appearance. Any property of the material
	 * (including any property from inherited materials) can be passed
	 * in here. Color values can be passed any type of value accepted
	 * by {@link Color#set}.
	 */ constructor(parameters){
        super();
        /**
		 * This flag can be used for type testing.
		 *
		 * @type {boolean}
		 * @readonly
		 * @default true
		 */ this.isMeshBasicMaterial = true;
        this.type = 'MeshBasicMaterial';
        /**
		 * Color of the material.
		 *
		 * @type {Color}
		 * @default (1,1,1)
		 */ this.color = new $9ddd7e9b53f7a2d4$export$892596cec99bc70e(0xffffff); // emissive
        /**
		 * The color map. May optionally include an alpha channel, typically combined
		 * with {@link Material#transparent} or {@link Material#alphaTest}. The texture map
		 * color is modulated by the diffuse `color`.
		 *
		 * @type {?Texture}
		 * @default null
		 */ this.map = null;
        /**
		 * The light map. Requires a second set of UVs.
		 *
		 * @type {?Texture}
		 * @default null
		 */ this.lightMap = null;
        /**
		 * Intensity of the baked light.
		 *
		 * @type {number}
		 * @default 1
		 */ this.lightMapIntensity = 1.0;
        /**
		 * The red channel of this texture is used as the ambient occlusion map.
		 * Requires a second set of UVs.
		 *
		 * @type {?Texture}
		 * @default null
		 */ this.aoMap = null;
        /**
		 * Intensity of the ambient occlusion effect. Range is `[0,1]`, where `0`
		 * disables ambient occlusion. Where intensity is `1` and the AO map's
		 * red channel is also `1`, ambient light is fully occluded on a surface.
		 *
		 * @type {number}
		 * @default 1
		 */ this.aoMapIntensity = 1.0;
        /**
		 * Specular map used by the material.
		 *
		 * @type {?Texture}
		 * @default null
		 */ this.specularMap = null;
        /**
		 * The alpha map is a grayscale texture that controls the opacity across the
		 * surface (black: fully transparent; white: fully opaque).
		 *
		 * Only the color of the texture is used, ignoring the alpha channel if one
		 * exists. For RGB and RGBA textures, the renderer will use the green channel
		 * when sampling this texture due to the extra bit of precision provided for
		 * green in DXT-compressed and uncompressed RGB 565 formats. Luminance-only and
		 * luminance/alpha textures will also still work as expected.
		 *
		 * @type {?Texture}
		 * @default null
		 */ this.alphaMap = null;
        /**
		 * The environment map.
		 *
		 * @type {?Texture}
		 * @default null
		 */ this.envMap = null;
        /**
		 * The rotation of the environment map in radians.
		 *
		 * @type {Euler}
		 * @default (0,0,0)
		 */ this.envMapRotation = new $9ddd7e9b53f7a2d4$export$d93cc409a0768c5f();
        /**
		 * How to combine the result of the surface's color with the environment map, if any.
		 *
		 * When set to `MixOperation`, the {@link MeshBasicMaterial#reflectivity} is used to
		 * blend between the two colors.
		 *
		 * @type {(MultiplyOperation|MixOperation|AddOperation)}
		 * @default MultiplyOperation
		 */ this.combine = $9ddd7e9b53f7a2d4$export$e50ac29801f1774d;
        /**
		 * How much the environment map affects the surface.
		 * The valid range is between `0` (no reflections) and `1` (full reflections).
		 *
		 * @type {number}
		 * @default 1
		 */ this.reflectivity = 1;
        /**
		 * The index of refraction (IOR) of air (approximately 1) divided by the
		 * index of refraction of the material. It is used with environment mapping
		 * modes {@link CubeRefractionMapping} and {@link EquirectangularRefractionMapping}.
		 * The refraction ratio should not exceed `1`.
		 *
		 * @type {number}
		 * @default 0.98
		 */ this.refractionRatio = 0.98;
        /**
		 * Renders the geometry as a wireframe.
		 *
		 * @type {boolean}
		 * @default false
		 */ this.wireframe = false;
        /**
		 * Controls the thickness of the wireframe.
		 *
		 * Can only be used with {@link SVGRenderer}.
		 *
		 * @type {number}
		 * @default 1
		 */ this.wireframeLinewidth = 1;
        /**
		 * Defines appearance of wireframe ends.
		 *
		 * Can only be used with {@link SVGRenderer}.
		 *
		 * @type {('round'|'bevel'|'miter')}
		 * @default 'round'
		 */ this.wireframeLinecap = 'round';
        /**
		 * Defines appearance of wireframe joints.
		 *
		 * Can only be used with {@link SVGRenderer}.
		 *
		 * @type {('round'|'bevel'|'miter')}
		 * @default 'round'
		 */ this.wireframeLinejoin = 'round';
        /**
		 * Whether the material is affected by fog or not.
		 *
		 * @type {boolean}
		 * @default true
		 */ this.fog = true;
        this.setValues(parameters);
    }
    copy(source) {
        super.copy(source);
        this.color.copy(source.color);
        this.map = source.map;
        this.lightMap = source.lightMap;
        this.lightMapIntensity = source.lightMapIntensity;
        this.aoMap = source.aoMap;
        this.aoMapIntensity = source.aoMapIntensity;
        this.specularMap = source.specularMap;
        this.alphaMap = source.alphaMap;
        this.envMap = source.envMap;
        this.envMapRotation.copy(source.envMapRotation);
        this.combine = source.combine;
        this.reflectivity = source.reflectivity;
        this.refractionRatio = source.refractionRatio;
        this.wireframe = source.wireframe;
        this.wireframeLinewidth = source.wireframeLinewidth;
        this.wireframeLinecap = source.wireframeLinecap;
        this.wireframeLinejoin = source.wireframeLinejoin;
        this.fog = source.fog;
        return this;
    }
}
// Fast Half Float Conversions, http://www.fox-toolkit.org/ftp/fasthalffloatconversion.pdf
const $9ddd7e9b53f7a2d4$var$_tables = /*@__PURE__*/ $9ddd7e9b53f7a2d4$var$_generateTables();
function $9ddd7e9b53f7a2d4$var$_generateTables() {
    // float32 to float16 helpers
    const buffer = new ArrayBuffer(4);
    const floatView = new Float32Array(buffer);
    const uint32View = new Uint32Array(buffer);
    const baseTable = new Uint32Array(512);
    const shiftTable = new Uint32Array(512);
    for(let i = 0; i < 256; ++i){
        const e = i - 127;
        // very small number (0, -0)
        if (e < -27) {
            baseTable[i] = 0x0000;
            baseTable[i | 0x100] = 0x8000;
            shiftTable[i] = 24;
            shiftTable[i | 0x100] = 24;
        // small number (denorm)
        } else if (e < -14) {
            baseTable[i] = 0x0400 >> -e - 14;
            baseTable[i | 0x100] = 0x0400 >> -e - 14 | 0x8000;
            shiftTable[i] = -e - 1;
            shiftTable[i | 0x100] = -e - 1;
        // normal number
        } else if (e <= 15) {
            baseTable[i] = e + 15 << 10;
            baseTable[i | 0x100] = e + 15 << 10 | 0x8000;
            shiftTable[i] = 13;
            shiftTable[i | 0x100] = 13;
        // large number (Infinity, -Infinity)
        } else if (e < 128) {
            baseTable[i] = 0x7c00;
            baseTable[i | 0x100] = 0xfc00;
            shiftTable[i] = 24;
            shiftTable[i | 0x100] = 24;
        // stay (NaN, Infinity, -Infinity)
        } else {
            baseTable[i] = 0x7c00;
            baseTable[i | 0x100] = 0xfc00;
            shiftTable[i] = 13;
            shiftTable[i | 0x100] = 13;
        }
    }
    // float16 to float32 helpers
    const mantissaTable = new Uint32Array(2048);
    const exponentTable = new Uint32Array(64);
    const offsetTable = new Uint32Array(64);
    for(let i = 1; i < 1024; ++i){
        let m = i << 13; // zero pad mantissa bits
        let e = 0; // zero exponent
        // normalized
        while((m & 0x00800000) === 0){
            m <<= 1;
            e -= 0x00800000; // decrement exponent
        }
        m &= -8388609; // clear leading 1 bit
        e += 0x38800000; // adjust bias
        mantissaTable[i] = m | e;
    }
    for(let i = 1024; i < 2048; ++i)mantissaTable[i] = 0x38000000 + (i - 1024 << 13);
    for(let i = 1; i < 31; ++i)exponentTable[i] = i << 23;
    exponentTable[31] = 0x47800000;
    exponentTable[32] = 0x80000000;
    for(let i = 33; i < 63; ++i)exponentTable[i] = 0x80000000 + (i - 32 << 23);
    exponentTable[63] = 0xc7800000;
    for(let i = 1; i < 64; ++i)if (i !== 32) offsetTable[i] = 1024;
    return {
        floatView: floatView,
        uint32View: uint32View,
        baseTable: baseTable,
        shiftTable: shiftTable,
        mantissaTable: mantissaTable,
        exponentTable: exponentTable,
        offsetTable: offsetTable
    };
}
/**
 * Returns a half precision floating point value (FP16) from the given single
 * precision floating point value (FP32).
 *
 * @param {number} val - A single precision floating point value.
 * @return {number} The FP16 value.
 */ function $9ddd7e9b53f7a2d4$var$toHalfFloat(val) {
    if (Math.abs(val) > 65504) console.warn('THREE.DataUtils.toHalfFloat(): Value out of range.');
    val = $9ddd7e9b53f7a2d4$var$clamp(val, -65504, 65504);
    $9ddd7e9b53f7a2d4$var$_tables.floatView[0] = val;
    const f = $9ddd7e9b53f7a2d4$var$_tables.uint32View[0];
    const e = f >> 23 & 0x1ff;
    return $9ddd7e9b53f7a2d4$var$_tables.baseTable[e] + ((f & 0x007fffff) >> $9ddd7e9b53f7a2d4$var$_tables.shiftTable[e]);
}
/**
 * Returns a single precision floating point value (FP32) from the given half
 * precision floating point value (FP16).
 *
 * @param {number} val - A half precision floating point value.
 * @return {number} The FP32 value.
 */ function $9ddd7e9b53f7a2d4$var$fromHalfFloat(val) {
    const m = val >> 10;
    $9ddd7e9b53f7a2d4$var$_tables.uint32View[0] = $9ddd7e9b53f7a2d4$var$_tables.mantissaTable[$9ddd7e9b53f7a2d4$var$_tables.offsetTable[m] + (val & 0x3ff)] + $9ddd7e9b53f7a2d4$var$_tables.exponentTable[m];
    return $9ddd7e9b53f7a2d4$var$_tables.floatView[0];
}
/**
 * A class containing utility functions for data.
 *
 * @hideconstructor
 */ class $9ddd7e9b53f7a2d4$export$11ce8b759162cc80 {
    /**
	 * Returns a half precision floating point value (FP16) from the given single
	 * precision floating point value (FP32).
	 *
	 * @param {number} val - A single precision floating point value.
	 * @return {number} The FP16 value.
	 */ static toHalfFloat(val) {
        return $9ddd7e9b53f7a2d4$var$toHalfFloat(val);
    }
    /**
	 * Returns a single precision floating point value (FP32) from the given half
	 * precision floating point value (FP16).
	 *
	 * @param {number} val - A half precision floating point value.
	 * @return {number} The FP32 value.
	 */ static fromHalfFloat(val) {
        return $9ddd7e9b53f7a2d4$var$fromHalfFloat(val);
    }
}
const $9ddd7e9b53f7a2d4$var$_vector$9 = /*@__PURE__*/ new $9ddd7e9b53f7a2d4$export$64b5c384219d3699();
const $9ddd7e9b53f7a2d4$var$_vector2$1 = /*@__PURE__*/ new $9ddd7e9b53f7a2d4$export$c977b3e384af9ae1();
let $9ddd7e9b53f7a2d4$var$_id$2 = 0;
/**
 * This class stores data for an attribute (such as vertex positions, face
 * indices, normals, colors, UVs, and any custom attributes ) associated with
 * a geometry, which allows for more efficient passing of data to the GPU.
 *
 * When working with vector-like data, the `fromBufferAttribute( attribute, index )`
 * helper methods on vector and color class might be helpful. E.g. {@link Vector3#fromBufferAttribute}.
 */ class $9ddd7e9b53f7a2d4$export$8dea267bd6bde117 {
    /**
	 * Constructs a new buffer attribute.
	 *
	 * @param {TypedArray} array - The array holding the attribute data.
	 * @param {number} itemSize - The item size.
	 * @param {boolean} [normalized=false] - Whether the data are normalized or not.
	 */ constructor(array, itemSize, normalized = false){
        if (Array.isArray(array)) throw new TypeError('THREE.BufferAttribute: array should be a Typed Array.');
        /**
		 * This flag can be used for type testing.
		 *
		 * @type {boolean}
		 * @readonly
		 * @default true
		 */ this.isBufferAttribute = true;
        /**
		 * The ID of the buffer attribute.
		 *
		 * @name BufferAttribute#id
		 * @type {number}
		 * @readonly
		 */ Object.defineProperty(this, 'id', {
            value: $9ddd7e9b53f7a2d4$var$_id$2++
        });
        /**
		 * The name of the buffer attribute.
		 *
		 * @type {string}
		 */ this.name = '';
        /**
		 * The array holding the attribute data. It should have `itemSize * numVertices`
		 * elements, where `numVertices` is the number of vertices in the associated geometry.
		 *
		 * @type {TypedArray}
		 */ this.array = array;
        /**
		 * The number of values of the array that should be associated with a particular vertex.
		 * For instance, if this attribute is storing a 3-component vector (such as a position,
		 * normal, or color), then the value should be `3`.
		 *
		 * @type {number}
		 */ this.itemSize = itemSize;
        /**
		 * Represents the number of items this buffer attribute stores. It is internally computed
		 * by dividing the `array` length by the `itemSize`.
		 *
		 * @type {number}
		 * @readonly
		 */ this.count = array !== undefined ? array.length / itemSize : 0;
        /**
		 * Applies to integer data only. Indicates how the underlying data in the buffer maps to
		 * the values in the GLSL code. For instance, if `array` is an instance of `UInt16Array`,
		 * and `normalized` is `true`, the values `0 -+65535` in the array data will be mapped to
		 * `0.0f - +1.0f` in the GLSL attribute. If `normalized` is `false`, the values will be converted
		 * to floats unmodified, i.e. `65535` becomes `65535.0f`.
		 *
		 * @type {boolean}
		 */ this.normalized = normalized;
        /**
		 * Defines the intended usage pattern of the data store for optimization purposes.
		 *
		 * Note: After the initial use of a buffer, its usage cannot be changed. Instead,
		 * instantiate a new one and set the desired usage before the next render.
		 *
		 * @type {(StaticDrawUsage|DynamicDrawUsage|StreamDrawUsage|StaticReadUsage|DynamicReadUsage|StreamReadUsage|StaticCopyUsage|DynamicCopyUsage|StreamCopyUsage)}
		 * @default StaticDrawUsage
		 */ this.usage = $9ddd7e9b53f7a2d4$export$763e8360f4d7f77d;
        /**
		 * This can be used to only update some components of stored vectors (for example, just the
		 * component related to color). Use the `addUpdateRange()` function to add ranges to this array.
		 *
		 * @type {Array<Object>}
		 */ this.updateRanges = [];
        /**
		 * Configures the bound GPU type for use in shaders.
		 *
		 * Note: this only has an effect for integer arrays and is not configurable for float arrays.
		 * For lower precision float types, use `Float16BufferAttribute`.
		 *
		 * @type {(FloatType|IntType)}
		 * @default FloatType
		 */ this.gpuType = $9ddd7e9b53f7a2d4$export$f6d331659b644596;
        /**
		 * A version number, incremented every time the `needsUpdate` is set to `true`.
		 *
		 * @type {number}
		 */ this.version = 0;
    }
    /**
	 * A callback function that is executed after the renderer has transferred the attribute
	 * array data to the GPU.
	 */ onUploadCallback() {}
    /**
	 * Flag to indicate that this attribute has changed and should be re-sent to
	 * the GPU. Set this to `true` when you modify the value of the array.
	 *
	 * @type {number}
	 * @default false
	 * @param {boolean} value
	 */ set needsUpdate(value) {
        if (value === true) this.version++;
    }
    /**
	 * Sets the usage of this buffer attribute.
	 *
	 * @param {(StaticDrawUsage|DynamicDrawUsage|StreamDrawUsage|StaticReadUsage|DynamicReadUsage|StreamReadUsage|StaticCopyUsage|DynamicCopyUsage|StreamCopyUsage)} value - The usage to set.
	 * @return {BufferAttribute} A reference to this buffer attribute.
	 */ setUsage(value) {
        this.usage = value;
        return this;
    }
    /**
	 * Adds a range of data in the data array to be updated on the GPU.
	 *
	 * @param {number} start - Position at which to start update.
	 * @param {number} count - The number of components to update.
	 */ addUpdateRange(start, count) {
        this.updateRanges.push({
            start: start,
            count: count
        });
    }
    /**
	 * Clears the update ranges.
	 */ clearUpdateRanges() {
        this.updateRanges.length = 0;
    }
    /**
	 * Copies the values of the given buffer attribute to this instance.
	 *
	 * @param {BufferAttribute} source - The buffer attribute to copy.
	 * @return {BufferAttribute} A reference to this instance.
	 */ copy(source) {
        this.name = source.name;
        this.array = new source.array.constructor(source.array);
        this.itemSize = source.itemSize;
        this.count = source.count;
        this.normalized = source.normalized;
        this.usage = source.usage;
        this.gpuType = source.gpuType;
        return this;
    }
    /**
	 * Copies a vector from the given buffer attribute to this one. The start
	 * and destination position in the attribute buffers are represented by the
	 * given indices.
	 *
	 * @param {number} index1 - The destination index into this buffer attribute.
	 * @param {BufferAttribute} attribute - The buffer attribute to copy from.
	 * @param {number} index2 - The source index into the given buffer attribute.
	 * @return {BufferAttribute} A reference to this instance.
	 */ copyAt(index1, attribute, index2) {
        index1 *= this.itemSize;
        index2 *= attribute.itemSize;
        for(let i = 0, l = this.itemSize; i < l; i++)this.array[index1 + i] = attribute.array[index2 + i];
        return this;
    }
    /**
	 * Copies the given array data into this buffer attribute.
	 *
	 * @param {(TypedArray|Array)} array - The array to copy.
	 * @return {BufferAttribute} A reference to this instance.
	 */ copyArray(array) {
        this.array.set(array);
        return this;
    }
    /**
	 * Applies the given 3x3 matrix to the given attribute. Works with
	 * item size `2` and `3`.
	 *
	 * @param {Matrix3} m - The matrix to apply.
	 * @return {BufferAttribute} A reference to this instance.
	 */ applyMatrix3(m) {
        if (this.itemSize === 2) for(let i = 0, l = this.count; i < l; i++){
            $9ddd7e9b53f7a2d4$var$_vector2$1.fromBufferAttribute(this, i);
            $9ddd7e9b53f7a2d4$var$_vector2$1.applyMatrix3(m);
            this.setXY(i, $9ddd7e9b53f7a2d4$var$_vector2$1.x, $9ddd7e9b53f7a2d4$var$_vector2$1.y);
        }
        else if (this.itemSize === 3) for(let i = 0, l = this.count; i < l; i++){
            $9ddd7e9b53f7a2d4$var$_vector$9.fromBufferAttribute(this, i);
            $9ddd7e9b53f7a2d4$var$_vector$9.applyMatrix3(m);
            this.setXYZ(i, $9ddd7e9b53f7a2d4$var$_vector$9.x, $9ddd7e9b53f7a2d4$var$_vector$9.y, $9ddd7e9b53f7a2d4$var$_vector$9.z);
        }
        return this;
    }
    /**
	 * Applies the given 4x4 matrix to the given attribute. Only works with
	 * item size `3`.
	 *
	 * @param {Matrix4} m - The matrix to apply.
	 * @return {BufferAttribute} A reference to this instance.
	 */ applyMatrix4(m) {
        for(let i = 0, l = this.count; i < l; i++){
            $9ddd7e9b53f7a2d4$var$_vector$9.fromBufferAttribute(this, i);
            $9ddd7e9b53f7a2d4$var$_vector$9.applyMatrix4(m);
            this.setXYZ(i, $9ddd7e9b53f7a2d4$var$_vector$9.x, $9ddd7e9b53f7a2d4$var$_vector$9.y, $9ddd7e9b53f7a2d4$var$_vector$9.z);
        }
        return this;
    }
    /**
	 * Applies the given 3x3 normal matrix to the given attribute. Only works with
	 * item size `3`.
	 *
	 * @param {Matrix3} m - The normal matrix to apply.
	 * @return {BufferAttribute} A reference to this instance.
	 */ applyNormalMatrix(m) {
        for(let i = 0, l = this.count; i < l; i++){
            $9ddd7e9b53f7a2d4$var$_vector$9.fromBufferAttribute(this, i);
            $9ddd7e9b53f7a2d4$var$_vector$9.applyNormalMatrix(m);
            this.setXYZ(i, $9ddd7e9b53f7a2d4$var$_vector$9.x, $9ddd7e9b53f7a2d4$var$_vector$9.y, $9ddd7e9b53f7a2d4$var$_vector$9.z);
        }
        return this;
    }
    /**
	 * Applies the given 4x4 matrix to the given attribute. Only works with
	 * item size `3` and with direction vectors.
	 *
	 * @param {Matrix4} m - The matrix to apply.
	 * @return {BufferAttribute} A reference to this instance.
	 */ transformDirection(m) {
        for(let i = 0, l = this.count; i < l; i++){
            $9ddd7e9b53f7a2d4$var$_vector$9.fromBufferAttribute(this, i);
            $9ddd7e9b53f7a2d4$var$_vector$9.transformDirection(m);
            this.setXYZ(i, $9ddd7e9b53f7a2d4$var$_vector$9.x, $9ddd7e9b53f7a2d4$var$_vector$9.y, $9ddd7e9b53f7a2d4$var$_vector$9.z);
        }
        return this;
    }
    /**
	 * Sets the given array data in the buffer attribute.
	 *
	 * @param {(TypedArray|Array)} value - The array data to set.
	 * @param {number} [offset=0] - The offset in this buffer attribute's array.
	 * @return {BufferAttribute} A reference to this instance.
	 */ set(value, offset = 0) {
        // Matching BufferAttribute constructor, do not normalize the array.
        this.array.set(value, offset);
        return this;
    }
    /**
	 * Returns the given component of the vector at the given index.
	 *
	 * @param {number} index - The index into the buffer attribute.
	 * @param {number} component - The component index.
	 * @return {number} The returned value.
	 */ getComponent(index, component) {
        let value = this.array[index * this.itemSize + component];
        if (this.normalized) value = $9ddd7e9b53f7a2d4$var$denormalize(value, this.array);
        return value;
    }
    /**
	 * Sets the given value to the given component of the vector at the given index.
	 *
	 * @param {number} index - The index into the buffer attribute.
	 * @param {number} component - The component index.
	 * @param {number} value - The value to set.
	 * @return {BufferAttribute} A reference to this instance.
	 */ setComponent(index, component, value) {
        if (this.normalized) value = $9ddd7e9b53f7a2d4$var$normalize(value, this.array);
        this.array[index * this.itemSize + component] = value;
        return this;
    }
    /**
	 * Returns the x component of the vector at the given index.
	 *
	 * @param {number} index - The index into the buffer attribute.
	 * @return {number} The x component.
	 */ getX(index) {
        let x = this.array[index * this.itemSize];
        if (this.normalized) x = $9ddd7e9b53f7a2d4$var$denormalize(x, this.array);
        return x;
    }
    /**
	 * Sets the x component of the vector at the given index.
	 *
	 * @param {number} index - The index into the buffer attribute.
	 * @param {number} x - The value to set.
	 * @return {BufferAttribute} A reference to this instance.
	 */ setX(index, x) {
        if (this.normalized) x = $9ddd7e9b53f7a2d4$var$normalize(x, this.array);
        this.array[index * this.itemSize] = x;
        return this;
    }
    /**
	 * Returns the y component of the vector at the given index.
	 *
	 * @param {number} index - The index into the buffer attribute.
	 * @return {number} The y component.
	 */ getY(index) {
        let y = this.array[index * this.itemSize + 1];
        if (this.normalized) y = $9ddd7e9b53f7a2d4$var$denormalize(y, this.array);
        return y;
    }
    /**
	 * Sets the y component of the vector at the given index.
	 *
	 * @param {number} index - The index into the buffer attribute.
	 * @param {number} y - The value to set.
	 * @return {BufferAttribute} A reference to this instance.
	 */ setY(index, y) {
        if (this.normalized) y = $9ddd7e9b53f7a2d4$var$normalize(y, this.array);
        this.array[index * this.itemSize + 1] = y;
        return this;
    }
    /**
	 * Returns the z component of the vector at the given index.
	 *
	 * @param {number} index - The index into the buffer attribute.
	 * @return {number} The z component.
	 */ getZ(index) {
        let z = this.array[index * this.itemSize + 2];
        if (this.normalized) z = $9ddd7e9b53f7a2d4$var$denormalize(z, this.array);
        return z;
    }
    /**
	 * Sets the z component of the vector at the given index.
	 *
	 * @param {number} index - The index into the buffer attribute.
	 * @param {number} z - The value to set.
	 * @return {BufferAttribute} A reference to this instance.
	 */ setZ(index, z) {
        if (this.normalized) z = $9ddd7e9b53f7a2d4$var$normalize(z, this.array);
        this.array[index * this.itemSize + 2] = z;
        return this;
    }
    /**
	 * Returns the w component of the vector at the given index.
	 *
	 * @param {number} index - The index into the buffer attribute.
	 * @return {number} The w component.
	 */ getW(index) {
        let w = this.array[index * this.itemSize + 3];
        if (this.normalized) w = $9ddd7e9b53f7a2d4$var$denormalize(w, this.array);
        return w;
    }
    /**
	 * Sets the w component of the vector at the given index.
	 *
	 * @param {number} index - The index into the buffer attribute.
	 * @param {number} w - The value to set.
	 * @return {BufferAttribute} A reference to this instance.
	 */ setW(index, w) {
        if (this.normalized) w = $9ddd7e9b53f7a2d4$var$normalize(w, this.array);
        this.array[index * this.itemSize + 3] = w;
        return this;
    }
    /**
	 * Sets the x and y component of the vector at the given index.
	 *
	 * @param {number} index - The index into the buffer attribute.
	 * @param {number} x - The value for the x component to set.
	 * @param {number} y - The value for the y component to set.
	 * @return {BufferAttribute} A reference to this instance.
	 */ setXY(index, x, y) {
        index *= this.itemSize;
        if (this.normalized) {
            x = $9ddd7e9b53f7a2d4$var$normalize(x, this.array);
            y = $9ddd7e9b53f7a2d4$var$normalize(y, this.array);
        }
        this.array[index + 0] = x;
        this.array[index + 1] = y;
        return this;
    }
    /**
	 * Sets the x, y and z component of the vector at the given index.
	 *
	 * @param {number} index - The index into the buffer attribute.
	 * @param {number} x - The value for the x component to set.
	 * @param {number} y - The value for the y component to set.
	 * @param {number} z - The value for the z component to set.
	 * @return {BufferAttribute} A reference to this instance.
	 */ setXYZ(index, x, y, z) {
        index *= this.itemSize;
        if (this.normalized) {
            x = $9ddd7e9b53f7a2d4$var$normalize(x, this.array);
            y = $9ddd7e9b53f7a2d4$var$normalize(y, this.array);
            z = $9ddd7e9b53f7a2d4$var$normalize(z, this.array);
        }
        this.array[index + 0] = x;
        this.array[index + 1] = y;
        this.array[index + 2] = z;
        return this;
    }
    /**
	 * Sets the x, y, z and w component of the vector at the given index.
	 *
	 * @param {number} index - The index into the buffer attribute.
	 * @param {number} x - The value for the x component to set.
	 * @param {number} y - The value for the y component to set.
	 * @param {number} z - The value for the z component to set.
	 * @param {number} w - The value for the w component to set.
	 * @return {BufferAttribute} A reference to this instance.
	 */ setXYZW(index, x, y, z, w) {
        index *= this.itemSize;
        if (this.normalized) {
            x = $9ddd7e9b53f7a2d4$var$normalize(x, this.array);
            y = $9ddd7e9b53f7a2d4$var$normalize(y, this.array);
            z = $9ddd7e9b53f7a2d4$var$normalize(z, this.array);
            w = $9ddd7e9b53f7a2d4$var$normalize(w, this.array);
        }
        this.array[index + 0] = x;
        this.array[index + 1] = y;
        this.array[index + 2] = z;
        this.array[index + 3] = w;
        return this;
    }
    /**
	 * Sets the given callback function that is executed after the Renderer has transferred
	 * the attribute array data to the GPU. Can be used to perform clean-up operations after
	 * the upload when attribute data are not needed anymore on the CPU side.
	 *
	 * @param {Function} callback - The `onUpload()` callback.
	 * @return {BufferAttribute} A reference to this instance.
	 */ onUpload(callback) {
        this.onUploadCallback = callback;
        return this;
    }
    /**
	 * Returns a new buffer attribute with copied values from this instance.
	 *
	 * @return {BufferAttribute} A clone of this instance.
	 */ clone() {
        return new this.constructor(this.array, this.itemSize).copy(this);
    }
    /**
	 * Serializes the buffer attribute into JSON.
	 *
	 * @return {Object} A JSON object representing the serialized buffer attribute.
	 */ toJSON() {
        const data = {
            itemSize: this.itemSize,
            type: this.array.constructor.name,
            array: Array.from(this.array),
            normalized: this.normalized
        };
        if (this.name !== '') data.name = this.name;
        if (this.usage !== $9ddd7e9b53f7a2d4$export$763e8360f4d7f77d) data.usage = this.usage;
        return data;
    }
}
/**
 * Convenient class that can be used when creating a `Int8` buffer attribute with
 * a plain `Array` instance.
 *
 * @augments BufferAttribute
 */ class $9ddd7e9b53f7a2d4$export$f9ff2d6a20248cbf extends $9ddd7e9b53f7a2d4$export$8dea267bd6bde117 {
    /**
	 * Constructs a new buffer attribute.
	 *
	 * @param {(Array<number>|Int8Array)} array - The array holding the attribute data.
	 * @param {number} itemSize - The item size.
	 * @param {boolean} [normalized=false] - Whether the data are normalized or not.
	 */ constructor(array, itemSize, normalized){
        super(new Int8Array(array), itemSize, normalized);
    }
}
/**
 * Convenient class that can be used when creating a `UInt8` buffer attribute with
 * a plain `Array` instance.
 *
 * @augments BufferAttribute
 */ class $9ddd7e9b53f7a2d4$export$cacc90cf35d11cdd extends $9ddd7e9b53f7a2d4$export$8dea267bd6bde117 {
    /**
	 * Constructs a new buffer attribute.
	 *
	 * @param {(Array<number>|Uint8Array)} array - The array holding the attribute data.
	 * @param {number} itemSize - The item size.
	 * @param {boolean} [normalized=false] - Whether the data are normalized or not.
	 */ constructor(array, itemSize, normalized){
        super(new Uint8Array(array), itemSize, normalized);
    }
}
/**
 * Convenient class that can be used when creating a `UInt8Clamped` buffer attribute with
 * a plain `Array` instance.
 *
 * @augments BufferAttribute
 */ class $9ddd7e9b53f7a2d4$export$baaa85a1a812c157 extends $9ddd7e9b53f7a2d4$export$8dea267bd6bde117 {
    /**
	 * Constructs a new buffer attribute.
	 *
	 * @param {(Array<number>|Uint8ClampedArray)} array - The array holding the attribute data.
	 * @param {number} itemSize - The item size.
	 * @param {boolean} [normalized=false] - Whether the data are normalized or not.
	 */ constructor(array, itemSize, normalized){
        super(new Uint8ClampedArray(array), itemSize, normalized);
    }
}
/**
 * Convenient class that can be used when creating a `Int16` buffer attribute with
 * a plain `Array` instance.
 *
 * @augments BufferAttribute
 */ class $9ddd7e9b53f7a2d4$export$2b755a102ccdcefe extends $9ddd7e9b53f7a2d4$export$8dea267bd6bde117 {
    /**
	 * Constructs a new buffer attribute.
	 *
	 * @param {(Array<number>|Int16Array)} array - The array holding the attribute data.
	 * @param {number} itemSize - The item size.
	 * @param {boolean} [normalized=false] - Whether the data are normalized or not.
	 */ constructor(array, itemSize, normalized){
        super(new Int16Array(array), itemSize, normalized);
    }
}
/**
 * Convenient class that can be used when creating a `UInt16` buffer attribute with
 * a plain `Array` instance.
 *
 * @augments BufferAttribute
 */ class $9ddd7e9b53f7a2d4$export$640a853f68025f2e extends $9ddd7e9b53f7a2d4$export$8dea267bd6bde117 {
    /**
	 * Constructs a new buffer attribute.
	 *
	 * @param {(Array<number>|Uint16Array)} array - The array holding the attribute data.
	 * @param {number} itemSize - The item size.
	 * @param {boolean} [normalized=false] - Whether the data are normalized or not.
	 */ constructor(array, itemSize, normalized){
        super(new Uint16Array(array), itemSize, normalized);
    }
}
/**
 * Convenient class that can be used when creating a `Int32` buffer attribute with
 * a plain `Array` instance.
 *
 * @augments BufferAttribute
 */ class $9ddd7e9b53f7a2d4$export$46b369aed2968a0a extends $9ddd7e9b53f7a2d4$export$8dea267bd6bde117 {
    /**
	 * Constructs a new buffer attribute.
	 *
	 * @param {(Array<number>|Int32Array)} array - The array holding the attribute data.
	 * @param {number} itemSize - The item size.
	 * @param {boolean} [normalized=false] - Whether the data are normalized or not.
	 */ constructor(array, itemSize, normalized){
        super(new Int32Array(array), itemSize, normalized);
    }
}
/**
 * Convenient class that can be used when creating a `UInt32` buffer attribute with
 * a plain `Array` instance.
 *
 * @augments BufferAttribute
 */ class $9ddd7e9b53f7a2d4$export$7eb8c9fa25cd5bd6 extends $9ddd7e9b53f7a2d4$export$8dea267bd6bde117 {
    /**
	 * Constructs a new buffer attribute.
	 *
	 * @param {(Array<number>|Uint32Array)} array - The array holding the attribute data.
	 * @param {number} itemSize - The item size.
	 * @param {boolean} [normalized=false] - Whether the data are normalized or not.
	 */ constructor(array, itemSize, normalized){
        super(new Uint32Array(array), itemSize, normalized);
    }
}
/**
 * Convenient class that can be used when creating a `Float16` buffer attribute with
 * a plain `Array` instance.
 *
 * This class automatically converts to to and from FP16 since `Float16Array` is not
 * natively supported in JavaScript.
 *
 * @augments BufferAttribute
 */ class $9ddd7e9b53f7a2d4$export$dbd3698c64958d69 extends $9ddd7e9b53f7a2d4$export$8dea267bd6bde117 {
    /**
	 * Constructs a new buffer attribute.
	 *
	 * @param {(Array<number>|Uint16Array)} array - The array holding the attribute data.
	 * @param {number} itemSize - The item size.
	 * @param {boolean} [normalized=false] - Whether the data are normalized or not.
	 */ constructor(array, itemSize, normalized){
        super(new Uint16Array(array), itemSize, normalized);
        this.isFloat16BufferAttribute = true;
    }
    getX(index) {
        let x = $9ddd7e9b53f7a2d4$var$fromHalfFloat(this.array[index * this.itemSize]);
        if (this.normalized) x = $9ddd7e9b53f7a2d4$var$denormalize(x, this.array);
        return x;
    }
    setX(index, x) {
        if (this.normalized) x = $9ddd7e9b53f7a2d4$var$normalize(x, this.array);
        this.array[index * this.itemSize] = $9ddd7e9b53f7a2d4$var$toHalfFloat(x);
        return this;
    }
    getY(index) {
        let y = $9ddd7e9b53f7a2d4$var$fromHalfFloat(this.array[index * this.itemSize + 1]);
        if (this.normalized) y = $9ddd7e9b53f7a2d4$var$denormalize(y, this.array);
        return y;
    }
    setY(index, y) {
        if (this.normalized) y = $9ddd7e9b53f7a2d4$var$normalize(y, this.array);
        this.array[index * this.itemSize + 1] = $9ddd7e9b53f7a2d4$var$toHalfFloat(y);
        return this;
    }
    getZ(index) {
        let z = $9ddd7e9b53f7a2d4$var$fromHalfFloat(this.array[index * this.itemSize + 2]);
        if (this.normalized) z = $9ddd7e9b53f7a2d4$var$denormalize(z, this.array);
        return z;
    }
    setZ(index, z) {
        if (this.normalized) z = $9ddd7e9b53f7a2d4$var$normalize(z, this.array);
        this.array[index * this.itemSize + 2] = $9ddd7e9b53f7a2d4$var$toHalfFloat(z);
        return this;
    }
    getW(index) {
        let w = $9ddd7e9b53f7a2d4$var$fromHalfFloat(this.array[index * this.itemSize + 3]);
        if (this.normalized) w = $9ddd7e9b53f7a2d4$var$denormalize(w, this.array);
        return w;
    }
    setW(index, w) {
        if (this.normalized) w = $9ddd7e9b53f7a2d4$var$normalize(w, this.array);
        this.array[index * this.itemSize + 3] = $9ddd7e9b53f7a2d4$var$toHalfFloat(w);
        return this;
    }
    setXY(index, x, y) {
        index *= this.itemSize;
        if (this.normalized) {
            x = $9ddd7e9b53f7a2d4$var$normalize(x, this.array);
            y = $9ddd7e9b53f7a2d4$var$normalize(y, this.array);
        }
        this.array[index + 0] = $9ddd7e9b53f7a2d4$var$toHalfFloat(x);
        this.array[index + 1] = $9ddd7e9b53f7a2d4$var$toHalfFloat(y);
        return this;
    }
    setXYZ(index, x, y, z) {
        index *= this.itemSize;
        if (this.normalized) {
            x = $9ddd7e9b53f7a2d4$var$normalize(x, this.array);
            y = $9ddd7e9b53f7a2d4$var$normalize(y, this.array);
            z = $9ddd7e9b53f7a2d4$var$normalize(z, this.array);
        }
        this.array[index + 0] = $9ddd7e9b53f7a2d4$var$toHalfFloat(x);
        this.array[index + 1] = $9ddd7e9b53f7a2d4$var$toHalfFloat(y);
        this.array[index + 2] = $9ddd7e9b53f7a2d4$var$toHalfFloat(z);
        return this;
    }
    setXYZW(index, x, y, z, w) {
        index *= this.itemSize;
        if (this.normalized) {
            x = $9ddd7e9b53f7a2d4$var$normalize(x, this.array);
            y = $9ddd7e9b53f7a2d4$var$normalize(y, this.array);
            z = $9ddd7e9b53f7a2d4$var$normalize(z, this.array);
            w = $9ddd7e9b53f7a2d4$var$normalize(w, this.array);
        }
        this.array[index + 0] = $9ddd7e9b53f7a2d4$var$toHalfFloat(x);
        this.array[index + 1] = $9ddd7e9b53f7a2d4$var$toHalfFloat(y);
        this.array[index + 2] = $9ddd7e9b53f7a2d4$var$toHalfFloat(z);
        this.array[index + 3] = $9ddd7e9b53f7a2d4$var$toHalfFloat(w);
        return this;
    }
}
/**
 * Convenient class that can be used when creating a `Float32` buffer attribute with
 * a plain `Array` instance.
 *
 * @augments BufferAttribute
 */ class $9ddd7e9b53f7a2d4$export$cbe7a62641830ebd extends $9ddd7e9b53f7a2d4$export$8dea267bd6bde117 {
    /**
	 * Constructs a new buffer attribute.
	 *
	 * @param {(Array<number>|Float32Array)} array - The array holding the attribute data.
	 * @param {number} itemSize - The item size.
	 * @param {boolean} [normalized=false] - Whether the data are normalized or not.
	 */ constructor(array, itemSize, normalized){
        super(new Float32Array(array), itemSize, normalized);
    }
}
let $9ddd7e9b53f7a2d4$var$_id$1 = 0;
const $9ddd7e9b53f7a2d4$var$_m1 = /*@__PURE__*/ new $9ddd7e9b53f7a2d4$export$2ae72fc923e5eb5();
const $9ddd7e9b53f7a2d4$var$_obj = /*@__PURE__*/ new $9ddd7e9b53f7a2d4$export$e4dd07dff30cc924();
const $9ddd7e9b53f7a2d4$var$_offset = /*@__PURE__*/ new $9ddd7e9b53f7a2d4$export$64b5c384219d3699();
const $9ddd7e9b53f7a2d4$var$_box$2 = /*@__PURE__*/ new $9ddd7e9b53f7a2d4$export$6f7d5a9418ab2aa3();
const $9ddd7e9b53f7a2d4$var$_boxMorphTargets = /*@__PURE__*/ new $9ddd7e9b53f7a2d4$export$6f7d5a9418ab2aa3();
const $9ddd7e9b53f7a2d4$var$_vector$8 = /*@__PURE__*/ new $9ddd7e9b53f7a2d4$export$64b5c384219d3699();
/**
 * A representation of mesh, line, or point geometry. Includes vertex
 * positions, face indices, normals, colors, UVs, and custom attributes
 * within buffers, reducing the cost of passing all this data to the GPU.
 *
 * ```js
 * const geometry = new THREE.BufferGeometry();
 * // create a simple square shape. We duplicate the top left and bottom right
 * // vertices because each vertex needs to appear once per triangle.
 * const vertices = new Float32Array( [
 * 	-1.0, -1.0,  1.0, // v0
 * 	 1.0, -1.0,  1.0, // v1
 * 	 1.0,  1.0,  1.0, // v2
 *
 * 	 1.0,  1.0,  1.0, // v3
 * 	-1.0,  1.0,  1.0, // v4
 * 	-1.0, -1.0,  1.0  // v5
 * ] );
 * // itemSize = 3 because there are 3 values (components) per vertex
 * geometry.setAttribute( 'position', new THREE.BufferAttribute( vertices, 3 ) );
 * const material = new THREE.MeshBasicMaterial( { color: 0xff0000 } );
 * const mesh = new THREE.Mesh( geometry, material );
 * ```
 *
 * @augments EventDispatcher
 */ class $9ddd7e9b53f7a2d4$export$b7be63a67df8959 extends $9ddd7e9b53f7a2d4$export$ec8b666c5fe2c75a {
    /**
	 * Constructs a new geometry.
	 */ constructor(){
        super();
        /**
		 * This flag can be used for type testing.
		 *
		 * @type {boolean}
		 * @readonly
		 * @default true
		 */ this.isBufferGeometry = true;
        /**
		 * The ID of the geometry.
		 *
		 * @name BufferGeometry#id
		 * @type {number}
		 * @readonly
		 */ Object.defineProperty(this, 'id', {
            value: $9ddd7e9b53f7a2d4$var$_id$1++
        });
        /**
		 * The UUID of the geometry.
		 *
		 * @type {string}
		 * @readonly
		 */ this.uuid = $9ddd7e9b53f7a2d4$var$generateUUID();
        /**
		 * The name of the geometry.
		 *
		 * @type {string}
		 */ this.name = '';
        this.type = 'BufferGeometry';
        /**
		 * Allows for vertices to be re-used across multiple triangles; this is
		 * called using "indexed triangles". Each triangle is associated with the
		 * indices of three vertices. This attribute therefore stores the index of
		 * each vertex for each triangular face. If this attribute is not set, the
		 * renderer assumes that each three contiguous positions represent a single triangle.
		 *
		 * @type {?BufferAttribute}
		 * @default null
		 */ this.index = null;
        /**
		 * A (storage) buffer attribute which was generated with a compute shader and
		 * now defines indirect draw calls.
		 *
		 * Can only be used with {@link WebGPURenderer} and a WebGPU backend.
		 *
		 * @type {?BufferAttribute}
		 * @default null
		 */ this.indirect = null;
        /**
		 * This dictionary has as id the name of the attribute to be set and as value
		 * the buffer attribute to set it to. Rather than accessing this property directly,
		 * use `setAttribute()` and `getAttribute()` to access attributes of this geometry.
		 *
		 * @type {Object<string,(BufferAttribute|InterleavedBufferAttribute)>}
		 */ this.attributes = {};
        /**
		 * This dictionary holds the morph targets of the geometry.
		 *
		 * Note: Once the geometry has been rendered, the morph attribute data cannot
		 * be changed. You will have to call `dispose()?, and create a new geometry instance.
		 *
		 * @type {Object}
		 */ this.morphAttributes = {};
        /**
		 * Used to control the morph target behavior; when set to `true`, the morph
		 * target data is treated as relative offsets, rather than as absolute
		 * positions/normals.
		 *
		 * @type {boolean}
		 * @default false
		 */ this.morphTargetsRelative = false;
        /**
		 * Split the geometry into groups, each of which will be rendered in a
		 * separate draw call. This allows an array of materials to be used with the geometry.
		 *
		 * Use `addGroup()` and `clearGroups()` to edit groups, rather than modifying this array directly.
		 *
		 * Every vertex and index must belong to exactly one group — groups must not share vertices or
		 * indices, and must not leave vertices or indices unused.
		 *
		 * @type {Array<Object>}
		 */ this.groups = [];
        /**
		 * Bounding box for the geometry which can be calculated with `computeBoundingBox()`.
		 *
		 * @type {Box3}
		 * @default null
		 */ this.boundingBox = null;
        /**
		 * Bounding sphere for the geometry which can be calculated with `computeBoundingSphere()`.
		 *
		 * @type {Sphere}
		 * @default null
		 */ this.boundingSphere = null;
        /**
		 * Determines the part of the geometry to render. This should not be set directly,
		 * instead use `setDrawRange()`.
		 *
		 * @type {{start:number,count:number}}
		 */ this.drawRange = {
            start: 0,
            count: Infinity
        };
        /**
		 * An object that can be used to store custom data about the geometry.
		 * It should not hold references to functions as these will not be cloned.
		 *
		 * @type {Object}
		 */ this.userData = {};
    }
    /**
	 * Returns the index of this geometry.
	 *
	 * @return {?BufferAttribute} The index. Returns `null` if no index is defined.
	 */ getIndex() {
        return this.index;
    }
    /**
	 * Sets the given index to this geometry.
	 *
	 * @param {Array<number>|BufferAttribute} index - The index to set.
	 * @return {BufferGeometry} A reference to this instance.
	 */ setIndex(index) {
        if (Array.isArray(index)) this.index = new ($9ddd7e9b53f7a2d4$export$bc6f937da07eae17(index) ? $9ddd7e9b53f7a2d4$export$7eb8c9fa25cd5bd6 : $9ddd7e9b53f7a2d4$export$640a853f68025f2e)(index, 1);
        else this.index = index;
        return this;
    }
    /**
	 * Sets the given indirect attribute to this geometry.
	 *
	 * @param {BufferAttribute} indirect - The attribute holding indirect draw calls.
	 * @return {BufferGeometry} A reference to this instance.
	 */ setIndirect(indirect) {
        this.indirect = indirect;
        return this;
    }
    /**
	 * Returns the indirect attribute of this geometry.
	 *
	 * @return {?BufferAttribute} The indirect attribute. Returns `null` if no indirect attribute is defined.
	 */ getIndirect() {
        return this.indirect;
    }
    /**
	 * Returns the buffer attribute for the given name.
	 *
	 * @param {string} name - The attribute name.
	 * @return {BufferAttribute|InterleavedBufferAttribute|undefined} The buffer attribute.
	 * Returns `undefined` if not attribute has been found.
	 */ getAttribute(name) {
        return this.attributes[name];
    }
    /**
	 * Sets the given attribute for the given name.
	 *
	 * @param {string} name - The attribute name.
	 * @param {BufferAttribute|InterleavedBufferAttribute} attribute - The attribute to set.
	 * @return {BufferGeometry} A reference to this instance.
	 */ setAttribute(name, attribute) {
        this.attributes[name] = attribute;
        return this;
    }
    /**
	 * Deletes the attribute for the given name.
	 *
	 * @param {string} name - The attribute name to delete.
	 * @return {BufferGeometry} A reference to this instance.
	 */ deleteAttribute(name) {
        delete this.attributes[name];
        return this;
    }
    /**
	 * Returns `true` if this geometry has an attribute for the given name.
	 *
	 * @param {string} name - The attribute name.
	 * @return {boolean} Whether this geometry has an attribute for the given name or not.
	 */ hasAttribute(name) {
        return this.attributes[name] !== undefined;
    }
    /**
	 * Adds a group to this geometry.
	 *
	 * @param {number} start - The first element in this draw call. That is the first
	 * vertex for non-indexed geometry, otherwise the first triangle index.
	 * @param {number} count - Specifies how many vertices (or indices) are part of this group.
	 * @param {number} [materialIndex=0] - The material array index to use.
	 */ addGroup(start, count, materialIndex = 0) {
        this.groups.push({
            start: start,
            count: count,
            materialIndex: materialIndex
        });
    }
    /**
	 * Clears all groups.
	 */ clearGroups() {
        this.groups = [];
    }
    /**
	 * Sets the draw range for this geometry.
	 *
	 * @param {number} start - The first vertex for non-indexed geometry, otherwise the first triangle index.
	 * @param {number} count - For non-indexed BufferGeometry, `count` is the number of vertices to render.
	 * For indexed BufferGeometry, `count` is the number of indices to render.
	 */ setDrawRange(start, count) {
        this.drawRange.start = start;
        this.drawRange.count = count;
    }
    /**
	 * Applies the given 4x4 transformation matrix to the geometry.
	 *
	 * @param {Matrix4} matrix - The matrix to apply.
	 * @return {BufferGeometry} A reference to this instance.
	 */ applyMatrix4(matrix) {
        const position = this.attributes.position;
        if (position !== undefined) {
            position.applyMatrix4(matrix);
            position.needsUpdate = true;
        }
        const normal = this.attributes.normal;
        if (normal !== undefined) {
            const normalMatrix = new $9ddd7e9b53f7a2d4$export$8ff26dafa08918().getNormalMatrix(matrix);
            normal.applyNormalMatrix(normalMatrix);
            normal.needsUpdate = true;
        }
        const tangent = this.attributes.tangent;
        if (tangent !== undefined) {
            tangent.transformDirection(matrix);
            tangent.needsUpdate = true;
        }
        if (this.boundingBox !== null) this.computeBoundingBox();
        if (this.boundingSphere !== null) this.computeBoundingSphere();
        return this;
    }
    /**
	 * Applies the rotation represented by the Quaternion to the geometry.
	 *
	 * @param {Quaternion} q - The Quaternion to apply.
	 * @return {BufferGeometry} A reference to this instance.
	 */ applyQuaternion(q) {
        $9ddd7e9b53f7a2d4$var$_m1.makeRotationFromQuaternion(q);
        this.applyMatrix4($9ddd7e9b53f7a2d4$var$_m1);
        return this;
    }
    /**
	 * Rotates the geometry about the X axis. This is typically done as a one time
	 * operation, and not during a loop. Use {@link Object3D#rotation} for typical
	 * real-time mesh rotation.
	 *
	 * @param {number} angle - The angle in radians.
	 * @return {BufferGeometry} A reference to this instance.
	 */ rotateX(angle) {
        // rotate geometry around world x-axis
        $9ddd7e9b53f7a2d4$var$_m1.makeRotationX(angle);
        this.applyMatrix4($9ddd7e9b53f7a2d4$var$_m1);
        return this;
    }
    /**
	 * Rotates the geometry about the Y axis. This is typically done as a one time
	 * operation, and not during a loop. Use {@link Object3D#rotation} for typical
	 * real-time mesh rotation.
	 *
	 * @param {number} angle - The angle in radians.
	 * @return {BufferGeometry} A reference to this instance.
	 */ rotateY(angle) {
        // rotate geometry around world y-axis
        $9ddd7e9b53f7a2d4$var$_m1.makeRotationY(angle);
        this.applyMatrix4($9ddd7e9b53f7a2d4$var$_m1);
        return this;
    }
    /**
	 * Rotates the geometry about the Z axis. This is typically done as a one time
	 * operation, and not during a loop. Use {@link Object3D#rotation} for typical
	 * real-time mesh rotation.
	 *
	 * @param {number} angle - The angle in radians.
	 * @return {BufferGeometry} A reference to this instance.
	 */ rotateZ(angle) {
        // rotate geometry around world z-axis
        $9ddd7e9b53f7a2d4$var$_m1.makeRotationZ(angle);
        this.applyMatrix4($9ddd7e9b53f7a2d4$var$_m1);
        return this;
    }
    /**
	 * Translates the geometry. This is typically done as a one time
	 * operation, and not during a loop. Use {@link Object3D#position} for typical
	 * real-time mesh rotation.
	 *
	 * @param {number} x - The x offset.
	 * @param {number} y - The y offset.
	 * @param {number} z - The z offset.
	 * @return {BufferGeometry} A reference to this instance.
	 */ translate(x, y, z) {
        // translate geometry
        $9ddd7e9b53f7a2d4$var$_m1.makeTranslation(x, y, z);
        this.applyMatrix4($9ddd7e9b53f7a2d4$var$_m1);
        return this;
    }
    /**
	 * Scales the geometry. This is typically done as a one time
	 * operation, and not during a loop. Use {@link Object3D#scale} for typical
	 * real-time mesh rotation.
	 *
	 * @param {number} x - The x scale.
	 * @param {number} y - The y scale.
	 * @param {number} z - The z scale.
	 * @return {BufferGeometry} A reference to this instance.
	 */ scale(x, y, z) {
        // scale geometry
        $9ddd7e9b53f7a2d4$var$_m1.makeScale(x, y, z);
        this.applyMatrix4($9ddd7e9b53f7a2d4$var$_m1);
        return this;
    }
    /**
	 * Rotates the geometry to face a point in 3D space. This is typically done as a one time
	 * operation, and not during a loop. Use {@link Object3D#lookAt} for typical
	 * real-time mesh rotation.
	 *
	 * @param {Vector3} vector - The target point.
	 * @return {BufferGeometry} A reference to this instance.
	 */ lookAt(vector) {
        $9ddd7e9b53f7a2d4$var$_obj.lookAt(vector);
        $9ddd7e9b53f7a2d4$var$_obj.updateMatrix();
        this.applyMatrix4($9ddd7e9b53f7a2d4$var$_obj.matrix);
        return this;
    }
    /**
	 * Center the geometry based on its bounding box.
	 *
	 * @return {BufferGeometry} A reference to this instance.
	 */ center() {
        this.computeBoundingBox();
        this.boundingBox.getCenter($9ddd7e9b53f7a2d4$var$_offset).negate();
        this.translate($9ddd7e9b53f7a2d4$var$_offset.x, $9ddd7e9b53f7a2d4$var$_offset.y, $9ddd7e9b53f7a2d4$var$_offset.z);
        return this;
    }
    /**
	 * Defines a geometry by creating a `position` attribute based on the given array of points. The array
	 * can hold 2D or 3D vectors. When using two-dimensional data, the `z` coordinate for all vertices is
	 * set to `0`.
	 *
	 * If the method is used with an existing `position` attribute, the vertex data are overwritten with the
	 * data from the array. The length of the array must match the vertex count.
	 *
	 * @param {Array<Vector2>|Array<Vector3>} points - The points.
	 * @return {BufferGeometry} A reference to this instance.
	 */ setFromPoints(points) {
        const positionAttribute = this.getAttribute('position');
        if (positionAttribute === undefined) {
            const position = [];
            for(let i = 0, l = points.length; i < l; i++){
                const point = points[i];
                position.push(point.x, point.y, point.z || 0);
            }
            this.setAttribute('position', new $9ddd7e9b53f7a2d4$export$cbe7a62641830ebd(position, 3));
        } else {
            const l = Math.min(points.length, positionAttribute.count); // make sure data do not exceed buffer size
            for(let i = 0; i < l; i++){
                const point = points[i];
                positionAttribute.setXYZ(i, point.x, point.y, point.z || 0);
            }
            if (points.length > positionAttribute.count) console.warn('THREE.BufferGeometry: Buffer size too small for points data. Use .dispose() and create a new geometry.');
            positionAttribute.needsUpdate = true;
        }
        return this;
    }
    /**
	 * Computes the bounding box of the geometry, and updates the `boundingBox` member.
	 * The bounding box is not computed by the engine; it must be computed by your app.
	 * You may need to recompute the bounding box if the geometry vertices are modified.
	 */ computeBoundingBox() {
        if (this.boundingBox === null) this.boundingBox = new $9ddd7e9b53f7a2d4$export$6f7d5a9418ab2aa3();
        const position = this.attributes.position;
        const morphAttributesPosition = this.morphAttributes.position;
        if (position && position.isGLBufferAttribute) {
            console.error('THREE.BufferGeometry.computeBoundingBox(): GLBufferAttribute requires a manual bounding box.', this);
            this.boundingBox.set(new $9ddd7e9b53f7a2d4$export$64b5c384219d3699(-Infinity, -Infinity, -Infinity), new $9ddd7e9b53f7a2d4$export$64b5c384219d3699(Infinity, Infinity, Infinity));
            return;
        }
        if (position !== undefined) {
            this.boundingBox.setFromBufferAttribute(position);
            // process morph attributes if present
            if (morphAttributesPosition) for(let i = 0, il = morphAttributesPosition.length; i < il; i++){
                const morphAttribute = morphAttributesPosition[i];
                $9ddd7e9b53f7a2d4$var$_box$2.setFromBufferAttribute(morphAttribute);
                if (this.morphTargetsRelative) {
                    $9ddd7e9b53f7a2d4$var$_vector$8.addVectors(this.boundingBox.min, $9ddd7e9b53f7a2d4$var$_box$2.min);
                    this.boundingBox.expandByPoint($9ddd7e9b53f7a2d4$var$_vector$8);
                    $9ddd7e9b53f7a2d4$var$_vector$8.addVectors(this.boundingBox.max, $9ddd7e9b53f7a2d4$var$_box$2.max);
                    this.boundingBox.expandByPoint($9ddd7e9b53f7a2d4$var$_vector$8);
                } else {
                    this.boundingBox.expandByPoint($9ddd7e9b53f7a2d4$var$_box$2.min);
                    this.boundingBox.expandByPoint($9ddd7e9b53f7a2d4$var$_box$2.max);
                }
            }
        } else this.boundingBox.makeEmpty();
        if (isNaN(this.boundingBox.min.x) || isNaN(this.boundingBox.min.y) || isNaN(this.boundingBox.min.z)) console.error('THREE.BufferGeometry.computeBoundingBox(): Computed min/max have NaN values. The "position" attribute is likely to have NaN values.', this);
    }
    /**
	 * Computes the bounding sphere of the geometry, and updates the `boundingSphere` member.
	 * The engine automatically computes the bounding sphere when it is needed, e.g., for ray casting or view frustum culling.
	 * You may need to recompute the bounding sphere if the geometry vertices are modified.
	 */ computeBoundingSphere() {
        if (this.boundingSphere === null) this.boundingSphere = new $9ddd7e9b53f7a2d4$export$805e8b72413ccaba();
        const position = this.attributes.position;
        const morphAttributesPosition = this.morphAttributes.position;
        if (position && position.isGLBufferAttribute) {
            console.error('THREE.BufferGeometry.computeBoundingSphere(): GLBufferAttribute requires a manual bounding sphere.', this);
            this.boundingSphere.set(new $9ddd7e9b53f7a2d4$export$64b5c384219d3699(), Infinity);
            return;
        }
        if (position) {
            // first, find the center of the bounding sphere
            const center = this.boundingSphere.center;
            $9ddd7e9b53f7a2d4$var$_box$2.setFromBufferAttribute(position);
            // process morph attributes if present
            if (morphAttributesPosition) for(let i = 0, il = morphAttributesPosition.length; i < il; i++){
                const morphAttribute = morphAttributesPosition[i];
                $9ddd7e9b53f7a2d4$var$_boxMorphTargets.setFromBufferAttribute(morphAttribute);
                if (this.morphTargetsRelative) {
                    $9ddd7e9b53f7a2d4$var$_vector$8.addVectors($9ddd7e9b53f7a2d4$var$_box$2.min, $9ddd7e9b53f7a2d4$var$_boxMorphTargets.min);
                    $9ddd7e9b53f7a2d4$var$_box$2.expandByPoint($9ddd7e9b53f7a2d4$var$_vector$8);
                    $9ddd7e9b53f7a2d4$var$_vector$8.addVectors($9ddd7e9b53f7a2d4$var$_box$2.max, $9ddd7e9b53f7a2d4$var$_boxMorphTargets.max);
                    $9ddd7e9b53f7a2d4$var$_box$2.expandByPoint($9ddd7e9b53f7a2d4$var$_vector$8);
                } else {
                    $9ddd7e9b53f7a2d4$var$_box$2.expandByPoint($9ddd7e9b53f7a2d4$var$_boxMorphTargets.min);
                    $9ddd7e9b53f7a2d4$var$_box$2.expandByPoint($9ddd7e9b53f7a2d4$var$_boxMorphTargets.max);
                }
            }
            $9ddd7e9b53f7a2d4$var$_box$2.getCenter(center);
            // second, try to find a boundingSphere with a radius smaller than the
            // boundingSphere of the boundingBox: sqrt(3) smaller in the best case
            let maxRadiusSq = 0;
            for(let i = 0, il = position.count; i < il; i++){
                $9ddd7e9b53f7a2d4$var$_vector$8.fromBufferAttribute(position, i);
                maxRadiusSq = Math.max(maxRadiusSq, center.distanceToSquared($9ddd7e9b53f7a2d4$var$_vector$8));
            }
            // process morph attributes if present
            if (morphAttributesPosition) for(let i = 0, il = morphAttributesPosition.length; i < il; i++){
                const morphAttribute = morphAttributesPosition[i];
                const morphTargetsRelative = this.morphTargetsRelative;
                for(let j = 0, jl = morphAttribute.count; j < jl; j++){
                    $9ddd7e9b53f7a2d4$var$_vector$8.fromBufferAttribute(morphAttribute, j);
                    if (morphTargetsRelative) {
                        $9ddd7e9b53f7a2d4$var$_offset.fromBufferAttribute(position, j);
                        $9ddd7e9b53f7a2d4$var$_vector$8.add($9ddd7e9b53f7a2d4$var$_offset);
                    }
                    maxRadiusSq = Math.max(maxRadiusSq, center.distanceToSquared($9ddd7e9b53f7a2d4$var$_vector$8));
                }
            }
            this.boundingSphere.radius = Math.sqrt(maxRadiusSq);
            if (isNaN(this.boundingSphere.radius)) console.error('THREE.BufferGeometry.computeBoundingSphere(): Computed radius is NaN. The "position" attribute is likely to have NaN values.', this);
        }
    }
    /**
	 * Calculates and adds a tangent attribute to this geometry.
	 *
	 * The computation is only supported for indexed geometries and if position, normal, and uv attributes
	 * are defined. When using a tangent space normal map, prefer the MikkTSpace algorithm provided by
	 * {@link BufferGeometryUtils#computeMikkTSpaceTangents} instead.
	 */ computeTangents() {
        const index = this.index;
        const attributes = this.attributes;
        // based on http://www.terathon.com/code/tangent.html
        // (per vertex tangents)
        if (index === null || attributes.position === undefined || attributes.normal === undefined || attributes.uv === undefined) {
            console.error('THREE.BufferGeometry: .computeTangents() failed. Missing required attributes (index, position, normal or uv)');
            return;
        }
        const positionAttribute = attributes.position;
        const normalAttribute = attributes.normal;
        const uvAttribute = attributes.uv;
        if (this.hasAttribute('tangent') === false) this.setAttribute('tangent', new $9ddd7e9b53f7a2d4$export$8dea267bd6bde117(new Float32Array(4 * positionAttribute.count), 4));
        const tangentAttribute = this.getAttribute('tangent');
        const tan1 = [], tan2 = [];
        for(let i = 0; i < positionAttribute.count; i++){
            tan1[i] = new $9ddd7e9b53f7a2d4$export$64b5c384219d3699();
            tan2[i] = new $9ddd7e9b53f7a2d4$export$64b5c384219d3699();
        }
        const vA = new $9ddd7e9b53f7a2d4$export$64b5c384219d3699(), vB = new $9ddd7e9b53f7a2d4$export$64b5c384219d3699(), vC = new $9ddd7e9b53f7a2d4$export$64b5c384219d3699(), uvA = new $9ddd7e9b53f7a2d4$export$c977b3e384af9ae1(), uvB = new $9ddd7e9b53f7a2d4$export$c977b3e384af9ae1(), uvC = new $9ddd7e9b53f7a2d4$export$c977b3e384af9ae1(), sdir = new $9ddd7e9b53f7a2d4$export$64b5c384219d3699(), tdir = new $9ddd7e9b53f7a2d4$export$64b5c384219d3699();
        function handleTriangle(a, b, c) {
            vA.fromBufferAttribute(positionAttribute, a);
            vB.fromBufferAttribute(positionAttribute, b);
            vC.fromBufferAttribute(positionAttribute, c);
            uvA.fromBufferAttribute(uvAttribute, a);
            uvB.fromBufferAttribute(uvAttribute, b);
            uvC.fromBufferAttribute(uvAttribute, c);
            vB.sub(vA);
            vC.sub(vA);
            uvB.sub(uvA);
            uvC.sub(uvA);
            const r = 1.0 / (uvB.x * uvC.y - uvC.x * uvB.y);
            // silently ignore degenerate uv triangles having coincident or colinear vertices
            if (!isFinite(r)) return;
            sdir.copy(vB).multiplyScalar(uvC.y).addScaledVector(vC, -uvB.y).multiplyScalar(r);
            tdir.copy(vC).multiplyScalar(uvB.x).addScaledVector(vB, -uvC.x).multiplyScalar(r);
            tan1[a].add(sdir);
            tan1[b].add(sdir);
            tan1[c].add(sdir);
            tan2[a].add(tdir);
            tan2[b].add(tdir);
            tan2[c].add(tdir);
        }
        let groups = this.groups;
        if (groups.length === 0) groups = [
            {
                start: 0,
                count: index.count
            }
        ];
        for(let i = 0, il = groups.length; i < il; ++i){
            const group = groups[i];
            const start = group.start;
            const count = group.count;
            for(let j = start, jl = start + count; j < jl; j += 3)handleTriangle(index.getX(j + 0), index.getX(j + 1), index.getX(j + 2));
        }
        const tmp = new $9ddd7e9b53f7a2d4$export$64b5c384219d3699(), tmp2 = new $9ddd7e9b53f7a2d4$export$64b5c384219d3699();
        const n = new $9ddd7e9b53f7a2d4$export$64b5c384219d3699(), n2 = new $9ddd7e9b53f7a2d4$export$64b5c384219d3699();
        function handleVertex(v) {
            n.fromBufferAttribute(normalAttribute, v);
            n2.copy(n);
            const t = tan1[v];
            // Gram-Schmidt orthogonalize
            tmp.copy(t);
            tmp.sub(n.multiplyScalar(n.dot(t))).normalize();
            // Calculate handedness
            tmp2.crossVectors(n2, t);
            const test = tmp2.dot(tan2[v]);
            const w = test < 0.0 ? -1 : 1.0;
            tangentAttribute.setXYZW(v, tmp.x, tmp.y, tmp.z, w);
        }
        for(let i = 0, il = groups.length; i < il; ++i){
            const group = groups[i];
            const start = group.start;
            const count = group.count;
            for(let j = start, jl = start + count; j < jl; j += 3){
                handleVertex(index.getX(j + 0));
                handleVertex(index.getX(j + 1));
                handleVertex(index.getX(j + 2));
            }
        }
    }
    /**
	 * Computes vertex normals for the given vertex data. For indexed geometries, the method sets
	 * each vertex normal to be the average of the face normals of the faces that share that vertex.
	 * For non-indexed geometries, vertices are not shared, and the method sets each vertex normal
	 * to be the same as the face normal.
	 */ computeVertexNormals() {
        const index = this.index;
        const positionAttribute = this.getAttribute('position');
        if (positionAttribute !== undefined) {
            let normalAttribute = this.getAttribute('normal');
            if (normalAttribute === undefined) {
                normalAttribute = new $9ddd7e9b53f7a2d4$export$8dea267bd6bde117(new Float32Array(positionAttribute.count * 3), 3);
                this.setAttribute('normal', normalAttribute);
            } else // reset existing normals to zero
            for(let i = 0, il = normalAttribute.count; i < il; i++)normalAttribute.setXYZ(i, 0, 0, 0);
            const pA = new $9ddd7e9b53f7a2d4$export$64b5c384219d3699(), pB = new $9ddd7e9b53f7a2d4$export$64b5c384219d3699(), pC = new $9ddd7e9b53f7a2d4$export$64b5c384219d3699();
            const nA = new $9ddd7e9b53f7a2d4$export$64b5c384219d3699(), nB = new $9ddd7e9b53f7a2d4$export$64b5c384219d3699(), nC = new $9ddd7e9b53f7a2d4$export$64b5c384219d3699();
            const cb = new $9ddd7e9b53f7a2d4$export$64b5c384219d3699(), ab = new $9ddd7e9b53f7a2d4$export$64b5c384219d3699();
            // indexed elements
            if (index) for(let i = 0, il = index.count; i < il; i += 3){
                const vA = index.getX(i + 0);
                const vB = index.getX(i + 1);
                const vC = index.getX(i + 2);
                pA.fromBufferAttribute(positionAttribute, vA);
                pB.fromBufferAttribute(positionAttribute, vB);
                pC.fromBufferAttribute(positionAttribute, vC);
                cb.subVectors(pC, pB);
                ab.subVectors(pA, pB);
                cb.cross(ab);
                nA.fromBufferAttribute(normalAttribute, vA);
                nB.fromBufferAttribute(normalAttribute, vB);
                nC.fromBufferAttribute(normalAttribute, vC);
                nA.add(cb);
                nB.add(cb);
                nC.add(cb);
                normalAttribute.setXYZ(vA, nA.x, nA.y, nA.z);
                normalAttribute.setXYZ(vB, nB.x, nB.y, nB.z);
                normalAttribute.setXYZ(vC, nC.x, nC.y, nC.z);
            }
            else // non-indexed elements (unconnected triangle soup)
            for(let i = 0, il = positionAttribute.count; i < il; i += 3){
                pA.fromBufferAttribute(positionAttribute, i + 0);
                pB.fromBufferAttribute(positionAttribute, i + 1);
                pC.fromBufferAttribute(positionAttribute, i + 2);
                cb.subVectors(pC, pB);
                ab.subVectors(pA, pB);
                cb.cross(ab);
                normalAttribute.setXYZ(i + 0, cb.x, cb.y, cb.z);
                normalAttribute.setXYZ(i + 1, cb.x, cb.y, cb.z);
                normalAttribute.setXYZ(i + 2, cb.x, cb.y, cb.z);
            }
            this.normalizeNormals();
            normalAttribute.needsUpdate = true;
        }
    }
    /**
	 * Ensures every normal vector in a geometry will have a magnitude of `1`. This will
	 * correct lighting on the geometry surfaces.
	 */ normalizeNormals() {
        const normals = this.attributes.normal;
        for(let i = 0, il = normals.count; i < il; i++){
            $9ddd7e9b53f7a2d4$var$_vector$8.fromBufferAttribute(normals, i);
            $9ddd7e9b53f7a2d4$var$_vector$8.normalize();
            normals.setXYZ(i, $9ddd7e9b53f7a2d4$var$_vector$8.x, $9ddd7e9b53f7a2d4$var$_vector$8.y, $9ddd7e9b53f7a2d4$var$_vector$8.z);
        }
    }
    /**
	 * Return a new non-index version of this indexed geometry. If the geometry
	 * is already non-indexed, the method is a NOOP.
	 *
	 * @return {BufferGeometry} The non-indexed version of this indexed geometry.
	 */ toNonIndexed() {
        function convertBufferAttribute(attribute, indices) {
            const array = attribute.array;
            const itemSize = attribute.itemSize;
            const normalized = attribute.normalized;
            const array2 = new array.constructor(indices.length * itemSize);
            let index = 0, index2 = 0;
            for(let i = 0, l = indices.length; i < l; i++){
                if (attribute.isInterleavedBufferAttribute) index = indices[i] * attribute.data.stride + attribute.offset;
                else index = indices[i] * itemSize;
                for(let j = 0; j < itemSize; j++)array2[index2++] = array[index++];
            }
            return new $9ddd7e9b53f7a2d4$export$8dea267bd6bde117(array2, itemSize, normalized);
        }
        //
        if (this.index === null) {
            console.warn('THREE.BufferGeometry.toNonIndexed(): BufferGeometry is already non-indexed.');
            return this;
        }
        const geometry2 = new $9ddd7e9b53f7a2d4$export$b7be63a67df8959();
        const indices = this.index.array;
        const attributes = this.attributes;
        // attributes
        for(const name in attributes){
            const attribute = attributes[name];
            const newAttribute = convertBufferAttribute(attribute, indices);
            geometry2.setAttribute(name, newAttribute);
        }
        // morph attributes
        const morphAttributes = this.morphAttributes;
        for(const name in morphAttributes){
            const morphArray = [];
            const morphAttribute = morphAttributes[name]; // morphAttribute: array of Float32BufferAttributes
            for(let i = 0, il = morphAttribute.length; i < il; i++){
                const attribute = morphAttribute[i];
                const newAttribute = convertBufferAttribute(attribute, indices);
                morphArray.push(newAttribute);
            }
            geometry2.morphAttributes[name] = morphArray;
        }
        geometry2.morphTargetsRelative = this.morphTargetsRelative;
        // groups
        const groups = this.groups;
        for(let i = 0, l = groups.length; i < l; i++){
            const group = groups[i];
            geometry2.addGroup(group.start, group.count, group.materialIndex);
        }
        return geometry2;
    }
    /**
	 * Serializes the geometry into JSON.
	 *
	 * @return {Object} A JSON object representing the serialized geometry.
	 */ toJSON() {
        const data = {
            metadata: {
                version: 4.6,
                type: 'BufferGeometry',
                generator: 'BufferGeometry.toJSON'
            }
        };
        // standard BufferGeometry serialization
        data.uuid = this.uuid;
        data.type = this.type;
        if (this.name !== '') data.name = this.name;
        if (Object.keys(this.userData).length > 0) data.userData = this.userData;
        if (this.parameters !== undefined) {
            const parameters = this.parameters;
            for(const key in parameters)if (parameters[key] !== undefined) data[key] = parameters[key];
            return data;
        }
        // for simplicity the code assumes attributes are not shared across geometries, see #15811
        data.data = {
            attributes: {}
        };
        const index = this.index;
        if (index !== null) data.data.index = {
            type: index.array.constructor.name,
            array: Array.prototype.slice.call(index.array)
        };
        const attributes = this.attributes;
        for(const key in attributes){
            const attribute = attributes[key];
            data.data.attributes[key] = attribute.toJSON(data.data);
        }
        const morphAttributes = {};
        let hasMorphAttributes = false;
        for(const key in this.morphAttributes){
            const attributeArray = this.morphAttributes[key];
            const array = [];
            for(let i = 0, il = attributeArray.length; i < il; i++){
                const attribute = attributeArray[i];
                array.push(attribute.toJSON(data.data));
            }
            if (array.length > 0) {
                morphAttributes[key] = array;
                hasMorphAttributes = true;
            }
        }
        if (hasMorphAttributes) {
            data.data.morphAttributes = morphAttributes;
            data.data.morphTargetsRelative = this.morphTargetsRelative;
        }
        const groups = this.groups;
        if (groups.length > 0) data.data.groups = JSON.parse(JSON.stringify(groups));
        const boundingSphere = this.boundingSphere;
        if (boundingSphere !== null) data.data.boundingSphere = {
            center: boundingSphere.center.toArray(),
            radius: boundingSphere.radius
        };
        return data;
    }
    /**
	 * Returns a new geometry with copied values from this instance.
	 *
	 * @return {BufferGeometry} A clone of this instance.
	 */ clone() {
        return new this.constructor().copy(this);
    }
    /**
	 * Copies the values of the given geometry to this instance.
	 *
	 * @param {BufferGeometry} source - The geometry to copy.
	 * @return {BufferGeometry} A reference to this instance.
	 */ copy(source) {
        // reset
        this.index = null;
        this.attributes = {};
        this.morphAttributes = {};
        this.groups = [];
        this.boundingBox = null;
        this.boundingSphere = null;
        // used for storing cloned, shared data
        const data = {};
        // name
        this.name = source.name;
        // index
        const index = source.index;
        if (index !== null) this.setIndex(index.clone());
        // attributes
        const attributes = source.attributes;
        for(const name in attributes){
            const attribute = attributes[name];
            this.setAttribute(name, attribute.clone(data));
        }
        // morph attributes
        const morphAttributes = source.morphAttributes;
        for(const name in morphAttributes){
            const array = [];
            const morphAttribute = morphAttributes[name]; // morphAttribute: array of Float32BufferAttributes
            for(let i = 0, l = morphAttribute.length; i < l; i++)array.push(morphAttribute[i].clone(data));
            this.morphAttributes[name] = array;
        }
        this.morphTargetsRelative = source.morphTargetsRelative;
        // groups
        const groups = source.groups;
        for(let i = 0, l = groups.length; i < l; i++){
            const group = groups[i];
            this.addGroup(group.start, group.count, group.materialIndex);
        }
        // bounding box
        const boundingBox = source.boundingBox;
        if (boundingBox !== null) this.boundingBox = boundingBox.clone();
        // bounding sphere
        const boundingSphere = source.boundingSphere;
        if (boundingSphere !== null) this.boundingSphere = boundingSphere.clone();
        // draw range
        this.drawRange.start = source.drawRange.start;
        this.drawRange.count = source.drawRange.count;
        // user data
        this.userData = source.userData;
        return this;
    }
    /**
	 * Frees the GPU-related resources allocated by this instance. Call this
	 * method whenever this instance is no longer used in your app.
	 *
	 * @fires BufferGeometry#dispose
	 */ dispose() {
        this.dispatchEvent({
            type: 'dispose'
        });
    }
}
const $9ddd7e9b53f7a2d4$var$_inverseMatrix$3 = /*@__PURE__*/ new $9ddd7e9b53f7a2d4$export$2ae72fc923e5eb5();
const $9ddd7e9b53f7a2d4$var$_ray$3 = /*@__PURE__*/ new $9ddd7e9b53f7a2d4$export$a186db52eed6d40e();
const $9ddd7e9b53f7a2d4$var$_sphere$6 = /*@__PURE__*/ new $9ddd7e9b53f7a2d4$export$805e8b72413ccaba();
const $9ddd7e9b53f7a2d4$var$_sphereHitAt = /*@__PURE__*/ new $9ddd7e9b53f7a2d4$export$64b5c384219d3699();
const $9ddd7e9b53f7a2d4$var$_vA$1 = /*@__PURE__*/ new $9ddd7e9b53f7a2d4$export$64b5c384219d3699();
const $9ddd7e9b53f7a2d4$var$_vB$1 = /*@__PURE__*/ new $9ddd7e9b53f7a2d4$export$64b5c384219d3699();
const $9ddd7e9b53f7a2d4$var$_vC$1 = /*@__PURE__*/ new $9ddd7e9b53f7a2d4$export$64b5c384219d3699();
const $9ddd7e9b53f7a2d4$var$_tempA = /*@__PURE__*/ new $9ddd7e9b53f7a2d4$export$64b5c384219d3699();
const $9ddd7e9b53f7a2d4$var$_morphA = /*@__PURE__*/ new $9ddd7e9b53f7a2d4$export$64b5c384219d3699();
const $9ddd7e9b53f7a2d4$var$_intersectionPoint = /*@__PURE__*/ new $9ddd7e9b53f7a2d4$export$64b5c384219d3699();
const $9ddd7e9b53f7a2d4$var$_intersectionPointWorld = /*@__PURE__*/ new $9ddd7e9b53f7a2d4$export$64b5c384219d3699();
/**
 * Class representing triangular polygon mesh based objects.
 *
 * ```js
 * const geometry = new THREE.BoxGeometry( 1, 1, 1 );
 * const material = new THREE.MeshBasicMaterial( { color: 0xffff00 } );
 * const mesh = new THREE.Mesh( geometry, material );
 * scene.add( mesh );
 * ```
 *
 * @augments Object3D
 */ class $9ddd7e9b53f7a2d4$export$e176487c05830cc5 extends $9ddd7e9b53f7a2d4$export$e4dd07dff30cc924 {
    /**
	 * Constructs a new mesh.
	 *
	 * @param {BufferGeometry} [geometry] - The mesh geometry.
	 * @param {Material|Array<Material>} [material] - The mesh material.
	 */ constructor(geometry = new $9ddd7e9b53f7a2d4$export$b7be63a67df8959(), material = new $9ddd7e9b53f7a2d4$export$55cbcc9b622fe1f5()){
        super();
        /**
		 * This flag can be used for type testing.
		 *
		 * @type {boolean}
		 * @readonly
		 * @default true
		 */ this.isMesh = true;
        this.type = 'Mesh';
        /**
		 * The mesh geometry.
		 *
		 * @type {BufferGeometry}
		 */ this.geometry = geometry;
        /**
		 * The mesh material.
		 *
		 * @type {Material|Array<Material>}
		 * @default MeshBasicMaterial
		 */ this.material = material;
        /**
		 * A dictionary representing the morph targets in the geometry. The key is the
		 * morph targets name, the value its attribute index. This member is `undefined`
		 * by default and only set when morph targets are detected in the geometry.
		 *
		 * @type {Object<String,number>|undefined}
		 * @default undefined
		 */ this.morphTargetDictionary = undefined;
        /**
		 * An array of weights typically in the range `[0,1]` that specify how much of the morph
		 * is applied. This member is `undefined` by default and only set when morph targets are
		 * detected in the geometry.
		 *
		 * @type {Array<number>|undefined}
		 * @default undefined
		 */ this.morphTargetInfluences = undefined;
        this.updateMorphTargets();
    }
    copy(source, recursive) {
        super.copy(source, recursive);
        if (source.morphTargetInfluences !== undefined) this.morphTargetInfluences = source.morphTargetInfluences.slice();
        if (source.morphTargetDictionary !== undefined) this.morphTargetDictionary = Object.assign({}, source.morphTargetDictionary);
        this.material = Array.isArray(source.material) ? source.material.slice() : source.material;
        this.geometry = source.geometry;
        return this;
    }
    /**
	 * Sets the values of {@link Mesh#morphTargetDictionary} and {@link Mesh#morphTargetInfluences}
	 * to make sure existing morph targets can influence this 3D object.
	 */ updateMorphTargets() {
        const geometry = this.geometry;
        const morphAttributes = geometry.morphAttributes;
        const keys = Object.keys(morphAttributes);
        if (keys.length > 0) {
            const morphAttribute = morphAttributes[keys[0]];
            if (morphAttribute !== undefined) {
                this.morphTargetInfluences = [];
                this.morphTargetDictionary = {};
                for(let m = 0, ml = morphAttribute.length; m < ml; m++){
                    const name = morphAttribute[m].name || String(m);
                    this.morphTargetInfluences.push(0);
                    this.morphTargetDictionary[name] = m;
                }
            }
        }
    }
    /**
	 * Returns the local-space position of the vertex at the given index, taking into
	 * account the current animation state of both morph targets and skinning.
	 *
	 * @param {number} index - The vertex index.
	 * @param {Vector3} target - The target object that is used to store the method's result.
	 * @return {Vector3} The vertex position in local space.
	 */ getVertexPosition(index, target) {
        const geometry = this.geometry;
        const position = geometry.attributes.position;
        const morphPosition = geometry.morphAttributes.position;
        const morphTargetsRelative = geometry.morphTargetsRelative;
        target.fromBufferAttribute(position, index);
        const morphInfluences = this.morphTargetInfluences;
        if (morphPosition && morphInfluences) {
            $9ddd7e9b53f7a2d4$var$_morphA.set(0, 0, 0);
            for(let i = 0, il = morphPosition.length; i < il; i++){
                const influence = morphInfluences[i];
                const morphAttribute = morphPosition[i];
                if (influence === 0) continue;
                $9ddd7e9b53f7a2d4$var$_tempA.fromBufferAttribute(morphAttribute, index);
                if (morphTargetsRelative) $9ddd7e9b53f7a2d4$var$_morphA.addScaledVector($9ddd7e9b53f7a2d4$var$_tempA, influence);
                else $9ddd7e9b53f7a2d4$var$_morphA.addScaledVector($9ddd7e9b53f7a2d4$var$_tempA.sub(target), influence);
            }
            target.add($9ddd7e9b53f7a2d4$var$_morphA);
        }
        return target;
    }
    /**
	 * Computes intersection points between a casted ray and this line.
	 *
	 * @param {Raycaster} raycaster - The raycaster.
	 * @param {Array<Object>} intersects - The target array that holds the intersection points.
	 */ raycast(raycaster, intersects) {
        const geometry = this.geometry;
        const material = this.material;
        const matrixWorld = this.matrixWorld;
        if (material === undefined) return;
        // test with bounding sphere in world space
        if (geometry.boundingSphere === null) geometry.computeBoundingSphere();
        $9ddd7e9b53f7a2d4$var$_sphere$6.copy(geometry.boundingSphere);
        $9ddd7e9b53f7a2d4$var$_sphere$6.applyMatrix4(matrixWorld);
        // check distance from ray origin to bounding sphere
        $9ddd7e9b53f7a2d4$var$_ray$3.copy(raycaster.ray).recast(raycaster.near);
        if ($9ddd7e9b53f7a2d4$var$_sphere$6.containsPoint($9ddd7e9b53f7a2d4$var$_ray$3.origin) === false) {
            if ($9ddd7e9b53f7a2d4$var$_ray$3.intersectSphere($9ddd7e9b53f7a2d4$var$_sphere$6, $9ddd7e9b53f7a2d4$var$_sphereHitAt) === null) return;
            if ($9ddd7e9b53f7a2d4$var$_ray$3.origin.distanceToSquared($9ddd7e9b53f7a2d4$var$_sphereHitAt) > (raycaster.far - raycaster.near) ** 2) return;
        }
        // convert ray to local space of mesh
        $9ddd7e9b53f7a2d4$var$_inverseMatrix$3.copy(matrixWorld).invert();
        $9ddd7e9b53f7a2d4$var$_ray$3.copy(raycaster.ray).applyMatrix4($9ddd7e9b53f7a2d4$var$_inverseMatrix$3);
        // test with bounding box in local space
        if (geometry.boundingBox !== null) {
            if ($9ddd7e9b53f7a2d4$var$_ray$3.intersectsBox(geometry.boundingBox) === false) return;
        }
        // test for intersections with geometry
        this._computeIntersections(raycaster, intersects, $9ddd7e9b53f7a2d4$var$_ray$3);
    }
    _computeIntersections(raycaster, intersects, rayLocalSpace) {
        let intersection;
        const geometry = this.geometry;
        const material = this.material;
        const index = geometry.index;
        const position = geometry.attributes.position;
        const uv = geometry.attributes.uv;
        const uv1 = geometry.attributes.uv1;
        const normal = geometry.attributes.normal;
        const groups = geometry.groups;
        const drawRange = geometry.drawRange;
        if (index !== null) {
            // indexed buffer geometry
            if (Array.isArray(material)) for(let i = 0, il = groups.length; i < il; i++){
                const group = groups[i];
                const groupMaterial = material[group.materialIndex];
                const start = Math.max(group.start, drawRange.start);
                const end = Math.min(index.count, Math.min(group.start + group.count, drawRange.start + drawRange.count));
                for(let j = start, jl = end; j < jl; j += 3){
                    const a = index.getX(j);
                    const b = index.getX(j + 1);
                    const c = index.getX(j + 2);
                    intersection = $9ddd7e9b53f7a2d4$var$checkGeometryIntersection(this, groupMaterial, raycaster, rayLocalSpace, uv, uv1, normal, a, b, c);
                    if (intersection) {
                        intersection.faceIndex = Math.floor(j / 3); // triangle number in indexed buffer semantics
                        intersection.face.materialIndex = group.materialIndex;
                        intersects.push(intersection);
                    }
                }
            }
            else {
                const start = Math.max(0, drawRange.start);
                const end = Math.min(index.count, drawRange.start + drawRange.count);
                for(let i = start, il = end; i < il; i += 3){
                    const a = index.getX(i);
                    const b = index.getX(i + 1);
                    const c = index.getX(i + 2);
                    intersection = $9ddd7e9b53f7a2d4$var$checkGeometryIntersection(this, material, raycaster, rayLocalSpace, uv, uv1, normal, a, b, c);
                    if (intersection) {
                        intersection.faceIndex = Math.floor(i / 3); // triangle number in indexed buffer semantics
                        intersects.push(intersection);
                    }
                }
            }
        } else if (position !== undefined) {
            // non-indexed buffer geometry
            if (Array.isArray(material)) for(let i = 0, il = groups.length; i < il; i++){
                const group = groups[i];
                const groupMaterial = material[group.materialIndex];
                const start = Math.max(group.start, drawRange.start);
                const end = Math.min(position.count, Math.min(group.start + group.count, drawRange.start + drawRange.count));
                for(let j = start, jl = end; j < jl; j += 3){
                    const a = j;
                    const b = j + 1;
                    const c = j + 2;
                    intersection = $9ddd7e9b53f7a2d4$var$checkGeometryIntersection(this, groupMaterial, raycaster, rayLocalSpace, uv, uv1, normal, a, b, c);
                    if (intersection) {
                        intersection.faceIndex = Math.floor(j / 3); // triangle number in non-indexed buffer semantics
                        intersection.face.materialIndex = group.materialIndex;
                        intersects.push(intersection);
                    }
                }
            }
            else {
                const start = Math.max(0, drawRange.start);
                const end = Math.min(position.count, drawRange.start + drawRange.count);
                for(let i = start, il = end; i < il; i += 3){
                    const a = i;
                    const b = i + 1;
                    const c = i + 2;
                    intersection = $9ddd7e9b53f7a2d4$var$checkGeometryIntersection(this, material, raycaster, rayLocalSpace, uv, uv1, normal, a, b, c);
                    if (intersection) {
                        intersection.faceIndex = Math.floor(i / 3); // triangle number in non-indexed buffer semantics
                        intersects.push(intersection);
                    }
                }
            }
        }
    }
}
function $9ddd7e9b53f7a2d4$var$checkIntersection$1(object, material, raycaster, ray, pA, pB, pC, point) {
    let intersect;
    if (material.side === $9ddd7e9b53f7a2d4$export$d9f0486e75b5ace) intersect = ray.intersectTriangle(pC, pB, pA, true, point);
    else intersect = ray.intersectTriangle(pA, pB, pC, material.side === $9ddd7e9b53f7a2d4$export$2ede184fc2998901, point);
    if (intersect === null) return null;
    $9ddd7e9b53f7a2d4$var$_intersectionPointWorld.copy(point);
    $9ddd7e9b53f7a2d4$var$_intersectionPointWorld.applyMatrix4(object.matrixWorld);
    const distance = raycaster.ray.origin.distanceTo($9ddd7e9b53f7a2d4$var$_intersectionPointWorld);
    if (distance < raycaster.near || distance > raycaster.far) return null;
    return {
        distance: distance,
        point: $9ddd7e9b53f7a2d4$var$_intersectionPointWorld.clone(),
        object: object
    };
}
function $9ddd7e9b53f7a2d4$var$checkGeometryIntersection(object, material, raycaster, ray, uv, uv1, normal, a, b, c) {
    object.getVertexPosition(a, $9ddd7e9b53f7a2d4$var$_vA$1);
    object.getVertexPosition(b, $9ddd7e9b53f7a2d4$var$_vB$1);
    object.getVertexPosition(c, $9ddd7e9b53f7a2d4$var$_vC$1);
    const intersection = $9ddd7e9b53f7a2d4$var$checkIntersection$1(object, material, raycaster, ray, $9ddd7e9b53f7a2d4$var$_vA$1, $9ddd7e9b53f7a2d4$var$_vB$1, $9ddd7e9b53f7a2d4$var$_vC$1, $9ddd7e9b53f7a2d4$var$_intersectionPoint);
    if (intersection) {
        const barycoord = new $9ddd7e9b53f7a2d4$export$64b5c384219d3699();
        $9ddd7e9b53f7a2d4$export$5a465592bfe74b48.getBarycoord($9ddd7e9b53f7a2d4$var$_intersectionPoint, $9ddd7e9b53f7a2d4$var$_vA$1, $9ddd7e9b53f7a2d4$var$_vB$1, $9ddd7e9b53f7a2d4$var$_vC$1, barycoord);
        if (uv) intersection.uv = $9ddd7e9b53f7a2d4$export$5a465592bfe74b48.getInterpolatedAttribute(uv, a, b, c, barycoord, new $9ddd7e9b53f7a2d4$export$c977b3e384af9ae1());
        if (uv1) intersection.uv1 = $9ddd7e9b53f7a2d4$export$5a465592bfe74b48.getInterpolatedAttribute(uv1, a, b, c, barycoord, new $9ddd7e9b53f7a2d4$export$c977b3e384af9ae1());
        if (normal) {
            intersection.normal = $9ddd7e9b53f7a2d4$export$5a465592bfe74b48.getInterpolatedAttribute(normal, a, b, c, barycoord, new $9ddd7e9b53f7a2d4$export$64b5c384219d3699());
            if (intersection.normal.dot(ray.direction) > 0) intersection.normal.multiplyScalar(-1);
        }
        const face = {
            a: a,
            b: b,
            c: c,
            normal: new $9ddd7e9b53f7a2d4$export$64b5c384219d3699(),
            materialIndex: 0
        };
        $9ddd7e9b53f7a2d4$export$5a465592bfe74b48.getNormal($9ddd7e9b53f7a2d4$var$_vA$1, $9ddd7e9b53f7a2d4$var$_vB$1, $9ddd7e9b53f7a2d4$var$_vC$1, face.normal);
        intersection.face = face;
        intersection.barycoord = barycoord;
    }
    return intersection;
}
/**
 * A geometry class for a rectangular cuboid with a given width, height, and depth.
 * On creation, the cuboid is centred on the origin, with each edge parallel to one
 * of the axes.
 *
 * ```js
 * const geometry = new THREE.BoxGeometry( 1, 1, 1 );
 * const material = new THREE.MeshBasicMaterial( { color: 0x00ff00 } );
 * const cube = new THREE.Mesh( geometry, material );
 * scene.add( cube );
 * ```
 *
 * @augments BufferGeometry
 */ class $9ddd7e9b53f7a2d4$export$33e43285f7406bd5 extends $9ddd7e9b53f7a2d4$export$b7be63a67df8959 {
    /**
	 * Constructs a new box geometry.
	 *
	 * @param {number} [width=1] - The width. That is, the length of the edges parallel to the X axis.
	 * @param {number} [height=1] - The height. That is, the length of the edges parallel to the Y axis.
	 * @param {number} [depth=1] - The depth. That is, the length of the edges parallel to the Z axis.
	 * @param {number} [widthSegments=1] - Number of segmented rectangular faces along the width of the sides.
	 * @param {number} [heightSegments=1] - Number of segmented rectangular faces along the height of the sides.
	 * @param {number} [depthSegments=1] - Number of segmented rectangular faces along the depth of the sides.
	 */ constructor(width = 1, height = 1, depth = 1, widthSegments = 1, heightSegments = 1, depthSegments = 1){
        super();
        this.type = 'BoxGeometry';
        /**
		 * Holds the constructor parameters that have been
		 * used to generate the geometry. Any modification
		 * after instantiation does not change the geometry.
		 *
		 * @type {Object}
		 */ this.parameters = {
            width: width,
            height: height,
            depth: depth,
            widthSegments: widthSegments,
            heightSegments: heightSegments,
            depthSegments: depthSegments
        };
        const scope = this;
        // segments
        widthSegments = Math.floor(widthSegments);
        heightSegments = Math.floor(heightSegments);
        depthSegments = Math.floor(depthSegments);
        // buffers
        const indices = [];
        const vertices = [];
        const normals = [];
        const uvs = [];
        // helper variables
        let numberOfVertices = 0;
        let groupStart = 0;
        // build each side of the box geometry
        buildPlane('z', 'y', 'x', -1, -1, depth, height, width, depthSegments, heightSegments, 0); // px
        buildPlane('z', 'y', 'x', 1, -1, depth, height, -width, depthSegments, heightSegments, 1); // nx
        buildPlane('x', 'z', 'y', 1, 1, width, depth, height, widthSegments, depthSegments, 2); // py
        buildPlane('x', 'z', 'y', 1, -1, width, depth, -height, widthSegments, depthSegments, 3); // ny
        buildPlane('x', 'y', 'z', 1, -1, width, height, depth, widthSegments, heightSegments, 4); // pz
        buildPlane('x', 'y', 'z', -1, -1, width, height, -depth, widthSegments, heightSegments, 5); // nz
        // build geometry
        this.setIndex(indices);
        this.setAttribute('position', new $9ddd7e9b53f7a2d4$export$cbe7a62641830ebd(vertices, 3));
        this.setAttribute('normal', new $9ddd7e9b53f7a2d4$export$cbe7a62641830ebd(normals, 3));
        this.setAttribute('uv', new $9ddd7e9b53f7a2d4$export$cbe7a62641830ebd(uvs, 2));
        function buildPlane(u, v, w, udir, vdir, width, height, depth, gridX, gridY, materialIndex) {
            const segmentWidth = width / gridX;
            const segmentHeight = height / gridY;
            const widthHalf = width / 2;
            const heightHalf = height / 2;
            const depthHalf = depth / 2;
            const gridX1 = gridX + 1;
            const gridY1 = gridY + 1;
            let vertexCounter = 0;
            let groupCount = 0;
            const vector = new $9ddd7e9b53f7a2d4$export$64b5c384219d3699();
            // generate vertices, normals and uvs
            for(let iy = 0; iy < gridY1; iy++){
                const y = iy * segmentHeight - heightHalf;
                for(let ix = 0; ix < gridX1; ix++){
                    const x = ix * segmentWidth - widthHalf;
                    // set values to correct vector component
                    vector[u] = x * udir;
                    vector[v] = y * vdir;
                    vector[w] = depthHalf;
                    // now apply vector to vertex buffer
                    vertices.push(vector.x, vector.y, vector.z);
                    // set values to correct vector component
                    vector[u] = 0;
                    vector[v] = 0;
                    vector[w] = depth > 0 ? 1 : -1;
                    // now apply vector to normal buffer
                    normals.push(vector.x, vector.y, vector.z);
                    // uvs
                    uvs.push(ix / gridX);
                    uvs.push(1 - iy / gridY);
                    // counters
                    vertexCounter += 1;
                }
            }
            // indices
            // 1. you need three indices to draw a single face
            // 2. a single segment consists of two faces
            // 3. so we need to generate six (2*3) indices per segment
            for(let iy = 0; iy < gridY; iy++)for(let ix = 0; ix < gridX; ix++){
                const a = numberOfVertices + ix + gridX1 * iy;
                const b = numberOfVertices + ix + gridX1 * (iy + 1);
                const c = numberOfVertices + (ix + 1) + gridX1 * (iy + 1);
                const d = numberOfVertices + (ix + 1) + gridX1 * iy;
                // faces
                indices.push(a, b, d);
                indices.push(b, c, d);
                // increase counter
                groupCount += 6;
            }
            // add a group to the geometry. this will ensure multi material support
            scope.addGroup(groupStart, groupCount, materialIndex);
            // calculate new start value for groups
            groupStart += groupCount;
            // update total number of vertices
            numberOfVertices += vertexCounter;
        }
    }
    copy(source) {
        super.copy(source);
        this.parameters = Object.assign({}, source.parameters);
        return this;
    }
    /**
	 * Factory method for creating an instance of this class from the given
	 * JSON object.
	 *
	 * @param {Object} data - A JSON object representing the serialized geometry.
	 * @return {BoxGeometry} A new instance.
	 */ static fromJSON(data) {
        return new $9ddd7e9b53f7a2d4$export$33e43285f7406bd5(data.width, data.height, data.depth, data.widthSegments, data.heightSegments, data.depthSegments);
    }
}
// Uniform Utilities
function $9ddd7e9b53f7a2d4$export$acda854380553452(src) {
    const dst = {};
    for(const u in src){
        dst[u] = {};
        for(const p in src[u]){
            const property = src[u][p];
            if (property && (property.isColor || property.isMatrix3 || property.isMatrix4 || property.isVector2 || property.isVector3 || property.isVector4 || property.isTexture || property.isQuaternion)) {
                if (property.isRenderTargetTexture) {
                    console.warn('UniformsUtils: Textures of render targets cannot be cloned via cloneUniforms() or mergeUniforms().');
                    dst[u][p] = null;
                } else dst[u][p] = property.clone();
            } else if (Array.isArray(property)) dst[u][p] = property.slice();
            else dst[u][p] = property;
        }
    }
    return dst;
}
function $9ddd7e9b53f7a2d4$export$8916ce6879271f43(uniforms) {
    const merged = {};
    for(let u = 0; u < uniforms.length; u++){
        const tmp = $9ddd7e9b53f7a2d4$export$acda854380553452(uniforms[u]);
        for(const p in tmp)merged[p] = tmp[p];
    }
    return merged;
}
function $9ddd7e9b53f7a2d4$var$cloneUniformsGroups(src) {
    const dst = [];
    for(let u = 0; u < src.length; u++)dst.push(src[u].clone());
    return dst;
}
function $9ddd7e9b53f7a2d4$export$a630742c640528c1(renderer) {
    const currentRenderTarget = renderer.getRenderTarget();
    if (currentRenderTarget === null) // https://github.com/mrdoob/three.js/pull/23937#issuecomment-1111067398
    return renderer.outputColorSpace;
    // https://github.com/mrdoob/three.js/issues/27868
    if (currentRenderTarget.isXRRenderTarget === true) return currentRenderTarget.texture.colorSpace;
    return $9ddd7e9b53f7a2d4$export$5e6fd513f44698c.workingColorSpace;
}
// Legacy
const $9ddd7e9b53f7a2d4$export$d8ecdf8615bfea69 = {
    clone: $9ddd7e9b53f7a2d4$export$acda854380553452,
    merge: $9ddd7e9b53f7a2d4$export$8916ce6879271f43
};
var $9ddd7e9b53f7a2d4$var$default_vertex = "void main() {\n\tgl_Position = projectionMatrix * modelViewMatrix * vec4( position, 1.0 );\n}";
var $9ddd7e9b53f7a2d4$var$default_fragment = "void main() {\n\tgl_FragColor = vec4( 1.0, 0.0, 0.0, 1.0 );\n}";
/**
 * A material rendered with custom shaders. A shader is a small program written in GLSL.
 * that runs on the GPU. You may want to use a custom shader if you need to implement an
 * effect not included with any of the built-in materials.
 *
 * There are the following notes to bear in mind when using a `ShaderMaterial`:
 *
 * - `ShaderMaterial` can only be used with {@link WebGLRenderer}.
 * - Built in attributes and uniforms are passed to the shaders along with your code. If
 * you don't want that, use {@link RawShaderMaterial} instead.
 * - You can use the directive `#pragma unroll_loop_start` and `#pragma unroll_loop_end`
 * in order to unroll a `for` loop in GLSL by the shader preprocessor. The directive has
 * to be placed right above the loop. The loop formatting has to correspond to a defined standard.
 *   - The loop has to be [normalized]{@link https://en.wikipedia.org/wiki/Normalized_loop}.
 *   - The loop variable has to be *i*.
 *   - The value `UNROLLED_LOOP_INDEX` will be replaced with the explicitly
 * value of *i* for the given iteration and can be used in preprocessor
 * statements.
 *
 * ```js
 * const material = new THREE.ShaderMaterial( {
 * 	uniforms: {
 * 		time: { value: 1.0 },
 * 		resolution: { value: new THREE.Vector2() }
 * 	},
 * 	vertexShader: document.getElementById( 'vertexShader' ).textContent,
 * 	fragmentShader: document.getElementById( 'fragmentShader' ).textContent
 * } );
 * ```
 *
 * @augments Material
 */ class $9ddd7e9b53f7a2d4$export$83c7d75d550a8b0d extends $9ddd7e9b53f7a2d4$export$a2d8b23205c25948 {
    /**
	 * Constructs a new shader material.
	 *
	 * @param {Object} [parameters] - An object with one or more properties
	 * defining the material's appearance. Any property of the material
	 * (including any property from inherited materials) can be passed
	 * in here. Color values can be passed any type of value accepted
	 * by {@link Color#set}.
	 */ constructor(parameters){
        super();
        /**
		 * This flag can be used for type testing.
		 *
		 * @type {boolean}
		 * @readonly
		 * @default true
		 */ this.isShaderMaterial = true;
        this.type = 'ShaderMaterial';
        /**
		 * Defines custom constants using `#define` directives within the GLSL code
		 * for both the vertex shader and the fragment shader; each key/value pair
		 * yields another directive.
		 * ```js
		 * defines: {
		 * 	FOO: 15,
		 * 	BAR: true
		 * }
		 * ```
		 * Yields the lines:
		 * ```
		 * #define FOO 15
		 * #define BAR true
		 * ```
		 *
		 * @type {Object}
		 */ this.defines = {};
        /**
		 * An object of the form:
		 * ```js
		 * {
		 * 	"uniform1": { value: 1.0 },
		 * 	"uniform2": { value: 2 }
		 * }
		 * ```
		 * specifying the uniforms to be passed to the shader code; keys are uniform
		 * names, values are definitions of the form
		 * ```
		 * {
		 * 	value: 1.0
		 * }
		 * ```
		 * where `value` is the value of the uniform. Names must match the name of
		 * the uniform, as defined in the GLSL code. Note that uniforms are refreshed
		 * on every frame, so updating the value of the uniform will immediately
		 * update the value available to the GLSL code.
		 *
		 * @type {Object}
		 */ this.uniforms = {};
        /**
		 * An array holding uniforms groups for configuring UBOs.
		 *
		 * @type {Array<UniformsGroup>}
		 */ this.uniformsGroups = [];
        /**
		 * Vertex shader GLSL code. This is the actual code for the shader.
		 *
		 * @type {string}
		 */ this.vertexShader = $9ddd7e9b53f7a2d4$var$default_vertex;
        /**
		 * Fragment shader GLSL code. This is the actual code for the shader.
		 *
		 * @type {string}
		 */ this.fragmentShader = $9ddd7e9b53f7a2d4$var$default_fragment;
        /**
		 * Controls line thickness or lines.
		 *
		 * WebGL and WebGPU ignore this setting and always render line primitives with a
		 * width of one pixel.
		 *
		 * @type {number}
		 * @default 1
		 */ this.linewidth = 1;
        /**
		 * Renders the geometry as a wireframe.
		 *
		 * @type {boolean}
		 * @default false
		 */ this.wireframe = false;
        /**
		 * Controls the thickness of the wireframe.
		 *
		 * WebGL and WebGPU ignore this property and always render
		 * 1 pixel wide lines.
		 *
		 * @type {number}
		 * @default 1
		 */ this.wireframeLinewidth = 1;
        /**
		 * Define whether the material color is affected by global fog settings; `true`
		 * to pass fog uniforms to the shader.
		 *
		 * @type {boolean}
		 * @default false
		 */ this.fog = false;
        /**
		 * Defines whether this material uses lighting; `true` to pass uniform data
		 * related to lighting to this shader.
		 *
		 * @type {boolean}
		 * @default false
		 */ this.lights = false;
        /**
		 * Defines whether this material supports clipping; `true` to let the renderer
		 * pass the clippingPlanes uniform.
		 *
		 * @type {boolean}
		 * @default false
		 */ this.clipping = false;
        /**
		 * Overwritten and set to `true` by default.
		 *
		 * @type {boolean}
		 * @default true
		 */ this.forceSinglePass = true;
        /**
		 * This object allows to enable certain WebGL 2 extensions.
		 *
		 * - clipCullDistance: set to `true` to use vertex shader clipping
		 * - multiDraw: set to `true` to use vertex shader multi_draw / enable gl_DrawID
		 *
		 * @type {{clipCullDistance:false,multiDraw:false}}
		 */ this.extensions = {
            clipCullDistance: false,
            multiDraw: false // set to use vertex shader multi_draw / enable gl_DrawID
        };
        /**
		 * When the rendered geometry doesn't include these attributes but the
		 * material does, these default values will be passed to the shaders. This
		 * avoids errors when buffer data is missing.
		 *
		 * - color: [ 1, 1, 1 ]
		 * - uv: [ 0, 0 ]
		 * - uv1: [ 0, 0 ]
		 *
		 * @type {Object}
		 */ this.defaultAttributeValues = {
            'color': [
                1,
                1,
                1
            ],
            'uv': [
                0,
                0
            ],
            'uv1': [
                0,
                0
            ]
        };
        /**
		 * If set, this calls [gl.bindAttribLocation]{@link https://developer.mozilla.org/en-US/docs/Web/API/WebGLRenderingContext/bindAttribLocation}
		 * to bind a generic vertex index to an attribute variable.
		 *
		 * @type {string|undefined}
		 * @default undefined
		 */ this.index0AttributeName = undefined;
        /**
		 * Can be used to force a uniform update while changing uniforms in
		 * {@link Object3D#onBeforeRender}.
		 *
		 * @type {boolean}
		 * @default false
		 */ this.uniformsNeedUpdate = false;
        /**
		 * Defines the GLSL version of custom shader code.
		 *
		 * @type {?(GLSL1|GLSL3)}
		 * @default null
		 */ this.glslVersion = null;
        if (parameters !== undefined) this.setValues(parameters);
    }
    copy(source) {
        super.copy(source);
        this.fragmentShader = source.fragmentShader;
        this.vertexShader = source.vertexShader;
        this.uniforms = $9ddd7e9b53f7a2d4$export$acda854380553452(source.uniforms);
        this.uniformsGroups = $9ddd7e9b53f7a2d4$var$cloneUniformsGroups(source.uniformsGroups);
        this.defines = Object.assign({}, source.defines);
        this.wireframe = source.wireframe;
        this.wireframeLinewidth = source.wireframeLinewidth;
        this.fog = source.fog;
        this.lights = source.lights;
        this.clipping = source.clipping;
        this.extensions = Object.assign({}, source.extensions);
        this.glslVersion = source.glslVersion;
        return this;
    }
    toJSON(meta) {
        const data = super.toJSON(meta);
        data.glslVersion = this.glslVersion;
        data.uniforms = {};
        for(const name in this.uniforms){
            const uniform = this.uniforms[name];
            const value = uniform.value;
            if (value && value.isTexture) data.uniforms[name] = {
                type: 't',
                value: value.toJSON(meta).uuid
            };
            else if (value && value.isColor) data.uniforms[name] = {
                type: 'c',
                value: value.getHex()
            };
            else if (value && value.isVector2) data.uniforms[name] = {
                type: 'v2',
                value: value.toArray()
            };
            else if (value && value.isVector3) data.uniforms[name] = {
                type: 'v3',
                value: value.toArray()
            };
            else if (value && value.isVector4) data.uniforms[name] = {
                type: 'v4',
                value: value.toArray()
            };
            else if (value && value.isMatrix3) data.uniforms[name] = {
                type: 'm3',
                value: value.toArray()
            };
            else if (value && value.isMatrix4) data.uniforms[name] = {
                type: 'm4',
                value: value.toArray()
            };
            else data.uniforms[name] = {
                value: value
            };
        }
        if (Object.keys(this.defines).length > 0) data.defines = this.defines;
        data.vertexShader = this.vertexShader;
        data.fragmentShader = this.fragmentShader;
        data.lights = this.lights;
        data.clipping = this.clipping;
        const extensions = {};
        for(const key in this.extensions)if (this.extensions[key] === true) extensions[key] = true;
        if (Object.keys(extensions).length > 0) data.extensions = extensions;
        return data;
    }
}
/**
 * Abstract base class for cameras. This class should always be inherited
 * when you build a new camera.
 *
 * @abstract
 * @augments Object3D
 */ class $9ddd7e9b53f7a2d4$export$79f141de891a5fed extends $9ddd7e9b53f7a2d4$export$e4dd07dff30cc924 {
    /**
	 * Constructs a new camera.
	 */ constructor(){
        super();
        /**
		 * This flag can be used for type testing.
		 *
		 * @type {boolean}
		 * @readonly
		 * @default true
		 */ this.isCamera = true;
        this.type = 'Camera';
        /**
		 * The inverse of the camera's world matrix.
		 *
		 * @type {Matrix4}
		 */ this.matrixWorldInverse = new $9ddd7e9b53f7a2d4$export$2ae72fc923e5eb5();
        /**
		 * The camera's projection matrix.
		 *
		 * @type {Matrix4}
		 */ this.projectionMatrix = new $9ddd7e9b53f7a2d4$export$2ae72fc923e5eb5();
        /**
		 * The inverse of the camera's projection matrix.
		 *
		 * @type {Matrix4}
		 */ this.projectionMatrixInverse = new $9ddd7e9b53f7a2d4$export$2ae72fc923e5eb5();
        /**
		 * The coordinate system in which the camera is used.
		 *
		 * @type {(WebGLCoordinateSystem|WebGPUCoordinateSystem)}
		 */ this.coordinateSystem = $9ddd7e9b53f7a2d4$export$5a0e9190d10875d3;
    }
    copy(source, recursive) {
        super.copy(source, recursive);
        this.matrixWorldInverse.copy(source.matrixWorldInverse);
        this.projectionMatrix.copy(source.projectionMatrix);
        this.projectionMatrixInverse.copy(source.projectionMatrixInverse);
        this.coordinateSystem = source.coordinateSystem;
        return this;
    }
    /**
	 * Returns a vector representing the ("look") direction of the 3D object in world space.
	 *
	 * This method is overwritten since cameras have a different forward vector compared to other
	 * 3D objects. A camera looks down its local, negative z-axis by default.
	 *
	 * @param {Vector3} target - The target vector the result is stored to.
	 * @return {Vector3} The 3D object's direction in world space.
	 */ getWorldDirection(target) {
        return super.getWorldDirection(target).negate();
    }
    updateMatrixWorld(force) {
        super.updateMatrixWorld(force);
        this.matrixWorldInverse.copy(this.matrixWorld).invert();
    }
    updateWorldMatrix(updateParents, updateChildren) {
        super.updateWorldMatrix(updateParents, updateChildren);
        this.matrixWorldInverse.copy(this.matrixWorld).invert();
    }
    clone() {
        return new this.constructor().copy(this);
    }
}
const $9ddd7e9b53f7a2d4$var$_v3$1 = /*@__PURE__*/ new $9ddd7e9b53f7a2d4$export$64b5c384219d3699();
const $9ddd7e9b53f7a2d4$var$_minTarget = /*@__PURE__*/ new $9ddd7e9b53f7a2d4$export$c977b3e384af9ae1();
const $9ddd7e9b53f7a2d4$var$_maxTarget = /*@__PURE__*/ new $9ddd7e9b53f7a2d4$export$c977b3e384af9ae1();
/**
 * Camera that uses [perspective projection]{@link https://en.wikipedia.org/wiki/Perspective_(graphical)}.
 *
 * This projection mode is designed to mimic the way the human eye sees. It
 * is the most common projection mode used for rendering a 3D scene.
 *
 * ```js
 * const camera = new THREE.PerspectiveCamera( 45, width / height, 1, 1000 );
 * scene.add( camera );
 * ```
 *
 * @augments Camera
 */ class $9ddd7e9b53f7a2d4$export$74e4ae24825f68d7 extends $9ddd7e9b53f7a2d4$export$79f141de891a5fed {
    /**
	 * Constructs a new perspective camera.
	 *
	 * @param {number} [fov=50] - The vertical field of view.
	 * @param {number} [aspect=1] - The aspect ratio.
	 * @param {number} [near=0.1] - The camera's near plane.
	 * @param {number} [far=2000] - The camera's far plane.
	 */ constructor(fov = 50, aspect = 1, near = 0.1, far = 2000){
        super();
        /**
		 * This flag can be used for type testing.
		 *
		 * @type {boolean}
		 * @readonly
		 * @default true
		 */ this.isPerspectiveCamera = true;
        this.type = 'PerspectiveCamera';
        /**
		 * The vertical field of view, from bottom to top of view,
		 * in degrees.
		 *
		 * @type {number}
		 * @default 50
		 */ this.fov = fov;
        /**
		 * The zoom factor of the camera.
		 *
		 * @type {number}
		 * @default 1
		 */ this.zoom = 1;
        /**
		 * The camera's near plane. The valid range is greater than `0`
		 * and less than the current value of {@link PerspectiveCamera#far}.
		 *
		 * Note that, unlike for the {@link OrthographicCamera}, `0` is <em>not</em> a
		 * valid value for a perspective camera's near plane.
		 *
		 * @type {number}
		 * @default 0.1
		 */ this.near = near;
        /**
		 * The camera's far plane. Must be greater than the
		 * current value of {@link PerspectiveCamera#near}.
		 *
		 * @type {number}
		 * @default 2000
		 */ this.far = far;
        /**
		 * Object distance used for stereoscopy and depth-of-field effects. This
		 * parameter does not influence the projection matrix unless a
		 * {@link StereoCamera} is being used.
		 *
		 * @type {number}
		 * @default 10
		 */ this.focus = 10;
        /**
		 * The aspect ratio, usually the canvas width / canvas height.
		 *
		 * @type {number}
		 * @default 1
		 */ this.aspect = aspect;
        /**
		 * Represents the frustum window specification. This property should not be edited
		 * directly but via {@link PerspectiveCamera#setViewOffset} and {@link PerspectiveCamera#clearViewOffset}.
		 *
		 * @type {?Object}
		 * @default null
		 */ this.view = null;
        /**
		 * Film size used for the larger axis. Default is `35` (millimeters). This
		 * parameter does not influence the projection matrix unless {@link PerspectiveCamera#filmOffset}
		 * is set to a nonzero value.
		 *
		 * @type {number}
		 * @default 35
		 */ this.filmGauge = 35;
        /**
		 * Horizontal off-center offset in the same unit as {@link PerspectiveCamera#filmGauge}.
		 *
		 * @type {number}
		 * @default 0
		 */ this.filmOffset = 0;
        this.updateProjectionMatrix();
    }
    copy(source, recursive) {
        super.copy(source, recursive);
        this.fov = source.fov;
        this.zoom = source.zoom;
        this.near = source.near;
        this.far = source.far;
        this.focus = source.focus;
        this.aspect = source.aspect;
        this.view = source.view === null ? null : Object.assign({}, source.view);
        this.filmGauge = source.filmGauge;
        this.filmOffset = source.filmOffset;
        return this;
    }
    /**
	 * Sets the FOV by focal length in respect to the current {@link PerspectiveCamera#filmGauge}.
	 *
	 * The default film gauge is 35, so that the focal length can be specified for
	 * a 35mm (full frame) camera.
	 *
	 * @param {number} focalLength - Values for focal length and film gauge must have the same unit.
	 */ setFocalLength(focalLength) {
        /** see {@link http://www.bobatkins.com/photography/technical/field_of_view.html} */ const vExtentSlope = 0.5 * this.getFilmHeight() / focalLength;
        this.fov = $9ddd7e9b53f7a2d4$export$914076c8150813e5 * 2 * Math.atan(vExtentSlope);
        this.updateProjectionMatrix();
    }
    /**
	 * Returns the focal length from the current {@link PerspectiveCamera#fov} and
	 * {@link PerspectiveCamera#filmGauge}.
	 *
	 * @return {number} The computed focal length.
	 */ getFocalLength() {
        const vExtentSlope = Math.tan($9ddd7e9b53f7a2d4$var$DEG2RAD * 0.5 * this.fov);
        return 0.5 * this.getFilmHeight() / vExtentSlope;
    }
    /**
	 * Returns the current vertical field of view angle in degrees considering {@link PerspectiveCamera#zoom}.
	 *
	 * @return {number} The effective FOV.
	 */ getEffectiveFOV() {
        return $9ddd7e9b53f7a2d4$export$914076c8150813e5 * 2 * Math.atan(Math.tan($9ddd7e9b53f7a2d4$var$DEG2RAD * 0.5 * this.fov) / this.zoom);
    }
    /**
	 * Returns the width of the image on the film. If {@link PerspectiveCamera#aspect} is greater than or
	 * equal to one (landscape format), the result equals {@link PerspectiveCamera#filmGauge}.
	 *
	 * @return {number} The film width.
	 */ getFilmWidth() {
        // film not completely covered in portrait format (aspect < 1)
        return this.filmGauge * Math.min(this.aspect, 1);
    }
    /**
	 * Returns the height of the image on the film. If {@link PerspectiveCamera#aspect} is greater than or
	 * equal to one (landscape format), the result equals {@link PerspectiveCamera#filmGauge}.
	 *
	 * @return {number} The film width.
	 */ getFilmHeight() {
        // film not completely covered in landscape format (aspect > 1)
        return this.filmGauge / Math.max(this.aspect, 1);
    }
    /**
	 * Computes the 2D bounds of the camera's viewable rectangle at a given distance along the viewing direction.
	 * Sets `minTarget` and `maxTarget` to the coordinates of the lower-left and upper-right corners of the view rectangle.
	 *
	 * @param {number} distance - The viewing distance.
	 * @param {Vector2} minTarget - The lower-left corner of the view rectangle is written into this vector.
	 * @param {Vector2} maxTarget - The upper-right corner of the view rectangle is written into this vector.
	 */ getViewBounds(distance, minTarget, maxTarget) {
        $9ddd7e9b53f7a2d4$var$_v3$1.set(-1, -1, 0.5).applyMatrix4(this.projectionMatrixInverse);
        minTarget.set($9ddd7e9b53f7a2d4$var$_v3$1.x, $9ddd7e9b53f7a2d4$var$_v3$1.y).multiplyScalar(-distance / $9ddd7e9b53f7a2d4$var$_v3$1.z);
        $9ddd7e9b53f7a2d4$var$_v3$1.set(1, 1, 0.5).applyMatrix4(this.projectionMatrixInverse);
        maxTarget.set($9ddd7e9b53f7a2d4$var$_v3$1.x, $9ddd7e9b53f7a2d4$var$_v3$1.y).multiplyScalar(-distance / $9ddd7e9b53f7a2d4$var$_v3$1.z);
    }
    /**
	 * Computes the width and height of the camera's viewable rectangle at a given distance along the viewing direction.
	 *
	 * @param {number} distance - The viewing distance.
	 * @param {Vector2} target - The target vector that is used to store result where x is width and y is height.
	 * @returns {Vector2} The view size.
	 */ getViewSize(distance, target) {
        this.getViewBounds(distance, $9ddd7e9b53f7a2d4$var$_minTarget, $9ddd7e9b53f7a2d4$var$_maxTarget);
        return target.subVectors($9ddd7e9b53f7a2d4$var$_maxTarget, $9ddd7e9b53f7a2d4$var$_minTarget);
    }
    /**
	 * Sets an offset in a larger frustum. This is useful for multi-window or
	 * multi-monitor/multi-machine setups.
	 *
	 * For example, if you have 3x2 monitors and each monitor is 1920x1080 and
	 * the monitors are in grid like this
	 *```
	 *   +---+---+---+
	 *   | A | B | C |
	 *   +---+---+---+
	 *   | D | E | F |
	 *   +---+---+---+
	 *```
	 * then for each monitor you would call it like this:
	 *```js
	 * const w = 1920;
	 * const h = 1080;
	 * const fullWidth = w * 3;
	 * const fullHeight = h * 2;
	 *
	 * // --A--
	 * camera.setViewOffset( fullWidth, fullHeight, w * 0, h * 0, w, h );
	 * // --B--
	 * camera.setViewOffset( fullWidth, fullHeight, w * 1, h * 0, w, h );
	 * // --C--
	 * camera.setViewOffset( fullWidth, fullHeight, w * 2, h * 0, w, h );
	 * // --D--
	 * camera.setViewOffset( fullWidth, fullHeight, w * 0, h * 1, w, h );
	 * // --E--
	 * camera.setViewOffset( fullWidth, fullHeight, w * 1, h * 1, w, h );
	 * // --F--
	 * camera.setViewOffset( fullWidth, fullHeight, w * 2, h * 1, w, h );
	 * ```
	 *
	 * Note there is no reason monitors have to be the same size or in a grid.
	 *
	 * @param {number} fullWidth - The full width of multiview setup.
	 * @param {number} fullHeight - The full height of multiview setup.
	 * @param {number} x - The horizontal offset of the subcamera.
	 * @param {number} y - The vertical offset of the subcamera.
	 * @param {number} width - The width of subcamera.
	 * @param {number} height - The height of subcamera.
	 */ setViewOffset(fullWidth, fullHeight, x, y, width, height) {
        this.aspect = fullWidth / fullHeight;
        if (this.view === null) this.view = {
            enabled: true,
            fullWidth: 1,
            fullHeight: 1,
            offsetX: 0,
            offsetY: 0,
            width: 1,
            height: 1
        };
        this.view.enabled = true;
        this.view.fullWidth = fullWidth;
        this.view.fullHeight = fullHeight;
        this.view.offsetX = x;
        this.view.offsetY = y;
        this.view.width = width;
        this.view.height = height;
        this.updateProjectionMatrix();
    }
    /**
	 * Removes the view offset from the projection matrix.
	 */ clearViewOffset() {
        if (this.view !== null) this.view.enabled = false;
        this.updateProjectionMatrix();
    }
    /**
	 * Updates the camera's projection matrix. Must be called after any change of
	 * camera properties.
	 */ updateProjectionMatrix() {
        const near = this.near;
        let top = near * Math.tan($9ddd7e9b53f7a2d4$var$DEG2RAD * 0.5 * this.fov) / this.zoom;
        let height = 2 * top;
        let width = this.aspect * height;
        let left = -0.5 * width;
        const view = this.view;
        if (this.view !== null && this.view.enabled) {
            const fullWidth = view.fullWidth, fullHeight = view.fullHeight;
            left += view.offsetX * width / fullWidth;
            top -= view.offsetY * height / fullHeight;
            width *= view.width / fullWidth;
            height *= view.height / fullHeight;
        }
        const skew = this.filmOffset;
        if (skew !== 0) left += near * skew / this.getFilmWidth();
        this.projectionMatrix.makePerspective(left, left + width, top, top - height, near, this.far, this.coordinateSystem);
        this.projectionMatrixInverse.copy(this.projectionMatrix).invert();
    }
    toJSON(meta) {
        const data = super.toJSON(meta);
        data.object.fov = this.fov;
        data.object.zoom = this.zoom;
        data.object.near = this.near;
        data.object.far = this.far;
        data.object.focus = this.focus;
        data.object.aspect = this.aspect;
        if (this.view !== null) data.object.view = Object.assign({}, this.view);
        data.object.filmGauge = this.filmGauge;
        data.object.filmOffset = this.filmOffset;
        return data;
    }
}
const $9ddd7e9b53f7a2d4$var$fov = -90; // negative fov is not an error
const $9ddd7e9b53f7a2d4$var$aspect = 1;
/**
 * A special type of camera that is positioned in 3D space to render its surroundings into a
 * cube render target. The render target can then be used as an environment map for rendering
 * realtime reflections in your scene.
 *
 * ```js
 * // Create cube render target
 * const cubeRenderTarget = new THREE.WebGLCubeRenderTarget( 256, { generateMipmaps: true, minFilter: THREE.LinearMipmapLinearFilter } );
 *
 * // Create cube camera
 * const cubeCamera = new THREE.CubeCamera( 1, 100000, cubeRenderTarget );
 * scene.add( cubeCamera );
 *
 * // Create car
 * const chromeMaterial = new THREE.MeshLambertMaterial( { color: 0xffffff, envMap: cubeRenderTarget.texture } );
 * const car = new THREE.Mesh( carGeometry, chromeMaterial );
 * scene.add( car );
 *
 * // Update the render target cube
 * car.visible = false;
 * cubeCamera.position.copy( car.position );
 * cubeCamera.update( renderer, scene );
 *
 * // Render the scene
 * car.visible = true;
 * renderer.render( scene, camera );
 * ```
 *
 * @augments Object3D
 */ class $9ddd7e9b53f7a2d4$export$d0cdd0bd804995de extends $9ddd7e9b53f7a2d4$export$e4dd07dff30cc924 {
    /**
	 * Constructs a new cube camera.
	 *
	 * @param {number} near - The camera's near plane.
	 * @param {number} far - The camera's far plane.
	 * @param {WebGLCubeRenderTarget} renderTarget - The cube render target.
	 */ constructor(near, far, renderTarget){
        super();
        this.type = 'CubeCamera';
        /**
		 * A reference to the cube render target.
		 *
		 * @type {WebGLCubeRenderTarget}
		 */ this.renderTarget = renderTarget;
        /**
		 * The current active coordinate system.
		 *
		 * @type {?(WebGLCoordinateSystem|WebGPUCoordinateSystem)}
		 * @default null
		 */ this.coordinateSystem = null;
        /**
		 * The current active mipmap level
		 *
		 * @type {number}
		 * @default 0
		 */ this.activeMipmapLevel = 0;
        const cameraPX = new $9ddd7e9b53f7a2d4$export$74e4ae24825f68d7($9ddd7e9b53f7a2d4$var$fov, $9ddd7e9b53f7a2d4$var$aspect, near, far);
        cameraPX.layers = this.layers;
        this.add(cameraPX);
        const cameraNX = new $9ddd7e9b53f7a2d4$export$74e4ae24825f68d7($9ddd7e9b53f7a2d4$var$fov, $9ddd7e9b53f7a2d4$var$aspect, near, far);
        cameraNX.layers = this.layers;
        this.add(cameraNX);
        const cameraPY = new $9ddd7e9b53f7a2d4$export$74e4ae24825f68d7($9ddd7e9b53f7a2d4$var$fov, $9ddd7e9b53f7a2d4$var$aspect, near, far);
        cameraPY.layers = this.layers;
        this.add(cameraPY);
        const cameraNY = new $9ddd7e9b53f7a2d4$export$74e4ae24825f68d7($9ddd7e9b53f7a2d4$var$fov, $9ddd7e9b53f7a2d4$var$aspect, near, far);
        cameraNY.layers = this.layers;
        this.add(cameraNY);
        const cameraPZ = new $9ddd7e9b53f7a2d4$export$74e4ae24825f68d7($9ddd7e9b53f7a2d4$var$fov, $9ddd7e9b53f7a2d4$var$aspect, near, far);
        cameraPZ.layers = this.layers;
        this.add(cameraPZ);
        const cameraNZ = new $9ddd7e9b53f7a2d4$export$74e4ae24825f68d7($9ddd7e9b53f7a2d4$var$fov, $9ddd7e9b53f7a2d4$var$aspect, near, far);
        cameraNZ.layers = this.layers;
        this.add(cameraNZ);
    }
    /**
	 * Must be called when the coordinate system of the cube camera is changed.
	 */ updateCoordinateSystem() {
        const coordinateSystem = this.coordinateSystem;
        const cameras = this.children.concat();
        const [cameraPX, cameraNX, cameraPY, cameraNY, cameraPZ, cameraNZ] = cameras;
        for (const camera of cameras)this.remove(camera);
        if (coordinateSystem === $9ddd7e9b53f7a2d4$export$5a0e9190d10875d3) {
            cameraPX.up.set(0, 1, 0);
            cameraPX.lookAt(1, 0, 0);
            cameraNX.up.set(0, 1, 0);
            cameraNX.lookAt(-1, 0, 0);
            cameraPY.up.set(0, 0, -1);
            cameraPY.lookAt(0, 1, 0);
            cameraNY.up.set(0, 0, 1);
            cameraNY.lookAt(0, -1, 0);
            cameraPZ.up.set(0, 1, 0);
            cameraPZ.lookAt(0, 0, 1);
            cameraNZ.up.set(0, 1, 0);
            cameraNZ.lookAt(0, 0, -1);
        } else if (coordinateSystem === $9ddd7e9b53f7a2d4$export$cc83beedcb9be9ac) {
            cameraPX.up.set(0, -1, 0);
            cameraPX.lookAt(-1, 0, 0);
            cameraNX.up.set(0, -1, 0);
            cameraNX.lookAt(1, 0, 0);
            cameraPY.up.set(0, 0, 1);
            cameraPY.lookAt(0, 1, 0);
            cameraNY.up.set(0, 0, -1);
            cameraNY.lookAt(0, -1, 0);
            cameraPZ.up.set(0, -1, 0);
            cameraPZ.lookAt(0, 0, 1);
            cameraNZ.up.set(0, -1, 0);
            cameraNZ.lookAt(0, 0, -1);
        } else throw new Error('THREE.CubeCamera.updateCoordinateSystem(): Invalid coordinate system: ' + coordinateSystem);
        for (const camera of cameras){
            this.add(camera);
            camera.updateMatrixWorld();
        }
    }
    /**
	 * Calling this method will render the given scene with the given renderer
	 * into the cube render target of the camera.
	 *
	 * @param {(Renderer|WebGLRenderer)} renderer - The renderer.
	 * @param {Scene} scene - The scene to render.
	 */ update(renderer, scene) {
        if (this.parent === null) this.updateMatrixWorld();
        const { renderTarget: renderTarget, activeMipmapLevel: activeMipmapLevel } = this;
        if (this.coordinateSystem !== renderer.coordinateSystem) {
            this.coordinateSystem = renderer.coordinateSystem;
            this.updateCoordinateSystem();
        }
        const [cameraPX, cameraNX, cameraPY, cameraNY, cameraPZ, cameraNZ] = this.children;
        const currentRenderTarget = renderer.getRenderTarget();
        const currentActiveCubeFace = renderer.getActiveCubeFace();
        const currentActiveMipmapLevel = renderer.getActiveMipmapLevel();
        const currentXrEnabled = renderer.xr.enabled;
        renderer.xr.enabled = false;
        const generateMipmaps = renderTarget.texture.generateMipmaps;
        renderTarget.texture.generateMipmaps = false;
        renderer.setRenderTarget(renderTarget, 0, activeMipmapLevel);
        renderer.render(scene, cameraPX);
        renderer.setRenderTarget(renderTarget, 1, activeMipmapLevel);
        renderer.render(scene, cameraNX);
        renderer.setRenderTarget(renderTarget, 2, activeMipmapLevel);
        renderer.render(scene, cameraPY);
        renderer.setRenderTarget(renderTarget, 3, activeMipmapLevel);
        renderer.render(scene, cameraNY);
        renderer.setRenderTarget(renderTarget, 4, activeMipmapLevel);
        renderer.render(scene, cameraPZ);
        // mipmaps are generated during the last call of render()
        // at this point, all sides of the cube render target are defined
        renderTarget.texture.generateMipmaps = generateMipmaps;
        renderer.setRenderTarget(renderTarget, 5, activeMipmapLevel);
        renderer.render(scene, cameraNZ);
        renderer.setRenderTarget(currentRenderTarget, currentActiveCubeFace, currentActiveMipmapLevel);
        renderer.xr.enabled = currentXrEnabled;
        renderTarget.texture.needsPMREMUpdate = true;
    }
}
/**
 * Creates a cube texture made up of six images.
 *
 * ```js
 * const loader = new THREE.CubeTextureLoader();
 * loader.setPath( 'textures/cube/pisa/' );
 *
 * const textureCube = loader.load( [
 * 	'px.png', 'nx.png', 'py.png', 'ny.png', 'pz.png', 'nz.png'
 * ] );
 *
 * const material = new THREE.MeshBasicMaterial( { color: 0xffffff, envMap: textureCube } );
 * ```
 *
 * @augments Texture
 */ class $9ddd7e9b53f7a2d4$export$ee2e5a18258a4049 extends $9ddd7e9b53f7a2d4$export$5431306cf43de24a {
    /**
	 * Constructs a new cube texture.
	 *
	 * @param {Array<Image>} [images=[]] - An array holding a image for each side of a cube.
	 * @param {number} [mapping=CubeReflectionMapping] - The texture mapping.
	 * @param {number} [wrapS=ClampToEdgeWrapping] - The wrapS value.
	 * @param {number} [wrapT=ClampToEdgeWrapping] - The wrapT value.
	 * @param {number} [magFilter=LinearFilter] - The mag filter value.
	 * @param {number} [minFilter=LinearMipmapLinearFilter] - The min filter value.
	 * @param {number} [format=RGBAFormat] - The texture format.
	 * @param {number} [type=UnsignedByteType] - The texture type.
	 * @param {number} [anisotropy=Texture.DEFAULT_ANISOTROPY] - The anisotropy value.
	 * @param {string} [colorSpace=NoColorSpace] - The color space value.
	 */ constructor(images = [], mapping = $9ddd7e9b53f7a2d4$export$8759762a6477f2c4, wrapS, wrapT, magFilter, minFilter, format, type, anisotropy, colorSpace){
        super(images, mapping, wrapS, wrapT, magFilter, minFilter, format, type, anisotropy, colorSpace);
        /**
		 * This flag can be used for type testing.
		 *
		 * @type {boolean}
		 * @readonly
		 * @default true
		 */ this.isCubeTexture = true;
        /**
		 * If set to `true`, the texture is flipped along the vertical axis when
		 * uploaded to the GPU.
		 *
		 * Overwritten and set to `false` by default.
		 *
		 * @type {boolean}
		 * @default false
		 */ this.flipY = false;
    }
    /**
	 * Alias for {@link CubeTexture#image}.
	 *
	 * @type {Array<Image>}
	 */ get images() {
        return this.image;
    }
    set images(value) {
        this.image = value;
    }
}
/**
 * A cube render target used in context of {@link WebGLRenderer}.
 *
 * @augments WebGLRenderTarget
 */ class $9ddd7e9b53f7a2d4$export$ac386671d651941e extends $9ddd7e9b53f7a2d4$export$3c052beb2e51e23f {
    /**
	 * Constructs a new cube render target.
	 *
	 * @param {number} [size=1] - The size of the render target.
	 * @param {RenderTarget~Options} [options] - The configuration object.
	 */ constructor(size = 1, options = {}){
        super(size, size, options);
        /**
		 * This flag can be used for type testing.
		 *
		 * @type {boolean}
		 * @readonly
		 * @default true
		 */ this.isWebGLCubeRenderTarget = true;
        const image = {
            width: size,
            height: size,
            depth: 1
        };
        const images = [
            image,
            image,
            image,
            image,
            image,
            image
        ];
        /**
		 * Overwritten with a different texture type.
		 *
		 * @type {DataArrayTexture}
		 */ this.texture = new $9ddd7e9b53f7a2d4$export$ee2e5a18258a4049(images, options.mapping, options.wrapS, options.wrapT, options.magFilter, options.minFilter, options.format, options.type, options.anisotropy, options.colorSpace);
        // By convention -- likely based on the RenderMan spec from the 1990's -- cube maps are specified by WebGL (and three.js)
        // in a coordinate system in which positive-x is to the right when looking up the positive-z axis -- in other words,
        // in a left-handed coordinate system. By continuing this convention, preexisting cube maps continued to render correctly.
        // three.js uses a right-handed coordinate system. So environment maps used in three.js appear to have px and nx swapped
        // and the flag isRenderTargetTexture controls this conversion. The flip is not required when using WebGLCubeRenderTarget.texture
        // as a cube texture (this is detected when isRenderTargetTexture is set to true for cube textures).
        this.texture.isRenderTargetTexture = true;
        this.texture.generateMipmaps = options.generateMipmaps !== undefined ? options.generateMipmaps : false;
        this.texture.minFilter = options.minFilter !== undefined ? options.minFilter : $9ddd7e9b53f7a2d4$export$8a72f490b25c56c8;
    }
    /**
	 * Converts the given equirectangular texture to a cube map.
	 *
	 * @param {WebGLRenderer} renderer - The renderer.
	 * @param {Texture} texture - The equirectangular texture.
	 * @return {WebGLCubeRenderTarget} A reference to this cube render target.
	 */ fromEquirectangularTexture(renderer, texture) {
        this.texture.type = texture.type;
        this.texture.colorSpace = texture.colorSpace;
        this.texture.generateMipmaps = texture.generateMipmaps;
        this.texture.minFilter = texture.minFilter;
        this.texture.magFilter = texture.magFilter;
        const shader = {
            uniforms: {
                tEquirect: {
                    value: null
                }
            },
            vertexShader: /* glsl */ `

				varying vec3 vWorldDirection;

				vec3 transformDirection( in vec3 dir, in mat4 matrix ) {

					return normalize( ( matrix * vec4( dir, 0.0 ) ).xyz );

				}

				void main() {

					vWorldDirection = transformDirection( position, modelMatrix );

					#include <begin_vertex>
					#include <project_vertex>

				}
			`,
            fragmentShader: /* glsl */ `

				uniform sampler2D tEquirect;

				varying vec3 vWorldDirection;

				#include <common>

				void main() {

					vec3 direction = normalize( vWorldDirection );

					vec2 sampleUV = equirectUv( direction );

					gl_FragColor = texture2D( tEquirect, sampleUV );

				}
			`
        };
        const geometry = new $9ddd7e9b53f7a2d4$export$33e43285f7406bd5(5, 5, 5);
        const material = new $9ddd7e9b53f7a2d4$export$83c7d75d550a8b0d({
            name: 'CubemapFromEquirect',
            uniforms: $9ddd7e9b53f7a2d4$export$acda854380553452(shader.uniforms),
            vertexShader: shader.vertexShader,
            fragmentShader: shader.fragmentShader,
            side: $9ddd7e9b53f7a2d4$export$d9f0486e75b5ace,
            blending: $9ddd7e9b53f7a2d4$export$63b8d6b580fc65ba
        });
        material.uniforms.tEquirect.value = texture;
        const mesh = new $9ddd7e9b53f7a2d4$export$e176487c05830cc5(geometry, material);
        const currentMinFilter = texture.minFilter;
        // Avoid blurred poles
        if (texture.minFilter === $9ddd7e9b53f7a2d4$export$5d8599b6a933fb1b) texture.minFilter = $9ddd7e9b53f7a2d4$export$8a72f490b25c56c8;
        const camera = new $9ddd7e9b53f7a2d4$export$d0cdd0bd804995de(1, 10, this);
        camera.update(renderer, mesh);
        texture.minFilter = currentMinFilter;
        mesh.geometry.dispose();
        mesh.material.dispose();
        return this;
    }
    /**
	 * Clears this cube render target.
	 *
	 * @param {WebGLRenderer} renderer - The renderer.
	 * @param {boolean} [color=true] - Whether the color buffer should be cleared or not.
	 * @param {boolean} [depth=true] - Whether the depth buffer should be cleared or not.
	 * @param {boolean} [stencil=true] - Whether the stencil buffer should be cleared or not.
	 */ clear(renderer, color = true, depth = true, stencil = true) {
        const currentRenderTarget = renderer.getRenderTarget();
        for(let i = 0; i < 6; i++){
            renderer.setRenderTarget(this, i);
            renderer.clear(color, depth, stencil);
        }
        renderer.setRenderTarget(currentRenderTarget);
    }
}
/**
 * This is almost identical to an {@link Object3D}. Its purpose is to
 * make working with groups of objects syntactically clearer.
 *
 * ```js
 * // Create a group and add the two cubes.
 * // These cubes can now be rotated / scaled etc as a group.
 * const group = new THREE.Group();
 *
 * group.add( meshA );
 * group.add( meshB );
 *
 * scene.add( group );
 * ```
 *
 * @augments Object3D
 */ class $9ddd7e9b53f7a2d4$export$eb2fcfdbd7ba97d4 extends $9ddd7e9b53f7a2d4$export$e4dd07dff30cc924 {
    constructor(){
        super();
        /**
		 * This flag can be used for type testing.
		 *
		 * @type {boolean}
		 * @readonly
		 * @default true
		 */ this.isGroup = true;
        this.type = 'Group';
    }
}
const $9ddd7e9b53f7a2d4$var$_moveEvent = {
    type: 'move'
};
/**
 * Class for representing a XR controller with its
 * different coordinate systems.
 *
 * @private
 */ class $9ddd7e9b53f7a2d4$export$cb626c57dcc48b9f {
    /**
	 * Constructs a new XR controller.
	 */ constructor(){
        /**
		 * A group representing the target ray space
		 * of the XR controller.
		 *
		 * @private
		 * @type {?Group}
		 * @default null
		 */ this._targetRay = null;
        /**
		 * A group representing the grip space
		 * of the XR controller.
		 *
		 * @private
		 * @type {?Group}
		 * @default null
		 */ this._grip = null;
        /**
		 * A group representing the hand space
		 * of the XR controller.
		 *
		 * @private
		 * @type {?Group}
		 * @default null
		 */ this._hand = null;
    }
    /**
	 * Returns a group representing the hand space of the XR controller.
	 *
	 * @return {Group} A group representing the hand space of the XR controller.
	 */ getHandSpace() {
        if (this._hand === null) {
            this._hand = new $9ddd7e9b53f7a2d4$export$eb2fcfdbd7ba97d4();
            this._hand.matrixAutoUpdate = false;
            this._hand.visible = false;
            this._hand.joints = {};
            this._hand.inputState = {
                pinching: false
            };
        }
        return this._hand;
    }
    /**
	 * Returns a group representing the target ray space of the XR controller.
	 *
	 * @return {Group} A group representing the target ray space of the XR controller.
	 */ getTargetRaySpace() {
        if (this._targetRay === null) {
            this._targetRay = new $9ddd7e9b53f7a2d4$export$eb2fcfdbd7ba97d4();
            this._targetRay.matrixAutoUpdate = false;
            this._targetRay.visible = false;
            this._targetRay.hasLinearVelocity = false;
            this._targetRay.linearVelocity = new $9ddd7e9b53f7a2d4$export$64b5c384219d3699();
            this._targetRay.hasAngularVelocity = false;
            this._targetRay.angularVelocity = new $9ddd7e9b53f7a2d4$export$64b5c384219d3699();
        }
        return this._targetRay;
    }
    /**
	 * Returns a group representing the grip space of the XR controller.
	 *
	 * @return {Group} A group representing the grip space of the XR controller.
	 */ getGripSpace() {
        if (this._grip === null) {
            this._grip = new $9ddd7e9b53f7a2d4$export$eb2fcfdbd7ba97d4();
            this._grip.matrixAutoUpdate = false;
            this._grip.visible = false;
            this._grip.hasLinearVelocity = false;
            this._grip.linearVelocity = new $9ddd7e9b53f7a2d4$export$64b5c384219d3699();
            this._grip.hasAngularVelocity = false;
            this._grip.angularVelocity = new $9ddd7e9b53f7a2d4$export$64b5c384219d3699();
        }
        return this._grip;
    }
    /**
	 * Dispatches the given event to the groups representing
	 * the different coordinate spaces of the XR controller.
	 *
	 * @param {Object} event - The event to dispatch.
	 * @return {WebXRController} A reference to this instance.
	 */ dispatchEvent(event) {
        if (this._targetRay !== null) this._targetRay.dispatchEvent(event);
        if (this._grip !== null) this._grip.dispatchEvent(event);
        if (this._hand !== null) this._hand.dispatchEvent(event);
        return this;
    }
    /**
	 * Connects the controller with the given XR input source.
	 *
	 * @param {XRInputSource} inputSource - The input source.
	 * @return {WebXRController} A reference to this instance.
	 */ connect(inputSource) {
        if (inputSource && inputSource.hand) {
            const hand = this._hand;
            if (hand) for (const inputjoint of inputSource.hand.values())// Initialize hand with joints when connected
            this._getHandJoint(hand, inputjoint);
        }
        this.dispatchEvent({
            type: 'connected',
            data: inputSource
        });
        return this;
    }
    /**
	 * Disconnects the controller from the given XR input source.
	 *
	 * @param {XRInputSource} inputSource - The input source.
	 * @return {WebXRController} A reference to this instance.
	 */ disconnect(inputSource) {
        this.dispatchEvent({
            type: 'disconnected',
            data: inputSource
        });
        if (this._targetRay !== null) this._targetRay.visible = false;
        if (this._grip !== null) this._grip.visible = false;
        if (this._hand !== null) this._hand.visible = false;
        return this;
    }
    /**
	 * Updates the controller with the given input source, XR frame and reference space.
	 * This updates the transformations of the groups that represent the different
	 * coordinate systems of the controller.
	 *
	 * @param {XRInputSource} inputSource - The input source.
	 * @param {XRFrame} frame - The XR frame.
	 * @param {XRReferenceSpace} referenceSpace - The reference space.
	 * @return {WebXRController} A reference to this instance.
	 */ update(inputSource, frame, referenceSpace) {
        let inputPose = null;
        let gripPose = null;
        let handPose = null;
        const targetRay = this._targetRay;
        const grip = this._grip;
        const hand = this._hand;
        if (inputSource && frame.session.visibilityState !== 'visible-blurred') {
            if (hand && inputSource.hand) {
                handPose = true;
                for (const inputjoint of inputSource.hand.values()){
                    // Update the joints groups with the XRJoint poses
                    const jointPose = frame.getJointPose(inputjoint, referenceSpace);
                    // The transform of this joint will be updated with the joint pose on each frame
                    const joint = this._getHandJoint(hand, inputjoint);
                    if (jointPose !== null) {
                        joint.matrix.fromArray(jointPose.transform.matrix);
                        joint.matrix.decompose(joint.position, joint.rotation, joint.scale);
                        joint.matrixWorldNeedsUpdate = true;
                        joint.jointRadius = jointPose.radius;
                    }
                    joint.visible = jointPose !== null;
                }
                // Custom events
                // Check pinchz
                const indexTip = hand.joints['index-finger-tip'];
                const thumbTip = hand.joints['thumb-tip'];
                const distance = indexTip.position.distanceTo(thumbTip.position);
                const distanceToPinch = 0.02;
                const threshold = 0.005;
                if (hand.inputState.pinching && distance > distanceToPinch + threshold) {
                    hand.inputState.pinching = false;
                    this.dispatchEvent({
                        type: 'pinchend',
                        handedness: inputSource.handedness,
                        target: this
                    });
                } else if (!hand.inputState.pinching && distance <= distanceToPinch - threshold) {
                    hand.inputState.pinching = true;
                    this.dispatchEvent({
                        type: 'pinchstart',
                        handedness: inputSource.handedness,
                        target: this
                    });
                }
            } else if (grip !== null && inputSource.gripSpace) {
                gripPose = frame.getPose(inputSource.gripSpace, referenceSpace);
                if (gripPose !== null) {
                    grip.matrix.fromArray(gripPose.transform.matrix);
                    grip.matrix.decompose(grip.position, grip.rotation, grip.scale);
                    grip.matrixWorldNeedsUpdate = true;
                    if (gripPose.linearVelocity) {
                        grip.hasLinearVelocity = true;
                        grip.linearVelocity.copy(gripPose.linearVelocity);
                    } else grip.hasLinearVelocity = false;
                    if (gripPose.angularVelocity) {
                        grip.hasAngularVelocity = true;
                        grip.angularVelocity.copy(gripPose.angularVelocity);
                    } else grip.hasAngularVelocity = false;
                }
            }
            if (targetRay !== null) {
                inputPose = frame.getPose(inputSource.targetRaySpace, referenceSpace);
                // Some runtimes (namely Vive Cosmos with Vive OpenXR Runtime) have only grip space and ray space is equal to it
                if (inputPose === null && gripPose !== null) inputPose = gripPose;
                if (inputPose !== null) {
                    targetRay.matrix.fromArray(inputPose.transform.matrix);
                    targetRay.matrix.decompose(targetRay.position, targetRay.rotation, targetRay.scale);
                    targetRay.matrixWorldNeedsUpdate = true;
                    if (inputPose.linearVelocity) {
                        targetRay.hasLinearVelocity = true;
                        targetRay.linearVelocity.copy(inputPose.linearVelocity);
                    } else targetRay.hasLinearVelocity = false;
                    if (inputPose.angularVelocity) {
                        targetRay.hasAngularVelocity = true;
                        targetRay.angularVelocity.copy(inputPose.angularVelocity);
                    } else targetRay.hasAngularVelocity = false;
                    this.dispatchEvent($9ddd7e9b53f7a2d4$var$_moveEvent);
                }
            }
        }
        if (targetRay !== null) targetRay.visible = inputPose !== null;
        if (grip !== null) grip.visible = gripPose !== null;
        if (hand !== null) hand.visible = handPose !== null;
        return this;
    }
    /**
	 * Returns a group representing the hand joint for the given input joint.
	 *
	 * @private
	 * @param {Group} hand - The group representing the hand space.
	 * @param {XRHandJoint} inputjoint - The XR frame.
	 * @return {Group} A group representing the hand joint for the given input joint.
	 */ _getHandJoint(hand, inputjoint) {
        if (hand.joints[inputjoint.jointName] === undefined) {
            const joint = new $9ddd7e9b53f7a2d4$export$eb2fcfdbd7ba97d4();
            joint.matrixAutoUpdate = false;
            joint.visible = false;
            hand.joints[inputjoint.jointName] = joint;
            hand.add(joint);
        }
        return hand.joints[inputjoint.jointName];
    }
}
/**
 * This class can be used to define an exponential squared fog,
 * which gives a clear view near the camera and a faster than exponentially
 * densening fog farther from the camera.
 *
 * ```js
 * const scene = new THREE.Scene();
 * scene.fog = new THREE.FogExp2( 0xcccccc, 0.002 );
 * ```
 */ class $9ddd7e9b53f7a2d4$export$6f1519f023b8d0f6 {
    /**
	 * Constructs a new fog.
	 *
	 * @param {number|Color} color - The fog's color.
	 * @param {number} [density=0.00025] - Defines how fast the fog will grow dense.
	 */ constructor(color, density = 0.00025){
        /**
		 * This flag can be used for type testing.
		 *
		 * @type {boolean}
		 * @readonly
		 * @default true
		 */ this.isFogExp2 = true;
        /**
		 * The name of the fog.
		 *
		 * @type {string}
		 */ this.name = '';
        /**
		 * The fog's color.
		 *
		 * @type {Color}
		 */ this.color = new $9ddd7e9b53f7a2d4$export$892596cec99bc70e(color);
        /**
		 *  Defines how fast the fog will grow dense.
		 *
		 * @type {number}
		 * @default 0.00025
		 */ this.density = density;
    }
    /**
	 * Returns a new fog with copied values from this instance.
	 *
	 * @return {FogExp2} A clone of this instance.
	 */ clone() {
        return new $9ddd7e9b53f7a2d4$export$6f1519f023b8d0f6(this.color, this.density);
    }
    /**
	 * Serializes the fog into JSON.
	 *
	 * @param {?(Object|string)} meta - An optional value holding meta information about the serialization.
	 * @return {Object} A JSON object representing the serialized fog
	 */ toJSON() {
        return {
            type: 'FogExp2',
            name: this.name,
            color: this.color.getHex(),
            density: this.density
        };
    }
}
/**
 * This class can be used to define a linear fog that grows linearly denser
 * with the distance.
 *
 * ```js
 * const scene = new THREE.Scene();
 * scene.fog = new THREE.Fog( 0xcccccc, 10, 15 );
 * ```
 */ class $9ddd7e9b53f7a2d4$export$3c890837b09508d4 {
    /**
	 * Constructs a new fog.
	 *
	 * @param {number|Color} color - The fog's color.
	 * @param {number} [near=1] - The minimum distance to start applying fog.
	 * @param {number} [far=1000] - The maximum distance at which fog stops being calculated and applied.
	 */ constructor(color, near = 1, far = 1000){
        /**
		 * This flag can be used for type testing.
		 *
		 * @type {boolean}
		 * @readonly
		 * @default true
		 */ this.isFog = true;
        /**
		 * The name of the fog.
		 *
		 * @type {string}
		 */ this.name = '';
        /**
		 * The fog's color.
		 *
		 * @type {Color}
		 */ this.color = new $9ddd7e9b53f7a2d4$export$892596cec99bc70e(color);
        /**
		 * The minimum distance to start applying fog. Objects that are less than
		 * `near` units from the active camera won't be affected by fog.
		 *
		 * @type {number}
		 * @default 1
		 */ this.near = near;
        /**
		 * The maximum distance at which fog stops being calculated and applied.
		 * Objects that are more than `far` units away from the active camera won't
		 * be affected by fog.
		 *
		 * @type {number}
		 * @default 1000
		 */ this.far = far;
    }
    /**
	 * Returns a new fog with copied values from this instance.
	 *
	 * @return {Fog} A clone of this instance.
	 */ clone() {
        return new $9ddd7e9b53f7a2d4$export$3c890837b09508d4(this.color, this.near, this.far);
    }
    /**
	 * Serializes the fog into JSON.
	 *
	 * @param {?(Object|string)} meta - An optional value holding meta information about the serialization.
	 * @return {Object} A JSON object representing the serialized fog
	 */ toJSON() {
        return {
            type: 'Fog',
            name: this.name,
            color: this.color.getHex(),
            near: this.near,
            far: this.far
        };
    }
}
/**
 * Scenes allow you to set up what is to be rendered and where by three.js.
 * This is where you place 3D objects like meshes, lines or lights.
 *
 * @augments Object3D
 */ class $9ddd7e9b53f7a2d4$export$38af1803e3442a7f extends $9ddd7e9b53f7a2d4$export$e4dd07dff30cc924 {
    /**
	 * Constructs a new scene.
	 */ constructor(){
        super();
        /**
		 * This flag can be used for type testing.
		 *
		 * @type {boolean}
		 * @readonly
		 * @default true
		 */ this.isScene = true;
        this.type = 'Scene';
        /**
		 * Defines the background of the scene. Valid inputs are:
		 *
		 * - A color for defining a uniform colored background.
		 * - A texture for defining a (flat) textured background.
		 * - Cube textures or equirectangular textures for defining a skybox.
		 *
		 * @type {?(Color|Texture)}
		 * @default null
		 */ this.background = null;
        /**
		 * Sets the environment map for all physical materials in the scene. However,
		 * it's not possible to overwrite an existing texture assigned to the `envMap`
		 * material property.
		 *
		 * @type {?Texture}
		 * @default null
		 */ this.environment = null;
        /**
		 * A fog instance defining the type of fog that affects everything
		 * rendered in the scene.
		 *
		 * @type {?(Fog|FogExp2)}
		 * @default null
		 */ this.fog = null;
        /**
		 * Sets the blurriness of the background. Only influences environment maps
		 * assigned to {@link Scene#background}. Valid input is a float between `0`
		 * and `1`.
		 *
		 * @type {number}
		 * @default 0
		 */ this.backgroundBlurriness = 0;
        /**
		 * Attenuates the color of the background. Only applies to background textures.
		 *
		 * @type {number}
		 * @default 1
		 */ this.backgroundIntensity = 1;
        /**
		 * The rotation of the background in radians. Only influences environment maps
		 * assigned to {@link Scene#background}.
		 *
		 * @type {Euler}
		 * @default (0,0,0)
		 */ this.backgroundRotation = new $9ddd7e9b53f7a2d4$export$d93cc409a0768c5f();
        /**
		 * Attenuates the color of the environment. Only influences environment maps
		 * assigned to {@link Scene#environment}.
		 *
		 * @type {number}
		 * @default 1
		 */ this.environmentIntensity = 1;
        /**
		 * The rotation of the environment map in radians. Only influences physical materials
		 * in the scene when {@link Scene#environment} is used.
		 *
		 * @type {Euler}
		 * @default (0,0,0)
		 */ this.environmentRotation = new $9ddd7e9b53f7a2d4$export$d93cc409a0768c5f();
        /**
		 * Forces everything in the scene to be rendered with the defined material. It is possible
		 * to exclude materials from override by setting {@link Material#allowOverride} to `false`.
		 *
		 * @type {?Material}
		 * @default null
		 */ this.overrideMaterial = null;
        if (typeof __THREE_DEVTOOLS__ !== 'undefined') __THREE_DEVTOOLS__.dispatchEvent(new CustomEvent('observe', {
            detail: this
        }));
    }
    copy(source, recursive) {
        super.copy(source, recursive);
        if (source.background !== null) this.background = source.background.clone();
        if (source.environment !== null) this.environment = source.environment.clone();
        if (source.fog !== null) this.fog = source.fog.clone();
        this.backgroundBlurriness = source.backgroundBlurriness;
        this.backgroundIntensity = source.backgroundIntensity;
        this.backgroundRotation.copy(source.backgroundRotation);
        this.environmentIntensity = source.environmentIntensity;
        this.environmentRotation.copy(source.environmentRotation);
        if (source.overrideMaterial !== null) this.overrideMaterial = source.overrideMaterial.clone();
        this.matrixAutoUpdate = source.matrixAutoUpdate;
        return this;
    }
    toJSON(meta) {
        const data = super.toJSON(meta);
        if (this.fog !== null) data.object.fog = this.fog.toJSON();
        if (this.backgroundBlurriness > 0) data.object.backgroundBlurriness = this.backgroundBlurriness;
        if (this.backgroundIntensity !== 1) data.object.backgroundIntensity = this.backgroundIntensity;
        data.object.backgroundRotation = this.backgroundRotation.toArray();
        if (this.environmentIntensity !== 1) data.object.environmentIntensity = this.environmentIntensity;
        data.object.environmentRotation = this.environmentRotation.toArray();
        return data;
    }
}
/**
 * "Interleaved" means that multiple attributes, possibly of different types,
 * (e.g., position, normal, uv, color) are packed into a single array buffer.
 *
 * An introduction into interleaved arrays can be found here: [Interleaved array basics]{@link https://blog.tojicode.com/2011/05/interleaved-array-basics.html}
 */ class $9ddd7e9b53f7a2d4$export$3d5cd879f108f53f {
    /**
	 * Constructs a new interleaved buffer.
	 *
	 * @param {TypedArray} array - A typed array with a shared buffer storing attribute data.
	 * @param {number} stride - The number of typed-array elements per vertex.
	 */ constructor(array, stride){
        /**
		 * This flag can be used for type testing.
		 *
		 * @type {boolean}
		 * @readonly
		 * @default true
		 */ this.isInterleavedBuffer = true;
        /**
		 * A typed array with a shared buffer storing attribute data.
		 *
		 * @type {TypedArray}
		 */ this.array = array;
        /**
		 * The number of typed-array elements per vertex.
		 *
		 * @type {number}
		 */ this.stride = stride;
        /**
		 * The total number of elements in the array
		 *
		 * @type {number}
		 * @readonly
		 */ this.count = array !== undefined ? array.length / stride : 0;
        /**
		 * Defines the intended usage pattern of the data store for optimization purposes.
		 *
		 * Note: After the initial use of a buffer, its usage cannot be changed. Instead,
		 * instantiate a new one and set the desired usage before the next render.
		 *
		 * @type {(StaticDrawUsage|DynamicDrawUsage|StreamDrawUsage|StaticReadUsage|DynamicReadUsage|StreamReadUsage|StaticCopyUsage|DynamicCopyUsage|StreamCopyUsage)}
		 * @default StaticDrawUsage
		 */ this.usage = $9ddd7e9b53f7a2d4$export$763e8360f4d7f77d;
        /**
		 * This can be used to only update some components of stored vectors (for example, just the
		 * component related to color). Use the `addUpdateRange()` function to add ranges to this array.
		 *
		 * @type {Array<Object>}
		 */ this.updateRanges = [];
        /**
		 * A version number, incremented every time the `needsUpdate` is set to `true`.
		 *
		 * @type {number}
		 */ this.version = 0;
        /**
		 * The UUID of the interleaved buffer.
		 *
		 * @type {string}
		 * @readonly
		 */ this.uuid = $9ddd7e9b53f7a2d4$var$generateUUID();
    }
    /**
	 * A callback function that is executed after the renderer has transferred the attribute array
	 * data to the GPU.
	 */ onUploadCallback() {}
    /**
	 * Flag to indicate that this attribute has changed and should be re-sent to
	 * the GPU. Set this to `true` when you modify the value of the array.
	 *
	 * @type {number}
	 * @default false
	 * @param {boolean} value
	 */ set needsUpdate(value) {
        if (value === true) this.version++;
    }
    /**
	 * Sets the usage of this interleaved buffer.
	 *
	 * @param {(StaticDrawUsage|DynamicDrawUsage|StreamDrawUsage|StaticReadUsage|DynamicReadUsage|StreamReadUsage|StaticCopyUsage|DynamicCopyUsage|StreamCopyUsage)} value - The usage to set.
	 * @return {InterleavedBuffer} A reference to this interleaved buffer.
	 */ setUsage(value) {
        this.usage = value;
        return this;
    }
    /**
	 * Adds a range of data in the data array to be updated on the GPU.
	 *
	 * @param {number} start - Position at which to start update.
	 * @param {number} count - The number of components to update.
	 */ addUpdateRange(start, count) {
        this.updateRanges.push({
            start: start,
            count: count
        });
    }
    /**
	 * Clears the update ranges.
	 */ clearUpdateRanges() {
        this.updateRanges.length = 0;
    }
    /**
	 * Copies the values of the given interleaved buffer to this instance.
	 *
	 * @param {InterleavedBuffer} source - The interleaved buffer to copy.
	 * @return {InterleavedBuffer} A reference to this instance.
	 */ copy(source) {
        this.array = new source.array.constructor(source.array);
        this.count = source.count;
        this.stride = source.stride;
        this.usage = source.usage;
        return this;
    }
    /**
	 * Copies a vector from the given interleaved buffer to this one. The start
	 * and destination position in the attribute buffers are represented by the
	 * given indices.
	 *
	 * @param {number} index1 - The destination index into this interleaved buffer.
	 * @param {InterleavedBuffer} interleavedBuffer - The interleaved buffer to copy from.
	 * @param {number} index2 - The source index into the given interleaved buffer.
	 * @return {InterleavedBuffer} A reference to this instance.
	 */ copyAt(index1, interleavedBuffer, index2) {
        index1 *= this.stride;
        index2 *= interleavedBuffer.stride;
        for(let i = 0, l = this.stride; i < l; i++)this.array[index1 + i] = interleavedBuffer.array[index2 + i];
        return this;
    }
    /**
	 * Sets the given array data in the interleaved buffer.
	 *
	 * @param {(TypedArray|Array)} value - The array data to set.
	 * @param {number} [offset=0] - The offset in this interleaved buffer's array.
	 * @return {InterleavedBuffer} A reference to this instance.
	 */ set(value, offset = 0) {
        this.array.set(value, offset);
        return this;
    }
    /**
	 * Returns a new interleaved buffer with copied values from this instance.
	 *
	 * @param {Object} [data] - An object with shared array buffers that allows to retain shared structures.
	 * @return {InterleavedBuffer} A clone of this instance.
	 */ clone(data) {
        if (data.arrayBuffers === undefined) data.arrayBuffers = {};
        if (this.array.buffer._uuid === undefined) this.array.buffer._uuid = $9ddd7e9b53f7a2d4$var$generateUUID();
        if (data.arrayBuffers[this.array.buffer._uuid] === undefined) data.arrayBuffers[this.array.buffer._uuid] = this.array.slice(0).buffer;
        const array = new this.array.constructor(data.arrayBuffers[this.array.buffer._uuid]);
        const ib = new this.constructor(array, this.stride);
        ib.setUsage(this.usage);
        return ib;
    }
    /**
	 * Sets the given callback function that is executed after the Renderer has transferred
	 * the array data to the GPU. Can be used to perform clean-up operations after
	 * the upload when data are not needed anymore on the CPU side.
	 *
	 * @param {Function} callback - The `onUpload()` callback.
	 * @return {InterleavedBuffer} A reference to this instance.
	 */ onUpload(callback) {
        this.onUploadCallback = callback;
        return this;
    }
    /**
	 * Serializes the interleaved buffer into JSON.
	 *
	 * @param {Object} [data] - An optional value holding meta information about the serialization.
	 * @return {Object} A JSON object representing the serialized interleaved buffer.
	 */ toJSON(data) {
        if (data.arrayBuffers === undefined) data.arrayBuffers = {};
        // generate UUID for array buffer if necessary
        if (this.array.buffer._uuid === undefined) this.array.buffer._uuid = $9ddd7e9b53f7a2d4$var$generateUUID();
        if (data.arrayBuffers[this.array.buffer._uuid] === undefined) data.arrayBuffers[this.array.buffer._uuid] = Array.from(new Uint32Array(this.array.buffer));
        //
        return {
            uuid: this.uuid,
            buffer: this.array.buffer._uuid,
            type: this.array.constructor.name,
            stride: this.stride
        };
    }
}
const $9ddd7e9b53f7a2d4$var$_vector$7 = /*@__PURE__*/ new $9ddd7e9b53f7a2d4$export$64b5c384219d3699();
/**
 * An alternative version of a buffer attribute with interleaved data. Interleaved
 * attributes share a common interleaved data storage ({@link InterleavedBuffer}) and refer with
 * different offsets into the buffer.
 */ class $9ddd7e9b53f7a2d4$export$920b6d07334599c7 {
    /**
	 * Constructs a new interleaved buffer attribute.
	 *
	 * @param {InterleavedBuffer} interleavedBuffer - The buffer holding the interleaved data.
	 * @param {number} itemSize - The item size.
	 * @param {number} offset - The attribute offset into the buffer.
	 * @param {boolean} [normalized=false] - Whether the data are normalized or not.
	 */ constructor(interleavedBuffer, itemSize, offset, normalized = false){
        /**
		 * This flag can be used for type testing.
		 *
		 * @type {boolean}
		 * @readonly
		 * @default true
		 */ this.isInterleavedBufferAttribute = true;
        /**
		 * The name of the buffer attribute.
		 *
		 * @type {string}
		 */ this.name = '';
        /**
		 * The buffer holding the interleaved data.
		 *
		 * @type {InterleavedBuffer}
		 */ this.data = interleavedBuffer;
        /**
		 * The item size, see {@link BufferAttribute#itemSize}.
		 *
		 * @type {number}
		 */ this.itemSize = itemSize;
        /**
		 * The attribute offset into the buffer.
		 *
		 * @type {number}
		 */ this.offset = offset;
        /**
		 * Whether the data are normalized or not, see {@link BufferAttribute#normalized}
		 *
		 * @type {InterleavedBuffer}
		 */ this.normalized = normalized;
    }
    /**
	 * The item count of this buffer attribute.
	 *
	 * @type {number}
	 * @readonly
	 */ get count() {
        return this.data.count;
    }
    /**
	 * The array holding the interleaved buffer attribute data.
	 *
	 * @type {TypedArray}
	 */ get array() {
        return this.data.array;
    }
    /**
	 * Flag to indicate that this attribute has changed and should be re-sent to
	 * the GPU. Set this to `true` when you modify the value of the array.
	 *
	 * @type {number}
	 * @default false
	 * @param {boolean} value
	 */ set needsUpdate(value) {
        this.data.needsUpdate = value;
    }
    /**
	 * Applies the given 4x4 matrix to the given attribute. Only works with
	 * item size `3`.
	 *
	 * @param {Matrix4} m - The matrix to apply.
	 * @return {InterleavedBufferAttribute} A reference to this instance.
	 */ applyMatrix4(m) {
        for(let i = 0, l = this.data.count; i < l; i++){
            $9ddd7e9b53f7a2d4$var$_vector$7.fromBufferAttribute(this, i);
            $9ddd7e9b53f7a2d4$var$_vector$7.applyMatrix4(m);
            this.setXYZ(i, $9ddd7e9b53f7a2d4$var$_vector$7.x, $9ddd7e9b53f7a2d4$var$_vector$7.y, $9ddd7e9b53f7a2d4$var$_vector$7.z);
        }
        return this;
    }
    /**
	 * Applies the given 3x3 normal matrix to the given attribute. Only works with
	 * item size `3`.
	 *
	 * @param {Matrix3} m - The normal matrix to apply.
	 * @return {InterleavedBufferAttribute} A reference to this instance.
	 */ applyNormalMatrix(m) {
        for(let i = 0, l = this.count; i < l; i++){
            $9ddd7e9b53f7a2d4$var$_vector$7.fromBufferAttribute(this, i);
            $9ddd7e9b53f7a2d4$var$_vector$7.applyNormalMatrix(m);
            this.setXYZ(i, $9ddd7e9b53f7a2d4$var$_vector$7.x, $9ddd7e9b53f7a2d4$var$_vector$7.y, $9ddd7e9b53f7a2d4$var$_vector$7.z);
        }
        return this;
    }
    /**
	 * Applies the given 4x4 matrix to the given attribute. Only works with
	 * item size `3` and with direction vectors.
	 *
	 * @param {Matrix4} m - The matrix to apply.
	 * @return {InterleavedBufferAttribute} A reference to this instance.
	 */ transformDirection(m) {
        for(let i = 0, l = this.count; i < l; i++){
            $9ddd7e9b53f7a2d4$var$_vector$7.fromBufferAttribute(this, i);
            $9ddd7e9b53f7a2d4$var$_vector$7.transformDirection(m);
            this.setXYZ(i, $9ddd7e9b53f7a2d4$var$_vector$7.x, $9ddd7e9b53f7a2d4$var$_vector$7.y, $9ddd7e9b53f7a2d4$var$_vector$7.z);
        }
        return this;
    }
    /**
	 * Returns the given component of the vector at the given index.
	 *
	 * @param {number} index - The index into the buffer attribute.
	 * @param {number} component - The component index.
	 * @return {number} The returned value.
	 */ getComponent(index, component) {
        let value = this.array[index * this.data.stride + this.offset + component];
        if (this.normalized) value = $9ddd7e9b53f7a2d4$var$denormalize(value, this.array);
        return value;
    }
    /**
	 * Sets the given value to the given component of the vector at the given index.
	 *
	 * @param {number} index - The index into the buffer attribute.
	 * @param {number} component - The component index.
	 * @param {number} value - The value to set.
	 * @return {InterleavedBufferAttribute} A reference to this instance.
	 */ setComponent(index, component, value) {
        if (this.normalized) value = $9ddd7e9b53f7a2d4$var$normalize(value, this.array);
        this.data.array[index * this.data.stride + this.offset + component] = value;
        return this;
    }
    /**
	 * Sets the x component of the vector at the given index.
	 *
	 * @param {number} index - The index into the buffer attribute.
	 * @param {number} x - The value to set.
	 * @return {InterleavedBufferAttribute} A reference to this instance.
	 */ setX(index, x) {
        if (this.normalized) x = $9ddd7e9b53f7a2d4$var$normalize(x, this.array);
        this.data.array[index * this.data.stride + this.offset] = x;
        return this;
    }
    /**
	 * Sets the y component of the vector at the given index.
	 *
	 * @param {number} index - The index into the buffer attribute.
	 * @param {number} y - The value to set.
	 * @return {InterleavedBufferAttribute} A reference to this instance.
	 */ setY(index, y) {
        if (this.normalized) y = $9ddd7e9b53f7a2d4$var$normalize(y, this.array);
        this.data.array[index * this.data.stride + this.offset + 1] = y;
        return this;
    }
    /**
	 * Sets the z component of the vector at the given index.
	 *
	 * @param {number} index - The index into the buffer attribute.
	 * @param {number} z - The value to set.
	 * @return {InterleavedBufferAttribute} A reference to this instance.
	 */ setZ(index, z) {
        if (this.normalized) z = $9ddd7e9b53f7a2d4$var$normalize(z, this.array);
        this.data.array[index * this.data.stride + this.offset + 2] = z;
        return this;
    }
    /**
	 * Sets the w component of the vector at the given index.
	 *
	 * @param {number} index - The index into the buffer attribute.
	 * @param {number} w - The value to set.
	 * @return {InterleavedBufferAttribute} A reference to this instance.
	 */ setW(index, w) {
        if (this.normalized) w = $9ddd7e9b53f7a2d4$var$normalize(w, this.array);
        this.data.array[index * this.data.stride + this.offset + 3] = w;
        return this;
    }
    /**
	 * Returns the x component of the vector at the given index.
	 *
	 * @param {number} index - The index into the buffer attribute.
	 * @return {number} The x component.
	 */ getX(index) {
        let x = this.data.array[index * this.data.stride + this.offset];
        if (this.normalized) x = $9ddd7e9b53f7a2d4$var$denormalize(x, this.array);
        return x;
    }
    /**
	 * Returns the y component of the vector at the given index.
	 *
	 * @param {number} index - The index into the buffer attribute.
	 * @return {number} The y component.
	 */ getY(index) {
        let y = this.data.array[index * this.data.stride + this.offset + 1];
        if (this.normalized) y = $9ddd7e9b53f7a2d4$var$denormalize(y, this.array);
        return y;
    }
    /**
	 * Returns the z component of the vector at the given index.
	 *
	 * @param {number} index - The index into the buffer attribute.
	 * @return {number} The z component.
	 */ getZ(index) {
        let z = this.data.array[index * this.data.stride + this.offset + 2];
        if (this.normalized) z = $9ddd7e9b53f7a2d4$var$denormalize(z, this.array);
        return z;
    }
    /**
	 * Returns the w component of the vector at the given index.
	 *
	 * @param {number} index - The index into the buffer attribute.
	 * @return {number} The w component.
	 */ getW(index) {
        let w = this.data.array[index * this.data.stride + this.offset + 3];
        if (this.normalized) w = $9ddd7e9b53f7a2d4$var$denormalize(w, this.array);
        return w;
    }
    /**
	 * Sets the x and y component of the vector at the given index.
	 *
	 * @param {number} index - The index into the buffer attribute.
	 * @param {number} x - The value for the x component to set.
	 * @param {number} y - The value for the y component to set.
	 * @return {InterleavedBufferAttribute} A reference to this instance.
	 */ setXY(index, x, y) {
        index = index * this.data.stride + this.offset;
        if (this.normalized) {
            x = $9ddd7e9b53f7a2d4$var$normalize(x, this.array);
            y = $9ddd7e9b53f7a2d4$var$normalize(y, this.array);
        }
        this.data.array[index + 0] = x;
        this.data.array[index + 1] = y;
        return this;
    }
    /**
	 * Sets the x, y and z component of the vector at the given index.
	 *
	 * @param {number} index - The index into the buffer attribute.
	 * @param {number} x - The value for the x component to set.
	 * @param {number} y - The value for the y component to set.
	 * @param {number} z - The value for the z component to set.
	 * @return {InterleavedBufferAttribute} A reference to this instance.
	 */ setXYZ(index, x, y, z) {
        index = index * this.data.stride + this.offset;
        if (this.normalized) {
            x = $9ddd7e9b53f7a2d4$var$normalize(x, this.array);
            y = $9ddd7e9b53f7a2d4$var$normalize(y, this.array);
            z = $9ddd7e9b53f7a2d4$var$normalize(z, this.array);
        }
        this.data.array[index + 0] = x;
        this.data.array[index + 1] = y;
        this.data.array[index + 2] = z;
        return this;
    }
    /**
	 * Sets the x, y, z and w component of the vector at the given index.
	 *
	 * @param {number} index - The index into the buffer attribute.
	 * @param {number} x - The value for the x component to set.
	 * @param {number} y - The value for the y component to set.
	 * @param {number} z - The value for the z component to set.
	 * @param {number} w - The value for the w component to set.
	 * @return {InterleavedBufferAttribute} A reference to this instance.
	 */ setXYZW(index, x, y, z, w) {
        index = index * this.data.stride + this.offset;
        if (this.normalized) {
            x = $9ddd7e9b53f7a2d4$var$normalize(x, this.array);
            y = $9ddd7e9b53f7a2d4$var$normalize(y, this.array);
            z = $9ddd7e9b53f7a2d4$var$normalize(z, this.array);
            w = $9ddd7e9b53f7a2d4$var$normalize(w, this.array);
        }
        this.data.array[index + 0] = x;
        this.data.array[index + 1] = y;
        this.data.array[index + 2] = z;
        this.data.array[index + 3] = w;
        return this;
    }
    /**
	 * Returns a new buffer attribute with copied values from this instance.
	 *
	 * If no parameter is provided, cloning an interleaved buffer attribute will de-interleave buffer data.
	 *
	 * @param {Object} [data] - An object with interleaved buffers that allows to retain the interleaved property.
	 * @return {BufferAttribute|InterleavedBufferAttribute} A clone of this instance.
	 */ clone(data) {
        if (data === undefined) {
            console.log('THREE.InterleavedBufferAttribute.clone(): Cloning an interleaved buffer attribute will de-interleave buffer data.');
            const array = [];
            for(let i = 0; i < this.count; i++){
                const index = i * this.data.stride + this.offset;
                for(let j = 0; j < this.itemSize; j++)array.push(this.data.array[index + j]);
            }
            return new $9ddd7e9b53f7a2d4$export$8dea267bd6bde117(new this.array.constructor(array), this.itemSize, this.normalized);
        } else {
            if (data.interleavedBuffers === undefined) data.interleavedBuffers = {};
            if (data.interleavedBuffers[this.data.uuid] === undefined) data.interleavedBuffers[this.data.uuid] = this.data.clone(data);
            return new $9ddd7e9b53f7a2d4$export$920b6d07334599c7(data.interleavedBuffers[this.data.uuid], this.itemSize, this.offset, this.normalized);
        }
    }
    /**
	 * Serializes the buffer attribute into JSON.
	 *
	 * If no parameter is provided, cloning an interleaved buffer attribute will de-interleave buffer data.
	 *
	 * @param {Object} [data] - An optional value holding meta information about the serialization.
	 * @return {Object} A JSON object representing the serialized buffer attribute.
	 */ toJSON(data) {
        if (data === undefined) {
            console.log('THREE.InterleavedBufferAttribute.toJSON(): Serializing an interleaved buffer attribute will de-interleave buffer data.');
            const array = [];
            for(let i = 0; i < this.count; i++){
                const index = i * this.data.stride + this.offset;
                for(let j = 0; j < this.itemSize; j++)array.push(this.data.array[index + j]);
            }
            // de-interleave data and save it as an ordinary buffer attribute for now
            return {
                itemSize: this.itemSize,
                type: this.array.constructor.name,
                array: array,
                normalized: this.normalized
            };
        } else {
            // save as true interleaved attribute
            if (data.interleavedBuffers === undefined) data.interleavedBuffers = {};
            if (data.interleavedBuffers[this.data.uuid] === undefined) data.interleavedBuffers[this.data.uuid] = this.data.toJSON(data);
            return {
                isInterleavedBufferAttribute: true,
                itemSize: this.itemSize,
                data: this.data.uuid,
                offset: this.offset,
                normalized: this.normalized
            };
        }
    }
}
/**
 * A material for rendering instances of {@link Sprite}.
 *
 * ```js
 * const map = new THREE.TextureLoader().load( 'textures/sprite.png' );
 * const material = new THREE.SpriteMaterial( { map: map, color: 0xffffff } );
 *
 * const sprite = new THREE.Sprite( material );
 * sprite.scale.set(200, 200, 1)
 * scene.add( sprite );
 * ```
 *
 * @augments Material
 */ class $9ddd7e9b53f7a2d4$export$5ec7dd1c6994bf8e extends $9ddd7e9b53f7a2d4$export$a2d8b23205c25948 {
    /**
	 * Constructs a new sprite material.
	 *
	 * @param {Object} [parameters] - An object with one or more properties
	 * defining the material's appearance. Any property of the material
	 * (including any property from inherited materials) can be passed
	 * in here. Color values can be passed any type of value accepted
	 * by {@link Color#set}.
	 */ constructor(parameters){
        super();
        /**
		 * This flag can be used for type testing.
		 *
		 * @type {boolean}
		 * @readonly
		 * @default true
		 */ this.isSpriteMaterial = true;
        this.type = 'SpriteMaterial';
        /**
		 * Color of the material.
		 *
		 * @type {Color}
		 * @default (1,1,1)
		 */ this.color = new $9ddd7e9b53f7a2d4$export$892596cec99bc70e(0xffffff);
        /**
		 * The color map. May optionally include an alpha channel, typically combined
		 * with {@link Material#transparent} or {@link Material#alphaTest}. The texture map
		 * color is modulated by the diffuse `color`.
		 *
		 * @type {?Texture}
		 * @default null
		 */ this.map = null;
        /**
		 * The alpha map is a grayscale texture that controls the opacity across the
		 * surface (black: fully transparent; white: fully opaque).
		 *
		 * Only the color of the texture is used, ignoring the alpha channel if one
		 * exists. For RGB and RGBA textures, the renderer will use the green channel
		 * when sampling this texture due to the extra bit of precision provided for
		 * green in DXT-compressed and uncompressed RGB 565 formats. Luminance-only and
		 * luminance/alpha textures will also still work as expected.
		 *
		 * @type {?Texture}
		 * @default null
		 */ this.alphaMap = null;
        /**
		 * The rotation of the sprite in radians.
		 *
		 * @type {number}
		 * @default 0
		 */ this.rotation = 0;
        /**
		 * Specifies whether size of the sprite is attenuated by the camera depth (perspective camera only).
		 *
		 * @type {boolean}
		 * @default true
		 */ this.sizeAttenuation = true;
        /**
		 * Overwritten since sprite materials are transparent
		 * by default.
		 *
		 * @type {boolean}
		 * @default true
		 */ this.transparent = true;
        /**
		 * Whether the material is affected by fog or not.
		 *
		 * @type {boolean}
		 * @default true
		 */ this.fog = true;
        this.setValues(parameters);
    }
    copy(source) {
        super.copy(source);
        this.color.copy(source.color);
        this.map = source.map;
        this.alphaMap = source.alphaMap;
        this.rotation = source.rotation;
        this.sizeAttenuation = source.sizeAttenuation;
        this.fog = source.fog;
        return this;
    }
}
let $9ddd7e9b53f7a2d4$var$_geometry;
const $9ddd7e9b53f7a2d4$var$_intersectPoint = /*@__PURE__*/ new $9ddd7e9b53f7a2d4$export$64b5c384219d3699();
const $9ddd7e9b53f7a2d4$var$_worldScale = /*@__PURE__*/ new $9ddd7e9b53f7a2d4$export$64b5c384219d3699();
const $9ddd7e9b53f7a2d4$var$_mvPosition = /*@__PURE__*/ new $9ddd7e9b53f7a2d4$export$64b5c384219d3699();
const $9ddd7e9b53f7a2d4$var$_alignedPosition = /*@__PURE__*/ new $9ddd7e9b53f7a2d4$export$c977b3e384af9ae1();
const $9ddd7e9b53f7a2d4$var$_rotatedPosition = /*@__PURE__*/ new $9ddd7e9b53f7a2d4$export$c977b3e384af9ae1();
const $9ddd7e9b53f7a2d4$var$_viewWorldMatrix = /*@__PURE__*/ new $9ddd7e9b53f7a2d4$export$2ae72fc923e5eb5();
const $9ddd7e9b53f7a2d4$var$_vA = /*@__PURE__*/ new $9ddd7e9b53f7a2d4$export$64b5c384219d3699();
const $9ddd7e9b53f7a2d4$var$_vB = /*@__PURE__*/ new $9ddd7e9b53f7a2d4$export$64b5c384219d3699();
const $9ddd7e9b53f7a2d4$var$_vC = /*@__PURE__*/ new $9ddd7e9b53f7a2d4$export$64b5c384219d3699();
const $9ddd7e9b53f7a2d4$var$_uvA = /*@__PURE__*/ new $9ddd7e9b53f7a2d4$export$c977b3e384af9ae1();
const $9ddd7e9b53f7a2d4$var$_uvB = /*@__PURE__*/ new $9ddd7e9b53f7a2d4$export$c977b3e384af9ae1();
const $9ddd7e9b53f7a2d4$var$_uvC = /*@__PURE__*/ new $9ddd7e9b53f7a2d4$export$c977b3e384af9ae1();
/**
 * A sprite is a plane that always faces towards the camera, generally with a
 * partially transparent texture applied.
 *
 * Sprites do not cast shadows, setting {@link Object3D#castShadow} to `true` will
 * have no effect.
 *
 * ```js
 * const map = new THREE.TextureLoader().load( 'sprite.png' );
 * const material = new THREE.SpriteMaterial( { map: map } );
 *
 * const sprite = new THREE.Sprite( material );
 * scene.add( sprite );
 * ```
 *
 * @augments Object3D
 */ class $9ddd7e9b53f7a2d4$export$3075603db8e6204c extends $9ddd7e9b53f7a2d4$export$e4dd07dff30cc924 {
    /**
	 * Constructs a new sprite.
	 *
	 * @param {SpriteMaterial} [material] - The sprite material.
	 */ constructor(material = new $9ddd7e9b53f7a2d4$export$5ec7dd1c6994bf8e()){
        super();
        /**
		 * This flag can be used for type testing.
		 *
		 * @type {boolean}
		 * @readonly
		 * @default true
		 */ this.isSprite = true;
        this.type = 'Sprite';
        if ($9ddd7e9b53f7a2d4$var$_geometry === undefined) {
            $9ddd7e9b53f7a2d4$var$_geometry = new $9ddd7e9b53f7a2d4$export$b7be63a67df8959();
            const float32Array = new Float32Array([
                -0.5,
                -0.5,
                0,
                0,
                0,
                0.5,
                -0.5,
                0,
                1,
                0,
                0.5,
                0.5,
                0,
                1,
                1,
                -0.5,
                0.5,
                0,
                0,
                1
            ]);
            const interleavedBuffer = new $9ddd7e9b53f7a2d4$export$3d5cd879f108f53f(float32Array, 5);
            $9ddd7e9b53f7a2d4$var$_geometry.setIndex([
                0,
                1,
                2,
                0,
                2,
                3
            ]);
            $9ddd7e9b53f7a2d4$var$_geometry.setAttribute('position', new $9ddd7e9b53f7a2d4$export$920b6d07334599c7(interleavedBuffer, 3, 0, false));
            $9ddd7e9b53f7a2d4$var$_geometry.setAttribute('uv', new $9ddd7e9b53f7a2d4$export$920b6d07334599c7(interleavedBuffer, 2, 3, false));
        }
        /**
		 * The sprite geometry.
		 *
		 * @type {BufferGeometry}
		 */ this.geometry = $9ddd7e9b53f7a2d4$var$_geometry;
        /**
		 * The sprite material.
		 *
		 * @type {SpriteMaterial}
		 */ this.material = material;
        /**
		 * The sprite's anchor point, and the point around which the sprite rotates.
		 * A value of `(0.5, 0.5)` corresponds to the midpoint of the sprite. A value
		 * of `(0, 0)` corresponds to the lower left corner of the sprite.
		 *
		 * @type {Vector2}
		 * @default (0.5,0.5)
		 */ this.center = new $9ddd7e9b53f7a2d4$export$c977b3e384af9ae1(0.5, 0.5);
    }
    /**
	 * Computes intersection points between a casted ray and this sprite.
	 *
	 * @param {Raycaster} raycaster - The raycaster.
	 * @param {Array<Object>} intersects - The target array that holds the intersection points.
	 */ raycast(raycaster, intersects) {
        if (raycaster.camera === null) console.error('THREE.Sprite: "Raycaster.camera" needs to be set in order to raycast against sprites.');
        $9ddd7e9b53f7a2d4$var$_worldScale.setFromMatrixScale(this.matrixWorld);
        $9ddd7e9b53f7a2d4$var$_viewWorldMatrix.copy(raycaster.camera.matrixWorld);
        this.modelViewMatrix.multiplyMatrices(raycaster.camera.matrixWorldInverse, this.matrixWorld);
        $9ddd7e9b53f7a2d4$var$_mvPosition.setFromMatrixPosition(this.modelViewMatrix);
        if (raycaster.camera.isPerspectiveCamera && this.material.sizeAttenuation === false) $9ddd7e9b53f7a2d4$var$_worldScale.multiplyScalar(-$9ddd7e9b53f7a2d4$var$_mvPosition.z);
        const rotation = this.material.rotation;
        let sin, cos;
        if (rotation !== 0) {
            cos = Math.cos(rotation);
            sin = Math.sin(rotation);
        }
        const center = this.center;
        $9ddd7e9b53f7a2d4$var$transformVertex($9ddd7e9b53f7a2d4$var$_vA.set(-0.5, -0.5, 0), $9ddd7e9b53f7a2d4$var$_mvPosition, center, $9ddd7e9b53f7a2d4$var$_worldScale, sin, cos);
        $9ddd7e9b53f7a2d4$var$transformVertex($9ddd7e9b53f7a2d4$var$_vB.set(0.5, -0.5, 0), $9ddd7e9b53f7a2d4$var$_mvPosition, center, $9ddd7e9b53f7a2d4$var$_worldScale, sin, cos);
        $9ddd7e9b53f7a2d4$var$transformVertex($9ddd7e9b53f7a2d4$var$_vC.set(0.5, 0.5, 0), $9ddd7e9b53f7a2d4$var$_mvPosition, center, $9ddd7e9b53f7a2d4$var$_worldScale, sin, cos);
        $9ddd7e9b53f7a2d4$var$_uvA.set(0, 0);
        $9ddd7e9b53f7a2d4$var$_uvB.set(1, 0);
        $9ddd7e9b53f7a2d4$var$_uvC.set(1, 1);
        // check first triangle
        let intersect = raycaster.ray.intersectTriangle($9ddd7e9b53f7a2d4$var$_vA, $9ddd7e9b53f7a2d4$var$_vB, $9ddd7e9b53f7a2d4$var$_vC, false, $9ddd7e9b53f7a2d4$var$_intersectPoint);
        if (intersect === null) {
            // check second triangle
            $9ddd7e9b53f7a2d4$var$transformVertex($9ddd7e9b53f7a2d4$var$_vB.set(-0.5, 0.5, 0), $9ddd7e9b53f7a2d4$var$_mvPosition, center, $9ddd7e9b53f7a2d4$var$_worldScale, sin, cos);
            $9ddd7e9b53f7a2d4$var$_uvB.set(0, 1);
            intersect = raycaster.ray.intersectTriangle($9ddd7e9b53f7a2d4$var$_vA, $9ddd7e9b53f7a2d4$var$_vC, $9ddd7e9b53f7a2d4$var$_vB, false, $9ddd7e9b53f7a2d4$var$_intersectPoint);
            if (intersect === null) return;
        }
        const distance = raycaster.ray.origin.distanceTo($9ddd7e9b53f7a2d4$var$_intersectPoint);
        if (distance < raycaster.near || distance > raycaster.far) return;
        intersects.push({
            distance: distance,
            point: $9ddd7e9b53f7a2d4$var$_intersectPoint.clone(),
            uv: $9ddd7e9b53f7a2d4$export$5a465592bfe74b48.getInterpolation($9ddd7e9b53f7a2d4$var$_intersectPoint, $9ddd7e9b53f7a2d4$var$_vA, $9ddd7e9b53f7a2d4$var$_vB, $9ddd7e9b53f7a2d4$var$_vC, $9ddd7e9b53f7a2d4$var$_uvA, $9ddd7e9b53f7a2d4$var$_uvB, $9ddd7e9b53f7a2d4$var$_uvC, new $9ddd7e9b53f7a2d4$export$c977b3e384af9ae1()),
            face: null,
            object: this
        });
    }
    copy(source, recursive) {
        super.copy(source, recursive);
        if (source.center !== undefined) this.center.copy(source.center);
        this.material = source.material;
        return this;
    }
}
function $9ddd7e9b53f7a2d4$var$transformVertex(vertexPosition, mvPosition, center, scale, sin, cos) {
    // compute position in camera space
    $9ddd7e9b53f7a2d4$var$_alignedPosition.subVectors(vertexPosition, center).addScalar(0.5).multiply(scale);
    // to check if rotation is not zero
    if (sin !== undefined) {
        $9ddd7e9b53f7a2d4$var$_rotatedPosition.x = cos * $9ddd7e9b53f7a2d4$var$_alignedPosition.x - sin * $9ddd7e9b53f7a2d4$var$_alignedPosition.y;
        $9ddd7e9b53f7a2d4$var$_rotatedPosition.y = sin * $9ddd7e9b53f7a2d4$var$_alignedPosition.x + cos * $9ddd7e9b53f7a2d4$var$_alignedPosition.y;
    } else $9ddd7e9b53f7a2d4$var$_rotatedPosition.copy($9ddd7e9b53f7a2d4$var$_alignedPosition);
    vertexPosition.copy(mvPosition);
    vertexPosition.x += $9ddd7e9b53f7a2d4$var$_rotatedPosition.x;
    vertexPosition.y += $9ddd7e9b53f7a2d4$var$_rotatedPosition.y;
    // transform to world space
    vertexPosition.applyMatrix4($9ddd7e9b53f7a2d4$var$_viewWorldMatrix);
}
const $9ddd7e9b53f7a2d4$var$_v1$2 = /*@__PURE__*/ new $9ddd7e9b53f7a2d4$export$64b5c384219d3699();
const $9ddd7e9b53f7a2d4$var$_v2$1 = /*@__PURE__*/ new $9ddd7e9b53f7a2d4$export$64b5c384219d3699();
/**
 * A component for providing a basic Level of Detail (LOD) mechanism.
 *
 * Every LOD level is associated with an object, and rendering can be switched
 * between them at the distances specified. Typically you would create, say,
 * three meshes, one for far away (low detail), one for mid range (medium
 * detail) and one for close up (high detail).
 *
 * ```js
 * const lod = new THREE.LOD();
 * const material = new THREE.MeshBasicMaterial( { color: 0xffff00 } );
 *
 * //Create spheres with 3 levels of detail and create new LOD levels for them
 * for( let i = 0; i < 3; i++ ) {
 *
 * 	const geometry = new THREE.IcosahedronGeometry( 10, 3 - i );
 * 	const mesh = new THREE.Mesh( geometry, material );
 * 	lod.addLevel( mesh, i * 75 );
 *
 * }
 *
 * scene.add( lod );
 * ```
 *
 * @augments Object3D
 */ class $9ddd7e9b53f7a2d4$export$112e7237be0c5f30 extends $9ddd7e9b53f7a2d4$export$e4dd07dff30cc924 {
    /**
	 * Constructs a new LOD.
	 */ constructor(){
        super();
        /**
		 * This flag can be used for type testing.
		 *
		 * @type {boolean}
		 * @readonly
		 * @default true
		 */ this.isLOD = true;
        /**
		 * The current LOD index.
		 *
		 * @private
		 * @type {number}
		 * @default 0
		 */ this._currentLevel = 0;
        this.type = 'LOD';
        Object.defineProperties(this, {
            /**
			 * This array holds the LOD levels.
			 *
			 * @name LOD#levels
			 * @type {Array<{object:Object3D,distance:number,hysteresis:number}>}
			 */ levels: {
                enumerable: true,
                value: []
            }
        });
        /**
		 * Whether the LOD object is updated automatically by the renderer per frame
		 * or not. If set to `false`, you have to call {@link LOD#update} in the
		 * render loop by yourself.
		 *
		 * @type {boolean}
		 * @default true
		 */ this.autoUpdate = true;
    }
    copy(source) {
        super.copy(source, false);
        const levels = source.levels;
        for(let i = 0, l = levels.length; i < l; i++){
            const level = levels[i];
            this.addLevel(level.object.clone(), level.distance, level.hysteresis);
        }
        this.autoUpdate = source.autoUpdate;
        return this;
    }
    /**
	 * Adds a mesh that will display at a certain distance and greater. Typically
	 * the further away the distance, the lower the detail on the mesh.
	 *
	 * @param {Object3D} object - The 3D object to display at this level.
	 * @param {number} [distance=0] - The distance at which to display this level of detail.
	 * @param {number} [hysteresis=0] - Threshold used to avoid flickering at LOD boundaries, as a fraction of distance.
	 * @return {LOD} A reference to this instance.
	 */ addLevel(object, distance = 0, hysteresis = 0) {
        distance = Math.abs(distance);
        const levels = this.levels;
        let l;
        for(l = 0; l < levels.length; l++){
            if (distance < levels[l].distance) break;
        }
        levels.splice(l, 0, {
            distance: distance,
            hysteresis: hysteresis,
            object: object
        });
        this.add(object);
        return this;
    }
    /**
	 * Removes an existing level, based on the distance from the camera.
	 * Returns `true` when the level has been removed. Otherwise `false`.
	 *
	 * @param {number} distance - Distance of the level to remove.
	 * @return {boolean} Whether the level has been removed or not.
	 */ removeLevel(distance) {
        const levels = this.levels;
        for(let i = 0; i < levels.length; i++)if (levels[i].distance === distance) {
            const removedElements = levels.splice(i, 1);
            this.remove(removedElements[0].object);
            return true;
        }
        return false;
    }
    /**
	 * Returns the currently active LOD level index.
	 *
	 * @return {number} The current active LOD level index.
	 */ getCurrentLevel() {
        return this._currentLevel;
    }
    /**
	 * Returns a reference to the first 3D object that is greater than
	 * the given distance.
	 *
	 * @param {number} distance - The LOD distance.
	 * @return {Object3D|null} The found 3D object. `null` if no 3D object has been found.
	 */ getObjectForDistance(distance) {
        const levels = this.levels;
        if (levels.length > 0) {
            let i, l;
            for(i = 1, l = levels.length; i < l; i++){
                let levelDistance = levels[i].distance;
                if (levels[i].object.visible) levelDistance -= levelDistance * levels[i].hysteresis;
                if (distance < levelDistance) break;
            }
            return levels[i - 1].object;
        }
        return null;
    }
    /**
	 * Computes intersection points between a casted ray and this LOD.
	 *
	 * @param {Raycaster} raycaster - The raycaster.
	 * @param {Array<Object>} intersects - The target array that holds the intersection points.
	 */ raycast(raycaster, intersects) {
        const levels = this.levels;
        if (levels.length > 0) {
            $9ddd7e9b53f7a2d4$var$_v1$2.setFromMatrixPosition(this.matrixWorld);
            const distance = raycaster.ray.origin.distanceTo($9ddd7e9b53f7a2d4$var$_v1$2);
            this.getObjectForDistance(distance).raycast(raycaster, intersects);
        }
    }
    /**
	 * Updates the LOD by computing which LOD level should be visible according
	 * to the current distance of the given camera.
	 *
	 * @param {Camera} camera - The camera the scene is rendered with.
	 */ update(camera) {
        const levels = this.levels;
        if (levels.length > 1) {
            $9ddd7e9b53f7a2d4$var$_v1$2.setFromMatrixPosition(camera.matrixWorld);
            $9ddd7e9b53f7a2d4$var$_v2$1.setFromMatrixPosition(this.matrixWorld);
            const distance = $9ddd7e9b53f7a2d4$var$_v1$2.distanceTo($9ddd7e9b53f7a2d4$var$_v2$1) / camera.zoom;
            levels[0].object.visible = true;
            let i, l;
            for(i = 1, l = levels.length; i < l; i++){
                let levelDistance = levels[i].distance;
                if (levels[i].object.visible) levelDistance -= levelDistance * levels[i].hysteresis;
                if (distance >= levelDistance) {
                    levels[i - 1].object.visible = false;
                    levels[i].object.visible = true;
                } else break;
            }
            this._currentLevel = i - 1;
            for(; i < l; i++)levels[i].object.visible = false;
        }
    }
    toJSON(meta) {
        const data = super.toJSON(meta);
        if (this.autoUpdate === false) data.object.autoUpdate = false;
        data.object.levels = [];
        const levels = this.levels;
        for(let i = 0, l = levels.length; i < l; i++){
            const level = levels[i];
            data.object.levels.push({
                object: level.object.uuid,
                distance: level.distance,
                hysteresis: level.hysteresis
            });
        }
        return data;
    }
}
const $9ddd7e9b53f7a2d4$var$_basePosition = /*@__PURE__*/ new $9ddd7e9b53f7a2d4$export$64b5c384219d3699();
const $9ddd7e9b53f7a2d4$var$_skinIndex = /*@__PURE__*/ new $9ddd7e9b53f7a2d4$export$fa7daccca11cdbe3();
const $9ddd7e9b53f7a2d4$var$_skinWeight = /*@__PURE__*/ new $9ddd7e9b53f7a2d4$export$fa7daccca11cdbe3();
const $9ddd7e9b53f7a2d4$var$_vector3 = /*@__PURE__*/ new $9ddd7e9b53f7a2d4$export$64b5c384219d3699();
const $9ddd7e9b53f7a2d4$var$_matrix4 = /*@__PURE__*/ new $9ddd7e9b53f7a2d4$export$2ae72fc923e5eb5();
const $9ddd7e9b53f7a2d4$var$_vertex = /*@__PURE__*/ new $9ddd7e9b53f7a2d4$export$64b5c384219d3699();
const $9ddd7e9b53f7a2d4$var$_sphere$5 = /*@__PURE__*/ new $9ddd7e9b53f7a2d4$export$805e8b72413ccaba();
const $9ddd7e9b53f7a2d4$var$_inverseMatrix$2 = /*@__PURE__*/ new $9ddd7e9b53f7a2d4$export$2ae72fc923e5eb5();
const $9ddd7e9b53f7a2d4$var$_ray$2 = /*@__PURE__*/ new $9ddd7e9b53f7a2d4$export$a186db52eed6d40e();
/**
 * A mesh that has a {@link Skeleton} that can then be used to animate the
 * vertices of the geometry with skinning/skeleton animation.
 *
 * Next to a valid skeleton, the skinned mesh requires skin indices and weights
 * as buffer attributes in its geometry. These attribute define which bones affect a single
 * vertex to a certain extend.
 *
 * Typically skinned meshes are not created manually but loaders like {@link GLTFLoader}
 * or {@link FBXLoader } import respective models.
 *
 * @augments Mesh
 */ class $9ddd7e9b53f7a2d4$export$b303577035157ecf extends $9ddd7e9b53f7a2d4$export$e176487c05830cc5 {
    /**
	 * Constructs a new skinned mesh.
	 *
	 * @param {BufferGeometry} [geometry] - The mesh geometry.
	 * @param {Material|Array<Material>} [material] - The mesh material.
	 */ constructor(geometry, material){
        super(geometry, material);
        /**
		 * This flag can be used for type testing.
		 *
		 * @type {boolean}
		 * @readonly
		 * @default true
		 */ this.isSkinnedMesh = true;
        this.type = 'SkinnedMesh';
        /**
		 * `AttachedBindMode` means the skinned mesh shares the same world space as the skeleton.
		 * This is not true when using `DetachedBindMode` which is useful when sharing a skeleton
		 * across multiple skinned meshes.
		 *
		 * @type {(AttachedBindMode|DetachedBindMode)}
		 * @default AttachedBindMode
		 */ this.bindMode = $9ddd7e9b53f7a2d4$export$2595a3798997538;
        /**
		 * The base matrix that is used for the bound bone transforms.
		 *
		 * @type {Matrix4}
		 */ this.bindMatrix = new $9ddd7e9b53f7a2d4$export$2ae72fc923e5eb5();
        /**
		 * The base matrix that is used for resetting the bound bone transforms.
		 *
		 * @type {Matrix4}
		 */ this.bindMatrixInverse = new $9ddd7e9b53f7a2d4$export$2ae72fc923e5eb5();
        /**
		 * The bounding box of the skinned mesh. Can be computed via {@link SkinnedMesh#computeBoundingBox}.
		 *
		 * @type {?Box3}
		 * @default null
		 */ this.boundingBox = null;
        /**
		 * The bounding sphere of the skinned mesh. Can be computed via {@link SkinnedMesh#computeBoundingSphere}.
		 *
		 * @type {?Sphere}
		 * @default null
		 */ this.boundingSphere = null;
    }
    /**
	 * Computes the bounding box of the skinned mesh, and updates {@link SkinnedMesh#boundingBox}.
	 * The bounding box is not automatically computed by the engine; this method must be called by your app.
	 * If the skinned mesh is animated, the bounding box should be recomputed per frame in order to reflect
	 * the current animation state.
	 */ computeBoundingBox() {
        const geometry = this.geometry;
        if (this.boundingBox === null) this.boundingBox = new $9ddd7e9b53f7a2d4$export$6f7d5a9418ab2aa3();
        this.boundingBox.makeEmpty();
        const positionAttribute = geometry.getAttribute('position');
        for(let i = 0; i < positionAttribute.count; i++){
            this.getVertexPosition(i, $9ddd7e9b53f7a2d4$var$_vertex);
            this.boundingBox.expandByPoint($9ddd7e9b53f7a2d4$var$_vertex);
        }
    }
    /**
	 * Computes the bounding sphere of the skinned mesh, and updates {@link SkinnedMesh#boundingSphere}.
	 * The bounding sphere is automatically computed by the engine once when it is needed, e.g., for ray casting
	 * and view frustum culling. If the skinned mesh is animated, the bounding sphere should be recomputed
	 * per frame in order to reflect the current animation state.
	 */ computeBoundingSphere() {
        const geometry = this.geometry;
        if (this.boundingSphere === null) this.boundingSphere = new $9ddd7e9b53f7a2d4$export$805e8b72413ccaba();
        this.boundingSphere.makeEmpty();
        const positionAttribute = geometry.getAttribute('position');
        for(let i = 0; i < positionAttribute.count; i++){
            this.getVertexPosition(i, $9ddd7e9b53f7a2d4$var$_vertex);
            this.boundingSphere.expandByPoint($9ddd7e9b53f7a2d4$var$_vertex);
        }
    }
    copy(source, recursive) {
        super.copy(source, recursive);
        this.bindMode = source.bindMode;
        this.bindMatrix.copy(source.bindMatrix);
        this.bindMatrixInverse.copy(source.bindMatrixInverse);
        this.skeleton = source.skeleton;
        if (source.boundingBox !== null) this.boundingBox = source.boundingBox.clone();
        if (source.boundingSphere !== null) this.boundingSphere = source.boundingSphere.clone();
        return this;
    }
    raycast(raycaster, intersects) {
        const material = this.material;
        const matrixWorld = this.matrixWorld;
        if (material === undefined) return;
        // test with bounding sphere in world space
        if (this.boundingSphere === null) this.computeBoundingSphere();
        $9ddd7e9b53f7a2d4$var$_sphere$5.copy(this.boundingSphere);
        $9ddd7e9b53f7a2d4$var$_sphere$5.applyMatrix4(matrixWorld);
        if (raycaster.ray.intersectsSphere($9ddd7e9b53f7a2d4$var$_sphere$5) === false) return;
        // convert ray to local space of skinned mesh
        $9ddd7e9b53f7a2d4$var$_inverseMatrix$2.copy(matrixWorld).invert();
        $9ddd7e9b53f7a2d4$var$_ray$2.copy(raycaster.ray).applyMatrix4($9ddd7e9b53f7a2d4$var$_inverseMatrix$2);
        // test with bounding box in local space
        if (this.boundingBox !== null) {
            if ($9ddd7e9b53f7a2d4$var$_ray$2.intersectsBox(this.boundingBox) === false) return;
        }
        // test for intersections with geometry
        this._computeIntersections(raycaster, intersects, $9ddd7e9b53f7a2d4$var$_ray$2);
    }
    getVertexPosition(index, target) {
        super.getVertexPosition(index, target);
        this.applyBoneTransform(index, target);
        return target;
    }
    /**
	 * Binds the given skeleton to the skinned mesh.
	 *
	 * @param {Skeleton} skeleton - The skeleton to bind.
	 * @param {Matrix4} [bindMatrix] - The bind matrix. If no bind matrix is provided,
	 * the skinned mesh's world matrix will be used instead.
	 */ bind(skeleton, bindMatrix) {
        this.skeleton = skeleton;
        if (bindMatrix === undefined) {
            this.updateMatrixWorld(true);
            this.skeleton.calculateInverses();
            bindMatrix = this.matrixWorld;
        }
        this.bindMatrix.copy(bindMatrix);
        this.bindMatrixInverse.copy(bindMatrix).invert();
    }
    /**
	 * This method sets the skinned mesh in the rest pose).
	 */ pose() {
        this.skeleton.pose();
    }
    /**
	 * Normalizes the skin weights which are defined as a buffer attribute
	 * in the skinned mesh's geometry.
	 */ normalizeSkinWeights() {
        const vector = new $9ddd7e9b53f7a2d4$export$fa7daccca11cdbe3();
        const skinWeight = this.geometry.attributes.skinWeight;
        for(let i = 0, l = skinWeight.count; i < l; i++){
            vector.fromBufferAttribute(skinWeight, i);
            const scale = 1.0 / vector.manhattanLength();
            if (scale !== Infinity) vector.multiplyScalar(scale);
            else vector.set(1, 0, 0, 0); // do something reasonable
            skinWeight.setXYZW(i, vector.x, vector.y, vector.z, vector.w);
        }
    }
    updateMatrixWorld(force) {
        super.updateMatrixWorld(force);
        if (this.bindMode === $9ddd7e9b53f7a2d4$export$2595a3798997538) this.bindMatrixInverse.copy(this.matrixWorld).invert();
        else if (this.bindMode === $9ddd7e9b53f7a2d4$export$d7e7dc2e114517a0) this.bindMatrixInverse.copy(this.bindMatrix).invert();
        else console.warn('THREE.SkinnedMesh: Unrecognized bindMode: ' + this.bindMode);
    }
    /**
	 * Applies the bone transform associated with the given index to the given
	 * vertex position. Returns the updated vector.
	 *
	 * @param {number} index - The vertex index.
	 * @param {Vector3} target - The target object that is used to store the method's result.
	 * the skinned mesh's world matrix will be used instead.
	 * @return {Vector3} The updated vertex position.
	 */ applyBoneTransform(index, target) {
        const skeleton = this.skeleton;
        const geometry = this.geometry;
        $9ddd7e9b53f7a2d4$var$_skinIndex.fromBufferAttribute(geometry.attributes.skinIndex, index);
        $9ddd7e9b53f7a2d4$var$_skinWeight.fromBufferAttribute(geometry.attributes.skinWeight, index);
        $9ddd7e9b53f7a2d4$var$_basePosition.copy(target).applyMatrix4(this.bindMatrix);
        target.set(0, 0, 0);
        for(let i = 0; i < 4; i++){
            const weight = $9ddd7e9b53f7a2d4$var$_skinWeight.getComponent(i);
            if (weight !== 0) {
                const boneIndex = $9ddd7e9b53f7a2d4$var$_skinIndex.getComponent(i);
                $9ddd7e9b53f7a2d4$var$_matrix4.multiplyMatrices(skeleton.bones[boneIndex].matrixWorld, skeleton.boneInverses[boneIndex]);
                target.addScaledVector($9ddd7e9b53f7a2d4$var$_vector3.copy($9ddd7e9b53f7a2d4$var$_basePosition).applyMatrix4($9ddd7e9b53f7a2d4$var$_matrix4), weight);
            }
        }
        return target.applyMatrix4(this.bindMatrixInverse);
    }
}
/**
 * A bone which is part of a {@link Skeleton}. The skeleton in turn is used by
 * the {@link SkinnedMesh}.
 *
 * ```js
 * const root = new THREE.Bone();
 * const child = new THREE.Bone();
 *
 * root.add( child );
 * child.position.y = 5;
 * ```
 *
 * @augments Object3D
 */ class $9ddd7e9b53f7a2d4$export$b127726e56765aa4 extends $9ddd7e9b53f7a2d4$export$e4dd07dff30cc924 {
    /**
	 * Constructs a new bone.
	 */ constructor(){
        super();
        /**
		 * This flag can be used for type testing.
		 *
		 * @type {boolean}
		 * @readonly
		 * @default true
		 */ this.isBone = true;
        this.type = 'Bone';
    }
}
/**
 * Creates a texture directly from raw buffer data.
 *
 * The interpretation of the data depends on type and format: If the type is
 * `UnsignedByteType`, a `Uint8Array` will be useful for addressing the
 * texel data. If the format is `RGBAFormat`, data needs four values for
 * one texel; Red, Green, Blue and Alpha (typically the opacity).
 *
 * @augments Texture
 */ class $9ddd7e9b53f7a2d4$export$b691f601014eabe1 extends $9ddd7e9b53f7a2d4$export$5431306cf43de24a {
    /**
	 * Constructs a new data texture.
	 *
	 * @param {?TypedArray} [data=null] - The buffer data.
	 * @param {number} [width=1] - The width of the texture.
	 * @param {number} [height=1] - The height of the texture.
	 * @param {number} [format=RGBAFormat] - The texture format.
	 * @param {number} [type=UnsignedByteType] - The texture type.
	 * @param {number} [mapping=Texture.DEFAULT_MAPPING] - The texture mapping.
	 * @param {number} [wrapS=ClampToEdgeWrapping] - The wrapS value.
	 * @param {number} [wrapT=ClampToEdgeWrapping] - The wrapT value.
	 * @param {number} [magFilter=NearestFilter] - The mag filter value.
	 * @param {number} [minFilter=NearestFilter] - The min filter value.
	 * @param {number} [anisotropy=Texture.DEFAULT_ANISOTROPY] - The anisotropy value.
	 * @param {string} [colorSpace=NoColorSpace] - The color space.
	 */ constructor(data = null, width = 1, height = 1, format, type, mapping, wrapS, wrapT, magFilter = $9ddd7e9b53f7a2d4$export$727aa5ec3fe39bf0, minFilter = $9ddd7e9b53f7a2d4$export$727aa5ec3fe39bf0, anisotropy, colorSpace){
        super(null, mapping, wrapS, wrapT, magFilter, minFilter, format, type, anisotropy, colorSpace);
        /**
		 * This flag can be used for type testing.
		 *
		 * @type {boolean}
		 * @readonly
		 * @default true
		 */ this.isDataTexture = true;
        /**
		 * The image definition of a data texture.
		 *
		 * @type {{data:TypedArray,width:number,height:number}}
		 */ this.image = {
            data: data,
            width: width,
            height: height
        };
        /**
		 * Whether to generate mipmaps (if possible) for a texture.
		 *
		 * Overwritten and set to `false` by default.
		 *
		 * @type {boolean}
		 * @default false
		 */ this.generateMipmaps = false;
        /**
		 * If set to `true`, the texture is flipped along the vertical axis when
		 * uploaded to the GPU.
		 *
		 * Overwritten and set to `false` by default.
		 *
		 * @type {boolean}
		 * @default false
		 */ this.flipY = false;
        /**
		 * Specifies the alignment requirements for the start of each pixel row in memory.
		 *
		 * Overwritten and set to `1` by default.
		 *
		 * @type {boolean}
		 * @default 1
		 */ this.unpackAlignment = 1;
    }
}
const $9ddd7e9b53f7a2d4$var$_offsetMatrix = /*@__PURE__*/ new $9ddd7e9b53f7a2d4$export$2ae72fc923e5eb5();
const $9ddd7e9b53f7a2d4$var$_identityMatrix = /*@__PURE__*/ new $9ddd7e9b53f7a2d4$export$2ae72fc923e5eb5();
/**
 * Class for representing the armatures in `three.js`. The skeleton
 * is defined by a hierarchy of bones.
 *
 * ```js
 * const bones = [];
 *
 * const shoulder = new THREE.Bone();
 * const elbow = new THREE.Bone();
 * const hand = new THREE.Bone();
 *
 * shoulder.add( elbow );
 * elbow.add( hand );
 *
 * bones.push( shoulder , elbow, hand);
 *
 * shoulder.position.y = -5;
 * elbow.position.y = 0;
 * hand.position.y = 5;
 *
 * const armSkeleton = new THREE.Skeleton( bones );
 * ```
 */ class $9ddd7e9b53f7a2d4$export$8f31e4c4a37b8e9c {
    /**
	 * Constructs a new skeleton.
	 *
	 * @param {Array<Bone>} [bones] - An array of bones.
	 * @param {Array<Matrix4>} [boneInverses] - An array of bone inverse matrices.
	 * If not provided, these matrices will be computed automatically via {@link Skeleton#calculateInverses}.
	 */ constructor(bones = [], boneInverses = []){
        this.uuid = $9ddd7e9b53f7a2d4$var$generateUUID();
        /**
		 * An array of bones defining the skeleton.
		 *
		 * @type {Array<Bone>}
		 */ this.bones = bones.slice(0);
        /**
		 * An array of bone inverse matrices.
		 *
		 * @type {Array<Matrix4>}
		 */ this.boneInverses = boneInverses;
        /**
		 * An array buffer holding the bone data.
		 * Input data for {@link Skeleton#boneTexture}.
		 *
		 * @type {?Float32Array}
		 * @default null
		 */ this.boneMatrices = null;
        /**
		 * A texture holding the bone data for use
		 * in the vertex shader.
		 *
		 * @type {?DataTexture}
		 * @default null
		 */ this.boneTexture = null;
        this.init();
    }
    /**
	 * Initializes the skeleton. This method gets automatically called by the constructor
	 * but depending on how the skeleton is created it might be necessary to call this method
	 * manually.
	 */ init() {
        const bones = this.bones;
        const boneInverses = this.boneInverses;
        this.boneMatrices = new Float32Array(bones.length * 16);
        // calculate inverse bone matrices if necessary
        if (boneInverses.length === 0) this.calculateInverses();
        else // handle special case
        if (bones.length !== boneInverses.length) {
            console.warn('THREE.Skeleton: Number of inverse bone matrices does not match amount of bones.');
            this.boneInverses = [];
            for(let i = 0, il = this.bones.length; i < il; i++)this.boneInverses.push(new $9ddd7e9b53f7a2d4$export$2ae72fc923e5eb5());
        }
    }
    /**
	 * Computes the bone inverse matrices. This method resets {@link Skeleton#boneInverses}
	 * and fills it with new matrices.
	 */ calculateInverses() {
        this.boneInverses.length = 0;
        for(let i = 0, il = this.bones.length; i < il; i++){
            const inverse = new $9ddd7e9b53f7a2d4$export$2ae72fc923e5eb5();
            if (this.bones[i]) inverse.copy(this.bones[i].matrixWorld).invert();
            this.boneInverses.push(inverse);
        }
    }
    /**
	 * Resets the skeleton to the base pose.
	 */ pose() {
        // recover the bind-time world matrices
        for(let i = 0, il = this.bones.length; i < il; i++){
            const bone = this.bones[i];
            if (bone) bone.matrixWorld.copy(this.boneInverses[i]).invert();
        }
        // compute the local matrices, positions, rotations and scales
        for(let i = 0, il = this.bones.length; i < il; i++){
            const bone = this.bones[i];
            if (bone) {
                if (bone.parent && bone.parent.isBone) {
                    bone.matrix.copy(bone.parent.matrixWorld).invert();
                    bone.matrix.multiply(bone.matrixWorld);
                } else bone.matrix.copy(bone.matrixWorld);
                bone.matrix.decompose(bone.position, bone.quaternion, bone.scale);
            }
        }
    }
    /**
	 * Resets the skeleton to the base pose.
	 */ update() {
        const bones = this.bones;
        const boneInverses = this.boneInverses;
        const boneMatrices = this.boneMatrices;
        const boneTexture = this.boneTexture;
        // flatten bone matrices to array
        for(let i = 0, il = bones.length; i < il; i++){
            // compute the offset between the current and the original transform
            const matrix = bones[i] ? bones[i].matrixWorld : $9ddd7e9b53f7a2d4$var$_identityMatrix;
            $9ddd7e9b53f7a2d4$var$_offsetMatrix.multiplyMatrices(matrix, boneInverses[i]);
            $9ddd7e9b53f7a2d4$var$_offsetMatrix.toArray(boneMatrices, i * 16);
        }
        if (boneTexture !== null) boneTexture.needsUpdate = true;
    }
    /**
	 * Returns a new skeleton with copied values from this instance.
	 *
	 * @return {Skeleton} A clone of this instance.
	 */ clone() {
        return new $9ddd7e9b53f7a2d4$export$8f31e4c4a37b8e9c(this.bones, this.boneInverses);
    }
    /**
	 * Computes a data texture for passing bone data to the vertex shader.
	 *
	 * @return {Skeleton} A reference of this instance.
	 */ computeBoneTexture() {
        // layout (1 matrix = 4 pixels)
        //      RGBA RGBA RGBA RGBA (=> column1, column2, column3, column4)
        //  with  8x8  pixel texture max   16 bones * 4 pixels =  (8 * 8)
        //       16x16 pixel texture max   64 bones * 4 pixels = (16 * 16)
        //       32x32 pixel texture max  256 bones * 4 pixels = (32 * 32)
        //       64x64 pixel texture max 1024 bones * 4 pixels = (64 * 64)
        let size = Math.sqrt(this.bones.length * 4); // 4 pixels needed for 1 matrix
        size = Math.ceil(size / 4) * 4;
        size = Math.max(size, 4);
        const boneMatrices = new Float32Array(size * size * 4); // 4 floats per RGBA pixel
        boneMatrices.set(this.boneMatrices); // copy current values
        const boneTexture = new $9ddd7e9b53f7a2d4$export$b691f601014eabe1(boneMatrices, size, size, $9ddd7e9b53f7a2d4$export$3f8bb04b555a363c, $9ddd7e9b53f7a2d4$export$f6d331659b644596);
        boneTexture.needsUpdate = true;
        this.boneMatrices = boneMatrices;
        this.boneTexture = boneTexture;
        return this;
    }
    /**
	 * Searches through the skeleton's bone array and returns the first with a
	 * matching name.
	 *
	 * @param {string} name - The name of the bone.
	 * @return {Bone|undefined} The found bone. `undefined` if no bone has been found.
	 */ getBoneByName(name) {
        for(let i = 0, il = this.bones.length; i < il; i++){
            const bone = this.bones[i];
            if (bone.name === name) return bone;
        }
        return undefined;
    }
    /**
	 * Frees the GPU-related resources allocated by this instance. Call this
	 * method whenever this instance is no longer used in your app.
	 */ dispose() {
        if (this.boneTexture !== null) {
            this.boneTexture.dispose();
            this.boneTexture = null;
        }
    }
    /**
	 * Setups the skeleton by the given JSON and bones.
	 *
	 * @param {Object} json - The skeleton as serialized JSON.
	 * @param {Object<string, Bone>} bones - An array of bones.
	 * @return {Skeleton} A reference of this instance.
	 */ fromJSON(json, bones) {
        this.uuid = json.uuid;
        for(let i = 0, l = json.bones.length; i < l; i++){
            const uuid = json.bones[i];
            let bone = bones[uuid];
            if (bone === undefined) {
                console.warn('THREE.Skeleton: No bone found with UUID:', uuid);
                bone = new $9ddd7e9b53f7a2d4$export$b127726e56765aa4();
            }
            this.bones.push(bone);
            this.boneInverses.push(new $9ddd7e9b53f7a2d4$export$2ae72fc923e5eb5().fromArray(json.boneInverses[i]));
        }
        this.init();
        return this;
    }
    /**
	 * Serializes the skeleton into JSON.
	 *
	 * @return {Object} A JSON object representing the serialized skeleton.
	 * @see {@link ObjectLoader#parse}
	 */ toJSON() {
        const data = {
            metadata: {
                version: 4.6,
                type: 'Skeleton',
                generator: 'Skeleton.toJSON'
            },
            bones: [],
            boneInverses: []
        };
        data.uuid = this.uuid;
        const bones = this.bones;
        const boneInverses = this.boneInverses;
        for(let i = 0, l = bones.length; i < l; i++){
            const bone = bones[i];
            data.bones.push(bone.uuid);
            const boneInverse = boneInverses[i];
            data.boneInverses.push(boneInverse.toArray());
        }
        return data;
    }
}
/**
 * An instanced version of a buffer attribute.
 *
 * @augments BufferAttribute
 */ class $9ddd7e9b53f7a2d4$export$32ea87a8b54d744a extends $9ddd7e9b53f7a2d4$export$8dea267bd6bde117 {
    /**
	 * Constructs a new instanced buffer attribute.
	 *
	 * @param {TypedArray} array - The array holding the attribute data.
	 * @param {number} itemSize - The item size.
	 * @param {boolean} [normalized=false] - Whether the data are normalized or not.
	 * @param {number} [meshPerAttribute=1] - How often a value of this buffer attribute should be repeated.
	 */ constructor(array, itemSize, normalized, meshPerAttribute = 1){
        super(array, itemSize, normalized);
        /**
		 * This flag can be used for type testing.
		 *
		 * @type {boolean}
		 * @readonly
		 * @default true
		 */ this.isInstancedBufferAttribute = true;
        /**
		 * Defines how often a value of this buffer attribute should be repeated. A
		 * value of one means that each value of the instanced attribute is used for
		 * a single instance. A value of two means that each value is used for two
		 * consecutive instances (and so on).
		 *
		 * @type {number}
		 * @default 1
		 */ this.meshPerAttribute = meshPerAttribute;
    }
    copy(source) {
        super.copy(source);
        this.meshPerAttribute = source.meshPerAttribute;
        return this;
    }
    toJSON() {
        const data = super.toJSON();
        data.meshPerAttribute = this.meshPerAttribute;
        data.isInstancedBufferAttribute = true;
        return data;
    }
}
const $9ddd7e9b53f7a2d4$var$_instanceLocalMatrix = /*@__PURE__*/ new $9ddd7e9b53f7a2d4$export$2ae72fc923e5eb5();
const $9ddd7e9b53f7a2d4$var$_instanceWorldMatrix = /*@__PURE__*/ new $9ddd7e9b53f7a2d4$export$2ae72fc923e5eb5();
const $9ddd7e9b53f7a2d4$var$_instanceIntersects = [];
const $9ddd7e9b53f7a2d4$var$_box3 = /*@__PURE__*/ new $9ddd7e9b53f7a2d4$export$6f7d5a9418ab2aa3();
const $9ddd7e9b53f7a2d4$var$_identity = /*@__PURE__*/ new $9ddd7e9b53f7a2d4$export$2ae72fc923e5eb5();
const $9ddd7e9b53f7a2d4$var$_mesh$1 = /*@__PURE__*/ new $9ddd7e9b53f7a2d4$export$e176487c05830cc5();
const $9ddd7e9b53f7a2d4$var$_sphere$4 = /*@__PURE__*/ new $9ddd7e9b53f7a2d4$export$805e8b72413ccaba();
/**
 * A special version of a mesh with instanced rendering support. Use
 * this class if you have to render a large number of objects with the same
 * geometry and material(s) but with different world transformations. The usage
 * of 'InstancedMesh' will help you to reduce the number of draw calls and thus
 * improve the overall rendering performance in your application.
 *
 * @augments Mesh
 */ class $9ddd7e9b53f7a2d4$export$f3c979c331175ad7 extends $9ddd7e9b53f7a2d4$export$e176487c05830cc5 {
    /**
	 * Constructs a new instanced mesh.
	 *
	 * @param {BufferGeometry} [geometry] - The mesh geometry.
	 * @param {Material|Array<Material>} [material] - The mesh material.
	 * @param {number} count - The number of instances.
	 */ constructor(geometry, material, count){
        super(geometry, material);
        /**
		 * This flag can be used for type testing.
		 *
		 * @type {boolean}
		 * @readonly
		 * @default true
		 */ this.isInstancedMesh = true;
        /**
		 * Represents the local transformation of all instances. You have to set its
		 * {@link BufferAttribute#needsUpdate} flag to true if you modify instanced data
		 * via {@link InstancedMesh#setMatrixAt}.
		 *
		 * @type {InstancedBufferAttribute}
		 */ this.instanceMatrix = new $9ddd7e9b53f7a2d4$export$32ea87a8b54d744a(new Float32Array(count * 16), 16);
        /**
		 * Represents the color of all instances. You have to set its
		 * {@link BufferAttribute#needsUpdate} flag to true if you modify instanced data
		 * via {@link InstancedMesh#setColorAt}.
		 *
		 * @type {?InstancedBufferAttribute}
		 * @default null
		 */ this.instanceColor = null;
        /**
		 * Represents the morph target weights of all instances. You have to set its
		 * {@link Texture#needsUpdate} flag to true if you modify instanced data
		 * via {@link InstancedMesh#setMorphAt}.
		 *
		 * @type {?DataTexture}
		 * @default null
		 */ this.morphTexture = null;
        /**
		 * The number of instances.
		 *
		 * @type {number}
		 */ this.count = count;
        /**
		 * The bounding box of the instanced mesh. Can be computed via {@link InstancedMesh#computeBoundingBox}.
		 *
		 * @type {?Box3}
		 * @default null
		 */ this.boundingBox = null;
        /**
		 * The bounding sphere of the instanced mesh. Can be computed via {@link InstancedMesh#computeBoundingSphere}.
		 *
		 * @type {?Sphere}
		 * @default null
		 */ this.boundingSphere = null;
        for(let i = 0; i < count; i++)this.setMatrixAt(i, $9ddd7e9b53f7a2d4$var$_identity);
    }
    /**
	 * Computes the bounding box of the instanced mesh, and updates {@link InstancedMesh#boundingBox}.
	 * The bounding box is not automatically computed by the engine; this method must be called by your app.
	 * You may need to recompute the bounding box if an instance is transformed via {@link InstancedMesh#setMatrixAt}.
	 */ computeBoundingBox() {
        const geometry = this.geometry;
        const count = this.count;
        if (this.boundingBox === null) this.boundingBox = new $9ddd7e9b53f7a2d4$export$6f7d5a9418ab2aa3();
        if (geometry.boundingBox === null) geometry.computeBoundingBox();
        this.boundingBox.makeEmpty();
        for(let i = 0; i < count; i++){
            this.getMatrixAt(i, $9ddd7e9b53f7a2d4$var$_instanceLocalMatrix);
            $9ddd7e9b53f7a2d4$var$_box3.copy(geometry.boundingBox).applyMatrix4($9ddd7e9b53f7a2d4$var$_instanceLocalMatrix);
            this.boundingBox.union($9ddd7e9b53f7a2d4$var$_box3);
        }
    }
    /**
	 * Computes the bounding sphere of the instanced mesh, and updates {@link InstancedMesh#boundingSphere}
	 * The engine automatically computes the bounding sphere when it is needed, e.g., for ray casting or view frustum culling.
	 * You may need to recompute the bounding sphere if an instance is transformed via {@link InstancedMesh#setMatrixAt}.
	 */ computeBoundingSphere() {
        const geometry = this.geometry;
        const count = this.count;
        if (this.boundingSphere === null) this.boundingSphere = new $9ddd7e9b53f7a2d4$export$805e8b72413ccaba();
        if (geometry.boundingSphere === null) geometry.computeBoundingSphere();
        this.boundingSphere.makeEmpty();
        for(let i = 0; i < count; i++){
            this.getMatrixAt(i, $9ddd7e9b53f7a2d4$var$_instanceLocalMatrix);
            $9ddd7e9b53f7a2d4$var$_sphere$4.copy(geometry.boundingSphere).applyMatrix4($9ddd7e9b53f7a2d4$var$_instanceLocalMatrix);
            this.boundingSphere.union($9ddd7e9b53f7a2d4$var$_sphere$4);
        }
    }
    copy(source, recursive) {
        super.copy(source, recursive);
        this.instanceMatrix.copy(source.instanceMatrix);
        if (source.morphTexture !== null) this.morphTexture = source.morphTexture.clone();
        if (source.instanceColor !== null) this.instanceColor = source.instanceColor.clone();
        this.count = source.count;
        if (source.boundingBox !== null) this.boundingBox = source.boundingBox.clone();
        if (source.boundingSphere !== null) this.boundingSphere = source.boundingSphere.clone();
        return this;
    }
    /**
	 * Gets the color of the defined instance.
	 *
	 * @param {number} index - The instance index.
	 * @param {Color} color - The target object that is used to store the method's result.
	 */ getColorAt(index, color) {
        color.fromArray(this.instanceColor.array, index * 3);
    }
    /**
	 * Gets the local transformation matrix of the defined instance.
	 *
	 * @param {number} index - The instance index.
	 * @param {Matrix4} matrix - The target object that is used to store the method's result.
	 */ getMatrixAt(index, matrix) {
        matrix.fromArray(this.instanceMatrix.array, index * 16);
    }
    /**
	 * Gets the morph target weights of the defined instance.
	 *
	 * @param {number} index - The instance index.
	 * @param {Mesh} object - The target object that is used to store the method's result.
	 */ getMorphAt(index, object) {
        const objectInfluences = object.morphTargetInfluences;
        const array = this.morphTexture.source.data.data;
        const len = objectInfluences.length + 1; // All influences + the baseInfluenceSum
        const dataIndex = index * len + 1; // Skip the baseInfluenceSum at the beginning
        for(let i = 0; i < objectInfluences.length; i++)objectInfluences[i] = array[dataIndex + i];
    }
    raycast(raycaster, intersects) {
        const matrixWorld = this.matrixWorld;
        const raycastTimes = this.count;
        $9ddd7e9b53f7a2d4$var$_mesh$1.geometry = this.geometry;
        $9ddd7e9b53f7a2d4$var$_mesh$1.material = this.material;
        if ($9ddd7e9b53f7a2d4$var$_mesh$1.material === undefined) return;
        // test with bounding sphere first
        if (this.boundingSphere === null) this.computeBoundingSphere();
        $9ddd7e9b53f7a2d4$var$_sphere$4.copy(this.boundingSphere);
        $9ddd7e9b53f7a2d4$var$_sphere$4.applyMatrix4(matrixWorld);
        if (raycaster.ray.intersectsSphere($9ddd7e9b53f7a2d4$var$_sphere$4) === false) return;
        // now test each instance
        for(let instanceId = 0; instanceId < raycastTimes; instanceId++){
            // calculate the world matrix for each instance
            this.getMatrixAt(instanceId, $9ddd7e9b53f7a2d4$var$_instanceLocalMatrix);
            $9ddd7e9b53f7a2d4$var$_instanceWorldMatrix.multiplyMatrices(matrixWorld, $9ddd7e9b53f7a2d4$var$_instanceLocalMatrix);
            // the mesh represents this single instance
            $9ddd7e9b53f7a2d4$var$_mesh$1.matrixWorld = $9ddd7e9b53f7a2d4$var$_instanceWorldMatrix;
            $9ddd7e9b53f7a2d4$var$_mesh$1.raycast(raycaster, $9ddd7e9b53f7a2d4$var$_instanceIntersects);
            // process the result of raycast
            for(let i = 0, l = $9ddd7e9b53f7a2d4$var$_instanceIntersects.length; i < l; i++){
                const intersect = $9ddd7e9b53f7a2d4$var$_instanceIntersects[i];
                intersect.instanceId = instanceId;
                intersect.object = this;
                intersects.push(intersect);
            }
            $9ddd7e9b53f7a2d4$var$_instanceIntersects.length = 0;
        }
    }
    /**
	 * Sets the given color to the defined instance. Make sure you set the `needsUpdate` flag of
	 * {@link InstancedMesh#instanceColor} to `true` after updating all the colors.
	 *
	 * @param {number} index - The instance index.
	 * @param {Color} color - The instance color.
	 */ setColorAt(index, color) {
        if (this.instanceColor === null) this.instanceColor = new $9ddd7e9b53f7a2d4$export$32ea87a8b54d744a(new Float32Array(this.instanceMatrix.count * 3).fill(1), 3);
        color.toArray(this.instanceColor.array, index * 3);
    }
    /**
	 * Sets the given local transformation matrix to the defined instance. Make sure you set the `needsUpdate` flag of
	 * {@link InstancedMesh#instanceMatrix} to `true` after updating all the colors.
	 *
	 * @param {number} index - The instance index.
	 * @param {Matrix4} matrix - The local transformation.
	 */ setMatrixAt(index, matrix) {
        matrix.toArray(this.instanceMatrix.array, index * 16);
    }
    /**
	 * Sets the morph target weights to the defined instance. Make sure you set the `needsUpdate` flag of
	 * {@link InstancedMesh#morphTexture} to `true` after updating all the influences.
	 *
	 * @param {number} index - The instance index.
	 * @param {Mesh} object -  A mesh which `morphTargetInfluences` property containing the morph target weights
	 * of a single instance.
	 */ setMorphAt(index, object) {
        const objectInfluences = object.morphTargetInfluences;
        const len = objectInfluences.length + 1; // morphBaseInfluence + all influences
        if (this.morphTexture === null) this.morphTexture = new $9ddd7e9b53f7a2d4$export$b691f601014eabe1(new Float32Array(len * this.count), len, this.count, $9ddd7e9b53f7a2d4$export$4e041a7967d15c4b, $9ddd7e9b53f7a2d4$export$f6d331659b644596);
        const array = this.morphTexture.source.data.data;
        let morphInfluencesSum = 0;
        for(let i = 0; i < objectInfluences.length; i++)morphInfluencesSum += objectInfluences[i];
        const morphBaseInfluence = this.geometry.morphTargetsRelative ? 1 : 1 - morphInfluencesSum;
        const dataIndex = len * index;
        array[dataIndex] = morphBaseInfluence;
        array.set(objectInfluences, dataIndex + 1);
    }
    updateMorphTargets() {}
    /**
	 * Frees the GPU-related resources allocated by this instance. Call this
	 * method whenever this instance is no longer used in your app.
	 */ dispose() {
        this.dispatchEvent({
            type: 'dispose'
        });
        if (this.morphTexture !== null) {
            this.morphTexture.dispose();
            this.morphTexture = null;
        }
    }
}
const $9ddd7e9b53f7a2d4$var$_vector1 = /*@__PURE__*/ new $9ddd7e9b53f7a2d4$export$64b5c384219d3699();
const $9ddd7e9b53f7a2d4$var$_vector2 = /*@__PURE__*/ new $9ddd7e9b53f7a2d4$export$64b5c384219d3699();
const $9ddd7e9b53f7a2d4$var$_normalMatrix = /*@__PURE__*/ new $9ddd7e9b53f7a2d4$export$8ff26dafa08918();
/**
 * A two dimensional surface that extends infinitely in 3D space, represented
 * in [Hessian normal form]{@link http://mathworld.wolfram.com/HessianNormalForm.html}
 * by a unit length normal vector and a constant.
 */ class $9ddd7e9b53f7a2d4$export$7ff5ac152ef991b0 {
    /**
	 * Constructs a new plane.
	 *
	 * @param {Vector3} [normal=(1,0,0)] - A unit length vector defining the normal of the plane.
	 * @param {number} [constant=0] - The signed distance from the origin to the plane.
	 */ constructor(normal = new $9ddd7e9b53f7a2d4$export$64b5c384219d3699(1, 0, 0), constant = 0){
        /**
		 * This flag can be used for type testing.
		 *
		 * @type {boolean}
		 * @readonly
		 * @default true
		 */ this.isPlane = true;
        /**
		 * A unit length vector defining the normal of the plane.
		 *
		 * @type {Vector3}
		 */ this.normal = normal;
        /**
		 * The signed distance from the origin to the plane.
		 *
		 * @type {number}
		 * @default 0
		 */ this.constant = constant;
    }
    /**
	 * Sets the plane components by copying the given values.
	 *
	 * @param {Vector3} normal - The normal.
	 * @param {number} constant - The constant.
	 * @return {Plane} A reference to this plane.
	 */ set(normal, constant) {
        this.normal.copy(normal);
        this.constant = constant;
        return this;
    }
    /**
	 * Sets the plane components by defining `x`, `y`, `z` as the
	 * plane normal and `w` as the constant.
	 *
	 * @param {number} x - The value for the normal's x component.
	 * @param {number} y - The value for the normal's y component.
	 * @param {number} z - The value for the normal's z component.
	 * @param {number} w - The constant value.
	 * @return {Plane} A reference to this plane.
	 */ setComponents(x, y, z, w) {
        this.normal.set(x, y, z);
        this.constant = w;
        return this;
    }
    /**
	 * Sets the plane from the given normal and coplanar point (that is a point
	 * that lies onto the plane).
	 *
	 * @param {Vector3} normal - The normal.
	 * @param {Vector3} point - A coplanar point.
	 * @return {Plane} A reference to this plane.
	 */ setFromNormalAndCoplanarPoint(normal, point) {
        this.normal.copy(normal);
        this.constant = -point.dot(this.normal);
        return this;
    }
    /**
	 * Sets the plane from three coplanar points. The winding order is
	 * assumed to be counter-clockwise, and determines the direction of
	 * the plane normal.
	 *
	 * @param {Vector3} a - The first coplanar point.
	 * @param {Vector3} b - The second coplanar point.
	 * @param {Vector3} c - The third coplanar point.
	 * @return {Plane} A reference to this plane.
	 */ setFromCoplanarPoints(a, b, c) {
        const normal = $9ddd7e9b53f7a2d4$var$_vector1.subVectors(c, b).cross($9ddd7e9b53f7a2d4$var$_vector2.subVectors(a, b)).normalize();
        // Q: should an error be thrown if normal is zero (e.g. degenerate plane)?
        this.setFromNormalAndCoplanarPoint(normal, a);
        return this;
    }
    /**
	 * Copies the values of the given plane to this instance.
	 *
	 * @param {Plane} plane - The plane to copy.
	 * @return {Plane} A reference to this plane.
	 */ copy(plane) {
        this.normal.copy(plane.normal);
        this.constant = plane.constant;
        return this;
    }
    /**
	 * Normalizes the plane normal and adjusts the constant accordingly.
	 *
	 * @return {Plane} A reference to this plane.
	 */ normalize() {
        // Note: will lead to a divide by zero if the plane is invalid.
        const inverseNormalLength = 1.0 / this.normal.length();
        this.normal.multiplyScalar(inverseNormalLength);
        this.constant *= inverseNormalLength;
        return this;
    }
    /**
	 * Negates both the plane normal and the constant.
	 *
	 * @return {Plane} A reference to this plane.
	 */ negate() {
        this.constant *= -1;
        this.normal.negate();
        return this;
    }
    /**
	 * Returns the signed distance from the given point to this plane.
	 *
	 * @param {Vector3} point - The point to compute the distance for.
	 * @return {number} The signed distance.
	 */ distanceToPoint(point) {
        return this.normal.dot(point) + this.constant;
    }
    /**
	 * Returns the signed distance from the given sphere to this plane.
	 *
	 * @param {Sphere} sphere - The sphere to compute the distance for.
	 * @return {number} The signed distance.
	 */ distanceToSphere(sphere) {
        return this.distanceToPoint(sphere.center) - sphere.radius;
    }
    /**
	 * Projects a the given point onto the plane.
	 *
	 * @param {Vector3} point - The point to project.
	 * @param {Vector3} target - The target vector that is used to store the method's result.
	 * @return {Vector3} The projected point on the plane.
	 */ projectPoint(point, target) {
        return target.copy(point).addScaledVector(this.normal, -this.distanceToPoint(point));
    }
    /**
	 * Returns the intersection point of the passed line and the plane. Returns
	 * `null` if the line does not intersect. Returns the line's starting point if
	 * the line is coplanar with the plane.
	 *
	 * @param {Line3} line - The line to compute the intersection for.
	 * @param {Vector3} target - The target vector that is used to store the method's result.
	 * @return {?Vector3} The intersection point.
	 */ intersectLine(line, target) {
        const direction = line.delta($9ddd7e9b53f7a2d4$var$_vector1);
        const denominator = this.normal.dot(direction);
        if (denominator === 0) {
            // line is coplanar, return origin
            if (this.distanceToPoint(line.start) === 0) return target.copy(line.start);
            // Unsure if this is the correct method to handle this case.
            return null;
        }
        const t = -(line.start.dot(this.normal) + this.constant) / denominator;
        if (t < 0 || t > 1) return null;
        return target.copy(line.start).addScaledVector(direction, t);
    }
    /**
	 * Returns `true` if the given line segment intersects with (passes through) the plane.
	 *
	 * @param {Line3} line - The line to test.
	 * @return {boolean} Whether the given line segment intersects with the plane or not.
	 */ intersectsLine(line) {
        // Note: this tests if a line intersects the plane, not whether it (or its end-points) are coplanar with it.
        const startSign = this.distanceToPoint(line.start);
        const endSign = this.distanceToPoint(line.end);
        return startSign < 0 && endSign > 0 || endSign < 0 && startSign > 0;
    }
    /**
	 * Returns `true` if the given bounding box intersects with the plane.
	 *
	 * @param {Box3} box - The bounding box to test.
	 * @return {boolean} Whether the given bounding box intersects with the plane or not.
	 */ intersectsBox(box) {
        return box.intersectsPlane(this);
    }
    /**
	 * Returns `true` if the given bounding sphere intersects with the plane.
	 *
	 * @param {Sphere} sphere - The bounding sphere to test.
	 * @return {boolean} Whether the given bounding sphere intersects with the plane or not.
	 */ intersectsSphere(sphere) {
        return sphere.intersectsPlane(this);
    }
    /**
	 * Returns a coplanar vector to the plane, by calculating the
	 * projection of the normal at the origin onto the plane.
	 *
	 * @param {Vector3} target - The target vector that is used to store the method's result.
	 * @return {Vector3} The coplanar point.
	 */ coplanarPoint(target) {
        return target.copy(this.normal).multiplyScalar(-this.constant);
    }
    /**
	 * Apply a 4x4 matrix to the plane. The matrix must be an affine, homogeneous transform.
	 *
	 * The optional normal matrix can be pre-computed like so:
	 * ```js
	 * const optionalNormalMatrix = new THREE.Matrix3().getNormalMatrix( matrix );
	 * ```
	 *
	 * @param {Matrix4} matrix - The transformation matrix.
	 * @param {Matrix4} [optionalNormalMatrix] - A pre-computed normal matrix.
	 * @return {Plane} A reference to this plane.
	 */ applyMatrix4(matrix, optionalNormalMatrix) {
        const normalMatrix = optionalNormalMatrix || $9ddd7e9b53f7a2d4$var$_normalMatrix.getNormalMatrix(matrix);
        const referencePoint = this.coplanarPoint($9ddd7e9b53f7a2d4$var$_vector1).applyMatrix4(matrix);
        const normal = this.normal.applyMatrix3(normalMatrix).normalize();
        this.constant = -referencePoint.dot(normal);
        return this;
    }
    /**
	 * Translates the plane by the distance defined by the given offset vector.
	 * Note that this only affects the plane constant and will not affect the normal vector.
	 *
	 * @param {Vector3} offset - The offset vector.
	 * @return {Plane} A reference to this plane.
	 */ translate(offset) {
        this.constant -= offset.dot(this.normal);
        return this;
    }
    /**
	 * Returns `true` if this plane is equal with the given one.
	 *
	 * @param {Plane} plane - The plane to test for equality.
	 * @return {boolean} Whether this plane is equal with the given one.
	 */ equals(plane) {
        return plane.normal.equals(this.normal) && plane.constant === this.constant;
    }
    /**
	 * Returns a new plane with copied values from this instance.
	 *
	 * @return {Plane} A clone of this instance.
	 */ clone() {
        return new this.constructor().copy(this);
    }
}
const $9ddd7e9b53f7a2d4$var$_sphere$3 = /*@__PURE__*/ new $9ddd7e9b53f7a2d4$export$805e8b72413ccaba();
const $9ddd7e9b53f7a2d4$var$_vector$6 = /*@__PURE__*/ new $9ddd7e9b53f7a2d4$export$64b5c384219d3699();
/**
 * Frustums are used to determine what is inside the camera's field of view.
 * They help speed up the rendering process - objects which lie outside a camera's
 * frustum can safely be excluded from rendering.
 *
 * This class is mainly intended for use internally by a renderer.
 */ class $9ddd7e9b53f7a2d4$export$35efe6f4c85463d2 {
    /**
	 * Constructs a new frustum.
	 *
	 * @param {Plane} [p0] - The first plane that encloses the frustum.
	 * @param {Plane} [p1] - The second plane that encloses the frustum.
	 * @param {Plane} [p2] - The third plane that encloses the frustum.
	 * @param {Plane} [p3] - The fourth plane that encloses the frustum.
	 * @param {Plane} [p4] - The fifth plane that encloses the frustum.
	 * @param {Plane} [p5] - The sixth plane that encloses the frustum.
	 */ constructor(p0 = new $9ddd7e9b53f7a2d4$export$7ff5ac152ef991b0(), p1 = new $9ddd7e9b53f7a2d4$export$7ff5ac152ef991b0(), p2 = new $9ddd7e9b53f7a2d4$export$7ff5ac152ef991b0(), p3 = new $9ddd7e9b53f7a2d4$export$7ff5ac152ef991b0(), p4 = new $9ddd7e9b53f7a2d4$export$7ff5ac152ef991b0(), p5 = new $9ddd7e9b53f7a2d4$export$7ff5ac152ef991b0()){
        /**
		 * This array holds the planes that enclose the frustum.
		 *
		 * @type {Array<Plane>}
		 */ this.planes = [
            p0,
            p1,
            p2,
            p3,
            p4,
            p5
        ];
    }
    /**
	 * Sets the frustum planes by copying the given planes.
	 *
	 * @param {Plane} [p0] - The first plane that encloses the frustum.
	 * @param {Plane} [p1] - The second plane that encloses the frustum.
	 * @param {Plane} [p2] - The third plane that encloses the frustum.
	 * @param {Plane} [p3] - The fourth plane that encloses the frustum.
	 * @param {Plane} [p4] - The fifth plane that encloses the frustum.
	 * @param {Plane} [p5] - The sixth plane that encloses the frustum.
	 * @return {Frustum} A reference to this frustum.
	 */ set(p0, p1, p2, p3, p4, p5) {
        const planes = this.planes;
        planes[0].copy(p0);
        planes[1].copy(p1);
        planes[2].copy(p2);
        planes[3].copy(p3);
        planes[4].copy(p4);
        planes[5].copy(p5);
        return this;
    }
    /**
	 * Copies the values of the given frustum to this instance.
	 *
	 * @param {Frustum} frustum - The frustum to copy.
	 * @return {Frustum} A reference to this frustum.
	 */ copy(frustum) {
        const planes = this.planes;
        for(let i = 0; i < 6; i++)planes[i].copy(frustum.planes[i]);
        return this;
    }
    /**
	 * Sets the frustum planes from the given projection matrix.
	 *
	 * @param {Matrix4} m - The projection matrix.
	 * @param {(WebGLCoordinateSystem|WebGPUCoordinateSystem)} coordinateSystem - The coordinate system.
	 * @return {Frustum} A reference to this frustum.
	 */ setFromProjectionMatrix(m, coordinateSystem = $9ddd7e9b53f7a2d4$export$5a0e9190d10875d3) {
        const planes = this.planes;
        const me = m.elements;
        const me0 = me[0], me1 = me[1], me2 = me[2], me3 = me[3];
        const me4 = me[4], me5 = me[5], me6 = me[6], me7 = me[7];
        const me8 = me[8], me9 = me[9], me10 = me[10], me11 = me[11];
        const me12 = me[12], me13 = me[13], me14 = me[14], me15 = me[15];
        planes[0].setComponents(me3 - me0, me7 - me4, me11 - me8, me15 - me12).normalize();
        planes[1].setComponents(me3 + me0, me7 + me4, me11 + me8, me15 + me12).normalize();
        planes[2].setComponents(me3 + me1, me7 + me5, me11 + me9, me15 + me13).normalize();
        planes[3].setComponents(me3 - me1, me7 - me5, me11 - me9, me15 - me13).normalize();
        planes[4].setComponents(me3 - me2, me7 - me6, me11 - me10, me15 - me14).normalize();
        if (coordinateSystem === $9ddd7e9b53f7a2d4$export$5a0e9190d10875d3) planes[5].setComponents(me3 + me2, me7 + me6, me11 + me10, me15 + me14).normalize();
        else if (coordinateSystem === $9ddd7e9b53f7a2d4$export$cc83beedcb9be9ac) planes[5].setComponents(me2, me6, me10, me14).normalize();
        else throw new Error('THREE.Frustum.setFromProjectionMatrix(): Invalid coordinate system: ' + coordinateSystem);
        return this;
    }
    /**
	 * Returns `true` if the 3D object's bounding sphere is intersecting this frustum.
	 *
	 * Note that the 3D object must have a geometry so that the bounding sphere can be calculated.
	 *
	 * @param {Object3D} object - The 3D object to test.
	 * @return {boolean} Whether the 3D object's bounding sphere is intersecting this frustum or not.
	 */ intersectsObject(object) {
        if (object.boundingSphere !== undefined) {
            if (object.boundingSphere === null) object.computeBoundingSphere();
            $9ddd7e9b53f7a2d4$var$_sphere$3.copy(object.boundingSphere).applyMatrix4(object.matrixWorld);
        } else {
            const geometry = object.geometry;
            if (geometry.boundingSphere === null) geometry.computeBoundingSphere();
            $9ddd7e9b53f7a2d4$var$_sphere$3.copy(geometry.boundingSphere).applyMatrix4(object.matrixWorld);
        }
        return this.intersectsSphere($9ddd7e9b53f7a2d4$var$_sphere$3);
    }
    /**
	 * Returns `true` if the given sprite is intersecting this frustum.
	 *
	 * @param {Sprite} sprite - The sprite to test.
	 * @return {boolean} Whether the sprite is intersecting this frustum or not.
	 */ intersectsSprite(sprite) {
        $9ddd7e9b53f7a2d4$var$_sphere$3.center.set(0, 0, 0);
        $9ddd7e9b53f7a2d4$var$_sphere$3.radius = 0.7071067811865476;
        $9ddd7e9b53f7a2d4$var$_sphere$3.applyMatrix4(sprite.matrixWorld);
        return this.intersectsSphere($9ddd7e9b53f7a2d4$var$_sphere$3);
    }
    /**
	 * Returns `true` if the given bounding sphere is intersecting this frustum.
	 *
	 * @param {Sphere} sphere - The bounding sphere to test.
	 * @return {boolean} Whether the bounding sphere is intersecting this frustum or not.
	 */ intersectsSphere(sphere) {
        const planes = this.planes;
        const center = sphere.center;
        const negRadius = -sphere.radius;
        for(let i = 0; i < 6; i++){
            const distance = planes[i].distanceToPoint(center);
            if (distance < negRadius) return false;
        }
        return true;
    }
    /**
	 * Returns `true` if the given bounding box is intersecting this frustum.
	 *
	 * @param {Box3} box - The bounding box to test.
	 * @return {boolean} Whether the bounding box is intersecting this frustum or not.
	 */ intersectsBox(box) {
        const planes = this.planes;
        for(let i = 0; i < 6; i++){
            const plane = planes[i];
            // corner at max distance
            $9ddd7e9b53f7a2d4$var$_vector$6.x = plane.normal.x > 0 ? box.max.x : box.min.x;
            $9ddd7e9b53f7a2d4$var$_vector$6.y = plane.normal.y > 0 ? box.max.y : box.min.y;
            $9ddd7e9b53f7a2d4$var$_vector$6.z = plane.normal.z > 0 ? box.max.z : box.min.z;
            if (plane.distanceToPoint($9ddd7e9b53f7a2d4$var$_vector$6) < 0) return false;
        }
        return true;
    }
    /**
	 * Returns `true` if the given point lies within the frustum.
	 *
	 * @param {Vector3} point - The point to test.
	 * @return {boolean} Whether the point lies within this frustum or not.
	 */ containsPoint(point) {
        const planes = this.planes;
        for(let i = 0; i < 6; i++){
            if (planes[i].distanceToPoint(point) < 0) return false;
        }
        return true;
    }
    /**
	 * Returns a new frustum with copied values from this instance.
	 *
	 * @return {Frustum} A clone of this instance.
	 */ clone() {
        return new this.constructor().copy(this);
    }
}
function $9ddd7e9b53f7a2d4$var$ascIdSort(a, b) {
    return a - b;
}
function $9ddd7e9b53f7a2d4$var$sortOpaque(a, b) {
    return a.z - b.z;
}
function $9ddd7e9b53f7a2d4$var$sortTransparent(a, b) {
    return b.z - a.z;
}
class $9ddd7e9b53f7a2d4$var$MultiDrawRenderList {
    constructor(){
        this.index = 0;
        this.pool = [];
        this.list = [];
    }
    push(start, count, z, index) {
        const pool = this.pool;
        const list = this.list;
        if (this.index >= pool.length) pool.push({
            start: -1,
            count: -1,
            z: -1,
            index: -1
        });
        const item = pool[this.index];
        list.push(item);
        this.index++;
        item.start = start;
        item.count = count;
        item.z = z;
        item.index = index;
    }
    reset() {
        this.list.length = 0;
        this.index = 0;
    }
}
const $9ddd7e9b53f7a2d4$var$_matrix$1 = /*@__PURE__*/ new $9ddd7e9b53f7a2d4$export$2ae72fc923e5eb5();
const $9ddd7e9b53f7a2d4$var$_whiteColor = /*@__PURE__*/ new $9ddd7e9b53f7a2d4$export$892596cec99bc70e(1, 1, 1);
const $9ddd7e9b53f7a2d4$var$_frustum = /*@__PURE__*/ new $9ddd7e9b53f7a2d4$export$35efe6f4c85463d2();
const $9ddd7e9b53f7a2d4$var$_box$1 = /*@__PURE__*/ new $9ddd7e9b53f7a2d4$export$6f7d5a9418ab2aa3();
const $9ddd7e9b53f7a2d4$var$_sphere$2 = /*@__PURE__*/ new $9ddd7e9b53f7a2d4$export$805e8b72413ccaba();
const $9ddd7e9b53f7a2d4$var$_vector$5 = /*@__PURE__*/ new $9ddd7e9b53f7a2d4$export$64b5c384219d3699();
const $9ddd7e9b53f7a2d4$var$_forward = /*@__PURE__*/ new $9ddd7e9b53f7a2d4$export$64b5c384219d3699();
const $9ddd7e9b53f7a2d4$var$_temp = /*@__PURE__*/ new $9ddd7e9b53f7a2d4$export$64b5c384219d3699();
const $9ddd7e9b53f7a2d4$var$_renderList = /*@__PURE__*/ new $9ddd7e9b53f7a2d4$var$MultiDrawRenderList();
const $9ddd7e9b53f7a2d4$var$_mesh = /*@__PURE__*/ new $9ddd7e9b53f7a2d4$export$e176487c05830cc5();
const $9ddd7e9b53f7a2d4$var$_batchIntersects = [];
// copies data from attribute "src" into "target" starting at "targetOffset"
function $9ddd7e9b53f7a2d4$var$copyAttributeData(src, target, targetOffset = 0) {
    const itemSize = target.itemSize;
    if (src.isInterleavedBufferAttribute || src.array.constructor !== target.array.constructor) {
        // use the component getters and setters if the array data cannot
        // be copied directly
        const vertexCount = src.count;
        for(let i = 0; i < vertexCount; i++)for(let c = 0; c < itemSize; c++)target.setComponent(i + targetOffset, c, src.getComponent(i, c));
    } else // faster copy approach using typed array set function
    target.array.set(src.array, targetOffset * itemSize);
    target.needsUpdate = true;
}
// safely copies array contents to a potentially smaller array
function $9ddd7e9b53f7a2d4$var$copyArrayContents(src, target) {
    if (src.constructor !== target.constructor) {
        // if arrays are of a different type (eg due to index size increasing) then data must be per-element copied
        const len = Math.min(src.length, target.length);
        for(let i = 0; i < len; i++)target[i] = src[i];
    } else {
        // if the arrays use the same data layout we can use a fast block copy
        const len = Math.min(src.length, target.length);
        target.set(new src.constructor(src.buffer, 0, len));
    }
}
/**
 * A special version of a mesh with multi draw batch rendering support. Use
 * this class if you have to render a large number of objects with the same
 * material but with different geometries or world transformations. The usage of
 * `BatchedMesh` will help you to reduce the number of draw calls and thus improve the overall
 * rendering performance in your application.
 *
 * ```js
 * const box = new THREE.BoxGeometry( 1, 1, 1 );
 * const sphere = new THREE.SphereGeometry( 1, 12, 12 );
 * const material = new THREE.MeshBasicMaterial( { color: 0x00ff00 } );
 *
 * // initialize and add geometries into the batched mesh
 * const batchedMesh = new BatchedMesh( 10, 5000, 10000, material );
 * const boxGeometryId = batchedMesh.addGeometry( box );
 * const sphereGeometryId = batchedMesh.addGeometry( sphere );
 *
 * // create instances of those geometries
 * const boxInstancedId1 = batchedMesh.addInstance( boxGeometryId );
 * const boxInstancedId2 = batchedMesh.addInstance( boxGeometryId );
 *
 * const sphereInstancedId1 = batchedMesh.addInstance( sphereGeometryId );
 * const sphereInstancedId2 = batchedMesh.addInstance( sphereGeometryId );
 *
 * // position the geometries
 * batchedMesh.setMatrixAt( boxInstancedId1, boxMatrix1 );
 * batchedMesh.setMatrixAt( boxInstancedId2, boxMatrix2 );
 *
 * batchedMesh.setMatrixAt( sphereInstancedId1, sphereMatrix1 );
 * batchedMesh.setMatrixAt( sphereInstancedId2, sphereMatrix2 );
 *
 * scene.add( batchedMesh );
 * ```
 *
 * @augments Mesh
 */ class $9ddd7e9b53f7a2d4$export$6e01c5ee52ed8f7b extends $9ddd7e9b53f7a2d4$export$e176487c05830cc5 {
    /**
	 * Constructs a new batched mesh.
	 *
	 * @param {number} maxInstanceCount - The maximum number of individual instances planned to be added and rendered.
	 * @param {number} maxVertexCount - The maximum number of vertices to be used by all unique geometries.
	 * @param {number} [maxIndexCount=maxVertexCount*2] - The maximum number of indices to be used by all unique geometries
	 * @param {Material|Array<Material>} [material] - The mesh material.
	 */ constructor(maxInstanceCount, maxVertexCount, maxIndexCount = maxVertexCount * 2, material){
        super(new $9ddd7e9b53f7a2d4$export$b7be63a67df8959(), material);
        /**
		 * This flag can be used for type testing.
		 *
		 * @type {boolean}
		 * @readonly
		 * @default true
		 */ this.isBatchedMesh = true;
        /**
		 * When set ot `true`, the individual objects of a batch are frustum culled.
		 *
		 * @type {boolean}
		 * @default true
		 */ this.perObjectFrustumCulled = true;
        /**
		 * When set to `true`, the individual objects of a batch are sorted to improve overdraw-related artifacts.
		 * If the material is marked as "transparent" objects are rendered back to front and if not then they are
		 * rendered front to back.
		 *
		 * @type {boolean}
		 * @default true
		 */ this.sortObjects = true;
        /**
		 * The bounding box of the batched mesh. Can be computed via {@link BatchedMesh#computeBoundingBox}.
		 *
		 * @type {?Box3}
		 * @default null
		 */ this.boundingBox = null;
        /**
		 * The bounding sphere of the batched mesh. Can be computed via {@link BatchedMesh#computeBoundingSphere}.
		 *
		 * @type {?Sphere}
		 * @default null
		 */ this.boundingSphere = null;
        /**
		 * Takes a sort a function that is run before render. The function takes a list of instances to
		 * sort and a camera. The objects in the list include a "z" field to perform a depth-ordered
		 * sort with.
		 *
		 * @type {?Function}
		 * @default null
		 */ this.customSort = null;
        // stores visible, active, and geometry id per instance and reserved buffer ranges for geometries
        this._instanceInfo = [];
        this._geometryInfo = [];
        // instance, geometry ids that have been set as inactive, and are available to be overwritten
        this._availableInstanceIds = [];
        this._availableGeometryIds = [];
        // used to track where the next point is that geometry should be inserted
        this._nextIndexStart = 0;
        this._nextVertexStart = 0;
        this._geometryCount = 0;
        // flags
        this._visibilityChanged = true;
        this._geometryInitialized = false;
        // cached user options
        this._maxInstanceCount = maxInstanceCount;
        this._maxVertexCount = maxVertexCount;
        this._maxIndexCount = maxIndexCount;
        // buffers for multi draw
        this._multiDrawCounts = new Int32Array(maxInstanceCount);
        this._multiDrawStarts = new Int32Array(maxInstanceCount);
        this._multiDrawCount = 0;
        this._multiDrawInstances = null;
        // Local matrix per geometry by using data texture
        this._matricesTexture = null;
        this._indirectTexture = null;
        this._colorsTexture = null;
        this._initMatricesTexture();
        this._initIndirectTexture();
    }
    /**
	 * The maximum number of individual instances that can be stored in the batch.
	 *
	 * @type {number}
	 * @readonly
	 */ get maxInstanceCount() {
        return this._maxInstanceCount;
    }
    /**
	 * The instance count.
	 *
	 * @type {number}
	 * @readonly
	 */ get instanceCount() {
        return this._instanceInfo.length - this._availableInstanceIds.length;
    }
    /**
	 * The number of unused vertices.
	 *
	 * @type {number}
	 * @readonly
	 */ get unusedVertexCount() {
        return this._maxVertexCount - this._nextVertexStart;
    }
    /**
	 * The number of unused indices.
	 *
	 * @type {number}
	 * @readonly
	 */ get unusedIndexCount() {
        return this._maxIndexCount - this._nextIndexStart;
    }
    _initMatricesTexture() {
        // layout (1 matrix = 4 pixels)
        //      RGBA RGBA RGBA RGBA (=> column1, column2, column3, column4)
        //  with  8x8  pixel texture max   16 matrices * 4 pixels =  (8 * 8)
        //       16x16 pixel texture max   64 matrices * 4 pixels = (16 * 16)
        //       32x32 pixel texture max  256 matrices * 4 pixels = (32 * 32)
        //       64x64 pixel texture max 1024 matrices * 4 pixels = (64 * 64)
        let size = Math.sqrt(this._maxInstanceCount * 4); // 4 pixels needed for 1 matrix
        size = Math.ceil(size / 4) * 4;
        size = Math.max(size, 4);
        const matricesArray = new Float32Array(size * size * 4); // 4 floats per RGBA pixel
        const matricesTexture = new $9ddd7e9b53f7a2d4$export$b691f601014eabe1(matricesArray, size, size, $9ddd7e9b53f7a2d4$export$3f8bb04b555a363c, $9ddd7e9b53f7a2d4$export$f6d331659b644596);
        this._matricesTexture = matricesTexture;
    }
    _initIndirectTexture() {
        let size = Math.sqrt(this._maxInstanceCount);
        size = Math.ceil(size);
        const indirectArray = new Uint32Array(size * size);
        const indirectTexture = new $9ddd7e9b53f7a2d4$export$b691f601014eabe1(indirectArray, size, size, $9ddd7e9b53f7a2d4$export$aa92e870a709d190, $9ddd7e9b53f7a2d4$export$c3c7fc4518ebba96);
        this._indirectTexture = indirectTexture;
    }
    _initColorsTexture() {
        let size = Math.sqrt(this._maxInstanceCount);
        size = Math.ceil(size);
        // 4 floats per RGBA pixel initialized to white
        const colorsArray = new Float32Array(size * size * 4).fill(1);
        const colorsTexture = new $9ddd7e9b53f7a2d4$export$b691f601014eabe1(colorsArray, size, size, $9ddd7e9b53f7a2d4$export$3f8bb04b555a363c, $9ddd7e9b53f7a2d4$export$f6d331659b644596);
        colorsTexture.colorSpace = $9ddd7e9b53f7a2d4$export$5e6fd513f44698c.workingColorSpace;
        this._colorsTexture = colorsTexture;
    }
    _initializeGeometry(reference) {
        const geometry = this.geometry;
        const maxVertexCount = this._maxVertexCount;
        const maxIndexCount = this._maxIndexCount;
        if (this._geometryInitialized === false) {
            for(const attributeName in reference.attributes){
                const srcAttribute = reference.getAttribute(attributeName);
                const { array: array, itemSize: itemSize, normalized: normalized } = srcAttribute;
                const dstArray = new array.constructor(maxVertexCount * itemSize);
                const dstAttribute = new $9ddd7e9b53f7a2d4$export$8dea267bd6bde117(dstArray, itemSize, normalized);
                geometry.setAttribute(attributeName, dstAttribute);
            }
            if (reference.getIndex() !== null) {
                // Reserve last u16 index for primitive restart.
                const indexArray = maxVertexCount > 65535 ? new Uint32Array(maxIndexCount) : new Uint16Array(maxIndexCount);
                geometry.setIndex(new $9ddd7e9b53f7a2d4$export$8dea267bd6bde117(indexArray, 1));
            }
            this._geometryInitialized = true;
        }
    }
    // Make sure the geometry is compatible with the existing combined geometry attributes
    _validateGeometry(geometry) {
        // check to ensure the geometries are using consistent attributes and indices
        const batchGeometry = this.geometry;
        if (Boolean(geometry.getIndex()) !== Boolean(batchGeometry.getIndex())) throw new Error('THREE.BatchedMesh: All geometries must consistently have "index".');
        for(const attributeName in batchGeometry.attributes){
            if (!geometry.hasAttribute(attributeName)) throw new Error(`THREE.BatchedMesh: Added geometry missing "${attributeName}". All geometries must have consistent attributes.`);
            const srcAttribute = geometry.getAttribute(attributeName);
            const dstAttribute = batchGeometry.getAttribute(attributeName);
            if (srcAttribute.itemSize !== dstAttribute.itemSize || srcAttribute.normalized !== dstAttribute.normalized) throw new Error('THREE.BatchedMesh: All attributes must have a consistent itemSize and normalized value.');
        }
    }
    /**
	 * Validates the instance defined by the given ID.
	 *
	 * @param {number} instanceId - The instance to validate.
	 */ validateInstanceId(instanceId) {
        const instanceInfo = this._instanceInfo;
        if (instanceId < 0 || instanceId >= instanceInfo.length || instanceInfo[instanceId].active === false) throw new Error(`THREE.BatchedMesh: Invalid instanceId ${instanceId}. Instance is either out of range or has been deleted.`);
    }
    /**
	 * Validates the geometry defined by the given ID.
	 *
	 * @param {number} geometryId - The geometry to validate.
	 */ validateGeometryId(geometryId) {
        const geometryInfoList = this._geometryInfo;
        if (geometryId < 0 || geometryId >= geometryInfoList.length || geometryInfoList[geometryId].active === false) throw new Error(`THREE.BatchedMesh: Invalid geometryId ${geometryId}. Geometry is either out of range or has been deleted.`);
    }
    /**
	 * Takes a sort a function that is run before render. The function takes a list of instances to
	 * sort and a camera. The objects in the list include a "z" field to perform a depth-ordered sort with.
	 *
	 * @param {Function} func - The custom sort function.
	 * @return {BatchedMesh} A reference to this batched mesh.
	 */ setCustomSort(func) {
        this.customSort = func;
        return this;
    }
    /**
	 * Computes the bounding box, updating {@link BatchedMesh#boundingBox}.
	 * Bounding boxes aren't computed by default. They need to be explicitly computed,
	 * otherwise they are `null`.
	 */ computeBoundingBox() {
        if (this.boundingBox === null) this.boundingBox = new $9ddd7e9b53f7a2d4$export$6f7d5a9418ab2aa3();
        const boundingBox = this.boundingBox;
        const instanceInfo = this._instanceInfo;
        boundingBox.makeEmpty();
        for(let i = 0, l = instanceInfo.length; i < l; i++){
            if (instanceInfo[i].active === false) continue;
            const geometryId = instanceInfo[i].geometryIndex;
            this.getMatrixAt(i, $9ddd7e9b53f7a2d4$var$_matrix$1);
            this.getBoundingBoxAt(geometryId, $9ddd7e9b53f7a2d4$var$_box$1).applyMatrix4($9ddd7e9b53f7a2d4$var$_matrix$1);
            boundingBox.union($9ddd7e9b53f7a2d4$var$_box$1);
        }
    }
    /**
	 * Computes the bounding sphere, updating {@link BatchedMesh#boundingSphere}.
	 * Bounding spheres aren't computed by default. They need to be explicitly computed,
	 * otherwise they are `null`.
	 */ computeBoundingSphere() {
        if (this.boundingSphere === null) this.boundingSphere = new $9ddd7e9b53f7a2d4$export$805e8b72413ccaba();
        const boundingSphere = this.boundingSphere;
        const instanceInfo = this._instanceInfo;
        boundingSphere.makeEmpty();
        for(let i = 0, l = instanceInfo.length; i < l; i++){
            if (instanceInfo[i].active === false) continue;
            const geometryId = instanceInfo[i].geometryIndex;
            this.getMatrixAt(i, $9ddd7e9b53f7a2d4$var$_matrix$1);
            this.getBoundingSphereAt(geometryId, $9ddd7e9b53f7a2d4$var$_sphere$2).applyMatrix4($9ddd7e9b53f7a2d4$var$_matrix$1);
            boundingSphere.union($9ddd7e9b53f7a2d4$var$_sphere$2);
        }
    }
    /**
	 * Adds a new instance to the batch using the geometry of the given ID and returns
	 * a new id referring to the new instance to be used by other functions.
	 *
	 * @param {number} geometryId - The ID of a previously added geometry via {@link BatchedMesh#addGeometry}.
	 * @return {number} The instance ID.
	 */ addInstance(geometryId) {
        const atCapacity = this._instanceInfo.length >= this.maxInstanceCount;
        // ensure we're not over geometry
        if (atCapacity && this._availableInstanceIds.length === 0) throw new Error('THREE.BatchedMesh: Maximum item count reached.');
        const instanceInfo = {
            visible: true,
            active: true,
            geometryIndex: geometryId
        };
        let drawId = null;
        // Prioritize using previously freed instance ids
        if (this._availableInstanceIds.length > 0) {
            this._availableInstanceIds.sort($9ddd7e9b53f7a2d4$var$ascIdSort);
            drawId = this._availableInstanceIds.shift();
            this._instanceInfo[drawId] = instanceInfo;
        } else {
            drawId = this._instanceInfo.length;
            this._instanceInfo.push(instanceInfo);
        }
        const matricesTexture = this._matricesTexture;
        $9ddd7e9b53f7a2d4$var$_matrix$1.identity().toArray(matricesTexture.image.data, drawId * 16);
        matricesTexture.needsUpdate = true;
        const colorsTexture = this._colorsTexture;
        if (colorsTexture) {
            $9ddd7e9b53f7a2d4$var$_whiteColor.toArray(colorsTexture.image.data, drawId * 4);
            colorsTexture.needsUpdate = true;
        }
        this._visibilityChanged = true;
        return drawId;
    }
    /**
	 * Adds the given geometry to the batch and returns the associated
	 * geometry id referring to it to be used in other functions.
	 *
	 * @param {BufferGeometry} geometry - The geometry to add.
	 * @param {number} [reservedVertexCount=-1] - Optional parameter specifying the amount of
	 * vertex buffer space to reserve for the added geometry. This is necessary if it is planned
	 * to set a new geometry at this index at a later time that is larger than the original geometry.
	 * Defaults to the length of the given geometry vertex buffer.
	 * @param {number} [reservedIndexCount=-1] - Optional parameter specifying the amount of index
	 * buffer space to reserve for the added geometry. This is necessary if it is planned to set a
	 * new geometry at this index at a later time that is larger than the original geometry. Defaults to
	 * the length of the given geometry index buffer.
	 * @return {number} The geometry ID.
	 */ addGeometry(geometry, reservedVertexCount = -1, reservedIndexCount = -1) {
        this._initializeGeometry(geometry);
        this._validateGeometry(geometry);
        const geometryInfo = {
            // geometry information
            vertexStart: -1,
            vertexCount: -1,
            reservedVertexCount: -1,
            indexStart: -1,
            indexCount: -1,
            reservedIndexCount: -1,
            // draw range information
            start: -1,
            count: -1,
            // state
            boundingBox: null,
            boundingSphere: null,
            active: true
        };
        const geometryInfoList = this._geometryInfo;
        geometryInfo.vertexStart = this._nextVertexStart;
        geometryInfo.reservedVertexCount = reservedVertexCount === -1 ? geometry.getAttribute('position').count : reservedVertexCount;
        const index = geometry.getIndex();
        const hasIndex = index !== null;
        if (hasIndex) {
            geometryInfo.indexStart = this._nextIndexStart;
            geometryInfo.reservedIndexCount = reservedIndexCount === -1 ? index.count : reservedIndexCount;
        }
        if (geometryInfo.indexStart !== -1 && geometryInfo.indexStart + geometryInfo.reservedIndexCount > this._maxIndexCount || geometryInfo.vertexStart + geometryInfo.reservedVertexCount > this._maxVertexCount) throw new Error('THREE.BatchedMesh: Reserved space request exceeds the maximum buffer size.');
        // update id
        let geometryId;
        if (this._availableGeometryIds.length > 0) {
            this._availableGeometryIds.sort($9ddd7e9b53f7a2d4$var$ascIdSort);
            geometryId = this._availableGeometryIds.shift();
            geometryInfoList[geometryId] = geometryInfo;
        } else {
            geometryId = this._geometryCount;
            this._geometryCount++;
            geometryInfoList.push(geometryInfo);
        }
        // update the geometry
        this.setGeometryAt(geometryId, geometry);
        // increment the next geometry position
        this._nextIndexStart = geometryInfo.indexStart + geometryInfo.reservedIndexCount;
        this._nextVertexStart = geometryInfo.vertexStart + geometryInfo.reservedVertexCount;
        return geometryId;
    }
    /**
	 * Replaces the geometry at the given ID with the provided geometry. Throws an error if there
	 * is not enough space reserved for geometry. Calling this will change all instances that are
	 * rendering that geometry.
	 *
	 * @param {number} geometryId - The ID of the geometry that should be replaced with the given geometry.
	 * @param {BufferGeometry} geometry - The new geometry.
	 * @return {number} The geometry ID.
	 */ setGeometryAt(geometryId, geometry) {
        if (geometryId >= this._geometryCount) throw new Error('THREE.BatchedMesh: Maximum geometry count reached.');
        this._validateGeometry(geometry);
        const batchGeometry = this.geometry;
        const hasIndex = batchGeometry.getIndex() !== null;
        const dstIndex = batchGeometry.getIndex();
        const srcIndex = geometry.getIndex();
        const geometryInfo = this._geometryInfo[geometryId];
        if (hasIndex && srcIndex.count > geometryInfo.reservedIndexCount || geometry.attributes.position.count > geometryInfo.reservedVertexCount) throw new Error('THREE.BatchedMesh: Reserved space not large enough for provided geometry.');
        // copy geometry buffer data over
        const vertexStart = geometryInfo.vertexStart;
        const reservedVertexCount = geometryInfo.reservedVertexCount;
        geometryInfo.vertexCount = geometry.getAttribute('position').count;
        for(const attributeName in batchGeometry.attributes){
            // copy attribute data
            const srcAttribute = geometry.getAttribute(attributeName);
            const dstAttribute = batchGeometry.getAttribute(attributeName);
            $9ddd7e9b53f7a2d4$var$copyAttributeData(srcAttribute, dstAttribute, vertexStart);
            // fill the rest in with zeroes
            const itemSize = srcAttribute.itemSize;
            for(let i = srcAttribute.count, l = reservedVertexCount; i < l; i++){
                const index = vertexStart + i;
                for(let c = 0; c < itemSize; c++)dstAttribute.setComponent(index, c, 0);
            }
            dstAttribute.needsUpdate = true;
            dstAttribute.addUpdateRange(vertexStart * itemSize, reservedVertexCount * itemSize);
        }
        // copy index
        if (hasIndex) {
            const indexStart = geometryInfo.indexStart;
            const reservedIndexCount = geometryInfo.reservedIndexCount;
            geometryInfo.indexCount = geometry.getIndex().count;
            // copy index data over
            for(let i = 0; i < srcIndex.count; i++)dstIndex.setX(indexStart + i, vertexStart + srcIndex.getX(i));
            // fill the rest in with zeroes
            for(let i = srcIndex.count, l = reservedIndexCount; i < l; i++)dstIndex.setX(indexStart + i, vertexStart);
            dstIndex.needsUpdate = true;
            dstIndex.addUpdateRange(indexStart, geometryInfo.reservedIndexCount);
        }
        // update the draw range
        geometryInfo.start = hasIndex ? geometryInfo.indexStart : geometryInfo.vertexStart;
        geometryInfo.count = hasIndex ? geometryInfo.indexCount : geometryInfo.vertexCount;
        // store the bounding boxes
        geometryInfo.boundingBox = null;
        if (geometry.boundingBox !== null) geometryInfo.boundingBox = geometry.boundingBox.clone();
        geometryInfo.boundingSphere = null;
        if (geometry.boundingSphere !== null) geometryInfo.boundingSphere = geometry.boundingSphere.clone();
        this._visibilityChanged = true;
        return geometryId;
    }
    /**
	 * Deletes the geometry defined by the given ID from this batch. Any instances referencing
	 * this geometry will also be removed as a side effect.
	 *
	 * @param {number} geometryId - The ID of the geometry to remove from the batch.
	 * @return {BatchedMesh} A reference to this batched mesh.
	 */ deleteGeometry(geometryId) {
        const geometryInfoList = this._geometryInfo;
        if (geometryId >= geometryInfoList.length || geometryInfoList[geometryId].active === false) return this;
        // delete any instances associated with this geometry
        const instanceInfo = this._instanceInfo;
        for(let i = 0, l = instanceInfo.length; i < l; i++)if (instanceInfo[i].active && instanceInfo[i].geometryIndex === geometryId) this.deleteInstance(i);
        geometryInfoList[geometryId].active = false;
        this._availableGeometryIds.push(geometryId);
        this._visibilityChanged = true;
        return this;
    }
    /**
	 * Deletes an existing instance from the batch using the given ID.
	 *
	 * @param {number} instanceId - The ID of the instance to remove from the batch.
	 * @return {BatchedMesh} A reference to this batched mesh.
	 */ deleteInstance(instanceId) {
        this.validateInstanceId(instanceId);
        this._instanceInfo[instanceId].active = false;
        this._availableInstanceIds.push(instanceId);
        this._visibilityChanged = true;
        return this;
    }
    /**
	 * Repacks the sub geometries in [name] to remove any unused space remaining from
	 * previously deleted geometry, freeing up space to add new geometry.
	 *
	 * @param {number} instanceId - The ID of the instance to remove from the batch.
	 * @return {BatchedMesh} A reference to this batched mesh.
	 */ optimize() {
        // track the next indices to copy data to
        let nextVertexStart = 0;
        let nextIndexStart = 0;
        // Iterate over all geometry ranges in order sorted from earliest in the geometry buffer to latest
        // in the geometry buffer. Because draw range objects can be reused there is no guarantee of their order.
        const geometryInfoList = this._geometryInfo;
        const indices = geometryInfoList.map((e, i)=>i).sort((a, b)=>{
            return geometryInfoList[a].vertexStart - geometryInfoList[b].vertexStart;
        });
        const geometry = this.geometry;
        for(let i = 0, l = geometryInfoList.length; i < l; i++){
            // if a geometry range is inactive then don't copy anything
            const index = indices[i];
            const geometryInfo = geometryInfoList[index];
            if (geometryInfo.active === false) continue;
            // if a geometry contains an index buffer then shift it, as well
            if (geometry.index !== null) {
                if (geometryInfo.indexStart !== nextIndexStart) {
                    const { indexStart: indexStart, vertexStart: vertexStart, reservedIndexCount: reservedIndexCount } = geometryInfo;
                    const index = geometry.index;
                    const array = index.array;
                    // shift the index pointers based on how the vertex data will shift
                    // adjusting the index must happen first so the original vertex start value is available
                    const elementDelta = nextVertexStart - vertexStart;
                    for(let j = indexStart; j < indexStart + reservedIndexCount; j++)array[j] = array[j] + elementDelta;
                    index.array.copyWithin(nextIndexStart, indexStart, indexStart + reservedIndexCount);
                    index.addUpdateRange(nextIndexStart, reservedIndexCount);
                    geometryInfo.indexStart = nextIndexStart;
                }
                nextIndexStart += geometryInfo.reservedIndexCount;
            }
            // if a geometry needs to be moved then copy attribute data to overwrite unused space
            if (geometryInfo.vertexStart !== nextVertexStart) {
                const { vertexStart: vertexStart, reservedVertexCount: reservedVertexCount } = geometryInfo;
                const attributes = geometry.attributes;
                for(const key in attributes){
                    const attribute = attributes[key];
                    const { array: array, itemSize: itemSize } = attribute;
                    array.copyWithin(nextVertexStart * itemSize, vertexStart * itemSize, (vertexStart + reservedVertexCount) * itemSize);
                    attribute.addUpdateRange(nextVertexStart * itemSize, reservedVertexCount * itemSize);
                }
                geometryInfo.vertexStart = nextVertexStart;
            }
            nextVertexStart += geometryInfo.reservedVertexCount;
            geometryInfo.start = geometry.index ? geometryInfo.indexStart : geometryInfo.vertexStart;
            // step the next geometry points to the shifted position
            this._nextIndexStart = geometry.index ? geometryInfo.indexStart + geometryInfo.reservedIndexCount : 0;
            this._nextVertexStart = geometryInfo.vertexStart + geometryInfo.reservedVertexCount;
        }
        return this;
    }
    /**
	 * Returns the bounding box for the given geometry.
	 *
	 * @param {number} geometryId - The ID of the geometry to return the bounding box for.
	 * @param {Box3} target - The target object that is used to store the method's result.
	 * @return {Box3|null} The geometry's bounding box. Returns `null` if no geometry has been found for the given ID.
	 */ getBoundingBoxAt(geometryId, target) {
        if (geometryId >= this._geometryCount) return null;
        // compute bounding box
        const geometry = this.geometry;
        const geometryInfo = this._geometryInfo[geometryId];
        if (geometryInfo.boundingBox === null) {
            const box = new $9ddd7e9b53f7a2d4$export$6f7d5a9418ab2aa3();
            const index = geometry.index;
            const position = geometry.attributes.position;
            for(let i = geometryInfo.start, l = geometryInfo.start + geometryInfo.count; i < l; i++){
                let iv = i;
                if (index) iv = index.getX(iv);
                box.expandByPoint($9ddd7e9b53f7a2d4$var$_vector$5.fromBufferAttribute(position, iv));
            }
            geometryInfo.boundingBox = box;
        }
        target.copy(geometryInfo.boundingBox);
        return target;
    }
    /**
	 * Returns the bounding sphere for the given geometry.
	 *
	 * @param {number} geometryId - The ID of the geometry to return the bounding sphere for.
	 * @param {Sphere} target - The target object that is used to store the method's result.
	 * @return {Sphere|null} The geometry's bounding sphere. Returns `null` if no geometry has been found for the given ID.
	 */ getBoundingSphereAt(geometryId, target) {
        if (geometryId >= this._geometryCount) return null;
        // compute bounding sphere
        const geometry = this.geometry;
        const geometryInfo = this._geometryInfo[geometryId];
        if (geometryInfo.boundingSphere === null) {
            const sphere = new $9ddd7e9b53f7a2d4$export$805e8b72413ccaba();
            this.getBoundingBoxAt(geometryId, $9ddd7e9b53f7a2d4$var$_box$1);
            $9ddd7e9b53f7a2d4$var$_box$1.getCenter(sphere.center);
            const index = geometry.index;
            const position = geometry.attributes.position;
            let maxRadiusSq = 0;
            for(let i = geometryInfo.start, l = geometryInfo.start + geometryInfo.count; i < l; i++){
                let iv = i;
                if (index) iv = index.getX(iv);
                $9ddd7e9b53f7a2d4$var$_vector$5.fromBufferAttribute(position, iv);
                maxRadiusSq = Math.max(maxRadiusSq, sphere.center.distanceToSquared($9ddd7e9b53f7a2d4$var$_vector$5));
            }
            sphere.radius = Math.sqrt(maxRadiusSq);
            geometryInfo.boundingSphere = sphere;
        }
        target.copy(geometryInfo.boundingSphere);
        return target;
    }
    /**
	 * Sets the given local transformation matrix to the defined instance.
	 * Negatively scaled matrices are not supported.
	 *
	 * @param {number} instanceId - The ID of an instance to set the matrix of.
	 * @param {Matrix4} matrix - A 4x4 matrix representing the local transformation of a single instance.
	 * @return {BatchedMesh} A reference to this batched mesh.
	 */ setMatrixAt(instanceId, matrix) {
        this.validateInstanceId(instanceId);
        const matricesTexture = this._matricesTexture;
        const matricesArray = this._matricesTexture.image.data;
        matrix.toArray(matricesArray, instanceId * 16);
        matricesTexture.needsUpdate = true;
        return this;
    }
    /**
	 * Returns the local transformation matrix of the defined instance.
	 *
	 * @param {number} instanceId - The ID of an instance to get the matrix of.
	 * @param {Matrix4} matrix - The target object that is used to store the method's result.
	 * @return {Matrix4} The instance's local transformation matrix.
	 */ getMatrixAt(instanceId, matrix) {
        this.validateInstanceId(instanceId);
        return matrix.fromArray(this._matricesTexture.image.data, instanceId * 16);
    }
    /**
	 * Sets the given color to the defined instance.
	 *
	 * @param {number} instanceId - The ID of an instance to set the color of.
	 * @param {Color} color - The color to set the instance to.
	 * @return {BatchedMesh} A reference to this batched mesh.
	 */ setColorAt(instanceId, color) {
        this.validateInstanceId(instanceId);
        if (this._colorsTexture === null) this._initColorsTexture();
        color.toArray(this._colorsTexture.image.data, instanceId * 4);
        this._colorsTexture.needsUpdate = true;
        return this;
    }
    /**
	 * Returns the color of the defined instance.
	 *
	 * @param {number} instanceId - The ID of an instance to get the color of.
	 * @param {Color} color - The target object that is used to store the method's result.
	 * @return {Color} The instance's color.
	 */ getColorAt(instanceId, color) {
        this.validateInstanceId(instanceId);
        return color.fromArray(this._colorsTexture.image.data, instanceId * 4);
    }
    /**
	 * Sets the visibility of the instance.
	 *
	 * @param {number} instanceId - The id of the instance to set the visibility of.
	 * @param {boolean} visible - Whether the instance is visible or not.
	 * @return {BatchedMesh} A reference to this batched mesh.
	 */ setVisibleAt(instanceId, visible) {
        this.validateInstanceId(instanceId);
        if (this._instanceInfo[instanceId].visible === visible) return this;
        this._instanceInfo[instanceId].visible = visible;
        this._visibilityChanged = true;
        return this;
    }
    /**
	 * Returns the visibility state of the defined instance.
	 *
	 * @param {number} instanceId - The ID of an instance to get the visibility state of.
	 * @return {boolean} Whether the instance is visible or not.
	 */ getVisibleAt(instanceId) {
        this.validateInstanceId(instanceId);
        return this._instanceInfo[instanceId].visible;
    }
    /**
	 * Sets the geometry ID of the instance at the given index.
	 *
	 * @param {number} instanceId - The ID of the instance to set the geometry ID of.
	 * @param {number} geometryId - The geometry ID to be use by the instance.
	 * @return {BatchedMesh} A reference to this batched mesh.
	 */ setGeometryIdAt(instanceId, geometryId) {
        this.validateInstanceId(instanceId);
        this.validateGeometryId(geometryId);
        this._instanceInfo[instanceId].geometryIndex = geometryId;
        return this;
    }
    /**
	 * Returns the geometry ID of the defined instance.
	 *
	 * @param {number} instanceId - The ID of an instance to get the geometry ID of.
	 * @return {number} The instance's geometry ID.
	 */ getGeometryIdAt(instanceId) {
        this.validateInstanceId(instanceId);
        return this._instanceInfo[instanceId].geometryIndex;
    }
    /**
	 * Get the range representing the subset of triangles related to the attached geometry,
	 * indicating the starting offset and count, or `null` if invalid.
	 *
	 * @param {number} geometryId - The id of the geometry to get the range of.
	 * @param {Object} [target] - The target object that is used to store the method's result.
	 * @return {{
	 * 	vertexStart:number,vertexCount:number,reservedVertexCount:number,
	 * 	indexStart:number,indexCount:number,reservedIndexCount:number,
	 * 	start:number,count:number
	 * }} The result object with range data.
	 */ getGeometryRangeAt(geometryId, target = {}) {
        this.validateGeometryId(geometryId);
        const geometryInfo = this._geometryInfo[geometryId];
        target.vertexStart = geometryInfo.vertexStart;
        target.vertexCount = geometryInfo.vertexCount;
        target.reservedVertexCount = geometryInfo.reservedVertexCount;
        target.indexStart = geometryInfo.indexStart;
        target.indexCount = geometryInfo.indexCount;
        target.reservedIndexCount = geometryInfo.reservedIndexCount;
        target.start = geometryInfo.start;
        target.count = geometryInfo.count;
        return target;
    }
    /**
	 * Resizes the necessary buffers to support the provided number of instances.
	 * If the provided arguments shrink the number of instances but there are not enough
	 * unused Ids at the end of the list then an error is thrown.
	 *
	 * @param {number} maxInstanceCount - The max number of individual instances that can be added and rendered by the batch.
	*/ setInstanceCount(maxInstanceCount) {
        // shrink the available instances as much as possible
        const availableInstanceIds = this._availableInstanceIds;
        const instanceInfo = this._instanceInfo;
        availableInstanceIds.sort($9ddd7e9b53f7a2d4$var$ascIdSort);
        while(availableInstanceIds[availableInstanceIds.length - 1] === instanceInfo.length){
            instanceInfo.pop();
            availableInstanceIds.pop();
        }
        // throw an error if it can't be shrunk to the desired size
        if (maxInstanceCount < instanceInfo.length) throw new Error(`BatchedMesh: Instance ids outside the range ${maxInstanceCount} are being used. Cannot shrink instance count.`);
        // copy the multi draw counts
        const multiDrawCounts = new Int32Array(maxInstanceCount);
        const multiDrawStarts = new Int32Array(maxInstanceCount);
        $9ddd7e9b53f7a2d4$var$copyArrayContents(this._multiDrawCounts, multiDrawCounts);
        $9ddd7e9b53f7a2d4$var$copyArrayContents(this._multiDrawStarts, multiDrawStarts);
        this._multiDrawCounts = multiDrawCounts;
        this._multiDrawStarts = multiDrawStarts;
        this._maxInstanceCount = maxInstanceCount;
        // update texture data for instance sampling
        const indirectTexture = this._indirectTexture;
        const matricesTexture = this._matricesTexture;
        const colorsTexture = this._colorsTexture;
        indirectTexture.dispose();
        this._initIndirectTexture();
        $9ddd7e9b53f7a2d4$var$copyArrayContents(indirectTexture.image.data, this._indirectTexture.image.data);
        matricesTexture.dispose();
        this._initMatricesTexture();
        $9ddd7e9b53f7a2d4$var$copyArrayContents(matricesTexture.image.data, this._matricesTexture.image.data);
        if (colorsTexture) {
            colorsTexture.dispose();
            this._initColorsTexture();
            $9ddd7e9b53f7a2d4$var$copyArrayContents(colorsTexture.image.data, this._colorsTexture.image.data);
        }
    }
    /**
	 * Resizes the available space in the batch's vertex and index buffer attributes to the provided sizes.
	 * If the provided arguments shrink the geometry buffers but there is not enough unused space at the
	 * end of the geometry attributes then an error is thrown.
	 *
	 * @param {number} maxVertexCount - The maximum number of vertices to be used by all unique geometries to resize to.
	 * @param {number} maxIndexCount - The maximum number of indices to be used by all unique geometries to resize to.
	*/ setGeometrySize(maxVertexCount, maxIndexCount) {
        // Check if we can shrink to the requested vertex attribute size
        const validRanges = [
            ...this._geometryInfo
        ].filter((info)=>info.active);
        const requiredVertexLength = Math.max(...validRanges.map((range)=>range.vertexStart + range.reservedVertexCount));
        if (requiredVertexLength > maxVertexCount) throw new Error(`BatchedMesh: Geometry vertex values are being used outside the range ${maxIndexCount}. Cannot shrink further.`);
        // Check if we can shrink to the requested index attribute size
        if (this.geometry.index) {
            const requiredIndexLength = Math.max(...validRanges.map((range)=>range.indexStart + range.reservedIndexCount));
            if (requiredIndexLength > maxIndexCount) throw new Error(`BatchedMesh: Geometry index values are being used outside the range ${maxIndexCount}. Cannot shrink further.`);
        }
        //
        // dispose of the previous geometry
        const oldGeometry = this.geometry;
        oldGeometry.dispose();
        // recreate the geometry needed based on the previous variant
        this._maxVertexCount = maxVertexCount;
        this._maxIndexCount = maxIndexCount;
        if (this._geometryInitialized) {
            this._geometryInitialized = false;
            this.geometry = new $9ddd7e9b53f7a2d4$export$b7be63a67df8959();
            this._initializeGeometry(oldGeometry);
        }
        // copy data from the previous geometry
        const geometry = this.geometry;
        if (oldGeometry.index) $9ddd7e9b53f7a2d4$var$copyArrayContents(oldGeometry.index.array, geometry.index.array);
        for(const key in oldGeometry.attributes)$9ddd7e9b53f7a2d4$var$copyArrayContents(oldGeometry.attributes[key].array, geometry.attributes[key].array);
    }
    raycast(raycaster, intersects) {
        const instanceInfo = this._instanceInfo;
        const geometryInfoList = this._geometryInfo;
        const matrixWorld = this.matrixWorld;
        const batchGeometry = this.geometry;
        // iterate over each geometry
        $9ddd7e9b53f7a2d4$var$_mesh.material = this.material;
        $9ddd7e9b53f7a2d4$var$_mesh.geometry.index = batchGeometry.index;
        $9ddd7e9b53f7a2d4$var$_mesh.geometry.attributes = batchGeometry.attributes;
        if ($9ddd7e9b53f7a2d4$var$_mesh.geometry.boundingBox === null) $9ddd7e9b53f7a2d4$var$_mesh.geometry.boundingBox = new $9ddd7e9b53f7a2d4$export$6f7d5a9418ab2aa3();
        if ($9ddd7e9b53f7a2d4$var$_mesh.geometry.boundingSphere === null) $9ddd7e9b53f7a2d4$var$_mesh.geometry.boundingSphere = new $9ddd7e9b53f7a2d4$export$805e8b72413ccaba();
        for(let i = 0, l = instanceInfo.length; i < l; i++){
            if (!instanceInfo[i].visible || !instanceInfo[i].active) continue;
            const geometryId = instanceInfo[i].geometryIndex;
            const geometryInfo = geometryInfoList[geometryId];
            $9ddd7e9b53f7a2d4$var$_mesh.geometry.setDrawRange(geometryInfo.start, geometryInfo.count);
            // get the intersects
            this.getMatrixAt(i, $9ddd7e9b53f7a2d4$var$_mesh.matrixWorld).premultiply(matrixWorld);
            this.getBoundingBoxAt(geometryId, $9ddd7e9b53f7a2d4$var$_mesh.geometry.boundingBox);
            this.getBoundingSphereAt(geometryId, $9ddd7e9b53f7a2d4$var$_mesh.geometry.boundingSphere);
            $9ddd7e9b53f7a2d4$var$_mesh.raycast(raycaster, $9ddd7e9b53f7a2d4$var$_batchIntersects);
            // add batch id to the intersects
            for(let j = 0, l = $9ddd7e9b53f7a2d4$var$_batchIntersects.length; j < l; j++){
                const intersect = $9ddd7e9b53f7a2d4$var$_batchIntersects[j];
                intersect.object = this;
                intersect.batchId = i;
                intersects.push(intersect);
            }
            $9ddd7e9b53f7a2d4$var$_batchIntersects.length = 0;
        }
        $9ddd7e9b53f7a2d4$var$_mesh.material = null;
        $9ddd7e9b53f7a2d4$var$_mesh.geometry.index = null;
        $9ddd7e9b53f7a2d4$var$_mesh.geometry.attributes = {};
        $9ddd7e9b53f7a2d4$var$_mesh.geometry.setDrawRange(0, Infinity);
    }
    copy(source) {
        super.copy(source);
        this.geometry = source.geometry.clone();
        this.perObjectFrustumCulled = source.perObjectFrustumCulled;
        this.sortObjects = source.sortObjects;
        this.boundingBox = source.boundingBox !== null ? source.boundingBox.clone() : null;
        this.boundingSphere = source.boundingSphere !== null ? source.boundingSphere.clone() : null;
        this._geometryInfo = source._geometryInfo.map((info)=>({
                ...info,
                boundingBox: info.boundingBox !== null ? info.boundingBox.clone() : null,
                boundingSphere: info.boundingSphere !== null ? info.boundingSphere.clone() : null
            }));
        this._instanceInfo = source._instanceInfo.map((info)=>({
                ...info
            }));
        this._maxInstanceCount = source._maxInstanceCount;
        this._maxVertexCount = source._maxVertexCount;
        this._maxIndexCount = source._maxIndexCount;
        this._geometryInitialized = source._geometryInitialized;
        this._geometryCount = source._geometryCount;
        this._multiDrawCounts = source._multiDrawCounts.slice();
        this._multiDrawStarts = source._multiDrawStarts.slice();
        this._matricesTexture = source._matricesTexture.clone();
        this._matricesTexture.image.data = this._matricesTexture.image.data.slice();
        if (this._colorsTexture !== null) {
            this._colorsTexture = source._colorsTexture.clone();
            this._colorsTexture.image.data = this._colorsTexture.image.data.slice();
        }
        return this;
    }
    /**
	 * Frees the GPU-related resources allocated by this instance. Call this
	 * method whenever this instance is no longer used in your app.
	 */ dispose() {
        // Assuming the geometry is not shared with other meshes
        this.geometry.dispose();
        this._matricesTexture.dispose();
        this._matricesTexture = null;
        this._indirectTexture.dispose();
        this._indirectTexture = null;
        if (this._colorsTexture !== null) {
            this._colorsTexture.dispose();
            this._colorsTexture = null;
        }
    }
    onBeforeRender(renderer, scene, camera, geometry, material /*, _group*/ ) {
        // if visibility has not changed and frustum culling and object sorting is not required
        // then skip iterating over all items
        if (!this._visibilityChanged && !this.perObjectFrustumCulled && !this.sortObjects) return;
        // the indexed version of the multi draw function requires specifying the start
        // offset in bytes.
        const index = geometry.getIndex();
        const bytesPerElement = index === null ? 1 : index.array.BYTES_PER_ELEMENT;
        const instanceInfo = this._instanceInfo;
        const multiDrawStarts = this._multiDrawStarts;
        const multiDrawCounts = this._multiDrawCounts;
        const geometryInfoList = this._geometryInfo;
        const perObjectFrustumCulled = this.perObjectFrustumCulled;
        const indirectTexture = this._indirectTexture;
        const indirectArray = indirectTexture.image.data;
        // prepare the frustum in the local frame
        if (perObjectFrustumCulled) {
            $9ddd7e9b53f7a2d4$var$_matrix$1.multiplyMatrices(camera.projectionMatrix, camera.matrixWorldInverse).multiply(this.matrixWorld);
            $9ddd7e9b53f7a2d4$var$_frustum.setFromProjectionMatrix($9ddd7e9b53f7a2d4$var$_matrix$1, renderer.coordinateSystem);
        }
        let multiDrawCount = 0;
        if (this.sortObjects) {
            // get the camera position in the local frame
            $9ddd7e9b53f7a2d4$var$_matrix$1.copy(this.matrixWorld).invert();
            $9ddd7e9b53f7a2d4$var$_vector$5.setFromMatrixPosition(camera.matrixWorld).applyMatrix4($9ddd7e9b53f7a2d4$var$_matrix$1);
            $9ddd7e9b53f7a2d4$var$_forward.set(0, 0, -1).transformDirection(camera.matrixWorld).transformDirection($9ddd7e9b53f7a2d4$var$_matrix$1);
            for(let i = 0, l = instanceInfo.length; i < l; i++)if (instanceInfo[i].visible && instanceInfo[i].active) {
                const geometryId = instanceInfo[i].geometryIndex;
                // get the bounds in world space
                this.getMatrixAt(i, $9ddd7e9b53f7a2d4$var$_matrix$1);
                this.getBoundingSphereAt(geometryId, $9ddd7e9b53f7a2d4$var$_sphere$2).applyMatrix4($9ddd7e9b53f7a2d4$var$_matrix$1);
                // determine whether the batched geometry is within the frustum
                let culled = false;
                if (perObjectFrustumCulled) culled = !$9ddd7e9b53f7a2d4$var$_frustum.intersectsSphere($9ddd7e9b53f7a2d4$var$_sphere$2);
                if (!culled) {
                    // get the distance from camera used for sorting
                    const geometryInfo = geometryInfoList[geometryId];
                    const z = $9ddd7e9b53f7a2d4$var$_temp.subVectors($9ddd7e9b53f7a2d4$var$_sphere$2.center, $9ddd7e9b53f7a2d4$var$_vector$5).dot($9ddd7e9b53f7a2d4$var$_forward);
                    $9ddd7e9b53f7a2d4$var$_renderList.push(geometryInfo.start, geometryInfo.count, z, i);
                }
            }
            // Sort the draw ranges and prep for rendering
            const list = $9ddd7e9b53f7a2d4$var$_renderList.list;
            const customSort = this.customSort;
            if (customSort === null) list.sort(material.transparent ? $9ddd7e9b53f7a2d4$var$sortTransparent : $9ddd7e9b53f7a2d4$var$sortOpaque);
            else customSort.call(this, list, camera);
            for(let i = 0, l = list.length; i < l; i++){
                const item = list[i];
                multiDrawStarts[multiDrawCount] = item.start * bytesPerElement;
                multiDrawCounts[multiDrawCount] = item.count;
                indirectArray[multiDrawCount] = item.index;
                multiDrawCount++;
            }
            $9ddd7e9b53f7a2d4$var$_renderList.reset();
        } else {
            for(let i = 0, l = instanceInfo.length; i < l; i++)if (instanceInfo[i].visible && instanceInfo[i].active) {
                const geometryId = instanceInfo[i].geometryIndex;
                // determine whether the batched geometry is within the frustum
                let culled = false;
                if (perObjectFrustumCulled) {
                    // get the bounds in world space
                    this.getMatrixAt(i, $9ddd7e9b53f7a2d4$var$_matrix$1);
                    this.getBoundingSphereAt(geometryId, $9ddd7e9b53f7a2d4$var$_sphere$2).applyMatrix4($9ddd7e9b53f7a2d4$var$_matrix$1);
                    culled = !$9ddd7e9b53f7a2d4$var$_frustum.intersectsSphere($9ddd7e9b53f7a2d4$var$_sphere$2);
                }
                if (!culled) {
                    const geometryInfo = geometryInfoList[geometryId];
                    multiDrawStarts[multiDrawCount] = geometryInfo.start * bytesPerElement;
                    multiDrawCounts[multiDrawCount] = geometryInfo.count;
                    indirectArray[multiDrawCount] = i;
                    multiDrawCount++;
                }
            }
        }
        indirectTexture.needsUpdate = true;
        this._multiDrawCount = multiDrawCount;
        this._visibilityChanged = false;
    }
    onBeforeShadow(renderer, object, camera, shadowCamera, geometry, depthMaterial /* , group */ ) {
        this.onBeforeRender(renderer, null, shadowCamera, geometry, depthMaterial);
    }
}
/**
 * A material for rendering line primitives.
 *
 * Materials define the appearance of renderable 3D objects.
 *
 * ```js
 * const material = new THREE.LineBasicMaterial( { color: 0xffffff } );
 * ```
 *
 * @augments Material
 */ class $9ddd7e9b53f7a2d4$export$fbaaa33907730a0c extends $9ddd7e9b53f7a2d4$export$a2d8b23205c25948 {
    /**
	 * Constructs a new line basic material.
	 *
	 * @param {Object} [parameters] - An object with one or more properties
	 * defining the material's appearance. Any property of the material
	 * (including any property from inherited materials) can be passed
	 * in here. Color values can be passed any type of value accepted
	 * by {@link Color#set}.
	 */ constructor(parameters){
        super();
        /**
		 * This flag can be used for type testing.
		 *
		 * @type {boolean}
		 * @readonly
		 * @default true
		 */ this.isLineBasicMaterial = true;
        this.type = 'LineBasicMaterial';
        /**
		 * Color of the material.
		 *
		 * @type {Color}
		 * @default (1,1,1)
		 */ this.color = new $9ddd7e9b53f7a2d4$export$892596cec99bc70e(0xffffff);
        /**
		 * Sets the color of the lines using data from a texture. The texture map
		 * color is modulated by the diffuse `color`.
		 *
		 * @type {?Texture}
		 * @default null
		 */ this.map = null;
        /**
		 * Controls line thickness or lines.
		 *
		 * Can only be used with {@link SVGRenderer}. WebGL and WebGPU
		 * ignore this setting and always render line primitives with a
		 * width of one pixel.
		 *
		 * @type {number}
		 * @default 1
		 */ this.linewidth = 1;
        /**
		 * Defines appearance of line ends.
		 *
		 * Can only be used with {@link SVGRenderer}.
		 *
		 * @type {('butt'|'round'|'square')}
		 * @default 'round'
		 */ this.linecap = 'round';
        /**
		 * Defines appearance of line joints.
		 *
		 * Can only be used with {@link SVGRenderer}.
		 *
		 * @type {('round'|'bevel'|'miter')}
		 * @default 'round'
		 */ this.linejoin = 'round';
        /**
		 * Whether the material is affected by fog or not.
		 *
		 * @type {boolean}
		 * @default true
		 */ this.fog = true;
        this.setValues(parameters);
    }
    copy(source) {
        super.copy(source);
        this.color.copy(source.color);
        this.map = source.map;
        this.linewidth = source.linewidth;
        this.linecap = source.linecap;
        this.linejoin = source.linejoin;
        this.fog = source.fog;
        return this;
    }
}
const $9ddd7e9b53f7a2d4$var$_vStart = /*@__PURE__*/ new $9ddd7e9b53f7a2d4$export$64b5c384219d3699();
const $9ddd7e9b53f7a2d4$var$_vEnd = /*@__PURE__*/ new $9ddd7e9b53f7a2d4$export$64b5c384219d3699();
const $9ddd7e9b53f7a2d4$var$_inverseMatrix$1 = /*@__PURE__*/ new $9ddd7e9b53f7a2d4$export$2ae72fc923e5eb5();
const $9ddd7e9b53f7a2d4$var$_ray$1 = /*@__PURE__*/ new $9ddd7e9b53f7a2d4$export$a186db52eed6d40e();
const $9ddd7e9b53f7a2d4$var$_sphere$1 = /*@__PURE__*/ new $9ddd7e9b53f7a2d4$export$805e8b72413ccaba();
const $9ddd7e9b53f7a2d4$var$_intersectPointOnRay = /*@__PURE__*/ new $9ddd7e9b53f7a2d4$export$64b5c384219d3699();
const $9ddd7e9b53f7a2d4$var$_intersectPointOnSegment = /*@__PURE__*/ new $9ddd7e9b53f7a2d4$export$64b5c384219d3699();
/**
 * A continuous line. The line are rendered by connecting consecutive
 * vertices with straight lines.
 *
 * ```js
 * const material = new THREE.LineBasicMaterial( { color: 0x0000ff } );
 *
 * const points = [];
 * points.push( new THREE.Vector3( - 10, 0, 0 ) );
 * points.push( new THREE.Vector3( 0, 10, 0 ) );
 * points.push( new THREE.Vector3( 10, 0, 0 ) );
 *
 * const geometry = new THREE.BufferGeometry().setFromPoints( points );
 *
 * const line = new THREE.Line( geometry, material );
 * scene.add( line );
 * ```
 *
 * @augments Object3D
 */ class $9ddd7e9b53f7a2d4$export$17d680238e50603e extends $9ddd7e9b53f7a2d4$export$e4dd07dff30cc924 {
    /**
	 * Constructs a new line.
	 *
	 * @param {BufferGeometry} [geometry] - The line geometry.
	 * @param {Material|Array<Material>} [material] - The line material.
	 */ constructor(geometry = new $9ddd7e9b53f7a2d4$export$b7be63a67df8959(), material = new $9ddd7e9b53f7a2d4$export$fbaaa33907730a0c()){
        super();
        /**
		 * This flag can be used for type testing.
		 *
		 * @type {boolean}
		 * @readonly
		 * @default true
		 */ this.isLine = true;
        this.type = 'Line';
        /**
		 * The line geometry.
		 *
		 * @type {BufferGeometry}
		 */ this.geometry = geometry;
        /**
		 * The line material.
		 *
		 * @type {Material|Array<Material>}
		 * @default LineBasicMaterial
		 */ this.material = material;
        /**
		 * A dictionary representing the morph targets in the geometry. The key is the
		 * morph targets name, the value its attribute index. This member is `undefined`
		 * by default and only set when morph targets are detected in the geometry.
		 *
		 * @type {Object<String,number>|undefined}
		 * @default undefined
		 */ this.morphTargetDictionary = undefined;
        /**
		 * An array of weights typically in the range `[0,1]` that specify how much of the morph
		 * is applied. This member is `undefined` by default and only set when morph targets are
		 * detected in the geometry.
		 *
		 * @type {Array<number>|undefined}
		 * @default undefined
		 */ this.morphTargetInfluences = undefined;
        this.updateMorphTargets();
    }
    copy(source, recursive) {
        super.copy(source, recursive);
        this.material = Array.isArray(source.material) ? source.material.slice() : source.material;
        this.geometry = source.geometry;
        return this;
    }
    /**
	 * Computes an array of distance values which are necessary for rendering dashed lines.
	 * For each vertex in the geometry, the method calculates the cumulative length from the
	 * current point to the very beginning of the line.
	 *
	 * @return {Line} A reference to this line.
	 */ computeLineDistances() {
        const geometry = this.geometry;
        // we assume non-indexed geometry
        if (geometry.index === null) {
            const positionAttribute = geometry.attributes.position;
            const lineDistances = [
                0
            ];
            for(let i = 1, l = positionAttribute.count; i < l; i++){
                $9ddd7e9b53f7a2d4$var$_vStart.fromBufferAttribute(positionAttribute, i - 1);
                $9ddd7e9b53f7a2d4$var$_vEnd.fromBufferAttribute(positionAttribute, i);
                lineDistances[i] = lineDistances[i - 1];
                lineDistances[i] += $9ddd7e9b53f7a2d4$var$_vStart.distanceTo($9ddd7e9b53f7a2d4$var$_vEnd);
            }
            geometry.setAttribute('lineDistance', new $9ddd7e9b53f7a2d4$export$cbe7a62641830ebd(lineDistances, 1));
        } else console.warn('THREE.Line.computeLineDistances(): Computation only possible with non-indexed BufferGeometry.');
        return this;
    }
    /**
	 * Computes intersection points between a casted ray and this line.
	 *
	 * @param {Raycaster} raycaster - The raycaster.
	 * @param {Array<Object>} intersects - The target array that holds the intersection points.
	 */ raycast(raycaster, intersects) {
        const geometry = this.geometry;
        const matrixWorld = this.matrixWorld;
        const threshold = raycaster.params.Line.threshold;
        const drawRange = geometry.drawRange;
        // Checking boundingSphere distance to ray
        if (geometry.boundingSphere === null) geometry.computeBoundingSphere();
        $9ddd7e9b53f7a2d4$var$_sphere$1.copy(geometry.boundingSphere);
        $9ddd7e9b53f7a2d4$var$_sphere$1.applyMatrix4(matrixWorld);
        $9ddd7e9b53f7a2d4$var$_sphere$1.radius += threshold;
        if (raycaster.ray.intersectsSphere($9ddd7e9b53f7a2d4$var$_sphere$1) === false) return;
        //
        $9ddd7e9b53f7a2d4$var$_inverseMatrix$1.copy(matrixWorld).invert();
        $9ddd7e9b53f7a2d4$var$_ray$1.copy(raycaster.ray).applyMatrix4($9ddd7e9b53f7a2d4$var$_inverseMatrix$1);
        const localThreshold = threshold / ((this.scale.x + this.scale.y + this.scale.z) / 3);
        const localThresholdSq = localThreshold * localThreshold;
        const step = this.isLineSegments ? 2 : 1;
        const index = geometry.index;
        const attributes = geometry.attributes;
        const positionAttribute = attributes.position;
        if (index !== null) {
            const start = Math.max(0, drawRange.start);
            const end = Math.min(index.count, drawRange.start + drawRange.count);
            for(let i = start, l = end - 1; i < l; i += step){
                const a = index.getX(i);
                const b = index.getX(i + 1);
                const intersect = $9ddd7e9b53f7a2d4$var$checkIntersection(this, raycaster, $9ddd7e9b53f7a2d4$var$_ray$1, localThresholdSq, a, b, i);
                if (intersect) intersects.push(intersect);
            }
            if (this.isLineLoop) {
                const a = index.getX(end - 1);
                const b = index.getX(start);
                const intersect = $9ddd7e9b53f7a2d4$var$checkIntersection(this, raycaster, $9ddd7e9b53f7a2d4$var$_ray$1, localThresholdSq, a, b, end - 1);
                if (intersect) intersects.push(intersect);
            }
        } else {
            const start = Math.max(0, drawRange.start);
            const end = Math.min(positionAttribute.count, drawRange.start + drawRange.count);
            for(let i = start, l = end - 1; i < l; i += step){
                const intersect = $9ddd7e9b53f7a2d4$var$checkIntersection(this, raycaster, $9ddd7e9b53f7a2d4$var$_ray$1, localThresholdSq, i, i + 1, i);
                if (intersect) intersects.push(intersect);
            }
            if (this.isLineLoop) {
                const intersect = $9ddd7e9b53f7a2d4$var$checkIntersection(this, raycaster, $9ddd7e9b53f7a2d4$var$_ray$1, localThresholdSq, end - 1, start, end - 1);
                if (intersect) intersects.push(intersect);
            }
        }
    }
    /**
	 * Sets the values of {@link Line#morphTargetDictionary} and {@link Line#morphTargetInfluences}
	 * to make sure existing morph targets can influence this 3D object.
	 */ updateMorphTargets() {
        const geometry = this.geometry;
        const morphAttributes = geometry.morphAttributes;
        const keys = Object.keys(morphAttributes);
        if (keys.length > 0) {
            const morphAttribute = morphAttributes[keys[0]];
            if (morphAttribute !== undefined) {
                this.morphTargetInfluences = [];
                this.morphTargetDictionary = {};
                for(let m = 0, ml = morphAttribute.length; m < ml; m++){
                    const name = morphAttribute[m].name || String(m);
                    this.morphTargetInfluences.push(0);
                    this.morphTargetDictionary[name] = m;
                }
            }
        }
    }
}
function $9ddd7e9b53f7a2d4$var$checkIntersection(object, raycaster, ray, thresholdSq, a, b, i) {
    const positionAttribute = object.geometry.attributes.position;
    $9ddd7e9b53f7a2d4$var$_vStart.fromBufferAttribute(positionAttribute, a);
    $9ddd7e9b53f7a2d4$var$_vEnd.fromBufferAttribute(positionAttribute, b);
    const distSq = ray.distanceSqToSegment($9ddd7e9b53f7a2d4$var$_vStart, $9ddd7e9b53f7a2d4$var$_vEnd, $9ddd7e9b53f7a2d4$var$_intersectPointOnRay, $9ddd7e9b53f7a2d4$var$_intersectPointOnSegment);
    if (distSq > thresholdSq) return;
    $9ddd7e9b53f7a2d4$var$_intersectPointOnRay.applyMatrix4(object.matrixWorld); // Move back to world space for distance calculation
    const distance = raycaster.ray.origin.distanceTo($9ddd7e9b53f7a2d4$var$_intersectPointOnRay);
    if (distance < raycaster.near || distance > raycaster.far) return;
    return {
        distance: distance,
        // What do we want? intersection point on the ray or on the segment??
        // point: raycaster.ray.at( distance ),
        point: $9ddd7e9b53f7a2d4$var$_intersectPointOnSegment.clone().applyMatrix4(object.matrixWorld),
        index: i,
        face: null,
        faceIndex: null,
        barycoord: null,
        object: object
    };
}
const $9ddd7e9b53f7a2d4$var$_start = /*@__PURE__*/ new $9ddd7e9b53f7a2d4$export$64b5c384219d3699();
const $9ddd7e9b53f7a2d4$var$_end = /*@__PURE__*/ new $9ddd7e9b53f7a2d4$export$64b5c384219d3699();
/**
 * A series of lines drawn between pairs of vertices.
 *
 * @augments Line
 */ class $9ddd7e9b53f7a2d4$export$ff1ed10fedfdd604 extends $9ddd7e9b53f7a2d4$export$17d680238e50603e {
    /**
	 * Constructs a new line segments.
	 *
	 * @param {BufferGeometry} [geometry] - The line geometry.
	 * @param {Material|Array<Material>} [material] - The line material.
	 */ constructor(geometry, material){
        super(geometry, material);
        /**
		 * This flag can be used for type testing.
		 *
		 * @type {boolean}
		 * @readonly
		 * @default true
		 */ this.isLineSegments = true;
        this.type = 'LineSegments';
    }
    computeLineDistances() {
        const geometry = this.geometry;
        // we assume non-indexed geometry
        if (geometry.index === null) {
            const positionAttribute = geometry.attributes.position;
            const lineDistances = [];
            for(let i = 0, l = positionAttribute.count; i < l; i += 2){
                $9ddd7e9b53f7a2d4$var$_start.fromBufferAttribute(positionAttribute, i);
                $9ddd7e9b53f7a2d4$var$_end.fromBufferAttribute(positionAttribute, i + 1);
                lineDistances[i] = i === 0 ? 0 : lineDistances[i - 1];
                lineDistances[i + 1] = lineDistances[i] + $9ddd7e9b53f7a2d4$var$_start.distanceTo($9ddd7e9b53f7a2d4$var$_end);
            }
            geometry.setAttribute('lineDistance', new $9ddd7e9b53f7a2d4$export$cbe7a62641830ebd(lineDistances, 1));
        } else console.warn('THREE.LineSegments.computeLineDistances(): Computation only possible with non-indexed BufferGeometry.');
        return this;
    }
}
/**
 * A continuous line. This is nearly the same as {@link Line} the only difference
 * is that the last vertex is connected with the first vertex in order to close
 * the line to form a loop.
 *
 * @augments Line
 */ class $9ddd7e9b53f7a2d4$export$f85a24d745e4f17d extends $9ddd7e9b53f7a2d4$export$17d680238e50603e {
    /**
	 * Constructs a new line loop.
	 *
	 * @param {BufferGeometry} [geometry] - The line geometry.
	 * @param {Material|Array<Material>} [material] - The line material.
	 */ constructor(geometry, material){
        super(geometry, material);
        /**
		 * This flag can be used for type testing.
		 *
		 * @type {boolean}
		 * @readonly
		 * @default true
		 */ this.isLineLoop = true;
        this.type = 'LineLoop';
    }
}
/**
 * A material for rendering point primitives.
 *
 * Materials define the appearance of renderable 3D objects.
 *
 * ```js
 * const vertices = [];
 *
 * for ( let i = 0; i < 10000; i ++ ) {
 * 	const x = THREE.MathUtils.randFloatSpread( 2000 );
 * 	const y = THREE.MathUtils.randFloatSpread( 2000 );
 * 	const z = THREE.MathUtils.randFloatSpread( 2000 );
 *
 * 	vertices.push( x, y, z );
 * }
 *
 * const geometry = new THREE.BufferGeometry();
 * geometry.setAttribute( 'position', new THREE.Float32BufferAttribute( vertices, 3 ) );
 * const material = new THREE.PointsMaterial( { color: 0x888888 } );
 * const points = new THREE.Points( geometry, material );
 * scene.add( points );
 * ```
 *
 * @augments Material
 */ class $9ddd7e9b53f7a2d4$export$a178c45366ce5d6b extends $9ddd7e9b53f7a2d4$export$a2d8b23205c25948 {
    /**
	 * Constructs a new points material.
	 *
	 * @param {Object} [parameters] - An object with one or more properties
	 * defining the material's appearance. Any property of the material
	 * (including any property from inherited materials) can be passed
	 * in here. Color values can be passed any type of value accepted
	 * by {@link Color#set}.
	 */ constructor(parameters){
        super();
        /**
		 * This flag can be used for type testing.
		 *
		 * @type {boolean}
		 * @readonly
		 * @default true
		 */ this.isPointsMaterial = true;
        this.type = 'PointsMaterial';
        /**
		 * Color of the material.
		 *
		 * @type {Color}
		 * @default (1,1,1)
		 */ this.color = new $9ddd7e9b53f7a2d4$export$892596cec99bc70e(0xffffff);
        /**
		 * The color map. May optionally include an alpha channel, typically combined
		 * with {@link Material#transparent} or {@link Material#alphaTest}. The texture map
		 * color is modulated by the diffuse `color`.
		 *
		 * @type {?Texture}
		 * @default null
		 */ this.map = null;
        /**
		 * The alpha map is a grayscale texture that controls the opacity across the
		 * surface (black: fully transparent; white: fully opaque).
		 *
		 * Only the color of the texture is used, ignoring the alpha channel if one
		 * exists. For RGB and RGBA textures, the renderer will use the green channel
		 * when sampling this texture due to the extra bit of precision provided for
		 * green in DXT-compressed and uncompressed RGB 565 formats. Luminance-only and
		 * luminance/alpha textures will also still work as expected.
		 *
		 * @type {?Texture}
		 * @default null
		 */ this.alphaMap = null;
        /**
		 * Defines the size of the points in pixels.
		 *
		 * Might be capped if the value exceeds hardware dependent parameters like [gl.ALIASED_POINT_SIZE_RANGE]{@link https://developer.mozilla.org/en-US/docs/Web/API/WebGLRenderingContext/getParamete}.
		 *
		 * @type {number}
		 * @default 1
		 */ this.size = 1;
        /**
		 * Specifies whether size of individual points is attenuated by the camera depth (perspective camera only).
		 *
		 * @type {boolean}
		 * @default true
		 */ this.sizeAttenuation = true;
        /**
		 * Whether the material is affected by fog or not.
		 *
		 * @type {boolean}
		 * @default true
		 */ this.fog = true;
        this.setValues(parameters);
    }
    copy(source) {
        super.copy(source);
        this.color.copy(source.color);
        this.map = source.map;
        this.alphaMap = source.alphaMap;
        this.size = source.size;
        this.sizeAttenuation = source.sizeAttenuation;
        this.fog = source.fog;
        return this;
    }
}
const $9ddd7e9b53f7a2d4$var$_inverseMatrix = /*@__PURE__*/ new $9ddd7e9b53f7a2d4$export$2ae72fc923e5eb5();
const $9ddd7e9b53f7a2d4$var$_ray = /*@__PURE__*/ new $9ddd7e9b53f7a2d4$export$a186db52eed6d40e();
const $9ddd7e9b53f7a2d4$var$_sphere = /*@__PURE__*/ new $9ddd7e9b53f7a2d4$export$805e8b72413ccaba();
const $9ddd7e9b53f7a2d4$var$_position$2 = /*@__PURE__*/ new $9ddd7e9b53f7a2d4$export$64b5c384219d3699();
/**
 * A class for displaying points or point clouds.
 *
 * @augments Object3D
 */ class $9ddd7e9b53f7a2d4$export$1c787534cb11aa3e extends $9ddd7e9b53f7a2d4$export$e4dd07dff30cc924 {
    /**
	 * Constructs a new point cloud.
	 *
	 * @param {BufferGeometry} [geometry] - The points geometry.
	 * @param {Material|Array<Material>} [material] - The points material.
	 */ constructor(geometry = new $9ddd7e9b53f7a2d4$export$b7be63a67df8959(), material = new $9ddd7e9b53f7a2d4$export$a178c45366ce5d6b()){
        super();
        /**
		 * This flag can be used for type testing.
		 *
		 * @type {boolean}
		 * @readonly
		 * @default true
		 */ this.isPoints = true;
        this.type = 'Points';
        /**
		 * The points geometry.
		 *
		 * @type {BufferGeometry}
		 */ this.geometry = geometry;
        /**
		 * The line material.
		 *
		 * @type {Material|Array<Material>}
		 * @default PointsMaterial
		 */ this.material = material;
        /**
		 * A dictionary representing the morph targets in the geometry. The key is the
		 * morph targets name, the value its attribute index. This member is `undefined`
		 * by default and only set when morph targets are detected in the geometry.
		 *
		 * @type {Object<String,number>|undefined}
		 * @default undefined
		 */ this.morphTargetDictionary = undefined;
        /**
		 * An array of weights typically in the range `[0,1]` that specify how much of the morph
		 * is applied. This member is `undefined` by default and only set when morph targets are
		 * detected in the geometry.
		 *
		 * @type {Array<number>|undefined}
		 * @default undefined
		 */ this.morphTargetInfluences = undefined;
        this.updateMorphTargets();
    }
    copy(source, recursive) {
        super.copy(source, recursive);
        this.material = Array.isArray(source.material) ? source.material.slice() : source.material;
        this.geometry = source.geometry;
        return this;
    }
    /**
	 * Computes intersection points between a casted ray and this point cloud.
	 *
	 * @param {Raycaster} raycaster - The raycaster.
	 * @param {Array<Object>} intersects - The target array that holds the intersection points.
	 */ raycast(raycaster, intersects) {
        const geometry = this.geometry;
        const matrixWorld = this.matrixWorld;
        const threshold = raycaster.params.Points.threshold;
        const drawRange = geometry.drawRange;
        // Checking boundingSphere distance to ray
        if (geometry.boundingSphere === null) geometry.computeBoundingSphere();
        $9ddd7e9b53f7a2d4$var$_sphere.copy(geometry.boundingSphere);
        $9ddd7e9b53f7a2d4$var$_sphere.applyMatrix4(matrixWorld);
        $9ddd7e9b53f7a2d4$var$_sphere.radius += threshold;
        if (raycaster.ray.intersectsSphere($9ddd7e9b53f7a2d4$var$_sphere) === false) return;
        //
        $9ddd7e9b53f7a2d4$var$_inverseMatrix.copy(matrixWorld).invert();
        $9ddd7e9b53f7a2d4$var$_ray.copy(raycaster.ray).applyMatrix4($9ddd7e9b53f7a2d4$var$_inverseMatrix);
        const localThreshold = threshold / ((this.scale.x + this.scale.y + this.scale.z) / 3);
        const localThresholdSq = localThreshold * localThreshold;
        const index = geometry.index;
        const attributes = geometry.attributes;
        const positionAttribute = attributes.position;
        if (index !== null) {
            const start = Math.max(0, drawRange.start);
            const end = Math.min(index.count, drawRange.start + drawRange.count);
            for(let i = start, il = end; i < il; i++){
                const a = index.getX(i);
                $9ddd7e9b53f7a2d4$var$_position$2.fromBufferAttribute(positionAttribute, a);
                $9ddd7e9b53f7a2d4$var$testPoint($9ddd7e9b53f7a2d4$var$_position$2, a, localThresholdSq, matrixWorld, raycaster, intersects, this);
            }
        } else {
            const start = Math.max(0, drawRange.start);
            const end = Math.min(positionAttribute.count, drawRange.start + drawRange.count);
            for(let i = start, l = end; i < l; i++){
                $9ddd7e9b53f7a2d4$var$_position$2.fromBufferAttribute(positionAttribute, i);
                $9ddd7e9b53f7a2d4$var$testPoint($9ddd7e9b53f7a2d4$var$_position$2, i, localThresholdSq, matrixWorld, raycaster, intersects, this);
            }
        }
    }
    /**
	 * Sets the values of {@link Points#morphTargetDictionary} and {@link Points#morphTargetInfluences}
	 * to make sure existing morph targets can influence this 3D object.
	 */ updateMorphTargets() {
        const geometry = this.geometry;
        const morphAttributes = geometry.morphAttributes;
        const keys = Object.keys(morphAttributes);
        if (keys.length > 0) {
            const morphAttribute = morphAttributes[keys[0]];
            if (morphAttribute !== undefined) {
                this.morphTargetInfluences = [];
                this.morphTargetDictionary = {};
                for(let m = 0, ml = morphAttribute.length; m < ml; m++){
                    const name = morphAttribute[m].name || String(m);
                    this.morphTargetInfluences.push(0);
                    this.morphTargetDictionary[name] = m;
                }
            }
        }
    }
}
function $9ddd7e9b53f7a2d4$var$testPoint(point, index, localThresholdSq, matrixWorld, raycaster, intersects, object) {
    const rayPointDistanceSq = $9ddd7e9b53f7a2d4$var$_ray.distanceSqToPoint(point);
    if (rayPointDistanceSq < localThresholdSq) {
        const intersectPoint = new $9ddd7e9b53f7a2d4$export$64b5c384219d3699();
        $9ddd7e9b53f7a2d4$var$_ray.closestPointToPoint(point, intersectPoint);
        intersectPoint.applyMatrix4(matrixWorld);
        const distance = raycaster.ray.origin.distanceTo(intersectPoint);
        if (distance < raycaster.near || distance > raycaster.far) return;
        intersects.push({
            distance: distance,
            distanceToRay: Math.sqrt(rayPointDistanceSq),
            point: intersectPoint,
            index: index,
            face: null,
            faceIndex: null,
            barycoord: null,
            object: object
        });
    }
}
/**
 * A texture for use with a video.
 *
 * ```js
 * // assuming you have created a HTML video element with id="video"
 * const video = document.getElementById( 'video' );
 * const texture = new THREE.VideoTexture( video );
 * ```
 *
 * Note: After the initial use of a texture, its dimensions, format, and type
 * cannot be changed. Instead, call {@link Texture#dispose} on the texture and instantiate a new one.
 *
 * @augments Texture
 */ class $9ddd7e9b53f7a2d4$export$6e09d1edf8d5a25c extends $9ddd7e9b53f7a2d4$export$5431306cf43de24a {
    /**
	 * Constructs a new video texture.
	 *
	 * @param {Video} video - The video element to use as a data source for the texture.
	 * @param {number} [mapping=Texture.DEFAULT_MAPPING] - The texture mapping.
	 * @param {number} [wrapS=ClampToEdgeWrapping] - The wrapS value.
	 * @param {number} [wrapT=ClampToEdgeWrapping] - The wrapT value.
	 * @param {number} [magFilter=LinearFilter] - The mag filter value.
	 * @param {number} [minFilter=LinearFilter] - The min filter value.
	 * @param {number} [format=RGBAFormat] - The texture format.
	 * @param {number} [type=UnsignedByteType] - The texture type.
	 * @param {number} [anisotropy=Texture.DEFAULT_ANISOTROPY] - The anisotropy value.
	 */ constructor(video, mapping, wrapS, wrapT, magFilter = $9ddd7e9b53f7a2d4$export$8a72f490b25c56c8, minFilter = $9ddd7e9b53f7a2d4$export$8a72f490b25c56c8, format, type, anisotropy){
        super(video, mapping, wrapS, wrapT, magFilter, minFilter, format, type, anisotropy);
        /**
		 * This flag can be used for type testing.
		 *
		 * @type {boolean}
		 * @readonly
		 * @default true
		 */ this.isVideoTexture = true;
        /**
		 * Whether to generate mipmaps (if possible) for a texture.
		 *
		 * Overwritten and set to `false` by default.
		 *
		 * @type {boolean}
		 * @default false
		 */ this.generateMipmaps = false;
        const scope = this;
        function updateVideo() {
            scope.needsUpdate = true;
            video.requestVideoFrameCallback(updateVideo);
        }
        if ('requestVideoFrameCallback' in video) video.requestVideoFrameCallback(updateVideo);
    }
    clone() {
        return new this.constructor(this.image).copy(this);
    }
    /**
	 * This method is called automatically by the renderer and sets {@link Texture#needsUpdate}
	 * to `true` every time a new frame is available.
	 *
	 * Only relevant if `requestVideoFrameCallback` is not supported in the browser.
	 */ update() {
        const video = this.image;
        const hasVideoFrameCallback = 'requestVideoFrameCallback' in video;
        if (hasVideoFrameCallback === false && video.readyState >= video.HAVE_CURRENT_DATA) this.needsUpdate = true;
    }
}
/**
 * This class can be used as an alternative way to define video data. Instead of using
 * an instance of `HTMLVideoElement` like with `VideoTexture`, `VideoFrameTexture` expects each frame is
 * defined manually via {@link VideoFrameTexture#setFrame}. A typical use case for this module is when
 * video frames are decoded with the WebCodecs API.
 *
 * ```js
 * const texture = new THREE.VideoFrameTexture();
 * texture.setFrame( frame );
 * ```
 *
 * @augments VideoTexture
 */ class $9ddd7e9b53f7a2d4$export$68498d200b825382 extends $9ddd7e9b53f7a2d4$export$6e09d1edf8d5a25c {
    /**
	 * Constructs a new video frame texture.
	 *
	 * @param {number} [mapping=Texture.DEFAULT_MAPPING] - The texture mapping.
	 * @param {number} [wrapS=ClampToEdgeWrapping] - The wrapS value.
	 * @param {number} [wrapT=ClampToEdgeWrapping] - The wrapT value.
	 * @param {number} [magFilter=LinearFilter] - The mag filter value.
	 * @param {number} [minFilter=LinearFilter] - The min filter value.
	 * @param {number} [format=RGBAFormat] - The texture format.
	 * @param {number} [type=UnsignedByteType] - The texture type.
	 * @param {number} [anisotropy=Texture.DEFAULT_ANISOTROPY] - The anisotropy value.
	 */ constructor(mapping, wrapS, wrapT, magFilter, minFilter, format, type, anisotropy){
        super({}, mapping, wrapS, wrapT, magFilter, minFilter, format, type, anisotropy);
        /**
		 * This flag can be used for type testing.
		 *
		 * @type {boolean}
		 * @readonly
		 * @default true
		 */ this.isVideoFrameTexture = true;
    }
    /**
	 * This method overwritten with an empty implementation since
	 * this type of texture is updated via `setFrame()`.
	 */ update() {}
    clone() {
        return new this.constructor().copy(this); // restoring Texture.clone()
    }
    /**
	 * Sets the current frame of the video. This will automatically update the texture
	 * so the data can be used for rendering.
	 *
	 * @param {VideoFrame} frame - The video frame.
	 */ setFrame(frame) {
        this.image = frame;
        this.needsUpdate = true;
    }
}
/**
 * This class can only be used in combination with `copyFramebufferToTexture()` methods
 * of renderers. It extracts the contents of the current bound framebuffer and provides it
 * as a texture for further usage.
 *
 * ```js
 * const pixelRatio = window.devicePixelRatio;
 * const textureSize = 128 * pixelRatio;
 *
 * const frameTexture = new FramebufferTexture( textureSize, textureSize );
 *
 * // calculate start position for copying part of the frame data
 * const vector = new Vector2();
 * vector.x = ( window.innerWidth * pixelRatio / 2 ) - ( textureSize / 2 );
 * vector.y = ( window.innerHeight * pixelRatio / 2 ) - ( textureSize / 2 );
 *
 * renderer.render( scene, camera );
 *
 * // copy part of the rendered frame into the framebuffer texture
 * renderer.copyFramebufferToTexture( frameTexture, vector );
 * ```
 *
 * @augments Texture
 */ class $9ddd7e9b53f7a2d4$export$9270d786f73ce6fe extends $9ddd7e9b53f7a2d4$export$5431306cf43de24a {
    /**
	 * Constructs a new framebuffer texture.
	 *
	 * @param {number} width - The width of the texture.
	 * @param {number} height - The height of the texture.
	 */ constructor(width, height){
        super({
            width: width,
            height: height
        });
        /**
		 * This flag can be used for type testing.
		 *
		 * @type {boolean}
		 * @readonly
		 * @default true
		 */ this.isFramebufferTexture = true;
        /**
		 * How the texture is sampled when a texel covers more than one pixel.
		 *
		 * Overwritten and set to `NearestFilter` by default to disable filtering.
		 *
		 * @type {(NearestFilter|NearestMipmapNearestFilter|NearestMipmapLinearFilter|LinearFilter|LinearMipmapNearestFilter|LinearMipmapLinearFilter)}
		 * @default NearestFilter
		 */ this.magFilter = $9ddd7e9b53f7a2d4$export$727aa5ec3fe39bf0;
        /**
		 * How the texture is sampled when a texel covers less than one pixel.
		 *
		 * Overwritten and set to `NearestFilter` by default to disable filtering.
		 *
		 * @type {(NearestFilter|NearestMipmapNearestFilter|NearestMipmapLinearFilter|LinearFilter|LinearMipmapNearestFilter|LinearMipmapLinearFilter)}
		 * @default NearestFilter
		 */ this.minFilter = $9ddd7e9b53f7a2d4$export$727aa5ec3fe39bf0;
        /**
		 * Whether to generate mipmaps (if possible) for a texture.
		 *
		 * Overwritten and set to `false` by default.
		 *
		 * @type {boolean}
		 * @default false
		 */ this.generateMipmaps = false;
        this.needsUpdate = true;
    }
}
/**
 * Creates a texture based on data in compressed form.
 *
 * These texture are usually loaded with {@link CompressedTextureLoader}.
 *
 * @augments Texture
 */ class $9ddd7e9b53f7a2d4$export$3466bac9141a5cc4 extends $9ddd7e9b53f7a2d4$export$5431306cf43de24a {
    /**
	 * Constructs a new compressed texture.
	 *
	 * @param {Array<Object>} mipmaps - This array holds for all mipmaps (including the bases mip)
	 * the data and dimensions.
	 * @param {number} width - The width of the texture.
	 * @param {number} height - The height of the texture.
	 * @param {number} [format=RGBAFormat] - The texture format.
	 * @param {number} [type=UnsignedByteType] - The texture type.
	 * @param {number} [mapping=Texture.DEFAULT_MAPPING] - The texture mapping.
	 * @param {number} [wrapS=ClampToEdgeWrapping] - The wrapS value.
	 * @param {number} [wrapT=ClampToEdgeWrapping] - The wrapT value.
	 * @param {number} [magFilter=LinearFilter] - The mag filter value.
	 * @param {number} [minFilter=LinearMipmapLinearFilter] - The min filter value.
	 * @param {number} [anisotropy=Texture.DEFAULT_ANISOTROPY] - The anisotropy value.
	 * @param {string} [colorSpace=NoColorSpace] - The color space.
	 */ constructor(mipmaps, width, height, format, type, mapping, wrapS, wrapT, magFilter, minFilter, anisotropy, colorSpace){
        super(null, mapping, wrapS, wrapT, magFilter, minFilter, format, type, anisotropy, colorSpace);
        /**
		 * This flag can be used for type testing.
		 *
		 * @type {boolean}
		 * @readonly
		 * @default true
		 */ this.isCompressedTexture = true;
        /**
		 * The image property of a compressed texture just defines its dimensions.
		 *
		 * @type {{width:number,height:number}}
		 */ this.image = {
            width: width,
            height: height
        };
        /**
		 * This array holds for all mipmaps (including the bases mip) the data and dimensions.
		 *
		 * @type {Array<Object>}
		 */ this.mipmaps = mipmaps;
        /**
		 * If set to `true`, the texture is flipped along the vertical axis when
		 * uploaded to the GPU.
		 *
		 * Overwritten and set to `false` by default since it is not possible to
		 * flip compressed textures.
		 *
		 * @type {boolean}
		 * @default false
		 * @readonly
		 */ this.flipY = false;
        /**
		 * Whether to generate mipmaps (if possible) for a texture.
		 *
		 * Overwritten and set to `false` by default since it is not
		 * possible to generate mipmaps for compressed data. Mipmaps
		 * must be embedded in the compressed texture file.
		 *
		 * @type {boolean}
		 * @default false
		 * @readonly
		 */ this.generateMipmaps = false;
    }
}
/**
 * Creates a texture 2D array based on data in compressed form.
 *
 * These texture are usually loaded with {@link CompressedTextureLoader}.
 *
 * @augments CompressedTexture
 */ class $9ddd7e9b53f7a2d4$export$5fe6b8e34b274fcb extends $9ddd7e9b53f7a2d4$export$3466bac9141a5cc4 {
    /**
	 * Constructs a new compressed array texture.
	 *
	 * @param {Array<Object>} mipmaps - This array holds for all mipmaps (including the bases mip)
	 * the data and dimensions.
	 * @param {number} width - The width of the texture.
	 * @param {number} height - The height of the texture.
	 * @param {number} depth - The depth of the texture.
	 * @param {number} [format=RGBAFormat] - The min filter value.
	 * @param {number} [type=UnsignedByteType] - The min filter value.
	 */ constructor(mipmaps, width, height, depth, format, type){
        super(mipmaps, width, height, format, type);
        /**
		 * This flag can be used for type testing.
		 *
		 * @type {boolean}
		 * @readonly
		 * @default true
		 */ this.isCompressedArrayTexture = true;
        /**
		 * The image property of a compressed texture just defines its dimensions.
		 *
		 * @name CompressedArrayTexture#image
		 * @type {{width:number,height:number,depth:number}}
		 */ this.image.depth = depth;
        /**
		 * This defines how the texture is wrapped in the depth and corresponds to
		 * *W* in UVW mapping.
		 *
		 * @type {(RepeatWrapping|ClampToEdgeWrapping|MirroredRepeatWrapping)}
		 * @default ClampToEdgeWrapping
		 */ this.wrapR = $9ddd7e9b53f7a2d4$export$9d9334239a5a5e06;
        /**
		 * A set of all layers which need to be updated in the texture.
		 *
		 * @type {Set<number>}
		 */ this.layerUpdates = new Set();
    }
    /**
	 * Describes that a specific layer of the texture needs to be updated.
	 * Normally when {@link Texture#needsUpdate} is set to `true`, the
	 * entire compressed texture array is sent to the GPU. Marking specific
	 * layers will only transmit subsets of all mipmaps associated with a
	 * specific depth in the array which is often much more performant.
	 *
	 * @param {number} layerIndex - The layer index that should be updated.
	 */ addLayerUpdate(layerIndex) {
        this.layerUpdates.add(layerIndex);
    }
    /**
	 * Resets the layer updates registry.
	 */ clearLayerUpdates() {
        this.layerUpdates.clear();
    }
}
/**
 * Creates a cube texture based on data in compressed form.
 *
 * These texture are usually loaded with {@link CompressedTextureLoader}.
 *
 * @augments CompressedTexture
 */ class $9ddd7e9b53f7a2d4$export$d80173634de65bff extends $9ddd7e9b53f7a2d4$export$3466bac9141a5cc4 {
    /**
	 * Constructs a new compressed texture.
	 *
	 * @param {Array<CompressedTexture>} images - An array of compressed textures.
	 * @param {number} [format=RGBAFormat] - The texture format.
	 * @param {number} [type=UnsignedByteType] - The texture type.
	 */ constructor(images, format, type){
        super(undefined, images[0].width, images[0].height, format, type, $9ddd7e9b53f7a2d4$export$8759762a6477f2c4);
        /**
		 * This flag can be used for type testing.
		 *
		 * @type {boolean}
		 * @readonly
		 * @default true
		 */ this.isCompressedCubeTexture = true;
        /**
		 * This flag can be used for type testing.
		 *
		 * @type {boolean}
		 * @readonly
		 * @default true
		 */ this.isCubeTexture = true;
        this.image = images;
    }
}
/**
 * Creates a texture from a canvas element.
 *
 * This is almost the same as the base texture class, except that it sets {@link Texture#needsUpdate}
 * to `true` immediately since a canvas can directly be used for rendering.
 *
 * @augments Texture
 */ class $9ddd7e9b53f7a2d4$export$f7189e49152d1c13 extends $9ddd7e9b53f7a2d4$export$5431306cf43de24a {
    /**
	 * Constructs a new texture.
	 *
	 * @param {HTMLCanvasElement} [canvas] - The HTML canvas element.
	 * @param {number} [mapping=Texture.DEFAULT_MAPPING] - The texture mapping.
	 * @param {number} [wrapS=ClampToEdgeWrapping] - The wrapS value.
	 * @param {number} [wrapT=ClampToEdgeWrapping] - The wrapT value.
	 * @param {number} [magFilter=LinearFilter] - The mag filter value.
	 * @param {number} [minFilter=LinearMipmapLinearFilter] - The min filter value.
	 * @param {number} [format=RGBAFormat] - The texture format.
	 * @param {number} [type=UnsignedByteType] - The texture type.
	 * @param {number} [anisotropy=Texture.DEFAULT_ANISOTROPY] - The anisotropy value.
	 */ constructor(canvas, mapping, wrapS, wrapT, magFilter, minFilter, format, type, anisotropy){
        super(canvas, mapping, wrapS, wrapT, magFilter, minFilter, format, type, anisotropy);
        /**
		 * This flag can be used for type testing.
		 *
		 * @type {boolean}
		 * @readonly
		 * @default true
		 */ this.isCanvasTexture = true;
        this.needsUpdate = true;
    }
}
/**
 * This class can be used to automatically save the depth information of a
 * rendering into a texture.
 *
 * @augments Texture
 */ class $9ddd7e9b53f7a2d4$export$fc830aa069cc8c2f extends $9ddd7e9b53f7a2d4$export$5431306cf43de24a {
    /**
	 * Constructs a new depth texture.
	 *
	 * @param {number} width - The width of the texture.
	 * @param {number} height - The height of the texture.
	 * @param {number} [type=UnsignedIntType] - The texture type.
	 * @param {number} [mapping=Texture.DEFAULT_MAPPING] - The texture mapping.
	 * @param {number} [wrapS=ClampToEdgeWrapping] - The wrapS value.
	 * @param {number} [wrapT=ClampToEdgeWrapping] - The wrapT value.
	 * @param {number} [magFilter=LinearFilter] - The mag filter value.
	 * @param {number} [minFilter=LinearFilter] - The min filter value.
	 * @param {number} [anisotropy=Texture.DEFAULT_ANISOTROPY] - The anisotropy value.
	 * @param {number} [format=DepthFormat] - The texture format.
	 */ constructor(width, height, type = $9ddd7e9b53f7a2d4$export$c3c7fc4518ebba96, mapping, wrapS, wrapT, magFilter = $9ddd7e9b53f7a2d4$export$727aa5ec3fe39bf0, minFilter = $9ddd7e9b53f7a2d4$export$727aa5ec3fe39bf0, anisotropy, format = $9ddd7e9b53f7a2d4$export$c1b6b5136be58045){
        if (format !== $9ddd7e9b53f7a2d4$export$c1b6b5136be58045 && format !== $9ddd7e9b53f7a2d4$export$1e113ac2d0905829) throw new Error('DepthTexture format must be either THREE.DepthFormat or THREE.DepthStencilFormat');
        super(null, mapping, wrapS, wrapT, magFilter, minFilter, format, type, anisotropy);
        /**
		 * This flag can be used for type testing.
		 *
		 * @type {boolean}
		 * @readonly
		 * @default true
		 */ this.isDepthTexture = true;
        /**
		 * The image property of a depth texture just defines its dimensions.
		 *
		 * @type {{width:number,height:number}}
		 */ this.image = {
            width: width,
            height: height
        };
        /**
		 * If set to `true`, the texture is flipped along the vertical axis when
		 * uploaded to the GPU.
		 *
		 * Overwritten and set to `false` by default.
		 *
		 * @type {boolean}
		 * @default false
		 */ this.flipY = false;
        /**
		 * Whether to generate mipmaps (if possible) for a texture.
		 *
		 * Overwritten and set to `false` by default.
		 *
		 * @type {boolean}
		 * @default false
		 */ this.generateMipmaps = false;
        /**
		 * The depth compare function.
		 *
		 * @type {?(NeverCompare|LessCompare|EqualCompare|LessEqualCompare|GreaterCompare|NotEqualCompare|GreaterEqualCompare|AlwaysCompare)}
		 * @default null
		 */ this.compareFunction = null;
    }
    copy(source) {
        super.copy(source);
        this.source = new $9ddd7e9b53f7a2d4$export$1d2df86270c81ecb(Object.assign({}, source.image)); // see #30540
        this.compareFunction = source.compareFunction;
        return this;
    }
    toJSON(meta) {
        const data = super.toJSON(meta);
        if (this.compareFunction !== null) data.compareFunction = this.compareFunction;
        return data;
    }
}
/**
 * An abstract base class for creating an analytic curve object that contains methods
 * for interpolation.
 *
 * @abstract
 */ class $9ddd7e9b53f7a2d4$export$b0e83c3ef8d2db1 {
    /**
	 * Constructs a new curve.
	 */ constructor(){
        /**
		 * The type property is used for detecting the object type
		 * in context of serialization/deserialization.
		 *
		 * @type {string}
		 * @readonly
		 */ this.type = 'Curve';
        /**
		 * This value determines the amount of divisions when calculating the
		 * cumulative segment lengths of a curve via {@link Curve#getLengths}. To ensure
		 * precision when using methods like {@link Curve#getSpacedPoints}, it is
		 * recommended to increase the value of this property if the curve is very large.
		 *
		 * @type {number}
		 * @default 200
		 */ this.arcLengthDivisions = 200;
        /**
		 * Must be set to `true` if the curve parameters have changed.
		 *
		 * @type {boolean}
		 * @default false
		 */ this.needsUpdate = false;
        /**
		 * An internal cache that holds precomputed curve length values.
		 *
		 * @private
		 * @type {?Array<number>}
		 * @default null
		 */ this.cacheArcLengths = null;
    }
    /**
	 * This method returns a vector in 2D or 3D space (depending on the curve definition)
	 * for the given interpolation factor.
	 *
	 * @abstract
	 * @param {number} t - A interpolation factor representing a position on the curve. Must be in the range `[0,1]`.
	 * @param {(Vector2|Vector3)} [optionalTarget] - The optional target vector the result is written to.
	 * @return {(Vector2|Vector3)} The position on the curve. It can be a 2D or 3D vector depending on the curve definition.
	 */ getPoint() {
        console.warn('THREE.Curve: .getPoint() not implemented.');
    }
    /**
	 * This method returns a vector in 2D or 3D space (depending on the curve definition)
	 * for the given interpolation factor. Unlike {@link Curve#getPoint}, this method honors the length
	 * of the curve which equidistant samples.
	 *
	 * @param {number} u - A interpolation factor representing a position on the curve. Must be in the range `[0,1]`.
	 * @param {(Vector2|Vector3)} [optionalTarget] - The optional target vector the result is written to.
	 * @return {(Vector2|Vector3)} The position on the curve. It can be a 2D or 3D vector depending on the curve definition.
	 */ getPointAt(u, optionalTarget) {
        const t = this.getUtoTmapping(u);
        return this.getPoint(t, optionalTarget);
    }
    /**
	 * This method samples the curve via {@link Curve#getPoint} and returns an array of points representing
	 * the curve shape.
	 *
	 * @param {number} [divisions=5] - The number of divisions.
	 * @return {Array<(Vector2|Vector3)>} An array holding the sampled curve values. The number of points is `divisions + 1`.
	 */ getPoints(divisions = 5) {
        const points = [];
        for(let d = 0; d <= divisions; d++)points.push(this.getPoint(d / divisions));
        return points;
    }
    // Get sequence of points using getPointAt( u )
    /**
	 * This method samples the curve via {@link Curve#getPointAt} and returns an array of points representing
	 * the curve shape. Unlike {@link Curve#getPoints}, this method returns equi-spaced points across the entire
	 * curve.
	 *
	 * @param {number} [divisions=5] - The number of divisions.
	 * @return {Array<(Vector2|Vector3)>} An array holding the sampled curve values. The number of points is `divisions + 1`.
	 */ getSpacedPoints(divisions = 5) {
        const points = [];
        for(let d = 0; d <= divisions; d++)points.push(this.getPointAt(d / divisions));
        return points;
    }
    /**
	 * Returns the total arc length of the curve.
	 *
	 * @return {number} The length of the curve.
	 */ getLength() {
        const lengths = this.getLengths();
        return lengths[lengths.length - 1];
    }
    /**
	 * Returns an array of cumulative segment lengths of the curve.
	 *
	 * @param {number} [divisions=this.arcLengthDivisions] - The number of divisions.
	 * @return {Array<number>} An array holding the cumulative segment lengths.
	 */ getLengths(divisions = this.arcLengthDivisions) {
        if (this.cacheArcLengths && this.cacheArcLengths.length === divisions + 1 && !this.needsUpdate) return this.cacheArcLengths;
        this.needsUpdate = false;
        const cache = [];
        let current, last = this.getPoint(0);
        let sum = 0;
        cache.push(0);
        for(let p = 1; p <= divisions; p++){
            current = this.getPoint(p / divisions);
            sum += current.distanceTo(last);
            cache.push(sum);
            last = current;
        }
        this.cacheArcLengths = cache;
        return cache; // { sums: cache, sum: sum }; Sum is in the last element.
    }
    /**
	 * Update the cumulative segment distance cache. The method must be called
	 * every time curve parameters are changed. If an updated curve is part of a
	 * composed curve like {@link CurvePath}, this method must be called on the
	 * composed curve, too.
	 */ updateArcLengths() {
        this.needsUpdate = true;
        this.getLengths();
    }
    /**
	 * Given an interpolation factor in the range `[0,1]`, this method returns an updated
	 * interpolation factor in the same range that can be ued to sample equidistant points
	 * from a curve.
	 *
	 * @param {number} u - The interpolation factor.
	 * @param {?number} distance - An optional distance on the curve.
	 * @return {number} The updated interpolation factor.
	 */ getUtoTmapping(u, distance = null) {
        const arcLengths = this.getLengths();
        let i = 0;
        const il = arcLengths.length;
        let targetArcLength; // The targeted u distance value to get
        if (distance) targetArcLength = distance;
        else targetArcLength = u * arcLengths[il - 1];
        // binary search for the index with largest value smaller than target u distance
        let low = 0, high = il - 1, comparison;
        while(low <= high){
            i = Math.floor(low + (high - low) / 2); // less likely to overflow, though probably not issue here, JS doesn't really have integers, all numbers are floats
            comparison = arcLengths[i] - targetArcLength;
            if (comparison < 0) low = i + 1;
            else if (comparison > 0) high = i - 1;
            else {
                high = i;
                break;
            // DONE
            }
        }
        i = high;
        if (arcLengths[i] === targetArcLength) return i / (il - 1);
        // we could get finer grain at lengths, or use simple interpolation between two points
        const lengthBefore = arcLengths[i];
        const lengthAfter = arcLengths[i + 1];
        const segmentLength = lengthAfter - lengthBefore;
        // determine where we are between the 'before' and 'after' points
        const segmentFraction = (targetArcLength - lengthBefore) / segmentLength;
        // add that fractional amount to t
        const t = (i + segmentFraction) / (il - 1);
        return t;
    }
    /**
	 * Returns a unit vector tangent for the given interpolation factor.
	 * If the derived curve does not implement its tangent derivation,
	 * two points a small delta apart will be used to find its gradient
	 * which seems to give a reasonable approximation.
	 *
	 * @param {number} t - The interpolation factor.
	 * @param {(Vector2|Vector3)} [optionalTarget] - The optional target vector the result is written to.
	 * @return {(Vector2|Vector3)} The tangent vector.
	 */ getTangent(t, optionalTarget) {
        const delta = 0.0001;
        let t1 = t - delta;
        let t2 = t + delta;
        // Capping in case of danger
        if (t1 < 0) t1 = 0;
        if (t2 > 1) t2 = 1;
        const pt1 = this.getPoint(t1);
        const pt2 = this.getPoint(t2);
        const tangent = optionalTarget || (pt1.isVector2 ? new $9ddd7e9b53f7a2d4$export$c977b3e384af9ae1() : new $9ddd7e9b53f7a2d4$export$64b5c384219d3699());
        tangent.copy(pt2).sub(pt1).normalize();
        return tangent;
    }
    /**
	 * Same as {@link Curve#getTangent} but with equidistant samples.
	 *
	 * @param {number} u - The interpolation factor.
	 * @param {(Vector2|Vector3)} [optionalTarget] - The optional target vector the result is written to.
	 * @return {(Vector2|Vector3)} The tangent vector.
	 * @see {@link Curve#getPointAt}
	 */ getTangentAt(u, optionalTarget) {
        const t = this.getUtoTmapping(u);
        return this.getTangent(t, optionalTarget);
    }
    /**
	 * Generates the Frenet Frames. Requires a curve definition in 3D space. Used
	 * in geometries like {@link TubeGeometry} or {@link ExtrudeGeometry}.
	 *
	 * @param {number} segments - The number of segments.
	 * @param {boolean} [closed=false] - Whether the curve is closed or not.
	 * @return {{tangents: Array<Vector3>, normals: Array<Vector3>, binormals: Array<Vector3>}} The Frenet Frames.
	 */ computeFrenetFrames(segments, closed = false) {
        // see http://www.cs.indiana.edu/pub/techreports/TR425.pdf
        const normal = new $9ddd7e9b53f7a2d4$export$64b5c384219d3699();
        const tangents = [];
        const normals = [];
        const binormals = [];
        const vec = new $9ddd7e9b53f7a2d4$export$64b5c384219d3699();
        const mat = new $9ddd7e9b53f7a2d4$export$2ae72fc923e5eb5();
        // compute the tangent vectors for each segment on the curve
        for(let i = 0; i <= segments; i++){
            const u = i / segments;
            tangents[i] = this.getTangentAt(u, new $9ddd7e9b53f7a2d4$export$64b5c384219d3699());
        }
        // select an initial normal vector perpendicular to the first tangent vector,
        // and in the direction of the minimum tangent xyz component
        normals[0] = new $9ddd7e9b53f7a2d4$export$64b5c384219d3699();
        binormals[0] = new $9ddd7e9b53f7a2d4$export$64b5c384219d3699();
        let min = Number.MAX_VALUE;
        const tx = Math.abs(tangents[0].x);
        const ty = Math.abs(tangents[0].y);
        const tz = Math.abs(tangents[0].z);
        if (tx <= min) {
            min = tx;
            normal.set(1, 0, 0);
        }
        if (ty <= min) {
            min = ty;
            normal.set(0, 1, 0);
        }
        if (tz <= min) normal.set(0, 0, 1);
        vec.crossVectors(tangents[0], normal).normalize();
        normals[0].crossVectors(tangents[0], vec);
        binormals[0].crossVectors(tangents[0], normals[0]);
        // compute the slowly-varying normal and binormal vectors for each segment on the curve
        for(let i = 1; i <= segments; i++){
            normals[i] = normals[i - 1].clone();
            binormals[i] = binormals[i - 1].clone();
            vec.crossVectors(tangents[i - 1], tangents[i]);
            if (vec.length() > Number.EPSILON) {
                vec.normalize();
                const theta = Math.acos($9ddd7e9b53f7a2d4$var$clamp(tangents[i - 1].dot(tangents[i]), -1, 1)); // clamp for floating pt errors
                normals[i].applyMatrix4(mat.makeRotationAxis(vec, theta));
            }
            binormals[i].crossVectors(tangents[i], normals[i]);
        }
        // if the curve is closed, postprocess the vectors so the first and last normal vectors are the same
        if (closed === true) {
            let theta = Math.acos($9ddd7e9b53f7a2d4$var$clamp(normals[0].dot(normals[segments]), -1, 1));
            theta /= segments;
            if (tangents[0].dot(vec.crossVectors(normals[0], normals[segments])) > 0) theta = -theta;
            for(let i = 1; i <= segments; i++){
                // twist a little...
                normals[i].applyMatrix4(mat.makeRotationAxis(tangents[i], theta * i));
                binormals[i].crossVectors(tangents[i], normals[i]);
            }
        }
        return {
            tangents: tangents,
            normals: normals,
            binormals: binormals
        };
    }
    /**
	 * Returns a new curve with copied values from this instance.
	 *
	 * @return {Curve} A clone of this instance.
	 */ clone() {
        return new this.constructor().copy(this);
    }
    /**
	 * Copies the values of the given curve to this instance.
	 *
	 * @param {Curve} source - The curve to copy.
	 * @return {Curve} A reference to this curve.
	 */ copy(source) {
        this.arcLengthDivisions = source.arcLengthDivisions;
        return this;
    }
    /**
	 * Serializes the curve into JSON.
	 *
	 * @return {Object} A JSON object representing the serialized curve.
	 * @see {@link ObjectLoader#parse}
	 */ toJSON() {
        const data = {
            metadata: {
                version: 4.6,
                type: 'Curve',
                generator: 'Curve.toJSON'
            }
        };
        data.arcLengthDivisions = this.arcLengthDivisions;
        data.type = this.type;
        return data;
    }
    /**
	 * Deserializes the curve from the given JSON.
	 *
	 * @param {Object} json - The JSON holding the serialized curve.
	 * @return {Curve} A reference to this curve.
	 */ fromJSON(json) {
        this.arcLengthDivisions = json.arcLengthDivisions;
        return this;
    }
}
/**
 * A curve representing an ellipse.
 *
 * ```js
 * const curve = new THREE.EllipseCurve(
 * 	0, 0,
 * 	10, 10,
 * 	0, 2 * Math.PI,
 * 	false,
 * 	0
 * );
 *
 * const points = curve.getPoints( 50 );
 * const geometry = new THREE.BufferGeometry().setFromPoints( points );
 *
 * const material = new THREE.LineBasicMaterial( { color: 0xff0000 } );
 *
 * // Create the final object to add to the scene
 * const ellipse = new THREE.Line( geometry, material );
 * ```
 *
 * @augments Curve
 */ class $9ddd7e9b53f7a2d4$export$3f87a931616cde04 extends $9ddd7e9b53f7a2d4$export$b0e83c3ef8d2db1 {
    /**
	 * Constructs a new ellipse curve.
	 *
	 * @param {number} [aX=0] - The X center of the ellipse.
	 * @param {number} [aY=0] - The Y center of the ellipse.
	 * @param {number} [xRadius=1] - The radius of the ellipse in the x direction.
	 * @param {number} [yRadius=1] - The radius of the ellipse in the y direction.
	 * @param {number} [aStartAngle=0] - The start angle of the curve in radians starting from the positive X axis.
	 * @param {number} [aEndAngle=Math.PI*2] - The end angle of the curve in radians starting from the positive X axis.
	 * @param {boolean} [aClockwise=false] - Whether the ellipse is drawn clockwise or not.
	 * @param {number} [aRotation=0] - The rotation angle of the ellipse in radians, counterclockwise from the positive X axis.
	 */ constructor(aX = 0, aY = 0, xRadius = 1, yRadius = 1, aStartAngle = 0, aEndAngle = Math.PI * 2, aClockwise = false, aRotation = 0){
        super();
        /**
		 * This flag can be used for type testing.
		 *
		 * @type {boolean}
		 * @readonly
		 * @default true
		 */ this.isEllipseCurve = true;
        this.type = 'EllipseCurve';
        /**
		 * The X center of the ellipse.
		 *
		 * @type {number}
		 * @default 0
		 */ this.aX = aX;
        /**
		 * The Y center of the ellipse.
		 *
		 * @type {number}
		 * @default 0
		 */ this.aY = aY;
        /**
		 * The radius of the ellipse in the x direction.
		 * Setting the this value equal to the {@link EllipseCurve#yRadius} will result in a circle.
		 *
		 * @type {number}
		 * @default 1
		 */ this.xRadius = xRadius;
        /**
		 * The radius of the ellipse in the y direction.
		 * Setting the this value equal to the {@link EllipseCurve#xRadius} will result in a circle.
		 *
		 * @type {number}
		 * @default 1
		 */ this.yRadius = yRadius;
        /**
		 * The start angle of the curve in radians starting from the positive X axis.
		 *
		 * @type {number}
		 * @default 0
		 */ this.aStartAngle = aStartAngle;
        /**
		 * The end angle of the curve in radians starting from the positive X axis.
		 *
		 * @type {number}
		 * @default Math.PI*2
		 */ this.aEndAngle = aEndAngle;
        /**
		 * Whether the ellipse is drawn clockwise or not.
		 *
		 * @type {boolean}
		 * @default false
		 */ this.aClockwise = aClockwise;
        /**
		 * The rotation angle of the ellipse in radians, counterclockwise from the positive X axis.
		 *
		 * @type {number}
		 * @default 0
		 */ this.aRotation = aRotation;
    }
    /**
	 * Returns a point on the curve.
	 *
	 * @param {number} t - A interpolation factor representing a position on the curve. Must be in the range `[0,1]`.
	 * @param {Vector2} [optionalTarget] - The optional target vector the result is written to.
	 * @return {Vector2} The position on the curve.
	 */ getPoint(t, optionalTarget = new $9ddd7e9b53f7a2d4$export$c977b3e384af9ae1()) {
        const point = optionalTarget;
        const twoPi = Math.PI * 2;
        let deltaAngle = this.aEndAngle - this.aStartAngle;
        const samePoints = Math.abs(deltaAngle) < Number.EPSILON;
        // ensures that deltaAngle is 0 .. 2 PI
        while(deltaAngle < 0)deltaAngle += twoPi;
        while(deltaAngle > twoPi)deltaAngle -= twoPi;
        if (deltaAngle < Number.EPSILON) {
            if (samePoints) deltaAngle = 0;
            else deltaAngle = twoPi;
        }
        if (this.aClockwise === true && !samePoints) {
            if (deltaAngle === twoPi) deltaAngle = -twoPi;
            else deltaAngle = deltaAngle - twoPi;
        }
        const angle = this.aStartAngle + t * deltaAngle;
        let x = this.aX + this.xRadius * Math.cos(angle);
        let y = this.aY + this.yRadius * Math.sin(angle);
        if (this.aRotation !== 0) {
            const cos = Math.cos(this.aRotation);
            const sin = Math.sin(this.aRotation);
            const tx = x - this.aX;
            const ty = y - this.aY;
            // Rotate the point about the center of the ellipse.
            x = tx * cos - ty * sin + this.aX;
            y = tx * sin + ty * cos + this.aY;
        }
        return point.set(x, y);
    }
    copy(source) {
        super.copy(source);
        this.aX = source.aX;
        this.aY = source.aY;
        this.xRadius = source.xRadius;
        this.yRadius = source.yRadius;
        this.aStartAngle = source.aStartAngle;
        this.aEndAngle = source.aEndAngle;
        this.aClockwise = source.aClockwise;
        this.aRotation = source.aRotation;
        return this;
    }
    toJSON() {
        const data = super.toJSON();
        data.aX = this.aX;
        data.aY = this.aY;
        data.xRadius = this.xRadius;
        data.yRadius = this.yRadius;
        data.aStartAngle = this.aStartAngle;
        data.aEndAngle = this.aEndAngle;
        data.aClockwise = this.aClockwise;
        data.aRotation = this.aRotation;
        return data;
    }
    fromJSON(json) {
        super.fromJSON(json);
        this.aX = json.aX;
        this.aY = json.aY;
        this.xRadius = json.xRadius;
        this.yRadius = json.yRadius;
        this.aStartAngle = json.aStartAngle;
        this.aEndAngle = json.aEndAngle;
        this.aClockwise = json.aClockwise;
        this.aRotation = json.aRotation;
        return this;
    }
}
/**
 * A curve representing an arc.
 *
 * @augments EllipseCurve
 */ class $9ddd7e9b53f7a2d4$export$b1eedc9aab6300e8 extends $9ddd7e9b53f7a2d4$export$3f87a931616cde04 {
    /**
	 * Constructs a new arc curve.
	 *
	 * @param {number} [aX=0] - The X center of the ellipse.
	 * @param {number} [aY=0] - The Y center of the ellipse.
	 * @param {number} [aRadius=1] - The radius of the ellipse in the x direction.
	 * @param {number} [aStartAngle=0] - The start angle of the curve in radians starting from the positive X axis.
	 * @param {number} [aEndAngle=Math.PI*2] - The end angle of the curve in radians starting from the positive X axis.
	 * @param {boolean} [aClockwise=false] - Whether the ellipse is drawn clockwise or not.
	 */ constructor(aX, aY, aRadius, aStartAngle, aEndAngle, aClockwise){
        super(aX, aY, aRadius, aRadius, aStartAngle, aEndAngle, aClockwise);
        /**
		 * This flag can be used for type testing.
		 *
		 * @type {boolean}
		 * @readonly
		 * @default true
		 */ this.isArcCurve = true;
        this.type = 'ArcCurve';
    }
}
function $9ddd7e9b53f7a2d4$var$CubicPoly() {
    /**
	 * Centripetal CatmullRom Curve - which is useful for avoiding
	* cusps and self-intersections in non-uniform catmull rom curves.
	* http://www.cemyuksel.com/research/catmullrom_param/catmullrom.pdf
	*
	* curve.type accepts centripetal(default), chordal and catmullrom
	* curve.tension is used for catmullrom which defaults to 0.5
	*/ /*
	Based on an optimized c++ solution in
	- http://stackoverflow.com/questions/9489736/catmull-rom-curve-with-no-cusps-and-no-self-intersections/
	- http://ideone.com/NoEbVM

	This CubicPoly class could be used for reusing some variables and calculations,
	but for three.js curve use, it could be possible inlined and flatten into a single function call
	which can be placed in CurveUtils.
	*/ let c0 = 0, c1 = 0, c2 = 0, c3 = 0;
    /*
	 * Compute coefficients for a cubic polynomial
	 *   p(s) = c0 + c1*s + c2*s^2 + c3*s^3
	 * such that
	 *   p(0) = x0, p(1) = x1
	 *  and
	 *   p'(0) = t0, p'(1) = t1.
	 */ function init(x0, x1, t0, t1) {
        c0 = x0;
        c1 = t0;
        c2 = -3 * x0 + 3 * x1 - 2 * t0 - t1;
        c3 = 2 * x0 - 2 * x1 + t0 + t1;
    }
    return {
        initCatmullRom: function(x0, x1, x2, x3, tension) {
            init(x1, x2, tension * (x2 - x0), tension * (x3 - x1));
        },
        initNonuniformCatmullRom: function(x0, x1, x2, x3, dt0, dt1, dt2) {
            // compute tangents when parameterized in [t1,t2]
            let t1 = (x1 - x0) / dt0 - (x2 - x0) / (dt0 + dt1) + (x2 - x1) / dt1;
            let t2 = (x2 - x1) / dt1 - (x3 - x1) / (dt1 + dt2) + (x3 - x2) / dt2;
            // rescale tangents for parametrization in [0,1]
            t1 *= dt1;
            t2 *= dt1;
            init(x1, x2, t1, t2);
        },
        calc: function(t) {
            const t2 = t * t;
            const t3 = t2 * t;
            return c0 + c1 * t + c2 * t2 + c3 * t3;
        }
    };
}
//
const $9ddd7e9b53f7a2d4$var$tmp = /*@__PURE__*/ new $9ddd7e9b53f7a2d4$export$64b5c384219d3699();
const $9ddd7e9b53f7a2d4$var$px = /*@__PURE__*/ new $9ddd7e9b53f7a2d4$var$CubicPoly();
const $9ddd7e9b53f7a2d4$var$py = /*@__PURE__*/ new $9ddd7e9b53f7a2d4$var$CubicPoly();
const $9ddd7e9b53f7a2d4$var$pz = /*@__PURE__*/ new $9ddd7e9b53f7a2d4$var$CubicPoly();
/**
 * A curve representing a Catmull-Rom spline.
 *
 * ```js
 * //Create a closed wavey loop
 * const curve = new THREE.CatmullRomCurve3( [
 * 	new THREE.Vector3( -10, 0, 10 ),
 * 	new THREE.Vector3( -5, 5, 5 ),
 * 	new THREE.Vector3( 0, 0, 0 ),
 * 	new THREE.Vector3( 5, -5, 5 ),
 * 	new THREE.Vector3( 10, 0, 10 )
 * ] );
 *
 * const points = curve.getPoints( 50 );
 * const geometry = new THREE.BufferGeometry().setFromPoints( points );
 *
 * const material = new THREE.LineBasicMaterial( { color: 0xff0000 } );
 *
 * // Create the final object to add to the scene
 * const curveObject = new THREE.Line( geometry, material );
 * ```
 *
 * @augments Curve
 */ class $9ddd7e9b53f7a2d4$export$b9146b27c24b744c extends $9ddd7e9b53f7a2d4$export$b0e83c3ef8d2db1 {
    /**
	 * Constructs a new Catmull-Rom curve.
	 *
	 * @param {Array<Vector3>} [points] - An array of 3D points defining the curve.
	 * @param {boolean} [closed=false] - Whether the curve is closed or not.
	 * @param {('centripetal'|'chordal'|'catmullrom')} [curveType='centripetal'] - The curve type.
	 * @param {number} [tension=0.5] - Tension of the curve.
	 */ constructor(points = [], closed = false, curveType = 'centripetal', tension = 0.5){
        super();
        /**
		 * This flag can be used for type testing.
		 *
		 * @type {boolean}
		 * @readonly
		 * @default true
		 */ this.isCatmullRomCurve3 = true;
        this.type = 'CatmullRomCurve3';
        /**
		 * An array of 3D points defining the curve.
		 *
		 * @type {Array<Vector3>}
		 */ this.points = points;
        /**
		 * Whether the curve is closed or not.
		 *
		 * @type {boolean}
		 * @default false
		 */ this.closed = closed;
        /**
		 * The curve type.
		 *
		 * @type {('centripetal'|'chordal'|'catmullrom')}
		 * @default 'centripetal'
		 */ this.curveType = curveType;
        /**
		 * Tension of the curve.
		 *
		 * @type {number}
		 * @default 0.5
		 */ this.tension = tension;
    }
    /**
	 * Returns a point on the curve.
	 *
	 * @param {number} t - A interpolation factor representing a position on the curve. Must be in the range `[0,1]`.
	 * @param {Vector3} [optionalTarget] - The optional target vector the result is written to.
	 * @return {Vector3} The position on the curve.
	 */ getPoint(t, optionalTarget = new $9ddd7e9b53f7a2d4$export$64b5c384219d3699()) {
        const point = optionalTarget;
        const points = this.points;
        const l = points.length;
        const p = (l - (this.closed ? 0 : 1)) * t;
        let intPoint = Math.floor(p);
        let weight = p - intPoint;
        if (this.closed) intPoint += intPoint > 0 ? 0 : (Math.floor(Math.abs(intPoint) / l) + 1) * l;
        else if (weight === 0 && intPoint === l - 1) {
            intPoint = l - 2;
            weight = 1;
        }
        let p0, p3; // 4 points (p1 & p2 defined below)
        if (this.closed || intPoint > 0) p0 = points[(intPoint - 1) % l];
        else {
            // extrapolate first point
            $9ddd7e9b53f7a2d4$var$tmp.subVectors(points[0], points[1]).add(points[0]);
            p0 = $9ddd7e9b53f7a2d4$var$tmp;
        }
        const p1 = points[intPoint % l];
        const p2 = points[(intPoint + 1) % l];
        if (this.closed || intPoint + 2 < l) p3 = points[(intPoint + 2) % l];
        else {
            // extrapolate last point
            $9ddd7e9b53f7a2d4$var$tmp.subVectors(points[l - 1], points[l - 2]).add(points[l - 1]);
            p3 = $9ddd7e9b53f7a2d4$var$tmp;
        }
        if (this.curveType === 'centripetal' || this.curveType === 'chordal') {
            // init Centripetal / Chordal Catmull-Rom
            const pow = this.curveType === 'chordal' ? 0.5 : 0.25;
            let dt0 = Math.pow(p0.distanceToSquared(p1), pow);
            let dt1 = Math.pow(p1.distanceToSquared(p2), pow);
            let dt2 = Math.pow(p2.distanceToSquared(p3), pow);
            // safety check for repeated points
            if (dt1 < 1e-4) dt1 = 1.0;
            if (dt0 < 1e-4) dt0 = dt1;
            if (dt2 < 1e-4) dt2 = dt1;
            $9ddd7e9b53f7a2d4$var$px.initNonuniformCatmullRom(p0.x, p1.x, p2.x, p3.x, dt0, dt1, dt2);
            $9ddd7e9b53f7a2d4$var$py.initNonuniformCatmullRom(p0.y, p1.y, p2.y, p3.y, dt0, dt1, dt2);
            $9ddd7e9b53f7a2d4$var$pz.initNonuniformCatmullRom(p0.z, p1.z, p2.z, p3.z, dt0, dt1, dt2);
        } else if (this.curveType === 'catmullrom') {
            $9ddd7e9b53f7a2d4$var$px.initCatmullRom(p0.x, p1.x, p2.x, p3.x, this.tension);
            $9ddd7e9b53f7a2d4$var$py.initCatmullRom(p0.y, p1.y, p2.y, p3.y, this.tension);
            $9ddd7e9b53f7a2d4$var$pz.initCatmullRom(p0.z, p1.z, p2.z, p3.z, this.tension);
        }
        point.set($9ddd7e9b53f7a2d4$var$px.calc(weight), $9ddd7e9b53f7a2d4$var$py.calc(weight), $9ddd7e9b53f7a2d4$var$pz.calc(weight));
        return point;
    }
    copy(source) {
        super.copy(source);
        this.points = [];
        for(let i = 0, l = source.points.length; i < l; i++){
            const point = source.points[i];
            this.points.push(point.clone());
        }
        this.closed = source.closed;
        this.curveType = source.curveType;
        this.tension = source.tension;
        return this;
    }
    toJSON() {
        const data = super.toJSON();
        data.points = [];
        for(let i = 0, l = this.points.length; i < l; i++){
            const point = this.points[i];
            data.points.push(point.toArray());
        }
        data.closed = this.closed;
        data.curveType = this.curveType;
        data.tension = this.tension;
        return data;
    }
    fromJSON(json) {
        super.fromJSON(json);
        this.points = [];
        for(let i = 0, l = json.points.length; i < l; i++){
            const point = json.points[i];
            this.points.push(new $9ddd7e9b53f7a2d4$export$64b5c384219d3699().fromArray(point));
        }
        this.closed = json.closed;
        this.curveType = json.curveType;
        this.tension = json.tension;
        return this;
    }
}
// Bezier Curves formulas obtained from: https://en.wikipedia.org/wiki/B%C3%A9zier_curve
/**
 * Computes a point on a Catmull-Rom spline.
 *
 * @param {number} t - The interpolation factor.
 * @param {number} p0 - The first control point.
 * @param {number} p1 - The second control point.
 * @param {number} p2 - The third control point.
 * @param {number} p3 - The fourth control point.
 * @return {number} The calculated point on a Catmull-Rom spline.
 */ function $9ddd7e9b53f7a2d4$var$CatmullRom(t, p0, p1, p2, p3) {
    const v0 = (p2 - p0) * 0.5;
    const v1 = (p3 - p1) * 0.5;
    const t2 = t * t;
    const t3 = t * t2;
    return (2 * p1 - 2 * p2 + v0 + v1) * t3 + (-3 * p1 + 3 * p2 - 2 * v0 - v1) * t2 + v0 * t + p1;
}
//
function $9ddd7e9b53f7a2d4$var$QuadraticBezierP0(t, p) {
    const k = 1 - t;
    return k * k * p;
}
function $9ddd7e9b53f7a2d4$var$QuadraticBezierP1(t, p) {
    return 2 * (1 - t) * t * p;
}
function $9ddd7e9b53f7a2d4$var$QuadraticBezierP2(t, p) {
    return t * t * p;
}
/**
 * Computes a point on a Quadratic Bezier curve.
 *
 * @param {number} t - The interpolation factor.
 * @param {number} p0 - The first control point.
 * @param {number} p1 - The second control point.
 * @param {number} p2 - The third control point.
 * @return {number} The calculated point on a Quadratic Bezier curve.
 */ function $9ddd7e9b53f7a2d4$var$QuadraticBezier(t, p0, p1, p2) {
    return $9ddd7e9b53f7a2d4$var$QuadraticBezierP0(t, p0) + $9ddd7e9b53f7a2d4$var$QuadraticBezierP1(t, p1) + $9ddd7e9b53f7a2d4$var$QuadraticBezierP2(t, p2);
}
//
function $9ddd7e9b53f7a2d4$var$CubicBezierP0(t, p) {
    const k = 1 - t;
    return k * k * k * p;
}
function $9ddd7e9b53f7a2d4$var$CubicBezierP1(t, p) {
    const k = 1 - t;
    return 3 * k * k * t * p;
}
function $9ddd7e9b53f7a2d4$var$CubicBezierP2(t, p) {
    return 3 * (1 - t) * t * t * p;
}
function $9ddd7e9b53f7a2d4$var$CubicBezierP3(t, p) {
    return t * t * t * p;
}
/**
 * Computes a point on a Cubic Bezier curve.
 *
 * @param {number} t - The interpolation factor.
 * @param {number} p0 - The first control point.
 * @param {number} p1 - The second control point.
 * @param {number} p2 - The third control point.
 * @param {number} p3 - The fourth control point.
 * @return {number} The calculated point on a Cubic Bezier curve.
 */ function $9ddd7e9b53f7a2d4$var$CubicBezier(t, p0, p1, p2, p3) {
    return $9ddd7e9b53f7a2d4$var$CubicBezierP0(t, p0) + $9ddd7e9b53f7a2d4$var$CubicBezierP1(t, p1) + $9ddd7e9b53f7a2d4$var$CubicBezierP2(t, p2) + $9ddd7e9b53f7a2d4$var$CubicBezierP3(t, p3);
}
/**
 * A curve representing a 2D Cubic Bezier curve.
 *
 * ```js
 * const curve = new THREE.CubicBezierCurve(
 * 	new THREE.Vector2( - 0, 0 ),
 * 	new THREE.Vector2( - 5, 15 ),
 * 	new THREE.Vector2( 20, 15 ),
 * 	new THREE.Vector2( 10, 0 )
 * );
 *
 * const points = curve.getPoints( 50 );
 * const geometry = new THREE.BufferGeometry().setFromPoints( points );
 *
 * const material = new THREE.LineBasicMaterial( { color: 0xff0000 } );
 *
 * // Create the final object to add to the scene
 * const curveObject = new THREE.Line( geometry, material );
 * ```
 *
 * @augments Curve
 */ class $9ddd7e9b53f7a2d4$export$e36650d36468bb39 extends $9ddd7e9b53f7a2d4$export$b0e83c3ef8d2db1 {
    /**
	 * Constructs a new Cubic Bezier curve.
	 *
	 * @param {Vector2} [v0] - The start point.
	 * @param {Vector2} [v1] - The first control point.
	 * @param {Vector2} [v2] - The second control point.
	 * @param {Vector2} [v3] - The end point.
	 */ constructor(v0 = new $9ddd7e9b53f7a2d4$export$c977b3e384af9ae1(), v1 = new $9ddd7e9b53f7a2d4$export$c977b3e384af9ae1(), v2 = new $9ddd7e9b53f7a2d4$export$c977b3e384af9ae1(), v3 = new $9ddd7e9b53f7a2d4$export$c977b3e384af9ae1()){
        super();
        /**
		 * This flag can be used for type testing.
		 *
		 * @type {boolean}
		 * @readonly
		 * @default true
		 */ this.isCubicBezierCurve = true;
        this.type = 'CubicBezierCurve';
        /**
		 * The start point.
		 *
		 * @type {Vector2}
		 */ this.v0 = v0;
        /**
		 * The first control point.
		 *
		 * @type {Vector2}
		 */ this.v1 = v1;
        /**
		 * The second control point.
		 *
		 * @type {Vector2}
		 */ this.v2 = v2;
        /**
		 * The end point.
		 *
		 * @type {Vector2}
		 */ this.v3 = v3;
    }
    /**
	 * Returns a point on the curve.
	 *
	 * @param {number} t - A interpolation factor representing a position on the curve. Must be in the range `[0,1]`.
	 * @param {Vector2} [optionalTarget] - The optional target vector the result is written to.
	 * @return {Vector2} The position on the curve.
	 */ getPoint(t, optionalTarget = new $9ddd7e9b53f7a2d4$export$c977b3e384af9ae1()) {
        const point = optionalTarget;
        const v0 = this.v0, v1 = this.v1, v2 = this.v2, v3 = this.v3;
        point.set($9ddd7e9b53f7a2d4$var$CubicBezier(t, v0.x, v1.x, v2.x, v3.x), $9ddd7e9b53f7a2d4$var$CubicBezier(t, v0.y, v1.y, v2.y, v3.y));
        return point;
    }
    copy(source) {
        super.copy(source);
        this.v0.copy(source.v0);
        this.v1.copy(source.v1);
        this.v2.copy(source.v2);
        this.v3.copy(source.v3);
        return this;
    }
    toJSON() {
        const data = super.toJSON();
        data.v0 = this.v0.toArray();
        data.v1 = this.v1.toArray();
        data.v2 = this.v2.toArray();
        data.v3 = this.v3.toArray();
        return data;
    }
    fromJSON(json) {
        super.fromJSON(json);
        this.v0.fromArray(json.v0);
        this.v1.fromArray(json.v1);
        this.v2.fromArray(json.v2);
        this.v3.fromArray(json.v3);
        return this;
    }
}
/**
 * A curve representing a 3D Cubic Bezier curve.
 *
 * @augments Curve
 */ class $9ddd7e9b53f7a2d4$export$13d5f1c9525f246c extends $9ddd7e9b53f7a2d4$export$b0e83c3ef8d2db1 {
    /**
	 * Constructs a new Cubic Bezier curve.
	 *
	 * @param {Vector3} [v0] - The start point.
	 * @param {Vector3} [v1] - The first control point.
	 * @param {Vector3} [v2] - The second control point.
	 * @param {Vector3} [v3] - The end point.
	 */ constructor(v0 = new $9ddd7e9b53f7a2d4$export$64b5c384219d3699(), v1 = new $9ddd7e9b53f7a2d4$export$64b5c384219d3699(), v2 = new $9ddd7e9b53f7a2d4$export$64b5c384219d3699(), v3 = new $9ddd7e9b53f7a2d4$export$64b5c384219d3699()){
        super();
        /**
		 * This flag can be used for type testing.
		 *
		 * @type {boolean}
		 * @readonly
		 * @default true
		 */ this.isCubicBezierCurve3 = true;
        this.type = 'CubicBezierCurve3';
        /**
		 * The start point.
		 *
		 * @type {Vector3}
		 */ this.v0 = v0;
        /**
		 * The first control point.
		 *
		 * @type {Vector3}
		 */ this.v1 = v1;
        /**
		 * The second control point.
		 *
		 * @type {Vector3}
		 */ this.v2 = v2;
        /**
		 * The end point.
		 *
		 * @type {Vector3}
		 */ this.v3 = v3;
    }
    /**
	 * Returns a point on the curve.
	 *
	 * @param {number} t - A interpolation factor representing a position on the curve. Must be in the range `[0,1]`.
	 * @param {Vector3} [optionalTarget] - The optional target vector the result is written to.
	 * @return {Vector3} The position on the curve.
	 */ getPoint(t, optionalTarget = new $9ddd7e9b53f7a2d4$export$64b5c384219d3699()) {
        const point = optionalTarget;
        const v0 = this.v0, v1 = this.v1, v2 = this.v2, v3 = this.v3;
        point.set($9ddd7e9b53f7a2d4$var$CubicBezier(t, v0.x, v1.x, v2.x, v3.x), $9ddd7e9b53f7a2d4$var$CubicBezier(t, v0.y, v1.y, v2.y, v3.y), $9ddd7e9b53f7a2d4$var$CubicBezier(t, v0.z, v1.z, v2.z, v3.z));
        return point;
    }
    copy(source) {
        super.copy(source);
        this.v0.copy(source.v0);
        this.v1.copy(source.v1);
        this.v2.copy(source.v2);
        this.v3.copy(source.v3);
        return this;
    }
    toJSON() {
        const data = super.toJSON();
        data.v0 = this.v0.toArray();
        data.v1 = this.v1.toArray();
        data.v2 = this.v2.toArray();
        data.v3 = this.v3.toArray();
        return data;
    }
    fromJSON(json) {
        super.fromJSON(json);
        this.v0.fromArray(json.v0);
        this.v1.fromArray(json.v1);
        this.v2.fromArray(json.v2);
        this.v3.fromArray(json.v3);
        return this;
    }
}
/**
 * A curve representing a 2D line segment.
 *
 * @augments Curve
 */ class $9ddd7e9b53f7a2d4$export$ab2e07e76531a47e extends $9ddd7e9b53f7a2d4$export$b0e83c3ef8d2db1 {
    /**
	 * Constructs a new line curve.
	 *
	 * @param {Vector2} [v1] - The start point.
	 * @param {Vector2} [v2] - The end point.
	 */ constructor(v1 = new $9ddd7e9b53f7a2d4$export$c977b3e384af9ae1(), v2 = new $9ddd7e9b53f7a2d4$export$c977b3e384af9ae1()){
        super();
        /**
		 * This flag can be used for type testing.
		 *
		 * @type {boolean}
		 * @readonly
		 * @default true
		 */ this.isLineCurve = true;
        this.type = 'LineCurve';
        /**
		 * The start point.
		 *
		 * @type {Vector2}
		 */ this.v1 = v1;
        /**
		 * The end point.
		 *
		 * @type {Vector2}
		 */ this.v2 = v2;
    }
    /**
	 * Returns a point on the line.
	 *
	 * @param {number} t - A interpolation factor representing a position on the line. Must be in the range `[0,1]`.
	 * @param {Vector2} [optionalTarget] - The optional target vector the result is written to.
	 * @return {Vector2} The position on the line.
	 */ getPoint(t, optionalTarget = new $9ddd7e9b53f7a2d4$export$c977b3e384af9ae1()) {
        const point = optionalTarget;
        if (t === 1) point.copy(this.v2);
        else {
            point.copy(this.v2).sub(this.v1);
            point.multiplyScalar(t).add(this.v1);
        }
        return point;
    }
    // Line curve is linear, so we can overwrite default getPointAt
    getPointAt(u, optionalTarget) {
        return this.getPoint(u, optionalTarget);
    }
    getTangent(t, optionalTarget = new $9ddd7e9b53f7a2d4$export$c977b3e384af9ae1()) {
        return optionalTarget.subVectors(this.v2, this.v1).normalize();
    }
    getTangentAt(u, optionalTarget) {
        return this.getTangent(u, optionalTarget);
    }
    copy(source) {
        super.copy(source);
        this.v1.copy(source.v1);
        this.v2.copy(source.v2);
        return this;
    }
    toJSON() {
        const data = super.toJSON();
        data.v1 = this.v1.toArray();
        data.v2 = this.v2.toArray();
        return data;
    }
    fromJSON(json) {
        super.fromJSON(json);
        this.v1.fromArray(json.v1);
        this.v2.fromArray(json.v2);
        return this;
    }
}
/**
 * A curve representing a 3D line segment.
 *
 * @augments Curve
 */ class $9ddd7e9b53f7a2d4$export$1fdfd9d9cf487600 extends $9ddd7e9b53f7a2d4$export$b0e83c3ef8d2db1 {
    /**
	 * Constructs a new line curve.
	 *
	 * @param {Vector3} [v1] - The start point.
	 * @param {Vector3} [v2] - The end point.
	 */ constructor(v1 = new $9ddd7e9b53f7a2d4$export$64b5c384219d3699(), v2 = new $9ddd7e9b53f7a2d4$export$64b5c384219d3699()){
        super();
        /**
		 * This flag can be used for type testing.
		 *
		 * @type {boolean}
		 * @readonly
		 * @default true
		 */ this.isLineCurve3 = true;
        this.type = 'LineCurve3';
        /**
		 * The start point.
		 *
		 * @type {Vector3}
		 */ this.v1 = v1;
        /**
		 * The end point.
		 *
		 * @type {Vector2}
		 */ this.v2 = v2;
    }
    /**
	 * Returns a point on the line.
	 *
	 * @param {number} t - A interpolation factor representing a position on the line. Must be in the range `[0,1]`.
	 * @param {Vector3} [optionalTarget] - The optional target vector the result is written to.
	 * @return {Vector3} The position on the line.
	 */ getPoint(t, optionalTarget = new $9ddd7e9b53f7a2d4$export$64b5c384219d3699()) {
        const point = optionalTarget;
        if (t === 1) point.copy(this.v2);
        else {
            point.copy(this.v2).sub(this.v1);
            point.multiplyScalar(t).add(this.v1);
        }
        return point;
    }
    // Line curve is linear, so we can overwrite default getPointAt
    getPointAt(u, optionalTarget) {
        return this.getPoint(u, optionalTarget);
    }
    getTangent(t, optionalTarget = new $9ddd7e9b53f7a2d4$export$64b5c384219d3699()) {
        return optionalTarget.subVectors(this.v2, this.v1).normalize();
    }
    getTangentAt(u, optionalTarget) {
        return this.getTangent(u, optionalTarget);
    }
    copy(source) {
        super.copy(source);
        this.v1.copy(source.v1);
        this.v2.copy(source.v2);
        return this;
    }
    toJSON() {
        const data = super.toJSON();
        data.v1 = this.v1.toArray();
        data.v2 = this.v2.toArray();
        return data;
    }
    fromJSON(json) {
        super.fromJSON(json);
        this.v1.fromArray(json.v1);
        this.v2.fromArray(json.v2);
        return this;
    }
}
/**
 * A curve representing a 2D Quadratic Bezier curve.
 *
 * ```js
 * const curve = new THREE.QuadraticBezierCurve(
 * 	new THREE.Vector2( - 10, 0 ),
 * 	new THREE.Vector2( 20, 15 ),
 * 	new THREE.Vector2( 10, 0 )
 * )
 *
 * const points = curve.getPoints( 50 );
 * const geometry = new THREE.BufferGeometry().setFromPoints( points );
 *
 * const material = new THREE.LineBasicMaterial( { color: 0xff0000 } );
 *
 * // Create the final object to add to the scene
 * const curveObject = new THREE.Line( geometry, material );
 * ```
 *
 * @augments Curve
 */ class $9ddd7e9b53f7a2d4$export$5938c4ee491a43ad extends $9ddd7e9b53f7a2d4$export$b0e83c3ef8d2db1 {
    /**
	 * Constructs a new Quadratic Bezier curve.
	 *
	 * @param {Vector2} [v0] - The start point.
	 * @param {Vector2} [v1] - The control point.
	 * @param {Vector2} [v2] - The end point.
	 */ constructor(v0 = new $9ddd7e9b53f7a2d4$export$c977b3e384af9ae1(), v1 = new $9ddd7e9b53f7a2d4$export$c977b3e384af9ae1(), v2 = new $9ddd7e9b53f7a2d4$export$c977b3e384af9ae1()){
        super();
        /**
		 * This flag can be used for type testing.
		 *
		 * @type {boolean}
		 * @readonly
		 * @default true
		 */ this.isQuadraticBezierCurve = true;
        this.type = 'QuadraticBezierCurve';
        /**
		 * The start point.
		 *
		 * @type {Vector2}
		 */ this.v0 = v0;
        /**
		 * The control point.
		 *
		 * @type {Vector2}
		 */ this.v1 = v1;
        /**
		 * The end point.
		 *
		 * @type {Vector2}
		 */ this.v2 = v2;
    }
    /**
	 * Returns a point on the curve.
	 *
	 * @param {number} t - A interpolation factor representing a position on the curve. Must be in the range `[0,1]`.
	 * @param {Vector2} [optionalTarget] - The optional target vector the result is written to.
	 * @return {Vector2} The position on the curve.
	 */ getPoint(t, optionalTarget = new $9ddd7e9b53f7a2d4$export$c977b3e384af9ae1()) {
        const point = optionalTarget;
        const v0 = this.v0, v1 = this.v1, v2 = this.v2;
        point.set($9ddd7e9b53f7a2d4$var$QuadraticBezier(t, v0.x, v1.x, v2.x), $9ddd7e9b53f7a2d4$var$QuadraticBezier(t, v0.y, v1.y, v2.y));
        return point;
    }
    copy(source) {
        super.copy(source);
        this.v0.copy(source.v0);
        this.v1.copy(source.v1);
        this.v2.copy(source.v2);
        return this;
    }
    toJSON() {
        const data = super.toJSON();
        data.v0 = this.v0.toArray();
        data.v1 = this.v1.toArray();
        data.v2 = this.v2.toArray();
        return data;
    }
    fromJSON(json) {
        super.fromJSON(json);
        this.v0.fromArray(json.v0);
        this.v1.fromArray(json.v1);
        this.v2.fromArray(json.v2);
        return this;
    }
}
/**
 * A curve representing a 3D Quadratic Bezier curve.
 *
 * @augments Curve
 */ class $9ddd7e9b53f7a2d4$export$bf3f4c7e459f90fc extends $9ddd7e9b53f7a2d4$export$b0e83c3ef8d2db1 {
    /**
	 * Constructs a new Quadratic Bezier curve.
	 *
	 * @param {Vector3} [v0] - The start point.
	 * @param {Vector3} [v1] - The control point.
	 * @param {Vector3} [v2] - The end point.
	 */ constructor(v0 = new $9ddd7e9b53f7a2d4$export$64b5c384219d3699(), v1 = new $9ddd7e9b53f7a2d4$export$64b5c384219d3699(), v2 = new $9ddd7e9b53f7a2d4$export$64b5c384219d3699()){
        super();
        /**
		 * This flag can be used for type testing.
		 *
		 * @type {boolean}
		 * @readonly
		 * @default true
		 */ this.isQuadraticBezierCurve3 = true;
        this.type = 'QuadraticBezierCurve3';
        /**
		 * The start point.
		 *
		 * @type {Vector3}
		 */ this.v0 = v0;
        /**
		 * The control point.
		 *
		 * @type {Vector3}
		 */ this.v1 = v1;
        /**
		 * The end point.
		 *
		 * @type {Vector3}
		 */ this.v2 = v2;
    }
    /**
	 * Returns a point on the curve.
	 *
	 * @param {number} t - A interpolation factor representing a position on the curve. Must be in the range `[0,1]`.
	 * @param {Vector3} [optionalTarget] - The optional target vector the result is written to.
	 * @return {Vector3} The position on the curve.
	 */ getPoint(t, optionalTarget = new $9ddd7e9b53f7a2d4$export$64b5c384219d3699()) {
        const point = optionalTarget;
        const v0 = this.v0, v1 = this.v1, v2 = this.v2;
        point.set($9ddd7e9b53f7a2d4$var$QuadraticBezier(t, v0.x, v1.x, v2.x), $9ddd7e9b53f7a2d4$var$QuadraticBezier(t, v0.y, v1.y, v2.y), $9ddd7e9b53f7a2d4$var$QuadraticBezier(t, v0.z, v1.z, v2.z));
        return point;
    }
    copy(source) {
        super.copy(source);
        this.v0.copy(source.v0);
        this.v1.copy(source.v1);
        this.v2.copy(source.v2);
        return this;
    }
    toJSON() {
        const data = super.toJSON();
        data.v0 = this.v0.toArray();
        data.v1 = this.v1.toArray();
        data.v2 = this.v2.toArray();
        return data;
    }
    fromJSON(json) {
        super.fromJSON(json);
        this.v0.fromArray(json.v0);
        this.v1.fromArray(json.v1);
        this.v2.fromArray(json.v2);
        return this;
    }
}
/**
 * A curve representing a 2D spline curve.
 *
 * ```js
 * // Create a sine-like wave
 * const curve = new THREE.SplineCurve( [
 * 	new THREE.Vector2( -10, 0 ),
 * 	new THREE.Vector2( -5, 5 ),
 * 	new THREE.Vector2( 0, 0 ),
 * 	new THREE.Vector2( 5, -5 ),
 * 	new THREE.Vector2( 10, 0 )
 * ] );
 *
 * const points = curve.getPoints( 50 );
 * const geometry = new THREE.BufferGeometry().setFromPoints( points );
 *
 * const material = new THREE.LineBasicMaterial( { color: 0xff0000 } );
 *
 * // Create the final object to add to the scene
 * const splineObject = new THREE.Line( geometry, material );
 * ```
 *
 * @augments Curve
 */ class $9ddd7e9b53f7a2d4$export$d3bdd77da77afc1b extends $9ddd7e9b53f7a2d4$export$b0e83c3ef8d2db1 {
    /**
	 * Constructs a new 2D spline curve.
	 *
	 * @param {Array<Vector2>} [points] -  An array of 2D points defining the curve.
	 */ constructor(points = []){
        super();
        /**
		 * This flag can be used for type testing.
		 *
		 * @type {boolean}
		 * @readonly
		 * @default true
		 */ this.isSplineCurve = true;
        this.type = 'SplineCurve';
        /**
		 * An array of 2D points defining the curve.
		 *
		 * @type {Array<Vector2>}
		 */ this.points = points;
    }
    /**
	 * Returns a point on the curve.
	 *
	 * @param {number} t - A interpolation factor representing a position on the curve. Must be in the range `[0,1]`.
	 * @param {Vector2} [optionalTarget] - The optional target vector the result is written to.
	 * @return {Vector2} The position on the curve.
	 */ getPoint(t, optionalTarget = new $9ddd7e9b53f7a2d4$export$c977b3e384af9ae1()) {
        const point = optionalTarget;
        const points = this.points;
        const p = (points.length - 1) * t;
        const intPoint = Math.floor(p);
        const weight = p - intPoint;
        const p0 = points[intPoint === 0 ? intPoint : intPoint - 1];
        const p1 = points[intPoint];
        const p2 = points[intPoint > points.length - 2 ? points.length - 1 : intPoint + 1];
        const p3 = points[intPoint > points.length - 3 ? points.length - 1 : intPoint + 2];
        point.set($9ddd7e9b53f7a2d4$var$CatmullRom(weight, p0.x, p1.x, p2.x, p3.x), $9ddd7e9b53f7a2d4$var$CatmullRom(weight, p0.y, p1.y, p2.y, p3.y));
        return point;
    }
    copy(source) {
        super.copy(source);
        this.points = [];
        for(let i = 0, l = source.points.length; i < l; i++){
            const point = source.points[i];
            this.points.push(point.clone());
        }
        return this;
    }
    toJSON() {
        const data = super.toJSON();
        data.points = [];
        for(let i = 0, l = this.points.length; i < l; i++){
            const point = this.points[i];
            data.points.push(point.toArray());
        }
        return data;
    }
    fromJSON(json) {
        super.fromJSON(json);
        this.points = [];
        for(let i = 0, l = json.points.length; i < l; i++){
            const point = json.points[i];
            this.points.push(new $9ddd7e9b53f7a2d4$export$c977b3e384af9ae1().fromArray(point));
        }
        return this;
    }
}
var $9ddd7e9b53f7a2d4$var$Curves = /*#__PURE__*/ Object.freeze({
    __proto__: null,
    ArcCurve: $9ddd7e9b53f7a2d4$export$b1eedc9aab6300e8,
    CatmullRomCurve3: $9ddd7e9b53f7a2d4$export$b9146b27c24b744c,
    CubicBezierCurve: $9ddd7e9b53f7a2d4$export$e36650d36468bb39,
    CubicBezierCurve3: $9ddd7e9b53f7a2d4$export$13d5f1c9525f246c,
    EllipseCurve: $9ddd7e9b53f7a2d4$export$3f87a931616cde04,
    LineCurve: $9ddd7e9b53f7a2d4$export$ab2e07e76531a47e,
    LineCurve3: $9ddd7e9b53f7a2d4$export$1fdfd9d9cf487600,
    QuadraticBezierCurve: $9ddd7e9b53f7a2d4$export$5938c4ee491a43ad,
    QuadraticBezierCurve3: $9ddd7e9b53f7a2d4$export$bf3f4c7e459f90fc,
    SplineCurve: $9ddd7e9b53f7a2d4$export$d3bdd77da77afc1b
});
/**
 * A base class extending {@link Curve}. `CurvePath` is simply an
 * array of connected curves, but retains the API of a curve.
 *
 * @augments Curve
 */ class $9ddd7e9b53f7a2d4$export$4aaf9b66af1bbf2c extends $9ddd7e9b53f7a2d4$export$b0e83c3ef8d2db1 {
    /**
	 * Constructs a new curve path.
	 */ constructor(){
        super();
        this.type = 'CurvePath';
        /**
		 * An array of curves defining the
		 * path.
		 *
		 * @type {Array<Curve>}
		 */ this.curves = [];
        /**
		 * Whether the path should automatically be closed
		 * by a line curve.
		 *
		 * @type {boolean}
		 * @default false
		 */ this.autoClose = false;
    }
    /**
	 * Adds a curve to this curve path.
	 *
	 * @param {Curve} curve - The curve to add.
	 */ add(curve) {
        this.curves.push(curve);
    }
    /**
	 * Adds a line curve to close the path.
	 *
	 * @return {CurvePath} A reference to this curve path.
	 */ closePath() {
        // Add a line curve if start and end of lines are not connected
        const startPoint = this.curves[0].getPoint(0);
        const endPoint = this.curves[this.curves.length - 1].getPoint(1);
        if (!startPoint.equals(endPoint)) {
            const lineType = startPoint.isVector2 === true ? 'LineCurve' : 'LineCurve3';
            this.curves.push(new $9ddd7e9b53f7a2d4$var$Curves[lineType](endPoint, startPoint));
        }
        return this;
    }
    /**
	 * This method returns a vector in 2D or 3D space (depending on the curve definitions)
	 * for the given interpolation factor.
	 *
	 * @param {number} t - A interpolation factor representing a position on the curve. Must be in the range `[0,1]`.
	 * @param {(Vector2|Vector3)} [optionalTarget] - The optional target vector the result is written to.
	 * @return {?(Vector2|Vector3)} The position on the curve. It can be a 2D or 3D vector depending on the curve definition.
	 */ getPoint(t, optionalTarget) {
        // To get accurate point with reference to
        // entire path distance at time t,
        // following has to be done:
        // 1. Length of each sub path have to be known
        // 2. Locate and identify type of curve
        // 3. Get t for the curve
        // 4. Return curve.getPointAt(t')
        const d = t * this.getLength();
        const curveLengths = this.getCurveLengths();
        let i = 0;
        // To think about boundaries points.
        while(i < curveLengths.length){
            if (curveLengths[i] >= d) {
                const diff = curveLengths[i] - d;
                const curve = this.curves[i];
                const segmentLength = curve.getLength();
                const u = segmentLength === 0 ? 0 : 1 - diff / segmentLength;
                return curve.getPointAt(u, optionalTarget);
            }
            i++;
        }
        return null;
    // loop where sum != 0, sum > d , sum+1 <d
    }
    getLength() {
        // We cannot use the default THREE.Curve getPoint() with getLength() because in
        // THREE.Curve, getLength() depends on getPoint() but in THREE.CurvePath
        // getPoint() depends on getLength
        const lens = this.getCurveLengths();
        return lens[lens.length - 1];
    }
    updateArcLengths() {
        // cacheLengths must be recalculated.
        this.needsUpdate = true;
        this.cacheLengths = null;
        this.getCurveLengths();
    }
    /**
	 * Returns list of cumulative curve lengths of the defined curves.
	 *
	 * @return {Array<number>} The curve lengths.
	 */ getCurveLengths() {
        // Compute lengths and cache them
        // We cannot overwrite getLengths() because UtoT mapping uses it.
        // We use cache values if curves and cache array are same length
        if (this.cacheLengths && this.cacheLengths.length === this.curves.length) return this.cacheLengths;
        // Get length of sub-curve
        // Push sums into cached array
        const lengths = [];
        let sums = 0;
        for(let i = 0, l = this.curves.length; i < l; i++){
            sums += this.curves[i].getLength();
            lengths.push(sums);
        }
        this.cacheLengths = lengths;
        return lengths;
    }
    getSpacedPoints(divisions = 40) {
        const points = [];
        for(let i = 0; i <= divisions; i++)points.push(this.getPoint(i / divisions));
        if (this.autoClose) points.push(points[0]);
        return points;
    }
    getPoints(divisions = 12) {
        const points = [];
        let last;
        for(let i = 0, curves = this.curves; i < curves.length; i++){
            const curve = curves[i];
            const resolution = curve.isEllipseCurve ? divisions * 2 : curve.isLineCurve || curve.isLineCurve3 ? 1 : curve.isSplineCurve ? divisions * curve.points.length : divisions;
            const pts = curve.getPoints(resolution);
            for(let j = 0; j < pts.length; j++){
                const point = pts[j];
                if (last && last.equals(point)) continue; // ensures no consecutive points are duplicates
                points.push(point);
                last = point;
            }
        }
        if (this.autoClose && points.length > 1 && !points[points.length - 1].equals(points[0])) points.push(points[0]);
        return points;
    }
    copy(source) {
        super.copy(source);
        this.curves = [];
        for(let i = 0, l = source.curves.length; i < l; i++){
            const curve = source.curves[i];
            this.curves.push(curve.clone());
        }
        this.autoClose = source.autoClose;
        return this;
    }
    toJSON() {
        const data = super.toJSON();
        data.autoClose = this.autoClose;
        data.curves = [];
        for(let i = 0, l = this.curves.length; i < l; i++){
            const curve = this.curves[i];
            data.curves.push(curve.toJSON());
        }
        return data;
    }
    fromJSON(json) {
        super.fromJSON(json);
        this.autoClose = json.autoClose;
        this.curves = [];
        for(let i = 0, l = json.curves.length; i < l; i++){
            const curve = json.curves[i];
            this.curves.push(new $9ddd7e9b53f7a2d4$var$Curves[curve.type]().fromJSON(curve));
        }
        return this;
    }
}
/**
 * A 2D path representation. The class provides methods for creating paths
 * and contours of 2D shapes similar to the 2D Canvas API.
 *
 * ```js
 * const path = new THREE.Path();
 *
 * path.lineTo( 0, 0.8 );
 * path.quadraticCurveTo( 0, 1, 0.2, 1 );
 * path.lineTo( 1, 1 );
 *
 * const points = path.getPoints();
 *
 * const geometry = new THREE.BufferGeometry().setFromPoints( points );
 * const material = new THREE.LineBasicMaterial( { color: 0xffffff } );
 *
 * const line = new THREE.Line( geometry, material );
 * scene.add( line );
 * ```
 *
 * @augments CurvePath
 */ class $9ddd7e9b53f7a2d4$export$4b2950bdac9b6ee9 extends $9ddd7e9b53f7a2d4$export$4aaf9b66af1bbf2c {
    /**
	 * Constructs a new path.
	 *
	 * @param {Array<Vector2>} [points] - An array of 2D points defining the path.
	 */ constructor(points){
        super();
        this.type = 'Path';
        /**
		 * The current offset of the path. Any new curve added will start here.
		 *
		 * @type {Vector2}
		 */ this.currentPoint = new $9ddd7e9b53f7a2d4$export$c977b3e384af9ae1();
        if (points) this.setFromPoints(points);
    }
    /**
	 * Creates a path from the given list of points. The points are added
	 * to the path as instances of {@link LineCurve}.
	 *
	 * @param {Array<Vector2>} points - An array of 2D points.
	 * @return {Path} A reference to this path.
	 */ setFromPoints(points) {
        this.moveTo(points[0].x, points[0].y);
        for(let i = 1, l = points.length; i < l; i++)this.lineTo(points[i].x, points[i].y);
        return this;
    }
    /**
	 * Moves {@link Path#currentPoint} to the given point.
	 *
	 * @param {number} x - The x coordinate.
	 * @param {number} y - The y coordinate.
	 * @return {Path} A reference to this path.
	 */ moveTo(x, y) {
        this.currentPoint.set(x, y); // TODO consider referencing vectors instead of copying?
        return this;
    }
    /**
	 * Adds an instance of {@link LineCurve} to the path by connecting
	 * the current point with the given one.
	 *
	 * @param {number} x - The x coordinate of the end point.
	 * @param {number} y - The y coordinate of the end point.
	 * @return {Path} A reference to this path.
	 */ lineTo(x, y) {
        const curve = new $9ddd7e9b53f7a2d4$export$ab2e07e76531a47e(this.currentPoint.clone(), new $9ddd7e9b53f7a2d4$export$c977b3e384af9ae1(x, y));
        this.curves.push(curve);
        this.currentPoint.set(x, y);
        return this;
    }
    /**
	 * Adds an instance of {@link QuadraticBezierCurve} to the path by connecting
	 * the current point with the given one.
	 *
	 * @param {number} aCPx - The x coordinate of the control point.
	 * @param {number} aCPy - The y coordinate of the control point.
	 * @param {number} aX - The x coordinate of the end point.
	 * @param {number} aY - The y coordinate of the end point.
	 * @return {Path} A reference to this path.
	 */ quadraticCurveTo(aCPx, aCPy, aX, aY) {
        const curve = new $9ddd7e9b53f7a2d4$export$5938c4ee491a43ad(this.currentPoint.clone(), new $9ddd7e9b53f7a2d4$export$c977b3e384af9ae1(aCPx, aCPy), new $9ddd7e9b53f7a2d4$export$c977b3e384af9ae1(aX, aY));
        this.curves.push(curve);
        this.currentPoint.set(aX, aY);
        return this;
    }
    /**
	 * Adds an instance of {@link CubicBezierCurve} to the path by connecting
	 * the current point with the given one.
	 *
	 * @param {number} aCP1x - The x coordinate of the first control point.
	 * @param {number} aCP1y - The y coordinate of the first control point.
	 * @param {number} aCP2x - The x coordinate of the second control point.
	 * @param {number} aCP2y - The y coordinate of the second control point.
	 * @param {number} aX - The x coordinate of the end point.
	 * @param {number} aY - The y coordinate of the end point.
	 * @return {Path} A reference to this path.
	 */ bezierCurveTo(aCP1x, aCP1y, aCP2x, aCP2y, aX, aY) {
        const curve = new $9ddd7e9b53f7a2d4$export$e36650d36468bb39(this.currentPoint.clone(), new $9ddd7e9b53f7a2d4$export$c977b3e384af9ae1(aCP1x, aCP1y), new $9ddd7e9b53f7a2d4$export$c977b3e384af9ae1(aCP2x, aCP2y), new $9ddd7e9b53f7a2d4$export$c977b3e384af9ae1(aX, aY));
        this.curves.push(curve);
        this.currentPoint.set(aX, aY);
        return this;
    }
    /**
	 * Adds an instance of {@link SplineCurve} to the path by connecting
	 * the current point with the given list of points.
	 *
	 * @param {Array<Vector2>} pts - An array of points in 2D space.
	 * @return {Path} A reference to this path.
	 */ splineThru(pts) {
        const npts = [
            this.currentPoint.clone()
        ].concat(pts);
        const curve = new $9ddd7e9b53f7a2d4$export$d3bdd77da77afc1b(npts);
        this.curves.push(curve);
        this.currentPoint.copy(pts[pts.length - 1]);
        return this;
    }
    /**
	 * Adds an arc as an instance of {@link EllipseCurve} to the path, positioned relative
	 * to the current point.
	 *
	 * @param {number} aX - The x coordinate of the center of the arc offsetted from the previous curve.
	 * @param {number} aY - The y coordinate of the center of the arc offsetted from the previous curve.
	 * @param {number} aRadius - The radius of the arc.
	 * @param {number} aStartAngle - The start angle in radians.
	 * @param {number} aEndAngle - The end angle in radians.
	 * @param {boolean} [aClockwise=false] - Whether to sweep the arc clockwise or not.
	 * @return {Path} A reference to this path.
	 */ arc(aX, aY, aRadius, aStartAngle, aEndAngle, aClockwise) {
        const x0 = this.currentPoint.x;
        const y0 = this.currentPoint.y;
        this.absarc(aX + x0, aY + y0, aRadius, aStartAngle, aEndAngle, aClockwise);
        return this;
    }
    /**
	 * Adds an absolutely positioned arc as an instance of {@link EllipseCurve} to the path.
	 *
	 * @param {number} aX - The x coordinate of the center of the arc.
	 * @param {number} aY - The y coordinate of the center of the arc.
	 * @param {number} aRadius - The radius of the arc.
	 * @param {number} aStartAngle - The start angle in radians.
	 * @param {number} aEndAngle - The end angle in radians.
	 * @param {boolean} [aClockwise=false] - Whether to sweep the arc clockwise or not.
	 * @return {Path} A reference to this path.
	 */ absarc(aX, aY, aRadius, aStartAngle, aEndAngle, aClockwise) {
        this.absellipse(aX, aY, aRadius, aRadius, aStartAngle, aEndAngle, aClockwise);
        return this;
    }
    /**
	 * Adds an ellipse as an instance of {@link EllipseCurve} to the path, positioned relative
	 * to the current point
	 *
	 * @param {number} aX - The x coordinate of the center of the ellipse offsetted from the previous curve.
	 * @param {number} aY - The y coordinate of the center of the ellipse offsetted from the previous curve.
	 * @param {number} xRadius - The radius of the ellipse in the x axis.
	 * @param {number} yRadius - The radius of the ellipse in the y axis.
	 * @param {number} aStartAngle - The start angle in radians.
	 * @param {number} aEndAngle - The end angle in radians.
	 * @param {boolean} [aClockwise=false] - Whether to sweep the ellipse clockwise or not.
	 * @param {number} [aRotation=0] - The rotation angle of the ellipse in radians, counterclockwise from the positive X axis.
	 * @return {Path} A reference to this path.
	 */ ellipse(aX, aY, xRadius, yRadius, aStartAngle, aEndAngle, aClockwise, aRotation) {
        const x0 = this.currentPoint.x;
        const y0 = this.currentPoint.y;
        this.absellipse(aX + x0, aY + y0, xRadius, yRadius, aStartAngle, aEndAngle, aClockwise, aRotation);
        return this;
    }
    /**
	 * Adds an absolutely positioned ellipse as an instance of {@link EllipseCurve} to the path.
	 *
	 * @param {number} aX - The x coordinate of the absolute center of the ellipse.
	 * @param {number} aY - The y coordinate of the absolute center of the ellipse.
	 * @param {number} xRadius - The radius of the ellipse in the x axis.
	 * @param {number} yRadius - The radius of the ellipse in the y axis.
	 * @param {number} aStartAngle - The start angle in radians.
	 * @param {number} aEndAngle - The end angle in radians.
	 * @param {boolean} [aClockwise=false] - Whether to sweep the ellipse clockwise or not.
	 * @param {number} [aRotation=0] - The rotation angle of the ellipse in radians, counterclockwise from the positive X axis.
	 * @return {Path} A reference to this path.
	 */ absellipse(aX, aY, xRadius, yRadius, aStartAngle, aEndAngle, aClockwise, aRotation) {
        const curve = new $9ddd7e9b53f7a2d4$export$3f87a931616cde04(aX, aY, xRadius, yRadius, aStartAngle, aEndAngle, aClockwise, aRotation);
        if (this.curves.length > 0) {
            // if a previous curve is present, attempt to join
            const firstPoint = curve.getPoint(0);
            if (!firstPoint.equals(this.currentPoint)) this.lineTo(firstPoint.x, firstPoint.y);
        }
        this.curves.push(curve);
        const lastPoint = curve.getPoint(1);
        this.currentPoint.copy(lastPoint);
        return this;
    }
    copy(source) {
        super.copy(source);
        this.currentPoint.copy(source.currentPoint);
        return this;
    }
    toJSON() {
        const data = super.toJSON();
        data.currentPoint = this.currentPoint.toArray();
        return data;
    }
    fromJSON(json) {
        super.fromJSON(json);
        this.currentPoint.fromArray(json.currentPoint);
        return this;
    }
}
/**
 * Creates meshes with axial symmetry like vases. The lathe rotates around the Y axis.
 *
 * ```js
 * const points = [];
 * for ( let i = 0; i < 10; i ++ ) {
 * 	points.push( new THREE.Vector2( Math.sin( i * 0.2 ) * 10 + 5, ( i - 5 ) * 2 ) );
 * }
 * const geometry = new THREE.LatheGeometry( points );
 * const material = new THREE.MeshBasicMaterial( { color: 0xffff00 } );
 * const lathe = new THREE.Mesh( geometry, material );
 * scene.add( lathe );
 * ```
 *
 * @augments BufferGeometry
 */ class $9ddd7e9b53f7a2d4$export$6d839803fcd1882c extends $9ddd7e9b53f7a2d4$export$b7be63a67df8959 {
    /**
	 * Constructs a new lathe geometry.
	 *
	 * @param {Array<Vector2|Vector3>} [points] - An array of points in 2D space. The x-coordinate of each point
	 * must be greater than zero.
	 * @param {number} [segments=12] - The number of circumference segments to generate.
	 * @param {number} [phiStart=0] - The starting angle in radians.
	 * @param {number} [phiLength=Math.PI*2] - The radian (0 to 2PI) range of the lathed section 2PI is a
	 * closed lathe, less than 2PI is a portion.
	 */ constructor(points = [
        new $9ddd7e9b53f7a2d4$export$c977b3e384af9ae1(0, -0.5),
        new $9ddd7e9b53f7a2d4$export$c977b3e384af9ae1(0.5, 0),
        new $9ddd7e9b53f7a2d4$export$c977b3e384af9ae1(0, 0.5)
    ], segments = 12, phiStart = 0, phiLength = Math.PI * 2){
        super();
        this.type = 'LatheGeometry';
        /**
		 * Holds the constructor parameters that have been
		 * used to generate the geometry. Any modification
		 * after instantiation does not change the geometry.
		 *
		 * @type {Object}
		 */ this.parameters = {
            points: points,
            segments: segments,
            phiStart: phiStart,
            phiLength: phiLength
        };
        segments = Math.floor(segments);
        // clamp phiLength so it's in range of [ 0, 2PI ]
        phiLength = $9ddd7e9b53f7a2d4$var$clamp(phiLength, 0, Math.PI * 2);
        // buffers
        const indices = [];
        const vertices = [];
        const uvs = [];
        const initNormals = [];
        const normals = [];
        // helper variables
        const inverseSegments = 1.0 / segments;
        const vertex = new $9ddd7e9b53f7a2d4$export$64b5c384219d3699();
        const uv = new $9ddd7e9b53f7a2d4$export$c977b3e384af9ae1();
        const normal = new $9ddd7e9b53f7a2d4$export$64b5c384219d3699();
        const curNormal = new $9ddd7e9b53f7a2d4$export$64b5c384219d3699();
        const prevNormal = new $9ddd7e9b53f7a2d4$export$64b5c384219d3699();
        let dx = 0;
        let dy = 0;
        // pre-compute normals for initial "meridian"
        for(let j = 0; j <= points.length - 1; j++)switch(j){
            case 0:
                dx = points[j + 1].x - points[j].x;
                dy = points[j + 1].y - points[j].y;
                normal.x = dy * 1.0;
                normal.y = -dx;
                normal.z = dy * 0.0;
                prevNormal.copy(normal);
                normal.normalize();
                initNormals.push(normal.x, normal.y, normal.z);
                break;
            case points.length - 1:
                initNormals.push(prevNormal.x, prevNormal.y, prevNormal.z);
                break;
            default:
                dx = points[j + 1].x - points[j].x;
                dy = points[j + 1].y - points[j].y;
                normal.x = dy * 1.0;
                normal.y = -dx;
                normal.z = dy * 0.0;
                curNormal.copy(normal);
                normal.x += prevNormal.x;
                normal.y += prevNormal.y;
                normal.z += prevNormal.z;
                normal.normalize();
                initNormals.push(normal.x, normal.y, normal.z);
                prevNormal.copy(curNormal);
        }
        // generate vertices, uvs and normals
        for(let i = 0; i <= segments; i++){
            const phi = phiStart + i * inverseSegments * phiLength;
            const sin = Math.sin(phi);
            const cos = Math.cos(phi);
            for(let j = 0; j <= points.length - 1; j++){
                // vertex
                vertex.x = points[j].x * sin;
                vertex.y = points[j].y;
                vertex.z = points[j].x * cos;
                vertices.push(vertex.x, vertex.y, vertex.z);
                // uv
                uv.x = i / segments;
                uv.y = j / (points.length - 1);
                uvs.push(uv.x, uv.y);
                // normal
                const x = initNormals[3 * j + 0] * sin;
                const y = initNormals[3 * j + 1];
                const z = initNormals[3 * j + 0] * cos;
                normals.push(x, y, z);
            }
        }
        // indices
        for(let i = 0; i < segments; i++)for(let j = 0; j < points.length - 1; j++){
            const base = j + i * points.length;
            const a = base;
            const b = base + points.length;
            const c = base + points.length + 1;
            const d = base + 1;
            // faces
            indices.push(a, b, d);
            indices.push(c, d, b);
        }
        // build geometry
        this.setIndex(indices);
        this.setAttribute('position', new $9ddd7e9b53f7a2d4$export$cbe7a62641830ebd(vertices, 3));
        this.setAttribute('uv', new $9ddd7e9b53f7a2d4$export$cbe7a62641830ebd(uvs, 2));
        this.setAttribute('normal', new $9ddd7e9b53f7a2d4$export$cbe7a62641830ebd(normals, 3));
    }
    copy(source) {
        super.copy(source);
        this.parameters = Object.assign({}, source.parameters);
        return this;
    }
    /**
	 * Factory method for creating an instance of this class from the given
	 * JSON object.
	 *
	 * @param {Object} data - A JSON object representing the serialized geometry.
	 * @return {LatheGeometry} A new instance.
	 */ static fromJSON(data) {
        return new $9ddd7e9b53f7a2d4$export$6d839803fcd1882c(data.points, data.segments, data.phiStart, data.phiLength);
    }
}
/**
 * A geometry class for a capsule with given radii and height. It is constructed using a lathe.
 *
 * ```js
 * const geometry = new THREE.CapsuleGeometry( 1, 1, 4, 8 );
 * const material = new THREE.MeshBasicMaterial( { color: 0x00ff00 } );
 * const capsule = new THREE.Mesh( geometry, material );
 * scene.add( capsule );
 * ```
 *
 * @augments LatheGeometry
 */ class $9ddd7e9b53f7a2d4$export$41680e8551036033 extends $9ddd7e9b53f7a2d4$export$6d839803fcd1882c {
    /**
	 * Constructs a new capsule geometry.
	 *
	 * @param {number} [radius=1] - Radius of the capsule.
	 * @param {number} [length=1] - Length of the middle section.
	 * @param {number} [capSegments=4] - Number of curve segments used to build the caps.
	 * @param {number} [radialSegments=8] - Number of segmented faces around the circumference of the capsule.
	 */ constructor(radius = 1, length = 1, capSegments = 4, radialSegments = 8){
        const path = new $9ddd7e9b53f7a2d4$export$4b2950bdac9b6ee9();
        path.absarc(0, -length / 2, radius, Math.PI * 1.5, 0);
        path.absarc(0, length / 2, radius, 0, Math.PI * 0.5);
        super(path.getPoints(capSegments), radialSegments);
        this.type = 'CapsuleGeometry';
        /**
		 * Holds the constructor parameters that have been
		 * used to generate the geometry. Any modification
		 * after instantiation does not change the geometry.
		 *
		 * @type {Object}
		 */ this.parameters = {
            radius: radius,
            length: length,
            capSegments: capSegments,
            radialSegments: radialSegments
        };
    }
    /**
	 * Factory method for creating an instance of this class from the given
	 * JSON object.
	 *
	 * @param {Object} data - A JSON object representing the serialized geometry.
	 * @return {CapsuleGeometry} A new instance.
	 */ static fromJSON(data) {
        return new $9ddd7e9b53f7a2d4$export$41680e8551036033(data.radius, data.length, data.capSegments, data.radialSegments);
    }
}
/**
 * A simple shape of Euclidean geometry. It is constructed from a
 * number of triangular segments that are oriented around a central point and
 * extend as far out as a given radius. It is built counter-clockwise from a
 * start angle and a given central angle. It can also be used to create
 * regular polygons, where the number of segments determines the number of
 * sides.
 *
 * ```js
 * const geometry = new THREE.CircleGeometry( 5, 32 );
 * const material = new THREE.MeshBasicMaterial( { color: 0xffff00 } );
 * const circle = new THREE.Mesh( geometry, material );
 * scene.add( circle )
 * ```
 *
 * @augments BufferGeometry
 */ class $9ddd7e9b53f7a2d4$export$d5c0e8d607467193 extends $9ddd7e9b53f7a2d4$export$b7be63a67df8959 {
    /**
	 * Constructs a new circle geometry.
	 *
	 * @param {number} [radius=1] - Radius of the circle.
	 * @param {number} [segments=32] - Number of segments (triangles), minimum = `3`.
	 * @param {number} [thetaStart=0] - Start angle for first segment in radians.
	 * @param {number} [thetaLength=Math.PI*2] - The central angle, often called theta,
	 * of the circular sector in radians. The default value results in a complete circle.
	 */ constructor(radius = 1, segments = 32, thetaStart = 0, thetaLength = Math.PI * 2){
        super();
        this.type = 'CircleGeometry';
        /**
		 * Holds the constructor parameters that have been
		 * used to generate the geometry. Any modification
		 * after instantiation does not change the geometry.
		 *
		 * @type {Object}
		 */ this.parameters = {
            radius: radius,
            segments: segments,
            thetaStart: thetaStart,
            thetaLength: thetaLength
        };
        segments = Math.max(3, segments);
        // buffers
        const indices = [];
        const vertices = [];
        const normals = [];
        const uvs = [];
        // helper variables
        const vertex = new $9ddd7e9b53f7a2d4$export$64b5c384219d3699();
        const uv = new $9ddd7e9b53f7a2d4$export$c977b3e384af9ae1();
        // center point
        vertices.push(0, 0, 0);
        normals.push(0, 0, 1);
        uvs.push(0.5, 0.5);
        for(let s = 0, i = 3; s <= segments; s++, i += 3){
            const segment = thetaStart + s / segments * thetaLength;
            // vertex
            vertex.x = radius * Math.cos(segment);
            vertex.y = radius * Math.sin(segment);
            vertices.push(vertex.x, vertex.y, vertex.z);
            // normal
            normals.push(0, 0, 1);
            // uvs
            uv.x = (vertices[i] / radius + 1) / 2;
            uv.y = (vertices[i + 1] / radius + 1) / 2;
            uvs.push(uv.x, uv.y);
        }
        // indices
        for(let i = 1; i <= segments; i++)indices.push(i, i + 1, 0);
        // build geometry
        this.setIndex(indices);
        this.setAttribute('position', new $9ddd7e9b53f7a2d4$export$cbe7a62641830ebd(vertices, 3));
        this.setAttribute('normal', new $9ddd7e9b53f7a2d4$export$cbe7a62641830ebd(normals, 3));
        this.setAttribute('uv', new $9ddd7e9b53f7a2d4$export$cbe7a62641830ebd(uvs, 2));
    }
    copy(source) {
        super.copy(source);
        this.parameters = Object.assign({}, source.parameters);
        return this;
    }
    /**
	 * Factory method for creating an instance of this class from the given
	 * JSON object.
	 *
	 * @param {Object} data - A JSON object representing the serialized geometry.
	 * @return {CircleGeometry} A new instance.
	 */ static fromJSON(data) {
        return new $9ddd7e9b53f7a2d4$export$d5c0e8d607467193(data.radius, data.segments, data.thetaStart, data.thetaLength);
    }
}
/**
 * A geometry class for representing a cylinder.
 *
 * ```js
 * const geometry = new THREE.CylinderGeometry( 5, 5, 20, 32 );
 * const material = new THREE.MeshBasicMaterial( { color: 0xffff00 } );
 * const cylinder = new THREE.Mesh( geometry, material );
 * scene.add( cylinder );
 * ```
 *
 * @augments BufferGeometry
 */ class $9ddd7e9b53f7a2d4$export$68f745719dbe5198 extends $9ddd7e9b53f7a2d4$export$b7be63a67df8959 {
    /**
	 * Constructs a new cylinder geometry.
	 *
	 * @param {number} [radiusTop=1] - Radius of the cylinder at the top.
	 * @param {number} [radiusBottom=1] - Radius of the cylinder at the bottom.
	 * @param {number} [height=1] - Height of the cylinder.
	 * @param {number} [radialSegments=32] - Number of segmented faces around the circumference of the cylinder.
	 * @param {number} [heightSegments=1] - Number of rows of faces along the height of the cylinder.
	 * @param {boolean} [openEnded=false] - Whether the base of the cylinder is open or capped.
	 * @param {number} [thetaStart=0] - Start angle for first segment, in radians.
	 * @param {number} [thetaLength=Math.PI*2] - The central angle, often called theta, of the circular sector, in radians.
	 * The default value results in a complete cylinder.
	 */ constructor(radiusTop = 1, radiusBottom = 1, height = 1, radialSegments = 32, heightSegments = 1, openEnded = false, thetaStart = 0, thetaLength = Math.PI * 2){
        super();
        this.type = 'CylinderGeometry';
        /**
		 * Holds the constructor parameters that have been
		 * used to generate the geometry. Any modification
		 * after instantiation does not change the geometry.
		 *
		 * @type {Object}
		 */ this.parameters = {
            radiusTop: radiusTop,
            radiusBottom: radiusBottom,
            height: height,
            radialSegments: radialSegments,
            heightSegments: heightSegments,
            openEnded: openEnded,
            thetaStart: thetaStart,
            thetaLength: thetaLength
        };
        const scope = this;
        radialSegments = Math.floor(radialSegments);
        heightSegments = Math.floor(heightSegments);
        // buffers
        const indices = [];
        const vertices = [];
        const normals = [];
        const uvs = [];
        // helper variables
        let index = 0;
        const indexArray = [];
        const halfHeight = height / 2;
        let groupStart = 0;
        // generate geometry
        generateTorso();
        if (openEnded === false) {
            if (radiusTop > 0) generateCap(true);
            if (radiusBottom > 0) generateCap(false);
        }
        // build geometry
        this.setIndex(indices);
        this.setAttribute('position', new $9ddd7e9b53f7a2d4$export$cbe7a62641830ebd(vertices, 3));
        this.setAttribute('normal', new $9ddd7e9b53f7a2d4$export$cbe7a62641830ebd(normals, 3));
        this.setAttribute('uv', new $9ddd7e9b53f7a2d4$export$cbe7a62641830ebd(uvs, 2));
        function generateTorso() {
            const normal = new $9ddd7e9b53f7a2d4$export$64b5c384219d3699();
            const vertex = new $9ddd7e9b53f7a2d4$export$64b5c384219d3699();
            let groupCount = 0;
            // this will be used to calculate the normal
            const slope = (radiusBottom - radiusTop) / height;
            // generate vertices, normals and uvs
            for(let y = 0; y <= heightSegments; y++){
                const indexRow = [];
                const v = y / heightSegments;
                // calculate the radius of the current row
                const radius = v * (radiusBottom - radiusTop) + radiusTop;
                for(let x = 0; x <= radialSegments; x++){
                    const u = x / radialSegments;
                    const theta = u * thetaLength + thetaStart;
                    const sinTheta = Math.sin(theta);
                    const cosTheta = Math.cos(theta);
                    // vertex
                    vertex.x = radius * sinTheta;
                    vertex.y = -v * height + halfHeight;
                    vertex.z = radius * cosTheta;
                    vertices.push(vertex.x, vertex.y, vertex.z);
                    // normal
                    normal.set(sinTheta, slope, cosTheta).normalize();
                    normals.push(normal.x, normal.y, normal.z);
                    // uv
                    uvs.push(u, 1 - v);
                    // save index of vertex in respective row
                    indexRow.push(index++);
                }
                // now save vertices of the row in our index array
                indexArray.push(indexRow);
            }
            // generate indices
            for(let x = 0; x < radialSegments; x++)for(let y = 0; y < heightSegments; y++){
                // we use the index array to access the correct indices
                const a = indexArray[y][x];
                const b = indexArray[y + 1][x];
                const c = indexArray[y + 1][x + 1];
                const d = indexArray[y][x + 1];
                // faces
                if (radiusTop > 0 || y !== 0) {
                    indices.push(a, b, d);
                    groupCount += 3;
                }
                if (radiusBottom > 0 || y !== heightSegments - 1) {
                    indices.push(b, c, d);
                    groupCount += 3;
                }
            }
            // add a group to the geometry. this will ensure multi material support
            scope.addGroup(groupStart, groupCount, 0);
            // calculate new start value for groups
            groupStart += groupCount;
        }
        function generateCap(top) {
            // save the index of the first center vertex
            const centerIndexStart = index;
            const uv = new $9ddd7e9b53f7a2d4$export$c977b3e384af9ae1();
            const vertex = new $9ddd7e9b53f7a2d4$export$64b5c384219d3699();
            let groupCount = 0;
            const radius = top === true ? radiusTop : radiusBottom;
            const sign = top === true ? 1 : -1;
            // first we generate the center vertex data of the cap.
            // because the geometry needs one set of uvs per face,
            // we must generate a center vertex per face/segment
            for(let x = 1; x <= radialSegments; x++){
                // vertex
                vertices.push(0, halfHeight * sign, 0);
                // normal
                normals.push(0, sign, 0);
                // uv
                uvs.push(0.5, 0.5);
                // increase index
                index++;
            }
            // save the index of the last center vertex
            const centerIndexEnd = index;
            // now we generate the surrounding vertices, normals and uvs
            for(let x = 0; x <= radialSegments; x++){
                const u = x / radialSegments;
                const theta = u * thetaLength + thetaStart;
                const cosTheta = Math.cos(theta);
                const sinTheta = Math.sin(theta);
                // vertex
                vertex.x = radius * sinTheta;
                vertex.y = halfHeight * sign;
                vertex.z = radius * cosTheta;
                vertices.push(vertex.x, vertex.y, vertex.z);
                // normal
                normals.push(0, sign, 0);
                // uv
                uv.x = cosTheta * 0.5 + 0.5;
                uv.y = sinTheta * 0.5 * sign + 0.5;
                uvs.push(uv.x, uv.y);
                // increase index
                index++;
            }
            // generate indices
            for(let x = 0; x < radialSegments; x++){
                const c = centerIndexStart + x;
                const i = centerIndexEnd + x;
                if (top === true) // face top
                indices.push(i, i + 1, c);
                else // face bottom
                indices.push(i + 1, i, c);
                groupCount += 3;
            }
            // add a group to the geometry. this will ensure multi material support
            scope.addGroup(groupStart, groupCount, top === true ? 1 : 2);
            // calculate new start value for groups
            groupStart += groupCount;
        }
    }
    copy(source) {
        super.copy(source);
        this.parameters = Object.assign({}, source.parameters);
        return this;
    }
    /**
	 * Factory method for creating an instance of this class from the given
	 * JSON object.
	 *
	 * @param {Object} data - A JSON object representing the serialized geometry.
	 * @return {CylinderGeometry} A new instance.
	 */ static fromJSON(data) {
        return new $9ddd7e9b53f7a2d4$export$68f745719dbe5198(data.radiusTop, data.radiusBottom, data.height, data.radialSegments, data.heightSegments, data.openEnded, data.thetaStart, data.thetaLength);
    }
}
/**
 * A geometry class for representing a cone.
 *
 * ```js
 * const geometry = new THREE.ConeGeometry( 5, 20, 32 );
 * const material = new THREE.MeshBasicMaterial( { color: 0xffff00 } );
 * const cone = new THREE.Mesh(geometry, material );
 * scene.add( cone );
 * ```
 *
 * @augments CylinderGeometry
 */ class $9ddd7e9b53f7a2d4$export$a7a48974f285c9b3 extends $9ddd7e9b53f7a2d4$export$68f745719dbe5198 {
    /**
	 * Constructs a new cone geometry.
	 *
	 * @param {number} [radius=1] - Radius of the cone base.
	 * @param {number} [height=1] - Height of the cone.
	 * @param {number} [radialSegments=32] - Number of segmented faces around the circumference of the cone.
	 * @param {number} [heightSegments=1] - Number of rows of faces along the height of the cone.
	 * @param {boolean} [openEnded=false] - Whether the base of the cone is open or capped.
	 * @param {number} [thetaStart=0] - Start angle for first segment, in radians.
	 * @param {number} [thetaLength=Math.PI*2] - The central angle, often called theta, of the circular sector, in radians.
	 * The default value results in a complete cone.
	 */ constructor(radius = 1, height = 1, radialSegments = 32, heightSegments = 1, openEnded = false, thetaStart = 0, thetaLength = Math.PI * 2){
        super(0, radius, height, radialSegments, heightSegments, openEnded, thetaStart, thetaLength);
        this.type = 'ConeGeometry';
        /**
		 * Holds the constructor parameters that have been
		 * used to generate the geometry. Any modification
		 * after instantiation does not change the geometry.
		 *
		 * @type {Object}
		 */ this.parameters = {
            radius: radius,
            height: height,
            radialSegments: radialSegments,
            heightSegments: heightSegments,
            openEnded: openEnded,
            thetaStart: thetaStart,
            thetaLength: thetaLength
        };
    }
    /**
	 * Factory method for creating an instance of this class from the given
	 * JSON object.
	 *
	 * @param {Object} data - A JSON object representing the serialized geometry.
	 * @return {ConeGeometry} A new instance.
	 */ static fromJSON(data) {
        return new $9ddd7e9b53f7a2d4$export$a7a48974f285c9b3(data.radius, data.height, data.radialSegments, data.heightSegments, data.openEnded, data.thetaStart, data.thetaLength);
    }
}
/**
 * A polyhedron is a solid in three dimensions with flat faces. This class
 * will take an array of vertices, project them onto a sphere, and then
 * divide them up to the desired level of detail.
 *
 * @augments BufferGeometry
 */ class $9ddd7e9b53f7a2d4$export$60e57a7d3f20ff65 extends $9ddd7e9b53f7a2d4$export$b7be63a67df8959 {
    /**
	 * Constructs a new polyhedron geometry.
	 *
	 * @param {Array<number>} [vertices] - A flat array of vertices describing the base shape.
	 * @param {Array<number>} [indices] - A flat array of indices describing the base shape.
	 * @param {number} [radius=1] - The radius of the shape.
	 * @param {number} [detail=0] - How many levels to subdivide the geometry. The more detail, the smoother the shape.
	 */ constructor(vertices = [], indices = [], radius = 1, detail = 0){
        super();
        this.type = 'PolyhedronGeometry';
        /**
		 * Holds the constructor parameters that have been
		 * used to generate the geometry. Any modification
		 * after instantiation does not change the geometry.
		 *
		 * @type {Object}
		 */ this.parameters = {
            vertices: vertices,
            indices: indices,
            radius: radius,
            detail: detail
        };
        // default buffer data
        const vertexBuffer = [];
        const uvBuffer = [];
        // the subdivision creates the vertex buffer data
        subdivide(detail);
        // all vertices should lie on a conceptual sphere with a given radius
        applyRadius(radius);
        // finally, create the uv data
        generateUVs();
        // build non-indexed geometry
        this.setAttribute('position', new $9ddd7e9b53f7a2d4$export$cbe7a62641830ebd(vertexBuffer, 3));
        this.setAttribute('normal', new $9ddd7e9b53f7a2d4$export$cbe7a62641830ebd(vertexBuffer.slice(), 3));
        this.setAttribute('uv', new $9ddd7e9b53f7a2d4$export$cbe7a62641830ebd(uvBuffer, 2));
        if (detail === 0) this.computeVertexNormals(); // flat normals
        else this.normalizeNormals(); // smooth normals
        // helper functions
        function subdivide(detail) {
            const a = new $9ddd7e9b53f7a2d4$export$64b5c384219d3699();
            const b = new $9ddd7e9b53f7a2d4$export$64b5c384219d3699();
            const c = new $9ddd7e9b53f7a2d4$export$64b5c384219d3699();
            // iterate over all faces and apply a subdivision with the given detail value
            for(let i = 0; i < indices.length; i += 3){
                // get the vertices of the face
                getVertexByIndex(indices[i + 0], a);
                getVertexByIndex(indices[i + 1], b);
                getVertexByIndex(indices[i + 2], c);
                // perform subdivision
                subdivideFace(a, b, c, detail);
            }
        }
        function subdivideFace(a, b, c, detail) {
            const cols = detail + 1;
            // we use this multidimensional array as a data structure for creating the subdivision
            const v = [];
            // construct all of the vertices for this subdivision
            for(let i = 0; i <= cols; i++){
                v[i] = [];
                const aj = a.clone().lerp(c, i / cols);
                const bj = b.clone().lerp(c, i / cols);
                const rows = cols - i;
                for(let j = 0; j <= rows; j++)if (j === 0 && i === cols) v[i][j] = aj;
                else v[i][j] = aj.clone().lerp(bj, j / rows);
            }
            // construct all of the faces
            for(let i = 0; i < cols; i++)for(let j = 0; j < 2 * (cols - i) - 1; j++){
                const k = Math.floor(j / 2);
                if (j % 2 === 0) {
                    pushVertex(v[i][k + 1]);
                    pushVertex(v[i + 1][k]);
                    pushVertex(v[i][k]);
                } else {
                    pushVertex(v[i][k + 1]);
                    pushVertex(v[i + 1][k + 1]);
                    pushVertex(v[i + 1][k]);
                }
            }
        }
        function applyRadius(radius) {
            const vertex = new $9ddd7e9b53f7a2d4$export$64b5c384219d3699();
            // iterate over the entire buffer and apply the radius to each vertex
            for(let i = 0; i < vertexBuffer.length; i += 3){
                vertex.x = vertexBuffer[i + 0];
                vertex.y = vertexBuffer[i + 1];
                vertex.z = vertexBuffer[i + 2];
                vertex.normalize().multiplyScalar(radius);
                vertexBuffer[i + 0] = vertex.x;
                vertexBuffer[i + 1] = vertex.y;
                vertexBuffer[i + 2] = vertex.z;
            }
        }
        function generateUVs() {
            const vertex = new $9ddd7e9b53f7a2d4$export$64b5c384219d3699();
            for(let i = 0; i < vertexBuffer.length; i += 3){
                vertex.x = vertexBuffer[i + 0];
                vertex.y = vertexBuffer[i + 1];
                vertex.z = vertexBuffer[i + 2];
                const u = azimuth(vertex) / 2 / Math.PI + 0.5;
                const v = inclination(vertex) / Math.PI + 0.5;
                uvBuffer.push(u, 1 - v);
            }
            correctUVs();
            correctSeam();
        }
        function correctSeam() {
            // handle case when face straddles the seam, see #3269
            for(let i = 0; i < uvBuffer.length; i += 6){
                // uv data of a single face
                const x0 = uvBuffer[i + 0];
                const x1 = uvBuffer[i + 2];
                const x2 = uvBuffer[i + 4];
                const max = Math.max(x0, x1, x2);
                const min = Math.min(x0, x1, x2);
                // 0.9 is somewhat arbitrary
                if (max > 0.9 && min < 0.1) {
                    if (x0 < 0.2) uvBuffer[i + 0] += 1;
                    if (x1 < 0.2) uvBuffer[i + 2] += 1;
                    if (x2 < 0.2) uvBuffer[i + 4] += 1;
                }
            }
        }
        function pushVertex(vertex) {
            vertexBuffer.push(vertex.x, vertex.y, vertex.z);
        }
        function getVertexByIndex(index, vertex) {
            const stride = index * 3;
            vertex.x = vertices[stride + 0];
            vertex.y = vertices[stride + 1];
            vertex.z = vertices[stride + 2];
        }
        function correctUVs() {
            const a = new $9ddd7e9b53f7a2d4$export$64b5c384219d3699();
            const b = new $9ddd7e9b53f7a2d4$export$64b5c384219d3699();
            const c = new $9ddd7e9b53f7a2d4$export$64b5c384219d3699();
            const centroid = new $9ddd7e9b53f7a2d4$export$64b5c384219d3699();
            const uvA = new $9ddd7e9b53f7a2d4$export$c977b3e384af9ae1();
            const uvB = new $9ddd7e9b53f7a2d4$export$c977b3e384af9ae1();
            const uvC = new $9ddd7e9b53f7a2d4$export$c977b3e384af9ae1();
            for(let i = 0, j = 0; i < vertexBuffer.length; i += 9, j += 6){
                a.set(vertexBuffer[i + 0], vertexBuffer[i + 1], vertexBuffer[i + 2]);
                b.set(vertexBuffer[i + 3], vertexBuffer[i + 4], vertexBuffer[i + 5]);
                c.set(vertexBuffer[i + 6], vertexBuffer[i + 7], vertexBuffer[i + 8]);
                uvA.set(uvBuffer[j + 0], uvBuffer[j + 1]);
                uvB.set(uvBuffer[j + 2], uvBuffer[j + 3]);
                uvC.set(uvBuffer[j + 4], uvBuffer[j + 5]);
                centroid.copy(a).add(b).add(c).divideScalar(3);
                const azi = azimuth(centroid);
                correctUV(uvA, j + 0, a, azi);
                correctUV(uvB, j + 2, b, azi);
                correctUV(uvC, j + 4, c, azi);
            }
        }
        function correctUV(uv, stride, vector, azimuth) {
            if (azimuth < 0 && uv.x === 1) uvBuffer[stride] = uv.x - 1;
            if (vector.x === 0 && vector.z === 0) uvBuffer[stride] = azimuth / 2 / Math.PI + 0.5;
        }
        // Angle around the Y axis, counter-clockwise when looking from above.
        function azimuth(vector) {
            return Math.atan2(vector.z, -vector.x);
        }
        // Angle above the XZ plane.
        function inclination(vector) {
            return Math.atan2(-vector.y, Math.sqrt(vector.x * vector.x + vector.z * vector.z));
        }
    }
    copy(source) {
        super.copy(source);
        this.parameters = Object.assign({}, source.parameters);
        return this;
    }
    /**
	 * Factory method for creating an instance of this class from the given
	 * JSON object.
	 *
	 * @param {Object} data - A JSON object representing the serialized geometry.
	 * @return {PolyhedronGeometry} A new instance.
	 */ static fromJSON(data) {
        return new $9ddd7e9b53f7a2d4$export$60e57a7d3f20ff65(data.vertices, data.indices, data.radius, data.details);
    }
}
/**
 * A geometry class for representing a dodecahedron.
 *
 * ```js
 * const geometry = new THREE.DodecahedronGeometry();
 * const material = new THREE.MeshBasicMaterial( { color: 0xffff00 } );
 * const dodecahedron = new THREE.Mesh( geometry, material );
 * scene.add( dodecahedron );
 * ```
 *
 * @augments PolyhedronGeometry
 */ class $9ddd7e9b53f7a2d4$export$c0babfeb8708fc9c extends $9ddd7e9b53f7a2d4$export$60e57a7d3f20ff65 {
    /**
	 * Constructs a new dodecahedron geometry.
	 *
	 * @param {number} [radius=1] - Radius of the dodecahedron.
	 * @param {number} [detail=0] - Setting this to a value greater than `0` adds vertices making it no longer a dodecahedron.
	 */ constructor(radius = 1, detail = 0){
        const t = (1 + Math.sqrt(5)) / 2;
        const r = 1 / t;
        const vertices = [
            // (±1, ±1, ±1)
            -1,
            -1,
            -1,
            -1,
            -1,
            1,
            -1,
            1,
            -1,
            -1,
            1,
            1,
            1,
            -1,
            -1,
            1,
            -1,
            1,
            1,
            1,
            -1,
            1,
            1,
            1,
            // (0, ±1/φ, ±φ)
            0,
            -r,
            -t,
            0,
            -r,
            t,
            0,
            r,
            -t,
            0,
            r,
            t,
            // (±1/φ, ±φ, 0)
            -r,
            -t,
            0,
            -r,
            t,
            0,
            r,
            -t,
            0,
            r,
            t,
            0,
            // (±φ, 0, ±1/φ)
            -t,
            0,
            -r,
            t,
            0,
            -r,
            -t,
            0,
            r,
            t,
            0,
            r
        ];
        const indices = [
            3,
            11,
            7,
            3,
            7,
            15,
            3,
            15,
            13,
            7,
            19,
            17,
            7,
            17,
            6,
            7,
            6,
            15,
            17,
            4,
            8,
            17,
            8,
            10,
            17,
            10,
            6,
            8,
            0,
            16,
            8,
            16,
            2,
            8,
            2,
            10,
            0,
            12,
            1,
            0,
            1,
            18,
            0,
            18,
            16,
            6,
            10,
            2,
            6,
            2,
            13,
            6,
            13,
            15,
            2,
            16,
            18,
            2,
            18,
            3,
            2,
            3,
            13,
            18,
            1,
            9,
            18,
            9,
            11,
            18,
            11,
            3,
            4,
            14,
            12,
            4,
            12,
            0,
            4,
            0,
            8,
            11,
            9,
            5,
            11,
            5,
            19,
            11,
            19,
            7,
            19,
            5,
            14,
            19,
            14,
            4,
            19,
            4,
            17,
            1,
            12,
            14,
            1,
            14,
            5,
            1,
            5,
            9
        ];
        super(vertices, indices, radius, detail);
        this.type = 'DodecahedronGeometry';
        /**
		 * Holds the constructor parameters that have been
		 * used to generate the geometry. Any modification
		 * after instantiation does not change the geometry.
		 *
		 * @type {Object}
		 */ this.parameters = {
            radius: radius,
            detail: detail
        };
    }
    /**
	 * Factory method for creating an instance of this class from the given
	 * JSON object.
	 *
	 * @param {Object} data - A JSON object representing the serialized geometry.
	 * @return {DodecahedronGeometry} A new instance.
	 */ static fromJSON(data) {
        return new $9ddd7e9b53f7a2d4$export$c0babfeb8708fc9c(data.radius, data.detail);
    }
}
const $9ddd7e9b53f7a2d4$var$_v0 = /*@__PURE__*/ new $9ddd7e9b53f7a2d4$export$64b5c384219d3699();
const $9ddd7e9b53f7a2d4$var$_v1$1 = /*@__PURE__*/ new $9ddd7e9b53f7a2d4$export$64b5c384219d3699();
const $9ddd7e9b53f7a2d4$var$_normal = /*@__PURE__*/ new $9ddd7e9b53f7a2d4$export$64b5c384219d3699();
const $9ddd7e9b53f7a2d4$var$_triangle = /*@__PURE__*/ new $9ddd7e9b53f7a2d4$export$5a465592bfe74b48();
/**
 * Can be used as a helper object to view the edges of a geometry.
 *
 * ```js
 * const geometry = new THREE.BoxGeometry();
 * const edges = new THREE.EdgesGeometry( geometry );
 * const line = new THREE.LineSegments( edges );
 * scene.add( line );
 * ```
 *
 * Note: It is not yet possible to serialize/deserialize instances of this class.
 *
 * @augments BufferGeometry
 */ class $9ddd7e9b53f7a2d4$export$4730b1542707547f extends $9ddd7e9b53f7a2d4$export$b7be63a67df8959 {
    /**
	 * Constructs a new edges geometry.
	 *
	 * @param {?BufferGeometry} [geometry=null] - The geometry.
	 * @param {number} [thresholdAngle=1] - An edge is only rendered if the angle (in degrees)
	 * between the face normals of the adjoining faces exceeds this value.
	 */ constructor(geometry = null, thresholdAngle = 1){
        super();
        this.type = 'EdgesGeometry';
        /**
		 * Holds the constructor parameters that have been
		 * used to generate the geometry. Any modification
		 * after instantiation does not change the geometry.
		 *
		 * @type {Object}
		 */ this.parameters = {
            geometry: geometry,
            thresholdAngle: thresholdAngle
        };
        if (geometry !== null) {
            const precisionPoints = 4;
            const precision = Math.pow(10, precisionPoints);
            const thresholdDot = Math.cos($9ddd7e9b53f7a2d4$var$DEG2RAD * thresholdAngle);
            const indexAttr = geometry.getIndex();
            const positionAttr = geometry.getAttribute('position');
            const indexCount = indexAttr ? indexAttr.count : positionAttr.count;
            const indexArr = [
                0,
                0,
                0
            ];
            const vertKeys = [
                'a',
                'b',
                'c'
            ];
            const hashes = new Array(3);
            const edgeData = {};
            const vertices = [];
            for(let i = 0; i < indexCount; i += 3){
                if (indexAttr) {
                    indexArr[0] = indexAttr.getX(i);
                    indexArr[1] = indexAttr.getX(i + 1);
                    indexArr[2] = indexAttr.getX(i + 2);
                } else {
                    indexArr[0] = i;
                    indexArr[1] = i + 1;
                    indexArr[2] = i + 2;
                }
                const { a: a, b: b, c: c } = $9ddd7e9b53f7a2d4$var$_triangle;
                a.fromBufferAttribute(positionAttr, indexArr[0]);
                b.fromBufferAttribute(positionAttr, indexArr[1]);
                c.fromBufferAttribute(positionAttr, indexArr[2]);
                $9ddd7e9b53f7a2d4$var$_triangle.getNormal($9ddd7e9b53f7a2d4$var$_normal);
                // create hashes for the edge from the vertices
                hashes[0] = `${Math.round(a.x * precision)},${Math.round(a.y * precision)},${Math.round(a.z * precision)}`;
                hashes[1] = `${Math.round(b.x * precision)},${Math.round(b.y * precision)},${Math.round(b.z * precision)}`;
                hashes[2] = `${Math.round(c.x * precision)},${Math.round(c.y * precision)},${Math.round(c.z * precision)}`;
                // skip degenerate triangles
                if (hashes[0] === hashes[1] || hashes[1] === hashes[2] || hashes[2] === hashes[0]) continue;
                // iterate over every edge
                for(let j = 0; j < 3; j++){
                    // get the first and next vertex making up the edge
                    const jNext = (j + 1) % 3;
                    const vecHash0 = hashes[j];
                    const vecHash1 = hashes[jNext];
                    const v0 = $9ddd7e9b53f7a2d4$var$_triangle[vertKeys[j]];
                    const v1 = $9ddd7e9b53f7a2d4$var$_triangle[vertKeys[jNext]];
                    const hash = `${vecHash0}_${vecHash1}`;
                    const reverseHash = `${vecHash1}_${vecHash0}`;
                    if (reverseHash in edgeData && edgeData[reverseHash]) {
                        // if we found a sibling edge add it into the vertex array if
                        // it meets the angle threshold and delete the edge from the map.
                        if ($9ddd7e9b53f7a2d4$var$_normal.dot(edgeData[reverseHash].normal) <= thresholdDot) {
                            vertices.push(v0.x, v0.y, v0.z);
                            vertices.push(v1.x, v1.y, v1.z);
                        }
                        edgeData[reverseHash] = null;
                    } else if (!(hash in edgeData)) // if we've already got an edge here then skip adding a new one
                    edgeData[hash] = {
                        index0: indexArr[j],
                        index1: indexArr[jNext],
                        normal: $9ddd7e9b53f7a2d4$var$_normal.clone()
                    };
                }
            }
            // iterate over all remaining, unmatched edges and add them to the vertex array
            for(const key in edgeData)if (edgeData[key]) {
                const { index0: index0, index1: index1 } = edgeData[key];
                $9ddd7e9b53f7a2d4$var$_v0.fromBufferAttribute(positionAttr, index0);
                $9ddd7e9b53f7a2d4$var$_v1$1.fromBufferAttribute(positionAttr, index1);
                vertices.push($9ddd7e9b53f7a2d4$var$_v0.x, $9ddd7e9b53f7a2d4$var$_v0.y, $9ddd7e9b53f7a2d4$var$_v0.z);
                vertices.push($9ddd7e9b53f7a2d4$var$_v1$1.x, $9ddd7e9b53f7a2d4$var$_v1$1.y, $9ddd7e9b53f7a2d4$var$_v1$1.z);
            }
            this.setAttribute('position', new $9ddd7e9b53f7a2d4$export$cbe7a62641830ebd(vertices, 3));
        }
    }
    copy(source) {
        super.copy(source);
        this.parameters = Object.assign({}, source.parameters);
        return this;
    }
}
/**
 * Defines an arbitrary 2d shape plane using paths with optional holes. It
 * can be used with {@link ExtrudeGeometry}, {@link ShapeGeometry}, to get
 * points, or to get triangulated faces.
 *
 * ```js
 * const heartShape = new THREE.Shape();
 *
 * heartShape.moveTo( 25, 25 );
 * heartShape.bezierCurveTo( 25, 25, 20, 0, 0, 0 );
 * heartShape.bezierCurveTo( - 30, 0, - 30, 35, - 30, 35 );
 * heartShape.bezierCurveTo( - 30, 55, - 10, 77, 25, 95 );
 * heartShape.bezierCurveTo( 60, 77, 80, 55, 80, 35 );
 * heartShape.bezierCurveTo( 80, 35, 80, 0, 50, 0 );
 * heartShape.bezierCurveTo( 35, 0, 25, 25, 25, 25 );
 *
 * const extrudeSettings = {
 * 	depth: 8,
 * 	bevelEnabled: true,
 * 	bevelSegments: 2,
 * 	steps: 2,
 * 	bevelSize: 1,
 * 	bevelThickness: 1
 * };
 *
 * const geometry = new THREE.ExtrudeGeometry( heartShape, extrudeSettings );
 * const mesh = new THREE.Mesh( geometry, new THREE.MeshBasicMaterial() );
 * ```
 *
 * @augments Path
 */ class $9ddd7e9b53f7a2d4$export$6428a7f2611ef1fa extends $9ddd7e9b53f7a2d4$export$4b2950bdac9b6ee9 {
    /**
	 * Constructs a new shape.
	 *
	 * @param {Array<Vector2>} [points] - An array of 2D points defining the shape.
	 */ constructor(points){
        super(points);
        /**
		 * The UUID of the shape.
		 *
		 * @type {string}
		 * @readonly
		 */ this.uuid = $9ddd7e9b53f7a2d4$var$generateUUID();
        this.type = 'Shape';
        /**
		 * Defines the holes in the shape. Hole definitions must use the
		 * opposite winding order (CW/CCW) than the outer shape.
		 *
		 * @type {Array<Path>}
		 * @readonly
		 */ this.holes = [];
    }
    /**
	 * Returns an array representing each contour of the holes
	 * as a list of 2D points.
	 *
	 * @param {number} divisions - The fineness of the result.
	 * @return {Array<Array<Vector2>>} The holes as a series of 2D points.
	 */ getPointsHoles(divisions) {
        const holesPts = [];
        for(let i = 0, l = this.holes.length; i < l; i++)holesPts[i] = this.holes[i].getPoints(divisions);
        return holesPts;
    }
    // get points of shape and holes (keypoints based on segments parameter)
    /**
	 * Returns an object that holds contour data for the shape and its holes as
	 * arrays of 2D points.
	 *
	 * @param {number} divisions - The fineness of the result.
	 * @return {{shape:Array<Vector2>,holes:Array<Array<Vector2>>}} An object with contour data.
	 */ extractPoints(divisions) {
        return {
            shape: this.getPoints(divisions),
            holes: this.getPointsHoles(divisions)
        };
    }
    copy(source) {
        super.copy(source);
        this.holes = [];
        for(let i = 0, l = source.holes.length; i < l; i++){
            const hole = source.holes[i];
            this.holes.push(hole.clone());
        }
        return this;
    }
    toJSON() {
        const data = super.toJSON();
        data.uuid = this.uuid;
        data.holes = [];
        for(let i = 0, l = this.holes.length; i < l; i++){
            const hole = this.holes[i];
            data.holes.push(hole.toJSON());
        }
        return data;
    }
    fromJSON(json) {
        super.fromJSON(json);
        this.uuid = json.uuid;
        this.holes = [];
        for(let i = 0, l = json.holes.length; i < l; i++){
            const hole = json.holes[i];
            this.holes.push(new $9ddd7e9b53f7a2d4$export$4b2950bdac9b6ee9().fromJSON(hole));
        }
        return this;
    }
}
/* eslint-disable */ // copy of mapbox/earcut version 3.0.1
// https://github.com/mapbox/earcut/tree/v3.0.1
function $9ddd7e9b53f7a2d4$var$earcut(data, holeIndices, dim = 2) {
    const hasHoles = holeIndices && holeIndices.length;
    const outerLen = hasHoles ? holeIndices[0] * dim : data.length;
    let outerNode = $9ddd7e9b53f7a2d4$var$linkedList(data, 0, outerLen, dim, true);
    const triangles = [];
    if (!outerNode || outerNode.next === outerNode.prev) return triangles;
    let minX, minY, invSize;
    if (hasHoles) outerNode = $9ddd7e9b53f7a2d4$var$eliminateHoles(data, holeIndices, outerNode, dim);
    // if the shape is not too simple, we'll use z-order curve hash later; calculate polygon bbox
    if (data.length > 80 * dim) {
        minX = Infinity;
        minY = Infinity;
        let maxX = -Infinity;
        let maxY = -Infinity;
        for(let i = dim; i < outerLen; i += dim){
            const x = data[i];
            const y = data[i + 1];
            if (x < minX) minX = x;
            if (y < minY) minY = y;
            if (x > maxX) maxX = x;
            if (y > maxY) maxY = y;
        }
        // minX, minY and invSize are later used to transform coords into integers for z-order calculation
        invSize = Math.max(maxX - minX, maxY - minY);
        invSize = invSize !== 0 ? 32767 / invSize : 0;
    }
    $9ddd7e9b53f7a2d4$var$earcutLinked(outerNode, triangles, dim, minX, minY, invSize, 0);
    return triangles;
}
// create a circular doubly linked list from polygon points in the specified winding order
function $9ddd7e9b53f7a2d4$var$linkedList(data, start, end, dim, clockwise) {
    let last;
    if (clockwise === $9ddd7e9b53f7a2d4$var$signedArea(data, start, end, dim) > 0) for(let i = start; i < end; i += dim)last = $9ddd7e9b53f7a2d4$var$insertNode(i / dim | 0, data[i], data[i + 1], last);
    else for(let i = end - dim; i >= start; i -= dim)last = $9ddd7e9b53f7a2d4$var$insertNode(i / dim | 0, data[i], data[i + 1], last);
    if (last && $9ddd7e9b53f7a2d4$var$equals(last, last.next)) {
        $9ddd7e9b53f7a2d4$var$removeNode(last);
        last = last.next;
    }
    return last;
}
// eliminate colinear or duplicate points
function $9ddd7e9b53f7a2d4$var$filterPoints(start, end) {
    if (!start) return start;
    if (!end) end = start;
    let p = start, again;
    do {
        again = false;
        if (!p.steiner && ($9ddd7e9b53f7a2d4$var$equals(p, p.next) || $9ddd7e9b53f7a2d4$var$area(p.prev, p, p.next) === 0)) {
            $9ddd7e9b53f7a2d4$var$removeNode(p);
            p = end = p.prev;
            if (p === p.next) break;
            again = true;
        } else p = p.next;
    }while (again || p !== end);
    return end;
}
// main ear slicing loop which triangulates a polygon (given as a linked list)
function $9ddd7e9b53f7a2d4$var$earcutLinked(ear, triangles, dim, minX, minY, invSize, pass) {
    if (!ear) return;
    // interlink polygon nodes in z-order
    if (!pass && invSize) $9ddd7e9b53f7a2d4$var$indexCurve(ear, minX, minY, invSize);
    let stop = ear;
    // iterate through ears, slicing them one by one
    while(ear.prev !== ear.next){
        const prev = ear.prev;
        const next = ear.next;
        if (invSize ? $9ddd7e9b53f7a2d4$var$isEarHashed(ear, minX, minY, invSize) : $9ddd7e9b53f7a2d4$var$isEar(ear)) {
            triangles.push(prev.i, ear.i, next.i); // cut off the triangle
            $9ddd7e9b53f7a2d4$var$removeNode(ear);
            // skipping the next vertex leads to less sliver triangles
            ear = next.next;
            stop = next.next;
            continue;
        }
        ear = next;
        // if we looped through the whole remaining polygon and can't find any more ears
        if (ear === stop) {
            // try filtering points and slicing again
            if (!pass) $9ddd7e9b53f7a2d4$var$earcutLinked($9ddd7e9b53f7a2d4$var$filterPoints(ear), triangles, dim, minX, minY, invSize, 1);
            else if (pass === 1) {
                ear = $9ddd7e9b53f7a2d4$var$cureLocalIntersections($9ddd7e9b53f7a2d4$var$filterPoints(ear), triangles);
                $9ddd7e9b53f7a2d4$var$earcutLinked(ear, triangles, dim, minX, minY, invSize, 2);
            // as a last resort, try splitting the remaining polygon into two
            } else if (pass === 2) $9ddd7e9b53f7a2d4$var$splitEarcut(ear, triangles, dim, minX, minY, invSize);
            break;
        }
    }
}
// check whether a polygon node forms a valid ear with adjacent nodes
function $9ddd7e9b53f7a2d4$var$isEar(ear) {
    const a = ear.prev, b = ear, c = ear.next;
    if ($9ddd7e9b53f7a2d4$var$area(a, b, c) >= 0) return false; // reflex, can't be an ear
    // now make sure we don't have other points inside the potential ear
    const ax = a.x, bx = b.x, cx = c.x, ay = a.y, by = b.y, cy = c.y;
    // triangle bbox
    const x0 = Math.min(ax, bx, cx), y0 = Math.min(ay, by, cy), x1 = Math.max(ax, bx, cx), y1 = Math.max(ay, by, cy);
    let p = c.next;
    while(p !== a){
        if (p.x >= x0 && p.x <= x1 && p.y >= y0 && p.y <= y1 && $9ddd7e9b53f7a2d4$var$pointInTriangleExceptFirst(ax, ay, bx, by, cx, cy, p.x, p.y) && $9ddd7e9b53f7a2d4$var$area(p.prev, p, p.next) >= 0) return false;
        p = p.next;
    }
    return true;
}
function $9ddd7e9b53f7a2d4$var$isEarHashed(ear, minX, minY, invSize) {
    const a = ear.prev, b = ear, c = ear.next;
    if ($9ddd7e9b53f7a2d4$var$area(a, b, c) >= 0) return false; // reflex, can't be an ear
    const ax = a.x, bx = b.x, cx = c.x, ay = a.y, by = b.y, cy = c.y;
    // triangle bbox
    const x0 = Math.min(ax, bx, cx), y0 = Math.min(ay, by, cy), x1 = Math.max(ax, bx, cx), y1 = Math.max(ay, by, cy);
    // z-order range for the current triangle bbox;
    const minZ = $9ddd7e9b53f7a2d4$var$zOrder(x0, y0, minX, minY, invSize), maxZ = $9ddd7e9b53f7a2d4$var$zOrder(x1, y1, minX, minY, invSize);
    let p = ear.prevZ, n = ear.nextZ;
    // look for points inside the triangle in both directions
    while(p && p.z >= minZ && n && n.z <= maxZ){
        if (p.x >= x0 && p.x <= x1 && p.y >= y0 && p.y <= y1 && p !== a && p !== c && $9ddd7e9b53f7a2d4$var$pointInTriangleExceptFirst(ax, ay, bx, by, cx, cy, p.x, p.y) && $9ddd7e9b53f7a2d4$var$area(p.prev, p, p.next) >= 0) return false;
        p = p.prevZ;
        if (n.x >= x0 && n.x <= x1 && n.y >= y0 && n.y <= y1 && n !== a && n !== c && $9ddd7e9b53f7a2d4$var$pointInTriangleExceptFirst(ax, ay, bx, by, cx, cy, n.x, n.y) && $9ddd7e9b53f7a2d4$var$area(n.prev, n, n.next) >= 0) return false;
        n = n.nextZ;
    }
    // look for remaining points in decreasing z-order
    while(p && p.z >= minZ){
        if (p.x >= x0 && p.x <= x1 && p.y >= y0 && p.y <= y1 && p !== a && p !== c && $9ddd7e9b53f7a2d4$var$pointInTriangleExceptFirst(ax, ay, bx, by, cx, cy, p.x, p.y) && $9ddd7e9b53f7a2d4$var$area(p.prev, p, p.next) >= 0) return false;
        p = p.prevZ;
    }
    // look for remaining points in increasing z-order
    while(n && n.z <= maxZ){
        if (n.x >= x0 && n.x <= x1 && n.y >= y0 && n.y <= y1 && n !== a && n !== c && $9ddd7e9b53f7a2d4$var$pointInTriangleExceptFirst(ax, ay, bx, by, cx, cy, n.x, n.y) && $9ddd7e9b53f7a2d4$var$area(n.prev, n, n.next) >= 0) return false;
        n = n.nextZ;
    }
    return true;
}
// go through all polygon nodes and cure small local self-intersections
function $9ddd7e9b53f7a2d4$var$cureLocalIntersections(start, triangles) {
    let p = start;
    do {
        const a = p.prev, b = p.next.next;
        if (!$9ddd7e9b53f7a2d4$var$equals(a, b) && $9ddd7e9b53f7a2d4$var$intersects(a, p, p.next, b) && $9ddd7e9b53f7a2d4$var$locallyInside(a, b) && $9ddd7e9b53f7a2d4$var$locallyInside(b, a)) {
            triangles.push(a.i, p.i, b.i);
            // remove two nodes involved
            $9ddd7e9b53f7a2d4$var$removeNode(p);
            $9ddd7e9b53f7a2d4$var$removeNode(p.next);
            p = start = b;
        }
        p = p.next;
    }while (p !== start);
    return $9ddd7e9b53f7a2d4$var$filterPoints(p);
}
// try splitting polygon into two and triangulate them independently
function $9ddd7e9b53f7a2d4$var$splitEarcut(start, triangles, dim, minX, minY, invSize) {
    // look for a valid diagonal that divides the polygon into two
    let a = start;
    do {
        let b = a.next.next;
        while(b !== a.prev){
            if (a.i !== b.i && $9ddd7e9b53f7a2d4$var$isValidDiagonal(a, b)) {
                // split the polygon in two by the diagonal
                let c = $9ddd7e9b53f7a2d4$var$splitPolygon(a, b);
                // filter colinear points around the cuts
                a = $9ddd7e9b53f7a2d4$var$filterPoints(a, a.next);
                c = $9ddd7e9b53f7a2d4$var$filterPoints(c, c.next);
                // run earcut on each half
                $9ddd7e9b53f7a2d4$var$earcutLinked(a, triangles, dim, minX, minY, invSize, 0);
                $9ddd7e9b53f7a2d4$var$earcutLinked(c, triangles, dim, minX, minY, invSize, 0);
                return;
            }
            b = b.next;
        }
        a = a.next;
    }while (a !== start);
}
// link every hole into the outer loop, producing a single-ring polygon without holes
function $9ddd7e9b53f7a2d4$var$eliminateHoles(data, holeIndices, outerNode, dim) {
    const queue = [];
    for(let i = 0, len = holeIndices.length; i < len; i++){
        const start = holeIndices[i] * dim;
        const end = i < len - 1 ? holeIndices[i + 1] * dim : data.length;
        const list = $9ddd7e9b53f7a2d4$var$linkedList(data, start, end, dim, false);
        if (list === list.next) list.steiner = true;
        queue.push($9ddd7e9b53f7a2d4$var$getLeftmost(list));
    }
    queue.sort($9ddd7e9b53f7a2d4$var$compareXYSlope);
    // process holes from left to right
    for(let i = 0; i < queue.length; i++)outerNode = $9ddd7e9b53f7a2d4$var$eliminateHole(queue[i], outerNode);
    return outerNode;
}
function $9ddd7e9b53f7a2d4$var$compareXYSlope(a, b) {
    let result = a.x - b.x;
    // when the left-most point of 2 holes meet at a vertex, sort the holes counterclockwise so that when we find
    // the bridge to the outer shell is always the point that they meet at.
    if (result === 0) {
        result = a.y - b.y;
        if (result === 0) {
            const aSlope = (a.next.y - a.y) / (a.next.x - a.x);
            const bSlope = (b.next.y - b.y) / (b.next.x - b.x);
            result = aSlope - bSlope;
        }
    }
    return result;
}
// find a bridge between vertices that connects hole with an outer ring and and link it
function $9ddd7e9b53f7a2d4$var$eliminateHole(hole, outerNode) {
    const bridge = $9ddd7e9b53f7a2d4$var$findHoleBridge(hole, outerNode);
    if (!bridge) return outerNode;
    const bridgeReverse = $9ddd7e9b53f7a2d4$var$splitPolygon(bridge, hole);
    // filter collinear points around the cuts
    $9ddd7e9b53f7a2d4$var$filterPoints(bridgeReverse, bridgeReverse.next);
    return $9ddd7e9b53f7a2d4$var$filterPoints(bridge, bridge.next);
}
// David Eberly's algorithm for finding a bridge between hole and outer polygon
function $9ddd7e9b53f7a2d4$var$findHoleBridge(hole, outerNode) {
    let p = outerNode;
    const hx = hole.x;
    const hy = hole.y;
    let qx = -Infinity;
    let m;
    // find a segment intersected by a ray from the hole's leftmost point to the left;
    // segment's endpoint with lesser x will be potential connection point
    // unless they intersect at a vertex, then choose the vertex
    if ($9ddd7e9b53f7a2d4$var$equals(hole, p)) return p;
    do {
        if ($9ddd7e9b53f7a2d4$var$equals(hole, p.next)) return p.next;
        else if (hy <= p.y && hy >= p.next.y && p.next.y !== p.y) {
            const x = p.x + (hy - p.y) * (p.next.x - p.x) / (p.next.y - p.y);
            if (x <= hx && x > qx) {
                qx = x;
                m = p.x < p.next.x ? p : p.next;
                if (x === hx) return m; // hole touches outer segment; pick leftmost endpoint
            }
        }
        p = p.next;
    }while (p !== outerNode);
    if (!m) return null;
    // look for points inside the triangle of hole point, segment intersection and endpoint;
    // if there are no points found, we have a valid connection;
    // otherwise choose the point of the minimum angle with the ray as connection point
    const stop = m;
    const mx = m.x;
    const my = m.y;
    let tanMin = Infinity;
    p = m;
    do {
        if (hx >= p.x && p.x >= mx && hx !== p.x && $9ddd7e9b53f7a2d4$var$pointInTriangle(hy < my ? hx : qx, hy, mx, my, hy < my ? qx : hx, hy, p.x, p.y)) {
            const tan = Math.abs(hy - p.y) / (hx - p.x); // tangential
            if ($9ddd7e9b53f7a2d4$var$locallyInside(p, hole) && (tan < tanMin || tan === tanMin && (p.x > m.x || p.x === m.x && $9ddd7e9b53f7a2d4$var$sectorContainsSector(m, p)))) {
                m = p;
                tanMin = tan;
            }
        }
        p = p.next;
    }while (p !== stop);
    return m;
}
// whether sector in vertex m contains sector in vertex p in the same coordinates
function $9ddd7e9b53f7a2d4$var$sectorContainsSector(m, p) {
    return $9ddd7e9b53f7a2d4$var$area(m.prev, m, p.prev) < 0 && $9ddd7e9b53f7a2d4$var$area(p.next, m, m.next) < 0;
}
// interlink polygon nodes in z-order
function $9ddd7e9b53f7a2d4$var$indexCurve(start, minX, minY, invSize) {
    let p = start;
    do {
        if (p.z === 0) p.z = $9ddd7e9b53f7a2d4$var$zOrder(p.x, p.y, minX, minY, invSize);
        p.prevZ = p.prev;
        p.nextZ = p.next;
        p = p.next;
    }while (p !== start);
    p.prevZ.nextZ = null;
    p.prevZ = null;
    $9ddd7e9b53f7a2d4$var$sortLinked(p);
}
// Simon Tatham's linked list merge sort algorithm
// http://www.chiark.greenend.org.uk/~sgtatham/algorithms/listsort.html
function $9ddd7e9b53f7a2d4$var$sortLinked(list) {
    let numMerges;
    let inSize = 1;
    do {
        let p = list;
        let e;
        list = null;
        let tail = null;
        numMerges = 0;
        while(p){
            numMerges++;
            let q = p;
            let pSize = 0;
            for(let i = 0; i < inSize; i++){
                pSize++;
                q = q.nextZ;
                if (!q) break;
            }
            let qSize = inSize;
            while(pSize > 0 || qSize > 0 && q){
                if (pSize !== 0 && (qSize === 0 || !q || p.z <= q.z)) {
                    e = p;
                    p = p.nextZ;
                    pSize--;
                } else {
                    e = q;
                    q = q.nextZ;
                    qSize--;
                }
                if (tail) tail.nextZ = e;
                else list = e;
                e.prevZ = tail;
                tail = e;
            }
            p = q;
        }
        tail.nextZ = null;
        inSize *= 2;
    }while (numMerges > 1);
    return list;
}
// z-order of a point given coords and inverse of the longer side of data bbox
function $9ddd7e9b53f7a2d4$var$zOrder(x, y, minX, minY, invSize) {
    // coords are transformed into non-negative 15-bit integer range
    x = (x - minX) * invSize | 0;
    y = (y - minY) * invSize | 0;
    x = (x | x << 8) & 0x00FF00FF;
    x = (x | x << 4) & 0x0F0F0F0F;
    x = (x | x << 2) & 0x33333333;
    x = (x | x << 1) & 0x55555555;
    y = (y | y << 8) & 0x00FF00FF;
    y = (y | y << 4) & 0x0F0F0F0F;
    y = (y | y << 2) & 0x33333333;
    y = (y | y << 1) & 0x55555555;
    return x | y << 1;
}
// find the leftmost node of a polygon ring
function $9ddd7e9b53f7a2d4$var$getLeftmost(start) {
    let p = start, leftmost = start;
    do {
        if (p.x < leftmost.x || p.x === leftmost.x && p.y < leftmost.y) leftmost = p;
        p = p.next;
    }while (p !== start);
    return leftmost;
}
// check if a point lies within a convex triangle
function $9ddd7e9b53f7a2d4$var$pointInTriangle(ax, ay, bx, by, cx, cy, px, py) {
    return (cx - px) * (ay - py) >= (ax - px) * (cy - py) && (ax - px) * (by - py) >= (bx - px) * (ay - py) && (bx - px) * (cy - py) >= (cx - px) * (by - py);
}
// check if a point lies within a convex triangle but false if its equal to the first point of the triangle
function $9ddd7e9b53f7a2d4$var$pointInTriangleExceptFirst(ax, ay, bx, by, cx, cy, px, py) {
    return !(ax === px && ay === py) && $9ddd7e9b53f7a2d4$var$pointInTriangle(ax, ay, bx, by, cx, cy, px, py);
}
// check if a diagonal between two polygon nodes is valid (lies in polygon interior)
function $9ddd7e9b53f7a2d4$var$isValidDiagonal(a, b) {
    return a.next.i !== b.i && a.prev.i !== b.i && !$9ddd7e9b53f7a2d4$var$intersectsPolygon(a, b) && // dones't intersect other edges
    ($9ddd7e9b53f7a2d4$var$locallyInside(a, b) && $9ddd7e9b53f7a2d4$var$locallyInside(b, a) && $9ddd7e9b53f7a2d4$var$middleInside(a, b) && // locally visible
    ($9ddd7e9b53f7a2d4$var$area(a.prev, a, b.prev) || $9ddd7e9b53f7a2d4$var$area(a, b.prev, b)) || // does not create opposite-facing sectors
    $9ddd7e9b53f7a2d4$var$equals(a, b) && $9ddd7e9b53f7a2d4$var$area(a.prev, a, a.next) > 0 && $9ddd7e9b53f7a2d4$var$area(b.prev, b, b.next) > 0); // special zero-length case
}
// signed area of a triangle
function $9ddd7e9b53f7a2d4$var$area(p, q, r) {
    return (q.y - p.y) * (r.x - q.x) - (q.x - p.x) * (r.y - q.y);
}
// check if two points are equal
function $9ddd7e9b53f7a2d4$var$equals(p1, p2) {
    return p1.x === p2.x && p1.y === p2.y;
}
// check if two segments intersect
function $9ddd7e9b53f7a2d4$var$intersects(p1, q1, p2, q2) {
    const o1 = $9ddd7e9b53f7a2d4$var$sign($9ddd7e9b53f7a2d4$var$area(p1, q1, p2));
    const o2 = $9ddd7e9b53f7a2d4$var$sign($9ddd7e9b53f7a2d4$var$area(p1, q1, q2));
    const o3 = $9ddd7e9b53f7a2d4$var$sign($9ddd7e9b53f7a2d4$var$area(p2, q2, p1));
    const o4 = $9ddd7e9b53f7a2d4$var$sign($9ddd7e9b53f7a2d4$var$area(p2, q2, q1));
    if (o1 !== o2 && o3 !== o4) return true; // general case
    if (o1 === 0 && $9ddd7e9b53f7a2d4$var$onSegment(p1, p2, q1)) return true; // p1, q1 and p2 are collinear and p2 lies on p1q1
    if (o2 === 0 && $9ddd7e9b53f7a2d4$var$onSegment(p1, q2, q1)) return true; // p1, q1 and q2 are collinear and q2 lies on p1q1
    if (o3 === 0 && $9ddd7e9b53f7a2d4$var$onSegment(p2, p1, q2)) return true; // p2, q2 and p1 are collinear and p1 lies on p2q2
    if (o4 === 0 && $9ddd7e9b53f7a2d4$var$onSegment(p2, q1, q2)) return true; // p2, q2 and q1 are collinear and q1 lies on p2q2
    return false;
}
// for collinear points p, q, r, check if point q lies on segment pr
function $9ddd7e9b53f7a2d4$var$onSegment(p, q, r) {
    return q.x <= Math.max(p.x, r.x) && q.x >= Math.min(p.x, r.x) && q.y <= Math.max(p.y, r.y) && q.y >= Math.min(p.y, r.y);
}
function $9ddd7e9b53f7a2d4$var$sign(num) {
    return num > 0 ? 1 : num < 0 ? -1 : 0;
}
// check if a polygon diagonal intersects any polygon segments
function $9ddd7e9b53f7a2d4$var$intersectsPolygon(a, b) {
    let p = a;
    do {
        if (p.i !== a.i && p.next.i !== a.i && p.i !== b.i && p.next.i !== b.i && $9ddd7e9b53f7a2d4$var$intersects(p, p.next, a, b)) return true;
        p = p.next;
    }while (p !== a);
    return false;
}
// check if a polygon diagonal is locally inside the polygon
function $9ddd7e9b53f7a2d4$var$locallyInside(a, b) {
    return $9ddd7e9b53f7a2d4$var$area(a.prev, a, a.next) < 0 ? $9ddd7e9b53f7a2d4$var$area(a, b, a.next) >= 0 && $9ddd7e9b53f7a2d4$var$area(a, a.prev, b) >= 0 : $9ddd7e9b53f7a2d4$var$area(a, b, a.prev) < 0 || $9ddd7e9b53f7a2d4$var$area(a, a.next, b) < 0;
}
// check if the middle point of a polygon diagonal is inside the polygon
function $9ddd7e9b53f7a2d4$var$middleInside(a, b) {
    let p = a;
    let inside = false;
    const px = (a.x + b.x) / 2;
    const py = (a.y + b.y) / 2;
    do {
        if (p.y > py !== p.next.y > py && p.next.y !== p.y && px < (p.next.x - p.x) * (py - p.y) / (p.next.y - p.y) + p.x) inside = !inside;
        p = p.next;
    }while (p !== a);
    return inside;
}
// link two polygon vertices with a bridge; if the vertices belong to the same ring, it splits polygon into two;
// if one belongs to the outer ring and another to a hole, it merges it into a single ring
function $9ddd7e9b53f7a2d4$var$splitPolygon(a, b) {
    const a2 = $9ddd7e9b53f7a2d4$var$createNode(a.i, a.x, a.y), b2 = $9ddd7e9b53f7a2d4$var$createNode(b.i, b.x, b.y), an = a.next, bp = b.prev;
    a.next = b;
    b.prev = a;
    a2.next = an;
    an.prev = a2;
    b2.next = a2;
    a2.prev = b2;
    bp.next = b2;
    b2.prev = bp;
    return b2;
}
// create a node and optionally link it with previous one (in a circular doubly linked list)
function $9ddd7e9b53f7a2d4$var$insertNode(i, x, y, last) {
    const p = $9ddd7e9b53f7a2d4$var$createNode(i, x, y);
    if (!last) {
        p.prev = p;
        p.next = p;
    } else {
        p.next = last.next;
        p.prev = last;
        last.next.prev = p;
        last.next = p;
    }
    return p;
}
function $9ddd7e9b53f7a2d4$var$removeNode(p) {
    p.next.prev = p.prev;
    p.prev.next = p.next;
    if (p.prevZ) p.prevZ.nextZ = p.nextZ;
    if (p.nextZ) p.nextZ.prevZ = p.prevZ;
}
function $9ddd7e9b53f7a2d4$var$createNode(i, x, y) {
    return {
        i: i,
        x: x,
        y: y,
        prev: null,
        next: null,
        z: 0,
        prevZ: null,
        nextZ: null,
        steiner: false // indicates whether this is a steiner point
    };
}
function $9ddd7e9b53f7a2d4$var$signedArea(data, start, end, dim) {
    let sum = 0;
    for(let i = start, j = end - dim; i < end; i += dim){
        sum += (data[j] - data[i]) * (data[i + 1] + data[j + 1]);
        j = i;
    }
    return sum;
}
class $9ddd7e9b53f7a2d4$var$Earcut {
    /**
	 * Triangulates the given shape definition by returning an array of triangles.
	 *
	 * @param {Array<number>} data - An array with 2D points.
	 * @param {Array<number>} holeIndices - An array with indices defining holes.
	 * @param {number} [dim=2] - The number of coordinates per vertex in the input array.
	 * @return {Array<number>} An array representing the triangulated faces. Each face is defined by three consecutive numbers
	 * representing vertex indices.
	 */ static triangulate(data, holeIndices, dim = 2) {
        return $9ddd7e9b53f7a2d4$var$earcut(data, holeIndices, dim);
    }
}
/**
 * A class containing utility functions for shapes.
 *
 * @hideconstructor
 */ class $9ddd7e9b53f7a2d4$export$96bdf6d9c66d7ba8 {
    /**
	 * Calculate area of a ( 2D ) contour polygon.
	 *
	 * @param {Array<Vector2>} contour - An array of 2D points.
	 * @return {number} The area.
	 */ static area(contour) {
        const n = contour.length;
        let a = 0.0;
        for(let p = n - 1, q = 0; q < n; p = q++)a += contour[p].x * contour[q].y - contour[q].x * contour[p].y;
        return a * 0.5;
    }
    /**
	 * Returns `true` if the given contour uses a clockwise winding order.
	 *
	 * @param {Array<Vector2>} pts - An array of 2D points defining a polygon.
	 * @return {boolean} Whether the given contour uses a clockwise winding order or not.
	 */ static isClockWise(pts) {
        return $9ddd7e9b53f7a2d4$export$96bdf6d9c66d7ba8.area(pts) < 0;
    }
    /**
	 * Triangulates the given shape definition.
	 *
	 * @param {Array<Vector2>} contour - An array of 2D points defining the contour.
	 * @param {Array<Array<Vector2>>} holes - An array that holds arrays of 2D points defining the holes.
	 * @return {Array<Array<number>>} An array that holds for each face definition an array with three indices.
	 */ static triangulateShape(contour, holes) {
        const vertices = []; // flat array of vertices like [ x0,y0, x1,y1, x2,y2, ... ]
        const holeIndices = []; // array of hole indices
        const faces = []; // final array of vertex indices like [ [ a,b,d ], [ b,c,d ] ]
        $9ddd7e9b53f7a2d4$var$removeDupEndPts(contour);
        $9ddd7e9b53f7a2d4$var$addContour(vertices, contour);
        //
        let holeIndex = contour.length;
        holes.forEach($9ddd7e9b53f7a2d4$var$removeDupEndPts);
        for(let i = 0; i < holes.length; i++){
            holeIndices.push(holeIndex);
            holeIndex += holes[i].length;
            $9ddd7e9b53f7a2d4$var$addContour(vertices, holes[i]);
        }
        //
        const triangles = $9ddd7e9b53f7a2d4$var$Earcut.triangulate(vertices, holeIndices);
        //
        for(let i = 0; i < triangles.length; i += 3)faces.push(triangles.slice(i, i + 3));
        return faces;
    }
}
function $9ddd7e9b53f7a2d4$var$removeDupEndPts(points) {
    const l = points.length;
    if (l > 2 && points[l - 1].equals(points[0])) points.pop();
}
function $9ddd7e9b53f7a2d4$var$addContour(vertices, contour) {
    for(let i = 0; i < contour.length; i++){
        vertices.push(contour[i].x);
        vertices.push(contour[i].y);
    }
}
/**
 * Creates extruded geometry from a path shape.
 *
 * ```js
 * const length = 12, width = 8;
 *
 * const shape = new THREE.Shape();
 * shape.moveTo( 0,0 );
 * shape.lineTo( 0, width );
 * shape.lineTo( length, width );
 * shape.lineTo( length, 0 );
 * shape.lineTo( 0, 0 );
 *
 * const geometry = new THREE.ExtrudeGeometry( shape );
 * const material = new THREE.MeshBasicMaterial( { color: 0x00ff00 } );
 * const mesh = new THREE.Mesh( geometry, material ) ;
 * scene.add( mesh );
 * ```
 *
 * @augments BufferGeometry
 */ class $9ddd7e9b53f7a2d4$export$598697a1efa63ca7 extends $9ddd7e9b53f7a2d4$export$b7be63a67df8959 {
    /**
	 * Constructs a new extrude geometry.
	 *
	 * @param {Shape|Array<Shape>} [shapes] - A shape or an array of shapes.
	 * @param {ExtrudeGeometry~Options} [options] - The extrude settings.
	 */ constructor(shapes = new $9ddd7e9b53f7a2d4$export$6428a7f2611ef1fa([
        new $9ddd7e9b53f7a2d4$export$c977b3e384af9ae1(0.5, 0.5),
        new $9ddd7e9b53f7a2d4$export$c977b3e384af9ae1(-0.5, 0.5),
        new $9ddd7e9b53f7a2d4$export$c977b3e384af9ae1(-0.5, -0.5),
        new $9ddd7e9b53f7a2d4$export$c977b3e384af9ae1(0.5, -0.5)
    ]), options = {}){
        super();
        this.type = 'ExtrudeGeometry';
        /**
		 * Holds the constructor parameters that have been
		 * used to generate the geometry. Any modification
		 * after instantiation does not change the geometry.
		 *
		 * @type {Object}
		 */ this.parameters = {
            shapes: shapes,
            options: options
        };
        shapes = Array.isArray(shapes) ? shapes : [
            shapes
        ];
        const scope = this;
        const verticesArray = [];
        const uvArray = [];
        for(let i = 0, l = shapes.length; i < l; i++){
            const shape = shapes[i];
            addShape(shape);
        }
        // build geometry
        this.setAttribute('position', new $9ddd7e9b53f7a2d4$export$cbe7a62641830ebd(verticesArray, 3));
        this.setAttribute('uv', new $9ddd7e9b53f7a2d4$export$cbe7a62641830ebd(uvArray, 2));
        this.computeVertexNormals();
        // functions
        function addShape(shape) {
            const placeholder = [];
            // options
            const curveSegments = options.curveSegments !== undefined ? options.curveSegments : 12;
            const steps = options.steps !== undefined ? options.steps : 1;
            const depth = options.depth !== undefined ? options.depth : 1;
            let bevelEnabled = options.bevelEnabled !== undefined ? options.bevelEnabled : true;
            let bevelThickness = options.bevelThickness !== undefined ? options.bevelThickness : 0.2;
            let bevelSize = options.bevelSize !== undefined ? options.bevelSize : bevelThickness - 0.1;
            let bevelOffset = options.bevelOffset !== undefined ? options.bevelOffset : 0;
            let bevelSegments = options.bevelSegments !== undefined ? options.bevelSegments : 3;
            const extrudePath = options.extrudePath;
            const uvgen = options.UVGenerator !== undefined ? options.UVGenerator : $9ddd7e9b53f7a2d4$var$WorldUVGenerator;
            //
            let extrudePts, extrudeByPath = false;
            let splineTube, binormal, normal, position2;
            if (extrudePath) {
                extrudePts = extrudePath.getSpacedPoints(steps);
                extrudeByPath = true;
                bevelEnabled = false; // bevels not supported for path extrusion
                // SETUP TNB variables
                // TODO1 - have a .isClosed in spline?
                splineTube = extrudePath.computeFrenetFrames(steps, false);
                // console.log(splineTube, 'splineTube', splineTube.normals.length, 'steps', steps, 'extrudePts', extrudePts.length);
                binormal = new $9ddd7e9b53f7a2d4$export$64b5c384219d3699();
                normal = new $9ddd7e9b53f7a2d4$export$64b5c384219d3699();
                position2 = new $9ddd7e9b53f7a2d4$export$64b5c384219d3699();
            }
            // Safeguards if bevels are not enabled
            if (!bevelEnabled) {
                bevelSegments = 0;
                bevelThickness = 0;
                bevelSize = 0;
                bevelOffset = 0;
            }
            // Variables initialization
            const shapePoints = shape.extractPoints(curveSegments);
            let vertices = shapePoints.shape;
            const holes = shapePoints.holes;
            const reverse = !$9ddd7e9b53f7a2d4$export$96bdf6d9c66d7ba8.isClockWise(vertices);
            if (reverse) {
                vertices = vertices.reverse();
                // Maybe we should also check if holes are in the opposite direction, just to be safe ...
                for(let h = 0, hl = holes.length; h < hl; h++){
                    const ahole = holes[h];
                    if ($9ddd7e9b53f7a2d4$export$96bdf6d9c66d7ba8.isClockWise(ahole)) holes[h] = ahole.reverse();
                }
            }
            /**Merges index-adjacent points that are within a threshold distance of each other. Array is modified in-place. Threshold distance is empirical, and scaled based on the magnitude of point coordinates.
			 * @param {Array<Vector2>} points
			*/ function mergeOverlappingPoints(points) {
                const THRESHOLD = 1e-10;
                const THRESHOLD_SQ = THRESHOLD * THRESHOLD;
                let prevPos = points[0];
                for(let i = 1; i <= points.length; i++){
                    const currentIndex = i % points.length;
                    const currentPos = points[currentIndex];
                    const dx = currentPos.x - prevPos.x;
                    const dy = currentPos.y - prevPos.y;
                    const distSq = dx * dx + dy * dy;
                    const scalingFactorSqrt = Math.max(Math.abs(currentPos.x), Math.abs(currentPos.y), Math.abs(prevPos.x), Math.abs(prevPos.y));
                    const thesholdSqScaled = THRESHOLD_SQ * scalingFactorSqrt * scalingFactorSqrt;
                    if (distSq <= thesholdSqScaled) {
                        points.splice(currentIndex, 1);
                        i--;
                        continue;
                    }
                    prevPos = currentPos;
                }
            }
            mergeOverlappingPoints(vertices);
            holes.forEach(mergeOverlappingPoints);
            const numHoles = holes.length;
            /* Vertices */ const contour = vertices; // vertices has all points but contour has only points of circumference
            for(let h = 0; h < numHoles; h++){
                const ahole = holes[h];
                vertices = vertices.concat(ahole);
            }
            function scalePt2(pt, vec, size) {
                if (!vec) console.error('THREE.ExtrudeGeometry: vec does not exist');
                return pt.clone().addScaledVector(vec, size);
            }
            const vlen = vertices.length;
            // Find directions for point movement
            function getBevelVec(inPt, inPrev, inNext) {
                // computes for inPt the corresponding point inPt' on a new contour
                //   shifted by 1 unit (length of normalized vector) to the left
                // if we walk along contour clockwise, this new contour is outside the old one
                //
                // inPt' is the intersection of the two lines parallel to the two
                //  adjacent edges of inPt at a distance of 1 unit on the left side.
                let v_trans_x, v_trans_y, shrink_by; // resulting translation vector for inPt
                // good reading for geometry algorithms (here: line-line intersection)
                // http://geomalgorithms.com/a05-_intersect-1.html
                const v_prev_x = inPt.x - inPrev.x, v_prev_y = inPt.y - inPrev.y;
                const v_next_x = inNext.x - inPt.x, v_next_y = inNext.y - inPt.y;
                const v_prev_lensq = v_prev_x * v_prev_x + v_prev_y * v_prev_y;
                // check for collinear edges
                const collinear0 = v_prev_x * v_next_y - v_prev_y * v_next_x;
                if (Math.abs(collinear0) > Number.EPSILON) {
                    // not collinear
                    // length of vectors for normalizing
                    const v_prev_len = Math.sqrt(v_prev_lensq);
                    const v_next_len = Math.sqrt(v_next_x * v_next_x + v_next_y * v_next_y);
                    // shift adjacent points by unit vectors to the left
                    const ptPrevShift_x = inPrev.x - v_prev_y / v_prev_len;
                    const ptPrevShift_y = inPrev.y + v_prev_x / v_prev_len;
                    const ptNextShift_x = inNext.x - v_next_y / v_next_len;
                    const ptNextShift_y = inNext.y + v_next_x / v_next_len;
                    // scaling factor for v_prev to intersection point
                    const sf = ((ptNextShift_x - ptPrevShift_x) * v_next_y - (ptNextShift_y - ptPrevShift_y) * v_next_x) / (v_prev_x * v_next_y - v_prev_y * v_next_x);
                    // vector from inPt to intersection point
                    v_trans_x = ptPrevShift_x + v_prev_x * sf - inPt.x;
                    v_trans_y = ptPrevShift_y + v_prev_y * sf - inPt.y;
                    // Don't normalize!, otherwise sharp corners become ugly
                    //  but prevent crazy spikes
                    const v_trans_lensq = v_trans_x * v_trans_x + v_trans_y * v_trans_y;
                    if (v_trans_lensq <= 2) return new $9ddd7e9b53f7a2d4$export$c977b3e384af9ae1(v_trans_x, v_trans_y);
                    else shrink_by = Math.sqrt(v_trans_lensq / 2);
                } else {
                    // handle special case of collinear edges
                    let direction_eq = false; // assumes: opposite
                    if (v_prev_x > Number.EPSILON) {
                        if (v_next_x > Number.EPSILON) direction_eq = true;
                    } else {
                        if (v_prev_x < -Number.EPSILON) {
                            if (v_next_x < -Number.EPSILON) direction_eq = true;
                        } else if (Math.sign(v_prev_y) === Math.sign(v_next_y)) direction_eq = true;
                    }
                    if (direction_eq) {
                        // console.log("Warning: lines are a straight sequence");
                        v_trans_x = -v_prev_y;
                        v_trans_y = v_prev_x;
                        shrink_by = Math.sqrt(v_prev_lensq);
                    } else {
                        // console.log("Warning: lines are a straight spike");
                        v_trans_x = v_prev_x;
                        v_trans_y = v_prev_y;
                        shrink_by = Math.sqrt(v_prev_lensq / 2);
                    }
                }
                return new $9ddd7e9b53f7a2d4$export$c977b3e384af9ae1(v_trans_x / shrink_by, v_trans_y / shrink_by);
            }
            const contourMovements = [];
            for(let i = 0, il = contour.length, j = il - 1, k = i + 1; i < il; i++, j++, k++){
                if (j === il) j = 0;
                if (k === il) k = 0;
                //  (j)---(i)---(k)
                // console.log('i,j,k', i, j , k)
                contourMovements[i] = getBevelVec(contour[i], contour[j], contour[k]);
            }
            const holesMovements = [];
            let oneHoleMovements, verticesMovements = contourMovements.concat();
            for(let h = 0, hl = numHoles; h < hl; h++){
                const ahole = holes[h];
                oneHoleMovements = [];
                for(let i = 0, il = ahole.length, j = il - 1, k = i + 1; i < il; i++, j++, k++){
                    if (j === il) j = 0;
                    if (k === il) k = 0;
                    //  (j)---(i)---(k)
                    oneHoleMovements[i] = getBevelVec(ahole[i], ahole[j], ahole[k]);
                }
                holesMovements.push(oneHoleMovements);
                verticesMovements = verticesMovements.concat(oneHoleMovements);
            }
            const contractedContourVertices = [];
            const expandedHoleVertices = [];
            // Loop bevelSegments, 1 for the front, 1 for the back
            for(let b = 0; b < bevelSegments; b++){
                //for ( b = bevelSegments; b > 0; b -- ) {
                const t = b / bevelSegments;
                const z = bevelThickness * Math.cos(t * Math.PI / 2);
                const bs = bevelSize * Math.sin(t * Math.PI / 2) + bevelOffset;
                // contract shape
                for(let i = 0, il = contour.length; i < il; i++){
                    const vert = scalePt2(contour[i], contourMovements[i], bs);
                    v(vert.x, vert.y, -z);
                    if (t == 0) contractedContourVertices.push(vert);
                }
                // expand holes
                for(let h = 0, hl = numHoles; h < hl; h++){
                    const ahole = holes[h];
                    oneHoleMovements = holesMovements[h];
                    const oneHoleVertices = [];
                    for(let i = 0, il = ahole.length; i < il; i++){
                        const vert = scalePt2(ahole[i], oneHoleMovements[i], bs);
                        v(vert.x, vert.y, -z);
                        if (t == 0) oneHoleVertices.push(vert);
                    }
                    if (t == 0) expandedHoleVertices.push(oneHoleVertices);
                }
            }
            const faces = $9ddd7e9b53f7a2d4$export$96bdf6d9c66d7ba8.triangulateShape(contractedContourVertices, expandedHoleVertices);
            const flen = faces.length;
            const bs = bevelSize + bevelOffset;
            // Back facing vertices
            for(let i = 0; i < vlen; i++){
                const vert = bevelEnabled ? scalePt2(vertices[i], verticesMovements[i], bs) : vertices[i];
                if (!extrudeByPath) v(vert.x, vert.y, 0);
                else {
                    // v( vert.x, vert.y + extrudePts[ 0 ].y, extrudePts[ 0 ].x );
                    normal.copy(splineTube.normals[0]).multiplyScalar(vert.x);
                    binormal.copy(splineTube.binormals[0]).multiplyScalar(vert.y);
                    position2.copy(extrudePts[0]).add(normal).add(binormal);
                    v(position2.x, position2.y, position2.z);
                }
            }
            // Add stepped vertices...
            // Including front facing vertices
            for(let s = 1; s <= steps; s++)for(let i = 0; i < vlen; i++){
                const vert = bevelEnabled ? scalePt2(vertices[i], verticesMovements[i], bs) : vertices[i];
                if (!extrudeByPath) v(vert.x, vert.y, depth / steps * s);
                else {
                    // v( vert.x, vert.y + extrudePts[ s - 1 ].y, extrudePts[ s - 1 ].x );
                    normal.copy(splineTube.normals[s]).multiplyScalar(vert.x);
                    binormal.copy(splineTube.binormals[s]).multiplyScalar(vert.y);
                    position2.copy(extrudePts[s]).add(normal).add(binormal);
                    v(position2.x, position2.y, position2.z);
                }
            }
            // Add bevel segments planes
            //for ( b = 1; b <= bevelSegments; b ++ ) {
            for(let b = bevelSegments - 1; b >= 0; b--){
                const t = b / bevelSegments;
                const z = bevelThickness * Math.cos(t * Math.PI / 2);
                const bs = bevelSize * Math.sin(t * Math.PI / 2) + bevelOffset;
                // contract shape
                for(let i = 0, il = contour.length; i < il; i++){
                    const vert = scalePt2(contour[i], contourMovements[i], bs);
                    v(vert.x, vert.y, depth + z);
                }
                // expand holes
                for(let h = 0, hl = holes.length; h < hl; h++){
                    const ahole = holes[h];
                    oneHoleMovements = holesMovements[h];
                    for(let i = 0, il = ahole.length; i < il; i++){
                        const vert = scalePt2(ahole[i], oneHoleMovements[i], bs);
                        if (!extrudeByPath) v(vert.x, vert.y, depth + z);
                        else v(vert.x, vert.y + extrudePts[steps - 1].y, extrudePts[steps - 1].x + z);
                    }
                }
            }
            /* Faces */ // Top and bottom faces
            buildLidFaces();
            // Sides faces
            buildSideFaces();
            /////  Internal functions
            function buildLidFaces() {
                const start = verticesArray.length / 3;
                if (bevelEnabled) {
                    let layer = 0; // steps + 1
                    let offset = vlen * layer;
                    // Bottom faces
                    for(let i = 0; i < flen; i++){
                        const face = faces[i];
                        f3(face[2] + offset, face[1] + offset, face[0] + offset);
                    }
                    layer = steps + bevelSegments * 2;
                    offset = vlen * layer;
                    // Top faces
                    for(let i = 0; i < flen; i++){
                        const face = faces[i];
                        f3(face[0] + offset, face[1] + offset, face[2] + offset);
                    }
                } else {
                    // Bottom faces
                    for(let i = 0; i < flen; i++){
                        const face = faces[i];
                        f3(face[2], face[1], face[0]);
                    }
                    // Top faces
                    for(let i = 0; i < flen; i++){
                        const face = faces[i];
                        f3(face[0] + vlen * steps, face[1] + vlen * steps, face[2] + vlen * steps);
                    }
                }
                scope.addGroup(start, verticesArray.length / 3 - start, 0);
            }
            // Create faces for the z-sides of the shape
            function buildSideFaces() {
                const start = verticesArray.length / 3;
                let layeroffset = 0;
                sidewalls(contour, layeroffset);
                layeroffset += contour.length;
                for(let h = 0, hl = holes.length; h < hl; h++){
                    const ahole = holes[h];
                    sidewalls(ahole, layeroffset);
                    //, true
                    layeroffset += ahole.length;
                }
                scope.addGroup(start, verticesArray.length / 3 - start, 1);
            }
            function sidewalls(contour, layeroffset) {
                let i = contour.length;
                while(--i >= 0){
                    const j = i;
                    let k = i - 1;
                    if (k < 0) k = contour.length - 1;
                    //console.log('b', i,j, i-1, k,vertices.length);
                    for(let s = 0, sl = steps + bevelSegments * 2; s < sl; s++){
                        const slen1 = vlen * s;
                        const slen2 = vlen * (s + 1);
                        const a = layeroffset + j + slen1, b = layeroffset + k + slen1, c = layeroffset + k + slen2, d = layeroffset + j + slen2;
                        f4(a, b, c, d);
                    }
                }
            }
            function v(x, y, z) {
                placeholder.push(x);
                placeholder.push(y);
                placeholder.push(z);
            }
            function f3(a, b, c) {
                addVertex(a);
                addVertex(b);
                addVertex(c);
                const nextIndex = verticesArray.length / 3;
                const uvs = uvgen.generateTopUV(scope, verticesArray, nextIndex - 3, nextIndex - 2, nextIndex - 1);
                addUV(uvs[0]);
                addUV(uvs[1]);
                addUV(uvs[2]);
            }
            function f4(a, b, c, d) {
                addVertex(a);
                addVertex(b);
                addVertex(d);
                addVertex(b);
                addVertex(c);
                addVertex(d);
                const nextIndex = verticesArray.length / 3;
                const uvs = uvgen.generateSideWallUV(scope, verticesArray, nextIndex - 6, nextIndex - 3, nextIndex - 2, nextIndex - 1);
                addUV(uvs[0]);
                addUV(uvs[1]);
                addUV(uvs[3]);
                addUV(uvs[1]);
                addUV(uvs[2]);
                addUV(uvs[3]);
            }
            function addVertex(index) {
                verticesArray.push(placeholder[index * 3 + 0]);
                verticesArray.push(placeholder[index * 3 + 1]);
                verticesArray.push(placeholder[index * 3 + 2]);
            }
            function addUV(vector2) {
                uvArray.push(vector2.x);
                uvArray.push(vector2.y);
            }
        }
    }
    copy(source) {
        super.copy(source);
        this.parameters = Object.assign({}, source.parameters);
        return this;
    }
    toJSON() {
        const data = super.toJSON();
        const shapes = this.parameters.shapes;
        const options = this.parameters.options;
        return $9ddd7e9b53f7a2d4$var$toJSON$1(shapes, options, data);
    }
    /**
	 * Factory method for creating an instance of this class from the given
	 * JSON object.
	 *
	 * @param {Object} data - A JSON object representing the serialized geometry.
	 * @param {Array<Shape>} shapes - An array of shapes.
	 * @return {ExtrudeGeometry} A new instance.
	 */ static fromJSON(data, shapes) {
        const geometryShapes = [];
        for(let j = 0, jl = data.shapes.length; j < jl; j++){
            const shape = shapes[data.shapes[j]];
            geometryShapes.push(shape);
        }
        const extrudePath = data.options.extrudePath;
        if (extrudePath !== undefined) data.options.extrudePath = new $9ddd7e9b53f7a2d4$var$Curves[extrudePath.type]().fromJSON(extrudePath);
        return new $9ddd7e9b53f7a2d4$export$598697a1efa63ca7(geometryShapes, data.options);
    }
}
const $9ddd7e9b53f7a2d4$var$WorldUVGenerator = {
    generateTopUV: function(geometry, vertices, indexA, indexB, indexC) {
        const a_x = vertices[indexA * 3];
        const a_y = vertices[indexA * 3 + 1];
        const b_x = vertices[indexB * 3];
        const b_y = vertices[indexB * 3 + 1];
        const c_x = vertices[indexC * 3];
        const c_y = vertices[indexC * 3 + 1];
        return [
            new $9ddd7e9b53f7a2d4$export$c977b3e384af9ae1(a_x, a_y),
            new $9ddd7e9b53f7a2d4$export$c977b3e384af9ae1(b_x, b_y),
            new $9ddd7e9b53f7a2d4$export$c977b3e384af9ae1(c_x, c_y)
        ];
    },
    generateSideWallUV: function(geometry, vertices, indexA, indexB, indexC, indexD) {
        const a_x = vertices[indexA * 3];
        const a_y = vertices[indexA * 3 + 1];
        const a_z = vertices[indexA * 3 + 2];
        const b_x = vertices[indexB * 3];
        const b_y = vertices[indexB * 3 + 1];
        const b_z = vertices[indexB * 3 + 2];
        const c_x = vertices[indexC * 3];
        const c_y = vertices[indexC * 3 + 1];
        const c_z = vertices[indexC * 3 + 2];
        const d_x = vertices[indexD * 3];
        const d_y = vertices[indexD * 3 + 1];
        const d_z = vertices[indexD * 3 + 2];
        if (Math.abs(a_y - b_y) < Math.abs(a_x - b_x)) return [
            new $9ddd7e9b53f7a2d4$export$c977b3e384af9ae1(a_x, 1 - a_z),
            new $9ddd7e9b53f7a2d4$export$c977b3e384af9ae1(b_x, 1 - b_z),
            new $9ddd7e9b53f7a2d4$export$c977b3e384af9ae1(c_x, 1 - c_z),
            new $9ddd7e9b53f7a2d4$export$c977b3e384af9ae1(d_x, 1 - d_z)
        ];
        else return [
            new $9ddd7e9b53f7a2d4$export$c977b3e384af9ae1(a_y, 1 - a_z),
            new $9ddd7e9b53f7a2d4$export$c977b3e384af9ae1(b_y, 1 - b_z),
            new $9ddd7e9b53f7a2d4$export$c977b3e384af9ae1(c_y, 1 - c_z),
            new $9ddd7e9b53f7a2d4$export$c977b3e384af9ae1(d_y, 1 - d_z)
        ];
    }
};
function $9ddd7e9b53f7a2d4$var$toJSON$1(shapes, options, data) {
    data.shapes = [];
    if (Array.isArray(shapes)) for(let i = 0, l = shapes.length; i < l; i++){
        const shape = shapes[i];
        data.shapes.push(shape.uuid);
    }
    else data.shapes.push(shapes.uuid);
    data.options = Object.assign({}, options);
    if (options.extrudePath !== undefined) data.options.extrudePath = options.extrudePath.toJSON();
    return data;
}
/**
 * A geometry class for representing an icosahedron.
 *
 * ```js
 * const geometry = new THREE.IcosahedronGeometry();
 * const material = new THREE.MeshBasicMaterial( { color: 0xffff00 } );
 * const icosahedron = new THREE.Mesh( geometry, material );
 * scene.add( icosahedron );
 * ```
 *
 * @augments PolyhedronGeometry
 */ class $9ddd7e9b53f7a2d4$export$9567cc828c9535da extends $9ddd7e9b53f7a2d4$export$60e57a7d3f20ff65 {
    /**
	 * Constructs a new icosahedron geometry.
	 *
	 * @param {number} [radius=1] - Radius of the icosahedron.
	 * @param {number} [detail=0] - Setting this to a value greater than `0` adds vertices making it no longer a icosahedron.
	 */ constructor(radius = 1, detail = 0){
        const t = (1 + Math.sqrt(5)) / 2;
        const vertices = [
            -1,
            t,
            0,
            1,
            t,
            0,
            -1,
            -t,
            0,
            1,
            -t,
            0,
            0,
            -1,
            t,
            0,
            1,
            t,
            0,
            -1,
            -t,
            0,
            1,
            -t,
            t,
            0,
            -1,
            t,
            0,
            1,
            -t,
            0,
            -1,
            -t,
            0,
            1
        ];
        const indices = [
            0,
            11,
            5,
            0,
            5,
            1,
            0,
            1,
            7,
            0,
            7,
            10,
            0,
            10,
            11,
            1,
            5,
            9,
            5,
            11,
            4,
            11,
            10,
            2,
            10,
            7,
            6,
            7,
            1,
            8,
            3,
            9,
            4,
            3,
            4,
            2,
            3,
            2,
            6,
            3,
            6,
            8,
            3,
            8,
            9,
            4,
            9,
            5,
            2,
            4,
            11,
            6,
            2,
            10,
            8,
            6,
            7,
            9,
            8,
            1
        ];
        super(vertices, indices, radius, detail);
        this.type = 'IcosahedronGeometry';
        /**
		 * Holds the constructor parameters that have been
		 * used to generate the geometry. Any modification
		 * after instantiation does not change the geometry.
		 *
		 * @type {Object}
		 */ this.parameters = {
            radius: radius,
            detail: detail
        };
    }
    /**
	 * Factory method for creating an instance of this class from the given
	 * JSON object.
	 *
	 * @param {Object} data - A JSON object representing the serialized geometry.
	 * @return {IcosahedronGeometry} A new instance.
	 */ static fromJSON(data) {
        return new $9ddd7e9b53f7a2d4$export$9567cc828c9535da(data.radius, data.detail);
    }
}
/**
 * A geometry class for representing an octahedron.
 *
 * ```js
 * const geometry = new THREE.OctahedronGeometry();
 * const material = new THREE.MeshBasicMaterial( { color: 0xffff00 } );
 * const octahedron = new THREE.Mesh( geometry, material );
 * scene.add( octahedron );
 * ```
 *
 * @augments PolyhedronGeometry
 */ class $9ddd7e9b53f7a2d4$export$1954e2b809fe361e extends $9ddd7e9b53f7a2d4$export$60e57a7d3f20ff65 {
    /**
	 * Constructs a new octahedron geometry.
	 *
	 * @param {number} [radius=1] - Radius of the octahedron.
	 * @param {number} [detail=0] - Setting this to a value greater than `0` adds vertices making it no longer a octahedron.
	 */ constructor(radius = 1, detail = 0){
        const vertices = [
            1,
            0,
            0,
            -1,
            0,
            0,
            0,
            1,
            0,
            0,
            -1,
            0,
            0,
            0,
            1,
            0,
            0,
            -1
        ];
        const indices = [
            0,
            2,
            4,
            0,
            4,
            3,
            0,
            3,
            5,
            0,
            5,
            2,
            1,
            2,
            5,
            1,
            5,
            3,
            1,
            3,
            4,
            1,
            4,
            2
        ];
        super(vertices, indices, radius, detail);
        this.type = 'OctahedronGeometry';
        /**
		 * Holds the constructor parameters that have been
		 * used to generate the geometry. Any modification
		 * after instantiation does not change the geometry.
		 *
		 * @type {Object}
		 */ this.parameters = {
            radius: radius,
            detail: detail
        };
    }
    /**
	 * Factory method for creating an instance of this class from the given
	 * JSON object.
	 *
	 * @param {Object} data - A JSON object representing the serialized geometry.
	 * @return {OctahedronGeometry} A new instance.
	 */ static fromJSON(data) {
        return new $9ddd7e9b53f7a2d4$export$1954e2b809fe361e(data.radius, data.detail);
    }
}
/**
 * A geometry class for representing a plane.
 *
 * ```js
 * const geometry = new THREE.PlaneGeometry( 1, 1 );
 * const material = new THREE.MeshBasicMaterial( { color: 0xffff00, side: THREE.DoubleSide } );
 * const plane = new THREE.Mesh( geometry, material );
 * scene.add( plane );
 * ```
 *
 * @augments BufferGeometry
 */ class $9ddd7e9b53f7a2d4$export$967d831af31f69ce extends $9ddd7e9b53f7a2d4$export$b7be63a67df8959 {
    /**
	 * Constructs a new plane geometry.
	 *
	 * @param {number} [width=1] - The width along the X axis.
	 * @param {number} [height=1] - The height along the Y axis
	 * @param {number} [widthSegments=1] - The number of segments along the X axis.
	 * @param {number} [heightSegments=1] - The number of segments along the Y axis.
	 */ constructor(width = 1, height = 1, widthSegments = 1, heightSegments = 1){
        super();
        this.type = 'PlaneGeometry';
        /**
		 * Holds the constructor parameters that have been
		 * used to generate the geometry. Any modification
		 * after instantiation does not change the geometry.
		 *
		 * @type {Object}
		 */ this.parameters = {
            width: width,
            height: height,
            widthSegments: widthSegments,
            heightSegments: heightSegments
        };
        const width_half = width / 2;
        const height_half = height / 2;
        const gridX = Math.floor(widthSegments);
        const gridY = Math.floor(heightSegments);
        const gridX1 = gridX + 1;
        const gridY1 = gridY + 1;
        const segment_width = width / gridX;
        const segment_height = height / gridY;
        //
        const indices = [];
        const vertices = [];
        const normals = [];
        const uvs = [];
        for(let iy = 0; iy < gridY1; iy++){
            const y = iy * segment_height - height_half;
            for(let ix = 0; ix < gridX1; ix++){
                const x = ix * segment_width - width_half;
                vertices.push(x, -y, 0);
                normals.push(0, 0, 1);
                uvs.push(ix / gridX);
                uvs.push(1 - iy / gridY);
            }
        }
        for(let iy = 0; iy < gridY; iy++)for(let ix = 0; ix < gridX; ix++){
            const a = ix + gridX1 * iy;
            const b = ix + gridX1 * (iy + 1);
            const c = ix + 1 + gridX1 * (iy + 1);
            const d = ix + 1 + gridX1 * iy;
            indices.push(a, b, d);
            indices.push(b, c, d);
        }
        this.setIndex(indices);
        this.setAttribute('position', new $9ddd7e9b53f7a2d4$export$cbe7a62641830ebd(vertices, 3));
        this.setAttribute('normal', new $9ddd7e9b53f7a2d4$export$cbe7a62641830ebd(normals, 3));
        this.setAttribute('uv', new $9ddd7e9b53f7a2d4$export$cbe7a62641830ebd(uvs, 2));
    }
    copy(source) {
        super.copy(source);
        this.parameters = Object.assign({}, source.parameters);
        return this;
    }
    /**
	 * Factory method for creating an instance of this class from the given
	 * JSON object.
	 *
	 * @param {Object} data - A JSON object representing the serialized geometry.
	 * @return {PlaneGeometry} A new instance.
	 */ static fromJSON(data) {
        return new $9ddd7e9b53f7a2d4$export$967d831af31f69ce(data.width, data.height, data.widthSegments, data.heightSegments);
    }
}
/**
 * A class for generating a two-dimensional ring geometry.
 *
 * ```js
 * const geometry = new THREE.RingGeometry( 1, 5, 32 );
 * const material = new THREE.MeshBasicMaterial( { color: 0xffff00, side: THREE.DoubleSide } );
 * const mesh = new THREE.Mesh( geometry, material );
 * scene.add( mesh );
 * ```
 *
 * @augments BufferGeometry
 */ class $9ddd7e9b53f7a2d4$export$68cb731f50f614af extends $9ddd7e9b53f7a2d4$export$b7be63a67df8959 {
    /**
	 * Constructs a new ring geometry.
	 *
	 * @param {number} [innerRadius=0.5] - The inner radius of the ring.
	 * @param {number} [outerRadius=1] - The outer radius of the ring.
	 * @param {number} [thetaSegments=32] - Number of segments. A higher number means the ring will be more round. Minimum is `3`.
	 * @param {number} [phiSegments=1] - Number of segments per ring segment. Minimum is `1`.
	 * @param {number} [thetaStart=0] - Starting angle in radians.
	 * @param {number} [thetaLength=Math.PI*2] - Central angle in radians.
	 */ constructor(innerRadius = 0.5, outerRadius = 1, thetaSegments = 32, phiSegments = 1, thetaStart = 0, thetaLength = Math.PI * 2){
        super();
        this.type = 'RingGeometry';
        /**
		 * Holds the constructor parameters that have been
		 * used to generate the geometry. Any modification
		 * after instantiation does not change the geometry.
		 *
		 * @type {Object}
		 */ this.parameters = {
            innerRadius: innerRadius,
            outerRadius: outerRadius,
            thetaSegments: thetaSegments,
            phiSegments: phiSegments,
            thetaStart: thetaStart,
            thetaLength: thetaLength
        };
        thetaSegments = Math.max(3, thetaSegments);
        phiSegments = Math.max(1, phiSegments);
        // buffers
        const indices = [];
        const vertices = [];
        const normals = [];
        const uvs = [];
        // some helper variables
        let radius = innerRadius;
        const radiusStep = (outerRadius - innerRadius) / phiSegments;
        const vertex = new $9ddd7e9b53f7a2d4$export$64b5c384219d3699();
        const uv = new $9ddd7e9b53f7a2d4$export$c977b3e384af9ae1();
        // generate vertices, normals and uvs
        for(let j = 0; j <= phiSegments; j++){
            for(let i = 0; i <= thetaSegments; i++){
                // values are generate from the inside of the ring to the outside
                const segment = thetaStart + i / thetaSegments * thetaLength;
                // vertex
                vertex.x = radius * Math.cos(segment);
                vertex.y = radius * Math.sin(segment);
                vertices.push(vertex.x, vertex.y, vertex.z);
                // normal
                normals.push(0, 0, 1);
                // uv
                uv.x = (vertex.x / outerRadius + 1) / 2;
                uv.y = (vertex.y / outerRadius + 1) / 2;
                uvs.push(uv.x, uv.y);
            }
            // increase the radius for next row of vertices
            radius += radiusStep;
        }
        // indices
        for(let j = 0; j < phiSegments; j++){
            const thetaSegmentLevel = j * (thetaSegments + 1);
            for(let i = 0; i < thetaSegments; i++){
                const segment = i + thetaSegmentLevel;
                const a = segment;
                const b = segment + thetaSegments + 1;
                const c = segment + thetaSegments + 2;
                const d = segment + 1;
                // faces
                indices.push(a, b, d);
                indices.push(b, c, d);
            }
        }
        // build geometry
        this.setIndex(indices);
        this.setAttribute('position', new $9ddd7e9b53f7a2d4$export$cbe7a62641830ebd(vertices, 3));
        this.setAttribute('normal', new $9ddd7e9b53f7a2d4$export$cbe7a62641830ebd(normals, 3));
        this.setAttribute('uv', new $9ddd7e9b53f7a2d4$export$cbe7a62641830ebd(uvs, 2));
    }
    copy(source) {
        super.copy(source);
        this.parameters = Object.assign({}, source.parameters);
        return this;
    }
    /**
	 * Factory method for creating an instance of this class from the given
	 * JSON object.
	 *
	 * @param {Object} data - A JSON object representing the serialized geometry.
	 * @return {RingGeometry} A new instance.
	 */ static fromJSON(data) {
        return new $9ddd7e9b53f7a2d4$export$68cb731f50f614af(data.innerRadius, data.outerRadius, data.thetaSegments, data.phiSegments, data.thetaStart, data.thetaLength);
    }
}
/**
 * Creates an one-sided polygonal geometry from one or more path shapes.
 *
 * ```js
 * const arcShape = new THREE.Shape()
 *	.moveTo( 5, 1 )
 *	.absarc( 1, 1, 4, 0, Math.PI * 2, false );
 *
 * const geometry = new THREE.ShapeGeometry( arcShape );
 * const material = new THREE.MeshBasicMaterial( { color: 0x00ff00, side: THREE.DoubleSide } );
 * const mesh = new THREE.Mesh( geometry, material ) ;
 * scene.add( mesh );
 * ```
 *
 * @augments BufferGeometry
 */ class $9ddd7e9b53f7a2d4$export$57a29a1c803e9065 extends $9ddd7e9b53f7a2d4$export$b7be63a67df8959 {
    /**
	 * Constructs a new shape geometry.
	 *
	 * @param {Shape|Array<Shape>} [shapes] - A shape or an array of shapes.
	 * @param {number} [curveSegments=12] - Number of segments per shape.
	 */ constructor(shapes = new $9ddd7e9b53f7a2d4$export$6428a7f2611ef1fa([
        new $9ddd7e9b53f7a2d4$export$c977b3e384af9ae1(0, 0.5),
        new $9ddd7e9b53f7a2d4$export$c977b3e384af9ae1(-0.5, -0.5),
        new $9ddd7e9b53f7a2d4$export$c977b3e384af9ae1(0.5, -0.5)
    ]), curveSegments = 12){
        super();
        this.type = 'ShapeGeometry';
        /**
		 * Holds the constructor parameters that have been
		 * used to generate the geometry. Any modification
		 * after instantiation does not change the geometry.
		 *
		 * @type {Object}
		 */ this.parameters = {
            shapes: shapes,
            curveSegments: curveSegments
        };
        // buffers
        const indices = [];
        const vertices = [];
        const normals = [];
        const uvs = [];
        // helper variables
        let groupStart = 0;
        let groupCount = 0;
        // allow single and array values for "shapes" parameter
        if (Array.isArray(shapes) === false) addShape(shapes);
        else for(let i = 0; i < shapes.length; i++){
            addShape(shapes[i]);
            this.addGroup(groupStart, groupCount, i); // enables MultiMaterial support
            groupStart += groupCount;
            groupCount = 0;
        }
        // build geometry
        this.setIndex(indices);
        this.setAttribute('position', new $9ddd7e9b53f7a2d4$export$cbe7a62641830ebd(vertices, 3));
        this.setAttribute('normal', new $9ddd7e9b53f7a2d4$export$cbe7a62641830ebd(normals, 3));
        this.setAttribute('uv', new $9ddd7e9b53f7a2d4$export$cbe7a62641830ebd(uvs, 2));
        // helper functions
        function addShape(shape) {
            const indexOffset = vertices.length / 3;
            const points = shape.extractPoints(curveSegments);
            let shapeVertices = points.shape;
            const shapeHoles = points.holes;
            // check direction of vertices
            if ($9ddd7e9b53f7a2d4$export$96bdf6d9c66d7ba8.isClockWise(shapeVertices) === false) shapeVertices = shapeVertices.reverse();
            for(let i = 0, l = shapeHoles.length; i < l; i++){
                const shapeHole = shapeHoles[i];
                if ($9ddd7e9b53f7a2d4$export$96bdf6d9c66d7ba8.isClockWise(shapeHole) === true) shapeHoles[i] = shapeHole.reverse();
            }
            const faces = $9ddd7e9b53f7a2d4$export$96bdf6d9c66d7ba8.triangulateShape(shapeVertices, shapeHoles);
            // join vertices of inner and outer paths to a single array
            for(let i = 0, l = shapeHoles.length; i < l; i++){
                const shapeHole = shapeHoles[i];
                shapeVertices = shapeVertices.concat(shapeHole);
            }
            // vertices, normals, uvs
            for(let i = 0, l = shapeVertices.length; i < l; i++){
                const vertex = shapeVertices[i];
                vertices.push(vertex.x, vertex.y, 0);
                normals.push(0, 0, 1);
                uvs.push(vertex.x, vertex.y); // world uvs
            }
            // indices
            for(let i = 0, l = faces.length; i < l; i++){
                const face = faces[i];
                const a = face[0] + indexOffset;
                const b = face[1] + indexOffset;
                const c = face[2] + indexOffset;
                indices.push(a, b, c);
                groupCount += 3;
            }
        }
    }
    copy(source) {
        super.copy(source);
        this.parameters = Object.assign({}, source.parameters);
        return this;
    }
    toJSON() {
        const data = super.toJSON();
        const shapes = this.parameters.shapes;
        return $9ddd7e9b53f7a2d4$var$toJSON(shapes, data);
    }
    /**
	 * Factory method for creating an instance of this class from the given
	 * JSON object.
	 *
	 * @param {Object} data - A JSON object representing the serialized geometry.
	 * @param {Array<Shape>} shapes - An array of shapes.
	 * @return {ShapeGeometry} A new instance.
	 */ static fromJSON(data, shapes) {
        const geometryShapes = [];
        for(let j = 0, jl = data.shapes.length; j < jl; j++){
            const shape = shapes[data.shapes[j]];
            geometryShapes.push(shape);
        }
        return new $9ddd7e9b53f7a2d4$export$57a29a1c803e9065(geometryShapes, data.curveSegments);
    }
}
function $9ddd7e9b53f7a2d4$var$toJSON(shapes, data) {
    data.shapes = [];
    if (Array.isArray(shapes)) for(let i = 0, l = shapes.length; i < l; i++){
        const shape = shapes[i];
        data.shapes.push(shape.uuid);
    }
    else data.shapes.push(shapes.uuid);
    return data;
}
/**
 * A class for generating a sphere geometry.
 *
 * ```js
 * const geometry = new THREE.SphereGeometry( 15, 32, 16 );
 * const material = new THREE.MeshBasicMaterial( { color: 0xffff00 } );
 * const sphere = new THREE.Mesh( geometry, material );
 * scene.add( sphere );
 * ```
 *
 * @augments BufferGeometry
 */ class $9ddd7e9b53f7a2d4$export$1b417fc3b307a251 extends $9ddd7e9b53f7a2d4$export$b7be63a67df8959 {
    /**
	 * Constructs a new sphere geometry.
	 *
	 * @param {number} [radius=1] - The sphere radius.
	 * @param {number} [widthSegments=32] - The number of horizontal segments. Minimum value is `3`.
	 * @param {number} [heightSegments=16] - The number of vertical segments. Minimum value is `2`.
	 * @param {number} [phiStart=0] - The horizontal starting angle in radians.
	 * @param {number} [phiLength=Math.PI*2] - The horizontal sweep angle size.
	 * @param {number} [thetaStart=0] - The vertical starting angle in radians.
	 * @param {number} [thetaLength=Math.PI] - The vertical sweep angle size.
	 */ constructor(radius = 1, widthSegments = 32, heightSegments = 16, phiStart = 0, phiLength = Math.PI * 2, thetaStart = 0, thetaLength = Math.PI){
        super();
        this.type = 'SphereGeometry';
        /**
		 * Holds the constructor parameters that have been
		 * used to generate the geometry. Any modification
		 * after instantiation does not change the geometry.
		 *
		 * @type {Object}
		 */ this.parameters = {
            radius: radius,
            widthSegments: widthSegments,
            heightSegments: heightSegments,
            phiStart: phiStart,
            phiLength: phiLength,
            thetaStart: thetaStart,
            thetaLength: thetaLength
        };
        widthSegments = Math.max(3, Math.floor(widthSegments));
        heightSegments = Math.max(2, Math.floor(heightSegments));
        const thetaEnd = Math.min(thetaStart + thetaLength, Math.PI);
        let index = 0;
        const grid = [];
        const vertex = new $9ddd7e9b53f7a2d4$export$64b5c384219d3699();
        const normal = new $9ddd7e9b53f7a2d4$export$64b5c384219d3699();
        // buffers
        const indices = [];
        const vertices = [];
        const normals = [];
        const uvs = [];
        // generate vertices, normals and uvs
        for(let iy = 0; iy <= heightSegments; iy++){
            const verticesRow = [];
            const v = iy / heightSegments;
            // special case for the poles
            let uOffset = 0;
            if (iy === 0 && thetaStart === 0) uOffset = 0.5 / widthSegments;
            else if (iy === heightSegments && thetaEnd === Math.PI) uOffset = -0.5 / widthSegments;
            for(let ix = 0; ix <= widthSegments; ix++){
                const u = ix / widthSegments;
                // vertex
                vertex.x = -radius * Math.cos(phiStart + u * phiLength) * Math.sin(thetaStart + v * thetaLength);
                vertex.y = radius * Math.cos(thetaStart + v * thetaLength);
                vertex.z = radius * Math.sin(phiStart + u * phiLength) * Math.sin(thetaStart + v * thetaLength);
                vertices.push(vertex.x, vertex.y, vertex.z);
                // normal
                normal.copy(vertex).normalize();
                normals.push(normal.x, normal.y, normal.z);
                // uv
                uvs.push(u + uOffset, 1 - v);
                verticesRow.push(index++);
            }
            grid.push(verticesRow);
        }
        // indices
        for(let iy = 0; iy < heightSegments; iy++)for(let ix = 0; ix < widthSegments; ix++){
            const a = grid[iy][ix + 1];
            const b = grid[iy][ix];
            const c = grid[iy + 1][ix];
            const d = grid[iy + 1][ix + 1];
            if (iy !== 0 || thetaStart > 0) indices.push(a, b, d);
            if (iy !== heightSegments - 1 || thetaEnd < Math.PI) indices.push(b, c, d);
        }
        // build geometry
        this.setIndex(indices);
        this.setAttribute('position', new $9ddd7e9b53f7a2d4$export$cbe7a62641830ebd(vertices, 3));
        this.setAttribute('normal', new $9ddd7e9b53f7a2d4$export$cbe7a62641830ebd(normals, 3));
        this.setAttribute('uv', new $9ddd7e9b53f7a2d4$export$cbe7a62641830ebd(uvs, 2));
    }
    copy(source) {
        super.copy(source);
        this.parameters = Object.assign({}, source.parameters);
        return this;
    }
    /**
	 * Factory method for creating an instance of this class from the given
	 * JSON object.
	 *
	 * @param {Object} data - A JSON object representing the serialized geometry.
	 * @return {SphereGeometry} A new instance.
	 */ static fromJSON(data) {
        return new $9ddd7e9b53f7a2d4$export$1b417fc3b307a251(data.radius, data.widthSegments, data.heightSegments, data.phiStart, data.phiLength, data.thetaStart, data.thetaLength);
    }
}
/**
 * A geometry class for representing an tetrahedron.
 *
 * ```js
 * const geometry = new THREE.TetrahedronGeometry();
 * const material = new THREE.MeshBasicMaterial( { color: 0xffff00 } );
 * const tetrahedron = new THREE.Mesh( geometry, material );
 * scene.add( tetrahedron );
 * ```
 *
 * @augments PolyhedronGeometry
 */ class $9ddd7e9b53f7a2d4$export$fb3f7adc68bd6e02 extends $9ddd7e9b53f7a2d4$export$60e57a7d3f20ff65 {
    /**
	 * Constructs a new tetrahedron geometry.
	 *
	 * @param {number} [radius=1] - Radius of the tetrahedron.
	 * @param {number} [detail=0] - Setting this to a value greater than `0` adds vertices making it no longer a tetrahedron.
	 */ constructor(radius = 1, detail = 0){
        const vertices = [
            1,
            1,
            1,
            -1,
            -1,
            1,
            -1,
            1,
            -1,
            1,
            -1,
            -1
        ];
        const indices = [
            2,
            1,
            0,
            0,
            3,
            2,
            1,
            3,
            0,
            2,
            3,
            1
        ];
        super(vertices, indices, radius, detail);
        this.type = 'TetrahedronGeometry';
        /**
		 * Holds the constructor parameters that have been
		 * used to generate the geometry. Any modification
		 * after instantiation does not change the geometry.
		 *
		 * @type {Object}
		 */ this.parameters = {
            radius: radius,
            detail: detail
        };
    }
    /**
	 * Factory method for creating an instance of this class from the given
	 * JSON object.
	 *
	 * @param {Object} data - A JSON object representing the serialized geometry.
	 * @return {TetrahedronGeometry} A new instance.
	 */ static fromJSON(data) {
        return new $9ddd7e9b53f7a2d4$export$fb3f7adc68bd6e02(data.radius, data.detail);
    }
}
/**
 * A geometry class for representing an torus.
 *
 * ```js
 * const geometry = new THREE.TorusGeometry( 10, 3, 16, 100 );
 * const material = new THREE.MeshBasicMaterial( { color: 0xffff00 } );
 * const torus = new THREE.Mesh( geometry, material );
 * scene.add( torus );
 * ```
 *
 * @augments BufferGeometry
 */ class $9ddd7e9b53f7a2d4$export$a2312a2a1fa56495 extends $9ddd7e9b53f7a2d4$export$b7be63a67df8959 {
    /**
	 * Constructs a new torus geometry.
	 *
	 * @param {number} [radius=1] - Radius of the torus, from the center of the torus to the center of the tube.
	 * @param {number} [tube=0.4] - Radius of the tube. Must be smaller than `radius`.
	 * @param {number} [radialSegments=12] - The number of radial segments.
	 * @param {number} [tubularSegments=48] - The number of tubular segments.
	 * @param {number} [arc=Math.PI*2] - Central angle in radians.
	 */ constructor(radius = 1, tube = 0.4, radialSegments = 12, tubularSegments = 48, arc = Math.PI * 2){
        super();
        this.type = 'TorusGeometry';
        /**
		 * Holds the constructor parameters that have been
		 * used to generate the geometry. Any modification
		 * after instantiation does not change the geometry.
		 *
		 * @type {Object}
		 */ this.parameters = {
            radius: radius,
            tube: tube,
            radialSegments: radialSegments,
            tubularSegments: tubularSegments,
            arc: arc
        };
        radialSegments = Math.floor(radialSegments);
        tubularSegments = Math.floor(tubularSegments);
        // buffers
        const indices = [];
        const vertices = [];
        const normals = [];
        const uvs = [];
        // helper variables
        const center = new $9ddd7e9b53f7a2d4$export$64b5c384219d3699();
        const vertex = new $9ddd7e9b53f7a2d4$export$64b5c384219d3699();
        const normal = new $9ddd7e9b53f7a2d4$export$64b5c384219d3699();
        // generate vertices, normals and uvs
        for(let j = 0; j <= radialSegments; j++)for(let i = 0; i <= tubularSegments; i++){
            const u = i / tubularSegments * arc;
            const v = j / radialSegments * Math.PI * 2;
            // vertex
            vertex.x = (radius + tube * Math.cos(v)) * Math.cos(u);
            vertex.y = (radius + tube * Math.cos(v)) * Math.sin(u);
            vertex.z = tube * Math.sin(v);
            vertices.push(vertex.x, vertex.y, vertex.z);
            // normal
            center.x = radius * Math.cos(u);
            center.y = radius * Math.sin(u);
            normal.subVectors(vertex, center).normalize();
            normals.push(normal.x, normal.y, normal.z);
            // uv
            uvs.push(i / tubularSegments);
            uvs.push(j / radialSegments);
        }
        // generate indices
        for(let j = 1; j <= radialSegments; j++)for(let i = 1; i <= tubularSegments; i++){
            // indices
            const a = (tubularSegments + 1) * j + i - 1;
            const b = (tubularSegments + 1) * (j - 1) + i - 1;
            const c = (tubularSegments + 1) * (j - 1) + i;
            const d = (tubularSegments + 1) * j + i;
            // faces
            indices.push(a, b, d);
            indices.push(b, c, d);
        }
        // build geometry
        this.setIndex(indices);
        this.setAttribute('position', new $9ddd7e9b53f7a2d4$export$cbe7a62641830ebd(vertices, 3));
        this.setAttribute('normal', new $9ddd7e9b53f7a2d4$export$cbe7a62641830ebd(normals, 3));
        this.setAttribute('uv', new $9ddd7e9b53f7a2d4$export$cbe7a62641830ebd(uvs, 2));
    }
    copy(source) {
        super.copy(source);
        this.parameters = Object.assign({}, source.parameters);
        return this;
    }
    /**
	 * Factory method for creating an instance of this class from the given
	 * JSON object.
	 *
	 * @param {Object} data - A JSON object representing the serialized geometry.
	 * @return {TorusGeometry} A new instance.
	 */ static fromJSON(data) {
        return new $9ddd7e9b53f7a2d4$export$a2312a2a1fa56495(data.radius, data.tube, data.radialSegments, data.tubularSegments, data.arc);
    }
}
/**
 * Creates a torus knot, the particular shape of which is defined by a pair
 * of coprime integers, p and q. If p and q are not coprime, the result will
 * be a torus link.
 *
 * ```js
 * const geometry = new THREE.TorusKnotGeometry( 10, 3, 100, 16 );
 * const material = new THREE.MeshBasicMaterial( { color: 0xffff00 } );
 * const torusKnot = new THREE.Mesh( geometry, material );
 * scene.add( torusKnot );
 * ```
 *
 * @augments BufferGeometry
 */ class $9ddd7e9b53f7a2d4$export$77e9bfadfb9ab8c8 extends $9ddd7e9b53f7a2d4$export$b7be63a67df8959 {
    /**
	 * Constructs a new torus knot geometry.
	 *
	 * @param {number} [radius=1] - Radius of the torus knot.
	 * @param {number} [tube=0.4] - Radius of the tube.
	 * @param {number} [tubularSegments=64] - The number of tubular segments.
	 * @param {number} [radialSegments=8] - The number of radial segments.
	 * @param {number} [p=2] - This value determines, how many times the geometry winds around its axis of rotational symmetry.
	 * @param {number} [q=3] - This value determines, how many times the geometry winds around a circle in the interior of the torus.
	 */ constructor(radius = 1, tube = 0.4, tubularSegments = 64, radialSegments = 8, p = 2, q = 3){
        super();
        this.type = 'TorusKnotGeometry';
        /**
		 * Holds the constructor parameters that have been
		 * used to generate the geometry. Any modification
		 * after instantiation does not change the geometry.
		 *
		 * @type {Object}
		 */ this.parameters = {
            radius: radius,
            tube: tube,
            tubularSegments: tubularSegments,
            radialSegments: radialSegments,
            p: p,
            q: q
        };
        tubularSegments = Math.floor(tubularSegments);
        radialSegments = Math.floor(radialSegments);
        // buffers
        const indices = [];
        const vertices = [];
        const normals = [];
        const uvs = [];
        // helper variables
        const vertex = new $9ddd7e9b53f7a2d4$export$64b5c384219d3699();
        const normal = new $9ddd7e9b53f7a2d4$export$64b5c384219d3699();
        const P1 = new $9ddd7e9b53f7a2d4$export$64b5c384219d3699();
        const P2 = new $9ddd7e9b53f7a2d4$export$64b5c384219d3699();
        const B = new $9ddd7e9b53f7a2d4$export$64b5c384219d3699();
        const T = new $9ddd7e9b53f7a2d4$export$64b5c384219d3699();
        const N = new $9ddd7e9b53f7a2d4$export$64b5c384219d3699();
        // generate vertices, normals and uvs
        for(let i = 0; i <= tubularSegments; ++i){
            // the radian "u" is used to calculate the position on the torus curve of the current tubular segment
            const u = i / tubularSegments * p * Math.PI * 2;
            // now we calculate two points. P1 is our current position on the curve, P2 is a little farther ahead.
            // these points are used to create a special "coordinate space", which is necessary to calculate the correct vertex positions
            calculatePositionOnCurve(u, p, q, radius, P1);
            calculatePositionOnCurve(u + 0.01, p, q, radius, P2);
            // calculate orthonormal basis
            T.subVectors(P2, P1);
            N.addVectors(P2, P1);
            B.crossVectors(T, N);
            N.crossVectors(B, T);
            // normalize B, N. T can be ignored, we don't use it
            B.normalize();
            N.normalize();
            for(let j = 0; j <= radialSegments; ++j){
                // now calculate the vertices. they are nothing more than an extrusion of the torus curve.
                // because we extrude a shape in the xy-plane, there is no need to calculate a z-value.
                const v = j / radialSegments * Math.PI * 2;
                const cx = -tube * Math.cos(v);
                const cy = tube * Math.sin(v);
                // now calculate the final vertex position.
                // first we orient the extrusion with our basis vectors, then we add it to the current position on the curve
                vertex.x = P1.x + (cx * N.x + cy * B.x);
                vertex.y = P1.y + (cx * N.y + cy * B.y);
                vertex.z = P1.z + (cx * N.z + cy * B.z);
                vertices.push(vertex.x, vertex.y, vertex.z);
                // normal (P1 is always the center/origin of the extrusion, thus we can use it to calculate the normal)
                normal.subVectors(vertex, P1).normalize();
                normals.push(normal.x, normal.y, normal.z);
                // uv
                uvs.push(i / tubularSegments);
                uvs.push(j / radialSegments);
            }
        }
        // generate indices
        for(let j = 1; j <= tubularSegments; j++)for(let i = 1; i <= radialSegments; i++){
            // indices
            const a = (radialSegments + 1) * (j - 1) + (i - 1);
            const b = (radialSegments + 1) * j + (i - 1);
            const c = (radialSegments + 1) * j + i;
            const d = (radialSegments + 1) * (j - 1) + i;
            // faces
            indices.push(a, b, d);
            indices.push(b, c, d);
        }
        // build geometry
        this.setIndex(indices);
        this.setAttribute('position', new $9ddd7e9b53f7a2d4$export$cbe7a62641830ebd(vertices, 3));
        this.setAttribute('normal', new $9ddd7e9b53f7a2d4$export$cbe7a62641830ebd(normals, 3));
        this.setAttribute('uv', new $9ddd7e9b53f7a2d4$export$cbe7a62641830ebd(uvs, 2));
        // this function calculates the current position on the torus curve
        function calculatePositionOnCurve(u, p, q, radius, position) {
            const cu = Math.cos(u);
            const su = Math.sin(u);
            const quOverP = q / p * u;
            const cs = Math.cos(quOverP);
            position.x = radius * (2 + cs) * 0.5 * cu;
            position.y = radius * (2 + cs) * su * 0.5;
            position.z = radius * Math.sin(quOverP) * 0.5;
        }
    }
    copy(source) {
        super.copy(source);
        this.parameters = Object.assign({}, source.parameters);
        return this;
    }
    /**
	 * Factory method for creating an instance of this class from the given
	 * JSON object.
	 *
	 * @param {Object} data - A JSON object representing the serialized geometry.
	 * @return {TorusKnotGeometry} A new instance.
	 */ static fromJSON(data) {
        return new $9ddd7e9b53f7a2d4$export$77e9bfadfb9ab8c8(data.radius, data.tube, data.tubularSegments, data.radialSegments, data.p, data.q);
    }
}
/**
 * Creates a tube that extrudes along a 3D curve.
 *
 * ```js
 * class CustomSinCurve extends THREE.Curve {
 *
 * 	getPoint( t, optionalTarget = new THREE.Vector3() ) {
 *
 * 		const tx = t * 3 - 1.5;
 * 		const ty = Math.sin( 2 * Math.PI * t );
 * 		const tz = 0;
 *
 * 		return optionalTarget.set( tx, ty, tz );
 * 	}
 *
 * }
 *
 * const path = new CustomSinCurve( 10 );
 * const geometry = new THREE.TubeGeometry( path, 20, 2, 8, false );
 * const material = new THREE.MeshBasicMaterial( { color: 0x00ff00 } );
 * const mesh = new THREE.Mesh( geometry, material );
 * scene.add( mesh );
 * ```
 *
 * @augments BufferGeometry
 */ class $9ddd7e9b53f7a2d4$export$7897d9d48904490c extends $9ddd7e9b53f7a2d4$export$b7be63a67df8959 {
    /**
	 * Constructs a new tube geometry.
	 *
	 * @param {Curve} [path=QuadraticBezierCurve3] - A 3D curve defining the path of the tube.
	 * @param {number} [tubularSegments=64] - The number of segments that make up the tube.
	 * @param {number} [radius=1] -The radius of the tube.
	 * @param {number} [radialSegments=8] - The number of segments that make up the cross-section.
	 * @param {boolean} [closed=false] - Whether the tube is closed or not.
	 */ constructor(path = new $9ddd7e9b53f7a2d4$export$bf3f4c7e459f90fc(new $9ddd7e9b53f7a2d4$export$64b5c384219d3699(-1, -1, 0), new $9ddd7e9b53f7a2d4$export$64b5c384219d3699(-1, 1, 0), new $9ddd7e9b53f7a2d4$export$64b5c384219d3699(1, 1, 0)), tubularSegments = 64, radius = 1, radialSegments = 8, closed = false){
        super();
        this.type = 'TubeGeometry';
        /**
		 * Holds the constructor parameters that have been
		 * used to generate the geometry. Any modification
		 * after instantiation does not change the geometry.
		 *
		 * @type {Object}
		 */ this.parameters = {
            path: path,
            tubularSegments: tubularSegments,
            radius: radius,
            radialSegments: radialSegments,
            closed: closed
        };
        const frames = path.computeFrenetFrames(tubularSegments, closed);
        // expose internals
        this.tangents = frames.tangents;
        this.normals = frames.normals;
        this.binormals = frames.binormals;
        // helper variables
        const vertex = new $9ddd7e9b53f7a2d4$export$64b5c384219d3699();
        const normal = new $9ddd7e9b53f7a2d4$export$64b5c384219d3699();
        const uv = new $9ddd7e9b53f7a2d4$export$c977b3e384af9ae1();
        let P = new $9ddd7e9b53f7a2d4$export$64b5c384219d3699();
        // buffer
        const vertices = [];
        const normals = [];
        const uvs = [];
        const indices = [];
        // create buffer data
        generateBufferData();
        // build geometry
        this.setIndex(indices);
        this.setAttribute('position', new $9ddd7e9b53f7a2d4$export$cbe7a62641830ebd(vertices, 3));
        this.setAttribute('normal', new $9ddd7e9b53f7a2d4$export$cbe7a62641830ebd(normals, 3));
        this.setAttribute('uv', new $9ddd7e9b53f7a2d4$export$cbe7a62641830ebd(uvs, 2));
        // functions
        function generateBufferData() {
            for(let i = 0; i < tubularSegments; i++)generateSegment(i);
            // if the geometry is not closed, generate the last row of vertices and normals
            // at the regular position on the given path
            //
            // if the geometry is closed, duplicate the first row of vertices and normals (uvs will differ)
            generateSegment(closed === false ? tubularSegments : 0);
            // uvs are generated in a separate function.
            // this makes it easy compute correct values for closed geometries
            generateUVs();
            // finally create faces
            generateIndices();
        }
        function generateSegment(i) {
            // we use getPointAt to sample evenly distributed points from the given path
            P = path.getPointAt(i / tubularSegments, P);
            // retrieve corresponding normal and binormal
            const N = frames.normals[i];
            const B = frames.binormals[i];
            // generate normals and vertices for the current segment
            for(let j = 0; j <= radialSegments; j++){
                const v = j / radialSegments * Math.PI * 2;
                const sin = Math.sin(v);
                const cos = -Math.cos(v);
                // normal
                normal.x = cos * N.x + sin * B.x;
                normal.y = cos * N.y + sin * B.y;
                normal.z = cos * N.z + sin * B.z;
                normal.normalize();
                normals.push(normal.x, normal.y, normal.z);
                // vertex
                vertex.x = P.x + radius * normal.x;
                vertex.y = P.y + radius * normal.y;
                vertex.z = P.z + radius * normal.z;
                vertices.push(vertex.x, vertex.y, vertex.z);
            }
        }
        function generateIndices() {
            for(let j = 1; j <= tubularSegments; j++)for(let i = 1; i <= radialSegments; i++){
                const a = (radialSegments + 1) * (j - 1) + (i - 1);
                const b = (radialSegments + 1) * j + (i - 1);
                const c = (radialSegments + 1) * j + i;
                const d = (radialSegments + 1) * (j - 1) + i;
                // faces
                indices.push(a, b, d);
                indices.push(b, c, d);
            }
        }
        function generateUVs() {
            for(let i = 0; i <= tubularSegments; i++)for(let j = 0; j <= radialSegments; j++){
                uv.x = i / tubularSegments;
                uv.y = j / radialSegments;
                uvs.push(uv.x, uv.y);
            }
        }
    }
    copy(source) {
        super.copy(source);
        this.parameters = Object.assign({}, source.parameters);
        return this;
    }
    toJSON() {
        const data = super.toJSON();
        data.path = this.parameters.path.toJSON();
        return data;
    }
    /**
	 * Factory method for creating an instance of this class from the given
	 * JSON object.
	 *
	 * @param {Object} data - A JSON object representing the serialized geometry.
	 * @return {TubeGeometry} A new instance.
	 */ static fromJSON(data) {
        // This only works for built-in curves (e.g. CatmullRomCurve3).
        // User defined curves or instances of CurvePath will not be deserialized.
        return new $9ddd7e9b53f7a2d4$export$7897d9d48904490c(new $9ddd7e9b53f7a2d4$var$Curves[data.path.type]().fromJSON(data.path), data.tubularSegments, data.radius, data.radialSegments, data.closed);
    }
}
/**
 * Can be used as a helper object to visualize a geometry as a wireframe.
 *
 * ```js
 * const geometry = new THREE.SphereGeometry();
 *
 * const wireframe = new THREE.WireframeGeometry( geometry );
 *
 * const line = new THREE.LineSegments( wireframe );
 * line.material.depthWrite = false;
 * line.material.opacity = 0.25;
 * line.material.transparent = true;
 *
 * scene.add( line );
 * ```
 *
 * Note: It is not yet possible to serialize/deserialize instances of this class.
 *
 * @augments BufferGeometry
 */ class $9ddd7e9b53f7a2d4$export$4b739da06d24892b extends $9ddd7e9b53f7a2d4$export$b7be63a67df8959 {
    /**
	 * Constructs a new wireframe geometry.
	 *
	 * @param {?BufferGeometry} [geometry=null] - The geometry.
	 */ constructor(geometry = null){
        super();
        this.type = 'WireframeGeometry';
        /**
		 * Holds the constructor parameters that have been
		 * used to generate the geometry. Any modification
		 * after instantiation does not change the geometry.
		 *
		 * @type {Object}
		 */ this.parameters = {
            geometry: geometry
        };
        if (geometry !== null) {
            // buffer
            const vertices = [];
            const edges = new Set();
            // helper variables
            const start = new $9ddd7e9b53f7a2d4$export$64b5c384219d3699();
            const end = new $9ddd7e9b53f7a2d4$export$64b5c384219d3699();
            if (geometry.index !== null) {
                // indexed BufferGeometry
                const position = geometry.attributes.position;
                const indices = geometry.index;
                let groups = geometry.groups;
                if (groups.length === 0) groups = [
                    {
                        start: 0,
                        count: indices.count,
                        materialIndex: 0
                    }
                ];
                // create a data structure that contains all edges without duplicates
                for(let o = 0, ol = groups.length; o < ol; ++o){
                    const group = groups[o];
                    const groupStart = group.start;
                    const groupCount = group.count;
                    for(let i = groupStart, l = groupStart + groupCount; i < l; i += 3)for(let j = 0; j < 3; j++){
                        const index1 = indices.getX(i + j);
                        const index2 = indices.getX(i + (j + 1) % 3);
                        start.fromBufferAttribute(position, index1);
                        end.fromBufferAttribute(position, index2);
                        if ($9ddd7e9b53f7a2d4$var$isUniqueEdge(start, end, edges) === true) {
                            vertices.push(start.x, start.y, start.z);
                            vertices.push(end.x, end.y, end.z);
                        }
                    }
                }
            } else {
                // non-indexed BufferGeometry
                const position = geometry.attributes.position;
                for(let i = 0, l = position.count / 3; i < l; i++)for(let j = 0; j < 3; j++){
                    // three edges per triangle, an edge is represented as (index1, index2)
                    // e.g. the first triangle has the following edges: (0,1),(1,2),(2,0)
                    const index1 = 3 * i + j;
                    const index2 = 3 * i + (j + 1) % 3;
                    start.fromBufferAttribute(position, index1);
                    end.fromBufferAttribute(position, index2);
                    if ($9ddd7e9b53f7a2d4$var$isUniqueEdge(start, end, edges) === true) {
                        vertices.push(start.x, start.y, start.z);
                        vertices.push(end.x, end.y, end.z);
                    }
                }
            }
            // build geometry
            this.setAttribute('position', new $9ddd7e9b53f7a2d4$export$cbe7a62641830ebd(vertices, 3));
        }
    }
    copy(source) {
        super.copy(source);
        this.parameters = Object.assign({}, source.parameters);
        return this;
    }
}
function $9ddd7e9b53f7a2d4$var$isUniqueEdge(start, end, edges) {
    const hash1 = `${start.x},${start.y},${start.z}-${end.x},${end.y},${end.z}`;
    const hash2 = `${end.x},${end.y},${end.z}-${start.x},${start.y},${start.z}`; // coincident edge
    if (edges.has(hash1) === true || edges.has(hash2) === true) return false;
    else {
        edges.add(hash1);
        edges.add(hash2);
        return true;
    }
}
var $9ddd7e9b53f7a2d4$var$Geometries = /*#__PURE__*/ Object.freeze({
    __proto__: null,
    BoxGeometry: $9ddd7e9b53f7a2d4$export$33e43285f7406bd5,
    CapsuleGeometry: $9ddd7e9b53f7a2d4$export$41680e8551036033,
    CircleGeometry: $9ddd7e9b53f7a2d4$export$d5c0e8d607467193,
    ConeGeometry: $9ddd7e9b53f7a2d4$export$a7a48974f285c9b3,
    CylinderGeometry: $9ddd7e9b53f7a2d4$export$68f745719dbe5198,
    DodecahedronGeometry: $9ddd7e9b53f7a2d4$export$c0babfeb8708fc9c,
    EdgesGeometry: $9ddd7e9b53f7a2d4$export$4730b1542707547f,
    ExtrudeGeometry: $9ddd7e9b53f7a2d4$export$598697a1efa63ca7,
    IcosahedronGeometry: $9ddd7e9b53f7a2d4$export$9567cc828c9535da,
    LatheGeometry: $9ddd7e9b53f7a2d4$export$6d839803fcd1882c,
    OctahedronGeometry: $9ddd7e9b53f7a2d4$export$1954e2b809fe361e,
    PlaneGeometry: $9ddd7e9b53f7a2d4$export$967d831af31f69ce,
    PolyhedronGeometry: $9ddd7e9b53f7a2d4$export$60e57a7d3f20ff65,
    RingGeometry: $9ddd7e9b53f7a2d4$export$68cb731f50f614af,
    ShapeGeometry: $9ddd7e9b53f7a2d4$export$57a29a1c803e9065,
    SphereGeometry: $9ddd7e9b53f7a2d4$export$1b417fc3b307a251,
    TetrahedronGeometry: $9ddd7e9b53f7a2d4$export$fb3f7adc68bd6e02,
    TorusGeometry: $9ddd7e9b53f7a2d4$export$a2312a2a1fa56495,
    TorusKnotGeometry: $9ddd7e9b53f7a2d4$export$77e9bfadfb9ab8c8,
    TubeGeometry: $9ddd7e9b53f7a2d4$export$7897d9d48904490c,
    WireframeGeometry: $9ddd7e9b53f7a2d4$export$4b739da06d24892b
});
/**
 * This material can receive shadows, but otherwise is completely transparent.
 *
 * ```js
 * const geometry = new THREE.PlaneGeometry( 2000, 2000 );
 * geometry.rotateX( - Math.PI / 2 );
 *
 * const material = new THREE.ShadowMaterial();
 * material.opacity = 0.2;
 *
 * const plane = new THREE.Mesh( geometry, material );
 * plane.position.y = -200;
 * plane.receiveShadow = true;
 * scene.add( plane );
 * ```
 *
 * @augments Material
 */ class $9ddd7e9b53f7a2d4$export$e8564da406055a3 extends $9ddd7e9b53f7a2d4$export$a2d8b23205c25948 {
    /**
	 * Constructs a new shadow material.
	 *
	 * @param {Object} [parameters] - An object with one or more properties
	 * defining the material's appearance. Any property of the material
	 * (including any property from inherited materials) can be passed
	 * in here. Color values can be passed any type of value accepted
	 * by {@link Color#set}.
	 */ constructor(parameters){
        super();
        /**
		 * This flag can be used for type testing.
		 *
		 * @type {boolean}
		 * @readonly
		 * @default true
		 */ this.isShadowMaterial = true;
        this.type = 'ShadowMaterial';
        /**
		 * Color of the material.
		 *
		 * @type {Color}
		 * @default (0,0,0)
		 */ this.color = new $9ddd7e9b53f7a2d4$export$892596cec99bc70e(0x000000);
        /**
		 * Overwritten since shadow materials are transparent
		 * by default.
		 *
		 * @type {boolean}
		 * @default true
		 */ this.transparent = true;
        /**
		 * Whether the material is affected by fog or not.
		 *
		 * @type {boolean}
		 * @default true
		 */ this.fog = true;
        this.setValues(parameters);
    }
    copy(source) {
        super.copy(source);
        this.color.copy(source.color);
        this.fog = source.fog;
        return this;
    }
}
/**
 * This class works just like {@link ShaderMaterial}, except that definitions
 * of built-in uniforms and attributes are not automatically prepended to the
 * GLSL shader code.
 *
 * `RawShaderMaterial` can only be used with {@link WebGLRenderer}.
 *
 * @augments ShaderMaterial
 */ class $9ddd7e9b53f7a2d4$export$21c421a2e1df9d22 extends $9ddd7e9b53f7a2d4$export$83c7d75d550a8b0d {
    /**
	 * Constructs a new raw shader material.
	 *
	 * @param {Object} [parameters] - An object with one or more properties
	 * defining the material's appearance. Any property of the material
	 * (including any property from inherited materials) can be passed
	 * in here. Color values can be passed any type of value accepted
	 * by {@link Color#set}.
	 */ constructor(parameters){
        super(parameters);
        /**
		 * This flag can be used for type testing.
		 *
		 * @type {boolean}
		 * @readonly
		 * @default true
		 */ this.isRawShaderMaterial = true;
        this.type = 'RawShaderMaterial';
    }
}
/**
 * A standard physically based material, using Metallic-Roughness workflow.
 *
 * Physically based rendering (PBR) has recently become the standard in many
 * 3D applications, such as [Unity]{@link https://blogs.unity3d.com/2014/10/29/physically-based-shading-in-unity-5-a-primer/},
 * [Unreal]{@link https://docs.unrealengine.com/latest/INT/Engine/Rendering/Materials/PhysicallyBased/} and
 * [3D Studio Max]{@link http://area.autodesk.com/blogs/the-3ds-max-blog/what039s-new-for-rendering-in-3ds-max-2017}.
 *
 * This approach differs from older approaches in that instead of using
 * approximations for the way in which light interacts with a surface, a
 * physically correct model is used. The idea is that, instead of tweaking
 * materials to look good under specific lighting, a material can be created
 * that will react 'correctly' under all lighting scenarios.
 *
 * In practice this gives a more accurate and realistic looking result than
 * the {@link MeshLambertMaterial} or {@link MeshPhongMaterial}, at the cost of
 * being somewhat more computationally expensive. `MeshStandardMaterial` uses per-fragment
 * shading.
 *
 * Note that for best results you should always specify an environment map when using this material.
 *
 * For a non-technical introduction to the concept of PBR and how to set up a
 * PBR material, check out these articles by the people at [marmoset]{@link https://www.marmoset.co}:
 *
 * - [Basic Theory of Physically Based Rendering]{@link https://www.marmoset.co/posts/basic-theory-of-physically-based-rendering/}
 * - [Physically Based Rendering and You Can Too]{@link https://www.marmoset.co/posts/physically-based-rendering-and-you-can-too/}
 *
 * Technical details of the approach used in three.js (and most other PBR systems) can be found is this
 * [paper from Disney]{@link https://media.disneyanimation.com/uploads/production/publication_asset/48/asset/s2012_pbs_disney_brdf_notes_v3.pdf}
 * (pdf), by Brent Burley.
 *
 * @augments Material
 */ class $9ddd7e9b53f7a2d4$export$f2980790215acccd extends $9ddd7e9b53f7a2d4$export$a2d8b23205c25948 {
    /**
	 * Constructs a new mesh standard material.
	 *
	 * @param {Object} [parameters] - An object with one or more properties
	 * defining the material's appearance. Any property of the material
	 * (including any property from inherited materials) can be passed
	 * in here. Color values can be passed any type of value accepted
	 * by {@link Color#set}.
	 */ constructor(parameters){
        super();
        /**
		 * This flag can be used for type testing.
		 *
		 * @type {boolean}
		 * @readonly
		 * @default true
		 */ this.isMeshStandardMaterial = true;
        this.type = 'MeshStandardMaterial';
        this.defines = {
            'STANDARD': ''
        };
        /**
		 * Color of the material.
		 *
		 * @type {Color}
		 * @default (1,1,1)
		 */ this.color = new $9ddd7e9b53f7a2d4$export$892596cec99bc70e(0xffffff); // diffuse
        /**
		 * How rough the material appears. `0.0` means a smooth mirror reflection, `1.0`
		 * means fully diffuse. If `roughnessMap` is also provided,
		 * both values are multiplied.
		 *
		 * @type {number}
		 * @default 1
		 */ this.roughness = 1.0;
        /**
		 * How much the material is like a metal. Non-metallic materials such as wood
		 * or stone use `0.0`, metallic use `1.0`, with nothing (usually) in between.
		 * A value between `0.0` and `1.0` could be used for a rusty metal look.
		 * If `metalnessMap` is also provided, both values are multiplied.
		 *
		 * @type {number}
		 * @default 0
		 */ this.metalness = 0.0;
        /**
		 * The color map. May optionally include an alpha channel, typically combined
		 * with {@link Material#transparent} or {@link Material#alphaTest}. The texture map
		 * color is modulated by the diffuse `color`.
		 *
		 * @type {?Texture}
		 * @default null
		 */ this.map = null;
        /**
		 * The light map. Requires a second set of UVs.
		 *
		 * @type {?Texture}
		 * @default null
		 */ this.lightMap = null;
        /**
		 * Intensity of the baked light.
		 *
		 * @type {number}
		 * @default 1
		 */ this.lightMapIntensity = 1.0;
        /**
		 * The red channel of this texture is used as the ambient occlusion map.
		 * Requires a second set of UVs.
		 *
		 * @type {?Texture}
		 * @default null
		 */ this.aoMap = null;
        /**
		 * Intensity of the ambient occlusion effect. Range is `[0,1]`, where `0`
		 * disables ambient occlusion. Where intensity is `1` and the AO map's
		 * red channel is also `1`, ambient light is fully occluded on a surface.
		 *
		 * @type {number}
		 * @default 1
		 */ this.aoMapIntensity = 1.0;
        /**
		 * Emissive (light) color of the material, essentially a solid color
		 * unaffected by other lighting.
		 *
		 * @type {Color}
		 * @default (0,0,0)
		 */ this.emissive = new $9ddd7e9b53f7a2d4$export$892596cec99bc70e(0x000000);
        /**
		 * Intensity of the emissive light. Modulates the emissive color.
		 *
		 * @type {number}
		 * @default 1
		 */ this.emissiveIntensity = 1.0;
        /**
		 * Set emissive (glow) map. The emissive map color is modulated by the
		 * emissive color and the emissive intensity. If you have an emissive map,
		 * be sure to set the emissive color to something other than black.
		 *
		 * @type {?Texture}
		 * @default null
		 */ this.emissiveMap = null;
        /**
		 * The texture to create a bump map. The black and white values map to the
		 * perceived depth in relation to the lights. Bump doesn't actually affect
		 * the geometry of the object, only the lighting. If a normal map is defined
		 * this will be ignored.
		 *
		 * @type {?Texture}
		 * @default null
		 */ this.bumpMap = null;
        /**
		 * How much the bump map affects the material. Typical range is `[0,1]`.
		 *
		 * @type {number}
		 * @default 1
		 */ this.bumpScale = 1;
        /**
		 * The texture to create a normal map. The RGB values affect the surface
		 * normal for each pixel fragment and change the way the color is lit. Normal
		 * maps do not change the actual shape of the surface, only the lighting. In
		 * case the material has a normal map authored using the left handed
		 * convention, the `y` component of `normalScale` should be negated to compensate
		 * for the different handedness.
		 *
		 * @type {?Texture}
		 * @default null
		 */ this.normalMap = null;
        /**
		 * The type of normal map.
		 *
		 * @type {(TangentSpaceNormalMap|ObjectSpaceNormalMap)}
		 * @default TangentSpaceNormalMap
		 */ this.normalMapType = $9ddd7e9b53f7a2d4$export$2852a58ebdac27b8;
        /**
		 * How much the normal map affects the material. Typical value range is `[0,1]`.
		 *
		 * @type {Vector2}
		 * @default (1,1)
		 */ this.normalScale = new $9ddd7e9b53f7a2d4$export$c977b3e384af9ae1(1, 1);
        /**
		 * The displacement map affects the position of the mesh's vertices. Unlike
		 * other maps which only affect the light and shade of the material the
		 * displaced vertices can cast shadows, block other objects, and otherwise
		 * act as real geometry. The displacement texture is an image where the value
		 * of each pixel (white being the highest) is mapped against, and
		 * repositions, the vertices of the mesh.
		 *
		 * @type {?Texture}
		 * @default null
		 */ this.displacementMap = null;
        /**
		 * How much the displacement map affects the mesh (where black is no
		 * displacement, and white is maximum displacement). Without a displacement
		 * map set, this value is not applied.
		 *
		 * @type {number}
		 * @default 0
		 */ this.displacementScale = 1;
        /**
		 * The offset of the displacement map's values on the mesh's vertices.
		 * The bias is added to the scaled sample of the displacement map.
		 * Without a displacement map set, this value is not applied.
		 *
		 * @type {number}
		 * @default 0
		 */ this.displacementBias = 0;
        /**
		 * The green channel of this texture is used to alter the roughness of the
		 * material.
		 *
		 * @type {?Texture}
		 * @default null
		 */ this.roughnessMap = null;
        /**
		 * The blue channel of this texture is used to alter the metalness of the
		 * material.
		 *
		 * @type {?Texture}
		 * @default null
		 */ this.metalnessMap = null;
        /**
		 * The alpha map is a grayscale texture that controls the opacity across the
		 * surface (black: fully transparent; white: fully opaque).
		 *
		 * Only the color of the texture is used, ignoring the alpha channel if one
		 * exists. For RGB and RGBA textures, the renderer will use the green channel
		 * when sampling this texture due to the extra bit of precision provided for
		 * green in DXT-compressed and uncompressed RGB 565 formats. Luminance-only and
		 * luminance/alpha textures will also still work as expected.
		 *
		 * @type {?Texture}
		 * @default null
		 */ this.alphaMap = null;
        /**
		 * The environment map. To ensure a physically correct rendering, environment maps
		 * are internally pre-processed with {@link PMREMGenerator}.
		 *
		 * @type {?Texture}
		 * @default null
		 */ this.envMap = null;
        /**
		 * The rotation of the environment map in radians.
		 *
		 * @type {Euler}
		 * @default (0,0,0)
		 */ this.envMapRotation = new $9ddd7e9b53f7a2d4$export$d93cc409a0768c5f();
        /**
		 * Scales the effect of the environment map by multiplying its color.
		 *
		 * @type {number}
		 * @default 1
		 */ this.envMapIntensity = 1.0;
        /**
		 * Renders the geometry as a wireframe.
		 *
		 * @type {boolean}
		 * @default false
		 */ this.wireframe = false;
        /**
		 * Controls the thickness of the wireframe.
		 *
		 * Can only be used with {@link SVGRenderer}.
		 *
		 * @type {number}
		 * @default 1
		 */ this.wireframeLinewidth = 1;
        /**
		 * Defines appearance of wireframe ends.
		 *
		 * Can only be used with {@link SVGRenderer}.
		 *
		 * @type {('round'|'bevel'|'miter')}
		 * @default 'round'
		 */ this.wireframeLinecap = 'round';
        /**
		 * Defines appearance of wireframe joints.
		 *
		 * Can only be used with {@link SVGRenderer}.
		 *
		 * @type {('round'|'bevel'|'miter')}
		 * @default 'round'
		 */ this.wireframeLinejoin = 'round';
        /**
		 * Whether the material is rendered with flat shading or not.
		 *
		 * @type {boolean}
		 * @default false
		 */ this.flatShading = false;
        /**
		 * Whether the material is affected by fog or not.
		 *
		 * @type {boolean}
		 * @default true
		 */ this.fog = true;
        this.setValues(parameters);
    }
    copy(source) {
        super.copy(source);
        this.defines = {
            'STANDARD': ''
        };
        this.color.copy(source.color);
        this.roughness = source.roughness;
        this.metalness = source.metalness;
        this.map = source.map;
        this.lightMap = source.lightMap;
        this.lightMapIntensity = source.lightMapIntensity;
        this.aoMap = source.aoMap;
        this.aoMapIntensity = source.aoMapIntensity;
        this.emissive.copy(source.emissive);
        this.emissiveMap = source.emissiveMap;
        this.emissiveIntensity = source.emissiveIntensity;
        this.bumpMap = source.bumpMap;
        this.bumpScale = source.bumpScale;
        this.normalMap = source.normalMap;
        this.normalMapType = source.normalMapType;
        this.normalScale.copy(source.normalScale);
        this.displacementMap = source.displacementMap;
        this.displacementScale = source.displacementScale;
        this.displacementBias = source.displacementBias;
        this.roughnessMap = source.roughnessMap;
        this.metalnessMap = source.metalnessMap;
        this.alphaMap = source.alphaMap;
        this.envMap = source.envMap;
        this.envMapRotation.copy(source.envMapRotation);
        this.envMapIntensity = source.envMapIntensity;
        this.wireframe = source.wireframe;
        this.wireframeLinewidth = source.wireframeLinewidth;
        this.wireframeLinecap = source.wireframeLinecap;
        this.wireframeLinejoin = source.wireframeLinejoin;
        this.flatShading = source.flatShading;
        this.fog = source.fog;
        return this;
    }
}
/**
 * An extension of the {@link MeshStandardMaterial}, providing more advanced
 * physically-based rendering properties:
 *
 * - Anisotropy: Ability to represent the anisotropic property of materials
 * as observable with brushed metals.
 * - Clearcoat: Some materials — like car paints, carbon fiber, and wet surfaces — require
 * a clear, reflective layer on top of another layer that may be irregular or rough.
 * Clearcoat approximates this effect, without the need for a separate transparent surface.
 * - Iridescence: Allows to render the effect where hue varies  depending on the viewing
 * angle and illumination angle. This can be seen on soap bubbles, oil films, or on the
 * wings of many insects.
 * - Physically-based transparency: One limitation of {@link Material#opacity} is that highly
 * transparent materials are less reflective. Physically-based transmission provides a more
 * realistic option for thin, transparent surfaces like glass.
 * - Advanced reflectivity: More flexible reflectivity for non-metallic materials.
 * - Sheen: Can be used for representing cloth and fabric materials.
 *
 * As a result of these complex shading features, `MeshPhysicalMaterial` has a
 * higher performance cost, per pixel, than other three.js materials. Most
 * effects are disabled by default, and add cost as they are enabled. For
 * best results, always specify an environment map when using this material.
 *
 * @augments MeshStandardMaterial
 */ class $9ddd7e9b53f7a2d4$export$28d04986c4269c9f extends $9ddd7e9b53f7a2d4$export$f2980790215acccd {
    /**
	 * Constructs a new mesh physical material.
	 *
	 * @param {Object} [parameters] - An object with one or more properties
	 * defining the material's appearance. Any property of the material
	 * (including any property from inherited materials) can be passed
	 * in here. Color values can be passed any type of value accepted
	 * by {@link Color#set}.
	 */ constructor(parameters){
        super();
        /**
		 * This flag can be used for type testing.
		 *
		 * @type {boolean}
		 * @readonly
		 * @default true
		 */ this.isMeshPhysicalMaterial = true;
        this.defines = {
            'STANDARD': '',
            'PHYSICAL': ''
        };
        this.type = 'MeshPhysicalMaterial';
        /**
		 * The rotation of the anisotropy in tangent, bitangent space, measured in radians
		 * counter-clockwise from the tangent. When `anisotropyMap` is present, this
		 * property provides additional rotation to the vectors in the texture.
		 *
		 * @type {number}
		 * @default 1
		 */ this.anisotropyRotation = 0;
        /**
		 * Red and green channels represent the anisotropy direction in `[-1, 1]` tangent,
		 * bitangent space, to be rotated by `anisotropyRotation`. The blue channel
		 * contains strength as `[0, 1]` to be multiplied by `anisotropy`.
		 *
		 * @type {?Texture}
		 * @default null
		 */ this.anisotropyMap = null;
        /**
		 * The red channel of this texture is multiplied against `clearcoat`,
		 * for per-pixel control over a coating's intensity.
		 *
		 * @type {?Texture}
		 * @default null
		 */ this.clearcoatMap = null;
        /**
		 * Roughness of the clear coat layer, from `0.0` to `1.0`.
		 *
		 * @type {number}
		 * @default 0
		 */ this.clearcoatRoughness = 0.0;
        /**
		 * The green channel of this texture is multiplied against
		 * `clearcoatRoughness`, for per-pixel control over a coating's roughness.
		 *
		 * @type {?Texture}
		 * @default null
		 */ this.clearcoatRoughnessMap = null;
        /**
		 * How much `clearcoatNormalMap` affects the clear coat layer, from
		 * `(0,0)` to `(1,1)`.
		 *
		 * @type {Vector2}
		 * @default (1,1)
		 */ this.clearcoatNormalScale = new $9ddd7e9b53f7a2d4$export$c977b3e384af9ae1(1, 1);
        /**
		 * Can be used to enable independent normals for the clear coat layer.
		 *
		 * @type {?Texture}
		 * @default null
		 */ this.clearcoatNormalMap = null;
        /**
		 * Index-of-refraction for non-metallic materials, from `1.0` to `2.333`.
		 *
		 * @type {number}
		 * @default 1.5
		 */ this.ior = 1.5;
        /**
		 * Degree of reflectivity, from `0.0` to `1.0`. Default is `0.5`, which
		 * corresponds to an index-of-refraction of `1.5`.
		 *
		 * This models the reflectivity of non-metallic materials. It has no effect
		 * when `metalness` is `1.0`
		 *
		 * @name MeshPhysicalMaterial#reflectivity
		 * @type {number}
		 * @default 0.5
		 */ Object.defineProperty(this, 'reflectivity', {
            get: function() {
                return $9ddd7e9b53f7a2d4$var$clamp(2.5 * (this.ior - 1) / (this.ior + 1), 0, 1);
            },
            set: function(reflectivity) {
                this.ior = (1 + 0.4 * reflectivity) / (1 - 0.4 * reflectivity);
            }
        });
        /**
		 * The red channel of this texture is multiplied against `iridescence`, for per-pixel
		 * control over iridescence.
		 *
		 * @type {?Texture}
		 * @default null
		 */ this.iridescenceMap = null;
        /**
		 * Strength of the iridescence RGB color shift effect, represented by an index-of-refraction.
		 * Between `1.0` to `2.333`.
		 *
		 * @type {number}
		 * @default 1.3
		 */ this.iridescenceIOR = 1.3;
        /**
		 *Array of exactly 2 elements, specifying minimum and maximum thickness of the iridescence layer.
		 Thickness of iridescence layer has an equivalent effect of the one `thickness` has on `ior`.
		 *
		 * @type {Array<number,number>}
		 * @default [100,400]
		 */ this.iridescenceThicknessRange = [
            100,
            400
        ];
        /**
		 * A texture that defines the thickness of the iridescence layer, stored in the green channel.
		 * Minimum and maximum values of thickness are defined by `iridescenceThicknessRange` array:
		 * - `0.0` in the green channel will result in thickness equal to first element of the array.
		 * - `1.0` in the green channel will result in thickness equal to second element of the array.
		 * - Values in-between will linearly interpolate between the elements of the array.
		 *
		 * @type {?Texture}
		 * @default null
		 */ this.iridescenceThicknessMap = null;
        /**
		 * The sheen tint.
		 *
		 * @type {Color}
		 * @default (0,0,0)
		 */ this.sheenColor = new $9ddd7e9b53f7a2d4$export$892596cec99bc70e(0x000000);
        /**
		 * The RGB channels of this texture are multiplied against  `sheenColor`, for per-pixel control
		 * over sheen tint.
		 *
		 * @type {?Texture}
		 * @default null
		 */ this.sheenColorMap = null;
        /**
		 * Roughness of the sheen layer, from `0.0` to `1.0`.
		 *
		 * @type {number}
		 * @default 1
		 */ this.sheenRoughness = 1.0;
        /**
		 * The alpha channel of this texture is multiplied against `sheenRoughness`, for per-pixel control
		 * over sheen roughness.
		 *
		 * @type {?Texture}
		 * @default null
		 */ this.sheenRoughnessMap = null;
        /**
		 * The red channel of this texture is multiplied against `transmission`, for per-pixel control over
		 * optical transparency.
		 *
		 * @type {?Texture}
		 * @default null
		 */ this.transmissionMap = null;
        /**
		 * The thickness of the volume beneath the surface. The value is given in the
		 * coordinate space of the mesh. If the value is `0` the material is
		 * thin-walled. Otherwise the material is a volume boundary.
		 *
		 * @type {number}
		 * @default 0
		 */ this.thickness = 0;
        /**
		 * A texture that defines the thickness, stored in the green channel. This will
		 * be multiplied by `thickness`.
		 *
		 * @type {?Texture}
		 * @default null
		 */ this.thicknessMap = null;
        /**
		 * Density of the medium given as the average distance that light travels in
		 * the medium before interacting with a particle. The value is given in world
		 * space units, and must be greater than zero.
		 *
		 * @type {number}
		 * @default Infinity
		 */ this.attenuationDistance = Infinity;
        /**
		 * The color that white light turns into due to absorption when reaching the
		 * attenuation distance.
		 *
		 * @type {Color}
		 * @default (1,1,1)
		 */ this.attenuationColor = new $9ddd7e9b53f7a2d4$export$892596cec99bc70e(1, 1, 1);
        /**
		 * A float that scales the amount of specular reflection for non-metals only.
		 * When set to zero, the model is effectively Lambertian. From `0.0` to `1.0`.
		 *
		 * @type {number}
		 * @default 1
		 */ this.specularIntensity = 1.0;
        /**
		 * The alpha channel of this texture is multiplied against `specularIntensity`,
		 * for per-pixel control over specular intensity.
		 *
		 * @type {?Texture}
		 * @default null
		 */ this.specularIntensityMap = null;
        /**
		 * Tints the specular reflection at normal incidence for non-metals only.
		 *
		 * @type {Color}
		 * @default (1,1,1)
		 */ this.specularColor = new $9ddd7e9b53f7a2d4$export$892596cec99bc70e(1, 1, 1);
        /**
		 * The RGB channels of this texture are multiplied against `specularColor`,
		 * for per-pixel control over specular color.
		 *
		 * @type {?Texture}
		 * @default null
		 */ this.specularColorMap = null;
        this._anisotropy = 0;
        this._clearcoat = 0;
        this._dispersion = 0;
        this._iridescence = 0;
        this._sheen = 0.0;
        this._transmission = 0;
        this.setValues(parameters);
    }
    /**
	 * The anisotropy strength.
	 *
	 * @type {number}
	 * @default 0
	 */ get anisotropy() {
        return this._anisotropy;
    }
    set anisotropy(value) {
        if (this._anisotropy > 0 !== value > 0) this.version++;
        this._anisotropy = value;
    }
    /**
	 * Represents the intensity of the clear coat layer, from `0.0` to `1.0`. Use
	 * clear coat related properties to enable multilayer materials that have a
	 * thin translucent layer over the base layer.
	 *
	 * @type {number}
	 * @default 0
	 */ get clearcoat() {
        return this._clearcoat;
    }
    set clearcoat(value) {
        if (this._clearcoat > 0 !== value > 0) this.version++;
        this._clearcoat = value;
    }
    /**
	 * The intensity of the iridescence layer, simulating RGB color shift based on the angle between
	 * the surface and the viewer, from `0.0` to `1.0`.
	 *
	 * @type {number}
	 * @default 0
	 */ get iridescence() {
        return this._iridescence;
    }
    set iridescence(value) {
        if (this._iridescence > 0 !== value > 0) this.version++;
        this._iridescence = value;
    }
    /**
	 * Defines the strength of the angular separation of colors (chromatic aberration) transmitting
	 * through a relatively clear volume. Any value zero or larger is valid, the typical range of
	 * realistic values is `[0, 1]`. This property can be only be used with transmissive objects.
	 *
	 * @type {number}
	 * @default 0
	 */ get dispersion() {
        return this._dispersion;
    }
    set dispersion(value) {
        if (this._dispersion > 0 !== value > 0) this.version++;
        this._dispersion = value;
    }
    /**
	 * The intensity of the sheen layer, from `0.0` to `1.0`.
	 *
	 * @type {number}
	 * @default 0
	 */ get sheen() {
        return this._sheen;
    }
    set sheen(value) {
        if (this._sheen > 0 !== value > 0) this.version++;
        this._sheen = value;
    }
    /**
	 * Degree of transmission (or optical transparency), from `0.0` to `1.0`.
	 *
	 * Thin, transparent or semitransparent, plastic or glass materials remain
	 * largely reflective even if they are fully transmissive. The transmission
	 * property can be used to model these materials.
	 *
	 * When transmission is non-zero, `opacity` should be  set to `1`.
	 *
	 * @type {number}
	 * @default 0
	 */ get transmission() {
        return this._transmission;
    }
    set transmission(value) {
        if (this._transmission > 0 !== value > 0) this.version++;
        this._transmission = value;
    }
    copy(source) {
        super.copy(source);
        this.defines = {
            'STANDARD': '',
            'PHYSICAL': ''
        };
        this.anisotropy = source.anisotropy;
        this.anisotropyRotation = source.anisotropyRotation;
        this.anisotropyMap = source.anisotropyMap;
        this.clearcoat = source.clearcoat;
        this.clearcoatMap = source.clearcoatMap;
        this.clearcoatRoughness = source.clearcoatRoughness;
        this.clearcoatRoughnessMap = source.clearcoatRoughnessMap;
        this.clearcoatNormalMap = source.clearcoatNormalMap;
        this.clearcoatNormalScale.copy(source.clearcoatNormalScale);
        this.dispersion = source.dispersion;
        this.ior = source.ior;
        this.iridescence = source.iridescence;
        this.iridescenceMap = source.iridescenceMap;
        this.iridescenceIOR = source.iridescenceIOR;
        this.iridescenceThicknessRange = [
            ...source.iridescenceThicknessRange
        ];
        this.iridescenceThicknessMap = source.iridescenceThicknessMap;
        this.sheen = source.sheen;
        this.sheenColor.copy(source.sheenColor);
        this.sheenColorMap = source.sheenColorMap;
        this.sheenRoughness = source.sheenRoughness;
        this.sheenRoughnessMap = source.sheenRoughnessMap;
        this.transmission = source.transmission;
        this.transmissionMap = source.transmissionMap;
        this.thickness = source.thickness;
        this.thicknessMap = source.thicknessMap;
        this.attenuationDistance = source.attenuationDistance;
        this.attenuationColor.copy(source.attenuationColor);
        this.specularIntensity = source.specularIntensity;
        this.specularIntensityMap = source.specularIntensityMap;
        this.specularColor.copy(source.specularColor);
        this.specularColorMap = source.specularColorMap;
        return this;
    }
}
/**
 * A material for shiny surfaces with specular highlights.
 *
 * The material uses a non-physically based [Blinn-Phong]{@link https://en.wikipedia.org/wiki/Blinn-Phong_shading_model}
 * model for calculating reflectance. Unlike the Lambertian model used in the
 * {@link MeshLambertMaterial} this can simulate shiny surfaces with specular
 * highlights (such as varnished wood). `MeshPhongMaterial` uses per-fragment shading.
 *
 * Performance will generally be greater when using this material over the
 * {@link MeshStandardMaterial} or {@link MeshPhysicalMaterial}, at the cost of
 * some graphical accuracy.
 *
 * @augments Material
 */ class $9ddd7e9b53f7a2d4$export$24c72f71cbaf0678 extends $9ddd7e9b53f7a2d4$export$a2d8b23205c25948 {
    /**
	 * Constructs a new mesh phong material.
	 *
	 * @param {Object} [parameters] - An object with one or more properties
	 * defining the material's appearance. Any property of the material
	 * (including any property from inherited materials) can be passed
	 * in here. Color values can be passed any type of value accepted
	 * by {@link Color#set}.
	 */ constructor(parameters){
        super();
        /**
		 * This flag can be used for type testing.
		 *
		 * @type {boolean}
		 * @readonly
		 * @default true
		 */ this.isMeshPhongMaterial = true;
        this.type = 'MeshPhongMaterial';
        /**
		 * Color of the material.
		 *
		 * @type {Color}
		 * @default (1,1,1)
		 */ this.color = new $9ddd7e9b53f7a2d4$export$892596cec99bc70e(0xffffff); // diffuse
        /**
		 * Specular color of the material. The default color is set to `0x111111` (very dark grey)
		 *
		 * This defines how shiny the material is and the color of its shine.
		 *
		 * @type {Color}
		 */ this.specular = new $9ddd7e9b53f7a2d4$export$892596cec99bc70e(0x111111);
        /**
		 * How shiny the specular highlight is; a higher value gives a sharper highlight.
		 *
		 * @type {number}
		 * @default 30
		 */ this.shininess = 30;
        /**
		 * The color map. May optionally include an alpha channel, typically combined
		 * with {@link Material#transparent} or {@link Material#alphaTest}. The texture map
		 * color is modulated by the diffuse `color`.
		 *
		 * @type {?Texture}
		 * @default null
		 */ this.map = null;
        /**
		 * The light map. Requires a second set of UVs.
		 *
		 * @type {?Texture}
		 * @default null
		 */ this.lightMap = null;
        /**
		 * Intensity of the baked light.
		 *
		 * @type {number}
		 * @default 1
		 */ this.lightMapIntensity = 1.0;
        /**
		 * The red channel of this texture is used as the ambient occlusion map.
		 * Requires a second set of UVs.
		 *
		 * @type {?Texture}
		 * @default null
		 */ this.aoMap = null;
        /**
		 * Intensity of the ambient occlusion effect. Range is `[0,1]`, where `0`
		 * disables ambient occlusion. Where intensity is `1` and the AO map's
		 * red channel is also `1`, ambient light is fully occluded on a surface.
		 *
		 * @type {number}
		 * @default 1
		 */ this.aoMapIntensity = 1.0;
        /**
		 * Emissive (light) color of the material, essentially a solid color
		 * unaffected by other lighting.
		 *
		 * @type {Color}
		 * @default (0,0,0)
		 */ this.emissive = new $9ddd7e9b53f7a2d4$export$892596cec99bc70e(0x000000);
        /**
		 * Intensity of the emissive light. Modulates the emissive color.
		 *
		 * @type {number}
		 * @default 1
		 */ this.emissiveIntensity = 1.0;
        /**
		 * Set emissive (glow) map. The emissive map color is modulated by the
		 * emissive color and the emissive intensity. If you have an emissive map,
		 * be sure to set the emissive color to something other than black.
		 *
		 * @type {?Texture}
		 * @default null
		 */ this.emissiveMap = null;
        /**
		 * The texture to create a bump map. The black and white values map to the
		 * perceived depth in relation to the lights. Bump doesn't actually affect
		 * the geometry of the object, only the lighting. If a normal map is defined
		 * this will be ignored.
		 *
		 * @type {?Texture}
		 * @default null
		 */ this.bumpMap = null;
        /**
		 * How much the bump map affects the material. Typical range is `[0,1]`.
		 *
		 * @type {number}
		 * @default 1
		 */ this.bumpScale = 1;
        /**
		 * The texture to create a normal map. The RGB values affect the surface
		 * normal for each pixel fragment and change the way the color is lit. Normal
		 * maps do not change the actual shape of the surface, only the lighting. In
		 * case the material has a normal map authored using the left handed
		 * convention, the `y` component of `normalScale` should be negated to compensate
		 * for the different handedness.
		 *
		 * @type {?Texture}
		 * @default null
		 */ this.normalMap = null;
        /**
		 * The type of normal map.
		 *
		 * @type {(TangentSpaceNormalMap|ObjectSpaceNormalMap)}
		 * @default TangentSpaceNormalMap
		 */ this.normalMapType = $9ddd7e9b53f7a2d4$export$2852a58ebdac27b8;
        /**
		 * How much the normal map affects the material. Typical value range is `[0,1]`.
		 *
		 * @type {Vector2}
		 * @default (1,1)
		 */ this.normalScale = new $9ddd7e9b53f7a2d4$export$c977b3e384af9ae1(1, 1);
        /**
		 * The displacement map affects the position of the mesh's vertices. Unlike
		 * other maps which only affect the light and shade of the material the
		 * displaced vertices can cast shadows, block other objects, and otherwise
		 * act as real geometry. The displacement texture is an image where the value
		 * of each pixel (white being the highest) is mapped against, and
		 * repositions, the vertices of the mesh.
		 *
		 * @type {?Texture}
		 * @default null
		 */ this.displacementMap = null;
        /**
		 * How much the displacement map affects the mesh (where black is no
		 * displacement, and white is maximum displacement). Without a displacement
		 * map set, this value is not applied.
		 *
		 * @type {number}
		 * @default 0
		 */ this.displacementScale = 1;
        /**
		 * The offset of the displacement map's values on the mesh's vertices.
		 * The bias is added to the scaled sample of the displacement map.
		 * Without a displacement map set, this value is not applied.
		 *
		 * @type {number}
		 * @default 0
		 */ this.displacementBias = 0;
        /**
		 * The specular map value affects both how much the specular surface
		 * highlight contributes and how much of the environment map affects the
		 * surface.
		 *
		 * @type {?Texture}
		 * @default null
		 */ this.specularMap = null;
        /**
		 * The alpha map is a grayscale texture that controls the opacity across the
		 * surface (black: fully transparent; white: fully opaque).
		 *
		 * Only the color of the texture is used, ignoring the alpha channel if one
		 * exists. For RGB and RGBA textures, the renderer will use the green channel
		 * when sampling this texture due to the extra bit of precision provided for
		 * green in DXT-compressed and uncompressed RGB 565 formats. Luminance-only and
		 * luminance/alpha textures will also still work as expected.
		 *
		 * @type {?Texture}
		 * @default null
		 */ this.alphaMap = null;
        /**
		 * The environment map.
		 *
		 * @type {?Texture}
		 * @default null
		 */ this.envMap = null;
        /**
		 * The rotation of the environment map in radians.
		 *
		 * @type {Euler}
		 * @default (0,0,0)
		 */ this.envMapRotation = new $9ddd7e9b53f7a2d4$export$d93cc409a0768c5f();
        /**
		 * How to combine the result of the surface's color with the environment map, if any.
		 *
		 * When set to `MixOperation`, the {@link MeshBasicMaterial#reflectivity} is used to
		 * blend between the two colors.
		 *
		 * @type {(MultiplyOperation|MixOperation|AddOperation)}
		 * @default MultiplyOperation
		 */ this.combine = $9ddd7e9b53f7a2d4$export$e50ac29801f1774d;
        /**
		 * How much the environment map affects the surface.
		 * The valid range is between `0` (no reflections) and `1` (full reflections).
		 *
		 * @type {number}
		 * @default 1
		 */ this.reflectivity = 1;
        /**
		 * The index of refraction (IOR) of air (approximately 1) divided by the
		 * index of refraction of the material. It is used with environment mapping
		 * modes {@link CubeRefractionMapping} and {@link EquirectangularRefractionMapping}.
		 * The refraction ratio should not exceed `1`.
		 *
		 * @type {number}
		 * @default 0.98
		 */ this.refractionRatio = 0.98;
        /**
		 * Renders the geometry as a wireframe.
		 *
		 * @type {boolean}
		 * @default false
		 */ this.wireframe = false;
        /**
		 * Controls the thickness of the wireframe.
		 *
		 * Can only be used with {@link SVGRenderer}.
		 *
		 * @type {number}
		 * @default 1
		 */ this.wireframeLinewidth = 1;
        /**
		 * Defines appearance of wireframe ends.
		 *
		 * Can only be used with {@link SVGRenderer}.
		 *
		 * @type {('round'|'bevel'|'miter')}
		 * @default 'round'
		 */ this.wireframeLinecap = 'round';
        /**
		 * Defines appearance of wireframe joints.
		 *
		 * Can only be used with {@link SVGRenderer}.
		 *
		 * @type {('round'|'bevel'|'miter')}
		 * @default 'round'
		 */ this.wireframeLinejoin = 'round';
        /**
		 * Whether the material is rendered with flat shading or not.
		 *
		 * @type {boolean}
		 * @default false
		 */ this.flatShading = false;
        /**
		 * Whether the material is affected by fog or not.
		 *
		 * @type {boolean}
		 * @default true
		 */ this.fog = true;
        this.setValues(parameters);
    }
    copy(source) {
        super.copy(source);
        this.color.copy(source.color);
        this.specular.copy(source.specular);
        this.shininess = source.shininess;
        this.map = source.map;
        this.lightMap = source.lightMap;
        this.lightMapIntensity = source.lightMapIntensity;
        this.aoMap = source.aoMap;
        this.aoMapIntensity = source.aoMapIntensity;
        this.emissive.copy(source.emissive);
        this.emissiveMap = source.emissiveMap;
        this.emissiveIntensity = source.emissiveIntensity;
        this.bumpMap = source.bumpMap;
        this.bumpScale = source.bumpScale;
        this.normalMap = source.normalMap;
        this.normalMapType = source.normalMapType;
        this.normalScale.copy(source.normalScale);
        this.displacementMap = source.displacementMap;
        this.displacementScale = source.displacementScale;
        this.displacementBias = source.displacementBias;
        this.specularMap = source.specularMap;
        this.alphaMap = source.alphaMap;
        this.envMap = source.envMap;
        this.envMapRotation.copy(source.envMapRotation);
        this.combine = source.combine;
        this.reflectivity = source.reflectivity;
        this.refractionRatio = source.refractionRatio;
        this.wireframe = source.wireframe;
        this.wireframeLinewidth = source.wireframeLinewidth;
        this.wireframeLinecap = source.wireframeLinecap;
        this.wireframeLinejoin = source.wireframeLinejoin;
        this.flatShading = source.flatShading;
        this.fog = source.fog;
        return this;
    }
}
/**
 * A material implementing toon shading.
 *
 * @augments Material
 */ class $9ddd7e9b53f7a2d4$export$df893cf97e765622 extends $9ddd7e9b53f7a2d4$export$a2d8b23205c25948 {
    /**
	 * Constructs a new mesh toon material.
	 *
	 * @param {Object} [parameters] - An object with one or more properties
	 * defining the material's appearance. Any property of the material
	 * (including any property from inherited materials) can be passed
	 * in here. Color values can be passed any type of value accepted
	 * by {@link Color#set}.
	 */ constructor(parameters){
        super();
        /**
		 * This flag can be used for type testing.
		 *
		 * @type {boolean}
		 * @readonly
		 * @default true
		 */ this.isMeshToonMaterial = true;
        this.defines = {
            'TOON': ''
        };
        this.type = 'MeshToonMaterial';
        /**
		 * Color of the material.
		 *
		 * @type {Color}
		 * @default (1,1,1)
		 */ this.color = new $9ddd7e9b53f7a2d4$export$892596cec99bc70e(0xffffff);
        /**
		 * The color map. May optionally include an alpha channel, typically combined
		 * with {@link Material#transparent} or {@link Material#alphaTest}. The texture map
		 * color is modulated by the diffuse `color`.
		 *
		 * @type {?Texture}
		 * @default null
		 */ this.map = null;
        /**
		 * Gradient map for toon shading. It's required to set
		 * {@link Texture#minFilter} and {@link Texture#magFilter} to {@linkNearestFilter}
		 * when using this type of texture.
		 *
		 * @type {?Texture}
		 * @default null
		 */ this.gradientMap = null;
        /**
		 * The light map. Requires a second set of UVs.
		 *
		 * @type {?Texture}
		 * @default null
		 */ this.lightMap = null;
        /**
		 * Intensity of the baked light.
		 *
		 * @type {number}
		 * @default 1
		 */ this.lightMapIntensity = 1.0;
        /**
		 * The red channel of this texture is used as the ambient occlusion map.
		 * Requires a second set of UVs.
		 *
		 * @type {?Texture}
		 * @default null
		 */ this.aoMap = null;
        /**
		 * Intensity of the ambient occlusion effect. Range is `[0,1]`, where `0`
		 * disables ambient occlusion. Where intensity is `1` and the AO map's
		 * red channel is also `1`, ambient light is fully occluded on a surface.
		 *
		 * @type {number}
		 * @default 1
		 */ this.aoMapIntensity = 1.0;
        /**
		 * Emissive (light) color of the material, essentially a solid color
		 * unaffected by other lighting.
		 *
		 * @type {Color}
		 * @default (0,0,0)
		 */ this.emissive = new $9ddd7e9b53f7a2d4$export$892596cec99bc70e(0x000000);
        /**
		 * Intensity of the emissive light. Modulates the emissive color.
		 *
		 * @type {number}
		 * @default 1
		 */ this.emissiveIntensity = 1.0;
        /**
		 * Set emissive (glow) map. The emissive map color is modulated by the
		 * emissive color and the emissive intensity. If you have an emissive map,
		 * be sure to set the emissive color to something other than black.
		 *
		 * @type {?Texture}
		 * @default null
		 */ this.emissiveMap = null;
        /**
		 * The texture to create a bump map. The black and white values map to the
		 * perceived depth in relation to the lights. Bump doesn't actually affect
		 * the geometry of the object, only the lighting. If a normal map is defined
		 * this will be ignored.
		 *
		 * @type {?Texture}
		 * @default null
		 */ this.bumpMap = null;
        /**
		 * How much the bump map affects the material. Typical range is `[0,1]`.
		 *
		 * @type {number}
		 * @default 1
		 */ this.bumpScale = 1;
        /**
		 * The texture to create a normal map. The RGB values affect the surface
		 * normal for each pixel fragment and change the way the color is lit. Normal
		 * maps do not change the actual shape of the surface, only the lighting. In
		 * case the material has a normal map authored using the left handed
		 * convention, the `y` component of `normalScale` should be negated to compensate
		 * for the different handedness.
		 *
		 * @type {?Texture}
		 * @default null
		 */ this.normalMap = null;
        /**
		 * The type of normal map.
		 *
		 * @type {(TangentSpaceNormalMap|ObjectSpaceNormalMap)}
		 * @default TangentSpaceNormalMap
		 */ this.normalMapType = $9ddd7e9b53f7a2d4$export$2852a58ebdac27b8;
        /**
		 * How much the normal map affects the material. Typical value range is `[0,1]`.
		 *
		 * @type {Vector2}
		 * @default (1,1)
		 */ this.normalScale = new $9ddd7e9b53f7a2d4$export$c977b3e384af9ae1(1, 1);
        /**
		 * The displacement map affects the position of the mesh's vertices. Unlike
		 * other maps which only affect the light and shade of the material the
		 * displaced vertices can cast shadows, block other objects, and otherwise
		 * act as real geometry. The displacement texture is an image where the value
		 * of each pixel (white being the highest) is mapped against, and
		 * repositions, the vertices of the mesh.
		 *
		 * @type {?Texture}
		 * @default null
		 */ this.displacementMap = null;
        /**
		 * How much the displacement map affects the mesh (where black is no
		 * displacement, and white is maximum displacement). Without a displacement
		 * map set, this value is not applied.
		 *
		 * @type {number}
		 * @default 0
		 */ this.displacementScale = 1;
        /**
		 * The offset of the displacement map's values on the mesh's vertices.
		 * The bias is added to the scaled sample of the displacement map.
		 * Without a displacement map set, this value is not applied.
		 *
		 * @type {number}
		 * @default 0
		 */ this.displacementBias = 0;
        /**
		 * The alpha map is a grayscale texture that controls the opacity across the
		 * surface (black: fully transparent; white: fully opaque).
		 *
		 * Only the color of the texture is used, ignoring the alpha channel if one
		 * exists. For RGB and RGBA textures, the renderer will use the green channel
		 * when sampling this texture due to the extra bit of precision provided for
		 * green in DXT-compressed and uncompressed RGB 565 formats. Luminance-only and
		 * luminance/alpha textures will also still work as expected.
		 *
		 * @type {?Texture}
		 * @default null
		 */ this.alphaMap = null;
        /**
		 * Renders the geometry as a wireframe.
		 *
		 * @type {boolean}
		 * @default false
		 */ this.wireframe = false;
        /**
		 * Controls the thickness of the wireframe.
		 *
		 * Can only be used with {@link SVGRenderer}.
		 *
		 * @type {number}
		 * @default 1
		 */ this.wireframeLinewidth = 1;
        /**
		 * Defines appearance of wireframe ends.
		 *
		 * Can only be used with {@link SVGRenderer}.
		 *
		 * @type {('round'|'bevel'|'miter')}
		 * @default 'round'
		 */ this.wireframeLinecap = 'round';
        /**
		 * Defines appearance of wireframe joints.
		 *
		 * Can only be used with {@link SVGRenderer}.
		 *
		 * @type {('round'|'bevel'|'miter')}
		 * @default 'round'
		 */ this.wireframeLinejoin = 'round';
        /**
		 * Whether the material is affected by fog or not.
		 *
		 * @type {boolean}
		 * @default true
		 */ this.fog = true;
        this.setValues(parameters);
    }
    copy(source) {
        super.copy(source);
        this.color.copy(source.color);
        this.map = source.map;
        this.gradientMap = source.gradientMap;
        this.lightMap = source.lightMap;
        this.lightMapIntensity = source.lightMapIntensity;
        this.aoMap = source.aoMap;
        this.aoMapIntensity = source.aoMapIntensity;
        this.emissive.copy(source.emissive);
        this.emissiveMap = source.emissiveMap;
        this.emissiveIntensity = source.emissiveIntensity;
        this.bumpMap = source.bumpMap;
        this.bumpScale = source.bumpScale;
        this.normalMap = source.normalMap;
        this.normalMapType = source.normalMapType;
        this.normalScale.copy(source.normalScale);
        this.displacementMap = source.displacementMap;
        this.displacementScale = source.displacementScale;
        this.displacementBias = source.displacementBias;
        this.alphaMap = source.alphaMap;
        this.wireframe = source.wireframe;
        this.wireframeLinewidth = source.wireframeLinewidth;
        this.wireframeLinecap = source.wireframeLinecap;
        this.wireframeLinejoin = source.wireframeLinejoin;
        this.fog = source.fog;
        return this;
    }
}
/**
 * A material that maps the normal vectors to RGB colors.
 *
 * @augments Material
 */ class $9ddd7e9b53f7a2d4$export$bfe8c0a091f41ae7 extends $9ddd7e9b53f7a2d4$export$a2d8b23205c25948 {
    /**
	 * Constructs a new mesh normal material.
	 *
	 * @param {Object} [parameters] - An object with one or more properties
	 * defining the material's appearance. Any property of the material
	 * (including any property from inherited materials) can be passed
	 * in here. Color values can be passed any type of value accepted
	 * by {@link Color#set}.
	 */ constructor(parameters){
        super();
        /**
		 * This flag can be used for type testing.
		 *
		 * @type {boolean}
		 * @readonly
		 * @default true
		 */ this.isMeshNormalMaterial = true;
        this.type = 'MeshNormalMaterial';
        /**
		 * The texture to create a bump map. The black and white values map to the
		 * perceived depth in relation to the lights. Bump doesn't actually affect
		 * the geometry of the object, only the lighting. If a normal map is defined
		 * this will be ignored.
		 *
		 * @type {?Texture}
		 * @default null
		 */ this.bumpMap = null;
        /**
		 * How much the bump map affects the material. Typical range is `[0,1]`.
		 *
		 * @type {number}
		 * @default 1
		 */ this.bumpScale = 1;
        /**
		 * The texture to create a normal map. The RGB values affect the surface
		 * normal for each pixel fragment and change the way the color is lit. Normal
		 * maps do not change the actual shape of the surface, only the lighting. In
		 * case the material has a normal map authored using the left handed
		 * convention, the `y` component of `normalScale` should be negated to compensate
		 * for the different handedness.
		 *
		 * @type {?Texture}
		 * @default null
		 */ this.normalMap = null;
        /**
		 * The type of normal map.
		 *
		 * @type {(TangentSpaceNormalMap|ObjectSpaceNormalMap)}
		 * @default TangentSpaceNormalMap
		 */ this.normalMapType = $9ddd7e9b53f7a2d4$export$2852a58ebdac27b8;
        /**
		 * How much the normal map affects the material. Typical value range is `[0,1]`.
		 *
		 * @type {Vector2}
		 * @default (1,1)
		 */ this.normalScale = new $9ddd7e9b53f7a2d4$export$c977b3e384af9ae1(1, 1);
        /**
		 * The displacement map affects the position of the mesh's vertices. Unlike
		 * other maps which only affect the light and shade of the material the
		 * displaced vertices can cast shadows, block other objects, and otherwise
		 * act as real geometry. The displacement texture is an image where the value
		 * of each pixel (white being the highest) is mapped against, and
		 * repositions, the vertices of the mesh.
		 *
		 * @type {?Texture}
		 * @default null
		 */ this.displacementMap = null;
        /**
		 * How much the displacement map affects the mesh (where black is no
		 * displacement, and white is maximum displacement). Without a displacement
		 * map set, this value is not applied.
		 *
		 * @type {number}
		 * @default 0
		 */ this.displacementScale = 1;
        /**
		 * The offset of the displacement map's values on the mesh's vertices.
		 * The bias is added to the scaled sample of the displacement map.
		 * Without a displacement map set, this value is not applied.
		 *
		 * @type {number}
		 * @default 0
		 */ this.displacementBias = 0;
        /**
		 * Renders the geometry as a wireframe.
		 *
		 * @type {boolean}
		 * @default false
		 */ this.wireframe = false;
        /**
		 * Controls the thickness of the wireframe.
		 *
		 * WebGL and WebGPU ignore this property and always render
		 * 1 pixel wide lines.
		 *
		 * @type {number}
		 * @default 1
		 */ this.wireframeLinewidth = 1;
        /**
		 * Whether the material is rendered with flat shading or not.
		 *
		 * @type {boolean}
		 * @default false
		 */ this.flatShading = false;
        this.setValues(parameters);
    }
    copy(source) {
        super.copy(source);
        this.bumpMap = source.bumpMap;
        this.bumpScale = source.bumpScale;
        this.normalMap = source.normalMap;
        this.normalMapType = source.normalMapType;
        this.normalScale.copy(source.normalScale);
        this.displacementMap = source.displacementMap;
        this.displacementScale = source.displacementScale;
        this.displacementBias = source.displacementBias;
        this.wireframe = source.wireframe;
        this.wireframeLinewidth = source.wireframeLinewidth;
        this.flatShading = source.flatShading;
        return this;
    }
}
/**
 * A material for non-shiny surfaces, without specular highlights.
 *
 * The material uses a non-physically based [Lambertian]{@link https://en.wikipedia.org/wiki/Lambertian_reflectance}
 * model for calculating reflectance. This can simulate some surfaces (such
 * as untreated wood or stone) well, but cannot simulate shiny surfaces with
 * specular highlights (such as varnished wood). `MeshLambertMaterial` uses per-fragment
 * shading.
 *
 * Due to the simplicity of the reflectance and illumination models,
 * performance will be greater when using this material over the
 * {@link MeshPhongMaterial}, {@link MeshStandardMaterial} or
 * {@link MeshPhysicalMaterial}, at the cost of some graphical accuracy.
 *
 * @augments Material
 */ class $9ddd7e9b53f7a2d4$export$5023a9a8114806b8 extends $9ddd7e9b53f7a2d4$export$a2d8b23205c25948 {
    /**
	 * Constructs a new mesh lambert material.
	 *
	 * @param {Object} [parameters] - An object with one or more properties
	 * defining the material's appearance. Any property of the material
	 * (including any property from inherited materials) can be passed
	 * in here. Color values can be passed any type of value accepted
	 * by {@link Color#set}.
	 */ constructor(parameters){
        super();
        /**
		 * This flag can be used for type testing.
		 *
		 * @type {boolean}
		 * @readonly
		 * @default true
		 */ this.isMeshLambertMaterial = true;
        this.type = 'MeshLambertMaterial';
        /**
		 * Color of the material.
		 *
		 * @type {Color}
		 * @default (1,1,1)
		 */ this.color = new $9ddd7e9b53f7a2d4$export$892596cec99bc70e(0xffffff); // diffuse
        /**
		 * The color map. May optionally include an alpha channel, typically combined
		 * with {@link Material#transparent} or {@link Material#alphaTest}. The texture map
		 * color is modulated by the diffuse `color`.
		 *
		 * @type {?Texture}
		 * @default null
		 */ this.map = null;
        /**
		 * The light map. Requires a second set of UVs.
		 *
		 * @type {?Texture}
		 * @default null
		 */ this.lightMap = null;
        /**
		 * Intensity of the baked light.
		 *
		 * @type {number}
		 * @default 1
		 */ this.lightMapIntensity = 1.0;
        /**
		 * The red channel of this texture is used as the ambient occlusion map.
		 * Requires a second set of UVs.
		 *
		 * @type {?Texture}
		 * @default null
		 */ this.aoMap = null;
        /**
		 * Intensity of the ambient occlusion effect. Range is `[0,1]`, where `0`
		 * disables ambient occlusion. Where intensity is `1` and the AO map's
		 * red channel is also `1`, ambient light is fully occluded on a surface.
		 *
		 * @type {number}
		 * @default 1
		 */ this.aoMapIntensity = 1.0;
        /**
		 * Emissive (light) color of the material, essentially a solid color
		 * unaffected by other lighting.
		 *
		 * @type {Color}
		 * @default (0,0,0)
		 */ this.emissive = new $9ddd7e9b53f7a2d4$export$892596cec99bc70e(0x000000);
        /**
		 * Intensity of the emissive light. Modulates the emissive color.
		 *
		 * @type {number}
		 * @default 1
		 */ this.emissiveIntensity = 1.0;
        /**
		 * Set emissive (glow) map. The emissive map color is modulated by the
		 * emissive color and the emissive intensity. If you have an emissive map,
		 * be sure to set the emissive color to something other than black.
		 *
		 * @type {?Texture}
		 * @default null
		 */ this.emissiveMap = null;
        /**
		 * The texture to create a bump map. The black and white values map to the
		 * perceived depth in relation to the lights. Bump doesn't actually affect
		 * the geometry of the object, only the lighting. If a normal map is defined
		 * this will be ignored.
		 *
		 * @type {?Texture}
		 * @default null
		 */ this.bumpMap = null;
        /**
		 * How much the bump map affects the material. Typical range is `[0,1]`.
		 *
		 * @type {number}
		 * @default 1
		 */ this.bumpScale = 1;
        /**
		 * The texture to create a normal map. The RGB values affect the surface
		 * normal for each pixel fragment and change the way the color is lit. Normal
		 * maps do not change the actual shape of the surface, only the lighting. In
		 * case the material has a normal map authored using the left handed
		 * convention, the `y` component of `normalScale` should be negated to compensate
		 * for the different handedness.
		 *
		 * @type {?Texture}
		 * @default null
		 */ this.normalMap = null;
        /**
		 * The type of normal map.
		 *
		 * @type {(TangentSpaceNormalMap|ObjectSpaceNormalMap)}
		 * @default TangentSpaceNormalMap
		 */ this.normalMapType = $9ddd7e9b53f7a2d4$export$2852a58ebdac27b8;
        /**
		 * How much the normal map affects the material. Typical value range is `[0,1]`.
		 *
		 * @type {Vector2}
		 * @default (1,1)
		 */ this.normalScale = new $9ddd7e9b53f7a2d4$export$c977b3e384af9ae1(1, 1);
        /**
		 * The displacement map affects the position of the mesh's vertices. Unlike
		 * other maps which only affect the light and shade of the material the
		 * displaced vertices can cast shadows, block other objects, and otherwise
		 * act as real geometry. The displacement texture is an image where the value
		 * of each pixel (white being the highest) is mapped against, and
		 * repositions, the vertices of the mesh.
		 *
		 * @type {?Texture}
		 * @default null
		 */ this.displacementMap = null;
        /**
		 * How much the displacement map affects the mesh (where black is no
		 * displacement, and white is maximum displacement). Without a displacement
		 * map set, this value is not applied.
		 *
		 * @type {number}
		 * @default 0
		 */ this.displacementScale = 1;
        /**
		 * The offset of the displacement map's values on the mesh's vertices.
		 * The bias is added to the scaled sample of the displacement map.
		 * Without a displacement map set, this value is not applied.
		 *
		 * @type {number}
		 * @default 0
		 */ this.displacementBias = 0;
        /**
		 * Specular map used by the material.
		 *
		 * @type {?Texture}
		 * @default null
		 */ this.specularMap = null;
        /**
		 * The alpha map is a grayscale texture that controls the opacity across the
		 * surface (black: fully transparent; white: fully opaque).
		 *
		 * Only the color of the texture is used, ignoring the alpha channel if one
		 * exists. For RGB and RGBA textures, the renderer will use the green channel
		 * when sampling this texture due to the extra bit of precision provided for
		 * green in DXT-compressed and uncompressed RGB 565 formats. Luminance-only and
		 * luminance/alpha textures will also still work as expected.
		 *
		 * @type {?Texture}
		 * @default null
		 */ this.alphaMap = null;
        /**
		 * The environment map.
		 *
		 * @type {?Texture}
		 * @default null
		 */ this.envMap = null;
        /**
		 * The rotation of the environment map in radians.
		 *
		 * @type {Euler}
		 * @default (0,0,0)
		 */ this.envMapRotation = new $9ddd7e9b53f7a2d4$export$d93cc409a0768c5f();
        /**
		 * How to combine the result of the surface's color with the environment map, if any.
		 *
		 * When set to `MixOperation`, the {@link MeshBasicMaterial#reflectivity} is used to
		 * blend between the two colors.
		 *
		 * @type {(MultiplyOperation|MixOperation|AddOperation)}
		 * @default MultiplyOperation
		 */ this.combine = $9ddd7e9b53f7a2d4$export$e50ac29801f1774d;
        /**
		 * How much the environment map affects the surface.
		 * The valid range is between `0` (no reflections) and `1` (full reflections).
		 *
		 * @type {number}
		 * @default 1
		 */ this.reflectivity = 1;
        /**
		 * The index of refraction (IOR) of air (approximately 1) divided by the
		 * index of refraction of the material. It is used with environment mapping
		 * modes {@link CubeRefractionMapping} and {@link EquirectangularRefractionMapping}.
		 * The refraction ratio should not exceed `1`.
		 *
		 * @type {number}
		 * @default 0.98
		 */ this.refractionRatio = 0.98;
        /**
		 * Renders the geometry as a wireframe.
		 *
		 * @type {boolean}
		 * @default false
		 */ this.wireframe = false;
        /**
		 * Controls the thickness of the wireframe.
		 *
		 * Can only be used with {@link SVGRenderer}.
		 *
		 * @type {number}
		 * @default 1
		 */ this.wireframeLinewidth = 1;
        /**
		 * Defines appearance of wireframe ends.
		 *
		 * Can only be used with {@link SVGRenderer}.
		 *
		 * @type {('round'|'bevel'|'miter')}
		 * @default 'round'
		 */ this.wireframeLinecap = 'round';
        /**
		 * Defines appearance of wireframe joints.
		 *
		 * Can only be used with {@link SVGRenderer}.
		 *
		 * @type {('round'|'bevel'|'miter')}
		 * @default 'round'
		 */ this.wireframeLinejoin = 'round';
        /**
		 * Whether the material is rendered with flat shading or not.
		 *
		 * @type {boolean}
		 * @default false
		 */ this.flatShading = false;
        /**
		 * Whether the material is affected by fog or not.
		 *
		 * @type {boolean}
		 * @default true
		 */ this.fog = true;
        this.setValues(parameters);
    }
    copy(source) {
        super.copy(source);
        this.color.copy(source.color);
        this.map = source.map;
        this.lightMap = source.lightMap;
        this.lightMapIntensity = source.lightMapIntensity;
        this.aoMap = source.aoMap;
        this.aoMapIntensity = source.aoMapIntensity;
        this.emissive.copy(source.emissive);
        this.emissiveMap = source.emissiveMap;
        this.emissiveIntensity = source.emissiveIntensity;
        this.bumpMap = source.bumpMap;
        this.bumpScale = source.bumpScale;
        this.normalMap = source.normalMap;
        this.normalMapType = source.normalMapType;
        this.normalScale.copy(source.normalScale);
        this.displacementMap = source.displacementMap;
        this.displacementScale = source.displacementScale;
        this.displacementBias = source.displacementBias;
        this.specularMap = source.specularMap;
        this.alphaMap = source.alphaMap;
        this.envMap = source.envMap;
        this.envMapRotation.copy(source.envMapRotation);
        this.combine = source.combine;
        this.reflectivity = source.reflectivity;
        this.refractionRatio = source.refractionRatio;
        this.wireframe = source.wireframe;
        this.wireframeLinewidth = source.wireframeLinewidth;
        this.wireframeLinecap = source.wireframeLinecap;
        this.wireframeLinejoin = source.wireframeLinejoin;
        this.flatShading = source.flatShading;
        this.fog = source.fog;
        return this;
    }
}
/**
 * A material for drawing geometry by depth. Depth is based off of the camera
 * near and far plane. White is nearest, black is farthest.
 *
 * @augments Material
 */ class $9ddd7e9b53f7a2d4$export$2698c22ec13825db extends $9ddd7e9b53f7a2d4$export$a2d8b23205c25948 {
    /**
	 * Constructs a new mesh depth material.
	 *
	 * @param {Object} [parameters] - An object with one or more properties
	 * defining the material's appearance. Any property of the material
	 * (including any property from inherited materials) can be passed
	 * in here. Color values can be passed any type of value accepted
	 * by {@link Color#set}.
	 */ constructor(parameters){
        super();
        /**
		 * This flag can be used for type testing.
		 *
		 * @type {boolean}
		 * @readonly
		 * @default true
		 */ this.isMeshDepthMaterial = true;
        this.type = 'MeshDepthMaterial';
        /**
		 * Type for depth packing.
		 *
		 * @type {(BasicDepthPacking|RGBADepthPacking|RGBDepthPacking|RGDepthPacking)}
		 * @default BasicDepthPacking
		 */ this.depthPacking = $9ddd7e9b53f7a2d4$export$deeb383078690b50;
        /**
		 * The color map. May optionally include an alpha channel, typically combined
		 * with {@link Material#transparent} or {@link Material#alphaTest}.
		 *
		 * @type {?Texture}
		 * @default null
		 */ this.map = null;
        /**
		 * The alpha map is a grayscale texture that controls the opacity across the
		 * surface (black: fully transparent; white: fully opaque).
		 *
		 * Only the color of the texture is used, ignoring the alpha channel if one
		 * exists. For RGB and RGBA textures, the renderer will use the green channel
		 * when sampling this texture due to the extra bit of precision provided for
		 * green in DXT-compressed and uncompressed RGB 565 formats. Luminance-only and
		 * luminance/alpha textures will also still work as expected.
		 *
		 * @type {?Texture}
		 * @default null
		 */ this.alphaMap = null;
        /**
		 * The displacement map affects the position of the mesh's vertices. Unlike
		 * other maps which only affect the light and shade of the material the
		 * displaced vertices can cast shadows, block other objects, and otherwise
		 * act as real geometry. The displacement texture is an image where the value
		 * of each pixel (white being the highest) is mapped against, and
		 * repositions, the vertices of the mesh.
		 *
		 * @type {?Texture}
		 * @default null
		 */ this.displacementMap = null;
        /**
		 * How much the displacement map affects the mesh (where black is no
		 * displacement, and white is maximum displacement). Without a displacement
		 * map set, this value is not applied.
		 *
		 * @type {number}
		 * @default 0
		 */ this.displacementScale = 1;
        /**
		 * The offset of the displacement map's values on the mesh's vertices.
		 * The bias is added to the scaled sample of the displacement map.
		 * Without a displacement map set, this value is not applied.
		 *
		 * @type {number}
		 * @default 0
		 */ this.displacementBias = 0;
        /**
		 * Renders the geometry as a wireframe.
		 *
		 * @type {boolean}
		 * @default false
		 */ this.wireframe = false;
        /**
		 * Controls the thickness of the wireframe.
		 *
		 * WebGL and WebGPU ignore this property and always render
		 * 1 pixel wide lines.
		 *
		 * @type {number}
		 * @default 1
		 */ this.wireframeLinewidth = 1;
        this.setValues(parameters);
    }
    copy(source) {
        super.copy(source);
        this.depthPacking = source.depthPacking;
        this.map = source.map;
        this.alphaMap = source.alphaMap;
        this.displacementMap = source.displacementMap;
        this.displacementScale = source.displacementScale;
        this.displacementBias = source.displacementBias;
        this.wireframe = source.wireframe;
        this.wireframeLinewidth = source.wireframeLinewidth;
        return this;
    }
}
/**
 * A material used internally for implementing shadow mapping with
 * point lights.
 *
 * Can also be used to customize the shadow casting of an object by assigning
 * an instance of `MeshDistanceMaterial` to {@link Object3D#customDistanceMaterial}.
 * The following examples demonstrates this approach in order to ensure
 * transparent parts of objects do no cast shadows.
 *
 * @augments Material
 */ class $9ddd7e9b53f7a2d4$export$33e187ed002f2a19 extends $9ddd7e9b53f7a2d4$export$a2d8b23205c25948 {
    /**
	 * Constructs a new mesh distance material.
	 *
	 * @param {Object} [parameters] - An object with one or more properties
	 * defining the material's appearance. Any property of the material
	 * (including any property from inherited materials) can be passed
	 * in here. Color values can be passed any type of value accepted
	 * by {@link Color#set}.
	 */ constructor(parameters){
        super();
        /**
		 * This flag can be used for type testing.
		 *
		 * @type {boolean}
		 * @readonly
		 * @default true
		 */ this.isMeshDistanceMaterial = true;
        this.type = 'MeshDistanceMaterial';
        /**
		 * The color map. May optionally include an alpha channel, typically combined
		 * with {@link Material#transparent} or {@link Material#alphaTest}.
		 *
		 * @type {?Texture}
		 * @default null
		 */ this.map = null;
        /**
		 * The alpha map is a grayscale texture that controls the opacity across the
		 * surface (black: fully transparent; white: fully opaque).
		 *
		 * Only the color of the texture is used, ignoring the alpha channel if one
		 * exists. For RGB and RGBA textures, the renderer will use the green channel
		 * when sampling this texture due to the extra bit of precision provided for
		 * green in DXT-compressed and uncompressed RGB 565 formats. Luminance-only and
		 * luminance/alpha textures will also still work as expected.
		 *
		 * @type {?Texture}
		 * @default null
		 */ this.alphaMap = null;
        /**
		 * The displacement map affects the position of the mesh's vertices. Unlike
		 * other maps which only affect the light and shade of the material the
		 * displaced vertices can cast shadows, block other objects, and otherwise
		 * act as real geometry. The displacement texture is an image where the value
		 * of each pixel (white being the highest) is mapped against, and
		 * repositions, the vertices of the mesh.
		 *
		 * @type {?Texture}
		 * @default null
		 */ this.displacementMap = null;
        /**
		 * How much the displacement map affects the mesh (where black is no
		 * displacement, and white is maximum displacement). Without a displacement
		 * map set, this value is not applied.
		 *
		 * @type {number}
		 * @default 0
		 */ this.displacementScale = 1;
        /**
		 * The offset of the displacement map's values on the mesh's vertices.
		 * The bias is added to the scaled sample of the displacement map.
		 * Without a displacement map set, this value is not applied.
		 *
		 * @type {number}
		 * @default 0
		 */ this.displacementBias = 0;
        this.setValues(parameters);
    }
    copy(source) {
        super.copy(source);
        this.map = source.map;
        this.alphaMap = source.alphaMap;
        this.displacementMap = source.displacementMap;
        this.displacementScale = source.displacementScale;
        this.displacementBias = source.displacementBias;
        return this;
    }
}
/**
 * This material is defined by a MatCap (or Lit Sphere) texture, which encodes the
 * material color and shading.
 *
 * `MeshMatcapMaterial` does not respond to lights since the matcap image file encodes
 * baked lighting. It will cast a shadow onto an object that receives shadows
 * (and shadow clipping works), but it will not self-shadow or receive
 * shadows.
 *
 * @augments Material
 */ class $9ddd7e9b53f7a2d4$export$6f5fef6235ec12ee extends $9ddd7e9b53f7a2d4$export$a2d8b23205c25948 {
    /**
	 * Constructs a new mesh matcap material.
	 *
	 * @param {Object} [parameters] - An object with one or more properties
	 * defining the material's appearance. Any property of the material
	 * (including any property from inherited materials) can be passed
	 * in here. Color values can be passed any type of value accepted
	 * by {@link Color#set}.
	 */ constructor(parameters){
        super();
        /**
		 * This flag can be used for type testing.
		 *
		 * @type {boolean}
		 * @readonly
		 * @default true
		 */ this.isMeshMatcapMaterial = true;
        this.defines = {
            'MATCAP': ''
        };
        this.type = 'MeshMatcapMaterial';
        /**
		 * Color of the material.
		 *
		 * @type {Color}
		 * @default (1,1,1)
		 */ this.color = new $9ddd7e9b53f7a2d4$export$892596cec99bc70e(0xffffff); // diffuse
        /**
		 * The matcap map.
		 *
		 * @type {?Texture}
		 * @default null
		 */ this.matcap = null;
        /**
		 * The color map. May optionally include an alpha channel, typically combined
		 * with {@link Material#transparent} or {@link Material#alphaTest}. The texture map
		 * color is modulated by the diffuse `color`.
		 *
		 * @type {?Texture}
		 * @default null
		 */ this.map = null;
        /**
		 * The texture to create a bump map. The black and white values map to the
		 * perceived depth in relation to the lights. Bump doesn't actually affect
		 * the geometry of the object, only the lighting. If a normal map is defined
		 * this will be ignored.
		 *
		 * @type {?Texture}
		 * @default null
		 */ this.bumpMap = null;
        /**
		 * How much the bump map affects the material. Typical range is `[0,1]`.
		 *
		 * @type {number}
		 * @default 1
		 */ this.bumpScale = 1;
        /**
		 * The texture to create a normal map. The RGB values affect the surface
		 * normal for each pixel fragment and change the way the color is lit. Normal
		 * maps do not change the actual shape of the surface, only the lighting. In
		 * case the material has a normal map authored using the left handed
		 * convention, the `y` component of `normalScale` should be negated to compensate
		 * for the different handedness.
		 *
		 * @type {?Texture}
		 * @default null
		 */ this.normalMap = null;
        /**
		 * The type of normal map.
		 *
		 * @type {(TangentSpaceNormalMap|ObjectSpaceNormalMap)}
		 * @default TangentSpaceNormalMap
		 */ this.normalMapType = $9ddd7e9b53f7a2d4$export$2852a58ebdac27b8;
        /**
		 * How much the normal map affects the material. Typical value range is `[0,1]`.
		 *
		 * @type {Vector2}
		 * @default (1,1)
		 */ this.normalScale = new $9ddd7e9b53f7a2d4$export$c977b3e384af9ae1(1, 1);
        /**
		 * The displacement map affects the position of the mesh's vertices. Unlike
		 * other maps which only affect the light and shade of the material the
		 * displaced vertices can cast shadows, block other objects, and otherwise
		 * act as real geometry. The displacement texture is an image where the value
		 * of each pixel (white being the highest) is mapped against, and
		 * repositions, the vertices of the mesh.
		 *
		 * @type {?Texture}
		 * @default null
		 */ this.displacementMap = null;
        /**
		 * How much the displacement map affects the mesh (where black is no
		 * displacement, and white is maximum displacement). Without a displacement
		 * map set, this value is not applied.
		 *
		 * @type {number}
		 * @default 0
		 */ this.displacementScale = 1;
        /**
		 * The offset of the displacement map's values on the mesh's vertices.
		 * The bias is added to the scaled sample of the displacement map.
		 * Without a displacement map set, this value is not applied.
		 *
		 * @type {number}
		 * @default 0
		 */ this.displacementBias = 0;
        /**
		 * The alpha map is a grayscale texture that controls the opacity across the
		 * surface (black: fully transparent; white: fully opaque).
		 *
		 * Only the color of the texture is used, ignoring the alpha channel if one
		 * exists. For RGB and RGBA textures, the renderer will use the green channel
		 * when sampling this texture due to the extra bit of precision provided for
		 * green in DXT-compressed and uncompressed RGB 565 formats. Luminance-only and
		 * luminance/alpha textures will also still work as expected.
		 *
		 * @type {?Texture}
		 * @default null
		 */ this.alphaMap = null;
        /**
		 * Whether the material is rendered with flat shading or not.
		 *
		 * @type {boolean}
		 * @default false
		 */ this.flatShading = false;
        /**
		 * Whether the material is affected by fog or not.
		 *
		 * @type {boolean}
		 * @default true
		 */ this.fog = true;
        this.setValues(parameters);
    }
    copy(source) {
        super.copy(source);
        this.defines = {
            'MATCAP': ''
        };
        this.color.copy(source.color);
        this.matcap = source.matcap;
        this.map = source.map;
        this.bumpMap = source.bumpMap;
        this.bumpScale = source.bumpScale;
        this.normalMap = source.normalMap;
        this.normalMapType = source.normalMapType;
        this.normalScale.copy(source.normalScale);
        this.displacementMap = source.displacementMap;
        this.displacementScale = source.displacementScale;
        this.displacementBias = source.displacementBias;
        this.alphaMap = source.alphaMap;
        this.flatShading = source.flatShading;
        this.fog = source.fog;
        return this;
    }
}
/**
 * A material for rendering line primitives.
 *
 * Materials define the appearance of renderable 3D objects.
 *
 * ```js
 * const material = new THREE.LineDashedMaterial( {
 * 	color: 0xffffff,
 * 	scale: 1,
 * 	dashSize: 3,
 * 	gapSize: 1,
 * } );
 * ```
 *
 * @augments LineBasicMaterial
 */ class $9ddd7e9b53f7a2d4$export$327886a3efaeaebe extends $9ddd7e9b53f7a2d4$export$fbaaa33907730a0c {
    /**
	 * Constructs a new line dashed material.
	 *
	 * @param {Object} [parameters] - An object with one or more properties
	 * defining the material's appearance. Any property of the material
	 * (including any property from inherited materials) can be passed
	 * in here. Color values can be passed any type of value accepted
	 * by {@link Color#set}.
	 */ constructor(parameters){
        super();
        /**
		 * This flag can be used for type testing.
		 *
		 * @type {boolean}
		 * @readonly
		 * @default true
		 */ this.isLineDashedMaterial = true;
        this.type = 'LineDashedMaterial';
        /**
		 * The scale of the dashed part of a line.
		 *
		 * @type {number}
		 * @default 1
		 */ this.scale = 1;
        /**
		 * The size of the dash. This is both the gap with the stroke.
		 *
		 * @type {number}
		 * @default 3
		 */ this.dashSize = 3;
        /**
		 * The size of the gap.
		 *
		 * @type {number}
		 * @default 1
		 */ this.gapSize = 1;
        this.setValues(parameters);
    }
    copy(source) {
        super.copy(source);
        this.scale = source.scale;
        this.dashSize = source.dashSize;
        this.gapSize = source.gapSize;
        return this;
    }
}
/**
 * Converts an array to a specific type.
 *
 * @param {TypedArray|Array} array - The array to convert.
 * @param {TypedArray.constructor} type - The constructor of a typed array that defines the new type.
 * @return {TypedArray} The converted array.
 */ function $9ddd7e9b53f7a2d4$var$convertArray(array, type) {
    if (!array || array.constructor === type) return array;
    if (typeof type.BYTES_PER_ELEMENT === 'number') return new type(array); // create typed array
    return Array.prototype.slice.call(array); // create Array
}
/**
 * Returns `true` if the given object is a typed array.
 *
 * @param {any} object - The object to check.
 * @return {boolean} Whether the given object is a typed array.
 */ function $9ddd7e9b53f7a2d4$var$isTypedArray(object) {
    return ArrayBuffer.isView(object) && !(object instanceof DataView);
}
/**
 * Returns an array by which times and values can be sorted.
 *
 * @param {Array<number>} times - The keyframe time values.
 * @return {Array<number>} The array.
 */ function $9ddd7e9b53f7a2d4$var$getKeyframeOrder(times) {
    function compareTime(i, j) {
        return times[i] - times[j];
    }
    const n = times.length;
    const result = new Array(n);
    for(let i = 0; i !== n; ++i)result[i] = i;
    result.sort(compareTime);
    return result;
}
/**
 * Sorts the given array by the previously computed order via `getKeyframeOrder()`.
 *
 * @param {Array<number>} values - The values to sort.
 * @param {number} stride - The stride.
 * @param {Array<number>} order - The sort order.
 * @return {Array<number>} The sorted values.
 */ function $9ddd7e9b53f7a2d4$var$sortedArray(values, stride, order) {
    const nValues = values.length;
    const result = new values.constructor(nValues);
    for(let i = 0, dstOffset = 0; dstOffset !== nValues; ++i){
        const srcOffset = order[i] * stride;
        for(let j = 0; j !== stride; ++j)result[dstOffset++] = values[srcOffset + j];
    }
    return result;
}
/**
 * Used for parsing AOS keyframe formats.
 *
 * @param {Array<number>} jsonKeys - A list of JSON keyframes.
 * @param {Array<number>} times - This array will be filled with keyframe times by this function.
 * @param {Array<number>} values - This array will be filled with keyframe values by this function.
 * @param {string} valuePropertyName - The name of the property to use.
 */ function $9ddd7e9b53f7a2d4$var$flattenJSON(jsonKeys, times, values, valuePropertyName) {
    let i = 1, key = jsonKeys[0];
    while(key !== undefined && key[valuePropertyName] === undefined)key = jsonKeys[i++];
    if (key === undefined) return; // no data
    let value = key[valuePropertyName];
    if (value === undefined) return; // no data
    if (Array.isArray(value)) do {
        value = key[valuePropertyName];
        if (value !== undefined) {
            times.push(key.time);
            values.push(...value); // push all elements
        }
        key = jsonKeys[i++];
    }while (key !== undefined);
    else if (value.toArray !== undefined) // ...assume THREE.Math-ish
    do {
        value = key[valuePropertyName];
        if (value !== undefined) {
            times.push(key.time);
            value.toArray(values, values.length);
        }
        key = jsonKeys[i++];
    }while (key !== undefined);
    else // otherwise push as-is
    do {
        value = key[valuePropertyName];
        if (value !== undefined) {
            times.push(key.time);
            values.push(value);
        }
        key = jsonKeys[i++];
    }while (key !== undefined);
}
/**
 * Creates a new clip, containing only the segment of the original clip between the given frames.
 *
 * @param {AnimationClip} sourceClip - The values to sort.
 * @param {string} name - The name of the clip.
 * @param {number} startFrame - The start frame.
 * @param {number} endFrame - The end frame.
 * @param {number} [fps=30] - The FPS.
 * @return {AnimationClip} The new sub clip.
 */ function $9ddd7e9b53f7a2d4$var$subclip(sourceClip, name, startFrame, endFrame, fps = 30) {
    const clip = sourceClip.clone();
    clip.name = name;
    const tracks = [];
    for(let i = 0; i < clip.tracks.length; ++i){
        const track = clip.tracks[i];
        const valueSize = track.getValueSize();
        const times = [];
        const values = [];
        for(let j = 0; j < track.times.length; ++j){
            const frame = track.times[j] * fps;
            if (frame < startFrame || frame >= endFrame) continue;
            times.push(track.times[j]);
            for(let k = 0; k < valueSize; ++k)values.push(track.values[j * valueSize + k]);
        }
        if (times.length === 0) continue;
        track.times = $9ddd7e9b53f7a2d4$var$convertArray(times, track.times.constructor);
        track.values = $9ddd7e9b53f7a2d4$var$convertArray(values, track.values.constructor);
        tracks.push(track);
    }
    clip.tracks = tracks;
    // find minimum .times value across all tracks in the trimmed clip
    let minStartTime = Infinity;
    for(let i = 0; i < clip.tracks.length; ++i)if (minStartTime > clip.tracks[i].times[0]) minStartTime = clip.tracks[i].times[0];
    // shift all tracks such that clip begins at t=0
    for(let i = 0; i < clip.tracks.length; ++i)clip.tracks[i].shift(-1 * minStartTime);
    clip.resetDuration();
    return clip;
}
/**
 * Converts the keyframes of the given animation clip to an additive format.
 *
 * @param {AnimationClip} targetClip - The clip to make additive.
 * @param {number} [referenceFrame=0] - The reference frame.
 * @param {AnimationClip} [referenceClip=targetClip] - The reference clip.
 * @param {number} [fps=30] - The FPS.
 * @return {AnimationClip} The updated clip which is now additive.
 */ function $9ddd7e9b53f7a2d4$var$makeClipAdditive(targetClip, referenceFrame = 0, referenceClip = targetClip, fps = 30) {
    if (fps <= 0) fps = 30;
    const numTracks = referenceClip.tracks.length;
    const referenceTime = referenceFrame / fps;
    // Make each track's values relative to the values at the reference frame
    for(let i = 0; i < numTracks; ++i){
        const referenceTrack = referenceClip.tracks[i];
        const referenceTrackType = referenceTrack.ValueTypeName;
        // Skip this track if it's non-numeric
        if (referenceTrackType === 'bool' || referenceTrackType === 'string') continue;
        // Find the track in the target clip whose name and type matches the reference track
        const targetTrack = targetClip.tracks.find(function(track) {
            return track.name === referenceTrack.name && track.ValueTypeName === referenceTrackType;
        });
        if (targetTrack === undefined) continue;
        let referenceOffset = 0;
        const referenceValueSize = referenceTrack.getValueSize();
        if (referenceTrack.createInterpolant.isInterpolantFactoryMethodGLTFCubicSpline) referenceOffset = referenceValueSize / 3;
        let targetOffset = 0;
        const targetValueSize = targetTrack.getValueSize();
        if (targetTrack.createInterpolant.isInterpolantFactoryMethodGLTFCubicSpline) targetOffset = targetValueSize / 3;
        const lastIndex = referenceTrack.times.length - 1;
        let referenceValue;
        // Find the value to subtract out of the track
        if (referenceTime <= referenceTrack.times[0]) {
            // Reference frame is earlier than the first keyframe, so just use the first keyframe
            const startIndex = referenceOffset;
            const endIndex = referenceValueSize - referenceOffset;
            referenceValue = referenceTrack.values.slice(startIndex, endIndex);
        } else if (referenceTime >= referenceTrack.times[lastIndex]) {
            // Reference frame is after the last keyframe, so just use the last keyframe
            const startIndex = lastIndex * referenceValueSize + referenceOffset;
            const endIndex = startIndex + referenceValueSize - referenceOffset;
            referenceValue = referenceTrack.values.slice(startIndex, endIndex);
        } else {
            // Interpolate to the reference value
            const interpolant = referenceTrack.createInterpolant();
            const startIndex = referenceOffset;
            const endIndex = referenceValueSize - referenceOffset;
            interpolant.evaluate(referenceTime);
            referenceValue = interpolant.resultBuffer.slice(startIndex, endIndex);
        }
        // Conjugate the quaternion
        if (referenceTrackType === 'quaternion') {
            const referenceQuat = new $9ddd7e9b53f7a2d4$export$23d6a54f0bbc85a3().fromArray(referenceValue).normalize().conjugate();
            referenceQuat.toArray(referenceValue);
        }
        // Subtract the reference value from all of the track values
        const numTimes = targetTrack.times.length;
        for(let j = 0; j < numTimes; ++j){
            const valueStart = j * targetValueSize + targetOffset;
            if (referenceTrackType === 'quaternion') // Multiply the conjugate for quaternion track types
            $9ddd7e9b53f7a2d4$export$23d6a54f0bbc85a3.multiplyQuaternionsFlat(targetTrack.values, valueStart, referenceValue, 0, targetTrack.values, valueStart);
            else {
                const valueEnd = targetValueSize - targetOffset * 2;
                // Subtract each value for all other numeric track types
                for(let k = 0; k < valueEnd; ++k)targetTrack.values[valueStart + k] -= referenceValue[k];
            }
        }
    }
    targetClip.blendMode = $9ddd7e9b53f7a2d4$export$d875e029ef558d3;
    return targetClip;
}
/**
 * A class with various methods to assist with animations.
 *
 * @hideconstructor
 */ class $9ddd7e9b53f7a2d4$export$7ee8caa573e71ad1 {
    /**
	 * Converts an array to a specific type
	 *
	 * @static
	 * @param {TypedArray|Array} array - The array to convert.
	 * @param {TypedArray.constructor} type - The constructor of a type array.
	 * @return {TypedArray} The converted array
	 */ static convertArray(array, type) {
        return $9ddd7e9b53f7a2d4$var$convertArray(array, type);
    }
    /**
	 * Returns `true` if the given object is a typed array.
	 *
	 * @static
	 * @param {any} object - The object to check.
	 * @return {boolean} Whether the given object is a typed array.
	 */ static isTypedArray(object) {
        return $9ddd7e9b53f7a2d4$var$isTypedArray(object);
    }
    /**
	 * Returns an array by which times and values can be sorted.
	 *
	 * @static
	 * @param {Array<number>} times - The keyframe time values.
	 * @return {Array<number>} The array.
	 */ static getKeyframeOrder(times) {
        return $9ddd7e9b53f7a2d4$var$getKeyframeOrder(times);
    }
    /**
	 * Sorts the given array by the previously computed order via `getKeyframeOrder()`.
	 *
	 * @static
	 * @param {Array<number>} values - The values to sort.
	 * @param {number} stride - The stride.
	 * @param {Array<number>} order - The sort order.
	 * @return {Array<number>} The sorted values.
	 */ static sortedArray(values, stride, order) {
        return $9ddd7e9b53f7a2d4$var$sortedArray(values, stride, order);
    }
    /**
	 * Used for parsing AOS keyframe formats.
	 *
	 * @static
	 * @param {Array<number>} jsonKeys - A list of JSON keyframes.
	 * @param {Array<number>} times - This array will be filled with keyframe times by this method.
	 * @param {Array<number>} values - This array will be filled with keyframe values by this method.
	 * @param {string} valuePropertyName - The name of the property to use.
	 */ static flattenJSON(jsonKeys, times, values, valuePropertyName) {
        $9ddd7e9b53f7a2d4$var$flattenJSON(jsonKeys, times, values, valuePropertyName);
    }
    /**
	 * Creates a new clip, containing only the segment of the original clip between the given frames.
	 *
	 * @static
	 * @param {AnimationClip} sourceClip - The values to sort.
	 * @param {string} name - The name of the clip.
	 * @param {number} startFrame - The start frame.
	 * @param {number} endFrame - The end frame.
	 * @param {number} [fps=30] - The FPS.
	 * @return {AnimationClip} The new sub clip.
	 */ static subclip(sourceClip, name, startFrame, endFrame, fps = 30) {
        return $9ddd7e9b53f7a2d4$var$subclip(sourceClip, name, startFrame, endFrame, fps);
    }
    /**
	 * Converts the keyframes of the given animation clip to an additive format.
	 *
	 * @static
	 * @param {AnimationClip} targetClip - The clip to make additive.
	 * @param {number} [referenceFrame=0] - The reference frame.
	 * @param {AnimationClip} [referenceClip=targetClip] - The reference clip.
	 * @param {number} [fps=30] - The FPS.
	 * @return {AnimationClip} The updated clip which is now additive.
	 */ static makeClipAdditive(targetClip, referenceFrame = 0, referenceClip = targetClip, fps = 30) {
        return $9ddd7e9b53f7a2d4$var$makeClipAdditive(targetClip, referenceFrame, referenceClip, fps);
    }
}
/**
 * Abstract base class of interpolants over parametric samples.
 *
 * The parameter domain is one dimensional, typically the time or a path
 * along a curve defined by the data.
 *
 * The sample values can have any dimensionality and derived classes may
 * apply special interpretations to the data.
 *
 * This class provides the interval seek in a Template Method, deferring
 * the actual interpolation to derived classes.
 *
 * Time complexity is O(1) for linear access crossing at most two points
 * and O(log N) for random access, where N is the number of positions.
 *
 * References: {@link http://www.oodesign.com/template-method-pattern.html}
 *
 * @abstract
 */ class $9ddd7e9b53f7a2d4$export$b558baee9c0f72d3 {
    /**
	 * Constructs a new interpolant.
	 *
	 * @param {TypedArray} parameterPositions - The parameter positions hold the interpolation factors.
	 * @param {TypedArray} sampleValues - The sample values.
	 * @param {number} sampleSize - The sample size
	 * @param {TypedArray} [resultBuffer] - The result buffer.
	 */ constructor(parameterPositions, sampleValues, sampleSize, resultBuffer){
        /**
		 * The parameter positions.
		 *
		 * @type {TypedArray}
		 */ this.parameterPositions = parameterPositions;
        /**
		 * A cache index.
		 *
		 * @private
		 * @type {number}
		 * @default 0
		 */ this._cachedIndex = 0;
        /**
		 * The result buffer.
		 *
		 * @type {TypedArray}
		 */ this.resultBuffer = resultBuffer !== undefined ? resultBuffer : new sampleValues.constructor(sampleSize);
        /**
		 * The sample values.
		 *
		 * @type {TypedArray}
		 */ this.sampleValues = sampleValues;
        /**
		 * The value size.
		 *
		 * @type {TypedArray}
		 */ this.valueSize = sampleSize;
        /**
		 * The interpolation settings.
		 *
		 * @type {?Object}
		 * @default null
		 */ this.settings = null;
        /**
		 * The default settings object.
		 *
		 * @type {Object}
		 */ this.DefaultSettings_ = {};
    }
    /**
	 * Evaluate the interpolant at position `t`.
	 *
	 * @param {number} t - The interpolation factor.
	 * @return {TypedArray} The result buffer.
	 */ evaluate(t) {
        const pp = this.parameterPositions;
        let i1 = this._cachedIndex, t1 = pp[i1], t0 = pp[i1 - 1];
        validate_interval: {
            seek: {
                let right;
                linear_scan: {
                    //- See http://jsperf.com/comparison-to-undefined/3
                    //- slower code:
                    //-
                    //- 				if ( t >= t1 || t1 === undefined ) {
                    forward_scan: if (!(t < t1)) {
                        for(let giveUpAt = i1 + 2;;){
                            if (t1 === undefined) {
                                if (t < t0) break forward_scan;
                                // after end
                                i1 = pp.length;
                                this._cachedIndex = i1;
                                return this.copySampleValue_(i1 - 1);
                            }
                            if (i1 === giveUpAt) break; // this loop
                            t0 = t1;
                            t1 = pp[++i1];
                            if (t < t1) break seek;
                        }
                        // prepare binary search on the right side of the index
                        right = pp.length;
                        break linear_scan;
                    }
                    //- slower code:
                    //-					if ( t < t0 || t0 === undefined ) {
                    if (!(t >= t0)) {
                        // looping?
                        const t1global = pp[1];
                        if (t < t1global) {
                            i1 = 2; // + 1, using the scan for the details
                            t0 = t1global;
                        }
                        // linear reverse scan
                        for(let giveUpAt = i1 - 2;;){
                            if (t0 === undefined) {
                                // before start
                                this._cachedIndex = 0;
                                return this.copySampleValue_(0);
                            }
                            if (i1 === giveUpAt) break; // this loop
                            t1 = t0;
                            t0 = pp[--i1 - 1];
                            if (t >= t0) break seek;
                        }
                        // prepare binary search on the left side of the index
                        right = i1;
                        i1 = 0;
                        break linear_scan;
                    }
                    break validate_interval;
                } // linear scan
                // binary search
                while(i1 < right){
                    const mid = i1 + right >>> 1;
                    if (t < pp[mid]) right = mid;
                    else i1 = mid + 1;
                }
                t1 = pp[i1];
                t0 = pp[i1 - 1];
                // check boundary cases, again
                if (t0 === undefined) {
                    this._cachedIndex = 0;
                    return this.copySampleValue_(0);
                }
                if (t1 === undefined) {
                    i1 = pp.length;
                    this._cachedIndex = i1;
                    return this.copySampleValue_(i1 - 1);
                }
            } // seek
            this._cachedIndex = i1;
            this.intervalChanged_(i1, t0, t1);
        } // validate_interval
        return this.interpolate_(i1, t0, t, t1);
    }
    /**
	 * Returns the interpolation settings.
	 *
	 * @return {Object} The interpolation settings.
	 */ getSettings_() {
        return this.settings || this.DefaultSettings_;
    }
    /**
	 * Copies a sample value to the result buffer.
	 *
	 * @param {number} index - An index into the sample value buffer.
	 * @return {TypedArray} The result buffer.
	 */ copySampleValue_(index) {
        // copies a sample value to the result buffer
        const result = this.resultBuffer, values = this.sampleValues, stride = this.valueSize, offset = index * stride;
        for(let i = 0; i !== stride; ++i)result[i] = values[offset + i];
        return result;
    }
    /**
	 * Copies a sample value to the result buffer.
	 *
	 * @abstract
	 * @param {number} i1 - An index into the sample value buffer.
	 * @param {number} t0 - The previous interpolation factor.
	 * @param {number} t - The current interpolation factor.
	 * @param {number} t1 - The next interpolation factor.
	 * @return {TypedArray} The result buffer.
	 */ interpolate_() {
        throw new Error('call to abstract method');
    // implementations shall return this.resultBuffer
    }
    /**
	 * Optional method that is executed when the interval has changed.
	 *
	 * @param {number} i1 - An index into the sample value buffer.
	 * @param {number} t0 - The previous interpolation factor.
	 * @param {number} t - The current interpolation factor.
	 */ intervalChanged_() {
    // empty
    }
}
/**
 * Fast and simple cubic spline interpolant.
 *
 * It was derived from a Hermitian construction setting the first derivative
 * at each sample position to the linear slope between neighboring positions
 * over their parameter interval.
 *
 * @augments Interpolant
 */ class $9ddd7e9b53f7a2d4$export$3646682e7a3959 extends $9ddd7e9b53f7a2d4$export$b558baee9c0f72d3 {
    /**
	 * Constructs a new cubic interpolant.
	 *
	 * @param {TypedArray} parameterPositions - The parameter positions hold the interpolation factors.
	 * @param {TypedArray} sampleValues - The sample values.
	 * @param {number} sampleSize - The sample size
	 * @param {TypedArray} [resultBuffer] - The result buffer.
	 */ constructor(parameterPositions, sampleValues, sampleSize, resultBuffer){
        super(parameterPositions, sampleValues, sampleSize, resultBuffer);
        this._weightPrev = -0;
        this._offsetPrev = -0;
        this._weightNext = -0;
        this._offsetNext = -0;
        this.DefaultSettings_ = {
            endingStart: $9ddd7e9b53f7a2d4$export$7f795934b84ab523,
            endingEnd: $9ddd7e9b53f7a2d4$export$7f795934b84ab523
        };
    }
    intervalChanged_(i1, t0, t1) {
        const pp = this.parameterPositions;
        let iPrev = i1 - 2, iNext = i1 + 1, tPrev = pp[iPrev], tNext = pp[iNext];
        if (tPrev === undefined) switch(this.getSettings_().endingStart){
            case $9ddd7e9b53f7a2d4$export$24a4ccb5099273b5:
                // f'(t0) = 0
                iPrev = i1;
                tPrev = 2 * t0 - t1;
                break;
            case $9ddd7e9b53f7a2d4$export$8e8c3ecdcd8e1fee:
                // use the other end of the curve
                iPrev = pp.length - 2;
                tPrev = t0 + pp[iPrev] - pp[iPrev + 1];
                break;
            default:
                // f''(t0) = 0 a.k.a. Natural Spline
                iPrev = i1;
                tPrev = t1;
        }
        if (tNext === undefined) switch(this.getSettings_().endingEnd){
            case $9ddd7e9b53f7a2d4$export$24a4ccb5099273b5:
                // f'(tN) = 0
                iNext = i1;
                tNext = 2 * t1 - t0;
                break;
            case $9ddd7e9b53f7a2d4$export$8e8c3ecdcd8e1fee:
                // use the other end of the curve
                iNext = 1;
                tNext = t1 + pp[1] - pp[0];
                break;
            default:
                // f''(tN) = 0, a.k.a. Natural Spline
                iNext = i1 - 1;
                tNext = t0;
        }
        const halfDt = (t1 - t0) * 0.5, stride = this.valueSize;
        this._weightPrev = halfDt / (t0 - tPrev);
        this._weightNext = halfDt / (tNext - t1);
        this._offsetPrev = iPrev * stride;
        this._offsetNext = iNext * stride;
    }
    interpolate_(i1, t0, t, t1) {
        const result = this.resultBuffer, values = this.sampleValues, stride = this.valueSize, o1 = i1 * stride, o0 = o1 - stride, oP = this._offsetPrev, oN = this._offsetNext, wP = this._weightPrev, wN = this._weightNext, p = (t - t0) / (t1 - t0), pp = p * p, ppp = pp * p;
        // evaluate polynomials
        const sP = -wP * ppp + 2 * wP * pp - wP * p;
        const s0 = (1 + wP) * ppp + (-1.5 - 2 * wP) * pp + (-0.5 + wP) * p + 1;
        const s1 = (-1 - wN) * ppp + (1.5 + wN) * pp + 0.5 * p;
        const sN = wN * ppp - wN * pp;
        // combine data linearly
        for(let i = 0; i !== stride; ++i)result[i] = sP * values[oP + i] + s0 * values[o0 + i] + s1 * values[o1 + i] + sN * values[oN + i];
        return result;
    }
}
/**
 * A basic linear interpolant.
 *
 * @augments Interpolant
 */ class $9ddd7e9b53f7a2d4$export$a8e6009059f51e1a extends $9ddd7e9b53f7a2d4$export$b558baee9c0f72d3 {
    /**
	 * Constructs a new linear interpolant.
	 *
	 * @param {TypedArray} parameterPositions - The parameter positions hold the interpolation factors.
	 * @param {TypedArray} sampleValues - The sample values.
	 * @param {number} sampleSize - The sample size
	 * @param {TypedArray} [resultBuffer] - The result buffer.
	 */ constructor(parameterPositions, sampleValues, sampleSize, resultBuffer){
        super(parameterPositions, sampleValues, sampleSize, resultBuffer);
    }
    interpolate_(i1, t0, t, t1) {
        const result = this.resultBuffer, values = this.sampleValues, stride = this.valueSize, offset1 = i1 * stride, offset0 = offset1 - stride, weight1 = (t - t0) / (t1 - t0), weight0 = 1 - weight1;
        for(let i = 0; i !== stride; ++i)result[i] = values[offset0 + i] * weight0 + values[offset1 + i] * weight1;
        return result;
    }
}
/**
 * Interpolant that evaluates to the sample value at the position preceding
 * the parameter.
 *
 * @augments Interpolant
 */ class $9ddd7e9b53f7a2d4$export$fb9758ef7ef8d5cc extends $9ddd7e9b53f7a2d4$export$b558baee9c0f72d3 {
    /**
	 * Constructs a new discrete interpolant.
	 *
	 * @param {TypedArray} parameterPositions - The parameter positions hold the interpolation factors.
	 * @param {TypedArray} sampleValues - The sample values.
	 * @param {number} sampleSize - The sample size
	 * @param {TypedArray} [resultBuffer] - The result buffer.
	 */ constructor(parameterPositions, sampleValues, sampleSize, resultBuffer){
        super(parameterPositions, sampleValues, sampleSize, resultBuffer);
    }
    interpolate_(i1 /*, t0, t, t1 */ ) {
        return this.copySampleValue_(i1 - 1);
    }
}
/**
 * Represents s a timed sequence of keyframes, which are composed of lists of
 * times and related values, and which are used to animate a specific property
 * of an object.
 */ class $9ddd7e9b53f7a2d4$export$b0e479f45b7006d6 {
    /**
	 * Constructs a new keyframe track.
	 *
	 * @param {string} name - The keyframe track's name.
	 * @param {Array<number>} times - A list of keyframe times.
	 * @param {Array<number>} values - A list of keyframe values.
	 * @param {(InterpolateLinear|InterpolateDiscrete|InterpolateSmooth)} [interpolation] - The interpolation type.
	 */ constructor(name, times, values, interpolation){
        if (name === undefined) throw new Error('THREE.KeyframeTrack: track name is undefined');
        if (times === undefined || times.length === 0) throw new Error('THREE.KeyframeTrack: no keyframes in track named ' + name);
        /**
		 * The track's name can refer to morph targets or bones or
		 * possibly other values within an animated object. See {@link PropertyBinding#parseTrackName}
		 * for the forms of strings that can be parsed for property binding.
		 *
		 * @type {string}
		 */ this.name = name;
        /**
		 * The keyframe times.
		 *
		 * @type {Float32Array}
		 */ this.times = $9ddd7e9b53f7a2d4$var$convertArray(times, this.TimeBufferType);
        /**
		 * The keyframe values.
		 *
		 * @type {Float32Array}
		 */ this.values = $9ddd7e9b53f7a2d4$var$convertArray(values, this.ValueBufferType);
        this.setInterpolation(interpolation || this.DefaultInterpolation);
    }
    /**
	 * Converts the keyframe track to JSON.
	 *
	 * @static
	 * @param {KeyframeTrack} track - The keyframe track to serialize.
	 * @return {Object} The serialized keyframe track as JSON.
	 */ static toJSON(track) {
        const trackType = track.constructor;
        let json;
        // derived classes can define a static toJSON method
        if (trackType.toJSON !== this.toJSON) json = trackType.toJSON(track);
        else {
            // by default, we assume the data can be serialized as-is
            json = {
                'name': track.name,
                'times': $9ddd7e9b53f7a2d4$var$convertArray(track.times, Array),
                'values': $9ddd7e9b53f7a2d4$var$convertArray(track.values, Array)
            };
            const interpolation = track.getInterpolation();
            if (interpolation !== track.DefaultInterpolation) json.interpolation = interpolation;
        }
        json.type = track.ValueTypeName; // mandatory
        return json;
    }
    /**
	 * Factory method for creating a new discrete interpolant.
	 *
	 * @static
	 * @param {TypedArray} [result] - The result buffer.
	 * @return {DiscreteInterpolant} The new interpolant.
	 */ InterpolantFactoryMethodDiscrete(result) {
        return new $9ddd7e9b53f7a2d4$export$fb9758ef7ef8d5cc(this.times, this.values, this.getValueSize(), result);
    }
    /**
	 * Factory method for creating a new linear interpolant.
	 *
	 * @static
	 * @param {TypedArray} [result] - The result buffer.
	 * @return {LinearInterpolant} The new interpolant.
	 */ InterpolantFactoryMethodLinear(result) {
        return new $9ddd7e9b53f7a2d4$export$a8e6009059f51e1a(this.times, this.values, this.getValueSize(), result);
    }
    /**
	 * Factory method for creating a new smooth interpolant.
	 *
	 * @static
	 * @param {TypedArray} [result] - The result buffer.
	 * @return {CubicInterpolant} The new interpolant.
	 */ InterpolantFactoryMethodSmooth(result) {
        return new $9ddd7e9b53f7a2d4$export$3646682e7a3959(this.times, this.values, this.getValueSize(), result);
    }
    /**
	 * Defines the interpolation factor method for this keyframe track.
	 *
	 * @param {(InterpolateLinear|InterpolateDiscrete|InterpolateSmooth)} interpolation - The interpolation type.
	 * @return {KeyframeTrack} A reference to this keyframe track.
	 */ setInterpolation(interpolation) {
        let factoryMethod;
        switch(interpolation){
            case $9ddd7e9b53f7a2d4$export$995b32462a65e855:
                factoryMethod = this.InterpolantFactoryMethodDiscrete;
                break;
            case $9ddd7e9b53f7a2d4$export$30fac1aace31cf4d:
                factoryMethod = this.InterpolantFactoryMethodLinear;
                break;
            case $9ddd7e9b53f7a2d4$export$198b11ff4c72bb30:
                factoryMethod = this.InterpolantFactoryMethodSmooth;
                break;
        }
        if (factoryMethod === undefined) {
            const message = 'unsupported interpolation for ' + this.ValueTypeName + ' keyframe track named ' + this.name;
            if (this.createInterpolant === undefined) {
                // fall back to default, unless the default itself is messed up
                if (interpolation !== this.DefaultInterpolation) this.setInterpolation(this.DefaultInterpolation);
                else throw new Error(message); // fatal, in this case
            }
            console.warn('THREE.KeyframeTrack:', message);
            return this;
        }
        this.createInterpolant = factoryMethod;
        return this;
    }
    /**
	 * Returns the current interpolation type.
	 *
	 * @return {(InterpolateLinear|InterpolateDiscrete|InterpolateSmooth)} The interpolation type.
	 */ getInterpolation() {
        switch(this.createInterpolant){
            case this.InterpolantFactoryMethodDiscrete:
                return $9ddd7e9b53f7a2d4$export$995b32462a65e855;
            case this.InterpolantFactoryMethodLinear:
                return $9ddd7e9b53f7a2d4$export$30fac1aace31cf4d;
            case this.InterpolantFactoryMethodSmooth:
                return $9ddd7e9b53f7a2d4$export$198b11ff4c72bb30;
        }
    }
    /**
	 * Returns the value size.
	 *
	 * @return {number} The value size.
	 */ getValueSize() {
        return this.values.length / this.times.length;
    }
    /**
	 * Moves all keyframes either forward or backward in time.
	 *
	 * @param {number} timeOffset - The offset to move the time values.
	 * @return {KeyframeTrack} A reference to this keyframe track.
	 */ shift(timeOffset) {
        if (timeOffset !== 0.0) {
            const times = this.times;
            for(let i = 0, n = times.length; i !== n; ++i)times[i] += timeOffset;
        }
        return this;
    }
    /**
	 * Scale all keyframe times by a factor (useful for frame - seconds conversions).
	 *
	 * @param {number} timeScale - The time scale.
	 * @return {KeyframeTrack} A reference to this keyframe track.
	 */ scale(timeScale) {
        if (timeScale !== 1.0) {
            const times = this.times;
            for(let i = 0, n = times.length; i !== n; ++i)times[i] *= timeScale;
        }
        return this;
    }
    /**
	 * Removes keyframes before and after animation without changing any values within the defined time range.
	 *
	 * Note: The method does not shift around keys to the start of the track time, because for interpolated
	 * keys this will change their values
	 *
	 * @param {number} startTime - The start time.
	 * @param {number} endTime - The end time.
	 * @return {KeyframeTrack} A reference to this keyframe track.
	 */ trim(startTime, endTime) {
        const times = this.times, nKeys = times.length;
        let from = 0, to = nKeys - 1;
        while(from !== nKeys && times[from] < startTime)++from;
        while(to !== -1 && times[to] > endTime)--to;
        ++to; // inclusive -> exclusive bound
        if (from !== 0 || to !== nKeys) {
            // empty tracks are forbidden, so keep at least one keyframe
            if (from >= to) {
                to = Math.max(to, 1);
                from = to - 1;
            }
            const stride = this.getValueSize();
            this.times = times.slice(from, to);
            this.values = this.values.slice(from * stride, to * stride);
        }
        return this;
    }
    /**
	 * Performs minimal validation on the keyframe track. Returns `true` if the values
	 * are valid.
	 *
	 * @return {boolean} Whether the keyframes are valid or not.
	 */ validate() {
        let valid = true;
        const valueSize = this.getValueSize();
        if (valueSize - Math.floor(valueSize) !== 0) {
            console.error('THREE.KeyframeTrack: Invalid value size in track.', this);
            valid = false;
        }
        const times = this.times, values = this.values, nKeys = times.length;
        if (nKeys === 0) {
            console.error('THREE.KeyframeTrack: Track is empty.', this);
            valid = false;
        }
        let prevTime = null;
        for(let i = 0; i !== nKeys; i++){
            const currTime = times[i];
            if (typeof currTime === 'number' && isNaN(currTime)) {
                console.error('THREE.KeyframeTrack: Time is not a valid number.', this, i, currTime);
                valid = false;
                break;
            }
            if (prevTime !== null && prevTime > currTime) {
                console.error('THREE.KeyframeTrack: Out of order keys.', this, i, currTime, prevTime);
                valid = false;
                break;
            }
            prevTime = currTime;
        }
        if (values !== undefined) {
            if ($9ddd7e9b53f7a2d4$var$isTypedArray(values)) for(let i = 0, n = values.length; i !== n; ++i){
                const value = values[i];
                if (isNaN(value)) {
                    console.error('THREE.KeyframeTrack: Value is not a valid number.', this, i, value);
                    valid = false;
                    break;
                }
            }
        }
        return valid;
    }
    /**
	 * Optimizes this keyframe track by removing equivalent sequential keys (which are
	 * common in morph target sequences).
	 *
	 * @return {AnimationClip} A reference to this animation clip.
	 */ optimize() {
        // (0,0,0,0,1,1,1,0,0,0,0,0,0,0) --> (0,0,1,1,0,0)
        // times or values may be shared with other tracks, so overwriting is unsafe
        const times = this.times.slice(), values = this.values.slice(), stride = this.getValueSize(), smoothInterpolation = this.getInterpolation() === $9ddd7e9b53f7a2d4$export$198b11ff4c72bb30, lastIndex = times.length - 1;
        let writeIndex = 1;
        for(let i = 1; i < lastIndex; ++i){
            let keep = false;
            const time = times[i];
            const timeNext = times[i + 1];
            // remove adjacent keyframes scheduled at the same time
            if (time !== timeNext && (i !== 1 || time !== times[0])) {
                if (!smoothInterpolation) {
                    // remove unnecessary keyframes same as their neighbors
                    const offset = i * stride, offsetP = offset - stride, offsetN = offset + stride;
                    for(let j = 0; j !== stride; ++j){
                        const value = values[offset + j];
                        if (value !== values[offsetP + j] || value !== values[offsetN + j]) {
                            keep = true;
                            break;
                        }
                    }
                } else keep = true;
            }
            // in-place compaction
            if (keep) {
                if (i !== writeIndex) {
                    times[writeIndex] = times[i];
                    const readOffset = i * stride, writeOffset = writeIndex * stride;
                    for(let j = 0; j !== stride; ++j)values[writeOffset + j] = values[readOffset + j];
                }
                ++writeIndex;
            }
        }
        // flush last keyframe (compaction looks ahead)
        if (lastIndex > 0) {
            times[writeIndex] = times[lastIndex];
            for(let readOffset = lastIndex * stride, writeOffset = writeIndex * stride, j = 0; j !== stride; ++j)values[writeOffset + j] = values[readOffset + j];
            ++writeIndex;
        }
        if (writeIndex !== times.length) {
            this.times = times.slice(0, writeIndex);
            this.values = values.slice(0, writeIndex * stride);
        } else {
            this.times = times;
            this.values = values;
        }
        return this;
    }
    /**
	 * Returns a new keyframe track with copied values from this instance.
	 *
	 * @return {KeyframeTrack} A clone of this instance.
	 */ clone() {
        const times = this.times.slice();
        const values = this.values.slice();
        const TypedKeyframeTrack = this.constructor;
        const track = new TypedKeyframeTrack(this.name, times, values);
        // Interpolant argument to constructor is not saved, so copy the factory method directly.
        track.createInterpolant = this.createInterpolant;
        return track;
    }
}
/**
 * The value type name.
 *
 * @type {String}
 * @default ''
 */ $9ddd7e9b53f7a2d4$export$b0e479f45b7006d6.prototype.ValueTypeName = '';
/**
 * The time buffer type of this keyframe track.
 *
 * @type {TypedArray|Array}
 * @default Float32Array.constructor
 */ $9ddd7e9b53f7a2d4$export$b0e479f45b7006d6.prototype.TimeBufferType = Float32Array;
/**
 * The value buffer type of this keyframe track.
 *
 * @type {TypedArray|Array}
 * @default Float32Array.constructor
 */ $9ddd7e9b53f7a2d4$export$b0e479f45b7006d6.prototype.ValueBufferType = Float32Array;
/**
 * The default interpolation type of this keyframe track.
 *
 * @type {(InterpolateLinear|InterpolateDiscrete|InterpolateSmooth)}
 * @default InterpolateLinear
 */ $9ddd7e9b53f7a2d4$export$b0e479f45b7006d6.prototype.DefaultInterpolation = $9ddd7e9b53f7a2d4$export$30fac1aace31cf4d;
/**
 * A track for boolean keyframe values.
 *
 * @augments KeyframeTrack
 */ class $9ddd7e9b53f7a2d4$export$d3a344b98cf0b775 extends $9ddd7e9b53f7a2d4$export$b0e479f45b7006d6 {
    /**
	 * Constructs a new boolean keyframe track.
	 *
	 * This keyframe track type has no `interpolation` parameter because the
	 * interpolation is always discrete.
	 *
	 * @param {string} name - The keyframe track's name.
	 * @param {Array<number>} times - A list of keyframe times.
	 * @param {Array<number>} values - A list of keyframe values.
	 */ constructor(name, times, values){
        super(name, times, values);
    }
}
/**
 * The value type name.
 *
 * @type {String}
 * @default 'bool'
 */ $9ddd7e9b53f7a2d4$export$d3a344b98cf0b775.prototype.ValueTypeName = 'bool';
/**
 * The value buffer type of this keyframe track.
 *
 * @type {TypedArray|Array}
 * @default Array.constructor
 */ $9ddd7e9b53f7a2d4$export$d3a344b98cf0b775.prototype.ValueBufferType = Array;
/**
 * The default interpolation type of this keyframe track.
 *
 * @type {(InterpolateLinear|InterpolateDiscrete|InterpolateSmooth)}
 * @default InterpolateDiscrete
 */ $9ddd7e9b53f7a2d4$export$d3a344b98cf0b775.prototype.DefaultInterpolation = $9ddd7e9b53f7a2d4$export$995b32462a65e855;
$9ddd7e9b53f7a2d4$export$d3a344b98cf0b775.prototype.InterpolantFactoryMethodLinear = undefined;
$9ddd7e9b53f7a2d4$export$d3a344b98cf0b775.prototype.InterpolantFactoryMethodSmooth = undefined;
/**
 * A track for color keyframe values.
 *
 * @augments KeyframeTrack
 */ class $9ddd7e9b53f7a2d4$export$83444c5d885347d8 extends $9ddd7e9b53f7a2d4$export$b0e479f45b7006d6 {
    /**
	 * Constructs a new color keyframe track.
	 *
	 * @param {string} name - The keyframe track's name.
	 * @param {Array<number>} times - A list of keyframe times.
	 * @param {Array<number>} values - A list of keyframe values.
	 * @param {(InterpolateLinear|InterpolateDiscrete|InterpolateSmooth)} [interpolation] - The interpolation type.
	 */ constructor(name, times, values, interpolation){
        super(name, times, values, interpolation);
    }
}
/**
 * The value type name.
 *
 * @type {String}
 * @default 'color'
 */ $9ddd7e9b53f7a2d4$export$83444c5d885347d8.prototype.ValueTypeName = 'color';
/**
 * A track for numeric keyframe values.
 *
 * @augments KeyframeTrack
 */ class $9ddd7e9b53f7a2d4$export$d45f0d1a4d9a9314 extends $9ddd7e9b53f7a2d4$export$b0e479f45b7006d6 {
    /**
	 * Constructs a new number keyframe track.
	 *
	 * @param {string} name - The keyframe track's name.
	 * @param {Array<number>} times - A list of keyframe times.
	 * @param {Array<number>} values - A list of keyframe values.
	 * @param {(InterpolateLinear|InterpolateDiscrete|InterpolateSmooth)} [interpolation] - The interpolation type.
	 */ constructor(name, times, values, interpolation){
        super(name, times, values, interpolation);
    }
}
/**
 * The value type name.
 *
 * @type {String}
 * @default 'number'
 */ $9ddd7e9b53f7a2d4$export$d45f0d1a4d9a9314.prototype.ValueTypeName = 'number';
/**
 * Spherical linear unit quaternion interpolant.
 *
 * @augments Interpolant
 */ class $9ddd7e9b53f7a2d4$export$2db1cfb7923d931e extends $9ddd7e9b53f7a2d4$export$b558baee9c0f72d3 {
    /**
	 * Constructs a new SLERP interpolant.
	 *
	 * @param {TypedArray} parameterPositions - The parameter positions hold the interpolation factors.
	 * @param {TypedArray} sampleValues - The sample values.
	 * @param {number} sampleSize - The sample size
	 * @param {TypedArray} [resultBuffer] - The result buffer.
	 */ constructor(parameterPositions, sampleValues, sampleSize, resultBuffer){
        super(parameterPositions, sampleValues, sampleSize, resultBuffer);
    }
    interpolate_(i1, t0, t, t1) {
        const result = this.resultBuffer, values = this.sampleValues, stride = this.valueSize, alpha = (t - t0) / (t1 - t0);
        let offset = i1 * stride;
        for(let end = offset + stride; offset !== end; offset += 4)$9ddd7e9b53f7a2d4$export$23d6a54f0bbc85a3.slerpFlat(result, 0, values, offset - stride, values, offset, alpha);
        return result;
    }
}
/**
 * A track for Quaternion keyframe values.
 *
 * @augments KeyframeTrack
 */ class $9ddd7e9b53f7a2d4$export$b8043f12b5aafbd7 extends $9ddd7e9b53f7a2d4$export$b0e479f45b7006d6 {
    /**
	 * Constructs a new Quaternion keyframe track.
	 *
	 * @param {string} name - The keyframe track's name.
	 * @param {Array<number>} times - A list of keyframe times.
	 * @param {Array<number>} values - A list of keyframe values.
	 * @param {(InterpolateLinear|InterpolateDiscrete|InterpolateSmooth)} [interpolation] - The interpolation type.
	 */ constructor(name, times, values, interpolation){
        super(name, times, values, interpolation);
    }
    /**
	 * Overwritten so the method returns Quaternion based interpolant.
	 *
	 * @static
	 * @param {TypedArray} [result] - The result buffer.
	 * @return {QuaternionLinearInterpolant} The new interpolant.
	 */ InterpolantFactoryMethodLinear(result) {
        return new $9ddd7e9b53f7a2d4$export$2db1cfb7923d931e(this.times, this.values, this.getValueSize(), result);
    }
}
/**
 * The value type name.
 *
 * @type {String}
 * @default 'quaternion'
 */ $9ddd7e9b53f7a2d4$export$b8043f12b5aafbd7.prototype.ValueTypeName = 'quaternion';
// ValueBufferType is inherited
// DefaultInterpolation is inherited;
$9ddd7e9b53f7a2d4$export$b8043f12b5aafbd7.prototype.InterpolantFactoryMethodSmooth = undefined;
/**
 * A track for string keyframe values.
 *
 * @augments KeyframeTrack
 */ class $9ddd7e9b53f7a2d4$export$6ce41d4f3a8df9cd extends $9ddd7e9b53f7a2d4$export$b0e479f45b7006d6 {
    /**
	 * Constructs a new string keyframe track.
	 *
	 * This keyframe track type has no `interpolation` parameter because the
	 * interpolation is always discrete.
	 *
	 * @param {string} name - The keyframe track's name.
	 * @param {Array<number>} times - A list of keyframe times.
	 * @param {Array<number>} values - A list of keyframe values.
	 */ constructor(name, times, values){
        super(name, times, values);
    }
}
/**
 * The value type name.
 *
 * @type {String}
 * @default 'string'
 */ $9ddd7e9b53f7a2d4$export$6ce41d4f3a8df9cd.prototype.ValueTypeName = 'string';
/**
 * The value buffer type of this keyframe track.
 *
 * @type {TypedArray|Array}
 * @default Array.constructor
 */ $9ddd7e9b53f7a2d4$export$6ce41d4f3a8df9cd.prototype.ValueBufferType = Array;
/**
 * The default interpolation type of this keyframe track.
 *
 * @type {(InterpolateLinear|InterpolateDiscrete|InterpolateSmooth)}
 * @default InterpolateDiscrete
 */ $9ddd7e9b53f7a2d4$export$6ce41d4f3a8df9cd.prototype.DefaultInterpolation = $9ddd7e9b53f7a2d4$export$995b32462a65e855;
$9ddd7e9b53f7a2d4$export$6ce41d4f3a8df9cd.prototype.InterpolantFactoryMethodLinear = undefined;
$9ddd7e9b53f7a2d4$export$6ce41d4f3a8df9cd.prototype.InterpolantFactoryMethodSmooth = undefined;
/**
 * A track for vector keyframe values.
 *
 * @augments KeyframeTrack
 */ class $9ddd7e9b53f7a2d4$export$5ce2dcb4cc9f2bff extends $9ddd7e9b53f7a2d4$export$b0e479f45b7006d6 {
    /**
	 * Constructs a new vector keyframe track.
	 *
	 * @param {string} name - The keyframe track's name.
	 * @param {Array<number>} times - A list of keyframe times.
	 * @param {Array<number>} values - A list of keyframe values.
	 * @param {(InterpolateLinear|InterpolateDiscrete|InterpolateSmooth)} [interpolation] - The interpolation type.
	 */ constructor(name, times, values, interpolation){
        super(name, times, values, interpolation);
    }
}
/**
 * The value type name.
 *
 * @type {String}
 * @default 'vector'
 */ $9ddd7e9b53f7a2d4$export$5ce2dcb4cc9f2bff.prototype.ValueTypeName = 'vector';
/**
 * A reusable set of keyframe tracks which represent an animation.
 */ class $9ddd7e9b53f7a2d4$export$d942c706bf23829c {
    /**
	 * Constructs a new animation clip.
	 *
	 * Note: Instead of instantiating an AnimationClip directly with the constructor, you can
	 * use the static interface of this class for creating clips. In most cases though, animation clips
	 * will automatically be created by loaders when importing animated 3D assets.
	 *
	 * @param {string} [name=''] - The clip's name.
	 * @param {number} [duration=-1] - The clip's duration in seconds. If a negative value is passed,
	 * the duration will be calculated from the passed keyframes.
	 * @param {Array<KeyframeTrack>} tracks - An array of keyframe tracks.
	 * @param {(NormalAnimationBlendMode|AdditiveAnimationBlendMode)} [blendMode=NormalAnimationBlendMode] - Defines how the animation
	 * is blended/combined when two or more animations are simultaneously played.
	 */ constructor(name = '', duration = -1, tracks = [], blendMode = $9ddd7e9b53f7a2d4$export$bcfbbdcf8de7f8cd){
        /**
		 * The clip's name.
		 *
		 * @type {string}
		 */ this.name = name;
        /**
		 *  An array of keyframe tracks.
		 *
		 * @type {Array<KeyframeTrack>}
		 */ this.tracks = tracks;
        /**
		 * The clip's duration in seconds.
		 *
		 * @type {number}
		 */ this.duration = duration;
        /**
		 * Defines how the animation is blended/combined when two or more animations
		 * are simultaneously played.
		 *
		 * @type {(NormalAnimationBlendMode|AdditiveAnimationBlendMode)}
		 */ this.blendMode = blendMode;
        /**
		 * The UUID of the animation clip.
		 *
		 * @type {string}
		 * @readonly
		 */ this.uuid = $9ddd7e9b53f7a2d4$var$generateUUID();
        // this means it should figure out its duration by scanning the tracks
        if (this.duration < 0) this.resetDuration();
    }
    /**
	 * Factory method for creating an animation clip from the given JSON.
	 *
	 * @static
	 * @param {Object} json - The serialized animation clip.
	 * @return {AnimationClip} The new animation clip.
	 */ static parse(json) {
        const tracks = [], jsonTracks = json.tracks, frameTime = 1.0 / (json.fps || 1.0);
        for(let i = 0, n = jsonTracks.length; i !== n; ++i)tracks.push($9ddd7e9b53f7a2d4$var$parseKeyframeTrack(jsonTracks[i]).scale(frameTime));
        const clip = new this(json.name, json.duration, tracks, json.blendMode);
        clip.uuid = json.uuid;
        return clip;
    }
    /**
	 * Serializes the given animation clip into JSON.
	 *
	 * @static
	 * @param {AnimationClip} clip - The animation clip to serialize.
	 * @return {Object} The JSON object.
	 */ static toJSON(clip) {
        const tracks = [], clipTracks = clip.tracks;
        const json = {
            'name': clip.name,
            'duration': clip.duration,
            'tracks': tracks,
            'uuid': clip.uuid,
            'blendMode': clip.blendMode
        };
        for(let i = 0, n = clipTracks.length; i !== n; ++i)tracks.push($9ddd7e9b53f7a2d4$export$b0e479f45b7006d6.toJSON(clipTracks[i]));
        return json;
    }
    /**
	 * Returns a new animation clip from the passed morph targets array of a
	 * geometry, taking a name and the number of frames per second.
	 *
	 * Note: The fps parameter is required, but the animation speed can be
	 * overridden via {@link AnimationAction#setDuration}.
	 *
	 * @static
	 * @param {string} name - The name of the animation clip.
	 * @param {Array<Object>} morphTargetSequence - A sequence of morph targets.
	 * @param {number} fps - The Frames-Per-Second value.
	 * @param {boolean} noLoop - Whether the clip should be no loop or not.
	 * @return {AnimationClip} The new animation clip.
	 */ static CreateFromMorphTargetSequence(name, morphTargetSequence, fps, noLoop) {
        const numMorphTargets = morphTargetSequence.length;
        const tracks = [];
        for(let i = 0; i < numMorphTargets; i++){
            let times = [];
            let values = [];
            times.push((i + numMorphTargets - 1) % numMorphTargets, i, (i + 1) % numMorphTargets);
            values.push(0, 1, 0);
            const order = $9ddd7e9b53f7a2d4$var$getKeyframeOrder(times);
            times = $9ddd7e9b53f7a2d4$var$sortedArray(times, 1, order);
            values = $9ddd7e9b53f7a2d4$var$sortedArray(values, 1, order);
            // if there is a key at the first frame, duplicate it as the
            // last frame as well for perfect loop.
            if (!noLoop && times[0] === 0) {
                times.push(numMorphTargets);
                values.push(values[0]);
            }
            tracks.push(new $9ddd7e9b53f7a2d4$export$d45f0d1a4d9a9314('.morphTargetInfluences[' + morphTargetSequence[i].name + ']', times, values).scale(1.0 / fps));
        }
        return new this(name, -1, tracks);
    }
    /**
	 * Searches for an animation clip by name, taking as its first parameter
	 * either an array of clips, or a mesh or geometry that contains an
	 * array named "animations" property.
	 *
	 * @static
	 * @param {(Array<AnimationClip>|Object3D)} objectOrClipArray - The array or object to search through.
	 * @param {string} name - The name to search for.
	 * @return {?AnimationClip} The found animation clip. Returns `null` if no clip has been found.
	 */ static findByName(objectOrClipArray, name) {
        let clipArray = objectOrClipArray;
        if (!Array.isArray(objectOrClipArray)) {
            const o = objectOrClipArray;
            clipArray = o.geometry && o.geometry.animations || o.animations;
        }
        for(let i = 0; i < clipArray.length; i++){
            if (clipArray[i].name === name) return clipArray[i];
        }
        return null;
    }
    /**
	 * Returns an array of new AnimationClips created from the morph target
	 * sequences of a geometry, trying to sort morph target names into
	 * animation-group-based patterns like "Walk_001, Walk_002, Run_001, Run_002...".
	 *
	 * See {@link MD2Loader#parse} as an example for how the method should be used.
	 *
	 * @static
	 * @param {Array<Object>} morphTargets - A sequence of morph targets.
	 * @param {number} fps - The Frames-Per-Second value.
	 * @param {boolean} noLoop - Whether the clip should be no loop or not.
	 * @return {Array<AnimationClip>} An array of new animation clips.
	 */ static CreateClipsFromMorphTargetSequences(morphTargets, fps, noLoop) {
        const animationToMorphTargets = {};
        // tested with https://regex101.com/ on trick sequences
        // such flamingo_flyA_003, flamingo_run1_003, crdeath0059
        const pattern = /^([\w-]*?)([\d]+)$/;
        // sort morph target names into animation groups based
        // patterns like Walk_001, Walk_002, Run_001, Run_002
        for(let i = 0, il = morphTargets.length; i < il; i++){
            const morphTarget = morphTargets[i];
            const parts = morphTarget.name.match(pattern);
            if (parts && parts.length > 1) {
                const name = parts[1];
                let animationMorphTargets = animationToMorphTargets[name];
                if (!animationMorphTargets) animationToMorphTargets[name] = animationMorphTargets = [];
                animationMorphTargets.push(morphTarget);
            }
        }
        const clips = [];
        for(const name in animationToMorphTargets)clips.push(this.CreateFromMorphTargetSequence(name, animationToMorphTargets[name], fps, noLoop));
        return clips;
    }
    /**
	 * Parses the `animation.hierarchy` format and returns a new animation clip.
	 *
	 * @static
	 * @deprecated since r175.
	 * @param {Object} animation - A serialized animation clip as JSON.
	 * @param {Array<Bones>} bones - An array of bones.
	 * @return {?AnimationClip} The new animation clip.
	 */ static parseAnimation(animation, bones) {
        console.warn('THREE.AnimationClip: parseAnimation() is deprecated and will be removed with r185');
        if (!animation) {
            console.error('THREE.AnimationClip: No animation in JSONLoader data.');
            return null;
        }
        const addNonemptyTrack = function(trackType, trackName, animationKeys, propertyName, destTracks) {
            // only return track if there are actually keys.
            if (animationKeys.length !== 0) {
                const times = [];
                const values = [];
                $9ddd7e9b53f7a2d4$var$flattenJSON(animationKeys, times, values, propertyName);
                // empty keys are filtered out, so check again
                if (times.length !== 0) destTracks.push(new trackType(trackName, times, values));
            }
        };
        const tracks = [];
        const clipName = animation.name || 'default';
        const fps = animation.fps || 30;
        const blendMode = animation.blendMode;
        // automatic length determination in AnimationClip.
        let duration = animation.length || -1;
        const hierarchyTracks = animation.hierarchy || [];
        for(let h = 0; h < hierarchyTracks.length; h++){
            const animationKeys = hierarchyTracks[h].keys;
            // skip empty tracks
            if (!animationKeys || animationKeys.length === 0) continue;
            // process morph targets
            if (animationKeys[0].morphTargets) {
                // figure out all morph targets used in this track
                const morphTargetNames = {};
                let k;
                for(k = 0; k < animationKeys.length; k++){
                    if (animationKeys[k].morphTargets) for(let m = 0; m < animationKeys[k].morphTargets.length; m++)morphTargetNames[animationKeys[k].morphTargets[m]] = -1;
                }
                // create a track for each morph target with all zero
                // morphTargetInfluences except for the keys in which
                // the morphTarget is named.
                for(const morphTargetName in morphTargetNames){
                    const times = [];
                    const values = [];
                    for(let m = 0; m !== animationKeys[k].morphTargets.length; ++m){
                        const animationKey = animationKeys[k];
                        times.push(animationKey.time);
                        values.push(animationKey.morphTarget === morphTargetName ? 1 : 0);
                    }
                    tracks.push(new $9ddd7e9b53f7a2d4$export$d45f0d1a4d9a9314('.morphTargetInfluence[' + morphTargetName + ']', times, values));
                }
                duration = morphTargetNames.length * fps;
            } else {
                // ...assume skeletal animation
                const boneName = '.bones[' + bones[h].name + ']';
                addNonemptyTrack($9ddd7e9b53f7a2d4$export$5ce2dcb4cc9f2bff, boneName + '.position', animationKeys, 'pos', tracks);
                addNonemptyTrack($9ddd7e9b53f7a2d4$export$b8043f12b5aafbd7, boneName + '.quaternion', animationKeys, 'rot', tracks);
                addNonemptyTrack($9ddd7e9b53f7a2d4$export$5ce2dcb4cc9f2bff, boneName + '.scale', animationKeys, 'scl', tracks);
            }
        }
        if (tracks.length === 0) return null;
        const clip = new this(clipName, duration, tracks, blendMode);
        return clip;
    }
    /**
	 * Sets the duration of this clip to the duration of its longest keyframe track.
	 *
	 * @return {AnimationClip} A reference to this animation clip.
	 */ resetDuration() {
        const tracks = this.tracks;
        let duration = 0;
        for(let i = 0, n = tracks.length; i !== n; ++i){
            const track = this.tracks[i];
            duration = Math.max(duration, track.times[track.times.length - 1]);
        }
        this.duration = duration;
        return this;
    }
    /**
	 * Trims all tracks to the clip's duration.
	 *
	 * @return {AnimationClip} A reference to this animation clip.
	 */ trim() {
        for(let i = 0; i < this.tracks.length; i++)this.tracks[i].trim(0, this.duration);
        return this;
    }
    /**
	 * Performs minimal validation on each track in the clip. Returns `true` if all
	 * tracks are valid.
	 *
	 * @return {boolean} Whether the clip's keyframes are valid or not.
	 */ validate() {
        let valid = true;
        for(let i = 0; i < this.tracks.length; i++)valid = valid && this.tracks[i].validate();
        return valid;
    }
    /**
	 * Optimizes each track by removing equivalent sequential keys (which are
	 * common in morph target sequences).
	 *
	 * @return {AnimationClip} A reference to this animation clip.
	 */ optimize() {
        for(let i = 0; i < this.tracks.length; i++)this.tracks[i].optimize();
        return this;
    }
    /**
	 * Returns a new animation clip with copied values from this instance.
	 *
	 * @return {AnimationClip} A clone of this instance.
	 */ clone() {
        const tracks = [];
        for(let i = 0; i < this.tracks.length; i++)tracks.push(this.tracks[i].clone());
        return new this.constructor(this.name, this.duration, tracks, this.blendMode);
    }
    /**
	 * Serializes this animation clip into JSON.
	 *
	 * @return {Object} The JSON object.
	 */ toJSON() {
        return this.constructor.toJSON(this);
    }
}
function $9ddd7e9b53f7a2d4$var$getTrackTypeForValueTypeName(typeName) {
    switch(typeName.toLowerCase()){
        case 'scalar':
        case 'double':
        case 'float':
        case 'number':
        case 'integer':
            return $9ddd7e9b53f7a2d4$export$d45f0d1a4d9a9314;
        case 'vector':
        case 'vector2':
        case 'vector3':
        case 'vector4':
            return $9ddd7e9b53f7a2d4$export$5ce2dcb4cc9f2bff;
        case 'color':
            return $9ddd7e9b53f7a2d4$export$83444c5d885347d8;
        case 'quaternion':
            return $9ddd7e9b53f7a2d4$export$b8043f12b5aafbd7;
        case 'bool':
        case 'boolean':
            return $9ddd7e9b53f7a2d4$export$d3a344b98cf0b775;
        case 'string':
            return $9ddd7e9b53f7a2d4$export$6ce41d4f3a8df9cd;
    }
    throw new Error('THREE.KeyframeTrack: Unsupported typeName: ' + typeName);
}
function $9ddd7e9b53f7a2d4$var$parseKeyframeTrack(json) {
    if (json.type === undefined) throw new Error('THREE.KeyframeTrack: track type undefined, can not parse');
    const trackType = $9ddd7e9b53f7a2d4$var$getTrackTypeForValueTypeName(json.type);
    if (json.times === undefined) {
        const times = [], values = [];
        $9ddd7e9b53f7a2d4$var$flattenJSON(json.keys, times, values, 'value');
        json.times = times;
        json.values = values;
    }
    // derived classes can define a static parse method
    if (trackType.parse !== undefined) return trackType.parse(json);
    else // by default, we assume a constructor compatible with the base
    return new trackType(json.name, json.times, json.values, json.interpolation);
}
/**
 * @class
 * @classdesc A simple caching system, used internally by {@link FileLoader}.
 * To enable caching across all loaders that use {@link FileLoader}, add `THREE.Cache.enabled = true.` once in your app.
 * @hideconstructor
 */ const $9ddd7e9b53f7a2d4$export$94affb487e701bf2 = {
    /**
	 * Whether caching is enabled or not.
	 *
	 * @static
	 * @type {boolean}
	 * @default false
	 */ enabled: false,
    /**
	 * A dictionary that holds cached files.
	 *
	 * @static
	 * @type {Object<string,Object>}
	 */ files: {},
    /**
	 * Adds a cache entry with a key to reference the file. If this key already
	 * holds a file, it is overwritten.
	 *
	 * @static
	 * @param {string} key - The key to reference the cached file.
	 * @param {Object} file -  The file to be cached.
	 */ add: function(key, file) {
        if (this.enabled === false) return;
        // console.log( 'THREE.Cache', 'Adding key:', key );
        this.files[key] = file;
    },
    /**
	 * Gets the cached value for the given key.
	 *
	 * @static
	 * @param {string} key - The key to reference the cached file.
	 * @return {Object|undefined} The cached file. If the key does not exist `undefined` is returned.
	 */ get: function(key) {
        if (this.enabled === false) return;
        // console.log( 'THREE.Cache', 'Checking key:', key );
        return this.files[key];
    },
    /**
	 * Removes the cached file associated with the given key.
	 *
	 * @static
	 * @param {string} key - The key to reference the cached file.
	 */ remove: function(key) {
        delete this.files[key];
    },
    /**
	 * Remove all values from the cache.
	 *
	 * @static
	 */ clear: function() {
        this.files = {};
    }
};
/**
 * Handles and keeps track of loaded and pending data. A default global
 * instance of this class is created and used by loaders if not supplied
 * manually.
 *
 * In general that should be sufficient, however there are times when it can
 * be useful to have separate loaders - for example if you want to show
 * separate loading bars for objects and textures.
 *
 * ```js
 * const manager = new THREE.LoadingManager();
 * manager.onLoad = () => console.log( 'Loading complete!' );
 *
 * const loader1 = new OBJLoader( manager );
 * const loader2 = new ColladaLoader( manager );
 * ```
 */ class $9ddd7e9b53f7a2d4$export$99cc795e99919eed {
    /**
	 * Constructs a new loading manager.
	 *
	 * @param {Function} [onLoad] - Executes when all items have been loaded.
	 * @param {Function} [onProgress] - Executes when single items have been loaded.
	 * @param {Function} [onError] - Executes when an error occurs.
	 */ constructor(onLoad, onProgress, onError){
        const scope = this;
        let isLoading = false;
        let itemsLoaded = 0;
        let itemsTotal = 0;
        let urlModifier = undefined;
        const handlers = [];
        // Refer to #5689 for the reason why we don't set .onStart
        // in the constructor
        /**
		 * Executes when an item starts loading.
		 *
		 * @type {Function|undefined}
		 * @default undefined
		 */ this.onStart = undefined;
        /**
		 * Executes when all items have been loaded.
		 *
		 * @type {Function|undefined}
		 * @default undefined
		 */ this.onLoad = onLoad;
        /**
		 * Executes when single items have been loaded.
		 *
		 * @type {Function|undefined}
		 * @default undefined
		 */ this.onProgress = onProgress;
        /**
		 * Executes when an error occurs.
		 *
		 * @type {Function|undefined}
		 * @default undefined
		 */ this.onError = onError;
        /**
		 * This should be called by any loader using the manager when the loader
		 * starts loading an item.
		 *
		 * @param {string} url - The URL to load.
		 */ this.itemStart = function(url) {
            itemsTotal++;
            if (isLoading === false) {
                if (scope.onStart !== undefined) scope.onStart(url, itemsLoaded, itemsTotal);
            }
            isLoading = true;
        };
        /**
		 * This should be called by any loader using the manager when the loader
		 * ended loading an item.
		 *
		 * @param {string} url - The URL of the loaded item.
		 */ this.itemEnd = function(url) {
            itemsLoaded++;
            if (scope.onProgress !== undefined) scope.onProgress(url, itemsLoaded, itemsTotal);
            if (itemsLoaded === itemsTotal) {
                isLoading = false;
                if (scope.onLoad !== undefined) scope.onLoad();
            }
        };
        /**
		 * This should be called by any loader using the manager when the loader
		 * encounters an error when loading an item.
		 *
		 * @param {string} url - The URL of the item that produces an error.
		 */ this.itemError = function(url) {
            if (scope.onError !== undefined) scope.onError(url);
        };
        /**
		 * Given a URL, uses the URL modifier callback (if any) and returns a
		 * resolved URL. If no URL modifier is set, returns the original URL.
		 *
		 * @param {string} url - The URL to load.
		 * @return {string} The resolved URL.
		 */ this.resolveURL = function(url) {
            if (urlModifier) return urlModifier(url);
            return url;
        };
        /**
		 * If provided, the callback will be passed each resource URL before a
		 * request is sent. The callback may return the original URL, or a new URL to
		 * override loading behavior. This behavior can be used to load assets from
		 * .ZIP files, drag-and-drop APIs, and Data URIs.
		 *
		 * ```js
		 * const blobs = {'fish.gltf': blob1, 'diffuse.png': blob2, 'normal.png': blob3};
		 *
		 * const manager = new THREE.LoadingManager();
		 *
		 * // Initialize loading manager with URL callback.
		 * const objectURLs = [];
		 * manager.setURLModifier( ( url ) => {
		 *
		 * 	url = URL.createObjectURL( blobs[ url ] );
		 * 	objectURLs.push( url );
		 * 	return url;
		 *
		 * } );
		 *
		 * // Load as usual, then revoke the blob URLs.
		 * const loader = new GLTFLoader( manager );
		 * loader.load( 'fish.gltf', (gltf) => {
		 *
		 * 	scene.add( gltf.scene );
		 * 	objectURLs.forEach( ( url ) => URL.revokeObjectURL( url ) );
		 *
		 * } );
		 * ```
		 *
		 * @param {function(string):string} transform - URL modifier callback. Called with an URL and must return a resolved URL.
		 * @return {LoadingManager} A reference to this loading manager.
		 */ this.setURLModifier = function(transform) {
            urlModifier = transform;
            return this;
        };
        /**
		 * Registers a loader with the given regular expression. Can be used to
		 * define what loader should be used in order to load specific files. A
		 * typical use case is to overwrite the default loader for textures.
		 *
		 * ```js
		 * // add handler for TGA textures
		 * manager.addHandler( /\.tga$/i, new TGALoader() );
		 * ```
		 *
		 * @param {string} regex - A regular expression.
		 * @param {Loader} loader - A loader that should handle matched cases.
		 * @return {LoadingManager} A reference to this loading manager.
		 */ this.addHandler = function(regex, loader) {
            handlers.push(regex, loader);
            return this;
        };
        /**
		 * Removes the loader for the given regular expression.
		 *
		 * @param {string} regex - A regular expression.
		 * @return {LoadingManager} A reference to this loading manager.
		 */ this.removeHandler = function(regex) {
            const index = handlers.indexOf(regex);
            if (index !== -1) handlers.splice(index, 2);
            return this;
        };
        /**
		 * Can be used to retrieve the registered loader for the given file path.
		 *
		 * @param {string} file - The file path.
		 * @return {?Loader} The registered loader. Returns `null` if no loader was found.
		 */ this.getHandler = function(file) {
            for(let i = 0, l = handlers.length; i < l; i += 2){
                const regex = handlers[i];
                const loader = handlers[i + 1];
                if (regex.global) regex.lastIndex = 0; // see #17920
                if (regex.test(file)) return loader;
            }
            return null;
        };
    }
}
/**
 * The global default loading manager.
 *
 * @constant
 * @type {LoadingManager}
 */ const $9ddd7e9b53f7a2d4$export$b033c3f9a95c6a16 = /*@__PURE__*/ new $9ddd7e9b53f7a2d4$export$99cc795e99919eed();
/**
 * Abstract base class for loaders.
 *
 * @abstract
 */ class $9ddd7e9b53f7a2d4$export$3b0d6d7590275603 {
    /**
	 * Constructs a new loader.
	 *
	 * @param {LoadingManager} [manager] - The loading manager.
	 */ constructor(manager){
        /**
		 * The loading manager.
		 *
		 * @type {LoadingManager}
		 * @default DefaultLoadingManager
		 */ this.manager = manager !== undefined ? manager : $9ddd7e9b53f7a2d4$export$b033c3f9a95c6a16;
        /**
		 * The crossOrigin string to implement CORS for loading the url from a
		 * different domain that allows CORS.
		 *
		 * @type {string}
		 * @default 'anonymous'
		 */ this.crossOrigin = 'anonymous';
        /**
		 * Whether the XMLHttpRequest uses credentials.
		 *
		 * @type {boolean}
		 * @default false
		 */ this.withCredentials = false;
        /**
		 * The base path from which the asset will be loaded.
		 *
		 * @type {string}
		 */ this.path = '';
        /**
		 * The base path from which additional resources like textures will be loaded.
		 *
		 * @type {string}
		 */ this.resourcePath = '';
        /**
		 * The [request header]{@link https://developer.mozilla.org/en-US/docs/Glossary/Request_header}
		 * used in HTTP request.
		 *
		 * @type {Object<string, any>}
		 */ this.requestHeader = {};
    }
    /**
	 * This method needs to be implemented by all concrete loaders. It holds the
	 * logic for loading assets from the backend.
	 *
	 * @param {string} url - The path/URL of the file to be loaded.
	 * @param {Function} onLoad - Executed when the loading process has been finished.
	 * @param {onProgressCallback} [onProgress] - Executed while the loading is in progress.
	 * @param {onErrorCallback} [onError] - Executed when errors occur.
	 */ load() {}
    /**
	 * A async version of {@link Loader#load}.
	 *
	 * @param {string} url - The path/URL of the file to be loaded.
	 * @param {onProgressCallback} [onProgress] - Executed while the loading is in progress.
	 * @return {Promise} A Promise that resolves when the asset has been loaded.
	 */ loadAsync(url, onProgress) {
        const scope = this;
        return new Promise(function(resolve, reject) {
            scope.load(url, resolve, onProgress, reject);
        });
    }
    /**
	 * This method needs to be implemented by all concrete loaders. It holds the
	 * logic for parsing the asset into three.js entities.
	 *
	 * @param {any} data - The data to parse.
	 */ parse() {}
    /**
	 * Sets the `crossOrigin` String to implement CORS for loading the URL
	 * from a different domain that allows CORS.
	 *
	 * @param {string} crossOrigin - The `crossOrigin` value.
	 * @return {Loader} A reference to this instance.
	 */ setCrossOrigin(crossOrigin) {
        this.crossOrigin = crossOrigin;
        return this;
    }
    /**
	 * Whether the XMLHttpRequest uses credentials such as cookies, authorization
	 * headers or TLS client certificates, see [XMLHttpRequest.withCredentials]{@link https://developer.mozilla.org/en-US/docs/Web/API/XMLHttpRequest/withCredentials}.
	 *
	 * Note: This setting has no effect if you are loading files locally or from the same domain.
	 *
	 * @param {boolean} value - The `withCredentials` value.
	 * @return {Loader} A reference to this instance.
	 */ setWithCredentials(value) {
        this.withCredentials = value;
        return this;
    }
    /**
	 * Sets the base path for the asset.
	 *
	 * @param {string} path - The base path.
	 * @return {Loader} A reference to this instance.
	 */ setPath(path) {
        this.path = path;
        return this;
    }
    /**
	 * Sets the base path for dependent resources like textures.
	 *
	 * @param {string} resourcePath - The resource path.
	 * @return {Loader} A reference to this instance.
	 */ setResourcePath(resourcePath) {
        this.resourcePath = resourcePath;
        return this;
    }
    /**
	 * Sets the given request header.
	 *
	 * @param {Object} requestHeader - A [request header]{@link https://developer.mozilla.org/en-US/docs/Glossary/Request_header}
	 * for configuring the HTTP request.
	 * @return {Loader} A reference to this instance.
	 */ setRequestHeader(requestHeader) {
        this.requestHeader = requestHeader;
        return this;
    }
}
/**
 * Callback for onProgress in loaders.
 *
 * @callback onProgressCallback
 * @param {ProgressEvent} event - An instance of `ProgressEvent` that represents the current loading status.
 */ /**
 * Callback for onError in loaders.
 *
 * @callback onErrorCallback
 * @param {Error} error - The error which occurred during the loading process.
 */ /**
 * The default material name that is used by loaders
 * when creating materials for loaded 3D objects.
 *
 * Note: Not all loaders might honor this setting.
 *
 * @static
 * @type {string}
 * @default '__DEFAULT'
 */ $9ddd7e9b53f7a2d4$export$3b0d6d7590275603.DEFAULT_MATERIAL_NAME = '__DEFAULT';
const $9ddd7e9b53f7a2d4$var$loading = {};
class $9ddd7e9b53f7a2d4$var$HttpError extends Error {
    constructor(message, response){
        super(message);
        this.response = response;
    }
}
/**
 * A low level class for loading resources with the Fetch API, used internally by
 * most loaders. It can also be used directly to load any file type that does
 * not have a loader.
 *
 * This loader supports caching. If you want to use it, add `THREE.Cache.enabled = true;`
 * once to your application.
 *
 * ```js
 * const loader = new THREE.FileLoader();
 * const data = await loader.loadAsync( 'example.txt' );
 * ```
 *
 * @augments Loader
 */ class $9ddd7e9b53f7a2d4$export$98435a25b5cf7b2b extends $9ddd7e9b53f7a2d4$export$3b0d6d7590275603 {
    /**
	 * Constructs a new file loader.
	 *
	 * @param {LoadingManager} [manager] - The loading manager.
	 */ constructor(manager){
        super(manager);
        /**
		 * The expected mime type.
		 *
		 * @type {string}
		 */ this.mimeType = '';
        /**
		 * The expected response type.
		 *
		 * @type {('arraybuffer'|'blob'|'document'|'json'|'')}
		 * @default ''
		 */ this.responseType = '';
    }
    /**
	 * Starts loading from the given URL and pass the loaded response to the `onLoad()` callback.
	 *
	 * @param {string} url - The path/URL of the file to be loaded. This can also be a data URI.
	 * @param {function(any)} onLoad - Executed when the loading process has been finished.
	 * @param {onProgressCallback} [onProgress] - Executed while the loading is in progress.
	 * @param {onErrorCallback} [onError] - Executed when errors occur.
	 * @return {any|undefined} The cached resource if available.
	 */ load(url, onLoad, onProgress, onError) {
        if (url === undefined) url = '';
        if (this.path !== undefined) url = this.path + url;
        url = this.manager.resolveURL(url);
        const cached = $9ddd7e9b53f7a2d4$export$94affb487e701bf2.get(url);
        if (cached !== undefined) {
            this.manager.itemStart(url);
            setTimeout(()=>{
                if (onLoad) onLoad(cached);
                this.manager.itemEnd(url);
            }, 0);
            return cached;
        }
        // Check if request is duplicate
        if ($9ddd7e9b53f7a2d4$var$loading[url] !== undefined) {
            $9ddd7e9b53f7a2d4$var$loading[url].push({
                onLoad: onLoad,
                onProgress: onProgress,
                onError: onError
            });
            return;
        }
        // Initialise array for duplicate requests
        $9ddd7e9b53f7a2d4$var$loading[url] = [];
        $9ddd7e9b53f7a2d4$var$loading[url].push({
            onLoad: onLoad,
            onProgress: onProgress,
            onError: onError
        });
        // create request
        const req = new Request(url, {
            headers: new Headers(this.requestHeader),
            credentials: this.withCredentials ? 'include' : 'same-origin'
        });
        // record states ( avoid data race )
        const mimeType = this.mimeType;
        const responseType = this.responseType;
        // start the fetch
        fetch(req).then((response)=>{
            if (response.status === 200 || response.status === 0) {
                // Some browsers return HTTP Status 0 when using non-http protocol
                // e.g. 'file://' or 'data://'. Handle as success.
                if (response.status === 0) console.warn('THREE.FileLoader: HTTP Status 0 received.');
                // Workaround: Checking if response.body === undefined for Alipay browser #23548
                if (typeof ReadableStream === 'undefined' || response.body === undefined || response.body.getReader === undefined) return response;
                const callbacks = $9ddd7e9b53f7a2d4$var$loading[url];
                const reader = response.body.getReader();
                // Nginx needs X-File-Size check
                // https://serverfault.com/questions/482875/why-does-nginx-remove-content-length-header-for-chunked-content
                const contentLength = response.headers.get('X-File-Size') || response.headers.get('Content-Length');
                const total = contentLength ? parseInt(contentLength) : 0;
                const lengthComputable = total !== 0;
                let loaded = 0;
                // periodically read data into the new stream tracking while download progress
                const stream = new ReadableStream({
                    start (controller) {
                        readData();
                        function readData() {
                            reader.read().then(({ done: done, value: value })=>{
                                if (done) controller.close();
                                else {
                                    loaded += value.byteLength;
                                    const event = new ProgressEvent('progress', {
                                        lengthComputable: lengthComputable,
                                        loaded: loaded,
                                        total: total
                                    });
                                    for(let i = 0, il = callbacks.length; i < il; i++){
                                        const callback = callbacks[i];
                                        if (callback.onProgress) callback.onProgress(event);
                                    }
                                    controller.enqueue(value);
                                    readData();
                                }
                            }, (e)=>{
                                controller.error(e);
                            });
                        }
                    }
                });
                return new Response(stream);
            } else throw new $9ddd7e9b53f7a2d4$var$HttpError(`fetch for "${response.url}" responded with ${response.status}: ${response.statusText}`, response);
        }).then((response)=>{
            switch(responseType){
                case 'arraybuffer':
                    return response.arrayBuffer();
                case 'blob':
                    return response.blob();
                case 'document':
                    return response.text().then((text)=>{
                        const parser = new DOMParser();
                        return parser.parseFromString(text, mimeType);
                    });
                case 'json':
                    return response.json();
                default:
                    if (mimeType === '') return response.text();
                    else {
                        // sniff encoding
                        const re = /charset="?([^;"\s]*)"?/i;
                        const exec = re.exec(mimeType);
                        const label = exec && exec[1] ? exec[1].toLowerCase() : undefined;
                        const decoder = new TextDecoder(label);
                        return response.arrayBuffer().then((ab)=>decoder.decode(ab));
                    }
            }
        }).then((data)=>{
            // Add to cache only on HTTP success, so that we do not cache
            // error response bodies as proper responses to requests.
            $9ddd7e9b53f7a2d4$export$94affb487e701bf2.add(url, data);
            const callbacks = $9ddd7e9b53f7a2d4$var$loading[url];
            delete $9ddd7e9b53f7a2d4$var$loading[url];
            for(let i = 0, il = callbacks.length; i < il; i++){
                const callback = callbacks[i];
                if (callback.onLoad) callback.onLoad(data);
            }
        }).catch((err)=>{
            // Abort errors and other errors are handled the same
            const callbacks = $9ddd7e9b53f7a2d4$var$loading[url];
            if (callbacks === undefined) {
                // When onLoad was called and url was deleted in `loading`
                this.manager.itemError(url);
                throw err;
            }
            delete $9ddd7e9b53f7a2d4$var$loading[url];
            for(let i = 0, il = callbacks.length; i < il; i++){
                const callback = callbacks[i];
                if (callback.onError) callback.onError(err);
            }
            this.manager.itemError(url);
        }).finally(()=>{
            this.manager.itemEnd(url);
        });
        this.manager.itemStart(url);
    }
    /**
	 * Sets the expected response type.
	 *
	 * @param {('arraybuffer'|'blob'|'document'|'json'|'')} value - The response type.
	 * @return {FileLoader} A reference to this file loader.
	 */ setResponseType(value) {
        this.responseType = value;
        return this;
    }
    /**
	 * Sets the expected mime type of the loaded file.
	 *
	 * @param {string} value - The mime type.
	 * @return {FileLoader} A reference to this file loader.
	 */ setMimeType(value) {
        this.mimeType = value;
        return this;
    }
}
/**
 * Class for loading animation clips in the JSON format. The files are internally
 * loaded via {@link FileLoader}.
 *
 * ```js
 * const loader = new THREE.AnimationLoader();
 * const animations = await loader.loadAsync( 'animations/animation.js' );
 * ```
 *
 * @augments Loader
 */ class $9ddd7e9b53f7a2d4$export$29711c7e14f61db extends $9ddd7e9b53f7a2d4$export$3b0d6d7590275603 {
    /**
	 * Constructs a new animation loader.
	 *
	 * @param {LoadingManager} [manager] - The loading manager.
	 */ constructor(manager){
        super(manager);
    }
    /**
	 * Starts loading from the given URL and pass the loaded animations as an array
	 * holding instances of {@link AnimationClip} to the `onLoad()` callback.
	 *
	 * @param {string} url - The path/URL of the file to be loaded. This can also be a data URI.
	 * @param {function(Array<AnimationClip>)} onLoad - Executed when the loading process has been finished.
	 * @param {onProgressCallback} onProgress - Executed while the loading is in progress.
	 * @param {onErrorCallback} onError - Executed when errors occur.
	 */ load(url, onLoad, onProgress, onError) {
        const scope = this;
        const loader = new $9ddd7e9b53f7a2d4$export$98435a25b5cf7b2b(this.manager);
        loader.setPath(this.path);
        loader.setRequestHeader(this.requestHeader);
        loader.setWithCredentials(this.withCredentials);
        loader.load(url, function(text) {
            try {
                onLoad(scope.parse(JSON.parse(text)));
            } catch (e) {
                if (onError) onError(e);
                else console.error(e);
                scope.manager.itemError(url);
            }
        }, onProgress, onError);
    }
    /**
	 * Parses the given JSON object and returns an array of animation clips.
	 *
	 * @param {Object} json - The serialized animation clips.
	 * @return {Array<AnimationClip>} The parsed animation clips.
	 */ parse(json) {
        const animations = [];
        for(let i = 0; i < json.length; i++){
            const clip = $9ddd7e9b53f7a2d4$export$d942c706bf23829c.parse(json[i]);
            animations.push(clip);
        }
        return animations;
    }
}
/**
 * Abstract base class for loading compressed texture formats S3TC, ASTC or ETC.
 * Textures are internally loaded via {@link FileLoader}.
 *
 * Derived classes have to implement the `parse()` method which holds the parsing
 * for the respective format.
 *
 * @abstract
 * @augments Loader
 */ class $9ddd7e9b53f7a2d4$export$bd73ce947a280350 extends $9ddd7e9b53f7a2d4$export$3b0d6d7590275603 {
    /**
	 * Constructs a new compressed texture loader.
	 *
	 * @param {LoadingManager} [manager] - The loading manager.
	 */ constructor(manager){
        super(manager);
    }
    /**
	 * Starts loading from the given URL and passes the loaded compressed texture
	 * to the `onLoad()` callback. The method also returns a new texture object which can
	 * directly be used for material creation. If you do it this way, the texture
	 * may pop up in your scene once the respective loading process is finished.
	 *
	 * @param {string} url - The path/URL of the file to be loaded. This can also be a data URI.
	 * @param {function(CompressedTexture)} onLoad - Executed when the loading process has been finished.
	 * @param {onProgressCallback} onProgress - Executed while the loading is in progress.
	 * @param {onErrorCallback} onError - Executed when errors occur.
	 * @return {CompressedTexture} The compressed texture.
	 */ load(url, onLoad, onProgress, onError) {
        const scope = this;
        const images = [];
        const texture = new $9ddd7e9b53f7a2d4$export$3466bac9141a5cc4();
        const loader = new $9ddd7e9b53f7a2d4$export$98435a25b5cf7b2b(this.manager);
        loader.setPath(this.path);
        loader.setResponseType('arraybuffer');
        loader.setRequestHeader(this.requestHeader);
        loader.setWithCredentials(scope.withCredentials);
        let loaded = 0;
        function loadTexture(i) {
            loader.load(url[i], function(buffer) {
                const texDatas = scope.parse(buffer, true);
                images[i] = {
                    width: texDatas.width,
                    height: texDatas.height,
                    format: texDatas.format,
                    mipmaps: texDatas.mipmaps
                };
                loaded += 1;
                if (loaded === 6) {
                    if (texDatas.mipmapCount === 1) texture.minFilter = $9ddd7e9b53f7a2d4$export$8a72f490b25c56c8;
                    texture.image = images;
                    texture.format = texDatas.format;
                    texture.needsUpdate = true;
                    if (onLoad) onLoad(texture);
                }
            }, onProgress, onError);
        }
        if (Array.isArray(url)) for(let i = 0, il = url.length; i < il; ++i)loadTexture(i);
        else // compressed cubemap texture stored in a single DDS file
        loader.load(url, function(buffer) {
            const texDatas = scope.parse(buffer, true);
            if (texDatas.isCubemap) {
                const faces = texDatas.mipmaps.length / texDatas.mipmapCount;
                for(let f = 0; f < faces; f++){
                    images[f] = {
                        mipmaps: []
                    };
                    for(let i = 0; i < texDatas.mipmapCount; i++){
                        images[f].mipmaps.push(texDatas.mipmaps[f * texDatas.mipmapCount + i]);
                        images[f].format = texDatas.format;
                        images[f].width = texDatas.width;
                        images[f].height = texDatas.height;
                    }
                }
                texture.image = images;
            } else {
                texture.image.width = texDatas.width;
                texture.image.height = texDatas.height;
                texture.mipmaps = texDatas.mipmaps;
            }
            if (texDatas.mipmapCount === 1) texture.minFilter = $9ddd7e9b53f7a2d4$export$8a72f490b25c56c8;
            texture.format = texDatas.format;
            texture.needsUpdate = true;
            if (onLoad) onLoad(texture);
        }, onProgress, onError);
        return texture;
    }
}
/**
 * A loader for loading images. The class loads images with the HTML `Image` API.
 *
 * ```js
 * const loader = new THREE.ImageLoader();
 * const image = await loader.loadAsync( 'image.png' );
 * ```
 * Please note that `ImageLoader` has dropped support for progress
 * events in `r84`. For an `ImageLoader` that supports progress events, see
 * [this thread]{@link https://github.com/mrdoob/three.js/issues/10439#issuecomment-275785639}.
 *
 * @augments Loader
 */ class $9ddd7e9b53f7a2d4$export$8905ce1c7a2464a1 extends $9ddd7e9b53f7a2d4$export$3b0d6d7590275603 {
    /**
	 * Constructs a new image loader.
	 *
	 * @param {LoadingManager} [manager] - The loading manager.
	 */ constructor(manager){
        super(manager);
    }
    /**
	 * Starts loading from the given URL and passes the loaded image
	 * to the `onLoad()` callback. The method also returns a new `Image` object which can
	 * directly be used for texture creation. If you do it this way, the texture
	 * may pop up in your scene once the respective loading process is finished.
	 *
	 * @param {string} url - The path/URL of the file to be loaded. This can also be a data URI.
	 * @param {function(Image)} onLoad - Executed when the loading process has been finished.
	 * @param {onProgressCallback} onProgress - Unsupported in this loader.
	 * @param {onErrorCallback} onError - Executed when errors occur.
	 * @return {Image} The image.
	 */ load(url, onLoad, onProgress, onError) {
        if (this.path !== undefined) url = this.path + url;
        url = this.manager.resolveURL(url);
        const scope = this;
        const cached = $9ddd7e9b53f7a2d4$export$94affb487e701bf2.get(url);
        if (cached !== undefined) {
            scope.manager.itemStart(url);
            setTimeout(function() {
                if (onLoad) onLoad(cached);
                scope.manager.itemEnd(url);
            }, 0);
            return cached;
        }
        const image = $9ddd7e9b53f7a2d4$export$7094a064528c7fee('img');
        function onImageLoad() {
            removeEventListeners();
            $9ddd7e9b53f7a2d4$export$94affb487e701bf2.add(url, this);
            if (onLoad) onLoad(this);
            scope.manager.itemEnd(url);
        }
        function onImageError(event) {
            removeEventListeners();
            if (onError) onError(event);
            scope.manager.itemError(url);
            scope.manager.itemEnd(url);
        }
        function removeEventListeners() {
            image.removeEventListener('load', onImageLoad, false);
            image.removeEventListener('error', onImageError, false);
        }
        image.addEventListener('load', onImageLoad, false);
        image.addEventListener('error', onImageError, false);
        if (url.slice(0, 5) !== 'data:') {
            if (this.crossOrigin !== undefined) image.crossOrigin = this.crossOrigin;
        }
        scope.manager.itemStart(url);
        image.src = url;
        return image;
    }
}
/**
 * Class for loading cube textures. Images are internally loaded via {@link ImageLoader}.
 *
 * The loader returns an instance of {@link CubeTexture} and expects the cube map to
 * be defined as six separate images representing the sides of a cube. Other cube map definitions
 * like vertical and horizontal cross, column and row layouts are not supported.
 *
 * Note that, by convention, cube maps are specified in a coordinate system
 * in which positive-x is to the right when looking up the positive-z axis --
 * in other words, using a left-handed coordinate system. Since three.js uses
 * a right-handed coordinate system, environment maps used in three.js will
 * have pos-x and neg-x swapped.
 *
 * The loaded cube texture is in sRGB color space. Meaning {@link Texture#colorSpace}
 * is set to `SRGBColorSpace` by default.
 *
 * ```js
 * const loader = new THREE.CubeTextureLoader().setPath( 'textures/cubeMaps/' );
 * const cubeTexture = await loader.loadAsync( [
 * 	'px.png', 'nx.png', 'py.png', 'ny.png', 'pz.png', 'nz.png'
 * ] );
 * scene.background = cubeTexture;
 * ```
 *
 * @augments Loader
 */ class $9ddd7e9b53f7a2d4$export$2ec114afc2cf6308 extends $9ddd7e9b53f7a2d4$export$3b0d6d7590275603 {
    /**
	 * Constructs a new cube texture loader.
	 *
	 * @param {LoadingManager} [manager] - The loading manager.
	 */ constructor(manager){
        super(manager);
    }
    /**
	 * Starts loading from the given URL and pass the fully loaded cube texture
	 * to the `onLoad()` callback. The method also returns a new cube texture object which can
	 * directly be used for material creation. If you do it this way, the cube texture
	 * may pop up in your scene once the respective loading process is finished.
	 *
	 * @param {Array<string>} urls - Array of 6 URLs to images, one for each side of the
	 * cube texture. The urls should be specified in the following order: pos-x,
	 * neg-x, pos-y, neg-y, pos-z, neg-z. An array of data URIs are allowed as well.
	 * @param {function(CubeTexture)} onLoad - Executed when the loading process has been finished.
	 * @param {onProgressCallback} onProgress - Unsupported in this loader.
	 * @param {onErrorCallback} onError - Executed when errors occur.
	 * @return {CubeTexture} The cube texture.
	 */ load(urls, onLoad, onProgress, onError) {
        const texture = new $9ddd7e9b53f7a2d4$export$ee2e5a18258a4049();
        texture.colorSpace = $9ddd7e9b53f7a2d4$export$561f394b24edfcaa;
        const loader = new $9ddd7e9b53f7a2d4$export$8905ce1c7a2464a1(this.manager);
        loader.setCrossOrigin(this.crossOrigin);
        loader.setPath(this.path);
        let loaded = 0;
        function loadTexture(i) {
            loader.load(urls[i], function(image) {
                texture.images[i] = image;
                loaded++;
                if (loaded === 6) {
                    texture.needsUpdate = true;
                    if (onLoad) onLoad(texture);
                }
            }, undefined, onError);
        }
        for(let i = 0; i < urls.length; ++i)loadTexture(i);
        return texture;
    }
}
/**
 * Abstract base class for loading binary texture formats RGBE, EXR or TGA.
 * Textures are internally loaded via {@link FileLoader}.
 *
 * Derived classes have to implement the `parse()` method which holds the parsing
 * for the respective format.
 *
 * @abstract
 * @augments Loader
 */ class $9ddd7e9b53f7a2d4$export$792d8a18f2c55855 extends $9ddd7e9b53f7a2d4$export$3b0d6d7590275603 {
    /**
	 * Constructs a new data texture loader.
	 *
	 * @param {LoadingManager} [manager] - The loading manager.
	 */ constructor(manager){
        super(manager);
    }
    /**
	 * Starts loading from the given URL and passes the loaded data texture
	 * to the `onLoad()` callback. The method also returns a new texture object which can
	 * directly be used for material creation. If you do it this way, the texture
	 * may pop up in your scene once the respective loading process is finished.
	 *
	 * @param {string} url - The path/URL of the file to be loaded. This can also be a data URI.
	 * @param {function(DataTexture)} onLoad - Executed when the loading process has been finished.
	 * @param {onProgressCallback} onProgress - Executed while the loading is in progress.
	 * @param {onErrorCallback} onError - Executed when errors occur.
	 * @return {DataTexture} The data texture.
	 */ load(url, onLoad, onProgress, onError) {
        const scope = this;
        const texture = new $9ddd7e9b53f7a2d4$export$b691f601014eabe1();
        const loader = new $9ddd7e9b53f7a2d4$export$98435a25b5cf7b2b(this.manager);
        loader.setResponseType('arraybuffer');
        loader.setRequestHeader(this.requestHeader);
        loader.setPath(this.path);
        loader.setWithCredentials(scope.withCredentials);
        loader.load(url, function(buffer) {
            let texData;
            try {
                texData = scope.parse(buffer);
            } catch (error) {
                if (onError !== undefined) onError(error);
                else {
                    console.error(error);
                    return;
                }
            }
            if (texData.image !== undefined) texture.image = texData.image;
            else if (texData.data !== undefined) {
                texture.image.width = texData.width;
                texture.image.height = texData.height;
                texture.image.data = texData.data;
            }
            texture.wrapS = texData.wrapS !== undefined ? texData.wrapS : $9ddd7e9b53f7a2d4$export$9d9334239a5a5e06;
            texture.wrapT = texData.wrapT !== undefined ? texData.wrapT : $9ddd7e9b53f7a2d4$export$9d9334239a5a5e06;
            texture.magFilter = texData.magFilter !== undefined ? texData.magFilter : $9ddd7e9b53f7a2d4$export$8a72f490b25c56c8;
            texture.minFilter = texData.minFilter !== undefined ? texData.minFilter : $9ddd7e9b53f7a2d4$export$8a72f490b25c56c8;
            texture.anisotropy = texData.anisotropy !== undefined ? texData.anisotropy : 1;
            if (texData.colorSpace !== undefined) texture.colorSpace = texData.colorSpace;
            if (texData.flipY !== undefined) texture.flipY = texData.flipY;
            if (texData.format !== undefined) texture.format = texData.format;
            if (texData.type !== undefined) texture.type = texData.type;
            if (texData.mipmaps !== undefined) {
                texture.mipmaps = texData.mipmaps;
                texture.minFilter = $9ddd7e9b53f7a2d4$export$5d8599b6a933fb1b; // presumably...
            }
            if (texData.mipmapCount === 1) texture.minFilter = $9ddd7e9b53f7a2d4$export$8a72f490b25c56c8;
            if (texData.generateMipmaps !== undefined) texture.generateMipmaps = texData.generateMipmaps;
            texture.needsUpdate = true;
            if (onLoad) onLoad(texture, texData);
        }, onProgress, onError);
        return texture;
    }
}
/**
 * Class for loading textures. Images are internally
 * loaded via {@link ImageLoader}.
 *
 * ```js
 * const loader = new THREE.TextureLoader();
 * const texture = await loader.loadAsync( 'textures/land_ocean_ice_cloud_2048.jpg' );
 *
 * const material = new THREE.MeshBasicMaterial( { map:texture } );
 * ```
 * Please note that `TextureLoader` has dropped support for progress
 * events in `r84`. For a `TextureLoader` that supports progress events, see
 * [this thread]{@link https://github.com/mrdoob/three.js/issues/10439#issuecomment-293260145}.
 *
 * @augments Loader
 */ class $9ddd7e9b53f7a2d4$export$fd1bfc71f64c538c extends $9ddd7e9b53f7a2d4$export$3b0d6d7590275603 {
    /**
	 * Constructs a new texture loader.
	 *
	 * @param {LoadingManager} [manager] - The loading manager.
	 */ constructor(manager){
        super(manager);
    }
    /**
	 * Starts loading from the given URL and pass the fully loaded texture
	 * to the `onLoad()` callback. The method also returns a new texture object which can
	 * directly be used for material creation. If you do it this way, the texture
	 * may pop up in your scene once the respective loading process is finished.
	 *
	 * @param {string} url - The path/URL of the file to be loaded. This can also be a data URI.
	 * @param {function(Texture)} onLoad - Executed when the loading process has been finished.
	 * @param {onProgressCallback} onProgress - Unsupported in this loader.
	 * @param {onErrorCallback} onError - Executed when errors occur.
	 * @return {Texture} The texture.
	 */ load(url, onLoad, onProgress, onError) {
        const texture = new $9ddd7e9b53f7a2d4$export$5431306cf43de24a();
        const loader = new $9ddd7e9b53f7a2d4$export$8905ce1c7a2464a1(this.manager);
        loader.setCrossOrigin(this.crossOrigin);
        loader.setPath(this.path);
        loader.load(url, function(image) {
            texture.image = image;
            texture.needsUpdate = true;
            if (onLoad !== undefined) onLoad(texture);
        }, onProgress, onError);
        return texture;
    }
}
/**
 * Abstract base class for lights - all other light types inherit the
 * properties and methods described here.
 *
 * @abstract
 * @augments Object3D
 */ class $9ddd7e9b53f7a2d4$export$6ecadb6ed240d696 extends $9ddd7e9b53f7a2d4$export$e4dd07dff30cc924 {
    /**
	 * Constructs a new light.
	 *
	 * @param {(number|Color|string)} [color=0xffffff] - The light's color.
	 * @param {number} [intensity=1] - The light's strength/intensity.
	 */ constructor(color, intensity = 1){
        super();
        /**
		 * This flag can be used for type testing.
		 *
		 * @type {boolean}
		 * @readonly
		 * @default true
		 */ this.isLight = true;
        this.type = 'Light';
        /**
		 * The light's color.
		 *
		 * @type {Color}
		 */ this.color = new $9ddd7e9b53f7a2d4$export$892596cec99bc70e(color);
        /**
		 * The light's intensity.
		 *
		 * @type {number}
		 * @default 1
		 */ this.intensity = intensity;
    }
    /**
	 * Frees the GPU-related resources allocated by this instance. Call this
	 * method whenever this instance is no longer used in your app.
	 */ dispose() {
    // Empty here in base class; some subclasses override.
    }
    copy(source, recursive) {
        super.copy(source, recursive);
        this.color.copy(source.color);
        this.intensity = source.intensity;
        return this;
    }
    toJSON(meta) {
        const data = super.toJSON(meta);
        data.object.color = this.color.getHex();
        data.object.intensity = this.intensity;
        if (this.groundColor !== undefined) data.object.groundColor = this.groundColor.getHex();
        if (this.distance !== undefined) data.object.distance = this.distance;
        if (this.angle !== undefined) data.object.angle = this.angle;
        if (this.decay !== undefined) data.object.decay = this.decay;
        if (this.penumbra !== undefined) data.object.penumbra = this.penumbra;
        if (this.shadow !== undefined) data.object.shadow = this.shadow.toJSON();
        if (this.target !== undefined) data.object.target = this.target.uuid;
        return data;
    }
}
/**
 * A light source positioned directly above the scene, with color fading from
 * the sky color to the ground color.
 *
 * This light cannot be used to cast shadows.
 *
 * ```js
 * const light = new THREE.HemisphereLight( 0xffffbb, 0x080820, 1 );
 * scene.add( light );
 * ```
 *
 * @augments Light
 */ class $9ddd7e9b53f7a2d4$export$8d474f55edbb9624 extends $9ddd7e9b53f7a2d4$export$6ecadb6ed240d696 {
    /**
	 * Constructs a new hemisphere light.
	 *
	 * @param {(number|Color|string)} [skyColor=0xffffff] - The light's sky color.
	 * @param {(number|Color|string)} [groundColor=0xffffff] - The light's ground color.
	 * @param {number} [intensity=1] - The light's strength/intensity.
	 */ constructor(skyColor, groundColor, intensity){
        super(skyColor, intensity);
        /**
		 * This flag can be used for type testing.
		 *
		 * @type {boolean}
		 * @readonly
		 * @default true
		 */ this.isHemisphereLight = true;
        this.type = 'HemisphereLight';
        this.position.copy($9ddd7e9b53f7a2d4$export$e4dd07dff30cc924.DEFAULT_UP);
        this.updateMatrix();
        /**
		 * The light's ground color.
		 *
		 * @type {Color}
		 */ this.groundColor = new $9ddd7e9b53f7a2d4$export$892596cec99bc70e(groundColor);
    }
    copy(source, recursive) {
        super.copy(source, recursive);
        this.groundColor.copy(source.groundColor);
        return this;
    }
}
const $9ddd7e9b53f7a2d4$var$_projScreenMatrix$1 = /*@__PURE__*/ new $9ddd7e9b53f7a2d4$export$2ae72fc923e5eb5();
const $9ddd7e9b53f7a2d4$var$_lightPositionWorld$1 = /*@__PURE__*/ new $9ddd7e9b53f7a2d4$export$64b5c384219d3699();
const $9ddd7e9b53f7a2d4$var$_lookTarget$1 = /*@__PURE__*/ new $9ddd7e9b53f7a2d4$export$64b5c384219d3699();
/**
 * Abstract base class for light shadow classes. These classes
 * represent the shadow configuration for different light types.
 *
 * @abstract
 */ class $9ddd7e9b53f7a2d4$var$LightShadow {
    /**
	 * Constructs a new light shadow.
	 *
	 * @param {Camera} camera - The light's view of the world.
	 */ constructor(camera){
        /**
		 * The light's view of the world.
		 *
		 * @type {Camera}
		 */ this.camera = camera;
        /**
		 * The intensity of the shadow. The default is `1`.
		 * Valid values are in the range `[0, 1]`.
		 *
		 * @type {number}
		 * @default 1
		 */ this.intensity = 1;
        /**
		 * Shadow map bias, how much to add or subtract from the normalized depth
		 * when deciding whether a surface is in shadow.
		 *
		 * The default is `0`. Very tiny adjustments here (in the order of `0.0001`)
		 * may help reduce artifacts in shadows.
		 *
		 * @type {number}
		 * @default 0
		 */ this.bias = 0;
        /**
		 * Defines how much the position used to query the shadow map is offset along
		 * the object normal. The default is `0`. Increasing this value can be used to
		 * reduce shadow acne especially in large scenes where light shines onto
		 * geometry at a shallow angle. The cost is that shadows may appear distorted.
		 *
		 * @type {number}
		 * @default 0
		 */ this.normalBias = 0;
        /**
		 * Setting this to values greater than 1 will blur the edges of the shadow.
		 * High values will cause unwanted banding effects in the shadows - a greater
		 * map size will allow for a higher value to be used here before these effects
		 * become visible.
		 *
		 * The property has no effect when the shadow map type is `PCFSoftShadowMap` and
		 * and it is recommended to increase softness by decreasing the shadow map size instead.
		 *
		 * The property has no effect when the shadow map type is `BasicShadowMap`.
		 *
		 * @type {number}
		 * @default 1
		 */ this.radius = 1;
        /**
		 * The amount of samples to use when blurring a VSM shadow map.
		 *
		 * @type {number}
		 * @default 8
		 */ this.blurSamples = 8;
        /**
		 * Defines the width and height of the shadow map. Higher values give better quality
		 * shadows at the cost of computation time. Values must be powers of two.
		 *
		 * @type {Vector2}
		 * @default (512,512)
		 */ this.mapSize = new $9ddd7e9b53f7a2d4$export$c977b3e384af9ae1(512, 512);
        /**
		 * The depth map generated using the internal camera; a location beyond a
		 * pixel's depth is in shadow. Computed internally during rendering.
		 *
		 * @type {?RenderTarget}
		 * @default null
		 */ this.map = null;
        /**
		 * The distribution map generated using the internal camera; an occlusion is
		 * calculated based on the distribution of depths. Computed internally during
		 * rendering.
		 *
		 * @type {?RenderTarget}
		 * @default null
		 */ this.mapPass = null;
        /**
		 * Model to shadow camera space, to compute location and depth in shadow map.
		 * This is computed internally during rendering.
		 *
		 * @type {Matrix4}
		 */ this.matrix = new $9ddd7e9b53f7a2d4$export$2ae72fc923e5eb5();
        /**
		 * Enables automatic updates of the light's shadow. If you do not require dynamic
		 * lighting / shadows, you may set this to `false`.
		 *
		 * @type {boolean}
		 * @default true
		 */ this.autoUpdate = true;
        /**
		 * When set to `true`, shadow maps will be updated in the next `render` call.
		 * If you have set {@link LightShadow#autoUpdate} to `false`, you will need to
		 * set this property to `true` and then make a render call to update the light's shadow.
		 *
		 * @type {boolean}
		 * @default false
		 */ this.needsUpdate = false;
        this._frustum = new $9ddd7e9b53f7a2d4$export$35efe6f4c85463d2();
        this._frameExtents = new $9ddd7e9b53f7a2d4$export$c977b3e384af9ae1(1, 1);
        this._viewportCount = 1;
        this._viewports = [
            new $9ddd7e9b53f7a2d4$export$fa7daccca11cdbe3(0, 0, 1, 1)
        ];
    }
    /**
	 * Used internally by the renderer to get the number of viewports that need
	 * to be rendered for this shadow.
	 *
	 * @return {number} The viewport count.
	 */ getViewportCount() {
        return this._viewportCount;
    }
    /**
	 * Gets the shadow cameras frustum. Used internally by the renderer to cull objects.
	 *
	 * @return {Frustum} The shadow camera frustum.
	 */ getFrustum() {
        return this._frustum;
    }
    /**
	 * Update the matrices for the camera and shadow, used internally by the renderer.
	 *
	 * @param {Light} light - The light for which the shadow is being rendered.
	 */ updateMatrices(light) {
        const shadowCamera = this.camera;
        const shadowMatrix = this.matrix;
        $9ddd7e9b53f7a2d4$var$_lightPositionWorld$1.setFromMatrixPosition(light.matrixWorld);
        shadowCamera.position.copy($9ddd7e9b53f7a2d4$var$_lightPositionWorld$1);
        $9ddd7e9b53f7a2d4$var$_lookTarget$1.setFromMatrixPosition(light.target.matrixWorld);
        shadowCamera.lookAt($9ddd7e9b53f7a2d4$var$_lookTarget$1);
        shadowCamera.updateMatrixWorld();
        $9ddd7e9b53f7a2d4$var$_projScreenMatrix$1.multiplyMatrices(shadowCamera.projectionMatrix, shadowCamera.matrixWorldInverse);
        this._frustum.setFromProjectionMatrix($9ddd7e9b53f7a2d4$var$_projScreenMatrix$1);
        shadowMatrix.set(0.5, 0.0, 0.0, 0.5, 0.0, 0.5, 0.0, 0.5, 0.0, 0.0, 0.5, 0.5, 0.0, 0.0, 0.0, 1.0);
        shadowMatrix.multiply($9ddd7e9b53f7a2d4$var$_projScreenMatrix$1);
    }
    /**
	 * Returns a viewport definition for the given viewport index.
	 *
	 * @param {number} viewportIndex - The viewport index.
	 * @return {Vector4} The viewport.
	 */ getViewport(viewportIndex) {
        return this._viewports[viewportIndex];
    }
    /**
	 * Returns the frame extends.
	 *
	 * @return {Vector2} The frame extends.
	 */ getFrameExtents() {
        return this._frameExtents;
    }
    /**
	 * Frees the GPU-related resources allocated by this instance. Call this
	 * method whenever this instance is no longer used in your app.
	 */ dispose() {
        if (this.map) this.map.dispose();
        if (this.mapPass) this.mapPass.dispose();
    }
    /**
	 * Copies the values of the given light shadow instance to this instance.
	 *
	 * @param {LightShadow} source - The light shadow to copy.
	 * @return {LightShadow} A reference to this light shadow instance.
	 */ copy(source) {
        this.camera = source.camera.clone();
        this.intensity = source.intensity;
        this.bias = source.bias;
        this.radius = source.radius;
        this.mapSize.copy(source.mapSize);
        return this;
    }
    /**
	 * Returns a new light shadow instance with copied values from this instance.
	 *
	 * @return {LightShadow} A clone of this instance.
	 */ clone() {
        return new this.constructor().copy(this);
    }
    /**
	 * Serializes the light shadow into JSON.
	 *
	 * @return {Object} A JSON object representing the serialized light shadow.
	 * @see {@link ObjectLoader#parse}
	 */ toJSON() {
        const object = {};
        if (this.intensity !== 1) object.intensity = this.intensity;
        if (this.bias !== 0) object.bias = this.bias;
        if (this.normalBias !== 0) object.normalBias = this.normalBias;
        if (this.radius !== 1) object.radius = this.radius;
        if (this.mapSize.x !== 512 || this.mapSize.y !== 512) object.mapSize = this.mapSize.toArray();
        object.camera = this.camera.toJSON(false).object;
        delete object.camera.matrix;
        return object;
    }
}
/**
 * Represents the shadow configuration of directional lights.
 *
 * @augments LightShadow
 */ class $9ddd7e9b53f7a2d4$var$SpotLightShadow extends $9ddd7e9b53f7a2d4$var$LightShadow {
    /**
	 * Constructs a new spot light shadow.
	 */ constructor(){
        super(new $9ddd7e9b53f7a2d4$export$74e4ae24825f68d7(50, 1, 0.5, 500));
        /**
		 * This flag can be used for type testing.
		 *
		 * @type {boolean}
		 * @readonly
		 * @default true
		 */ this.isSpotLightShadow = true;
        /**
		 * Used to focus the shadow camera. The camera's field of view is set as a
		 * percentage of the spotlight's field-of-view. Range is `[0, 1]`.
		 *
		 * @type {number}
		 * @default 1
		 */ this.focus = 1;
    }
    updateMatrices(light) {
        const camera = this.camera;
        const fov = $9ddd7e9b53f7a2d4$export$914076c8150813e5 * 2 * light.angle * this.focus;
        const aspect = this.mapSize.width / this.mapSize.height;
        const far = light.distance || camera.far;
        if (fov !== camera.fov || aspect !== camera.aspect || far !== camera.far) {
            camera.fov = fov;
            camera.aspect = aspect;
            camera.far = far;
            camera.updateProjectionMatrix();
        }
        super.updateMatrices(light);
    }
    copy(source) {
        super.copy(source);
        this.focus = source.focus;
        return this;
    }
}
/**
 * This light gets emitted from a single point in one direction, along a cone
 * that increases in size the further from the light it gets.
 *
 * This light can cast shadows - see the {@link SpotLightShadow} for details.
 *
 * ```js
 * // white spotlight shining from the side, modulated by a texture
 * const spotLight = new THREE.SpotLight( 0xffffff );
 * spotLight.position.set( 100, 1000, 100 );
 * spotLight.map = new THREE.TextureLoader().load( url );
 *
 * spotLight.castShadow = true;
 * spotLight.shadow.mapSize.width = 1024;
 * spotLight.shadow.mapSize.height = 1024;
 * spotLight.shadow.camera.near = 500;
 * spotLight.shadow.camera.far = 4000;
 * spotLight.shadow.camera.fov = 30;s
 * ```
 *
 * @augments Light
 */ class $9ddd7e9b53f7a2d4$export$81495cbb73897362 extends $9ddd7e9b53f7a2d4$export$6ecadb6ed240d696 {
    /**
	 * Constructs a new spot light.
	 *
	 * @param {(number|Color|string)} [color=0xffffff] - The light's color.
	 * @param {number} [intensity=1] - The light's strength/intensity measured in candela (cd).
	 * @param {number} [distance=0] - Maximum range of the light. `0` means no limit.
	 * @param {number} [angle=Math.PI/3] - Maximum angle of light dispersion from its direction whose upper bound is `Math.PI/2`.
	 * @param {number} [penumbra=0] - Percent of the spotlight cone that is attenuated due to penumbra. Value range is `[0,1]`.
	 * @param {number} [decay=2] - The amount the light dims along the distance of the light.
	 */ constructor(color, intensity, distance = 0, angle = Math.PI / 3, penumbra = 0, decay = 2){
        super(color, intensity);
        /**
		 * This flag can be used for type testing.
		 *
		 * @type {boolean}
		 * @readonly
		 * @default true
		 */ this.isSpotLight = true;
        this.type = 'SpotLight';
        this.position.copy($9ddd7e9b53f7a2d4$export$e4dd07dff30cc924.DEFAULT_UP);
        this.updateMatrix();
        /**
		 * The spot light points from its position to the
		 * target's position.
		 *
		 * For the target's position to be changed to anything other
		 * than the default, it must be added to the scene.
		 *
		 * It is also possible to set the target to be another 3D object
		 * in the scene. The light will now track the target object.
		 *
		 * @type {Object3D}
		 */ this.target = new $9ddd7e9b53f7a2d4$export$e4dd07dff30cc924();
        /**
		 * Maximum range of the light. `0` means no limit.
		 *
		 * @type {number}
		 * @default 0
		 */ this.distance = distance;
        /**
		 * Maximum angle of light dispersion from its direction whose upper bound is `Math.PI/2`.
		 *
		 * @type {number}
		 * @default Math.PI/3
		 */ this.angle = angle;
        /**
		 * Percent of the spotlight cone that is attenuated due to penumbra.
		 * Value range is `[0,1]`.
		 *
		 * @type {number}
		 * @default 0
		 */ this.penumbra = penumbra;
        /**
		 * The amount the light dims along the distance of the light. In context of
		 * physically-correct rendering the default value should not be changed.
		 *
		 * @type {number}
		 * @default 2
		 */ this.decay = decay;
        /**
		 * A texture used to modulate the color of the light. The spot light
		 * color is mixed with the RGB value of this texture, with a ratio
		 * corresponding to its alpha value. The cookie-like masking effect is
		 * reproduced using pixel values (0, 0, 0, 1-cookie_value).
		 *
		 * *Warning*: This property is disabled if {@link Object3D#castShadow} is set to `false`.
		 *
		 * @type {?Texture}
		 * @default null
		 */ this.map = null;
        /**
		 * This property holds the light's shadow configuration.
		 *
		 * @type {SpotLightShadow}
		 */ this.shadow = new $9ddd7e9b53f7a2d4$var$SpotLightShadow();
    }
    /**
	 * The light's power. Power is the luminous power of the light measured in lumens (lm).
	 *  Changing the power will also change the light's intensity.
	 *
	 * @type {number}
	 */ get power() {
        // compute the light's luminous power (in lumens) from its intensity (in candela)
        // by convention for a spotlight, luminous power (lm) = π * luminous intensity (cd)
        return this.intensity * Math.PI;
    }
    set power(power) {
        // set the light's intensity (in candela) from the desired luminous power (in lumens)
        this.intensity = power / Math.PI;
    }
    dispose() {
        this.shadow.dispose();
    }
    copy(source, recursive) {
        super.copy(source, recursive);
        this.distance = source.distance;
        this.angle = source.angle;
        this.penumbra = source.penumbra;
        this.decay = source.decay;
        this.target = source.target.clone();
        this.shadow = source.shadow.clone();
        return this;
    }
}
const $9ddd7e9b53f7a2d4$var$_projScreenMatrix = /*@__PURE__*/ new $9ddd7e9b53f7a2d4$export$2ae72fc923e5eb5();
const $9ddd7e9b53f7a2d4$var$_lightPositionWorld = /*@__PURE__*/ new $9ddd7e9b53f7a2d4$export$64b5c384219d3699();
const $9ddd7e9b53f7a2d4$var$_lookTarget = /*@__PURE__*/ new $9ddd7e9b53f7a2d4$export$64b5c384219d3699();
/**
 * Represents the shadow configuration of point lights.
 *
 * @augments LightShadow
 */ class $9ddd7e9b53f7a2d4$var$PointLightShadow extends $9ddd7e9b53f7a2d4$var$LightShadow {
    /**
	 * Constructs a new point light shadow.
	 */ constructor(){
        super(new $9ddd7e9b53f7a2d4$export$74e4ae24825f68d7(90, 1, 0.5, 500));
        /**
		 * This flag can be used for type testing.
		 *
		 * @type {boolean}
		 * @readonly
		 * @default true
		 */ this.isPointLightShadow = true;
        this._frameExtents = new $9ddd7e9b53f7a2d4$export$c977b3e384af9ae1(4, 2);
        this._viewportCount = 6;
        this._viewports = [
            // These viewports map a cube-map onto a 2D texture with the
            // following orientation:
            //
            //  xzXZ
            //   y Y
            //
            // X - Positive x direction
            // x - Negative x direction
            // Y - Positive y direction
            // y - Negative y direction
            // Z - Positive z direction
            // z - Negative z direction
            // positive X
            new $9ddd7e9b53f7a2d4$export$fa7daccca11cdbe3(2, 1, 1, 1),
            // negative X
            new $9ddd7e9b53f7a2d4$export$fa7daccca11cdbe3(0, 1, 1, 1),
            // positive Z
            new $9ddd7e9b53f7a2d4$export$fa7daccca11cdbe3(3, 1, 1, 1),
            // negative Z
            new $9ddd7e9b53f7a2d4$export$fa7daccca11cdbe3(1, 1, 1, 1),
            // positive Y
            new $9ddd7e9b53f7a2d4$export$fa7daccca11cdbe3(3, 0, 1, 1),
            // negative Y
            new $9ddd7e9b53f7a2d4$export$fa7daccca11cdbe3(1, 0, 1, 1)
        ];
        this._cubeDirections = [
            new $9ddd7e9b53f7a2d4$export$64b5c384219d3699(1, 0, 0),
            new $9ddd7e9b53f7a2d4$export$64b5c384219d3699(-1, 0, 0),
            new $9ddd7e9b53f7a2d4$export$64b5c384219d3699(0, 0, 1),
            new $9ddd7e9b53f7a2d4$export$64b5c384219d3699(0, 0, -1),
            new $9ddd7e9b53f7a2d4$export$64b5c384219d3699(0, 1, 0),
            new $9ddd7e9b53f7a2d4$export$64b5c384219d3699(0, -1, 0)
        ];
        this._cubeUps = [
            new $9ddd7e9b53f7a2d4$export$64b5c384219d3699(0, 1, 0),
            new $9ddd7e9b53f7a2d4$export$64b5c384219d3699(0, 1, 0),
            new $9ddd7e9b53f7a2d4$export$64b5c384219d3699(0, 1, 0),
            new $9ddd7e9b53f7a2d4$export$64b5c384219d3699(0, 1, 0),
            new $9ddd7e9b53f7a2d4$export$64b5c384219d3699(0, 0, 1),
            new $9ddd7e9b53f7a2d4$export$64b5c384219d3699(0, 0, -1)
        ];
    }
    /**
	 * Update the matrices for the camera and shadow, used internally by the renderer.
	 *
	 * @param {Light} light - The light for which the shadow is being rendered.
	 * @param {number} [viewportIndex=0] - The viewport index.
	 */ updateMatrices(light, viewportIndex = 0) {
        const camera = this.camera;
        const shadowMatrix = this.matrix;
        const far = light.distance || camera.far;
        if (far !== camera.far) {
            camera.far = far;
            camera.updateProjectionMatrix();
        }
        $9ddd7e9b53f7a2d4$var$_lightPositionWorld.setFromMatrixPosition(light.matrixWorld);
        camera.position.copy($9ddd7e9b53f7a2d4$var$_lightPositionWorld);
        $9ddd7e9b53f7a2d4$var$_lookTarget.copy(camera.position);
        $9ddd7e9b53f7a2d4$var$_lookTarget.add(this._cubeDirections[viewportIndex]);
        camera.up.copy(this._cubeUps[viewportIndex]);
        camera.lookAt($9ddd7e9b53f7a2d4$var$_lookTarget);
        camera.updateMatrixWorld();
        shadowMatrix.makeTranslation(-$9ddd7e9b53f7a2d4$var$_lightPositionWorld.x, -$9ddd7e9b53f7a2d4$var$_lightPositionWorld.y, -$9ddd7e9b53f7a2d4$var$_lightPositionWorld.z);
        $9ddd7e9b53f7a2d4$var$_projScreenMatrix.multiplyMatrices(camera.projectionMatrix, camera.matrixWorldInverse);
        this._frustum.setFromProjectionMatrix($9ddd7e9b53f7a2d4$var$_projScreenMatrix);
    }
}
/**
 * A light that gets emitted from a single point in all directions. A common
 * use case for this is to replicate the light emitted from a bare
 * lightbulb.
 *
 * This light can cast shadows - see the {@link PointLightShadow} for details.
 *
 * ```js
 * const light = new THREE.PointLight( 0xff0000, 1, 100 );
 * light.position.set( 50, 50, 50 );
 * scene.add( light );
 * ```
 *
 * @augments Light
 */ class $9ddd7e9b53f7a2d4$export$4c9c1cb3f0b6f455 extends $9ddd7e9b53f7a2d4$export$6ecadb6ed240d696 {
    /**
	 * Constructs a new point light.
	 *
	 * @param {(number|Color|string)} [color=0xffffff] - The light's color.
	 * @param {number} [intensity=1] - The light's strength/intensity measured in candela (cd).
	 * @param {number} [distance=0] - Maximum range of the light. `0` means no limit.
	 * @param {number} [decay=2] - The amount the light dims along the distance of the light.
	 */ constructor(color, intensity, distance = 0, decay = 2){
        super(color, intensity);
        /**
		 * This flag can be used for type testing.
		 *
		 * @type {boolean}
		 * @readonly
		 * @default true
		 */ this.isPointLight = true;
        this.type = 'PointLight';
        /**
		 * When distance is zero, light will attenuate according to inverse-square
		 * law to infinite distance. When distance is non-zero, light will attenuate
		 * according to inverse-square law until near the distance cutoff, where it
		 * will then attenuate quickly and smoothly to 0. Inherently, cutoffs are not
		 * physically correct.
		 *
		 * @type {number}
		 * @default 0
		 */ this.distance = distance;
        /**
		 * The amount the light dims along the distance of the light. In context of
		 * physically-correct rendering the default value should not be changed.
		 *
		 * @type {number}
		 * @default 2
		 */ this.decay = decay;
        /**
		 * This property holds the light's shadow configuration.
		 *
		 * @type {PointLightShadow}
		 */ this.shadow = new $9ddd7e9b53f7a2d4$var$PointLightShadow();
    }
    /**
	 * The light's power. Power is the luminous power of the light measured in lumens (lm).
	 * Changing the power will also change the light's intensity.
	 *
	 * @type {number}
	 */ get power() {
        // compute the light's luminous power (in lumens) from its intensity (in candela)
        // for an isotropic light source, luminous power (lm) = 4 π luminous intensity (cd)
        return this.intensity * 4 * Math.PI;
    }
    set power(power) {
        // set the light's intensity (in candela) from the desired luminous power (in lumens)
        this.intensity = power / (4 * Math.PI);
    }
    dispose() {
        this.shadow.dispose();
    }
    copy(source, recursive) {
        super.copy(source, recursive);
        this.distance = source.distance;
        this.decay = source.decay;
        this.shadow = source.shadow.clone();
        return this;
    }
}
/**
 * Camera that uses [orthographic projection]{@link https://en.wikipedia.org/wiki/Orthographic_projection}.
 *
 * In this projection mode, an object's size in the rendered image stays
 * constant regardless of its distance from the camera. This can be useful
 * for rendering 2D scenes and UI elements, amongst other things.
 *
 * ```js
 * const camera = new THREE.OrthographicCamera( width / - 2, width / 2, height / 2, height / - 2, 1, 1000 );
 * scene.add( camera );
 * ```
 *
 * @augments Camera
 */ class $9ddd7e9b53f7a2d4$export$9ebf355ee4ed261b extends $9ddd7e9b53f7a2d4$export$79f141de891a5fed {
    /**
	 * Constructs a new orthographic camera.
	 *
	 * @param {number} [left=-1] - The left plane of the camera's frustum.
	 * @param {number} [right=1] - The right plane of the camera's frustum.
	 * @param {number} [top=1] - The top plane of the camera's frustum.
	 * @param {number} [bottom=-1] - The bottom plane of the camera's frustum.
	 * @param {number} [near=0.1] - The camera's near plane.
	 * @param {number} [far=2000] - The camera's far plane.
	 */ constructor(left = -1, right = 1, top = 1, bottom = -1, near = 0.1, far = 2000){
        super();
        /**
		 * This flag can be used for type testing.
		 *
		 * @type {boolean}
		 * @readonly
		 * @default true
		 */ this.isOrthographicCamera = true;
        this.type = 'OrthographicCamera';
        /**
		 * The zoom factor of the camera.
		 *
		 * @type {number}
		 * @default 1
		 */ this.zoom = 1;
        /**
		 * Represents the frustum window specification. This property should not be edited
		 * directly but via {@link PerspectiveCamera#setViewOffset} and {@link PerspectiveCamera#clearViewOffset}.
		 *
		 * @type {?Object}
		 * @default null
		 */ this.view = null;
        /**
		 * The left plane of the camera's frustum.
		 *
		 * @type {number}
		 * @default -1
		 */ this.left = left;
        /**
		 * The right plane of the camera's frustum.
		 *
		 * @type {number}
		 * @default 1
		 */ this.right = right;
        /**
		 * The top plane of the camera's frustum.
		 *
		 * @type {number}
		 * @default 1
		 */ this.top = top;
        /**
		 * The bottom plane of the camera's frustum.
		 *
		 * @type {number}
		 * @default -1
		 */ this.bottom = bottom;
        /**
		 * The camera's near plane. The valid range is greater than `0`
		 * and less than the current value of {@link OrthographicCamera#far}.
		 *
		 * Note that, unlike for the {@link PerspectiveCamera}, `0` is a
		 * valid value for an orthographic camera's near plane.
		 *
		 * @type {number}
		 * @default 0.1
		 */ this.near = near;
        /**
		 * The camera's far plane. Must be greater than the
		 * current value of {@link OrthographicCamera#near}.
		 *
		 * @type {number}
		 * @default 2000
		 */ this.far = far;
        this.updateProjectionMatrix();
    }
    copy(source, recursive) {
        super.copy(source, recursive);
        this.left = source.left;
        this.right = source.right;
        this.top = source.top;
        this.bottom = source.bottom;
        this.near = source.near;
        this.far = source.far;
        this.zoom = source.zoom;
        this.view = source.view === null ? null : Object.assign({}, source.view);
        return this;
    }
    /**
	 * Sets an offset in a larger frustum. This is useful for multi-window or
	 * multi-monitor/multi-machine setups.
	 *
	 * @param {number} fullWidth - The full width of multiview setup.
	 * @param {number} fullHeight - The full height of multiview setup.
	 * @param {number} x - The horizontal offset of the subcamera.
	 * @param {number} y - The vertical offset of the subcamera.
	 * @param {number} width - The width of subcamera.
	 * @param {number} height - The height of subcamera.
	 * @see {@link PerspectiveCamera#setViewOffset}
	 */ setViewOffset(fullWidth, fullHeight, x, y, width, height) {
        if (this.view === null) this.view = {
            enabled: true,
            fullWidth: 1,
            fullHeight: 1,
            offsetX: 0,
            offsetY: 0,
            width: 1,
            height: 1
        };
        this.view.enabled = true;
        this.view.fullWidth = fullWidth;
        this.view.fullHeight = fullHeight;
        this.view.offsetX = x;
        this.view.offsetY = y;
        this.view.width = width;
        this.view.height = height;
        this.updateProjectionMatrix();
    }
    /**
	 * Removes the view offset from the projection matrix.
	 */ clearViewOffset() {
        if (this.view !== null) this.view.enabled = false;
        this.updateProjectionMatrix();
    }
    /**
	 * Updates the camera's projection matrix. Must be called after any change of
	 * camera properties.
	 */ updateProjectionMatrix() {
        const dx = (this.right - this.left) / (2 * this.zoom);
        const dy = (this.top - this.bottom) / (2 * this.zoom);
        const cx = (this.right + this.left) / 2;
        const cy = (this.top + this.bottom) / 2;
        let left = cx - dx;
        let right = cx + dx;
        let top = cy + dy;
        let bottom = cy - dy;
        if (this.view !== null && this.view.enabled) {
            const scaleW = (this.right - this.left) / this.view.fullWidth / this.zoom;
            const scaleH = (this.top - this.bottom) / this.view.fullHeight / this.zoom;
            left += scaleW * this.view.offsetX;
            right = left + scaleW * this.view.width;
            top -= scaleH * this.view.offsetY;
            bottom = top - scaleH * this.view.height;
        }
        this.projectionMatrix.makeOrthographic(left, right, top, bottom, this.near, this.far, this.coordinateSystem);
        this.projectionMatrixInverse.copy(this.projectionMatrix).invert();
    }
    toJSON(meta) {
        const data = super.toJSON(meta);
        data.object.zoom = this.zoom;
        data.object.left = this.left;
        data.object.right = this.right;
        data.object.top = this.top;
        data.object.bottom = this.bottom;
        data.object.near = this.near;
        data.object.far = this.far;
        if (this.view !== null) data.object.view = Object.assign({}, this.view);
        return data;
    }
}
/**
 * Represents the shadow configuration of directional lights.
 *
 * @augments LightShadow
 */ class $9ddd7e9b53f7a2d4$var$DirectionalLightShadow extends $9ddd7e9b53f7a2d4$var$LightShadow {
    /**
	 * Constructs a new directional light shadow.
	 */ constructor(){
        super(new $9ddd7e9b53f7a2d4$export$9ebf355ee4ed261b(-5, 5, 5, -5, 0.5, 500));
        /**
		 * This flag can be used for type testing.
		 *
		 * @type {boolean}
		 * @readonly
		 * @default true
		 */ this.isDirectionalLightShadow = true;
    }
}
/**
 * A light that gets emitted in a specific direction. This light will behave
 * as though it is infinitely far away and the rays produced from it are all
 * parallel. The common use case for this is to simulate daylight; the sun is
 * far enough away that its position can be considered to be infinite, and
 * all light rays coming from it are parallel.
 *
 * A common point of confusion for directional lights is that setting the
 * rotation has no effect. This is because three.js's DirectionalLight is the
 * equivalent to what is often called a 'Target Direct Light' in other
 * applications.
 *
 * This means that its direction is calculated as pointing from the light's
 * {@link Object3D#position} to the {@link DirectionalLight#target} position
 * (as opposed to a 'Free Direct Light' that just has a rotation
 * component).
 *
 * This light can cast shadows - see the {@link DirectionalLightShadow} for details.
 *
 * ```js
 * // White directional light at half intensity shining from the top.
 * const directionalLight = new THREE.DirectionalLight( 0xffffff, 0.5 );
 * scene.add( directionalLight );
 * ```
 *
 * @augments Light
 */ class $9ddd7e9b53f7a2d4$export$3fea33cc9972c868 extends $9ddd7e9b53f7a2d4$export$6ecadb6ed240d696 {
    /**
	 * Constructs a new directional light.
	 *
	 * @param {(number|Color|string)} [color=0xffffff] - The light's color.
	 * @param {number} [intensity=1] - The light's strength/intensity.
	 */ constructor(color, intensity){
        super(color, intensity);
        /**
		 * This flag can be used for type testing.
		 *
		 * @type {boolean}
		 * @readonly
		 * @default true
		 */ this.isDirectionalLight = true;
        this.type = 'DirectionalLight';
        this.position.copy($9ddd7e9b53f7a2d4$export$e4dd07dff30cc924.DEFAULT_UP);
        this.updateMatrix();
        /**
		 * The directional light points from its position to the
		 * target's position.
		 *
		 * For the target's position to be changed to anything other
		 * than the default, it must be added to the scene.
		 *
		 * It is also possible to set the target to be another 3D object
		 * in the scene. The light will now track the target object.
		 *
		 * @type {Object3D}
		 */ this.target = new $9ddd7e9b53f7a2d4$export$e4dd07dff30cc924();
        /**
		 * This property holds the light's shadow configuration.
		 *
		 * @type {DirectionalLightShadow}
		 */ this.shadow = new $9ddd7e9b53f7a2d4$var$DirectionalLightShadow();
    }
    dispose() {
        this.shadow.dispose();
    }
    copy(source) {
        super.copy(source);
        this.target = source.target.clone();
        this.shadow = source.shadow.clone();
        return this;
    }
}
/**
 * This light globally illuminates all objects in the scene equally.
 *
 * It cannot be used to cast shadows as it does not have a direction.
 *
 * ```js
 * const light = new THREE.AmbientLight( 0x404040 ); // soft white light
 * scene.add( light );
 * ```
 *
 * @augments Light
 */ class $9ddd7e9b53f7a2d4$export$af279bfef9ec2c96 extends $9ddd7e9b53f7a2d4$export$6ecadb6ed240d696 {
    /**
	 * Constructs a new ambient light.
	 *
	 * @param {(number|Color|string)} [color=0xffffff] - The light's color.
	 * @param {number} [intensity=1] - The light's strength/intensity.
	 */ constructor(color, intensity){
        super(color, intensity);
        /**
		 * This flag can be used for type testing.
		 *
		 * @type {boolean}
		 * @readonly
		 * @default true
		 */ this.isAmbientLight = true;
        this.type = 'AmbientLight';
    }
}
/**
 * This class emits light uniformly across the face a rectangular plane.
 * This light type can be used to simulate light sources such as bright
 * windows or strip lighting.
 *
 * Important Notes:
 *
 * - There is no shadow support.
 * - Only PBR materials are supported.
 * - You have to include `RectAreaLightUniformsLib` (`WebGLRenderer`) or `RectAreaLightTexturesLib` (`WebGPURenderer`)
 * into your app and init the uniforms/textures.
 *
 * ```js
 * RectAreaLightUniformsLib.init(); // only relevant for WebGLRenderer
 * THREE.RectAreaLightNode.setLTC( RectAreaLightTexturesLib.init() ); //  only relevant for WebGPURenderer
 *
 * const intensity = 1; const width = 10; const height = 10;
 * const rectLight = new THREE.RectAreaLight( 0xffffff, intensity, width, height );
 * rectLight.position.set( 5, 5, 0 );
 * rectLight.lookAt( 0, 0, 0 );
 * scene.add( rectLight )
 * ```
 *
 * @augments Light
 */ class $9ddd7e9b53f7a2d4$export$61db2d908bbd2429 extends $9ddd7e9b53f7a2d4$export$6ecadb6ed240d696 {
    /**
	 * Constructs a new area light.
	 *
	 * @param {(number|Color|string)} [color=0xffffff] - The light's color.
	 * @param {number} [intensity=1] - The light's strength/intensity.
	 * @param {number} [width=10] - The width of the light.
	 * @param {number} [height=10] - The height of the light.
	 */ constructor(color, intensity, width = 10, height = 10){
        super(color, intensity);
        /**
		 * This flag can be used for type testing.
		 *
		 * @type {boolean}
		 * @readonly
		 * @default true
		 */ this.isRectAreaLight = true;
        this.type = 'RectAreaLight';
        /**
		 * The width of the light.
		 *
		 * @type {number}
		 * @default 10
		 */ this.width = width;
        /**
		 * The height of the light.
		 *
		 * @type {number}
		 * @default 10
		 */ this.height = height;
    }
    /**
	 * The light's power. Power is the luminous power of the light measured in lumens (lm).
	 * Changing the power will also change the light's intensity.
	 *
	 * @type {number}
	 */ get power() {
        // compute the light's luminous power (in lumens) from its intensity (in nits)
        return this.intensity * this.width * this.height * Math.PI;
    }
    set power(power) {
        // set the light's intensity (in nits) from the desired luminous power (in lumens)
        this.intensity = power / (this.width * this.height * Math.PI);
    }
    copy(source) {
        super.copy(source);
        this.width = source.width;
        this.height = source.height;
        return this;
    }
    toJSON(meta) {
        const data = super.toJSON(meta);
        data.object.width = this.width;
        data.object.height = this.height;
        return data;
    }
}
/**
 * Represents a third-order spherical harmonics (SH). Light probes use this class
 * to encode lighting information.
 *
 * - Primary reference: {@link https://graphics.stanford.edu/papers/envmap/envmap.pdf}
 * - Secondary reference: {@link https://www.ppsloan.org/publications/StupidSH36.pdf}
 */ class $9ddd7e9b53f7a2d4$export$ba61ce607e1f405a {
    /**
	 * Constructs a new spherical harmonics.
	 */ constructor(){
        /**
		 * This flag can be used for type testing.
		 *
		 * @type {boolean}
		 * @readonly
		 * @default true
		 */ this.isSphericalHarmonics3 = true;
        /**
		 * An array holding the (9) SH coefficients.
		 *
		 * @type {Array<Vector3>}
		 */ this.coefficients = [];
        for(let i = 0; i < 9; i++)this.coefficients.push(new $9ddd7e9b53f7a2d4$export$64b5c384219d3699());
    }
    /**
	 * Sets the given SH coefficients to this instance by copying
	 * the values.
	 *
	 * @param {Array<Vector3>} coefficients - The SH coefficients.
	 * @return {SphericalHarmonics3} A reference to this spherical harmonics.
	 */ set(coefficients) {
        for(let i = 0; i < 9; i++)this.coefficients[i].copy(coefficients[i]);
        return this;
    }
    /**
	 * Sets all SH coefficients to `0`.
	 *
	 * @return {SphericalHarmonics3} A reference to this spherical harmonics.
	 */ zero() {
        for(let i = 0; i < 9; i++)this.coefficients[i].set(0, 0, 0);
        return this;
    }
    /**
	 * Returns the radiance in the direction of the given normal.
	 *
	 * @param {Vector3} normal - The normal vector (assumed to be unit length)
	 * @param {Vector3} target - The target vector that is used to store the method's result.
	 * @return {Vector3} The radiance.
	 */ getAt(normal, target) {
        // normal is assumed to be unit length
        const x = normal.x, y = normal.y, z = normal.z;
        const coeff = this.coefficients;
        // band 0
        target.copy(coeff[0]).multiplyScalar(0.282095);
        // band 1
        target.addScaledVector(coeff[1], 0.488603 * y);
        target.addScaledVector(coeff[2], 0.488603 * z);
        target.addScaledVector(coeff[3], 0.488603 * x);
        // band 2
        target.addScaledVector(coeff[4], 1.092548 * (x * y));
        target.addScaledVector(coeff[5], 1.092548 * (y * z));
        target.addScaledVector(coeff[6], 0.315392 * (3.0 * z * z - 1.0));
        target.addScaledVector(coeff[7], 1.092548 * (x * z));
        target.addScaledVector(coeff[8], 0.546274 * (x * x - y * y));
        return target;
    }
    /**
	 * Returns the irradiance (radiance convolved with cosine lobe) in the
	 * direction of the given normal.
	 *
	 * @param {Vector3} normal - The normal vector (assumed to be unit length)
	 * @param {Vector3} target - The target vector that is used to store the method's result.
	 * @return {Vector3} The irradiance.
	 */ getIrradianceAt(normal, target) {
        // normal is assumed to be unit length
        const x = normal.x, y = normal.y, z = normal.z;
        const coeff = this.coefficients;
        // band 0
        target.copy(coeff[0]).multiplyScalar(0.886227); // π * 0.282095
        // band 1
        target.addScaledVector(coeff[1], 1.023328 * y); // ( 2 * π / 3 ) * 0.488603
        target.addScaledVector(coeff[2], 1.023328 * z);
        target.addScaledVector(coeff[3], 1.023328 * x);
        // band 2
        target.addScaledVector(coeff[4], 0.858086 * x * y); // ( π / 4 ) * 1.092548
        target.addScaledVector(coeff[5], 0.858086 * y * z);
        target.addScaledVector(coeff[6], 0.743125 * z * z - 0.247708); // ( π / 4 ) * 0.315392 * 3
        target.addScaledVector(coeff[7], 0.858086 * x * z);
        target.addScaledVector(coeff[8], 0.429043 * (x * x - y * y)); // ( π / 4 ) * 0.546274
        return target;
    }
    /**
	 * Adds the given SH to this instance.
	 *
	 * @param {SphericalHarmonics3} sh - The SH to add.
	 * @return {SphericalHarmonics3} A reference to this spherical harmonics.
	 */ add(sh) {
        for(let i = 0; i < 9; i++)this.coefficients[i].add(sh.coefficients[i]);
        return this;
    }
    /**
	 * A convenience method for performing {@link SphericalHarmonics3#add} and
	 * {@link SphericalHarmonics3#scale} at once.
	 *
	 * @param {SphericalHarmonics3} sh - The SH to add.
	 * @param {number} s - The scale factor.
	 * @return {SphericalHarmonics3} A reference to this spherical harmonics.
	 */ addScaledSH(sh, s) {
        for(let i = 0; i < 9; i++)this.coefficients[i].addScaledVector(sh.coefficients[i], s);
        return this;
    }
    /**
	 * Scales this SH by the given scale factor.
	 *
	 * @param {number} s - The scale factor.
	 * @return {SphericalHarmonics3} A reference to this spherical harmonics.
	 */ scale(s) {
        for(let i = 0; i < 9; i++)this.coefficients[i].multiplyScalar(s);
        return this;
    }
    /**
	 * Linear interpolates between the given SH and this instance by the given
	 * alpha factor.
	 *
	 * @param {SphericalHarmonics3} sh - The SH to interpolate with.
	 * @param {number} alpha - The alpha factor.
	 * @return {SphericalHarmonics3} A reference to this spherical harmonics.
	 */ lerp(sh, alpha) {
        for(let i = 0; i < 9; i++)this.coefficients[i].lerp(sh.coefficients[i], alpha);
        return this;
    }
    /**
	 * Returns `true` if this spherical harmonics is equal with the given one.
	 *
	 * @param {SphericalHarmonics3} sh - The spherical harmonics to test for equality.
	 * @return {boolean} Whether this spherical harmonics is equal with the given one.
	 */ equals(sh) {
        for(let i = 0; i < 9; i++){
            if (!this.coefficients[i].equals(sh.coefficients[i])) return false;
        }
        return true;
    }
    /**
	 * Copies the values of the given spherical harmonics to this instance.
	 *
	 * @param {SphericalHarmonics3} sh - The spherical harmonics to copy.
	 * @return {SphericalHarmonics3} A reference to this spherical harmonics.
	 */ copy(sh) {
        return this.set(sh.coefficients);
    }
    /**
	 * Returns a new spherical harmonics with copied values from this instance.
	 *
	 * @return {SphericalHarmonics3} A clone of this instance.
	 */ clone() {
        return new this.constructor().copy(this);
    }
    /**
	 * Sets the SH coefficients of this instance from the given array.
	 *
	 * @param {Array<number>} array - An array holding the SH coefficients.
	 * @param {number} [offset=0] - The array offset where to start copying.
	 * @return {SphericalHarmonics3} A clone of this instance.
	 */ fromArray(array, offset = 0) {
        const coefficients = this.coefficients;
        for(let i = 0; i < 9; i++)coefficients[i].fromArray(array, offset + i * 3);
        return this;
    }
    /**
	 * Returns an array with the SH coefficients, or copies them into the provided
	 * array. The coefficients are represented as numbers.
	 *
	 * @param {Array<number>} [array=[]] - The target array.
	 * @param {number} [offset=0] - The array offset where to start copying.
	 * @return {Array<number>} An array with flat SH coefficients.
	 */ toArray(array = [], offset = 0) {
        const coefficients = this.coefficients;
        for(let i = 0; i < 9; i++)coefficients[i].toArray(array, offset + i * 3);
        return array;
    }
    /**
	 * Computes the SH basis for the given normal vector.
	 *
	 * @param {Vector3} normal - The normal.
	 * @param {Array<number>} shBasis - The target array holding the SH basis.
	 */ static getBasisAt(normal, shBasis) {
        // normal is assumed to be unit length
        const x = normal.x, y = normal.y, z = normal.z;
        // band 0
        shBasis[0] = 0.282095;
        // band 1
        shBasis[1] = 0.488603 * y;
        shBasis[2] = 0.488603 * z;
        shBasis[3] = 0.488603 * x;
        // band 2
        shBasis[4] = 1.092548 * x * y;
        shBasis[5] = 1.092548 * y * z;
        shBasis[6] = 0.315392 * (3 * z * z - 1);
        shBasis[7] = 1.092548 * x * z;
        shBasis[8] = 0.546274 * (x * x - y * y);
    }
}
/**
 * Light probes are an alternative way of adding light to a 3D scene. Unlike
 * classical light sources (e.g. directional, point or spot lights), light
 * probes do not emit light. Instead they store information about light
 * passing through 3D space. During rendering, the light that hits a 3D
 * object is approximated by using the data from the light probe.
 *
 * Light probes are usually created from (radiance) environment maps. The
 * class {@link LightProbeGenerator} can be used to create light probes from
 * cube textures or render targets. However, light estimation data could also
 * be provided in other forms e.g. by WebXR. This enables the rendering of
 * augmented reality content that reacts to real world lighting.
 *
 * The current probe implementation in three.js supports so-called diffuse
 * light probes. This type of light probe is functionally equivalent to an
 * irradiance environment map.
 *
 * @augments Light
 */ class $9ddd7e9b53f7a2d4$export$e7ef036e309b38d2 extends $9ddd7e9b53f7a2d4$export$6ecadb6ed240d696 {
    /**
	 * Constructs a new light probe.
	 *
	 * @param {SphericalHarmonics3} sh - The spherical harmonics which represents encoded lighting information.
	 * @param {number} [intensity=1] - The light's strength/intensity.
	 */ constructor(sh = new $9ddd7e9b53f7a2d4$export$ba61ce607e1f405a(), intensity = 1){
        super(undefined, intensity);
        /**
		 * This flag can be used for type testing.
		 *
		 * @type {boolean}
		 * @readonly
		 * @default true
		 */ this.isLightProbe = true;
        /**
		 * A light probe uses spherical harmonics to encode lighting information.
		 *
		 * @type {SphericalHarmonics3}
		 */ this.sh = sh;
    }
    copy(source) {
        super.copy(source);
        this.sh.copy(source.sh);
        return this;
    }
    /**
	 * Deserializes the light prove from the given JSON.
	 *
	 * @param {Object} json - The JSON holding the serialized light probe.
	 * @return {LightProbe} A reference to this light probe.
	 */ fromJSON(json) {
        this.intensity = json.intensity; // TODO: Move this bit to Light.fromJSON();
        this.sh.fromArray(json.sh);
        return this;
    }
    toJSON(meta) {
        const data = super.toJSON(meta);
        data.object.sh = this.sh.toArray();
        return data;
    }
}
/**
 * Class for loading geometries. The files are internally
 * loaded via {@link FileLoader}.
 *
 * ```js
 * const loader = new THREE.MaterialLoader();
 * const material = await loader.loadAsync( 'material.json' );
 * ```
 * This loader does not support node materials. Use {@link NodeMaterialLoader} instead.
 *
 * @augments Loader
 */ class $9ddd7e9b53f7a2d4$export$3bd6d323353dcf96 extends $9ddd7e9b53f7a2d4$export$3b0d6d7590275603 {
    /**
	 * Constructs a new material loader.
	 *
	 * @param {LoadingManager} [manager] - The loading manager.
	 */ constructor(manager){
        super(manager);
        /**
		 * A dictionary holding textures used by the material.
		 *
		 * @type {Object<string,Texture>}
		 */ this.textures = {};
    }
    /**
	 * Starts loading from the given URL and pass the loaded material to the `onLoad()` callback.
	 *
	 * @param {string} url - The path/URL of the file to be loaded. This can also be a data URI.
	 * @param {function(Material)} onLoad - Executed when the loading process has been finished.
	 * @param {onProgressCallback} onProgress - Executed while the loading is in progress.
	 * @param {onErrorCallback} onError - Executed when errors occur.
	 */ load(url, onLoad, onProgress, onError) {
        const scope = this;
        const loader = new $9ddd7e9b53f7a2d4$export$98435a25b5cf7b2b(scope.manager);
        loader.setPath(scope.path);
        loader.setRequestHeader(scope.requestHeader);
        loader.setWithCredentials(scope.withCredentials);
        loader.load(url, function(text) {
            try {
                onLoad(scope.parse(JSON.parse(text)));
            } catch (e) {
                if (onError) onError(e);
                else console.error(e);
                scope.manager.itemError(url);
            }
        }, onProgress, onError);
    }
    /**
	 * Parses the given JSON object and returns a material.
	 *
	 * @param {Object} json - The serialized material.
	 * @return {Material} The parsed material.
	 */ parse(json) {
        const textures = this.textures;
        function getTexture(name) {
            if (textures[name] === undefined) console.warn('THREE.MaterialLoader: Undefined texture', name);
            return textures[name];
        }
        const material = this.createMaterialFromType(json.type);
        if (json.uuid !== undefined) material.uuid = json.uuid;
        if (json.name !== undefined) material.name = json.name;
        if (json.color !== undefined && material.color !== undefined) material.color.setHex(json.color);
        if (json.roughness !== undefined) material.roughness = json.roughness;
        if (json.metalness !== undefined) material.metalness = json.metalness;
        if (json.sheen !== undefined) material.sheen = json.sheen;
        if (json.sheenColor !== undefined) material.sheenColor = new $9ddd7e9b53f7a2d4$export$892596cec99bc70e().setHex(json.sheenColor);
        if (json.sheenRoughness !== undefined) material.sheenRoughness = json.sheenRoughness;
        if (json.emissive !== undefined && material.emissive !== undefined) material.emissive.setHex(json.emissive);
        if (json.specular !== undefined && material.specular !== undefined) material.specular.setHex(json.specular);
        if (json.specularIntensity !== undefined) material.specularIntensity = json.specularIntensity;
        if (json.specularColor !== undefined && material.specularColor !== undefined) material.specularColor.setHex(json.specularColor);
        if (json.shininess !== undefined) material.shininess = json.shininess;
        if (json.clearcoat !== undefined) material.clearcoat = json.clearcoat;
        if (json.clearcoatRoughness !== undefined) material.clearcoatRoughness = json.clearcoatRoughness;
        if (json.dispersion !== undefined) material.dispersion = json.dispersion;
        if (json.iridescence !== undefined) material.iridescence = json.iridescence;
        if (json.iridescenceIOR !== undefined) material.iridescenceIOR = json.iridescenceIOR;
        if (json.iridescenceThicknessRange !== undefined) material.iridescenceThicknessRange = json.iridescenceThicknessRange;
        if (json.transmission !== undefined) material.transmission = json.transmission;
        if (json.thickness !== undefined) material.thickness = json.thickness;
        if (json.attenuationDistance !== undefined) material.attenuationDistance = json.attenuationDistance;
        if (json.attenuationColor !== undefined && material.attenuationColor !== undefined) material.attenuationColor.setHex(json.attenuationColor);
        if (json.anisotropy !== undefined) material.anisotropy = json.anisotropy;
        if (json.anisotropyRotation !== undefined) material.anisotropyRotation = json.anisotropyRotation;
        if (json.fog !== undefined) material.fog = json.fog;
        if (json.flatShading !== undefined) material.flatShading = json.flatShading;
        if (json.blending !== undefined) material.blending = json.blending;
        if (json.combine !== undefined) material.combine = json.combine;
        if (json.side !== undefined) material.side = json.side;
        if (json.shadowSide !== undefined) material.shadowSide = json.shadowSide;
        if (json.opacity !== undefined) material.opacity = json.opacity;
        if (json.transparent !== undefined) material.transparent = json.transparent;
        if (json.alphaTest !== undefined) material.alphaTest = json.alphaTest;
        if (json.alphaHash !== undefined) material.alphaHash = json.alphaHash;
        if (json.depthFunc !== undefined) material.depthFunc = json.depthFunc;
        if (json.depthTest !== undefined) material.depthTest = json.depthTest;
        if (json.depthWrite !== undefined) material.depthWrite = json.depthWrite;
        if (json.colorWrite !== undefined) material.colorWrite = json.colorWrite;
        if (json.blendSrc !== undefined) material.blendSrc = json.blendSrc;
        if (json.blendDst !== undefined) material.blendDst = json.blendDst;
        if (json.blendEquation !== undefined) material.blendEquation = json.blendEquation;
        if (json.blendSrcAlpha !== undefined) material.blendSrcAlpha = json.blendSrcAlpha;
        if (json.blendDstAlpha !== undefined) material.blendDstAlpha = json.blendDstAlpha;
        if (json.blendEquationAlpha !== undefined) material.blendEquationAlpha = json.blendEquationAlpha;
        if (json.blendColor !== undefined && material.blendColor !== undefined) material.blendColor.setHex(json.blendColor);
        if (json.blendAlpha !== undefined) material.blendAlpha = json.blendAlpha;
        if (json.stencilWriteMask !== undefined) material.stencilWriteMask = json.stencilWriteMask;
        if (json.stencilFunc !== undefined) material.stencilFunc = json.stencilFunc;
        if (json.stencilRef !== undefined) material.stencilRef = json.stencilRef;
        if (json.stencilFuncMask !== undefined) material.stencilFuncMask = json.stencilFuncMask;
        if (json.stencilFail !== undefined) material.stencilFail = json.stencilFail;
        if (json.stencilZFail !== undefined) material.stencilZFail = json.stencilZFail;
        if (json.stencilZPass !== undefined) material.stencilZPass = json.stencilZPass;
        if (json.stencilWrite !== undefined) material.stencilWrite = json.stencilWrite;
        if (json.wireframe !== undefined) material.wireframe = json.wireframe;
        if (json.wireframeLinewidth !== undefined) material.wireframeLinewidth = json.wireframeLinewidth;
        if (json.wireframeLinecap !== undefined) material.wireframeLinecap = json.wireframeLinecap;
        if (json.wireframeLinejoin !== undefined) material.wireframeLinejoin = json.wireframeLinejoin;
        if (json.rotation !== undefined) material.rotation = json.rotation;
        if (json.linewidth !== undefined) material.linewidth = json.linewidth;
        if (json.dashSize !== undefined) material.dashSize = json.dashSize;
        if (json.gapSize !== undefined) material.gapSize = json.gapSize;
        if (json.scale !== undefined) material.scale = json.scale;
        if (json.polygonOffset !== undefined) material.polygonOffset = json.polygonOffset;
        if (json.polygonOffsetFactor !== undefined) material.polygonOffsetFactor = json.polygonOffsetFactor;
        if (json.polygonOffsetUnits !== undefined) material.polygonOffsetUnits = json.polygonOffsetUnits;
        if (json.dithering !== undefined) material.dithering = json.dithering;
        if (json.alphaToCoverage !== undefined) material.alphaToCoverage = json.alphaToCoverage;
        if (json.premultipliedAlpha !== undefined) material.premultipliedAlpha = json.premultipliedAlpha;
        if (json.forceSinglePass !== undefined) material.forceSinglePass = json.forceSinglePass;
        if (json.visible !== undefined) material.visible = json.visible;
        if (json.toneMapped !== undefined) material.toneMapped = json.toneMapped;
        if (json.userData !== undefined) material.userData = json.userData;
        if (json.vertexColors !== undefined) {
            if (typeof json.vertexColors === 'number') material.vertexColors = json.vertexColors > 0 ? true : false;
            else material.vertexColors = json.vertexColors;
        }
        // Shader Material
        if (json.uniforms !== undefined) for(const name in json.uniforms){
            const uniform = json.uniforms[name];
            material.uniforms[name] = {};
            switch(uniform.type){
                case 't':
                    material.uniforms[name].value = getTexture(uniform.value);
                    break;
                case 'c':
                    material.uniforms[name].value = new $9ddd7e9b53f7a2d4$export$892596cec99bc70e().setHex(uniform.value);
                    break;
                case 'v2':
                    material.uniforms[name].value = new $9ddd7e9b53f7a2d4$export$c977b3e384af9ae1().fromArray(uniform.value);
                    break;
                case 'v3':
                    material.uniforms[name].value = new $9ddd7e9b53f7a2d4$export$64b5c384219d3699().fromArray(uniform.value);
                    break;
                case 'v4':
                    material.uniforms[name].value = new $9ddd7e9b53f7a2d4$export$fa7daccca11cdbe3().fromArray(uniform.value);
                    break;
                case 'm3':
                    material.uniforms[name].value = new $9ddd7e9b53f7a2d4$export$8ff26dafa08918().fromArray(uniform.value);
                    break;
                case 'm4':
                    material.uniforms[name].value = new $9ddd7e9b53f7a2d4$export$2ae72fc923e5eb5().fromArray(uniform.value);
                    break;
                default:
                    material.uniforms[name].value = uniform.value;
            }
        }
        if (json.defines !== undefined) material.defines = json.defines;
        if (json.vertexShader !== undefined) material.vertexShader = json.vertexShader;
        if (json.fragmentShader !== undefined) material.fragmentShader = json.fragmentShader;
        if (json.glslVersion !== undefined) material.glslVersion = json.glslVersion;
        if (json.extensions !== undefined) for(const key in json.extensions)material.extensions[key] = json.extensions[key];
        if (json.lights !== undefined) material.lights = json.lights;
        if (json.clipping !== undefined) material.clipping = json.clipping;
        // for PointsMaterial
        if (json.size !== undefined) material.size = json.size;
        if (json.sizeAttenuation !== undefined) material.sizeAttenuation = json.sizeAttenuation;
        // maps
        if (json.map !== undefined) material.map = getTexture(json.map);
        if (json.matcap !== undefined) material.matcap = getTexture(json.matcap);
        if (json.alphaMap !== undefined) material.alphaMap = getTexture(json.alphaMap);
        if (json.bumpMap !== undefined) material.bumpMap = getTexture(json.bumpMap);
        if (json.bumpScale !== undefined) material.bumpScale = json.bumpScale;
        if (json.normalMap !== undefined) material.normalMap = getTexture(json.normalMap);
        if (json.normalMapType !== undefined) material.normalMapType = json.normalMapType;
        if (json.normalScale !== undefined) {
            let normalScale = json.normalScale;
            if (Array.isArray(normalScale) === false) // Blender exporter used to export a scalar. See #7459
            normalScale = [
                normalScale,
                normalScale
            ];
            material.normalScale = new $9ddd7e9b53f7a2d4$export$c977b3e384af9ae1().fromArray(normalScale);
        }
        if (json.displacementMap !== undefined) material.displacementMap = getTexture(json.displacementMap);
        if (json.displacementScale !== undefined) material.displacementScale = json.displacementScale;
        if (json.displacementBias !== undefined) material.displacementBias = json.displacementBias;
        if (json.roughnessMap !== undefined) material.roughnessMap = getTexture(json.roughnessMap);
        if (json.metalnessMap !== undefined) material.metalnessMap = getTexture(json.metalnessMap);
        if (json.emissiveMap !== undefined) material.emissiveMap = getTexture(json.emissiveMap);
        if (json.emissiveIntensity !== undefined) material.emissiveIntensity = json.emissiveIntensity;
        if (json.specularMap !== undefined) material.specularMap = getTexture(json.specularMap);
        if (json.specularIntensityMap !== undefined) material.specularIntensityMap = getTexture(json.specularIntensityMap);
        if (json.specularColorMap !== undefined) material.specularColorMap = getTexture(json.specularColorMap);
        if (json.envMap !== undefined) material.envMap = getTexture(json.envMap);
        if (json.envMapRotation !== undefined) material.envMapRotation.fromArray(json.envMapRotation);
        if (json.envMapIntensity !== undefined) material.envMapIntensity = json.envMapIntensity;
        if (json.reflectivity !== undefined) material.reflectivity = json.reflectivity;
        if (json.refractionRatio !== undefined) material.refractionRatio = json.refractionRatio;
        if (json.lightMap !== undefined) material.lightMap = getTexture(json.lightMap);
        if (json.lightMapIntensity !== undefined) material.lightMapIntensity = json.lightMapIntensity;
        if (json.aoMap !== undefined) material.aoMap = getTexture(json.aoMap);
        if (json.aoMapIntensity !== undefined) material.aoMapIntensity = json.aoMapIntensity;
        if (json.gradientMap !== undefined) material.gradientMap = getTexture(json.gradientMap);
        if (json.clearcoatMap !== undefined) material.clearcoatMap = getTexture(json.clearcoatMap);
        if (json.clearcoatRoughnessMap !== undefined) material.clearcoatRoughnessMap = getTexture(json.clearcoatRoughnessMap);
        if (json.clearcoatNormalMap !== undefined) material.clearcoatNormalMap = getTexture(json.clearcoatNormalMap);
        if (json.clearcoatNormalScale !== undefined) material.clearcoatNormalScale = new $9ddd7e9b53f7a2d4$export$c977b3e384af9ae1().fromArray(json.clearcoatNormalScale);
        if (json.iridescenceMap !== undefined) material.iridescenceMap = getTexture(json.iridescenceMap);
        if (json.iridescenceThicknessMap !== undefined) material.iridescenceThicknessMap = getTexture(json.iridescenceThicknessMap);
        if (json.transmissionMap !== undefined) material.transmissionMap = getTexture(json.transmissionMap);
        if (json.thicknessMap !== undefined) material.thicknessMap = getTexture(json.thicknessMap);
        if (json.anisotropyMap !== undefined) material.anisotropyMap = getTexture(json.anisotropyMap);
        if (json.sheenColorMap !== undefined) material.sheenColorMap = getTexture(json.sheenColorMap);
        if (json.sheenRoughnessMap !== undefined) material.sheenRoughnessMap = getTexture(json.sheenRoughnessMap);
        return material;
    }
    /**
	 * Textures are not embedded in the material JSON so they have
	 * to be injected before the loading process starts.
	 *
	 * @param {Object} value - A dictionary holding textures for material properties.
	 * @return {MaterialLoader} A reference to this material loader.
	 */ setTextures(value) {
        this.textures = value;
        return this;
    }
    /**
	 * Creates a material for the given type.
	 *
	 * @param {string} type - The material type.
	 * @return {Material} The new material.
	 */ createMaterialFromType(type) {
        return $9ddd7e9b53f7a2d4$export$3bd6d323353dcf96.createMaterialFromType(type);
    }
    /**
	 * Creates a material for the given type.
	 *
	 * @static
	 * @param {string} type - The material type.
	 * @return {Material} The new material.
	 */ static createMaterialFromType(type) {
        const materialLib = {
            ShadowMaterial: $9ddd7e9b53f7a2d4$export$e8564da406055a3,
            SpriteMaterial: $9ddd7e9b53f7a2d4$export$5ec7dd1c6994bf8e,
            RawShaderMaterial: $9ddd7e9b53f7a2d4$export$21c421a2e1df9d22,
            ShaderMaterial: $9ddd7e9b53f7a2d4$export$83c7d75d550a8b0d,
            PointsMaterial: $9ddd7e9b53f7a2d4$export$a178c45366ce5d6b,
            MeshPhysicalMaterial: $9ddd7e9b53f7a2d4$export$28d04986c4269c9f,
            MeshStandardMaterial: $9ddd7e9b53f7a2d4$export$f2980790215acccd,
            MeshPhongMaterial: $9ddd7e9b53f7a2d4$export$24c72f71cbaf0678,
            MeshToonMaterial: $9ddd7e9b53f7a2d4$export$df893cf97e765622,
            MeshNormalMaterial: $9ddd7e9b53f7a2d4$export$bfe8c0a091f41ae7,
            MeshLambertMaterial: $9ddd7e9b53f7a2d4$export$5023a9a8114806b8,
            MeshDepthMaterial: $9ddd7e9b53f7a2d4$export$2698c22ec13825db,
            MeshDistanceMaterial: $9ddd7e9b53f7a2d4$export$33e187ed002f2a19,
            MeshBasicMaterial: $9ddd7e9b53f7a2d4$export$55cbcc9b622fe1f5,
            MeshMatcapMaterial: $9ddd7e9b53f7a2d4$export$6f5fef6235ec12ee,
            LineDashedMaterial: $9ddd7e9b53f7a2d4$export$327886a3efaeaebe,
            LineBasicMaterial: $9ddd7e9b53f7a2d4$export$fbaaa33907730a0c,
            Material: $9ddd7e9b53f7a2d4$export$a2d8b23205c25948
        };
        return new materialLib[type]();
    }
}
/**
 * A class with loader utility functions.
 */ class $9ddd7e9b53f7a2d4$export$b5d2dc08d867e41a {
    /**
	 * Extracts the base URL from the given URL.
	 *
	 * @param {string} url -The URL to extract the base URL from.
	 * @return {string} The extracted base URL.
	 */ static extractUrlBase(url) {
        const index = url.lastIndexOf('/');
        if (index === -1) return './';
        return url.slice(0, index + 1);
    }
    /**
	 * Resolves relative URLs against the given path. Absolute paths, data urls,
	 * and blob URLs will be returned as is. Invalid URLs will return an empty
	 * string.
	 *
	 * @param {string} url -The URL to resolve.
	 * @param {string} path - The base path for relative URLs to be resolved against.
	 * @return {string} The resolved URL.
	 */ static resolveURL(url, path) {
        // Invalid URL
        if (typeof url !== 'string' || url === '') return '';
        // Host Relative URL
        if (/^https?:\/\//i.test(path) && /^\//.test(url)) path = path.replace(/(^https?:\/\/[^\/]+).*/i, '$1');
        // Absolute URL http://,https://,//
        if (/^(https?:)?\/\//i.test(url)) return url;
        // Data URI
        if (/^data:.*,.*$/i.test(url)) return url;
        // Blob URL
        if (/^blob:.*$/i.test(url)) return url;
        // Relative URL
        return path + url;
    }
}
/**
 * An instanced version of a geometry.
 */ class $9ddd7e9b53f7a2d4$export$231f009cbe414146 extends $9ddd7e9b53f7a2d4$export$b7be63a67df8959 {
    /**
	 * Constructs a new instanced buffer geometry.
	 */ constructor(){
        super();
        /**
		 * This flag can be used for type testing.
		 *
		 * @type {boolean}
		 * @readonly
		 * @default true
		 */ this.isInstancedBufferGeometry = true;
        this.type = 'InstancedBufferGeometry';
        /**
		 * The instance count.
		 *
		 * @type {number}
		 * @default Infinity
		 */ this.instanceCount = Infinity;
    }
    copy(source) {
        super.copy(source);
        this.instanceCount = source.instanceCount;
        return this;
    }
    toJSON() {
        const data = super.toJSON();
        data.instanceCount = this.instanceCount;
        data.isInstancedBufferGeometry = true;
        return data;
    }
}
/**
 * Class for loading geometries. The files are internally
 * loaded via {@link FileLoader}.
 *
 * ```js
 * const loader = new THREE.BufferGeometryLoader();
 * const geometry = await loader.loadAsync( 'models/json/pressure.json' );
 *
 * const material = new THREE.MeshBasicMaterial( { color: 0xF5F5F5 } );
 * const object = new THREE.Mesh( geometry, material );
 * scene.add( object );
 * ```
 *
 * @augments Loader
 */ class $9ddd7e9b53f7a2d4$export$dc275bb96327833a extends $9ddd7e9b53f7a2d4$export$3b0d6d7590275603 {
    /**
	 * Constructs a new geometry loader.
	 *
	 * @param {LoadingManager} [manager] - The loading manager.
	 */ constructor(manager){
        super(manager);
    }
    /**
	 * Starts loading from the given URL and pass the loaded geometry to the `onLoad()` callback.
	 *
	 * @param {string} url - The path/URL of the file to be loaded. This can also be a data URI.
	 * @param {function(BufferGeometry)} onLoad - Executed when the loading process has been finished.
	 * @param {onProgressCallback} onProgress - Executed while the loading is in progress.
	 * @param {onErrorCallback} onError - Executed when errors occur.
	 */ load(url, onLoad, onProgress, onError) {
        const scope = this;
        const loader = new $9ddd7e9b53f7a2d4$export$98435a25b5cf7b2b(scope.manager);
        loader.setPath(scope.path);
        loader.setRequestHeader(scope.requestHeader);
        loader.setWithCredentials(scope.withCredentials);
        loader.load(url, function(text) {
            try {
                onLoad(scope.parse(JSON.parse(text)));
            } catch (e) {
                if (onError) onError(e);
                else console.error(e);
                scope.manager.itemError(url);
            }
        }, onProgress, onError);
    }
    /**
	 * Parses the given JSON object and returns a geometry.
	 *
	 * @param {Object} json - The serialized geometry.
	 * @return {BufferGeometry} The parsed geometry.
	 */ parse(json) {
        const interleavedBufferMap = {};
        const arrayBufferMap = {};
        function getInterleavedBuffer(json, uuid) {
            if (interleavedBufferMap[uuid] !== undefined) return interleavedBufferMap[uuid];
            const interleavedBuffers = json.interleavedBuffers;
            const interleavedBuffer = interleavedBuffers[uuid];
            const buffer = getArrayBuffer(json, interleavedBuffer.buffer);
            const array = $9ddd7e9b53f7a2d4$var$getTypedArray(interleavedBuffer.type, buffer);
            const ib = new $9ddd7e9b53f7a2d4$export$3d5cd879f108f53f(array, interleavedBuffer.stride);
            ib.uuid = interleavedBuffer.uuid;
            interleavedBufferMap[uuid] = ib;
            return ib;
        }
        function getArrayBuffer(json, uuid) {
            if (arrayBufferMap[uuid] !== undefined) return arrayBufferMap[uuid];
            const arrayBuffers = json.arrayBuffers;
            const arrayBuffer = arrayBuffers[uuid];
            const ab = new Uint32Array(arrayBuffer).buffer;
            arrayBufferMap[uuid] = ab;
            return ab;
        }
        const geometry = json.isInstancedBufferGeometry ? new $9ddd7e9b53f7a2d4$export$231f009cbe414146() : new $9ddd7e9b53f7a2d4$export$b7be63a67df8959();
        const index = json.data.index;
        if (index !== undefined) {
            const typedArray = $9ddd7e9b53f7a2d4$var$getTypedArray(index.type, index.array);
            geometry.setIndex(new $9ddd7e9b53f7a2d4$export$8dea267bd6bde117(typedArray, 1));
        }
        const attributes = json.data.attributes;
        for(const key in attributes){
            const attribute = attributes[key];
            let bufferAttribute;
            if (attribute.isInterleavedBufferAttribute) {
                const interleavedBuffer = getInterleavedBuffer(json.data, attribute.data);
                bufferAttribute = new $9ddd7e9b53f7a2d4$export$920b6d07334599c7(interleavedBuffer, attribute.itemSize, attribute.offset, attribute.normalized);
            } else {
                const typedArray = $9ddd7e9b53f7a2d4$var$getTypedArray(attribute.type, attribute.array);
                const bufferAttributeConstr = attribute.isInstancedBufferAttribute ? $9ddd7e9b53f7a2d4$export$32ea87a8b54d744a : $9ddd7e9b53f7a2d4$export$8dea267bd6bde117;
                bufferAttribute = new bufferAttributeConstr(typedArray, attribute.itemSize, attribute.normalized);
            }
            if (attribute.name !== undefined) bufferAttribute.name = attribute.name;
            if (attribute.usage !== undefined) bufferAttribute.setUsage(attribute.usage);
            geometry.setAttribute(key, bufferAttribute);
        }
        const morphAttributes = json.data.morphAttributes;
        if (morphAttributes) for(const key in morphAttributes){
            const attributeArray = morphAttributes[key];
            const array = [];
            for(let i = 0, il = attributeArray.length; i < il; i++){
                const attribute = attributeArray[i];
                let bufferAttribute;
                if (attribute.isInterleavedBufferAttribute) {
                    const interleavedBuffer = getInterleavedBuffer(json.data, attribute.data);
                    bufferAttribute = new $9ddd7e9b53f7a2d4$export$920b6d07334599c7(interleavedBuffer, attribute.itemSize, attribute.offset, attribute.normalized);
                } else {
                    const typedArray = $9ddd7e9b53f7a2d4$var$getTypedArray(attribute.type, attribute.array);
                    bufferAttribute = new $9ddd7e9b53f7a2d4$export$8dea267bd6bde117(typedArray, attribute.itemSize, attribute.normalized);
                }
                if (attribute.name !== undefined) bufferAttribute.name = attribute.name;
                array.push(bufferAttribute);
            }
            geometry.morphAttributes[key] = array;
        }
        const morphTargetsRelative = json.data.morphTargetsRelative;
        if (morphTargetsRelative) geometry.morphTargetsRelative = true;
        const groups = json.data.groups || json.data.drawcalls || json.data.offsets;
        if (groups !== undefined) for(let i = 0, n = groups.length; i !== n; ++i){
            const group = groups[i];
            geometry.addGroup(group.start, group.count, group.materialIndex);
        }
        const boundingSphere = json.data.boundingSphere;
        if (boundingSphere !== undefined) {
            const center = new $9ddd7e9b53f7a2d4$export$64b5c384219d3699();
            if (boundingSphere.center !== undefined) center.fromArray(boundingSphere.center);
            geometry.boundingSphere = new $9ddd7e9b53f7a2d4$export$805e8b72413ccaba(center, boundingSphere.radius);
        }
        if (json.name) geometry.name = json.name;
        if (json.userData) geometry.userData = json.userData;
        return geometry;
    }
}
/**
 * A loader for loading a JSON resource in the [JSON Object/Scene format]{@link https://github.com/mrdoob/three.js/wiki/JSON-Object-Scene-format-4}.
 * The files are internally loaded via {@link FileLoader}.
 *
 * ```js
 * const loader = new THREE.ObjectLoader();
 * const obj = await loader.loadAsync( 'models/json/example.json' );
 * scene.add( obj );
 *
 * // Alternatively, to parse a previously loaded JSON structure
 * const object = await loader.parseAsync( a_json_object );
 * scene.add( object );
 * ```
 *
 * @augments Loader
 */ class $9ddd7e9b53f7a2d4$export$40110c8505c5ad19 extends $9ddd7e9b53f7a2d4$export$3b0d6d7590275603 {
    /**
	 * Constructs a new object loader.
	 *
	 * @param {LoadingManager} [manager] - The loading manager.
	 */ constructor(manager){
        super(manager);
    }
    /**
	 * Starts loading from the given URL and pass the loaded 3D object to the `onLoad()` callback.
	 *
	 * @param {string} url - The path/URL of the file to be loaded. This can also be a data URI.
	 * @param {function(Object3D)} onLoad - Executed when the loading process has been finished.
	 * @param {onProgressCallback} onProgress - Executed while the loading is in progress.
	 * @param {onErrorCallback} onError - Executed when errors occur.
	 */ load(url, onLoad, onProgress, onError) {
        const scope = this;
        const path = this.path === '' ? $9ddd7e9b53f7a2d4$export$b5d2dc08d867e41a.extractUrlBase(url) : this.path;
        this.resourcePath = this.resourcePath || path;
        const loader = new $9ddd7e9b53f7a2d4$export$98435a25b5cf7b2b(this.manager);
        loader.setPath(this.path);
        loader.setRequestHeader(this.requestHeader);
        loader.setWithCredentials(this.withCredentials);
        loader.load(url, function(text) {
            let json = null;
            try {
                json = JSON.parse(text);
            } catch (error) {
                if (onError !== undefined) onError(error);
                console.error('THREE:ObjectLoader: Can\'t parse ' + url + '.', error.message);
                return;
            }
            const metadata = json.metadata;
            if (metadata === undefined || metadata.type === undefined || metadata.type.toLowerCase() === 'geometry') {
                if (onError !== undefined) onError(new Error('THREE.ObjectLoader: Can\'t load ' + url));
                console.error('THREE.ObjectLoader: Can\'t load ' + url);
                return;
            }
            scope.parse(json, onLoad);
        }, onProgress, onError);
    }
    /**
	 * Async version of {@link ObjectLoader#load}.
	 *
	 * @async
	 * @param {string} url - The path/URL of the file to be loaded. This can also be a data URI.
	 * @param {onProgressCallback} onProgress - Executed while the loading is in progress.
	 * @return {Promise<Object3D>} A Promise that resolves with the loaded 3D object.
	 */ async loadAsync(url, onProgress) {
        const scope = this;
        const path = this.path === '' ? $9ddd7e9b53f7a2d4$export$b5d2dc08d867e41a.extractUrlBase(url) : this.path;
        this.resourcePath = this.resourcePath || path;
        const loader = new $9ddd7e9b53f7a2d4$export$98435a25b5cf7b2b(this.manager);
        loader.setPath(this.path);
        loader.setRequestHeader(this.requestHeader);
        loader.setWithCredentials(this.withCredentials);
        const text = await loader.loadAsync(url, onProgress);
        const json = JSON.parse(text);
        const metadata = json.metadata;
        if (metadata === undefined || metadata.type === undefined || metadata.type.toLowerCase() === 'geometry') throw new Error('THREE.ObjectLoader: Can\'t load ' + url);
        return await scope.parseAsync(json);
    }
    /**
	 * Parses the given JSON. This is used internally by {@link ObjectLoader#load}
	 * but can also be used directly to parse a previously loaded JSON structure.
	 *
	 * @param {Object} json - The serialized 3D object.
	 * @param {onLoad} onLoad - Executed when all resources (e.g. textures) have been fully loaded.
	 * @return {Object3D} The parsed 3D object.
	 */ parse(json, onLoad) {
        const animations = this.parseAnimations(json.animations);
        const shapes = this.parseShapes(json.shapes);
        const geometries = this.parseGeometries(json.geometries, shapes);
        const images = this.parseImages(json.images, function() {
            if (onLoad !== undefined) onLoad(object);
        });
        const textures = this.parseTextures(json.textures, images);
        const materials = this.parseMaterials(json.materials, textures);
        const object = this.parseObject(json.object, geometries, materials, textures, animations);
        const skeletons = this.parseSkeletons(json.skeletons, object);
        this.bindSkeletons(object, skeletons);
        this.bindLightTargets(object);
        //
        if (onLoad !== undefined) {
            let hasImages = false;
            for(const uuid in images)if (images[uuid].data instanceof HTMLImageElement) {
                hasImages = true;
                break;
            }
            if (hasImages === false) onLoad(object);
        }
        return object;
    }
    /**
	 * Async version of {@link ObjectLoader#parse}.
	 *
	 * @param {Object} json - The serialized 3D object.
	 * @return {Promise<Object3D>} A Promise that resolves with the parsed 3D object.
	 */ async parseAsync(json) {
        const animations = this.parseAnimations(json.animations);
        const shapes = this.parseShapes(json.shapes);
        const geometries = this.parseGeometries(json.geometries, shapes);
        const images = await this.parseImagesAsync(json.images);
        const textures = this.parseTextures(json.textures, images);
        const materials = this.parseMaterials(json.materials, textures);
        const object = this.parseObject(json.object, geometries, materials, textures, animations);
        const skeletons = this.parseSkeletons(json.skeletons, object);
        this.bindSkeletons(object, skeletons);
        this.bindLightTargets(object);
        return object;
    }
    // internals
    parseShapes(json) {
        const shapes = {};
        if (json !== undefined) for(let i = 0, l = json.length; i < l; i++){
            const shape = new $9ddd7e9b53f7a2d4$export$6428a7f2611ef1fa().fromJSON(json[i]);
            shapes[shape.uuid] = shape;
        }
        return shapes;
    }
    parseSkeletons(json, object) {
        const skeletons = {};
        const bones = {};
        // generate bone lookup table
        object.traverse(function(child) {
            if (child.isBone) bones[child.uuid] = child;
        });
        // create skeletons
        if (json !== undefined) for(let i = 0, l = json.length; i < l; i++){
            const skeleton = new $9ddd7e9b53f7a2d4$export$8f31e4c4a37b8e9c().fromJSON(json[i], bones);
            skeletons[skeleton.uuid] = skeleton;
        }
        return skeletons;
    }
    parseGeometries(json, shapes) {
        const geometries = {};
        if (json !== undefined) {
            const bufferGeometryLoader = new $9ddd7e9b53f7a2d4$export$dc275bb96327833a();
            for(let i = 0, l = json.length; i < l; i++){
                let geometry;
                const data = json[i];
                switch(data.type){
                    case 'BufferGeometry':
                    case 'InstancedBufferGeometry':
                        geometry = bufferGeometryLoader.parse(data);
                        break;
                    default:
                        if (data.type in $9ddd7e9b53f7a2d4$var$Geometries) geometry = $9ddd7e9b53f7a2d4$var$Geometries[data.type].fromJSON(data, shapes);
                        else console.warn(`THREE.ObjectLoader: Unsupported geometry type "${data.type}"`);
                }
                geometry.uuid = data.uuid;
                if (data.name !== undefined) geometry.name = data.name;
                if (data.userData !== undefined) geometry.userData = data.userData;
                geometries[data.uuid] = geometry;
            }
        }
        return geometries;
    }
    parseMaterials(json, textures) {
        const cache = {}; // MultiMaterial
        const materials = {};
        if (json !== undefined) {
            const loader = new $9ddd7e9b53f7a2d4$export$3bd6d323353dcf96();
            loader.setTextures(textures);
            for(let i = 0, l = json.length; i < l; i++){
                const data = json[i];
                if (cache[data.uuid] === undefined) cache[data.uuid] = loader.parse(data);
                materials[data.uuid] = cache[data.uuid];
            }
        }
        return materials;
    }
    parseAnimations(json) {
        const animations = {};
        if (json !== undefined) for(let i = 0; i < json.length; i++){
            const data = json[i];
            const clip = $9ddd7e9b53f7a2d4$export$d942c706bf23829c.parse(data);
            animations[clip.uuid] = clip;
        }
        return animations;
    }
    parseImages(json, onLoad) {
        const scope = this;
        const images = {};
        let loader;
        function loadImage(url) {
            scope.manager.itemStart(url);
            return loader.load(url, function() {
                scope.manager.itemEnd(url);
            }, undefined, function() {
                scope.manager.itemError(url);
                scope.manager.itemEnd(url);
            });
        }
        function deserializeImage(image) {
            if (typeof image === 'string') {
                const url = image;
                const path = /^(\/\/)|([a-z]+:(\/\/)?)/i.test(url) ? url : scope.resourcePath + url;
                return loadImage(path);
            } else {
                if (image.data) return {
                    data: $9ddd7e9b53f7a2d4$var$getTypedArray(image.type, image.data),
                    width: image.width,
                    height: image.height
                };
                else return null;
            }
        }
        if (json !== undefined && json.length > 0) {
            const manager = new $9ddd7e9b53f7a2d4$export$99cc795e99919eed(onLoad);
            loader = new $9ddd7e9b53f7a2d4$export$8905ce1c7a2464a1(manager);
            loader.setCrossOrigin(this.crossOrigin);
            for(let i = 0, il = json.length; i < il; i++){
                const image = json[i];
                const url = image.url;
                if (Array.isArray(url)) {
                    // load array of images e.g CubeTexture
                    const imageArray = [];
                    for(let j = 0, jl = url.length; j < jl; j++){
                        const currentUrl = url[j];
                        const deserializedImage = deserializeImage(currentUrl);
                        if (deserializedImage !== null) {
                            if (deserializedImage instanceof HTMLImageElement) imageArray.push(deserializedImage);
                            else // special case: handle array of data textures for cube textures
                            imageArray.push(new $9ddd7e9b53f7a2d4$export$b691f601014eabe1(deserializedImage.data, deserializedImage.width, deserializedImage.height));
                        }
                    }
                    images[image.uuid] = new $9ddd7e9b53f7a2d4$export$1d2df86270c81ecb(imageArray);
                } else {
                    // load single image
                    const deserializedImage = deserializeImage(image.url);
                    images[image.uuid] = new $9ddd7e9b53f7a2d4$export$1d2df86270c81ecb(deserializedImage);
                }
            }
        }
        return images;
    }
    async parseImagesAsync(json) {
        const scope = this;
        const images = {};
        let loader;
        async function deserializeImage(image) {
            if (typeof image === 'string') {
                const url = image;
                const path = /^(\/\/)|([a-z]+:(\/\/)?)/i.test(url) ? url : scope.resourcePath + url;
                return await loader.loadAsync(path);
            } else {
                if (image.data) return {
                    data: $9ddd7e9b53f7a2d4$var$getTypedArray(image.type, image.data),
                    width: image.width,
                    height: image.height
                };
                else return null;
            }
        }
        if (json !== undefined && json.length > 0) {
            loader = new $9ddd7e9b53f7a2d4$export$8905ce1c7a2464a1(this.manager);
            loader.setCrossOrigin(this.crossOrigin);
            for(let i = 0, il = json.length; i < il; i++){
                const image = json[i];
                const url = image.url;
                if (Array.isArray(url)) {
                    // load array of images e.g CubeTexture
                    const imageArray = [];
                    for(let j = 0, jl = url.length; j < jl; j++){
                        const currentUrl = url[j];
                        const deserializedImage = await deserializeImage(currentUrl);
                        if (deserializedImage !== null) {
                            if (deserializedImage instanceof HTMLImageElement) imageArray.push(deserializedImage);
                            else // special case: handle array of data textures for cube textures
                            imageArray.push(new $9ddd7e9b53f7a2d4$export$b691f601014eabe1(deserializedImage.data, deserializedImage.width, deserializedImage.height));
                        }
                    }
                    images[image.uuid] = new $9ddd7e9b53f7a2d4$export$1d2df86270c81ecb(imageArray);
                } else {
                    // load single image
                    const deserializedImage = await deserializeImage(image.url);
                    images[image.uuid] = new $9ddd7e9b53f7a2d4$export$1d2df86270c81ecb(deserializedImage);
                }
            }
        }
        return images;
    }
    parseTextures(json, images) {
        function parseConstant(value, type) {
            if (typeof value === 'number') return value;
            console.warn('THREE.ObjectLoader.parseTexture: Constant should be in numeric form.', value);
            return type[value];
        }
        const textures = {};
        if (json !== undefined) for(let i = 0, l = json.length; i < l; i++){
            const data = json[i];
            if (data.image === undefined) console.warn('THREE.ObjectLoader: No "image" specified for', data.uuid);
            if (images[data.image] === undefined) console.warn('THREE.ObjectLoader: Undefined image', data.image);
            const source = images[data.image];
            const image = source.data;
            let texture;
            if (Array.isArray(image)) {
                texture = new $9ddd7e9b53f7a2d4$export$ee2e5a18258a4049();
                if (image.length === 6) texture.needsUpdate = true;
            } else {
                if (image && image.data) texture = new $9ddd7e9b53f7a2d4$export$b691f601014eabe1();
                else texture = new $9ddd7e9b53f7a2d4$export$5431306cf43de24a();
                if (image) texture.needsUpdate = true; // textures can have undefined image data
            }
            texture.source = source;
            texture.uuid = data.uuid;
            if (data.name !== undefined) texture.name = data.name;
            if (data.mapping !== undefined) texture.mapping = parseConstant(data.mapping, $9ddd7e9b53f7a2d4$var$TEXTURE_MAPPING);
            if (data.channel !== undefined) texture.channel = data.channel;
            if (data.offset !== undefined) texture.offset.fromArray(data.offset);
            if (data.repeat !== undefined) texture.repeat.fromArray(data.repeat);
            if (data.center !== undefined) texture.center.fromArray(data.center);
            if (data.rotation !== undefined) texture.rotation = data.rotation;
            if (data.wrap !== undefined) {
                texture.wrapS = parseConstant(data.wrap[0], $9ddd7e9b53f7a2d4$var$TEXTURE_WRAPPING);
                texture.wrapT = parseConstant(data.wrap[1], $9ddd7e9b53f7a2d4$var$TEXTURE_WRAPPING);
            }
            if (data.format !== undefined) texture.format = data.format;
            if (data.internalFormat !== undefined) texture.internalFormat = data.internalFormat;
            if (data.type !== undefined) texture.type = data.type;
            if (data.colorSpace !== undefined) texture.colorSpace = data.colorSpace;
            if (data.minFilter !== undefined) texture.minFilter = parseConstant(data.minFilter, $9ddd7e9b53f7a2d4$var$TEXTURE_FILTER);
            if (data.magFilter !== undefined) texture.magFilter = parseConstant(data.magFilter, $9ddd7e9b53f7a2d4$var$TEXTURE_FILTER);
            if (data.anisotropy !== undefined) texture.anisotropy = data.anisotropy;
            if (data.flipY !== undefined) texture.flipY = data.flipY;
            if (data.generateMipmaps !== undefined) texture.generateMipmaps = data.generateMipmaps;
            if (data.premultiplyAlpha !== undefined) texture.premultiplyAlpha = data.premultiplyAlpha;
            if (data.unpackAlignment !== undefined) texture.unpackAlignment = data.unpackAlignment;
            if (data.compareFunction !== undefined) texture.compareFunction = data.compareFunction;
            if (data.userData !== undefined) texture.userData = data.userData;
            textures[data.uuid] = texture;
        }
        return textures;
    }
    parseObject(data, geometries, materials, textures, animations) {
        let object;
        function getGeometry(name) {
            if (geometries[name] === undefined) console.warn('THREE.ObjectLoader: Undefined geometry', name);
            return geometries[name];
        }
        function getMaterial(name) {
            if (name === undefined) return undefined;
            if (Array.isArray(name)) {
                const array = [];
                for(let i = 0, l = name.length; i < l; i++){
                    const uuid = name[i];
                    if (materials[uuid] === undefined) console.warn('THREE.ObjectLoader: Undefined material', uuid);
                    array.push(materials[uuid]);
                }
                return array;
            }
            if (materials[name] === undefined) console.warn('THREE.ObjectLoader: Undefined material', name);
            return materials[name];
        }
        function getTexture(uuid) {
            if (textures[uuid] === undefined) console.warn('THREE.ObjectLoader: Undefined texture', uuid);
            return textures[uuid];
        }
        let geometry, material;
        switch(data.type){
            case 'Scene':
                object = new $9ddd7e9b53f7a2d4$export$38af1803e3442a7f();
                if (data.background !== undefined) {
                    if (Number.isInteger(data.background)) object.background = new $9ddd7e9b53f7a2d4$export$892596cec99bc70e(data.background);
                    else object.background = getTexture(data.background);
                }
                if (data.environment !== undefined) object.environment = getTexture(data.environment);
                if (data.fog !== undefined) {
                    if (data.fog.type === 'Fog') object.fog = new $9ddd7e9b53f7a2d4$export$3c890837b09508d4(data.fog.color, data.fog.near, data.fog.far);
                    else if (data.fog.type === 'FogExp2') object.fog = new $9ddd7e9b53f7a2d4$export$6f1519f023b8d0f6(data.fog.color, data.fog.density);
                    if (data.fog.name !== '') object.fog.name = data.fog.name;
                }
                if (data.backgroundBlurriness !== undefined) object.backgroundBlurriness = data.backgroundBlurriness;
                if (data.backgroundIntensity !== undefined) object.backgroundIntensity = data.backgroundIntensity;
                if (data.backgroundRotation !== undefined) object.backgroundRotation.fromArray(data.backgroundRotation);
                if (data.environmentIntensity !== undefined) object.environmentIntensity = data.environmentIntensity;
                if (data.environmentRotation !== undefined) object.environmentRotation.fromArray(data.environmentRotation);
                break;
            case 'PerspectiveCamera':
                object = new $9ddd7e9b53f7a2d4$export$74e4ae24825f68d7(data.fov, data.aspect, data.near, data.far);
                if (data.focus !== undefined) object.focus = data.focus;
                if (data.zoom !== undefined) object.zoom = data.zoom;
                if (data.filmGauge !== undefined) object.filmGauge = data.filmGauge;
                if (data.filmOffset !== undefined) object.filmOffset = data.filmOffset;
                if (data.view !== undefined) object.view = Object.assign({}, data.view);
                break;
            case 'OrthographicCamera':
                object = new $9ddd7e9b53f7a2d4$export$9ebf355ee4ed261b(data.left, data.right, data.top, data.bottom, data.near, data.far);
                if (data.zoom !== undefined) object.zoom = data.zoom;
                if (data.view !== undefined) object.view = Object.assign({}, data.view);
                break;
            case 'AmbientLight':
                object = new $9ddd7e9b53f7a2d4$export$af279bfef9ec2c96(data.color, data.intensity);
                break;
            case 'DirectionalLight':
                object = new $9ddd7e9b53f7a2d4$export$3fea33cc9972c868(data.color, data.intensity);
                object.target = data.target || '';
                break;
            case 'PointLight':
                object = new $9ddd7e9b53f7a2d4$export$4c9c1cb3f0b6f455(data.color, data.intensity, data.distance, data.decay);
                break;
            case 'RectAreaLight':
                object = new $9ddd7e9b53f7a2d4$export$61db2d908bbd2429(data.color, data.intensity, data.width, data.height);
                break;
            case 'SpotLight':
                object = new $9ddd7e9b53f7a2d4$export$81495cbb73897362(data.color, data.intensity, data.distance, data.angle, data.penumbra, data.decay);
                object.target = data.target || '';
                break;
            case 'HemisphereLight':
                object = new $9ddd7e9b53f7a2d4$export$8d474f55edbb9624(data.color, data.groundColor, data.intensity);
                break;
            case 'LightProbe':
                object = new $9ddd7e9b53f7a2d4$export$e7ef036e309b38d2().fromJSON(data);
                break;
            case 'SkinnedMesh':
                geometry = getGeometry(data.geometry);
                material = getMaterial(data.material);
                object = new $9ddd7e9b53f7a2d4$export$b303577035157ecf(geometry, material);
                if (data.bindMode !== undefined) object.bindMode = data.bindMode;
                if (data.bindMatrix !== undefined) object.bindMatrix.fromArray(data.bindMatrix);
                if (data.skeleton !== undefined) object.skeleton = data.skeleton;
                break;
            case 'Mesh':
                geometry = getGeometry(data.geometry);
                material = getMaterial(data.material);
                object = new $9ddd7e9b53f7a2d4$export$e176487c05830cc5(geometry, material);
                break;
            case 'InstancedMesh':
                geometry = getGeometry(data.geometry);
                material = getMaterial(data.material);
                const count = data.count;
                const instanceMatrix = data.instanceMatrix;
                const instanceColor = data.instanceColor;
                object = new $9ddd7e9b53f7a2d4$export$f3c979c331175ad7(geometry, material, count);
                object.instanceMatrix = new $9ddd7e9b53f7a2d4$export$32ea87a8b54d744a(new Float32Array(instanceMatrix.array), 16);
                if (instanceColor !== undefined) object.instanceColor = new $9ddd7e9b53f7a2d4$export$32ea87a8b54d744a(new Float32Array(instanceColor.array), instanceColor.itemSize);
                break;
            case 'BatchedMesh':
                geometry = getGeometry(data.geometry);
                material = getMaterial(data.material);
                object = new $9ddd7e9b53f7a2d4$export$6e01c5ee52ed8f7b(data.maxInstanceCount, data.maxVertexCount, data.maxIndexCount, material);
                object.geometry = geometry;
                object.perObjectFrustumCulled = data.perObjectFrustumCulled;
                object.sortObjects = data.sortObjects;
                object._drawRanges = data.drawRanges;
                object._reservedRanges = data.reservedRanges;
                object._visibility = data.visibility;
                object._active = data.active;
                object._bounds = data.bounds.map((bound)=>{
                    const box = new $9ddd7e9b53f7a2d4$export$6f7d5a9418ab2aa3();
                    box.min.fromArray(bound.boxMin);
                    box.max.fromArray(bound.boxMax);
                    const sphere = new $9ddd7e9b53f7a2d4$export$805e8b72413ccaba();
                    sphere.radius = bound.sphereRadius;
                    sphere.center.fromArray(bound.sphereCenter);
                    return {
                        boxInitialized: bound.boxInitialized,
                        box: box,
                        sphereInitialized: bound.sphereInitialized,
                        sphere: sphere
                    };
                });
                object._maxInstanceCount = data.maxInstanceCount;
                object._maxVertexCount = data.maxVertexCount;
                object._maxIndexCount = data.maxIndexCount;
                object._geometryInitialized = data.geometryInitialized;
                object._geometryCount = data.geometryCount;
                object._matricesTexture = getTexture(data.matricesTexture.uuid);
                if (data.colorsTexture !== undefined) object._colorsTexture = getTexture(data.colorsTexture.uuid);
                break;
            case 'LOD':
                object = new $9ddd7e9b53f7a2d4$export$112e7237be0c5f30();
                break;
            case 'Line':
                object = new $9ddd7e9b53f7a2d4$export$17d680238e50603e(getGeometry(data.geometry), getMaterial(data.material));
                break;
            case 'LineLoop':
                object = new $9ddd7e9b53f7a2d4$export$f85a24d745e4f17d(getGeometry(data.geometry), getMaterial(data.material));
                break;
            case 'LineSegments':
                object = new $9ddd7e9b53f7a2d4$export$ff1ed10fedfdd604(getGeometry(data.geometry), getMaterial(data.material));
                break;
            case 'PointCloud':
            case 'Points':
                object = new $9ddd7e9b53f7a2d4$export$1c787534cb11aa3e(getGeometry(data.geometry), getMaterial(data.material));
                break;
            case 'Sprite':
                object = new $9ddd7e9b53f7a2d4$export$3075603db8e6204c(getMaterial(data.material));
                break;
            case 'Group':
                object = new $9ddd7e9b53f7a2d4$export$eb2fcfdbd7ba97d4();
                break;
            case 'Bone':
                object = new $9ddd7e9b53f7a2d4$export$b127726e56765aa4();
                break;
            default:
                object = new $9ddd7e9b53f7a2d4$export$e4dd07dff30cc924();
        }
        object.uuid = data.uuid;
        if (data.name !== undefined) object.name = data.name;
        if (data.matrix !== undefined) {
            object.matrix.fromArray(data.matrix);
            if (data.matrixAutoUpdate !== undefined) object.matrixAutoUpdate = data.matrixAutoUpdate;
            if (object.matrixAutoUpdate) object.matrix.decompose(object.position, object.quaternion, object.scale);
        } else {
            if (data.position !== undefined) object.position.fromArray(data.position);
            if (data.rotation !== undefined) object.rotation.fromArray(data.rotation);
            if (data.quaternion !== undefined) object.quaternion.fromArray(data.quaternion);
            if (data.scale !== undefined) object.scale.fromArray(data.scale);
        }
        if (data.up !== undefined) object.up.fromArray(data.up);
        if (data.castShadow !== undefined) object.castShadow = data.castShadow;
        if (data.receiveShadow !== undefined) object.receiveShadow = data.receiveShadow;
        if (data.shadow) {
            if (data.shadow.intensity !== undefined) object.shadow.intensity = data.shadow.intensity;
            if (data.shadow.bias !== undefined) object.shadow.bias = data.shadow.bias;
            if (data.shadow.normalBias !== undefined) object.shadow.normalBias = data.shadow.normalBias;
            if (data.shadow.radius !== undefined) object.shadow.radius = data.shadow.radius;
            if (data.shadow.mapSize !== undefined) object.shadow.mapSize.fromArray(data.shadow.mapSize);
            if (data.shadow.camera !== undefined) object.shadow.camera = this.parseObject(data.shadow.camera);
        }
        if (data.visible !== undefined) object.visible = data.visible;
        if (data.frustumCulled !== undefined) object.frustumCulled = data.frustumCulled;
        if (data.renderOrder !== undefined) object.renderOrder = data.renderOrder;
        if (data.userData !== undefined) object.userData = data.userData;
        if (data.layers !== undefined) object.layers.mask = data.layers;
        if (data.children !== undefined) {
            const children = data.children;
            for(let i = 0; i < children.length; i++)object.add(this.parseObject(children[i], geometries, materials, textures, animations));
        }
        if (data.animations !== undefined) {
            const objectAnimations = data.animations;
            for(let i = 0; i < objectAnimations.length; i++){
                const uuid = objectAnimations[i];
                object.animations.push(animations[uuid]);
            }
        }
        if (data.type === 'LOD') {
            if (data.autoUpdate !== undefined) object.autoUpdate = data.autoUpdate;
            const levels = data.levels;
            for(let l = 0; l < levels.length; l++){
                const level = levels[l];
                const child = object.getObjectByProperty('uuid', level.object);
                if (child !== undefined) object.addLevel(child, level.distance, level.hysteresis);
            }
        }
        return object;
    }
    bindSkeletons(object, skeletons) {
        if (Object.keys(skeletons).length === 0) return;
        object.traverse(function(child) {
            if (child.isSkinnedMesh === true && child.skeleton !== undefined) {
                const skeleton = skeletons[child.skeleton];
                if (skeleton === undefined) console.warn('THREE.ObjectLoader: No skeleton found with UUID:', child.skeleton);
                else child.bind(skeleton, child.bindMatrix);
            }
        });
    }
    bindLightTargets(object) {
        object.traverse(function(child) {
            if (child.isDirectionalLight || child.isSpotLight) {
                const uuid = child.target;
                const target = object.getObjectByProperty('uuid', uuid);
                if (target !== undefined) child.target = target;
                else child.target = new $9ddd7e9b53f7a2d4$export$e4dd07dff30cc924();
            }
        });
    }
}
const $9ddd7e9b53f7a2d4$var$TEXTURE_MAPPING = {
    UVMapping: $9ddd7e9b53f7a2d4$export$1beec6768cbb3d2d,
    CubeReflectionMapping: $9ddd7e9b53f7a2d4$export$8759762a6477f2c4,
    CubeRefractionMapping: $9ddd7e9b53f7a2d4$export$dc59f8aed047f61d,
    EquirectangularReflectionMapping: $9ddd7e9b53f7a2d4$export$d64030b316d3b087,
    EquirectangularRefractionMapping: $9ddd7e9b53f7a2d4$export$ee99d97d46898098,
    CubeUVReflectionMapping: $9ddd7e9b53f7a2d4$export$dbf3e70ff37af79
};
const $9ddd7e9b53f7a2d4$var$TEXTURE_WRAPPING = {
    RepeatWrapping: $9ddd7e9b53f7a2d4$export$533346c8e8dac0f5,
    ClampToEdgeWrapping: $9ddd7e9b53f7a2d4$export$9d9334239a5a5e06,
    MirroredRepeatWrapping: $9ddd7e9b53f7a2d4$export$c7e7c00b14f51a4f
};
const $9ddd7e9b53f7a2d4$var$TEXTURE_FILTER = {
    NearestFilter: $9ddd7e9b53f7a2d4$export$727aa5ec3fe39bf0,
    NearestMipmapNearestFilter: $9ddd7e9b53f7a2d4$export$d129e38cf6feaa8c,
    NearestMipmapLinearFilter: $9ddd7e9b53f7a2d4$export$d2327c1afe5bfdf2,
    LinearFilter: $9ddd7e9b53f7a2d4$export$8a72f490b25c56c8,
    LinearMipmapNearestFilter: $9ddd7e9b53f7a2d4$export$19a719f377145a13,
    LinearMipmapLinearFilter: $9ddd7e9b53f7a2d4$export$5d8599b6a933fb1b
};
/**
 * A loader for loading images as an [ImageBitmap]{@link https://developer.mozilla.org/en-US/docs/Web/API/ImageBitmap}.
 * An `ImageBitmap` provides an asynchronous and resource efficient pathway to prepare
 * textures for rendering.
 *
 * Note that {@link Texture#flipY} and {@link Texture#premultiplyAlpha} are ignored with image bitmaps.
 * They needs these configuration on bitmap creation unlike regular images need them on uploading to GPU.
 *
 * You need to set the equivalent options via {@link ImageBitmapLoader#setOptions} instead.
 *
 * Also note that unlike {@link FileLoader}, this loader does not avoid multiple concurrent requests to the same URL.
 *
 * ```js
 * const loader = new THREE.ImageBitmapLoader();
 * loader.setOptions( { imageOrientation: 'flipY' } ); // set options if needed
 * const imageBitmap = await loader.loadAsync( 'image.png' );
 *
 * const texture = new THREE.Texture( imageBitmap );
 * texture.needsUpdate = true;
 * ```
 *
 * @augments Loader
 */ class $9ddd7e9b53f7a2d4$export$52286b55c4a9b51f extends $9ddd7e9b53f7a2d4$export$3b0d6d7590275603 {
    /**
	 * Constructs a new image bitmap loader.
	 *
	 * @param {LoadingManager} [manager] - The loading manager.
	 */ constructor(manager){
        super(manager);
        /**
		 * This flag can be used for type testing.
		 *
		 * @type {boolean}
		 * @readonly
		 * @default true
		 */ this.isImageBitmapLoader = true;
        if (typeof createImageBitmap === 'undefined') console.warn('THREE.ImageBitmapLoader: createImageBitmap() not supported.');
        if (typeof fetch === 'undefined') console.warn('THREE.ImageBitmapLoader: fetch() not supported.');
        /**
		 * Represents the loader options.
		 *
		 * @type {Object}
		 * @default {premultiplyAlpha:'none'}
		 */ this.options = {
            premultiplyAlpha: 'none'
        };
    }
    /**
	 * Sets the given loader options. The structure of the object must match the `options` parameter of
	 * [createImageBitmap]{@link https://developer.mozilla.org/en-US/docs/Web/API/Window/createImageBitmap}.
	 *
	 * @param {Object} options - The loader options to set.
	 * @return {ImageBitmapLoader} A reference to this image bitmap loader.
	 */ setOptions(options) {
        this.options = options;
        return this;
    }
    /**
	 * Starts loading from the given URL and pass the loaded image bitmap to the `onLoad()` callback.
	 *
	 * @param {string} url - The path/URL of the file to be loaded. This can also be a data URI.
	 * @param {function(ImageBitmap)} onLoad - Executed when the loading process has been finished.
	 * @param {onProgressCallback} onProgress - Unsupported in this loader.
	 * @param {onErrorCallback} onError - Executed when errors occur.
	 * @return {ImageBitmap|undefined} The image bitmap.
	 */ load(url, onLoad, onProgress, onError) {
        if (url === undefined) url = '';
        if (this.path !== undefined) url = this.path + url;
        url = this.manager.resolveURL(url);
        const scope = this;
        const cached = $9ddd7e9b53f7a2d4$export$94affb487e701bf2.get(url);
        if (cached !== undefined) {
            scope.manager.itemStart(url);
            // If cached is a promise, wait for it to resolve
            if (cached.then) {
                cached.then((imageBitmap)=>{
                    if (onLoad) onLoad(imageBitmap);
                    scope.manager.itemEnd(url);
                }).catch((e)=>{
                    if (onError) onError(e);
                });
                return;
            }
            // If cached is not a promise (i.e., it's already an imageBitmap)
            setTimeout(function() {
                if (onLoad) onLoad(cached);
                scope.manager.itemEnd(url);
            }, 0);
            return cached;
        }
        const fetchOptions = {};
        fetchOptions.credentials = this.crossOrigin === 'anonymous' ? 'same-origin' : 'include';
        fetchOptions.headers = this.requestHeader;
        const promise = fetch(url, fetchOptions).then(function(res) {
            return res.blob();
        }).then(function(blob) {
            return createImageBitmap(blob, Object.assign(scope.options, {
                colorSpaceConversion: 'none'
            }));
        }).then(function(imageBitmap) {
            $9ddd7e9b53f7a2d4$export$94affb487e701bf2.add(url, imageBitmap);
            if (onLoad) onLoad(imageBitmap);
            scope.manager.itemEnd(url);
            return imageBitmap;
        }).catch(function(e) {
            if (onError) onError(e);
            $9ddd7e9b53f7a2d4$export$94affb487e701bf2.remove(url);
            scope.manager.itemError(url);
            scope.manager.itemEnd(url);
        });
        $9ddd7e9b53f7a2d4$export$94affb487e701bf2.add(url, promise);
        scope.manager.itemStart(url);
    }
}
let $9ddd7e9b53f7a2d4$var$_context;
/**
 * Manages the global audio context in the engine.
 *
 * @hideconstructor
 */ class $9ddd7e9b53f7a2d4$export$fcbc63750ec2a81f {
    /**
	 * Returns the global native audio context.
	 *
	 * @return {AudioContext} The native audio context.
	 */ static getContext() {
        if ($9ddd7e9b53f7a2d4$var$_context === undefined) $9ddd7e9b53f7a2d4$var$_context = new (window.AudioContext || window.webkitAudioContext)();
        return $9ddd7e9b53f7a2d4$var$_context;
    }
    /**
	 * Allows to set the global native audio context from outside.
	 *
	 * @param {AudioContext} value - The native context to set.
	 */ static setContext(value) {
        $9ddd7e9b53f7a2d4$var$_context = value;
    }
}
/**
 * Class for loading audio buffers. Audios are internally
 * loaded via {@link FileLoader}.
 *
 * ```js
 * const audioListener = new THREE.AudioListener();
 * const ambientSound = new THREE.Audio( audioListener );
 *
 * const loader = new THREE.AudioLoader();
 * const audioBuffer = await loader.loadAsync( 'audio/ambient_ocean.ogg' );
 *
 * ambientSound.setBuffer( audioBuffer );
 * ambientSound.play();
 * ```
 *
 * @augments Loader
 */ class $9ddd7e9b53f7a2d4$export$d8d5fccfbf47714e extends $9ddd7e9b53f7a2d4$export$3b0d6d7590275603 {
    /**
	 * Constructs a new audio loader.
	 *
	 * @param {LoadingManager} [manager] - The loading manager.
	 */ constructor(manager){
        super(manager);
    }
    /**
	 * Starts loading from the given URL and passes the loaded audio buffer
	 * to the `onLoad()` callback.
	 *
	 * @param {string} url - The path/URL of the file to be loaded. This can also be a data URI.
	 * @param {function(AudioBuffer)} onLoad - Executed when the loading process has been finished.
	 * @param {onProgressCallback} onProgress - Executed while the loading is in progress.
	 * @param {onErrorCallback} onError - Executed when errors occur.
	 */ load(url, onLoad, onProgress, onError) {
        const scope = this;
        const loader = new $9ddd7e9b53f7a2d4$export$98435a25b5cf7b2b(this.manager);
        loader.setResponseType('arraybuffer');
        loader.setPath(this.path);
        loader.setRequestHeader(this.requestHeader);
        loader.setWithCredentials(this.withCredentials);
        loader.load(url, function(buffer) {
            try {
                // Create a copy of the buffer. The `decodeAudioData` method
                // detaches the buffer when complete, preventing reuse.
                const bufferCopy = buffer.slice(0);
                const context = $9ddd7e9b53f7a2d4$export$fcbc63750ec2a81f.getContext();
                context.decodeAudioData(bufferCopy, function(audioBuffer) {
                    onLoad(audioBuffer);
                }).catch(handleError);
            } catch (e) {
                handleError(e);
            }
        }, onProgress, onError);
        function handleError(e) {
            if (onError) onError(e);
            else console.error(e);
            scope.manager.itemError(url);
        }
    }
}
const $9ddd7e9b53f7a2d4$var$_eyeRight = /*@__PURE__*/ new $9ddd7e9b53f7a2d4$export$2ae72fc923e5eb5();
const $9ddd7e9b53f7a2d4$var$_eyeLeft = /*@__PURE__*/ new $9ddd7e9b53f7a2d4$export$2ae72fc923e5eb5();
const $9ddd7e9b53f7a2d4$var$_projectionMatrix = /*@__PURE__*/ new $9ddd7e9b53f7a2d4$export$2ae72fc923e5eb5();
/**
 * A special type of camera that uses two perspective cameras with
 * stereoscopic projection. Can be used for rendering stereo effects
 * like [3D Anaglyph]{@link https://en.wikipedia.org/wiki/Anaglyph_3D} or
 * [Parallax Barrier]{@link https://en.wikipedia.org/wiki/parallax_barrier}.
 */ class $9ddd7e9b53f7a2d4$export$bc7f73a1065bee0c {
    /**
	 * Constructs a new stereo camera.
	 */ constructor(){
        /**
		 * The type property is used for detecting the object type
		 * in context of serialization/deserialization.
		 *
		 * @type {string}
		 * @readonly
		 */ this.type = 'StereoCamera';
        /**
		 * The aspect.
		 *
		 * @type {number}
		 * @default 1
		 */ this.aspect = 1;
        /**
		 * The eye separation which represents the distance
		 * between the left and right camera.
		 *
		 * @type {number}
		 * @default 0.064
		 */ this.eyeSep = 0.064;
        /**
		 * The camera representing the left eye. This is added to layer `1` so objects to be
		 * rendered by the left camera must also be added to this layer.
		 *
		 * @type {PerspectiveCamera}
		 */ this.cameraL = new $9ddd7e9b53f7a2d4$export$74e4ae24825f68d7();
        this.cameraL.layers.enable(1);
        this.cameraL.matrixAutoUpdate = false;
        /**
		 * The camera representing the right eye. This is added to layer `2` so objects to be
		 * rendered by the right camera must also be added to this layer.
		 *
		 * @type {PerspectiveCamera}
		 */ this.cameraR = new $9ddd7e9b53f7a2d4$export$74e4ae24825f68d7();
        this.cameraR.layers.enable(2);
        this.cameraR.matrixAutoUpdate = false;
        this._cache = {
            focus: null,
            fov: null,
            aspect: null,
            near: null,
            far: null,
            zoom: null,
            eyeSep: null
        };
    }
    /**
	 * Updates the stereo camera based on the given perspective camera.
	 *
	 * @param {PerspectiveCamera} camera - The perspective camera.
	 */ update(camera) {
        const cache = this._cache;
        const needsUpdate = cache.focus !== camera.focus || cache.fov !== camera.fov || cache.aspect !== camera.aspect * this.aspect || cache.near !== camera.near || cache.far !== camera.far || cache.zoom !== camera.zoom || cache.eyeSep !== this.eyeSep;
        if (needsUpdate) {
            cache.focus = camera.focus;
            cache.fov = camera.fov;
            cache.aspect = camera.aspect * this.aspect;
            cache.near = camera.near;
            cache.far = camera.far;
            cache.zoom = camera.zoom;
            cache.eyeSep = this.eyeSep;
            // Off-axis stereoscopic effect based on
            // http://paulbourke.net/stereographics/stereorender/
            $9ddd7e9b53f7a2d4$var$_projectionMatrix.copy(camera.projectionMatrix);
            const eyeSepHalf = cache.eyeSep / 2;
            const eyeSepOnProjection = eyeSepHalf * cache.near / cache.focus;
            const ymax = cache.near * Math.tan($9ddd7e9b53f7a2d4$var$DEG2RAD * cache.fov * 0.5) / cache.zoom;
            let xmin, xmax;
            // translate xOffset
            $9ddd7e9b53f7a2d4$var$_eyeLeft.elements[12] = -eyeSepHalf;
            $9ddd7e9b53f7a2d4$var$_eyeRight.elements[12] = eyeSepHalf;
            // for left eye
            xmin = -ymax * cache.aspect + eyeSepOnProjection;
            xmax = ymax * cache.aspect + eyeSepOnProjection;
            $9ddd7e9b53f7a2d4$var$_projectionMatrix.elements[0] = 2 * cache.near / (xmax - xmin);
            $9ddd7e9b53f7a2d4$var$_projectionMatrix.elements[8] = (xmax + xmin) / (xmax - xmin);
            this.cameraL.projectionMatrix.copy($9ddd7e9b53f7a2d4$var$_projectionMatrix);
            // for right eye
            xmin = -ymax * cache.aspect - eyeSepOnProjection;
            xmax = ymax * cache.aspect - eyeSepOnProjection;
            $9ddd7e9b53f7a2d4$var$_projectionMatrix.elements[0] = 2 * cache.near / (xmax - xmin);
            $9ddd7e9b53f7a2d4$var$_projectionMatrix.elements[8] = (xmax + xmin) / (xmax - xmin);
            this.cameraR.projectionMatrix.copy($9ddd7e9b53f7a2d4$var$_projectionMatrix);
        }
        this.cameraL.matrixWorld.copy(camera.matrixWorld).multiply($9ddd7e9b53f7a2d4$var$_eyeLeft);
        this.cameraR.matrixWorld.copy(camera.matrixWorld).multiply($9ddd7e9b53f7a2d4$var$_eyeRight);
    }
}
/**
 * This type of camera can be used in order to efficiently render a scene with a
 * predefined set of cameras. This is an important performance aspect for
 * rendering VR scenes.
 *
 * An instance of `ArrayCamera` always has an array of sub cameras. It's mandatory
 * to define for each sub camera the `viewport` property which determines the
 * part of the viewport that is rendered with this camera.
 *
 * @augments PerspectiveCamera
 */ class $9ddd7e9b53f7a2d4$export$56b937d9e5581166 extends $9ddd7e9b53f7a2d4$export$74e4ae24825f68d7 {
    /**
	 * Constructs a new array camera.
	 *
	 * @param {Array<PerspectiveCamera>} [array=[]] - An array of perspective sub cameras.
	 */ constructor(array = []){
        super();
        /**
		 * This flag can be used for type testing.
		 *
		 * @type {boolean}
		 * @readonly
		 * @default true
		 */ this.isArrayCamera = true;
        /**
		 * An array of perspective sub cameras.
		 *
		 * @type {Array<PerspectiveCamera>}
		 */ this.cameras = array;
        this.index = 0;
    }
}
/**
 * Class for keeping track of time.
 */ class $9ddd7e9b53f7a2d4$export$9735c82c4bae3302 {
    /**
	 * Constructs a new clock.
	 *
	 * @param {boolean} [autoStart=true] - Whether to automatically start the clock when
	 * `getDelta()` is called for the first time.
	 */ constructor(autoStart = true){
        /**
		 * If set to `true`, the clock starts automatically when `getDelta()` is called
		 * for the first time.
		 *
		 * @type {boolean}
		 * @default true
		 */ this.autoStart = autoStart;
        /**
		 * Holds the time at which the clock's `start()` method was last called.
		 *
		 * @type {number}
		 * @default 0
		 */ this.startTime = 0;
        /**
		 * Holds the time at which the clock's `start()`, `getElapsedTime()` or
		 * `getDelta()` methods were last called.
		 *
		 * @type {number}
		 * @default 0
		 */ this.oldTime = 0;
        /**
		 * Keeps track of the total time that the clock has been running.
		 *
		 * @type {number}
		 * @default 0
		 */ this.elapsedTime = 0;
        /**
		 * Whether the clock is running or not.
		 *
		 * @type {boolean}
		 * @default true
		 */ this.running = false;
    }
    /**
	 * Starts the clock. When `autoStart` is set to `true`, the method is automatically
	 * called by the class.
	 */ start() {
        this.startTime = $9ddd7e9b53f7a2d4$var$now();
        this.oldTime = this.startTime;
        this.elapsedTime = 0;
        this.running = true;
    }
    /**
	 * Stops the clock.
	 */ stop() {
        this.getElapsedTime();
        this.running = false;
        this.autoStart = false;
    }
    /**
	 * Returns the elapsed time in seconds.
	 *
	 * @return {number} The elapsed time.
	 */ getElapsedTime() {
        this.getDelta();
        return this.elapsedTime;
    }
    /**
	 * Returns the delta time in seconds.
	 *
	 * @return {number} The delta time.
	 */ getDelta() {
        let diff = 0;
        if (this.autoStart && !this.running) {
            this.start();
            return 0;
        }
        if (this.running) {
            const newTime = $9ddd7e9b53f7a2d4$var$now();
            diff = (newTime - this.oldTime) / 1000;
            this.oldTime = newTime;
            this.elapsedTime += diff;
        }
        return diff;
    }
}
function $9ddd7e9b53f7a2d4$var$now() {
    return performance.now();
}
const $9ddd7e9b53f7a2d4$var$_position$1 = /*@__PURE__*/ new $9ddd7e9b53f7a2d4$export$64b5c384219d3699();
const $9ddd7e9b53f7a2d4$var$_quaternion$1 = /*@__PURE__*/ new $9ddd7e9b53f7a2d4$export$23d6a54f0bbc85a3();
const $9ddd7e9b53f7a2d4$var$_scale$1 = /*@__PURE__*/ new $9ddd7e9b53f7a2d4$export$64b5c384219d3699();
const $9ddd7e9b53f7a2d4$var$_orientation$1 = /*@__PURE__*/ new $9ddd7e9b53f7a2d4$export$64b5c384219d3699();
/**
 * The class represents a virtual listener of the all positional and non-positional audio effects
 * in the scene. A three.js application usually creates a single listener. It is a mandatory
 * constructor parameter for audios entities like {@link Audio} and {@link PositionalAudio}.
 *
 * In most cases, the listener object is a child of the camera. So the 3D transformation of the
 * camera represents the 3D transformation of the listener.
 *
 * @augments Object3D
 */ class $9ddd7e9b53f7a2d4$export$8a1b810c6fde8951 extends $9ddd7e9b53f7a2d4$export$e4dd07dff30cc924 {
    /**
	 * Constructs a new audio listener.
	 */ constructor(){
        super();
        this.type = 'AudioListener';
        /**
		 * The native audio context.
		 *
		 * @type {AudioContext}
		 * @readonly
		 */ this.context = $9ddd7e9b53f7a2d4$export$fcbc63750ec2a81f.getContext();
        /**
		 * The gain node used for volume control.
		 *
		 * @type {GainNode}
		 * @readonly
		 */ this.gain = this.context.createGain();
        this.gain.connect(this.context.destination);
        /**
		 * An optional filter.
		 *
		 * Defined via {@link AudioListener#setFilter}.
		 *
		 * @type {?AudioNode}
		 * @default null
		 * @readonly
		 */ this.filter = null;
        /**
		 * Time delta values required for `linearRampToValueAtTime()` usage.
		 *
		 * @type {number}
		 * @default 0
		 * @readonly
		 */ this.timeDelta = 0;
        // private
        this._clock = new $9ddd7e9b53f7a2d4$export$9735c82c4bae3302();
    }
    /**
	 * Returns the listener's input node.
	 *
	 * This method is used by other audio nodes to connect to this listener.
	 *
	 * @return {GainNode} The input node.
	 */ getInput() {
        return this.gain;
    }
    /**
	 * Removes the current filter from this listener.
	 *
	 * @return {AudioListener} A reference to this listener.
	 */ removeFilter() {
        if (this.filter !== null) {
            this.gain.disconnect(this.filter);
            this.filter.disconnect(this.context.destination);
            this.gain.connect(this.context.destination);
            this.filter = null;
        }
        return this;
    }
    /**
	 * Returns the current set filter.
	 *
	 * @return {?AudioNode} The filter.
	 */ getFilter() {
        return this.filter;
    }
    /**
	 * Sets the given filter to this listener.
	 *
	 * @param {AudioNode} value - The filter to set.
	 * @return {AudioListener} A reference to this listener.
	 */ setFilter(value) {
        if (this.filter !== null) {
            this.gain.disconnect(this.filter);
            this.filter.disconnect(this.context.destination);
        } else this.gain.disconnect(this.context.destination);
        this.filter = value;
        this.gain.connect(this.filter);
        this.filter.connect(this.context.destination);
        return this;
    }
    /**
	 * Returns the applications master volume.
	 *
	 * @return {number} The master volume.
	 */ getMasterVolume() {
        return this.gain.gain.value;
    }
    /**
	 * Sets the applications master volume. This volume setting affects
	 * all audio nodes in the scene.
	 *
	 * @param {number} value - The master volume to set.
	 * @return {AudioListener} A reference to this listener.
	 */ setMasterVolume(value) {
        this.gain.gain.setTargetAtTime(value, this.context.currentTime, 0.01);
        return this;
    }
    updateMatrixWorld(force) {
        super.updateMatrixWorld(force);
        const listener = this.context.listener;
        const up = this.up;
        this.timeDelta = this._clock.getDelta();
        this.matrixWorld.decompose($9ddd7e9b53f7a2d4$var$_position$1, $9ddd7e9b53f7a2d4$var$_quaternion$1, $9ddd7e9b53f7a2d4$var$_scale$1);
        $9ddd7e9b53f7a2d4$var$_orientation$1.set(0, 0, -1).applyQuaternion($9ddd7e9b53f7a2d4$var$_quaternion$1);
        if (listener.positionX) {
            // code path for Chrome (see #14393)
            const endTime = this.context.currentTime + this.timeDelta;
            listener.positionX.linearRampToValueAtTime($9ddd7e9b53f7a2d4$var$_position$1.x, endTime);
            listener.positionY.linearRampToValueAtTime($9ddd7e9b53f7a2d4$var$_position$1.y, endTime);
            listener.positionZ.linearRampToValueAtTime($9ddd7e9b53f7a2d4$var$_position$1.z, endTime);
            listener.forwardX.linearRampToValueAtTime($9ddd7e9b53f7a2d4$var$_orientation$1.x, endTime);
            listener.forwardY.linearRampToValueAtTime($9ddd7e9b53f7a2d4$var$_orientation$1.y, endTime);
            listener.forwardZ.linearRampToValueAtTime($9ddd7e9b53f7a2d4$var$_orientation$1.z, endTime);
            listener.upX.linearRampToValueAtTime(up.x, endTime);
            listener.upY.linearRampToValueAtTime(up.y, endTime);
            listener.upZ.linearRampToValueAtTime(up.z, endTime);
        } else {
            listener.setPosition($9ddd7e9b53f7a2d4$var$_position$1.x, $9ddd7e9b53f7a2d4$var$_position$1.y, $9ddd7e9b53f7a2d4$var$_position$1.z);
            listener.setOrientation($9ddd7e9b53f7a2d4$var$_orientation$1.x, $9ddd7e9b53f7a2d4$var$_orientation$1.y, $9ddd7e9b53f7a2d4$var$_orientation$1.z, up.x, up.y, up.z);
        }
    }
}
/**
 * Represents a non-positional ( global ) audio object.
 *
 * This and related audio modules make use of the [Web Audio API]{@link https://www.w3.org/TR/webaudio-1.1/}.
 *
 * ```js
 * // create an AudioListener and add it to the camera
 * const listener = new THREE.AudioListener();
 * camera.add( listener );
 *
 * // create a global audio source
 * const sound = new THREE.Audio( listener );
 *
 * // load a sound and set it as the Audio object's buffer
 * const audioLoader = new THREE.AudioLoader();
 * audioLoader.load( 'sounds/ambient.ogg', function( buffer ) {
 * 	sound.setBuffer( buffer );
 * 	sound.setLoop( true );
 * 	sound.setVolume( 0.5 );
 * 	sound.play();
 * });
 * ```
 *
 * @augments Object3D
 */ class $9ddd7e9b53f7a2d4$export$153755f98d9861de extends $9ddd7e9b53f7a2d4$export$e4dd07dff30cc924 {
    /**
	 * Constructs a new audio.
	 *
	 * @param {AudioListener} listener - The global audio listener.
	 */ constructor(listener){
        super();
        this.type = 'Audio';
        /**
		 * The global audio listener.
		 *
		 * @type {AudioListener}
		 * @readonly
		 */ this.listener = listener;
        /**
		 * The audio context.
		 *
		 * @type {AudioContext}
		 * @readonly
		 */ this.context = listener.context;
        /**
		 * The gain node used for volume control.
		 *
		 * @type {GainNode}
		 * @readonly
		 */ this.gain = this.context.createGain();
        this.gain.connect(listener.getInput());
        /**
		 * Whether to start playback automatically or not.
		 *
		 * @type {boolean}
		 * @default false
		 */ this.autoplay = false;
        /**
		 * A reference to an audio buffer.
		 *
		 * Defined via {@link Audio#setBuffer}.
		 *
		 * @type {?AudioBuffer}
		 * @default null
		 * @readonly
		 */ this.buffer = null;
        /**
		 * Modify pitch, measured in cents. +/- 100 is a semitone.
		 * +/- 1200 is an octave.
		 *
		 * Defined via {@link Audio#setDetune}.
		 *
		 * @type {number}
		 * @default 0
		 * @readonly
		 */ this.detune = 0;
        /**
		 * Whether the audio should loop or not.
		 *
		 * Defined via {@link Audio#setLoop}.
		 *
		 * @type {boolean}
		 * @default false
		 * @readonly
		 */ this.loop = false;
        /**
		 * Defines where in the audio buffer the replay should
		 * start, in seconds.
		 *
		 * @type {number}
		 * @default 0
		 */ this.loopStart = 0;
        /**
		 * Defines where in the audio buffer the replay should
		 * stop, in seconds.
		 *
		 * @type {number}
		 * @default 0
		 */ this.loopEnd = 0;
        /**
		 * An offset to the time within the audio buffer the playback
		 * should begin, in seconds.
		 *
		 * @type {number}
		 * @default 0
		 */ this.offset = 0;
        /**
		 * Overrides the default duration of the audio.
		 *
		 * @type {undefined|number}
		 * @default undefined
		 */ this.duration = undefined;
        /**
		 * The playback speed.
		 *
		 * Defined via {@link Audio#setPlaybackRate}.
		 *
		 * @type {number}
		 * @readonly
		 * @default 1
		 */ this.playbackRate = 1;
        /**
		 * Indicates whether the audio is playing or not.
		 *
		 * This flag will be automatically set when using {@link Audio#play},
		 * {@link Audio#pause}, {@link Audio#stop}.
		 *
		 * @type {boolean}
		 * @readonly
		 * @default false
		 */ this.isPlaying = false;
        /**
		 * Indicates whether the audio playback can be controlled
		 * with method like {@link Audio#play} or {@link Audio#pause}.
		 *
		 * This flag will be automatically set when audio sources are
		 * defined.
		 *
		 * @type {boolean}
		 * @readonly
		 * @default true
		 */ this.hasPlaybackControl = true;
        /**
		 * Holds a reference to the current audio source.
		 *
		 * The property is automatically by one of the `set*()` methods.
		 *
		 * @type {?AudioNode}
		 * @readonly
		 * @default null
		 */ this.source = null;
        /**
		 * Defines the source type.
		 *
		 * The property is automatically by one of the `set*()` methods.
		 *
		 * @type {('empty'|'audioNode'|'mediaNode'|'mediaStreamNode'|'buffer')}
		 * @readonly
		 * @default 'empty'
		 */ this.sourceType = 'empty';
        this._startedAt = 0;
        this._progress = 0;
        this._connected = false;
        /**
		 * Can be used to apply a variety of low-order filters to create
		 * more complex sound effects e.g. via `BiquadFilterNode`.
		 *
		 * The property is automatically set by {@link Audio#setFilters}.
		 *
		 * @type {Array<AudioNode>}
		 * @readonly
		 */ this.filters = [];
    }
    /**
	 * Returns the output audio node.
	 *
	 * @return {GainNode} The output node.
	 */ getOutput() {
        return this.gain;
    }
    /**
	 * Sets the given audio node as the source of this instance.
	 *
	 * {@link Audio#sourceType} is set to `audioNode` and {@link Audio#hasPlaybackControl} to `false`.
	 *
	 * @param {AudioNode} audioNode - The audio node like an instance of `OscillatorNode`.
	 * @return {Audio} A reference to this instance.
	 */ setNodeSource(audioNode) {
        this.hasPlaybackControl = false;
        this.sourceType = 'audioNode';
        this.source = audioNode;
        this.connect();
        return this;
    }
    /**
	 * Sets the given media element as the source of this instance.
	 *
	 * {@link Audio#sourceType} is set to `mediaNode` and {@link Audio#hasPlaybackControl} to `false`.
	 *
	 * @param {HTMLMediaElement} mediaElement - The media element.
	 * @return {Audio} A reference to this instance.
	 */ setMediaElementSource(mediaElement) {
        this.hasPlaybackControl = false;
        this.sourceType = 'mediaNode';
        this.source = this.context.createMediaElementSource(mediaElement);
        this.connect();
        return this;
    }
    /**
	 * Sets the given media stream as the source of this instance.
	 *
	 * {@link Audio#sourceType} is set to `mediaStreamNode` and {@link Audio#hasPlaybackControl} to `false`.
	 *
	 * @param {MediaStream} mediaStream - The media stream.
	 * @return {Audio} A reference to this instance.
	 */ setMediaStreamSource(mediaStream) {
        this.hasPlaybackControl = false;
        this.sourceType = 'mediaStreamNode';
        this.source = this.context.createMediaStreamSource(mediaStream);
        this.connect();
        return this;
    }
    /**
	 * Sets the given audio buffer as the source of this instance.
	 *
	 * {@link Audio#sourceType} is set to `buffer` and {@link Audio#hasPlaybackControl} to `true`.
	 *
	 * @param {AudioBuffer} audioBuffer - The audio buffer.
	 * @return {Audio} A reference to this instance.
	 */ setBuffer(audioBuffer) {
        this.buffer = audioBuffer;
        this.sourceType = 'buffer';
        if (this.autoplay) this.play();
        return this;
    }
    /**
	 * Starts the playback of the audio.
	 *
	 * Can only be used with compatible audio sources that allow playback control.
	 *
	 * @param {number} [delay=0] - The delay, in seconds, at which the audio should start playing.
	 * @return {Audio|undefined} A reference to this instance.
	 */ play(delay = 0) {
        if (this.isPlaying === true) {
            console.warn('THREE.Audio: Audio is already playing.');
            return;
        }
        if (this.hasPlaybackControl === false) {
            console.warn('THREE.Audio: this Audio has no playback control.');
            return;
        }
        this._startedAt = this.context.currentTime + delay;
        const source = this.context.createBufferSource();
        source.buffer = this.buffer;
        source.loop = this.loop;
        source.loopStart = this.loopStart;
        source.loopEnd = this.loopEnd;
        source.onended = this.onEnded.bind(this);
        source.start(this._startedAt, this._progress + this.offset, this.duration);
        this.isPlaying = true;
        this.source = source;
        this.setDetune(this.detune);
        this.setPlaybackRate(this.playbackRate);
        return this.connect();
    }
    /**
	 * Pauses the playback of the audio.
	 *
	 * Can only be used with compatible audio sources that allow playback control.
	 *
	 * @return {Audio|undefined} A reference to this instance.
	 */ pause() {
        if (this.hasPlaybackControl === false) {
            console.warn('THREE.Audio: this Audio has no playback control.');
            return;
        }
        if (this.isPlaying === true) {
            // update current progress
            this._progress += Math.max(this.context.currentTime - this._startedAt, 0) * this.playbackRate;
            if (this.loop === true) // ensure _progress does not exceed duration with looped audios
            this._progress = this._progress % (this.duration || this.buffer.duration);
            this.source.stop();
            this.source.onended = null;
            this.isPlaying = false;
        }
        return this;
    }
    /**
	 * Stops the playback of the audio.
	 *
	 * Can only be used with compatible audio sources that allow playback control.
	 *
	 * @param {number} [delay=0] - The delay, in seconds, at which the audio should stop playing.
	 * @return {Audio|undefined} A reference to this instance.
	 */ stop(delay = 0) {
        if (this.hasPlaybackControl === false) {
            console.warn('THREE.Audio: this Audio has no playback control.');
            return;
        }
        this._progress = 0;
        if (this.source !== null) {
            this.source.stop(this.context.currentTime + delay);
            this.source.onended = null;
        }
        this.isPlaying = false;
        return this;
    }
    /**
	 * Connects to the audio source. This is used internally on
	 * initialisation and when setting / removing filters.
	 *
	 * @return {Audio} A reference to this instance.
	 */ connect() {
        if (this.filters.length > 0) {
            this.source.connect(this.filters[0]);
            for(let i = 1, l = this.filters.length; i < l; i++)this.filters[i - 1].connect(this.filters[i]);
            this.filters[this.filters.length - 1].connect(this.getOutput());
        } else this.source.connect(this.getOutput());
        this._connected = true;
        return this;
    }
    /**
	 * Disconnects to the audio source. This is used internally on
	 * initialisation and when setting / removing filters.
	 *
	 * @return {Audio|undefined} A reference to this instance.
	 */ disconnect() {
        if (this._connected === false) return;
        if (this.filters.length > 0) {
            this.source.disconnect(this.filters[0]);
            for(let i = 1, l = this.filters.length; i < l; i++)this.filters[i - 1].disconnect(this.filters[i]);
            this.filters[this.filters.length - 1].disconnect(this.getOutput());
        } else this.source.disconnect(this.getOutput());
        this._connected = false;
        return this;
    }
    /**
	 * Returns the current set filters.
	 *
	 * @return {Array<AudioNode>} The list of filters.
	 */ getFilters() {
        return this.filters;
    }
    /**
	 * Sets an array of filters and connects them with the audio source.
	 *
	 * @param {Array<AudioNode>} [value] - A list of filters.
	 * @return {Audio} A reference to this instance.
	 */ setFilters(value) {
        if (!value) value = [];
        if (this._connected === true) {
            this.disconnect();
            this.filters = value.slice();
            this.connect();
        } else this.filters = value.slice();
        return this;
    }
    /**
	 * Defines the detuning of oscillation in cents.
	 *
	 * @param {number} value - The detuning of oscillation in cents.
	 * @return {Audio} A reference to this instance.
	 */ setDetune(value) {
        this.detune = value;
        if (this.isPlaying === true && this.source.detune !== undefined) this.source.detune.setTargetAtTime(this.detune, this.context.currentTime, 0.01);
        return this;
    }
    /**
	 * Returns the detuning of oscillation in cents.
	 *
	 * @return {number} The detuning of oscillation in cents.
	 */ getDetune() {
        return this.detune;
    }
    /**
	 * Returns the first filter in the list of filters.
	 *
	 * @return {AudioNode|undefined} The first filter in the list of filters.
	 */ getFilter() {
        return this.getFilters()[0];
    }
    /**
	 * Applies a single filter node to the audio.
	 *
	 * @param {AudioNode} [filter] - The filter to set.
	 * @return {Audio} A reference to this instance.
	 */ setFilter(filter) {
        return this.setFilters(filter ? [
            filter
        ] : []);
    }
    /**
	 * Sets the playback rate.
	 *
	 * Can only be used with compatible audio sources that allow playback control.
	 *
	 * @param {number} [value] - The playback rate to set.
	 * @return {Audio|undefined} A reference to this instance.
	 */ setPlaybackRate(value) {
        if (this.hasPlaybackControl === false) {
            console.warn('THREE.Audio: this Audio has no playback control.');
            return;
        }
        this.playbackRate = value;
        if (this.isPlaying === true) this.source.playbackRate.setTargetAtTime(this.playbackRate, this.context.currentTime, 0.01);
        return this;
    }
    /**
	 * Returns the current playback rate.

	 * @return {number} The playback rate.
	 */ getPlaybackRate() {
        return this.playbackRate;
    }
    /**
	 * Automatically called when playback finished.
	 */ onEnded() {
        this.isPlaying = false;
        this._progress = 0;
    }
    /**
	 * Returns the loop flag.
	 *
	 * Can only be used with compatible audio sources that allow playback control.
	 *
	 * @return {boolean} Whether the audio should loop or not.
	 */ getLoop() {
        if (this.hasPlaybackControl === false) {
            console.warn('THREE.Audio: this Audio has no playback control.');
            return false;
        }
        return this.loop;
    }
    /**
	 * Sets the loop flag.
	 *
	 * Can only be used with compatible audio sources that allow playback control.
	 *
	 * @param {boolean} value - Whether the audio should loop or not.
	 * @return {Audio|undefined} A reference to this instance.
	 */ setLoop(value) {
        if (this.hasPlaybackControl === false) {
            console.warn('THREE.Audio: this Audio has no playback control.');
            return;
        }
        this.loop = value;
        if (this.isPlaying === true) this.source.loop = this.loop;
        return this;
    }
    /**
	 * Sets the loop start value which defines where in the audio buffer the replay should
	 * start, in seconds.
	 *
	 * @param {number} value - The loop start value.
	 * @return {Audio} A reference to this instance.
	 */ setLoopStart(value) {
        this.loopStart = value;
        return this;
    }
    /**
	 * Sets the loop end value which defines where in the audio buffer the replay should
	 * stop, in seconds.
	 *
	 * @param {number} value - The loop end value.
	 * @return {Audio} A reference to this instance.
	 */ setLoopEnd(value) {
        this.loopEnd = value;
        return this;
    }
    /**
	 * Returns the volume.
	 *
	 * @return {number} The volume.
	 */ getVolume() {
        return this.gain.gain.value;
    }
    /**
	 * Sets the volume.
	 *
	 * @param {number} value - The volume to set.
	 * @return {Audio} A reference to this instance.
	 */ setVolume(value) {
        this.gain.gain.setTargetAtTime(value, this.context.currentTime, 0.01);
        return this;
    }
    copy(source, recursive) {
        super.copy(source, recursive);
        if (source.sourceType !== 'buffer') {
            console.warn('THREE.Audio: Audio source type cannot be copied.');
            return this;
        }
        this.autoplay = source.autoplay;
        this.buffer = source.buffer;
        this.detune = source.detune;
        this.loop = source.loop;
        this.loopStart = source.loopStart;
        this.loopEnd = source.loopEnd;
        this.offset = source.offset;
        this.duration = source.duration;
        this.playbackRate = source.playbackRate;
        this.hasPlaybackControl = source.hasPlaybackControl;
        this.sourceType = source.sourceType;
        this.filters = source.filters.slice();
        return this;
    }
    clone(recursive) {
        return new this.constructor(this.listener).copy(this, recursive);
    }
}
const $9ddd7e9b53f7a2d4$var$_position = /*@__PURE__*/ new $9ddd7e9b53f7a2d4$export$64b5c384219d3699();
const $9ddd7e9b53f7a2d4$var$_quaternion = /*@__PURE__*/ new $9ddd7e9b53f7a2d4$export$23d6a54f0bbc85a3();
const $9ddd7e9b53f7a2d4$var$_scale = /*@__PURE__*/ new $9ddd7e9b53f7a2d4$export$64b5c384219d3699();
const $9ddd7e9b53f7a2d4$var$_orientation = /*@__PURE__*/ new $9ddd7e9b53f7a2d4$export$64b5c384219d3699();
/**
 * Represents a positional audio object.
 *
 * ```js
 * // create an AudioListener and add it to the camera
 * const listener = new THREE.AudioListener();
 * camera.add( listener );
 *
 * // create the PositionalAudio object (passing in the listener)
 * const sound = new THREE.PositionalAudio( listener );
 *
 * // load a sound and set it as the PositionalAudio object's buffer
 * const audioLoader = new THREE.AudioLoader();
 * audioLoader.load( 'sounds/song.ogg', function( buffer ) {
 * 	sound.setBuffer( buffer );
 * 	sound.setRefDistance( 20 );
 * 	sound.play();
 * });
 *
 * // create an object for the sound to play from
 * const sphere = new THREE.SphereGeometry( 20, 32, 16 );
 * const material = new THREE.MeshPhongMaterial( { color: 0xff2200 } );
 * const mesh = new THREE.Mesh( sphere, material );
 * scene.add( mesh );
 *
 * // finally add the sound to the mesh
 * mesh.add( sound );
 *
 * @augments Audio
 */ class $9ddd7e9b53f7a2d4$export$4b3e397ef1832507 extends $9ddd7e9b53f7a2d4$export$153755f98d9861de {
    /**
	 * Constructs a positional audio.
	 *
	 * @param {AudioListener} listener - The global audio listener.
	 */ constructor(listener){
        super(listener);
        /**
		 * The panner node represents the location, direction, and behavior of an audio
		 * source in 3D space.
		 *
		 * @type {PannerNode}
		 * @readonly
		 */ this.panner = this.context.createPanner();
        this.panner.panningModel = 'HRTF';
        this.panner.connect(this.gain);
    }
    connect() {
        super.connect();
        this.panner.connect(this.gain);
        return this;
    }
    disconnect() {
        super.disconnect();
        this.panner.disconnect(this.gain);
        return this;
    }
    getOutput() {
        return this.panner;
    }
    /**
	 * Returns the current reference distance.
	 *
	 * @return {number} The reference distance.
	 */ getRefDistance() {
        return this.panner.refDistance;
    }
    /**
	 * Defines the reference distance for reducing volume as the audio source moves
	 * further from the listener – i.e. the distance at which the volume reduction
	 * starts taking effect.
	 *
	 * @param {number} value - The reference distance to set.
	 * @return {PositionalAudio} A reference to this instance.
	 */ setRefDistance(value) {
        this.panner.refDistance = value;
        return this;
    }
    /**
	 * Returns the current rolloff factor.
	 *
	 * @return {number} The rolloff factor.
	 */ getRolloffFactor() {
        return this.panner.rolloffFactor;
    }
    /**
	 * Defines how quickly the volume is reduced as the source moves away from the listener.
	 *
	 * @param {number} value - The rolloff factor.
	 * @return {PositionalAudio} A reference to this instance.
	 */ setRolloffFactor(value) {
        this.panner.rolloffFactor = value;
        return this;
    }
    /**
	 * Returns the current distance model.
	 *
	 * @return {('linear'|'inverse'|'exponential')} The distance model.
	 */ getDistanceModel() {
        return this.panner.distanceModel;
    }
    /**
	 * Defines which algorithm to use to reduce the volume of the audio source
	 * as it moves away from the listener.
	 *
	 * Read [the spec]{@link https://www.w3.org/TR/webaudio-1.1/#enumdef-distancemodeltype}
	 * for more details.
	 *
	 * @param {('linear'|'inverse'|'exponential')} value - The distance model to set.
	 * @return {PositionalAudio} A reference to this instance.
	 */ setDistanceModel(value) {
        this.panner.distanceModel = value;
        return this;
    }
    /**
	 * Returns the current max distance.
	 *
	 * @return {number} The max distance.
	 */ getMaxDistance() {
        return this.panner.maxDistance;
    }
    /**
	 * Defines the maximum distance between the audio source and the listener,
	 * after which the volume is not reduced any further.
	 *
	 * This value is used only by the `linear` distance model.
	 *
	 * @param {number} value - The max distance.
	 * @return {PositionalAudio} A reference to this instance.
	 */ setMaxDistance(value) {
        this.panner.maxDistance = value;
        return this;
    }
    /**
	 * Sets the directional cone in which the audio can be listened.
	 *
	 * @param {number} coneInnerAngle - An angle, in degrees, of a cone inside of which there will be no volume reduction.
	 * @param {number} coneOuterAngle - An angle, in degrees, of a cone outside of which the volume will be reduced by a constant value, defined by the `coneOuterGain` parameter.
	 * @param {number} coneOuterGain - The amount of volume reduction outside the cone defined by the `coneOuterAngle`. When set to `0`, no sound can be heard.
	 * @return {PositionalAudio} A reference to this instance.
	 */ setDirectionalCone(coneInnerAngle, coneOuterAngle, coneOuterGain) {
        this.panner.coneInnerAngle = coneInnerAngle;
        this.panner.coneOuterAngle = coneOuterAngle;
        this.panner.coneOuterGain = coneOuterGain;
        return this;
    }
    updateMatrixWorld(force) {
        super.updateMatrixWorld(force);
        if (this.hasPlaybackControl === true && this.isPlaying === false) return;
        this.matrixWorld.decompose($9ddd7e9b53f7a2d4$var$_position, $9ddd7e9b53f7a2d4$var$_quaternion, $9ddd7e9b53f7a2d4$var$_scale);
        $9ddd7e9b53f7a2d4$var$_orientation.set(0, 0, 1).applyQuaternion($9ddd7e9b53f7a2d4$var$_quaternion);
        const panner = this.panner;
        if (panner.positionX) {
            // code path for Chrome and Firefox (see #14393)
            const endTime = this.context.currentTime + this.listener.timeDelta;
            panner.positionX.linearRampToValueAtTime($9ddd7e9b53f7a2d4$var$_position.x, endTime);
            panner.positionY.linearRampToValueAtTime($9ddd7e9b53f7a2d4$var$_position.y, endTime);
            panner.positionZ.linearRampToValueAtTime($9ddd7e9b53f7a2d4$var$_position.z, endTime);
            panner.orientationX.linearRampToValueAtTime($9ddd7e9b53f7a2d4$var$_orientation.x, endTime);
            panner.orientationY.linearRampToValueAtTime($9ddd7e9b53f7a2d4$var$_orientation.y, endTime);
            panner.orientationZ.linearRampToValueAtTime($9ddd7e9b53f7a2d4$var$_orientation.z, endTime);
        } else {
            panner.setPosition($9ddd7e9b53f7a2d4$var$_position.x, $9ddd7e9b53f7a2d4$var$_position.y, $9ddd7e9b53f7a2d4$var$_position.z);
            panner.setOrientation($9ddd7e9b53f7a2d4$var$_orientation.x, $9ddd7e9b53f7a2d4$var$_orientation.y, $9ddd7e9b53f7a2d4$var$_orientation.z);
        }
    }
}
/**
 * This class can be used to analyse audio data.
 *
 * ```js
 * // create an AudioListener and add it to the camera
 * const listener = new THREE.AudioListener();
 * camera.add( listener );
 *
 * // create an Audio source
 * const sound = new THREE.Audio( listener );
 *
 * // load a sound and set it as the Audio object's buffer
 * const audioLoader = new THREE.AudioLoader();
 * audioLoader.load( 'sounds/ambient.ogg', function( buffer ) {
 * 	sound.setBuffer( buffer );
 * 	sound.setLoop(true);
 * 	sound.setVolume(0.5);
 * 	sound.play();
 * });
 *
 * // create an AudioAnalyser, passing in the sound and desired fftSize
 * const analyser = new THREE.AudioAnalyser( sound, 32 );
 *
 * // get the average frequency of the sound
 * const data = analyser.getAverageFrequency();
 * ```
 */ class $9ddd7e9b53f7a2d4$export$d47da1ef3d382827 {
    /**
	 * Constructs a new audio analyzer.
	 *
	 * @param {Audio} audio - The audio to analyze.
	 * @param {number} [fftSize=2048] - The window size in samples that is used when performing a Fast Fourier Transform (FFT) to get frequency domain data.
	 */ constructor(audio, fftSize = 2048){
        /**
		 * The global audio listener.
		 *
		 * @type {AnalyserNode}
		 */ this.analyser = audio.context.createAnalyser();
        this.analyser.fftSize = fftSize;
        /**
		 * Holds the analyzed data.
		 *
		 * @type {Uint8Array}
		 */ this.data = new Uint8Array(this.analyser.frequencyBinCount);
        audio.getOutput().connect(this.analyser);
    }
    /**
	 * Returns an array with frequency data of the audio.
	 *
	 * Each item in the array represents the decibel value for a specific frequency.
	 * The frequencies are spread linearly from 0 to 1/2 of the sample rate.
	 * For example, for 48000 sample rate, the last item of the array will represent
	 * the decibel value for 24000 Hz.
	 *
	 * @return {Uint8Array} The frequency data.
	 */ getFrequencyData() {
        this.analyser.getByteFrequencyData(this.data);
        return this.data;
    }
    /**
	 * Returns the average of the frequencies returned by {@link AudioAnalyser#getFrequencyData}.
	 *
	 * @return {number} The average frequency.
	 */ getAverageFrequency() {
        let value = 0;
        const data = this.getFrequencyData();
        for(let i = 0; i < data.length; i++)value += data[i];
        return value / data.length;
    }
}
/**
 * Buffered scene graph property that allows weighted accumulation; used internally.
 */ class $9ddd7e9b53f7a2d4$export$dfe0af1ca1acb78a {
    /**
	 * Constructs a new property mixer.
	 *
	 * @param {PropertyBinding} binding - The property binding.
	 * @param {string} typeName - The keyframe track type name.
	 * @param {number} valueSize - The keyframe track value size.
	 */ constructor(binding, typeName, valueSize){
        /**
		 * The property binding.
		 *
		 * @type {PropertyBinding}
		 */ this.binding = binding;
        /**
		 * The keyframe track value size.
		 *
		 * @type {number}
		 */ this.valueSize = valueSize;
        let mixFunction, mixFunctionAdditive, setIdentity;
        // buffer layout: [ incoming | accu0 | accu1 | orig | addAccu | (optional work) ]
        //
        // interpolators can use .buffer as their .result
        // the data then goes to 'incoming'
        //
        // 'accu0' and 'accu1' are used frame-interleaved for
        // the cumulative result and are compared to detect
        // changes
        //
        // 'orig' stores the original state of the property
        //
        // 'add' is used for additive cumulative results
        //
        // 'work' is optional and is only present for quaternion types. It is used
        // to store intermediate quaternion multiplication results
        switch(typeName){
            case 'quaternion':
                mixFunction = this._slerp;
                mixFunctionAdditive = this._slerpAdditive;
                setIdentity = this._setAdditiveIdentityQuaternion;
                this.buffer = new Float64Array(valueSize * 6);
                this._workIndex = 5;
                break;
            case 'string':
            case 'bool':
                mixFunction = this._select;
                // Use the regular mix function and for additive on these types,
                // additive is not relevant for non-numeric types
                mixFunctionAdditive = this._select;
                setIdentity = this._setAdditiveIdentityOther;
                this.buffer = new Array(valueSize * 5);
                break;
            default:
                mixFunction = this._lerp;
                mixFunctionAdditive = this._lerpAdditive;
                setIdentity = this._setAdditiveIdentityNumeric;
                this.buffer = new Float64Array(valueSize * 5);
        }
        this._mixBufferRegion = mixFunction;
        this._mixBufferRegionAdditive = mixFunctionAdditive;
        this._setIdentity = setIdentity;
        this._origIndex = 3;
        this._addIndex = 4;
        /**
		 * TODO
		 *
		 * @type {number}
		 * @default 0
		 */ this.cumulativeWeight = 0;
        /**
		 * TODO
		 *
		 * @type {number}
		 * @default 0
		 */ this.cumulativeWeightAdditive = 0;
        /**
		 * TODO
		 *
		 * @type {number}
		 * @default 0
		 */ this.useCount = 0;
        /**
		 * TODO
		 *
		 * @type {number}
		 * @default 0
		 */ this.referenceCount = 0;
    }
    /**
	 * Accumulates data in the `incoming` region into `accu<i>`.
	 *
	 * @param {number} accuIndex - The accumulation index.
	 * @param {number} weight - The weight.
	 */ accumulate(accuIndex, weight) {
        // note: happily accumulating nothing when weight = 0, the caller knows
        // the weight and shouldn't have made the call in the first place
        const buffer = this.buffer, stride = this.valueSize, offset = accuIndex * stride + stride;
        let currentWeight = this.cumulativeWeight;
        if (currentWeight === 0) {
            // accuN := incoming * weight
            for(let i = 0; i !== stride; ++i)buffer[offset + i] = buffer[i];
            currentWeight = weight;
        } else {
            // accuN := accuN + incoming * weight
            currentWeight += weight;
            const mix = weight / currentWeight;
            this._mixBufferRegion(buffer, offset, 0, mix, stride);
        }
        this.cumulativeWeight = currentWeight;
    }
    /**
	 * Accumulates data in the `incoming` region into `add`.
	 *
	 * @param {number} weight - The weight.
	 */ accumulateAdditive(weight) {
        const buffer = this.buffer, stride = this.valueSize, offset = stride * this._addIndex;
        if (this.cumulativeWeightAdditive === 0) // add = identity
        this._setIdentity();
        // add := add + incoming * weight
        this._mixBufferRegionAdditive(buffer, offset, 0, weight, stride);
        this.cumulativeWeightAdditive += weight;
    }
    /**
	 * Applies the state of `accu<i>` to the binding when accus differ.
	 *
	 * @param {number} accuIndex - The accumulation index.
	 */ apply(accuIndex) {
        const stride = this.valueSize, buffer = this.buffer, offset = accuIndex * stride + stride, weight = this.cumulativeWeight, weightAdditive = this.cumulativeWeightAdditive, binding = this.binding;
        this.cumulativeWeight = 0;
        this.cumulativeWeightAdditive = 0;
        if (weight < 1) {
            // accuN := accuN + original * ( 1 - cumulativeWeight )
            const originalValueOffset = stride * this._origIndex;
            this._mixBufferRegion(buffer, offset, originalValueOffset, 1 - weight, stride);
        }
        if (weightAdditive > 0) // accuN := accuN + additive accuN
        this._mixBufferRegionAdditive(buffer, offset, this._addIndex * stride, 1, stride);
        for(let i = stride, e = stride + stride; i !== e; ++i)if (buffer[i] !== buffer[i + stride]) {
            // value has changed -> update scene graph
            binding.setValue(buffer, offset);
            break;
        }
    }
    /**
	 * Remembers the state of the bound property and copy it to both accus.
	 */ saveOriginalState() {
        const binding = this.binding;
        const buffer = this.buffer, stride = this.valueSize, originalValueOffset = stride * this._origIndex;
        binding.getValue(buffer, originalValueOffset);
        // accu[0..1] := orig -- initially detect changes against the original
        for(let i = stride, e = originalValueOffset; i !== e; ++i)buffer[i] = buffer[originalValueOffset + i % stride];
        // Add to identity for additive
        this._setIdentity();
        this.cumulativeWeight = 0;
        this.cumulativeWeightAdditive = 0;
    }
    /**
	 * Applies the state previously taken via {@link PropertyMixer#saveOriginalState} to the binding.
	 */ restoreOriginalState() {
        const originalValueOffset = this.valueSize * 3;
        this.binding.setValue(this.buffer, originalValueOffset);
    }
    // internals
    _setAdditiveIdentityNumeric() {
        const startIndex = this._addIndex * this.valueSize;
        const endIndex = startIndex + this.valueSize;
        for(let i = startIndex; i < endIndex; i++)this.buffer[i] = 0;
    }
    _setAdditiveIdentityQuaternion() {
        this._setAdditiveIdentityNumeric();
        this.buffer[this._addIndex * this.valueSize + 3] = 1;
    }
    _setAdditiveIdentityOther() {
        const startIndex = this._origIndex * this.valueSize;
        const targetIndex = this._addIndex * this.valueSize;
        for(let i = 0; i < this.valueSize; i++)this.buffer[targetIndex + i] = this.buffer[startIndex + i];
    }
    // mix functions
    _select(buffer, dstOffset, srcOffset, t, stride) {
        if (t >= 0.5) for(let i = 0; i !== stride; ++i)buffer[dstOffset + i] = buffer[srcOffset + i];
    }
    _slerp(buffer, dstOffset, srcOffset, t) {
        $9ddd7e9b53f7a2d4$export$23d6a54f0bbc85a3.slerpFlat(buffer, dstOffset, buffer, dstOffset, buffer, srcOffset, t);
    }
    _slerpAdditive(buffer, dstOffset, srcOffset, t, stride) {
        const workOffset = this._workIndex * stride;
        // Store result in intermediate buffer offset
        $9ddd7e9b53f7a2d4$export$23d6a54f0bbc85a3.multiplyQuaternionsFlat(buffer, workOffset, buffer, dstOffset, buffer, srcOffset);
        // Slerp to the intermediate result
        $9ddd7e9b53f7a2d4$export$23d6a54f0bbc85a3.slerpFlat(buffer, dstOffset, buffer, dstOffset, buffer, workOffset, t);
    }
    _lerp(buffer, dstOffset, srcOffset, t, stride) {
        const s = 1 - t;
        for(let i = 0; i !== stride; ++i){
            const j = dstOffset + i;
            buffer[j] = buffer[j] * s + buffer[srcOffset + i] * t;
        }
    }
    _lerpAdditive(buffer, dstOffset, srcOffset, t, stride) {
        for(let i = 0; i !== stride; ++i){
            const j = dstOffset + i;
            buffer[j] = buffer[j] + buffer[srcOffset + i] * t;
        }
    }
}
// Characters [].:/ are reserved for track binding syntax.
const $9ddd7e9b53f7a2d4$var$_RESERVED_CHARS_RE = '\\[\\]\\.:\\/';
const $9ddd7e9b53f7a2d4$var$_reservedRe = new RegExp('[' + $9ddd7e9b53f7a2d4$var$_RESERVED_CHARS_RE + ']', 'g');
// Attempts to allow node names from any language. ES5's `\w` regexp matches
// only latin characters, and the unicode \p{L} is not yet supported. So
// instead, we exclude reserved characters and match everything else.
const $9ddd7e9b53f7a2d4$var$_wordChar = '[^' + $9ddd7e9b53f7a2d4$var$_RESERVED_CHARS_RE + ']';
const $9ddd7e9b53f7a2d4$var$_wordCharOrDot = '[^' + $9ddd7e9b53f7a2d4$var$_RESERVED_CHARS_RE.replace('\\.', '') + ']';
// Parent directories, delimited by '/' or ':'. Currently unused, but must
// be matched to parse the rest of the track name.
const $9ddd7e9b53f7a2d4$var$_directoryRe = /*@__PURE__*/ /((?:WC+[\/:])*)/.source.replace('WC', $9ddd7e9b53f7a2d4$var$_wordChar);
// Target node. May contain word characters (a-zA-Z0-9_) and '.' or '-'.
const $9ddd7e9b53f7a2d4$var$_nodeRe = /*@__PURE__*/ /(WCOD+)?/.source.replace('WCOD', $9ddd7e9b53f7a2d4$var$_wordCharOrDot);
// Object on target node, and accessor. May not contain reserved
// characters. Accessor may contain any character except closing bracket.
const $9ddd7e9b53f7a2d4$var$_objectRe = /*@__PURE__*/ /(?:\.(WC+)(?:\[(.+)\])?)?/.source.replace('WC', $9ddd7e9b53f7a2d4$var$_wordChar);
// Property and accessor. May not contain reserved characters. Accessor may
// contain any non-bracket characters.
const $9ddd7e9b53f7a2d4$var$_propertyRe = /*@__PURE__*/ /\.(WC+)(?:\[(.+)\])?/.source.replace('WC', $9ddd7e9b53f7a2d4$var$_wordChar);
const $9ddd7e9b53f7a2d4$var$_trackRe = new RegExp("^" + $9ddd7e9b53f7a2d4$var$_directoryRe + $9ddd7e9b53f7a2d4$var$_nodeRe + $9ddd7e9b53f7a2d4$var$_objectRe + $9ddd7e9b53f7a2d4$var$_propertyRe + '$');
const $9ddd7e9b53f7a2d4$var$_supportedObjectNames = [
    'material',
    'materials',
    'bones',
    'map'
];
class $9ddd7e9b53f7a2d4$var$Composite {
    constructor(targetGroup, path, optionalParsedPath){
        const parsedPath = optionalParsedPath || $9ddd7e9b53f7a2d4$export$7bf70fcf9f891893.parseTrackName(path);
        this._targetGroup = targetGroup;
        this._bindings = targetGroup.subscribe_(path, parsedPath);
    }
    getValue(array, offset) {
        this.bind(); // bind all binding
        const firstValidIndex = this._targetGroup.nCachedObjects_, binding = this._bindings[firstValidIndex];
        // and only call .getValue on the first
        if (binding !== undefined) binding.getValue(array, offset);
    }
    setValue(array, offset) {
        const bindings = this._bindings;
        for(let i = this._targetGroup.nCachedObjects_, n = bindings.length; i !== n; ++i)bindings[i].setValue(array, offset);
    }
    bind() {
        const bindings = this._bindings;
        for(let i = this._targetGroup.nCachedObjects_, n = bindings.length; i !== n; ++i)bindings[i].bind();
    }
    unbind() {
        const bindings = this._bindings;
        for(let i = this._targetGroup.nCachedObjects_, n = bindings.length; i !== n; ++i)bindings[i].unbind();
    }
}
// Note: This class uses a State pattern on a per-method basis:
// 'bind' sets 'this.getValue' / 'setValue' and shadows the
// prototype version of these methods with one that represents
// the bound state. When the property is not found, the methods
// become no-ops.
/**
 * This holds a reference to a real property in the scene graph; used internally.
 */ class $9ddd7e9b53f7a2d4$export$7bf70fcf9f891893 {
    /**
	 * Constructs a new property binding.
	 *
	 * @param {Object} rootNode - The root node.
	 * @param {string} path - The path.
	 * @param {?Object} [parsedPath] - The parsed path.
	 */ constructor(rootNode, path, parsedPath){
        /**
		 * The object path to the animated property.
		 *
		 * @type {string}
		 */ this.path = path;
        /**
		 * An object holding information about the path.
		 *
		 * @type {Object}
		 */ this.parsedPath = parsedPath || $9ddd7e9b53f7a2d4$export$7bf70fcf9f891893.parseTrackName(path);
        /**
		 * The object owns the animated property.
		 *
		 * @type {?Object}
		 */ this.node = $9ddd7e9b53f7a2d4$export$7bf70fcf9f891893.findNode(rootNode, this.parsedPath.nodeName);
        /**
		 * The root node.
		 *
		 * @type {Object3D|Skeleton}
		 */ this.rootNode = rootNode;
        // initial state of these methods that calls 'bind'
        this.getValue = this._getValue_unbound;
        this.setValue = this._setValue_unbound;
    }
    /**
	 * Factory method for creating a property binding from the given parameters.
	 *
	 * @static
	 * @param {Object} root - The root node.
	 * @param {string} path - The path.
	 * @param {?Object} [parsedPath] - The parsed path.
	 * @return {PropertyBinding|Composite} The created property binding or composite.
	 */ static create(root, path, parsedPath) {
        if (!(root && root.isAnimationObjectGroup)) return new $9ddd7e9b53f7a2d4$export$7bf70fcf9f891893(root, path, parsedPath);
        else return new $9ddd7e9b53f7a2d4$export$7bf70fcf9f891893.Composite(root, path, parsedPath);
    }
    /**
	 * Replaces spaces with underscores and removes unsupported characters from
	 * node names, to ensure compatibility with parseTrackName().
	 *
	 * @param {string} name - Node name to be sanitized.
	 * @return {string} The sanitized node name.
	 */ static sanitizeNodeName(name) {
        return name.replace(/\s/g, '_').replace($9ddd7e9b53f7a2d4$var$_reservedRe, '');
    }
    /**
	 * Parses the given track name (an object path to an animated property) and
	 * returns an object with information about the path. Matches strings in the following forms:
	 *
	 * - nodeName.property
	 * - nodeName.property[accessor]
	 * - nodeName.material.property[accessor]
	 * - uuid.property[accessor]
	 * - uuid.objectName[objectIndex].propertyName[propertyIndex]
	 * - parentName/nodeName.property
	 * - parentName/parentName/nodeName.property[index]
	 * - .bone[Armature.DEF_cog].position
	 * - scene:helium_balloon_model:helium_balloon_model.position
	 *
	 * @static
	 * @param {string} trackName - The track name to parse.
	 * @return {Object} The parsed track name as an object.
	 */ static parseTrackName(trackName) {
        const matches = $9ddd7e9b53f7a2d4$var$_trackRe.exec(trackName);
        if (matches === null) throw new Error('PropertyBinding: Cannot parse trackName: ' + trackName);
        const results = {
            // directoryName: matches[ 1 ], // (tschw) currently unused
            nodeName: matches[2],
            objectName: matches[3],
            objectIndex: matches[4],
            propertyName: matches[5],
            propertyIndex: matches[6]
        };
        const lastDot = results.nodeName && results.nodeName.lastIndexOf('.');
        if (lastDot !== undefined && lastDot !== -1) {
            const objectName = results.nodeName.substring(lastDot + 1);
            // Object names must be checked against an allowlist. Otherwise, there
            // is no way to parse 'foo.bar.baz': 'baz' must be a property, but
            // 'bar' could be the objectName, or part of a nodeName (which can
            // include '.' characters).
            if ($9ddd7e9b53f7a2d4$var$_supportedObjectNames.indexOf(objectName) !== -1) {
                results.nodeName = results.nodeName.substring(0, lastDot);
                results.objectName = objectName;
            }
        }
        if (results.propertyName === null || results.propertyName.length === 0) throw new Error('PropertyBinding: can not parse propertyName from trackName: ' + trackName);
        return results;
    }
    /**
	 * Searches for a node in the hierarchy of the given root object by the given
	 * node name.
	 *
	 * @static
	 * @param {Object} root - The root object.
	 * @param {string|number} nodeName - The name of the node.
	 * @return {?Object} The found node. Returns `null` if no object was found.
	 */ static findNode(root, nodeName) {
        if (nodeName === undefined || nodeName === '' || nodeName === '.' || nodeName === -1 || nodeName === root.name || nodeName === root.uuid) return root;
        // search into skeleton bones.
        if (root.skeleton) {
            const bone = root.skeleton.getBoneByName(nodeName);
            if (bone !== undefined) return bone;
        }
        // search into node subtree.
        if (root.children) {
            const searchNodeSubtree = function(children) {
                for(let i = 0; i < children.length; i++){
                    const childNode = children[i];
                    if (childNode.name === nodeName || childNode.uuid === nodeName) return childNode;
                    const result = searchNodeSubtree(childNode.children);
                    if (result) return result;
                }
                return null;
            };
            const subTreeNode = searchNodeSubtree(root.children);
            if (subTreeNode) return subTreeNode;
        }
        return null;
    }
    // these are used to "bind" a nonexistent property
    _getValue_unavailable() {}
    _setValue_unavailable() {}
    // Getters
    _getValue_direct(buffer, offset) {
        buffer[offset] = this.targetObject[this.propertyName];
    }
    _getValue_array(buffer, offset) {
        const source = this.resolvedProperty;
        for(let i = 0, n = source.length; i !== n; ++i)buffer[offset++] = source[i];
    }
    _getValue_arrayElement(buffer, offset) {
        buffer[offset] = this.resolvedProperty[this.propertyIndex];
    }
    _getValue_toArray(buffer, offset) {
        this.resolvedProperty.toArray(buffer, offset);
    }
    // Direct
    _setValue_direct(buffer, offset) {
        this.targetObject[this.propertyName] = buffer[offset];
    }
    _setValue_direct_setNeedsUpdate(buffer, offset) {
        this.targetObject[this.propertyName] = buffer[offset];
        this.targetObject.needsUpdate = true;
    }
    _setValue_direct_setMatrixWorldNeedsUpdate(buffer, offset) {
        this.targetObject[this.propertyName] = buffer[offset];
        this.targetObject.matrixWorldNeedsUpdate = true;
    }
    // EntireArray
    _setValue_array(buffer, offset) {
        const dest = this.resolvedProperty;
        for(let i = 0, n = dest.length; i !== n; ++i)dest[i] = buffer[offset++];
    }
    _setValue_array_setNeedsUpdate(buffer, offset) {
        const dest = this.resolvedProperty;
        for(let i = 0, n = dest.length; i !== n; ++i)dest[i] = buffer[offset++];
        this.targetObject.needsUpdate = true;
    }
    _setValue_array_setMatrixWorldNeedsUpdate(buffer, offset) {
        const dest = this.resolvedProperty;
        for(let i = 0, n = dest.length; i !== n; ++i)dest[i] = buffer[offset++];
        this.targetObject.matrixWorldNeedsUpdate = true;
    }
    // ArrayElement
    _setValue_arrayElement(buffer, offset) {
        this.resolvedProperty[this.propertyIndex] = buffer[offset];
    }
    _setValue_arrayElement_setNeedsUpdate(buffer, offset) {
        this.resolvedProperty[this.propertyIndex] = buffer[offset];
        this.targetObject.needsUpdate = true;
    }
    _setValue_arrayElement_setMatrixWorldNeedsUpdate(buffer, offset) {
        this.resolvedProperty[this.propertyIndex] = buffer[offset];
        this.targetObject.matrixWorldNeedsUpdate = true;
    }
    // HasToFromArray
    _setValue_fromArray(buffer, offset) {
        this.resolvedProperty.fromArray(buffer, offset);
    }
    _setValue_fromArray_setNeedsUpdate(buffer, offset) {
        this.resolvedProperty.fromArray(buffer, offset);
        this.targetObject.needsUpdate = true;
    }
    _setValue_fromArray_setMatrixWorldNeedsUpdate(buffer, offset) {
        this.resolvedProperty.fromArray(buffer, offset);
        this.targetObject.matrixWorldNeedsUpdate = true;
    }
    _getValue_unbound(targetArray, offset) {
        this.bind();
        this.getValue(targetArray, offset);
    }
    _setValue_unbound(sourceArray, offset) {
        this.bind();
        this.setValue(sourceArray, offset);
    }
    /**
	 * Creates a getter / setter pair for the property tracked by this binding.
	 */ bind() {
        let targetObject = this.node;
        const parsedPath = this.parsedPath;
        const objectName = parsedPath.objectName;
        const propertyName = parsedPath.propertyName;
        let propertyIndex = parsedPath.propertyIndex;
        if (!targetObject) {
            targetObject = $9ddd7e9b53f7a2d4$export$7bf70fcf9f891893.findNode(this.rootNode, parsedPath.nodeName);
            this.node = targetObject;
        }
        // set fail state so we can just 'return' on error
        this.getValue = this._getValue_unavailable;
        this.setValue = this._setValue_unavailable;
        // ensure there is a value node
        if (!targetObject) {
            console.warn('THREE.PropertyBinding: No target node found for track: ' + this.path + '.');
            return;
        }
        if (objectName) {
            let objectIndex = parsedPath.objectIndex;
            // special cases were we need to reach deeper into the hierarchy to get the face materials....
            switch(objectName){
                case 'materials':
                    if (!targetObject.material) {
                        console.error('THREE.PropertyBinding: Can not bind to material as node does not have a material.', this);
                        return;
                    }
                    if (!targetObject.material.materials) {
                        console.error('THREE.PropertyBinding: Can not bind to material.materials as node.material does not have a materials array.', this);
                        return;
                    }
                    targetObject = targetObject.material.materials;
                    break;
                case 'bones':
                    if (!targetObject.skeleton) {
                        console.error('THREE.PropertyBinding: Can not bind to bones as node does not have a skeleton.', this);
                        return;
                    }
                    // potential future optimization: skip this if propertyIndex is already an integer
                    // and convert the integer string to a true integer.
                    targetObject = targetObject.skeleton.bones;
                    // support resolving morphTarget names into indices.
                    for(let i = 0; i < targetObject.length; i++)if (targetObject[i].name === objectIndex) {
                        objectIndex = i;
                        break;
                    }
                    break;
                case 'map':
                    if ('map' in targetObject) {
                        targetObject = targetObject.map;
                        break;
                    }
                    if (!targetObject.material) {
                        console.error('THREE.PropertyBinding: Can not bind to material as node does not have a material.', this);
                        return;
                    }
                    if (!targetObject.material.map) {
                        console.error('THREE.PropertyBinding: Can not bind to material.map as node.material does not have a map.', this);
                        return;
                    }
                    targetObject = targetObject.material.map;
                    break;
                default:
                    if (targetObject[objectName] === undefined) {
                        console.error('THREE.PropertyBinding: Can not bind to objectName of node undefined.', this);
                        return;
                    }
                    targetObject = targetObject[objectName];
            }
            if (objectIndex !== undefined) {
                if (targetObject[objectIndex] === undefined) {
                    console.error('THREE.PropertyBinding: Trying to bind to objectIndex of objectName, but is undefined.', this, targetObject);
                    return;
                }
                targetObject = targetObject[objectIndex];
            }
        }
        // resolve property
        const nodeProperty = targetObject[propertyName];
        if (nodeProperty === undefined) {
            const nodeName = parsedPath.nodeName;
            console.error('THREE.PropertyBinding: Trying to update property for track: ' + nodeName + '.' + propertyName + ' but it wasn\'t found.', targetObject);
            return;
        }
        // determine versioning scheme
        let versioning = this.Versioning.None;
        this.targetObject = targetObject;
        if (targetObject.isMaterial === true) versioning = this.Versioning.NeedsUpdate;
        else if (targetObject.isObject3D === true) versioning = this.Versioning.MatrixWorldNeedsUpdate;
        // determine how the property gets bound
        let bindingType = this.BindingType.Direct;
        if (propertyIndex !== undefined) {
            // access a sub element of the property array (only primitives are supported right now)
            if (propertyName === 'morphTargetInfluences') {
                // potential optimization, skip this if propertyIndex is already an integer, and convert the integer string to a true integer.
                // support resolving morphTarget names into indices.
                if (!targetObject.geometry) {
                    console.error('THREE.PropertyBinding: Can not bind to morphTargetInfluences because node does not have a geometry.', this);
                    return;
                }
                if (!targetObject.geometry.morphAttributes) {
                    console.error('THREE.PropertyBinding: Can not bind to morphTargetInfluences because node does not have a geometry.morphAttributes.', this);
                    return;
                }
                if (targetObject.morphTargetDictionary[propertyIndex] !== undefined) propertyIndex = targetObject.morphTargetDictionary[propertyIndex];
            }
            bindingType = this.BindingType.ArrayElement;
            this.resolvedProperty = nodeProperty;
            this.propertyIndex = propertyIndex;
        } else if (nodeProperty.fromArray !== undefined && nodeProperty.toArray !== undefined) {
            // must use copy for Object3D.Euler/Quaternion
            bindingType = this.BindingType.HasFromToArray;
            this.resolvedProperty = nodeProperty;
        } else if (Array.isArray(nodeProperty)) {
            bindingType = this.BindingType.EntireArray;
            this.resolvedProperty = nodeProperty;
        } else this.propertyName = propertyName;
        // select getter / setter
        this.getValue = this.GetterByBindingType[bindingType];
        this.setValue = this.SetterByBindingTypeAndVersioning[bindingType][versioning];
    }
    /**
	 * Unbinds the property.
	 */ unbind() {
        this.node = null;
        // back to the prototype version of getValue / setValue
        // note: avoiding to mutate the shape of 'this' via 'delete'
        this.getValue = this._getValue_unbound;
        this.setValue = this._setValue_unbound;
    }
}
$9ddd7e9b53f7a2d4$export$7bf70fcf9f891893.Composite = $9ddd7e9b53f7a2d4$var$Composite;
$9ddd7e9b53f7a2d4$export$7bf70fcf9f891893.prototype.BindingType = {
    Direct: 0,
    EntireArray: 1,
    ArrayElement: 2,
    HasFromToArray: 3
};
$9ddd7e9b53f7a2d4$export$7bf70fcf9f891893.prototype.Versioning = {
    None: 0,
    NeedsUpdate: 1,
    MatrixWorldNeedsUpdate: 2
};
$9ddd7e9b53f7a2d4$export$7bf70fcf9f891893.prototype.GetterByBindingType = [
    $9ddd7e9b53f7a2d4$export$7bf70fcf9f891893.prototype._getValue_direct,
    $9ddd7e9b53f7a2d4$export$7bf70fcf9f891893.prototype._getValue_array,
    $9ddd7e9b53f7a2d4$export$7bf70fcf9f891893.prototype._getValue_arrayElement,
    $9ddd7e9b53f7a2d4$export$7bf70fcf9f891893.prototype._getValue_toArray
];
$9ddd7e9b53f7a2d4$export$7bf70fcf9f891893.prototype.SetterByBindingTypeAndVersioning = [
    [
        // Direct
        $9ddd7e9b53f7a2d4$export$7bf70fcf9f891893.prototype._setValue_direct,
        $9ddd7e9b53f7a2d4$export$7bf70fcf9f891893.prototype._setValue_direct_setNeedsUpdate,
        $9ddd7e9b53f7a2d4$export$7bf70fcf9f891893.prototype._setValue_direct_setMatrixWorldNeedsUpdate
    ],
    [
        // EntireArray
        $9ddd7e9b53f7a2d4$export$7bf70fcf9f891893.prototype._setValue_array,
        $9ddd7e9b53f7a2d4$export$7bf70fcf9f891893.prototype._setValue_array_setNeedsUpdate,
        $9ddd7e9b53f7a2d4$export$7bf70fcf9f891893.prototype._setValue_array_setMatrixWorldNeedsUpdate
    ],
    [
        // ArrayElement
        $9ddd7e9b53f7a2d4$export$7bf70fcf9f891893.prototype._setValue_arrayElement,
        $9ddd7e9b53f7a2d4$export$7bf70fcf9f891893.prototype._setValue_arrayElement_setNeedsUpdate,
        $9ddd7e9b53f7a2d4$export$7bf70fcf9f891893.prototype._setValue_arrayElement_setMatrixWorldNeedsUpdate
    ],
    [
        // HasToFromArray
        $9ddd7e9b53f7a2d4$export$7bf70fcf9f891893.prototype._setValue_fromArray,
        $9ddd7e9b53f7a2d4$export$7bf70fcf9f891893.prototype._setValue_fromArray_setNeedsUpdate,
        $9ddd7e9b53f7a2d4$export$7bf70fcf9f891893.prototype._setValue_fromArray_setMatrixWorldNeedsUpdate
    ]
];
/**
 * A group of objects that receives a shared animation state.
 *
 * Usage:
 *
 * - Add objects you would otherwise pass as 'root' to the
 * constructor or the .clipAction method of AnimationMixer.
 * - Instead pass this object as 'root'.
 * - You can also add and remove objects later when the mixer is running.
 *
 * Note:
 *
 * - Objects of this class appear as one object to the mixer,
 * so cache control of the individual objects must be done on the group.
 *
 * Limitation:
 *
 * - The animated properties must be compatible among the all objects in the group.
 * - A single property can either be controlled through a target group or directly, but not both.
 */ class $9ddd7e9b53f7a2d4$export$30619c2afd3f34db {
    /**
	 * Constructs a new animation group.
	 *
	 * @param {...Object3D} arguments - An arbitrary number of 3D objects that share the same animation state.
	 */ constructor(){
        /**
		 * This flag can be used for type testing.
		 *
		 * @type {boolean}
		 * @readonly
		 * @default true
		 */ this.isAnimationObjectGroup = true;
        /**
		 * The UUID of the 3D object.
		 *
		 * @type {string}
		 * @readonly
		 */ this.uuid = $9ddd7e9b53f7a2d4$var$generateUUID();
        // cached objects followed by the active ones
        this._objects = Array.prototype.slice.call(arguments);
        this.nCachedObjects_ = 0; // threshold
        // note: read by PropertyBinding.Composite
        const indices = {};
        this._indicesByUUID = indices; // for bookkeeping
        for(let i = 0, n = arguments.length; i !== n; ++i)indices[arguments[i].uuid] = i;
        this._paths = []; // inside: string
        this._parsedPaths = []; // inside: { we don't care, here }
        this._bindings = []; // inside: Array< PropertyBinding >
        this._bindingsIndicesByPath = {}; // inside: indices in these arrays
        const scope = this;
        this.stats = {
            objects: {
                get total () {
                    return scope._objects.length;
                },
                get inUse () {
                    return this.total - scope.nCachedObjects_;
                }
            },
            get bindingsPerObject () {
                return scope._bindings.length;
            }
        };
    }
    /**
	 * Adds an arbitrary number of objects to this animation group.
	 *
	 * @param {...Object3D} arguments - The 3D objects to add.
	 */ add() {
        const objects = this._objects, indicesByUUID = this._indicesByUUID, paths = this._paths, parsedPaths = this._parsedPaths, bindings = this._bindings, nBindings = bindings.length;
        let knownObject = undefined, nObjects = objects.length, nCachedObjects = this.nCachedObjects_;
        for(let i = 0, n = arguments.length; i !== n; ++i){
            const object = arguments[i], uuid = object.uuid;
            let index = indicesByUUID[uuid];
            if (index === undefined) {
                // unknown object -> add it to the ACTIVE region
                index = nObjects++;
                indicesByUUID[uuid] = index;
                objects.push(object);
                // accounting is done, now do the same for all bindings
                for(let j = 0, m = nBindings; j !== m; ++j)bindings[j].push(new $9ddd7e9b53f7a2d4$export$7bf70fcf9f891893(object, paths[j], parsedPaths[j]));
            } else if (index < nCachedObjects) {
                knownObject = objects[index];
                // move existing object to the ACTIVE region
                const firstActiveIndex = --nCachedObjects, lastCachedObject = objects[firstActiveIndex];
                indicesByUUID[lastCachedObject.uuid] = index;
                objects[index] = lastCachedObject;
                indicesByUUID[uuid] = firstActiveIndex;
                objects[firstActiveIndex] = object;
                // accounting is done, now do the same for all bindings
                for(let j = 0, m = nBindings; j !== m; ++j){
                    const bindingsForPath = bindings[j], lastCached = bindingsForPath[firstActiveIndex];
                    let binding = bindingsForPath[index];
                    bindingsForPath[index] = lastCached;
                    if (binding === undefined) // since we do not bother to create new bindings
                    // for objects that are cached, the binding may
                    // or may not exist
                    binding = new $9ddd7e9b53f7a2d4$export$7bf70fcf9f891893(object, paths[j], parsedPaths[j]);
                    bindingsForPath[firstActiveIndex] = binding;
                }
            } else if (objects[index] !== knownObject) console.error("THREE.AnimationObjectGroup: Different objects with the same UUID detected. Clean the caches or recreate your infrastructure when reloading scenes.");
             // else the object is already where we want it to be
        } // for arguments
        this.nCachedObjects_ = nCachedObjects;
    }
    /**
	 * Removes an arbitrary number of objects to this animation group
	 *
	 * @param {...Object3D} arguments - The 3D objects to remove.
	 */ remove() {
        const objects = this._objects, indicesByUUID = this._indicesByUUID, bindings = this._bindings, nBindings = bindings.length;
        let nCachedObjects = this.nCachedObjects_;
        for(let i = 0, n = arguments.length; i !== n; ++i){
            const object = arguments[i], uuid = object.uuid, index = indicesByUUID[uuid];
            if (index !== undefined && index >= nCachedObjects) {
                // move existing object into the CACHED region
                const lastCachedIndex = nCachedObjects++, firstActiveObject = objects[lastCachedIndex];
                indicesByUUID[firstActiveObject.uuid] = index;
                objects[index] = firstActiveObject;
                indicesByUUID[uuid] = lastCachedIndex;
                objects[lastCachedIndex] = object;
                // accounting is done, now do the same for all bindings
                for(let j = 0, m = nBindings; j !== m; ++j){
                    const bindingsForPath = bindings[j], firstActive = bindingsForPath[lastCachedIndex], binding = bindingsForPath[index];
                    bindingsForPath[index] = firstActive;
                    bindingsForPath[lastCachedIndex] = binding;
                }
            }
        } // for arguments
        this.nCachedObjects_ = nCachedObjects;
    }
    /**
	 * Deallocates all memory resources for the passed 3D objects of this animation group.
	 *
	 * @param {...Object3D} arguments - The 3D objects to uncache.
	 */ uncache() {
        const objects = this._objects, indicesByUUID = this._indicesByUUID, bindings = this._bindings, nBindings = bindings.length;
        let nCachedObjects = this.nCachedObjects_, nObjects = objects.length;
        for(let i = 0, n = arguments.length; i !== n; ++i){
            const object = arguments[i], uuid = object.uuid, index = indicesByUUID[uuid];
            if (index !== undefined) {
                delete indicesByUUID[uuid];
                if (index < nCachedObjects) {
                    // object is cached, shrink the CACHED region
                    const firstActiveIndex = --nCachedObjects, lastCachedObject = objects[firstActiveIndex], lastIndex = --nObjects, lastObject = objects[lastIndex];
                    // last cached object takes this object's place
                    indicesByUUID[lastCachedObject.uuid] = index;
                    objects[index] = lastCachedObject;
                    // last object goes to the activated slot and pop
                    indicesByUUID[lastObject.uuid] = firstActiveIndex;
                    objects[firstActiveIndex] = lastObject;
                    objects.pop();
                    // accounting is done, now do the same for all bindings
                    for(let j = 0, m = nBindings; j !== m; ++j){
                        const bindingsForPath = bindings[j], lastCached = bindingsForPath[firstActiveIndex], last = bindingsForPath[lastIndex];
                        bindingsForPath[index] = lastCached;
                        bindingsForPath[firstActiveIndex] = last;
                        bindingsForPath.pop();
                    }
                } else {
                    // object is active, just swap with the last and pop
                    const lastIndex = --nObjects, lastObject = objects[lastIndex];
                    if (lastIndex > 0) indicesByUUID[lastObject.uuid] = index;
                    objects[index] = lastObject;
                    objects.pop();
                    // accounting is done, now do the same for all bindings
                    for(let j = 0, m = nBindings; j !== m; ++j){
                        const bindingsForPath = bindings[j];
                        bindingsForPath[index] = bindingsForPath[lastIndex];
                        bindingsForPath.pop();
                    }
                } // cached or active
            } // if object is known
        } // for arguments
        this.nCachedObjects_ = nCachedObjects;
    }
    // Internal interface used by befriended PropertyBinding.Composite:
    subscribe_(path, parsedPath) {
        // returns an array of bindings for the given path that is changed
        // according to the contained objects in the group
        const indicesByPath = this._bindingsIndicesByPath;
        let index = indicesByPath[path];
        const bindings = this._bindings;
        if (index !== undefined) return bindings[index];
        const paths = this._paths, parsedPaths = this._parsedPaths, objects = this._objects, nObjects = objects.length, nCachedObjects = this.nCachedObjects_, bindingsForPath = new Array(nObjects);
        index = bindings.length;
        indicesByPath[path] = index;
        paths.push(path);
        parsedPaths.push(parsedPath);
        bindings.push(bindingsForPath);
        for(let i = nCachedObjects, n = objects.length; i !== n; ++i){
            const object = objects[i];
            bindingsForPath[i] = new $9ddd7e9b53f7a2d4$export$7bf70fcf9f891893(object, path, parsedPath);
        }
        return bindingsForPath;
    }
    unsubscribe_(path) {
        // tells the group to forget about a property path and no longer
        // update the array previously obtained with 'subscribe_'
        const indicesByPath = this._bindingsIndicesByPath, index = indicesByPath[path];
        if (index !== undefined) {
            const paths = this._paths, parsedPaths = this._parsedPaths, bindings = this._bindings, lastBindingsIndex = bindings.length - 1, lastBindings = bindings[lastBindingsIndex], lastBindingsPath = path[lastBindingsIndex];
            indicesByPath[lastBindingsPath] = index;
            bindings[index] = lastBindings;
            bindings.pop();
            parsedPaths[index] = parsedPaths[lastBindingsIndex];
            parsedPaths.pop();
            paths[index] = paths[lastBindingsIndex];
            paths.pop();
        }
    }
}
/**
 * An instance of `AnimationAction` schedules the playback of an animation which is
 * stored in {@link AnimationClip}.
 */ class $9ddd7e9b53f7a2d4$export$6946940a69e799e {
    /**
	 * Constructs a new animation action.
	 *
	 * @param {AnimationMixer} mixer - The mixer that is controlled by this action.
	 * @param {AnimationClip} clip - The animation clip that holds the actual keyframes.
	 * @param {?Object3D} [localRoot=null] - The root object on which this action is performed.
	 * @param {(NormalAnimationBlendMode|AdditiveAnimationBlendMode)} [blendMode] - The blend mode.
	 */ constructor(mixer, clip, localRoot = null, blendMode = clip.blendMode){
        this._mixer = mixer;
        this._clip = clip;
        this._localRoot = localRoot;
        /**
		 * Defines how the animation is blended/combined when two or more animations
		 * are simultaneously played.
		 *
		 * @type {(NormalAnimationBlendMode|AdditiveAnimationBlendMode)}
		 */ this.blendMode = blendMode;
        const tracks = clip.tracks, nTracks = tracks.length, interpolants = new Array(nTracks);
        const interpolantSettings = {
            endingStart: $9ddd7e9b53f7a2d4$export$7f795934b84ab523,
            endingEnd: $9ddd7e9b53f7a2d4$export$7f795934b84ab523
        };
        for(let i = 0; i !== nTracks; ++i){
            const interpolant = tracks[i].createInterpolant(null);
            interpolants[i] = interpolant;
            interpolant.settings = interpolantSettings;
        }
        this._interpolantSettings = interpolantSettings;
        this._interpolants = interpolants; // bound by the mixer
        // inside: PropertyMixer (managed by the mixer)
        this._propertyBindings = new Array(nTracks);
        this._cacheIndex = null; // for the memory manager
        this._byClipCacheIndex = null; // for the memory manager
        this._timeScaleInterpolant = null;
        this._weightInterpolant = null;
        /**
		 * The loop mode, set via {@link AnimationAction#setLoop}.
		 *
		 * @type {(LoopRepeat|LoopOnce|LoopPingPong)}
		 * @default LoopRepeat
		 */ this.loop = $9ddd7e9b53f7a2d4$export$dfaf4422ce096e29;
        this._loopCount = -1;
        // global mixer time when the action is to be started
        // it's set back to 'null' upon start of the action
        this._startTime = null;
        /**
		 * The local time of this action (in seconds, starting with `0`).
		 *
		 * The value gets clamped or wrapped to `[0,clip.duration]` (according to the
		 * loop state).
		 *
		 * @type {number}
		 * @default Infinity
		 */ this.time = 0;
        /**
		 * Scaling factor for the {@link AnimationAction#time}. A value of `0` causes the
		 * animation to pause. Negative values cause the animation to play backwards.
		 *
		 * @type {number}
		 * @default 1
		 */ this.timeScale = 1;
        this._effectiveTimeScale = 1;
        /**
		 * The degree of influence of this action (in the interval `[0, 1]`). Values
		 * between `0` (no impact) and `1` (full impact) can be used to blend between
		 * several actions.
		 *
		 * @type {number}
		 * @default 1
		 */ this.weight = 1;
        this._effectiveWeight = 1;
        /**
		 * The number of repetitions of the performed clip over the course of this action.
		 * Can be set via {@link AnimationAction#setLoop}.
		 *
		 * Setting this number has no effect if {@link AnimationAction#loop} is set to
		 * `THREE:LoopOnce`.
		 *
		 * @type {number}
		 * @default Infinity
		 */ this.repetitions = Infinity;
        /**
		 * If set to `true`, the playback of the action is paused.
		 *
		 * @type {boolean}
		 * @default false
		 */ this.paused = false;
        /**
		 * If set to `false`, the action is disabled so it has no impact.
		 *
		 * When the action is re-enabled, the animation continues from its current
		 * time (setting `enabled` to `false` doesn't reset the action).
		 *
		 * @type {boolean}
		 * @default true
		 */ this.enabled = true;
        /**
		 * If set to true the animation will automatically be paused on its last frame.
		 *
		 * If set to false, {@link AnimationAction#enabled} will automatically be switched
		 * to `false` when the last loop of the action has finished, so that this action has
		 * no further impact.
		 *
		 * Note: This member has no impact if the action is interrupted (it
		 * has only an effect if its last loop has really finished).
		 *
		 * @type {boolean}
		 * @default false
		 */ this.clampWhenFinished = false;
        /**
		 * Enables smooth interpolation without separate clips for start, loop and end.
		 *
		 * @type {boolean}
		 * @default true
		 */ this.zeroSlopeAtStart = true;
        /**
		 * Enables smooth interpolation without separate clips for start, loop and end.
		 *
		 * @type {boolean}
		 * @default true
		 */ this.zeroSlopeAtEnd = true;
    }
    /**
	 * Starts the playback of the animation.
	 *
	 * @return {AnimationAction} A reference to this animation action.
	 */ play() {
        this._mixer._activateAction(this);
        return this;
    }
    /**
	 * Stops the playback of the animation.
	 *
	 * @return {AnimationAction} A reference to this animation action.
	 */ stop() {
        this._mixer._deactivateAction(this);
        return this.reset();
    }
    /**
	 * Resets the playback of the animation.
	 *
	 * @return {AnimationAction} A reference to this animation action.
	 */ reset() {
        this.paused = false;
        this.enabled = true;
        this.time = 0; // restart clip
        this._loopCount = -1; // forget previous loops
        this._startTime = null; // forget scheduling
        return this.stopFading().stopWarping();
    }
    /**
	 * Returns `true` if the animation is running.
	 *
	 * @return {boolean} Whether the animation is running or not.
	 */ isRunning() {
        return this.enabled && !this.paused && this.timeScale !== 0 && this._startTime === null && this._mixer._isActiveAction(this);
    }
    /**
	 * Returns `true` when {@link AnimationAction#play} has been called.
	 *
	 * @return {boolean} Whether the animation is scheduled or not.
	 */ isScheduled() {
        return this._mixer._isActiveAction(this);
    }
    /**
	 * Defines the time when the animation should start.
	 *
	 * @param {number} time - The start time in seconds.
	 * @return {AnimationAction} A reference to this animation action.
	 */ startAt(time) {
        this._startTime = time;
        return this;
    }
    /**
	 * Configures the loop settings for this action.
	 *
	 * @param {(LoopRepeat|LoopOnce|LoopPingPong)} mode - The loop mode.
	 * @param {number} repetitions - The number of repetitions.
	 * @return {AnimationAction} A reference to this animation action.
	 */ setLoop(mode, repetitions) {
        this.loop = mode;
        this.repetitions = repetitions;
        return this;
    }
    /**
	 * Sets the effective weight of this action.
	 *
	 * An action has no effect and thus an effective weight of zero when the
	 * action is disabled.
	 *
	 * @param {number} weight - The weight to set.
	 * @return {AnimationAction} A reference to this animation action.
	 */ setEffectiveWeight(weight) {
        this.weight = weight;
        // note: same logic as when updated at runtime
        this._effectiveWeight = this.enabled ? weight : 0;
        return this.stopFading();
    }
    /**
	 * Returns the effective weight of this action.
	 *
	 * @return {number} The effective weight.
	 */ getEffectiveWeight() {
        return this._effectiveWeight;
    }
    /**
	 * Fades the animation in by increasing its weight gradually from `0` to `1`,
	 * within the passed time interval.
	 *
	 * @param {number} duration - The duration of the fade.
	 * @return {AnimationAction} A reference to this animation action.
	 */ fadeIn(duration) {
        return this._scheduleFading(duration, 0, 1);
    }
    /**
	 * Fades the animation out by decreasing its weight gradually from `1` to `0`,
	 * within the passed time interval.
	 *
	 * @param {number} duration - The duration of the fade.
	 * @return {AnimationAction} A reference to this animation action.
	 */ fadeOut(duration) {
        return this._scheduleFading(duration, 1, 0);
    }
    /**
	 * Causes this action to fade in and the given action to fade out,
	 * within the passed time interval.
	 *
	 * @param {AnimationAction} fadeOutAction - The animation action to fade out.
	 * @param {number} duration - The duration of the fade.
	 * @param {boolean} [warp=false] - Whether warping should be used or not.
	 * @return {AnimationAction} A reference to this animation action.
	 */ crossFadeFrom(fadeOutAction, duration, warp = false) {
        fadeOutAction.fadeOut(duration);
        this.fadeIn(duration);
        if (warp === true) {
            const fadeInDuration = this._clip.duration, fadeOutDuration = fadeOutAction._clip.duration, startEndRatio = fadeOutDuration / fadeInDuration, endStartRatio = fadeInDuration / fadeOutDuration;
            fadeOutAction.warp(1.0, startEndRatio, duration);
            this.warp(endStartRatio, 1.0, duration);
        }
        return this;
    }
    /**
	 * Causes this action to fade out and the given action to fade in,
	 * within the passed time interval.
	 *
	 * @param {AnimationAction} fadeInAction - The animation action to fade in.
	 * @param {number} duration - The duration of the fade.
	 * @param {boolean} [warp=false] - Whether warping should be used or not.
	 * @return {AnimationAction} A reference to this animation action.
	 */ crossFadeTo(fadeInAction, duration, warp = false) {
        return fadeInAction.crossFadeFrom(this, duration, warp);
    }
    /**
	 * Stops any fading which is applied to this action.
	 *
	 * @return {AnimationAction} A reference to this animation action.
	 */ stopFading() {
        const weightInterpolant = this._weightInterpolant;
        if (weightInterpolant !== null) {
            this._weightInterpolant = null;
            this._mixer._takeBackControlInterpolant(weightInterpolant);
        }
        return this;
    }
    /**
	 * Sets the effective time scale of this action.
	 *
	 * An action has no effect and thus an effective time scale of zero when the
	 * action is paused.
	 *
	 * @param {number} timeScale - The time scale to set.
	 * @return {AnimationAction} A reference to this animation action.
	 */ setEffectiveTimeScale(timeScale) {
        this.timeScale = timeScale;
        this._effectiveTimeScale = this.paused ? 0 : timeScale;
        return this.stopWarping();
    }
    /**
	 * Returns the effective time scale of this action.
	 *
	 * @return {number} The effective time scale.
	 */ getEffectiveTimeScale() {
        return this._effectiveTimeScale;
    }
    /**
	 * Sets the duration for a single loop of this action.
	 *
	 * @param {number} duration - The duration to set.
	 * @return {AnimationAction} A reference to this animation action.
	 */ setDuration(duration) {
        this.timeScale = this._clip.duration / duration;
        return this.stopWarping();
    }
    /**
	 * Synchronizes this action with the passed other action.
	 *
	 * @param {AnimationAction} action - The action to sync with.
	 * @return {AnimationAction} A reference to this animation action.
	 */ syncWith(action) {
        this.time = action.time;
        this.timeScale = action.timeScale;
        return this.stopWarping();
    }
    /**
	 * Decelerates this animation's speed to `0` within the passed time interval.
	 *
	 * @param {number} duration - The duration.
	 * @return {AnimationAction} A reference to this animation action.
	 */ halt(duration) {
        return this.warp(this._effectiveTimeScale, 0, duration);
    }
    /**
	 * Changes the playback speed, within the passed time interval, by modifying
	 * {@link AnimationAction#timeScale} gradually from `startTimeScale` to
	 * `endTimeScale`.
	 *
	 * @param {number} startTimeScale - The start time scale.
	 * @param {number} endTimeScale - The end time scale.
	 * @param {number} duration - The duration.
	 * @return {AnimationAction} A reference to this animation action.
	 */ warp(startTimeScale, endTimeScale, duration) {
        const mixer = this._mixer, now = mixer.time, timeScale = this.timeScale;
        let interpolant = this._timeScaleInterpolant;
        if (interpolant === null) {
            interpolant = mixer._lendControlInterpolant();
            this._timeScaleInterpolant = interpolant;
        }
        const times = interpolant.parameterPositions, values = interpolant.sampleValues;
        times[0] = now;
        times[1] = now + duration;
        values[0] = startTimeScale / timeScale;
        values[1] = endTimeScale / timeScale;
        return this;
    }
    /**
	 * Stops any scheduled warping which is applied to this action.
	 *
	 * @return {AnimationAction} A reference to this animation action.
	 */ stopWarping() {
        const timeScaleInterpolant = this._timeScaleInterpolant;
        if (timeScaleInterpolant !== null) {
            this._timeScaleInterpolant = null;
            this._mixer._takeBackControlInterpolant(timeScaleInterpolant);
        }
        return this;
    }
    /**
	 * Returns the animation mixer of this animation action.
	 *
	 * @return {AnimationMixer} The animation mixer.
	 */ getMixer() {
        return this._mixer;
    }
    /**
	 * Returns the animation clip of this animation action.
	 *
	 * @return {AnimationClip} The animation clip.
	 */ getClip() {
        return this._clip;
    }
    /**
	 * Returns the root object of this animation action.
	 *
	 * @return {Object3D} The root object.
	 */ getRoot() {
        return this._localRoot || this._mixer._root;
    }
    // Interna
    _update(time, deltaTime, timeDirection, accuIndex) {
        // called by the mixer
        if (!this.enabled) {
            // call ._updateWeight() to update ._effectiveWeight
            this._updateWeight(time);
            return;
        }
        const startTime = this._startTime;
        if (startTime !== null) {
            // check for scheduled start of action
            const timeRunning = (time - startTime) * timeDirection;
            if (timeRunning < 0 || timeDirection === 0) deltaTime = 0;
            else {
                this._startTime = null; // unschedule
                deltaTime = timeDirection * timeRunning;
            }
        }
        // apply time scale and advance time
        deltaTime *= this._updateTimeScale(time);
        const clipTime = this._updateTime(deltaTime);
        // note: _updateTime may disable the action resulting in
        // an effective weight of 0
        const weight = this._updateWeight(time);
        if (weight > 0) {
            const interpolants = this._interpolants;
            const propertyMixers = this._propertyBindings;
            switch(this.blendMode){
                case $9ddd7e9b53f7a2d4$export$d875e029ef558d3:
                    for(let j = 0, m = interpolants.length; j !== m; ++j){
                        interpolants[j].evaluate(clipTime);
                        propertyMixers[j].accumulateAdditive(weight);
                    }
                    break;
                case $9ddd7e9b53f7a2d4$export$bcfbbdcf8de7f8cd:
                default:
                    for(let j = 0, m = interpolants.length; j !== m; ++j){
                        interpolants[j].evaluate(clipTime);
                        propertyMixers[j].accumulate(accuIndex, weight);
                    }
            }
        }
    }
    _updateWeight(time) {
        let weight = 0;
        if (this.enabled) {
            weight = this.weight;
            const interpolant = this._weightInterpolant;
            if (interpolant !== null) {
                const interpolantValue = interpolant.evaluate(time)[0];
                weight *= interpolantValue;
                if (time > interpolant.parameterPositions[1]) {
                    this.stopFading();
                    if (interpolantValue === 0) // faded out, disable
                    this.enabled = false;
                }
            }
        }
        this._effectiveWeight = weight;
        return weight;
    }
    _updateTimeScale(time) {
        let timeScale = 0;
        if (!this.paused) {
            timeScale = this.timeScale;
            const interpolant = this._timeScaleInterpolant;
            if (interpolant !== null) {
                const interpolantValue = interpolant.evaluate(time)[0];
                timeScale *= interpolantValue;
                if (time > interpolant.parameterPositions[1]) {
                    this.stopWarping();
                    if (timeScale === 0) // motion has halted, pause
                    this.paused = true;
                    else // warp done - apply final time scale
                    this.timeScale = timeScale;
                }
            }
        }
        this._effectiveTimeScale = timeScale;
        return timeScale;
    }
    _updateTime(deltaTime) {
        const duration = this._clip.duration;
        const loop = this.loop;
        let time = this.time + deltaTime;
        let loopCount = this._loopCount;
        const pingPong = loop === $9ddd7e9b53f7a2d4$export$f8f6f2041b78e210;
        if (deltaTime === 0) {
            if (loopCount === -1) return time;
            return pingPong && (loopCount & 1) === 1 ? duration - time : time;
        }
        if (loop === $9ddd7e9b53f7a2d4$export$d62fdc9d1b1cccad) {
            if (loopCount === -1) {
                // just started
                this._loopCount = 0;
                this._setEndings(true, true, false);
            }
            handle_stop: {
                if (time >= duration) time = duration;
                else if (time < 0) time = 0;
                else {
                    this.time = time;
                    break handle_stop;
                }
                if (this.clampWhenFinished) this.paused = true;
                else this.enabled = false;
                this.time = time;
                this._mixer.dispatchEvent({
                    type: 'finished',
                    action: this,
                    direction: deltaTime < 0 ? -1 : 1
                });
            }
        } else {
            if (loopCount === -1) {
                // just started
                if (deltaTime >= 0) {
                    loopCount = 0;
                    this._setEndings(true, this.repetitions === 0, pingPong);
                } else // when looping in reverse direction, the initial
                // transition through zero counts as a repetition,
                // so leave loopCount at -1
                this._setEndings(this.repetitions === 0, true, pingPong);
            }
            if (time >= duration || time < 0) {
                // wrap around
                const loopDelta = Math.floor(time / duration); // signed
                time -= duration * loopDelta;
                loopCount += Math.abs(loopDelta);
                const pending = this.repetitions - loopCount;
                if (pending <= 0) {
                    // have to stop (switch state, clamp time, fire event)
                    if (this.clampWhenFinished) this.paused = true;
                    else this.enabled = false;
                    time = deltaTime > 0 ? duration : 0;
                    this.time = time;
                    this._mixer.dispatchEvent({
                        type: 'finished',
                        action: this,
                        direction: deltaTime > 0 ? 1 : -1
                    });
                } else {
                    // keep running
                    if (pending === 1) {
                        // entering the last round
                        const atStart = deltaTime < 0;
                        this._setEndings(atStart, !atStart, pingPong);
                    } else this._setEndings(false, false, pingPong);
                    this._loopCount = loopCount;
                    this.time = time;
                    this._mixer.dispatchEvent({
                        type: 'loop',
                        action: this,
                        loopDelta: loopDelta
                    });
                }
            } else this.time = time;
            if (pingPong && (loopCount & 1) === 1) // invert time for the "pong round"
            return duration - time;
        }
        return time;
    }
    _setEndings(atStart, atEnd, pingPong) {
        const settings = this._interpolantSettings;
        if (pingPong) {
            settings.endingStart = $9ddd7e9b53f7a2d4$export$24a4ccb5099273b5;
            settings.endingEnd = $9ddd7e9b53f7a2d4$export$24a4ccb5099273b5;
        } else {
            // assuming for LoopOnce atStart == atEnd == true
            if (atStart) settings.endingStart = this.zeroSlopeAtStart ? $9ddd7e9b53f7a2d4$export$24a4ccb5099273b5 : $9ddd7e9b53f7a2d4$export$7f795934b84ab523;
            else settings.endingStart = $9ddd7e9b53f7a2d4$export$8e8c3ecdcd8e1fee;
            if (atEnd) settings.endingEnd = this.zeroSlopeAtEnd ? $9ddd7e9b53f7a2d4$export$24a4ccb5099273b5 : $9ddd7e9b53f7a2d4$export$7f795934b84ab523;
            else settings.endingEnd = $9ddd7e9b53f7a2d4$export$8e8c3ecdcd8e1fee;
        }
    }
    _scheduleFading(duration, weightNow, weightThen) {
        const mixer = this._mixer, now = mixer.time;
        let interpolant = this._weightInterpolant;
        if (interpolant === null) {
            interpolant = mixer._lendControlInterpolant();
            this._weightInterpolant = interpolant;
        }
        const times = interpolant.parameterPositions, values = interpolant.sampleValues;
        times[0] = now;
        values[0] = weightNow;
        times[1] = now + duration;
        values[1] = weightThen;
        return this;
    }
}
const $9ddd7e9b53f7a2d4$var$_controlInterpolantsResultBuffer = new Float32Array(1);
/**
 * `AnimationMixer` is a player for animations on a particular object in
 * the scene. When multiple objects in the scene are animated independently,
 * one `AnimationMixer` may be used for each object.
 */ class $9ddd7e9b53f7a2d4$export$fbd77e5aefaa0102 extends $9ddd7e9b53f7a2d4$export$ec8b666c5fe2c75a {
    /**
	 * Constructs a new animation mixer.
	 *
	 * @param {Object3D} root - The object whose animations shall be played by this mixer.
	 */ constructor(root){
        super();
        this._root = root;
        this._initMemoryManager();
        this._accuIndex = 0;
        /**
		 * The global mixer time (in seconds; starting with `0` on the mixer's creation).
		 *
		 * @type {number}
		 * @default 0
		 */ this.time = 0;
        /**
		 * A scaling factor for the global time.
		 *
		 * Note: Setting this member to `0` and later back to `1` is a
		 * possibility to pause/unpause all actions that are controlled by this
		 * mixer.
		 *
		 * @type {number}
		 * @default 1
		 */ this.timeScale = 1.0;
    }
    _bindAction(action, prototypeAction) {
        const root = action._localRoot || this._root, tracks = action._clip.tracks, nTracks = tracks.length, bindings = action._propertyBindings, interpolants = action._interpolants, rootUuid = root.uuid, bindingsByRoot = this._bindingsByRootAndName;
        let bindingsByName = bindingsByRoot[rootUuid];
        if (bindingsByName === undefined) {
            bindingsByName = {};
            bindingsByRoot[rootUuid] = bindingsByName;
        }
        for(let i = 0; i !== nTracks; ++i){
            const track = tracks[i], trackName = track.name;
            let binding = bindingsByName[trackName];
            if (binding !== undefined) {
                ++binding.referenceCount;
                bindings[i] = binding;
            } else {
                binding = bindings[i];
                if (binding !== undefined) {
                    // existing binding, make sure the cache knows
                    if (binding._cacheIndex === null) {
                        ++binding.referenceCount;
                        this._addInactiveBinding(binding, rootUuid, trackName);
                    }
                    continue;
                }
                const path = prototypeAction && prototypeAction._propertyBindings[i].binding.parsedPath;
                binding = new $9ddd7e9b53f7a2d4$export$dfe0af1ca1acb78a($9ddd7e9b53f7a2d4$export$7bf70fcf9f891893.create(root, trackName, path), track.ValueTypeName, track.getValueSize());
                ++binding.referenceCount;
                this._addInactiveBinding(binding, rootUuid, trackName);
                bindings[i] = binding;
            }
            interpolants[i].resultBuffer = binding.buffer;
        }
    }
    _activateAction(action) {
        if (!this._isActiveAction(action)) {
            if (action._cacheIndex === null) {
                // this action has been forgotten by the cache, but the user
                // appears to be still using it -> rebind
                const rootUuid = (action._localRoot || this._root).uuid, clipUuid = action._clip.uuid, actionsForClip = this._actionsByClip[clipUuid];
                this._bindAction(action, actionsForClip && actionsForClip.knownActions[0]);
                this._addInactiveAction(action, clipUuid, rootUuid);
            }
            const bindings = action._propertyBindings;
            // increment reference counts / sort out state
            for(let i = 0, n = bindings.length; i !== n; ++i){
                const binding = bindings[i];
                if (binding.useCount++ === 0) {
                    this._lendBinding(binding);
                    binding.saveOriginalState();
                }
            }
            this._lendAction(action);
        }
    }
    _deactivateAction(action) {
        if (this._isActiveAction(action)) {
            const bindings = action._propertyBindings;
            // decrement reference counts / sort out state
            for(let i = 0, n = bindings.length; i !== n; ++i){
                const binding = bindings[i];
                if (--binding.useCount === 0) {
                    binding.restoreOriginalState();
                    this._takeBackBinding(binding);
                }
            }
            this._takeBackAction(action);
        }
    }
    // Memory manager
    _initMemoryManager() {
        this._actions = []; // 'nActiveActions' followed by inactive ones
        this._nActiveActions = 0;
        this._actionsByClip = {};
        // inside:
        // {
        // 	knownActions: Array< AnimationAction > - used as prototypes
        // 	actionByRoot: AnimationAction - lookup
        // }
        this._bindings = []; // 'nActiveBindings' followed by inactive ones
        this._nActiveBindings = 0;
        this._bindingsByRootAndName = {}; // inside: Map< name, PropertyMixer >
        this._controlInterpolants = []; // same game as above
        this._nActiveControlInterpolants = 0;
        const scope = this;
        this.stats = {
            actions: {
                get total () {
                    return scope._actions.length;
                },
                get inUse () {
                    return scope._nActiveActions;
                }
            },
            bindings: {
                get total () {
                    return scope._bindings.length;
                },
                get inUse () {
                    return scope._nActiveBindings;
                }
            },
            controlInterpolants: {
                get total () {
                    return scope._controlInterpolants.length;
                },
                get inUse () {
                    return scope._nActiveControlInterpolants;
                }
            }
        };
    }
    // Memory management for AnimationAction objects
    _isActiveAction(action) {
        const index = action._cacheIndex;
        return index !== null && index < this._nActiveActions;
    }
    _addInactiveAction(action, clipUuid, rootUuid) {
        const actions = this._actions, actionsByClip = this._actionsByClip;
        let actionsForClip = actionsByClip[clipUuid];
        if (actionsForClip === undefined) {
            actionsForClip = {
                knownActions: [
                    action
                ],
                actionByRoot: {}
            };
            action._byClipCacheIndex = 0;
            actionsByClip[clipUuid] = actionsForClip;
        } else {
            const knownActions = actionsForClip.knownActions;
            action._byClipCacheIndex = knownActions.length;
            knownActions.push(action);
        }
        action._cacheIndex = actions.length;
        actions.push(action);
        actionsForClip.actionByRoot[rootUuid] = action;
    }
    _removeInactiveAction(action) {
        const actions = this._actions, lastInactiveAction = actions[actions.length - 1], cacheIndex = action._cacheIndex;
        lastInactiveAction._cacheIndex = cacheIndex;
        actions[cacheIndex] = lastInactiveAction;
        actions.pop();
        action._cacheIndex = null;
        const clipUuid = action._clip.uuid, actionsByClip = this._actionsByClip, actionsForClip = actionsByClip[clipUuid], knownActionsForClip = actionsForClip.knownActions, lastKnownAction = knownActionsForClip[knownActionsForClip.length - 1], byClipCacheIndex = action._byClipCacheIndex;
        lastKnownAction._byClipCacheIndex = byClipCacheIndex;
        knownActionsForClip[byClipCacheIndex] = lastKnownAction;
        knownActionsForClip.pop();
        action._byClipCacheIndex = null;
        const actionByRoot = actionsForClip.actionByRoot, rootUuid = (action._localRoot || this._root).uuid;
        delete actionByRoot[rootUuid];
        if (knownActionsForClip.length === 0) delete actionsByClip[clipUuid];
        this._removeInactiveBindingsForAction(action);
    }
    _removeInactiveBindingsForAction(action) {
        const bindings = action._propertyBindings;
        for(let i = 0, n = bindings.length; i !== n; ++i){
            const binding = bindings[i];
            if (--binding.referenceCount === 0) this._removeInactiveBinding(binding);
        }
    }
    _lendAction(action) {
        // [ active actions |  inactive actions  ]
        // [  active actions >| inactive actions ]
        //                 s        a
        //                  <-swap->
        //                 a        s
        const actions = this._actions, prevIndex = action._cacheIndex, lastActiveIndex = this._nActiveActions++, firstInactiveAction = actions[lastActiveIndex];
        action._cacheIndex = lastActiveIndex;
        actions[lastActiveIndex] = action;
        firstInactiveAction._cacheIndex = prevIndex;
        actions[prevIndex] = firstInactiveAction;
    }
    _takeBackAction(action) {
        // [  active actions  | inactive actions ]
        // [ active actions |< inactive actions  ]
        //        a        s
        //         <-swap->
        //        s        a
        const actions = this._actions, prevIndex = action._cacheIndex, firstInactiveIndex = --this._nActiveActions, lastActiveAction = actions[firstInactiveIndex];
        action._cacheIndex = firstInactiveIndex;
        actions[firstInactiveIndex] = action;
        lastActiveAction._cacheIndex = prevIndex;
        actions[prevIndex] = lastActiveAction;
    }
    // Memory management for PropertyMixer objects
    _addInactiveBinding(binding, rootUuid, trackName) {
        const bindingsByRoot = this._bindingsByRootAndName, bindings = this._bindings;
        let bindingByName = bindingsByRoot[rootUuid];
        if (bindingByName === undefined) {
            bindingByName = {};
            bindingsByRoot[rootUuid] = bindingByName;
        }
        bindingByName[trackName] = binding;
        binding._cacheIndex = bindings.length;
        bindings.push(binding);
    }
    _removeInactiveBinding(binding) {
        const bindings = this._bindings, propBinding = binding.binding, rootUuid = propBinding.rootNode.uuid, trackName = propBinding.path, bindingsByRoot = this._bindingsByRootAndName, bindingByName = bindingsByRoot[rootUuid], lastInactiveBinding = bindings[bindings.length - 1], cacheIndex = binding._cacheIndex;
        lastInactiveBinding._cacheIndex = cacheIndex;
        bindings[cacheIndex] = lastInactiveBinding;
        bindings.pop();
        delete bindingByName[trackName];
        if (Object.keys(bindingByName).length === 0) delete bindingsByRoot[rootUuid];
    }
    _lendBinding(binding) {
        const bindings = this._bindings, prevIndex = binding._cacheIndex, lastActiveIndex = this._nActiveBindings++, firstInactiveBinding = bindings[lastActiveIndex];
        binding._cacheIndex = lastActiveIndex;
        bindings[lastActiveIndex] = binding;
        firstInactiveBinding._cacheIndex = prevIndex;
        bindings[prevIndex] = firstInactiveBinding;
    }
    _takeBackBinding(binding) {
        const bindings = this._bindings, prevIndex = binding._cacheIndex, firstInactiveIndex = --this._nActiveBindings, lastActiveBinding = bindings[firstInactiveIndex];
        binding._cacheIndex = firstInactiveIndex;
        bindings[firstInactiveIndex] = binding;
        lastActiveBinding._cacheIndex = prevIndex;
        bindings[prevIndex] = lastActiveBinding;
    }
    // Memory management of Interpolants for weight and time scale
    _lendControlInterpolant() {
        const interpolants = this._controlInterpolants, lastActiveIndex = this._nActiveControlInterpolants++;
        let interpolant = interpolants[lastActiveIndex];
        if (interpolant === undefined) {
            interpolant = new $9ddd7e9b53f7a2d4$export$a8e6009059f51e1a(new Float32Array(2), new Float32Array(2), 1, $9ddd7e9b53f7a2d4$var$_controlInterpolantsResultBuffer);
            interpolant.__cacheIndex = lastActiveIndex;
            interpolants[lastActiveIndex] = interpolant;
        }
        return interpolant;
    }
    _takeBackControlInterpolant(interpolant) {
        const interpolants = this._controlInterpolants, prevIndex = interpolant.__cacheIndex, firstInactiveIndex = --this._nActiveControlInterpolants, lastActiveInterpolant = interpolants[firstInactiveIndex];
        interpolant.__cacheIndex = firstInactiveIndex;
        interpolants[firstInactiveIndex] = interpolant;
        lastActiveInterpolant.__cacheIndex = prevIndex;
        interpolants[prevIndex] = lastActiveInterpolant;
    }
    /**
	 * Returns an instance of {@link AnimationAction} for the passed clip.
	 *
	 * If an action fitting the clip and root parameters doesn't yet exist, it
	 * will be created by this method. Calling this method several times with the
	 * same clip and root parameters always returns the same action.
	 *
	 * @param {AnimationClip|string} clip - An animation clip or alternatively the name of the animation clip.
	 * @param {Object3D} [optionalRoot] - An alternative root object.
	 * @param {(NormalAnimationBlendMode|AdditiveAnimationBlendMode)} [blendMode] - The blend mode.
	 * @return {?AnimationAction} The animation action.
	 */ clipAction(clip, optionalRoot, blendMode) {
        const root = optionalRoot || this._root, rootUuid = root.uuid;
        let clipObject = typeof clip === 'string' ? $9ddd7e9b53f7a2d4$export$d942c706bf23829c.findByName(root, clip) : clip;
        const clipUuid = clipObject !== null ? clipObject.uuid : clip;
        const actionsForClip = this._actionsByClip[clipUuid];
        let prototypeAction = null;
        if (blendMode === undefined) {
            if (clipObject !== null) blendMode = clipObject.blendMode;
            else blendMode = $9ddd7e9b53f7a2d4$export$bcfbbdcf8de7f8cd;
        }
        if (actionsForClip !== undefined) {
            const existingAction = actionsForClip.actionByRoot[rootUuid];
            if (existingAction !== undefined && existingAction.blendMode === blendMode) return existingAction;
            // we know the clip, so we don't have to parse all
            // the bindings again but can just copy
            prototypeAction = actionsForClip.knownActions[0];
            // also, take the clip from the prototype action
            if (clipObject === null) clipObject = prototypeAction._clip;
        }
        // clip must be known when specified via string
        if (clipObject === null) return null;
        // allocate all resources required to run it
        const newAction = new $9ddd7e9b53f7a2d4$export$6946940a69e799e(this, clipObject, optionalRoot, blendMode);
        this._bindAction(newAction, prototypeAction);
        // and make the action known to the memory manager
        this._addInactiveAction(newAction, clipUuid, rootUuid);
        return newAction;
    }
    /**
	 * Returns an existing animation action for the passed clip.
	 *
	 * @param {AnimationClip|string} clip - An animation clip or alternatively the name of the animation clip.
	 * @param {Object3D} [optionalRoot] - An alternative root object.
	 * @return {?AnimationAction} The animation action. Returns `null` if no action was found.
	 */ existingAction(clip, optionalRoot) {
        const root = optionalRoot || this._root, rootUuid = root.uuid, clipObject = typeof clip === 'string' ? $9ddd7e9b53f7a2d4$export$d942c706bf23829c.findByName(root, clip) : clip, clipUuid = clipObject ? clipObject.uuid : clip, actionsForClip = this._actionsByClip[clipUuid];
        if (actionsForClip !== undefined) return actionsForClip.actionByRoot[rootUuid] || null;
        return null;
    }
    /**
	 * Deactivates all previously scheduled actions on this mixer.
	 *
	 * @return {AnimationMixer} A reference to thi animation mixer.
	 */ stopAllAction() {
        const actions = this._actions, nActions = this._nActiveActions;
        for(let i = nActions - 1; i >= 0; --i)actions[i].stop();
        return this;
    }
    /**
	 * Advances the global mixer time and updates the animation.
	 *
	 * This is usually done in the render loop by passing the delta
	 * time from {@link Clock} or {@link Timer}.
	 *
	 * @param {number} deltaTime - The delta time in seconds.
	 * @return {AnimationMixer} A reference to thi animation mixer.
	 */ update(deltaTime) {
        deltaTime *= this.timeScale;
        const actions = this._actions, nActions = this._nActiveActions, time = this.time += deltaTime, timeDirection = Math.sign(deltaTime), accuIndex = this._accuIndex ^= 1;
        // run active actions
        for(let i = 0; i !== nActions; ++i){
            const action = actions[i];
            action._update(time, deltaTime, timeDirection, accuIndex);
        }
        // update scene graph
        const bindings = this._bindings, nBindings = this._nActiveBindings;
        for(let i = 0; i !== nBindings; ++i)bindings[i].apply(accuIndex);
        return this;
    }
    /**
	 * Sets the global mixer to a specific time and updates the animation accordingly.
	 *
	 * This is useful when you need to jump to an exact time in an animation. The
	 * input parameter will be scaled by {@link AnimationMixer#timeScale}
	 *
	 * @param {number} time - The time to set in seconds.
	 * @return {AnimationMixer} A reference to thi animation mixer.
	 */ setTime(time) {
        this.time = 0; // Zero out time attribute for AnimationMixer object;
        for(let i = 0; i < this._actions.length; i++)this._actions[i].time = 0; // Zero out time attribute for all associated AnimationAction objects.
        return this.update(time); // Update used to set exact time. Returns "this" AnimationMixer object.
    }
    /**
	 * Returns this mixer's root object.
	 *
	 * @return {Object3D} The mixer's root object.
	 */ getRoot() {
        return this._root;
    }
    /**
	 * Deallocates all memory resources for a clip. Before using this method make
	 * sure to call {@link AnimationAction#stop} for all related actions.
	 *
	 * @param {AnimationClip} clip - The clip to uncache.
	 */ uncacheClip(clip) {
        const actions = this._actions, clipUuid = clip.uuid, actionsByClip = this._actionsByClip, actionsForClip = actionsByClip[clipUuid];
        if (actionsForClip !== undefined) {
            // note: just calling _removeInactiveAction would mess up the
            // iteration state and also require updating the state we can
            // just throw away
            const actionsToRemove = actionsForClip.knownActions;
            for(let i = 0, n = actionsToRemove.length; i !== n; ++i){
                const action = actionsToRemove[i];
                this._deactivateAction(action);
                const cacheIndex = action._cacheIndex, lastInactiveAction = actions[actions.length - 1];
                action._cacheIndex = null;
                action._byClipCacheIndex = null;
                lastInactiveAction._cacheIndex = cacheIndex;
                actions[cacheIndex] = lastInactiveAction;
                actions.pop();
                this._removeInactiveBindingsForAction(action);
            }
            delete actionsByClip[clipUuid];
        }
    }
    /**
	 * Deallocates all memory resources for a root object. Before using this
	 * method make sure to call {@link AnimationAction#stop} for all related
	 * actions or alternatively {@link AnimationMixer#stopAllAction} when the
	 * mixer operates on a single root.
	 *
	 * @param {Object3D} root - The root object to uncache.
	 */ uncacheRoot(root) {
        const rootUuid = root.uuid, actionsByClip = this._actionsByClip;
        for(const clipUuid in actionsByClip){
            const actionByRoot = actionsByClip[clipUuid].actionByRoot, action = actionByRoot[rootUuid];
            if (action !== undefined) {
                this._deactivateAction(action);
                this._removeInactiveAction(action);
            }
        }
        const bindingsByRoot = this._bindingsByRootAndName, bindingByName = bindingsByRoot[rootUuid];
        if (bindingByName !== undefined) for(const trackName in bindingByName){
            const binding = bindingByName[trackName];
            binding.restoreOriginalState();
            this._removeInactiveBinding(binding);
        }
    }
    /**
	 * Deallocates all memory resources for an action. The action is identified by the
	 * given clip and an optional root object. Before using this method make
	 * sure to call {@link AnimationAction#stop} to deactivate the action.
	 *
	 * @param {AnimationClip|string} clip - An animation clip or alternatively the name of the animation clip.
	 * @param {Object3D} [optionalRoot] - An alternative root object.
	 */ uncacheAction(clip, optionalRoot) {
        const action = this.existingAction(clip, optionalRoot);
        if (action !== null) {
            this._deactivateAction(action);
            this._removeInactiveAction(action);
        }
    }
}
/**
 * Represents a 3D render target.
 *
 * @augments RenderTarget
 */ class $9ddd7e9b53f7a2d4$export$6b116d2fdfef087c extends $9ddd7e9b53f7a2d4$export$efcb1f8bf367cbfb {
    /**
	 * Constructs a new 3D render target.
	 *
	 * @param {number} [width=1] - The width of the render target.
	 * @param {number} [height=1] - The height of the render target.
	 * @param {number} [depth=1] - The height of the render target.
	 * @param {RenderTarget~Options} [options] - The configuration object.
	 */ constructor(width = 1, height = 1, depth = 1, options = {}){
        super(width, height, options);
        /**
		 * This flag can be used for type testing.
		 *
		 * @type {boolean}
		 * @readonly
		 * @default true
		 */ this.isRenderTarget3D = true;
        this.depth = depth;
        /**
		 * Overwritten with a different texture type.
		 *
		 * @type {Data3DTexture}
		 */ this.texture = new $9ddd7e9b53f7a2d4$export$d7a3086320f856db(null, width, height, depth);
        this.texture.isRenderTargetTexture = true;
    }
}
/**
 * Represents an array render target.
 *
 * @augments RenderTarget
 */ class $9ddd7e9b53f7a2d4$export$eb4d196341728d65 extends $9ddd7e9b53f7a2d4$export$efcb1f8bf367cbfb {
    /**
	 * Constructs a new 3D render target.
	 *
	 * @param {number} [width=1] - The width of the render target.
	 * @param {number} [height=1] - The height of the render target.
	 * @param {number} [depth=1] - The height of the render target.
	 * @param {RenderTarget~Options} [options] - The configuration object.
	 */ constructor(width = 1, height = 1, depth = 1, options = {}){
        super(width, height, options);
        this.isRenderTargetArray = true;
        this.depth = depth;
        /**
		 * Overwritten with a different texture type.
		 *
		 * @type {DataArrayTexture}
		 */ this.texture = new $9ddd7e9b53f7a2d4$export$dfac6c8e811406a3(null, width, height, depth);
        this.texture.isRenderTargetTexture = true;
    }
}
/**
 * Represents a uniform which is a global shader variable. They are passed to shader programs.
 *
 * When declaring a uniform of a {@link ShaderMaterial}, it is declared by value or by object.
 * ```js
 * uniforms: {
 * 	time: { value: 1.0 },
 * 	resolution: new Uniform( new Vector2() )
 * };
 * ```
 * Since this class can only be used in context of {@link ShaderMaterial}, it is only supported
 * in {@link WebGLRenderer}.
 */ class $9ddd7e9b53f7a2d4$export$2947cebfe91c02f8 {
    /**
	 * Constructs a new uniform.
	 *
	 * @param {any} value - The uniform value.
	 */ constructor(value){
        /**
		 * The uniform value.
		 *
		 * @type {any}
		 */ this.value = value;
    }
    /**
	 * Returns a new uniform with copied values from this instance.
	 * If the value has a `clone()` method, the value is cloned as well.
	 *
	 * @return {Uniform} A clone of this instance.
	 */ clone() {
        return new $9ddd7e9b53f7a2d4$export$2947cebfe91c02f8(this.value.clone === undefined ? this.value : this.value.clone());
    }
}
let $9ddd7e9b53f7a2d4$var$_id = 0;
/**
 * A class for managing multiple uniforms in a single group. The renderer will process
 * such a definition as a single UBO.
 *
 * Since this class can only be used in context of {@link ShaderMaterial}, it is only supported
 * in {@link WebGLRenderer}.
 *
 * @augments EventDispatcher
 */ class $9ddd7e9b53f7a2d4$export$c412d5ffe1f79209 extends $9ddd7e9b53f7a2d4$export$ec8b666c5fe2c75a {
    /**
	 * Constructs a new uniforms group.
	 */ constructor(){
        super();
        /**
		 * This flag can be used for type testing.
		 *
		 * @type {boolean}
		 * @readonly
		 * @default true
		 */ this.isUniformsGroup = true;
        /**
		 * The ID of the 3D object.
		 *
		 * @name UniformsGroup#id
		 * @type {number}
		 * @readonly
		 */ Object.defineProperty(this, 'id', {
            value: $9ddd7e9b53f7a2d4$var$_id++
        });
        /**
		 * The name of the uniforms group.
		 *
		 * @type {string}
		 */ this.name = '';
        /**
		 * The buffer usage.
		 *
		 * @type {(StaticDrawUsage|DynamicDrawUsage|StreamDrawUsage|StaticReadUsage|DynamicReadUsage|StreamReadUsage|StaticCopyUsage|DynamicCopyUsage|StreamCopyUsage)}
		 * @default StaticDrawUsage
		 */ this.usage = $9ddd7e9b53f7a2d4$export$763e8360f4d7f77d;
        /**
		 * An array holding the uniforms.
		 *
		 * @type {Array<Uniform>}
		 */ this.uniforms = [];
    }
    /**
	 * Adds the given uniform to this uniforms group.
	 *
	 * @param {Uniform} uniform - The uniform to add.
	 * @return {UniformsGroup} A reference to this uniforms group.
	 */ add(uniform) {
        this.uniforms.push(uniform);
        return this;
    }
    /**
	 * Removes the given uniform from this uniforms group.
	 *
	 * @param {Uniform} uniform - The uniform to remove.
	 * @return {UniformsGroup} A reference to this uniforms group.
	 */ remove(uniform) {
        const index = this.uniforms.indexOf(uniform);
        if (index !== -1) this.uniforms.splice(index, 1);
        return this;
    }
    /**
	 * Sets the name of this uniforms group.
	 *
	 * @param {string} name - The name to set.
	 * @return {UniformsGroup} A reference to this uniforms group.
	 */ setName(name) {
        this.name = name;
        return this;
    }
    /**
	 * Sets the usage of this uniforms group.
	 *
	 * @param {(StaticDrawUsage|DynamicDrawUsage|StreamDrawUsage|StaticReadUsage|DynamicReadUsage|StreamReadUsage|StaticCopyUsage|DynamicCopyUsage|StreamCopyUsage)} value - The usage to set.
	 * @return {UniformsGroup} A reference to this uniforms group.
	 */ setUsage(value) {
        this.usage = value;
        return this;
    }
    /**
	 * Frees the GPU-related resources allocated by this instance. Call this
	 * method whenever this instance is no longer used in your app.
	 *
	 * @fires Texture#dispose
	 */ dispose() {
        this.dispatchEvent({
            type: 'dispose'
        });
    }
    /**
	 * Copies the values of the given uniforms group to this instance.
	 *
	 * @param {UniformsGroup} source - The uniforms group to copy.
	 * @return {UniformsGroup} A reference to this uniforms group.
	 */ copy(source) {
        this.name = source.name;
        this.usage = source.usage;
        const uniformsSource = source.uniforms;
        this.uniforms.length = 0;
        for(let i = 0, l = uniformsSource.length; i < l; i++){
            const uniforms = Array.isArray(uniformsSource[i]) ? uniformsSource[i] : [
                uniformsSource[i]
            ];
            for(let j = 0; j < uniforms.length; j++)this.uniforms.push(uniforms[j].clone());
        }
        return this;
    }
    /**
	 * Returns a new uniforms group with copied values from this instance.
	 *
	 * @return {UniformsGroup} A clone of this instance.
	 */ clone() {
        return new this.constructor().copy(this);
    }
}
/**
 * An instanced version of an interleaved buffer.
 *
 * @augments InterleavedBuffer
 */ class $9ddd7e9b53f7a2d4$export$25ec0e1af1389358 extends $9ddd7e9b53f7a2d4$export$3d5cd879f108f53f {
    /**
	 * Constructs a new instanced interleaved buffer.
	 *
	 * @param {TypedArray} array - A typed array with a shared buffer storing attribute data.
	 * @param {number} stride - The number of typed-array elements per vertex.
	 * @param {number} [meshPerAttribute=1] - Defines how often a value of this interleaved buffer should be repeated.
	 */ constructor(array, stride, meshPerAttribute = 1){
        super(array, stride);
        /**
		 * This flag can be used for type testing.
		 *
		 * @type {boolean}
		 * @readonly
		 * @default true
		 */ this.isInstancedInterleavedBuffer = true;
        /**
		 * Defines how often a value of this buffer attribute should be repeated,
		 * see {@link InstancedBufferAttribute#meshPerAttribute}.
		 *
		 * @type {number}
		 * @default 1
		 */ this.meshPerAttribute = meshPerAttribute;
    }
    copy(source) {
        super.copy(source);
        this.meshPerAttribute = source.meshPerAttribute;
        return this;
    }
    clone(data) {
        const ib = super.clone(data);
        ib.meshPerAttribute = this.meshPerAttribute;
        return ib;
    }
    toJSON(data) {
        const json = super.toJSON(data);
        json.isInstancedInterleavedBuffer = true;
        json.meshPerAttribute = this.meshPerAttribute;
        return json;
    }
}
/**
 * An alternative version of a buffer attribute with more control over the VBO.
 *
 * The renderer does not construct a VBO for this kind of attribute. Instead, it uses
 * whatever VBO is passed in constructor and can later be altered via the `buffer` property.
 *
 * The most common use case for this class is when some kind of GPGPU calculation interferes
 * or even produces the VBOs in question.
 *
 * Notice that this class can only be used with {@link WebGLRenderer}.
 */ class $9ddd7e9b53f7a2d4$export$6b7339ae8dbddf73 {
    /**
	 * Constructs a new GL buffer attribute.
	 *
	 * @param {WebGLBuffer} buffer - The native WebGL buffer.
	 * @param {number} type - The native data type (e.g. `gl.FLOAT`).
	 * @param {number} itemSize - The item size.
	 * @param {number} elementSize - The corresponding size (in bytes) for the given `type` parameter.
	 * @param {number} count - The expected number of vertices in VBO.
	 */ constructor(buffer, type, itemSize, elementSize, count){
        /**
		 * This flag can be used for type testing.
		 *
		 * @type {boolean}
		 * @readonly
		 * @default true
		 */ this.isGLBufferAttribute = true;
        /**
		 * The name of the buffer attribute.
		 *
		 * @type {string}
		 */ this.name = '';
        /**
		 * The native WebGL buffer.
		 *
		 * @type {WebGLBuffer}
		 */ this.buffer = buffer;
        /**
		 * The native data type.
		 *
		 * @type {number}
		 */ this.type = type;
        /**
		 * The item size, see {@link BufferAttribute#itemSize}.
		 *
		 * @type {number}
		 */ this.itemSize = itemSize;
        /**
		 * The corresponding size (in bytes) for the given `type` parameter.
		 *
		 * @type {number}
		 */ this.elementSize = elementSize;
        /**
		 * The expected number of vertices in VBO.
		 *
		 * @type {number}
		 */ this.count = count;
        /**
		 * A version number, incremented every time the `needsUpdate` is set to `true`.
		 *
		 * @type {number}
		 */ this.version = 0;
    }
    /**
	 * Flag to indicate that this attribute has changed and should be re-sent to
	 * the GPU. Set this to `true` when you modify the value of the array.
	 *
	 * @type {number}
	 * @default false
	 * @param {boolean} value
	 */ set needsUpdate(value) {
        if (value === true) this.version++;
    }
    /**
	 * Sets the given native WebGL buffer.
	 *
	 * @param {WebGLBuffer} buffer - The buffer to set.
	 * @return {BufferAttribute} A reference to this instance.
	 */ setBuffer(buffer) {
        this.buffer = buffer;
        return this;
    }
    /**
	 * Sets the given native data type and element size.
	 *
	 * @param {number} type - The native data type (e.g. `gl.FLOAT`).
	 * @param {number} elementSize - The corresponding size (in bytes) for the given `type` parameter.
	 * @return {BufferAttribute} A reference to this instance.
	 */ setType(type, elementSize) {
        this.type = type;
        this.elementSize = elementSize;
        return this;
    }
    /**
	 * Sets the item size.
	 *
	 * @param {number} itemSize - The item size.
	 * @return {BufferAttribute} A reference to this instance.
	 */ setItemSize(itemSize) {
        this.itemSize = itemSize;
        return this;
    }
    /**
	 * Sets the count (the expected number of vertices in VBO).
	 *
	 * @param {number} count - The count.
	 * @return {BufferAttribute} A reference to this instance.
	 */ setCount(count) {
        this.count = count;
        return this;
    }
}
const $9ddd7e9b53f7a2d4$var$_matrix = /*@__PURE__*/ new $9ddd7e9b53f7a2d4$export$2ae72fc923e5eb5();
/**
 * This class is designed to assist with raycasting. Raycasting is used for
 * mouse picking (working out what objects in the 3d space the mouse is over)
 * amongst other things.
 */ class $9ddd7e9b53f7a2d4$export$8b7aaceff00bd2f {
    /**
	 * Constructs a new raycaster.
	 *
	 * @param {Vector3} origin - The origin vector where the ray casts from.
	 * @param {Vector3} direction - The (normalized) direction vector that gives direction to the ray.
	 * @param {number} [near=0] - All results returned are further away than near. Near can't be negative.
	 * @param {number} [far=Infinity] - All results returned are closer than far. Far can't be lower than near.
	 */ constructor(origin, direction, near = 0, far = Infinity){
        /**
		 * The ray used for raycasting.
		 *
		 * @type {Ray}
		 */ this.ray = new $9ddd7e9b53f7a2d4$export$a186db52eed6d40e(origin, direction);
        /**
		 * All results returned are further away than near. Near can't be negative.
		 *
		 * @type {number}
		 * @default 0
		 */ this.near = near;
        /**
		 * All results returned are further away than near. Near can't be negative.
		 *
		 * @type {number}
		 * @default Infinity
		 */ this.far = far;
        /**
		 * The camera to use when raycasting against view-dependent objects such as
		 * billboarded objects like sprites. This field can be set manually or
		 * is set when calling `setFromCamera()`.
		 *
		 * @type {?Camera}
		 * @default null
		 */ this.camera = null;
        /**
		 * Allows to selectively ignore 3D objects when performing intersection tests.
		 * The following code example ensures that only 3D objects on layer `1` will be
		 * honored by raycaster.
		 * ```js
		 * raycaster.layers.set( 1 );
		 * object.layers.enable( 1 );
		 * ```
		 *
		 * @type {Layers}
		 */ this.layers = new $9ddd7e9b53f7a2d4$export$89312ce47c0ca777();
        /**
		 * A parameter object that configures the raycasting. It has the structure:
		 *
		 * ```
		 * {
		 * 	Mesh: {},
		 * 	Line: { threshold: 1 },
		 * 	LOD: {},
		 * 	Points: { threshold: 1 },
		 * 	Sprite: {}
		 * }
		 * ```
		 * Where `threshold` is the precision of the raycaster when intersecting objects, in world units.
		 *
		 * @type {Object}
		 */ this.params = {
            Mesh: {},
            Line: {
                threshold: 1
            },
            LOD: {},
            Points: {
                threshold: 1
            },
            Sprite: {}
        };
    }
    /**
	 * Updates the ray with a new origin and direction by copying the values from the arguments.
	 *
	 * @param {Vector3} origin - The origin vector where the ray casts from.
	 * @param {Vector3} direction - The (normalized) direction vector that gives direction to the ray.
	 */ set(origin, direction) {
        // direction is assumed to be normalized (for accurate distance calculations)
        this.ray.set(origin, direction);
    }
    /**
	 * Uses the given coordinates and camera to compute a new origin and direction for the internal ray.
	 *
	 * @param {Vector2} coords - 2D coordinates of the mouse, in normalized device coordinates (NDC).
	 * X and Y components should be between `-1` and `1`.
	 * @param {Camera} camera - The camera from which the ray should originate.
	 */ setFromCamera(coords, camera) {
        if (camera.isPerspectiveCamera) {
            this.ray.origin.setFromMatrixPosition(camera.matrixWorld);
            this.ray.direction.set(coords.x, coords.y, 0.5).unproject(camera).sub(this.ray.origin).normalize();
            this.camera = camera;
        } else if (camera.isOrthographicCamera) {
            this.ray.origin.set(coords.x, coords.y, (camera.near + camera.far) / (camera.near - camera.far)).unproject(camera); // set origin in plane of camera
            this.ray.direction.set(0, 0, -1).transformDirection(camera.matrixWorld);
            this.camera = camera;
        } else console.error('THREE.Raycaster: Unsupported camera type: ' + camera.type);
    }
    /**
	 * Uses the given WebXR controller to compute a new origin and direction for the internal ray.
	 *
	 * @param {WebXRController} controller - The controller to copy the position and direction from.
	 * @return {Raycaster} A reference to this raycaster.
	 */ setFromXRController(controller) {
        $9ddd7e9b53f7a2d4$var$_matrix.identity().extractRotation(controller.matrixWorld);
        this.ray.origin.setFromMatrixPosition(controller.matrixWorld);
        this.ray.direction.set(0, 0, -1).applyMatrix4($9ddd7e9b53f7a2d4$var$_matrix);
        return this;
    }
    /**
	 * The intersection point of a raycaster intersection test.
	 * @typedef {Object} Raycaster~Intersection
	 * @property {number} distance - The distance from the ray's origin to the intersection point.
	 * @property {number} distanceToRay -  Some 3D objects e.g. {@link Points} provide the distance of the
	 * intersection to the nearest point on the ray. For other objects it will be `undefined`.
	 * @property {Vector3} point - The intersection point, in world coordinates.
	 * @property {Object} face - The face that has been intersected.
	 * @property {number} faceIndex - The face index.
	 * @property {Object3D} object - The 3D object that has been intersected.
	 * @property {Vector2} uv - U,V coordinates at point of intersection.
	 * @property {Vector2} uv1 - Second set of U,V coordinates at point of intersection.
	 * @property {Vector3} uv1 - Interpolated normal vector at point of intersection.
	 * @property {number} instanceId - The index number of the instance where the ray
	 * intersects the {@link InstancedMesh}.
	 */ /**
	 * Checks all intersection between the ray and the object with or without the
	 * descendants. Intersections are returned sorted by distance, closest first.
	 *
	 * `Raycaster` delegates to the `raycast()` method of the passed 3D object, when
	 * evaluating whether the ray intersects the object or not. This allows meshes to respond
	 * differently to ray casting than lines or points.
	 *
	 * Note that for meshes, faces must be pointed towards the origin of the ray in order
	 * to be detected; intersections of the ray passing through the back of a face will not
	 * be detected. To raycast against both faces of an object, you'll want to set  {@link Material#side}
	 * to `THREE.DoubleSide`.
	 *
	 * @param {Object3D} object - The 3D object to check for intersection with the ray.
	 * @param {boolean} [recursive=true] - If set to `true`, it also checks all descendants.
	 * Otherwise it only checks intersection with the object.
	 * @param {Array<Raycaster~Intersection>} [intersects=[]] The target array that holds the result of the method.
	 * @return {Array<Raycaster~Intersection>} An array holding the intersection points.
	 */ intersectObject(object, recursive = true, intersects = []) {
        $9ddd7e9b53f7a2d4$var$intersect(object, this, intersects, recursive);
        intersects.sort($9ddd7e9b53f7a2d4$var$ascSort);
        return intersects;
    }
    /**
	 * Checks all intersection between the ray and the objects with or without
	 * the descendants. Intersections are returned sorted by distance, closest first.
	 *
	 * @param {Array<Object3D>} objects - The 3D objects to check for intersection with the ray.
	 * @param {boolean} [recursive=true] - If set to `true`, it also checks all descendants.
	 * Otherwise it only checks intersection with the object.
	 * @param {Array<Raycaster~Intersection>} [intersects=[]] The target array that holds the result of the method.
	 * @return {Array<Raycaster~Intersection>} An array holding the intersection points.
	 */ intersectObjects(objects, recursive = true, intersects = []) {
        for(let i = 0, l = objects.length; i < l; i++)$9ddd7e9b53f7a2d4$var$intersect(objects[i], this, intersects, recursive);
        intersects.sort($9ddd7e9b53f7a2d4$var$ascSort);
        return intersects;
    }
}
function $9ddd7e9b53f7a2d4$var$ascSort(a, b) {
    return a.distance - b.distance;
}
function $9ddd7e9b53f7a2d4$var$intersect(object, raycaster, intersects, recursive) {
    let propagate = true;
    if (object.layers.test(raycaster.layers)) {
        const result = object.raycast(raycaster, intersects);
        if (result === false) propagate = false;
    }
    if (propagate === true && recursive === true) {
        const children = object.children;
        for(let i = 0, l = children.length; i < l; i++)$9ddd7e9b53f7a2d4$var$intersect(children[i], raycaster, intersects, true);
    }
}
/**
 * This class can be used to represent points in 3D space as
 * [Spherical coordinates]{@link https://en.wikipedia.org/wiki/Spherical_coordinate_system}.
 */ class $9ddd7e9b53f7a2d4$export$d712cd887b4a00f7 {
    /**
	 * Constructs a new spherical.
	 *
	 * @param {number} [radius=1] - The radius, or the Euclidean distance (straight-line distance) from the point to the origin.
	 * @param {number} [phi=0] - The polar angle in radians from the y (up) axis.
	 * @param {number} [theta=0] - The equator/azimuthal angle in radians around the y (up) axis.
	 */ constructor(radius = 1, phi = 0, theta = 0){
        /**
		 * The radius, or the Euclidean distance (straight-line distance) from the point to the origin.
		 *
		 * @type {number}
		 * @default 1
		 */ this.radius = radius;
        /**
		 * The polar angle in radians from the y (up) axis.
		 *
		 * @type {number}
		 * @default 0
		 */ this.phi = phi;
        /**
		 * The equator/azimuthal angle in radians around the y (up) axis.
		 *
		 * @type {number}
		 * @default 0
		 */ this.theta = theta;
    }
    /**
	 * Sets the spherical components by copying the given values.
	 *
	 * @param {number} radius - The radius.
	 * @param {number} phi - The polar angle.
	 * @param {number} theta - The azimuthal angle.
	 * @return {Spherical} A reference to this spherical.
	 */ set(radius, phi, theta) {
        this.radius = radius;
        this.phi = phi;
        this.theta = theta;
        return this;
    }
    /**
	 * Copies the values of the given spherical to this instance.
	 *
	 * @param {Spherical} other - The spherical to copy.
	 * @return {Spherical} A reference to this spherical.
	 */ copy(other) {
        this.radius = other.radius;
        this.phi = other.phi;
        this.theta = other.theta;
        return this;
    }
    /**
	 * Restricts the polar angle [page:.phi phi] to be between `0.000001` and pi -
	 * `0.000001`.
	 *
	 * @return {Spherical} A reference to this spherical.
	 */ makeSafe() {
        const EPS = 0.000001;
        this.phi = $9ddd7e9b53f7a2d4$var$clamp(this.phi, EPS, Math.PI - EPS);
        return this;
    }
    /**
	 * Sets the spherical components from the given vector which is assumed to hold
	 * Cartesian coordinates.
	 *
	 * @param {Vector3} v - The vector to set.
	 * @return {Spherical} A reference to this spherical.
	 */ setFromVector3(v) {
        return this.setFromCartesianCoords(v.x, v.y, v.z);
    }
    /**
	 * Sets the spherical components from the given Cartesian coordinates.
	 *
	 * @param {number} x - The x value.
	 * @param {number} y - The x value.
	 * @param {number} z - The x value.
	 * @return {Spherical} A reference to this spherical.
	 */ setFromCartesianCoords(x, y, z) {
        this.radius = Math.sqrt(x * x + y * y + z * z);
        if (this.radius === 0) {
            this.theta = 0;
            this.phi = 0;
        } else {
            this.theta = Math.atan2(x, z);
            this.phi = Math.acos($9ddd7e9b53f7a2d4$var$clamp(y / this.radius, -1, 1));
        }
        return this;
    }
    /**
	 * Returns a new spherical with copied values from this instance.
	 *
	 * @return {Spherical} A clone of this instance.
	 */ clone() {
        return new this.constructor().copy(this);
    }
}
/**
 * This class can be used to represent points in 3D space as
 * [Cylindrical coordinates]{@link https://en.wikipedia.org/wiki/Cylindrical_coordinate_system}.
 */ class $9ddd7e9b53f7a2d4$export$287165bb2177f4fd {
    /**
	 * Constructs a new cylindrical.
	 *
	 * @param {number} [radius=1] - The distance from the origin to a point in the x-z plane.
	 * @param {number} [theta=0] - A counterclockwise angle in the x-z plane measured in radians from the positive z-axis.
	 * @param {number} [y=0] - The height above the x-z plane.
	 */ constructor(radius = 1, theta = 0, y = 0){
        /**
		 * The distance from the origin to a point in the x-z plane.
		 *
		 * @type {number}
		 * @default 1
		 */ this.radius = radius;
        /**
		 * A counterclockwise angle in the x-z plane measured in radians from the positive z-axis.
		 *
		 * @type {number}
		 * @default 0
		 */ this.theta = theta;
        /**
		 * The height above the x-z plane.
		 *
		 * @type {number}
		 * @default 0
		 */ this.y = y;
    }
    /**
	 * Sets the cylindrical components by copying the given values.
	 *
	 * @param {number} radius - The radius.
	 * @param {number} theta - The theta angle.
	 * @param {number} y - The height value.
	 * @return {Cylindrical} A reference to this cylindrical.
	 */ set(radius, theta, y) {
        this.radius = radius;
        this.theta = theta;
        this.y = y;
        return this;
    }
    /**
	 * Copies the values of the given cylindrical to this instance.
	 *
	 * @param {Cylindrical} other - The cylindrical to copy.
	 * @return {Cylindrical} A reference to this cylindrical.
	 */ copy(other) {
        this.radius = other.radius;
        this.theta = other.theta;
        this.y = other.y;
        return this;
    }
    /**
	 * Sets the cylindrical components from the given vector which is assumed to hold
	 * Cartesian coordinates.
	 *
	 * @param {Vector3} v - The vector to set.
	 * @return {Cylindrical} A reference to this cylindrical.
	 */ setFromVector3(v) {
        return this.setFromCartesianCoords(v.x, v.y, v.z);
    }
    /**
	 * Sets the cylindrical components from the given Cartesian coordinates.
	 *
	 * @param {number} x - The x value.
	 * @param {number} y - The x value.
	 * @param {number} z - The x value.
	 * @return {Cylindrical} A reference to this cylindrical.
	 */ setFromCartesianCoords(x, y, z) {
        this.radius = Math.sqrt(x * x + z * z);
        this.theta = Math.atan2(x, z);
        this.y = y;
        return this;
    }
    /**
	 * Returns a new cylindrical with copied values from this instance.
	 *
	 * @return {Cylindrical} A clone of this instance.
	 */ clone() {
        return new this.constructor().copy(this);
    }
}
/**
 * Represents a 2x2 matrix.
 *
 * A Note on Row-Major and Column-Major Ordering:
 *
 * The constructor and {@link Matrix2#set} method take arguments in
 * [row-major]{@link https://en.wikipedia.org/wiki/Row-_and_column-major_order#Column-major_order}
 * order, while internally they are stored in the {@link Matrix2#elements} array in column-major order.
 * This means that calling:
 * ```js
 * const m = new THREE.Matrix2();
 * m.set( 11, 12,
 *        21, 22 );
 * ```
 * will result in the elements array containing:
 * ```js
 * m.elements = [ 11, 21,
 *                12, 22 ];
 * ```
 * and internally all calculations are performed using column-major ordering.
 * However, as the actual ordering makes no difference mathematically and
 * most people are used to thinking about matrices in row-major order, the
 * three.js documentation shows matrices in row-major order. Just bear in
 * mind that if you are reading the source code, you'll have to take the
 * transpose of any matrices outlined here to make sense of the calculations.
 */ class $9ddd7e9b53f7a2d4$export$cbcc6560bf79fb38 {
    /**
	 * Constructs a new 2x2 matrix. The arguments are supposed to be
	 * in row-major order. If no arguments are provided, the constructor
	 * initializes the matrix as an identity matrix.
	 *
	 * @param {number} [n11] - 1-1 matrix element.
	 * @param {number} [n12] - 1-2 matrix element.
	 * @param {number} [n21] - 2-1 matrix element.
	 * @param {number} [n22] - 2-2 matrix element.
	 */ constructor(n11, n12, n21, n22){
        /**
		 * This flag can be used for type testing.
		 *
		 * @type {boolean}
		 * @readonly
		 * @default true
		 */ $9ddd7e9b53f7a2d4$export$cbcc6560bf79fb38.prototype.isMatrix2 = true;
        /**
		 * A column-major list of matrix values.
		 *
		 * @type {Array<number>}
		 */ this.elements = [
            1,
            0,
            0,
            1
        ];
        if (n11 !== undefined) this.set(n11, n12, n21, n22);
    }
    /**
	 * Sets this matrix to the 2x2 identity matrix.
	 *
	 * @return {Matrix2} A reference to this matrix.
	 */ identity() {
        this.set(1, 0, 0, 1);
        return this;
    }
    /**
	 * Sets the elements of the matrix from the given array.
	 *
	 * @param {Array<number>} array - The matrix elements in column-major order.
	 * @param {number} [offset=0] - Index of the first element in the array.
	 * @return {Matrix2} A reference to this matrix.
	 */ fromArray(array, offset = 0) {
        for(let i = 0; i < 4; i++)this.elements[i] = array[i + offset];
        return this;
    }
    /**
	 * Sets the elements of the matrix.The arguments are supposed to be
	 * in row-major order.
	 *
	 * @param {number} n11 - 1-1 matrix element.
	 * @param {number} n12 - 1-2 matrix element.
	 * @param {number} n21 - 2-1 matrix element.
	 * @param {number} n22 - 2-2 matrix element.
	 * @return {Matrix2} A reference to this matrix.
	 */ set(n11, n12, n21, n22) {
        const te = this.elements;
        te[0] = n11;
        te[2] = n12;
        te[1] = n21;
        te[3] = n22;
        return this;
    }
}
const $9ddd7e9b53f7a2d4$var$_vector$4 = /*@__PURE__*/ new $9ddd7e9b53f7a2d4$export$c977b3e384af9ae1();
/**
 * Represents an axis-aligned bounding box (AABB) in 2D space.
 */ class $9ddd7e9b53f7a2d4$export$60f553fa130f08b0 {
    /**
	 * Constructs a new bounding box.
	 *
	 * @param {Vector2} [min=(Infinity,Infinity)] - A vector representing the lower boundary of the box.
	 * @param {Vector2} [max=(-Infinity,-Infinity)] - A vector representing the upper boundary of the box.
	 */ constructor(min = new $9ddd7e9b53f7a2d4$export$c977b3e384af9ae1(Infinity, Infinity), max = new $9ddd7e9b53f7a2d4$export$c977b3e384af9ae1(-Infinity, -Infinity)){
        /**
		 * This flag can be used for type testing.
		 *
		 * @type {boolean}
		 * @readonly
		 * @default true
		 */ this.isBox2 = true;
        /**
		 * The lower boundary of the box.
		 *
		 * @type {Vector2}
		 */ this.min = min;
        /**
		 * The upper boundary of the box.
		 *
		 * @type {Vector2}
		 */ this.max = max;
    }
    /**
	 * Sets the lower and upper boundaries of this box.
	 * Please note that this method only copies the values from the given objects.
	 *
	 * @param {Vector2} min - The lower boundary of the box.
	 * @param {Vector2} max - The upper boundary of the box.
	 * @return {Box2} A reference to this bounding box.
	 */ set(min, max) {
        this.min.copy(min);
        this.max.copy(max);
        return this;
    }
    /**
	 * Sets the upper and lower bounds of this box so it encloses the position data
	 * in the given array.
	 *
	 * @param {Array<Vector2>} points - An array holding 2D position data as instances of {@link Vector2}.
	 * @return {Box2} A reference to this bounding box.
	 */ setFromPoints(points) {
        this.makeEmpty();
        for(let i = 0, il = points.length; i < il; i++)this.expandByPoint(points[i]);
        return this;
    }
    /**
	 * Centers this box on the given center vector and sets this box's width, height and
	 * depth to the given size values.
	 *
	 * @param {Vector2} center - The center of the box.
	 * @param {Vector2} size - The x and y dimensions of the box.
	 * @return {Box2} A reference to this bounding box.
	 */ setFromCenterAndSize(center, size) {
        const halfSize = $9ddd7e9b53f7a2d4$var$_vector$4.copy(size).multiplyScalar(0.5);
        this.min.copy(center).sub(halfSize);
        this.max.copy(center).add(halfSize);
        return this;
    }
    /**
	 * Returns a new box with copied values from this instance.
	 *
	 * @return {Box2} A clone of this instance.
	 */ clone() {
        return new this.constructor().copy(this);
    }
    /**
	 * Copies the values of the given box to this instance.
	 *
	 * @param {Box2} box - The box to copy.
	 * @return {Box2} A reference to this bounding box.
	 */ copy(box) {
        this.min.copy(box.min);
        this.max.copy(box.max);
        return this;
    }
    /**
	 * Makes this box empty which means in encloses a zero space in 2D.
	 *
	 * @return {Box2} A reference to this bounding box.
	 */ makeEmpty() {
        this.min.x = this.min.y = Infinity;
        this.max.x = this.max.y = -Infinity;
        return this;
    }
    /**
	 * Returns true if this box includes zero points within its bounds.
	 * Note that a box with equal lower and upper bounds still includes one
	 * point, the one both bounds share.
	 *
	 * @return {boolean} Whether this box is empty or not.
	 */ isEmpty() {
        // this is a more robust check for empty than ( volume <= 0 ) because volume can get positive with two negative axes
        return this.max.x < this.min.x || this.max.y < this.min.y;
    }
    /**
	 * Returns the center point of this box.
	 *
	 * @param {Vector2} target - The target vector that is used to store the method's result.
	 * @return {Vector2} The center point.
	 */ getCenter(target) {
        return this.isEmpty() ? target.set(0, 0) : target.addVectors(this.min, this.max).multiplyScalar(0.5);
    }
    /**
	 * Returns the dimensions of this box.
	 *
	 * @param {Vector2} target - The target vector that is used to store the method's result.
	 * @return {Vector2} The size.
	 */ getSize(target) {
        return this.isEmpty() ? target.set(0, 0) : target.subVectors(this.max, this.min);
    }
    /**
	 * Expands the boundaries of this box to include the given point.
	 *
	 * @param {Vector2} point - The point that should be included by the bounding box.
	 * @return {Box2} A reference to this bounding box.
	 */ expandByPoint(point) {
        this.min.min(point);
        this.max.max(point);
        return this;
    }
    /**
	 * Expands this box equilaterally by the given vector. The width of this
	 * box will be expanded by the x component of the vector in both
	 * directions. The height of this box will be expanded by the y component of
	 * the vector in both directions.
	 *
	 * @param {Vector2} vector - The vector that should expand the bounding box.
	 * @return {Box2} A reference to this bounding box.
	 */ expandByVector(vector) {
        this.min.sub(vector);
        this.max.add(vector);
        return this;
    }
    /**
	 * Expands each dimension of the box by the given scalar. If negative, the
	 * dimensions of the box will be contracted.
	 *
	 * @param {number} scalar - The scalar value that should expand the bounding box.
	 * @return {Box2} A reference to this bounding box.
	 */ expandByScalar(scalar) {
        this.min.addScalar(-scalar);
        this.max.addScalar(scalar);
        return this;
    }
    /**
	 * Returns `true` if the given point lies within or on the boundaries of this box.
	 *
	 * @param {Vector2} point - The point to test.
	 * @return {boolean} Whether the bounding box contains the given point or not.
	 */ containsPoint(point) {
        return point.x >= this.min.x && point.x <= this.max.x && point.y >= this.min.y && point.y <= this.max.y;
    }
    /**
	 * Returns `true` if this bounding box includes the entirety of the given bounding box.
	 * If this box and the given one are identical, this function also returns `true`.
	 *
	 * @param {Box2} box - The bounding box to test.
	 * @return {boolean} Whether the bounding box contains the given bounding box or not.
	 */ containsBox(box) {
        return this.min.x <= box.min.x && box.max.x <= this.max.x && this.min.y <= box.min.y && box.max.y <= this.max.y;
    }
    /**
	 * Returns a point as a proportion of this box's width and height.
	 *
	 * @param {Vector2} point - A point in 2D space.
	 * @param {Vector2} target - The target vector that is used to store the method's result.
	 * @return {Vector2} A point as a proportion of this box's width and height.
	 */ getParameter(point, target) {
        // This can potentially have a divide by zero if the box
        // has a size dimension of 0.
        return target.set((point.x - this.min.x) / (this.max.x - this.min.x), (point.y - this.min.y) / (this.max.y - this.min.y));
    }
    /**
	 * Returns `true` if the given bounding box intersects with this bounding box.
	 *
	 * @param {Box2} box - The bounding box to test.
	 * @return {boolean} Whether the given bounding box intersects with this bounding box.
	 */ intersectsBox(box) {
        // using 4 splitting planes to rule out intersections
        return box.max.x >= this.min.x && box.min.x <= this.max.x && box.max.y >= this.min.y && box.min.y <= this.max.y;
    }
    /**
	 * Clamps the given point within the bounds of this box.
	 *
	 * @param {Vector2} point - The point to clamp.
	 * @param {Vector2} target - The target vector that is used to store the method's result.
	 * @return {Vector2} The clamped point.
	 */ clampPoint(point, target) {
        return target.copy(point).clamp(this.min, this.max);
    }
    /**
	 * Returns the euclidean distance from any edge of this box to the specified point. If
	 * the given point lies inside of this box, the distance will be `0`.
	 *
	 * @param {Vector2} point - The point to compute the distance to.
	 * @return {number} The euclidean distance.
	 */ distanceToPoint(point) {
        return this.clampPoint(point, $9ddd7e9b53f7a2d4$var$_vector$4).distanceTo(point);
    }
    /**
	 * Computes the intersection of this bounding box and the given one, setting the upper
	 * bound of this box to the lesser of the two boxes' upper bounds and the
	 * lower bound of this box to the greater of the two boxes' lower bounds. If
	 * there's no overlap, makes this box empty.
	 *
	 * @param {Box2} box - The bounding box to intersect with.
	 * @return {Box2} A reference to this bounding box.
	 */ intersect(box) {
        this.min.max(box.min);
        this.max.min(box.max);
        if (this.isEmpty()) this.makeEmpty();
        return this;
    }
    /**
	 * Computes the union of this box and another and the given one, setting the upper
	 * bound of this box to the greater of the two boxes' upper bounds and the
	 * lower bound of this box to the lesser of the two boxes' lower bounds.
	 *
	 * @param {Box2} box - The bounding box that will be unioned with this instance.
	 * @return {Box2} A reference to this bounding box.
	 */ union(box) {
        this.min.min(box.min);
        this.max.max(box.max);
        return this;
    }
    /**
	 * Adds the given offset to both the upper and lower bounds of this bounding box,
	 * effectively moving it in 2D space.
	 *
	 * @param {Vector2} offset - The offset that should be used to translate the bounding box.
	 * @return {Box2} A reference to this bounding box.
	 */ translate(offset) {
        this.min.add(offset);
        this.max.add(offset);
        return this;
    }
    /**
	 * Returns `true` if this bounding box is equal with the given one.
	 *
	 * @param {Box2} box - The box to test for equality.
	 * @return {boolean} Whether this bounding box is equal with the given one.
	 */ equals(box) {
        return box.min.equals(this.min) && box.max.equals(this.max);
    }
}
const $9ddd7e9b53f7a2d4$var$_startP = /*@__PURE__*/ new $9ddd7e9b53f7a2d4$export$64b5c384219d3699();
const $9ddd7e9b53f7a2d4$var$_startEnd = /*@__PURE__*/ new $9ddd7e9b53f7a2d4$export$64b5c384219d3699();
/**
 * An analytical line segment in 3D space represented by a start and end point.
 */ class $9ddd7e9b53f7a2d4$export$e0ba6359f1954fd3 {
    /**
	 * Constructs a new line segment.
	 *
	 * @param {Vector3} [start=(0,0,0)] - Start of the line segment.
	 * @param {Vector3} [end=(0,0,0)] - End of the line segment.
	 */ constructor(start = new $9ddd7e9b53f7a2d4$export$64b5c384219d3699(), end = new $9ddd7e9b53f7a2d4$export$64b5c384219d3699()){
        /**
		 * Start of the line segment.
		 *
		 * @type {Vector3}
		 */ this.start = start;
        /**
		 * End of the line segment.
		 *
		 * @type {Vector3}
		 */ this.end = end;
    }
    /**
	 * Sets the start and end values by copying the given vectors.
	 *
	 * @param {Vector3} start - The start point.
	 * @param {Vector3} end - The end point.
	 * @return {Line3} A reference to this line segment.
	 */ set(start, end) {
        this.start.copy(start);
        this.end.copy(end);
        return this;
    }
    /**
	 * Copies the values of the given line segment to this instance.
	 *
	 * @param {Line3} line - The line segment to copy.
	 * @return {Line3} A reference to this line segment.
	 */ copy(line) {
        this.start.copy(line.start);
        this.end.copy(line.end);
        return this;
    }
    /**
	 * Returns the center of the line segment.
	 *
	 * @param {Vector3} target - The target vector that is used to store the method's result.
	 * @return {Vector3} The center point.
	 */ getCenter(target) {
        return target.addVectors(this.start, this.end).multiplyScalar(0.5);
    }
    /**
	 * Returns the delta vector of the line segment's start and end point.
	 *
	 * @param {Vector3} target - The target vector that is used to store the method's result.
	 * @return {Vector3} The delta vector.
	 */ delta(target) {
        return target.subVectors(this.end, this.start);
    }
    /**
	 * Returns the squared Euclidean distance between the line' start and end point.
	 *
	 * @return {number} The squared Euclidean distance.
	 */ distanceSq() {
        return this.start.distanceToSquared(this.end);
    }
    /**
	 * Returns the Euclidean distance between the line' start and end point.
	 *
	 * @return {number} The Euclidean distance.
	 */ distance() {
        return this.start.distanceTo(this.end);
    }
    /**
	 * Returns a vector at a certain position along the line segment.
	 *
	 * @param {number} t - A value between `[0,1]` to represent a position along the line segment.
	 * @param {Vector3} target - The target vector that is used to store the method's result.
	 * @return {Vector3} The delta vector.
	 */ at(t, target) {
        return this.delta(target).multiplyScalar(t).add(this.start);
    }
    /**
	 * Returns a point parameter based on the closest point as projected on the line segment.
	 *
	 * @param {Vector3} point - The point for which to return a point parameter.
	 * @param {boolean} clampToLine - Whether to clamp the result to the range `[0,1]` or not.
	 * @return {number} The point parameter.
	 */ closestPointToPointParameter(point, clampToLine) {
        $9ddd7e9b53f7a2d4$var$_startP.subVectors(point, this.start);
        $9ddd7e9b53f7a2d4$var$_startEnd.subVectors(this.end, this.start);
        const startEnd2 = $9ddd7e9b53f7a2d4$var$_startEnd.dot($9ddd7e9b53f7a2d4$var$_startEnd);
        const startEnd_startP = $9ddd7e9b53f7a2d4$var$_startEnd.dot($9ddd7e9b53f7a2d4$var$_startP);
        let t = startEnd_startP / startEnd2;
        if (clampToLine) t = $9ddd7e9b53f7a2d4$var$clamp(t, 0, 1);
        return t;
    }
    /**
	 * Returns the closets point on the line for a given point.
	 *
	 * @param {Vector3} point - The point to compute the closest point on the line for.
	 * @param {boolean} clampToLine - Whether to clamp the result to the range `[0,1]` or not.
	 * @param {Vector3} target -  The target vector that is used to store the method's result.
	 * @return {Vector3} The closest point on the line.
	 */ closestPointToPoint(point, clampToLine, target) {
        const t = this.closestPointToPointParameter(point, clampToLine);
        return this.delta(target).multiplyScalar(t).add(this.start);
    }
    /**
	 * Applies a 4x4 transformation matrix to this line segment.
	 *
	 * @param {Matrix4} matrix - The transformation matrix.
	 * @return {Line3} A reference to this line segment.
	 */ applyMatrix4(matrix) {
        this.start.applyMatrix4(matrix);
        this.end.applyMatrix4(matrix);
        return this;
    }
    /**
	 * Returns `true` if this line segment is equal with the given one.
	 *
	 * @param {Line3} line - The line segment to test for equality.
	 * @return {boolean} Whether this line segment is equal with the given one.
	 */ equals(line) {
        return line.start.equals(this.start) && line.end.equals(this.end);
    }
    /**
	 * Returns a new line segment with copied values from this instance.
	 *
	 * @return {Line3} A clone of this instance.
	 */ clone() {
        return new this.constructor().copy(this);
    }
}
const $9ddd7e9b53f7a2d4$var$_vector$3 = /*@__PURE__*/ new $9ddd7e9b53f7a2d4$export$64b5c384219d3699();
/**
 * This displays a cone shaped helper object for a {@link SpotLight}.
 *
 * ```js
 * const spotLight = new THREE.SpotLight( 0xffffff );
 * spotLight.position.set( 10, 10, 10 );
 * scene.add( spotLight );
 *
 * const spotLightHelper = new THREE.SpotLightHelper( spotLight );
 * scene.add( spotLightHelper );
 * ```
 *
 * @augments Object3D
 */ class $9ddd7e9b53f7a2d4$export$4b14638ffdd81e68 extends $9ddd7e9b53f7a2d4$export$e4dd07dff30cc924 {
    /**
	 * Constructs a new spot light helper.
	 *
	 * @param {HemisphereLight} light - The light to be visualized.
	 * @param {number|Color|string} [color] - The helper's color. If not set, the helper will take
	 * the color of the light.
	 */ constructor(light, color){
        super();
        /**
		 * The light being visualized.
		 *
		 * @type {SpotLight}
		 */ this.light = light;
        this.matrixAutoUpdate = false;
        /**
		 * The color parameter passed in the constructor.
		 * If not set, the helper will take the color of the light.
		 *
		 * @type {number|Color|string}
		 */ this.color = color;
        this.type = 'SpotLightHelper';
        const geometry = new $9ddd7e9b53f7a2d4$export$b7be63a67df8959();
        const positions = [
            0,
            0,
            0,
            0,
            0,
            1,
            0,
            0,
            0,
            1,
            0,
            1,
            0,
            0,
            0,
            -1,
            0,
            1,
            0,
            0,
            0,
            0,
            1,
            1,
            0,
            0,
            0,
            0,
            -1,
            1
        ];
        for(let i = 0, j = 1, l = 32; i < l; i++, j++){
            const p1 = i / l * Math.PI * 2;
            const p2 = j / l * Math.PI * 2;
            positions.push(Math.cos(p1), Math.sin(p1), 1, Math.cos(p2), Math.sin(p2), 1);
        }
        geometry.setAttribute('position', new $9ddd7e9b53f7a2d4$export$cbe7a62641830ebd(positions, 3));
        const material = new $9ddd7e9b53f7a2d4$export$fbaaa33907730a0c({
            fog: false,
            toneMapped: false
        });
        this.cone = new $9ddd7e9b53f7a2d4$export$ff1ed10fedfdd604(geometry, material);
        this.add(this.cone);
        this.update();
    }
    /**
	 * Frees the GPU-related resources allocated by this instance. Call this
	 * method whenever this instance is no longer used in your app.
	 */ dispose() {
        this.cone.geometry.dispose();
        this.cone.material.dispose();
    }
    /**
	 * Updates the helper to match the position and direction of the
	 * light being visualized.
	 */ update() {
        this.light.updateWorldMatrix(true, false);
        this.light.target.updateWorldMatrix(true, false);
        // update the local matrix based on the parent and light target transforms
        if (this.parent) {
            this.parent.updateWorldMatrix(true);
            this.matrix.copy(this.parent.matrixWorld).invert().multiply(this.light.matrixWorld);
        } else this.matrix.copy(this.light.matrixWorld);
        this.matrixWorld.copy(this.light.matrixWorld);
        const coneLength = this.light.distance ? this.light.distance : 1000;
        const coneWidth = coneLength * Math.tan(this.light.angle);
        this.cone.scale.set(coneWidth, coneWidth, coneLength);
        $9ddd7e9b53f7a2d4$var$_vector$3.setFromMatrixPosition(this.light.target.matrixWorld);
        this.cone.lookAt($9ddd7e9b53f7a2d4$var$_vector$3);
        if (this.color !== undefined) this.cone.material.color.set(this.color);
        else this.cone.material.color.copy(this.light.color);
    }
}
const $9ddd7e9b53f7a2d4$var$_vector$2 = /*@__PURE__*/ new $9ddd7e9b53f7a2d4$export$64b5c384219d3699();
const $9ddd7e9b53f7a2d4$var$_boneMatrix = /*@__PURE__*/ new $9ddd7e9b53f7a2d4$export$2ae72fc923e5eb5();
const $9ddd7e9b53f7a2d4$var$_matrixWorldInv = /*@__PURE__*/ new $9ddd7e9b53f7a2d4$export$2ae72fc923e5eb5();
/**
 * A helper object to assist with visualizing a {@link Skeleton}.
 *
 * ```js
 * const helper = new THREE.SkeletonHelper( skinnedMesh );
 * scene.add( helper );
 * ```
 *
 * @augments LineSegments
 */ class $9ddd7e9b53f7a2d4$export$5277df3c9e732259 extends $9ddd7e9b53f7a2d4$export$ff1ed10fedfdd604 {
    /**
	 * Constructs a new hemisphere light helper.
	 *
	 * @param {Object3D} object -  Usually an instance of {@link SkinnedMesh}. However, any 3D object
	 * can be used if it represents a hierarchy of bones (see {@link Bone}).
	 */ constructor(object){
        const bones = $9ddd7e9b53f7a2d4$var$getBoneList(object);
        const geometry = new $9ddd7e9b53f7a2d4$export$b7be63a67df8959();
        const vertices = [];
        const colors = [];
        const color1 = new $9ddd7e9b53f7a2d4$export$892596cec99bc70e(0, 0, 1);
        const color2 = new $9ddd7e9b53f7a2d4$export$892596cec99bc70e(0, 1, 0);
        for(let i = 0; i < bones.length; i++){
            const bone = bones[i];
            if (bone.parent && bone.parent.isBone) {
                vertices.push(0, 0, 0);
                vertices.push(0, 0, 0);
                colors.push(color1.r, color1.g, color1.b);
                colors.push(color2.r, color2.g, color2.b);
            }
        }
        geometry.setAttribute('position', new $9ddd7e9b53f7a2d4$export$cbe7a62641830ebd(vertices, 3));
        geometry.setAttribute('color', new $9ddd7e9b53f7a2d4$export$cbe7a62641830ebd(colors, 3));
        const material = new $9ddd7e9b53f7a2d4$export$fbaaa33907730a0c({
            vertexColors: true,
            depthTest: false,
            depthWrite: false,
            toneMapped: false,
            transparent: true
        });
        super(geometry, material);
        /**
		 * This flag can be used for type testing.
		 *
		 * @type {boolean}
		 * @readonly
		 * @default true
		 */ this.isSkeletonHelper = true;
        this.type = 'SkeletonHelper';
        /**
		 * The object being visualized.
		 *
		 * @type {Object3D}
		 */ this.root = object;
        /**
		 * he list of bones that the helper visualizes.
		 *
		 * @type {Array<Bone>}
		 */ this.bones = bones;
        this.matrix = object.matrixWorld;
        this.matrixAutoUpdate = false;
    }
    updateMatrixWorld(force) {
        const bones = this.bones;
        const geometry = this.geometry;
        const position = geometry.getAttribute('position');
        $9ddd7e9b53f7a2d4$var$_matrixWorldInv.copy(this.root.matrixWorld).invert();
        for(let i = 0, j = 0; i < bones.length; i++){
            const bone = bones[i];
            if (bone.parent && bone.parent.isBone) {
                $9ddd7e9b53f7a2d4$var$_boneMatrix.multiplyMatrices($9ddd7e9b53f7a2d4$var$_matrixWorldInv, bone.matrixWorld);
                $9ddd7e9b53f7a2d4$var$_vector$2.setFromMatrixPosition($9ddd7e9b53f7a2d4$var$_boneMatrix);
                position.setXYZ(j, $9ddd7e9b53f7a2d4$var$_vector$2.x, $9ddd7e9b53f7a2d4$var$_vector$2.y, $9ddd7e9b53f7a2d4$var$_vector$2.z);
                $9ddd7e9b53f7a2d4$var$_boneMatrix.multiplyMatrices($9ddd7e9b53f7a2d4$var$_matrixWorldInv, bone.parent.matrixWorld);
                $9ddd7e9b53f7a2d4$var$_vector$2.setFromMatrixPosition($9ddd7e9b53f7a2d4$var$_boneMatrix);
                position.setXYZ(j + 1, $9ddd7e9b53f7a2d4$var$_vector$2.x, $9ddd7e9b53f7a2d4$var$_vector$2.y, $9ddd7e9b53f7a2d4$var$_vector$2.z);
                j += 2;
            }
        }
        geometry.getAttribute('position').needsUpdate = true;
        super.updateMatrixWorld(force);
    }
    /**
	 * Frees the GPU-related resources allocated by this instance. Call this
	 * method whenever this instance is no longer used in your app.
	 */ dispose() {
        this.geometry.dispose();
        this.material.dispose();
    }
}
function $9ddd7e9b53f7a2d4$var$getBoneList(object) {
    const boneList = [];
    if (object.isBone === true) boneList.push(object);
    for(let i = 0; i < object.children.length; i++)boneList.push(...$9ddd7e9b53f7a2d4$var$getBoneList(object.children[i]));
    return boneList;
}
/**
 * This displays a helper object consisting of a spherical mesh for
 * visualizing an instance of {@link PointLight}.
 *
 * ```js
 * const pointLight = new THREE.PointLight( 0xff0000, 1, 100 );
 * pointLight.position.set( 10, 10, 10 );
 * scene.add( pointLight );
 *
 * const sphereSize = 1;
 * const pointLightHelper = new THREE.PointLightHelper( pointLight, sphereSize );
 * scene.add( pointLightHelper );
 * ```
 *
 * @augments Mesh
 */ class $9ddd7e9b53f7a2d4$export$9a9291685b9e4023 extends $9ddd7e9b53f7a2d4$export$e176487c05830cc5 {
    /**
	 * Constructs a new point light helper.
	 *
	 * @param {PointLight} light - The light to be visualized.
	 * @param {number} [sphereSize=1] - The size of the sphere helper.
	 * @param {number|Color|string} [color] - The helper's color. If not set, the helper will take
	 * the color of the light.
	 */ constructor(light, sphereSize, color){
        const geometry = new $9ddd7e9b53f7a2d4$export$1b417fc3b307a251(sphereSize, 4, 2);
        const material = new $9ddd7e9b53f7a2d4$export$55cbcc9b622fe1f5({
            wireframe: true,
            fog: false,
            toneMapped: false
        });
        super(geometry, material);
        /**
		 * The light being visualized.
		 *
		 * @type {HemisphereLight}
		 */ this.light = light;
        /**
		 * The color parameter passed in the constructor.
		 * If not set, the helper will take the color of the light.
		 *
		 * @type {number|Color|string}
		 */ this.color = color;
        this.type = 'PointLightHelper';
        this.matrix = this.light.matrixWorld;
        this.matrixAutoUpdate = false;
        this.update();
    /*
	// TODO: delete this comment?
	const distanceGeometry = new THREE.IcosahedronGeometry( 1, 2 );
	const distanceMaterial = new THREE.MeshBasicMaterial( { color: hexColor, fog: false, wireframe: true, opacity: 0.1, transparent: true } );

	this.lightSphere = new THREE.Mesh( bulbGeometry, bulbMaterial );
	this.lightDistance = new THREE.Mesh( distanceGeometry, distanceMaterial );

	const d = light.distance;

	if ( d === 0.0 ) {

		this.lightDistance.visible = false;

	} else {

		this.lightDistance.scale.set( d, d, d );

	}

	this.add( this.lightDistance );
	*/ }
    /**
	 * Frees the GPU-related resources allocated by this instance. Call this
	 * method whenever this instance is no longer used in your app.
	 */ dispose() {
        this.geometry.dispose();
        this.material.dispose();
    }
    /**
	 * Updates the helper to match the position of the
	 * light being visualized.
	 */ update() {
        this.light.updateWorldMatrix(true, false);
        if (this.color !== undefined) this.material.color.set(this.color);
        else this.material.color.copy(this.light.color);
    /*
		const d = this.light.distance;

		if ( d === 0.0 ) {

			this.lightDistance.visible = false;

		} else {

			this.lightDistance.visible = true;
			this.lightDistance.scale.set( d, d, d );

		}
		*/ }
}
const $9ddd7e9b53f7a2d4$var$_vector$1 = /*@__PURE__*/ new $9ddd7e9b53f7a2d4$export$64b5c384219d3699();
const $9ddd7e9b53f7a2d4$var$_color1 = /*@__PURE__*/ new $9ddd7e9b53f7a2d4$export$892596cec99bc70e();
const $9ddd7e9b53f7a2d4$var$_color2 = /*@__PURE__*/ new $9ddd7e9b53f7a2d4$export$892596cec99bc70e();
/**
 * Creates a visual aid consisting of a spherical mesh for a
 * given {@link HemisphereLight}.
 *
 * ```js
 * const light = new THREE.HemisphereLight( 0xffffbb, 0x080820, 1 );
 * const helper = new THREE.HemisphereLightHelper( light, 5 );
 * scene.add( helper );
 * ```
 *
 * @augments Object3D
 */ class $9ddd7e9b53f7a2d4$export$8dca15f13f4f8172 extends $9ddd7e9b53f7a2d4$export$e4dd07dff30cc924 {
    /**
	 * Constructs a new hemisphere light helper.
	 *
	 * @param {HemisphereLight} light - The light to be visualized.
	 * @param {number} [size=1] - The size of the mesh used to visualize the light.
	 * @param {number|Color|string} [color] - The helper's color. If not set, the helper will take
	 * the color of the light.
	 */ constructor(light, size, color){
        super();
        /**
		 * The light being visualized.
		 *
		 * @type {HemisphereLight}
		 */ this.light = light;
        this.matrix = light.matrixWorld;
        this.matrixAutoUpdate = false;
        /**
		 * The color parameter passed in the constructor.
		 * If not set, the helper will take the color of the light.
		 *
		 * @type {number|Color|string}
		 */ this.color = color;
        this.type = 'HemisphereLightHelper';
        const geometry = new $9ddd7e9b53f7a2d4$export$1954e2b809fe361e(size);
        geometry.rotateY(Math.PI * 0.5);
        this.material = new $9ddd7e9b53f7a2d4$export$55cbcc9b622fe1f5({
            wireframe: true,
            fog: false,
            toneMapped: false
        });
        if (this.color === undefined) this.material.vertexColors = true;
        const position = geometry.getAttribute('position');
        const colors = new Float32Array(position.count * 3);
        geometry.setAttribute('color', new $9ddd7e9b53f7a2d4$export$8dea267bd6bde117(colors, 3));
        this.add(new $9ddd7e9b53f7a2d4$export$e176487c05830cc5(geometry, this.material));
        this.update();
    }
    /**
	 * Frees the GPU-related resources allocated by this instance. Call this
	 * method whenever this instance is no longer used in your app.
	 */ dispose() {
        this.children[0].geometry.dispose();
        this.children[0].material.dispose();
    }
    /**
	 * Updates the helper to match the position and direction of the
	 * light being visualized.
	 */ update() {
        const mesh = this.children[0];
        if (this.color !== undefined) this.material.color.set(this.color);
        else {
            const colors = mesh.geometry.getAttribute('color');
            $9ddd7e9b53f7a2d4$var$_color1.copy(this.light.color);
            $9ddd7e9b53f7a2d4$var$_color2.copy(this.light.groundColor);
            for(let i = 0, l = colors.count; i < l; i++){
                const color = i < l / 2 ? $9ddd7e9b53f7a2d4$var$_color1 : $9ddd7e9b53f7a2d4$var$_color2;
                colors.setXYZ(i, color.r, color.g, color.b);
            }
            colors.needsUpdate = true;
        }
        this.light.updateWorldMatrix(true, false);
        mesh.lookAt($9ddd7e9b53f7a2d4$var$_vector$1.setFromMatrixPosition(this.light.matrixWorld).negate());
    }
}
/**
 * The helper is an object to define grids. Grids are two-dimensional
 * arrays of lines.
 *
 * ```js
 * const size = 10;
 * const divisions = 10;
 *
 * const gridHelper = new THREE.GridHelper( size, divisions );
 * scene.add( gridHelper );
 * ```
 *
 * @augments LineSegments
 */ class $9ddd7e9b53f7a2d4$export$3875d39926561055 extends $9ddd7e9b53f7a2d4$export$ff1ed10fedfdd604 {
    /**
	 * Constructs a new grid helper.
	 *
	 * @param {number} [size=10] - The size of the grid.
	 * @param {number} [divisions=10] - The number of divisions across the grid.
	 * @param {number|Color|string} [color1=0x444444] - The color of the center line.
	 * @param {number|Color|string} [color2=0x888888] - The color of the lines of the grid.
	 */ constructor(size = 10, divisions = 10, color1 = 0x444444, color2 = 0x888888){
        color1 = new $9ddd7e9b53f7a2d4$export$892596cec99bc70e(color1);
        color2 = new $9ddd7e9b53f7a2d4$export$892596cec99bc70e(color2);
        const center = divisions / 2;
        const step = size / divisions;
        const halfSize = size / 2;
        const vertices = [], colors = [];
        for(let i = 0, j = 0, k = -halfSize; i <= divisions; i++, k += step){
            vertices.push(-halfSize, 0, k, halfSize, 0, k);
            vertices.push(k, 0, -halfSize, k, 0, halfSize);
            const color = i === center ? color1 : color2;
            color.toArray(colors, j);
            j += 3;
            color.toArray(colors, j);
            j += 3;
            color.toArray(colors, j);
            j += 3;
            color.toArray(colors, j);
            j += 3;
        }
        const geometry = new $9ddd7e9b53f7a2d4$export$b7be63a67df8959();
        geometry.setAttribute('position', new $9ddd7e9b53f7a2d4$export$cbe7a62641830ebd(vertices, 3));
        geometry.setAttribute('color', new $9ddd7e9b53f7a2d4$export$cbe7a62641830ebd(colors, 3));
        const material = new $9ddd7e9b53f7a2d4$export$fbaaa33907730a0c({
            vertexColors: true,
            toneMapped: false
        });
        super(geometry, material);
        this.type = 'GridHelper';
    }
    /**
	 * Frees the GPU-related resources allocated by this instance. Call this
	 * method whenever this instance is no longer used in your app.
	 */ dispose() {
        this.geometry.dispose();
        this.material.dispose();
    }
}
/**
 * This helper is an object to define polar grids. Grids are
 * two-dimensional arrays of lines.
 *
 * ```js
 * const radius = 10;
 * const sectors = 16;
 * const rings = 8;
 * const divisions = 64;
 *
 * const helper = new THREE.PolarGridHelper( radius, sectors, rings, divisions );
 * scene.add( helper );
 * ```
 *
 * @augments LineSegments
 */ class $9ddd7e9b53f7a2d4$export$361430a10f533cd3 extends $9ddd7e9b53f7a2d4$export$ff1ed10fedfdd604 {
    /**
	 * Constructs a new polar grid helper.
	 *
	 * @param {number} [radius=10] - The radius of the polar grid. This can be any positive number.
	 * @param {number} [sectors=16] - The number of sectors the grid will be divided into. This can be any positive integer.
	 * @param {number} [rings=16] - The number of rings. This can be any positive integer.
	 * @param {number} [divisions=64] - The number of line segments used for each circle. This can be any positive integer.
	 * @param {number|Color|string} [color1=0x444444] - The first color used for grid elements.
	 * @param {number|Color|string} [color2=0x888888] -  The second color used for grid elements.
	 */ constructor(radius = 10, sectors = 16, rings = 8, divisions = 64, color1 = 0x444444, color2 = 0x888888){
        color1 = new $9ddd7e9b53f7a2d4$export$892596cec99bc70e(color1);
        color2 = new $9ddd7e9b53f7a2d4$export$892596cec99bc70e(color2);
        const vertices = [];
        const colors = [];
        // create the sectors
        if (sectors > 1) for(let i = 0; i < sectors; i++){
            const v = i / sectors * (Math.PI * 2);
            const x = Math.sin(v) * radius;
            const z = Math.cos(v) * radius;
            vertices.push(0, 0, 0);
            vertices.push(x, 0, z);
            const color = i & 1 ? color1 : color2;
            colors.push(color.r, color.g, color.b);
            colors.push(color.r, color.g, color.b);
        }
        // create the rings
        for(let i = 0; i < rings; i++){
            const color = i & 1 ? color1 : color2;
            const r = radius - radius / rings * i;
            for(let j = 0; j < divisions; j++){
                // first vertex
                let v = j / divisions * (Math.PI * 2);
                let x = Math.sin(v) * r;
                let z = Math.cos(v) * r;
                vertices.push(x, 0, z);
                colors.push(color.r, color.g, color.b);
                // second vertex
                v = (j + 1) / divisions * (Math.PI * 2);
                x = Math.sin(v) * r;
                z = Math.cos(v) * r;
                vertices.push(x, 0, z);
                colors.push(color.r, color.g, color.b);
            }
        }
        const geometry = new $9ddd7e9b53f7a2d4$export$b7be63a67df8959();
        geometry.setAttribute('position', new $9ddd7e9b53f7a2d4$export$cbe7a62641830ebd(vertices, 3));
        geometry.setAttribute('color', new $9ddd7e9b53f7a2d4$export$cbe7a62641830ebd(colors, 3));
        const material = new $9ddd7e9b53f7a2d4$export$fbaaa33907730a0c({
            vertexColors: true,
            toneMapped: false
        });
        super(geometry, material);
        this.type = 'PolarGridHelper';
    }
    /**
	 * Frees the GPU-related resources allocated by this instance. Call this
	 * method whenever this instance is no longer used in your app.
	 */ dispose() {
        this.geometry.dispose();
        this.material.dispose();
    }
}
const $9ddd7e9b53f7a2d4$var$_v1 = /*@__PURE__*/ new $9ddd7e9b53f7a2d4$export$64b5c384219d3699();
const $9ddd7e9b53f7a2d4$var$_v2 = /*@__PURE__*/ new $9ddd7e9b53f7a2d4$export$64b5c384219d3699();
const $9ddd7e9b53f7a2d4$var$_v3 = /*@__PURE__*/ new $9ddd7e9b53f7a2d4$export$64b5c384219d3699();
/**
 * Helper object to assist with visualizing a {@link DirectionalLight}'s
 * effect on the scene. This consists of plane and a line representing the
 * light's position and direction.
 *
 * ```js
 * const light = new THREE.DirectionalLight( 0xFFFFFF );
 * scene.add( light );
 *
 * const helper = new THREE.DirectionalLightHelper( light, 5 );
 * scene.add( helper );
 * ```
 *
 * @augments Object3D
 */ class $9ddd7e9b53f7a2d4$export$f8e434dc14203e7d extends $9ddd7e9b53f7a2d4$export$e4dd07dff30cc924 {
    /**
	 * Constructs a new directional light helper.
	 *
	 * @param {DirectionalLight} light - The light to be visualized.
	 * @param {number} [size=1] - The dimensions of the plane.
	 * @param {number|Color|string} [color] - The helper's color. If not set, the helper will take
	 * the color of the light.
	 */ constructor(light, size, color){
        super();
        /**
		 * The light being visualized.
		 *
		 * @type {DirectionalLight}
		 */ this.light = light;
        this.matrix = light.matrixWorld;
        this.matrixAutoUpdate = false;
        /**
		 * The color parameter passed in the constructor.
		 * If not set, the helper will take the color of the light.
		 *
		 * @type {number|Color|string}
		 */ this.color = color;
        this.type = 'DirectionalLightHelper';
        if (size === undefined) size = 1;
        let geometry = new $9ddd7e9b53f7a2d4$export$b7be63a67df8959();
        geometry.setAttribute('position', new $9ddd7e9b53f7a2d4$export$cbe7a62641830ebd([
            -size,
            size,
            0,
            size,
            size,
            0,
            size,
            -size,
            0,
            -size,
            -size,
            0,
            -size,
            size,
            0
        ], 3));
        const material = new $9ddd7e9b53f7a2d4$export$fbaaa33907730a0c({
            fog: false,
            toneMapped: false
        });
        /**
		 * Contains the line showing the location of the directional light.
		 *
		 * @type {Line}
		 */ this.lightPlane = new $9ddd7e9b53f7a2d4$export$17d680238e50603e(geometry, material);
        this.add(this.lightPlane);
        geometry = new $9ddd7e9b53f7a2d4$export$b7be63a67df8959();
        geometry.setAttribute('position', new $9ddd7e9b53f7a2d4$export$cbe7a62641830ebd([
            0,
            0,
            0,
            0,
            0,
            1
        ], 3));
        /**
		 * Represents the target line of the directional light.
		 *
		 * @type {Line}
		 */ this.targetLine = new $9ddd7e9b53f7a2d4$export$17d680238e50603e(geometry, material);
        this.add(this.targetLine);
        this.update();
    }
    /**
	 * Frees the GPU-related resources allocated by this instance. Call this
	 * method whenever this instance is no longer used in your app.
	 */ dispose() {
        this.lightPlane.geometry.dispose();
        this.lightPlane.material.dispose();
        this.targetLine.geometry.dispose();
        this.targetLine.material.dispose();
    }
    /**
	 * Updates the helper to match the position and direction of the
	 * light being visualized.
	 */ update() {
        this.light.updateWorldMatrix(true, false);
        this.light.target.updateWorldMatrix(true, false);
        $9ddd7e9b53f7a2d4$var$_v1.setFromMatrixPosition(this.light.matrixWorld);
        $9ddd7e9b53f7a2d4$var$_v2.setFromMatrixPosition(this.light.target.matrixWorld);
        $9ddd7e9b53f7a2d4$var$_v3.subVectors($9ddd7e9b53f7a2d4$var$_v2, $9ddd7e9b53f7a2d4$var$_v1);
        this.lightPlane.lookAt($9ddd7e9b53f7a2d4$var$_v2);
        if (this.color !== undefined) {
            this.lightPlane.material.color.set(this.color);
            this.targetLine.material.color.set(this.color);
        } else {
            this.lightPlane.material.color.copy(this.light.color);
            this.targetLine.material.color.copy(this.light.color);
        }
        this.targetLine.lookAt($9ddd7e9b53f7a2d4$var$_v2);
        this.targetLine.scale.z = $9ddd7e9b53f7a2d4$var$_v3.length();
    }
}
const $9ddd7e9b53f7a2d4$var$_vector = /*@__PURE__*/ new $9ddd7e9b53f7a2d4$export$64b5c384219d3699();
const $9ddd7e9b53f7a2d4$var$_camera = /*@__PURE__*/ new $9ddd7e9b53f7a2d4$export$79f141de891a5fed();
/**
 * This helps with visualizing what a camera contains in its frustum. It
 * visualizes the frustum of a camera using a line segments.
 *
 * Based on frustum visualization in [lightgl.js shadowmap example]{@link https://github.com/evanw/lightgl.js/blob/master/tests/shadowmap.html}.
 *
 * `CameraHelper` must be a child of the scene.
 *
 * ```js
 * const camera = new THREE.PerspectiveCamera( 75, window.innerWidth / window.innerHeight, 0.1, 1000 );
 * const helper = new THREE.CameraHelper( camera );
 * scene.add( helper );
 * ```
 *
 * @augments LineSegments
 */ class $9ddd7e9b53f7a2d4$export$ed8e93f853cd795 extends $9ddd7e9b53f7a2d4$export$ff1ed10fedfdd604 {
    /**
	 * Constructs a new arrow helper.
	 *
	 * @param {Camera} camera - The camera to visualize.
	 */ constructor(camera){
        const geometry = new $9ddd7e9b53f7a2d4$export$b7be63a67df8959();
        const material = new $9ddd7e9b53f7a2d4$export$fbaaa33907730a0c({
            color: 0xffffff,
            vertexColors: true,
            toneMapped: false
        });
        const vertices = [];
        const colors = [];
        const pointMap = {};
        // near
        addLine('n1', 'n2');
        addLine('n2', 'n4');
        addLine('n4', 'n3');
        addLine('n3', 'n1');
        // far
        addLine('f1', 'f2');
        addLine('f2', 'f4');
        addLine('f4', 'f3');
        addLine('f3', 'f1');
        // sides
        addLine('n1', 'f1');
        addLine('n2', 'f2');
        addLine('n3', 'f3');
        addLine('n4', 'f4');
        // cone
        addLine('p', 'n1');
        addLine('p', 'n2');
        addLine('p', 'n3');
        addLine('p', 'n4');
        // up
        addLine('u1', 'u2');
        addLine('u2', 'u3');
        addLine('u3', 'u1');
        // target
        addLine('c', 't');
        addLine('p', 'c');
        // cross
        addLine('cn1', 'cn2');
        addLine('cn3', 'cn4');
        addLine('cf1', 'cf2');
        addLine('cf3', 'cf4');
        function addLine(a, b) {
            addPoint(a);
            addPoint(b);
        }
        function addPoint(id) {
            vertices.push(0, 0, 0);
            colors.push(0, 0, 0);
            if (pointMap[id] === undefined) pointMap[id] = [];
            pointMap[id].push(vertices.length / 3 - 1);
        }
        geometry.setAttribute('position', new $9ddd7e9b53f7a2d4$export$cbe7a62641830ebd(vertices, 3));
        geometry.setAttribute('color', new $9ddd7e9b53f7a2d4$export$cbe7a62641830ebd(colors, 3));
        super(geometry, material);
        this.type = 'CameraHelper';
        /**
		 * The camera being visualized.
		 *
		 * @type {Camera}
		 */ this.camera = camera;
        if (this.camera.updateProjectionMatrix) this.camera.updateProjectionMatrix();
        this.matrix = camera.matrixWorld;
        this.matrixAutoUpdate = false;
        /**
		 * This contains the points used to visualize the camera.
		 *
		 * @type {Object<string,Array<number>>}
		 */ this.pointMap = pointMap;
        this.update();
        // colors
        const colorFrustum = new $9ddd7e9b53f7a2d4$export$892596cec99bc70e(0xffaa00);
        const colorCone = new $9ddd7e9b53f7a2d4$export$892596cec99bc70e(0xff0000);
        const colorUp = new $9ddd7e9b53f7a2d4$export$892596cec99bc70e(0x00aaff);
        const colorTarget = new $9ddd7e9b53f7a2d4$export$892596cec99bc70e(0xffffff);
        const colorCross = new $9ddd7e9b53f7a2d4$export$892596cec99bc70e(0x333333);
        this.setColors(colorFrustum, colorCone, colorUp, colorTarget, colorCross);
    }
    /**
	 * Defines the colors of the helper.
	 *
	 * @param {Color} frustum - The frustum line color.
	 * @param {Color} cone - The cone line color.
	 * @param {Color} up - The up line color.
	 * @param {Color} target - The target line color.
	 * @param {Color} cross - The cross line color.
	 */ setColors(frustum, cone, up, target, cross) {
        const geometry = this.geometry;
        const colorAttribute = geometry.getAttribute('color');
        // near
        colorAttribute.setXYZ(0, frustum.r, frustum.g, frustum.b);
        colorAttribute.setXYZ(1, frustum.r, frustum.g, frustum.b); // n1, n2
        colorAttribute.setXYZ(2, frustum.r, frustum.g, frustum.b);
        colorAttribute.setXYZ(3, frustum.r, frustum.g, frustum.b); // n2, n4
        colorAttribute.setXYZ(4, frustum.r, frustum.g, frustum.b);
        colorAttribute.setXYZ(5, frustum.r, frustum.g, frustum.b); // n4, n3
        colorAttribute.setXYZ(6, frustum.r, frustum.g, frustum.b);
        colorAttribute.setXYZ(7, frustum.r, frustum.g, frustum.b); // n3, n1
        // far
        colorAttribute.setXYZ(8, frustum.r, frustum.g, frustum.b);
        colorAttribute.setXYZ(9, frustum.r, frustum.g, frustum.b); // f1, f2
        colorAttribute.setXYZ(10, frustum.r, frustum.g, frustum.b);
        colorAttribute.setXYZ(11, frustum.r, frustum.g, frustum.b); // f2, f4
        colorAttribute.setXYZ(12, frustum.r, frustum.g, frustum.b);
        colorAttribute.setXYZ(13, frustum.r, frustum.g, frustum.b); // f4, f3
        colorAttribute.setXYZ(14, frustum.r, frustum.g, frustum.b);
        colorAttribute.setXYZ(15, frustum.r, frustum.g, frustum.b); // f3, f1
        // sides
        colorAttribute.setXYZ(16, frustum.r, frustum.g, frustum.b);
        colorAttribute.setXYZ(17, frustum.r, frustum.g, frustum.b); // n1, f1
        colorAttribute.setXYZ(18, frustum.r, frustum.g, frustum.b);
        colorAttribute.setXYZ(19, frustum.r, frustum.g, frustum.b); // n2, f2
        colorAttribute.setXYZ(20, frustum.r, frustum.g, frustum.b);
        colorAttribute.setXYZ(21, frustum.r, frustum.g, frustum.b); // n3, f3
        colorAttribute.setXYZ(22, frustum.r, frustum.g, frustum.b);
        colorAttribute.setXYZ(23, frustum.r, frustum.g, frustum.b); // n4, f4
        // cone
        colorAttribute.setXYZ(24, cone.r, cone.g, cone.b);
        colorAttribute.setXYZ(25, cone.r, cone.g, cone.b); // p, n1
        colorAttribute.setXYZ(26, cone.r, cone.g, cone.b);
        colorAttribute.setXYZ(27, cone.r, cone.g, cone.b); // p, n2
        colorAttribute.setXYZ(28, cone.r, cone.g, cone.b);
        colorAttribute.setXYZ(29, cone.r, cone.g, cone.b); // p, n3
        colorAttribute.setXYZ(30, cone.r, cone.g, cone.b);
        colorAttribute.setXYZ(31, cone.r, cone.g, cone.b); // p, n4
        // up
        colorAttribute.setXYZ(32, up.r, up.g, up.b);
        colorAttribute.setXYZ(33, up.r, up.g, up.b); // u1, u2
        colorAttribute.setXYZ(34, up.r, up.g, up.b);
        colorAttribute.setXYZ(35, up.r, up.g, up.b); // u2, u3
        colorAttribute.setXYZ(36, up.r, up.g, up.b);
        colorAttribute.setXYZ(37, up.r, up.g, up.b); // u3, u1
        // target
        colorAttribute.setXYZ(38, target.r, target.g, target.b);
        colorAttribute.setXYZ(39, target.r, target.g, target.b); // c, t
        colorAttribute.setXYZ(40, cross.r, cross.g, cross.b);
        colorAttribute.setXYZ(41, cross.r, cross.g, cross.b); // p, c
        // cross
        colorAttribute.setXYZ(42, cross.r, cross.g, cross.b);
        colorAttribute.setXYZ(43, cross.r, cross.g, cross.b); // cn1, cn2
        colorAttribute.setXYZ(44, cross.r, cross.g, cross.b);
        colorAttribute.setXYZ(45, cross.r, cross.g, cross.b); // cn3, cn4
        colorAttribute.setXYZ(46, cross.r, cross.g, cross.b);
        colorAttribute.setXYZ(47, cross.r, cross.g, cross.b); // cf1, cf2
        colorAttribute.setXYZ(48, cross.r, cross.g, cross.b);
        colorAttribute.setXYZ(49, cross.r, cross.g, cross.b); // cf3, cf4
        colorAttribute.needsUpdate = true;
    }
    /**
	 * Updates the helper based on the projection matrix of the camera.
	 */ update() {
        const geometry = this.geometry;
        const pointMap = this.pointMap;
        const w = 1, h = 1;
        // we need just camera projection matrix inverse
        // world matrix must be identity
        $9ddd7e9b53f7a2d4$var$_camera.projectionMatrixInverse.copy(this.camera.projectionMatrixInverse);
        // Adjust z values based on coordinate system
        const nearZ = this.camera.coordinateSystem === $9ddd7e9b53f7a2d4$export$5a0e9190d10875d3 ? -1 : 0;
        // center / target
        $9ddd7e9b53f7a2d4$var$setPoint('c', pointMap, geometry, $9ddd7e9b53f7a2d4$var$_camera, 0, 0, nearZ);
        $9ddd7e9b53f7a2d4$var$setPoint('t', pointMap, geometry, $9ddd7e9b53f7a2d4$var$_camera, 0, 0, 1);
        // near
        $9ddd7e9b53f7a2d4$var$setPoint('n1', pointMap, geometry, $9ddd7e9b53f7a2d4$var$_camera, -1, -1, nearZ);
        $9ddd7e9b53f7a2d4$var$setPoint('n2', pointMap, geometry, $9ddd7e9b53f7a2d4$var$_camera, w, -1, nearZ);
        $9ddd7e9b53f7a2d4$var$setPoint('n3', pointMap, geometry, $9ddd7e9b53f7a2d4$var$_camera, -1, h, nearZ);
        $9ddd7e9b53f7a2d4$var$setPoint('n4', pointMap, geometry, $9ddd7e9b53f7a2d4$var$_camera, w, h, nearZ);
        // far
        $9ddd7e9b53f7a2d4$var$setPoint('f1', pointMap, geometry, $9ddd7e9b53f7a2d4$var$_camera, -1, -1, 1);
        $9ddd7e9b53f7a2d4$var$setPoint('f2', pointMap, geometry, $9ddd7e9b53f7a2d4$var$_camera, w, -1, 1);
        $9ddd7e9b53f7a2d4$var$setPoint('f3', pointMap, geometry, $9ddd7e9b53f7a2d4$var$_camera, -1, h, 1);
        $9ddd7e9b53f7a2d4$var$setPoint('f4', pointMap, geometry, $9ddd7e9b53f7a2d4$var$_camera, w, h, 1);
        // up
        $9ddd7e9b53f7a2d4$var$setPoint('u1', pointMap, geometry, $9ddd7e9b53f7a2d4$var$_camera, w * 0.7, h * 1.1, nearZ);
        $9ddd7e9b53f7a2d4$var$setPoint('u2', pointMap, geometry, $9ddd7e9b53f7a2d4$var$_camera, -0.7, h * 1.1, nearZ);
        $9ddd7e9b53f7a2d4$var$setPoint('u3', pointMap, geometry, $9ddd7e9b53f7a2d4$var$_camera, 0, h * 2, nearZ);
        // cross
        $9ddd7e9b53f7a2d4$var$setPoint('cf1', pointMap, geometry, $9ddd7e9b53f7a2d4$var$_camera, -1, 0, 1);
        $9ddd7e9b53f7a2d4$var$setPoint('cf2', pointMap, geometry, $9ddd7e9b53f7a2d4$var$_camera, w, 0, 1);
        $9ddd7e9b53f7a2d4$var$setPoint('cf3', pointMap, geometry, $9ddd7e9b53f7a2d4$var$_camera, 0, -1, 1);
        $9ddd7e9b53f7a2d4$var$setPoint('cf4', pointMap, geometry, $9ddd7e9b53f7a2d4$var$_camera, 0, h, 1);
        $9ddd7e9b53f7a2d4$var$setPoint('cn1', pointMap, geometry, $9ddd7e9b53f7a2d4$var$_camera, -1, 0, nearZ);
        $9ddd7e9b53f7a2d4$var$setPoint('cn2', pointMap, geometry, $9ddd7e9b53f7a2d4$var$_camera, w, 0, nearZ);
        $9ddd7e9b53f7a2d4$var$setPoint('cn3', pointMap, geometry, $9ddd7e9b53f7a2d4$var$_camera, 0, -1, nearZ);
        $9ddd7e9b53f7a2d4$var$setPoint('cn4', pointMap, geometry, $9ddd7e9b53f7a2d4$var$_camera, 0, h, nearZ);
        geometry.getAttribute('position').needsUpdate = true;
    }
    /**
	 * Frees the GPU-related resources allocated by this instance. Call this
	 * method whenever this instance is no longer used in your app.
	 */ dispose() {
        this.geometry.dispose();
        this.material.dispose();
    }
}
function $9ddd7e9b53f7a2d4$var$setPoint(point, pointMap, geometry, camera, x, y, z) {
    $9ddd7e9b53f7a2d4$var$_vector.set(x, y, z).unproject(camera);
    const points = pointMap[point];
    if (points !== undefined) {
        const position = geometry.getAttribute('position');
        for(let i = 0, l = points.length; i < l; i++)position.setXYZ(points[i], $9ddd7e9b53f7a2d4$var$_vector.x, $9ddd7e9b53f7a2d4$var$_vector.y, $9ddd7e9b53f7a2d4$var$_vector.z);
    }
}
const $9ddd7e9b53f7a2d4$var$_box = /*@__PURE__*/ new $9ddd7e9b53f7a2d4$export$6f7d5a9418ab2aa3();
/**
 * Helper object to graphically show the world-axis-aligned bounding box
 * around an object. The actual bounding box is handled with {@link Box3},
 * this is just a visual helper for debugging. It can be automatically
 * resized with {@link BoxHelper#update} when the object it's created from
 * is transformed. Note that the object must have a geometry for this to work,
 * so it won't work with sprites.
 *
 * ```js
 * const sphere = new THREE.SphereGeometry();
 * const object = new THREE.Mesh( sphere, new THREE.MeshBasicMaterial( 0xff0000 ) );
 * const box = new THREE.BoxHelper( object, 0xffff00 );
 * scene.add( box );
 * ```
 *
 * @augments LineSegments
 */ class $9ddd7e9b53f7a2d4$export$38a664cc862a6a9d extends $9ddd7e9b53f7a2d4$export$ff1ed10fedfdd604 {
    /**
	 * Constructs a new box helper.
	 *
	 * @param {Object3D} [object] - The 3D object to show the world-axis-aligned bounding box.
	 * @param {number|Color|string} [color=0xffff00] - The box's color.
	 */ constructor(object, color = 0xffff00){
        const indices = new Uint16Array([
            0,
            1,
            1,
            2,
            2,
            3,
            3,
            0,
            4,
            5,
            5,
            6,
            6,
            7,
            7,
            4,
            0,
            4,
            1,
            5,
            2,
            6,
            3,
            7
        ]);
        const positions = new Float32Array(24);
        const geometry = new $9ddd7e9b53f7a2d4$export$b7be63a67df8959();
        geometry.setIndex(new $9ddd7e9b53f7a2d4$export$8dea267bd6bde117(indices, 1));
        geometry.setAttribute('position', new $9ddd7e9b53f7a2d4$export$8dea267bd6bde117(positions, 3));
        super(geometry, new $9ddd7e9b53f7a2d4$export$fbaaa33907730a0c({
            color: color,
            toneMapped: false
        }));
        /**
		 * The 3D object being visualized.
		 *
		 * @type {Object3D}
		 */ this.object = object;
        this.type = 'BoxHelper';
        this.matrixAutoUpdate = false;
        this.update();
    }
    /**
	 * Updates the helper's geometry to match the dimensions of the object,
	 * including any children.
	 */ update() {
        if (this.object !== undefined) $9ddd7e9b53f7a2d4$var$_box.setFromObject(this.object);
        if ($9ddd7e9b53f7a2d4$var$_box.isEmpty()) return;
        const min = $9ddd7e9b53f7a2d4$var$_box.min;
        const max = $9ddd7e9b53f7a2d4$var$_box.max;
        /*
			5____4
		1/___0/|
		| 6__|_7
		2/___3/

		0: max.x, max.y, max.z
		1: min.x, max.y, max.z
		2: min.x, min.y, max.z
		3: max.x, min.y, max.z
		4: max.x, max.y, min.z
		5: min.x, max.y, min.z
		6: min.x, min.y, min.z
		7: max.x, min.y, min.z
		*/ const position = this.geometry.attributes.position;
        const array = position.array;
        array[0] = max.x;
        array[1] = max.y;
        array[2] = max.z;
        array[3] = min.x;
        array[4] = max.y;
        array[5] = max.z;
        array[6] = min.x;
        array[7] = min.y;
        array[8] = max.z;
        array[9] = max.x;
        array[10] = min.y;
        array[11] = max.z;
        array[12] = max.x;
        array[13] = max.y;
        array[14] = min.z;
        array[15] = min.x;
        array[16] = max.y;
        array[17] = min.z;
        array[18] = min.x;
        array[19] = min.y;
        array[20] = min.z;
        array[21] = max.x;
        array[22] = min.y;
        array[23] = min.z;
        position.needsUpdate = true;
        this.geometry.computeBoundingSphere();
    }
    /**
	 * Updates the wireframe box for the passed object.
	 *
	 * @param {Object3D} object - The 3D object to create the helper for.
	 * @return {BoxHelper} A reference to this instance.
	 */ setFromObject(object) {
        this.object = object;
        this.update();
        return this;
    }
    copy(source, recursive) {
        super.copy(source, recursive);
        this.object = source.object;
        return this;
    }
    /**
	 * Frees the GPU-related resources allocated by this instance. Call this
	 * method whenever this instance is no longer used in your app.
	 */ dispose() {
        this.geometry.dispose();
        this.material.dispose();
    }
}
/**
 * A helper object to visualize an instance of {@link Box3}.
 *
 * ```js
 * const box = new THREE.Box3();
 * box.setFromCenterAndSize( new THREE.Vector3( 1, 1, 1 ), new THREE.Vector3( 2, 1, 3 ) );
 *
 * const helper = new THREE.Box3Helper( box, 0xffff00 );
 * scene.add( helper )
 * ```
 *
 * @augments LineSegments
 */ class $9ddd7e9b53f7a2d4$export$ce39f4bb96c9a290 extends $9ddd7e9b53f7a2d4$export$ff1ed10fedfdd604 {
    /**
	 * Constructs a new box3 helper.
	 *
	 * @param {Box3} box - The box to visualize.
	 * @param {number|Color|string} [color=0xffff00] - The box's color.
	 */ constructor(box, color = 0xffff00){
        const indices = new Uint16Array([
            0,
            1,
            1,
            2,
            2,
            3,
            3,
            0,
            4,
            5,
            5,
            6,
            6,
            7,
            7,
            4,
            0,
            4,
            1,
            5,
            2,
            6,
            3,
            7
        ]);
        const positions = [
            1,
            1,
            1,
            -1,
            1,
            1,
            -1,
            -1,
            1,
            1,
            -1,
            1,
            1,
            1,
            -1,
            -1,
            1,
            -1,
            -1,
            -1,
            -1,
            1,
            -1,
            -1
        ];
        const geometry = new $9ddd7e9b53f7a2d4$export$b7be63a67df8959();
        geometry.setIndex(new $9ddd7e9b53f7a2d4$export$8dea267bd6bde117(indices, 1));
        geometry.setAttribute('position', new $9ddd7e9b53f7a2d4$export$cbe7a62641830ebd(positions, 3));
        super(geometry, new $9ddd7e9b53f7a2d4$export$fbaaa33907730a0c({
            color: color,
            toneMapped: false
        }));
        /**
		 * The box being visualized.
		 *
		 * @type {Box3}
		 */ this.box = box;
        this.type = 'Box3Helper';
        this.geometry.computeBoundingSphere();
    }
    updateMatrixWorld(force) {
        const box = this.box;
        if (box.isEmpty()) return;
        box.getCenter(this.position);
        box.getSize(this.scale);
        this.scale.multiplyScalar(0.5);
        super.updateMatrixWorld(force);
    }
    /**
	 * Frees the GPU-related resources allocated by this instance. Call this
	 * method whenever this instance is no longer used in your app.
	 */ dispose() {
        this.geometry.dispose();
        this.material.dispose();
    }
}
/**
 * A helper object to visualize an instance of {@link Plane}.
 *
 * ```js
 * const plane = new THREE.Plane( new THREE.Vector3( 1, 1, 0.2 ), 3 );
 * const helper = new THREE.PlaneHelper( plane, 1, 0xffff00 );
 * scene.add( helper );
 * ```
 *
 * @augments Line
 */ class $9ddd7e9b53f7a2d4$export$a34fe8156c66e5d7 extends $9ddd7e9b53f7a2d4$export$17d680238e50603e {
    /**
	 * Constructs a new plane helper.
	 *
	 * @param {Plane} plane - The plane to be visualized.
	 * @param {number} [size=1] - The side length of plane helper.
	 * @param {number|Color|string} [hex=0xffff00] - The helper's color.
	 */ constructor(plane, size = 1, hex = 0xffff00){
        const color = hex;
        const positions = [
            1,
            -1,
            0,
            -1,
            1,
            0,
            -1,
            -1,
            0,
            1,
            1,
            0,
            -1,
            1,
            0,
            -1,
            -1,
            0,
            1,
            -1,
            0,
            1,
            1,
            0
        ];
        const geometry = new $9ddd7e9b53f7a2d4$export$b7be63a67df8959();
        geometry.setAttribute('position', new $9ddd7e9b53f7a2d4$export$cbe7a62641830ebd(positions, 3));
        geometry.computeBoundingSphere();
        super(geometry, new $9ddd7e9b53f7a2d4$export$fbaaa33907730a0c({
            color: color,
            toneMapped: false
        }));
        this.type = 'PlaneHelper';
        /**
		 * The plane being visualized.
		 *
		 * @type {Plane}
		 */ this.plane = plane;
        /**
		 * The side length of plane helper.
		 *
		 * @type {number}
		 * @default 1
		 */ this.size = size;
        const positions2 = [
            1,
            1,
            0,
            -1,
            1,
            0,
            -1,
            -1,
            0,
            1,
            1,
            0,
            -1,
            -1,
            0,
            1,
            -1,
            0
        ];
        const geometry2 = new $9ddd7e9b53f7a2d4$export$b7be63a67df8959();
        geometry2.setAttribute('position', new $9ddd7e9b53f7a2d4$export$cbe7a62641830ebd(positions2, 3));
        geometry2.computeBoundingSphere();
        this.add(new $9ddd7e9b53f7a2d4$export$e176487c05830cc5(geometry2, new $9ddd7e9b53f7a2d4$export$55cbcc9b622fe1f5({
            color: color,
            opacity: 0.2,
            transparent: true,
            depthWrite: false,
            toneMapped: false
        })));
    }
    updateMatrixWorld(force) {
        this.position.set(0, 0, 0);
        this.scale.set(0.5 * this.size, 0.5 * this.size, 1);
        this.lookAt(this.plane.normal);
        this.translateZ(-this.plane.constant);
        super.updateMatrixWorld(force);
    }
    /**
	 * Updates the helper to match the position and direction of the
	 * light being visualized.
	 */ dispose() {
        this.geometry.dispose();
        this.material.dispose();
        this.children[0].geometry.dispose();
        this.children[0].material.dispose();
    }
}
const $9ddd7e9b53f7a2d4$var$_axis = /*@__PURE__*/ new $9ddd7e9b53f7a2d4$export$64b5c384219d3699();
let $9ddd7e9b53f7a2d4$var$_lineGeometry, $9ddd7e9b53f7a2d4$var$_coneGeometry;
/**
 * An 3D arrow object for visualizing directions.
 *
 * ```js
 * const dir = new THREE.Vector3( 1, 2, 0 );
 *
 * //normalize the direction vector (convert to vector of length 1)
 * dir.normalize();
 *
 * const origin = new THREE.Vector3( 0, 0, 0 );
 * const length = 1;
 * const hex = 0xffff00;
 *
 * const arrowHelper = new THREE.ArrowHelper( dir, origin, length, hex );
 * scene.add( arrowHelper );
 * ```
 *
 * @augments Object3D
 */ class $9ddd7e9b53f7a2d4$export$a3008e7bd8d2cbe7 extends $9ddd7e9b53f7a2d4$export$e4dd07dff30cc924 {
    /**
	 * Constructs a new arrow helper.
	 *
	 * @param {Vector3} [dir=(0, 0, 1)] - The (normalized) direction vector.
	 * @param {Vector3} [origin=(0, 0, 0)] - Point at which the arrow starts.
	 * @param {number} [length=1] - Length of the arrow in world units.
	 * @param {(number|Color|string)} [color=0xffff00] - Color of the arrow.
	 * @param {number} [headLength=length*0.2] - The length of the head of the arrow.
	 * @param {number} [headWidth=headLength*0.2] - The width of the head of the arrow.
	 */ constructor(dir = new $9ddd7e9b53f7a2d4$export$64b5c384219d3699(0, 0, 1), origin = new $9ddd7e9b53f7a2d4$export$64b5c384219d3699(0, 0, 0), length = 1, color = 0xffff00, headLength = length * 0.2, headWidth = headLength * 0.2){
        super();
        this.type = 'ArrowHelper';
        if ($9ddd7e9b53f7a2d4$var$_lineGeometry === undefined) {
            $9ddd7e9b53f7a2d4$var$_lineGeometry = new $9ddd7e9b53f7a2d4$export$b7be63a67df8959();
            $9ddd7e9b53f7a2d4$var$_lineGeometry.setAttribute('position', new $9ddd7e9b53f7a2d4$export$cbe7a62641830ebd([
                0,
                0,
                0,
                0,
                1,
                0
            ], 3));
            $9ddd7e9b53f7a2d4$var$_coneGeometry = new $9ddd7e9b53f7a2d4$export$68f745719dbe5198(0, 0.5, 1, 5, 1);
            $9ddd7e9b53f7a2d4$var$_coneGeometry.translate(0, -0.5, 0);
        }
        this.position.copy(origin);
        /**
		 * The line part of the arrow helper.
		 *
		 * @type {Line}
		 */ this.line = new $9ddd7e9b53f7a2d4$export$17d680238e50603e($9ddd7e9b53f7a2d4$var$_lineGeometry, new $9ddd7e9b53f7a2d4$export$fbaaa33907730a0c({
            color: color,
            toneMapped: false
        }));
        this.line.matrixAutoUpdate = false;
        this.add(this.line);
        /**
		 * The cone part of the arrow helper.
		 *
		 * @type {Mesh}
		 */ this.cone = new $9ddd7e9b53f7a2d4$export$e176487c05830cc5($9ddd7e9b53f7a2d4$var$_coneGeometry, new $9ddd7e9b53f7a2d4$export$55cbcc9b622fe1f5({
            color: color,
            toneMapped: false
        }));
        this.cone.matrixAutoUpdate = false;
        this.add(this.cone);
        this.setDirection(dir);
        this.setLength(length, headLength, headWidth);
    }
    /**
	 * Sets the direction of the helper.
	 *
	 * @param {Vector3} dir - The normalized direction vector.
	 */ setDirection(dir) {
        // dir is assumed to be normalized
        if (dir.y > 0.99999) this.quaternion.set(0, 0, 0, 1);
        else if (dir.y < -0.99999) this.quaternion.set(1, 0, 0, 0);
        else {
            $9ddd7e9b53f7a2d4$var$_axis.set(dir.z, 0, -dir.x).normalize();
            const radians = Math.acos(dir.y);
            this.quaternion.setFromAxisAngle($9ddd7e9b53f7a2d4$var$_axis, radians);
        }
    }
    /**
	 * Sets the length of the helper.
	 *
	 * @param {number} length - Length of the arrow in world units.
	 * @param {number} [headLength=length*0.2] - The length of the head of the arrow.
	 * @param {number} [headWidth=headLength*0.2] - The width of the head of the arrow.
	 */ setLength(length, headLength = length * 0.2, headWidth = headLength * 0.2) {
        this.line.scale.set(1, Math.max(0.0001, length - headLength), 1); // see #17458
        this.line.updateMatrix();
        this.cone.scale.set(headWidth, headLength, headWidth);
        this.cone.position.y = length;
        this.cone.updateMatrix();
    }
    /**
	 * Sets the color of the helper.
	 *
	 * @param {number|Color|string} color - The color to set.
	 */ setColor(color) {
        this.line.material.color.set(color);
        this.cone.material.color.set(color);
    }
    copy(source) {
        super.copy(source, false);
        this.line.copy(source.line);
        this.cone.copy(source.cone);
        return this;
    }
    /**
	 * Frees the GPU-related resources allocated by this instance. Call this
	 * method whenever this instance is no longer used in your app.
	 */ dispose() {
        this.line.geometry.dispose();
        this.line.material.dispose();
        this.cone.geometry.dispose();
        this.cone.material.dispose();
    }
}
/**
 * An axis object to visualize the 3 axes in a simple way.
 * The X axis is red. The Y axis is green. The Z axis is blue.
 *
 * ```js
 * const axesHelper = new THREE.AxesHelper( 5 );
 * scene.add( axesHelper );
 * ```
 *
 * @augments LineSegments
 */ class $9ddd7e9b53f7a2d4$export$6c8303f35b8578fd extends $9ddd7e9b53f7a2d4$export$ff1ed10fedfdd604 {
    /**
	 * Constructs a new axes helper.
	 *
	 * @param {number} [size=1] - Size of the lines representing the axes.
	 */ constructor(size = 1){
        const vertices = [
            0,
            0,
            0,
            size,
            0,
            0,
            0,
            0,
            0,
            0,
            size,
            0,
            0,
            0,
            0,
            0,
            0,
            size
        ];
        const colors = [
            1,
            0,
            0,
            1,
            0.6,
            0,
            0,
            1,
            0,
            0.6,
            1,
            0,
            0,
            0,
            1,
            0,
            0.6,
            1
        ];
        const geometry = new $9ddd7e9b53f7a2d4$export$b7be63a67df8959();
        geometry.setAttribute('position', new $9ddd7e9b53f7a2d4$export$cbe7a62641830ebd(vertices, 3));
        geometry.setAttribute('color', new $9ddd7e9b53f7a2d4$export$cbe7a62641830ebd(colors, 3));
        const material = new $9ddd7e9b53f7a2d4$export$fbaaa33907730a0c({
            vertexColors: true,
            toneMapped: false
        });
        super(geometry, material);
        this.type = 'AxesHelper';
    }
    /**
	 * Defines the colors of the axes helper.
	 *
	 * @param {number|Color|string} xAxisColor - The color for the x axis.
	 * @param {number|Color|string} yAxisColor - The color for the y axis.
	 * @param {number|Color|string} zAxisColor - The color for the z axis.
	 * @return {AxesHelper} A reference to this axes helper.
	 */ setColors(xAxisColor, yAxisColor, zAxisColor) {
        const color = new $9ddd7e9b53f7a2d4$export$892596cec99bc70e();
        const array = this.geometry.attributes.color.array;
        color.set(xAxisColor);
        color.toArray(array, 0);
        color.toArray(array, 3);
        color.set(yAxisColor);
        color.toArray(array, 6);
        color.toArray(array, 9);
        color.set(zAxisColor);
        color.toArray(array, 12);
        color.toArray(array, 15);
        this.geometry.attributes.color.needsUpdate = true;
        return this;
    }
    /**
	 * Frees the GPU-related resources allocated by this instance. Call this
	 * method whenever this instance is no longer used in your app.
	 */ dispose() {
        this.geometry.dispose();
        this.material.dispose();
    }
}
/**
 * This class is used to convert a series of paths to an array of
 * shapes. It is specifically used in context of fonts and SVG.
 */ class $9ddd7e9b53f7a2d4$export$148534a3c727230b {
    /**
	 * Constructs a new shape path.
	 */ constructor(){
        this.type = 'ShapePath';
        /**
		 * The color of the shape.
		 *
		 * @type {Color}
		 */ this.color = new $9ddd7e9b53f7a2d4$export$892596cec99bc70e();
        /**
		 * The paths that have been generated for this shape.
		 *
		 * @type {Array<Path>}
		 * @default null
		 */ this.subPaths = [];
        /**
		 * The current path that is being generated.
		 *
		 * @type {?Path}
		 * @default null
		 */ this.currentPath = null;
    }
    /**
	 * Creates a new path and moves it current point to the given one.
	 *
	 * @param {number} x - The x coordinate.
	 * @param {number} y - The y coordinate.
	 * @return {ShapePath} A reference to this shape path.
	 */ moveTo(x, y) {
        this.currentPath = new $9ddd7e9b53f7a2d4$export$4b2950bdac9b6ee9();
        this.subPaths.push(this.currentPath);
        this.currentPath.moveTo(x, y);
        return this;
    }
    /**
	 * Adds an instance of {@link LineCurve} to the path by connecting
	 * the current point with the given one.
	 *
	 * @param {number} x - The x coordinate of the end point.
	 * @param {number} y - The y coordinate of the end point.
	 * @return {ShapePath} A reference to this shape path.
	 */ lineTo(x, y) {
        this.currentPath.lineTo(x, y);
        return this;
    }
    /**
	 * Adds an instance of {@link QuadraticBezierCurve} to the path by connecting
	 * the current point with the given one.
	 *
	 * @param {number} aCPx - The x coordinate of the control point.
	 * @param {number} aCPy - The y coordinate of the control point.
	 * @param {number} aX - The x coordinate of the end point.
	 * @param {number} aY - The y coordinate of the end point.
	 * @return {ShapePath} A reference to this shape path.
	 */ quadraticCurveTo(aCPx, aCPy, aX, aY) {
        this.currentPath.quadraticCurveTo(aCPx, aCPy, aX, aY);
        return this;
    }
    /**
	 * Adds an instance of {@link CubicBezierCurve} to the path by connecting
	 * the current point with the given one.
	 *
	 * @param {number} aCP1x - The x coordinate of the first control point.
	 * @param {number} aCP1y - The y coordinate of the first control point.
	 * @param {number} aCP2x - The x coordinate of the second control point.
	 * @param {number} aCP2y - The y coordinate of the second control point.
	 * @param {number} aX - The x coordinate of the end point.
	 * @param {number} aY - The y coordinate of the end point.
	 * @return {ShapePath} A reference to this shape path.
	 */ bezierCurveTo(aCP1x, aCP1y, aCP2x, aCP2y, aX, aY) {
        this.currentPath.bezierCurveTo(aCP1x, aCP1y, aCP2x, aCP2y, aX, aY);
        return this;
    }
    /**
	 * Adds an instance of {@link SplineCurve} to the path by connecting
	 * the current point with the given list of points.
	 *
	 * @param {Array<Vector2>} pts - An array of points in 2D space.
	 * @return {ShapePath} A reference to this shape path.
	 */ splineThru(pts) {
        this.currentPath.splineThru(pts);
        return this;
    }
    /**
	 * Converts the paths into an array of shapes.
	 *
	 * @param {boolean} isCCW - By default solid shapes are  defined clockwise (CW) and holes are defined counterclockwise (CCW).
	 * If this flag is set to `true`, then those are flipped.
	 * @return {Array<Shape>} An array of shapes.
	 */ toShapes(isCCW) {
        function toShapesNoHoles(inSubpaths) {
            const shapes = [];
            for(let i = 0, l = inSubpaths.length; i < l; i++){
                const tmpPath = inSubpaths[i];
                const tmpShape = new $9ddd7e9b53f7a2d4$export$6428a7f2611ef1fa();
                tmpShape.curves = tmpPath.curves;
                shapes.push(tmpShape);
            }
            return shapes;
        }
        function isPointInsidePolygon(inPt, inPolygon) {
            const polyLen = inPolygon.length;
            // inPt on polygon contour => immediate success    or
            // toggling of inside/outside at every single! intersection point of an edge
            //  with the horizontal line through inPt, left of inPt
            //  not counting lowerY endpoints of edges and whole edges on that line
            let inside = false;
            for(let p = polyLen - 1, q = 0; q < polyLen; p = q++){
                let edgeLowPt = inPolygon[p];
                let edgeHighPt = inPolygon[q];
                let edgeDx = edgeHighPt.x - edgeLowPt.x;
                let edgeDy = edgeHighPt.y - edgeLowPt.y;
                if (Math.abs(edgeDy) > Number.EPSILON) {
                    // not parallel
                    if (edgeDy < 0) {
                        edgeLowPt = inPolygon[q];
                        edgeDx = -edgeDx;
                        edgeHighPt = inPolygon[p];
                        edgeDy = -edgeDy;
                    }
                    if (inPt.y < edgeLowPt.y || inPt.y > edgeHighPt.y) continue;
                    if (inPt.y === edgeLowPt.y) {
                        if (inPt.x === edgeLowPt.x) return true; // inPt is on contour ?
                    // continue;				// no intersection or edgeLowPt => doesn't count !!!
                    } else {
                        const perpEdge = edgeDy * (inPt.x - edgeLowPt.x) - edgeDx * (inPt.y - edgeLowPt.y);
                        if (perpEdge === 0) return true; // inPt is on contour ?
                        if (perpEdge < 0) continue;
                        inside = !inside; // true intersection left of inPt
                    }
                } else {
                    // parallel or collinear
                    if (inPt.y !== edgeLowPt.y) continue; // parallel
                    // edge lies on the same horizontal line as inPt
                    if (edgeHighPt.x <= inPt.x && inPt.x <= edgeLowPt.x || edgeLowPt.x <= inPt.x && inPt.x <= edgeHighPt.x) return true; // inPt: Point on contour !
                // continue;
                }
            }
            return inside;
        }
        const isClockWise = $9ddd7e9b53f7a2d4$export$96bdf6d9c66d7ba8.isClockWise;
        const subPaths = this.subPaths;
        if (subPaths.length === 0) return [];
        let solid, tmpPath, tmpShape;
        const shapes = [];
        if (subPaths.length === 1) {
            tmpPath = subPaths[0];
            tmpShape = new $9ddd7e9b53f7a2d4$export$6428a7f2611ef1fa();
            tmpShape.curves = tmpPath.curves;
            shapes.push(tmpShape);
            return shapes;
        }
        let holesFirst = !isClockWise(subPaths[0].getPoints());
        holesFirst = isCCW ? !holesFirst : holesFirst;
        // console.log("Holes first", holesFirst);
        const betterShapeHoles = [];
        const newShapes = [];
        let newShapeHoles = [];
        let mainIdx = 0;
        let tmpPoints;
        newShapes[mainIdx] = undefined;
        newShapeHoles[mainIdx] = [];
        for(let i = 0, l = subPaths.length; i < l; i++){
            tmpPath = subPaths[i];
            tmpPoints = tmpPath.getPoints();
            solid = isClockWise(tmpPoints);
            solid = isCCW ? !solid : solid;
            if (solid) {
                if (!holesFirst && newShapes[mainIdx]) mainIdx++;
                newShapes[mainIdx] = {
                    s: new $9ddd7e9b53f7a2d4$export$6428a7f2611ef1fa(),
                    p: tmpPoints
                };
                newShapes[mainIdx].s.curves = tmpPath.curves;
                if (holesFirst) mainIdx++;
                newShapeHoles[mainIdx] = [];
            //console.log('cw', i);
            } else newShapeHoles[mainIdx].push({
                h: tmpPath,
                p: tmpPoints[0]
            });
        }
        // only Holes? -> probably all Shapes with wrong orientation
        if (!newShapes[0]) return toShapesNoHoles(subPaths);
        if (newShapes.length > 1) {
            let ambiguous = false;
            let toChange = 0;
            for(let sIdx = 0, sLen = newShapes.length; sIdx < sLen; sIdx++)betterShapeHoles[sIdx] = [];
            for(let sIdx = 0, sLen = newShapes.length; sIdx < sLen; sIdx++){
                const sho = newShapeHoles[sIdx];
                for(let hIdx = 0; hIdx < sho.length; hIdx++){
                    const ho = sho[hIdx];
                    let hole_unassigned = true;
                    for(let s2Idx = 0; s2Idx < newShapes.length; s2Idx++)if (isPointInsidePolygon(ho.p, newShapes[s2Idx].p)) {
                        if (sIdx !== s2Idx) toChange++;
                        if (hole_unassigned) {
                            hole_unassigned = false;
                            betterShapeHoles[s2Idx].push(ho);
                        } else ambiguous = true;
                    }
                    if (hole_unassigned) betterShapeHoles[sIdx].push(ho);
                }
            }
            if (toChange > 0 && ambiguous === false) newShapeHoles = betterShapeHoles;
        }
        let tmpHoles;
        for(let i = 0, il = newShapes.length; i < il; i++){
            tmpShape = newShapes[i].s;
            shapes.push(tmpShape);
            tmpHoles = newShapeHoles[i];
            for(let j = 0, jl = tmpHoles.length; j < jl; j++)tmpShape.holes.push(tmpHoles[j].h);
        }
        //console.log("shape", shapes);
        return shapes;
    }
}
/**
 * Abstract base class for controls.
 *
 * @abstract
 * @augments EventDispatcher
 */ class $9ddd7e9b53f7a2d4$export$c7c44baae9d9f25f extends $9ddd7e9b53f7a2d4$export$ec8b666c5fe2c75a {
    /**
	 * Constructs a new controls instance.
	 *
	 * @param {Object3D} object - The object that is managed by the controls.
	 * @param {?HTMLDOMElement} domElement - The HTML element used for event listeners.
	 */ constructor(object, domElement = null){
        super();
        /**
		 * The object that is managed by the controls.
		 *
		 * @type {Object3D}
		 */ this.object = object;
        /**
		 * The HTML element used for event listeners.
		 *
		 * @type {?HTMLDOMElement}
		 * @default null
		 */ this.domElement = domElement;
        /**
		 * Whether the controls responds to user input or not.
		 *
		 * @type {boolean}
		 * @default true
		 */ this.enabled = true;
        /**
		 * The internal state of the controls.
		 *
		 * @type {number}
		 * @default -1
		 */ this.state = -1;
        /**
		 * This object defines the keyboard input of the controls.
		 *
		 * @type {Object}
		 */ this.keys = {};
        /**
		 * This object defines what type of actions are assigned to the available mouse buttons.
		 * It depends on the control implementation what kind of mouse buttons and actions are supported.
		 *
		 * @type {{LEFT: ?number, MIDDLE: ?number, RIGHT: ?number}}
		 */ this.mouseButtons = {
            LEFT: null,
            MIDDLE: null,
            RIGHT: null
        };
        /**
		 * This object defines what type of actions are assigned to what kind of touch interaction.
		 * It depends on the control implementation what kind of touch interaction and actions are supported.
		 *
		 * @type {{ONE: ?number, TWO: ?number}}
		 */ this.touches = {
            ONE: null,
            TWO: null
        };
    }
    /**
	 * Connects the controls to the DOM. This method has so called "side effects" since
	 * it adds the module's event listeners to the DOM.
	 *
	 * @param {HTMLDOMElement} element - The DOM element to connect to.
	 */ connect(element) {
        if (element === undefined) {
            console.warn('THREE.Controls: connect() now requires an element.'); // @deprecated, the warning can be removed with r185
            return;
        }
        if (this.domElement !== null) this.disconnect();
        this.domElement = element;
    }
    /**
	 * Disconnects the controls from the DOM.
	 */ disconnect() {}
    /**
	 * Call this method if you no longer want use to the controls. It frees all internal
	 * resources and removes all event listeners.
	 */ dispose() {}
    /**
	 * Controls should implement this method if they have to update their internal state
	 * per simulation step.
	 *
	 * @param {number} [delta] - The time delta in seconds.
	 */ update() {}
}
/**
 * Scales the texture as large as possible within its surface without cropping
 * or stretching the texture. The method preserves the original aspect ratio of
 * the texture. Akin to CSS `object-fit: contain`
 *
 * @param {Texture} texture - The texture.
 * @param {number} aspect - The texture's aspect ratio.
 * @return {Texture} The updated texture.
 */ function $9ddd7e9b53f7a2d4$var$contain(texture, aspect) {
    const imageAspect = texture.image && texture.image.width ? texture.image.width / texture.image.height : 1;
    if (imageAspect > aspect) {
        texture.repeat.x = 1;
        texture.repeat.y = imageAspect / aspect;
        texture.offset.x = 0;
        texture.offset.y = (1 - texture.repeat.y) / 2;
    } else {
        texture.repeat.x = aspect / imageAspect;
        texture.repeat.y = 1;
        texture.offset.x = (1 - texture.repeat.x) / 2;
        texture.offset.y = 0;
    }
    return texture;
}
/**
 * Scales the texture to the smallest possible size to fill the surface, leaving
 * no empty space. The method preserves the original aspect ratio of the texture.
 * Akin to CSS `object-fit: cover`.
 *
 * @param {Texture} texture - The texture.
 * @param {number} aspect - The texture's aspect ratio.
 * @return {Texture} The updated texture.
 */ function $9ddd7e9b53f7a2d4$var$cover(texture, aspect) {
    const imageAspect = texture.image && texture.image.width ? texture.image.width / texture.image.height : 1;
    if (imageAspect > aspect) {
        texture.repeat.x = aspect / imageAspect;
        texture.repeat.y = 1;
        texture.offset.x = (1 - texture.repeat.x) / 2;
        texture.offset.y = 0;
    } else {
        texture.repeat.x = 1;
        texture.repeat.y = imageAspect / aspect;
        texture.offset.x = 0;
        texture.offset.y = (1 - texture.repeat.y) / 2;
    }
    return texture;
}
/**
 * Configures the texture to the default transformation. Akin to CSS `object-fit: fill`.
 *
 * @param {Texture} texture - The texture.
 * @return {Texture} The updated texture.
 */ function $9ddd7e9b53f7a2d4$var$fill(texture) {
    texture.repeat.x = 1;
    texture.repeat.y = 1;
    texture.offset.x = 0;
    texture.offset.y = 0;
    return texture;
}
/**
 * Determines how many bytes must be used to represent the texture.
 *
 * @param {number} width - The width of the texture.
 * @param {number} height - The height of the texture.
 * @param {number} format - The texture's format.
 * @param {number} type - The texture's type.
 * @return {number} The byte length.
 */ function $9ddd7e9b53f7a2d4$export$cc8c3b705bb8e6e2(width, height, format, type) {
    const typeByteLength = $9ddd7e9b53f7a2d4$var$getTextureTypeByteLength(type);
    switch(format){
        // https://registry.khronos.org/OpenGL-Refpages/es3.0/html/glTexImage2D.xhtml
        case $9ddd7e9b53f7a2d4$export$988473390501ed4b:
            return width * height;
        case $9ddd7e9b53f7a2d4$export$cc09ccbf6d1ed449:
            return width * height;
        case $9ddd7e9b53f7a2d4$export$9053a81c4a69c289:
            return width * height * 2;
        case $9ddd7e9b53f7a2d4$export$4e041a7967d15c4b:
            return width * height / typeByteLength.components * typeByteLength.byteLength;
        case $9ddd7e9b53f7a2d4$export$aa92e870a709d190:
            return width * height / typeByteLength.components * typeByteLength.byteLength;
        case $9ddd7e9b53f7a2d4$export$6cdf0b461c7ce8a0:
            return width * height * 2 / typeByteLength.components * typeByteLength.byteLength;
        case $9ddd7e9b53f7a2d4$export$1ba1c45f9f77d4d7:
            return width * height * 2 / typeByteLength.components * typeByteLength.byteLength;
        case $9ddd7e9b53f7a2d4$export$7c67423a5ee6f5eb:
            return width * height * 3 / typeByteLength.components * typeByteLength.byteLength;
        case $9ddd7e9b53f7a2d4$export$3f8bb04b555a363c:
            return width * height * 4 / typeByteLength.components * typeByteLength.byteLength;
        case $9ddd7e9b53f7a2d4$export$c200e7d26f592f21:
            return width * height * 4 / typeByteLength.components * typeByteLength.byteLength;
        // https://registry.khronos.org/webgl/extensions/WEBGL_compressed_texture_s3tc_srgb/
        case $9ddd7e9b53f7a2d4$export$21d1799c6d552fc0:
        case $9ddd7e9b53f7a2d4$export$afa304c3e981b668:
            return Math.floor((width + 3) / 4) * Math.floor((height + 3) / 4) * 8;
        case $9ddd7e9b53f7a2d4$export$d2a1a68024a3e56c:
        case $9ddd7e9b53f7a2d4$export$9a79c424327dacf9:
            return Math.floor((width + 3) / 4) * Math.floor((height + 3) / 4) * 16;
        // https://registry.khronos.org/webgl/extensions/WEBGL_compressed_texture_pvrtc/
        case $9ddd7e9b53f7a2d4$export$d0f0355bb3d948e4:
        case $9ddd7e9b53f7a2d4$export$b71692456c47b6c3:
            return Math.max(width, 16) * Math.max(height, 8) / 4;
        case $9ddd7e9b53f7a2d4$export$19ada9bbb1af3573:
        case $9ddd7e9b53f7a2d4$export$b82296714358084c:
            return Math.max(width, 8) * Math.max(height, 8) / 2;
        // https://registry.khronos.org/webgl/extensions/WEBGL_compressed_texture_etc/
        case $9ddd7e9b53f7a2d4$export$6ab91af2d757aee7:
        case $9ddd7e9b53f7a2d4$export$7800993ef8106a6a:
            return Math.floor((width + 3) / 4) * Math.floor((height + 3) / 4) * 8;
        case $9ddd7e9b53f7a2d4$export$23ed8300a860e7d8:
            return Math.floor((width + 3) / 4) * Math.floor((height + 3) / 4) * 16;
        // https://registry.khronos.org/webgl/extensions/WEBGL_compressed_texture_astc/
        case $9ddd7e9b53f7a2d4$export$dc5570b4a2b92d48:
            return Math.floor((width + 3) / 4) * Math.floor((height + 3) / 4) * 16;
        case $9ddd7e9b53f7a2d4$export$68880cd325f8b2fb:
            return Math.floor((width + 4) / 5) * Math.floor((height + 3) / 4) * 16;
        case $9ddd7e9b53f7a2d4$export$7d2c0be323373d95:
            return Math.floor((width + 4) / 5) * Math.floor((height + 4) / 5) * 16;
        case $9ddd7e9b53f7a2d4$export$22b52da301fc3a3e:
            return Math.floor((width + 5) / 6) * Math.floor((height + 4) / 5) * 16;
        case $9ddd7e9b53f7a2d4$export$c009e2cb4a66485e:
            return Math.floor((width + 5) / 6) * Math.floor((height + 5) / 6) * 16;
        case $9ddd7e9b53f7a2d4$export$118fff5afa255b63:
            return Math.floor((width + 7) / 8) * Math.floor((height + 4) / 5) * 16;
        case $9ddd7e9b53f7a2d4$export$120713c829ae0667:
            return Math.floor((width + 7) / 8) * Math.floor((height + 5) / 6) * 16;
        case $9ddd7e9b53f7a2d4$export$c79eeabbf53313e9:
            return Math.floor((width + 7) / 8) * Math.floor((height + 7) / 8) * 16;
        case $9ddd7e9b53f7a2d4$export$443cf6567cdd6424:
            return Math.floor((width + 9) / 10) * Math.floor((height + 4) / 5) * 16;
        case $9ddd7e9b53f7a2d4$export$6573984fc9840780:
            return Math.floor((width + 9) / 10) * Math.floor((height + 5) / 6) * 16;
        case $9ddd7e9b53f7a2d4$export$e7aee563f30091de:
            return Math.floor((width + 9) / 10) * Math.floor((height + 7) / 8) * 16;
        case $9ddd7e9b53f7a2d4$export$2eb8634622ddeab7:
            return Math.floor((width + 9) / 10) * Math.floor((height + 9) / 10) * 16;
        case $9ddd7e9b53f7a2d4$export$202b1ce7b5d25742:
            return Math.floor((width + 11) / 12) * Math.floor((height + 9) / 10) * 16;
        case $9ddd7e9b53f7a2d4$export$18ab77abd087e467:
            return Math.floor((width + 11) / 12) * Math.floor((height + 11) / 12) * 16;
        // https://registry.khronos.org/webgl/extensions/EXT_texture_compression_bptc/
        case $9ddd7e9b53f7a2d4$export$ce40b115e188bc81:
        case $9ddd7e9b53f7a2d4$export$d279c5c4bac5121e:
        case $9ddd7e9b53f7a2d4$export$cde52d17225fdbd3:
            return Math.ceil(width / 4) * Math.ceil(height / 4) * 16;
        // https://registry.khronos.org/webgl/extensions/EXT_texture_compression_rgtc/
        case $9ddd7e9b53f7a2d4$export$b1688df4c4c21670:
        case $9ddd7e9b53f7a2d4$export$fc15e5d8261eed58:
            return Math.ceil(width / 4) * Math.ceil(height / 4) * 8;
        case $9ddd7e9b53f7a2d4$export$d220f6ade8463a0f:
        case $9ddd7e9b53f7a2d4$export$768646d09dc1b6ef:
            return Math.ceil(width / 4) * Math.ceil(height / 4) * 16;
    }
    throw new Error(`Unable to determine texture byte length for ${format} format.`);
}
function $9ddd7e9b53f7a2d4$var$getTextureTypeByteLength(type) {
    switch(type){
        case $9ddd7e9b53f7a2d4$export$2e8ce08d3f6f5e10:
        case $9ddd7e9b53f7a2d4$export$545fce0311a9796a:
            return {
                byteLength: 1,
                components: 1
            };
        case $9ddd7e9b53f7a2d4$export$c63dc51868b06a9d:
        case $9ddd7e9b53f7a2d4$export$88572337f312435f:
        case $9ddd7e9b53f7a2d4$export$2697304443f382bc:
            return {
                byteLength: 2,
                components: 1
            };
        case $9ddd7e9b53f7a2d4$export$b3969b01faf587f2:
        case $9ddd7e9b53f7a2d4$export$18886f8ae33e90de:
            return {
                byteLength: 2,
                components: 4
            };
        case $9ddd7e9b53f7a2d4$export$c3c7fc4518ebba96:
        case $9ddd7e9b53f7a2d4$export$5c612977753abe2:
        case $9ddd7e9b53f7a2d4$export$f6d331659b644596:
            return {
                byteLength: 4,
                components: 1
            };
        case $9ddd7e9b53f7a2d4$export$5a4c329b7e2092d3:
            return {
                byteLength: 4,
                components: 3
            };
    }
    throw new Error(`Unknown texture type ${type}.`);
}
/**
 * A class containing utility functions for textures.
 *
 * @hideconstructor
 */ class $9ddd7e9b53f7a2d4$export$ec276d39f33d4b7 {
    /**
	 * Scales the texture as large as possible within its surface without cropping
	 * or stretching the texture. The method preserves the original aspect ratio of
	 * the texture. Akin to CSS `object-fit: contain`
	 *
	 * @param {Texture} texture - The texture.
	 * @param {number} aspect - The texture's aspect ratio.
	 * @return {Texture} The updated texture.
	 */ static contain(texture, aspect) {
        return $9ddd7e9b53f7a2d4$var$contain(texture, aspect);
    }
    /**
	 * Scales the texture to the smallest possible size to fill the surface, leaving
	 * no empty space. The method preserves the original aspect ratio of the texture.
	 * Akin to CSS `object-fit: cover`.
	 *
	 * @param {Texture} texture - The texture.
	 * @param {number} aspect - The texture's aspect ratio.
	 * @return {Texture} The updated texture.
	 */ static cover(texture, aspect) {
        return $9ddd7e9b53f7a2d4$var$cover(texture, aspect);
    }
    /**
	 * Configures the texture to the default transformation. Akin to CSS `object-fit: fill`.
	 *
	 * @param {Texture} texture - The texture.
	 * @return {Texture} The updated texture.
	 */ static fill(texture) {
        return $9ddd7e9b53f7a2d4$var$fill(texture);
    }
    /**
	 * Determines how many bytes must be used to represent the texture.
	 *
	 * @param {number} width - The width of the texture.
	 * @param {number} height - The height of the texture.
	 * @param {number} format - The texture's format.
	 * @param {number} type - The texture's type.
	 * @return {number} The byte length.
	 */ static getByteLength(width, height, format, type) {
        return $9ddd7e9b53f7a2d4$export$cc8c3b705bb8e6e2(width, height, format, type);
    }
}
if (typeof __THREE_DEVTOOLS__ !== 'undefined') __THREE_DEVTOOLS__.dispatchEvent(new CustomEvent('register', {
    detail: {
        revision: $9ddd7e9b53f7a2d4$export$3545e07a80636437
    }
}));
if (typeof window !== 'undefined') {
    if (window.__THREE__) console.warn('WARNING: Multiple instances of Three.js being imported.');
    else window.__THREE__ = $9ddd7e9b53f7a2d4$export$3545e07a80636437;
}

});


parcelRegister("kzKe3", function(module, exports) {

$parcel$export(module.exports, "mercury", () => mercury);
$parcel$export(module.exports, "venus", () => venus);
$parcel$export(module.exports, "earth", () => earth);
$parcel$export(module.exports, "mars", () => mars);
$parcel$export(module.exports, "jupiter", () => jupiter);
$parcel$export(module.exports, "saturn", () => saturn);
$parcel$export(module.exports, "uranus", () => uranus);
$parcel$export(module.exports, "neptune", () => neptune);
$parcel$export(module.exports, "Elements", () => Elements);
$parcel$export(module.exports, "mean", () => mean);
$parcel$export(module.exports, "inc", () => inc);
$parcel$export(module.exports, "node", () => node);
$parcel$export(module.exports, "default", () => $efaaeefdb104c801$export$2e2bcd8739ae039);
/**
 * @copyright 2013 Sonia Keys
 * @copyright 2016 commenthol
 * @license MIT
 * @module planetelements
 */ /**
 * Planetelements: Chapter 31, Elements of Planetary Orbits.
 *
 * Partial:  Only implemented for mean equinox of date.
 */ 
var $9QpM5 = parcelRequire("9QpM5");
const mercury = 'mercury';
const venus = 'venus';
const earth = 'earth';
const mars = 'mars';
const jupiter = 'jupiter';
const saturn = 'saturn';
const uranus = 'uranus';
const neptune = 'neptune';
function Elements(lon, axis, ecc, inc, node, peri) {
    const o = typeof lon === 'object' ? lon : {};
    this.lon = o.lon || lon;
    this.axis = o.axis || axis;
    this.ecc = o.ecc || ecc;
    this.inc = o.inc || inc;
    this.node = o.node || node;
    this.peri = o.peri || peri;
}
/**
 * Table 31.A, p. 212
 */ const cMean = {
    mercury: {
        L: [
            252.250906,
            149474.0722491,
            0.0003035,
            0.000000018
        ],
        a: [
            0.38709831
        ],
        e: [
            0.20563175,
            0.000020407,
            -0.0000000283,
            -0.00000000018
        ],
        i: [
            7.004986,
            0.0018215,
            -0.0000181,
            0.000000056
        ],
        \u03A9: [
            48.330893,
            1.1861883,
            0.00017542,
            0.000000215
        ],
        \u03D6: [
            77.456119,
            1.5564776,
            0.00029544,
            0.000000009
        ]
    },
    venus: {
        L: [
            181.979801,
            58519.2130302,
            0.00031014,
            0.000000015
        ],
        a: [
            0.72332982
        ],
        e: [
            0.00677192,
            -0.000047765,
            0.0000000981,
            0.00000000046
        ],
        i: [
            3.394662,
            0.0010037,
            -0.00000088,
            -0.000000007
        ],
        \u03A9: [
            76.67992,
            0.9011206,
            0.00040618,
            -0.000000093
        ],
        \u03D6: [
            131.563703,
            1.4022288,
            -0.00107618,
            -0.000005678
        ]
    },
    earth: {
        L: [
            100.466457,
            36000.7698278,
            0.00030322,
            0.00000002
        ],
        a: [
            1.000001018
        ],
        e: [
            0.01670863,
            -0.000042037,
            -0.0000001267,
            0.00000000014
        ],
        i: [
            0
        ],
        \u03A9: undefined,
        \u03D6: [
            102.937348,
            1.7195366,
            0.00045688,
            -0.000000018
        ]
    },
    mars: {
        L: [
            355.433,
            19141.6964471,
            0.00031052,
            0.000000016
        ],
        a: [
            1.523679342
        ],
        e: [
            0.09340065,
            0.000090484,
            -0.0000000806,
            -0.00000000025
        ],
        i: [
            1.849726,
            -0.0006011,
            0.00001276,
            -0.000000007
        ],
        \u03A9: [
            49.558093,
            0.7720959,
            0.00001557,
            0.000002267
        ],
        \u03D6: [
            336.060234,
            1.8410449,
            0.00013477,
            0.000000536
        ]
    },
    jupiter: {
        L: [
            34.351519,
            3036.3027748,
            0.0002233,
            0.000000037
        ],
        a: [
            5.202603209,
            0.0000001913
        ],
        e: [
            0.04849793,
            0.000163225,
            -0.0000004714,
            -0.00000000201
        ],
        i: [
            1.303267,
            -0.0054965,
            0.00000466,
            -0.000000002
        ],
        \u03A9: [
            100.464407,
            1.0209774,
            0.00040315,
            0.000000404
        ],
        \u03D6: [
            14.331207,
            1.6126352,
            0.00103042,
            -0.000004464
        ]
    },
    saturn: {
        L: [
            50.077444,
            1223.5110686,
            0.00051908,
            -0.00000003
        ],
        a: [
            9.554909192,
            -0.000002139,
            0.000000004
        ],
        e: [
            0.05554814,
            -0.000346641,
            -0.0000006436,
            0.0000000034
        ],
        i: [
            2.488879,
            -0.0037362,
            -0.00001519,
            0.000000087
        ],
        \u03A9: [
            113.665503,
            0.877088,
            -0.00012176,
            -0.000002249
        ],
        \u03D6: [
            93.057237,
            1.9637613,
            0.00083753,
            0.000004928
        ]
    },
    uranus: {
        L: [
            314.055005,
            429.8640561,
            0.0003039,
            0.000000026
        ],
        a: [
            19.218446062,
            -0.0000000372,
            0.00000000098
        ],
        e: [
            0.04638122,
            -0.000027293,
            0.0000000789,
            0.00000000024
        ],
        i: [
            0.773197,
            0.0007744,
            0.00003749,
            -0.000000092
        ],
        \u03A9: [
            74.005957,
            0.5211278,
            0.00133947,
            0.000018484
        ],
        \u03D6: [
            173.005291,
            1.486379,
            0.00021406,
            0.000000434
        ]
    },
    neptune: {
        L: [
            304.348665,
            219.8833092,
            0.00030882,
            0.000000018
        ],
        a: [
            30.110386869,
            -0.0000001663,
            0.00000000069
        ],
        e: [
            0.00945575,
            0.000006033,
            0,
            -0.00000000005
        ],
        i: [
            1.769953,
            -0.0093082,
            -0.00000708,
            0.000000027
        ],
        \u03A9: [
            131.784057,
            1.1022039,
            0.00025952,
            -0.000000637
        ],
        \u03D6: [
            48.120276,
            1.4262957,
            0.00038434,
            0.00000002
        ]
    }
};
function mean(p, jde, e) {
    const T = (0, $9QpM5.default).J2000Century(jde);
    const c = cMean[p];
    e = e || new Elements();
    e.lon = (0, $9QpM5.default).pmod((0, $9QpM5.default).horner(T, c.L) * Math.PI / 180, 2 * Math.PI);
    e.axis = (0, $9QpM5.default).horner(T, c.a);
    e.ecc = (0, $9QpM5.default).horner(T, c.e);
    e.inc = (0, $9QpM5.default).horner(T, c.i) * Math.PI / 180;
    e.node = (0, $9QpM5.default).horner(T, c.\u03A9) * Math.PI / 180;
    e.peri = (0, $9QpM5.default).horner(T, c.\u03D6) * Math.PI / 180;
    return e;
}
function inc(p, jde) {
    return (0, $9QpM5.default).horner((0, $9QpM5.default).J2000Century(jde), cMean[p].i) * Math.PI / 180;
}
function node(p, jde) {
    return (0, $9QpM5.default).horner((0, $9QpM5.default).J2000Century(jde), cMean[p].\u03A9) * Math.PI / 180;
}
var $efaaeefdb104c801$export$2e2bcd8739ae039 = {
    mercury: mercury,
    venus: venus,
    earth: earth,
    mars: mars,
    jupiter: jupiter,
    saturn: saturn,
    uranus: uranus,
    neptune: neptune,
    Elements: Elements,
    mean: mean,
    inc: inc,
    node: node
};

});
parcelRegister("9QpM5", function(module, exports) {

$parcel$export(module.exports, "Coord", () => $72acf6b008689fe8$export$5e2392d12cf9f46);
$parcel$export(module.exports, "default", () => $72acf6b008689fe8$export$2e2bcd8739ae039);
/**
 * @copyright 2013 Sonia Keys
 * @copyright 2016 commenthol
 * @license MIT
 * @module base
 */ /**
 * Base: Functions and other definitions useful with multiple packages.
 *
 * Base contains various definitions and support functions useful in multiple
 * chapters.
 *
 * Bessellian and Julian Year
 *
 * Chapter 21, Precession actually contains these definitions.  They are moved
 * here because of their general utility.
 *
 * Chapter 22, Nutation contains the function for Julian centuries since J2000.
 *
 * Phase angle functions
 *
 * Two functions, Illuminated and Limb, concern the illumnated phase of a body
 * and are given in two chapters, 41 an 48.  They are collected here because
 * the identical functions apply in both chapters.
 *
 * General purpose math functions
 *
 * SmallAngle is recommended in chapter 17, p. 109.
 *
 * PMod addresses the issue on p. 7, chapter 1, in the section "Trigonometric
 * functions of large angles", but the function is not written to be specific
 * to angles and so has more general utility.
 *
 * Horner is described on p. 10, chapter 1.
 *
 * FloorDiv and FloorDiv64 are optimizations for the INT function described
 * on p. 60, chapter 7.
*/ // ---- constants ----
/** K is the Gaussian gravitational constant. */ const $72acf6b008689fe8$export$3466f893ebf79586 = 0.01720209895;
const $72acf6b008689fe8$export$24f205cbfb89b8fc = 149597870;
const $72acf6b008689fe8$export$f7acd2a40d6a13bd = 0.397777156;
const $72acf6b008689fe8$export$d570688739ed4128 = 0.917482062;
function $72acf6b008689fe8$export$c1a4ae6b46262f0e(dist) {
    // Formula given as (33.3) p. 224.
    return 0.0057755183 * dist;
}
const $72acf6b008689fe8$export$168959b554a3f78e = 2400000.5;
const $72acf6b008689fe8$export$c5c105c0e77e09aa = 2451545.0;
const $72acf6b008689fe8$export$d93f78abac12623f = 2415020.0;
const $72acf6b008689fe8$export$69580e712078f3cb = 2415020.3135;
const $72acf6b008689fe8$export$b03193476f44b171 = 2433282.4235;
const $72acf6b008689fe8$export$f08341e38af102b5 = 365.25 // days
;
const $72acf6b008689fe8$export$75e19ff60a6c8ea5 = 36525 // days
;
const $72acf6b008689fe8$export$c27ffb6618ac0e9f = 365.2421988 // days
;
const $72acf6b008689fe8$export$a6d1f2eb2ba48ea7 = 365.25636 // days
;
function $72acf6b008689fe8$export$cccc52840a15a6e7(jy) {
    return $72acf6b008689fe8$export$c5c105c0e77e09aa + $72acf6b008689fe8$export$f08341e38af102b5 * (jy - 2000);
}
function $72acf6b008689fe8$export$f629cf913cb18281(jde) {
    return 2000 + (jde - $72acf6b008689fe8$export$c5c105c0e77e09aa) / $72acf6b008689fe8$export$f08341e38af102b5;
}
function $72acf6b008689fe8$export$9ba0d6c5cdcf7559(by) {
    return $72acf6b008689fe8$export$69580e712078f3cb + $72acf6b008689fe8$export$c27ffb6618ac0e9f * (by - 1900);
}
function $72acf6b008689fe8$export$cdef6414cb680e8c(jde) {
    return 1900 + (jde - $72acf6b008689fe8$export$69580e712078f3cb) / $72acf6b008689fe8$export$c27ffb6618ac0e9f;
}
function $72acf6b008689fe8$export$f32f2f16f747a5(jde) {
    // The formula is given in a number of places in the book, for example
    // (12.1) p. 87.
    // (22.1) p. 143.
    // (25.1) p. 163.
    return (jde - $72acf6b008689fe8$export$c5c105c0e77e09aa) / $72acf6b008689fe8$export$75e19ff60a6c8ea5;
}
function $72acf6b008689fe8$export$4a6fcde1d8ff2d31(i) {
    // (41.1) p. 283, also (48.1) p. 345.
    return (1 + Math.cos(i)) * 0.5;
}
class $72acf6b008689fe8$export$5e2392d12cf9f46 {
    /**
   * celestial coordinates in right ascension and declination
   * or ecliptic coordinates in longitude and latitude
   *
   * @param {number} ra - right ascension (or longitude)
   * @param {number} dec - declination (or latitude)
   * @param {number} [range] - distance
   * @param {number} [elongation] - elongation
   */ constructor(ra, dec, range, elongation){
        this._ra = ra || 0;
        this._dec = dec || 0;
        this.range = range;
        this.elongation = elongation;
    }
    /**
   * right ascension
   * @return {number}
   */ get ra() {
        return this._ra;
    }
    set ra(ra) {
        this._ra = ra;
    }
    /**
   * declination
   * @return {number}
   */ get dec() {
        return this._dec;
    }
    set dec(dec) {
        this._dec = dec;
    }
    /**
   * right ascension (or longitude)
   * @return {number}
   */ get lon() {
        return this._ra;
    }
    set lon(ra) {
        this._ra = ra;
    }
    /**
   * declination (or latitude)
   * @return {number}
   */ get lat() {
        return this._dec;
    }
    set lat(dec) {
        this._dec = dec;
    }
}
function $72acf6b008689fe8$export$f8cec6e8c6d00437(equ, appSun) {
    const \u03B1 = equ.ra;
    const \u03B4 = equ.dec;
    const \u03B10 = appSun.ra;
    const \u03B40 = appSun.dec;
    // Mentioned in ch 41, p. 283.  Formula (48.5) p. 346
    const s\u03B4 = Math.sin(\u03B4);
    const c\u03B4 = Math.cos(\u03B4);
    const s\u03B40 = Math.sin(\u03B40);
    const c\u03B40 = Math.cos(\u03B40);
    const s\u03B10\u03B1 = Math.sin(\u03B10 - \u03B1);
    const c\u03B10\u03B1 = Math.cos(\u03B10 - \u03B1);
    let \u03C7 = Math.atan2(c\u03B40 * s\u03B10\u03B1, s\u03B40 * c\u03B4 - c\u03B40 * s\u03B4 * c\u03B10\u03B1);
    if (\u03C7 < 0) \u03C7 += 2 * Math.PI;
    return \u03C7;
}
const $72acf6b008689fe8$export$bc327092d749df2b = 10 * Math.PI / 180 / 60 // about .003 radians
;
const $72acf6b008689fe8$export$9100407c79c8a236 = Math.cos($72acf6b008689fe8$export$bc327092d749df2b) // about .999996
;
function $72acf6b008689fe8$export$7aeecd5e25056787(x, y) {
    let r = x % y;
    if (r < 0) r += y;
    return r;
}
function $72acf6b008689fe8$export$14a0be257559f4c3(x, ...c) {
    if (Array.isArray(c[0])) c = c[0];
    let i = c.length - 1;
    let y = c[i];
    while(i > 0){
        i--;
        y = y * x + c[i];
    }
    return y;
}
function $72acf6b008689fe8$export$112397bc52715a8(x, y) {
    const q = x / y;
    return Math.floor(q);
}
function $72acf6b008689fe8$export$6154dcdb7d23e37b(a, b) {
    if (a < b) return -1;
    if (a > b) return 1;
    return 0;
}
function $72acf6b008689fe8$export$7d5e3328550ce0cd(\u03B5) {
    return [
        Math.sin(\u03B5),
        Math.cos(\u03B5)
    ];
}
function $72acf6b008689fe8$export$8cca2b44d6a11240(deg) {
    return Math.PI / 180.0 * deg;
}
function $72acf6b008689fe8$export$21c41b81d811632c(rad) {
    return 180.0 / Math.PI * rad;
}
function $72acf6b008689fe8$export$bdda1f937f5ab9ee(float) {
    const i = Math.trunc(float);
    const f = Math.abs(float - i);
    return [
        i,
        f
    ];
}
function $72acf6b008689fe8$export$2077e0241d6afd3c(float, precision = 14) {
    return parseFloat(float.toFixed(precision));
}
function $72acf6b008689fe8$export$dbfe74f291058e97(msg, code) {
    const err = new Error(msg);
    // @ts-ignore
    err.code = code;
    return err;
}
var $72acf6b008689fe8$export$2e2bcd8739ae039 = {
    K: $72acf6b008689fe8$export$3466f893ebf79586,
    AU: $72acf6b008689fe8$export$24f205cbfb89b8fc,
    SOblJ2000: $72acf6b008689fe8$export$f7acd2a40d6a13bd,
    COblJ2000: $72acf6b008689fe8$export$d570688739ed4128,
    lightTime: $72acf6b008689fe8$export$c1a4ae6b46262f0e,
    JMod: $72acf6b008689fe8$export$168959b554a3f78e,
    J2000: $72acf6b008689fe8$export$c5c105c0e77e09aa,
    J1900: $72acf6b008689fe8$export$d93f78abac12623f,
    B1900: $72acf6b008689fe8$export$69580e712078f3cb,
    B1950: $72acf6b008689fe8$export$b03193476f44b171,
    JulianYear: $72acf6b008689fe8$export$f08341e38af102b5,
    JulianCentury: $72acf6b008689fe8$export$75e19ff60a6c8ea5,
    BesselianYear: $72acf6b008689fe8$export$c27ffb6618ac0e9f,
    meanSiderealYear: $72acf6b008689fe8$export$a6d1f2eb2ba48ea7,
    JulianYearToJDE: $72acf6b008689fe8$export$cccc52840a15a6e7,
    JDEToJulianYear: $72acf6b008689fe8$export$f629cf913cb18281,
    BesselianYearToJDE: $72acf6b008689fe8$export$9ba0d6c5cdcf7559,
    JDEToBesselianYear: $72acf6b008689fe8$export$cdef6414cb680e8c,
    J2000Century: $72acf6b008689fe8$export$f32f2f16f747a5,
    illuminated: $72acf6b008689fe8$export$4a6fcde1d8ff2d31,
    Coord: $72acf6b008689fe8$export$5e2392d12cf9f46,
    limb: $72acf6b008689fe8$export$f8cec6e8c6d00437,
    SmallAngle: $72acf6b008689fe8$export$bc327092d749df2b,
    CosSmallAngle: $72acf6b008689fe8$export$9100407c79c8a236,
    pmod: $72acf6b008689fe8$export$7aeecd5e25056787,
    horner: $72acf6b008689fe8$export$14a0be257559f4c3,
    floorDiv: $72acf6b008689fe8$export$112397bc52715a8,
    cmp: $72acf6b008689fe8$export$6154dcdb7d23e37b,
    sincos: $72acf6b008689fe8$export$7d5e3328550ce0cd,
    toRad: $72acf6b008689fe8$export$8cca2b44d6a11240,
    toDeg: $72acf6b008689fe8$export$21c41b81d811632c,
    modf: $72acf6b008689fe8$export$bdda1f937f5ab9ee,
    round: $72acf6b008689fe8$export$2077e0241d6afd3c,
    errorCode: $72acf6b008689fe8$export$dbfe74f291058e97
};

});


parcelRegister("2Tywo", function(module, exports) {

$parcel$export(module.exports, "_config", () => _config);
$parcel$export(module.exports, "_isString", () => _isString);
$parcel$export(module.exports, "_isUndefined", () => _isUndefined);
$parcel$export(module.exports, "_numExp", () => _numExp);
$parcel$export(module.exports, "_numWithUnitExp", () => _numWithUnitExp);
$parcel$export(module.exports, "_relExp", () => _relExp);
$parcel$export(module.exports, "gsap", () => gsap);
$parcel$export(module.exports, "_missingPlugin", () => _missingPlugin);
$parcel$export(module.exports, "_plugins", () => _plugins);
$parcel$export(module.exports, "GSCache", () => GSCache);
$parcel$export(module.exports, "_getCache", () => _getCache);
$parcel$export(module.exports, "_getProperty", () => _getProperty);
$parcel$export(module.exports, "_forEachName", () => _forEachName);
$parcel$export(module.exports, "_round", () => _round);
$parcel$export(module.exports, "_parseRelative", () => _parseRelative);
$parcel$export(module.exports, "_ticker", () => _ticker);
$parcel$export(module.exports, "getUnit", () => getUnit);
$parcel$export(module.exports, "_replaceRandom", () => _replaceRandom);
$parcel$export(module.exports, "_getSetter", () => _getSetter);
$parcel$export(module.exports, "PropTween", () => PropTween);
$parcel$export(module.exports, "_colorExp", () => _colorExp);
$parcel$export(module.exports, "_colorStringFilter", () => _colorStringFilter);
$parcel$export(module.exports, "_renderComplexString", () => _renderComplexString);
$parcel$export(module.exports, "_checkPlugin", () => _checkPlugin);
$parcel$export(module.exports, "_sortPropTweensByPriority", () => _sortPropTweensByPriority);
function _assertThisInitialized(self) {
    if (self === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return self;
}
function _inheritsLoose(subClass, superClass) {
    subClass.prototype = Object.create(superClass.prototype);
    subClass.prototype.constructor = subClass;
    subClass.__proto__ = superClass;
}
/*!
 * GSAP 3.12.7
 * https://gsap.com
 *
 * @license Copyright 2008-2025, GreenSock. All rights reserved.
 * Subject to the terms at https://gsap.com/standard-license or for
 * Club GSAP members, the agreement issued with that membership.
 * @author: Jack Doyle, jack@greensock.com
*/ /* eslint-disable */ var _config = {
    autoSleep: 120,
    force3D: "auto",
    nullTargetWarn: 1,
    units: {
        lineHeight: ""
    }
}, _defaults = {
    duration: .5,
    overwrite: false,
    delay: 0
}, _suppressOverwrites, _reverting, _context, _bigNum = 1e8, _tinyNum = 1 / _bigNum, _2PI = Math.PI * 2, _HALF_PI = _2PI / 4, _gsID = 0, _sqrt = Math.sqrt, _cos = Math.cos, _sin = Math.sin, _isString = function _isString(value) {
    return typeof value === "string";
}, _isFunction = function _isFunction(value) {
    return typeof value === "function";
}, _isNumber = function _isNumber(value) {
    return typeof value === "number";
}, _isUndefined = function _isUndefined(value) {
    return typeof value === "undefined";
}, _isObject = function _isObject(value) {
    return typeof value === "object";
}, _isNotFalse = function _isNotFalse(value) {
    return value !== false;
}, _windowExists = function _windowExists() {
    return typeof window !== "undefined";
}, _isFuncOrString = function _isFuncOrString(value) {
    return _isFunction(value) || _isString(value);
}, _isTypedArray = typeof ArrayBuffer === "function" && ArrayBuffer.isView || function() {}, // note: IE10 has ArrayBuffer, but NOT ArrayBuffer.isView().
_isArray = Array.isArray, _strictNumExp = /(?:-?\.?\d|\.)+/gi, //only numbers (including negatives and decimals) but NOT relative values.
_numExp = /[-+=.]*\d+[.e\-+]*\d*[e\-+]*\d*/g, //finds any numbers, including ones that start with += or -=, negative numbers, and ones in scientific notation like 1e-8.
_numWithUnitExp = /[-+=.]*\d+[.e-]*\d*[a-z%]*/g, _complexStringNumExp = /[-+=.]*\d+\.?\d*(?:e-|e\+)?\d*/gi, //duplicate so that while we're looping through matches from exec(), it doesn't contaminate the lastIndex of _numExp which we use to search for colors too.
_relExp = /[+-]=-?[.\d]+/, _delimitedValueExp = /[^,'"\[\]\s]+/gi, // previously /[#\-+.]*\b[a-z\d\-=+%.]+/gi but didn't catch special characters.
_unitExp = /^[+\-=e\s\d]*\d+[.\d]*([a-z]*|%)\s*$/i, _globalTimeline, _win, _coreInitted, _doc, _globals = {}, _installScope = {}, _coreReady, _install = function _install(scope) {
    return (_installScope = _merge(scope, _globals)) && gsap;
}, _missingPlugin = function _missingPlugin(property, value) {
    return console.warn("Invalid property", property, "set to", value, "Missing plugin? gsap.registerPlugin()");
}, _warn = function _warn(message, suppress) {
    return !suppress && console.warn(message);
}, _addGlobal = function _addGlobal(name, obj) {
    return name && (_globals[name] = obj) && _installScope && (_installScope[name] = obj) || _globals;
}, _emptyFunc = function _emptyFunc() {
    return 0;
}, _startAtRevertConfig = {
    suppressEvents: true,
    isStart: true,
    kill: false
}, _revertConfigNoKill = {
    suppressEvents: true,
    kill: false
}, _revertConfig = {
    suppressEvents: true
}, _reservedProps = {}, _lazyTweens = [], _lazyLookup = {}, _lastRenderedFrame, _plugins = {}, _effects = {}, _nextGCFrame = 30, _harnessPlugins = [], _callbackNames = "", _harness = function _harness(targets) {
    var target = targets[0], harnessPlugin, i;
    _isObject(target) || _isFunction(target) || (targets = [
        targets
    ]);
    if (!(harnessPlugin = (target._gsap || {}).harness)) {
        // find the first target with a harness. We assume targets passed into an animation will be of similar type, meaning the same kind of harness can be used for them all (performance optimization)
        i = _harnessPlugins.length;
        while(i-- && !_harnessPlugins[i].targetTest(target));
        harnessPlugin = _harnessPlugins[i];
    }
    i = targets.length;
    while(i--)targets[i] && (targets[i]._gsap || (targets[i]._gsap = new GSCache(targets[i], harnessPlugin))) || targets.splice(i, 1);
    return targets;
}, _getCache = function _getCache(target) {
    return target._gsap || _harness(toArray(target))[0]._gsap;
}, _getProperty = function _getProperty(target, property, v) {
    return (v = target[property]) && _isFunction(v) ? target[property]() : _isUndefined(v) && target.getAttribute && target.getAttribute(property) || v;
}, _forEachName = function _forEachName(names, func) {
    return (names = names.split(",")).forEach(func) || names;
}, //split a comma-delimited list of names into an array, then run a forEach() function and return the split array (this is just a way to consolidate/shorten some code).
_round = function _round(value) {
    return Math.round(value * 100000) / 100000 || 0;
}, _roundPrecise = function _roundPrecise(value) {
    return Math.round(value * 10000000) / 10000000 || 0;
}, // increased precision mostly for timing values.
_parseRelative = function _parseRelative(start, value) {
    var operator = value.charAt(0), end = parseFloat(value.substr(2));
    start = parseFloat(start);
    return operator === "+" ? start + end : operator === "-" ? start - end : operator === "*" ? start * end : start / end;
}, _arrayContainsAny = function _arrayContainsAny(toSearch, toFind) {
    //searches one array to find matches for any of the items in the toFind array. As soon as one is found, it returns true. It does NOT return all the matches; it's simply a boolean search.
    var l = toFind.length, i = 0;
    for(; toSearch.indexOf(toFind[i]) < 0 && ++i < l;);
    return i < l;
}, _lazyRender = function _lazyRender() {
    var l = _lazyTweens.length, a = _lazyTweens.slice(0), i, tween;
    _lazyLookup = {};
    _lazyTweens.length = 0;
    for(i = 0; i < l; i++){
        tween = a[i];
        tween && tween._lazy && (tween.render(tween._lazy[0], tween._lazy[1], true)._lazy = 0);
    }
}, _lazySafeRender = function _lazySafeRender(animation, time, suppressEvents, force) {
    _lazyTweens.length && !_reverting && _lazyRender();
    animation.render(time, suppressEvents, force || _reverting && time < 0 && (animation._initted || animation._startAt));
    _lazyTweens.length && !_reverting && _lazyRender(); //in case rendering caused any tweens to lazy-init, we should render them because typically when someone calls seek() or time() or progress(), they expect an immediate render.
}, _numericIfPossible = function _numericIfPossible(value) {
    var n = parseFloat(value);
    return (n || n === 0) && (value + "").match(_delimitedValueExp).length < 2 ? n : _isString(value) ? value.trim() : value;
}, _passThrough = function _passThrough(p) {
    return p;
}, _setDefaults = function _setDefaults(obj, defaults) {
    for(var p in defaults)p in obj || (obj[p] = defaults[p]);
    return obj;
}, _setKeyframeDefaults = function _setKeyframeDefaults(excludeDuration) {
    return function(obj, defaults) {
        for(var p in defaults)p in obj || p === "duration" && excludeDuration || p === "ease" || (obj[p] = defaults[p]);
    };
}, _merge = function _merge(base, toMerge) {
    for(var p in toMerge)base[p] = toMerge[p];
    return base;
}, _mergeDeep = function _mergeDeep(base, toMerge) {
    for(var p in toMerge)p !== "__proto__" && p !== "constructor" && p !== "prototype" && (base[p] = _isObject(toMerge[p]) ? _mergeDeep(base[p] || (base[p] = {}), toMerge[p]) : toMerge[p]);
    return base;
}, _copyExcluding = function _copyExcluding(obj, excluding) {
    var copy = {}, p;
    for(p in obj)p in excluding || (copy[p] = obj[p]);
    return copy;
}, _inheritDefaults = function _inheritDefaults(vars) {
    var parent = vars.parent || _globalTimeline, func = vars.keyframes ? _setKeyframeDefaults(_isArray(vars.keyframes)) : _setDefaults;
    if (_isNotFalse(vars.inherit)) while(parent){
        func(vars, parent.vars.defaults);
        parent = parent.parent || parent._dp;
    }
    return vars;
}, _arraysMatch = function _arraysMatch(a1, a2) {
    var i = a1.length, match = i === a2.length;
    while(match && i-- && a1[i] === a2[i]);
    return i < 0;
}, _addLinkedListItem = function _addLinkedListItem(parent, child, firstProp, lastProp, sortBy) {
    if (firstProp === void 0) firstProp = "_first";
    if (lastProp === void 0) lastProp = "_last";
    var prev = parent[lastProp], t;
    if (sortBy) {
        t = child[sortBy];
        while(prev && prev[sortBy] > t)prev = prev._prev;
    }
    if (prev) {
        child._next = prev._next;
        prev._next = child;
    } else {
        child._next = parent[firstProp];
        parent[firstProp] = child;
    }
    if (child._next) child._next._prev = child;
    else parent[lastProp] = child;
    child._prev = prev;
    child.parent = child._dp = parent;
    return child;
}, _removeLinkedListItem = function _removeLinkedListItem(parent, child, firstProp, lastProp) {
    if (firstProp === void 0) firstProp = "_first";
    if (lastProp === void 0) lastProp = "_last";
    var prev = child._prev, next = child._next;
    if (prev) prev._next = next;
    else if (parent[firstProp] === child) parent[firstProp] = next;
    if (next) next._prev = prev;
    else if (parent[lastProp] === child) parent[lastProp] = prev;
    child._next = child._prev = child.parent = null; // don't delete the _dp just so we can revert if necessary. But parent should be null to indicate the item isn't in a linked list.
}, _removeFromParent = function _removeFromParent(child, onlyIfParentHasAutoRemove) {
    child.parent && (!onlyIfParentHasAutoRemove || child.parent.autoRemoveChildren) && child.parent.remove && child.parent.remove(child);
    child._act = 0;
}, _uncache = function _uncache(animation, child) {
    if (animation && (!child || child._end > animation._dur || child._start < 0)) {
        // performance optimization: if a child animation is passed in we should only uncache if that child EXTENDS the animation (its end time is beyond the end)
        var a = animation;
        while(a){
            a._dirty = 1;
            a = a.parent;
        }
    }
    return animation;
}, _recacheAncestors = function _recacheAncestors(animation) {
    var parent = animation.parent;
    while(parent && parent.parent){
        //sometimes we must force a re-sort of all children and update the duration/totalDuration of all ancestor timelines immediately in case, for example, in the middle of a render loop, one tween alters another tween's timeScale which shoves its startTime before 0, forcing the parent timeline to shift around and shiftChildren() which could affect that next tween's render (startTime). Doesn't matter for the root timeline though.
        parent._dirty = 1;
        parent.totalDuration();
        parent = parent.parent;
    }
    return animation;
}, _rewindStartAt = function _rewindStartAt(tween, totalTime, suppressEvents, force) {
    return tween._startAt && (_reverting ? tween._startAt.revert(_revertConfigNoKill) : tween.vars.immediateRender && !tween.vars.autoRevert || tween._startAt.render(totalTime, true, force));
}, _hasNoPausedAncestors = function _hasNoPausedAncestors(animation) {
    return !animation || animation._ts && _hasNoPausedAncestors(animation.parent);
}, _elapsedCycleDuration = function _elapsedCycleDuration(animation) {
    return animation._repeat ? _animationCycle(animation._tTime, animation = animation.duration() + animation._rDelay) * animation : 0;
}, // feed in the totalTime and cycleDuration and it'll return the cycle (iteration minus 1) and if the playhead is exactly at the very END, it will NOT bump up to the next cycle.
_animationCycle = function _animationCycle(tTime, cycleDuration) {
    var whole = Math.floor(tTime = _roundPrecise(tTime / cycleDuration));
    return tTime && whole === tTime ? whole - 1 : whole;
}, _parentToChildTotalTime = function _parentToChildTotalTime(parentTime, child) {
    return (parentTime - child._start) * child._ts + (child._ts >= 0 ? 0 : child._dirty ? child.totalDuration() : child._tDur);
}, _setEnd = function _setEnd(animation) {
    return animation._end = _roundPrecise(animation._start + (animation._tDur / Math.abs(animation._ts || animation._rts || _tinyNum) || 0));
}, _alignPlayhead = function _alignPlayhead(animation, totalTime) {
    // adjusts the animation's _start and _end according to the provided totalTime (only if the parent's smoothChildTiming is true and the animation isn't paused). It doesn't do any rendering or forcing things back into parent timelines, etc. - that's what totalTime() is for.
    var parent = animation._dp;
    if (parent && parent.smoothChildTiming && animation._ts) {
        animation._start = _roundPrecise(parent._time - (animation._ts > 0 ? totalTime / animation._ts : ((animation._dirty ? animation.totalDuration() : animation._tDur) - totalTime) / -animation._ts));
        _setEnd(animation);
        parent._dirty || _uncache(parent, animation); //for performance improvement. If the parent's cache is already dirty, it already took care of marking the ancestors as dirty too, so skip the function call here.
    }
    return animation;
}, /*
_totalTimeToTime = (clampedTotalTime, duration, repeat, repeatDelay, yoyo) => {
	let cycleDuration = duration + repeatDelay,
		time = _round(clampedTotalTime % cycleDuration);
	if (time > duration) {
		time = duration;
	}
	return (yoyo && (~~(clampedTotalTime / cycleDuration) & 1)) ? duration - time : time;
},
*/ _postAddChecks = function _postAddChecks(timeline, child) {
    var t;
    if (child._time || !child._dur && child._initted || child._start < timeline._time && (child._dur || !child.add)) {
        // in case, for example, the _start is moved on a tween that has already rendered, or if it's being inserted into a timeline BEFORE where the playhead is currently. Imagine it's at its end state, then the startTime is moved WAY later (after the end of this timeline), it should render at its beginning. Special case: if it's a timeline (has .add() method) and no duration, we can skip rendering because the user may be populating it AFTER adding it to a parent timeline (unconventional, but possible, and we wouldn't want it to get removed if the parent's autoRemoveChildren is true).
        t = _parentToChildTotalTime(timeline.rawTime(), child);
        if (!child._dur || _clamp(0, child.totalDuration(), t) - child._tTime > _tinyNum) child.render(t, true);
    } //if the timeline has already ended but the inserted tween/timeline extends the duration, we should enable this timeline again so that it renders properly. We should also align the playhead with the parent timeline's when appropriate.
    if (_uncache(timeline, child)._dp && timeline._initted && timeline._time >= timeline._dur && timeline._ts) {
        //in case any of the ancestors had completed but should now be enabled...
        if (timeline._dur < timeline.duration()) {
            t = timeline;
            while(t._dp){
                t.rawTime() >= 0 && t.totalTime(t._tTime); //moves the timeline (shifts its startTime) if necessary, and also enables it. If it's currently zero, though, it may not be scheduled to render until later so there's no need to force it to align with the current playhead position. Only move to catch up with the playhead.
                t = t._dp;
            }
        }
        timeline._zTime = -_tinyNum; // helps ensure that the next render() will be forced (crossingStart = true in render()), even if the duration hasn't changed (we're adding a child which would need to get rendered). Definitely an edge case. Note: we MUST do this AFTER the loop above where the totalTime() might trigger a render() because this _addToTimeline() method gets called from the Animation constructor, BEFORE tweens even record their targets, etc. so we wouldn't want things to get triggered in the wrong order.
    }
}, _addToTimeline = function _addToTimeline(timeline, child, position, skipChecks) {
    child.parent && _removeFromParent(child);
    child._start = _roundPrecise((_isNumber(position) ? position : position || timeline !== _globalTimeline ? _parsePosition(timeline, position, child) : timeline._time) + child._delay);
    child._end = _roundPrecise(child._start + (child.totalDuration() / Math.abs(child.timeScale()) || 0));
    _addLinkedListItem(timeline, child, "_first", "_last", timeline._sort ? "_start" : 0);
    _isFromOrFromStart(child) || (timeline._recent = child);
    skipChecks || _postAddChecks(timeline, child);
    timeline._ts < 0 && _alignPlayhead(timeline, timeline._tTime); // if the timeline is reversed and the new child makes it longer, we may need to adjust the parent's _start (push it back)
    return timeline;
}, _scrollTrigger = function _scrollTrigger(animation, trigger) {
    return (_globals.ScrollTrigger || _missingPlugin("scrollTrigger", trigger)) && _globals.ScrollTrigger.create(trigger, animation);
}, _attemptInitTween = function _attemptInitTween(tween, time, force, suppressEvents, tTime) {
    _initTween(tween, time, tTime);
    if (!tween._initted) return 1;
    if (!force && tween._pt && !_reverting && (tween._dur && tween.vars.lazy !== false || !tween._dur && tween.vars.lazy) && _lastRenderedFrame !== _ticker.frame) {
        _lazyTweens.push(tween);
        tween._lazy = [
            tTime,
            suppressEvents
        ];
        return 1;
    }
}, _parentPlayheadIsBeforeStart = function _parentPlayheadIsBeforeStart(_ref) {
    var parent = _ref.parent;
    return parent && parent._ts && parent._initted && !parent._lock && (parent.rawTime() < 0 || _parentPlayheadIsBeforeStart(parent));
}, // check parent's _lock because when a timeline repeats/yoyos and does its artificial wrapping, we shouldn't force the ratio back to 0
_isFromOrFromStart = function _isFromOrFromStart(_ref2) {
    var data = _ref2.data;
    return data === "isFromStart" || data === "isStart";
}, _renderZeroDurationTween = function _renderZeroDurationTween(tween, totalTime, suppressEvents, force) {
    var prevRatio = tween.ratio, ratio = totalTime < 0 || !totalTime && (!tween._start && _parentPlayheadIsBeforeStart(tween) && !(!tween._initted && _isFromOrFromStart(tween)) || (tween._ts < 0 || tween._dp._ts < 0) && !_isFromOrFromStart(tween)) ? 0 : 1, // if the tween or its parent is reversed and the totalTime is 0, we should go to a ratio of 0. Edge case: if a from() or fromTo() stagger tween is placed later in a timeline, the "startAt" zero-duration tween could initially render at a time when the parent timeline's playhead is technically BEFORE where this tween is, so make sure that any "from" and "fromTo" startAt tweens are rendered the first time at a ratio of 1.
    repeatDelay = tween._rDelay, tTime = 0, pt, iteration, prevIteration;
    if (repeatDelay && tween._repeat) {
        // in case there's a zero-duration tween that has a repeat with a repeatDelay
        tTime = _clamp(0, tween._tDur, totalTime);
        iteration = _animationCycle(tTime, repeatDelay);
        tween._yoyo && iteration & 1 && (ratio = 1 - ratio);
        if (iteration !== _animationCycle(tween._tTime, repeatDelay)) {
            // if iteration changed
            prevRatio = 1 - ratio;
            tween.vars.repeatRefresh && tween._initted && tween.invalidate();
        }
    }
    if (ratio !== prevRatio || _reverting || force || tween._zTime === _tinyNum || !totalTime && tween._zTime) {
        if (!tween._initted && _attemptInitTween(tween, totalTime, force, suppressEvents, tTime)) // if we render the very beginning (time == 0) of a fromTo(), we must force the render (normal tweens wouldn't need to render at a time of 0 when the prevTime was also 0). This is also mandatory to make sure overwriting kicks in immediately.
        return;
        prevIteration = tween._zTime;
        tween._zTime = totalTime || (suppressEvents ? _tinyNum : 0); // when the playhead arrives at EXACTLY time 0 (right on top) of a zero-duration tween, we need to discern if events are suppressed so that when the playhead moves again (next time), it'll trigger the callback. If events are NOT suppressed, obviously the callback would be triggered in this render. Basically, the callback should fire either when the playhead ARRIVES or LEAVES this exact spot, not both. Imagine doing a timeline.seek(0) and there's a callback that sits at 0. Since events are suppressed on that seek() by default, nothing will fire, but when the playhead moves off of that position, the callback should fire. This behavior is what people intuitively expect.
        suppressEvents || (suppressEvents = totalTime && !prevIteration); // if it was rendered previously at exactly 0 (_zTime) and now the playhead is moving away, DON'T fire callbacks otherwise they'll seem like duplicates.
        tween.ratio = ratio;
        tween._from && (ratio = 1 - ratio);
        tween._time = 0;
        tween._tTime = tTime;
        pt = tween._pt;
        while(pt){
            pt.r(ratio, pt.d);
            pt = pt._next;
        }
        totalTime < 0 && _rewindStartAt(tween, totalTime, suppressEvents, true);
        tween._onUpdate && !suppressEvents && _callback(tween, "onUpdate");
        tTime && tween._repeat && !suppressEvents && tween.parent && _callback(tween, "onRepeat");
        if ((totalTime >= tween._tDur || totalTime < 0) && tween.ratio === ratio) {
            ratio && _removeFromParent(tween, 1);
            if (!suppressEvents && !_reverting) {
                _callback(tween, ratio ? "onComplete" : "onReverseComplete", true);
                tween._prom && tween._prom();
            }
        }
    } else if (!tween._zTime) tween._zTime = totalTime;
}, _findNextPauseTween = function _findNextPauseTween(animation, prevTime, time) {
    var child;
    if (time > prevTime) {
        child = animation._first;
        while(child && child._start <= time){
            if (child.data === "isPause" && child._start > prevTime) return child;
            child = child._next;
        }
    } else {
        child = animation._last;
        while(child && child._start >= time){
            if (child.data === "isPause" && child._start < prevTime) return child;
            child = child._prev;
        }
    }
}, _setDuration = function _setDuration(animation, duration, skipUncache, leavePlayhead) {
    var repeat = animation._repeat, dur = _roundPrecise(duration) || 0, totalProgress = animation._tTime / animation._tDur;
    totalProgress && !leavePlayhead && (animation._time *= dur / animation._dur);
    animation._dur = dur;
    animation._tDur = !repeat ? dur : repeat < 0 ? 1e10 : _roundPrecise(dur * (repeat + 1) + animation._rDelay * repeat);
    totalProgress > 0 && !leavePlayhead && _alignPlayhead(animation, animation._tTime = animation._tDur * totalProgress);
    animation.parent && _setEnd(animation);
    skipUncache || _uncache(animation.parent, animation);
    return animation;
}, _onUpdateTotalDuration = function _onUpdateTotalDuration(animation) {
    return animation instanceof Timeline ? _uncache(animation) : _setDuration(animation, animation._dur);
}, _zeroPosition = {
    _start: 0,
    endTime: _emptyFunc,
    totalDuration: _emptyFunc
}, _parsePosition = function _parsePosition(animation, position, percentAnimation) {
    var labels = animation.labels, recent = animation._recent || _zeroPosition, clippedDuration = animation.duration() >= _bigNum ? recent.endTime(false) : animation._dur, //in case there's a child that infinitely repeats, users almost never intend for the insertion point of a new child to be based on a SUPER long value like that so we clip it and assume the most recently-added child's endTime should be used instead.
    i, offset, isPercent;
    if (_isString(position) && (isNaN(position) || position in labels)) {
        //if the string is a number like "1", check to see if there's a label with that name, otherwise interpret it as a number (absolute value).
        offset = position.charAt(0);
        isPercent = position.substr(-1) === "%";
        i = position.indexOf("=");
        if (offset === "<" || offset === ">") {
            i >= 0 && (position = position.replace(/=/, ""));
            return (offset === "<" ? recent._start : recent.endTime(recent._repeat >= 0)) + (parseFloat(position.substr(1)) || 0) * (isPercent ? (i < 0 ? recent : percentAnimation).totalDuration() / 100 : 1);
        }
        if (i < 0) {
            position in labels || (labels[position] = clippedDuration);
            return labels[position];
        }
        offset = parseFloat(position.charAt(i - 1) + position.substr(i + 1));
        if (isPercent && percentAnimation) offset = offset / 100 * (_isArray(percentAnimation) ? percentAnimation[0] : percentAnimation).totalDuration();
        return i > 1 ? _parsePosition(animation, position.substr(0, i - 1), percentAnimation) + offset : clippedDuration + offset;
    }
    return position == null ? clippedDuration : +position;
}, _createTweenType = function _createTweenType(type, params, timeline) {
    var isLegacy = _isNumber(params[1]), varsIndex = (isLegacy ? 2 : 1) + (type < 2 ? 0 : 1), vars = params[varsIndex], irVars, parent;
    isLegacy && (vars.duration = params[1]);
    vars.parent = timeline;
    if (type) {
        irVars = vars;
        parent = timeline;
        while(parent && !("immediateRender" in irVars)){
            // inheritance hasn't happened yet, but someone may have set a default in an ancestor timeline. We could do vars.immediateRender = _isNotFalse(_inheritDefaults(vars).immediateRender) but that'd exact a slight performance penalty because _inheritDefaults() also runs in the Tween constructor. We're paying a small kb price here to gain speed.
            irVars = parent.vars.defaults || {};
            parent = _isNotFalse(parent.vars.inherit) && parent.parent;
        }
        vars.immediateRender = _isNotFalse(irVars.immediateRender);
        type < 2 ? vars.runBackwards = 1 : vars.startAt = params[varsIndex - 1]; // "from" vars
    }
    return new Tween(params[0], vars, params[varsIndex + 1]);
}, _conditionalReturn = function _conditionalReturn(value, func) {
    return value || value === 0 ? func(value) : func;
}, _clamp = function _clamp(min, max, value) {
    return value < min ? min : value > max ? max : value;
}, getUnit = function getUnit(value, v) {
    return !_isString(value) || !(v = _unitExp.exec(value)) ? "" : v[1];
}, // note: protect against padded numbers as strings, like "100.100". That shouldn't return "00" as the unit. If it's numeric, return no unit.
clamp = function clamp(min, max, value) {
    return _conditionalReturn(value, function(v) {
        return _clamp(min, max, v);
    });
}, _slice = [].slice, _isArrayLike = function _isArrayLike(value, nonEmpty) {
    return value && _isObject(value) && "length" in value && (!nonEmpty && !value.length || value.length - 1 in value && _isObject(value[0])) && !value.nodeType && value !== _win;
}, _flatten = function _flatten(ar, leaveStrings, accumulator) {
    if (accumulator === void 0) accumulator = [];
    return ar.forEach(function(value) {
        var _accumulator;
        return _isString(value) && !leaveStrings || _isArrayLike(value, 1) ? (_accumulator = accumulator).push.apply(_accumulator, toArray(value)) : accumulator.push(value);
    }) || accumulator;
}, //takes any value and returns an array. If it's a string (and leaveStrings isn't true), it'll use document.querySelectorAll() and convert that to an array. It'll also accept iterables like jQuery objects.
toArray = function toArray(value, scope, leaveStrings) {
    return _context && !scope && _context.selector ? _context.selector(value) : _isString(value) && !leaveStrings && (_coreInitted || !_wake()) ? _slice.call((scope || _doc).querySelectorAll(value), 0) : _isArray(value) ? _flatten(value, leaveStrings) : _isArrayLike(value) ? _slice.call(value, 0) : value ? [
        value
    ] : [];
}, selector = function selector(value) {
    value = toArray(value)[0] || _warn("Invalid scope") || {};
    return function(v) {
        var el = value.current || value.nativeElement || value;
        return toArray(v, el.querySelectorAll ? el : el === value ? _warn("Invalid scope") || _doc.createElement("div") : value);
    };
}, shuffle = function shuffle(a) {
    return a.sort(function() {
        return .5 - Math.random();
    });
}, // alternative that's a bit faster and more reliably diverse but bigger:   for (let j, v, i = a.length; i; j = (Math.random() * i) | 0, v = a[--i], a[i] = a[j], a[j] = v); return a;
//for distributing values across an array. Can accept a number, a function or (most commonly) a function which can contain the following properties: {base, amount, from, ease, grid, axis, length, each}. Returns a function that expects the following parameters: index, target, array. Recognizes the following
distribute = function distribute(v) {
    if (_isFunction(v)) return v;
    var vars = _isObject(v) ? v : {
        each: v
    }, //n:1 is just to indicate v was a number; we leverage that later to set v according to the length we get. If a number is passed in, we treat it like the old stagger value where 0.1, for example, would mean that things would be distributed with 0.1 between each element in the array rather than a total "amount" that's chunked out among them all.
    ease = _parseEase(vars.ease), from = vars.from || 0, base = parseFloat(vars.base) || 0, cache = {}, isDecimal = from > 0 && from < 1, ratios = isNaN(from) || isDecimal, axis = vars.axis, ratioX = from, ratioY = from;
    if (_isString(from)) ratioX = ratioY = ({
        center: .5,
        edges: .5,
        end: 1
    })[from] || 0;
    else if (!isDecimal && ratios) {
        ratioX = from[0];
        ratioY = from[1];
    }
    return function(i, target, a) {
        var l = (a || vars).length, distances = cache[l], originX, originY, x, y, d, j, max, min, wrapAt;
        if (!distances) {
            wrapAt = vars.grid === "auto" ? 0 : (vars.grid || [
                1,
                _bigNum
            ])[1];
            if (!wrapAt) {
                max = -_bigNum;
                while(max < (max = a[wrapAt++].getBoundingClientRect().left) && wrapAt < l);
                wrapAt < l && wrapAt--;
            }
            distances = cache[l] = [];
            originX = ratios ? Math.min(wrapAt, l) * ratioX - .5 : from % wrapAt;
            originY = wrapAt === _bigNum ? 0 : ratios ? l * ratioY / wrapAt - .5 : from / wrapAt | 0;
            max = 0;
            min = _bigNum;
            for(j = 0; j < l; j++){
                x = j % wrapAt - originX;
                y = originY - (j / wrapAt | 0);
                distances[j] = d = !axis ? _sqrt(x * x + y * y) : Math.abs(axis === "y" ? y : x);
                d > max && (max = d);
                d < min && (min = d);
            }
            from === "random" && shuffle(distances);
            distances.max = max - min;
            distances.min = min;
            distances.v = l = (parseFloat(vars.amount) || parseFloat(vars.each) * (wrapAt > l ? l - 1 : !axis ? Math.max(wrapAt, l / wrapAt) : axis === "y" ? l / wrapAt : wrapAt) || 0) * (from === "edges" ? -1 : 1);
            distances.b = l < 0 ? base - l : base;
            distances.u = getUnit(vars.amount || vars.each) || 0; //unit
            ease = ease && l < 0 ? _invertEase(ease) : ease;
        }
        l = (distances[i] - distances.min) / distances.max || 0;
        return _roundPrecise(distances.b + (ease ? ease(l) : l) * distances.v) + distances.u; //round in order to work around floating point errors
    };
}, _roundModifier = function _roundModifier(v) {
    //pass in 0.1 get a function that'll round to the nearest tenth, or 5 to round to the closest 5, or 0.001 to the closest 1000th, etc.
    var p = Math.pow(10, ((v + "").split(".")[1] || "").length); //to avoid floating point math errors (like 24 * 0.1 == 2.4000000000000004), we chop off at a specific number of decimal places (much faster than toFixed())
    return function(raw) {
        var n = _roundPrecise(Math.round(parseFloat(raw) / v) * v * p);
        return (n - n % 1) / p + (_isNumber(raw) ? 0 : getUnit(raw)); // n - n % 1 replaces Math.floor() in order to handle negative values properly. For example, Math.floor(-150.00000000000003) is 151!
    };
}, snap = function snap(snapTo, value) {
    var isArray = _isArray(snapTo), radius, is2D;
    if (!isArray && _isObject(snapTo)) {
        radius = isArray = snapTo.radius || _bigNum;
        if (snapTo.values) {
            snapTo = toArray(snapTo.values);
            if (is2D = !_isNumber(snapTo[0])) radius *= radius; //performance optimization so we don't have to Math.sqrt() in the loop.
        } else snapTo = _roundModifier(snapTo.increment);
    }
    return _conditionalReturn(value, !isArray ? _roundModifier(snapTo) : _isFunction(snapTo) ? function(raw) {
        is2D = snapTo(raw);
        return Math.abs(is2D - raw) <= radius ? is2D : raw;
    } : function(raw) {
        var x = parseFloat(is2D ? raw.x : raw), y = parseFloat(is2D ? raw.y : 0), min = _bigNum, closest = 0, i = snapTo.length, dx, dy;
        while(i--){
            if (is2D) {
                dx = snapTo[i].x - x;
                dy = snapTo[i].y - y;
                dx = dx * dx + dy * dy;
            } else dx = Math.abs(snapTo[i] - x);
            if (dx < min) {
                min = dx;
                closest = i;
            }
        }
        closest = !radius || min <= radius ? snapTo[closest] : raw;
        return is2D || closest === raw || _isNumber(raw) ? closest : closest + getUnit(raw);
    });
}, random = function random(min, max, roundingIncrement, returnFunction) {
    return _conditionalReturn(_isArray(min) ? !max : roundingIncrement === true ? (roundingIncrement = 0, false) : !returnFunction, function() {
        return _isArray(min) ? min[~~(Math.random() * min.length)] : (roundingIncrement = roundingIncrement || 1e-5, returnFunction = roundingIncrement < 1 ? Math.pow(10, (roundingIncrement + "").length - 2) : 1) && Math.floor(Math.round((min - roundingIncrement / 2 + Math.random() * (max - min + roundingIncrement * .99)) / roundingIncrement) * roundingIncrement * returnFunction) / returnFunction;
    });
}, pipe = function pipe() {
    for(var _len = arguments.length, functions = new Array(_len), _key = 0; _key < _len; _key++)functions[_key] = arguments[_key];
    return function(value) {
        return functions.reduce(function(v, f) {
            return f(v);
        }, value);
    };
}, unitize = function unitize(func, unit) {
    return function(value) {
        return func(parseFloat(value)) + (unit || getUnit(value));
    };
}, normalize = function normalize(min, max, value) {
    return mapRange(min, max, 0, 1, value);
}, _wrapArray = function _wrapArray(a, wrapper, value) {
    return _conditionalReturn(value, function(index) {
        return a[~~wrapper(index)];
    });
}, wrap = function wrap(min, max, value) {
    // NOTE: wrap() CANNOT be an arrow function! A very odd compiling bug causes problems (unrelated to GSAP).
    var range = max - min;
    return _isArray(min) ? _wrapArray(min, wrap(0, min.length), max) : _conditionalReturn(value, function(value) {
        return (range + (value - min) % range) % range + min;
    });
}, wrapYoyo = function wrapYoyo(min, max, value) {
    var range = max - min, total = range * 2;
    return _isArray(min) ? _wrapArray(min, wrapYoyo(0, min.length - 1), max) : _conditionalReturn(value, function(value) {
        value = (total + (value - min) % total) % total || 0;
        return min + (value > range ? total - value : value);
    });
}, _replaceRandom = function _replaceRandom(value) {
    //replaces all occurrences of random(...) in a string with the calculated random value. can be a range like random(-100, 100, 5) or an array like random([0, 100, 500])
    var prev = 0, s = "", i, nums, end, isArray;
    while(~(i = value.indexOf("random(", prev))){
        end = value.indexOf(")", i);
        isArray = value.charAt(i + 7) === "[";
        nums = value.substr(i + 7, end - i - 7).match(isArray ? _delimitedValueExp : _strictNumExp);
        s += value.substr(prev, i - prev) + random(isArray ? nums : +nums[0], isArray ? 0 : +nums[1], +nums[2] || 1e-5);
        prev = end + 1;
    }
    return s + value.substr(prev, value.length - prev);
}, mapRange = function mapRange(inMin, inMax, outMin, outMax, value) {
    var inRange = inMax - inMin, outRange = outMax - outMin;
    return _conditionalReturn(value, function(value) {
        return outMin + ((value - inMin) / inRange * outRange || 0);
    });
}, interpolate = function interpolate(start, end, progress, mutate) {
    var func = isNaN(start + end) ? 0 : function(p) {
        return (1 - p) * start + p * end;
    };
    if (!func) {
        var isString = _isString(start), master = {}, p, i, interpolators, l, il;
        progress === true && (mutate = 1) && (progress = null);
        if (isString) {
            start = {
                p: start
            };
            end = {
                p: end
            };
        } else if (_isArray(start) && !_isArray(end)) {
            interpolators = [];
            l = start.length;
            il = l - 2;
            for(i = 1; i < l; i++)interpolators.push(interpolate(start[i - 1], start[i])); //build the interpolators up front as a performance optimization so that when the function is called many times, it can just reuse them.
            l--;
            func = function func(p) {
                p *= l;
                var i = Math.min(il, ~~p);
                return interpolators[i](p - i);
            };
            progress = end;
        } else if (!mutate) start = _merge(_isArray(start) ? [] : {}, start);
        if (!interpolators) {
            for(p in end)_addPropTween.call(master, start, p, "get", end[p]);
            func = function func(p) {
                return _renderPropTweens(p, master) || (isString ? start.p : start);
            };
        }
    }
    return _conditionalReturn(progress, func);
}, _getLabelInDirection = function _getLabelInDirection(timeline, fromTime, backward) {
    //used for nextLabel() and previousLabel()
    var labels = timeline.labels, min = _bigNum, p, distance, label;
    for(p in labels){
        distance = labels[p] - fromTime;
        if (distance < 0 === !!backward && distance && min > (distance = Math.abs(distance))) {
            label = p;
            min = distance;
        }
    }
    return label;
}, _callback = function _callback(animation, type, executeLazyFirst) {
    var v = animation.vars, callback = v[type], prevContext = _context, context = animation._ctx, params, scope, result;
    if (!callback) return;
    params = v[type + "Params"];
    scope = v.callbackScope || animation;
    executeLazyFirst && _lazyTweens.length && _lazyRender(); //in case rendering caused any tweens to lazy-init, we should render them because typically when a timeline finishes, users expect things to have rendered fully. Imagine an onUpdate on a timeline that reports/checks tweened values.
    context && (_context = context);
    result = params ? callback.apply(scope, params) : callback.call(scope);
    _context = prevContext;
    return result;
}, _interrupt = function _interrupt(animation) {
    _removeFromParent(animation);
    animation.scrollTrigger && animation.scrollTrigger.kill(!!_reverting);
    animation.progress() < 1 && _callback(animation, "onInterrupt");
    return animation;
}, _quickTween, _registerPluginQueue = [], _createPlugin = function _createPlugin(config) {
    if (!config) return;
    config = !config.name && config["default"] || config; // UMD packaging wraps things oddly, so for example MotionPathHelper becomes {MotionPathHelper:MotionPathHelper, default:MotionPathHelper}.
    if (_windowExists() || config.headless) {
        // edge case: some build tools may pass in a null/undefined value
        var name = config.name, isFunc = _isFunction(config), Plugin = name && !isFunc && config.init ? function() {
            this._props = [];
        } : config, //in case someone passes in an object that's not a plugin, like CustomEase
        instanceDefaults = {
            init: _emptyFunc,
            render: _renderPropTweens,
            add: _addPropTween,
            kill: _killPropTweensOf,
            modifier: _addPluginModifier,
            rawVars: 0
        }, statics = {
            targetTest: 0,
            get: 0,
            getSetter: _getSetter,
            aliases: {},
            register: 0
        };
        _wake();
        if (config !== Plugin) {
            if (_plugins[name]) return;
            _setDefaults(Plugin, _setDefaults(_copyExcluding(config, instanceDefaults), statics)); //static methods
            _merge(Plugin.prototype, _merge(instanceDefaults, _copyExcluding(config, statics))); //instance methods
            _plugins[Plugin.prop = name] = Plugin;
            if (config.targetTest) {
                _harnessPlugins.push(Plugin);
                _reservedProps[name] = 1;
            }
            name = (name === "css" ? "CSS" : name.charAt(0).toUpperCase() + name.substr(1)) + "Plugin"; //for the global name. "motionPath" should become MotionPathPlugin
        }
        _addGlobal(name, Plugin);
        config.register && config.register(gsap, Plugin, PropTween);
    } else _registerPluginQueue.push(config);
}, /*
 * --------------------------------------------------------------------------------------
 * COLORS
 * --------------------------------------------------------------------------------------
 */ _255 = 255, _colorLookup = {
    aqua: [
        0,
        _255,
        _255
    ],
    lime: [
        0,
        _255,
        0
    ],
    silver: [
        192,
        192,
        192
    ],
    black: [
        0,
        0,
        0
    ],
    maroon: [
        128,
        0,
        0
    ],
    teal: [
        0,
        128,
        128
    ],
    blue: [
        0,
        0,
        _255
    ],
    navy: [
        0,
        0,
        128
    ],
    white: [
        _255,
        _255,
        _255
    ],
    olive: [
        128,
        128,
        0
    ],
    yellow: [
        _255,
        _255,
        0
    ],
    orange: [
        _255,
        165,
        0
    ],
    gray: [
        128,
        128,
        128
    ],
    purple: [
        128,
        0,
        128
    ],
    green: [
        0,
        128,
        0
    ],
    red: [
        _255,
        0,
        0
    ],
    pink: [
        _255,
        192,
        203
    ],
    cyan: [
        0,
        _255,
        _255
    ],
    transparent: [
        _255,
        _255,
        _255,
        0
    ]
}, // possible future idea to replace the hard-coded color name values - put this in the ticker.wake() where we set the _doc:
// let ctx = _doc.createElement("canvas").getContext("2d");
// _forEachName("aqua,lime,silver,black,maroon,teal,blue,navy,white,olive,yellow,orange,gray,purple,green,red,pink,cyan", color => {ctx.fillStyle = color; _colorLookup[color] = splitColor(ctx.fillStyle)});
_hue = function _hue(h, m1, m2) {
    h += h < 0 ? 1 : h > 1 ? -1 : 0;
    return (h * 6 < 1 ? m1 + (m2 - m1) * h * 6 : h < .5 ? m2 : h * 3 < 2 ? m1 + (m2 - m1) * (2 / 3 - h) * 6 : m1) * _255 + .5 | 0;
}, splitColor = function splitColor(v, toHSL, forceAlpha) {
    var a = !v ? _colorLookup.black : _isNumber(v) ? [
        v >> 16,
        v >> 8 & _255,
        v & _255
    ] : 0, r, g, b, h, s, l, max, min, d, wasHSL;
    if (!a) {
        if (v.substr(-1) === ",") //sometimes a trailing comma is included and we should chop it off (typically from a comma-delimited list of values like a textShadow:"2px 2px 2px blue, 5px 5px 5px rgb(255,0,0)" - in this example "blue," has a trailing comma. We could strip it out inside parseComplex() but we'd need to do it to the beginning and ending values plus it wouldn't provide protection from other potential scenarios like if the user passes in a similar value.
        v = v.substr(0, v.length - 1);
        if (_colorLookup[v]) a = _colorLookup[v];
        else if (v.charAt(0) === "#") {
            if (v.length < 6) {
                //for shorthand like #9F0 or #9F0F (could have alpha)
                r = v.charAt(1);
                g = v.charAt(2);
                b = v.charAt(3);
                v = "#" + r + r + g + g + b + b + (v.length === 5 ? v.charAt(4) + v.charAt(4) : "");
            }
            if (v.length === 9) {
                // hex with alpha, like #fd5e53ff
                a = parseInt(v.substr(1, 6), 16);
                return [
                    a >> 16,
                    a >> 8 & _255,
                    a & _255,
                    parseInt(v.substr(7), 16) / 255
                ];
            }
            v = parseInt(v.substr(1), 16);
            a = [
                v >> 16,
                v >> 8 & _255,
                v & _255
            ];
        } else if (v.substr(0, 3) === "hsl") {
            a = wasHSL = v.match(_strictNumExp);
            if (!toHSL) {
                h = +a[0] % 360 / 360;
                s = +a[1] / 100;
                l = +a[2] / 100;
                g = l <= .5 ? l * (s + 1) : l + s - l * s;
                r = l * 2 - g;
                a.length > 3 && (a[3] *= 1); //cast as number
                a[0] = _hue(h + 1 / 3, r, g);
                a[1] = _hue(h, r, g);
                a[2] = _hue(h - 1 / 3, r, g);
            } else if (~v.indexOf("=")) {
                //if relative values are found, just return the raw strings with the relative prefixes in place.
                a = v.match(_numExp);
                forceAlpha && a.length < 4 && (a[3] = 1);
                return a;
            }
        } else a = v.match(_strictNumExp) || _colorLookup.transparent;
        a = a.map(Number);
    }
    if (toHSL && !wasHSL) {
        r = a[0] / _255;
        g = a[1] / _255;
        b = a[2] / _255;
        max = Math.max(r, g, b);
        min = Math.min(r, g, b);
        l = (max + min) / 2;
        if (max === min) h = s = 0;
        else {
            d = max - min;
            s = l > 0.5 ? d / (2 - max - min) : d / (max + min);
            h = max === r ? (g - b) / d + (g < b ? 6 : 0) : max === g ? (b - r) / d + 2 : (r - g) / d + 4;
            h *= 60;
        }
        a[0] = ~~(h + .5);
        a[1] = ~~(s * 100 + .5);
        a[2] = ~~(l * 100 + .5);
    }
    forceAlpha && a.length < 4 && (a[3] = 1);
    return a;
}, _colorOrderData = function _colorOrderData(v) {
    // strips out the colors from the string, finds all the numeric slots (with units) and returns an array of those. The Array also has a "c" property which is an Array of the index values where the colors belong. This is to help work around issues where there's a mis-matched order of color/numeric data like drop-shadow(#f00 0px 1px 2px) and drop-shadow(0x 1px 2px #f00). This is basically a helper function used in _formatColors()
    var values = [], c = [], i = -1;
    v.split(_colorExp).forEach(function(v) {
        var a = v.match(_numWithUnitExp) || [];
        values.push.apply(values, a);
        c.push(i += a.length + 1);
    });
    values.c = c;
    return values;
}, _formatColors = function _formatColors(s, toHSL, orderMatchData) {
    var result = "", colors = (s + result).match(_colorExp), type = toHSL ? "hsla(" : "rgba(", i = 0, c, shell, d, l;
    if (!colors) return s;
    colors = colors.map(function(color) {
        return (color = splitColor(color, toHSL, 1)) && type + (toHSL ? color[0] + "," + color[1] + "%," + color[2] + "%," + color[3] : color.join(",")) + ")";
    });
    if (orderMatchData) {
        d = _colorOrderData(s);
        c = orderMatchData.c;
        if (c.join(result) !== d.c.join(result)) {
            shell = s.replace(_colorExp, "1").split(_numWithUnitExp);
            l = shell.length - 1;
            for(; i < l; i++)result += shell[i] + (~c.indexOf(i) ? colors.shift() || type + "0,0,0,0)" : (d.length ? d : colors.length ? colors : orderMatchData).shift());
        }
    }
    if (!shell) {
        shell = s.split(_colorExp);
        l = shell.length - 1;
        for(; i < l; i++)result += shell[i] + colors[i];
    }
    return result + shell[l];
}, _colorExp = function() {
    var s = "(?:\\b(?:(?:rgb|rgba|hsl|hsla)\\(.+?\\))|\\B#(?:[0-9a-f]{3,4}){1,2}\\b", //we'll dynamically build this Regular Expression to conserve file size. After building it, it will be able to find rgb(), rgba(), # (hexadecimal), and named color values like red, blue, purple, etc.,
    p;
    for(p in _colorLookup)s += "|" + p + "\\b";
    return new RegExp(s + ")", "gi");
}(), _hslExp = /hsl[a]?\(/, _colorStringFilter = function _colorStringFilter(a) {
    var combined = a.join(" "), toHSL;
    _colorExp.lastIndex = 0;
    if (_colorExp.test(combined)) {
        toHSL = _hslExp.test(combined);
        a[1] = _formatColors(a[1], toHSL);
        a[0] = _formatColors(a[0], toHSL, _colorOrderData(a[1])); // make sure the order of numbers/colors match with the END value.
        return true;
    }
}, /*
 * --------------------------------------------------------------------------------------
 * TICKER
 * --------------------------------------------------------------------------------------
 */ _tickerActive, _ticker = function() {
    var _getTime = Date.now, _lagThreshold = 500, _adjustedLag = 33, _startTime = _getTime(), _lastUpdate = _startTime, _gap = 1000 / 240, _nextTime = _gap, _listeners = [], _id, _req, _raf, _self, _delta, _i, _tick = function _tick(v) {
        var elapsed = _getTime() - _lastUpdate, manual = v === true, overlap, dispatch, time, frame;
        (elapsed > _lagThreshold || elapsed < 0) && (_startTime += elapsed - _adjustedLag);
        _lastUpdate += elapsed;
        time = _lastUpdate - _startTime;
        overlap = time - _nextTime;
        if (overlap > 0 || manual) {
            frame = ++_self.frame;
            _delta = time - _self.time * 1000;
            _self.time = time = time / 1000;
            _nextTime += overlap + (overlap >= _gap ? 4 : _gap - overlap);
            dispatch = 1;
        }
        manual || (_id = _req(_tick)); //make sure the request is made before we dispatch the "tick" event so that timing is maintained. Otherwise, if processing the "tick" requires a bunch of time (like 15ms) and we're using a setTimeout() that's based on 16.7ms, it'd technically take 31.7ms between frames otherwise.
        if (dispatch) for(_i = 0; _i < _listeners.length; _i++)// use _i and check _listeners.length instead of a variable because a listener could get removed during the loop, and if that happens to an element less than the current index, it'd throw things off in the loop.
        _listeners[_i](time, _delta, frame, v);
    };
    _self = {
        time: 0,
        frame: 0,
        tick: function tick() {
            _tick(true);
        },
        deltaRatio: function deltaRatio(fps) {
            return _delta / (1000 / (fps || 60));
        },
        wake: function wake() {
            if (_coreReady) {
                if (!_coreInitted && _windowExists()) {
                    _win = _coreInitted = window;
                    _doc = _win.document || {};
                    _globals.gsap = gsap;
                    (_win.gsapVersions || (_win.gsapVersions = [])).push(gsap.version);
                    _install(_installScope || _win.GreenSockGlobals || !_win.gsap && _win || {});
                    _registerPluginQueue.forEach(_createPlugin);
                }
                _raf = typeof requestAnimationFrame !== "undefined" && requestAnimationFrame;
                _id && _self.sleep();
                _req = _raf || function(f) {
                    return setTimeout(f, _nextTime - _self.time * 1000 + 1 | 0);
                };
                _tickerActive = 1;
                _tick(2);
            }
        },
        sleep: function sleep() {
            (_raf ? cancelAnimationFrame : clearTimeout)(_id);
            _tickerActive = 0;
            _req = _emptyFunc;
        },
        lagSmoothing: function lagSmoothing(threshold, adjustedLag) {
            _lagThreshold = threshold || Infinity; // zero should be interpreted as basically unlimited
            _adjustedLag = Math.min(adjustedLag || 33, _lagThreshold);
        },
        fps: function fps(_fps) {
            _gap = 1000 / (_fps || 240);
            _nextTime = _self.time * 1000 + _gap;
        },
        add: function add(callback, once, prioritize) {
            var func = once ? function(t, d, f, v) {
                callback(t, d, f, v);
                _self.remove(func);
            } : callback;
            _self.remove(callback);
            _listeners[prioritize ? "unshift" : "push"](func);
            _wake();
            return func;
        },
        remove: function remove(callback, i) {
            ~(i = _listeners.indexOf(callback)) && _listeners.splice(i, 1) && _i >= i && _i--;
        },
        _listeners: _listeners
    };
    return _self;
}(), _wake = function _wake() {
    return !_tickerActive && _ticker.wake();
}, //also ensures the core classes are initialized.
/*
* -------------------------------------------------
* EASING
* -------------------------------------------------
*/ _easeMap = {}, _customEaseExp = /^[\d.\-M][\d.\-,\s]/, _quotesExp = /["']/g, _parseObjectInString = function _parseObjectInString(value) {
    //takes a string like "{wiggles:10, type:anticipate})" and turns it into a real object. Notice it ends in ")" and includes the {} wrappers. This is because we only use this function for parsing ease configs and prioritized optimization rather than reusability.
    var obj = {}, split = value.substr(1, value.length - 3).split(":"), key = split[0], i = 1, l = split.length, index, val, parsedVal;
    for(; i < l; i++){
        val = split[i];
        index = i !== l - 1 ? val.lastIndexOf(",") : val.length;
        parsedVal = val.substr(0, index);
        obj[key] = isNaN(parsedVal) ? parsedVal.replace(_quotesExp, "").trim() : +parsedVal;
        key = val.substr(index + 1).trim();
    }
    return obj;
}, _valueInParentheses = function _valueInParentheses(value) {
    var open = value.indexOf("(") + 1, close = value.indexOf(")"), nested = value.indexOf("(", open);
    return value.substring(open, ~nested && nested < close ? value.indexOf(")", close + 1) : close);
}, _configEaseFromString = function _configEaseFromString(name) {
    //name can be a string like "elastic.out(1,0.5)", and pass in _easeMap as obj and it'll parse it out and call the actual function like _easeMap.Elastic.easeOut.config(1,0.5). It will also parse custom ease strings as long as CustomEase is loaded and registered (internally as _easeMap._CE).
    var split = (name + "").split("("), ease = _easeMap[split[0]];
    return ease && split.length > 1 && ease.config ? ease.config.apply(null, ~name.indexOf("{") ? [
        _parseObjectInString(split[1])
    ] : _valueInParentheses(name).split(",").map(_numericIfPossible)) : _easeMap._CE && _customEaseExp.test(name) ? _easeMap._CE("", name) : ease;
}, _invertEase = function _invertEase(ease) {
    return function(p) {
        return 1 - ease(1 - p);
    };
}, // allow yoyoEase to be set in children and have those affected when the parent/ancestor timeline yoyos.
_propagateYoyoEase = function _propagateYoyoEase(timeline, isYoyo) {
    var child = timeline._first, ease;
    while(child){
        if (child instanceof Timeline) _propagateYoyoEase(child, isYoyo);
        else if (child.vars.yoyoEase && (!child._yoyo || !child._repeat) && child._yoyo !== isYoyo) {
            if (child.timeline) _propagateYoyoEase(child.timeline, isYoyo);
            else {
                ease = child._ease;
                child._ease = child._yEase;
                child._yEase = ease;
                child._yoyo = isYoyo;
            }
        }
        child = child._next;
    }
}, _parseEase = function _parseEase(ease, defaultEase) {
    return !ease ? defaultEase : (_isFunction(ease) ? ease : _easeMap[ease] || _configEaseFromString(ease)) || defaultEase;
}, _insertEase = function _insertEase(names, easeIn, easeOut, easeInOut) {
    if (easeOut === void 0) easeOut = function easeOut(p) {
        return 1 - easeIn(1 - p);
    };
    if (easeInOut === void 0) easeInOut = function easeInOut(p) {
        return p < .5 ? easeIn(p * 2) / 2 : 1 - easeIn((1 - p) * 2) / 2;
    };
    var ease = {
        easeIn: easeIn,
        easeOut: easeOut,
        easeInOut: easeInOut
    }, lowercaseName;
    _forEachName(names, function(name) {
        _easeMap[name] = _globals[name] = ease;
        _easeMap[lowercaseName = name.toLowerCase()] = easeOut;
        for(var p in ease)_easeMap[lowercaseName + (p === "easeIn" ? ".in" : p === "easeOut" ? ".out" : ".inOut")] = _easeMap[name + "." + p] = ease[p];
    });
    return ease;
}, _easeInOutFromOut = function _easeInOutFromOut(easeOut) {
    return function(p) {
        return p < .5 ? (1 - easeOut(1 - p * 2)) / 2 : .5 + easeOut((p - .5) * 2) / 2;
    };
}, _configElastic = function _configElastic(type, amplitude, period) {
    var p1 = amplitude >= 1 ? amplitude : 1, //note: if amplitude is < 1, we simply adjust the period for a more natural feel. Otherwise the math doesn't work right and the curve starts at 1.
    p2 = (period || (type ? .3 : .45)) / (amplitude < 1 ? amplitude : 1), p3 = p2 / _2PI * (Math.asin(1 / p1) || 0), easeOut = function easeOut(p) {
        return p === 1 ? 1 : p1 * Math.pow(2, -10 * p) * _sin((p - p3) * p2) + 1;
    }, ease = type === "out" ? easeOut : type === "in" ? function(p) {
        return 1 - easeOut(1 - p);
    } : _easeInOutFromOut(easeOut);
    p2 = _2PI / p2; //precalculate to optimize
    ease.config = function(amplitude, period) {
        return _configElastic(type, amplitude, period);
    };
    return ease;
}, _configBack = function _configBack(type, overshoot) {
    if (overshoot === void 0) overshoot = 1.70158;
    var easeOut = function easeOut(p) {
        return p ? --p * p * ((overshoot + 1) * p + overshoot) + 1 : 0;
    }, ease = type === "out" ? easeOut : type === "in" ? function(p) {
        return 1 - easeOut(1 - p);
    } : _easeInOutFromOut(easeOut);
    ease.config = function(overshoot) {
        return _configBack(type, overshoot);
    };
    return ease;
}; // a cheaper (kb and cpu) but more mild way to get a parameterized weighted ease by feeding in a value between -1 (easeIn) and 1 (easeOut) where 0 is linear.
// _weightedEase = ratio => {
// 	let y = 0.5 + ratio / 2;
// 	return p => (2 * (1 - p) * p * y + p * p);
// },
// a stronger (but more expensive kb/cpu) parameterized weighted ease that lets you feed in a value between -1 (easeIn) and 1 (easeOut) where 0 is linear.
// _weightedEaseStrong = ratio => {
// 	ratio = .5 + ratio / 2;
// 	let o = 1 / 3 * (ratio < .5 ? ratio : 1 - ratio),
// 		b = ratio - o,
// 		c = ratio + o;
// 	return p => p === 1 ? p : 3 * b * (1 - p) * (1 - p) * p + 3 * c * (1 - p) * p * p + p * p * p;
// };
_forEachName("Linear,Quad,Cubic,Quart,Quint,Strong", function(name, i) {
    var power = i < 5 ? i + 1 : i;
    _insertEase(name + ",Power" + (power - 1), i ? function(p) {
        return Math.pow(p, power);
    } : function(p) {
        return p;
    }, function(p) {
        return 1 - Math.pow(1 - p, power);
    }, function(p) {
        return p < .5 ? Math.pow(p * 2, power) / 2 : 1 - Math.pow((1 - p) * 2, power) / 2;
    });
});
_easeMap.Linear.easeNone = _easeMap.none = _easeMap.Linear.easeIn;
_insertEase("Elastic", _configElastic("in"), _configElastic("out"), _configElastic());
(function(n, c) {
    var n1 = 1 / c, n2 = 2 * n1, n3 = 2.5 * n1, easeOut = function easeOut(p) {
        return p < n1 ? n * p * p : p < n2 ? n * Math.pow(p - 1.5 / c, 2) + .75 : p < n3 ? n * (p -= 2.25 / c) * p + .9375 : n * Math.pow(p - 2.625 / c, 2) + .984375;
    };
    _insertEase("Bounce", function(p) {
        return 1 - easeOut(1 - p);
    }, easeOut);
})(7.5625, 2.75);
_insertEase("Expo", function(p) {
    return Math.pow(2, 10 * (p - 1)) * p + p * p * p * p * p * p * (1 - p);
}); // previously 2 ** (10 * (p - 1)) but that doesn't end up with the value quite at the right spot so we do a blended ease to ensure it lands where it should perfectly.
_insertEase("Circ", function(p) {
    return -(_sqrt(1 - p * p) - 1);
});
_insertEase("Sine", function(p) {
    return p === 1 ? 1 : -_cos(p * _HALF_PI) + 1;
});
_insertEase("Back", _configBack("in"), _configBack("out"), _configBack());
_easeMap.SteppedEase = _easeMap.steps = _globals.SteppedEase = {
    config: function config(steps, immediateStart) {
        if (steps === void 0) steps = 1;
        var p1 = 1 / steps, p2 = steps + (immediateStart ? 0 : 1), p3 = immediateStart ? 1 : 0, max = 1 - _tinyNum;
        return function(p) {
            return ((p2 * _clamp(0, max, p) | 0) + p3) * p1;
        };
    }
};
_defaults.ease = _easeMap["quad.out"];
_forEachName("onComplete,onUpdate,onStart,onRepeat,onReverseComplete,onInterrupt", function(name) {
    return _callbackNames += name + "," + name + "Params,";
});
var GSCache = function GSCache(target, harness) {
    this.id = _gsID++;
    target._gsap = this;
    this.target = target;
    this.harness = harness;
    this.get = harness ? harness.get : _getProperty;
    this.set = harness ? harness.getSetter : _getSetter;
};
var Animation = /*#__PURE__*/ function() {
    function Animation(vars) {
        this.vars = vars;
        this._delay = +vars.delay || 0;
        if (this._repeat = vars.repeat === Infinity ? -2 : vars.repeat || 0) {
            // TODO: repeat: Infinity on a timeline's children must flag that timeline internally and affect its totalDuration, otherwise it'll stop in the negative direction when reaching the start.
            this._rDelay = vars.repeatDelay || 0;
            this._yoyo = !!vars.yoyo || !!vars.yoyoEase;
        }
        this._ts = 1;
        _setDuration(this, +vars.duration, 1, 1);
        this.data = vars.data;
        if (_context) {
            this._ctx = _context;
            _context.data.push(this);
        }
        _tickerActive || _ticker.wake();
    }
    var _proto = Animation.prototype;
    _proto.delay = function delay(value) {
        if (value || value === 0) {
            this.parent && this.parent.smoothChildTiming && this.startTime(this._start + value - this._delay);
            this._delay = value;
            return this;
        }
        return this._delay;
    };
    _proto.duration = function duration(value) {
        return arguments.length ? this.totalDuration(this._repeat > 0 ? value + (value + this._rDelay) * this._repeat : value) : this.totalDuration() && this._dur;
    };
    _proto.totalDuration = function totalDuration(value) {
        if (!arguments.length) return this._tDur;
        this._dirty = 0;
        return _setDuration(this, this._repeat < 0 ? value : (value - this._repeat * this._rDelay) / (this._repeat + 1));
    };
    _proto.totalTime = function totalTime(_totalTime, suppressEvents) {
        _wake();
        if (!arguments.length) return this._tTime;
        var parent = this._dp;
        if (parent && parent.smoothChildTiming && this._ts) {
            _alignPlayhead(this, _totalTime);
            !parent._dp || parent.parent || _postAddChecks(parent, this); // edge case: if this is a child of a timeline that already completed, for example, we must re-activate the parent.
            //in case any of the ancestor timelines had completed but should now be enabled, we should reset their totalTime() which will also ensure that they're lined up properly and enabled. Skip for animations that are on the root (wasteful). Example: a TimelineLite.exportRoot() is performed when there's a paused tween on the root, the export will not complete until that tween is unpaused, but imagine a child gets restarted later, after all [unpaused] tweens have completed. The start of that child would get pushed out, but one of the ancestors may have completed.
            while(parent && parent.parent){
                if (parent.parent._time !== parent._start + (parent._ts >= 0 ? parent._tTime / parent._ts : (parent.totalDuration() - parent._tTime) / -parent._ts)) parent.totalTime(parent._tTime, true);
                parent = parent.parent;
            }
            if (!this.parent && this._dp.autoRemoveChildren && (this._ts > 0 && _totalTime < this._tDur || this._ts < 0 && _totalTime > 0 || !this._tDur && !_totalTime)) //if the animation doesn't have a parent, put it back into its last parent (recorded as _dp for exactly cases like this). Limit to parents with autoRemoveChildren (like globalTimeline) so that if the user manually removes an animation from a timeline and then alters its playhead, it doesn't get added back in.
            _addToTimeline(this._dp, this, this._start - this._delay);
        }
        if (this._tTime !== _totalTime || !this._dur && !suppressEvents || this._initted && Math.abs(this._zTime) === _tinyNum || !_totalTime && !this._initted && (this.add || this._ptLookup)) {
            // check for _ptLookup on a Tween instance to ensure it has actually finished being instantiated, otherwise if this.reverse() gets called in the Animation constructor, it could trigger a render() here even though the _targets weren't populated, thus when _init() is called there won't be any PropTweens (it'll act like the tween is non-functional)
            this._ts || (this._pTime = _totalTime); // otherwise, if an animation is paused, then the playhead is moved back to zero, then resumed, it'd revert back to the original time at the pause
            //if (!this._lock) { // avoid endless recursion (not sure we need this yet or if it's worth the performance hit)
            //   this._lock = 1;
            _lazySafeRender(this, _totalTime, suppressEvents); //   this._lock = 0;
        //}
        }
        return this;
    };
    _proto.time = function time(value, suppressEvents) {
        return arguments.length ? this.totalTime(Math.min(this.totalDuration(), value + _elapsedCycleDuration(this)) % (this._dur + this._rDelay) || (value ? this._dur : 0), suppressEvents) : this._time; // note: if the modulus results in 0, the playhead could be exactly at the end or the beginning, and we always defer to the END with a non-zero value, otherwise if you set the time() to the very end (duration()), it would render at the START!
    };
    _proto.totalProgress = function totalProgress(value, suppressEvents) {
        return arguments.length ? this.totalTime(this.totalDuration() * value, suppressEvents) : this.totalDuration() ? Math.min(1, this._tTime / this._tDur) : this.rawTime() >= 0 && this._initted ? 1 : 0;
    };
    _proto.progress = function progress(value, suppressEvents) {
        return arguments.length ? this.totalTime(this.duration() * (this._yoyo && !(this.iteration() & 1) ? 1 - value : value) + _elapsedCycleDuration(this), suppressEvents) : this.duration() ? Math.min(1, this._time / this._dur) : this.rawTime() > 0 ? 1 : 0;
    };
    _proto.iteration = function iteration(value, suppressEvents) {
        var cycleDuration = this.duration() + this._rDelay;
        return arguments.length ? this.totalTime(this._time + (value - 1) * cycleDuration, suppressEvents) : this._repeat ? _animationCycle(this._tTime, cycleDuration) + 1 : 1;
    } // potential future addition:
    ;
    _proto.timeScale = function timeScale(value, suppressEvents) {
        if (!arguments.length) return this._rts === -_tinyNum ? 0 : this._rts; // recorded timeScale. Special case: if someone calls reverse() on an animation with timeScale of 0, we assign it -_tinyNum to remember it's reversed.
        if (this._rts === value) return this;
        var tTime = this.parent && this._ts ? _parentToChildTotalTime(this.parent._time, this) : this._tTime; // make sure to do the parentToChildTotalTime() BEFORE setting the new _ts because the old one must be used in that calculation.
        // future addition? Up side: fast and minimal file size. Down side: only works on this animation; if a timeline is reversed, for example, its childrens' onReverse wouldn't get called.
        //(+value < 0 && this._rts >= 0) && _callback(this, "onReverse", true);
        // prioritize rendering where the parent's playhead lines up instead of this._tTime because there could be a tween that's animating another tween's timeScale in the same rendering loop (same parent), thus if the timeScale tween renders first, it would alter _start BEFORE _tTime was set on that tick (in the rendering loop), effectively freezing it until the timeScale tween finishes.
        this._rts = +value || 0;
        this._ts = this._ps || value === -_tinyNum ? 0 : this._rts; // _ts is the functional timeScale which would be 0 if the animation is paused.
        this.totalTime(_clamp(-Math.abs(this._delay), this._tDur, tTime), suppressEvents !== false);
        _setEnd(this); // if parent.smoothChildTiming was false, the end time didn't get updated in the _alignPlayhead() method, so do it here.
        return _recacheAncestors(this);
    };
    _proto.paused = function paused(value) {
        if (!arguments.length) return this._ps;
         // possible future addition - if an animation is removed from its parent and then .restart() or .play() or .resume() is called, perhaps we should force it back into the globalTimeline but be careful because what if it's already at its end? We don't want it to just persist forever and not get released for GC.
        // !this.parent && !value && this._tTime < this._tDur && this !== _globalTimeline && _globalTimeline.add(this);
        if (this._ps !== value) {
            this._ps = value;
            if (value) {
                this._pTime = this._tTime || Math.max(-this._delay, this.rawTime()); // if the pause occurs during the delay phase, make sure that's factored in when resuming.
                this._ts = this._act = 0; // _ts is the functional timeScale, so a paused tween would effectively have a timeScale of 0. We record the "real" timeScale as _rts (recorded time scale)
            } else {
                _wake();
                this._ts = this._rts; //only defer to _pTime (pauseTime) if tTime is zero. Remember, someone could pause() an animation, then scrub the playhead and resume(). If the parent doesn't have smoothChildTiming, we render at the rawTime() because the startTime won't get updated.
                this.totalTime(this.parent && !this.parent.smoothChildTiming ? this.rawTime() : this._tTime || this._pTime, this.progress() === 1 && Math.abs(this._zTime) !== _tinyNum && (this._tTime -= _tinyNum)); // edge case: animation.progress(1).pause().play() wouldn't render again because the playhead is already at the end, but the call to totalTime() below will add it back to its parent...and not remove it again (since removing only happens upon rendering at a new time). Offsetting the _tTime slightly is done simply to cause the final render in totalTime() that'll pop it off its timeline (if autoRemoveChildren is true, of course). Check to make sure _zTime isn't -_tinyNum to avoid an edge case where the playhead is pushed to the end but INSIDE a tween/callback, the timeline itself is paused thus halting rendering and leaving a few unrendered. When resuming, it wouldn't render those otherwise.
            }
        }
        return this;
    };
    _proto.startTime = function startTime(value) {
        if (arguments.length) {
            this._start = value;
            var parent = this.parent || this._dp;
            parent && (parent._sort || !this.parent) && _addToTimeline(parent, this, value - this._delay);
            return this;
        }
        return this._start;
    };
    _proto.endTime = function endTime(includeRepeats) {
        return this._start + (_isNotFalse(includeRepeats) ? this.totalDuration() : this.duration()) / Math.abs(this._ts || 1);
    };
    _proto.rawTime = function rawTime(wrapRepeats) {
        var parent = this.parent || this._dp; // _dp = detached parent
        return !parent ? this._tTime : wrapRepeats && (!this._ts || this._repeat && this._time && this.totalProgress() < 1) ? this._tTime % (this._dur + this._rDelay) : !this._ts ? this._tTime : _parentToChildTotalTime(parent.rawTime(wrapRepeats), this);
    };
    _proto.revert = function revert(config) {
        if (config === void 0) config = _revertConfig;
        var prevIsReverting = _reverting;
        _reverting = config;
        if (this._initted || this._startAt) {
            this.timeline && this.timeline.revert(config);
            this.totalTime(-0.01, config.suppressEvents);
        }
        this.data !== "nested" && config.kill !== false && this.kill();
        _reverting = prevIsReverting;
        return this;
    };
    _proto.globalTime = function globalTime(rawTime) {
        var animation = this, time = arguments.length ? rawTime : animation.rawTime();
        while(animation){
            time = animation._start + time / (Math.abs(animation._ts) || 1);
            animation = animation._dp;
        }
        return !this.parent && this._sat ? this._sat.globalTime(rawTime) : time; // the _startAt tweens for .fromTo() and .from() that have immediateRender should always be FIRST in the timeline (important for context.revert()). "_sat" stands for _startAtTween, referring to the parent tween that created the _startAt. We must discern if that tween had immediateRender so that we can know whether or not to prioritize it in revert().
    };
    _proto.repeat = function repeat(value) {
        if (arguments.length) {
            this._repeat = value === Infinity ? -2 : value;
            return _onUpdateTotalDuration(this);
        }
        return this._repeat === -2 ? Infinity : this._repeat;
    };
    _proto.repeatDelay = function repeatDelay(value) {
        if (arguments.length) {
            var time = this._time;
            this._rDelay = value;
            _onUpdateTotalDuration(this);
            return time ? this.time(time) : this;
        }
        return this._rDelay;
    };
    _proto.yoyo = function yoyo(value) {
        if (arguments.length) {
            this._yoyo = value;
            return this;
        }
        return this._yoyo;
    };
    _proto.seek = function seek(position, suppressEvents) {
        return this.totalTime(_parsePosition(this, position), _isNotFalse(suppressEvents));
    };
    _proto.restart = function restart(includeDelay, suppressEvents) {
        this.play().totalTime(includeDelay ? -this._delay : 0, _isNotFalse(suppressEvents));
        this._dur || (this._zTime = -_tinyNum); // ensures onComplete fires on a zero-duration animation that gets restarted.
        return this;
    };
    _proto.play = function play(from, suppressEvents) {
        from != null && this.seek(from, suppressEvents);
        return this.reversed(false).paused(false);
    };
    _proto.reverse = function reverse(from, suppressEvents) {
        from != null && this.seek(from || this.totalDuration(), suppressEvents);
        return this.reversed(true).paused(false);
    };
    _proto.pause = function pause(atTime, suppressEvents) {
        atTime != null && this.seek(atTime, suppressEvents);
        return this.paused(true);
    };
    _proto.resume = function resume() {
        return this.paused(false);
    };
    _proto.reversed = function reversed(value) {
        if (arguments.length) {
            !!value !== this.reversed() && this.timeScale(-this._rts || (value ? -_tinyNum : 0)); // in case timeScale is zero, reversing would have no effect so we use _tinyNum.
            return this;
        }
        return this._rts < 0;
    };
    _proto.invalidate = function invalidate() {
        this._initted = this._act = 0;
        this._zTime = -_tinyNum;
        return this;
    };
    _proto.isActive = function isActive() {
        var parent = this.parent || this._dp, start = this._start, rawTime;
        return !!(!parent || this._ts && this._initted && parent.isActive() && (rawTime = parent.rawTime(true)) >= start && rawTime < this.endTime(true) - _tinyNum);
    };
    _proto.eventCallback = function eventCallback(type, callback, params) {
        var vars = this.vars;
        if (arguments.length > 1) {
            if (!callback) delete vars[type];
            else {
                vars[type] = callback;
                params && (vars[type + "Params"] = params);
                type === "onUpdate" && (this._onUpdate = callback);
            }
            return this;
        }
        return vars[type];
    };
    _proto.then = function then(onFulfilled) {
        var self = this;
        return new Promise(function(resolve) {
            var f = _isFunction(onFulfilled) ? onFulfilled : _passThrough, _resolve = function _resolve() {
                var _then = self.then;
                self.then = null; // temporarily null the then() method to avoid an infinite loop (see https://github.com/greensock/GSAP/issues/322)
                _isFunction(f) && (f = f(self)) && (f.then || f === self) && (self.then = _then);
                resolve(f);
                self.then = _then;
            };
            if (self._initted && self.totalProgress() === 1 && self._ts >= 0 || !self._tTime && self._ts < 0) _resolve();
            else self._prom = _resolve;
        });
    };
    _proto.kill = function kill() {
        _interrupt(this);
    };
    return Animation;
}();
_setDefaults(Animation.prototype, {
    _time: 0,
    _start: 0,
    _end: 0,
    _tTime: 0,
    _tDur: 0,
    _dirty: 0,
    _repeat: 0,
    _yoyo: false,
    parent: null,
    _initted: false,
    _rDelay: 0,
    _ts: 1,
    _dp: 0,
    ratio: 0,
    _zTime: -_tinyNum,
    _prom: 0,
    _ps: false,
    _rts: 1
});
var Timeline = /*#__PURE__*/ function(_Animation) {
    _inheritsLoose(Timeline, _Animation);
    function Timeline(vars, position) {
        var _this;
        if (vars === void 0) vars = {};
        _this = _Animation.call(this, vars) || this;
        _this.labels = {};
        _this.smoothChildTiming = !!vars.smoothChildTiming;
        _this.autoRemoveChildren = !!vars.autoRemoveChildren;
        _this._sort = _isNotFalse(vars.sortChildren);
        _globalTimeline && _addToTimeline(vars.parent || _globalTimeline, _assertThisInitialized(_this), position);
        vars.reversed && _this.reverse();
        vars.paused && _this.paused(true);
        vars.scrollTrigger && _scrollTrigger(_assertThisInitialized(_this), vars.scrollTrigger);
        return _this;
    }
    var _proto2 = Timeline.prototype;
    _proto2.to = function to(targets, vars, position) {
        _createTweenType(0, arguments, this);
        return this;
    };
    _proto2.from = function from(targets, vars, position) {
        _createTweenType(1, arguments, this);
        return this;
    };
    _proto2.fromTo = function fromTo(targets, fromVars, toVars, position) {
        _createTweenType(2, arguments, this);
        return this;
    };
    _proto2.set = function set(targets, vars, position) {
        vars.duration = 0;
        vars.parent = this;
        _inheritDefaults(vars).repeatDelay || (vars.repeat = 0);
        vars.immediateRender = !!vars.immediateRender;
        new Tween(targets, vars, _parsePosition(this, position), 1);
        return this;
    };
    _proto2.call = function call(callback, params, position) {
        return _addToTimeline(this, Tween.delayedCall(0, callback, params), position);
    } //ONLY for backward compatibility! Maybe delete?
    ;
    _proto2.staggerTo = function staggerTo(targets, duration, vars, stagger, position, onCompleteAll, onCompleteAllParams) {
        vars.duration = duration;
        vars.stagger = vars.stagger || stagger;
        vars.onComplete = onCompleteAll;
        vars.onCompleteParams = onCompleteAllParams;
        vars.parent = this;
        new Tween(targets, vars, _parsePosition(this, position));
        return this;
    };
    _proto2.staggerFrom = function staggerFrom(targets, duration, vars, stagger, position, onCompleteAll, onCompleteAllParams) {
        vars.runBackwards = 1;
        _inheritDefaults(vars).immediateRender = _isNotFalse(vars.immediateRender);
        return this.staggerTo(targets, duration, vars, stagger, position, onCompleteAll, onCompleteAllParams);
    };
    _proto2.staggerFromTo = function staggerFromTo(targets, duration, fromVars, toVars, stagger, position, onCompleteAll, onCompleteAllParams) {
        toVars.startAt = fromVars;
        _inheritDefaults(toVars).immediateRender = _isNotFalse(toVars.immediateRender);
        return this.staggerTo(targets, duration, toVars, stagger, position, onCompleteAll, onCompleteAllParams);
    };
    _proto2.render = function render(totalTime, suppressEvents, force) {
        var prevTime = this._time, tDur = this._dirty ? this.totalDuration() : this._tDur, dur = this._dur, tTime = totalTime <= 0 ? 0 : _roundPrecise(totalTime), // if a paused timeline is resumed (or its _start is updated for another reason...which rounds it), that could result in the playhead shifting a **tiny** amount and a zero-duration child at that spot may get rendered at a different ratio, like its totalTime in render() may be 1e-17 instead of 0, for example.
        crossingStart = this._zTime < 0 !== totalTime < 0 && (this._initted || !dur), time, child, next, iteration, cycleDuration, prevPaused, pauseTween, timeScale, prevStart, prevIteration, yoyo, isYoyo;
        this !== _globalTimeline && tTime > tDur && totalTime >= 0 && (tTime = tDur);
        if (tTime !== this._tTime || force || crossingStart) {
            if (prevTime !== this._time && dur) {
                //if totalDuration() finds a child with a negative startTime and smoothChildTiming is true, things get shifted around internally so we need to adjust the time accordingly. For example, if a tween starts at -30 we must shift EVERYTHING forward 30 seconds and move this timeline's startTime backward by 30 seconds so that things align with the playhead (no jump).
                tTime += this._time - prevTime;
                totalTime += this._time - prevTime;
            }
            time = tTime;
            prevStart = this._start;
            timeScale = this._ts;
            prevPaused = !timeScale;
            if (crossingStart) {
                dur || (prevTime = this._zTime); //when the playhead arrives at EXACTLY time 0 (right on top) of a zero-duration timeline, we need to discern if events are suppressed so that when the playhead moves again (next time), it'll trigger the callback. If events are NOT suppressed, obviously the callback would be triggered in this render. Basically, the callback should fire either when the playhead ARRIVES or LEAVES this exact spot, not both. Imagine doing a timeline.seek(0) and there's a callback that sits at 0. Since events are suppressed on that seek() by default, nothing will fire, but when the playhead moves off of that position, the callback should fire. This behavior is what people intuitively expect.
                (totalTime || !suppressEvents) && (this._zTime = totalTime);
            }
            if (this._repeat) {
                //adjust the time for repeats and yoyos
                yoyo = this._yoyo;
                cycleDuration = dur + this._rDelay;
                if (this._repeat < -1 && totalTime < 0) return this.totalTime(cycleDuration * 100 + totalTime, suppressEvents, force);
                time = _roundPrecise(tTime % cycleDuration); //round to avoid floating point errors. (4 % 0.8 should be 0 but some browsers report it as 0.79999999!)
                if (tTime === tDur) {
                    // the tDur === tTime is for edge cases where there's a lengthy decimal on the duration and it may reach the very end but the time is rendered as not-quite-there (remember, tDur is rounded to 4 decimals whereas dur isn't)
                    iteration = this._repeat;
                    time = dur;
                } else {
                    prevIteration = _roundPrecise(tTime / cycleDuration); // full decimal version of iterations, not the previous iteration (we're reusing prevIteration variable for efficiency)
                    iteration = ~~prevIteration;
                    if (iteration && iteration === prevIteration) {
                        time = dur;
                        iteration--;
                    }
                    time > dur && (time = dur);
                }
                prevIteration = _animationCycle(this._tTime, cycleDuration);
                !prevTime && this._tTime && prevIteration !== iteration && this._tTime - prevIteration * cycleDuration - this._dur <= 0 && (prevIteration = iteration); // edge case - if someone does addPause() at the very beginning of a repeating timeline, that pause is technically at the same spot as the end which causes this._time to get set to 0 when the totalTime would normally place the playhead at the end. See https://gsap.com/forums/topic/23823-closing-nav-animation-not-working-on-ie-and-iphone-6-maybe-other-older-browser/?tab=comments#comment-113005 also, this._tTime - prevIteration * cycleDuration - this._dur <= 0 just checks to make sure it wasn't previously in the "repeatDelay" portion
                if (yoyo && iteration & 1) {
                    time = dur - time;
                    isYoyo = 1;
                }
                /*
        make sure children at the end/beginning of the timeline are rendered properly. If, for example,
        a 3-second long timeline rendered at 2.9 seconds previously, and now renders at 3.2 seconds (which
        would get translated to 2.8 seconds if the timeline yoyos or 0.2 seconds if it just repeats), there
        could be a callback or a short tween that's at 2.95 or 3 seconds in which wouldn't render. So
        we need to push the timeline to the end (and/or beginning depending on its yoyo value). Also we must
        ensure that zero-duration tweens at the very beginning or end of the Timeline work.
        */ if (iteration !== prevIteration && !this._lock) {
                    var rewinding = yoyo && prevIteration & 1, doesWrap = rewinding === (yoyo && iteration & 1);
                    iteration < prevIteration && (rewinding = !rewinding);
                    prevTime = rewinding ? 0 : tTime % dur ? dur : tTime; // if the playhead is landing exactly at the end of an iteration, use that totalTime rather than only the duration, otherwise it'll skip the 2nd render since it's effectively at the same time.
                    this._lock = 1;
                    this.render(prevTime || (isYoyo ? 0 : _roundPrecise(iteration * cycleDuration)), suppressEvents, !dur)._lock = 0;
                    this._tTime = tTime; // if a user gets the iteration() inside the onRepeat, for example, it should be accurate.
                    !suppressEvents && this.parent && _callback(this, "onRepeat");
                    this.vars.repeatRefresh && !isYoyo && (this.invalidate()._lock = 1);
                    if (prevTime && prevTime !== this._time || prevPaused !== !this._ts || this.vars.onRepeat && !this.parent && !this._act) // if prevTime is 0 and we render at the very end, _time will be the end, thus won't match. So in this edge case, prevTime won't match _time but that's okay. If it gets killed in the onRepeat, eject as well.
                    return this;
                    dur = this._dur; // in case the duration changed in the onRepeat
                    tDur = this._tDur;
                    if (doesWrap) {
                        this._lock = 2;
                        prevTime = rewinding ? dur : -0.0001;
                        this.render(prevTime, true);
                        this.vars.repeatRefresh && !isYoyo && this.invalidate();
                    }
                    this._lock = 0;
                    if (!this._ts && !prevPaused) return this;
                     //in order for yoyoEase to work properly when there's a stagger, we must swap out the ease in each sub-tween.
                    _propagateYoyoEase(this, isYoyo);
                }
            }
            if (this._hasPause && !this._forcing && this._lock < 2) {
                pauseTween = _findNextPauseTween(this, _roundPrecise(prevTime), _roundPrecise(time));
                if (pauseTween) tTime -= time - (time = pauseTween._start);
            }
            this._tTime = tTime;
            this._time = time;
            this._act = !timeScale; //as long as it's not paused, force it to be active so that if the user renders independent of the parent timeline, it'll be forced to re-render on the next tick.
            if (!this._initted) {
                this._onUpdate = this.vars.onUpdate;
                this._initted = 1;
                this._zTime = totalTime;
                prevTime = 0; // upon init, the playhead should always go forward; someone could invalidate() a completed timeline and then if they restart(), that would make child tweens render in reverse order which could lock in the wrong starting values if they build on each other, like tl.to(obj, {x: 100}).to(obj, {x: 0}).
            }
            if (!prevTime && time && !suppressEvents && !iteration) {
                _callback(this, "onStart");
                if (this._tTime !== tTime) // in case the onStart triggered a render at a different spot, eject. Like if someone did animation.pause(0.5) or something inside the onStart.
                return this;
            }
            if (time >= prevTime && totalTime >= 0) {
                child = this._first;
                while(child){
                    next = child._next;
                    if ((child._act || time >= child._start) && child._ts && pauseTween !== child) {
                        if (child.parent !== this) // an extreme edge case - the child's render could do something like kill() the "next" one in the linked list, or reparent it. In that case we must re-initiate the whole render to be safe.
                        return this.render(totalTime, suppressEvents, force);
                        child.render(child._ts > 0 ? (time - child._start) * child._ts : (child._dirty ? child.totalDuration() : child._tDur) + (time - child._start) * child._ts, suppressEvents, force);
                        if (time !== this._time || !this._ts && !prevPaused) {
                            //in case a tween pauses or seeks the timeline when rendering, like inside of an onUpdate/onComplete
                            pauseTween = 0;
                            next && (tTime += this._zTime = -_tinyNum); // it didn't finish rendering, so flag zTime as negative so that the next time render() is called it'll be forced (to render any remaining children)
                            break;
                        }
                    }
                    child = next;
                }
            } else {
                child = this._last;
                var adjustedTime = totalTime < 0 ? totalTime : time; //when the playhead goes backward beyond the start of this timeline, we must pass that information down to the child animations so that zero-duration tweens know whether to render their starting or ending values.
                while(child){
                    next = child._prev;
                    if ((child._act || adjustedTime <= child._end) && child._ts && pauseTween !== child) {
                        if (child.parent !== this) // an extreme edge case - the child's render could do something like kill() the "next" one in the linked list, or reparent it. In that case we must re-initiate the whole render to be safe.
                        return this.render(totalTime, suppressEvents, force);
                        child.render(child._ts > 0 ? (adjustedTime - child._start) * child._ts : (child._dirty ? child.totalDuration() : child._tDur) + (adjustedTime - child._start) * child._ts, suppressEvents, force || _reverting && (child._initted || child._startAt)); // if reverting, we should always force renders of initted tweens (but remember that .fromTo() or .from() may have a _startAt but not _initted yet). If, for example, a .fromTo() tween with a stagger (which creates an internal timeline) gets reverted BEFORE some of its child tweens render for the first time, it may not properly trigger them to revert.
                        if (time !== this._time || !this._ts && !prevPaused) {
                            //in case a tween pauses or seeks the timeline when rendering, like inside of an onUpdate/onComplete
                            pauseTween = 0;
                            next && (tTime += this._zTime = adjustedTime ? -_tinyNum : _tinyNum); // it didn't finish rendering, so adjust zTime so that so that the next time render() is called it'll be forced (to render any remaining children)
                            break;
                        }
                    }
                    child = next;
                }
            }
            if (pauseTween && !suppressEvents) {
                this.pause();
                pauseTween.render(time >= prevTime ? 0 : -_tinyNum)._zTime = time >= prevTime ? 1 : -1;
                if (this._ts) {
                    //the callback resumed playback! So since we may have held back the playhead due to where the pause is positioned, go ahead and jump to where it's SUPPOSED to be (if no pause happened).
                    this._start = prevStart; //if the pause was at an earlier time and the user resumed in the callback, it could reposition the timeline (changing its startTime), throwing things off slightly, so we make sure the _start doesn't shift.
                    _setEnd(this);
                    return this.render(totalTime, suppressEvents, force);
                }
            }
            this._onUpdate && !suppressEvents && _callback(this, "onUpdate", true);
            if (tTime === tDur && this._tTime >= this.totalDuration() || !tTime && prevTime) {
                if (prevStart === this._start || Math.abs(timeScale) !== Math.abs(this._ts)) {
                    if (!this._lock) {
                        // remember, a child's callback may alter this timeline's playhead or timeScale which is why we need to add some of these checks.
                        (totalTime || !dur) && (tTime === tDur && this._ts > 0 || !tTime && this._ts < 0) && _removeFromParent(this, 1); // don't remove if the timeline is reversed and the playhead isn't at 0, otherwise tl.progress(1).reverse() won't work. Only remove if the playhead is at the end and timeScale is positive, or if the playhead is at 0 and the timeScale is negative.
                        if (!suppressEvents && !(totalTime < 0 && !prevTime) && (tTime || prevTime || !tDur)) {
                            _callback(this, tTime === tDur && totalTime >= 0 ? "onComplete" : "onReverseComplete", true);
                            this._prom && !(tTime < tDur && this.timeScale() > 0) && this._prom();
                        }
                    }
                }
            }
        }
        return this;
    };
    _proto2.add = function add(child, position) {
        var _this2 = this;
        _isNumber(position) || (position = _parsePosition(this, position, child));
        if (!(child instanceof Animation)) {
            if (_isArray(child)) {
                child.forEach(function(obj) {
                    return _this2.add(obj, position);
                });
                return this;
            }
            if (_isString(child)) return this.addLabel(child, position);
            if (_isFunction(child)) child = Tween.delayedCall(0, child);
            else return this;
        }
        return this !== child ? _addToTimeline(this, child, position) : this; //don't allow a timeline to be added to itself as a child!
    };
    _proto2.getChildren = function getChildren(nested, tweens, timelines, ignoreBeforeTime) {
        if (nested === void 0) nested = true;
        if (tweens === void 0) tweens = true;
        if (timelines === void 0) timelines = true;
        if (ignoreBeforeTime === void 0) ignoreBeforeTime = -_bigNum;
        var a = [], child = this._first;
        while(child){
            if (child._start >= ignoreBeforeTime) {
                if (child instanceof Tween) tweens && a.push(child);
                else {
                    timelines && a.push(child);
                    nested && a.push.apply(a, child.getChildren(true, tweens, timelines));
                }
            }
            child = child._next;
        }
        return a;
    };
    _proto2.getById = function getById(id) {
        var animations = this.getChildren(1, 1, 1), i = animations.length;
        while(i--){
            if (animations[i].vars.id === id) return animations[i];
        }
    };
    _proto2.remove = function remove(child) {
        if (_isString(child)) return this.removeLabel(child);
        if (_isFunction(child)) return this.killTweensOf(child);
        child.parent === this && _removeLinkedListItem(this, child);
        if (child === this._recent) this._recent = this._last;
        return _uncache(this);
    };
    _proto2.totalTime = function totalTime(_totalTime2, suppressEvents) {
        if (!arguments.length) return this._tTime;
        this._forcing = 1;
        if (!this._dp && this._ts) //special case for the global timeline (or any other that has no parent or detached parent).
        this._start = _roundPrecise(_ticker.time - (this._ts > 0 ? _totalTime2 / this._ts : (this.totalDuration() - _totalTime2) / -this._ts));
        _Animation.prototype.totalTime.call(this, _totalTime2, suppressEvents);
        this._forcing = 0;
        return this;
    };
    _proto2.addLabel = function addLabel(label, position) {
        this.labels[label] = _parsePosition(this, position);
        return this;
    };
    _proto2.removeLabel = function removeLabel(label) {
        delete this.labels[label];
        return this;
    };
    _proto2.addPause = function addPause(position, callback, params) {
        var t = Tween.delayedCall(0, callback || _emptyFunc, params);
        t.data = "isPause";
        this._hasPause = 1;
        return _addToTimeline(this, t, _parsePosition(this, position));
    };
    _proto2.removePause = function removePause(position) {
        var child = this._first;
        position = _parsePosition(this, position);
        while(child){
            if (child._start === position && child.data === "isPause") _removeFromParent(child);
            child = child._next;
        }
    };
    _proto2.killTweensOf = function killTweensOf(targets, props, onlyActive) {
        var tweens = this.getTweensOf(targets, onlyActive), i = tweens.length;
        while(i--)_overwritingTween !== tweens[i] && tweens[i].kill(targets, props);
        return this;
    };
    _proto2.getTweensOf = function getTweensOf(targets, onlyActive) {
        var a = [], parsedTargets = toArray(targets), child = this._first, isGlobalTime = _isNumber(onlyActive), // a number is interpreted as a global time. If the animation spans
        children;
        while(child){
            if (child instanceof Tween) {
                if (_arrayContainsAny(child._targets, parsedTargets) && (isGlobalTime ? (!_overwritingTween || child._initted && child._ts) && child.globalTime(0) <= onlyActive && child.globalTime(child.totalDuration()) > onlyActive : !onlyActive || child.isActive())) // note: if this is for overwriting, it should only be for tweens that aren't paused and are initted.
                a.push(child);
            } else if ((children = child.getTweensOf(parsedTargets, onlyActive)).length) a.push.apply(a, children);
            child = child._next;
        }
        return a;
    } // potential future feature - targets() on timelines
    ;
    _proto2.tweenTo = function tweenTo(position, vars) {
        vars = vars || {};
        var tl = this, endTime = _parsePosition(tl, position), _vars = vars, startAt = _vars.startAt, _onStart = _vars.onStart, onStartParams = _vars.onStartParams, immediateRender = _vars.immediateRender, initted, tween = Tween.to(tl, _setDefaults({
            ease: vars.ease || "none",
            lazy: false,
            immediateRender: false,
            time: endTime,
            overwrite: "auto",
            duration: vars.duration || Math.abs((endTime - (startAt && "time" in startAt ? startAt.time : tl._time)) / tl.timeScale()) || _tinyNum,
            onStart: function onStart() {
                tl.pause();
                if (!initted) {
                    var duration = vars.duration || Math.abs((endTime - (startAt && "time" in startAt ? startAt.time : tl._time)) / tl.timeScale());
                    tween._dur !== duration && _setDuration(tween, duration, 0, 1).render(tween._time, true, true);
                    initted = 1;
                }
                _onStart && _onStart.apply(tween, onStartParams || []); //in case the user had an onStart in the vars - we don't want to overwrite it.
            }
        }, vars));
        return immediateRender ? tween.render(0) : tween;
    };
    _proto2.tweenFromTo = function tweenFromTo(fromPosition, toPosition, vars) {
        return this.tweenTo(toPosition, _setDefaults({
            startAt: {
                time: _parsePosition(this, fromPosition)
            }
        }, vars));
    };
    _proto2.recent = function recent() {
        return this._recent;
    };
    _proto2.nextLabel = function nextLabel(afterTime) {
        if (afterTime === void 0) afterTime = this._time;
        return _getLabelInDirection(this, _parsePosition(this, afterTime));
    };
    _proto2.previousLabel = function previousLabel(beforeTime) {
        if (beforeTime === void 0) beforeTime = this._time;
        return _getLabelInDirection(this, _parsePosition(this, beforeTime), 1);
    };
    _proto2.currentLabel = function currentLabel(value) {
        return arguments.length ? this.seek(value, true) : this.previousLabel(this._time + _tinyNum);
    };
    _proto2.shiftChildren = function shiftChildren(amount, adjustLabels, ignoreBeforeTime) {
        if (ignoreBeforeTime === void 0) ignoreBeforeTime = 0;
        var child = this._first, labels = this.labels, p;
        while(child){
            if (child._start >= ignoreBeforeTime) {
                child._start += amount;
                child._end += amount;
            }
            child = child._next;
        }
        if (adjustLabels) {
            for(p in labels)if (labels[p] >= ignoreBeforeTime) labels[p] += amount;
        }
        return _uncache(this);
    };
    _proto2.invalidate = function invalidate(soft) {
        var child = this._first;
        this._lock = 0;
        while(child){
            child.invalidate(soft);
            child = child._next;
        }
        return _Animation.prototype.invalidate.call(this, soft);
    };
    _proto2.clear = function clear(includeLabels) {
        if (includeLabels === void 0) includeLabels = true;
        var child = this._first, next;
        while(child){
            next = child._next;
            this.remove(child);
            child = next;
        }
        this._dp && (this._time = this._tTime = this._pTime = 0);
        includeLabels && (this.labels = {});
        return _uncache(this);
    };
    _proto2.totalDuration = function totalDuration(value) {
        var max = 0, self = this, child = self._last, prevStart = _bigNum, prev, start, parent;
        if (arguments.length) return self.timeScale((self._repeat < 0 ? self.duration() : self.totalDuration()) / (self.reversed() ? -value : value));
        if (self._dirty) {
            parent = self.parent;
            while(child){
                prev = child._prev; //record it here in case the tween changes position in the sequence...
                child._dirty && child.totalDuration(); //could change the tween._startTime, so make sure the animation's cache is clean before analyzing it.
                start = child._start;
                if (start > prevStart && self._sort && child._ts && !self._lock) {
                    //in case one of the tweens shifted out of order, it needs to be re-inserted into the correct position in the sequence
                    self._lock = 1; //prevent endless recursive calls - there are methods that get triggered that check duration/totalDuration when we add().
                    _addToTimeline(self, child, start - child._delay, 1)._lock = 0;
                } else prevStart = start;
                if (start < 0 && child._ts) {
                    //children aren't allowed to have negative startTimes unless smoothChildTiming is true, so adjust here if one is found.
                    max -= start;
                    if (!parent && !self._dp || parent && parent.smoothChildTiming) {
                        self._start += start / self._ts;
                        self._time -= start;
                        self._tTime -= start;
                    }
                    self.shiftChildren(-start, false, -Infinity);
                    prevStart = 0;
                }
                child._end > max && child._ts && (max = child._end);
                child = prev;
            }
            _setDuration(self, self === _globalTimeline && self._time > max ? self._time : max, 1, 1);
            self._dirty = 0;
        }
        return self._tDur;
    };
    Timeline.updateRoot = function updateRoot(time) {
        if (_globalTimeline._ts) {
            _lazySafeRender(_globalTimeline, _parentToChildTotalTime(time, _globalTimeline));
            _lastRenderedFrame = _ticker.frame;
        }
        if (_ticker.frame >= _nextGCFrame) {
            _nextGCFrame += _config.autoSleep || 120;
            var child = _globalTimeline._first;
            if (!child || !child._ts) {
                if (_config.autoSleep && _ticker._listeners.length < 2) {
                    while(child && !child._ts)child = child._next;
                    child || _ticker.sleep();
                }
            }
        }
    };
    return Timeline;
}(Animation);
_setDefaults(Timeline.prototype, {
    _lock: 0,
    _hasPause: 0,
    _forcing: 0
});
var _addComplexStringPropTween = function _addComplexStringPropTween(target, prop, start, end, setter, stringFilter, funcParam) {
    //note: we call _addComplexStringPropTween.call(tweenInstance...) to ensure that it's scoped properly. We may call it from within a plugin too, thus "this" would refer to the plugin.
    var pt = new PropTween(this._pt, target, prop, 0, 1, _renderComplexString, null, setter), index = 0, matchIndex = 0, result, startNums, color, endNum, chunk, startNum, hasRandom, a;
    pt.b = start;
    pt.e = end;
    start += ""; //ensure values are strings
    end += "";
    if (hasRandom = ~end.indexOf("random(")) end = _replaceRandom(end);
    if (stringFilter) {
        a = [
            start,
            end
        ];
        stringFilter(a, target, prop); //pass an array with the starting and ending values and let the filter do whatever it needs to the values.
        start = a[0];
        end = a[1];
    }
    startNums = start.match(_complexStringNumExp) || [];
    while(result = _complexStringNumExp.exec(end)){
        endNum = result[0];
        chunk = end.substring(index, result.index);
        if (color) color = (color + 1) % 5;
        else if (chunk.substr(-5) === "rgba(") color = 1;
        if (endNum !== startNums[matchIndex++]) {
            startNum = parseFloat(startNums[matchIndex - 1]) || 0; //these nested PropTweens are handled in a special way - we'll never actually call a render or setter method on them. We'll just loop through them in the parent complex string PropTween's render method.
            pt._pt = {
                _next: pt._pt,
                p: chunk || matchIndex === 1 ? chunk : ",",
                //note: SVG spec allows omission of comma/space when a negative sign is wedged between two numbers, like 2.5-5.3 instead of 2.5,-5.3 but when tweening, the negative value may switch to positive, so we insert the comma just in case.
                s: startNum,
                c: endNum.charAt(1) === "=" ? _parseRelative(startNum, endNum) - startNum : parseFloat(endNum) - startNum,
                m: color && color < 4 ? Math.round : 0
            };
            index = _complexStringNumExp.lastIndex;
        }
    }
    pt.c = index < end.length ? end.substring(index, end.length) : ""; //we use the "c" of the PropTween to store the final part of the string (after the last number)
    pt.fp = funcParam;
    if (_relExp.test(end) || hasRandom) pt.e = 0; //if the end string contains relative values or dynamic random(...) values, delete the end it so that on the final render we don't actually set it to the string with += or -= characters (forces it to use the calculated value).
    this._pt = pt; //start the linked list with this new PropTween. Remember, we call _addComplexStringPropTween.call(tweenInstance...) to ensure that it's scoped properly. We may call it from within a plugin too, thus "this" would refer to the plugin.
    return pt;
}, _addPropTween = function _addPropTween(target, prop, start, end, index, targets, modifier, stringFilter, funcParam, optional) {
    _isFunction(end) && (end = end(index || 0, target, targets));
    var currentValue = target[prop], parsedStart = start !== "get" ? start : !_isFunction(currentValue) ? currentValue : funcParam ? target[prop.indexOf("set") || !_isFunction(target["get" + prop.substr(3)]) ? prop : "get" + prop.substr(3)](funcParam) : target[prop](), setter = !_isFunction(currentValue) ? _setterPlain : funcParam ? _setterFuncWithParam : _setterFunc, pt;
    if (_isString(end)) {
        if (~end.indexOf("random(")) end = _replaceRandom(end);
        if (end.charAt(1) === "=") {
            pt = _parseRelative(parsedStart, end) + (getUnit(parsedStart) || 0);
            if (pt || pt === 0) // to avoid isNaN, like if someone passes in a value like "!= whatever"
            end = pt;
        }
    }
    if (!optional || parsedStart !== end || _forceAllPropTweens) {
        if (!isNaN(parsedStart * end) && end !== "") {
            // fun fact: any number multiplied by "" is evaluated as the number 0!
            pt = new PropTween(this._pt, target, prop, +parsedStart || 0, end - (parsedStart || 0), typeof currentValue === "boolean" ? _renderBoolean : _renderPlain, 0, setter);
            funcParam && (pt.fp = funcParam);
            modifier && pt.modifier(modifier, this, target);
            return this._pt = pt;
        }
        !currentValue && !(prop in target) && _missingPlugin(prop, end);
        return _addComplexStringPropTween.call(this, target, prop, parsedStart, end, setter, stringFilter || _config.stringFilter, funcParam);
    }
}, //creates a copy of the vars object and processes any function-based values (putting the resulting values directly into the copy) as well as strings with "random()" in them. It does NOT process relative values.
_processVars = function _processVars(vars, index, target, targets, tween) {
    _isFunction(vars) && (vars = _parseFuncOrString(vars, tween, index, target, targets));
    if (!_isObject(vars) || vars.style && vars.nodeType || _isArray(vars) || _isTypedArray(vars)) return _isString(vars) ? _parseFuncOrString(vars, tween, index, target, targets) : vars;
    var copy = {}, p;
    for(p in vars)copy[p] = _parseFuncOrString(vars[p], tween, index, target, targets);
    return copy;
}, _checkPlugin = function _checkPlugin(property, vars, tween, index, target, targets) {
    var plugin, pt, ptLookup, i;
    if (_plugins[property] && (plugin = new _plugins[property]()).init(target, plugin.rawVars ? vars[property] : _processVars(vars[property], index, target, targets, tween), tween, index, targets) !== false) {
        tween._pt = pt = new PropTween(tween._pt, target, property, 0, 1, plugin.render, plugin, 0, plugin.priority);
        if (tween !== _quickTween) {
            ptLookup = tween._ptLookup[tween._targets.indexOf(target)]; //note: we can't use tween._ptLookup[index] because for staggered tweens, the index from the fullTargets array won't match what it is in each individual tween that spawns from the stagger.
            i = plugin._props.length;
            while(i--)ptLookup[plugin._props[i]] = pt;
        }
    }
    return plugin;
}, _overwritingTween, //store a reference temporarily so we can avoid overwriting itself.
_forceAllPropTweens, _initTween = function _initTween(tween, time, tTime) {
    var vars = tween.vars, ease = vars.ease, startAt = vars.startAt, immediateRender = vars.immediateRender, lazy = vars.lazy, onUpdate = vars.onUpdate, runBackwards = vars.runBackwards, yoyoEase = vars.yoyoEase, keyframes = vars.keyframes, autoRevert = vars.autoRevert, dur = tween._dur, prevStartAt = tween._startAt, targets = tween._targets, parent = tween.parent, fullTargets = parent && parent.data === "nested" ? parent.vars.targets : targets, autoOverwrite = tween._overwrite === "auto" && !_suppressOverwrites, tl = tween.timeline, cleanVars, i, p, pt, target, hasPriority, gsData, harness, plugin, ptLookup, index, harnessVars, overwritten;
    tl && (!keyframes || !ease) && (ease = "none");
    tween._ease = _parseEase(ease, _defaults.ease);
    tween._yEase = yoyoEase ? _invertEase(_parseEase(yoyoEase === true ? ease : yoyoEase, _defaults.ease)) : 0;
    if (yoyoEase && tween._yoyo && !tween._repeat) {
        //there must have been a parent timeline with yoyo:true that is currently in its yoyo phase, so flip the eases.
        yoyoEase = tween._yEase;
        tween._yEase = tween._ease;
        tween._ease = yoyoEase;
    }
    tween._from = !tl && !!vars.runBackwards; //nested timelines should never run backwards - the backwards-ness is in the child tweens.
    if (!tl || keyframes && !vars.stagger) {
        //if there's an internal timeline, skip all the parsing because we passed that task down the chain.
        harness = targets[0] ? _getCache(targets[0]).harness : 0;
        harnessVars = harness && vars[harness.prop]; //someone may need to specify CSS-specific values AND non-CSS values, like if the element has an "x" property plus it's a standard DOM element. We allow people to distinguish by wrapping plugin-specific stuff in a css:{} object for example.
        cleanVars = _copyExcluding(vars, _reservedProps);
        if (prevStartAt) {
            prevStartAt._zTime < 0 && prevStartAt.progress(1); // in case it's a lazy startAt that hasn't rendered yet.
            time < 0 && runBackwards && immediateRender && !autoRevert ? prevStartAt.render(-1, true) : prevStartAt.revert(runBackwards && dur ? _revertConfigNoKill : _startAtRevertConfig); // if it's a "startAt" (not "from()" or runBackwards: true), we only need to do a shallow revert (keep transforms cached in CSSPlugin)
            // don't just _removeFromParent(prevStartAt.render(-1, true)) because that'll leave inline styles. We're creating a new _startAt for "startAt" tweens that re-capture things to ensure that if the pre-tween values changed since the tween was created, they're recorded.
            prevStartAt._lazy = 0;
        }
        if (startAt) {
            _removeFromParent(tween._startAt = Tween.set(targets, _setDefaults({
                data: "isStart",
                overwrite: false,
                parent: parent,
                immediateRender: true,
                lazy: !prevStartAt && _isNotFalse(lazy),
                startAt: null,
                delay: 0,
                onUpdate: onUpdate && function() {
                    return _callback(tween, "onUpdate");
                },
                stagger: 0
            }, startAt))); //copy the properties/values into a new object to avoid collisions, like var to = {x:0}, from = {x:500}; timeline.fromTo(e, from, to).fromTo(e, to, from);
            tween._startAt._dp = 0; // don't allow it to get put back into root timeline! Like when revert() is called and totalTime() gets set.
            tween._startAt._sat = tween; // used in globalTime(). _sat stands for _startAtTween
            time < 0 && (_reverting || !immediateRender && !autoRevert) && tween._startAt.revert(_revertConfigNoKill); // rare edge case, like if a render is forced in the negative direction of a non-initted tween.
            if (immediateRender) {
                if (dur && time <= 0 && tTime <= 0) {
                    // check tTime here because in the case of a yoyo tween whose playhead gets pushed to the end like tween.progress(1), we should allow it through so that the onComplete gets fired properly.
                    time && (tween._zTime = time);
                    return; //we skip initialization here so that overwriting doesn't occur until the tween actually begins. Otherwise, if you create several immediateRender:true tweens of the same target/properties to drop into a Timeline, the last one created would overwrite the first ones because they didn't get placed into the timeline yet before the first render occurs and kicks in overwriting.
                }
            }
        } else if (runBackwards && dur) //from() tweens must be handled uniquely: their beginning values must be rendered but we don't want overwriting to occur yet (when time is still 0). Wait until the tween actually begins before doing all the routines like overwriting. At that time, we should render at the END of the tween to ensure that things initialize correctly (remember, from() tweens go backwards)
        {
            if (!prevStartAt) {
                time && (immediateRender = false); //in rare cases (like if a from() tween runs and then is invalidate()-ed), immediateRender could be true but the initial forced-render gets skipped, so there's no need to force the render in this context when the _time is greater than 0
                p = _setDefaults({
                    overwrite: false,
                    data: "isFromStart",
                    //we tag the tween with as "isFromStart" so that if [inside a plugin] we need to only do something at the very END of a tween, we have a way of identifying this tween as merely the one that's setting the beginning values for a "from()" tween. For example, clearProps in CSSPlugin should only get applied at the very END of a tween and without this tag, from(...{height:100, clearProps:"height", delay:1}) would wipe the height at the beginning of the tween and after 1 second, it'd kick back in.
                    lazy: immediateRender && !prevStartAt && _isNotFalse(lazy),
                    immediateRender: immediateRender,
                    //zero-duration tweens render immediately by default, but if we're not specifically instructed to render this tween immediately, we should skip this and merely _init() to record the starting values (rendering them immediately would push them to completion which is wasteful in that case - we'd have to render(-1) immediately after)
                    stagger: 0,
                    parent: parent //ensures that nested tweens that had a stagger are handled properly, like gsap.from(".class", {y: gsap.utils.wrap([-100,100]), stagger: 0.5})
                }, cleanVars);
                harnessVars && (p[harness.prop] = harnessVars); // in case someone does something like .from(..., {css:{}})
                _removeFromParent(tween._startAt = Tween.set(targets, p));
                tween._startAt._dp = 0; // don't allow it to get put back into root timeline!
                tween._startAt._sat = tween; // used in globalTime()
                time < 0 && (_reverting ? tween._startAt.revert(_revertConfigNoKill) : tween._startAt.render(-1, true));
                tween._zTime = time;
                if (!immediateRender) _initTween(tween._startAt, _tinyNum, _tinyNum); //ensures that the initial values are recorded
                else if (!time) return;
            }
        }
        tween._pt = tween._ptCache = 0;
        lazy = dur && _isNotFalse(lazy) || lazy && !dur;
        for(i = 0; i < targets.length; i++){
            target = targets[i];
            gsData = target._gsap || _harness(targets)[i]._gsap;
            tween._ptLookup[i] = ptLookup = {};
            _lazyLookup[gsData.id] && _lazyTweens.length && _lazyRender(); //if other tweens of the same target have recently initted but haven't rendered yet, we've got to force the render so that the starting values are correct (imagine populating a timeline with a bunch of sequential tweens and then jumping to the end)
            index = fullTargets === targets ? i : fullTargets.indexOf(target);
            if (harness && (plugin = new harness()).init(target, harnessVars || cleanVars, tween, index, fullTargets) !== false) {
                tween._pt = pt = new PropTween(tween._pt, target, plugin.name, 0, 1, plugin.render, plugin, 0, plugin.priority);
                plugin._props.forEach(function(name) {
                    ptLookup[name] = pt;
                });
                plugin.priority && (hasPriority = 1);
            }
            if (!harness || harnessVars) {
                for(p in cleanVars)if (_plugins[p] && (plugin = _checkPlugin(p, cleanVars, tween, index, target, fullTargets))) plugin.priority && (hasPriority = 1);
                else ptLookup[p] = pt = _addPropTween.call(tween, target, p, "get", cleanVars[p], index, fullTargets, 0, vars.stringFilter);
            }
            tween._op && tween._op[i] && tween.kill(target, tween._op[i]);
            if (autoOverwrite && tween._pt) {
                _overwritingTween = tween;
                _globalTimeline.killTweensOf(target, ptLookup, tween.globalTime(time)); // make sure the overwriting doesn't overwrite THIS tween!!!
                overwritten = !tween.parent;
                _overwritingTween = 0;
            }
            tween._pt && lazy && (_lazyLookup[gsData.id] = 1);
        }
        hasPriority && _sortPropTweensByPriority(tween);
        tween._onInit && tween._onInit(tween); //plugins like RoundProps must wait until ALL of the PropTweens are instantiated. In the plugin's init() function, it sets the _onInit on the tween instance. May not be pretty/intuitive, but it's fast and keeps file size down.
    }
    tween._onUpdate = onUpdate;
    tween._initted = (!tween._op || tween._pt) && !overwritten; // if overwrittenProps resulted in the entire tween being killed, do NOT flag it as initted or else it may render for one tick.
    keyframes && time <= 0 && tl.render(_bigNum, true, true); // if there's a 0% keyframe, it'll render in the "before" state for any staggered/delayed animations thus when the following tween initializes, it'll use the "before" state instead of the "after" state as the initial values.
}, _updatePropTweens = function _updatePropTweens(tween, property, value, start, startIsRelative, ratio, time, skipRecursion) {
    var ptCache = (tween._pt && tween._ptCache || (tween._ptCache = {}))[property], pt, rootPT, lookup, i;
    if (!ptCache) {
        ptCache = tween._ptCache[property] = [];
        lookup = tween._ptLookup;
        i = tween._targets.length;
        while(i--){
            pt = lookup[i][property];
            if (pt && pt.d && pt.d._pt) {
                // it's a plugin, so find the nested PropTween
                pt = pt.d._pt;
                while(pt && pt.p !== property && pt.fp !== property)// "fp" is functionParam for things like setting CSS variables which require .setProperty("--var-name", value)
                pt = pt._next;
            }
            if (!pt) {
                // there is no PropTween associated with that property, so we must FORCE one to be created and ditch out of this
                // if the tween has other properties that already rendered at new positions, we'd normally have to rewind to put them back like tween.render(0, true) before forcing an _initTween(), but that can create another edge case like tweening a timeline's progress would trigger onUpdates to fire which could move other things around. It's better to just inform users that .resetTo() should ONLY be used for tweens that already have that property. For example, you can't gsap.to(...{ y: 0 }) and then tween.restTo("x", 200) for example.
                _forceAllPropTweens = 1; // otherwise, when we _addPropTween() and it finds no change between the start and end values, it skips creating a PropTween (for efficiency...why tween when there's no difference?) but in this case we NEED that PropTween created so we can edit it.
                tween.vars[property] = "+=0";
                _initTween(tween, time);
                _forceAllPropTweens = 0;
                return skipRecursion ? _warn(property + " not eligible for reset") : 1; // if someone tries to do a quickTo() on a special property like borderRadius which must get split into 4 different properties, that's not eligible for .resetTo().
            }
            ptCache.push(pt);
        }
    }
    i = ptCache.length;
    while(i--){
        rootPT = ptCache[i];
        pt = rootPT._pt || rootPT; // complex values may have nested PropTweens. We only accommodate the FIRST value.
        pt.s = (start || start === 0) && !startIsRelative ? start : pt.s + (start || 0) + ratio * pt.c;
        pt.c = value - pt.s;
        rootPT.e && (rootPT.e = _round(value) + getUnit(rootPT.e)); // mainly for CSSPlugin (end value)
        rootPT.b && (rootPT.b = pt.s + getUnit(rootPT.b)); // (beginning value)
    }
}, _addAliasesToVars = function _addAliasesToVars(targets, vars) {
    var harness = targets[0] ? _getCache(targets[0]).harness : 0, propertyAliases = harness && harness.aliases, copy, p, i, aliases;
    if (!propertyAliases) return vars;
    copy = _merge({}, vars);
    for(p in propertyAliases)if (p in copy) {
        aliases = propertyAliases[p].split(",");
        i = aliases.length;
        while(i--)copy[aliases[i]] = copy[p];
    }
    return copy;
}, // parses multiple formats, like {"0%": {x: 100}, {"50%": {x: -20}} and { x: {"0%": 100, "50%": -20} }, and an "ease" can be set on any object. We populate an "allProps" object with an Array for each property, like {x: [{}, {}], y:[{}, {}]} with data for each property tween. The objects have a "t" (time), "v", (value), and "e" (ease) property. This allows us to piece together a timeline later.
_parseKeyframe = function _parseKeyframe(prop, obj, allProps, easeEach) {
    var ease = obj.ease || easeEach || "power1.inOut", p, a;
    if (_isArray(obj)) {
        a = allProps[prop] || (allProps[prop] = []); // t = time (out of 100), v = value, e = ease
        obj.forEach(function(value, i) {
            return a.push({
                t: i / (obj.length - 1) * 100,
                v: value,
                e: ease
            });
        });
    } else for(p in obj){
        a = allProps[p] || (allProps[p] = []);
        p === "ease" || a.push({
            t: parseFloat(prop),
            v: obj[p],
            e: ease
        });
    }
}, _parseFuncOrString = function _parseFuncOrString(value, tween, i, target, targets) {
    return _isFunction(value) ? value.call(tween, i, target, targets) : _isString(value) && ~value.indexOf("random(") ? _replaceRandom(value) : value;
}, _staggerTweenProps = _callbackNames + "repeat,repeatDelay,yoyo,repeatRefresh,yoyoEase,autoRevert", _staggerPropsToSkip = {};
_forEachName(_staggerTweenProps + ",id,stagger,delay,duration,paused,scrollTrigger", function(name) {
    return _staggerPropsToSkip[name] = 1;
});
var Tween = /*#__PURE__*/ function(_Animation2) {
    _inheritsLoose(Tween, _Animation2);
    function Tween(targets, vars, position, skipInherit) {
        var _this3;
        if (typeof vars === "number") {
            position.duration = vars;
            vars = position;
            position = null;
        }
        _this3 = _Animation2.call(this, skipInherit ? vars : _inheritDefaults(vars)) || this;
        var _this3$vars = _this3.vars, duration = _this3$vars.duration, delay = _this3$vars.delay, immediateRender = _this3$vars.immediateRender, stagger = _this3$vars.stagger, overwrite = _this3$vars.overwrite, keyframes = _this3$vars.keyframes, defaults = _this3$vars.defaults, scrollTrigger = _this3$vars.scrollTrigger, yoyoEase = _this3$vars.yoyoEase, parent = vars.parent || _globalTimeline, parsedTargets = (_isArray(targets) || _isTypedArray(targets) ? _isNumber(targets[0]) : "length" in vars) ? [
            targets
        ] : toArray(targets), tl, i, copy, l, p, curTarget, staggerFunc, staggerVarsToMerge;
        _this3._targets = parsedTargets.length ? _harness(parsedTargets) : _warn("GSAP target " + targets + " not found. https://gsap.com", !_config.nullTargetWarn) || [];
        _this3._ptLookup = []; //PropTween lookup. An array containing an object for each target, having keys for each tweening property
        _this3._overwrite = overwrite;
        if (keyframes || stagger || _isFuncOrString(duration) || _isFuncOrString(delay)) {
            vars = _this3.vars;
            tl = _this3.timeline = new Timeline({
                data: "nested",
                defaults: defaults || {},
                targets: parent && parent.data === "nested" ? parent.vars.targets : parsedTargets
            }); // we need to store the targets because for staggers and keyframes, we end up creating an individual tween for each but function-based values need to know the index and the whole Array of targets.
            tl.kill();
            tl.parent = tl._dp = _assertThisInitialized(_this3);
            tl._start = 0;
            if (stagger || _isFuncOrString(duration) || _isFuncOrString(delay)) {
                l = parsedTargets.length;
                staggerFunc = stagger && distribute(stagger);
                if (_isObject(stagger)) {
                    //users can pass in callbacks like onStart/onComplete in the stagger object. These should fire with each individual tween.
                    for(p in stagger)if (~_staggerTweenProps.indexOf(p)) {
                        staggerVarsToMerge || (staggerVarsToMerge = {});
                        staggerVarsToMerge[p] = stagger[p];
                    }
                }
                for(i = 0; i < l; i++){
                    copy = _copyExcluding(vars, _staggerPropsToSkip);
                    copy.stagger = 0;
                    yoyoEase && (copy.yoyoEase = yoyoEase);
                    staggerVarsToMerge && _merge(copy, staggerVarsToMerge);
                    curTarget = parsedTargets[i]; //don't just copy duration or delay because if they're a string or function, we'd end up in an infinite loop because _isFuncOrString() would evaluate as true in the child tweens, entering this loop, etc. So we parse the value straight from vars and default to 0.
                    copy.duration = +_parseFuncOrString(duration, _assertThisInitialized(_this3), i, curTarget, parsedTargets);
                    copy.delay = (+_parseFuncOrString(delay, _assertThisInitialized(_this3), i, curTarget, parsedTargets) || 0) - _this3._delay;
                    if (!stagger && l === 1 && copy.delay) {
                        // if someone does delay:"random(1, 5)", repeat:-1, for example, the delay shouldn't be inside the repeat.
                        _this3._delay = delay = copy.delay;
                        _this3._start += delay;
                        copy.delay = 0;
                    }
                    tl.to(curTarget, copy, staggerFunc ? staggerFunc(i, curTarget, parsedTargets) : 0);
                    tl._ease = _easeMap.none;
                }
                tl.duration() ? duration = delay = 0 : _this3.timeline = 0; // if the timeline's duration is 0, we don't need a timeline internally!
            } else if (keyframes) {
                _inheritDefaults(_setDefaults(tl.vars.defaults, {
                    ease: "none"
                }));
                tl._ease = _parseEase(keyframes.ease || vars.ease || "none");
                var time = 0, a, kf, v;
                if (_isArray(keyframes)) {
                    keyframes.forEach(function(frame) {
                        return tl.to(parsedTargets, frame, ">");
                    });
                    tl.duration(); // to ensure tl._dur is cached because we tap into it for performance purposes in the render() method.
                } else {
                    copy = {};
                    for(p in keyframes)p === "ease" || p === "easeEach" || _parseKeyframe(p, keyframes[p], copy, keyframes.easeEach);
                    for(p in copy){
                        a = copy[p].sort(function(a, b) {
                            return a.t - b.t;
                        });
                        time = 0;
                        for(i = 0; i < a.length; i++){
                            kf = a[i];
                            v = {
                                ease: kf.e,
                                duration: (kf.t - (i ? a[i - 1].t : 0)) / 100 * duration
                            };
                            v[p] = kf.v;
                            tl.to(parsedTargets, v, time);
                            time += v.duration;
                        }
                    }
                    tl.duration() < duration && tl.to({}, {
                        duration: duration - tl.duration()
                    }); // in case keyframes didn't go to 100%
                }
            }
            duration || _this3.duration(duration = tl.duration());
        } else _this3.timeline = 0; //speed optimization, faster lookups (no going up the prototype chain)
        if (overwrite === true && !_suppressOverwrites) {
            _overwritingTween = _assertThisInitialized(_this3);
            _globalTimeline.killTweensOf(parsedTargets);
            _overwritingTween = 0;
        }
        _addToTimeline(parent, _assertThisInitialized(_this3), position);
        vars.reversed && _this3.reverse();
        vars.paused && _this3.paused(true);
        if (immediateRender || !duration && !keyframes && _this3._start === _roundPrecise(parent._time) && _isNotFalse(immediateRender) && _hasNoPausedAncestors(_assertThisInitialized(_this3)) && parent.data !== "nested") {
            _this3._tTime = -_tinyNum; //forces a render without having to set the render() "force" parameter to true because we want to allow lazying by default (using the "force" parameter always forces an immediate full render)
            _this3.render(Math.max(0, -delay) || 0); //in case delay is negative
        }
        scrollTrigger && _scrollTrigger(_assertThisInitialized(_this3), scrollTrigger);
        return _this3;
    }
    var _proto3 = Tween.prototype;
    _proto3.render = function render(totalTime, suppressEvents, force) {
        var prevTime = this._time, tDur = this._tDur, dur = this._dur, isNegative = totalTime < 0, tTime = totalTime > tDur - _tinyNum && !isNegative ? tDur : totalTime < _tinyNum ? 0 : totalTime, time, pt, iteration, cycleDuration, prevIteration, isYoyo, ratio, timeline, yoyoEase;
        if (!dur) _renderZeroDurationTween(this, totalTime, suppressEvents, force);
        else if (tTime !== this._tTime || !totalTime || force || !this._initted && this._tTime || this._startAt && this._zTime < 0 !== isNegative || this._lazy) {
            // this senses if we're crossing over the start time, in which case we must record _zTime and force the render, but we do it in this lengthy conditional way for performance reasons (usually we can skip the calculations): this._initted && (this._zTime < 0) !== (totalTime < 0)
            time = tTime;
            timeline = this.timeline;
            if (this._repeat) {
                //adjust the time for repeats and yoyos
                cycleDuration = dur + this._rDelay;
                if (this._repeat < -1 && isNegative) return this.totalTime(cycleDuration * 100 + totalTime, suppressEvents, force);
                time = _roundPrecise(tTime % cycleDuration); //round to avoid floating point errors. (4 % 0.8 should be 0 but some browsers report it as 0.79999999!)
                if (tTime === tDur) {
                    // the tDur === tTime is for edge cases where there's a lengthy decimal on the duration and it may reach the very end but the time is rendered as not-quite-there (remember, tDur is rounded to 4 decimals whereas dur isn't)
                    iteration = this._repeat;
                    time = dur;
                } else {
                    prevIteration = _roundPrecise(tTime / cycleDuration); // full decimal version of iterations, not the previous iteration (we're reusing prevIteration variable for efficiency)
                    iteration = ~~prevIteration;
                    if (iteration && iteration === prevIteration) {
                        time = dur;
                        iteration--;
                    } else if (time > dur) time = dur;
                }
                isYoyo = this._yoyo && iteration & 1;
                if (isYoyo) {
                    yoyoEase = this._yEase;
                    time = dur - time;
                }
                prevIteration = _animationCycle(this._tTime, cycleDuration);
                if (time === prevTime && !force && this._initted && iteration === prevIteration) {
                    //could be during the repeatDelay part. No need to render and fire callbacks.
                    this._tTime = tTime;
                    return this;
                }
                if (iteration !== prevIteration) {
                    timeline && this._yEase && _propagateYoyoEase(timeline, isYoyo); //repeatRefresh functionality
                    if (this.vars.repeatRefresh && !isYoyo && !this._lock && time !== cycleDuration && this._initted) {
                        // this._time will === cycleDuration when we render at EXACTLY the end of an iteration. Without this condition, it'd often do the repeatRefresh render TWICE (again on the very next tick).
                        this._lock = force = 1; //force, otherwise if lazy is true, the _attemptInitTween() will return and we'll jump out and get caught bouncing on each tick.
                        this.render(_roundPrecise(cycleDuration * iteration), true).invalidate()._lock = 0;
                    }
                }
            }
            if (!this._initted) {
                if (_attemptInitTween(this, isNegative ? totalTime : time, force, suppressEvents, tTime)) {
                    this._tTime = 0; // in constructor if immediateRender is true, we set _tTime to -_tinyNum to have the playhead cross the starting point but we can't leave _tTime as a negative number.
                    return this;
                }
                if (prevTime !== this._time && !(force && this.vars.repeatRefresh && iteration !== prevIteration)) // rare edge case - during initialization, an onUpdate in the _startAt (.fromTo()) might force this tween to render at a different spot in which case we should ditch this render() call so that it doesn't revert the values. But we also don't want to dump if we're doing a repeatRefresh render!
                return this;
                if (dur !== this._dur) // while initting, a plugin like InertiaPlugin might alter the duration, so rerun from the start to ensure everything renders as it should.
                return this.render(totalTime, suppressEvents, force);
            }
            this._tTime = tTime;
            this._time = time;
            if (!this._act && this._ts) {
                this._act = 1; //as long as it's not paused, force it to be active so that if the user renders independent of the parent timeline, it'll be forced to re-render on the next tick.
                this._lazy = 0;
            }
            this.ratio = ratio = (yoyoEase || this._ease)(time / dur);
            if (this._from) this.ratio = ratio = 1 - ratio;
            if (time && !prevTime && !suppressEvents && !iteration) {
                _callback(this, "onStart");
                if (this._tTime !== tTime) // in case the onStart triggered a render at a different spot, eject. Like if someone did animation.pause(0.5) or something inside the onStart.
                return this;
            }
            pt = this._pt;
            while(pt){
                pt.r(ratio, pt.d);
                pt = pt._next;
            }
            timeline && timeline.render(totalTime < 0 ? totalTime : timeline._dur * timeline._ease(time / this._dur), suppressEvents, force) || this._startAt && (this._zTime = totalTime);
            if (this._onUpdate && !suppressEvents) {
                isNegative && _rewindStartAt(this, totalTime, suppressEvents, force); //note: for performance reasons, we tuck this conditional logic inside less traveled areas (most tweens don't have an onUpdate). We'd just have it at the end before the onComplete, but the values should be updated before any onUpdate is called, so we ALSO put it here and then if it's not called, we do so later near the onComplete.
                _callback(this, "onUpdate");
            }
            this._repeat && iteration !== prevIteration && this.vars.onRepeat && !suppressEvents && this.parent && _callback(this, "onRepeat");
            if ((tTime === this._tDur || !tTime) && this._tTime === tTime) {
                isNegative && !this._onUpdate && _rewindStartAt(this, totalTime, true, true);
                (totalTime || !dur) && (tTime === this._tDur && this._ts > 0 || !tTime && this._ts < 0) && _removeFromParent(this, 1); // don't remove if we're rendering at exactly a time of 0, as there could be autoRevert values that should get set on the next tick (if the playhead goes backward beyond the startTime, negative totalTime). Don't remove if the timeline is reversed and the playhead isn't at 0, otherwise tl.progress(1).reverse() won't work. Only remove if the playhead is at the end and timeScale is positive, or if the playhead is at 0 and the timeScale is negative.
                if (!suppressEvents && !(isNegative && !prevTime) && (tTime || prevTime || isYoyo)) {
                    // if prevTime and tTime are zero, we shouldn't fire the onReverseComplete. This could happen if you gsap.to(... {paused:true}).play();
                    _callback(this, tTime === tDur ? "onComplete" : "onReverseComplete", true);
                    this._prom && !(tTime < tDur && this.timeScale() > 0) && this._prom();
                }
            }
        }
        return this;
    };
    _proto3.targets = function targets() {
        return this._targets;
    };
    _proto3.invalidate = function invalidate(soft) {
        // "soft" gives us a way to clear out everything EXCEPT the recorded pre-"from" portion of from() tweens. Otherwise, for example, if you tween.progress(1).render(0, true true).invalidate(), the "from" values would persist and then on the next render, the from() tweens would initialize and the current value would match the "from" values, thus animate from the same value to the same value (no animation). We tap into this in ScrollTrigger's refresh() where we must push a tween to completion and then back again but honor its init state in case the tween is dependent on another tween further up on the page.
        (!soft || !this.vars.runBackwards) && (this._startAt = 0);
        this._pt = this._op = this._onUpdate = this._lazy = this.ratio = 0;
        this._ptLookup = [];
        this.timeline && this.timeline.invalidate(soft);
        return _Animation2.prototype.invalidate.call(this, soft);
    };
    _proto3.resetTo = function resetTo(property, value, start, startIsRelative, skipRecursion) {
        _tickerActive || _ticker.wake();
        this._ts || this.play();
        var time = Math.min(this._dur, (this._dp._time - this._start) * this._ts), ratio;
        this._initted || _initTween(this, time);
        ratio = this._ease(time / this._dur); // don't just get tween.ratio because it may not have rendered yet.
        // possible future addition to allow an object with multiple values to update, like tween.resetTo({x: 100, y: 200}); At this point, it doesn't seem worth the added kb given the fact that most users will likely opt for the convenient gsap.quickTo() way of interacting with this method.
        // if (_isObject(property)) { // performance optimization
        // 	for (p in property) {
        // 		if (_updatePropTweens(this, p, property[p], value ? value[p] : null, start, ratio, time)) {
        // 			return this.resetTo(property, value, start, startIsRelative); // if a PropTween wasn't found for the property, it'll get forced with a re-initialization so we need to jump out and start over again.
        // 		}
        // 	}
        // } else {
        if (_updatePropTweens(this, property, value, start, startIsRelative, ratio, time, skipRecursion)) return this.resetTo(property, value, start, startIsRelative, 1); // if a PropTween wasn't found for the property, it'll get forced with a re-initialization so we need to jump out and start over again.
         //}
        _alignPlayhead(this, 0);
        this.parent || _addLinkedListItem(this._dp, this, "_first", "_last", this._dp._sort ? "_start" : 0);
        return this.render(0);
    };
    _proto3.kill = function kill(targets, vars) {
        if (vars === void 0) vars = "all";
        if (!targets && (!vars || vars === "all")) {
            this._lazy = this._pt = 0;
            this.parent ? _interrupt(this) : this.scrollTrigger && this.scrollTrigger.kill(!!_reverting);
            return this;
        }
        if (this.timeline) {
            var tDur = this.timeline.totalDuration();
            this.timeline.killTweensOf(targets, vars, _overwritingTween && _overwritingTween.vars.overwrite !== true)._first || _interrupt(this); // if nothing is left tweening, interrupt.
            this.parent && tDur !== this.timeline.totalDuration() && _setDuration(this, this._dur * this.timeline._tDur / tDur, 0, 1); // if a nested tween is killed that changes the duration, it should affect this tween's duration. We must use the ratio, though, because sometimes the internal timeline is stretched like for keyframes where they don't all add up to whatever the parent tween's duration was set to.
            return this;
        }
        var parsedTargets = this._targets, killingTargets = targets ? toArray(targets) : parsedTargets, propTweenLookup = this._ptLookup, firstPT = this._pt, overwrittenProps, curLookup, curOverwriteProps, props, p, pt, i;
        if ((!vars || vars === "all") && _arraysMatch(parsedTargets, killingTargets)) {
            vars === "all" && (this._pt = 0);
            return _interrupt(this);
        }
        overwrittenProps = this._op = this._op || [];
        if (vars !== "all") {
            //so people can pass in a comma-delimited list of property names
            if (_isString(vars)) {
                p = {};
                _forEachName(vars, function(name) {
                    return p[name] = 1;
                });
                vars = p;
            }
            vars = _addAliasesToVars(parsedTargets, vars);
        }
        i = parsedTargets.length;
        while(i--)if (~killingTargets.indexOf(parsedTargets[i])) {
            curLookup = propTweenLookup[i];
            if (vars === "all") {
                overwrittenProps[i] = vars;
                props = curLookup;
                curOverwriteProps = {};
            } else {
                curOverwriteProps = overwrittenProps[i] = overwrittenProps[i] || {};
                props = vars;
            }
            for(p in props){
                pt = curLookup && curLookup[p];
                if (pt) {
                    if (!("kill" in pt.d) || pt.d.kill(p) === true) _removeLinkedListItem(this, pt, "_pt");
                    delete curLookup[p];
                }
                if (curOverwriteProps !== "all") curOverwriteProps[p] = 1;
            }
        }
        this._initted && !this._pt && firstPT && _interrupt(this); //if all tweening properties are killed, kill the tween. Without this line, if there's a tween with multiple targets and then you killTweensOf() each target individually, the tween would technically still remain active and fire its onComplete even though there aren't any more properties tweening.
        return this;
    };
    Tween.to = function to(targets, vars) {
        return new Tween(targets, vars, arguments[2]);
    };
    Tween.from = function from(targets, vars) {
        return _createTweenType(1, arguments);
    };
    Tween.delayedCall = function delayedCall(delay, callback, params, scope) {
        return new Tween(callback, 0, {
            immediateRender: false,
            lazy: false,
            overwrite: false,
            delay: delay,
            onComplete: callback,
            onReverseComplete: callback,
            onCompleteParams: params,
            onReverseCompleteParams: params,
            callbackScope: scope
        }); // we must use onReverseComplete too for things like timeline.add(() => {...}) which should be triggered in BOTH directions (forward and reverse)
    };
    Tween.fromTo = function fromTo(targets, fromVars, toVars) {
        return _createTweenType(2, arguments);
    };
    Tween.set = function set(targets, vars) {
        vars.duration = 0;
        vars.repeatDelay || (vars.repeat = 0);
        return new Tween(targets, vars);
    };
    Tween.killTweensOf = function killTweensOf(targets, props, onlyActive) {
        return _globalTimeline.killTweensOf(targets, props, onlyActive);
    };
    return Tween;
}(Animation);
_setDefaults(Tween.prototype, {
    _targets: [],
    _lazy: 0,
    _startAt: 0,
    _op: 0,
    _onInit: 0
}); //add the pertinent timeline methods to Tween instances so that users can chain conveniently and create a timeline automatically. (removed due to concerns that it'd ultimately add to more confusion especially for beginners)
// _forEachName("to,from,fromTo,set,call,add,addLabel,addPause", name => {
// 	Tween.prototype[name] = function() {
// 		let tl = new Timeline();
// 		return _addToTimeline(tl, this)[name].apply(tl, toArray(arguments));
// 	}
// });
//for backward compatibility. Leverage the timeline calls.
_forEachName("staggerTo,staggerFrom,staggerFromTo", function(name) {
    Tween[name] = function() {
        var tl = new Timeline(), params = _slice.call(arguments, 0);
        params.splice(name === "staggerFromTo" ? 5 : 4, 0, 0);
        return tl[name].apply(tl, params);
    };
});
/*
 * --------------------------------------------------------------------------------------
 * PROPTWEEN
 * --------------------------------------------------------------------------------------
 */ var _setterPlain = function _setterPlain(target, property, value) {
    return target[property] = value;
}, _setterFunc = function _setterFunc(target, property, value) {
    return target[property](value);
}, _setterFuncWithParam = function _setterFuncWithParam(target, property, value, data) {
    return target[property](data.fp, value);
}, _setterAttribute = function _setterAttribute(target, property, value) {
    return target.setAttribute(property, value);
}, _getSetter = function _getSetter(target, property) {
    return _isFunction(target[property]) ? _setterFunc : _isUndefined(target[property]) && target.setAttribute ? _setterAttribute : _setterPlain;
}, _renderPlain = function _renderPlain(ratio, data) {
    return data.set(data.t, data.p, Math.round((data.s + data.c * ratio) * 1000000) / 1000000, data);
}, _renderBoolean = function _renderBoolean(ratio, data) {
    return data.set(data.t, data.p, !!(data.s + data.c * ratio), data);
}, _renderComplexString = function _renderComplexString(ratio, data) {
    var pt = data._pt, s = "";
    if (!ratio && data.b) //b = beginning string
    s = data.b;
    else if (ratio === 1 && data.e) //e = ending string
    s = data.e;
    else {
        while(pt){
            s = pt.p + (pt.m ? pt.m(pt.s + pt.c * ratio) : Math.round((pt.s + pt.c * ratio) * 10000) / 10000) + s; //we use the "p" property for the text inbetween (like a suffix). And in the context of a complex string, the modifier (m) is typically just Math.round(), like for RGB colors.
            pt = pt._next;
        }
        s += data.c; //we use the "c" of the PropTween to store the final chunk of non-numeric text.
    }
    data.set(data.t, data.p, s, data);
}, _renderPropTweens = function _renderPropTweens(ratio, data) {
    var pt = data._pt;
    while(pt){
        pt.r(ratio, pt.d);
        pt = pt._next;
    }
}, _addPluginModifier = function _addPluginModifier(modifier, tween, target, property) {
    var pt = this._pt, next;
    while(pt){
        next = pt._next;
        pt.p === property && pt.modifier(modifier, tween, target);
        pt = next;
    }
}, _killPropTweensOf = function _killPropTweensOf(property) {
    var pt = this._pt, hasNonDependentRemaining, next;
    while(pt){
        next = pt._next;
        if (pt.p === property && !pt.op || pt.op === property) _removeLinkedListItem(this, pt, "_pt");
        else if (!pt.dep) hasNonDependentRemaining = 1;
        pt = next;
    }
    return !hasNonDependentRemaining;
}, _setterWithModifier = function _setterWithModifier(target, property, value, data) {
    data.mSet(target, property, data.m.call(data.tween, value, data.mt), data);
}, _sortPropTweensByPriority = function _sortPropTweensByPriority(parent) {
    var pt = parent._pt, next, pt2, first, last; //sorts the PropTween linked list in order of priority because some plugins need to do their work after ALL of the PropTweens were created (like RoundPropsPlugin and ModifiersPlugin)
    while(pt){
        next = pt._next;
        pt2 = first;
        while(pt2 && pt2.pr > pt.pr)pt2 = pt2._next;
        if (pt._prev = pt2 ? pt2._prev : last) pt._prev._next = pt;
        else first = pt;
        if (pt._next = pt2) pt2._prev = pt;
        else last = pt;
        pt = next;
    }
    parent._pt = first;
}; //PropTween key: t = target, p = prop, r = renderer, d = data, s = start, c = change, op = overwriteProperty (ONLY populated when it's different than p), pr = priority, _next/_prev for the linked list siblings, set = setter, m = modifier, mSet = modifierSetter (the original setter, before a modifier was added)
var PropTween = /*#__PURE__*/ function() {
    function PropTween(next, target, prop, start, change, renderer, data, setter, priority) {
        this.t = target;
        this.s = start;
        this.c = change;
        this.p = prop;
        this.r = renderer || _renderPlain;
        this.d = data || this;
        this.set = setter || _setterPlain;
        this.pr = priority || 0;
        this._next = next;
        if (next) next._prev = this;
    }
    var _proto4 = PropTween.prototype;
    _proto4.modifier = function modifier(func, tween, target) {
        this.mSet = this.mSet || this.set; //in case it was already set (a PropTween can only have one modifier)
        this.set = _setterWithModifier;
        this.m = func;
        this.mt = target; //modifier target
        this.tween = tween;
    };
    return PropTween;
}(); //Initialization tasks
_forEachName(_callbackNames + "parent,duration,ease,delay,overwrite,runBackwards,startAt,yoyo,immediateRender,repeat,repeatDelay,data,paused,reversed,lazy,callbackScope,stringFilter,id,yoyoEase,stagger,inherit,repeatRefresh,keyframes,autoRevert,scrollTrigger", function(name) {
    return _reservedProps[name] = 1;
});
_globals.TweenMax = _globals.TweenLite = Tween;
_globals.TimelineLite = _globals.TimelineMax = Timeline;
_globalTimeline = new Timeline({
    sortChildren: false,
    defaults: _defaults,
    autoRemoveChildren: true,
    id: "root",
    smoothChildTiming: true
});
_config.stringFilter = _colorStringFilter;
var _media = [], _listeners = {}, _emptyArray = [], _lastMediaTime = 0, _contextID = 0, _dispatch = function _dispatch(type) {
    return (_listeners[type] || _emptyArray).map(function(f) {
        return f();
    });
}, _onMediaChange = function _onMediaChange() {
    var time = Date.now(), matches = [];
    if (time - _lastMediaTime > 2) {
        _dispatch("matchMediaInit");
        _media.forEach(function(c) {
            var queries = c.queries, conditions = c.conditions, match, p, anyMatch, toggled;
            for(p in queries){
                match = _win.matchMedia(queries[p]).matches; // Firefox doesn't update the "matches" property of the MediaQueryList object correctly - it only does so as it calls its change handler - so we must re-create a media query here to ensure it's accurate.
                match && (anyMatch = 1);
                if (match !== conditions[p]) {
                    conditions[p] = match;
                    toggled = 1;
                }
            }
            if (toggled) {
                c.revert();
                anyMatch && matches.push(c);
            }
        });
        _dispatch("matchMediaRevert");
        matches.forEach(function(c) {
            return c.onMatch(c, function(func) {
                return c.add(null, func);
            });
        });
        _lastMediaTime = time;
        _dispatch("matchMedia");
    }
};
var Context = /*#__PURE__*/ function() {
    function Context(func, scope) {
        this.selector = scope && selector(scope);
        this.data = [];
        this._r = []; // returned/cleanup functions
        this.isReverted = false;
        this.id = _contextID++; // to work around issues that frameworks like Vue cause by making things into Proxies which make it impossible to do something like _media.indexOf(this) because "this" would no longer refer to the Context instance itself - it'd refer to a Proxy! We needed a way to identify the context uniquely
        func && this.add(func);
    }
    var _proto5 = Context.prototype;
    _proto5.add = function add(name, func, scope) {
        // possible future addition if we need the ability to add() an animation to a context and for whatever reason cannot create that animation inside of a context.add(() => {...}) function.
        // if (name && _isFunction(name.revert)) {
        // 	this.data.push(name);
        // 	return (name._ctx = this);
        // }
        if (_isFunction(name)) {
            scope = func;
            func = name;
            name = _isFunction;
        }
        var self = this, f = function f() {
            var prev = _context, prevSelector = self.selector, result;
            prev && prev !== self && prev.data.push(self);
            scope && (self.selector = selector(scope));
            _context = self;
            result = func.apply(self, arguments);
            _isFunction(result) && self._r.push(result);
            _context = prev;
            self.selector = prevSelector;
            self.isReverted = false;
            return result;
        };
        self.last = f;
        return name === _isFunction ? f(self, function(func) {
            return self.add(null, func);
        }) : name ? self[name] = f : f;
    };
    _proto5.ignore = function ignore(func) {
        var prev = _context;
        _context = null;
        func(this);
        _context = prev;
    };
    _proto5.getTweens = function getTweens() {
        var a = [];
        this.data.forEach(function(e) {
            return e instanceof Context ? a.push.apply(a, e.getTweens()) : e instanceof Tween && !(e.parent && e.parent.data === "nested") && a.push(e);
        });
        return a;
    };
    _proto5.clear = function clear() {
        this._r.length = this.data.length = 0;
    };
    _proto5.kill = function kill(revert, matchMedia) {
        var _this4 = this;
        if (revert) (function() {
            var tweens = _this4.getTweens(), i = _this4.data.length, t;
            while(i--){
                // Flip plugin tweens are very different in that they should actually be pushed to their end. The plugin replaces the timeline's .revert() method to do exactly that. But we also need to remove any of those nested tweens inside the flip timeline so that they don't get individually reverted.
                t = _this4.data[i];
                if (t.data === "isFlip") {
                    t.revert();
                    t.getChildren(true, true, false).forEach(function(tween) {
                        return tweens.splice(tweens.indexOf(tween), 1);
                    });
                }
            } // save as an object so that we can cache the globalTime for each tween to optimize performance during the sort
            tweens.map(function(t) {
                return {
                    g: t._dur || t._delay || t._sat && !t._sat.vars.immediateRender ? t.globalTime(0) : -Infinity,
                    t: t
                };
            }).sort(function(a, b) {
                return b.g - a.g || -Infinity;
            }).forEach(function(o) {
                return o.t.revert(revert);
            }); // note: all of the _startAt tweens should be reverted in reverse order that they were created, and they'll all have the same globalTime (-1) so the " || -1" in the sort keeps the order properly.
            i = _this4.data.length;
            while(i--){
                // make sure we loop backwards so that, for example, SplitTexts that were created later on the same element get reverted first
                t = _this4.data[i];
                if (t instanceof Timeline) {
                    if (t.data !== "nested") {
                        t.scrollTrigger && t.scrollTrigger.revert();
                        t.kill(); // don't revert() the timeline because that's duplicating efforts since we already reverted all the tweens
                    }
                } else !(t instanceof Tween) && t.revert && t.revert(revert);
            }
            _this4._r.forEach(function(f) {
                return f(revert, _this4);
            });
            _this4.isReverted = true;
        })();
        else this.data.forEach(function(e) {
            return e.kill && e.kill();
        });
        this.clear();
        if (matchMedia) {
            var i = _media.length;
            while(i--)// previously, we checked _media.indexOf(this), but some frameworks like Vue enforce Proxy objects that make it impossible to get the proper result that way, so we must use a unique ID number instead.
            _media[i].id === this.id && _media.splice(i, 1);
        }
    } // killWithCleanup() {
    ;
    _proto5.revert = function revert(config) {
        this.kill(config || {});
    };
    return Context;
}();
var MatchMedia = /*#__PURE__*/ function() {
    function MatchMedia(scope) {
        this.contexts = [];
        this.scope = scope;
        _context && _context.data.push(this);
    }
    var _proto6 = MatchMedia.prototype;
    _proto6.add = function add(conditions, func, scope) {
        _isObject(conditions) || (conditions = {
            matches: conditions
        });
        var context = new Context(0, scope || this.scope), cond = context.conditions = {}, mq, p, active;
        _context && !context.selector && (context.selector = _context.selector); // in case a context is created inside a context. Like a gsap.matchMedia() that's inside a scoped gsap.context()
        this.contexts.push(context);
        func = context.add("onMatch", func);
        context.queries = conditions;
        for(p in conditions)if (p === "all") active = 1;
        else {
            mq = _win.matchMedia(conditions[p]);
            if (mq) {
                _media.indexOf(context) < 0 && _media.push(context);
                (cond[p] = mq.matches) && (active = 1);
                mq.addListener ? mq.addListener(_onMediaChange) : mq.addEventListener("change", _onMediaChange);
            }
        }
        active && func(context, function(f) {
            return context.add(null, f);
        });
        return this;
    } // refresh() {
    ;
    _proto6.revert = function revert(config) {
        this.kill(config || {});
    };
    _proto6.kill = function kill(revert) {
        this.contexts.forEach(function(c) {
            return c.kill(revert, true);
        });
    };
    return MatchMedia;
}();
/*
 * --------------------------------------------------------------------------------------
 * GSAP
 * --------------------------------------------------------------------------------------
 */ var _gsap = {
    registerPlugin: function registerPlugin() {
        for(var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++)args[_key2] = arguments[_key2];
        args.forEach(function(config) {
            return _createPlugin(config);
        });
    },
    timeline: function timeline(vars) {
        return new Timeline(vars);
    },
    getTweensOf: function getTweensOf(targets, onlyActive) {
        return _globalTimeline.getTweensOf(targets, onlyActive);
    },
    getProperty: function getProperty(target, property, unit, uncache) {
        _isString(target) && (target = toArray(target)[0]); //in case selector text or an array is passed in
        var getter = _getCache(target || {}).get, format = unit ? _passThrough : _numericIfPossible;
        unit === "native" && (unit = "");
        return !target ? target : !property ? function(property, unit, uncache) {
            return format((_plugins[property] && _plugins[property].get || getter)(target, property, unit, uncache));
        } : format((_plugins[property] && _plugins[property].get || getter)(target, property, unit, uncache));
    },
    quickSetter: function quickSetter(target, property, unit) {
        target = toArray(target);
        if (target.length > 1) {
            var setters = target.map(function(t) {
                return gsap.quickSetter(t, property, unit);
            }), l = setters.length;
            return function(value) {
                var i = l;
                while(i--)setters[i](value);
            };
        }
        target = target[0] || {};
        var Plugin = _plugins[property], cache = _getCache(target), p = cache.harness && (cache.harness.aliases || {})[property] || property, // in case it's an alias, like "rotate" for "rotation".
        setter = Plugin ? function(value) {
            var p = new Plugin();
            _quickTween._pt = 0;
            p.init(target, unit ? value + unit : value, _quickTween, 0, [
                target
            ]);
            p.render(1, p);
            _quickTween._pt && _renderPropTweens(1, _quickTween);
        } : cache.set(target, p);
        return Plugin ? setter : function(value) {
            return setter(target, p, unit ? value + unit : value, cache, 1);
        };
    },
    quickTo: function quickTo(target, property, vars) {
        var _setDefaults2;
        var tween = gsap.to(target, _setDefaults((_setDefaults2 = {}, _setDefaults2[property] = "+=0.1", _setDefaults2.paused = true, _setDefaults2.stagger = 0, _setDefaults2), vars || {})), func = function func(value, start, startIsRelative) {
            return tween.resetTo(property, value, start, startIsRelative);
        };
        func.tween = tween;
        return func;
    },
    isTweening: function isTweening(targets) {
        return _globalTimeline.getTweensOf(targets, true).length > 0;
    },
    defaults: function defaults(value) {
        value && value.ease && (value.ease = _parseEase(value.ease, _defaults.ease));
        return _mergeDeep(_defaults, value || {});
    },
    config: function config(value) {
        return _mergeDeep(_config, value || {});
    },
    registerEffect: function registerEffect(_ref3) {
        var name = _ref3.name, effect = _ref3.effect, plugins = _ref3.plugins, defaults = _ref3.defaults, extendTimeline = _ref3.extendTimeline;
        (plugins || "").split(",").forEach(function(pluginName) {
            return pluginName && !_plugins[pluginName] && !_globals[pluginName] && _warn(name + " effect requires " + pluginName + " plugin.");
        });
        _effects[name] = function(targets, vars, tl) {
            return effect(toArray(targets), _setDefaults(vars || {}, defaults), tl);
        };
        if (extendTimeline) Timeline.prototype[name] = function(targets, vars, position) {
            return this.add(_effects[name](targets, _isObject(vars) ? vars : (position = vars) && {}, this), position);
        };
    },
    registerEase: function registerEase(name, ease) {
        _easeMap[name] = _parseEase(ease);
    },
    parseEase: function parseEase(ease, defaultEase) {
        return arguments.length ? _parseEase(ease, defaultEase) : _easeMap;
    },
    getById: function getById(id) {
        return _globalTimeline.getById(id);
    },
    exportRoot: function exportRoot(vars, includeDelayedCalls) {
        if (vars === void 0) vars = {};
        var tl = new Timeline(vars), child, next;
        tl.smoothChildTiming = _isNotFalse(vars.smoothChildTiming);
        _globalTimeline.remove(tl);
        tl._dp = 0; //otherwise it'll get re-activated when adding children and be re-introduced into _globalTimeline's linked list (then added to itself).
        tl._time = tl._tTime = _globalTimeline._time;
        child = _globalTimeline._first;
        while(child){
            next = child._next;
            if (includeDelayedCalls || !(!child._dur && child instanceof Tween && child.vars.onComplete === child._targets[0])) _addToTimeline(tl, child, child._start - child._delay);
            child = next;
        }
        _addToTimeline(_globalTimeline, tl, 0);
        return tl;
    },
    context: function context(func, scope) {
        return func ? new Context(func, scope) : _context;
    },
    matchMedia: function matchMedia(scope) {
        return new MatchMedia(scope);
    },
    matchMediaRefresh: function matchMediaRefresh() {
        return _media.forEach(function(c) {
            var cond = c.conditions, found, p;
            for(p in cond)if (cond[p]) {
                cond[p] = false;
                found = 1;
            }
            found && c.revert();
        }) || _onMediaChange();
    },
    addEventListener: function addEventListener(type, callback) {
        var a = _listeners[type] || (_listeners[type] = []);
        ~a.indexOf(callback) || a.push(callback);
    },
    removeEventListener: function removeEventListener(type, callback) {
        var a = _listeners[type], i = a && a.indexOf(callback);
        i >= 0 && a.splice(i, 1);
    },
    utils: {
        wrap: wrap,
        wrapYoyo: wrapYoyo,
        distribute: distribute,
        random: random,
        snap: snap,
        normalize: normalize,
        getUnit: getUnit,
        clamp: clamp,
        splitColor: splitColor,
        toArray: toArray,
        selector: selector,
        mapRange: mapRange,
        pipe: pipe,
        unitize: unitize,
        interpolate: interpolate,
        shuffle: shuffle
    },
    install: _install,
    effects: _effects,
    ticker: _ticker,
    updateRoot: Timeline.updateRoot,
    plugins: _plugins,
    globalTimeline: _globalTimeline,
    core: {
        PropTween: PropTween,
        globals: _addGlobal,
        Tween: Tween,
        Timeline: Timeline,
        Animation: Animation,
        getCache: _getCache,
        _removeLinkedListItem: _removeLinkedListItem,
        reverting: function reverting() {
            return _reverting;
        },
        context: function context(toAdd) {
            if (toAdd && _context) {
                _context.data.push(toAdd);
                toAdd._ctx = _context;
            }
            return _context;
        },
        suppressOverwrites: function suppressOverwrites(value) {
            return _suppressOverwrites = value;
        }
    }
};
_forEachName("to,from,fromTo,delayedCall,set,killTweensOf", function(name) {
    return _gsap[name] = Tween[name];
});
_ticker.add(Timeline.updateRoot);
_quickTween = _gsap.to({}, {
    duration: 0
}); // ---- EXTRA PLUGINS --------------------------------------------------------
var _getPluginPropTween = function _getPluginPropTween(plugin, prop) {
    var pt = plugin._pt;
    while(pt && pt.p !== prop && pt.op !== prop && pt.fp !== prop)pt = pt._next;
    return pt;
}, _addModifiers = function _addModifiers(tween, modifiers) {
    var targets = tween._targets, p, i, pt;
    for(p in modifiers){
        i = targets.length;
        while(i--){
            pt = tween._ptLookup[i][p];
            if (pt && (pt = pt.d)) {
                if (pt._pt) // is a plugin
                pt = _getPluginPropTween(pt, p);
                pt && pt.modifier && pt.modifier(modifiers[p], tween, targets[i], p);
            }
        }
    }
}, _buildModifierPlugin = function _buildModifierPlugin(name, modifier) {
    return {
        name: name,
        rawVars: 1,
        //don't pre-process function-based values or "random()" strings.
        init: function init(target, vars, tween) {
            tween._onInit = function(tween) {
                var temp, p;
                if (_isString(vars)) {
                    temp = {};
                    _forEachName(vars, function(name) {
                        return temp[name] = 1;
                    }); //if the user passes in a comma-delimited list of property names to roundProps, like "x,y", we round to whole numbers.
                    vars = temp;
                }
                if (modifier) {
                    temp = {};
                    for(p in vars)temp[p] = modifier(vars[p]);
                    vars = temp;
                }
                _addModifiers(tween, vars);
            };
        }
    };
}; //register core plugins
var gsap = _gsap.registerPlugin({
    name: "attr",
    init: function init(target, vars, tween, index, targets) {
        var p, pt, v;
        this.tween = tween;
        for(p in vars){
            v = target.getAttribute(p) || "";
            pt = this.add(target, "setAttribute", (v || 0) + "", vars[p], index, targets, 0, 0, p);
            pt.op = p;
            pt.b = v; // record the beginning value so we can revert()
            this._props.push(p);
        }
    },
    render: function render(ratio, data) {
        var pt = data._pt;
        while(pt){
            _reverting ? pt.set(pt.t, pt.p, pt.b, pt) : pt.r(ratio, pt.d); // if reverting, go back to the original (pt.b)
            pt = pt._next;
        }
    }
}, {
    name: "endArray",
    init: function init(target, value) {
        var i = value.length;
        while(i--)this.add(target, i, target[i] || 0, value[i], 0, 0, 0, 0, 0, 1);
    }
}, _buildModifierPlugin("roundProps", _roundModifier), _buildModifierPlugin("modifiers"), _buildModifierPlugin("snap", snap)) || _gsap; //to prevent the core plugins from being dropped via aggressive tree shaking, we must include them in the variable declaration in this way.
Tween.version = Timeline.version = gsap.version = "3.12.7";
_coreReady = 1;
_windowExists() && _wake();
var Power0 = _easeMap.Power0, Power1 = _easeMap.Power1, Power2 = _easeMap.Power2, Power3 = _easeMap.Power3, Power4 = _easeMap.Power4, Linear = _easeMap.Linear, Quad = _easeMap.Quad, Cubic = _easeMap.Cubic, Quart = _easeMap.Quart, Quint = _easeMap.Quint, Strong = _easeMap.Strong, Elastic = _easeMap.Elastic, Back = _easeMap.Back, SteppedEase = _easeMap.SteppedEase, Bounce = _easeMap.Bounce, Sine = _easeMap.Sine, Expo = _easeMap.Expo, Circ = _easeMap.Circ;

});

parcelRegister("8hJz1", function(module, exports) {
module.exports = import("cbKY9").then(()=>parcelRequire('16Huy'));

});

parcelRegister("4RZ4E", function(module, exports) {
module.exports = import("JSq6p").then(()=>parcelRequire('50i7i'));

});

parcelRegister("1ucKx", function(module, exports) {

(function() {
    'use strict';
    var root = this;
    var has_require = true;
    var THREE = root.THREE || has_require && (parcelRequire("ilwiq"));
    if (!THREE) throw new Error('MeshLine requires three.js');
    class MeshLine extends THREE.BufferGeometry {
        constructor(){
            super();
            this.isMeshLine = true;
            this.type = 'MeshLine';
            this.positions = [];
            this.previous = [];
            this.next = [];
            this.side = [];
            this.width = [];
            this.indices_array = [];
            this.uvs = [];
            this.counters = [];
            this._points = [];
            this._geom = null;
            this.widthCallback = null;
            // Used to raycast
            this.matrixWorld = new THREE.Matrix4();
            Object.defineProperties(this, {
                // this is now a bufferGeometry
                // add getter to support previous api
                geometry: {
                    enumerable: true,
                    get: function() {
                        return this;
                    }
                },
                geom: {
                    enumerable: true,
                    get: function() {
                        return this._geom;
                    },
                    set: function(value) {
                        this.setGeometry(value, this.widthCallback);
                    }
                },
                // for declaritive architectures
                // to return the same value that sets the points
                // eg. this.points = points
                // console.log(this.points) -> points
                points: {
                    enumerable: true,
                    get: function() {
                        return this._points;
                    },
                    set: function(value) {
                        this.setPoints(value, this.widthCallback);
                    }
                }
            });
        }
    }
    MeshLine.prototype.setMatrixWorld = function(matrixWorld) {
        this.matrixWorld = matrixWorld;
    };
    // setting via a geometry is rather superfluous
    // as you're creating a unecessary geometry just to throw away
    // but exists to support previous api
    MeshLine.prototype.setGeometry = function(g, c) {
        // as the input geometry are mutated we store them
        // for later retreival when necessary (declaritive architectures)
        this._geometry = g;
        this.setPoints(g.getAttribute("position").array, c);
    };
    MeshLine.prototype.setPoints = function(points, wcb) {
        if (!(points instanceof Float32Array) && !(points instanceof Array)) {
            console.error("ERROR: The BufferArray of points is not instancied correctly.");
            return;
        }
        // as the points are mutated we store them
        // for later retreival when necessary (declaritive architectures)
        this._points = points;
        this.widthCallback = wcb;
        this.positions = [];
        this.counters = [];
        if (points.length && points[0] instanceof THREE.Vector3) // could transform Vector3 array into the array used below
        // but this approach will only loop through the array once
        // and is more performant
        for(var j = 0; j < points.length; j++){
            var p = points[j];
            var c = j / points.length;
            this.positions.push(p.x, p.y, p.z);
            this.positions.push(p.x, p.y, p.z);
            this.counters.push(c);
            this.counters.push(c);
        }
        else for(var j = 0; j < points.length; j += 3){
            var c = j / points.length;
            this.positions.push(points[j], points[j + 1], points[j + 2]);
            this.positions.push(points[j], points[j + 1], points[j + 2]);
            this.counters.push(c);
            this.counters.push(c);
        }
        this.process();
    };
    function MeshLineRaycast(raycaster, intersects) {
        var inverseMatrix = new THREE.Matrix4();
        var ray = new THREE.Ray();
        var sphere = new THREE.Sphere();
        var interRay = new THREE.Vector3();
        var geometry = this.geometry;
        // Checking boundingSphere distance to ray
        if (!geometry.boundingSphere) geometry.computeBoundingSphere();
        sphere.copy(geometry.boundingSphere);
        sphere.applyMatrix4(this.matrixWorld);
        if (raycaster.ray.intersectSphere(sphere, interRay) === false) return;
        inverseMatrix.copy(this.matrixWorld).invert();
        ray.copy(raycaster.ray).applyMatrix4(inverseMatrix);
        var vStart = new THREE.Vector3();
        var vEnd = new THREE.Vector3();
        var interSegment = new THREE.Vector3();
        var step = this instanceof THREE.LineSegments ? 2 : 1;
        var index = geometry.index;
        var attributes = geometry.attributes;
        if (index !== null) {
            var indices = index.array;
            var positions = attributes.position.array;
            var widths = attributes.width.array;
            for(var i = 0, l = indices.length - 1; i < l; i += step){
                var a = indices[i];
                var b = indices[i + 1];
                vStart.fromArray(positions, a * 3);
                vEnd.fromArray(positions, b * 3);
                var width = widths[Math.floor(i / 3)] !== undefined ? widths[Math.floor(i / 3)] : 1;
                var precision = raycaster.params.Line.threshold + this.material.lineWidth * width / 2;
                var precisionSq = precision * precision;
                var distSq = ray.distanceSqToSegment(vStart, vEnd, interRay, interSegment);
                if (distSq > precisionSq) continue;
                interRay.applyMatrix4(this.matrixWorld) //Move back to world space for distance calculation
                ;
                var distance = raycaster.ray.origin.distanceTo(interRay);
                if (distance < raycaster.near || distance > raycaster.far) continue;
                intersects.push({
                    distance: distance,
                    // What do we want? intersection point on the ray or on the segment??
                    // point: raycaster.ray.at( distance ),
                    point: interSegment.clone().applyMatrix4(this.matrixWorld),
                    index: i,
                    face: null,
                    faceIndex: null,
                    object: this
                });
                // make event only fire once
                i = l;
            }
        }
    }
    MeshLine.prototype.raycast = MeshLineRaycast;
    MeshLine.prototype.compareV3 = function(a, b) {
        var aa = a * 6;
        var ab = b * 6;
        return this.positions[aa] === this.positions[ab] && this.positions[aa + 1] === this.positions[ab + 1] && this.positions[aa + 2] === this.positions[ab + 2];
    };
    MeshLine.prototype.copyV3 = function(a) {
        var aa = a * 6;
        return [
            this.positions[aa],
            this.positions[aa + 1],
            this.positions[aa + 2]
        ];
    };
    MeshLine.prototype.process = function() {
        var l = this.positions.length / 6;
        this.previous = [];
        this.next = [];
        this.side = [];
        this.width = [];
        this.indices_array = [];
        this.uvs = [];
        var w;
        var v;
        // initial previous points
        if (this.compareV3(0, l - 1)) v = this.copyV3(l - 2);
        else v = this.copyV3(0);
        this.previous.push(v[0], v[1], v[2]);
        this.previous.push(v[0], v[1], v[2]);
        for(var j = 0; j < l; j++){
            // sides
            this.side.push(1);
            this.side.push(-1);
            // widths
            if (this.widthCallback) w = this.widthCallback(j / (l - 1));
            else w = 1;
            this.width.push(w);
            this.width.push(w);
            // uvs
            this.uvs.push(j / (l - 1), 0);
            this.uvs.push(j / (l - 1), 1);
            if (j < l - 1) {
                // points previous to poisitions
                v = this.copyV3(j);
                this.previous.push(v[0], v[1], v[2]);
                this.previous.push(v[0], v[1], v[2]);
                // indices
                var n = j * 2;
                this.indices_array.push(n, n + 1, n + 2);
                this.indices_array.push(n + 2, n + 1, n + 3);
            }
            if (j > 0) {
                // points after poisitions
                v = this.copyV3(j);
                this.next.push(v[0], v[1], v[2]);
                this.next.push(v[0], v[1], v[2]);
            }
        }
        // last next point
        if (this.compareV3(l - 1, 0)) v = this.copyV3(1);
        else v = this.copyV3(l - 1);
        this.next.push(v[0], v[1], v[2]);
        this.next.push(v[0], v[1], v[2]);
        // redefining the attribute seems to prevent range errors
        // if the user sets a differing number of vertices
        if (!this._attributes || this._attributes.position.count !== this.positions.length) this._attributes = {
            position: new THREE.BufferAttribute(new Float32Array(this.positions), 3),
            previous: new THREE.BufferAttribute(new Float32Array(this.previous), 3),
            next: new THREE.BufferAttribute(new Float32Array(this.next), 3),
            side: new THREE.BufferAttribute(new Float32Array(this.side), 1),
            width: new THREE.BufferAttribute(new Float32Array(this.width), 1),
            uv: new THREE.BufferAttribute(new Float32Array(this.uvs), 2),
            index: new THREE.BufferAttribute(new Uint16Array(this.indices_array), 1),
            counters: new THREE.BufferAttribute(new Float32Array(this.counters), 1)
        };
        else {
            this._attributes.position.copyArray(new Float32Array(this.positions));
            this._attributes.position.needsUpdate = true;
            this._attributes.previous.copyArray(new Float32Array(this.previous));
            this._attributes.previous.needsUpdate = true;
            this._attributes.next.copyArray(new Float32Array(this.next));
            this._attributes.next.needsUpdate = true;
            this._attributes.side.copyArray(new Float32Array(this.side));
            this._attributes.side.needsUpdate = true;
            this._attributes.width.copyArray(new Float32Array(this.width));
            this._attributes.width.needsUpdate = true;
            this._attributes.uv.copyArray(new Float32Array(this.uvs));
            this._attributes.uv.needsUpdate = true;
            this._attributes.index.copyArray(new Uint16Array(this.indices_array));
            this._attributes.index.needsUpdate = true;
        }
        this.setAttribute('position', this._attributes.position);
        this.setAttribute('previous', this._attributes.previous);
        this.setAttribute('next', this._attributes.next);
        this.setAttribute('side', this._attributes.side);
        this.setAttribute('width', this._attributes.width);
        this.setAttribute('uv', this._attributes.uv);
        this.setAttribute('counters', this._attributes.counters);
        this.setIndex(this._attributes.index);
        this.computeBoundingSphere();
        this.computeBoundingBox();
    };
    function memcpy(src, srcOffset, dst, dstOffset, length) {
        var i;
        src = src.subarray || src.slice ? src : src.buffer;
        dst = dst.subarray || dst.slice ? dst : dst.buffer;
        src = srcOffset ? src.subarray ? src.subarray(srcOffset, length && srcOffset + length) : src.slice(srcOffset, length && srcOffset + length) : src;
        if (dst.set) dst.set(src, dstOffset);
        else for(i = 0; i < src.length; i++)dst[i + dstOffset] = src[i];
        return dst;
    }
    /**
   * Fast method to advance the line by one position.  The oldest position is removed.
   * @param position
   */ MeshLine.prototype.advance = function(position) {
        var positions = this._attributes.position.array;
        var previous = this._attributes.previous.array;
        var next = this._attributes.next.array;
        var l = positions.length;
        // PREVIOUS
        memcpy(positions, 0, previous, 0, l);
        // POSITIONS
        memcpy(positions, 6, positions, 0, l - 6);
        positions[l - 6] = position.x;
        positions[l - 5] = position.y;
        positions[l - 4] = position.z;
        positions[l - 3] = position.x;
        positions[l - 2] = position.y;
        positions[l - 1] = position.z;
        // NEXT
        memcpy(positions, 6, next, 0, l - 6);
        next[l - 6] = position.x;
        next[l - 5] = position.y;
        next[l - 4] = position.z;
        next[l - 3] = position.x;
        next[l - 2] = position.y;
        next[l - 1] = position.z;
        this._attributes.position.needsUpdate = true;
        this._attributes.previous.needsUpdate = true;
        this._attributes.next.needsUpdate = true;
    };
    THREE.ShaderChunk['meshline_vert'] = [
        '',
        THREE.ShaderChunk.logdepthbuf_pars_vertex,
        THREE.ShaderChunk.fog_pars_vertex,
        '',
        'attribute vec3 previous;',
        'attribute vec3 next;',
        'attribute float side;',
        'attribute float width;',
        'attribute float counters;',
        '',
        'uniform vec2 resolution;',
        'uniform float lineWidth;',
        'uniform vec3 color;',
        'uniform float opacity;',
        'uniform float sizeAttenuation;',
        '',
        'varying vec2 vUV;',
        'varying vec4 vColor;',
        'varying float vCounters;',
        '',
        'vec2 fix( vec4 i, float aspect ) {',
        '',
        '    vec2 res = i.xy / i.w;',
        '    res.x *= aspect;',
        '	 vCounters = counters;',
        '    return res;',
        '',
        '}',
        '',
        'void main() {',
        '',
        '    float aspect = resolution.x / resolution.y;',
        '',
        '    vColor = vec4( color, opacity );',
        '    vUV = uv;',
        '',
        '    mat4 m = projectionMatrix * modelViewMatrix;',
        '    vec4 finalPosition = m * vec4( position, 1.0 );',
        '    vec4 prevPos = m * vec4( previous, 1.0 );',
        '    vec4 nextPos = m * vec4( next, 1.0 );',
        '',
        '    vec2 currentP = fix( finalPosition, aspect );',
        '    vec2 prevP = fix( prevPos, aspect );',
        '    vec2 nextP = fix( nextPos, aspect );',
        '',
        '    float w = lineWidth * width;',
        '',
        '    vec2 dir;',
        '    if( nextP == currentP ) dir = normalize( currentP - prevP );',
        '    else if( prevP == currentP ) dir = normalize( nextP - currentP );',
        '    else {',
        '        vec2 dir1 = normalize( currentP - prevP );',
        '        vec2 dir2 = normalize( nextP - currentP );',
        '        dir = normalize( dir1 + dir2 );',
        '',
        '        vec2 perp = vec2( -dir1.y, dir1.x );',
        '        vec2 miter = vec2( -dir.y, dir.x );',
        '        //w = clamp( w / dot( miter, perp ), 0., 4. * lineWidth * width );',
        '',
        '    }',
        '',
        '    //vec2 normal = ( cross( vec3( dir, 0. ), vec3( 0., 0., 1. ) ) ).xy;',
        '    vec4 normal = vec4( -dir.y, dir.x, 0., 1. );',
        '    normal.xy *= .5 * w;',
        '    normal *= projectionMatrix;',
        '    if( sizeAttenuation == 0. ) {',
        '        normal.xy *= finalPosition.w;',
        '        normal.xy /= ( vec4( resolution, 0., 1. ) * projectionMatrix ).xy;',
        '    }',
        '',
        '    finalPosition.xy += normal.xy * side;',
        '',
        '    gl_Position = finalPosition;',
        '',
        THREE.ShaderChunk.logdepthbuf_vertex,
        THREE.ShaderChunk.fog_vertex && '    vec4 mvPosition = modelViewMatrix * vec4( position, 1.0 );',
        THREE.ShaderChunk.fog_vertex,
        '}'
    ].join('\n');
    THREE.ShaderChunk['meshline_frag'] = [
        '',
        THREE.ShaderChunk.fog_pars_fragment,
        THREE.ShaderChunk.logdepthbuf_pars_fragment,
        '',
        'uniform sampler2D map;',
        'uniform sampler2D alphaMap;',
        'uniform float useMap;',
        'uniform float useAlphaMap;',
        'uniform float useDash;',
        'uniform float dashArray;',
        'uniform float dashOffset;',
        'uniform float dashRatio;',
        'uniform float visibility;',
        'uniform float alphaTest;',
        'uniform vec2 repeat;',
        '',
        'varying vec2 vUV;',
        'varying vec4 vColor;',
        'varying float vCounters;',
        '',
        'void main() {',
        '',
        THREE.ShaderChunk.logdepthbuf_fragment,
        '',
        '    vec4 c = vColor;',
        '    if( useMap == 1. ) c *= texture2D( map, vUV * repeat );',
        '    if( useAlphaMap == 1. ) c.a *= texture2D( alphaMap, vUV * repeat ).a;',
        '    if( c.a < alphaTest ) discard;',
        '    if( useDash == 1. ){',
        '        c.a *= ceil(mod(vCounters + dashOffset, dashArray) - (dashArray * dashRatio));',
        '    }',
        '    gl_FragColor = c;',
        '    gl_FragColor.a *= step(vCounters, visibility);',
        '',
        THREE.ShaderChunk.fog_fragment,
        '}'
    ].join('\n');
    class MeshLineMaterial extends THREE.ShaderMaterial {
        constructor(parameters){
            super({
                uniforms: Object.assign({}, THREE.UniformsLib.fog, {
                    lineWidth: {
                        value: 1
                    },
                    map: {
                        value: null
                    },
                    useMap: {
                        value: 0
                    },
                    alphaMap: {
                        value: null
                    },
                    useAlphaMap: {
                        value: 0
                    },
                    color: {
                        value: new THREE.Color(0xffffff)
                    },
                    opacity: {
                        value: 1
                    },
                    resolution: {
                        value: new THREE.Vector2(1, 1)
                    },
                    sizeAttenuation: {
                        value: 1
                    },
                    dashArray: {
                        value: 0
                    },
                    dashOffset: {
                        value: 0
                    },
                    dashRatio: {
                        value: 0.5
                    },
                    useDash: {
                        value: 0
                    },
                    visibility: {
                        value: 1
                    },
                    alphaTest: {
                        value: 0
                    },
                    repeat: {
                        value: new THREE.Vector2(1, 1)
                    }
                }),
                vertexShader: THREE.ShaderChunk.meshline_vert,
                fragmentShader: THREE.ShaderChunk.meshline_frag
            });
            this.isMeshLineMaterial = true;
            this.type = 'MeshLineMaterial';
            Object.defineProperties(this, {
                lineWidth: {
                    enumerable: true,
                    get: function() {
                        return this.uniforms.lineWidth.value;
                    },
                    set: function(value) {
                        this.uniforms.lineWidth.value = value;
                    }
                },
                map: {
                    enumerable: true,
                    get: function() {
                        return this.uniforms.map.value;
                    },
                    set: function(value) {
                        this.uniforms.map.value = value;
                    }
                },
                useMap: {
                    enumerable: true,
                    get: function() {
                        return this.uniforms.useMap.value;
                    },
                    set: function(value) {
                        this.uniforms.useMap.value = value;
                    }
                },
                alphaMap: {
                    enumerable: true,
                    get: function() {
                        return this.uniforms.alphaMap.value;
                    },
                    set: function(value) {
                        this.uniforms.alphaMap.value = value;
                    }
                },
                useAlphaMap: {
                    enumerable: true,
                    get: function() {
                        return this.uniforms.useAlphaMap.value;
                    },
                    set: function(value) {
                        this.uniforms.useAlphaMap.value = value;
                    }
                },
                color: {
                    enumerable: true,
                    get: function() {
                        return this.uniforms.color.value;
                    },
                    set: function(value) {
                        this.uniforms.color.value = value;
                    }
                },
                opacity: {
                    enumerable: true,
                    get: function() {
                        return this.uniforms.opacity.value;
                    },
                    set: function(value) {
                        this.uniforms.opacity.value = value;
                    }
                },
                resolution: {
                    enumerable: true,
                    get: function() {
                        return this.uniforms.resolution.value;
                    },
                    set: function(value) {
                        this.uniforms.resolution.value.copy(value);
                    }
                },
                sizeAttenuation: {
                    enumerable: true,
                    get: function() {
                        return this.uniforms.sizeAttenuation.value;
                    },
                    set: function(value) {
                        this.uniforms.sizeAttenuation.value = value;
                    }
                },
                dashArray: {
                    enumerable: true,
                    get: function() {
                        return this.uniforms.dashArray.value;
                    },
                    set: function(value) {
                        this.uniforms.dashArray.value = value;
                        this.useDash = value !== 0 ? 1 : 0;
                    }
                },
                dashOffset: {
                    enumerable: true,
                    get: function() {
                        return this.uniforms.dashOffset.value;
                    },
                    set: function(value) {
                        this.uniforms.dashOffset.value = value;
                    }
                },
                dashRatio: {
                    enumerable: true,
                    get: function() {
                        return this.uniforms.dashRatio.value;
                    },
                    set: function(value) {
                        this.uniforms.dashRatio.value = value;
                    }
                },
                useDash: {
                    enumerable: true,
                    get: function() {
                        return this.uniforms.useDash.value;
                    },
                    set: function(value) {
                        this.uniforms.useDash.value = value;
                    }
                },
                visibility: {
                    enumerable: true,
                    get: function() {
                        return this.uniforms.visibility.value;
                    },
                    set: function(value) {
                        this.uniforms.visibility.value = value;
                    }
                },
                alphaTest: {
                    enumerable: true,
                    get: function() {
                        return this.uniforms.alphaTest.value;
                    },
                    set: function(value) {
                        this.uniforms.alphaTest.value = value;
                    }
                },
                repeat: {
                    enumerable: true,
                    get: function() {
                        return this.uniforms.repeat.value;
                    },
                    set: function(value) {
                        this.uniforms.repeat.value.copy(value);
                    }
                }
            });
            this.setValues(parameters);
        }
    }
    MeshLineMaterial.prototype.copy = function(source) {
        THREE.ShaderMaterial.prototype.copy.call(this, source);
        this.lineWidth = source.lineWidth;
        this.map = source.map;
        this.useMap = source.useMap;
        this.alphaMap = source.alphaMap;
        this.useAlphaMap = source.useAlphaMap;
        this.color.copy(source.color);
        this.opacity = source.opacity;
        this.resolution.copy(source.resolution);
        this.sizeAttenuation = source.sizeAttenuation;
        this.dashArray.copy(source.dashArray);
        this.dashOffset.copy(source.dashOffset);
        this.dashRatio.copy(source.dashRatio);
        this.useDash = source.useDash;
        this.visibility = source.visibility;
        this.alphaTest = source.alphaTest;
        this.repeat.copy(source.repeat);
        return this;
    };
    if (0, module.exports) exports = module.exports = {
        MeshLine: MeshLine,
        MeshLineMaterial: MeshLineMaterial,
        MeshLineRaycast: MeshLineRaycast
    };
    exports.MeshLine = MeshLine;
    exports.MeshLineMaterial = MeshLineMaterial;
    exports.MeshLineRaycast = MeshLineRaycast;
}).call(this);

});

parcelRequire("ilwiq");
var $dyjou = parcelRequire("dyjou");
var $ilwiq = parcelRequire("ilwiq");
var $dyjou = parcelRequire("dyjou");

var $dyjou = parcelRequire("dyjou");parcelRequire("ilwiq");
var $dyjou = parcelRequire("dyjou");
parcelRequire("ilwiq");
var $dyjou = parcelRequire("dyjou");
var $dyjou = parcelRequire("dyjou");
/** @module BufferGeometryUtils */ /**
 * Computes vertex tangents using the MikkTSpace algorithm. MikkTSpace generates the same tangents consistently,
 * and is used in most modelling tools and normal map bakers. Use MikkTSpace for materials with normal maps,
 * because inconsistent tangents may lead to subtle visual issues in the normal map, particularly around mirrored
 * UV seams.
 *
 * In comparison to this method, {@link BufferGeometry#computeTangents} (a custom algorithm) generates tangents that
 * probably will not match the tangents in other software. The custom algorithm is sufficient for general use with a
 * custom material, and may be faster than MikkTSpace.
 *
 * Returns the original BufferGeometry. Indexed geometries will be de-indexed. Requires position, normal, and uv attributes.
 *
 * @param {BufferGeometry} geometry - The geometry to compute tangents for.
 * @param {Object} MikkTSpace - Instance of `examples/jsm/libs/mikktspace.module.js`, or `mikktspace` npm package.
 * Await `MikkTSpace.ready` before use.
 * @param {boolean} [negateSign=true] - Whether to negate the sign component (.w) of each tangent.
 * Required for normal map conventions in some formats, including glTF.
 * @return {BufferGeometry} The updated geometry.
 */ function $5451ea62abbe5f68$export$676e3e70c930f774(geometry, MikkTSpace, negateSign = true) {
    if (!MikkTSpace || !MikkTSpace.isReady) throw new Error('BufferGeometryUtils: Initialized MikkTSpace library required.');
    if (!geometry.hasAttribute('position') || !geometry.hasAttribute('normal') || !geometry.hasAttribute('uv')) throw new Error('BufferGeometryUtils: Tangents require "position", "normal", and "uv" attributes.');
    function getAttributeArray(attribute) {
        if (attribute.normalized || attribute.isInterleavedBufferAttribute) {
            const dstArray = new Float32Array(attribute.count * attribute.itemSize);
            for(let i = 0, j = 0; i < attribute.count; i++){
                dstArray[j++] = attribute.getX(i);
                dstArray[j++] = attribute.getY(i);
                if (attribute.itemSize > 2) dstArray[j++] = attribute.getZ(i);
            }
            return dstArray;
        }
        if (attribute.array instanceof Float32Array) return attribute.array;
        return new Float32Array(attribute.array);
    }
    // MikkTSpace algorithm requires non-indexed input.
    const _geometry = geometry.index ? geometry.toNonIndexed() : geometry;
    // Compute vertex tangents.
    const tangents = MikkTSpace.generateTangents(getAttributeArray(_geometry.attributes.position), getAttributeArray(_geometry.attributes.normal), getAttributeArray(_geometry.attributes.uv));
    // Texture coordinate convention of glTF differs from the apparent
    // default of the MikkTSpace library; .w component must be flipped.
    if (negateSign) for(let i = 3; i < tangents.length; i += 4)tangents[i] *= -1;
    //
    _geometry.setAttribute('tangent', new (0, $dyjou.BufferAttribute)(tangents, 4));
    if (geometry !== _geometry) geometry.copy(_geometry);
    return geometry;
}
/**
 * Merges a set of geometries into a single instance. All geometries must have compatible attributes.
 *
 * @param {Array<BufferGeometry>} geometries - The geometries to merge.
 * @param {boolean} [useGroups=false] - Whether to use groups or not.
 * @return {?BufferGeometry} The merged geometry. Returns `null` if the merge does not succeed.
 */ function $5451ea62abbe5f68$export$f06f69b3bf41d25c(geometries, useGroups = false) {
    const isIndexed = geometries[0].index !== null;
    const attributesUsed = new Set(Object.keys(geometries[0].attributes));
    const morphAttributesUsed = new Set(Object.keys(geometries[0].morphAttributes));
    const attributes = {};
    const morphAttributes = {};
    const morphTargetsRelative = geometries[0].morphTargetsRelative;
    const mergedGeometry = new (0, $dyjou.BufferGeometry)();
    let offset = 0;
    for(let i = 0; i < geometries.length; ++i){
        const geometry = geometries[i];
        let attributesCount = 0;
        // ensure that all geometries are indexed, or none
        if (isIndexed !== (geometry.index !== null)) {
            console.error('THREE.BufferGeometryUtils: .mergeGeometries() failed with geometry at index ' + i + '. All geometries must have compatible attributes; make sure index attribute exists among all geometries, or in none of them.');
            return null;
        }
        // gather attributes, exit early if they're different
        for(const name in geometry.attributes){
            if (!attributesUsed.has(name)) {
                console.error('THREE.BufferGeometryUtils: .mergeGeometries() failed with geometry at index ' + i + '. All geometries must have compatible attributes; make sure "' + name + '" attribute exists among all geometries, or in none of them.');
                return null;
            }
            if (attributes[name] === undefined) attributes[name] = [];
            attributes[name].push(geometry.attributes[name]);
            attributesCount++;
        }
        // ensure geometries have the same number of attributes
        if (attributesCount !== attributesUsed.size) {
            console.error('THREE.BufferGeometryUtils: .mergeGeometries() failed with geometry at index ' + i + '. Make sure all geometries have the same number of attributes.');
            return null;
        }
        // gather morph attributes, exit early if they're different
        if (morphTargetsRelative !== geometry.morphTargetsRelative) {
            console.error('THREE.BufferGeometryUtils: .mergeGeometries() failed with geometry at index ' + i + '. .morphTargetsRelative must be consistent throughout all geometries.');
            return null;
        }
        for(const name in geometry.morphAttributes){
            if (!morphAttributesUsed.has(name)) {
                console.error('THREE.BufferGeometryUtils: .mergeGeometries() failed with geometry at index ' + i + '.  .morphAttributes must be consistent throughout all geometries.');
                return null;
            }
            if (morphAttributes[name] === undefined) morphAttributes[name] = [];
            morphAttributes[name].push(geometry.morphAttributes[name]);
        }
        if (useGroups) {
            let count;
            if (isIndexed) count = geometry.index.count;
            else if (geometry.attributes.position !== undefined) count = geometry.attributes.position.count;
            else {
                console.error('THREE.BufferGeometryUtils: .mergeGeometries() failed with geometry at index ' + i + '. The geometry must have either an index or a position attribute');
                return null;
            }
            mergedGeometry.addGroup(offset, count, i);
            offset += count;
        }
    }
    // merge indices
    if (isIndexed) {
        let indexOffset = 0;
        const mergedIndex = [];
        for(let i = 0; i < geometries.length; ++i){
            const index = geometries[i].index;
            for(let j = 0; j < index.count; ++j)mergedIndex.push(index.getX(j) + indexOffset);
            indexOffset += geometries[i].attributes.position.count;
        }
        mergedGeometry.setIndex(mergedIndex);
    }
    // merge attributes
    for(const name in attributes){
        const mergedAttribute = $5451ea62abbe5f68$export$9f98db6234c4bd78(attributes[name]);
        if (!mergedAttribute) {
            console.error('THREE.BufferGeometryUtils: .mergeGeometries() failed while trying to merge the ' + name + ' attribute.');
            return null;
        }
        mergedGeometry.setAttribute(name, mergedAttribute);
    }
    // merge morph attributes
    for(const name in morphAttributes){
        const numMorphTargets = morphAttributes[name][0].length;
        if (numMorphTargets === 0) break;
        mergedGeometry.morphAttributes = mergedGeometry.morphAttributes || {};
        mergedGeometry.morphAttributes[name] = [];
        for(let i = 0; i < numMorphTargets; ++i){
            const morphAttributesToMerge = [];
            for(let j = 0; j < morphAttributes[name].length; ++j)morphAttributesToMerge.push(morphAttributes[name][j][i]);
            const mergedMorphAttribute = $5451ea62abbe5f68$export$9f98db6234c4bd78(morphAttributesToMerge);
            if (!mergedMorphAttribute) {
                console.error('THREE.BufferGeometryUtils: .mergeGeometries() failed while trying to merge the ' + name + ' morphAttribute.');
                return null;
            }
            mergedGeometry.morphAttributes[name].push(mergedMorphAttribute);
        }
    }
    return mergedGeometry;
}
/**
 * Merges a set of attributes into a single instance. All attributes must have compatible properties and types.
 * Instances of {@link InterleavedBufferAttribute} are not supported.
 *
 * @param {Array<BufferAttribute>} attributes - The attributes to merge.
 * @return {?BufferAttribute} The merged attribute. Returns `null` if the merge does not succeed.
 */ function $5451ea62abbe5f68$export$9f98db6234c4bd78(attributes) {
    let TypedArray;
    let itemSize;
    let normalized;
    let gpuType = -1;
    let arrayLength = 0;
    for(let i = 0; i < attributes.length; ++i){
        const attribute = attributes[i];
        if (TypedArray === undefined) TypedArray = attribute.array.constructor;
        if (TypedArray !== attribute.array.constructor) {
            console.error('THREE.BufferGeometryUtils: .mergeAttributes() failed. BufferAttribute.array must be of consistent array types across matching attributes.');
            return null;
        }
        if (itemSize === undefined) itemSize = attribute.itemSize;
        if (itemSize !== attribute.itemSize) {
            console.error('THREE.BufferGeometryUtils: .mergeAttributes() failed. BufferAttribute.itemSize must be consistent across matching attributes.');
            return null;
        }
        if (normalized === undefined) normalized = attribute.normalized;
        if (normalized !== attribute.normalized) {
            console.error('THREE.BufferGeometryUtils: .mergeAttributes() failed. BufferAttribute.normalized must be consistent across matching attributes.');
            return null;
        }
        if (gpuType === -1) gpuType = attribute.gpuType;
        if (gpuType !== attribute.gpuType) {
            console.error('THREE.BufferGeometryUtils: .mergeAttributes() failed. BufferAttribute.gpuType must be consistent across matching attributes.');
            return null;
        }
        arrayLength += attribute.count * itemSize;
    }
    const array = new TypedArray(arrayLength);
    const result = new (0, $dyjou.BufferAttribute)(array, itemSize, normalized);
    let offset = 0;
    for(let i = 0; i < attributes.length; ++i){
        const attribute = attributes[i];
        if (attribute.isInterleavedBufferAttribute) {
            const tupleOffset = offset / itemSize;
            for(let j = 0, l = attribute.count; j < l; j++)for(let c = 0; c < itemSize; c++){
                const value = attribute.getComponent(j, c);
                result.setComponent(j + tupleOffset, c, value);
            }
        } else array.set(attribute.array, offset);
        offset += attribute.count * itemSize;
    }
    if (gpuType !== undefined) result.gpuType = gpuType;
    return result;
}
/**
 * Performs a deep clone of the given buffer attribute.
 *
 * @param {BufferAttribute} attribute - The attribute to clone.
 * @return {BufferAttribute} The cloned attribute.
 */ function $5451ea62abbe5f68$export$4848639a9adff548(attribute) {
    if (attribute.isInstancedInterleavedBufferAttribute || attribute.isInterleavedBufferAttribute) return $5451ea62abbe5f68$export$4b7aa2f2134b7e19(attribute);
    if (attribute.isInstancedBufferAttribute) return new (0, $dyjou.InstancedBufferAttribute)().copy(attribute);
    return new (0, $dyjou.BufferAttribute)().copy(attribute);
}
/**
 * Interleaves a set of attributes and returns a new array of corresponding attributes that share a
 * single {@link InterleavedBuffer} instance. All attributes must have compatible types.
 *
 * @param {Array<BufferAttribute>} attributes - The attributes to interleave.
 * @return {Array<InterleavedBufferAttribute>} An array of interleaved attributes. If interleave does not succeed, the method returns `null`.
 */ function $5451ea62abbe5f68$export$308f9509e428a845(attributes) {
    // Interleaves the provided attributes into an InterleavedBuffer and returns
    // a set of InterleavedBufferAttributes for each attribute
    let TypedArray;
    let arrayLength = 0;
    let stride = 0;
    // calculate the length and type of the interleavedBuffer
    for(let i = 0, l = attributes.length; i < l; ++i){
        const attribute = attributes[i];
        if (TypedArray === undefined) TypedArray = attribute.array.constructor;
        if (TypedArray !== attribute.array.constructor) {
            console.error('AttributeBuffers of different types cannot be interleaved');
            return null;
        }
        arrayLength += attribute.array.length;
        stride += attribute.itemSize;
    }
    // Create the set of buffer attributes
    const interleavedBuffer = new (0, $dyjou.InterleavedBuffer)(new TypedArray(arrayLength), stride);
    let offset = 0;
    const res = [];
    const getters = [
        'getX',
        'getY',
        'getZ',
        'getW'
    ];
    const setters = [
        'setX',
        'setY',
        'setZ',
        'setW'
    ];
    for(let j = 0, l = attributes.length; j < l; j++){
        const attribute = attributes[j];
        const itemSize = attribute.itemSize;
        const count = attribute.count;
        const iba = new (0, $dyjou.InterleavedBufferAttribute)(interleavedBuffer, itemSize, offset, attribute.normalized);
        res.push(iba);
        offset += itemSize;
        // Move the data for each attribute into the new interleavedBuffer
        // at the appropriate offset
        for(let c = 0; c < count; c++)for(let k = 0; k < itemSize; k++)iba[setters[k]](c, attribute[getters[k]](c));
    }
    return res;
}
/**
 * Returns a new, non-interleaved version of the given attribute.
 *
 * @param {InterleavedBufferAttribute} attribute - The interleaved attribute.
 * @return {BufferAttribute} The non-interleaved attribute.
 */ function $5451ea62abbe5f68$export$4b7aa2f2134b7e19(attribute) {
    const cons = attribute.data.array.constructor;
    const count = attribute.count;
    const itemSize = attribute.itemSize;
    const normalized = attribute.normalized;
    const array = new cons(count * itemSize);
    let newAttribute;
    if (attribute.isInstancedInterleavedBufferAttribute) newAttribute = new (0, $dyjou.InstancedBufferAttribute)(array, itemSize, normalized, attribute.meshPerAttribute);
    else newAttribute = new (0, $dyjou.BufferAttribute)(array, itemSize, normalized);
    for(let i = 0; i < count; i++){
        newAttribute.setX(i, attribute.getX(i));
        if (itemSize >= 2) newAttribute.setY(i, attribute.getY(i));
        if (itemSize >= 3) newAttribute.setZ(i, attribute.getZ(i));
        if (itemSize >= 4) newAttribute.setW(i, attribute.getW(i));
    }
    return newAttribute;
}
/**
 * Deinterleaves all attributes on the given geometry.
 *
 * @param {BufferGeometry} geometry - The geometry to deinterleave.
 */ function $5451ea62abbe5f68$export$e7413b17bfaaa80b(geometry) {
    const attributes = geometry.attributes;
    const morphTargets = geometry.morphTargets;
    const attrMap = new Map();
    for(const key in attributes){
        const attr = attributes[key];
        if (attr.isInterleavedBufferAttribute) {
            if (!attrMap.has(attr)) attrMap.set(attr, $5451ea62abbe5f68$export$4b7aa2f2134b7e19(attr));
            attributes[key] = attrMap.get(attr);
        }
    }
    for(const key in morphTargets){
        const attr = morphTargets[key];
        if (attr.isInterleavedBufferAttribute) {
            if (!attrMap.has(attr)) attrMap.set(attr, $5451ea62abbe5f68$export$4b7aa2f2134b7e19(attr));
            morphTargets[key] = attrMap.get(attr);
        }
    }
}
/**
 * Returns the amount of bytes used by all attributes to represent the geometry.
 *
 * @param {BufferGeometry} geometry - The geometry.
 * @return {number} The estimate bytes used.
 */ function $5451ea62abbe5f68$export$35bee7999e19754d(geometry) {
    // Return the estimated memory used by this geometry in bytes
    // Calculate using itemSize, count, and BYTES_PER_ELEMENT to account
    // for InterleavedBufferAttributes.
    let mem = 0;
    for(const name in geometry.attributes){
        const attr = geometry.getAttribute(name);
        mem += attr.count * attr.itemSize * attr.array.BYTES_PER_ELEMENT;
    }
    const indices = geometry.getIndex();
    mem += indices ? indices.count * indices.itemSize * indices.array.BYTES_PER_ELEMENT : 0;
    return mem;
}
/**
 * Returns a new geometry with vertices for which all similar vertex attributes (within tolerance) are merged.
 *
 * @param {BufferGeometry} geometry - The geometry to merge vertices for.
 * @param {number} [tolerance=1e-4] - The tolerance value.
 * @return {BufferGeometry} - The new geometry with merged vertices.
 */ function $5451ea62abbe5f68$export$e36bb98c4c944f9(geometry, tolerance = 1e-4) {
    tolerance = Math.max(tolerance, Number.EPSILON);
    // Generate an index buffer if the geometry doesn't have one, or optimize it
    // if it's already available.
    const hashToIndex = {};
    const indices = geometry.getIndex();
    const positions = geometry.getAttribute('position');
    const vertexCount = indices ? indices.count : positions.count;
    // next value for triangle indices
    let nextIndex = 0;
    // attributes and new attribute arrays
    const attributeNames = Object.keys(geometry.attributes);
    const tmpAttributes = {};
    const tmpMorphAttributes = {};
    const newIndices = [];
    const getters = [
        'getX',
        'getY',
        'getZ',
        'getW'
    ];
    const setters = [
        'setX',
        'setY',
        'setZ',
        'setW'
    ];
    // Initialize the arrays, allocating space conservatively. Extra
    // space will be trimmed in the last step.
    for(let i = 0, l = attributeNames.length; i < l; i++){
        const name = attributeNames[i];
        const attr = geometry.attributes[name];
        tmpAttributes[name] = new attr.constructor(new attr.array.constructor(attr.count * attr.itemSize), attr.itemSize, attr.normalized);
        const morphAttributes = geometry.morphAttributes[name];
        if (morphAttributes) {
            if (!tmpMorphAttributes[name]) tmpMorphAttributes[name] = [];
            morphAttributes.forEach((morphAttr, i)=>{
                const array = new morphAttr.array.constructor(morphAttr.count * morphAttr.itemSize);
                tmpMorphAttributes[name][i] = new morphAttr.constructor(array, morphAttr.itemSize, morphAttr.normalized);
            });
        }
    }
    // convert the error tolerance to an amount of decimal places to truncate to
    const halfTolerance = tolerance * 0.5;
    const exponent = Math.log10(1 / tolerance);
    const hashMultiplier = Math.pow(10, exponent);
    const hashAdditive = halfTolerance * hashMultiplier;
    for(let i = 0; i < vertexCount; i++){
        const index = indices ? indices.getX(i) : i;
        // Generate a hash for the vertex attributes at the current index 'i'
        let hash = '';
        for(let j = 0, l = attributeNames.length; j < l; j++){
            const name = attributeNames[j];
            const attribute = geometry.getAttribute(name);
            const itemSize = attribute.itemSize;
            for(let k = 0; k < itemSize; k++)// double tilde truncates the decimal value
            hash += `${~~(attribute[getters[k]](index) * hashMultiplier + hashAdditive)},`;
        }
        // Add another reference to the vertex if it's already
        // used by another index
        if (hash in hashToIndex) newIndices.push(hashToIndex[hash]);
        else {
            // copy data to the new index in the temporary attributes
            for(let j = 0, l = attributeNames.length; j < l; j++){
                const name = attributeNames[j];
                const attribute = geometry.getAttribute(name);
                const morphAttributes = geometry.morphAttributes[name];
                const itemSize = attribute.itemSize;
                const newArray = tmpAttributes[name];
                const newMorphArrays = tmpMorphAttributes[name];
                for(let k = 0; k < itemSize; k++){
                    const getterFunc = getters[k];
                    const setterFunc = setters[k];
                    newArray[setterFunc](nextIndex, attribute[getterFunc](index));
                    if (morphAttributes) for(let m = 0, ml = morphAttributes.length; m < ml; m++)newMorphArrays[m][setterFunc](nextIndex, morphAttributes[m][getterFunc](index));
                }
            }
            hashToIndex[hash] = nextIndex;
            newIndices.push(nextIndex);
            nextIndex++;
        }
    }
    // generate result BufferGeometry
    const result = geometry.clone();
    for(const name in geometry.attributes){
        const tmpAttribute = tmpAttributes[name];
        result.setAttribute(name, new tmpAttribute.constructor(tmpAttribute.array.slice(0, nextIndex * tmpAttribute.itemSize), tmpAttribute.itemSize, tmpAttribute.normalized));
        if (!(name in tmpMorphAttributes)) continue;
        for(let j = 0; j < tmpMorphAttributes[name].length; j++){
            const tmpMorphAttribute = tmpMorphAttributes[name][j];
            result.morphAttributes[name][j] = new tmpMorphAttribute.constructor(tmpMorphAttribute.array.slice(0, nextIndex * tmpMorphAttribute.itemSize), tmpMorphAttribute.itemSize, tmpMorphAttribute.normalized);
        }
    }
    // indices
    result.setIndex(newIndices);
    return result;
}
/**
 * Returns a new indexed geometry based on `TrianglesDrawMode` draw mode.
 * This mode corresponds to the `gl.TRIANGLES` primitive in WebGL.
 *
 * @param {BufferGeometry} geometry - The geometry to convert.
 * @param {number} drawMode - The current draw mode.
 * @return {BufferGeometry} The new geometry using `TrianglesDrawMode`.
 */ function $5451ea62abbe5f68$export$5492ca6e5c0c7aa0(geometry, drawMode) {
    if (drawMode === (0, $dyjou.TrianglesDrawMode)) {
        console.warn('THREE.BufferGeometryUtils.toTrianglesDrawMode(): Geometry already defined as triangles.');
        return geometry;
    }
    if (drawMode === (0, $dyjou.TriangleFanDrawMode) || drawMode === (0, $dyjou.TriangleStripDrawMode)) {
        let index = geometry.getIndex();
        // generate index if not present
        if (index === null) {
            const indices = [];
            const position = geometry.getAttribute('position');
            if (position !== undefined) {
                for(let i = 0; i < position.count; i++)indices.push(i);
                geometry.setIndex(indices);
                index = geometry.getIndex();
            } else {
                console.error('THREE.BufferGeometryUtils.toTrianglesDrawMode(): Undefined position attribute. Processing not possible.');
                return geometry;
            }
        }
        //
        const numberOfTriangles = index.count - 2;
        const newIndices = [];
        if (drawMode === (0, $dyjou.TriangleFanDrawMode)) // gl.TRIANGLE_FAN
        for(let i = 1; i <= numberOfTriangles; i++){
            newIndices.push(index.getX(0));
            newIndices.push(index.getX(i));
            newIndices.push(index.getX(i + 1));
        }
        else {
            // gl.TRIANGLE_STRIP
            for(let i = 0; i < numberOfTriangles; i++)if (i % 2 === 0) {
                newIndices.push(index.getX(i));
                newIndices.push(index.getX(i + 1));
                newIndices.push(index.getX(i + 2));
            } else {
                newIndices.push(index.getX(i + 2));
                newIndices.push(index.getX(i + 1));
                newIndices.push(index.getX(i));
            }
        }
        if (newIndices.length / 3 !== numberOfTriangles) console.error('THREE.BufferGeometryUtils.toTrianglesDrawMode(): Unable to generate correct amount of triangles.');
        // build final geometry
        const newGeometry = geometry.clone();
        newGeometry.setIndex(newIndices);
        newGeometry.clearGroups();
        return newGeometry;
    } else {
        console.error('THREE.BufferGeometryUtils.toTrianglesDrawMode(): Unknown draw mode:', drawMode);
        return geometry;
    }
}
/**
 * Calculates the morphed attributes of a morphed/skinned BufferGeometry.
 *
 * Helpful for Raytracing or Decals (i.e. a `DecalGeometry` applied to a morphed Object with a `BufferGeometry`
 * will use the original `BufferGeometry`, not the morphed/skinned one, generating an incorrect result.
 * Using this function to create a shadow `Object3`D the `DecalGeometry` can be correctly generated).
 *
 * @param {Mesh|Line|Points} object - The 3D object to compute morph attributes for.
 * @return {Object} An object with original position/normal attributes and morphed ones.
 */ function $5451ea62abbe5f68$export$29e54e2e4ab904e7(object) {
    const _vA = new (0, $dyjou.Vector3)();
    const _vB = new (0, $dyjou.Vector3)();
    const _vC = new (0, $dyjou.Vector3)();
    const _tempA = new (0, $dyjou.Vector3)();
    const _tempB = new (0, $dyjou.Vector3)();
    const _tempC = new (0, $dyjou.Vector3)();
    const _morphA = new (0, $dyjou.Vector3)();
    const _morphB = new (0, $dyjou.Vector3)();
    const _morphC = new (0, $dyjou.Vector3)();
    function _calculateMorphedAttributeData(object, attribute, morphAttribute, morphTargetsRelative, a, b, c, modifiedAttributeArray) {
        _vA.fromBufferAttribute(attribute, a);
        _vB.fromBufferAttribute(attribute, b);
        _vC.fromBufferAttribute(attribute, c);
        const morphInfluences = object.morphTargetInfluences;
        if (morphAttribute && morphInfluences) {
            _morphA.set(0, 0, 0);
            _morphB.set(0, 0, 0);
            _morphC.set(0, 0, 0);
            for(let i = 0, il = morphAttribute.length; i < il; i++){
                const influence = morphInfluences[i];
                const morph = morphAttribute[i];
                if (influence === 0) continue;
                _tempA.fromBufferAttribute(morph, a);
                _tempB.fromBufferAttribute(morph, b);
                _tempC.fromBufferAttribute(morph, c);
                if (morphTargetsRelative) {
                    _morphA.addScaledVector(_tempA, influence);
                    _morphB.addScaledVector(_tempB, influence);
                    _morphC.addScaledVector(_tempC, influence);
                } else {
                    _morphA.addScaledVector(_tempA.sub(_vA), influence);
                    _morphB.addScaledVector(_tempB.sub(_vB), influence);
                    _morphC.addScaledVector(_tempC.sub(_vC), influence);
                }
            }
            _vA.add(_morphA);
            _vB.add(_morphB);
            _vC.add(_morphC);
        }
        if (object.isSkinnedMesh) {
            object.applyBoneTransform(a, _vA);
            object.applyBoneTransform(b, _vB);
            object.applyBoneTransform(c, _vC);
        }
        modifiedAttributeArray[a * 3 + 0] = _vA.x;
        modifiedAttributeArray[a * 3 + 1] = _vA.y;
        modifiedAttributeArray[a * 3 + 2] = _vA.z;
        modifiedAttributeArray[b * 3 + 0] = _vB.x;
        modifiedAttributeArray[b * 3 + 1] = _vB.y;
        modifiedAttributeArray[b * 3 + 2] = _vB.z;
        modifiedAttributeArray[c * 3 + 0] = _vC.x;
        modifiedAttributeArray[c * 3 + 1] = _vC.y;
        modifiedAttributeArray[c * 3 + 2] = _vC.z;
    }
    const geometry = object.geometry;
    const material = object.material;
    let a, b, c;
    const index = geometry.index;
    const positionAttribute = geometry.attributes.position;
    const morphPosition = geometry.morphAttributes.position;
    const morphTargetsRelative = geometry.morphTargetsRelative;
    const normalAttribute = geometry.attributes.normal;
    const morphNormal = geometry.morphAttributes.position;
    const groups = geometry.groups;
    const drawRange = geometry.drawRange;
    let i, j, il, jl;
    let group;
    let start, end;
    const modifiedPosition = new Float32Array(positionAttribute.count * positionAttribute.itemSize);
    const modifiedNormal = new Float32Array(normalAttribute.count * normalAttribute.itemSize);
    if (index !== null) {
        // indexed buffer geometry
        if (Array.isArray(material)) for(i = 0, il = groups.length; i < il; i++){
            group = groups[i];
            start = Math.max(group.start, drawRange.start);
            end = Math.min(group.start + group.count, drawRange.start + drawRange.count);
            for(j = start, jl = end; j < jl; j += 3){
                a = index.getX(j);
                b = index.getX(j + 1);
                c = index.getX(j + 2);
                _calculateMorphedAttributeData(object, positionAttribute, morphPosition, morphTargetsRelative, a, b, c, modifiedPosition);
                _calculateMorphedAttributeData(object, normalAttribute, morphNormal, morphTargetsRelative, a, b, c, modifiedNormal);
            }
        }
        else {
            start = Math.max(0, drawRange.start);
            end = Math.min(index.count, drawRange.start + drawRange.count);
            for(i = start, il = end; i < il; i += 3){
                a = index.getX(i);
                b = index.getX(i + 1);
                c = index.getX(i + 2);
                _calculateMorphedAttributeData(object, positionAttribute, morphPosition, morphTargetsRelative, a, b, c, modifiedPosition);
                _calculateMorphedAttributeData(object, normalAttribute, morphNormal, morphTargetsRelative, a, b, c, modifiedNormal);
            }
        }
    } else {
        // non-indexed buffer geometry
        if (Array.isArray(material)) for(i = 0, il = groups.length; i < il; i++){
            group = groups[i];
            start = Math.max(group.start, drawRange.start);
            end = Math.min(group.start + group.count, drawRange.start + drawRange.count);
            for(j = start, jl = end; j < jl; j += 3){
                a = j;
                b = j + 1;
                c = j + 2;
                _calculateMorphedAttributeData(object, positionAttribute, morphPosition, morphTargetsRelative, a, b, c, modifiedPosition);
                _calculateMorphedAttributeData(object, normalAttribute, morphNormal, morphTargetsRelative, a, b, c, modifiedNormal);
            }
        }
        else {
            start = Math.max(0, drawRange.start);
            end = Math.min(positionAttribute.count, drawRange.start + drawRange.count);
            for(i = start, il = end; i < il; i += 3){
                a = i;
                b = i + 1;
                c = i + 2;
                _calculateMorphedAttributeData(object, positionAttribute, morphPosition, morphTargetsRelative, a, b, c, modifiedPosition);
                _calculateMorphedAttributeData(object, normalAttribute, morphNormal, morphTargetsRelative, a, b, c, modifiedNormal);
            }
        }
    }
    const morphedPositionAttribute = new (0, $dyjou.Float32BufferAttribute)(modifiedPosition, 3);
    const morphedNormalAttribute = new (0, $dyjou.Float32BufferAttribute)(modifiedNormal, 3);
    return {
        positionAttribute: positionAttribute,
        normalAttribute: normalAttribute,
        morphedPositionAttribute: morphedPositionAttribute,
        morphedNormalAttribute: morphedNormalAttribute
    };
}
/**
 * Merges the {@link BufferGeometry#groups} for the given geometry.
 *
 * @param {BufferGeometry} geometry - The geometry to modify.
 * @return {BufferGeometry} - The updated geometry
 */ function $5451ea62abbe5f68$export$8babbf41197098b1(geometry) {
    if (geometry.groups.length === 0) {
        console.warn('THREE.BufferGeometryUtils.mergeGroups(): No groups are defined. Nothing to merge.');
        return geometry;
    }
    let groups = geometry.groups;
    // sort groups by material index
    groups = groups.sort((a, b)=>{
        if (a.materialIndex !== b.materialIndex) return a.materialIndex - b.materialIndex;
        return a.start - b.start;
    });
    // create index for non-indexed geometries
    if (geometry.getIndex() === null) {
        const positionAttribute = geometry.getAttribute('position');
        const indices = [];
        for(let i = 0; i < positionAttribute.count; i += 3)indices.push(i, i + 1, i + 2);
        geometry.setIndex(indices);
    }
    // sort index
    const index = geometry.getIndex();
    const newIndices = [];
    for(let i = 0; i < groups.length; i++){
        const group = groups[i];
        const groupStart = group.start;
        const groupLength = groupStart + group.count;
        for(let j = groupStart; j < groupLength; j++)newIndices.push(index.getX(j));
    }
    geometry.dispose(); // Required to force buffer recreation
    geometry.setIndex(newIndices);
    // update groups indices
    let start = 0;
    for(let i = 0; i < groups.length; i++){
        const group = groups[i];
        group.start = start;
        start += group.count;
    }
    // merge groups
    let currentGroup = groups[0];
    geometry.groups = [
        currentGroup
    ];
    for(let i = 1; i < groups.length; i++){
        const group = groups[i];
        if (currentGroup.materialIndex === group.materialIndex) currentGroup.count += group.count;
        else {
            currentGroup = group;
            geometry.groups.push(currentGroup);
        }
    }
    return geometry;
}
/**
 * Modifies the supplied geometry if it is non-indexed, otherwise creates a new,
 * non-indexed geometry. Returns the geometry with smooth normals everywhere except
 * faces that meet at an angle greater than the crease angle.
 *
 * @param {BufferGeometry} geometry - The geometry to modify.
 * @param {number} [creaseAngle=Math.PI/3] - The crease angle in radians.
 * @return {BufferGeometry} - The updated geometry
 */ function $5451ea62abbe5f68$export$b525764477fc001f(geometry, creaseAngle = Math.PI / 3 /* 60 degrees */ ) {
    const creaseDot = Math.cos(creaseAngle);
    const hashMultiplier = (1 + 1e-10) * 1e2;
    // reusable vectors
    const verts = [
        new (0, $dyjou.Vector3)(),
        new (0, $dyjou.Vector3)(),
        new (0, $dyjou.Vector3)()
    ];
    const tempVec1 = new (0, $dyjou.Vector3)();
    const tempVec2 = new (0, $dyjou.Vector3)();
    const tempNorm = new (0, $dyjou.Vector3)();
    const tempNorm2 = new (0, $dyjou.Vector3)();
    // hashes a vector
    function hashVertex(v) {
        const x = ~~(v.x * hashMultiplier);
        const y = ~~(v.y * hashMultiplier);
        const z = ~~(v.z * hashMultiplier);
        return `${x},${y},${z}`;
    }
    // BufferGeometry.toNonIndexed() warns if the geometry is non-indexed
    // and returns the original geometry
    const resultGeometry = geometry.index ? geometry.toNonIndexed() : geometry;
    const posAttr = resultGeometry.attributes.position;
    const vertexMap = {};
    // find all the normals shared by commonly located vertices
    for(let i = 0, l = posAttr.count / 3; i < l; i++){
        const i3 = 3 * i;
        const a = verts[0].fromBufferAttribute(posAttr, i3 + 0);
        const b = verts[1].fromBufferAttribute(posAttr, i3 + 1);
        const c = verts[2].fromBufferAttribute(posAttr, i3 + 2);
        tempVec1.subVectors(c, b);
        tempVec2.subVectors(a, b);
        // add the normal to the map for all vertices
        const normal = new (0, $dyjou.Vector3)().crossVectors(tempVec1, tempVec2).normalize();
        for(let n = 0; n < 3; n++){
            const vert = verts[n];
            const hash = hashVertex(vert);
            if (!(hash in vertexMap)) vertexMap[hash] = [];
            vertexMap[hash].push(normal);
        }
    }
    // average normals from all vertices that share a common location if they are within the
    // provided crease threshold
    const normalArray = new Float32Array(posAttr.count * 3);
    const normAttr = new (0, $dyjou.BufferAttribute)(normalArray, 3, false);
    for(let i = 0, l = posAttr.count / 3; i < l; i++){
        // get the face normal for this vertex
        const i3 = 3 * i;
        const a = verts[0].fromBufferAttribute(posAttr, i3 + 0);
        const b = verts[1].fromBufferAttribute(posAttr, i3 + 1);
        const c = verts[2].fromBufferAttribute(posAttr, i3 + 2);
        tempVec1.subVectors(c, b);
        tempVec2.subVectors(a, b);
        tempNorm.crossVectors(tempVec1, tempVec2).normalize();
        // average all normals that meet the threshold and set the normal value
        for(let n = 0; n < 3; n++){
            const vert = verts[n];
            const hash = hashVertex(vert);
            const otherNormals = vertexMap[hash];
            tempNorm2.set(0, 0, 0);
            for(let k = 0, lk = otherNormals.length; k < lk; k++){
                const otherNorm = otherNormals[k];
                if (tempNorm.dot(otherNorm) > creaseDot) tempNorm2.add(otherNorm);
            }
            tempNorm2.normalize();
            normAttr.setXYZ(i3 + n, tempNorm2.x, tempNorm2.y, tempNorm2.z);
        }
    }
    resultGeometry.setAttribute('normal', normAttr);
    return resultGeometry;
}


/**
 * A loader for the glTF 2.0 format.
 *
 * [glTF]{@link https://www.khronos.org/gltf/} (GL Transmission Format) is an [open format specification]{@link https://github.com/KhronosGroup/glTF/tree/main/specification/2.0}
 * for efficient delivery and loading of 3D content. Assets may be provided either in JSON (.gltf) or binary (.glb)
 * format. External files store textures (.jpg, .png) and additional binary data (.bin). A glTF asset may deliver
 * one or more scenes, including meshes, materials, textures, skins, skeletons, morph targets, animations, lights,
 * and/or cameras.
 *
 * `GLTFLoader` uses {@link ImageBitmapLoader} whenever possible. Be advised that image bitmaps are not
 * automatically GC-collected when they are no longer referenced, and they require special handling during
 * the disposal process.
 *
 * `GLTFLoader` supports the following glTF 2.0 extensions:
 * - KHR_draco_mesh_compression
 * - KHR_materials_clearcoat
 * - KHR_materials_dispersion
 * - KHR_materials_ior
 * - KHR_materials_specular
 * - KHR_materials_transmission
 * - KHR_materials_iridescence
 * - KHR_materials_unlit
 * - KHR_materials_volume
 * - KHR_mesh_quantization
 * - KHR_lights_punctual
 * - KHR_texture_basisu
 * - KHR_texture_transform
 * - EXT_texture_webp
 * - EXT_meshopt_compression
 * - EXT_mesh_gpu_instancing
 *
 * The following glTF 2.0 extension is supported by an external user plugin:
 * - [KHR_materials_variants]{@link https://github.com/takahirox/three-gltf-extensions}
 * - [MSFT_texture_dds]{@link https://github.com/takahirox/three-gltf-extensions}
 *
 * ```js
 * const loader = new GLTFLoader();
 *
 * // Optional: Provide a DRACOLoader instance to decode compressed mesh data
 * const dracoLoader = new DRACOLoader();
 * dracoLoader.setDecoderPath( '/examples/jsm/libs/draco/' );
 * loader.setDRACOLoader( dracoLoader );
 *
 * const gltf = await loader.loadAsync( 'models/gltf/duck/duck.gltf' );
 * scene.add( gltf.scene );
 * ```
 *
 * @augments Loader
 */ class $559434fcc6e6401d$export$aa93f11e7884f0f4 extends (0, $dyjou.Loader) {
    /**
	 * Constructs a new glTF loader.
	 *
	 * @param {LoadingManager} [manager] - The loading manager.
	 */ constructor(manager){
        super(manager);
        this.dracoLoader = null;
        this.ktx2Loader = null;
        this.meshoptDecoder = null;
        this.pluginCallbacks = [];
        this.register(function(parser) {
            return new $559434fcc6e6401d$var$GLTFMaterialsClearcoatExtension(parser);
        });
        this.register(function(parser) {
            return new $559434fcc6e6401d$var$GLTFMaterialsDispersionExtension(parser);
        });
        this.register(function(parser) {
            return new $559434fcc6e6401d$var$GLTFTextureBasisUExtension(parser);
        });
        this.register(function(parser) {
            return new $559434fcc6e6401d$var$GLTFTextureWebPExtension(parser);
        });
        this.register(function(parser) {
            return new $559434fcc6e6401d$var$GLTFTextureAVIFExtension(parser);
        });
        this.register(function(parser) {
            return new $559434fcc6e6401d$var$GLTFMaterialsSheenExtension(parser);
        });
        this.register(function(parser) {
            return new $559434fcc6e6401d$var$GLTFMaterialsTransmissionExtension(parser);
        });
        this.register(function(parser) {
            return new $559434fcc6e6401d$var$GLTFMaterialsVolumeExtension(parser);
        });
        this.register(function(parser) {
            return new $559434fcc6e6401d$var$GLTFMaterialsIorExtension(parser);
        });
        this.register(function(parser) {
            return new $559434fcc6e6401d$var$GLTFMaterialsEmissiveStrengthExtension(parser);
        });
        this.register(function(parser) {
            return new $559434fcc6e6401d$var$GLTFMaterialsSpecularExtension(parser);
        });
        this.register(function(parser) {
            return new $559434fcc6e6401d$var$GLTFMaterialsIridescenceExtension(parser);
        });
        this.register(function(parser) {
            return new $559434fcc6e6401d$var$GLTFMaterialsAnisotropyExtension(parser);
        });
        this.register(function(parser) {
            return new $559434fcc6e6401d$var$GLTFMaterialsBumpExtension(parser);
        });
        this.register(function(parser) {
            return new $559434fcc6e6401d$var$GLTFLightsExtension(parser);
        });
        this.register(function(parser) {
            return new $559434fcc6e6401d$var$GLTFMeshoptCompression(parser);
        });
        this.register(function(parser) {
            return new $559434fcc6e6401d$var$GLTFMeshGpuInstancing(parser);
        });
    }
    /**
	 * Starts loading from the given URL and passes the loaded glTF asset
	 * to the `onLoad()` callback.
	 *
	 * @param {string} url - The path/URL of the file to be loaded. This can also be a data URI.
	 * @param {function(GLTFLoader~LoadObject)} onLoad - Executed when the loading process has been finished.
	 * @param {onProgressCallback} onProgress - Executed while the loading is in progress.
	 * @param {onErrorCallback} onError - Executed when errors occur.
	 */ load(url, onLoad, onProgress, onError) {
        const scope = this;
        let resourcePath;
        if (this.resourcePath !== '') resourcePath = this.resourcePath;
        else if (this.path !== '') {
            // If a base path is set, resources will be relative paths from that plus the relative path of the gltf file
            // Example  path = 'https://my-cnd-server.com/', url = 'assets/models/model.gltf'
            // resourcePath = 'https://my-cnd-server.com/assets/models/'
            // referenced resource 'model.bin' will be loaded from 'https://my-cnd-server.com/assets/models/model.bin'
            // referenced resource '../textures/texture.png' will be loaded from 'https://my-cnd-server.com/assets/textures/texture.png'
            const relativeUrl = (0, $dyjou.LoaderUtils).extractUrlBase(url);
            resourcePath = (0, $dyjou.LoaderUtils).resolveURL(relativeUrl, this.path);
        } else resourcePath = (0, $dyjou.LoaderUtils).extractUrlBase(url);
        // Tells the LoadingManager to track an extra item, which resolves after
        // the model is fully loaded. This means the count of items loaded will
        // be incorrect, but ensures manager.onLoad() does not fire early.
        this.manager.itemStart(url);
        const _onError = function(e) {
            if (onError) onError(e);
            else console.error(e);
            scope.manager.itemError(url);
            scope.manager.itemEnd(url);
        };
        const loader = new (0, $dyjou.FileLoader)(this.manager);
        loader.setPath(this.path);
        loader.setResponseType('arraybuffer');
        loader.setRequestHeader(this.requestHeader);
        loader.setWithCredentials(this.withCredentials);
        loader.load(url, function(data) {
            try {
                scope.parse(data, resourcePath, function(gltf) {
                    onLoad(gltf);
                    scope.manager.itemEnd(url);
                }, _onError);
            } catch (e) {
                _onError(e);
            }
        }, onProgress, _onError);
    }
    /**
	 * Sets the given Draco loader to this loader. Required for decoding assets
	 * compressed with the `KHR_draco_mesh_compression` extension.
	 *
	 * @param {DRACOLoader} dracoLoader - The Draco loader to set.
	 * @return {GLTFLoader} A reference to this loader.
	 */ setDRACOLoader(dracoLoader) {
        this.dracoLoader = dracoLoader;
        return this;
    }
    /**
	 * Sets the given KTX2 loader to this loader. Required for loading KTX2
	 * compressed textures.
	 *
	 * @param {KTX2Loader} ktx2Loader - The KTX2 loader to set.
	 * @return {GLTFLoader} A reference to this loader.
	 */ setKTX2Loader(ktx2Loader) {
        this.ktx2Loader = ktx2Loader;
        return this;
    }
    /**
	 * Sets the given meshopt decoder. Required for decoding assets
	 * compressed with the `EXT_meshopt_compression` extension.
	 *
	 * @param {Object} meshoptDecoder - The meshopt decoder to set.
	 * @return {GLTFLoader} A reference to this loader.
	 */ setMeshoptDecoder(meshoptDecoder) {
        this.meshoptDecoder = meshoptDecoder;
        return this;
    }
    /**
	 * Registers a plugin callback. This API is internally used to implement the various
	 * glTF extensions but can also used by third-party code to add additional logic
	 * to the loader.
	 *
	 * @param {function(parser:GLTFParser)} callback - The callback function to register.
	 * @return {GLTFLoader} A reference to this loader.
	 */ register(callback) {
        if (this.pluginCallbacks.indexOf(callback) === -1) this.pluginCallbacks.push(callback);
        return this;
    }
    /**
	 * Unregisters a plugin callback.
	 *
	 * @param {Function} callback - The callback function to unregister.
	 * @return {GLTFLoader} A reference to this loader.
	 */ unregister(callback) {
        if (this.pluginCallbacks.indexOf(callback) !== -1) this.pluginCallbacks.splice(this.pluginCallbacks.indexOf(callback), 1);
        return this;
    }
    /**
	 * Parses the given FBX data and returns the resulting group.
	 *
	 * @param {string|ArrayBuffer} data - The raw glTF data.
	 * @param {string} path - The URL base path.
	 * @param {function(GLTFLoader~LoadObject)} onLoad - Executed when the loading process has been finished.
	 * @param {onErrorCallback} onError - Executed when errors occur.
	 */ parse(data, path, onLoad, onError) {
        let json;
        const extensions = {};
        const plugins = {};
        const textDecoder = new TextDecoder();
        if (typeof data === 'string') json = JSON.parse(data);
        else if (data instanceof ArrayBuffer) {
            const magic = textDecoder.decode(new Uint8Array(data, 0, 4));
            if (magic === $559434fcc6e6401d$var$BINARY_EXTENSION_HEADER_MAGIC) {
                try {
                    extensions[$559434fcc6e6401d$var$EXTENSIONS.KHR_BINARY_GLTF] = new $559434fcc6e6401d$var$GLTFBinaryExtension(data);
                } catch (error) {
                    if (onError) onError(error);
                    return;
                }
                json = JSON.parse(extensions[$559434fcc6e6401d$var$EXTENSIONS.KHR_BINARY_GLTF].content);
            } else json = JSON.parse(textDecoder.decode(data));
        } else json = data;
        if (json.asset === undefined || json.asset.version[0] < 2) {
            if (onError) onError(new Error('THREE.GLTFLoader: Unsupported asset. glTF versions >=2.0 are supported.'));
            return;
        }
        const parser = new $559434fcc6e6401d$var$GLTFParser(json, {
            path: path || this.resourcePath || '',
            crossOrigin: this.crossOrigin,
            requestHeader: this.requestHeader,
            manager: this.manager,
            ktx2Loader: this.ktx2Loader,
            meshoptDecoder: this.meshoptDecoder
        });
        parser.fileLoader.setRequestHeader(this.requestHeader);
        for(let i = 0; i < this.pluginCallbacks.length; i++){
            const plugin = this.pluginCallbacks[i](parser);
            if (!plugin.name) console.error('THREE.GLTFLoader: Invalid plugin found: missing name');
            plugins[plugin.name] = plugin;
            // Workaround to avoid determining as unknown extension
            // in addUnknownExtensionsToUserData().
            // Remove this workaround if we move all the existing
            // extension handlers to plugin system
            extensions[plugin.name] = true;
        }
        if (json.extensionsUsed) for(let i = 0; i < json.extensionsUsed.length; ++i){
            const extensionName = json.extensionsUsed[i];
            const extensionsRequired = json.extensionsRequired || [];
            switch(extensionName){
                case $559434fcc6e6401d$var$EXTENSIONS.KHR_MATERIALS_UNLIT:
                    extensions[extensionName] = new $559434fcc6e6401d$var$GLTFMaterialsUnlitExtension();
                    break;
                case $559434fcc6e6401d$var$EXTENSIONS.KHR_DRACO_MESH_COMPRESSION:
                    extensions[extensionName] = new $559434fcc6e6401d$var$GLTFDracoMeshCompressionExtension(json, this.dracoLoader);
                    break;
                case $559434fcc6e6401d$var$EXTENSIONS.KHR_TEXTURE_TRANSFORM:
                    extensions[extensionName] = new $559434fcc6e6401d$var$GLTFTextureTransformExtension();
                    break;
                case $559434fcc6e6401d$var$EXTENSIONS.KHR_MESH_QUANTIZATION:
                    extensions[extensionName] = new $559434fcc6e6401d$var$GLTFMeshQuantizationExtension();
                    break;
                default:
                    if (extensionsRequired.indexOf(extensionName) >= 0 && plugins[extensionName] === undefined) console.warn('THREE.GLTFLoader: Unknown extension "' + extensionName + '".');
            }
        }
        parser.setExtensions(extensions);
        parser.setPlugins(plugins);
        parser.parse(onLoad, onError);
    }
    /**
	 * Async version of {@link GLTFLoader#parse}.
	 *
	 * @async
	 * @param {string|ArrayBuffer} data - The raw glTF data.
	 * @param {string} path - The URL base path.
	 * @return {Promise<GLTFLoader~LoadObject>} A Promise that resolves with the loaded glTF when the parsing has been finished.
	 */ parseAsync(data, path) {
        const scope = this;
        return new Promise(function(resolve, reject) {
            scope.parse(data, path, resolve, reject);
        });
    }
}
/* GLTFREGISTRY */ function $559434fcc6e6401d$var$GLTFRegistry() {
    let objects = {};
    return {
        get: function(key) {
            return objects[key];
        },
        add: function(key, object) {
            objects[key] = object;
        },
        remove: function(key) {
            delete objects[key];
        },
        removeAll: function() {
            objects = {};
        }
    };
}
/*********************************/ /********** EXTENSIONS ***********/ /*********************************/ const $559434fcc6e6401d$var$EXTENSIONS = {
    KHR_BINARY_GLTF: 'KHR_binary_glTF',
    KHR_DRACO_MESH_COMPRESSION: 'KHR_draco_mesh_compression',
    KHR_LIGHTS_PUNCTUAL: 'KHR_lights_punctual',
    KHR_MATERIALS_CLEARCOAT: 'KHR_materials_clearcoat',
    KHR_MATERIALS_DISPERSION: 'KHR_materials_dispersion',
    KHR_MATERIALS_IOR: 'KHR_materials_ior',
    KHR_MATERIALS_SHEEN: 'KHR_materials_sheen',
    KHR_MATERIALS_SPECULAR: 'KHR_materials_specular',
    KHR_MATERIALS_TRANSMISSION: 'KHR_materials_transmission',
    KHR_MATERIALS_IRIDESCENCE: 'KHR_materials_iridescence',
    KHR_MATERIALS_ANISOTROPY: 'KHR_materials_anisotropy',
    KHR_MATERIALS_UNLIT: 'KHR_materials_unlit',
    KHR_MATERIALS_VOLUME: 'KHR_materials_volume',
    KHR_TEXTURE_BASISU: 'KHR_texture_basisu',
    KHR_TEXTURE_TRANSFORM: 'KHR_texture_transform',
    KHR_MESH_QUANTIZATION: 'KHR_mesh_quantization',
    KHR_MATERIALS_EMISSIVE_STRENGTH: 'KHR_materials_emissive_strength',
    EXT_MATERIALS_BUMP: 'EXT_materials_bump',
    EXT_TEXTURE_WEBP: 'EXT_texture_webp',
    EXT_TEXTURE_AVIF: 'EXT_texture_avif',
    EXT_MESHOPT_COMPRESSION: 'EXT_meshopt_compression',
    EXT_MESH_GPU_INSTANCING: 'EXT_mesh_gpu_instancing'
};
/**
 * Punctual Lights Extension
 *
 * Specification: https://github.com/KhronosGroup/glTF/tree/master/extensions/2.0/Khronos/KHR_lights_punctual
 *
 * @private
 */ class $559434fcc6e6401d$var$GLTFLightsExtension {
    constructor(parser){
        this.parser = parser;
        this.name = $559434fcc6e6401d$var$EXTENSIONS.KHR_LIGHTS_PUNCTUAL;
        // Object3D instance caches
        this.cache = {
            refs: {},
            uses: {}
        };
    }
    _markDefs() {
        const parser = this.parser;
        const nodeDefs = this.parser.json.nodes || [];
        for(let nodeIndex = 0, nodeLength = nodeDefs.length; nodeIndex < nodeLength; nodeIndex++){
            const nodeDef = nodeDefs[nodeIndex];
            if (nodeDef.extensions && nodeDef.extensions[this.name] && nodeDef.extensions[this.name].light !== undefined) parser._addNodeRef(this.cache, nodeDef.extensions[this.name].light);
        }
    }
    _loadLight(lightIndex) {
        const parser = this.parser;
        const cacheKey = 'light:' + lightIndex;
        let dependency = parser.cache.get(cacheKey);
        if (dependency) return dependency;
        const json = parser.json;
        const extensions = json.extensions && json.extensions[this.name] || {};
        const lightDefs = extensions.lights || [];
        const lightDef = lightDefs[lightIndex];
        let lightNode;
        const color = new (0, $dyjou.Color)(0xffffff);
        if (lightDef.color !== undefined) color.setRGB(lightDef.color[0], lightDef.color[1], lightDef.color[2], (0, $dyjou.LinearSRGBColorSpace));
        const range = lightDef.range !== undefined ? lightDef.range : 0;
        switch(lightDef.type){
            case 'directional':
                lightNode = new (0, $dyjou.DirectionalLight)(color);
                lightNode.target.position.set(0, 0, -1);
                lightNode.add(lightNode.target);
                break;
            case 'point':
                lightNode = new (0, $dyjou.PointLight)(color);
                lightNode.distance = range;
                break;
            case 'spot':
                lightNode = new (0, $dyjou.SpotLight)(color);
                lightNode.distance = range;
                // Handle spotlight properties.
                lightDef.spot = lightDef.spot || {};
                lightDef.spot.innerConeAngle = lightDef.spot.innerConeAngle !== undefined ? lightDef.spot.innerConeAngle : 0;
                lightDef.spot.outerConeAngle = lightDef.spot.outerConeAngle !== undefined ? lightDef.spot.outerConeAngle : Math.PI / 4.0;
                lightNode.angle = lightDef.spot.outerConeAngle;
                lightNode.penumbra = 1.0 - lightDef.spot.innerConeAngle / lightDef.spot.outerConeAngle;
                lightNode.target.position.set(0, 0, -1);
                lightNode.add(lightNode.target);
                break;
            default:
                throw new Error('THREE.GLTFLoader: Unexpected light type: ' + lightDef.type);
        }
        // Some lights (e.g. spot) default to a position other than the origin. Reset the position
        // here, because node-level parsing will only override position if explicitly specified.
        lightNode.position.set(0, 0, 0);
        $559434fcc6e6401d$var$assignExtrasToUserData(lightNode, lightDef);
        if (lightDef.intensity !== undefined) lightNode.intensity = lightDef.intensity;
        lightNode.name = parser.createUniqueName(lightDef.name || 'light_' + lightIndex);
        dependency = Promise.resolve(lightNode);
        parser.cache.add(cacheKey, dependency);
        return dependency;
    }
    getDependency(type, index) {
        if (type !== 'light') return;
        return this._loadLight(index);
    }
    createNodeAttachment(nodeIndex) {
        const self1 = this;
        const parser = this.parser;
        const json = parser.json;
        const nodeDef = json.nodes[nodeIndex];
        const lightDef = nodeDef.extensions && nodeDef.extensions[this.name] || {};
        const lightIndex = lightDef.light;
        if (lightIndex === undefined) return null;
        return this._loadLight(lightIndex).then(function(light) {
            return parser._getNodeRef(self1.cache, lightIndex, light);
        });
    }
}
/**
 * Unlit Materials Extension
 *
 * Specification: https://github.com/KhronosGroup/glTF/tree/master/extensions/2.0/Khronos/KHR_materials_unlit
 *
 * @private
 */ class $559434fcc6e6401d$var$GLTFMaterialsUnlitExtension {
    constructor(){
        this.name = $559434fcc6e6401d$var$EXTENSIONS.KHR_MATERIALS_UNLIT;
    }
    getMaterialType() {
        return 0, $dyjou.MeshBasicMaterial;
    }
    extendParams(materialParams, materialDef, parser) {
        const pending = [];
        materialParams.color = new (0, $dyjou.Color)(1.0, 1.0, 1.0);
        materialParams.opacity = 1.0;
        const metallicRoughness = materialDef.pbrMetallicRoughness;
        if (metallicRoughness) {
            if (Array.isArray(metallicRoughness.baseColorFactor)) {
                const array = metallicRoughness.baseColorFactor;
                materialParams.color.setRGB(array[0], array[1], array[2], (0, $dyjou.LinearSRGBColorSpace));
                materialParams.opacity = array[3];
            }
            if (metallicRoughness.baseColorTexture !== undefined) pending.push(parser.assignTexture(materialParams, 'map', metallicRoughness.baseColorTexture, (0, $dyjou.SRGBColorSpace)));
        }
        return Promise.all(pending);
    }
}
/**
 * Materials Emissive Strength Extension
 *
 * Specification: https://github.com/KhronosGroup/glTF/blob/5768b3ce0ef32bc39cdf1bef10b948586635ead3/extensions/2.0/Khronos/KHR_materials_emissive_strength/README.md
 *
 * @private
 */ class $559434fcc6e6401d$var$GLTFMaterialsEmissiveStrengthExtension {
    constructor(parser){
        this.parser = parser;
        this.name = $559434fcc6e6401d$var$EXTENSIONS.KHR_MATERIALS_EMISSIVE_STRENGTH;
    }
    extendMaterialParams(materialIndex, materialParams) {
        const parser = this.parser;
        const materialDef = parser.json.materials[materialIndex];
        if (!materialDef.extensions || !materialDef.extensions[this.name]) return Promise.resolve();
        const emissiveStrength = materialDef.extensions[this.name].emissiveStrength;
        if (emissiveStrength !== undefined) materialParams.emissiveIntensity = emissiveStrength;
        return Promise.resolve();
    }
}
/**
 * Clearcoat Materials Extension
 *
 * Specification: https://github.com/KhronosGroup/glTF/tree/master/extensions/2.0/Khronos/KHR_materials_clearcoat
 *
 * @private
 */ class $559434fcc6e6401d$var$GLTFMaterialsClearcoatExtension {
    constructor(parser){
        this.parser = parser;
        this.name = $559434fcc6e6401d$var$EXTENSIONS.KHR_MATERIALS_CLEARCOAT;
    }
    getMaterialType(materialIndex) {
        const parser = this.parser;
        const materialDef = parser.json.materials[materialIndex];
        if (!materialDef.extensions || !materialDef.extensions[this.name]) return null;
        return 0, $dyjou.MeshPhysicalMaterial;
    }
    extendMaterialParams(materialIndex, materialParams) {
        const parser = this.parser;
        const materialDef = parser.json.materials[materialIndex];
        if (!materialDef.extensions || !materialDef.extensions[this.name]) return Promise.resolve();
        const pending = [];
        const extension = materialDef.extensions[this.name];
        if (extension.clearcoatFactor !== undefined) materialParams.clearcoat = extension.clearcoatFactor;
        if (extension.clearcoatTexture !== undefined) pending.push(parser.assignTexture(materialParams, 'clearcoatMap', extension.clearcoatTexture));
        if (extension.clearcoatRoughnessFactor !== undefined) materialParams.clearcoatRoughness = extension.clearcoatRoughnessFactor;
        if (extension.clearcoatRoughnessTexture !== undefined) pending.push(parser.assignTexture(materialParams, 'clearcoatRoughnessMap', extension.clearcoatRoughnessTexture));
        if (extension.clearcoatNormalTexture !== undefined) {
            pending.push(parser.assignTexture(materialParams, 'clearcoatNormalMap', extension.clearcoatNormalTexture));
            if (extension.clearcoatNormalTexture.scale !== undefined) {
                const scale = extension.clearcoatNormalTexture.scale;
                materialParams.clearcoatNormalScale = new (0, $dyjou.Vector2)(scale, scale);
            }
        }
        return Promise.all(pending);
    }
}
/**
 * Materials dispersion Extension
 *
 * Specification: https://github.com/KhronosGroup/glTF/tree/main/extensions/2.0/Khronos/KHR_materials_dispersion
 *
 * @private
 */ class $559434fcc6e6401d$var$GLTFMaterialsDispersionExtension {
    constructor(parser){
        this.parser = parser;
        this.name = $559434fcc6e6401d$var$EXTENSIONS.KHR_MATERIALS_DISPERSION;
    }
    getMaterialType(materialIndex) {
        const parser = this.parser;
        const materialDef = parser.json.materials[materialIndex];
        if (!materialDef.extensions || !materialDef.extensions[this.name]) return null;
        return 0, $dyjou.MeshPhysicalMaterial;
    }
    extendMaterialParams(materialIndex, materialParams) {
        const parser = this.parser;
        const materialDef = parser.json.materials[materialIndex];
        if (!materialDef.extensions || !materialDef.extensions[this.name]) return Promise.resolve();
        const extension = materialDef.extensions[this.name];
        materialParams.dispersion = extension.dispersion !== undefined ? extension.dispersion : 0;
        return Promise.resolve();
    }
}
/**
 * Iridescence Materials Extension
 *
 * Specification: https://github.com/KhronosGroup/glTF/tree/master/extensions/2.0/Khronos/KHR_materials_iridescence
 *
 * @private
 */ class $559434fcc6e6401d$var$GLTFMaterialsIridescenceExtension {
    constructor(parser){
        this.parser = parser;
        this.name = $559434fcc6e6401d$var$EXTENSIONS.KHR_MATERIALS_IRIDESCENCE;
    }
    getMaterialType(materialIndex) {
        const parser = this.parser;
        const materialDef = parser.json.materials[materialIndex];
        if (!materialDef.extensions || !materialDef.extensions[this.name]) return null;
        return 0, $dyjou.MeshPhysicalMaterial;
    }
    extendMaterialParams(materialIndex, materialParams) {
        const parser = this.parser;
        const materialDef = parser.json.materials[materialIndex];
        if (!materialDef.extensions || !materialDef.extensions[this.name]) return Promise.resolve();
        const pending = [];
        const extension = materialDef.extensions[this.name];
        if (extension.iridescenceFactor !== undefined) materialParams.iridescence = extension.iridescenceFactor;
        if (extension.iridescenceTexture !== undefined) pending.push(parser.assignTexture(materialParams, 'iridescenceMap', extension.iridescenceTexture));
        if (extension.iridescenceIor !== undefined) materialParams.iridescenceIOR = extension.iridescenceIor;
        if (materialParams.iridescenceThicknessRange === undefined) materialParams.iridescenceThicknessRange = [
            100,
            400
        ];
        if (extension.iridescenceThicknessMinimum !== undefined) materialParams.iridescenceThicknessRange[0] = extension.iridescenceThicknessMinimum;
        if (extension.iridescenceThicknessMaximum !== undefined) materialParams.iridescenceThicknessRange[1] = extension.iridescenceThicknessMaximum;
        if (extension.iridescenceThicknessTexture !== undefined) pending.push(parser.assignTexture(materialParams, 'iridescenceThicknessMap', extension.iridescenceThicknessTexture));
        return Promise.all(pending);
    }
}
/**
 * Sheen Materials Extension
 *
 * Specification: https://github.com/KhronosGroup/glTF/tree/main/extensions/2.0/Khronos/KHR_materials_sheen
 *
 * @private
 */ class $559434fcc6e6401d$var$GLTFMaterialsSheenExtension {
    constructor(parser){
        this.parser = parser;
        this.name = $559434fcc6e6401d$var$EXTENSIONS.KHR_MATERIALS_SHEEN;
    }
    getMaterialType(materialIndex) {
        const parser = this.parser;
        const materialDef = parser.json.materials[materialIndex];
        if (!materialDef.extensions || !materialDef.extensions[this.name]) return null;
        return 0, $dyjou.MeshPhysicalMaterial;
    }
    extendMaterialParams(materialIndex, materialParams) {
        const parser = this.parser;
        const materialDef = parser.json.materials[materialIndex];
        if (!materialDef.extensions || !materialDef.extensions[this.name]) return Promise.resolve();
        const pending = [];
        materialParams.sheenColor = new (0, $dyjou.Color)(0, 0, 0);
        materialParams.sheenRoughness = 0;
        materialParams.sheen = 1;
        const extension = materialDef.extensions[this.name];
        if (extension.sheenColorFactor !== undefined) {
            const colorFactor = extension.sheenColorFactor;
            materialParams.sheenColor.setRGB(colorFactor[0], colorFactor[1], colorFactor[2], (0, $dyjou.LinearSRGBColorSpace));
        }
        if (extension.sheenRoughnessFactor !== undefined) materialParams.sheenRoughness = extension.sheenRoughnessFactor;
        if (extension.sheenColorTexture !== undefined) pending.push(parser.assignTexture(materialParams, 'sheenColorMap', extension.sheenColorTexture, (0, $dyjou.SRGBColorSpace)));
        if (extension.sheenRoughnessTexture !== undefined) pending.push(parser.assignTexture(materialParams, 'sheenRoughnessMap', extension.sheenRoughnessTexture));
        return Promise.all(pending);
    }
}
/**
 * Transmission Materials Extension
 *
 * Specification: https://github.com/KhronosGroup/glTF/tree/master/extensions/2.0/Khronos/KHR_materials_transmission
 * Draft: https://github.com/KhronosGroup/glTF/pull/1698
 *
 * @private
 */ class $559434fcc6e6401d$var$GLTFMaterialsTransmissionExtension {
    constructor(parser){
        this.parser = parser;
        this.name = $559434fcc6e6401d$var$EXTENSIONS.KHR_MATERIALS_TRANSMISSION;
    }
    getMaterialType(materialIndex) {
        const parser = this.parser;
        const materialDef = parser.json.materials[materialIndex];
        if (!materialDef.extensions || !materialDef.extensions[this.name]) return null;
        return 0, $dyjou.MeshPhysicalMaterial;
    }
    extendMaterialParams(materialIndex, materialParams) {
        const parser = this.parser;
        const materialDef = parser.json.materials[materialIndex];
        if (!materialDef.extensions || !materialDef.extensions[this.name]) return Promise.resolve();
        const pending = [];
        const extension = materialDef.extensions[this.name];
        if (extension.transmissionFactor !== undefined) materialParams.transmission = extension.transmissionFactor;
        if (extension.transmissionTexture !== undefined) pending.push(parser.assignTexture(materialParams, 'transmissionMap', extension.transmissionTexture));
        return Promise.all(pending);
    }
}
/**
 * Materials Volume Extension
 *
 * Specification: https://github.com/KhronosGroup/glTF/tree/master/extensions/2.0/Khronos/KHR_materials_volume
 *
 * @private
 */ class $559434fcc6e6401d$var$GLTFMaterialsVolumeExtension {
    constructor(parser){
        this.parser = parser;
        this.name = $559434fcc6e6401d$var$EXTENSIONS.KHR_MATERIALS_VOLUME;
    }
    getMaterialType(materialIndex) {
        const parser = this.parser;
        const materialDef = parser.json.materials[materialIndex];
        if (!materialDef.extensions || !materialDef.extensions[this.name]) return null;
        return 0, $dyjou.MeshPhysicalMaterial;
    }
    extendMaterialParams(materialIndex, materialParams) {
        const parser = this.parser;
        const materialDef = parser.json.materials[materialIndex];
        if (!materialDef.extensions || !materialDef.extensions[this.name]) return Promise.resolve();
        const pending = [];
        const extension = materialDef.extensions[this.name];
        materialParams.thickness = extension.thicknessFactor !== undefined ? extension.thicknessFactor : 0;
        if (extension.thicknessTexture !== undefined) pending.push(parser.assignTexture(materialParams, 'thicknessMap', extension.thicknessTexture));
        materialParams.attenuationDistance = extension.attenuationDistance || Infinity;
        const colorArray = extension.attenuationColor || [
            1,
            1,
            1
        ];
        materialParams.attenuationColor = new (0, $dyjou.Color)().setRGB(colorArray[0], colorArray[1], colorArray[2], (0, $dyjou.LinearSRGBColorSpace));
        return Promise.all(pending);
    }
}
/**
 * Materials ior Extension
 *
 * Specification: https://github.com/KhronosGroup/glTF/tree/master/extensions/2.0/Khronos/KHR_materials_ior
 *
 * @private
 */ class $559434fcc6e6401d$var$GLTFMaterialsIorExtension {
    constructor(parser){
        this.parser = parser;
        this.name = $559434fcc6e6401d$var$EXTENSIONS.KHR_MATERIALS_IOR;
    }
    getMaterialType(materialIndex) {
        const parser = this.parser;
        const materialDef = parser.json.materials[materialIndex];
        if (!materialDef.extensions || !materialDef.extensions[this.name]) return null;
        return 0, $dyjou.MeshPhysicalMaterial;
    }
    extendMaterialParams(materialIndex, materialParams) {
        const parser = this.parser;
        const materialDef = parser.json.materials[materialIndex];
        if (!materialDef.extensions || !materialDef.extensions[this.name]) return Promise.resolve();
        const extension = materialDef.extensions[this.name];
        materialParams.ior = extension.ior !== undefined ? extension.ior : 1.5;
        return Promise.resolve();
    }
}
/**
 * Materials specular Extension
 *
 * Specification: https://github.com/KhronosGroup/glTF/tree/master/extensions/2.0/Khronos/KHR_materials_specular
 *
 * @private
 */ class $559434fcc6e6401d$var$GLTFMaterialsSpecularExtension {
    constructor(parser){
        this.parser = parser;
        this.name = $559434fcc6e6401d$var$EXTENSIONS.KHR_MATERIALS_SPECULAR;
    }
    getMaterialType(materialIndex) {
        const parser = this.parser;
        const materialDef = parser.json.materials[materialIndex];
        if (!materialDef.extensions || !materialDef.extensions[this.name]) return null;
        return 0, $dyjou.MeshPhysicalMaterial;
    }
    extendMaterialParams(materialIndex, materialParams) {
        const parser = this.parser;
        const materialDef = parser.json.materials[materialIndex];
        if (!materialDef.extensions || !materialDef.extensions[this.name]) return Promise.resolve();
        const pending = [];
        const extension = materialDef.extensions[this.name];
        materialParams.specularIntensity = extension.specularFactor !== undefined ? extension.specularFactor : 1.0;
        if (extension.specularTexture !== undefined) pending.push(parser.assignTexture(materialParams, 'specularIntensityMap', extension.specularTexture));
        const colorArray = extension.specularColorFactor || [
            1,
            1,
            1
        ];
        materialParams.specularColor = new (0, $dyjou.Color)().setRGB(colorArray[0], colorArray[1], colorArray[2], (0, $dyjou.LinearSRGBColorSpace));
        if (extension.specularColorTexture !== undefined) pending.push(parser.assignTexture(materialParams, 'specularColorMap', extension.specularColorTexture, (0, $dyjou.SRGBColorSpace)));
        return Promise.all(pending);
    }
}
/**
 * Materials bump Extension
 *
 * Specification: https://github.com/KhronosGroup/glTF/tree/master/extensions/2.0/Khronos/EXT_materials_bump
 *
 * @private
 */ class $559434fcc6e6401d$var$GLTFMaterialsBumpExtension {
    constructor(parser){
        this.parser = parser;
        this.name = $559434fcc6e6401d$var$EXTENSIONS.EXT_MATERIALS_BUMP;
    }
    getMaterialType(materialIndex) {
        const parser = this.parser;
        const materialDef = parser.json.materials[materialIndex];
        if (!materialDef.extensions || !materialDef.extensions[this.name]) return null;
        return 0, $dyjou.MeshPhysicalMaterial;
    }
    extendMaterialParams(materialIndex, materialParams) {
        const parser = this.parser;
        const materialDef = parser.json.materials[materialIndex];
        if (!materialDef.extensions || !materialDef.extensions[this.name]) return Promise.resolve();
        const pending = [];
        const extension = materialDef.extensions[this.name];
        materialParams.bumpScale = extension.bumpFactor !== undefined ? extension.bumpFactor : 1.0;
        if (extension.bumpTexture !== undefined) pending.push(parser.assignTexture(materialParams, 'bumpMap', extension.bumpTexture));
        return Promise.all(pending);
    }
}
/**
 * Materials anisotropy Extension
 *
 * Specification: https://github.com/KhronosGroup/glTF/tree/master/extensions/2.0/Khronos/KHR_materials_anisotropy
 *
 * @private
 */ class $559434fcc6e6401d$var$GLTFMaterialsAnisotropyExtension {
    constructor(parser){
        this.parser = parser;
        this.name = $559434fcc6e6401d$var$EXTENSIONS.KHR_MATERIALS_ANISOTROPY;
    }
    getMaterialType(materialIndex) {
        const parser = this.parser;
        const materialDef = parser.json.materials[materialIndex];
        if (!materialDef.extensions || !materialDef.extensions[this.name]) return null;
        return 0, $dyjou.MeshPhysicalMaterial;
    }
    extendMaterialParams(materialIndex, materialParams) {
        const parser = this.parser;
        const materialDef = parser.json.materials[materialIndex];
        if (!materialDef.extensions || !materialDef.extensions[this.name]) return Promise.resolve();
        const pending = [];
        const extension = materialDef.extensions[this.name];
        if (extension.anisotropyStrength !== undefined) materialParams.anisotropy = extension.anisotropyStrength;
        if (extension.anisotropyRotation !== undefined) materialParams.anisotropyRotation = extension.anisotropyRotation;
        if (extension.anisotropyTexture !== undefined) pending.push(parser.assignTexture(materialParams, 'anisotropyMap', extension.anisotropyTexture));
        return Promise.all(pending);
    }
}
/**
 * BasisU Texture Extension
 *
 * Specification: https://github.com/KhronosGroup/glTF/tree/master/extensions/2.0/Khronos/KHR_texture_basisu
 *
 * @private
 */ class $559434fcc6e6401d$var$GLTFTextureBasisUExtension {
    constructor(parser){
        this.parser = parser;
        this.name = $559434fcc6e6401d$var$EXTENSIONS.KHR_TEXTURE_BASISU;
    }
    loadTexture(textureIndex) {
        const parser = this.parser;
        const json = parser.json;
        const textureDef = json.textures[textureIndex];
        if (!textureDef.extensions || !textureDef.extensions[this.name]) return null;
        const extension = textureDef.extensions[this.name];
        const loader = parser.options.ktx2Loader;
        if (!loader) {
            if (json.extensionsRequired && json.extensionsRequired.indexOf(this.name) >= 0) throw new Error('THREE.GLTFLoader: setKTX2Loader must be called before loading KTX2 textures');
            else // Assumes that the extension is optional and that a fallback texture is present
            return null;
        }
        return parser.loadTextureImage(textureIndex, extension.source, loader);
    }
}
/**
 * WebP Texture Extension
 *
 * Specification: https://github.com/KhronosGroup/glTF/tree/master/extensions/2.0/Vendor/EXT_texture_webp
 *
 * @private
 */ class $559434fcc6e6401d$var$GLTFTextureWebPExtension {
    constructor(parser){
        this.parser = parser;
        this.name = $559434fcc6e6401d$var$EXTENSIONS.EXT_TEXTURE_WEBP;
        this.isSupported = null;
    }
    loadTexture(textureIndex) {
        const name = this.name;
        const parser = this.parser;
        const json = parser.json;
        const textureDef = json.textures[textureIndex];
        if (!textureDef.extensions || !textureDef.extensions[name]) return null;
        const extension = textureDef.extensions[name];
        const source = json.images[extension.source];
        let loader = parser.textureLoader;
        if (source.uri) {
            const handler = parser.options.manager.getHandler(source.uri);
            if (handler !== null) loader = handler;
        }
        return this.detectSupport().then(function(isSupported) {
            if (isSupported) return parser.loadTextureImage(textureIndex, extension.source, loader);
            if (json.extensionsRequired && json.extensionsRequired.indexOf(name) >= 0) throw new Error('THREE.GLTFLoader: WebP required by asset but unsupported.');
            // Fall back to PNG or JPEG.
            return parser.loadTexture(textureIndex);
        });
    }
    detectSupport() {
        if (!this.isSupported) this.isSupported = new Promise(function(resolve) {
            const image = new Image();
            // Lossy test image. Support for lossy images doesn't guarantee support for all
            // WebP images, unfortunately.
            image.src = 'data:image/webp;base64,UklGRiIAAABXRUJQVlA4IBYAAAAwAQCdASoBAAEADsD+JaQAA3AAAAAA';
            image.onload = image.onerror = function() {
                resolve(image.height === 1);
            };
        });
        return this.isSupported;
    }
}
/**
 * AVIF Texture Extension
 *
 * Specification: https://github.com/KhronosGroup/glTF/tree/master/extensions/2.0/Vendor/EXT_texture_avif
 *
 * @private
 */ class $559434fcc6e6401d$var$GLTFTextureAVIFExtension {
    constructor(parser){
        this.parser = parser;
        this.name = $559434fcc6e6401d$var$EXTENSIONS.EXT_TEXTURE_AVIF;
        this.isSupported = null;
    }
    loadTexture(textureIndex) {
        const name = this.name;
        const parser = this.parser;
        const json = parser.json;
        const textureDef = json.textures[textureIndex];
        if (!textureDef.extensions || !textureDef.extensions[name]) return null;
        const extension = textureDef.extensions[name];
        const source = json.images[extension.source];
        let loader = parser.textureLoader;
        if (source.uri) {
            const handler = parser.options.manager.getHandler(source.uri);
            if (handler !== null) loader = handler;
        }
        return this.detectSupport().then(function(isSupported) {
            if (isSupported) return parser.loadTextureImage(textureIndex, extension.source, loader);
            if (json.extensionsRequired && json.extensionsRequired.indexOf(name) >= 0) throw new Error('THREE.GLTFLoader: AVIF required by asset but unsupported.');
            // Fall back to PNG or JPEG.
            return parser.loadTexture(textureIndex);
        });
    }
    detectSupport() {
        if (!this.isSupported) this.isSupported = new Promise(function(resolve) {
            const image = new Image();
            // Lossy test image.
            image.src = 'data:image/avif;base64,AAAAIGZ0eXBhdmlmAAAAAGF2aWZtaWYxbWlhZk1BMUIAAADybWV0YQAAAAAAAAAoaGRscgAAAAAAAAAAcGljdAAAAAAAAAAAAAAAAGxpYmF2aWYAAAAADnBpdG0AAAAAAAEAAAAeaWxvYwAAAABEAAABAAEAAAABAAABGgAAABcAAAAoaWluZgAAAAAAAQAAABppbmZlAgAAAAABAABhdjAxQ29sb3IAAAAAamlwcnAAAABLaXBjbwAAABRpc3BlAAAAAAAAAAEAAAABAAAAEHBpeGkAAAAAAwgICAAAAAxhdjFDgQAMAAAAABNjb2xybmNseAACAAIABoAAAAAXaXBtYQAAAAAAAAABAAEEAQKDBAAAAB9tZGF0EgAKCBgABogQEDQgMgkQAAAAB8dSLfI=';
            image.onload = image.onerror = function() {
                resolve(image.height === 1);
            };
        });
        return this.isSupported;
    }
}
/**
 * meshopt BufferView Compression Extension
 *
 * Specification: https://github.com/KhronosGroup/glTF/tree/master/extensions/2.0/Vendor/EXT_meshopt_compression
 *
 * @private
 */ class $559434fcc6e6401d$var$GLTFMeshoptCompression {
    constructor(parser){
        this.name = $559434fcc6e6401d$var$EXTENSIONS.EXT_MESHOPT_COMPRESSION;
        this.parser = parser;
    }
    loadBufferView(index) {
        const json = this.parser.json;
        const bufferView = json.bufferViews[index];
        if (bufferView.extensions && bufferView.extensions[this.name]) {
            const extensionDef = bufferView.extensions[this.name];
            const buffer = this.parser.getDependency('buffer', extensionDef.buffer);
            const decoder = this.parser.options.meshoptDecoder;
            if (!decoder || !decoder.supported) {
                if (json.extensionsRequired && json.extensionsRequired.indexOf(this.name) >= 0) throw new Error('THREE.GLTFLoader: setMeshoptDecoder must be called before loading compressed files');
                else // Assumes that the extension is optional and that fallback buffer data is present
                return null;
            }
            return buffer.then(function(res) {
                const byteOffset = extensionDef.byteOffset || 0;
                const byteLength = extensionDef.byteLength || 0;
                const count = extensionDef.count;
                const stride = extensionDef.byteStride;
                const source = new Uint8Array(res, byteOffset, byteLength);
                if (decoder.decodeGltfBufferAsync) return decoder.decodeGltfBufferAsync(count, stride, source, extensionDef.mode, extensionDef.filter).then(function(res) {
                    return res.buffer;
                });
                else // Support for MeshoptDecoder 0.18 or earlier, without decodeGltfBufferAsync
                return decoder.ready.then(function() {
                    const result = new ArrayBuffer(count * stride);
                    decoder.decodeGltfBuffer(new Uint8Array(result), count, stride, source, extensionDef.mode, extensionDef.filter);
                    return result;
                });
            });
        } else return null;
    }
}
/**
 * GPU Instancing Extension
 *
 * Specification: https://github.com/KhronosGroup/glTF/tree/master/extensions/2.0/Vendor/EXT_mesh_gpu_instancing
 *
 * @private
 */ class $559434fcc6e6401d$var$GLTFMeshGpuInstancing {
    constructor(parser){
        this.name = $559434fcc6e6401d$var$EXTENSIONS.EXT_MESH_GPU_INSTANCING;
        this.parser = parser;
    }
    createNodeMesh(nodeIndex) {
        const json = this.parser.json;
        const nodeDef = json.nodes[nodeIndex];
        if (!nodeDef.extensions || !nodeDef.extensions[this.name] || nodeDef.mesh === undefined) return null;
        const meshDef = json.meshes[nodeDef.mesh];
        // No Points or Lines + Instancing support yet
        for (const primitive of meshDef.primitives){
            if (primitive.mode !== $559434fcc6e6401d$var$WEBGL_CONSTANTS.TRIANGLES && primitive.mode !== $559434fcc6e6401d$var$WEBGL_CONSTANTS.TRIANGLE_STRIP && primitive.mode !== $559434fcc6e6401d$var$WEBGL_CONSTANTS.TRIANGLE_FAN && primitive.mode !== undefined) return null;
        }
        const extensionDef = nodeDef.extensions[this.name];
        const attributesDef = extensionDef.attributes;
        // @TODO: Can we support InstancedMesh + SkinnedMesh?
        const pending = [];
        const attributes = {};
        for(const key in attributesDef)pending.push(this.parser.getDependency('accessor', attributesDef[key]).then((accessor)=>{
            attributes[key] = accessor;
            return attributes[key];
        }));
        if (pending.length < 1) return null;
        pending.push(this.parser.createNodeMesh(nodeIndex));
        return Promise.all(pending).then((results)=>{
            const nodeObject = results.pop();
            const meshes = nodeObject.isGroup ? nodeObject.children : [
                nodeObject
            ];
            const count = results[0].count; // All attribute counts should be same
            const instancedMeshes = [];
            for (const mesh of meshes){
                // Temporal variables
                const m = new (0, $dyjou.Matrix4)();
                const p = new (0, $dyjou.Vector3)();
                const q = new (0, $dyjou.Quaternion)();
                const s = new (0, $dyjou.Vector3)(1, 1, 1);
                const instancedMesh = new (0, $dyjou.InstancedMesh)(mesh.geometry, mesh.material, count);
                for(let i = 0; i < count; i++){
                    if (attributes.TRANSLATION) p.fromBufferAttribute(attributes.TRANSLATION, i);
                    if (attributes.ROTATION) q.fromBufferAttribute(attributes.ROTATION, i);
                    if (attributes.SCALE) s.fromBufferAttribute(attributes.SCALE, i);
                    instancedMesh.setMatrixAt(i, m.compose(p, q, s));
                }
                // Add instance attributes to the geometry, excluding TRS.
                for(const attributeName in attributes){
                    if (attributeName === '_COLOR_0') {
                        const attr = attributes[attributeName];
                        instancedMesh.instanceColor = new (0, $dyjou.InstancedBufferAttribute)(attr.array, attr.itemSize, attr.normalized);
                    } else if (attributeName !== 'TRANSLATION' && attributeName !== 'ROTATION' && attributeName !== 'SCALE') mesh.geometry.setAttribute(attributeName, attributes[attributeName]);
                }
                // Just in case
                (0, $dyjou.Object3D).prototype.copy.call(instancedMesh, mesh);
                this.parser.assignFinalMaterial(instancedMesh);
                instancedMeshes.push(instancedMesh);
            }
            if (nodeObject.isGroup) {
                nodeObject.clear();
                nodeObject.add(...instancedMeshes);
                return nodeObject;
            }
            return instancedMeshes[0];
        });
    }
}
/* BINARY EXTENSION */ const $559434fcc6e6401d$var$BINARY_EXTENSION_HEADER_MAGIC = 'glTF';
const $559434fcc6e6401d$var$BINARY_EXTENSION_HEADER_LENGTH = 12;
const $559434fcc6e6401d$var$BINARY_EXTENSION_CHUNK_TYPES = {
    JSON: 0x4E4F534A,
    BIN: 0x004E4942
};
class $559434fcc6e6401d$var$GLTFBinaryExtension {
    constructor(data){
        this.name = $559434fcc6e6401d$var$EXTENSIONS.KHR_BINARY_GLTF;
        this.content = null;
        this.body = null;
        const headerView = new DataView(data, 0, $559434fcc6e6401d$var$BINARY_EXTENSION_HEADER_LENGTH);
        const textDecoder = new TextDecoder();
        this.header = {
            magic: textDecoder.decode(new Uint8Array(data.slice(0, 4))),
            version: headerView.getUint32(4, true),
            length: headerView.getUint32(8, true)
        };
        if (this.header.magic !== $559434fcc6e6401d$var$BINARY_EXTENSION_HEADER_MAGIC) throw new Error('THREE.GLTFLoader: Unsupported glTF-Binary header.');
        else if (this.header.version < 2.0) throw new Error('THREE.GLTFLoader: Legacy binary file detected.');
        const chunkContentsLength = this.header.length - $559434fcc6e6401d$var$BINARY_EXTENSION_HEADER_LENGTH;
        const chunkView = new DataView(data, $559434fcc6e6401d$var$BINARY_EXTENSION_HEADER_LENGTH);
        let chunkIndex = 0;
        while(chunkIndex < chunkContentsLength){
            const chunkLength = chunkView.getUint32(chunkIndex, true);
            chunkIndex += 4;
            const chunkType = chunkView.getUint32(chunkIndex, true);
            chunkIndex += 4;
            if (chunkType === $559434fcc6e6401d$var$BINARY_EXTENSION_CHUNK_TYPES.JSON) {
                const contentArray = new Uint8Array(data, $559434fcc6e6401d$var$BINARY_EXTENSION_HEADER_LENGTH + chunkIndex, chunkLength);
                this.content = textDecoder.decode(contentArray);
            } else if (chunkType === $559434fcc6e6401d$var$BINARY_EXTENSION_CHUNK_TYPES.BIN) {
                const byteOffset = $559434fcc6e6401d$var$BINARY_EXTENSION_HEADER_LENGTH + chunkIndex;
                this.body = data.slice(byteOffset, byteOffset + chunkLength);
            }
            // Clients must ignore chunks with unknown types.
            chunkIndex += chunkLength;
        }
        if (this.content === null) throw new Error('THREE.GLTFLoader: JSON content not found.');
    }
}
/**
 * DRACO Mesh Compression Extension
 *
 * Specification: https://github.com/KhronosGroup/glTF/tree/master/extensions/2.0/Khronos/KHR_draco_mesh_compression
 *
 * @private
 */ class $559434fcc6e6401d$var$GLTFDracoMeshCompressionExtension {
    constructor(json, dracoLoader){
        if (!dracoLoader) throw new Error('THREE.GLTFLoader: No DRACOLoader instance provided.');
        this.name = $559434fcc6e6401d$var$EXTENSIONS.KHR_DRACO_MESH_COMPRESSION;
        this.json = json;
        this.dracoLoader = dracoLoader;
        this.dracoLoader.preload();
    }
    decodePrimitive(primitive, parser) {
        const json = this.json;
        const dracoLoader = this.dracoLoader;
        const bufferViewIndex = primitive.extensions[this.name].bufferView;
        const gltfAttributeMap = primitive.extensions[this.name].attributes;
        const threeAttributeMap = {};
        const attributeNormalizedMap = {};
        const attributeTypeMap = {};
        for(const attributeName in gltfAttributeMap){
            const threeAttributeName = $559434fcc6e6401d$var$ATTRIBUTES[attributeName] || attributeName.toLowerCase();
            threeAttributeMap[threeAttributeName] = gltfAttributeMap[attributeName];
        }
        for(const attributeName in primitive.attributes){
            const threeAttributeName = $559434fcc6e6401d$var$ATTRIBUTES[attributeName] || attributeName.toLowerCase();
            if (gltfAttributeMap[attributeName] !== undefined) {
                const accessorDef = json.accessors[primitive.attributes[attributeName]];
                const componentType = $559434fcc6e6401d$var$WEBGL_COMPONENT_TYPES[accessorDef.componentType];
                attributeTypeMap[threeAttributeName] = componentType.name;
                attributeNormalizedMap[threeAttributeName] = accessorDef.normalized === true;
            }
        }
        return parser.getDependency('bufferView', bufferViewIndex).then(function(bufferView) {
            return new Promise(function(resolve, reject) {
                dracoLoader.decodeDracoFile(bufferView, function(geometry) {
                    for(const attributeName in geometry.attributes){
                        const attribute = geometry.attributes[attributeName];
                        const normalized = attributeNormalizedMap[attributeName];
                        if (normalized !== undefined) attribute.normalized = normalized;
                    }
                    resolve(geometry);
                }, threeAttributeMap, attributeTypeMap, (0, $dyjou.LinearSRGBColorSpace), reject);
            });
        });
    }
}
/**
 * Texture Transform Extension
 *
 * Specification: https://github.com/KhronosGroup/glTF/tree/master/extensions/2.0/Khronos/KHR_texture_transform
 *
 * @private
 */ class $559434fcc6e6401d$var$GLTFTextureTransformExtension {
    constructor(){
        this.name = $559434fcc6e6401d$var$EXTENSIONS.KHR_TEXTURE_TRANSFORM;
    }
    extendTexture(texture, transform) {
        if ((transform.texCoord === undefined || transform.texCoord === texture.channel) && transform.offset === undefined && transform.rotation === undefined && transform.scale === undefined) // See https://github.com/mrdoob/three.js/issues/21819.
        return texture;
        texture = texture.clone();
        if (transform.texCoord !== undefined) texture.channel = transform.texCoord;
        if (transform.offset !== undefined) texture.offset.fromArray(transform.offset);
        if (transform.rotation !== undefined) texture.rotation = transform.rotation;
        if (transform.scale !== undefined) texture.repeat.fromArray(transform.scale);
        texture.needsUpdate = true;
        return texture;
    }
}
/**
 * Mesh Quantization Extension
 *
 * Specification: https://github.com/KhronosGroup/glTF/tree/master/extensions/2.0/Khronos/KHR_mesh_quantization
 *
 * @private
 */ class $559434fcc6e6401d$var$GLTFMeshQuantizationExtension {
    constructor(){
        this.name = $559434fcc6e6401d$var$EXTENSIONS.KHR_MESH_QUANTIZATION;
    }
}
/*********************************/ /********** INTERPOLATION ********/ /*********************************/ // Spline Interpolation
// Specification: https://github.com/KhronosGroup/glTF/blob/master/specification/2.0/README.md#appendix-c-spline-interpolation
class $559434fcc6e6401d$var$GLTFCubicSplineInterpolant extends (0, $dyjou.Interpolant) {
    constructor(parameterPositions, sampleValues, sampleSize, resultBuffer){
        super(parameterPositions, sampleValues, sampleSize, resultBuffer);
    }
    copySampleValue_(index) {
        // Copies a sample value to the result buffer. See description of glTF
        // CUBICSPLINE values layout in interpolate_() function below.
        const result = this.resultBuffer, values = this.sampleValues, valueSize = this.valueSize, offset = index * valueSize * 3 + valueSize;
        for(let i = 0; i !== valueSize; i++)result[i] = values[offset + i];
        return result;
    }
    interpolate_(i1, t0, t, t1) {
        const result = this.resultBuffer;
        const values = this.sampleValues;
        const stride = this.valueSize;
        const stride2 = stride * 2;
        const stride3 = stride * 3;
        const td = t1 - t0;
        const p = (t - t0) / td;
        const pp = p * p;
        const ppp = pp * p;
        const offset1 = i1 * stride3;
        const offset0 = offset1 - stride3;
        const s2 = -2 * ppp + 3 * pp;
        const s3 = ppp - pp;
        const s0 = 1 - s2;
        const s1 = s3 - pp + p;
        // Layout of keyframe output values for CUBICSPLINE animations:
        //   [ inTangent_1, splineVertex_1, outTangent_1, inTangent_2, splineVertex_2, ... ]
        for(let i = 0; i !== stride; i++){
            const p0 = values[offset0 + i + stride]; // splineVertex_k
            const m0 = values[offset0 + i + stride2] * td; // outTangent_k * (t_k+1 - t_k)
            const p1 = values[offset1 + i + stride]; // splineVertex_k+1
            const m1 = values[offset1 + i] * td; // inTangent_k+1 * (t_k+1 - t_k)
            result[i] = s0 * p0 + s1 * m0 + s2 * p1 + s3 * m1;
        }
        return result;
    }
}
const $559434fcc6e6401d$var$_q = new (0, $dyjou.Quaternion)();
class $559434fcc6e6401d$var$GLTFCubicSplineQuaternionInterpolant extends $559434fcc6e6401d$var$GLTFCubicSplineInterpolant {
    interpolate_(i1, t0, t, t1) {
        const result = super.interpolate_(i1, t0, t, t1);
        $559434fcc6e6401d$var$_q.fromArray(result).normalize().toArray(result);
        return result;
    }
}
/*********************************/ /********** INTERNALS ************/ /*********************************/ /* CONSTANTS */ const $559434fcc6e6401d$var$WEBGL_CONSTANTS = {
    FLOAT: 5126,
    //FLOAT_MAT2: 35674,
    FLOAT_MAT3: 35675,
    FLOAT_MAT4: 35676,
    FLOAT_VEC2: 35664,
    FLOAT_VEC3: 35665,
    FLOAT_VEC4: 35666,
    LINEAR: 9729,
    REPEAT: 10497,
    SAMPLER_2D: 35678,
    POINTS: 0,
    LINES: 1,
    LINE_LOOP: 2,
    LINE_STRIP: 3,
    TRIANGLES: 4,
    TRIANGLE_STRIP: 5,
    TRIANGLE_FAN: 6,
    UNSIGNED_BYTE: 5121,
    UNSIGNED_SHORT: 5123
};
const $559434fcc6e6401d$var$WEBGL_COMPONENT_TYPES = {
    5120: Int8Array,
    5121: Uint8Array,
    5122: Int16Array,
    5123: Uint16Array,
    5125: Uint32Array,
    5126: Float32Array
};
const $559434fcc6e6401d$var$WEBGL_FILTERS = {
    9728: (0, $dyjou.NearestFilter),
    9729: (0, $dyjou.LinearFilter),
    9984: (0, $dyjou.NearestMipmapNearestFilter),
    9985: (0, $dyjou.LinearMipmapNearestFilter),
    9986: (0, $dyjou.NearestMipmapLinearFilter),
    9987: (0, $dyjou.LinearMipmapLinearFilter)
};
const $559434fcc6e6401d$var$WEBGL_WRAPPINGS = {
    33071: (0, $dyjou.ClampToEdgeWrapping),
    33648: (0, $dyjou.MirroredRepeatWrapping),
    10497: (0, $dyjou.RepeatWrapping)
};
const $559434fcc6e6401d$var$WEBGL_TYPE_SIZES = {
    'SCALAR': 1,
    'VEC2': 2,
    'VEC3': 3,
    'VEC4': 4,
    'MAT2': 4,
    'MAT3': 9,
    'MAT4': 16
};
const $559434fcc6e6401d$var$ATTRIBUTES = {
    POSITION: 'position',
    NORMAL: 'normal',
    TANGENT: 'tangent',
    TEXCOORD_0: 'uv',
    TEXCOORD_1: 'uv1',
    TEXCOORD_2: 'uv2',
    TEXCOORD_3: 'uv3',
    COLOR_0: 'color',
    WEIGHTS_0: 'skinWeight',
    JOINTS_0: 'skinIndex'
};
const $559434fcc6e6401d$var$PATH_PROPERTIES = {
    scale: 'scale',
    translation: 'position',
    rotation: 'quaternion',
    weights: 'morphTargetInfluences'
};
const $559434fcc6e6401d$var$INTERPOLATION = {
    CUBICSPLINE: undefined,
    // keyframe track will be initialized with a default interpolation type, then modified.
    LINEAR: (0, $dyjou.InterpolateLinear),
    STEP: (0, $dyjou.InterpolateDiscrete)
};
const $559434fcc6e6401d$var$ALPHA_MODES = {
    OPAQUE: 'OPAQUE',
    MASK: 'MASK',
    BLEND: 'BLEND'
};
/**
 * Specification: https://github.com/KhronosGroup/glTF/blob/master/specification/2.0/README.md#default-material
 *
 * @private
 * @param {Object<string, Material>} cache
 * @return {Material}
 */ function $559434fcc6e6401d$var$createDefaultMaterial(cache) {
    if (cache['DefaultMaterial'] === undefined) cache['DefaultMaterial'] = new (0, $dyjou.MeshStandardMaterial)({
        color: 0xFFFFFF,
        emissive: 0x000000,
        metalness: 1,
        roughness: 1,
        transparent: false,
        depthTest: true,
        side: (0, $dyjou.FrontSide)
    });
    return cache['DefaultMaterial'];
}
function $559434fcc6e6401d$var$addUnknownExtensionsToUserData(knownExtensions, object, objectDef) {
    // Add unknown glTF extensions to an object's userData.
    for(const name in objectDef.extensions)if (knownExtensions[name] === undefined) {
        object.userData.gltfExtensions = object.userData.gltfExtensions || {};
        object.userData.gltfExtensions[name] = objectDef.extensions[name];
    }
}
/**
 *
 * @private
 * @param {Object3D|Material|BufferGeometry|Object} object
 * @param {GLTF.definition} gltfDef
 */ function $559434fcc6e6401d$var$assignExtrasToUserData(object, gltfDef) {
    if (gltfDef.extras !== undefined) {
        if (typeof gltfDef.extras === 'object') Object.assign(object.userData, gltfDef.extras);
        else console.warn('THREE.GLTFLoader: Ignoring primitive type .extras, ' + gltfDef.extras);
    }
}
/**
 * Specification: https://github.com/KhronosGroup/glTF/blob/master/specification/2.0/README.md#morph-targets
 *
 * @private
 * @param {BufferGeometry} geometry
 * @param {Array<GLTF.Target>} targets
 * @param {GLTFParser} parser
 * @return {Promise<BufferGeometry>}
 */ function $559434fcc6e6401d$var$addMorphTargets(geometry, targets, parser) {
    let hasMorphPosition = false;
    let hasMorphNormal = false;
    let hasMorphColor = false;
    for(let i = 0, il = targets.length; i < il; i++){
        const target = targets[i];
        if (target.POSITION !== undefined) hasMorphPosition = true;
        if (target.NORMAL !== undefined) hasMorphNormal = true;
        if (target.COLOR_0 !== undefined) hasMorphColor = true;
        if (hasMorphPosition && hasMorphNormal && hasMorphColor) break;
    }
    if (!hasMorphPosition && !hasMorphNormal && !hasMorphColor) return Promise.resolve(geometry);
    const pendingPositionAccessors = [];
    const pendingNormalAccessors = [];
    const pendingColorAccessors = [];
    for(let i = 0, il = targets.length; i < il; i++){
        const target = targets[i];
        if (hasMorphPosition) {
            const pendingAccessor = target.POSITION !== undefined ? parser.getDependency('accessor', target.POSITION) : geometry.attributes.position;
            pendingPositionAccessors.push(pendingAccessor);
        }
        if (hasMorphNormal) {
            const pendingAccessor = target.NORMAL !== undefined ? parser.getDependency('accessor', target.NORMAL) : geometry.attributes.normal;
            pendingNormalAccessors.push(pendingAccessor);
        }
        if (hasMorphColor) {
            const pendingAccessor = target.COLOR_0 !== undefined ? parser.getDependency('accessor', target.COLOR_0) : geometry.attributes.color;
            pendingColorAccessors.push(pendingAccessor);
        }
    }
    return Promise.all([
        Promise.all(pendingPositionAccessors),
        Promise.all(pendingNormalAccessors),
        Promise.all(pendingColorAccessors)
    ]).then(function(accessors) {
        const morphPositions = accessors[0];
        const morphNormals = accessors[1];
        const morphColors = accessors[2];
        if (hasMorphPosition) geometry.morphAttributes.position = morphPositions;
        if (hasMorphNormal) geometry.morphAttributes.normal = morphNormals;
        if (hasMorphColor) geometry.morphAttributes.color = morphColors;
        geometry.morphTargetsRelative = true;
        return geometry;
    });
}
/**
 *
 * @private
 * @param {Mesh} mesh
 * @param {GLTF.Mesh} meshDef
 */ function $559434fcc6e6401d$var$updateMorphTargets(mesh, meshDef) {
    mesh.updateMorphTargets();
    if (meshDef.weights !== undefined) for(let i = 0, il = meshDef.weights.length; i < il; i++)mesh.morphTargetInfluences[i] = meshDef.weights[i];
    // .extras has user-defined data, so check that .extras.targetNames is an array.
    if (meshDef.extras && Array.isArray(meshDef.extras.targetNames)) {
        const targetNames = meshDef.extras.targetNames;
        if (mesh.morphTargetInfluences.length === targetNames.length) {
            mesh.morphTargetDictionary = {};
            for(let i = 0, il = targetNames.length; i < il; i++)mesh.morphTargetDictionary[targetNames[i]] = i;
        } else console.warn('THREE.GLTFLoader: Invalid extras.targetNames length. Ignoring names.');
    }
}
function $559434fcc6e6401d$var$createPrimitiveKey(primitiveDef) {
    let geometryKey;
    const dracoExtension = primitiveDef.extensions && primitiveDef.extensions[$559434fcc6e6401d$var$EXTENSIONS.KHR_DRACO_MESH_COMPRESSION];
    if (dracoExtension) geometryKey = 'draco:' + dracoExtension.bufferView + ':' + dracoExtension.indices + ':' + $559434fcc6e6401d$var$createAttributesKey(dracoExtension.attributes);
    else geometryKey = primitiveDef.indices + ':' + $559434fcc6e6401d$var$createAttributesKey(primitiveDef.attributes) + ':' + primitiveDef.mode;
    if (primitiveDef.targets !== undefined) for(let i = 0, il = primitiveDef.targets.length; i < il; i++)geometryKey += ':' + $559434fcc6e6401d$var$createAttributesKey(primitiveDef.targets[i]);
    return geometryKey;
}
function $559434fcc6e6401d$var$createAttributesKey(attributes) {
    let attributesKey = '';
    const keys = Object.keys(attributes).sort();
    for(let i = 0, il = keys.length; i < il; i++)attributesKey += keys[i] + ':' + attributes[keys[i]] + ';';
    return attributesKey;
}
function $559434fcc6e6401d$var$getNormalizedComponentScale(constructor) {
    // Reference:
    // https://github.com/KhronosGroup/glTF/tree/master/extensions/2.0/Khronos/KHR_mesh_quantization#encoding-quantized-data
    switch(constructor){
        case Int8Array:
            return 1 / 127;
        case Uint8Array:
            return 1 / 255;
        case Int16Array:
            return 1 / 32767;
        case Uint16Array:
            return 1 / 65535;
        default:
            throw new Error('THREE.GLTFLoader: Unsupported normalized accessor component type.');
    }
}
function $559434fcc6e6401d$var$getImageURIMimeType(uri) {
    if (uri.search(/\.jpe?g($|\?)/i) > 0 || uri.search(/^data\:image\/jpeg/) === 0) return 'image/jpeg';
    if (uri.search(/\.webp($|\?)/i) > 0 || uri.search(/^data\:image\/webp/) === 0) return 'image/webp';
    if (uri.search(/\.ktx2($|\?)/i) > 0 || uri.search(/^data\:image\/ktx2/) === 0) return 'image/ktx2';
    return 'image/png';
}
const $559434fcc6e6401d$var$_identityMatrix = new (0, $dyjou.Matrix4)();
/* GLTF PARSER */ class $559434fcc6e6401d$var$GLTFParser {
    constructor(json = {}, options = {}){
        this.json = json;
        this.extensions = {};
        this.plugins = {};
        this.options = options;
        // loader object cache
        this.cache = new $559434fcc6e6401d$var$GLTFRegistry();
        // associations between Three.js objects and glTF elements
        this.associations = new Map();
        // BufferGeometry caching
        this.primitiveCache = {};
        // Node cache
        this.nodeCache = {};
        // Object3D instance caches
        this.meshCache = {
            refs: {},
            uses: {}
        };
        this.cameraCache = {
            refs: {},
            uses: {}
        };
        this.lightCache = {
            refs: {},
            uses: {}
        };
        this.sourceCache = {};
        this.textureCache = {};
        // Track node names, to ensure no duplicates
        this.nodeNamesUsed = {};
        // Use an ImageBitmapLoader if imageBitmaps are supported. Moves much of the
        // expensive work of uploading a texture to the GPU off the main thread.
        let isSafari = false;
        let safariVersion = -1;
        let isFirefox = false;
        let firefoxVersion = -1;
        if (typeof navigator !== 'undefined') {
            const userAgent = navigator.userAgent;
            isSafari = /^((?!chrome|android).)*safari/i.test(userAgent) === true;
            const safariMatch = userAgent.match(/Version\/(\d+)/);
            safariVersion = isSafari && safariMatch ? parseInt(safariMatch[1], 10) : -1;
            isFirefox = userAgent.indexOf('Firefox') > -1;
            firefoxVersion = isFirefox ? userAgent.match(/Firefox\/([0-9]+)\./)[1] : -1;
        }
        if (typeof createImageBitmap === 'undefined' || isSafari && safariVersion < 17 || isFirefox && firefoxVersion < 98) this.textureLoader = new (0, $dyjou.TextureLoader)(this.options.manager);
        else this.textureLoader = new (0, $dyjou.ImageBitmapLoader)(this.options.manager);
        this.textureLoader.setCrossOrigin(this.options.crossOrigin);
        this.textureLoader.setRequestHeader(this.options.requestHeader);
        this.fileLoader = new (0, $dyjou.FileLoader)(this.options.manager);
        this.fileLoader.setResponseType('arraybuffer');
        if (this.options.crossOrigin === 'use-credentials') this.fileLoader.setWithCredentials(true);
    }
    setExtensions(extensions) {
        this.extensions = extensions;
    }
    setPlugins(plugins) {
        this.plugins = plugins;
    }
    parse(onLoad, onError) {
        const parser = this;
        const json = this.json;
        const extensions = this.extensions;
        // Clear the loader cache
        this.cache.removeAll();
        this.nodeCache = {};
        // Mark the special nodes/meshes in json for efficient parse
        this._invokeAll(function(ext) {
            return ext._markDefs && ext._markDefs();
        });
        Promise.all(this._invokeAll(function(ext) {
            return ext.beforeRoot && ext.beforeRoot();
        })).then(function() {
            return Promise.all([
                parser.getDependencies('scene'),
                parser.getDependencies('animation'),
                parser.getDependencies('camera')
            ]);
        }).then(function(dependencies) {
            const result = {
                scene: dependencies[0][json.scene || 0],
                scenes: dependencies[0],
                animations: dependencies[1],
                cameras: dependencies[2],
                asset: json.asset,
                parser: parser,
                userData: {}
            };
            $559434fcc6e6401d$var$addUnknownExtensionsToUserData(extensions, result, json);
            $559434fcc6e6401d$var$assignExtrasToUserData(result, json);
            return Promise.all(parser._invokeAll(function(ext) {
                return ext.afterRoot && ext.afterRoot(result);
            })).then(function() {
                for (const scene of result.scenes)scene.updateMatrixWorld();
                onLoad(result);
            });
        }).catch(onError);
    }
    /**
	 * Marks the special nodes/meshes in json for efficient parse.
	 *
	 * @private
	 */ _markDefs() {
        const nodeDefs = this.json.nodes || [];
        const skinDefs = this.json.skins || [];
        const meshDefs = this.json.meshes || [];
        // Nothing in the node definition indicates whether it is a Bone or an
        // Object3D. Use the skins' joint references to mark bones.
        for(let skinIndex = 0, skinLength = skinDefs.length; skinIndex < skinLength; skinIndex++){
            const joints = skinDefs[skinIndex].joints;
            for(let i = 0, il = joints.length; i < il; i++)nodeDefs[joints[i]].isBone = true;
        }
        // Iterate over all nodes, marking references to shared resources,
        // as well as skeleton joints.
        for(let nodeIndex = 0, nodeLength = nodeDefs.length; nodeIndex < nodeLength; nodeIndex++){
            const nodeDef = nodeDefs[nodeIndex];
            if (nodeDef.mesh !== undefined) {
                this._addNodeRef(this.meshCache, nodeDef.mesh);
                // Nothing in the mesh definition indicates whether it is
                // a SkinnedMesh or Mesh. Use the node's mesh reference
                // to mark SkinnedMesh if node has skin.
                if (nodeDef.skin !== undefined) meshDefs[nodeDef.mesh].isSkinnedMesh = true;
            }
            if (nodeDef.camera !== undefined) this._addNodeRef(this.cameraCache, nodeDef.camera);
        }
    }
    /**
	 * Counts references to shared node / Object3D resources. These resources
	 * can be reused, or "instantiated", at multiple nodes in the scene
	 * hierarchy. Mesh, Camera, and Light instances are instantiated and must
	 * be marked. Non-scenegraph resources (like Materials, Geometries, and
	 * Textures) can be reused directly and are not marked here.
	 *
	 * Example: CesiumMilkTruck sample model reuses "Wheel" meshes.
	 *
	 * @private
	 * @param {Object} cache
	 * @param {Object3D} index
	 */ _addNodeRef(cache, index) {
        if (index === undefined) return;
        if (cache.refs[index] === undefined) cache.refs[index] = cache.uses[index] = 0;
        cache.refs[index]++;
    }
    /**
	 * Returns a reference to a shared resource, cloning it if necessary.
	 *
	 * @private
	 * @param {Object} cache
	 * @param {number} index
	 * @param {Object} object
	 * @return {Object}
	 */ _getNodeRef(cache, index, object) {
        if (cache.refs[index] <= 1) return object;
        const ref = object.clone();
        // Propagates mappings to the cloned object, prevents mappings on the
        // original object from being lost.
        const updateMappings = (original, clone)=>{
            const mappings = this.associations.get(original);
            if (mappings != null) this.associations.set(clone, mappings);
            for (const [i, child] of original.children.entries())updateMappings(child, clone.children[i]);
        };
        updateMappings(object, ref);
        ref.name += '_instance_' + cache.uses[index]++;
        return ref;
    }
    _invokeOne(func) {
        const extensions = Object.values(this.plugins);
        extensions.push(this);
        for(let i = 0; i < extensions.length; i++){
            const result = func(extensions[i]);
            if (result) return result;
        }
        return null;
    }
    _invokeAll(func) {
        const extensions = Object.values(this.plugins);
        extensions.unshift(this);
        const pending = [];
        for(let i = 0; i < extensions.length; i++){
            const result = func(extensions[i]);
            if (result) pending.push(result);
        }
        return pending;
    }
    /**
	 * Requests the specified dependency asynchronously, with caching.
	 *
	 * @private
	 * @param {string} type
	 * @param {number} index
	 * @return {Promise<Object3D|Material|THREE.Texture|AnimationClip|ArrayBuffer|Object>}
	 */ getDependency(type, index) {
        const cacheKey = type + ':' + index;
        let dependency = this.cache.get(cacheKey);
        if (!dependency) {
            switch(type){
                case 'scene':
                    dependency = this.loadScene(index);
                    break;
                case 'node':
                    dependency = this._invokeOne(function(ext) {
                        return ext.loadNode && ext.loadNode(index);
                    });
                    break;
                case 'mesh':
                    dependency = this._invokeOne(function(ext) {
                        return ext.loadMesh && ext.loadMesh(index);
                    });
                    break;
                case 'accessor':
                    dependency = this.loadAccessor(index);
                    break;
                case 'bufferView':
                    dependency = this._invokeOne(function(ext) {
                        return ext.loadBufferView && ext.loadBufferView(index);
                    });
                    break;
                case 'buffer':
                    dependency = this.loadBuffer(index);
                    break;
                case 'material':
                    dependency = this._invokeOne(function(ext) {
                        return ext.loadMaterial && ext.loadMaterial(index);
                    });
                    break;
                case 'texture':
                    dependency = this._invokeOne(function(ext) {
                        return ext.loadTexture && ext.loadTexture(index);
                    });
                    break;
                case 'skin':
                    dependency = this.loadSkin(index);
                    break;
                case 'animation':
                    dependency = this._invokeOne(function(ext) {
                        return ext.loadAnimation && ext.loadAnimation(index);
                    });
                    break;
                case 'camera':
                    dependency = this.loadCamera(index);
                    break;
                default:
                    dependency = this._invokeOne(function(ext) {
                        return ext != this && ext.getDependency && ext.getDependency(type, index);
                    });
                    if (!dependency) throw new Error('Unknown type: ' + type);
                    break;
            }
            this.cache.add(cacheKey, dependency);
        }
        return dependency;
    }
    /**
	 * Requests all dependencies of the specified type asynchronously, with caching.
	 *
	 * @private
	 * @param {string} type
	 * @return {Promise<Array<Object>>}
	 */ getDependencies(type) {
        let dependencies = this.cache.get(type);
        if (!dependencies) {
            const parser = this;
            const defs = this.json[type + (type === 'mesh' ? 'es' : 's')] || [];
            dependencies = Promise.all(defs.map(function(def, index) {
                return parser.getDependency(type, index);
            }));
            this.cache.add(type, dependencies);
        }
        return dependencies;
    }
    /**
	 * Specification: https://github.com/KhronosGroup/glTF/blob/master/specification/2.0/README.md#buffers-and-buffer-views
	 *
	 * @private
	 * @param {number} bufferIndex
	 * @return {Promise<ArrayBuffer>}
	 */ loadBuffer(bufferIndex) {
        const bufferDef = this.json.buffers[bufferIndex];
        const loader = this.fileLoader;
        if (bufferDef.type && bufferDef.type !== 'arraybuffer') throw new Error('THREE.GLTFLoader: ' + bufferDef.type + ' buffer type is not supported.');
        // If present, GLB container is required to be the first buffer.
        if (bufferDef.uri === undefined && bufferIndex === 0) return Promise.resolve(this.extensions[$559434fcc6e6401d$var$EXTENSIONS.KHR_BINARY_GLTF].body);
        const options = this.options;
        return new Promise(function(resolve, reject) {
            loader.load((0, $dyjou.LoaderUtils).resolveURL(bufferDef.uri, options.path), resolve, undefined, function() {
                reject(new Error('THREE.GLTFLoader: Failed to load buffer "' + bufferDef.uri + '".'));
            });
        });
    }
    /**
	 * Specification: https://github.com/KhronosGroup/glTF/blob/master/specification/2.0/README.md#buffers-and-buffer-views
	 *
	 * @private
	 * @param {number} bufferViewIndex
	 * @return {Promise<ArrayBuffer>}
	 */ loadBufferView(bufferViewIndex) {
        const bufferViewDef = this.json.bufferViews[bufferViewIndex];
        return this.getDependency('buffer', bufferViewDef.buffer).then(function(buffer) {
            const byteLength = bufferViewDef.byteLength || 0;
            const byteOffset = bufferViewDef.byteOffset || 0;
            return buffer.slice(byteOffset, byteOffset + byteLength);
        });
    }
    /**
	 * Specification: https://github.com/KhronosGroup/glTF/blob/master/specification/2.0/README.md#accessors
	 *
	 * @private
	 * @param {number} accessorIndex
	 * @return {Promise<BufferAttribute|InterleavedBufferAttribute>}
	 */ loadAccessor(accessorIndex) {
        const parser = this;
        const json = this.json;
        const accessorDef = this.json.accessors[accessorIndex];
        if (accessorDef.bufferView === undefined && accessorDef.sparse === undefined) {
            const itemSize = $559434fcc6e6401d$var$WEBGL_TYPE_SIZES[accessorDef.type];
            const TypedArray = $559434fcc6e6401d$var$WEBGL_COMPONENT_TYPES[accessorDef.componentType];
            const normalized = accessorDef.normalized === true;
            const array = new TypedArray(accessorDef.count * itemSize);
            return Promise.resolve(new (0, $dyjou.BufferAttribute)(array, itemSize, normalized));
        }
        const pendingBufferViews = [];
        if (accessorDef.bufferView !== undefined) pendingBufferViews.push(this.getDependency('bufferView', accessorDef.bufferView));
        else pendingBufferViews.push(null);
        if (accessorDef.sparse !== undefined) {
            pendingBufferViews.push(this.getDependency('bufferView', accessorDef.sparse.indices.bufferView));
            pendingBufferViews.push(this.getDependency('bufferView', accessorDef.sparse.values.bufferView));
        }
        return Promise.all(pendingBufferViews).then(function(bufferViews) {
            const bufferView = bufferViews[0];
            const itemSize = $559434fcc6e6401d$var$WEBGL_TYPE_SIZES[accessorDef.type];
            const TypedArray = $559434fcc6e6401d$var$WEBGL_COMPONENT_TYPES[accessorDef.componentType];
            // For VEC3: itemSize is 3, elementBytes is 4, itemBytes is 12.
            const elementBytes = TypedArray.BYTES_PER_ELEMENT;
            const itemBytes = elementBytes * itemSize;
            const byteOffset = accessorDef.byteOffset || 0;
            const byteStride = accessorDef.bufferView !== undefined ? json.bufferViews[accessorDef.bufferView].byteStride : undefined;
            const normalized = accessorDef.normalized === true;
            let array, bufferAttribute;
            // The buffer is not interleaved if the stride is the item size in bytes.
            if (byteStride && byteStride !== itemBytes) {
                // Each "slice" of the buffer, as defined by 'count' elements of 'byteStride' bytes, gets its own InterleavedBuffer
                // This makes sure that IBA.count reflects accessor.count properly
                const ibSlice = Math.floor(byteOffset / byteStride);
                const ibCacheKey = 'InterleavedBuffer:' + accessorDef.bufferView + ':' + accessorDef.componentType + ':' + ibSlice + ':' + accessorDef.count;
                let ib = parser.cache.get(ibCacheKey);
                if (!ib) {
                    array = new TypedArray(bufferView, ibSlice * byteStride, accessorDef.count * byteStride / elementBytes);
                    // Integer parameters to IB/IBA are in array elements, not bytes.
                    ib = new (0, $dyjou.InterleavedBuffer)(array, byteStride / elementBytes);
                    parser.cache.add(ibCacheKey, ib);
                }
                bufferAttribute = new (0, $dyjou.InterleavedBufferAttribute)(ib, itemSize, byteOffset % byteStride / elementBytes, normalized);
            } else {
                if (bufferView === null) array = new TypedArray(accessorDef.count * itemSize);
                else array = new TypedArray(bufferView, byteOffset, accessorDef.count * itemSize);
                bufferAttribute = new (0, $dyjou.BufferAttribute)(array, itemSize, normalized);
            }
            // https://github.com/KhronosGroup/glTF/blob/master/specification/2.0/README.md#sparse-accessors
            if (accessorDef.sparse !== undefined) {
                const itemSizeIndices = $559434fcc6e6401d$var$WEBGL_TYPE_SIZES.SCALAR;
                const TypedArrayIndices = $559434fcc6e6401d$var$WEBGL_COMPONENT_TYPES[accessorDef.sparse.indices.componentType];
                const byteOffsetIndices = accessorDef.sparse.indices.byteOffset || 0;
                const byteOffsetValues = accessorDef.sparse.values.byteOffset || 0;
                const sparseIndices = new TypedArrayIndices(bufferViews[1], byteOffsetIndices, accessorDef.sparse.count * itemSizeIndices);
                const sparseValues = new TypedArray(bufferViews[2], byteOffsetValues, accessorDef.sparse.count * itemSize);
                if (bufferView !== null) // Avoid modifying the original ArrayBuffer, if the bufferView wasn't initialized with zeroes.
                bufferAttribute = new (0, $dyjou.BufferAttribute)(bufferAttribute.array.slice(), bufferAttribute.itemSize, bufferAttribute.normalized);
                // Ignore normalized since we copy from sparse
                bufferAttribute.normalized = false;
                for(let i = 0, il = sparseIndices.length; i < il; i++){
                    const index = sparseIndices[i];
                    bufferAttribute.setX(index, sparseValues[i * itemSize]);
                    if (itemSize >= 2) bufferAttribute.setY(index, sparseValues[i * itemSize + 1]);
                    if (itemSize >= 3) bufferAttribute.setZ(index, sparseValues[i * itemSize + 2]);
                    if (itemSize >= 4) bufferAttribute.setW(index, sparseValues[i * itemSize + 3]);
                    if (itemSize >= 5) throw new Error('THREE.GLTFLoader: Unsupported itemSize in sparse BufferAttribute.');
                }
                bufferAttribute.normalized = normalized;
            }
            return bufferAttribute;
        });
    }
    /**
	 * Specification: https://github.com/KhronosGroup/glTF/tree/master/specification/2.0#textures
	 *
	 * @private
	 * @param {number} textureIndex
	 * @return {Promise<THREE.Texture|null>}
	 */ loadTexture(textureIndex) {
        const json = this.json;
        const options = this.options;
        const textureDef = json.textures[textureIndex];
        const sourceIndex = textureDef.source;
        const sourceDef = json.images[sourceIndex];
        let loader = this.textureLoader;
        if (sourceDef.uri) {
            const handler = options.manager.getHandler(sourceDef.uri);
            if (handler !== null) loader = handler;
        }
        return this.loadTextureImage(textureIndex, sourceIndex, loader);
    }
    loadTextureImage(textureIndex, sourceIndex, loader) {
        const parser = this;
        const json = this.json;
        const textureDef = json.textures[textureIndex];
        const sourceDef = json.images[sourceIndex];
        const cacheKey = (sourceDef.uri || sourceDef.bufferView) + ':' + textureDef.sampler;
        if (this.textureCache[cacheKey]) // See https://github.com/mrdoob/three.js/issues/21559.
        return this.textureCache[cacheKey];
        const promise = this.loadImageSource(sourceIndex, loader).then(function(texture) {
            texture.flipY = false;
            texture.name = textureDef.name || sourceDef.name || '';
            if (texture.name === '' && typeof sourceDef.uri === 'string' && sourceDef.uri.startsWith('data:image/') === false) texture.name = sourceDef.uri;
            const samplers = json.samplers || {};
            const sampler = samplers[textureDef.sampler] || {};
            texture.magFilter = $559434fcc6e6401d$var$WEBGL_FILTERS[sampler.magFilter] || (0, $dyjou.LinearFilter);
            texture.minFilter = $559434fcc6e6401d$var$WEBGL_FILTERS[sampler.minFilter] || (0, $dyjou.LinearMipmapLinearFilter);
            texture.wrapS = $559434fcc6e6401d$var$WEBGL_WRAPPINGS[sampler.wrapS] || (0, $dyjou.RepeatWrapping);
            texture.wrapT = $559434fcc6e6401d$var$WEBGL_WRAPPINGS[sampler.wrapT] || (0, $dyjou.RepeatWrapping);
            texture.generateMipmaps = !texture.isCompressedTexture && texture.minFilter !== (0, $dyjou.NearestFilter) && texture.minFilter !== (0, $dyjou.LinearFilter);
            parser.associations.set(texture, {
                textures: textureIndex
            });
            return texture;
        }).catch(function() {
            return null;
        });
        this.textureCache[cacheKey] = promise;
        return promise;
    }
    loadImageSource(sourceIndex, loader) {
        const parser = this;
        const json = this.json;
        const options = this.options;
        if (this.sourceCache[sourceIndex] !== undefined) return this.sourceCache[sourceIndex].then((texture)=>texture.clone());
        const sourceDef = json.images[sourceIndex];
        const URL = self.URL || self.webkitURL;
        let sourceURI = sourceDef.uri || '';
        let isObjectURL = false;
        if (sourceDef.bufferView !== undefined) // Load binary image data from bufferView, if provided.
        sourceURI = parser.getDependency('bufferView', sourceDef.bufferView).then(function(bufferView) {
            isObjectURL = true;
            const blob = new Blob([
                bufferView
            ], {
                type: sourceDef.mimeType
            });
            sourceURI = URL.createObjectURL(blob);
            return sourceURI;
        });
        else if (sourceDef.uri === undefined) throw new Error('THREE.GLTFLoader: Image ' + sourceIndex + ' is missing URI and bufferView');
        const promise = Promise.resolve(sourceURI).then(function(sourceURI) {
            return new Promise(function(resolve, reject) {
                let onLoad = resolve;
                if (loader.isImageBitmapLoader === true) onLoad = function(imageBitmap) {
                    const texture = new (0, $dyjou.Texture)(imageBitmap);
                    texture.needsUpdate = true;
                    resolve(texture);
                };
                loader.load((0, $dyjou.LoaderUtils).resolveURL(sourceURI, options.path), onLoad, undefined, reject);
            });
        }).then(function(texture) {
            // Clean up resources and configure Texture.
            if (isObjectURL === true) URL.revokeObjectURL(sourceURI);
            $559434fcc6e6401d$var$assignExtrasToUserData(texture, sourceDef);
            texture.userData.mimeType = sourceDef.mimeType || $559434fcc6e6401d$var$getImageURIMimeType(sourceDef.uri);
            return texture;
        }).catch(function(error) {
            console.error('THREE.GLTFLoader: Couldn\'t load texture', sourceURI);
            throw error;
        });
        this.sourceCache[sourceIndex] = promise;
        return promise;
    }
    /**
	 * Asynchronously assigns a texture to the given material parameters.
	 *
	 * @private
	 * @param {Object} materialParams
	 * @param {string} mapName
	 * @param {Object} mapDef
	 * @param {string} [colorSpace]
	 * @return {Promise<Texture>}
	 */ assignTexture(materialParams, mapName, mapDef, colorSpace) {
        const parser = this;
        return this.getDependency('texture', mapDef.index).then(function(texture) {
            if (!texture) return null;
            if (mapDef.texCoord !== undefined && mapDef.texCoord > 0) {
                texture = texture.clone();
                texture.channel = mapDef.texCoord;
            }
            if (parser.extensions[$559434fcc6e6401d$var$EXTENSIONS.KHR_TEXTURE_TRANSFORM]) {
                const transform = mapDef.extensions !== undefined ? mapDef.extensions[$559434fcc6e6401d$var$EXTENSIONS.KHR_TEXTURE_TRANSFORM] : undefined;
                if (transform) {
                    const gltfReference = parser.associations.get(texture);
                    texture = parser.extensions[$559434fcc6e6401d$var$EXTENSIONS.KHR_TEXTURE_TRANSFORM].extendTexture(texture, transform);
                    parser.associations.set(texture, gltfReference);
                }
            }
            if (colorSpace !== undefined) texture.colorSpace = colorSpace;
            materialParams[mapName] = texture;
            return texture;
        });
    }
    /**
	 * Assigns final material to a Mesh, Line, or Points instance. The instance
	 * already has a material (generated from the glTF material options alone)
	 * but reuse of the same glTF material may require multiple threejs materials
	 * to accommodate different primitive types, defines, etc. New materials will
	 * be created if necessary, and reused from a cache.
	 *
	 * @private
	 * @param {Object3D} mesh Mesh, Line, or Points instance.
	 */ assignFinalMaterial(mesh) {
        const geometry = mesh.geometry;
        let material = mesh.material;
        const useDerivativeTangents = geometry.attributes.tangent === undefined;
        const useVertexColors = geometry.attributes.color !== undefined;
        const useFlatShading = geometry.attributes.normal === undefined;
        if (mesh.isPoints) {
            const cacheKey = 'PointsMaterial:' + material.uuid;
            let pointsMaterial = this.cache.get(cacheKey);
            if (!pointsMaterial) {
                pointsMaterial = new (0, $dyjou.PointsMaterial)();
                (0, $dyjou.Material).prototype.copy.call(pointsMaterial, material);
                pointsMaterial.color.copy(material.color);
                pointsMaterial.map = material.map;
                pointsMaterial.sizeAttenuation = false; // glTF spec says points should be 1px
                this.cache.add(cacheKey, pointsMaterial);
            }
            material = pointsMaterial;
        } else if (mesh.isLine) {
            const cacheKey = 'LineBasicMaterial:' + material.uuid;
            let lineMaterial = this.cache.get(cacheKey);
            if (!lineMaterial) {
                lineMaterial = new (0, $dyjou.LineBasicMaterial)();
                (0, $dyjou.Material).prototype.copy.call(lineMaterial, material);
                lineMaterial.color.copy(material.color);
                lineMaterial.map = material.map;
                this.cache.add(cacheKey, lineMaterial);
            }
            material = lineMaterial;
        }
        // Clone the material if it will be modified
        if (useDerivativeTangents || useVertexColors || useFlatShading) {
            let cacheKey = 'ClonedMaterial:' + material.uuid + ':';
            if (useDerivativeTangents) cacheKey += 'derivative-tangents:';
            if (useVertexColors) cacheKey += 'vertex-colors:';
            if (useFlatShading) cacheKey += 'flat-shading:';
            let cachedMaterial = this.cache.get(cacheKey);
            if (!cachedMaterial) {
                cachedMaterial = material.clone();
                if (useVertexColors) cachedMaterial.vertexColors = true;
                if (useFlatShading) cachedMaterial.flatShading = true;
                if (useDerivativeTangents) {
                    // https://github.com/mrdoob/three.js/issues/11438#issuecomment-507003995
                    if (cachedMaterial.normalScale) cachedMaterial.normalScale.y *= -1;
                    if (cachedMaterial.clearcoatNormalScale) cachedMaterial.clearcoatNormalScale.y *= -1;
                }
                this.cache.add(cacheKey, cachedMaterial);
                this.associations.set(cachedMaterial, this.associations.get(material));
            }
            material = cachedMaterial;
        }
        mesh.material = material;
    }
    getMaterialType() {
        return 0, $dyjou.MeshStandardMaterial;
    }
    /**
	 * Specification: https://github.com/KhronosGroup/glTF/blob/master/specification/2.0/README.md#materials
	 *
	 * @private
	 * @param {number} materialIndex
	 * @return {Promise<Material>}
	 */ loadMaterial(materialIndex) {
        const parser = this;
        const json = this.json;
        const extensions = this.extensions;
        const materialDef = json.materials[materialIndex];
        let materialType;
        const materialParams = {};
        const materialExtensions = materialDef.extensions || {};
        const pending = [];
        if (materialExtensions[$559434fcc6e6401d$var$EXTENSIONS.KHR_MATERIALS_UNLIT]) {
            const kmuExtension = extensions[$559434fcc6e6401d$var$EXTENSIONS.KHR_MATERIALS_UNLIT];
            materialType = kmuExtension.getMaterialType();
            pending.push(kmuExtension.extendParams(materialParams, materialDef, parser));
        } else {
            // Specification:
            // https://github.com/KhronosGroup/glTF/tree/master/specification/2.0#metallic-roughness-material
            const metallicRoughness = materialDef.pbrMetallicRoughness || {};
            materialParams.color = new (0, $dyjou.Color)(1.0, 1.0, 1.0);
            materialParams.opacity = 1.0;
            if (Array.isArray(metallicRoughness.baseColorFactor)) {
                const array = metallicRoughness.baseColorFactor;
                materialParams.color.setRGB(array[0], array[1], array[2], (0, $dyjou.LinearSRGBColorSpace));
                materialParams.opacity = array[3];
            }
            if (metallicRoughness.baseColorTexture !== undefined) pending.push(parser.assignTexture(materialParams, 'map', metallicRoughness.baseColorTexture, (0, $dyjou.SRGBColorSpace)));
            materialParams.metalness = metallicRoughness.metallicFactor !== undefined ? metallicRoughness.metallicFactor : 1.0;
            materialParams.roughness = metallicRoughness.roughnessFactor !== undefined ? metallicRoughness.roughnessFactor : 1.0;
            if (metallicRoughness.metallicRoughnessTexture !== undefined) {
                pending.push(parser.assignTexture(materialParams, 'metalnessMap', metallicRoughness.metallicRoughnessTexture));
                pending.push(parser.assignTexture(materialParams, 'roughnessMap', metallicRoughness.metallicRoughnessTexture));
            }
            materialType = this._invokeOne(function(ext) {
                return ext.getMaterialType && ext.getMaterialType(materialIndex);
            });
            pending.push(Promise.all(this._invokeAll(function(ext) {
                return ext.extendMaterialParams && ext.extendMaterialParams(materialIndex, materialParams);
            })));
        }
        if (materialDef.doubleSided === true) materialParams.side = (0, $dyjou.DoubleSide);
        const alphaMode = materialDef.alphaMode || $559434fcc6e6401d$var$ALPHA_MODES.OPAQUE;
        if (alphaMode === $559434fcc6e6401d$var$ALPHA_MODES.BLEND) {
            materialParams.transparent = true;
            // See: https://github.com/mrdoob/three.js/issues/17706
            materialParams.depthWrite = false;
        } else {
            materialParams.transparent = false;
            if (alphaMode === $559434fcc6e6401d$var$ALPHA_MODES.MASK) materialParams.alphaTest = materialDef.alphaCutoff !== undefined ? materialDef.alphaCutoff : 0.5;
        }
        if (materialDef.normalTexture !== undefined && materialType !== (0, $dyjou.MeshBasicMaterial)) {
            pending.push(parser.assignTexture(materialParams, 'normalMap', materialDef.normalTexture));
            materialParams.normalScale = new (0, $dyjou.Vector2)(1, 1);
            if (materialDef.normalTexture.scale !== undefined) {
                const scale = materialDef.normalTexture.scale;
                materialParams.normalScale.set(scale, scale);
            }
        }
        if (materialDef.occlusionTexture !== undefined && materialType !== (0, $dyjou.MeshBasicMaterial)) {
            pending.push(parser.assignTexture(materialParams, 'aoMap', materialDef.occlusionTexture));
            if (materialDef.occlusionTexture.strength !== undefined) materialParams.aoMapIntensity = materialDef.occlusionTexture.strength;
        }
        if (materialDef.emissiveFactor !== undefined && materialType !== (0, $dyjou.MeshBasicMaterial)) {
            const emissiveFactor = materialDef.emissiveFactor;
            materialParams.emissive = new (0, $dyjou.Color)().setRGB(emissiveFactor[0], emissiveFactor[1], emissiveFactor[2], (0, $dyjou.LinearSRGBColorSpace));
        }
        if (materialDef.emissiveTexture !== undefined && materialType !== (0, $dyjou.MeshBasicMaterial)) pending.push(parser.assignTexture(materialParams, 'emissiveMap', materialDef.emissiveTexture, (0, $dyjou.SRGBColorSpace)));
        return Promise.all(pending).then(function() {
            const material = new materialType(materialParams);
            if (materialDef.name) material.name = materialDef.name;
            $559434fcc6e6401d$var$assignExtrasToUserData(material, materialDef);
            parser.associations.set(material, {
                materials: materialIndex
            });
            if (materialDef.extensions) $559434fcc6e6401d$var$addUnknownExtensionsToUserData(extensions, material, materialDef);
            return material;
        });
    }
    /**
	 * When Object3D instances are targeted by animation, they need unique names.
	 *
	 * @private
	 * @param {string} originalName
	 * @return {string}
	 */ createUniqueName(originalName) {
        const sanitizedName = (0, $dyjou.PropertyBinding).sanitizeNodeName(originalName || '');
        if (sanitizedName in this.nodeNamesUsed) return sanitizedName + '_' + ++this.nodeNamesUsed[sanitizedName];
        else {
            this.nodeNamesUsed[sanitizedName] = 0;
            return sanitizedName;
        }
    }
    /**
	 * Specification: https://github.com/KhronosGroup/glTF/blob/master/specification/2.0/README.md#geometry
	 *
	 * Creates BufferGeometries from primitives.
	 *
	 * @private
	 * @param {Array<GLTF.Primitive>} primitives
	 * @return {Promise<Array<BufferGeometry>>}
	 */ loadGeometries(primitives) {
        const parser = this;
        const extensions = this.extensions;
        const cache = this.primitiveCache;
        function createDracoPrimitive(primitive) {
            return extensions[$559434fcc6e6401d$var$EXTENSIONS.KHR_DRACO_MESH_COMPRESSION].decodePrimitive(primitive, parser).then(function(geometry) {
                return $559434fcc6e6401d$var$addPrimitiveAttributes(geometry, primitive, parser);
            });
        }
        const pending = [];
        for(let i = 0, il = primitives.length; i < il; i++){
            const primitive = primitives[i];
            const cacheKey = $559434fcc6e6401d$var$createPrimitiveKey(primitive);
            // See if we've already created this geometry
            const cached = cache[cacheKey];
            if (cached) // Use the cached geometry if it exists
            pending.push(cached.promise);
            else {
                let geometryPromise;
                if (primitive.extensions && primitive.extensions[$559434fcc6e6401d$var$EXTENSIONS.KHR_DRACO_MESH_COMPRESSION]) // Use DRACO geometry if available
                geometryPromise = createDracoPrimitive(primitive);
                else // Otherwise create a new geometry
                geometryPromise = $559434fcc6e6401d$var$addPrimitiveAttributes(new (0, $dyjou.BufferGeometry)(), primitive, parser);
                // Cache this geometry
                cache[cacheKey] = {
                    primitive: primitive,
                    promise: geometryPromise
                };
                pending.push(geometryPromise);
            }
        }
        return Promise.all(pending);
    }
    /**
	 * Specification: https://github.com/KhronosGroup/glTF/blob/master/specification/2.0/README.md#meshes
	 *
	 * @private
	 * @param {number} meshIndex
	 * @return {Promise<Group|Mesh|SkinnedMesh|Line|Points>}
	 */ loadMesh(meshIndex) {
        const parser = this;
        const json = this.json;
        const extensions = this.extensions;
        const meshDef = json.meshes[meshIndex];
        const primitives = meshDef.primitives;
        const pending = [];
        for(let i = 0, il = primitives.length; i < il; i++){
            const material = primitives[i].material === undefined ? $559434fcc6e6401d$var$createDefaultMaterial(this.cache) : this.getDependency('material', primitives[i].material);
            pending.push(material);
        }
        pending.push(parser.loadGeometries(primitives));
        return Promise.all(pending).then(function(results) {
            const materials = results.slice(0, results.length - 1);
            const geometries = results[results.length - 1];
            const meshes = [];
            for(let i = 0, il = geometries.length; i < il; i++){
                const geometry = geometries[i];
                const primitive = primitives[i];
                // 1. create Mesh
                let mesh;
                const material = materials[i];
                if (primitive.mode === $559434fcc6e6401d$var$WEBGL_CONSTANTS.TRIANGLES || primitive.mode === $559434fcc6e6401d$var$WEBGL_CONSTANTS.TRIANGLE_STRIP || primitive.mode === $559434fcc6e6401d$var$WEBGL_CONSTANTS.TRIANGLE_FAN || primitive.mode === undefined) {
                    // .isSkinnedMesh isn't in glTF spec. See ._markDefs()
                    mesh = meshDef.isSkinnedMesh === true ? new (0, $dyjou.SkinnedMesh)(geometry, material) : new (0, $dyjou.Mesh)(geometry, material);
                    if (mesh.isSkinnedMesh === true) // normalize skin weights to fix malformed assets (see #15319)
                    mesh.normalizeSkinWeights();
                    if (primitive.mode === $559434fcc6e6401d$var$WEBGL_CONSTANTS.TRIANGLE_STRIP) mesh.geometry = (0, $5451ea62abbe5f68$export$5492ca6e5c0c7aa0)(mesh.geometry, (0, $dyjou.TriangleStripDrawMode));
                    else if (primitive.mode === $559434fcc6e6401d$var$WEBGL_CONSTANTS.TRIANGLE_FAN) mesh.geometry = (0, $5451ea62abbe5f68$export$5492ca6e5c0c7aa0)(mesh.geometry, (0, $dyjou.TriangleFanDrawMode));
                } else if (primitive.mode === $559434fcc6e6401d$var$WEBGL_CONSTANTS.LINES) mesh = new (0, $dyjou.LineSegments)(geometry, material);
                else if (primitive.mode === $559434fcc6e6401d$var$WEBGL_CONSTANTS.LINE_STRIP) mesh = new (0, $dyjou.Line)(geometry, material);
                else if (primitive.mode === $559434fcc6e6401d$var$WEBGL_CONSTANTS.LINE_LOOP) mesh = new (0, $dyjou.LineLoop)(geometry, material);
                else if (primitive.mode === $559434fcc6e6401d$var$WEBGL_CONSTANTS.POINTS) mesh = new (0, $dyjou.Points)(geometry, material);
                else throw new Error('THREE.GLTFLoader: Primitive mode unsupported: ' + primitive.mode);
                if (Object.keys(mesh.geometry.morphAttributes).length > 0) $559434fcc6e6401d$var$updateMorphTargets(mesh, meshDef);
                mesh.name = parser.createUniqueName(meshDef.name || 'mesh_' + meshIndex);
                $559434fcc6e6401d$var$assignExtrasToUserData(mesh, meshDef);
                if (primitive.extensions) $559434fcc6e6401d$var$addUnknownExtensionsToUserData(extensions, mesh, primitive);
                parser.assignFinalMaterial(mesh);
                meshes.push(mesh);
            }
            for(let i = 0, il = meshes.length; i < il; i++)parser.associations.set(meshes[i], {
                meshes: meshIndex,
                primitives: i
            });
            if (meshes.length === 1) {
                if (meshDef.extensions) $559434fcc6e6401d$var$addUnknownExtensionsToUserData(extensions, meshes[0], meshDef);
                return meshes[0];
            }
            const group = new (0, $dyjou.Group)();
            if (meshDef.extensions) $559434fcc6e6401d$var$addUnknownExtensionsToUserData(extensions, group, meshDef);
            parser.associations.set(group, {
                meshes: meshIndex
            });
            for(let i = 0, il = meshes.length; i < il; i++)group.add(meshes[i]);
            return group;
        });
    }
    /**
	 * Specification: https://github.com/KhronosGroup/glTF/tree/master/specification/2.0#cameras
	 *
	 * @private
	 * @param {number} cameraIndex
	 * @return {Promise<THREE.Camera>}
	 */ loadCamera(cameraIndex) {
        let camera;
        const cameraDef = this.json.cameras[cameraIndex];
        const params = cameraDef[cameraDef.type];
        if (!params) {
            console.warn('THREE.GLTFLoader: Missing camera parameters.');
            return;
        }
        if (cameraDef.type === 'perspective') camera = new (0, $dyjou.PerspectiveCamera)((0, $dyjou.MathUtils).radToDeg(params.yfov), params.aspectRatio || 1, params.znear || 1, params.zfar || 2e6);
        else if (cameraDef.type === 'orthographic') camera = new (0, $dyjou.OrthographicCamera)(-params.xmag, params.xmag, params.ymag, -params.ymag, params.znear, params.zfar);
        if (cameraDef.name) camera.name = this.createUniqueName(cameraDef.name);
        $559434fcc6e6401d$var$assignExtrasToUserData(camera, cameraDef);
        return Promise.resolve(camera);
    }
    /**
	 * Specification: https://github.com/KhronosGroup/glTF/tree/master/specification/2.0#skins
	 *
	 * @private
	 * @param {number} skinIndex
	 * @return {Promise<Skeleton>}
	 */ loadSkin(skinIndex) {
        const skinDef = this.json.skins[skinIndex];
        const pending = [];
        for(let i = 0, il = skinDef.joints.length; i < il; i++)pending.push(this._loadNodeShallow(skinDef.joints[i]));
        if (skinDef.inverseBindMatrices !== undefined) pending.push(this.getDependency('accessor', skinDef.inverseBindMatrices));
        else pending.push(null);
        return Promise.all(pending).then(function(results) {
            const inverseBindMatrices = results.pop();
            const jointNodes = results;
            // Note that bones (joint nodes) may or may not be in the
            // scene graph at this time.
            const bones = [];
            const boneInverses = [];
            for(let i = 0, il = jointNodes.length; i < il; i++){
                const jointNode = jointNodes[i];
                if (jointNode) {
                    bones.push(jointNode);
                    const mat = new (0, $dyjou.Matrix4)();
                    if (inverseBindMatrices !== null) mat.fromArray(inverseBindMatrices.array, i * 16);
                    boneInverses.push(mat);
                } else console.warn('THREE.GLTFLoader: Joint "%s" could not be found.', skinDef.joints[i]);
            }
            return new (0, $dyjou.Skeleton)(bones, boneInverses);
        });
    }
    /**
	 * Specification: https://github.com/KhronosGroup/glTF/tree/master/specification/2.0#animations
	 *
	 * @private
	 * @param {number} animationIndex
	 * @return {Promise<AnimationClip>}
	 */ loadAnimation(animationIndex) {
        const json = this.json;
        const parser = this;
        const animationDef = json.animations[animationIndex];
        const animationName = animationDef.name ? animationDef.name : 'animation_' + animationIndex;
        const pendingNodes = [];
        const pendingInputAccessors = [];
        const pendingOutputAccessors = [];
        const pendingSamplers = [];
        const pendingTargets = [];
        for(let i = 0, il = animationDef.channels.length; i < il; i++){
            const channel = animationDef.channels[i];
            const sampler = animationDef.samplers[channel.sampler];
            const target = channel.target;
            const name = target.node;
            const input = animationDef.parameters !== undefined ? animationDef.parameters[sampler.input] : sampler.input;
            const output = animationDef.parameters !== undefined ? animationDef.parameters[sampler.output] : sampler.output;
            if (target.node === undefined) continue;
            pendingNodes.push(this.getDependency('node', name));
            pendingInputAccessors.push(this.getDependency('accessor', input));
            pendingOutputAccessors.push(this.getDependency('accessor', output));
            pendingSamplers.push(sampler);
            pendingTargets.push(target);
        }
        return Promise.all([
            Promise.all(pendingNodes),
            Promise.all(pendingInputAccessors),
            Promise.all(pendingOutputAccessors),
            Promise.all(pendingSamplers),
            Promise.all(pendingTargets)
        ]).then(function(dependencies) {
            const nodes = dependencies[0];
            const inputAccessors = dependencies[1];
            const outputAccessors = dependencies[2];
            const samplers = dependencies[3];
            const targets = dependencies[4];
            const tracks = [];
            for(let i = 0, il = nodes.length; i < il; i++){
                const node = nodes[i];
                const inputAccessor = inputAccessors[i];
                const outputAccessor = outputAccessors[i];
                const sampler = samplers[i];
                const target = targets[i];
                if (node === undefined) continue;
                if (node.updateMatrix) node.updateMatrix();
                const createdTracks = parser._createAnimationTracks(node, inputAccessor, outputAccessor, sampler, target);
                if (createdTracks) for(let k = 0; k < createdTracks.length; k++)tracks.push(createdTracks[k]);
            }
            return new (0, $dyjou.AnimationClip)(animationName, undefined, tracks);
        });
    }
    createNodeMesh(nodeIndex) {
        const json = this.json;
        const parser = this;
        const nodeDef = json.nodes[nodeIndex];
        if (nodeDef.mesh === undefined) return null;
        return parser.getDependency('mesh', nodeDef.mesh).then(function(mesh) {
            const node = parser._getNodeRef(parser.meshCache, nodeDef.mesh, mesh);
            // if weights are provided on the node, override weights on the mesh.
            if (nodeDef.weights !== undefined) node.traverse(function(o) {
                if (!o.isMesh) return;
                for(let i = 0, il = nodeDef.weights.length; i < il; i++)o.morphTargetInfluences[i] = nodeDef.weights[i];
            });
            return node;
        });
    }
    /**
	 * Specification: https://github.com/KhronosGroup/glTF/tree/master/specification/2.0#nodes-and-hierarchy
	 *
	 * @private
	 * @param {number} nodeIndex
	 * @return {Promise<Object3D>}
	 */ loadNode(nodeIndex) {
        const json = this.json;
        const parser = this;
        const nodeDef = json.nodes[nodeIndex];
        const nodePending = parser._loadNodeShallow(nodeIndex);
        const childPending = [];
        const childrenDef = nodeDef.children || [];
        for(let i = 0, il = childrenDef.length; i < il; i++)childPending.push(parser.getDependency('node', childrenDef[i]));
        const skeletonPending = nodeDef.skin === undefined ? Promise.resolve(null) : parser.getDependency('skin', nodeDef.skin);
        return Promise.all([
            nodePending,
            Promise.all(childPending),
            skeletonPending
        ]).then(function(results) {
            const node = results[0];
            const children = results[1];
            const skeleton = results[2];
            if (skeleton !== null) // This full traverse should be fine because
            // child glTF nodes have not been added to this node yet.
            node.traverse(function(mesh) {
                if (!mesh.isSkinnedMesh) return;
                mesh.bind(skeleton, $559434fcc6e6401d$var$_identityMatrix);
            });
            for(let i = 0, il = children.length; i < il; i++)node.add(children[i]);
            return node;
        });
    }
    // ._loadNodeShallow() parses a single node.
    // skin and child nodes are created and added in .loadNode() (no '_' prefix).
    _loadNodeShallow(nodeIndex) {
        const json = this.json;
        const extensions = this.extensions;
        const parser = this;
        // This method is called from .loadNode() and .loadSkin().
        // Cache a node to avoid duplication.
        if (this.nodeCache[nodeIndex] !== undefined) return this.nodeCache[nodeIndex];
        const nodeDef = json.nodes[nodeIndex];
        // reserve node's name before its dependencies, so the root has the intended name.
        const nodeName = nodeDef.name ? parser.createUniqueName(nodeDef.name) : '';
        const pending = [];
        const meshPromise = parser._invokeOne(function(ext) {
            return ext.createNodeMesh && ext.createNodeMesh(nodeIndex);
        });
        if (meshPromise) pending.push(meshPromise);
        if (nodeDef.camera !== undefined) pending.push(parser.getDependency('camera', nodeDef.camera).then(function(camera) {
            return parser._getNodeRef(parser.cameraCache, nodeDef.camera, camera);
        }));
        parser._invokeAll(function(ext) {
            return ext.createNodeAttachment && ext.createNodeAttachment(nodeIndex);
        }).forEach(function(promise) {
            pending.push(promise);
        });
        this.nodeCache[nodeIndex] = Promise.all(pending).then(function(objects) {
            let node;
            // .isBone isn't in glTF spec. See ._markDefs
            if (nodeDef.isBone === true) node = new (0, $dyjou.Bone)();
            else if (objects.length > 1) node = new (0, $dyjou.Group)();
            else if (objects.length === 1) node = objects[0];
            else node = new (0, $dyjou.Object3D)();
            if (node !== objects[0]) for(let i = 0, il = objects.length; i < il; i++)node.add(objects[i]);
            if (nodeDef.name) {
                node.userData.name = nodeDef.name;
                node.name = nodeName;
            }
            $559434fcc6e6401d$var$assignExtrasToUserData(node, nodeDef);
            if (nodeDef.extensions) $559434fcc6e6401d$var$addUnknownExtensionsToUserData(extensions, node, nodeDef);
            if (nodeDef.matrix !== undefined) {
                const matrix = new (0, $dyjou.Matrix4)();
                matrix.fromArray(nodeDef.matrix);
                node.applyMatrix4(matrix);
            } else {
                if (nodeDef.translation !== undefined) node.position.fromArray(nodeDef.translation);
                if (nodeDef.rotation !== undefined) node.quaternion.fromArray(nodeDef.rotation);
                if (nodeDef.scale !== undefined) node.scale.fromArray(nodeDef.scale);
            }
            if (!parser.associations.has(node)) parser.associations.set(node, {});
            parser.associations.get(node).nodes = nodeIndex;
            return node;
        });
        return this.nodeCache[nodeIndex];
    }
    /**
	 * Specification: https://github.com/KhronosGroup/glTF/tree/master/specification/2.0#scenes
	 *
	 * @private
	 * @param {number} sceneIndex
	 * @return {Promise<Group>}
	 */ loadScene(sceneIndex) {
        const extensions = this.extensions;
        const sceneDef = this.json.scenes[sceneIndex];
        const parser = this;
        // Loader returns Group, not Scene.
        // See: https://github.com/mrdoob/three.js/issues/18342#issuecomment-578981172
        const scene = new (0, $dyjou.Group)();
        if (sceneDef.name) scene.name = parser.createUniqueName(sceneDef.name);
        $559434fcc6e6401d$var$assignExtrasToUserData(scene, sceneDef);
        if (sceneDef.extensions) $559434fcc6e6401d$var$addUnknownExtensionsToUserData(extensions, scene, sceneDef);
        const nodeIds = sceneDef.nodes || [];
        const pending = [];
        for(let i = 0, il = nodeIds.length; i < il; i++)pending.push(parser.getDependency('node', nodeIds[i]));
        return Promise.all(pending).then(function(nodes) {
            for(let i = 0, il = nodes.length; i < il; i++)scene.add(nodes[i]);
            // Removes dangling associations, associations that reference a node that
            // didn't make it into the scene.
            const reduceAssociations = (node)=>{
                const reducedAssociations = new Map();
                for (const [key, value] of parser.associations)if (key instanceof (0, $dyjou.Material) || key instanceof (0, $dyjou.Texture)) reducedAssociations.set(key, value);
                node.traverse((node)=>{
                    const mappings = parser.associations.get(node);
                    if (mappings != null) reducedAssociations.set(node, mappings);
                });
                return reducedAssociations;
            };
            parser.associations = reduceAssociations(scene);
            return scene;
        });
    }
    _createAnimationTracks(node, inputAccessor, outputAccessor, sampler, target) {
        const tracks = [];
        const targetName = node.name ? node.name : node.uuid;
        const targetNames = [];
        if ($559434fcc6e6401d$var$PATH_PROPERTIES[target.path] === $559434fcc6e6401d$var$PATH_PROPERTIES.weights) node.traverse(function(object) {
            if (object.morphTargetInfluences) targetNames.push(object.name ? object.name : object.uuid);
        });
        else targetNames.push(targetName);
        let TypedKeyframeTrack;
        switch($559434fcc6e6401d$var$PATH_PROPERTIES[target.path]){
            case $559434fcc6e6401d$var$PATH_PROPERTIES.weights:
                TypedKeyframeTrack = (0, $dyjou.NumberKeyframeTrack);
                break;
            case $559434fcc6e6401d$var$PATH_PROPERTIES.rotation:
                TypedKeyframeTrack = (0, $dyjou.QuaternionKeyframeTrack);
                break;
            case $559434fcc6e6401d$var$PATH_PROPERTIES.translation:
            case $559434fcc6e6401d$var$PATH_PROPERTIES.scale:
                TypedKeyframeTrack = (0, $dyjou.VectorKeyframeTrack);
                break;
            default:
                switch(outputAccessor.itemSize){
                    case 1:
                        TypedKeyframeTrack = (0, $dyjou.NumberKeyframeTrack);
                        break;
                    case 2:
                    case 3:
                    default:
                        TypedKeyframeTrack = (0, $dyjou.VectorKeyframeTrack);
                        break;
                }
                break;
        }
        const interpolation = sampler.interpolation !== undefined ? $559434fcc6e6401d$var$INTERPOLATION[sampler.interpolation] : (0, $dyjou.InterpolateLinear);
        const outputArray = this._getArrayFromAccessor(outputAccessor);
        for(let j = 0, jl = targetNames.length; j < jl; j++){
            const track = new TypedKeyframeTrack(targetNames[j] + '.' + $559434fcc6e6401d$var$PATH_PROPERTIES[target.path], inputAccessor.array, outputArray, interpolation);
            // Override interpolation with custom factory method.
            if (sampler.interpolation === 'CUBICSPLINE') this._createCubicSplineTrackInterpolant(track);
            tracks.push(track);
        }
        return tracks;
    }
    _getArrayFromAccessor(accessor) {
        let outputArray = accessor.array;
        if (accessor.normalized) {
            const scale = $559434fcc6e6401d$var$getNormalizedComponentScale(outputArray.constructor);
            const scaled = new Float32Array(outputArray.length);
            for(let j = 0, jl = outputArray.length; j < jl; j++)scaled[j] = outputArray[j] * scale;
            outputArray = scaled;
        }
        return outputArray;
    }
    _createCubicSplineTrackInterpolant(track) {
        track.createInterpolant = function InterpolantFactoryMethodGLTFCubicSpline(result) {
            // A CUBICSPLINE keyframe in glTF has three output values for each input value,
            // representing inTangent, splineVertex, and outTangent. As a result, track.getValueSize()
            // must be divided by three to get the interpolant's sampleSize argument.
            const interpolantType = this instanceof (0, $dyjou.QuaternionKeyframeTrack) ? $559434fcc6e6401d$var$GLTFCubicSplineQuaternionInterpolant : $559434fcc6e6401d$var$GLTFCubicSplineInterpolant;
            return new interpolantType(this.times, this.values, this.getValueSize() / 3, result);
        };
        // Mark as CUBICSPLINE. `track.getInterpolation()` doesn't support custom interpolants.
        track.createInterpolant.isInterpolantFactoryMethodGLTFCubicSpline = true;
    }
}
/**
 *
 * @private
 * @param {BufferGeometry} geometry
 * @param {GLTF.Primitive} primitiveDef
 * @param {GLTFParser} parser
 */ function $559434fcc6e6401d$var$computeBounds(geometry, primitiveDef, parser) {
    const attributes = primitiveDef.attributes;
    const box = new (0, $dyjou.Box3)();
    if (attributes.POSITION !== undefined) {
        const accessor = parser.json.accessors[attributes.POSITION];
        const min = accessor.min;
        const max = accessor.max;
        // glTF requires 'min' and 'max', but VRM (which extends glTF) currently ignores that requirement.
        if (min !== undefined && max !== undefined) {
            box.set(new (0, $dyjou.Vector3)(min[0], min[1], min[2]), new (0, $dyjou.Vector3)(max[0], max[1], max[2]));
            if (accessor.normalized) {
                const boxScale = $559434fcc6e6401d$var$getNormalizedComponentScale($559434fcc6e6401d$var$WEBGL_COMPONENT_TYPES[accessor.componentType]);
                box.min.multiplyScalar(boxScale);
                box.max.multiplyScalar(boxScale);
            }
        } else {
            console.warn('THREE.GLTFLoader: Missing min/max properties for accessor POSITION.');
            return;
        }
    } else return;
    const targets = primitiveDef.targets;
    if (targets !== undefined) {
        const maxDisplacement = new (0, $dyjou.Vector3)();
        const vector = new (0, $dyjou.Vector3)();
        for(let i = 0, il = targets.length; i < il; i++){
            const target = targets[i];
            if (target.POSITION !== undefined) {
                const accessor = parser.json.accessors[target.POSITION];
                const min = accessor.min;
                const max = accessor.max;
                // glTF requires 'min' and 'max', but VRM (which extends glTF) currently ignores that requirement.
                if (min !== undefined && max !== undefined) {
                    // we need to get max of absolute components because target weight is [-1,1]
                    vector.setX(Math.max(Math.abs(min[0]), Math.abs(max[0])));
                    vector.setY(Math.max(Math.abs(min[1]), Math.abs(max[1])));
                    vector.setZ(Math.max(Math.abs(min[2]), Math.abs(max[2])));
                    if (accessor.normalized) {
                        const boxScale = $559434fcc6e6401d$var$getNormalizedComponentScale($559434fcc6e6401d$var$WEBGL_COMPONENT_TYPES[accessor.componentType]);
                        vector.multiplyScalar(boxScale);
                    }
                    // Note: this assumes that the sum of all weights is at most 1. This isn't quite correct - it's more conservative
                    // to assume that each target can have a max weight of 1. However, for some use cases - notably, when morph targets
                    // are used to implement key-frame animations and as such only two are active at a time - this results in very large
                    // boxes. So for now we make a box that's sometimes a touch too small but is hopefully mostly of reasonable size.
                    maxDisplacement.max(vector);
                } else console.warn('THREE.GLTFLoader: Missing min/max properties for accessor POSITION.');
            }
        }
        // As per comment above this box isn't conservative, but has a reasonable size for a very large number of morph targets.
        box.expandByVector(maxDisplacement);
    }
    geometry.boundingBox = box;
    const sphere = new (0, $dyjou.Sphere)();
    box.getCenter(sphere.center);
    sphere.radius = box.min.distanceTo(box.max) / 2;
    geometry.boundingSphere = sphere;
}
/**
 *
 * @private
 * @param {BufferGeometry} geometry
 * @param {GLTF.Primitive} primitiveDef
 * @param {GLTFParser} parser
 * @return {Promise<BufferGeometry>}
 */ function $559434fcc6e6401d$var$addPrimitiveAttributes(geometry, primitiveDef, parser) {
    const attributes = primitiveDef.attributes;
    const pending = [];
    function assignAttributeAccessor(accessorIndex, attributeName) {
        return parser.getDependency('accessor', accessorIndex).then(function(accessor) {
            geometry.setAttribute(attributeName, accessor);
        });
    }
    for(const gltfAttributeName in attributes){
        const threeAttributeName = $559434fcc6e6401d$var$ATTRIBUTES[gltfAttributeName] || gltfAttributeName.toLowerCase();
        // Skip attributes already provided by e.g. Draco extension.
        if (threeAttributeName in geometry.attributes) continue;
        pending.push(assignAttributeAccessor(attributes[gltfAttributeName], threeAttributeName));
    }
    if (primitiveDef.indices !== undefined && !geometry.index) {
        const accessor = parser.getDependency('accessor', primitiveDef.indices).then(function(accessor) {
            geometry.setIndex(accessor);
        });
        pending.push(accessor);
    }
    if ((0, $dyjou.ColorManagement).workingColorSpace !== (0, $dyjou.LinearSRGBColorSpace) && 'COLOR_0' in attributes) console.warn(`THREE.GLTFLoader: Converting vertex colors from "srgb-linear" to "${(0, $dyjou.ColorManagement).workingColorSpace}" not supported.`);
    $559434fcc6e6401d$var$assignExtrasToUserData(geometry, primitiveDef);
    $559434fcc6e6401d$var$computeBounds(geometry, primitiveDef, parser);
    return Promise.all(pending).then(function() {
        return primitiveDef.targets !== undefined ? $559434fcc6e6401d$var$addMorphTargets(geometry, primitiveDef.targets, parser) : geometry;
    });
}





var $dyjou = parcelRequire("dyjou");parcelRequire("ilwiq");
var $dyjou = parcelRequire("dyjou");
/** @module CopyShader */ /**
 * Full-screen copy shader pass.
 *
 * @constant
 * @type {ShaderMaterial~Shader}
 */ const $2f93ac2d46312da9$export$57f84a24a9a6130d = {
    name: 'CopyShader',
    uniforms: {
        'tDiffuse': {
            value: null
        },
        'opacity': {
            value: 1.0
        }
    },
    vertexShader: /* glsl */ `

		varying vec2 vUv;

		void main() {

			vUv = uv;
			gl_Position = projectionMatrix * modelViewMatrix * vec4( position, 1.0 );

		}`,
    fragmentShader: /* glsl */ `

		uniform float opacity;

		uniform sampler2D tDiffuse;

		varying vec2 vUv;

		void main() {

			vec4 texel = texture2D( tDiffuse, vUv );
			gl_FragColor = opacity * texel;


		}`
};


parcelRequire("ilwiq");
var $dyjou = parcelRequire("dyjou");
parcelRequire("ilwiq");
var $dyjou = parcelRequire("dyjou");
var $dyjou = parcelRequire("dyjou");
/**
 * Abstract base class for all post processing passes.
 *
 * This module is only relevant for post processing with {@link WebGLRenderer}.
 *
 * @abstract
 */ class $0a1d3a5a6a49de03$export$802bc10488da99c7 {
    /**
	 * Constructs a new pass.
	 */ constructor(){
        /**
		 * This flag can be used for type testing.
		 *
		 * @type {boolean}
		 * @readonly
		 * @default true
		 */ this.isPass = true;
        /**
		 * If set to `true`, the pass is processed by the composer.
		 *
		 * @type {boolean}
		 * @default true
		 */ this.enabled = true;
        /**
		 * If set to `true`, the pass indicates to swap read and write buffer after rendering.
		 *
		 * @type {boolean}
		 * @default true
		 */ this.needsSwap = true;
        /**
		 * If set to `true`, the pass clears its buffer before rendering
		 *
		 * @type {boolean}
		 * @default false
		 */ this.clear = false;
        /**
		 * If set to `true`, the result of the pass is rendered to screen. The last pass in the composers
		 * pass chain gets automatically rendered to screen, no matter how this property is configured.
		 *
		 * @type {boolean}
		 * @default false
		 */ this.renderToScreen = false;
    }
    /**
	 * Sets the size of the pass.
	 *
	 * @abstract
	 * @param {number} width - The width to set.
	 * @param {number} height - The width to set.
	 */ setSize() {}
    /**
	 * This method holds the render logic of a pass. It must be implemented in all derived classes.
	 *
	 * @abstract
	 * @param {WebGLRenderer} renderer - The renderer.
	 * @param {WebGLRenderTarget} writeBuffer - The write buffer. This buffer is intended as the rendering
	 * destination for the pass.
	 * @param {WebGLRenderTarget} readBuffer - The read buffer. The pass can access the result from the
	 * previous pass from this buffer.
	 * @param {number} deltaTime - The delta time in seconds.
	 * @param {boolean} maskActive - Whether masking is active or not.
	 */ render() {
        console.error('THREE.Pass: .render() must be implemented in derived pass.');
    }
    /**
	 * Frees the GPU-related resources allocated by this instance. Call this
	 * method whenever the pass is no longer used in your app.
	 *
	 * @abstract
	 */ dispose() {}
}
// Helper for passes that need to fill the viewport with a single quad.
const $0a1d3a5a6a49de03$var$_camera = new (0, $dyjou.OrthographicCamera)(-1, 1, 1, -1, 0, 1);
// https://github.com/mrdoob/three.js/pull/21358
class $0a1d3a5a6a49de03$var$FullscreenTriangleGeometry extends (0, $dyjou.BufferGeometry) {
    constructor(){
        super();
        this.setAttribute('position', new (0, $dyjou.Float32BufferAttribute)([
            -1,
            3,
            0,
            -1,
            -1,
            0,
            3,
            -1,
            0
        ], 3));
        this.setAttribute('uv', new (0, $dyjou.Float32BufferAttribute)([
            0,
            2,
            0,
            0,
            2,
            0
        ], 2));
    }
}
const $0a1d3a5a6a49de03$var$_geometry = new $0a1d3a5a6a49de03$var$FullscreenTriangleGeometry();
/**
 * This module is a helper for passes which need to render a full
 * screen effect which is quite common in context of post processing.
 *
 * The intended usage is to reuse a single full screen quad for rendering
 * subsequent passes by just reassigning the `material` reference.
 *
 * This module can only be used with {@link WebGLRenderer}.
 *
 * @augments Mesh
 */ class $0a1d3a5a6a49de03$export$3983474c8e6e978b {
    /**
	 * Constructs a new full screen quad.
	 *
	 * @param {?Material} material - The material to render te full screen quad with.
	 */ constructor(material){
        this._mesh = new (0, $dyjou.Mesh)($0a1d3a5a6a49de03$var$_geometry, material);
    }
    /**
	 * Frees the GPU-related resources allocated by this instance. Call this
	 * method whenever the instance is no longer used in your app.
	 */ dispose() {
        this._mesh.geometry.dispose();
    }
    /**
	 * Renders the full screen quad.
	 *
	 * @param {WebGLRenderer} renderer - The renderer.
	 */ render(renderer) {
        renderer.render(this._mesh, $0a1d3a5a6a49de03$var$_camera);
    }
    /**
	 * The quad's material.
	 *
	 * @type {?Material}
	 */ get material() {
        return this._mesh.material;
    }
    set material(value) {
        this._mesh.material = value;
    }
}


/**
 * This pass can be used to create a post processing effect
 * with a raw GLSL shader object. Useful for implementing custom
 * effects.
 *
 * ```js
 * const fxaaPass = new ShaderPass( FXAAShader );
 * composer.addPass( fxaaPass );
 * ```
 *
 * @augments Pass
 */ class $6ac47a3de6300e1f$export$c55093fd4f9e42f0 extends (0, $0a1d3a5a6a49de03$export$802bc10488da99c7) {
    /**
	 * Constructs a new shader pass.
	 *
	 * @param {Object|ShaderMaterial} [shader] - A shader object holding vertex and fragment shader as well as
	 * defines and uniforms. It's also valid to pass a custom shader material.
	 * @param {string} [textureID='tDiffuse'] - The name of the texture uniform that should sample
	 * the read buffer.
	 */ constructor(shader, textureID = 'tDiffuse'){
        super();
        /**
		 * The name of the texture uniform that should sample the read buffer.
		 *
		 * @type {string}
		 * @default 'tDiffuse'
		 */ this.textureID = textureID;
        /**
		 * The pass uniforms.
		 *
		 * @type {?Object}
		 */ this.uniforms = null;
        /**
		 * The pass material.
		 *
		 * @type {?ShaderMaterial}
		 */ this.material = null;
        if (shader instanceof (0, $dyjou.ShaderMaterial)) {
            this.uniforms = shader.uniforms;
            this.material = shader;
        } else if (shader) {
            this.uniforms = (0, $dyjou.UniformsUtils).clone(shader.uniforms);
            this.material = new (0, $dyjou.ShaderMaterial)({
                name: shader.name !== undefined ? shader.name : 'unspecified',
                defines: Object.assign({}, shader.defines),
                uniforms: this.uniforms,
                vertexShader: shader.vertexShader,
                fragmentShader: shader.fragmentShader
            });
        }
        // internals
        this._fsQuad = new (0, $0a1d3a5a6a49de03$export$3983474c8e6e978b)(this.material);
    }
    /**
	 * Performs the shader pass.
	 *
	 * @param {WebGLRenderer} renderer - The renderer.
	 * @param {WebGLRenderTarget} writeBuffer - The write buffer. This buffer is intended as the rendering
	 * destination for the pass.
	 * @param {WebGLRenderTarget} readBuffer - The read buffer. The pass can access the result from the
	 * previous pass from this buffer.
	 * @param {number} deltaTime - The delta time in seconds.
	 * @param {boolean} maskActive - Whether masking is active or not.
	 */ render(renderer, writeBuffer, readBuffer /*, deltaTime, maskActive */ ) {
        if (this.uniforms[this.textureID]) this.uniforms[this.textureID].value = readBuffer.texture;
        this._fsQuad.material = this.material;
        if (this.renderToScreen) {
            renderer.setRenderTarget(null);
            this._fsQuad.render(renderer);
        } else {
            renderer.setRenderTarget(writeBuffer);
            // TODO: Avoid using autoClear properties, see https://github.com/mrdoob/three.js/pull/15571#issuecomment-465669600
            if (this.clear) renderer.clear(renderer.autoClearColor, renderer.autoClearDepth, renderer.autoClearStencil);
            this._fsQuad.render(renderer);
        }
    }
    /**
	 * Frees the GPU-related resources allocated by this instance. Call this
	 * method whenever the pass is no longer used in your app.
	 */ dispose() {
        this.material.dispose();
        this._fsQuad.dispose();
    }
}



/**
 * This pass can be used to define a mask during post processing.
 * Meaning only areas of subsequent post processing are affected
 * which lie in the masking area of this pass. Internally, the masking
 * is implemented with the stencil buffer.
 *
 * ```js
 * const maskPass = new MaskPass( scene, camera );
 * composer.addPass( maskPass );
 * ```
 *
 * @augments Pass
 */ class $0f4907a355572481$export$bb424a4005d6dde0 extends (0, $0a1d3a5a6a49de03$export$802bc10488da99c7) {
    /**
	 * Constructs a new mask pass.
	 *
	 * @param {Scene} scene - The 3D objects in this scene will define the mask.
	 * @param {Camera} camera - The camera.
	 */ constructor(scene, camera){
        super();
        /**
		 * The scene that defines the mask.
		 *
		 * @type {Scene}
		 */ this.scene = scene;
        /**
		 * The camera.
		 *
		 * @type {Camera}
		 */ this.camera = camera;
        /**
		 * Overwritten to perform a clear operation by default.
		 *
		 * @type {boolean}
		 * @default true
		 */ this.clear = true;
        /**
		 * Overwritten to disable the swap.
		 *
		 * @type {boolean}
		 * @default false
		 */ this.needsSwap = false;
        /**
		 * Whether to inverse the mask or not.
		 *
		 * @type {boolean}
		 * @default false
		 */ this.inverse = false;
    }
    /**
	 * Performs a mask pass with the configured scene and camera.
	 *
	 * @param {WebGLRenderer} renderer - The renderer.
	 * @param {WebGLRenderTarget} writeBuffer - The write buffer. This buffer is intended as the rendering
	 * destination for the pass.
	 * @param {WebGLRenderTarget} readBuffer - The read buffer. The pass can access the result from the
	 * previous pass from this buffer.
	 * @param {number} deltaTime - The delta time in seconds.
	 * @param {boolean} maskActive - Whether masking is active or not.
	 */ render(renderer, writeBuffer, readBuffer /*, deltaTime, maskActive */ ) {
        const context = renderer.getContext();
        const state = renderer.state;
        // don't update color or depth
        state.buffers.color.setMask(false);
        state.buffers.depth.setMask(false);
        // lock buffers
        state.buffers.color.setLocked(true);
        state.buffers.depth.setLocked(true);
        // set up stencil
        let writeValue, clearValue;
        if (this.inverse) {
            writeValue = 0;
            clearValue = 1;
        } else {
            writeValue = 1;
            clearValue = 0;
        }
        state.buffers.stencil.setTest(true);
        state.buffers.stencil.setOp(context.REPLACE, context.REPLACE, context.REPLACE);
        state.buffers.stencil.setFunc(context.ALWAYS, writeValue, 0xffffffff);
        state.buffers.stencil.setClear(clearValue);
        state.buffers.stencil.setLocked(true);
        // draw into the stencil buffer
        renderer.setRenderTarget(readBuffer);
        if (this.clear) renderer.clear();
        renderer.render(this.scene, this.camera);
        renderer.setRenderTarget(writeBuffer);
        if (this.clear) renderer.clear();
        renderer.render(this.scene, this.camera);
        // unlock color and depth buffer and make them writable for subsequent rendering/clearing
        state.buffers.color.setLocked(false);
        state.buffers.depth.setLocked(false);
        state.buffers.color.setMask(true);
        state.buffers.depth.setMask(true);
        // only render where stencil is set to 1
        state.buffers.stencil.setLocked(false);
        state.buffers.stencil.setFunc(context.EQUAL, 1, 0xffffffff); // draw if == 1
        state.buffers.stencil.setOp(context.KEEP, context.KEEP, context.KEEP);
        state.buffers.stencil.setLocked(true);
    }
}
/**
 * This pass can be used to clear a mask previously defined with {@link MaskPass}.
 *
 * ```js
 * const clearPass = new ClearMaskPass();
 * composer.addPass( clearPass );
 * ```
 *
 * @augments Pass
 */ class $0f4907a355572481$export$8d8650aed29c6251 extends (0, $0a1d3a5a6a49de03$export$802bc10488da99c7) {
    /**
	 * Constructs a new clear mask pass.
	 */ constructor(){
        super();
        /**
		 * Overwritten to disable the swap.
		 *
		 * @type {boolean}
		 * @default false
		 */ this.needsSwap = false;
    }
    /**
	 * Performs the clear of the currently defined mask.
	 *
	 * @param {WebGLRenderer} renderer - The renderer.
	 * @param {WebGLRenderTarget} writeBuffer - The write buffer. This buffer is intended as the rendering
	 * destination for the pass.
	 * @param {WebGLRenderTarget} readBuffer - The read buffer. The pass can access the result from the
	 * previous pass from this buffer.
	 * @param {number} deltaTime - The delta time in seconds.
	 * @param {boolean} maskActive - Whether masking is active or not.
	 */ render(renderer /*, writeBuffer, readBuffer, deltaTime, maskActive */ ) {
        renderer.state.buffers.stencil.setLocked(false);
        renderer.state.buffers.stencil.setTest(false);
    }
}


/**
 * Used to implement post-processing effects in three.js.
 * The class manages a chain of post-processing passes to produce the final visual result.
 * Post-processing passes are executed in order of their addition/insertion.
 * The last pass is automatically rendered to screen.
 *
 * This module can only be used with {@link WebGLRenderer}.
 *
 * ```js
 * const composer = new EffectComposer( renderer );
 *
 * // adding some passes
 * const renderPass = new RenderPass( scene, camera );
 * composer.addPass( renderPass );
 *
 * const glitchPass = new GlitchPass();
 * composer.addPass( glitchPass );
 *
 * const outputPass = new OutputPass()
 * composer.addPass( outputPass );
 *
 * function animate() {
 *
 * 	composer.render(); // instead of renderer.render()
 *
 * }
 * ```
 */ class $1f89f80dfbd5e815$export$7fe01e6ab8aa748c {
    /**
	 * Constructs a new effect composer.
	 *
	 * @param {WebGLRenderer} renderer - The renderer.
	 * @param {WebGLRenderTarget} [renderTarget] - This render target and a clone will
	 * be used as the internal read and write buffers. If not given, the composer creates
	 * the buffers automatically.
	 */ constructor(renderer, renderTarget){
        /**
		 * The renderer.
		 *
		 * @type {WebGLRenderer}
		 */ this.renderer = renderer;
        this._pixelRatio = renderer.getPixelRatio();
        if (renderTarget === undefined) {
            const size = renderer.getSize(new (0, $dyjou.Vector2)());
            this._width = size.width;
            this._height = size.height;
            renderTarget = new (0, $dyjou.WebGLRenderTarget)(this._width * this._pixelRatio, this._height * this._pixelRatio, {
                type: (0, $dyjou.HalfFloatType)
            });
            renderTarget.texture.name = 'EffectComposer.rt1';
        } else {
            this._width = renderTarget.width;
            this._height = renderTarget.height;
        }
        this.renderTarget1 = renderTarget;
        this.renderTarget2 = renderTarget.clone();
        this.renderTarget2.texture.name = 'EffectComposer.rt2';
        /**
		 * A reference to the internal write buffer. Passes usually write
		 * their result into this buffer.
		 *
		 * @type {WebGLRenderTarget}
		 */ this.writeBuffer = this.renderTarget1;
        /**
		 * A reference to the internal read buffer. Passes usually read
		 * the previous render result from this buffer.
		 *
		 * @type {WebGLRenderTarget}
		 */ this.readBuffer = this.renderTarget2;
        /**
		 * Whether the final pass is rendered to the screen (default framebuffer) or not.
		 *
		 * @type {boolean}
		 * @default true
		 */ this.renderToScreen = true;
        /**
		 * An array representing the (ordered) chain of post-processing passes.
		 *
		 * @type {Array<Pass>}
		 */ this.passes = [];
        /**
		 * A copy pass used for internal swap operations.
		 *
		 * @private
		 * @type {ShaderPass}
		 */ this.copyPass = new (0, $6ac47a3de6300e1f$export$c55093fd4f9e42f0)((0, $2f93ac2d46312da9$export$57f84a24a9a6130d));
        this.copyPass.material.blending = (0, $dyjou.NoBlending);
        /**
		 * The intenral clock for managing time data.
		 *
		 * @private
		 * @type {Clock}
		 */ this.clock = new (0, $dyjou.Clock)();
    }
    /**
	 * Swaps the internal read/write buffers.
	 */ swapBuffers() {
        const tmp = this.readBuffer;
        this.readBuffer = this.writeBuffer;
        this.writeBuffer = tmp;
    }
    /**
	 * Adds the given pass to the pass chain.
	 *
	 * @param {Pass} pass - The pass to add.
	 */ addPass(pass) {
        this.passes.push(pass);
        pass.setSize(this._width * this._pixelRatio, this._height * this._pixelRatio);
    }
    /**
	 * Inserts the given pass at a given index.
	 *
	 * @param {Pass} pass - The pass to insert.
	 * @param {number} index - The index into the pass chain.
	 */ insertPass(pass, index) {
        this.passes.splice(index, 0, pass);
        pass.setSize(this._width * this._pixelRatio, this._height * this._pixelRatio);
    }
    /**
	 * Removes the given pass from the pass chain.
	 *
	 * @param {Pass} pass - The pass to remove.
	 */ removePass(pass) {
        const index = this.passes.indexOf(pass);
        if (index !== -1) this.passes.splice(index, 1);
    }
    /**
	 * Returns `true` if the pass for the given index is the last enabled pass in the pass chain.
	 *
	 * @param {number} passIndex - The pass index.
	 * @return {boolean} Whether the the pass for the given index is the last pass in the pass chain.
	 */ isLastEnabledPass(passIndex) {
        for(let i = passIndex + 1; i < this.passes.length; i++){
            if (this.passes[i].enabled) return false;
        }
        return true;
    }
    /**
	 * Executes all enabled post-processing passes in order to produce the final frame.
	 *
	 * @param {number} deltaTime - The delta time in seconds. If not given, the composer computes
	 * its own time delta value.
	 */ render(deltaTime) {
        // deltaTime value is in seconds
        if (deltaTime === undefined) deltaTime = this.clock.getDelta();
        const currentRenderTarget = this.renderer.getRenderTarget();
        let maskActive = false;
        for(let i = 0, il = this.passes.length; i < il; i++){
            const pass = this.passes[i];
            if (pass.enabled === false) continue;
            pass.renderToScreen = this.renderToScreen && this.isLastEnabledPass(i);
            pass.render(this.renderer, this.writeBuffer, this.readBuffer, deltaTime, maskActive);
            if (pass.needsSwap) {
                if (maskActive) {
                    const context = this.renderer.getContext();
                    const stencil = this.renderer.state.buffers.stencil;
                    //context.stencilFunc( context.NOTEQUAL, 1, 0xffffffff );
                    stencil.setFunc(context.NOTEQUAL, 1, 0xffffffff);
                    this.copyPass.render(this.renderer, this.writeBuffer, this.readBuffer, deltaTime);
                    //context.stencilFunc( context.EQUAL, 1, 0xffffffff );
                    stencil.setFunc(context.EQUAL, 1, 0xffffffff);
                }
                this.swapBuffers();
            }
            if ((0, $0f4907a355572481$export$bb424a4005d6dde0) !== undefined) {
                if (pass instanceof (0, $0f4907a355572481$export$bb424a4005d6dde0)) maskActive = true;
                else if (pass instanceof (0, $0f4907a355572481$export$8d8650aed29c6251)) maskActive = false;
            }
        }
        this.renderer.setRenderTarget(currentRenderTarget);
    }
    /**
	 * Resets the internal state of the EffectComposer.
	 *
	 * @param {WebGLRenderTarget} [renderTarget] - This render target has the same purpose like
	 * the one from the constructor. If set, it is used to setup the read and write buffers.
	 */ reset(renderTarget) {
        if (renderTarget === undefined) {
            const size = this.renderer.getSize(new (0, $dyjou.Vector2)());
            this._pixelRatio = this.renderer.getPixelRatio();
            this._width = size.width;
            this._height = size.height;
            renderTarget = this.renderTarget1.clone();
            renderTarget.setSize(this._width * this._pixelRatio, this._height * this._pixelRatio);
        }
        this.renderTarget1.dispose();
        this.renderTarget2.dispose();
        this.renderTarget1 = renderTarget;
        this.renderTarget2 = renderTarget.clone();
        this.writeBuffer = this.renderTarget1;
        this.readBuffer = this.renderTarget2;
    }
    /**
	 * Resizes the internal read and write buffers as well as all passes. Similar to {@link WebGLRenderer#setSize},
	 * this method honors the current pixel ration.
	 *
	 * @param {number} width - The width in logical pixels.
	 * @param {number} height - The height in logical pixels.
	 */ setSize(width, height) {
        this._width = width;
        this._height = height;
        const effectiveWidth = this._width * this._pixelRatio;
        const effectiveHeight = this._height * this._pixelRatio;
        this.renderTarget1.setSize(effectiveWidth, effectiveHeight);
        this.renderTarget2.setSize(effectiveWidth, effectiveHeight);
        for(let i = 0; i < this.passes.length; i++)this.passes[i].setSize(effectiveWidth, effectiveHeight);
    }
    /**
	 * Sets device pixel ratio. This is usually used for HiDPI device to prevent blurring output.
	 * Setting the pixel ratio will automatically resize the composer.
	 *
	 * @param {number} pixelRatio - The pixel ratio to set.
	 */ setPixelRatio(pixelRatio) {
        this._pixelRatio = pixelRatio;
        this.setSize(this._width, this._height);
    }
    /**
	 * Frees the GPU-related resources allocated by this instance. Call this
	 * method whenever the composer is no longer used in your app.
	 */ dispose() {
        this.renderTarget1.dispose();
        this.renderTarget2.dispose();
        this.copyPass.dispose();
    }
}


parcelRequire("ilwiq");
var $dyjou = parcelRequire("dyjou");

/**
 * This class represents a render pass. It takes a camera and a scene and produces
 * a beauty pass for subsequent post processing effects.
 *
 * ```js
 * const renderPass = new RenderPass( scene, camera );
 * composer.addPass( renderPass );
 * ```
 *
 * @augments Pass
 */ class $f4d3a60efece63cd$export$f63ea822f020b5b0 extends (0, $0a1d3a5a6a49de03$export$802bc10488da99c7) {
    /**
	 * Constructs a new render pass.
	 *
	 * @param {Scene} scene - The scene to render.
	 * @param {Camera} camera - The camera.
	 * @param {?Material} [overrideMaterial=null] - The override material. If set, this material is used
	 * for all objects in the scene.
	 * @param {?(number|Color|string)} [clearColor=null] - The clear color of the render pass.
	 * @param {?number} [clearAlpha=null] - The clear alpha of the render pass.
	 */ constructor(scene, camera, overrideMaterial = null, clearColor = null, clearAlpha = null){
        super();
        /**
		 * The scene to render.
		 *
		 * @type {Scene}
		 */ this.scene = scene;
        /**
		 * The camera.
		 *
		 * @type {Camera}
		 */ this.camera = camera;
        /**
		 * The override material. If set, this material is used
		 * for all objects in the scene.
		 *
		 * @type {?Material}
		 * @default null
		 */ this.overrideMaterial = overrideMaterial;
        /**
		 * The clear color of the render pass.
		 *
		 * @type {?(number|Color|string)}
		 * @default null
		 */ this.clearColor = clearColor;
        /**
		 * The clear alpha of the render pass.
		 *
		 * @type {?number}
		 * @default null
		 */ this.clearAlpha = clearAlpha;
        /**
		 * Overwritten to perform a clear operation by default.
		 *
		 * @type {boolean}
		 * @default true
		 */ this.clear = true;
        /**
		 * If set to `true`, only the depth can be cleared when `clear` is to `false`.
		 *
		 * @type {boolean}
		 * @default false
		 */ this.clearDepth = false;
        /**
		 * Overwritten to disable the swap.
		 *
		 * @type {boolean}
		 * @default false
		 */ this.needsSwap = false;
        this._oldClearColor = new (0, $dyjou.Color)();
    }
    /**
	 * Performs a beauty pass with the configured scene and camera.
	 *
	 * @param {WebGLRenderer} renderer - The renderer.
	 * @param {WebGLRenderTarget} writeBuffer - The write buffer. This buffer is intended as the rendering
	 * destination for the pass.
	 * @param {WebGLRenderTarget} readBuffer - The read buffer. The pass can access the result from the
	 * previous pass from this buffer.
	 * @param {number} deltaTime - The delta time in seconds.
	 * @param {boolean} maskActive - Whether masking is active or not.
	 */ render(renderer, writeBuffer, readBuffer /*, deltaTime, maskActive */ ) {
        const oldAutoClear = renderer.autoClear;
        renderer.autoClear = false;
        let oldClearAlpha, oldOverrideMaterial;
        if (this.overrideMaterial !== null) {
            oldOverrideMaterial = this.scene.overrideMaterial;
            this.scene.overrideMaterial = this.overrideMaterial;
        }
        if (this.clearColor !== null) {
            renderer.getClearColor(this._oldClearColor);
            renderer.setClearColor(this.clearColor, renderer.getClearAlpha());
        }
        if (this.clearAlpha !== null) {
            oldClearAlpha = renderer.getClearAlpha();
            renderer.setClearAlpha(this.clearAlpha);
        }
        if (this.clearDepth == true) renderer.clearDepth();
        renderer.setRenderTarget(this.renderToScreen ? null : readBuffer);
        if (this.clear === true) // TODO: Avoid using autoClear properties, see https://github.com/mrdoob/three.js/pull/15571#issuecomment-465669600
        renderer.clear(renderer.autoClearColor, renderer.autoClearDepth, renderer.autoClearStencil);
        renderer.render(this.scene, this.camera);
        // restore
        if (this.clearColor !== null) renderer.setClearColor(this._oldClearColor);
        if (this.clearAlpha !== null) renderer.setClearAlpha(oldClearAlpha);
        if (this.overrideMaterial !== null) this.scene.overrideMaterial = oldOverrideMaterial;
        renderer.autoClear = oldAutoClear;
    }
}


parcelRequire("ilwiq");
var $dyjou = parcelRequire("dyjou");


parcelRequire("ilwiq");
var $dyjou = parcelRequire("dyjou");
/** @module LuminosityHighPassShader */ /**
 * Luminosity high pass shader.
 *
 * @constant
 * @type {ShaderMaterial~Shader}
 */ const $a034d2d59dd75b4e$export$30029d01c9072e8b = {
    name: 'LuminosityHighPassShader',
    uniforms: {
        'tDiffuse': {
            value: null
        },
        'luminosityThreshold': {
            value: 1.0
        },
        'smoothWidth': {
            value: 1.0
        },
        'defaultColor': {
            value: new (0, $dyjou.Color)(0x000000)
        },
        'defaultOpacity': {
            value: 0.0
        }
    },
    vertexShader: /* glsl */ `

		varying vec2 vUv;

		void main() {

			vUv = uv;

			gl_Position = projectionMatrix * modelViewMatrix * vec4( position, 1.0 );

		}`,
    fragmentShader: /* glsl */ `

		uniform sampler2D tDiffuse;
		uniform vec3 defaultColor;
		uniform float defaultOpacity;
		uniform float luminosityThreshold;
		uniform float smoothWidth;

		varying vec2 vUv;

		void main() {

			vec4 texel = texture2D( tDiffuse, vUv );

			float v = luminance( texel.xyz );

			vec4 outputColor = vec4( defaultColor.rgb, defaultOpacity );

			float alpha = smoothstep( luminosityThreshold, luminosityThreshold + smoothWidth, v );

			gl_FragColor = mix( outputColor, texel, alpha );

		}`
};


/**
 * This pass is inspired by the bloom pass of Unreal Engine. It creates a
 * mip map chain of bloom textures and blurs them with different radii. Because
 * of the weighted combination of mips, and because larger blurs are done on
 * higher mips, this effect provides good quality and performance.
 *
 * When using this pass, tone mapping must be enabled in the renderer settings.
 *
 * Reference:
 * - [Bloom in Unreal Engine]{@link https://docs.unrealengine.com/latest/INT/Engine/Rendering/PostProcessEffects/Bloom/}
 *
 * ```js
 * const resolution = new THREE.Vector2( window.innerWidth, window.innerHeight );
 * const bloomPass = new UnrealBloomPass( resolution, 1.5, 0.4, 0.85 );
 * composer.addPass( bloomPass );
 * ```
 *
 * @augments Pass
 */ class $ca010d9f34e35dc3$export$d4d608c865617544 extends (0, $0a1d3a5a6a49de03$export$802bc10488da99c7) {
    /**
	 * Constructs a new Unreal Bloom pass.
	 *
	 * @param {Vector2} [resolution] - The effect's resolution.
	 * @param {number} [strength=1] - The Bloom strength.
	 * @param {number} radius - The Bloom radius.
	 * @param {number} threshold - The luminance threshold limits which bright areas contribute to the Bloom effect.
	 */ constructor(resolution, strength = 1, radius, threshold){
        super();
        /**
		 * The Bloom strength.
		 *
		 * @type {number}
		 * @default 1
		 */ this.strength = strength;
        /**
		 * The Bloom radius.
		 *
		 * @type {number}
		 */ this.radius = radius;
        /**
		 * The luminance threshold limits which bright areas contribute to the Bloom effect.
		 *
		 * @type {number}
		 */ this.threshold = threshold;
        /**
		 * The effect's resolution.
		 *
		 * @type {Vector2}
		 * @default (256,256)
		 */ this.resolution = resolution !== undefined ? new (0, $dyjou.Vector2)(resolution.x, resolution.y) : new (0, $dyjou.Vector2)(256, 256);
        /**
		 * The effect's clear color
		 *
		 * @type {Color}
		 * @default (0,0,0)
		 */ this.clearColor = new (0, $dyjou.Color)(0, 0, 0);
        /**
		 * Overwritten to disable the swap.
		 *
		 * @type {boolean}
		 * @default false
		 */ this.needsSwap = false;
        // internals
        // render targets
        this.renderTargetsHorizontal = [];
        this.renderTargetsVertical = [];
        this.nMips = 5;
        let resx = Math.round(this.resolution.x / 2);
        let resy = Math.round(this.resolution.y / 2);
        this.renderTargetBright = new (0, $dyjou.WebGLRenderTarget)(resx, resy, {
            type: (0, $dyjou.HalfFloatType)
        });
        this.renderTargetBright.texture.name = 'UnrealBloomPass.bright';
        this.renderTargetBright.texture.generateMipmaps = false;
        for(let i = 0; i < this.nMips; i++){
            const renderTargetHorizontal = new (0, $dyjou.WebGLRenderTarget)(resx, resy, {
                type: (0, $dyjou.HalfFloatType)
            });
            renderTargetHorizontal.texture.name = 'UnrealBloomPass.h' + i;
            renderTargetHorizontal.texture.generateMipmaps = false;
            this.renderTargetsHorizontal.push(renderTargetHorizontal);
            const renderTargetVertical = new (0, $dyjou.WebGLRenderTarget)(resx, resy, {
                type: (0, $dyjou.HalfFloatType)
            });
            renderTargetVertical.texture.name = 'UnrealBloomPass.v' + i;
            renderTargetVertical.texture.generateMipmaps = false;
            this.renderTargetsVertical.push(renderTargetVertical);
            resx = Math.round(resx / 2);
            resy = Math.round(resy / 2);
        }
        // luminosity high pass material
        const highPassShader = (0, $a034d2d59dd75b4e$export$30029d01c9072e8b);
        this.highPassUniforms = (0, $dyjou.UniformsUtils).clone(highPassShader.uniforms);
        this.highPassUniforms['luminosityThreshold'].value = threshold;
        this.highPassUniforms['smoothWidth'].value = 0.01;
        this.materialHighPassFilter = new (0, $dyjou.ShaderMaterial)({
            uniforms: this.highPassUniforms,
            vertexShader: highPassShader.vertexShader,
            fragmentShader: highPassShader.fragmentShader
        });
        // gaussian blur materials
        this.separableBlurMaterials = [];
        const kernelSizeArray = [
            3,
            5,
            7,
            9,
            11
        ];
        resx = Math.round(this.resolution.x / 2);
        resy = Math.round(this.resolution.y / 2);
        for(let i = 0; i < this.nMips; i++){
            this.separableBlurMaterials.push(this._getSeparableBlurMaterial(kernelSizeArray[i]));
            this.separableBlurMaterials[i].uniforms['invSize'].value = new (0, $dyjou.Vector2)(1 / resx, 1 / resy);
            resx = Math.round(resx / 2);
            resy = Math.round(resy / 2);
        }
        // composite material
        this.compositeMaterial = this._getCompositeMaterial(this.nMips);
        this.compositeMaterial.uniforms['blurTexture1'].value = this.renderTargetsVertical[0].texture;
        this.compositeMaterial.uniforms['blurTexture2'].value = this.renderTargetsVertical[1].texture;
        this.compositeMaterial.uniforms['blurTexture3'].value = this.renderTargetsVertical[2].texture;
        this.compositeMaterial.uniforms['blurTexture4'].value = this.renderTargetsVertical[3].texture;
        this.compositeMaterial.uniforms['blurTexture5'].value = this.renderTargetsVertical[4].texture;
        this.compositeMaterial.uniforms['bloomStrength'].value = strength;
        this.compositeMaterial.uniforms['bloomRadius'].value = 0.1;
        const bloomFactors = [
            1.0,
            0.8,
            0.6,
            0.4,
            0.2
        ];
        this.compositeMaterial.uniforms['bloomFactors'].value = bloomFactors;
        this.bloomTintColors = [
            new (0, $dyjou.Vector3)(1, 1, 1),
            new (0, $dyjou.Vector3)(1, 1, 1),
            new (0, $dyjou.Vector3)(1, 1, 1),
            new (0, $dyjou.Vector3)(1, 1, 1),
            new (0, $dyjou.Vector3)(1, 1, 1)
        ];
        this.compositeMaterial.uniforms['bloomTintColors'].value = this.bloomTintColors;
        // blend material
        this.copyUniforms = (0, $dyjou.UniformsUtils).clone((0, $2f93ac2d46312da9$export$57f84a24a9a6130d).uniforms);
        this.blendMaterial = new (0, $dyjou.ShaderMaterial)({
            uniforms: this.copyUniforms,
            vertexShader: (0, $2f93ac2d46312da9$export$57f84a24a9a6130d).vertexShader,
            fragmentShader: (0, $2f93ac2d46312da9$export$57f84a24a9a6130d).fragmentShader,
            blending: (0, $dyjou.AdditiveBlending),
            depthTest: false,
            depthWrite: false,
            transparent: true
        });
        this._oldClearColor = new (0, $dyjou.Color)();
        this._oldClearAlpha = 1;
        this._basic = new (0, $dyjou.MeshBasicMaterial)();
        this._fsQuad = new (0, $0a1d3a5a6a49de03$export$3983474c8e6e978b)(null);
    }
    /**
	 * Frees the GPU-related resources allocated by this instance. Call this
	 * method whenever the pass is no longer used in your app.
	 */ dispose() {
        for(let i = 0; i < this.renderTargetsHorizontal.length; i++)this.renderTargetsHorizontal[i].dispose();
        for(let i = 0; i < this.renderTargetsVertical.length; i++)this.renderTargetsVertical[i].dispose();
        this.renderTargetBright.dispose();
        //
        for(let i = 0; i < this.separableBlurMaterials.length; i++)this.separableBlurMaterials[i].dispose();
        this.compositeMaterial.dispose();
        this.blendMaterial.dispose();
        this._basic.dispose();
        //
        this._fsQuad.dispose();
    }
    /**
	 * Sets the size of the pass.
	 *
	 * @param {number} width - The width to set.
	 * @param {number} height - The width to set.
	 */ setSize(width, height) {
        let resx = Math.round(width / 2);
        let resy = Math.round(height / 2);
        this.renderTargetBright.setSize(resx, resy);
        for(let i = 0; i < this.nMips; i++){
            this.renderTargetsHorizontal[i].setSize(resx, resy);
            this.renderTargetsVertical[i].setSize(resx, resy);
            this.separableBlurMaterials[i].uniforms['invSize'].value = new (0, $dyjou.Vector2)(1 / resx, 1 / resy);
            resx = Math.round(resx / 2);
            resy = Math.round(resy / 2);
        }
    }
    /**
	 * Performs the Bloom pass.
	 *
	 * @param {WebGLRenderer} renderer - The renderer.
	 * @param {WebGLRenderTarget} writeBuffer - The write buffer. This buffer is intended as the rendering
	 * destination for the pass.
	 * @param {WebGLRenderTarget} readBuffer - The read buffer. The pass can access the result from the
	 * previous pass from this buffer.
	 * @param {number} deltaTime - The delta time in seconds.
	 * @param {boolean} maskActive - Whether masking is active or not.
	 */ render(renderer, writeBuffer, readBuffer, deltaTime, maskActive) {
        renderer.getClearColor(this._oldClearColor);
        this._oldClearAlpha = renderer.getClearAlpha();
        const oldAutoClear = renderer.autoClear;
        renderer.autoClear = false;
        renderer.setClearColor(this.clearColor, 0);
        if (maskActive) renderer.state.buffers.stencil.setTest(false);
        // Render input to screen
        if (this.renderToScreen) {
            this._fsQuad.material = this._basic;
            this._basic.map = readBuffer.texture;
            renderer.setRenderTarget(null);
            renderer.clear();
            this._fsQuad.render(renderer);
        }
        // 1. Extract Bright Areas
        this.highPassUniforms['tDiffuse'].value = readBuffer.texture;
        this.highPassUniforms['luminosityThreshold'].value = this.threshold;
        this._fsQuad.material = this.materialHighPassFilter;
        renderer.setRenderTarget(this.renderTargetBright);
        renderer.clear();
        this._fsQuad.render(renderer);
        // 2. Blur All the mips progressively
        let inputRenderTarget = this.renderTargetBright;
        for(let i = 0; i < this.nMips; i++){
            this._fsQuad.material = this.separableBlurMaterials[i];
            this.separableBlurMaterials[i].uniforms['colorTexture'].value = inputRenderTarget.texture;
            this.separableBlurMaterials[i].uniforms['direction'].value = $ca010d9f34e35dc3$export$d4d608c865617544.BlurDirectionX;
            renderer.setRenderTarget(this.renderTargetsHorizontal[i]);
            renderer.clear();
            this._fsQuad.render(renderer);
            this.separableBlurMaterials[i].uniforms['colorTexture'].value = this.renderTargetsHorizontal[i].texture;
            this.separableBlurMaterials[i].uniforms['direction'].value = $ca010d9f34e35dc3$export$d4d608c865617544.BlurDirectionY;
            renderer.setRenderTarget(this.renderTargetsVertical[i]);
            renderer.clear();
            this._fsQuad.render(renderer);
            inputRenderTarget = this.renderTargetsVertical[i];
        }
        // Composite All the mips
        this._fsQuad.material = this.compositeMaterial;
        this.compositeMaterial.uniforms['bloomStrength'].value = this.strength;
        this.compositeMaterial.uniforms['bloomRadius'].value = this.radius;
        this.compositeMaterial.uniforms['bloomTintColors'].value = this.bloomTintColors;
        renderer.setRenderTarget(this.renderTargetsHorizontal[0]);
        renderer.clear();
        this._fsQuad.render(renderer);
        // Blend it additively over the input texture
        this._fsQuad.material = this.blendMaterial;
        this.copyUniforms['tDiffuse'].value = this.renderTargetsHorizontal[0].texture;
        if (maskActive) renderer.state.buffers.stencil.setTest(true);
        if (this.renderToScreen) {
            renderer.setRenderTarget(null);
            this._fsQuad.render(renderer);
        } else {
            renderer.setRenderTarget(readBuffer);
            this._fsQuad.render(renderer);
        }
        // Restore renderer settings
        renderer.setClearColor(this._oldClearColor, this._oldClearAlpha);
        renderer.autoClear = oldAutoClear;
    }
    // internals
    _getSeparableBlurMaterial(kernelRadius) {
        const coefficients = [];
        for(let i = 0; i < kernelRadius; i++)coefficients.push(0.39894 * Math.exp(-0.5 * i * i / (kernelRadius * kernelRadius)) / kernelRadius);
        return new (0, $dyjou.ShaderMaterial)({
            defines: {
                'KERNEL_RADIUS': kernelRadius
            },
            uniforms: {
                'colorTexture': {
                    value: null
                },
                'invSize': {
                    value: new (0, $dyjou.Vector2)(0.5, 0.5)
                },
                'direction': {
                    value: new (0, $dyjou.Vector2)(0.5, 0.5)
                },
                'gaussianCoefficients': {
                    value: coefficients
                } // precomputed Gaussian coefficients
            },
            vertexShader: `varying vec2 vUv;
				void main() {
					vUv = uv;
					gl_Position = projectionMatrix * modelViewMatrix * vec4( position, 1.0 );
				}`,
            fragmentShader: `#include <common>
				varying vec2 vUv;
				uniform sampler2D colorTexture;
				uniform vec2 invSize;
				uniform vec2 direction;
				uniform float gaussianCoefficients[KERNEL_RADIUS];

				void main() {
					float weightSum = gaussianCoefficients[0];
					vec3 diffuseSum = texture2D( colorTexture, vUv ).rgb * weightSum;
					for( int i = 1; i < KERNEL_RADIUS; i ++ ) {
						float x = float(i);
						float w = gaussianCoefficients[i];
						vec2 uvOffset = direction * invSize * x;
						vec3 sample1 = texture2D( colorTexture, vUv + uvOffset ).rgb;
						vec3 sample2 = texture2D( colorTexture, vUv - uvOffset ).rgb;
						diffuseSum += (sample1 + sample2) * w;
						weightSum += 2.0 * w;
					}
					gl_FragColor = vec4(diffuseSum/weightSum, 1.0);
				}`
        });
    }
    _getCompositeMaterial(nMips) {
        return new (0, $dyjou.ShaderMaterial)({
            defines: {
                'NUM_MIPS': nMips
            },
            uniforms: {
                'blurTexture1': {
                    value: null
                },
                'blurTexture2': {
                    value: null
                },
                'blurTexture3': {
                    value: null
                },
                'blurTexture4': {
                    value: null
                },
                'blurTexture5': {
                    value: null
                },
                'bloomStrength': {
                    value: 1.0
                },
                'bloomFactors': {
                    value: null
                },
                'bloomTintColors': {
                    value: null
                },
                'bloomRadius': {
                    value: 0.0
                }
            },
            vertexShader: `varying vec2 vUv;
				void main() {
					vUv = uv;
					gl_Position = projectionMatrix * modelViewMatrix * vec4( position, 1.0 );
				}`,
            fragmentShader: `varying vec2 vUv;
				uniform sampler2D blurTexture1;
				uniform sampler2D blurTexture2;
				uniform sampler2D blurTexture3;
				uniform sampler2D blurTexture4;
				uniform sampler2D blurTexture5;
				uniform float bloomStrength;
				uniform float bloomRadius;
				uniform float bloomFactors[NUM_MIPS];
				uniform vec3 bloomTintColors[NUM_MIPS];

				float lerpBloomFactor(const in float factor) {
					float mirrorFactor = 1.2 - factor;
					return mix(factor, mirrorFactor, bloomRadius);
				}

				void main() {
					gl_FragColor = bloomStrength * ( lerpBloomFactor(bloomFactors[0]) * vec4(bloomTintColors[0], 1.0) * texture2D(blurTexture1, vUv) +
						lerpBloomFactor(bloomFactors[1]) * vec4(bloomTintColors[1], 1.0) * texture2D(blurTexture2, vUv) +
						lerpBloomFactor(bloomFactors[2]) * vec4(bloomTintColors[2], 1.0) * texture2D(blurTexture3, vUv) +
						lerpBloomFactor(bloomFactors[3]) * vec4(bloomTintColors[3], 1.0) * texture2D(blurTexture4, vUv) +
						lerpBloomFactor(bloomFactors[4]) * vec4(bloomTintColors[4], 1.0) * texture2D(blurTexture5, vUv) );
				}`
        });
    }
}
$ca010d9f34e35dc3$export$d4d608c865617544.BlurDirectionX = new (0, $dyjou.Vector2)(1.0, 0.0);
$ca010d9f34e35dc3$export$d4d608c865617544.BlurDirectionY = new (0, $dyjou.Vector2)(0.0, 1.0);


/**
 * @copyright 2013 Sonia Keys
 * @copyright 2016 commenthol
 * @license MIT
 * @module angle
 */ /**
 * Angle: Chapter 17: Angular Separation.
 *
 * Functions in this package are useful for Ecliptic, Equatorial, or any
 * similar coordinate frame.  To avoid suggestion of a particular frame,
 * function parameters are specified simply as "r1, d1" to correspond to a
 * right ascenscion, declination pair or to a longitude, latitude pair.
 *
 * In function Sep, Meeus recommends 10 arc min as a threshold.  This
 * value is in package base as base.SmallAngle because it has general utility.
 *
 * All angles are in radians.
 */ 
var $9QpM5 = parcelRequire("9QpM5");
/**
 * @copyright 2013 Sonia Keys
 * @copyright 2016 commenthol
 * @license MIT
 * @module interpolation
 */ /**
 * Interp: Chapter 3, Interpolation.
 *
 * Len3 and Len5 types
 *
 * These types allow interpolation from a table of equidistant x values
 * and corresponding y values.  Since the x values are equidistant,
 * only the first and last values are supplied as arguments to the
 * constructors.  The interior x values are implicit.  All y values must be
 * supplied however.  They are passed as a slice, and the length of y is fixed.
 * For Len3 it must be 3 and for (Len5 it must be 5.0
 *
 * For these Len3 and Len5 functions, Meeus notes the importance of choosing
 * the 3 or 5 rows of a larger table that will minimize the interpolating
 * factor n.  He does not provide algorithms for doing this however.
 *
 * For an example of a selection function, see len3ForInterpolateX. This
 * was useful for computing Delta T.
 */ 
var $9QpM5 = parcelRequire("9QpM5");
const $7480a29e66a7d324$var$int = Math.trunc;
const $7480a29e66a7d324$export$f182dcc1bb694892 = new Error('Argument y must be length 3');
const $7480a29e66a7d324$export$695377deec4e418c = new Error('Argument y must be length 4');
const $7480a29e66a7d324$export$297e50313eb4589 = new Error('Argument y must be length 5');
const $7480a29e66a7d324$export$3f599669cb6314bb = new Error('Argument x3 (or x5) cannot equal x1');
const $7480a29e66a7d324$export$476b3a724b078f00 = new Error('Interpolating factor n must be in range -1 to 1');
const $7480a29e66a7d324$export$dac4d0dc3708da4c = new Error('No extremum in table');
const $7480a29e66a7d324$export$781cf8d048e44318 = new Error('Extremum falls outside of table');
const $7480a29e66a7d324$export$b69cf33b51e6fa3e = new Error('Zero falls outside of table');
const $7480a29e66a7d324$export$58661ecec816171c = new Error('Failure to converge');
class $7480a29e66a7d324$export$5380f45c1222ba0f {
    /**
   * NewLen3 prepares a Len3 object from a table of three rows of x and y values.
   *
   * X values must be equally spaced, so only the first and last are supplied.
   * X1 must not equal to x3.  Y must be a slice of three y values.
   *
   * @throws Error
   * @param {Number} x1 - is the x value corresponding to the first y value of the table.
   * @param {Number} x3 - is the x value corresponding to the last y value of the table.
   * @param {Number[]} y - is all y values in the table. y.length should be >= 3.0
   */ constructor(x1, x3, y){
        if (y.length !== 3) throw $7480a29e66a7d324$export$f182dcc1bb694892;
        if (x3 === x1) throw $7480a29e66a7d324$export$3f599669cb6314bb;
        this.x1 = x1;
        this.x3 = x3;
        this.y = y;
        // differences. (3.1) p. 23
        this.a = y[1] - y[0];
        this.b = y[2] - y[1];
        this.c = this.b - this.a;
        // other intermediate values
        this.abSum = this.a + this.b;
        this.xSum = x3 + x1;
        this.xDiff = x3 - x1;
    }
    /**
   * InterpolateX interpolates for a given x value.
   */ interpolateX(x) {
        const n = (2 * x - this.xSum) / this.xDiff;
        return this.interpolateN(n);
    }
    /**
   * InterpolateXStrict interpolates for a given x value,
   * restricting x to the range x1 to x3 given to the constructor NewLen3.
   */ interpolateXStrict(x) {
        const n = (2 * x - this.xSum) / this.xDiff;
        const y = this.interpolateNStrict(n);
        return y;
    }
    /**
   * InterpolateN interpolates for (a given interpolating factor n.
   *
   * This is interpolation formula (3.3)
   *
   * @param n - The interpolation factor n is x-x2 in units of the tabular x interval.
   * (See Meeus p. 24.)
   * @return {number} interpolation value
   */ interpolateN(n) {
        return this.y[1] + n * 0.5 * (this.abSum + n * this.c);
    }
    /**
   * InterpolateNStrict interpolates for (a given interpolating factor n.
   *
   * @param {number} n - n is restricted to the range [-1..1] corresponding to the range x1 to x3
   * given to the constructor of Len3.
   * @return {number} interpolation value
   */ interpolateNStrict(n) {
        if (n < -1 || n > 1) throw $7480a29e66a7d324$export$476b3a724b078f00;
        return this.interpolateN(n);
    }
    /**
   * Extremum returns the x and y values at the extremum.
   *
   * Results are restricted to the range of the table given to the constructor
   * new Len3.
   */ extremum() {
        if (this.c === 0) throw $7480a29e66a7d324$export$dac4d0dc3708da4c;
        const n = this.abSum / (-2 * this.c // (3.5), p. 25
        );
        if (n < -1 || n > 1) throw $7480a29e66a7d324$export$781cf8d048e44318;
        const x = 0.5 * (this.xSum + this.xDiff * n);
        const y = this.y[1] - this.abSum * this.abSum / (8 * this.c // (3.4), p. 25
        );
        return [
            x,
            y
        ];
    }
    /**
   * Len3Zero finds a zero of the quadratic function represented by the table.
   *
   * That is, it returns an x value that yields y=0.
   *
   * Argument strong switches between two strategies for the estimation step.
   * when iterating to converge on the zero.
   *
   * Strong=false specifies a quick and dirty estimate that works well
   * for gentle curves, but can work poorly or fail on more dramatic curves.
   *
   * Strong=true specifies a more sophisticated and thus somewhat more
   * expensive estimate.  However, if the curve has quick changes, This estimate
   * will converge more reliably and in fewer steps, making it a better choice.
   *
   * Results are restricted to the range of the table given to the constructor
   * NewLen3.
   */ zero(strong) {
        let f;
        if (strong) // (3.7), p. 27
        f = (n0)=>{
            return n0 - (2 * this.y[1] + n0 * (this.abSum + this.c * n0)) / (this.abSum + 2 * this.c * n0);
        };
        else // (3.6), p. 26
        f = (n0)=>{
            return -2 * this.y[1] / (this.abSum + this.c * n0);
        };
        const [n0, ok] = $7480a29e66a7d324$export$c1a059043cc9c119(0, f);
        if (!ok) throw $7480a29e66a7d324$export$58661ecec816171c;
        if (n0 > 1 || n0 < -1) throw $7480a29e66a7d324$export$b69cf33b51e6fa3e;
        return 0.5 * (this.xSum + this.xDiff * n0 // success
        );
    }
}
function $7480a29e66a7d324$export$ea110fdee209939f(x, x1, xN, y) {
    let y3 = y;
    if (y.length > 3) {
        const interval = (xN - x1) / (y.length - 1);
        if (interval === 0) throw $7480a29e66a7d324$export$3f599669cb6314bb;
        let nearestX = $7480a29e66a7d324$var$int((x - x1) / interval + 0.5);
        if (nearestX < 1) nearestX = 1;
        else if (nearestX > y.length - 2) nearestX = y.length - 2;
        y3 = y.slice(nearestX - 1, nearestX + 2);
        xN = x1 + (nearestX + 1) * interval;
        x1 = x1 + (nearestX - 1) * interval;
    }
    return new $7480a29e66a7d324$export$5380f45c1222ba0f(x1, xN, y3);
}
const $7480a29e66a7d324$export$c1a059043cc9c119 = function(n0, f) {
    for(let limit = 0; limit < 50; limit++){
        const n1 = f(n0);
        if (!isFinite(n1) || isNaN(n1)) break; // failure to converge
        if (Math.abs((n1 - n0) / n0) < 1e-15) return [
            n1,
            true
        ] // success
        ;
        n0 = n1;
    }
    return [
        0,
        false
    ] // failure to converge
    ;
};
function $7480a29e66a7d324$export$aeee3129190683b7(y) {
    if (y.length !== 4) throw $7480a29e66a7d324$export$695377deec4e418c;
    // (3.12) p. 32
    return (9 * (y[1] + y[2]) - y[0] - y[3]) / 16;
}
class $7480a29e66a7d324$export$2771e25665bf0d3b {
    /**
   * NewLen5 prepares a Len5 object from a table of five rows of x and y values.
   *
   * X values must be equally spaced, so only the first and last are suppliethis.
   * X1 must not equal x5.  Y must be a slice of five y values.
   */ constructor(x1, x5, y){
        if (y.length !== 5) throw $7480a29e66a7d324$export$297e50313eb4589;
        if (x5 === x1) throw $7480a29e66a7d324$export$3f599669cb6314bb;
        this.x1 = x1;
        this.x5 = x5;
        this.y = y;
        this.y3 = y[2];
        // differences
        this.a = y[1] - y[0];
        this.b = y[2] - y[1];
        this.c = y[3] - y[2];
        this.d = y[4] - y[3];
        this.e = this.b - this.a;
        this.f = this.c - this.b;
        this.g = this.d - this.c;
        this.h = this.f - this.e;
        this.j = this.g - this.f;
        this.k = this.j - this.h;
        // other intermediate values
        this.xSum = x5 + x1;
        this.xDiff = x5 - x1;
        this.interpCoeff = [
            this.y3,
            (this.b + this.c) / 2 - (this.h + this.j) / 12,
            this.f / 2 - this.k / 24,
            (this.h + this.j) / 12,
            this.k / 24
        ];
    }
    /**
   * InterpolateX interpolates for (a given x value.
   */ interpolateX(x) {
        const n = (4 * x - 2 * this.xSum) / this.xDiff;
        return this.interpolateN(n);
    }
    /**
   * InterpolateXStrict interpolates for a given x value,
   * restricting x to the range x1 to x5 given to the the constructor NewLen5.
   */ interpolateXStrict(x) {
        const n = (4 * x - 2 * this.xSum) / this.xDiff;
        const y = this.interpolateNStrict(n);
        return y;
    }
    /**
   * InterpolateN interpolates for (a given interpolating factor n.
   *
   * The interpolation factor n is x-x3 in units of the tabular x interval.
   * (See Meeus p. 28.)
   */ interpolateN(n) {
        return (0, $9QpM5.default).horner(n, ...this.interpCoeff);
    }
    /**
   * InterpolateNStrict interpolates for (a given interpolating factor n.
   *
   * N is restricted to the range [-1..1].  This is only half the range given
   * to the constructor NewLen5, but is the recommendation given on p. 31.0
   */ interpolateNStrict(n) {
        if (n < -1 || n > 1) throw $7480a29e66a7d324$export$476b3a724b078f00;
        return (0, $9QpM5.default).horner(n, ...this.interpCoeff);
    }
    /**
   * Extremum returns the x and y values at the extremum.
   *
   * Results are restricted to the range of the table given to the constructor
   * NewLen5.  (Meeus actually recommends restricting the range to one unit of
   * the tabular interval, but that seems a little harsh.)
   */ extremum() {
        // (3.9) p. 29
        const nCoeff = [
            6 * (this.b + this.c) - this.h - this.j,
            0,
            3 * (this.h + this.j),
            2 * this.k
        ];
        const den = this.k - 12 * this.f;
        if (den === 0) throw $7480a29e66a7d324$export$781cf8d048e44318;
        const [n0, ok] = $7480a29e66a7d324$export$c1a059043cc9c119(0, function(n0) {
            return (0, $9QpM5.default).horner(n0, ...nCoeff) / den;
        });
        if (!ok) throw $7480a29e66a7d324$export$58661ecec816171c;
        if (n0 < -2 || n0 > 2) throw $7480a29e66a7d324$export$781cf8d048e44318;
        const x = 0.5 * this.xSum + 0.25 * this.xDiff * n0;
        const y = (0, $9QpM5.default).horner(n0, ...this.interpCoeff);
        return [
            x,
            y
        ];
    }
    /**
   * Len5Zero finds a zero of the quartic function represented by the table.
   *
   * That is, it returns an x value that yields y=0.
   *
   * Argument strong switches between two strategies for the estimation step.
   * when iterating to converge on the zero.
   *
   * Strong=false specifies a quick and dirty estimate that works well
   * for gentle curves, but can work poorly or fail on more dramatic curves.
   *
   * Strong=true specifies a more sophisticated and thus somewhat more
   * expensive estimate.  However, if the curve has quick changes, This estimate
   * will converge more reliably and in fewer steps, making it a better choice.
   *
   * Results are restricted to the range of the table given to the constructor
   * NewLen5.
   */ zero(strong) {
        let f;
        if (strong) {
            // (3.11), p. 29
            const M = this.k / 24;
            const N = (this.h + this.j) / 12;
            const P = this.f / 2 - M;
            const Q = (this.b + this.c) / 2 - N;
            const numCoeff = [
                this.y3,
                Q,
                P,
                N,
                M
            ];
            const denCoeff = [
                Q,
                2 * P,
                3 * N,
                4 * M
            ];
            f = function(n0) {
                return n0 - (0, $9QpM5.default).horner(n0, ...numCoeff) / (0, $9QpM5.default).horner(n0, ...denCoeff);
            };
        } else {
            // (3.10), p. 29
            const numCoeff = [
                -24 * this.y3,
                0,
                this.k - 12 * this.f,
                -2 * (this.h + this.j),
                -this.k
            ];
            const den = 12 * (this.b + this.c) - 2 * (this.h + this.j);
            f = function(n0) {
                return (0, $9QpM5.default).horner(n0, ...numCoeff) / den;
            };
        }
        const [n0, ok] = $7480a29e66a7d324$export$c1a059043cc9c119(0, f);
        if (!ok) throw $7480a29e66a7d324$export$58661ecec816171c;
        if (n0 > 2 || n0 < -2) throw $7480a29e66a7d324$export$b69cf33b51e6fa3e;
        const x = 0.5 * this.xSum + 0.25 * this.xDiff * n0;
        return x;
    }
}
function $7480a29e66a7d324$export$100d6ad808cd347d(x, table) {
    // method of BASIC program, p. 33.0
    let sum = 0;
    table.forEach((ti, i)=>{
        const xi = ti[0];
        let prod = 1.0;
        table.forEach((tj, j)=>{
            if (i !== j) {
                const xj = tj[0];
                prod *= (x - xj) / (xi - xj);
            }
        });
        sum += ti[1] * prod;
    });
    return sum;
}
function $7480a29e66a7d324$export$3ba4f06cd85d3884(table) {
    // Method not fully described by Meeus, but needed for (numerical solution
    // to Example 3.g.
    const sum = new Array(table.length).fill(0);
    const prod = new Array(table.length).fill(0);
    const last = table.length - 1;
    for(let i = 0; i < table.length; i++){
        const xi = table[i][0] || table[i].x || 0;
        const yi = table[i][1] || table[i].y || 0;
        prod[last] = 1;
        let den = 1.0;
        let n = last;
        for(let j = 0; j < table.length; j++)if (i !== j) {
            const xj = table[j][0] || table[j].x || 0;
            prod[n - 1] = prod[n] * -xj;
            for(let k = n; k < last; k++)prod[k] -= prod[k + 1] * xj;
            n--;
            den *= xi - xj;
        }
        prod.forEach((pj, j)=>{
            sum[j] += yi * pj / den;
        });
    }
    return sum;
}
function $7480a29e66a7d324$export$45db2fc2f15997e7(x, x1, xN, y) {
    const interval = (xN - x1) / (y.length - 1);
    if (interval === 0) throw $7480a29e66a7d324$export$3f599669cb6314bb;
    let nearestX = Math.floor((x - x1) / interval);
    if (nearestX < 0) nearestX = 0;
    else if (nearestX > y.length - 2) nearestX = y.length - 2;
    const y2 = y.slice(nearestX, nearestX + 2);
    const x01 = x1 + nearestX * interval;
    return y2[0] + (y[1] - y[0]) * (x - x01) / interval;
}
var $7480a29e66a7d324$export$2e2bcd8739ae039 = {
    errorNot3: $7480a29e66a7d324$export$f182dcc1bb694892,
    errorNot4: $7480a29e66a7d324$export$695377deec4e418c,
    errorNot5: $7480a29e66a7d324$export$297e50313eb4589,
    errorNoXRange: $7480a29e66a7d324$export$3f599669cb6314bb,
    errorNOutOfRange: $7480a29e66a7d324$export$476b3a724b078f00,
    errorNoExtremum: $7480a29e66a7d324$export$dac4d0dc3708da4c,
    errorExtremumOutside: $7480a29e66a7d324$export$781cf8d048e44318,
    errorZeroOutside: $7480a29e66a7d324$export$b69cf33b51e6fa3e,
    errorNoConverge: $7480a29e66a7d324$export$58661ecec816171c,
    Len3: $7480a29e66a7d324$export$5380f45c1222ba0f,
    len3ForInterpolateX: $7480a29e66a7d324$export$ea110fdee209939f,
    iterate: $7480a29e66a7d324$export$c1a059043cc9c119,
    len4Half: $7480a29e66a7d324$export$aeee3129190683b7,
    Len5: $7480a29e66a7d324$export$2771e25665bf0d3b,
    lagrange: $7480a29e66a7d324$export$100d6ad808cd347d,
    lagrangePoly: $7480a29e66a7d324$export$3ba4f06cd85d3884,
    linear: $7480a29e66a7d324$export$45db2fc2f15997e7
};


const { abs: $3992d891b7047db6$var$abs, acos: $3992d891b7047db6$var$acos, asin: $3992d891b7047db6$var$asin, atan2: $3992d891b7047db6$var$atan2, cos: $3992d891b7047db6$var$cos, hypot: $3992d891b7047db6$var$hypot, sin: $3992d891b7047db6$var$sin, sqrt: $3992d891b7047db6$var$sqrt, tan: $3992d891b7047db6$var$tan } = Math;
function $3992d891b7047db6$export$5aee1a5bd9743d8f(c1, c2) {
    const [sind1, cosd1] = (0, $9QpM5.default).sincos(c1.dec);
    const [sind2, cosd2] = (0, $9QpM5.default).sincos(c2.dec);
    const cd = sind1 * sind2 + cosd1 * cosd2 * $3992d891b7047db6$var$cos(c1.ra - c2.ra) // (17.1) p. 109
    ;
    if (cd < (0, $9QpM5.default).CosSmallAngle) return $3992d891b7047db6$var$acos(cd);
    else {
        const cosd = $3992d891b7047db6$var$cos((c2.dec + c1.dec) / 2) // average dec of two bodies
        ;
        return $3992d891b7047db6$var$hypot((c2.ra - c1.ra) * cosd, c2.dec - c1.dec) // (17.2) p. 109
        ;
    }
}
function $3992d891b7047db6$export$dd85433ea0bcefcf(jd1, jd3, cs1, cs2, fnSep) {
    fnSep = fnSep || $3992d891b7047db6$export$5aee1a5bd9743d8f;
    if (cs1.length !== 3 || cs2.length !== 3) throw (0, $7480a29e66a7d324$export$2e2bcd8739ae039).errorNot3;
    const y = new Array(3);
    cs1.forEach((c, x)=>{
        y[x] = $3992d891b7047db6$export$5aee1a5bd9743d8f(cs1[x], cs2[x]);
    });
    const d3 = new (0, $7480a29e66a7d324$export$2e2bcd8739ae039).Len3(jd1, jd3, y);
    const dMin = d3.extremum()[1];
    return dMin;
}
function $3992d891b7047db6$export$14519813f3758b7(jd1, jd3, cs1, cs2) {
    if (cs1.length !== 3 || cs2.length !== 3) throw (0, $7480a29e66a7d324$export$2e2bcd8739ae039).ErrorNot3;
    const uv = function(c1, c2) {
        const [sind1, cosd1] = (0, $9QpM5.default).sincos(c1.dec);
        const \u0394r = c2.ra - c1.ra;
        const tan\u0394r = $3992d891b7047db6$var$tan(\u0394r);
        const tanh\u0394r = $3992d891b7047db6$var$tan(\u0394r / 2);
        const K = 1 / (1 + sind1 * sind1 * tan\u0394r * tanh\u0394r);
        const sin\u0394d = $3992d891b7047db6$var$sin(c2.dec - c1.dec);
        const u = -K * (1 - sind1 / cosd1 * sin\u0394d) * cosd1 * tan\u0394r;
        const v = K * (sin\u0394d + sind1 * cosd1 * tan\u0394r * tanh\u0394r);
        return [
            u,
            v
        ];
    };
    const us = new Array(3).fill(0);
    const vs = new Array(3).fill(0);
    cs1.forEach((c, x)=>{
        [us[x], vs[x]] = uv(cs1[x], cs2[x]);
    });
    const u3 = new (0, $7480a29e66a7d324$export$2e2bcd8739ae039).Len3(-1, 1, us) // if line throws then bug not caller's fault.
    ;
    const v3 = new (0, $7480a29e66a7d324$export$2e2bcd8739ae039).Len3(-1, 1, vs) // if line throws then bug not caller's fault.
    ;
    const up0 = (us[2] - us[0]) / 2;
    const vp0 = (vs[2] - vs[0]) / 2;
    const up1 = us[0] + us[2] - 2 * us[1];
    const vp1 = vs[0] + vs[2] - 2 * vs[1];
    const up = up0;
    const vp = vp0;
    let dn = -(us[1] * up + vs[1] * vp) / (up * up + vp * vp);
    let n = dn;
    let u;
    let v;
    for(let limit = 0; limit < 10; limit++){
        u = u3.interpolateN(n);
        v = v3.interpolateN(n);
        if ($3992d891b7047db6$var$abs(dn) < 1e-5) return $3992d891b7047db6$var$hypot(u, v) // success
        ;
        const up = up0 + n * up1;
        const vp = vp0 + n * vp1;
        dn = -(u * up + v * vp) / (up * up + vp * vp);
        n += dn;
    }
    throw new Error('minSepRect: failure to converge');
}
function $3992d891b7047db6$export$ed10f26d20d83b8e(a) {
    return 0.5 * (1 - Math.cos(a));
}
function $3992d891b7047db6$export$a1c3a945d6d4c5d6(c1, c2) {
    // using (17.5) p. 115
    return 2 * $3992d891b7047db6$var$asin($3992d891b7047db6$var$sqrt($3992d891b7047db6$export$ed10f26d20d83b8e(c2.dec - c1.dec) + $3992d891b7047db6$var$cos(c1.dec) * $3992d891b7047db6$var$cos(c2.dec) * $3992d891b7047db6$export$ed10f26d20d83b8e(c2.ra - c1.ra)));
}
function $3992d891b7047db6$export$46a0f0b2a7a3ac93(jd1, jd3, cs1, cs2) {
    return $3992d891b7047db6$export$dd85433ea0bcefcf(jd1, jd3, cs1, cs2, $3992d891b7047db6$export$a1c3a945d6d4c5d6);
}
function $3992d891b7047db6$export$80e4e138f04cc02(c1, c2) {
    const [sind1, cosd1] = (0, $9QpM5.default).sincos(c1.dec);
    const [sind2, cosd2] = (0, $9QpM5.default).sincos(c2.dec);
    const cosdr = $3992d891b7047db6$var$cos(c2.ra - c1.ra);
    const x = cosd1 * sind2 - sind1 * cosd2 * cosdr;
    const y = cosd2 * $3992d891b7047db6$var$sin(c2.ra - c1.ra);
    const z = sind1 * sind2 + cosd1 * cosd2 * cosdr;
    return $3992d891b7047db6$var$atan2($3992d891b7047db6$var$hypot(x, y), z);
}
function $3992d891b7047db6$export$726b6372323e712f(jd1, jd3, cs1, cs2) {
    return $3992d891b7047db6$export$dd85433ea0bcefcf(jd1, jd3, cs1, cs2, $3992d891b7047db6$export$80e4e138f04cc02);
}
function $3992d891b7047db6$export$11575fec8593cad8(c1, c2) {
    const [sin\u0394r, cos\u0394r] = (0, $9QpM5.default).sincos(c1.ra - c2.ra);
    const [sind2, cosd2] = (0, $9QpM5.default).sincos(c2.dec);
    const p = $3992d891b7047db6$var$atan2(sin\u0394r, cosd2 * $3992d891b7047db6$var$tan(c1.dec) - sind2 * cos\u0394r);
    return p;
}
var $3992d891b7047db6$export$2e2bcd8739ae039 = {
    sep: $3992d891b7047db6$export$5aee1a5bd9743d8f,
    minSep: $3992d891b7047db6$export$dd85433ea0bcefcf,
    minSepRect: $3992d891b7047db6$export$14519813f3758b7,
    hav: $3992d891b7047db6$export$ed10f26d20d83b8e,
    sepHav: $3992d891b7047db6$export$a1c3a945d6d4c5d6,
    minSepHav: $3992d891b7047db6$export$46a0f0b2a7a3ac93,
    sepPauwels: $3992d891b7047db6$export$80e4e138f04cc02,
    minSepPauwels: $3992d891b7047db6$export$726b6372323e712f,
    relativePosition: $3992d891b7047db6$export$11575fec8593cad8
};


/**
 * @copyright 2013 Sonia Keys
 * @copyright 2016 commenthol
 * @license MIT
 * @module apparent
 */ /**
 * Apparent: Chapter 23, Apparent Place of a Star
 */ 
var $9QpM5 = parcelRequire("9QpM5");
/**
 * @copyright 2013 Sonia Keys
 * @copyright 2016 commenthol
 * @license MIT
 * @module coord
 */ /**
 * Coord: Chapter 13, Transformation of Coordinates.
 *
 * Transforms in this package are provided in two forms, function and method.
 * The results of the two forms should be identical.
 *
 * The function forms pass all arguments and results as single values.  These
 * forms are best used when you are transforming a single pair of coordinates
 * and wish to avoid memory allocation.
 *
 * The method forms take and return pointers to structs.  These forms are best
 * used when you are transforming multiple coordinates and can reuse one or
 * more of the structs.  In this case reuse of structs will minimize
 * allocations, and the struct pointers will pass more efficiently on the
 * stack.  These methods transform their arguments, placing the result in
 * the receiver.  The receiver is then returned for convenience.
 *
 * A number of the functions take sine and cosine of the obliquity of the
 * ecliptic.  This becomes an advantage when you doing multiple transformations
 * with the same obliquity.  The efficiency of computing sine and cosine once
 * and reuse these values far outweighs the overhead of passing one number as
 * opposed to two.
 */ 
var $9QpM5 = parcelRequire("9QpM5");
/**
 * @copyright 2013 Sonia Keys
 * @copyright 2016 commenthol
 * @license MIT
 * @module sexagesimal
 */ /**
 * Sexagesimal functions
 */ /**
 * Angle represents a general purpose angle.
 * Unit is radians.
 */ class $c953199d551a315b$export$6cdc1cb9345ffadf {
    /**
  * constructs a new Angle value from sign, degree, minute, and second
  * components.
  * @param {Number|Boolean} angleOrNeg - angle in radians or sign, true if negative (required to attribute -0°30')
  * __Four arguments__
  * @param {Number} [d] - (int) degree
  * @param {Number} [m] - (int) minute
  * @param {Number} [s] - (float) second
  */ constructor(angleOrNeg, d, m, s){
        if (arguments.length === 1) this.angle = Number(angleOrNeg);
        else this.setDMS(!!angleOrNeg, d, m, s);
    }
    /**
   * SetDMS sets the value of an FAngle from sign, degree, minute, and second
   * components.
   * The receiver is returned as a convenience.
   * @param {Boolean} neg - sign, true if negative
   * @param {Number} d - (int) degree
   * @param {Number} m - (int) minute
   * @param {Number} s - (float) second
   * @returns {Angle}
   */ setDMS(neg = false, d = 0, m = 0, s = 0.0) {
        this.angle = $c953199d551a315b$export$673e5ba61b194b70(neg, d, m, s) * Math.PI / 180;
        return this;
    }
    /**
   * sets angle
   * @param {Number} angle - (float) angle in radians
   * @returns {Angle}
   */ setAngle(angle) {
        this.angle = angle;
        return this;
    }
    /**
   * Rad returns the angle in radians.
   * @returns {Number} angle in radians
   */ rad() {
        return this.angle;
    }
    /**
   * Deg returns the angle in degrees.
   * @returns {Number} angle in degree
   */ deg() {
        return this.angle * 180 / Math.PI;
    }
    /**
   * toDMS converts to parsed sexagesimal angle component.
   */ toDMS() {
        return $c953199d551a315b$export$9725769da854c713(this.deg());
    }
    /**
   * Print angle in degree using `d°m´s.ss″`
   * @param {Number} [precision] - precision of `s.ss`
   * @returns {String}
   */ toString(precision) {
        let [neg, d, m, s] = this.toDMS();
        s = $c953199d551a315b$var$round(s, precision).toString().replace(/^0\./, '.');
        const str = (neg ? '-' : '') + (d + "\xb0") + (m + "\u2032") + (s + "\u2033");
        return str;
    }
    /**
   * Print angle in degree using `d°.ff`
   * @param {Number} [precision] - precision of `.ff`
   * @returns {String}
   */ toDegString(precision) {
        let [i, s] = $c953199d551a315b$var$modf(this.deg());
        s = $c953199d551a315b$var$round(s, precision).toString().replace(/^0\./, '.');
        const str = i + "\xb0" + s;
        return str;
    }
}
class $c953199d551a315b$export$cdffa68f256807f6 extends $c953199d551a315b$export$6cdc1cb9345ffadf {
    /**
   * NewHourAngle constructs a new HourAngle value from sign, hour, minute,
   * and second components.
   * @param {Boolean} neg
   * @param {Number} h - (int)
   * @param {Number} m - (int)
   * @param {Number} s - (float)
   * @constructor
   */ /**
   * SetDMS sets the value of an FAngle from sign, degree, minute, and second
   * components.
   * The receiver is returned as a convenience.
   * @param {Boolean} neg - sign, true if negative
   * @param {Number} h - (int) hour
   * @param {Number} m - (int) minute
   * @param {Number} s - (float) second
   * @returns {Angle}
   */ setDMS(neg = false, h = 0, m = 0, s = 0.0) {
        this.angle = $c953199d551a315b$export$673e5ba61b194b70(neg, h, m, s) * 15 * Math.PI / 180;
        return this;
    }
    /**
   * Hour returns the hour angle as hours of time.
   * @returns hour angle
   */ hour() {
        return this.angle * 12 / Math.PI // 12 = 180 / 15
        ;
    }
    deg() {
        return this.hour();
    }
    /**
   * Print angle in `HʰMᵐs.ssˢ`
   * @param {Number} precision - precision of `s.ss`
   * @returns {String}
   */ toString(precision) {
        let [neg, h, m, s] = this.toDMS();
        s = $c953199d551a315b$var$round(s, precision).toString().replace(/^0\./, '.');
        const str = (neg ? '-' : '') + (h + "\u02B0") + (m + "\u1D50") + (s + "\u02E2");
        return str;
    }
}
function $c953199d551a315b$export$673e5ba61b194b70(neg, d, m, s) {
    s = ((d * 60 + m) * 60 + s) / 3600;
    if (neg) return -s;
    return s;
}
function $c953199d551a315b$export$9725769da854c713(deg) {
    const neg = deg < 0;
    deg = Math.abs(deg);
    let [d, s] = $c953199d551a315b$var$modf(deg % 360);
    const [m, s1] = $c953199d551a315b$var$modf(s * 60);
    s = $c953199d551a315b$var$round(s1 * 60) // may introduce an error < 1e13
    ;
    return [
        neg,
        d,
        m,
        s
    ];
}
class $c953199d551a315b$export$3824ffa54b14cedf extends $c953199d551a315b$export$cdffa68f256807f6 {
    /**
   * constructs a new RA value from hour, minute, and second components.
   * Negative values are not supported, RA wraps values larger than 24
   * to the range [0,24) hours.
   * @param {Number} h - (int) hour
   * @param {Number} m - (int) minute
   * @param {Number} s - (float) second
   */ constructor(h = 0, m = 0, s = 0){
        super(false, h, m, s);
        const args = [].slice.call(arguments);
        if (args.length === 1) this.angle = h;
        else {
            const hr = $c953199d551a315b$export$673e5ba61b194b70(false, h, m, s) % 24;
            this.angle = hr * 15 * Math.PI / 180;
        }
    }
    hour() {
        const h = this.angle * 12 / Math.PI;
        return (24 + h % 24) % 24;
    }
}
class $c953199d551a315b$export$680ea196effce5f {
    /**
   * @param {boolean|number} negOrTimeInSecs - set `true` if negative; if type is number than time in seconds
   * @param {number} [h] - (int) hour
   * @param {number} [m] - (int) minute
   * @param {number} [s] - (float) second
   * @example
   * new sexa.Time(SECS_OF_DAY)
   * new sexa.Time(false, 15, 22, 7)
   */ constructor(negOrTimeInSecs, h, m, s){
        if (typeof negOrTimeInSecs === 'number') this.time = negOrTimeInSecs;
        else this.setHMS(negOrTimeInSecs, h, m, s);
    }
    setHMS(neg = false, h = 0, m = 0, s = 0) {
        s += (h * 60 + m) * 60;
        if (neg) s = -s;
        this.time = s;
    }
    /**
   * @returns {Number} time in seconds.
   */ sec() {
        return this.time;
    }
    /**
   * @returns {Number} time in minutes.
   */ min() {
        return this.time / 60;
    }
    /**
   * @returns {Number} time in hours.
   */ hour() {
        return this.time / 3600;
    }
    /**
   * @returns {Number} time in days.
   */ day() {
        return this.time / 3600 / 24;
    }
    /**
   * @returns {Number} time in radians, where 1 day = 2 Pi radians.
   */ rad() {
        return this.time * Math.PI / 12 / 3600;
    }
    /**
   * convert time to HMS
   * @returns {Array} [neg, h, m, s]
   *  {Boolean} neg - sign, true if negative
   *  {Number} h - (int) hour
   *  {Number} m - (int) minute
   *  {Number} s - (float) second
   */ toHMS() {
        let t = this.time;
        const neg = t < 0;
        t = neg ? -t : t;
        const h = Math.trunc(t / 3600);
        t = t - h * 3600;
        const m = Math.trunc(t / 60);
        const s = t - m * 60;
        return [
            neg,
            h,
            m,
            s
        ];
    }
    /**
   * Print time using `HʰMᵐsˢ.ss`
   * @param {Number} precision - precision of `.ss`
   * @returns {String}
   */ toString(precision) {
        const [neg, h, m, s] = this.toHMS();
        let [si, sf] = $c953199d551a315b$var$modf(s);
        if (precision === 0) {
            si = $c953199d551a315b$var$round(s, 0);
            sf = 0;
        } else sf = $c953199d551a315b$var$round(sf, precision).toString().substr(1);
        const str = (neg ? '-' : '') + (h + "\u02B0") + (m + "\u1D50") + (si + "\u02E2") + (sf || '');
        return str;
    }
}
const $c953199d551a315b$export$26bdfa58ecfaff90 = (deg)=>deg * Math.PI / 180;
const $c953199d551a315b$export$94030e221002073d = (min)=>min / 60 * Math.PI / 180;
const $c953199d551a315b$export$67aac8c0853e8fb0 = (sec)=>sec / 3600 * Math.PI / 180;
const $c953199d551a315b$export$6b19d8b56c11dd92 = (angle)=>angle * 180 / Math.PI;
const $c953199d551a315b$export$2bdf5e57dd62b164 = (angle)=>angle * 648000 / Math.PI;
const $c953199d551a315b$export$64fdd440378dae22 = (ha)=>ha * 43200 / Math.PI;
/**
 * separate fix `i` from fraction `f`
 * @private
 * @param {Number} float
 * @returns {Array} [i, f]
 *  {Number} i - (int) fix value
 *  {Number} f - (float) fractional portion; always > 1
 */ function $c953199d551a315b$var$modf(float) {
    const i = Math.trunc(float);
    const f = Math.abs(float - i);
    return [
        i,
        f
    ];
}
/**
 * Rounds `float` value by precision
 * @private
 * @param {Number} float - value to round
 * @param {Number} [precision] - (int) number of post decimal positions
 * @return {Number} rounded `float`
 */ function $c953199d551a315b$var$round(float, precision = 10) {
    return parseFloat(float.toFixed(precision));
}
var $c953199d551a315b$export$2e2bcd8739ae039 = {
    Angle: $c953199d551a315b$export$6cdc1cb9345ffadf,
    HourAngle: $c953199d551a315b$export$cdffa68f256807f6,
    DMSToDeg: $c953199d551a315b$export$673e5ba61b194b70,
    degToDMS: $c953199d551a315b$export$9725769da854c713,
    RA: $c953199d551a315b$export$3824ffa54b14cedf,
    Time: $c953199d551a315b$export$680ea196effce5f,
    angleFromDeg: $c953199d551a315b$export$26bdfa58ecfaff90,
    angleFromMin: $c953199d551a315b$export$94030e221002073d,
    angleFromSec: $c953199d551a315b$export$67aac8c0853e8fb0,
    degFromAngle: $c953199d551a315b$export$6b19d8b56c11dd92,
    secFromAngle: $c953199d551a315b$export$2bdf5e57dd62b164,
    secFromHourAngle: $c953199d551a315b$export$64fdd440378dae22
};


/**
 * @copyright 2013 Sonia Keys
 * @copyright 2016 commenthol
 * @license MIT
 * @module globe
 */ /**
 * Globe: Chapter 11, The Earth's Globe.
 *
 * Globe contains functions concerning the surface of the Earth idealized as
 * an ellipsoid of revolution.
 */ /**
 * Ellipsoid represents an ellipsoid of revolution. */ class $4901b270ff8bc2d1$export$edfc7dc0e9336c5b {
    /**
   * @param {number} radius - equatorial radius
   * @param {number} flat - ellipsiod flattening
   */ constructor(radius, flat){
        this.radius = radius;
        this.flat = flat;
    }
    /** A is a common identifier for equatorial radius. */ A() {
        return this.radius;
    }
    /** B is a common identifier for polar radius. */ B() {
        return this.radius * (1 - this.flat);
    }
    /** eccentricity of a meridian. */ eccentricity() {
        return Math.sqrt((2 - this.flat) * this.flat);
    }
    /**
   * parallaxConstants computes parallax constants ρ sin φ′ and ρ cos φ′.
   *
   * Arguments are geographic latitude φ in radians and height h
   * in meters above the ellipsoid.
   *
   * @param {number} φ - geographic latitude in radians
   * @param {number} h - height in meters above the ellipsoid
   * @return {number[]} [ρ sin φ′, ρ cos φ] parallax constants [ρsφ, ρcφ]
   */ parallaxConstants(\u03C6, h) {
        const boa = 1 - this.flat;
        const su = Math.sin(Math.atan(boa * Math.tan(\u03C6)));
        const cu = Math.cos(Math.atan(boa * Math.tan(\u03C6)));
        const s = Math.sin(\u03C6);
        const c = Math.cos(\u03C6);
        const hoa = h * 1e-3 / this.radius;
        // (s, c float)
        const \u03C1s\u03C6 = su * boa + hoa * s;
        const \u03C1c\u03C6 = cu + hoa * c;
        return [
            \u03C1s\u03C6,
            \u03C1c\u03C6
        ];
    }
    /**
   * rho is distance from Earth center to a point on the ellipsoid.
   *
   * Result unit is fraction of the equatorial radius.
   * @param {number} φ - geographic latitude in radians
   * @returns {number} // TODO
   */ rho(\u03C6) {
        // Magic numbers...
        return 0.9983271 + 0.0016764 * Math.cos(2 * \u03C6) - 0.0000035 * Math.cos(4 * \u03C6);
    }
    /**
   * radiusAtLatitude returns the radius of the circle that is the parallel of
   * latitude at φ.
   *
   * Result unit is Km.
   *
   * @param {number} φ
   * @return {number} radius in km
   */ radiusAtLatitude(\u03C6) {
        const s = Math.sin(\u03C6);
        const c = Math.cos(\u03C6);
        return this.A() * c / Math.sqrt(1 - (2 - this.flat) * this.flat * s * s);
    }
    /**
   * radiusOfCurvature of meridian at latitude φ.
   *
   * Result unit is Km.
   *
   * @param {number} φ
   * @return {number} radius in km
   */ radiusOfCurvature(\u03C6) {
        const s = Math.sin(\u03C6);
        const e2 = (2 - this.flat) * this.flat;
        return this.A() * (1 - e2) / Math.pow(1 - e2 * s * s, 1.5);
    }
    /**
   * distance is distance between two points measured along the surface
   * of an ellipsoid.
   *
   * Accuracy is much better than that of approxAngularDistance or
   * approxLinearDistance.
   *
   * Result unit is Km.
   *
   * @param {Coord} c1
   * @param {Coord} c2
   * @return {number} radius in km
   */ distance(c1, c2) {
        // From AA, ch 11, p 84.
        const [s2f, c2f] = $4901b270ff8bc2d1$var$sincos2((c1.lat + c2.lat) / 2);
        const [s2g, c2g] = $4901b270ff8bc2d1$var$sincos2((c1.lat - c2.lat) / 2);
        const [s2\u03BB, c2\u03BB] = $4901b270ff8bc2d1$var$sincos2((c1.lon - c2.lon) / 2);
        const s = s2g * c2\u03BB + c2f * s2\u03BB;
        const c = c2g * c2\u03BB + s2f * s2\u03BB;
        const \u03C9 = Math.atan(Math.sqrt(s / c));
        const r = Math.sqrt(s * c) / \u03C9;
        const d = 2 * \u03C9 * this.radius;
        const h1 = (3 * r - 1) / (2 * c);
        const h2 = (3 * r + 1) / (2 * s);
        return d * (1 + this.flat * (h1 * s2f * c2g - h2 * c2f * s2g));
    }
}
const $4901b270ff8bc2d1$export$be47bce284b266 = new $4901b270ff8bc2d1$export$edfc7dc0e9336c5b(6378.14, 1 / 298.257);
const $4901b270ff8bc2d1$export$ce0376f6e59c4a37 = 7.292114992e-5 // eslint-disable-line camelcase
;
function $4901b270ff8bc2d1$export$47b19c868233b888(rp) {
    return rp * Math.PI / 180;
}
function $4901b270ff8bc2d1$export$8f88c5293120f0be(rm) {
    return rm * Math.PI / 180;
}
function $4901b270ff8bc2d1$export$ddcdf76730592ff1(\u03C6) {
    // This appears to be an approximation with hard coded magic numbers.
    // No explanation is given in the text. The ellipsoid is not specified.
    // Perhaps the approximation works well enough for all ellipsoids?
    return (692.73 * Math.sin(2 * \u03C6) - 1.16 * Math.sin(4 * \u03C6)) * Math.PI / 648000;
}
class $4901b270ff8bc2d1$export$5e2392d12cf9f46 {
    /**
   * @param {number} lat - latitude (φ) in radians
   * @param {number} lon - longitude (ψ, or L) in radians (measured positively westward)
   */ constructor(lat = 0, lon = 0){
        this.lat = lat;
        this.lon = lon;
    }
}
function $4901b270ff8bc2d1$export$394cebf691306a54(p1, p2) {
    const s1 = Math.sin(p1.lat);
    const c1 = Math.cos(p1.lat);
    const s2 = Math.sin(p2.lat);
    const c2 = Math.cos(p2.lat);
    return s1 * s2 + c1 * c2 * Math.cos(p1.lon - p2.lon);
}
function $4901b270ff8bc2d1$export$8a4b3514c4818273(d) {
    return 6371 * d;
}
/**
 * @private
 */ function $4901b270ff8bc2d1$var$sincos2(x) {
    const s = Math.sin(x);
    const c = Math.cos(x);
    return [
        s * s,
        c * c
    ];
}
var $4901b270ff8bc2d1$export$2e2bcd8739ae039 = {
    Ellipsoid: $4901b270ff8bc2d1$export$edfc7dc0e9336c5b,
    Earth76: $4901b270ff8bc2d1$export$be47bce284b266,
    RotationRate1996_5: // eslint-disable-next-line camelcase
    $4901b270ff8bc2d1$export$ce0376f6e59c4a37,
    oneDegreeOfLongitude: $4901b270ff8bc2d1$export$47b19c868233b888,
    oneDegreeOfLatitude: $4901b270ff8bc2d1$export$8f88c5293120f0be,
    geocentricLatitudeDifference: $4901b270ff8bc2d1$export$ddcdf76730592ff1,
    Coord: $4901b270ff8bc2d1$export$5e2392d12cf9f46,
    approxAngularDistance: $4901b270ff8bc2d1$export$394cebf691306a54,
    approxLinearDistance: $4901b270ff8bc2d1$export$8a4b3514c4818273
};


class $77f14e36e565e56c$export$c98da9fa25580f41 {
    /**
   * IMPORTANT: Longitudes are measured *positively* westwards
   * e.g. Washington D.C. +77°04; Vienna -16°23'
   * @param {Number|LonLat} [lon] - Longitude (λ) in radians
   * @param {Number} [lat] - Latitude (β) in radians
   */ constructor(lon, lat){
        if (typeof lon === 'object') {
            lat = lon.lat;
            lon = lon.lon;
        }
        this.lon = lon || 0;
        this.lat = lat || 0;
    }
    /**
   * converts ecliptic coordinates to equatorial coordinates.
   * @param {Number} ε - Obliquity
   * @returns {Equatorial}
   */ toEquatorial(\u03B5) {
        const [\u03B5sin, \u03B5cos] = (0, $9QpM5.default).sincos(\u03B5);
        const [s\u03B2, c\u03B2] = (0, $9QpM5.default).sincos(this.lat);
        const [s\u03BB, c\u03BB] = (0, $9QpM5.default).sincos(this.lon);
        let ra = Math.atan2(s\u03BB * \u03B5cos - s\u03B2 / c\u03B2 * \u03B5sin, c\u03BB) // (13.3) p. 93
        ;
        if (ra < 0) ra += 2 * Math.PI;
        const dec = Math.asin(s\u03B2 * \u03B5cos + c\u03B2 * \u03B5sin * s\u03BB) // (13.4) p. 93
        ;
        return new $77f14e36e565e56c$export$64805cef36012871(ra, dec);
    }
}
class $77f14e36e565e56c$export$64805cef36012871 {
    /**
   * @param {Number} ra - (float) Right ascension (α) in radians
   * @param {Number} dec - (float) Declination (δ) in radians
   */ constructor(ra = 0, dec = 0){
        this.ra = ra;
        this.dec = dec;
    }
    /**
   * EqToEcl converts equatorial coordinates to ecliptic coordinates.
   * @param {Number} ε - Obliquity
   * @returns {Ecliptic}
   */ toEcliptic(\u03B5) {
        const [\u03B5sin, \u03B5cos] = (0, $9QpM5.default).sincos(\u03B5);
        const [s\u03B1, c\u03B1] = (0, $9QpM5.default).sincos(this.ra);
        const [s\u03B4, c\u03B4] = (0, $9QpM5.default).sincos(this.dec);
        const lon = Math.atan2(s\u03B1 * \u03B5cos + s\u03B4 / c\u03B4 * \u03B5sin, c\u03B1) // (13.1) p. 93
        ;
        const lat = Math.asin(s\u03B4 * \u03B5cos - c\u03B4 * \u03B5sin * s\u03B1) // (13.2) p. 93
        ;
        return new $77f14e36e565e56c$export$c98da9fa25580f41(lon, lat);
    }
    /**
   * EqToHz computes Horizontal coordinates from equatorial coordinates.
   *
   * Argument g is the location of the observer on the Earth.  Argument st
   * is the sidereal time at Greenwich.
   *
   * Sidereal time must be consistent with the equatorial coordinates.
   * If coordinates are apparent, sidereal time must be apparent as well.
   *
   * @param {GlobeCoord} g - coordinates of observer on Earth
   * @param {Number} st - sidereal time at Greenwich at time of observation
   * @returns {Horizontal}
   */ toHorizontal(g, st) {
        const H = new (0, $c953199d551a315b$export$2e2bcd8739ae039).Time(st).rad() - g.lon - this.ra;
        const [sH, cH] = (0, $9QpM5.default).sincos(H);
        const [s\u03C6, c\u03C6] = (0, $9QpM5.default).sincos(g.lat);
        const [s\u03B4, c\u03B4] = (0, $9QpM5.default).sincos(this.dec);
        const azimuth = Math.atan2(sH, cH * s\u03C6 - s\u03B4 / c\u03B4 * c\u03C6) // (13.5) p. 93
        ;
        const altitude = Math.asin(s\u03C6 * s\u03B4 + c\u03C6 * c\u03B4 * cH) // (13.6) p. 93
        ;
        return new $77f14e36e565e56c$export$67923d792ddaccd0(azimuth, altitude);
    }
    /**
   * EqToGal converts equatorial coordinates to galactic coordinates.
   *
   * Equatorial coordinates must be referred to the standard equinox of B1950.0.
   * For conversion to B1950, see package precess and utility functions in
   * package "common".
   *
   * @returns {Galactic}
   */ toGalactic() {
        const [sd\u03B1, cd\u03B1] = (0, $9QpM5.default).sincos($77f14e36e565e56c$export$a0ebe620b3e1cd04.ra - this.ra);
        const [sg\u03B4, cg\u03B4] = (0, $9QpM5.default).sincos($77f14e36e565e56c$export$a0ebe620b3e1cd04.dec);
        const [s\u03B4, c\u03B4] = (0, $9QpM5.default).sincos(this.dec);
        const x = Math.atan2(sd\u03B1, cd\u03B1 * sg\u03B4 - s\u03B4 / c\u03B4 * cg\u03B4) // (13.7) p. 94
        ;
        // (galactic0Lon1950 + 1.5*math.Pi) = magic number of 303 deg
        const lon = ($77f14e36e565e56c$export$bbf3cb9635b89b6e + 1.5 * Math.PI - x) % (2 * Math.PI // (13.8) p. 94
        );
        const lat = Math.asin(s\u03B4 * sg\u03B4 + c\u03B4 * cg\u03B4 * cd\u03B1);
        return new $77f14e36e565e56c$export$5aa2019dd42eaeee(lon, lat);
    }
}
class $77f14e36e565e56c$export$67923d792ddaccd0 {
    constructor(az = 0, alt = 0){
        this.az = az;
        this.alt = alt;
    }
    /**
   * transforms horizontal coordinates to equatorial coordinates.
   *
   * Sidereal time must be consistent with the equatorial coordinates.
   * If coordinates are apparent, sidereal time must be apparent as well.
   * @param {GlobeCoord} g - coordinates of observer on Earth (lat, lon)
   * @param {Number} st - sidereal time at Greenwich at time of observation.
   * @returns {Equatorial} (right ascension, declination)
   */ toEquatorial(g, st) {
        const [sA, cA] = (0, $9QpM5.default).sincos(this.az);
        const [sh, ch] = (0, $9QpM5.default).sincos(this.alt);
        const [s\u03C6, c\u03C6] = (0, $9QpM5.default).sincos(g.lat);
        const H = Math.atan2(sA, cA * s\u03C6 + sh / ch * c\u03C6);
        const ra = (0, $9QpM5.default).pmod(new (0, $c953199d551a315b$export$2e2bcd8739ae039).Time(st).rad() - g.lon - H, 2 * Math.PI);
        const dec = Math.asin(s\u03C6 * sh - c\u03C6 * ch * cA);
        return new $77f14e36e565e56c$export$64805cef36012871(ra, dec);
    }
}
class $77f14e36e565e56c$export$5aa2019dd42eaeee {
    constructor(lon = 0, lat = 0){
        this.lon = lon;
        this.lat = lat;
    }
    /**
   * GalToEq converts galactic coordinates to equatorial coordinates.
   *
   * Resulting equatorial coordinates will be referred to the standard equinox of
   * B1950.0.  For subsequent conversion to other epochs, see package precess and
   * utility functions in package meeus.
   *
   * @returns {Equatorial} (right ascension, declination)
   */ toEquatorial() {
        // (-galactic0Lon1950 - math.Pi/2) = magic number of -123 deg
        const [sdLon, cdLon] = (0, $9QpM5.default).sincos(this.lon - $77f14e36e565e56c$export$bbf3cb9635b89b6e - Math.PI / 2);
        const [sg\u03B4, cg\u03B4] = (0, $9QpM5.default).sincos($77f14e36e565e56c$export$a0ebe620b3e1cd04.dec);
        const [sb, cb] = (0, $9QpM5.default).sincos(this.lat);
        const y = Math.atan2(sdLon, cdLon * sg\u03B4 - sb / cb * cg\u03B4);
        // (galacticNorth1950.RA.Rad() - math.Pi) = magic number of 12.25 deg
        const ra = (0, $9QpM5.default).pmod(y + $77f14e36e565e56c$export$a0ebe620b3e1cd04.ra - Math.PI, 2 * Math.PI);
        const dec = Math.asin(sb * sg\u03B4 + cb * cg\u03B4 * cdLon);
        return new $77f14e36e565e56c$export$64805cef36012871(ra, dec);
    }
}
const $77f14e36e565e56c$export$eb099fac53ea0d75 = new $77f14e36e565e56c$export$64805cef36012871(new (0, $c953199d551a315b$export$2e2bcd8739ae039).RA(12, 49, 0).rad(), 27.4 * Math.PI / 180);
const $77f14e36e565e56c$export$a0ebe620b3e1cd04 = $77f14e36e565e56c$export$eb099fac53ea0d75;
const $77f14e36e565e56c$export$b89e553bdf7620cd = 33 * Math.PI / 180;
const $77f14e36e565e56c$export$bbf3cb9635b89b6e = $77f14e36e565e56c$export$b89e553bdf7620cd;
var $77f14e36e565e56c$export$2e2bcd8739ae039 = {
    Ecliptic: $77f14e36e565e56c$export$c98da9fa25580f41,
    Equatorial: $77f14e36e565e56c$export$64805cef36012871,
    Horizontal: $77f14e36e565e56c$export$67923d792ddaccd0,
    Galactic: $77f14e36e565e56c$export$5aa2019dd42eaeee,
    galacticNorth: $77f14e36e565e56c$export$eb099fac53ea0d75,
    galacticNorth1950: $77f14e36e565e56c$export$a0ebe620b3e1cd04,
    galacticLon0: $77f14e36e565e56c$export$b89e553bdf7620cd,
    galactic0Lon1950: $77f14e36e565e56c$export$bbf3cb9635b89b6e
};


/**
 * @copyright 2013 Sonia Keys
 * @copyright 2016 commenthol
 * @license MIT
 * @module nutation
 */ /**
 * Nutation: Chapter 22, Nutation and the Obliquity of the Ecliptic.
 */ 
var $9QpM5 = parcelRequire("9QpM5");

function $c50a9505be5a627c$export$34d2a3f43e8c5dd6(jde) {
    const T = (0, $9QpM5.default).J2000Century(jde);
    // Mean elongation of the Moon from the sun
    const D = (0, $9QpM5.default).horner(T, 297.85036, 445267.11148, -0.0019142, 1.0 / 189474) * Math.PI / 180;
    // Mean anomaly of the Sun (Earth)
    const M = (0, $9QpM5.default).horner(T, 357.52772, 35999.050340, -0.0001603, -1 / 300000) * Math.PI / 180;
    // Mean anomaly of the Moon
    const N = (0, $9QpM5.default).horner(T, 134.96298, 477198.867398, 0.0086972, 1.0 / 56250) * Math.PI / 180;
    // Moon's argument of latitude
    const F = (0, $9QpM5.default).horner(T, 93.27191, 483202.017538, -0.0036825, 1.0 / 327270) * Math.PI / 180;
    // Longitude of the ascending node of the Moon's mean orbit on the ecliptic, measured from mean equinox of date
    const \u03A9 = (0, $9QpM5.default).horner(T, 125.04452, -1934.136261, 0.0020708, 1.0 / 450000) * Math.PI / 180;
    let \u0394\u03C8 = 0;
    let \u0394\u03B5 = 0;
    // sum in reverse order to accumulate smaller terms first
    for(let i = $c50a9505be5a627c$var$table22A.length - 1; i >= 0; i--){
        const row = $c50a9505be5a627c$var$table22A[i];
        const arg = row.d * D + row.m * M + row.n * N + row.f * F + row.\u03C9 * \u03A9;
        const [s, c] = (0, $9QpM5.default).sincos(arg);
        \u0394\u03C8 += s * (row.s0 + row.s1 * T);
        \u0394\u03B5 += c * (row.c0 + row.c1 * T);
    }
    \u0394\u03C8 *= 0.0001 / 3600 * (Math.PI / 180);
    \u0394\u03B5 *= 0.0001 / 3600 * (Math.PI / 180);
    return [
        \u0394\u03C8,
        \u0394\u03B5
    ] // (Δψ, Δε float)
    ;
}
function $c50a9505be5a627c$export$52ec46766a23d5fe(jde) {
    const T = (jde - (0, $9QpM5.default).J2000) / 36525;
    const \u03A9 = (125.04452 - 1934.136261 * T) * Math.PI / 180;
    const L = (280.4665 + 36000.7698 * T) * Math.PI / 180;
    const N = (218.3165 + 481267.8813 * T) * Math.PI / 180;
    const [s\u03A9, c\u03A9] = (0, $9QpM5.default).sincos(\u03A9);
    const [s2L, c2L] = (0, $9QpM5.default).sincos(2 * L);
    const [s2N, c2N] = (0, $9QpM5.default).sincos(2 * N);
    const [s2\u03A9, c2\u03A9] = (0, $9QpM5.default).sincos(2 * \u03A9);
    const \u0394\u03C8 = (-17.2 * s\u03A9 - 1.32 * s2L - 0.23 * s2N + 0.21 * s2\u03A9) / 3600 * (Math.PI / 180);
    const \u0394\u03B5 = (9.2 * c\u03A9 + 0.57 * c2L + 0.1 * c2N - 0.09 * c2\u03A9) / 3600 * (Math.PI / 180);
    return [
        \u0394\u03C8,
        \u0394\u03B5
    ] // (Δψ, Δε float)
    ;
}
function $c50a9505be5a627c$export$8f491cc7d2e0478d(jde) {
    // (22.2) p. 147
    return (0, $9QpM5.default).horner((0, $9QpM5.default).J2000Century(jde), new (0, $c953199d551a315b$export$2e2bcd8739ae039).Angle(false, 23, 26, 21.448).rad(), -46.815 / 3600 * (Math.PI / 180), -0.00059 / 3600 * (Math.PI / 180), 0.001813 / 3600 * (Math.PI / 180));
}
function $c50a9505be5a627c$export$e5889c8159ed4b62(jde) {
    // (22.3) p. 147
    return (0, $9QpM5.default).horner((0, $9QpM5.default).J2000Century(jde) * 0.01, new (0, $c953199d551a315b$export$2e2bcd8739ae039).Angle(false, 23, 26, 21.448).rad(), -4680.93 / 3600 * (Math.PI / 180), -1.55 / 3600 * (Math.PI / 180), 1999.25 / 3600 * (Math.PI / 180), -51.38 / 3600 * (Math.PI / 180), -249.67 / 3600 * (Math.PI / 180), -39.05 / 3600 * (Math.PI / 180), 7.12 / 3600 * (Math.PI / 180), 27.87 / 3600 * (Math.PI / 180), 5.79 / 3600 * (Math.PI / 180), 2.45 / 3600 * (Math.PI / 180));
}
function $c50a9505be5a627c$export$863d57f191f555aa(jde) {
    const [\u0394\u03C8, \u0394\u03B5] = $c50a9505be5a627c$export$34d2a3f43e8c5dd6(jde);
    const \u03B50 = $c50a9505be5a627c$export$8f491cc7d2e0478d(jde);
    return \u0394\u03C8 * Math.cos(\u03B50 + \u0394\u03B5);
}
const $c50a9505be5a627c$var$table22A = function() {
    const PROPS = "d,m,n,f,\u03C9,s0,s1,c0,c1".split(',');
    const tab = [
        [
            0,
            0,
            0,
            0,
            1,
            -171996,
            -174.2,
            92025,
            8.9
        ],
        [
            -2,
            0,
            0,
            2,
            2,
            -13187,
            -1.6,
            5736,
            -3.1
        ],
        [
            0,
            0,
            0,
            2,
            2,
            -2274,
            -0.2,
            977,
            -0.5
        ],
        [
            0,
            0,
            0,
            0,
            2,
            2062,
            0.2,
            -895,
            0.5
        ],
        [
            0,
            1,
            0,
            0,
            0,
            1426,
            -3.4,
            54,
            -0.1
        ],
        [
            0,
            0,
            1,
            0,
            0,
            712,
            0.1,
            -7,
            0
        ],
        [
            -2,
            1,
            0,
            2,
            2,
            -517,
            1.2,
            224,
            -0.6
        ],
        [
            0,
            0,
            0,
            2,
            1,
            -386,
            -0.4,
            200,
            0
        ],
        [
            0,
            0,
            1,
            2,
            2,
            -301,
            0,
            129,
            -0.1
        ],
        [
            -2,
            -1,
            0,
            2,
            2,
            217,
            -0.5,
            -95,
            0.3
        ],
        [
            -2,
            0,
            1,
            0,
            0,
            -158,
            0,
            0,
            0
        ],
        [
            -2,
            0,
            0,
            2,
            1,
            129,
            0.1,
            -70,
            0
        ],
        [
            0,
            0,
            -1,
            2,
            2,
            123,
            0,
            -53,
            0
        ],
        [
            2,
            0,
            0,
            0,
            0,
            63,
            0,
            0,
            0
        ],
        [
            0,
            0,
            1,
            0,
            1,
            63,
            0.1,
            -33,
            0
        ],
        [
            2,
            0,
            -1,
            2,
            2,
            -59,
            0,
            26,
            0
        ],
        [
            0,
            0,
            -1,
            0,
            1,
            -58,
            -0.1,
            32,
            0
        ],
        [
            0,
            0,
            1,
            2,
            1,
            -51,
            0,
            27,
            0
        ],
        [
            -2,
            0,
            2,
            0,
            0,
            48,
            0,
            0,
            0
        ],
        [
            0,
            0,
            -2,
            2,
            1,
            46,
            0,
            -24,
            0
        ],
        [
            2,
            0,
            0,
            2,
            2,
            -38,
            0,
            16,
            0
        ],
        [
            0,
            0,
            2,
            2,
            2,
            -31,
            0,
            13,
            0
        ],
        [
            0,
            0,
            2,
            0,
            0,
            29,
            0,
            0,
            0
        ],
        [
            -2,
            0,
            1,
            2,
            2,
            29,
            0,
            -12,
            0
        ],
        [
            0,
            0,
            0,
            2,
            0,
            26,
            0,
            0,
            0
        ],
        [
            -2,
            0,
            0,
            2,
            0,
            -22,
            0,
            0,
            0
        ],
        [
            0,
            0,
            -1,
            2,
            1,
            21,
            0,
            -10,
            0
        ],
        [
            0,
            2,
            0,
            0,
            0,
            17,
            -0.1,
            0,
            0
        ],
        [
            2,
            0,
            -1,
            0,
            1,
            16,
            0,
            -8,
            0
        ],
        [
            -2,
            2,
            0,
            2,
            2,
            -16,
            0.1,
            7,
            0
        ],
        [
            0,
            1,
            0,
            0,
            1,
            -15,
            0,
            9,
            0
        ],
        [
            -2,
            0,
            1,
            0,
            1,
            -13,
            0,
            7,
            0
        ],
        [
            0,
            -1,
            0,
            0,
            1,
            -12,
            0,
            6,
            0
        ],
        [
            0,
            0,
            2,
            -2,
            0,
            11,
            0,
            0,
            0
        ],
        [
            2,
            0,
            -1,
            2,
            1,
            -10,
            0,
            5,
            0
        ],
        [
            2,
            0,
            1,
            2,
            2,
            -8,
            0,
            3,
            0
        ],
        [
            0,
            1,
            0,
            2,
            2,
            7,
            0,
            -3,
            0
        ],
        [
            -2,
            1,
            1,
            0,
            0,
            -7,
            0,
            0,
            0
        ],
        [
            0,
            -1,
            0,
            2,
            2,
            -7,
            0,
            3,
            0
        ],
        [
            2,
            0,
            0,
            2,
            1,
            -7,
            0,
            3,
            0
        ],
        [
            2,
            0,
            1,
            0,
            0,
            6,
            0,
            0,
            0
        ],
        [
            -2,
            0,
            2,
            2,
            2,
            6,
            0,
            -3,
            0
        ],
        [
            -2,
            0,
            1,
            2,
            1,
            6,
            0,
            -3,
            0
        ],
        [
            2,
            0,
            -2,
            0,
            1,
            -6,
            0,
            3,
            0
        ],
        [
            2,
            0,
            0,
            0,
            1,
            -6,
            0,
            3,
            0
        ],
        [
            0,
            -1,
            1,
            0,
            0,
            5,
            0,
            0,
            0
        ],
        [
            -2,
            -1,
            0,
            2,
            1,
            -5,
            0,
            3,
            0
        ],
        [
            -2,
            0,
            0,
            0,
            1,
            -5,
            0,
            3,
            0
        ],
        [
            0,
            0,
            2,
            2,
            1,
            -5,
            0,
            3,
            0
        ],
        [
            -2,
            0,
            2,
            0,
            1,
            4,
            0,
            0,
            0
        ],
        [
            -2,
            1,
            0,
            2,
            1,
            4,
            0,
            0,
            0
        ],
        [
            0,
            0,
            1,
            -2,
            0,
            4,
            0,
            0,
            0
        ],
        [
            -1,
            0,
            1,
            0,
            0,
            -4,
            0,
            0,
            0
        ],
        [
            -2,
            1,
            0,
            0,
            0,
            -4,
            0,
            0,
            0
        ],
        [
            1,
            0,
            0,
            0,
            0,
            -4,
            0,
            0,
            0
        ],
        [
            0,
            0,
            1,
            2,
            0,
            3,
            0,
            0,
            0
        ],
        [
            0,
            0,
            -2,
            2,
            2,
            -3,
            0,
            0,
            0
        ],
        [
            -1,
            -1,
            1,
            0,
            0,
            -3,
            0,
            0,
            0
        ],
        [
            0,
            1,
            1,
            0,
            0,
            -3,
            0,
            0,
            0
        ],
        [
            0,
            -1,
            1,
            2,
            2,
            -3,
            0,
            0,
            0
        ],
        [
            2,
            -1,
            -1,
            2,
            2,
            -3,
            0,
            0,
            0
        ],
        [
            0,
            0,
            3,
            2,
            2,
            -3,
            0,
            0,
            0
        ],
        [
            2,
            -1,
            0,
            2,
            2,
            -3,
            0,
            0,
            0
        ]
    ];
    return tab.map((row)=>{
        const o = {};
        PROPS.forEach((p, i)=>{
            o[p] = row[i];
        });
        return o;
    });
}();
var $c50a9505be5a627c$export$2e2bcd8739ae039 = {
    nutation: $c50a9505be5a627c$export$34d2a3f43e8c5dd6,
    approxNutation: $c50a9505be5a627c$export$52ec46766a23d5fe,
    meanObliquity: $c50a9505be5a627c$export$8f491cc7d2e0478d,
    meanObliquityLaskar: $c50a9505be5a627c$export$e5889c8159ed4b62,
    nutationInRA: $c50a9505be5a627c$export$863d57f191f555aa
};


/**
 * @copyright 2013 Sonia Keys
 * @copyright 2016 commenthol
 * @license MIT
 * @module precess
 */ /**
 * Precession: Chapter 21, Precession.
 *
 * Functions in this package take Julian epoch argurments rather than Julian
 * days.  Use base.JDEToJulianYear() to convert.
 *
 * Also in package base are some definitions related to the Besselian and
 * Julian Year.
 *
 * Partial:  Precession from FK4 not implemented.  Meeus gives no test cases.
 * It's a fair amount of code and data, representing significant chances for
 * errors.  And precession from FK4 would seem to be of little interest today.
 *
 * Proper motion units
 *
 * Meeus gives some example annual proper motions in units of seconds of
 * right ascension and seconds of declination.  To make units clear,
 * functions in this package take proper motions with argument types of
 * sexa.HourAngle and sexa.Angle respectively.  Error-prone conversions
 * can be avoided by using the constructors for these base types.
 *
 * For example, given an annual proper motion in right ascension of -0ˢ.03847,
 * rather than
 *
 * mra = -0.03847 / 13751 // as Meeus suggests
 *
 * or
 *
 * mra = -0.03847 * (15/3600) * (pi/180) // less magic
 *
 * use
 *
 * mra = new sexa.HourAngle(false, 0, 0, -0.03847)
 *
 * Unless otherwise indicated, functions in this library expect proper motions
 * to be annual proper motions, so the unit denominator is years.
 * (The code, following Meeus's example, technically treats it as Julian years.)
 */ 
var $9QpM5 = parcelRequire("9QpM5");

/**
 * @copyright 2013 Sonia Keys
 * @copyright 2016 commenthol
 * @license MIT
 * @module elementequinox
 */ /**
 * Elementequinox: Chapter 24, Reduction of Ecliptical Elements
 * from one Equinox to another one.
 *
 * See package precess for the method EclipticPrecessor.ReduceElements and
 * associated example.  The method is described in this chapter but located
 * in package precess so that it can be a method of EclipticPrecessor.
 */ 
var $9QpM5 = parcelRequire("9QpM5");
class $0099c90c1252b855$export$3abb4be70fa2c84e {
    constructor(inc, node, peri){
        if (typeof inc === 'object') {
            node = inc.pode;
            peri = inc.peri;
            inc = inc.inc;
        }
        this.inc = inc || 0;
        this.node = node || 0;
        this.peri = peri || 0;
    }
}
// (24.4) p. 161
const $0099c90c1252b855$var$S = 0.0001139788;
const $0099c90c1252b855$var$C = 0.9999999935;
function $0099c90c1252b855$export$8119df3acb71b121(eFrom) {
    const W = eFrom.node - 174.298782 * Math.PI / 180;
    const [si, ci] = (0, $9QpM5.default).sincos(eFrom.inc);
    const [sW, cW] = (0, $9QpM5.default).sincos(W);
    const A = si * sW;
    const B = $0099c90c1252b855$var$C * si * cW - $0099c90c1252b855$var$S * ci;
    const eTo = new $0099c90c1252b855$export$3abb4be70fa2c84e();
    eTo.inc = Math.asin(Math.hypot(A, B));
    eTo.node = (0, $9QpM5.default).pmod(174.997194 * Math.PI / 180 + Math.atan2(A, B), 2 * Math.PI);
    eTo.peri = (0, $9QpM5.default).pmod(eFrom.peri + Math.atan2(-$0099c90c1252b855$var$S * sW, $0099c90c1252b855$var$C * si - $0099c90c1252b855$var$S * ci * cW), 2 * Math.PI);
    return eTo;
}
const $0099c90c1252b855$var$Lp = 4.50001688 * Math.PI / 180;
const $0099c90c1252b855$var$L = 5.19856209 * Math.PI / 180;
const $0099c90c1252b855$var$J = 0.00651966 * Math.PI / 180;
function $0099c90c1252b855$export$5d101b3332857d18(eFrom) {
    const W = $0099c90c1252b855$var$L + eFrom.node;
    const [si, ci] = (0, $9QpM5.default).sincos(eFrom.inc);
    const [sJ, cJ] = (0, $9QpM5.default).sincos($0099c90c1252b855$var$J);
    const [sW, cW] = (0, $9QpM5.default).sincos(W);
    const eTo = new $0099c90c1252b855$export$3abb4be70fa2c84e();
    eTo.inc = Math.acos(ci * cJ - si * sJ * cW);
    eTo.node = (0, $9QpM5.default).pmod(Math.atan2(si * sW, ci * sJ + si * cJ * cW) - $0099c90c1252b855$var$Lp, 2 * Math.PI);
    eTo.peri = (0, $9QpM5.default).pmod(eFrom.peri + Math.atan2(sJ * sW, si * cJ + ci * sJ * cW), 2 * Math.PI);
    return eTo;
}
var $0099c90c1252b855$export$2e2bcd8739ae039 = {
    Elements: $0099c90c1252b855$export$3abb4be70fa2c84e,
    reduceB1950ToJ2000: $0099c90c1252b855$export$8119df3acb71b121,
    reduceB1950FK4ToJ2000FK5: $0099c90c1252b855$export$5d101b3332857d18
};




function $7b9a9495915be746$export$88524606be196c0a(eqFrom, epochFrom, epochTo) {
    const [m, na, nd] = $7b9a9495915be746$export$e78c44be168181dc(epochFrom, epochTo);
    const [sa, ca] = (0, $9QpM5.default).sincos(eqFrom.ra);
    // (21.1) p. 132
    const \u0394\u03B1s = m + na * sa * Math.tan(eqFrom.dec) // seconds of RA
    ;
    const \u0394\u03B4s = nd * ca // seconds of Dec
    ;
    const ra = new (0, $c953199d551a315b$export$cdffa68f256807f6)(false, 0, 0, \u0394\u03B1s).rad();
    const dec = new (0, $c953199d551a315b$export$6cdc1cb9345ffadf)(false, 0, 0, \u0394\u03B4s).rad();
    return {
        ra: ra,
        dec: dec
    };
}
function $7b9a9495915be746$export$e78c44be168181dc(epochFrom, epochTo) {
    const T = (epochTo - epochFrom) * 0.01;
    const m = 3.07496 + 0.00186 * T;
    const na = 1.33621 - 0.00057 * T;
    const nd = 20.0431 - 0.0085 * T;
    return [
        m,
        na,
        nd
    ];
}
function $7b9a9495915be746$export$66cb4137f5eb726c(eqFrom, epochFrom, epochTo, m\u03B1, m\u03B4) {
    const { ra: ra, dec: dec } = $7b9a9495915be746$export$88524606be196c0a(eqFrom, epochFrom, epochTo);
    const dy = epochTo - epochFrom;
    const eqTo = new (0, $77f14e36e565e56c$export$64805cef36012871)();
    eqTo.ra = eqFrom.ra + (ra + m\u03B1) * dy;
    eqTo.dec = eqFrom.dec + (dec + m\u03B4) * dy;
    return eqTo;
}
// constants
const $7b9a9495915be746$var$d = Math.PI / 180;
const $7b9a9495915be746$var$s = $7b9a9495915be746$var$d / 3600;
// coefficients from (21.2) p. 134
const $7b9a9495915be746$var$\u03B6T = [
    2306.2181 * $7b9a9495915be746$var$s,
    1.39656 * $7b9a9495915be746$var$s,
    -0.000139 * $7b9a9495915be746$var$s
];
const $7b9a9495915be746$var$zT = [
    2306.2181 * $7b9a9495915be746$var$s,
    1.39656 * $7b9a9495915be746$var$s,
    -0.000139 * $7b9a9495915be746$var$s
];
const $7b9a9495915be746$var$\u03B8T = [
    2004.3109 * $7b9a9495915be746$var$s,
    -0.8533 * $7b9a9495915be746$var$s,
    -0.000217 * $7b9a9495915be746$var$s
];
// coefficients from (21.3) p. 134
const $7b9a9495915be746$var$\u03B6t = [
    2306.2181 * $7b9a9495915be746$var$s,
    0.30188 * $7b9a9495915be746$var$s,
    0.017998 * $7b9a9495915be746$var$s
];
const $7b9a9495915be746$var$zt = [
    2306.2181 * $7b9a9495915be746$var$s,
    1.09468 * $7b9a9495915be746$var$s,
    0.018203 * $7b9a9495915be746$var$s
];
const $7b9a9495915be746$var$\u03B8t = [
    2004.3109 * $7b9a9495915be746$var$s,
    -0.42665 * $7b9a9495915be746$var$s,
    -0.041833 * $7b9a9495915be746$var$s
];
class $7b9a9495915be746$export$a3fc18e4d8623be0 {
    /**
   * constructs a Precessor object and initializes it to precess
   * coordinates from epochFrom to epochTo.
   * @param {Number} epochFrom
   * @param {Number} epochTo
   */ constructor(epochFrom, epochTo){
        // (21.2) p. 134
        let \u03B6Coeff = $7b9a9495915be746$var$\u03B6t;
        let zCoeff = $7b9a9495915be746$var$zt;
        let \u03B8Coeff = $7b9a9495915be746$var$\u03B8t;
        if (epochFrom !== 2000) {
            const T = (epochFrom - 2000) * 0.01;
            \u03B6Coeff = [
                (0, $9QpM5.default).horner(T, ...$7b9a9495915be746$var$\u03B6T),
                0.30188 * $7b9a9495915be746$var$s - 0.000344 * $7b9a9495915be746$var$s * T,
                0.017998 * $7b9a9495915be746$var$s
            ];
            zCoeff = [
                (0, $9QpM5.default).horner(T, ...$7b9a9495915be746$var$zT),
                1.09468 * $7b9a9495915be746$var$s + 0.000066 * $7b9a9495915be746$var$s * T,
                0.018203 * $7b9a9495915be746$var$s
            ];
            \u03B8Coeff = [
                (0, $9QpM5.default).horner(T, ...$7b9a9495915be746$var$\u03B8T),
                -0.42665 * $7b9a9495915be746$var$s - 0.000217 * $7b9a9495915be746$var$s * T,
                -0.041833 * $7b9a9495915be746$var$s
            ];
        }
        const t = (epochTo - epochFrom) * 0.01;
        this.\u03B6 = (0, $9QpM5.default).horner(t, ...\u03B6Coeff) * t;
        this.z = (0, $9QpM5.default).horner(t, ...zCoeff) * t;
        const \u03B8 = (0, $9QpM5.default).horner(t, ...\u03B8Coeff) * t;
        this.s\u03B8 = Math.sin(\u03B8);
        this.c\u03B8 = Math.cos(\u03B8);
    }
    /**
   * Precess precesses coordinates eqFrom, leaving result in eqTo.
   *
   * @param {Equatorial} eqFrom
   * @returns {Equatorial} eqTo
   */ precess(eqFrom) {
        // (21.4) p. 134
        const [s\u03B4, c\u03B4] = (0, $9QpM5.default).sincos(eqFrom.dec);
        const [s\u03B1\u03B6, c\u03B1\u03B6] = (0, $9QpM5.default).sincos(eqFrom.ra + this.\u03B6);
        const A = c\u03B4 * s\u03B1\u03B6;
        const B = this.c\u03B8 * c\u03B4 * c\u03B1\u03B6 - this.s\u03B8 * s\u03B4;
        const C = this.s\u03B8 * c\u03B4 * c\u03B1\u03B6 + this.c\u03B8 * s\u03B4;
        const eqTo = new (0, $77f14e36e565e56c$export$64805cef36012871)();
        eqTo.ra = Math.atan2(A, B) + this.z;
        if (C < (0, $9QpM5.default).CosSmallAngle) eqTo.dec = Math.asin(C);
        else eqTo.dec = Math.acos(Math.hypot(A, B)) // near pole
        ;
        return eqTo;
    }
}
function $7b9a9495915be746$export$5880b8b5730aff45(eqFrom, epochFrom, epochTo, m\u03B1, m\u03B4) {
    const p = new $7b9a9495915be746$export$a3fc18e4d8623be0(epochFrom, epochTo);
    const t = epochTo - epochFrom;
    const eqTo = new (0, $77f14e36e565e56c$export$64805cef36012871)();
    eqTo.ra = eqFrom.ra + m\u03B1 * t;
    eqTo.dec = eqFrom.dec + m\u03B4 * t;
    return p.precess(eqTo);
}
// coefficients from (21.5) p. 136
const $7b9a9495915be746$var$\u03B7T = [
    47.0029 * $7b9a9495915be746$var$s,
    -0.06603 * $7b9a9495915be746$var$s,
    0.000598 * $7b9a9495915be746$var$s
];
const $7b9a9495915be746$var$\u03C0T = [
    174.876384 * $7b9a9495915be746$var$d,
    3289.4789 * $7b9a9495915be746$var$s,
    0.60622 * $7b9a9495915be746$var$s
];
const $7b9a9495915be746$var$pT = [
    5029.0966 * $7b9a9495915be746$var$s,
    2.22226 * $7b9a9495915be746$var$s,
    -0.000042 * $7b9a9495915be746$var$s
];
const $7b9a9495915be746$var$\u03B7t = [
    47.0029 * $7b9a9495915be746$var$s,
    -0.03302 * $7b9a9495915be746$var$s,
    0.000060 * $7b9a9495915be746$var$s
];
const $7b9a9495915be746$var$\u03C0t = [
    174.876384 * $7b9a9495915be746$var$d,
    -869.8089 * $7b9a9495915be746$var$s,
    0.03536 * $7b9a9495915be746$var$s
];
const $7b9a9495915be746$var$pt = [
    5029.0966 * $7b9a9495915be746$var$s,
    1.11113 * $7b9a9495915be746$var$s,
    -0.000006 * $7b9a9495915be746$var$s
];
class $7b9a9495915be746$export$77cb812bcd275818 {
    /**
   * constructs an EclipticPrecessor object and initializes
   * it to precess coordinates from epochFrom to epochTo.
   * @param {Number} epochFrom
   * @param {Number} epochTo
   */ constructor(epochFrom, epochTo){
        // (21.5) p. 136
        let \u03B7Coeff = $7b9a9495915be746$var$\u03B7t;
        let \u03C0Coeff = $7b9a9495915be746$var$\u03C0t;
        let pCoeff = $7b9a9495915be746$var$pt;
        if (epochFrom !== 2000) {
            const T = (epochFrom - 2000) * 0.01;
            \u03B7Coeff = [
                (0, $9QpM5.default).horner(T, ...$7b9a9495915be746$var$\u03B7T),
                -0.03302 * $7b9a9495915be746$var$s + 0.000598 * $7b9a9495915be746$var$s * T,
                0.000060 * $7b9a9495915be746$var$s
            ];
            \u03C0Coeff = [
                (0, $9QpM5.default).horner(T, ...$7b9a9495915be746$var$\u03C0T),
                -869.8089 * $7b9a9495915be746$var$s - 0.50491 * $7b9a9495915be746$var$s * T,
                0.03536 * $7b9a9495915be746$var$s
            ];
            pCoeff = [
                (0, $9QpM5.default).horner(T, ...$7b9a9495915be746$var$pT),
                1.11113 * $7b9a9495915be746$var$s - 0.000042 * $7b9a9495915be746$var$s * T,
                -0.000006 * $7b9a9495915be746$var$s
            ];
        }
        const t = (epochTo - epochFrom) * 0.01;
        this.\u03C0 = (0, $9QpM5.default).horner(t, ...\u03C0Coeff);
        this.p = (0, $9QpM5.default).horner(t, ...pCoeff) * t;
        const \u03B7 = (0, $9QpM5.default).horner(t, ...\u03B7Coeff) * t;
        this.s\u03B7 = Math.sin(\u03B7);
        this.c\u03B7 = Math.cos(\u03B7);
    }
    /**
   * EclipticPrecess precesses coordinates eclFrom, leaving result in eclTo.
   *
   * The same struct may be used for eclFrom and eclTo.
   * EclTo is returned for convenience.
   * @param {Ecliptic} eclFrom
   * @returns {Ecliptic} [eclTo]
   */ precess(eclFrom) {
        // (21.7) p. 137
        const [s\u03B2, c\u03B2] = (0, $9QpM5.default).sincos(eclFrom.lat);
        const [sd, cd] = (0, $9QpM5.default).sincos(this.\u03C0 - eclFrom.lon);
        const A = this.c\u03B7 * c\u03B2 * sd - this.s\u03B7 * s\u03B2;
        const B = c\u03B2 * cd;
        const C = this.c\u03B7 * s\u03B2 + this.s\u03B7 * c\u03B2 * sd;
        const eclTo = new (0, $77f14e36e565e56c$export$c98da9fa25580f41)(this.p + this.\u03C0 - Math.atan2(A, B));
        if (C < (0, $9QpM5.default).CosSmallAngle) eclTo.lat = Math.asin(C);
        else eclTo.lat = Math.acos(Math.hypot(A, B)) // near pole
        ;
        return eclTo;
    }
    /**
   * ReduceElements reduces orbital elements of a solar system body from one
   * equinox to another.
   *
   * This function is described in chapter 24, but is located in this
   * package so it can be a method of EclipticPrecessor.
   *
   * @param {Elements} eFrom
   * @returns {Elements} eTo
   */ reduceElements(eFrom) {
        const \u03C8 = this.\u03C0 + this.p;
        const [si, ci] = (0, $9QpM5.default).sincos(eFrom.inc);
        const [snp, cnp] = (0, $9QpM5.default).sincos(eFrom.node - this.\u03C0);
        const eTo = new (0, $0099c90c1252b855$export$3abb4be70fa2c84e)();
        // (24.1) p. 159
        eTo.inc = Math.acos(ci * this.c\u03B7 + si * this.s\u03B7 * cnp);
        // (24.2) p. 159
        eTo.node = Math.atan2(si * snp, this.c\u03B7 * si * cnp - this.s\u03B7 * ci) + \u03C8;
        // (24.3) p. 159
        eTo.peri = Math.atan2(-this.s\u03B7 * snp, si * this.c\u03B7 - ci * this.s\u03B7 * cnp) + eFrom.peri;
        return eTo;
    }
}
function $7b9a9495915be746$export$d9b194be5e18818a(eclFrom, epochFrom, epochTo, m\u03B1, m\u03B4) {
    const p = new $7b9a9495915be746$export$77cb812bcd275818(epochFrom, epochTo);
    if (m\u03B1 && m\u03B4 && (m\u03B1.rad() !== 0 || m\u03B4.rad() !== 0)) {
        const { lon: lon, lat: lat } = $7b9a9495915be746$export$7c3953778c05ed65(m\u03B1.rad(), m\u03B4.rad(), epochFrom, eclFrom);
        const t = epochTo - epochFrom;
        eclFrom.lon += lon * t;
        eclFrom.lat += lat * t;
    }
    return p.precess(eclFrom);
}
function $7b9a9495915be746$export$7c3953778c05ed65(m\u03B1, m\u03B4, epoch, ecl) {
    const \u03B5 = (0, $c50a9505be5a627c$export$2e2bcd8739ae039).meanObliquity((0, $9QpM5.default).JulianYearToJDE(epoch));
    const [\u03B5sin, \u03B5cos] = (0, $9QpM5.default).sincos(\u03B5);
    const { ra: ra, dec: dec } = ecl.toEquatorial(\u03B5);
    const [s\u03B1, c\u03B1] = (0, $9QpM5.default).sincos(ra);
    const [s\u03B4, c\u03B4] = (0, $9QpM5.default).sincos(dec);
    const c\u03B2 = Math.cos(ecl.lat);
    const lon = (m\u03B4 * \u03B5sin * c\u03B1 + m\u03B1 * c\u03B4 * (\u03B5cos * c\u03B4 + \u03B5sin * s\u03B4 * s\u03B1)) / (c\u03B2 * c\u03B2);
    const lat = (m\u03B4 * (\u03B5cos * c\u03B4 + \u03B5sin * s\u03B4 * s\u03B1) - m\u03B1 * \u03B5sin * c\u03B1 * c\u03B4) / c\u03B2;
    return new (0, $77f14e36e565e56c$export$c98da9fa25580f41)(lon, lat);
}
function $7b9a9495915be746$export$9c7cb08f16df4b27(eqFrom, epochFrom, epochTo, r, mr, m\u03B1, m\u03B4) {
    const [s\u03B1, c\u03B1] = (0, $9QpM5.default).sincos(eqFrom.ra);
    const [s\u03B4, c\u03B4] = (0, $9QpM5.default).sincos(eqFrom.dec);
    const x = r * c\u03B4 * c\u03B1;
    const y = r * c\u03B4 * s\u03B1;
    const z = r * s\u03B4;
    const mrr = mr / r;
    const zm\u03B4 = z * m\u03B4.rad();
    const mx = x * mrr - zm\u03B4 * c\u03B1 - y * m\u03B1.rad();
    const my = y * mrr - zm\u03B4 * s\u03B1 + x * m\u03B1.rad();
    const mz = z * mrr + r * m\u03B4.rad() * c\u03B4;
    const t = epochTo - epochFrom;
    const xp = x + t * mx;
    const yp = y + t * my;
    const zp = z + t * mz;
    const eqTo = new (0, $77f14e36e565e56c$export$64805cef36012871)();
    eqTo.ra = Math.atan2(yp, xp);
    eqTo.dec = Math.atan2(zp, Math.hypot(xp, yp));
    return eqTo;
}
var $7b9a9495915be746$export$2e2bcd8739ae039 = {
    approxAnnualPrecession: $7b9a9495915be746$export$88524606be196c0a,
    mn: $7b9a9495915be746$export$e78c44be168181dc,
    approxPosition: $7b9a9495915be746$export$66cb4137f5eb726c,
    Precessor: $7b9a9495915be746$export$a3fc18e4d8623be0,
    position: $7b9a9495915be746$export$5880b8b5730aff45,
    EclipticPrecessor: $7b9a9495915be746$export$77cb812bcd275818,
    eclipticPosition: $7b9a9495915be746$export$d9b194be5e18818a,
    properMotion: $7b9a9495915be746$export$7c3953778c05ed65,
    properMotion3D: $7b9a9495915be746$export$9c7cb08f16df4b27
};


/**
 * @copyright 2013 Sonia Keys
 * @copyright 2016 commenthol
 * @license MIT
 * @module solar
 */ /**
 * Solar: Chapter 25, Solar Coordinates.
 *
 * Partial implementation:
 *
 * 1. Higher accuracy positions are not computed with Appendix III but with
 * full VSOP87 as implemented in package planetposition.
 *
 * 2. Higher accuracy correction for aberration (using the formula for
 * variation Δλ on p. 168) is not implemented.  Results for example 25.b
 * already match the full VSOP87 values on p. 165 even with the low accuracy
 * correction for aberration, thus there are no more significant digits that
 * would check a more accurate result.  Also the size of the formula presents
 * significant chance of typographical error.
 */ 
var $9QpM5 = parcelRequire("9QpM5");
/**
 * @copyright 2013 Sonia Keys
 * @copyright 2016 commenthol
 * @license MIT
 * @module planetposition
 */ /**
 * Planetposition: Chapter 32, Positions of the Planets.
 *
 * Incomplete:
 *
 * 1. The package does not implement algorithms that use appendix III,
 * but instead implements a full VSOP87 solution.  I do not have a copy
 * of the supplimentary disk with appendix III in machine readable form
 * and as the appendix is rather large, retyping it by hand is problematic.
 * The full VSOP87 data set on the other hand is freely downloadable from
 * the internet, so I implement here code that can use that data directly.
 *
 * 2. The formula for accuracy of results is not implemented.  It is
 * not needed for full VSOP87 solutions.
 *
 * 3. Polynomial expressions are not implemented.  Again, implementation
 * would involve typing rather large tables of numbers with associated
 * risk of typographical errors.
 */ 
var $9QpM5 = parcelRequire("9QpM5");



function $2c5cad23f9dfa2db$var$sum(t, series) {
    const coeffs = [];
    Object.keys(series).forEach((x)=>{
        coeffs[x] = 0;
        let y = series[x].length - 1;
        for(y; y >= 0; y--){
            const term = {
                a: series[x][y][0],
                b: series[x][y][1],
                c: series[x][y][2]
            };
            coeffs[x] += term.a * Math.cos(term.b + term.c * t);
        }
    });
    const res = (0, $9QpM5.default).horner(t, ...coeffs);
    return res;
}
class $2c5cad23f9dfa2db$export$965755fbf184a8fc {
    /**
   * VSOP87 representation of a Planet
   * @constructs Planet
   * @param {object} planet - planet data series
   * @example
   * ```js
   * // for use in browser
   * import {data} from 'astronomia'
   * const earth = new planetposition.Planet(data.vsop87Bearth)
   * ```
   */ constructor(planet){
        if (typeof planet !== 'object') throw new TypeError('need planet vsop87 data');
        this.name = planet.name;
        this.type = planet.type || 'B';
        this.series = planet;
    }
    /**
   * Position2000 returns ecliptic position of planets by full VSOP87 theory.
   *
   * @param {Number} jde - the date for which positions are desired.
   * @returns {Coord} Results are for the dynamical equinox and ecliptic J2000.
   *  {Number} lon - heliocentric longitude in radians.
   *  {Number} lat - heliocentric latitude in radians.
   *  {Number} range - heliocentric range in AU.
   */ position2000(jde) {
        const T = (0, $9QpM5.default).J2000Century(jde);
        const \u03C4 = T * 0.1;
        const lon = (0, $9QpM5.default).pmod($2c5cad23f9dfa2db$var$sum(\u03C4, this.series.L), 2 * Math.PI);
        const lat = $2c5cad23f9dfa2db$var$sum(\u03C4, this.series.B);
        const range = $2c5cad23f9dfa2db$var$sum(\u03C4, this.series.R);
        switch(this.type){
            case 'B':
                return new (0, $9QpM5.default).Coord(lon, lat, range);
            case 'D':
                {
                    const eclFrom = new (0, $77f14e36e565e56c$export$2e2bcd8739ae039).Ecliptic(lon, lat);
                    const epochFrom = (0, $9QpM5.default).JDEToJulianYear(jde);
                    const epochTo = 2000.0;
                    const eclTo = (0, $7b9a9495915be746$export$2e2bcd8739ae039).eclipticPosition(eclFrom, epochFrom, epochTo);
                    return new (0, $9QpM5.default).Coord(eclTo.lon, eclTo.lat, range);
                }
        }
    }
    /**
   * Position returns ecliptic position of planets at equinox and ecliptic of date.
   *
   * @param {Number} jde - the date for which positions are desired.
   * @returns {Coord} Results are positions consistent with those from Meeus's
   * Apendix III, that is, at equinox and ecliptic of date.
   *  {Number} lon - heliocentric longitude in radians.
   *  {Number} lat - heliocentric latitude in radians.
   *  {Number} range - heliocentric range in AU.
   */ position(jde) {
        const T = (0, $9QpM5.default).J2000Century(jde);
        const \u03C4 = T * 0.1;
        const lon = (0, $9QpM5.default).pmod($2c5cad23f9dfa2db$var$sum(\u03C4, this.series.L), 2 * Math.PI);
        const lat = $2c5cad23f9dfa2db$var$sum(\u03C4, this.series.B);
        const range = $2c5cad23f9dfa2db$var$sum(\u03C4, this.series.R);
        switch(this.type){
            case 'B':
                {
                    const eclFrom = new (0, $77f14e36e565e56c$export$2e2bcd8739ae039).Ecliptic(lon, lat);
                    const epochFrom = 2000.0;
                    const epochTo = (0, $9QpM5.default).JDEToJulianYear(jde);
                    const eclTo = (0, $7b9a9495915be746$export$2e2bcd8739ae039).eclipticPosition(eclFrom, epochFrom, epochTo);
                    return new (0, $9QpM5.default).Coord(eclTo.lon, eclTo.lat, range);
                }
            case 'D':
                return new (0, $9QpM5.default).Coord(lon, lat, range);
        }
    }
}
function $2c5cad23f9dfa2db$export$82bc369f3de182d7(lon, lat, jde) {
    // formula 32.3, p. 219.
    const T = (0, $9QpM5.default).J2000Century(jde);
    // const Lp = lon - 1.397 * Math.PI / 180 * T - 0.00031 * Math.PI / 180 * T * T
    const Lp = lon - (0, $c953199d551a315b$export$2e2bcd8739ae039).angleFromDeg((1.397 + 0.00031 * T) * T);
    const [sLp, cLp] = (0, $9QpM5.default).sincos(Lp);
    // (32.3) p. 219
    const L5 = lon + (0, $c953199d551a315b$export$2e2bcd8739ae039).angleFromSec(-0.09033 + 0.03916 * (cLp + sLp) * Math.tan(lat));
    const B5 = lat + (0, $c953199d551a315b$export$2e2bcd8739ae039).angleFromSec(0.03916 * (cLp - sLp));
    return new (0, $9QpM5.default).Coord(L5, B5);
}
var $2c5cad23f9dfa2db$export$2e2bcd8739ae039 = {
    Planet: $2c5cad23f9dfa2db$export$965755fbf184a8fc,
    toFK5: $2c5cad23f9dfa2db$export$82bc369f3de182d7
};




function $c85b876782fe98e7$export$2f878549bb250e54(T) {
    // (25.2) p. 163
    const L0 = (0, $9QpM5.default).horner(T, 280.46646, 36000.76983, 0.0003032) * Math.PI / 180;
    const m = $c85b876782fe98e7$export$af3c22e2cbc805e9(T);
    const C = ((0, $9QpM5.default).horner(T, 1.914602, -0.004817, -0.000014) * Math.sin(m) + (0.019993 - 0.000101 * T) * Math.sin(2 * m) + 0.000289 * Math.sin(3 * m)) * Math.PI / 180;
    const lon = (0, $9QpM5.default).pmod(L0 + C, 2 * Math.PI);
    const ano = (0, $9QpM5.default).pmod(m + C, 2 * Math.PI);
    return {
        lon: lon,
        ano: ano
    };
}
function $c85b876782fe98e7$export$af3c22e2cbc805e9(T) {
    // (25.3) p. 163
    return (0, $9QpM5.default).horner(T, 357.52911, 35999.05029, -0.0001537) * Math.PI / 180;
}
function $c85b876782fe98e7$export$e3d7bf2ed2a7479f(T) {
    // (25.4) p. 163
    return (0, $9QpM5.default).horner(T, 0.016708634, -0.000042037, -0.0000001267);
}
function $c85b876782fe98e7$export$872dd985a098dd45(T) {
    const { lon: lon, ano: ano } = $c85b876782fe98e7$export$2f878549bb250e54(T) // eslint-disable-line
    ;
    const e = $c85b876782fe98e7$export$e3d7bf2ed2a7479f(T);
    // (25.5) p. 164
    return 1.000001018 * (1 - e * e) / (1 + e * Math.cos(ano));
}
function $c85b876782fe98e7$export$7402f257a8a7a76c(T) {
    const \u03A9 = $c85b876782fe98e7$var$node(T);
    const { lon: lon, ano: ano } = $c85b876782fe98e7$export$2f878549bb250e54(T) // eslint-disable-line
    ;
    return lon - 0.00569 * Math.PI / 180 - 0.00478 * Math.PI / 180 * Math.sin(\u03A9);
}
/**
 * @private
 */ function $c85b876782fe98e7$var$node(T) {
    return 125.04 * Math.PI / 180 - 1934.136 * Math.PI / 180 * T;
}
function $c85b876782fe98e7$export$7ec572a06da83a8b(T) {
    let { lon: lon, ano: ano } = $c85b876782fe98e7$export$2f878549bb250e54(T);
    lon -= 0.01397 * Math.PI / 180 * T * 100;
    return {
        lon: lon,
        ano: ano
    };
}
function $c85b876782fe98e7$export$4ad7a136db631e1a(jde) {
    const { lon: lon, ano: ano } = $c85b876782fe98e7$export$2f878549bb250e54((0, $9QpM5.default).J2000Century(jde)) // eslint-disable-line
    ;
    const \u03B5 = (0, $c50a9505be5a627c$export$2e2bcd8739ae039).meanObliquity(jde);
    const [ss, cs] = (0, $9QpM5.default).sincos(lon);
    const [s\u03B5, c\u03B5] = (0, $9QpM5.default).sincos(\u03B5);
    // (25.6, 25.7) p. 165
    const ra = Math.atan2(c\u03B5 * ss, cs);
    const dec = s\u03B5 * ss;
    return new (0, $9QpM5.default).Coord(ra, dec);
}
function $c85b876782fe98e7$export$130198999cf4761(jde) {
    const T = (0, $9QpM5.default).J2000Century(jde);
    const \u03BB = $c85b876782fe98e7$export$7402f257a8a7a76c(T);
    const \u03B5 = (0, $c50a9505be5a627c$export$2e2bcd8739ae039).meanObliquity(jde);
    const [s\u03BB, c\u03BB] = (0, $9QpM5.default).sincos(\u03BB);
    // (25.8) p. 165
    const [s\u03B5, c\u03B5] = (0, $9QpM5.default).sincos(\u03B5 + 0.00256 * Math.PI / 180 * Math.cos($c85b876782fe98e7$var$node(T)));
    const ra = Math.atan2(c\u03B5 * s\u03BB, c\u03BB);
    const dec = Math.asin(s\u03B5 * s\u03BB);
    return new (0, $9QpM5.default).Coord(ra, dec);
}
function $c85b876782fe98e7$export$b3d400e12ed6a502(planet, jde) {
    let { lon: lon, lat: lat, range: range } = planet.position(jde);
    const s = lon + Math.PI;
    // FK5 correction.
    const \u03BBp = (0, $9QpM5.default).horner((0, $9QpM5.default).J2000Century(jde), s, -1.397 * Math.PI / 180, -0.00031 * Math.PI / 180);
    const [s\u03BBp, c\u03BBp] = (0, $9QpM5.default).sincos(\u03BBp);
    const \u0394\u03B2 = 0.03916 / 3600 * Math.PI / 180 * (c\u03BBp - s\u03BBp);
    // (25.9) p. 166
    lon = (0, $9QpM5.default).pmod(s - 0.09033 / 3600 * Math.PI / 180, 2 * Math.PI);
    lat = \u0394\u03B2 - lat;
    return new (0, $9QpM5.default).Coord(lon, lat, range);
}
function $c85b876782fe98e7$export$3413f1a344807229(planet, jde) {
    // note: see duplicated code in ApparentEquatorialVSOP87.
    let { lon: lon, lat: lat, range: range } = $c85b876782fe98e7$export$b3d400e12ed6a502(planet, jde);
    const \u0394\u03C8 = (0, $c50a9505be5a627c$export$2e2bcd8739ae039).nutation(jde)[0];
    const a = $c85b876782fe98e7$export$8bdd0d085f5dc0f2(range);
    lon = lon + \u0394\u03C8 + a;
    return new (0, $9QpM5.default).Coord(lon, lat, range);
}
function $c85b876782fe98e7$export$b73d68dff17f8ee8(planet, jde) {
    // note: duplicate code from ApparentVSOP87 so we can keep Δε.
    // see also duplicate code in time.E().
    const { lon: lon, lat: lat, range: range } = $c85b876782fe98e7$export$b3d400e12ed6a502(planet, jde);
    const [\u0394\u03C8, \u0394\u03B5] = (0, $c50a9505be5a627c$export$2e2bcd8739ae039).nutation(jde);
    const a = $c85b876782fe98e7$export$8bdd0d085f5dc0f2(range);
    const \u03BB = lon + \u0394\u03C8 + a;
    const \u03B5 = (0, $c50a9505be5a627c$export$2e2bcd8739ae039).meanObliquity(jde) + \u0394\u03B5;
    const { ra: ra, dec: dec } = new (0, $77f14e36e565e56c$export$2e2bcd8739ae039).Ecliptic(\u03BB, lat).toEquatorial(\u03B5);
    return new (0, $9QpM5.Coord)(ra, dec, range);
}
function $c85b876782fe98e7$export$8bdd0d085f5dc0f2(range) {
    // (25.10) p. 167
    return -20.4898 / 3600 * Math.PI / 180 / range;
}
var $c85b876782fe98e7$export$2e2bcd8739ae039 = {
    trueLongitude: $c85b876782fe98e7$export$2f878549bb250e54,
    true: $c85b876782fe98e7$export$2f878549bb250e54,
    meanAnomaly: $c85b876782fe98e7$export$af3c22e2cbc805e9,
    eccentricity: $c85b876782fe98e7$export$e3d7bf2ed2a7479f,
    radius: $c85b876782fe98e7$export$872dd985a098dd45,
    apparentLongitude: $c85b876782fe98e7$export$7402f257a8a7a76c,
    true2000: $c85b876782fe98e7$export$7ec572a06da83a8b,
    trueEquatorial: $c85b876782fe98e7$export$4ad7a136db631e1a,
    apparentEquatorial: $c85b876782fe98e7$export$130198999cf4761,
    trueVSOP87: $c85b876782fe98e7$export$b3d400e12ed6a502,
    apparentVSOP87: $c85b876782fe98e7$export$3413f1a344807229,
    apparentEquatorialVSOP87: $c85b876782fe98e7$export$b73d68dff17f8ee8,
    aberration: $c85b876782fe98e7$export$8bdd0d085f5dc0f2
};


const { cos: $66020aba9d13c5db$var$cos, tan: $66020aba9d13c5db$var$tan } = Math;
function $66020aba9d13c5db$export$34d2a3f43e8c5dd6(\u03B1, \u03B4, jd) {
    const \u03B5 = (0, $c50a9505be5a627c$export$2e2bcd8739ae039).meanObliquity(jd);
    const [sin\u03B5, cos\u03B5] = (0, $9QpM5.default).sincos(\u03B5);
    const [\u0394\u03C8, \u0394\u03B5] = (0, $c50a9505be5a627c$export$2e2bcd8739ae039).nutation(jd);
    const [sin\u03B1, cos\u03B1] = (0, $9QpM5.default).sincos(\u03B1);
    const tan\u03B4 = $66020aba9d13c5db$var$tan(\u03B4);
    // (23.1) p. 151
    const \u0394\u03B11 = (cos\u03B5 + sin\u03B5 * sin\u03B1 * tan\u03B4) * \u0394\u03C8 - cos\u03B1 * tan\u03B4 * \u0394\u03B5;
    const \u0394\u03B41 = sin\u03B5 * cos\u03B1 * \u0394\u03C8 + sin\u03B1 * \u0394\u03B5;
    return [
        \u0394\u03B11,
        \u0394\u03B41
    ];
}
/**
 * κ is the constant of aberration in radians.
 */ const $66020aba9d13c5db$var$\u03BA = 20.49552 * Math.PI / 180 / 3600;
function $66020aba9d13c5db$export$407dd2a47a94200d(T) {
    return (0, $9QpM5.default).horner(T, 102.93735, 1.71946, 0.00046) * Math.PI / 180;
}
function $66020aba9d13c5db$export$1dcbf4916a95b726(\u03BB, \u03B2, jd) {
    const T = (0, $9QpM5.default).J2000Century(jd);
    const { lon: lon, ano: ano } = (0, $c85b876782fe98e7$export$2e2bcd8739ae039).trueLongitude(T) // eslint-disable-line no-unused-vars
    ;
    const e = (0, $c85b876782fe98e7$export$2e2bcd8739ae039).eccentricity(T);
    const \u03C0 = $66020aba9d13c5db$export$407dd2a47a94200d(T);
    const [s\u03B2, c\u03B2] = (0, $9QpM5.default).sincos(\u03B2);
    const [ss\u03BB, cs\u03BB] = (0, $9QpM5.default).sincos(lon - \u03BB);
    const [sin\u03C0\u03BB, cos\u03C0\u03BB] = (0, $9QpM5.default).sincos(\u03C0 - \u03BB);
    // (23.2) p. 151
    const \u0394\u03BB = $66020aba9d13c5db$var$\u03BA * (e * cos\u03C0\u03BB - cs\u03BB) / c\u03B2;
    const \u0394\u03B2 = -$66020aba9d13c5db$var$\u03BA * s\u03B2 * (ss\u03BB - e * sin\u03C0\u03BB);
    return [
        \u0394\u03BB,
        \u0394\u03B2
    ];
}
function $66020aba9d13c5db$export$8bdd0d085f5dc0f2(\u03B1, \u03B4, jd) {
    const \u03B5 = (0, $c50a9505be5a627c$export$2e2bcd8739ae039).meanObliquity(jd);
    const T = (0, $9QpM5.default).J2000Century(jd);
    const { lon: lon, ano: ano } = (0, $c85b876782fe98e7$export$2e2bcd8739ae039).trueLongitude(T) // eslint-disable-line no-unused-vars
    ;
    const e = (0, $c85b876782fe98e7$export$2e2bcd8739ae039).eccentricity(T);
    const \u03C0 = $66020aba9d13c5db$export$407dd2a47a94200d(T);
    const [sin\u03B1, cos\u03B1] = (0, $9QpM5.default).sincos(\u03B1);
    const [sin\u03B4, cos\u03B4] = (0, $9QpM5.default).sincos(\u03B4);
    const [sins, coss] = (0, $9QpM5.default).sincos(lon);
    const [sin\u03C0, cos\u03C0] = (0, $9QpM5.default).sincos(\u03C0);
    const cos\u03B5 = $66020aba9d13c5db$var$cos(\u03B5);
    const q1 = cos\u03B1 * cos\u03B5;
    // (23.3) p. 152
    const \u0394\u03B12 = $66020aba9d13c5db$var$\u03BA * (e * (q1 * cos\u03C0 + sin\u03B1 * sin\u03C0) - (q1 * coss + sin\u03B1 * sins)) / cos\u03B4;
    const q2 = cos\u03B5 * ($66020aba9d13c5db$var$tan(\u03B5) * cos\u03B4 - sin\u03B1 * sin\u03B4);
    const q3 = cos\u03B1 * sin\u03B4;
    const \u0394\u03B42 = $66020aba9d13c5db$var$\u03BA * (e * (cos\u03C0 * q2 + sin\u03C0 * q3) - (coss * q2 + sins * q3));
    return [
        \u0394\u03B12,
        \u0394\u03B42
    ];
}
function $66020aba9d13c5db$export$5880b8b5730aff45(eqFrom, epochFrom, epochTo, m\u03B1, m\u03B4) {
    const eqTo = (0, $7b9a9495915be746$export$2e2bcd8739ae039).position(eqFrom, epochFrom, epochTo, m\u03B1, m\u03B4);
    const jd = (0, $9QpM5.default).JulianYearToJDE(epochTo);
    const [\u0394\u03B11, \u0394\u03B41] = $66020aba9d13c5db$export$34d2a3f43e8c5dd6(eqTo.ra, eqTo.dec, jd);
    const [\u0394\u03B12, \u0394\u03B42] = $66020aba9d13c5db$export$8bdd0d085f5dc0f2(eqTo.ra, eqTo.dec, jd);
    eqTo.ra += \u0394\u03B11 + \u0394\u03B12;
    eqTo.dec += \u0394\u03B41 + \u0394\u03B42;
    return eqTo;
}
function $66020aba9d13c5db$export$d2affbd77acccdb9(\u03B1, \u03B4, jd) {
    const T = (0, $9QpM5.default).J2000Century(jd);
    const r = {
        T: T,
        L2: 3.1761467 + 1021.3285546 * T,
        L3: 1.7534703 + 628.3075849 * T,
        L4: 6.2034809 + 334.0612431 * T,
        L5: 0.5995465 + 52.9690965 * T,
        L6: 0.8740168 + 21.3299095 * T,
        L7: 5.4812939 + 7.4781599 * T,
        L8: 5.3118863 + 3.8133036 * T,
        Lp: 3.8103444 + 8399.6847337 * T,
        D: 5.1984667 + 7771.3771486 * T,
        Mp: 2.3555559 + 8328.6914289 * T,
        F: 1.6279052 + 8433.4661601 * T
    };
    let Xp = 0;
    let Yp = 0;
    let Zp = 0;
    // sum smaller terms first
    for(let i = 35; i >= 0; i--){
        const [x, y, z] = $66020aba9d13c5db$var$rvTerm[i](r);
        Xp += x;
        Yp += y;
        Zp += z;
    }
    const [sin\u03B1, cos\u03B1] = (0, $9QpM5.default).sincos(\u03B1);
    const [sin\u03B4, cos\u03B4] = (0, $9QpM5.default).sincos(\u03B4);
    // (23.4) p. 156
    return [
        (Yp * cos\u03B1 - Xp * sin\u03B1) / ($66020aba9d13c5db$var$c * cos\u03B4),
        -((Xp * cos\u03B1 + Yp * sin\u03B1) * sin\u03B4 - Zp * cos\u03B4) / $66020aba9d13c5db$var$c
    ];
}
const $66020aba9d13c5db$var$c = 17314463350 // unit is 1e-8 AU / day
;
// r = {T, L2, L3, L4, L5, L6, L7, L8, Lp, D, Mp, F}
const $66020aba9d13c5db$var$rvTerm = [
    function(r) {
        const [sinA, cosA] = (0, $9QpM5.default).sincos(r.L3);
        return [
            (-1719914 - 2 * r.T) * sinA - 25 * cosA,
            (25 - 13 * r.T) * sinA + (1578089 + 156 * r.T) * cosA,
            (10 + 32 * r.T) * sinA + (684185 - 358 * r.T) * cosA
        ];
    },
    function(r) {
        const [sinA, cosA] = (0, $9QpM5.default).sincos(2 * r.L3);
        return [
            (6434 + 141 * r.T) * sinA + (28007 - 107 * r.T) * cosA,
            (25697 - 95 * r.T) * sinA + (-5904 - 130 * r.T) * cosA,
            (11141 - 48 * r.T) * sinA + (-2559 - 55 * r.T) * cosA
        ];
    },
    function(r) {
        const [sinA, cosA] = (0, $9QpM5.default).sincos(r.L5);
        return [
            715 * sinA,
            6 * sinA - 657 * cosA,
            -15 * sinA - 282 * cosA
        ];
    },
    function(r) {
        const [sinA, cosA] = (0, $9QpM5.default).sincos(r.Lp);
        return [
            715 * sinA,
            -656 * cosA,
            -285 * cosA
        ];
    },
    function(r) {
        const [sinA, cosA] = (0, $9QpM5.default).sincos(3 * r.L3);
        return [
            (486 - 5 * r.T) * sinA + (-236 - 4 * r.T) * cosA,
            (-216 - 4 * r.T) * sinA + (-446 + 5 * r.T) * cosA,
            -94 * sinA - 193 * cosA
        ];
    },
    function(r) {
        const [sinA, cosA] = (0, $9QpM5.default).sincos(r.L6);
        return [
            159 * sinA,
            2 * sinA - 147 * cosA,
            -6 * sinA - 61 * cosA
        ];
    },
    function(r) {
        const cosA = Math.cos(r.F);
        return [
            0,
            26 * cosA,
            -59 * cosA
        ];
    },
    function(r) {
        const [sinA, cosA] = (0, $9QpM5.default).sincos(r.Lp + r.Mp);
        return [
            39 * sinA,
            -36 * cosA,
            -16 * cosA
        ];
    },
    function(r) {
        const [sinA, cosA] = (0, $9QpM5.default).sincos(2 * r.L5);
        return [
            33 * sinA - 10 * cosA,
            -9 * sinA - 30 * cosA,
            -5 * sinA - 13 * cosA
        ];
    },
    function(r) {
        const [sinA, cosA] = (0, $9QpM5.default).sincos(2 * r.L3 - r.L5);
        return [
            31 * sinA + cosA,
            sinA - 28 * cosA,
            -12 * cosA
        ];
    },
    function(r) {
        const [sinA, cosA] = (0, $9QpM5.default).sincos(3 * r.L3 - 8 * r.L4 + 3 * r.L5);
        return [
            8 * sinA - 28 * cosA,
            25 * sinA + 8 * cosA,
            11 * sinA + 3 * cosA
        ];
    },
    function(r) {
        const [sinA, cosA] = (0, $9QpM5.default).sincos(5 * r.L3 - 8 * r.L4 + 3 * r.L5);
        return [
            8 * sinA - 28 * cosA,
            -25 * sinA - 8 * cosA,
            -11 * sinA + -3 * cosA
        ];
    },
    function(r) {
        const [sinA, cosA] = (0, $9QpM5.default).sincos(2 * r.L2 - r.L3);
        return [
            21 * sinA,
            -19 * cosA,
            -8 * cosA
        ];
    },
    function(r) {
        const [sinA, cosA] = (0, $9QpM5.default).sincos(r.L2);
        return [
            -19 * sinA,
            17 * cosA,
            8 * cosA
        ];
    },
    function(r) {
        const [sinA, cosA] = (0, $9QpM5.default).sincos(r.L7);
        return [
            17 * sinA,
            -16 * cosA,
            -7 * cosA
        ];
    },
    function(r) {
        const [sinA, cosA] = (0, $9QpM5.default).sincos(r.L3 - 2 * r.L5);
        return [
            16 * sinA,
            15 * cosA,
            sinA + 7 * cosA
        ];
    },
    function(r) {
        const [sinA, cosA] = (0, $9QpM5.default).sincos(r.L8);
        return [
            16 * sinA,
            sinA - 15 * cosA,
            -3 * sinA - 6 * cosA
        ];
    },
    function(r) {
        const [sinA, cosA] = (0, $9QpM5.default).sincos(r.L3 + r.L5);
        return [
            11 * sinA - cosA,
            -sinA - 10 * cosA,
            -sinA - 5 * cosA
        ];
    },
    function(r) {
        const [sinA, cosA] = (0, $9QpM5.default).sincos(2 * r.L2 - 2 * r.L3);
        return [
            -11 * cosA,
            -10 * sinA,
            -4 * sinA
        ];
    },
    function(r) {
        const [sinA, cosA] = (0, $9QpM5.default).sincos(r.L3 - r.L5);
        return [
            -11 * sinA - 2 * cosA,
            -2 * sinA + 9 * cosA,
            -sinA + 4 * cosA
        ];
    },
    function(r) {
        const [sinA, cosA] = (0, $9QpM5.default).sincos(4 * r.L3);
        return [
            -7 * sinA - 8 * cosA,
            -8 * sinA + 6 * cosA,
            -3 * sinA + 3 * cosA
        ];
    },
    function(r) {
        const [sinA, cosA] = (0, $9QpM5.default).sincos(3 * r.L3 - 2 * r.L5);
        return [
            -10 * sinA,
            9 * cosA,
            4 * cosA
        ];
    },
    function(r) {
        const [sinA, cosA] = (0, $9QpM5.default).sincos(r.L2 - 2 * r.L3);
        return [
            -9 * sinA,
            -9 * cosA,
            -4 * cosA
        ];
    },
    function(r) {
        const [sinA, cosA] = (0, $9QpM5.default).sincos(2 * r.L2 - 3 * r.L3);
        return [
            -9 * sinA,
            -8 * cosA,
            -4 * cosA
        ];
    },
    function(r) {
        const [sinA, cosA] = (0, $9QpM5.default).sincos(2 * r.L6);
        return [
            -9 * cosA,
            -8 * sinA,
            -3 * sinA
        ];
    },
    function(r) {
        const [sinA, cosA] = (0, $9QpM5.default).sincos(2 * r.L2 - 4 * r.L3);
        return [
            -9 * cosA,
            8 * sinA,
            3 * sinA
        ];
    },
    function(r) {
        const [sinA, cosA] = (0, $9QpM5.default).sincos(3 * r.L3 - 2 * r.L4);
        return [
            8 * sinA,
            -8 * cosA,
            -3 * cosA
        ];
    },
    function(r) {
        const [sinA, cosA] = (0, $9QpM5.default).sincos(r.Lp + 2 * r.D - r.Mp);
        return [
            8 * sinA,
            -7 * cosA,
            -3 * cosA
        ];
    },
    function(r) {
        const [sinA, cosA] = (0, $9QpM5.default).sincos(8 * r.L2 - 12 * r.L3);
        return [
            -4 * sinA - 7 * cosA,
            -6 * sinA + 4 * cosA,
            -3 * sinA + 2 * cosA
        ];
    },
    function(r) {
        const [sinA, cosA] = (0, $9QpM5.default).sincos(8 * r.L2 - 14 * r.L3);
        return [
            -4 * sinA - 7 * cosA,
            6 * sinA - 4 * cosA,
            3 * sinA - 2 * cosA
        ];
    },
    function(r) {
        const [sinA, cosA] = (0, $9QpM5.default).sincos(2 * r.L4);
        return [
            -6 * sinA - 5 * cosA,
            -4 * sinA + 5 * cosA,
            -2 * sinA + 2 * cosA
        ];
    },
    function(r) {
        const [sinA, cosA] = (0, $9QpM5.default).sincos(3 * r.L2 - 4 * r.L3);
        return [
            -sinA - cosA,
            -2 * sinA - 7 * cosA,
            sinA - 4 * cosA
        ];
    },
    function(r) {
        const [sinA, cosA] = (0, $9QpM5.default).sincos(2 * r.L3 - 2 * r.L5);
        return [
            4 * sinA - 6 * cosA,
            -5 * sinA - 4 * cosA,
            -2 * sinA - 2 * cosA
        ];
    },
    function(r) {
        const [sinA, cosA] = (0, $9QpM5.default).sincos(3 * r.L2 - 3 * r.L3);
        return [
            -7 * cosA,
            -6 * sinA,
            -3 * sinA
        ];
    },
    function(r) {
        const [sinA, cosA] = (0, $9QpM5.default).sincos(2 * r.L3 - 2 * r.L4);
        return [
            5 * sinA - 5 * cosA,
            -4 * sinA - 5 * cosA,
            -2 * sinA - 2 * cosA
        ];
    },
    function(r) {
        const [sinA, cosA] = (0, $9QpM5.default).sincos(r.Lp - 2 * r.D);
        return [
            5 * sinA,
            -5 * cosA,
            -2 * cosA
        ];
    }
];
function $66020aba9d13c5db$export$65d74d40cdefedee(eqFrom, epochTo, m\u03B1, m\u03B4) {
    const t = epochTo - 2000;
    let eqTo = new (0, $77f14e36e565e56c$export$2e2bcd8739ae039).Equatorial();
    eqTo.ra = eqFrom.ra + m\u03B1.rad() * t;
    eqTo.dec = eqFrom.dec + m\u03B4.rad() * t;
    const jd = (0, $9QpM5.default).JulianYearToJDE(epochTo);
    const [\u0394\u03B1, \u0394\u03B4] = $66020aba9d13c5db$export$d2affbd77acccdb9(eqTo.ra, eqTo.dec, jd);
    eqTo.ra += \u0394\u03B1;
    eqTo.dec += \u0394\u03B4;
    eqTo = (0, $7b9a9495915be746$export$2e2bcd8739ae039).position(eqTo, 2000, epochTo, 0, 0);
    const [\u0394\u03B11, \u0394\u03B41] = $66020aba9d13c5db$export$34d2a3f43e8c5dd6(eqTo.ra, eqTo.dec, jd);
    eqTo.ra += \u0394\u03B11;
    eqTo.dec += \u0394\u03B41;
    return eqTo;
}
var $66020aba9d13c5db$export$2e2bcd8739ae039 = {
    nutation: $66020aba9d13c5db$export$34d2a3f43e8c5dd6,
    perihelion: $66020aba9d13c5db$export$407dd2a47a94200d,
    eclipticAberration: $66020aba9d13c5db$export$1dcbf4916a95b726,
    aberration: $66020aba9d13c5db$export$8bdd0d085f5dc0f2,
    position: $66020aba9d13c5db$export$5880b8b5730aff45,
    aberrationRonVondrak: $66020aba9d13c5db$export$d2affbd77acccdb9,
    positionRonVondrak: $66020aba9d13c5db$export$65d74d40cdefedee
};


/**
 * @copyright 2013 Sonia Keys
 * @copyright 2016 commenthol
 * @license MIT
 * @module apsis
 */ /**
 * Apsis: Chapter 50, Perigee and apogee of the Moon
 */ 
var $9QpM5 = parcelRequire("9QpM5");
const { sin: $376f550d407bd294$var$sin, cos: $376f550d407bd294$var$cos } = Math;
/**
 * conversion factor from k to T, given in (50.3) p. 356
 */ const $376f550d407bd294$var$ck = 1 / 1325.55;
const $376f550d407bd294$var$D2R = Math.PI / 180;
const $376f550d407bd294$export$938789a6994ad1a = 6378.137 // km
;
const $376f550d407bd294$export$74b6af3099e51c3f = 1738.1 // km
;
/**
 * mean time of perigee or apogee
 * (50.1) p. 355
 */ const $376f550d407bd294$var$mean = function(T) {
    return (0, $9QpM5.default).horner(T, 2451534.6698, 27.55454989 / $376f550d407bd294$var$ck, -0.0006691, -0.000001098, 0.0000000052);
};
/**
 * snap returns k at half h nearest year y.
 */ const $376f550d407bd294$var$snap = function(y, h) {
    const k = (y - 1999.97) * 13.2555 // (50.2) p. 355
    ;
    return Math.floor(k - h + 0.5) + h;
};
function $376f550d407bd294$export$acddb215e5a3aae7(year) {
    return $376f550d407bd294$var$mean($376f550d407bd294$var$snap(year, 0) * $376f550d407bd294$var$ck);
}
function $376f550d407bd294$export$ef3fbfd5eea0a35(year) {
    const l = new $376f550d407bd294$var$La(year, 0);
    return $376f550d407bd294$var$mean(l.T) + l.perigeeCorr();
}
function $376f550d407bd294$export$9b05b1ae12c580c7(year) {
    return $376f550d407bd294$var$mean($376f550d407bd294$var$snap(year, 0.5) * $376f550d407bd294$var$ck);
}
function $376f550d407bd294$export$b42571f20605ceb9(year) {
    const l = new $376f550d407bd294$var$La(year, 0.5);
    return $376f550d407bd294$var$mean(l.T) + l.apogeeCorr();
}
function $376f550d407bd294$export$24dd58fe9b00f7ce(year) {
    return new $376f550d407bd294$var$La(year, 0.5).apogeeParallax();
}
function $376f550d407bd294$export$ccc223c98f6335b6(year) {
    return new $376f550d407bd294$var$La(year, 0).perigeeParallax();
}
function $376f550d407bd294$export$9f17032d917177de(parallax) {
    return $376f550d407bd294$export$938789a6994ad1a / $376f550d407bd294$var$sin(parallax);
}
class $376f550d407bd294$var$La {
    constructor(y, h){
        this.k = $376f550d407bd294$var$snap(y, h);
        this.T = this.k * $376f550d407bd294$var$ck // (50.3) p. 350
        ;
        this.D = (0, $9QpM5.default).horner(this.T, 171.9179 * $376f550d407bd294$var$D2R, 335.9106046 * $376f550d407bd294$var$D2R / $376f550d407bd294$var$ck, -0.0100383 * $376f550d407bd294$var$D2R, -0.00001156 * $376f550d407bd294$var$D2R, 0.000000055 * $376f550d407bd294$var$D2R);
        this.M = (0, $9QpM5.default).horner(this.T, 347.3477 * $376f550d407bd294$var$D2R, 27.1577721 * $376f550d407bd294$var$D2R / $376f550d407bd294$var$ck, -0.000813 * $376f550d407bd294$var$D2R, -0.000001 * $376f550d407bd294$var$D2R);
        this.F = (0, $9QpM5.default).horner(this.T, 316.6109 * $376f550d407bd294$var$D2R, 364.5287911 * $376f550d407bd294$var$D2R / $376f550d407bd294$var$ck, -0.0125053 * $376f550d407bd294$var$D2R, -0.0000148 * $376f550d407bd294$var$D2R);
        return this;
    }
    /**
   * perigee correction
   */ perigeeCorr() {
        const l = this;
        return -1.6769 * $376f550d407bd294$var$sin(2 * l.D) + 0.4589 * $376f550d407bd294$var$sin(4 * l.D) + -0.1856 * $376f550d407bd294$var$sin(6 * l.D) + 0.0883 * $376f550d407bd294$var$sin(8 * l.D) + (-0.0773 + 0.00019 * l.T) * $376f550d407bd294$var$sin(2 * l.D - l.M) + (0.0502 - 0.00013 * l.T) * $376f550d407bd294$var$sin(l.M) + -0.046 * $376f550d407bd294$var$sin(10 * l.D) + (0.0422 - 0.00011 * l.T) * $376f550d407bd294$var$sin(4 * l.D - l.M) + -0.0256 * $376f550d407bd294$var$sin(6 * l.D - l.M) + 0.0253 * $376f550d407bd294$var$sin(12 * l.D) + 0.0237 * $376f550d407bd294$var$sin(l.D) + 0.0162 * $376f550d407bd294$var$sin(8 * l.D - l.M) + -0.0145 * $376f550d407bd294$var$sin(14 * l.D) + 0.0129 * $376f550d407bd294$var$sin(2 * l.F) + -0.0112 * $376f550d407bd294$var$sin(3 * l.D) + -0.0104 * $376f550d407bd294$var$sin(10 * l.D - l.M) + 0.0086 * $376f550d407bd294$var$sin(16 * l.D) + 0.0069 * $376f550d407bd294$var$sin(12 * l.D - l.M) + 0.0066 * $376f550d407bd294$var$sin(5 * l.D) + -0.0053 * $376f550d407bd294$var$sin(2 * (l.D + l.F)) + -0.0052 * $376f550d407bd294$var$sin(18 * l.D) + -0.0046 * $376f550d407bd294$var$sin(14 * l.D - l.M) + -0.0041 * $376f550d407bd294$var$sin(7 * l.D) + 0.004 * $376f550d407bd294$var$sin(2 * l.D + l.M) + 0.0032 * $376f550d407bd294$var$sin(20 * l.D) + -0.0032 * $376f550d407bd294$var$sin(l.D + l.M) + 0.0031 * $376f550d407bd294$var$sin(16 * l.D - l.M) + -0.0029 * $376f550d407bd294$var$sin(4 * l.D + l.M) + 0.0027 * $376f550d407bd294$var$sin(9 * l.D) + 0.0027 * $376f550d407bd294$var$sin(4 * l.D + 2 * l.F) + -0.0027 * $376f550d407bd294$var$sin(2 * (l.D - l.M)) + 0.0024 * $376f550d407bd294$var$sin(4 * l.D - 2 * l.M) + -0.0021 * $376f550d407bd294$var$sin(6 * l.D - 2 * l.M) + -0.0021 * $376f550d407bd294$var$sin(22 * l.D) + -0.0021 * $376f550d407bd294$var$sin(18 * l.D - l.M) + 0.0019 * $376f550d407bd294$var$sin(6 * l.D + l.M) + -0.0018 * $376f550d407bd294$var$sin(11 * l.D) + -0.0014 * $376f550d407bd294$var$sin(8 * l.D + l.M) + -0.0014 * $376f550d407bd294$var$sin(4 * l.D - 2 * l.F) + -0.0014 * $376f550d407bd294$var$sin(6 * l.D + 2 * l.F) + 0.0014 * $376f550d407bd294$var$sin(3 * l.D + l.M) + -0.0014 * $376f550d407bd294$var$sin(5 * l.D + l.M) + 0.0013 * $376f550d407bd294$var$sin(13 * l.D) + 0.0013 * $376f550d407bd294$var$sin(20 * l.D - l.M) + 0.0011 * $376f550d407bd294$var$sin(3 * l.D + 2 * l.M) + -0.0011 * $376f550d407bd294$var$sin(2 * (2 * l.D + l.F - l.M)) + -0.001 * $376f550d407bd294$var$sin(l.D + 2 * l.M) + -0.0009 * $376f550d407bd294$var$sin(22 * l.D - l.M) + -0.0008 * $376f550d407bd294$var$sin(4 * l.F) + 0.0008 * $376f550d407bd294$var$sin(6 * l.D - 2 * l.F) + 0.0008 * $376f550d407bd294$var$sin(2 * (l.D - l.F) + l.M) + 0.0007 * $376f550d407bd294$var$sin(2 * l.M) + 0.0007 * $376f550d407bd294$var$sin(2 * l.F - l.M) + 0.0007 * $376f550d407bd294$var$sin(2 * l.D + 4 * l.F) + -0.0006 * $376f550d407bd294$var$sin(2 * (l.F - l.M)) + -0.0006 * $376f550d407bd294$var$sin(2 * (l.D - l.F + l.M)) + 0.0006 * $376f550d407bd294$var$sin(24 * l.D) + 0.0005 * $376f550d407bd294$var$sin(4 * (l.D - l.F)) + 0.0005 * $376f550d407bd294$var$sin(2 * (l.D + l.M)) + -0.0004 * $376f550d407bd294$var$sin(l.D - l.M);
    }
    /**
   * apogee correction
   */ apogeeCorr() {
        const l = this;
        return 0.4392 * $376f550d407bd294$var$sin(2 * l.D) + 0.0684 * $376f550d407bd294$var$sin(4 * l.D) + (0.0456 - 0.00011 * l.T) * $376f550d407bd294$var$sin(l.M) + (0.0426 - 0.00011 * l.T) * $376f550d407bd294$var$sin(2 * l.D - l.M) + 0.0212 * $376f550d407bd294$var$sin(2 * l.F) + -0.0189 * $376f550d407bd294$var$sin(l.D) + 0.0144 * $376f550d407bd294$var$sin(6 * l.D) + 0.0113 * $376f550d407bd294$var$sin(4 * l.D - l.M) + 0.0047 * $376f550d407bd294$var$sin(2 * (l.D + l.F)) + 0.0036 * $376f550d407bd294$var$sin(l.D + l.M) + 0.0035 * $376f550d407bd294$var$sin(8 * l.D) + 0.0034 * $376f550d407bd294$var$sin(6 * l.D - l.M) + -0.0034 * $376f550d407bd294$var$sin(2 * (l.D - l.F)) + 0.0022 * $376f550d407bd294$var$sin(2 * (l.D - l.M)) + -0.0017 * $376f550d407bd294$var$sin(3 * l.D) + 0.0013 * $376f550d407bd294$var$sin(4 * l.D + 2 * l.F) + 0.0011 * $376f550d407bd294$var$sin(8 * l.D - l.M) + 0.001 * $376f550d407bd294$var$sin(4 * l.D - 2 * l.M) + 0.0009 * $376f550d407bd294$var$sin(10 * l.D) + 0.0007 * $376f550d407bd294$var$sin(3 * l.D + l.M) + 0.0006 * $376f550d407bd294$var$sin(2 * l.M) + 0.0005 * $376f550d407bd294$var$sin(2 * l.D + l.M) + 0.0005 * $376f550d407bd294$var$sin(2 * (l.D + l.M)) + 0.0004 * $376f550d407bd294$var$sin(6 * l.D + 2 * l.F) + 0.0004 * $376f550d407bd294$var$sin(6 * l.D - 2 * l.M) + 0.0004 * $376f550d407bd294$var$sin(10 * l.D - l.M) + -0.0004 * $376f550d407bd294$var$sin(5 * l.D) + -0.0004 * $376f550d407bd294$var$sin(4 * l.D - 2 * l.F) + 0.0003 * $376f550d407bd294$var$sin(2 * l.F + l.M) + 0.0003 * $376f550d407bd294$var$sin(12 * l.D) + 0.0003 * $376f550d407bd294$var$sin(2 * l.D + 2 * l.F - l.M) + -0.0003 * $376f550d407bd294$var$sin(l.D - l.M);
    }
    /**
   * apogee parallax
   */ apogeeParallax() {
        const s = Math.PI / 180 / 3600;
        const l = this;
        return 3245.251 * s + -9.147 * s * $376f550d407bd294$var$cos(2 * l.D) + -0.841 * s * $376f550d407bd294$var$cos(l.D) + 0.697 * s * $376f550d407bd294$var$cos(2 * l.F) + (-0.656 * s + 0.0016 * s * l.T) * $376f550d407bd294$var$cos(l.M) + 0.355 * s * $376f550d407bd294$var$cos(4 * l.D) + 0.159 * s * $376f550d407bd294$var$cos(2 * l.D - l.M) + 0.127 * s * $376f550d407bd294$var$cos(l.D + l.M) + 0.065 * s * $376f550d407bd294$var$cos(4 * l.D - l.M) + 0.052 * s * $376f550d407bd294$var$cos(6 * l.D) + 0.043 * s * $376f550d407bd294$var$cos(2 * l.D + l.M) + 0.031 * s * $376f550d407bd294$var$cos(2 * (l.D + l.F)) + -0.023 * s * $376f550d407bd294$var$cos(2 * (l.D - l.F)) + 0.022 * s * $376f550d407bd294$var$cos(2 * (l.D - l.M)) + 0.019 * s * $376f550d407bd294$var$cos(2 * (l.D + l.M)) + -0.016 * s * $376f550d407bd294$var$cos(2 * l.M) + 0.014 * s * $376f550d407bd294$var$cos(6 * l.D - l.M) + 0.01 * s * $376f550d407bd294$var$cos(8 * l.D);
    }
    /**
   * perigee parallax
   */ perigeeParallax() {
        const s = Math.PI / 180 / 3600;
        const l = this;
        return 3629.215 * s + 63.224 * s * $376f550d407bd294$var$cos(2 * l.D) + -6.99 * s * $376f550d407bd294$var$cos(4 * l.D) + (2.834 * s - 0.0071 * l.T * s) * $376f550d407bd294$var$cos(2 * l.D - l.M) + 1.927 * s * $376f550d407bd294$var$cos(6 * l.D) + -1.263 * s * $376f550d407bd294$var$cos(l.D) + -0.702 * s * $376f550d407bd294$var$cos(8 * l.D) + (0.696 * s - 0.0017 * l.T * s) * $376f550d407bd294$var$cos(l.M) + -0.69 * s * $376f550d407bd294$var$cos(2 * l.F) + (-0.629 * s + 0.0016 * l.T * s) * $376f550d407bd294$var$cos(4 * l.D - l.M) + -0.392 * s * $376f550d407bd294$var$cos(2 * (l.D - l.F)) + 0.297 * s * $376f550d407bd294$var$cos(10 * l.D) + 0.260 * s * $376f550d407bd294$var$cos(6 * l.D - l.M) + 0.201 * s * $376f550d407bd294$var$cos(3 * l.D) + -0.161 * s * $376f550d407bd294$var$cos(2 * l.D + l.M) + 0.157 * s * $376f550d407bd294$var$cos(l.D + l.M) + -0.138 * s * $376f550d407bd294$var$cos(12 * l.D) + -0.127 * s * $376f550d407bd294$var$cos(8 * l.D - l.M) + 0.104 * s * $376f550d407bd294$var$cos(2 * (l.D + l.F)) + 0.104 * s * $376f550d407bd294$var$cos(2 * (l.D - l.M)) + -0.079 * s * $376f550d407bd294$var$cos(5 * l.D) + 0.068 * s * $376f550d407bd294$var$cos(14 * l.D) + 0.067 * s * $376f550d407bd294$var$cos(10 * l.D - l.M) + 0.054 * s * $376f550d407bd294$var$cos(4 * l.D + l.M) + -0.038 * s * $376f550d407bd294$var$cos(12 * l.D - l.M) + -0.038 * s * $376f550d407bd294$var$cos(4 * l.D - 2 * l.M) + 0.037 * s * $376f550d407bd294$var$cos(7 * l.D) + -0.037 * s * $376f550d407bd294$var$cos(4 * l.D + 2 * l.F) + -0.035 * s * $376f550d407bd294$var$cos(16 * l.D) + -0.03 * s * $376f550d407bd294$var$cos(3 * l.D + l.M) + 0.029 * s * $376f550d407bd294$var$cos(l.D - l.M) + -0.025 * s * $376f550d407bd294$var$cos(6 * l.D + l.M) + 0.023 * s * $376f550d407bd294$var$cos(2 * l.M) + 0.023 * s * $376f550d407bd294$var$cos(14 * l.D - l.M) + -0.023 * s * $376f550d407bd294$var$cos(2 * (l.D + l.M)) + 0.022 * s * $376f550d407bd294$var$cos(6 * l.D - 2 * l.M) + -0.021 * s * $376f550d407bd294$var$cos(2 * l.D - 2 * l.F - l.M) + -0.02 * s * $376f550d407bd294$var$cos(9 * l.D) + 0.019 * s * $376f550d407bd294$var$cos(18 * l.D) + 0.017 * s * $376f550d407bd294$var$cos(6 * l.D + 2 * l.F) + 0.014 * s * $376f550d407bd294$var$cos(2 * l.F - l.M) + -0.014 * s * $376f550d407bd294$var$cos(16 * l.D - l.M) + 0.013 * s * $376f550d407bd294$var$cos(4 * l.D - 2 * l.F) + 0.012 * s * $376f550d407bd294$var$cos(8 * l.D + l.M) + 0.011 * s * $376f550d407bd294$var$cos(11 * l.D) + 0.010 * s * $376f550d407bd294$var$cos(5 * l.D + l.M) + -0.01 * s * $376f550d407bd294$var$cos(20 * l.D);
    }
}
var $376f550d407bd294$export$2e2bcd8739ae039 = {
    EARTH_RADIUS: $376f550d407bd294$export$938789a6994ad1a,
    MOON_RADIUS: $376f550d407bd294$export$74b6af3099e51c3f,
    meanPerigee: $376f550d407bd294$export$acddb215e5a3aae7,
    perigee: $376f550d407bd294$export$ef3fbfd5eea0a35,
    meanApogee: $376f550d407bd294$export$9b05b1ae12c580c7,
    apogee: $376f550d407bd294$export$b42571f20605ceb9,
    apogeeParallax: $376f550d407bd294$export$24dd58fe9b00f7ce,
    perigeeParallax: $376f550d407bd294$export$ccc223c98f6335b6,
    distance: $376f550d407bd294$export$9f17032d917177de
};



var $9QpM5 = parcelRequire("9QpM5");
/**
 * @copyright 2013 Sonia Keys
 * @copyright 2016 commenthol
 * @license MIT
 * @module binary
 */ /**
 * Binary: Chapter 57, Binary Stars
 */ 
var $9QpM5 = parcelRequire("9QpM5");
const { atan: $5d54de017e12c818$var$atan, atan2: $5d54de017e12c818$var$atan2, cos: $5d54de017e12c818$var$cos, sqrt: $5d54de017e12c818$var$sqrt, tan: $5d54de017e12c818$var$tan } = Math;
function $5d54de017e12c818$export$af3c22e2cbc805e9(year, T, P) {
    const n = 2 * Math.PI / P;
    return (0, $9QpM5.default).pmod(n * (year - T), 2 * Math.PI);
}
function $5d54de017e12c818$export$5880b8b5730aff45(a, e, i, \u03A9, \u03C9, E) {
    const r = a * (1 - e * $5d54de017e12c818$var$cos(E));
    const \u03BD = 2 * $5d54de017e12c818$var$atan($5d54de017e12c818$var$sqrt((1 + e) / (1 - e)) * $5d54de017e12c818$var$tan(E / 2));
    const [sin\u03BD\u03C9, cos\u03BD\u03C9] = (0, $9QpM5.default).sincos(\u03BD + \u03C9);
    const cosi = $5d54de017e12c818$var$cos(i);
    const num = sin\u03BD\u03C9 * cosi;
    let \u03B8 = $5d54de017e12c818$var$atan2(num, cos\u03BD\u03C9) + \u03A9;
    if (\u03B8 < 0) \u03B8 += 2 * Math.PI;
    const \u03C1 = r * $5d54de017e12c818$var$sqrt(num * num + cos\u03BD\u03C9 * cos\u03BD\u03C9);
    return [
        \u03B8,
        \u03C1
    ];
}
function $5d54de017e12c818$export$3e3c873bedc3a284(e, i, \u03C9) {
    const cosi = $5d54de017e12c818$var$cos(i);
    const [sin\u03C9, cos\u03C9] = (0, $9QpM5.default).sincos(\u03C9);
    const A = (1 - e * e * cos\u03C9 * cos\u03C9) * cosi * cosi;
    const B = e * e * sin\u03C9 * cos\u03C9 * cosi;
    const C = 1 - e * e * sin\u03C9 * sin\u03C9;
    const d = A - C;
    const sqrtD = $5d54de017e12c818$var$sqrt(d * d + 4 * B * B);
    return $5d54de017e12c818$var$sqrt(2 * sqrtD / (A + C + sqrtD));
}
var $5d54de017e12c818$export$2e2bcd8739ae039 = {
    meanAnomaly: $5d54de017e12c818$export$af3c22e2cbc805e9,
    position: $5d54de017e12c818$export$5880b8b5730aff45,
    apparentEccentricity: $5d54de017e12c818$export$3e3c873bedc3a284
};



/**
 * @copyright 2013 Sonia Keys
 * @copyright 2016 commenthol
 * @license MIT
 * @module conjunction
 */ /**
 * Conjunction: Chapter 18: Planetary Conjunctions.
 */ parcelRequire("9QpM5");

function $01f0c665171d3d03$export$b4d2a043f6dcb2a8(t1, t5, cs1, cs2) {
    if (cs1.length !== 5 || cs2.length !== 5) throw new Error('Five rows required in ephemerides');
    const dr = new Array(5);
    const dd = new Array(5);
    cs1.forEach((r, i)=>{
        dr[i] = cs2[i].ra - cs1[i].ra;
        dd[i] = cs2[i].dec - cs1[i].dec;
    });
    return $01f0c665171d3d03$var$conj(t1, t5, dr, dd);
}
function $01f0c665171d3d03$export$2b9bd2686112a263(t1, t5, c1, cs2) {
    if (cs2.length !== 5) throw new Error('Five rows required in ephemerides');
    const dr = new Array(5);
    const dd = new Array(5);
    cs2.forEach((r, i)=>{
        dr[i] = cs2[i].ra - c1.ra;
        dd[i] = cs2[i].dec - c1.dec;
    });
    return $01f0c665171d3d03$var$conj(t1, t5, dr, dd);
}
const $01f0c665171d3d03$var$conj = function(t1, t5, dr, dd) {
    let l5 = new (0, $7480a29e66a7d324$export$2e2bcd8739ae039).Len5(t1, t5, dr);
    const t = l5.zero(true);
    l5 = new (0, $7480a29e66a7d324$export$2e2bcd8739ae039).Len5(t1, t5, dd);
    const \u0394d = l5.interpolateXStrict(t);
    return [
        t,
        \u0394d
    ];
};
var $01f0c665171d3d03$export$2e2bcd8739ae039 = {
    planetary: $01f0c665171d3d03$export$b4d2a043f6dcb2a8,
    stellar: $01f0c665171d3d03$export$2b9bd2686112a263
};


/**
 * @copyright 2013 Sonia Keys
 * @copyright 2016 commenthol
 * @license MIT
 * @module circle
 */ /**
 * Circle: Chapter 20, Smallest Circle containing three Celestial Bodies.
 */ parcelRequire("9QpM5");
function $9c60e3ab73fbfbfe$export$c253db0078641cbf(c1, c2, c3) {
    // Using haversine formula
    const cd1 = Math.cos(c1.dec);
    const cd2 = Math.cos(c2.dec);
    const cd3 = Math.cos(c3.dec);
    let a = 2 * Math.asin(Math.sqrt($9c60e3ab73fbfbfe$var$hav(c2.dec - c1.dec) + cd1 * cd2 * $9c60e3ab73fbfbfe$var$hav(c2.ra - c1.ra)));
    let b = 2 * Math.asin(Math.sqrt($9c60e3ab73fbfbfe$var$hav(c3.dec - c2.dec) + cd2 * cd3 * $9c60e3ab73fbfbfe$var$hav(c3.ra - c2.ra)));
    let c = 2 * Math.asin(Math.sqrt($9c60e3ab73fbfbfe$var$hav(c1.dec - c3.dec) + cd3 * cd1 * $9c60e3ab73fbfbfe$var$hav(c1.ra - c3.ra)));
    if (b > a) [a, b] = $9c60e3ab73fbfbfe$var$noswap(b, a);
    if (c > a) [a, c] = $9c60e3ab73fbfbfe$var$noswap(c, a);
    if (a * a >= b * b + c * c) return [
        a,
        true
    ];
    // (20.1) p. 128
    return [
        2 * a * b * c / Math.sqrt((a + b + c) * (a + b - c) * (b + c - a) * (a + c - b)),
        false
    ];
}
const $9c60e3ab73fbfbfe$var$noswap = function(a, b) {
    return [
        a,
        b
    ];
};
/**
 * haversine function (17.5) p. 115
 */ const $9c60e3ab73fbfbfe$var$hav = function(a) {
    return 0.5 * (1 - Math.cos(a));
};
var $9c60e3ab73fbfbfe$export$2e2bcd8739ae039 = {
    smallest: $9c60e3ab73fbfbfe$export$c253db0078641cbf
};


/**
 * @copyright 2013 Sonia Keys
 * @copyright 2016 commenthol
 * @license MIT
 * @module deltat
 */ /**
 * DeltaT: Chapter 10, Dynamical Time and Universal Time.
 *
 * This package uses no functions from the Chapter. Polynoms are from
 * <http://eclipse.gsfc.nasa.gov/SEcat5/deltatpoly.html>, data sets are from
 * <http://maia.usno.navy.mil/ser7/>
 *
 * Functions in this package compute ΔT for various ranges of dates.
 *
 * ΔT = TD - UT1
 *
 * TD = "Dynamical Time", which is related to:
 *   ET "Ephermis Time", an older term.
 *   TDB "Barycentric Dynamical Time", very close to TD.
 *   TDT "Terrestrial Dynamical Time", a more correct term.
 *   TT "Terrestrial Time", a newer and more correct term.
 *
 * UT = "Universal Time", which is related (if ambiguously) to GMT "Greenwich
 * Mean Time".
 *
 * Terrestrial Time is effectively equal to International Atomic Time (TAI)
 * plus 32.184 seconds exactly: TT = TAI + 32.184
 * The epoch designated "J2000.0" is specified as Julian date 2451545.0 TT,
 * or 2000 January 1, 12h TT. This epoch can also be expressed as
 * 2000 January 1, 11:59:27.816 TAI or 2000 January 1, 11:58:55.816 UTC.
 */ 
var $9QpM5 = parcelRequire("9QpM5");

/**
 * DO NOT EDIT MANUALLY
 * Use `scripts/deltat.js` to generate file.
 * Datasets are from <https://maia.usno.navy.mil/ser7> and
 * <ftp://ftp.iers.org/products/eop/rapid/standard>
 */ const $7da48ceeb6b9c888$var$m = {
    historic: {
        table: [
            44,
            43,
            43,
            41,
            40,
            39,
            38,
            37,
            37,
            36,
            36,
            36,
            37,
            37,
            38,
            37,
            36,
            36,
            35,
            35,
            34,
            33,
            33,
            32,
            32,
            31,
            31,
            30,
            30,
            29,
            29,
            29,
            29,
            29,
            28,
            28,
            27,
            27,
            26,
            26,
            25,
            25,
            25,
            26,
            26,
            26,
            26,
            25,
            25,
            25,
            24,
            24,
            24,
            24,
            24,
            24,
            24,
            24,
            24,
            24,
            23,
            23,
            23,
            23,
            22,
            22,
            22,
            22,
            22,
            21,
            21,
            21,
            21,
            21,
            21,
            21,
            21,
            20,
            20,
            20,
            20,
            20,
            20,
            20,
            20,
            20,
            21,
            21,
            21,
            20,
            20,
            20,
            20,
            20,
            19,
            19,
            19,
            19,
            19,
            20,
            20,
            20,
            20,
            19,
            20,
            20,
            20,
            20,
            20,
            20,
            21,
            21,
            21,
            21,
            21,
            21,
            21,
            21,
            21,
            21,
            21,
            21,
            21,
            21,
            21,
            21,
            21.1,
            21,
            21,
            21,
            20.9,
            20.8,
            20.7,
            20.6,
            20.4,
            20.2,
            20,
            19.7,
            19.4,
            19.1,
            18.7,
            18.3,
            17.8,
            17.4,
            17,
            16.8,
            16.6,
            16.4,
            16.1,
            15.9,
            15.7,
            15.5,
            15.3,
            15,
            14.7,
            14.5,
            14.3,
            14.2,
            14.1,
            14.1,
            14.1,
            13.9,
            13.7,
            13.6,
            13.5,
            13.5,
            13.5,
            13.5,
            13.4,
            13.4,
            13.4,
            13.4,
            13.3,
            13.3,
            13.2,
            13.2,
            13.2,
            13.1,
            13.1,
            13.1,
            13,
            13.2,
            13.3,
            13.4,
            13.5,
            13.6,
            13.7,
            13.8,
            13.9,
            14,
            14,
            14.1,
            14.1,
            14.1,
            14.1,
            14.2,
            14.3,
            14.4,
            14.4,
            14.5,
            14.6,
            14.6,
            14.7,
            14.7,
            14.7,
            14.8,
            14.8,
            14.9,
            14.9,
            15,
            15,
            15.1,
            15.2,
            15.3,
            15.4,
            15.5,
            15.6,
            15.6,
            15.6,
            15.8,
            15.9,
            15.9,
            15.9,
            15.8,
            15.7,
            15.8,
            15.7,
            15.7,
            15.7,
            15.8,
            15.9,
            16.1,
            16.1,
            16,
            15.9,
            15.9,
            15.7,
            15.4,
            15.3,
            15.4,
            15.5,
            15.6,
            15.6,
            15.6,
            15.6,
            15.6,
            15.6,
            15.6,
            15.5,
            15.5,
            15.4,
            15.3,
            15.2,
            15.1,
            14.9,
            14.8,
            14.6,
            14.4,
            14.3,
            14.2,
            14.1,
            14.2,
            14.2,
            13.9,
            13.7,
            13.5,
            13.3,
            13.1,
            13,
            13.2,
            13.2,
            13.1,
            13.1,
            13.2,
            13.3,
            13.5,
            13.5,
            13.4,
            13.2,
            13.2,
            13.1,
            13.1,
            13,
            12.8,
            12.6,
            12.7,
            12.6,
            12.3,
            12,
            11.9,
            11.8,
            11.6,
            11.4,
            11.2,
            11.1,
            11.1,
            11.1,
            11.1,
            11.1,
            11.2,
            11.1,
            11.1,
            11.2,
            11.4,
            11.5,
            11.3,
            11.2,
            11.4,
            11.7,
            11.9,
            11.9,
            11.9,
            11.8,
            11.7,
            11.8,
            11.8,
            11.8,
            11.7,
            11.6,
            11.6,
            11.5,
            11.5,
            11.4,
            11.4,
            11.3,
            11.3,
            11.13,
            11.16,
            10.94,
            10.72,
            10.29,
            10.04,
            9.94,
            9.91,
            9.88,
            9.86,
            9.72,
            9.67,
            9.66,
            9.64,
            9.51,
            9.4,
            9.21,
            9,
            8.6,
            8.29,
            7.95,
            7.73,
            7.59,
            7.49,
            7.36,
            7.26,
            7.1,
            7,
            6.89,
            6.82,
            6.73,
            6.64,
            6.39,
            6.28,
            6.25,
            6.27,
            6.25,
            6.27,
            6.22,
            6.24,
            6.22,
            6.27,
            6.3,
            6.36,
            6.35,
            6.37,
            6.32,
            6.33,
            6.33,
            6.37,
            6.37,
            6.41,
            6.4,
            6.44,
            6.46,
            6.51,
            6.48,
            6.51,
            6.53,
            6.58,
            6.55,
            6.61,
            6.69,
            6.8,
            6.84,
            6.94,
            7.03,
            7.13,
            7.15,
            7.22,
            7.26,
            7.3,
            7.23,
            7.22,
            7.21,
            7.2,
            6.99,
            6.98,
            7.19,
            7.36,
            7.35,
            7.39,
            7.41,
            7.45,
            7.36,
            7.18,
            6.95,
            6.72,
            6.45,
            6.24,
            5.92,
            5.59,
            5.15,
            4.67,
            4.11,
            3.52,
            2.94,
            2.47,
            1.97,
            1.52,
            1.04,
            0.6,
            0.11,
            -0.34,
            -0.82,
            -1.25,
            -1.7,
            -2.08,
            -2.48,
            -2.82,
            -3.19,
            -3.5,
            -3.84,
            -4.14,
            -4.43,
            -4.59,
            -4.79,
            -4.92,
            -5.09,
            -5.24,
            -5.36,
            -5.34,
            -5.37,
            -5.32,
            -5.34,
            -5.33,
            -5.4,
            -5.47,
            -5.58,
            -5.66,
            -5.74,
            -5.68,
            -5.69,
            -5.65,
            -5.67,
            -5.68,
            -5.73,
            -5.72,
            -5.78,
            -5.79,
            -5.86,
            -5.89,
            -6.01,
            -6.13,
            -6.28,
            -6.41,
            -6.53,
            -6.49,
            -6.5,
            -6.45,
            -6.41,
            -6.26,
            -6.11,
            -5.9,
            -5.63,
            -5.13,
            -4.68,
            -4.19,
            -3.72,
            -3.21,
            -2.7,
            -2.09,
            -1.48,
            -0.75,
            -0.08,
            0.62,
            1.26,
            1.95,
            2.59,
            3.28,
            3.92,
            4.61,
            5.2,
            5.73,
            6.29,
            7,
            7.68,
            8.45,
            9.13,
            9.78,
            10.38,
            10.99,
            11.64,
            12.47,
            13.23,
            14,
            14.69,
            15.38,
            16,
            16.64,
            17.19,
            17.72,
            18.19,
            18.67,
            19.13,
            19.69,
            20.14,
            20.54,
            20.86,
            21.14,
            21.41,
            21.78,
            22.06,
            22.3,
            22.51,
            22.79,
            23.01,
            23.29,
            23.46,
            23.55,
            23.63,
            23.8,
            23.95,
            24.25,
            24.39,
            24.42,
            24.34,
            24.22,
            24.1,
            24.08,
            24.02,
            24.04,
            23.98,
            23.91,
            23.89,
            23.95,
            23.93,
            23.92,
            23.88,
            23.94,
            23.91,
            23.82,
            23.76,
            23.87,
            23.91,
            23.95,
            23.96,
            24,
            24.04,
            24.2,
            24.35,
            24.61,
            24.82,
            25.09,
            25.3,
            25.56,
            25.77,
            26.05,
            26.27,
            26.54,
            26.76,
            27.04,
            27.27,
            27.55,
            27.77,
            28.03,
            28.25,
            28.5,
            28.7,
            28.95,
            29.15,
            29.38,
            29.57,
            29.8,
            29.97,
            30.19,
            30.36,
            30.57,
            30.72,
            30.93,
            31.07,
            31.24,
            31.349,
            31.516,
            31.677,
            31.923,
            32.166,
            32.449,
            32.671,
            32.919,
            33.15,
            33.397,
            33.584,
            33.804,
            33.992,
            34.24,
            34.466,
            34.731,
            35.03,
            35.4,
            35.738,
            36.147,
            36.546,
            36.995,
            37.429,
            37.879,
            38.291,
            38.753,
            39.204,
            39.707,
            40.182,
            40.706,
            41.17,
            41.686,
            42.227,
            42.825,
            43.373,
            43.959,
            44.486,
            44.997,
            45.477,
            45.983,
            46.458,
            46.997,
            47.521,
            48.034,
            48.535,
            49.099,
            49.589,
            50.102,
            50.54,
            50.975,
            51.382,
            51.81,
            52.168,
            52.572,
            52.957,
            53.434,
            53.789,
            54.087
        ],
        first: 1657,
        last: 1984.5
    },
    data: {
        table: [
            43.4724372,
            43.5648351,
            43.6736863,
            43.7782156,
            43.8763273,
            43.9562443,
            44.0314956,
            44.1131788,
            44.1982187,
            44.2951747,
            44.3936471,
            44.4840562,
            44.5646335,
            44.6425099,
            44.7385767,
            44.8370135,
            44.9302138,
            44.9986146,
            45.0583549,
            45.1283911,
            45.2063835,
            45.2980068,
            45.3897017,
            45.476138,
            45.5632485,
            45.6450189,
            45.7374593,
            45.8283721,
            45.9132976,
            45.9819705,
            46.0407484,
            46.1067084,
            46.1825041,
            46.2788561,
            46.3713351,
            46.4567207,
            46.544486,
            46.6310899,
            46.7302231,
            46.8283588,
            46.9247443,
            46.9969757,
            47.0709148,
            47.1450515,
            47.2361542,
            47.3413241,
            47.4319364,
            47.5213815,
            47.6049313,
            47.6837388,
            47.7781381,
            47.8770756,
            47.9687104,
            48.0348257,
            48.0942021,
            48.1608205,
            48.2460028,
            48.3438529,
            48.4355405,
            48.5344163,
            48.6324506,
            48.7293718,
            48.8365414,
            48.9353232,
            49.0318781,
            49.1013205,
            49.1590844,
            49.2285534,
            49.3069683,
            49.4017939,
            49.4945263,
            49.5861495,
            49.6804907,
            49.7602264,
            49.8555805,
            49.9489224,
            50.0346777,
            50.1018531,
            50.1621723,
            50.2260014,
            50.2967905,
            50.3831254,
            50.4598772,
            50.5387068,
            50.6160484,
            50.6865941,
            50.7658362,
            50.8453698,
            50.918672,
            50.9761148,
            51.0278017,
            51.084323,
            51.1537928,
            51.2318645,
            51.306308,
            51.3807849,
            51.4526292,
            51.5160394,
            51.5985479,
            51.680924,
            51.7572854,
            51.8133335,
            51.8532385,
            51.9014358,
            51.9603433,
            52.0328072,
            52.0984957,
            52.1667826,
            52.2316418,
            52.2938376,
            52.3679897,
            52.4465221,
            52.5179552,
            52.5751485,
            52.6178012,
            52.666816,
            52.7340036,
            52.8055792,
            52.8792189,
            52.9564838,
            53.0444971,
            53.126769,
            53.2196749,
            53.3024139,
            53.3746645,
            53.4335399,
            53.4778015,
            53.5299937,
            53.5845392,
            53.6522628,
            53.7255844,
            53.7882418,
            53.8366625,
            53.8829665,
            53.9442904,
            54.0042478,
            54.0536342,
            54.085644,
            54.1084122,
            54.1462942,
            54.1913988,
            54.2452023,
            54.2957622,
            54.3427024,
            54.3910864,
            54.4319877,
            54.4897699,
            54.545636,
            54.597741,
            54.6354962,
            54.6532352,
            54.677594,
            54.7173643,
            54.7740957,
            54.8253023,
            54.8712512,
            54.916146,
            54.9580535,
            54.9997186,
            55.047571,
            55.0911778,
            55.1132386,
            55.132774,
            55.1532423,
            55.1898003,
            55.2415531,
            55.283803,
            55.3222105,
            55.3612676,
            55.406262,
            55.4628719,
            55.5110909,
            55.5523777,
            55.5811877,
            55.6004372,
            55.626202,
            55.6656271,
            55.7167999,
            55.7698097,
            55.8196609,
            55.8615028,
            55.9129883,
            55.9663474,
            56.0220102,
            56.0700015,
            56.0939035,
            56.110463,
            56.1313736,
            56.1610839,
            56.2068432,
            56.2582503,
            56.3000349,
            56.339902,
            56.3789995,
            56.4282839,
            56.4803947,
            56.5352164,
            56.5697487,
            56.5983102,
            56.6328326,
            56.6738814,
            56.7332116,
            56.7971596,
            56.8552701,
            56.9111378,
            56.9754725,
            57.0470772,
            57.1136128,
            57.173831,
            57.2226068,
            57.259731,
            57.3072742,
            57.3643368,
            57.4334281,
            57.5015747,
            57.5653127,
            57.6333396,
            57.6972844,
            57.7710774,
            57.8407427,
            57.9057801,
            57.9575663,
            57.9974929,
            58.0425517,
            58.1043319,
            58.1679128,
            58.2389092,
            58.3091659,
            58.3833021,
            58.4536748,
            58.5401438,
            58.6227714,
            58.6916662,
            58.7409628,
            58.7836189,
            58.8405543,
            58.898579,
            58.9713678,
            59.043837,
            59.1218414,
            59.2002687,
            59.274737,
            59.3574134,
            59.4433827,
            59.5242416,
            59.5849787,
            59.6343497,
            59.6927827,
            59.758805,
            59.8386448,
            59.9110567,
            59.9844537,
            60.056435,
            60.123065,
            60.2042185,
            60.2803745,
            60.3530352,
            60.4011891,
            60.4439959,
            60.4900257,
            60.5578054,
            60.6324446,
            60.7058569,
            60.7853482,
            60.8663504,
            60.9386672,
            61.0276757,
            61.1103448,
            61.1870458,
            61.2453891,
            61.2881024,
            61.3377799,
            61.4036165,
            61.4760366,
            61.5524599,
            61.6286593,
            61.6845819,
            61.743306,
            61.8132425,
            61.8823203,
            61.9496762,
            61.9968743,
            62.0342938,
            62.0714108,
            62.1202315,
            62.1809508,
            62.2382046,
            62.2950486,
            62.3506479,
            62.3995381,
            62.475395,
            62.5463091,
            62.6136031,
            62.6570739,
            62.6941742,
            62.7383271,
            62.7926305,
            62.8566986,
            62.9145607,
            62.9658689,
            63.0216632,
            63.0807052,
            63.1461718,
            63.2052946,
            63.2599441,
            63.2844088,
            63.2961369,
            63.3126092,
            63.3421622,
            63.3871303,
            63.4339302,
            63.4673369,
            63.4978642,
            63.5319327,
            63.5679441,
            63.6104432,
            63.6444291,
            63.6641815,
            63.6739403,
            63.692603,
            63.7147066,
            63.7518055,
            63.792717,
            63.8285221,
            63.8556871,
            63.8803854,
            63.9075025,
            63.9392787,
            63.9690744,
            63.9798604,
            63.9833077,
            63.9938011,
            64.0093384,
            64.0399621,
            64.0670429,
            64.0907881,
            64.1068077,
            64.1282125,
            64.1584211,
            64.1832722,
            64.2093975,
            64.2116628,
            64.2073173,
            64.2115565,
            64.2222858,
            64.2499625,
            64.2760973,
            64.2998037,
            64.3191858,
            64.345013,
            64.3734584,
            64.3943291,
            64.4151156,
            64.4132064,
            64.4118464,
            64.4096536,
            64.4167832,
            64.43292,
            64.4510529,
            64.4734276,
            64.4893377,
            64.5053342,
            64.5269189,
            64.5470942,
            64.5596729,
            64.5512293,
            64.5370906,
            64.5359472,
            64.5414947,
            64.5543634,
            64.5654298,
            64.5736111,
            64.5891142,
            64.6014759,
            64.6176147,
            64.6374397,
            64.6548674,
            64.6530021,
            64.6379271,
            64.637161,
            64.6399614,
            64.6543152,
            64.6723164,
            64.6876311,
            64.7051905,
            64.7313433,
            64.7575312,
            64.7811143,
            64.8000929,
            64.7994561,
            64.7876424,
            64.783095,
            64.7920604,
            64.8096421,
            64.8310888,
            64.8451826,
            64.8597013,
            64.8849929,
            64.9174991,
            64.9480298,
            64.9793881,
            64.9894772,
            65.0028155,
            65.0138193,
            65.0371432,
            65.0772597,
            65.112197,
            65.1464034,
            65.1832638,
            65.2145358,
            65.2493713,
            65.2920645,
            65.3279403,
            65.3413366,
            65.3451881,
            65.34964,
            65.3711307,
            65.3971998,
            65.4295547,
            65.4573487,
            65.486752,
            65.5152012,
            65.5449916,
            65.5780768,
            65.612728,
            65.6287505,
            65.6370091,
            65.6493375,
            65.6759928,
            65.7096966,
            65.746092,
            65.7768362,
            65.8024614,
            65.8236695,
            65.8595036,
            65.8973008,
            65.932291,
            65.950911,
            65.9534105,
            65.962833,
            65.9838647,
            66.0146733,
            66.042049,
            66.0699217,
            66.0961343,
            66.1310116,
            66.1682713,
            66.2071627,
            66.2355846,
            66.2408549,
            66.2335423,
            66.2349107,
            66.2441095,
            66.2751123,
            66.3054334,
            66.3245568,
            66.3405713,
            66.3624433,
            66.3957101,
            66.428903,
            66.4618675,
            66.4748837,
            66.4751281,
            66.4828678,
            66.5056165,
            66.5382912,
            66.5705628,
            66.6030198,
            66.6339689,
            66.6569117,
            66.6925011,
            66.7288729,
            66.7578719,
            66.7707625,
            66.7740427,
            66.7846288,
            66.810324,
            66.840048,
            66.8778601,
            66.9069091,
            66.944259,
            66.9762508,
            67.0258126,
            67.0716286,
            67.1100184,
            67.1266401,
            67.1331391,
            67.145797,
            67.17174,
            67.2091069,
            67.2459812,
            67.2810383,
            67.3136452,
            67.3456968,
            67.389003,
            67.4318433,
            67.4666209,
            67.4858459,
            67.4989147,
            67.5110936,
            67.5352658,
            67.571103,
            67.6070253,
            67.6439167,
            67.6765272,
            67.7116693,
            67.7590634,
            67.8011542,
            67.840213,
            67.8606318,
            67.8821576,
            67.9120101,
            67.9546462,
            68.0054839,
            68.051412,
            68.1024205,
            68.1577127,
            68.2043653,
            68.2664507,
            68.3188171,
            68.3703564,
            68.3964356,
            68.4094472,
            68.4304611,
            68.4629791,
            68.507818,
            68.5537018,
            68.5927179,
            68.6298107,
            68.6670627,
            68.7135208,
            68.7622755,
            68.8032843,
            68.8244838,
            68.8373427,
            68.847693,
            68.8688567,
            68.9005814,
            68.9354999,
            68.9676423,
            68.9875354,
            69.0175527,
            69.0499081,
            69.0823433,
            69.1070034,
            69.1134027,
            69.1141898,
            69.1207203,
            69.1355578,
            69.16459,
            69.1964228,
            69.2201632,
            69.2451564,
            69.2732758,
            69.3031979,
            69.3325675,
            69.3540507,
            69.3581722,
            69.3441594,
            69.3376329,
            69.3377424,
            69.3432191,
            69.3540144,
            69.3611554,
            69.3751703,
            69.3889904,
            69.4091639,
            69.4264662,
            69.4386335,
            69.4241335,
            69.3921241,
            69.3693422,
            69.3574782,
            69.3593242,
            69.3630244,
            69.359334,
            69.3510133,
            69.3537917,
            69.3582217,
            69.367306,
            69.3678649,
            69.3514228,
            69.3273414,
            69.3033273,
            69.2892463,
            69.2880419,
            69.2908014,
            69.2944974,
            69.2913953,
            69.286149,
            69.2835153,
            69.2815422,
            69.2806375,
            69.2553511,
            69.2125426,
            69.1847287,
            69.17207,
            69.1691531,
            69.173303,
            69.1698064,
            69.1589095,
            69.1556275,
            69.1672253,
            69.1771384
        ],
        first: 1973.0849315068492,
        firstYM: [
            1973,
            2
        ],
        last: 2023.3287671232877,
        lastYM: [
            2023,
            5
        ]
    },
    prediction: {
        table: [
            67.87818,
            67.96817999999999,
            68.02817999999999,
            68.04818,
            68.12818,
            68.21817999999999,
            68.26818,
            68.28818,
            68.36818,
            68.44818,
            68.50818,
            68.51818,
            68.59818,
            68.68818,
            68.73818,
            68.74817999999999,
            68.82818,
            68.91817999999999,
            68.96817999999999,
            68.98818,
            69.06818,
            69.14818,
            69.20818,
            69.22818,
            69.30818,
            69.39818,
            69.46817999999999,
            69.48818,
            69.57818,
            69.66817999999999,
            69.73818,
            69.75818,
            69.85817999999999,
            69.95818,
            70.02817999999999,
            70.05818,
            70.15818,
            70.25818,
            70.33818,
            70.36818,
            70.46817999999999
        ],
        first: 2022,
        last: 2032
    }
};
var $7da48ceeb6b9c888$export$2e2bcd8739ae039 = $7da48ceeb6b9c888$var$m;


// avoids ciclic import { LeapYearGregorian } from './julian.js'
function $8085e6c028279bac$var$LeapYearGregorian(y) {
    return y % 4 === 0 && y % 100 !== 0 || y % 400 === 0;
}
function $8085e6c028279bac$export$d11ea4025d4e6b4e(dyear) {
    let \u0394T;
    if (dyear < -500) \u0394T = (0, $9QpM5.default).horner((dyear - 1820) * 0.01, -20, 0, 32);
    else if (dyear < 500) \u0394T = (0, $9QpM5.default).horner(dyear * 0.01, 10583.6, -1014.41, 33.78311, -5.952053, -0.1798452, 0.022174192, 0.0090316521);
    else if (dyear < 1600) \u0394T = (0, $9QpM5.default).horner((dyear - 1000) * 0.01, 1574.2, -556.01, 71.23472, 0.319781, -0.8503463, -0.005050998, 0.0083572073);
    else if (dyear < (0, $7da48ceeb6b9c888$export$2e2bcd8739ae039).historic.first) \u0394T = (0, $9QpM5.default).horner(dyear - 1600, 120, -0.9808, -0.01532, 1 / 7129);
    else if (dyear < (0, $7da48ceeb6b9c888$export$2e2bcd8739ae039).data.first) \u0394T = $8085e6c028279bac$var$interpolate(dyear, (0, $7da48ceeb6b9c888$export$2e2bcd8739ae039).historic);
    else if (dyear < (0, $7da48ceeb6b9c888$export$2e2bcd8739ae039).data.last - 0.25) \u0394T = $8085e6c028279bac$var$interpolateData(dyear, (0, $7da48ceeb6b9c888$export$2e2bcd8739ae039).data);
    else if (dyear < (0, $7da48ceeb6b9c888$export$2e2bcd8739ae039).prediction.last) \u0394T = $8085e6c028279bac$var$interpolate(dyear, (0, $7da48ceeb6b9c888$export$2e2bcd8739ae039).prediction);
    else if (dyear < 2050) \u0394T = (0, $9QpM5.default).horner((dyear - 2000) / 100, 62.92, 32.217, 55.89);
    else if (dyear < 2150) \u0394T = (0, $9QpM5.default).horner((dyear - 1820) / 100, -205.72, 56.28, 32);
    else {
        const u = (dyear - 1820) / 100;
        \u0394T = -20 + 32 * u * u;
    }
    return \u0394T;
}
/**
 * interpolation of dataset
 * @private
 * @param {Number} dyear - julian year
 * @returns {Number} ΔT in seconds.
 */ function $8085e6c028279bac$var$interpolate(dyear, data) {
    const d3 = (0, $7480a29e66a7d324$export$2e2bcd8739ae039).len3ForInterpolateX(dyear, data.first, data.last, data.table);
    return d3.interpolateX(dyear);
}
/**
 * interpolation of dataset from finals2000A with is one entry per month
 * linear interpolation over whole dataset is inaccurate as points per month
 * are not equidistant. Therefore points are approximated using 2nd diff. interpolation
 * from current month using the following two points
 *
 * @private
 * @param {Number} dyear - julian year
 * @returns {Number} ΔT in seconds.
 */ function $8085e6c028279bac$var$interpolateData(dyear, data) {
    const [fyear, fmonth] = data.firstYM;
    const { year: year, month: month, first: first, last: last } = $8085e6c028279bac$var$monthOfYear(dyear);
    const pos = 12 * (year - fyear) + (month - fmonth);
    const table = data.table.slice(pos, pos + 3);
    const d3 = new (0, $7480a29e66a7d324$export$2e2bcd8739ae039).Len3(first, last, table);
    return d3.interpolateX(dyear);
}
/**
 * Get month of Year from fraction. Fraction differs at leap years.
 * @private
 * @param {Number} dyear - decimal year
 * @return {Object} `{year: Number, month: Number, first: Number, last}`
 */ function $8085e6c028279bac$var$monthOfYear(dyear) {
    // if (!monthOfYear.data) { // memoize yearly fractions per month
    //   monthOfYear.data = { 0: [], 1: [] }
    //   for (let m = 0; m <= 12; m++) {
    //     monthOfYear.data[0][m] = new Calendar(1999, m, 1).toYear() - 1999 // non leap year
    //     monthOfYear.data[1][m] = new Calendar(2000, m, 1).toYear() - 2000 // leap year
    //   }
    // }
    // console.log(monthOfYear)
    const year = dyear | 0;
    const f = dyear - year;
    const d = $8085e6c028279bac$var$LeapYearGregorian(year) ? 1 : 0;
    const data = $8085e6c028279bac$var$monthOfYear.data[d];
    let month = 12 // TODO loop could be improved
    ;
    while(month > 0 && data[month] > f)month--;
    const first = year + data[month];
    const last = month < 11 ? year + data[month + 2] : year + 1 + data[(month + 2) % 12];
    return {
        year: year,
        month: month,
        first: first,
        last: last
    };
}
/**
  monthOfYear.data[0][m] = new Calendar(1999, m, 1).toYear() - 1999 // non leap year
  monthOfYear.data[1][m] = new Calendar(2000, m, 1).toYear() - 2000 // leap year
 */ $8085e6c028279bac$var$monthOfYear.data = [
    [
        0,
        0,
        0.08493150684921602,
        0.16164383561635987,
        0.24657534246580326,
        0.3287671232876619,
        0.4136986301368779,
        0.4958904109589639,
        0.5808219178081799,
        0.6657534246576233,
        0.747945205479482,
        0.832876712328698,
        0.915068493150784
    ],
    [
        0,
        0,
        0.08743169398917416,
        0.1639344262296163,
        0.24863387978143692,
        0.3306010928961314,
        0.4153005464481794,
        0.49726775956287383,
        0.5819672131146945,
        0.6666666666667425,
        0.7486338797814369,
        0.8333333333332575,
        0.9153005464481794
    ]
];
var $8085e6c028279bac$export$2e2bcd8739ae039 = {
    deltaT: $8085e6c028279bac$export$d11ea4025d4e6b4e
};



/**
 * @copyright 2013 Sonia Keys
 * @copyright 2016 commenthol
 * @license MIT
 * @module elliptic
 */ /**
 * Elliptic: Chapter 33, Elliptic Motion.
 *
 * Partial: Various formulas and algorithms are unimplemented for lack of
 * examples or test cases.
 */ 

var $9QpM5 = parcelRequire("9QpM5");

/**
 * @copyright 2013 Sonia Keys
 * @copyright 2016 commenthol
 * @license MIT
 * @module kepler
 */ /**
 * Kepler: Chapter 30, Equation of Kepler.
 */ 
var $9QpM5 = parcelRequire("9QpM5");
/**
 * @copyright 2013 Sonia Keys
 * @copyright 2016 commenthol
 * @license MIT
 * @module iterate
 */ /**
 * Iterate: Chapter 5, Iteration.
 *
 * This package is best considered illustrative.  While the functions are
 * usable, they are minimal in showing the points of the chapter text.  More
 * robust functions would handle more cases of overflow, loss of precision,
 * and divergence.
 */ /**
 * decimalPlaces iterates to a fixed number of decimal places.
 *
 * Inputs are an improvement function, a starting value, the number of
 * decimal places desired in the result, and an iteration limit.
 *
 * @throws Error
 * @param {Function} better
 * @param {Number} start - (float)
 * @param {Number} places - (int)
 * @param {Number} maxIterations - (int)
 * @returns {Number}
 */ function $52f80fe09aea80eb$export$4aa4df8b0f34e5d(better, start, places, maxIterations) {
    const d = Math.pow(10, -places);
    for(let i = 0; i < maxIterations; i++){
        const n = better(start);
        if (Math.abs(n - start) < d) return n;
        start = n;
    }
    throw new Error('Maximum iterations reached');
}
function $52f80fe09aea80eb$export$3879c186d90f5f75(better, start, maxIterations) {
    for(let i = 0; i < maxIterations; i++){
        const n = better(start);
        if (Math.abs((n - start) / n) < 1e-15) return n;
        start = n;
    }
    throw new Error('Maximum iterations reached');
}
function $52f80fe09aea80eb$export$b1ead97d1e9bc17e(f, lower, upper) {
    let yLower = f(lower);
    let mid = 0;
    for(let j = 0; j < 52; j++){
        mid = (lower + upper) / 2;
        const yMid = f(mid);
        if (yMid === 0) break;
        if ($52f80fe09aea80eb$var$signbit(yLower) === $52f80fe09aea80eb$var$signbit(yMid)) {
            lower = mid;
            yLower = yMid;
        } else upper = mid;
    }
    return mid;
}
function $52f80fe09aea80eb$var$signbit(v) {
    return v < 0;
}
var $52f80fe09aea80eb$export$2e2bcd8739ae039 = {
    decimalPlaces: $52f80fe09aea80eb$export$4aa4df8b0f34e5d,
    fullPrecision: $52f80fe09aea80eb$export$3879c186d90f5f75,
    binaryRoot: $52f80fe09aea80eb$export$b1ead97d1e9bc17e
};


function $0d93cc9a1dec3ae2$export$2770a5e91076516f(E, e) {
    // (30.1) p. 195
    return 2 * Math.atan(Math.sqrt((1 + e) / (1 - e)) * Math.tan(E * 0.5));
}
function $0d93cc9a1dec3ae2$export$872dd985a098dd45(E, e, a) {
    // (30.2) p. 195
    return a * (1 - e * Math.cos(E));
}
function $0d93cc9a1dec3ae2$export$3361546d1d3a405c(e, m, places) {
    const f = function(E0) {
        return m + e * Math.sin(E0) // (30.5) p. 195
        ;
    };
    return (0, $52f80fe09aea80eb$export$2e2bcd8739ae039).decimalPlaces(f, m, places, places * 5);
}
function $0d93cc9a1dec3ae2$export$dae9ca42f9db1ba4(e, m, places) {
    const f = function(E0) {
        const [se, ce] = (0, $9QpM5.default).sincos(E0);
        return E0 + (m + e * se - E0) / (1 - e * ce // (30.7) p. 199
        );
    };
    return (0, $52f80fe09aea80eb$export$2e2bcd8739ae039).decimalPlaces(f, m, places, places);
}
function $0d93cc9a1dec3ae2$export$c6a010221c2255d5(e, m, places) {
    const f = function(E0) {
        const [se, ce] = (0, $9QpM5.default).sincos(E0);
        // method of Leingärtner, p. 205
        return E0 + Math.asin(Math.sin((m + e * se - E0) / (1 - e * ce)));
    };
    return (0, $52f80fe09aea80eb$export$2e2bcd8739ae039).decimalPlaces(f, m, places, places * 5);
}
function $0d93cc9a1dec3ae2$export$cd8f5e3bbf80b5f1(e, m, places) {
    const f = function(E0) {
        const [se, ce] = (0, $9QpM5.default).sincos(E0);
        let d = (m + e * se - E0) / (1 - e * ce);
        // method of Steele, p. 205
        if (d > 0.5) d = 0.5;
        else if (d < -0.5) d = -0.5;
        return E0 + d;
    };
    return (0, $52f80fe09aea80eb$export$2e2bcd8739ae039).decimalPlaces(f, m, places, places);
}
function $0d93cc9a1dec3ae2$export$e462f9f6fab5f4a5(e, m) {
    // adapted from BASIC, p. 206
    m = (0, $9QpM5.default).pmod(m, 2 * Math.PI);
    let f = 1;
    if (m > Math.PI) {
        f = -1;
        m = 2 * Math.PI - m;
    }
    let E0 = Math.PI * 0.5;
    let d = Math.PI * 0.25;
    for(let i = 0; i < 53; i++){
        const M1 = E0 - e * Math.sin(E0);
        if (m - M1 < 0) E0 -= d;
        else E0 += d;
        d *= 0.5;
    }
    if (f < 0) return -E0;
    return E0;
}
function $0d93cc9a1dec3ae2$export$a22029f0dcac5fec(e, m) {
    const [sm, cm] = (0, $9QpM5.default).sincos(m);
    return Math.atan2(sm, cm - e) // (30.8) p. 206
    ;
}
var $0d93cc9a1dec3ae2$export$2e2bcd8739ae039 = {
    trueAnomaly: $0d93cc9a1dec3ae2$export$2770a5e91076516f,
    true: $0d93cc9a1dec3ae2$export$2770a5e91076516f,
    radius: $0d93cc9a1dec3ae2$export$872dd985a098dd45,
    kepler1: $0d93cc9a1dec3ae2$export$3361546d1d3a405c,
    kepler2: $0d93cc9a1dec3ae2$export$dae9ca42f9db1ba4,
    kepler2a: $0d93cc9a1dec3ae2$export$c6a010221c2255d5,
    kepler2b: $0d93cc9a1dec3ae2$export$cd8f5e3bbf80b5f1,
    kepler3: $0d93cc9a1dec3ae2$export$e462f9f6fab5f4a5,
    kepler4: $0d93cc9a1dec3ae2$export$a22029f0dcac5fec
};




/**
 * @copyright 2013 Sonia Keys
 * @copyright 2016 commenthol
 * @license MIT
 * @module solarxyz
 */ /**
 * Solarxyz: Chapter 26, Rectangular Coordinates of the Sun.
 */ 
var $9QpM5 = parcelRequire("9QpM5");


function $d3422cd09c39e78d$export$5880b8b5730aff45(earth, jde) {
    // (26.1) p. 171
    const { lon: lon, lat: lat, range: range } = (0, $c85b876782fe98e7$export$2e2bcd8739ae039).trueVSOP87(earth, jde);
    const [s\u03B5, c\u03B5] = (0, $9QpM5.default).sincos((0, $c50a9505be5a627c$export$2e2bcd8739ae039).meanObliquity(jde));
    const [ss, cs] = (0, $9QpM5.default).sincos(lon);
    const s\u03B2 = Math.sin(lat);
    const x = range * cs;
    const y = range * (ss * c\u03B5 - s\u03B2 * s\u03B5);
    const z = range * (ss * s\u03B5 + s\u03B2 * c\u03B5);
    return {
        x: x,
        y: y,
        z: z
    };
}
function $d3422cd09c39e78d$export$378c2f3818f6259f(earth, jde) {
    const lon = earth.position2000(jde).lon;
    return (0, $9QpM5.default).pmod(lon + Math.PI - 0.09033 / 3600 * Math.PI / 180, 2 * Math.PI);
}
function $d3422cd09c39e78d$export$c4c97acd385d3e1f(earth, jde) {
    const { x: x, y: y, z: z } = $d3422cd09c39e78d$export$7d17437f13c86aaa(earth, jde);
    // (26.3) p. 174
    return {
        x: x + 0.00000044036 * y - 0.000000190919 * z,
        y: -0.000000479966 * x + 0.917482137087 * y - 0.397776982902 * z,
        z: 0.397776982902 * y + 0.917482137087 * z
    };
}
function $d3422cd09c39e78d$export$7d17437f13c86aaa(earth, jde) {
    const { lon: lon, lat: lat, range: range } = earth.position2000(jde);
    const s = lon + Math.PI;
    const \u03B2 = -lat;
    const [ss, cs] = (0, $9QpM5.default).sincos(s);
    const [s\u03B2, c\u03B2] = (0, $9QpM5.default).sincos(\u03B2);
    // (26.2) p. 172
    const x = range * c\u03B2 * cs;
    const y = range * c\u03B2 * ss;
    const z = range * s\u03B2;
    return {
        x: x,
        y: y,
        z: z
    };
}
function $d3422cd09c39e78d$export$8a8d7bcbcb6548fc(earth, jde) {
    const { x: x, y: y, z: z } = $d3422cd09c39e78d$export$7d17437f13c86aaa(earth, jde);
    return {
        x: 0.999925702634 * x + 0.012189716217 * y + 0.000011134016 * z,
        y: -0.011179418036 * x + 0.917413998946 * y - 0.397777041885 * z,
        z: -0.004859003787 * x + 0.397747363646 * y + 0.917482111428 * z
    };
}
const $d3422cd09c39e78d$var$\u03B6t = [
    2306.2181,
    0.30188,
    0.017998
];
const $d3422cd09c39e78d$var$zt = [
    2306.2181,
    1.09468,
    0.018203
];
const $d3422cd09c39e78d$var$\u03B8t = [
    2004.3109,
    -0.42665,
    -0.041833
];
function $d3422cd09c39e78d$export$21a9cce43fda88e3(earth, jde, epoch) {
    const xyz = $d3422cd09c39e78d$export$c4c97acd385d3e1f(earth, jde);
    const x0 = xyz.x;
    const y0 = xyz.y;
    const z0 = xyz.z;
    const t = (epoch - 2000) * 0.01;
    const \u03B6 = (0, $9QpM5.default).horner(t, $d3422cd09c39e78d$var$\u03B6t) * t * Math.PI / 180 / 3600;
    const z = (0, $9QpM5.default).horner(t, $d3422cd09c39e78d$var$zt) * t * Math.PI / 180 / 3600;
    const \u03B8 = (0, $9QpM5.default).horner(t, $d3422cd09c39e78d$var$\u03B8t) * t * Math.PI / 180 / 3600;
    const [s\u03B6, c\u03B6] = (0, $9QpM5.default).sincos(\u03B6);
    const [sz, cz] = (0, $9QpM5.default).sincos(z);
    const [s\u03B8, c\u03B8] = (0, $9QpM5.default).sincos(\u03B8);
    const xx = c\u03B6 * cz * c\u03B8 - s\u03B6 * sz;
    const xy = s\u03B6 * cz + c\u03B6 * sz * c\u03B8;
    const xz = c\u03B6 * s\u03B8;
    const yx = -c\u03B6 * sz - s\u03B6 * cz * c\u03B8;
    const yy = c\u03B6 * cz - s\u03B6 * sz * c\u03B8;
    const yz = -s\u03B6 * s\u03B8;
    const zx = -cz * s\u03B8;
    const zy = -sz * s\u03B8;
    const zz = c\u03B8;
    return {
        x: xx * x0 + yx * y0 + zx * z0,
        y: xy * x0 + yy * y0 + zy * z0,
        z: xz * x0 + yz * y0 + zz * z0
    };
}
var $d3422cd09c39e78d$export$2e2bcd8739ae039 = {
    position: $d3422cd09c39e78d$export$5880b8b5730aff45,
    longitudeJ2000: $d3422cd09c39e78d$export$378c2f3818f6259f,
    positionJ2000: $d3422cd09c39e78d$export$c4c97acd385d3e1f,
    xyz: $d3422cd09c39e78d$export$7d17437f13c86aaa,
    positionB1950: $d3422cd09c39e78d$export$8a8d7bcbcb6548fc,
    positionEquinox: $d3422cd09c39e78d$export$21a9cce43fda88e3
};


function $05c3bff5926cc6a8$export$5880b8b5730aff45(planet, earth, jde) {
    let x = 0;
    let y = 0;
    let z = 0;
    const posEarth = earth.position(jde);
    const [L0, B0, R0] = [
        posEarth.lon,
        posEarth.lat,
        posEarth.range
    ];
    const [sB0, cB0] = (0, $9QpM5.default).sincos(B0);
    const [sL0, cL0] = (0, $9QpM5.default).sincos(L0);
    function pos(\u03C4 = 0) {
        const pos1 = planet.position(jde - \u03C4);
        const [L, B, R] = [
            pos1.lon,
            pos1.lat,
            pos1.range
        ];
        const [sB, cB] = (0, $9QpM5.default).sincos(B);
        const [sL, cL] = (0, $9QpM5.default).sincos(L);
        x = R * cB * cL - R0 * cB0 * cL0;
        y = R * cB * sL - R0 * cB0 * sL0;
        z = R * sB - R0 * sB0;
    }
    pos();
    const \u0394 = Math.sqrt(x * x + y * y + z * z) // (33.4) p. 224
    ;
    const \u03C4 = (0, $9QpM5.default).lightTime(\u0394);
    // repeating with jde-τ
    pos(\u03C4);
    let \u03BB = Math.atan2(y, x) // (33.1) p. 223
    ;
    let \u03B2 = Math.atan2(z, Math.hypot(x, y)) // (33.2) p. 223
    ;
    const [\u0394\u03BB, \u0394\u03B2] = (0, $66020aba9d13c5db$export$2e2bcd8739ae039).eclipticAberration(\u03BB, \u03B2, jde);
    const fk5 = (0, $2c5cad23f9dfa2db$export$2e2bcd8739ae039).toFK5(\u03BB + \u0394\u03BB, \u03B2 + \u0394\u03B2, jde);
    \u03BB = fk5.lon;
    \u03B2 = fk5.lat;
    const [\u0394\u03C8, \u0394\u03B5] = (0, $c50a9505be5a627c$export$2e2bcd8739ae039).nutation(jde);
    \u03BB += \u0394\u03C8;
    const \u03B5 = (0, $c50a9505be5a627c$export$2e2bcd8739ae039).meanObliquity(jde) + \u0394\u03B5;
    return new (0, $77f14e36e565e56c$export$2e2bcd8739ae039).Ecliptic(\u03BB, \u03B2).toEquatorial(\u03B5);
// Meeus gives a formula for elongation but doesn't spell out how to
// obtaion term λ0 and doesn't give an example solution.
}
class $05c3bff5926cc6a8$export$3abb4be70fa2c84e {
    /*
  Axis  float64 // Semimajor axis, a, in AU
  Ecc   float64 // Eccentricity, e
  Inc   float64 // Inclination, i, in radians
  ArgP  float64 // Argument of perihelion, ω, in radians
  Node  float64 // Longitude of ascending node, Ω, in radians
  TimeP float64 // Time of perihelion, T, as jde
  */ constructor(axis, ecc, inc, argP, node, timeP){
        let o = {};
        if (typeof axis === 'object') o = axis;
        this.axis = o.axis || axis;
        this.ecc = o.ecc || ecc;
        this.inc = o.inc || inc;
        this.argP = o.argP || argP;
        this.node = o.node || node;
        this.timeP = o.timeP || timeP;
    }
    /**
   * Position returns observed equatorial coordinates of a body with Keplerian elements.
   *
   * Argument e must be a valid V87Planet object for Earth.
   *
   * Results are right ascension and declination α and δ, and elongation ψ,
   * all in radians.
   */ position(jde, earth) {
        // (33.6) p. 227
        const n = (0, $9QpM5.default).K / this.axis / Math.sqrt(this.axis);
        const s\u03B5 = (0, $9QpM5.default).SOblJ2000;
        const c\u03B5 = (0, $9QpM5.default).COblJ2000;
        const [s\u03A9, c\u03A9] = (0, $9QpM5.default).sincos(this.node);
        const [si, ci] = (0, $9QpM5.default).sincos(this.inc);
        // (33.7) p. 228
        const F = c\u03A9;
        const G = s\u03A9 * c\u03B5;
        const H = s\u03A9 * s\u03B5;
        const P = -s\u03A9 * ci;
        const Q = c\u03A9 * ci * c\u03B5 - si * s\u03B5;
        const R = c\u03A9 * ci * s\u03B5 + si * c\u03B5;
        // (33.8) p. 229
        const A = Math.atan2(F, P);
        const B = Math.atan2(G, Q);
        const C = Math.atan2(H, R);
        const a = Math.hypot(F, P);
        const b = Math.hypot(G, Q);
        const c = Math.hypot(H, R);
        const f = (jde)=>{
            const M = n * (jde - this.timeP);
            let E;
            try {
                E = (0, $0d93cc9a1dec3ae2$export$2e2bcd8739ae039).kepler2b(this.ecc, M, 15);
            } catch (e) {
                E = (0, $0d93cc9a1dec3ae2$export$2e2bcd8739ae039).kepler3(this.ecc, M);
            }
            const \u03BD = (0, $0d93cc9a1dec3ae2$export$2e2bcd8739ae039).trueAnomaly(E, this.ecc);
            const r = (0, $0d93cc9a1dec3ae2$export$2e2bcd8739ae039).radius(E, this.ecc, this.axis);
            // (33.9) p. 229
            const x = r * a * Math.sin(A + this.argP + \u03BD);
            const y = r * b * Math.sin(B + this.argP + \u03BD);
            const z = r * c * Math.sin(C + this.argP + \u03BD);
            return {
                x: x,
                y: y,
                z: z
            };
        };
        return $05c3bff5926cc6a8$export$b12e32da895c9a4b(f, jde, earth);
    }
}
function $05c3bff5926cc6a8$export$b12e32da895c9a4b(f, jde, earth) {
    const sol = (0, $d3422cd09c39e78d$export$2e2bcd8739ae039).positionJ2000(earth, jde);
    const [X, Y, Z] = [
        sol.x,
        sol.y,
        sol.z
    ];
    let \u03BE = 0;
    let \u03B7 = 0;
    let \u03B6 = 0;
    let \u0394 = 0;
    function fn(\u03C4 = 0) {
        // (33.10) p. 229
        const { x: x, y: y, z: z } = f(jde - \u03C4);
        \u03BE = X + x;
        \u03B7 = Y + y;
        \u03B6 = Z + z;
        \u0394 = Math.sqrt(\u03BE * \u03BE + \u03B7 * \u03B7 + \u03B6 * \u03B6);
    }
    fn();
    const \u03C4 = (0, $9QpM5.default).lightTime(\u0394);
    fn(\u03C4);
    let \u03B1 = Math.atan2(\u03B7, \u03BE);
    if (\u03B1 < 0) \u03B1 += 2 * Math.PI;
    const \u03B4 = Math.asin(\u03B6 / \u0394);
    const R0 = Math.sqrt(X * X + Y * Y + Z * Z);
    const \u03C8 = Math.acos((\u03BE * X + \u03B7 * Y + \u03B6 * Z) / R0 / \u0394);
    return new (0, $9QpM5.default).Coord(\u03B1, \u03B4, undefined, \u03C8);
}
function $05c3bff5926cc6a8$export$b9fe5d314b12b4ca(a, r) {
    return 42.1219 * Math.sqrt(1 / r - 0.5 / a);
}
function $05c3bff5926cc6a8$export$4f6988bc2ebea774(a, e) {
    return 29.7847 * Math.sqrt((1 - e) / (1 + e) / a);
}
function $05c3bff5926cc6a8$export$7eda5510719bf0bf(a, e) {
    return 29.7847 * Math.sqrt((1 + e) / (1 - e) / a);
}
function $05c3bff5926cc6a8$export$870080f64606ac28(a, e) {
    const b = a * Math.sqrt(1 - e * e);
    return Math.PI * (3 * (a + b) - Math.sqrt((a + 3 * b) * (3 * a + b)));
}
function $05c3bff5926cc6a8$export$996a93cbe0a611e2(a, e) {
    const b = a * Math.sqrt(1 - e * e);
    const s = a + b;
    const p = a * b;
    const A = s * 0.5;
    const G = Math.sqrt(p);
    const H = 2 * p / s;
    return Math.PI * (21 * A - 2 * G - 3 * H) * 0.125;
}
function $05c3bff5926cc6a8$export$6ebba63fee1585c7(a, e) {
    const b = a * Math.sqrt(1 - e * e);
    const m = (a - b) / (a + b);
    const m2 = m * m;
    let sum0 = 1.0;
    let term = m2 * 0.25;
    let sum1 = 1.0 + term;
    let nf = -1;
    let df = 2.0;
    while(sum1 !== sum0){
        nf += 2;
        df += 2;
        term *= nf * nf * m2 / (df * df);
        sum0 = sum1;
        sum1 += term;
    }
    return 2 * Math.PI * a * sum0 / (1 + m);
}
var $05c3bff5926cc6a8$export$2e2bcd8739ae039 = {
    position: $05c3bff5926cc6a8$export$5880b8b5730aff45,
    Elements: $05c3bff5926cc6a8$export$3abb4be70fa2c84e,
    astrometricJ2000: $05c3bff5926cc6a8$export$b12e32da895c9a4b,
    velocity: $05c3bff5926cc6a8$export$b9fe5d314b12b4ca,
    vAphelion: $05c3bff5926cc6a8$export$4f6988bc2ebea774,
    vPerihelion: $05c3bff5926cc6a8$export$7eda5510719bf0bf,
    length1: $05c3bff5926cc6a8$export$870080f64606ac28,
    length2: $05c3bff5926cc6a8$export$996a93cbe0a611e2,
    length4: // length3,
    $05c3bff5926cc6a8$export$6ebba63fee1585c7
};


/**
 * @copyright 2013 Sonia Keys
 * @copyright 2016 commenthol
 * @license MIT
 * @module eclipse
 */ /**
 * Eclipse: Chapter 54, Eclipses.
 */ 
var $9QpM5 = parcelRequire("9QpM5");
/**
 * @copyright 2013 Sonia Keys
 * @copyright 2016 commenthol
 * @license MIT
 * @module moonphase
 */ /**
 * Moonphase: Chapter 49, Phases of the Moon
 */ 
var $9QpM5 = parcelRequire("9QpM5");
const { sin: $5669375e18e193a3$var$sin, cos: $5669375e18e193a3$var$cos } = Math;
const $5669375e18e193a3$var$ck = 1 / 1236.85;
const $5669375e18e193a3$var$D2R = Math.PI / 180;
const $5669375e18e193a3$export$d9e084c74b41d873 = 29.530588861;
// (49.1) p. 349
function $5669375e18e193a3$var$mean(T) {
    return (0, $9QpM5.default).horner(T, 2451550.09766, 29.530588861 / $5669375e18e193a3$var$ck, 0.00015437, -0.00000015, 0.00000000073);
}
/** snap returns k at specified quarter q nearest year y. */ function $5669375e18e193a3$var$snap(y, q) {
    const k = (y - 2000) * 12.3685 // (49.2) p. 350
    ;
    return Math.floor(k - q + 0.5) + q;
}
function $5669375e18e193a3$export$a349ff5e92ffa831(year) {
    return $5669375e18e193a3$var$mean($5669375e18e193a3$var$snap(year, 0) * $5669375e18e193a3$var$ck);
}
function $5669375e18e193a3$export$b84c4777ba203528(year) {
    return $5669375e18e193a3$var$mean($5669375e18e193a3$var$snap(year, 0.25) * $5669375e18e193a3$var$ck);
}
function $5669375e18e193a3$export$cec151f10d629476(year) {
    return $5669375e18e193a3$var$mean($5669375e18e193a3$var$snap(year, 0.5) * $5669375e18e193a3$var$ck);
}
function $5669375e18e193a3$export$ee7f963c93d978b1(year) {
    return $5669375e18e193a3$var$mean($5669375e18e193a3$var$snap(year, 0.75) * $5669375e18e193a3$var$ck);
}
function $5669375e18e193a3$export$aa03204081ff21d0(year) {
    const m = new $5669375e18e193a3$var$Mp(year, 0);
    return $5669375e18e193a3$var$mean(m.T) + m.nfc($5669375e18e193a3$var$nc) + m.a();
}
function $5669375e18e193a3$export$43128fadae87b74a(year) {
    const m = new $5669375e18e193a3$var$Mp(year, 0.25);
    return $5669375e18e193a3$var$mean(m.T) + m.flc() + m.w() + m.a();
}
function $5669375e18e193a3$export$2adb16ac204af30e(year) {
    const m = new $5669375e18e193a3$var$Mp(year, 0.5);
    return $5669375e18e193a3$var$mean(m.T) + m.nfc($5669375e18e193a3$var$fc) + m.a();
}
function $5669375e18e193a3$export$4c7897fafd92b108(year) {
    const m = new $5669375e18e193a3$var$Mp(year, 0.75);
    return $5669375e18e193a3$var$mean(m.T) + m.flc() - m.w() + m.a();
}
class $5669375e18e193a3$var$Mp {
    constructor(y, q){
        this.A = new Array(14);
        const k = this.k = $5669375e18e193a3$var$snap(y, q);
        const T = this.T = this.k * $5669375e18e193a3$var$ck // (49.3) p. 350
        ;
        this.E = (0, $9QpM5.default).horner(T, 1, -0.002516, -0.0000074);
        this.M = (0, $9QpM5.default).horner(T, 2.5534 * $5669375e18e193a3$var$D2R, 29.1053567 * $5669375e18e193a3$var$D2R / $5669375e18e193a3$var$ck, -0.0000014 * $5669375e18e193a3$var$D2R, -0.00000011 * $5669375e18e193a3$var$D2R);
        this.M_ = (0, $9QpM5.default).horner(T, 201.5643 * $5669375e18e193a3$var$D2R, 385.81693528 * $5669375e18e193a3$var$D2R / $5669375e18e193a3$var$ck, 0.0107582 * $5669375e18e193a3$var$D2R, 0.00001238 * $5669375e18e193a3$var$D2R, -0.000000058 * $5669375e18e193a3$var$D2R);
        this.F = (0, $9QpM5.default).horner(T, 160.7108 * $5669375e18e193a3$var$D2R, 390.67050284 * $5669375e18e193a3$var$D2R / $5669375e18e193a3$var$ck, -0.0016118 * $5669375e18e193a3$var$D2R, -0.00000227 * $5669375e18e193a3$var$D2R, 0.000000011 * $5669375e18e193a3$var$D2R);
        this.\u03A9 = (0, $9QpM5.default).horner(T, 124.7746 * $5669375e18e193a3$var$D2R, -1.56375588 * $5669375e18e193a3$var$D2R / $5669375e18e193a3$var$ck, 0.0020672 * $5669375e18e193a3$var$D2R, 0.00000215 * $5669375e18e193a3$var$D2R);
        this.A[0] = 299.7 * $5669375e18e193a3$var$D2R + 0.107408 * $5669375e18e193a3$var$D2R * k - 0.009173 * T * T;
        this.A[1] = 251.88 * $5669375e18e193a3$var$D2R + 0.016321 * $5669375e18e193a3$var$D2R * k;
        this.A[2] = 251.83 * $5669375e18e193a3$var$D2R + 26.651886 * $5669375e18e193a3$var$D2R * k;
        this.A[3] = 349.42 * $5669375e18e193a3$var$D2R + 36.412478 * $5669375e18e193a3$var$D2R * k;
        this.A[4] = 84.66 * $5669375e18e193a3$var$D2R + 18.206239 * $5669375e18e193a3$var$D2R * k;
        this.A[5] = 141.74 * $5669375e18e193a3$var$D2R + 53.303771 * $5669375e18e193a3$var$D2R * k;
        this.A[6] = 207.17 * $5669375e18e193a3$var$D2R + 2.453732 * $5669375e18e193a3$var$D2R * k;
        this.A[7] = 154.84 * $5669375e18e193a3$var$D2R + 7.30686 * $5669375e18e193a3$var$D2R * k;
        this.A[8] = 34.52 * $5669375e18e193a3$var$D2R + 27.261239 * $5669375e18e193a3$var$D2R * k;
        this.A[9] = 207.19 * $5669375e18e193a3$var$D2R + 0.121824 * $5669375e18e193a3$var$D2R * k;
        this.A[10] = 291.34 * $5669375e18e193a3$var$D2R + 1.844379 * $5669375e18e193a3$var$D2R * k;
        this.A[11] = 161.72 * $5669375e18e193a3$var$D2R + 24.198154 * $5669375e18e193a3$var$D2R * k;
        this.A[12] = 239.56 * $5669375e18e193a3$var$D2R + 25.513099 * $5669375e18e193a3$var$D2R * k;
        this.A[13] = 331.55 * $5669375e18e193a3$var$D2R + 3.592518 * $5669375e18e193a3$var$D2R * k;
    }
    // new or full corrections
    nfc(c) {
        const { M: M, M_: M_, E: E, F: F, \u03A9: \u03A9 } = this;
        return c[0] * $5669375e18e193a3$var$sin(M_) + c[1] * $5669375e18e193a3$var$sin(M) * E + c[2] * $5669375e18e193a3$var$sin(2 * M_) + c[3] * $5669375e18e193a3$var$sin(2 * F) + c[4] * $5669375e18e193a3$var$sin(M_ - M) * E + c[5] * $5669375e18e193a3$var$sin(M_ + M) * E + c[6] * $5669375e18e193a3$var$sin(2 * M) * E * E + c[7] * $5669375e18e193a3$var$sin(M_ - 2 * F) + c[8] * $5669375e18e193a3$var$sin(M_ + 2 * F) + c[9] * $5669375e18e193a3$var$sin(2 * M_ + M) * E + c[10] * $5669375e18e193a3$var$sin(3 * M_) + c[11] * $5669375e18e193a3$var$sin(M + 2 * F) * E + c[12] * $5669375e18e193a3$var$sin(M - 2 * F) * E + c[13] * $5669375e18e193a3$var$sin(2 * M_ - M) * E + c[14] * $5669375e18e193a3$var$sin(\u03A9) + c[15] * $5669375e18e193a3$var$sin(M_ + 2 * M) + c[16] * $5669375e18e193a3$var$sin(2 * (M_ - F)) + c[17] * $5669375e18e193a3$var$sin(3 * M) + c[18] * $5669375e18e193a3$var$sin(M_ + M - 2 * F) + c[19] * $5669375e18e193a3$var$sin(2 * (M_ + F)) + c[20] * $5669375e18e193a3$var$sin(M_ + M + 2 * F) + c[21] * $5669375e18e193a3$var$sin(M_ - M + 2 * F) + c[22] * $5669375e18e193a3$var$sin(M_ - M - 2 * F) + c[23] * $5669375e18e193a3$var$sin(3 * M_ + M) + c[24] * $5669375e18e193a3$var$sin(4 * M_);
    }
    // first or last corrections
    flc() {
        const { M: M, M_: M_, E: E, F: F, \u03A9: \u03A9 } = this;
        return -0.62801 * $5669375e18e193a3$var$sin(M_) + 0.17172 * $5669375e18e193a3$var$sin(M) * E + -0.01183 * $5669375e18e193a3$var$sin(M_ + M) * E + 0.00862 * $5669375e18e193a3$var$sin(2 * M_) + 0.00804 * $5669375e18e193a3$var$sin(2 * F) + 0.00454 * $5669375e18e193a3$var$sin(M_ - M) * E + 0.00204 * $5669375e18e193a3$var$sin(2 * M) * E * E + -0.0018 * $5669375e18e193a3$var$sin(M_ - 2 * F) + -0.0007 * $5669375e18e193a3$var$sin(M_ + 2 * F) + -0.0004 * $5669375e18e193a3$var$sin(3 * M_) + -0.00034 * $5669375e18e193a3$var$sin(2 * M_ - M) * E + 0.00032 * $5669375e18e193a3$var$sin(M + 2 * F) * E + 0.00032 * $5669375e18e193a3$var$sin(M - 2 * F) * E + -0.00028 * $5669375e18e193a3$var$sin(M_ + 2 * M) * E * E + 0.00027 * $5669375e18e193a3$var$sin(2 * M_ + M) * E + -0.00017 * $5669375e18e193a3$var$sin(\u03A9) + -0.00005 * $5669375e18e193a3$var$sin(M_ - M - 2 * F) + 0.00004 * $5669375e18e193a3$var$sin(2 * M_ + 2 * F) + -0.00004 * $5669375e18e193a3$var$sin(M_ + M + 2 * F) + 0.00004 * $5669375e18e193a3$var$sin(M_ - 2 * M) + 0.00003 * $5669375e18e193a3$var$sin(M_ + M - 2 * F) + 0.00003 * $5669375e18e193a3$var$sin(3 * M) + 0.00002 * $5669375e18e193a3$var$sin(2 * M_ - 2 * F) + 0.00002 * $5669375e18e193a3$var$sin(M_ - M + 2 * F) + -0.00002 * $5669375e18e193a3$var$sin(3 * M_ + M);
    }
    w() {
        const { M: M, M_: M_, E: E, F: F } = this;
        return 0.00306 - 0.00038 * E * $5669375e18e193a3$var$cos(M) + 0.00026 * $5669375e18e193a3$var$cos(M_) - 0.00002 * ($5669375e18e193a3$var$cos(M_ - M) - $5669375e18e193a3$var$cos(M_ + M) - $5669375e18e193a3$var$cos(2 * F));
    }
    // additional corrections
    a() {
        let a = 0;
        $5669375e18e193a3$var$ac.forEach((c, i)=>{
            a += c * $5669375e18e193a3$var$sin(this.A[i]);
        });
        return a;
    }
}
// new coefficients
const $5669375e18e193a3$var$nc = [
    -0.4072,
    0.17241,
    0.01608,
    0.01039,
    0.00739,
    -0.00514,
    0.00208,
    -0.00111,
    -0.00057,
    0.00056,
    -0.00042,
    0.00042,
    0.00038,
    -0.00024,
    -0.00017,
    -0.00007,
    0.00004,
    0.00004,
    0.00003,
    0.00003,
    -0.00003,
    0.00003,
    -0.00002,
    -0.00002,
    0.00002
];
// full coefficients
const $5669375e18e193a3$var$fc = [
    -0.40614,
    0.17302,
    0.01614,
    0.01043,
    0.00734,
    -0.00515,
    0.00209,
    -0.00111,
    -0.00057,
    0.00056,
    -0.00042,
    0.00042,
    0.00038,
    -0.00024,
    -0.00017,
    -0.00007,
    0.00004,
    0.00004,
    0.00003,
    0.00003,
    -0.00003,
    0.00003,
    -0.00002,
    -0.00002,
    0.00002
];
// additional corrections
const $5669375e18e193a3$var$ac = [
    0.000325,
    0.000165,
    0.000164,
    0.000126,
    0.00011,
    0.000062,
    0.00006,
    0.000056,
    0.000047,
    0.000042,
    0.000040,
    0.000037,
    0.000035,
    0.000023
];
var $5669375e18e193a3$export$2e2bcd8739ae039 = {
    meanLunarMonth: $5669375e18e193a3$export$d9e084c74b41d873,
    meanNew: $5669375e18e193a3$export$a349ff5e92ffa831,
    meanFirst: $5669375e18e193a3$export$b84c4777ba203528,
    meanFull: $5669375e18e193a3$export$cec151f10d629476,
    meanLast: $5669375e18e193a3$export$ee7f963c93d978b1,
    newMoon: $5669375e18e193a3$export$aa03204081ff21d0,
    new: $5669375e18e193a3$export$aa03204081ff21d0,
    first: $5669375e18e193a3$export$43128fadae87b74a,
    full: $5669375e18e193a3$export$2adb16ac204af30e,
    last: $5669375e18e193a3$export$4c7897fafd92b108
};


/**
 * @private
 */ const $8498b823993a15d8$var$g = function(k, jm, c1, c2) {
    const ck = 1 / 1236.85;
    const p = Math.PI / 180;
    const T = k * ck;
    const F = (0, $9QpM5.default).horner(T, 160.7108 * p, 390.67050284 * p / ck, -0.0016118 * p, -0.00000227 * p, 0.000000011 * p);
    if (Math.abs(Math.sin(F)) > 0.36) return [
        false
    ] // no eclipse
    ;
    const eclipse = true;
    const E = (0, $9QpM5.default).horner(T, 1, -0.002516, -0.0000074);
    const M = (0, $9QpM5.default).horner(T, 2.5534 * p, 29.1053567 * p / ck, -0.0000014 * p, -0.00000011 * p);
    const M\u02B9 = (0, $9QpM5.default).horner(T, 201.5643 * p, 385.81693528 * p / ck, 0.0107582 * p, 0.00001238 * p, -0.000000058 * p);
    const \u03A9 = (0, $9QpM5.default).horner(T, 124.7746 * p, -1.56375588 * p / ck, 0.0020672 * p, 0.00000215 * p);
    const s\u03A9 = Math.sin(\u03A9);
    const F1 = F - 0.02665 * p * s\u03A9;
    const A1 = (0, $9QpM5.default).horner(T, 299.77 * p, 0.107408 * p / ck, -0.009173 * p);
    // (54.1) p. 380
    const jdeMax = jm + c1 * Math.sin(M\u02B9) + c2 * Math.sin(M) * E + 0.0161 * Math.sin(2 * M\u02B9) + -0.0097 * Math.sin(2 * F1) + 0.0073 * Math.sin(M\u02B9 - M) * E + -0.005 * Math.sin(M\u02B9 + M) * E + -0.0023 * Math.sin(M\u02B9 - 2 * F1) + 0.0021 * Math.sin(2 * M) * E + 0.0012 * Math.sin(M\u02B9 + 2 * F1) + 0.0006 * Math.sin(2 * M\u02B9 + M) * E + -0.0004 * Math.sin(3 * M\u02B9) + -0.0003 * Math.sin(M + 2 * F1) * E + 0.0003 * Math.sin(A1) + -0.0002 * Math.sin(M - 2 * F1) * E + -0.0002 * Math.sin(2 * M\u02B9 - M) * E + -0.0002 * s\u03A9;
    const P = 0.207 * Math.sin(M) * E + 0.0024 * Math.sin(2 * M) * E + -0.0392 * Math.sin(M\u02B9) + 0.0116 * Math.sin(2 * M\u02B9) + -0.0073 * Math.sin(M\u02B9 + M) * E + 0.0067 * Math.sin(M\u02B9 - M) * E + 0.0118 * Math.sin(2 * F1);
    const Q = 5.2207 + -0.0048 * Math.cos(M) * E + 0.002 * Math.cos(2 * M) * E + -0.3299 * Math.cos(M\u02B9) + -0.006 * Math.cos(M\u02B9 + M) * E + 0.0041 * Math.cos(M\u02B9 - M) * E;
    const [sF1, cF1] = (0, $9QpM5.default).sincos(F1);
    const W = Math.abs(cF1);
    const \u03B3 = (P * cF1 + Q * sF1) * (1 - 0.0048 * W);
    const u = 0.0059 + 0.0046 * Math.cos(M) * E + -0.0182 * Math.cos(M\u02B9) + 0.0004 * Math.cos(2 * M\u02B9) + -0.0005 * Math.cos(M + M\u02B9);
    return [
        eclipse,
        jdeMax,
        \u03B3,
        u,
        M\u02B9
    ] // (eclipse bool, jdeMax, γ, u, Mʹ float64)
    ;
};
const $8498b823993a15d8$export$b87f371cbc396fcf = {
    None: 0,
    Partial: 1,
    Annular: 2,
    AnnularTotal: 3,
    Penumbral: 4,
    Umbral: 5,
    Total: 6 // solar or lunar
};
/**
 * Snap returns k at specified quarter q nearest year y.
 * Cut and paste from moonphase.  Time corresponding to k needed in these
 * algorithms but otherwise not meaningful enough to export from moonphase.
 */ const $8498b823993a15d8$var$snap = function(y, q) {
    const k = (y - 2000) * 12.3685 // (49.2) p. 350
    ;
    return Math.floor(k - q + 0.5) + q;
};
function $8498b823993a15d8$export$45452b6bebae1c00(year) {
    let eclipseType = $8498b823993a15d8$export$b87f371cbc396fcf.None;
    let mag;
    const [e, jdeMax, \u03B3, u, _] = $8498b823993a15d8$var$g($8498b823993a15d8$var$snap(year, 0), (0, $5669375e18e193a3$export$2e2bcd8739ae039).meanNew(year), -0.4075, 0.1721) // eslint-disable-line no-unused-vars
    ;
    const p = u + 0.5461;
    if (!e) return {
        type: eclipseType
    } // no eclipse
    ;
    const a\u03B3 = Math.abs(\u03B3);
    if (a\u03B3 > 1.5433 + u) return {
        type: eclipseType
    } // no eclipse
    ;
    const central = a\u03B3 < 0.9972 // eclipse center touches Earth
    ;
    if (!central) {
        eclipseType = $8498b823993a15d8$export$b87f371cbc396fcf.Partial // most common case
        ;
        if (a\u03B3 < 1.026) {
            if (a\u03B3 < 0.9972 + Math.abs(u)) eclipseType = $8498b823993a15d8$export$b87f371cbc396fcf.Total // report total in both cases
            ;
        }
    } else if (u < 0) eclipseType = $8498b823993a15d8$export$b87f371cbc396fcf.Total;
    else if (u > 0.0047) eclipseType = $8498b823993a15d8$export$b87f371cbc396fcf.Annular;
    else {
        const \u03C9 = 0.00464 * Math.sqrt(1 - \u03B3 * \u03B3);
        if (u < \u03C9) eclipseType = $8498b823993a15d8$export$b87f371cbc396fcf.AnnularTotal;
        else eclipseType = $8498b823993a15d8$export$b87f371cbc396fcf.Annular;
    }
    if (eclipseType === $8498b823993a15d8$export$b87f371cbc396fcf.Partial) // (54.2) p. 382
    mag = (1.5433 + u - a\u03B3) / (0.5461 + 2 * u);
    return {
        type: eclipseType,
        central: central,
        jdeMax: jdeMax,
        magnitude: mag,
        distance: \u03B3,
        umbral: u,
        penumbral: p
    };
}
function $8498b823993a15d8$export$4f8a4f64b25d8f9(year) {
    let eclipseType = $8498b823993a15d8$export$b87f371cbc396fcf.None;
    let mag;
    let sdTotal;
    let sdPartial;
    let sdPenumbral;
    const [e, jdeMax, \u03B3, u, M\u02B9] = $8498b823993a15d8$var$g($8498b823993a15d8$var$snap(year, 0.5), (0, $5669375e18e193a3$export$2e2bcd8739ae039).meanFull(year), -0.4065, 0.1727);
    if (!e) return {
        type: eclipseType
    } // no eclipse
    ;
    const \u03C1 = 1.2848 + u;
    const \u03C3 = 0.7403 - u;
    const a\u03B3 = Math.abs(\u03B3);
    mag = (1.0128 - u - a\u03B3) / 0.545 // (54.3) p. 382
    ;
    if (mag > 1) eclipseType = $8498b823993a15d8$export$b87f371cbc396fcf.Total;
    else if (mag > 0) eclipseType = $8498b823993a15d8$export$b87f371cbc396fcf.Umbral;
    else {
        mag = (1.5573 + u - a\u03B3) / 0.545 // (54.4) p. 382
        ;
        if (mag < 0) return {
            type: eclipseType
        } // no eclipse
        ;
        eclipseType = $8498b823993a15d8$export$b87f371cbc396fcf.Penumbral;
    }
    const p = 1.0128 - u;
    const t = 0.4678 - u;
    const n = 0.5458 + 0.04 * Math.cos(M\u02B9);
    const \u03B32 = \u03B3 * \u03B3;
    /* eslint-disable no-fallthrough */ switch(eclipseType){
        case $8498b823993a15d8$export$b87f371cbc396fcf.Total:
            sdTotal = Math.sqrt(t * t - \u03B32) / n / 24;
        case $8498b823993a15d8$export$b87f371cbc396fcf.Umbral:
            sdPartial = Math.sqrt(p * p - \u03B32) / n / 24;
        default:
            {
                const h = 1.5573 + u;
                sdPenumbral = Math.sqrt(h * h - \u03B32) / n / 24;
            }
    }
    /* eslint-enable */ return {
        type: eclipseType,
        jdeMax: jdeMax,
        magnitude: mag,
        distance: \u03B3,
        umbral: \u03C3,
        penumbral: \u03C1,
        sdTotal: sdTotal,
        sdPartial: sdPartial,
        sdPenumbral: sdPenumbral
    };
}
var $8498b823993a15d8$export$2e2bcd8739ae039 = {
    TYPE: $8498b823993a15d8$export$b87f371cbc396fcf,
    solar: $8498b823993a15d8$export$45452b6bebae1c00,
    lunar: $8498b823993a15d8$export$4f8a4f64b25d8f9
};


/**
 * @copyright 2020 mdmunir
 * @copyright 2020 commenthol
 * @license MIT
 * @module elp
 */ /**
 * Elp Mpp02
 * source ftp://cyrano-se.obspm.fr/pub/2_lunar_solutions/2_elpmpp02/elpmpp02.pdf
 */ 
var $9QpM5 = parcelRequire("9QpM5");
const $d44a8ba23c4a8314$var$SEC2RAD = 1 / 3600 * Math.PI / 180;
function $d44a8ba23c4a8314$var$sum(T, series) {
    const coeffs = [];
    Object.keys(series).forEach((x)=>{
        coeffs[x] = 0.0;
        let y = series[x].length - 1;
        for(y; y >= 0; y--){
            // A, t0, t1, t2, t3, t4
            const row = series[x][y];
            const \u03C6 = (0, $9QpM5.default).horner(T, row.slice(1));
            coeffs[x] += row[0] * Math.sin(\u03C6);
        }
    });
    return (0, $9QpM5.default).horner(T, ...coeffs);
}
class $d44a8ba23c4a8314$export$ab2e8fc3a68054ee {
    /**
   * ELP representation of a Moon
   * @constructs Moon
   * @param {object} data - elp data series
   * @example
   * ```js
   * // for use in browser
   * import {data} from 'astronomia.js'
   * const moon = new elp.Moon(data.elpMppDe)
   * ```
   */ constructor(data){
        if (typeof data !== 'object') throw new TypeError('need Elp data');
        this.series = data;
    }
    _calcLBR(T) {
        const L = (0, $9QpM5.default).horner(T, this.series.W1) + $d44a8ba23c4a8314$var$sum(T, this.series.L) * $d44a8ba23c4a8314$var$SEC2RAD;
        const B = $d44a8ba23c4a8314$var$sum(T, this.series.B) * $d44a8ba23c4a8314$var$SEC2RAD;
        const R = $d44a8ba23c4a8314$var$sum(T, this.series.R);
        return {
            L: (0, $9QpM5.default).pmod(L, 2 * Math.PI),
            B: B,
            R: R
        };
    }
    /**
   * Position returns rectangular coordinates referred to the inertial mean ecliptic and equinox of J2000.
   * @param {Number} jde - Julian ephemeris day
   * @return {object} rectangular coordinates
   *   {Number} x
   *   {Number} y
   *   {Number} z
   */ positionXYZ(jde) {
        const T = (0, $9QpM5.default).J2000Century(jde);
        const { L: L, B: B, R: R } = this._calcLBR(T);
        const x = R * Math.cos(L) * Math.cos(B);
        const y = R * Math.sin(L) * Math.cos(B);
        const z = R * Math.sin(B);
        const P = (0, $9QpM5.default).horner(T, 0, 0.10180391e-4, 0.47020439e-6, -0.0000000005417367, -0.000000000002507948, 0.463486e-14);
        const Q = (0, $9QpM5.default).horner(T, 0, -0.000113469002, 0.12372674e-6, 0.12654170e-8, -0.000000000001371808, -0.00000000000000320334);
        const sq = Math.sqrt(1 - P * P - Q * Q);
        const p11 = 1 - 2 * P * P;
        const p12 = 2 * P * Q;
        const p13 = 2 * P * sq;
        const p21 = 2 * P * Q;
        const p22 = 1 - 2 * Q * Q;
        const p23 = -2 * Q * sq;
        const p31 = -2 * P * sq;
        const p32 = 2 * Q * sq;
        const p33 = 1 - 2 * P * P - 2 * Q * Q;
        const result = {
            x: p11 * x + p12 * y + p13 * z,
            y: p21 * x + p22 * y + p23 * z,
            z: p31 * x + p32 * y + p33 * z
        };
        return result;
    }
    /**
   * Delay effect of light time
   *
   * @param {Number} jde - Julian ephemeris day
   * @returns {Number} Delay time in days
   */ lightTime(jde) {
        const T = (0, $9QpM5.default).J2000Century(jde);
        const R = $d44a8ba23c4a8314$var$sum(T, this.series.R);
        return (0, $9QpM5.default).lightTime(R / (0, $9QpM5.default).AU);
    }
    /**
   * Position returns ecliptic position of moon at equinox and ecliptic of date.
   *
   * @param {Number} jde - the date for which positions are desired.
   * @returns {Coord} Results are positions consistent with those elp data,
   * that is, at equinox and ecliptic of date.
   *  {Number} lon - geocentric longitude in radians.
   *  {Number} lat - geocentric latitude in radians.
   *  {Number} range - geocentric range in KM.
   */ position(jde) {
        const T = (0, $9QpM5.default).J2000Century(jde);
        const { L: L, B: B, R: R } = this._calcLBR(T);
        // precession
        const pA = (0, $9QpM5.default).horner(T, 0, 5028.79695, 1.1120, 0.000077, -0.00002353) * $d44a8ba23c4a8314$var$SEC2RAD;
        return new (0, $9QpM5.Coord)((0, $9QpM5.default).pmod(L + pA, 2 * Math.PI), B, R);
    }
}
function $d44a8ba23c4a8314$export$5880b8b5730aff45(elpData, jde) {
    const moon = new $d44a8ba23c4a8314$export$ab2e8fc3a68054ee(elpData);
    return moon.position(jde);
}
var $d44a8ba23c4a8314$export$2e2bcd8739ae039 = {
    Moon: $d44a8ba23c4a8314$export$ab2e8fc3a68054ee,
    position: $d44a8ba23c4a8314$export$5880b8b5730aff45
};


/**
 * @copyright 2013 Sonia Keys
 * @copyright 2016 commenthol
 * @license MIT
 * @module eqtime
 */ /**
 * Eqtime: Chapter 28, Equation of time.
 */ 
var $9QpM5 = parcelRequire("9QpM5");



const { cos: $7195c11bc2a1ace6$var$cos, sin: $7195c11bc2a1ace6$var$sin, tan: $7195c11bc2a1ace6$var$tan } = Math;
function $7195c11bc2a1ace6$export$f1e1789686576879(jde, earth) {
    const \u03C4 = (0, $9QpM5.default).J2000Century(jde) * 0.1;
    const L0 = $7195c11bc2a1ace6$var$l0(\u03C4);
    // code duplicated from solar.ApparentEquatorialVSOP87 so that
    // we can keep Δψ and cε
    const { lon: lon, lat: lat, range: range } = (0, $c85b876782fe98e7$export$2e2bcd8739ae039).trueVSOP87(earth, jde);
    const [\u0394\u03C8, \u0394\u03B5] = (0, $c50a9505be5a627c$export$2e2bcd8739ae039).nutation(jde);
    const a = -20.4898 / 3600 * Math.PI / 180 / range;
    const \u03BB = lon + \u0394\u03C8 + a;
    const \u03B5 = (0, $c50a9505be5a627c$export$2e2bcd8739ae039).meanObliquity(jde) + \u0394\u03B5;
    const eq = new (0, $77f14e36e565e56c$export$2e2bcd8739ae039).Ecliptic(\u03BB, lat).toEquatorial(\u03B5);
    // (28.1) p. 183
    const E = L0 - 0.0057183 * Math.PI / 180 - eq.ra + \u0394\u03C8 * $7195c11bc2a1ace6$var$cos(\u03B5);
    return (0, $9QpM5.default).pmod(E + Math.PI, 2 * Math.PI) - Math.PI;
}
/**
 * (28.2) p. 183
 */ const $7195c11bc2a1ace6$var$l0 = function(\u03C4) {
    return (0, $9QpM5.default).horner(\u03C4, 280.4664567, 360007.6982779, 0.03032028, 1.0 / 49931, -1 / 15300, -0.0000005) * Math.PI / 180;
};
function $7195c11bc2a1ace6$export$ff37b58a2114a13c(jde) {
    const \u03B5 = (0, $c50a9505be5a627c$export$2e2bcd8739ae039).meanObliquity(jde);
    const t = $7195c11bc2a1ace6$var$tan(\u03B5 * 0.5);
    const y = t * t;
    const T = (0, $9QpM5.default).J2000Century(jde);
    const L0 = $7195c11bc2a1ace6$var$l0(T * 0.1);
    const e = (0, $c85b876782fe98e7$export$2e2bcd8739ae039).eccentricity(T);
    const M = (0, $c85b876782fe98e7$export$2e2bcd8739ae039).meanAnomaly(T);
    const [sin2L0, cos2L0] = (0, $9QpM5.default).sincos(2 * L0);
    const sinM = $7195c11bc2a1ace6$var$sin(M);
    // (28.3) p. 185
    return y * sin2L0 - 2 * e * sinM + 4 * e * y * sinM * cos2L0 - y * y * sin2L0 * cos2L0 - 1.25 * e * e * $7195c11bc2a1ace6$var$sin(2 * M);
}
var $7195c11bc2a1ace6$export$2e2bcd8739ae039 = {
    e: $7195c11bc2a1ace6$export$f1e1789686576879,
    eSmart: $7195c11bc2a1ace6$export$ff37b58a2114a13c
};


/**
 * @copyright 2013 Sonia Keys
 * @copyright 2016 commenthol
 * @license MIT
 * @module fit
 */ /**
 * Fit: Chapter 4, Curve Fitting.
 */ /**
 * Linear fits a line to sample data.
 *
 * Argument p is a list of data points.  Results a and b are coefficients
 * of the best fit line y = ax + b.
 */ function $5cc7d5c680e3a9a7$export$45db2fc2f15997e7(points) {
    let sx = 0;
    let sy = 0;
    let sx2 = 0;
    let sxy = 0;
    for (const p of points){
        const x = p.x;
        const y = p.y;
        sx += x;
        sy += y;
        sx2 += x * x;
        sxy += x * y;
    }
    const n = points.length;
    const d = n * sx2 - sx * sx;
    // (4.2) p. 36
    const a = (n * sxy - sx * sy) / d;
    const b = (sy * sx2 - sx * sxy) / d;
    return [
        a,
        b
    ];
}
function $5cc7d5c680e3a9a7$export$8a791b9067a52dff(points) {
    let sx = 0;
    let sy = 0;
    let sx2 = 0;
    let sy2 = 0;
    let sxy = 0;
    for (const p of points){
        const x = p.x;
        const y = p.y;
        sx += x;
        sy += y;
        sx2 += x * x;
        sy2 += y * y;
        sxy += x * y;
    }
    const n = points.length;
    // (4.3) p. 38
    return (n * sxy - sx * sy) / (Math.sqrt(n * sx2 - sx * sx) * Math.sqrt(n * sy2 - sy * sy));
}
function $5cc7d5c680e3a9a7$export$26003e3bc38c881e(points) {
    let P = 0;
    let Q = 0;
    let R = 0;
    let S = 0;
    let T = 0;
    let U = 0;
    let V = 0;
    for (const p of points){
        const x = p.x;
        const y = p.y;
        const x2 = x * x;
        P += x;
        Q += x2;
        R += x * x2;
        S += x2 * x2;
        T += y;
        U += x * y;
        V += x2 * y;
    }
    const N = points.length;
    // (4.5) p. 43
    const D = N * Q * S + 2 * P * Q * R - Q * Q * Q - P * P * S - N * R * R;
    // (4.6) p. 43
    const a = (N * Q * V + P * R * T + P * Q * U - Q * Q * T - P * P * V - N * R * U) / D;
    const b = (N * S * U + P * Q * V + Q * R * T - Q * Q * U - P * S * T - N * R * V) / D;
    const c = (Q * S * T + Q * R * U + P * R * V - Q * Q * V - P * S * U - R * R * T) / D;
    return [
        a,
        b,
        c
    ];
}
function $5cc7d5c680e3a9a7$export$1077fd4c939ea20a(points, f0, f1, f2) {
    let M = 0;
    let P = 0;
    let Q = 0;
    let R = 0;
    let S = 0;
    let T = 0;
    let U = 0;
    let V = 0;
    let W = 0;
    for (const p of points){
        const x = p.x;
        const y = p.y;
        const y0 = f0(x);
        const y1 = f1(x);
        const y2 = f2(x);
        M += y0 * y0;
        P += y0 * y1;
        Q += y0 * y2;
        R += y1 * y1;
        S += y1 * y2;
        T += y2 * y2;
        U += y * y0;
        V += y * y1;
        W += y * y2;
    }
    // (4.7) p. 44
    const D = M * R * T + 2 * P * Q * S - M * S * S - R * Q * Q - T * P * P;
    const a = (U * (R * T - S * S) + V * (Q * S - P * T) + W * (P * S - Q * R)) / D;
    const b = (U * (S * Q - P * T) + V * (M * T - Q * Q) + W * (P * Q - M * S)) / D;
    const c = (U * (P * S - R * Q) + V * (P * Q - M * S) + W * (M * R - P * P)) / D;
    return [
        a,
        b,
        c
    ];
}
function $5cc7d5c680e3a9a7$export$42117deedea10657(points, f) {
    let syf = 0;
    let sf2 = 0;
    // (4.8) p. 45
    for (const p of points){
        const fx = f(p.x);
        const y = p.y;
        syf += y * fx;
        sf2 += fx * fx;
    }
    return syf / sf2;
}
var $5cc7d5c680e3a9a7$export$2e2bcd8739ae039 = {
    linear: $5cc7d5c680e3a9a7$export$45db2fc2f15997e7,
    correlationCoefficient: $5cc7d5c680e3a9a7$export$8a791b9067a52dff,
    quadratic: $5cc7d5c680e3a9a7$export$26003e3bc38c881e,
    func3: $5cc7d5c680e3a9a7$export$1077fd4c939ea20a,
    func1: $5cc7d5c680e3a9a7$export$42117deedea10657
};



/**
 * @copyright 2013 Sonia Keys
 * @copyright 2016 commenthol
 * @license MIT
 * @module illum
 */ /**
 * Illum: Chapter 41, Illuminated Fraction of the Disk and Magnitude of a Planet.
 *
 * Also see functions `illuminated` and `limb` in package base.  While this
 * chapter title includes "illumnated fraction," the function for computing
 * illuminated fraction given a phase angle is `base.illuminated`.
 * `base.limb` is the function mentioned at the bottom of p. 283.0
 */ 
var $9QpM5 = parcelRequire("9QpM5");
const { toDeg: $b8b3a7f8c0299d51$var$toDeg } = (0, $9QpM5.default);
const $b8b3a7f8c0299d51$var$D2R = Math.PI / 180;
function $b8b3a7f8c0299d51$export$47deed96f0ec238c(r, \u0394, R) {
    return Math.acos((r * r + \u0394 * \u0394 - R * R) / (2 * r * \u0394));
}
function $b8b3a7f8c0299d51$export$7f34ce79760854f7(r, \u0394, R) {
    // (41.2) p. 283
    const s = r + \u0394;
    return (s * s - R * R) / (4 * r * \u0394);
}
function $b8b3a7f8c0299d51$export$7ac4458ee5605b11(L, B, R, L0, R0, \u0394) {
    // (41.3) p. 283
    return Math.acos((R - R0 * Math.cos(B) * Math.cos(L - L0)) / \u0394);
}
function $b8b3a7f8c0299d51$export$be86d9bcd1af0de5(L, B, x, y, z, \u0394) {
    // (41.4) p. 283
    const [sL, cL] = (0, $9QpM5.default).sincos(L);
    const [sB, cB] = (0, $9QpM5.default).sincos(B);
    return Math.acos((x * cB * cL + y * cB * sL + z * sB) / \u0394);
}
function $b8b3a7f8c0299d51$export$5dd715c46a6e525c(jde) {
    const T = (0, $9QpM5.default).J2000Century(jde);
    const V = (261.51 + 22518.443 * T) * $b8b3a7f8c0299d51$var$D2R;
    const M = (177.53 + 35999.05 * T) * $b8b3a7f8c0299d51$var$D2R;
    const N = (50.42 + 58517.811 * T) * $b8b3a7f8c0299d51$var$D2R;
    const W = V + (1.91 * Math.sin(M) + 0.78 * Math.sin(N)) * $b8b3a7f8c0299d51$var$D2R;
    const \u0394 = Math.sqrt(1.52321 + 1.44666 * Math.cos(W));
    const s = 0.72333 + \u0394;
    return (s * s - 1) / 2.89332 / \u0394;
}
function $b8b3a7f8c0299d51$export$35a4f18dc3a22ac8(r, \u0394, i) {
    const s = $b8b3a7f8c0299d51$var$toDeg(i) - 50;
    return 1.16 + 5 * Math.log10(r * \u0394) + (0.02838 + 0.0001023 * s) * s;
}
function $b8b3a7f8c0299d51$export$7200842790f06d68(r, \u0394, i) {
    const iDeg = $b8b3a7f8c0299d51$var$toDeg(i);
    return -4 + 5 * Math.log10(r * \u0394) + (0.01322 + 0.0000004247 * iDeg * iDeg) * iDeg;
}
function $b8b3a7f8c0299d51$export$9400e8fb899a485a(r, \u0394, i) {
    return -1.3 + 5 * Math.log10(r * \u0394) + 0.01486 * $b8b3a7f8c0299d51$var$toDeg(i);
}
function $b8b3a7f8c0299d51$export$8e9760ab551a9bc7(r, \u0394) {
    return -8.93 + 5 * Math.log10(r * \u0394);
}
function $b8b3a7f8c0299d51$export$9ca5fcb91cfa691f(r, \u0394, B, \u0394U) {
    const s = Math.sin(Math.abs(B));
    return -8.68 + 5 * Math.log10(r * \u0394) + 0.044 * Math.abs($b8b3a7f8c0299d51$var$toDeg(\u0394U)) - 2.6 * s + 1.25 * s * s;
}
function $b8b3a7f8c0299d51$export$7133e45f08d551bc(r, \u0394) {
    return -6.85 + 5 * Math.log10(r * \u0394);
}
function $b8b3a7f8c0299d51$export$335a11867ede73d(r, \u0394) {
    return -7.05 + 5 * Math.log10(r * \u0394);
}
function $b8b3a7f8c0299d51$export$1083aeecfca85773(r, \u0394, i) {
    return (0, $9QpM5.default).horner($b8b3a7f8c0299d51$var$toDeg(i), -0.42 + 5 * Math.log10(r * \u0394), 0.038, -0.000273, 0.000002);
}
function $b8b3a7f8c0299d51$export$5d6d9e99beee727e(r, \u0394, i) {
    return (0, $9QpM5.default).horner($b8b3a7f8c0299d51$var$toDeg(i), -4.4 + 5 * Math.log10(r * \u0394), 0.0009, 0.000239, -0.00000065);
}
function $b8b3a7f8c0299d51$export$18606e7dba32985(r, \u0394, i) {
    return -1.52 + 5 * Math.log10(r * \u0394) + 0.016 * $b8b3a7f8c0299d51$var$toDeg(i);
}
function $b8b3a7f8c0299d51$export$4013df0368b77f45(r, \u0394, i) {
    return -9.4 + 5 * Math.log10(r * \u0394) + 0.005 * $b8b3a7f8c0299d51$var$toDeg(i);
}
function $b8b3a7f8c0299d51$export$35b79a93e2087325(r, \u0394, B, \u0394U) {
    const s = Math.sin(Math.abs(B));
    return -8.88 + 5 * Math.log10(r * \u0394) + 0.044 * Math.abs($b8b3a7f8c0299d51$var$toDeg(\u0394U)) - 2.6 * s + 1.25 * s * s;
}
function $b8b3a7f8c0299d51$export$a95147d0986e0841(r, \u0394) {
    return -7.19 + 5 * Math.log10(r * \u0394);
}
function $b8b3a7f8c0299d51$export$3418d03ec5f3e6a9(r, \u0394) {
    return -6.87 + 5 * Math.log10(r * \u0394);
}
function $b8b3a7f8c0299d51$export$f92b06382837769b(r, \u0394) {
    return -1 + 5 * Math.log10(r * \u0394);
}
var $b8b3a7f8c0299d51$export$2e2bcd8739ae039 = {
    phaseAngle: $b8b3a7f8c0299d51$export$47deed96f0ec238c,
    fraction: $b8b3a7f8c0299d51$export$7f34ce79760854f7,
    phaseAngle2: $b8b3a7f8c0299d51$export$7ac4458ee5605b11,
    phaseAngle3: $b8b3a7f8c0299d51$export$be86d9bcd1af0de5,
    fractionVenus: $b8b3a7f8c0299d51$export$5dd715c46a6e525c,
    mercury: $b8b3a7f8c0299d51$export$35a4f18dc3a22ac8,
    venus: $b8b3a7f8c0299d51$export$7200842790f06d68,
    mars: $b8b3a7f8c0299d51$export$9400e8fb899a485a,
    jupiter: $b8b3a7f8c0299d51$export$8e9760ab551a9bc7,
    saturn: $b8b3a7f8c0299d51$export$9ca5fcb91cfa691f,
    uranus: $b8b3a7f8c0299d51$export$7133e45f08d551bc,
    neptune: $b8b3a7f8c0299d51$export$335a11867ede73d,
    mercury84: $b8b3a7f8c0299d51$export$1083aeecfca85773,
    venus84: $b8b3a7f8c0299d51$export$5d6d9e99beee727e,
    mars84: $b8b3a7f8c0299d51$export$18606e7dba32985,
    jupiter84: $b8b3a7f8c0299d51$export$4013df0368b77f45,
    saturn84: $b8b3a7f8c0299d51$export$35b79a93e2087325,
    uranus84: $b8b3a7f8c0299d51$export$a95147d0986e0841,
    neptune84: $b8b3a7f8c0299d51$export$3418d03ec5f3e6a9,
    pluto84: $b8b3a7f8c0299d51$export$f92b06382837769b
};




/**
 * @copyright 2013 Sonia Keys
 * @copyright 2016 commenthol
 * @license MIT
 * @module jm
 */ /**
 * JM: Chapter 9, Jewish and Moslem Calendars.
 *
 * The Jewish calendar routines are implemented as a monolithic function,
 * because computations of the various results build off of common
 * intermediate results.
 *
 * The Moslem calendar routines break down nicely into some separate functions.
 *
 * Included in these are two functions that convert between Gregorian and
 * Julian calendar days without going through Julian day (JD).  As such,
 * I suppose, these or similar routines are not in chapter 7, Julian Day.
 * Package base might also be a suitable place for these, but I'm not sure
 * they are used anywhere else in the book.  Anyway, they have the quirk
 * that they are not direct inverses:  JulianToGregorian returns the day number
 * of the day of the Gregorian year, but GregorianToJulian wants the Gregorian
 * month and day of month as input.
 */ 
var $9QpM5 = parcelRequire("9QpM5");
/**
 * @copyright 2013 Sonia Keys
 * @copyright 2016 commenthol
 * @license MIT
 * @module julian
 */ /**
 * Julian: Chapter 7, Julian day.
 */ 
var $9QpM5 = parcelRequire("9QpM5");


const $b4d5bd4b4d56819f$var$int = Math.trunc;
const $b4d5bd4b4d56819f$export$1ac59b60fd73f945 = 2299160.5;
const $b4d5bd4b4d56819f$var$DAYS_OF_YEAR = [
    0,
    0,
    31,
    59,
    90,
    120,
    151,
    181,
    212,
    243,
    273,
    304,
    334
];
const $b4d5bd4b4d56819f$var$SECS_OF_DAY = 86400 // 24 * 60 * 60
;
class $b4d5bd4b4d56819f$export$e1aef45b828286de {
    /**
   * @param {number|Date} [year] - If `Date` is given then year, month, day is taken from that. Shortcut to `new Calendar().fromDate(date)`
   * @param {number} [month]
   * @param {number} [day]
   */ constructor(year, month = 1, day = 1){
        if (year instanceof Date) this.fromDate(year);
        else {
            this.year = year;
            this.month = month;
            this.day = day;
        }
    }
    getDate() {
        return {
            year: this.year,
            month: this.month,
            day: Math.floor(this.day)
        };
    }
    getTime() {
        const t = new (0, $c953199d551a315b$export$2e2bcd8739ae039).Time(this.day * $b4d5bd4b4d56819f$var$SECS_OF_DAY);
        const [neg, h, m, _s] = t.toHMS() // eslint-disable-line no-unused-vars
        ;
        let [s, ms] = (0, $9QpM5.default).modf(_s);
        ms = Math.trunc(ms * 1000);
        return {
            hour: h % 24,
            minute: m,
            second: s,
            millisecond: ms
        };
    }
    toISOString() {
        const { year: year, month: month, day: day } = this.getDate();
        const { hour: hour, minute: minute, second: second, millisecond: millisecond } = this.getTime();
        return `${$b4d5bd4b4d56819f$var$pad(year, 4)}-${$b4d5bd4b4d56819f$var$pad(month)}-${$b4d5bd4b4d56819f$var$pad(day)}T` + `${$b4d5bd4b4d56819f$var$pad(hour)}:${$b4d5bd4b4d56819f$var$pad(minute)}:${$b4d5bd4b4d56819f$var$pad(second)}.${$b4d5bd4b4d56819f$var$pad(millisecond, 3)}Z`;
    }
    isGregorian() {
        return $b4d5bd4b4d56819f$export$a334000b14cf6bd1(this.year, this.month, this.day);
    }
    /**
   * Note: Take care for dates < GREGORIAN0JD as `date` is always within the
   * proleptic Gregorian Calender
   * @param {Date} date - proleptic Gregorian date
   */ fromDate(date) {
        this.year = date.getUTCFullYear();
        this.month = date.getUTCMonth() + 1;
        const day = date.getUTCDate();
        const hour = date.getUTCHours();
        const minute = date.getUTCMinutes();
        const second = date.getUTCSeconds();
        const ms = date.getMilliseconds();
        this.day = day + (hour + (minute + (second + ms / 1000) / 60) / 60) / 24;
        return this;
    }
    /**
   * Note: Take care for dates < GREGORIAN0JD as `date` is always within the
   * proleptic Gregorian Calender
   * @returns {Date} proleptic Gregorian date
   */ toDate() {
        const [day, fhour] = (0, $9QpM5.default).modf(this.day);
        const [hour, fminute] = (0, $9QpM5.default).modf(fhour * 24);
        const [minute, fsecond] = (0, $9QpM5.default).modf(fminute * 60);
        const [second, fms] = (0, $9QpM5.default).modf(fsecond * 60);
        const date = new Date(Date.UTC(this.year, this.month - 1, day, hour, minute, second, Math.round(fms * 1000)));
        date.setUTCFullYear(this.year);
        return date;
    }
    /**
   * converts a calendar date to decimal year
   * @returns {number} decimal year
   */ toYear() {
        const [d, f] = (0, $9QpM5.default).modf(this.day) // eslint-disable-line no-unused-vars
        ;
        const n = this.dayOfYear() - 1 + f;
        const days = this.isLeapYear() ? 366 : 365;
        const decYear = this.year + n / days;
        return decYear;
    }
    /**
   * converts a decimal year to a calendar date
   * @param {number} year - decimal year
   */ fromYear(year) {
        const [y, f] = (0, $9QpM5.default).modf(year);
        this.year = y;
        const days = this.isLeapYear() ? 366 : 365;
        const dayOfYear = (0, $9QpM5.default).round(f * days, 5);
        let m = 12;
        while(m > 0 && $b4d5bd4b4d56819f$var$DAYS_OF_YEAR[m] > dayOfYear)m--;
        this.month = m;
        this.day = 1 + dayOfYear - $b4d5bd4b4d56819f$var$DAYS_OF_YEAR[this.month];
        return this;
    }
    isLeapYear() {
        if (this.isGregorian()) return $b4d5bd4b4d56819f$export$3a96a939b32299e1(this.year);
        else return $b4d5bd4b4d56819f$export$7732f06b3e563022(this.year);
    }
    toJD() {
        return $b4d5bd4b4d56819f$export$5c3ee97de8692d33(this.year, this.month, this.day, !this.isGregorian());
    }
    fromJD(jd) {
        const isJulian = !$b4d5bd4b4d56819f$export$d5f736862d7242e2(jd);
        const { year: year, month: month, day: day } = $b4d5bd4b4d56819f$export$25f420322076464b(jd, isJulian);
        this.year = year;
        this.month = month;
        this.day = day;
        return this;
    }
    fromJDE(jde) {
        this.fromJD(jde);
        const dT = (0, $8085e6c028279bac$export$2e2bcd8739ae039).deltaT(this.toYear()) // in seconds
        ;
        this.day -= dT / 86400;
        return this;
    }
    toJDE() {
        const dT = (0, $8085e6c028279bac$export$2e2bcd8739ae039).deltaT(this.toYear()) // in seconds
        ;
        this.day += dT / 86400;
        return this.toJD();
    }
    /**
   * set date to midnight UTC
   */ midnight() {
        this.day = Math.floor(this.day);
        return this;
    }
    /**
   * set date to noon UTC
   */ noon() {
        this.day = Math.floor(this.day) + 0.5;
        return this;
    }
    /**
   * @param {Boolean} td - if `true` calendar instance is in TD; date gets converted to UT
   *   true  - `UT = TD - ΔT`
   *   false - `TD = UT + ΔT`
   */ deltaT(td) {
        const dT = (0, $8085e6c028279bac$export$2e2bcd8739ae039).deltaT(this.toYear()) // in seconds
        ;
        if (td) this.day -= dT / 86400;
        else this.day += dT / 86400;
        return this;
    }
    dayOfWeek() {
        return $b4d5bd4b4d56819f$export$7ed5ca4f8b987938(this.toJD());
    }
    dayOfYear() {
        if (this.isGregorian()) return $b4d5bd4b4d56819f$export$120980cddbd1279d(this.year, this.month, this.day);
        else return $b4d5bd4b4d56819f$export$df50309aaf259a4e(this.year, this.month, this.day);
    }
}
class $b4d5bd4b4d56819f$export$4d66f3c95443b8eb extends $b4d5bd4b4d56819f$export$e1aef45b828286de {
    toJD() {
        return $b4d5bd4b4d56819f$export$deca0f77506b46b9(this.year, this.month, this.day);
    }
    fromJD(jd) {
        const { year: year, month: month, day: day } = $b4d5bd4b4d56819f$export$64214f487e685bfc(jd);
        this.year = year;
        this.month = month;
        this.day = day;
        return this;
    }
    isLeapYear() {
        return $b4d5bd4b4d56819f$export$7732f06b3e563022(this.year);
    }
    dayOfYear() {
        return $b4d5bd4b4d56819f$export$df50309aaf259a4e(this.year, this.month, this.day);
    }
    /**
   * toGregorian converts a Julian calendar date to a year, month, and day
   * in the Gregorian calendar.
   * @returns {CalendarGregorian}
   */ toGregorian() {
        const jd = this.toJD();
        return new $b4d5bd4b4d56819f$export$9b7e39522fa0718e().fromJD(jd);
    }
}
class $b4d5bd4b4d56819f$export$9b7e39522fa0718e extends $b4d5bd4b4d56819f$export$e1aef45b828286de {
    toJD() {
        return $b4d5bd4b4d56819f$export$4c4945d26b9b7e7b(this.year, this.month, this.day);
    }
    fromJD(jd) {
        const { year: year, month: month, day: day } = $b4d5bd4b4d56819f$export$80bbca3e1fd7a95a(jd);
        this.year = year;
        this.month = month;
        this.day = day;
        return this;
    }
    isLeapYear() {
        return $b4d5bd4b4d56819f$export$3a96a939b32299e1(this.year);
    }
    dayOfYear() {
        return $b4d5bd4b4d56819f$export$120980cddbd1279d(this.year, this.month, this.day);
    }
    /*
  * toJulian converts a Gregorian calendar date to a year, month, and day
  * in the Julian calendar.
  * @returns {CalendarJulian}
  */ toJulian() {
        const jd = this.toJD();
        return new $b4d5bd4b4d56819f$export$4d66f3c95443b8eb().fromJD(jd);
    }
}
function $b4d5bd4b4d56819f$export$5c3ee97de8692d33(y, m, d, isJulian) {
    let b = 0;
    if (m < 3) {
        y--;
        m += 12;
    }
    if (!isJulian) {
        const a = (0, $9QpM5.default).floorDiv(y, 100);
        b = 2 - a + (0, $9QpM5.default).floorDiv(a, 4);
    }
    // (7.1) p. 61
    const jd = (0, $9QpM5.default).floorDiv(36525 * $b4d5bd4b4d56819f$var$int(y + 4716), 100) + ((0, $9QpM5.default).floorDiv(306 * (m + 1), 10) + b) + d - 1524.5;
    return jd;
}
function $b4d5bd4b4d56819f$export$4c4945d26b9b7e7b(y, m, d) {
    return $b4d5bd4b4d56819f$export$5c3ee97de8692d33(y, m, d, false);
}
function $b4d5bd4b4d56819f$export$deca0f77506b46b9(y, m, d) {
    return $b4d5bd4b4d56819f$export$5c3ee97de8692d33(y, m, d, true);
}
function $b4d5bd4b4d56819f$export$7732f06b3e563022(y) {
    return y % 4 === 0;
}
function $b4d5bd4b4d56819f$export$3a96a939b32299e1(y) {
    return y % 4 === 0 && y % 100 !== 0 || y % 400 === 0;
}
function $b4d5bd4b4d56819f$export$25f420322076464b(jd, isJulian) {
    const [z, f] = (0, $9QpM5.default).modf(jd + 0.5);
    let a = z;
    if (!isJulian) {
        const \u03B1 = (0, $9QpM5.default).floorDiv(z * 100 - 186721625, 3652425);
        a = z + 1 + \u03B1 - (0, $9QpM5.default).floorDiv(\u03B1, 4);
    }
    const b = a + 1524;
    const c = (0, $9QpM5.default).floorDiv(b * 100 - 12210, 36525);
    const d = (0, $9QpM5.default).floorDiv(36525 * c, 100);
    const e = $b4d5bd4b4d56819f$var$int((0, $9QpM5.default).floorDiv((b - d) * 1e4, 306001));
    // compute return values
    let year;
    let month;
    const day = $b4d5bd4b4d56819f$var$int(b - d) - (0, $9QpM5.default).floorDiv(306001 * e, 1e4) + f;
    if (e === 14 || e === 15) month = e - 13;
    else month = e - 1;
    if (month < 3) year = $b4d5bd4b4d56819f$var$int(c) - 4715;
    else year = $b4d5bd4b4d56819f$var$int(c) - 4716;
    return {
        year: year,
        month: month,
        day: day
    };
}
function $b4d5bd4b4d56819f$export$80bbca3e1fd7a95a(jd) {
    return $b4d5bd4b4d56819f$export$25f420322076464b(jd, false);
}
function $b4d5bd4b4d56819f$export$64214f487e685bfc(jd) {
    return $b4d5bd4b4d56819f$export$25f420322076464b(jd, true);
}
function $b4d5bd4b4d56819f$export$d5f736862d7242e2(jd) {
    return jd >= $b4d5bd4b4d56819f$export$1ac59b60fd73f945;
}
function $b4d5bd4b4d56819f$export$a334000b14cf6bd1(year, month = 1, day = 1) {
    return year > 1582 || year === 1582 && month > 10 || year === 1582 && month === 10 && day >= 15;
}
function $b4d5bd4b4d56819f$export$c013fe662c11fe2d(jd) {
    return new $b4d5bd4b4d56819f$export$9b7e39522fa0718e().fromJD(jd).toDate();
}
function $b4d5bd4b4d56819f$export$f14fca4b40dc7424(date) {
    return new $b4d5bd4b4d56819f$export$9b7e39522fa0718e().fromDate(date).toJD();
}
function $b4d5bd4b4d56819f$export$421af55bfb018a9c(jde) {
    return new $b4d5bd4b4d56819f$export$9b7e39522fa0718e().fromJDE(jde).toDate();
}
function $b4d5bd4b4d56819f$export$10385f7313f32c84(date) {
    return new $b4d5bd4b4d56819f$export$9b7e39522fa0718e().fromDate(date).toJDE();
}
function $b4d5bd4b4d56819f$export$7b7d103923ee7b85(mjd) {
    return mjd + (0, $9QpM5.default).JMod;
}
function $b4d5bd4b4d56819f$export$26cab58911bc0eba(jd) {
    return jd - (0, $9QpM5.default).JMod;
}
function $b4d5bd4b4d56819f$export$7ed5ca4f8b987938(jd) {
    return $b4d5bd4b4d56819f$var$int(jd + 1.5) % 7;
}
function $b4d5bd4b4d56819f$export$120980cddbd1279d(y, m, d) {
    return $b4d5bd4b4d56819f$export$3464bc6543d4e73d(y, m, $b4d5bd4b4d56819f$var$int(d), $b4d5bd4b4d56819f$export$3a96a939b32299e1(y));
}
function $b4d5bd4b4d56819f$export$df50309aaf259a4e(y, m, d) {
    return $b4d5bd4b4d56819f$export$3464bc6543d4e73d(y, m, $b4d5bd4b4d56819f$var$int(d), $b4d5bd4b4d56819f$export$7732f06b3e563022(y));
}
function $b4d5bd4b4d56819f$export$3464bc6543d4e73d(y, m, d, leap) {
    let k = 0;
    if (leap && m > 1) k = 1;
    return k + $b4d5bd4b4d56819f$var$DAYS_OF_YEAR[m] + $b4d5bd4b4d56819f$var$int(d);
}
function $b4d5bd4b4d56819f$export$61d2b0466ae2cfc6(n, leap) {
    let month;
    let k = 0;
    if (leap) k = 1;
    for(month = 1; month <= 12; month++)if (k + $b4d5bd4b4d56819f$var$DAYS_OF_YEAR[month] > n) {
        month = month - 1;
        break;
    }
    const day = n - k - $b4d5bd4b4d56819f$var$DAYS_OF_YEAR[month];
    return {
        month: month,
        day: day
    };
}
function $b4d5bd4b4d56819f$export$e161fb2ea860251b(year, n) {
    const { month: month, day: day } = $b4d5bd4b4d56819f$export$61d2b0466ae2cfc6(n, $b4d5bd4b4d56819f$export$3a96a939b32299e1(year));
    return new $b4d5bd4b4d56819f$export$9b7e39522fa0718e(year, month, day);
}
function $b4d5bd4b4d56819f$export$102e82b32094e03d(year, n) {
    const { month: month, day: day } = $b4d5bd4b4d56819f$export$61d2b0466ae2cfc6(n, $b4d5bd4b4d56819f$export$7732f06b3e563022(year));
    return new $b4d5bd4b4d56819f$export$4d66f3c95443b8eb(year, month, day);
}
function $b4d5bd4b4d56819f$var$pad(num, len) {
    len = len || 2;
    const neg = num < 0 ? '-' : '';
    num = Math.abs(num);
    const padded = '0000' + num;
    return neg + padded.substr(padded.length - len, len);
}
var $b4d5bd4b4d56819f$export$2e2bcd8739ae039 = {
    GREGORIAN0JD: $b4d5bd4b4d56819f$export$1ac59b60fd73f945,
    Calendar: $b4d5bd4b4d56819f$export$e1aef45b828286de,
    CalendarJulian: $b4d5bd4b4d56819f$export$4d66f3c95443b8eb,
    CalendarGregorian: $b4d5bd4b4d56819f$export$9b7e39522fa0718e,
    CalendarToJD: $b4d5bd4b4d56819f$export$5c3ee97de8692d33,
    CalendarGregorianToJD: $b4d5bd4b4d56819f$export$4c4945d26b9b7e7b,
    CalendarJulianToJD: $b4d5bd4b4d56819f$export$deca0f77506b46b9,
    LeapYearJulian: $b4d5bd4b4d56819f$export$7732f06b3e563022,
    LeapYearGregorian: $b4d5bd4b4d56819f$export$3a96a939b32299e1,
    JDToCalendar: $b4d5bd4b4d56819f$export$25f420322076464b,
    JDToCalendarGregorian: $b4d5bd4b4d56819f$export$80bbca3e1fd7a95a,
    JDToCalendarJulian: $b4d5bd4b4d56819f$export$64214f487e685bfc,
    isJDCalendarGregorian: $b4d5bd4b4d56819f$export$d5f736862d7242e2,
    isCalendarGregorian: $b4d5bd4b4d56819f$export$a334000b14cf6bd1,
    JDToDate: $b4d5bd4b4d56819f$export$c013fe662c11fe2d,
    DateToJD: $b4d5bd4b4d56819f$export$f14fca4b40dc7424,
    JDEToDate: $b4d5bd4b4d56819f$export$421af55bfb018a9c,
    DateToJDE: $b4d5bd4b4d56819f$export$10385f7313f32c84,
    MJDToJD: $b4d5bd4b4d56819f$export$7b7d103923ee7b85,
    JDToMJD: $b4d5bd4b4d56819f$export$26cab58911bc0eba,
    DayOfWeek: $b4d5bd4b4d56819f$export$7ed5ca4f8b987938,
    DayOfYearGregorian: $b4d5bd4b4d56819f$export$120980cddbd1279d,
    DayOfYearJulian: $b4d5bd4b4d56819f$export$df50309aaf259a4e,
    DayOfYear: $b4d5bd4b4d56819f$export$3464bc6543d4e73d,
    DayOfYearToCalendar: $b4d5bd4b4d56819f$export$61d2b0466ae2cfc6,
    DayOfYearToCalendarGregorian: $b4d5bd4b4d56819f$export$e161fb2ea860251b,
    DayOfYearToCalendarJulian: $b4d5bd4b4d56819f$export$102e82b32094e03d
};


const $aedfb8106013dc69$var$int = Math.trunc;
function $aedfb8106013dc69$export$67b5a4894536668c(y) {
    const A = y + 3760;
    const D = $aedfb8106013dc69$var$bigD(y);
    let mP = 3;
    let dP = D;
    if (dP > 31) {
        mP++;
        dP -= 31;
    }
    // A simplification of Meeus's rule to add 163 days.  Months of Pesach
    // are either March or April with D based off of March.  Months of New
    // year are either September or August so D+163-(days from March to
    // September == 184) = D-21 must be based off of September.
    let mNY = 9;
    let dNY = D - 21;
    if (dNY > 30) {
        mNY++;
        dNY -= 30;
    }
    let months = 12;
    switch(A % 19){
        case 0:
        case 3:
        case 6:
        case 8:
        case 11:
        case 14:
        case 17:
            months++;
            break;
    }
    // Similarly, A simplification of Meeus's rule to take the difference
    // in calendar days from NY of one year to NY of the next.  NY is based
    // on D, so difference in D is difference in day numbers of year.  Result
    // is sum of this number and the number of days in the Western calandar
    // year.
    const y1 = y + 1;
    let lf = (0, $b4d5bd4b4d56819f$export$2e2bcd8739ae039).LeapYearGregorian;
    if (y1 < 1583) lf = (0, $b4d5bd4b4d56819f$export$2e2bcd8739ae039).LeapYearJulian;
    let days = 365;
    if (lf(y1)) days++;
    days += $aedfb8106013dc69$var$bigD(y1) - D;
    return [
        A,
        mP,
        dP,
        mNY,
        dNY,
        months,
        days
    ];
}
const $aedfb8106013dc69$var$bigD = function(y) {
    const C = (0, $9QpM5.default).floorDiv(y, 100);
    // const S int
    let S = 0;
    if (y >= 1583) S = $aedfb8106013dc69$var$int((0, $9QpM5.default).floorDiv(3 * C - 5, 4));
    const a = (12 * y + 12) % 19;
    const b = y % 4;
    const Q = -1.904412361576 + 1.554241796621 * a + 0.25 * b - 0.003177794022 * y + S;
    const fq = Math.floor(Q);
    const iq = $aedfb8106013dc69$var$int(fq);
    const j = (iq + 3 * y + 5 * b + 2 - S) % 7;
    const r = Q - fq;
    // const D int
    let D;
    if (j === 2 || j === 4 || j === 6) D = iq + 23;
    else if (j === 1 && a > 6 && r >= 0.63287037) D = iq + 24;
    else if (j === 0 && a > 11 && r >= 0.897723765) D = iq + 23;
    else D = iq + 22;
    return $aedfb8106013dc69$var$int(D);
};
function $aedfb8106013dc69$export$3a21d295cae2d2bd(y, m, d) {
    const N = d + (0, $9QpM5.default).floorDiv(295001 * (m - 1) + 9900, 10000);
    const Q = (0, $9QpM5.default).floorDiv(y, 30);
    const R = y % 30;
    const A = (0, $9QpM5.default).floorDiv(11 * R + 3, 30);
    const W = 404 * Q + 354 * R + 208 + A;
    const Q1 = (0, $9QpM5.default).floorDiv(W, 1461);
    const Q2 = W % 1461;
    const G = 621 + 28 * Q + 4 * Q1;
    const K = (0, $9QpM5.default).floorDiv(Q2 * 10000, 3652422);
    const E = (0, $9QpM5.default).floorDiv(3652422 * K, 10000);
    let J = Q2 - E + N - 1;
    let X = G + K;
    if (J > 366 && X % 4 === 0) {
        J -= 366;
        X++;
    } else if (J > 365 && X % 4 > 0) {
        J -= 365;
        X++;
    }
    const jd = (0, $9QpM5.default).floorDiv(36525 * (X - 1), 100) + 1721423 + J;
    return jd;
}
function $aedfb8106013dc69$export$d538786d3132347b(year) {
    const R = year % 30;
    return (11 * R + 3) % 30 > 18;
}
function $aedfb8106013dc69$export$cf6d61f7677d835c(y, m, d) {
    let W = 2;
    if (y % 4 === 0) W = 1;
    const N = (0, $9QpM5.default).floorDiv(275 * m, 9) - W * (0, $9QpM5.default).floorDiv(m + 9, 12) + d - 30;
    const A = $aedfb8106013dc69$var$int(y - 623);
    const B = (0, $9QpM5.default).floorDiv(A, 4);
    const C2 = function(A) {
        const C = A % 4;
        const C1 = 365.25001 * C;
        const C2 = Math.floor(C1);
        if (C1 - C2 > 0.5) return $aedfb8106013dc69$var$int(C2) + 1;
        return $aedfb8106013dc69$var$int(C2);
    }(A);
    const Dp = 1461 * B + 170 + C2;
    const Q = (0, $9QpM5.default).floorDiv(Dp, 10631);
    const R = Dp % 10631;
    const J = (0, $9QpM5.default).floorDiv(R, 354);
    const K = R % 354;
    const O = (0, $9QpM5.default).floorDiv(11 * J + 14, 30);
    let my = 30 * Q + J + 1;
    let JJ = K - O + N - 1;
    let days = 354;
    if ($aedfb8106013dc69$export$d538786d3132347b(y)) days++;
    if (JJ > days) {
        JJ -= days;
        my++;
    }
    let mm;
    let md;
    if (JJ === 355) {
        mm = 12;
        md = 30;
    } else {
        const S = (0, $9QpM5.default).floorDiv((JJ - 1) * 10, 295);
        mm = 1 + S;
        md = (0, $9QpM5.default).floorDiv(10 * JJ - 295 * S, 10);
    }
    return {
        year: my,
        month: mm,
        day: md
    };
}
/**
 * An MMonth specifies a month of the Moslum Calendar (Muharram = 1, ...).
 *
 * Upgraded to Unicode from the spellings given by Meeus.
 * Source: http://en.wikipedia.org/wiki/Islamic_calendar.
 */ const $aedfb8106013dc69$var$mmonths = [
    '',
    "Mu\u1E25arram",
    "\u1E62afar",
    "Rab\u012B\u02BF I",
    "Rab\u012B\u02BF II",
    "Jum\u0101d\u0101 I",
    "Jum\u0101d\u0101 II",
    'Rajab',
    "Sha\u02BFb\u0101n",
    "Rama\u1E0D\u0101n",
    "Shaww\u0101l",
    "Dh\u016B al-Qa\u02BFda",
    "Dh\u016B al-\u1E24ijja"
];
function $aedfb8106013dc69$export$ac91787e03c34dd(m) {
    return $aedfb8106013dc69$var$mmonths[m];
}
var $aedfb8106013dc69$export$2e2bcd8739ae039 = {
    JewishCalendar: $aedfb8106013dc69$export$67b5a4894536668c,
    MoslemToJD: $aedfb8106013dc69$export$3a21d295cae2d2bd,
    MoslemLeapYear: $aedfb8106013dc69$export$d538786d3132347b,
    JulianToMoslem: $aedfb8106013dc69$export$cf6d61f7677d835c,
    moslemMonth: $aedfb8106013dc69$export$ac91787e03c34dd
};



/**
 * @copyright 2013 Sonia Keys
 * @copyright 2016 commenthol
 * @license MIT
 * @module jupiter
 */ /**
 * Jupiter: Chapter 42, Ephemeris for Physical Observations of Jupiter.
 */ 
var $9QpM5 = parcelRequire("9QpM5");


function $1e4a07ab10e353f5$export$9a54d1b59736b1ea(jde, earth, jupiter) {
    // Step 1.0
    const d = jde - 2433282.5;
    const T1 = d / (0, $9QpM5.default).JulianCentury;
    const p = Math.PI / 180;
    const \u03B10 = 268 * p + 0.1061 * p * T1;
    const \u03B40 = 64.5 * p - 0.0164 * p * T1;
    // Step 2.0
    const W1 = 17.71 * p + 877.90003539 * p * d;
    const W2 = 16.838 * p + 870.27003539 * p * d;
    // Step 3.0
    const pos = earth.position(jde);
    let [l0, b0, R] = [
        pos.lon,
        pos.lat,
        pos.range
    ];
    const fk5 = (0, $2c5cad23f9dfa2db$export$2e2bcd8739ae039).toFK5(l0, b0, jde);
    l0 = fk5.lon;
    b0 = fk5.lat;
    // Steps 4-7.
    const [sl0, cl0] = (0, $9QpM5.default).sincos(l0);
    const sb0 = Math.sin(b0);
    let \u0394 = 4.0 // surely better than 0.0
    ;
    let l = 0;
    let b = 0;
    let r = 0;
    let x = 0;
    let y = 0;
    let z = 0;
    const f = function() {
        const \u03C4 = (0, $9QpM5.default).lightTime(\u0394);
        const pos = jupiter.position(jde - \u03C4);
        l = pos.lon;
        b = pos.lat;
        r = pos.range;
        const fk5 = (0, $2c5cad23f9dfa2db$export$2e2bcd8739ae039).toFK5(l, b, jde);
        l = fk5.lon;
        b = fk5.lat;
        const [sb, cb] = (0, $9QpM5.default).sincos(b);
        const [sl, cl] = (0, $9QpM5.default).sincos(l);
        // (42.2) p. 289
        x = r * cb * cl - R * cl0;
        y = r * cb * sl - R * sl0;
        z = r * sb - R * sb0;
        // (42.3) p. 289
        \u0394 = Math.sqrt(x * x + y * y + z * z);
    };
    f();
    f();
    // Step 8.0
    const \u03B50 = (0, $c50a9505be5a627c$export$2e2bcd8739ae039).meanObliquity(jde);
    // Step 9.0
    const [s\u03B50, c\u03B50] = (0, $9QpM5.default).sincos(\u03B50);
    const [sl, cl] = (0, $9QpM5.default).sincos(l);
    const [sb, cb] = (0, $9QpM5.default).sincos(b);
    const \u03B1s = Math.atan2(c\u03B50 * sl - s\u03B50 * sb / cb, cl);
    const \u03B4s = Math.asin(c\u03B50 * sb + s\u03B50 * cb * sl);
    // Step 10.0
    const [s\u03B4s, c\u03B4s] = (0, $9QpM5.default).sincos(\u03B4s);
    const [s\u03B40, c\u03B40] = (0, $9QpM5.default).sincos(\u03B40);
    const DS = Math.asin(-s\u03B40 * s\u03B4s - c\u03B40 * c\u03B4s * Math.cos(\u03B10 - \u03B1s));
    // Step 11.0
    const u = y * c\u03B50 - z * s\u03B50;
    const v = y * s\u03B50 + z * c\u03B50;
    let \u03B1 = Math.atan2(u, x);
    let \u03B4 = Math.atan(v / Math.hypot(x, u));
    const [s\u03B4, c\u03B4] = (0, $9QpM5.default).sincos(\u03B4);
    const [s\u03B10\u03B1, c\u03B10\u03B1] = (0, $9QpM5.default).sincos(\u03B10 - \u03B1);
    const \u03B6 = Math.atan2(s\u03B40 * c\u03B4 * c\u03B10\u03B1 - s\u03B4 * c\u03B40, c\u03B4 * s\u03B10\u03B1);
    // Step 12.0
    const DE = Math.asin(-s\u03B40 * s\u03B4 - c\u03B40 * c\u03B4 * Math.cos(\u03B10 - \u03B1));
    // Step 13.0
    let \u03C91 = W1 - \u03B6 - 5.07033 * p * \u0394;
    let \u03C92 = W2 - \u03B6 - 5.02626 * p * \u0394;
    // Step 14.0
    let C = (2 * r * \u0394 + R * R - r * r - \u0394 * \u0394) / (4 * r * \u0394);
    if (Math.sin(l - l0) < 0) C = -C;
    \u03C91 = (0, $9QpM5.default).pmod(\u03C91 + C, 2 * Math.PI);
    \u03C92 = (0, $9QpM5.default).pmod(\u03C92 + C, 2 * Math.PI);
    // Step 15.0
    const [\u0394\u03C8, \u0394\u03B5] = (0, $c50a9505be5a627c$export$2e2bcd8739ae039).nutation(jde);
    const \u03B5 = \u03B50 + \u0394\u03B5;
    // Step 16.0
    const [s\u03B5, c\u03B5] = (0, $9QpM5.default).sincos(\u03B5);
    const [s\u03B1, c\u03B1] = (0, $9QpM5.default).sincos(\u03B1);
    \u03B1 += 0.005693 * p * (c\u03B1 * cl0 * c\u03B5 + s\u03B1 * sl0) / c\u03B4;
    \u03B4 += 0.005693 * p * (cl0 * c\u03B5 * (s\u03B5 / c\u03B5 * c\u03B4 - s\u03B1 * s\u03B4) + c\u03B1 * s\u03B4 * sl0);
    // Step 17.0
    const t\u03B4 = s\u03B4 / c\u03B4;
    const \u0394\u03B1 = (c\u03B5 + s\u03B5 * s\u03B1 * t\u03B4) * \u0394\u03C8 - c\u03B1 * t\u03B4 * \u0394\u03B5;
    const \u0394\u03B4 = s\u03B5 * c\u03B1 * \u0394\u03C8 + s\u03B1 * \u0394\u03B5;
    const \u03B1\u02B9 = \u03B1 + \u0394\u03B1;
    const \u03B4\u02B9 = \u03B4 + \u0394\u03B4;
    const [s\u03B10, c\u03B10] = (0, $9QpM5.default).sincos(\u03B10);
    const t\u03B40 = s\u03B40 / c\u03B40;
    const \u0394\u03B10 = (c\u03B5 + s\u03B5 * s\u03B10 * t\u03B40) * \u0394\u03C8 - c\u03B10 * t\u03B40 * \u0394\u03B5;
    const \u0394\u03B40 = s\u03B5 * c\u03B10 * \u0394\u03C8 + s\u03B10 * \u0394\u03B5;
    const \u03B10\u02B9 = \u03B10 + \u0394\u03B10;
    const \u03B40\u02B9 = \u03B40 + \u0394\u03B40;
    // Step 18.0
    const [s\u03B4\u02B9, c\u03B4\u02B9] = (0, $9QpM5.default).sincos(\u03B4\u02B9);
    const [s\u03B40\u02B9, c\u03B40\u02B9] = (0, $9QpM5.default).sincos(\u03B40\u02B9);
    const [s\u03B10\u02B9\u03B1\u02B9, c\u03B10\u02B9\u03B1\u02B9] = (0, $9QpM5.default).sincos(\u03B10\u02B9 - \u03B1\u02B9);
    // (42.4) p. 290
    let P = Math.atan2(c\u03B40\u02B9 * s\u03B10\u02B9\u03B1\u02B9, s\u03B40\u02B9 * c\u03B4\u02B9 - c\u03B40\u02B9 * s\u03B4\u02B9 * c\u03B10\u02B9\u03B1\u02B9);
    if (P < 0) P += 2 * Math.PI;
    return [
        DS,
        DE,
        \u03C91,
        \u03C92,
        P
    ];
}
function $1e4a07ab10e353f5$export$dce79a35c25b4aa0(jde) {
    const d = jde - (0, $9QpM5.default).J2000;
    const p = Math.PI / 180;
    const V = 172.74 * p + 0.00111588 * p * d;
    const M = 357.529 * p + 0.9856003 * p * d;
    const sV = Math.sin(V);
    const N = 20.02 * p + 0.0830853 * p * d + 0.329 * p * sV;
    const J = 66.115 * p + 0.9025179 * p * d - 0.329 * p * sV;
    const [sM, cM] = (0, $9QpM5.default).sincos(M);
    const [sN, cN] = (0, $9QpM5.default).sincos(N);
    const [s2M, c2M] = (0, $9QpM5.default).sincos(2 * M);
    const [s2N, c2N] = (0, $9QpM5.default).sincos(2 * N);
    const A = 1.915 * p * sM + 0.02 * p * s2M;
    const B = 5.555 * p * sN + 0.168 * p * s2N;
    const K = J + A - B;
    const R = 1.00014 - 0.01671 * cM - 0.00014 * c2M;
    const r = 5.20872 - 0.25208 * cN - 0.00611 * c2N;
    const [sK, cK] = (0, $9QpM5.default).sincos(K);
    const \u0394 = Math.sqrt(r * r + R * R - 2 * r * R * cK);
    const \u03C8 = Math.asin(R / \u0394 * sK);
    const dd = d - \u0394 / 173;
    let \u03C91 = 210.98 * p + 877.8169088 * p * dd + \u03C8 - B;
    let \u03C92 = 187.23 * p + 870.1869088 * p * dd + \u03C8 - B;
    let C = Math.sin(\u03C8 / 2);
    C *= C;
    if (sK > 0) C = -C;
    \u03C91 = (0, $9QpM5.default).pmod(\u03C91 + C, 2 * Math.PI);
    \u03C92 = (0, $9QpM5.default).pmod(\u03C92 + C, 2 * Math.PI);
    const \u03BB = 34.35 * p + 0.083091 * p * d + 0.329 * p * sV + B;
    const DS = 3.12 * p * Math.sin(\u03BB + 42.8 * p);
    const DE = DS - 2.22 * p * Math.sin(\u03C8) * Math.cos(\u03BB + 22 * p) - 1.3 * p * (r - \u0394) / \u0394 * Math.sin(\u03BB - 100.5 * p);
    return [
        DS,
        DE,
        \u03C91,
        \u03C92
    ];
}
var $1e4a07ab10e353f5$export$2e2bcd8739ae039 = {
    physical: $1e4a07ab10e353f5$export$9a54d1b59736b1ea,
    physical2: $1e4a07ab10e353f5$export$dce79a35c25b4aa0
};


/**
 * @copyright 2013 Sonia Keys
 * @copyright 2016 commenthol
 * @license MIT
 * @module jupitermoons
 */ /**
 * Jupitermoons: Chapter 44, Positions of the Satellites of Jupiter.
 */ 
var $9QpM5 = parcelRequire("9QpM5");

var $kzKe3 = parcelRequire("kzKe3");


const $224017778e68dde6$export$841407ceb083bd74 = 0;
const $224017778e68dde6$export$26d3a9f095b7d63d = 1;
const $224017778e68dde6$export$3cf9f97a9a940c37 = 2;
const $224017778e68dde6$export$cb8607be86097c3c = 3;
const $224017778e68dde6$var$k = [
    17295,
    21819,
    27558,
    36548
];
/**
 * XY used for returning coordinates of moons.
 * @param {number} x - in units of Jupiter radii
 * @param {number} y - in units of Jupiter radii
 */ function $224017778e68dde6$var$XY(x, y) {
    this.x = x;
    this.y = y;
}
function $224017778e68dde6$export$878041e1e4cd4218(jde) {
    const d = jde - (0, $9QpM5.default).J2000;
    const p = Math.PI / 180;
    const V = 172.74 * p + 0.00111588 * p * d;
    const M = 357.529 * p + 0.9856003 * p * d;
    const sV = Math.sin(V);
    const N = 20.02 * p + 0.0830853 * p * d + 0.329 * p * sV;
    const J = 66.115 * p + 0.9025179 * p * d - 0.329 * p * sV;
    const [sM, cM] = (0, $9QpM5.default).sincos(M);
    const [sN, cN] = (0, $9QpM5.default).sincos(N);
    const [s2M, c2M] = (0, $9QpM5.default).sincos(2 * M);
    const [s2N, c2N] = (0, $9QpM5.default).sincos(2 * N);
    const A = 1.915 * p * sM + 0.02 * p * s2M;
    const B = 5.555 * p * sN + 0.168 * p * s2N;
    const K = J + A - B;
    const R = 1.00014 - 0.01671 * cM - 0.00014 * c2M;
    const r = 5.20872 - 0.25208 * cN - 0.00611 * c2N;
    const [sK, cK] = (0, $9QpM5.default).sincos(K);
    const \u0394 = Math.sqrt(r * r + R * R - 2 * r * R * cK);
    const \u03C8 = Math.asin(R / \u0394 * sK);
    const \u03BB = 34.35 * p + 0.083091 * p * d + 0.329 * p * sV + B;
    const DS = 3.12 * p * Math.sin(\u03BB + 42.8 * p);
    const DE = DS - 2.22 * p * Math.sin(\u03C8) * Math.cos(\u03BB + 22 * p) - 1.3 * p * (r - \u0394) / \u0394 * Math.sin(\u03BB - 100.5 * p);
    const dd = d - \u0394 / 173;
    const u1 = 163.8069 * p + 203.4058646 * p * dd + \u03C8 - B;
    const u2 = 358.414 * p + 101.2916335 * p * dd + \u03C8 - B;
    const u3 = 5.7176 * p + 50.234518 * p * dd + \u03C8 - B;
    const u4 = 224.8092 * p + 21.48798 * p * dd + \u03C8 - B;
    const G = 331.18 * p + 50.310482 * p * dd;
    const H = 87.45 * p + 21.569231 * p * dd;
    const [s212, c212] = (0, $9QpM5.default).sincos(2 * (u1 - u2));
    const [s223, c223] = (0, $9QpM5.default).sincos(2 * (u2 - u3));
    const [sG, cG] = (0, $9QpM5.default).sincos(G);
    const [sH, cH] = (0, $9QpM5.default).sincos(H);
    const c1 = 0.473 * p * s212;
    const c2 = 1.065 * p * s223;
    const c3 = 0.165 * p * sG;
    const c4 = 0.843 * p * sH;
    const r1 = 5.9057 - 0.0244 * c212;
    const r2 = 9.3966 - 0.0882 * c223;
    const r3 = 14.9883 - 0.0216 * cG;
    const r4 = 26.3627 - 0.1939 * cH;
    const sDE = Math.sin(DE);
    const xy = function(u, r) {
        const [su, cu] = (0, $9QpM5.default).sincos(u);
        return new $224017778e68dde6$var$XY(r * su, -r * cu * sDE);
    };
    return [
        xy(u1 + c1, r1),
        xy(u2 + c2, r2),
        xy(u3 + c3, r3),
        xy(u4 + c4, r4)
    ];
}
function $224017778e68dde6$export$3e0e4217c1341b05(jde, earth, jupiter, pos) {
    pos = pos || new Array(4);
    // variables assigned in following block
    let \u03BB0, \u03B20, t;
    let \u0394 = 5.0;
    (function() {
        const { lon: lon, lat: lat, range: range } = (0, $c85b876782fe98e7$export$2e2bcd8739ae039).trueVSOP87(earth, jde);
        const [s, \u03B2, R] = [
            lon,
            lat,
            range
        ];
        const [ss, cs] = (0, $9QpM5.default).sincos(s);
        const s\u03B2 = Math.sin(\u03B2);
        let \u03C4 = (0, $9QpM5.default).lightTime(\u0394);
        let x = 0;
        let y = 0;
        let z = 0;
        function f() {
            const { lon: lon, lat: lat, range: range } = jupiter.position(jde - \u03C4);
            const [sl, cl] = (0, $9QpM5.default).sincos(lon);
            const [sb, cb] = (0, $9QpM5.default).sincos(lat);
            x = range * cb * cl + R * cs;
            y = range * cb * sl + R * ss;
            z = range * sb + R * s\u03B2;
            \u0394 = Math.sqrt(x * x + y * y + z * z);
            \u03C4 = (0, $9QpM5.default).lightTime(\u0394);
        }
        f();
        f();
        \u03BB0 = Math.atan2(y, x);
        \u03B20 = Math.atan(z / Math.hypot(x, y));
        t = jde - 2443000.5 - \u03C4;
    })();
    const p = Math.PI / 180;
    const l1 = 106.07719 * p + 203.48895579 * p * t;
    const l2 = 175.73161 * p + 101.374724735 * p * t;
    const l3 = 120.55883 * p + 50.317609207 * p * t;
    const l4 = 84.44459 * p + 21.571071177 * p * t;
    const \u03C01 = 97.0881 * p + 0.16138586 * p * t;
    const \u03C02 = 154.8663 * p + 0.04726307 * p * t;
    const \u03C03 = 188.184 * p + 0.00712734 * p * t;
    const \u03C04 = 335.2868 * p + 0.00184 * p * t;
    const \u03C91 = 312.3346 * p - 0.13279386 * p * t;
    const \u03C92 = 100.4411 * p - 0.03263064 * p * t;
    const \u03C93 = 119.1942 * p - 0.00717703 * p * t;
    const \u03C94 = 322.6186 * p - 0.00175934 * p * t;
    const \u0393 = 0.33033 * p * Math.sin(163.679 * p + 0.0010512 * p * t) + 0.03439 * p * Math.sin(34.486 * p - 0.0161731 * p * t);
    const \u03A6\u03BB = 199.6766 * p + 0.1737919 * p * t;
    let \u03C8 = 316.5182 * p - 0.00000208 * p * t;
    const G = 30.23756 * p + 0.0830925701 * p * t + \u0393;
    const G\u02B9 = 31.97853 * p + 0.0334597339 * p * t;
    const \u03A0 = 13.469942 * p;
    const \u03A31 = 0.47259 * p * Math.sin(2 * (l1 - l2)) + -0.03478 * p * Math.sin(\u03C03 - \u03C04) + 0.01081 * p * Math.sin(l2 - 2 * l3 + \u03C03) + 0.00738 * p * Math.sin(\u03A6\u03BB) + 0.00713 * p * Math.sin(l2 - 2 * l3 + \u03C02) + -0.00674 * p * Math.sin(\u03C01 + \u03C03 - 2 * \u03A0 - 2 * G) + 0.00666 * p * Math.sin(l2 - 2 * l3 + \u03C04) + 0.00445 * p * Math.sin(l1 - \u03C03) + -0.00354 * p * Math.sin(l1 - l2) + -0.00317 * p * Math.sin(2 * \u03C8 - 2 * \u03A0) + 0.00265 * p * Math.sin(l1 - \u03C04) + -0.00186 * p * Math.sin(G) + 0.00162 * p * Math.sin(\u03C02 - \u03C03) + 0.00158 * p * Math.sin(4 * (l1 - l2)) + -0.00155 * p * Math.sin(l1 - l3) + -0.00138 * p * Math.sin(\u03C8 + \u03C93 - 2 * \u03A0 - 2 * G) + -0.00115 * p * Math.sin(2 * (l1 - 2 * l2 + \u03C92)) + 0.00089 * p * Math.sin(\u03C02 - \u03C04) + 0.00085 * p * Math.sin(l1 + \u03C03 - 2 * \u03A0 - 2 * G) + 0.00083 * p * Math.sin(\u03C92 - \u03C93) + 0.00053 * p * Math.sin(\u03C8 - \u03C92);
    const \u03A32 = 1.06476 * p * Math.sin(2 * (l2 - l3)) + 0.04256 * p * Math.sin(l1 - 2 * l2 + \u03C03) + 0.03581 * p * Math.sin(l2 - \u03C03) + 0.02395 * p * Math.sin(l1 - 2 * l2 + \u03C04) + 0.01984 * p * Math.sin(l2 - \u03C04) + -0.01778 * p * Math.sin(\u03A6\u03BB) + 0.01654 * p * Math.sin(l2 - \u03C02) + 0.01334 * p * Math.sin(l2 - 2 * l3 + \u03C02) + 0.01294 * p * Math.sin(\u03C03 - \u03C04) + -0.01142 * p * Math.sin(l2 - l3) + -0.01057 * p * Math.sin(G) + -0.00775 * p * Math.sin(2 * (\u03C8 - \u03A0)) + 0.00524 * p * Math.sin(2 * (l1 - l2)) + -0.0046 * p * Math.sin(l1 - l3) + 0.00316 * p * Math.sin(\u03C8 - 2 * G + \u03C93 - 2 * \u03A0) + -0.00203 * p * Math.sin(\u03C01 + \u03C03 - 2 * \u03A0 - 2 * G) + 0.00146 * p * Math.sin(\u03C8 - \u03C93) + -0.00145 * p * Math.sin(2 * G) + 0.00125 * p * Math.sin(\u03C8 - \u03C94) + -0.00115 * p * Math.sin(l1 - 2 * l3 + \u03C03) + -0.00094 * p * Math.sin(2 * (l2 - \u03C92)) + 0.00086 * p * Math.sin(2 * (l1 - 2 * l2 + \u03C92)) + -0.00086 * p * Math.sin(5 * G\u02B9 - 2 * G + 52.225 * p) + -0.00078 * p * Math.sin(l2 - l4) + -0.00064 * p * Math.sin(3 * l3 - 7 * l4 + 4 * \u03C04) + 0.00064 * p * Math.sin(\u03C01 - \u03C04) + -0.00063 * p * Math.sin(l1 - 2 * l3 + \u03C04) + 0.00058 * p * Math.sin(\u03C93 - \u03C94) + 0.00056 * p * Math.sin(2 * (\u03C8 - \u03A0 - G)) + 0.00056 * p * Math.sin(2 * (l2 - l4)) + 0.00055 * p * Math.sin(2 * (l1 - l3)) + 0.00052 * p * Math.sin(3 * l3 - 7 * l4 + \u03C03 + 3 * \u03C04) + -0.00043 * p * Math.sin(l1 - \u03C03) + 0.00041 * p * Math.sin(5 * (l2 - l3)) + 0.00041 * p * Math.sin(\u03C04 - \u03A0) + 0.00032 * p * Math.sin(\u03C92 - \u03C93) + 0.00032 * p * Math.sin(2 * (l3 - G - \u03A0));
    const \u03A33 = 0.1649 * p * Math.sin(l3 - \u03C03) + 0.09081 * p * Math.sin(l3 - \u03C04) + -0.06907 * p * Math.sin(l2 - l3) + 0.03784 * p * Math.sin(\u03C03 - \u03C04) + 0.01846 * p * Math.sin(2 * (l3 - l4)) + -0.0134 * p * Math.sin(G) + -0.01014 * p * Math.sin(2 * (\u03C8 - \u03A0)) + 0.00704 * p * Math.sin(l2 - 2 * l3 + \u03C03) + -0.0062 * p * Math.sin(l2 - 2 * l3 + \u03C02) + -0.00541 * p * Math.sin(l3 - l4) + 0.00381 * p * Math.sin(l2 - 2 * l3 + \u03C04) + 0.00235 * p * Math.sin(\u03C8 - \u03C93) + 0.00198 * p * Math.sin(\u03C8 - \u03C94) + 0.00176 * p * Math.sin(\u03A6\u03BB) + 0.0013 * p * Math.sin(3 * (l3 - l4)) + 0.00125 * p * Math.sin(l1 - l3) + -0.00119 * p * Math.sin(5 * G\u02B9 - 2 * G + 52.225 * p) + 0.00109 * p * Math.sin(l1 - l2) + -0.001 * p * Math.sin(3 * l3 - 7 * l4 + 4 * \u03C04) + 0.00091 * p * Math.sin(\u03C93 - \u03C94) + 0.0008 * p * Math.sin(3 * l3 - 7 * l4 + \u03C03 + 3 * \u03C04) + -0.00075 * p * Math.sin(2 * l2 - 3 * l3 + \u03C03) + 0.00072 * p * Math.sin(\u03C01 + \u03C03 - 2 * \u03A0 - 2 * G) + 0.00069 * p * Math.sin(\u03C04 - \u03A0) + -0.00058 * p * Math.sin(2 * l3 - 3 * l4 + \u03C04) + -0.00057 * p * Math.sin(l3 - 2 * l4 + \u03C04) + 0.00056 * p * Math.sin(l3 + \u03C03 - 2 * \u03A0 - 2 * G) + -0.00052 * p * Math.sin(l2 - 2 * l3 + \u03C01) + -0.0005 * p * Math.sin(\u03C02 - \u03C03) + 0.00048 * p * Math.sin(l3 - 2 * l4 + \u03C03) + -0.00045 * p * Math.sin(2 * l2 - 3 * l3 + \u03C04) + -0.00041 * p * Math.sin(\u03C02 - \u03C04) + -0.00038 * p * Math.sin(2 * G) + -0.00037 * p * Math.sin(\u03C03 - \u03C04 + \u03C93 - \u03C94) + -0.00032 * p * Math.sin(3 * l3 - 7 * l4 + 2 * \u03C03 + 2 * \u03C04) + 0.0003 * p * Math.sin(4 * (l3 - l4)) + 0.00029 * p * Math.sin(l3 + \u03C04 - 2 * \u03A0 - 2 * G) + -0.00028 * p * Math.sin(\u03C93 + \u03C8 - 2 * \u03A0 - 2 * G) + 0.00026 * p * Math.sin(l3 - \u03A0 - G) + 0.00024 * p * Math.sin(l2 - 3 * l3 + 2 * l4) + 0.00021 * p * Math.sin(2 * (l3 - \u03A0 - G)) + -0.00021 * p * Math.sin(l3 - \u03C02) + 0.00017 * p * Math.sin(2 * (l3 - \u03C03));
    const \u03A34 = 0.84287 * p * Math.sin(l4 - \u03C04) + 0.03431 * p * Math.sin(\u03C04 - \u03C03) + -0.03305 * p * Math.sin(2 * (\u03C8 - \u03A0)) + -0.03211 * p * Math.sin(G) + -0.01862 * p * Math.sin(l4 - \u03C03) + 0.01186 * p * Math.sin(\u03C8 - \u03C94) + 0.00623 * p * Math.sin(l4 + \u03C04 - 2 * G - 2 * \u03A0) + 0.00387 * p * Math.sin(2 * (l4 - \u03C04)) + -0.00284 * p * Math.sin(5 * G\u02B9 - 2 * G + 52.225 * p) + -0.00234 * p * Math.sin(2 * (\u03C8 - \u03C04)) + -0.00223 * p * Math.sin(l3 - l4) + -0.00208 * p * Math.sin(l4 - \u03A0) + 0.00178 * p * Math.sin(\u03C8 + \u03C94 - 2 * \u03C04) + 0.00134 * p * Math.sin(\u03C04 - \u03A0) + 0.00125 * p * Math.sin(2 * (l4 - G - \u03A0)) + -0.00117 * p * Math.sin(2 * G) + -0.00112 * p * Math.sin(2 * (l3 - l4)) + 0.00107 * p * Math.sin(3 * l3 - 7 * l4 + 4 * \u03C04) + 0.00102 * p * Math.sin(l4 - G - \u03A0) + 0.00096 * p * Math.sin(2 * l4 - \u03C8 - \u03C94) + 0.00087 * p * Math.sin(2 * (\u03C8 - \u03C94)) + -0.00085 * p * Math.sin(3 * l3 - 7 * l4 + \u03C03 + 3 * \u03C04) + 0.00085 * p * Math.sin(l3 - 2 * l4 + \u03C04) + -0.00081 * p * Math.sin(2 * (l4 - \u03C8)) + 0.00071 * p * Math.sin(l4 + \u03C04 - 2 * \u03A0 - 3 * G) + 0.00061 * p * Math.sin(l1 - l4) + -0.00056 * p * Math.sin(\u03C8 - \u03C93) + -0.00054 * p * Math.sin(l3 - 2 * l4 + \u03C03) + 0.00051 * p * Math.sin(l2 - l4) + 0.00042 * p * Math.sin(2 * (\u03C8 - G - \u03A0)) + 0.00039 * p * Math.sin(2 * (\u03C04 - \u03C94)) + 0.00036 * p * Math.sin(\u03C8 + \u03A0 - \u03C04 - \u03C94) + 0.00035 * p * Math.sin(2 * G\u02B9 - G + 188.37 * p) + -0.00035 * p * Math.sin(l4 - \u03C04 + 2 * \u03A0 - 2 * \u03C8) + -0.00032 * p * Math.sin(l4 + \u03C04 - 2 * \u03A0 - G) + 0.0003 * p * Math.sin(2 * G\u02B9 - 2 * G + 149.15 * p) + 0.00029 * p * Math.sin(3 * l3 - 7 * l4 + 2 * \u03C03 + 2 * \u03C04) + 0.00028 * p * Math.sin(l4 - \u03C04 + 2 * \u03C8 - 2 * \u03A0) + -0.00028 * p * Math.sin(2 * (l4 - \u03C94)) + -0.00027 * p * Math.sin(\u03C03 - \u03C04 + \u03C93 - \u03C94) + -0.00026 * p * Math.sin(5 * G\u02B9 - 3 * G + 188.37 * p) + 0.00025 * p * Math.sin(\u03C94 - \u03C93) + -0.00025 * p * Math.sin(l2 - 3 * l3 + 2 * l4) + -0.00023 * p * Math.sin(3 * (l3 - l4)) + 0.00021 * p * Math.sin(2 * l4 - 2 * \u03A0 - 3 * G) + -0.00021 * p * Math.sin(2 * l3 - 3 * l4 + \u03C04) + 0.00019 * p * Math.sin(l4 - \u03C04 - G) + -0.00019 * p * Math.sin(2 * l4 - \u03C03 - \u03C04) + -0.00018 * p * Math.sin(l4 - \u03C04 + G) + -0.00016 * p * Math.sin(l4 + \u03C03 - 2 * \u03A0 - 2 * G);
    const L1 = l1 + \u03A31;
    const L2 = l2 + \u03A32;
    const L3 = l3 + \u03A33;
    const L4 = l4 + \u03A34;
    // variables assigned in following block
    let I;
    const X = new Array(5).fill(0);
    const Y = new Array(5).fill(0);
    const Z = new Array(5).fill(0);
    let R;
    (function() {
        const L = [
            L1,
            L2,
            L3,
            L4
        ];
        const B = [
            Math.atan(0.0006393 * Math.sin(L1 - \u03C91) + 0.0001825 * Math.sin(L1 - \u03C92) + 0.0000329 * Math.sin(L1 - \u03C93) + -0.0000311 * Math.sin(L1 - \u03C8) + 0.0000093 * Math.sin(L1 - \u03C94) + 0.0000075 * Math.sin(3 * L1 - 4 * l2 - 1.9927 * \u03A31 + \u03C92) + 0.0000046 * Math.sin(L1 + \u03C8 - 2 * \u03A0 - 2 * G)),
            Math.atan(0.0081004 * Math.sin(L2 - \u03C92) + 0.0004512 * Math.sin(L2 - \u03C93) + -0.0003284 * Math.sin(L2 - \u03C8) + 0.0001160 * Math.sin(L2 - \u03C94) + 0.0000272 * Math.sin(l1 - 2 * l3 + 1.0146 * \u03A32 + \u03C92) + -0.0000144 * Math.sin(L2 - \u03C91) + 0.0000143 * Math.sin(L2 + \u03C8 - 2 * \u03A0 - 2 * G) + 0.0000035 * Math.sin(L2 - \u03C8 + G) + -0.0000028 * Math.sin(l1 - 2 * l3 + 1.0146 * \u03A32 + \u03C93)),
            Math.atan(0.0032402 * Math.sin(L3 - \u03C93) + -0.0016911 * Math.sin(L3 - \u03C8) + 0.0006847 * Math.sin(L3 - \u03C94) + -0.0002797 * Math.sin(L3 - \u03C92) + 0.0000321 * Math.sin(L3 + \u03C8 - 2 * \u03A0 - 2 * G) + 0.0000051 * Math.sin(L3 - \u03C8 + G) + -0.0000045 * Math.sin(L3 - \u03C8 - G) + -0.0000045 * Math.sin(L3 + \u03C8 - 2 * \u03A0) + 0.0000037 * Math.sin(L3 + \u03C8 - 2 * \u03A0 - 3 * G) + 0.000003 * Math.sin(2 * l2 - 3 * L3 + 4.03 * \u03A33 + \u03C92) + -0.0000021 * Math.sin(2 * l2 - 3 * L3 + 4.03 * \u03A33 + \u03C93)),
            Math.atan(-0.0076579 * Math.sin(L4 - \u03C8) + 0.0044134 * Math.sin(L4 - \u03C94) + -0.0005112 * Math.sin(L4 - \u03C93) + 0.0000773 * Math.sin(L4 + \u03C8 - 2 * \u03A0 - 2 * G) + 0.0000104 * Math.sin(L4 - \u03C8 + G) + -0.0000102 * Math.sin(L4 - \u03C8 - G) + 0.0000088 * Math.sin(L4 + \u03C8 - 2 * \u03A0 - 3 * G) + -0.0000038 * Math.sin(L4 + \u03C8 - 2 * \u03A0 - G))
        ];
        R = [
            5.90569 * (1 + -0.0041339 * Math.cos(2 * (l1 - l2)) + -0.0000387 * Math.cos(l1 - \u03C03) + -0.0000214 * Math.cos(l1 - \u03C04) + 0.000017 * Math.cos(l1 - l2) + -0.0000131 * Math.cos(4 * (l1 - l2)) + 0.0000106 * Math.cos(l1 - l3) + -0.0000066 * Math.cos(l1 + \u03C03 - 2 * \u03A0 - 2 * G)),
            9.39657 * (1 + 0.0093848 * Math.cos(l1 - l2) + -0.0003116 * Math.cos(l2 - \u03C03) + -0.0001744 * Math.cos(l2 - \u03C04) + -0.0001442 * Math.cos(l2 - \u03C02) + 0.0000553 * Math.cos(l2 - l3) + 0.0000523 * Math.cos(l1 - l3) + -0.000029 * Math.cos(2 * (l1 - l2)) + 0.0000164 * Math.cos(2 * (l2 - \u03C92)) + 0.0000107 * Math.cos(l1 - 2 * l3 + \u03C03) + -0.0000102 * Math.cos(l2 - \u03C01) + -0.0000091 * Math.cos(2 * (l1 - l3))),
            14.98832 * (1 + -0.0014388 * Math.cos(l3 - \u03C03) + -0.0007917 * Math.cos(l3 - \u03C04) + 0.0006342 * Math.cos(l2 - l3) + -0.0001761 * Math.cos(2 * (l3 - l4)) + 0.0000294 * Math.cos(l3 - l4) + -0.0000156 * Math.cos(3 * (l3 - l4)) + 0.0000156 * Math.cos(l1 - l3) + -0.0000153 * Math.cos(l1 - l2) + 0.000007 * Math.cos(2 * l2 - 3 * l3 + \u03C03) + -0.0000051 * Math.cos(l3 + \u03C03 - 2 * \u03A0 - 2 * G)),
            26.36273 * (1 + -0.0073546 * Math.cos(l4 - \u03C04) + 0.0001621 * Math.cos(l4 - \u03C03) + 0.0000974 * Math.cos(l3 - l4) + -0.0000543 * Math.cos(l4 + \u03C04 - 2 * \u03A0 - 2 * G) + -0.0000271 * Math.cos(2 * (l4 - \u03C04)) + 0.0000182 * Math.cos(l4 - \u03A0) + 0.0000177 * Math.cos(2 * (l3 - l4)) + -0.0000167 * Math.cos(2 * l4 - \u03C8 - \u03C94) + 0.0000167 * Math.cos(\u03C8 - \u03C94) + -0.0000155 * Math.cos(2 * (l4 - \u03A0 - G)) + 0.0000142 * Math.cos(2 * (l4 - \u03C8)) + 0.0000105 * Math.cos(l1 - l4) + 0.0000092 * Math.cos(l2 - l4) + -0.0000089 * Math.cos(l4 - \u03A0 - G) + -0.0000062 * Math.cos(l4 + \u03C04 - 2 * \u03A0 - 3 * G) + 0.0000048 * Math.cos(2 * (l4 - \u03C94)))
        ];
        // p. 311
        const T0 = (jde - 2433282.423) / (0, $9QpM5.default).JulianCentury;
        const P = (1.3966626 * p + 0.0003088 * p * T0) * T0;
        for(const i in L)L[i] += P;
        \u03C8 += P;
        const T = (jde - (0, $9QpM5.default).J1900) / (0, $9QpM5.default).JulianCentury;
        I = 3.120262 * p + 0.0006 * p * T;
        for(const i in L){
            const [sL\u03C8, cL\u03C8] = (0, $9QpM5.default).sincos(L[i] - \u03C8);
            const [sB, cB] = (0, $9QpM5.default).sincos(B[i]);
            X[i] = R[i] * cL\u03C8 * cB;
            Y[i] = R[i] * sL\u03C8 * cB;
            Z[i] = R[i] * sB;
        }
    })();
    Z[4] = 1;
    // p. 312
    const A = new Array(5).fill(0);
    const B = new Array(5).fill(0);
    const C = new Array(5).fill(0);
    const [sI, cI] = (0, $9QpM5.default).sincos(I);
    const \u03A9 = (0, $kzKe3.default).node((0, $kzKe3.default).jupiter, jde);
    const [s\u03A9, c\u03A9] = (0, $9QpM5.default).sincos(\u03A9);
    const [s\u03A6, c\u03A6] = (0, $9QpM5.default).sincos(\u03C8 - \u03A9);
    const [si, ci] = (0, $9QpM5.default).sincos((0, $kzKe3.default).inc((0, $kzKe3.default).jupiter, jde));
    const [s\u03BB0, c\u03BB0] = (0, $9QpM5.default).sincos(\u03BB0);
    const [s\u03B20, c\u03B20] = (0, $9QpM5.default).sincos(\u03B20);
    for(const i in A){
        let a0;
        // step 1
        let a = X[i];
        let b = Y[i] * cI - Z[i] * sI;
        let c = Y[i] * sI + Z[i] * cI;
        // step 2
        a0 = a * c\u03A6 - b * s\u03A6;
        b = a * s\u03A6 + b * c\u03A6;
        a = a0;
        // step 3
        const b0 = b * ci - c * si;
        c = b * si + c * ci;
        b = b0;
        // step 4
        a0 = a * c\u03A9 - b * s\u03A9;
        b = a * s\u03A9 + b * c\u03A9;
        a = a0;
        // step 5
        a0 = a * s\u03BB0 - b * c\u03BB0;
        b = a * c\u03BB0 + b * s\u03BB0;
        a = a0;
        // step 6
        A[i] = a;
        B[i] = c * s\u03B20 + b * c\u03B20;
        C[i] = c * c\u03B20 - b * s\u03B20;
    }
    const [sD, cD] = (0, $9QpM5.default).sincos(Math.atan2(A[4], C[4]));
    // p. 313
    for(let i = 0; i < 4; i++){
        let x = A[i] * cD - C[i] * sD;
        const y = A[i] * sD + C[i] * cD;
        const z = B[i];
        // differential light time
        const d = x / R[i];
        x += Math.abs(z) / $224017778e68dde6$var$k[i] * Math.sqrt(1 - d * d);
        // perspective effect
        const W = \u0394 / (\u0394 + z / 2095);
        pos[i] = new $224017778e68dde6$var$XY(x * W, y * W);
    }
    return pos;
}
var $224017778e68dde6$export$2e2bcd8739ae039 = {
    io: $224017778e68dde6$export$841407ceb083bd74,
    europa: $224017778e68dde6$export$26d3a9f095b7d63d,
    ganymede: $224017778e68dde6$export$3cf9f97a9a940c37,
    callisto: $224017778e68dde6$export$cb8607be86097c3c,
    positions: $224017778e68dde6$export$878041e1e4cd4218,
    e5: $224017778e68dde6$export$3e0e4217c1341b05
};



/**
 * @copyright 2013 Sonia Keys
 * @copyright 2016 commenthol
 * @license MIT
 * @module line
 */ /**
 * Line: Chapter 19, Bodies in Straight Line
 */ 
var $9QpM5 = parcelRequire("9QpM5");

function $8df64fadfe12b1b8$export$2da9be4cfdb689b1(r1, d1, r2, d2, r3, d3, t1, t5) {
    if (r3.length !== 5 || d3.length !== 5) throw new Error('r3, d3 must be length 5');
    const gc = new Array(5);
    r3.forEach((r3i, i)=>{
        // (19.1) p. 121
        gc[i] = Math.tan(d1) * Math.sin(r2 - r3i) + Math.tan(d2) * Math.sin(r3i - r1) + Math.tan(d3[i]) * Math.sin(r1 - r2);
    });
    const l5 = new (0, $7480a29e66a7d324$export$2e2bcd8739ae039).Len5(t1, t5, gc);
    return l5.zero(false);
}
function $8df64fadfe12b1b8$export$944b09d2ad10b378(r1, d1, r2, d2, r3, d3) {
    const [sd2, cd2] = (0, $9QpM5.default).sincos(d2);
    const [sr21, cr21] = (0, $9QpM5.default).sincos(r2 - r1);
    const [sr32, cr32] = (0, $9QpM5.default).sincos(r3 - r2);
    const C1 = Math.atan2(sr21, cd2 * Math.tan(d1) - sd2 * cr21);
    const C2 = Math.atan2(sr32, cd2 * Math.tan(d3) - sd2 * cr32);
    return C1 + C2;
}
function $8df64fadfe12b1b8$export$a3bc9b8ed74fc(r1, d1, r2, d2, r0, d0) {
    const [sr1, cr1] = (0, $9QpM5.default).sincos(r1);
    const [sd1, cd1] = (0, $9QpM5.default).sincos(d1);
    const [sr2, cr2] = (0, $9QpM5.default).sincos(r2);
    const [sd2, cd2] = (0, $9QpM5.default).sincos(d2);
    const X1 = cd1 * cr1;
    const X2 = cd2 * cr2;
    const Y1 = cd1 * sr1;
    const Y2 = cd2 * sr2;
    const Z1 = sd1;
    const Z2 = sd2;
    const A = Y1 * Z2 - Z1 * Y2;
    const B = Z1 * X2 - X1 * Z2;
    const C = X1 * Y2 - Y1 * X2;
    const m = Math.tan(r0);
    const n = Math.tan(d0) / Math.cos(r0);
    return Math.asin((A + B * m + C * n) / (Math.sqrt(A * A + B * B + C * C) * Math.sqrt(1 + m * m + n * n)));
}
function $8df64fadfe12b1b8$export$94a42327d415e0d2(r1, d1, r2, d2, r3, d3) {
    const [sr1, cr1] = (0, $9QpM5.default).sincos(r1);
    const [c1, cd1] = (0, $9QpM5.default).sincos(d1);
    const [sr2, cr2] = (0, $9QpM5.default).sincos(r2);
    const [c2, cd2] = (0, $9QpM5.default).sincos(d2);
    const [sr3, cr3] = (0, $9QpM5.default).sincos(r3);
    const [c3, cd3] = (0, $9QpM5.default).sincos(d3);
    const a1 = cd1 * cr1;
    const a2 = cd2 * cr2;
    const a3 = cd3 * cr3;
    const b1 = cd1 * sr1;
    const b2 = cd2 * sr2;
    const b3 = cd3 * sr3;
    const l1 = b1 * c2 - b2 * c1;
    const l2 = b2 * c3 - b3 * c2;
    const l3 = b1 * c3 - b3 * c1;
    const m1 = c1 * a2 - c2 * a1;
    const m2 = c2 * a3 - c3 * a2;
    const m3 = c1 * a3 - c3 * a1;
    const n1 = a1 * b2 - a2 * b1;
    const n2 = a2 * b3 - a3 * b2;
    const n3 = a1 * b3 - a3 * b1;
    const \u03C8 = Math.acos((l1 * l2 + m1 * m2 + n1 * n2) / (Math.sqrt(l1 * l1 + m1 * m1 + n1 * n1) * Math.sqrt(l2 * l2 + m2 * m2 + n2 * n2)));
    const \u03C9 = Math.asin((a2 * l3 + b2 * m3 + c2 * n3) / (Math.sqrt(a2 * a2 + b2 * b2 + c2 * c2) * Math.sqrt(l3 * l3 + m3 * m3 + n3 * n3)));
    return [
        \u03C8,
        \u03C9
    ];
}
var $8df64fadfe12b1b8$export$2e2bcd8739ae039 = {
    time: $8df64fadfe12b1b8$export$2da9be4cfdb689b1,
    angle: $8df64fadfe12b1b8$export$944b09d2ad10b378,
    error: $8df64fadfe12b1b8$export$a3bc9b8ed74fc,
    angleError: $8df64fadfe12b1b8$export$94a42327d415e0d2
};


/**
 * @copyright 2013 Sonia Keys
 * @copyright 2016 commenthol
 * @license MIT
 * @module nearparabolic
 */ /**
 * Nearparabolic: Chapter 35, Near-parabolic Motion.
 */ 
var $9QpM5 = parcelRequire("9QpM5");
class $3c7ff0a9728b8e4a$export$3abb4be70fa2c84e {
    /**
   * @param {Number} timeP - time of Perihelion, T
   * @param {Number} pDis - Perihelion distance, q
   * @param {Number} ecc - eccentricity, e
   */ constructor(timeP, pDis, ecc){
        this.timeP = timeP;
        this.pDis = pDis;
        this.ecc = ecc;
    }
    /**
   * AnomalyDistance returns true anomaly and distance for near-parabolic orbits.
   *
   * True anomaly ν returned in radians. Distance r returned in AU.
   * An error is returned if the algorithm fails to converge.
   */ anomalyDistance(jde) {
        // fairly literal translation of code on p. 246
        const q1 = (0, $9QpM5.default).K * Math.sqrt((1 + this.ecc) / this.pDis) / (2 * this.pDis // line 20
        );
        const g = (1 - this.ecc) / (1 + this.ecc // line 20
        );
        const t = jde - this.timeP // line 22
        ;
        if (t === 0) return {
            ano: 0,
            dist: this.pDis,
            err: null
        };
        const d1 = 1e4;
        const d = 1e-9 // line 14
        ;
        const q2 = q1 * t // line 28
        ;
        let s = 2.0 / (3 * Math.abs(q2) // line 30
        );
        s = 2 / Math.tan(2 * Math.atan(Math.cbrt(Math.tan(Math.atan(s) / 2))));
        if (t < 0) s = -s;
        if (this.ecc !== 1) {
            let l = 0 // line 38
            ;
            for(;;){
                const s0 = s // line 40
                ;
                let z = 1.0;
                const y = s * s;
                let g1 = -y * s;
                let q3 = q2 + 2 * g * s * y / 3 // line 42
                ;
                for(;;){
                    z += 1 // line 44
                    ;
                    g1 = -g1 * g * y // line 46
                    ;
                    const z1 = (z - (z + 1) * g) / (2 * z + 1 // line 48
                    );
                    const f = z1 * g1 // line 50
                    ;
                    q3 += f // line 52
                    ;
                    if (z > 50 || Math.abs(f) > d1) return {
                        err: new Error('No convergence')
                    };
                    if (Math.abs(f) <= d) break;
                }
                l++ // line 58
                ;
                if (l > 50) return {
                    err: new Error('No convergence')
                };
                for(;;){
                    const s1 = s // line 60
                    ;
                    s = (2 * s * s * s / 3 + q3) / (s * s + 1);
                    if (Math.abs(s - s1) <= d) break;
                }
                if (Math.abs(s - s0) <= d) break;
            }
        }
        let \u03BD = 2 * Math.atan(s) // line 66
        ;
        const r = this.pDis * (1 + this.ecc) / (1 + this.ecc * Math.cos(\u03BD) // line 68
        );
        if (\u03BD < 0) \u03BD += 2 * Math.PI;
        return {
            ano: \u03BD,
            dist: r,
            err: null
        };
    }
}
var $3c7ff0a9728b8e4a$export$2e2bcd8739ae039 = {
    Elements: $3c7ff0a9728b8e4a$export$3abb4be70fa2c84e
};


/**
 * @copyright 2013 Sonia Keys
 * @copyright 2016 commenthol
 * @license MIT
 * @module node
 */ /**
 * Node: Chapter 39, Passages through the Nodes.
 */ 
var $9QpM5 = parcelRequire("9QpM5");
function $f1c28828d3798db7$export$8bcc2ea4616dbc41(axis, ecc, argP, timeP) {
    return $f1c28828d3798db7$export$c3da0dad1b44eea9(-argP, axis, ecc, timeP);
}
function $f1c28828d3798db7$export$749303b109aa08ca(axis, ecc, argP, timeP) {
    return $f1c28828d3798db7$export$c3da0dad1b44eea9(Math.PI - argP, axis, ecc, timeP);
}
function $f1c28828d3798db7$export$c3da0dad1b44eea9(\u03BD, axis, ecc, timeP) {
    const E = 2 * Math.atan(Math.sqrt((1 - ecc) / (1 + ecc)) * Math.tan(\u03BD * 0.5));
    const [sE, cE] = (0, $9QpM5.default).sincos(E);
    const M = E - ecc * sE;
    const n = (0, $9QpM5.default).K / axis / Math.sqrt(axis);
    const jde = timeP + M / n;
    const r = axis * (1 - ecc * cE);
    return [
        jde,
        r
    ];
}
function $f1c28828d3798db7$export$55ecb77a79e5eb54(q, argP, timeP) {
    return $f1c28828d3798db7$export$34ff22a248b92171(-argP, q, timeP);
}
function $f1c28828d3798db7$export$df7d0f9cf4ce412e(q, argP, timeP) {
    return $f1c28828d3798db7$export$34ff22a248b92171(Math.PI - argP, q, timeP);
}
function $f1c28828d3798db7$export$34ff22a248b92171(\u03BD, q, timeP) {
    const s = Math.tan(\u03BD * 0.5);
    const jde = timeP + 27.403895 * s * (s * s + 3) * q * Math.sqrt(q);
    const r = q * (1 + s * s);
    return [
        jde,
        r
    ];
}
var $f1c28828d3798db7$export$2e2bcd8739ae039 = {
    ellipticAscending: $f1c28828d3798db7$export$8bcc2ea4616dbc41,
    ellipticDescending: $f1c28828d3798db7$export$749303b109aa08ca,
    el: $f1c28828d3798db7$export$c3da0dad1b44eea9,
    parabolicAscending: $f1c28828d3798db7$export$55ecb77a79e5eb54,
    parabolicDescending: $f1c28828d3798db7$export$df7d0f9cf4ce412e,
    pa: $f1c28828d3798db7$export$34ff22a248b92171
};



/**
 * @copyright 2013 Sonia Keys
 * @copyright 2016 commenthol
 * @license MIT
 * @module mars
 */ /**
 * Mars: Chapter 42, Ephemeris for Physical Observations of Mars.
 */ 
var $9QpM5 = parcelRequire("9QpM5");




function $2d87e36c913093d6$export$9a54d1b59736b1ea(jde, earth, mars) {
    // Step 1.0
    const T = (0, $9QpM5.default).J2000Century(jde);
    const p = Math.PI / 180;
    // (42.1) p. 288
    let \u03BB0 = 352.9065 * p + 1.1733 * p * T;
    const \u03B20 = 63.2818 * p - 0.00394 * p * T;
    // Step 2.0
    const earthPos = earth.position(jde);
    const R = earthPos.range;
    const fk5 = (0, $2c5cad23f9dfa2db$export$2e2bcd8739ae039).toFK5(earthPos.lon, earthPos.lat, jde);
    const [l0, b0] = [
        fk5.lon,
        fk5.lat
    ];
    // Steps 3, 4.0
    const [sl0, cl0] = (0, $9QpM5.default).sincos(l0);
    const sb0 = Math.sin(b0);
    let \u0394 = 0.5 // surely better than 0.0
    ;
    let \u03C4 = (0, $9QpM5.default).lightTime(\u0394);
    let l = 0;
    let b = 0;
    let r = 0;
    let x = 0;
    let y = 0;
    let z = 0;
    function f() {
        const marsPos = mars.position(jde - \u03C4);
        r = marsPos.range;
        const fk5 = (0, $2c5cad23f9dfa2db$export$2e2bcd8739ae039).toFK5(marsPos.lon, marsPos.lat, jde);
        l = fk5.lon;
        b = fk5.lat;
        const [sb, cb] = (0, $9QpM5.default).sincos(b);
        const [sl, cl] = (0, $9QpM5.default).sincos(l);
        // (42.2) p. 289
        x = r * cb * cl - R * cl0;
        y = r * cb * sl - R * sl0;
        z = r * sb - R * sb0;
        // (42.3) p. 289
        \u0394 = Math.sqrt(x * x + y * y + z * z);
        \u03C4 = (0, $9QpM5.default).lightTime(\u0394);
    }
    f();
    f();
    // Step 5.0
    let \u03BB = Math.atan2(y, x);
    let \u03B2 = Math.atan(z / Math.hypot(x, y));
    // Step 6.0
    const [s\u03B20, c\u03B20] = (0, $9QpM5.default).sincos(\u03B20);
    const [s\u03B2, c\u03B2] = (0, $9QpM5.default).sincos(\u03B2);
    const DE = Math.asin(-s\u03B20 * s\u03B2 - c\u03B20 * c\u03B2 * Math.cos(\u03BB0 - \u03BB));
    // Step 7.0
    const N = 49.5581 * p + 0.7721 * p * T;
    const l\u02B9 = l - 0.00697 * p / r;
    const b\u02B9 = b - 0.000225 * p * Math.cos(l - N) / r;
    // Step 8.0
    const [sb\u02B9, cb\u02B9] = (0, $9QpM5.default).sincos(b\u02B9);
    const DS = Math.asin(-s\u03B20 * sb\u02B9 - c\u03B20 * cb\u02B9 * Math.cos(\u03BB0 - l\u02B9));
    // Step 9.0
    const W = 11.504 * p + 350.89200025 * p * (jde - \u03C4 - 2433282.5);
    // Step 10.0
    const \u03B50 = (0, $c50a9505be5a627c$export$2e2bcd8739ae039).meanObliquity(jde);
    const [s\u03B50, c\u03B50] = (0, $9QpM5.default).sincos(\u03B50);
    let eq = new (0, $77f14e36e565e56c$export$2e2bcd8739ae039).Ecliptic(\u03BB0, \u03B20).toEquatorial(\u03B50);
    const [\u03B10, \u03B40] = [
        eq.ra,
        eq.dec
    ];
    // Step 11.0
    const u = y * c\u03B50 - z * s\u03B50;
    const v = y * s\u03B50 + z * c\u03B50;
    const \u03B1 = Math.atan2(u, x);
    const \u03B4 = Math.atan(v / Math.hypot(x, u));
    const [s\u03B4, c\u03B4] = (0, $9QpM5.default).sincos(\u03B4);
    const [s\u03B40, c\u03B40] = (0, $9QpM5.default).sincos(\u03B40);
    const [s\u03B10\u03B1, c\u03B10\u03B1] = (0, $9QpM5.default).sincos(\u03B10 - \u03B1);
    const \u03B6 = Math.atan2(s\u03B40 * c\u03B4 * c\u03B10\u03B1 - s\u03B4 * c\u03B40, c\u03B4 * s\u03B10\u03B1);
    // Step 12.0
    const \u03C9 = (0, $9QpM5.default).pmod(W - \u03B6, 2 * Math.PI);
    // Step 13.0
    const [\u0394\u03C8, \u0394\u03B5] = (0, $c50a9505be5a627c$export$2e2bcd8739ae039).nutation(jde);
    // Step 14.0
    const [sl0\u03BB, cl0\u03BB] = (0, $9QpM5.default).sincos(l0 - \u03BB);
    \u03BB += 0.005693 * p * cl0\u03BB / c\u03B2;
    \u03B2 += 0.005693 * p * sl0\u03BB * s\u03B2;
    // Step 15.0
    \u03BB0 += \u0394\u03C8;
    \u03BB += \u0394\u03C8;
    const \u03B5 = \u03B50 + \u0394\u03B5;
    // Step 16.0
    const [s\u03B5, c\u03B5] = (0, $9QpM5.default).sincos(\u03B5);
    eq = new (0, $77f14e36e565e56c$export$2e2bcd8739ae039).Ecliptic(\u03BB0, \u03B20).toEquatorial(\u03B5);
    const [\u03B10\u02B9, \u03B40\u02B9] = [
        eq.ra,
        eq.dec
    ];
    eq = new (0, $77f14e36e565e56c$export$2e2bcd8739ae039).Ecliptic(\u03BB, \u03B2).toEquatorial(\u03B5);
    const [\u03B1\u02B9, \u03B4\u02B9] = [
        eq.ra,
        eq.dec
    ];
    // Step 17.0
    const [s\u03B40\u02B9, c\u03B40\u02B9] = (0, $9QpM5.default).sincos(\u03B40\u02B9);
    const [s\u03B4\u02B9, c\u03B4\u02B9] = (0, $9QpM5.default).sincos(\u03B4\u02B9);
    const [s\u03B10\u02B9\u03B1\u02B9, c\u03B10\u02B9\u03B1\u02B9] = (0, $9QpM5.default).sincos(\u03B10\u02B9 - \u03B1\u02B9);
    // (42.4) p. 290
    let P = Math.atan2(c\u03B40\u02B9 * s\u03B10\u02B9\u03B1\u02B9, s\u03B40\u02B9 * c\u03B4\u02B9 - c\u03B40\u02B9 * s\u03B4\u02B9 * c\u03B10\u02B9\u03B1\u02B9);
    if (P < 0) P += 2 * Math.PI;
    // Step 18.0
    const s = l0 + Math.PI;
    const [ss, cs] = (0, $9QpM5.default).sincos(s);
    const \u03B1s = Math.atan2(c\u03B5 * ss, cs);
    const \u03B4s = Math.asin(s\u03B5 * ss);
    const [s\u03B4s, c\u03B4s] = (0, $9QpM5.default).sincos(\u03B4s);
    const [s\u03B1s\u03B1, c\u03B1s\u03B1] = (0, $9QpM5.default).sincos(\u03B1s - \u03B1);
    const \u03C7 = Math.atan2(c\u03B4s * s\u03B1s\u03B1, s\u03B4s * c\u03B4 - c\u03B4s * s\u03B4 * c\u03B1s\u03B1);
    const Q = \u03C7 + Math.PI;
    // Step 19.0
    const d = 0.0026 * Math.PI / 180 / \u0394;
    const k = (0, $b8b3a7f8c0299d51$export$2e2bcd8739ae039).fraction(r, \u0394, R);
    const q = (1 - k) * d;
    return [
        DE,
        DS,
        \u03C9,
        P,
        Q,
        d,
        k,
        q
    ];
}
var $2d87e36c913093d6$export$2e2bcd8739ae039 = {
    physical: $2d87e36c913093d6$export$9a54d1b59736b1ea
};


/**
 * @copyright 2013 Sonia Keys
 * @copyright 2016 commenthol
 * @license MIT
 * @module moon
 */ /**
 * Moon: Chapter 53, Ephemeris for Physical Observations of the Moon.
 *
 * Incomplete.  Topocentric functions are commented out for lack of test data.
 */ 
var $9QpM5 = parcelRequire("9QpM5");

/**
 * @copyright 2013 Sonia Keys
 * @copyright 2016 commenthol
 * @license MIT
 * @module moonposition
 */ /**
 * Moonposition: Chapter 47, Position of the Moon.
 */ 
var $9QpM5 = parcelRequire("9QpM5");
const { asin: $bb07df9bdf17912b$var$asin, sin: $bb07df9bdf17912b$var$sin } = Math;
const $bb07df9bdf17912b$var$D2R = Math.PI / 180;
const $bb07df9bdf17912b$var$EARTH_RADIUS = 6378.137 // km
;
function $bb07df9bdf17912b$export$714480decc7901b5(distance) {
    // p. 337
    return $bb07df9bdf17912b$var$asin($bb07df9bdf17912b$var$EARTH_RADIUS / distance);
}
function $bb07df9bdf17912b$var$dmf(T) {
    const d = (0, $9QpM5.default).horner(T, 297.8501921 * $bb07df9bdf17912b$var$D2R, 445267.1114034 * $bb07df9bdf17912b$var$D2R, -0.0018819 * $bb07df9bdf17912b$var$D2R, $bb07df9bdf17912b$var$D2R / 545868, -$bb07df9bdf17912b$var$D2R / 113065000);
    const m = (0, $9QpM5.default).horner(T, 357.5291092 * $bb07df9bdf17912b$var$D2R, 35999.0502909 * $bb07df9bdf17912b$var$D2R, -0.0001536 * $bb07df9bdf17912b$var$D2R, $bb07df9bdf17912b$var$D2R / 24490000);
    const m_ = (0, $9QpM5.default).horner(T, 134.9633964 * $bb07df9bdf17912b$var$D2R, 477198.8675055 * $bb07df9bdf17912b$var$D2R, 0.0087414 * $bb07df9bdf17912b$var$D2R, $bb07df9bdf17912b$var$D2R / 69699, -$bb07df9bdf17912b$var$D2R / 14712000);
    const f = (0, $9QpM5.default).horner(T, 93.272095 * $bb07df9bdf17912b$var$D2R, 483202.0175233 * $bb07df9bdf17912b$var$D2R, -0.0036539 * $bb07df9bdf17912b$var$D2R, -$bb07df9bdf17912b$var$D2R / 3526000, $bb07df9bdf17912b$var$D2R / 863310000);
    return [
        d,
        m,
        m_,
        f
    ];
}
function $bb07df9bdf17912b$export$5880b8b5730aff45(jde) {
    const T = (0, $9QpM5.default).J2000Century(jde);
    const l_ = (0, $9QpM5.default).horner(T, 218.3164477 * $bb07df9bdf17912b$var$D2R, 481267.88123421 * $bb07df9bdf17912b$var$D2R, -0.0015786 * $bb07df9bdf17912b$var$D2R, $bb07df9bdf17912b$var$D2R / 538841, -$bb07df9bdf17912b$var$D2R / 65194000);
    const [d, m, m_, f] = $bb07df9bdf17912b$var$dmf(T);
    const a1 = 119.75 * $bb07df9bdf17912b$var$D2R + 131.849 * $bb07df9bdf17912b$var$D2R * T;
    const a2 = 53.09 * $bb07df9bdf17912b$var$D2R + 479264.29 * $bb07df9bdf17912b$var$D2R * T;
    const a3 = 313.45 * $bb07df9bdf17912b$var$D2R + 481266.484 * $bb07df9bdf17912b$var$D2R * T;
    const e = (0, $9QpM5.default).horner(T, 1, -0.002516, -0.0000074);
    const e2 = e * e;
    let \u03A3l = 3958 * $bb07df9bdf17912b$var$sin(a1) + 1962 * $bb07df9bdf17912b$var$sin(l_ - f) + 318 * $bb07df9bdf17912b$var$sin(a2);
    let \u03A3r = 0.0;
    let \u03A3b = -2235 * $bb07df9bdf17912b$var$sin(l_) + 382 * $bb07df9bdf17912b$var$sin(a3) + 175 * $bb07df9bdf17912b$var$sin(a1 - f) + 175 * $bb07df9bdf17912b$var$sin(a1 + f) + 127 * $bb07df9bdf17912b$var$sin(l_ - m_) - 115 * $bb07df9bdf17912b$var$sin(l_ + m_);
    $bb07df9bdf17912b$var$ta.forEach((r)=>{
        const [sina, cosa] = (0, $9QpM5.default).sincos(d * r.d + m * r.m + m_ * r.m_ + f * r.f);
        switch(r.m){
            case 0:
                \u03A3l += r.\u03A3l * sina;
                \u03A3r += r.\u03A3r * cosa;
                break;
            case -1:
            case 1:
                \u03A3l += r.\u03A3l * sina * e;
                \u03A3r += r.\u03A3r * cosa * e;
                break;
            case -2:
            case 2:
                \u03A3l += r.\u03A3l * sina * e2;
                \u03A3r += r.\u03A3r * cosa * e2;
                break;
        }
    });
    $bb07df9bdf17912b$var$tb.forEach((r)=>{
        const sb = $bb07df9bdf17912b$var$sin(d * r.d + m * r.m + m_ * r.m_ + f * r.f);
        switch(r.m){
            case 0:
                \u03A3b += r.\u03A3b * sb;
                break;
            case -1:
            case 1:
                \u03A3b += r.\u03A3b * sb * e;
                break;
            case -2:
            case 2:
                \u03A3b += r.\u03A3b * sb * e2;
                break;
        }
    });
    const lon = (0, $9QpM5.default).pmod(l_, 2 * Math.PI) + \u03A3l * 1e-6 * $bb07df9bdf17912b$var$D2R;
    const lat = \u03A3b * 1e-6 * $bb07df9bdf17912b$var$D2R;
    const range = 385000.56 + \u03A3r * 1e-3;
    return new (0, $9QpM5.default).Coord(lon, lat, range);
}
const $bb07df9bdf17912b$var$ta = function() {
    const ta = [
        [
            0,
            0,
            1,
            0,
            6288774,
            -20905355
        ],
        [
            2,
            0,
            -1,
            0,
            1274027,
            -3699111
        ],
        [
            2,
            0,
            0,
            0,
            658314,
            -2955968
        ],
        [
            0,
            0,
            2,
            0,
            213618,
            -569925
        ],
        [
            0,
            1,
            0,
            0,
            -185116,
            48888
        ],
        [
            0,
            0,
            0,
            2,
            -114332,
            -3149
        ],
        [
            2,
            0,
            -2,
            0,
            58793,
            246158
        ],
        [
            2,
            -1,
            -1,
            0,
            57066,
            -152138
        ],
        [
            2,
            0,
            1,
            0,
            53322,
            -170733
        ],
        [
            2,
            -1,
            0,
            0,
            45758,
            -204586
        ],
        [
            0,
            1,
            -1,
            0,
            -40923,
            -129620
        ],
        [
            1,
            0,
            0,
            0,
            -34720,
            108743
        ],
        [
            0,
            1,
            1,
            0,
            -30383,
            104755
        ],
        [
            2,
            0,
            0,
            -2,
            15327,
            10321
        ],
        [
            0,
            0,
            1,
            2,
            -12528,
            0
        ],
        [
            0,
            0,
            1,
            -2,
            10980,
            79661
        ],
        [
            4,
            0,
            -1,
            0,
            10675,
            -34782
        ],
        [
            0,
            0,
            3,
            0,
            10034,
            -23210
        ],
        [
            4,
            0,
            -2,
            0,
            8548,
            -21636
        ],
        [
            2,
            1,
            -1,
            0,
            -7888,
            24208
        ],
        [
            2,
            1,
            0,
            0,
            -6766,
            30824
        ],
        [
            1,
            0,
            -1,
            0,
            -5163,
            -8379
        ],
        [
            1,
            1,
            0,
            0,
            4987,
            -16675
        ],
        [
            2,
            -1,
            1,
            0,
            4036,
            -12831
        ],
        [
            2,
            0,
            2,
            0,
            3994,
            -10445
        ],
        [
            4,
            0,
            0,
            0,
            3861,
            -11650
        ],
        [
            2,
            0,
            -3,
            0,
            3665,
            14403
        ],
        [
            0,
            1,
            -2,
            0,
            -2689,
            -7003
        ],
        [
            2,
            0,
            -1,
            2,
            -2602,
            0
        ],
        [
            2,
            -1,
            -2,
            0,
            2390,
            10056
        ],
        [
            1,
            0,
            1,
            0,
            -2348,
            6322
        ],
        [
            2,
            -2,
            0,
            0,
            2236,
            -9884
        ],
        [
            0,
            1,
            2,
            0,
            -2120,
            5751
        ],
        [
            0,
            2,
            0,
            0,
            -2069,
            0
        ],
        [
            2,
            -2,
            -1,
            0,
            2048,
            -4950
        ],
        [
            2,
            0,
            1,
            -2,
            -1773,
            4130
        ],
        [
            2,
            0,
            0,
            2,
            -1595,
            0
        ],
        [
            4,
            -1,
            -1,
            0,
            1215,
            -3958
        ],
        [
            0,
            0,
            2,
            2,
            -1110,
            0
        ],
        [
            3,
            0,
            -1,
            0,
            -892,
            3258
        ],
        [
            2,
            1,
            1,
            0,
            -810,
            2616
        ],
        [
            4,
            -1,
            -2,
            0,
            759,
            -1897
        ],
        [
            0,
            2,
            -1,
            0,
            -713,
            -2117
        ],
        [
            2,
            2,
            -1,
            0,
            -700,
            2354
        ],
        [
            2,
            1,
            -2,
            0,
            691,
            0
        ],
        [
            2,
            -1,
            0,
            -2,
            596,
            0
        ],
        [
            4,
            0,
            1,
            0,
            549,
            -1423
        ],
        [
            0,
            0,
            4,
            0,
            537,
            -1117
        ],
        [
            4,
            -1,
            0,
            0,
            520,
            -1571
        ],
        [
            1,
            0,
            -2,
            0,
            -487,
            -1739
        ],
        [
            2,
            1,
            0,
            -2,
            -399,
            0
        ],
        [
            0,
            0,
            2,
            -2,
            -381,
            -4421
        ],
        [
            1,
            1,
            1,
            0,
            351,
            0
        ],
        [
            3,
            0,
            -2,
            0,
            -340,
            0
        ],
        [
            4,
            0,
            -3,
            0,
            330,
            0
        ],
        [
            2,
            -1,
            2,
            0,
            327,
            0
        ],
        [
            0,
            2,
            1,
            0,
            -323,
            1165
        ],
        [
            1,
            1,
            -1,
            0,
            299,
            0
        ],
        [
            2,
            0,
            3,
            0,
            294,
            0
        ],
        [
            2,
            0,
            -1,
            -2,
            0,
            8752
        ]
    ];
    return ta.map((row)=>{
        const o = {};
        const vals = [
            'd',
            'm',
            'm_',
            'f',
            "\u03A3l",
            "\u03A3r"
        ];
        vals.forEach((D2R, i)=>{
            o[D2R] = row[i];
        });
        return o;
    });
}();
const $bb07df9bdf17912b$var$tb = function() {
    const tb = [
        [
            0,
            0,
            0,
            1,
            5128122
        ],
        [
            0,
            0,
            1,
            1,
            280602
        ],
        [
            0,
            0,
            1,
            -1,
            277693
        ],
        [
            2,
            0,
            0,
            -1,
            173237
        ],
        [
            2,
            0,
            -1,
            1,
            55413
        ],
        [
            2,
            0,
            -1,
            -1,
            46271
        ],
        [
            2,
            0,
            0,
            1,
            32573
        ],
        [
            0,
            0,
            2,
            1,
            17198
        ],
        [
            2,
            0,
            1,
            -1,
            9266
        ],
        [
            0,
            0,
            2,
            -1,
            8822
        ],
        [
            2,
            -1,
            0,
            -1,
            8216
        ],
        [
            2,
            0,
            -2,
            -1,
            4324
        ],
        [
            2,
            0,
            1,
            1,
            4200
        ],
        [
            2,
            1,
            0,
            -1,
            -3359
        ],
        [
            2,
            -1,
            -1,
            1,
            2463
        ],
        [
            2,
            -1,
            0,
            1,
            2211
        ],
        [
            2,
            -1,
            -1,
            -1,
            2065
        ],
        [
            0,
            1,
            -1,
            -1,
            -1870
        ],
        [
            4,
            0,
            -1,
            -1,
            1828
        ],
        [
            0,
            1,
            0,
            1,
            -1794
        ],
        [
            0,
            0,
            0,
            3,
            -1749
        ],
        [
            0,
            1,
            -1,
            1,
            -1565
        ],
        [
            1,
            0,
            0,
            1,
            -1491
        ],
        [
            0,
            1,
            1,
            1,
            -1475
        ],
        [
            0,
            1,
            1,
            -1,
            -1410
        ],
        [
            0,
            1,
            0,
            -1,
            -1344
        ],
        [
            1,
            0,
            0,
            -1,
            -1335
        ],
        [
            0,
            0,
            3,
            1,
            1107
        ],
        [
            4,
            0,
            0,
            -1,
            1021
        ],
        [
            4,
            0,
            -1,
            1,
            833
        ],
        [
            0,
            0,
            1,
            -3,
            777
        ],
        [
            4,
            0,
            -2,
            1,
            671
        ],
        [
            2,
            0,
            0,
            -3,
            607
        ],
        [
            2,
            0,
            2,
            -1,
            596
        ],
        [
            2,
            -1,
            1,
            -1,
            491
        ],
        [
            2,
            0,
            -2,
            1,
            -451
        ],
        [
            0,
            0,
            3,
            -1,
            439
        ],
        [
            2,
            0,
            2,
            1,
            422
        ],
        [
            2,
            0,
            -3,
            -1,
            421
        ],
        [
            2,
            1,
            -1,
            1,
            -366
        ],
        [
            2,
            1,
            0,
            1,
            -351
        ],
        [
            4,
            0,
            0,
            1,
            331
        ],
        [
            2,
            -1,
            1,
            1,
            315
        ],
        [
            2,
            -2,
            0,
            -1,
            302
        ],
        [
            0,
            0,
            1,
            3,
            -283
        ],
        [
            2,
            1,
            1,
            -1,
            -229
        ],
        [
            1,
            1,
            0,
            -1,
            223
        ],
        [
            1,
            1,
            0,
            1,
            223
        ],
        [
            0,
            1,
            -2,
            -1,
            -220
        ],
        [
            2,
            1,
            -1,
            -1,
            -220
        ],
        [
            1,
            0,
            1,
            1,
            -185
        ],
        [
            2,
            -1,
            -2,
            -1,
            181
        ],
        [
            0,
            1,
            2,
            1,
            -177
        ],
        [
            4,
            0,
            -2,
            -1,
            176
        ],
        [
            4,
            -1,
            -1,
            -1,
            166
        ],
        [
            1,
            0,
            1,
            -1,
            -164
        ],
        [
            4,
            0,
            1,
            -1,
            132
        ],
        [
            1,
            0,
            -1,
            -1,
            -119
        ],
        [
            4,
            -1,
            0,
            -1,
            115
        ],
        [
            2,
            -2,
            0,
            1,
            107
        ]
    ];
    return tb.map((row)=>{
        const o = {};
        const vals = [
            'd',
            'm',
            'm_',
            'f',
            "\u03A3b"
        ];
        vals.forEach((D2R, i)=>{
            o[D2R] = row[i];
        });
        return o;
    });
}();
function $bb07df9bdf17912b$export$35059013cd4a06db(jde) {
    return (0, $9QpM5.default).pmod((0, $9QpM5.default).horner((0, $9QpM5.default).J2000Century(jde), 125.0445479 * $bb07df9bdf17912b$var$D2R, -1934.1362891 * $bb07df9bdf17912b$var$D2R, 0.0020754 * $bb07df9bdf17912b$var$D2R, $bb07df9bdf17912b$var$D2R / 467441, -$bb07df9bdf17912b$var$D2R / 60616000), 2 * Math.PI);
}
function $bb07df9bdf17912b$export$ef3fbfd5eea0a35(jde) {
    return (0, $9QpM5.default).pmod((0, $9QpM5.default).horner((0, $9QpM5.default).J2000Century(jde), 83.3532465 * $bb07df9bdf17912b$var$D2R, 4069.0137287 * $bb07df9bdf17912b$var$D2R, -0.01032 * $bb07df9bdf17912b$var$D2R, -$bb07df9bdf17912b$var$D2R / 80053, $bb07df9bdf17912b$var$D2R / 18999000), 2 * Math.PI);
}
function $bb07df9bdf17912b$export$a3478dad3a9c99ae(jde) {
    const [d, m, m_, f] = $bb07df9bdf17912b$var$dmf((0, $9QpM5.default).J2000Century(jde));
    return $bb07df9bdf17912b$export$35059013cd4a06db(jde) + -1.4979 * $bb07df9bdf17912b$var$D2R * $bb07df9bdf17912b$var$sin(2 * (d - f)) + -0.15 * $bb07df9bdf17912b$var$D2R * $bb07df9bdf17912b$var$sin(m) + -0.1226 * $bb07df9bdf17912b$var$D2R * $bb07df9bdf17912b$var$sin(2 * d) + 0.1176 * $bb07df9bdf17912b$var$D2R * $bb07df9bdf17912b$var$sin(2 * f) + -0.0801 * $bb07df9bdf17912b$var$D2R * $bb07df9bdf17912b$var$sin(2 * (m_ - f));
}
var $bb07df9bdf17912b$export$2e2bcd8739ae039 = {
    parallax: $bb07df9bdf17912b$export$714480decc7901b5,
    position: $bb07df9bdf17912b$export$5880b8b5730aff45,
    node: $bb07df9bdf17912b$export$35059013cd4a06db,
    perigee: $bb07df9bdf17912b$export$ef3fbfd5eea0a35,
    trueNode: $bb07df9bdf17912b$export$a3478dad3a9c99ae
};





const { sin: $7179560f0cf754e5$var$sin, cos: $7179560f0cf754e5$var$cos, asin: $7179560f0cf754e5$var$asin, atan2: $7179560f0cf754e5$var$atan2 } = Math;
const $7179560f0cf754e5$var$D2R = Math.PI / 180;
const $7179560f0cf754e5$var$_I = 1.54242 * $7179560f0cf754e5$var$D2R // IAU value of inclination of mean lunar equator
;
const [$7179560f0cf754e5$var$sI, $7179560f0cf754e5$var$cI] = (0, $9QpM5.default).sincos($7179560f0cf754e5$var$_I);
function $7179560f0cf754e5$export$9a54d1b59736b1ea(jde, earth) {
    const { lon: lon, lat: lat, range: range } = (0, $bb07df9bdf17912b$export$2e2bcd8739ae039).position(jde) // (λ without nutation)
    ;
    // [λ, β, Δ]
    const m = new $7179560f0cf754e5$export$ab2e8fc3a68054ee(jde);
    const [l, b] = m.lib(lon, lat);
    const P = m.pa(lon, lat, b);
    const [l0, b0] = m.sun(lon, lat, range, earth);
    const cMoon = new (0, $9QpM5.default).Coord(l, b);
    const cSun = new (0, $9QpM5.default).Coord(l0, b0);
    return [
        cMoon,
        P,
        cSun
    ];
}
class $7179560f0cf754e5$export$ab2e8fc3a68054ee {
    constructor(jde){
        this.jde = jde;
        // Δψ, F, Ω, p. 372.0
        const [\u0394\u03C8, \u0394\u03B5] = (0, $c50a9505be5a627c$export$2e2bcd8739ae039).nutation(jde);
        this.\u0394\u03C8 = \u0394\u03C8;
        const T = (0, $9QpM5.default).J2000Century(jde);
        const F = this.F = (0, $9QpM5.default).horner(T, 93.272095 * $7179560f0cf754e5$var$D2R, 483202.0175233 * $7179560f0cf754e5$var$D2R, -0.0036539 * $7179560f0cf754e5$var$D2R, -$7179560f0cf754e5$var$D2R / 3526000, $7179560f0cf754e5$var$D2R / 863310000);
        this.\u03A9 = (0, $9QpM5.default).horner(T, 125.0445479 * $7179560f0cf754e5$var$D2R, -1934.1362891 * $7179560f0cf754e5$var$D2R, 0.0020754 * $7179560f0cf754e5$var$D2R, $7179560f0cf754e5$var$D2R / 467441, -$7179560f0cf754e5$var$D2R / 60616000);
        // true ecliptic
        this.\u03B5 = (0, $c50a9505be5a627c$export$2e2bcd8739ae039).meanObliquity(jde) + \u0394\u03B5;
        this.s\u03B5 = $7179560f0cf754e5$var$sin(this.\u03B5);
        this.c\u03B5 = $7179560f0cf754e5$var$cos(this.\u03B5);
        // ρ, σ, τ, p. 372,373
        const D = (0, $9QpM5.default).horner(T, 297.8501921 * $7179560f0cf754e5$var$D2R, 445267.1114034 * $7179560f0cf754e5$var$D2R, -0.0018819 * $7179560f0cf754e5$var$D2R, $7179560f0cf754e5$var$D2R / 545868, -$7179560f0cf754e5$var$D2R / 113065000);
        const M = (0, $9QpM5.default).horner(T, 357.5291092 * $7179560f0cf754e5$var$D2R, 35999.0502909 * $7179560f0cf754e5$var$D2R, -0.0001536 * $7179560f0cf754e5$var$D2R, $7179560f0cf754e5$var$D2R / 24490000);
        const M_ = (0, $9QpM5.default).horner(T, 134.9633964 * $7179560f0cf754e5$var$D2R, 477198.8675055 * $7179560f0cf754e5$var$D2R, 0.0087414 * $7179560f0cf754e5$var$D2R, $7179560f0cf754e5$var$D2R / 69699, -$7179560f0cf754e5$var$D2R / 14712000);
        const E = (0, $9QpM5.default).horner(T, 1, -0.002516, -0.0000074);
        const K1 = 119.75 * $7179560f0cf754e5$var$D2R + 131.849 * $7179560f0cf754e5$var$D2R * T;
        const K2 = 72.56 * $7179560f0cf754e5$var$D2R + 20.186 * $7179560f0cf754e5$var$D2R * T;
        this.\u03C1 = -0.02752 * $7179560f0cf754e5$var$D2R * $7179560f0cf754e5$var$cos(M_) + -0.02245 * $7179560f0cf754e5$var$D2R * $7179560f0cf754e5$var$sin(F) + 0.00684 * $7179560f0cf754e5$var$D2R * $7179560f0cf754e5$var$cos(M_ - 2 * F) + -0.00293 * $7179560f0cf754e5$var$D2R * $7179560f0cf754e5$var$cos(2 * F) + -0.00085 * $7179560f0cf754e5$var$D2R * $7179560f0cf754e5$var$cos(2 * (F - D)) + -0.00054 * $7179560f0cf754e5$var$D2R * $7179560f0cf754e5$var$cos(M_ - 2 * D) + -0.0002 * $7179560f0cf754e5$var$D2R * $7179560f0cf754e5$var$sin(M_ + F) + -0.0002 * $7179560f0cf754e5$var$D2R * $7179560f0cf754e5$var$cos(M_ + 2 * F) + -0.0002 * $7179560f0cf754e5$var$D2R * $7179560f0cf754e5$var$cos(M_ - F) + 0.00014 * $7179560f0cf754e5$var$D2R * $7179560f0cf754e5$var$cos(M_ + 2 * (F - D));
        this.\u03C3 = -0.02816 * $7179560f0cf754e5$var$D2R * $7179560f0cf754e5$var$sin(M_) + 0.02244 * $7179560f0cf754e5$var$D2R * $7179560f0cf754e5$var$cos(F) + -0.00682 * $7179560f0cf754e5$var$D2R * $7179560f0cf754e5$var$sin(M_ - 2 * F) + -0.00279 * $7179560f0cf754e5$var$D2R * $7179560f0cf754e5$var$sin(2 * F) + -0.00083 * $7179560f0cf754e5$var$D2R * $7179560f0cf754e5$var$sin(2 * (F - D)) + 0.00069 * $7179560f0cf754e5$var$D2R * $7179560f0cf754e5$var$sin(M_ - 2 * D) + 0.0004 * $7179560f0cf754e5$var$D2R * $7179560f0cf754e5$var$cos(M_ + F) + -0.00025 * $7179560f0cf754e5$var$D2R * $7179560f0cf754e5$var$sin(2 * M_) + -0.00023 * $7179560f0cf754e5$var$D2R * $7179560f0cf754e5$var$sin(M_ + 2 * F) + 0.0002 * $7179560f0cf754e5$var$D2R * $7179560f0cf754e5$var$cos(M_ - F) + 0.00019 * $7179560f0cf754e5$var$D2R * $7179560f0cf754e5$var$sin(M_ - F) + 0.00013 * $7179560f0cf754e5$var$D2R * $7179560f0cf754e5$var$sin(M_ + 2 * (F - D)) + -0.0001 * $7179560f0cf754e5$var$D2R * $7179560f0cf754e5$var$cos(M_ - 3 * F);
        this.\u03C4 = 0.0252 * $7179560f0cf754e5$var$D2R * $7179560f0cf754e5$var$sin(M) * E + 0.00473 * $7179560f0cf754e5$var$D2R * $7179560f0cf754e5$var$sin(2 * (M_ - F)) + -0.00467 * $7179560f0cf754e5$var$D2R * $7179560f0cf754e5$var$sin(M_) + 0.00396 * $7179560f0cf754e5$var$D2R * $7179560f0cf754e5$var$sin(K1) + 0.00276 * $7179560f0cf754e5$var$D2R * $7179560f0cf754e5$var$sin(2 * (M_ - D)) + 0.00196 * $7179560f0cf754e5$var$D2R * $7179560f0cf754e5$var$sin(this.\u03A9) + -0.00183 * $7179560f0cf754e5$var$D2R * $7179560f0cf754e5$var$cos(M_ - F) + 0.00115 * $7179560f0cf754e5$var$D2R * $7179560f0cf754e5$var$sin(M_ - 2 * D) + -0.00096 * $7179560f0cf754e5$var$D2R * $7179560f0cf754e5$var$sin(M_ - D) + 0.00046 * $7179560f0cf754e5$var$D2R * $7179560f0cf754e5$var$sin(2 * (F - D)) + -0.00039 * $7179560f0cf754e5$var$D2R * $7179560f0cf754e5$var$sin(M_ - F) + -0.00032 * $7179560f0cf754e5$var$D2R * $7179560f0cf754e5$var$sin(M_ - M - D) + 0.00027 * $7179560f0cf754e5$var$D2R * $7179560f0cf754e5$var$sin(2 * (M_ - D) - M) + 0.00023 * $7179560f0cf754e5$var$D2R * $7179560f0cf754e5$var$sin(K2) + -0.00014 * $7179560f0cf754e5$var$D2R * $7179560f0cf754e5$var$sin(2 * D) + 0.00014 * $7179560f0cf754e5$var$D2R * $7179560f0cf754e5$var$cos(2 * (M_ - F)) + -0.00012 * $7179560f0cf754e5$var$D2R * $7179560f0cf754e5$var$sin(M_ - 2 * F) + -0.00012 * $7179560f0cf754e5$var$D2R * $7179560f0cf754e5$var$sin(2 * M_) + 0.00011 * $7179560f0cf754e5$var$D2R * $7179560f0cf754e5$var$sin(2 * (M_ - M - D));
    }
    /**
   * lib() curiously serves for computing both librations and solar coordinates,
   * depending on the coordinates λ, β passed in.  Quantity A not described in
   * the book, but clearly depends on the λ, β of the current context and so
   * does not belong in the moon struct.  Instead just return it from optical
   * and pass it along to physical.
   */ lib(\u03BB, \u03B2) {
        const [l_, b_, A] = this.optical(\u03BB, \u03B2);
        const [l$, b$] = this.physical(A, b_);
        let l = l_ + l$;
        if (l > Math.PI) l -= 2 * Math.PI;
        const b = b_ + b$;
        return [
            l,
            b
        ];
    }
    optical(\u03BB, \u03B2) {
        // (53.1) p. 372
        const W = \u03BB - this.\u03A9 // (λ without nutation)
        ;
        const [sW, cW] = (0, $9QpM5.default).sincos(W);
        const [s\u03B2, c\u03B2] = (0, $9QpM5.default).sincos(\u03B2);
        const A = $7179560f0cf754e5$var$atan2(sW * c\u03B2 * $7179560f0cf754e5$var$cI - s\u03B2 * $7179560f0cf754e5$var$sI, cW * c\u03B2);
        const l_ = (0, $9QpM5.default).pmod(A - this.F, 2 * Math.PI);
        const b_ = $7179560f0cf754e5$var$asin(-sW * c\u03B2 * $7179560f0cf754e5$var$sI - s\u03B2 * $7179560f0cf754e5$var$cI);
        return [
            l_,
            b_,
            A
        ];
    }
    physical(A, b_) {
        // (53.2) p. 373
        const [sA, cA] = (0, $9QpM5.default).sincos(A);
        const l$ = -this.\u03C4 + (this.\u03C1 * cA + this.\u03C3 * sA) * Math.tan(b_);
        const b$ = this.\u03C3 * cA - this.\u03C1 * sA;
        return [
            l$,
            b$
        ];
    }
    pa(\u03BB, \u03B2, b) {
        const V = this.\u03A9 + this.\u0394\u03C8 + this.\u03C3 / $7179560f0cf754e5$var$sI;
        const [sV, cV] = (0, $9QpM5.default).sincos(V);
        const [sI\u03C1, cI\u03C1] = (0, $9QpM5.default).sincos($7179560f0cf754e5$var$_I + this.\u03C1);
        const X = sI\u03C1 * sV;
        const Y = sI\u03C1 * cV * this.c\u03B5 - cI\u03C1 * this.s\u03B5;
        const \u03C9 = Math.atan2(X, Y);
        const ecl = new (0, $77f14e36e565e56c$export$2e2bcd8739ae039).Ecliptic(\u03BB + this.\u0394\u03C8, \u03B2).toEquatorial(this.\u03B5) // eslint-disable-line no-unused-vars
        ;
        let P = $7179560f0cf754e5$var$asin(Math.hypot(X, Y) * $7179560f0cf754e5$var$cos(ecl.ra - \u03C9) / $7179560f0cf754e5$var$cos(b));
        if (P < 0) P += 2 * Math.PI;
        return P;
    }
    sun(\u03BB, \u03B2, \u0394, earth) {
        const { lon: lon, lat: lat, range: range } = (0, $c85b876782fe98e7$export$2e2bcd8739ae039).apparentVSOP87(earth, this.jde) // eslint-disable-line no-unused-vars
        ;
        const \u0394R = \u0394 / (range * (0, $9QpM5.default).AU);
        const \u03BBH = lon + Math.PI + 57.296 * $7179560f0cf754e5$var$D2R * \u0394R * $7179560f0cf754e5$var$cos(\u03B2) * $7179560f0cf754e5$var$sin(lon - \u03BB);
        const \u03B2H = \u0394R * \u03B2;
        return this.lib(\u03BBH, \u03B2H);
    }
}
function $7179560f0cf754e5$export$b506b00ea7a204ce(cOnMoon, cSun) {
    const c0 = Math.PI / 2 - cSun.lon;
    const [sb0, cb0] = (0, $9QpM5.default).sincos(cSun.lat);
    const [s\u03B8, c\u03B8] = (0, $9QpM5.default).sincos(cOnMoon.lat);
    return $7179560f0cf754e5$var$asin(sb0 * s\u03B8 + cb0 * c\u03B8 * $7179560f0cf754e5$var$sin(c0 + cOnMoon.lon));
}
function $7179560f0cf754e5$export$a58fe85ad234014d(cOnMoon, jde, earth) {
    jde -= $7179560f0cf754e5$var$srCorr(cOnMoon, jde, earth);
    return jde - $7179560f0cf754e5$var$srCorr(cOnMoon, jde, earth);
}
function $7179560f0cf754e5$export$bb8beb7812301860(cOnMoon, jde, earth) {
    jde += $7179560f0cf754e5$var$srCorr(cOnMoon, jde, earth);
    return jde + $7179560f0cf754e5$var$srCorr(cOnMoon, jde, earth);
}
/**
 * @private
 */ function $7179560f0cf754e5$var$srCorr(cOnMoon, jde, earth) {
    const phy = $7179560f0cf754e5$export$9a54d1b59736b1ea(jde, earth);
    const h = $7179560f0cf754e5$export$b506b00ea7a204ce(cOnMoon, phy[2]);
    return h / (12.19075 * $7179560f0cf754e5$var$D2R * $7179560f0cf754e5$var$cos(cOnMoon.lat));
}
const $7179560f0cf754e5$var$lunarCoord = (\u03B7, \u03B8)=>new (0, $9QpM5.default).Coord(\u03B7 * $7179560f0cf754e5$var$D2R, \u03B8 * $7179560f0cf754e5$var$D2R);
const $7179560f0cf754e5$export$b554ad3b1570af50 = {
    archimedes: $7179560f0cf754e5$var$lunarCoord(-3.9, 29.7),
    aristarchus: $7179560f0cf754e5$var$lunarCoord(-47.5, 23.7),
    aristillus: $7179560f0cf754e5$var$lunarCoord(1.2, 33.9),
    aristoteles: $7179560f0cf754e5$var$lunarCoord(17.3, 50.1),
    arzachel: $7179560f0cf754e5$var$lunarCoord(-1.9, -17.7),
    autolycus: $7179560f0cf754e5$var$lunarCoord(1.5, 30.7),
    billy: $7179560f0cf754e5$var$lunarCoord(-50, -13.8),
    birt: $7179560f0cf754e5$var$lunarCoord(-8.5, -22.3),
    campanus: $7179560f0cf754e5$var$lunarCoord(-27.7, -28),
    censorinus: $7179560f0cf754e5$var$lunarCoord(32.7, -0.4),
    clavius: $7179560f0cf754e5$var$lunarCoord(-14, -58),
    copernicus: $7179560f0cf754e5$var$lunarCoord(-20, 9.7),
    delambre: $7179560f0cf754e5$var$lunarCoord(17.5, -1.9),
    dionysius: $7179560f0cf754e5$var$lunarCoord(17.3, 2.8),
    endymion: $7179560f0cf754e5$var$lunarCoord(56.4, 53.6),
    eratosthenes: $7179560f0cf754e5$var$lunarCoord(-11.3, 14.5),
    eudoxus: $7179560f0cf754e5$var$lunarCoord(16.3, 44.3),
    fracastorius: $7179560f0cf754e5$var$lunarCoord(33.2, -21),
    fraMauro: $7179560f0cf754e5$var$lunarCoord(-17, -6),
    gassendi: $7179560f0cf754e5$var$lunarCoord(-39.9, -17.5),
    goclenius: $7179560f0cf754e5$var$lunarCoord(45, -10.1),
    grimaldi: $7179560f0cf754e5$var$lunarCoord(-68.5, -5.8),
    harpalus: $7179560f0cf754e5$var$lunarCoord(-43.4, 52.6),
    horrocks: $7179560f0cf754e5$var$lunarCoord(5.9, -4),
    kepler: $7179560f0cf754e5$var$lunarCoord(-38, 8.1),
    langrenus: $7179560f0cf754e5$var$lunarCoord(60.9, -8.9),
    lansberg: $7179560f0cf754e5$var$lunarCoord(-26.6, -0.3),
    letronne: $7179560f0cf754e5$var$lunarCoord(-43, -10),
    macrobius: $7179560f0cf754e5$var$lunarCoord(46, 21.2),
    manilius: $7179560f0cf754e5$var$lunarCoord(9.1, 14.5),
    menelaus: $7179560f0cf754e5$var$lunarCoord(16, 16.3),
    messier: $7179560f0cf754e5$var$lunarCoord(47.6, -1.9),
    petavius: $7179560f0cf754e5$var$lunarCoord(61, -25),
    pico: $7179560f0cf754e5$var$lunarCoord(-8.8, 45.8),
    pitatus: $7179560f0cf754e5$var$lunarCoord(-13.5, -29.8),
    piton: $7179560f0cf754e5$var$lunarCoord(-0.8, 40.8),
    plato: $7179560f0cf754e5$var$lunarCoord(-9.2, 51.4),
    plinius: $7179560f0cf754e5$var$lunarCoord(23.6, 15.3),
    posidonius: $7179560f0cf754e5$var$lunarCoord(30, 31.9),
    proclus: $7179560f0cf754e5$var$lunarCoord(46.9, 16.1),
    ptolemeusA: $7179560f0cf754e5$var$lunarCoord(-0.8, -8.5),
    pytheas: $7179560f0cf754e5$var$lunarCoord(-20.6, 20.5),
    reinhold: $7179560f0cf754e5$var$lunarCoord(-22.8, 3.2),
    riccioli: $7179560f0cf754e5$var$lunarCoord(-74.3, -3.2),
    schickard: $7179560f0cf754e5$var$lunarCoord(-54.5, -44),
    schiller: $7179560f0cf754e5$var$lunarCoord(-39, -52),
    tauruntius: $7179560f0cf754e5$var$lunarCoord(46.5, 5.6),
    theophilus: $7179560f0cf754e5$var$lunarCoord(26.5, -11.4),
    timocharis: $7179560f0cf754e5$var$lunarCoord(-13.1, 26.7),
    tycho: $7179560f0cf754e5$var$lunarCoord(-11, -43.2),
    vitruvius: $7179560f0cf754e5$var$lunarCoord(31.3, 17.6),
    walter: $7179560f0cf754e5$var$lunarCoord(1, -33)
};
var $7179560f0cf754e5$export$2e2bcd8739ae039 = {
    physical: $7179560f0cf754e5$export$9a54d1b59736b1ea,
    Moon: $7179560f0cf754e5$export$ab2e8fc3a68054ee,
    sunAltitude: // Topocentric,
    // TopocentricCorrections,
    $7179560f0cf754e5$export$b506b00ea7a204ce,
    sunrise: $7179560f0cf754e5$export$a58fe85ad234014d,
    sunset: $7179560f0cf754e5$export$bb8beb7812301860,
    selenographic: $7179560f0cf754e5$export$b554ad3b1570af50
};


/**
 * @copyright 2013 Sonia Keys
 * @copyright 2016 commenthol
 * @license MIT
 * @module moonillum
 */ /**
 * Moonillum: Chapter 48, Illuminated Fraction of the Moon's Disk
 *
 * Also see functions `illuminated` and `limb` in package base.  The function
 * for computing illuminated fraction given a phase angle (48.1) is
 * base.illuminated.  Formula (48.3) is implemented as base.limb.
 */ 
var $9QpM5 = parcelRequire("9QpM5");
const $de8e711e24a585ef$var$D2R = Math.PI / 180;
function $de8e711e24a585ef$export$acb5c4eb466d335d(cMoon, cSun) {
    return $de8e711e24a585ef$var$pa(cMoon.range, cSun.range, $de8e711e24a585ef$var$cosEq(cMoon.ra, cMoon.dec, cSun.ra, cSun.dec));
}
/**
 * cos elongation from equatorial coordinates
 * @private
 */ function $de8e711e24a585ef$var$cosEq(\u03B1, \u03B4, \u03B10, \u03B40) {
    const [s\u03B4, c\u03B4] = (0, $9QpM5.default).sincos(\u03B4);
    const [s\u03B40, c\u03B40] = (0, $9QpM5.default).sincos(\u03B40);
    return s\u03B40 * s\u03B4 + c\u03B40 * c\u03B4 * Math.cos(\u03B10 - \u03B1);
}
/**
 * phase angle from cos elongation and distances
 * @private
 * @param {number} Δ
 * @param {number} R
 * @param {number} cψ
 * @returns {number}
 */ function $de8e711e24a585ef$var$pa(\u0394, R, c\u03C8) {
    const s\u03C8 = Math.sin(Math.acos(c\u03C8));
    let i = Math.atan(R * s\u03C8 / (\u0394 - R * c\u03C8));
    if (i < 0) i += Math.PI;
    return i;
}
function $de8e711e24a585ef$export$22a7320464d9e02e(cMoon, cSun) {
    return Math.acos(-$de8e711e24a585ef$var$cosEq(cMoon.ra, cMoon.dec, cSun.ra, cSun.dec));
}
function $de8e711e24a585ef$export$652b8a56bbe9f92f(cMoon, cSun) {
    return $de8e711e24a585ef$var$pa(cMoon.range, cSun.range, $de8e711e24a585ef$var$cosEcl(cMoon.lon, cMoon.lat, cSun.lon));
}
/**
 * cos elongation from ecliptic coordinates
 * @private
 */ function $de8e711e24a585ef$var$cosEcl(\u03BB, \u03B2, \u03BB0) {
    return Math.cos(\u03B2) * Math.cos(\u03BB - \u03BB0);
}
function $de8e711e24a585ef$export$9278afc1ecf4c0d1(cMoon, cSun) {
    return Math.acos(-$de8e711e24a585ef$var$cosEcl(cMoon.lon, cMoon.lat, cSun.lon));
}
function $de8e711e24a585ef$export$be86d9bcd1af0de5(jde) {
    const T = (0, $9QpM5.default).J2000Century(jde);
    const D = (0, $9QpM5.default).horner(T, 297.8501921 * $de8e711e24a585ef$var$D2R, 445267.1114034 * $de8e711e24a585ef$var$D2R, -0.0018819 * $de8e711e24a585ef$var$D2R, $de8e711e24a585ef$var$D2R / 545868, -$de8e711e24a585ef$var$D2R / 113065000);
    const m = (0, $9QpM5.default).horner(T, 357.5291092 * $de8e711e24a585ef$var$D2R, 35999.0502909 * $de8e711e24a585ef$var$D2R, -0.0001536 * $de8e711e24a585ef$var$D2R, $de8e711e24a585ef$var$D2R / 24490000);
    const m_ = (0, $9QpM5.default).horner(T, 134.9633964 * $de8e711e24a585ef$var$D2R, 477198.8675055 * $de8e711e24a585ef$var$D2R, 0.0087414 * $de8e711e24a585ef$var$D2R, $de8e711e24a585ef$var$D2R / 69699, -$de8e711e24a585ef$var$D2R / 14712000);
    return Math.PI - (0, $9QpM5.default).pmod(D, 2 * Math.PI) + -6.289 * $de8e711e24a585ef$var$D2R * Math.sin(m_) + 2.1 * $de8e711e24a585ef$var$D2R * Math.sin(m) + -1.274 * $de8e711e24a585ef$var$D2R * Math.sin(2 * D - m_) + -0.658 * $de8e711e24a585ef$var$D2R * Math.sin(2 * D) + -0.214 * $de8e711e24a585ef$var$D2R * Math.sin(2 * m_) + -0.11 * $de8e711e24a585ef$var$D2R * Math.sin(D);
}
var $de8e711e24a585ef$export$2e2bcd8739ae039 = {
    phaseAngleEquatorial: $de8e711e24a585ef$export$acb5c4eb466d335d,
    phaseAngleEquatorial2: $de8e711e24a585ef$export$22a7320464d9e02e,
    phaseAngleEcliptic: $de8e711e24a585ef$export$652b8a56bbe9f92f,
    phaseAngleEcliptic2: $de8e711e24a585ef$export$9278afc1ecf4c0d1,
    phaseAngle3: $de8e711e24a585ef$export$be86d9bcd1af0de5
};


/**
 * @copyright 2013 Sonia Keys
 * @copyright 2016 commenthol
 * @license MIT
 * @module moonmaxdec
 */ /**
 * Moonmaxdec: Chapter 52, Maximum Declinations of the Moon
 */ 
var $9QpM5 = parcelRequire("9QpM5");
function $b2d591b289be7a7e$export$27475a238f11763a(y) {
    return $b2d591b289be7a7e$var$max(y, $b2d591b289be7a7e$var$nc);
}
function $b2d591b289be7a7e$export$de7ad725f88394c4(y) {
    return $b2d591b289be7a7e$var$max(y, $b2d591b289be7a7e$var$sc);
}
const $b2d591b289be7a7e$var$p = Math.PI / 180;
const $b2d591b289be7a7e$var$ck = 1 / 1336.86;
/**
 * @private
 */ function $b2d591b289be7a7e$var$max(y, c) {
    let k = (y - 2000.03) * 13.3686 // (52.1) p. 367
    ;
    k = Math.floor(k + 0.5);
    const T = k * $b2d591b289be7a7e$var$ck;
    const D = (0, $9QpM5.default).horner(T, c.D, 333.0705546 * $b2d591b289be7a7e$var$p / $b2d591b289be7a7e$var$ck, -0.0004214 * $b2d591b289be7a7e$var$p, 0.00000011 * $b2d591b289be7a7e$var$p);
    const m = (0, $9QpM5.default).horner(T, c.m, 26.9281592 * $b2d591b289be7a7e$var$p / $b2d591b289be7a7e$var$ck, -0.0000355 * $b2d591b289be7a7e$var$p, -0.0000001 * $b2d591b289be7a7e$var$p);
    const m_ = (0, $9QpM5.default).horner(T, c.m_, 356.9562794 * $b2d591b289be7a7e$var$p / $b2d591b289be7a7e$var$ck, 0.0103066 * $b2d591b289be7a7e$var$p, 0.00001251 * $b2d591b289be7a7e$var$p);
    const f = (0, $9QpM5.default).horner(T, c.f, 1.4467807 * $b2d591b289be7a7e$var$p / $b2d591b289be7a7e$var$ck, -0.002069 * $b2d591b289be7a7e$var$p, -0.00000215 * $b2d591b289be7a7e$var$p);
    const E = (0, $9QpM5.default).horner(T, 1, -0.002516, -0.0000074);
    const jde = (0, $9QpM5.default).horner(T, c.JDE, 27.321582247 / $b2d591b289be7a7e$var$ck, 0.000119804, -0.000000141) + c.tc[0] * Math.cos(f) + c.tc[1] * Math.sin(m_) + c.tc[2] * Math.sin(2 * f) + c.tc[3] * Math.sin(2 * D - m_) + c.tc[4] * Math.cos(m_ - f) + c.tc[5] * Math.cos(m_ + f) + c.tc[6] * Math.sin(2 * D) + c.tc[7] * Math.sin(m) * E + c.tc[8] * Math.cos(3 * f) + c.tc[9] * Math.sin(m_ + 2 * f) + c.tc[10] * Math.cos(2 * D - f) + c.tc[11] * Math.cos(2 * D - m_ - f) + c.tc[12] * Math.cos(2 * D - m_ + f) + c.tc[13] * Math.cos(2 * D + f) + c.tc[14] * Math.sin(2 * m_) + c.tc[15] * Math.sin(m_ - 2 * f) + c.tc[16] * Math.cos(2 * m_ - f) + c.tc[17] * Math.sin(m_ + 3 * f) + c.tc[18] * Math.sin(2 * D - m - m_) * E + c.tc[19] * Math.cos(m_ - 2 * f) + c.tc[20] * Math.sin(2 * (D - m_)) + c.tc[21] * Math.sin(f) + c.tc[22] * Math.sin(2 * D + m_) + c.tc[23] * Math.cos(m_ + 2 * f) + c.tc[24] * Math.sin(2 * D - m) * E + c.tc[25] * Math.sin(m_ + f) + c.tc[26] * Math.sin(m - m_) * E + c.tc[27] * Math.sin(m_ - 3 * f) + c.tc[28] * Math.sin(2 * m_ + f) + c.tc[29] * Math.cos(2 * (D - m_) - f) + c.tc[30] * Math.sin(3 * f) + c.tc[31] * Math.cos(m_ + 3 * f) + c.tc[32] * Math.cos(2 * m_) + c.tc[33] * Math.cos(2 * D - m_) + c.tc[34] * Math.cos(2 * D + m_ + f) + c.tc[35] * Math.cos(m_) + c.tc[36] * Math.sin(3 * m_ + f) + c.tc[37] * Math.sin(2 * D - m_ + f) + c.tc[38] * Math.cos(2 * (D - m_)) + c.tc[39] * Math.cos(D + f) + c.tc[40] * Math.sin(m + m_) * E + c.tc[41] * Math.sin(2 * (D - f)) + c.tc[42] * Math.cos(2 * m_ + f) + c.tc[43] * Math.cos(3 * m_ + f);
    const \u03B4 = 23.6961 * $b2d591b289be7a7e$var$p - 0.013004 * $b2d591b289be7a7e$var$p * T + c.dc[0] * Math.sin(f) + c.dc[1] * Math.cos(2 * f) + c.dc[2] * Math.sin(2 * D - f) + c.dc[3] * Math.sin(3 * f) + c.dc[4] * Math.cos(2 * (D - f)) + c.dc[5] * Math.cos(2 * D) + c.dc[6] * Math.sin(m_ - f) + c.dc[7] * Math.sin(m_ + 2 * f) + c.dc[8] * Math.cos(f) + c.dc[9] * Math.sin(2 * D + m - f) * E + c.dc[10] * Math.sin(m_ + 3 * f) + c.dc[11] * Math.sin(D + f) + c.dc[12] * Math.sin(m_ - 2 * f) + c.dc[13] * Math.sin(2 * D - m - f) * E + c.dc[14] * Math.sin(2 * D - m_ - f) + c.dc[15] * Math.cos(m_ + f) + c.dc[16] * Math.cos(m_ + 2 * f) + c.dc[17] * Math.cos(2 * m_ + f) + c.dc[18] * Math.cos(m_ - 3 * f) + c.dc[19] * Math.cos(2 * m_ - f) + c.dc[20] * Math.cos(m_ - 2 * f) + c.dc[21] * Math.sin(2 * m_) + c.dc[22] * Math.sin(3 * m_ + f) + c.dc[23] * Math.cos(2 * D + m - f) * E + c.dc[24] * Math.cos(m_ - f) + c.dc[25] * Math.cos(3 * f) + c.dc[26] * Math.sin(2 * D + f) + c.dc[27] * Math.cos(m_ + 3 * f) + c.dc[28] * Math.cos(D + f) + c.dc[29] * Math.sin(2 * m_ - f) + c.dc[30] * Math.cos(3 * m_ + f) + c.dc[31] * Math.cos(2 * (D + m_) + f) + c.dc[32] * Math.sin(2 * (D - m_) - f) + c.dc[33] * Math.cos(2 * m_) + c.dc[34] * Math.cos(m_) + c.dc[35] * Math.sin(2 * f) + c.dc[36] * Math.sin(m_ + f);
    return {
        jde: jde,
        dec: c.s * \u03B4
    };
}
/**
 * north coefficients
 */ const $b2d591b289be7a7e$var$nc = {
    D: 152.2029 * $b2d591b289be7a7e$var$p,
    m: 14.8591 * $b2d591b289be7a7e$var$p,
    m_: 4.6881 * $b2d591b289be7a7e$var$p,
    f: 325.8867 * $b2d591b289be7a7e$var$p,
    JDE: 2451562.5897,
    s: 1,
    tc: [
        0.8975,
        -0.4726,
        -0.103,
        -0.0976,
        -0.0462,
        -0.0461,
        -0.0438,
        0.0162,
        -0.0157,
        0.0145,
        0.0136,
        -0.0095,
        -0.0091,
        -0.0089,
        0.0075,
        -0.0068,
        0.0061,
        -0.0047,
        -0.0043,
        -0.004,
        -0.0037,
        0.0031,
        0.0030,
        -0.0029,
        -0.0029,
        -0.0027,
        0.0024,
        -0.0021,
        0.0019,
        0.0018,
        0.0018,
        0.0017,
        0.0017,
        -0.0014,
        0.0013,
        0.0013,
        0.0012,
        0.0011,
        -0.0011,
        0.001,
        0.001,
        -0.0009,
        0.0007,
        -0.0007
    ],
    dc: [
        5.1093 * $b2d591b289be7a7e$var$p,
        0.2658 * $b2d591b289be7a7e$var$p,
        0.1448 * $b2d591b289be7a7e$var$p,
        -0.0322 * $b2d591b289be7a7e$var$p,
        0.0133 * $b2d591b289be7a7e$var$p,
        0.0125 * $b2d591b289be7a7e$var$p,
        -0.0124 * $b2d591b289be7a7e$var$p,
        -0.0101 * $b2d591b289be7a7e$var$p,
        0.0097 * $b2d591b289be7a7e$var$p,
        -0.0087 * $b2d591b289be7a7e$var$p,
        0.0074 * $b2d591b289be7a7e$var$p,
        0.0067 * $b2d591b289be7a7e$var$p,
        0.0063 * $b2d591b289be7a7e$var$p,
        0.0060 * $b2d591b289be7a7e$var$p,
        -0.0057 * $b2d591b289be7a7e$var$p,
        -0.0056 * $b2d591b289be7a7e$var$p,
        0.0052 * $b2d591b289be7a7e$var$p,
        0.0041 * $b2d591b289be7a7e$var$p,
        -0.004 * $b2d591b289be7a7e$var$p,
        0.0038 * $b2d591b289be7a7e$var$p,
        -0.0034 * $b2d591b289be7a7e$var$p,
        -0.0029 * $b2d591b289be7a7e$var$p,
        0.0029 * $b2d591b289be7a7e$var$p,
        -0.0028 * $b2d591b289be7a7e$var$p,
        -0.0028 * $b2d591b289be7a7e$var$p,
        -0.0023 * $b2d591b289be7a7e$var$p,
        -0.0021 * $b2d591b289be7a7e$var$p,
        0.0019 * $b2d591b289be7a7e$var$p,
        0.0018 * $b2d591b289be7a7e$var$p,
        0.0017 * $b2d591b289be7a7e$var$p,
        0.0015 * $b2d591b289be7a7e$var$p,
        0.0014 * $b2d591b289be7a7e$var$p,
        -0.0012 * $b2d591b289be7a7e$var$p,
        -0.0012 * $b2d591b289be7a7e$var$p,
        -0.001 * $b2d591b289be7a7e$var$p,
        -0.001 * $b2d591b289be7a7e$var$p,
        0.0006 * $b2d591b289be7a7e$var$p
    ]
};
/**
 * south coefficients
 */ const $b2d591b289be7a7e$var$sc = {
    D: 345.6676 * $b2d591b289be7a7e$var$p,
    m: 1.3951 * $b2d591b289be7a7e$var$p,
    m_: 186.21 * $b2d591b289be7a7e$var$p,
    f: 145.1633 * $b2d591b289be7a7e$var$p,
    JDE: 2451548.9289,
    s: -1,
    tc: [
        -0.8975,
        -0.4726,
        -0.103,
        -0.0976,
        0.0541,
        0.0516,
        -0.0438,
        0.0112,
        0.0157,
        0.0023,
        -0.0136,
        0.011,
        0.0091,
        0.0089,
        0.0075,
        -0.003,
        -0.0061,
        -0.0047,
        -0.0043,
        0.004,
        -0.0037,
        -0.0031,
        0.0030,
        0.0029,
        -0.0029,
        -0.0027,
        0.0024,
        -0.0021,
        -0.0019,
        -0.0006,
        -0.0018,
        -0.0017,
        0.0017,
        0.0014,
        -0.0013,
        -0.0013,
        0.0012,
        0.0011,
        0.0011,
        0.001,
        0.001,
        -0.0009,
        -0.0007,
        -0.0007
    ],
    dc: [
        -5.1093 * $b2d591b289be7a7e$var$p,
        0.2658 * $b2d591b289be7a7e$var$p,
        -0.1448 * $b2d591b289be7a7e$var$p,
        0.0322 * $b2d591b289be7a7e$var$p,
        0.0133 * $b2d591b289be7a7e$var$p,
        0.0125 * $b2d591b289be7a7e$var$p,
        -0.0015 * $b2d591b289be7a7e$var$p,
        0.0101 * $b2d591b289be7a7e$var$p,
        -0.0097 * $b2d591b289be7a7e$var$p,
        0.0087 * $b2d591b289be7a7e$var$p,
        0.0074 * $b2d591b289be7a7e$var$p,
        0.0067 * $b2d591b289be7a7e$var$p,
        -0.0063 * $b2d591b289be7a7e$var$p,
        -0.006 * $b2d591b289be7a7e$var$p,
        0.0057 * $b2d591b289be7a7e$var$p,
        -0.0056 * $b2d591b289be7a7e$var$p,
        -0.0052 * $b2d591b289be7a7e$var$p,
        -0.0041 * $b2d591b289be7a7e$var$p,
        -0.004 * $b2d591b289be7a7e$var$p,
        -0.0038 * $b2d591b289be7a7e$var$p,
        0.0034 * $b2d591b289be7a7e$var$p,
        -0.0029 * $b2d591b289be7a7e$var$p,
        0.0029 * $b2d591b289be7a7e$var$p,
        0.0028 * $b2d591b289be7a7e$var$p,
        -0.0028 * $b2d591b289be7a7e$var$p,
        0.0023 * $b2d591b289be7a7e$var$p,
        0.0021 * $b2d591b289be7a7e$var$p,
        0.0019 * $b2d591b289be7a7e$var$p,
        0.0018 * $b2d591b289be7a7e$var$p,
        -0.0017 * $b2d591b289be7a7e$var$p,
        0.0015 * $b2d591b289be7a7e$var$p,
        0.0014 * $b2d591b289be7a7e$var$p,
        0.0012 * $b2d591b289be7a7e$var$p,
        -0.0012 * $b2d591b289be7a7e$var$p,
        0.001 * $b2d591b289be7a7e$var$p,
        -0.001 * $b2d591b289be7a7e$var$p,
        0.0037 * $b2d591b289be7a7e$var$p
    ]
};
var $b2d591b289be7a7e$export$2e2bcd8739ae039 = {
    north: $b2d591b289be7a7e$export$27475a238f11763a,
    south: $b2d591b289be7a7e$export$de7ad725f88394c4
};


/**
 * @copyright 2013 Sonia Keys
 * @copyright 2016 commenthol
 * @license MIT
 * @module moonnode
 */ /**
 * Moonnode: Chapter 51, Passages of the Moon through the Nodes.
 */ 
var $9QpM5 = parcelRequire("9QpM5");
function $8ae8900e1bfb41ff$export$fcb633242ef15540(year) {
    return $8ae8900e1bfb41ff$var$node(year, 0);
}
function $8ae8900e1bfb41ff$export$4fa3190a997c3d8f(year) {
    return $8ae8900e1bfb41ff$var$node(year, 0.5);
}
/**
 * @private
 */ function $8ae8900e1bfb41ff$var$node(y, h) {
    let k = (y - 2000.05) * 13.4223 // (50.1) p. 355
    ;
    k = Math.floor(k - h + 0.5) + h // snap to half orbit
    ;
    const p = Math.PI / 180;
    const ck = 1 / 1342.23;
    const T = k * ck;
    const D = (0, $9QpM5.default).horner(T, 183.638 * p, 331.73735682 * p / ck, 0.0014852 * p, 0.00000209 * p, -0.00000001 * p);
    const M = (0, $9QpM5.default).horner(T, 17.4006 * p, 26.8203725 * p / ck, 0.0001186 * p, 0.00000006 * p);
    const m_ = (0, $9QpM5.default).horner(T, 38.3776 * p, 355.52747313 * p / ck, 0.0123499 * p, 0.000014627 * p, -0.000000069 * p);
    const \u03A9 = (0, $9QpM5.default).horner(T, 123.9767 * p, -1.44098956 * p / ck, 0.0020608 * p, 0.00000214 * p, -0.000000016 * p);
    const V = (0, $9QpM5.default).horner(T, 299.75 * p, 132.85 * p, -0.009173 * p);
    const P = \u03A9 + 272.75 * p - 2.3 * p * T;
    const E = (0, $9QpM5.default).horner(T, 1, -0.002516, -0.0000074);
    return (0, $9QpM5.default).horner(T, 2451565.1619, 27.212220817 / ck, 0.0002762, 0.000000021, -0.000000000088) + -0.4721 * Math.sin(m_) + -0.1649 * Math.sin(2 * D) + -0.0868 * Math.sin(2 * D - m_) + 0.0084 * Math.sin(2 * D + m_) + -0.0083 * Math.sin(2 * D - M) * E + -0.0039 * Math.sin(2 * D - M - m_) * E + 0.0034 * Math.sin(2 * m_) + -0.0031 * Math.sin(2 * (D - m_)) + 0.003 * Math.sin(2 * D + M) * E + 0.0028 * Math.sin(M - m_) * E + 0.0026 * Math.sin(M) * E + 0.0025 * Math.sin(4 * D) + 0.0024 * Math.sin(D) + 0.0022 * Math.sin(M + m_) * E + 0.0017 * Math.sin(\u03A9) + 0.0014 * Math.sin(4 * D - m_) + 0.0005 * Math.sin(2 * D + M - m_) * E + 0.0004 * Math.sin(2 * D - M + m_) * E + -0.0003 * Math.sin(2 * (D - M)) * E + 0.0003 * Math.sin(4 * D - M) * E + 0.0003 * Math.sin(V) + 0.0003 * Math.sin(P);
}
var $8ae8900e1bfb41ff$export$2e2bcd8739ae039 = {
    ascending: $8ae8900e1bfb41ff$export$fcb633242ef15540,
    descending: $8ae8900e1bfb41ff$export$4fa3190a997c3d8f
};




/**
 * @copyright 2013 Sonia Keys
 * @copyright 2016 commenthol
 * @license MIT
 * @module parabolic
 */ /**
 * Parabolic: Chapter 34, Parabolic Motion.
 */ 
var $9QpM5 = parcelRequire("9QpM5");
class $de8e3326ff25a0c2$export$3abb4be70fa2c84e {
    /**
   * @param {Number} timeP - time of perihelion, T
   * @param {Number} pDis - perihelion distance, q
   */ constructor(timeP, pDis){
        this.timeP = timeP;
        this.pDis = pDis;
    }
    /**
   * AnomalyDistance returns true anomaly and distance of a body in a parabolic orbit of the Sun.
   *
   * @param {Number} jde - Julian ephemeris day
   * @returns {Object} {ano, dist}
   *   {Number} ano - True anomaly ν in radians.
   *   {Number} dist - Distance r returned in AU.
   */ anomalyDistance(jde) {
        const W = 3 * (0, $9QpM5.default).K / Math.SQRT2 * (jde - this.timeP) / this.pDis / Math.sqrt(this.pDis);
        const G = W * 0.5;
        const Y = Math.cbrt(G + Math.sqrt(G * G + 1));
        const s = Y - 1 / Y;
        const \u03BD = 2 * Math.atan(s);
        const r = this.pDis * (1 + s * s);
        return {
            ano: \u03BD,
            dist: r
        };
    }
}
var $de8e3326ff25a0c2$export$2e2bcd8739ae039 = {
    Elements: $de8e3326ff25a0c2$export$3abb4be70fa2c84e
};


/**
 * @copyright 2013 Sonia Keys
 * @copyright 2016 commenthol
 * @license MIT
 * @module parallax
 */ /**
 * Parallax: Chapter 40, Correction for Parallax.
 */ 
var $9QpM5 = parcelRequire("9QpM5");

/**
 * @copyright 2013 Sonia Keys
 * @copyright 2016 commenthol
 * @license MIT
 * @module sidereal
 */ /**
 * Sidereal: Chapter 12, Sidereal Time at Greenwich.
 */ 
var $9QpM5 = parcelRequire("9QpM5");

function $15a74672f869bd9f$export$b6d55a22b99dd3ca(jd) {
    const [j0, f] = (0, $9QpM5.default).modf(jd + 0.5);
    return [
        (0, $9QpM5.default).J2000Century(j0 - 0.5),
        f
    ] // (cen, dayFrac /* float */)
    ;
}
const $15a74672f869bd9f$export$a5aca795efa74167 = [
    24110.54841,
    8640184.812866,
    0.093104,
    -0.0000062
];
function $15a74672f869bd9f$export$1ce691f85baaa52(jd) {
    return (0, $9QpM5.default).pmod($15a74672f869bd9f$var$_mean(jd), 86400);
}
/**
 * @private
 */ function $15a74672f869bd9f$var$_mean(jd) {
    const [s, f] = $15a74672f869bd9f$var$_mean0UT(jd);
    return s + f * 86636.55536784;
}
function $15a74672f869bd9f$export$3cfac6ad94781c(jd /* float */ ) {
    const [s, _] = $15a74672f869bd9f$var$_mean0UT(jd) // eslint-disable-line
    ;
    return (0, $9QpM5.default).pmod(s, 86400);
}
/**
 * @private
 */ function $15a74672f869bd9f$var$_mean0UT(jd /* float */ ) {
    const [cen, f] = $15a74672f869bd9f$export$b6d55a22b99dd3ca(jd);
    // (12.2) p. 87
    return [
        (0, $9QpM5.default).horner(cen, ...$15a74672f869bd9f$export$a5aca795efa74167),
        f
    ] // (sidereal, dayFrac /* float */)
    ;
}
function $15a74672f869bd9f$export$196d5d5cca980f6d(jd) {
    const s = $15a74672f869bd9f$var$_mean(jd) // seconds of time
    ;
    const n = (0, $c50a9505be5a627c$export$2e2bcd8739ae039).nutationInRA(jd) // angle (radians) of RA
    ;
    const ns = n * 648000 / Math.PI / 15 // convert RA to time in seconds
    ;
    return (0, $9QpM5.default).pmod(s + ns, 86400);
}
function $15a74672f869bd9f$export$316964b8d57b0e40(jd) {
    const [j0, f] = (0, $9QpM5.default).modf(jd + 0.5);
    const cen = (j0 - 0.5 - (0, $9QpM5.default).J2000) / 36525;
    const s = (0, $9QpM5.default).horner(cen, ...$15a74672f869bd9f$export$a5aca795efa74167) + f * 86636.55536784;
    const n = (0, $c50a9505be5a627c$export$2e2bcd8739ae039).nutationInRA(j0) // angle (radians) of RA
    ;
    const ns = n * 648000 / Math.PI / 15 // convert RA to time in seconds
    ;
    return (0, $9QpM5.default).pmod(s + ns, 86400);
}
var $15a74672f869bd9f$export$2e2bcd8739ae039 = {
    JDToCFrac: $15a74672f869bd9f$export$b6d55a22b99dd3ca,
    iau82: $15a74672f869bd9f$export$a5aca795efa74167,
    mean: $15a74672f869bd9f$export$1ce691f85baaa52,
    mean0UT: $15a74672f869bd9f$export$3cfac6ad94781c,
    apparent: $15a74672f869bd9f$export$196d5d5cca980f6d,
    apparent0UT: $15a74672f869bd9f$export$316964b8d57b0e40
};



const $96df6ed80680fe1d$var$horPar = 8.794 / 3600 * Math.PI / 180 // 8".794 arcseconds in radians
;
function $96df6ed80680fe1d$export$641ecd0b2bc39508(\u0394) {
    // (40.1) p. 279
    return Math.asin(Math.sin($96df6ed80680fe1d$var$horPar) / \u0394);
// return horPar / Δ // with sufficient accuracy
}
function $96df6ed80680fe1d$export$65465a986b74f25f(c, \u03C1s\u03C6, \u03C1c\u03C6, lon, jde) {
    const [\u03B1, \u03B4, \u0394] = [
        c.ra,
        c.dec,
        c.range
    ];
    const \u03C0 = $96df6ed80680fe1d$export$641ecd0b2bc39508(\u0394);
    const \u03B80 = new (0, $c953199d551a315b$export$2e2bcd8739ae039).Time((0, $15a74672f869bd9f$export$2e2bcd8739ae039).apparent(jde)).rad();
    const H = (0, $9QpM5.default).pmod(\u03B80 - lon - \u03B1, 2 * Math.PI);
    const s\u03C0 = Math.sin(\u03C0);
    const [sH, cH] = (0, $9QpM5.default).sincos(H);
    const [s\u03B4, c\u03B4] = (0, $9QpM5.default).sincos(\u03B4);
    const \u0394\u03B1 = Math.atan2(-\u03C1c\u03C6 * s\u03C0 * sH, c\u03B4 - \u03C1c\u03C6 * s\u03C0 * cH) // (40.2) p. 279
    ;
    const \u03B1_ = \u03B1 + \u0394\u03B1;
    const \u03B4_ = Math.atan2((s\u03B4 - \u03C1s\u03C6 * s\u03C0) * Math.cos(\u0394\u03B1), c\u03B4 - \u03C1c\u03C6 * s\u03C0 * cH) // (40.3) p. 279
    ;
    return new (0, $9QpM5.Coord)(\u03B1_, \u03B4_);
}
function $96df6ed80680fe1d$export$964876fa5c1a1b5b(c, \u03C1s\u03C6, \u03C1c\u03C6, lon, jde) {
    const [\u03B1, \u03B4, \u0394] = [
        c.ra,
        c.dec,
        c.range
    ];
    const \u03C0 = $96df6ed80680fe1d$export$641ecd0b2bc39508(\u0394);
    const \u03B80 = new (0, $c953199d551a315b$export$2e2bcd8739ae039).Time((0, $15a74672f869bd9f$export$2e2bcd8739ae039).apparent(jde)).rad();
    const H = (0, $9QpM5.default).pmod(\u03B80 - lon - \u03B1, 2 * Math.PI);
    const [sH, cH] = (0, $9QpM5.default).sincos(H);
    const [s\u03B4, c\u03B4] = (0, $9QpM5.default).sincos(\u03B4);
    const \u0394\u03B1 = -\u03C0 * \u03C1c\u03C6 * sH / c\u03B4 // (40.4) p. 280
    ;
    const \u0394\u03B4 = -\u03C0 * (\u03C1s\u03C6 * c\u03B4 - \u03C1c\u03C6 * cH * s\u03B4 // (40.5) p. 280
    );
    return new (0, $9QpM5.default).Coord(\u0394\u03B1, \u0394\u03B4);
}
function $96df6ed80680fe1d$export$3329b4836d860afa(c, \u03C1s\u03C6, \u03C1c\u03C6, lon, jde) {
    const [\u03B1, \u03B4, \u0394] = [
        c.ra,
        c.dec,
        c.range
    ];
    const \u03C0 = $96df6ed80680fe1d$export$641ecd0b2bc39508(\u0394);
    const \u03B80 = new (0, $c953199d551a315b$export$2e2bcd8739ae039).Time((0, $15a74672f869bd9f$export$2e2bcd8739ae039).apparent(jde)).rad();
    const H = (0, $9QpM5.default).pmod(\u03B80 - lon - \u03B1, 2 * Math.PI);
    const s\u03C0 = Math.sin(\u03C0);
    const [sH, cH] = (0, $9QpM5.default).sincos(H);
    const [s\u03B4, c\u03B4] = (0, $9QpM5.default).sincos(\u03B4);
    const A = c\u03B4 * sH;
    const B = c\u03B4 * cH - \u03C1c\u03C6 * s\u03C0;
    const C = s\u03B4 - \u03C1s\u03C6 * s\u03C0;
    const q = Math.sqrt(A * A + B * B + C * C);
    const H_ = Math.atan2(A, B);
    const \u03B4_ = Math.asin(C / q);
    return [
        H_,
        \u03B4_
    ];
}
function $96df6ed80680fe1d$export$2283745bcac25a1b(c, s, \u03C6, h, \u03B5, \u03B8, \u03C0) {
    const [\u03BB, \u03B2] = [
        c.lon,
        c.lat
    ];
    const [S, C] = (0, $4901b270ff8bc2d1$export$2e2bcd8739ae039).Earth76.parallaxConstants(\u03C6, h);
    const [s\u03BB, c\u03BB] = (0, $9QpM5.default).sincos(\u03BB);
    const [s\u03B2, c\u03B2] = (0, $9QpM5.default).sincos(\u03B2);
    const [s\u03B5, c\u03B5] = (0, $9QpM5.default).sincos(\u03B5);
    const [s\u03B8, c\u03B8] = (0, $9QpM5.default).sincos(\u03B8);
    const s\u03C0 = Math.sin(\u03C0);
    const N = c\u03BB * c\u03B2 - C * s\u03C0 * c\u03B8;
    let \u03BB_ = Math.atan2(s\u03BB * c\u03B2 - s\u03C0 * (S * s\u03B5 + C * c\u03B5 * s\u03B8), N);
    if (\u03BB_ < 0) \u03BB_ += 2 * Math.PI;
    const c\u03BB_ = Math.cos(\u03BB_);
    const \u03B2_ = Math.atan(c\u03BB_ * (s\u03B2 - s\u03C0 * (S * c\u03B5 - C * s\u03B5 * s\u03B8)) / N);
    const s_ = Math.asin(c\u03BB_ * Math.cos(\u03B2_) * Math.sin(s) / N);
    return [
        \u03BB_,
        \u03B2_,
        s_
    ];
}
var $96df6ed80680fe1d$export$2e2bcd8739ae039 = {
    horizontal: $96df6ed80680fe1d$export$641ecd0b2bc39508,
    topocentric: $96df6ed80680fe1d$export$65465a986b74f25f,
    topocentric2: $96df6ed80680fe1d$export$964876fa5c1a1b5b,
    topocentric3: $96df6ed80680fe1d$export$3329b4836d860afa,
    topocentricEcliptical: $96df6ed80680fe1d$export$2283745bcac25a1b
};


/**
 * @copyright 2013 Sonia Keys
 * @copyright 2016 commenthol
 * @license MIT
 * @module parallactic
 */ /**
 * Parallactic: Chapter 14, The Parallactic Angle, and three other Topics.
 */ 
var $9QpM5 = parcelRequire("9QpM5");
function $5a5dd9c0d8c78dd0$export$31396d5f0617b7e5(\u03C6, \u03B4, H) {
    const [s\u03B4, c\u03B4] = (0, $9QpM5.default).sincos(\u03B4);
    const [sH, cH] = (0, $9QpM5.default).sincos(H);
    return Math.atan2(sH, Math.tan(\u03C6) * c\u03B4 - s\u03B4 * cH) // (14.1) p. 98
    ;
}
function $5a5dd9c0d8c78dd0$export$a49bd946a3c45e98(\u03C6, \u03B4) {
    return Math.acos(Math.sin(\u03C6) / Math.cos(\u03B4));
}
function $5a5dd9c0d8c78dd0$export$6005c58f45e89e02(\u03B5, \u03C6, \u03B8) {
    const [s\u03B5, c\u03B5] = (0, $9QpM5.default).sincos(\u03B5);
    const [s\u03C6, c\u03C6] = (0, $9QpM5.default).sincos(\u03C6);
    const [s\u03B8, c\u03B8] = (0, $9QpM5.default).sincos(\u03B8);
    let \u03BB = Math.atan2(-c\u03B8, s\u03B5 * (s\u03C6 / c\u03C6) + c\u03B5 * s\u03B8) // (14.2) p. 99
    ;
    if (\u03BB < 0) \u03BB += Math.PI;
    return [
        \u03BB,
        \u03BB + Math.PI,
        Math.acos(c\u03B5 * s\u03C6 - s\u03B5 * c\u03C6 * s\u03B8)
    ] // (14.3) p. 99
    ;
}
function $5a5dd9c0d8c78dd0$export$2ce85acb27e101c(\u03BB, \u03B5) {
    return Math.atan(-Math.cos(\u03BB) * Math.tan(\u03B5));
}
function $5a5dd9c0d8c78dd0$export$ede699f4660b98a3(\u03B4, \u03C6) {
    const t\u03C6 = Math.tan(\u03C6);
    const b = Math.tan(\u03B4) * t\u03C6;
    const c = Math.sqrt(1 - b * b);
    return Math.atan(c * Math.cos(\u03B4) / t\u03C6);
}
var $5a5dd9c0d8c78dd0$export$2e2bcd8739ae039 = {
    parallacticAngle: $5a5dd9c0d8c78dd0$export$31396d5f0617b7e5,
    parallacticAngleOnHorizon: $5a5dd9c0d8c78dd0$export$a49bd946a3c45e98,
    eclipticAtHorizon: $5a5dd9c0d8c78dd0$export$6005c58f45e89e02,
    eclipticAtEquator: $5a5dd9c0d8c78dd0$export$2ce85acb27e101c,
    diurnalPathAtHorizon: $5a5dd9c0d8c78dd0$export$ede699f4660b98a3
};


/* eslint-disable n/no-callback-literal */ /**
 * @copyright 2013 Sonia Keys
 * @copyright 2016 commenthol
 * @license MIT
 * @module perihelion
 */ /**
 * Perihelion: Chapter 38, Planets in Perihelion and Aphelion.
 *
 * Functions Aphelion and Perihelion implement algorithms from the book
 * to return approximate results.
 *
 * For accurate results, Meeus describes the general technique of
 * interpolating from a precise ephemeris but does not give a complete
 * algorithm.  The algorithm implemented here for Aphelion2 and Perihelion2
 * is to start with the approximate result and then crawl along the curve
 * at the specified time resolution until the desired extremum is found.
 * This algorithm slows down as higher accuracy is demanded.  1 day accuracy
 * is generally quick for planets other than Neptune.
 *
 * Meeus doesn't give an algorithm to handle the double extrema of Neptune.
 * The algorithm here is to pick starting points several years either side
 * of the approximate date and follow the slopes inward.  The consequence of
 * starting farther from the extremum is that these functions are particularly
 * slow for Neptune.  They are offered here though as a simple implementation
 * of Meeus's presentation in the book.
 */ 
var $9QpM5 = parcelRequire("9QpM5");


/**
 * Planet constants for first argument of Perihelion and Aphelion functions.
 * @enum {number}
 */ const $3e25336275dd6c20$var$planetsEnum = {
    mercury: 0,
    venus: 1,
    earth: 2,
    mars: 3,
    jupiter: 4,
    saturn: 5,
    uranus: 6,
    neptune: 7,
    embary: 8
};
const $3e25336275dd6c20$export$35a4f18dc3a22ac8 = $3e25336275dd6c20$var$planetsEnum.mercury;
const $3e25336275dd6c20$export$7200842790f06d68 = $3e25336275dd6c20$var$planetsEnum.venus;
const $3e25336275dd6c20$export$fa783d5dd5198ae3 = $3e25336275dd6c20$var$planetsEnum.earth;
const $3e25336275dd6c20$export$9400e8fb899a485a = $3e25336275dd6c20$var$planetsEnum.mars;
const $3e25336275dd6c20$export$8e9760ab551a9bc7 = $3e25336275dd6c20$var$planetsEnum.jupiter;
const $3e25336275dd6c20$export$9ca5fcb91cfa691f = $3e25336275dd6c20$var$planetsEnum.saturn;
const $3e25336275dd6c20$export$7133e45f08d551bc = $3e25336275dd6c20$var$planetsEnum.uranus;
const $3e25336275dd6c20$export$335a11867ede73d = $3e25336275dd6c20$var$planetsEnum.neptune;
const $3e25336275dd6c20$export$847d40d4fd71752d = $3e25336275dd6c20$var$planetsEnum.embary;
function $3e25336275dd6c20$export$407dd2a47a94200d(p, year) {
    return $3e25336275dd6c20$var$ap(p, year, false, $3e25336275dd6c20$var$pf);
}
function $3e25336275dd6c20$export$2a498cdfa6a8b27c(p, year) {
    return $3e25336275dd6c20$var$ap(p, year, true, $3e25336275dd6c20$var$af);
}
const $3e25336275dd6c20$var$pf = function(x) {
    return Math.floor(x + 0.5);
};
const $3e25336275dd6c20$var$af = function(x) {
    return Math.floor(x) + 0.5;
};
const $3e25336275dd6c20$var$ap = function(p, y, a, f) {
    let i = p;
    if (i === $3e25336275dd6c20$export$847d40d4fd71752d) i = $3e25336275dd6c20$export$fa783d5dd5198ae3;
    const k = f($3e25336275dd6c20$var$ka[i].a * (y - $3e25336275dd6c20$var$ka[i].b));
    let j = (0, $9QpM5.default).horner(k, ...$3e25336275dd6c20$var$c[i]);
    if (p === $3e25336275dd6c20$export$fa783d5dd5198ae3) {
        let c = $3e25336275dd6c20$var$ep;
        if (a) c = $3e25336275dd6c20$var$ea;
        for(let i = 0; i < 5; i++)j += c[i] * Math.sin(($3e25336275dd6c20$var$ec[i].a + $3e25336275dd6c20$var$ec[i].b * k) * Math.PI / 180);
    }
    return j;
};
const $3e25336275dd6c20$var$ka = [
    {
        a: 4.15201,
        b: 2000.12
    },
    {
        a: 1.62549,
        b: 2000.53
    },
    {
        a: 0.99997,
        b: 2000.01
    },
    {
        a: 0.53166,
        b: 2001.78
    },
    {
        a: 0.0843,
        b: 2011.2
    },
    {
        a: 0.03393,
        b: 2003.52
    },
    {
        a: 0.0119,
        b: 2051.1
    },
    {
        a: 0.00607,
        b: 2047.5
    } // neptune
];
const $3e25336275dd6c20$var$c = [
    [
        2451590.257,
        87.96934963
    ],
    [
        2451738.233,
        224.7008188,
        -0.0000000327
    ],
    [
        2451547.507,
        365.2596358,
        0.0000000156
    ],
    [
        2452195.026,
        686.9957857,
        -0.0000001187
    ],
    [
        2455636.936,
        4332.897065,
        0.0001367
    ],
    [
        2452830.12,
        10764.21676,
        0.000827
    ],
    [
        2470213.5,
        30694.8767,
        -0.00541
    ],
    [
        2468895.1,
        60190.33,
        0.03429
    ] // neptune
];
const $3e25336275dd6c20$var$ec = [
    {
        a: 328.41,
        b: 132.788585
    },
    {
        a: 316.13,
        b: 584.903153
    },
    {
        a: 346.2,
        b: 450.380738
    },
    {
        a: 136.95,
        b: 659.306737
    },
    {
        a: 249.52,
        b: 329.653368
    }
];
const $3e25336275dd6c20$var$ep = [
    1.278,
    -0.055,
    -0.091,
    -0.056,
    -0.045
];
const $3e25336275dd6c20$var$ea = [
    -1.352,
    0.061,
    0.062,
    0.029,
    0.031
];
function $3e25336275dd6c20$export$6e282f8087c432ac(planet, year, precision, cb) {
    return $3e25336275dd6c20$var$ap2($3e25336275dd6c20$var$planetsEnum[planet.name], year, precision, planet, false, $3e25336275dd6c20$var$pf, cb);
}
function $3e25336275dd6c20$export$f02309d481e2cd4c(planet, year, precision, cb) {
    return $3e25336275dd6c20$var$ap2($3e25336275dd6c20$var$planetsEnum[planet.name], year, precision, planet, true, $3e25336275dd6c20$var$af, cb);
}
if (typeof setImmediate !== 'function') {
    const setImmediate1 = setTimeout // eslint-disable-line no-unused-vars
    ;
}
const $3e25336275dd6c20$var$ap2 = function(p, y, d, v, a, f, cb) {
    const j1 = $3e25336275dd6c20$var$ap(p, y, a, f);
    if (p !== $3e25336275dd6c20$export$335a11867ede73d) return $3e25336275dd6c20$var$ap2a(j1, d, a, v, cb);
    // handle the double extrema of Neptune
    if (cb) $3e25336275dd6c20$var$ap2a(j1 - 5000, d, a, v, ([j0, r0])=>{
        $3e25336275dd6c20$var$ap2a(j1 + 5000, d, a, v, ([j2, r2])=>{
            if (r0 > r2 === a) {
                cb([
                    j0,
                    r0
                ]);
                return;
            }
            cb([
                j2,
                r2
            ]);
        });
    });
    else {
        const [j0, r0] = $3e25336275dd6c20$var$ap2a(j1 - 5000, d, a, v);
        const [j2, r2] = $3e25336275dd6c20$var$ap2a(j1 + 5000, d, a, v);
        if (r0 > r2 === a) return [
            j0,
            r0
        ];
        return [
            j2,
            r2
        ];
    }
};
const $3e25336275dd6c20$var$ap2a = function(j1, d, a, v, cb) {
    let j0 = j1 - d;
    let j2 = j1 + d;
    const rr = new Array(3);
    rr[1] = v.position2000(j1).range;
    rr[0] = v.position2000(j0).range;
    rr[2] = v.position2000(j2).range;
    function end() {
        const l = new (0, $7480a29e66a7d324$export$2e2bcd8739ae039).Len3(j0, j2, rr);
        const [jde, r] = l.extremum();
        return [
            jde,
            r
        ];
    }
    function run() {
        if (a) {
            if (rr[1] > rr[0] && rr[1] > rr[2]) {
                cb && cb(end());
                return true;
            }
        } else if (rr[1] < rr[0] && rr[1] < rr[2]) {
            cb && cb(end());
            return true;
        }
        if (rr[0] < rr[2] === a) {
            j0 = j1;
            j1 = j2;
            j2 += d;
            rr[0] = rr[1];
            rr[1] = rr[2];
            rr[2] = v.position2000(j2).range;
        } else {
            j2 = j1;
            j1 = j0;
            j0 -= d;
            rr[2] = rr[1];
            rr[1] = rr[0];
            rr[0] = v.position2000(j0).range;
        }
        if (cb) setImmediate(run, 0);
    }
    if (cb) run();
    else for(;;){
        if (run()) return end();
    }
};
var $3e25336275dd6c20$export$2e2bcd8739ae039 = {
    mercury: $3e25336275dd6c20$export$35a4f18dc3a22ac8,
    venus: $3e25336275dd6c20$export$7200842790f06d68,
    earth: $3e25336275dd6c20$export$fa783d5dd5198ae3,
    mars: $3e25336275dd6c20$export$9400e8fb899a485a,
    jupiter: $3e25336275dd6c20$export$8e9760ab551a9bc7,
    saturn: $3e25336275dd6c20$export$9ca5fcb91cfa691f,
    uranus: $3e25336275dd6c20$export$7133e45f08d551bc,
    neptune: $3e25336275dd6c20$export$335a11867ede73d,
    embary: $3e25336275dd6c20$export$847d40d4fd71752d,
    perihelion: $3e25336275dd6c20$export$407dd2a47a94200d,
    aphelion: $3e25336275dd6c20$export$2a498cdfa6a8b27c,
    perihelion2: $3e25336275dd6c20$export$6e282f8087c432ac,
    aphelion2: $3e25336275dd6c20$export$f02309d481e2cd4c
};


/**
 * @copyright 2013 Sonia Keys
 * @copyright 2016 commenthol
 * @license MIT
 * @module planetary
 */ /**
 * Planetary: Chapter 36, The Calculation of some Planetary Phenomena.
 *
 * Incomplete: Some functions unimplemented for lack of test data.
 */ 
var $9QpM5 = parcelRequire("9QpM5");
function $a7c3a003cefc5494$export$1ce691f85baaa52(y, a) {
    // (36.1) p. 250
    const k = Math.floor((365.2425 * y + 1721060 - a.A) / a.B + 0.5);
    const J = a.A + k * a.B;
    const M = (0, $9QpM5.default).pmod(a.M0 + k * a.M1, 360) * Math.PI / 180;
    const T = (0, $9QpM5.default).J2000Century(J);
    return [
        J,
        M,
        T
    ];
}
function $a7c3a003cefc5494$export$8a63f25cc62965f1(T, M, c) {
    let j = (0, $9QpM5.default).horner(T, c[0]);
    let mm = 0.0;
    for(let i = 1; i < c.length; i++){
        mm += M;
        const [smm, cmm] = (0, $9QpM5.default).sincos(mm);
        j += smm * (0, $9QpM5.default).horner(T, c[i]);
        i++;
        j += cmm * (0, $9QpM5.default).horner(T, c[i]);
    }
    return j;
}
function $a7c3a003cefc5494$export$5dd2165da01bec80(y, a, c) {
    const [J, M, T] = $a7c3a003cefc5494$export$1ce691f85baaa52(y, a);
    return J + $a7c3a003cefc5494$export$8a63f25cc62965f1(T, M, c);
}
function $a7c3a003cefc5494$export$76169c43d3938300(y) {
    return $a7c3a003cefc5494$export$5dd2165da01bec80(y, $a7c3a003cefc5494$var$micA, $a7c3a003cefc5494$var$micB);
}
function $a7c3a003cefc5494$export$ce8977aa2d00bfc8(y) {
    return $a7c3a003cefc5494$export$5dd2165da01bec80(y, $a7c3a003cefc5494$var$mscA, $a7c3a003cefc5494$var$mscB);
}
function $a7c3a003cefc5494$export$30a7d2600c8d62e4(y) {
    return $a7c3a003cefc5494$export$5dd2165da01bec80(y, $a7c3a003cefc5494$var$vicA, $a7c3a003cefc5494$var$vicB);
}
function $a7c3a003cefc5494$export$59bd7cf55aa25e8b(y) {
    return $a7c3a003cefc5494$export$5dd2165da01bec80(y, $a7c3a003cefc5494$var$moA, $a7c3a003cefc5494$var$moB);
}
function $a7c3a003cefc5494$export$266f75ba0609eb7f(T, M, c, aa) {
    let i = c.length - 2 * aa.length;
    let j = $a7c3a003cefc5494$export$8a63f25cc62965f1(T, M, c.slice(0, i));
    for(let k = 0; k < aa.length; k++){
        const [saa, caa] = (0, $9QpM5.default).sincos((aa[k].c + aa[k].f * T) * Math.PI / 180);
        j += saa * (0, $9QpM5.default).horner(T, c[i]);
        i++;
        j += caa * (0, $9QpM5.default).horner(T, c[i]);
        i++;
    }
    return j;
}
function $a7c3a003cefc5494$export$47f8b53ac5f243ba(y, a, c, aa) {
    const [J, M, T] = $a7c3a003cefc5494$export$1ce691f85baaa52(y, a);
    return J + $a7c3a003cefc5494$export$266f75ba0609eb7f(T, M, c, aa);
}
function $a7c3a003cefc5494$export$e488a03fbb892bbb(y) {
    return $a7c3a003cefc5494$export$47f8b53ac5f243ba(y, $a7c3a003cefc5494$var$joA, $a7c3a003cefc5494$var$joB, $a7c3a003cefc5494$var$jaa);
}
function $a7c3a003cefc5494$export$a1bbd71c5a147da5(y) {
    return $a7c3a003cefc5494$export$47f8b53ac5f243ba(y, $a7c3a003cefc5494$var$soA, $a7c3a003cefc5494$var$soB, $a7c3a003cefc5494$var$saa);
}
function $a7c3a003cefc5494$export$ac01cbb39f932caf(y) {
    return $a7c3a003cefc5494$export$47f8b53ac5f243ba(y, $a7c3a003cefc5494$var$scA, $a7c3a003cefc5494$var$scB, $a7c3a003cefc5494$var$saa);
}
function $a7c3a003cefc5494$export$1b6838cdb8229aa(y) {
    return $a7c3a003cefc5494$export$47f8b53ac5f243ba(y, $a7c3a003cefc5494$var$uoA, $a7c3a003cefc5494$var$uoB, $a7c3a003cefc5494$var$uaa);
}
function $a7c3a003cefc5494$export$5ade32f1596c5ce5(y) {
    return $a7c3a003cefc5494$export$47f8b53ac5f243ba(y, $a7c3a003cefc5494$var$noA, $a7c3a003cefc5494$var$noB, $a7c3a003cefc5494$var$naa);
}
function $a7c3a003cefc5494$export$c3da0dad1b44eea9(y, a, t, e) {
    const [J, M, T] = $a7c3a003cefc5494$export$1ce691f85baaa52(y, $a7c3a003cefc5494$var$micA);
    return [
        J + $a7c3a003cefc5494$export$8a63f25cc62965f1(T, M, t),
        $a7c3a003cefc5494$export$8a63f25cc62965f1(T, M, e) * Math.PI / 180
    ];
}
function $a7c3a003cefc5494$export$3754c8e7f6b36bf6(y) {
    return $a7c3a003cefc5494$export$c3da0dad1b44eea9(y, $a7c3a003cefc5494$var$micA, $a7c3a003cefc5494$var$met, $a7c3a003cefc5494$var$mee);
}
function $a7c3a003cefc5494$export$30ea0c285180713e(y) {
    return $a7c3a003cefc5494$export$c3da0dad1b44eea9(y, $a7c3a003cefc5494$var$micA, $a7c3a003cefc5494$var$mwt, $a7c3a003cefc5494$var$mwe);
}
function $a7c3a003cefc5494$export$3015313126dcb245(y) {
    const [J, M, T] = $a7c3a003cefc5494$export$1ce691f85baaa52(y, $a7c3a003cefc5494$var$moA);
    return J + $a7c3a003cefc5494$export$8a63f25cc62965f1(T, M, $a7c3a003cefc5494$var$ms2);
}
/**
 * ca holds coefficients from one line of table 36.A, p. 250
 */ function $a7c3a003cefc5494$var$Ca(A, B, M0, M1) {
    this.A = A;
    this.B = B;
    this.M0 = M0;
    this.M1 = M1;
}
/**
 * Table 36.A, p. 250
 */ const $a7c3a003cefc5494$var$micA = new $a7c3a003cefc5494$var$Ca(2451612.023, 115.8774771, 63.5867, 114.2088742);
const $a7c3a003cefc5494$var$mscA = new $a7c3a003cefc5494$var$Ca(2451554.084, 115.8774771, 6.4822, 114.2088742);
const $a7c3a003cefc5494$var$vicA = new $a7c3a003cefc5494$var$Ca(2451996.706, 583.921361, 82.7311, 215.513058);
const $a7c3a003cefc5494$var$moA = new $a7c3a003cefc5494$var$Ca(2452097.382, 779.936104, 181.9573, 48.705244);
const $a7c3a003cefc5494$var$joA = new $a7c3a003cefc5494$var$Ca(2451870.628, 398.884046, 318.4681, 33.140229);
const $a7c3a003cefc5494$var$soA = new $a7c3a003cefc5494$var$Ca(2451870.17, 378.091904, 318.0172, 12.647487);
const $a7c3a003cefc5494$var$scA = new $a7c3a003cefc5494$var$Ca(2451681.124, 378.091904, 131.6934, 12.647487);
const $a7c3a003cefc5494$var$uoA = new $a7c3a003cefc5494$var$Ca(2451764.317, 369.656035, 213.6884, 4.333093);
const $a7c3a003cefc5494$var$noA = new $a7c3a003cefc5494$var$Ca(2451753.122, 367.486703, 202.6544, 2.194998);
/**
 * caa holds coefficients for "additional angles" for outer planets
 * as given on p. 251
 */ function $a7c3a003cefc5494$var$Caa(c, f) {
    this.c = c;
    this.f = f;
}
const $a7c3a003cefc5494$var$jaa = [
    new $a7c3a003cefc5494$var$Caa(82.74, 40.76)
];
const $a7c3a003cefc5494$var$saa = [
    new $a7c3a003cefc5494$var$Caa(82.74, 40.76),
    new $a7c3a003cefc5494$var$Caa(29.86, 1181.36),
    new $a7c3a003cefc5494$var$Caa(14.13, 590.68),
    new $a7c3a003cefc5494$var$Caa(220.02, 1262.87)
];
const $a7c3a003cefc5494$var$uaa = [
    new $a7c3a003cefc5494$var$Caa(207.83, 8.51),
    new $a7c3a003cefc5494$var$Caa(108.84, 419.96)
];
const $a7c3a003cefc5494$var$naa = [
    new $a7c3a003cefc5494$var$Caa(207.83, 8.51),
    new $a7c3a003cefc5494$var$Caa(276.74, 209.98)
];
/**
 * Table 33.B, p. 256
 */ /**
 * Mercury inferior conjunction
 */ const $a7c3a003cefc5494$var$micB = [
    [
        0.0545,
        0.0002
    ],
    [
        -6.2008,
        0.0074,
        0.00003
    ],
    [
        -3.275,
        -0.0197,
        0.00001
    ],
    [
        0.4737,
        -0.0052,
        -0.00001
    ],
    [
        0.8111,
        0.0033,
        -0.00002
    ],
    [
        0.0037,
        0.0018
    ],
    [
        -0.1768,
        0,
        0.00001
    ],
    [
        -0.0211,
        -0.0004
    ],
    [
        0.0326,
        -0.0003
    ],
    [
        0.0083,
        0.0001
    ],
    [
        -0.004,
        0.0001
    ]
];
/**
 * Mercury superior conjunction
 */ const $a7c3a003cefc5494$var$mscB = [
    [
        -0.0548,
        -0.0002
    ],
    [
        7.3894,
        -0.01,
        -0.00003
    ],
    [
        3.22,
        0.0197,
        -0.00001
    ],
    [
        0.8383,
        -0.0064,
        -0.00001
    ],
    [
        0.9666,
        0.0039,
        -0.00003
    ],
    [
        0.077,
        -0.0026
    ],
    [
        0.2758,
        0.0002,
        -0.00002
    ],
    [
        -0.0128,
        -0.0008
    ],
    [
        0.0734,
        -0.0004,
        -0.00001
    ],
    [
        -0.0122,
        -0.0002
    ],
    [
        0.0173,
        -0.0002
    ]
];
/**
 * Venus inferior conjunction
 */ const $a7c3a003cefc5494$var$vicB = [
    [
        -0.0096,
        0.0002,
        -0.00001
    ],
    [
        2.0009,
        -0.0033,
        -0.00001
    ],
    [
        0.598,
        -0.0104,
        0.00001
    ],
    [
        0.0967,
        -0.0018,
        -0.00003
    ],
    [
        0.0913,
        0.0009,
        -0.00002
    ],
    [
        0.0046,
        -0.0002
    ],
    [
        0.0079,
        0.0001
    ]
];
/**
 * Mars opposition
 */ const $a7c3a003cefc5494$var$moB = [
    [
        -0.3088,
        0,
        0.00002
    ],
    [
        -17.6965,
        0.0363,
        0.00005
    ],
    [
        18.3131,
        0.0467,
        -0.00006
    ],
    [
        -0.2162,
        -0.0198,
        -0.00001
    ],
    [
        -4.5028,
        -0.0019,
        0.00007
    ],
    [
        0.8987,
        0.0058,
        -0.00002
    ],
    [
        0.7666,
        -0.005,
        -0.00003
    ],
    [
        -0.3636,
        -0.0001,
        0.00002
    ],
    [
        0.0402,
        0.0032
    ],
    [
        0.0737,
        -0.0008
    ],
    [
        -0.098,
        -0.0011
    ]
];
/**
 * Jupiter opposition
 */ const $a7c3a003cefc5494$var$joB = [
    [
        -0.1029,
        0,
        -0.00009
    ],
    [
        -1.9658,
        -0.0056,
        0.00007
    ],
    [
        6.1537,
        0.021,
        -0.00006
    ],
    [
        -0.2081,
        -0.0013
    ],
    [
        -0.1116,
        -0.001
    ],
    [
        0.0074,
        0.0001
    ],
    [
        -0.0097,
        -0.0001
    ],
    [
        0,
        0.0144,
        -0.00008
    ],
    [
        0.3642,
        -0.0019,
        -0.00029
    ]
];
/**
 * Saturn opposition
 */ const $a7c3a003cefc5494$var$soB = [
    [
        -0.0209,
        0.0006,
        0.00023
    ],
    [
        4.5795,
        -0.0312,
        -0.00017
    ],
    [
        1.1462,
        -0.0351,
        0.00011
    ],
    [
        0.0985,
        -0.0015
    ],
    [
        0.0733,
        -0.0031,
        0.00001
    ],
    [
        0.0025,
        -0.0001
    ],
    [
        0.005,
        -0.0002
    ],
    [
        0,
        -0.0337,
        0.00018
    ],
    [
        -0.851,
        0.0044,
        0.00068
    ],
    [
        0,
        -0.0064,
        0.00004
    ],
    [
        0.2397,
        -0.0012,
        -0.00008
    ],
    [
        0,
        -0.001
    ],
    [
        0.1245,
        0.0006
    ],
    [
        0,
        0.0024,
        -0.00003
    ],
    [
        0.0477,
        -0.0005,
        -0.00006
    ]
];
/**
 * Saturn conjunction
 */ const $a7c3a003cefc5494$var$scB = [
    [
        0.0172,
        -0.0006,
        0.00023
    ],
    [
        -8.5885,
        0.0411,
        0.00020
    ],
    [
        -1.147,
        0.0352,
        -0.00011
    ],
    [
        0.3331,
        -0.0034,
        -0.00001
    ],
    [
        0.1145,
        -0.0045,
        0.00002
    ],
    [
        -0.0169,
        0.0002
    ],
    [
        -0.0109,
        0.0004
    ],
    [
        0,
        -0.0337,
        0.00018
    ],
    [
        -0.851,
        0.0044,
        0.00068
    ],
    [
        0,
        -0.0064,
        0.00004
    ],
    [
        0.2397,
        -0.0012,
        -0.00008
    ],
    [
        0,
        -0.001
    ],
    [
        0.1245,
        0.0006
    ],
    [
        0,
        0.0024,
        -0.00003
    ],
    [
        0.0477,
        -0.0005,
        -0.00006
    ]
];
/**
 * Uranus opposition
 */ const $a7c3a003cefc5494$var$uoB = [
    [
        0.0844,
        -0.0006
    ],
    [
        -0.1048,
        0.0246
    ],
    [
        -5.1221,
        0.0104,
        0.00003
    ],
    [
        -0.1428,
        0.0005
    ],
    [
        -0.0148,
        -0.0013
    ],
    [
        0
    ],
    [
        0.0055
    ],
    [
        0
    ],
    [
        0.885
    ],
    [
        0
    ],
    [
        0.2153
    ]
];
/**
 * Neptune opposition [
 */ const $a7c3a003cefc5494$var$noB = [
    [
        -0.014,
        0,
        0.00001
    ],
    [
        -1.3486,
        0.001,
        0.00001
    ],
    [
        0.8597,
        0.0037
    ],
    [
        -0.0082,
        -0.0002,
        0.00001
    ],
    [
        0.0037,
        -0.0003
    ],
    [
        0
    ],
    [
        -0.5964
    ],
    [
        0
    ],
    [
        0.0728
    ]
];
/**
 * Table 36.C, p. 259
 */ /**
 * Mercury east time correction
 */ const $a7c3a003cefc5494$var$met = [
    [
        -21.6106,
        0.0002
    ],
    [
        -1.9803,
        -0.006,
        0.00001
    ],
    [
        1.4151,
        -0.0072,
        -0.00001
    ],
    [
        0.5528,
        -0.0005,
        -0.00001
    ],
    [
        0.2905,
        0.0034,
        0.00001
    ],
    [
        -0.1121,
        -0.0001,
        0.00001
    ],
    [
        -0.0098,
        -0.0015
    ],
    [
        0.0192
    ],
    [
        0.0111,
        0.0004
    ],
    [
        -0.0061
    ],
    [
        -0.0032,
        -0.0001
    ]
];
/**
 * Mercury east elongation
 */ const $a7c3a003cefc5494$var$mee = [
    [
        22.4697
    ],
    [
        -4.2666,
        0.0054,
        0.00002
    ],
    [
        -1.8537,
        -0.0137
    ],
    [
        0.3598,
        0.0008,
        -0.00001
    ],
    [
        -0.068,
        0.0026
    ],
    [
        -0.0524,
        -0.0003
    ],
    [
        0.0052,
        -0.0006
    ],
    [
        0.0107,
        0.0001
    ],
    [
        -0.0013,
        0.0001
    ],
    [
        -0.0021
    ],
    [
        0.0003
    ]
];
/**
 * Mercury west time correction
 */ const $a7c3a003cefc5494$var$mwt = [
    [
        21.6249,
        -0.0002
    ],
    [
        0.1306,
        0.0065
    ],
    [
        -2.7661,
        -0.0011,
        0.00001
    ],
    [
        0.2438,
        -0.0024,
        -0.00001
    ],
    [
        0.5767,
        0.0023
    ],
    [
        0.1041
    ],
    [
        -0.0184,
        0.0007
    ],
    [
        -0.0051,
        -0.0001
    ],
    [
        0.0048,
        0.0001
    ],
    [
        0.0026
    ],
    [
        0.0037
    ]
];
/**
 * Mercury west elongation
 */ const $a7c3a003cefc5494$var$mwe = [
    [
        22.4143,
        -0.0001
    ],
    [
        4.3651,
        -0.0048,
        -0.00002
    ],
    [
        2.3787,
        0.0121,
        -0.00001
    ],
    [
        0.2674,
        0.0022
    ],
    [
        -0.3873,
        0.0008,
        0.00001
    ],
    [
        -0.0369,
        -0.0001
    ],
    [
        0.0017,
        -0.0001
    ],
    [
        0.0059
    ],
    [
        0.0061,
        0.0001
    ],
    [
        0.0007
    ],
    [
        -0.0011
    ]
];
/**
 * Table 36.D, p. 261
 */ /**
 * Mars Station 2
 */ const $a7c3a003cefc5494$var$ms2 = [
    [
        36.7191,
        0.0016,
        0.00003
    ],
    [
        -12.6163,
        0.0417,
        -0.00001
    ],
    [
        20.1218,
        0.0379,
        -0.00006
    ],
    [
        -1.636,
        -0.019
    ],
    [
        -3.9657,
        0.0045,
        0.00007
    ],
    [
        1.1546,
        0.0029,
        -0.00003
    ],
    [
        0.2888,
        -0.0073,
        -0.00002
    ],
    [
        -0.3128,
        0.0017,
        0.00002
    ],
    [
        0.2513,
        0.0026,
        -0.00002
    ],
    [
        -0.0021,
        -0.0016
    ],
    [
        -0.1497,
        -0.0006
    ]
];
var $a7c3a003cefc5494$export$2e2bcd8739ae039 = {
    mean: $a7c3a003cefc5494$export$1ce691f85baaa52,
    sum: $a7c3a003cefc5494$export$8a63f25cc62965f1,
    ms: $a7c3a003cefc5494$export$5dd2165da01bec80,
    mercuryInfConj: $a7c3a003cefc5494$export$76169c43d3938300,
    mercurySupConj: $a7c3a003cefc5494$export$ce8977aa2d00bfc8,
    venusInfConj: $a7c3a003cefc5494$export$30a7d2600c8d62e4,
    marsOpp: $a7c3a003cefc5494$export$59bd7cf55aa25e8b,
    sumA: $a7c3a003cefc5494$export$266f75ba0609eb7f,
    msa: $a7c3a003cefc5494$export$47f8b53ac5f243ba,
    jupiterOpp: $a7c3a003cefc5494$export$e488a03fbb892bbb,
    saturnOpp: $a7c3a003cefc5494$export$a1bbd71c5a147da5,
    saturnConj: $a7c3a003cefc5494$export$ac01cbb39f932caf,
    uranusOpp: $a7c3a003cefc5494$export$1b6838cdb8229aa,
    neptuneOpp: $a7c3a003cefc5494$export$5ade32f1596c5ce5,
    el: $a7c3a003cefc5494$export$c3da0dad1b44eea9,
    mercuryEastElongation: $a7c3a003cefc5494$export$3754c8e7f6b36bf6,
    mercuryWestElongation: $a7c3a003cefc5494$export$30ea0c285180713e,
    marsStation2: $a7c3a003cefc5494$export$3015313126dcb245
};




var $kzKe3 = parcelRequire("kzKe3");
/**
 * @copyright 2013 Sonia Keys
 * @copyright 2016 commenthol
 * @license MIT
 * @module pluto
 */ /**
 * Pluto: Chapter 37, Pluto.
 */ 
var $9QpM5 = parcelRequire("9QpM5");

function $7a410765491fb419$export$69e8648434155e39(jde) {
    let l = 0;
    let b = 0;
    let r = 0;
    const T = (0, $9QpM5.default).J2000Century(jde);
    const J = 34.35 + 3034.9057 * T;
    const S = 50.08 + 1222.1138 * T;
    const P = 238.96 + 144.96 * T;
    for(const i in $7a410765491fb419$var$t37){
        const t = $7a410765491fb419$var$t37[i];
        const [s\u03B1, c\u03B1] = (0, $9QpM5.default).sincos((t.i * J + t.j * S + t.k * P) * Math.PI / 180);
        l += t.lA * s\u03B1 + t.lB * c\u03B1;
        b += t.bA * s\u03B1 + t.bB * c\u03B1;
        r += t.rA * s\u03B1 + t.rB * c\u03B1;
    }
    l = (l + 238.958116 + 144.96 * T) * Math.PI / 180;
    b = (b - 3.908239) * Math.PI / 180;
    r += 40.7241346;
    return {
        lon: l,
        lat: b,
        range: r
    };
}
function $7a410765491fb419$export$f061bb514a02f1ef(jde, earth) {
    const s\u03B5 = (0, $9QpM5.default).SOblJ2000;
    const c\u03B5 = (0, $9QpM5.default).COblJ2000;
    const f = function(jde) {
        const { lon: lon, lat: lat, range: range } = $7a410765491fb419$export$69e8648434155e39(jde);
        const [sl, cl] = (0, $9QpM5.default).sincos(lon);
        const [sb, cb] = (0, $9QpM5.default).sincos(lat);
        // (37.1) p. 264
        const x = range * cl * cb;
        const y = range * (sl * cb * c\u03B5 - sb * s\u03B5);
        const z = range * (sl * cb * s\u03B5 + sb * c\u03B5);
        return {
            x: x,
            y: y,
            z: z
        };
    };
    const c = (0, $05c3bff5926cc6a8$export$2e2bcd8739ae039).astrometricJ2000(f, jde, earth) // eslint-disable-line no-unused-vars
    ;
    return new (0, $9QpM5.default).Coord(c.ra, c.dec);
}
function $7a410765491fb419$var$Pt(i, j, k, lA, lB, bA, bB, rA, rB) {
    this.i = i;
    this.j = j;
    this.k = k;
    this.lA = lA;
    this.lB = lB;
    this.bA = bA;
    this.bB = bB;
    this.rA = rA;
    this.rB = rB;
}
const $7a410765491fb419$var$t37 = [
    new $7a410765491fb419$var$Pt(0, 0, 1, -19.799805, 19.850055, -5.452852, -14.974862, 6.6865439, 6.8951812),
    new $7a410765491fb419$var$Pt(0, 0, 2, 0.897144, -4.954829, 3.527812, 1.67279, -1.1827535, -0.0332538),
    new $7a410765491fb419$var$Pt(0, 0, 3, 0.611149, 1.211027, -1.050748, 0.327647, 0.1593179, -0.143889),
    new $7a410765491fb419$var$Pt(0, 0, 4, -0.341243, -0.189585, 0.17869, -0.292153, -0.0018444, 0.048322),
    new $7a410765491fb419$var$Pt(0, 0, 5, 0.129287, -0.034992, 0.01865, 0.10034, -0.0065977, -0.0085431),
    new $7a410765491fb419$var$Pt(0, 0, 6, -0.038164, 0.030893, -0.030697, -0.025823, 0.0031174, -0.0006032),
    new $7a410765491fb419$var$Pt(0, 1, -1, 0.020442, -0.009987, 0.004878, 0.011248, -0.0005794, 0.0022161),
    new $7a410765491fb419$var$Pt(0, 1, 0, -0.004063, -0.005071, 0.000226, -0.000064, 0.0004601, 0.0004032),
    new $7a410765491fb419$var$Pt(0, 1, 1, -0.006016, -0.003336, 0.00203, -0.000836, -0.0001729, 0.0000234),
    new $7a410765491fb419$var$Pt(0, 1, 2, -0.003956, 0.003039, 0.000069, -0.000604, -0.0000415, 0.0000702),
    new $7a410765491fb419$var$Pt(0, 1, 3, -0.000667, 0.003572, -0.000247, -0.000567, 0.0000239, 0.0000723),
    new $7a410765491fb419$var$Pt(0, 2, -2, 0.001276, 0.000501, -0.000057, 0.000001, 0.0000067, -0.0000067),
    new $7a410765491fb419$var$Pt(0, 2, -1, 0.001152, -0.000917, -0.000122, 0.000175, 0.0001034, -0.0000451),
    new $7a410765491fb419$var$Pt(0, 2, 0, 0.00063, -0.001277, -0.000049, -0.000164, -0.0000129, 0.0000504),
    new $7a410765491fb419$var$Pt(1, -1, 0, 0.002571, -0.000459, -0.000197, 0.000199, 0.000048, -0.0000231),
    new $7a410765491fb419$var$Pt(1, -1, 1, 0.000899, -0.001449, -0.000025, 0.000217, 0.0000002, -0.0000441),
    new $7a410765491fb419$var$Pt(1, 0, -3, -0.001016, 0.001043, 0.000589, -0.000248, -0.0003359, 0.0000265),
    new $7a410765491fb419$var$Pt(1, 0, -2, -0.002343, -0.001012, -0.000269, 0.000711, 0.0007856, -0.0007832),
    new $7a410765491fb419$var$Pt(1, 0, -1, 0.007042, 0.000788, 0.000185, 0.000193, 0.0000036, 0.0045763),
    new $7a410765491fb419$var$Pt(1, 0, 0, 0.001199, -0.000338, 0.000315, 0.000807, 0.0008663, 0.0008547),
    new $7a410765491fb419$var$Pt(1, 0, 1, 0.000418, -0.000067, -0.00013, -0.000043, -0.0000809, -0.0000769),
    new $7a410765491fb419$var$Pt(1, 0, 2, 0.00012, -0.000274, 0.000005, 0.000003, 0.0000263, -0.0000144),
    new $7a410765491fb419$var$Pt(1, 0, 3, -0.00006, -0.000159, 0.000002, 0.000017, -0.0000126, 0.0000032),
    new $7a410765491fb419$var$Pt(1, 0, 4, -0.000082, -0.000029, 0.000002, 0.000005, -0.0000035, -0.0000016),
    new $7a410765491fb419$var$Pt(1, 1, -3, -0.000036, -0.000029, 0.000002, 0.000003, -0.0000019, -0.0000004),
    new $7a410765491fb419$var$Pt(1, 1, -2, -0.00004, 0.000007, 0.000003, 0.000001, -0.0000015, 0.0000008),
    new $7a410765491fb419$var$Pt(1, 1, -1, -0.000014, 0.000022, 0.000002, -0.000001, -0.0000004, 0.0000012),
    new $7a410765491fb419$var$Pt(1, 1, 0, 0.000004, 0.000013, 0.000001, -0.000001, 0.0000005, 0.0000006),
    new $7a410765491fb419$var$Pt(1, 1, 1, 0.000005, 0.000002, 0, -0.000001, 0.0000003, 0.0000001),
    new $7a410765491fb419$var$Pt(1, 1, 3, -0.000001, 0, 0, 0, 0.0000006, -0.0000002),
    new $7a410765491fb419$var$Pt(2, 0, -6, 0.000002, 0, 0, -0.000002, 0.0000002, 0.0000002),
    new $7a410765491fb419$var$Pt(2, 0, -5, -0.000004, 0.000005, 0.000002, 0.000002, -0.0000002, -0.0000002),
    new $7a410765491fb419$var$Pt(2, 0, -4, 0.000004, -0.000007, -0.000007, 0, 0.0000014, 0.0000013),
    new $7a410765491fb419$var$Pt(2, 0, -3, 0.000014, 0.000024, 0.00001, -0.000008, -0.0000063, 0.0000013),
    new $7a410765491fb419$var$Pt(2, 0, -2, -0.000049, -0.000034, -0.000003, 0.00002, 0.0000136, -0.0000236),
    new $7a410765491fb419$var$Pt(2, 0, -1, 0.000163, -0.000048, 0.000006, 0.000005, 0.0000273, 0.0001065),
    new $7a410765491fb419$var$Pt(2, 0, 0, 0.000009, -0.000024, 0.000014, 0.000017, 0.0000251, 0.0000149),
    new $7a410765491fb419$var$Pt(2, 0, 1, -0.000004, 0.000001, -0.000002, 0, -0.0000025, -0.0000009),
    new $7a410765491fb419$var$Pt(2, 0, 2, -0.000003, 0.000001, 0, 0, 0.0000009, -0.0000002),
    new $7a410765491fb419$var$Pt(2, 0, 3, 0.000001, 0.000003, 0, 0, -0.0000008, 0.0000007),
    new $7a410765491fb419$var$Pt(3, 0, -2, -0.000003, -0.000001, 0, 0.000001, 0.0000002, -0.000001),
    new $7a410765491fb419$var$Pt(3, 0, -1, 0.000005, -0.000003, 0, 0, 0.0000019, 0.0000035),
    new $7a410765491fb419$var$Pt(3, 0, 0, 0, 0, 0.000001, 0, 0.000001, 0.0000003)
];
var $7a410765491fb419$export$2e2bcd8739ae039 = {
    heliocentric: $7a410765491fb419$export$69e8648434155e39,
    astrometric: $7a410765491fb419$export$f061bb514a02f1ef
};



/**
 * @copyright 2013 Sonia Keys
 * @copyright 2016 commenthol
 * @license MIT
 * @module refraction
 */ /**
 * Refraction: Chapter 16: Atmospheric Refraction.
 *
 * Functions here assume atmospheric pressure of 1010 mb, temperature of
 * 10°C, and yellow light.
 */ 
const { sin: $460c5af762d5815e$var$sin, tan: $460c5af762d5815e$var$tan } = Math;
const $460c5af762d5815e$var$D2R = Math.PI / 180;
const $460c5af762d5815e$var$gt15true1 = new (0, $c953199d551a315b$export$2e2bcd8739ae039).Angle(false, 0, 0, 58.294).rad();
const $460c5af762d5815e$var$gt15true2 = new (0, $c953199d551a315b$export$2e2bcd8739ae039).Angle(false, 0, 0, 0.0668).rad();
const $460c5af762d5815e$var$gt15app1 = new (0, $c953199d551a315b$export$2e2bcd8739ae039).Angle(false, 0, 0, 58.276).rad();
const $460c5af762d5815e$var$gt15app2 = new (0, $c953199d551a315b$export$2e2bcd8739ae039).Angle(false, 0, 0, 0.0824).rad();
function $460c5af762d5815e$export$6260f6a4b8beface(h0) {
    // (16.1) p. 105
    const t = $460c5af762d5815e$var$tan(Math.PI / 2 - h0);
    return $460c5af762d5815e$var$gt15true1 * t - $460c5af762d5815e$var$gt15true2 * t * t * t;
}
function $460c5af762d5815e$export$6f46e3807fcd28cc(h) {
    // (16.2) p. 105
    const t = $460c5af762d5815e$var$tan(Math.PI / 2 - h);
    return $460c5af762d5815e$var$gt15app1 * t - $460c5af762d5815e$var$gt15app2 * t * t * t;
}
function $460c5af762d5815e$export$65f9897326b48554(h0) {
    // (16.3) p. 106
    const c1 = $460c5af762d5815e$var$D2R / 60;
    const c731 = 7.31 * $460c5af762d5815e$var$D2R * $460c5af762d5815e$var$D2R;
    const c44 = 4.4 * $460c5af762d5815e$var$D2R;
    return c1 / $460c5af762d5815e$var$tan(h0 + c731 / (h0 + c44));
}
function $460c5af762d5815e$export$35b82aef48ffbd87(h0) {
    const cMin = 60 / $460c5af762d5815e$var$D2R;
    const c06 = 0.06 / cMin;
    const c147 = 14.7 * cMin * $460c5af762d5815e$var$D2R;
    const c13 = 13 * $460c5af762d5815e$var$D2R;
    const R = $460c5af762d5815e$export$65f9897326b48554(h0);
    return R - c06 * $460c5af762d5815e$var$sin(c147 * R + c13);
}
function $460c5af762d5815e$export$835cb098fc7016f2(h) {
    // (16.4) p. 106
    const c102 = 1.02 * $460c5af762d5815e$var$D2R / 60;
    const c103 = 10.3 * $460c5af762d5815e$var$D2R * $460c5af762d5815e$var$D2R;
    const c511 = 5.11 * $460c5af762d5815e$var$D2R;
    return c102 / $460c5af762d5815e$var$tan(h + c103 / (h + c511));
}
var $460c5af762d5815e$export$2e2bcd8739ae039 = {
    gt15True: $460c5af762d5815e$export$6260f6a4b8beface,
    gt15Apparent: $460c5af762d5815e$export$6f46e3807fcd28cc,
    bennett: $460c5af762d5815e$export$65f9897326b48554,
    bennett2: $460c5af762d5815e$export$35b82aef48ffbd87,
    saemundsson: $460c5af762d5815e$export$835cb098fc7016f2
};


/* eslint key-spacing: 1 */ /**
 * @copyright 2013 Sonia Keys
 * @copyright 2016 commenthol
 * @license MIT
 * @module rise
 */ /**
 * Rise: Chapter 15, Rising, Transit, and Setting.
 */ 
var $9QpM5 = parcelRequire("9QpM5");








const { acos: $b764fc4e2cf928d6$var$acos, asin: $b764fc4e2cf928d6$var$asin, cos: $b764fc4e2cf928d6$var$cos, sin: $b764fc4e2cf928d6$var$sin } = Math;
/**
 * @typedef {object} RiseObj
 * @property {number} rise - in seconds
 * @property {number} transit - in seconds
 * @property {number} set - in seconds
 */ const $b764fc4e2cf928d6$var$SECS_PER_DEGREE = 240 // = 86400 / 360
;
const $b764fc4e2cf928d6$var$SECS_PER_DAY = 86400;
const $b764fc4e2cf928d6$var$D2R = Math.PI / 180;
const $b764fc4e2cf928d6$export$7a4183dcd283f4fb = (0, $9QpM5.default).errorCode('always above horizon', -1);
const $b764fc4e2cf928d6$export$d3f1548a4b2d2d29 = (0, $9QpM5.default).errorCode('always below horizon', 1);
const $b764fc4e2cf928d6$export$ee07f596784d6278 = new (0, $c953199d551a315b$export$2e2bcd8739ae039).Angle(false, 0, 34, 0).rad();
const $b764fc4e2cf928d6$export$996cf7bb5452fca5 = {
    stellar: -$b764fc4e2cf928d6$export$ee07f596784d6278,
    solar: new (0, $c953199d551a315b$export$2e2bcd8739ae039).Angle(true, 0, 50, 0).rad(),
    // not containing meanRefraction
    lunar: (0, $c953199d551a315b$export$2e2bcd8739ae039).angleFromDeg(0.7275),
    lunarMean: (0, $c953199d551a315b$export$2e2bcd8739ae039).angleFromDeg(0.125)
};
function $b764fc4e2cf928d6$export$738f930a728b5990(h0, corr) {
    if (!corr) return h0;
    else return h0 - $b764fc4e2cf928d6$export$ee07f596784d6278 - corr;
}
const $b764fc4e2cf928d6$export$ef79cfac7174f1de = (_refraction)=>$b764fc4e2cf928d6$export$738f930a728b5990($b764fc4e2cf928d6$export$996cf7bb5452fca5.stellar, _refraction);
const $b764fc4e2cf928d6$export$8f817f50f3babcd9 = $b764fc4e2cf928d6$export$ef79cfac7174f1de() // for backward-compatibility
;
const $b764fc4e2cf928d6$export$b5328d125d25a8c9 = (_refraction)=>$b764fc4e2cf928d6$export$738f930a728b5990($b764fc4e2cf928d6$export$996cf7bb5452fca5.solar, _refraction);
const $b764fc4e2cf928d6$export$93be80d0b9bdfd29 = $b764fc4e2cf928d6$export$b5328d125d25a8c9() // for backward-compatibility
;
const $b764fc4e2cf928d6$export$e799b9f6a6d1721b = (_refraction)=>{
    return $b764fc4e2cf928d6$export$996cf7bb5452fca5.lunarMean - $b764fc4e2cf928d6$export$738f930a728b5990(_refraction);
};
const $b764fc4e2cf928d6$export$21869d509cef315e = $b764fc4e2cf928d6$export$e799b9f6a6d1721b() // for backward-compatibility
;
const $b764fc4e2cf928d6$export$64f50c4863f1f687 = (\u03C0, refraction)=>{
    return $b764fc4e2cf928d6$export$996cf7bb5452fca5.lunar * \u03C0 - (refraction || $b764fc4e2cf928d6$export$ee07f596784d6278);
};
const $b764fc4e2cf928d6$export$e32a3167bc8d6c0 = $b764fc4e2cf928d6$export$64f50c4863f1f687 // for backward-compatibility
;
function $b764fc4e2cf928d6$export$3e10cfdbb7817863(lat, h0, \u03B4) {
    // approximate local hour angle
    const cosH = ($b764fc4e2cf928d6$var$sin(h0) - $b764fc4e2cf928d6$var$sin(lat) * $b764fc4e2cf928d6$var$sin(\u03B4)) / ($b764fc4e2cf928d6$var$cos(lat) * $b764fc4e2cf928d6$var$cos(\u03B4) // (15.1) p. 102
    );
    if (cosH < -1) throw $b764fc4e2cf928d6$export$7a4183dcd283f4fb;
    else if (cosH > 1) throw $b764fc4e2cf928d6$export$d3f1548a4b2d2d29;
    const H = $b764fc4e2cf928d6$var$acos(cosH);
    return H;
}
/**
 * @param {number} lon - longitude in radians
 * @param {number} α - right ascension in radians
 * @param {number} th0 - sidereal.apparent0UT in seconds of day `[0...86400[`
 * @return {number} time of transit in seconds of day `[0, 86400[`
 */ function $b764fc4e2cf928d6$var$_mt(lon, \u03B1, th0) {
    // const mt = (((lon + α) * 180 / Math.PI - (th0 * 360 / 86400)) * 86400 / 360)
    const mt = (lon + \u03B1) * $b764fc4e2cf928d6$var$SECS_PER_DEGREE * 180 / Math.PI - th0;
    return mt;
}
/**
 * @param {number} Th0 - sidereal.apparent0UT in seconds of day `[0...86400[`
 * @param {number} m - motion in seconds of day `[0...86400[`
 * @return {number} new siderial time seconds of day `[0...86400[`
 */ function $b764fc4e2cf928d6$var$_th0(Th0, m) {
    // in original formula Th0 = 0...360 and m = 0...1 -> return value would be in 0...360 degrees
    // Th0 /= 240
    // m /= 86400
    const th0 = (0, $9QpM5.default).pmod(Th0 + m * 360.985647 / 360, $b764fc4e2cf928d6$var$SECS_PER_DAY) // p103
    ;
    return th0 // 0...86400 in seconds angle
    ;
}
/**
 * maintain backward compatibility - will be removed in v2
 * return value in future will be an object not an array
 * @private
 * @param {RiseObj} rs
 * @return {RiseObj}
 */ function $b764fc4e2cf928d6$var$_compatibility(rs) {
    const _rs = [
        rs.rise,
        rs.transit,
        rs.set
    ];
    _rs.rise = rs.rise;
    _rs.transit = rs.transit;
    _rs.set = rs.set;
    return _rs;
}
function $b764fc4e2cf928d6$export$5e956742c00b33bb(p, h0, Th0, \u03B1, \u03B4) {
    const H0 = $b764fc4e2cf928d6$export$3e10cfdbb7817863(p.lat, h0, \u03B4) * $b764fc4e2cf928d6$var$SECS_PER_DEGREE * 180 / Math.PI // in degrees per day === seconds
    ;
    // approximate transit, rise, set times.
    // (15.2) p. 102.0
    const mt = $b764fc4e2cf928d6$var$_mt(p.lon, \u03B1, Th0);
    const rs = {};
    rs.transit = (0, $9QpM5.default).pmod(mt, $b764fc4e2cf928d6$var$SECS_PER_DAY);
    rs.rise = (0, $9QpM5.default).pmod(mt - H0, $b764fc4e2cf928d6$var$SECS_PER_DAY);
    rs.set = (0, $9QpM5.default).pmod(mt + H0, $b764fc4e2cf928d6$var$SECS_PER_DAY);
    return $b764fc4e2cf928d6$var$_compatibility(rs);
}
function $b764fc4e2cf928d6$export$b5bc26e198ce73d0(p, \u0394T, h0, Th0, \u03B13, \u03B43) {
    const rs = $b764fc4e2cf928d6$export$5e956742c00b33bb(p, h0, Th0, \u03B13[1], \u03B43[1]);
    const d3\u03B1 = new (0, $7480a29e66a7d324$export$2e2bcd8739ae039).Len3(-$b764fc4e2cf928d6$var$SECS_PER_DAY, $b764fc4e2cf928d6$var$SECS_PER_DAY, \u03B13);
    const d3\u03B4 = new (0, $7480a29e66a7d324$export$2e2bcd8739ae039).Len3(-$b764fc4e2cf928d6$var$SECS_PER_DAY, $b764fc4e2cf928d6$var$SECS_PER_DAY, \u03B43);
    // adjust mTransit
    const ut = rs.transit + \u0394T;
    const \u03B1 = d3\u03B1.interpolateX(ut);
    const th0 = $b764fc4e2cf928d6$var$_th0(Th0, rs.transit);
    const H = -1 * $b764fc4e2cf928d6$var$_mt(p.lon, \u03B1, th0) // in secs // Hmeus = 0...360
    ;
    rs.transit -= H;
    // adjust mRise, mSet
    const [sLat, cLat] = (0, $9QpM5.default).sincos(p.lat);
    const adjustRS = function(m) {
        const ut = m + \u0394T;
        const \u03B1 = d3\u03B1.interpolateX(ut);
        const \u03B4 = d3\u03B4.interpolateX(ut);
        const th0 = $b764fc4e2cf928d6$var$_th0(Th0, m);
        const H = -1 * $b764fc4e2cf928d6$var$_mt(p.lon, \u03B1, th0);
        const Hrad = H / $b764fc4e2cf928d6$var$SECS_PER_DEGREE * $b764fc4e2cf928d6$var$D2R;
        const h = $b764fc4e2cf928d6$var$asin(sLat * $b764fc4e2cf928d6$var$sin(\u03B4) + cLat * $b764fc4e2cf928d6$var$cos(\u03B4) * $b764fc4e2cf928d6$var$cos(Hrad)) // formula 13.6
        ;
        const \u0394m = $b764fc4e2cf928d6$var$SECS_PER_DAY * (h - h0) / ($b764fc4e2cf928d6$var$cos(\u03B4) * cLat * $b764fc4e2cf928d6$var$sin(Hrad) * 2 * Math.PI) // formula p103 3
        ;
        return m + \u0394m;
    };
    rs.rise = adjustRS(rs.rise);
    rs.set = adjustRS(rs.set);
    return $b764fc4e2cf928d6$var$_compatibility(rs);
}
class $b764fc4e2cf928d6$export$2d560226544f65c7 {
    /**
   * @param {number|Date} jd - Julian Day starting at midnight or Date object
   * @param {number} lat - geographic latitude of the observerin degrees
   * @param {number} lon - geographic longitude of the observer in degrees (measured positively westward)
   * @param {Planet} earth - VSOP87 Planet object for Earth
   * @param {Planet} planet - VSOP87 Planet object of observed body
   * @param {object} [opts]
   * @param {boolean} [opts.date] - return times as Date objects
   * @param {number} [opts.refraction] - use different refraction than `stdh0Stellar`
   */ constructor(jd, lat, lon, earth, planet, opts){
        this.opts = opts || {};
        this.refraction = this.opts.refraction || $b764fc4e2cf928d6$export$ef79cfac7174f1de();
        if (jd instanceof Date) jd = new (0, $b4d5bd4b4d56819f$export$2e2bcd8739ae039).Calendar().fromDate(jd).toJD();
        this.jd = Math.floor(jd - 0.5) + 0.5 // start at midnight
        ;
        this.lat = lat * $b764fc4e2cf928d6$var$D2R // convert to radians
        ;
        this.lon = lon * $b764fc4e2cf928d6$var$D2R;
        const cal = new (0, $b4d5bd4b4d56819f$export$2e2bcd8739ae039).Calendar().fromJD(this.jd);
        this.jde = cal.toJDE();
        this.\u0394T = (0, $8085e6c028279bac$export$2e2bcd8739ae039).deltaT(cal.toYear());
        this.earth = earth;
        this.planet = planet;
    }
    approxTimes() {
        const body = (0, $05c3bff5926cc6a8$export$2e2bcd8739ae039).position(this.planet, this.earth, this.jde);
        const Th0 = (0, $15a74672f869bd9f$export$2e2bcd8739ae039).apparent0UT(this.jd);
        const rs = $b764fc4e2cf928d6$export$5e956742c00b33bb({
            lat: this.lat,
            lon: this.lon
        }, this.refraction, Th0, body.ra, body.dec);
        return this._rsToJD(rs);
    }
    times() {
        const body = [
            (0, $05c3bff5926cc6a8$export$2e2bcd8739ae039).position(this.planet, this.earth, this.jde - 1),
            (0, $05c3bff5926cc6a8$export$2e2bcd8739ae039).position(this.planet, this.earth, this.jde),
            (0, $05c3bff5926cc6a8$export$2e2bcd8739ae039).position(this.planet, this.earth, this.jde + 1)
        ];
        const Th0 = (0, $15a74672f869bd9f$export$2e2bcd8739ae039).apparent0UT(this.jd);
        const rs = $b764fc4e2cf928d6$export$b5bc26e198ce73d0({
            lat: this.lat,
            lon: this.lon
        }, this.\u0394T, this.refraction, Th0, this._toArr(body, 'ra'), this._toArr(body, 'dec'));
        return this._rsToJD(rs);
    }
    /** @private */ _toArr(body, p) {
        return body.map((item)=>{
            return item[p];
        });
    }
    /** @private */ _rsToJD(rs) {
        return {
            rise: this._toJD(rs.rise),
            transit: this._toJD(rs.transit),
            set: this._toJD(rs.set)
        };
    }
    /** @private */ _toJD(secs) {
        const jd = this.jd + secs / 86400;
        if (this.opts.date) return new (0, $b4d5bd4b4d56819f$export$2e2bcd8739ae039).Calendar().fromJD(jd).toDate();
        else return jd;
    }
}
var $b764fc4e2cf928d6$export$2e2bcd8739ae039 = {
    errorAboveHorizon: $b764fc4e2cf928d6$export$7a4183dcd283f4fb,
    errorBelowHorizon: $b764fc4e2cf928d6$export$d3f1548a4b2d2d29,
    meanRefraction: $b764fc4e2cf928d6$export$ee07f596784d6278,
    stdh0: $b764fc4e2cf928d6$export$996cf7bb5452fca5,
    refraction: $b764fc4e2cf928d6$export$738f930a728b5990,
    stdh0Stellar: $b764fc4e2cf928d6$export$ef79cfac7174f1de,
    Stdh0Stellar: $b764fc4e2cf928d6$export$8f817f50f3babcd9,
    stdh0Solar: $b764fc4e2cf928d6$export$b5328d125d25a8c9,
    Stdh0Solar: $b764fc4e2cf928d6$export$93be80d0b9bdfd29,
    stdh0LunarMean: $b764fc4e2cf928d6$export$e799b9f6a6d1721b,
    Stdh0LunarMean: $b764fc4e2cf928d6$export$21869d509cef315e,
    stdh0Lunar: $b764fc4e2cf928d6$export$64f50c4863f1f687,
    Stdh0Lunar: $b764fc4e2cf928d6$export$e32a3167bc8d6c0,
    hourAngle: $b764fc4e2cf928d6$export$3e10cfdbb7817863,
    approxTimes: $b764fc4e2cf928d6$export$5e956742c00b33bb,
    times: $b764fc4e2cf928d6$export$b5bc26e198ce73d0,
    PlanetRise: $b764fc4e2cf928d6$export$2d560226544f65c7
};


/**
 * @copyright 2013 Sonia Keys
 * @copyright 2016 commenthol
 * @license MIT
 * @module saturnmoons
 */ /**
 * Saturnmoons: Chapter 46, Positions of the Satellites of Saturn
 */ 
var $9QpM5 = parcelRequire("9QpM5");




const $e6a67dd706075c83$export$386fd18ee4e95ea6 = 0;
const $e6a67dd706075c83$export$8acd9c77820d511d = 1;
const $e6a67dd706075c83$export$ba052db0268f1760 = 2;
const $e6a67dd706075c83$export$2d7ac83ab9682cb9 = 3;
const $e6a67dd706075c83$export$516ef25d43319868 = 4;
const $e6a67dd706075c83$export$a6fdf7980a37a5b = 5;
const $e6a67dd706075c83$export$cd2a3076998678b5 = 6;
const $e6a67dd706075c83$export$d39f79f8fae75e4c = 7;
/**
 * XY holds coordinates returned from positions().
 */ function $e6a67dd706075c83$var$XY(x, y) {
    this.x = x;
    this.y = y;
}
const $e6a67dd706075c83$var$d = Math.PI / 180;
function $e6a67dd706075c83$export$878041e1e4cd4218(jde, earth, saturn) {
    const sol = (0, $c85b876782fe98e7$export$2e2bcd8739ae039).trueVSOP87(earth, jde);
    const [s, \u03B2, R] = [
        sol.lon,
        sol.lat,
        sol.range
    ];
    const [ss, cs] = (0, $9QpM5.default).sincos(s);
    const s\u03B2 = Math.sin(\u03B2);
    let \u0394 = 9.0;
    let x;
    let y;
    let z = 0;
    let _jde;
    const f = function() {
        const \u03C4 = (0, $9QpM5.default).lightTime(\u0394);
        _jde = jde - \u03C4;
        const { lon: lon, lat: lat, range: range } = saturn.position(_jde);
        const fk5 = (0, $2c5cad23f9dfa2db$export$2e2bcd8739ae039).toFK5(lon, lat, _jde) // eslint-disable-line no-unused-vars
        ;
        const [l, b] = [
            fk5.lon,
            fk5.lat
        ];
        const [sl, cl] = (0, $9QpM5.default).sincos(l);
        const [sb, cb] = (0, $9QpM5.default).sincos(b);
        x = range * cb * cl + R * cs;
        y = range * cb * sl + R * ss;
        z = range * sb + R * s\u03B2;
        \u0394 = Math.sqrt(x * x + y * y + z * z);
    };
    f();
    f();
    let \u03BB0 = Math.atan2(y, x);
    let \u03B20 = Math.atan(z / Math.hypot(x, y));
    let ecl = new (0, $77f14e36e565e56c$export$2e2bcd8739ae039).Ecliptic(\u03BB0, \u03B20);
    ecl = (0, $7b9a9495915be746$export$2e2bcd8739ae039).eclipticPosition(ecl, (0, $9QpM5.default).JDEToJulianYear(jde), (0, $9QpM5.default).JDEToJulianYear((0, $9QpM5.default).B1950));
    \u03BB0 = ecl.lon;
    \u03B20 = ecl.lat;
    const q = new $e6a67dd706075c83$export$6f42510323279e12(_jde);
    const s4 = [
        new $e6a67dd706075c83$var$R4(),
        q.mimas(),
        q.enceladus(),
        q.tethys(),
        q.dione(),
        q.rhea(),
        q.titan(),
        q.hyperion(),
        q.iapetus()
    ];
    const X = new Array(9).fill(0);
    const Y = new Array(9).fill(0);
    const Z = new Array(9).fill(0);
    for(let j = 1; j <= 8; j++){
        const u = s4[j].\u03BB - s4[j].\u03A9;
        const w = s4[j].\u03A9 - 168.8112 * $e6a67dd706075c83$var$d;
        const [su, cu] = (0, $9QpM5.default).sincos(u);
        const [sw, cw] = (0, $9QpM5.default).sincos(w);
        const [s\u03B3, c\u03B3] = (0, $9QpM5.default).sincos(s4[j].\u03B3);
        const r = s4[j].r;
        X[j] = r * (cu * cw - su * c\u03B3 * sw);
        Y[j] = r * (su * cw * c\u03B3 + cu * sw);
        Z[j] = r * su * s\u03B3;
    }
    Z[0] = 1;
    const [s\u03BB0, c\u03BB0] = (0, $9QpM5.default).sincos(\u03BB0);
    const [s\u03B20, c\u03B20] = (0, $9QpM5.default).sincos(\u03B20);
    const A = new Array(9).fill(0);
    const B = new Array(9).fill(0);
    const C = new Array(9).fill(0);
    for(const j in X){
        let a = X[j];
        let b = q.c1 * Y[j] - q.s1 * Z[j];
        const c = q.s1 * Y[j] + q.c1 * Z[j];
        const a0 = q.c2 * a - q.s2 * b;
        b = q.s2 * a + q.c2 * b;
        a = a0;
        A[j] = a * s\u03BB0 - b * c\u03BB0;
        b = a * c\u03BB0 + b * s\u03BB0;
        B[j] = b * c\u03B20 + c * s\u03B20;
        C[j] = c * c\u03B20 - b * s\u03B20;
    }
    const pos = new Array(9);
    const D = Math.atan2(A[0], C[0]);
    const [sD, cD] = (0, $9QpM5.default).sincos(D);
    for(let j = 1; j <= 8; j++){
        X[j] = A[j] * cD - C[j] * sD;
        Y[j] = A[j] * sD + C[j] * cD;
        Z[j] = B[j];
        const d = X[j] / s4[j].r;
        X[j] += Math.abs(Z[j]) / $e6a67dd706075c83$var$k[j] * Math.sqrt(1 - d * d);
        const W = \u0394 / (\u0394 + Z[j] / 2475);
        pos[j - 1] = new $e6a67dd706075c83$var$XY(X[j] * W, Y[j] * W);
    }
    return pos;
}
const $e6a67dd706075c83$var$k = [
    0,
    20947,
    23715,
    26382,
    29876,
    35313,
    53800,
    59222,
    91820
];
function $e6a67dd706075c83$var$R4(\u03BB, r, \u03B3, \u03A9) {
    this.\u03BB = \u03BB || 0;
    this.r = r || 0;
    this.\u03B3 = \u03B3 || 0;
    this.\u03A9 = \u03A9 || 0;
}
function $e6a67dd706075c83$export$6f42510323279e12(jde) {
    this.t1 = jde - 2411093;
    this.t2 = this.t1 / 365.25;
    this.t3 = (jde - 2433282.423) / 365.25 + 1950;
    this.t4 = jde - 2411368;
    this.t5 = this.t4 / 365.25;
    this.t6 = jde - 2415020;
    this.t7 = this.t6 / 36525;
    this.t8 = this.t6 / 365.25;
    this.t9 = (jde - 2442000.5) / 365.25;
    this.t10 = jde - 2409786;
    this.t11 = this.t10 / 36525;
    this.W0 = 5.095 * $e6a67dd706075c83$var$d * (this.t3 - 1866.39);
    this.W1 = 74.4 * $e6a67dd706075c83$var$d + 32.39 * $e6a67dd706075c83$var$d * this.t2;
    this.W2 = 134.3 * $e6a67dd706075c83$var$d + 92.62 * $e6a67dd706075c83$var$d * this.t2;
    this.W3 = 42 * $e6a67dd706075c83$var$d - 0.5118 * $e6a67dd706075c83$var$d * this.t5;
    this.W4 = 276.59 * $e6a67dd706075c83$var$d + 0.5118 * $e6a67dd706075c83$var$d * this.t5;
    this.W5 = 267.2635 * $e6a67dd706075c83$var$d + 1222.1136 * $e6a67dd706075c83$var$d * this.t7;
    this.W6 = 175.4762 * $e6a67dd706075c83$var$d + 1221.5515 * $e6a67dd706075c83$var$d * this.t7;
    this.W7 = 2.4891 * $e6a67dd706075c83$var$d + 0.002435 * $e6a67dd706075c83$var$d * this.t7;
    this.W8 = 113.35 * $e6a67dd706075c83$var$d - 0.2597 * $e6a67dd706075c83$var$d * this.t7;
    this.s1 = Math.sin(28.0817 * $e6a67dd706075c83$var$d);
    this.c1 = Math.cos(28.0817 * $e6a67dd706075c83$var$d);
    this.s2 = Math.sin(168.8112 * $e6a67dd706075c83$var$d);
    this.c2 = Math.cos(168.8112 * $e6a67dd706075c83$var$d);
    this.e1 = 0.05589 - 0.000346 * this.t7;
    this.sW0 = Math.sin(this.W0);
    this.s3W0 = Math.sin(3 * this.W0);
    this.s5W0 = Math.sin(5 * this.W0);
    this.sW1 = Math.sin(this.W1);
    this.sW2 = Math.sin(this.W2);
    this.sW3 = Math.sin(this.W3);
    this.cW3 = Math.cos(this.W3);
    this.sW4 = Math.sin(this.W4);
    this.cW4 = Math.cos(this.W4);
    this.sW7 = Math.sin(this.W7);
    this.cW7 = Math.cos(this.W7);
    return this;
}
$e6a67dd706075c83$export$6f42510323279e12.prototype.mimas = function() {
    const r = new $e6a67dd706075c83$var$R4();
    const L = 127.64 * $e6a67dd706075c83$var$d + 381.994497 * $e6a67dd706075c83$var$d * this.t1 - 43.57 * $e6a67dd706075c83$var$d * this.sW0 - 0.72 * $e6a67dd706075c83$var$d * this.s3W0 - 0.02144 * $e6a67dd706075c83$var$d * this.s5W0;
    const p = 106.1 * $e6a67dd706075c83$var$d + 365.549 * $e6a67dd706075c83$var$d * this.t2;
    const M = L - p;
    const C = 2.18287 * $e6a67dd706075c83$var$d * Math.sin(M) + 0.025988 * $e6a67dd706075c83$var$d * Math.sin(2 * M) + 0.00043 * $e6a67dd706075c83$var$d * Math.sin(3 * M);
    r.\u03BB = L + C;
    r.r = 3.06879 / (1 + 0.01905 * Math.cos(M + C));
    r.\u03B3 = 1.563 * $e6a67dd706075c83$var$d;
    r.\u03A9 = 54.5 * $e6a67dd706075c83$var$d - 365.072 * $e6a67dd706075c83$var$d * this.t2;
    return r;
};
$e6a67dd706075c83$export$6f42510323279e12.prototype.enceladus = function() {
    const r = new $e6a67dd706075c83$var$R4();
    const L = 200.317 * $e6a67dd706075c83$var$d + 262.7319002 * $e6a67dd706075c83$var$d * this.t1 + 0.25667 * $e6a67dd706075c83$var$d * this.sW1 + 0.20883 * $e6a67dd706075c83$var$d * this.sW2;
    const p = 309.107 * $e6a67dd706075c83$var$d + 123.44121 * $e6a67dd706075c83$var$d * this.t2;
    const M = L - p;
    const C = 0.55577 * $e6a67dd706075c83$var$d * Math.sin(M) + 0.00168 * $e6a67dd706075c83$var$d * Math.sin(2 * M);
    r.\u03BB = L + C;
    r.r = 3.94118 / (1 + 0.00485 * Math.cos(M + C));
    r.\u03B3 = 0.0262 * $e6a67dd706075c83$var$d;
    r.\u03A9 = 348 * $e6a67dd706075c83$var$d - 151.95 * $e6a67dd706075c83$var$d * this.t2;
    return r;
};
$e6a67dd706075c83$export$6f42510323279e12.prototype.tethys = function() {
    const r = new $e6a67dd706075c83$var$R4();
    r.\u03BB = 285.306 * $e6a67dd706075c83$var$d + 190.69791226 * $e6a67dd706075c83$var$d * this.t1 + 2.063 * $e6a67dd706075c83$var$d * this.sW0 + 0.03409 * $e6a67dd706075c83$var$d * this.s3W0 + 0.001015 * $e6a67dd706075c83$var$d * this.s5W0;
    r.r = 4.880998;
    r.\u03B3 = 1.0976 * $e6a67dd706075c83$var$d;
    r.\u03A9 = 111.33 * $e6a67dd706075c83$var$d - 72.2441 * $e6a67dd706075c83$var$d * this.t2;
    return r;
};
$e6a67dd706075c83$export$6f42510323279e12.prototype.dione = function() {
    const r = new $e6a67dd706075c83$var$R4();
    const L = 254.712 * $e6a67dd706075c83$var$d + 131.53493193 * $e6a67dd706075c83$var$d * this.t1 - 0.0215 * $e6a67dd706075c83$var$d * this.sW1 - 0.01733 * $e6a67dd706075c83$var$d * this.sW2;
    const p = 174.8 * $e6a67dd706075c83$var$d + 30.82 * $e6a67dd706075c83$var$d * this.t2;
    const M = L - p;
    const C = 0.24717 * $e6a67dd706075c83$var$d * Math.sin(M) + 0.00033 * $e6a67dd706075c83$var$d * Math.sin(2 * M);
    r.\u03BB = L + C;
    r.r = 6.24871 / (1 + 0.002157 * Math.cos(M + C));
    r.\u03B3 = 0.0139 * $e6a67dd706075c83$var$d;
    r.\u03A9 = 232 * $e6a67dd706075c83$var$d - 30.27 * $e6a67dd706075c83$var$d * this.t2;
    return r;
};
$e6a67dd706075c83$export$6f42510323279e12.prototype.rhea = function() {
    const p\u02B9 = 342.7 * $e6a67dd706075c83$var$d + 10.057 * $e6a67dd706075c83$var$d * this.t2;
    const [sp\u02B9, cp\u02B9] = (0, $9QpM5.default).sincos(p\u02B9);
    const a1 = 0.000265 * sp\u02B9 + 0.001 * this.sW4;
    const a2 = 0.000265 * cp\u02B9 + 0.001 * this.cW4;
    const e = Math.hypot(a1, a2);
    const p = Math.atan2(a1, a2);
    const N = 345 * $e6a67dd706075c83$var$d - 10.057 * $e6a67dd706075c83$var$d * this.t2;
    const [sN, cN] = (0, $9QpM5.default).sincos(N);
    const \u03BB\u02B9 = 359.244 * $e6a67dd706075c83$var$d + 79.6900472 * $e6a67dd706075c83$var$d * this.t1 + 0.086754 * $e6a67dd706075c83$var$d * sN;
    const i = 28.0362 * $e6a67dd706075c83$var$d + 0.346898 * $e6a67dd706075c83$var$d * cN + 0.0193 * $e6a67dd706075c83$var$d * this.cW3;
    const \u03A9 = 168.8034 * $e6a67dd706075c83$var$d + 0.736936 * $e6a67dd706075c83$var$d * sN + 0.041 * $e6a67dd706075c83$var$d * this.sW3;
    const a = 8.725924;
    return this.subr(\u03BB\u02B9, p, e, a, \u03A9, i);
};
$e6a67dd706075c83$export$6f42510323279e12.prototype.subr = function(\u03BB\u02B9, p, e, a, \u03A9, i) {
    const r = new $e6a67dd706075c83$var$R4();
    const M = \u03BB\u02B9 - p;
    const e2 = e * e;
    const e3 = e2 * e;
    const e4 = e2 * e2;
    const e5 = e3 * e2;
    const C = (2 * e - 0.25 * e3 + 0.0520833333 * e5) * Math.sin(M) + (1.25 * e2 - 0.458333333 * e4) * Math.sin(2 * M) + (1.083333333 * e3 - 0.671875 * e5) * Math.sin(3 * M) + 1.072917 * e4 * Math.sin(4 * M) + 1.142708 * e5 * Math.sin(5 * M);
    r.r = a * (1 - e2) / (1 + e * Math.cos(M + C) // return value
    );
    const g = \u03A9 - 168.8112 * $e6a67dd706075c83$var$d;
    const [si, ci] = (0, $9QpM5.default).sincos(i);
    const [sg, cg] = (0, $9QpM5.default).sincos(g);
    const a1 = si * sg;
    const a2 = this.c1 * si * cg - this.s1 * ci;
    r.\u03B3 = Math.asin(Math.hypot(a1, a2)) // return value
    ;
    const u = Math.atan2(a1, a2);
    r.\u03A9 = 168.8112 * $e6a67dd706075c83$var$d + u // return value (w)
    ;
    const h = this.c1 * si - this.s1 * ci * cg;
    const \u03C8 = Math.atan2(this.s1 * sg, h);
    r.\u03BB = \u03BB\u02B9 + C + u - g - \u03C8 // return value
    ;
    return r;
};
$e6a67dd706075c83$export$6f42510323279e12.prototype.titan = function() {
    const L = 261.1582 * $e6a67dd706075c83$var$d + 22.57697855 * $e6a67dd706075c83$var$d * this.t4 + 0.074025 * $e6a67dd706075c83$var$d * this.sW3;
    const i\u02B9 = 27.45141 * $e6a67dd706075c83$var$d + 0.295999 * $e6a67dd706075c83$var$d * this.cW3;
    const \u03A9\u02B9 = 168.66925 * $e6a67dd706075c83$var$d + 0.628808 * $e6a67dd706075c83$var$d * this.sW3;
    const [si\u02B9, ci\u02B9] = (0, $9QpM5.default).sincos(i\u02B9);
    const [s\u03A9\u02B9W8, c\u03A9\u02B9W8] = (0, $9QpM5.default).sincos(\u03A9\u02B9 - this.W8);
    const a1 = this.sW7 * s\u03A9\u02B9W8;
    const a2 = this.cW7 * si\u02B9 - this.sW7 * ci\u02B9 * c\u03A9\u02B9W8;
    const g0 = 102.8623 * $e6a67dd706075c83$var$d;
    const \u03C8 = Math.atan2(a1, a2);
    const s = Math.hypot(a1, a2);
    let g = this.W4 - \u03A9\u02B9 - \u03C8;
    let \u03D6 = 0;
    const [s2g0, c2g0] = (0, $9QpM5.default).sincos(2 * g0);
    const f = ()=>{
        \u03D6 = this.W4 + 0.37515 * $e6a67dd706075c83$var$d * (Math.sin(2 * g) - s2g0);
        g = \u03D6 - \u03A9\u02B9 - \u03C8;
    };
    f();
    f();
    f();
    const e\u02B9 = 0.029092 + 0.00019048 * (Math.cos(2 * g) - c2g0);
    const qq = 2 * (this.W5 - \u03D6);
    const b1 = si\u02B9 * s\u03A9\u02B9W8;
    const b2 = this.cW7 * si\u02B9 * c\u03A9\u02B9W8 - this.sW7 * ci\u02B9;
    const \u03B8 = Math.atan2(b1, b2) + this.W8;
    const [sq, cq] = (0, $9QpM5.default).sincos(qq);
    const e = e\u02B9 + 0.002778797 * e\u02B9 * cq;
    const p = \u03D6 + 0.159215 * $e6a67dd706075c83$var$d * sq;
    const u = 2 * this.W5 - 2 * \u03B8 + \u03C8;
    const [su, cu] = (0, $9QpM5.default).sincos(u);
    const h = 0.9375 * e\u02B9 * e\u02B9 * sq + 0.1875 * s * s * Math.sin(2 * (this.W5 - \u03B8));
    const \u03BB\u02B9 = L - 0.254744 * $e6a67dd706075c83$var$d * (this.e1 * Math.sin(this.W6) + 0.75 * this.e1 * this.e1 * Math.sin(2 * this.W6) + h);
    const i = i\u02B9 + 0.031843 * $e6a67dd706075c83$var$d * s * cu;
    const \u03A9 = \u03A9\u02B9 + 0.031843 * $e6a67dd706075c83$var$d * s * su / si\u02B9;
    const a = 20.216193;
    return this.subr(\u03BB\u02B9, p, e, a, \u03A9, i);
};
$e6a67dd706075c83$export$6f42510323279e12.prototype.hyperion = function() {
    const \u03B7 = 92.39 * $e6a67dd706075c83$var$d + 0.5621071 * $e6a67dd706075c83$var$d * this.t6;
    const \u03B6 = 148.19 * $e6a67dd706075c83$var$d - 19.18 * $e6a67dd706075c83$var$d * this.t8;
    const \u03B8 = 184.8 * $e6a67dd706075c83$var$d - 35.41 * $e6a67dd706075c83$var$d * this.t9;
    const \u03B8\u02B9 = \u03B8 - 7.5 * $e6a67dd706075c83$var$d;
    const as = 176 * $e6a67dd706075c83$var$d + 12.22 * $e6a67dd706075c83$var$d * this.t8;
    const bs = 8 * $e6a67dd706075c83$var$d + 24.44 * $e6a67dd706075c83$var$d * this.t8;
    const cs = bs + 5 * $e6a67dd706075c83$var$d;
    const \u03D6 = 69.898 * $e6a67dd706075c83$var$d - 18.67088 * $e6a67dd706075c83$var$d * this.t8;
    const \u03C6 = 2 * (\u03D6 - this.W5);
    const \u03C7 = 94.9 * $e6a67dd706075c83$var$d - 2.292 * $e6a67dd706075c83$var$d * this.t8;
    const [s\u03B7, c\u03B7] = (0, $9QpM5.default).sincos(\u03B7);
    const [s\u03B6, c\u03B6] = (0, $9QpM5.default).sincos(\u03B6);
    const [s2\u03B6, c2\u03B6] = (0, $9QpM5.default).sincos(2 * \u03B6);
    const [s3\u03B6, c3\u03B6] = (0, $9QpM5.default).sincos(3 * \u03B6);
    const [s\u03B6p\u03B7, c\u03B6p\u03B7] = (0, $9QpM5.default).sincos(\u03B6 + \u03B7);
    const [s\u03B6m\u03B7, c\u03B6m\u03B7] = (0, $9QpM5.default).sincos(\u03B6 - \u03B7);
    const [s\u03C6, c\u03C6] = (0, $9QpM5.default).sincos(\u03C6);
    const [s\u03C7, c\u03C7] = (0, $9QpM5.default).sincos(\u03C7);
    const [scs, ccs] = (0, $9QpM5.default).sincos(cs);
    const a = 24.50601 - 0.08686 * c\u03B7 - 0.00166 * c\u03B6p\u03B7 + 0.00175 * c\u03B6m\u03B7;
    const e = 0.103458 - 0.004099 * c\u03B7 - 0.000167 * c\u03B6p\u03B7 + 0.000235 * c\u03B6m\u03B7 + 0.02303 * c\u03B6 - 0.00212 * c2\u03B6 + 0.000151 * c3\u03B6 + 0.00013 * c\u03C6;
    const p = \u03D6 + 0.15648 * $e6a67dd706075c83$var$d * s\u03C7 - 0.4457 * $e6a67dd706075c83$var$d * s\u03B7 - 0.2657 * $e6a67dd706075c83$var$d * s\u03B6p\u03B7 - 0.3573 * $e6a67dd706075c83$var$d * s\u03B6m\u03B7 - 12.872 * $e6a67dd706075c83$var$d * s\u03B6 + 1.668 * $e6a67dd706075c83$var$d * s2\u03B6 - 0.2419 * $e6a67dd706075c83$var$d * s3\u03B6 - 0.07 * $e6a67dd706075c83$var$d * s\u03C6;
    const \u03BB\u02B9 = 177.047 * $e6a67dd706075c83$var$d + 16.91993829 * $e6a67dd706075c83$var$d * this.t6 + 0.15648 * $e6a67dd706075c83$var$d * s\u03C7 + 9.142 * $e6a67dd706075c83$var$d * s\u03B7 + 0.007 * $e6a67dd706075c83$var$d * Math.sin(2 * \u03B7) - 0.014 * $e6a67dd706075c83$var$d * Math.sin(3 * \u03B7) + 0.2275 * $e6a67dd706075c83$var$d * s\u03B6p\u03B7 + 0.2112 * $e6a67dd706075c83$var$d * s\u03B6m\u03B7 - 0.26 * $e6a67dd706075c83$var$d * s\u03B6 - 0.0098 * $e6a67dd706075c83$var$d * s2\u03B6 - 0.013 * $e6a67dd706075c83$var$d * Math.sin(as) + 0.017 * $e6a67dd706075c83$var$d * Math.sin(bs) - 0.0303 * $e6a67dd706075c83$var$d * s\u03C6;
    const i = 27.3347 * $e6a67dd706075c83$var$d + 0.6434886 * $e6a67dd706075c83$var$d * c\u03C7 + 0.315 * $e6a67dd706075c83$var$d * this.cW3 + 0.018 * $e6a67dd706075c83$var$d * Math.cos(\u03B8) - 0.018 * $e6a67dd706075c83$var$d * ccs;
    const \u03A9 = 168.6812 * $e6a67dd706075c83$var$d + 1.40136 * $e6a67dd706075c83$var$d * c\u03C7 + 0.68599 * $e6a67dd706075c83$var$d * this.sW3 - 0.0392 * $e6a67dd706075c83$var$d * scs + 0.0366 * $e6a67dd706075c83$var$d * Math.sin(\u03B8\u02B9);
    return this.subr(\u03BB\u02B9, p, e, a, \u03A9, i);
};
$e6a67dd706075c83$export$6f42510323279e12.prototype.iapetus = function() {
    const L = 261.1582 * $e6a67dd706075c83$var$d + 22.57697855 * $e6a67dd706075c83$var$d * this.t4;
    const \u03D6\u02B9 = 91.796 * $e6a67dd706075c83$var$d + 0.562 * $e6a67dd706075c83$var$d * this.t7;
    const \u03C8 = 4.367 * $e6a67dd706075c83$var$d - 0.195 * $e6a67dd706075c83$var$d * this.t7;
    const \u03B8 = 146.819 * $e6a67dd706075c83$var$d - 3.198 * $e6a67dd706075c83$var$d * this.t7;
    const \u03C6 = 60.47 * $e6a67dd706075c83$var$d + 1.521 * $e6a67dd706075c83$var$d * this.t7;
    const \u03A6 = 205.055 * $e6a67dd706075c83$var$d - 2.091 * $e6a67dd706075c83$var$d * this.t7;
    const e\u02B9 = 0.028298 + 0.001156 * this.t11;
    const \u03D60 = 352.91 * $e6a67dd706075c83$var$d + 11.71 * $e6a67dd706075c83$var$d * this.t11;
    const \u03BC = 76.3852 * $e6a67dd706075c83$var$d + 4.53795125 * $e6a67dd706075c83$var$d * this.t10;
    const i\u02B9 = (0, $9QpM5.default).horner(this.t11, 18.4602 * $e6a67dd706075c83$var$d, -0.9518 * $e6a67dd706075c83$var$d, -0.072 * $e6a67dd706075c83$var$d, 0.0054 * $e6a67dd706075c83$var$d);
    const \u03A9\u02B9 = (0, $9QpM5.default).horner(this.t11, 143.198 * $e6a67dd706075c83$var$d, -3.919 * $e6a67dd706075c83$var$d, 0.116 * $e6a67dd706075c83$var$d, 0.008 * $e6a67dd706075c83$var$d);
    const l = \u03BC - \u03D60;
    const g = \u03D60 - \u03A9\u02B9 - \u03C8;
    const g1 = \u03D60 - \u03A9\u02B9 - \u03C6;
    const ls = this.W5 - \u03D6\u02B9;
    const gs = \u03D6\u02B9 - \u03B8;
    const lT = L - this.W4;
    const gT = this.W4 - \u03A6;
    const u1 = 2 * (l + g - ls - gs);
    const u2 = l + g1 - lT - gT;
    const u3 = l + 2 * (g - ls - gs);
    const u4 = lT + gT - g1;
    const u5 = 2 * (ls + gs);
    const [sl, cl] = (0, $9QpM5.default).sincos(l);
    const [su1, cu1] = (0, $9QpM5.default).sincos(u1);
    const [su2, cu2] = (0, $9QpM5.default).sincos(u2);
    const [su3, cu3] = (0, $9QpM5.default).sincos(u3);
    const [su4, cu4] = (0, $9QpM5.default).sincos(u4);
    const [slu2, clu2] = (0, $9QpM5.default).sincos(l + u2);
    const [sg1gT, cg1gT] = (0, $9QpM5.default).sincos(g1 - gT);
    const [su52g, cu52g] = (0, $9QpM5.default).sincos(u5 - 2 * g);
    const [su5\u03C8, cu5\u03C8] = (0, $9QpM5.default).sincos(u5 + \u03C8);
    const [su2\u03C6, cu2\u03C6] = (0, $9QpM5.default).sincos(u2 + \u03C6);
    const [s5, c5] = (0, $9QpM5.default).sincos(l + g1 + lT + gT + \u03C6);
    const a = 58.935028 + 0.004638 * cu1 + 0.058222 * cu2;
    const e = e\u02B9 - 0.0014097 * cg1gT + 0.0003733 * cu52g + 0.000118 * cu3 + 0.0002408 * cl + 0.0002849 * clu2 + 0.000619 * cu4;
    const w = 0.08077 * $e6a67dd706075c83$var$d * sg1gT + 0.02139 * $e6a67dd706075c83$var$d * su52g - 0.00676 * $e6a67dd706075c83$var$d * su3 + 0.0138 * $e6a67dd706075c83$var$d * sl + 0.01632 * $e6a67dd706075c83$var$d * slu2 + 0.03547 * $e6a67dd706075c83$var$d * su4;
    const p = \u03D60 + w / e\u02B9;
    const \u03BB\u02B9 = \u03BC - 0.04299 * $e6a67dd706075c83$var$d * su2 - 0.00789 * $e6a67dd706075c83$var$d * su1 - 0.06312 * $e6a67dd706075c83$var$d * Math.sin(ls) - 0.00295 * $e6a67dd706075c83$var$d * Math.sin(2 * ls) - 0.02231 * $e6a67dd706075c83$var$d * Math.sin(u5) + 0.0065 * $e6a67dd706075c83$var$d * su5\u03C8;
    const i = i\u02B9 + 0.04204 * $e6a67dd706075c83$var$d * cu5\u03C8 + 0.00235 * $e6a67dd706075c83$var$d * c5 + 0.0036 * $e6a67dd706075c83$var$d * cu2\u03C6;
    const w\u02B9 = 0.04204 * $e6a67dd706075c83$var$d * su5\u03C8 + 0.00235 * $e6a67dd706075c83$var$d * s5 + 0.00358 * $e6a67dd706075c83$var$d * su2\u03C6;
    const \u03A9 = \u03A9\u02B9 + w\u02B9 / Math.sin(i\u02B9);
    return this.subr(\u03BB\u02B9, p, e, a, \u03A9, i);
};
var $e6a67dd706075c83$export$2e2bcd8739ae039 = {
    mimas: $e6a67dd706075c83$export$386fd18ee4e95ea6,
    enceladus: $e6a67dd706075c83$export$8acd9c77820d511d,
    tethys: $e6a67dd706075c83$export$ba052db0268f1760,
    dione: $e6a67dd706075c83$export$2d7ac83ab9682cb9,
    rhea: $e6a67dd706075c83$export$516ef25d43319868,
    titan: $e6a67dd706075c83$export$a6fdf7980a37a5b,
    hyperion: $e6a67dd706075c83$export$cd2a3076998678b5,
    iapetus: $e6a67dd706075c83$export$d39f79f8fae75e4c,
    positions: $e6a67dd706075c83$export$878041e1e4cd4218,
    Qs: $e6a67dd706075c83$export$6f42510323279e12
};


/**
 * @copyright 2013 Sonia Keys
 * @copyright 2016 commenthol
 * @license MIT
 * @module saturnring
 */ /**
 * Saturnrings: Chapter 45, The Ring of Saturn
 */ 
var $9QpM5 = parcelRequire("9QpM5");



function $d75f745c14dccc10$export$e7d0da6968da5dd(jde, earth, saturn) {
    const [f1, f2] = $d75f745c14dccc10$var$cl(jde, earth, saturn);
    const [\u0394U, B] = f1();
    const [B\u02B9, P, aEdge, bEdge] = f2();
    return [
        B,
        B\u02B9,
        \u0394U,
        P,
        aEdge,
        bEdge
    ];
}
function $d75f745c14dccc10$export$153279fcf8905e61(jde, earth, saturn) {
    const [f1, f2] = $d75f745c14dccc10$var$cl(jde, earth, saturn) // eslint-disable-line no-unused-vars
    ;
    return f1();
}
/**
 * cl splits the work into two closures.
 */ function $d75f745c14dccc10$var$cl(jde, earth, saturn) {
    // f2 func() (Bʹ, P, aEdge, bEdge float64))
    const p = Math.PI / 180;
    let i, \u03A9;
    let l0, b0, R;
    let \u0394 = 9.0;
    let \u03BB, \u03B2;
    let si, ci, s\u03B2, c\u03B2, sB;
    let sb\u02B9, cb\u02B9, sl\u02B9\u03A9, cl\u02B9\u03A9;
    const f1 = function() {
        // (45.1), p. 318
        const T = (0, $9QpM5.default).J2000Century(jde);
        i = (0, $9QpM5.default).horner(T, 28.075216 * p, -0.012998 * p, 0.000004 * p);
        \u03A9 = (0, $9QpM5.default).horner(T, 169.50847 * p, 1.394681 * p, 0.000412 * p);
        // Step 2.0
        const earthPos = earth.position(jde);
        R = earthPos.range;
        const fk5 = (0, $2c5cad23f9dfa2db$export$2e2bcd8739ae039).toFK5(earthPos.lon, earthPos.lat, jde);
        l0 = fk5.lon;
        b0 = fk5.lat;
        const [sl0, cl0] = (0, $9QpM5.default).sincos(l0);
        const sb0 = Math.sin(b0);
        // Steps 3, 4.0
        let l = 0;
        let b = 0;
        let r = 0;
        let x = 0;
        let y = 0;
        let z = 0;
        const f = function() {
            const \u03C4 = (0, $9QpM5.default).lightTime(\u0394);
            const saturnPos = saturn.position(jde - \u03C4);
            r = saturnPos.range;
            const fk5 = (0, $2c5cad23f9dfa2db$export$2e2bcd8739ae039).toFK5(saturnPos.lon, saturnPos.lat, jde);
            l = fk5.lon;
            b = fk5.lat;
            const [sl, cl] = (0, $9QpM5.default).sincos(l);
            const [sb, cb] = (0, $9QpM5.default).sincos(b);
            x = r * cb * cl - R * cl0;
            y = r * cb * sl - R * sl0;
            z = r * sb - R * sb0;
            \u0394 = Math.sqrt(x * x + y * y + z * z);
        };
        f();
        f();
        // Step 5.0
        \u03BB = Math.atan2(y, x);
        \u03B2 = Math.atan(z / Math.hypot(x, y));
        // First part of step 6.0
        si = Math.sin(i);
        ci = Math.cos(i);
        s\u03B2 = Math.sin(\u03B2);
        c\u03B2 = Math.cos(\u03B2);
        sB = si * c\u03B2 * Math.sin(\u03BB - \u03A9) - ci * s\u03B2;
        const B = Math.asin(sB) // return value
        ;
        // Step 7.0
        const N = 113.6655 * p + 0.8771 * p * T;
        const l\u02B9 = l - 0.01759 * p / r;
        const b\u02B9 = b - 0.000764 * p * Math.cos(l - N) / r;
        // Setup for steps 8, 9.0
        sb\u02B9 = Math.sin(b\u02B9);
        cb\u02B9 = Math.cos(b\u02B9);
        sl\u02B9\u03A9 = Math.sin(l\u02B9 - \u03A9);
        cl\u02B9\u03A9 = Math.cos(l\u02B9 - \u03A9);
        // Step 9.0
        const [s\u03BB\u03A9, c\u03BB\u03A9] = (0, $9QpM5.default).sincos(\u03BB - \u03A9);
        const U1 = Math.atan2(si * sb\u02B9 + ci * cb\u02B9 * sl\u02B9\u03A9, cb\u02B9 * cl\u02B9\u03A9);
        const U2 = Math.atan2(si * s\u03B2 + ci * c\u03B2 * s\u03BB\u03A9, c\u03B2 * c\u03BB\u03A9);
        const \u0394U = Math.abs(U1 - U2) // return value
        ;
        return [
            \u0394U,
            B
        ];
    };
    const f2 = function() {
        // Remainder of step 6.0
        const aEdge = 375.35 / 3600 * p / \u0394 // return value
        ;
        const bEdge = aEdge * Math.abs(sB) // return value
        ;
        // Step 8.0
        const sB\u02B9 = si * cb\u02B9 * sl\u02B9\u03A9 - ci * sb\u02B9;
        const B\u02B9 = Math.asin(sB\u02B9) // return value
        ;
        // Step 10.0
        const [\u0394\u03C8, \u0394\u03B5] = (0, $c50a9505be5a627c$export$2e2bcd8739ae039).nutation(jde);
        const \u03B5 = (0, $c50a9505be5a627c$export$2e2bcd8739ae039).meanObliquity(jde) + \u0394\u03B5;
        // Step 11.0
        let \u03BB0 = \u03A9 - Math.PI / 2;
        const \u03B20 = Math.PI / 2 - i;
        // Step 12.0
        const [sl0\u03BB, cl0\u03BB] = (0, $9QpM5.default).sincos(l0 - \u03BB);
        \u03BB += 0.005693 * p * cl0\u03BB / c\u03B2;
        \u03B2 += 0.005693 * p * sl0\u03BB * s\u03B2;
        // Step 13.0
        \u03BB0 += \u0394\u03C8;
        \u03BB += \u0394\u03C8;
        // Step 14.0
        let eq = new (0, $77f14e36e565e56c$export$2e2bcd8739ae039).Ecliptic(\u03BB0, \u03B20).toEquatorial(\u03B5);
        const [\u03B10, \u03B40] = [
            eq.ra,
            eq.dec
        ];
        eq = new (0, $77f14e36e565e56c$export$2e2bcd8739ae039).Ecliptic(\u03BB, \u03B2).toEquatorial(\u03B5);
        const [\u03B1, \u03B4] = [
            eq.ra,
            eq.dec
        ];
        // Step 15.0
        const [s\u03B40, c\u03B40] = (0, $9QpM5.default).sincos(\u03B40);
        const [s\u03B4, c\u03B4] = (0, $9QpM5.default).sincos(\u03B4);
        const [s\u03B10\u03B1, c\u03B10\u03B1] = (0, $9QpM5.default).sincos(\u03B10 - \u03B1);
        const P = Math.atan2(c\u03B40 * s\u03B10\u03B1, s\u03B40 * c\u03B4 - c\u03B40 * s\u03B4 * c\u03B10\u03B1) // return value
        ;
        return [
            B\u02B9,
            P,
            aEdge,
            bEdge
        ];
    };
    return [
        f1,
        f2
    ];
}
var $d75f745c14dccc10$export$2e2bcd8739ae039 = {
    ring: $d75f745c14dccc10$export$e7d0da6968da5dd,
    ub: $d75f745c14dccc10$export$153279fcf8905e61
};





/**
 * @copyright 2013 Sonia Keys
 * @copyright 2016 commenthol
 * @license MIT
 * @module solardisk
 */ /**
 * Solardisk: Chapter 29, Ephemeris for Physical Observations of the Sun.
 */ 
var $9QpM5 = parcelRequire("9QpM5");


function $95bcf07e14a646e8$export$b3390a82f912ab4e(jd, earth) {
    const \u03B8 = (jd - 2398220) * 2 * Math.PI / 25.38;
    const I = 7.25 * Math.PI / 180;
    const K = 73.6667 * Math.PI / 180 + 1.3958333 * Math.PI / 180 * (jd - 2396758) / (0, $9QpM5.default).JulianCentury;
    const solarPos = (0, $c85b876782fe98e7$export$2e2bcd8739ae039).trueVSOP87(earth, jd);
    const L = solarPos.lon;
    const R = solarPos.range;
    const [\u0394\u03C8, \u0394\u03B5] = (0, $c50a9505be5a627c$export$2e2bcd8739ae039).nutation(jd);
    const \u03B50 = (0, $c50a9505be5a627c$export$2e2bcd8739ae039).meanObliquity(jd);
    const \u03B5 = \u03B50 + \u0394\u03B5;
    const \u03BB = L - 20.4898 / 3600 * Math.PI / 180 / R;
    const \u03BBp = \u03BB + \u0394\u03C8;
    const [s\u03BBK, c\u03BBK] = (0, $9QpM5.default).sincos(\u03BB - K);
    const [sI, cI] = (0, $9QpM5.default).sincos(I);
    const tx = -Math.cos(\u03BBp) * Math.tan(\u03B5);
    const ty = -c\u03BBK * Math.tan(I);
    const P = Math.atan(tx) + Math.atan(ty);
    const B0 = Math.asin(s\u03BBK * sI);
    const \u03B7 = Math.atan2(-s\u03BBK * cI, -c\u03BBK);
    const L0 = (0, $9QpM5.default).pmod(\u03B7 - \u03B8, 2 * Math.PI);
    return [
        P,
        B0,
        L0
    ];
}
function $95bcf07e14a646e8$export$c04a9f24a4230e1f(c) {
    const jde = 2398140.227 + 27.2752316 * c;
    const m = 281.96 * Math.PI / 180 + 26.882476 * Math.PI / 180 * c;
    const [s2m, c2m] = (0, $9QpM5.default).sincos(2 * m);
    return jde + 0.1454 * Math.sin(m) - 0.0085 * s2m - 0.0141 * c2m;
}
var $95bcf07e14a646e8$export$2e2bcd8739ae039 = {
    ephemeris: $95bcf07e14a646e8$export$b3390a82f912ab4e,
    cycle: $95bcf07e14a646e8$export$c04a9f24a4230e1f
};



/**
 * @copyright 2013 Sonia Keys
 * @copyright 2016 commenthol
 * @license MIT
 * @module solstice
 */ /**
 * Solstice: Chapter 27: Equinoxes and Solstices.
 */ 
var $9QpM5 = parcelRequire("9QpM5");

const { abs: $5456d46a73662399$var$abs, cos: $5456d46a73662399$var$cos, sin: $5456d46a73662399$var$sin } = Math;
const $5456d46a73662399$var$D2R = Math.PI / 180;
// table 27.a - for years from -1000 to +1000
const $5456d46a73662399$var$mc0 = [
    1721139.29189,
    365242.13740,
    0.06134,
    0.00111,
    -0.00071
];
const $5456d46a73662399$var$jc0 = [
    1721233.25401,
    365241.72562,
    -0.05323,
    0.00907,
    0.00025
];
const $5456d46a73662399$var$sc0 = [
    1721325.70455,
    365242.49558,
    -0.11677,
    -0.00297,
    0.00074
];
const $5456d46a73662399$var$dc0 = [
    1721414.39987,
    365242.88257,
    -0.00769,
    -0.00933,
    -0.00006
];
// table 27.b - for years from +1000 to +3000
const $5456d46a73662399$var$mc2 = [
    2451623.80984,
    365242.37404,
    0.05169,
    -0.00411,
    -0.00057
];
const $5456d46a73662399$var$jc2 = [
    2451716.56767,
    365241.62603,
    0.00325,
    0.00888,
    -0.0003
];
const $5456d46a73662399$var$sc2 = [
    2451810.21715,
    365242.01767,
    -0.11575,
    0.00337,
    0.00078
];
const $5456d46a73662399$var$dc2 = [
    2451900.05952,
    365242.74049,
    -0.06223,
    -0.00823,
    0.00032
];
// table 27.c
const $5456d46a73662399$var$terms = function() {
    const term = [
        [
            485,
            324.96,
            1934.136
        ],
        [
            203,
            337.23,
            32964.467
        ],
        [
            199,
            342.08,
            20.186
        ],
        [
            182,
            27.85,
            445267.112
        ],
        [
            156,
            73.14,
            45036.886
        ],
        [
            136,
            171.52,
            22518.443
        ],
        [
            77,
            222.54,
            65928.934
        ],
        [
            74,
            296.72,
            3034.906
        ],
        [
            70,
            243.58,
            9037.513
        ],
        [
            58,
            119.81,
            33718.147
        ],
        [
            52,
            297.17,
            150.678
        ],
        [
            50,
            21.02,
            2281.226
        ],
        [
            45,
            247.54,
            29929.562
        ],
        [
            44,
            325.15,
            31555.956
        ],
        [
            29,
            60.93,
            4443.417
        ],
        [
            18,
            155.12,
            67555.328
        ],
        [
            17,
            288.79,
            4562.452
        ],
        [
            16,
            198.04,
            62894.029
        ],
        [
            14,
            199.76,
            31436.921
        ],
        [
            12,
            95.39,
            14577.848
        ],
        [
            12,
            287.11,
            31931.756
        ],
        [
            12,
            320.81,
            34777.259
        ],
        [
            9,
            227.73,
            1222.114
        ],
        [
            8,
            15.45,
            16859.074
        ]
    ];
    return term.map((t)=>{
        return {
            a: t[0],
            b: t[1],
            c: t[2]
        };
    });
}();
function $5456d46a73662399$export$96455b6aa6cdb149(y) {
    if (y < 1000) return $5456d46a73662399$var$eq(y, $5456d46a73662399$var$mc0);
    return $5456d46a73662399$var$eq(y - 2000, $5456d46a73662399$var$mc2);
}
function $5456d46a73662399$export$564f8e35389cfbc3(y) {
    if (y < 1000) return $5456d46a73662399$var$eq(y, $5456d46a73662399$var$jc0);
    return $5456d46a73662399$var$eq(y - 2000, $5456d46a73662399$var$jc2);
}
function $5456d46a73662399$export$2ef67b914e0dd9f3(y) {
    if (y < 1000) return $5456d46a73662399$var$eq(y, $5456d46a73662399$var$sc0);
    return $5456d46a73662399$var$eq(y - 2000, $5456d46a73662399$var$sc2);
}
function $5456d46a73662399$export$d2ce3f2d00d43a49(y) {
    if (y < 1000) return $5456d46a73662399$var$eq(y, $5456d46a73662399$var$dc0);
    return $5456d46a73662399$var$eq(y - 2000, $5456d46a73662399$var$dc2);
}
/**
 * Fast calculation of solstices/ equinoxes
 * Accuracy is within one minute of time for the years 1951-2050.
 *
 * @param {Number} y - (int) year
 * @param {Array} c - term from table 27.a / 27.b
 * @returns {Number} JDE
 */ function $5456d46a73662399$var$eq(y, c) {
    const J0 = (0, $9QpM5.default).horner(y * 0.001, c);
    const T = (0, $9QpM5.default).J2000Century(J0);
    const W = 35999.373 * $5456d46a73662399$var$D2R * T - 2.47 * $5456d46a73662399$var$D2R;
    const \u0394\u03BB = 1 + 0.0334 * $5456d46a73662399$var$cos(W) + 0.0007 * $5456d46a73662399$var$cos(2 * W);
    let S = 0;
    for(let i = $5456d46a73662399$var$terms.length - 1; i >= 0; i--){
        const t = $5456d46a73662399$var$terms[i];
        S += t.a * $5456d46a73662399$var$cos((t.b + t.c * T) * $5456d46a73662399$var$D2R);
    }
    return J0 + 0.00001 * S / \u0394\u03BB;
}
function $5456d46a73662399$export$11b71b22db4d0d45(year, planet) {
    return $5456d46a73662399$export$26bbe58595f5aff6(year, planet, 0);
}
function $5456d46a73662399$export$fa49791c467ee133(year, planet) {
    return $5456d46a73662399$export$26bbe58595f5aff6(year, planet, Math.PI / 2);
}
function $5456d46a73662399$export$b873eb137cf57a0(year, planet) {
    return $5456d46a73662399$export$26bbe58595f5aff6(year, planet, Math.PI);
}
function $5456d46a73662399$export$257bea9766ab750f(year, planet) {
    return $5456d46a73662399$export$26bbe58595f5aff6(year, planet, Math.PI * 3 / 2);
}
function $5456d46a73662399$export$26bbe58595f5aff6(year, planet, lon) {
    let c;
    let ct;
    if (year < 1000) ct = [
        $5456d46a73662399$var$mc0,
        $5456d46a73662399$var$jc0,
        $5456d46a73662399$var$sc0,
        $5456d46a73662399$var$dc0
    ];
    else {
        ct = [
            $5456d46a73662399$var$mc2,
            $5456d46a73662399$var$jc2,
            $5456d46a73662399$var$sc2,
            $5456d46a73662399$var$dc2
        ];
        year -= 2000;
    }
    lon = lon % (Math.PI * 2);
    if (lon < Math.PI / 2) c = ct[0];
    else if (lon < Math.PI) c = ct[1];
    else if (lon < Math.PI * 3 / 2) c = ct[2];
    else c = ct[3];
    return $5456d46a73662399$var$eq2(year, planet, lon, c);
}
/**
  * Accurate calculation of solstices/ equinoxes
  * Result is accurate to one second of time.
  *
  * @param {Number} year - (int) year
  * @param {planetposition.Planet} planet - vsop87 planet
  * @param {Number} lon - longitude in radians
  * @param {Array} c - term from table 27.a / 27.b
  * @returns {Number} JDE
  */ function $5456d46a73662399$var$eq2(year, planet, lon, c) {
    let J0 = (0, $9QpM5.default).horner(year * 0.001, c);
    for(;;){
        const a = (0, $c85b876782fe98e7$export$2e2bcd8739ae039).apparentVSOP87(planet, J0);
        const c = 58 * $5456d46a73662399$var$sin(lon - a.lon) // (27.1) p. 180
        ;
        J0 += c;
        if ($5456d46a73662399$var$abs(c) < 0.000005) break;
    }
    return J0;
}
var $5456d46a73662399$export$2e2bcd8739ae039 = {
    march: $5456d46a73662399$export$96455b6aa6cdb149,
    june: $5456d46a73662399$export$564f8e35389cfbc3,
    september: $5456d46a73662399$export$2ef67b914e0dd9f3,
    december: $5456d46a73662399$export$d2ce3f2d00d43a49,
    march2: $5456d46a73662399$export$11b71b22db4d0d45,
    june2: $5456d46a73662399$export$fa49791c467ee133,
    september2: $5456d46a73662399$export$b873eb137cf57a0,
    december2: $5456d46a73662399$export$257bea9766ab750f,
    longitude: $5456d46a73662399$export$26bbe58595f5aff6
};


/**
 * @copyright 2013 Sonia Keys
 * @copyright 2016 commenthol
 * @license MIT
 * @module stellar
 */ /**
 * Stellar: Chapter 56, Stellar Magnitudes.
 */ /**
 * Sum returns the combined apparent magnitude of two stars.
 */ function $b80570d0ac5b7035$export$8a63f25cc62965f1(m1, m2) {
    const x = 0.4 * (m2 - m1);
    return m2 - 2.5 * Math.log10(Math.pow(10, x) + 1);
}
function $b80570d0ac5b7035$export$c0c3fb6bc69ae40f(m) {
    let s = 0;
    for (const mi of m)s += Math.pow(10, -0.4 * mi);
    return -2.5 * Math.log10(s);
}
function $b80570d0ac5b7035$export$85f17f73487c6e7d(m1, m2) {
    const x = 0.4 * (m2 - m1);
    return Math.pow(10, x);
}
function $b80570d0ac5b7035$export$acaf96a27438246b(ratio) {
    return 2.5 * Math.log10(ratio);
}
function $b80570d0ac5b7035$export$872a16a635d96404(m, \u03C0) {
    return m + 5 + 5 * Math.log10(\u03C0);
}
function $b80570d0ac5b7035$export$e267de468830c8fc(m, d) {
    return m + 5 - 5 * Math.log10(d);
}
var $b80570d0ac5b7035$export$2e2bcd8739ae039 = {
    sum: $b80570d0ac5b7035$export$8a63f25cc62965f1,
    sumN: $b80570d0ac5b7035$export$c0c3fb6bc69ae40f,
    ratio: $b80570d0ac5b7035$export$85f17f73487c6e7d,
    difference: $b80570d0ac5b7035$export$acaf96a27438246b,
    absoluteByParallax: $b80570d0ac5b7035$export$872a16a635d96404,
    absoluteByDistance: $b80570d0ac5b7035$export$e267de468830c8fc
};


/**
 * @copyright 2013 Sonia Keys
 * @copyright 2016 commenthol
 * @license MIT
 * @module sundial
 */ /**
 * Sundial: Chapter 58, Calculation of a Planar Sundial.
 */ 
var $9QpM5 = parcelRequire("9QpM5");
/**
 * Point return type represents a point to be used in constructing the sundial.
 */ function $5a849cd7c1e53e55$var$Point(x, y) {
    this.x = x || 0;
    this.y = y || 0;
}
/**
 * Line holds data to draw an hour line on the sundial.
 */ function $5a849cd7c1e53e55$var$Line(hour, points) {
    this.hour = hour // 0 to 24
    ;
    this.points = points || [] // One or more points corresponding to the hour.
    ;
}
const $5a849cd7c1e53e55$var$m = [
    -23.44,
    -20.15,
    -11.47,
    0,
    11.47,
    20.15,
    23.44
];
function $5a849cd7c1e53e55$export$78b80bc2f5d4953a(\u03C6, D, a, z) {
    const [s\u03C6, c\u03C6] = (0, $9QpM5.default).sincos(\u03C6);
    const t\u03C6 = s\u03C6 / c\u03C6;
    const [sD, cD] = (0, $9QpM5.default).sincos(D);
    const [sz, cz] = (0, $9QpM5.default).sincos(z);
    const P = s\u03C6 * cz - c\u03C6 * sz * cD;
    const lines = [];
    for(let i = 0; i < 24; i++){
        const l = new $5a849cd7c1e53e55$var$Line(i);
        const H = (i - 12) * 15 * Math.PI / 180;
        const aH = Math.abs(H);
        const [sH, cH] = (0, $9QpM5.default).sincos(H);
        for (const d of $5a849cd7c1e53e55$var$m){
            const t\u03B4 = Math.tan(d * Math.PI / 180);
            const H0 = Math.acos(-t\u03C6 * t\u03B4);
            if (aH > H0) continue; // sun below horizon
            const Q = sD * sz * sH + (c\u03C6 * cz + s\u03C6 * sz * cD) * cH + P * t\u03B4;
            if (Q < 0) continue; // sun below plane of sundial
            const Nx = cD * sH - sD * (s\u03C6 * cH - c\u03C6 * t\u03B4);
            const Ny = cz * sD * sH - (c\u03C6 * sz - s\u03C6 * cz * cD) * cH - (s\u03C6 * sz + c\u03C6 * cz * cD) * t\u03B4;
            l.points.push(new $5a849cd7c1e53e55$var$Point(a * Nx / Q, a * Ny / Q));
        }
        if (l.points.length > 0) lines.push(l);
    }
    const center = new $5a849cd7c1e53e55$var$Point();
    center.x = a / P * c\u03C6 * sD;
    center.y = -a / P * (s\u03C6 * sz + c\u03C6 * cz * cD);
    const aP = Math.abs(P);
    const u = a / aP;
    const \u03C8 = Math.asin(aP);
    return {
        lines: lines,
        center: center,
        length: u,
        angle: \u03C8
    };
}
function $5a849cd7c1e53e55$export$6b257beed8f4f1f3(\u03C6, a) {
    const t\u03C6 = Math.tan(\u03C6);
    const n = [];
    const s = [];
    for(let i = 0; i < 24; i++){
        const nl = new $5a849cd7c1e53e55$var$Line(i);
        const sl = new $5a849cd7c1e53e55$var$Line(i);
        const H = (i - 12) * 15 * Math.PI / 180;
        const aH = Math.abs(H);
        const [sH, cH] = (0, $9QpM5.default).sincos(H);
        for (const d of $5a849cd7c1e53e55$var$m){
            const t\u03B4 = Math.tan(d * Math.PI / 180);
            const H0 = Math.acos(-t\u03C6 * t\u03B4);
            if (aH > H0) continue;
            const x = -a * sH / t\u03B4;
            const yy = a * cH / t\u03B4;
            if (t\u03B4 < 0) sl.points.push(new $5a849cd7c1e53e55$var$Point(x, yy));
            else nl.points.push(new $5a849cd7c1e53e55$var$Point(x, -yy));
        }
        if (nl.points.length > 0) n.push(nl);
        if (sl.points.length > 0) s.push(sl);
    }
    return {
        north: n,
        south: s
    };
}
function $5a849cd7c1e53e55$export$641ecd0b2bc39508(\u03C6, a) {
    const [s\u03C6, c\u03C6] = (0, $9QpM5.default).sincos(\u03C6);
    const t\u03C6 = s\u03C6 / c\u03C6;
    const lines = [];
    for(let i = 0; i < 24; i++){
        const l = new $5a849cd7c1e53e55$var$Line(i);
        const H = (i - 12) * 15 * Math.PI / 180;
        const aH = Math.abs(H);
        const [sH, cH] = (0, $9QpM5.default).sincos(H);
        for (const d of $5a849cd7c1e53e55$var$m){
            const t\u03B4 = Math.tan(d * Math.PI / 180);
            const H0 = Math.acos(-t\u03C6 * t\u03B4);
            if (aH > H0) continue; // sun below horizon
            const Q = c\u03C6 * cH + s\u03C6 * t\u03B4;
            const x = a * sH / Q;
            const y = a * (s\u03C6 * cH - c\u03C6 * t\u03B4) / Q;
            l.points.push(new $5a849cd7c1e53e55$var$Point(x, y));
        }
        if (l.points.length > 0) lines.push(l);
    }
    const center = new $5a849cd7c1e53e55$var$Point(0, -a / t\u03C6);
    const u = a / Math.abs(s\u03C6);
    return {
        lines: lines,
        center: center,
        length: u
    };
}
function $5a849cd7c1e53e55$export$32f8a6eb41d46820(\u03C6, D, a) {
    const [s\u03C6, c\u03C6] = (0, $9QpM5.default).sincos(\u03C6);
    const t\u03C6 = s\u03C6 / c\u03C6;
    const [sD, cD] = (0, $9QpM5.default).sincos(D);
    const lines = [];
    for(let i = 0; i < 24; i++){
        const l = new $5a849cd7c1e53e55$var$Line(i);
        const H = (i - 12) * 15 * Math.PI / 180;
        const aH = Math.abs(H);
        const [sH, cH] = (0, $9QpM5.default).sincos(H);
        for (const d of $5a849cd7c1e53e55$var$m){
            const t\u03B4 = Math.tan(d * Math.PI / 180);
            const H0 = Math.acos(-t\u03C6 * t\u03B4);
            if (aH > H0) continue; // sun below horizon
            const Q = sD * sH + s\u03C6 * cD * cH - c\u03C6 * cD * t\u03B4;
            if (Q < 0) continue; // sun below plane of sundial
            const x = a * (cD * sH - s\u03C6 * sD * cH + c\u03C6 * sD * t\u03B4) / Q;
            const y = -a * (c\u03C6 * cH + s\u03C6 * t\u03B4) / Q;
            l.points.push(new $5a849cd7c1e53e55$var$Point(x, y));
        }
        if (l.points.length > 0) lines.push(l);
    }
    const center = new $5a849cd7c1e53e55$var$Point();
    center.x = -a * sD / cD;
    center.y = a * t\u03C6 / cD;
    const u = a / Math.abs(c\u03C6 * cD);
    return {
        lines: lines,
        center: center,
        length: u
    };
}
var $5a849cd7c1e53e55$export$2e2bcd8739ae039 = {
    general: $5a849cd7c1e53e55$export$78b80bc2f5d4953a,
    equatorial: $5a849cd7c1e53e55$export$6b257beed8f4f1f3,
    horizontal: $5a849cd7c1e53e55$export$641ecd0b2bc39508,
    vertical: $5a849cd7c1e53e55$export$32f8a6eb41d46820
};


/**
 * @copyright 2016 commenthol
 * @license MIT
 * @module sunrise
 */ /**
 * Sunrise: Compute rise, noon, set of the Sun for an earth observer
 */ /* eslint key-spacing: 0 */ 
var $9QpM5 = parcelRequire("9QpM5");





const $29ef561e1ad8dac5$var$stdh0 = {
    sunrise: new (0, $c953199d551a315b$export$2e2bcd8739ae039).Angle(true, 0, 50, 0).rad(),
    sunriseEnd: new (0, $c953199d551a315b$export$2e2bcd8739ae039).Angle(true, 0, 18, 0).rad(),
    twilight: new (0, $c953199d551a315b$export$2e2bcd8739ae039).Angle(true, 6, 0, 0).rad(),
    nauticalTwilight: new (0, $c953199d551a315b$export$2e2bcd8739ae039).Angle(true, 12, 0, 0).rad(),
    night: new (0, $c953199d551a315b$export$2e2bcd8739ae039).Angle(true, 18, 0, 0).rad(),
    goldenHour: new (0, $c953199d551a315b$export$2e2bcd8739ae039).Angle(false, 6, 0, 0).rad()
};
const $29ef561e1ad8dac5$var$stdh0Sunrise = (refraction)=>(0, $b764fc4e2cf928d6$export$2e2bcd8739ae039).refraction($29ef561e1ad8dac5$var$stdh0.sunrise, refraction);
const $29ef561e1ad8dac5$var$stdh0SunriseEnd = (refraction)=>(0, $b764fc4e2cf928d6$export$2e2bcd8739ae039).refraction($29ef561e1ad8dac5$var$stdh0.sunriseEnd, refraction);
const $29ef561e1ad8dac5$var$stdh0Twilight = (refraction)=>(0, $b764fc4e2cf928d6$export$2e2bcd8739ae039).refraction($29ef561e1ad8dac5$var$stdh0.twilight, refraction);
const $29ef561e1ad8dac5$var$stdh0NauticalTwilight = (refraction)=>(0, $b764fc4e2cf928d6$export$2e2bcd8739ae039).refraction($29ef561e1ad8dac5$var$stdh0.nauticalTwilight, refraction);
const $29ef561e1ad8dac5$var$stdh0Night = (refraction)=>(0, $b764fc4e2cf928d6$export$2e2bcd8739ae039).refraction($29ef561e1ad8dac5$var$stdh0.night, refraction);
const $29ef561e1ad8dac5$var$stdh0GoldenHour = (refraction)=>(0, $b764fc4e2cf928d6$export$2e2bcd8739ae039).refraction($29ef561e1ad8dac5$var$stdh0.goldenHour, refraction);
class $29ef561e1ad8dac5$export$bf182411798a7d0d {
    /**
   * Computes time of sunrise, sunset for a given day `date` of an observer on earth given by latitude and longitude.
   * Methods may return `undefined` instead of `julian.Calendar` for latitudes very near the poles.
   * @param {julian.Calendar} date - calendar date
   * @param {number} lat - latitude of observer in the range of (-89.6, 89.6)
   * @param {number} lon - longitude of observer (measured positively westwards, New York = 40.7° lat, 74° lon)
   * @param {number} [refraction] - optional refraction
   */ constructor(date, lat, lon, refraction){
        this.date = date;
        this.jde = date.midnight().toJDE();
        this.lat = (0, $c953199d551a315b$export$2e2bcd8739ae039).angleFromDeg(lat);
        this.lon = (0, $c953199d551a315b$export$2e2bcd8739ae039).angleFromDeg(lon);
        this.refraction = refraction;
    }
    _calcNoon(jde) {
        const etime = (0, $c953199d551a315b$export$2e2bcd8739ae039).secFromHourAngle((0, $7195c11bc2a1ace6$export$2e2bcd8739ae039).eSmart(jde));
        const delta = (0, $c953199d551a315b$export$2e2bcd8739ae039).secFromHourAngle(this.lon);
        const time = 43200 /* noon */  + delta - etime // in seconds
        ;
        return (0, $9QpM5.default).pmod(time / 86400, 86400);
    }
    _calcRiseOrSet(jde, h0, isSet) {
        const etime = (0, $c953199d551a315b$export$2e2bcd8739ae039).secFromHourAngle((0, $7195c11bc2a1ace6$export$2e2bcd8739ae039).eSmart(jde));
        const solarDec = (0, $c85b876782fe98e7$export$2e2bcd8739ae039).apparentEquatorial(jde).dec;
        let ha = (0, $b764fc4e2cf928d6$export$2e2bcd8739ae039).hourAngle(this.lat, h0, solarDec);
        if (isSet) ha = -ha;
        const delta = (0, $c953199d551a315b$export$2e2bcd8739ae039).secFromHourAngle(ha - this.lon);
        const time = 43200 /* noon */  - delta - etime // in seconds
        ;
        return time / 86400;
    }
    _calcPolarDayNight(h0, isSet, step) {
        let jde = this.jde;
        let t;
        let failCnt = 0;
        while(failCnt < 190){
            jde += step;
            try {
                t = this._calcRiseOrSet(jde, h0, isSet);
                t = this._calcRiseOrSet(jde + t, h0, isSet);
                break;
            } catch (e) {
                t = undefined;
                failCnt++;
            }
        }
        if (t === undefined) return;
        return new (0, $b4d5bd4b4d56819f$export$2e2bcd8739ae039).Calendar().fromJDE(jde + t);
    }
    _calc(h0, isSet) {
        let t;
        const jde = this.jde;
        // calc 2times for higher accuracy
        try {
            t = this._calcRiseOrSet(jde, h0, isSet);
            t = this._calcRiseOrSet(jde + t, h0, isSet);
            return new (0, $b4d5bd4b4d56819f$export$2e2bcd8739ae039).Calendar().fromJDE(jde + t);
        } catch (e) {
            let step = isSet ? -1 : 1;
            const doy = this.date.dayOfYear();
            if (this.lat > 0 && doy > 76 && doy < 267 || // northern hemisphere
            this.lat < 0 && (doy < 83 || doy > 262) // southern hemisphere
            ) step = -step;
            return this._calcPolarDayNight(h0, isSet, step);
        }
    }
    /**
   * time of solar transit
   * @return {julian.Calendar} time of noon
   */ noon() {
        const jde = this.jde;
        // calc 2times for higher accuracy
        let t = this._calcNoon(jde + this.lon / (2 * Math.PI));
        t = this._calcNoon(jde + t);
        return new (0, $b4d5bd4b4d56819f$export$2e2bcd8739ae039).Calendar().fromJDE(jde + t);
    }
    /**
   * Solar limb appears over the easter horizon in the morning
   * @return {julian.Calendar} time of sunrise
   */ rise() {
        return this._calc($29ef561e1ad8dac5$var$stdh0Sunrise(this.refraction), false);
    }
    /**
   * @return {julian.Calendar} time of sunset
   * Solar limb disappears on the western horizon in the evening
   */ set() {
        return this._calc($29ef561e1ad8dac5$var$stdh0Sunrise(this.refraction), true);
    }
    /**
   * Solar limb is fully visible at the easter horizon
   * @return {julian.Calendar} time of sunrise end
   */ riseEnd() {
        return this._calc($29ef561e1ad8dac5$var$stdh0SunriseEnd(this.refraction), false);
    }
    /**
   * Solar limb starts disappearing on the western horizon in the evening
   * @return {julian.Calendar} time of sunset start
   */ setStart() {
        return this._calc($29ef561e1ad8dac5$var$stdh0SunriseEnd(this.refraction), true);
    }
    /**
   * Dawn, there is still enough light for objects to be distinguishable,
   * @return {julian.Calendar} time of dawn
   */ dawn() {
        return this._calc($29ef561e1ad8dac5$var$stdh0Twilight(this.refraction), false);
    }
    /**
   * Dusk, there is still enough light for objects to be distinguishable
   * Bright stars and planets are visible by naked eye
   * @return {julian.Calendar} time of dusk
   */ dusk() {
        return this._calc($29ef561e1ad8dac5$var$stdh0Twilight(this.refraction), true);
    }
    /**
   * nautical dawn - Horizon gets visible by naked eye
   * @return {julian.Calendar} time of nautical dawn
   */ nauticalDawn() {
        return this._calc($29ef561e1ad8dac5$var$stdh0NauticalTwilight(this.refraction), false);
    }
    /**
   * nautical dusk - Horizon is no longer visible by naked eye
   * @return {julian.Calendar} time of nautical dusk
   */ nauticalDusk() {
        return this._calc($29ef561e1ad8dac5$var$stdh0NauticalTwilight(this.refraction), true);
    }
    /**
   * night starts - No sunlight illumination of the sky, such no intereferance
   * with astronomical observations.
   * @return {julian.Calendar} time of start of night
   */ nightStart() {
        return this._calc($29ef561e1ad8dac5$var$stdh0Night(this.refraction), true);
    }
    /**
   * night end - Sunlight starts illumination of the sky and interferes
   * with astronomical observations.
   * @return {julian.Calendar} time of end of night
   */ nightEnd() {
        return this._calc($29ef561e1ad8dac5$var$stdh0Night(this.refraction), false);
    }
    /**
   * Start of "golden hour" before sunset
   * @return {julian.Calendar} time of start of golden hour
   */ goldenHourStart() {
        return this._calc($29ef561e1ad8dac5$var$stdh0GoldenHour(this.refraction), true);
    }
    /**
   * End of "golden hour" after sunrise
   * @return {julian.Calendar} time of end of golden hour
   */ goldenHourEnd() {
        return this._calc($29ef561e1ad8dac5$var$stdh0GoldenHour(this.refraction), false);
    }
}
var $29ef561e1ad8dac5$export$2e2bcd8739ae039 = {
    Sunrise: $29ef561e1ad8dac5$export$bf182411798a7d0d
};





var $2Tywo = parcelRequire("2Tywo");
/*!
 * CSSPlugin 3.12.7
 * https://gsap.com
 *
 * Copyright 2008-2025, GreenSock. All rights reserved.
 * Subject to the terms at https://gsap.com/standard-license or for
 * Club GSAP members, the agreement issued with that membership.
 * @author: Jack Doyle, jack@greensock.com
*/ /* eslint-disable */ 
var $2Tywo = parcelRequire("2Tywo");
var $0cdfc2eaac330c87$var$_win, $0cdfc2eaac330c87$var$_doc, $0cdfc2eaac330c87$var$_docElement, $0cdfc2eaac330c87$var$_pluginInitted, $0cdfc2eaac330c87$var$_tempDiv, $0cdfc2eaac330c87$var$_tempDivStyler, $0cdfc2eaac330c87$var$_recentSetterPlugin, $0cdfc2eaac330c87$var$_reverting, $0cdfc2eaac330c87$var$_windowExists = function _windowExists() {
    return typeof window !== "undefined";
}, $0cdfc2eaac330c87$var$_transformProps = {}, $0cdfc2eaac330c87$var$_RAD2DEG = 180 / Math.PI, $0cdfc2eaac330c87$var$_DEG2RAD = Math.PI / 180, $0cdfc2eaac330c87$var$_atan2 = Math.atan2, $0cdfc2eaac330c87$var$_bigNum = 1e8, $0cdfc2eaac330c87$var$_capsExp = /([A-Z])/g, $0cdfc2eaac330c87$var$_horizontalExp = /(left|right|width|margin|padding|x)/i, $0cdfc2eaac330c87$var$_complexExp = /[\s,\(]\S/, $0cdfc2eaac330c87$var$_propertyAliases = {
    autoAlpha: "opacity,visibility",
    scale: "scaleX,scaleY",
    alpha: "opacity"
}, $0cdfc2eaac330c87$var$_renderCSSProp = function _renderCSSProp(ratio, data) {
    return data.set(data.t, data.p, Math.round((data.s + data.c * ratio) * 10000) / 10000 + data.u, data);
}, $0cdfc2eaac330c87$var$_renderPropWithEnd = function _renderPropWithEnd(ratio, data) {
    return data.set(data.t, data.p, ratio === 1 ? data.e : Math.round((data.s + data.c * ratio) * 10000) / 10000 + data.u, data);
}, $0cdfc2eaac330c87$var$_renderCSSPropWithBeginning = function _renderCSSPropWithBeginning(ratio, data) {
    return data.set(data.t, data.p, ratio ? Math.round((data.s + data.c * ratio) * 10000) / 10000 + data.u : data.b, data);
}, //if units change, we need a way to render the original unit/value when the tween goes all the way back to the beginning (ratio:0)
$0cdfc2eaac330c87$var$_renderRoundedCSSProp = function _renderRoundedCSSProp(ratio, data) {
    var value = data.s + data.c * ratio;
    data.set(data.t, data.p, ~~(value + (value < 0 ? -0.5 : .5)) + data.u, data);
}, $0cdfc2eaac330c87$var$_renderNonTweeningValue = function _renderNonTweeningValue(ratio, data) {
    return data.set(data.t, data.p, ratio ? data.e : data.b, data);
}, $0cdfc2eaac330c87$var$_renderNonTweeningValueOnlyAtEnd = function _renderNonTweeningValueOnlyAtEnd(ratio, data) {
    return data.set(data.t, data.p, ratio !== 1 ? data.b : data.e, data);
}, $0cdfc2eaac330c87$var$_setterCSSStyle = function _setterCSSStyle(target, property, value) {
    return target.style[property] = value;
}, $0cdfc2eaac330c87$var$_setterCSSProp = function _setterCSSProp(target, property, value) {
    return target.style.setProperty(property, value);
}, $0cdfc2eaac330c87$var$_setterTransform = function _setterTransform(target, property, value) {
    return target._gsap[property] = value;
}, $0cdfc2eaac330c87$var$_setterScale = function _setterScale(target, property, value) {
    return target._gsap.scaleX = target._gsap.scaleY = value;
}, $0cdfc2eaac330c87$var$_setterScaleWithRender = function _setterScaleWithRender(target, property, value, data, ratio) {
    var cache = target._gsap;
    cache.scaleX = cache.scaleY = value;
    cache.renderTransform(ratio, cache);
}, $0cdfc2eaac330c87$var$_setterTransformWithRender = function _setterTransformWithRender(target, property, value, data, ratio) {
    var cache = target._gsap;
    cache[property] = value;
    cache.renderTransform(ratio, cache);
}, $0cdfc2eaac330c87$var$_transformProp = "transform", $0cdfc2eaac330c87$var$_transformOriginProp = $0cdfc2eaac330c87$var$_transformProp + "Origin", $0cdfc2eaac330c87$var$_saveStyle = function _saveStyle(property, isNotCSS) {
    var _this = this;
    var target = this.target, style = target.style, cache = target._gsap;
    if (property in $0cdfc2eaac330c87$var$_transformProps && style) {
        this.tfm = this.tfm || {};
        if (property !== "transform") {
            property = $0cdfc2eaac330c87$var$_propertyAliases[property] || property;
            ~property.indexOf(",") ? property.split(",").forEach(function(a) {
                return _this.tfm[a] = $0cdfc2eaac330c87$var$_get(target, a);
            }) : this.tfm[property] = cache.x ? cache[property] : $0cdfc2eaac330c87$var$_get(target, property); // note: scale would map to "scaleX,scaleY", thus we loop and apply them both.
            property === $0cdfc2eaac330c87$var$_transformOriginProp && (this.tfm.zOrigin = cache.zOrigin);
        } else return $0cdfc2eaac330c87$var$_propertyAliases.transform.split(",").forEach(function(p) {
            return _saveStyle.call(_this, p, isNotCSS);
        });
        if (this.props.indexOf($0cdfc2eaac330c87$var$_transformProp) >= 0) return;
        if (cache.svg) {
            this.svgo = target.getAttribute("data-svg-origin");
            this.props.push($0cdfc2eaac330c87$var$_transformOriginProp, isNotCSS, "");
        }
        property = $0cdfc2eaac330c87$var$_transformProp;
    }
    (style || isNotCSS) && this.props.push(property, isNotCSS, style[property]);
}, $0cdfc2eaac330c87$var$_removeIndependentTransforms = function _removeIndependentTransforms(style) {
    if (style.translate) {
        style.removeProperty("translate");
        style.removeProperty("scale");
        style.removeProperty("rotate");
    }
}, $0cdfc2eaac330c87$var$_revertStyle = function _revertStyle() {
    var props = this.props, target = this.target, style = target.style, cache = target._gsap, i, p;
    for(i = 0; i < props.length; i += 3){
        // stored like this: property, isNotCSS, value
        if (!props[i + 1]) props[i + 2] ? style[props[i]] = props[i + 2] : style.removeProperty(props[i].substr(0, 2) === "--" ? props[i] : props[i].replace($0cdfc2eaac330c87$var$_capsExp, "-$1").toLowerCase());
        else if (props[i + 1] === 2) // non-CSS value (function-based)
        target[props[i]](props[i + 2]);
        else // non-CSS value (not function-based)
        target[props[i]] = props[i + 2];
    }
    if (this.tfm) {
        for(p in this.tfm)cache[p] = this.tfm[p];
        if (cache.svg) {
            cache.renderTransform();
            target.setAttribute("data-svg-origin", this.svgo || "");
        }
        i = $0cdfc2eaac330c87$var$_reverting();
        if ((!i || !i.isStart) && !style[$0cdfc2eaac330c87$var$_transformProp]) {
            $0cdfc2eaac330c87$var$_removeIndependentTransforms(style);
            if (cache.zOrigin && style[$0cdfc2eaac330c87$var$_transformOriginProp]) {
                style[$0cdfc2eaac330c87$var$_transformOriginProp] += " " + cache.zOrigin + "px"; // since we're uncaching, we must put the zOrigin back into the transformOrigin so that we can pull it out accurately when we parse again. Otherwise, we'd lose the z portion of the origin since we extract it to protect from Safari bugs.
                cache.zOrigin = 0;
                cache.renderTransform();
            }
            cache.uncache = 1; // if it's a startAt that's being reverted in the _initTween() of the core, we don't need to uncache transforms. This is purely a performance optimization.
        }
    }
}, $0cdfc2eaac330c87$var$_getStyleSaver = function _getStyleSaver(target, properties) {
    var saver = {
        target: target,
        props: [],
        revert: $0cdfc2eaac330c87$var$_revertStyle,
        save: $0cdfc2eaac330c87$var$_saveStyle
    };
    target._gsap || (0, $2Tywo.gsap).core.getCache(target); // just make sure there's a _gsap cache defined because we read from it in _saveStyle() and it's more efficient to just check it here once.
    properties && target.style && target.nodeType && properties.split(",").forEach(function(p) {
        return saver.save(p);
    }); // make sure it's a DOM node too.
    return saver;
}, $0cdfc2eaac330c87$var$_supports3D, $0cdfc2eaac330c87$export$a232bb0480ae674a = function _createElement(type, ns) {
    var e = $0cdfc2eaac330c87$var$_doc.createElementNS ? $0cdfc2eaac330c87$var$_doc.createElementNS((ns || "http://www.w3.org/1999/xhtml").replace(/^https/, "http"), type) : $0cdfc2eaac330c87$var$_doc.createElement(type); //some servers swap in https for http in the namespace which can break things, making "style" inaccessible.
    return e && e.style ? e : $0cdfc2eaac330c87$var$_doc.createElement(type); //some environments won't allow access to the element's style when created with a namespace in which case we default to the standard createElement() to work around the issue. Also note that when GSAP is embedded directly inside an SVG file, createElement() won't allow access to the style object in Firefox (see https://gsap.com/forums/topic/20215-problem-using-tweenmax-in-standalone-self-containing-svg-file-err-cannot-set-property-csstext-of-undefined/).
}, $0cdfc2eaac330c87$var$_getComputedProperty = function _getComputedProperty(target, property, skipPrefixFallback) {
    var cs = getComputedStyle(target);
    return cs[property] || cs.getPropertyValue(property.replace($0cdfc2eaac330c87$var$_capsExp, "-$1").toLowerCase()) || cs.getPropertyValue(property) || !skipPrefixFallback && _getComputedProperty(target, $0cdfc2eaac330c87$export$8cbef5dd49a09c8b(property) || property, 1) || ""; //css variables may not need caps swapped out for dashes and lowercase.
}, $0cdfc2eaac330c87$var$_prefixes = "O,Moz,ms,Ms,Webkit".split(","), $0cdfc2eaac330c87$export$8cbef5dd49a09c8b = function _checkPropPrefix(property, element, preferPrefix) {
    var e = element || $0cdfc2eaac330c87$var$_tempDiv, s = e.style, i = 5;
    if (property in s && !preferPrefix) return property;
    property = property.charAt(0).toUpperCase() + property.substr(1);
    while(i-- && !($0cdfc2eaac330c87$var$_prefixes[i] + property in s));
    return i < 0 ? null : (i === 3 ? "ms" : i >= 0 ? $0cdfc2eaac330c87$var$_prefixes[i] : "") + property;
}, $0cdfc2eaac330c87$var$_initCore = function _initCore() {
    if ($0cdfc2eaac330c87$var$_windowExists() && window.document) {
        $0cdfc2eaac330c87$var$_win = window;
        $0cdfc2eaac330c87$var$_doc = $0cdfc2eaac330c87$var$_win.document;
        $0cdfc2eaac330c87$var$_docElement = $0cdfc2eaac330c87$var$_doc.documentElement;
        $0cdfc2eaac330c87$var$_tempDiv = $0cdfc2eaac330c87$export$a232bb0480ae674a("div") || {
            style: {}
        };
        $0cdfc2eaac330c87$var$_tempDivStyler = $0cdfc2eaac330c87$export$a232bb0480ae674a("div");
        $0cdfc2eaac330c87$var$_transformProp = $0cdfc2eaac330c87$export$8cbef5dd49a09c8b($0cdfc2eaac330c87$var$_transformProp);
        $0cdfc2eaac330c87$var$_transformOriginProp = $0cdfc2eaac330c87$var$_transformProp + "Origin";
        $0cdfc2eaac330c87$var$_tempDiv.style.cssText = "border-width:0;line-height:0;position:absolute;padding:0"; //make sure to override certain properties that may contaminate measurements, in case the user has overreaching style sheets.
        $0cdfc2eaac330c87$var$_supports3D = !!$0cdfc2eaac330c87$export$8cbef5dd49a09c8b("perspective");
        $0cdfc2eaac330c87$var$_reverting = (0, $2Tywo.gsap).core.reverting;
        $0cdfc2eaac330c87$var$_pluginInitted = 1;
    }
}, $0cdfc2eaac330c87$var$_getReparentedCloneBBox = function _getReparentedCloneBBox(target) {
    //works around issues in some browsers (like Firefox) that don't correctly report getBBox() on SVG elements inside a <defs> element and/or <mask>. We try creating an SVG, adding it to the documentElement and toss the element in there so that it's definitely part of the rendering tree, then grab the bbox and if it works, we actually swap out the original getBBox() method for our own that does these extra steps whenever getBBox is needed. This helps ensure that performance is optimal (only do all these extra steps when absolutely necessary...most elements don't need it).
    var owner = target.ownerSVGElement, svg = $0cdfc2eaac330c87$export$a232bb0480ae674a("svg", owner && owner.getAttribute("xmlns") || "http://www.w3.org/2000/svg"), clone = target.cloneNode(true), bbox;
    clone.style.display = "block";
    svg.appendChild(clone);
    $0cdfc2eaac330c87$var$_docElement.appendChild(svg);
    try {
        bbox = clone.getBBox();
    } catch (e) {}
    svg.removeChild(clone);
    $0cdfc2eaac330c87$var$_docElement.removeChild(svg);
    return bbox;
}, $0cdfc2eaac330c87$var$_getAttributeFallbacks = function _getAttributeFallbacks(target, attributesArray) {
    var i = attributesArray.length;
    while(i--){
        if (target.hasAttribute(attributesArray[i])) return target.getAttribute(attributesArray[i]);
    }
}, $0cdfc2eaac330c87$export$41bc7c2d1e04f11b = function _getBBox(target) {
    var bounds, cloned;
    try {
        bounds = target.getBBox(); //Firefox throws errors if you try calling getBBox() on an SVG element that's not rendered (like in a <symbol> or <defs>). https://bugzilla.mozilla.org/show_bug.cgi?id=612118
    } catch (error) {
        bounds = $0cdfc2eaac330c87$var$_getReparentedCloneBBox(target);
        cloned = 1;
    }
    bounds && (bounds.width || bounds.height) || cloned || (bounds = $0cdfc2eaac330c87$var$_getReparentedCloneBBox(target)); //some browsers (like Firefox) misreport the bounds if the element has zero width and height (it just assumes it's at x:0, y:0), thus we need to manually grab the position in that case.
    return bounds && !bounds.width && !bounds.x && !bounds.y ? {
        x: +$0cdfc2eaac330c87$var$_getAttributeFallbacks(target, [
            "x",
            "cx",
            "x1"
        ]) || 0,
        y: +$0cdfc2eaac330c87$var$_getAttributeFallbacks(target, [
            "y",
            "cy",
            "y1"
        ]) || 0,
        width: 0,
        height: 0
    } : bounds;
}, $0cdfc2eaac330c87$var$_isSVG = function _isSVG(e) {
    return !!(e.getCTM && (!e.parentNode || e.ownerSVGElement) && $0cdfc2eaac330c87$export$41bc7c2d1e04f11b(e));
}, //reports if the element is an SVG on which getBBox() actually works
$0cdfc2eaac330c87$var$_removeProperty = function _removeProperty(target, property) {
    if (property) {
        var style = target.style, first2Chars;
        if (property in $0cdfc2eaac330c87$var$_transformProps && property !== $0cdfc2eaac330c87$var$_transformOriginProp) property = $0cdfc2eaac330c87$var$_transformProp;
        if (style.removeProperty) {
            first2Chars = property.substr(0, 2);
            if (first2Chars === "ms" || property.substr(0, 6) === "webkit") //Microsoft and some Webkit browsers don't conform to the standard of capitalizing the first prefix character, so we adjust so that when we prefix the caps with a dash, it's correct (otherwise it'd be "ms-transform" instead of "-ms-transform" for IE9, for example)
            property = "-" + property;
            style.removeProperty(first2Chars === "--" ? property : property.replace($0cdfc2eaac330c87$var$_capsExp, "-$1").toLowerCase());
        } else //note: old versions of IE use "removeAttribute()" instead of "removeProperty()"
        style.removeAttribute(property);
    }
}, $0cdfc2eaac330c87$var$_addNonTweeningPT = function _addNonTweeningPT(plugin, target, property, beginning, end, onlySetAtEnd) {
    var pt = new (0, $2Tywo.PropTween)(plugin._pt, target, property, 0, 1, onlySetAtEnd ? $0cdfc2eaac330c87$var$_renderNonTweeningValueOnlyAtEnd : $0cdfc2eaac330c87$var$_renderNonTweeningValue);
    plugin._pt = pt;
    pt.b = beginning;
    pt.e = end;
    plugin._props.push(property);
    return pt;
}, $0cdfc2eaac330c87$var$_nonConvertibleUnits = {
    deg: 1,
    rad: 1,
    turn: 1
}, $0cdfc2eaac330c87$var$_nonStandardLayouts = {
    grid: 1,
    flex: 1
}, //takes a single value like 20px and converts it to the unit specified, like "%", returning only the numeric amount.
$0cdfc2eaac330c87$var$_convertToUnit = function _convertToUnit(target, property, value, unit) {
    var curValue = parseFloat(value) || 0, curUnit = (value + "").trim().substr((curValue + "").length) || "px", // some browsers leave extra whitespace at the beginning of CSS variables, hence the need to trim()
    style = $0cdfc2eaac330c87$var$_tempDiv.style, horizontal = $0cdfc2eaac330c87$var$_horizontalExp.test(property), isRootSVG = target.tagName.toLowerCase() === "svg", measureProperty = (isRootSVG ? "client" : "offset") + (horizontal ? "Width" : "Height"), amount = 100, toPixels = unit === "px", toPercent = unit === "%", px, parent, cache, isSVG;
    if (unit === curUnit || !curValue || $0cdfc2eaac330c87$var$_nonConvertibleUnits[unit] || $0cdfc2eaac330c87$var$_nonConvertibleUnits[curUnit]) return curValue;
    curUnit !== "px" && !toPixels && (curValue = _convertToUnit(target, property, value, "px"));
    isSVG = target.getCTM && $0cdfc2eaac330c87$var$_isSVG(target);
    if ((toPercent || curUnit === "%") && ($0cdfc2eaac330c87$var$_transformProps[property] || ~property.indexOf("adius"))) {
        px = isSVG ? target.getBBox()[horizontal ? "width" : "height"] : target[measureProperty];
        return (0, $2Tywo._round)(toPercent ? curValue / px * amount : curValue / 100 * px);
    }
    style[horizontal ? "width" : "height"] = amount + (toPixels ? curUnit : unit);
    parent = unit !== "rem" && ~property.indexOf("adius") || unit === "em" && target.appendChild && !isRootSVG ? target : target.parentNode;
    if (isSVG) parent = (target.ownerSVGElement || {}).parentNode;
    if (!parent || parent === $0cdfc2eaac330c87$var$_doc || !parent.appendChild) parent = $0cdfc2eaac330c87$var$_doc.body;
    cache = parent._gsap;
    if (cache && toPercent && cache.width && horizontal && cache.time === (0, $2Tywo._ticker).time && !cache.uncache) return (0, $2Tywo._round)(curValue / cache.width * amount);
    else {
        if (toPercent && (property === "height" || property === "width")) {
            // if we're dealing with width/height that's inside a container with padding and/or it's a flexbox/grid container, we must apply it to the target itself rather than the _tempDiv in order to ensure complete accuracy, factoring in the parent's padding.
            var v = target.style[property];
            target.style[property] = amount + unit;
            px = target[measureProperty];
            v ? target.style[property] = v : $0cdfc2eaac330c87$var$_removeProperty(target, property);
        } else {
            (toPercent || curUnit === "%") && !$0cdfc2eaac330c87$var$_nonStandardLayouts[$0cdfc2eaac330c87$var$_getComputedProperty(parent, "display")] && (style.position = $0cdfc2eaac330c87$var$_getComputedProperty(target, "position"));
            parent === target && (style.position = "static"); // like for borderRadius, if it's a % we must have it relative to the target itself but that may not have position: relative or position: absolute in which case it'd go up the chain until it finds its offsetParent (bad). position: static protects against that.
            parent.appendChild($0cdfc2eaac330c87$var$_tempDiv);
            px = $0cdfc2eaac330c87$var$_tempDiv[measureProperty];
            parent.removeChild($0cdfc2eaac330c87$var$_tempDiv);
            style.position = "absolute";
        }
        if (horizontal && toPercent) {
            cache = (0, $2Tywo._getCache)(parent);
            cache.time = (0, $2Tywo._ticker).time;
            cache.width = parent[measureProperty];
        }
    }
    return (0, $2Tywo._round)(toPixels ? px * curValue / amount : px && curValue ? amount / px * curValue : 0);
}, $0cdfc2eaac330c87$var$_get = function _get(target, property, unit, uncache) {
    var value;
    $0cdfc2eaac330c87$var$_pluginInitted || $0cdfc2eaac330c87$var$_initCore();
    if (property in $0cdfc2eaac330c87$var$_propertyAliases && property !== "transform") {
        property = $0cdfc2eaac330c87$var$_propertyAliases[property];
        if (~property.indexOf(",")) property = property.split(",")[0];
    }
    if ($0cdfc2eaac330c87$var$_transformProps[property] && property !== "transform") {
        value = $0cdfc2eaac330c87$var$_parseTransform(target, uncache);
        value = property !== "transformOrigin" ? value[property] : value.svg ? value.origin : $0cdfc2eaac330c87$var$_firstTwoOnly($0cdfc2eaac330c87$var$_getComputedProperty(target, $0cdfc2eaac330c87$var$_transformOriginProp)) + " " + value.zOrigin + "px";
    } else {
        value = target.style[property];
        if (!value || value === "auto" || uncache || ~(value + "").indexOf("calc(")) value = $0cdfc2eaac330c87$var$_specialProps[property] && $0cdfc2eaac330c87$var$_specialProps[property](target, property, unit) || $0cdfc2eaac330c87$var$_getComputedProperty(target, property) || (0, $2Tywo._getProperty)(target, property) || (property === "opacity" ? 1 : 0); // note: some browsers, like Firefox, don't report borderRadius correctly! Instead, it only reports every corner like  borderTopLeftRadius
    }
    return unit && !~(value + "").trim().indexOf(" ") ? $0cdfc2eaac330c87$var$_convertToUnit(target, property, value, unit) + unit : value;
}, $0cdfc2eaac330c87$var$_tweenComplexCSSString = function _tweenComplexCSSString(target, prop, start, end) {
    // note: we call _tweenComplexCSSString.call(pluginInstance...) to ensure that it's scoped properly. We may call it from within a plugin too, thus "this" would refer to the plugin.
    if (!start || start === "none") {
        // some browsers like Safari actually PREFER the prefixed property and mis-report the unprefixed value like clipPath (BUG). In other words, even though clipPath exists in the style ("clipPath" in target.style) and it's set in the CSS properly (along with -webkit-clip-path), Safari reports clipPath as "none" whereas WebkitClipPath reports accurately like "ellipse(100% 0% at 50% 0%)", so in this case we must SWITCH to using the prefixed property instead. See https://gsap.com/forums/topic/18310-clippath-doesnt-work-on-ios/
        var p = $0cdfc2eaac330c87$export$8cbef5dd49a09c8b(prop, target, 1), s = p && $0cdfc2eaac330c87$var$_getComputedProperty(target, p, 1);
        if (s && s !== start) {
            prop = p;
            start = s;
        } else if (prop === "borderColor") start = $0cdfc2eaac330c87$var$_getComputedProperty(target, "borderTopColor"); // Firefox bug: always reports "borderColor" as "", so we must fall back to borderTopColor. See https://gsap.com/forums/topic/24583-how-to-return-colors-that-i-had-after-reverse/
    }
    var pt = new (0, $2Tywo.PropTween)(this._pt, target.style, prop, 0, 1, (0, $2Tywo._renderComplexString)), index = 0, matchIndex = 0, a, result, startValues, startNum, color, startValue, endValue, endNum, chunk, endUnit, startUnit, endValues;
    pt.b = start;
    pt.e = end;
    start += ""; // ensure values are strings
    end += "";
    if (end === "auto") {
        startValue = target.style[prop];
        target.style[prop] = end;
        end = $0cdfc2eaac330c87$var$_getComputedProperty(target, prop) || end;
        startValue ? target.style[prop] = startValue : $0cdfc2eaac330c87$var$_removeProperty(target, prop);
    }
    a = [
        start,
        end
    ];
    (0, $2Tywo._colorStringFilter)(a); // pass an array with the starting and ending values and let the filter do whatever it needs to the values. If colors are found, it returns true and then we must match where the color shows up order-wise because for things like boxShadow, sometimes the browser provides the computed values with the color FIRST, but the user provides it with the color LAST, so flip them if necessary. Same for drop-shadow().
    start = a[0];
    end = a[1];
    startValues = start.match((0, $2Tywo._numWithUnitExp)) || [];
    endValues = end.match((0, $2Tywo._numWithUnitExp)) || [];
    if (endValues.length) {
        while(result = (0, $2Tywo._numWithUnitExp).exec(end)){
            endValue = result[0];
            chunk = end.substring(index, result.index);
            if (color) color = (color + 1) % 5;
            else if (chunk.substr(-5) === "rgba(" || chunk.substr(-5) === "hsla(") color = 1;
            if (endValue !== (startValue = startValues[matchIndex++] || "")) {
                startNum = parseFloat(startValue) || 0;
                startUnit = startValue.substr((startNum + "").length);
                endValue.charAt(1) === "=" && (endValue = (0, $2Tywo._parseRelative)(startNum, endValue) + startUnit);
                endNum = parseFloat(endValue);
                endUnit = endValue.substr((endNum + "").length);
                index = (0, $2Tywo._numWithUnitExp).lastIndex - endUnit.length;
                if (!endUnit) {
                    //if something like "perspective:300" is passed in and we must add a unit to the end
                    endUnit = endUnit || (0, $2Tywo._config).units[prop] || startUnit;
                    if (index === end.length) {
                        end += endUnit;
                        pt.e += endUnit;
                    }
                }
                if (startUnit !== endUnit) startNum = $0cdfc2eaac330c87$var$_convertToUnit(target, prop, startValue, endUnit) || 0;
                 // these nested PropTweens are handled in a special way - we'll never actually call a render or setter method on them. We'll just loop through them in the parent complex string PropTween's render method.
                pt._pt = {
                    _next: pt._pt,
                    p: chunk || matchIndex === 1 ? chunk : ",",
                    //note: SVG spec allows omission of comma/space when a negative sign is wedged between two numbers, like 2.5-5.3 instead of 2.5,-5.3 but when tweening, the negative value may switch to positive, so we insert the comma just in case.
                    s: startNum,
                    c: endNum - startNum,
                    m: color && color < 4 || prop === "zIndex" ? Math.round : 0
                };
            }
        }
        pt.c = index < end.length ? end.substring(index, end.length) : ""; //we use the "c" of the PropTween to store the final part of the string (after the last number)
    } else pt.r = prop === "display" && end === "none" ? $0cdfc2eaac330c87$var$_renderNonTweeningValueOnlyAtEnd : $0cdfc2eaac330c87$var$_renderNonTweeningValue;
    (0, $2Tywo._relExp).test(end) && (pt.e = 0); //if the end string contains relative values or dynamic random(...) values, delete the end it so that on the final render we don't actually set it to the string with += or -= characters (forces it to use the calculated value).
    this._pt = pt; //start the linked list with this new PropTween. Remember, we call _tweenComplexCSSString.call(pluginInstance...) to ensure that it's scoped properly. We may call it from within another plugin too, thus "this" would refer to the plugin.
    return pt;
}, $0cdfc2eaac330c87$var$_keywordToPercent = {
    top: "0%",
    bottom: "100%",
    left: "0%",
    right: "100%",
    center: "50%"
}, $0cdfc2eaac330c87$var$_convertKeywordsToPercentages = function _convertKeywordsToPercentages(value) {
    var split = value.split(" "), x = split[0], y = split[1] || "50%";
    if (x === "top" || x === "bottom" || y === "left" || y === "right") {
        //the user provided them in the wrong order, so flip them
        value = x;
        x = y;
        y = value;
    }
    split[0] = $0cdfc2eaac330c87$var$_keywordToPercent[x] || x;
    split[1] = $0cdfc2eaac330c87$var$_keywordToPercent[y] || y;
    return split.join(" ");
}, $0cdfc2eaac330c87$var$_renderClearProps = function _renderClearProps(ratio, data) {
    if (data.tween && data.tween._time === data.tween._dur) {
        var target = data.t, style = target.style, props = data.u, cache = target._gsap, prop, clearTransforms, i;
        if (props === "all" || props === true) {
            style.cssText = "";
            clearTransforms = 1;
        } else {
            props = props.split(",");
            i = props.length;
            while(--i > -1){
                prop = props[i];
                if ($0cdfc2eaac330c87$var$_transformProps[prop]) {
                    clearTransforms = 1;
                    prop = prop === "transformOrigin" ? $0cdfc2eaac330c87$var$_transformOriginProp : $0cdfc2eaac330c87$var$_transformProp;
                }
                $0cdfc2eaac330c87$var$_removeProperty(target, prop);
            }
        }
        if (clearTransforms) {
            $0cdfc2eaac330c87$var$_removeProperty(target, $0cdfc2eaac330c87$var$_transformProp);
            if (cache) {
                cache.svg && target.removeAttribute("transform");
                style.scale = style.rotate = style.translate = "none";
                $0cdfc2eaac330c87$var$_parseTransform(target, 1); // force all the cached values back to "normal"/identity, otherwise if there's another tween that's already set to render transforms on this element, it could display the wrong values.
                cache.uncache = 1;
                $0cdfc2eaac330c87$var$_removeIndependentTransforms(style);
            }
        }
    }
}, // note: specialProps should return 1 if (and only if) they have a non-zero priority. It indicates we need to sort the linked list.
$0cdfc2eaac330c87$var$_specialProps = {
    clearProps: function clearProps(plugin, target, property, endValue, tween) {
        if (tween.data !== "isFromStart") {
            var pt = plugin._pt = new (0, $2Tywo.PropTween)(plugin._pt, target, property, 0, 0, $0cdfc2eaac330c87$var$_renderClearProps);
            pt.u = endValue;
            pt.pr = -10;
            pt.tween = tween;
            plugin._props.push(property);
            return 1;
        }
    }
}, /*
 * --------------------------------------------------------------------------------------
 * TRANSFORMS
 * --------------------------------------------------------------------------------------
 */ $0cdfc2eaac330c87$var$_identity2DMatrix = [
    1,
    0,
    0,
    1,
    0,
    0
], $0cdfc2eaac330c87$var$_rotationalProperties = {}, $0cdfc2eaac330c87$var$_isNullTransform = function _isNullTransform(value) {
    return value === "matrix(1, 0, 0, 1, 0, 0)" || value === "none" || !value;
}, $0cdfc2eaac330c87$var$_getComputedTransformMatrixAsArray = function _getComputedTransformMatrixAsArray(target) {
    var matrixString = $0cdfc2eaac330c87$var$_getComputedProperty(target, $0cdfc2eaac330c87$var$_transformProp);
    return $0cdfc2eaac330c87$var$_isNullTransform(matrixString) ? $0cdfc2eaac330c87$var$_identity2DMatrix : matrixString.substr(7).match((0, $2Tywo._numExp)).map((0, $2Tywo._round));
}, $0cdfc2eaac330c87$var$_getMatrix = function _getMatrix(target, force2D) {
    var cache = target._gsap || (0, $2Tywo._getCache)(target), style = target.style, matrix = $0cdfc2eaac330c87$var$_getComputedTransformMatrixAsArray(target), parent, nextSibling, temp, addedToDOM;
    if (cache.svg && target.getAttribute("transform")) {
        temp = target.transform.baseVal.consolidate().matrix; //ensures that even complex values like "translate(50,60) rotate(135,0,0)" are parsed because it mashes it into a matrix.
        matrix = [
            temp.a,
            temp.b,
            temp.c,
            temp.d,
            temp.e,
            temp.f
        ];
        return matrix.join(",") === "1,0,0,1,0,0" ? $0cdfc2eaac330c87$var$_identity2DMatrix : matrix;
    } else if (matrix === $0cdfc2eaac330c87$var$_identity2DMatrix && !target.offsetParent && target !== $0cdfc2eaac330c87$var$_docElement && !cache.svg) {
        //note: if offsetParent is null, that means the element isn't in the normal document flow, like if it has display:none or one of its ancestors has display:none). Firefox returns null for getComputedStyle() if the element is in an iframe that has display:none. https://bugzilla.mozilla.org/show_bug.cgi?id=548397
        //browsers don't report transforms accurately unless the element is in the DOM and has a display value that's not "none". Firefox and Microsoft browsers have a partial bug where they'll report transforms even if display:none BUT not any percentage-based values like translate(-50%, 8px) will be reported as if it's translate(0, 8px).
        temp = style.display;
        style.display = "block";
        parent = target.parentNode;
        if (!parent || !target.offsetParent && !target.getBoundingClientRect().width) {
            // note: in 3.3.0 we switched target.offsetParent to _doc.body.contains(target) to avoid [sometimes unnecessary] MutationObserver calls but that wasn't adequate because there are edge cases where nested position: fixed elements need to get reparented to accurately sense transforms. See https://github.com/greensock/GSAP/issues/388 and https://github.com/greensock/GSAP/issues/375. Note: position: fixed elements report a null offsetParent but they could also be invisible because they're in an ancestor with display: none, so we check getBoundingClientRect(). We only want to alter the DOM if we absolutely have to because it can cause iframe content to reload, like a Vimeo video.
            addedToDOM = 1; //flag
            nextSibling = target.nextElementSibling;
            $0cdfc2eaac330c87$var$_docElement.appendChild(target); //we must add it to the DOM in order to get values properly
        }
        matrix = $0cdfc2eaac330c87$var$_getComputedTransformMatrixAsArray(target);
        temp ? style.display = temp : $0cdfc2eaac330c87$var$_removeProperty(target, "display");
        if (addedToDOM) nextSibling ? parent.insertBefore(target, nextSibling) : parent ? parent.appendChild(target) : $0cdfc2eaac330c87$var$_docElement.removeChild(target);
    }
    return force2D && matrix.length > 6 ? [
        matrix[0],
        matrix[1],
        matrix[4],
        matrix[5],
        matrix[12],
        matrix[13]
    ] : matrix;
}, $0cdfc2eaac330c87$var$_applySVGOrigin = function _applySVGOrigin(target, origin, originIsAbsolute, smooth, matrixArray, pluginToAddPropTweensTo) {
    var cache = target._gsap, matrix = matrixArray || $0cdfc2eaac330c87$var$_getMatrix(target, true), xOriginOld = cache.xOrigin || 0, yOriginOld = cache.yOrigin || 0, xOffsetOld = cache.xOffset || 0, yOffsetOld = cache.yOffset || 0, a = matrix[0], b = matrix[1], c = matrix[2], d = matrix[3], tx = matrix[4], ty = matrix[5], originSplit = origin.split(" "), xOrigin = parseFloat(originSplit[0]) || 0, yOrigin = parseFloat(originSplit[1]) || 0, bounds, determinant, x, y;
    if (!originIsAbsolute) {
        bounds = $0cdfc2eaac330c87$export$41bc7c2d1e04f11b(target);
        xOrigin = bounds.x + (~originSplit[0].indexOf("%") ? xOrigin / 100 * bounds.width : xOrigin);
        yOrigin = bounds.y + (~(originSplit[1] || originSplit[0]).indexOf("%") ? yOrigin / 100 * bounds.height : yOrigin); // if (!("xOrigin" in cache) && (xOrigin || yOrigin)) { // added in 3.12.3, reverted in 3.12.4; requires more exploration
    // 	xOrigin -= bounds.x;
    // 	yOrigin -= bounds.y;
    // }
    } else if (matrix !== $0cdfc2eaac330c87$var$_identity2DMatrix && (determinant = a * d - b * c)) {
        //if it's zero (like if scaleX and scaleY are zero), skip it to avoid errors with dividing by zero.
        x = xOrigin * (d / determinant) + yOrigin * (-c / determinant) + (c * ty - d * tx) / determinant;
        y = xOrigin * (-b / determinant) + yOrigin * (a / determinant) - (a * ty - b * tx) / determinant;
        xOrigin = x;
        yOrigin = y; // theory: we only had to do this for smoothing and it assumes that the previous one was not originIsAbsolute.
    }
    if (smooth || smooth !== false && cache.smooth) {
        tx = xOrigin - xOriginOld;
        ty = yOrigin - yOriginOld;
        cache.xOffset = xOffsetOld + (tx * a + ty * c) - tx;
        cache.yOffset = yOffsetOld + (tx * b + ty * d) - ty;
    } else cache.xOffset = cache.yOffset = 0;
    cache.xOrigin = xOrigin;
    cache.yOrigin = yOrigin;
    cache.smooth = !!smooth;
    cache.origin = origin;
    cache.originIsAbsolute = !!originIsAbsolute;
    target.style[$0cdfc2eaac330c87$var$_transformOriginProp] = "0px 0px"; //otherwise, if someone sets  an origin via CSS, it will likely interfere with the SVG transform attribute ones (because remember, we're baking the origin into the matrix() value).
    if (pluginToAddPropTweensTo) {
        $0cdfc2eaac330c87$var$_addNonTweeningPT(pluginToAddPropTweensTo, cache, "xOrigin", xOriginOld, xOrigin);
        $0cdfc2eaac330c87$var$_addNonTweeningPT(pluginToAddPropTweensTo, cache, "yOrigin", yOriginOld, yOrigin);
        $0cdfc2eaac330c87$var$_addNonTweeningPT(pluginToAddPropTweensTo, cache, "xOffset", xOffsetOld, cache.xOffset);
        $0cdfc2eaac330c87$var$_addNonTweeningPT(pluginToAddPropTweensTo, cache, "yOffset", yOffsetOld, cache.yOffset);
    }
    target.setAttribute("data-svg-origin", xOrigin + " " + yOrigin);
}, $0cdfc2eaac330c87$var$_parseTransform = function _parseTransform(target, uncache) {
    var cache = target._gsap || new (0, $2Tywo.GSCache)(target);
    if ("x" in cache && !uncache && !cache.uncache) return cache;
    var style = target.style, invertedScaleX = cache.scaleX < 0, px = "px", deg = "deg", cs = getComputedStyle(target), origin = $0cdfc2eaac330c87$var$_getComputedProperty(target, $0cdfc2eaac330c87$var$_transformOriginProp) || "0", x, y, z, scaleX, scaleY, rotation, rotationX, rotationY, skewX, skewY, perspective, xOrigin, yOrigin, matrix, angle, cos, sin, a, b, c, d, a12, a22, t1, t2, t3, a13, a23, a33, a42, a43, a32;
    x = y = z = rotation = rotationX = rotationY = skewX = skewY = perspective = 0;
    scaleX = scaleY = 1;
    cache.svg = !!(target.getCTM && $0cdfc2eaac330c87$var$_isSVG(target));
    if (cs.translate) {
        // accommodate independent transforms by combining them into normal ones.
        if (cs.translate !== "none" || cs.scale !== "none" || cs.rotate !== "none") style[$0cdfc2eaac330c87$var$_transformProp] = (cs.translate !== "none" ? "translate3d(" + (cs.translate + " 0 0").split(" ").slice(0, 3).join(", ") + ") " : "") + (cs.rotate !== "none" ? "rotate(" + cs.rotate + ") " : "") + (cs.scale !== "none" ? "scale(" + cs.scale.split(" ").join(",") + ") " : "") + (cs[$0cdfc2eaac330c87$var$_transformProp] !== "none" ? cs[$0cdfc2eaac330c87$var$_transformProp] : "");
        style.scale = style.rotate = style.translate = "none";
    }
    matrix = $0cdfc2eaac330c87$var$_getMatrix(target, cache.svg);
    if (cache.svg) {
        if (cache.uncache) {
            // if cache.uncache is true (and maybe if origin is 0,0), we need to set element.style.transformOrigin = (cache.xOrigin - bbox.x) + "px " + (cache.yOrigin - bbox.y) + "px". Previously we let the data-svg-origin stay instead, but when introducing revert(), it complicated things.
            t2 = target.getBBox();
            origin = cache.xOrigin - t2.x + "px " + (cache.yOrigin - t2.y) + "px";
            t1 = "";
        } else t1 = !uncache && target.getAttribute("data-svg-origin"); //  Remember, to work around browser inconsistencies we always force SVG elements' transformOrigin to 0,0 and offset the translation accordingly.
        $0cdfc2eaac330c87$var$_applySVGOrigin(target, t1 || origin, !!t1 || cache.originIsAbsolute, cache.smooth !== false, matrix);
    }
    xOrigin = cache.xOrigin || 0;
    yOrigin = cache.yOrigin || 0;
    if (matrix !== $0cdfc2eaac330c87$var$_identity2DMatrix) {
        a = matrix[0]; //a11
        b = matrix[1]; //a21
        c = matrix[2]; //a31
        d = matrix[3]; //a41
        x = a12 = matrix[4];
        y = a22 = matrix[5]; //2D matrix
        if (matrix.length === 6) {
            scaleX = Math.sqrt(a * a + b * b);
            scaleY = Math.sqrt(d * d + c * c);
            rotation = a || b ? $0cdfc2eaac330c87$var$_atan2(b, a) * $0cdfc2eaac330c87$var$_RAD2DEG : 0; //note: if scaleX is 0, we cannot accurately measure rotation. Same for skewX with a scaleY of 0. Therefore, we default to the previously recorded value (or zero if that doesn't exist).
            skewX = c || d ? $0cdfc2eaac330c87$var$_atan2(c, d) * $0cdfc2eaac330c87$var$_RAD2DEG + rotation : 0;
            skewX && (scaleY *= Math.abs(Math.cos(skewX * $0cdfc2eaac330c87$var$_DEG2RAD)));
            if (cache.svg) {
                x -= xOrigin - (xOrigin * a + yOrigin * c);
                y -= yOrigin - (xOrigin * b + yOrigin * d);
            } //3D matrix
        } else {
            a32 = matrix[6];
            a42 = matrix[7];
            a13 = matrix[8];
            a23 = matrix[9];
            a33 = matrix[10];
            a43 = matrix[11];
            x = matrix[12];
            y = matrix[13];
            z = matrix[14];
            angle = $0cdfc2eaac330c87$var$_atan2(a32, a33);
            rotationX = angle * $0cdfc2eaac330c87$var$_RAD2DEG; //rotationX
            if (angle) {
                cos = Math.cos(-angle);
                sin = Math.sin(-angle);
                t1 = a12 * cos + a13 * sin;
                t2 = a22 * cos + a23 * sin;
                t3 = a32 * cos + a33 * sin;
                a13 = a12 * -sin + a13 * cos;
                a23 = a22 * -sin + a23 * cos;
                a33 = a32 * -sin + a33 * cos;
                a43 = a42 * -sin + a43 * cos;
                a12 = t1;
                a22 = t2;
                a32 = t3;
            } //rotationY
            angle = $0cdfc2eaac330c87$var$_atan2(-c, a33);
            rotationY = angle * $0cdfc2eaac330c87$var$_RAD2DEG;
            if (angle) {
                cos = Math.cos(-angle);
                sin = Math.sin(-angle);
                t1 = a * cos - a13 * sin;
                t2 = b * cos - a23 * sin;
                t3 = c * cos - a33 * sin;
                a43 = d * sin + a43 * cos;
                a = t1;
                b = t2;
                c = t3;
            } //rotationZ
            angle = $0cdfc2eaac330c87$var$_atan2(b, a);
            rotation = angle * $0cdfc2eaac330c87$var$_RAD2DEG;
            if (angle) {
                cos = Math.cos(angle);
                sin = Math.sin(angle);
                t1 = a * cos + b * sin;
                t2 = a12 * cos + a22 * sin;
                b = b * cos - a * sin;
                a22 = a22 * cos - a12 * sin;
                a = t1;
                a12 = t2;
            }
            if (rotationX && Math.abs(rotationX) + Math.abs(rotation) > 359.9) {
                //when rotationY is set, it will often be parsed as 180 degrees different than it should be, and rotationX and rotation both being 180 (it looks the same), so we adjust for that here.
                rotationX = rotation = 0;
                rotationY = 180 - rotationY;
            }
            scaleX = (0, $2Tywo._round)(Math.sqrt(a * a + b * b + c * c));
            scaleY = (0, $2Tywo._round)(Math.sqrt(a22 * a22 + a32 * a32));
            angle = $0cdfc2eaac330c87$var$_atan2(a12, a22);
            skewX = Math.abs(angle) > 0.0002 ? angle * $0cdfc2eaac330c87$var$_RAD2DEG : 0;
            perspective = a43 ? 1 / (a43 < 0 ? -a43 : a43) : 0;
        }
        if (cache.svg) {
            //sense if there are CSS transforms applied on an SVG element in which case we must overwrite them when rendering. The transform attribute is more reliable cross-browser, but we can't just remove the CSS ones because they may be applied in a CSS rule somewhere (not just inline).
            t1 = target.getAttribute("transform");
            cache.forceCSS = target.setAttribute("transform", "") || !$0cdfc2eaac330c87$var$_isNullTransform($0cdfc2eaac330c87$var$_getComputedProperty(target, $0cdfc2eaac330c87$var$_transformProp));
            t1 && target.setAttribute("transform", t1);
        }
    }
    if (Math.abs(skewX) > 90 && Math.abs(skewX) < 270) {
        if (invertedScaleX) {
            scaleX *= -1;
            skewX += rotation <= 0 ? 180 : -180;
            rotation += rotation <= 0 ? 180 : -180;
        } else {
            scaleY *= -1;
            skewX += skewX <= 0 ? 180 : -180;
        }
    }
    uncache = uncache || cache.uncache;
    cache.x = x - ((cache.xPercent = x && (!uncache && cache.xPercent || (Math.round(target.offsetWidth / 2) === Math.round(-x) ? -50 : 0))) ? target.offsetWidth * cache.xPercent / 100 : 0) + px;
    cache.y = y - ((cache.yPercent = y && (!uncache && cache.yPercent || (Math.round(target.offsetHeight / 2) === Math.round(-y) ? -50 : 0))) ? target.offsetHeight * cache.yPercent / 100 : 0) + px;
    cache.z = z + px;
    cache.scaleX = (0, $2Tywo._round)(scaleX);
    cache.scaleY = (0, $2Tywo._round)(scaleY);
    cache.rotation = (0, $2Tywo._round)(rotation) + deg;
    cache.rotationX = (0, $2Tywo._round)(rotationX) + deg;
    cache.rotationY = (0, $2Tywo._round)(rotationY) + deg;
    cache.skewX = skewX + deg;
    cache.skewY = skewY + deg;
    cache.transformPerspective = perspective + px;
    if (cache.zOrigin = parseFloat(origin.split(" ")[2]) || !uncache && cache.zOrigin || 0) style[$0cdfc2eaac330c87$var$_transformOriginProp] = $0cdfc2eaac330c87$var$_firstTwoOnly(origin);
    cache.xOffset = cache.yOffset = 0;
    cache.force3D = (0, $2Tywo._config).force3D;
    cache.renderTransform = cache.svg ? $0cdfc2eaac330c87$var$_renderSVGTransforms : $0cdfc2eaac330c87$var$_supports3D ? $0cdfc2eaac330c87$var$_renderCSSTransforms : $0cdfc2eaac330c87$var$_renderNon3DTransforms;
    cache.uncache = 0;
    return cache;
}, $0cdfc2eaac330c87$var$_firstTwoOnly = function _firstTwoOnly(value) {
    return (value = value.split(" "))[0] + " " + value[1];
}, //for handling transformOrigin values, stripping out the 3rd dimension
$0cdfc2eaac330c87$var$_addPxTranslate = function _addPxTranslate(target, start, value) {
    var unit = (0, $2Tywo.getUnit)(start);
    return (0, $2Tywo._round)(parseFloat(start) + parseFloat($0cdfc2eaac330c87$var$_convertToUnit(target, "x", value + "px", unit))) + unit;
}, $0cdfc2eaac330c87$var$_renderNon3DTransforms = function _renderNon3DTransforms(ratio, cache) {
    cache.z = "0px";
    cache.rotationY = cache.rotationX = "0deg";
    cache.force3D = 0;
    $0cdfc2eaac330c87$var$_renderCSSTransforms(ratio, cache);
}, $0cdfc2eaac330c87$var$_zeroDeg = "0deg", $0cdfc2eaac330c87$var$_zeroPx = "0px", $0cdfc2eaac330c87$var$_endParenthesis = ") ", $0cdfc2eaac330c87$var$_renderCSSTransforms = function _renderCSSTransforms(ratio, cache) {
    var _ref = cache || this, xPercent = _ref.xPercent, yPercent = _ref.yPercent, x = _ref.x, y = _ref.y, z = _ref.z, rotation = _ref.rotation, rotationY = _ref.rotationY, rotationX = _ref.rotationX, skewX = _ref.skewX, skewY = _ref.skewY, scaleX = _ref.scaleX, scaleY = _ref.scaleY, transformPerspective = _ref.transformPerspective, force3D = _ref.force3D, target = _ref.target, zOrigin = _ref.zOrigin, transforms = "", use3D = force3D === "auto" && ratio && ratio !== 1 || force3D === true; // Safari has a bug that causes it not to render 3D transform-origin values properly, so we force the z origin to 0, record it in the cache, and then do the math here to offset the translate values accordingly (basically do the 3D transform-origin part manually)
    if (zOrigin && (rotationX !== $0cdfc2eaac330c87$var$_zeroDeg || rotationY !== $0cdfc2eaac330c87$var$_zeroDeg)) {
        var angle = parseFloat(rotationY) * $0cdfc2eaac330c87$var$_DEG2RAD, a13 = Math.sin(angle), a33 = Math.cos(angle), cos;
        angle = parseFloat(rotationX) * $0cdfc2eaac330c87$var$_DEG2RAD;
        cos = Math.cos(angle);
        x = $0cdfc2eaac330c87$var$_addPxTranslate(target, x, a13 * cos * -zOrigin);
        y = $0cdfc2eaac330c87$var$_addPxTranslate(target, y, -Math.sin(angle) * -zOrigin);
        z = $0cdfc2eaac330c87$var$_addPxTranslate(target, z, a33 * cos * -zOrigin + zOrigin);
    }
    if (transformPerspective !== $0cdfc2eaac330c87$var$_zeroPx) transforms += "perspective(" + transformPerspective + $0cdfc2eaac330c87$var$_endParenthesis;
    if (xPercent || yPercent) transforms += "translate(" + xPercent + "%, " + yPercent + "%) ";
    if (use3D || x !== $0cdfc2eaac330c87$var$_zeroPx || y !== $0cdfc2eaac330c87$var$_zeroPx || z !== $0cdfc2eaac330c87$var$_zeroPx) transforms += z !== $0cdfc2eaac330c87$var$_zeroPx || use3D ? "translate3d(" + x + ", " + y + ", " + z + ") " : "translate(" + x + ", " + y + $0cdfc2eaac330c87$var$_endParenthesis;
    if (rotation !== $0cdfc2eaac330c87$var$_zeroDeg) transforms += "rotate(" + rotation + $0cdfc2eaac330c87$var$_endParenthesis;
    if (rotationY !== $0cdfc2eaac330c87$var$_zeroDeg) transforms += "rotateY(" + rotationY + $0cdfc2eaac330c87$var$_endParenthesis;
    if (rotationX !== $0cdfc2eaac330c87$var$_zeroDeg) transforms += "rotateX(" + rotationX + $0cdfc2eaac330c87$var$_endParenthesis;
    if (skewX !== $0cdfc2eaac330c87$var$_zeroDeg || skewY !== $0cdfc2eaac330c87$var$_zeroDeg) transforms += "skew(" + skewX + ", " + skewY + $0cdfc2eaac330c87$var$_endParenthesis;
    if (scaleX !== 1 || scaleY !== 1) transforms += "scale(" + scaleX + ", " + scaleY + $0cdfc2eaac330c87$var$_endParenthesis;
    target.style[$0cdfc2eaac330c87$var$_transformProp] = transforms || "translate(0, 0)";
}, $0cdfc2eaac330c87$var$_renderSVGTransforms = function _renderSVGTransforms(ratio, cache) {
    var _ref2 = cache || this, xPercent = _ref2.xPercent, yPercent = _ref2.yPercent, x = _ref2.x, y = _ref2.y, rotation = _ref2.rotation, skewX = _ref2.skewX, skewY = _ref2.skewY, scaleX = _ref2.scaleX, scaleY = _ref2.scaleY, target = _ref2.target, xOrigin = _ref2.xOrigin, yOrigin = _ref2.yOrigin, xOffset = _ref2.xOffset, yOffset = _ref2.yOffset, forceCSS = _ref2.forceCSS, tx = parseFloat(x), ty = parseFloat(y), a11, a21, a12, a22, temp;
    rotation = parseFloat(rotation);
    skewX = parseFloat(skewX);
    skewY = parseFloat(skewY);
    if (skewY) {
        //for performance reasons, we combine all skewing into the skewX and rotation values. Remember, a skewY of 10 degrees looks the same as a rotation of 10 degrees plus a skewX of 10 degrees.
        skewY = parseFloat(skewY);
        skewX += skewY;
        rotation += skewY;
    }
    if (rotation || skewX) {
        rotation *= $0cdfc2eaac330c87$var$_DEG2RAD;
        skewX *= $0cdfc2eaac330c87$var$_DEG2RAD;
        a11 = Math.cos(rotation) * scaleX;
        a21 = Math.sin(rotation) * scaleX;
        a12 = Math.sin(rotation - skewX) * -scaleY;
        a22 = Math.cos(rotation - skewX) * scaleY;
        if (skewX) {
            skewY *= $0cdfc2eaac330c87$var$_DEG2RAD;
            temp = Math.tan(skewX - skewY);
            temp = Math.sqrt(1 + temp * temp);
            a12 *= temp;
            a22 *= temp;
            if (skewY) {
                temp = Math.tan(skewY);
                temp = Math.sqrt(1 + temp * temp);
                a11 *= temp;
                a21 *= temp;
            }
        }
        a11 = (0, $2Tywo._round)(a11);
        a21 = (0, $2Tywo._round)(a21);
        a12 = (0, $2Tywo._round)(a12);
        a22 = (0, $2Tywo._round)(a22);
    } else {
        a11 = scaleX;
        a22 = scaleY;
        a21 = a12 = 0;
    }
    if (tx && !~(x + "").indexOf("px") || ty && !~(y + "").indexOf("px")) {
        tx = $0cdfc2eaac330c87$var$_convertToUnit(target, "x", x, "px");
        ty = $0cdfc2eaac330c87$var$_convertToUnit(target, "y", y, "px");
    }
    if (xOrigin || yOrigin || xOffset || yOffset) {
        tx = (0, $2Tywo._round)(tx + xOrigin - (xOrigin * a11 + yOrigin * a12) + xOffset);
        ty = (0, $2Tywo._round)(ty + yOrigin - (xOrigin * a21 + yOrigin * a22) + yOffset);
    }
    if (xPercent || yPercent) {
        //The SVG spec doesn't support percentage-based translation in the "transform" attribute, so we merge it into the translation to simulate it.
        temp = target.getBBox();
        tx = (0, $2Tywo._round)(tx + xPercent / 100 * temp.width);
        ty = (0, $2Tywo._round)(ty + yPercent / 100 * temp.height);
    }
    temp = "matrix(" + a11 + "," + a21 + "," + a12 + "," + a22 + "," + tx + "," + ty + ")";
    target.setAttribute("transform", temp);
    forceCSS && (target.style[$0cdfc2eaac330c87$var$_transformProp] = temp); //some browsers prioritize CSS transforms over the transform attribute. When we sense that the user has CSS transforms applied, we must overwrite them this way (otherwise some browser simply won't render the transform attribute changes!)
}, $0cdfc2eaac330c87$var$_addRotationalPropTween = function _addRotationalPropTween(plugin, target, property, startNum, endValue) {
    var cap = 360, isString = (0, $2Tywo._isString)(endValue), endNum = parseFloat(endValue) * (isString && ~endValue.indexOf("rad") ? $0cdfc2eaac330c87$var$_RAD2DEG : 1), change = endNum - startNum, finalValue = startNum + change + "deg", direction, pt;
    if (isString) {
        direction = endValue.split("_")[1];
        if (direction === "short") {
            change %= cap;
            if (change !== change % (cap / 2)) change += change < 0 ? cap : -cap;
        }
        if (direction === "cw" && change < 0) change = (change + cap * $0cdfc2eaac330c87$var$_bigNum) % cap - ~~(change / cap) * cap;
        else if (direction === "ccw" && change > 0) change = (change - cap * $0cdfc2eaac330c87$var$_bigNum) % cap - ~~(change / cap) * cap;
    }
    plugin._pt = pt = new (0, $2Tywo.PropTween)(plugin._pt, target, property, startNum, change, $0cdfc2eaac330c87$var$_renderPropWithEnd);
    pt.e = finalValue;
    pt.u = "deg";
    plugin._props.push(property);
    return pt;
}, $0cdfc2eaac330c87$var$_assign = function _assign(target, source) {
    // Internet Explorer doesn't have Object.assign(), so we recreate it here.
    for(var p in source)target[p] = source[p];
    return target;
}, $0cdfc2eaac330c87$var$_addRawTransformPTs = function _addRawTransformPTs(plugin, transforms, target) {
    //for handling cases where someone passes in a whole transform string, like transform: "scale(2, 3) rotate(20deg) translateY(30em)"
    var startCache = $0cdfc2eaac330c87$var$_assign({}, target._gsap), exclude = "perspective,force3D,transformOrigin,svgOrigin", style = target.style, endCache, p, startValue, endValue, startNum, endNum, startUnit, endUnit;
    if (startCache.svg) {
        startValue = target.getAttribute("transform");
        target.setAttribute("transform", "");
        style[$0cdfc2eaac330c87$var$_transformProp] = transforms;
        endCache = $0cdfc2eaac330c87$var$_parseTransform(target, 1);
        $0cdfc2eaac330c87$var$_removeProperty(target, $0cdfc2eaac330c87$var$_transformProp);
        target.setAttribute("transform", startValue);
    } else {
        startValue = getComputedStyle(target)[$0cdfc2eaac330c87$var$_transformProp];
        style[$0cdfc2eaac330c87$var$_transformProp] = transforms;
        endCache = $0cdfc2eaac330c87$var$_parseTransform(target, 1);
        style[$0cdfc2eaac330c87$var$_transformProp] = startValue;
    }
    for(p in $0cdfc2eaac330c87$var$_transformProps){
        startValue = startCache[p];
        endValue = endCache[p];
        if (startValue !== endValue && exclude.indexOf(p) < 0) {
            //tweening to no perspective gives very unintuitive results - just keep the same perspective in that case.
            startUnit = (0, $2Tywo.getUnit)(startValue);
            endUnit = (0, $2Tywo.getUnit)(endValue);
            startNum = startUnit !== endUnit ? $0cdfc2eaac330c87$var$_convertToUnit(target, p, startValue, endUnit) : parseFloat(startValue);
            endNum = parseFloat(endValue);
            plugin._pt = new (0, $2Tywo.PropTween)(plugin._pt, endCache, p, startNum, endNum - startNum, $0cdfc2eaac330c87$var$_renderCSSProp);
            plugin._pt.u = endUnit || 0;
            plugin._props.push(p);
        }
    }
    $0cdfc2eaac330c87$var$_assign(endCache, startCache);
}; // handle splitting apart padding, margin, borderWidth, and borderRadius into their 4 components. Firefox, for example, won't report borderRadius correctly - it will only do borderTopLeftRadius and the other corners. We also want to handle paddingTop, marginLeft, borderRightWidth, etc.
(0, $2Tywo._forEachName)("padding,margin,Width,Radius", function(name, index) {
    var t = "Top", r = "Right", b = "Bottom", l = "Left", props = (index < 3 ? [
        t,
        r,
        b,
        l
    ] : [
        t + l,
        t + r,
        b + r,
        b + l
    ]).map(function(side) {
        return index < 2 ? name + side : "border" + side + name;
    });
    $0cdfc2eaac330c87$var$_specialProps[index > 1 ? "border" + name : name] = function(plugin, target, property, endValue, tween) {
        var a, vars;
        if (arguments.length < 4) {
            // getter, passed target, property, and unit (from _get())
            a = props.map(function(prop) {
                return $0cdfc2eaac330c87$var$_get(plugin, prop, property);
            });
            vars = a.join(" ");
            return vars.split(a[0]).length === 5 ? a[0] : vars;
        }
        a = (endValue + "").split(" ");
        vars = {};
        props.forEach(function(prop, i) {
            return vars[prop] = a[i] = a[i] || a[(i - 1) / 2 | 0];
        });
        plugin.init(target, vars, tween);
    };
});
var $0cdfc2eaac330c87$export$855822f522f18eef = {
    name: "css",
    register: $0cdfc2eaac330c87$var$_initCore,
    targetTest: function targetTest(target) {
        return target.style && target.nodeType;
    },
    init: function init(target, vars, tween, index, targets) {
        var props = this._props, style = target.style, startAt = tween.vars.startAt, startValue, endValue, endNum, startNum, type, specialProp, p, startUnit, endUnit, relative, isTransformRelated, transformPropTween, cache, smooth, hasPriority, inlineProps;
        $0cdfc2eaac330c87$var$_pluginInitted || $0cdfc2eaac330c87$var$_initCore(); // we may call init() multiple times on the same plugin instance, like when adding special properties, so make sure we don't overwrite the revert data or inlineProps
        this.styles = this.styles || $0cdfc2eaac330c87$var$_getStyleSaver(target);
        inlineProps = this.styles.props;
        this.tween = tween;
        for(p in vars){
            if (p === "autoRound") continue;
            endValue = vars[p];
            if ((0, $2Tywo._plugins)[p] && (0, $2Tywo._checkPlugin)(p, vars, tween, index, target, targets)) continue;
            type = typeof endValue;
            specialProp = $0cdfc2eaac330c87$var$_specialProps[p];
            if (type === "function") {
                endValue = endValue.call(tween, index, target, targets);
                type = typeof endValue;
            }
            if (type === "string" && ~endValue.indexOf("random(")) endValue = (0, $2Tywo._replaceRandom)(endValue);
            if (specialProp) specialProp(this, target, p, endValue, tween) && (hasPriority = 1);
            else if (p.substr(0, 2) === "--") {
                //CSS variable
                startValue = (getComputedStyle(target).getPropertyValue(p) + "").trim();
                endValue += "";
                (0, $2Tywo._colorExp).lastIndex = 0;
                if (!(0, $2Tywo._colorExp).test(startValue)) {
                    // colors don't have units
                    startUnit = (0, $2Tywo.getUnit)(startValue);
                    endUnit = (0, $2Tywo.getUnit)(endValue);
                }
                endUnit ? startUnit !== endUnit && (startValue = $0cdfc2eaac330c87$var$_convertToUnit(target, p, startValue, endUnit) + endUnit) : startUnit && (endValue += startUnit);
                this.add(style, "setProperty", startValue, endValue, index, targets, 0, 0, p);
                props.push(p);
                inlineProps.push(p, 0, style[p]);
            } else if (type !== "undefined") {
                if (startAt && p in startAt) {
                    // in case someone hard-codes a complex value as the start, like top: "calc(2vh / 2)". Without this, it'd use the computed value (always in px)
                    startValue = typeof startAt[p] === "function" ? startAt[p].call(tween, index, target, targets) : startAt[p];
                    (0, $2Tywo._isString)(startValue) && ~startValue.indexOf("random(") && (startValue = (0, $2Tywo._replaceRandom)(startValue));
                    (0, $2Tywo.getUnit)(startValue + "") || startValue === "auto" || (startValue += (0, $2Tywo._config).units[p] || (0, $2Tywo.getUnit)($0cdfc2eaac330c87$var$_get(target, p)) || ""); // for cases when someone passes in a unitless value like {x: 100}; if we try setting translate(100, 0px) it won't work.
                    (startValue + "").charAt(1) === "=" && (startValue = $0cdfc2eaac330c87$var$_get(target, p)); // can't work with relative values
                } else startValue = $0cdfc2eaac330c87$var$_get(target, p);
                startNum = parseFloat(startValue);
                relative = type === "string" && endValue.charAt(1) === "=" && endValue.substr(0, 2);
                relative && (endValue = endValue.substr(2));
                endNum = parseFloat(endValue);
                if (p in $0cdfc2eaac330c87$var$_propertyAliases) {
                    if (p === "autoAlpha") {
                        //special case where we control the visibility along with opacity. We still allow the opacity value to pass through and get tweened.
                        if (startNum === 1 && $0cdfc2eaac330c87$var$_get(target, "visibility") === "hidden" && endNum) //if visibility is initially set to "hidden", we should interpret that as intent to make opacity 0 (a convenience)
                        startNum = 0;
                        inlineProps.push("visibility", 0, style.visibility);
                        $0cdfc2eaac330c87$var$_addNonTweeningPT(this, style, "visibility", startNum ? "inherit" : "hidden", endNum ? "inherit" : "hidden", !endNum);
                    }
                    if (p !== "scale" && p !== "transform") {
                        p = $0cdfc2eaac330c87$var$_propertyAliases[p];
                        ~p.indexOf(",") && (p = p.split(",")[0]);
                    }
                }
                isTransformRelated = p in $0cdfc2eaac330c87$var$_transformProps; //--- TRANSFORM-RELATED ---
                if (isTransformRelated) {
                    this.styles.save(p);
                    if (!transformPropTween) {
                        cache = target._gsap;
                        cache.renderTransform && !vars.parseTransform || $0cdfc2eaac330c87$var$_parseTransform(target, vars.parseTransform); // if, for example, gsap.set(... {transform:"translateX(50vw)"}), the _get() call doesn't parse the transform, thus cache.renderTransform won't be set yet so force the parsing of the transform here.
                        smooth = vars.smoothOrigin !== false && cache.smooth;
                        transformPropTween = this._pt = new (0, $2Tywo.PropTween)(this._pt, style, $0cdfc2eaac330c87$var$_transformProp, 0, 1, cache.renderTransform, cache, 0, -1); //the first time through, create the rendering PropTween so that it runs LAST (in the linked list, we keep adding to the beginning)
                        transformPropTween.dep = 1; //flag it as dependent so that if things get killed/overwritten and this is the only PropTween left, we can safely kill the whole tween.
                    }
                    if (p === "scale") {
                        this._pt = new (0, $2Tywo.PropTween)(this._pt, cache, "scaleY", cache.scaleY, (relative ? (0, $2Tywo._parseRelative)(cache.scaleY, relative + endNum) : endNum) - cache.scaleY || 0, $0cdfc2eaac330c87$var$_renderCSSProp);
                        this._pt.u = 0;
                        props.push("scaleY", p);
                        p += "X";
                    } else if (p === "transformOrigin") {
                        inlineProps.push($0cdfc2eaac330c87$var$_transformOriginProp, 0, style[$0cdfc2eaac330c87$var$_transformOriginProp]);
                        endValue = $0cdfc2eaac330c87$var$_convertKeywordsToPercentages(endValue); //in case something like "left top" or "bottom right" is passed in. Convert to percentages.
                        if (cache.svg) $0cdfc2eaac330c87$var$_applySVGOrigin(target, endValue, 0, smooth, 0, this);
                        else {
                            endUnit = parseFloat(endValue.split(" ")[2]) || 0; //handle the zOrigin separately!
                            endUnit !== cache.zOrigin && $0cdfc2eaac330c87$var$_addNonTweeningPT(this, cache, "zOrigin", cache.zOrigin, endUnit);
                            $0cdfc2eaac330c87$var$_addNonTweeningPT(this, style, p, $0cdfc2eaac330c87$var$_firstTwoOnly(startValue), $0cdfc2eaac330c87$var$_firstTwoOnly(endValue));
                        }
                        continue;
                    } else if (p === "svgOrigin") {
                        $0cdfc2eaac330c87$var$_applySVGOrigin(target, endValue, 1, smooth, 0, this);
                        continue;
                    } else if (p in $0cdfc2eaac330c87$var$_rotationalProperties) {
                        $0cdfc2eaac330c87$var$_addRotationalPropTween(this, cache, p, startNum, relative ? (0, $2Tywo._parseRelative)(startNum, relative + endValue) : endValue);
                        continue;
                    } else if (p === "smoothOrigin") {
                        $0cdfc2eaac330c87$var$_addNonTweeningPT(this, cache, "smooth", cache.smooth, endValue);
                        continue;
                    } else if (p === "force3D") {
                        cache[p] = endValue;
                        continue;
                    } else if (p === "transform") {
                        $0cdfc2eaac330c87$var$_addRawTransformPTs(this, endValue, target);
                        continue;
                    }
                } else if (!(p in style)) p = $0cdfc2eaac330c87$export$8cbef5dd49a09c8b(p) || p;
                if (isTransformRelated || (endNum || endNum === 0) && (startNum || startNum === 0) && !$0cdfc2eaac330c87$var$_complexExp.test(endValue) && p in style) {
                    startUnit = (startValue + "").substr((startNum + "").length);
                    endNum || (endNum = 0); // protect against NaN
                    endUnit = (0, $2Tywo.getUnit)(endValue) || (p in (0, $2Tywo._config).units ? (0, $2Tywo._config).units[p] : startUnit);
                    startUnit !== endUnit && (startNum = $0cdfc2eaac330c87$var$_convertToUnit(target, p, startValue, endUnit));
                    this._pt = new (0, $2Tywo.PropTween)(this._pt, isTransformRelated ? cache : style, p, startNum, (relative ? (0, $2Tywo._parseRelative)(startNum, relative + endNum) : endNum) - startNum, !isTransformRelated && (endUnit === "px" || p === "zIndex") && vars.autoRound !== false ? $0cdfc2eaac330c87$var$_renderRoundedCSSProp : $0cdfc2eaac330c87$var$_renderCSSProp);
                    this._pt.u = endUnit || 0;
                    if (startUnit !== endUnit && endUnit !== "%") {
                        //when the tween goes all the way back to the beginning, we need to revert it to the OLD/ORIGINAL value (with those units). We record that as a "b" (beginning) property and point to a render method that handles that. (performance optimization)
                        this._pt.b = startValue;
                        this._pt.r = $0cdfc2eaac330c87$var$_renderCSSPropWithBeginning;
                    }
                } else if (!(p in style)) {
                    if (p in target) //maybe it's not a style - it could be a property added directly to an element in which case we'll try to animate that.
                    this.add(target, p, startValue || target[p], relative ? relative + endValue : endValue, index, targets);
                    else if (p !== "parseTransform") {
                        (0, $2Tywo._missingPlugin)(p, endValue);
                        continue;
                    }
                } else $0cdfc2eaac330c87$var$_tweenComplexCSSString.call(this, target, p, startValue, relative ? relative + endValue : endValue);
                isTransformRelated || (p in style ? inlineProps.push(p, 0, style[p]) : typeof target[p] === "function" ? inlineProps.push(p, 2, target[p]()) : inlineProps.push(p, 1, startValue || target[p]));
                props.push(p);
            }
        }
        hasPriority && (0, $2Tywo._sortPropTweensByPriority)(this);
    },
    render: function render(ratio, data) {
        if (data.tween._time || !$0cdfc2eaac330c87$var$_reverting()) {
            var pt = data._pt;
            while(pt){
                pt.r(ratio, pt.d);
                pt = pt._next;
            }
        } else data.styles.revert();
    },
    get: $0cdfc2eaac330c87$var$_get,
    aliases: $0cdfc2eaac330c87$var$_propertyAliases,
    getSetter: function getSetter(target, property, plugin) {
        //returns a setter function that accepts target, property, value and applies it accordingly. Remember, properties like "x" aren't as simple as target.style.property = value because they've got to be applied to a proxy object and then merged into a transform string in a renderer.
        var p = $0cdfc2eaac330c87$var$_propertyAliases[property];
        p && p.indexOf(",") < 0 && (property = p);
        return property in $0cdfc2eaac330c87$var$_transformProps && property !== $0cdfc2eaac330c87$var$_transformOriginProp && (target._gsap.x || $0cdfc2eaac330c87$var$_get(target, "x")) ? plugin && $0cdfc2eaac330c87$var$_recentSetterPlugin === plugin ? property === "scale" ? $0cdfc2eaac330c87$var$_setterScale : $0cdfc2eaac330c87$var$_setterTransform : ($0cdfc2eaac330c87$var$_recentSetterPlugin = plugin || {}, property === "scale" ? $0cdfc2eaac330c87$var$_setterScaleWithRender : $0cdfc2eaac330c87$var$_setterTransformWithRender) : target.style && !(0, $2Tywo._isUndefined)(target.style[property]) ? $0cdfc2eaac330c87$var$_setterCSSStyle : ~property.indexOf("-") ? $0cdfc2eaac330c87$var$_setterCSSProp : (0, $2Tywo._getSetter)(target, property);
    },
    core: {
        _removeProperty: $0cdfc2eaac330c87$var$_removeProperty,
        _getMatrix: $0cdfc2eaac330c87$var$_getMatrix
    }
};
(0, $2Tywo.gsap).utils.checkPrefix = $0cdfc2eaac330c87$export$8cbef5dd49a09c8b;
(0, $2Tywo.gsap).core.getStyleSaver = $0cdfc2eaac330c87$var$_getStyleSaver;
(function(positionAndScale, rotation, others, aliases) {
    var all = (0, $2Tywo._forEachName)(positionAndScale + "," + rotation + "," + others, function(name) {
        $0cdfc2eaac330c87$var$_transformProps[name] = 1;
    });
    (0, $2Tywo._forEachName)(rotation, function(name) {
        (0, $2Tywo._config).units[name] = "deg";
        $0cdfc2eaac330c87$var$_rotationalProperties[name] = 1;
    });
    $0cdfc2eaac330c87$var$_propertyAliases[all[13]] = positionAndScale + "," + rotation;
    (0, $2Tywo._forEachName)(aliases, function(name) {
        var split = name.split(":");
        $0cdfc2eaac330c87$var$_propertyAliases[split[1]] = all[split[0]];
    });
})("x,y,z,scale,scaleX,scaleY,xPercent,yPercent", "rotation,rotationX,rotationY,skewX,skewY", "transform,transformOrigin,svgOrigin,force3D,smoothOrigin,transformPerspective", "0:translateX,1:translateY,2:translateZ,8:rotate,8:rotationZ,8:rotateZ,9:rotateX,10:rotateY");
(0, $2Tywo._forEachName)("x,y,z,top,right,bottom,left,width,height,fontSize,padding,margin,perspective", function(name) {
    (0, $2Tywo._config).units[name] = "px";
});
(0, $2Tywo.gsap).registerPlugin($0cdfc2eaac330c87$export$855822f522f18eef);


var $357b3f2d5f2ec9d5$export$99ee26438460406a = (0, $2Tywo.gsap).registerPlugin((0, $0cdfc2eaac330c87$export$855822f522f18eef)) || (0, $2Tywo.gsap), // to protect from tree shaking
$357b3f2d5f2ec9d5$export$7b23975ad686bf91 = $357b3f2d5f2ec9d5$export$99ee26438460406a.core.Tween;


/** textalive-app-api v0.4.0 | Copyright 2024 AIST TextAlive Project <textalive-ml@aist.go.jp> (https://textalive.jp) */ 'use strict';
function $e5cb5cefd6507f7e$export$2e2bcd8739ae039(fn, thisArg) {
    return function wrap() {
        return fn.apply(thisArg, arguments);
    };
}


'use strict';
// utils is a library of generic helper functions non-specific to axios
const { toString: $c319b2c832c2914a$var$toString } = Object.prototype;
const { getPrototypeOf: $c319b2c832c2914a$var$getPrototypeOf } = Object;
const $c319b2c832c2914a$var$kindOf = ((cache)=>(thing)=>{
        const str = $c319b2c832c2914a$var$toString.call(thing);
        return cache[str] || (cache[str] = str.slice(8, -1).toLowerCase());
    })(Object.create(null));
const $c319b2c832c2914a$var$kindOfTest = (type)=>{
    type = type.toLowerCase();
    return (thing)=>$c319b2c832c2914a$var$kindOf(thing) === type;
};
const $c319b2c832c2914a$var$typeOfTest = (type)=>(thing)=>typeof thing === type;
/**
 * Determine if a value is an Array
 *
 * @param {Object} val The value to test
 *
 * @returns {boolean} True if value is an Array, otherwise false
 */ const { isArray: $c319b2c832c2914a$var$isArray } = Array;
/**
 * Determine if a value is undefined
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if the value is undefined, otherwise false
 */ const $c319b2c832c2914a$var$isUndefined = $c319b2c832c2914a$var$typeOfTest('undefined');
/**
 * Determine if a value is a Buffer
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a Buffer, otherwise false
 */ function $c319b2c832c2914a$var$isBuffer(val) {
    return val !== null && !$c319b2c832c2914a$var$isUndefined(val) && val.constructor !== null && !$c319b2c832c2914a$var$isUndefined(val.constructor) && $c319b2c832c2914a$var$isFunction(val.constructor.isBuffer) && val.constructor.isBuffer(val);
}
/**
 * Determine if a value is an ArrayBuffer
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is an ArrayBuffer, otherwise false
 */ const $c319b2c832c2914a$var$isArrayBuffer = $c319b2c832c2914a$var$kindOfTest('ArrayBuffer');
/**
 * Determine if a value is a view on an ArrayBuffer
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a view on an ArrayBuffer, otherwise false
 */ function $c319b2c832c2914a$var$isArrayBufferView(val) {
    let result;
    if (typeof ArrayBuffer !== 'undefined' && ArrayBuffer.isView) result = ArrayBuffer.isView(val);
    else result = val && val.buffer && $c319b2c832c2914a$var$isArrayBuffer(val.buffer);
    return result;
}
/**
 * Determine if a value is a String
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a String, otherwise false
 */ const $c319b2c832c2914a$var$isString = $c319b2c832c2914a$var$typeOfTest('string');
/**
 * Determine if a value is a Function
 *
 * @param {*} val The value to test
 * @returns {boolean} True if value is a Function, otherwise false
 */ const $c319b2c832c2914a$var$isFunction = $c319b2c832c2914a$var$typeOfTest('function');
/**
 * Determine if a value is a Number
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a Number, otherwise false
 */ const $c319b2c832c2914a$var$isNumber = $c319b2c832c2914a$var$typeOfTest('number');
/**
 * Determine if a value is an Object
 *
 * @param {*} thing The value to test
 *
 * @returns {boolean} True if value is an Object, otherwise false
 */ const $c319b2c832c2914a$var$isObject = (thing)=>thing !== null && typeof thing === 'object';
/**
 * Determine if a value is a Boolean
 *
 * @param {*} thing The value to test
 * @returns {boolean} True if value is a Boolean, otherwise false
 */ const $c319b2c832c2914a$var$isBoolean = (thing)=>thing === true || thing === false;
/**
 * Determine if a value is a plain Object
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a plain Object, otherwise false
 */ const $c319b2c832c2914a$var$isPlainObject = (val)=>{
    if ($c319b2c832c2914a$var$kindOf(val) !== 'object') return false;
    const prototype = $c319b2c832c2914a$var$getPrototypeOf(val);
    return (prototype === null || prototype === Object.prototype || Object.getPrototypeOf(prototype) === null) && !(Symbol.toStringTag in val) && !(Symbol.iterator in val);
};
/**
 * Determine if a value is a Date
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a Date, otherwise false
 */ const $c319b2c832c2914a$var$isDate = $c319b2c832c2914a$var$kindOfTest('Date');
/**
 * Determine if a value is a File
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a File, otherwise false
 */ const $c319b2c832c2914a$var$isFile = $c319b2c832c2914a$var$kindOfTest('File');
/**
 * Determine if a value is a Blob
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a Blob, otherwise false
 */ const $c319b2c832c2914a$var$isBlob = $c319b2c832c2914a$var$kindOfTest('Blob');
/**
 * Determine if a value is a FileList
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a File, otherwise false
 */ const $c319b2c832c2914a$var$isFileList = $c319b2c832c2914a$var$kindOfTest('FileList');
/**
 * Determine if a value is a Stream
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a Stream, otherwise false
 */ const $c319b2c832c2914a$var$isStream = (val)=>$c319b2c832c2914a$var$isObject(val) && $c319b2c832c2914a$var$isFunction(val.pipe);
/**
 * Determine if a value is a FormData
 *
 * @param {*} thing The value to test
 *
 * @returns {boolean} True if value is an FormData, otherwise false
 */ const $c319b2c832c2914a$var$isFormData = (thing)=>{
    let kind;
    return thing && (typeof FormData === 'function' && thing instanceof FormData || $c319b2c832c2914a$var$isFunction(thing.append) && ((kind = $c319b2c832c2914a$var$kindOf(thing)) === 'formdata' || // detect form-data instance
    kind === 'object' && $c319b2c832c2914a$var$isFunction(thing.toString) && thing.toString() === '[object FormData]'));
};
/**
 * Determine if a value is a URLSearchParams object
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a URLSearchParams object, otherwise false
 */ const $c319b2c832c2914a$var$isURLSearchParams = $c319b2c832c2914a$var$kindOfTest('URLSearchParams');
const [$c319b2c832c2914a$var$isReadableStream, $c319b2c832c2914a$var$isRequest, $c319b2c832c2914a$var$isResponse, $c319b2c832c2914a$var$isHeaders] = [
    'ReadableStream',
    'Request',
    'Response',
    'Headers'
].map($c319b2c832c2914a$var$kindOfTest);
/**
 * Trim excess whitespace off the beginning and end of a string
 *
 * @param {String} str The String to trim
 *
 * @returns {String} The String freed of excess whitespace
 */ const $c319b2c832c2914a$var$trim = (str)=>str.trim ? str.trim() : str.replace(/^[\s\uFEFF\xA0]+|[\s\uFEFF\xA0]+$/g, '');
/**
 * Iterate over an Array or an Object invoking a function for each item.
 *
 * If `obj` is an Array callback will be called passing
 * the value, index, and complete array for each item.
 *
 * If 'obj' is an Object callback will be called passing
 * the value, key, and complete object for each property.
 *
 * @param {Object|Array} obj The object to iterate
 * @param {Function} fn The callback to invoke for each item
 *
 * @param {Boolean} [allOwnKeys = false]
 * @returns {any}
 */ function $c319b2c832c2914a$var$forEach(obj, fn, { allOwnKeys: allOwnKeys = false } = {}) {
    // Don't bother if no value provided
    if (obj === null || typeof obj === 'undefined') return;
    let i;
    let l;
    // Force an array if not already something iterable
    if (typeof obj !== 'object') /*eslint no-param-reassign:0*/ obj = [
        obj
    ];
    if ($c319b2c832c2914a$var$isArray(obj)) // Iterate over array values
    for(i = 0, l = obj.length; i < l; i++)fn.call(null, obj[i], i, obj);
    else {
        // Iterate over object keys
        const keys = allOwnKeys ? Object.getOwnPropertyNames(obj) : Object.keys(obj);
        const len = keys.length;
        let key;
        for(i = 0; i < len; i++){
            key = keys[i];
            fn.call(null, obj[key], key, obj);
        }
    }
}
function $c319b2c832c2914a$var$findKey(obj, key) {
    key = key.toLowerCase();
    const keys = Object.keys(obj);
    let i = keys.length;
    let _key;
    while(i-- > 0){
        _key = keys[i];
        if (key === _key.toLowerCase()) return _key;
    }
    return null;
}
const $c319b2c832c2914a$var$_global = (()=>{
    /*eslint no-undef:0*/ if (typeof globalThis !== "undefined") return globalThis;
    return typeof self !== "undefined" ? self : typeof window !== 'undefined' ? window : $parcel$global;
})();
const $c319b2c832c2914a$var$isContextDefined = (context)=>!$c319b2c832c2914a$var$isUndefined(context) && context !== $c319b2c832c2914a$var$_global;
/**
 * Accepts varargs expecting each argument to be an object, then
 * immutably merges the properties of each object and returns result.
 *
 * When multiple objects contain the same key the later object in
 * the arguments list will take precedence.
 *
 * Example:
 *
 * ```js
 * var result = merge({foo: 123}, {foo: 456});
 * console.log(result.foo); // outputs 456
 * ```
 *
 * @param {Object} obj1 Object to merge
 *
 * @returns {Object} Result of all merge properties
 */ function $c319b2c832c2914a$var$merge() {
    const { caseless: caseless } = $c319b2c832c2914a$var$isContextDefined(this) && this || {};
    const result = {};
    const assignValue = (val, key)=>{
        const targetKey = caseless && $c319b2c832c2914a$var$findKey(result, key) || key;
        if ($c319b2c832c2914a$var$isPlainObject(result[targetKey]) && $c319b2c832c2914a$var$isPlainObject(val)) result[targetKey] = $c319b2c832c2914a$var$merge(result[targetKey], val);
        else if ($c319b2c832c2914a$var$isPlainObject(val)) result[targetKey] = $c319b2c832c2914a$var$merge({}, val);
        else if ($c319b2c832c2914a$var$isArray(val)) result[targetKey] = val.slice();
        else result[targetKey] = val;
    };
    for(let i = 0, l = arguments.length; i < l; i++)arguments[i] && $c319b2c832c2914a$var$forEach(arguments[i], assignValue);
    return result;
}
/**
 * Extends object a by mutably adding to it the properties of object b.
 *
 * @param {Object} a The object to be extended
 * @param {Object} b The object to copy properties from
 * @param {Object} thisArg The object to bind function to
 *
 * @param {Boolean} [allOwnKeys]
 * @returns {Object} The resulting value of object a
 */ const $c319b2c832c2914a$var$extend = (a, b, thisArg, { allOwnKeys: allOwnKeys } = {})=>{
    $c319b2c832c2914a$var$forEach(b, (val, key)=>{
        if (thisArg && $c319b2c832c2914a$var$isFunction(val)) a[key] = (0, $e5cb5cefd6507f7e$export$2e2bcd8739ae039)(val, thisArg);
        else a[key] = val;
    }, {
        allOwnKeys: allOwnKeys
    });
    return a;
};
/**
 * Remove byte order marker. This catches EF BB BF (the UTF-8 BOM)
 *
 * @param {string} content with BOM
 *
 * @returns {string} content value without BOM
 */ const $c319b2c832c2914a$var$stripBOM = (content)=>{
    if (content.charCodeAt(0) === 0xFEFF) content = content.slice(1);
    return content;
};
/**
 * Inherit the prototype methods from one constructor into another
 * @param {function} constructor
 * @param {function} superConstructor
 * @param {object} [props]
 * @param {object} [descriptors]
 *
 * @returns {void}
 */ const $c319b2c832c2914a$var$inherits = (constructor, superConstructor, props, descriptors)=>{
    constructor.prototype = Object.create(superConstructor.prototype, descriptors);
    constructor.prototype.constructor = constructor;
    Object.defineProperty(constructor, 'super', {
        value: superConstructor.prototype
    });
    props && Object.assign(constructor.prototype, props);
};
/**
 * Resolve object with deep prototype chain to a flat object
 * @param {Object} sourceObj source object
 * @param {Object} [destObj]
 * @param {Function|Boolean} [filter]
 * @param {Function} [propFilter]
 *
 * @returns {Object}
 */ const $c319b2c832c2914a$var$toFlatObject = (sourceObj, destObj, filter, propFilter)=>{
    let props;
    let i;
    let prop;
    const merged = {};
    destObj = destObj || {};
    // eslint-disable-next-line no-eq-null,eqeqeq
    if (sourceObj == null) return destObj;
    do {
        props = Object.getOwnPropertyNames(sourceObj);
        i = props.length;
        while(i-- > 0){
            prop = props[i];
            if ((!propFilter || propFilter(prop, sourceObj, destObj)) && !merged[prop]) {
                destObj[prop] = sourceObj[prop];
                merged[prop] = true;
            }
        }
        sourceObj = filter !== false && $c319b2c832c2914a$var$getPrototypeOf(sourceObj);
    }while (sourceObj && (!filter || filter(sourceObj, destObj)) && sourceObj !== Object.prototype);
    return destObj;
};
/**
 * Determines whether a string ends with the characters of a specified string
 *
 * @param {String} str
 * @param {String} searchString
 * @param {Number} [position= 0]
 *
 * @returns {boolean}
 */ const $c319b2c832c2914a$var$endsWith = (str, searchString, position)=>{
    str = String(str);
    if (position === undefined || position > str.length) position = str.length;
    position -= searchString.length;
    const lastIndex = str.indexOf(searchString, position);
    return lastIndex !== -1 && lastIndex === position;
};
/**
 * Returns new array from array like object or null if failed
 *
 * @param {*} [thing]
 *
 * @returns {?Array}
 */ const $c319b2c832c2914a$var$toArray = (thing)=>{
    if (!thing) return null;
    if ($c319b2c832c2914a$var$isArray(thing)) return thing;
    let i = thing.length;
    if (!$c319b2c832c2914a$var$isNumber(i)) return null;
    const arr = new Array(i);
    while(i-- > 0)arr[i] = thing[i];
    return arr;
};
/**
 * Checking if the Uint8Array exists and if it does, it returns a function that checks if the
 * thing passed in is an instance of Uint8Array
 *
 * @param {TypedArray}
 *
 * @returns {Array}
 */ // eslint-disable-next-line func-names
const $c319b2c832c2914a$var$isTypedArray = ((TypedArray)=>{
    // eslint-disable-next-line func-names
    return (thing)=>{
        return TypedArray && thing instanceof TypedArray;
    };
})(typeof Uint8Array !== 'undefined' && $c319b2c832c2914a$var$getPrototypeOf(Uint8Array));
/**
 * For each entry in the object, call the function with the key and value.
 *
 * @param {Object<any, any>} obj - The object to iterate over.
 * @param {Function} fn - The function to call for each entry.
 *
 * @returns {void}
 */ const $c319b2c832c2914a$var$forEachEntry = (obj, fn)=>{
    const generator = obj && obj[Symbol.iterator];
    const iterator = generator.call(obj);
    let result;
    while((result = iterator.next()) && !result.done){
        const pair = result.value;
        fn.call(obj, pair[0], pair[1]);
    }
};
/**
 * It takes a regular expression and a string, and returns an array of all the matches
 *
 * @param {string} regExp - The regular expression to match against.
 * @param {string} str - The string to search.
 *
 * @returns {Array<boolean>}
 */ const $c319b2c832c2914a$var$matchAll = (regExp, str)=>{
    let matches;
    const arr = [];
    while((matches = regExp.exec(str)) !== null)arr.push(matches);
    return arr;
};
/* Checking if the kindOfTest function returns true when passed an HTMLFormElement. */ const $c319b2c832c2914a$var$isHTMLForm = $c319b2c832c2914a$var$kindOfTest('HTMLFormElement');
const $c319b2c832c2914a$var$toCamelCase = (str)=>{
    return str.toLowerCase().replace(/[-_\s]([a-z\d])(\w*)/g, function replacer(m, p1, p2) {
        return p1.toUpperCase() + p2;
    });
};
/* Creating a function that will check if an object has a property. */ const $c319b2c832c2914a$var$hasOwnProperty = (({ hasOwnProperty: hasOwnProperty })=>(obj, prop)=>hasOwnProperty.call(obj, prop))(Object.prototype);
/**
 * Determine if a value is a RegExp object
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a RegExp object, otherwise false
 */ const $c319b2c832c2914a$var$isRegExp = $c319b2c832c2914a$var$kindOfTest('RegExp');
const $c319b2c832c2914a$var$reduceDescriptors = (obj, reducer)=>{
    const descriptors = Object.getOwnPropertyDescriptors(obj);
    const reducedDescriptors = {};
    $c319b2c832c2914a$var$forEach(descriptors, (descriptor, name)=>{
        let ret;
        if ((ret = reducer(descriptor, name, obj)) !== false) reducedDescriptors[name] = ret || descriptor;
    });
    Object.defineProperties(obj, reducedDescriptors);
};
/**
 * Makes all methods read-only
 * @param {Object} obj
 */ const $c319b2c832c2914a$var$freezeMethods = (obj)=>{
    $c319b2c832c2914a$var$reduceDescriptors(obj, (descriptor, name)=>{
        // skip restricted props in strict mode
        if ($c319b2c832c2914a$var$isFunction(obj) && [
            'arguments',
            'caller',
            'callee'
        ].indexOf(name) !== -1) return false;
        const value = obj[name];
        if (!$c319b2c832c2914a$var$isFunction(value)) return;
        descriptor.enumerable = false;
        if ('writable' in descriptor) {
            descriptor.writable = false;
            return;
        }
        if (!descriptor.set) descriptor.set = ()=>{
            throw Error('Can not rewrite read-only method \'' + name + '\'');
        };
    });
};
const $c319b2c832c2914a$var$toObjectSet = (arrayOrString, delimiter)=>{
    const obj = {};
    const define = (arr)=>{
        arr.forEach((value)=>{
            obj[value] = true;
        });
    };
    $c319b2c832c2914a$var$isArray(arrayOrString) ? define(arrayOrString) : define(String(arrayOrString).split(delimiter));
    return obj;
};
const $c319b2c832c2914a$var$noop = ()=>{};
const $c319b2c832c2914a$var$toFiniteNumber = (value, defaultValue)=>{
    return value != null && Number.isFinite(value = +value) ? value : defaultValue;
};
/**
 * If the thing is a FormData object, return true, otherwise return false.
 *
 * @param {unknown} thing - The thing to check.
 *
 * @returns {boolean}
 */ function $c319b2c832c2914a$var$isSpecCompliantForm(thing) {
    return !!(thing && $c319b2c832c2914a$var$isFunction(thing.append) && thing[Symbol.toStringTag] === 'FormData' && thing[Symbol.iterator]);
}
const $c319b2c832c2914a$var$toJSONObject = (obj)=>{
    const stack = new Array(10);
    const visit = (source, i)=>{
        if ($c319b2c832c2914a$var$isObject(source)) {
            if (stack.indexOf(source) >= 0) return;
            if (!('toJSON' in source)) {
                stack[i] = source;
                const target = $c319b2c832c2914a$var$isArray(source) ? [] : {};
                $c319b2c832c2914a$var$forEach(source, (value, key)=>{
                    const reducedValue = visit(value, i + 1);
                    !$c319b2c832c2914a$var$isUndefined(reducedValue) && (target[key] = reducedValue);
                });
                stack[i] = undefined;
                return target;
            }
        }
        return source;
    };
    return visit(obj, 0);
};
const $c319b2c832c2914a$var$isAsyncFn = $c319b2c832c2914a$var$kindOfTest('AsyncFunction');
const $c319b2c832c2914a$var$isThenable = (thing)=>thing && ($c319b2c832c2914a$var$isObject(thing) || $c319b2c832c2914a$var$isFunction(thing)) && $c319b2c832c2914a$var$isFunction(thing.then) && $c319b2c832c2914a$var$isFunction(thing.catch);
// original code
// https://github.com/DigitalBrainJS/AxiosPromise/blob/16deab13710ec09779922131f3fa5954320f83ab/lib/utils.js#L11-L34
const $c319b2c832c2914a$var$_setImmediate = ((setImmediateSupported, postMessageSupported)=>{
    if (setImmediateSupported) return setImmediate;
    return postMessageSupported ? ((token, callbacks)=>{
        $c319b2c832c2914a$var$_global.addEventListener("message", ({ source: source, data: data })=>{
            if (source === $c319b2c832c2914a$var$_global && data === token) callbacks.length && callbacks.shift()();
        }, false);
        return (cb)=>{
            callbacks.push(cb);
            $c319b2c832c2914a$var$_global.postMessage(token, "*");
        };
    })(`axios@${Math.random()}`, []) : (cb)=>setTimeout(cb);
})(typeof setImmediate === 'function', $c319b2c832c2914a$var$isFunction($c319b2c832c2914a$var$_global.postMessage));
const $c319b2c832c2914a$var$asap = typeof queueMicrotask !== 'undefined' ? queueMicrotask.bind($c319b2c832c2914a$var$_global) : $c319b2c832c2914a$var$_setImmediate;
var // *********************
$c319b2c832c2914a$export$2e2bcd8739ae039 = {
    isArray: $c319b2c832c2914a$var$isArray,
    isArrayBuffer: $c319b2c832c2914a$var$isArrayBuffer,
    isBuffer: $c319b2c832c2914a$var$isBuffer,
    isFormData: $c319b2c832c2914a$var$isFormData,
    isArrayBufferView: $c319b2c832c2914a$var$isArrayBufferView,
    isString: $c319b2c832c2914a$var$isString,
    isNumber: $c319b2c832c2914a$var$isNumber,
    isBoolean: $c319b2c832c2914a$var$isBoolean,
    isObject: $c319b2c832c2914a$var$isObject,
    isPlainObject: $c319b2c832c2914a$var$isPlainObject,
    isReadableStream: $c319b2c832c2914a$var$isReadableStream,
    isRequest: $c319b2c832c2914a$var$isRequest,
    isResponse: $c319b2c832c2914a$var$isResponse,
    isHeaders: $c319b2c832c2914a$var$isHeaders,
    isUndefined: $c319b2c832c2914a$var$isUndefined,
    isDate: $c319b2c832c2914a$var$isDate,
    isFile: $c319b2c832c2914a$var$isFile,
    isBlob: $c319b2c832c2914a$var$isBlob,
    isRegExp: $c319b2c832c2914a$var$isRegExp,
    isFunction: $c319b2c832c2914a$var$isFunction,
    isStream: $c319b2c832c2914a$var$isStream,
    isURLSearchParams: $c319b2c832c2914a$var$isURLSearchParams,
    isTypedArray: $c319b2c832c2914a$var$isTypedArray,
    isFileList: $c319b2c832c2914a$var$isFileList,
    forEach: $c319b2c832c2914a$var$forEach,
    merge: $c319b2c832c2914a$var$merge,
    extend: $c319b2c832c2914a$var$extend,
    trim: $c319b2c832c2914a$var$trim,
    stripBOM: $c319b2c832c2914a$var$stripBOM,
    inherits: $c319b2c832c2914a$var$inherits,
    toFlatObject: $c319b2c832c2914a$var$toFlatObject,
    kindOf: $c319b2c832c2914a$var$kindOf,
    kindOfTest: $c319b2c832c2914a$var$kindOfTest,
    endsWith: $c319b2c832c2914a$var$endsWith,
    toArray: $c319b2c832c2914a$var$toArray,
    forEachEntry: $c319b2c832c2914a$var$forEachEntry,
    matchAll: $c319b2c832c2914a$var$matchAll,
    isHTMLForm: $c319b2c832c2914a$var$isHTMLForm,
    hasOwnProperty: $c319b2c832c2914a$var$hasOwnProperty,
    hasOwnProp: $c319b2c832c2914a$var$hasOwnProperty,
    reduceDescriptors: $c319b2c832c2914a$var$reduceDescriptors,
    freezeMethods: $c319b2c832c2914a$var$freezeMethods,
    toObjectSet: $c319b2c832c2914a$var$toObjectSet,
    toCamelCase: $c319b2c832c2914a$var$toCamelCase,
    noop: $c319b2c832c2914a$var$noop,
    toFiniteNumber: $c319b2c832c2914a$var$toFiniteNumber,
    findKey: $c319b2c832c2914a$var$findKey,
    global: $c319b2c832c2914a$var$_global,
    isContextDefined: $c319b2c832c2914a$var$isContextDefined,
    isSpecCompliantForm: $c319b2c832c2914a$var$isSpecCompliantForm,
    toJSONObject: $c319b2c832c2914a$var$toJSONObject,
    isAsyncFn: $c319b2c832c2914a$var$isAsyncFn,
    isThenable: $c319b2c832c2914a$var$isThenable,
    setImmediate: $c319b2c832c2914a$var$_setImmediate,
    asap: $c319b2c832c2914a$var$asap
};







'use strict';
/**
 * Create an Error with the specified message, config, error code, request and response.
 *
 * @param {string} message The error message.
 * @param {string} [code] The error code (for example, 'ECONNABORTED').
 * @param {Object} [config] The config.
 * @param {Object} [request] The request.
 * @param {Object} [response] The response.
 *
 * @returns {Error} The created error.
 */ function $4e2395edb77acf3a$var$AxiosError(message, code, config, request, response) {
    Error.call(this);
    if (Error.captureStackTrace) Error.captureStackTrace(this, this.constructor);
    else this.stack = new Error().stack;
    this.message = message;
    this.name = 'AxiosError';
    code && (this.code = code);
    config && (this.config = config);
    request && (this.request = request);
    if (response) {
        this.response = response;
        this.status = response.status ? response.status : null;
    }
}
(0, $c319b2c832c2914a$export$2e2bcd8739ae039).inherits($4e2395edb77acf3a$var$AxiosError, Error, {
    toJSON: function toJSON() {
        return {
            // Standard
            message: this.message,
            name: this.name,
            // Microsoft
            description: this.description,
            number: this.number,
            // Mozilla
            fileName: this.fileName,
            lineNumber: this.lineNumber,
            columnNumber: this.columnNumber,
            stack: this.stack,
            // Axios
            config: (0, $c319b2c832c2914a$export$2e2bcd8739ae039).toJSONObject(this.config),
            code: this.code,
            status: this.status
        };
    }
});
const $4e2395edb77acf3a$var$prototype = $4e2395edb77acf3a$var$AxiosError.prototype;
const $4e2395edb77acf3a$var$descriptors = {};
[
    'ERR_BAD_OPTION_VALUE',
    'ERR_BAD_OPTION',
    'ECONNABORTED',
    'ETIMEDOUT',
    'ERR_NETWORK',
    'ERR_FR_TOO_MANY_REDIRECTS',
    'ERR_DEPRECATED',
    'ERR_BAD_RESPONSE',
    'ERR_BAD_REQUEST',
    'ERR_CANCELED',
    'ERR_NOT_SUPPORT',
    'ERR_INVALID_URL'
].forEach((code)=>{
    $4e2395edb77acf3a$var$descriptors[code] = {
        value: code
    };
});
Object.defineProperties($4e2395edb77acf3a$var$AxiosError, $4e2395edb77acf3a$var$descriptors);
Object.defineProperty($4e2395edb77acf3a$var$prototype, 'isAxiosError', {
    value: true
});
// eslint-disable-next-line func-names
$4e2395edb77acf3a$var$AxiosError.from = (error, code, config, request, response, customProps)=>{
    const axiosError = Object.create($4e2395edb77acf3a$var$prototype);
    (0, $c319b2c832c2914a$export$2e2bcd8739ae039).toFlatObject(error, axiosError, function filter(obj) {
        return obj !== Error.prototype;
    }, (prop)=>{
        return prop !== 'isAxiosError';
    });
    $4e2395edb77acf3a$var$AxiosError.call(axiosError, error.message, code, config, request, response);
    axiosError.cause = error;
    axiosError.name = error.name;
    customProps && Object.assign(axiosError, customProps);
    return axiosError;
};
var $4e2395edb77acf3a$export$2e2bcd8739ae039 = $4e2395edb77acf3a$var$AxiosError;


// eslint-disable-next-line strict
var $4023ac50ad132196$export$2e2bcd8739ae039 = null;


/*!
 * The buffer module from node.js, for the browser.
 *
 * @author   Feross Aboukhadijeh <https://feross.org>
 * @license  MIT
 */ /* eslint-disable no-proto */ var $51861dfc7ca9d588$export$a143d493d941bafc;
var $51861dfc7ca9d588$export$e4cf37d7f6fb9e0a;
var $51861dfc7ca9d588$export$f99ded8fe4b79145;
var $51861dfc7ca9d588$export$599f31c3813fae4d;
'use strict';
var $eeb0961446aae8e3$export$a48f0734ac7c2329;
var $eeb0961446aae8e3$export$d622b2ad8d90c771;
var $eeb0961446aae8e3$export$6100ba28696e12de;
'use strict';
$eeb0961446aae8e3$export$a48f0734ac7c2329 = $eeb0961446aae8e3$var$byteLength;
$eeb0961446aae8e3$export$d622b2ad8d90c771 = $eeb0961446aae8e3$var$toByteArray;
$eeb0961446aae8e3$export$6100ba28696e12de = $eeb0961446aae8e3$var$fromByteArray;
var $eeb0961446aae8e3$var$lookup = [];
var $eeb0961446aae8e3$var$revLookup = [];
var $eeb0961446aae8e3$var$Arr = typeof Uint8Array !== 'undefined' ? Uint8Array : Array;
var $eeb0961446aae8e3$var$code = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/';
for(var $eeb0961446aae8e3$var$i = 0, $eeb0961446aae8e3$var$len = $eeb0961446aae8e3$var$code.length; $eeb0961446aae8e3$var$i < $eeb0961446aae8e3$var$len; ++$eeb0961446aae8e3$var$i){
    $eeb0961446aae8e3$var$lookup[$eeb0961446aae8e3$var$i] = $eeb0961446aae8e3$var$code[$eeb0961446aae8e3$var$i];
    $eeb0961446aae8e3$var$revLookup[$eeb0961446aae8e3$var$code.charCodeAt($eeb0961446aae8e3$var$i)] = $eeb0961446aae8e3$var$i;
}
// Support decoding URL-safe base64 strings, as Node.js does.
// See: https://en.wikipedia.org/wiki/Base64#URL_applications
$eeb0961446aae8e3$var$revLookup['-'.charCodeAt(0)] = 62;
$eeb0961446aae8e3$var$revLookup['_'.charCodeAt(0)] = 63;
function $eeb0961446aae8e3$var$getLens(b64) {
    var len = b64.length;
    if (len % 4 > 0) throw new Error('Invalid string. Length must be a multiple of 4');
    // Trim off extra bytes after placeholder bytes are found
    // See: https://github.com/beatgammit/base64-js/issues/42
    var validLen = b64.indexOf('=');
    if (validLen === -1) validLen = len;
    var placeHoldersLen = validLen === len ? 0 : 4 - validLen % 4;
    return [
        validLen,
        placeHoldersLen
    ];
}
// base64 is 4/3 + up to two characters of the original data
function $eeb0961446aae8e3$var$byteLength(b64) {
    var lens = $eeb0961446aae8e3$var$getLens(b64);
    var validLen = lens[0];
    var placeHoldersLen = lens[1];
    return (validLen + placeHoldersLen) * 3 / 4 - placeHoldersLen;
}
function $eeb0961446aae8e3$var$_byteLength(b64, validLen, placeHoldersLen) {
    return (validLen + placeHoldersLen) * 3 / 4 - placeHoldersLen;
}
function $eeb0961446aae8e3$var$toByteArray(b64) {
    var tmp;
    var lens = $eeb0961446aae8e3$var$getLens(b64);
    var validLen = lens[0];
    var placeHoldersLen = lens[1];
    var arr = new $eeb0961446aae8e3$var$Arr($eeb0961446aae8e3$var$_byteLength(b64, validLen, placeHoldersLen));
    var curByte = 0;
    // if there are placeholders, only get up to the last complete 4 chars
    var len = placeHoldersLen > 0 ? validLen - 4 : validLen;
    var i;
    for(i = 0; i < len; i += 4){
        tmp = $eeb0961446aae8e3$var$revLookup[b64.charCodeAt(i)] << 18 | $eeb0961446aae8e3$var$revLookup[b64.charCodeAt(i + 1)] << 12 | $eeb0961446aae8e3$var$revLookup[b64.charCodeAt(i + 2)] << 6 | $eeb0961446aae8e3$var$revLookup[b64.charCodeAt(i + 3)];
        arr[curByte++] = tmp >> 16 & 0xFF;
        arr[curByte++] = tmp >> 8 & 0xFF;
        arr[curByte++] = tmp & 0xFF;
    }
    if (placeHoldersLen === 2) {
        tmp = $eeb0961446aae8e3$var$revLookup[b64.charCodeAt(i)] << 2 | $eeb0961446aae8e3$var$revLookup[b64.charCodeAt(i + 1)] >> 4;
        arr[curByte++] = tmp & 0xFF;
    }
    if (placeHoldersLen === 1) {
        tmp = $eeb0961446aae8e3$var$revLookup[b64.charCodeAt(i)] << 10 | $eeb0961446aae8e3$var$revLookup[b64.charCodeAt(i + 1)] << 4 | $eeb0961446aae8e3$var$revLookup[b64.charCodeAt(i + 2)] >> 2;
        arr[curByte++] = tmp >> 8 & 0xFF;
        arr[curByte++] = tmp & 0xFF;
    }
    return arr;
}
function $eeb0961446aae8e3$var$tripletToBase64(num) {
    return $eeb0961446aae8e3$var$lookup[num >> 18 & 0x3F] + $eeb0961446aae8e3$var$lookup[num >> 12 & 0x3F] + $eeb0961446aae8e3$var$lookup[num >> 6 & 0x3F] + $eeb0961446aae8e3$var$lookup[num & 0x3F];
}
function $eeb0961446aae8e3$var$encodeChunk(uint8, start, end) {
    var tmp;
    var output = [];
    for(var i = start; i < end; i += 3){
        tmp = (uint8[i] << 16 & 0xFF0000) + (uint8[i + 1] << 8 & 0xFF00) + (uint8[i + 2] & 0xFF);
        output.push($eeb0961446aae8e3$var$tripletToBase64(tmp));
    }
    return output.join('');
}
function $eeb0961446aae8e3$var$fromByteArray(uint8) {
    var tmp;
    var len = uint8.length;
    var extraBytes = len % 3 // if we have 1 byte left, pad 2 bytes
    ;
    var parts = [];
    var maxChunkLength = 16383 // must be multiple of 3
    ;
    // go through the array every three bytes, we'll deal with trailing stuff later
    for(var i = 0, len2 = len - extraBytes; i < len2; i += maxChunkLength)parts.push($eeb0961446aae8e3$var$encodeChunk(uint8, i, i + maxChunkLength > len2 ? len2 : i + maxChunkLength));
    // pad the end with zeros, but make sure to not forget the extra bytes
    if (extraBytes === 1) {
        tmp = uint8[len - 1];
        parts.push($eeb0961446aae8e3$var$lookup[tmp >> 2] + $eeb0961446aae8e3$var$lookup[tmp << 4 & 0x3F] + '==');
    } else if (extraBytes === 2) {
        tmp = (uint8[len - 2] << 8) + uint8[len - 1];
        parts.push($eeb0961446aae8e3$var$lookup[tmp >> 10] + $eeb0961446aae8e3$var$lookup[tmp >> 4 & 0x3F] + $eeb0961446aae8e3$var$lookup[tmp << 2 & 0x3F] + '=');
    }
    return parts.join('');
}


/*! ieee754. BSD-3-Clause License. Feross Aboukhadijeh <https://feross.org/opensource> */ var $7221566bd4d49f44$export$aafa59e2e03f2942;
var $7221566bd4d49f44$export$68d8715fc104d294;
$7221566bd4d49f44$export$aafa59e2e03f2942 = function(buffer, offset, isLE, mLen, nBytes) {
    var e, m;
    var eLen = nBytes * 8 - mLen - 1;
    var eMax = (1 << eLen) - 1;
    var eBias = eMax >> 1;
    var nBits = -7;
    var i = isLE ? nBytes - 1 : 0;
    var d = isLE ? -1 : 1;
    var s = buffer[offset + i];
    i += d;
    e = s & (1 << -nBits) - 1;
    s >>= -nBits;
    nBits += eLen;
    for(; nBits > 0; e = e * 256 + buffer[offset + i], i += d, nBits -= 8);
    m = e & (1 << -nBits) - 1;
    e >>= -nBits;
    nBits += mLen;
    for(; nBits > 0; m = m * 256 + buffer[offset + i], i += d, nBits -= 8);
    if (e === 0) e = 1 - eBias;
    else if (e === eMax) return m ? NaN : (s ? -1 : 1) * Infinity;
    else {
        m = m + Math.pow(2, mLen);
        e = e - eBias;
    }
    return (s ? -1 : 1) * m * Math.pow(2, e - mLen);
};
$7221566bd4d49f44$export$68d8715fc104d294 = function(buffer, value, offset, isLE, mLen, nBytes) {
    var e, m, c;
    var eLen = nBytes * 8 - mLen - 1;
    var eMax = (1 << eLen) - 1;
    var eBias = eMax >> 1;
    var rt = mLen === 23 ? Math.pow(2, -24) - Math.pow(2, -77) : 0;
    var i = isLE ? 0 : nBytes - 1;
    var d = isLE ? 1 : -1;
    var s = value < 0 || value === 0 && 1 / value < 0 ? 1 : 0;
    value = Math.abs(value);
    if (isNaN(value) || value === Infinity) {
        m = isNaN(value) ? 1 : 0;
        e = eMax;
    } else {
        e = Math.floor(Math.log(value) / Math.LN2);
        if (value * (c = Math.pow(2, -e)) < 1) {
            e--;
            c *= 2;
        }
        if (e + eBias >= 1) value += rt / c;
        else value += rt * Math.pow(2, 1 - eBias);
        if (value * c >= 2) {
            e++;
            c /= 2;
        }
        if (e + eBias >= eMax) {
            m = 0;
            e = eMax;
        } else if (e + eBias >= 1) {
            m = (value * c - 1) * Math.pow(2, mLen);
            e = e + eBias;
        } else {
            m = value * Math.pow(2, eBias - 1) * Math.pow(2, mLen);
            e = 0;
        }
    }
    for(; mLen >= 8; buffer[offset + i] = m & 0xff, i += d, m /= 256, mLen -= 8);
    e = e << mLen | m;
    eLen += mLen;
    for(; eLen > 0; buffer[offset + i] = e & 0xff, i += d, e /= 256, eLen -= 8);
    buffer[offset + i - d] |= s * 128;
};


const $51861dfc7ca9d588$var$customInspectSymbol = typeof Symbol === 'function' && typeof Symbol['for'] === 'function' // eslint-disable-line dot-notation
 ? Symbol['for']('nodejs.util.inspect.custom') // eslint-disable-line dot-notation
 : null;
$51861dfc7ca9d588$export$a143d493d941bafc = $51861dfc7ca9d588$var$Buffer;
$51861dfc7ca9d588$export$e4cf37d7f6fb9e0a = $51861dfc7ca9d588$var$SlowBuffer;
$51861dfc7ca9d588$export$f99ded8fe4b79145 = 50;
const $51861dfc7ca9d588$var$K_MAX_LENGTH = 0x7fffffff;
$51861dfc7ca9d588$export$599f31c3813fae4d = $51861dfc7ca9d588$var$K_MAX_LENGTH;
/**
 * If `Buffer.TYPED_ARRAY_SUPPORT`:
 *   === true    Use Uint8Array implementation (fastest)
 *   === false   Print warning and recommend using `buffer` v4.x which has an Object
 *               implementation (most compatible, even IE6)
 *
 * Browsers that support typed arrays are IE 10+, Firefox 4+, Chrome 7+, Safari 5.1+,
 * Opera 11.6+, iOS 4.2+.
 *
 * We report that the browser does not support typed arrays if the are not subclassable
 * using __proto__. Firefox 4-29 lacks support for adding new properties to `Uint8Array`
 * (See: https://bugzilla.mozilla.org/show_bug.cgi?id=695438). IE 10 lacks support
 * for __proto__ and has a buggy typed array implementation.
 */ $51861dfc7ca9d588$var$Buffer.TYPED_ARRAY_SUPPORT = $51861dfc7ca9d588$var$typedArraySupport();
if (!$51861dfc7ca9d588$var$Buffer.TYPED_ARRAY_SUPPORT && typeof console !== 'undefined' && typeof console.error === 'function') console.error("This browser lacks typed array (Uint8Array) support which is required by `buffer` v5.x. Use `buffer` v4.x if you require old browser support.");
function $51861dfc7ca9d588$var$typedArraySupport() {
    // Can typed array instances can be augmented?
    try {
        const arr = new Uint8Array(1);
        const proto = {
            foo: function() {
                return 42;
            }
        };
        Object.setPrototypeOf(proto, Uint8Array.prototype);
        Object.setPrototypeOf(arr, proto);
        return arr.foo() === 42;
    } catch (e) {
        return false;
    }
}
Object.defineProperty($51861dfc7ca9d588$var$Buffer.prototype, 'parent', {
    enumerable: true,
    get: function() {
        if (!$51861dfc7ca9d588$var$Buffer.isBuffer(this)) return undefined;
        return this.buffer;
    }
});
Object.defineProperty($51861dfc7ca9d588$var$Buffer.prototype, 'offset', {
    enumerable: true,
    get: function() {
        if (!$51861dfc7ca9d588$var$Buffer.isBuffer(this)) return undefined;
        return this.byteOffset;
    }
});
function $51861dfc7ca9d588$var$createBuffer(length) {
    if (length > $51861dfc7ca9d588$var$K_MAX_LENGTH) throw new RangeError('The value "' + length + '" is invalid for option "size"');
    // Return an augmented `Uint8Array` instance
    const buf = new Uint8Array(length);
    Object.setPrototypeOf(buf, $51861dfc7ca9d588$var$Buffer.prototype);
    return buf;
}
/**
 * The Buffer constructor returns instances of `Uint8Array` that have their
 * prototype changed to `Buffer.prototype`. Furthermore, `Buffer` is a subclass of
 * `Uint8Array`, so the returned instances will have all the node `Buffer` methods
 * and the `Uint8Array` methods. Square bracket notation works as expected -- it
 * returns a single octet.
 *
 * The `Uint8Array` prototype remains unmodified.
 */ function $51861dfc7ca9d588$var$Buffer(arg, encodingOrOffset, length) {
    // Common case.
    if (typeof arg === 'number') {
        if (typeof encodingOrOffset === 'string') throw new TypeError('The "string" argument must be of type string. Received type number');
        return $51861dfc7ca9d588$var$allocUnsafe(arg);
    }
    return $51861dfc7ca9d588$var$from(arg, encodingOrOffset, length);
}
$51861dfc7ca9d588$var$Buffer.poolSize = 8192 // not used by this implementation
;
function $51861dfc7ca9d588$var$from(value, encodingOrOffset, length) {
    if (typeof value === 'string') return $51861dfc7ca9d588$var$fromString(value, encodingOrOffset);
    if (ArrayBuffer.isView(value)) return $51861dfc7ca9d588$var$fromArrayView(value);
    if (value == null) throw new TypeError("The first argument must be one of type string, Buffer, ArrayBuffer, Array, or Array-like Object. Received type " + typeof value);
    if ($51861dfc7ca9d588$var$isInstance(value, ArrayBuffer) || value && $51861dfc7ca9d588$var$isInstance(value.buffer, ArrayBuffer)) return $51861dfc7ca9d588$var$fromArrayBuffer(value, encodingOrOffset, length);
    if (typeof SharedArrayBuffer !== 'undefined' && ($51861dfc7ca9d588$var$isInstance(value, SharedArrayBuffer) || value && $51861dfc7ca9d588$var$isInstance(value.buffer, SharedArrayBuffer))) return $51861dfc7ca9d588$var$fromArrayBuffer(value, encodingOrOffset, length);
    if (typeof value === 'number') throw new TypeError('The "value" argument must not be of type number. Received type number');
    const valueOf = value.valueOf && value.valueOf();
    if (valueOf != null && valueOf !== value) return $51861dfc7ca9d588$var$Buffer.from(valueOf, encodingOrOffset, length);
    const b = $51861dfc7ca9d588$var$fromObject(value);
    if (b) return b;
    if (typeof Symbol !== 'undefined' && Symbol.toPrimitive != null && typeof value[Symbol.toPrimitive] === 'function') return $51861dfc7ca9d588$var$Buffer.from(value[Symbol.toPrimitive]('string'), encodingOrOffset, length);
    throw new TypeError("The first argument must be one of type string, Buffer, ArrayBuffer, Array, or Array-like Object. Received type " + typeof value);
}
/**
 * Functionally equivalent to Buffer(arg, encoding) but throws a TypeError
 * if value is a number.
 * Buffer.from(str[, encoding])
 * Buffer.from(array)
 * Buffer.from(buffer)
 * Buffer.from(arrayBuffer[, byteOffset[, length]])
 **/ $51861dfc7ca9d588$var$Buffer.from = function(value, encodingOrOffset, length) {
    return $51861dfc7ca9d588$var$from(value, encodingOrOffset, length);
};
// Note: Change prototype *after* Buffer.from is defined to workaround Chrome bug:
// https://github.com/feross/buffer/pull/148
Object.setPrototypeOf($51861dfc7ca9d588$var$Buffer.prototype, Uint8Array.prototype);
Object.setPrototypeOf($51861dfc7ca9d588$var$Buffer, Uint8Array);
function $51861dfc7ca9d588$var$assertSize(size) {
    if (typeof size !== 'number') throw new TypeError('"size" argument must be of type number');
    else if (size < 0) throw new RangeError('The value "' + size + '" is invalid for option "size"');
}
function $51861dfc7ca9d588$var$alloc(size, fill, encoding) {
    $51861dfc7ca9d588$var$assertSize(size);
    if (size <= 0) return $51861dfc7ca9d588$var$createBuffer(size);
    if (fill !== undefined) // Only pay attention to encoding if it's a string. This
    // prevents accidentally sending in a number that would
    // be interpreted as a start offset.
    return typeof encoding === 'string' ? $51861dfc7ca9d588$var$createBuffer(size).fill(fill, encoding) : $51861dfc7ca9d588$var$createBuffer(size).fill(fill);
    return $51861dfc7ca9d588$var$createBuffer(size);
}
/**
 * Creates a new filled Buffer instance.
 * alloc(size[, fill[, encoding]])
 **/ $51861dfc7ca9d588$var$Buffer.alloc = function(size, fill, encoding) {
    return $51861dfc7ca9d588$var$alloc(size, fill, encoding);
};
function $51861dfc7ca9d588$var$allocUnsafe(size) {
    $51861dfc7ca9d588$var$assertSize(size);
    return $51861dfc7ca9d588$var$createBuffer(size < 0 ? 0 : $51861dfc7ca9d588$var$checked(size) | 0);
}
/**
 * Equivalent to Buffer(num), by default creates a non-zero-filled Buffer instance.
 * */ $51861dfc7ca9d588$var$Buffer.allocUnsafe = function(size) {
    return $51861dfc7ca9d588$var$allocUnsafe(size);
};
/**
 * Equivalent to SlowBuffer(num), by default creates a non-zero-filled Buffer instance.
 */ $51861dfc7ca9d588$var$Buffer.allocUnsafeSlow = function(size) {
    return $51861dfc7ca9d588$var$allocUnsafe(size);
};
function $51861dfc7ca9d588$var$fromString(string, encoding) {
    if (typeof encoding !== 'string' || encoding === '') encoding = 'utf8';
    if (!$51861dfc7ca9d588$var$Buffer.isEncoding(encoding)) throw new TypeError('Unknown encoding: ' + encoding);
    const length = $51861dfc7ca9d588$var$byteLength(string, encoding) | 0;
    let buf = $51861dfc7ca9d588$var$createBuffer(length);
    const actual = buf.write(string, encoding);
    if (actual !== length) // Writing a hex string, for example, that contains invalid characters will
    // cause everything after the first invalid character to be ignored. (e.g.
    // 'abxxcd' will be treated as 'ab')
    buf = buf.slice(0, actual);
    return buf;
}
function $51861dfc7ca9d588$var$fromArrayLike(array) {
    const length = array.length < 0 ? 0 : $51861dfc7ca9d588$var$checked(array.length) | 0;
    const buf = $51861dfc7ca9d588$var$createBuffer(length);
    for(let i = 0; i < length; i += 1)buf[i] = array[i] & 255;
    return buf;
}
function $51861dfc7ca9d588$var$fromArrayView(arrayView) {
    if ($51861dfc7ca9d588$var$isInstance(arrayView, Uint8Array)) {
        const copy = new Uint8Array(arrayView);
        return $51861dfc7ca9d588$var$fromArrayBuffer(copy.buffer, copy.byteOffset, copy.byteLength);
    }
    return $51861dfc7ca9d588$var$fromArrayLike(arrayView);
}
function $51861dfc7ca9d588$var$fromArrayBuffer(array, byteOffset, length) {
    if (byteOffset < 0 || array.byteLength < byteOffset) throw new RangeError('"offset" is outside of buffer bounds');
    if (array.byteLength < byteOffset + (length || 0)) throw new RangeError('"length" is outside of buffer bounds');
    let buf;
    if (byteOffset === undefined && length === undefined) buf = new Uint8Array(array);
    else if (length === undefined) buf = new Uint8Array(array, byteOffset);
    else buf = new Uint8Array(array, byteOffset, length);
    // Return an augmented `Uint8Array` instance
    Object.setPrototypeOf(buf, $51861dfc7ca9d588$var$Buffer.prototype);
    return buf;
}
function $51861dfc7ca9d588$var$fromObject(obj) {
    if ($51861dfc7ca9d588$var$Buffer.isBuffer(obj)) {
        const len = $51861dfc7ca9d588$var$checked(obj.length) | 0;
        const buf = $51861dfc7ca9d588$var$createBuffer(len);
        if (buf.length === 0) return buf;
        obj.copy(buf, 0, 0, len);
        return buf;
    }
    if (obj.length !== undefined) {
        if (typeof obj.length !== 'number' || $51861dfc7ca9d588$var$numberIsNaN(obj.length)) return $51861dfc7ca9d588$var$createBuffer(0);
        return $51861dfc7ca9d588$var$fromArrayLike(obj);
    }
    if (obj.type === 'Buffer' && Array.isArray(obj.data)) return $51861dfc7ca9d588$var$fromArrayLike(obj.data);
}
function $51861dfc7ca9d588$var$checked(length) {
    // Note: cannot use `length < K_MAX_LENGTH` here because that fails when
    // length is NaN (which is otherwise coerced to zero.)
    if (length >= $51861dfc7ca9d588$var$K_MAX_LENGTH) throw new RangeError("Attempt to allocate Buffer larger than maximum size: 0x" + $51861dfc7ca9d588$var$K_MAX_LENGTH.toString(16) + ' bytes');
    return length | 0;
}
function $51861dfc7ca9d588$var$SlowBuffer(length) {
    if (+length != length) length = 0;
    return $51861dfc7ca9d588$var$Buffer.alloc(+length);
}
$51861dfc7ca9d588$var$Buffer.isBuffer = function isBuffer(b) {
    return b != null && b._isBuffer === true && b !== $51861dfc7ca9d588$var$Buffer.prototype // so Buffer.isBuffer(Buffer.prototype) will be false
    ;
};
$51861dfc7ca9d588$var$Buffer.compare = function compare(a, b) {
    if ($51861dfc7ca9d588$var$isInstance(a, Uint8Array)) a = $51861dfc7ca9d588$var$Buffer.from(a, a.offset, a.byteLength);
    if ($51861dfc7ca9d588$var$isInstance(b, Uint8Array)) b = $51861dfc7ca9d588$var$Buffer.from(b, b.offset, b.byteLength);
    if (!$51861dfc7ca9d588$var$Buffer.isBuffer(a) || !$51861dfc7ca9d588$var$Buffer.isBuffer(b)) throw new TypeError('The "buf1", "buf2" arguments must be one of type Buffer or Uint8Array');
    if (a === b) return 0;
    let x = a.length;
    let y = b.length;
    for(let i = 0, len = Math.min(x, y); i < len; ++i)if (a[i] !== b[i]) {
        x = a[i];
        y = b[i];
        break;
    }
    if (x < y) return -1;
    if (y < x) return 1;
    return 0;
};
$51861dfc7ca9d588$var$Buffer.isEncoding = function isEncoding(encoding) {
    switch(String(encoding).toLowerCase()){
        case 'hex':
        case 'utf8':
        case 'utf-8':
        case 'ascii':
        case 'latin1':
        case 'binary':
        case 'base64':
        case 'ucs2':
        case 'ucs-2':
        case 'utf16le':
        case 'utf-16le':
            return true;
        default:
            return false;
    }
};
$51861dfc7ca9d588$var$Buffer.concat = function concat(list, length) {
    if (!Array.isArray(list)) throw new TypeError('"list" argument must be an Array of Buffers');
    if (list.length === 0) return $51861dfc7ca9d588$var$Buffer.alloc(0);
    let i;
    if (length === undefined) {
        length = 0;
        for(i = 0; i < list.length; ++i)length += list[i].length;
    }
    const buffer = $51861dfc7ca9d588$var$Buffer.allocUnsafe(length);
    let pos = 0;
    for(i = 0; i < list.length; ++i){
        let buf = list[i];
        if ($51861dfc7ca9d588$var$isInstance(buf, Uint8Array)) {
            if (pos + buf.length > buffer.length) {
                if (!$51861dfc7ca9d588$var$Buffer.isBuffer(buf)) buf = $51861dfc7ca9d588$var$Buffer.from(buf);
                buf.copy(buffer, pos);
            } else Uint8Array.prototype.set.call(buffer, buf, pos);
        } else if (!$51861dfc7ca9d588$var$Buffer.isBuffer(buf)) throw new TypeError('"list" argument must be an Array of Buffers');
        else buf.copy(buffer, pos);
        pos += buf.length;
    }
    return buffer;
};
function $51861dfc7ca9d588$var$byteLength(string, encoding) {
    if ($51861dfc7ca9d588$var$Buffer.isBuffer(string)) return string.length;
    if (ArrayBuffer.isView(string) || $51861dfc7ca9d588$var$isInstance(string, ArrayBuffer)) return string.byteLength;
    if (typeof string !== 'string') throw new TypeError('The "string" argument must be one of type string, Buffer, or ArrayBuffer. Received type ' + typeof string);
    const len = string.length;
    const mustMatch = arguments.length > 2 && arguments[2] === true;
    if (!mustMatch && len === 0) return 0;
    // Use a for loop to avoid recursion
    let loweredCase = false;
    for(;;)switch(encoding){
        case 'ascii':
        case 'latin1':
        case 'binary':
            return len;
        case 'utf8':
        case 'utf-8':
            return $51861dfc7ca9d588$var$utf8ToBytes(string).length;
        case 'ucs2':
        case 'ucs-2':
        case 'utf16le':
        case 'utf-16le':
            return len * 2;
        case 'hex':
            return len >>> 1;
        case 'base64':
            return $51861dfc7ca9d588$var$base64ToBytes(string).length;
        default:
            if (loweredCase) return mustMatch ? -1 : $51861dfc7ca9d588$var$utf8ToBytes(string).length // assume utf8
            ;
            encoding = ('' + encoding).toLowerCase();
            loweredCase = true;
    }
}
$51861dfc7ca9d588$var$Buffer.byteLength = $51861dfc7ca9d588$var$byteLength;
function $51861dfc7ca9d588$var$slowToString(encoding, start, end) {
    let loweredCase = false;
    // No need to verify that "this.length <= MAX_UINT32" since it's a read-only
    // property of a typed array.
    // This behaves neither like String nor Uint8Array in that we set start/end
    // to their upper/lower bounds if the value passed is out of range.
    // undefined is handled specially as per ECMA-262 6th Edition,
    // Section 13.3.3.7 Runtime Semantics: KeyedBindingInitialization.
    if (start === undefined || start < 0) start = 0;
    // Return early if start > this.length. Done here to prevent potential uint32
    // coercion fail below.
    if (start > this.length) return '';
    if (end === undefined || end > this.length) end = this.length;
    if (end <= 0) return '';
    // Force coercion to uint32. This will also coerce falsey/NaN values to 0.
    end >>>= 0;
    start >>>= 0;
    if (end <= start) return '';
    if (!encoding) encoding = 'utf8';
    while(true)switch(encoding){
        case 'hex':
            return $51861dfc7ca9d588$var$hexSlice(this, start, end);
        case 'utf8':
        case 'utf-8':
            return $51861dfc7ca9d588$var$utf8Slice(this, start, end);
        case 'ascii':
            return $51861dfc7ca9d588$var$asciiSlice(this, start, end);
        case 'latin1':
        case 'binary':
            return $51861dfc7ca9d588$var$latin1Slice(this, start, end);
        case 'base64':
            return $51861dfc7ca9d588$var$base64Slice(this, start, end);
        case 'ucs2':
        case 'ucs-2':
        case 'utf16le':
        case 'utf-16le':
            return $51861dfc7ca9d588$var$utf16leSlice(this, start, end);
        default:
            if (loweredCase) throw new TypeError('Unknown encoding: ' + encoding);
            encoding = (encoding + '').toLowerCase();
            loweredCase = true;
    }
}
// This property is used by `Buffer.isBuffer` (and the `is-buffer` npm package)
// to detect a Buffer instance. It's not possible to use `instanceof Buffer`
// reliably in a browserify context because there could be multiple different
// copies of the 'buffer' package in use. This method works even for Buffer
// instances that were created from another copy of the `buffer` package.
// See: https://github.com/feross/buffer/issues/154
$51861dfc7ca9d588$var$Buffer.prototype._isBuffer = true;
function $51861dfc7ca9d588$var$swap(b, n, m) {
    const i = b[n];
    b[n] = b[m];
    b[m] = i;
}
$51861dfc7ca9d588$var$Buffer.prototype.swap16 = function swap16() {
    const len = this.length;
    if (len % 2 !== 0) throw new RangeError('Buffer size must be a multiple of 16-bits');
    for(let i = 0; i < len; i += 2)$51861dfc7ca9d588$var$swap(this, i, i + 1);
    return this;
};
$51861dfc7ca9d588$var$Buffer.prototype.swap32 = function swap32() {
    const len = this.length;
    if (len % 4 !== 0) throw new RangeError('Buffer size must be a multiple of 32-bits');
    for(let i = 0; i < len; i += 4){
        $51861dfc7ca9d588$var$swap(this, i, i + 3);
        $51861dfc7ca9d588$var$swap(this, i + 1, i + 2);
    }
    return this;
};
$51861dfc7ca9d588$var$Buffer.prototype.swap64 = function swap64() {
    const len = this.length;
    if (len % 8 !== 0) throw new RangeError('Buffer size must be a multiple of 64-bits');
    for(let i = 0; i < len; i += 8){
        $51861dfc7ca9d588$var$swap(this, i, i + 7);
        $51861dfc7ca9d588$var$swap(this, i + 1, i + 6);
        $51861dfc7ca9d588$var$swap(this, i + 2, i + 5);
        $51861dfc7ca9d588$var$swap(this, i + 3, i + 4);
    }
    return this;
};
$51861dfc7ca9d588$var$Buffer.prototype.toString = function toString() {
    const length = this.length;
    if (length === 0) return '';
    if (arguments.length === 0) return $51861dfc7ca9d588$var$utf8Slice(this, 0, length);
    return $51861dfc7ca9d588$var$slowToString.apply(this, arguments);
};
$51861dfc7ca9d588$var$Buffer.prototype.toLocaleString = $51861dfc7ca9d588$var$Buffer.prototype.toString;
$51861dfc7ca9d588$var$Buffer.prototype.equals = function equals(b) {
    if (!$51861dfc7ca9d588$var$Buffer.isBuffer(b)) throw new TypeError('Argument must be a Buffer');
    if (this === b) return true;
    return $51861dfc7ca9d588$var$Buffer.compare(this, b) === 0;
};
$51861dfc7ca9d588$var$Buffer.prototype.inspect = function inspect() {
    let str = '';
    const max = $51861dfc7ca9d588$export$f99ded8fe4b79145;
    str = this.toString('hex', 0, max).replace(/(.{2})/g, '$1 ').trim();
    if (this.length > max) str += ' ... ';
    return '<Buffer ' + str + '>';
};
if ($51861dfc7ca9d588$var$customInspectSymbol) $51861dfc7ca9d588$var$Buffer.prototype[$51861dfc7ca9d588$var$customInspectSymbol] = $51861dfc7ca9d588$var$Buffer.prototype.inspect;
$51861dfc7ca9d588$var$Buffer.prototype.compare = function compare(target, start, end, thisStart, thisEnd) {
    if ($51861dfc7ca9d588$var$isInstance(target, Uint8Array)) target = $51861dfc7ca9d588$var$Buffer.from(target, target.offset, target.byteLength);
    if (!$51861dfc7ca9d588$var$Buffer.isBuffer(target)) throw new TypeError('The "target" argument must be one of type Buffer or Uint8Array. Received type ' + typeof target);
    if (start === undefined) start = 0;
    if (end === undefined) end = target ? target.length : 0;
    if (thisStart === undefined) thisStart = 0;
    if (thisEnd === undefined) thisEnd = this.length;
    if (start < 0 || end > target.length || thisStart < 0 || thisEnd > this.length) throw new RangeError('out of range index');
    if (thisStart >= thisEnd && start >= end) return 0;
    if (thisStart >= thisEnd) return -1;
    if (start >= end) return 1;
    start >>>= 0;
    end >>>= 0;
    thisStart >>>= 0;
    thisEnd >>>= 0;
    if (this === target) return 0;
    let x = thisEnd - thisStart;
    let y = end - start;
    const len = Math.min(x, y);
    const thisCopy = this.slice(thisStart, thisEnd);
    const targetCopy = target.slice(start, end);
    for(let i = 0; i < len; ++i)if (thisCopy[i] !== targetCopy[i]) {
        x = thisCopy[i];
        y = targetCopy[i];
        break;
    }
    if (x < y) return -1;
    if (y < x) return 1;
    return 0;
};
// Finds either the first index of `val` in `buffer` at offset >= `byteOffset`,
// OR the last index of `val` in `buffer` at offset <= `byteOffset`.
//
// Arguments:
// - buffer - a Buffer to search
// - val - a string, Buffer, or number
// - byteOffset - an index into `buffer`; will be clamped to an int32
// - encoding - an optional encoding, relevant is val is a string
// - dir - true for indexOf, false for lastIndexOf
function $51861dfc7ca9d588$var$bidirectionalIndexOf(buffer, val, byteOffset, encoding, dir) {
    // Empty buffer means no match
    if (buffer.length === 0) return -1;
    // Normalize byteOffset
    if (typeof byteOffset === 'string') {
        encoding = byteOffset;
        byteOffset = 0;
    } else if (byteOffset > 0x7fffffff) byteOffset = 0x7fffffff;
    else if (byteOffset < -2147483648) byteOffset = -2147483648;
    byteOffset = +byteOffset // Coerce to Number.
    ;
    if ($51861dfc7ca9d588$var$numberIsNaN(byteOffset)) // byteOffset: it it's undefined, null, NaN, "foo", etc, search whole buffer
    byteOffset = dir ? 0 : buffer.length - 1;
    // Normalize byteOffset: negative offsets start from the end of the buffer
    if (byteOffset < 0) byteOffset = buffer.length + byteOffset;
    if (byteOffset >= buffer.length) {
        if (dir) return -1;
        else byteOffset = buffer.length - 1;
    } else if (byteOffset < 0) {
        if (dir) byteOffset = 0;
        else return -1;
    }
    // Normalize val
    if (typeof val === 'string') val = $51861dfc7ca9d588$var$Buffer.from(val, encoding);
    // Finally, search either indexOf (if dir is true) or lastIndexOf
    if ($51861dfc7ca9d588$var$Buffer.isBuffer(val)) {
        // Special case: looking for empty string/buffer always fails
        if (val.length === 0) return -1;
        return $51861dfc7ca9d588$var$arrayIndexOf(buffer, val, byteOffset, encoding, dir);
    } else if (typeof val === 'number') {
        val = val & 0xFF // Search for a byte value [0-255]
        ;
        if (typeof Uint8Array.prototype.indexOf === 'function') {
            if (dir) return Uint8Array.prototype.indexOf.call(buffer, val, byteOffset);
            else return Uint8Array.prototype.lastIndexOf.call(buffer, val, byteOffset);
        }
        return $51861dfc7ca9d588$var$arrayIndexOf(buffer, [
            val
        ], byteOffset, encoding, dir);
    }
    throw new TypeError('val must be string, number or Buffer');
}
function $51861dfc7ca9d588$var$arrayIndexOf(arr, val, byteOffset, encoding, dir) {
    let indexSize = 1;
    let arrLength = arr.length;
    let valLength = val.length;
    if (encoding !== undefined) {
        encoding = String(encoding).toLowerCase();
        if (encoding === 'ucs2' || encoding === 'ucs-2' || encoding === 'utf16le' || encoding === 'utf-16le') {
            if (arr.length < 2 || val.length < 2) return -1;
            indexSize = 2;
            arrLength /= 2;
            valLength /= 2;
            byteOffset /= 2;
        }
    }
    function read(buf, i) {
        if (indexSize === 1) return buf[i];
        else return buf.readUInt16BE(i * indexSize);
    }
    let i;
    if (dir) {
        let foundIndex = -1;
        for(i = byteOffset; i < arrLength; i++)if (read(arr, i) === read(val, foundIndex === -1 ? 0 : i - foundIndex)) {
            if (foundIndex === -1) foundIndex = i;
            if (i - foundIndex + 1 === valLength) return foundIndex * indexSize;
        } else {
            if (foundIndex !== -1) i -= i - foundIndex;
            foundIndex = -1;
        }
    } else {
        if (byteOffset + valLength > arrLength) byteOffset = arrLength - valLength;
        for(i = byteOffset; i >= 0; i--){
            let found = true;
            for(let j = 0; j < valLength; j++)if (read(arr, i + j) !== read(val, j)) {
                found = false;
                break;
            }
            if (found) return i;
        }
    }
    return -1;
}
$51861dfc7ca9d588$var$Buffer.prototype.includes = function includes(val, byteOffset, encoding) {
    return this.indexOf(val, byteOffset, encoding) !== -1;
};
$51861dfc7ca9d588$var$Buffer.prototype.indexOf = function indexOf(val, byteOffset, encoding) {
    return $51861dfc7ca9d588$var$bidirectionalIndexOf(this, val, byteOffset, encoding, true);
};
$51861dfc7ca9d588$var$Buffer.prototype.lastIndexOf = function lastIndexOf(val, byteOffset, encoding) {
    return $51861dfc7ca9d588$var$bidirectionalIndexOf(this, val, byteOffset, encoding, false);
};
function $51861dfc7ca9d588$var$hexWrite(buf, string, offset, length) {
    offset = Number(offset) || 0;
    const remaining = buf.length - offset;
    if (!length) length = remaining;
    else {
        length = Number(length);
        if (length > remaining) length = remaining;
    }
    const strLen = string.length;
    if (length > strLen / 2) length = strLen / 2;
    let i;
    for(i = 0; i < length; ++i){
        const parsed = parseInt(string.substr(i * 2, 2), 16);
        if ($51861dfc7ca9d588$var$numberIsNaN(parsed)) return i;
        buf[offset + i] = parsed;
    }
    return i;
}
function $51861dfc7ca9d588$var$utf8Write(buf, string, offset, length) {
    return $51861dfc7ca9d588$var$blitBuffer($51861dfc7ca9d588$var$utf8ToBytes(string, buf.length - offset), buf, offset, length);
}
function $51861dfc7ca9d588$var$asciiWrite(buf, string, offset, length) {
    return $51861dfc7ca9d588$var$blitBuffer($51861dfc7ca9d588$var$asciiToBytes(string), buf, offset, length);
}
function $51861dfc7ca9d588$var$base64Write(buf, string, offset, length) {
    return $51861dfc7ca9d588$var$blitBuffer($51861dfc7ca9d588$var$base64ToBytes(string), buf, offset, length);
}
function $51861dfc7ca9d588$var$ucs2Write(buf, string, offset, length) {
    return $51861dfc7ca9d588$var$blitBuffer($51861dfc7ca9d588$var$utf16leToBytes(string, buf.length - offset), buf, offset, length);
}
$51861dfc7ca9d588$var$Buffer.prototype.write = function write(string, offset, length, encoding) {
    // Buffer#write(string)
    if (offset === undefined) {
        encoding = 'utf8';
        length = this.length;
        offset = 0;
    // Buffer#write(string, encoding)
    } else if (length === undefined && typeof offset === 'string') {
        encoding = offset;
        length = this.length;
        offset = 0;
    // Buffer#write(string, offset[, length][, encoding])
    } else if (isFinite(offset)) {
        offset = offset >>> 0;
        if (isFinite(length)) {
            length = length >>> 0;
            if (encoding === undefined) encoding = 'utf8';
        } else {
            encoding = length;
            length = undefined;
        }
    } else throw new Error('Buffer.write(string, encoding, offset[, length]) is no longer supported');
    const remaining = this.length - offset;
    if (length === undefined || length > remaining) length = remaining;
    if (string.length > 0 && (length < 0 || offset < 0) || offset > this.length) throw new RangeError('Attempt to write outside buffer bounds');
    if (!encoding) encoding = 'utf8';
    let loweredCase = false;
    for(;;)switch(encoding){
        case 'hex':
            return $51861dfc7ca9d588$var$hexWrite(this, string, offset, length);
        case 'utf8':
        case 'utf-8':
            return $51861dfc7ca9d588$var$utf8Write(this, string, offset, length);
        case 'ascii':
        case 'latin1':
        case 'binary':
            return $51861dfc7ca9d588$var$asciiWrite(this, string, offset, length);
        case 'base64':
            // Warning: maxLength not taken into account in base64Write
            return $51861dfc7ca9d588$var$base64Write(this, string, offset, length);
        case 'ucs2':
        case 'ucs-2':
        case 'utf16le':
        case 'utf-16le':
            return $51861dfc7ca9d588$var$ucs2Write(this, string, offset, length);
        default:
            if (loweredCase) throw new TypeError('Unknown encoding: ' + encoding);
            encoding = ('' + encoding).toLowerCase();
            loweredCase = true;
    }
};
$51861dfc7ca9d588$var$Buffer.prototype.toJSON = function toJSON() {
    return {
        type: 'Buffer',
        data: Array.prototype.slice.call(this._arr || this, 0)
    };
};
function $51861dfc7ca9d588$var$base64Slice(buf, start, end) {
    if (start === 0 && end === buf.length) return $eeb0961446aae8e3$export$6100ba28696e12de(buf);
    else return $eeb0961446aae8e3$export$6100ba28696e12de(buf.slice(start, end));
}
function $51861dfc7ca9d588$var$utf8Slice(buf, start, end) {
    end = Math.min(buf.length, end);
    const res = [];
    let i = start;
    while(i < end){
        const firstByte = buf[i];
        let codePoint = null;
        let bytesPerSequence = firstByte > 0xEF ? 4 : firstByte > 0xDF ? 3 : firstByte > 0xBF ? 2 : 1;
        if (i + bytesPerSequence <= end) {
            let secondByte, thirdByte, fourthByte, tempCodePoint;
            switch(bytesPerSequence){
                case 1:
                    if (firstByte < 0x80) codePoint = firstByte;
                    break;
                case 2:
                    secondByte = buf[i + 1];
                    if ((secondByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0x1F) << 0x6 | secondByte & 0x3F;
                        if (tempCodePoint > 0x7F) codePoint = tempCodePoint;
                    }
                    break;
                case 3:
                    secondByte = buf[i + 1];
                    thirdByte = buf[i + 2];
                    if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0xF) << 0xC | (secondByte & 0x3F) << 0x6 | thirdByte & 0x3F;
                        if (tempCodePoint > 0x7FF && (tempCodePoint < 0xD800 || tempCodePoint > 0xDFFF)) codePoint = tempCodePoint;
                    }
                    break;
                case 4:
                    secondByte = buf[i + 1];
                    thirdByte = buf[i + 2];
                    fourthByte = buf[i + 3];
                    if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80 && (fourthByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0xF) << 0x12 | (secondByte & 0x3F) << 0xC | (thirdByte & 0x3F) << 0x6 | fourthByte & 0x3F;
                        if (tempCodePoint > 0xFFFF && tempCodePoint < 0x110000) codePoint = tempCodePoint;
                    }
            }
        }
        if (codePoint === null) {
            // we did not generate a valid codePoint so insert a
            // replacement char (U+FFFD) and advance only 1 byte
            codePoint = 0xFFFD;
            bytesPerSequence = 1;
        } else if (codePoint > 0xFFFF) {
            // encode to utf16 (surrogate pair dance)
            codePoint -= 0x10000;
            res.push(codePoint >>> 10 & 0x3FF | 0xD800);
            codePoint = 0xDC00 | codePoint & 0x3FF;
        }
        res.push(codePoint);
        i += bytesPerSequence;
    }
    return $51861dfc7ca9d588$var$decodeCodePointsArray(res);
}
// Based on http://stackoverflow.com/a/22747272/680742, the browser with
// the lowest limit is Chrome, with 0x10000 args.
// We go 1 magnitude less, for safety
const $51861dfc7ca9d588$var$MAX_ARGUMENTS_LENGTH = 0x1000;
function $51861dfc7ca9d588$var$decodeCodePointsArray(codePoints) {
    const len = codePoints.length;
    if (len <= $51861dfc7ca9d588$var$MAX_ARGUMENTS_LENGTH) return String.fromCharCode.apply(String, codePoints) // avoid extra slice()
    ;
    // Decode in chunks to avoid "call stack size exceeded".
    let res = '';
    let i = 0;
    while(i < len)res += String.fromCharCode.apply(String, codePoints.slice(i, i += $51861dfc7ca9d588$var$MAX_ARGUMENTS_LENGTH));
    return res;
}
function $51861dfc7ca9d588$var$asciiSlice(buf, start, end) {
    let ret = '';
    end = Math.min(buf.length, end);
    for(let i = start; i < end; ++i)ret += String.fromCharCode(buf[i] & 0x7F);
    return ret;
}
function $51861dfc7ca9d588$var$latin1Slice(buf, start, end) {
    let ret = '';
    end = Math.min(buf.length, end);
    for(let i = start; i < end; ++i)ret += String.fromCharCode(buf[i]);
    return ret;
}
function $51861dfc7ca9d588$var$hexSlice(buf, start, end) {
    const len = buf.length;
    if (!start || start < 0) start = 0;
    if (!end || end < 0 || end > len) end = len;
    let out = '';
    for(let i = start; i < end; ++i)out += $51861dfc7ca9d588$var$hexSliceLookupTable[buf[i]];
    return out;
}
function $51861dfc7ca9d588$var$utf16leSlice(buf, start, end) {
    const bytes = buf.slice(start, end);
    let res = '';
    // If bytes.length is odd, the last 8 bits must be ignored (same as node.js)
    for(let i = 0; i < bytes.length - 1; i += 2)res += String.fromCharCode(bytes[i] + bytes[i + 1] * 256);
    return res;
}
$51861dfc7ca9d588$var$Buffer.prototype.slice = function slice(start, end) {
    const len = this.length;
    start = ~~start;
    end = end === undefined ? len : ~~end;
    if (start < 0) {
        start += len;
        if (start < 0) start = 0;
    } else if (start > len) start = len;
    if (end < 0) {
        end += len;
        if (end < 0) end = 0;
    } else if (end > len) end = len;
    if (end < start) end = start;
    const newBuf = this.subarray(start, end);
    // Return an augmented `Uint8Array` instance
    Object.setPrototypeOf(newBuf, $51861dfc7ca9d588$var$Buffer.prototype);
    return newBuf;
};
/*
 * Need to make sure that buffer isn't trying to write out of bounds.
 */ function $51861dfc7ca9d588$var$checkOffset(offset, ext, length) {
    if (offset % 1 !== 0 || offset < 0) throw new RangeError('offset is not uint');
    if (offset + ext > length) throw new RangeError('Trying to access beyond buffer length');
}
$51861dfc7ca9d588$var$Buffer.prototype.readUintLE = $51861dfc7ca9d588$var$Buffer.prototype.readUIntLE = function readUIntLE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, byteLength, this.length);
    let val = this[offset];
    let mul = 1;
    let i = 0;
    while(++i < byteLength && (mul *= 0x100))val += this[offset + i] * mul;
    return val;
};
$51861dfc7ca9d588$var$Buffer.prototype.readUintBE = $51861dfc7ca9d588$var$Buffer.prototype.readUIntBE = function readUIntBE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, byteLength, this.length);
    let val = this[offset + --byteLength];
    let mul = 1;
    while(byteLength > 0 && (mul *= 0x100))val += this[offset + --byteLength] * mul;
    return val;
};
$51861dfc7ca9d588$var$Buffer.prototype.readUint8 = $51861dfc7ca9d588$var$Buffer.prototype.readUInt8 = function readUInt8(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 1, this.length);
    return this[offset];
};
$51861dfc7ca9d588$var$Buffer.prototype.readUint16LE = $51861dfc7ca9d588$var$Buffer.prototype.readUInt16LE = function readUInt16LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 2, this.length);
    return this[offset] | this[offset + 1] << 8;
};
$51861dfc7ca9d588$var$Buffer.prototype.readUint16BE = $51861dfc7ca9d588$var$Buffer.prototype.readUInt16BE = function readUInt16BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 2, this.length);
    return this[offset] << 8 | this[offset + 1];
};
$51861dfc7ca9d588$var$Buffer.prototype.readUint32LE = $51861dfc7ca9d588$var$Buffer.prototype.readUInt32LE = function readUInt32LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 4, this.length);
    return (this[offset] | this[offset + 1] << 8 | this[offset + 2] << 16) + this[offset + 3] * 0x1000000;
};
$51861dfc7ca9d588$var$Buffer.prototype.readUint32BE = $51861dfc7ca9d588$var$Buffer.prototype.readUInt32BE = function readUInt32BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 4, this.length);
    return this[offset] * 0x1000000 + (this[offset + 1] << 16 | this[offset + 2] << 8 | this[offset + 3]);
};
$51861dfc7ca9d588$var$Buffer.prototype.readBigUInt64LE = $51861dfc7ca9d588$var$defineBigIntMethod(function readBigUInt64LE(offset) {
    offset = offset >>> 0;
    $51861dfc7ca9d588$var$validateNumber(offset, 'offset');
    const first = this[offset];
    const last = this[offset + 7];
    if (first === undefined || last === undefined) $51861dfc7ca9d588$var$boundsError(offset, this.length - 8);
    const lo = first + this[++offset] * 256 + this[++offset] * 2 ** 16 + this[++offset] * 2 ** 24;
    const hi = this[++offset] + this[++offset] * 256 + this[++offset] * 2 ** 16 + last * 2 ** 24;
    return BigInt(lo) + (BigInt(hi) << BigInt(32));
});
$51861dfc7ca9d588$var$Buffer.prototype.readBigUInt64BE = $51861dfc7ca9d588$var$defineBigIntMethod(function readBigUInt64BE(offset) {
    offset = offset >>> 0;
    $51861dfc7ca9d588$var$validateNumber(offset, 'offset');
    const first = this[offset];
    const last = this[offset + 7];
    if (first === undefined || last === undefined) $51861dfc7ca9d588$var$boundsError(offset, this.length - 8);
    const hi = first * 2 ** 24 + this[++offset] * 2 ** 16 + this[++offset] * 256 + this[++offset];
    const lo = this[++offset] * 2 ** 24 + this[++offset] * 2 ** 16 + this[++offset] * 256 + last;
    return (BigInt(hi) << BigInt(32)) + BigInt(lo);
});
$51861dfc7ca9d588$var$Buffer.prototype.readIntLE = function readIntLE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, byteLength, this.length);
    let val = this[offset];
    let mul = 1;
    let i = 0;
    while(++i < byteLength && (mul *= 0x100))val += this[offset + i] * mul;
    mul *= 0x80;
    if (val >= mul) val -= Math.pow(2, 8 * byteLength);
    return val;
};
$51861dfc7ca9d588$var$Buffer.prototype.readIntBE = function readIntBE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, byteLength, this.length);
    let i = byteLength;
    let mul = 1;
    let val = this[offset + --i];
    while(i > 0 && (mul *= 0x100))val += this[offset + --i] * mul;
    mul *= 0x80;
    if (val >= mul) val -= Math.pow(2, 8 * byteLength);
    return val;
};
$51861dfc7ca9d588$var$Buffer.prototype.readInt8 = function readInt8(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 1, this.length);
    if (!(this[offset] & 0x80)) return this[offset];
    return (0xff - this[offset] + 1) * -1;
};
$51861dfc7ca9d588$var$Buffer.prototype.readInt16LE = function readInt16LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 2, this.length);
    const val = this[offset] | this[offset + 1] << 8;
    return val & 0x8000 ? val | 0xFFFF0000 : val;
};
$51861dfc7ca9d588$var$Buffer.prototype.readInt16BE = function readInt16BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 2, this.length);
    const val = this[offset + 1] | this[offset] << 8;
    return val & 0x8000 ? val | 0xFFFF0000 : val;
};
$51861dfc7ca9d588$var$Buffer.prototype.readInt32LE = function readInt32LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 4, this.length);
    return this[offset] | this[offset + 1] << 8 | this[offset + 2] << 16 | this[offset + 3] << 24;
};
$51861dfc7ca9d588$var$Buffer.prototype.readInt32BE = function readInt32BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 4, this.length);
    return this[offset] << 24 | this[offset + 1] << 16 | this[offset + 2] << 8 | this[offset + 3];
};
$51861dfc7ca9d588$var$Buffer.prototype.readBigInt64LE = $51861dfc7ca9d588$var$defineBigIntMethod(function readBigInt64LE(offset) {
    offset = offset >>> 0;
    $51861dfc7ca9d588$var$validateNumber(offset, 'offset');
    const first = this[offset];
    const last = this[offset + 7];
    if (first === undefined || last === undefined) $51861dfc7ca9d588$var$boundsError(offset, this.length - 8);
    const val = this[offset + 4] + this[offset + 5] * 256 + this[offset + 6] * 2 ** 16 + (last << 24 // Overflow
    );
    return (BigInt(val) << BigInt(32)) + BigInt(first + this[++offset] * 256 + this[++offset] * 2 ** 16 + this[++offset] * 2 ** 24);
});
$51861dfc7ca9d588$var$Buffer.prototype.readBigInt64BE = $51861dfc7ca9d588$var$defineBigIntMethod(function readBigInt64BE(offset) {
    offset = offset >>> 0;
    $51861dfc7ca9d588$var$validateNumber(offset, 'offset');
    const first = this[offset];
    const last = this[offset + 7];
    if (first === undefined || last === undefined) $51861dfc7ca9d588$var$boundsError(offset, this.length - 8);
    const val = (first << 24) + // Overflow
    this[++offset] * 2 ** 16 + this[++offset] * 256 + this[++offset];
    return (BigInt(val) << BigInt(32)) + BigInt(this[++offset] * 2 ** 24 + this[++offset] * 2 ** 16 + this[++offset] * 256 + last);
});
$51861dfc7ca9d588$var$Buffer.prototype.readFloatLE = function readFloatLE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 4, this.length);
    return $7221566bd4d49f44$export$aafa59e2e03f2942(this, offset, true, 23, 4);
};
$51861dfc7ca9d588$var$Buffer.prototype.readFloatBE = function readFloatBE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 4, this.length);
    return $7221566bd4d49f44$export$aafa59e2e03f2942(this, offset, false, 23, 4);
};
$51861dfc7ca9d588$var$Buffer.prototype.readDoubleLE = function readDoubleLE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 8, this.length);
    return $7221566bd4d49f44$export$aafa59e2e03f2942(this, offset, true, 52, 8);
};
$51861dfc7ca9d588$var$Buffer.prototype.readDoubleBE = function readDoubleBE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 8, this.length);
    return $7221566bd4d49f44$export$aafa59e2e03f2942(this, offset, false, 52, 8);
};
function $51861dfc7ca9d588$var$checkInt(buf, value, offset, ext, max, min) {
    if (!$51861dfc7ca9d588$var$Buffer.isBuffer(buf)) throw new TypeError('"buffer" argument must be a Buffer instance');
    if (value > max || value < min) throw new RangeError('"value" argument is out of bounds');
    if (offset + ext > buf.length) throw new RangeError('Index out of range');
}
$51861dfc7ca9d588$var$Buffer.prototype.writeUintLE = $51861dfc7ca9d588$var$Buffer.prototype.writeUIntLE = function writeUIntLE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) {
        const maxBytes = Math.pow(2, 8 * byteLength) - 1;
        $51861dfc7ca9d588$var$checkInt(this, value, offset, byteLength, maxBytes, 0);
    }
    let mul = 1;
    let i = 0;
    this[offset] = value & 0xFF;
    while(++i < byteLength && (mul *= 0x100))this[offset + i] = value / mul & 0xFF;
    return offset + byteLength;
};
$51861dfc7ca9d588$var$Buffer.prototype.writeUintBE = $51861dfc7ca9d588$var$Buffer.prototype.writeUIntBE = function writeUIntBE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) {
        const maxBytes = Math.pow(2, 8 * byteLength) - 1;
        $51861dfc7ca9d588$var$checkInt(this, value, offset, byteLength, maxBytes, 0);
    }
    let i = byteLength - 1;
    let mul = 1;
    this[offset + i] = value & 0xFF;
    while(--i >= 0 && (mul *= 0x100))this[offset + i] = value / mul & 0xFF;
    return offset + byteLength;
};
$51861dfc7ca9d588$var$Buffer.prototype.writeUint8 = $51861dfc7ca9d588$var$Buffer.prototype.writeUInt8 = function writeUInt8(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkInt(this, value, offset, 1, 0xff, 0);
    this[offset] = value & 0xff;
    return offset + 1;
};
$51861dfc7ca9d588$var$Buffer.prototype.writeUint16LE = $51861dfc7ca9d588$var$Buffer.prototype.writeUInt16LE = function writeUInt16LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkInt(this, value, offset, 2, 0xffff, 0);
    this[offset] = value & 0xff;
    this[offset + 1] = value >>> 8;
    return offset + 2;
};
$51861dfc7ca9d588$var$Buffer.prototype.writeUint16BE = $51861dfc7ca9d588$var$Buffer.prototype.writeUInt16BE = function writeUInt16BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkInt(this, value, offset, 2, 0xffff, 0);
    this[offset] = value >>> 8;
    this[offset + 1] = value & 0xff;
    return offset + 2;
};
$51861dfc7ca9d588$var$Buffer.prototype.writeUint32LE = $51861dfc7ca9d588$var$Buffer.prototype.writeUInt32LE = function writeUInt32LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkInt(this, value, offset, 4, 0xffffffff, 0);
    this[offset + 3] = value >>> 24;
    this[offset + 2] = value >>> 16;
    this[offset + 1] = value >>> 8;
    this[offset] = value & 0xff;
    return offset + 4;
};
$51861dfc7ca9d588$var$Buffer.prototype.writeUint32BE = $51861dfc7ca9d588$var$Buffer.prototype.writeUInt32BE = function writeUInt32BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkInt(this, value, offset, 4, 0xffffffff, 0);
    this[offset] = value >>> 24;
    this[offset + 1] = value >>> 16;
    this[offset + 2] = value >>> 8;
    this[offset + 3] = value & 0xff;
    return offset + 4;
};
function $51861dfc7ca9d588$var$wrtBigUInt64LE(buf, value, offset, min, max) {
    $51861dfc7ca9d588$var$checkIntBI(value, min, max, buf, offset, 7);
    let lo = Number(value & BigInt(0xffffffff));
    buf[offset++] = lo;
    lo = lo >> 8;
    buf[offset++] = lo;
    lo = lo >> 8;
    buf[offset++] = lo;
    lo = lo >> 8;
    buf[offset++] = lo;
    let hi = Number(value >> BigInt(32) & BigInt(0xffffffff));
    buf[offset++] = hi;
    hi = hi >> 8;
    buf[offset++] = hi;
    hi = hi >> 8;
    buf[offset++] = hi;
    hi = hi >> 8;
    buf[offset++] = hi;
    return offset;
}
function $51861dfc7ca9d588$var$wrtBigUInt64BE(buf, value, offset, min, max) {
    $51861dfc7ca9d588$var$checkIntBI(value, min, max, buf, offset, 7);
    let lo = Number(value & BigInt(0xffffffff));
    buf[offset + 7] = lo;
    lo = lo >> 8;
    buf[offset + 6] = lo;
    lo = lo >> 8;
    buf[offset + 5] = lo;
    lo = lo >> 8;
    buf[offset + 4] = lo;
    let hi = Number(value >> BigInt(32) & BigInt(0xffffffff));
    buf[offset + 3] = hi;
    hi = hi >> 8;
    buf[offset + 2] = hi;
    hi = hi >> 8;
    buf[offset + 1] = hi;
    hi = hi >> 8;
    buf[offset] = hi;
    return offset + 8;
}
$51861dfc7ca9d588$var$Buffer.prototype.writeBigUInt64LE = $51861dfc7ca9d588$var$defineBigIntMethod(function writeBigUInt64LE(value, offset = 0) {
    return $51861dfc7ca9d588$var$wrtBigUInt64LE(this, value, offset, BigInt(0), BigInt('0xffffffffffffffff'));
});
$51861dfc7ca9d588$var$Buffer.prototype.writeBigUInt64BE = $51861dfc7ca9d588$var$defineBigIntMethod(function writeBigUInt64BE(value, offset = 0) {
    return $51861dfc7ca9d588$var$wrtBigUInt64BE(this, value, offset, BigInt(0), BigInt('0xffffffffffffffff'));
});
$51861dfc7ca9d588$var$Buffer.prototype.writeIntLE = function writeIntLE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) {
        const limit = Math.pow(2, 8 * byteLength - 1);
        $51861dfc7ca9d588$var$checkInt(this, value, offset, byteLength, limit - 1, -limit);
    }
    let i = 0;
    let mul = 1;
    let sub = 0;
    this[offset] = value & 0xFF;
    while(++i < byteLength && (mul *= 0x100)){
        if (value < 0 && sub === 0 && this[offset + i - 1] !== 0) sub = 1;
        this[offset + i] = (value / mul >> 0) - sub & 0xFF;
    }
    return offset + byteLength;
};
$51861dfc7ca9d588$var$Buffer.prototype.writeIntBE = function writeIntBE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) {
        const limit = Math.pow(2, 8 * byteLength - 1);
        $51861dfc7ca9d588$var$checkInt(this, value, offset, byteLength, limit - 1, -limit);
    }
    let i = byteLength - 1;
    let mul = 1;
    let sub = 0;
    this[offset + i] = value & 0xFF;
    while(--i >= 0 && (mul *= 0x100)){
        if (value < 0 && sub === 0 && this[offset + i + 1] !== 0) sub = 1;
        this[offset + i] = (value / mul >> 0) - sub & 0xFF;
    }
    return offset + byteLength;
};
$51861dfc7ca9d588$var$Buffer.prototype.writeInt8 = function writeInt8(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkInt(this, value, offset, 1, 0x7f, -128);
    if (value < 0) value = 0xff + value + 1;
    this[offset] = value & 0xff;
    return offset + 1;
};
$51861dfc7ca9d588$var$Buffer.prototype.writeInt16LE = function writeInt16LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkInt(this, value, offset, 2, 0x7fff, -32768);
    this[offset] = value & 0xff;
    this[offset + 1] = value >>> 8;
    return offset + 2;
};
$51861dfc7ca9d588$var$Buffer.prototype.writeInt16BE = function writeInt16BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkInt(this, value, offset, 2, 0x7fff, -32768);
    this[offset] = value >>> 8;
    this[offset + 1] = value & 0xff;
    return offset + 2;
};
$51861dfc7ca9d588$var$Buffer.prototype.writeInt32LE = function writeInt32LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkInt(this, value, offset, 4, 0x7fffffff, -2147483648);
    this[offset] = value & 0xff;
    this[offset + 1] = value >>> 8;
    this[offset + 2] = value >>> 16;
    this[offset + 3] = value >>> 24;
    return offset + 4;
};
$51861dfc7ca9d588$var$Buffer.prototype.writeInt32BE = function writeInt32BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkInt(this, value, offset, 4, 0x7fffffff, -2147483648);
    if (value < 0) value = 0xffffffff + value + 1;
    this[offset] = value >>> 24;
    this[offset + 1] = value >>> 16;
    this[offset + 2] = value >>> 8;
    this[offset + 3] = value & 0xff;
    return offset + 4;
};
$51861dfc7ca9d588$var$Buffer.prototype.writeBigInt64LE = $51861dfc7ca9d588$var$defineBigIntMethod(function writeBigInt64LE(value, offset = 0) {
    return $51861dfc7ca9d588$var$wrtBigUInt64LE(this, value, offset, -BigInt('0x8000000000000000'), BigInt('0x7fffffffffffffff'));
});
$51861dfc7ca9d588$var$Buffer.prototype.writeBigInt64BE = $51861dfc7ca9d588$var$defineBigIntMethod(function writeBigInt64BE(value, offset = 0) {
    return $51861dfc7ca9d588$var$wrtBigUInt64BE(this, value, offset, -BigInt('0x8000000000000000'), BigInt('0x7fffffffffffffff'));
});
function $51861dfc7ca9d588$var$checkIEEE754(buf, value, offset, ext, max, min) {
    if (offset + ext > buf.length) throw new RangeError('Index out of range');
    if (offset < 0) throw new RangeError('Index out of range');
}
function $51861dfc7ca9d588$var$writeFloat(buf, value, offset, littleEndian, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkIEEE754(buf, value, offset, 4, 3.4028234663852886e+38, -340282346638528860000000000000000000000);
    $7221566bd4d49f44$export$68d8715fc104d294(buf, value, offset, littleEndian, 23, 4);
    return offset + 4;
}
$51861dfc7ca9d588$var$Buffer.prototype.writeFloatLE = function writeFloatLE(value, offset, noAssert) {
    return $51861dfc7ca9d588$var$writeFloat(this, value, offset, true, noAssert);
};
$51861dfc7ca9d588$var$Buffer.prototype.writeFloatBE = function writeFloatBE(value, offset, noAssert) {
    return $51861dfc7ca9d588$var$writeFloat(this, value, offset, false, noAssert);
};
function $51861dfc7ca9d588$var$writeDouble(buf, value, offset, littleEndian, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkIEEE754(buf, value, offset, 8, 1.7976931348623157E+308, -179769313486231570000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000);
    $7221566bd4d49f44$export$68d8715fc104d294(buf, value, offset, littleEndian, 52, 8);
    return offset + 8;
}
$51861dfc7ca9d588$var$Buffer.prototype.writeDoubleLE = function writeDoubleLE(value, offset, noAssert) {
    return $51861dfc7ca9d588$var$writeDouble(this, value, offset, true, noAssert);
};
$51861dfc7ca9d588$var$Buffer.prototype.writeDoubleBE = function writeDoubleBE(value, offset, noAssert) {
    return $51861dfc7ca9d588$var$writeDouble(this, value, offset, false, noAssert);
};
// copy(targetBuffer, targetStart=0, sourceStart=0, sourceEnd=buffer.length)
$51861dfc7ca9d588$var$Buffer.prototype.copy = function copy(target, targetStart, start, end) {
    if (!$51861dfc7ca9d588$var$Buffer.isBuffer(target)) throw new TypeError('argument should be a Buffer');
    if (!start) start = 0;
    if (!end && end !== 0) end = this.length;
    if (targetStart >= target.length) targetStart = target.length;
    if (!targetStart) targetStart = 0;
    if (end > 0 && end < start) end = start;
    // Copy 0 bytes; we're done
    if (end === start) return 0;
    if (target.length === 0 || this.length === 0) return 0;
    // Fatal error conditions
    if (targetStart < 0) throw new RangeError('targetStart out of bounds');
    if (start < 0 || start >= this.length) throw new RangeError('Index out of range');
    if (end < 0) throw new RangeError('sourceEnd out of bounds');
    // Are we oob?
    if (end > this.length) end = this.length;
    if (target.length - targetStart < end - start) end = target.length - targetStart + start;
    const len = end - start;
    if (this === target && typeof Uint8Array.prototype.copyWithin === 'function') // Use built-in when available, missing from IE11
    this.copyWithin(targetStart, start, end);
    else Uint8Array.prototype.set.call(target, this.subarray(start, end), targetStart);
    return len;
};
// Usage:
//    buffer.fill(number[, offset[, end]])
//    buffer.fill(buffer[, offset[, end]])
//    buffer.fill(string[, offset[, end]][, encoding])
$51861dfc7ca9d588$var$Buffer.prototype.fill = function fill(val, start, end, encoding) {
    // Handle string cases:
    if (typeof val === 'string') {
        if (typeof start === 'string') {
            encoding = start;
            start = 0;
            end = this.length;
        } else if (typeof end === 'string') {
            encoding = end;
            end = this.length;
        }
        if (encoding !== undefined && typeof encoding !== 'string') throw new TypeError('encoding must be a string');
        if (typeof encoding === 'string' && !$51861dfc7ca9d588$var$Buffer.isEncoding(encoding)) throw new TypeError('Unknown encoding: ' + encoding);
        if (val.length === 1) {
            const code = val.charCodeAt(0);
            if (encoding === 'utf8' && code < 128 || encoding === 'latin1') // Fast path: If `val` fits into a single byte, use that numeric value.
            val = code;
        }
    } else if (typeof val === 'number') val = val & 255;
    else if (typeof val === 'boolean') val = Number(val);
    // Invalid ranges are not set to a default, so can range check early.
    if (start < 0 || this.length < start || this.length < end) throw new RangeError('Out of range index');
    if (end <= start) return this;
    start = start >>> 0;
    end = end === undefined ? this.length : end >>> 0;
    if (!val) val = 0;
    let i;
    if (typeof val === 'number') for(i = start; i < end; ++i)this[i] = val;
    else {
        const bytes = $51861dfc7ca9d588$var$Buffer.isBuffer(val) ? val : $51861dfc7ca9d588$var$Buffer.from(val, encoding);
        const len = bytes.length;
        if (len === 0) throw new TypeError('The value "' + val + '" is invalid for argument "value"');
        for(i = 0; i < end - start; ++i)this[i + start] = bytes[i % len];
    }
    return this;
};
// CUSTOM ERRORS
// =============
// Simplified versions from Node, changed for Buffer-only usage
const $51861dfc7ca9d588$var$errors = {};
function $51861dfc7ca9d588$var$E(sym, getMessage, Base) {
    $51861dfc7ca9d588$var$errors[sym] = class NodeError extends Base {
        constructor(){
            super();
            Object.defineProperty(this, 'message', {
                value: getMessage.apply(this, arguments),
                writable: true,
                configurable: true
            });
            // Add the error code to the name to include it in the stack trace.
            this.name = `${this.name} [${sym}]`;
            // Access the stack to generate the error message including the error code
            // from the name.
            this.stack // eslint-disable-line no-unused-expressions
            ;
            // Reset the name to the actual name.
            delete this.name;
        }
        get code() {
            return sym;
        }
        set code(value) {
            Object.defineProperty(this, 'code', {
                configurable: true,
                enumerable: true,
                value: value,
                writable: true
            });
        }
        toString() {
            return `${this.name} [${sym}]: ${this.message}`;
        }
    };
}
$51861dfc7ca9d588$var$E('ERR_BUFFER_OUT_OF_BOUNDS', function(name) {
    if (name) return `${name} is outside of buffer bounds`;
    return 'Attempt to access memory outside buffer bounds';
}, RangeError);
$51861dfc7ca9d588$var$E('ERR_INVALID_ARG_TYPE', function(name, actual) {
    return `The "${name}" argument must be of type number. Received type ${typeof actual}`;
}, TypeError);
$51861dfc7ca9d588$var$E('ERR_OUT_OF_RANGE', function(str, range, input) {
    let msg = `The value of "${str}" is out of range.`;
    let received = input;
    if (Number.isInteger(input) && Math.abs(input) > 2 ** 32) received = $51861dfc7ca9d588$var$addNumericalSeparator(String(input));
    else if (typeof input === 'bigint') {
        received = String(input);
        if (input > BigInt(2) ** BigInt(32) || input < -(BigInt(2) ** BigInt(32))) received = $51861dfc7ca9d588$var$addNumericalSeparator(received);
        received += 'n';
    }
    msg += ` It must be ${range}. Received ${received}`;
    return msg;
}, RangeError);
function $51861dfc7ca9d588$var$addNumericalSeparator(val) {
    let res = '';
    let i = val.length;
    const start = val[0] === '-' ? 1 : 0;
    for(; i >= start + 4; i -= 3)res = `_${val.slice(i - 3, i)}${res}`;
    return `${val.slice(0, i)}${res}`;
}
// CHECK FUNCTIONS
// ===============
function $51861dfc7ca9d588$var$checkBounds(buf, offset, byteLength) {
    $51861dfc7ca9d588$var$validateNumber(offset, 'offset');
    if (buf[offset] === undefined || buf[offset + byteLength] === undefined) $51861dfc7ca9d588$var$boundsError(offset, buf.length - (byteLength + 1));
}
function $51861dfc7ca9d588$var$checkIntBI(value, min, max, buf, offset, byteLength) {
    if (value > max || value < min) {
        const n = typeof min === 'bigint' ? 'n' : '';
        let range;
        if (byteLength > 3) {
            if (min === 0 || min === BigInt(0)) range = `>= 0${n} and < 2${n} ** ${(byteLength + 1) * 8}${n}`;
            else range = `>= -(2${n} ** ${(byteLength + 1) * 8 - 1}${n}) and < 2 ** ` + `${(byteLength + 1) * 8 - 1}${n}`;
        } else range = `>= ${min}${n} and <= ${max}${n}`;
        throw new $51861dfc7ca9d588$var$errors.ERR_OUT_OF_RANGE('value', range, value);
    }
    $51861dfc7ca9d588$var$checkBounds(buf, offset, byteLength);
}
function $51861dfc7ca9d588$var$validateNumber(value, name) {
    if (typeof value !== 'number') throw new $51861dfc7ca9d588$var$errors.ERR_INVALID_ARG_TYPE(name, 'number', value);
}
function $51861dfc7ca9d588$var$boundsError(value, length, type) {
    if (Math.floor(value) !== value) {
        $51861dfc7ca9d588$var$validateNumber(value, type);
        throw new $51861dfc7ca9d588$var$errors.ERR_OUT_OF_RANGE(type || 'offset', 'an integer', value);
    }
    if (length < 0) throw new $51861dfc7ca9d588$var$errors.ERR_BUFFER_OUT_OF_BOUNDS();
    throw new $51861dfc7ca9d588$var$errors.ERR_OUT_OF_RANGE(type || 'offset', `>= ${type ? 1 : 0} and <= ${length}`, value);
}
// HELPER FUNCTIONS
// ================
const $51861dfc7ca9d588$var$INVALID_BASE64_RE = /[^+/0-9A-Za-z-_]/g;
function $51861dfc7ca9d588$var$base64clean(str) {
    // Node takes equal signs as end of the Base64 encoding
    str = str.split('=')[0];
    // Node strips out invalid characters like \n and \t from the string, base64-js does not
    str = str.trim().replace($51861dfc7ca9d588$var$INVALID_BASE64_RE, '');
    // Node converts strings with length < 2 to ''
    if (str.length < 2) return '';
    // Node allows for non-padded base64 strings (missing trailing ===), base64-js does not
    while(str.length % 4 !== 0)str = str + '=';
    return str;
}
function $51861dfc7ca9d588$var$utf8ToBytes(string, units) {
    units = units || Infinity;
    let codePoint;
    const length = string.length;
    let leadSurrogate = null;
    const bytes = [];
    for(let i = 0; i < length; ++i){
        codePoint = string.charCodeAt(i);
        // is surrogate component
        if (codePoint > 0xD7FF && codePoint < 0xE000) {
            // last char was a lead
            if (!leadSurrogate) {
                // no lead yet
                if (codePoint > 0xDBFF) {
                    // unexpected trail
                    if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                    continue;
                } else if (i + 1 === length) {
                    // unpaired lead
                    if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                    continue;
                }
                // valid lead
                leadSurrogate = codePoint;
                continue;
            }
            // 2 leads in a row
            if (codePoint < 0xDC00) {
                if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                leadSurrogate = codePoint;
                continue;
            }
            // valid surrogate pair
            codePoint = (leadSurrogate - 0xD800 << 10 | codePoint - 0xDC00) + 0x10000;
        } else if (leadSurrogate) // valid bmp char, but last char was a lead
        {
            if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
        }
        leadSurrogate = null;
        // encode utf8
        if (codePoint < 0x80) {
            if ((units -= 1) < 0) break;
            bytes.push(codePoint);
        } else if (codePoint < 0x800) {
            if ((units -= 2) < 0) break;
            bytes.push(codePoint >> 0x6 | 0xC0, codePoint & 0x3F | 0x80);
        } else if (codePoint < 0x10000) {
            if ((units -= 3) < 0) break;
            bytes.push(codePoint >> 0xC | 0xE0, codePoint >> 0x6 & 0x3F | 0x80, codePoint & 0x3F | 0x80);
        } else if (codePoint < 0x110000) {
            if ((units -= 4) < 0) break;
            bytes.push(codePoint >> 0x12 | 0xF0, codePoint >> 0xC & 0x3F | 0x80, codePoint >> 0x6 & 0x3F | 0x80, codePoint & 0x3F | 0x80);
        } else throw new Error('Invalid code point');
    }
    return bytes;
}
function $51861dfc7ca9d588$var$asciiToBytes(str) {
    const byteArray = [];
    for(let i = 0; i < str.length; ++i)// Node's code seems to be doing this and not & 0x7F..
    byteArray.push(str.charCodeAt(i) & 0xFF);
    return byteArray;
}
function $51861dfc7ca9d588$var$utf16leToBytes(str, units) {
    let c, hi, lo;
    const byteArray = [];
    for(let i = 0; i < str.length; ++i){
        if ((units -= 2) < 0) break;
        c = str.charCodeAt(i);
        hi = c >> 8;
        lo = c % 256;
        byteArray.push(lo);
        byteArray.push(hi);
    }
    return byteArray;
}
function $51861dfc7ca9d588$var$base64ToBytes(str) {
    return $eeb0961446aae8e3$export$d622b2ad8d90c771($51861dfc7ca9d588$var$base64clean(str));
}
function $51861dfc7ca9d588$var$blitBuffer(src, dst, offset, length) {
    let i;
    for(i = 0; i < length; ++i){
        if (i + offset >= dst.length || i >= src.length) break;
        dst[i + offset] = src[i];
    }
    return i;
}
// ArrayBuffer or Uint8Array objects from other contexts (i.e. iframes) do not pass
// the `instanceof` check but they should be treated as of that type.
// See: https://github.com/feross/buffer/issues/166
function $51861dfc7ca9d588$var$isInstance(obj, type) {
    return obj instanceof type || obj != null && obj.constructor != null && obj.constructor.name != null && obj.constructor.name === type.name;
}
function $51861dfc7ca9d588$var$numberIsNaN(obj) {
    // For IE11 support
    return obj !== obj // eslint-disable-line no-self-compare
    ;
}
// Create lookup table for `toString('hex')`
// See: https://github.com/feross/buffer/issues/219
const $51861dfc7ca9d588$var$hexSliceLookupTable = function() {
    const alphabet = '0123456789abcdef';
    const table = new Array(256);
    for(let i = 0; i < 16; ++i){
        const i16 = i * 16;
        for(let j = 0; j < 16; ++j)table[i16 + j] = alphabet[i] + alphabet[j];
    }
    return table;
}();
// Return not function with Error if BigInt not supported
function $51861dfc7ca9d588$var$defineBigIntMethod(fn) {
    return typeof BigInt === 'undefined' ? $51861dfc7ca9d588$var$BufferBigIntNotDefined : fn;
}
function $51861dfc7ca9d588$var$BufferBigIntNotDefined() {
    throw new Error('BigInt not supported');
}


var $e6cbd383b18c9625$require$Buffer = $51861dfc7ca9d588$export$a143d493d941bafc;
'use strict';
/**
 * Determines if the given thing is a array or js object.
 *
 * @param {string} thing - The object or array to be visited.
 *
 * @returns {boolean}
 */ function $e6cbd383b18c9625$var$isVisitable(thing) {
    return (0, $c319b2c832c2914a$export$2e2bcd8739ae039).isPlainObject(thing) || (0, $c319b2c832c2914a$export$2e2bcd8739ae039).isArray(thing);
}
/**
 * It removes the brackets from the end of a string
 *
 * @param {string} key - The key of the parameter.
 *
 * @returns {string} the key without the brackets.
 */ function $e6cbd383b18c9625$var$removeBrackets(key) {
    return (0, $c319b2c832c2914a$export$2e2bcd8739ae039).endsWith(key, '[]') ? key.slice(0, -2) : key;
}
/**
 * It takes a path, a key, and a boolean, and returns a string
 *
 * @param {string} path - The path to the current key.
 * @param {string} key - The key of the current object being iterated over.
 * @param {string} dots - If true, the key will be rendered with dots instead of brackets.
 *
 * @returns {string} The path to the current key.
 */ function $e6cbd383b18c9625$var$renderKey(path, key, dots) {
    if (!path) return key;
    return path.concat(key).map(function each(token, i) {
        // eslint-disable-next-line no-param-reassign
        token = $e6cbd383b18c9625$var$removeBrackets(token);
        return !dots && i ? '[' + token + ']' : token;
    }).join(dots ? '.' : '');
}
/**
 * If the array is an array and none of its elements are visitable, then it's a flat array.
 *
 * @param {Array<any>} arr - The array to check
 *
 * @returns {boolean}
 */ function $e6cbd383b18c9625$var$isFlatArray(arr) {
    return (0, $c319b2c832c2914a$export$2e2bcd8739ae039).isArray(arr) && !arr.some($e6cbd383b18c9625$var$isVisitable);
}
const $e6cbd383b18c9625$var$predicates = (0, $c319b2c832c2914a$export$2e2bcd8739ae039).toFlatObject((0, $c319b2c832c2914a$export$2e2bcd8739ae039), {}, null, function filter(prop) {
    return /^is[A-Z]/.test(prop);
});
/**
 * Convert a data object to FormData
 *
 * @param {Object} obj
 * @param {?Object} [formData]
 * @param {?Object} [options]
 * @param {Function} [options.visitor]
 * @param {Boolean} [options.metaTokens = true]
 * @param {Boolean} [options.dots = false]
 * @param {?Boolean} [options.indexes = false]
 *
 * @returns {Object}
 **/ /**
 * It converts an object into a FormData object
 *
 * @param {Object<any, any>} obj - The object to convert to form data.
 * @param {string} formData - The FormData object to append to.
 * @param {Object<string, any>} options
 *
 * @returns
 */ function $e6cbd383b18c9625$var$toFormData(obj, formData, options) {
    if (!(0, $c319b2c832c2914a$export$2e2bcd8739ae039).isObject(obj)) throw new TypeError('target must be an object');
    // eslint-disable-next-line no-param-reassign
    formData = formData || new ((0, $4023ac50ad132196$export$2e2bcd8739ae039) || FormData)();
    // eslint-disable-next-line no-param-reassign
    options = (0, $c319b2c832c2914a$export$2e2bcd8739ae039).toFlatObject(options, {
        metaTokens: true,
        dots: false,
        indexes: false
    }, false, function defined(option, source) {
        // eslint-disable-next-line no-eq-null,eqeqeq
        return !(0, $c319b2c832c2914a$export$2e2bcd8739ae039).isUndefined(source[option]);
    });
    const metaTokens = options.metaTokens;
    // eslint-disable-next-line no-use-before-define
    const visitor = options.visitor || defaultVisitor;
    const dots = options.dots;
    const indexes = options.indexes;
    const _Blob = options.Blob || typeof Blob !== 'undefined' && Blob;
    const useBlob = _Blob && (0, $c319b2c832c2914a$export$2e2bcd8739ae039).isSpecCompliantForm(formData);
    if (!(0, $c319b2c832c2914a$export$2e2bcd8739ae039).isFunction(visitor)) throw new TypeError('visitor must be a function');
    function convertValue(value) {
        if (value === null) return '';
        if ((0, $c319b2c832c2914a$export$2e2bcd8739ae039).isDate(value)) return value.toISOString();
        if (!useBlob && (0, $c319b2c832c2914a$export$2e2bcd8739ae039).isBlob(value)) throw new (0, $4e2395edb77acf3a$export$2e2bcd8739ae039)('Blob is not supported. Use a Buffer instead.');
        if ((0, $c319b2c832c2914a$export$2e2bcd8739ae039).isArrayBuffer(value) || (0, $c319b2c832c2914a$export$2e2bcd8739ae039).isTypedArray(value)) return useBlob && typeof Blob === 'function' ? new Blob([
            value
        ]) : $e6cbd383b18c9625$require$Buffer.from(value);
        return value;
    }
    /**
   * Default visitor.
   *
   * @param {*} value
   * @param {String|Number} key
   * @param {Array<String|Number>} path
   * @this {FormData}
   *
   * @returns {boolean} return true to visit the each prop of the value recursively
   */ function defaultVisitor(value, key, path) {
        let arr = value;
        if (value && !path && typeof value === 'object') {
            if ((0, $c319b2c832c2914a$export$2e2bcd8739ae039).endsWith(key, '{}')) {
                // eslint-disable-next-line no-param-reassign
                key = metaTokens ? key : key.slice(0, -2);
                // eslint-disable-next-line no-param-reassign
                value = JSON.stringify(value);
            } else if ((0, $c319b2c832c2914a$export$2e2bcd8739ae039).isArray(value) && $e6cbd383b18c9625$var$isFlatArray(value) || ((0, $c319b2c832c2914a$export$2e2bcd8739ae039).isFileList(value) || (0, $c319b2c832c2914a$export$2e2bcd8739ae039).endsWith(key, '[]')) && (arr = (0, $c319b2c832c2914a$export$2e2bcd8739ae039).toArray(value))) {
                // eslint-disable-next-line no-param-reassign
                key = $e6cbd383b18c9625$var$removeBrackets(key);
                arr.forEach(function each(el, index) {
                    !((0, $c319b2c832c2914a$export$2e2bcd8739ae039).isUndefined(el) || el === null) && formData.append(// eslint-disable-next-line no-nested-ternary
                    indexes === true ? $e6cbd383b18c9625$var$renderKey([
                        key
                    ], index, dots) : indexes === null ? key : key + '[]', convertValue(el));
                });
                return false;
            }
        }
        if ($e6cbd383b18c9625$var$isVisitable(value)) return true;
        formData.append($e6cbd383b18c9625$var$renderKey(path, key, dots), convertValue(value));
        return false;
    }
    const stack = [];
    const exposedHelpers = Object.assign($e6cbd383b18c9625$var$predicates, {
        defaultVisitor: defaultVisitor,
        convertValue: convertValue,
        isVisitable: $e6cbd383b18c9625$var$isVisitable
    });
    function build(value, path) {
        if ((0, $c319b2c832c2914a$export$2e2bcd8739ae039).isUndefined(value)) return;
        if (stack.indexOf(value) !== -1) throw Error('Circular reference detected in ' + path.join('.'));
        stack.push(value);
        (0, $c319b2c832c2914a$export$2e2bcd8739ae039).forEach(value, function each(el, key) {
            const result = !((0, $c319b2c832c2914a$export$2e2bcd8739ae039).isUndefined(el) || el === null) && visitor.call(formData, el, (0, $c319b2c832c2914a$export$2e2bcd8739ae039).isString(key) ? key.trim() : key, path, exposedHelpers);
            if (result === true) build(el, path ? path.concat(key) : [
                key
            ]);
        });
        stack.pop();
    }
    if (!(0, $c319b2c832c2914a$export$2e2bcd8739ae039).isObject(obj)) throw new TypeError('data must be an object');
    build(obj);
    return formData;
}
var $e6cbd383b18c9625$export$2e2bcd8739ae039 = $e6cbd383b18c9625$var$toFormData;


'use strict';
/**
 * It encodes a string by replacing all characters that are not in the unreserved set with
 * their percent-encoded equivalents
 *
 * @param {string} str - The string to encode.
 *
 * @returns {string} The encoded string.
 */ function $f66f8c7b4f247caf$var$encode(str) {
    const charMap = {
        '!': '%21',
        "'": '%27',
        '(': '%28',
        ')': '%29',
        '~': '%7E',
        '%20': '+',
        '%00': '\x00'
    };
    return encodeURIComponent(str).replace(/[!'()~]|%20|%00/g, function replacer(match) {
        return charMap[match];
    });
}
/**
 * It takes a params object and converts it to a FormData object
 *
 * @param {Object<string, any>} params - The parameters to be converted to a FormData object.
 * @param {Object<string, any>} options - The options object passed to the Axios constructor.
 *
 * @returns {void}
 */ function $f66f8c7b4f247caf$var$AxiosURLSearchParams(params, options) {
    this._pairs = [];
    params && (0, $e6cbd383b18c9625$export$2e2bcd8739ae039)(params, this, options);
}
const $f66f8c7b4f247caf$var$prototype = $f66f8c7b4f247caf$var$AxiosURLSearchParams.prototype;
$f66f8c7b4f247caf$var$prototype.append = function append(name, value) {
    this._pairs.push([
        name,
        value
    ]);
};
$f66f8c7b4f247caf$var$prototype.toString = function toString(encoder) {
    const _encode = encoder ? function(value) {
        return encoder.call(this, value, $f66f8c7b4f247caf$var$encode);
    } : $f66f8c7b4f247caf$var$encode;
    return this._pairs.map(function each(pair) {
        return _encode(pair[0]) + '=' + _encode(pair[1]);
    }, '').join('&');
};
var $f66f8c7b4f247caf$export$2e2bcd8739ae039 = $f66f8c7b4f247caf$var$AxiosURLSearchParams;


'use strict';
/**
 * It replaces all instances of the characters `:`, `$`, `,`, `+`, `[`, and `]` with their
 * URI encoded counterparts
 *
 * @param {string} val The value to be encoded.
 *
 * @returns {string} The encoded value.
 */ function $8df8fedf1c1e4428$var$encode(val) {
    return encodeURIComponent(val).replace(/%3A/gi, ':').replace(/%24/g, '$').replace(/%2C/gi, ',').replace(/%20/g, '+').replace(/%5B/gi, '[').replace(/%5D/gi, ']');
}
function $8df8fedf1c1e4428$export$2e2bcd8739ae039(url, params, options) {
    /*eslint no-param-reassign:0*/ if (!params) return url;
    const _encode = options && options.encode || $8df8fedf1c1e4428$var$encode;
    if ((0, $c319b2c832c2914a$export$2e2bcd8739ae039).isFunction(options)) options = {
        serialize: options
    };
    const serializeFn = options && options.serialize;
    let serializedParams;
    if (serializeFn) serializedParams = serializeFn(params, options);
    else serializedParams = (0, $c319b2c832c2914a$export$2e2bcd8739ae039).isURLSearchParams(params) ? params.toString() : new (0, $f66f8c7b4f247caf$export$2e2bcd8739ae039)(params, options).toString(_encode);
    if (serializedParams) {
        const hashmarkIndex = url.indexOf("#");
        if (hashmarkIndex !== -1) url = url.slice(0, hashmarkIndex);
        url += (url.indexOf('?') === -1 ? '?' : '&') + serializedParams;
    }
    return url;
}



'use strict';
class $5de878cd737ef277$var$InterceptorManager {
    constructor(){
        this.handlers = [];
    }
    /**
   * Add a new interceptor to the stack
   *
   * @param {Function} fulfilled The function to handle `then` for a `Promise`
   * @param {Function} rejected The function to handle `reject` for a `Promise`
   *
   * @return {Number} An ID used to remove interceptor later
   */ use(fulfilled, rejected, options) {
        this.handlers.push({
            fulfilled: fulfilled,
            rejected: rejected,
            synchronous: options ? options.synchronous : false,
            runWhen: options ? options.runWhen : null
        });
        return this.handlers.length - 1;
    }
    /**
   * Remove an interceptor from the stack
   *
   * @param {Number} id The ID that was returned by `use`
   *
   * @returns {Boolean} `true` if the interceptor was removed, `false` otherwise
   */ eject(id) {
        if (this.handlers[id]) this.handlers[id] = null;
    }
    /**
   * Clear all interceptors from the stack
   *
   * @returns {void}
   */ clear() {
        if (this.handlers) this.handlers = [];
    }
    /**
   * Iterate over all the registered interceptors
   *
   * This method is particularly useful for skipping over any
   * interceptors that may have become `null` calling `eject`.
   *
   * @param {Function} fn The function to call for each interceptor
   *
   * @returns {void}
   */ forEach(fn) {
        (0, $c319b2c832c2914a$export$2e2bcd8739ae039).forEach(this.handlers, function forEachHandler(h) {
            if (h !== null) fn(h);
        });
    }
}
var $5de878cd737ef277$export$2e2bcd8739ae039 = $5de878cd737ef277$var$InterceptorManager;





'use strict';
var $51466d41a76e5b4b$export$2e2bcd8739ae039 = {
    silentJSONParsing: true,
    forcedJSONParsing: true,
    clarifyTimeoutError: false
};






'use strict';
var $6eeff4490c995137$export$2e2bcd8739ae039 = typeof URLSearchParams !== 'undefined' ? URLSearchParams : (0, $f66f8c7b4f247caf$export$2e2bcd8739ae039);


'use strict';
var $86d275a264afb13f$export$2e2bcd8739ae039 = typeof FormData !== 'undefined' ? FormData : null;


'use strict';
var $59c79e94740631e4$export$2e2bcd8739ae039 = typeof Blob !== 'undefined' ? Blob : null;


var $2f71637df772b183$export$2e2bcd8739ae039 = {
    isBrowser: true,
    classes: {
        URLSearchParams: $6eeff4490c995137$export$2e2bcd8739ae039,
        FormData: $86d275a264afb13f$export$2e2bcd8739ae039,
        Blob: $59c79e94740631e4$export$2e2bcd8739ae039
    },
    protocols: [
        'http',
        'https',
        'file',
        'blob',
        'url',
        'data'
    ]
};


var $565e85ead8bde60a$exports = {};

$parcel$export($565e85ead8bde60a$exports, "hasBrowserEnv", () => $565e85ead8bde60a$export$c4996c4b7b93b0bf);
$parcel$export($565e85ead8bde60a$exports, "navigator", () => $565e85ead8bde60a$export$ec7c8efa7f5790ae);
$parcel$export($565e85ead8bde60a$exports, "hasStandardBrowserEnv", () => $565e85ead8bde60a$export$c0bcc9250309d66);
$parcel$export($565e85ead8bde60a$exports, "hasStandardBrowserWebWorkerEnv", () => $565e85ead8bde60a$export$c81692cf5af97dac);
$parcel$export($565e85ead8bde60a$exports, "origin", () => $565e85ead8bde60a$export$f710a83a91838a36);
const $565e85ead8bde60a$export$c4996c4b7b93b0bf = typeof window !== 'undefined' && typeof document !== 'undefined';
const $565e85ead8bde60a$export$ec7c8efa7f5790ae = typeof navigator === 'object' && navigator || undefined;
/**
 * Determine if we're running in a standard browser environment
 *
 * This allows axios to run in a web worker, and react-native.
 * Both environments support XMLHttpRequest, but not fully standard globals.
 *
 * web workers:
 *  typeof window -> undefined
 *  typeof document -> undefined
 *
 * react-native:
 *  navigator.product -> 'ReactNative'
 * nativescript
 *  navigator.product -> 'NativeScript' or 'NS'
 *
 * @returns {boolean}
 */ const $565e85ead8bde60a$export$c0bcc9250309d66 = $565e85ead8bde60a$export$c4996c4b7b93b0bf && (!$565e85ead8bde60a$export$ec7c8efa7f5790ae || [
    'ReactNative',
    'NativeScript',
    'NS'
].indexOf($565e85ead8bde60a$export$ec7c8efa7f5790ae.product) < 0);
/**
 * Determine if we're running in a standard browser webWorker environment
 *
 * Although the `isStandardBrowserEnv` method indicates that
 * `allows axios to run in a web worker`, the WebWorker will still be
 * filtered out due to its judgment standard
 * `typeof window !== 'undefined' && typeof document !== 'undefined'`.
 * This leads to a problem when axios post `FormData` in webWorker
 */ const $565e85ead8bde60a$export$c81692cf5af97dac = (()=>{
    return typeof WorkerGlobalScope !== 'undefined' && // eslint-disable-next-line no-undef
    self instanceof WorkerGlobalScope && typeof self.importScripts === 'function';
})();
const $565e85ead8bde60a$export$f710a83a91838a36 = $565e85ead8bde60a$export$c4996c4b7b93b0bf && window.location.href || 'http://localhost';


var $bb8180acb278e187$export$2e2bcd8739ae039 = {
    ...$565e85ead8bde60a$exports,
    ...(0, $2f71637df772b183$export$2e2bcd8739ae039)
};


'use strict';
function $f6f250f62cadb740$export$2e2bcd8739ae039(data, options) {
    return (0, $e6cbd383b18c9625$export$2e2bcd8739ae039)(data, new (0, $bb8180acb278e187$export$2e2bcd8739ae039).classes.URLSearchParams(), Object.assign({
        visitor: function(value, key, path, helpers) {
            if ((0, $bb8180acb278e187$export$2e2bcd8739ae039).isNode && (0, $c319b2c832c2914a$export$2e2bcd8739ae039).isBuffer(value)) {
                this.append(key, value.toString('base64'));
                return false;
            }
            return helpers.defaultVisitor.apply(this, arguments);
        }
    }, options));
}




'use strict';
/**
 * It takes a string like `foo[x][y][z]` and returns an array like `['foo', 'x', 'y', 'z']
 *
 * @param {string} name - The name of the property to get.
 *
 * @returns An array of strings.
 */ function $5f8142930b3b943f$var$parsePropPath(name) {
    // foo[x][y][z]
    // foo.x.y.z
    // foo-x-y-z
    // foo x y z
    return (0, $c319b2c832c2914a$export$2e2bcd8739ae039).matchAll(/\w+|\[(\w*)]/g, name).map((match)=>{
        return match[0] === '[]' ? '' : match[1] || match[0];
    });
}
/**
 * Convert an array to an object.
 *
 * @param {Array<any>} arr - The array to convert to an object.
 *
 * @returns An object with the same keys and values as the array.
 */ function $5f8142930b3b943f$var$arrayToObject(arr) {
    const obj = {};
    const keys = Object.keys(arr);
    let i;
    const len = keys.length;
    let key;
    for(i = 0; i < len; i++){
        key = keys[i];
        obj[key] = arr[key];
    }
    return obj;
}
/**
 * It takes a FormData object and returns a JavaScript object
 *
 * @param {string} formData The FormData object to convert to JSON.
 *
 * @returns {Object<string, any> | null} The converted object.
 */ function $5f8142930b3b943f$var$formDataToJSON(formData) {
    function buildPath(path, value, target, index) {
        let name = path[index++];
        if (name === '__proto__') return true;
        const isNumericKey = Number.isFinite(+name);
        const isLast = index >= path.length;
        name = !name && (0, $c319b2c832c2914a$export$2e2bcd8739ae039).isArray(target) ? target.length : name;
        if (isLast) {
            if ((0, $c319b2c832c2914a$export$2e2bcd8739ae039).hasOwnProp(target, name)) target[name] = [
                target[name],
                value
            ];
            else target[name] = value;
            return !isNumericKey;
        }
        if (!target[name] || !(0, $c319b2c832c2914a$export$2e2bcd8739ae039).isObject(target[name])) target[name] = [];
        const result = buildPath(path, value, target[name], index);
        if (result && (0, $c319b2c832c2914a$export$2e2bcd8739ae039).isArray(target[name])) target[name] = $5f8142930b3b943f$var$arrayToObject(target[name]);
        return !isNumericKey;
    }
    if ((0, $c319b2c832c2914a$export$2e2bcd8739ae039).isFormData(formData) && (0, $c319b2c832c2914a$export$2e2bcd8739ae039).isFunction(formData.entries)) {
        const obj = {};
        (0, $c319b2c832c2914a$export$2e2bcd8739ae039).forEachEntry(formData, (name, value)=>{
            buildPath($5f8142930b3b943f$var$parsePropPath(name), value, obj, 0);
        });
        return obj;
    }
    return null;
}
var $5f8142930b3b943f$export$2e2bcd8739ae039 = $5f8142930b3b943f$var$formDataToJSON;


'use strict';
/**
 * It takes a string, tries to parse it, and if it fails, it returns the stringified version
 * of the input
 *
 * @param {any} rawValue - The value to be stringified.
 * @param {Function} parser - A function that parses a string into a JavaScript object.
 * @param {Function} encoder - A function that takes a value and returns a string.
 *
 * @returns {string} A stringified version of the rawValue.
 */ function $843bf0209bc94df8$var$stringifySafely(rawValue, parser, encoder) {
    if ((0, $c319b2c832c2914a$export$2e2bcd8739ae039).isString(rawValue)) try {
        (parser || JSON.parse)(rawValue);
        return (0, $c319b2c832c2914a$export$2e2bcd8739ae039).trim(rawValue);
    } catch (e) {
        if (e.name !== 'SyntaxError') throw e;
    }
    return (encoder || JSON.stringify)(rawValue);
}
const $843bf0209bc94df8$var$defaults = {
    transitional: (0, $51466d41a76e5b4b$export$2e2bcd8739ae039),
    adapter: [
        'xhr',
        'http',
        'fetch'
    ],
    transformRequest: [
        function transformRequest(data, headers) {
            const contentType = headers.getContentType() || '';
            const hasJSONContentType = contentType.indexOf('application/json') > -1;
            const isObjectPayload = (0, $c319b2c832c2914a$export$2e2bcd8739ae039).isObject(data);
            if (isObjectPayload && (0, $c319b2c832c2914a$export$2e2bcd8739ae039).isHTMLForm(data)) data = new FormData(data);
            const isFormData = (0, $c319b2c832c2914a$export$2e2bcd8739ae039).isFormData(data);
            if (isFormData) return hasJSONContentType ? JSON.stringify((0, $5f8142930b3b943f$export$2e2bcd8739ae039)(data)) : data;
            if ((0, $c319b2c832c2914a$export$2e2bcd8739ae039).isArrayBuffer(data) || (0, $c319b2c832c2914a$export$2e2bcd8739ae039).isBuffer(data) || (0, $c319b2c832c2914a$export$2e2bcd8739ae039).isStream(data) || (0, $c319b2c832c2914a$export$2e2bcd8739ae039).isFile(data) || (0, $c319b2c832c2914a$export$2e2bcd8739ae039).isBlob(data) || (0, $c319b2c832c2914a$export$2e2bcd8739ae039).isReadableStream(data)) return data;
            if ((0, $c319b2c832c2914a$export$2e2bcd8739ae039).isArrayBufferView(data)) return data.buffer;
            if ((0, $c319b2c832c2914a$export$2e2bcd8739ae039).isURLSearchParams(data)) {
                headers.setContentType('application/x-www-form-urlencoded;charset=utf-8', false);
                return data.toString();
            }
            let isFileList;
            if (isObjectPayload) {
                if (contentType.indexOf('application/x-www-form-urlencoded') > -1) return (0, $f6f250f62cadb740$export$2e2bcd8739ae039)(data, this.formSerializer).toString();
                if ((isFileList = (0, $c319b2c832c2914a$export$2e2bcd8739ae039).isFileList(data)) || contentType.indexOf('multipart/form-data') > -1) {
                    const _FormData = this.env && this.env.FormData;
                    return (0, $e6cbd383b18c9625$export$2e2bcd8739ae039)(isFileList ? {
                        'files[]': data
                    } : data, _FormData && new _FormData(), this.formSerializer);
                }
            }
            if (isObjectPayload || hasJSONContentType) {
                headers.setContentType('application/json', false);
                return $843bf0209bc94df8$var$stringifySafely(data);
            }
            return data;
        }
    ],
    transformResponse: [
        function transformResponse(data) {
            const transitional = this.transitional || $843bf0209bc94df8$var$defaults.transitional;
            const forcedJSONParsing = transitional && transitional.forcedJSONParsing;
            const JSONRequested = this.responseType === 'json';
            if ((0, $c319b2c832c2914a$export$2e2bcd8739ae039).isResponse(data) || (0, $c319b2c832c2914a$export$2e2bcd8739ae039).isReadableStream(data)) return data;
            if (data && (0, $c319b2c832c2914a$export$2e2bcd8739ae039).isString(data) && (forcedJSONParsing && !this.responseType || JSONRequested)) {
                const silentJSONParsing = transitional && transitional.silentJSONParsing;
                const strictJSONParsing = !silentJSONParsing && JSONRequested;
                try {
                    return JSON.parse(data);
                } catch (e) {
                    if (strictJSONParsing) {
                        if (e.name === 'SyntaxError') throw (0, $4e2395edb77acf3a$export$2e2bcd8739ae039).from(e, (0, $4e2395edb77acf3a$export$2e2bcd8739ae039).ERR_BAD_RESPONSE, this, null, this.response);
                        throw e;
                    }
                }
            }
            return data;
        }
    ],
    /**
   * A timeout in milliseconds to abort a request. If set to 0 (default) a
   * timeout is not created.
   */ timeout: 0,
    xsrfCookieName: 'XSRF-TOKEN',
    xsrfHeaderName: 'X-XSRF-TOKEN',
    maxContentLength: -1,
    maxBodyLength: -1,
    env: {
        FormData: (0, $bb8180acb278e187$export$2e2bcd8739ae039).classes.FormData,
        Blob: (0, $bb8180acb278e187$export$2e2bcd8739ae039).classes.Blob
    },
    validateStatus: function validateStatus(status) {
        return status >= 200 && status < 300;
    },
    headers: {
        common: {
            'Accept': 'application/json, text/plain, */*',
            'Content-Type': undefined
        }
    }
};
(0, $c319b2c832c2914a$export$2e2bcd8739ae039).forEach([
    'delete',
    'get',
    'head',
    'post',
    'put',
    'patch'
], (method)=>{
    $843bf0209bc94df8$var$defaults.headers[method] = {};
});
var $843bf0209bc94df8$export$2e2bcd8739ae039 = $843bf0209bc94df8$var$defaults;




'use strict';
// RawAxiosHeaders whose duplicates are ignored by node
// c.f. https://nodejs.org/api/http.html#http_message_headers
const $fc026bbf9ee156f1$var$ignoreDuplicateOf = (0, $c319b2c832c2914a$export$2e2bcd8739ae039).toObjectSet([
    'age',
    'authorization',
    'content-length',
    'content-type',
    'etag',
    'expires',
    'from',
    'host',
    'if-modified-since',
    'if-unmodified-since',
    'last-modified',
    'location',
    'max-forwards',
    'proxy-authorization',
    'referer',
    'retry-after',
    'user-agent'
]);
var /**
 * Parse headers into an object
 *
 * ```
 * Date: Wed, 27 Aug 2014 08:58:49 GMT
 * Content-Type: application/json
 * Connection: keep-alive
 * Transfer-Encoding: chunked
 * ```
 *
 * @param {String} rawHeaders Headers needing to be parsed
 *
 * @returns {Object} Headers parsed into an object
 */ $fc026bbf9ee156f1$export$2e2bcd8739ae039 = (rawHeaders)=>{
    const parsed = {};
    let key;
    let val;
    let i;
    rawHeaders && rawHeaders.split('\n').forEach(function parser(line) {
        i = line.indexOf(':');
        key = line.substring(0, i).trim().toLowerCase();
        val = line.substring(i + 1).trim();
        if (!key || parsed[key] && $fc026bbf9ee156f1$var$ignoreDuplicateOf[key]) return;
        if (key === 'set-cookie') {
            if (parsed[key]) parsed[key].push(val);
            else parsed[key] = [
                val
            ];
        } else parsed[key] = parsed[key] ? parsed[key] + ', ' + val : val;
    });
    return parsed;
};


'use strict';
const $866cce54f6bdfb0c$var$$internals = Symbol('internals');
function $866cce54f6bdfb0c$var$normalizeHeader(header) {
    return header && String(header).trim().toLowerCase();
}
function $866cce54f6bdfb0c$var$normalizeValue(value) {
    if (value === false || value == null) return value;
    return (0, $c319b2c832c2914a$export$2e2bcd8739ae039).isArray(value) ? value.map($866cce54f6bdfb0c$var$normalizeValue) : String(value);
}
function $866cce54f6bdfb0c$var$parseTokens(str) {
    const tokens = Object.create(null);
    const tokensRE = /([^\s,;=]+)\s*(?:=\s*([^,;]+))?/g;
    let match;
    while(match = tokensRE.exec(str))tokens[match[1]] = match[2];
    return tokens;
}
const $866cce54f6bdfb0c$var$isValidHeaderName = (str)=>/^[-_a-zA-Z0-9^`|~,!#$%&'*+.]+$/.test(str.trim());
function $866cce54f6bdfb0c$var$matchHeaderValue(context, value, header, filter, isHeaderNameFilter) {
    if ((0, $c319b2c832c2914a$export$2e2bcd8739ae039).isFunction(filter)) return filter.call(this, value, header);
    if (isHeaderNameFilter) value = header;
    if (!(0, $c319b2c832c2914a$export$2e2bcd8739ae039).isString(value)) return;
    if ((0, $c319b2c832c2914a$export$2e2bcd8739ae039).isString(filter)) return value.indexOf(filter) !== -1;
    if ((0, $c319b2c832c2914a$export$2e2bcd8739ae039).isRegExp(filter)) return filter.test(value);
}
function $866cce54f6bdfb0c$var$formatHeader(header) {
    return header.trim().toLowerCase().replace(/([a-z\d])(\w*)/g, (w, char, str)=>{
        return char.toUpperCase() + str;
    });
}
function $866cce54f6bdfb0c$var$buildAccessors(obj, header) {
    const accessorName = (0, $c319b2c832c2914a$export$2e2bcd8739ae039).toCamelCase(' ' + header);
    [
        'get',
        'set',
        'has'
    ].forEach((methodName)=>{
        Object.defineProperty(obj, methodName + accessorName, {
            value: function(arg1, arg2, arg3) {
                return this[methodName].call(this, header, arg1, arg2, arg3);
            },
            configurable: true
        });
    });
}
class $866cce54f6bdfb0c$var$AxiosHeaders {
    constructor(headers){
        headers && this.set(headers);
    }
    set(header, valueOrRewrite, rewrite) {
        const self = this;
        function setHeader(_value, _header, _rewrite) {
            const lHeader = $866cce54f6bdfb0c$var$normalizeHeader(_header);
            if (!lHeader) throw new Error('header name must be a non-empty string');
            const key = (0, $c319b2c832c2914a$export$2e2bcd8739ae039).findKey(self, lHeader);
            if (!key || self[key] === undefined || _rewrite === true || _rewrite === undefined && self[key] !== false) self[key || _header] = $866cce54f6bdfb0c$var$normalizeValue(_value);
        }
        const setHeaders = (headers, _rewrite)=>(0, $c319b2c832c2914a$export$2e2bcd8739ae039).forEach(headers, (_value, _header)=>setHeader(_value, _header, _rewrite));
        if ((0, $c319b2c832c2914a$export$2e2bcd8739ae039).isPlainObject(header) || header instanceof this.constructor) setHeaders(header, valueOrRewrite);
        else if ((0, $c319b2c832c2914a$export$2e2bcd8739ae039).isString(header) && (header = header.trim()) && !$866cce54f6bdfb0c$var$isValidHeaderName(header)) setHeaders((0, $fc026bbf9ee156f1$export$2e2bcd8739ae039)(header), valueOrRewrite);
        else if ((0, $c319b2c832c2914a$export$2e2bcd8739ae039).isHeaders(header)) for (const [key, value] of header.entries())setHeader(value, key, rewrite);
        else header != null && setHeader(valueOrRewrite, header, rewrite);
        return this;
    }
    get(header, parser) {
        header = $866cce54f6bdfb0c$var$normalizeHeader(header);
        if (header) {
            const key = (0, $c319b2c832c2914a$export$2e2bcd8739ae039).findKey(this, header);
            if (key) {
                const value = this[key];
                if (!parser) return value;
                if (parser === true) return $866cce54f6bdfb0c$var$parseTokens(value);
                if ((0, $c319b2c832c2914a$export$2e2bcd8739ae039).isFunction(parser)) return parser.call(this, value, key);
                if ((0, $c319b2c832c2914a$export$2e2bcd8739ae039).isRegExp(parser)) return parser.exec(value);
                throw new TypeError('parser must be boolean|regexp|function');
            }
        }
    }
    has(header, matcher) {
        header = $866cce54f6bdfb0c$var$normalizeHeader(header);
        if (header) {
            const key = (0, $c319b2c832c2914a$export$2e2bcd8739ae039).findKey(this, header);
            return !!(key && this[key] !== undefined && (!matcher || $866cce54f6bdfb0c$var$matchHeaderValue(this, this[key], key, matcher)));
        }
        return false;
    }
    delete(header, matcher) {
        const self = this;
        let deleted = false;
        function deleteHeader(_header) {
            _header = $866cce54f6bdfb0c$var$normalizeHeader(_header);
            if (_header) {
                const key = (0, $c319b2c832c2914a$export$2e2bcd8739ae039).findKey(self, _header);
                if (key && (!matcher || $866cce54f6bdfb0c$var$matchHeaderValue(self, self[key], key, matcher))) {
                    delete self[key];
                    deleted = true;
                }
            }
        }
        if ((0, $c319b2c832c2914a$export$2e2bcd8739ae039).isArray(header)) header.forEach(deleteHeader);
        else deleteHeader(header);
        return deleted;
    }
    clear(matcher) {
        const keys = Object.keys(this);
        let i = keys.length;
        let deleted = false;
        while(i--){
            const key = keys[i];
            if (!matcher || $866cce54f6bdfb0c$var$matchHeaderValue(this, this[key], key, matcher, true)) {
                delete this[key];
                deleted = true;
            }
        }
        return deleted;
    }
    normalize(format) {
        const self = this;
        const headers = {};
        (0, $c319b2c832c2914a$export$2e2bcd8739ae039).forEach(this, (value, header)=>{
            const key = (0, $c319b2c832c2914a$export$2e2bcd8739ae039).findKey(headers, header);
            if (key) {
                self[key] = $866cce54f6bdfb0c$var$normalizeValue(value);
                delete self[header];
                return;
            }
            const normalized = format ? $866cce54f6bdfb0c$var$formatHeader(header) : String(header).trim();
            if (normalized !== header) delete self[header];
            self[normalized] = $866cce54f6bdfb0c$var$normalizeValue(value);
            headers[normalized] = true;
        });
        return this;
    }
    concat(...targets) {
        return this.constructor.concat(this, ...targets);
    }
    toJSON(asStrings) {
        const obj = Object.create(null);
        (0, $c319b2c832c2914a$export$2e2bcd8739ae039).forEach(this, (value, header)=>{
            value != null && value !== false && (obj[header] = asStrings && (0, $c319b2c832c2914a$export$2e2bcd8739ae039).isArray(value) ? value.join(', ') : value);
        });
        return obj;
    }
    [Symbol.iterator]() {
        return Object.entries(this.toJSON())[Symbol.iterator]();
    }
    toString() {
        return Object.entries(this.toJSON()).map(([header, value])=>header + ': ' + value).join('\n');
    }
    get [Symbol.toStringTag]() {
        return 'AxiosHeaders';
    }
    static from(thing) {
        return thing instanceof this ? thing : new this(thing);
    }
    static concat(first, ...targets) {
        const computed = new this(first);
        targets.forEach((target)=>computed.set(target));
        return computed;
    }
    static accessor(header) {
        const internals = this[$866cce54f6bdfb0c$var$$internals] = this[$866cce54f6bdfb0c$var$$internals] = {
            accessors: {}
        };
        const accessors = internals.accessors;
        const prototype = this.prototype;
        function defineAccessor(_header) {
            const lHeader = $866cce54f6bdfb0c$var$normalizeHeader(_header);
            if (!accessors[lHeader]) {
                $866cce54f6bdfb0c$var$buildAccessors(prototype, _header);
                accessors[lHeader] = true;
            }
        }
        (0, $c319b2c832c2914a$export$2e2bcd8739ae039).isArray(header) ? header.forEach(defineAccessor) : defineAccessor(header);
        return this;
    }
}
$866cce54f6bdfb0c$var$AxiosHeaders.accessor([
    'Content-Type',
    'Content-Length',
    'Accept',
    'Accept-Encoding',
    'User-Agent',
    'Authorization'
]);
// reserved names hotfix
(0, $c319b2c832c2914a$export$2e2bcd8739ae039).reduceDescriptors($866cce54f6bdfb0c$var$AxiosHeaders.prototype, ({ value: value }, key)=>{
    let mapped = key[0].toUpperCase() + key.slice(1); // map `set` => `Set`
    return {
        get: ()=>value,
        set (headerValue) {
            this[mapped] = headerValue;
        }
    };
});
(0, $c319b2c832c2914a$export$2e2bcd8739ae039).freezeMethods($866cce54f6bdfb0c$var$AxiosHeaders);
var $866cce54f6bdfb0c$export$2e2bcd8739ae039 = $866cce54f6bdfb0c$var$AxiosHeaders;


'use strict';
function $5cf10c777cce5f4f$export$2e2bcd8739ae039(fns, response) {
    const config = this || (0, $843bf0209bc94df8$export$2e2bcd8739ae039);
    const context = response || config;
    const headers = (0, $866cce54f6bdfb0c$export$2e2bcd8739ae039).from(context.headers);
    let data = context.data;
    (0, $c319b2c832c2914a$export$2e2bcd8739ae039).forEach(fns, function transform(fn) {
        data = fn.call(config, data, headers.normalize(), response ? response.status : undefined);
    });
    headers.normalize();
    return data;
}


'use strict';
function $5a60afef8b0dd173$export$2e2bcd8739ae039(value) {
    return !!(value && value.__CANCEL__);
}





'use strict';
/**
 * A `CanceledError` is an object that is thrown when an operation is canceled.
 *
 * @param {string=} message The message.
 * @param {Object=} config The config.
 * @param {Object=} request The request.
 *
 * @returns {CanceledError} The created error.
 */ function $9fd0919e266b4fda$var$CanceledError(message, config, request) {
    // eslint-disable-next-line no-eq-null,eqeqeq
    (0, $4e2395edb77acf3a$export$2e2bcd8739ae039).call(this, message == null ? 'canceled' : message, (0, $4e2395edb77acf3a$export$2e2bcd8739ae039).ERR_CANCELED, config, request);
    this.name = 'CanceledError';
}
(0, $c319b2c832c2914a$export$2e2bcd8739ae039).inherits($9fd0919e266b4fda$var$CanceledError, (0, $4e2395edb77acf3a$export$2e2bcd8739ae039), {
    __CANCEL__: true
});
var $9fd0919e266b4fda$export$2e2bcd8739ae039 = $9fd0919e266b4fda$var$CanceledError;







'use strict';
function $ecb62d5372993dcf$export$2e2bcd8739ae039(resolve, reject, response) {
    const validateStatus = response.config.validateStatus;
    if (!response.status || !validateStatus || validateStatus(response.status)) resolve(response);
    else reject(new (0, $4e2395edb77acf3a$export$2e2bcd8739ae039)('Request failed with status code ' + response.status, [
        (0, $4e2395edb77acf3a$export$2e2bcd8739ae039).ERR_BAD_REQUEST,
        (0, $4e2395edb77acf3a$export$2e2bcd8739ae039).ERR_BAD_RESPONSE
    ][Math.floor(response.status / 100) - 4], response.config, response.request, response));
}





'use strict';
function $23607f53e4fda918$export$2e2bcd8739ae039(url) {
    const match = /^([-+\w]{1,25})(:?\/\/|:)/.exec(url);
    return match && match[1] || '';
}




'use strict';
/**
 * Calculate data maxRate
 * @param {Number} [samplesCount= 10]
 * @param {Number} [min= 1000]
 * @returns {Function}
 */ function $4a9d49cd0e6b8acc$var$speedometer(samplesCount, min) {
    samplesCount = samplesCount || 10;
    const bytes = new Array(samplesCount);
    const timestamps = new Array(samplesCount);
    let head = 0;
    let tail = 0;
    let firstSampleTS;
    min = min !== undefined ? min : 1000;
    return function push(chunkLength) {
        const now = Date.now();
        const startedAt = timestamps[tail];
        if (!firstSampleTS) firstSampleTS = now;
        bytes[head] = chunkLength;
        timestamps[head] = now;
        let i = tail;
        let bytesCount = 0;
        while(i !== head){
            bytesCount += bytes[i++];
            i = i % samplesCount;
        }
        head = (head + 1) % samplesCount;
        if (head === tail) tail = (tail + 1) % samplesCount;
        if (now - firstSampleTS < min) return;
        const passed = startedAt && now - startedAt;
        return passed ? Math.round(bytesCount * 1000 / passed) : undefined;
    };
}
var $4a9d49cd0e6b8acc$export$2e2bcd8739ae039 = $4a9d49cd0e6b8acc$var$speedometer;


/**
 * Throttle decorator
 * @param {Function} fn
 * @param {Number} freq
 * @return {Function}
 */ function $9b3ced92bc7bdc99$var$throttle(fn, freq) {
    let timestamp = 0;
    let threshold = 1000 / freq;
    let lastArgs;
    let timer;
    const invoke = (args, now = Date.now())=>{
        timestamp = now;
        lastArgs = null;
        if (timer) {
            clearTimeout(timer);
            timer = null;
        }
        fn.apply(null, args);
    };
    const throttled = (...args)=>{
        const now = Date.now();
        const passed = now - timestamp;
        if (passed >= threshold) invoke(args, now);
        else {
            lastArgs = args;
            if (!timer) timer = setTimeout(()=>{
                timer = null;
                invoke(lastArgs);
            }, threshold - passed);
        }
    };
    const flush = ()=>lastArgs && invoke(lastArgs);
    return [
        throttled,
        flush
    ];
}
var $9b3ced92bc7bdc99$export$2e2bcd8739ae039 = $9b3ced92bc7bdc99$var$throttle;



const $1a6c80b567b74091$export$c1b28109d46c3592 = (listener, isDownloadStream, freq = 3)=>{
    let bytesNotified = 0;
    const _speedometer = (0, $4a9d49cd0e6b8acc$export$2e2bcd8739ae039)(50, 250);
    return (0, $9b3ced92bc7bdc99$export$2e2bcd8739ae039)((e)=>{
        const loaded = e.loaded;
        const total = e.lengthComputable ? e.total : undefined;
        const progressBytes = loaded - bytesNotified;
        const rate = _speedometer(progressBytes);
        const inRange = loaded <= total;
        bytesNotified = loaded;
        const data = {
            loaded: loaded,
            total: total,
            progress: total ? loaded / total : undefined,
            bytes: progressBytes,
            rate: rate ? rate : undefined,
            estimated: rate && total && inRange ? (total - loaded) / rate : undefined,
            event: e,
            lengthComputable: total != null,
            [isDownloadStream ? 'download' : 'upload']: true
        };
        listener(data);
    }, freq);
};
const $1a6c80b567b74091$export$d9fadd12586c18d6 = (total, throttled)=>{
    const lengthComputable = total != null;
    return [
        (loaded)=>throttled[0]({
                lengthComputable: lengthComputable,
                total: total,
                loaded: loaded
            }),
        throttled[1]
    ];
};
const $1a6c80b567b74091$export$5d35863c355a22a9 = (fn)=>(...args)=>(0, $c319b2c832c2914a$export$2e2bcd8739ae039).asap(()=>fn(...args));





var $5eb63b558e1fb85a$export$2e2bcd8739ae039 = (0, $bb8180acb278e187$export$2e2bcd8739ae039).hasStandardBrowserEnv ? ((origin, isMSIE)=>(url)=>{
        url = new URL(url, (0, $bb8180acb278e187$export$2e2bcd8739ae039).origin);
        return origin.protocol === url.protocol && origin.host === url.host && (isMSIE || origin.port === url.port);
    })(new URL((0, $bb8180acb278e187$export$2e2bcd8739ae039).origin), (0, $bb8180acb278e187$export$2e2bcd8739ae039).navigator && /(msie|trident)/i.test((0, $bb8180acb278e187$export$2e2bcd8739ae039).navigator.userAgent)) : ()=>true;




var $65cc14c0704b5541$export$2e2bcd8739ae039 = (0, $bb8180acb278e187$export$2e2bcd8739ae039).hasStandardBrowserEnv ? // Standard browser envs support document.cookie
{
    write (name, value, expires, path, domain, secure) {
        const cookie = [
            name + '=' + encodeURIComponent(value)
        ];
        (0, $c319b2c832c2914a$export$2e2bcd8739ae039).isNumber(expires) && cookie.push('expires=' + new Date(expires).toGMTString());
        (0, $c319b2c832c2914a$export$2e2bcd8739ae039).isString(path) && cookie.push('path=' + path);
        (0, $c319b2c832c2914a$export$2e2bcd8739ae039).isString(domain) && cookie.push('domain=' + domain);
        secure === true && cookie.push('secure');
        document.cookie = cookie.join('; ');
    },
    read (name) {
        const match = document.cookie.match(new RegExp('(^|;\\s*)(' + name + ')=([^;]*)'));
        return match ? decodeURIComponent(match[3]) : null;
    },
    remove (name) {
        this.write(name, '', Date.now() - 86400000);
    }
} : // Non-standard browser env (web workers, react-native) lack needed support.
{
    write () {},
    read () {
        return null;
    },
    remove () {}
};


'use strict';
function $8fa91c1a59edb5d9$export$2e2bcd8739ae039(url) {
    // A URL is considered absolute if it begins with "<scheme>://" or "//" (protocol-relative URL).
    // RFC 3986 defines scheme name as a sequence of characters beginning with a letter and followed
    // by any combination of letters, digits, plus, period, or hyphen.
    return /^([a-z][a-z\d+\-.]*:)?\/\//i.test(url);
}


'use strict';
function $b63e12c1e0b9e0be$export$2e2bcd8739ae039(baseURL, relativeURL) {
    return relativeURL ? baseURL.replace(/\/?\/$/, '') + '/' + relativeURL.replace(/^\/+/, '') : baseURL;
}


'use strict';
function $598acbfafd2c63c5$export$2e2bcd8739ae039(baseURL, requestedURL, allowAbsoluteUrls) {
    let isRelativeUrl = !(0, $8fa91c1a59edb5d9$export$2e2bcd8739ae039)(requestedURL);
    if (baseURL && (isRelativeUrl || allowAbsoluteUrls == false)) return (0, $b63e12c1e0b9e0be$export$2e2bcd8739ae039)(baseURL, requestedURL);
    return requestedURL;
}




'use strict';
const $f85fda54cd977b19$var$headersToObject = (thing)=>thing instanceof (0, $866cce54f6bdfb0c$export$2e2bcd8739ae039) ? {
        ...thing
    } : thing;
function $f85fda54cd977b19$export$2e2bcd8739ae039(config1, config2) {
    // eslint-disable-next-line no-param-reassign
    config2 = config2 || {};
    const config = {};
    function getMergedValue(target, source, prop, caseless) {
        if ((0, $c319b2c832c2914a$export$2e2bcd8739ae039).isPlainObject(target) && (0, $c319b2c832c2914a$export$2e2bcd8739ae039).isPlainObject(source)) return (0, $c319b2c832c2914a$export$2e2bcd8739ae039).merge.call({
            caseless: caseless
        }, target, source);
        else if ((0, $c319b2c832c2914a$export$2e2bcd8739ae039).isPlainObject(source)) return (0, $c319b2c832c2914a$export$2e2bcd8739ae039).merge({}, source);
        else if ((0, $c319b2c832c2914a$export$2e2bcd8739ae039).isArray(source)) return source.slice();
        return source;
    }
    // eslint-disable-next-line consistent-return
    function mergeDeepProperties(a, b, prop, caseless) {
        if (!(0, $c319b2c832c2914a$export$2e2bcd8739ae039).isUndefined(b)) return getMergedValue(a, b, prop, caseless);
        else if (!(0, $c319b2c832c2914a$export$2e2bcd8739ae039).isUndefined(a)) return getMergedValue(undefined, a, prop, caseless);
    }
    // eslint-disable-next-line consistent-return
    function valueFromConfig2(a, b) {
        if (!(0, $c319b2c832c2914a$export$2e2bcd8739ae039).isUndefined(b)) return getMergedValue(undefined, b);
    }
    // eslint-disable-next-line consistent-return
    function defaultToConfig2(a, b) {
        if (!(0, $c319b2c832c2914a$export$2e2bcd8739ae039).isUndefined(b)) return getMergedValue(undefined, b);
        else if (!(0, $c319b2c832c2914a$export$2e2bcd8739ae039).isUndefined(a)) return getMergedValue(undefined, a);
    }
    // eslint-disable-next-line consistent-return
    function mergeDirectKeys(a, b, prop) {
        if (prop in config2) return getMergedValue(a, b);
        else if (prop in config1) return getMergedValue(undefined, a);
    }
    const mergeMap = {
        url: valueFromConfig2,
        method: valueFromConfig2,
        data: valueFromConfig2,
        baseURL: defaultToConfig2,
        transformRequest: defaultToConfig2,
        transformResponse: defaultToConfig2,
        paramsSerializer: defaultToConfig2,
        timeout: defaultToConfig2,
        timeoutMessage: defaultToConfig2,
        withCredentials: defaultToConfig2,
        withXSRFToken: defaultToConfig2,
        adapter: defaultToConfig2,
        responseType: defaultToConfig2,
        xsrfCookieName: defaultToConfig2,
        xsrfHeaderName: defaultToConfig2,
        onUploadProgress: defaultToConfig2,
        onDownloadProgress: defaultToConfig2,
        decompress: defaultToConfig2,
        maxContentLength: defaultToConfig2,
        maxBodyLength: defaultToConfig2,
        beforeRedirect: defaultToConfig2,
        transport: defaultToConfig2,
        httpAgent: defaultToConfig2,
        httpsAgent: defaultToConfig2,
        cancelToken: defaultToConfig2,
        socketPath: defaultToConfig2,
        responseEncoding: defaultToConfig2,
        validateStatus: mergeDirectKeys,
        headers: (a, b, prop)=>mergeDeepProperties($f85fda54cd977b19$var$headersToObject(a), $f85fda54cd977b19$var$headersToObject(b), prop, true)
    };
    (0, $c319b2c832c2914a$export$2e2bcd8739ae039).forEach(Object.keys(Object.assign({}, config1, config2)), function computeConfigValue(prop) {
        const merge = mergeMap[prop] || mergeDeepProperties;
        const configValue = merge(config1[prop], config2[prop], prop);
        (0, $c319b2c832c2914a$export$2e2bcd8739ae039).isUndefined(configValue) && merge !== mergeDirectKeys || (config[prop] = configValue);
    });
    return config;
}




var $ab4625fac3104691$export$2e2bcd8739ae039 = (config)=>{
    const newConfig = (0, $f85fda54cd977b19$export$2e2bcd8739ae039)({}, config);
    let { data: data, withXSRFToken: withXSRFToken, xsrfHeaderName: xsrfHeaderName, xsrfCookieName: xsrfCookieName, headers: headers, auth: auth } = newConfig;
    newConfig.headers = headers = (0, $866cce54f6bdfb0c$export$2e2bcd8739ae039).from(headers);
    newConfig.url = (0, $8df8fedf1c1e4428$export$2e2bcd8739ae039)((0, $598acbfafd2c63c5$export$2e2bcd8739ae039)(newConfig.baseURL, newConfig.url, newConfig.allowAbsoluteUrls), config.params, config.paramsSerializer);
    // HTTP basic authentication
    if (auth) headers.set('Authorization', 'Basic ' + btoa((auth.username || '') + ':' + (auth.password ? unescape(encodeURIComponent(auth.password)) : '')));
    let contentType;
    if ((0, $c319b2c832c2914a$export$2e2bcd8739ae039).isFormData(data)) {
        if ((0, $bb8180acb278e187$export$2e2bcd8739ae039).hasStandardBrowserEnv || (0, $bb8180acb278e187$export$2e2bcd8739ae039).hasStandardBrowserWebWorkerEnv) headers.setContentType(undefined); // Let the browser set it
        else if ((contentType = headers.getContentType()) !== false) {
            // fix semicolon duplication issue for ReactNative FormData implementation
            const [type, ...tokens] = contentType ? contentType.split(';').map((token)=>token.trim()).filter(Boolean) : [];
            headers.setContentType([
                type || 'multipart/form-data',
                ...tokens
            ].join('; '));
        }
    }
    // Add xsrf header
    // This is only done if running in a standard browser environment.
    // Specifically not if we're in a web worker, or react-native.
    if ((0, $bb8180acb278e187$export$2e2bcd8739ae039).hasStandardBrowserEnv) {
        withXSRFToken && (0, $c319b2c832c2914a$export$2e2bcd8739ae039).isFunction(withXSRFToken) && (withXSRFToken = withXSRFToken(newConfig));
        if (withXSRFToken || withXSRFToken !== false && (0, $5eb63b558e1fb85a$export$2e2bcd8739ae039)(newConfig.url)) {
            // Add xsrf header
            const xsrfValue = xsrfHeaderName && xsrfCookieName && (0, $65cc14c0704b5541$export$2e2bcd8739ae039).read(xsrfCookieName);
            if (xsrfValue) headers.set(xsrfHeaderName, xsrfValue);
        }
    }
    return newConfig;
};


const $79f0a48d5eb7919b$var$isXHRAdapterSupported = typeof XMLHttpRequest !== 'undefined';
var $79f0a48d5eb7919b$export$2e2bcd8739ae039 = $79f0a48d5eb7919b$var$isXHRAdapterSupported && function(config) {
    return new Promise(function dispatchXhrRequest(resolve, reject) {
        const _config = (0, $ab4625fac3104691$export$2e2bcd8739ae039)(config);
        let requestData = _config.data;
        const requestHeaders = (0, $866cce54f6bdfb0c$export$2e2bcd8739ae039).from(_config.headers).normalize();
        let { responseType: responseType, onUploadProgress: onUploadProgress, onDownloadProgress: onDownloadProgress } = _config;
        let onCanceled;
        let uploadThrottled, downloadThrottled;
        let flushUpload, flushDownload;
        function done() {
            flushUpload && flushUpload(); // flush events
            flushDownload && flushDownload(); // flush events
            _config.cancelToken && _config.cancelToken.unsubscribe(onCanceled);
            _config.signal && _config.signal.removeEventListener('abort', onCanceled);
        }
        let request = new XMLHttpRequest();
        request.open(_config.method.toUpperCase(), _config.url, true);
        // Set the request timeout in MS
        request.timeout = _config.timeout;
        function onloadend() {
            if (!request) return;
            // Prepare the response
            const responseHeaders = (0, $866cce54f6bdfb0c$export$2e2bcd8739ae039).from('getAllResponseHeaders' in request && request.getAllResponseHeaders());
            const responseData = !responseType || responseType === 'text' || responseType === 'json' ? request.responseText : request.response;
            const response = {
                data: responseData,
                status: request.status,
                statusText: request.statusText,
                headers: responseHeaders,
                config: config,
                request: request
            };
            (0, $ecb62d5372993dcf$export$2e2bcd8739ae039)(function _resolve(value) {
                resolve(value);
                done();
            }, function _reject(err) {
                reject(err);
                done();
            }, response);
            // Clean up request
            request = null;
        }
        if ('onloadend' in request) // Use onloadend if available
        request.onloadend = onloadend;
        else // Listen for ready state to emulate onloadend
        request.onreadystatechange = function handleLoad() {
            if (!request || request.readyState !== 4) return;
            // The request errored out and we didn't get a response, this will be
            // handled by onerror instead
            // With one exception: request that using file: protocol, most browsers
            // will return status as 0 even though it's a successful request
            if (request.status === 0 && !(request.responseURL && request.responseURL.indexOf('file:') === 0)) return;
            // readystate handler is calling before onerror or ontimeout handlers,
            // so we should call onloadend on the next 'tick'
            setTimeout(onloadend);
        };
        // Handle browser request cancellation (as opposed to a manual cancellation)
        request.onabort = function handleAbort() {
            if (!request) return;
            reject(new (0, $4e2395edb77acf3a$export$2e2bcd8739ae039)('Request aborted', (0, $4e2395edb77acf3a$export$2e2bcd8739ae039).ECONNABORTED, config, request));
            // Clean up request
            request = null;
        };
        // Handle low level network errors
        request.onerror = function handleError() {
            // Real errors are hidden from us by the browser
            // onerror should only fire if it's a network error
            reject(new (0, $4e2395edb77acf3a$export$2e2bcd8739ae039)('Network Error', (0, $4e2395edb77acf3a$export$2e2bcd8739ae039).ERR_NETWORK, config, request));
            // Clean up request
            request = null;
        };
        // Handle timeout
        request.ontimeout = function handleTimeout() {
            let timeoutErrorMessage = _config.timeout ? 'timeout of ' + _config.timeout + 'ms exceeded' : 'timeout exceeded';
            const transitional = _config.transitional || (0, $51466d41a76e5b4b$export$2e2bcd8739ae039);
            if (_config.timeoutErrorMessage) timeoutErrorMessage = _config.timeoutErrorMessage;
            reject(new (0, $4e2395edb77acf3a$export$2e2bcd8739ae039)(timeoutErrorMessage, transitional.clarifyTimeoutError ? (0, $4e2395edb77acf3a$export$2e2bcd8739ae039).ETIMEDOUT : (0, $4e2395edb77acf3a$export$2e2bcd8739ae039).ECONNABORTED, config, request));
            // Clean up request
            request = null;
        };
        // Remove Content-Type if data is undefined
        requestData === undefined && requestHeaders.setContentType(null);
        // Add headers to the request
        if ('setRequestHeader' in request) (0, $c319b2c832c2914a$export$2e2bcd8739ae039).forEach(requestHeaders.toJSON(), function setRequestHeader(val, key) {
            request.setRequestHeader(key, val);
        });
        // Add withCredentials to request if needed
        if (!(0, $c319b2c832c2914a$export$2e2bcd8739ae039).isUndefined(_config.withCredentials)) request.withCredentials = !!_config.withCredentials;
        // Add responseType to request if needed
        if (responseType && responseType !== 'json') request.responseType = _config.responseType;
        // Handle progress if needed
        if (onDownloadProgress) {
            [downloadThrottled, flushDownload] = (0, $1a6c80b567b74091$export$c1b28109d46c3592)(onDownloadProgress, true);
            request.addEventListener('progress', downloadThrottled);
        }
        // Not all browsers support upload events
        if (onUploadProgress && request.upload) {
            [uploadThrottled, flushUpload] = (0, $1a6c80b567b74091$export$c1b28109d46c3592)(onUploadProgress);
            request.upload.addEventListener('progress', uploadThrottled);
            request.upload.addEventListener('loadend', flushUpload);
        }
        if (_config.cancelToken || _config.signal) {
            // Handle cancellation
            // eslint-disable-next-line func-names
            onCanceled = (cancel)=>{
                if (!request) return;
                reject(!cancel || cancel.type ? new (0, $9fd0919e266b4fda$export$2e2bcd8739ae039)(null, config, request) : cancel);
                request.abort();
                request = null;
            };
            _config.cancelToken && _config.cancelToken.subscribe(onCanceled);
            if (_config.signal) _config.signal.aborted ? onCanceled() : _config.signal.addEventListener('abort', onCanceled);
        }
        const protocol = (0, $23607f53e4fda918$export$2e2bcd8739ae039)(_config.url);
        if (protocol && (0, $bb8180acb278e187$export$2e2bcd8739ae039).protocols.indexOf(protocol) === -1) {
            reject(new (0, $4e2395edb77acf3a$export$2e2bcd8739ae039)('Unsupported protocol ' + protocol + ':', (0, $4e2395edb77acf3a$export$2e2bcd8739ae039).ERR_BAD_REQUEST, config));
            return;
        }
        // Send the request
        request.send(requestData || null);
    });
};








const $a052b9a6636aacdc$var$composeSignals = (signals, timeout)=>{
    const { length: length } = signals = signals ? signals.filter(Boolean) : [];
    if (timeout || length) {
        let controller = new AbortController();
        let aborted;
        const onabort = function(reason) {
            if (!aborted) {
                aborted = true;
                unsubscribe();
                const err = reason instanceof Error ? reason : this.reason;
                controller.abort(err instanceof (0, $4e2395edb77acf3a$export$2e2bcd8739ae039) ? err : new (0, $9fd0919e266b4fda$export$2e2bcd8739ae039)(err instanceof Error ? err.message : err));
            }
        };
        let timer = timeout && setTimeout(()=>{
            timer = null;
            onabort(new (0, $4e2395edb77acf3a$export$2e2bcd8739ae039)(`timeout ${timeout} of ms exceeded`, (0, $4e2395edb77acf3a$export$2e2bcd8739ae039).ETIMEDOUT));
        }, timeout);
        const unsubscribe = ()=>{
            if (signals) {
                timer && clearTimeout(timer);
                timer = null;
                signals.forEach((signal)=>{
                    signal.unsubscribe ? signal.unsubscribe(onabort) : signal.removeEventListener('abort', onabort);
                });
                signals = null;
            }
        };
        signals.forEach((signal)=>signal.addEventListener('abort', onabort));
        const { signal: signal } = controller;
        signal.unsubscribe = ()=>(0, $c319b2c832c2914a$export$2e2bcd8739ae039).asap(unsubscribe);
        return signal;
    }
};
var $a052b9a6636aacdc$export$2e2bcd8739ae039 = $a052b9a6636aacdc$var$composeSignals;


const $c9465135abb26626$export$71b051935044bd5d = function*(chunk, chunkSize) {
    let len = chunk.byteLength;
    if (!chunkSize || len < chunkSize) {
        yield chunk;
        return;
    }
    let pos = 0;
    let end;
    while(pos < len){
        end = pos + chunkSize;
        yield chunk.slice(pos, end);
        pos = end;
    }
};
const $c9465135abb26626$export$f9f241124ee3198e = async function*(iterable, chunkSize) {
    for await (const chunk of $c9465135abb26626$var$readStream(iterable))yield* $c9465135abb26626$export$71b051935044bd5d(chunk, chunkSize);
};
const $c9465135abb26626$var$readStream = async function*(stream) {
    if (stream[Symbol.asyncIterator]) {
        yield* stream;
        return;
    }
    const reader = stream.getReader();
    try {
        for(;;){
            const { done: done, value: value } = await reader.read();
            if (done) break;
            yield value;
        }
    } finally{
        await reader.cancel();
    }
};
const $c9465135abb26626$export$b0119225647bd83 = (stream, chunkSize, onProgress, onFinish)=>{
    const iterator = $c9465135abb26626$export$f9f241124ee3198e(stream, chunkSize);
    let bytes = 0;
    let done;
    let _onFinish = (e)=>{
        if (!done) {
            done = true;
            onFinish && onFinish(e);
        }
    };
    return new ReadableStream({
        async pull (controller) {
            try {
                const { done: done, value: value } = await iterator.next();
                if (done) {
                    _onFinish();
                    controller.close();
                    return;
                }
                let len = value.byteLength;
                if (onProgress) {
                    let loadedBytes = bytes += len;
                    onProgress(loadedBytes);
                }
                controller.enqueue(new Uint8Array(value));
            } catch (err) {
                _onFinish(err);
                throw err;
            }
        },
        cancel (reason) {
            _onFinish(reason);
            return iterator.return();
        }
    }, {
        highWaterMark: 2
    });
};






const $e52be20a9fc15e96$var$isFetchSupported = typeof fetch === 'function' && typeof Request === 'function' && typeof Response === 'function';
const $e52be20a9fc15e96$var$isReadableStreamSupported = $e52be20a9fc15e96$var$isFetchSupported && typeof ReadableStream === 'function';
// used only inside the fetch adapter
const $e52be20a9fc15e96$var$encodeText = $e52be20a9fc15e96$var$isFetchSupported && (typeof TextEncoder === 'function' ? ((encoder)=>(str)=>encoder.encode(str))(new TextEncoder()) : async (str)=>new Uint8Array(await new Response(str).arrayBuffer()));
const $e52be20a9fc15e96$var$test = (fn, ...args)=>{
    try {
        return !!fn(...args);
    } catch (e) {
        return false;
    }
};
const $e52be20a9fc15e96$var$supportsRequestStream = $e52be20a9fc15e96$var$isReadableStreamSupported && $e52be20a9fc15e96$var$test(()=>{
    let duplexAccessed = false;
    const hasContentType = new Request((0, $bb8180acb278e187$export$2e2bcd8739ae039).origin, {
        body: new ReadableStream(),
        method: 'POST',
        get duplex () {
            duplexAccessed = true;
            return 'half';
        }
    }).headers.has('Content-Type');
    return duplexAccessed && !hasContentType;
});
const $e52be20a9fc15e96$var$DEFAULT_CHUNK_SIZE = 65536;
const $e52be20a9fc15e96$var$supportsResponseStream = $e52be20a9fc15e96$var$isReadableStreamSupported && $e52be20a9fc15e96$var$test(()=>(0, $c319b2c832c2914a$export$2e2bcd8739ae039).isReadableStream(new Response('').body));
const $e52be20a9fc15e96$var$resolvers = {
    stream: $e52be20a9fc15e96$var$supportsResponseStream && ((res)=>res.body)
};
$e52be20a9fc15e96$var$isFetchSupported && ((res)=>{
    [
        'text',
        'arrayBuffer',
        'blob',
        'formData',
        'stream'
    ].forEach((type)=>{
        !$e52be20a9fc15e96$var$resolvers[type] && ($e52be20a9fc15e96$var$resolvers[type] = (0, $c319b2c832c2914a$export$2e2bcd8739ae039).isFunction(res[type]) ? (res)=>res[type]() : (_, config)=>{
            throw new (0, $4e2395edb77acf3a$export$2e2bcd8739ae039)(`Response type '${type}' is not supported`, (0, $4e2395edb77acf3a$export$2e2bcd8739ae039).ERR_NOT_SUPPORT, config);
        });
    });
})(new Response);
const $e52be20a9fc15e96$var$getBodyLength = async (body)=>{
    if (body == null) return 0;
    if ((0, $c319b2c832c2914a$export$2e2bcd8739ae039).isBlob(body)) return body.size;
    if ((0, $c319b2c832c2914a$export$2e2bcd8739ae039).isSpecCompliantForm(body)) {
        const _request = new Request((0, $bb8180acb278e187$export$2e2bcd8739ae039).origin, {
            method: 'POST',
            body: body
        });
        return (await _request.arrayBuffer()).byteLength;
    }
    if ((0, $c319b2c832c2914a$export$2e2bcd8739ae039).isArrayBufferView(body) || (0, $c319b2c832c2914a$export$2e2bcd8739ae039).isArrayBuffer(body)) return body.byteLength;
    if ((0, $c319b2c832c2914a$export$2e2bcd8739ae039).isURLSearchParams(body)) body = body + '';
    if ((0, $c319b2c832c2914a$export$2e2bcd8739ae039).isString(body)) return (await $e52be20a9fc15e96$var$encodeText(body)).byteLength;
};
const $e52be20a9fc15e96$var$resolveBodyLength = async (headers, body)=>{
    const length = (0, $c319b2c832c2914a$export$2e2bcd8739ae039).toFiniteNumber(headers.getContentLength());
    return length == null ? $e52be20a9fc15e96$var$getBodyLength(body) : length;
};
var $e52be20a9fc15e96$export$2e2bcd8739ae039 = $e52be20a9fc15e96$var$isFetchSupported && (async (config)=>{
    let { url: url, method: method, data: data, signal: signal, cancelToken: cancelToken, timeout: timeout, onDownloadProgress: onDownloadProgress, onUploadProgress: onUploadProgress, responseType: responseType, headers: headers, withCredentials: withCredentials = 'same-origin', fetchOptions: fetchOptions } = (0, $ab4625fac3104691$export$2e2bcd8739ae039)(config);
    responseType = responseType ? (responseType + '').toLowerCase() : 'text';
    let composedSignal = (0, $a052b9a6636aacdc$export$2e2bcd8739ae039)([
        signal,
        cancelToken && cancelToken.toAbortSignal()
    ], timeout);
    let request;
    const unsubscribe = composedSignal && composedSignal.unsubscribe && (()=>{
        composedSignal.unsubscribe();
    });
    let requestContentLength;
    try {
        if (onUploadProgress && $e52be20a9fc15e96$var$supportsRequestStream && method !== 'get' && method !== 'head' && (requestContentLength = await $e52be20a9fc15e96$var$resolveBodyLength(headers, data)) !== 0) {
            let _request = new Request(url, {
                method: 'POST',
                body: data,
                duplex: "half"
            });
            let contentTypeHeader;
            if ((0, $c319b2c832c2914a$export$2e2bcd8739ae039).isFormData(data) && (contentTypeHeader = _request.headers.get('content-type'))) headers.setContentType(contentTypeHeader);
            if (_request.body) {
                const [onProgress, flush] = (0, $1a6c80b567b74091$export$d9fadd12586c18d6)(requestContentLength, (0, $1a6c80b567b74091$export$c1b28109d46c3592)((0, $1a6c80b567b74091$export$5d35863c355a22a9)(onUploadProgress)));
                data = (0, $c9465135abb26626$export$b0119225647bd83)(_request.body, $e52be20a9fc15e96$var$DEFAULT_CHUNK_SIZE, onProgress, flush);
            }
        }
        if (!(0, $c319b2c832c2914a$export$2e2bcd8739ae039).isString(withCredentials)) withCredentials = withCredentials ? 'include' : 'omit';
        // Cloudflare Workers throws when credentials are defined
        // see https://github.com/cloudflare/workerd/issues/902
        const isCredentialsSupported = "credentials" in Request.prototype;
        request = new Request(url, {
            ...fetchOptions,
            signal: composedSignal,
            method: method.toUpperCase(),
            headers: headers.normalize().toJSON(),
            body: data,
            duplex: "half",
            credentials: isCredentialsSupported ? withCredentials : undefined
        });
        let response = await fetch(request);
        const isStreamResponse = $e52be20a9fc15e96$var$supportsResponseStream && (responseType === 'stream' || responseType === 'response');
        if ($e52be20a9fc15e96$var$supportsResponseStream && (onDownloadProgress || isStreamResponse && unsubscribe)) {
            const options = {};
            [
                'status',
                'statusText',
                'headers'
            ].forEach((prop)=>{
                options[prop] = response[prop];
            });
            const responseContentLength = (0, $c319b2c832c2914a$export$2e2bcd8739ae039).toFiniteNumber(response.headers.get('content-length'));
            const [onProgress, flush] = onDownloadProgress && (0, $1a6c80b567b74091$export$d9fadd12586c18d6)(responseContentLength, (0, $1a6c80b567b74091$export$c1b28109d46c3592)((0, $1a6c80b567b74091$export$5d35863c355a22a9)(onDownloadProgress), true)) || [];
            response = new Response((0, $c9465135abb26626$export$b0119225647bd83)(response.body, $e52be20a9fc15e96$var$DEFAULT_CHUNK_SIZE, onProgress, ()=>{
                flush && flush();
                unsubscribe && unsubscribe();
            }), options);
        }
        responseType = responseType || 'text';
        let responseData = await $e52be20a9fc15e96$var$resolvers[(0, $c319b2c832c2914a$export$2e2bcd8739ae039).findKey($e52be20a9fc15e96$var$resolvers, responseType) || 'text'](response, config);
        !isStreamResponse && unsubscribe && unsubscribe();
        return await new Promise((resolve, reject)=>{
            (0, $ecb62d5372993dcf$export$2e2bcd8739ae039)(resolve, reject, {
                data: responseData,
                headers: (0, $866cce54f6bdfb0c$export$2e2bcd8739ae039).from(response.headers),
                status: response.status,
                statusText: response.statusText,
                config: config,
                request: request
            });
        });
    } catch (err) {
        unsubscribe && unsubscribe();
        if (err && err.name === 'TypeError' && /fetch/i.test(err.message)) throw Object.assign(new (0, $4e2395edb77acf3a$export$2e2bcd8739ae039)('Network Error', (0, $4e2395edb77acf3a$export$2e2bcd8739ae039).ERR_NETWORK, config, request), {
            cause: err.cause || err
        });
        throw (0, $4e2395edb77acf3a$export$2e2bcd8739ae039).from(err, err && err.code, config, request);
    }
});



const $e8c8c7960873e9ee$var$knownAdapters = {
    http: (0, $4023ac50ad132196$export$2e2bcd8739ae039),
    xhr: (0, $79f0a48d5eb7919b$export$2e2bcd8739ae039),
    fetch: (0, $e52be20a9fc15e96$export$2e2bcd8739ae039)
};
(0, $c319b2c832c2914a$export$2e2bcd8739ae039).forEach($e8c8c7960873e9ee$var$knownAdapters, (fn, value)=>{
    if (fn) {
        try {
            Object.defineProperty(fn, 'name', {
                value: value
            });
        } catch (e) {
        // eslint-disable-next-line no-empty
        }
        Object.defineProperty(fn, 'adapterName', {
            value: value
        });
    }
});
const $e8c8c7960873e9ee$var$renderReason = (reason)=>`- ${reason}`;
const $e8c8c7960873e9ee$var$isResolvedHandle = (adapter)=>(0, $c319b2c832c2914a$export$2e2bcd8739ae039).isFunction(adapter) || adapter === null || adapter === false;
var $e8c8c7960873e9ee$export$2e2bcd8739ae039 = {
    getAdapter: (adapters)=>{
        adapters = (0, $c319b2c832c2914a$export$2e2bcd8739ae039).isArray(adapters) ? adapters : [
            adapters
        ];
        const { length: length } = adapters;
        let nameOrAdapter;
        let adapter;
        const rejectedReasons = {};
        for(let i = 0; i < length; i++){
            nameOrAdapter = adapters[i];
            let id;
            adapter = nameOrAdapter;
            if (!$e8c8c7960873e9ee$var$isResolvedHandle(nameOrAdapter)) {
                adapter = $e8c8c7960873e9ee$var$knownAdapters[(id = String(nameOrAdapter)).toLowerCase()];
                if (adapter === undefined) throw new (0, $4e2395edb77acf3a$export$2e2bcd8739ae039)(`Unknown adapter '${id}'`);
            }
            if (adapter) break;
            rejectedReasons[id || '#' + i] = adapter;
        }
        if (!adapter) {
            const reasons = Object.entries(rejectedReasons).map(([id, state])=>`adapter ${id} ` + (state === false ? 'is not supported by the environment' : 'is not available in the build'));
            let s = length ? reasons.length > 1 ? 'since :\n' + reasons.map($e8c8c7960873e9ee$var$renderReason).join('\n') : ' ' + $e8c8c7960873e9ee$var$renderReason(reasons[0]) : 'as no adapter specified';
            throw new (0, $4e2395edb77acf3a$export$2e2bcd8739ae039)(`There is no suitable adapter to dispatch the request ` + s, 'ERR_NOT_SUPPORT');
        }
        return adapter;
    },
    adapters: $e8c8c7960873e9ee$var$knownAdapters
};


'use strict';
/**
 * Throws a `CanceledError` if cancellation has been requested.
 *
 * @param {Object} config The config that is to be used for the request
 *
 * @returns {void}
 */ function $9b8d10189805ccc0$var$throwIfCancellationRequested(config) {
    if (config.cancelToken) config.cancelToken.throwIfRequested();
    if (config.signal && config.signal.aborted) throw new (0, $9fd0919e266b4fda$export$2e2bcd8739ae039)(null, config);
}
function $9b8d10189805ccc0$export$2e2bcd8739ae039(config) {
    $9b8d10189805ccc0$var$throwIfCancellationRequested(config);
    config.headers = (0, $866cce54f6bdfb0c$export$2e2bcd8739ae039).from(config.headers);
    // Transform request data
    config.data = (0, $5cf10c777cce5f4f$export$2e2bcd8739ae039).call(config, config.transformRequest);
    if ([
        'post',
        'put',
        'patch'
    ].indexOf(config.method) !== -1) config.headers.setContentType('application/x-www-form-urlencoded', false);
    const adapter = (0, $e8c8c7960873e9ee$export$2e2bcd8739ae039).getAdapter(config.adapter || (0, $843bf0209bc94df8$export$2e2bcd8739ae039).adapter);
    return adapter(config).then(function onAdapterResolution(response) {
        $9b8d10189805ccc0$var$throwIfCancellationRequested(config);
        // Transform response data
        response.data = (0, $5cf10c777cce5f4f$export$2e2bcd8739ae039).call(config, config.transformResponse, response);
        response.headers = (0, $866cce54f6bdfb0c$export$2e2bcd8739ae039).from(response.headers);
        return response;
    }, function onAdapterRejection(reason) {
        if (!(0, $5a60afef8b0dd173$export$2e2bcd8739ae039)(reason)) {
            $9b8d10189805ccc0$var$throwIfCancellationRequested(config);
            // Transform response data
            if (reason && reason.response) {
                reason.response.data = (0, $5cf10c777cce5f4f$export$2e2bcd8739ae039).call(config, config.transformResponse, reason.response);
                reason.response.headers = (0, $866cce54f6bdfb0c$export$2e2bcd8739ae039).from(reason.response.headers);
            }
        }
        return Promise.reject(reason);
    });
}




const $23ff3f1a5c7912d5$export$a4ad2735b021c132 = "1.8.4";



'use strict';
const $85f59389941e7907$var$validators = {};
// eslint-disable-next-line func-names
[
    'object',
    'boolean',
    'number',
    'function',
    'string',
    'symbol'
].forEach((type, i)=>{
    $85f59389941e7907$var$validators[type] = function validator(thing) {
        return typeof thing === type || 'a' + (i < 1 ? 'n ' : ' ') + type;
    };
});
const $85f59389941e7907$var$deprecatedWarnings = {};
/**
 * Transitional option validator
 *
 * @param {function|boolean?} validator - set to false if the transitional option has been removed
 * @param {string?} version - deprecated version / removed since version
 * @param {string?} message - some message with additional info
 *
 * @returns {function}
 */ $85f59389941e7907$var$validators.transitional = function transitional(validator, version, message) {
    function formatMessage(opt, desc) {
        return '[Axios v' + (0, $23ff3f1a5c7912d5$export$a4ad2735b021c132) + '] Transitional option \'' + opt + '\'' + desc + (message ? '. ' + message : '');
    }
    // eslint-disable-next-line func-names
    return (value, opt, opts)=>{
        if (validator === false) throw new (0, $4e2395edb77acf3a$export$2e2bcd8739ae039)(formatMessage(opt, ' has been removed' + (version ? ' in ' + version : '')), (0, $4e2395edb77acf3a$export$2e2bcd8739ae039).ERR_DEPRECATED);
        if (version && !$85f59389941e7907$var$deprecatedWarnings[opt]) {
            $85f59389941e7907$var$deprecatedWarnings[opt] = true;
            // eslint-disable-next-line no-console
            console.warn(formatMessage(opt, ' has been deprecated since v' + version + ' and will be removed in the near future'));
        }
        return validator ? validator(value, opt, opts) : true;
    };
};
$85f59389941e7907$var$validators.spelling = function spelling(correctSpelling) {
    return (value, opt)=>{
        // eslint-disable-next-line no-console
        console.warn(`${opt} is likely a misspelling of ${correctSpelling}`);
        return true;
    };
};
/**
 * Assert object's properties type
 *
 * @param {object} options
 * @param {object} schema
 * @param {boolean?} allowUnknown
 *
 * @returns {object}
 */ function $85f59389941e7907$var$assertOptions(options, schema, allowUnknown) {
    if (typeof options !== 'object') throw new (0, $4e2395edb77acf3a$export$2e2bcd8739ae039)('options must be an object', (0, $4e2395edb77acf3a$export$2e2bcd8739ae039).ERR_BAD_OPTION_VALUE);
    const keys = Object.keys(options);
    let i = keys.length;
    while(i-- > 0){
        const opt = keys[i];
        const validator = schema[opt];
        if (validator) {
            const value = options[opt];
            const result = value === undefined || validator(value, opt, options);
            if (result !== true) throw new (0, $4e2395edb77acf3a$export$2e2bcd8739ae039)('option ' + opt + ' must be ' + result, (0, $4e2395edb77acf3a$export$2e2bcd8739ae039).ERR_BAD_OPTION_VALUE);
            continue;
        }
        if (allowUnknown !== true) throw new (0, $4e2395edb77acf3a$export$2e2bcd8739ae039)('Unknown option ' + opt, (0, $4e2395edb77acf3a$export$2e2bcd8739ae039).ERR_BAD_OPTION);
    }
}
var $85f59389941e7907$export$2e2bcd8739ae039 = {
    assertOptions: $85f59389941e7907$var$assertOptions,
    validators: $85f59389941e7907$var$validators
};



'use strict';
const $a93486d2307f31c3$var$validators = (0, $85f59389941e7907$export$2e2bcd8739ae039).validators;
/**
 * Create a new instance of Axios
 *
 * @param {Object} instanceConfig The default config for the instance
 *
 * @return {Axios} A new instance of Axios
 */ class $a93486d2307f31c3$var$Axios {
    constructor(instanceConfig){
        this.defaults = instanceConfig;
        this.interceptors = {
            request: new (0, $5de878cd737ef277$export$2e2bcd8739ae039)(),
            response: new (0, $5de878cd737ef277$export$2e2bcd8739ae039)()
        };
    }
    /**
   * Dispatch a request
   *
   * @param {String|Object} configOrUrl The config specific for this request (merged with this.defaults)
   * @param {?Object} config
   *
   * @returns {Promise} The Promise to be fulfilled
   */ async request(configOrUrl, config) {
        try {
            return await this._request(configOrUrl, config);
        } catch (err) {
            if (err instanceof Error) {
                let dummy = {};
                Error.captureStackTrace ? Error.captureStackTrace(dummy) : dummy = new Error();
                // slice off the Error: ... line
                const stack = dummy.stack ? dummy.stack.replace(/^.+\n/, '') : '';
                try {
                    if (!err.stack) err.stack = stack;
                    else if (stack && !String(err.stack).endsWith(stack.replace(/^.+\n.+\n/, ''))) err.stack += '\n' + stack;
                } catch (e) {
                // ignore the case where "stack" is an un-writable property
                }
            }
            throw err;
        }
    }
    _request(configOrUrl, config) {
        /*eslint no-param-reassign:0*/ // Allow for axios('example/url'[, config]) a la fetch API
        if (typeof configOrUrl === 'string') {
            config = config || {};
            config.url = configOrUrl;
        } else config = configOrUrl || {};
        config = (0, $f85fda54cd977b19$export$2e2bcd8739ae039)(this.defaults, config);
        const { transitional: transitional, paramsSerializer: paramsSerializer, headers: headers } = config;
        if (transitional !== undefined) (0, $85f59389941e7907$export$2e2bcd8739ae039).assertOptions(transitional, {
            silentJSONParsing: $a93486d2307f31c3$var$validators.transitional($a93486d2307f31c3$var$validators.boolean),
            forcedJSONParsing: $a93486d2307f31c3$var$validators.transitional($a93486d2307f31c3$var$validators.boolean),
            clarifyTimeoutError: $a93486d2307f31c3$var$validators.transitional($a93486d2307f31c3$var$validators.boolean)
        }, false);
        if (paramsSerializer != null) {
            if ((0, $c319b2c832c2914a$export$2e2bcd8739ae039).isFunction(paramsSerializer)) config.paramsSerializer = {
                serialize: paramsSerializer
            };
            else (0, $85f59389941e7907$export$2e2bcd8739ae039).assertOptions(paramsSerializer, {
                encode: $a93486d2307f31c3$var$validators.function,
                serialize: $a93486d2307f31c3$var$validators.function
            }, true);
        }
        // Set config.allowAbsoluteUrls
        if (config.allowAbsoluteUrls !== undefined) ;
        else if (this.defaults.allowAbsoluteUrls !== undefined) config.allowAbsoluteUrls = this.defaults.allowAbsoluteUrls;
        else config.allowAbsoluteUrls = true;
        (0, $85f59389941e7907$export$2e2bcd8739ae039).assertOptions(config, {
            baseUrl: $a93486d2307f31c3$var$validators.spelling('baseURL'),
            withXsrfToken: $a93486d2307f31c3$var$validators.spelling('withXSRFToken')
        }, true);
        // Set config.method
        config.method = (config.method || this.defaults.method || 'get').toLowerCase();
        // Flatten headers
        let contextHeaders = headers && (0, $c319b2c832c2914a$export$2e2bcd8739ae039).merge(headers.common, headers[config.method]);
        headers && (0, $c319b2c832c2914a$export$2e2bcd8739ae039).forEach([
            'delete',
            'get',
            'head',
            'post',
            'put',
            'patch',
            'common'
        ], (method)=>{
            delete headers[method];
        });
        config.headers = (0, $866cce54f6bdfb0c$export$2e2bcd8739ae039).concat(contextHeaders, headers);
        // filter out skipped interceptors
        const requestInterceptorChain = [];
        let synchronousRequestInterceptors = true;
        this.interceptors.request.forEach(function unshiftRequestInterceptors(interceptor) {
            if (typeof interceptor.runWhen === 'function' && interceptor.runWhen(config) === false) return;
            synchronousRequestInterceptors = synchronousRequestInterceptors && interceptor.synchronous;
            requestInterceptorChain.unshift(interceptor.fulfilled, interceptor.rejected);
        });
        const responseInterceptorChain = [];
        this.interceptors.response.forEach(function pushResponseInterceptors(interceptor) {
            responseInterceptorChain.push(interceptor.fulfilled, interceptor.rejected);
        });
        let promise;
        let i = 0;
        let len;
        if (!synchronousRequestInterceptors) {
            const chain = [
                (0, $9b8d10189805ccc0$export$2e2bcd8739ae039).bind(this),
                undefined
            ];
            chain.unshift.apply(chain, requestInterceptorChain);
            chain.push.apply(chain, responseInterceptorChain);
            len = chain.length;
            promise = Promise.resolve(config);
            while(i < len)promise = promise.then(chain[i++], chain[i++]);
            return promise;
        }
        len = requestInterceptorChain.length;
        let newConfig = config;
        i = 0;
        while(i < len){
            const onFulfilled = requestInterceptorChain[i++];
            const onRejected = requestInterceptorChain[i++];
            try {
                newConfig = onFulfilled(newConfig);
            } catch (error) {
                onRejected.call(this, error);
                break;
            }
        }
        try {
            promise = (0, $9b8d10189805ccc0$export$2e2bcd8739ae039).call(this, newConfig);
        } catch (error) {
            return Promise.reject(error);
        }
        i = 0;
        len = responseInterceptorChain.length;
        while(i < len)promise = promise.then(responseInterceptorChain[i++], responseInterceptorChain[i++]);
        return promise;
    }
    getUri(config) {
        config = (0, $f85fda54cd977b19$export$2e2bcd8739ae039)(this.defaults, config);
        const fullPath = (0, $598acbfafd2c63c5$export$2e2bcd8739ae039)(config.baseURL, config.url, config.allowAbsoluteUrls);
        return (0, $8df8fedf1c1e4428$export$2e2bcd8739ae039)(fullPath, config.params, config.paramsSerializer);
    }
}
// Provide aliases for supported request methods
(0, $c319b2c832c2914a$export$2e2bcd8739ae039).forEach([
    'delete',
    'get',
    'head',
    'options'
], function forEachMethodNoData(method) {
    /*eslint func-names:0*/ $a93486d2307f31c3$var$Axios.prototype[method] = function(url, config) {
        return this.request((0, $f85fda54cd977b19$export$2e2bcd8739ae039)(config || {}, {
            method: method,
            url: url,
            data: (config || {}).data
        }));
    };
});
(0, $c319b2c832c2914a$export$2e2bcd8739ae039).forEach([
    'post',
    'put',
    'patch'
], function forEachMethodWithData(method) {
    /*eslint func-names:0*/ function generateHTTPMethod(isForm) {
        return function httpMethod(url, data, config) {
            return this.request((0, $f85fda54cd977b19$export$2e2bcd8739ae039)(config || {}, {
                method: method,
                headers: isForm ? {
                    'Content-Type': 'multipart/form-data'
                } : {},
                url: url,
                data: data
            }));
        };
    }
    $a93486d2307f31c3$var$Axios.prototype[method] = generateHTTPMethod();
    $a93486d2307f31c3$var$Axios.prototype[method + 'Form'] = generateHTTPMethod(true);
});
var $a93486d2307f31c3$export$2e2bcd8739ae039 = $a93486d2307f31c3$var$Axios;







'use strict';
/**
 * A `CancelToken` is an object that can be used to request cancellation of an operation.
 *
 * @param {Function} executor The executor function.
 *
 * @returns {CancelToken}
 */ class $fb81495929d8a282$var$CancelToken {
    constructor(executor){
        if (typeof executor !== 'function') throw new TypeError('executor must be a function.');
        let resolvePromise;
        this.promise = new Promise(function promiseExecutor(resolve) {
            resolvePromise = resolve;
        });
        const token = this;
        // eslint-disable-next-line func-names
        this.promise.then((cancel)=>{
            if (!token._listeners) return;
            let i = token._listeners.length;
            while(i-- > 0)token._listeners[i](cancel);
            token._listeners = null;
        });
        // eslint-disable-next-line func-names
        this.promise.then = (onfulfilled)=>{
            let _resolve;
            // eslint-disable-next-line func-names
            const promise = new Promise((resolve)=>{
                token.subscribe(resolve);
                _resolve = resolve;
            }).then(onfulfilled);
            promise.cancel = function reject() {
                token.unsubscribe(_resolve);
            };
            return promise;
        };
        executor(function cancel(message, config, request) {
            if (token.reason) // Cancellation has already been requested
            return;
            token.reason = new (0, $9fd0919e266b4fda$export$2e2bcd8739ae039)(message, config, request);
            resolvePromise(token.reason);
        });
    }
    /**
   * Throws a `CanceledError` if cancellation has been requested.
   */ throwIfRequested() {
        if (this.reason) throw this.reason;
    }
    /**
   * Subscribe to the cancel signal
   */ subscribe(listener) {
        if (this.reason) {
            listener(this.reason);
            return;
        }
        if (this._listeners) this._listeners.push(listener);
        else this._listeners = [
            listener
        ];
    }
    /**
   * Unsubscribe from the cancel signal
   */ unsubscribe(listener) {
        if (!this._listeners) return;
        const index = this._listeners.indexOf(listener);
        if (index !== -1) this._listeners.splice(index, 1);
    }
    toAbortSignal() {
        const controller = new AbortController();
        const abort = (err)=>{
            controller.abort(err);
        };
        this.subscribe(abort);
        controller.signal.unsubscribe = ()=>this.unsubscribe(abort);
        return controller.signal;
    }
    /**
   * Returns an object that contains a new `CancelToken` and a function that, when called,
   * cancels the `CancelToken`.
   */ static source() {
        let cancel;
        const token = new $fb81495929d8a282$var$CancelToken(function executor(c) {
            cancel = c;
        });
        return {
            token: token,
            cancel: cancel
        };
    }
}
var $fb81495929d8a282$export$2e2bcd8739ae039 = $fb81495929d8a282$var$CancelToken;






'use strict';
function $089369673aa7c1c3$export$2e2bcd8739ae039(callback) {
    return function wrap(arr) {
        return callback.apply(null, arr);
    };
}



'use strict';
function $9db8da59db12cd94$export$2e2bcd8739ae039(payload) {
    return (0, $c319b2c832c2914a$export$2e2bcd8739ae039).isObject(payload) && payload.isAxiosError === true;
}




const $f919374d785e9fb8$var$HttpStatusCode = {
    Continue: 100,
    SwitchingProtocols: 101,
    Processing: 102,
    EarlyHints: 103,
    Ok: 200,
    Created: 201,
    Accepted: 202,
    NonAuthoritativeInformation: 203,
    NoContent: 204,
    ResetContent: 205,
    PartialContent: 206,
    MultiStatus: 207,
    AlreadyReported: 208,
    ImUsed: 226,
    MultipleChoices: 300,
    MovedPermanently: 301,
    Found: 302,
    SeeOther: 303,
    NotModified: 304,
    UseProxy: 305,
    Unused: 306,
    TemporaryRedirect: 307,
    PermanentRedirect: 308,
    BadRequest: 400,
    Unauthorized: 401,
    PaymentRequired: 402,
    Forbidden: 403,
    NotFound: 404,
    MethodNotAllowed: 405,
    NotAcceptable: 406,
    ProxyAuthenticationRequired: 407,
    RequestTimeout: 408,
    Conflict: 409,
    Gone: 410,
    LengthRequired: 411,
    PreconditionFailed: 412,
    PayloadTooLarge: 413,
    UriTooLong: 414,
    UnsupportedMediaType: 415,
    RangeNotSatisfiable: 416,
    ExpectationFailed: 417,
    ImATeapot: 418,
    MisdirectedRequest: 421,
    UnprocessableEntity: 422,
    Locked: 423,
    FailedDependency: 424,
    TooEarly: 425,
    UpgradeRequired: 426,
    PreconditionRequired: 428,
    TooManyRequests: 429,
    RequestHeaderFieldsTooLarge: 431,
    UnavailableForLegalReasons: 451,
    InternalServerError: 500,
    NotImplemented: 501,
    BadGateway: 502,
    ServiceUnavailable: 503,
    GatewayTimeout: 504,
    HttpVersionNotSupported: 505,
    VariantAlsoNegotiates: 506,
    InsufficientStorage: 507,
    LoopDetected: 508,
    NotExtended: 510,
    NetworkAuthenticationRequired: 511
};
Object.entries($f919374d785e9fb8$var$HttpStatusCode).forEach(([key, value])=>{
    $f919374d785e9fb8$var$HttpStatusCode[value] = key;
});
var $f919374d785e9fb8$export$2e2bcd8739ae039 = $f919374d785e9fb8$var$HttpStatusCode;


'use strict';
/**
 * Create an instance of Axios
 *
 * @param {Object} defaultConfig The default config for the instance
 *
 * @returns {Axios} A new instance of Axios
 */ function $57966c7e0affc4cb$var$createInstance(defaultConfig) {
    const context = new (0, $a93486d2307f31c3$export$2e2bcd8739ae039)(defaultConfig);
    const instance = (0, $e5cb5cefd6507f7e$export$2e2bcd8739ae039)((0, $a93486d2307f31c3$export$2e2bcd8739ae039).prototype.request, context);
    // Copy axios.prototype to instance
    (0, $c319b2c832c2914a$export$2e2bcd8739ae039).extend(instance, (0, $a93486d2307f31c3$export$2e2bcd8739ae039).prototype, context, {
        allOwnKeys: true
    });
    // Copy context to instance
    (0, $c319b2c832c2914a$export$2e2bcd8739ae039).extend(instance, context, null, {
        allOwnKeys: true
    });
    // Factory for creating new instances
    instance.create = function create(instanceConfig) {
        return $57966c7e0affc4cb$var$createInstance((0, $f85fda54cd977b19$export$2e2bcd8739ae039)(defaultConfig, instanceConfig));
    };
    return instance;
}
// Create the default instance to be exported
const $57966c7e0affc4cb$var$axios = $57966c7e0affc4cb$var$createInstance((0, $843bf0209bc94df8$export$2e2bcd8739ae039));
// Expose Axios class to allow class inheritance
$57966c7e0affc4cb$var$axios.Axios = (0, $a93486d2307f31c3$export$2e2bcd8739ae039);
// Expose Cancel & CancelToken
$57966c7e0affc4cb$var$axios.CanceledError = (0, $9fd0919e266b4fda$export$2e2bcd8739ae039);
$57966c7e0affc4cb$var$axios.CancelToken = (0, $fb81495929d8a282$export$2e2bcd8739ae039);
$57966c7e0affc4cb$var$axios.isCancel = (0, $5a60afef8b0dd173$export$2e2bcd8739ae039);
$57966c7e0affc4cb$var$axios.VERSION = (0, $23ff3f1a5c7912d5$export$a4ad2735b021c132);
$57966c7e0affc4cb$var$axios.toFormData = (0, $e6cbd383b18c9625$export$2e2bcd8739ae039);
// Expose AxiosError class
$57966c7e0affc4cb$var$axios.AxiosError = (0, $4e2395edb77acf3a$export$2e2bcd8739ae039);
// alias for CanceledError for backward compatibility
$57966c7e0affc4cb$var$axios.Cancel = $57966c7e0affc4cb$var$axios.CanceledError;
// Expose all/spread
$57966c7e0affc4cb$var$axios.all = function all(promises) {
    return Promise.all(promises);
};
$57966c7e0affc4cb$var$axios.spread = (0, $089369673aa7c1c3$export$2e2bcd8739ae039);
// Expose isAxiosError
$57966c7e0affc4cb$var$axios.isAxiosError = (0, $9db8da59db12cd94$export$2e2bcd8739ae039);
// Expose mergeConfig
$57966c7e0affc4cb$var$axios.mergeConfig = (0, $f85fda54cd977b19$export$2e2bcd8739ae039);
$57966c7e0affc4cb$var$axios.AxiosHeaders = (0, $866cce54f6bdfb0c$export$2e2bcd8739ae039);
$57966c7e0affc4cb$var$axios.formToJSON = (thing)=>(0, $5f8142930b3b943f$export$2e2bcd8739ae039)((0, $c319b2c832c2914a$export$2e2bcd8739ae039).isHTMLForm(thing) ? new FormData(thing) : thing);
$57966c7e0affc4cb$var$axios.getAdapter = (0, $e8c8c7960873e9ee$export$2e2bcd8739ae039).getAdapter;
$57966c7e0affc4cb$var$axios.HttpStatusCode = (0, $f919374d785e9fb8$export$2e2bcd8739ae039);
$57966c7e0affc4cb$var$axios.default = $57966c7e0affc4cb$var$axios;
var // this module should only have a default export
$57966c7e0affc4cb$export$2e2bcd8739ae039 = $57966c7e0affc4cb$var$axios;


// This module is intended to unwrap Axios default export as named.
// Keep top-level export same with static properties
// so that it can keep same with es module or cjs
const { Axios: $b302555736d21bd7$export$1c00760e9e5a4e95, AxiosError: $b302555736d21bd7$export$c1fbed17c2f6a328, CanceledError: $b302555736d21bd7$export$1ab0c6b20d94fa14, isCancel: $b302555736d21bd7$export$3b22524397b493c6, CancelToken: $b302555736d21bd7$export$fd08e3cb425f0d61, VERSION: $b302555736d21bd7$export$a4ad2735b021c132, all: $b302555736d21bd7$export$84bf76cd7afc7469, Cancel: $b302555736d21bd7$export$848c9b7ead0df967, isAxiosError: $b302555736d21bd7$export$fbafdbe06a5b5a9a, spread: $b302555736d21bd7$export$3ae0fd4797ed47c8, toFormData: $b302555736d21bd7$export$10ae0d317ea97f8b, AxiosHeaders: $b302555736d21bd7$export$4e7d6ff0f3e6520, HttpStatusCode: $b302555736d21bd7$export$a972f69c851492b3, formToJSON: $b302555736d21bd7$export$86d7c59254d6a2c9, getAdapter: $b302555736d21bd7$export$17ddc20a97d669e2, mergeConfig: $b302555736d21bd7$export$7ec1ebcfa9d8bd6a } = (0, $57966c7e0affc4cb$export$2e2bcd8739ae039);


"undefined" != typeof globalThis ? globalThis : "undefined" != typeof window ? window : "undefined" != typeof $parcel$global ? $parcel$global : "undefined" != typeof self && self;
var $af62ec6a841e10b9$var$e = {
    exports: {}
};
!function(t) {
    function e(t, e, r) {
        for(var n = r && "number" != typeof e ? r(e) : e, i = 0, o = t.length; i < o;){
            var s = i + o >>> 1;
            (r ? r(t[s]) : t[s]) < n ? i = s + 1 : o = s;
        }
        return i;
    }
    t.sortedIndex = e, Object.defineProperty(t, "__esModule", {
        value: !0
    });
}($af62ec6a841e10b9$var$e.exports);
var $af62ec6a841e10b9$var$r = $af62ec6a841e10b9$var$e.exports, $af62ec6a841e10b9$export$6ba26ae1c58c0147 = {
    NONE: 0,
    PHRASE: 1,
    WORD: 2,
    CHAR: 4,
    GRAPHIC: 8,
    ALL: 63,
    PUBLIC: 64
}, $af62ec6a841e10b9$var$i = /^https?:\/\/uploader\.ongaaccel\.jp\/files\?guid=([a-zA-Z0-9]+)/i, $af62ec6a841e10b9$var$o = /^https?:\/\/songle\.jp\/uploads\/([a-zA-Z0-9]+)\.mp3$/i, $af62ec6a841e10b9$var$s = /^uploaded:([a-zA-Z0-9]+)$/i, $af62ec6a841e10b9$var$a = /^songle\.jp\/uploads\/([a-zA-Z0-9]+)\.mp3$/i, $af62ec6a841e10b9$var$u = /^https?:\/\/piapro\.jp\/t\/([^/]+)(\/[0-9]+)?$/i, $af62ec6a841e10b9$var$c = {
    getSongPathFromUrl: function(t) {
        if ($af62ec6a841e10b9$var$c.isUploaderUrl(t)) {
            var e = $af62ec6a841e10b9$var$o.exec(t);
            if (e) return "songle.jp/uploads/".concat(e[1], ".mp3");
            var r = $af62ec6a841e10b9$var$i.exec(t);
            if (r) return "songle.jp/uploads/".concat(r[1], ".mp3");
        }
        return /https?:\/\/(.+)/.exec(t)[1];
    },
    isUploaderUrl: function(t) {
        return $af62ec6a841e10b9$var$o.test(t) || $af62ec6a841e10b9$var$i.test(t);
    },
    isUploaderPath: function(t) {
        return $af62ec6a841e10b9$var$a.test(t) || $af62ec6a841e10b9$var$s.test(t);
    },
    getUploaderGuid: function(t) {
        var e = $af62ec6a841e10b9$var$a.exec(t);
        if (e) return e[1];
        var r = $af62ec6a841e10b9$var$s.exec(t);
        return r ? r[1] : null;
    },
    getSongUrlFromUploaderGuid: function(t) {
        return t ? "https://songle.jp/uploads/".concat(t, ".mp3") : null;
    },
    getAltSongUrlFromUploaderGuid: function(t) {
        return t ? "https://api.textalive.jp/songle/me/uploads/".concat(t) : null;
    },
    getSongUrlFromPath: function(t) {
        var e = $af62ec6a841e10b9$var$c.getUploaderGuid(t);
        return e ? $af62ec6a841e10b9$var$c.getSongUrlFromUploaderGuid(e) : "https://".concat(t);
    },
    isYouTubeUrl: function(t) {
        return /^https?:\/\/((www|m)\.)?youtube\.com/i.test(t);
    },
    isNicovideoUrl: function(t) {
        return /^https?:\/\/(www\.)?nicovideo.jp/i.test(t);
    },
    isVideoSiteUrl: function(t) {
        return $af62ec6a841e10b9$var$c.isYouTubeUrl(t) || $af62ec6a841e10b9$var$c.isNicovideoUrl(t);
    },
    isPiaproUrl: function(t) {
        return $af62ec6a841e10b9$var$u.test(t);
    }
}, $af62ec6a841e10b9$var$l = /^https:\/\/songle\.jp\/api\/v[0-9]+\/users\/(.+)\/uploads\/(.+)$/, $af62ec6a841e10b9$var$p = function(t) {
    return $af62ec6a841e10b9$var$l.test(t);
}, $af62ec6a841e10b9$var$h = function(t) {
    var e = $af62ec6a841e10b9$var$l.exec(t);
    return e ? {
        user: e[1],
        identifier: e[2]
    } : {
        user: null,
        identifier: null
    };
}, $af62ec6a841e10b9$var$d = function() {
    function t() {}
    return t.prototype.isLicenseLoading = function(t) {
        return !t || !t.song || void 0 === t.lyrics || void 0 === t.backgroundImage;
    }, t.prototype.checkLicenses = function(t) {
        return !this.isLicenseLoading(t) && this.checkLicense(t.song) && this.checkLicense(t.lyrics) && this.checkLicense(t.backgroundImage);
    }, t.prototype.checkLicense = function(t) {
        return null === t || (1 === t.contentType ? this.checkMusicLicense(t.license) : 2 === t.contentType ? this.checkTextLicense(t.license) : 0 === t.contentType && (!!this.isBackgroundColorAsset(t) || this.checkBackgroundImageLicense(t.license)));
    }, t.prototype.checkMusicLicense = function(t) {
        return t.condition && t.condition.uploader || !(!t.condition || t.condition.ns || t.condition.nc || t.condition.org || t.condition.clb);
    }, t.prototype.checkTextLicense = function(t) {
        return t.condition && t.condition.uploader || !(!t.condition || t.condition.ns || t.condition.org || t.condition.clb);
    }, t.prototype.checkBackgroundImageLicense = function(t) {
        return !(!t.condition || t.condition.ns || t.condition.nc || t.condition.org || t.condition.clb);
    }, t.prototype.isUploaderAsset = function(t) {
        return t && t.url && ($af62ec6a841e10b9$var$c.isUploaderUrl(t.url) || $af62ec6a841e10b9$var$p(t.url));
    }, t.prototype.isPiaproAsset = function(t) {
        return t && t.url && $af62ec6a841e10b9$var$c.isPiaproUrl(t.url);
    }, t.prototype.isBlankBackgroundAsset = function(t) {
        return !t || !t.originalUrl;
    }, t.prototype.isBackgroundColorAsset = function(t) {
        var e = t && t.originalUrl ? t.originalUrl : "";
        return /^#[0-9a-fA-F]{3,6}$/.test(e);
    }, t.prototype.isBackgroundPiaproImageAsset = function(t) {
        var e = t && t.originalUrl ? t.originalUrl : "";
        return $af62ec6a841e10b9$var$c.isPiaproUrl(e);
    }, t.prototype.isBackgroundSpecialImageAsset = function(t) {
        var e = t && t.originalUrl ? t.originalUrl : "";
        return /^snowmiku2016-([0-9]{2})$/.test(e);
    }, t.prototype.getQueryParameter = function(t) {
        return !t || t.license && !this.checkBackgroundImageLicense(t.license) ? null : t.originalUrl;
    }, t;
}(), $af62ec6a841e10b9$var$f = function(t, e) {
    return $af62ec6a841e10b9$var$f = Object.setPrototypeOf || ({
        __proto__: []
    }) instanceof Array && function(t, e) {
        t.__proto__ = e;
    } || function(t, e) {
        for(var r in e)Object.prototype.hasOwnProperty.call(e, r) && (t[r] = e[r]);
    }, $af62ec6a841e10b9$var$f(t, e);
}, $af62ec6a841e10b9$var$y = function() {
    return $af62ec6a841e10b9$var$y = Object.assign || function(t) {
        for(var e, r = 1, n = arguments.length; r < n; r++)for(var i in e = arguments[r])Object.prototype.hasOwnProperty.call(e, i) && (t[i] = e[i]);
        return t;
    }, $af62ec6a841e10b9$var$y.apply(this, arguments);
};
function $af62ec6a841e10b9$var$g(t, e, r, n) {
    return new (r || (r = Promise))(function(e, i) {
        function o(t) {
            try {
                a(n.next(t));
            } catch (t) {
                i(t);
            }
        }
        function s(t) {
            try {
                a(n.throw(t));
            } catch (t) {
                i(t);
            }
        }
        function a(t) {
            var n;
            t.done ? e(t.value) : (n = t.value, n instanceof r ? n : new r(function(t) {
                t(n);
            })).then(o, s);
        }
        a((n = n.apply(t, [])).next());
    });
}
function $af62ec6a841e10b9$var$v(t, e) {
    var r, n, i, o, s = {
        label: 0,
        sent: function() {
            if (1 & i[0]) throw i[1];
            return i[1];
        },
        trys: [],
        ops: []
    };
    return o = {
        next: a(0),
        throw: a(1),
        return: a(2)
    }, "function" == typeof Symbol && (o[Symbol.iterator] = function() {
        return this;
    }), o;
    function a(a) {
        return function(u) {
            return function(a) {
                if (r) throw new TypeError("Generator is already executing.");
                for(; o && (o = 0, a[0] && (s = 0)), s;)try {
                    if (r = 1, n && (i = 2 & a[0] ? n.return : a[0] ? n.throw || ((i = n.return) && i.call(n), 0) : n.next) && !(i = i.call(n, a[1])).done) return i;
                    switch(n = 0, i && (a = [
                        2 & a[0],
                        i.value
                    ]), a[0]){
                        case 0:
                        case 1:
                            i = a;
                            break;
                        case 4:
                            return s.label++, {
                                value: a[1],
                                done: !1
                            };
                        case 5:
                            s.label++, n = a[1], a = [
                                0
                            ];
                            continue;
                        case 7:
                            a = s.ops.pop(), s.trys.pop();
                            continue;
                        default:
                            if (!((i = (i = s.trys).length > 0 && i[i.length - 1]) || 6 !== a[0] && 2 !== a[0])) {
                                s = 0;
                                continue;
                            }
                            if (3 === a[0] && (!i || a[1] > i[0] && a[1] < i[3])) {
                                s.label = a[1];
                                break;
                            }
                            if (6 === a[0] && s.label < i[1]) {
                                s.label = i[1], i = a;
                                break;
                            }
                            if (i && s.label < i[2]) {
                                s.label = i[2], s.ops.push(a);
                                break;
                            }
                            i[2] && s.ops.pop(), s.trys.pop();
                            continue;
                    }
                    a = e.call(t, s);
                } catch (t) {
                    a = [
                        6,
                        t
                    ], n = 0;
                } finally{
                    r = i = 0;
                }
                if (5 & a[0]) throw a[1];
                return {
                    value: a[0] ? a[1] : void 0,
                    done: !0
                };
            }([
                a,
                u
            ]);
        };
    }
}
"function" == typeof SuppressedError && SuppressedError;
var $af62ec6a841e10b9$var$m = {
    fallback: {
        protocol: "https"
    },
    songle: {
        domain: "songle.jp"
    },
    textalive: {
        domain: "api.textalive.jp"
    },
    content: {
        domain: "content.textalive.jp"
    },
    client: {
        version: "0.10.0",
        axios: null
    }
};
function $af62ec6a841e10b9$var$b(e, r, n) {
    var i, o, s;
    return $af62ec6a841e10b9$var$g(this, 0, void 0, function() {
        var a;
        return $af62ec6a841e10b9$var$v(this, function(u) {
            switch(u.label){
                case 0:
                    a = {
                        responseType: (null == n ? void 0 : n.responseType) || "json"
                    }, r && (a.params = r), (null == n ? void 0 : n.auth) && (a.auth = {
                        username: null === (i = n.auth) || void 0 === i ? void 0 : i.username,
                        password: null === (o = n.auth) || void 0 === o ? void 0 : o.password
                    }), (null == n ? void 0 : n.withCredentials) && (a.withCredentials = !0), a.headers = {}, 0 === e.indexOf($af62ec6a841e10b9$var$m.textalive.server) && ($af62ec6a841e10b9$var$m.textalive.appToken && (a.headers["x-ta-app-token"] = $af62ec6a841e10b9$var$m.textalive.appToken), $af62ec6a841e10b9$var$m.textalive.authUser && $af62ec6a841e10b9$var$m.textalive.authToken && (a.headers["x-ta-auth-user"] = $af62ec6a841e10b9$var$m.textalive.authUser, a.headers["x-ta-auth-token"] = $af62ec6a841e10b9$var$m.textalive.authToken)), (null == n ? void 0 : n.headers) && (a.headers = $af62ec6a841e10b9$var$y($af62ec6a841e10b9$var$y({}, a.headers), n.headers)), u.label = 1;
                case 1:
                    return u.trys.push([
                        1,
                        3,
                        ,
                        4
                    ]), [
                        4,
                        ((null == n ? void 0 : n.client) || (null === (s = $af62ec6a841e10b9$var$m.client) || void 0 === s ? void 0 : s.axios) || (0, $57966c7e0affc4cb$export$2e2bcd8739ae039)).get(e, a)
                    ];
                case 2:
                    return [
                        2,
                        u.sent()
                    ];
                case 3:
                    return u.sent(), [
                        2,
                        null
                    ];
                case 4:
                    return [
                        2
                    ];
            }
        });
    });
}
function $af62ec6a841e10b9$var$_(t) {
    var e, r, n = 0;
    if (0 === t.length) return n;
    for(e = 0, r = t.length; e < r; e++)n = (n << 5) - n + t.charCodeAt(e), n |= 0;
    return n;
}
$af62ec6a841e10b9$var$m.songle.protocol = $af62ec6a841e10b9$var$m.songle.protocol || $af62ec6a841e10b9$var$m.fallback.protocol, $af62ec6a841e10b9$var$m.songle.server = "".concat($af62ec6a841e10b9$var$m.songle.protocol, "://").concat($af62ec6a841e10b9$var$m.songle.domain), $af62ec6a841e10b9$var$m.textalive.protocol = $af62ec6a841e10b9$var$m.textalive.protocol || $af62ec6a841e10b9$var$m.fallback.protocol, $af62ec6a841e10b9$var$m.textalive.server = "".concat($af62ec6a841e10b9$var$m.textalive.protocol, "://").concat($af62ec6a841e10b9$var$m.textalive.domain), $af62ec6a841e10b9$var$m.textalive.appToken = null, $af62ec6a841e10b9$var$m.content.protocol = $af62ec6a841e10b9$var$m.content.protocol || $af62ec6a841e10b9$var$m.fallback.protocol, $af62ec6a841e10b9$var$m.content.server = "".concat($af62ec6a841e10b9$var$m.content.protocol, "://").concat($af62ec6a841e10b9$var$m.content.domain);
var $af62ec6a841e10b9$var$w = new (function(t) {
    function e() {
        return null !== t && t.apply(this, arguments) || this;
    }
    return function(t, e) {
        if ("function" != typeof e && null !== e) throw new TypeError("Class extends value " + String(e) + " is not a constructor or null");
        function r() {
            this.constructor = t;
        }
        $af62ec6a841e10b9$var$f(t, e), t.prototype = null === e ? Object.create(e) : (r.prototype = e.prototype, new r);
    }(e, t), Object.defineProperty(e.prototype, "endpoint", {
        get: function() {
            return "".concat($af62ec6a841e10b9$var$m.textalive.server, "/etc/license");
        },
        enumerable: !1,
        configurable: !0
    }), e.prototype.read = function(t, e) {
        var r;
        return void 0 === e && (e = !0), $af62ec6a841e10b9$var$g(this, 0, void 0, function() {
            var n, i;
            return $af62ec6a841e10b9$var$v(this, function(o) {
                switch(o.label){
                    case 0:
                        return [
                            4,
                            $af62ec6a841e10b9$var$b(this.endpoint, {
                                url: t,
                                token: $af62ec6a841e10b9$var$_("ta" + t),
                                skipOptoutCheck: !!e || void 0
                            })
                        ];
                    case 1:
                        return !(n = o.sent()) || 200 !== n.status || (null === (r = n.data) || void 0 === r ? void 0 : r.error) ? [
                            2,
                            {
                                originalUrl: null,
                                license: {
                                    code: n ? n.status : 404
                                }
                            }
                        ] : ((i = n.data).license.code = n.status, 0 === i.contentType && (i.css = 'url("' + i.contentUrl + '")'), [
                            2,
                            i
                        ]);
                }
            });
        });
    }, e;
}($af62ec6a841e10b9$var$d));
function $af62ec6a841e10b9$var$P(e, r, n) {
    var i;
    return $af62ec6a841e10b9$var$g(this, 0, void 0, function() {
        var o;
        return $af62ec6a841e10b9$var$v(this, function(s) {
            switch(s.label){
                case 0:
                    r || (r = {}), o = {
                        responseType: (null == n ? void 0 : n.responseType) || "json"
                    }, (null == n ? void 0 : n.withCredentials) && (o.withCredentials = !0), o.headers = {}, 0 === e.indexOf($af62ec6a841e10b9$var$m.textalive.server) && ($af62ec6a841e10b9$var$m.textalive.appToken && (o.headers["x-ta-app-token"] = $af62ec6a841e10b9$var$m.textalive.appToken), $af62ec6a841e10b9$var$m.textalive.authUser && $af62ec6a841e10b9$var$m.textalive.authToken && (o.headers["x-ta-auth-user"] = $af62ec6a841e10b9$var$m.textalive.authUser, o.headers["x-ta-auth-token"] = $af62ec6a841e10b9$var$m.textalive.authToken)), (null == n ? void 0 : n.postToken) && (o.headers["x-ta-post-token"] = n.postToken), (null == n ? void 0 : n.headers) && (o.headers || (o.headers = {}), o.headers = $af62ec6a841e10b9$var$y($af62ec6a841e10b9$var$y({}, o.headers), n.headers)), s.label = 1;
                case 1:
                    return s.trys.push([
                        1,
                        3,
                        ,
                        4
                    ]), [
                        4,
                        ((null == n ? void 0 : n.client) || (null === (i = $af62ec6a841e10b9$var$m.client) || void 0 === i ? void 0 : i.axios) || (0, $57966c7e0affc4cb$export$2e2bcd8739ae039)).post(e, r, o)
                    ];
                case 2:
                    return [
                        2,
                        s.sent()
                    ];
                case 3:
                    return s.sent(), [
                        2,
                        null
                    ];
                case 4:
                    return [
                        2
                    ];
            }
        });
    });
}
var $af62ec6a841e10b9$var$E = "data:text/plain;base64,";
function $af62ec6a841e10b9$export$9167496004a18c0(t) {
    return "string" == typeof t && 0 === t.indexOf($af62ec6a841e10b9$var$E);
}
function $af62ec6a841e10b9$export$8a3afe04b75316cd(t) {
    if (!$af62ec6a841e10b9$export$9167496004a18c0(t)) return null;
    var e = t.split(",")[1];
    return decodeURIComponent(atob(e).split("").map(function(t) {
        return "%" + ("00" + t.charCodeAt(0).toString(16)).slice(-2);
    }).join(""));
}
function $af62ec6a841e10b9$export$c8ddbc4478af1a1c(t) {
    return "string" != typeof t ? null : $af62ec6a841e10b9$var$E + btoa(encodeURIComponent(t).replace(/%([0-9A-F]{2})/g, function(t, e) {
        return String.fromCharCode(parseInt("0x" + e));
    }));
}
function $af62ec6a841e10b9$var$x(t, e, r, n, i) {
    var o = void 0 === window.screenLeft ? screen.left : window.screenLeft, s = void 0 === window.screenTop ? screen.top : window.screenTop, a = (window.innerWidth ? window.innerWidth : document.documentElement.clientWidth ? document.documentElement.clientWidth : screen.width) / 2 - r / 2 + o, u = (window.innerHeight ? window.innerHeight : document.documentElement.clientHeight ? document.documentElement.clientHeight : screen.height) / 2 - n / 2 + s, c = window.open(t, e, "width=" + r + ",height=" + n + ",top=" + u + ",left=" + a + "," + i);
    return window.focus && c.focus(), c;
}
var $af62ec6a841e10b9$var$A = new (function() {
    function t() {
        this.listeners = [], this.pollingTimeout = null;
    }
    return Object.defineProperty(t.prototype, "endpoint", {
        get: function() {
            return "".concat($af62ec6a841e10b9$var$m.textalive.server, "/");
        },
        enumerable: !1,
        configurable: !0
    }), Object.defineProperty(t.prototype, "songleEndpoint", {
        get: function() {
            return "".concat($af62ec6a841e10b9$var$m.songle.server, "/");
        },
        enumerable: !1,
        configurable: !0
    }), t.prototype.isLoading = function() {
        return !!this.userProfile;
    }, t.prototype.spoof = function(t) {
        this.userProfile = t;
    }, t.prototype.getServerStatus = function() {
        return $af62ec6a841e10b9$var$g(this, 0, void 0, function() {
            return $af62ec6a841e10b9$var$v(this, function(t) {
                return [
                    2,
                    this.serverStatus || this.doGetServerStatus()
                ];
            });
        });
    }, t.prototype.doGetServerStatus = function() {
        return $af62ec6a841e10b9$var$g(this, 0, void 0, function() {
            var t;
            return $af62ec6a841e10b9$var$v(this, function(e) {
                switch(e.label){
                    case 0:
                        return this.serverStatusRequest || (this.serverStatusRequest = $af62ec6a841e10b9$var$b(this.endpoint, null, {
                            withCredentials: !0
                        })), [
                            4,
                            this.serverStatusRequest
                        ];
                    case 1:
                        return t = e.sent(), this.serverStatusRequest = null, t && 200 === t.status ? (this.serverStatus = t.data, [
                            2,
                            this.serverStatus
                        ]) : [
                            2,
                            null
                        ];
                }
            });
        });
    }, t.prototype.getProfile = function() {
        return $af62ec6a841e10b9$var$g(this, 0, void 0, function() {
            return $af62ec6a841e10b9$var$v(this, function(t) {
                return [
                    2,
                    this.userProfile || this.doGetProfile()
                ];
            });
        });
    }, t.prototype.doGetProfile = function() {
        return $af62ec6a841e10b9$var$g(this, 0, void 0, function() {
            var t;
            return $af62ec6a841e10b9$var$v(this, function(e) {
                switch(e.label){
                    case 0:
                        return this.userProfileRequest || (this.userProfileRequest = $af62ec6a841e10b9$var$b("".concat(this.endpoint, "profile"), null, {
                            withCredentials: !0
                        })), [
                            4,
                            this.userProfileRequest
                        ];
                    case 1:
                        return t = e.sent(), this.userProfileRequest = null, t && 200 === t.status ? (this.emitUserProfile(t.data), this.userProfile = t.data, [
                            2,
                            this.userProfile
                        ]) : [
                            2,
                            null
                        ];
                }
            });
        });
    }, t.prototype.getMergingUsers = function() {
        return $af62ec6a841e10b9$var$g(this, 0, void 0, function() {
            var t;
            return $af62ec6a841e10b9$var$v(this, function(e) {
                switch(e.label){
                    case 0:
                        return [
                            4,
                            $af62ec6a841e10b9$var$b("".concat(this.endpoint, "profile/merge"), null, {
                                withCredentials: !0
                            })
                        ];
                    case 1:
                        return (t = e.sent()) && 200 === t.status && t.data ? [
                            2,
                            [
                                t.data.user,
                                t.data.mergeWith
                            ]
                        ] : [
                            2,
                            [
                                null,
                                null
                            ]
                        ];
                }
            });
        });
    }, t.prototype.mergeUsers = function() {
        var t;
        return $af62ec6a841e10b9$var$g(this, 0, void 0, function() {
            var e, r, n, i, o, s;
            return $af62ec6a841e10b9$var$v(this, function(a) {
                switch(a.label){
                    case 0:
                        return [
                            4,
                            this.getToken()
                        ];
                    case 1:
                        return e = a.sent(), [
                            4,
                            $af62ec6a841e10b9$var$P("".concat(this.endpoint, "profile/merge"), null, {
                                postToken: e,
                                withCredentials: !0
                            })
                        ];
                    case 2:
                        if (!(r = a.sent()) || 200 !== r.status || !(null === (t = r.data) || void 0 === t ? void 0 : t.success)) return [
                            2,
                            null
                        ];
                        for(n = r.data.user, i = 0, o = this.listeners; i < o.length; i++)(s = o[i]).onUserMerged && s.onUserMerged(n);
                        return [
                            2,
                            n
                        ];
                }
            });
        });
    }, t.prototype.updateUser = function(t) {
        var e;
        return $af62ec6a841e10b9$var$g(this, 0, void 0, function() {
            var r, n, i, o;
            return $af62ec6a841e10b9$var$v(this, function(s) {
                switch(s.label){
                    case 0:
                        return [
                            4,
                            this.getToken()
                        ];
                    case 1:
                        return r = s.sent(), [
                            4,
                            $af62ec6a841e10b9$var$P("".concat(this.endpoint, "profile"), t, {
                                postToken: r,
                                withCredentials: !0
                            })
                        ];
                    case 2:
                        return (n = s.sent()) && 200 === n.status && (null === (e = n.data) || void 0 === e ? void 0 : e.success) ? (i = n.data.user, [
                            4,
                            this.getProfile()
                        ]) : [
                            2,
                            null
                        ];
                    case 3:
                        return (o = s.sent()).user = i, this.emitUserProfile(o), [
                            2,
                            i
                        ];
                }
            });
        });
    }, t.prototype.isYouTubeUser = function(t) {
        return t && t.user && "string" == typeof t.user.youtubeIdString;
    }, t.prototype.isPiaproUser = function(t) {
        return t && t.user && "string" == typeof t.user.piaproIdString;
    }, t.prototype.isSongleUser = function(t) {
        return t && t.user && ("number" == typeof t.user.songleUserId && t.user.songleUserId >= 0 || "string" == typeof t.user.songleAccessToken);
    }, t.prototype.isSpoofingSongleUser = function(t) {
        return this.isSongleUser(t) && ("number" != typeof t.user.id || t.user.id < 0);
    }, t.prototype.addListener = function(t) {
        t && this.listeners.push(t);
    }, t.prototype.removeListener = function(t) {
        this.listeners = this.listeners.filter(function(e) {
            return e !== t;
        });
    }, t.prototype.emitUserProfile = function(t) {
        this.userProfile = t;
        for(var e = 0, r = this.listeners; e < r.length; e++){
            var n = r[e];
            n.onUserProfileUpdated && n.onUserProfileUpdated(t), this.userProfile.user ? n.onUserLoggedIn && n.onUserLoggedIn(t.user) : n.onUserLoggedOut && n.onUserLoggedOut();
        }
    }, t.prototype.authenticate = function(t, e) {
        return $af62ec6a841e10b9$var$g(this, 0, void 0, function() {
            var r;
            return $af62ec6a841e10b9$var$v(this, function(n) {
                switch(n.label){
                    case 0:
                        return [
                            4,
                            $af62ec6a841e10b9$var$b("".concat(this.endpoint, "profile/logins/basic"), null, {
                                auth: {
                                    username: String(t),
                                    password: e
                                },
                                withCredentials: !0
                            })
                        ];
                    case 1:
                        return (r = n.sent()) && 200 === r.status && r.data ? [
                            2,
                            r.data
                        ] : [
                            2,
                            null
                        ];
                }
            });
        });
    }, t.prototype.loginTwitter = function(t) {
        return this.login(t, "twitter");
    }, t.prototype.loginGitHub = function(t) {
        return this.login(t, "github");
    }, t.prototype.loginYouTube = function(t) {
        return this.login(t, "youtube");
    }, t.prototype.loginPiapro = function(t) {
        return this.login(t, "piapro");
    }, t.prototype.loginSongle = function(t) {
        return this.login(t, "songle");
    }, t.prototype.login = function(t, e) {
        return t && t.preventDefault(), !!e && ($af62ec6a841e10b9$var$x("".concat(this.endpoint, "profile/logins/").concat(e), "TextAliveAuth", 600, 480, "status=no,toolbar=no,menubar=no"), this.startMonitoringAuthState(), !1);
    }, t.prototype.logoutTwitter = function(t) {
        return this.logout(t, "twitter");
    }, t.prototype.logoutGitHub = function(t) {
        return this.logout(t, "github");
    }, t.prototype.logoutYouTube = function(t) {
        return this.logout(t, "youtube");
    }, t.prototype.logoutPiapro = function(t) {
        return this.logout(t, "piapro");
    }, t.prototype.logoutSongle = function(t) {
        return this.logout(t, "songle");
    }, t.prototype.logout = function(t, e) {
        return void 0 === e && (e = null), t && t.preventDefault(), $af62ec6a841e10b9$var$x("".concat(this.endpoint, "profile/logouts/").concat(e || "all"), "TextAliveAuth", 600, 480, "status=no,toolbar=no,menubar=no"), this.startMonitoringAuthState(), !1;
    }, t.prototype.startMonitoringAuthState = function() {
        var t = this;
        this.pollingTimeout && (clearTimeout(this.pollingTimeout), this.pollingTimeout = null);
        var e = function(r) {
            if (r.data && r.data.textalive) {
                if (r.source.postMessage("close", r.origin), r.data.merge) return t.getMergingUsers().then(function(e) {
                    for(var r = e[0], n = e[1], i = 0, o = t.listeners; i < o.length; i++){
                        var s = o[i];
                        s.onUserMergeRequired && s.onUserMergeRequired(r, n);
                    }
                }).catch(function() {}), void window.removeEventListener("message", e);
                t.doGetProfile(), window.removeEventListener("message", e);
            }
        };
        window.addEventListener("message", e);
    }, t.prototype.getToken = function() {
        return $af62ec6a841e10b9$var$g(this, 0, void 0, function() {
            return $af62ec6a841e10b9$var$v(this, function(t) {
                return this.userProfile ? [
                    2,
                    this.userProfile.status.token
                ] : this.token ? [
                    2,
                    this.token
                ] : [
                    2,
                    this.doGetToken()
                ];
            });
        });
    }, t.prototype.doGetToken = function() {
        var t;
        return $af62ec6a841e10b9$var$g(this, 0, void 0, function() {
            var e;
            return $af62ec6a841e10b9$var$v(this, function(r) {
                switch(r.label){
                    case 0:
                        return [
                            4,
                            $af62ec6a841e10b9$var$b("".concat(this.endpoint, "profile/token"), null, {
                                withCredentials: !0
                            })
                        ];
                    case 1:
                        return e = r.sent(), (null === (t = null == e ? void 0 : e.data) || void 0 === t ? void 0 : t.token) && (this.token = e.data.token), [
                            2,
                            this.token
                        ];
                }
            });
        });
    }, t;
}()), $af62ec6a841e10b9$var$R = new (function() {
    function t() {}
    return Object.defineProperty(t.prototype, "endpoint", {
        get: function() {
            return "".concat($af62ec6a841e10b9$var$m.textalive.server, "/text-parser/");
        },
        enumerable: !1,
        configurable: !0
    }), t.prototype.parse = function(t) {
        return $af62ec6a841e10b9$var$g(this, 0, void 0, function() {
            var e, r;
            return $af62ec6a841e10b9$var$v(this, function(n) {
                switch(n.label){
                    case 0:
                        return [
                            4,
                            $af62ec6a841e10b9$var$A.getToken()
                        ];
                    case 1:
                        return e = n.sent(), [
                            4,
                            $af62ec6a841e10b9$var$P(this.endpoint, {
                                text: t
                            }, {
                                postToken: e,
                                withCredentials: !0
                            })
                        ];
                    case 2:
                        return (r = n.sent()) && 200 === r.status ? [
                            2,
                            r.data
                        ] : [
                            2,
                            null
                        ];
                }
            });
        });
    }, t;
}()), $af62ec6a841e10b9$var$C = new (function() {
    function t() {}
    return Object.defineProperty(t.prototype, "endpoint", {
        get: function() {
            return "".concat($af62ec6a841e10b9$var$m.content.server, "/fonts");
        },
        enumerable: !1,
        configurable: !0
    }), t.prototype.listAvailableFonts = function() {
        return $af62ec6a841e10b9$var$g(this, 0, void 0, function() {
            var t = this;
            return $af62ec6a841e10b9$var$v(this, function(e) {
                switch(e.label){
                    case 0:
                        return this.data ? [
                            3,
                            2
                        ] : [
                            4,
                            this.fetchInfo()
                        ];
                    case 1:
                        e.sent(), e.label = 2;
                    case 2:
                        return this.data && this.data.fontFamilies ? [
                            2,
                            Object.keys(this.data.fontFamilies).map(function(e) {
                                return $af62ec6a841e10b9$var$y({
                                    key: e
                                }, t.data.fontFamilies[e]);
                            })
                        ] : [
                            2,
                            []
                        ];
                }
            });
        });
    }, t.prototype.getFrequentChars = function() {
        return $af62ec6a841e10b9$var$g(this, 0, void 0, function() {
            return $af62ec6a841e10b9$var$v(this, function(t) {
                switch(t.label){
                    case 0:
                        return this.data ? [
                            3,
                            2
                        ] : [
                            4,
                            this.fetchInfo()
                        ];
                    case 1:
                        t.sent(), t.label = 2;
                    case 2:
                        return [
                            2,
                            this.data && this.data.frequentChars || ""
                        ];
                }
            });
        });
    }, t.prototype.clearCache = function() {
        this.data = null;
    }, t.prototype.fetchInfo = function() {
        return $af62ec6a841e10b9$var$g(this, 0, void 0, function() {
            var t, e, r, n;
            return $af62ec6a841e10b9$var$v(this, function(i) {
                switch(i.label){
                    case 0:
                        return [
                            4,
                            $af62ec6a841e10b9$var$b("".concat(this.endpoint, "/index.json"))
                        ];
                    case 1:
                        if (!(t = i.sent()) || 200 !== t.status || !t.data) return this.data = null, [
                            2,
                            null
                        ];
                        for(r in this.data = t.data, e = this.data.fontUrlPrefix, this.data.fontFamilies)(n = this.data.fontFamilies[r]).typesquare || n.typekit || n.google || n.url || (n.url = "".concat(e, "/").concat(r, "-all.css"), n.compactUrl = "".concat(e, "/").concat(r, ".css"));
                        return [
                            2
                        ];
                }
            });
        });
    }, t;
}());
var $af62ec6a841e10b9$var$N = new RegExp("\\b([CDEFGAB](?:b|bb)*(?:#|##|sus|maj|min|aug|m|M)*[\\d/]*(?:[CDEFGAB](?:b|bb)*(?:#|##|sus|maj|min|aug|m|M)*[\\d/]*)*\\-){2}");
function $af62ec6a841e10b9$var$k(t, e, r) {
    return !$af62ec6a841e10b9$var$N.test(t) && !t.match(/[（(].+(?:転載|書き起こし).*[）)]/) && (!t.match(/(作詞|作曲).+(作詞|作曲)/) || 0 !== e && e !== r.length - 2);
}
function $af62ec6a841e10b9$var$j(t) {
    return !t.match(new RegExp("[\uFF08(]?\u203B"));
}
var $af62ec6a841e10b9$var$I = {}, $af62ec6a841e10b9$var$U = {}, $af62ec6a841e10b9$var$F = function() {
    function t() {}
    return Object.defineProperty(t.prototype, "endpoint", {
        get: function() {
            return "".concat($af62ec6a841e10b9$var$m.songle.server, "/lyrics/");
        },
        enumerable: !1,
        configurable: !0
    }), Object.defineProperty(t.prototype, "localLyricsEndpoint", {
        get: function() {
            return "".concat($af62ec6a841e10b9$var$m.textalive.server, "/etc/lyrics");
        },
        enumerable: !1,
        configurable: !0
    }), Object.defineProperty(t.prototype, "timingEndpoint", {
        get: function() {
            return "".concat($af62ec6a841e10b9$var$m.songle.server, "/songs/");
        },
        enumerable: !1,
        configurable: !0
    }), Object.defineProperty(t.prototype, "lyricsParserEndpoint", {
        get: function() {
            return $af62ec6a841e10b9$var$m.songle.server;
        },
        enumerable: !1,
        configurable: !0
    }), Object.defineProperty(t.prototype, "lyricsPostEndpoint", {
        get: function() {
            return $af62ec6a841e10b9$var$m.songle.server;
        },
        enumerable: !1,
        configurable: !0
    }), t.prototype.isUploaderUrl = function(t) {
        return $af62ec6a841e10b9$var$p(t);
    }, t.prototype.parseUploaderUrl = function(t) {
        return $af62ec6a841e10b9$var$h(t);
    }, t.prototype.getRecentlySynchronizedList = function(t) {
        return void 0 === t && (t = {}), $af62ec6a841e10b9$var$g(this, 0, void 0, function() {
            var e, r;
            return $af62ec6a841e10b9$var$v(this, function(n) {
                switch(n.label){
                    case 0:
                        return e = {}, "number" == typeof t ? e.page = t : t && (e.page = t.page, e.per_page = t.perPage), [
                            4,
                            $af62ec6a841e10b9$var$b("".concat(this.endpoint, "recently_synchronized.json"), e)
                        ];
                    case 1:
                        return (r = n.sent()) && 200 === r.status ? [
                            2,
                            r.data
                        ] : [
                            2,
                            null
                        ];
                }
            });
        });
    }, t.prototype.load = function(t) {
        return $af62ec6a841e10b9$var$g(this, 0, void 0, function() {
            var e;
            return $af62ec6a841e10b9$var$v(this, function(r) {
                switch(r.label){
                    case 0:
                        return [
                            4,
                            $af62ec6a841e10b9$var$b("".concat(this.timingEndpoint + t, "/lyrics.json"))
                        ];
                    case 1:
                        return (e = r.sent()) && 200 === e.status ? [
                            2,
                            e.data
                        ] : [
                            2,
                            null
                        ];
                }
            });
        });
    }, t.prototype.clearCache = function() {
        $af62ec6a841e10b9$var$I = {};
    }, t.prototype.loadDetail = function(t, e) {
        return $af62ec6a841e10b9$var$g(this, 0, void 0, function() {
            var r, n;
            return $af62ec6a841e10b9$var$v(this, function(i) {
                switch(i.label){
                    case 0:
                        return $af62ec6a841e10b9$var$I[t] && $af62ec6a841e10b9$var$I[t][e] ? [
                            2,
                            $af62ec6a841e10b9$var$I[t][e]
                        ] : [
                            4,
                            $af62ec6a841e10b9$var$b("".concat(this.timingEndpoint + t, "/lyrics/").concat(e < 0 ? "latest" : e, ".json"))
                        ];
                    case 1:
                        return (r = i.sent()) && 200 === r.status ? (n = r.data, $af62ec6a841e10b9$var$I[t] || ($af62ec6a841e10b9$var$I[t] = {}), $af62ec6a841e10b9$var$I[t][n.id] = n, e < 0 && ($af62ec6a841e10b9$var$I[t][-1] = n), [
                            2,
                            n
                        ]) : [
                            2,
                            null
                        ];
                }
            });
        });
    }, t.prototype.loadDiffs = function(t, e) {
        return $af62ec6a841e10b9$var$g(this, 0, void 0, function() {
            var r;
            return $af62ec6a841e10b9$var$v(this, function(n) {
                switch(n.label){
                    case 0:
                        return [
                            4,
                            $af62ec6a841e10b9$var$b("".concat(this.timingEndpoint + t, "/lyrics/").concat(e, "/diffs.json"))
                        ];
                    case 1:
                        return (r = n.sent()) && 200 === r.status ? [
                            2,
                            r.data
                        ] : [
                            2,
                            null
                        ];
                }
            });
        });
    }, t.prototype.loadDiff = function(t, e, r) {
        return $af62ec6a841e10b9$var$g(this, 0, void 0, function() {
            return $af62ec6a841e10b9$var$v(this, function(n) {
                switch(n.label){
                    case 0:
                        return [
                            4,
                            $af62ec6a841e10b9$var$b("".concat(this.timingEndpoint + t, "/lyrics/").concat(e).concat(r < 0 ? "" : 0 === r ? "/original" : "/diffs/".concat(r, "/lyrics"), ".json"))
                        ];
                    case 1:
                        return [
                            2,
                            n.sent().data
                        ];
                }
            });
        });
    }, t.prototype.loadAllRevisionsForSong = function(t) {
        return $af62ec6a841e10b9$var$g(this, 0, void 0, function() {
            var e, r, n, i, o, s, a, u, c, l;
            return $af62ec6a841e10b9$var$v(this, function(p) {
                switch(p.label){
                    case 0:
                        return [
                            4,
                            this.load(t)
                        ];
                    case 1:
                        if (!(e = p.sent())) return [
                            2,
                            null
                        ];
                        r = [], n = 0, i = e.lyrics, p.label = 2;
                    case 2:
                        return n < i.length ? (o = i[n], [
                            4,
                            this.loadDetail(t, o.id)
                        ]) : [
                            3,
                            6
                        ];
                    case 3:
                        return s = p.sent(), [
                            4,
                            this.loadDiffs(t, s.id)
                        ];
                    case 4:
                        if (a = p.sent(), r.push({
                            lyrics: s,
                            updated_at: new Date(s.created_at)
                        }), Array.isArray(a)) for(u = 0, c = a; u < c.length; u++)l = c[u], r.push({
                            diff_id: l.id,
                            source_id: l.source_id,
                            lyrics: s,
                            updated_at: new Date(l.updated_at)
                        });
                        p.label = 5;
                    case 5:
                        return n++, [
                            3,
                            2
                        ];
                    case 6:
                        return [
                            2,
                            r.sort(function(t, e) {
                                var r = e.updated_at.getTime() - t.updated_at.getTime();
                                return 0 === r ? e.diff_id - t.diff_id : r;
                            })
                        ];
                }
            });
        });
    }, t.prototype.getLatestRevision = function(t) {
        return t.filter(function(t) {
            return !(t.lyrics.processing || t.lyrics.failed);
        })[0];
    }, t.prototype.fetchLocalLyricBody = function(t) {
        return $af62ec6a841e10b9$var$g(this, 0, void 0, function() {
            var e, r, n, i;
            return $af62ec6a841e10b9$var$v(this, function(o) {
                switch(o.label){
                    case 0:
                        return this.verbose && ("string" == typeof t ? console.log("load locally-stored lyrics for song code", t) : console.log("load locally-stored lyrics for lyric id", t)), e = {}, "string" == typeof t ? e.code = t : e.lyricId = t, [
                            4,
                            $af62ec6a841e10b9$var$b("".concat(this.localLyricsEndpoint, "/token"), e)
                        ];
                    case 1:
                        return !(r = o.sent()) || 200 !== r.status || r.data.error ? [
                            2,
                            null
                        ] : (n = r.data.token, e.token = n, [
                            4,
                            $af62ec6a841e10b9$var$b(this.localLyricsEndpoint, e)
                        ]);
                    case 2:
                        return (i = o.sent()) && 200 === i.status ? (this.verbose && console.log("loaded locally-stored lyrics with params", e), [
                            2,
                            i.data
                        ]) : [
                            2,
                            null
                        ];
                }
            });
        });
    }, t.prototype.fetchSongleLyricBody = function(t, e) {
        return $af62ec6a841e10b9$var$g(this, 0, void 0, function() {
            var r, n, i, o, s, a, u, c, l, p, h;
            return $af62ec6a841e10b9$var$v(this, function(d) {
                switch(d.label){
                    case 0:
                        if (!(r = this.parseUploaderUrl(t)).identifier) throw new Error("unsupported lyrics url ".concat(t));
                        return [
                            4,
                            $af62ec6a841e10b9$var$A.getProfile()
                        ];
                    case 1:
                        if (n = d.sent(), !$af62ec6a841e10b9$var$A.isSongleUser(n)) throw new Error("Songle authentication is required");
                        return i = "".concat(t, "//").concat(e), $af62ec6a841e10b9$var$U[i] ? [
                            2,
                            $af62ec6a841e10b9$var$U[i]
                        ] : ($af62ec6a841e10b9$var$A.isSpoofingSongleUser(n) && (s = n.user, a = s.songleUserId, u = s.songleAccessToken, c = s.songleRefreshToken, o = {
                            songleUserId: a,
                            songleAccessToken: u,
                            songleRefreshToken: c
                        }), [
                            4,
                            $af62ec6a841e10b9$var$b("".concat($af62ec6a841e10b9$var$m.textalive.server, "/songle/users/").concat(r.user, "/uploads/").concat(r.identifier), o, {
                                withCredentials: !0,
                                responseType: "text"
                            })
                        ]);
                    case 2:
                        return l = d.sent(), p = null == l ? void 0 : l.data, h = p ? {
                            text: p,
                            url: t
                        } : null, p && ($af62ec6a841e10b9$var$U[i] = h), [
                            2,
                            h
                        ];
                }
            });
        });
    }, t.prototype.fetchPiaproLyricBody = function(t, e) {
        return $af62ec6a841e10b9$var$g(this, 0, void 0, function() {
            var r, n, i, o, s;
            return $af62ec6a841e10b9$var$v(this, function(a) {
                switch(a.label){
                    case 0:
                        if (!$af62ec6a841e10b9$var$c.isPiaproUrl(t)) throw new Error("unsupported lyrics url ".concat(t));
                        return r = "".concat(t, "//").concat(e), $af62ec6a841e10b9$var$U[r] ? [
                            2,
                            $af62ec6a841e10b9$var$U[r]
                        ] : [
                            4,
                            $af62ec6a841e10b9$var$w.read(t, !0)
                        ];
                    case 1:
                        if (n = a.sent(), !$af62ec6a841e10b9$var$w.isPiaproAsset(n)) throw new Error("unsupported piapro lyrics url ".concat(t));
                        return i = $af62ec6a841e10b9$export$8a3afe04b75316cd(n.contentUrl), [
                            4,
                            this.parseLyricBody(i, e)
                        ];
                    case 2:
                        return o = a.sent(), (s = o ? {
                            text: o,
                            artist: {
                                name: n.authorName,
                                url: n.authorPath ? "https://piapro.jp".concat(n.authorPath) : null
                            },
                            name: n.name,
                            url: t
                        } : null) && ($af62ec6a841e10b9$var$U[r] = s), [
                            2,
                            s
                        ];
                }
            });
        });
    }, t.prototype.fetchInternalLyricBody = function(t, e) {
        return $af62ec6a841e10b9$var$g(this, 0, void 0, function() {
            var r;
            return $af62ec6a841e10b9$var$v(this, function(n) {
                if (r = new URL(t), "undefined" == typeof location || location.protocol !== r.protocol || location.hostname !== r.hostname) throw new Error("direct access not supported for lyrics url ".concat(t));
                return [
                    2,
                    this.fetchCrossOriginLyricBody(t, e)
                ];
            });
        });
    }, t.prototype.fetchCrossOriginLyricBody = function(t, e) {
        return $af62ec6a841e10b9$var$g(this, 0, void 0, function() {
            var r, n, i, o, s;
            return $af62ec6a841e10b9$var$v(this, function(a) {
                switch(a.label){
                    case 0:
                        return r = "".concat(t, "//").concat(e), $af62ec6a841e10b9$var$U[r] ? [
                            2,
                            $af62ec6a841e10b9$var$U[r]
                        ] : [
                            4,
                            $af62ec6a841e10b9$var$b(t, null, {
                                responseType: "text"
                            })
                        ];
                    case 1:
                        return n = a.sent(), i = null == n ? void 0 : n.data, n && 200 === n.status && i ? [
                            4,
                            this.parseLyricBody(i, e)
                        ] : (this.verbose && console.error("direct access not supported for lyrics url ".concat(t)), [
                            2,
                            this.fetchProxiedLyricBody(t, e)
                        ]);
                    case 2:
                        return o = a.sent(), (s = o ? {
                            text: o,
                            url: t
                        } : null) && ($af62ec6a841e10b9$var$U[r] = s), [
                            2,
                            s
                        ];
                }
            });
        });
    }, t.prototype.fetchProxiedLyricBody = function(t, e) {
        return $af62ec6a841e10b9$var$g(this, 0, void 0, function() {
            var r, n, i;
            return $af62ec6a841e10b9$var$v(this, function(o) {
                switch(o.label){
                    case 0:
                        return r = "".concat(t, "//").concat(e), $af62ec6a841e10b9$var$U[r] ? [
                            2,
                            $af62ec6a841e10b9$var$U[r]
                        ] : (this.verbose && console.log("load lyrics from the external server", t), [
                            4,
                            $af62ec6a841e10b9$var$L(this.lyricsParserEndpoint + e, function(e) {
                                return new Promise(function(r, n) {
                                    e.Songle.Utils.url2Lyric(t, function(t) {
                                        return r(t);
                                    }, function(t) {
                                        return n(t);
                                    });
                                });
                            }, this.verbose)
                        ]);
                    case 1:
                        return n = o.sent(), (i = n ? {
                            text: n,
                            url: t
                        } : null) && ($af62ec6a841e10b9$var$U[r] = i), [
                            2,
                            i
                        ];
                }
            });
        });
    }, t.prototype.parseLyricBody = function(t, e) {
        return $af62ec6a841e10b9$var$g(this, 0, void 0, function() {
            var r;
            return $af62ec6a841e10b9$var$v(this, function(n) {
                switch(n.label){
                    case 0:
                        return n.trys.push([
                            0,
                            2,
                            ,
                            3
                        ]), [
                            4,
                            $af62ec6a841e10b9$var$L(this.lyricsParserEndpoint + e, function(e) {
                                return e.Songle.Utils.parseLyric(t);
                            }, this.verbose)
                        ];
                    case 1:
                        return r = n.sent(), [
                            3,
                            3
                        ];
                    case 2:
                        return n.sent(), r = function(t) {
                            return function(t) {
                                return t = function(t) {
                                    var e, r = t.split(/\n/);
                                    return r.forEach(function(t, r) {
                                        t.match(/^\S+：\S+$/m) && (e = r);
                                    }), void 0 !== e && e < 5 ? r.slice(e + 1).join("\n") : t;
                                }(t), t = function(t) {
                                    for(var e, r, n, i, o, s = new RegExp("[\uFF08(]?(.)\u7E70\u308A\u8FD4\u3057[)\uFF09]?", "g"); null !== (r = s.exec(t));)n = r[1], i = new RegExp("^(" + n + "[\\s\\S]+?)(?=\\n\\n[^\\u3000|\\s])", "m"), null !== (o = t.match(i)) && (e = o[1].replace(new RegExp("^" + n, "m"), "").replace(new RegExp("^\\n"), "").replace(new RegExp("^\\u3000", "mg"), ""), t = (t = t.replace(i, function() {
                                        return e;
                                    })).replace(new RegExp("[\uFF08\\(]?" + n + "\u7E70\u308A\u8FD4\u3057[\\)\uFF09]?", "g"), e).replace(new RegExp("^" + n, "m"), ""));
                                    return t;
                                }(t = t.split(/\n/).filter($af62ec6a841e10b9$var$k).join("\n")), t = function(t) {
                                    var e = new RegExp("[\\u4E00-\\u9FAF|\\uFF66-\\uFF9D|\\u31F0-\\u31FF]+[\uFF08\\(]([\\u3041-\\u3096\\u309D-\\u309F]+)[\\)\uFF09]", "g");
                                    return t.replace(e, function(t, e) {
                                        return e;
                                    });
                                }(t), t.split(/\n/).filter($af62ec6a841e10b9$var$j).join("\n").replace(/\n\n+/g, "\n\n").replace(/\n+$/g, "\n");
                            }(t.replace(/^\ufeff/, "").replace(/\r/, "").split(/\n/).filter($af62ec6a841e10b9$var$k).filter(function(t) {
                                return !t.match(/^#/);
                            }).join("\n").replace(/^\s+/, ""));
                        }(t), [
                            3,
                            3
                        ];
                    case 3:
                        return [
                            2,
                            r
                        ];
                }
            });
        });
    }, t.prototype.clearLyricBodyCache = function() {
        $af62ec6a841e10b9$var$U = {};
    }, t.prototype.fetchLyricBody = function(t, e) {
        var r, n, i = e.parserPath, o = e.directAccess;
        return $af62ec6a841e10b9$var$g(this, 0, void 0, function() {
            var e, s;
            return $af62ec6a841e10b9$var$v(this, function(a) {
                switch(a.label){
                    case 0:
                        if ($af62ec6a841e10b9$export$9167496004a18c0(t)) return this.verbose && console.log("load lyrics from the data url", t), [
                            2,
                            {
                                text: $af62ec6a841e10b9$export$8a3afe04b75316cd(t)
                            }
                        ];
                        if (this.isUploaderUrl(t)) return [
                            2,
                            this.fetchSongleLyricBody(t, i)
                        ];
                        if ($af62ec6a841e10b9$var$c.isPiaproUrl(t)) return [
                            2,
                            this.fetchPiaproLyricBody(t, i)
                        ];
                        a.label = 1;
                    case 1:
                        return a.trys.push([
                            1,
                            5,
                            ,
                            6
                        ]), e = new URL(t), o || "undefined" != typeof location && location.protocol !== e.protocol && "https:" !== e.protocol ? [
                            3,
                            4
                        ] : "undefined" != typeof location && location.hostname !== e.hostname ? [
                            3,
                            2
                        ] : (o = !0, [
                            3,
                            4
                        ]);
                    case 2:
                        return [
                            4,
                            $af62ec6a841e10b9$var$b("".concat(this.localLyricsEndpoint, "/cors"), {
                                url: t
                            })
                        ];
                    case 3:
                        s = a.sent(), o = s && 200 === s.status && (null === (n = null === (r = s.data) || void 0 === r ? void 0 : r.data) || void 0 === n ? void 0 : n.enabled), a.label = 4;
                    case 4:
                        return o ? (this.verbose && console.log("load lyrics directly", t), [
                            2,
                            this.fetchCrossOriginLyricBody(t, i)
                        ]) : [
                            3,
                            6
                        ];
                    case 5:
                        return a.sent(), [
                            3,
                            6
                        ];
                    case 6:
                        return [
                            2,
                            this.fetchProxiedLyricBody(t, i)
                        ];
                }
            });
        });
    }, t.prototype.post = function(t) {
        return $af62ec6a841e10b9$var$g(this, 0, void 0, function() {
            var e, r;
            return $af62ec6a841e10b9$var$v(this, function(n) {
                switch(n.label){
                    case 0:
                        return e = t.forceUpdate ? {
                            url: t.lyricsUrl,
                            force_create: "true"
                        } : {
                            url: t.lyricsUrl
                        }, [
                            4,
                            $af62ec6a841e10b9$var$P("".concat(this.lyricsPostEndpoint, "/songs/").concat(t.songId, "/lyrics.json"), e)
                        ];
                    case 1:
                        return (r = n.sent()) && 200 === r.status && r.data ? [
                            2,
                            {
                                success: !0,
                                lyricsId: r.data.id
                            }
                        ] : [
                            2,
                            {
                                success: !1,
                                error: "failed to update lyrics url"
                            }
                        ];
                }
            });
        });
    }, t.prototype.postPrivate = function(t) {
        return $af62ec6a841e10b9$var$g(this, 0, void 0, function() {
            var e, r, n, i, o, s, a, u, c, l, p;
            return $af62ec6a841e10b9$var$v(this, function(h) {
                switch(h.label){
                    case 0:
                        return [
                            4,
                            $af62ec6a841e10b9$var$A.getProfile()
                        ];
                    case 1:
                        if (e = h.sent(), !$af62ec6a841e10b9$var$A.isSongleUser(e)) throw new Error("Songle authentication is required");
                        return $af62ec6a841e10b9$var$A.isSpoofingSongleUser(e) ? (n = e.user, i = n.songleUserId, o = n.songleAccessToken, s = n.songleRefreshToken, a = {
                            songleUserId: i,
                            songleAccessToken: o,
                            songleRefreshToken: s
                        }, r = "?" + Object.keys(a).map(function(t) {
                            return "".concat(t, "=").concat(encodeURIComponent(a[t]));
                        }).join("&")) : r = "", u = t.songId, c = t.lyricsText, (l = new FormData).append("text", c), [
                            4,
                            $af62ec6a841e10b9$var$P("".concat($af62ec6a841e10b9$var$m.textalive.server, "/songle/me/songs/").concat(u, "/lyrics.json").concat(r), l, {
                                withCredentials: !0
                            })
                        ];
                    case 2:
                        return (p = h.sent()) && 200 === p.status && p.data ? [
                            2,
                            {
                                success: !0,
                                lyrics: p.data.data.lyric
                            }
                        ] : [
                            2,
                            {
                                success: !1,
                                error: "failed to post lyrics text"
                            }
                        ];
                }
            });
        });
    }, t.prototype.update = function(t) {
        var e;
        return $af62ec6a841e10b9$var$g(this, 0, void 0, function() {
            var r;
            return $af62ec6a841e10b9$var$v(this, function(n) {
                switch(n.label){
                    case 0:
                        return [
                            4,
                            $af62ec6a841e10b9$var$P("".concat(this.lyricsPostEndpoint, "/songs/").concat(t.songCode, "/lyrics/").concat(t.lyricsId, "/diffs.json"), t.lyricsData ? {
                                lyric: JSON.stringify(t.lyricsData)
                            } : {
                                source_diff_id: t.lyricsDiffId
                            })
                        ];
                    case 1:
                        return r = n.sent(), [
                            2,
                            (null === (e = null == r ? void 0 : r.data) || void 0 === e ? void 0 : e.lyric_diff) ? {
                                success: 200 === r.status,
                                lyricsId: r.data.lyric_diff.lyric_id,
                                lyricsDiffId: r.data.lyric_diff.id
                            } : {
                                success: 200 === r.status
                            }
                        ];
                }
            });
        });
    }, t;
}();
function $af62ec6a841e10b9$var$L(t, e, r) {
    var n, i = this;
    return "undefined" == typeof window || !(null === (n = null === window || void 0 === window ? void 0 : window.navigator) || void 0 === n ? void 0 : n.userAgent) || window.navigator.userAgent.includes("Node.js") || window.navigator.userAgent.includes("jsdom") ? function(t, e, r) {
        return r && console.log("parse lyrics: loading on Node.js", t), new Promise(function(r, n) {
            $af62ec6a841e10b9$var$b(t, {
                responseType: "text"
            }).then(function(t) {
                var i = t.data, o = new Function("let g=global;global={};".concat(i, ";let res=global;global=g")), s = {};
                try {
                    o.bind(s)(), r(e(s));
                } catch (t) {
                    n(t);
                }
            }).catch(n);
        });
    }(t, e, r) : (r && console.log("parse lyrics: loading", t), new Promise(function(n, o) {
        try {
            var s = document.createElement("script"), a = null;
            window.module && (a = window.module, delete window.module), s.src = t, s.onload = function() {
                return $af62ec6a841e10b9$var$g(i, 0, void 0, function() {
                    var i, u;
                    return $af62ec6a841e10b9$var$v(this, function(c) {
                        switch(c.label){
                            case 0:
                                document.body.removeChild(s), r && console.log("parse lyrics: load", t), window.Songle && window.Songle.Utils && window.Songle.Utils.url2Lyric || (a && (window.module = a), o("url2Lyric not found")), c.label = 1;
                            case 1:
                                return c.trys.push([
                                    1,
                                    3,
                                    4,
                                    5
                                ]), i = n, [
                                    4,
                                    e(window)
                                ];
                            case 2:
                                return i.apply(void 0, [
                                    c.sent()
                                ]), [
                                    3,
                                    5
                                ];
                            case 3:
                                return u = c.sent(), o(u), [
                                    3,
                                    5
                                ];
                            case 4:
                                return a && (window.module = a), [
                                    7
                                ];
                            case 5:
                                return [
                                    2
                                ];
                        }
                    });
                });
            }, s.onerror = function(t) {
                return o(t.message);
            }, document.body.appendChild(s);
        } catch (e) {
            console.error("failed to call lyrics parser", t, e);
        }
    }));
}
var $af62ec6a841e10b9$var$D = new $af62ec6a841e10b9$var$F, $af62ec6a841e10b9$var$M = {}, $af62ec6a841e10b9$var$B = {}, $af62ec6a841e10b9$var$V = new (function() {
    function t() {}
    return Object.defineProperty(t.prototype, "endpoint", {
        get: function() {
            return $af62ec6a841e10b9$var$m.textalive.server;
        },
        enumerable: !1,
        configurable: !0
    }), Object.defineProperty(t.prototype, "songleEndpoint", {
        get: function() {
            return $af62ec6a841e10b9$var$m.songle.server;
        },
        enumerable: !1,
        configurable: !0
    }), t.prototype.getSongPathFromUrl = function(t) {
        return $af62ec6a841e10b9$var$c.getSongPathFromUrl(t);
    }, t.prototype.isUploaderUrl = function(t) {
        return $af62ec6a841e10b9$var$c.isUploaderUrl(t);
    }, t.prototype.isUploaderPath = function(t) {
        return $af62ec6a841e10b9$var$c.isUploaderPath(t);
    }, t.prototype.getUploaderGuid = function(t) {
        return $af62ec6a841e10b9$var$c.getUploaderGuid(t);
    }, t.prototype.getAltSongUrlFromUploaderGuid = function(t) {
        return $af62ec6a841e10b9$var$c.getAltSongUrlFromUploaderGuid(t);
    }, t.prototype.getSongUrlFromUploaderGuid = function(t) {
        return $af62ec6a841e10b9$var$c.getSongUrlFromUploaderGuid(t);
    }, t.prototype.getSongUrlFromPath = function(t) {
        return $af62ec6a841e10b9$var$c.getSongUrlFromPath(t);
    }, t.prototype.isYouTubeUrl = function(t) {
        return $af62ec6a841e10b9$var$c.isYouTubeUrl(t);
    }, t.prototype.isNicovideoUrl = function(t) {
        return $af62ec6a841e10b9$var$c.isNicovideoUrl(t);
    }, t.prototype.isVideoSiteUrl = function(t) {
        return $af62ec6a841e10b9$var$c.isVideoSiteUrl(t);
    }, t.prototype.isPiaproUrl = function(t) {
        return $af62ec6a841e10b9$var$c.isPiaproUrl(t);
    }, t.prototype.load = function(t) {
        return $af62ec6a841e10b9$var$g(this, 0, void 0, function() {
            var e, r;
            return $af62ec6a841e10b9$var$v(this, function(n) {
                switch(n.label){
                    case 0:
                        return e = t.code || "number" == typeof t.id && String(t.id) || encodeURIComponent(t.songPath), $af62ec6a841e10b9$var$M[e] ? [
                            2,
                            $af62ec6a841e10b9$var$M[e]
                        ] : ($af62ec6a841e10b9$var$M[e] = this.doLoad(e), [
                            4,
                            $af62ec6a841e10b9$var$M[e]
                        ]);
                    case 1:
                        return r = n.sent(), this.use(r), [
                            2,
                            r
                        ];
                }
            });
        });
    }, t.prototype.use = function(t) {
        if (t) {
            var e = String(t.song.id), r = t.song.code, n = this.getSongPathFromUrl(t.song.permalink);
            $af62ec6a841e10b9$var$M[e] = $af62ec6a841e10b9$var$M[r] = $af62ec6a841e10b9$var$M[n] = Promise.resolve(t);
        }
    }, t.prototype.clearCache = function() {
        $af62ec6a841e10b9$var$M = {}, $af62ec6a841e10b9$var$B = {};
    }, t.prototype.doLoad = function(t) {
        var e;
        return $af62ec6a841e10b9$var$g(this, 0, void 0, function() {
            var r, n, i;
            return $af62ec6a841e10b9$var$v(this, function(o) {
                switch(o.label){
                    case 0:
                        return [
                            4,
                            $af62ec6a841e10b9$var$b("".concat(this.songleEndpoint, "/songs/").concat(t, "?format=json"))
                        ];
                    case 1:
                        return (r = o.sent()) && 200 === r.status ? (n = r.data, this.isUploaderUrl(null === (e = null == n ? void 0 : n.song) || void 0 === e ? void 0 : e.permalink) ? [
                            4,
                            this.doLoadPrivateSong(n.song.id)
                        ] : [
                            3,
                            3
                        ]) : [
                            2,
                            null
                        ];
                    case 2:
                        if (i = o.sent()) return n.status = n.status || {}, n.status.owner = !0, [
                            2,
                            $af62ec6a841e10b9$var$y($af62ec6a841e10b9$var$y({}, n), {
                                song: i
                            })
                        ];
                        n.status = n.status || {}, n.status.owner = !1, o.label = 3;
                    case 3:
                        return [
                            2,
                            n
                        ];
                }
            });
        });
    }, t.prototype.doLoadPrivateSong = function(t) {
        var e, r;
        return $af62ec6a841e10b9$var$g(this, 0, void 0, function() {
            var n, i, o, s, a, u, c;
            return $af62ec6a841e10b9$var$v(this, function(l) {
                switch(l.label){
                    case 0:
                        return [
                            4,
                            $af62ec6a841e10b9$var$A.getProfile()
                        ];
                    case 1:
                        return n = l.sent(), $af62ec6a841e10b9$var$A.isSongleUser(n) ? ($af62ec6a841e10b9$var$A.isSpoofingSongleUser(n) && (o = n.user, s = o.songleUserId, a = o.songleAccessToken, u = o.songleRefreshToken, i = {
                            songleUserId: s,
                            songleAccessToken: a,
                            songleRefreshToken: u
                        }), [
                            4,
                            $af62ec6a841e10b9$var$b("".concat(this.endpoint, "/songle/me/songs/").concat(t, ".json"), i, {
                                withCredentials: !0
                            })
                        ]) : [
                            2,
                            null
                        ];
                    case 2:
                        return (c = l.sent()) && 200 === c.status && (null === (r = null === (e = c.data) || void 0 === e ? void 0 : e.data) || void 0 === r ? void 0 : r.song) ? [
                            2,
                            c.data.data.song
                        ] : [
                            2,
                            null
                        ];
                }
            });
        });
    }, t.prototype.loadInfo = function(t, e) {
        return $af62ec6a841e10b9$var$g(this, 0, void 0, function() {
            var r;
            return $af62ec6a841e10b9$var$v(this, function(n) {
                return r = this.cacheKey(t, e), $af62ec6a841e10b9$var$B[r] || ($af62ec6a841e10b9$var$B[r] = this.doLoadInfo(t, {
                    min: !0,
                    revisions: null == e ? void 0 : e.revisions
                })), [
                    2,
                    $af62ec6a841e10b9$var$B[r]
                ];
            });
        });
    }, t.prototype.loadDetailInfo = function(t, e) {
        return $af62ec6a841e10b9$var$g(this, 0, void 0, function() {
            var r;
            return $af62ec6a841e10b9$var$v(this, function(n) {
                return r = this.cacheKey(t, e) + "/dt", $af62ec6a841e10b9$var$B[r] || ($af62ec6a841e10b9$var$B[r] = this.doLoadInfo(t, {
                    min: !1,
                    revisions: null == e ? void 0 : e.revisions
                })), [
                    2,
                    $af62ec6a841e10b9$var$B[r]
                ];
            });
        });
    }, t.prototype.cacheKey = function(t, e) {
        var r = String(t);
        return (null == e ? void 0 : e.revisions) && ("number" == typeof e.revisions.chord && (r += "/cd" + e.revisions.chord), "number" == typeof e.revisions.beat && (r += "/bt" + e.revisions.beat), "number" == typeof e.revisions.chorus && (r += "/cr" + e.revisions.chorus)), r;
    }, t.prototype.doLoadInfo = function(t, e) {
        var r = void 0 === e ? {
            min: !0
        } : e, n = r.min, i = r.revisions;
        return $af62ec6a841e10b9$var$g(this, 0, void 0, function() {
            var e, r;
            return $af62ec6a841e10b9$var$v(this, function(o) {
                switch(o.label){
                    case 0:
                        return e = {
                            min: n ? 1 : 0
                        }, "number" == typeof (null == i ? void 0 : i.chord) && (e.chord_revision_id = i.chord), "number" == typeof (null == i ? void 0 : i.beat) && (e.beat_revision_id = i.beat), "number" == typeof (null == i ? void 0 : i.chorus) && (e.chorus_revision_id = i.chorus), [
                            4,
                            $af62ec6a841e10b9$var$b("".concat(this.songleEndpoint, "/songs/").concat(t, "/info.json"), e)
                        ];
                    case 1:
                        return (r = o.sent()) && 200 === r.status ? [
                            2,
                            r.data
                        ] : [
                            2,
                            null
                        ];
                }
            });
        });
    }, t.prototype.loadVocalAmplitude = function(t) {
        return $af62ec6a841e10b9$var$g(this, 0, void 0, function() {
            var e;
            return $af62ec6a841e10b9$var$v(this, function(r) {
                switch(r.label){
                    case 0:
                        return [
                            4,
                            $af62ec6a841e10b9$var$b("".concat(this.songleEndpoint, "/songs/").concat(t, "/vamplitude.json"))
                        ];
                    case 1:
                        return (e = r.sent()) && 200 === e.status && e.data ? [
                            2,
                            e.data
                        ] : [
                            2,
                            null
                        ];
                }
            });
        });
    }, t.prototype.loadValenceArousal = function(t) {
        return $af62ec6a841e10b9$var$g(this, 0, void 0, function() {
            var e;
            return $af62ec6a841e10b9$var$v(this, function(r) {
                switch(r.label){
                    case 0:
                        return [
                            4,
                            $af62ec6a841e10b9$var$b("".concat(this.songleEndpoint, "/songs/").concat(t, "/av.json"))
                        ];
                    case 1:
                        return (e = r.sent()) && 200 === e.status && e.data ? [
                            2,
                            e.data
                        ] : [
                            2,
                            null
                        ];
                }
            });
        });
    }, t.prototype.list = function(t) {
        return void 0 === t && (t = {}), $af62ec6a841e10b9$var$g(this, 0, void 0, function() {
            var e;
            return $af62ec6a841e10b9$var$v(this, function(r) {
                switch(r.label){
                    case 0:
                        return [
                            4,
                            $af62ec6a841e10b9$var$b(this.endpoint + "/songs", t)
                        ];
                    case 1:
                        return (e = r.sent()) && 200 === e.status ? [
                            2,
                            e.data
                        ] : [
                            2,
                            null
                        ];
                }
            });
        });
    }, t.prototype.listPrivate = function(t) {
        return void 0 === t && (t = {}), $af62ec6a841e10b9$var$g(this, 0, void 0, function() {
            var e, r, n, i, o, s, a;
            return $af62ec6a841e10b9$var$v(this, function(u) {
                switch(u.label){
                    case 0:
                        return [
                            4,
                            $af62ec6a841e10b9$var$A.getProfile()
                        ];
                    case 1:
                        return e = u.sent(), $af62ec6a841e10b9$var$A.isSongleUser(e) ? (r = {}, $af62ec6a841e10b9$var$A.isSpoofingSongleUser(e) && (n = e.user, i = n.songleUserId, o = n.songleAccessToken, s = n.songleRefreshToken, r = {
                            songleUserId: i,
                            songleAccessToken: o,
                            songleRefreshToken: s
                        }), "number" == typeof t.page && (r.page = t.page), "number" == typeof t.perPage && (r.per_page = t.perPage), [
                            4,
                            $af62ec6a841e10b9$var$b("".concat(this.endpoint, "/songle/me/songs.json"), $af62ec6a841e10b9$var$y($af62ec6a841e10b9$var$y({}, r), {
                                private: !0
                            }), {
                                withCredentials: !0
                            })
                        ]) : [
                            2,
                            {
                                data: null,
                                error: "Songle authentication is required"
                            }
                        ];
                    case 2:
                        return (a = u.sent()) && 200 === a.status ? [
                            2,
                            a.data
                        ] : [
                            2,
                            {
                                data: null,
                                error: "private songs not found"
                            }
                        ];
                }
            });
        });
    }, t.prototype.create = function(t) {
        return $af62ec6a841e10b9$var$g(this, 0, void 0, function() {
            return $af62ec6a841e10b9$var$v(this, function(e) {
                return [
                    2,
                    this.doCreate(t, !1)
                ];
            });
        });
    }, t.prototype.createPrivate = function(t) {
        return $af62ec6a841e10b9$var$g(this, 0, void 0, function() {
            var e;
            return $af62ec6a841e10b9$var$v(this, function(r) {
                switch(r.label){
                    case 0:
                        return [
                            4,
                            $af62ec6a841e10b9$var$A.getProfile()
                        ];
                    case 1:
                        return e = r.sent(), $af62ec6a841e10b9$var$A.isSongleUser(e) ? [
                            2,
                            this.doCreate(t, !0)
                        ] : [
                            2,
                            {
                                success: !1,
                                song: null,
                                error: "Songle authentication is required"
                            }
                        ];
                }
            });
        });
    }, t.prototype.doCreate = function(t, e) {
        var r, n;
        return $af62ec6a841e10b9$var$g(this, 0, void 0, function() {
            var i, o, s, a, u;
            return $af62ec6a841e10b9$var$v(this, function(c) {
                switch(c.label){
                    case 0:
                        return i = t.url, o = t.name, s = t.artistName, [
                            4,
                            $af62ec6a841e10b9$var$A.getToken()
                        ];
                    case 1:
                        return a = c.sent(), [
                            4,
                            $af62ec6a841e10b9$var$P(e ? this.endpoint + "/etc/songs/private" : this.endpoint + "/etc/songs", {
                                url: i,
                                name: o,
                                artist: s
                            }, {
                                postToken: a,
                                withCredentials: !0
                            })
                        ];
                    case 2:
                        return (u = c.sent()) && 200 === u.status ? e ? [
                            2,
                            {
                                success: !0,
                                song: u.data.data.song
                            }
                        ] : [
                            2,
                            {
                                success: !0,
                                song: u.data.song
                            }
                        ] : [
                            2,
                            {
                                success: !1,
                                error: ((null === (r = null == u ? void 0 : u.data) || void 0 === r ? void 0 : r.data) ? u.data.data.message : null === (n = null == u ? void 0 : u.data) || void 0 === n ? void 0 : n.message) || "failed to register a song"
                            }
                        ];
                }
            });
        });
    }, t.prototype.uploadPrivate = function(t) {
        return $af62ec6a841e10b9$var$g(this, 0, void 0, function() {
            var e, r, n, i, o, s, a, u, c;
            return $af62ec6a841e10b9$var$v(this, function(l) {
                switch(l.label){
                    case 0:
                        return [
                            4,
                            $af62ec6a841e10b9$var$A.getProfile()
                        ];
                    case 1:
                        if (e = l.sent(), !$af62ec6a841e10b9$var$A.isSongleUser(e)) throw new Error("Songle authentication is required");
                        return $af62ec6a841e10b9$var$A.isSpoofingSongleUser(e) ? (n = e.user, i = n.songleUserId, o = n.songleAccessToken, s = n.songleRefreshToken, a = {
                            songleUserId: i,
                            songleAccessToken: o,
                            songleRefreshToken: s
                        }, r = "?" + Object.keys(a).map(function(t) {
                            return "".concat(t, "=").concat(encodeURIComponent(a[t]));
                        }).join("&")) : r = "", (u = new FormData).append("file", t), [
                            4,
                            $af62ec6a841e10b9$var$P("".concat(this.endpoint, "/songle/me/uploads.json").concat(r), u, {
                                withCredentials: !0
                            })
                        ];
                    case 2:
                        return (c = l.sent()) && 200 === c.status && c.data ? [
                            2,
                            c.data.data
                        ] : [
                            2,
                            null
                        ];
                }
            });
        });
    }, t.prototype.search = function(t, e) {
        return void 0 === e && (e = !0), $af62ec6a841e10b9$var$g(this, 0, void 0, function() {
            var r;
            return $af62ec6a841e10b9$var$v(this, function(n) {
                switch(n.label){
                    case 0:
                        return [
                            4,
                            $af62ec6a841e10b9$var$b("".concat(this.songleEndpoint, "/songs/search.json"), {
                                q: t,
                                lyrics: e ? 1 : 0
                            })
                        ];
                    case 1:
                        return (r = n.sent()) && 200 === r.status && r.data ? [
                            2,
                            {
                                success: !0,
                                data: r.data
                            }
                        ] : [
                            2,
                            {
                                success: !1
                            }
                        ];
                }
            });
        });
    }, t.prototype.copySongMap = function(t) {
        var e;
        return $af62ec6a841e10b9$var$g(this, 0, void 0, function() {
            var r, n, i, o;
            return $af62ec6a841e10b9$var$v(this, function(s) {
                switch(s.label){
                    case 0:
                        return r = t.sourceId, n = t.destinationId, i = t.types || [
                            "beat",
                            "chord",
                            "chorus",
                            "melody"
                        ], [
                            4,
                            $af62ec6a841e10b9$var$P("".concat(this.endpoint, "/songle/me/songs/").concat(n, "/actions/copy_music_map.json"), {
                                source_id: r,
                                types: i
                            }, {
                                withCredentials: !0
                            })
                        ];
                    case 1:
                        return (o = s.sent()) && (null === (e = o.data) || void 0 === e ? void 0 : e.success) ? [
                            2,
                            {
                                success: !0
                            }
                        ] : [
                            2,
                            {
                                success: !1,
                                error: null == o ? void 0 : o.data
                            }
                        ];
                }
            });
        });
    }, t.prototype.createStage = function() {
        var t;
        return $af62ec6a841e10b9$var$g(this, 0, void 0, function() {
            var e, r;
            return $af62ec6a841e10b9$var$v(this, function(n) {
                switch(n.label){
                    case 0:
                        return [
                            4,
                            $af62ec6a841e10b9$var$A.getProfile()
                        ];
                    case 1:
                        return e = n.sent(), [
                            4,
                            $af62ec6a841e10b9$var$P("".concat(this.endpoint, "/etc/songs/stage"), null, {
                                postToken: null === (t = null == e ? void 0 : e.status) || void 0 === t ? void 0 : t.token,
                                withCredentials: !0
                            })
                        ];
                    case 2:
                        return [
                            2,
                            (null == (r = n.sent()) ? void 0 : r.data) || null
                        ];
                }
            });
        });
    }, t;
}()), $af62ec6a841e10b9$var$G = function() {
    function t() {}
    return Object.defineProperty(t.prototype, "endpoint", {
        get: function() {
            return "".concat($af62ec6a841e10b9$var$m.textalive.server, "/templates/");
        },
        enumerable: !1,
        configurable: !0
    }), t.prototype.list = function(t) {
        return $af62ec6a841e10b9$var$g(this, 0, void 0, function() {
            var e;
            return $af62ec6a841e10b9$var$v(this, function(r) {
                switch(r.label){
                    case 0:
                        return [
                            4,
                            $af62ec6a841e10b9$var$b("".concat(this.endpoint), t)
                        ];
                    case 1:
                        return (e = r.sent()) && 200 === e.status ? [
                            2,
                            e.data
                        ] : [
                            2,
                            null
                        ];
                }
            });
        });
    }, t.prototype.load = function(t) {
        return $af62ec6a841e10b9$var$g(this, 0, void 0, function() {
            var e;
            return $af62ec6a841e10b9$var$v(this, function(r) {
                switch(r.label){
                    case 0:
                        return [
                            4,
                            $af62ec6a841e10b9$var$b("".concat(this.endpoint + t))
                        ];
                    case 1:
                        return (e = r.sent()) && 200 === e.status ? [
                            2,
                            e.data
                        ] : [
                            2,
                            null
                        ];
                }
            });
        });
    }, t.prototype.loadByName = function(t) {
        return $af62ec6a841e10b9$var$g(this, 0, void 0, function() {
            var e, r, n;
            return $af62ec6a841e10b9$var$v(this, function(i) {
                switch(i.label){
                    case 0:
                        return r = "latest", t && (e = t.match(/(.+)@([0-9]+)/)) && (t = e[1], r = e[2]), [
                            4,
                            $af62ec6a841e10b9$var$b("".concat(this.endpoint + t, "/").concat(r))
                        ];
                    case 1:
                        return (n = i.sent()) && 200 === n.status ? [
                            2,
                            n.data
                        ] : "latest" !== r ? [
                            2,
                            this.loadByName(t)
                        ] : [
                            2,
                            null
                        ];
                }
            });
        });
    }, t.prototype.loadForVideo = function(t, e) {
        return void 0 === e && (e = {
            script: !0,
            withoutAuthors: !0
        }), $af62ec6a841e10b9$var$g(this, 0, void 0, function() {
            var r;
            return $af62ec6a841e10b9$var$v(this, function(n) {
                switch(n.label){
                    case 0:
                        return [
                            4,
                            $af62ec6a841e10b9$var$b("".concat(this.endpoint, "for/").concat(t), e)
                        ];
                    case 1:
                        return (r = n.sent()) && 200 === r.status ? [
                            2,
                            r.data
                        ] : [
                            2,
                            null
                        ];
                }
            });
        });
    }, t.prototype.create = function(t) {
        return $af62ec6a841e10b9$var$g(this, 0, void 0, function() {
            var e, r, n;
            return $af62ec6a841e10b9$var$v(this, function(i) {
                switch(i.label){
                    case 0:
                        return [
                            4,
                            $af62ec6a841e10b9$var$A.getToken()
                        ];
                    case 1:
                        return e = i.sent(), [
                            4,
                            $af62ec6a841e10b9$var$P(this.endpoint, t, {
                                postToken: e,
                                withCredentials: !0
                            })
                        ];
                    case 2:
                        return (r = i.sent()) ? 200 !== r.status || Array.isArray(r.data) || r.data.error ? (n = Array.isArray(r.data) ? {
                            parseErrors: r.data
                        } : r.data, [
                            2,
                            $af62ec6a841e10b9$var$y($af62ec6a841e10b9$var$y({}, n), {
                                success: !1
                            })
                        ]) : [
                            2,
                            $af62ec6a841e10b9$var$y($af62ec6a841e10b9$var$y({}, r.data), {
                                success: !0
                            })
                        ] : [
                            2,
                            {
                                success: !1
                            }
                        ];
                }
            });
        });
    }, t.prototype.listContributors = function(t, e) {
        return $af62ec6a841e10b9$var$g(this, 0, void 0, function() {
            var r;
            return $af62ec6a841e10b9$var$v(this, function(n) {
                switch(n.label){
                    case 0:
                        return [
                            4,
                            $af62ec6a841e10b9$var$b("".concat(this.endpoint).concat(t, "/").concat(e, "/contributors"))
                        ];
                    case 1:
                        return (r = n.sent()) && 200 === r.status ? [
                            2,
                            r.data
                        ] : [
                            2,
                            null
                        ];
                }
            });
        });
    }, t;
}(), $af62ec6a841e10b9$var$q = new $af62ec6a841e10b9$var$G, $af62ec6a841e10b9$var$W = new (function() {
    function t() {}
    return Object.defineProperty(t.prototype, "endpoint", {
        get: function() {
            return "".concat($af62ec6a841e10b9$var$m.textalive.server, "/videos/");
        },
        enumerable: !1,
        configurable: !0
    }), Object.defineProperty(t.prototype, "rendererEndpoint", {
        get: function() {
            return "".concat($af62ec6a841e10b9$var$m.textalive.server, "/renderer/");
        },
        enumerable: !1,
        configurable: !0
    }), t.prototype.list = function(t) {
        return $af62ec6a841e10b9$var$g(this, 0, void 0, function() {
            var e;
            return $af62ec6a841e10b9$var$v(this, function(r) {
                switch(r.label){
                    case 0:
                        return [
                            4,
                            $af62ec6a841e10b9$var$b("".concat(this.endpoint), t)
                        ];
                    case 1:
                        return (e = r.sent()) && 200 === e.status ? [
                            2,
                            e.data
                        ] : [
                            2,
                            null
                        ];
                }
            });
        });
    }, t.prototype.load = function(t) {
        return $af62ec6a841e10b9$var$g(this, 0, void 0, function() {
            var e, r, n, i, o, s, a;
            return $af62ec6a841e10b9$var$v(this, function(u) {
                switch(u.label){
                    case 0:
                        return e = {}, [
                            4,
                            $af62ec6a841e10b9$var$A.getProfile()
                        ];
                    case 1:
                        return r = u.sent(), $af62ec6a841e10b9$var$A.isSpoofingSongleUser(r) && (n = r.user, i = n.songleUserId, o = n.songleAccessToken, s = n.songleRefreshToken, e = {
                            songleUserId: i,
                            songleAccessToken: o,
                            songleRefreshToken: s
                        }), [
                            4,
                            $af62ec6a841e10b9$var$b("".concat(this.endpoint + t), e, {
                                withCredentials: !0
                            })
                        ];
                    case 2:
                        return (a = u.sent()) && 200 === a.status ? [
                            2,
                            a.data
                        ] : [
                            2,
                            null
                        ];
                }
            });
        });
    }, t.prototype.create = function(t) {
        return $af62ec6a841e10b9$var$g(this, 0, void 0, function() {
            var e, r;
            return $af62ec6a841e10b9$var$v(this, function(n) {
                switch(n.label){
                    case 0:
                        return [
                            4,
                            $af62ec6a841e10b9$var$A.getToken()
                        ];
                    case 1:
                        return e = n.sent(), [
                            4,
                            $af62ec6a841e10b9$var$P(this.endpoint, t, {
                                postToken: e,
                                withCredentials: !0
                            })
                        ];
                    case 2:
                        return (r = n.sent()) ? 200 !== r.status || r.data.error ? [
                            2,
                            $af62ec6a841e10b9$var$y($af62ec6a841e10b9$var$y({}, r.data), {
                                success: !1
                            })
                        ] : [
                            2,
                            $af62ec6a841e10b9$var$y($af62ec6a841e10b9$var$y({}, r.data), {
                                success: !0
                            })
                        ] : [
                            2,
                            {
                                success: !1
                            }
                        ];
                }
            });
        });
    }, t.prototype.delete = function(t) {
        return $af62ec6a841e10b9$var$g(this, 0, void 0, function() {
            var e, r;
            return $af62ec6a841e10b9$var$v(this, function(n) {
                switch(n.label){
                    case 0:
                        return [
                            4,
                            $af62ec6a841e10b9$var$A.getToken()
                        ];
                    case 1:
                        return e = n.sent(), [
                            4,
                            $af62ec6a841e10b9$var$P("".concat(this.endpoint, "delete"), {
                                id: t
                            }, {
                                postToken: e,
                                withCredentials: !0
                            })
                        ];
                    case 2:
                        return (r = n.sent()) && 200 === r.status ? [
                            2,
                            {
                                success: !0,
                                video: r.data
                            }
                        ] : [
                            2,
                            {
                                success: !1,
                                video: null
                            }
                        ];
                }
            });
        });
    }, t.prototype.listContributors = function(t) {
        return $af62ec6a841e10b9$var$g(this, 0, void 0, function() {
            var e;
            return $af62ec6a841e10b9$var$v(this, function(r) {
                switch(r.label){
                    case 0:
                        return [
                            4,
                            $af62ec6a841e10b9$var$b("".concat(this.endpoint).concat(t, "/contributors"), null, {
                                withCredentials: !0
                            })
                        ];
                    case 1:
                        return (e = r.sent()) && 200 === e.status ? [
                            2,
                            e.data
                        ] : [
                            2,
                            null
                        ];
                }
            });
        });
    }, t.prototype.listRenderings = function(t) {
        return $af62ec6a841e10b9$var$g(this, 0, void 0, function() {
            var e;
            return $af62ec6a841e10b9$var$v(this, function(r) {
                switch(r.label){
                    case 0:
                        return [
                            4,
                            $af62ec6a841e10b9$var$b("".concat(this.rendererEndpoint, "list"), {
                                videoId: t
                            }, {
                                withCredentials: !0
                            })
                        ];
                    case 1:
                        return (e = r.sent()) && 200 === e.status ? [
                            2,
                            e.data
                        ] : [
                            2,
                            null
                        ];
                }
            });
        });
    }, t.prototype.getRenderingStatus = function(t) {
        return $af62ec6a841e10b9$var$g(this, 0, void 0, function() {
            var e;
            return $af62ec6a841e10b9$var$v(this, function(r) {
                switch(r.label){
                    case 0:
                        return [
                            4,
                            $af62ec6a841e10b9$var$b("".concat(this.rendererEndpoint, "status"), {
                                id: t
                            }, {
                                withCredentials: !0
                            })
                        ];
                    case 1:
                        return (e = r.sent()) && 200 === e.status ? [
                            2,
                            e.data
                        ] : [
                            2,
                            null
                        ];
                }
            });
        });
    }, t.prototype.render = function(t, e, r) {
        return $af62ec6a841e10b9$var$g(this, 0, void 0, function() {
            var n, i, o;
            return $af62ec6a841e10b9$var$v(this, function(s) {
                switch(s.label){
                    case 0:
                        return [
                            4,
                            $af62ec6a841e10b9$var$A.getToken()
                        ];
                    case 1:
                        return n = s.sent(), i = {
                            token: n,
                            videoId: t,
                            quality: e
                        }, r && (i.authentication = !0), [
                            4,
                            $af62ec6a841e10b9$var$P("".concat(this.rendererEndpoint, "render"), i, {
                                withCredentials: !0
                            })
                        ];
                    case 2:
                        return (o = s.sent()) && 200 === o.status ? [
                            2,
                            o.data
                        ] : [
                            2,
                            null
                        ];
                }
            });
        });
    }, t.prototype.getDownloadInfo = function() {
        return $af62ec6a841e10b9$var$g(this, 0, void 0, function() {
            var t;
            return $af62ec6a841e10b9$var$v(this, function(e) {
                switch(e.label){
                    case 0:
                        return t = {
                            endpoint: "".concat(this.rendererEndpoint, "download")
                        }, [
                            4,
                            $af62ec6a841e10b9$var$A.getToken()
                        ];
                    case 1:
                        return [
                            2,
                            (t.token = e.sent(), t)
                        ];
                }
            });
        });
    }, t;
}()), $af62ec6a841e10b9$var$Y = {
    asset: $af62ec6a841e10b9$var$w,
    endpoint: $af62ec6a841e10b9$var$m,
    lyrics: $af62ec6a841e10b9$var$D,
    song: $af62ec6a841e10b9$var$V,
    template: $af62ec6a841e10b9$var$q,
    text: $af62ec6a841e10b9$var$R,
    font: $af62ec6a841e10b9$var$C,
    user: $af62ec6a841e10b9$var$A,
    video: $af62ec6a841e10b9$var$W
}, $af62ec6a841e10b9$var$z = function(t, e) {
    return $af62ec6a841e10b9$var$z = Object.setPrototypeOf || ({
        __proto__: []
    }) instanceof Array && function(t, e) {
        t.__proto__ = e;
    } || function(t, e) {
        for(var r in e)Object.prototype.hasOwnProperty.call(e, r) && (t[r] = e[r]);
    }, $af62ec6a841e10b9$var$z(t, e);
};
function $af62ec6a841e10b9$var$J(t, e) {
    if ("function" != typeof e && null !== e) throw new TypeError("Class extends value " + String(e) + " is not a constructor or null");
    function r() {
        this.constructor = t;
    }
    $af62ec6a841e10b9$var$z(t, e), t.prototype = null === e ? Object.create(e) : (r.prototype = e.prototype, new r);
}
function $af62ec6a841e10b9$var$H(t, e, r) {
    if (2 === arguments.length) for(var n, i = 0, o = e.length; i < o; i++)!n && i in e || (n || (n = Array.prototype.slice.call(e, 0, i)), n[i] = e[i]);
    return t.concat(n || Array.prototype.slice.call(e));
}
"function" == typeof SuppressedError && SuppressedError;
var $af62ec6a841e10b9$export$892596cec99bc70e = function() {
    function t(t) {
        this.a = 0, this.r = 0, this.g = 0, this.b = 0, this.from(t);
    }
    return Object.defineProperty(t.prototype, "value", {
        get: function() {
            return this.valueArgb;
        },
        set: function(t) {
            this.fromNumber(t, !0);
        },
        enumerable: !1,
        configurable: !0
    }), Object.defineProperty(t.prototype, "valueArgb", {
        get: function() {
            return this.valueRgb + 16777216 * (255 & this.a);
        },
        enumerable: !1,
        configurable: !0
    }), Object.defineProperty(t.prototype, "valueRgb", {
        get: function() {
            return ((255 & this.r) << 8 | 255 & this.g) << 8 | 255 & this.b;
        },
        enumerable: !1,
        configurable: !0
    }), Object.defineProperty(t.prototype, "hexRgb", {
        get: function() {
            return ("000000" + (16777215 & this.value).toString(16)).slice(-6);
        },
        enumerable: !1,
        configurable: !0
    }), Object.defineProperty(t.prototype, "hexA", {
        get: function() {
            return ("00" + (255 & this.a).toString(16)).slice(-2);
        },
        enumerable: !1,
        configurable: !0
    }), Object.defineProperty(t.prototype, "rgb", {
        get: function() {
            return "#".concat(this.hexRgb);
        },
        enumerable: !1,
        configurable: !0
    }), Object.defineProperty(t.prototype, "cssRgb", {
        get: function() {
            return "rgb(" + this.r + "," + this.g + "," + this.b + ")";
        },
        enumerable: !1,
        configurable: !0
    }), Object.defineProperty(t.prototype, "rgba", {
        get: function() {
            return "".concat(this.rgb).concat(this.hexA);
        },
        enumerable: !1,
        configurable: !0
    }), Object.defineProperty(t.prototype, "argb", {
        get: function() {
            return "0x".concat(this.hexA).concat(this.rgb.substring(1));
        },
        enumerable: !1,
        configurable: !0
    }), Object.defineProperty(t.prototype, "cssRgba", {
        get: function() {
            return "rgba(" + this.r + "," + this.g + "," + this.b + "," + this.a / 255 + ")";
        },
        enumerable: !1,
        configurable: !0
    }), t.prototype.eq = function(e) {
        return typeof this == typeof e && e instanceof t && this.value === e.value;
    }, t.prototype.toString = function(t) {
        return void 0 === t && (t = !0), t ? this.rgba : this.rgb;
    }, t.prototype.from = function(t) {
        if (void 0 === t && (t = "#000"), "object" == typeof t) {
            if (!t) return;
            return "number" == typeof t.value ? void (this.value = t.value) : "number" == typeof t.r && "number" == typeof t.g && "number" == typeof t.b ? (this.a = "number" == typeof t.a ? t.a : 255, this.r = t.r, this.g = t.g, void (this.b = t.b)) : void 0;
        }
        "string" == typeof t ? this.fromString(t) : "number" == typeof t && this.fromNumber(t);
    }, t.prototype.fromString = function(t) {
        if (t) {
            if ("#" === t.charAt(0) && (t = t.substring(1)), 4 === t.length) {
                var e = t.charAt(0), r = t.charAt(1), n = t.charAt(2), i = t.charAt(3);
                t = "".concat(e).concat(e).concat(r).concat(r).concat(n).concat(n).concat(i).concat(i);
            } else 3 === t.length && (e = t.charAt(0), r = t.charAt(1), n = t.charAt(2), t = "".concat(e).concat(e).concat(r).concat(r).concat(n).concat(n)), 6 === t.length && (t = "".concat(t, "ff"));
            var o = parseInt("".concat(t.substring(6)).concat(t.substring(0, 6)), 16);
            this.fromNumber(o, !0);
        }
    }, t.prototype.fromNumber = function(t, e) {
        void 0 === e && (e = !0), isNaN(t) || (this.a = e ? t >>> 24 & 255 : 0, this.r = t >>> 16 & 255, this.g = t >>> 8 & 255, this.b = t >>> 0 & 255);
    }, t;
}();
var $af62ec6a841e10b9$var$Z = function() {
    function t(t, e, r) {
        void 0 === t && (t = "Noto Sans Japanese"), void 0 === e && (e = 40), void 0 === r && (r = ""), this._family = t, this._size = e, this._style = r;
    }
    return Object.defineProperty(t.prototype, "family", {
        get: function() {
            return this._family;
        },
        enumerable: !1,
        configurable: !0
    }), Object.defineProperty(t.prototype, "size", {
        get: function() {
            return this._size;
        },
        enumerable: !1,
        configurable: !0
    }), Object.defineProperty(t.prototype, "style", {
        get: function() {
            return this._style;
        },
        enumerable: !1,
        configurable: !0
    }), t.prototype.deriveFamily = function(e) {
        return new t(e, this._size, this._style);
    }, t.prototype.deriveStyle = function(e) {
        return new t(this._family, this._size, e);
    }, t.prototype.deriveSize = function(e) {
        return new t(this._family, e, this._style);
    }, t.prototype.clone = function() {
        return new t(this._family, this._size, this._style);
    }, t.prototype.eq = function(t) {
        return this._family === t._family && this._size === t._size && this._style === t._style;
    }, t.prototype.toString = function(t) {
        void 0 === t && (t = 1);
        var e, r = function(t) {
            if (!t || t.length <= 0) return [];
            for(var e = [], r = "", n = !1, i = !1, o = !1, s = 0, a = t; s < a.length; s++){
                var u = a[s];
                if (i ? o ? o = !1 : "\\" === u ? o = !0 : u === i && (i = !1) : '"' === u || "'" === u ? i = u : "," === u && (n = !0), n) {
                    var c = r.trim();
                    "" !== c && e.push(c), r = "", n = !1;
                } else r += u;
            }
            var l = r.trim();
            return "" !== l && e.push(l), e;
        }(this._family);
        return e = r.length < 1 ? "" : r.length > 1 ? " " + r.join(", ") : (e = r[0]).length > 1 && e[0] !== e[e.length - 1] || "'" !== e[0] && '"' !== e[0] ? " '".concat(e, "'") : " ".concat(e), this._style + (this._style.length > 0 ? " " : "") + this._size * t + "px" + e;
    }, t;
}(), $af62ec6a841e10b9$export$52786b6f4da3c973 = function() {
    function t() {}
    return Object.defineProperty(t.prototype, "duration", {
        get: function() {
            return this.endTime - this.startTime;
        },
        enumerable: !1,
        configurable: !0
    }), t.prototype.contains = function(t) {
        return t >= this.startTime && t <= this.endTime;
    }, t.prototype.overlaps = function(t, e) {
        if ("object" == typeof t) return this.overlaps(t.startTime, t.endTime);
        var r = t;
        return this.contains(r) || this.contains(e) || this.startTime <= r && this.endTime >= e;
    }, t.prototype.progress = function(t) {
        return this.contains(t) ? (t - this.startTime) / this.duration : -1;
    }, t;
}(), $af62ec6a841e10b9$var$K = function(t) {
    function e() {
        var e = null !== t && t.apply(this, arguments) || this;
        return e._parent = null, e._children = [], e._previous = null, e._next = null, e._runtime = null, e._templates = [], e;
    }
    return $af62ec6a841e10b9$var$J(e, t), Object.defineProperty(e.prototype, "video", {
        get: function() {
            return this.parent && this.parent.video;
        },
        enumerable: !1,
        configurable: !0
    }), Object.defineProperty(e.prototype, "parent", {
        get: function() {
            return this._parent;
        },
        enumerable: !1,
        configurable: !0
    }), Object.defineProperty(e.prototype, "children", {
        get: function() {
            return this._children;
        },
        enumerable: !1,
        configurable: !0
    }), Object.defineProperty(e.prototype, "previous", {
        get: function() {
            return this._previous;
        },
        enumerable: !1,
        configurable: !0
    }), Object.defineProperty(e.prototype, "next", {
        get: function() {
            return this._next;
        },
        enumerable: !1,
        configurable: !0
    }), Object.defineProperty(e.prototype, "startTime", {
        get: function() {
            return this._data ? this._data.startTime : 0;
        },
        enumerable: !1,
        configurable: !0
    }), Object.defineProperty(e.prototype, "endTime", {
        get: function() {
            return this._data ? this._data.endTime : 0;
        },
        enumerable: !1,
        configurable: !0
    }), Object.defineProperty(e.prototype, "duration", {
        get: function() {
            return this.endTime - this.startTime;
        },
        enumerable: !1,
        configurable: !0
    }), Object.defineProperty(e.prototype, "rendering", {
        get: function() {
            return this._runtime ? this._runtime.rendering : null;
        },
        enumerable: !1,
        configurable: !0
    }), Object.defineProperty(e.prototype, "graphics", {
        get: function() {
            return this._runtime ? this._runtime.graphics : null;
        },
        enumerable: !1,
        configurable: !0
    }), Object.defineProperty(e.prototype, "templates", {
        get: function() {
            return this._templates.slice();
        },
        enumerable: !1,
        configurable: !0
    }), Object.defineProperty(e.prototype, "templateCount", {
        get: function() {
            return this._templates.length;
        },
        enumerable: !1,
        configurable: !0
    }), e.prototype.maximize = function() {
        var t = !1, e = this.endTime, r = Math.max(null === this._parent ? 0 : this._parent.startTime, null === this._previous ? 0 : this._previous.endTime);
        r !== this.startTime && (this.moveWithChildren(r - this.startTime), t = !0);
        var n = Math.min(null === this._parent ? this.video.duration : this._parent.endTime, null === this._next ? this.video.duration : this._next.startTime);
        return n !== this.endTime && (this._data.endTime = n, t = e !== n), t;
    }, e.prototype.moveWithChildren = function(t) {
        var e = [];
        for(e.push(this); e.length > 0;){
            var r = e.pop();
            null != r._children && r._children.forEach(function(t) {
                return e.push(t);
            }), r._data.startTime += t, r._data.endTime += t;
        }
    }, e.prototype.getTemplate = function(t) {
        return void 0 === t && (t = 0), t < 0 || t >= this._templates.length ? null : this._templates[t];
    }, e.prototype.addTemplateAt = function(t, e) {
        this._templates.splice(e, 0, t), t.assignedUnit = this;
    }, e.prototype.addTemplate = function(t) {
        this._templates.push(t), t.assignedUnit = this;
    }, e.prototype.removeTemplates = function() {
        for(var t = this._templates.slice(); this._templates.length > 0;)this._templates.pop();
        return t;
    }, e.prototype.removeTemplateAt = function(t) {
        if (t < 0 || t >= this._templates.length) return null;
        var e = this._templates.splice(t, 1)[0];
        return e.assignedUnit = null, e;
    }, e.prototype.removeTemplate = function(t) {
        for(var e = 0; e < this._templates.length; e++){
            var r = this._templates[e];
            if (r === t) return this._templates.splice(e, 1), t.assignedUnit = null, r;
        }
        return null;
    }, e.prototype.getType = function() {
        return $af62ec6a841e10b9$export$6ba26ae1c58c0147.NONE;
    }, e.prototype.toString = function() {
        return "RenderingUnit";
    }, e;
}($af62ec6a841e10b9$export$52786b6f4da3c973);
function $af62ec6a841e10b9$var$Q(t, e) {
    return "number" == typeof e && !isNaN(e) && e > t ? e : t;
}
function $af62ec6a841e10b9$var$tt(t, e) {
    return "number" == typeof e && !isNaN(e) && e < t ? e : t;
}
var $af62ec6a841e10b9$var$et = function(t) {
    function e() {
        return null !== t && t.apply(this, arguments) || this;
    }
    return $af62ec6a841e10b9$var$J(e, t), Object.defineProperty(e.prototype, "text", {
        get: function() {
            var t = "";
            return this.children.forEach(function(e) {
                t += e.text;
            }), t;
        },
        enumerable: !1,
        configurable: !0
    }), Object.defineProperty(e.prototype, "color", {
        get: function() {
            return this.children.reduce(function(t, e) {
                return null === t ? e.color : void 0 === t || t.eq(e.color) ? t : void 0;
            }, null);
        },
        set: function(t) {
            null !== t && this.children.forEach(function(e) {
                e.color = t;
            });
        },
        enumerable: !1,
        configurable: !0
    }), Object.defineProperty(e.prototype, "font", {
        set: function(t) {
            null !== t && this.children.forEach(function(e) {
                e.font = t;
            });
        },
        enumerable: !1,
        configurable: !0
    }), Object.defineProperty(e.prototype, "fontFamily", {
        get: function() {
            return this.children.reduce(function(t, e) {
                var r = e.fontFamily;
                return void 0 === t || null !== t && t !== r ? void 0 : r;
            }, null);
        },
        set: function(t) {
            this.children.forEach(function(e) {
                e.fontFamily = t;
            });
        },
        enumerable: !1,
        configurable: !0
    }), Object.defineProperty(e.prototype, "fontStyle", {
        get: function() {
            return this.children.reduce(function(t, e) {
                var r = e.fontStyle;
                return void 0 === t || null !== t && t !== r ? void 0 : r;
            }, null);
        },
        set: function(t) {
            this.children.forEach(function(e) {
                e.fontStyle = t;
            });
        },
        enumerable: !1,
        configurable: !0
    }), Object.defineProperty(e.prototype, "fontSize", {
        get: function() {
            return this.children.length <= 0 ? 0 : this.children.reduce(function(t, e) {
                return t + e.fontSize;
            }, 0) / this.children.length;
        },
        set: function(t) {
            this.children.forEach(function(e) {
                e.fontSize = t;
            });
        },
        enumerable: !1,
        configurable: !0
    }), Object.defineProperty(e.prototype, "advance", {
        get: function() {
            return this.children.reduce(function(t, e) {
                return t + e.advance;
            }, 0);
        },
        enumerable: !1,
        configurable: !0
    }), Object.defineProperty(e.prototype, "ascent", {
        get: function() {
            return this.children.reduce(function(t, e) {
                return Math.max(t, e.ascent);
            }, 0);
        },
        enumerable: !1,
        configurable: !0
    }), Object.defineProperty(e.prototype, "descent", {
        get: function() {
            return this.children.reduce(function(t, e) {
                return Math.max(t, e.descent);
            }, 0);
        },
        enumerable: !1,
        configurable: !0
    }), Object.defineProperty(e.prototype, "height", {
        get: function() {
            return this.ascent + this.descent;
        },
        enumerable: !1,
        configurable: !0
    }), e.prototype.expandTime = function(t) {
        return {
            startTime: $af62ec6a841e10b9$var$tt(this.startTime, t.startTime),
            endTime: $af62ec6a841e10b9$var$Q(this.endTime, t.endTime)
        };
    }, e.prototype.toString = function() {
        return this.text;
    }, e;
}($af62ec6a841e10b9$var$K), $af62ec6a841e10b9$var$rt = function(t) {
    function e(e) {
        var r = t.call(this) || this;
        return r._data = e, r._font = new $af62ec6a841e10b9$var$Z(e && e.fontFamily, e && e.fontSize, e && e.fontStyle), r._color = new $af62ec6a841e10b9$export$892596cec99bc70e, r;
    }
    return $af62ec6a841e10b9$var$J(e, t), Object.defineProperty(e.prototype, "parent", {
        get: function() {
            return this._parent;
        },
        enumerable: !1,
        configurable: !0
    }), Object.defineProperty(e.prototype, "previous", {
        get: function() {
            return this._previous;
        },
        enumerable: !1,
        configurable: !0
    }), Object.defineProperty(e.prototype, "next", {
        get: function() {
            return this._next;
        },
        enumerable: !1,
        configurable: !0
    }), Object.defineProperty(e.prototype, "text", {
        get: function() {
            return this._data && this._data.char || "?";
        },
        enumerable: !1,
        configurable: !0
    }), Object.defineProperty(e.prototype, "advance", {
        get: function() {
            return this._runtime ? this._runtime.advance : 0;
        },
        enumerable: !1,
        configurable: !0
    }), Object.defineProperty(e.prototype, "ascent", {
        get: function() {
            return this._runtime ? this._runtime.ascent : 0;
        },
        enumerable: !1,
        configurable: !0
    }), Object.defineProperty(e.prototype, "descent", {
        get: function() {
            return this._runtime ? this._runtime.descent : 0;
        },
        enumerable: !1,
        configurable: !0
    }), Object.defineProperty(e.prototype, "font", {
        get: function() {
            return this._font;
        },
        set: function(t) {
            null === t || this.font.eq(t) || (this._font = t.clone(), this._data.fontFamily = t.family, this._data.fontSize = t.size, this._data.fontStyle = t.style, this._runtime && this._runtime.onFontUpdate(this.font));
        },
        enumerable: !1,
        configurable: !0
    }), Object.defineProperty(e.prototype, "fontFamily", {
        get: function() {
            return this.font.family;
        },
        set: function(t) {
            this.font.family !== t && (this._font = this.font.deriveFamily(t), this._data.fontFamily = t, this._runtime && this._runtime.onFontUpdate(this.font));
        },
        enumerable: !1,
        configurable: !0
    }), Object.defineProperty(e.prototype, "fontStyle", {
        get: function() {
            return this.font.style;
        },
        set: function(t) {
            this.font.style !== t && (this._font = this.font.deriveStyle(t), this._data.fontStyle = t, this._runtime && this._runtime.onFontUpdate(this.font));
        },
        enumerable: !1,
        configurable: !0
    }), Object.defineProperty(e.prototype, "fontSize", {
        get: function() {
            return this.font.size;
        },
        set: function(t) {
            isNaN(t) || this.font.size === t || (this._font = this.font.deriveSize(t), this._data.fontSize = t, this._runtime && this._runtime.onFontUpdate(this.font));
        },
        enumerable: !1,
        configurable: !0
    }), Object.defineProperty(e.prototype, "color", {
        get: function() {
            return this._color;
        },
        set: function(t) {
            t && !t.eq(this.color) && (this._color = t, this._runtime && this._runtime.onColorUpdate(t));
        },
        enumerable: !1,
        configurable: !0
    }), e.prototype.getType = function() {
        return $af62ec6a841e10b9$export$6ba26ae1c58c0147.CHAR;
    }, e;
}($af62ec6a841e10b9$var$et), $af62ec6a841e10b9$var$nt = function(t) {
    function e(e) {
        var r = t.call(this) || this;
        return r._data = e, r;
    }
    return $af62ec6a841e10b9$var$J(e, t), e.prototype.getType = function() {
        return $af62ec6a841e10b9$export$6ba26ae1c58c0147.GRAPHIC;
    }, e.prototype.toString = function() {
        return "Graphic";
    }, e;
}($af62ec6a841e10b9$var$K), $af62ec6a841e10b9$var$it = function(t) {
    function e(e) {
        var r = t.call(this) || this;
        return r._data = e, r;
    }
    return $af62ec6a841e10b9$var$J(e, t), Object.defineProperty(e.prototype, "parent", {
        get: function() {
            return this._parent;
        },
        enumerable: !1,
        configurable: !0
    }), Object.defineProperty(e.prototype, "children", {
        get: function() {
            return this._children.slice();
        },
        enumerable: !1,
        configurable: !0
    }), Object.defineProperty(e.prototype, "previous", {
        get: function() {
            return this._previous;
        },
        enumerable: !1,
        configurable: !0
    }), Object.defineProperty(e.prototype, "next", {
        get: function() {
            return this._next;
        },
        enumerable: !1,
        configurable: !0
    }), Object.defineProperty(e.prototype, "startTime", {
        get: function() {
            return this.firstChar ? this.firstChar.startTime : 0;
        },
        enumerable: !1,
        configurable: !0
    }), Object.defineProperty(e.prototype, "endTime", {
        get: function() {
            return this.lastChar ? this.lastChar.endTime : 0;
        },
        enumerable: !1,
        configurable: !0
    }), Object.defineProperty(e.prototype, "pos", {
        get: function() {
            return this._data && this._data.pos || "";
        },
        enumerable: !1,
        configurable: !0
    }), Object.defineProperty(e.prototype, "rawPos", {
        get: function() {
            return this._data && this._data.rawPoS || "";
        },
        enumerable: !1,
        configurable: !0
    }), Object.defineProperty(e.prototype, "language", {
        get: function() {
            return this._data && this._data.language || "";
        },
        enumerable: !1,
        configurable: !0
    }), Object.defineProperty(e.prototype, "countDown", {
        get: function() {
            return this._data ? this._data.countDown : -1;
        },
        enumerable: !1,
        configurable: !0
    }), Object.defineProperty(e.prototype, "countUp", {
        get: function() {
            return this._data ? this._data.countUp : -1;
        },
        enumerable: !1,
        configurable: !0
    }), Object.defineProperty(e.prototype, "initialCount", {
        get: function() {
            return this._data ? this._data.initialCount : -1;
        },
        enumerable: !1,
        configurable: !0
    }), Object.defineProperty(e.prototype, "charCount", {
        get: function() {
            return this._children.length;
        },
        enumerable: !1,
        configurable: !0
    }), Object.defineProperty(e.prototype, "firstChar", {
        get: function() {
            return this._children.length <= 0 ? null : this._children[0];
        },
        enumerable: !1,
        configurable: !0
    }), Object.defineProperty(e.prototype, "lastChar", {
        get: function() {
            return this._children.length <= 0 ? null : this._children[this._children.length - 1];
        },
        enumerable: !1,
        configurable: !0
    }), e.prototype.addChar = function(t) {
        if (t) {
            this._children.length > 0 && (t._previous = this.lastChar, this.lastChar._next = t), this._children.push(t), t._parent = this;
            var e = this.expandTime(t), r = e.startTime, n = e.endTime;
            this._data.startTime = r, this._data.endTime = n;
        }
    }, e.prototype.findIndex = function(t) {
        return t instanceof $af62ec6a841e10b9$var$rt ? this._children.indexOf(t) : -1;
    }, e.prototype.getType = function() {
        return $af62ec6a841e10b9$export$6ba26ae1c58c0147.WORD;
    }, e;
}($af62ec6a841e10b9$var$et), $af62ec6a841e10b9$var$ot = function(t) {
    function e(e, r) {
        var n = t.call(this) || this;
        return n._video = e, n._data = r, n.createUnits(), n;
    }
    return $af62ec6a841e10b9$var$J(e, t), e.prototype.createUnits = function() {
        var t = this, e = this._data;
        e && Array.isArray(e.words) && e.words.forEach(function(e) {
            if (e) {
                var r = new $af62ec6a841e10b9$var$it(e);
                Array.isArray(e.characters) && e.characters.forEach(function(t) {
                    return r.addChar(new $af62ec6a841e10b9$var$rt(t));
                }), t.addWord(r);
            }
        });
    }, Object.defineProperty(e.prototype, "children", {
        get: function() {
            return this._children.slice();
        },
        enumerable: !1,
        configurable: !0
    }), Object.defineProperty(e.prototype, "previous", {
        get: function() {
            return this._previous;
        },
        enumerable: !1,
        configurable: !0
    }), Object.defineProperty(e.prototype, "next", {
        get: function() {
            return this._next;
        },
        enumerable: !1,
        configurable: !0
    }), Object.defineProperty(e.prototype, "video", {
        get: function() {
            return this._video;
        },
        enumerable: !1,
        configurable: !0
    }), Object.defineProperty(e.prototype, "startTime", {
        get: function() {
            return this.firstChar ? this.firstChar.startTime : 0;
        },
        enumerable: !1,
        configurable: !0
    }), Object.defineProperty(e.prototype, "endTime", {
        get: function() {
            return this.lastChar ? this.lastChar.endTime : 0;
        },
        enumerable: !1,
        configurable: !0
    }), Object.defineProperty(e.prototype, "wordCount", {
        get: function() {
            return this._children.length;
        },
        enumerable: !1,
        configurable: !0
    }), Object.defineProperty(e.prototype, "charCount", {
        get: function() {
            return this._children.reduce(function(t, e) {
                return t + e.charCount;
            }, 0);
        },
        enumerable: !1,
        configurable: !0
    }), Object.defineProperty(e.prototype, "firstWord", {
        get: function() {
            return this._children.length <= 0 ? null : this._children[0];
        },
        enumerable: !1,
        configurable: !0
    }), Object.defineProperty(e.prototype, "lastWord", {
        get: function() {
            return this._children.length <= 0 ? null : this._children[this._children.length - 1];
        },
        enumerable: !1,
        configurable: !0
    }), Object.defineProperty(e.prototype, "firstChar", {
        get: function() {
            var t = this.firstWord;
            return null === t ? null : t.firstChar;
        },
        enumerable: !1,
        configurable: !0
    }), Object.defineProperty(e.prototype, "lastChar", {
        get: function() {
            var t = this.lastWord;
            return null === t ? null : t.lastChar;
        },
        enumerable: !1,
        configurable: !0
    }), e.prototype.getWord = function(t) {
        return t < 0 || t >= this._children.length ? null : this._children[t];
    }, e.prototype.getChar = function(t) {
        if (t < 0) return null;
        for(var e = 0, r = this.firstWord;;){
            if (!r) return null;
            if (e + r.children.length > t) break;
            e += r.children.length, r = r.next;
        }
        return r.children[t - e];
    }, e.prototype.addWord = function(t) {
        if (t) {
            this._children.length > 0 && (t._previous = this.lastWord, t._previous._next = t, t.firstChar._previous = t._previous.lastChar, t._previous.lastChar._next = t.firstChar), this._children.push(t), t._parent = this;
            var e = this.expandTime(t), r = e.startTime, n = e.endTime;
            this._data.startTime = r, this._data.endTime = n;
        }
    }, e.prototype.findIndex = function(t) {
        if (t instanceof $af62ec6a841e10b9$var$it) return this._children.indexOf(t);
        if (t instanceof $af62ec6a841e10b9$var$rt) {
            for(var e = 0, r = !1, n = 0, i = this._children; n < i.length; n++){
                var o = i[n], s = o.findIndex(t);
                if (!(s < 0)) {
                    e += s, r = !0;
                    break;
                }
                e += o.charCount;
            }
            return r ? e : -1;
        }
        return -1;
    }, e.prototype.getType = function() {
        return $af62ec6a841e10b9$export$6ba26ae1c58c0147.PHRASE;
    }, e;
}($af62ec6a841e10b9$var$et);
function $af62ec6a841e10b9$export$9bae06dfae5441df(t, e, n) {
    if (!t || t.length <= 0) return null;
    var i = $af62ec6a841e10b9$var$r.sortedIndex(t, e, function(t) {
        return t.endTime;
    });
    if (i < 0) return null;
    if (n && "endTime" in n && "number" == typeof n.endTime) {
        i >= t.length && (i = t.length - 1);
        var o = e, s = n.endTime;
        return t[i].overlaps(o, s) ? t[i] : i < 1 ? null : t[i - 1].overlaps(o, s) ? t[i - 1] : null;
    }
    return i >= t.length ? null : n && "loose" in n && n.loose || t[i].contains(e) ? t[i] : null;
}
function $af62ec6a841e10b9$export$212614cfc0556d1e(t, e, n) {
    if (!t || t.length <= 0) return {
        current: null,
        entered: [],
        left: [],
        previous: null,
        next: null
    };
    var i = $af62ec6a841e10b9$var$r.sortedIndex(t, e, function(t) {
        return t.startTime;
    });
    i < t.length && t[i].startTime === e && i++;
    var o, s, a, u = i - 1 < 0 ? -1 : t[i - 1].startTime <= e && t[i - 1].endTime > e ? i - 2 : i - 1, c = $af62ec6a841e10b9$var$r.sortedIndex(t, n, function(t) {
        return t.endTime;
    });
    c >= t.length ? (o = -1, s = -1, a = t[c - 1].endTime > e ? t.length : 0) : (t[c].startTime > n ? (o = -1, s = c) : c + 1 >= t.length || t[c + 1].startTime > n ? (o = t[c].endTime > n && t[c].startTime <= n ? c : -1, s = c + 1) : (o = c + 1, s = c + 2), a = t[c].endTime <= n ? c + 1 : c);
    var l = u >= 0 ? t[u] : null, p = s >= 0 && s < t.length ? t[s] : null;
    return {
        current: o >= 0 ? t[o] : null,
        entered: t.slice(i, s),
        left: t.slice(u + 1, a),
        previous: l,
        next: p
    };
}
var $af62ec6a841e10b9$var$ut = function(t) {
    function e(e) {
        var r = t.call(this) || this;
        return r._credits = [], r._phrases = [], r._graphics = [], r.data = e || {}, r.createUnits(), r;
    }
    return $af62ec6a841e10b9$var$J(e, t), Object.defineProperty(e.prototype, "credits", {
        get: function() {
            return this._credits.slice();
        },
        enumerable: !1,
        configurable: !0
    }), Object.defineProperty(e.prototype, "phrases", {
        get: function() {
            return this._phrases.slice();
        },
        enumerable: !1,
        configurable: !0
    }), Object.defineProperty(e.prototype, "words", {
        get: function() {
            return this._phrases.reduce(function(t, e) {
                return t.splice.apply(t, $af62ec6a841e10b9$var$H([
                    t.length,
                    0
                ], e._children, !1)), t;
            }, []);
        },
        enumerable: !1,
        configurable: !0
    }), Object.defineProperty(e.prototype, "chars", {
        get: function() {
            return this.words.reduce(function(t, e) {
                return t.splice.apply(t, $af62ec6a841e10b9$var$H([
                    t.length,
                    0
                ], e._children, !1)), t;
            }, []);
        },
        enumerable: !1,
        configurable: !0
    }), Object.defineProperty(e.prototype, "graphics", {
        get: function() {
            return this._graphics.slice();
        },
        enumerable: !1,
        configurable: !0
    }), Object.defineProperty(e.prototype, "rendering", {
        get: function() {
            return this._runtime.rendering;
        },
        enumerable: !1,
        configurable: !0
    }), Object.defineProperty(e.prototype, "duration", {
        get: function() {
            return this.data.duration || 0;
        },
        set: function(t) {
            this.data.duration = t;
        },
        enumerable: !1,
        configurable: !0
    }), Object.defineProperty(e.prototype, "startTime", {
        get: function() {
            return this.data.startTime || 0;
        },
        enumerable: !1,
        configurable: !0
    }), Object.defineProperty(e.prototype, "endTime", {
        get: function() {
            return this.data.endTime || 0;
        },
        enumerable: !1,
        configurable: !0
    }), Object.defineProperty(e.prototype, "creditCount", {
        get: function() {
            return this._credits.length;
        },
        enumerable: !1,
        configurable: !0
    }), Object.defineProperty(e.prototype, "phraseCount", {
        get: function() {
            return this._phrases.length;
        },
        enumerable: !1,
        configurable: !0
    }), Object.defineProperty(e.prototype, "graphicCount", {
        get: function() {
            return this._graphics.length;
        },
        enumerable: !1,
        configurable: !0
    }), Object.defineProperty(e.prototype, "wordCount", {
        get: function() {
            return this._phrases.reduce(function(t, e) {
                return t + e.wordCount;
            }, 0);
        },
        enumerable: !1,
        configurable: !0
    }), Object.defineProperty(e.prototype, "charCount", {
        get: function() {
            return this._phrases.reduce(function(t, e) {
                return t + e.charCount;
            }, 0);
        },
        enumerable: !1,
        configurable: !0
    }), Object.defineProperty(e.prototype, "firstCredit", {
        get: function() {
            return this._credits.length <= 0 ? null : this._credits[0];
        },
        enumerable: !1,
        configurable: !0
    }), Object.defineProperty(e.prototype, "lastCredit", {
        get: function() {
            return this._credits.length <= 0 ? null : this._credits[this._credits.length - 1];
        },
        enumerable: !1,
        configurable: !0
    }), Object.defineProperty(e.prototype, "firstPhrase", {
        get: function() {
            return this._phrases.length <= 0 ? null : this._phrases[0];
        },
        enumerable: !1,
        configurable: !0
    }), Object.defineProperty(e.prototype, "lastPhrase", {
        get: function() {
            return this._phrases.length <= 0 ? null : this._phrases[this._phrases.length - 1];
        },
        enumerable: !1,
        configurable: !0
    }), Object.defineProperty(e.prototype, "firstWord", {
        get: function() {
            var t;
            return (null === (t = this.firstPhrase) || void 0 === t ? void 0 : t.firstWord) || null;
        },
        enumerable: !1,
        configurable: !0
    }), Object.defineProperty(e.prototype, "lastWord", {
        get: function() {
            var t;
            return (null === (t = this.lastPhrase) || void 0 === t ? void 0 : t.lastWord) || null;
        },
        enumerable: !1,
        configurable: !0
    }), Object.defineProperty(e.prototype, "firstChar", {
        get: function() {
            var t;
            return (null === (t = this.firstWord) || void 0 === t ? void 0 : t.firstChar) || null;
        },
        enumerable: !1,
        configurable: !0
    }), Object.defineProperty(e.prototype, "lastChar", {
        get: function() {
            var t;
            return (null === (t = this.lastWord) || void 0 === t ? void 0 : t.lastChar) || null;
        },
        enumerable: !1,
        configurable: !0
    }), Object.defineProperty(e.prototype, "firstGraphic", {
        get: function() {
            return this._graphics.length <= 0 ? null : this._graphics[0];
        },
        enumerable: !1,
        configurable: !0
    }), Object.defineProperty(e.prototype, "lastGraphic", {
        get: function() {
            return this._graphics.length <= 0 ? null : this._graphics[this._graphics.length - 1];
        },
        enumerable: !1,
        configurable: !0
    }), e.prototype.createUnits = function() {
        var t, e, r = this;
        Array.isArray(this.data.credits) ? (this.data.credits.sort($af62ec6a841e10b9$var$ct), this.data.credits.forEach(function(t) {
            return r.doAddCredit(new $af62ec6a841e10b9$var$ot(r, t), !1);
        }), this.organizeTimings(null === (t = this.firstCredit) || void 0 === t ? void 0 : t.firstChar)) : this.data.credits = [], Array.isArray(this.data.phrases) ? (this.data.phrases.sort($af62ec6a841e10b9$var$ct), this.data.phrases.forEach(function(t) {
            return r.doAddPhrase(new $af62ec6a841e10b9$var$ot(r, t), !1);
        }), this.organizeTimings(null === (e = this.firstPhrase) || void 0 === e ? void 0 : e.firstChar)) : this.data.phrases = [], Array.isArray(this.data.graphics) ? (this.data.graphics.sort($af62ec6a841e10b9$var$ct), this.data.graphics.forEach(function(t) {
            return r.doAddGraphic(new $af62ec6a841e10b9$var$nt(t), !1);
        })) : this.data.graphics = [];
    }, e.prototype.organizeTimings = function(t) {
        for(; t;)t.startTime === t.endTime && t.maximize(), t = t.next;
    }, e.prototype.exportData = function(t) {
        this.updateTemplateData(t);
        for(var r = e.exportUnitData(this.data.credits, !0), n = r.units, i = r.templateClasses, o = e.exportUnitData(this.data.phrases, !1), s = o.units, a = o.templateClasses, u = e.exportUnitData(this.data.graphics, !0), c = u.units, l = u.templateClasses, p = i.concat(a, l).filter(function(t, e, r) {
            return r.indexOf(t) === e;
        }), h = {}; p.length > 0;){
            var d = p.shift(), f = t.getByName(d);
            if (f) {
                h[d] = f.id;
                for(var y = 0, g = t.getRequiredTemplates(f.script); y < g.length; y++){
                    var v = g[y];
                    h[v] || p.push(v);
                }
            } else console.log("template class not found", d);
        }
        return {
            credits: n,
            phrases: s,
            graphics: c,
            templateClasses: h
        };
    }, e.exportUnitData = function(t, r) {
        if (void 0 === r && (r = !1), !t) return {
            units: [],
            templateClasses: []
        };
        for(var n = [], i = [], o = 0, s = t; o < s.length; o++){
            var a = s[o], u = {
                templates: a.templates ? a.templates.map(function(t) {
                    var e = t.type;
                    i.push(e);
                    var r = {};
                    return Object.keys(t.value).forEach(function(e) {
                        var n = t.value[e];
                        r[e] = "object" == typeof n ? Object.assign({}, n) : n;
                    }), {
                        type: e,
                        value: r
                    };
                }) : []
            }, c = void 0;
            if (a.words) {
                var l = a, p = e.exportUnitData(l.words);
                u.words = p.units, c = p.templateClasses;
            } else if (a.characters) {
                var h = a, d = e.exportUnitData(h.characters);
                u.characters = d.units, c = d.templateClasses;
            } else {
                for(var f = 0, y = [
                    "fontFamily",
                    "fontSize",
                    "fontStyle"
                ]; f < y.length; f++){
                    var g = y[f];
                    a[g] && (u[g] = a[g]);
                }
                c = [];
            }
            r && (u.startTime = a.startTime, u.endTime = a.endTime), n.push(u), i = i.concat(c);
        }
        return {
            units: n,
            templateClasses: i = i.filter(function(t, e, r) {
                return r.indexOf(t) === e;
            })
        };
    }, e.prototype.updateTemplateData = function(t) {
        e.updateTemplateDataForUnits(t, this.firstCredit, this.data.credits), e.updateTemplateDataForUnits(t, this.firstPhrase, this.data.phrases), e.updateTemplateDataForUnits(t, this.firstGraphic, this.data.graphics);
    }, e.updateTemplateDataForUnits = function(t, r, n) {
        if (r && n) for(var i = 0, o = n; i < o.length; i++){
            var s = o[i];
            s.templates = [];
            for(var a = 0; a < r.templateCount; a++){
                var u = r.getTemplate(a), c = t.exportInstance(u);
                s.templates.push(c);
            }
            if (s.words) {
                var l = s;
                e.updateTemplateDataForUnits(t, r.children[0], l.words);
            } else if (s.characters) {
                var p = s;
                e.updateTemplateDataForUnits(t, r.children[0], p.characters);
            }
            r = r.next;
        }
    }, e.prototype.addCredit = function(t) {
        this.doAddCredit(t, !0);
    }, e.prototype.doAddCredit = function(t, e) {
        var r = this.addRenderingUnit(this._credits, t);
        e && this.data.credits.splice(r, 0, t._data), this._runtime && this._runtime.addCredit(t);
    }, e.prototype.addPhrase = function(t) {
        this.doAddPhrase(t, !0);
    }, e.prototype.doAddPhrase = function(t, e) {
        var r = this.addRenderingUnit(this._phrases, t);
        e && this.data.phrases.splice(r, 0, t._data), this._runtime && this._runtime.addPhrase(t);
    }, e.prototype.addGraphic = function(t) {
        this.doAddGraphic(t, !0);
    }, e.prototype.doAddGraphic = function(t, e) {
        if (t) {
            var r = this.addRenderingUnit(this._graphics, t);
            e && this.data.graphics.splice(r, 0, t._data), this._runtime && this._runtime.addGraphic(t);
        }
    }, e.prototype.addRenderingUnit = function(t, e) {
        if (e) {
            var n = $af62ec6a841e10b9$var$r.sortedIndex(t, e, $af62ec6a841e10b9$var$lt), i = n > 0 ? t[n - 1] : null, o = n < t.length ? t[n] : null;
            if (t.splice(n, 0, e), i && (e._previous = i, e._previous._next = e), o && (o._previous = e, e._next = o), e instanceof $af62ec6a841e10b9$var$ot && e.wordCount > 0) {
                for(var s = i; s && !s.lastWord;)s = s.previous;
                for(var a = o; a && !a.firstWord;)a = a.next;
                if (s && (e.firstWord._previous = s.lastWord, s.lastWord._next = e.firstWord), a && (e.lastWord._next = a.firstWord, a.firstWord._previous = e.lastWord), e.charCount > 0) {
                    for(var u = null == s ? void 0 : s.lastWord; u && null === u.lastChar;)u = u.previous;
                    for(var c = null == a ? void 0 : a.firstWord; c && null === c.firstChar;)c = c.next;
                    u && (e.firstChar._previous = u.lastChar, u.lastChar._next = e.firstChar), c && (e.lastChar._next = c.firstChar, c.firstChar._previous = e.lastChar);
                }
            }
            return this.updateStartAndEndTime(), n;
        }
    }, e.prototype.removeCredit = function(t) {
        var e = this.removeRenderingUnit(this._credits, t);
        return !(e < 0 || (this.data.credits.splice(e, 1), this._runtime && this._runtime.removeCredit(t), 0));
    }, e.prototype.removeCredits = function() {
        var t = this;
        this._runtime && this._credits.forEach(function(e) {
            return t._runtime.removeCredit(e);
        }), this._credits = [], this.data.credits.splice(0, this.data.credits.length);
    }, e.prototype.removePhrase = function(t) {
        var e = this.removeRenderingUnit(this._phrases, t);
        return !(e < 0 || (this.data.phrases.splice(e, 1), this._runtime && this._runtime.removePhrase(t), 0));
    }, e.prototype.removePhrases = function() {
        var t = this;
        this._runtime && this._phrases.forEach(function(e) {
            return t._runtime.removePhrase(e);
        }), this._phrases = [], this.data.phrases.splice(0, this.data.phrases.length);
    }, e.prototype.removeGraphic = function(t) {
        var e = this.removeRenderingUnit(this._graphics, t);
        return !(e < 0 || (this.data.graphics.splice(e, 1), this._runtime && this._runtime.removeGraphic(t), 0));
    }, e.prototype.removeGraphics = function() {
        var t = this;
        this._runtime && this._graphics.forEach(function(e) {
            return t._runtime.removeGraphic(e);
        }), this._graphics = [], this.data.graphics.splice(0, this.data.graphics.length), this.rendering.reset();
    }, e.prototype.removeRenderingUnit = function(t, e) {
        var n = $af62ec6a841e10b9$var$r.sortedIndex(t, e, $af62ec6a841e10b9$var$lt);
        if (n < 0 || t[n] !== e) return -1;
        if (t.splice(n, 1), e instanceof $af62ec6a841e10b9$var$ot) {
            if (e.charCount > 0) {
                for(var i = e._previous; i && null === i.lastChar;)i = i.previous;
                for(var o = e._next; o && null === o.firstChar;)o = o.next;
                i && o ? (i.lastChar._next = o.firstChar, o.firstChar._previous = i.lastChar) : i ? i.lastChar._next = null : o && (o.firstChar._previous = null);
            }
            if (e.wordCount > 0) {
                for(i = e._previous; i && null === i.lastWord;)i = i.previous;
                for(o = e._next; o && null === o.firstWord;)o = o.next;
                i && o ? (i.lastWord._next = o.firstWord, o.firstWord._previous = i.lastWord) : i ? i.lastWord._next = null : o && (o.firstWord._previous = null);
            }
        }
        e._previous && (e._previous._next = e._next), e._next && (e._next._previous = e._previous), this.updateStartAndEndTime();
    }, e.prototype.updateStartAndEndTime = function() {
        var t, e, r, n, i, o, s, a;
        this.data.endTime = Math.max((null === (e = null === (t = this.lastCredit) || void 0 === t ? void 0 : t.lastChar) || void 0 === e ? void 0 : e.endTime) || 0, (null === (r = this.lastChar) || void 0 === r ? void 0 : r.endTime) || 0, (null === (n = this.lastGraphic) || void 0 === n ? void 0 : n.endTime) || 0);
        var u = null === (o = null === (i = this.firstCredit) || void 0 === i ? void 0 : i.firstChar) || void 0 === o ? void 0 : o.startTime, c = null === (s = this.firstChar) || void 0 === s ? void 0 : s.startTime, l = null === (a = this.firstGraphic) || void 0 === a ? void 0 : a.startTime;
        this.data.startTime = Math.min("number" == typeof u ? u : Number.MAX_VALUE, "number" == typeof c ? c : Number.MAX_VALUE, "number" == typeof l ? l : Number.MAX_VALUE, this.data.endTime);
    }, e.prototype.findIndex = function(t) {
        if (t instanceof $af62ec6a841e10b9$var$ot) return (e = this._phrases.indexOf(t)) >= 0 ? e : this._credits.indexOf(t);
        if (t instanceof $af62ec6a841e10b9$var$it) {
            for(var e = 0, r = !1, n = 0, i = this._phrases; n < i.length; n++){
                if (!((u = (a = i[n]).findIndex(t)) < 0)) {
                    e += u, r = !0;
                    break;
                }
                e += a.wordCount;
            }
            return r ? e : -1;
        }
        if (t instanceof $af62ec6a841e10b9$var$rt) {
            e = 0, r = !1;
            for(var o = 0, s = this._phrases; o < s.length; o++){
                var a, u;
                if (!((u = (a = s[o]).findIndex(t)) < 0)) {
                    e += u, r = !0;
                    break;
                }
                e += a.charCount;
            }
            return r ? e : -1;
        }
        return t instanceof $af62ec6a841e10b9$var$nt ? this._graphics.indexOf(t) : -1;
    }, e.prototype.getCredit = function(t) {
        return t < 0 || t >= this._credits.length ? null : this._credits[t];
    }, e.prototype.getPhrase = function(t) {
        return t < 0 || t >= this._phrases.length ? null : this._phrases[t];
    }, e.prototype.getWord = function(t) {
        if (t < 0) return null;
        for(var e = 0, r = this.firstPhrase;;){
            if (!r) return null;
            if (e + r.children.length > t) break;
            e += r.children.length, r = r.next;
        }
        return r.children[t - e];
    }, e.prototype.getChar = function(t) {
        if (t < 0) return null;
        for(var e = 0, r = this.firstWord;;){
            if (!r) return null;
            if (e + r.children.length > t) break;
            e += r.children.length, r = r.next;
        }
        return r.children[t - e];
    }, e.prototype.getGraphic = function(t) {
        return t < 0 || t >= this._graphics.length ? null : this._graphics[t];
    }, e.prototype.findCredit = function(t, e) {
        return $af62ec6a841e10b9$export$9bae06dfae5441df(this._credits, t, e);
    }, e.prototype.findCreditChange = function(t, e) {
        return $af62ec6a841e10b9$export$212614cfc0556d1e(this._credits, t, e);
    }, e.prototype.findPhrase = function(t, e) {
        return $af62ec6a841e10b9$export$9bae06dfae5441df(this._phrases, t, e);
    }, e.prototype.findPhraseChange = function(t, e) {
        return $af62ec6a841e10b9$export$212614cfc0556d1e(this._phrases, t, e);
    }, e.prototype.findWord = function(t, e) {
        var r = this.findPhrase(t, e);
        return r ? $af62ec6a841e10b9$export$9bae06dfae5441df(r._children, t, e) : null;
    }, e.prototype.findWordChange = function(t, e) {
        return $af62ec6a841e10b9$export$212614cfc0556d1e(this.words, t, e);
    }, e.prototype.findChar = function(t, e) {
        var r = this.findWord(t, e);
        return r ? $af62ec6a841e10b9$export$9bae06dfae5441df(r._children, t, e) : null;
    }, e.prototype.findCharChange = function(t, e) {
        return $af62ec6a841e10b9$export$212614cfc0556d1e(this.chars, t, e);
    }, e.prototype.findGraphic = function(t, e) {
        return $af62ec6a841e10b9$export$9bae06dfae5441df(this._graphics, t, e);
    }, e.prototype.findGraphicChange = function(t, e) {
        return $af62ec6a841e10b9$export$212614cfc0556d1e(this._graphics, t, e);
    }, e;
}($af62ec6a841e10b9$export$52786b6f4da3c973);
function $af62ec6a841e10b9$var$ct(t, e) {
    return t.startTime - e.startTime;
}
function $af62ec6a841e10b9$var$lt(t) {
    return t.startTime;
}
var $af62ec6a841e10b9$export$26e6ecd136a15474 = function() {
    function t(t, e, r, n, i, o) {
        void 0 === t && (t = 1), void 0 === e && (e = 0), void 0 === r && (r = 0), void 0 === n && (n = 1), void 0 === i && (i = 0), void 0 === o && (o = 0), this.setValues(t, e, r, n, i, o);
    }
    return t.prototype.setValues = function(t, e, r, n, i, o) {
        return void 0 === t && (t = 1), void 0 === e && (e = 0), void 0 === r && (r = 0), void 0 === n && (n = 1), void 0 === i && (i = 0), void 0 === o && (o = 0), this.a = t, this.b = e, this.c = r, this.d = n, this.tx = i, this.ty = o, this;
    }, t.prototype.append = function(t, e, r, n, i, o) {
        var s = this.a, a = this.b, u = this.c, c = this.d;
        return 1 == t && 0 == e && 0 == r && 1 == n || (this.a = s * t + u * e, this.b = a * t + c * e, this.c = s * r + u * n, this.d = a * r + c * n), this.tx = s * i + u * o + this.tx, this.ty = a * i + c * o + this.ty, this;
    }, t.prototype.prepend = function(t, e, r, n, i, o) {
        var s = this.a, a = this.c, u = this.tx;
        return this.a = t * s + r * this.b, this.b = e * s + n * this.b, this.c = t * a + r * this.d, this.d = e * a + n * this.d, this.tx = t * u + r * this.ty + i, this.ty = e * u + n * this.ty + o, this;
    }, t.prototype.appendMatrix = function(t) {
        return this.append(t.a, t.b, t.c, t.d, t.tx, t.ty);
    }, t.prototype.prependMatrix = function(t) {
        return this.prepend(t.a, t.b, t.c, t.d, t.tx, t.ty);
    }, t.prototype.appendTransform = function(e, r, n, i, o, s, a, u, c) {
        var l, p, h;
        return o % 360 ? (l = o * t.DEG_TO_RAD, p = Math.cos(l), h = Math.sin(l)) : (p = 1, h = 0), s || a ? (s *= t.DEG_TO_RAD, a *= t.DEG_TO_RAD, this.append(Math.cos(a), Math.sin(a), -Math.sin(s), Math.cos(s), e, r), this.append(p * n, h * n, -h * i, p * i, 0, 0)) : this.append(p * n, h * n, -h * i, p * i, e, r), (u || c) && (this.tx -= u * this.a + c * this.c, this.ty -= u * this.b + c * this.d), this;
    }, t.prototype.prependTransform = function(e, r, n, i, o, s, a, u, c) {
        var l, p, h;
        return o % 360 ? (l = o * t.DEG_TO_RAD, p = Math.cos(l), h = Math.sin(l)) : (p = 1, h = 0), (u || c) && (this.tx -= u, this.ty -= c), s || a ? (s *= t.DEG_TO_RAD, a *= t.DEG_TO_RAD, this.prepend(p * n, h * n, -h * i, p * i, 0, 0), this.prepend(Math.cos(a), Math.sin(a), -Math.sin(s), Math.cos(s), e, r)) : this.prepend(p * n, h * n, -h * i, p * i, e, r), this;
    }, t.prototype.rotate = function(e) {
        e *= t.DEG_TO_RAD;
        var r = Math.cos(e), n = Math.sin(e), i = this.a, o = this.b;
        return this.a = i * r + this.c * n, this.b = o * r + this.d * n, this.c = -i * n + this.c * r, this.d = -o * n + this.d * r, this;
    }, t.prototype.skew = function(e, r) {
        return e *= t.DEG_TO_RAD, r *= t.DEG_TO_RAD, this.append(Math.cos(r), Math.sin(r), -Math.sin(e), Math.cos(e), 0, 0), this;
    }, t.prototype.scale = function(t, e) {
        return this.a *= t, this.b *= t, this.c *= e, this.d *= e, this;
    }, t.prototype.translate = function(t, e) {
        return this.tx += this.a * t + this.c * e, this.ty += this.b * t + this.d * e, this;
    }, t.prototype.identity = function() {
        return this.a = this.d = 1, this.b = this.c = this.tx = this.ty = 0, this;
    }, t.prototype.invert = function() {
        var t = this.a, e = this.b, r = this.c, n = this.d, i = this.tx, o = t * n - e * r;
        return this.a = n / o, this.b = -e / o, this.c = -r / o, this.d = t / o, this.tx = (r * this.ty - n * i) / o, this.ty = -(t * this.ty - e * i) / o, this;
    }, t.prototype.isIdentity = function() {
        return 0 === this.tx && 0 === this.ty && 1 === this.a && 0 === this.b && 0 === this.c && 1 === this.d;
    }, t.prototype.equals = function(t) {
        return this.tx === t.tx && this.ty === t.ty && this.a === t.a && this.b === t.b && this.c === t.c && this.d === t.d;
    }, t.prototype.transformPoint = function(t, e, r) {
        return r.x = t * this.a + e * this.c + this.tx, r.y = t * this.b + e * this.d + this.ty, r;
    }, t.prototype.decompose = function(e) {
        void 0 === e && (e = {}), e.x = this.tx, e.y = this.ty, e.scaleX = Math.sqrt(this.a * this.a + this.b * this.b), e.scaleY = Math.sqrt(this.c * this.c + this.d * this.d);
        var r = Math.atan2(-this.c, this.d), n = Math.atan2(this.b, this.a);
        return Math.abs(1 - r / n) < 1e-5 ? (e.rotation = n / t.DEG_TO_RAD, this.a < 0 && this.d >= 0 && (e.rotation += e.rotation <= 0 ? 180 : -180), e.skewX = e.skewY = 0) : (e.skewX = r / t.DEG_TO_RAD, e.skewY = n / t.DEG_TO_RAD), e;
    }, t.prototype.copy = function(t) {
        return this.setValues(t.a, t.b, t.c, t.d, t.tx, t.ty);
    }, t.prototype.clone = function() {
        return new t(this.a, this.b, this.c, this.d, this.tx, this.ty);
    }, t.prototype.toString = function() {
        return "[".concat(this.constructor.name, " (a=").concat(this.a, " b=").concat(this.b, " c=").concat(this.c, " d=").concat(this.d, " tx=").concat(this.tx, " ty=").concat(this.ty, ")]");
    }, t.DEG_TO_RAD = Math.PI / 180, t.identity = new t, t;
}(), $af62ec6a841e10b9$export$baf26146a414f24a = function() {
    function t(t, e) {
        void 0 === t && (t = 0), void 0 === e && (e = 0), this.setValues(t, e);
    }
    return t.prototype.setValues = function(t, e) {
        return void 0 === t && (t = 0), void 0 === e && (e = 0), this.x = t, this.y = e, this;
    }, t.prototype.copy = function(t) {
        return this.x = t.x, this.y = t.y, this;
    }, t.prototype.clone = function() {
        return new t(this.x, this.y);
    }, t.prototype.toString = function() {
        return "[".concat(this.constructor.name, " (x=").concat(this.x, " y=").concat(this.y, ")]");
    }, t;
}(), $af62ec6a841e10b9$var$dt = function() {
    function t() {
        this.tx = new $af62ec6a841e10b9$export$26e6ecd136a15474, this.alpha = 0, this.composite = "", this.visible = !0;
    }
    return t.prototype.reset = function() {}, t;
}(), $af62ec6a841e10b9$var$ft = function() {
    function t() {
        this.rendering = new $af62ec6a841e10b9$var$dt;
    }
    return t.prototype.addCredit = function(t) {
        this.doAddPhrase(t);
    }, t.prototype.removeCredit = function(t) {
        t._runtime = null;
    }, t.prototype.addPhrase = function(t) {
        this.doAddPhrase(t);
    }, t.prototype.removePhrase = function(t) {
        t._runtime = null;
    }, t.prototype.doAddPhrase = function(t) {
        t._runtime = {
            graphics: {
                clear: function() {}
            },
            rendering: new $af62ec6a841e10b9$var$dt,
            update: function() {}
        };
        for(var e = t.firstWord; e;){
            e._runtime = {
                graphics: {
                    clear: function() {}
                },
                rendering: new $af62ec6a841e10b9$var$dt,
                update: function() {}
            };
            for(var r = e.firstChar; r && (r._runtime = {
                graphics: {
                    clear: function() {}
                },
                rendering: new $af62ec6a841e10b9$var$dt,
                update: function() {},
                advance: 0,
                ascent: 0,
                descent: 0,
                onFontUpdate: function() {},
                onColorUpdate: function() {}
            }, r !== e.lastChar);)r = r.next;
            if (e === t.lastWord) break;
            e = e.next;
        }
    }, t.prototype.addGraphic = function(t) {
        t._runtime = {
            graphics: {
                clear: function() {}
            },
            rendering: new $af62ec6a841e10b9$var$dt,
            update: function() {}
        };
    }, t.prototype.removeGraphic = function(t) {
        t._runtime = null;
    }, t;
}(), $af62ec6a841e10b9$var$yt = function() {
    function t() {
        this.wrapperTable = {};
    }
    return t.prototype.isGraphics = function() {
        return !1;
    }, t.prototype.setCanvas = function() {
        return Promise.resolve();
    }, t.prototype.createRuntime = function(t) {
        return function(t, e, r, n) {
            return new (r || (r = Promise))(function(e, i) {
                function o(t) {
                    try {
                        a(n.next(t));
                    } catch (t) {
                        i(t);
                    }
                }
                function s(t) {
                    try {
                        a(n.throw(t));
                    } catch (t) {
                        i(t);
                    }
                }
                function a(t) {
                    var n;
                    t.done ? e(t.value) : (n = t.value, n instanceof r ? n : new r(function(t) {
                        t(n);
                    })).then(o, s);
                }
                a((n = n.apply(t, [])).next());
            });
        }(this, 0, void 0, function() {
            var e, r, n;
            return function(t, e) {
                var r, n, i, o, s = {
                    label: 0,
                    sent: function() {
                        if (1 & i[0]) throw i[1];
                        return i[1];
                    },
                    trys: [],
                    ops: []
                };
                return o = {
                    next: a(0),
                    throw: a(1),
                    return: a(2)
                }, "function" == typeof Symbol && (o[Symbol.iterator] = function() {
                    return this;
                }), o;
                function a(a) {
                    return function(u) {
                        return function(a) {
                            if (r) throw new TypeError("Generator is already executing.");
                            for(; o && (o = 0, a[0] && (s = 0)), s;)try {
                                if (r = 1, n && (i = 2 & a[0] ? n.return : a[0] ? n.throw || ((i = n.return) && i.call(n), 0) : n.next) && !(i = i.call(n, a[1])).done) return i;
                                switch(n = 0, i && (a = [
                                    2 & a[0],
                                    i.value
                                ]), a[0]){
                                    case 0:
                                    case 1:
                                        i = a;
                                        break;
                                    case 4:
                                        return s.label++, {
                                            value: a[1],
                                            done: !1
                                        };
                                    case 5:
                                        s.label++, n = a[1], a = [
                                            0
                                        ];
                                        continue;
                                    case 7:
                                        a = s.ops.pop(), s.trys.pop();
                                        continue;
                                    default:
                                        if (!((i = (i = s.trys).length > 0 && i[i.length - 1]) || 6 !== a[0] && 2 !== a[0])) {
                                            s = 0;
                                            continue;
                                        }
                                        if (3 === a[0] && (!i || a[1] > i[0] && a[1] < i[3])) {
                                            s.label = a[1];
                                            break;
                                        }
                                        if (6 === a[0] && s.label < i[1]) {
                                            s.label = i[1], i = a;
                                            break;
                                        }
                                        if (i && s.label < i[2]) {
                                            s.label = i[2], s.ops.push(a);
                                            break;
                                        }
                                        i[2] && s.ops.pop(), s.trys.pop();
                                        continue;
                                }
                                a = e.call(t, s);
                            } catch (t) {
                                a = [
                                    6,
                                    t
                                ], n = 0;
                            } finally{
                                r = i = 0;
                            }
                            if (5 & a[0]) throw a[1];
                            return {
                                value: a[0] ? a[1] : void 0,
                                done: !0
                            };
                        }([
                            a,
                            u
                        ]);
                    };
                }
            }(this, function(i) {
                for(this.video = t, t._runtime = new $af62ec6a841e10b9$var$ft, e = t.firstCredit; e;)t._runtime.addCredit(e), e = e.next;
                for(r = t.firstPhrase; r;)t._runtime.addPhrase(r), r = r.next;
                for(n = t.firstGraphic; n;)t._runtime.addGraphic(n), n = n.next;
                return [
                    2,
                    t._runtime
                ];
            });
        });
    }, t.prototype.reset = function() {
        var t, e;
        this.resetTextUnitsFrom(this.video.firstCredit), this.resetTextUnitsFrom(null === (t = this.video.firstCredit) || void 0 === t ? void 0 : t.firstWord), this.resetTextUnitsFrom(null === (e = this.video.firstCredit) || void 0 === e ? void 0 : e.firstChar), this.resetTextUnitsFrom(this.video.firstPhrase), this.resetTextUnitsFrom(this.video.firstWord), this.resetTextUnitsFrom(this.video.firstChar), this.video._runtime.rendering.reset();
    }, t.prototype.resetTextUnitsFrom = function(t) {
        for(; t;)t.rendering.reset(), t.graphics.clear(), t = t.next;
    }, t.prototype.update = function() {
        var t, e;
        this.updateCharsFrom(null === (t = this.video.firstCredit) || void 0 === t ? void 0 : t.firstChar), this.updateCharsFrom(null === (e = this.video.firstPhrase) || void 0 === e ? void 0 : e.firstChar);
    }, t.prototype.updateCharsFrom = function(t) {
        for(; t;)t._runtime.update(), t = t.next;
    }, t.prototype.updateStageTx = function() {}, t;
}();
function $af62ec6a841e10b9$var$gt(t) {
    if (void 0 !== t && "function" != typeof t) {
        if ("object" != typeof t) return t;
        if (null === t) return null;
        if (t instanceof $af62ec6a841e10b9$export$892596cec99bc70e) return {
            type: "Color",
            value: {
                r: t.r,
                g: t.g,
                b: t.b,
                a: t.a
            }
        };
        throw new Error;
    }
}
function $af62ec6a841e10b9$var$vt(t, e) {
    if ("object" != typeof t || null === t) return t;
    if (t.type && (e[t.type] || "Color" === t.type)) {
        var r;
        if ("Color" === t.type) {
            var n = new $af62ec6a841e10b9$export$892596cec99bc70e;
            n.r = Number(t.value.r), n.g = Number(t.value.g), n.b = Number(t.value.b), n.a = Number(t.value.a), r = n;
        } else {
            for(var i = new e[t.type], o = 0, s = Object.keys(t.value); o < s.length; o++){
                var a = s[o];
                i[a] = t.value[a];
            }
            r = i;
        }
        return r;
    }
}
var $af62ec6a841e10b9$var$mt, $af62ec6a841e10b9$var$bt, $af62ec6a841e10b9$var$_t, $af62ec6a841e10b9$var$wt, $af62ec6a841e10b9$var$Pt, $af62ec6a841e10b9$var$Et, $af62ec6a841e10b9$var$Ot, $af62ec6a841e10b9$var$St, $af62ec6a841e10b9$var$Tt, $af62ec6a841e10b9$var$xt, $af62ec6a841e10b9$var$At, $af62ec6a841e10b9$var$Rt, $af62ec6a841e10b9$var$Ct, $af62ec6a841e10b9$var$Nt, $af62ec6a841e10b9$var$kt, $af62ec6a841e10b9$var$jt, $af62ec6a841e10b9$var$It, $af62ec6a841e10b9$var$Ut, $af62ec6a841e10b9$var$Ft, $af62ec6a841e10b9$var$Lt, $af62ec6a841e10b9$var$Dt = function(t, e) {
    return $af62ec6a841e10b9$var$bt = String(t), $af62ec6a841e10b9$var$_t = $af62ec6a841e10b9$var$bt.length, function(t) {
        for(var e in $af62ec6a841e10b9$var$mt = t || {}, $af62ec6a841e10b9$var$Mt)Object.prototype.hasOwnProperty.call($af62ec6a841e10b9$var$mt, e) || ($af62ec6a841e10b9$var$mt[e] = $af62ec6a841e10b9$var$Mt[e]);
        $af62ec6a841e10b9$var$wt = $af62ec6a841e10b9$var$mt.sourceFile || null;
    }(e), $af62ec6a841e10b9$var$Ct = 1, $af62ec6a841e10b9$var$Pt = $af62ec6a841e10b9$var$Nt = 0, $af62ec6a841e10b9$var$Rt = !0, $af62ec6a841e10b9$var$pr(), function(t) {
        $af62ec6a841e10b9$var$kt = $af62ec6a841e10b9$var$jt = $af62ec6a841e10b9$var$Pt, $af62ec6a841e10b9$var$mt.locations && ($af62ec6a841e10b9$var$It = new $af62ec6a841e10b9$var$ar), $af62ec6a841e10b9$var$Ut = $af62ec6a841e10b9$var$Lt = null, $af62ec6a841e10b9$var$Ft = [], $af62ec6a841e10b9$var$hr();
        var e = t || $af62ec6a841e10b9$var$Or(), r = !0;
        for(t || (e.body = []); $af62ec6a841e10b9$var$xt !== $af62ec6a841e10b9$var$Jt;){
            var n = $af62ec6a841e10b9$var$Fr();
            e.body.push(n), r && $af62ec6a841e10b9$var$xr(n) && $af62ec6a841e10b9$var$wr(!0), r = !1;
        }
        return $af62ec6a841e10b9$var$Tr(e, "Program");
    }($af62ec6a841e10b9$var$mt.program);
}, $af62ec6a841e10b9$var$Mt = {
    ecmaVersion: 5,
    strictSemicolons: !1,
    allowTrailingCommas: !0,
    forbidReserved: !1,
    locations: !1,
    onComment: null,
    ranges: !1,
    program: null,
    sourceFile: null,
    directSourceFile: null
}, $af62ec6a841e10b9$var$Bt = function(t, e) {
    for(var r = 1, n = 0;;){
        $af62ec6a841e10b9$var$ir.lastIndex = n;
        var i = $af62ec6a841e10b9$var$ir.exec(t);
        if (!(i && i.index < e)) break;
        ++r, n = i.index + i[0].length;
    }
    return {
        line: r,
        column: e - n
    };
};
function $af62ec6a841e10b9$var$Vt(t, e) {
    var r = $af62ec6a841e10b9$var$Bt($af62ec6a841e10b9$var$bt, t);
    e += " (" + r.line + ":" + r.column + ")";
    var n = new SyntaxError(e);
    throw n.pos = t, n.loc = r, n.raisedAt = $af62ec6a841e10b9$var$Pt, n;
}
var $af62ec6a841e10b9$var$Gt = [], $af62ec6a841e10b9$var$qt = {
    type: "num"
}, $af62ec6a841e10b9$var$Wt = {
    type: "regexp"
}, $af62ec6a841e10b9$var$Yt = {
    type: "string"
}, $af62ec6a841e10b9$var$zt = {
    type: "name"
}, $af62ec6a841e10b9$var$Jt = {
    type: "eof"
}, $af62ec6a841e10b9$var$Ht = {
    keyword: "break"
}, $af62ec6a841e10b9$var$Xt = {
    keyword: "case",
    beforeExpr: !0
}, $af62ec6a841e10b9$var$Zt = {
    keyword: "catch"
}, $af62ec6a841e10b9$var$$t = {
    keyword: "continue"
}, $af62ec6a841e10b9$var$Kt = {
    keyword: "debugger"
}, $af62ec6a841e10b9$var$Qt = {
    keyword: "default"
}, $af62ec6a841e10b9$var$te = {
    keyword: "do",
    isLoop: !0
}, $af62ec6a841e10b9$var$ee = {
    keyword: "else",
    beforeExpr: !0
}, $af62ec6a841e10b9$var$re = {
    keyword: "finally"
}, $af62ec6a841e10b9$var$ne = {
    keyword: "for",
    isLoop: !0
}, $af62ec6a841e10b9$var$ie = {
    keyword: "function"
}, $af62ec6a841e10b9$var$oe = {
    keyword: "if"
}, $af62ec6a841e10b9$var$se = {
    keyword: "return",
    beforeExpr: !0
}, $af62ec6a841e10b9$var$ae = {
    keyword: "switch"
}, $af62ec6a841e10b9$var$ue = {
    keyword: "throw",
    beforeExpr: !0
}, $af62ec6a841e10b9$var$ce = {
    keyword: "try"
}, $af62ec6a841e10b9$var$le = {
    keyword: "var"
}, $af62ec6a841e10b9$var$pe = {
    keyword: "while",
    isLoop: !0
}, $af62ec6a841e10b9$var$he = {
    keyword: "with"
}, $af62ec6a841e10b9$var$de = {
    keyword: "new",
    beforeExpr: !0
}, $af62ec6a841e10b9$var$fe = {
    keyword: "this"
}, $af62ec6a841e10b9$var$ye = {
    keyword: "null",
    atomValue: null
}, $af62ec6a841e10b9$var$ge = {
    keyword: "true",
    atomValue: !0
}, $af62ec6a841e10b9$var$ve = {
    keyword: "false",
    atomValue: !1
}, $af62ec6a841e10b9$var$me = {
    keyword: "in",
    binop: 7,
    beforeExpr: !0
}, $af62ec6a841e10b9$var$be = {
    break: $af62ec6a841e10b9$var$Ht,
    case: $af62ec6a841e10b9$var$Xt,
    catch: $af62ec6a841e10b9$var$Zt,
    continue: $af62ec6a841e10b9$var$$t,
    debugger: $af62ec6a841e10b9$var$Kt,
    default: $af62ec6a841e10b9$var$Qt,
    do: $af62ec6a841e10b9$var$te,
    else: $af62ec6a841e10b9$var$ee,
    finally: $af62ec6a841e10b9$var$re,
    for: $af62ec6a841e10b9$var$ne,
    function: $af62ec6a841e10b9$var$ie,
    if: $af62ec6a841e10b9$var$oe,
    return: $af62ec6a841e10b9$var$se,
    switch: $af62ec6a841e10b9$var$ae,
    throw: $af62ec6a841e10b9$var$ue,
    try: $af62ec6a841e10b9$var$ce,
    var: $af62ec6a841e10b9$var$le,
    while: $af62ec6a841e10b9$var$pe,
    with: $af62ec6a841e10b9$var$he,
    null: $af62ec6a841e10b9$var$ye,
    true: $af62ec6a841e10b9$var$ge,
    false: $af62ec6a841e10b9$var$ve,
    new: $af62ec6a841e10b9$var$de,
    in: $af62ec6a841e10b9$var$me,
    instanceof: {
        keyword: "instanceof",
        binop: 7,
        beforeExpr: !0
    },
    this: $af62ec6a841e10b9$var$fe,
    typeof: {
        keyword: "typeof",
        prefix: !0,
        beforeExpr: !0
    },
    void: {
        keyword: "void",
        prefix: !0,
        beforeExpr: !0
    },
    delete: {
        keyword: "delete",
        prefix: !0,
        beforeExpr: !0
    }
}, $af62ec6a841e10b9$var$_e = {
    type: "[",
    beforeExpr: !0
}, $af62ec6a841e10b9$var$we = {
    type: "]"
}, $af62ec6a841e10b9$var$Pe = {
    type: "{",
    beforeExpr: !0
}, $af62ec6a841e10b9$var$Ee = {
    type: "}"
}, $af62ec6a841e10b9$var$Oe = {
    type: "(",
    beforeExpr: !0
}, $af62ec6a841e10b9$var$Se = {
    type: ")"
}, $af62ec6a841e10b9$var$Te = {
    type: ",",
    beforeExpr: !0
}, $af62ec6a841e10b9$var$xe = {
    type: ";",
    beforeExpr: !0
}, $af62ec6a841e10b9$var$Ae = {
    type: ":",
    beforeExpr: !0
}, $af62ec6a841e10b9$var$Re = {
    type: "."
}, $af62ec6a841e10b9$var$Ce = {
    type: "?",
    beforeExpr: !0
}, $af62ec6a841e10b9$var$Ne = {
    binop: 10,
    beforeExpr: !0
}, $af62ec6a841e10b9$var$ke = {
    isAssign: !0,
    beforeExpr: !0
}, $af62ec6a841e10b9$var$je = {
    isAssign: !0,
    beforeExpr: !0
}, $af62ec6a841e10b9$var$Ie = {
    postfix: !0,
    prefix: !0,
    isUpdate: !0
}, $af62ec6a841e10b9$var$Ue = {
    prefix: !0,
    beforeExpr: !0
}, $af62ec6a841e10b9$var$Fe = {
    binop: 1,
    beforeExpr: !0
}, $af62ec6a841e10b9$var$Le = {
    binop: 2,
    beforeExpr: !0
}, $af62ec6a841e10b9$var$De = {
    binop: 3,
    beforeExpr: !0
}, $af62ec6a841e10b9$var$Me = {
    binop: 4,
    beforeExpr: !0
}, $af62ec6a841e10b9$var$Be = {
    binop: 5,
    beforeExpr: !0
}, $af62ec6a841e10b9$var$Ve = {
    binop: 6,
    beforeExpr: !0
}, $af62ec6a841e10b9$var$Ge = {
    binop: 7,
    beforeExpr: !0
}, $af62ec6a841e10b9$var$qe = {
    binop: 8,
    beforeExpr: !0
}, $af62ec6a841e10b9$var$We = {
    binop: 9,
    prefix: !0,
    beforeExpr: !0
}, $af62ec6a841e10b9$var$Ye = {
    binop: 10,
    beforeExpr: !0
};
function $af62ec6a841e10b9$var$ze(t) {
    t = t.split(" ");
    var e = "", r = [];
    t: for(var n = 0; n < t.length; ++n){
        for(var i = 0; i < r.length; ++i)if (r[i][0].length == t[n].length) {
            r[i].push(t[n]);
            continue t;
        }
        r.push([
            t[n]
        ]);
    }
    function o(t) {
        if (1 == t.length) return e += "return str === " + JSON.stringify(t[0]) + ";";
        e += "switch(str){";
        for(var r = 0; r < t.length; ++r)e += "case " + JSON.stringify(t[r]) + ":";
        e += "return true}return false;";
    }
    if (r.length > 3) {
        for(r.sort(function(t, e) {
            return e.length - t.length;
        }), e += "switch(str.length){", n = 0; n < r.length; ++n){
            var s = r[n];
            e += "case " + s[0].length + ":", o(s);
        }
        e += "}";
    } else o(t);
    return new Function("str", e);
}
var $af62ec6a841e10b9$var$Je, $af62ec6a841e10b9$var$He = $af62ec6a841e10b9$var$ze("abstract boolean byte char class double enum export extends final float goto implements import int interface long native package private protected public short static super synchronized throws transient volatile"), $af62ec6a841e10b9$var$Xe = $af62ec6a841e10b9$var$ze("class enum extends super const export import"), $af62ec6a841e10b9$var$Ze = $af62ec6a841e10b9$var$ze("implements interface let package private protected public static yield"), $af62ec6a841e10b9$var$$e = $af62ec6a841e10b9$var$ze("eval arguments"), $af62ec6a841e10b9$var$Ke = $af62ec6a841e10b9$var$ze("break case catch continue debugger default do else finally for function if return switch throw try var while with null true false instanceof typeof void delete new in this"), $af62ec6a841e10b9$var$Qe = /[\u1680\u180e\u2000-\u200a\u202f\u205f\u3000\ufeff]/, $af62ec6a841e10b9$var$tr = "\xaa\xb5\xba\xc0-\xd6\xd8-\xf6\xf8-\u02C1\u02C6-\u02D1\u02E0-\u02E4\u02EC\u02EE\u0370-\u0374\u0376\u0377\u037A-\u037D\u0386\u0388-\u038A\u038C\u038E-\u03A1\u03A3-\u03F5\u03F7-\u0481\u048A-\u0527\u0531-\u0556\u0559\u0561-\u0587\u05D0-\u05EA\u05F0-\u05F2\u0620-\u064A\u066E\u066F\u0671-\u06D3\u06D5\u06E5\u06E6\u06EE\u06EF\u06FA-\u06FC\u06FF\u0710\u0712-\u072F\u074D-\u07A5\u07B1\u07CA-\u07EA\u07F4\u07F5\u07FA\u0800-\u0815\u081A\u0824\u0828\u0840-\u0858\u08A0\u08A2-\u08AC\u0904-\u0939\u093D\u0950\u0958-\u0961\u0971-\u0977\u0979-\u097F\u0985-\u098C\u098F\u0990\u0993-\u09A8\u09AA-\u09B0\u09B2\u09B6-\u09B9\u09BD\u09CE\u09DC\u09DD\u09DF-\u09E1\u09F0\u09F1\u0A05-\u0A0A\u0A0F\u0A10\u0A13-\u0A28\u0A2A-\u0A30\u0A32\u0A33\u0A35\u0A36\u0A38\u0A39\u0A59-\u0A5C\u0A5E\u0A72-\u0A74\u0A85-\u0A8D\u0A8F-\u0A91\u0A93-\u0AA8\u0AAA-\u0AB0\u0AB2\u0AB3\u0AB5-\u0AB9\u0ABD\u0AD0\u0AE0\u0AE1\u0B05-\u0B0C\u0B0F\u0B10\u0B13-\u0B28\u0B2A-\u0B30\u0B32\u0B33\u0B35-\u0B39\u0B3D\u0B5C\u0B5D\u0B5F-\u0B61\u0B71\u0B83\u0B85-\u0B8A\u0B8E-\u0B90\u0B92-\u0B95\u0B99\u0B9A\u0B9C\u0B9E\u0B9F\u0BA3\u0BA4\u0BA8-\u0BAA\u0BAE-\u0BB9\u0BD0\u0C05-\u0C0C\u0C0E-\u0C10\u0C12-\u0C28\u0C2A-\u0C33\u0C35-\u0C39\u0C3D\u0C58\u0C59\u0C60\u0C61\u0C85-\u0C8C\u0C8E-\u0C90\u0C92-\u0CA8\u0CAA-\u0CB3\u0CB5-\u0CB9\u0CBD\u0CDE\u0CE0\u0CE1\u0CF1\u0CF2\u0D05-\u0D0C\u0D0E-\u0D10\u0D12-\u0D3A\u0D3D\u0D4E\u0D60\u0D61\u0D7A-\u0D7F\u0D85-\u0D96\u0D9A-\u0DB1\u0DB3-\u0DBB\u0DBD\u0DC0-\u0DC6\u0E01-\u0E30\u0E32\u0E33\u0E40-\u0E46\u0E81\u0E82\u0E84\u0E87\u0E88\u0E8A\u0E8D\u0E94-\u0E97\u0E99-\u0E9F\u0EA1-\u0EA3\u0EA5\u0EA7\u0EAA\u0EAB\u0EAD-\u0EB0\u0EB2\u0EB3\u0EBD\u0EC0-\u0EC4\u0EC6\u0EDC-\u0EDF\u0F00\u0F40-\u0F47\u0F49-\u0F6C\u0F88-\u0F8C\u1000-\u102A\u103F\u1050-\u1055\u105A-\u105D\u1061\u1065\u1066\u106E-\u1070\u1075-\u1081\u108E\u10A0-\u10C5\u10C7\u10CD\u10D0-\u10FA\u10FC-\u1248\u124A-\u124D\u1250-\u1256\u1258\u125A-\u125D\u1260-\u1288\u128A-\u128D\u1290-\u12B0\u12B2-\u12B5\u12B8-\u12BE\u12C0\u12C2-\u12C5\u12C8-\u12D6\u12D8-\u1310\u1312-\u1315\u1318-\u135A\u1380-\u138F\u13A0-\u13F4\u1401-\u166C\u166F-\u167F\u1681-\u169A\u16A0-\u16EA\u16EE-\u16F0\u1700-\u170C\u170E-\u1711\u1720-\u1731\u1740-\u1751\u1760-\u176C\u176E-\u1770\u1780-\u17B3\u17D7\u17DC\u1820-\u1877\u1880-\u18A8\u18AA\u18B0-\u18F5\u1900-\u191C\u1950-\u196D\u1970-\u1974\u1980-\u19AB\u19C1-\u19C7\u1A00-\u1A16\u1A20-\u1A54\u1AA7\u1B05-\u1B33\u1B45-\u1B4B\u1B83-\u1BA0\u1BAE\u1BAF\u1BBA-\u1BE5\u1C00-\u1C23\u1C4D-\u1C4F\u1C5A-\u1C7D\u1CE9-\u1CEC\u1CEE-\u1CF1\u1CF5\u1CF6\u1D00-\u1DBF\u1E00-\u1F15\u1F18-\u1F1D\u1F20-\u1F45\u1F48-\u1F4D\u1F50-\u1F57\u1F59\u1F5B\u1F5D\u1F5F-\u1F7D\u1F80-\u1FB4\u1FB6-\u1FBC\u1FBE\u1FC2-\u1FC4\u1FC6-\u1FCC\u1FD0-\u1FD3\u1FD6-\u1FDB\u1FE0-\u1FEC\u1FF2-\u1FF4\u1FF6-\u1FFC\u2071\u207F\u2090-\u209C\u2102\u2107\u210A-\u2113\u2115\u2119-\u211D\u2124\u2126\u2128\u212A-\u212D\u212F-\u2139\u213C-\u213F\u2145-\u2149\u214E\u2160-\u2188\u2C00-\u2C2E\u2C30-\u2C5E\u2C60-\u2CE4\u2CEB-\u2CEE\u2CF2\u2CF3\u2D00-\u2D25\u2D27\u2D2D\u2D30-\u2D67\u2D6F\u2D80-\u2D96\u2DA0-\u2DA6\u2DA8-\u2DAE\u2DB0-\u2DB6\u2DB8-\u2DBE\u2DC0-\u2DC6\u2DC8-\u2DCE\u2DD0-\u2DD6\u2DD8-\u2DDE\u2E2F\u3005-\u3007\u3021-\u3029\u3031-\u3035\u3038-\u303C\u3041-\u3096\u309D-\u309F\u30A1-\u30FA\u30FC-\u30FF\u3105-\u312D\u3131-\u318E\u31A0-\u31BA\u31F0-\u31FF\u3400-\u4DB5\u4E00-\u9FCC\uA000-\uA48C\uA4D0-\uA4FD\uA500-\uA60C\uA610-\uA61F\uA62A\uA62B\uA640-\uA66E\uA67F-\uA697\uA6A0-\uA6EF\uA717-\uA71F\uA722-\uA788\uA78B-\uA78E\uA790-\uA793\uA7A0-\uA7AA\uA7F8-\uA801\uA803-\uA805\uA807-\uA80A\uA80C-\uA822\uA840-\uA873\uA882-\uA8B3\uA8F2-\uA8F7\uA8FB\uA90A-\uA925\uA930-\uA946\uA960-\uA97C\uA984-\uA9B2\uA9CF\uAA00-\uAA28\uAA40-\uAA42\uAA44-\uAA4B\uAA60-\uAA76\uAA7A\uAA80-\uAAAF\uAAB1\uAAB5\uAAB6\uAAB9-\uAABD\uAAC0\uAAC2\uAADB-\uAADD\uAAE0-\uAAEA\uAAF2-\uAAF4\uAB01-\uAB06\uAB09-\uAB0E\uAB11-\uAB16\uAB20-\uAB26\uAB28-\uAB2E\uABC0-\uABE2\uAC00-\uD7A3\uD7B0-\uD7C6\uD7CB-\uD7FB\uF900-\uFA6D\uFA70-\uFAD9\uFB00-\uFB06\uFB13-\uFB17\uFB1D\uFB1F-\uFB28\uFB2A-\uFB36\uFB38-\uFB3C\uFB3E\uFB40\uFB41\uFB43\uFB44\uFB46-\uFBB1\uFBD3-\uFD3D\uFD50-\uFD8F\uFD92-\uFDC7\uFDF0-\uFDFB\uFE70-\uFE74\uFE76-\uFEFC\uFF21-\uFF3A\uFF41-\uFF5A\uFF66-\uFFBE\uFFC2-\uFFC7\uFFCA-\uFFCF\uFFD2-\uFFD7\uFFDA-\uFFDC", $af62ec6a841e10b9$var$er = new RegExp("[" + $af62ec6a841e10b9$var$tr + "]"), $af62ec6a841e10b9$var$rr = new RegExp("[" + $af62ec6a841e10b9$var$tr + "\u0300-\u036F\u0483-\u0487\u0591-\u05BD\u05BF\u05C1\u05C2\u05C4\u05C5\u05C7\u0610-\u061A\u0620-\u0649\u0672-\u06D3\u06E7-\u06E8\u06FB-\u06FC\u0730-\u074A\u0800-\u0814\u081B-\u0823\u0825-\u0827\u0829-\u082D\u0840-\u0857\u08E4-\u08FE\u0900-\u0903\u093A-\u093C\u093E-\u094F\u0951-\u0957\u0962-\u0963\u0966-\u096F\u0981-\u0983\u09BC\u09BE-\u09C4\u09C7\u09C8\u09D7\u09DF-\u09E0\u0A01-\u0A03\u0A3C\u0A3E-\u0A42\u0A47\u0A48\u0A4B-\u0A4D\u0A51\u0A66-\u0A71\u0A75\u0A81-\u0A83\u0ABC\u0ABE-\u0AC5\u0AC7-\u0AC9\u0ACB-\u0ACD\u0AE2-\u0AE3\u0AE6-\u0AEF\u0B01-\u0B03\u0B3C\u0B3E-\u0B44\u0B47\u0B48\u0B4B-\u0B4D\u0B56\u0B57\u0B5F-\u0B60\u0B66-\u0B6F\u0B82\u0BBE-\u0BC2\u0BC6-\u0BC8\u0BCA-\u0BCD\u0BD7\u0BE6-\u0BEF\u0C01-\u0C03\u0C46-\u0C48\u0C4A-\u0C4D\u0C55\u0C56\u0C62-\u0C63\u0C66-\u0C6F\u0C82\u0C83\u0CBC\u0CBE-\u0CC4\u0CC6-\u0CC8\u0CCA-\u0CCD\u0CD5\u0CD6\u0CE2-\u0CE3\u0CE6-\u0CEF\u0D02\u0D03\u0D46-\u0D48\u0D57\u0D62-\u0D63\u0D66-\u0D6F\u0D82\u0D83\u0DCA\u0DCF-\u0DD4\u0DD6\u0DD8-\u0DDF\u0DF2\u0DF3\u0E34-\u0E3A\u0E40-\u0E45\u0E50-\u0E59\u0EB4-\u0EB9\u0EC8-\u0ECD\u0ED0-\u0ED9\u0F18\u0F19\u0F20-\u0F29\u0F35\u0F37\u0F39\u0F41-\u0F47\u0F71-\u0F84\u0F86-\u0F87\u0F8D-\u0F97\u0F99-\u0FBC\u0FC6\u1000-\u1029\u1040-\u1049\u1067-\u106D\u1071-\u1074\u1082-\u108D\u108F-\u109D\u135D-\u135F\u170E-\u1710\u1720-\u1730\u1740-\u1750\u1772\u1773\u1780-\u17B2\u17DD\u17E0-\u17E9\u180B-\u180D\u1810-\u1819\u1920-\u192B\u1930-\u193B\u1951-\u196D\u19B0-\u19C0\u19C8-\u19C9\u19D0-\u19D9\u1A00-\u1A15\u1A20-\u1A53\u1A60-\u1A7C\u1A7F-\u1A89\u1A90-\u1A99\u1B46-\u1B4B\u1B50-\u1B59\u1B6B-\u1B73\u1BB0-\u1BB9\u1BE6-\u1BF3\u1C00-\u1C22\u1C40-\u1C49\u1C5B-\u1C7D\u1CD0-\u1CD2\u1D00-\u1DBE\u1E01-\u1F15\u200C\u200D\u203F\u2040\u2054\u20D0-\u20DC\u20E1\u20E5-\u20F0\u2D81-\u2D96\u2DE0-\u2DFF\u3021-\u3028\u3099\u309A\uA640-\uA66D\uA674-\uA67D\uA69F\uA6F0-\uA6F1\uA7F8-\uA800\uA806\uA80B\uA823-\uA827\uA880-\uA881\uA8B4-\uA8C4\uA8D0-\uA8D9\uA8F3-\uA8F7\uA900-\uA909\uA926-\uA92D\uA930-\uA945\uA980-\uA983\uA9B3-\uA9C0\uAA00-\uAA27\uAA40-\uAA41\uAA4C-\uAA4D\uAA50-\uAA59\uAA7B\uAAE0-\uAAE9\uAAF2-\uAAF3\uABC0-\uABE1\uABEC\uABED\uABF0-\uABF9\uFB20-\uFB28\uFE00-\uFE0F\uFE20-\uFE26\uFE33\uFE34\uFE4D-\uFE4F\uFF10-\uFF19\uFF3F]"), $af62ec6a841e10b9$var$nr = /[\n\r\u2028\u2029]/, $af62ec6a841e10b9$var$ir = /\r\n|[\n\r\u2028\u2029]/g, $af62ec6a841e10b9$var$or = function(t) {
    return t < 65 ? 36 === t : t < 91 || (t < 97 ? 95 === t : t < 123 || t >= 170 && $af62ec6a841e10b9$var$er.test(String.fromCharCode(t)));
}, $af62ec6a841e10b9$var$sr = function(t) {
    return t < 48 ? 36 === t : t < 58 || !(t < 65) && (t < 91 || (t < 97 ? 95 === t : t < 123 || t >= 170 && $af62ec6a841e10b9$var$rr.test(String.fromCharCode(t))));
};
function $af62ec6a841e10b9$var$ar() {
    this.line = $af62ec6a841e10b9$var$Ct, this.column = $af62ec6a841e10b9$var$Pt - $af62ec6a841e10b9$var$Nt;
}
function $af62ec6a841e10b9$var$ur(t, e) {
    $af62ec6a841e10b9$var$Ot = $af62ec6a841e10b9$var$Pt, $af62ec6a841e10b9$var$mt.locations && ($af62ec6a841e10b9$var$Tt = new $af62ec6a841e10b9$var$ar), $af62ec6a841e10b9$var$xt = t, $af62ec6a841e10b9$var$pr(), $af62ec6a841e10b9$var$At = e, $af62ec6a841e10b9$var$Rt = t.beforeExpr;
}
function $af62ec6a841e10b9$var$cr() {
    var t, e = $af62ec6a841e10b9$var$mt.onComment && $af62ec6a841e10b9$var$mt.locations && new $af62ec6a841e10b9$var$ar, r = $af62ec6a841e10b9$var$Pt, n = $af62ec6a841e10b9$var$bt.indexOf("*/", $af62ec6a841e10b9$var$Pt += 2);
    if (-1 === n && $af62ec6a841e10b9$var$Vt($af62ec6a841e10b9$var$Pt - 2, "Unterminated comment"), $af62ec6a841e10b9$var$Pt = n + 2, $af62ec6a841e10b9$var$mt.locations) for($af62ec6a841e10b9$var$ir.lastIndex = r; (t = $af62ec6a841e10b9$var$ir.exec($af62ec6a841e10b9$var$bt)) && t.index < $af62ec6a841e10b9$var$Pt;)++$af62ec6a841e10b9$var$Ct, $af62ec6a841e10b9$var$Nt = t.index + t[0].length;
    $af62ec6a841e10b9$var$mt.onComment && $af62ec6a841e10b9$var$mt.onComment(!0, $af62ec6a841e10b9$var$bt.slice(r + 2, n), r, $af62ec6a841e10b9$var$Pt, e, $af62ec6a841e10b9$var$mt.locations && new $af62ec6a841e10b9$var$ar);
}
function $af62ec6a841e10b9$var$lr() {
    for(var t = $af62ec6a841e10b9$var$Pt, e = $af62ec6a841e10b9$var$mt.onComment && $af62ec6a841e10b9$var$mt.locations && new $af62ec6a841e10b9$var$ar, r = $af62ec6a841e10b9$var$bt.charCodeAt($af62ec6a841e10b9$var$Pt += 2); $af62ec6a841e10b9$var$Pt < $af62ec6a841e10b9$var$_t && 10 !== r && 13 !== r && 8232 !== r && 8233 !== r;)++$af62ec6a841e10b9$var$Pt, r = $af62ec6a841e10b9$var$bt.charCodeAt($af62ec6a841e10b9$var$Pt);
    $af62ec6a841e10b9$var$mt.onComment && $af62ec6a841e10b9$var$mt.onComment(!1, $af62ec6a841e10b9$var$bt.slice(t + 2, $af62ec6a841e10b9$var$Pt), t, $af62ec6a841e10b9$var$Pt, e, $af62ec6a841e10b9$var$mt.locations && new $af62ec6a841e10b9$var$ar);
}
function $af62ec6a841e10b9$var$pr() {
    for(; $af62ec6a841e10b9$var$Pt < $af62ec6a841e10b9$var$_t;){
        var t = $af62ec6a841e10b9$var$bt.charCodeAt($af62ec6a841e10b9$var$Pt);
        if (32 === t) ++$af62ec6a841e10b9$var$Pt;
        else if (13 === t) ++$af62ec6a841e10b9$var$Pt, 10 === (e = $af62ec6a841e10b9$var$bt.charCodeAt($af62ec6a841e10b9$var$Pt)) && ++$af62ec6a841e10b9$var$Pt, $af62ec6a841e10b9$var$mt.locations && (++$af62ec6a841e10b9$var$Ct, $af62ec6a841e10b9$var$Nt = $af62ec6a841e10b9$var$Pt);
        else if (10 === t || 8232 === t || 8233 === t) ++$af62ec6a841e10b9$var$Pt, $af62ec6a841e10b9$var$mt.locations && (++$af62ec6a841e10b9$var$Ct, $af62ec6a841e10b9$var$Nt = $af62ec6a841e10b9$var$Pt);
        else if (t > 8 && t < 14) ++$af62ec6a841e10b9$var$Pt;
        else if (47 === t) {
            var e;
            if (42 === (e = $af62ec6a841e10b9$var$bt.charCodeAt($af62ec6a841e10b9$var$Pt + 1))) $af62ec6a841e10b9$var$cr();
            else {
                if (47 !== e) break;
                $af62ec6a841e10b9$var$lr();
            }
        } else if (160 === t) ++$af62ec6a841e10b9$var$Pt;
        else {
            if (!(t >= 5760 && $af62ec6a841e10b9$var$Qe.test(String.fromCharCode(t)))) break;
            ++$af62ec6a841e10b9$var$Pt;
        }
    }
}
function $af62ec6a841e10b9$var$hr(t) {
    if (t ? $af62ec6a841e10b9$var$Pt = $af62ec6a841e10b9$var$Et + 1 : $af62ec6a841e10b9$var$Et = $af62ec6a841e10b9$var$Pt, $af62ec6a841e10b9$var$mt.locations && ($af62ec6a841e10b9$var$St = new $af62ec6a841e10b9$var$ar), t) return $af62ec6a841e10b9$var$fr();
    if ($af62ec6a841e10b9$var$Pt >= $af62ec6a841e10b9$var$_t) return $af62ec6a841e10b9$var$ur($af62ec6a841e10b9$var$Jt);
    var e = $af62ec6a841e10b9$var$bt.charCodeAt($af62ec6a841e10b9$var$Pt);
    if ($af62ec6a841e10b9$var$or(e) || 92 === e) return $af62ec6a841e10b9$var$br();
    var r = function(t) {
        switch(t){
            case 46:
                return function() {
                    var t = $af62ec6a841e10b9$var$bt.charCodeAt($af62ec6a841e10b9$var$Pt + 1);
                    return t >= 48 && t <= 57 ? $af62ec6a841e10b9$var$gr(!0) : (++$af62ec6a841e10b9$var$Pt, $af62ec6a841e10b9$var$ur($af62ec6a841e10b9$var$Re));
                }();
            case 40:
                return ++$af62ec6a841e10b9$var$Pt, $af62ec6a841e10b9$var$ur($af62ec6a841e10b9$var$Oe);
            case 41:
                return ++$af62ec6a841e10b9$var$Pt, $af62ec6a841e10b9$var$ur($af62ec6a841e10b9$var$Se);
            case 59:
                return ++$af62ec6a841e10b9$var$Pt, $af62ec6a841e10b9$var$ur($af62ec6a841e10b9$var$xe);
            case 44:
                return ++$af62ec6a841e10b9$var$Pt, $af62ec6a841e10b9$var$ur($af62ec6a841e10b9$var$Te);
            case 91:
                return ++$af62ec6a841e10b9$var$Pt, $af62ec6a841e10b9$var$ur($af62ec6a841e10b9$var$_e);
            case 93:
                return ++$af62ec6a841e10b9$var$Pt, $af62ec6a841e10b9$var$ur($af62ec6a841e10b9$var$we);
            case 123:
                return ++$af62ec6a841e10b9$var$Pt, $af62ec6a841e10b9$var$ur($af62ec6a841e10b9$var$Pe);
            case 125:
                return ++$af62ec6a841e10b9$var$Pt, $af62ec6a841e10b9$var$ur($af62ec6a841e10b9$var$Ee);
            case 58:
                return ++$af62ec6a841e10b9$var$Pt, $af62ec6a841e10b9$var$ur($af62ec6a841e10b9$var$Ae);
            case 63:
                return ++$af62ec6a841e10b9$var$Pt, $af62ec6a841e10b9$var$ur($af62ec6a841e10b9$var$Ce);
            case 48:
                var e = $af62ec6a841e10b9$var$bt.charCodeAt($af62ec6a841e10b9$var$Pt + 1);
                if (120 === e || 88 === e) return function() {
                    $af62ec6a841e10b9$var$Pt += 2;
                    var t = $af62ec6a841e10b9$var$yr(16);
                    return null == t && $af62ec6a841e10b9$var$Vt($af62ec6a841e10b9$var$Et + 2, "Expected hexadecimal number"), $af62ec6a841e10b9$var$or($af62ec6a841e10b9$var$bt.charCodeAt($af62ec6a841e10b9$var$Pt)) && $af62ec6a841e10b9$var$Vt($af62ec6a841e10b9$var$Pt, "Identifier directly after number"), $af62ec6a841e10b9$var$ur($af62ec6a841e10b9$var$qt, t);
                }();
            case 49:
            case 50:
            case 51:
            case 52:
            case 53:
            case 54:
            case 55:
            case 56:
            case 57:
                return $af62ec6a841e10b9$var$gr(!1);
            case 34:
            case 39:
                return function(t) {
                    $af62ec6a841e10b9$var$Pt++;
                    for(var e = "";;){
                        $af62ec6a841e10b9$var$Pt >= $af62ec6a841e10b9$var$_t && $af62ec6a841e10b9$var$Vt($af62ec6a841e10b9$var$Et, "Unterminated string constant");
                        var r = $af62ec6a841e10b9$var$bt.charCodeAt($af62ec6a841e10b9$var$Pt);
                        if (r === t) return ++$af62ec6a841e10b9$var$Pt, $af62ec6a841e10b9$var$ur($af62ec6a841e10b9$var$Yt, e);
                        if (92 === r) {
                            r = $af62ec6a841e10b9$var$bt.charCodeAt(++$af62ec6a841e10b9$var$Pt);
                            var n = /^[0-7]+/.exec($af62ec6a841e10b9$var$bt.slice($af62ec6a841e10b9$var$Pt, $af62ec6a841e10b9$var$Pt + 3));
                            for(n && (n = n[0]); n && parseInt(n, 8) > 255;)n = n.slice(0, -1);
                            if ("0" === n && (n = null), ++$af62ec6a841e10b9$var$Pt, n) $af62ec6a841e10b9$var$Lt && $af62ec6a841e10b9$var$Vt($af62ec6a841e10b9$var$Pt - 2, "Octal literal in strict mode"), e += String.fromCharCode(parseInt(n, 8)), $af62ec6a841e10b9$var$Pt += n.length - 1;
                            else switch(r){
                                case 110:
                                    e += "\n";
                                    break;
                                case 114:
                                    e += "\r";
                                    break;
                                case 120:
                                    e += String.fromCharCode($af62ec6a841e10b9$var$vr(2));
                                    break;
                                case 117:
                                    e += String.fromCharCode($af62ec6a841e10b9$var$vr(4));
                                    break;
                                case 85:
                                    e += String.fromCharCode($af62ec6a841e10b9$var$vr(8));
                                    break;
                                case 116:
                                    e += "\t";
                                    break;
                                case 98:
                                    e += "\b";
                                    break;
                                case 118:
                                    e += "\v";
                                    break;
                                case 102:
                                    e += "\f";
                                    break;
                                case 48:
                                    e += "\0";
                                    break;
                                case 13:
                                    10 === $af62ec6a841e10b9$var$bt.charCodeAt($af62ec6a841e10b9$var$Pt) && ++$af62ec6a841e10b9$var$Pt;
                                case 10:
                                    $af62ec6a841e10b9$var$mt.locations && ($af62ec6a841e10b9$var$Nt = $af62ec6a841e10b9$var$Pt, ++$af62ec6a841e10b9$var$Ct);
                                    break;
                                default:
                                    e += String.fromCharCode(r);
                            }
                        } else 13 !== r && 10 !== r && 8232 !== r && 8233 !== r || $af62ec6a841e10b9$var$Vt($af62ec6a841e10b9$var$Et, "Unterminated string constant"), e += String.fromCharCode(r), ++$af62ec6a841e10b9$var$Pt;
                    }
                }(t);
            case 47:
                return function(t) {
                    var e = $af62ec6a841e10b9$var$bt.charCodeAt($af62ec6a841e10b9$var$Pt + 1);
                    return $af62ec6a841e10b9$var$Rt ? (++$af62ec6a841e10b9$var$Pt, $af62ec6a841e10b9$var$fr()) : 61 === e ? $af62ec6a841e10b9$var$dr($af62ec6a841e10b9$var$je, 2) : $af62ec6a841e10b9$var$dr($af62ec6a841e10b9$var$Ne, 1);
                }();
            case 37:
            case 42:
                return 61 === $af62ec6a841e10b9$var$bt.charCodeAt($af62ec6a841e10b9$var$Pt + 1) ? $af62ec6a841e10b9$var$dr($af62ec6a841e10b9$var$je, 2) : $af62ec6a841e10b9$var$dr($af62ec6a841e10b9$var$Ye, 1);
            case 124:
            case 38:
                return function(t) {
                    var e = $af62ec6a841e10b9$var$bt.charCodeAt($af62ec6a841e10b9$var$Pt + 1);
                    return e === t ? $af62ec6a841e10b9$var$dr(124 === t ? $af62ec6a841e10b9$var$Fe : $af62ec6a841e10b9$var$Le, 2) : 61 === e ? $af62ec6a841e10b9$var$dr($af62ec6a841e10b9$var$je, 2) : $af62ec6a841e10b9$var$dr(124 === t ? $af62ec6a841e10b9$var$De : $af62ec6a841e10b9$var$Be, 1);
                }(t);
            case 94:
                return 61 === $af62ec6a841e10b9$var$bt.charCodeAt($af62ec6a841e10b9$var$Pt + 1) ? $af62ec6a841e10b9$var$dr($af62ec6a841e10b9$var$je, 2) : $af62ec6a841e10b9$var$dr($af62ec6a841e10b9$var$Me, 1);
            case 43:
            case 45:
                return function(t) {
                    var e = $af62ec6a841e10b9$var$bt.charCodeAt($af62ec6a841e10b9$var$Pt + 1);
                    return e === t ? 45 == e && 62 == $af62ec6a841e10b9$var$bt.charCodeAt($af62ec6a841e10b9$var$Pt + 2) && $af62ec6a841e10b9$var$nr.test($af62ec6a841e10b9$var$bt.slice($af62ec6a841e10b9$var$jt, $af62ec6a841e10b9$var$Pt)) ? ($af62ec6a841e10b9$var$Pt += 3, $af62ec6a841e10b9$var$lr(), $af62ec6a841e10b9$var$pr(), $af62ec6a841e10b9$var$hr()) : $af62ec6a841e10b9$var$dr($af62ec6a841e10b9$var$Ie, 2) : 61 === e ? $af62ec6a841e10b9$var$dr($af62ec6a841e10b9$var$je, 2) : $af62ec6a841e10b9$var$dr($af62ec6a841e10b9$var$We, 1);
                }(t);
            case 60:
            case 62:
                return function(t) {
                    var e = $af62ec6a841e10b9$var$bt.charCodeAt($af62ec6a841e10b9$var$Pt + 1), r = 1;
                    return e === t ? (r = 62 === t && 62 === $af62ec6a841e10b9$var$bt.charCodeAt($af62ec6a841e10b9$var$Pt + 2) ? 3 : 2, 61 === $af62ec6a841e10b9$var$bt.charCodeAt($af62ec6a841e10b9$var$Pt + r) ? $af62ec6a841e10b9$var$dr($af62ec6a841e10b9$var$je, r + 1) : $af62ec6a841e10b9$var$dr($af62ec6a841e10b9$var$qe, r)) : 33 == e && 60 == t && 45 == $af62ec6a841e10b9$var$bt.charCodeAt($af62ec6a841e10b9$var$Pt + 2) && 45 == $af62ec6a841e10b9$var$bt.charCodeAt($af62ec6a841e10b9$var$Pt + 3) ? ($af62ec6a841e10b9$var$Pt += 4, $af62ec6a841e10b9$var$lr(), $af62ec6a841e10b9$var$pr(), $af62ec6a841e10b9$var$hr()) : (61 === e && (r = 61 === $af62ec6a841e10b9$var$bt.charCodeAt($af62ec6a841e10b9$var$Pt + 2) ? 3 : 2), $af62ec6a841e10b9$var$dr($af62ec6a841e10b9$var$Ge, r));
                }(t);
            case 61:
            case 33:
                return function(t) {
                    return 61 === $af62ec6a841e10b9$var$bt.charCodeAt($af62ec6a841e10b9$var$Pt + 1) ? $af62ec6a841e10b9$var$dr($af62ec6a841e10b9$var$Ve, 61 === $af62ec6a841e10b9$var$bt.charCodeAt($af62ec6a841e10b9$var$Pt + 2) ? 3 : 2) : $af62ec6a841e10b9$var$dr(61 === t ? $af62ec6a841e10b9$var$ke : $af62ec6a841e10b9$var$Ue, 1);
                }(t);
            case 126:
                return $af62ec6a841e10b9$var$dr($af62ec6a841e10b9$var$Ue, 1);
        }
        return !1;
    }(e);
    if (!1 === r) {
        var n = String.fromCharCode(e);
        if ("\\" === n || $af62ec6a841e10b9$var$er.test(n)) return $af62ec6a841e10b9$var$br();
        $af62ec6a841e10b9$var$Vt($af62ec6a841e10b9$var$Pt, "Unexpected character '" + n + "'");
    }
    return r;
}
function $af62ec6a841e10b9$var$dr(t, e) {
    var r = $af62ec6a841e10b9$var$bt.slice($af62ec6a841e10b9$var$Pt, $af62ec6a841e10b9$var$Pt + e);
    $af62ec6a841e10b9$var$Pt += e, $af62ec6a841e10b9$var$ur(t, r);
}
function $af62ec6a841e10b9$var$fr() {
    for(var t, e, r = $af62ec6a841e10b9$var$Pt;;){
        $af62ec6a841e10b9$var$Pt >= $af62ec6a841e10b9$var$_t && $af62ec6a841e10b9$var$Vt(r, "Unterminated regular expression");
        var n = $af62ec6a841e10b9$var$bt.charAt($af62ec6a841e10b9$var$Pt);
        if ($af62ec6a841e10b9$var$nr.test(n) && $af62ec6a841e10b9$var$Vt(r, "Unterminated regular expression"), t) t = !1;
        else {
            if ("[" === n) e = !0;
            else if ("]" === n && e) e = !1;
            else if ("/" === n && !e) break;
            t = "\\" === n;
        }
        ++$af62ec6a841e10b9$var$Pt;
    }
    var i = $af62ec6a841e10b9$var$bt.slice(r, $af62ec6a841e10b9$var$Pt);
    ++$af62ec6a841e10b9$var$Pt;
    var o = $af62ec6a841e10b9$var$mr();
    return o && !/^[gmsiy]*$/.test(o) && $af62ec6a841e10b9$var$Vt(r, "Invalid regexp flag"), $af62ec6a841e10b9$var$ur($af62ec6a841e10b9$var$Wt, new RegExp(i, o));
}
function $af62ec6a841e10b9$var$yr(t, e) {
    for(var r = $af62ec6a841e10b9$var$Pt, n = 0, i = 0, o = null == e ? 1 / 0 : e; i < o; ++i){
        var s, a = $af62ec6a841e10b9$var$bt.charCodeAt($af62ec6a841e10b9$var$Pt);
        if ((s = a >= 97 ? a - 97 + 10 : a >= 65 ? a - 65 + 10 : a >= 48 && a <= 57 ? a - 48 : 1 / 0) >= t) break;
        ++$af62ec6a841e10b9$var$Pt, n = n * t + s;
    }
    return $af62ec6a841e10b9$var$Pt === r || null != e && $af62ec6a841e10b9$var$Pt - r !== e ? null : n;
}
function $af62ec6a841e10b9$var$gr(t) {
    var e = $af62ec6a841e10b9$var$Pt, r = !1, n = 48 === $af62ec6a841e10b9$var$bt.charCodeAt($af62ec6a841e10b9$var$Pt);
    t || null !== $af62ec6a841e10b9$var$yr(10) || $af62ec6a841e10b9$var$Vt(e, "Invalid number"), 46 === $af62ec6a841e10b9$var$bt.charCodeAt($af62ec6a841e10b9$var$Pt) && (++$af62ec6a841e10b9$var$Pt, $af62ec6a841e10b9$var$yr(10), r = !0);
    var i = $af62ec6a841e10b9$var$bt.charCodeAt($af62ec6a841e10b9$var$Pt);
    69 !== i && 101 !== i || (43 !== (i = $af62ec6a841e10b9$var$bt.charCodeAt(++$af62ec6a841e10b9$var$Pt)) && 45 !== i || ++$af62ec6a841e10b9$var$Pt, null === $af62ec6a841e10b9$var$yr(10) && $af62ec6a841e10b9$var$Vt(e, "Invalid number"), r = !0), $af62ec6a841e10b9$var$or($af62ec6a841e10b9$var$bt.charCodeAt($af62ec6a841e10b9$var$Pt)) && $af62ec6a841e10b9$var$Vt($af62ec6a841e10b9$var$Pt, "Identifier directly after number");
    var o, s = $af62ec6a841e10b9$var$bt.slice(e, $af62ec6a841e10b9$var$Pt);
    return r ? o = parseFloat(s) : n && 1 !== s.length ? /[89]/.test(s) || $af62ec6a841e10b9$var$Lt ? $af62ec6a841e10b9$var$Vt(e, "Invalid number") : o = parseInt(s, 8) : o = parseInt(s, 10), $af62ec6a841e10b9$var$ur($af62ec6a841e10b9$var$qt, o);
}
function $af62ec6a841e10b9$var$vr(t) {
    var e = $af62ec6a841e10b9$var$yr(16, t);
    return null === e && $af62ec6a841e10b9$var$Vt($af62ec6a841e10b9$var$Et, "Bad character escape sequence"), e;
}
function $af62ec6a841e10b9$var$mr() {
    $af62ec6a841e10b9$var$Je = !1;
    for(var t, e = !0, r = $af62ec6a841e10b9$var$Pt;;){
        var n = $af62ec6a841e10b9$var$bt.charCodeAt($af62ec6a841e10b9$var$Pt);
        if ($af62ec6a841e10b9$var$sr(n)) $af62ec6a841e10b9$var$Je && (t += $af62ec6a841e10b9$var$bt.charAt($af62ec6a841e10b9$var$Pt)), ++$af62ec6a841e10b9$var$Pt;
        else {
            if (92 !== n) break;
            $af62ec6a841e10b9$var$Je || (t = $af62ec6a841e10b9$var$bt.slice(r, $af62ec6a841e10b9$var$Pt)), $af62ec6a841e10b9$var$Je = !0, 117 != $af62ec6a841e10b9$var$bt.charCodeAt(++$af62ec6a841e10b9$var$Pt) && $af62ec6a841e10b9$var$Vt($af62ec6a841e10b9$var$Pt, "Expecting Unicode escape sequence \\uXXXX"), ++$af62ec6a841e10b9$var$Pt;
            var i = $af62ec6a841e10b9$var$vr(4), o = String.fromCharCode(i);
            o || $af62ec6a841e10b9$var$Vt($af62ec6a841e10b9$var$Pt - 1, "Invalid Unicode escape"), (e ? $af62ec6a841e10b9$var$or(i) : $af62ec6a841e10b9$var$sr(i)) || $af62ec6a841e10b9$var$Vt($af62ec6a841e10b9$var$Pt - 4, "Invalid Unicode escape"), t += o;
        }
        e = !1;
    }
    return $af62ec6a841e10b9$var$Je ? t : $af62ec6a841e10b9$var$bt.slice(r, $af62ec6a841e10b9$var$Pt);
}
function $af62ec6a841e10b9$var$br() {
    var t = $af62ec6a841e10b9$var$mr(), e = $af62ec6a841e10b9$var$zt;
    return $af62ec6a841e10b9$var$Je || ($af62ec6a841e10b9$var$Ke(t) ? e = $af62ec6a841e10b9$var$be[t] : ($af62ec6a841e10b9$var$mt.forbidReserved && (3 === $af62ec6a841e10b9$var$mt.ecmaVersion ? $af62ec6a841e10b9$var$He : $af62ec6a841e10b9$var$Xe)(t) || $af62ec6a841e10b9$var$Lt && $af62ec6a841e10b9$var$Ze(t)) && $af62ec6a841e10b9$var$Vt($af62ec6a841e10b9$var$Et, "The keyword '" + t + "' is reserved")), $af62ec6a841e10b9$var$ur(e, t);
}
function $af62ec6a841e10b9$var$_r() {
    $af62ec6a841e10b9$var$kt = $af62ec6a841e10b9$var$Et, $af62ec6a841e10b9$var$jt = $af62ec6a841e10b9$var$Ot, $af62ec6a841e10b9$var$It = $af62ec6a841e10b9$var$Tt, $af62ec6a841e10b9$var$hr();
}
function $af62ec6a841e10b9$var$wr(t) {
    if ($af62ec6a841e10b9$var$Lt = t, $af62ec6a841e10b9$var$Pt = $af62ec6a841e10b9$var$jt, $af62ec6a841e10b9$var$mt.locations) for(; $af62ec6a841e10b9$var$Pt < $af62ec6a841e10b9$var$Nt;)$af62ec6a841e10b9$var$Nt = $af62ec6a841e10b9$var$bt.lastIndexOf("\n", $af62ec6a841e10b9$var$Nt - 2) + 1, --$af62ec6a841e10b9$var$Ct;
    $af62ec6a841e10b9$var$pr(), $af62ec6a841e10b9$var$hr();
}
function $af62ec6a841e10b9$var$Pr() {
    this.type = null, this.start = $af62ec6a841e10b9$var$Et, this.end = null;
}
function $af62ec6a841e10b9$var$Er() {
    this.start = $af62ec6a841e10b9$var$St, this.end = null, null !== $af62ec6a841e10b9$var$wt && (this.source = $af62ec6a841e10b9$var$wt);
}
function $af62ec6a841e10b9$var$Or() {
    var t = new $af62ec6a841e10b9$var$Pr;
    return $af62ec6a841e10b9$var$mt.locations && (t.loc = new $af62ec6a841e10b9$var$Er), $af62ec6a841e10b9$var$mt.directSourceFile && (t.sourceFile = $af62ec6a841e10b9$var$mt.directSourceFile), $af62ec6a841e10b9$var$mt.ranges && (t.range = [
        $af62ec6a841e10b9$var$Et,
        0
    ]), t;
}
function $af62ec6a841e10b9$var$Sr(t) {
    var e = new $af62ec6a841e10b9$var$Pr;
    return e.start = t.start, $af62ec6a841e10b9$var$mt.locations && (e.loc = new $af62ec6a841e10b9$var$Er, e.loc.start = t.loc.start), $af62ec6a841e10b9$var$mt.ranges && (e.range = [
        t.range[0],
        0
    ]), e;
}
function $af62ec6a841e10b9$var$Tr(t, e) {
    return t.type = e, t.end = $af62ec6a841e10b9$var$jt, $af62ec6a841e10b9$var$mt.locations && (t.loc.end = $af62ec6a841e10b9$var$It), $af62ec6a841e10b9$var$mt.ranges && (t.range[1] = $af62ec6a841e10b9$var$jt), t;
}
function $af62ec6a841e10b9$var$xr(t) {
    return $af62ec6a841e10b9$var$mt.ecmaVersion >= 5 && "ExpressionStatement" === t.type && "Literal" === t.expression.type && "use strict" === t.expression.value;
}
function $af62ec6a841e10b9$var$Ar(t) {
    if ($af62ec6a841e10b9$var$xt === t) return $af62ec6a841e10b9$var$_r(), !0;
}
function $af62ec6a841e10b9$var$Rr() {
    return !$af62ec6a841e10b9$var$mt.strictSemicolons && ($af62ec6a841e10b9$var$xt === $af62ec6a841e10b9$var$Jt || $af62ec6a841e10b9$var$xt === $af62ec6a841e10b9$var$Ee || $af62ec6a841e10b9$var$nr.test($af62ec6a841e10b9$var$bt.slice($af62ec6a841e10b9$var$jt, $af62ec6a841e10b9$var$Et)));
}
function $af62ec6a841e10b9$var$Cr() {
    $af62ec6a841e10b9$var$Ar($af62ec6a841e10b9$var$xe) || $af62ec6a841e10b9$var$Rr() || $af62ec6a841e10b9$var$kr();
}
function $af62ec6a841e10b9$var$Nr(t) {
    $af62ec6a841e10b9$var$xt === t ? $af62ec6a841e10b9$var$_r() : $af62ec6a841e10b9$var$kr();
}
function $af62ec6a841e10b9$var$kr() {
    $af62ec6a841e10b9$var$Vt($af62ec6a841e10b9$var$Et, "Unexpected token");
}
function $af62ec6a841e10b9$var$jr(t) {
    "Identifier" !== t.type && "MemberExpression" !== t.type && $af62ec6a841e10b9$var$Vt(t.start, "Assigning to rvalue"), $af62ec6a841e10b9$var$Lt && "Identifier" === t.type && $af62ec6a841e10b9$var$$e(t.name) && $af62ec6a841e10b9$var$Vt(t.start, "Assigning to " + t.name + " in strict mode");
}
var $af62ec6a841e10b9$var$Ir = {
    kind: "loop"
}, $af62ec6a841e10b9$var$Ur = {
    kind: "switch"
};
function $af62ec6a841e10b9$var$Fr() {
    ($af62ec6a841e10b9$var$xt === $af62ec6a841e10b9$var$Ne || $af62ec6a841e10b9$var$xt === $af62ec6a841e10b9$var$je && "/=" == $af62ec6a841e10b9$var$At) && $af62ec6a841e10b9$var$hr(!0);
    var t = $af62ec6a841e10b9$var$xt, e = $af62ec6a841e10b9$var$Or();
    switch(t){
        case $af62ec6a841e10b9$var$Ht:
        case $af62ec6a841e10b9$var$$t:
            $af62ec6a841e10b9$var$_r();
            var r = t === $af62ec6a841e10b9$var$Ht;
            $af62ec6a841e10b9$var$Ar($af62ec6a841e10b9$var$xe) || $af62ec6a841e10b9$var$Rr() ? e.label = null : $af62ec6a841e10b9$var$xt !== $af62ec6a841e10b9$var$zt ? $af62ec6a841e10b9$var$kr() : (e.label = $af62ec6a841e10b9$var$$r(), $af62ec6a841e10b9$var$Cr());
            for(var n = 0; n < $af62ec6a841e10b9$var$Ft.length; ++n){
                var i = $af62ec6a841e10b9$var$Ft[n];
                if (null == e.label || i.name === e.label.name) {
                    if (null != i.kind && (r || "loop" === i.kind)) break;
                    if (e.label && r) break;
                }
            }
            return n === $af62ec6a841e10b9$var$Ft.length && $af62ec6a841e10b9$var$Vt(e.start, "Unsyntactic " + t.keyword), $af62ec6a841e10b9$var$Tr(e, r ? "BreakStatement" : "ContinueStatement");
        case $af62ec6a841e10b9$var$Kt:
            return $af62ec6a841e10b9$var$_r(), $af62ec6a841e10b9$var$Cr(), $af62ec6a841e10b9$var$Tr(e, "DebuggerStatement");
        case $af62ec6a841e10b9$var$te:
            return $af62ec6a841e10b9$var$_r(), $af62ec6a841e10b9$var$Ft.push($af62ec6a841e10b9$var$Ir), e.body = $af62ec6a841e10b9$var$Fr(), $af62ec6a841e10b9$var$Ft.pop(), $af62ec6a841e10b9$var$Nr($af62ec6a841e10b9$var$pe), e.test = $af62ec6a841e10b9$var$Lr(), $af62ec6a841e10b9$var$Cr(), $af62ec6a841e10b9$var$Tr(e, "DoWhileStatement");
        case $af62ec6a841e10b9$var$ne:
            if ($af62ec6a841e10b9$var$_r(), $af62ec6a841e10b9$var$Ft.push($af62ec6a841e10b9$var$Ir), $af62ec6a841e10b9$var$Nr($af62ec6a841e10b9$var$Oe), $af62ec6a841e10b9$var$xt === $af62ec6a841e10b9$var$xe) return $af62ec6a841e10b9$var$Mr(e, null);
            if ($af62ec6a841e10b9$var$xt === $af62ec6a841e10b9$var$le) {
                var o = $af62ec6a841e10b9$var$Or();
                return $af62ec6a841e10b9$var$_r(), $af62ec6a841e10b9$var$Vr(o, !0), $af62ec6a841e10b9$var$Tr(o, "VariableDeclaration"), 1 === o.declarations.length && $af62ec6a841e10b9$var$Ar($af62ec6a841e10b9$var$me) ? $af62ec6a841e10b9$var$Br(e, o) : $af62ec6a841e10b9$var$Mr(e, o);
            }
            return o = $af62ec6a841e10b9$var$Gr(!1, !0), $af62ec6a841e10b9$var$Ar($af62ec6a841e10b9$var$me) ? ($af62ec6a841e10b9$var$jr(o), $af62ec6a841e10b9$var$Br(e, o)) : $af62ec6a841e10b9$var$Mr(e, o);
        case $af62ec6a841e10b9$var$ie:
            return $af62ec6a841e10b9$var$_r(), $af62ec6a841e10b9$var$Xr(e, !0);
        case $af62ec6a841e10b9$var$oe:
            return $af62ec6a841e10b9$var$_r(), e.test = $af62ec6a841e10b9$var$Lr(), e.consequent = $af62ec6a841e10b9$var$Fr(), e.alternate = $af62ec6a841e10b9$var$Ar($af62ec6a841e10b9$var$ee) ? $af62ec6a841e10b9$var$Fr() : null, $af62ec6a841e10b9$var$Tr(e, "IfStatement");
        case $af62ec6a841e10b9$var$se:
            return $af62ec6a841e10b9$var$Ut || $af62ec6a841e10b9$var$Vt($af62ec6a841e10b9$var$Et, "'return' outside of function"), $af62ec6a841e10b9$var$_r(), $af62ec6a841e10b9$var$Ar($af62ec6a841e10b9$var$xe) || $af62ec6a841e10b9$var$Rr() ? e.argument = null : (e.argument = $af62ec6a841e10b9$var$Gr(), $af62ec6a841e10b9$var$Cr()), $af62ec6a841e10b9$var$Tr(e, "ReturnStatement");
        case $af62ec6a841e10b9$var$ae:
            $af62ec6a841e10b9$var$_r(), e.discriminant = $af62ec6a841e10b9$var$Lr(), e.cases = [], $af62ec6a841e10b9$var$Nr($af62ec6a841e10b9$var$Pe), $af62ec6a841e10b9$var$Ft.push($af62ec6a841e10b9$var$Ur);
            for(var s, a; $af62ec6a841e10b9$var$xt != $af62ec6a841e10b9$var$Ee;)if ($af62ec6a841e10b9$var$xt === $af62ec6a841e10b9$var$Xt || $af62ec6a841e10b9$var$xt === $af62ec6a841e10b9$var$Qt) {
                var u = $af62ec6a841e10b9$var$xt === $af62ec6a841e10b9$var$Xt;
                s && $af62ec6a841e10b9$var$Tr(s, "SwitchCase"), e.cases.push(s = $af62ec6a841e10b9$var$Or()), s.consequent = [], $af62ec6a841e10b9$var$_r(), u ? s.test = $af62ec6a841e10b9$var$Gr() : (a && $af62ec6a841e10b9$var$Vt($af62ec6a841e10b9$var$kt, "Multiple default clauses"), a = !0, s.test = null), $af62ec6a841e10b9$var$Nr($af62ec6a841e10b9$var$Ae);
            } else s || $af62ec6a841e10b9$var$kr(), s.consequent.push($af62ec6a841e10b9$var$Fr());
            return s && $af62ec6a841e10b9$var$Tr(s, "SwitchCase"), $af62ec6a841e10b9$var$_r(), $af62ec6a841e10b9$var$Ft.pop(), $af62ec6a841e10b9$var$Tr(e, "SwitchStatement");
        case $af62ec6a841e10b9$var$ue:
            return $af62ec6a841e10b9$var$_r(), $af62ec6a841e10b9$var$nr.test($af62ec6a841e10b9$var$bt.slice($af62ec6a841e10b9$var$jt, $af62ec6a841e10b9$var$Et)) && $af62ec6a841e10b9$var$Vt($af62ec6a841e10b9$var$jt, "Illegal newline after throw"), e.argument = $af62ec6a841e10b9$var$Gr(), $af62ec6a841e10b9$var$Cr(), $af62ec6a841e10b9$var$Tr(e, "ThrowStatement");
        case $af62ec6a841e10b9$var$ce:
            if ($af62ec6a841e10b9$var$_r(), e.block = $af62ec6a841e10b9$var$Dr(), e.handler = null, $af62ec6a841e10b9$var$xt === $af62ec6a841e10b9$var$Zt) {
                var c = $af62ec6a841e10b9$var$Or();
                $af62ec6a841e10b9$var$_r(), $af62ec6a841e10b9$var$Nr($af62ec6a841e10b9$var$Oe), c.param = $af62ec6a841e10b9$var$$r(), $af62ec6a841e10b9$var$Lt && $af62ec6a841e10b9$var$$e(c.param.name) && $af62ec6a841e10b9$var$Vt(c.param.start, "Binding " + c.param.name + " in strict mode"), $af62ec6a841e10b9$var$Nr($af62ec6a841e10b9$var$Se), c.guard = null, c.body = $af62ec6a841e10b9$var$Dr(), e.handler = $af62ec6a841e10b9$var$Tr(c, "CatchClause");
            }
            return e.guardedHandlers = $af62ec6a841e10b9$var$Gt, e.finalizer = $af62ec6a841e10b9$var$Ar($af62ec6a841e10b9$var$re) ? $af62ec6a841e10b9$var$Dr() : null, e.handler || e.finalizer || $af62ec6a841e10b9$var$Vt(e.start, "Missing catch or finally clause"), $af62ec6a841e10b9$var$Tr(e, "TryStatement");
        case $af62ec6a841e10b9$var$le:
            return $af62ec6a841e10b9$var$_r(), $af62ec6a841e10b9$var$Vr(e), $af62ec6a841e10b9$var$Cr(), $af62ec6a841e10b9$var$Tr(e, "VariableDeclaration");
        case $af62ec6a841e10b9$var$pe:
            return $af62ec6a841e10b9$var$_r(), e.test = $af62ec6a841e10b9$var$Lr(), $af62ec6a841e10b9$var$Ft.push($af62ec6a841e10b9$var$Ir), e.body = $af62ec6a841e10b9$var$Fr(), $af62ec6a841e10b9$var$Ft.pop(), $af62ec6a841e10b9$var$Tr(e, "WhileStatement");
        case $af62ec6a841e10b9$var$he:
            return $af62ec6a841e10b9$var$Lt && $af62ec6a841e10b9$var$Vt($af62ec6a841e10b9$var$Et, "'with' in strict mode"), $af62ec6a841e10b9$var$_r(), e.object = $af62ec6a841e10b9$var$Lr(), e.body = $af62ec6a841e10b9$var$Fr(), $af62ec6a841e10b9$var$Tr(e, "WithStatement");
        case $af62ec6a841e10b9$var$Pe:
            return $af62ec6a841e10b9$var$Dr();
        case $af62ec6a841e10b9$var$xe:
            return $af62ec6a841e10b9$var$_r(), $af62ec6a841e10b9$var$Tr(e, "EmptyStatement");
        default:
            var l = $af62ec6a841e10b9$var$At, p = $af62ec6a841e10b9$var$Gr();
            if (t === $af62ec6a841e10b9$var$zt && "Identifier" === p.type && $af62ec6a841e10b9$var$Ar($af62ec6a841e10b9$var$Ae)) {
                for(n = 0; n < $af62ec6a841e10b9$var$Ft.length; ++n)$af62ec6a841e10b9$var$Ft[n].name === l && $af62ec6a841e10b9$var$Vt(p.start, "Label '" + l + "' is already declared");
                var h = $af62ec6a841e10b9$var$xt.isLoop ? "loop" : $af62ec6a841e10b9$var$xt === $af62ec6a841e10b9$var$ae ? "switch" : null;
                return $af62ec6a841e10b9$var$Ft.push({
                    name: l,
                    kind: h
                }), e.body = $af62ec6a841e10b9$var$Fr(), $af62ec6a841e10b9$var$Ft.pop(), e.label = p, $af62ec6a841e10b9$var$Tr(e, "LabeledStatement");
            }
            return e.expression = p, $af62ec6a841e10b9$var$Cr(), $af62ec6a841e10b9$var$Tr(e, "ExpressionStatement");
    }
}
function $af62ec6a841e10b9$var$Lr() {
    $af62ec6a841e10b9$var$Nr($af62ec6a841e10b9$var$Oe);
    var t = $af62ec6a841e10b9$var$Gr();
    return $af62ec6a841e10b9$var$Nr($af62ec6a841e10b9$var$Se), t;
}
function $af62ec6a841e10b9$var$Dr(t) {
    var e, r = $af62ec6a841e10b9$var$Or(), n = !0, i = !1;
    for(r.body = [], $af62ec6a841e10b9$var$Nr($af62ec6a841e10b9$var$Pe); !$af62ec6a841e10b9$var$Ar($af62ec6a841e10b9$var$Ee);){
        var o = $af62ec6a841e10b9$var$Fr();
        r.body.push(o), n && t && $af62ec6a841e10b9$var$xr(o) && (e = i, $af62ec6a841e10b9$var$wr(i = !0)), n = !1;
    }
    return i && !e && $af62ec6a841e10b9$var$wr(!1), $af62ec6a841e10b9$var$Tr(r, "BlockStatement");
}
function $af62ec6a841e10b9$var$Mr(t, e) {
    return t.init = e, $af62ec6a841e10b9$var$Nr($af62ec6a841e10b9$var$xe), t.test = $af62ec6a841e10b9$var$xt === $af62ec6a841e10b9$var$xe ? null : $af62ec6a841e10b9$var$Gr(), $af62ec6a841e10b9$var$Nr($af62ec6a841e10b9$var$xe), t.update = $af62ec6a841e10b9$var$xt === $af62ec6a841e10b9$var$Se ? null : $af62ec6a841e10b9$var$Gr(), $af62ec6a841e10b9$var$Nr($af62ec6a841e10b9$var$Se), t.body = $af62ec6a841e10b9$var$Fr(), $af62ec6a841e10b9$var$Ft.pop(), $af62ec6a841e10b9$var$Tr(t, "ForStatement");
}
function $af62ec6a841e10b9$var$Br(t, e) {
    return t.left = e, t.right = $af62ec6a841e10b9$var$Gr(), $af62ec6a841e10b9$var$Nr($af62ec6a841e10b9$var$Se), t.body = $af62ec6a841e10b9$var$Fr(), $af62ec6a841e10b9$var$Ft.pop(), $af62ec6a841e10b9$var$Tr(t, "ForInStatement");
}
function $af62ec6a841e10b9$var$Vr(t, e) {
    for(t.declarations = [], t.kind = "var";;){
        var r = $af62ec6a841e10b9$var$Or();
        if (r.id = $af62ec6a841e10b9$var$$r(), $af62ec6a841e10b9$var$Lt && $af62ec6a841e10b9$var$$e(r.id.name) && $af62ec6a841e10b9$var$Vt(r.id.start, "Binding " + r.id.name + " in strict mode"), r.init = $af62ec6a841e10b9$var$Ar($af62ec6a841e10b9$var$ke) ? $af62ec6a841e10b9$var$Gr(!0, e) : null, t.declarations.push($af62ec6a841e10b9$var$Tr(r, "VariableDeclarator")), !$af62ec6a841e10b9$var$Ar($af62ec6a841e10b9$var$Te)) break;
    }
    return t;
}
function $af62ec6a841e10b9$var$Gr(t, e) {
    var r = $af62ec6a841e10b9$var$qr(e);
    if (!t && $af62ec6a841e10b9$var$xt === $af62ec6a841e10b9$var$Te) {
        var n = $af62ec6a841e10b9$var$Sr(r);
        for(n.expressions = [
            r
        ]; $af62ec6a841e10b9$var$Ar($af62ec6a841e10b9$var$Te);)n.expressions.push($af62ec6a841e10b9$var$qr(e));
        return $af62ec6a841e10b9$var$Tr(n, "SequenceExpression");
    }
    return r;
}
function $af62ec6a841e10b9$var$qr(t) {
    var e = function(t) {
        var e = function(t) {
            return $af62ec6a841e10b9$var$Wr($af62ec6a841e10b9$var$Yr(), -1, t);
        }(t);
        if ($af62ec6a841e10b9$var$Ar($af62ec6a841e10b9$var$Ce)) {
            var r = $af62ec6a841e10b9$var$Sr(e);
            return r.test = e, r.consequent = $af62ec6a841e10b9$var$Gr(!0), $af62ec6a841e10b9$var$Nr($af62ec6a841e10b9$var$Ae), r.alternate = $af62ec6a841e10b9$var$Gr(!0, t), $af62ec6a841e10b9$var$Tr(r, "ConditionalExpression");
        }
        return e;
    }(t);
    if ($af62ec6a841e10b9$var$xt.isAssign) {
        var r = $af62ec6a841e10b9$var$Sr(e);
        return r.operator = $af62ec6a841e10b9$var$At, r.left = e, $af62ec6a841e10b9$var$_r(), r.right = $af62ec6a841e10b9$var$qr(t), $af62ec6a841e10b9$var$jr(e), $af62ec6a841e10b9$var$Tr(r, "AssignmentExpression");
    }
    return e;
}
function $af62ec6a841e10b9$var$Wr(t, e, r) {
    var n = $af62ec6a841e10b9$var$xt.binop;
    if (null != n && (!r || $af62ec6a841e10b9$var$xt !== $af62ec6a841e10b9$var$me) && n > e) {
        var i = $af62ec6a841e10b9$var$Sr(t);
        i.left = t, i.operator = $af62ec6a841e10b9$var$At;
        var o = $af62ec6a841e10b9$var$xt;
        return $af62ec6a841e10b9$var$_r(), i.right = $af62ec6a841e10b9$var$Wr($af62ec6a841e10b9$var$Yr(), n, r), $af62ec6a841e10b9$var$Wr($af62ec6a841e10b9$var$Tr(i, o === $af62ec6a841e10b9$var$Fe || o === $af62ec6a841e10b9$var$Le ? "LogicalExpression" : "BinaryExpression"), e, r);
    }
    return t;
}
function $af62ec6a841e10b9$var$Yr() {
    if ($af62ec6a841e10b9$var$xt.prefix) {
        var t = $af62ec6a841e10b9$var$Or(), e = $af62ec6a841e10b9$var$xt.isUpdate;
        return t.operator = $af62ec6a841e10b9$var$At, t.prefix = !0, $af62ec6a841e10b9$var$Rt = !0, $af62ec6a841e10b9$var$_r(), t.argument = $af62ec6a841e10b9$var$Yr(), e ? $af62ec6a841e10b9$var$jr(t.argument) : $af62ec6a841e10b9$var$Lt && "delete" === t.operator && "Identifier" === t.argument.type && $af62ec6a841e10b9$var$Vt(t.start, "Deleting local variable in strict mode"), $af62ec6a841e10b9$var$Tr(t, e ? "UpdateExpression" : "UnaryExpression");
    }
    for(var r = $af62ec6a841e10b9$var$zr($af62ec6a841e10b9$var$Jr()); $af62ec6a841e10b9$var$xt.postfix && !$af62ec6a841e10b9$var$Rr();)(t = $af62ec6a841e10b9$var$Sr(r)).operator = $af62ec6a841e10b9$var$At, t.prefix = !1, t.argument = r, $af62ec6a841e10b9$var$jr(r), $af62ec6a841e10b9$var$_r(), r = $af62ec6a841e10b9$var$Tr(t, "UpdateExpression");
    return r;
}
function $af62ec6a841e10b9$var$zr(t, e) {
    var r;
    return $af62ec6a841e10b9$var$Ar($af62ec6a841e10b9$var$Re) ? ((r = $af62ec6a841e10b9$var$Sr(t)).object = t, r.property = $af62ec6a841e10b9$var$$r(!0), r.computed = !1, $af62ec6a841e10b9$var$zr($af62ec6a841e10b9$var$Tr(r, "MemberExpression"), e)) : $af62ec6a841e10b9$var$Ar($af62ec6a841e10b9$var$_e) ? ((r = $af62ec6a841e10b9$var$Sr(t)).object = t, r.property = $af62ec6a841e10b9$var$Gr(), r.computed = !0, $af62ec6a841e10b9$var$Nr($af62ec6a841e10b9$var$we), $af62ec6a841e10b9$var$zr($af62ec6a841e10b9$var$Tr(r, "MemberExpression"), e)) : !e && $af62ec6a841e10b9$var$Ar($af62ec6a841e10b9$var$Oe) ? ((r = $af62ec6a841e10b9$var$Sr(t)).callee = t, r.arguments = $af62ec6a841e10b9$var$Zr($af62ec6a841e10b9$var$Se, !1), $af62ec6a841e10b9$var$zr($af62ec6a841e10b9$var$Tr(r, "CallExpression"), e)) : t;
}
function $af62ec6a841e10b9$var$Jr() {
    switch($af62ec6a841e10b9$var$xt){
        case $af62ec6a841e10b9$var$fe:
            var t = $af62ec6a841e10b9$var$Or();
            return $af62ec6a841e10b9$var$_r(), $af62ec6a841e10b9$var$Tr(t, "ThisExpression");
        case $af62ec6a841e10b9$var$zt:
            return $af62ec6a841e10b9$var$$r();
        case $af62ec6a841e10b9$var$qt:
        case $af62ec6a841e10b9$var$Yt:
        case $af62ec6a841e10b9$var$Wt:
            return (t = $af62ec6a841e10b9$var$Or()).value = $af62ec6a841e10b9$var$At, t.raw = $af62ec6a841e10b9$var$bt.slice($af62ec6a841e10b9$var$Et, $af62ec6a841e10b9$var$Ot), $af62ec6a841e10b9$var$_r(), $af62ec6a841e10b9$var$Tr(t, "Literal");
        case $af62ec6a841e10b9$var$ye:
        case $af62ec6a841e10b9$var$ge:
        case $af62ec6a841e10b9$var$ve:
            return (t = $af62ec6a841e10b9$var$Or()).value = $af62ec6a841e10b9$var$xt.atomValue, t.raw = $af62ec6a841e10b9$var$xt.keyword, $af62ec6a841e10b9$var$_r(), $af62ec6a841e10b9$var$Tr(t, "Literal");
        case $af62ec6a841e10b9$var$Oe:
            var e = $af62ec6a841e10b9$var$St, r = $af62ec6a841e10b9$var$Et;
            $af62ec6a841e10b9$var$_r();
            var n = $af62ec6a841e10b9$var$Gr();
            return n.start = r, n.end = $af62ec6a841e10b9$var$Ot, $af62ec6a841e10b9$var$mt.locations && (n.loc.start = e, n.loc.end = $af62ec6a841e10b9$var$Tt), $af62ec6a841e10b9$var$mt.ranges && (n.range = [
                r,
                $af62ec6a841e10b9$var$Ot
            ]), $af62ec6a841e10b9$var$Nr($af62ec6a841e10b9$var$Se), n;
        case $af62ec6a841e10b9$var$_e:
            return t = $af62ec6a841e10b9$var$Or(), $af62ec6a841e10b9$var$_r(), t.elements = $af62ec6a841e10b9$var$Zr($af62ec6a841e10b9$var$we, !0, !0), $af62ec6a841e10b9$var$Tr(t, "ArrayExpression");
        case $af62ec6a841e10b9$var$Pe:
            return function() {
                var t = $af62ec6a841e10b9$var$Or(), e = !0, r = !1;
                for(t.properties = [], $af62ec6a841e10b9$var$_r(); !$af62ec6a841e10b9$var$Ar($af62ec6a841e10b9$var$Ee);){
                    if (e) e = !1;
                    else if ($af62ec6a841e10b9$var$Nr($af62ec6a841e10b9$var$Te), $af62ec6a841e10b9$var$mt.allowTrailingCommas && $af62ec6a841e10b9$var$Ar($af62ec6a841e10b9$var$Ee)) break;
                    var n, i = {
                        key: $af62ec6a841e10b9$var$Hr()
                    }, o = !1;
                    if ($af62ec6a841e10b9$var$Ar($af62ec6a841e10b9$var$Ae) ? (i.value = $af62ec6a841e10b9$var$Gr(!0), n = i.kind = "init") : $af62ec6a841e10b9$var$mt.ecmaVersion >= 5 && "Identifier" === i.key.type && ("get" === i.key.name || "set" === i.key.name) ? (o = r = !0, n = i.kind = i.key.name, i.key = $af62ec6a841e10b9$var$Hr(), $af62ec6a841e10b9$var$xt !== $af62ec6a841e10b9$var$Oe && $af62ec6a841e10b9$var$kr(), i.value = $af62ec6a841e10b9$var$Xr($af62ec6a841e10b9$var$Or(), !1)) : $af62ec6a841e10b9$var$kr(), "Identifier" === i.key.type && ($af62ec6a841e10b9$var$Lt || r)) for(var s = 0; s < t.properties.length; ++s){
                        var a = t.properties[s];
                        if (a.key.name === i.key.name) {
                            var u = n == a.kind || o && "init" === a.kind || "init" === n && ("get" === a.kind || "set" === a.kind);
                            u && !$af62ec6a841e10b9$var$Lt && "init" === n && "init" === a.kind && (u = !1), u && $af62ec6a841e10b9$var$Vt(i.key.start, "Redefinition of property");
                        }
                    }
                    t.properties.push(i);
                }
                return $af62ec6a841e10b9$var$Tr(t, "ObjectExpression");
            }();
        case $af62ec6a841e10b9$var$ie:
            return t = $af62ec6a841e10b9$var$Or(), $af62ec6a841e10b9$var$_r(), $af62ec6a841e10b9$var$Xr(t, !1);
        case $af62ec6a841e10b9$var$de:
            return function() {
                var t = $af62ec6a841e10b9$var$Or();
                return $af62ec6a841e10b9$var$_r(), t.callee = $af62ec6a841e10b9$var$zr($af62ec6a841e10b9$var$Jr(), !0), $af62ec6a841e10b9$var$Ar($af62ec6a841e10b9$var$Oe) ? t.arguments = $af62ec6a841e10b9$var$Zr($af62ec6a841e10b9$var$Se, !1) : t.arguments = $af62ec6a841e10b9$var$Gt, $af62ec6a841e10b9$var$Tr(t, "NewExpression");
            }();
        default:
            $af62ec6a841e10b9$var$kr();
    }
}
function $af62ec6a841e10b9$var$Hr() {
    return $af62ec6a841e10b9$var$xt === $af62ec6a841e10b9$var$qt || $af62ec6a841e10b9$var$xt === $af62ec6a841e10b9$var$Yt ? $af62ec6a841e10b9$var$Jr() : $af62ec6a841e10b9$var$$r(!0);
}
function $af62ec6a841e10b9$var$Xr(t, e) {
    $af62ec6a841e10b9$var$xt === $af62ec6a841e10b9$var$zt ? t.id = $af62ec6a841e10b9$var$$r() : e ? $af62ec6a841e10b9$var$kr() : t.id = null, t.params = [];
    var r = !0;
    for($af62ec6a841e10b9$var$Nr($af62ec6a841e10b9$var$Oe); !$af62ec6a841e10b9$var$Ar($af62ec6a841e10b9$var$Se);)r ? r = !1 : $af62ec6a841e10b9$var$Nr($af62ec6a841e10b9$var$Te), t.params.push($af62ec6a841e10b9$var$$r());
    var n = $af62ec6a841e10b9$var$Ut, i = $af62ec6a841e10b9$var$Ft;
    if ($af62ec6a841e10b9$var$Ut = !0, $af62ec6a841e10b9$var$Ft = [], t.body = $af62ec6a841e10b9$var$Dr(!0), $af62ec6a841e10b9$var$Ut = n, $af62ec6a841e10b9$var$Ft = i, $af62ec6a841e10b9$var$Lt || t.body.body.length && $af62ec6a841e10b9$var$xr(t.body.body[0])) for(var o = t.id ? -1 : 0; o < t.params.length; ++o){
        var s = o < 0 ? t.id : t.params[o];
        if (($af62ec6a841e10b9$var$Ze(s.name) || $af62ec6a841e10b9$var$$e(s.name)) && $af62ec6a841e10b9$var$Vt(s.start, "Defining '" + s.name + "' in strict mode"), o >= 0) for(var a = 0; a < o; ++a)s.name === t.params[a].name && $af62ec6a841e10b9$var$Vt(s.start, "Argument name clash in strict mode");
    }
    return $af62ec6a841e10b9$var$Tr(t, e ? "FunctionDeclaration" : "FunctionExpression");
}
function $af62ec6a841e10b9$var$Zr(t, e, r) {
    for(var n = [], i = !0; !$af62ec6a841e10b9$var$Ar(t);){
        if (i) i = !1;
        else if ($af62ec6a841e10b9$var$Nr($af62ec6a841e10b9$var$Te), e && $af62ec6a841e10b9$var$mt.allowTrailingCommas && $af62ec6a841e10b9$var$Ar(t)) break;
        r && $af62ec6a841e10b9$var$xt === $af62ec6a841e10b9$var$Te ? n.push(null) : n.push($af62ec6a841e10b9$var$Gr(!0));
    }
    return n;
}
function $af62ec6a841e10b9$var$$r(t) {
    var e = $af62ec6a841e10b9$var$Or();
    return e.name = $af62ec6a841e10b9$var$xt === $af62ec6a841e10b9$var$zt ? $af62ec6a841e10b9$var$At : t && !$af62ec6a841e10b9$var$mt.forbidReserved && $af62ec6a841e10b9$var$xt.keyword || $af62ec6a841e10b9$var$kr(), $af62ec6a841e10b9$var$Rt = !1, $af62ec6a841e10b9$var$_r(), $af62ec6a841e10b9$var$Tr(e, "Identifier");
}
var $af62ec6a841e10b9$var$Kr = function() {
    function t(e, r) {
        var n, i = "string" == typeof e ? $af62ec6a841e10b9$var$Dt(e, t.PARSE_OPTIONS) : e;
        this.ast = i, this.initFunc_ = r, this.paused_ = !1, this.polyfills_ = [], this.functionCounter_ = 0, this.stepFunctions_ = Object.create(null);
        for(var o, s = /^step([A-Z]\w*)$/, a = Object.getOwnPropertyNames(t.prototype), u = 0; u < a.length; u++){
            var c = a[u];
            "function" == typeof t.prototype[c] && (o = c.match(s)) && (this.stepFunctions_[o[1]] = t.prototype[c].bind(this));
        }
        this.global = this.createScope(this.ast, null), this.ast = $af62ec6a841e10b9$var$Dt(this.polyfills_.join("\n"), t.PARSE_OPTIONS), this.polyfills_ = void 0, this.stripLocations_(this.ast, void 0, void 0), (n = new $af62ec6a841e10b9$var$tn(this.ast, this.global)).done = !1, this.stateStack = [
            n
        ], this.run(), this.value = void 0, this.ast = i, (n = new $af62ec6a841e10b9$var$tn(this.ast, this.global)).done = !1, this.stateStack.length = 0, this.stateStack[0] = n, this.nodeConstructor = n.node.constructor, this.stateStack = this.stateStack, this.OBJECT = this.OBJECT, this.OBJECT_PROTO = this.OBJECT_PROTO, this.FUNCTION = this.FUNCTION, this.FUNCTION_PROTO = this.FUNCTION_PROTO, this.ARRAY = this.ARRAY, this.ARRAY_PROTO = this.ARRAY_PROTO, this.REGEXP = this.REGEXP, this.REGEXP_PROTO = this.REGEXP_PROTO, this.UNDEFINED = void 0, this.NULL = null, this.NAN = NaN, this.TRUE = !0, this.FALSE = !1, this.STRING_EMPTY = "", this.NUMBER_ZERO = 0, this.NUMBER_ONE = 1;
    }
    return t.prototype.wrap = function(t) {
        return t;
    }, t.prototype.unwrap = function(t, e) {
        return t;
    }, t.prototype.appendCode = function(e) {
        var r = this.stateStack[0];
        if (!r || "Program" !== r.node.type) throw Error("Expecting original AST to start with a Program node.");
        var n = "string" == typeof e ? $af62ec6a841e10b9$var$Dt(e, t.PARSE_OPTIONS) : e;
        if (!n || "Program" !== n.type) throw Error("Expecting new AST to start with a Program node.");
        this.populateScope_(n, r.scope);
        for(var i, o = 0; i = n.body[o]; o++)r.node.body.push(i);
        r.done = !1;
    }, t.prototype.step = function() {
        var e = this.stateStack, r = e[e.length - 1];
        if (!r) return !1;
        var n = r.node, i = n.type;
        if ("Program" === i && r.done) return !1;
        if (this.paused_) return !0;
        try {
            var o = this.stepFunctions_[i](e, r, n);
        } catch (e) {
            if (e !== t.STEP_ERROR) throw e;
        }
        return o && e.push(o), !!n.end || this.step();
    }, t.prototype.run = function() {
        for(; !this.paused_ && this.step(););
        return this.paused_;
    }, t.prototype.initGlobalScope = function(e) {
        this.setProperty(e, "NaN", NaN, t.READONLY_DESCRIPTOR), this.setProperty(e, "Infinity", 1 / 0, t.READONLY_DESCRIPTOR), this.setProperty(e, "undefined", void 0, t.READONLY_DESCRIPTOR), this.setProperty(e, "window", e, t.READONLY_DESCRIPTOR), this.setProperty(e, "this", e, t.READONLY_DESCRIPTOR), this.setProperty(e, "self", e), this.OBJECT_PROTO = new $af62ec6a841e10b9$var$Qr(null), this.FUNCTION_PROTO = new $af62ec6a841e10b9$var$Qr(this.OBJECT_PROTO), this.initFunction(e), this.initObject(e), e.proto = this.OBJECT_PROTO, this.setProperty(e, "constructor", this.OBJECT), this.initArray(e), this.initString(e), this.initBoolean(e), this.initNumber(e), this.initDate(e), this.initRegExp(e), this.initError(e), this.initMath(e), this.initJSON(e);
        var r = this, n = this.createNativeFunction(function(t) {
            throw EvalError("Can't happen");
        }, !1);
        n.eval = !0, this.setProperty(e, "eval", n), this.setProperty(e, "parseInt", this.createNativeFunction(parseInt, !1)), this.setProperty(e, "parseFloat", this.createNativeFunction(parseFloat, !1)), this.setProperty(e, "isNaN", this.createNativeFunction(isNaN, !1)), this.setProperty(e, "isFinite", this.createNativeFunction(isFinite, !1));
        for(var i = [
            [
                escape,
                "escape"
            ],
            [
                unescape,
                "unescape"
            ],
            [
                decodeURI,
                "decodeURI"
            ],
            [
                decodeURIComponent,
                "decodeURIComponent"
            ],
            [
                encodeURI,
                "encodeURI"
            ],
            [
                encodeURIComponent,
                "encodeURIComponent"
            ]
        ], o = 0; o < i.length; o++){
            var s = function(t) {
                return function(e) {
                    try {
                        return t(e);
                    } catch (t) {
                        r.throwException(r.URI_ERROR, t.message);
                    }
                };
            }(i[o][0]);
            this.setProperty(e, i[o][1], this.createNativeFunction(s, !1), t.NONENUMERABLE_DESCRIPTOR);
        }
        this.initFunc_ && this.initFunc_(this, e);
    }, t.prototype.initFunction = function(e) {
        var r, n = this, i = /^[A-Za-z_$][\w$]*$/;
        r = function(e) {
            if (n.calledWithNew()) var r = this;
            else r = n.createObjectProto(n.FUNCTION_PROTO);
            if (arguments.length) var o = String(arguments[arguments.length - 1]);
            else o = "";
            for(var s = [], a = 0; a < arguments.length - 1; a++){
                var u = String(arguments[a]);
                u.match(i) || n.throwException(n.SYNTAX_ERROR, "Invalid function argument: " + u), s.push(u);
            }
            s = s.join(", "), r.parentScope = n.global;
            try {
                var c = $af62ec6a841e10b9$var$Dt("$ = function(" + s + ") {" + o + "};", t.PARSE_OPTIONS);
            } catch (t) {
                n.throwException(n.SYNTAX_ERROR, "Invalid code: " + t.message);
            }
            return 1 !== c.body.length && n.throwException(n.SYNTAX_ERROR, "Invalid code in function body."), r.node = c.body[0].expression.right, n.setProperty(r, "length", r.node.length, t.READONLY_DESCRIPTOR), r;
        }, r.id = this.functionCounter_++, this.FUNCTION = this.createObjectProto(this.FUNCTION_PROTO), this.setProperty(e, "Function", this.FUNCTION), this.setProperty(this.FUNCTION, "prototype", this.FUNCTION_PROTO), this.FUNCTION.nativeFunc = r, this.setProperty(this.FUNCTION_PROTO, "constructor", this.FUNCTION, t.NONENUMERABLE_DESCRIPTOR), this.FUNCTION_PROTO.nativeFunc = function() {}, this.FUNCTION_PROTO.nativeFunc.id = this.functionCounter_++, this.setProperty(this.FUNCTION_PROTO, "length", 0, t.READONLY_DESCRIPTOR);
        var o = function(t) {
            if (!(t && t.isObject || n.getScope().strict)) {
                if (null == t) t = n.global;
                else {
                    var e = n.createObjectProto(n.getPrototype(t));
                    e.data = t, t = e;
                }
            }
            return t;
        };
        r = function(t, e) {
            var r = n.stateStack[n.stateStack.length - 1];
            r.func_ = this, r.funcThis_ = o(t), r.arguments_ = [], null != e && (e.isObject ? r.arguments_ = n.pseudoToNative(e) : n.throwException(n.TYPE_ERROR, "CreateListFromArrayLike called on non-object")), r.doneExec_ = !1;
        }, this.setNativeFunctionPrototype(this.FUNCTION, "apply", r), r = function(t, e) {
            var r = n.stateStack[n.stateStack.length - 1];
            r.func_ = this, r.funcThis_ = o(t), r.arguments_ = [];
            for(var i = 1; i < arguments.length; i++)r.arguments_.push(arguments[i]);
            r.doneExec_ = !1;
        }, this.setNativeFunctionPrototype(this.FUNCTION, "call", r), this.polyfills_.push("Object.defineProperty(Function.prototype, 'bind',", "{configurable: true, writable: true, value:", "function(oThis) {", "if (typeof this !== 'function') {", "throw TypeError('What is trying to be bound is not callable');", "}", "var aArgs   = Array.prototype.slice.call(arguments, 1),", "fToBind = this,", "fNOP    = function() {},", "fBound  = function() {", "return fToBind.apply(this instanceof fNOP", "? this", ": oThis,", "aArgs.concat(Array.prototype.slice.call(arguments)));", "};", "if (this.prototype) {", "fNOP.prototype = this.prototype;", "}", "fBound.prototype = new fNOP();", "return fBound;", "}", "});", ""), r = function() {
            return this.toString();
        }, this.setNativeFunctionPrototype(this.FUNCTION, "toString", r), this.setProperty(this.FUNCTION, "toString", this.createNativeFunction(r, !1), t.NONENUMERABLE_DESCRIPTOR), r = function() {
            return this.valueOf();
        }, this.setNativeFunctionPrototype(this.FUNCTION, "valueOf", r), this.setProperty(this.FUNCTION, "valueOf", this.createNativeFunction(r, !1), t.NONENUMERABLE_DESCRIPTOR);
    }, t.prototype.initObject = function(e) {
        var r, n = this;
        r = function(t) {
            if (null == t) return n.calledWithNew() ? this : n.createObjectProto(n.OBJECT_PROTO);
            if (!t.isObject) {
                var e = n.createObjectProto(n.getPrototype(t));
                return e.data = t, e;
            }
            return t;
        }, this.OBJECT = this.createNativeFunction(r, !0), this.setProperty(this.OBJECT, "prototype", this.OBJECT_PROTO), this.setProperty(this.OBJECT_PROTO, "constructor", this.OBJECT), this.setProperty(e, "Object", this.OBJECT);
        var i = function(t) {
            null == t && n.throwException(n.TYPE_ERROR, "Cannot convert '" + t + "' to object");
        };
        r = function(t) {
            i(t);
            var e = t.isObject ? t.properties : t;
            return n.nativeToPseudo(Object.getOwnPropertyNames(e));
        }, this.setProperty(this.OBJECT, "getOwnPropertyNames", this.createNativeFunction(r, !1), t.NONENUMERABLE_DESCRIPTOR), r = function(t) {
            return i(t), t.isObject ? n.nativeToPseudo(Object.keys(t.properties)) : n.nativeToPseudo(Object.keys(t));
        }, this.setProperty(this.OBJECT, "keys", this.createNativeFunction(r, !1), t.NONENUMERABLE_DESCRIPTOR), r = function(t) {
            return null === t ? n.createObjectProto(null) : (void 0 !== t && t.isObject || n.throwException(n.TYPE_ERROR, "Object prototype may only be an Object or null"), n.createObjectProto(t));
        }, this.setProperty(this.OBJECT, "create", this.createNativeFunction(r, !1), t.NONENUMERABLE_DESCRIPTOR), this.polyfills_.push("(function() {", "var create_ = Object.create;", "Object.create = function(proto, props) {", "var obj = create_(proto);", "props && Object.defineProperties(obj, props);", "return obj;", "};", "})();", ""), r = function(t, e, r) {
            return e = String(e), t && t.isObject || n.throwException(n.TYPE_ERROR, "Object.defineProperty called on non-object"), r && r.isObject || n.throwException(n.TYPE_ERROR, "Property description must be an object"), !t.properties[e] && t.preventExtensions && n.throwException(n.TYPE_ERROR, "Can't define property '" + e + "', object is not extensible"), n.setProperty(t, e, ReferenceError, r.properties), t;
        }, this.setProperty(this.OBJECT, "defineProperty", this.createNativeFunction(r, !1), t.NONENUMERABLE_DESCRIPTOR), this.polyfills_.push("(function() {", "var defineProperty_ = Object.defineProperty;", "Object.defineProperty = function(obj, prop, d1) {", "var d2 = {};", "if ('configurable' in d1) d2.configurable = d1.configurable;", "if ('enumerable' in d1) d2.enumerable = d1.enumerable;", "if ('writable' in d1) d2.writable = d1.writable;", "if ('value' in d1) d2.value = d1.value;", "if ('get' in d1) d2.get = d1.get;", "if ('set' in d1) d2.set = d1.set;", "return defineProperty_(obj, prop, d2);", "};", "})();", "Object.defineProperty(Object, 'defineProperties',", "{configurable: true, writable: true, value:", "function(obj, props) {", "var keys = Object.keys(props);", "for (var i = 0; i < keys.length; i++) {", "Object.defineProperty(obj, keys[i], props[keys[i]]);", "}", "return obj;", "}", "});", ""), r = function(t, e) {
            if (t && t.isObject || n.throwException(n.TYPE_ERROR, "Object.getOwnPropertyDescriptor called on non-object"), (e = String(e)) in t.properties) {
                var r = Object.getOwnPropertyDescriptor(t.properties, e), i = t.getter[e], o = t.setter[e];
                (i || o) && (r.get = i, r.set = o, delete r.value, delete r.writable);
                var s = n.nativeToPseudo(r);
                return "value" in r && n.setProperty(s, "value", r.value), s;
            }
        }, this.setProperty(this.OBJECT, "getOwnPropertyDescriptor", this.createNativeFunction(r, !1), t.NONENUMERABLE_DESCRIPTOR), r = function(t) {
            return i(t), n.getPrototype(t);
        }, this.setProperty(this.OBJECT, "getPrototypeOf", this.createNativeFunction(r, !1), t.NONENUMERABLE_DESCRIPTOR), r = function(t) {
            return Boolean(t) && !t.preventExtensions;
        }, this.setProperty(this.OBJECT, "isExtensible", this.createNativeFunction(r, !1), t.NONENUMERABLE_DESCRIPTOR), r = function(t) {
            return t && t.isObject && (t.preventExtensions = !0), t;
        }, this.setProperty(this.OBJECT, "preventExtensions", this.createNativeFunction(r, !1), t.NONENUMERABLE_DESCRIPTOR), this.setNativeFunctionPrototype(this.OBJECT, "toString", $af62ec6a841e10b9$var$Qr.prototype.toString), this.setNativeFunctionPrototype(this.OBJECT, "toLocaleString", $af62ec6a841e10b9$var$Qr.prototype.toString), this.setNativeFunctionPrototype(this.OBJECT, "valueOf", $af62ec6a841e10b9$var$Qr.prototype.valueOf), r = function(t) {
            return i(this), this.isObject ? String(t) in this.properties : this.hasOwnProperty(t);
        }, this.setNativeFunctionPrototype(this.OBJECT, "hasOwnProperty", r), r = function(t) {
            return i(this), Object.prototype.propertyIsEnumerable.call(this.properties, t);
        }, this.setNativeFunctionPrototype(this.OBJECT, "propertyIsEnumerable", r), r = function(t) {
            for(;;){
                if (!(t = n.getPrototype(t))) return !1;
                if (t === this) return !0;
            }
        }, this.setNativeFunctionPrototype(this.OBJECT, "isPrototypeOf", r);
    }, t.prototype.initArray = function(e) {
        var r, n = this;
        r = function(e) {
            if (n.calledWithNew()) var r = this;
            else r = n.createObjectProto(n.ARRAY_PROTO);
            var i = arguments[0];
            if (1 === arguments.length && "number" == typeof i) isNaN(t.legalArrayLength(i)) && n.throwException(n.RANGE_ERROR, "Invalid array length"), r.properties.length = i;
            else {
                for(var o = 0; o < arguments.length; o++)r.properties[o] = arguments[o];
                r.properties.length = o;
            }
            return r;
        }, this.ARRAY = this.createNativeFunction(r, !0), this.ARRAY_PROTO = this.ARRAY.properties.prototype, this.setProperty(e, "Array", this.ARRAY), r = function(t) {
            return t && "Array" === t.class;
        }, this.setProperty(this.ARRAY, "isArray", this.createNativeFunction(r, !1), t.NONENUMERABLE_DESCRIPTOR), r = function() {
            return Array.prototype.pop.call(this.properties);
        }, this.setNativeFunctionPrototype(this.ARRAY, "pop", r), r = function(t) {
            return Array.prototype.push.apply(this.properties, arguments);
        }, this.setNativeFunctionPrototype(this.ARRAY, "push", r), r = function() {
            return Array.prototype.shift.call(this.properties);
        }, this.setNativeFunctionPrototype(this.ARRAY, "shift", r), r = function(t) {
            return Array.prototype.unshift.apply(this.properties, arguments);
        }, this.setNativeFunctionPrototype(this.ARRAY, "unshift", r), r = function() {
            return Array.prototype.reverse.call(this.properties), this;
        }, this.setNativeFunctionPrototype(this.ARRAY, "reverse", r), r = function(t, e) {
            var r = Array.prototype.splice.apply(this.properties, arguments);
            return n.unwrap && (r = r.map(n.unwrap)), n.nativeToPseudo(r);
        }, this.setNativeFunctionPrototype(this.ARRAY, "splice", r), r = function(t, e) {
            var r = Array.prototype.slice.call(this.properties, t, e);
            return n.unwrap && (r = r.map(n.unwrap)), n.nativeToPseudo(r);
        }, this.setNativeFunctionPrototype(this.ARRAY, "slice", r), r = function(t) {
            return Array.prototype.join.call(this.properties, t);
        }, this.setNativeFunctionPrototype(this.ARRAY, "join", r), r = function(t) {
            for(var e = [], r = 0, i = n.getProperty(this, "length"), o = 0; o < i; o++){
                if (n.hasProperty(this, o)) {
                    var s = n.getProperty(this, o);
                    e[r] = s;
                }
                r++;
            }
            for(o = 0; o < arguments.length; o++){
                var a = arguments[o];
                if (n.isa(a, n.ARRAY)) for(var u = n.getProperty(a, "length"), c = 0; c < u; c++)n.hasProperty(a, c) && (e[r] = n.getProperty(a, c)), r++;
                else e[r] = a;
            }
            return n.unwrap && (e = e.map(n.unwrap)), n.nativeToPseudo(e);
        }, this.setNativeFunctionPrototype(this.ARRAY, "concat", r), r = function(t, e) {
            return Array.prototype.indexOf.apply(this.properties, arguments);
        }, this.setNativeFunctionPrototype(this.ARRAY, "indexOf", r), r = function(t, e) {
            return Array.prototype.lastIndexOf.apply(this.properties, arguments);
        }, this.setNativeFunctionPrototype(this.ARRAY, "lastIndexOf", r), r = function() {
            return Array.prototype.sort.call(this.properties), this;
        }, this.setNativeFunctionPrototype(this.ARRAY, "sort", r), this.polyfills_.push("Object.defineProperty(Array.prototype, 'every',", "{configurable: true, writable: true, value:", "function(callbackfn, thisArg) {", "if (!this || typeof callbackfn !== 'function') throw TypeError();", "var T, k;", "var O = Object(this);", "var len = O.length >>> 0;", "if (arguments.length > 1) T = thisArg;", "k = 0;", "while (k < len) {", "if (k in O && !callbackfn.call(T, O[k], k, O)) return false;", "k++;", "}", "return true;", "}", "});", "Object.defineProperty(Array.prototype, 'filter',", "{configurable: true, writable: true, value:", "function(fun/*, thisArg*/) {", "if (this === void 0 || this === null || typeof fun !== 'function') throw TypeError();", "var t = Object(this);", "var len = t.length >>> 0;", "var res = [];", "var thisArg = arguments.length >= 2 ? arguments[1] : void 0;", "for (var i = 0; i < len; i++) {", "if (i in t) {", "var val = t[i];", "if (fun.call(thisArg, val, i, t)) res.push(val);", "}", "}", "return res;", "}", "});", "Object.defineProperty(Array.prototype, 'forEach',", "{configurable: true, writable: true, value:", "function(callback, thisArg) {", "if (!this || typeof callback !== 'function') throw TypeError();", "var T, k;", "var O = Object(this);", "var len = O.length >>> 0;", "if (arguments.length > 1) T = thisArg;", "k = 0;", "while (k < len) {", "if (k in O) callback.call(T, O[k], k, O);", "k++;", "}", "}", "});", "Object.defineProperty(Array.prototype, 'map',", "{configurable: true, writable: true, value:", "function(callback, thisArg) {", "if (!this || typeof callback !== 'function') new TypeError;", "var T, A, k;", "var O = Object(this);", "var len = O.length >>> 0;", "if (arguments.length > 1) T = thisArg;", "A = new Array(len);", "k = 0;", "while (k < len) {", "if (k in O) A[k] = callback.call(T, O[k], k, O);", "k++;", "}", "return A;", "}", "});", "Object.defineProperty(Array.prototype, 'reduce',", "{configurable: true, writable: true, value:", "function(callback /*, initialValue*/) {", "if (!this || typeof callback !== 'function') throw TypeError();", "var t = Object(this), len = t.length >>> 0, k = 0, value;", "if (arguments.length === 2) {", "value = arguments[1];", "} else {", "while (k < len && !(k in t)) k++;", "if (k >= len) {", "throw TypeError('Reduce of empty array with no initial value');", "}", "value = t[k++];", "}", "for (; k < len; k++) {", "if (k in t) value = callback(value, t[k], k, t);", "}", "return value;", "}", "});", "Object.defineProperty(Array.prototype, 'reduceRight',", "{configurable: true, writable: true, value:", "function(callback /*, initialValue*/) {", "if (null === this || 'undefined' === typeof this || 'function' !== typeof callback) throw TypeError();", "var t = Object(this), len = t.length >>> 0, k = len - 1, value;", "if (arguments.length >= 2) {", "value = arguments[1];", "} else {", "while (k >= 0 && !(k in t)) k--;", "if (k < 0) {", "throw TypeError('Reduce of empty array with no initial value');", "}", "value = t[k--];", "}", "for (; k >= 0; k--) {", "if (k in t) value = callback(value, t[k], k, t);", "}", "return value;", "}", "});", "Object.defineProperty(Array.prototype, 'some',", "{configurable: true, writable: true, value:", "function(fun/*, thisArg*/) {", "if (!this || typeof fun !== 'function') throw TypeError();", "var t = Object(this);", "var len = t.length >>> 0;", "var thisArg = arguments.length >= 2 ? arguments[1] : void 0;", "for (var i = 0; i < len; i++) {", "if (i in t && fun.call(thisArg, t[i], i, t)) {", "return true;", "}", "}", "return false;", "}", "});", "(function() {", "var sort_ = Array.prototype.sort;", "Array.prototype.sort = function(opt_comp) {", "if (typeof opt_comp !== 'function') {", "return sort_.call(this);", "}", "for (var i = 0; i < this.length; i++) {", "var changes = 0;", "for (var j = 0; j < this.length - i - 1; j++) {", "if (opt_comp(this[j], this[j + 1]) > 0) {", "var swap = this[j];", "this[j] = this[j + 1];", "this[j + 1] = swap;", "changes++;", "}", "}", "if (!changes) break;", "}", "return this;", "};", "})();", "Object.defineProperty(Array.prototype, 'toLocaleString',", "{configurable: true, writable: true, value:", "function() {", "var out = [];", "for (var i = 0; i < this.length; i++) {", "out[i] = (this[i] === null || this[i] === undefined) ? '' : this[i].toLocaleString();", "}", "return out.join(',');", "}", "});", "");
    }, t.prototype.initString = function(e) {
        var r, n = this;
        r = function(t) {
            return t = String(t), n.calledWithNew() ? (this.data = t, this) : t;
        }, this.STRING = this.createNativeFunction(r, !0), this.setProperty(e, "String", this.STRING), this.setProperty(this.STRING, "fromCharCode", this.createNativeFunction(String.fromCharCode, !1), t.NONENUMERABLE_DESCRIPTOR);
        for(var i = [
            "trim",
            "toLowerCase",
            "toUpperCase",
            "toLocaleLowerCase",
            "toLocaleUpperCase",
            "charAt",
            "charCodeAt",
            "substring",
            "slice",
            "substr",
            "indexOf",
            "lastIndexOf",
            "concat"
        ], o = 0; o < i.length; o++)this.setNativeFunctionPrototype(this.STRING, i[o], String.prototype[i[o]]);
        r = function(t, e, r) {
            return e = e ? n.pseudoToNative(e) : void 0, r = r ? n.pseudoToNative(r) : void 0, String(this).localeCompare(t, e, r);
        }, this.setNativeFunctionPrototype(this.STRING, "localeCompare", r), r = function(t, e) {
            n.isa(t, n.REGEXP) && (t = t.data);
            var r = String(this).split(t, e);
            return n.nativeToPseudo(r);
        }, this.setNativeFunctionPrototype(this.STRING, "split", r), r = function(t) {
            t = t ? t.data : void 0;
            var e = String(this).match(t);
            return e ? n.nativeToPseudo(e) : null;
        }, this.setNativeFunctionPrototype(this.STRING, "match", r), r = function(t) {
            return n.isa(t, n.REGEXP) && (t = t.data), String(this).search(t);
        }, this.setNativeFunctionPrototype(this.STRING, "search", r), r = function(t, e) {
            return String(this).replace(t.data || t, e);
        }, this.setNativeFunctionPrototype(this.STRING, "replace", r), this.polyfills_.push("(function() {", "var replace_ = String.prototype.replace;", "String.prototype.replace = function(substr, newSubstr) {", "if (typeof newSubstr !== 'function') {", "return replace_.call(this, substr, newSubstr);", "}", "var str = this;", "if (substr instanceof RegExp) {", "var subs = [];", "var m = substr.exec(str);", "while (m) {", "m.push(m.index, str);", "var inject = newSubstr.apply(null, m);", "subs.push([m.index, m[0].length, inject]);", "m = substr.global ? substr.exec(str) : null;", "}", "for (var i = subs.length - 1; i >= 0; i--) {", "str = str.substring(0, subs[i][0]) + subs[i][2] + str.substring(subs[i][0] + subs[i][1]);", "}", "} else {", "var i = str.indexOf(substr);", "if (i !== -1) {", "var inject = newSubstr(str.substr(i, substr.length), i, str);", "str = str.substring(0, i) + inject + str.substring(i + substr.length);", "}", "}", "return str;", "};", "})();", "");
    }, t.prototype.initBoolean = function(t) {
        var e, r = this;
        e = function(t) {
            return t = Boolean(t), r.calledWithNew() ? (this.data = t, this) : t;
        }, this.BOOLEAN = this.createNativeFunction(e, !0), this.setProperty(t, "Boolean", this.BOOLEAN);
    }, t.prototype.initNumber = function(e) {
        var r, n = this;
        r = function(t) {
            return t = Number(t), n.calledWithNew() ? (this.data = t, this) : t;
        }, this.NUMBER = this.createNativeFunction(r, !0), this.setProperty(e, "Number", this.NUMBER);
        for(var i = [
            "MAX_VALUE",
            "MIN_VALUE",
            "NaN",
            "NEGATIVE_INFINITY",
            "POSITIVE_INFINITY"
        ], o = 0; o < i.length; o++)this.setProperty(this.NUMBER, i[o], Number[i[o]], t.READONLY_NONENUMERABLE_DESCRIPTOR);
        r = function(t) {
            try {
                return Number(this).toExponential(t);
            } catch (t) {
                n.throwException(n.ERROR, t.message);
            }
        }, this.setNativeFunctionPrototype(this.NUMBER, "toExponential", r), r = function(t) {
            try {
                return Number(this).toFixed(t);
            } catch (t) {
                n.throwException(n.ERROR, t.message);
            }
        }, this.setNativeFunctionPrototype(this.NUMBER, "toFixed", r), r = function(t) {
            try {
                return Number(this).toPrecision(t);
            } catch (t) {
                n.throwException(n.ERROR, t.message);
            }
        }, this.setNativeFunctionPrototype(this.NUMBER, "toPrecision", r), r = function(t) {
            try {
                return Number(this).toString(t);
            } catch (t) {
                n.throwException(n.ERROR, t.message);
            }
        }, this.setNativeFunctionPrototype(this.NUMBER, "toString", r), r = function(t, e) {
            return t = t ? n.pseudoToNative(t) : void 0, e = e ? n.pseudoToNative(e) : void 0, Number(this).toLocaleString(t, e);
        }, this.setNativeFunctionPrototype(this.NUMBER, "toLocaleString", r);
    }, t.prototype.initDate = function(e) {
        var r, n = this;
        r = function(t, e) {
            if (!n.calledWithNew()) return Date();
            var r = [
                null
            ].concat([].slice.call(arguments));
            return this.data = new (Function.prototype.bind.apply(Date, r)), this;
        }, this.DATE = this.createNativeFunction(r, !0), this.setProperty(e, "Date", this.DATE), this.setProperty(this.DATE, "now", this.createNativeFunction(Date.now, !1), t.NONENUMERABLE_DESCRIPTOR), this.setProperty(this.DATE, "parse", this.createNativeFunction(Date.parse, !1), t.NONENUMERABLE_DESCRIPTOR), this.setProperty(this.DATE, "UTC", this.createNativeFunction(Date.UTC, !1), t.NONENUMERABLE_DESCRIPTOR);
        for(var i = [
            "getDate",
            "getDay",
            "getFullYear",
            "getHours",
            "getMilliseconds",
            "getMinutes",
            "getMonth",
            "getSeconds",
            "getTime",
            "getTimezoneOffset",
            "getUTCDate",
            "getUTCDay",
            "getUTCFullYear",
            "getUTCHours",
            "getUTCMilliseconds",
            "getUTCMinutes",
            "getUTCMonth",
            "getUTCSeconds",
            "getYear",
            "setDate",
            "setFullYear",
            "setHours",
            "setMilliseconds",
            "setMinutes",
            "setMonth",
            "setSeconds",
            "setTime",
            "setUTCDate",
            "setUTCFullYear",
            "setUTCHours",
            "setUTCMilliseconds",
            "setUTCMinutes",
            "setUTCMonth",
            "setUTCSeconds",
            "setYear",
            "toDateString",
            "toISOString",
            "toJSON",
            "toGMTString",
            "toLocaleDateString",
            "toLocaleString",
            "toLocaleTimeString",
            "toTimeString",
            "toUTCString"
        ], o = 0; o < i.length; o++)r = function(t) {
            return function(e) {
                for(var r = [], i = 0; i < arguments.length; i++)r[i] = n.pseudoToNative(arguments[i]);
                return this.data[t].apply(this.data, r);
            };
        }(i[o]), this.setNativeFunctionPrototype(this.DATE, i[o], r);
    }, t.prototype.initRegExp = function(e) {
        var r, n = this;
        r = function(t, e) {
            if (n.calledWithNew()) var r = this;
            else r = n.createObjectProto(n.REGEXP_PROTO);
            return t = t ? t.toString() : "", e = e ? e.toString() : "", n.populateRegExp(r, new RegExp(t, e)), r;
        }, this.REGEXP = this.createNativeFunction(r, !0), this.REGEXP_PROTO = this.REGEXP.properties.prototype, this.setProperty(e, "RegExp", this.REGEXP), this.setProperty(this.REGEXP.properties.prototype, "global", void 0, t.READONLY_NONENUMERABLE_DESCRIPTOR), this.setProperty(this.REGEXP.properties.prototype, "ignoreCase", void 0, t.READONLY_NONENUMERABLE_DESCRIPTOR), this.setProperty(this.REGEXP.properties.prototype, "multiline", void 0, t.READONLY_NONENUMERABLE_DESCRIPTOR), this.setProperty(this.REGEXP.properties.prototype, "source", "(?:)", t.READONLY_NONENUMERABLE_DESCRIPTOR), r = function(t) {
            return this.data.test(t);
        }, this.setNativeFunctionPrototype(this.REGEXP, "test", r), r = function(t) {
            t = t.toString(), this.data.lastIndex = Number(n.getProperty(this, "lastIndex"));
            var e = this.data.exec(t);
            if (n.setProperty(this, "lastIndex", this.data.lastIndex), e) {
                for(var r = n.createObjectProto(n.ARRAY_PROTO), i = 0; i < e.length; i++)n.setProperty(r, i, e[i]);
                return n.setProperty(r, "index", e.index), n.setProperty(r, "input", e.input), r;
            }
            return null;
        }, this.setNativeFunctionPrototype(this.REGEXP, "exec", r);
    }, t.prototype.initError = function(e) {
        var r = this;
        this.ERROR = this.createNativeFunction(function(e) {
            if (r.calledWithNew()) var n = this;
            else n = r.createObject(r.ERROR);
            return e && r.setProperty(n, "message", String(e), t.NONENUMERABLE_DESCRIPTOR), n;
        }, !0), this.setProperty(e, "Error", this.ERROR), this.setProperty(this.ERROR.properties.prototype, "message", "", t.NONENUMERABLE_DESCRIPTOR), this.setProperty(this.ERROR.properties.prototype, "name", "Error", t.NONENUMERABLE_DESCRIPTOR);
        var n = function(n) {
            var i = r.createNativeFunction(function(e) {
                if (r.calledWithNew()) var n = this;
                else n = r.createObject(i);
                return e && r.setProperty(n, "message", String(e), t.NONENUMERABLE_DESCRIPTOR), n;
            }, !0);
            return r.setProperty(i, "prototype", r.createObject(r.ERROR)), r.setProperty(i.properties.prototype, "name", n, t.NONENUMERABLE_DESCRIPTOR), r.setProperty(e, n, i), i;
        };
        this.EVAL_ERROR = n("EvalError"), this.RANGE_ERROR = n("RangeError"), this.REFERENCE_ERROR = n("ReferenceError"), this.SYNTAX_ERROR = n("SyntaxError"), this.TYPE_ERROR = n("TypeError"), this.URI_ERROR = n("URIError");
    }, t.prototype.initMath = function(e) {
        var r = this.createObjectProto(this.OBJECT_PROTO);
        this.setProperty(e, "Math", r);
        for(var n = [
            "E",
            "LN2",
            "LN10",
            "LOG2E",
            "LOG10E",
            "PI",
            "SQRT1_2",
            "SQRT2"
        ], i = 0; i < n.length; i++)this.setProperty(r, n[i], Math[n[i]], t.READONLY_NONENUMERABLE_DESCRIPTOR);
        var o = [
            "abs",
            "acos",
            "asin",
            "atan",
            "atan2",
            "ceil",
            "cos",
            "exp",
            "floor",
            "log",
            "max",
            "min",
            "pow",
            "random",
            "round",
            "sin",
            "sqrt",
            "tan"
        ];
        for(i = 0; i < o.length; i++)this.setProperty(r, o[i], this.createNativeFunction(Math[o[i]], !1), t.NONENUMERABLE_DESCRIPTOR);
    }, t.prototype.initJSON = function(t) {
        var e = this, r = e.createObjectProto(this.OBJECT_PROTO);
        this.setProperty(t, "JSON", r);
        var n = function(t) {
            try {
                var r = JSON.parse(t.toString());
            } catch (t) {
                e.throwException(e.SYNTAX_ERROR, t.message);
            }
            return e.nativeToPseudo(r);
        };
        this.setProperty(r, "parse", this.createNativeFunction(n, !1)), n = function(t) {
            var r = e.pseudoToNative(t);
            try {
                var n = JSON.stringify(r);
            } catch (t) {
                e.throwException(e.TYPE_ERROR, t.message);
            }
            return n;
        }, this.setProperty(r, "stringify", this.createNativeFunction(n, !1));
    }, t.prototype.isa = function(t, e) {
        if (null == t || !e) return !1;
        var r = e.properties.prototype;
        if (t === r) return !0;
        for(var n = this.getPrototype(t); n;){
            if (n === r) return !0;
            n = n.proto;
        }
        return !1;
    }, t.legalArrayLength = function(t) {
        var e = t >>> 0;
        return e === Number(t) ? e : NaN;
    }, t.legalArrayIndex = function(t) {
        var e = t >>> 0;
        return String(e) === String(t) && 4294967295 !== e ? e : NaN;
    }, t.prototype.createObject = function(t) {
        return this.createObjectProto(t && t.properties.prototype);
    }, t.prototype.createObjectProto = function(t) {
        var e = new $af62ec6a841e10b9$var$Qr(t);
        return this.isa(e, this.FUNCTION) && (this.setProperty(e, "prototype", this.createObjectProto(this.OBJECT_PROTO || null)), e.class = "Function"), this.isa(e, this.ARRAY) && (this.setProperty(e, "length", 0, {
            configurable: !1,
            enumerable: !1,
            writable: !0
        }), e.class = "Array"), this.isa(e, this.ERROR) && (e.class = "Error"), e;
    }, t.prototype.populateRegExp = function(e, r) {
        e.data = r, this.setProperty(e, "lastIndex", r.lastIndex, t.NONENUMERABLE_DESCRIPTOR), this.setProperty(e, "source", r.source, t.READONLY_NONENUMERABLE_DESCRIPTOR), this.setProperty(e, "global", r.global, t.READONLY_NONENUMERABLE_DESCRIPTOR), this.setProperty(e, "ignoreCase", r.ignoreCase, t.READONLY_NONENUMERABLE_DESCRIPTOR), this.setProperty(e, "multiline", r.multiline, t.READONLY_NONENUMERABLE_DESCRIPTOR);
    }, t.prototype.createFunction = function(e, r) {
        var n = this.createObjectProto(this.FUNCTION_PROTO);
        return n.parentScope = r, n.node = e, this.setProperty(n, "length", n.node.params.length, t.READONLY_DESCRIPTOR), n;
    }, t.prototype.createNativeFunction = function(e, r) {
        var n = this.createObjectProto(this.FUNCTION_PROTO);
        return n.nativeFunc = e, e.id = this.functionCounter_++, this.setProperty(n, "length", e.length, t.READONLY_DESCRIPTOR), r ? this.setProperty(n.properties.prototype, "constructor", n, t.NONENUMERABLE_DESCRIPTOR) : !1 === r && (n.illegalConstructor = !0, this.setProperty(n, "prototype", void 0)), n;
    }, t.prototype.createAsyncFunction = function(e) {
        var r = this.createObjectProto(this.FUNCTION_PROTO);
        return r.asyncFunc = e, e.id = this.functionCounter_++, this.setProperty(r, "length", e.length, t.READONLY_DESCRIPTOR), r;
    }, t.prototype.nativeToPseudo = function(t) {
        if ("boolean" == typeof t || "number" == typeof t || "string" == typeof t || null == t) return t;
        if (t instanceof RegExp) {
            var e = this.createObjectProto(this.REGEXP_PROTO);
            return this.populateRegExp(e, t), e;
        }
        if (t instanceof Function) {
            var r = this;
            return this.createNativeFunction(function() {
                return r.nativeToPseudo(t.apply(r, Array.prototype.slice.call(arguments).map(function(t) {
                    return r.pseudoToNative(t);
                })));
            }, void 0);
        }
        var n;
        if (Array.isArray(t)) {
            n = this.createObjectProto(this.ARRAY_PROTO);
            for(var i = 0; i < t.length; i++)i in t && this.setProperty(n, i, this.wrap ? this.wrap(t[i]) : this.nativeToPseudo(t[i]));
        } else for(var o in n = this.createObjectProto(this.OBJECT_PROTO), t)this.setProperty(n, o, this.wrap ? this.wrap(t[i]) : this.nativeToPseudo(t[i]));
        return n;
    }, t.prototype.pseudoToNative = function(t, e) {
        if ("boolean" == typeof t || "number" == typeof t || "string" == typeof t || null == t) return t;
        if (this.isa(t, this.REGEXP)) return t.data;
        var r, n = e || {
            pseudo: [],
            native: []
        };
        if (-1 !== (o = n.pseudo.indexOf(t))) return n.native[o];
        if (n.pseudo.push(t), this.isa(t, this.ARRAY)) {
            r = [], n.native.push(r);
            for(var i = this.getProperty(t, "length"), o = 0; o < i; o++)this.hasProperty(t, o) && (r[o] = this.unwrap ? this.unwrap(this.getProperty(t, o), n) : this.pseudoToNative(this.getProperty(t, o), n));
        } else {
            if (t._native) return t._native;
            r = {}, n.native.push(r);
            var s = void 0;
            for(var a in t.properties)s = t.properties[a], r[a] = this.unwrap ? this.unwrap(s, n) : this.pseudoToNative(s, n);
        }
        return n.pseudo.pop(), n.native.pop(), r;
    }, t.prototype.getPrototype = function(t) {
        switch(typeof t){
            case "number":
                return this.NUMBER.properties.prototype;
            case "boolean":
                return this.BOOLEAN.properties.prototype;
            case "string":
                return this.STRING.properties.prototype;
        }
        return t ? t.proto : null;
    }, t.prototype.getProperty = function(e, r) {
        if (r = String(r), null == e && this.throwException(this.TYPE_ERROR, "Cannot read property '" + r + "' of " + e), "length" === r) {
            if (this.isa(e, this.STRING)) return String(e).length;
        } else if (r.charCodeAt(0) < 64 && this.isa(e, this.STRING)) {
            var n = t.legalArrayIndex(r);
            if (!isNaN(n) && n < String(e).length) return String(e)[n];
        }
        do {
            var i = e;
            if (i.properties && r in i.properties) {
                var o = i.getter[r];
                return o ? (o.isGetter = !0, o) : i.properties[r];
            }
            if (void 0 !== i._native && "_" !== r.charAt(0) && "function" != typeof i._native[r]) return this.wrap ? this.wrap(i._native[r]) : i._native[r];
        }while (e = this.getPrototype(e));
    }, t.prototype.hasProperty = function(e, r) {
        if (!e.isObject) throw TypeError("Primitive data type has no properties");
        if ("length" === (r = String(r)) && this.isa(e, this.STRING)) return !0;
        if (this.isa(e, this.STRING)) {
            var n = t.legalArrayIndex(r);
            if (!isNaN(n) && n < String(e).length) return !0;
        }
        do {
            var i = e;
            if (i.properties && r in i.properties) return !0;
            if (void 0 !== i._native && "_" != r.charAt(0)) {
                var o = typeof i._native[r];
                return "function" !== o && ("undefined" !== o || $af62ec6a841e10b9$var$en(i._native.constructor, r));
            }
        }while (e = this.getPrototype(e));
        return !1;
    }, t.prototype.setProperty = function(e, r, n, i) {
        r = String(r), null == e && this.throwException(this.TYPE_ERROR, "Cannot set property '" + r + "' of " + e), i && ("get" in i || "set" in i) && ("value" in i || "writable" in i) && this.throwException(this.TYPE_ERROR, "Invalid property descriptor. Cannot both specify accessors and a value or writable attribute");
        var o = !this.stateStack || this.getScope().strict;
        if (e.isObject) {
            if (this.isa(e, this.STRING)) {
                var s = t.legalArrayIndex(r);
                if ("length" === r || !isNaN(s) && s < String(e).length) return void (o && this.throwException(this.TYPE_ERROR, "Cannot assign to read only property '" + r + "' of String '" + e.data + "'"));
            }
            if ("Array" === e.class) {
                var a = e.properties.length, u = void 0;
                if ("length" === r) {
                    if (n = t.legalArrayLength(n), isNaN(n) && this.throwException(this.RANGE_ERROR, "Invalid array length"), n < a) for(u in e.properties)u = t.legalArrayIndex(u), !isNaN(u) && n <= u && delete e.properties[u];
                } else isNaN(u = t.legalArrayIndex(r)) || (e.properties.length = Math.max(a, u + 1));
            }
            if (!e.preventExtensions || r in e.properties) {
                if (i) {
                    "get" in i && (i.get ? e.getter[r] = i.get : delete e.getter[r]), "set" in i && (i.set ? e.setter[r] = i.set : delete e.setter[r]);
                    var c = {};
                    "configurable" in i && (c.configurable = i.configurable), "enumerable" in i && (c.enumerable = i.enumerable), "writable" in i && (c.writable = i.writable, delete e.getter[r], delete e.setter[r]), "value" in i ? (c.value = i.value, delete e.getter[r], delete e.setter[r]) : n !== ReferenceError && (c.value = n, delete e.getter[r], delete e.setter[r]);
                    try {
                        Object.defineProperty(e.properties, r, c);
                    } catch (t) {
                        this.throwException(this.TYPE_ERROR, "Cannot redefine property: " + r);
                    }
                } else {
                    if (n === ReferenceError) throw ReferenceError("Value not specified.");
                    if (void 0 !== e._native && "_" != r.charAt(0)) {
                        var l = typeof e._native[r];
                        if ("function" !== l && ("undefined" !== l || $af62ec6a841e10b9$var$en(e._native.constructor, r))) {
                            var p = this.unwrap ? this.unwrap(n) : n;
                            return void (e._native[r] = p);
                        }
                    }
                    for(var h = e; !(r in h.properties);)if (!(h = this.getPrototype(h))) {
                        h = e;
                        break;
                    }
                    if (h.setter && h.setter[r]) return h.setter[r];
                    if (h.getter && h.getter[r]) o && this.throwException(this.TYPE_ERROR, "Cannot set property '" + r + "' of object '" + e + "' which only has a getter");
                    else try {
                        e.properties[r] = n;
                    } catch (t) {
                        o && this.throwException(this.TYPE_ERROR, "Cannot assign to read only property '" + r + "' of object '" + e + "'");
                    }
                }
            } else o && this.throwException(this.TYPE_ERROR, "Can't add property '" + r + "', object is not extensible");
        } else o && this.throwException(this.TYPE_ERROR, "Can't create property '" + r + "' on '" + e + "'");
    }, t.prototype.setNativeFunctionPrototype = function(e, r, n) {
        this.setProperty(e.properties.prototype, r, this.createNativeFunction(n, !1), t.NONENUMERABLE_DESCRIPTOR);
    }, t.prototype.getScope = function() {
        var t = this.stateStack[this.stateStack.length - 1].scope;
        if (!t) throw Error("No scope found.");
        return t;
    }, t.prototype.createScope = function(t, e) {
        var r = this.createObjectProto(null);
        if (r.parentScope = e, e || this.initGlobalScope(r), this.populateScope_(t, r), r.strict = !1, e && e.strict) r.strict = !0;
        else {
            var n = t.body && t.body[0];
            n && n.expression && "Literal" === n.expression.type && "use strict" === n.expression.value && (r.strict = !0);
        }
        return r;
    }, t.prototype.createSpecialScope = function(t, e) {
        if (!t) throw Error("parentScope required");
        var r = e || this.createObjectProto(null);
        return r.parentScope = t, r.strict = t.strict, r;
    }, t.prototype.getValueFromScope = function(t) {
        for(var e = this.getScope(); e && e !== this.global;){
            if (t in e.properties) return e.properties[t];
            e = e.parentScope;
        }
        if (e === this.global && this.hasProperty(e, t)) return this.getProperty(e, t);
        var r = this.stateStack[this.stateStack.length - 1].node;
        "UnaryExpression" === r.type && "typeof" === r.operator || this.throwException(this.REFERENCE_ERROR, t + " is not defined");
    }, t.prototype.setValueToScope = function(t, e) {
        for(var r = this.getScope(), n = r.strict; r && r !== this.global;){
            if (t in r.properties) return void (r.properties[t] = e);
            r = r.parentScope;
        }
        if (r === this.global && (!n || this.hasProperty(r, t))) return this.setProperty(r, t, e);
        this.throwException(this.REFERENCE_ERROR, t + " is not defined");
    }, t.prototype.populateScope_ = function(e, r) {
        if ("VariableDeclaration" === e.type) for(var n = 0; n < e.declarations.length; n++)this.setProperty(r, e.declarations[n].id.name, void 0, t.VARIABLE_DESCRIPTOR);
        else {
            if ("FunctionDeclaration" === e.type) return void this.setProperty(r, e.id.name, this.createFunction(e, r), t.VARIABLE_DESCRIPTOR);
            if ("FunctionExpression" === e.type) return;
            if ("ExpressionStatement" === e.type) return;
        }
        var i = e.constructor;
        for(var o in e){
            var s = e[o];
            if (s && "object" == typeof s) {
                if (Array.isArray(s)) for(n = 0; n < s.length; n++)s[n] && s[n].constructor === i && this.populateScope_(s[n], r);
                else s.constructor === i && this.populateScope_(s, r);
            }
        }
    }, t.prototype.stripLocations_ = function(t, e, r) {
        for(var n in e ? t.start = e : delete t.start, r ? t.end = r : delete t.end, t)if (t.hasOwnProperty(n)) {
            var i = t[n];
            i && "object" == typeof i && this.stripLocations_(i, e, r);
        }
    }, t.prototype.calledWithNew = function() {
        return this.stateStack[this.stateStack.length - 1].isConstructor;
    }, t.prototype.getValue = function(e) {
        return e[0] === t.SCOPE_REFERENCE ? this.getValueFromScope(e[1]) : this.getProperty(e[0], e[1]);
    }, t.prototype.setValue = function(e, r) {
        return e[0] === t.SCOPE_REFERENCE ? this.setValueToScope(e[1], r) : this.setProperty(e[0], e[1], r);
    }, t.prototype.throwException = function(e, r) {
        if (void 0 === r) var n = e;
        else n = this.createObject(e), this.setProperty(n, "message", r, t.NONENUMERABLE_DESCRIPTOR);
        throw this.executeException(n), t.STEP_ERROR;
    }, t.prototype.executeException = function(t) {
        var e, r = this.stateStack.slice();
        do {
            this.stateStack.pop();
            var n = this.stateStack[this.stateStack.length - 1];
            if ("TryStatement" === n.node.type) return void (n.throwValue = t);
        }while (n && "Program" !== n.node.type);
        if (this.isa(t, this.ERROR)) {
            var i = {
                EvalError: EvalError,
                RangeError: RangeError,
                ReferenceError: ReferenceError,
                SyntaxError: SyntaxError,
                TypeError: TypeError,
                URIError: URIError
            }, o = this.getProperty(t, "name").toString(), s = this.getProperty(t, "message").valueOf();
            e = (i[o] || Error)(s);
        } else e = t.toString();
        throw this.stateStack = r, e;
    }, t.prototype.createGetter_ = function(t, e) {
        var r = Array.isArray(e) ? e[0] : e, n = new this.nodeConstructor;
        n.type = "CallExpression";
        var i = new $af62ec6a841e10b9$var$tn(n, this.stateStack[this.stateStack.length - 1].scope);
        return i.doneCallee_ = !0, i.funcThis_ = r, i.func_ = t, i.doneArgs_ = !0, i.arguments_ = [], i;
    }, t.prototype.createSetter_ = function(t, e, r) {
        var n = Array.isArray(e) ? e[0] : this.global, i = new this.nodeConstructor;
        i.type = "CallExpression";
        var o = new $af62ec6a841e10b9$var$tn(i, this.stateStack[this.stateStack.length - 1].scope);
        return o.doneCallee_ = !0, o.funcThis_ = n, o.func_ = t, o.doneArgs_ = !0, o.arguments_ = [
            r
        ], o;
    }, t.prototype.stepArrayExpression = function(t, e, r) {
        var n = r.elements, i = e.n_ || 0;
        for(e.array_ ? (this.setProperty(e.array_, i, e.value), i++) : (e.array_ = this.createObjectProto(this.ARRAY_PROTO), e.array_.properties.length = n.length); i < n.length;){
            if (n[i]) return e.n_ = i, new $af62ec6a841e10b9$var$tn(n[i], e.scope);
            i++;
        }
        t.pop(), t[t.length - 1].value = e.array_;
    }, t.prototype.stepAssignmentExpression = function(t, e, r) {
        if (!e.doneLeft_) {
            e.doneLeft_ = !0;
            var n = new $af62ec6a841e10b9$var$tn(r.left, e.scope);
            return n.components = !0, n;
        }
        if (!e.doneRight_) {
            if (e.leftReference_ || (e.leftReference_ = e.value), e.doneGetter_ && (e.leftValue_ = e.value), !e.doneGetter_ && "=" !== r.operator) {
                var i = this.getValue(e.leftReference_);
                if (e.leftValue_ = i, i && "object" == typeof i && i.isGetter) {
                    i.isGetter = !1, e.doneGetter_ = !0;
                    var o = i;
                    return this.createGetter_(o, e.leftReference_);
                }
            }
            return e.doneRight_ = !0, new $af62ec6a841e10b9$var$tn(r.right, e.scope);
        }
        if (e.doneSetter_) return t.pop(), void (t[t.length - 1].value = e.doneSetter_);
        var s = e.leftValue_, a = e.value;
        switch(r.operator){
            case "=":
                s = a;
                break;
            case "+=":
                s += a;
                break;
            case "-=":
                s -= a;
                break;
            case "*=":
                s *= a;
                break;
            case "/=":
                s /= a;
                break;
            case "%=":
                s %= a;
                break;
            case "<<=":
                s <<= a;
                break;
            case ">>=":
                s >>= a;
                break;
            case ">>>=":
                s >>>= a;
                break;
            case "&=":
                s &= a;
                break;
            case "^=":
                s ^= a;
                break;
            case "|=":
                s |= a;
                break;
            default:
                throw SyntaxError("Unknown assignment expression: " + r.operator);
        }
        var u = this.setValue(e.leftReference_, s);
        if (u) return e.doneSetter_ = s, this.createSetter_(u, e.leftReference_, s);
        t.pop(), t[t.length - 1].value = s;
    }, t.prototype.stepBinaryExpression = function(t, e, r) {
        if (!e.doneLeft_) return e.doneLeft_ = !0, new $af62ec6a841e10b9$var$tn(r.left, e.scope);
        if (!e.doneRight_) return e.doneRight_ = !0, e.leftValue_ = e.value, new $af62ec6a841e10b9$var$tn(r.right, e.scope);
        t.pop();
        var n, i = e.leftValue_, o = e.value;
        switch(r.operator){
            case "==":
                n = i == o;
                break;
            case "!=":
                n = i != o;
                break;
            case "===":
                n = i === o;
                break;
            case "!==":
                n = i !== o;
                break;
            case ">":
                n = i > o;
                break;
            case ">=":
                n = i >= o;
                break;
            case "<":
                n = i < o;
                break;
            case "<=":
                n = i <= o;
                break;
            case "+":
                n = i + o;
                break;
            case "-":
                n = i - o;
                break;
            case "*":
                n = i * o;
                break;
            case "/":
                n = i / o;
                break;
            case "%":
                n = i % o;
                break;
            case "&":
                n = i & o;
                break;
            case "|":
                n = i | o;
                break;
            case "^":
                n = i ^ o;
                break;
            case "<<":
                n = i << o;
                break;
            case ">>":
                n = i >> o;
                break;
            case ">>>":
                n = i >>> o;
                break;
            case "in":
                o && o.isObject || this.throwException(this.TYPE_ERROR, "'in' expects an object, not '" + o + "'"), n = this.hasProperty(o, i);
                break;
            case "instanceof":
                this.isa(o, this.FUNCTION) || this.throwException(this.TYPE_ERROR, "Right-hand side of instanceof is not an object"), n = !!i.isObject && this.isa(i, o);
                break;
            default:
                throw SyntaxError("Unknown binary operator: " + r.operator);
        }
        t[t.length - 1].value = n;
    }, t.prototype.stepBlockStatement = function(t, e, r) {
        var n = e.n_ || 0, i = r.body[n];
        if (i) return e.n_ = n + 1, new $af62ec6a841e10b9$var$tn(i, e.scope);
        t.pop();
    }, t.prototype.stepBreakStatement = function(t, e, r) {
        t.pop();
        var n = null;
        for(r.label && (n = r.label.name); e && "CallExpression" !== e.node.type && "NewExpression" !== e.node.type;){
            if (n) {
                if (e.labels && -1 !== e.labels.indexOf(n)) return;
            } else if (e.isLoop || e.isSwitch) return;
            e = t.pop();
        }
        throw SyntaxError("Illegal break statement");
    }, t.prototype.stepCallExpression = function(e, r, n) {
        if (!r.doneCallee_) {
            r.doneCallee_ = 1;
            var i = new $af62ec6a841e10b9$var$tn(n.callee, r.scope);
            return i.components = !0, i;
        }
        if (1 === r.doneCallee_) {
            r.doneCallee_ = 2;
            var o = r.value;
            if (Array.isArray(o)) {
                if (r.func_ = this.getValue(o), o[0] !== t.SCOPE_REFERENCE && (r.funcThis_ = o[0]), (o = r.func_) && "object" == typeof o && o.isGetter) return o.isGetter = !1, r.doneCallee_ = 1, this.createGetter_(o, r.value);
            } else r.func_ = o;
            r.arguments_ = [], r.n_ = 0;
        }
        if (o = r.func_, !r.doneArgs_) {
            if (0 !== r.n_ && r.arguments_.push(r.value), n.arguments[r.n_]) return new $af62ec6a841e10b9$var$tn(n.arguments[r.n_++], r.scope);
            "NewExpression" === n.type ? (o.illegalConstructor && this.throwException(this.TYPE_ERROR, o + " is not a constructor"), r.funcThis_ = this.createObject(o), r.isConstructor = !0) : void 0 === r.funcThis_ && (r.funcThis_ = r.scope.strict ? void 0 : this.global), r.doneArgs_ = !0;
        }
        if (r.doneExec_) e.pop(), r.isConstructor && "object" != typeof r.value ? e[e.length - 1].value = r.funcThis_ : e[e.length - 1].value = r.value;
        else {
            r.doneExec_ = !0, o && o.isObject || (console.log("non-function called", o, r), this.throwException(this.TYPE_ERROR, o + " is not a function"));
            var s = o.node;
            if (s) {
                for(var a = this.createScope(s.body, o.parentScope), u = 0; u < s.params.length; u++){
                    var c = s.params[u].name, l = r.arguments_.length > u ? r.arguments_[u] : void 0;
                    this.setProperty(a, c, l);
                }
                var p = this.createObjectProto(this.ARRAY_PROTO);
                for(u = 0; u < r.arguments_.length; u++)this.setProperty(p, u, r.arguments_[u]);
                this.setProperty(a, "arguments", p);
                var h = s.id && s.id.name;
                return h && this.setProperty(a, h, o), this.setProperty(a, "this", r.funcThis_, t.READONLY_DESCRIPTOR), r.value = void 0, new $af62ec6a841e10b9$var$tn(s.body, a);
            }
            if (o.eval) {
                var d = r.arguments_[0];
                if ("string" == typeof d) {
                    try {
                        var f = $af62ec6a841e10b9$var$Dt(d.toString(), t.PARSE_OPTIONS);
                    } catch (t) {
                        this.throwException(this.SYNTAX_ERROR, "Invalid code: " + t.message);
                    }
                    var y = new this.nodeConstructor;
                    return y.type = "EvalProgram_", y.body = f.body, this.stripLocations_(y, n.start, n.end), (a = r.scope).strict ? a = this.createScope(f, a) : this.populateScope_(f, a), this.value = void 0, new $af62ec6a841e10b9$var$tn(y, a);
                }
                r.value = d;
            } else if (o.nativeFunc) void 0 !== r.funcThis_ && void 0 !== r.funcThis_._native ? r.value = o.nativeFunc.call(r.funcThis_, r.arguments_) : r.value = o.nativeFunc.apply(r.funcThis_, r.arguments_);
            else {
                if (o.asyncFunc) {
                    var g = this, v = r.arguments_.concat(function(t) {
                        r.value = t, g.paused_ = !1;
                    });
                    return this.paused_ = !0, void o.asyncFunc.apply(r.funcThis_, v);
                }
                this.throwException(this.TYPE_ERROR, o.class + " is not a function");
            }
        }
    }, t.prototype.stepCatchClause = function(t, e, r) {
        if (!e.done_) {
            e.done_ = !0;
            var n = this.createSpecialScope(e.scope);
            return this.setProperty(n, r.param.name, e.throwValue), new $af62ec6a841e10b9$var$tn(r.body, n);
        }
        t.pop();
    }, t.prototype.stepConditionalExpression = function(t, e, r) {
        var n = e.mode_ || 0;
        if (0 === n) return e.mode_ = 1, new $af62ec6a841e10b9$var$tn(r.test, e.scope);
        if (1 === n) {
            e.mode_ = 2;
            var i = Boolean(e.value);
            if (i && r.consequent) return new $af62ec6a841e10b9$var$tn(r.consequent, e.scope);
            if (!i && r.alternate) return new $af62ec6a841e10b9$var$tn(r.alternate, e.scope);
            this.value = void 0;
        }
        t.pop(), "ConditionalExpression" === r.type && (t[t.length - 1].value = e.value);
    }, t.prototype.stepContinueStatement = function(t, e, r) {
        t.pop();
        var n = null;
        for(r.label && (n = r.label.name), e = t[t.length - 1]; e && "CallExpression" !== e.node.type && "NewExpression" !== e.node.type;){
            if (e.isLoop && (!n || e.labels && -1 !== e.labels.indexOf(n))) return;
            t.pop(), e = t[t.length - 1];
        }
        throw SyntaxError("Illegal continue statement");
    }, t.prototype.stepDebuggerStatement = function(t, e, r) {
        t.pop();
    }, t.prototype.stepDoWhileStatement = function(t, e, r) {
        if ("DoWhileStatement" === r.type && void 0 === e.test_ && (e.value = !0, e.test_ = !0), !e.test_) return e.test_ = !0, new $af62ec6a841e10b9$var$tn(r.test, e.scope);
        if (e.value) {
            if (r.body) return e.test_ = !1, e.isLoop = !0, new $af62ec6a841e10b9$var$tn(r.body, e.scope);
        } else t.pop();
    }, t.prototype.stepEmptyStatement = function(t, e, r) {
        t.pop();
    }, t.prototype.stepEvalProgram_ = function(t, e, r) {
        var n = e.n_ || 0, i = r.body[n];
        if (i) return e.n_ = n + 1, new $af62ec6a841e10b9$var$tn(i, e.scope);
        t.pop(), t[t.length - 1].value = this.value;
    }, t.prototype.stepExpressionStatement = function(t, e, r) {
        if (!e.done_) return e.done_ = !0, new $af62ec6a841e10b9$var$tn(r.expression, e.scope);
        t.pop(), this.value = e.value;
    }, t.prototype.stepForInStatement = function(e, r, n) {
        if (!r.doneInit_ && (r.doneInit_ = !0, n.left.declarations && n.left.declarations[0].init)) return r.scope.strict && this.throwException(this.SYNTAX_ERROR, "for-in loop variable declaration may not have an initializer."), new $af62ec6a841e10b9$var$tn(n.left, r.scope);
        if (!r.doneObject_) return r.doneObject_ = !0, r.variable_ || (r.variable_ = r.value), new $af62ec6a841e10b9$var$tn(n.right, r.scope);
        if (r.isLoop || (r.isLoop = !0, r.object_ = r.value, r.visited_ = Object.create(null)), void 0 === r.name_) {
            t: do {
                if (r.object_ && r.object_.isObject) {
                    r.props_ || (r.props_ = Object.getOwnPropertyNames(r.object_.properties));
                    do var i = r.props_.shift();
                    while (i && (r.visited_[i] || !Object.prototype.hasOwnProperty.call(r.object_.properties, i)));
                    if (i && (r.visited_[i] = !0, Object.prototype.propertyIsEnumerable.call(r.object_.properties, i))) {
                        r.name_ = i;
                        break t;
                    }
                } else if (null !== r.object_) {
                    r.props_ || (r.props_ = Object.getOwnPropertyNames(r.object_));
                    do i = r.props_.shift();
                    while (i && r.visited_[i]);
                    if (i) {
                        r.visited_[i] = !0, r.name_ = i;
                        break t;
                    }
                }
                r.object_ = this.getPrototype(r.object_), r.props_ = null;
            }while (null !== r.object_);
            if (null === r.object_) return void e.pop();
        }
        if (!r.doneVariable_) {
            r.doneVariable_ = !0;
            var o = n.left;
            if ("VariableDeclaration" !== o.type) {
                r.variable_ = null;
                var s = new $af62ec6a841e10b9$var$tn(o, r.scope);
                return s.components = !0, s;
            }
            r.variable_ = [
                t.SCOPE_REFERENCE,
                o.declarations[0].id.name
            ];
        }
        if (r.variable_ || (r.variable_ = r.value), !r.doneSetter_) {
            r.doneSetter_ = !0;
            var a = r.name_, u = this.setValue(r.variable_, a);
            if (u) return this.createSetter_(u, r.variable_, a);
        }
        return r.name_ = void 0, r.doneVariable_ = !1, r.doneSetter_ = !1, n.body ? new $af62ec6a841e10b9$var$tn(n.body, r.scope) : void 0;
    }, t.prototype.stepForStatement = function(t, e, r) {
        var n = e.mode_ || 0;
        if (0 === n) {
            if (e.mode_ = 1, r.init) return new $af62ec6a841e10b9$var$tn(r.init, e.scope);
        } else if (1 === n) {
            if (e.mode_ = 2, r.test) return new $af62ec6a841e10b9$var$tn(r.test, e.scope);
        } else if (2 === n) {
            if (e.mode_ = 3, !r.test || e.value) return e.isLoop = !0, new $af62ec6a841e10b9$var$tn(r.body, e.scope);
            t.pop();
        } else if (3 === n && (e.mode_ = 1, r.update)) return new $af62ec6a841e10b9$var$tn(r.update, e.scope);
    }, t.prototype.stepFunctionDeclaration = function(t, e, r) {
        t.pop();
    }, t.prototype.stepFunctionExpression = function(t, e, r) {
        t.pop(), t[t.length - 1].value = this.createFunction(r, e.scope);
    }, t.prototype.stepIdentifier = function(e, r, n) {
        if (e.pop(), r.components) e[e.length - 1].value = [
            t.SCOPE_REFERENCE,
            n.name
        ];
        else {
            var i = this.getValueFromScope(n.name);
            if (i && "object" == typeof i && i.isGetter) {
                i.isGetter = !1;
                for(var o = r.scope; !this.hasProperty(o, n.name);)o = o.parentScope;
                var s = i;
                return this.createGetter_(s, this.global);
            }
            e[e.length - 1].value = i;
        }
    }, t.prototype.stepIfStatement = function(t, e, r) {
        return this.stepConditionalExpression(t, e, r);
    }, t.prototype.stepLabeledStatement = function(t, e, r) {
        t.pop();
        var n = e.labels || [];
        n.push(r.label.name);
        var i = new $af62ec6a841e10b9$var$tn(r.body, e.scope);
        return i.labels = n, i;
    }, t.prototype.stepLiteral = function(t, e, r) {
        t.pop();
        var n = r.value;
        if (n instanceof RegExp) {
            var i = this.createObjectProto(this.REGEXP_PROTO);
            this.populateRegExp(i, n), n = i;
        }
        t[t.length - 1].value = n;
    }, t.prototype.stepLogicalExpression = function(t, e, r) {
        if ("&&" !== r.operator && "||" !== r.operator) throw SyntaxError("Unknown logical operator: " + r.operator);
        if (!e.doneLeft_) return e.doneLeft_ = !0, new $af62ec6a841e10b9$var$tn(r.left, e.scope);
        if (e.doneRight_) t.pop(), t[t.length - 1].value = e.value;
        else {
            if (!("&&" === r.operator && !e.value || "||" === r.operator && e.value)) return e.doneRight_ = !0, new $af62ec6a841e10b9$var$tn(r.right, e.scope);
            t.pop(), t[t.length - 1].value = e.value;
        }
    }, t.prototype.stepMemberExpression = function(t, e, r) {
        if (!e.doneObject_) return e.doneObject_ = !0, new $af62ec6a841e10b9$var$tn(r.object, e.scope);
        var n;
        if (r.computed) {
            if (!e.doneProperty_) return e.object_ = e.value, e.doneProperty_ = !0, new $af62ec6a841e10b9$var$tn(r.property, e.scope);
            n = e.value;
        } else e.object_ = e.value, n = r.property.name;
        if (t.pop(), e.components) t[t.length - 1].value = [
            e.object_,
            n
        ];
        else {
            var i = this.getProperty(e.object_, n);
            if (i && "object" == typeof i && i.isGetter) {
                i.isGetter = !1;
                var o = i;
                return this.createGetter_(o, e.object_);
            }
            t[t.length - 1].value = i;
        }
    }, t.prototype.stepNewExpression = function(t, e, r) {
        return this.stepCallExpression(t, e, r);
    }, t.prototype.stepObjectExpression = function(t, e, r) {
        var n = e.n_ || 0, i = r.properties[n];
        if (e.object_) {
            var o = i.key;
            if ("Identifier" === o.type) var s = o.name;
            else {
                if ("Literal" !== o.type) throw SyntaxError("Unknown object structure: " + o.type);
                s = o.value;
            }
            e.properties_[s] || (e.properties_[s] = {}), e.properties_[s][i.kind] = e.value, e.n_ = ++n, i = r.properties[n];
        } else e.object_ = this.createObjectProto(this.OBJECT_PROTO), e.properties_ = Object.create(null);
        if (i) return new $af62ec6a841e10b9$var$tn(i.value, e.scope);
        for(var a in e.properties_){
            var u = e.properties_[a];
            if ("get" in u || "set" in u) {
                var c = {
                    configurable: !0,
                    enumerable: !0,
                    get: u.get,
                    set: u.set
                };
                this.setProperty(e.object_, a, null, c);
            } else this.setProperty(e.object_, a, u.init);
        }
        t.pop(), t[t.length - 1].value = e.object_;
    }, t.prototype.stepProgram = function(t, e, r) {
        var n = e.n_ || 0, i = r.body[n];
        if (i) return e.done = !1, e.n_ = n + 1, new $af62ec6a841e10b9$var$tn(i, e.scope);
        e.done = !0;
    }, t.prototype.stepReturnStatement = function(t, e, r) {
        if (r.argument && !e.done_) return e.done_ = !0, new $af62ec6a841e10b9$var$tn(r.argument, e.scope);
        var n = e.value, i = t.length - 1;
        for(e = t[i]; "CallExpression" !== e.node.type && "NewExpression" !== e.node.type;){
            if ("TryStatement" !== e.node.type && t.splice(i, 1), --i < 0) throw SyntaxError("Illegal return statement");
            e = t[i];
        }
        e.value = n;
    }, t.prototype.stepSequenceExpression = function(t, e, r) {
        var n = e.n_ || 0, i = r.expressions[n];
        if (i) return e.n_ = n + 1, new $af62ec6a841e10b9$var$tn(i, e.scope);
        t.pop(), t[t.length - 1].value = e.value;
    }, t.prototype.stepSwitchStatement = function(t, e, r) {
        if (!e.test_) return e.test_ = 1, new $af62ec6a841e10b9$var$tn(r.discriminant, e.scope);
        for(1 === e.test_ && (e.test_ = 2, e.switchValue_ = e.value);;){
            var n = e.index_ || 0, i = r.cases[n];
            if (e.matched_ || !i || i.test) {
                if (i || e.matched_ || !e.defaultCase_) {
                    if (!i) return void t.pop();
                    if (!e.matched_ && !e.tested_ && i.test) return e.tested_ = !0, new $af62ec6a841e10b9$var$tn(i.test, e.scope);
                    if (e.matched_ || e.value === e.switchValue_) {
                        e.matched_ = !0;
                        var o = e.n_ || 0;
                        if (i.consequent[o]) return e.isSwitch = !0, e.n_ = o + 1, new $af62ec6a841e10b9$var$tn(i.consequent[o], e.scope);
                    }
                    e.tested_ = !1, e.n_ = 0, e.index_ = n + 1;
                } else e.matched_ = !0, e.index_ = e.defaultCase_;
            } else e.defaultCase_ = n, e.index_ = n + 1;
        }
    }, t.prototype.stepThisExpression = function(t, e, r) {
        t.pop(), t[t.length - 1].value = this.getValueFromScope("this");
    }, t.prototype.stepThrowStatement = function(t, e, r) {
        if (!e.done_) return e.done_ = !0, new $af62ec6a841e10b9$var$tn(r.argument, e.scope);
        this.throwException(e.value);
    }, t.prototype.stepTryStatement = function(t, e, r) {
        if (!e.doneBlock_) return e.doneBlock_ = !0, new $af62ec6a841e10b9$var$tn(r.block, e.scope);
        if (e.throwValue && !e.doneHandler_ && r.handler) {
            e.doneHandler_ = !0;
            var n = new $af62ec6a841e10b9$var$tn(r.handler, e.scope);
            return n.throwValue = e.throwValue, e.throwValue = null, n;
        }
        if (!e.doneFinalizer_ && r.finalizer) return e.doneFinalizer_ = !0, new $af62ec6a841e10b9$var$tn(r.finalizer, e.scope);
        e.throwValue ? this.executeException(e.throwValue) : t.pop();
    }, t.prototype.stepUnaryExpression = function(e, r, n) {
        if (!r.done_) {
            r.done_ = !0;
            var i = new $af62ec6a841e10b9$var$tn(n.argument, r.scope);
            return i.components = "delete" === n.operator, i;
        }
        e.pop();
        var o = r.value;
        if ("-" === n.operator) o = -o;
        else if ("+" === n.operator) o = +o;
        else if ("!" === n.operator) o = !o;
        else if ("~" === n.operator) o = ~o;
        else if ("delete" === n.operator) {
            var s = !0;
            if (Array.isArray(o)) {
                var a = o[0];
                a === t.SCOPE_REFERENCE && (a = r.scope);
                var u = String(o[1]);
                try {
                    delete a.properties[u];
                } catch (t) {
                    r.scope.strict ? this.throwException(this.TYPE_ERROR, "Cannot delete property '" + u + "' of '" + a + "'") : s = !1;
                }
            }
            o = s;
        } else if ("typeof" === n.operator) o = o && "Function" === o.class ? "function" : typeof o;
        else {
            if ("void" !== n.operator) throw SyntaxError("Unknown unary operator: " + n.operator);
            o = void 0;
        }
        e[e.length - 1].value = o;
    }, t.prototype.stepUpdateExpression = function(t, e, r) {
        if (!e.doneLeft_) {
            e.doneLeft_ = !0;
            var n = new $af62ec6a841e10b9$var$tn(r.argument, e.scope);
            return n.components = !0, n;
        }
        if (e.leftSide_ || (e.leftSide_ = e.value), e.doneGetter_ && (e.leftValue_ = e.value), !e.doneGetter_) {
            var i = this.getValue(e.leftSide_);
            if (e.leftValue_ = i, i && "object" == typeof i && i.isGetter) {
                i.isGetter = !1, e.doneGetter_ = !0;
                var o = i;
                return this.createGetter_(o, e.leftSide_);
            }
        }
        if (e.doneSetter_) return t.pop(), void (t[t.length - 1].value = e.doneSetter_);
        var s;
        if (i = Number(e.leftValue_), "++" === r.operator) s = i + 1;
        else {
            if ("--" !== r.operator) throw SyntaxError("Unknown update expression: " + r.operator);
            s = i - 1;
        }
        var a = r.prefix ? s : i, u = this.setValue(e.leftSide_, s);
        if (u) return e.doneSetter_ = a, this.createSetter_(u, e.leftSide_, s);
        t.pop(), t[t.length - 1].value = a;
    }, t.prototype.stepVariableDeclaration = function(t, e, r) {
        var n = r.declarations, i = e.n_ || 0, o = n[i];
        for(e.init_ && o && (this.setValueToScope(o.id.name, e.value), e.init_ = !1, o = n[++i]); o;){
            if (o.init) return e.n_ = i, e.init_ = !0, new $af62ec6a841e10b9$var$tn(o.init, e.scope);
            o = n[++i];
        }
        t.pop();
    }, t.prototype.stepWithStatement = function(t, e, r) {
        if (!e.doneObject_) return e.doneObject_ = !0, new $af62ec6a841e10b9$var$tn(r.object, e.scope);
        if (!e.doneBody_) {
            e.doneBody_ = !0;
            var n = this.createSpecialScope(e.scope, e.value);
            return new $af62ec6a841e10b9$var$tn(r.body, n);
        }
        t.pop();
    }, t.prototype.stepWhileStatement = function(t, e, r) {
        return this.stepDoWhileStatement(t, e, r);
    }, t.PARSE_OPTIONS = {
        ecmaVersion: 5
    }, t.READONLY_DESCRIPTOR = {
        configurable: !0,
        enumerable: !0,
        writable: !1
    }, t.NONENUMERABLE_DESCRIPTOR = {
        configurable: !0,
        enumerable: !1,
        writable: !0
    }, t.READONLY_NONENUMERABLE_DESCRIPTOR = {
        configurable: !0,
        enumerable: !1,
        writable: !1
    }, t.VARIABLE_DESCRIPTOR = {
        configurable: !1,
        enumerable: !0,
        writable: !0
    }, t.STEP_ERROR = {}, t.SCOPE_REFERENCE = {}, t.toStringCycles_ = [], t;
}(), $af62ec6a841e10b9$var$Qr = function() {
    function t(t) {
        this.proto = null, this.isObject = !0, this.class = "Object", this.data = null, this._native = void 0, this.getter = Object.create(null), this.setter = Object.create(null), this.properties = Object.create(null), this.proto = t;
    }
    return t.prototype.toString = function() {
        if ("Array" === this.class) {
            (n = $af62ec6a841e10b9$var$Kr.toStringCycles_).push(this);
            try {
                for(var t = [], e = 0; e < this.properties.length; e++){
                    var r = this.properties[e];
                    t[e] = r && r.isObject && -1 !== n.indexOf(r) ? "..." : r;
                }
            } finally{
                n.pop();
            }
            return t.join(",");
        }
        if ("Error" === this.class) {
            var n;
            if (-1 !== (n = $af62ec6a841e10b9$var$Kr.toStringCycles_).indexOf(this)) return "[object Error]";
            var i, o = void 0, s = this;
            do if ("name" in s.properties) {
                i = s.properties.name;
                break;
            }
            while (s = s.proto);
            s = this;
            do if ("message" in s.properties) {
                o = s.properties.message;
                break;
            }
            while (s = s.proto);
            n.push(this);
            try {
                i = i && i.toString(), o = o && o.toString();
            } finally{
                n.pop();
            }
            return o ? i + ": " + o : String(i);
        }
        return null !== this.data ? String(this.data) : "[object " + this.class + "]";
    }, t.prototype.valueOf = function() {
        return void 0 === this.data || null === this.data || this.data instanceof RegExp ? this : this.data instanceof Date ? this.data.valueOf() : this.data;
    }, t;
}(), $af62ec6a841e10b9$var$tn = function(t, e) {
    this.node = t, this.scope = e;
}, $af62ec6a841e10b9$var$en = function(t, e) {
    for(var r = t; r && r.prototype;){
        if (Object.getOwnPropertyNames(r.prototype).indexOf(e) >= 0) return !0;
        r = Object.getPrototypeOf(r);
    }
    return !1;
};
function $af62ec6a841e10b9$var$rn(t, e) {
    var r = {}, n = $af62ec6a841e10b9$var$Dt(t, {
        locations: !0,
        onComment: function(t, e, n, i, o, s) {
            r[s.line] = e;
        }
    });
    if ("Program" !== n.type || 1 !== n.body.length || "FunctionDeclaration" !== n.body[0].type) throw new Error("JavaScript program should only have one function definition");
    var i = n.body[0].body.body, o = [], s = [];
    return i.forEach(function(t) {
        if ("ExpressionStatement" === t.type) {
            var n = t.expression;
            if ("AssignmentExpression" === n.type && "=" === n.operator && "MemberExpression" === n.left.type && "ThisExpression" === n.left.object.type && "Identifier" === n.left.property.type) {
                for(var i = [], a = n.loc.start.line - 1; a >= 0 && void 0 !== r[a]; a--)i.push(r[a]);
                if (!(i.length <= 0)) {
                    var u = n.left.property.name;
                    if (!(Array.isArray(e) && e.indexOf(u) >= 0) && "FunctionExpression" !== n.right.type) {
                        var c = function(t, e, r) {
                            var n = {
                                name: t,
                                title: {},
                                className: null,
                                proposed: !1,
                                initialValue: null
                            };
                            if (e.forEach(function(t) {
                                var e = t.indexOf("@ui ");
                                if (e >= 0) n.description = t.substring(e + 4).trim();
                                else {
                                    var r = t.indexOf("@title ");
                                    if (r >= 0) {
                                        var i = t.substring(r + 7).trim();
                                        0 === i.indexOf("@ja ") ? n.title.ja = i.substring(4).trim() : n.title.default = i;
                                    } else if (t.indexOf("@proposed") >= 0) n.proposed = !0;
                                    else {
                                        var o = t.indexOf("@comment ");
                                        if (o >= 0) {
                                            var s = t.substring(o + 9).trim();
                                            return n.comment || (n.comment = {}), void (0 === s.indexOf("@ja ") ? n.comment.ja = s.substring(4).trim() : n.comment.default = s);
                                        }
                                    }
                                }
                            }), !n.description && !n.comment) return null;
                            if (n.proposed || n.comment) return n;
                            var i = n.description.indexOf("("), o = n.description.indexOf(")", i);
                            if (!(i < 0 || o < 0)) {
                                n.className = n.description.substr(0, i);
                                try {
                                    var s = new $af62ec6a841e10b9$var$Kr("[".concat(n.description.substr(i + 1, o - i - 1), "]")), a = Date.now();
                                    for(s.unwrap = null, s.wrap = null; s.step() && !(Date.now() - a > 100););
                                    n.params = s.pseudoToNative(s.value);
                                } catch (t) {}
                                return n.params || (n.params = []), n;
                            }
                        }(u, i);
                        s.push(n), c && o.push(c);
                    }
                }
            }
        }
    }), {
        widgets: o,
        fields: s,
        ast: n
    };
}
function $af62ec6a841e10b9$var$nn(t, e) {
    if (void 0 === e && (e = -1), !t) return {
        dependencyAtCursor: null,
        dependencies: []
    };
    for(var r = [], n = null, i = ("string" == typeof t ? $af62ec6a841e10b9$var$Dt(t, $af62ec6a841e10b9$var$Kr.PARSE_OPTIONS) : t).body[0].body.body.slice(0); i.length > 0;){
        var o = i.shift();
        if (null != o) {
            if ("CallExpression" !== o.type) o.expression && i.push(o.expression), o.object && i.push(o.object), o.property && i.push(o.property), o.name && "string" != typeof name && i.push(o.name), o.left && i.push(o.left), o.right && i.push(o.right), o.id && i.push(o.id), o.init && i.push(o.init), o.callee && i.push(o.callee), o.body && Array.isArray(o.body) && i.push.apply(i, o.body), o.declarations && Array.isArray(o.declarations) && i.push.apply(i, o.declarations), o.arguments && Array.isArray(o.arguments) && i.push.apply(i, o.arguments), o.params && Array.isArray(o.params) && i.push.apply(i, o.params);
            else if (o.callee.name && "require" === o.callee.name) {
                var s = o.arguments;
                if (s && Array.isArray(s) && 1 === s.length) {
                    var a = s[0];
                    if ("Literal" === a.type) {
                        var u = a.value;
                        r.push(u), o.start && o.end && o.start <= e && o.end >= e && (n = u);
                    }
                }
            }
        }
    }
    return {
        dependencyAtCursor: n,
        dependencies: r
    };
}
$af62ec6a841e10b9$var$Kr.Object = $af62ec6a841e10b9$var$Qr, $af62ec6a841e10b9$var$Kr.State = $af62ec6a841e10b9$var$tn;
var $af62ec6a841e10b9$var$on = function() {
    return $af62ec6a841e10b9$var$on = Object.assign || function(t) {
        for(var e, r = 1, n = arguments.length; r < n; r++)for(var i in e = arguments[r])Object.prototype.hasOwnProperty.call(e, i) && (t[i] = e[i]);
        return t;
    }, $af62ec6a841e10b9$var$on.apply(this, arguments);
};
function $af62ec6a841e10b9$var$sn(t, e, r) {
    for(var n, i = 0, o = e.length; i < o; i++)!n && i in e || (n || (n = Array.prototype.slice.call(e, 0, i)), n[i] = e[i]);
    return t.concat(n || Array.prototype.slice.call(e));
}
function $af62ec6a841e10b9$var$an(t) {
    return "boolean" == typeof t || "number" == typeof t || "string" == typeof t || null == t;
}
"function" == typeof SuppressedError && SuppressedError;
var $af62ec6a841e10b9$var$un = {
    type: "ExpressionStatement",
    start: null,
    end: null,
    expression: {
        type: "CallExpression",
        start: null,
        end: null,
        expression: null,
        arguments: null
    },
    arguments: null
}, $af62ec6a841e10b9$var$cn = function() {
    function t(t, e, r) {
        void 0 === r && (r = null), this.wrapperTable = t, this.ignoredPropNames = e, this.wrapMethodParameter = r, this.verbose = !1, this.initialize();
    }
    return t.prototype.initialize = function() {
        var t = this, e = new $af62ec6a841e10b9$var$Kr("", function(e, r) {
            t.globalScope = r;
        });
        this.interpreter = e, this.interpreter.wrap = function(e) {
            return t.wrap(e);
        }, this.interpreter.unwrap = function(e, r) {
            return t.unwrap(e, r);
        }, this.wrappers = {}, Object.keys(this.wrapperTable).forEach(function(e) {
            return t.wrapClass(t.wrapperTable[e], e);
        });
    }, t.prototype.createGlobalFunction = function(t, e) {
        var r, n = this, i = e.func, o = e.raw, s = e.isConstructor, a = e.async, u = function() {
            for(var t = [], e = 0; e < arguments.length; e++)t[e] = arguments[e];
            var r = i(o ? t : t.map(function(e, r) {
                return r < t.length - 1 || !a ? n.unwrap(e) : e;
            }));
            return o ? r : n.wrap(r);
        };
        r = a ? this.interpreter.createAsyncFunction(u) : this.interpreter.createNativeFunction(u, s), this.interpreter.setProperty(this.globalScope, t, r);
    }, t.prototype.createFunction = function(t, e) {
        return void 0 === e && (e = !1), this.interpreter.createNativeFunction(t, e);
    }, t.prototype.setProperty = function(t, e, r) {
        this.interpreter.setProperty(t, e, this.wrap(r));
    }, t.prototype.setRawProperty = function(t, e, r) {
        this.interpreter.setProperty(t, e, r);
    }, t.prototype.getProperty = function(t, e) {
        return this.unwrap(this.interpreter.getProperty(t, e));
    }, t.prototype.getRawProperty = function(t, e) {
        return this.interpreter.getProperty(t, e);
    }, t.prototype.prepareRun = function(t) {
        var e;
        e = "string" == typeof t ? $af62ec6a841e10b9$var$Dt(t, $af62ec6a841e10b9$var$Kr.PARSE_OPTIONS) : t;
        var r = this.interpreter.createScope(e, this.globalScope);
        return this.interpreter.stateStack = [
            {
                node: e,
                scope: r,
                done: !1
            }
        ], r;
    }, t.prototype.newStatementFor = function(t) {
        return $af62ec6a841e10b9$var$Dt("new " + t + "();", $af62ec6a841e10b9$var$Kr.PARSE_OPTIONS);
    }, t.prototype.prepareNewInstance = function(t, e) {
        var r = this.interpreter.createScope($af62ec6a841e10b9$var$Dt("", $af62ec6a841e10b9$var$Kr.PARSE_OPTIONS), e);
        return this.interpreter.stateStack = [
            {
                node: t,
                scope: r,
                thisExpression: r
            }
        ], r;
    }, t.prototype.exec = function(t, e, r, n) {
        var i = this, o = this.interpreter;
        $af62ec6a841e10b9$var$un.expression.arguments = [];
        var s = [];
        return r.forEach(function(t) {
            $af62ec6a841e10b9$var$un.expression.arguments.push(null), s.push(i.wrap(t));
        }), o.stateStack = [
            {
                node: {
                    type: "Program",
                    body: [
                        $af62ec6a841e10b9$var$un
                    ]
                },
                scope: this.globalScope,
                done: !0,
                n_: 1
            },
            {
                node: $af62ec6a841e10b9$var$un,
                scope: this.globalScope,
                done_: !0
            },
            {
                node: $af62ec6a841e10b9$var$un.expression,
                doneCallee_: 2,
                doneArgs_: !0,
                arguments_: s,
                funcThis_: t,
                func_: o.getProperty(t, e),
                scope: t,
                n_: s.length,
                value: [
                    t,
                    e
                ]
            }
        ], this.run(700, "call a method (" + t.className + "." + e + (n || "") + ")");
    }, t.prototype.run = function(t, e) {
        var r = this.interpreter, n = Date.now(), i = !1;
        try {
            for(; r.step();)if (Date.now() - n > t) {
                i = !0;
                break;
            }
        } catch (o) {
            throw this.verbose && console.log(r.stateStack), "string" == typeof o && (o = new Error(o)), r.stateStack.length > 0 && (o.node = r.stateStack[r.stateStack.length - 1].node), o;
        }
        if (i) {
            var o = new Error("timeout: spent too long time (> " + t + "ms) to " + e);
            throw r.stateStack.length > 0 && (o.node = r.stateStack[0].node), o;
        }
        return this.interpreter.value;
    }, t.prototype.cleanupProperties = function(t) {
        if (!t) return null;
        for(var e in this.ignoredPropNames.forEach(function(e) {
            void 0 !== t.properties[e] && delete t.properties[e];
        }), t.properties)this.cleanupProperty(t.properties[e]) || delete t.properties[e];
        return t.properties;
    }, t.prototype.cleanupProperty = function(t) {
        if ($af62ec6a841e10b9$var$an(t)) return !0;
        var e = t;
        if (e._native) return !0;
        var r = this.globalScope.properties;
        if (e.parent === r.Array) {
            for(var n = e.length, i = 0; i < e.length; i++)this.cleanupProperty(e.properties[i]) || (delete e.properties[i], n--);
            return e.length = n, n > 0;
        }
        if (e.parent === r.Object) {
            var o = !0;
            for(var s in e.properties)this.cleanupProperty(e.properties[s]) ? o = !1 : delete e.properties[s];
            return !o;
        }
        return !1;
    }, t.prototype.restoreProperties = function(t, e) {
        e && (t.properties = $af62ec6a841e10b9$var$on($af62ec6a841e10b9$var$on({}, t.properties), e));
    }, t.prototype.wrap = function(t) {
        if ("object" == typeof t && null !== t && void 0 !== t.constructor && "string" == typeof t.constructor.className) {
            var e = t.constructor.className, r = this.wrappers[e];
            if (void 0 === r) return;
            var n = this.interpreter.createObject(r);
            return n._native = t, n;
        }
        return this.verbose && ($af62ec6a841e10b9$var$an(t) || Array.isArray(t) || console.log("wrap complex obj:", String(t))), this.interpreter.nativeToPseudo(t);
    }, t.prototype.unwrap = function(t, e) {
        return "object" == typeof t && null !== t && t._native ? t._native : this.interpreter.pseudoToNative(t, e);
    }, t.prototype.wrapClass = function(t, e) {
        this.verbose && console.log("--- wrapping " + e + " ---"), t.className = e;
        var r = this, n = this.interpreter.createNativeFunction(function(e) {
            var i, o;
            if (i = r.interpreter.calledWithNew() ? this : r.interpreter.createObjectProto(n.properties.prototype), void 0 !== e) {
                if (Array.isArray(e)) for(var s = 0; s < e.length; s++)o[s] = r.unwrap(e[s]);
                else o = r.unwrap(e);
            }
            if (t) {
                var a = Object.create(t.prototype), u = t.apply(a, [
                    null
                ].concat(o).splice(1));
                i._native = null !== u && "object" == typeof u ? u : a;
            }
            return i;
        });
        return this.interpreter.setProperty(this.globalScope, e, n), this.wrapStaticMembers(n, t), this.wrapInstanceMembers(n, t), this.wrappers[e] = n, n;
    }, t.prototype.wrapStaticMembers = function(t, e) {
        var r = this, n = function(n) {
            var o = n;
            if (i.interpreter.setProperty(t, n, ReferenceError, {
                get: function() {
                    return r.wrap(e[o]);
                },
                set: function(t) {
                    return e[o] = r.unwrap(t);
                }
            }), i.verbose) {
                var s = void 0;
                try {
                    s = typeof e[o];
                } catch (t) {
                    s = "not accessible";
                }
                console.log("static " + o + " (" + s + ")");
            }
        }, i = this;
        for(var o in e)n(o);
    }, t.prototype.wrapInstanceMembers = function(t, e) {
        for(var r, n = new e, i = 0, o = $af62ec6a841e10b9$var$sn($af62ec6a841e10b9$var$sn([], Object.keys(n)), function(t) {
            for(var e = t, r = []; e && e.prototype;)r = $af62ec6a841e10b9$var$sn($af62ec6a841e10b9$var$sn([], r), Object.getOwnPropertyNames(e.prototype)), e = Object.getPrototypeOf(e);
            return r;
        }(e)).filter(function(t, e, r) {
            return r.indexOf(t) === e;
        }); i < o.length; i++){
            var s = o[i];
            if ("constructor" !== s && !this.interpreter.hasProperty(t, s) && !this.interpreter.hasProperty(t.properties.prototype, s) && "_" !== s.charAt(0)) {
                if (this.verbose) {
                    var a = void 0;
                    try {
                        a = typeof n[s];
                    } catch (t) {
                        a = "not accessible";
                    }
                    r = s + " (" + a + ")";
                }
                try {
                    if ("function" == typeof n[s]) {
                        var u = function(e, r) {
                            return function(n) {
                                var i;
                                return r.wrap((i = this._native)[e].apply(i, n.map(function(e) {
                                    var n = r.unwrap(e);
                                    return r.wrapMethodParameter ? r.wrapMethodParameter(t, n) : n;
                                })));
                            };
                        }(s, this);
                        this.interpreter.setProperty(t.properties.prototype, s, this.interpreter.createNativeFunction(u)), this.verbose && (r += " native method");
                    }
                } catch (t) {}
                this.verbose && console.log(r);
            }
        }
    }, t;
}();
function $af62ec6a841e10b9$var$ln(t) {
    var e = parseFloat(t);
    return isNaN(e) ? 0 : e;
}
function $af62ec6a841e10b9$var$pn(t) {
    var e;
    if ("undefined" == typeof window || !(null === (e = null === window || void 0 === window ? void 0 : window.location) || void 0 === e ? void 0 : e.search)) return null;
    for(var r = 0, n = window.location.search.substring(1).split("&"); r < n.length; r++){
        var i = n[r].split("=");
        if (decodeURIComponent(i[0]) === t) return decodeURIComponent(i[1]);
    }
    return null;
}
var $af62ec6a841e10b9$var$hn = function(t, e) {
    return $af62ec6a841e10b9$var$hn = Object.setPrototypeOf || ({
        __proto__: []
    }) instanceof Array && function(t, e) {
        t.__proto__ = e;
    } || function(t, e) {
        for(var r in e)Object.prototype.hasOwnProperty.call(e, r) && (t[r] = e[r]);
    }, $af62ec6a841e10b9$var$hn(t, e);
};
function $af62ec6a841e10b9$var$dn(t, e) {
    if ("function" != typeof e && null !== e) throw new TypeError("Class extends value " + String(e) + " is not a constructor or null");
    function r() {
        this.constructor = t;
    }
    $af62ec6a841e10b9$var$hn(t, e), t.prototype = null === e ? Object.create(e) : (r.prototype = e.prototype, new r);
}
var $af62ec6a841e10b9$var$fn = function() {
    return $af62ec6a841e10b9$var$fn = Object.assign || function(t) {
        for(var e, r = 1, n = arguments.length; r < n; r++)for(var i in e = arguments[r])Object.prototype.hasOwnProperty.call(e, i) && (t[i] = e[i]);
        return t;
    }, $af62ec6a841e10b9$var$fn.apply(this, arguments);
};
function $af62ec6a841e10b9$var$yn(t, e, r, n) {
    return new (r || (r = Promise))(function(e, i) {
        function o(t) {
            try {
                a(n.next(t));
            } catch (t) {
                i(t);
            }
        }
        function s(t) {
            try {
                a(n.throw(t));
            } catch (t) {
                i(t);
            }
        }
        function a(t) {
            var n;
            t.done ? e(t.value) : (n = t.value, n instanceof r ? n : new r(function(t) {
                t(n);
            })).then(o, s);
        }
        a((n = n.apply(t, [])).next());
    });
}
function $af62ec6a841e10b9$var$gn(t, e) {
    var r, n, i, o, s = {
        label: 0,
        sent: function() {
            if (1 & i[0]) throw i[1];
            return i[1];
        },
        trys: [],
        ops: []
    };
    return o = {
        next: a(0),
        throw: a(1),
        return: a(2)
    }, "function" == typeof Symbol && (o[Symbol.iterator] = function() {
        return this;
    }), o;
    function a(a) {
        return function(u) {
            return function(a) {
                if (r) throw new TypeError("Generator is already executing.");
                for(; o && (o = 0, a[0] && (s = 0)), s;)try {
                    if (r = 1, n && (i = 2 & a[0] ? n.return : a[0] ? n.throw || ((i = n.return) && i.call(n), 0) : n.next) && !(i = i.call(n, a[1])).done) return i;
                    switch(n = 0, i && (a = [
                        2 & a[0],
                        i.value
                    ]), a[0]){
                        case 0:
                        case 1:
                            i = a;
                            break;
                        case 4:
                            return s.label++, {
                                value: a[1],
                                done: !1
                            };
                        case 5:
                            s.label++, n = a[1], a = [
                                0
                            ];
                            continue;
                        case 7:
                            a = s.ops.pop(), s.trys.pop();
                            continue;
                        default:
                            if (!((i = (i = s.trys).length > 0 && i[i.length - 1]) || 6 !== a[0] && 2 !== a[0])) {
                                s = 0;
                                continue;
                            }
                            if (3 === a[0] && (!i || a[1] > i[0] && a[1] < i[3])) {
                                s.label = a[1];
                                break;
                            }
                            if (6 === a[0] && s.label < i[1]) {
                                s.label = i[1], i = a;
                                break;
                            }
                            if (i && s.label < i[2]) {
                                s.label = i[2], s.ops.push(a);
                                break;
                            }
                            i[2] && s.ops.pop(), s.trys.pop();
                            continue;
                    }
                    a = e.call(t, s);
                } catch (t) {
                    a = [
                        6,
                        t
                    ], n = 0;
                } finally{
                    r = i = 0;
                }
                if (5 & a[0]) throw a[1];
                return {
                    value: a[0] ? a[1] : void 0,
                    done: !0
                };
            }([
                a,
                u
            ]);
        };
    }
}
function $af62ec6a841e10b9$var$vn(t, e, r) {
    if (2 === arguments.length) for(var n, i = 0, o = e.length; i < o; i++)!n && i in e || (n || (n = Array.prototype.slice.call(e, 0, i)), n[i] = e[i]);
    return t.concat(n || Array.prototype.slice.call(e));
}
"function" == typeof SuppressedError && SuppressedError;
var $af62ec6a841e10b9$var$mn, $af62ec6a841e10b9$var$bn, $af62ec6a841e10b9$var$_n = [
    0,
    0,
    0,
    0
], $af62ec6a841e10b9$export$e985807e6b50ff90 = function() {
    function t() {
        this._position = 0, this._wait = 50, this.update = this.update.bind(this);
    }
    return Object.defineProperty(t.prototype, "wait", {
        get: function() {
            return this._wait;
        },
        set: function(t) {
            this._wait = t, this._isPlaying && this.start();
        },
        enumerable: !1,
        configurable: !0
    }), Object.defineProperty(t.prototype, "isPlaying", {
        get: function() {
            return this._isPlaying;
        },
        enumerable: !1,
        configurable: !0
    }), Object.defineProperty(t.prototype, "position", {
        get: function() {
            if (!this.isPlaying) return this._position;
            var t = this.basePosition.position + (Date.now() - this.basePosition.time);
            return Math.min(t, this.player.video.duration);
        },
        enumerable: !1,
        configurable: !0
    }), t.prototype.initialize = function(t) {
        var e = t.player, r = t.updater, n = t.emitter;
        return $af62ec6a841e10b9$var$yn(this, 0, void 0, function() {
            return $af62ec6a841e10b9$var$gn(this, function(t) {
                return this.player = e, this.updateMediaPosition = r, this.emitter = n, [
                    2
                ];
            });
        });
    }, t.prototype.play = function() {
        this.start(), this.emitter.onPlay();
    }, t.prototype.stop = function() {
        this.clearInterval(), this._isPlaying = !1, this.seek(0), this.pause(), this.emitter.onStop();
    }, t.prototype.pause = function() {
        this.clearInterval(), this._isPlaying = !1, this.emitter.onPause();
    }, t.prototype.seek = function(t) {
        var e = this;
        this._position = t, this.updateMediaPosition(t).then(function() {
            e.emitter.onSeek(t), e.emitter.onSeekComplete(t);
        }), this.isPlaying && this.start();
    }, t.prototype.dispose = function() {
        this.clearInterval();
    }, t.prototype.clearInterval = function() {
        window.clearInterval(this.intervalId);
    }, t.prototype.start = function() {
        this.clearInterval(), this._isPlaying = !0, this.basePosition = {
            time: Date.now(),
            position: this._position
        }, this.intervalId = window.setInterval(this.update, this.wait);
    }, t.prototype.update = function() {
        this.player.video || this.stop();
        var t = this.basePosition.position + (Date.now() - this.basePosition.time);
        this._position = Math.min(t, this.player.video.duration), this.updateMediaPosition(this.position), this._position >= this.player.video.duration && this.stop();
    }, t;
}();

function $af62ec6a841e10b9$var$Pn() {
    return $af62ec6a841e10b9$var$yn(this, 0, void 0, function() {
        return $af62ec6a841e10b9$var$gn(this, function(t) {
            return $af62ec6a841e10b9$var$bn && $af62ec6a841e10b9$var$bn.Player ? [
                2,
                $af62ec6a841e10b9$var$bn
            ] : "undefined" == typeof window ? [
                2,
                (parcelRequire("8hJz1"))
            ] : window.Songle && window.Songle.Player ? [
                2,
                window.Songle
            ] : ($af62ec6a841e10b9$var$mn || ($af62ec6a841e10b9$var$mn = new Promise(function(t) {
                var e = !1;
                window.onSongleAPIReady = function(r) {
                    e = !0, t($af62ec6a841e10b9$var$bn = r);
                }, setTimeout(function() {
                    if (!e) {
                        var t = [];
                        document.querySelectorAll("script").forEach(function(e) {
                            var r = e.getAttribute("src");
                            r && r.indexOf("songle.jp/v2/api.js") >= 0 && t.push(e);
                        }), t.forEach(function(t) {
                            return t.parentElement.removeChild(t);
                        });
                        var r = document.createElement("script");
                        r.src = "https://api.songle.jp/v2/api.js", document.head.appendChild(r);
                    }
                }, 1e3);
            })), [
                2,
                $af62ec6a841e10b9$var$mn
            ]);
        });
    });
}
var $af62ec6a841e10b9$export$c66cf4e5d83f6286 = function() {
    function t(t) {
        void 0 === t && (t = {}), this.options = t, this.wait = 50, this.volumeListener = {
            onVolumeUpdate: this.onVolumeUpdate.bind(this)
        }, this.resetProps();
    }
    return Object.defineProperty(t.prototype, "songlePlayer", {
        get: function() {
            return this._songlePlayer;
        },
        enumerable: !1,
        configurable: !0
    }), Object.defineProperty(t.prototype, "isPlaying", {
        get: function() {
            return !!this._songlePlayer && this._songlePlayer.isPlaying;
        },
        enumerable: !1,
        configurable: !0
    }), Object.defineProperty(t.prototype, "withSync", {
        get: function() {
            var t, e;
            return !(!(null === (t = this.options) || void 0 === t ? void 0 : t.accessToken) && !(null === (e = this.options) || void 0 === e ? void 0 : e.secretToken));
        },
        enumerable: !1,
        configurable: !0
    }), Object.defineProperty(t.prototype, "position", {
        get: function() {
            var t;
            if (!this._songlePlayer) return 0;
            if (this.lastPosition > 0 && this.lastTime > 0) return Date.now() + this.lastPosition - this.lastTime;
            var e = this._songlePlayer.positionTime;
            if ("songle-api-html-media-element-media" === (null === (t = this._songlePlayer.media) || void 0 === t ? void 0 : t.dispatcherName)) {
                var r = this.lastTime, n = this.lastPosition, i = void 0;
                if (r > 0) {
                    var o = Date.now() - r;
                    i = Math.max(0, this.wait - o);
                } else i = this.wait;
                0 === n && e >= 500 ? e = 0 : 0 === r && e - n >= 800 && (e = n + i);
            }
            return e;
        },
        enumerable: !1,
        configurable: !0
    }), t.prototype.initialize = function(t) {
        var e, r, n, i, o = t.player, s = t.updater, a = t.emitter, u = t.altSourceUrl;
        return $af62ec6a841e10b9$var$yn(this, 0, void 0, function() {
            var t, l, p;
            return $af62ec6a841e10b9$var$gn(this, function(h) {
                switch(h.label){
                    case 0:
                        return this.player && this.player.removeListener(this.volumeListener), this.player = o, this.player.addListener(this.volumeListener), this.updateMediaPosition = s, this.emitter = a, this._songlePlayer ? [
                            3,
                            2
                        ] : [
                            4,
                            this.initializeSonglePlayer()
                        ];
                    case 1:
                        h.sent(), h.label = 2;
                    case 2:
                        return t = this.options.headless, l = u || this.options.altSourceUrls && (null === (e = this.player.data.song) || void 0 === e ? void 0 : e.permalink) && this.options.altSourceUrls[null === (r = this.player.data.song) || void 0 === r ? void 0 : r.permalink] || (null === (n = this.player.data.song) || void 0 === n ? void 0 : n.permalink) || void 0, $af62ec6a841e10b9$var$c.isUploaderUrl(l) && (l = $af62ec6a841e10b9$var$c.getAltSongUrlFromUploaderGuid($af62ec6a841e10b9$var$c.getUploaderGuid($af62ec6a841e10b9$var$c.getSongPathFromUrl(l)))), (p = (null === (i = this.player.data.song) || void 0 === i ? void 0 : i.permalink) || l) === l && (l = void 0), [
                            4,
                            this._songlePlayer.useMedia(p, {
                                headless: t,
                                altSourceUrl: l
                            })
                        ];
                    case 3:
                        return h.sent(), this.ignoreSonglePlayerEvents = !0, this._songlePlayer.volume = 0 * (1 - this.player.volume / 100) + 100 * this.player.volume / 100, this._songlePlayer.play(), this._songlePlayer.stop(), this.ignoreSonglePlayerEvents = !1, this.resetProps(), [
                            2
                        ];
                }
            });
        });
    }, t.prototype.resetProps = function() {
        this.lastPosition = 0, this.lastTime = 0, this.elapsedTimes = [];
    }, t.prototype.initializeSonglePlayer = function() {
        var t;
        return $af62ec6a841e10b9$var$yn(this, 0, void 0, function() {
            var e, r, n, i, o, s, a, u = this;
            return $af62ec6a841e10b9$var$gn(this, function(c) {
                switch(c.label){
                    case 0:
                        return e = this.options, r = e.accessToken, n = e.secretToken, (o = this.options.songle) ? [
                            3,
                            2
                        ] : [
                            4,
                            $af62ec6a841e10b9$var$Pn()
                        ];
                    case 1:
                        o = c.sent(), c.label = 2;
                    case 2:
                        return (i = o).System && (i.System.showLicense = !1), s = null === (t = this.options) || void 0 === t ? void 0 : t.autoUseMedia, this._songlePlayer = this.withSync ? new i.SyncPlayer({
                            mediaElement: this.player.mediaSourceElement,
                            accessToken: r,
                            secretToken: n,
                            autoUseMedia: s
                        }) : new i.Player({
                            mediaElement: this.player.mediaSourceElement
                        }), a = !1, this._songlePlayer.on("play", function() {
                            u.ignoreSonglePlayerEvents || (a = !1, u.handler || (u.startPolling(), u.emitter.onPlay()));
                        }), this._songlePlayer.on("pause", function() {
                            return $af62ec6a841e10b9$var$yn(u, 0, void 0, function() {
                                return $af62ec6a841e10b9$var$gn(this, function(t) {
                                    switch(t.label){
                                        case 0:
                                            return this.ignoreSonglePlayerEvents ? [
                                                2
                                            ] : (a = !1, this.stopPolling(), this.emitter.onPause(), this.stopping ? (this.stopping = !1, [
                                                4,
                                                this.updateMediaPosition(0)
                                            ]) : [
                                                3,
                                                2
                                            ]);
                                        case 1:
                                            t.sent(), this.resetProps(), this.emitter.onStop(), t.label = 2;
                                        case 2:
                                            return [
                                                2
                                            ];
                                    }
                                });
                            });
                        }), this._songlePlayer.on("finish", function() {
                            return $af62ec6a841e10b9$var$yn(u, 0, void 0, function() {
                                return $af62ec6a841e10b9$var$gn(this, function(t) {
                                    switch(t.label){
                                        case 0:
                                            return a = !1, this.handler ? (this.stopPolling(), [
                                                4,
                                                this.updateMediaPosition(0)
                                            ]) : [
                                                3,
                                                2
                                            ];
                                        case 1:
                                            t.sent(), this.emitter.onStop(), t.label = 2;
                                        case 2:
                                            return [
                                                2
                                            ];
                                    }
                                });
                            });
                        }), this._songlePlayer.on("seek", function(t) {
                            var e = t.data;
                            return $af62ec6a841e10b9$var$yn(u, 0, void 0, function() {
                                return $af62ec6a841e10b9$var$gn(this, function(t) {
                                    switch(t.label){
                                        case 0:
                                            return this._songlePlayer.isPlaying ? [
                                                3,
                                                2
                                            ] : (a = !1, [
                                                4,
                                                this.updateMediaPosition(e.positionTime)
                                            ]);
                                        case 1:
                                            return t.sent(), this.emitter.onSeekComplete(e.positionTime), [
                                                3,
                                                4
                                            ];
                                        case 2:
                                            return a = !0, [
                                                4,
                                                this.updateMediaPosition(this._songlePlayer.positionTime)
                                            ];
                                        case 3:
                                            t.sent(), t.label = 4;
                                        case 4:
                                            return [
                                                2
                                            ];
                                    }
                                });
                            });
                        }), this._songlePlayer.on("mediaSeek", function() {
                            a && (u.emitter.onSeekComplete(u.position), a = !1);
                        }), this.withSync && (this._songlePlayer.on("mediaPlay", function() {
                            u.handler || (u.startPolling(), u.emitter.onPlay());
                        }), this._songlePlayer.on("mediaFinish", function() {
                            u.handler && (u.stopPolling(), u.emitter.onStop());
                        })), [
                            2
                        ];
                }
            });
        });
    }, t.prototype.play = function() {
        if (this._songlePlayer) return this._songlePlayer.play();
        this.emitter.onPlay();
    }, t.prototype.stop = function() {
        if (this._songlePlayer) return this.stopping = this._songlePlayer.isPlaying, this._songlePlayer.stop();
        this.emitter.onStop();
    }, t.prototype.pause = function() {
        if (this._songlePlayer) return this.stopping = !1, this._songlePlayer.pause();
        this.emitter.onPause();
    }, t.prototype.seek = function(t) {
        var e = this;
        this._songlePlayer ? (this._songlePlayer.seekTo(t), this.emitter.onSeek(t)) : this.updateMediaPosition(t).then(function() {
            e.emitter.onSeek(t);
        });
    }, t.prototype.startPolling = function() {
        var t, e = this;
        if (this.lastTime > 0) {
            var r = Date.now() - this.lastTime;
            t = Math.max(0, this.wait - r);
        } else t = this.wait;
        this.handler = setTimeout(function() {
            return $af62ec6a841e10b9$var$yn(e, 0, void 0, function() {
                var e, r, n, i, o, s, a, u, c;
                return $af62ec6a841e10b9$var$gn(this, function(l) {
                    switch(l.label){
                        case 0:
                            return this._songlePlayer ? (r = (e = this).lastTime, n = e.lastPosition, i = this._songlePlayer.positionTime, o = !1, "songle-api-html-media-element-media" === (null === (c = this._songlePlayer.media) || void 0 === c ? void 0 : c.dispatcherName) && (0 === n && i >= 500 ? (i = 0, o = !0) : 0 === r && i - n >= 800 && (i = n + t, o = !0)), s = r > 0 ? Date.now() - r : t, this.updateElapsedTimes(s), a = n > 0 ? n + s : i, u = Math.abs(i - a), (a = u > 2 * this.wait ? i : a <= i ? .5 * (a + i) : Math.max(n, i)) < this.lastPosition && (this.lastPosition - a > 5 * this.wait || (a = this.lastPosition)), o || (this.lastTime = Date.now()), this.lastPosition = a, [
                                4,
                                this.updateMediaPosition(a)
                            ]) : [
                                2
                            ];
                        case 1:
                            return l.sent(), this.handler && this.startPolling(), [
                                2
                            ];
                    }
                });
            });
        }, t);
    }, t.prototype.updateElapsedTimes = function(t) {
        if (this.elapsedTimes.unshift(t), this.elapsedTimes = this.elapsedTimes.slice(0, 10), this.elapsedTimes.length >= 10) {
            var e = this.elapsedTimes.reduce(function(t, e) {
                return t + e;
            }) / 10;
            e > 5 * this.wait && (this.player.stageScale = Math.max(.25, .9 * this.player.stageScale), this.elapsedTimes = []), e < 1.2 * this.wait && this.player.stageScale < 1 && (this.player.stageScale = Math.min(1, this.player.stageScale / .9), this.elapsedTimes = []);
        }
    }, t.prototype.stopPolling = function() {
        var t;
        if (this.handler) {
            if (clearTimeout(this.handler), this._songlePlayer) {
                if ("songle-api-html-media-element-media" === (null === (t = this._songlePlayer.media) || void 0 === t ? void 0 : t.dispatcherName)) {
                    var e = this.lastTime, r = this.lastPosition, n = Date.now() - e;
                    this.lastPosition = r + n;
                } else this.lastPosition = this._songlePlayer.positionTime;
            }
            this.lastTime = 0;
        }
        this.handler = null;
    }, t.prototype.dispose = function() {
        if (this.player && this.player.removeListener(this.volumeListener), this._songlePlayer) {
            try {
                this._songlePlayer.stop();
            } catch (t) {}
            this._songlePlayer = null;
        }
    }, t.prototype.onVolumeUpdate = function(t) {
        this._songlePlayer && (this._songlePlayer.volume = t);
    }, t;
}(), $af62ec6a841e10b9$var$On = function() {
    function t(t) {
        this.listeners = [], this.throttleInterval = t && t.throttleInterval ? Number(t.throttleInterval) : 100;
    }
    return t.prototype.onVideoLoad = function(t, e) {
        this.listeners.forEach(function(r) {
            return r.onVideoLoad && r.onVideoLoad(t, e);
        });
    }, t.prototype.onSongLoad = function(t, e) {
        this.listeners.forEach(function(r) {
            return r.onSongLoad && r.onSongLoad(t, e);
        });
    }, t.prototype.onSongMapLoad = function(t, e) {
        this.listeners.forEach(function(r) {
            return r.onSongMapLoad && r.onSongMapLoad(t, e);
        });
    }, t.prototype.onSongInfoLoad = function(t, e) {
        var r = !1;
        this.listeners.forEach(function(n) {
            n.onSongInfoLoad && (n.onSongInfoLoad(t, e), r = !0);
        }), r && console.warn('[TextAlive API] "onSongInfoLoad" event is deprecated; use "onSongMapLoad" event instead');
    }, t.prototype.onVocalAmplitudeLoad = function(t, e) {
        this.listeners.forEach(function(r) {
            return r.onVocalAmplitudeLoad && r.onVocalAmplitudeLoad(t, e);
        });
    }, t.prototype.onValenceArousalLoad = function(t, e) {
        this.listeners.forEach(function(r) {
            return r.onValenceArousalLoad && r.onValenceArousalLoad(t, e);
        });
    }, t.prototype.onLyricsLoad = function(t, e) {
        this.listeners.forEach(function(r) {
            return r.onLyricsLoad && r.onLyricsLoad(t, e);
        });
    }, t.prototype.onTextLoad = function(t, e) {
        this.listeners.forEach(function(r) {
            return r.onTextLoad && r.onTextLoad(t, e);
        });
    }, t.prototype.onAppLoad = function(t) {
        this.listeners.forEach(function(e) {
            return e.onAppLoad && e.onAppLoad(t);
        });
    }, t.prototype.onAppReady = function(t) {
        this.listeners.forEach(function(e) {
            return e.onAppReady && e.onAppReady(t);
        });
    }, t.prototype.onAppParameterUpdate = function(t, e) {
        this.listeners.forEach(function(r) {
            return r.onAppParameterUpdate && r.onAppParameterUpdate(t, e);
        });
    }, t.prototype.onAppMediaChange = function(t, e) {
        this.listeners.forEach(function(r) {
            return r.onAppMediaChange && r.onAppMediaChange(t, e);
        });
    }, t.prototype.onTemplateUpdate = function(t) {
        this.listeners.forEach(function(e) {
            return e.onTemplateUpdate && e.onTemplateUpdate(t);
        });
    }, t.prototype.onTemplateCommit = function(t) {
        this.listeners.forEach(function(e) {
            return e.onTemplateCommit && e.onTemplateCommit(t);
        });
    }, t.prototype.onTemplatesLoad = function(t, e) {
        this.listeners.forEach(function(r) {
            return r.onTemplatesLoad && r.onTemplatesLoad(t, e);
        });
    }, t.prototype.onFontsLoad = function(t, e) {
        this.listeners.forEach(function(r) {
            return r.onFontsLoad && r.onFontsLoad(t, e);
        });
    }, t.prototype.onVideoReady = function(t) {
        this.listeners.forEach(function(e) {
            return e.onVideoReady && e.onVideoReady(t);
        });
    }, t.prototype.onTimerReady = function(t) {
        this.listeners.forEach(function(e) {
            return e.onTimerReady && e.onTimerReady(t);
        });
    }, t.prototype.onStageElementSet = function(t) {
        this.listeners.forEach(function(e) {
            return e.onStageElementSet && e.onStageElementSet(t);
        });
    }, t.prototype.onMediaElementSet = function(t) {
        this.listeners.forEach(function(e) {
            return e.onMediaElementSet && e.onMediaElementSet(t);
        });
    }, t.prototype.onTimeUpdate = function(t) {
        var e = this;
        this.listeners.forEach(function(e) {
            return e.onTimeUpdate && e.onTimeUpdate(t);
        }), this.position = t, this.throttledTimeUpdate || (this.throttledTimeUpdate = new Promise(function(t, r) {
            setTimeout(function() {
                e.onThrottledTimeUpdate(e.position), e.throttledTimeUpdate = null, t();
            }, e.throttleInterval);
        }));
    }, t.prototype.onThrottledTimeUpdate = function(t) {
        this.listeners.forEach(function(e) {
            return e.onThrottledTimeUpdate && e.onThrottledTimeUpdate(t);
        });
    }, t.prototype.onBackgroundGraphicsUpdate = function(t) {
        this.listeners.forEach(function(e) {
            return e.onBackgroundGraphicsUpdate && e.onBackgroundGraphicsUpdate(t);
        });
    }, t.prototype.onMediaSeek = function(t) {
        this.listeners.forEach(function(e) {
            return e.onMediaSeek && e.onMediaSeek(t);
        });
    }, t.prototype.onVideoSeekStart = function() {
        this.listeners.forEach(function(t) {
            return t.onVideoSeekStart && t.onVideoSeekStart();
        });
    }, t.prototype.onVideoSeekEnd = function() {
        this.listeners.forEach(function(t) {
            return t.onVideoSeekEnd && t.onVideoSeekEnd();
        });
    }, t.prototype.onVideoSeek = function(t) {
        this.listeners.forEach(function(e) {
            return e.onVideoSeek && e.onVideoSeek(t);
        });
    }, t.prototype.onPlay = function() {
        this.listeners.forEach(function(t) {
            return t.onPlay && t.onPlay();
        });
    }, t.prototype.onPause = function() {
        this.listeners.forEach(function(t) {
            return t.onPause && t.onPause();
        });
    }, t.prototype.onSeek = function(t) {
        this.listeners.forEach(function(e) {
            return e.onSeek && e.onSeek(t);
        });
    }, t.prototype.onSeekComplete = function(t) {
        this.listeners.forEach(function(e) {
            return e.onSeekComplete && e.onSeekComplete(t);
        });
    }, t.prototype.onStop = function() {
        this.listeners.forEach(function(t) {
            return t.onStop && t.onStop();
        });
    }, t.prototype.onDispose = function() {
        this.listeners.forEach(function(t) {
            return t.onDispose && t.onDispose();
        });
    }, t.prototype.onResize = function(t) {
        this.listeners.forEach(function(e) {
            return e.onResize && e.onResize(t);
        });
    }, t.prototype.onVolumeUpdate = function(t) {
        this.listeners.forEach(function(e) {
            return e.onVolumeUpdate && e.onVolumeUpdate(t);
        });
    }, t.prototype.addListener = function(t) {
        !t || this.listeners.indexOf(t) >= 0 || this.listeners.push(t);
    }, t.prototype.removeListener = function(t) {
        var e = !1;
        return this.listeners = this.listeners.filter(function(r) {
            var n = r === t;
            return e = e || n, !n;
        }), e;
    }, t;
}(), $af62ec6a841e10b9$var$Sn = function() {
    function t(t, e, r) {
        var n = this;
        this.player = t, this.manager = e, this.emitter = r, this._defaultBackgroundCss = null, this._background = null, t.addListener({
            onStageElementSet: function(t) {
                return n.doUpdateBackground(n.background);
            }
        });
    }
    return Object.defineProperty(t.prototype, "background", {
        get: function() {
            return this._background;
        },
        enumerable: !1,
        configurable: !0
    }), Object.defineProperty(t.prototype, "defaultBackgroundCss", {
        get: function() {
            return this._defaultBackgroundCss ? this._defaultBackgroundCss : "";
        },
        set: function(t) {
            this._defaultBackgroundCss = t, this.updateBackground(this._background);
        },
        enumerable: !1,
        configurable: !0
    }), Object.defineProperty(t.prototype, "ready", {
        get: function() {
            return null !== this._background;
        },
        enumerable: !1,
        configurable: !0
    }), t.prototype.settingBackground = function(t) {
        return $af62ec6a841e10b9$var$yn(this, 0, void 0, function() {
            return $af62ec6a841e10b9$var$gn(this, function(e) {
                switch(e.label){
                    case 0:
                        return [
                            4,
                            this.doSetBackground(t)
                        ];
                    case 1:
                        return [
                            2,
                            e.sent() && this.doUpdateBackground(t)
                        ];
                }
            });
        });
    }, t.prototype.setBackground = function(t) {
        return $af62ec6a841e10b9$var$yn(this, 0, void 0, function() {
            var e;
            return $af62ec6a841e10b9$var$gn(this, function(r) {
                switch(r.label){
                    case 0:
                        return [
                            4,
                            this.doSetBackground(t)
                        ];
                    case 1:
                        return [
                            2,
                            (e = r.sent()) && this.updateBackground(e)
                        ];
                }
            });
        });
    }, t.prototype.doSetBackground = function(t) {
        return $af62ec6a841e10b9$var$yn(this, 0, void 0, function() {
            var e, r, n;
            return $af62ec6a841e10b9$var$gn(this, function(i) {
                switch(i.label){
                    case 0:
                        return e = t && t.originalUrl ? t.originalUrl : "", this.manager.isBackgroundColorAsset(t) ? [
                            2,
                            {
                                css: e,
                                originalUrl: e
                            }
                        ] : this.manager.isBackgroundPiaproImageAsset(t) ? [
                            4,
                            this.manager.read(e)
                        ] : [
                            3,
                            2
                        ];
                    case 1:
                        return (r = i.sent()) && r.url && this.manager.checkBackgroundImageLicense(r.license) ? (r.originalUrl = e, t && (r.x = t.x, r.y = t.y), [
                            2,
                            r
                        ]) : [
                            2,
                            {
                                css: "",
                                originalUrl: e,
                                x: t ? t.x : void 0,
                                y: t ? t.y : void 0,
                                license: r ? r.license : void 0
                            }
                        ];
                    case 2:
                        return this.manager.isBackgroundSpecialImageAsset(t) ? [
                            2,
                            {
                                css: 'url("https://api.textalive.jp/images/backgrounds/snowmiku2016/' + (n = /^snowmiku2016-([0-9]{2})$/.exec(e))[1] + '.jpg")',
                                contentUrl: "https://api.textalive.jp/images/backgrounds/snowmiku2016/" + n[1] + ".jpg",
                                url: "https://snowmiku.com/2016/info_chara.html",
                                name: "SNOW MIKU 2016",
                                authorName: "\u8C46\u306E\u7D20",
                                originalUrl: e,
                                x: t ? t.x : void 0,
                                y: t ? t.y : void 0,
                                defaultY: 0
                            }
                        ] : [
                            2,
                            {
                                originalUrl: null,
                                css: "",
                                x: t ? t.x : void 0,
                                y: t ? t.y : void 0
                            }
                        ];
                }
            });
        });
    }, t.prototype.updateBackground = function(t) {
        return !!this.doUpdateBackground(t) && (this.emitter && this.emitter.onBackgroundGraphicsUpdate && this.emitter.onBackgroundGraphicsUpdate(t), !0);
    }, t.prototype.doUpdateBackground = function(t) {
        if (!t) return !1;
        if (!this.player.stageElement) return this._background = t, !0;
        var e = this.player.stageElement.style;
        return t.css.length <= 0 ? e.background = this.defaultBackgroundCss : e.background = t.css, "number" == typeof t.x || this._background && "number" == typeof this._background.x ? ("number" != typeof t.x && (t.x = this._background.x), e.backgroundPositionX = e.backgroundPositionX + "%") : e.backgroundPositionX = "number" == typeof t.defaultX ? t.defaultX + "%" : "center", "number" == typeof t.y || this._background && "number" == typeof this._background.y ? ("number" != typeof t.y && (t.y = this._background.y), e.backgroundPositionY = e.backgroundPositionY + "%") : e.backgroundPositionY = "number" == typeof t.defaultY ? t.defaultY + "%" : "center", e.backgroundSize = "cover", this._background = t, !0;
    }, t.prototype.export = function() {
        if (!this.background || !this.background.originalUrl) return null;
        var t = {
            originalUrl: this.background.originalUrl
        };
        return void 0 !== this.background.x && (t.x = this.background.x), void 0 !== this.background.y && (t.y = this.background.y), t;
    }, t.prototype.exportPartialVideoEntry = function(t) {
        return {
            background: this.export()
        };
    }, t;
}();

function $af62ec6a841e10b9$var$Tn(t, e, r) {
    return $af62ec6a841e10b9$var$yn(this, 0, void 0, function() {
        var n, i, o, s, a, u, c, l, p, h, d, f, y, g;
        return $af62ec6a841e10b9$var$gn(this, function(v) {
            switch(v.label){
                case 0:
                    if (n = {
                        loaded: [],
                        failed: []
                    }, "undefined" == typeof window || !window.document || !window.document.head) return n.failed = t.slice(), [
                        2,
                        n
                    ];
                    for(i = r.split("").filter(function(t, e, r) {
                        return r.indexOf(t) === e;
                    }).sort(), o = !0, s = 0, i.forEach(function(t) {
                        var r = e.indexOf(t, s);
                        o = o && r >= 0, s = r;
                    }), a = window.document.head, u = [], c = 0; c < a.children.length; c++)"link" === (l = a.children.item(c)).tagName.toLowerCase() && "stylesheet" === l.getAttribute("rel") && u.push(l.getAttribute("href"));
                    if (p = [], h = [], d = [], t.forEach(function(t) {
                        if (t.google) d.push(t.key);
                        else {
                            var e = o && t.compactUrl || t.url;
                            u.includes(e) ? n.loaded.push(t) : (h.push(t.en), p.push(e));
                        }
                    }), f = {
                        classes: !1,
                        active: null,
                        inactive: null,
                        fontactive: function(e) {
                            n.loaded.push(t.find(function(t) {
                                return t.en === e;
                            })), n.failed = n.failed.filter(function(t) {
                                return t.en !== e;
                            });
                        },
                        fontinactive: function(e) {
                            n.failed.push(t.find(function(t) {
                                return t.en === e;
                            }));
                        },
                        timeout: 5e3
                    }, d.length > 0 && (f.google = {
                        families: d
                    }), h.length > 0 && (f.custom = {
                        families: h,
                        urls: p
                    }), !f.google && !f.custom) return [
                        3,
                        6
                    ];
                    v.label = 1;
                case 1:
                    return v.trys.push([
                        1,
                        5,
                        ,
                        6
                    ]), (g = "undefined" != typeof window && (null === window || void 0 === window ? void 0 : window.WebFont)) ? [
                        3,
                        3
                    ] : [
                        4,
                        (parcelRequire("4RZ4E"))
                    ];
                case 2:
                    g = v.sent(), v.label = 3;
                case 3:
                    return y = g, [
                        4,
                        new Promise(function(t) {
                            f.active = f.inactive = t, y.load(f);
                        })
                    ];
                case 4:
                case 5:
                    return v.sent(), [
                        3,
                        6
                    ];
                case 6:
                    return [
                        2,
                        n
                    ];
            }
        });
    });
}
function $af62ec6a841e10b9$var$xn(t, e) {
    return $af62ec6a841e10b9$var$yn(this, 0, void 0, function() {
        var r, n, i, o, s, a, u;
        return $af62ec6a841e10b9$var$gn(this, function(c) {
            switch(c.label){
                case 0:
                    if (r = {
                        loaded: [],
                        failed: []
                    }, !("undefined" != typeof window && window.document && window.document.head && window.Ts && window.Ts.loadFontAsync)) return r.failed = t.slice(), [
                        2,
                        r
                    ];
                    for(n = window.document.head, i = {}, o = function(t) {
                        var e = n.children.item(t);
                        if ("style" !== e.tagName.toLowerCase() || "text/css" !== e.getAttribute("type") || "stylesheet" !== e.getAttribute("rel") || !e.hasAttribute("data-cssName")) return "continue";
                        var r = e.getAttribute("data-cssName");
                        if (void 0 === i[r]) return i[r] = new Set(e.getAttribute("data-text")), "continue";
                        e.getAttribute("data-text").split("").forEach(function(t) {
                            return i[r].add(t);
                        });
                    }, s = 0; s < n.children.length; s++)o(s);
                    return a = window.Ts, u = [], t.forEach(function(t) {
                        var n = new Set(e + t.en + t.ja);
                        if (i[t.en] && i[t.en].forEach(function(t) {
                            return n.delete(t);
                        }), n.size <= 0) return r.loaded.push(t), r;
                        u.push(new Promise(function(e) {
                            return function(t, e, r, n, i) {
                                var o = e.en;
                                t.loadFontAsync({
                                    cssName: o,
                                    text: n,
                                    outputType: "json",
                                    callback: function(t) {
                                        try {
                                            !function(t, e, r) {
                                                var n = JSON.parse(r), i = JSON.parse(n.res), o = document.createElement("style");
                                                o.setAttribute("data-cssName", t), o.setAttribute("data-text", e), o.setAttribute("type", "text/css"), o.setAttribute("rel", "stylesheet"), o.innerHTML = "@font-face {font-family: '" + i.fontFamily + "';font-weight: " + i["font-weight"] + ";src: url(data:font/woff;base64," + i.src + ");}", document.head.appendChild(o);
                                            }(o, n, t.data), r.loaded.push(e);
                                        } catch (t) {
                                            r.failed.push(e);
                                        }
                                        i();
                                    }
                                });
                            }(a, t, r, Array.from(n.values()).join(""), e);
                        }));
                    }), [
                        4,
                        Promise.all(u)
                    ];
                case 1:
                    return c.sent(), [
                        2,
                        r
                    ];
            }
        });
    });
}
var $af62ec6a841e10b9$var$An = function(t) {
    function e(e, r) {
        var n = this.constructor, i = t.call(this, e) || this;
        return i.fonts = r, Object.setPrototypeOf(i, n.prototype), i;
    }
    return $af62ec6a841e10b9$var$dn(e, t), e;
}(Error), $af62ec6a841e10b9$var$Rn = function() {
    function t(t, e, r) {
        this.fontInfoManager = t, this.textFetcher = e, this.listener = r, this._failed = [], this._loaded = [];
    }
    return Object.defineProperty(t.prototype, "failed", {
        get: function() {
            return this._failed;
        },
        enumerable: !1,
        configurable: !0
    }), Object.defineProperty(t.prototype, "loaded", {
        get: function() {
            return this._loaded;
        },
        enumerable: !1,
        configurable: !0
    }), t.prototype.loadAll = function() {
        return $af62ec6a841e10b9$var$yn(this, 0, void 0, function() {
            var t;
            return $af62ec6a841e10b9$var$gn(this, function(e) {
                switch(e.label){
                    case 0:
                        return [
                            4,
                            this.listAvailableFonts()
                        ];
                    case 1:
                        return t = e.sent(), [
                            2,
                            this.loadFonts(t)
                        ];
                }
            });
        });
    }, t.prototype.loadForVideo = function(t) {
        return $af62ec6a841e10b9$var$yn(this, 0, void 0, function() {
            var e, r;
            return $af62ec6a841e10b9$var$gn(this, function(n) {
                switch(n.label){
                    case 0:
                        return (e = this.listFontFamiliesInVideo(t)) ? [
                            4,
                            this.listAvailableFonts()
                        ] : (this.listener && this.listener.onFontsLoad && this.listener.onFontsLoad(this.loaded), [
                            2,
                            Promise.resolve(this.loaded)
                        ]);
                    case 1:
                        return r = n.sent(), [
                            2,
                            this.loadFonts(r.filter(function(t) {
                                return e.indexOf(t.en) >= 0;
                            }))
                        ];
                }
            });
        });
    }, t.prototype.listFontFamiliesInVideo = function(t) {
        if (!t || !t.phrases) return null;
        var e = [];
        return t.phrases.forEach(function(t) {
            return t.words.forEach(function(t) {
                return t.characters.forEach(function(t) {
                    return e.push(t.fontFamily);
                });
            });
        }), e.filter(function(t, e, r) {
            return r.indexOf(t) === e;
        });
    }, t.prototype.listAvailableFonts = function() {
        return $af62ec6a841e10b9$var$yn(this, 0, void 0, function() {
            return $af62ec6a841e10b9$var$gn(this, function(t) {
                return [
                    2,
                    this.fontInfoManager.listAvailableFonts()
                ];
            });
        });
    }, t.prototype.isLoading = function() {
        return !!this.queue;
    }, t.prototype.load = function(t) {
        return $af62ec6a841e10b9$var$yn(this, 0, void 0, function() {
            var e, r;
            return $af62ec6a841e10b9$var$gn(this, function(n) {
                switch(n.label){
                    case 0:
                        return e = [], r = [], t.forEach(function(t) {
                            "string" == typeof t ? e.push(t) : r.push(t);
                        }), [
                            4,
                            this.fontInfoManager.listAvailableFonts()
                        ];
                    case 1:
                        return n.sent().forEach(function(t) {
                            e.indexOf(t.key) >= 0 && r.push(t);
                        }), [
                            2,
                            this.loadFonts(r)
                        ];
                }
            });
        });
    }, t.prototype.loadFonts = function(t) {
        return $af62ec6a841e10b9$var$yn(this, 0, void 0, function() {
            var e = this;
            return $af62ec6a841e10b9$var$gn(this, function(r) {
                return this.queue ? (this.listener && this.listener.onFontsLoad && this.listener.onFontsLoad(null, new $af62ec6a841e10b9$var$An("Failed to load some fonts because there is an ongoing font loding process", this.failed.slice())), [
                    2,
                    this.loaded
                ]) : (this.queue = this.doLoad(t).then(function(t) {
                    return e.queue = null, t;
                }), [
                    2,
                    this.queue
                ]);
            });
        });
    }, t.prototype.doLoad = function(t) {
        return $af62ec6a841e10b9$var$yn(this, 0, void 0, function() {
            var e, r, n, i, o = this;
            return $af62ec6a841e10b9$var$gn(this, function(s) {
                switch(s.label){
                    case 0:
                        return e = [], r = [], [
                            4,
                            this.fontInfoManager.getFrequentChars()
                        ];
                    case 1:
                        return n = s.sent(), t.forEach(function(t) {
                            t.typesquare || t.typekit || e.push(t), t.typesquare && r.push(t);
                        }), i = (this.textFetcher && this.textFetcher() || "").split("").filter(function(t, e, r) {
                            return r.indexOf(t) === e;
                        }).sort().join(""), [
                            2,
                            Promise.all([
                                $af62ec6a841e10b9$var$Tn(e, n, i),
                                $af62ec6a841e10b9$var$xn(r, i)
                            ]).then(function(t) {
                                var e = t[0], r = t[1], n = e.loaded.concat(r.loaded);
                                if (o.addLoadedFonts(n), e.failed.length > 0 || r.failed.length > 0) {
                                    var i = e.failed.concat(r.failed);
                                    o.addFailedFonts(i), o.listener && o.listener.onFontsLoad && o.listener.onFontsLoad(null, new $af62ec6a841e10b9$var$An("Failed to load some fonts", o.failed.slice()));
                                } else o.listener && o.listener.onFontsLoad && o.listener.onFontsLoad(n);
                                return o.loaded;
                            }).catch(function(t) {
                                return o.listener && o.listener.onFontsLoad && o.listener.onFontsLoad(null, new $af62ec6a841e10b9$var$An(t, o.failed.slice())), o.loaded;
                            })
                        ];
                }
            });
        });
    }, t.prototype.addLoadedFonts = function(t) {
        var e = this;
        this._loaded = this.loaded.concat(t.filter(function(t) {
            return e.failed.findIndex(function(e) {
                return e.key === t.key;
            }) < 0;
        }));
    }, t.prototype.addFailedFonts = function(t) {
        var e = this;
        this._failed = this.failed.concat(t.filter(function(t) {
            return e.failed.findIndex(function(e) {
                return e.key === t.key;
            }) < 0;
        }));
    }, t;
}(), $af62ec6a841e10b9$var$Cn = function() {
    function t() {}
    return Object.defineProperty(t.prototype, "duration", {
        get: function() {
            return this.endTime - this.startTime;
        },
        enumerable: !1,
        configurable: !0
    }), t.prototype.contains = function(t) {
        return t >= this.startTime && t <= this.endTime;
    }, t.prototype.overlaps = function(t, e) {
        if ("object" == typeof t) return this.overlaps(t.startTime, t.endTime);
        var r = t;
        return this.contains(r) || this.contains(e) || this.startTime <= r && this.endTime >= e;
    }, t.prototype.progress = function(t) {
        return this.contains(t) ? this.startTime === this.endTime ? 0 : (t - this.startTime) / (this.endTime - this.startTime) : -1;
    }, t;
}(), $af62ec6a841e10b9$var$Nn = function(t) {
    function e() {
        var e = t.call(this) || this;
        return e.previous = e.next = null, e;
    }
    return $af62ec6a841e10b9$var$dn(e, t), Object.defineProperty(e.prototype, "endTime", {
        get: function() {
            return this.next ? this.next.startTime : this.startTime;
        },
        enumerable: !1,
        configurable: !0
    }), e;
}($af62ec6a841e10b9$var$Cn), $af62ec6a841e10b9$var$kn = function(t) {
    function e() {
        var e = t.call(this) || this;
        return e.previous = e.next = null, e;
    }
    return $af62ec6a841e10b9$var$dn(e, t), e;
}($af62ec6a841e10b9$var$Cn), $af62ec6a841e10b9$var$jn = function(t) {
    function e() {
        var e = t.call(this) || this;
        return e.previous = e.next = null, e;
    }
    return $af62ec6a841e10b9$var$dn(e, t), e;
}($af62ec6a841e10b9$var$Cn), $af62ec6a841e10b9$var$In = function(t) {
    function e() {
        var e = t.call(this) || this;
        return e.previous = e.next = null, e;
    }
    return $af62ec6a841e10b9$var$dn(e, t), e;
}($af62ec6a841e10b9$var$Cn), $af62ec6a841e10b9$var$Un = function() {
    function t(t) {
        var e = t.analysis, r = t.info;
        this.beats = [], this.chords = [], this.segments = [], this.voice = [], this._revisions = {
            beatId: (null == r ? void 0 : r.beatRevisionId) || -1,
            chordId: (null == r ? void 0 : r.chordRevisionId) || -1,
            repetitiveSegmentId: (null == r ? void 0 : r.chorusRevisionId) || -1
        }, this.parseBeats(null == e ? void 0 : e.beats), this.parseSegments(null == e ? void 0 : e.repetitive_segment), this.parseChords(null == e ? void 0 : e.chords), this.parseVoice(e.voice);
    }
    return Object.defineProperty(t.prototype, "revisions", {
        get: function() {
            return this._revisions;
        },
        enumerable: !1,
        configurable: !0
    }), t.prototype.parseBeats = function(t) {
        var e = this;
        if (this.beats.splice(0, this.beats.length), Array.isArray(t) && Array.isArray(t[0])) {
            var r = null, n = 0;
            t[0].forEach(function(t) {
                var i = new $af62ec6a841e10b9$var$Nn;
                i.startTime = 1e3 * t[0], i.length = t[2], i.position = t[3], i.previous = r, null !== r && (r.next = i), i.index = n++, e.beats.push(i), r = i;
            }), null !== r && (r.next = null);
        }
    }, t.prototype.parseChords = function(t) {
        var e = this;
        if (this.chords.splice(0, this.chords.length), Array.isArray(t)) {
            var r = null, n = 0;
            t.forEach(function(t) {
                var i = new $af62ec6a841e10b9$var$kn;
                i.startTime = 1e3 * t[0], i.endTime = 1e3 * t[1], i.name = t[2], i.previous = r, null !== r && (r.next = i), i.index = n++, e.chords.push(i), r = i;
            }), null !== r && (r.next = null);
        }
    }, t.prototype.parseSegments = function(t) {
        var e = this;
        this.segments.splice(0, this.segments.length), Array.isArray(t) && t.forEach(function(t) {
            var r = {
                chorus: !!t.chorus,
                duration: 10 * t.segment_length,
                segments: null
            }, n = null, i = 0;
            r.segments = t.start_frames.map(function(t) {
                var e = new $af62ec6a841e10b9$var$jn;
                return e.startTime = 10 * t, e.endTime = e.startTime + r.duration, e.previous = n, null !== n && (n.next = e), e.index = i++, n = e, e;
            }), null !== n && (n.next = null), e.segments.push(r);
        });
    }, t.prototype.parseVoice = function(t) {
        var e = this;
        this.voice.splice(0, this.voice.length), Array.isArray(t) && t.forEach(function(t) {
            var r = [], n = null, i = 0, o = 0;
            t.forEach(function(t) {
                var e = new $af62ec6a841e10b9$var$In;
                e.startTime = o, e.endTime = e.startTime + 10 * t[1], e.f0 = t[0][0], e.initialF0 = t[0][1], e.previous = n, null !== n && (n.next = e), e.index = i++, r.push(e), n = e, o = e.endTime;
            }), null !== n && (n.next = null), e.voice.push(r);
        });
    }, t;
}(), $af62ec6a841e10b9$var$Fn = function() {
    function t(t) {
        var e = t.song, r = t.analysis, n = t.vocalAmplitude, i = t.maxVocalAmplitude, o = t.valenceArousal;
        this._song = e, this._analysis = r, this._vocalAmplitude = n, this._maxVocalAmplitude = i, this._valenceArousal = o;
    }
    return Object.defineProperty(t.prototype, "song", {
        get: function() {
            return this._song;
        },
        enumerable: !1,
        configurable: !0
    }), Object.defineProperty(t.prototype, "analysis", {
        get: function() {
            return this._analysis;
        },
        enumerable: !1,
        configurable: !0
    }), Object.defineProperty(t.prototype, "vocalAmplitude", {
        get: function() {
            return this._vocalAmplitude;
        },
        enumerable: !1,
        configurable: !0
    }), Object.defineProperty(t.prototype, "maxVocalAmplitude", {
        get: function() {
            return this._maxVocalAmplitude;
        },
        enumerable: !1,
        configurable: !0
    }), Object.defineProperty(t.prototype, "valenceArousal", {
        get: function() {
            return this._valenceArousal;
        },
        enumerable: !1,
        configurable: !0
    }), t.prototype.getChoruses = function() {
        var t;
        if (!this._analysis) return [];
        var e = this._analysis.segments.filter(function(t) {
            return t.chorus;
        });
        return e.length <= 0 ? [] : (null === (t = e[0].segments) || void 0 === t ? void 0 : t.slice()) || [];
    }, t.prototype.findChorus = function(t, e) {
        return $af62ec6a841e10b9$export$9bae06dfae5441df(this.getChoruses(), t, e);
    }, t.prototype.findChorusBetween = function(t, e) {
        return this.findChorus(t, {
            endTime: e
        });
    }, t.prototype.findChorusChange = function(t, e) {
        return $af62ec6a841e10b9$export$212614cfc0556d1e(this.getChoruses(), t, e);
    }, t.prototype.getBeats = function() {
        var t, e;
        return (null === (e = null === (t = this._analysis) || void 0 === t ? void 0 : t.beats) || void 0 === e ? void 0 : e.slice()) || [];
    }, t.prototype.findBeat = function(t, e) {
        return $af62ec6a841e10b9$export$9bae06dfae5441df(this.getBeats(), t, e);
    }, t.prototype.findBeatChange = function(t, e) {
        return $af62ec6a841e10b9$export$212614cfc0556d1e(this.getBeats(), t, e);
    }, t.prototype.getChords = function() {
        var t, e;
        return (null === (e = null === (t = this._analysis) || void 0 === t ? void 0 : t.chords) || void 0 === e ? void 0 : e.slice()) || [];
    }, t.prototype.findChord = function(t, e) {
        return $af62ec6a841e10b9$export$9bae06dfae5441df(this.getChords(), t, e);
    }, t.prototype.findChordChange = function(t, e) {
        return $af62ec6a841e10b9$export$212614cfc0556d1e(this.getChords(), t, e);
    }, t.prototype.getVocalFrequency = function(t) {
        var e;
        if (!Array.isArray(null === (e = this._analysis) || void 0 === e ? void 0 : e.voice)) return -1;
        var n = this._analysis.voice[0];
        if (n.length <= 0) return -1;
        var i = $af62ec6a841e10b9$var$r.sortedIndex(n, t, function(t) {
            return t.endTime;
        });
        return n[i].contains(t) ? n[i].f0 : -1;
    }, t.prototype.getVocalAmplitude = function(t) {
        var e = this._vocalAmplitude, r = Math.round(t / 10);
        return !Array.isArray(this._vocalAmplitude) || r < 0 || r >= e.length ? -1 : this._vocalAmplitude[r];
    }, t.prototype.getMaxVocalAmplitude = function() {
        return "number" == typeof this._maxVocalAmplitude ? this._maxVocalAmplitude : -1;
    }, t.prototype.getValenceArousal = function(t) {
        var e = this._valenceArousal;
        if (!e) return null;
        var n = $af62ec6a841e10b9$var$r.sortedIndex(e.seq, t, function(t) {
            return 1e3 * t.t[1];
        });
        if (n < 0) return {
            a: e.seq[0].a,
            v: e.seq[0].v
        };
        if (n + 1 >= e.seq.length || t < 1e3 * e.seq[n + 1].t[0]) return {
            a: e.seq[Math.min(n, e.seq.length - 1)].a,
            v: e.seq[Math.min(n, e.seq.length - 1)].v
        };
        var i = e.seq[n], o = e.seq[n + 1], s = t / 1e3, a = o.t[0], u = i.t[1], c = u - a;
        return {
            a: (i.a * (u - s) + o.a * (s - a)) / c,
            v: (i.v * (u - s) + o.v * (s - a)) / c
        };
    }, t.prototype.getMedianValenceArousal = function() {
        var t = this._valenceArousal;
        return t ? t.stats.median : null;
    }, t;
}(), $af62ec6a841e10b9$var$Ln = function() {
    function t(t, e, r) {
        this.songManager = t, this.options = r, this.listener = e;
    }
    return Object.defineProperty(t.prototype, "song", {
        get: function() {
            return this._song;
        },
        enumerable: !1,
        configurable: !0
    }), Object.defineProperty(t.prototype, "analysis", {
        get: function() {
            return this._analysis;
        },
        enumerable: !1,
        configurable: !0
    }), Object.defineProperty(t.prototype, "vocalAmplitude", {
        get: function() {
            return this._vocalAmplitude;
        },
        enumerable: !1,
        configurable: !0
    }), Object.defineProperty(t.prototype, "maxVocalAmplitude", {
        get: function() {
            return this._maxVocalAmplitude;
        },
        enumerable: !1,
        configurable: !0
    }), Object.defineProperty(t.prototype, "valenceArousal", {
        get: function() {
            return this._valenceArousal;
        },
        enumerable: !1,
        configurable: !0
    }), t.prototype.loadSong = function(t, e) {
        var r, n, i;
        return $af62ec6a841e10b9$var$yn(this, 0, void 0, function() {
            var o, s;
            return $af62ec6a841e10b9$var$gn(this, function(a) {
                switch(a.label){
                    case 0:
                        return "number" == typeof t && t < 0 || !t ? (this.onSongLoad(null, new Error("Neither Songle ID or code provided")), [
                            2,
                            null
                        ]) : [
                            4,
                            this.songManager.load("number" == typeof t ? {
                                id: t
                            } : {
                                code: t
                            })
                        ];
                    case 1:
                        return o = a.sent(), this.onSongLoad(o, o ? void 0 : new Error("Song data not found")), o ? (s = {
                            chord: null == e ? void 0 : e.chordId,
                            beat: null == e ? void 0 : e.beatId,
                            chorus: null == e ? void 0 : e.repetitiveSegmentId
                        }, [
                            4,
                            Promise.all([
                                (null === (r = this.options) || void 0 === r ? void 0 : r.vocalFrequencyEnabled) ? this.loadSongDetailInfo(o.song.code, {
                                    revisions: s
                                }) : this.loadSongInfo(o.song.code, {
                                    revisions: s
                                }),
                                (null === (n = this.options) || void 0 === n ? void 0 : n.vocalAmplitudeEnabled) ? this.loadVocalAmplitude(o.song.code) : Promise.resolve(null),
                                (null === (i = this.options) || void 0 === i ? void 0 : i.valenceArousalEnabled) ? this.loadValenceArousal(o.song.code) : Promise.resolve(null)
                            ])
                        ]) : [
                            2,
                            null
                        ];
                    case 2:
                        return a.sent(), [
                            2,
                            new $af62ec6a841e10b9$var$Fn(this)
                        ];
                }
            });
        });
    }, t.prototype.onSongLoad = function(t, e) {
        this._song = t, this.listener && this.listener.onSongLoad && this.listener.onSongLoad(t, e);
    }, t.prototype.loadSongInfo = function(t, e) {
        return $af62ec6a841e10b9$var$yn(this, 0, void 0, function() {
            var r;
            return $af62ec6a841e10b9$var$gn(this, function(n) {
                switch(n.label){
                    case 0:
                        return [
                            4,
                            this.songManager.loadInfo(String(t), e)
                        ];
                    case 1:
                        return r = n.sent(), this.onSongMapLoad(r, r ? void 0 : new Error("Song analysis data not found")), [
                            2,
                            r
                        ];
                }
            });
        });
    }, t.prototype.loadSongDetailInfo = function(t, e) {
        return $af62ec6a841e10b9$var$yn(this, 0, void 0, function() {
            var r;
            return $af62ec6a841e10b9$var$gn(this, function(n) {
                switch(n.label){
                    case 0:
                        return [
                            4,
                            this.songManager.loadDetailInfo(String(t), e)
                        ];
                    case 1:
                        return r = n.sent(), this.onSongMapLoad(r, r ? void 0 : new Error("Song analysis data not found")), [
                            2,
                            r
                        ];
                }
            });
        });
    }, t.prototype.mockSongInfo = function(t) {
        var e = function(t) {
            for(var e = t.beat, r = t.chorusSegment, n = t.duration, i = [], o = 0; 60 * o / e.bpm < n / 1e3;)i.push([
                60 * o / e.bpm,
                1,
                e.length,
                o % e.length + 1,
                1
            ]), o++;
            return {
                beats: [
                    i
                ],
                chords: null,
                repetitive_segment: [
                    {
                        chorus: !0,
                        index: 0,
                        segment_length: r.duration / 10,
                        start_frames: r.startTimes.map(function(t) {
                            return t / 10;
                        })
                    }
                ],
                voice: null
            };
        }(t);
        return this._song = null, this.onSongMapLoad({
            analysis: e,
            info: null
        }), new $af62ec6a841e10b9$var$Fn(this);
    }, t.prototype.onSongMapLoad = function(t, e) {
        var r, n;
        this._analysis = new $af62ec6a841e10b9$var$Un(t), (null === (r = this.listener) || void 0 === r ? void 0 : r.onSongMapLoad) && this.listener.onSongMapLoad(this._analysis, e), (null === (n = this.listener) || void 0 === n ? void 0 : n.onSongInfoLoad) && this.listener.onSongInfoLoad(t, e);
    }, t.prototype.loadVocalAmplitude = function(t) {
        var e;
        return $af62ec6a841e10b9$var$yn(this, 0, void 0, function() {
            var r;
            return $af62ec6a841e10b9$var$gn(this, function(n) {
                switch(n.label){
                    case 0:
                        return r = this, [
                            4,
                            this.songManager.loadVocalAmplitude(String(t))
                        ];
                    case 1:
                        return r._vocalAmplitude = n.sent(), this._maxVocalAmplitude = Math.max.apply(Math, this._vocalAmplitude), (null === (e = this.listener) || void 0 === e ? void 0 : e.onVocalAmplitudeLoad) && this.listener.onVocalAmplitudeLoad(this._vocalAmplitude, this._vocalAmplitude ? void 0 : new Error("Vocal amplitude data not found")), [
                            2,
                            this._vocalAmplitude
                        ];
                }
            });
        });
    }, t.prototype.loadValenceArousal = function(t) {
        var e;
        return $af62ec6a841e10b9$var$yn(this, 0, void 0, function() {
            var r;
            return $af62ec6a841e10b9$var$gn(this, function(n) {
                switch(n.label){
                    case 0:
                        return r = this, [
                            4,
                            this.songManager.loadValenceArousal(String(t))
                        ];
                    case 1:
                        return r._valenceArousal = n.sent(), (null === (e = this.listener) || void 0 === e ? void 0 : e.onValenceArousalLoad) && this.listener.onValenceArousalLoad(this._valenceArousal, this._valenceArousal ? void 0 : new Error("Valence arousal data not found")), [
                            2,
                            this._valenceArousal
                        ];
                }
            });
        });
    }, t;
}(), $af62ec6a841e10b9$var$Dn = function() {
    function t(t, e, r) {
        this.managers = t, this.listener = e, this.options = r;
    }
    return t.prototype.loadRawText = function(t) {
        var e;
        return e = !t.phrases || t.phrases.length < 0 ? "" : t.phrases.map(function(t) {
            return t.words.map(function(t) {
                return t.characters.map(function(t) {
                    return t.char;
                }).join("");
            }).join("");
        }).join(""), this.onTextLoad({
            text: e
        }), {
            lyricsId: -1,
            lyrics: null,
            lyricsBody: {
                text: e,
                artist: null,
                name: null,
                url: null
            }
        };
    }, t.prototype.loadLyrics = function(t) {
        var e = t.songCode, r = t.lyricId, n = void 0 === r ? -1 : r, i = t.lyricDiffId, o = void 0 === i ? -1 : i, s = t.altLyricsUrl, a = t.directAccess;
        return $af62ec6a841e10b9$var$yn(this, 0, void 0, function() {
            var t, r, i, u;
            return $af62ec6a841e10b9$var$gn(this, function(c) {
                switch(c.label){
                    case 0:
                        return n <= 0 ? (0 === n ? this.onLyricsLoad(null, new Error("Lyrics not loaded")) : this.onLyricsLoad(null, new Error("Lyrics not found")), [
                            2,
                            null
                        ]) : [
                            4,
                            this.managers.lyrics.loadDiff(e, n, o)
                        ];
                    case 1:
                        return (null == (t = c.sent()) ? void 0 : t.data) ? (r = $af62ec6a841e10b9$var$fn($af62ec6a841e10b9$var$fn({}, t), {
                            processing: !1,
                            failed: !1,
                            id: n,
                            diff: {
                                id: o
                            }
                        }), this.onLyricsLoad(r), s || a ? [
                            3,
                            3
                        ] : [
                            4,
                            this.managers.lyrics.fetchLocalLyricBody(n)
                        ]) : (this.onLyricsLoad(null, new Error("Lyrics timing information not found")), [
                            2,
                            null
                        ]);
                    case 2:
                        i = c.sent(), c.label = 3;
                    case 3:
                        if (null == i ? void 0 : i.text) return [
                            3,
                            7
                        ];
                        c.label = 4;
                    case 4:
                        return c.trys.push([
                            4,
                            6,
                            ,
                            7
                        ]), [
                            4,
                            this.loadLyricsText(t, {
                                altLyricsUrl: s,
                                directAccess: a
                            })
                        ];
                    case 5:
                        return i = c.sent(), [
                            3,
                            7
                        ];
                    case 6:
                        return u = c.sent(), this.onTextLoad(null, u), [
                            3,
                            7
                        ];
                    case 7:
                        return i && this.onTextLoad(i), [
                            2,
                            {
                                lyricsId: r.id,
                                lyrics: r,
                                lyricsBody: i
                            }
                        ];
                }
            });
        });
    }, t.prototype.loadLyricsText = function(t, e) {
        var r = void 0 === e ? {} : e, n = r.altLyricsUrl, i = r.directAccess;
        return $af62ec6a841e10b9$var$yn(this, 0, void 0, function() {
            var e, r, o = this;
            return $af62ec6a841e10b9$var$gn(this, function(s) {
                switch(s.label){
                    case 0:
                        return e = this.options && "number" == typeof this.options.lyricsFetchTimeout && this.options.lyricsFetchTimeout >= 0, r = this.managers.lyrics.fetchLyricBody(n || t.url, {
                            parserPath: t.parser_path,
                            directAccess: i
                        }), [
                            4,
                            e ? Promise.race([
                                r,
                                new Promise(function(t, e) {
                                    return setTimeout(function() {
                                        return e(new Error("Fetching lyrics text timeout"));
                                    }, o.options.lyricsFetchTimeout);
                                })
                            ]) : r
                        ];
                    case 1:
                        return [
                            2,
                            s.sent()
                        ];
                }
            });
        });
    }, t.prototype.onLyricsLoad = function(t, e) {
        this.listener && this.listener.onLyricsLoad && this.listener.onLyricsLoad(t, e);
    }, t.prototype.onTextLoad = function(t, e) {
        this.listener && this.listener.onTextLoad && this.listener.onTextLoad(t, e);
    }, t;
}(), $af62ec6a841e10b9$var$Mn = function() {
    function t(t) {
        var e = t.video;
        this._video = e;
    }
    return Object.defineProperty(t.prototype, "video", {
        get: function() {
            return this._video;
        },
        enumerable: !1,
        configurable: !0
    }), Object.defineProperty(t.prototype, "data", {
        get: function() {
            return this._video.json;
        },
        enumerable: !1,
        configurable: !0
    }), t;
}(), $af62ec6a841e10b9$var$Bn = function() {
    function t(t, e) {
        this.managers = t, this.listener = e, this.listener = e;
    }
    return Object.defineProperty(t.prototype, "video", {
        get: function() {
            return this._video;
        },
        enumerable: !1,
        configurable: !0
    }), t.prototype.onVideoLoad = function(t, e) {
        var r = t ? Object.assign(t, e) : null;
        return r && ("string" == typeof r.json ? r.json = JSON.parse(r.json) : "object" == typeof r.json && null !== r.json || (r.json = {}), "string" == typeof r.config ? r.config = JSON.parse(r.config) : "object" == typeof r.config && null !== r.config || (r.config = {})), this._video = r, this.listener && this.listener.onVideoLoad && this.listener.onVideoLoad(r), new $af62ec6a841e10b9$var$Mn({
            video: r
        });
    }, t.prototype.createFromVideoId = function(t, e) {
        return $af62ec6a841e10b9$var$yn(this, 0, void 0, function() {
            var r;
            return $af62ec6a841e10b9$var$gn(this, function(n) {
                switch(n.label){
                    case 0:
                        return [
                            4,
                            this.managers.video.load(t)
                        ];
                    case 1:
                        return r = n.sent(), [
                            2,
                            this.onVideoLoad(r, e)
                        ];
                }
            });
        });
    }, t.prototype.createFromVideo = function(t, e) {
        return this.onVideoLoad(t, e);
    }, t.prototype.createFromSongUrl = function(t, e) {
        return $af62ec6a841e10b9$var$yn(this, 0, void 0, function() {
            return $af62ec6a841e10b9$var$gn(this, function(r) {
                return [
                    2,
                    this.createFromSongPath(this.managers.song.getSongPathFromUrl(t), e)
                ];
            });
        });
    }, t.prototype.createFromSongPath = function(t, e) {
        return $af62ec6a841e10b9$var$yn(this, 0, void 0, function() {
            var r;
            return $af62ec6a841e10b9$var$gn(this, function(n) {
                switch(n.label){
                    case 0:
                        return [
                            4,
                            this.managers.song.load({
                                songPath: t
                            })
                        ];
                    case 1:
                        return (r = n.sent()) ? [
                            2,
                            this.createFromSong(r.song, e)
                        ] : [
                            2,
                            null
                        ];
                }
            });
        });
    }, t.prototype.createFromSongId = function(t, e) {
        return $af62ec6a841e10b9$var$yn(this, 0, void 0, function() {
            var r;
            return $af62ec6a841e10b9$var$gn(this, function(n) {
                switch(n.label){
                    case 0:
                        return [
                            4,
                            this.managers.song.load({
                                id: t
                            })
                        ];
                    case 1:
                        return (r = n.sent()) ? [
                            2,
                            this.createFromSong(r.song, e)
                        ] : [
                            2,
                            null
                        ];
                }
            });
        });
    }, t.prototype.createFromSongCode = function(t, e) {
        return $af62ec6a841e10b9$var$yn(this, 0, void 0, function() {
            var r;
            return $af62ec6a841e10b9$var$gn(this, function(n) {
                switch(n.label){
                    case 0:
                        return [
                            4,
                            this.managers.song.load({
                                code: t
                            })
                        ];
                    case 1:
                        return (r = n.sent()) ? [
                            2,
                            this.createFromSong(r.song, e)
                        ] : [
                            2,
                            null
                        ];
                }
            });
        });
    }, t.prototype.createFromSong = function(t, e) {
        var r;
        return $af62ec6a841e10b9$var$yn(this, 0, void 0, function() {
            var n, i, o, s, a, u;
            return $af62ec6a841e10b9$var$gn(this, function(c) {
                switch(c.label){
                    case 0:
                        return n = null == e ? void 0 : e.lyricId, i = null == e ? void 0 : e.lyricDiffId, "number" != typeof n || n < 0 ? [
                            4,
                            this.managers.lyrics.load(t.code)
                        ] : [
                            3,
                            4
                        ];
                    case 1:
                        return o = c.sent(), (a = o && !o.status.failed && !o.status.processing && Array.isArray(o.lyrics) && o.lyrics.length > 0) ? [
                            4,
                            this.managers.lyrics.loadDetail(t.code, o.lyrics[0].id)
                        ] : [
                            3,
                            3
                        ];
                    case 2:
                        a = c.sent(), c.label = 3;
                    case 3:
                        (s = a) && (n = s.id, i = null === (r = s.diff) || void 0 === r ? void 0 : r.id), c.label = 4;
                    case 4:
                        return "number" != typeof n && (n = -1), "number" != typeof i && (i = -1), u = {
                            id: -1,
                            sourceId: -1,
                            sourceOriginId: -1,
                            songleId: t.id,
                            songleCode: t.code,
                            lyricId: n,
                            lyricDiffId: i,
                            title: null,
                            log: null,
                            background: null,
                            config: null,
                            json: null,
                            synthJson: null,
                            author: null,
                            createdDate: null,
                            accessCount: -1,
                            altUrl: null
                        }, [
                            2,
                            this.onVideoLoad(u, e)
                        ];
                }
            });
        });
    }, t.prototype.createFromText = function(t, e) {
        return $af62ec6a841e10b9$var$yn(this, 0, void 0, function() {
            var r, n, i, o, s, a;
            return $af62ec6a841e10b9$var$gn(this, function(u) {
                switch(u.label){
                    case 0:
                        return [
                            4,
                            this.managers.text.parse(t)
                        ];
                    case 1:
                        return r = u.sent(), n = r && "success" === r.status ? this.createVideoDataFromParsedText(r, t) : this.createVideoDataFromText(t), i = n[n.length - 1], o = i && i.words[i.words.length - 1], s = o && o.characters[o.characters.length - 1], a = s ? s.endTime : 0, [
                            2,
                            this.createFromJSON({
                                phrases: n,
                                startTime: 0,
                                endTime: a,
                                duration: a
                            }, e)
                        ];
                }
            });
        });
    }, t.prototype.createFromJSON = function(t, e) {
        var r = {
            id: -1,
            sourceId: -1,
            sourceOriginId: -1,
            songleId: -1,
            lyricId: -1,
            lyricDiffId: -1,
            title: null,
            log: null,
            background: null,
            config: null,
            json: t,
            synthJson: null,
            author: null,
            createdDate: null,
            accessCount: -1,
            altUrl: null
        };
        return this.onVideoLoad(r, e);
    }, t.prototype.createVideoDataFromParsedText = function(t, e) {
        var r = 0, n = e.split(/\r\n|[\n\v\f\r\x85\u2028\u2029]/);
        return t.result.map(function(t, e) {
            return {
                words: t.map(function(t) {
                    return {
                        characters: n[e].substr(t.startPosition, t.wordLength).split("").map(function(t) {
                            return {
                                char: t,
                                startTime: 300 * r,
                                endTime: 300 * ++r
                            };
                        }),
                        pos: t.PoS,
                        rawPoS: t.rawPoS,
                        language: t.language
                    };
                }),
                templates: [
                    {
                        type: "DefaultAlignment"
                    }
                ]
            };
        });
    }, t.prototype.createVideoDataFromText = function(t) {
        for(var e, r = {
            characters: []
        }, n = {
            words: [
                r
            ],
            templates: [
                {
                    type: "DefaultAlignment"
                }
            ]
        }, i = 0, o = [
            n
        ], s = 0; s < t.length; s++){
            var a = t.charAt(s);
            "\n" !== a ? " " !== a ? (e = {
                char: a,
                startTime: 300 * i,
                endTime: 300 * ++i
            }, r.characters.push(e)) : (r = {
                characters: []
            }, n.words.push(r)) : (n = {
                words: [
                    r = {
                        characters: []
                    }
                ],
                templates: [
                    {
                        type: "DefaultAlignment"
                    }
                ]
            }, o.push(n));
        }
        return r.characters.length <= 0 && n.words.pop(), n.words.length <= 0 && o.pop(), o;
    }, t;
}(), $af62ec6a841e10b9$var$Vn = function() {
    function t(t, e, r) {
        void 0 === e && (e = null);
        var n = this;
        this.managers = t, this.listener = e, this.options = r, this.fontLoader = new $af62ec6a841e10b9$var$Rn(t.font, function() {
            return n.text;
        }, e);
    }
    return Object.defineProperty(t.prototype, "permalink", {
        get: function() {
            var t;
            return "https://textalive.jp".concat((null === (t = this.song) || void 0 === t ? void 0 : t.permalink) ? "/songs/".concat(encodeURIComponent($af62ec6a841e10b9$var$c.getSongPathFromUrl(this.song.permalink))) : "");
        },
        enumerable: !1,
        configurable: !0
    }), Object.defineProperty(t.prototype, "video", {
        get: function() {
            var t;
            return null === (t = this.videoProvider) || void 0 === t ? void 0 : t.video;
        },
        enumerable: !1,
        configurable: !0
    }), Object.defineProperty(t.prototype, "song", {
        get: function() {
            var t, e;
            return null === (e = null === (t = this.songProvider) || void 0 === t ? void 0 : t.song) || void 0 === e ? void 0 : e.song;
        },
        enumerable: !1,
        configurable: !0
    }), Object.defineProperty(t.prototype, "songStatus", {
        get: function() {
            var t, e;
            return null === (e = null === (t = this.songProvider) || void 0 === t ? void 0 : t.song) || void 0 === e ? void 0 : e.status;
        },
        enumerable: !1,
        configurable: !0
    }), Object.defineProperty(t.prototype, "songMap", {
        get: function() {
            var t;
            return null === (t = this.songProvider) || void 0 === t ? void 0 : t.analysis;
        },
        enumerable: !1,
        configurable: !0
    }), Object.defineProperty(t.prototype, "lyricsId", {
        get: function() {
            var t, e;
            return null === (e = null === (t = this.textProvider) || void 0 === t ? void 0 : t.lyrics) || void 0 === e ? void 0 : e.id;
        },
        enumerable: !1,
        configurable: !0
    }), Object.defineProperty(t.prototype, "lyrics", {
        get: function() {
            var t;
            return null === (t = this.textProvider) || void 0 === t ? void 0 : t.lyrics;
        },
        enumerable: !1,
        configurable: !0
    }), Object.defineProperty(t.prototype, "lyricsBody", {
        get: function() {
            var t;
            return null === (t = this.textProvider) || void 0 === t ? void 0 : t.lyricsBody;
        },
        enumerable: !1,
        configurable: !0
    }), Object.defineProperty(t.prototype, "text", {
        get: function() {
            var t, e;
            return null === (e = null === (t = this.textProvider) || void 0 === t ? void 0 : t.lyricsBody) || void 0 === e ? void 0 : e.text;
        },
        enumerable: !1,
        configurable: !0
    }), Object.defineProperty(t.prototype, "fonts", {
        get: function() {
            return this.fontLoader;
        },
        enumerable: !1,
        configurable: !0
    }), t.prototype.createFromVideoId = function(t, e) {
        return $af62ec6a841e10b9$var$yn(this, 0, void 0, function() {
            var r;
            return $af62ec6a841e10b9$var$gn(this, function(n) {
                switch(n.label){
                    case 0:
                        return r = this, [
                            4,
                            new $af62ec6a841e10b9$var$Bn(this.managers, this.listener).createFromVideoId(t, e)
                        ];
                    case 1:
                        return r.videoProvider = n.sent(), [
                            2,
                            this.videoProvider
                        ];
                }
            });
        });
    }, t.prototype.createFromVideo = function(t, e) {
        return this.videoProvider = new $af62ec6a841e10b9$var$Bn(this.managers, this.listener).createFromVideo(t, e), this.videoProvider;
    }, t.prototype.createFromSongUrl = function(t, e) {
        return $af62ec6a841e10b9$var$yn(this, 0, void 0, function() {
            var r;
            return $af62ec6a841e10b9$var$gn(this, function(n) {
                switch(n.label){
                    case 0:
                        return r = this, [
                            4,
                            new $af62ec6a841e10b9$var$Bn(this.managers, this.listener).createFromSongUrl(t, e)
                        ];
                    case 1:
                        return r.videoProvider = n.sent(), [
                            2,
                            this.videoProvider
                        ];
                }
            });
        });
    }, t.prototype.createFromSongPath = function(t, e) {
        return $af62ec6a841e10b9$var$yn(this, 0, void 0, function() {
            var r;
            return $af62ec6a841e10b9$var$gn(this, function(n) {
                switch(n.label){
                    case 0:
                        return r = this, [
                            4,
                            new $af62ec6a841e10b9$var$Bn(this.managers, this.listener).createFromSongPath(t, e)
                        ];
                    case 1:
                        return r.videoProvider = n.sent(), [
                            2,
                            this.videoProvider
                        ];
                }
            });
        });
    }, t.prototype.createFromSongId = function(t, e) {
        return $af62ec6a841e10b9$var$yn(this, 0, void 0, function() {
            var r;
            return $af62ec6a841e10b9$var$gn(this, function(n) {
                switch(n.label){
                    case 0:
                        return r = this, [
                            4,
                            new $af62ec6a841e10b9$var$Bn(this.managers, this.listener).createFromSongId(t, e)
                        ];
                    case 1:
                        return r.videoProvider = n.sent(), [
                            2,
                            this.videoProvider
                        ];
                }
            });
        });
    }, t.prototype.createFromSongCode = function(t, e) {
        return $af62ec6a841e10b9$var$yn(this, 0, void 0, function() {
            var r;
            return $af62ec6a841e10b9$var$gn(this, function(n) {
                switch(n.label){
                    case 0:
                        return r = this, [
                            4,
                            new $af62ec6a841e10b9$var$Bn(this.managers, this.listener).createFromSongCode(t, e)
                        ];
                    case 1:
                        return r.videoProvider = n.sent(), [
                            2,
                            this.videoProvider
                        ];
                }
            });
        });
    }, t.prototype.createFromText = function(t, e) {
        return $af62ec6a841e10b9$var$yn(this, 0, void 0, function() {
            var r;
            return $af62ec6a841e10b9$var$gn(this, function(n) {
                switch(n.label){
                    case 0:
                        return r = this, [
                            4,
                            new $af62ec6a841e10b9$var$Bn(this.managers, this.listener).createFromText(t, e)
                        ];
                    case 1:
                        return r.videoProvider = n.sent(), [
                            2,
                            this.videoProvider
                        ];
                }
            });
        });
    }, t.prototype.createFromJSON = function(t, e) {
        return this.videoProvider = new $af62ec6a841e10b9$var$Bn(this.managers, this.listener).createFromJSON(t, e), this.videoProvider;
    }, t.prototype.finalize = function(t) {
        return $af62ec6a841e10b9$var$yn(this, 0, void 0, function() {
            return $af62ec6a841e10b9$var$gn(this, function(e) {
                switch(e.label){
                    case 0:
                        return this.video ? [
                            4,
                            this.loadSong()
                        ] : [
                            2,
                            null
                        ];
                    case 1:
                        return e.sent(), [
                            4,
                            this.loadText(t)
                        ];
                    case 2:
                        return e.sent(), [
                            4,
                            this.loadFonts()
                        ];
                    case 3:
                        return e.sent(), [
                            2
                        ];
                }
            });
        });
    }, t.prototype.mockSongInfo = function(t) {
        this.songProvider = new $af62ec6a841e10b9$var$Ln(this.managers.song, this.listener, this.options).mockSongInfo(t);
    }, t.prototype.loadSong = function() {
        return $af62ec6a841e10b9$var$yn(this, 0, void 0, function() {
            var t;
            return $af62ec6a841e10b9$var$gn(this, function(e) {
                switch(e.label){
                    case 0:
                        return t = this, [
                            4,
                            new $af62ec6a841e10b9$var$Ln(this.managers.song, this.listener, this.options).loadSong(this.video.songleCode || this.video.songleId, this.video)
                        ];
                    case 1:
                        return t.songProvider = e.sent(), [
                            2
                        ];
                }
            });
        });
    }, t.prototype.loadText = function(t) {
        var e, r;
        return $af62ec6a841e10b9$var$yn(this, 0, void 0, function() {
            var n, i, o, s, a, u, c, l;
            return $af62ec6a841e10b9$var$gn(this, function(p) {
                switch(p.label){
                    case 0:
                        return n = this.video, i = n.lyricId, o = n.lyricDiffId, s = this.song ? this.song.code : null, a = new $af62ec6a841e10b9$var$Dn(this.managers, this.listener, this.options), !s && i < 0 ? (u = a.loadRawText(null === (e = this.videoProvider) || void 0 === e ? void 0 : e.data), [
                            3,
                            3
                        ]) : [
                            3,
                            1
                        ];
                    case 1:
                        return c = (null == t ? void 0 : t.altLyricsUrl) || void 0, l = (null == t ? void 0 : t.lyricsDirectAccess) || void 0, [
                            4,
                            a.loadLyrics({
                                songCode: s,
                                lyricId: i,
                                lyricDiffId: o,
                                altLyricsUrl: c,
                                directAccess: l
                            })
                        ];
                    case 2:
                        u = p.sent(), p.label = 3;
                    case 3:
                        return this.textProvider = u, (null == u ? void 0 : u.lyrics) && (null === (r = null == u ? void 0 : u.lyricsBody) || void 0 === r ? void 0 : r.text) && this.importLyrics(), [
                            2
                        ];
                }
            });
        });
    }, t.prototype.loadFonts = function() {
        var t, e, r;
        return $af62ec6a841e10b9$var$yn(this, 0, void 0, function() {
            return $af62ec6a841e10b9$var$gn(this, function(n) {
                switch(n.label){
                    case 0:
                        return "number" == typeof this.video.id && this.video.id >= 0 ? [
                            4,
                            this.fontLoader.loadForVideo(null === (t = this.videoProvider) || void 0 === t ? void 0 : t.data)
                        ] : [
                            3,
                            2
                        ];
                    case 1:
                    case 3:
                    case 5:
                        return n.sent(), [
                            2
                        ];
                    case 2:
                        return Array.isArray(null === (e = this.options) || void 0 === e ? void 0 : e.fontFamilies) ? [
                            4,
                            this.fontLoader.load(this.options.fontFamilies)
                        ] : [
                            3,
                            4
                        ];
                    case 4:
                        return null !== (null === (r = this.options) || void 0 === r ? void 0 : r.fontFamilies) ? [
                            3,
                            6
                        ] : [
                            4,
                            this.fontLoader.loadAll()
                        ];
                    case 6:
                        return [
                            2
                        ];
                }
            });
        });
    }, t.prototype.importLyrics = function() {
        var t = this.text.replace(/[\s\r\n]/g, ""), e = 0, r = {
            phrases: this.lyrics.data.map(function(r) {
                return {
                    words: r.map(function(r) {
                        return {
                            characters: r.map(function(r) {
                                return {
                                    char: t.charAt(e++),
                                    startTime: 1e3 * r.start_time,
                                    endTime: 1e3 * r.end_time
                                };
                            })
                        };
                    })
                };
            })
        };
        this.video.json && Array.isArray(this.video.json.phrases) ? this.video.json.phrases.forEach(function(t, e) {
            t.words.forEach(function(t, n) {
                t.characters.forEach(function(t, i) {
                    var o = r.phrases[e].words[n].characters[i];
                    t.char = o.char, t.startTime = o.startTime, t.endTime = o.endTime;
                });
            });
        }) : this.video.json = r;
    }, t.prototype.getChoruses = function() {
        var t;
        return null === (t = this.songProvider) || void 0 === t ? void 0 : t.getChoruses();
    }, t.prototype.findChorus = function(t, e) {
        var r;
        return null === (r = this.songProvider) || void 0 === r ? void 0 : r.findChorus(t, e);
    }, t.prototype.findChorusBetween = function(t, e) {
        var r;
        return null === (r = this.songProvider) || void 0 === r ? void 0 : r.findChorusBetween(t, e);
    }, t.prototype.findChorusChange = function(t, e) {
        var r;
        return null === (r = this.songProvider) || void 0 === r ? void 0 : r.findChorusChange(t, e);
    }, t.prototype.getBeats = function() {
        var t;
        return null === (t = this.songProvider) || void 0 === t ? void 0 : t.getBeats();
    }, t.prototype.findBeat = function(t, e) {
        var r;
        return null === (r = this.songProvider) || void 0 === r ? void 0 : r.findBeat(t, e);
    }, t.prototype.findBeatChange = function(t, e) {
        var r;
        return null === (r = this.songProvider) || void 0 === r ? void 0 : r.findBeatChange(t, e);
    }, t.prototype.getChords = function() {
        var t;
        return null === (t = this.songProvider) || void 0 === t ? void 0 : t.getChords();
    }, t.prototype.findChord = function(t, e) {
        var r;
        return null === (r = this.songProvider) || void 0 === r ? void 0 : r.findChord(t, e);
    }, t.prototype.findChordChange = function(t, e) {
        var r;
        return null === (r = this.songProvider) || void 0 === r ? void 0 : r.findChordChange(t, e);
    }, t.prototype.getVocalFrequency = function(t) {
        var e;
        return null === (e = this.songProvider) || void 0 === e ? void 0 : e.getVocalFrequency(t);
    }, t.prototype.getVocalAmplitude = function(t) {
        var e;
        return null === (e = this.songProvider) || void 0 === e ? void 0 : e.getVocalAmplitude(t);
    }, t.prototype.getMaxVocalAmplitude = function() {
        var t;
        return null === (t = this.songProvider) || void 0 === t ? void 0 : t.getMaxVocalAmplitude();
    }, t.prototype.getValenceArousal = function(t) {
        var e;
        return null === (e = this.songProvider) || void 0 === e ? void 0 : e.getValenceArousal(t);
    }, t.prototype.getMedianValenceArousal = function() {
        var t;
        return null === (t = this.songProvider) || void 0 === t ? void 0 : t.getMedianValenceArousal();
    }, t;
}(), $af62ec6a841e10b9$var$Gn = function() {
    function t(t, e) {
        this.player = t, this.listener = e, this.initialize();
    }
    return Object.defineProperty(t.prototype, "options", {
        get: function() {
            return this._options ? $af62ec6a841e10b9$var$fn({}, this._options) : null;
        },
        enumerable: !1,
        configurable: !0
    }), Object.defineProperty(t.prototype, "name", {
        get: function() {
            return this._name;
        },
        enumerable: !1,
        configurable: !0
    }), Object.defineProperty(t.prototype, "author", {
        get: function() {
            return this._author;
        },
        enumerable: !1,
        configurable: !0
    }), Object.defineProperty(t.prototype, "status", {
        get: function() {
            return this._status;
        },
        enumerable: !1,
        configurable: !0
    }), Object.defineProperty(t.prototype, "server", {
        get: function() {
            return this._server;
        },
        enumerable: !1,
        configurable: !0
    }), Object.defineProperty(t.prototype, "managed", {
        get: function() {
            return !!this._host;
        },
        enumerable: !1,
        configurable: !0
    }), Object.defineProperty(t.prototype, "host", {
        get: function() {
            return this._host;
        },
        enumerable: !1,
        configurable: !0
    }), Object.defineProperty(t.prototype, "songUrl", {
        get: function() {
            return this._songUrl;
        },
        enumerable: !1,
        configurable: !0
    }), Object.defineProperty(t.prototype, "songOptions", {
        get: function() {
            return this._songOptions;
        },
        enumerable: !1,
        configurable: !0
    }), Object.defineProperty(t.prototype, "parameters", {
        get: function() {
            return this._parameters;
        },
        enumerable: !1,
        configurable: !0
    }), Object.defineProperty(t.prototype, "isConnecting", {
        get: function() {
            return !!this.connecting;
        },
        enumerable: !1,
        configurable: !0
    }), t.prototype.initialize = function() {
        var t, e, r, n;
        return $af62ec6a841e10b9$var$yn(this, 0, void 0, function() {
            return $af62ec6a841e10b9$var$gn(this, function(i) {
                switch(i.label){
                    case 0:
                        return this._options = null === (e = null === (t = this.player) || void 0 === t ? void 0 : t.options) || void 0 === e ? void 0 : e.app, this._options && (this._options = $af62ec6a841e10b9$var$fn({}, this._options), this._name = null === (r = this._options) || void 0 === r ? void 0 : r.appName, this._author = null === (n = this._options) || void 0 === n ? void 0 : n.appAuthor, this._options.token && ($af62ec6a841e10b9$var$m.textalive.appToken = this._options.token)), this._parameters = {}, this.parseQueryString(), this.initializeServerConnection(), "undefined" != typeof window && this._options ? [
                            4,
                            this.connect()
                        ] : [
                            3,
                            2
                        ];
                    case 1:
                        i.sent(), this.initializePlayerListener(), this.initializeMessageListener(), i.label = 2;
                    case 2:
                        return this._songUrl && this.createFromSongUrl(), [
                            2
                        ];
                }
            });
        });
    }, t.prototype.initializeServerConnection = function() {
        var t, e, r, n, i, o;
        return $af62ec6a841e10b9$var$yn(this, 0, void 0, function() {
            var s, a, u, c, l;
            return $af62ec6a841e10b9$var$gn(this, function(p) {
                switch(p.label){
                    case 0:
                        return [
                            4,
                            $af62ec6a841e10b9$var$A.getServerStatus()
                        ];
                    case 1:
                        return s = p.sent(), a = "ja" === (null == s ? void 0 : s.lang), $af62ec6a841e10b9$var$m.textalive.appToken && (null == s ? void 0 : s.app) && (s.app.data && (this._name = null === (t = s.app.data) || void 0 === t ? void 0 : t.name, this._author = null === (r = null === (e = s.app) || void 0 === e ? void 0 : e.data) || void 0 === r ? void 0 : r.author, u = null === (i = null === (n = s.app) || void 0 === n ? void 0 : n.data) || void 0 === i ? void 0 : i.status, this._status = "number" == typeof u ? u : -1), this._server = {
                            version: s.version,
                            message: s.app.message,
                            error: s.app.error
                        }, !this._server.error) ? (c = this._server.message ? "\n".concat(this._server.message) : "", a ? console.info("[TextAlive API] \u30AF\u30E9\u30A4\u30A2\u30F3\u30C8 v".concat($af62ec6a841e10b9$var$m.client.version, " \u3067\u30B5\u30FC\u30D0 v").concat(this._server.version || "0.0.0", " \u306B\u63A5\u7D9A").concat(c)) : console.info("[TextAlive API] App API client v".concat($af62ec6a841e10b9$var$m.client.version, " connected to server v").concat(this._server.version || "0.0.0").concat(c)), this.listener.onAppLoad(this), [
                            2
                        ]) : (l = (null === (o = this._server) || void 0 === o ? void 0 : o.error) ? "\n".concat(this._server.error) : "", a ? console.warn("[TextAlive API] \u3053\u306E\u30A2\u30D7\u30EA\u306F\u30C8\u30FC\u30AF\u30F3\u304C\u6B63\u3057\u304F\u6307\u5B9A\u3055\u308C\u3066\u3044\u306A\u3044\u305F\u3081\u52D5\u4F5C\u3057\u307E\u305B\u3093\u3002 https://developer.textalive.jp \u304B\u3089\u30C8\u30FC\u30AF\u30F3\u3092\u5165\u624B\u3057\u3066\u6307\u5B9A\u3057\u3066\u304F\u3060\u3055\u3044\u3002".concat(l)) : console.warn("[TextAlive API] This app requires a valid app token to run properly. You could get a token from https://developer.textalive.jp. ".concat(l)), this.listener.onAppLoad(null, l), [
                            2
                        ]);
                }
            });
        });
    }, t.prototype.initializePlayerListener = function() {
        var t = this;
        this.playerListener = {
            onVideoReady: function(e) {
                t._host && window.parent.postMessage({
                    kind: "ta_video",
                    options: {
                        lyrics: !!t.player.data.lyrics,
                        duration: t.player.video.duration
                    }
                }, "*");
            },
            onThrottledTimeUpdate: function(e) {
                t._host && window.parent.postMessage({
                    kind: "ta_position",
                    options: {
                        position: e
                    }
                }, "*");
            },
            onPlay: function() {
                t._host && window.parent.postMessage({
                    kind: "ta_status",
                    options: {
                        status: "play"
                    }
                }, "*");
            },
            onPause: function() {
                t._host && window.parent.postMessage({
                    kind: "ta_status",
                    options: {
                        status: "pause"
                    }
                }, "*");
            },
            onStop: function() {
                t._host && window.parent.postMessage({
                    kind: "ta_status",
                    options: {
                        status: "stop"
                    }
                }, "*");
            },
            onVolumeUpdate: function(e) {
                t._host && window.parent.postMessage({
                    kind: "ta_volume",
                    options: {
                        volume: e
                    }
                }, "*");
            },
            onDispose: function() {
                t.dispose();
            }
        }, this.player.addListener(this.playerListener);
    }, t.prototype.initializeMessageListener = function() {
        var t = this;
        this.messageListener = function(e) {
            if (e.data.kind && /^ta_/.test(e.data.kind)) {
                var r = t.player;
                switch(e.data.kind.substring(3)){
                    case "status":
                        switch(e.data.options.status){
                            case "play":
                                r.requestPlay();
                                break;
                            case "pause":
                                r.requestPause();
                                break;
                            case "stop":
                                r.requestStop();
                        }
                        break;
                    case "seek":
                        r.requestMediaSeek(e.data.options.position);
                        break;
                    case "volume":
                        r.volume = e.data.options.volume;
                        break;
                    case "parameter":
                        var n = e.data.options, i = n.name, o = n.value;
                        t.parameters[i] = o, t.listener.onAppParameterUpdate(i, o);
                        break;
                    case "media":
                        t._songUrl = e.data.options.url, t._songOptions = e.data.options.options || {}, r.requestStop();
                        var s = t.createFromSongUrl();
                        t.listener.onAppMediaChange(t._songUrl, s);
                }
            }
        }, window.addEventListener("message", this.messageListener);
    }, t.prototype.createFromSongUrl = function() {
        var t, e = this._songOptions;
        return e && (t = {
            video: {}
        }, e.altLyricsUrl && (t.altLyricsUrl = e.altLyricsUrl), e.lyricsDirectAccess && (t.lyricsDirectAccess = e.lyricsDirectAccess), e.lyricId && (t.video.lyricId = e.lyricId), e.lyricDiffId && (t.video.lyricDiffId = e.lyricDiffId), e.chordId && (t.video.chordId = e.chordId), e.beatId && (t.video.beatId = e.beatId), e.repetitiveSegmentId && (t.video.repetitiveSegmentId = e.repetitiveSegmentId)), this.player.createFromSongUrl(this._songUrl, t);
    }, t.prototype.parseQueryString = function() {
        var t = $af62ec6a841e10b9$var$pn("ta_app_token");
        t && ($af62ec6a841e10b9$var$m.textalive.appToken = t), this._songUrl = $af62ec6a841e10b9$var$pn("ta_song_url"), this._songOptions = {};
        var e = $af62ec6a841e10b9$var$pn("ta_lyric_id");
        e && (this._songOptions.lyricId = parseInt(e), isNaN(this._songOptions.lyricId) && delete this._songOptions.lyricId);
        var r = $af62ec6a841e10b9$var$pn("ta_lyric_diff_id");
        r && (this._songOptions.lyricDiffId = parseInt(r), isNaN(this._songOptions.lyricDiffId) && delete this._songOptions.lyricDiffId);
        var n = $af62ec6a841e10b9$var$pn("ta_alt_lyrics_url");
        n && (this._songOptions.altLyricsUrl = n);
        var i = $af62ec6a841e10b9$var$pn("ta_lyrics_direct_access");
        i && (this._songOptions.lyricsDirectAccess = "true" === i, this._songOptions.lyricsDirectAccess || delete this._songOptions.lyricsDirectAccess);
        var o = $af62ec6a841e10b9$var$pn("ta_chord_id");
        o && (this._songOptions.chordId = parseInt(o), isNaN(this._songOptions.chordId) && delete this._songOptions.chordId);
        var s = $af62ec6a841e10b9$var$pn("ta_beat_id");
        s && (this._songOptions.beatId = parseInt(s), isNaN(this._songOptions.beatId) && delete this._songOptions.beatId);
        var a = $af62ec6a841e10b9$var$pn("ta_repetitive_segment_id");
        a && (this._songOptions.repetitiveSegmentId = parseInt(a), isNaN(this._songOptions.repetitiveSegmentId) && delete this._songOptions.repetitiveSegmentId);
    }, t.prototype.connect = function() {
        return $af62ec6a841e10b9$var$yn(this, 0, void 0, function() {
            var t, e = this;
            return $af62ec6a841e10b9$var$gn(this, function(r) {
                switch(r.label){
                    case 0:
                        return this.connecting ? [
                            2,
                            this.connecting
                        ] : "undefined" != typeof window && this.options && window.parent && window !== window.parent ? [
                            3,
                            2
                        ] : [
                            4,
                            new Promise(function(t) {
                                return setTimeout(t, 1);
                            })
                        ];
                    case 1:
                        return r.sent(), this.listener.onAppReady(this), [
                            2,
                            !1
                        ];
                    case 2:
                        return this.connecting = Promise.race([
                            new Promise(function(r) {
                                t = function(n) {
                                    n.data.kind && /^ta_/.test(n.data.kind) && "ack" === n.data.kind.substring(3) && (window.removeEventListener("message", t), e._host = n.data.options, r(!0));
                                }, window.addEventListener("message", t);
                            }),
                            $af62ec6a841e10b9$var$yn(e, 0, void 0, function() {
                                var e;
                                return $af62ec6a841e10b9$var$gn(this, function(r) {
                                    switch(r.label){
                                        case 0:
                                            e = 0, r.label = 1;
                                        case 1:
                                            return e < 5 ? (window.parent.postMessage({
                                                kind: "ta_connect",
                                                options: this.options
                                            }, "*"), [
                                                4,
                                                new Promise(function(t) {
                                                    return setTimeout(t, 200);
                                                })
                                            ]) : [
                                                3,
                                                4
                                            ];
                                        case 2:
                                            if (r.sent(), this._host) return [
                                                3,
                                                4
                                            ];
                                            r.label = 3;
                                        case 3:
                                            return e++, [
                                                3,
                                                1
                                            ];
                                        case 4:
                                            return !this._host && t && window.removeEventListener("message", t), [
                                                2,
                                                !!this._host
                                            ];
                                    }
                                });
                            })
                        ]), this.connecting.finally(function() {
                            e.connecting = null, e.listener.onAppReady(e);
                        }), [
                            2,
                            this.connecting
                        ];
                }
            });
        });
    }, t.prototype.dispose = function() {
        "undefined" != typeof window && this.options && (this.player.removeListener(this.playerListener), window.removeEventListener("message", this.messageListener)), this._host = null, this.player = null;
    }, t;
}();
function $af62ec6a841e10b9$var$qn(t) {
    return t;
}
function $af62ec6a841e10b9$var$Wn(t) {
    return t < -1 ? t = -1 : t > 1 && (t = 1), function(e) {
        return 0 == t ? e : t < 0 ? e * (e * -t + 1 + t) : e * ((2 - e) * t + (1 - t));
    };
}
function $af62ec6a841e10b9$var$Yn(t) {
    return function(e) {
        return Math.pow(e, t);
    };
}
function $af62ec6a841e10b9$var$zn(t) {
    return function(e) {
        return 1 - Math.pow(1 - e, t);
    };
}
function $af62ec6a841e10b9$var$Jn(t) {
    return function(e) {
        return (e *= 2) < 1 ? .5 * Math.pow(e, t) : 1 - .5 * Math.abs(Math.pow(2 - e, t));
    };
}
var $af62ec6a841e10b9$var$Hn = $af62ec6a841e10b9$var$Yn(2), $af62ec6a841e10b9$var$Xn = $af62ec6a841e10b9$var$zn(2), $af62ec6a841e10b9$var$Zn = $af62ec6a841e10b9$var$Jn(2), $af62ec6a841e10b9$var$$n = $af62ec6a841e10b9$var$Yn(3), $af62ec6a841e10b9$var$Kn = $af62ec6a841e10b9$var$zn(3), $af62ec6a841e10b9$var$Qn = $af62ec6a841e10b9$var$Jn(3), $af62ec6a841e10b9$var$ti = $af62ec6a841e10b9$var$Yn(4), $af62ec6a841e10b9$var$ei = $af62ec6a841e10b9$var$zn(4), $af62ec6a841e10b9$var$ri = $af62ec6a841e10b9$var$Jn(4), $af62ec6a841e10b9$var$ni = $af62ec6a841e10b9$var$Yn(5), $af62ec6a841e10b9$var$ii = $af62ec6a841e10b9$var$zn(5), $af62ec6a841e10b9$var$oi = $af62ec6a841e10b9$var$Jn(5);
function $af62ec6a841e10b9$var$si(t) {
    return 1 - Math.cos(t * Math.PI / 2);
}
function $af62ec6a841e10b9$var$ai(t) {
    return Math.sin(t * Math.PI / 2);
}
function $af62ec6a841e10b9$var$ui(t) {
    return -0.5 * (Math.cos(Math.PI * t) - 1);
}
function $af62ec6a841e10b9$var$ci(t) {
    return function(e) {
        return e * e * ((t + 1) * e - t);
    };
}
var $af62ec6a841e10b9$var$li = $af62ec6a841e10b9$var$ci(1.7);
function $af62ec6a841e10b9$var$pi(t) {
    return function(e) {
        return --e * e * ((t + 1) * e + t) + 1;
    };
}
var $af62ec6a841e10b9$var$hi = $af62ec6a841e10b9$var$pi(1.7);
function $af62ec6a841e10b9$var$di(t) {
    return t *= 1.525, function(e) {
        return (e *= 2) < 1 ? e * e * ((t + 1) * e - t) * .5 : .5 * ((e -= 2) * e * ((t + 1) * e + t) + 2);
    };
}
var $af62ec6a841e10b9$var$fi = $af62ec6a841e10b9$var$di(1.7);
function $af62ec6a841e10b9$var$yi(t) {
    return -(Math.sqrt(1 - t * t) - 1);
}
function $af62ec6a841e10b9$var$gi(t) {
    return Math.sqrt(1 - --t * t);
}
function $af62ec6a841e10b9$var$vi(t) {
    return (t *= 2) < 1 ? -0.5 * (Math.sqrt(1 - t * t) - 1) : .5 * (Math.sqrt(1 - (t -= 2) * t) + 1);
}
function $af62ec6a841e10b9$var$mi(t) {
    return 1 - $af62ec6a841e10b9$var$bi(1 - t);
}
function $af62ec6a841e10b9$var$bi(t) {
    return t < 1 / 2.75 ? 7.5625 * t * t : t < 2 / 2.75 ? 7.5625 * (t -= 1.5 / 2.75) * t + .75 : t < 2.5 / 2.75 ? 7.5625 * (t -= 2.25 / 2.75) * t + .9375 : 7.5625 * (t -= 2.625 / 2.75) * t + .984375;
}
function $af62ec6a841e10b9$var$_i(t) {
    return t < .5 ? .5 * $af62ec6a841e10b9$var$mi(2 * t) : .5 * $af62ec6a841e10b9$var$bi(2 * t - 1) + .5;
}
function $af62ec6a841e10b9$var$wi(t, e) {
    var r = 2 * Math.PI;
    return function(n) {
        if (0 == n || 1 == n) return n;
        var i = e / r * Math.asin(1 / t);
        return -t * Math.pow(2, 10 * (n -= 1)) * Math.sin((n - i) * r / e);
    };
}
var $af62ec6a841e10b9$var$Pi = $af62ec6a841e10b9$var$wi(1, .3);
function $af62ec6a841e10b9$var$Ei(t, e) {
    var r = 2 * Math.PI;
    return function(n) {
        if (0 == n || 1 == n) return n;
        var i = e / r * Math.asin(1 / t);
        return t * Math.pow(2, -10 * n) * Math.sin((n - i) * r / e) + 1;
    };
}
var $af62ec6a841e10b9$var$Oi = $af62ec6a841e10b9$var$Ei(1, .3);
function $af62ec6a841e10b9$var$Si(t, e) {
    var r = 2 * Math.PI;
    return function(n) {
        var i = e / r * Math.asin(1 / t);
        return (n *= 2) < 1 ? t * Math.pow(2, 10 * (n -= 1)) * Math.sin((n - i) * r / e) * -0.5 : t * Math.pow(2, -10 * (n -= 1)) * Math.sin((n - i) * r / e) * .5 + 1;
    };
}
var $af62ec6a841e10b9$var$Ti = $af62ec6a841e10b9$var$Si(1, .3 * 1.5), $af62ec6a841e10b9$var$xi = Object.freeze({
    __proto__: null,
    backIn: $af62ec6a841e10b9$var$li,
    backInOut: $af62ec6a841e10b9$var$fi,
    backOut: $af62ec6a841e10b9$var$hi,
    bounceIn: $af62ec6a841e10b9$var$mi,
    bounceInOut: $af62ec6a841e10b9$var$_i,
    bounceOut: $af62ec6a841e10b9$var$bi,
    circIn: $af62ec6a841e10b9$var$yi,
    circInOut: $af62ec6a841e10b9$var$vi,
    circOut: $af62ec6a841e10b9$var$gi,
    cubicIn: $af62ec6a841e10b9$var$$n,
    cubicInOut: $af62ec6a841e10b9$var$Qn,
    cubicOut: $af62ec6a841e10b9$var$Kn,
    elasticIn: $af62ec6a841e10b9$var$Pi,
    elasticInOut: $af62ec6a841e10b9$var$Ti,
    elasticOut: $af62ec6a841e10b9$var$Oi,
    get: $af62ec6a841e10b9$var$Wn,
    getBackIn: $af62ec6a841e10b9$var$ci,
    getBackInOut: $af62ec6a841e10b9$var$di,
    getBackOut: $af62ec6a841e10b9$var$pi,
    getElasticIn: $af62ec6a841e10b9$var$wi,
    getElasticInOut: $af62ec6a841e10b9$var$Si,
    getElasticOut: $af62ec6a841e10b9$var$Ei,
    getPowIn: $af62ec6a841e10b9$var$Yn,
    getPowInOut: $af62ec6a841e10b9$var$Jn,
    getPowOut: $af62ec6a841e10b9$var$zn,
    linear: $af62ec6a841e10b9$var$qn,
    quadIn: $af62ec6a841e10b9$var$Hn,
    quadInOut: $af62ec6a841e10b9$var$Zn,
    quadOut: $af62ec6a841e10b9$var$Xn,
    quartIn: $af62ec6a841e10b9$var$ti,
    quartInOut: $af62ec6a841e10b9$var$ri,
    quartOut: $af62ec6a841e10b9$var$ei,
    quintIn: $af62ec6a841e10b9$var$ni,
    quintInOut: $af62ec6a841e10b9$var$oi,
    quintOut: $af62ec6a841e10b9$var$ii,
    sineIn: $af62ec6a841e10b9$var$si,
    sineInOut: $af62ec6a841e10b9$var$ui,
    sineOut: $af62ec6a841e10b9$var$ai
}), $af62ec6a841e10b9$export$e60daad661aebae6 = function() {
    function t() {}
    return t.linear = $af62ec6a841e10b9$var$qn, t.get = $af62ec6a841e10b9$var$Wn, t.getPowIn = $af62ec6a841e10b9$var$Yn, t.getPowOut = $af62ec6a841e10b9$var$zn, t.getPowInOut = $af62ec6a841e10b9$var$Jn, t.quadIn = $af62ec6a841e10b9$var$Hn, t.quadOut = $af62ec6a841e10b9$var$Xn, t.quadInOut = $af62ec6a841e10b9$var$Zn, t.cubicIn = $af62ec6a841e10b9$var$$n, t.cubicOut = $af62ec6a841e10b9$var$Kn, t.cubicInOut = $af62ec6a841e10b9$var$Qn, t.quartIn = $af62ec6a841e10b9$var$ti, t.quartOut = $af62ec6a841e10b9$var$ei, t.quartInOut = $af62ec6a841e10b9$var$ri, t.quintIn = $af62ec6a841e10b9$var$ni, t.quintOut = $af62ec6a841e10b9$var$ii, t.quintInOut = $af62ec6a841e10b9$var$oi, t.sineIn = $af62ec6a841e10b9$var$si, t.sineOut = $af62ec6a841e10b9$var$ai, t.sineInOut = $af62ec6a841e10b9$var$ui, t.getBackIn = $af62ec6a841e10b9$var$ci, t.backIn = $af62ec6a841e10b9$var$li, t.getBackOut = $af62ec6a841e10b9$var$pi, t.backOut = $af62ec6a841e10b9$var$hi, t.getBackInOut = $af62ec6a841e10b9$var$di, t.backInOut = $af62ec6a841e10b9$var$fi, t.circIn = $af62ec6a841e10b9$var$yi, t.circOut = $af62ec6a841e10b9$var$gi, t.circInOut = $af62ec6a841e10b9$var$vi, t.bounceIn = $af62ec6a841e10b9$var$mi, t.bounceOut = $af62ec6a841e10b9$var$bi, t.bounceInOut = $af62ec6a841e10b9$var$_i, t.getElasticIn = $af62ec6a841e10b9$var$wi, t.elasticIn = $af62ec6a841e10b9$var$Pi, t.getElasticOut = $af62ec6a841e10b9$var$Ei, t.elasticOut = $af62ec6a841e10b9$var$Oi, t.getElasticInOut = $af62ec6a841e10b9$var$Si, t.elasticInOut = $af62ec6a841e10b9$var$Ti, t;
}(), $af62ec6a841e10b9$var$Ri = function() {
    function t() {
        this.cursor = -1, this.widgets = [], this.instances = [], this.model = {
            id: -1,
            type: $af62ec6a841e10b9$export$6ba26ae1c58c0147.NONE,
            sourceId: -1,
            author: null,
            originalAuthor: null,
            className: null,
            createdDate: null
        };
    }
    return Object.defineProperty(t.prototype, "id", {
        get: function() {
            return this.model ? this.model.id : -1;
        },
        enumerable: !1,
        configurable: !0
    }), Object.defineProperty(t.prototype, "script", {
        get: function() {
            return this.model ? this.model.script : null;
        },
        enumerable: !1,
        configurable: !0
    }), t;
}(), $af62ec6a841e10b9$var$Ci = function() {}, $af62ec6a841e10b9$var$Ni = function() {
    function t(t, e) {
        this.onTemplateLoad = e, this._emitter = null, this._loaded = null, this._loading = null, this.verbose = !1, this._emitter = t, this.clear();
    }
    return Object.defineProperty(t.prototype, "loaded", {
        get: function() {
            return this._loaded;
        },
        enumerable: !1,
        configurable: !0
    }), Object.defineProperty(t.prototype, "loading", {
        get: function() {
            return this._loading;
        },
        enumerable: !1,
        configurable: !0
    }), t.prototype.clear = function() {
        this._loaded = {}, this._loading = {};
    }, t.prototype.loadLatest = function(t) {
        return void 0 === t && (t = 100), $af62ec6a841e10b9$var$yn(this, 0, void 0, function() {
            var e;
            return $af62ec6a841e10b9$var$gn(this, function(r) {
                switch(r.label){
                    case 0:
                        return [
                            4,
                            $af62ec6a841e10b9$var$q.list({
                                maxResults: t,
                                withoutAuthors: !0,
                                withoutOriginalAuthors: !0,
                                script: !0
                            })
                        ];
                    case 1:
                        return (e = r.sent()) && e.list ? (this.verbose && console.log("--- loading template classes ---"), [
                            2,
                            this.registerMany(e.list)
                        ]) : [
                            2
                        ];
                }
            });
        });
    }, t.prototype.loadForVideo = function(t) {
        return $af62ec6a841e10b9$var$yn(this, 0, void 0, function() {
            var e, r = this;
            return $af62ec6a841e10b9$var$gn(this, function(n) {
                switch(n.label){
                    case 0:
                        return [
                            4,
                            $af62ec6a841e10b9$var$q.loadForVideo(t)
                        ];
                    case 1:
                        return (e = n.sent()) && e.list ? (this.verbose && console.log("--- loading template classes for vid:".concat(t, " ---")), [
                            4,
                            this.registerMany(e.list)
                        ]) : [
                            2,
                            null
                        ];
                    case 2:
                        return [
                            2,
                            n.sent().map(function(t) {
                                return t ? r.getByName(t) : null;
                            })
                        ];
                }
            });
        });
    }, t.prototype.loadByNames = function(t) {
        return $af62ec6a841e10b9$var$yn(this, 0, void 0, function() {
            var e, r = this;
            return $af62ec6a841e10b9$var$gn(this, function(n) {
                switch(n.label){
                    case 0:
                        return !Array.isArray(t) || t.length <= 0 ? [
                            2,
                            []
                        ] : (this.verbose && console.log("--- loading template classes ---"), [
                            4,
                            Promise.all(t.map(function(t) {
                                return r.doLoadByName(t);
                            }))
                        ]);
                    case 1:
                        return (e = n.sent()) && this._emitter.onTemplatesLoad(e.filter(function(t) {
                            return !!t;
                        }).map(function(t) {
                            return t.className;
                        })), [
                            2,
                            e
                        ];
                }
            });
        });
    }, t.prototype.loadByName = function(t) {
        return $af62ec6a841e10b9$var$yn(this, 0, void 0, function() {
            var e, r;
            return $af62ec6a841e10b9$var$gn(this, function(n) {
                switch(n.label){
                    case 0:
                        return n.trys.push([
                            0,
                            2,
                            ,
                            3
                        ]), [
                            4,
                            this.doLoadByName(t)
                        ];
                    case 1:
                        return e = n.sent(), this._emitter.onTemplatesLoad([
                            e.className
                        ]), [
                            2,
                            e
                        ];
                    case 2:
                        return r = n.sent(), this._emitter.onTemplatesLoad(null, r), [
                            2,
                            null
                        ];
                    case 3:
                        return [
                            2
                        ];
                }
            });
        });
    }, t.prototype.doLoadByName = function(t) {
        return $af62ec6a841e10b9$var$yn(this, 0, void 0, function() {
            var e, r, n = this;
            return $af62ec6a841e10b9$var$gn(this, function(i) {
                return null !== (e = this.getByName(t)) ? [
                    2,
                    e
                ] : this._loading[t] ? [
                    2,
                    this._loading[t]
                ] : (r = new Promise(function(e) {
                    return $af62ec6a841e10b9$var$q.loadByName(t).then(function(t) {
                        return n.onTemplateLoad(t);
                    }).then(e);
                }), this._loading[t] = r, r.finally(function() {
                    return delete n._loading[t];
                }), [
                    2,
                    r
                ]);
            });
        });
    }, t.prototype.loadById = function(t) {
        return $af62ec6a841e10b9$var$yn(this, 0, void 0, function() {
            var e, r, n;
            return $af62ec6a841e10b9$var$gn(this, function(i) {
                switch(i.label){
                    case 0:
                        return i.trys.push([
                            0,
                            2,
                            ,
                            3
                        ]), [
                            4,
                            this.doLoadById(t)
                        ];
                    case 1:
                        return e = i.sent(), r = null, [
                            3,
                            3
                        ];
                    case 2:
                        return n = i.sent(), r = n, [
                            3,
                            3
                        ];
                    case 3:
                        return this._emitter.onTemplatesLoad(e ? [
                            e.className
                        ] : null, r), [
                            2,
                            e
                        ];
                }
            });
        });
    }, t.prototype.doLoadById = function(t) {
        return $af62ec6a841e10b9$var$yn(this, 0, void 0, function() {
            var e, r, n = this;
            return $af62ec6a841e10b9$var$gn(this, function(i) {
                return (e = this.getById(t)) ? [
                    2,
                    e
                ] : this._loading[t] ? [
                    2,
                    this._loading[t]
                ] : (r = new Promise(function(e) {
                    return $af62ec6a841e10b9$var$q.load(t).then(function(t) {
                        return n.onTemplateLoad(t);
                    }).then(e);
                }), this._loading[t] = r, r.finally(function() {
                    return delete n._loading[t];
                }), [
                    2,
                    r
                ]);
            });
        });
    }, t.prototype.registerMany = function(t) {
        return $af62ec6a841e10b9$var$yn(this, 0, void 0, function() {
            var e, r, n = this;
            return $af62ec6a841e10b9$var$gn(this, function(i) {
                switch(i.label){
                    case 0:
                        return e = t.map(function(t) {
                            var e = n.onTemplateLoad(t);
                            return n._loading[t.className] = e, n._loading["".concat(t.className, "@").concat(t.id)] = e, e;
                        }), [
                            4,
                            Promise.all(e.map(function(t) {
                                return t.then(function(t) {
                                    return t.className;
                                }).catch(function(t) {
                                    return null;
                                });
                            }))
                        ];
                    case 1:
                        return r = i.sent().filter(function(t) {
                            return !!t;
                        }), this._emitter.onTemplatesLoad(r), [
                            2,
                            r
                        ];
                }
            });
        });
    }, t.prototype.commit = function(t, e) {
        return $af62ec6a841e10b9$var$yn(this, 0, void 0, function() {
            var r;
            return $af62ec6a841e10b9$var$gn(this, function(n) {
                switch(n.label){
                    case 0:
                        return [
                            4,
                            $af62ec6a841e10b9$var$q.create({
                                sourceId: t.model.sourceId,
                                script: t.model.script,
                                log: e
                            })
                        ];
                    case 1:
                        return (r = n.sent()).success && (t.model.id = r.id, this._emitter.onTemplateCommit(t.className)), [
                            2,
                            r
                        ];
                }
            });
        });
    }, t.prototype.getByName = function(t, e) {
        var r;
        if (void 0 === e && (e = !1), t && (r = t.match(/(.+)@([0-9]+)/))) {
            t = r[1];
            var n = parseInt(r[2]);
            if (!this._loaded[t]) return null;
            var i = this._loaded[t].model;
            if (i.id !== n) {
                if (!e) return null;
                this.verbose && console.log("[warning] template ".concat(t, " version ").concat(n, " is requested but ").concat(i.id, " is used"));
            }
        }
        return this._loaded[t] ? this._loaded[t] : null;
    }, t.prototype.getById = function(t) {
        var e = null;
        for(var r in this._loaded)if (this._loaded[r].model.id === t) {
            e = this._loaded[r];
            break;
        }
        return e;
    }, t;
}(), $af62ec6a841e10b9$var$ki = {
    Matrix2D: $af62ec6a841e10b9$export$26e6ecd136a15474,
    Point: $af62ec6a841e10b9$export$baf26146a414f24a,
    Color: $af62ec6a841e10b9$export$892596cec99bc70e,
    Font: $af62ec6a841e10b9$var$Z,
    RenderingUnit: $af62ec6a841e10b9$var$K,
    TextUnit: $af62ec6a841e10b9$var$et,
    Graphic: $af62ec6a841e10b9$var$nt,
    Phrase: $af62ec6a841e10b9$var$ot,
    Word: $af62ec6a841e10b9$var$it,
    Char: $af62ec6a841e10b9$var$rt,
    Beat: $af62ec6a841e10b9$var$Nn,
    RepetitiveSegment: $af62ec6a841e10b9$var$jn
}, $af62ec6a841e10b9$var$ji = [
    "headTime",
    "tailTime",
    "insomnia"
], $af62ec6a841e10b9$var$Ii = [
    "animate",
    "getAssignedUnit",
    "name",
    "type"
], $af62ec6a841e10b9$var$Ui = function() {
    function t(t, e, r) {
        this._emitter = null, this._player = null, this.interpreter = null, this.unsafeAcceleration = !1, this._verbose = !1, this.ignoreVersion = !1, this.rawConsole = !1, this._player = t, this._emitter = e, this.unsafeAcceleration = r, this.loader = new $af62ec6a841e10b9$var$Ni(e, this.register.bind(this)), t.addListener({
            onVideoReady: this.onVideoReady.bind(this)
        });
    }
    return Object.defineProperty(t.prototype, "verbose", {
        get: function() {
            return this._verbose;
        },
        set: function(t) {
            this._verbose = this.loader.verbose = t;
        },
        enumerable: !1,
        configurable: !0
    }), Object.defineProperty(t.prototype, "ready", {
        get: function() {
            return !!this.interpreter;
        },
        enumerable: !1,
        configurable: !0
    }), Object.defineProperty(t.prototype, "loaded", {
        get: function() {
            return this.loader.loaded;
        },
        enumerable: !1,
        configurable: !0
    }), t.prototype.initialize = function() {
        var t = this;
        if (!this.ready) {
            var e = function(t) {
                var e = t.player, r = t.ignoredPropNames, i = t.rawConsole, o = t.templateGetter, s = e.graphics.wrapperTable, a = new $af62ec6a841e10b9$var$cn($af62ec6a841e10b9$var$fn($af62ec6a841e10b9$var$fn({}, $af62ec6a841e10b9$var$ki), s), r, function(t, r) {
                    return e.graphics.isGraphics(t) && r instanceof $af62ec6a841e10b9$export$892596cec99bc70e ? r.toString() : r;
                }), u = {
                    require: {
                        func: function(t) {
                            if (!(t.length < 1 || "string" != typeof t[0])) {
                                var e = t[0], r = o(e);
                                return null === r ? void 0 : r.functionDefinition;
                            }
                        },
                        raw: !0,
                        isConstructor: !0
                    },
                    print: {
                        func: function(t) {
                            e.isEditing && console.log.apply(console, t);
                        },
                        raw: i
                    },
                    findChorus: {
                        func: function(t) {
                            return t.length < 1 || "number" != typeof t[0] ? null : e.findChorus(t[0]);
                        }
                    },
                    findBeat: {
                        func: function(t) {
                            return t.length < 1 || "number" != typeof t[0] ? null : e.findBeat(t[0]);
                        }
                    },
                    getVocalFrequency: {
                        func: function(t) {
                            return t.length < 1 || "number" != typeof t[0] ? null : e.getVocalFrequency(t[0]);
                        }
                    },
                    getVocalAmplitude: {
                        func: function(t) {
                            return t.length < 1 || "number" != typeof t[0] ? -1 : e.getVocalAmplitude(t[0]);
                        }
                    },
                    getMaxVocalAmplitude: {
                        func: function(t) {
                            return e.getMaxVocalAmplitude();
                        }
                    },
                    getValenceArousal: {
                        func: function(t) {
                            return t.length < 1 || "number" != typeof t[0] ? null : e.getValenceArousal(t[0]);
                        }
                    },
                    getMedianValenceArousal: {
                        func: function(t) {
                            return e.getMedianValenceArousal();
                        }
                    }
                };
                Object.keys($af62ec6a841e10b9$export$6ba26ae1c58c0147).forEach(function(t) {
                    a.setProperty(a.globalScope, t, $af62ec6a841e10b9$export$6ba26ae1c58c0147[t]), u[t] = {
                        value: $af62ec6a841e10b9$export$6ba26ae1c58c0147[t]
                    };
                }), Object.keys($af62ec6a841e10b9$var$xi).forEach(function(t) {
                    var e = $af62ec6a841e10b9$var$xi[t];
                    0 !== t.indexOf("get") && (u[t] = {
                        func: e
                    });
                });
                var c = Object.keys(a.wrapperTable);
                return c && c.forEach(function(t) {
                    return u[t] = {
                        cls: a.wrapperTable[t]
                    };
                }), Object.keys(u).forEach(function(t) {
                    var e = u[t];
                    e.func ? a.createGlobalFunction(t, e) : e.value && a.setProperty(a.globalScope, t, e.value);
                }), {
                    interpreter: a,
                    unsafeGlobalScope: u
                };
            }({
                player: this._player,
                ignoredPropNames: $af62ec6a841e10b9$var$Ii,
                rawConsole: this.rawConsole,
                templateGetter: function(e) {
                    return t.getByName(e, !0);
                }
            }), r = e.interpreter, i = e.unsafeGlobalScope;
            this.unsafeGlobalScope = i, this.interpreter = r, this.onVideoReady(this._player.video);
        }
    }, t.prototype.getByName = function(t, e) {
        return void 0 === e && (e = !1), this.loader.getByName(t, e);
    }, t.prototype.getById = function(t) {
        return this.loader.getById(t);
    }, t.prototype.clear = function() {
        this.loader.clear();
    }, t.prototype.loadLatest = function(t) {
        return void 0 === t && (t = 100), $af62ec6a841e10b9$var$yn(this, 0, void 0, function() {
            return $af62ec6a841e10b9$var$gn(this, function(e) {
                return this.ready || this.initialize(), [
                    2,
                    this.loader.loadLatest(t)
                ];
            });
        });
    }, t.prototype.loadForVideo = function(t) {
        return $af62ec6a841e10b9$var$yn(this, 0, void 0, function() {
            return $af62ec6a841e10b9$var$gn(this, function(e) {
                return this.ready || this.initialize(), [
                    2,
                    this.loader.loadForVideo(t)
                ];
            });
        });
    }, t.prototype.loadByNames = function(t) {
        return $af62ec6a841e10b9$var$yn(this, 0, void 0, function() {
            return $af62ec6a841e10b9$var$gn(this, function(e) {
                return this.ready || this.initialize(), [
                    2,
                    this.loader.loadByNames(t)
                ];
            });
        });
    }, t.prototype.loadByName = function(t) {
        return $af62ec6a841e10b9$var$yn(this, 0, void 0, function() {
            return $af62ec6a841e10b9$var$gn(this, function(e) {
                return this.ready || this.initialize(), [
                    2,
                    this.loader.loadByName(t)
                ];
            });
        });
    }, t.prototype.loadById = function(t) {
        return $af62ec6a841e10b9$var$yn(this, 0, void 0, function() {
            return $af62ec6a841e10b9$var$gn(this, function(e) {
                return this.ready || this.initialize(), [
                    2,
                    this.loader.loadById(t)
                ];
            });
        });
    }, t.prototype.commit = function(t, e) {
        return $af62ec6a841e10b9$var$yn(this, 0, void 0, function() {
            return $af62ec6a841e10b9$var$gn(this, function(r) {
                return [
                    2,
                    this.loader.commit(t, e)
                ];
            });
        });
    }, t.prototype.register = function(t) {
        return $af62ec6a841e10b9$var$yn(this, 0, void 0, function() {
            var e, r, n, i, o, s, a = this;
            return $af62ec6a841e10b9$var$gn(this, function(u) {
                switch(u.label){
                    case 0:
                        if (!t) return [
                            2,
                            null
                        ];
                        if ("number" == typeof t.sourceId) {
                            if (e = t, !(r = this.createClass(t.script))) return [
                                2,
                                null
                            ];
                        } else r = t;
                        n = $af62ec6a841e10b9$var$nn(r.ast).dependencies, u.label = 1;
                    case 1:
                        return u.trys.push([
                            1,
                            3,
                            ,
                            4
                        ]), [
                            4,
                            Promise.all(n.map(function(t) {
                                var e = a.getByName(t, a.ignoreVersion);
                                return e ? Promise.resolve(e) : a.loadByName(t);
                            }))
                        ];
                    case 2:
                        return u.sent(), this.verbose && console.log("load dependencies for", r.className, n), [
                            3,
                            4
                        ];
                    case 3:
                        return i = u.sent(), this.verbose && console.error("failed loading dependencies for", r.className, i), [
                            3,
                            4
                        ];
                    case 4:
                        try {
                            if (!(e ? this.loadModel(r, e) : this.createModel(r))) throw new Error("failed to create a template instance");
                            return [
                                2,
                                this.registerClass(r)
                            ];
                        } catch (t) {
                            throw o = void 0, e && (delete (s = $af62ec6a841e10b9$var$fn({}, e)).script, o = s), {
                                error: t.message,
                                stack: t.stack,
                                cause: o
                            };
                        }
                        return [
                            2
                        ];
                }
            });
        });
    }, t.prototype.updateClassScript = function(t, e) {
        var r = this.createClass(e);
        return this.updateClass(t, r);
    }, t.prototype.registerClass = function(t) {
        if (!t) return null;
        if (this.loader.loaded[t.className]) {
            this.verbose && console.log("updating", t.className, t.model.id);
            var e = this.updateClass(this.loader.loaded[t.className], t);
            return this.verbose && console.log("updated", e.className, e.id), e;
        }
        return this.loader.loaded[t.className] = t, this.verbose && console.log("loaded", t.className, t.model.id), t;
    }, t.prototype.updateClass = function(t, e) {
        var r = t, n = e;
        if (!n) return null;
        if (r.model.script === n.model.script) return this.verbose && console.log("no diff for", r.className), r;
        if (!this.createModel(n)) return null;
        if (r.className !== n.className) {
            var i = this.getByName(n.className);
            if (!i) return n.cursor = r.cursor, this.loader.loaded[n.className] = n, this.verbose && console.log("create", n.className), n;
            r = i;
        }
        return r.newStatement = n.newStatement, r.widgets = n.widgets, r.scope = n.scope, r.functionDefinition = n.functionDefinition, r.newStatement = n.newStatement, r.unsafeConstructorGenerator = n.unsafeConstructorGenerator, r.ast = n.ast, r.cursor < 0 && (r.cursor = n.cursor), n.id >= 0 ? (this.verbose && console.log("replace", n.className, r.id, n.id), r.model = n.model) : (this.verbose && console.log("update", n.className, r.id, n.id), r.model.type = n.model.type, r.model.className = n.model.className, r.model.prettyName = n.model.prettyName, r.model.script = n.model.script, r.model.createdDate = null, r.id >= 0 && (r.model.sourceId = r.model.id, r.model.id = -1)), n = r, this.updateInstances(r.instances.slice(), n), this._emitter.onTemplateUpdate(n.className), n;
    }, t.prototype.loadModel = function(t, e) {
        var r = this.newRawInstance(t);
        return t.model = e, this.updateWidgetInitialValues(t, r), r;
    }, t.prototype.createModel = function(t) {
        var e = this.newRawInstance(t);
        if (null === e) return !1;
        if (t.id >= 0) return !0;
        var r = e.templateInstance, n = t.model.script;
        return t.model = {
            id: -1,
            sourceId: -1,
            className: t.className,
            prettyName: r ? this.interpreter.getProperty(r, "name") : e.unsafeTemplateInstance.name,
            type: r ? this.interpreter.getProperty(r, "type") : e.unsafeTemplateInstance.type,
            script: n,
            author: null,
            originalAuthor: null,
            createdDate: null
        }, this.updateWidgetInitialValues(t, e), e;
    }, t.prototype.updateWidgetInitialValues = function(t, e) {
        var r = this;
        t.widgets.forEach(function(t) {
            t.initialValue = r.getProperty(e, t.name);
        });
    }, t.prototype.updateInstances = function(t, e) {
        var r = this;
        t.forEach(function(t) {
            try {
                r.updateInstance(t, e);
            } catch (r) {
                console.log("failed updating template for", t.assignedUnit, ":", e);
            }
        }), this._player.isPlaying || this._player.requestStageUpdate();
    }, t.prototype.createClass = function(t) {
        var e = this;
        this.ready || this.initialize();
        var r = new $af62ec6a841e10b9$var$Ri;
        r.model = {
            id: -1,
            sourceId: -1,
            className: null,
            prettyName: null,
            type: 0,
            script: t,
            author: null,
            originalAuthor: null,
            createdDate: null
        };
        var n = $af62ec6a841e10b9$var$rn(t, $af62ec6a841e10b9$var$Ii), i = n.ast, o = n.widgets;
        if (r.ast = i, r.widgets = o, r.className = r.ast.body[0].id.name, r.scope = this.interpreter.prepareRun(r.ast), this.interpreter.run(1e3, "to define " + r.className), r.functionDefinition = this.interpreter.getRawProperty(r.scope, r.className), r.newStatement = this.interpreter.newStatementFor(r.className), this.unsafeAcceleration) {
            var s = Object.keys(this.unsafeGlobalScope), a = Object.keys(this.getGlobalProperties()).map(function(t) {
                return "".concat(t, "=props.").concat(t);
            }).join(","), u = "return function(props){var ".concat(a, ";").concat(t, "return ").concat(r.className, ";}"), c = new (Function.bind.apply(Function, $af62ec6a841e10b9$var$vn($af62ec6a841e10b9$var$vn([
                void 0
            ], s, !1), [
                u
            ], !1))), l = function(t) {
                var r = e.getByName(t);
                return r ? r.unsafeConstructorGenerator(e.getGlobalProperties()) : null;
            }, p = s.map(function(t) {
                if ("require" === t) return l;
                var r = e.unsafeGlobalScope[t];
                return r.func ? function() {
                    for(var t = [], e = 0; e < arguments.length; e++)t[e] = arguments[e];
                    return r.func(t);
                } : r.cls || r.value;
            });
            r.unsafeConstructorGenerator = c.apply({}, p);
        }
        return r;
    }, t.prototype.getGlobalProperties = function() {
        var t;
        return {
            width: this._player.videoWidth,
            height: this._player.videoHeight,
            margin: this._player.margin,
            duration: (null === (t = this._player.video) || void 0 === t ? void 0 : t.duration) || 0
        };
    }, t.prototype.newRawInstance = function(t) {
        var e = t, r = new $af62ec6a841e10b9$var$Ci;
        if (this.unsafeAcceleration) {
            var n = new (e.unsafeConstructorGenerator(this.getGlobalProperties()));
            r.unsafeTemplateInstance = n;
        } else {
            this.interpreter.prepareNewInstance(e.newStatement, e.scope);
            var i = this.interpreter.run(700, "to instantiate " + e.className);
            r.templateInstance = i, r.templateInstance._nativeInstance = r;
        }
        return r.templateClass = e, r.ignore = !1, r;
    }, t.prototype.setProperty = function(t, e, r) {
        this.unsafeAcceleration ? t.unsafeTemplateInstance[e] = r : this.interpreter.setProperty(t.templateInstance, e, r);
    }, t.prototype.getProperty = function(t, e) {
        return this.unsafeAcceleration ? t.unsafeTemplateInstance[e] : this.interpreter.getProperty(t.templateInstance, e);
    }, t.prototype.exportInstance = function(t) {
        for(var e = {}, r = 0, n = t.templateClass.widgets.map(function(t) {
            return t.name;
        }).concat($af62ec6a841e10b9$var$ji); r < n.length; r++){
            var i = n[r], o = this.getProperty(t, i);
            try {
                var s = $af62ec6a841e10b9$var$gt(o);
                void 0 !== s && (e[i] = s);
            } catch (e) {
                console.error("cannot export ".concat(t.templateClass.className, ".").concat(i), o, "assigned to", t.assignedUnit);
            }
        }
        return {
            type: t.templateClass.className,
            value: e
        };
    }, t.prototype.importInstances = function(t, e) {
        try {
            this.importPhraseTemplates(t.firstCredit, e.credits), this.importPhraseTemplates(t.firstPhrase, e.phrases);
            for(var r = e.graphics, n = t.firstGraphic, i = 0; null !== n;){
                var o = r[i++];
                this.importTemplates(n, o.templates), n = n.next;
            }
        } catch (t) {
            return console.error("restoring templates failed", t), !1;
        }
        return !0;
    }, t.prototype.importPhraseTemplates = function(t, e) {
        if (Array.isArray(e)) for(var r = 0; t;){
            var n = e[r++];
            this.importTemplates(t, n.templates);
            for(var i = t.firstWord, o = 0; o < t.wordCount; o++){
                var s = n.words[o];
                this.importTemplates(i, s.templates);
                for(var a = i.firstChar, u = 0; u < i.charCount; u++){
                    var c = s.characters[u];
                    this.importTemplates(a, c.templates), a = a.next;
                }
                i = i.next;
            }
            if (e.length < r + 1) break;
            t = t.next;
        }
    }, t.prototype.importTemplates = function(t, e) {
        if (Array.isArray(e)) for(var r = 0, n = e; r < n.length; r++){
            var i = n[r], o = this.importInstance(i);
            o && t.addTemplate(o);
        }
    }, t.prototype.importInstance = function(t) {
        var e = this.getByName(t.type), r = this.newInstance(e);
        if (!r || !t.value) return null;
        for(var n = 0, i = Object.keys(t.value); n < i.length; n++){
            var o = i[n], s = $af62ec6a841e10b9$var$vt(t.value[o], this.interpreter.wrapperTable);
            void 0 !== s && this.setProperty(r, o, s);
        }
        return r;
    }, t.prototype.updateInstance = function(t, e) {
        var r = t, n = e, i = this.newRawInstance(n), o = r.templateInstance, s = this.interpreter.cleanupProperties(o);
        r.templateClass !== n && (this.disposeInstance(r), n.instances.push(r)), r.templateClass = n, r.scope = i.scope, r.templateInstance = i.templateInstance, r.ignore = i.ignore, this.interpreter.restoreProperties(r.templateInstance, s), this.attachGetAssignedUnitMethod(r);
    }, t.prototype.newInstance = function(t) {
        var e;
        try {
            if (null === (e = this.newRawInstance(t))) return null;
        } catch (t) {
            return null;
        }
        return this.attachGetAssignedUnitMethod(e), t.instances.push(e), e;
    }, t.prototype.attachGetAssignedUnitMethod = function(t) {
        var e = this;
        if (this.unsafeAcceleration) t.unsafeTemplateInstance.getAssignedUnit = function() {
            return t.assignedUnit;
        };
        else {
            var r = this.interpreter.createFunction(function() {
                return e.interpreter.wrap(t.assignedUnit);
            });
            this.interpreter.setRawProperty(t.templateInstance, "getAssignedUnit", r);
        }
    }, t.prototype.disposeInstance = function(t) {
        var e = t.templateClass;
        e.instances = e.instances.filter(function(e) {
            return e !== t;
        });
    }, t.prototype.disposeInstances = function(t) {
        var e = this;
        if (Array.isArray(t)) t.forEach(function(t) {
            return e.disposeInstance(t);
        });
        else {
            var r = t;
            [
                r.firstCredit,
                r.firstPhrase,
                r.firstWord,
                r.firstChar,
                r.firstGraphic
            ].forEach(function(t) {
                for(; t;)e.disposeInstances(t.removeTemplates()), t = t.next;
            });
        }
    }, t.prototype.setTemplate = function(t, e) {
        this.removeTemplates(t), t.addTemplate(e);
    }, t.prototype.clearTemplate = function(t) {
        this.removeTemplates(t);
    }, t.prototype.removeTemplateAt = function(t, e) {
        var r = t.removeTemplateAt(e);
        r && this.disposeInstance(r);
    }, t.prototype.removeTemplates = function(t) {
        var e = t.removeTemplates();
        this.disposeInstances(e);
    }, t.prototype.getRequiredTemplates = function(t) {
        return $af62ec6a841e10b9$var$nn(t).dependencies;
    }, t.prototype.getRequiredTemplateAt = function(t, e) {
        return $af62ec6a841e10b9$var$nn(t, e).dependencyAtCursor;
    }, t.prototype.exec = function(t, e, r) {
        if (t.unsafeTemplateInstance) {
            var n = t.unsafeTemplateInstance;
            return n[e].apply(n, r);
        }
        var i = this.interpreter.exec(t.templateInstance, e, r, t.assignedUnit ? " assigned to " + t.assignedUnit.toString() : "");
        return this.interpreter.unwrap(i);
    }, t.prototype.declareVariable = function(t, e, r, n) {
        return this.updateClassScript(t, function(t, e, r, n) {
            try {
                var i = $af62ec6a841e10b9$var$rn(t), o = i.ast, s = i.fields, a = s[s.length - 1], u = t.match(/(\r\n|[\n\v\f\r\x85\u2028\u2029])/), c = u ? u.pop() : "\n", l = t.split(c), p = a ? Array(a.loc.start.column + 1).join(" ") : "  ", h = a ? a.loc.end.line : 0;
                if (h <= 0) {
                    var d = o.body[0].body, f = l[d.loc.start.line - 1], y = f.substring(0, d.loc.start.column + 1), g = f.substring(d.loc.start.column + 1);
                    l[d.loc.start.line - 1] = y, l.splice(d.loc.start.line, 0, g), h = d.loc.start.line;
                }
                for(var v = void 0; (v = "var" + Math.random().toString().substring(2)).length > 8 && (v = v.substring(0, 8)), !(t.indexOf(v) < 0););
                l.length > h && l[h].length > 0 && l.splice(h, 0, ""), l.splice(h, 0, "", p + "// @proposed", p + "// @title " + e, p + "// " + function(t, e) {
                    if ("Slider" === t) return "@ui Slider(" + e.min + ", " + e.max + ")";
                    if ("Check" === t) return "@ui Check()";
                    if ("Color" === t) return "@ui Color()";
                    var r = e.etc;
                    return "@comment " + (r = r.replace(/(\r\n|[\n\v\f\r\x85\u2028\u2029])/g, "")).replace(/\/[*/]/g, "");
                }(r, n), p + "this." + v + " = " + function(t, e) {
                    return "Slider" === t ? ((e.min + e.max) / 2).toString() : "Check" === t ? "false" : "Color" === t ? 'new Color("#000000")' : "null";
                }(r, n) + ";"), t = l.join(c);
            } catch (t) {}
            return t;
        }(t.model.script, e, r, n));
    }, t.prototype.onVideoReady = function(t) {
        this.ready && (this.interpreter.setRawProperty(this.interpreter.globalScope, "width", this._player.resolutionWidth), this.interpreter.setRawProperty(this.interpreter.globalScope, "height", this._player.resolutionHeight), this.interpreter.setRawProperty(this.interpreter.globalScope, "margin", this.interpreter.wrap(this._player.margin)), this.interpreter.setRawProperty(this.interpreter.globalScope, "duration", (null == t ? void 0 : t.duration) || 0));
    }, t;
}(), $af62ec6a841e10b9$export$ff76868b9ee07b99 = '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 200 200"><defs><style>.bg{fill:#1f4391;}.fg{fill:#fff;}</style></defs><g class="logo-sq"><rect class="bg" x="-20" y="-20" width="240" height="240"/><g class="textalive-logo-art"><path class="fg" d="M97.33,130.81V142a3,3,0,0,0,4.78,2.41l56.81-42.09a3,3,0,0,0,0-4.81l-8.33-6.14Z"/><path class="fg" d="M137.14,81.43l-35-25.84A3,3,0,0,0,97.33,58v52.92Z"/><path class="fg" d="M51,55H80.33a2,2,0,0,1,2,2V71.67a0,0,0,0,1,0,0H51a2,2,0,0,1-2-2V57A2,2,0,0,1,51,55Z"/><path class="fg" d="M44.83,107.5h56.33a2,2,0,0,1,2,2v12.67a2,2,0,0,1-2,2H44.83a0,0,0,0,1,0,0V107.5A0,0,0,0,1,44.83,107.5Z" transform="translate(189.83 41.84) rotate(90)"/></g></g></svg>', $af62ec6a841e10b9$var$Li = "https://textalive.jp", $af62ec6a841e10b9$var$Di = function() {
    function t(t) {
        var e, r = this;
        if (this.player = t, this._position = "embed", this._rounded = !1, this._bordered = !1, this._shadowed = !1, this._background = "#fff", this._color = "#1f4391", void 0 !== (null === (e = t.options) || void 0 === e ? void 0 : e.mediaBannerPosition) && (this._position = t.options.mediaBannerPosition), this.domEnabled) {
            this.logoAnchor = document.createElement("a"), this.logoAnchor.className = "textalive-logo", this.logoAnchor.innerHTML = $af62ec6a841e10b9$export$ff76868b9ee07b99, this.logoAnchor.style.padding = this.bordered ? "1px 2px" : "1px 3px", this.logoAnchor.href = $af62ec6a841e10b9$var$Li, this.logoAnchor.target = "_blank", this.logoAnchor.title = "Powered by TextAlive App API", this.logoSvg = this.logoAnchor.querySelector("svg"), this.logoSvg.style.width = "24px", this.songNameDiv = document.createElement("div"), this.songNameDiv.className = "name", this.songNameDiv.style.fontWeight = "bold", this.songNameDiv.style.overflow = "hidden", this.songNameDiv.style.textOverflow = "ellipsis", this.songNameDiv.style.marginBottom = "2px", this.songNameDiv.textContent = "-", this.songArtistDiv = document.createElement("div"), this.songArtistDiv.className = "artist", this.songArtistDiv.textContent = "-", this.songArtistDiv.style.overflow = "hidden", this.songArtistDiv.style.textOverflow = "ellipsis";
            var n = document.createElement("span");
            n.innerHTML = '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 150 150"><g class="song"><path d="M120.95,45.77l-59.12,13a2.57,2.57,0,0,0-2,2.51v47.8c0,13.61-12.4,23.74-24.2,23.74-8.92,0-14.82-4.23-14.82-13,0-13,12.86-21.93,23.9-21.93a16.33,16.33,0,0,1,10,3V35a2.57,2.57,0,0,1,2-2.51l69.41-15.29a2.57,2.57,0,0,1,3.13,2.51V92.84c0,13.61-12.1,23.9-24.2,23.9-8.92,0-14.82-4.24-14.82-13,0-13.16,12.86-21.93,23.9-21.93a16.31,16.31,0,0,1,10,2.87V48.29A2.57,2.57,0,0,0,120.95,45.77Z"/><path d="M35.61,134.36c-10.22,0-16.32-5.42-16.32-14.51,0-13.81,13.38-23.43,25.4-23.43a18.4,18.4,0,0,1,8.48,1.88V35a4,4,0,0,1,3.2-4l69.41-15.29a4.07,4.07,0,0,1,5,4V92.83c0,15-13.54,25.4-25.7,25.4-10.22,0-16.32-5.42-16.32-14.51,0-13.81,13.38-23.43,25.4-23.43A19,19,0,0,1,122.57,82V48.29a1.07,1.07,0,0,0-1.3-1h0l-59.12,13a1.08,1.08,0,0,0-.84,1v47.8C61.3,124,47.76,134.36,35.61,134.36Zm9.07-34.94c-10.57,0-22.4,8.74-22.4,20.43,0,10,8.35,11.51,13.32,11.51,13.38,0,22.7-11.72,22.7-22.24V61.31a4.1,4.1,0,0,1,3.2-4l59.12-13h0a4.07,4.07,0,0,1,5,4V87.56l-2.37-1.67a14.88,14.88,0,0,0-9.12-2.6c-10.59,0-22.4,8.39-22.4,20.43,0,10,8.35,11.51,13.32,11.51,10.74,0,22.7-9.2,22.7-22.4V19.72a1.07,1.07,0,0,0-1.3-1L57,34a1.07,1.07,0,0,0-.84,1v68.83l-2.37-1.67A14.87,14.87,0,0,0,44.68,99.42Z"/></g></svg>', n.style.padding = "0 3px 0 0", this.songSvg = n.querySelector("svg"), this.songSvg.style.width = "14px", this.songWrapper = document.createElement("div"), this.songWrapper.style.width = "203px", this.songWrapper.style.maxWidth = "203px", this.songWrapper.appendChild(this.songNameDiv), this.songWrapper.appendChild(this.songArtistDiv), this.songAnchor = document.createElement("a"), this.songAnchor.className = "song", this.songAnchor.target = "_blank", this.songAnchor.style.display = "flex", this.songAnchor.style.lineHeight = "1.2em", this.songAnchor.style.padding = "4px 3px 3px 3px", this.songAnchor.style.textDecoration = "none", this.songAnchor.appendChild(n), this.songAnchor.appendChild(this.songWrapper), this.lyricsNameDiv = document.createElement("div"), this.lyricsNameDiv.className = "name", this.lyricsNameDiv.style.fontWeight = "bold", this.lyricsNameDiv.textContent = "-", this.lyricsNameDiv.style.overflow = "hidden", this.lyricsNameDiv.style.textOverflow = "ellipsis", this.lyricsNameDiv.style.marginBottom = "2px", this.lyricsArtistDiv = document.createElement("div"), this.lyricsArtistDiv.className = "artist", this.lyricsArtistDiv.textContent = "-", this.lyricsArtistDiv.style.overflow = "hidden", this.lyricsArtistDiv.style.textOverflow = "ellipsis";
            var i = document.createElement("span");
            i.innerHTML = '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 150 150"><g class="lyrics"><path d="M78,126.3H67.52l-6.26-23.82H24.4L18.14,126.3H7.7L35.7,22H50ZM27,92.39H58.65l-15.82-61Z"/><path d="M78,128.3H67.52a2,2,0,0,1-1.93-1.49l-5.87-22.33H25.94l-5.87,22.33a2,2,0,0,1-1.93,1.49H7.7a2,2,0,0,1-1.93-2.52l28-104.34A2,2,0,0,1,35.7,20H50a2,2,0,0,1,1.93,1.48l28,104.34A2,2,0,0,1,78,128.3Zm-8.89-4h6.29L48.43,24H37.23L10.31,124.3h6.28L22.46,102a2,2,0,0,1,1.93-1.49H61.26A2,2,0,0,1,63.2,102ZM58.65,94.39H27a2,2,0,0,1-1.94-2.5l15.82-61a2,2,0,0,1,3.87,0l15.82,61a2,2,0,0,1-1.94,2.5Zm-29.06-4H56.07L42.83,39.32Z"/><path d="M106.82,128c-17.74,0-26.43-13-26.43-36.52S89.09,55,106.82,55a21.78,21.78,0,0,1,15.83,6.43L134,56.22V112c0,5.22,1.56,8,4.7,8a7.31,7.31,0,0,0,3.65-1v6.61A17.77,17.77,0,0,1,133.6,128a9.61,9.61,0,0,1-9.74-7.65A22.4,22.4,0,0,1,106.82,128Zm0-10.09a18.15,18.15,0,0,0,16.69-10.61V75.7a18.15,18.15,0,0,0-16.69-10.61c-11.3,0-16,9.56-16,26.43S95.52,118,106.82,118Z"/><path d="M133.6,130A11.61,11.61,0,0,1,123.08,124,24.48,24.48,0,0,1,106.82,130c-13,0-28.43-6.68-28.43-38.52S93.85,53,106.82,53A23.88,23.88,0,0,1,123,59.05l10.08-4.65A2,2,0,0,1,136,56.22V112c0,4,.91,6,2.7,6a5.3,5.3,0,0,0,2.66-.78,2,2,0,0,1,3,1.74v6.61a2,2,0,0,1-1,1.74A19.64,19.64,0,0,1,133.6,130Zm-9.74-11.65a2,2,0,0,1,1.95,1.55,7.63,7.63,0,0,0,7.79,6.1,15.19,15.19,0,0,0,6.69-1.64v-2.52a8.51,8.51,0,0,1-1.65.16c-2.5,0-6.7-1.3-6.7-10V59.34l-8.46,3.91a2,2,0,0,1-2.25-.4A19.67,19.67,0,0,0,106.82,57C90.61,57,82.39,68.62,82.39,91.52S90.61,126,106.82,126a20.33,20.33,0,0,0,15.55-7A2,2,0,0,1,123.86,118.39Zm-17,1.57c-11.94,0-18-9.57-18-28.43s6.06-28.43,18-28.43a20.07,20.07,0,0,1,18.5,11.75,2,2,0,0,1,.19.86v31.65a2,2,0,0,1-.19.86A20.06,20.06,0,0,1,106.82,120Zm0-52.86c-12.55,0-14,13.94-14,24.43,0,21.9,8,24.43,14,24.43a16.13,16.13,0,0,0,14.69-9.07V76.16A16.13,16.13,0,0,0,106.82,67.09Z"/></g></svg>', i.style.padding = "0 3px 0 0", this.lyricsSvg = i.querySelector("svg"), this.lyricsSvg.style.width = "14px", this.lyricsWrapper = document.createElement("div"), this.lyricsWrapper.style.width = "90px", this.lyricsWrapper.style.maxWidth = "90px", this.lyricsWrapper.appendChild(this.lyricsNameDiv), this.lyricsWrapper.appendChild(this.lyricsArtistDiv), this.lyricsAnchor = document.createElement("a"), this.lyricsAnchor.className = "lyrics", this.lyricsAnchor.target = "_blank", this.lyricsAnchor.style.display = "flex", this.lyricsAnchor.style.lineHeight = "1.2em", this.lyricsAnchor.style.padding = "4px 3px 3px 3px", this.lyricsAnchor.style.textDecoration = "none", this.lyricsAnchor.appendChild(i), this.lyricsAnchor.appendChild(this.lyricsWrapper), this.bannerDiv = document.createElement("div"), this.bannerDiv.className = "textalive-banner", this.bannerDiv.style.cursor = "pointer", this.bannerDiv.style.zIndex = "10000", this.bannerDiv.style.background = "#1f4391", this.bannerDiv.style.lineHeight = "0", this.bannerDiv.style.display = "flex", this.bannerDiv.style.maxWidth = "256px", this.bannerDiv.style.fontFamily = "'Hiragino Kaku Gothic Pro','\u6E38\u30B4\u30B7\u30C3\u30AF\u4F53','Yu Gothic',YuGothic,Meiryo,HelveticaNeue,'Helvetica Neue',Helvetica,Arial,sans-serif", this.bannerDiv.style.fontSize = "9px", this.bannerDiv.style.alignItems = "center", this.bannerDiv.style.whiteSpace = "nowrap", this.bannerDiv.appendChild(this.logoAnchor), this.bannerDiv.appendChild(this.songAnchor), this.bannerDiv.appendChild(this.lyricsAnchor), this.songAnchor.style.display = "none", this.lyricsAnchor.style.display = "none", this.updatePosition(), this.updateRounded(), this.updateBordered(), this.updateShadowed(), this.updateBackground(), this.updateColor();
        }
        this.listener = {
            onAppReady: function() {
                r.updatePosition();
            },
            onMediaElementSet: function(t) {
                r.domEnabled && (r.bannerDiv && r.bannerDiv.parentElement && r.bannerDiv.parentElement.removeChild(r.bannerDiv), r.player.mediaBannerElement && r.player.mediaBannerElement.appendChild(r.bannerDiv));
            },
            onVideoLoad: function() {
                r.domEnabled && (r.logoAnchor.href = $af62ec6a841e10b9$var$Li, r.songAnchor.style.display = "none", r.lyricsAnchor.style.display = "none", r.songAnchor.style.borderRadius = "0");
            },
            onSongLoad: function(t) {
                return $af62ec6a841e10b9$var$yn(r, 0, void 0, function() {
                    var e, r, n, i, o, s, a, u, l;
                    return $af62ec6a841e10b9$var$gn(this, function(p) {
                        switch(p.label){
                            case 0:
                                return t ? (e = null === (a = null === (s = null == t ? void 0 : t.song) || void 0 === s ? void 0 : s.artist) || void 0 === a ? void 0 : a.name, r = null === (u = null == t ? void 0 : t.song) || void 0 === u ? void 0 : u.name, n = null === (l = null == t ? void 0 : t.song) || void 0 === l ? void 0 : l.permalink, i = "".concat($af62ec6a841e10b9$var$Li).concat(n ? "/songs/".concat(encodeURIComponent($af62ec6a841e10b9$var$c.getSongPathFromUrl(n))) : ""), this.domEnabled && (this.logoAnchor.href = i, this.songArtistDiv.textContent = $af62ec6a841e10b9$var$Mi(e), this.songNameDiv.textContent = $af62ec6a841e10b9$var$Mi(r), this.songAnchor.title = "".concat($af62ec6a841e10b9$var$Mi(r), " by ").concat($af62ec6a841e10b9$var$Mi(e)), this.songAnchor.href = n, this.songAnchor.style.display = "flex", this.songAnchor.style.borderRadius = this.rounded ? "0 4px 4px 0" : "0", this.songWrapper.style.width = "auto"), [
                                    4,
                                    $af62ec6a841e10b9$var$A.getServerStatus()
                                ]) : [
                                    2
                                ];
                            case 1:
                                return "ja" === (null == (o = p.sent()) ? void 0 : o.lang) ? console.warn("[TextAlive API] \u697D\u66F2 \u30A2\u30FC\u30C6\u30A3\u30B9\u30C8:", $af62ec6a841e10b9$var$Mi(e), "/ \u697D\u66F2\u540D:", $af62ec6a841e10b9$var$Mi(r), "/ \u914D\u4FE1\u5143\u30B5\u30A4\u30C8:", $af62ec6a841e10b9$var$Mi(n)) : console.warn("[TextAlive API] Song artist:", $af62ec6a841e10b9$var$Mi(e), "/ song name:", $af62ec6a841e10b9$var$Mi(r), "/ distributed at:", $af62ec6a841e10b9$var$Mi(n)), [
                                    2
                                ];
                        }
                    });
                });
            },
            onLyricsLoad: function(t) {
                t && r.domEnabled && (r.songWrapper.style.maxWidth = "90px", r.lyricsAnchor.style.display = "flex", r.songAnchor.style.borderRadius = "0");
            },
            onTextLoad: function(t) {
                return $af62ec6a841e10b9$var$yn(r, 0, void 0, function() {
                    var e, r, n, i, o;
                    return $af62ec6a841e10b9$var$gn(this, function(s) {
                        switch(s.label){
                            case 0:
                                return t ? (e = null === (o = null == t ? void 0 : t.artist) || void 0 === o ? void 0 : o.name, r = null == t ? void 0 : t.name, n = null == t ? void 0 : t.url, this.domEnabled && (this.lyricsArtistDiv.textContent = $af62ec6a841e10b9$var$Mi(e), this.lyricsNameDiv.textContent = $af62ec6a841e10b9$var$Mi(r), this.lyricsAnchor.title = "".concat($af62ec6a841e10b9$var$Mi(r), " by ").concat($af62ec6a841e10b9$var$Mi(e)), this.lyricsAnchor.href = n, this.lyricsWrapper.style.width = "auto"), [
                                    4,
                                    $af62ec6a841e10b9$var$A.getServerStatus()
                                ]) : [
                                    2
                                ];
                            case 1:
                                return "ja" === (null == (i = s.sent()) ? void 0 : i.lang) ? console.warn("[TextAlive API] \u6B4C\u8A5E \u30A2\u30FC\u30C6\u30A3\u30B9\u30C8:", $af62ec6a841e10b9$var$Mi(e), "/ \u6B4C\u8A5E\u540D:", $af62ec6a841e10b9$var$Mi(r), "/ \u914D\u4FE1\u5143\u30B5\u30A4\u30C8:", $af62ec6a841e10b9$var$Mi(n)) : console.warn("[TextAlive API] Song lyrics artist:", $af62ec6a841e10b9$var$Mi(e), "/ lyrics name:", $af62ec6a841e10b9$var$Mi(r), "/ distributed at:", $af62ec6a841e10b9$var$Mi(n)), [
                                    2
                                ];
                        }
                    });
                });
            },
            onDispose: function() {
                r.dispose();
            }
        }, t.addListener(this.listener), t.mediaBannerElement && this.player.mediaBannerElement.appendChild(this.bannerDiv);
    }
    return Object.defineProperty(t.prototype, "domEnabled", {
        get: function() {
            return "undefined" != typeof window && "undefined" != typeof document && "function" == typeof document.createElement;
        },
        enumerable: !1,
        configurable: !0
    }), Object.defineProperty(t.prototype, "position", {
        get: function() {
            return this._position;
        },
        set: function(t) {
            this._position = t, this.updatePosition();
        },
        enumerable: !1,
        configurable: !0
    }), Object.defineProperty(t.prototype, "rounded", {
        get: function() {
            return this._rounded;
        },
        set: function(t) {
            this._rounded = t, this.updateRounded();
        },
        enumerable: !1,
        configurable: !0
    }), Object.defineProperty(t.prototype, "bordered", {
        get: function() {
            return this._bordered;
        },
        set: function(t) {
            this._bordered = t, this.updateBordered();
        },
        enumerable: !1,
        configurable: !0
    }), Object.defineProperty(t.prototype, "shadowed", {
        get: function() {
            return this._shadowed;
        },
        set: function(t) {
            this._shadowed = t, this.updateShadowed();
        },
        enumerable: !1,
        configurable: !0
    }), Object.defineProperty(t.prototype, "background", {
        get: function() {
            return this._background;
        },
        set: function(t) {
            this._background = t, this.updateBackground();
        },
        enumerable: !1,
        configurable: !0
    }), Object.defineProperty(t.prototype, "color", {
        get: function() {
            return this._color;
        },
        set: function(t) {
            this._color = t, this.updateColor();
        },
        enumerable: !1,
        configurable: !0
    }), t.prototype.dispose = function() {
        this.player.removeListener(this.listener);
    }, t.prototype.updatePosition = function() {
        var t, e;
        if (this.domEnabled) {
            var r = this.position, n = this.player;
            if (null === r || !(null === (t = n.options) || void 0 === t ? void 0 : t.app) || (null === (e = n.app) || void 0 === e ? void 0 : e.managed)) this.bannerDiv.style.display = "none";
            else if (this.bannerDiv.style.display = "flex", "embed" === r) this.bannerDiv.style.position = "initial", this.bannerDiv.style.marginTop = "4px", this.songAnchor.style.flexGrow = "1", this.lyricsAnchor.style.flexGrow = "1";
            else {
                this.bannerDiv.style.position = "fixed", this.bannerDiv.style.marginTop = "0";
                var i = r.indexOf("top") >= 0, o = r.indexOf("right") >= 0, s = r.indexOf("bottom") >= 0, a = r.indexOf("left") >= 0;
                this.bannerDiv.style.top = i ? "4px" : "initial", this.bannerDiv.style.right = o ? "4px" : "initial", this.bannerDiv.style.bottom = s ? "4px" : "initial", this.bannerDiv.style.left = a ? "4px" : "initial", this.songAnchor.style.flexGrow = "0", this.lyricsAnchor.style.flexGrow = "0";
            }
        }
    }, t.prototype.updateRounded = function() {
        if (this.domEnabled) {
            var t = this.rounded;
            this.logoSvg.style.borderRadius = t ? "4px 0 0 4px" : "0", this.lyricsAnchor.style.borderRadius = t ? "0 4px 4px 0" : "0", this.bannerDiv.style.borderRadius = t ? "4px" : "0";
        }
    }, t.prototype.updateBordered = function() {
        if (this.domEnabled) {
            var t = this.bordered;
            this.logoAnchor.style.padding = t ? "1px 2px" : "1px 3px", this.bannerDiv.style.border = t ? "1px solid rgba(31, 67, 145, 0.3)" : "none";
        }
    }, t.prototype.updateShadowed = function() {
        if (this.domEnabled) {
            var t = this.shadowed;
            this.bannerDiv.style.boxShadow = t ? "1px 1px 3px 0 rgba(9, 19, 42, 0.9)" : "none";
        }
    }, t.prototype.updateBackground = function() {
        this.domEnabled && (this.songAnchor.style.background = this.background, this.lyricsAnchor.style.background = this.background);
    }, t.prototype.updateColor = function() {
        this.domEnabled && (this.songSvg.style.fill = this.color, this.songAnchor.style.color = this.color, this.lyricsSvg.style.fill = this.color, this.lyricsAnchor.style.color = this.color);
    }, t;
}();
function $af62ec6a841e10b9$var$Mi(t) {
    return t && "" !== t ? t : "-";
}
var $af62ec6a841e10b9$var$Bi = function() {
    this.halted = [], this.errors = [];
}, $af62ec6a841e10b9$var$Vi = function() {
    function t(t, e) {
        var r = this;
        this.listener = e, this.player = null, this._scale = 1, this.playerListener = {
            onResize: function(t) {
                r.elementWidth = Math.floor(t.width), r.updateSize();
            },
            onVideoReady: function() {
                r.elementWidth = r.calcWidth(), r.updateSize();
            },
            onStageElementSet: function(t) {
                r.elementWidth = r.calcWidth(), r.updateSize(), r.player.graphics.setCanvas(t);
            },
            onDispose: function() {
                r.dispose();
            }
        }, this.requestedTime = 0, this.request = null, this.player = t, t.addListener(this.playerListener);
    }
    return Object.defineProperty(t.prototype, "scale", {
        get: function() {
            return this._scale;
        },
        set: function(t) {
            this._scale = t, this.updateSize();
        },
        enumerable: !1,
        configurable: !0
    }), Object.defineProperty(t.prototype, "width", {
        get: function() {
            return this.player.graphics.width;
        },
        enumerable: !1,
        configurable: !0
    }), Object.defineProperty(t.prototype, "height", {
        get: function() {
            return this.player.graphics.height;
        },
        enumerable: !1,
        configurable: !0
    }), t.prototype.requestUpdate = function(t) {
        return $af62ec6a841e10b9$var$yn(this, 0, void 0, function() {
            var e = this;
            return $af62ec6a841e10b9$var$gn(this, function(r) {
                return this.requestedTime = void 0 === t ? this.player.videoPosition : t, this.request || (this.request = new Promise(function(t) {
                    setTimeout(function() {
                        try {
                            e.update(e.requestedTime);
                        } catch (t) {}
                        e.request = null, t(e.requestedTime);
                    }, 0);
                })), [
                    2,
                    this.request
                ];
            });
        });
    }, t.prototype.update = function(t) {
        t || (t = this.player.mediaPosition), "number" == typeof t && (this.player.graphics.reset(), this.animate(t), this.player.graphics.update(), this.listener.onStageUpdate(t));
    }, t.prototype.animate = function(t) {
        for(var e = new $af62ec6a841e10b9$var$Bi, r = e.errors, n = e.halted, i = 0, o = [
            this.player.video.firstCredit,
            this.player.video.firstPhrase,
            this.player.video.firstWord,
            this.player.video.firstChar,
            this.player.video.firstGraphic
        ]; i < o.length; i++)for(var s = o[i]; s;)this.animateRenderingUnit(t, s, e), s = s.next;
        if (n.length > 0) {
            console.error("---");
            for(var a = 0; a < n.length; a++)console.error("halted", n[a], r[a]);
        }
    }, t.prototype.animateRenderingUnit = function(t, e, r) {
        if (e.animate) e.animate(t, e);
        else if (e.templateCount <= 0) $af62ec6a841e10b9$var$Gi(e) && e.getType() === $af62ec6a841e10b9$export$6ba26ae1c58c0147.CHAR && (e.rendering.visible = !1);
        else for(var i = 0; i < e.templateCount; i++)this.animateTemplate(t, e, e.getTemplate(i), r);
    }, t.prototype.animateTemplate = function(t, e, r, i) {
        var o = this;
        if (r.ignore) e.rendering.visible = !1;
        else {
            if (e.getType() !== $af62ec6a841e10b9$export$6ba26ae1c58c0147.GRAPHIC) for(var s = e.parent; s;){
                if (s.templateCount > 0 && (!s.rendering.visible || 0 === s.rendering.alpha)) return void (e.rendering.visible = !1);
                s = s.parent;
            }
            var a = this.player.templates.getProperty(r, "insomnia"), u = $af62ec6a841e10b9$var$Gi(e);
            if (!a && u) {
                var c = function(t, e, r, i) {
                    var o = i && t(i, "headTime") || 500, s = i && t(i, "tailTime") || 500;
                    return !(r.startTime - o <= e && r.endTime + s >= e) && (r.getType() !== $af62ec6a841e10b9$export$6ba26ae1c58c0147.GRAPHIC && (r.rendering.visible = !1), !0);
                }(function(t, e) {
                    return o.player.templates.getProperty(t, e);
                }, t, e, r);
                if (c) return;
            }
            this.doAnimateTemplate(t, r, i);
        }
    }, t.prototype.doAnimateTemplate = function(t, e, r) {
        var n = r.errors, i = r.halted;
        try {
            this.player.templates.exec(e, "animate", [
                t
            ]);
        } catch (t) {
            n.push(t), i.push(e);
        }
    }, t.prototype.calcWidth = function() {
        var t = this.player.stageElement;
        if (!t) return 0;
        var e = window.getComputedStyle(t);
        return t.offsetWidth - $af62ec6a841e10b9$var$ln(e.borderLeftWidth) - $af62ec6a841e10b9$var$ln(e.borderRightWidth) - $af62ec6a841e10b9$var$ln(e.paddingLeft) - $af62ec6a841e10b9$var$ln(e.paddingRight);
    }, t.prototype.updateSize = function() {
        var t = this.player.stageElement;
        if (t) {
            var e = this.elementWidth * this.player.videoProportion;
            if (t.style.height = "".concat(e, "px"), t.width = this.elementWidth * this._scale, t.height = e * this._scale, this.player.video) {
                var r = t.width / this.player.videoWidth;
                this.player.graphics.updateStageTx(r, this.player.margin), this.player.isPlaying || this.requestUpdate();
            }
        }
    }, t.prototype.dispose = function() {
        this.player.removeListener(this.playerListener), this.player = null;
    }, t;
}();
function $af62ec6a841e10b9$var$Gi(t) {
    if (t.getType() === $af62ec6a841e10b9$export$6ba26ae1c58c0147.GRAPHIC) return !0;
    for(var e = !0, r = t.parent; r;){
        if (r.templateCount > 0) {
            e = !1;
            break;
        }
        r = r.parent;
    }
    return e;
}
var $af62ec6a841e10b9$var$qi = function(t) {
    function e(e, r) {
        var n = this.constructor, i = t.call(this, e) || this;
        return i.video = r, Object.setPrototypeOf(i, n.prototype), i;
    }
    return $af62ec6a841e10b9$var$dn(e, t), e;
}(Error);
function $af62ec6a841e10b9$var$Wi(t, e) {
    var r = e.parser;
    return $af62ec6a841e10b9$var$yn(this, 0, void 0, function() {
        var e, n, i;
        return $af62ec6a841e10b9$var$gn(this, function(o) {
            switch(o.label){
                case 0:
                    return t && t.length > 0 && t[0].words && t[0].words.length > 0 && t[0].words[0] && !t[0].words[0].pos ? (e = t.map(function(t) {
                        return t.words.map(function(t) {
                            return t.characters.map(function(t) {
                                return t.char;
                            }).join("");
                        }).join(" ");
                    }), n = e.join("\n"), [
                        4,
                        r(n)
                    ]) : [
                        2
                    ];
                case 1:
                    return (i = o.sent()) && "success" === i.status ? (t.forEach(function(t, r) {
                        var n = i.result[r], o = 0;
                        t.words.forEach(function(t) {
                            var i = t.characters.map(function(t) {
                                return t.char;
                            }).join(""), s = e[r].indexOf(i, o);
                            if (!(s < 0)) {
                                o = s;
                                var a = n.find(function(t) {
                                    return t.startPosition <= s && t.endPosition >= s;
                                });
                                a && (t.pos = a.PoS, t.rawPoS = a.rawPoS, t.language = a.language);
                            }
                        });
                    }), [
                        2
                    ]) : [
                        2
                    ];
            }
        });
    });
}
function $af62ec6a841e10b9$var$Yi(t) {
    for(; t.firstElementChild;)t.removeChild(t.firstElementChild);
}
function $af62ec6a841e10b9$var$zi(t, e) {
    var r = e.id, n = e.data, i = e.loader, o = e.deserializer;
    return $af62ec6a841e10b9$var$yn(this, 0, void 0, function() {
        return $af62ec6a841e10b9$var$gn(this, function(e) {
            switch(e.label){
                case 0:
                    return r && r >= 0 ? [
                        4,
                        i(r)
                    ] : [
                        3,
                        2
                    ];
                case 1:
                    e.sent(), e.label = 2;
                case 2:
                    return o(t, n), [
                        2
                    ];
            }
        });
    });
}
function $af62ec6a841e10b9$var$Ji(t) {
    return "string" != typeof t ? t : "undefined" == typeof window ? null : document.querySelector(t);
}
var $af62ec6a841e10b9$export$2616165974278734 = function() {
    function t(t) {
        this._mediaPosition = 0, this._videoPosition = 0, this.isEditing = !1, this._isVideoSeeking = !1, this._volume = 100, this._options = t, this.emitter = new $af62ec6a841e10b9$var$On(t), this._templates = new $af62ec6a841e10b9$var$Ui(this, this.emitter, t && t.unsafeAcceleration);
        var e = Object.assign({}, $af62ec6a841e10b9$var$Y);
        t && t.managers && (e = Object.assign(e, t.managers)), this.managers = e, this._timer = t && t.timer || this.createDefaultTimer(), this._data = new $af62ec6a841e10b9$var$Vn(e, this.emitter, t), this._backgroundGraphics = new $af62ec6a841e10b9$var$Sn(this, e.asset, this.emitter), this._graphics = t && t.graphics || this.createDefaultGraphicsDriver(), this.stage = new $af62ec6a841e10b9$var$Vi(this, {
            onStageUpdate: this.onStageUpdate.bind(this)
        }), this._banner = new $af62ec6a841e10b9$var$Di(this), this.stageElement = $af62ec6a841e10b9$var$Ji(null == t ? void 0 : t.stageElement) || null, this.mediaElement = $af62ec6a841e10b9$var$Ji(null == t ? void 0 : t.mediaElement) || null, this._app = new $af62ec6a841e10b9$var$Gn(this, this.emitter);
    }
    return Object.defineProperty(t.prototype, "options", {
        get: function() {
            return this._options ? $af62ec6a841e10b9$var$fn({}, this._options) : null;
        },
        enumerable: !1,
        configurable: !0
    }), Object.defineProperty(t.prototype, "app", {
        get: function() {
            return this._app;
        },
        enumerable: !1,
        configurable: !0
    }), Object.defineProperty(t.prototype, "data", {
        get: function() {
            return this._data;
        },
        enumerable: !1,
        configurable: !0
    }), Object.defineProperty(t.prototype, "backgroundGraphics", {
        get: function() {
            return this._backgroundGraphics;
        },
        enumerable: !1,
        configurable: !0
    }), Object.defineProperty(t.prototype, "video", {
        get: function() {
            return this._video;
        },
        enumerable: !1,
        configurable: !0
    }), Object.defineProperty(t.prototype, "templates", {
        get: function() {
            return this._templates;
        },
        enumerable: !1,
        configurable: !0
    }), Object.defineProperty(t.prototype, "graphics", {
        get: function() {
            return this._graphics;
        },
        enumerable: !1,
        configurable: !0
    }), Object.defineProperty(t.prototype, "stageElement", {
        get: function() {
            return this._stageElement;
        },
        set: function(t) {
            this._stageElement = t, this.emitter.onStageElementSet(t);
        },
        enumerable: !1,
        configurable: !0
    }), Object.defineProperty(t.prototype, "stageScale", {
        get: function() {
            return this.stage.scale;
        },
        set: function(t) {
            this.stage.scale = t;
        },
        enumerable: !1,
        configurable: !0
    }), Object.defineProperty(t.prototype, "mediaElement", {
        get: function() {
            return this._mediaElement;
        },
        set: function(t) {
            this.updateMediaElement(t);
        },
        enumerable: !1,
        configurable: !0
    }), Object.defineProperty(t.prototype, "mediaSourceElement", {
        get: function() {
            return this._mediaSourceElement;
        },
        enumerable: !1,
        configurable: !0
    }), Object.defineProperty(t.prototype, "mediaBannerElement", {
        get: function() {
            return this._mediaBannerElement;
        },
        enumerable: !1,
        configurable: !0
    }), Object.defineProperty(t.prototype, "mediaPosition", {
        get: function() {
            return this._mediaPosition;
        },
        enumerable: !1,
        configurable: !0
    }), Object.defineProperty(t.prototype, "videoPosition", {
        get: function() {
            return this._videoPosition;
        },
        enumerable: !1,
        configurable: !0
    }), Object.defineProperty(t.prototype, "wait", {
        get: function() {
            return this._timer ? this._timer.wait : 0;
        },
        set: function(t) {
            this._timer && (this._timer.wait = t);
        },
        enumerable: !1,
        configurable: !0
    }), Object.defineProperty(t.prototype, "fps", {
        get: function() {
            return 1e3 / this.wait;
        },
        set: function(t) {
            this.wait = 1e3 / t;
        },
        enumerable: !1,
        configurable: !0
    }), Object.defineProperty(t.prototype, "resolutionWidth", {
        get: function() {
            var t, e, r, n;
            return "object" == typeof (null === (e = null === (t = this._data) || void 0 === t ? void 0 : t.video) || void 0 === e ? void 0 : e.config) && "number" == typeof this._data.video.config.width ? this._data.video.config.width : "number" == typeof (null === (n = null === (r = this._options) || void 0 === r ? void 0 : r.defaultVideoSize) || void 0 === n ? void 0 : n.width) ? this._options.defaultVideoSize.width : 1280;
        },
        enumerable: !1,
        configurable: !0
    }), Object.defineProperty(t.prototype, "resolutionHeight", {
        get: function() {
            var t, e, r, n;
            return "object" == typeof (null === (e = null === (t = this._data) || void 0 === t ? void 0 : t.video) || void 0 === e ? void 0 : e.config) && "number" == typeof this._data.video.config.height ? this._data.video.config.height : "number" == typeof (null === (n = null === (r = this._options) || void 0 === r ? void 0 : r.defaultVideoSize) || void 0 === n ? void 0 : n.height) ? this._options.defaultVideoSize.height : 720;
        },
        enumerable: !1,
        configurable: !0
    }), Object.defineProperty(t.prototype, "resolutionProportion", {
        get: function() {
            return this.resolutionHeight / this.resolutionWidth;
        },
        enumerable: !1,
        configurable: !0
    }), Object.defineProperty(t.prototype, "margin", {
        get: function() {
            var t, e, r, n;
            return "object" == typeof (null === (e = null === (t = this._data) || void 0 === t ? void 0 : t.video) || void 0 === e ? void 0 : e.config) && this._data.video.config.margin ? this._data.video.config.margin : (null === (n = null === (r = this._options) || void 0 === r ? void 0 : r.defaultVideoSize) || void 0 === n ? void 0 : n.margin) || $af62ec6a841e10b9$var$_n;
        },
        enumerable: !1,
        configurable: !0
    }), Object.defineProperty(t.prototype, "videoWidth", {
        get: function() {
            var t = this.resolutionWidth, e = this.margin;
            return t + e[1] + e[3];
        },
        enumerable: !1,
        configurable: !0
    }), Object.defineProperty(t.prototype, "videoHeight", {
        get: function() {
            var t = this.resolutionHeight, e = this.margin;
            return t + e[0] + e[2];
        },
        enumerable: !1,
        configurable: !0
    }), Object.defineProperty(t.prototype, "videoProportion", {
        get: function() {
            return this.videoHeight / this.videoWidth;
        },
        enumerable: !1,
        configurable: !0
    }), Object.defineProperty(t.prototype, "stageWidth", {
        get: function() {
            return this.stage.width;
        },
        enumerable: !1,
        configurable: !0
    }), Object.defineProperty(t.prototype, "stageHeight", {
        get: function() {
            return this.stage.height;
        },
        enumerable: !1,
        configurable: !0
    }), Object.defineProperty(t.prototype, "isLoading", {
        get: function() {
            return !!this._videoPromise;
        },
        enumerable: !1,
        configurable: !0
    }), Object.defineProperty(t.prototype, "isPlaying", {
        get: function() {
            return !!this._timer && this._timer.isPlaying;
        },
        enumerable: !1,
        configurable: !0
    }), Object.defineProperty(t.prototype, "isVideoSeeking", {
        get: function() {
            return this._isVideoSeeking;
        },
        enumerable: !1,
        configurable: !0
    }), Object.defineProperty(t.prototype, "banner", {
        get: function() {
            return this._banner;
        },
        enumerable: !1,
        configurable: !0
    }), Object.defineProperty(t.prototype, "timer", {
        get: function() {
            return this._timer;
        },
        enumerable: !1,
        configurable: !0
    }), Object.defineProperty(t.prototype, "volume", {
        get: function() {
            return this._volume;
        },
        set: function(t) {
            isNaN(t) || (this._volume = Math.min(100, Math.max(0, t)), this.emitter.onVolumeUpdate(this._volume));
        },
        enumerable: !1,
        configurable: !0
    }), t.prototype.createDefaultTimer = function() {
        try {
            if ("undefined" != typeof window && "basic" !== $af62ec6a841e10b9$var$pn("ta_timer")) return new $af62ec6a841e10b9$export$c66cf4e5d83f6286;
        } catch (t) {}
        return new $af62ec6a841e10b9$export$e985807e6b50ff90;
    }, t.prototype.createDefaultGraphicsDriver = function() {
        return new $af62ec6a841e10b9$var$yt;
    }, t.prototype.addListener = function(t) {
        return this.emitter.addListener(t);
    }, t.prototype.removeListener = function(t) {
        return this.emitter.removeListener(t);
    }, t.prototype.createFromVideoId = function(t, e) {
        return $af62ec6a841e10b9$var$yn(this, 0, void 0, function() {
            var r = this;
            return $af62ec6a841e10b9$var$gn(this, function(n) {
                return [
                    2,
                    this.create(function() {
                        return r.doCreateFromVideoId(t, e);
                    }, null == e ? void 0 : e.dryRun)
                ];
            });
        });
    }, t.prototype.doCreateFromVideoId = function(t, e) {
        return $af62ec6a841e10b9$var$yn(this, 0, void 0, function() {
            var r;
            return $af62ec6a841e10b9$var$gn(this, function(n) {
                switch(n.label){
                    case 0:
                        return [
                            4,
                            (r = new $af62ec6a841e10b9$var$Vn(this.managers, this.emitter, this._options)).createFromVideoId(t, null == e ? void 0 : e.video)
                        ];
                    case 1:
                        return n.sent(), [
                            2,
                            this.finalize(r, e)
                        ];
                }
            });
        });
    }, t.prototype.createFromVideo = function(t, e) {
        return $af62ec6a841e10b9$var$yn(this, 0, void 0, function() {
            var r = this;
            return $af62ec6a841e10b9$var$gn(this, function(n) {
                return [
                    2,
                    this.create(function() {
                        return r.doCreateFromVideo(t, e);
                    }, null == e ? void 0 : e.dryRun)
                ];
            });
        });
    }, t.prototype.doCreateFromVideo = function(t, e) {
        return $af62ec6a841e10b9$var$yn(this, 0, void 0, function() {
            var r;
            return $af62ec6a841e10b9$var$gn(this, function(n) {
                return (r = new $af62ec6a841e10b9$var$Vn(this.managers, this.emitter, this._options)).createFromVideo(t, null == e ? void 0 : e.video), [
                    2,
                    this.finalize(r, e)
                ];
            });
        });
    }, t.prototype.createFromSongUrl = function(t, e) {
        return $af62ec6a841e10b9$var$yn(this, 0, void 0, function() {
            var r = this;
            return $af62ec6a841e10b9$var$gn(this, function(n) {
                return [
                    2,
                    this.create(function() {
                        return r.doCreateFromSongUrl(t, e);
                    }, null == e ? void 0 : e.dryRun)
                ];
            });
        });
    }, t.prototype.doCreateFromSongUrl = function(t, e) {
        return $af62ec6a841e10b9$var$yn(this, 0, void 0, function() {
            var r;
            return $af62ec6a841e10b9$var$gn(this, function(n) {
                switch(n.label){
                    case 0:
                        return [
                            4,
                            (r = new $af62ec6a841e10b9$var$Vn(this.managers, this.emitter, this._options)).createFromSongUrl(t, null == e ? void 0 : e.video)
                        ];
                    case 1:
                        return n.sent(), [
                            2,
                            this.finalize(r, e)
                        ];
                }
            });
        });
    }, t.prototype.createFromSongPath = function(t, e) {
        return $af62ec6a841e10b9$var$yn(this, 0, void 0, function() {
            var r = this;
            return $af62ec6a841e10b9$var$gn(this, function(n) {
                return [
                    2,
                    this.create(function() {
                        return r.doCreateFromSongPath(t, e);
                    }, null == e ? void 0 : e.dryRun)
                ];
            });
        });
    }, t.prototype.doCreateFromSongPath = function(t, e) {
        return $af62ec6a841e10b9$var$yn(this, 0, void 0, function() {
            var r;
            return $af62ec6a841e10b9$var$gn(this, function(n) {
                switch(n.label){
                    case 0:
                        return [
                            4,
                            (r = new $af62ec6a841e10b9$var$Vn(this.managers, this.emitter, this._options)).createFromSongPath(t, null == e ? void 0 : e.video)
                        ];
                    case 1:
                        return n.sent(), [
                            2,
                            this.finalize(r, e)
                        ];
                }
            });
        });
    }, t.prototype.createFromSongId = function(t, e) {
        return $af62ec6a841e10b9$var$yn(this, 0, void 0, function() {
            var r = this;
            return $af62ec6a841e10b9$var$gn(this, function(n) {
                return [
                    2,
                    this.create(function() {
                        return r.doCreateFromSongId(t, e);
                    }, null == e ? void 0 : e.dryRun)
                ];
            });
        });
    }, t.prototype.doCreateFromSongId = function(t, e) {
        return $af62ec6a841e10b9$var$yn(this, 0, void 0, function() {
            var r;
            return $af62ec6a841e10b9$var$gn(this, function(n) {
                switch(n.label){
                    case 0:
                        return [
                            4,
                            (r = new $af62ec6a841e10b9$var$Vn(this.managers, this.emitter, this._options)).createFromSongId(t, null == e ? void 0 : e.video)
                        ];
                    case 1:
                        return n.sent(), [
                            2,
                            this.finalize(r, e)
                        ];
                }
            });
        });
    }, t.prototype.createFromSongCode = function(t, e) {
        return $af62ec6a841e10b9$var$yn(this, 0, void 0, function() {
            var r = this;
            return $af62ec6a841e10b9$var$gn(this, function(n) {
                return [
                    2,
                    this.create(function() {
                        return r.doCreateFromSongCode(t, e);
                    }, null == e ? void 0 : e.dryRun)
                ];
            });
        });
    }, t.prototype.doCreateFromSongCode = function(t, e) {
        return $af62ec6a841e10b9$var$yn(this, 0, void 0, function() {
            var r;
            return $af62ec6a841e10b9$var$gn(this, function(n) {
                switch(n.label){
                    case 0:
                        return [
                            4,
                            (r = new $af62ec6a841e10b9$var$Vn(this.managers, this.emitter, this._options)).createFromSongCode(t, null == e ? void 0 : e.video)
                        ];
                    case 1:
                        return n.sent(), [
                            2,
                            this.finalize(r, e)
                        ];
                }
            });
        });
    }, t.prototype.createFromText = function(t, e) {
        return $af62ec6a841e10b9$var$yn(this, 0, void 0, function() {
            var r = this;
            return $af62ec6a841e10b9$var$gn(this, function(n) {
                return [
                    2,
                    this.create(function() {
                        return r.doCreateFromText(t, e);
                    }, null == e ? void 0 : e.dryRun)
                ];
            });
        });
    }, t.prototype.doCreateFromText = function(t, e) {
        return $af62ec6a841e10b9$var$yn(this, 0, void 0, function() {
            var r;
            return $af62ec6a841e10b9$var$gn(this, function(n) {
                switch(n.label){
                    case 0:
                        return [
                            4,
                            (r = new $af62ec6a841e10b9$var$Vn(this.managers, this.emitter, this._options)).createFromText(t, null == e ? void 0 : e.video)
                        ];
                    case 1:
                        return n.sent(), [
                            2,
                            this.finalize(r, e)
                        ];
                }
            });
        });
    }, t.prototype.createFromJSON = function(t, e) {
        return $af62ec6a841e10b9$var$yn(this, 0, void 0, function() {
            var r = this;
            return $af62ec6a841e10b9$var$gn(this, function(n) {
                return [
                    2,
                    this.create(function() {
                        return r.doCreateFromJSON(t, e);
                    }, null == e ? void 0 : e.dryRun)
                ];
            });
        });
    }, t.prototype.doCreateFromJSON = function(t, e) {
        return $af62ec6a841e10b9$var$yn(this, 0, void 0, function() {
            var r;
            return $af62ec6a841e10b9$var$gn(this, function(n) {
                return (r = new $af62ec6a841e10b9$var$Vn(this.managers, this.emitter, this._options)).createFromJSON(t, null == e ? void 0 : e.video), [
                    2,
                    this.finalize(r, e)
                ];
            });
        });
    }, t.prototype.create = function(t, e) {
        return $af62ec6a841e10b9$var$yn(this, 0, void 0, function() {
            var r, n = this;
            return $af62ec6a841e10b9$var$gn(this, function(i) {
                if (this._videoPromise && !e) throw new $af62ec6a841e10b9$var$qi("Player.createFrom* method calls cannot run in parallel", this._videoPromise);
                return r = t(), e || (this._videoPromise = r, r.finally(function() {
                    return n._videoPromise = null;
                })), [
                    2,
                    r
                ];
            });
        });
    }, t.prototype.finalize = function(t, e) {
        return $af62ec6a841e10b9$var$yn(this, 0, void 0, function() {
            var r, n, i, o = this;
            return $af62ec6a841e10b9$var$gn(this, function(s) {
                switch(s.label){
                    case 0:
                        return t.video ? [
                            4,
                            Promise.all([
                                t.finalize(e),
                                this.backgroundGraphics.setBackground(t.video.background)
                            ])
                        ] : [
                            2,
                            null
                        ];
                    case 1:
                        return s.sent(), (null == e ? void 0 : e.dryRun) ? [
                            2,
                            null
                        ] : (r = t.video.json, function(t, e) {
                            var r = e.config, n = e.song;
                            r && "object" == typeof r && "number" == typeof r.duration ? t.duration = r.duration : n ? t.duration = 1e3 * n.length : t.duration || (t.duration = t.endTime);
                        }(n = new $af62ec6a841e10b9$var$ut(r), {
                            config: t.video.config,
                            song: t.song
                        }), [
                            4,
                            Promise.all([
                                this.graphics.createRuntime(n),
                                $af62ec6a841e10b9$var$zi(n, {
                                    id: t.video.id,
                                    data: r,
                                    loader: function(t) {
                                        return $af62ec6a841e10b9$var$yn(o, 0, void 0, function() {
                                            return $af62ec6a841e10b9$var$gn(this, function(e) {
                                                switch(e.label){
                                                    case 0:
                                                        return [
                                                            4,
                                                            this.templates.loadForVideo(t)
                                                        ];
                                                    case 1:
                                                        return e.sent(), [
                                                            2
                                                        ];
                                                }
                                            });
                                        });
                                    },
                                    deserializer: function(t, e) {
                                        return o.templates.importInstances(t, e);
                                    }
                                }),
                                $af62ec6a841e10b9$var$Wi(null == r ? void 0 : r.phrases, {
                                    parser: $af62ec6a841e10b9$var$R.parse.bind($af62ec6a841e10b9$var$R)
                                })
                            ])
                        ]);
                    case 2:
                        return s.sent(), this._data, this._video && this.templates.disposeInstances(this._video), this._data = t, this._video = n, this.emitter.onVideoReady(n), i = (null == e ? void 0 : e.altSourceUrl) || void 0, [
                            4,
                            this._timer.initialize({
                                player: this,
                                updater: this.updateMediaPosition.bind(this),
                                emitter: this.emitter,
                                altSourceUrl: i
                            })
                        ];
                    case 3:
                        return s.sent(), this.emitter.onTimerReady(this._timer), [
                            2,
                            n
                        ];
                }
            });
        });
    }, t.prototype.updateMediaPosition = function(t) {
        return $af62ec6a841e10b9$var$yn(this, 0, void 0, function() {
            var e = this;
            return $af62ec6a841e10b9$var$gn(this, function(r) {
                return this._isVideoSeeking ? (this._mediaPosition = t, this.emitter.onMediaSeek(t), [
                    2,
                    t
                ]) : [
                    2,
                    this.stage.requestUpdate(t).then(function(t) {
                        return e._mediaPosition = t, e._videoPosition = t, e.emitter.onMediaSeek(t), t;
                    })
                ];
            });
        });
    }, t.prototype.exportVideo = function(t) {
        var e, r, n, i, o, s, a;
        return void 0 === t && (t = {
            legacyStringMode: !0
        }), $af62ec6a841e10b9$var$yn(this, 0, void 0, function() {
            var u, c, l, p;
            return $af62ec6a841e10b9$var$gn(this, function(h) {
                return u = {
                    sourceId: (null === (e = this._data.video) || void 0 === e ? void 0 : e.id) || -1,
                    sourceOriginId: (null === (r = this._data.video) || void 0 === r ? void 0 : r.sourceOriginId) || -1,
                    songleId: (null === (n = this._data.song) || void 0 === n ? void 0 : n.id) || -1,
                    lyricId: this._data.lyricsId || -1,
                    lyricDiffId: (null === (i = this._data.lyrics) || void 0 === i ? void 0 : i.id) || -1,
                    config: ((null == t ? void 0 : t.legacyStringMode) ? (null === (o = this._data.video) || void 0 === o ? void 0 : o.config) && JSON.stringify(this._data.video.config) : null === (s = this._data.video) || void 0 === s ? void 0 : s.config) || null
                }, c = this.backgroundGraphics.exportPartialVideoEntry(t), l = (null === (a = this._video) || void 0 === a ? void 0 : a.exportData(this._templates)) || null, p = (null == t ? void 0 : t.legacyStringMode) ? JSON.stringify(l) : l, [
                    2,
                    $af62ec6a841e10b9$var$fn($af62ec6a841e10b9$var$fn($af62ec6a841e10b9$var$fn({}, u), c), {
                        json: p
                    })
                ];
            });
        });
    }, t.prototype.getChoruses = function() {
        return this._data.getChoruses();
    }, t.prototype.findChorus = function(t, e) {
        return this._data.findChorus(t, e);
    }, t.prototype.findChorusBetween = function(t, e) {
        return this._data.findChorusBetween(t, e);
    }, t.prototype.findChorusChange = function(t, e) {
        return this._data.findChorusChange(t, e);
    }, t.prototype.getBeats = function() {
        return this._data.getBeats();
    }, t.prototype.findBeat = function(t, e) {
        return this._data.findBeat(t, e);
    }, t.prototype.findBeatChange = function(t, e) {
        return this._data.findBeatChange(t, e);
    }, t.prototype.getChords = function() {
        return this._data.getChords();
    }, t.prototype.findChord = function(t, e) {
        return this._data.findChord(t, e);
    }, t.prototype.findChordChange = function(t, e) {
        return this._data.findChordChange(t, e);
    }, t.prototype.getVocalFrequency = function(t) {
        return this._data.getVocalFrequency(t);
    }, t.prototype.getVocalAmplitude = function(t) {
        return this._data.getVocalAmplitude(t);
    }, t.prototype.getMaxVocalAmplitude = function() {
        return this._data.getMaxVocalAmplitude();
    }, t.prototype.getValenceArousal = function(t) {
        return this._data.getValenceArousal(t);
    }, t.prototype.getMedianValenceArousal = function() {
        return this._data.getMedianValenceArousal();
    }, t.prototype.resize = function(t) {
        return this.emitter.onResize(t);
    }, t.prototype.onResize = function(t) {
        return this.resize(t);
    }, t.prototype.setStageElement = function(t) {
        return this._stageElement = t, this.emitter.onStageElementSet(t);
    }, t.prototype.setMediaElement = function(t) {
        this.mediaElement = t;
    }, t.prototype.updateMediaElement = function(t) {
        "undefined" != typeof document && (this._mediaElement && $af62ec6a841e10b9$var$Yi(this._mediaElement), t ? ($af62ec6a841e10b9$var$Yi(t), this._mediaSourceElement || (this._mediaSourceElement = document.createElement("div"), this._mediaSourceElement.classList.add("textalive-media-wrapper")), t.appendChild(this._mediaSourceElement), this._mediaBannerElement || (this._mediaBannerElement = document.createElement("div"), this._mediaSourceElement.classList.add("textalive-banner-wrapper")), t.appendChild(this._mediaBannerElement)) : (this._mediaSourceElement = null, this._mediaBannerElement = null)), this._mediaElement = t, this.emitter.onMediaElementSet(t);
    }, t.prototype.setVideoPosition = function(t) {
        return $af62ec6a841e10b9$var$yn(this, 0, void 0, function() {
            var e = this;
            return $af62ec6a841e10b9$var$gn(this, function(r) {
                return [
                    2,
                    this.stage.requestUpdate(t).then(function(t) {
                        return e._videoPosition = t, e.emitter.onVideoSeek(t), t;
                    })
                ];
            });
        });
    }, t.prototype.setMediaPosition = function(t) {
        return $af62ec6a841e10b9$var$yn(this, 0, void 0, function() {
            return $af62ec6a841e10b9$var$gn(this, function(e) {
                return this.requestMediaSeek(t), [
                    2
                ];
            });
        });
    }, t.prototype.requestPlay = function() {
        return this._timer.play(), !0;
    }, t.prototype.requestStop = function() {
        return this._timer.stop(), !0;
    }, t.prototype.requestPause = function() {
        return this._timer.pause(), !0;
    }, t.prototype.requestMediaSeek = function(t) {
        return this._timer.seek(t), !0;
    }, t.prototype.startVideoSeek = function() {
        return this._isVideoSeeking = !0, this.emitter.onVideoSeekStart();
    }, t.prototype.endVideoSeek = function() {
        return this._isVideoSeeking = !1, this.emitter.onVideoSeekEnd();
    }, t.prototype.requestSettingBackground = function(t) {
        return $af62ec6a841e10b9$var$yn(this, 0, void 0, function() {
            return $af62ec6a841e10b9$var$gn(this, function(e) {
                return [
                    2,
                    this.backgroundGraphics.settingBackground(t)
                ];
            });
        });
    }, t.prototype.requestSetBackground = function(t) {
        return $af62ec6a841e10b9$var$yn(this, 0, void 0, function() {
            return $af62ec6a841e10b9$var$gn(this, function(e) {
                return [
                    2,
                    this.backgroundGraphics.setBackground(t)
                ];
            });
        });
    }, t.prototype.requestStageUpdate = function() {
        return $af62ec6a841e10b9$var$yn(this, 0, void 0, function() {
            return $af62ec6a841e10b9$var$gn(this, function(t) {
                return [
                    2,
                    this.stage.requestUpdate()
                ];
            });
        });
    }, t.prototype.onStageUpdate = function(t) {
        this._isVideoSeeking || this.emitter.onTimeUpdate(t);
    }, t.prototype.dispose = function() {
        this._timer && (this._timer.dispose(), this._timer = null), this.mediaElement && ($af62ec6a841e10b9$var$Yi(this._mediaElement), this._mediaElement = null), this.stageElement && (this._stageElement = null), this.emitter.onDispose();
    }, t;
}();
console.log("# \u30E9\u30A4\u30BB\u30F3\u30B9\u8868\u8A18\u306B\u95A2\u3059\u308B\u30AC\u30A4\u30C9\u30E9\u30A4\u30F3\n\n\u56FD\u7ACB\u7814\u7A76\u958B\u767A\u6CD5\u4EBA\u7523\u696D\u6280\u8853\u7DCF\u5408\u7814\u7A76\u6240\n\u4EBA\u9593\u60C5\u5831\u30A4\u30F3\u30BF\u30E9\u30AF\u30B7\u30E7\u30F3\u7814\u7A76\u90E8\u9580\n\u30E1\u30C7\u30A3\u30A2\u30A4\u30F3\u30BF\u30E9\u30AF\u30B7\u30E7\u30F3\u7814\u7A76\u30B0\u30EB\u30FC\u30D7\n\nTextAlive App API\u306F\u975E\u5546\u7528\u5229\u7528\u306B\u9650\u308A\u3001\u3069\u306A\u305F\u3067\u3082\u7121\u6599\u30FB\u7121\u4FDD\u8A3C\u3067\u5229\u7528\u3059\u308B\u3053\u3068\u304C\u3067\u304D\u307E\u3059\u3002\n\u305F\u3060\u3057\u3001\u539F\u5247\u3068\u3057\u3066TextAlive App API\u3092\u5229\u7528\u3057\u3066\u3044\u308B\u65E8\u3092 TextAlive https://textalive.jp/ \u30B5\u30A4\u30C8\u5185\u697D\u66F2\u30DA\u30FC\u30B8\u307E\u305F\u306F https://developer.textalive.jp/ \u306B\u30CF\u30A4\u30D1\u30FC\u30EA\u30F3\u30AF\u3057\u305F\u4E0A\u3067\u3001\u5229\u7528\u3057\u3066\u3044\u308B\u30B7\u30B9\u30C6\u30E0\u3082\u3057\u304F\u306F\u5916\u90E8\u30B5\u30A4\u30C8\u7B49\u306B\u8868\u793A\u3059\u308B\u5FC5\u8981\u304C\u3042\u308A\u307E\u3059\u3002\n\n# \u304A\u554F\u3044\u5408\u308F\u305B\n\ntextalive-ml@aist.go.jp");
var $af62ec6a841e10b9$export$3bf46e7874a0fbad = $af62ec6a841e10b9$var$r.sortedIndex;


parcelRequire("1ucKx");
parcelRequire("ilwiq");
var $dyjou = parcelRequire("dyjou");
var $dyjou = parcelRequire("dyjou");
const $1728f660d4783387$var$_zee = new (0, $dyjou.Vector3)(0, 0, 1);
const $1728f660d4783387$var$_euler = new (0, $dyjou.Euler)();
const $1728f660d4783387$var$_q0 = new (0, $dyjou.Quaternion)();
const $1728f660d4783387$var$_q1 = new (0, $dyjou.Quaternion)(-Math.sqrt(0.5), 0, 0, Math.sqrt(0.5)); // - PI/2 around the x-axis
const $1728f660d4783387$var$_changeEvent = {
    type: 'change'
};
class $1728f660d4783387$export$d45c362978480ef3 extends (0, $dyjou.EventDispatcher) {
    constructor(object){
        super();
        if (window.isSecureContext === false) console.error('THREE.DeviceOrientationControls: DeviceOrientationEvent is only available in secure contexts (https)');
        const scope = this;
        const EPS = 0.000001;
        const lastQuaternion = new (0, $dyjou.Quaternion)();
        this.object = object;
        this.object.rotation.reorder('YXZ');
        this.enabled = true;
        this.deviceOrientation = {};
        this.screenOrientation = 0;
        this.alphaOffset = 0; // radians
        const onDeviceOrientationChangeEvent = function(event) {
            scope.deviceOrientation = event;
        };
        const onScreenOrientationChangeEvent = function() {
            scope.screenOrientation = window.orientation || 0;
        };
        // The angles alpha, beta and gamma form a set of intrinsic Tait-Bryan angles of type Z-X'-Y''
        const setObjectQuaternion = function(quaternion, alpha, beta, gamma, orient) {
            $1728f660d4783387$var$_euler.set(beta, alpha, -gamma, 'YXZ'); // 'ZXY' for the device, but 'YXZ' for us
            quaternion.setFromEuler($1728f660d4783387$var$_euler); // orient the device
            quaternion.multiply($1728f660d4783387$var$_q1); // camera looks out the back of the device, not the top
            quaternion.multiply($1728f660d4783387$var$_q0.setFromAxisAngle($1728f660d4783387$var$_zee, -orient)); // adjust for screen orientation
        };
        this.connect = function() {
            onScreenOrientationChangeEvent(); // run once on load
            // iOS 13+
            if (window.DeviceOrientationEvent !== undefined && typeof window.DeviceOrientationEvent.requestPermission === 'function') window.DeviceOrientationEvent.requestPermission().then(function(response) {
                if (response == 'granted') {
                    window.addEventListener('orientationchange', onScreenOrientationChangeEvent);
                    window.addEventListener('deviceorientation', onDeviceOrientationChangeEvent);
                }
            }).catch(function(error) {
                console.error('THREE.DeviceOrientationControls: Unable to use DeviceOrientation API:', error);
            });
            else {
                window.addEventListener('orientationchange', onScreenOrientationChangeEvent);
                window.addEventListener('deviceorientation', onDeviceOrientationChangeEvent);
            }
            scope.enabled = true;
        };
        this.disconnect = function() {
            window.removeEventListener('orientationchange', onScreenOrientationChangeEvent);
            window.removeEventListener('deviceorientation', onDeviceOrientationChangeEvent);
            scope.enabled = false;
        };
        this.update = function() {
            if (scope.enabled === false) return;
            const device = scope.deviceOrientation;
            if (device) {
                const alpha = device.alpha ? (0, $dyjou.MathUtils).degToRad(device.alpha) + scope.alphaOffset : 0; // Z
                const beta = device.beta ? (0, $dyjou.MathUtils).degToRad(device.beta) : 0; // X'
                const gamma = device.gamma ? (0, $dyjou.MathUtils).degToRad(device.gamma) : 0; // Y''
                const orient = scope.screenOrientation ? (0, $dyjou.MathUtils).degToRad(scope.screenOrientation) : 0; // O
                setObjectQuaternion(scope.object.quaternion, alpha, beta, gamma, orient);
                if (8 * (1 - lastQuaternion.dot(scope.object.quaternion)) > EPS) {
                    lastQuaternion.copy(scope.object.quaternion);
                    scope.dispatchEvent($1728f660d4783387$var$_changeEvent);
                }
            }
        };
        this.dispose = function() {
            scope.disconnect();
        };
        this.connect();
    }
}


var $73dcae1a8329d972$exports = {};
$73dcae1a8329d972$exports = import.meta.resolve("inO4J");


var $74cf49d57ca99315$exports = {};
$74cf49d57ca99315$exports = import.meta.resolve("9Bc1D");


var $ad84c9be58b7a2d3$exports = {};
$ad84c9be58b7a2d3$exports = import.meta.resolve("c7hmk");


var $ddf48f29f0c57660$exports = {};
$ddf48f29f0c57660$exports = import.meta.resolve("aFgEV");


var $bff0ee7dd12d5fb4$exports = {};
$bff0ee7dd12d5fb4$exports = import.meta.resolve("33C6w");


var $c955cdd67aa99cf2$exports = {};
$c955cdd67aa99cf2$exports = import.meta.resolve("dU7iU");


var $241c34d778a01174$exports = {};
$241c34d778a01174$exports = import.meta.resolve("5B2hv");


var $39c43c2be5e16a01$exports = {};
$39c43c2be5e16a01$exports = import.meta.resolve("dhmug");


var $1dc737c91cb5f1fb$exports = {};
$1dc737c91cb5f1fb$exports = import.meta.resolve("55sLT");


var $4812f2a55fcfa131$exports = {};
$4812f2a55fcfa131$exports = import.meta.resolve("kZVyM");


var $d81e672b6d1344dd$exports = {};
$d81e672b6d1344dd$exports = import.meta.resolve("aIDMs");


var $2b394d55fe10f5be$exports = {};
$2b394d55fe10f5be$exports = import.meta.resolve("h7Kmw");


var $572ae2c7d6f6d3ac$exports = {};
$572ae2c7d6f6d3ac$exports = import.meta.resolve("3Lf75");


var $b3fd4caac830b527$exports = {};
$b3fd4caac830b527$exports = import.meta.resolve("6abTk");


var $bf7b41788c03325e$exports = {};
$bf7b41788c03325e$exports = import.meta.resolve("fA7oN");


var $42c76402dafc120d$exports = {};
$42c76402dafc120d$exports = import.meta.resolve("lLdhq");


var $86db31fcb6027a0b$exports = {};
$86db31fcb6027a0b$exports = import.meta.resolve("8LTDL");


var $8735bc822ebea544$exports = {};
$8735bc822ebea544$exports = import.meta.resolve("hXrTF");


var $27b5311fe55a1682$exports = {};
$27b5311fe55a1682$exports = import.meta.resolve("kuZae");


var $5d0d813a9d90d076$exports = {};
$5d0d813a9d90d076$exports = import.meta.resolve("l1YYd");


var $e0065fe43859ca3b$exports = {};
$e0065fe43859ca3b$exports = import.meta.resolve("c7LUc");


var $5310eb25ec68b2aa$exports = {};
$5310eb25ec68b2aa$exports = import.meta.resolve("86z5f");


var $3b3f596d115e6335$exports = {};
$3b3f596d115e6335$exports = import.meta.resolve("fIIlM");


var $f443bc2d37eda7c6$exports = {};
$f443bc2d37eda7c6$exports = import.meta.resolve("iCac1");


var $9752a241ba3ed1cd$exports = {};
$9752a241ba3ed1cd$exports = import.meta.resolve("1xcPh");


var $4a8393e7a08ded3d$exports = {};
$4a8393e7a08ded3d$exports = import.meta.resolve("9inm2");


var $e67b450df87d6c6b$exports = {};
$e67b450df87d6c6b$exports = import.meta.resolve("4Vnpq");


var $c6ef9c97687cefd0$exports = {};
$c6ef9c97687cefd0$exports = import.meta.resolve("cPVqy");


var $5d65f570a481959a$exports = {};
$5d65f570a481959a$exports = import.meta.resolve("4bLTk");


var $fe92ec6d8a56b4b9$exports = {};
$fe92ec6d8a56b4b9$exports = import.meta.resolve("l42QU");


var $2533da9c927d3b25$exports = {};
$2533da9c927d3b25$exports = import.meta.resolve("5o7uo");


var $762662d96e2f204e$exports = {};
$762662d96e2f204e$exports = import.meta.resolve("7h52l");


var $3e749358f8f5ee23$exports = {};
$3e749358f8f5ee23$exports = import.meta.resolve("aoJC6");


var $a1c6b99100043b95$exports = {};
$a1c6b99100043b95$exports = import.meta.resolve("8vPLF");


var $c2abe5adbe6f2dbc$exports = {};
$c2abe5adbe6f2dbc$exports = import.meta.resolve("ftZKL");


var $384ce38d072dc7f7$exports = {};
$384ce38d072dc7f7$exports = import.meta.resolve("dD4O9");


var $3f6a90922b0842fa$exports = {};
$3f6a90922b0842fa$exports = import.meta.resolve("hQVNE");


var $20393ec9509e964d$exports = {};
$20393ec9509e964d$exports = import.meta.resolve("4WlRZ");


var $d7ebf84f4c1dd3f5$exports = {};
$d7ebf84f4c1dd3f5$exports = import.meta.resolve("5U3jQ");


var $6c398bc4e99e73ee$exports = {};
$6c398bc4e99e73ee$exports = import.meta.resolve("4UXPn");


var $118dfab1de38582c$exports = {};
$118dfab1de38582c$exports = import.meta.resolve("h7G2f");


let $2b6e161c9edcf319$var$width = window.innerWidth;
let $2b6e161c9edcf319$var$height = window.innerHeight;
// レンダラーを作成
const $2b6e161c9edcf319$var$renderer = new $ilwiq.WebGLRenderer({
    antialias: true,
    canvas: document.querySelector('#myCanvas'),
    alpha: false
});
$2b6e161c9edcf319$var$renderer.setSize($2b6e161c9edcf319$var$width, $2b6e161c9edcf319$var$height);
$2b6e161c9edcf319$var$renderer.setPixelRatio(window.devicePixelRatio);
$2b6e161c9edcf319$var$renderer.autoClear = false;
// シーンを作成
const $2b6e161c9edcf319$var$scene = new $dyjou.Scene();
$2b6e161c9edcf319$var$scene.background = new $dyjou.Color(0x101530);
// カメラを作成
const $2b6e161c9edcf319$var$camera = new $dyjou.PerspectiveCamera(60, $2b6e161c9edcf319$var$width / $2b6e161c9edcf319$var$height, 0.01, 5000);
$2b6e161c9edcf319$var$camera.aspect = $2b6e161c9edcf319$var$width / $2b6e161c9edcf319$var$height;
$2b6e161c9edcf319$var$camera.updateProjectionMatrix();
// カメラの初期座標を設定（X座標:0, Y座標:0, Z座標:0）
$2b6e161c9edcf319$var$camera.position.set(0, 3, 0);
$2b6e161c9edcf319$var$camera.rotation.set(0, -90, 0);
function $2b6e161c9edcf319$var$onResize() {
    $2b6e161c9edcf319$var$width = window.innerWidth;
    $2b6e161c9edcf319$var$height = window.innerHeight;
    $2b6e161c9edcf319$var$renderer.setSize($2b6e161c9edcf319$var$width, $2b6e161c9edcf319$var$height);
    $2b6e161c9edcf319$var$camera.aspect = $2b6e161c9edcf319$var$width / $2b6e161c9edcf319$var$height;
    $2b6e161c9edcf319$var$camera.updateProjectionMatrix();
}
window.addEventListener('resize', $2b6e161c9edcf319$var$onResize);
//const controls = new DeviceOrientationControls(camera,true);
let $2b6e161c9edcf319$var$origin_alpha_rotation;
let $2b6e161c9edcf319$var$origin_beta_rotation;
let $2b6e161c9edcf319$var$origin_gamma_rotation;
let $2b6e161c9edcf319$var$deviceorientation_count = 0;
let $2b6e161c9edcf319$var$which_side_is_bottom;
let $2b6e161c9edcf319$var$dir_type = 0;
let $2b6e161c9edcf319$var$a = undefined;
const $2b6e161c9edcf319$var$alpha_txt = document.getElementById("alpha");
let $2b6e161c9edcf319$var$permission;
console.log($2b6e161c9edcf319$var$permission);
let $2b6e161c9edcf319$var$is_gyro = false;
let $2b6e161c9edcf319$var$offset_rotate_x;
let $2b6e161c9edcf319$var$offset_rotate_y;
let $2b6e161c9edcf319$var$reset_offset = false;
window.addEventListener("deviceorientation", (event)=>{
    if ($2b6e161c9edcf319$var$is_gyro) {
        console.log($2b6e161c9edcf319$var$permission);
        if ($2b6e161c9edcf319$var$deviceorientation_count == 0) {
            $2b6e161c9edcf319$var$origin_alpha_rotation = event.alpha ?? 0;
            $2b6e161c9edcf319$var$origin_beta_rotation = event.beta ?? 0;
            $2b6e161c9edcf319$var$origin_gamma_rotation = event.gamma ?? 0;
            if (!$2b6e161c9edcf319$var$reset_offset) {
                $2b6e161c9edcf319$var$offset_rotate_x = $2b6e161c9edcf319$var$camera.rotation.x * 180 / Math.PI;
                $2b6e161c9edcf319$var$offset_rotate_y = $2b6e161c9edcf319$var$camera.rotation.y * 180 / Math.PI;
            } else {
                if (!$2b6e161c9edcf319$var$at_main_content) {
                    $2b6e161c9edcf319$var$offset_rotate_x = 0;
                    $2b6e161c9edcf319$var$offset_rotate_y = -90;
                } else {
                    $2b6e161c9edcf319$var$offset_rotate_x = 45;
                    $2b6e161c9edcf319$var$offset_rotate_y = -90;
                }
                $2b6e161c9edcf319$var$reset_offset = false;
            }
            if ($2b6e161c9edcf319$var$origin_gamma_rotation > 0 /*  && Math.abs(origin_beta_rotation)<90)||(origin_gamma_rotation< 0 && Math.abs(origin_beta_rotation)>90 */ ) {
                $2b6e161c9edcf319$var$dir_type = 0;
                $2b6e161c9edcf319$var$which_side_is_bottom = 1; //右
                if (Math.abs($2b6e161c9edcf319$var$origin_beta_rotation) > 90) {
                    $2b6e161c9edcf319$var$dir_type = 1;
                    $2b6e161c9edcf319$var$which_side_is_bottom = -1;
                }
            } else if ($2b6e161c9edcf319$var$origin_gamma_rotation <= 0 /*  && Math.abs(origin_beta_rotation)<90)||(origin_gamma_rotation>= 0 && Math.abs(origin_beta_rotation)>90) */ ) {
                $2b6e161c9edcf319$var$which_side_is_bottom = -1; //左
                $2b6e161c9edcf319$var$dir_type = 0;
                if (Math.abs($2b6e161c9edcf319$var$origin_beta_rotation) > 90) {
                    $2b6e161c9edcf319$var$dir_type = 1;
                    $2b6e161c9edcf319$var$which_side_is_bottom = 1;
                }
            }
        }
        if ($2b6e161c9edcf319$var$deviceorientation_count !== 0) {
            let alpha = event.alpha ?? 0;
            const beta = event.beta ?? 0;
            let gamma = event.gamma ?? 0;
            const o_gamma = gamma;
            if ($2b6e161c9edcf319$var$dir_type == 0) {
                console.log($2b6e161c9edcf319$var$origin_alpha_rotation, $2b6e161c9edcf319$var$origin_gamma_rotation);
                let d = 0;
                if (gamma <= 0 && gamma >= -60 && $2b6e161c9edcf319$var$which_side_is_bottom == -1 && Math.abs(beta) >= 100) {
                    gamma -= 180;
                    alpha += 180;
                    console.log($2b6e161c9edcf319$var$a);
                    d = 1;
                } else if (gamma >= 0 && gamma <= 60 && $2b6e161c9edcf319$var$which_side_is_bottom == 1 && Math.abs(beta) >= 100) {
                    gamma += 180;
                    alpha += 180;
                    console.log($2b6e161c9edcf319$var$a);
                    d = 2;
                } else if (gamma >= 0 && $2b6e161c9edcf319$var$which_side_is_bottom == -1 && Math.abs(beta) >= 100 /*  && (camera.rotation.x*180/Math.PI>180 || a) */  /*  && camera.rotation.x*180/Math.PI>180 */ ) {
                    gamma -= 180;
                    alpha += 180;
                    //a = true;
                    console.log($2b6e161c9edcf319$var$a);
                    d = 3;
                } else if (gamma <= 0 && $2b6e161c9edcf319$var$which_side_is_bottom == 1 && Math.abs(beta) >= 100 /*  && camera.rotation.x*180/Math.PI>180 */ ) {
                    gamma += 180;
                    alpha += 180;
                    console.log($2b6e161c9edcf319$var$a);
                    d = 4;
                //a = false;
                }
                console.log(alpha, gamma);
                console.log($2b6e161c9edcf319$var$a);
                //euler.set(-gamma, alpha, 0, 'YXZ');
                //camera.rotation.order = 'YXZ';
                //camera.rotation.y = THREE.MathUtils.degToRad(alpha -origin_alpha_rotation -90);
                //camera.rotation.x = THREE.MathUtils.degToRad(-gamma +origin_gamma_rotation);
                //新連載！～後で後悔するコードの書き方～第1話:数字の根拠は行方不明！メモもコメントも残ってな～い！！
                //角度の種類とか(残された時間では)わからんかったので気合でパズル
                let adjusted_gamma = ($2b6e161c9edcf319$var$which_side_is_bottom * (gamma - $2b6e161c9edcf319$var$origin_gamma_rotation - $2b6e161c9edcf319$var$offset_rotate_x) % 360 + 360) % 360;
                let c = adjusted_gamma;
                let b = 0;
                while(adjusted_gamma < 0)adjusted_gamma += 360;
                if (adjusted_gamma <= 150 && adjusted_gamma >= 90 && $2b6e161c9edcf319$var$which_side_is_bottom == -1 && gamma <= 0 && gamma > -45 && !$2b6e161c9edcf319$var$a) {
                    adjusted_gamma = 90;
                    alpha += 180;
                    b = 1;
                } else if (adjusted_gamma <= 150 && adjusted_gamma >= 90 && $2b6e161c9edcf319$var$which_side_is_bottom == 1 && gamma >= 0 && gamma < 45 && !$2b6e161c9edcf319$var$a) {
                    adjusted_gamma = 90;
                    alpha += 180;
                    b = 2;
                } else if (adjusted_gamma >= 90 && adjusted_gamma < 150 && !$2b6e161c9edcf319$var$a && $2b6e161c9edcf319$var$which_side_is_bottom == -1 && (gamma < 0 || gamma <= 0 && gamma > -45)) {
                    adjusted_gamma = 90;
                    b = 3;
                } else if (adjusted_gamma >= 90 && adjusted_gamma < 150 && !$2b6e161c9edcf319$var$a && $2b6e161c9edcf319$var$which_side_is_bottom == 1 && (gamma > -30 || gamma >= -180 && gamma < -135)) {
                    adjusted_gamma = 90;
                    b = 4;
                } else if (/* which_side_is_bottom == -1 && */ adjusted_gamma > 180 && adjusted_gamma <= 270 && gamma >= 0 && gamma < 90 && $2b6e161c9edcf319$var$a) {
                    adjusted_gamma = 270;
                    //alpha+=180;
                    b = 5;
                } else if (adjusted_gamma > 150 && adjusted_gamma <= 270 && $2b6e161c9edcf319$var$a && gamma < 30 /*  && which_side_is_bottom == -1 */ ) {
                    adjusted_gamma = 270;
                    b = 6;
                }
                const euler = new $dyjou.Euler($dyjou.MathUtils.degToRad(adjusted_gamma), $dyjou.MathUtils.degToRad((alpha - $2b6e161c9edcf319$var$origin_alpha_rotation + $2b6e161c9edcf319$var$offset_rotate_y) % 360 - 360), 0, 'YXZ');
                //console.log(((alpha -origin_alpha_rotation +270)% 360 - 360),((-gamma +origin_gamma_rotation)%360+360)%360);
                $2b6e161c9edcf319$var$camera.rotation.copy(euler);
            //alpha_txt.innerText = Math.round(beta)+" :b "+b+" :d "+d+" :c "+Math.round(c)+" : "+a+" :g "+Math.round(gamma)+" :rx "+Math.round(camera.rotation.x*180/Math.PI)+" :og "+Math.round(o_gamma);
            //alpha_txt.innerText = offset_rotate_y;
            } else if ($2b6e161c9edcf319$var$dir_type == 1) {
                let d = 0;
                if (gamma <= 0 && $2b6e161c9edcf319$var$which_side_is_bottom == -1 && Math.abs(beta) <= 80) {
                    alpha += 180;
                    gamma += 180;
                    d = 1;
                } else if (gamma >= 0 && gamma <= 60 && $2b6e161c9edcf319$var$which_side_is_bottom == -1 && Math.abs(beta) <= 80) {
                    gamma += 180;
                    alpha += 180;
                    console.log($2b6e161c9edcf319$var$a);
                    d = 2;
                }
                if (gamma > 0 && $2b6e161c9edcf319$var$which_side_is_bottom == 1 && Math.abs(beta) <= 80) {
                    alpha += 180;
                    gamma -= 180;
                    d = 3;
                } else if (gamma < 0 && gamma >= -60 && $2b6e161c9edcf319$var$which_side_is_bottom == 1 && Math.abs(beta) <= 80) {
                    gamma -= 180;
                    alpha += 180;
                    console.log($2b6e161c9edcf319$var$a);
                    d = 4;
                }
                let b = 0;
                let adjusted_gamma = ($2b6e161c9edcf319$var$which_side_is_bottom * (gamma - $2b6e161c9edcf319$var$origin_gamma_rotation - $2b6e161c9edcf319$var$offset_rotate_x) % 360 + 360) % 360;
                let c = adjusted_gamma;
                if ($2b6e161c9edcf319$var$which_side_is_bottom == -1 && adjusted_gamma <= 270 && adjusted_gamma >= 150 && $2b6e161c9edcf319$var$a) {
                    adjusted_gamma = 270;
                    b = 1;
                } else if ($2b6e161c9edcf319$var$which_side_is_bottom == 1 && adjusted_gamma <= 270 && adjusted_gamma >= 150 && $2b6e161c9edcf319$var$a) {
                    adjusted_gamma = 270;
                    b = 2;
                } else if ($2b6e161c9edcf319$var$which_side_is_bottom == -1 && adjusted_gamma <= 270 && adjusted_gamma >= 150 && gamma <= 90 && gamma >= 0) {
                    adjusted_gamma = 270;
                    alpha += 180;
                    b = 3;
                } else if ($2b6e161c9edcf319$var$which_side_is_bottom == 1 && adjusted_gamma <= 270 && adjusted_gamma >= 150 && gamma <= 0 && gamma >= -90) {
                    adjusted_gamma = 270;
                    alpha += 180;
                    b = 4;
                } else if ($2b6e161c9edcf319$var$which_side_is_bottom == -1 && adjusted_gamma >= 90 && adjusted_gamma <= 150 && !$2b6e161c9edcf319$var$a) {
                    adjusted_gamma = 90;
                    b = 5;
                } else if ($2b6e161c9edcf319$var$which_side_is_bottom == 1 && adjusted_gamma >= 90 && adjusted_gamma <= 150 && !$2b6e161c9edcf319$var$a) {
                    adjusted_gamma = 90;
                    b = 6;
                }
                const euler = new $dyjou.Euler($dyjou.MathUtils.degToRad(adjusted_gamma), $dyjou.MathUtils.degToRad((alpha - $2b6e161c9edcf319$var$origin_alpha_rotation + $2b6e161c9edcf319$var$offset_rotate_y) % 360 - 360), 0, 'YXZ');
                //console.log(((alpha -origin_alpha_rotation +270)% 360 - 360),((-gamma +origin_gamma_rotation)%360+360)%360);
                $2b6e161c9edcf319$var$camera.rotation.copy(euler);
            //alpha_txt.innerText = Math.round(beta)+" :b "+b+" :d "+d+" :c "+Math.round(c)+" : "+a+" :g "+Math.round(gamma)+" :rx "+Math.round(camera.rotation.x*180/Math.PI)+" :og "+Math.round(o_gamma);
            }
            if ($2b6e161c9edcf319$var$camera.rotation.x * 180 / Math.PI < 180) $2b6e161c9edcf319$var$a = false;
            if ($2b6e161c9edcf319$var$camera.rotation.x * 180 / Math.PI >= 180) $2b6e161c9edcf319$var$a = true;
        }
        $2b6e161c9edcf319$var$deviceorientation_count++;
    }
}, true);
let $2b6e161c9edcf319$var$telescope;
const $2b6e161c9edcf319$var$loader = new (0, $559434fcc6e6401d$export$aa93f11e7884f0f4)();
$2b6e161c9edcf319$var$loader.load((0, (/*@__PURE__*/$parcel$interopDefault($73dcae1a8329d972$exports))), function(gltf) {
    //console.log("Loaded GLTF:", gltf); // <- ここで構造確認
    //console.log("Children:", gltf.scene.children);
    gltf.scene.traverse((child)=>{
        //console.log(child.type, child.name);
        if (child.isMesh) {
            child.material.transparent = false;
            child.material.opacity = 1;
            child.visible = true;
        //console.log(child.material);
        }
    });
    gltf.scene.scale.set(1, 1, 1); // 必要なら 10 や 0.1 に変えて調整
    gltf.scene.position.set(2, 0, 0);
    gltf.scene.rotation.y = Math.PI / 2;
    $2b6e161c9edcf319$var$telescope = gltf.scene;
    $2b6e161c9edcf319$var$scene.add(gltf.scene);
});
/* import modelUrl2 from './water.glb?url';
const loader2 = new GLTFLoader();
loader2.load(modelUrl2, function (gltf) {
    console.log("Loaded GLTF:", gltf); // <- ここで構造確認
    console.log("Children:", gltf.scene.children);
    gltf.scene.traverse((child) => {
      console.log(child.type, child.name);
      if (child.isMesh) {
        child.material.transparent = false;
        child.material.opacity = 1;
        child.visible = true;
        console.log(child.material);
      }
    });
    gltf.scene.scale.set(1, 1, 1); // 必要なら 10 や 0.1 に変えて調整
    gltf.scene.position.set(0,0,-1)
    scene.add(gltf.scene);
    
}); */ const $2b6e161c9edcf319$var$textureLoader = new $dyjou.TextureLoader();
const $2b6e161c9edcf319$var$diffuseMap = $2b6e161c9edcf319$var$textureLoader.load('textures/color.png'); // カラーマップ
const $2b6e161c9edcf319$var$normalMap = $2b6e161c9edcf319$var$textureLoader.load((0, (/*@__PURE__*/$parcel$interopDefault($74cf49d57ca99315$exports)))); // ノーマルマップ
const $2b6e161c9edcf319$var$roughnessMap = $2b6e161c9edcf319$var$textureLoader.load((0, (/*@__PURE__*/$parcel$interopDefault($ad84c9be58b7a2d3$exports)))); // ラフネスマップ（任意）
// マテリアルに適用
const $2b6e161c9edcf319$var$material = new $dyjou.MeshStandardMaterial({
    color: 0x6DFFF6,
    normalMap: $2b6e161c9edcf319$var$normalMap,
    roughnessMap: $2b6e161c9edcf319$var$roughnessMap,
    metalness: 0.2,
    roughness: 0.4,
    envMapIntensity: 1
});
$2b6e161c9edcf319$var$material.needsUpdate = true;
// 平面ジオメトリ（幅500, 高さ500）
const $2b6e161c9edcf319$var$geometry = new $dyjou.PlaneGeometry(6000, 6000, 1, 1);
// メッシュ作成
const $2b6e161c9edcf319$var$plane = new $dyjou.Mesh($2b6e161c9edcf319$var$geometry, $2b6e161c9edcf319$var$material);
// 初期状態だとYZ平面に立っているので、X軸まわりに -90度 回転させて、XZ平面に変更
$2b6e161c9edcf319$var$plane.rotation.x = -Math.PI / 2;
// 中心を (0, 0, 0) に配置（デフォルトです）
$2b6e161c9edcf319$var$plane.position.set(0, 0, 0);
//scene.add(plane);  
const $2b6e161c9edcf319$var$light = new $dyjou.AmbientLight(0xFFFFFF, 0.1);
$2b6e161c9edcf319$var$scene.add($2b6e161c9edcf319$var$light);
let $2b6e161c9edcf319$var$isMouseDown = false;
let $2b6e161c9edcf319$var$previousMousePosition = {
    x: 0,
    y: 0
};
let $2b6e161c9edcf319$var$yaw = -Math.PI / 2; // 左右
let $2b6e161c9edcf319$var$pitch = 0; // 上下
let $2b6e161c9edcf319$var$isLooked = false;
$2b6e161c9edcf319$var$camera.rotation.y = $2b6e161c9edcf319$var$yaw;
$2b6e161c9edcf319$var$camera.rotation.x = $2b6e161c9edcf319$var$pitch;
const $2b6e161c9edcf319$var$canvas = document.getElementById("myCanvas");
$2b6e161c9edcf319$var$canvas.addEventListener('mousedown', (e)=>{
    $2b6e161c9edcf319$var$isMouseDown = true;
    if (!$2b6e161c9edcf319$var$at_main_content) {
        $2b6e161c9edcf319$var$previousMousePosition.x = e.clientX;
        $2b6e161c9edcf319$var$previousMousePosition.y = e.clientY;
    }
    if ($2b6e161c9edcf319$var$at_main_content && !$2b6e161c9edcf319$var$in_transition_telescope) {
        if (document.pointerLockElement === $2b6e161c9edcf319$var$canvas) document.exitPointerLock();
        else $2b6e161c9edcf319$var$canvas.requestPointerLock();
    }
});
let $2b6e161c9edcf319$var$ignoreNextMouseMove = false;
document.addEventListener('pointerlockchange', ()=>{
    if (document.pointerLockElement === $2b6e161c9edcf319$var$canvas) {
        console.log("Pointer lock \u958B\u59CB");
        $2b6e161c9edcf319$var$ignoreNextMouseMove = true;
        document.addEventListener('mousemove', $2b6e161c9edcf319$var$onMouseMove, false);
    } else {
        console.log("Pointer lock \u7D42\u4E86");
        document.removeEventListener('mousemove', $2b6e161c9edcf319$var$onMouseMove, false);
        console.log("Pointer lock \u7D42\u4E862");
    }
});
function $2b6e161c9edcf319$var$onMouseMove(event) {
    /* if (ignoreNextMouseMove) {
        ignoreNextMouseMove = false;
        return; // 最初の1回をスキップ！
    } */ const movementX = event.movementX || 0;
    const movementY = event.movementY || 0;
    // movementX/Y を使ってカメラ角度を調整
    $2b6e161c9edcf319$var$yaw += movementX * 0.0005;
    $2b6e161c9edcf319$var$pitch += movementY * 0.0005;
    const maxPitch = Math.PI / 2 - 0.01;
    const minPitch = -Math.PI / 2 + 0.01;
    $2b6e161c9edcf319$var$pitch = Math.max(minPitch, Math.min(maxPitch, $2b6e161c9edcf319$var$pitch));
    $2b6e161c9edcf319$var$camera.rotation.order = 'YXZ';
    $2b6e161c9edcf319$var$camera.rotation.y = $2b6e161c9edcf319$var$yaw;
    $2b6e161c9edcf319$var$camera.rotation.x = $2b6e161c9edcf319$var$pitch;
//console.log(yaw,pitch);
}
document.addEventListener('mouseup', ()=>{
    $2b6e161c9edcf319$var$at_main_content && $2b6e161c9edcf319$var$in_transition_telescope;
    $2b6e161c9edcf319$var$isMouseDown = false;
});
document.addEventListener('mousemove', (e)=>{
    if (!$2b6e161c9edcf319$var$isMouseDown) return;
    if (!$2b6e161c9edcf319$var$at_main_content) {
        const deltaX = e.clientX - $2b6e161c9edcf319$var$previousMousePosition.x;
        const deltaY = e.clientY - $2b6e161c9edcf319$var$previousMousePosition.y;
        $2b6e161c9edcf319$var$previousMousePosition.x = e.clientX;
        $2b6e161c9edcf319$var$previousMousePosition.y = e.clientY;
        if (!$2b6e161c9edcf319$var$at_main_content) {
            $2b6e161c9edcf319$var$yaw += deltaX * 0.003;
            $2b6e161c9edcf319$var$pitch += deltaY * 0.003;
        } else {
            $2b6e161c9edcf319$var$yaw += deltaX * 0.0009;
            $2b6e161c9edcf319$var$pitch += deltaY * 0.0009;
        }
        const maxPitch = Math.PI / 2 - 0.01;
        const minPitch = -Math.PI / 2 + 0.01;
        $2b6e161c9edcf319$var$pitch = Math.max(minPitch, Math.min(maxPitch, $2b6e161c9edcf319$var$pitch));
        $2b6e161c9edcf319$var$camera.rotation.order = 'YXZ';
        $2b6e161c9edcf319$var$camera.rotation.y = $2b6e161c9edcf319$var$yaw;
        $2b6e161c9edcf319$var$camera.rotation.x = $2b6e161c9edcf319$var$pitch;
    }
//console.log(yaw,pitch);
});
let $2b6e161c9edcf319$var$isTouching = false;
let $2b6e161c9edcf319$var$allow_touch_move = true;
$2b6e161c9edcf319$var$canvas.addEventListener('touchstart', (e)=>{
    if (e.touches.length === 1) {
        $2b6e161c9edcf319$var$isTouching = true;
        $2b6e161c9edcf319$var$previousMousePosition.x = e.touches[0].clientX;
        $2b6e161c9edcf319$var$previousMousePosition.y = e.touches[0].clientY;
    }
});
$2b6e161c9edcf319$var$canvas.addEventListener('touchmove', (e)=>{
    if (!$2b6e161c9edcf319$var$isTouching || e.touches.length !== 1 || $2b6e161c9edcf319$var$is_gyro || !$2b6e161c9edcf319$var$allow_touch_move) return;
    const touch = e.touches[0];
    const deltaX = touch.clientX - $2b6e161c9edcf319$var$previousMousePosition.x;
    const deltaY = touch.clientY - $2b6e161c9edcf319$var$previousMousePosition.y;
    $2b6e161c9edcf319$var$previousMousePosition.x = touch.clientX;
    $2b6e161c9edcf319$var$previousMousePosition.y = touch.clientY;
    if (!$2b6e161c9edcf319$var$at_main_content) {
        $2b6e161c9edcf319$var$yaw += deltaX * 0.003;
        $2b6e161c9edcf319$var$pitch += deltaY * 0.003;
    } else {
        $2b6e161c9edcf319$var$yaw += deltaX * 0.004;
        $2b6e161c9edcf319$var$pitch += deltaY * 0.004;
    }
    const maxPitch = Math.PI / 2 - 0.01;
    const minPitch = -Math.PI / 2 + 0.01;
    $2b6e161c9edcf319$var$pitch = Math.max(minPitch, Math.min(maxPitch, $2b6e161c9edcf319$var$pitch));
    $2b6e161c9edcf319$var$camera.rotation.order = 'YXZ';
    $2b6e161c9edcf319$var$camera.rotation.y = $2b6e161c9edcf319$var$yaw;
    $2b6e161c9edcf319$var$camera.rotation.x = $2b6e161c9edcf319$var$pitch;
});
$2b6e161c9edcf319$var$canvas.addEventListener('touchend', ()=>{
    $2b6e161c9edcf319$var$isTouching = false;
});
function $2b6e161c9edcf319$var$tick() {
    requestAnimationFrame($2b6e161c9edcf319$var$tick);
    // 箱を回転させる
    $2b6e161c9edcf319$var$camera.rotation.x += 0.01;
    $2b6e161c9edcf319$var$camera.rotation.y += 0.01;
    // レンダリング
    $2b6e161c9edcf319$var$renderer.render($2b6e161c9edcf319$var$scene, $2b6e161c9edcf319$var$camera);
}
let $2b6e161c9edcf319$var$time = 0;
const $2b6e161c9edcf319$var$raycaster = new $dyjou.Raycaster();
$2b6e161c9edcf319$var$raycaster.params.Points.threshold = 30;
const $2b6e161c9edcf319$var$mouse = new $dyjou.Vector2();
const $2b6e161c9edcf319$var$canvas_panel = document.createElement('canvas');
const $2b6e161c9edcf319$var$ctx = $2b6e161c9edcf319$var$canvas_panel.getContext('2d');
$2b6e161c9edcf319$var$ctx.canvas.width = 960;
$2b6e161c9edcf319$var$ctx.canvas.height = 540;
// 背景
$2b6e161c9edcf319$var$ctx.fillStyle = 'rgba(255, 255, 255, 0)';
$2b6e161c9edcf319$var$ctx.fillRect(0, 0, $2b6e161c9edcf319$var$canvas_panel.width, $2b6e161c9edcf319$var$canvas_panel.height);
const $2b6e161c9edcf319$var$img = new Image();
let $2b6e161c9edcf319$var$panel; // panelを外で定義しておく
$2b6e161c9edcf319$var$img.onload = ()=>{
    $2b6e161c9edcf319$var$ctx.drawImage($2b6e161c9edcf319$var$img, 0, 0);
    // テキスト描画
    $2b6e161c9edcf319$var$ctx.fillStyle = 'lightblue';
    $2b6e161c9edcf319$var$ctx.textAlign = 'center';
    $2b6e161c9edcf319$var$ctx.textBaseline = 'middle';
    $2b6e161c9edcf319$var$ctx.font = '100px sans-serif';
    $2b6e161c9edcf319$var$ctx.fillText("\u671B\u9060\u93E1", 580, 170); // 中央寄りに
    // Canvas を Three.js のテクスチャに変換
    const texture_panel = new $dyjou.CanvasTexture($2b6e161c9edcf319$var$canvas_panel);
    texture_panel.needsUpdate = true;
    // 平面ジオメトリ（縦横比をキャンバスと一致させると綺麗）
    const geometry_panel = new $dyjou.PlaneGeometry(2, 1); // 縦横 = 2:1
    geometry_panel.translate(1, 0.5, 0);
    const material_panel = new $dyjou.MeshBasicMaterial({
        map: texture_panel,
        transparent: true,
        opacity: 1.5,
        side: $dyjou.DoubleSide,
        alphaTest: 0.1,
        depthWrite: false
    });
    $2b6e161c9edcf319$var$panel = new $dyjou.Mesh(geometry_panel, material_panel);
    // 表示位置を調整（カメラから見えるところに）
    $2b6e161c9edcf319$var$panel.position.set(1, 3, 0);
    $2b6e161c9edcf319$var$panel.rotation.y = -Math.PI / 2;
    $2b6e161c9edcf319$var$panel.visible = false;
    $2b6e161c9edcf319$var$scene.add($2b6e161c9edcf319$var$panel);
};
$2b6e161c9edcf319$var$img.src = (0, (/*@__PURE__*/$parcel$interopDefault($ddf48f29f0c57660$exports)));
const $2b6e161c9edcf319$var$chTime_x_list = {
    "y5": [
        0,
        0.09
    ],
    "y4": [
        0.091,
        0.18
    ],
    "y3": [
        0.181,
        0.27
    ],
    "y2": [
        0.271,
        0.36
    ],
    "y1": [
        0.361,
        0.45
    ],
    "m2": [
        0.52,
        0.61
    ],
    "m1": [
        0.611,
        0.70
    ],
    "d2": [
        0.77,
        0.86
    ],
    "d1": [
        0.861,
        0.95
    ],
    "h2": [
        0.36,
        0.44
    ],
    "h1": [
        0.441,
        0.52
    ],
    "f2": [
        0.6,
        0.685
    ],
    "f1": [
        0.686,
        0.77
    ]
};
const $2b6e161c9edcf319$var$chTime_y_list = {
    "up1": [
        1,
        0.935
    ],
    "down1": [
        0.595,
        0.525
    ],
    "up2": [
        0.485,
        0.425
    ],
    "down2": [
        0.12,
        0.05
    ]
};
//時間変更を記録する変数
let $2b6e161c9edcf319$var$CT_year, $2b6e161c9edcf319$var$CT_month, $2b6e161c9edcf319$var$CT_day, $2b6e161c9edcf319$var$CT_hour, $2b6e161c9edcf319$var$CT_min, $2b6e161c9edcf319$var$CT_sec;
function $2b6e161c9edcf319$var$isValidDate(y, m, d) {
    const date = new Date(y, m - 1, d);
    return date.getFullYear() === y && date.getMonth() === m - 1 && date.getDate() === d;
}
function $2b6e161c9edcf319$var$getMaxDay(year, month) {
    return new Date(year, month, 0).getDate(); //前月の末日
}
let $2b6e161c9edcf319$var$mousedown_on_telescope = false;
$2b6e161c9edcf319$var$canvas.addEventListener('mousedown', (event)=>{
    if (!$2b6e161c9edcf319$var$at_main_content) {
        const element = event.currentTarget;
        //canvas上のマウスのXY座標
        const x = event.clientX - element.offsetLeft;
        const y = event.clientY - element.offsetTop;
        //canvasの幅と高さを取得
        const w = element.offsetWidth;
        const h = element.offsetHeight;
        //マウス座標を-1〜1の範囲に変換
        $2b6e161c9edcf319$var$mouse.x = x / w * 2 - 1;
        $2b6e161c9edcf319$var$mouse.y = -(y / h) * 2 + 1;
        // マウス位置からRayを発射
        $2b6e161c9edcf319$var$scene.updateMatrixWorld(); // 必須: ワールド行列の更新
        $2b6e161c9edcf319$var$raycaster.setFromCamera($2b6e161c9edcf319$var$mouse, $2b6e161c9edcf319$var$camera);
        var allObjects;
        if (!$2b6e161c9edcf319$var$changing_time && !$2b6e161c9edcf319$var$moving_location && !$2b6e161c9edcf319$var$transitioning) {
            allObjects = $2b6e161c9edcf319$var$scene.children.filter((obj)=>obj !== $2b6e161c9edcf319$var$panel && obj !== $2b6e161c9edcf319$var$star_panel && obj !== $2b6e161c9edcf319$var$star_panel_time); // panelを除外
            $2b6e161c9edcf319$var$particle_list.forEach((particles)=>{
                allObjects = allObjects.filter((obj)=>obj !== particles);
            });
        } else allObjects = $2b6e161c9edcf319$var$scene.children.filter((obj)=>obj === $2b6e161c9edcf319$var$star_panel_time);
        if ($2b6e161c9edcf319$var$changing_location_Q != 0) allObjects = [];
        // オブジェクトとの交差を検出
        const intersects = $2b6e161c9edcf319$var$raycaster.intersectObjects(allObjects, true);
        console.log(intersects);
        const meshHits = intersects.filter((i)=>i.object.isMesh); //Points
        console.log(meshHits);
        // 交差したオブジェクトがあればイベントを発火
        if (meshHits.length > 0) {
            const object = meshHits[0].object;
            if (!$2b6e161c9edcf319$var$changing_time) {
                let group = object;
                while(group.parent && !group.parent.name)group = group.parent;
                if (group.parent) group = group.parent;
                //console.log('クリックされたグループ:', group.name);
                if (group.name == "\u671B\u9060\u93E1") $2b6e161c9edcf319$var$mousedown_on_telescope = true;
            } else {
                let simulatedDate = $2b6e161c9edcf319$var$getSimulatedDate();
                simulatedDate = new Date(simulatedDate.getTime() + $2b6e161c9edcf319$var$offsetHours * 3600000);
                let year = simulatedDate.getFullYear();
                let month = simulatedDate.getMonth() + 1;
                let day = simulatedDate.getDate();
                let hour = simulatedDate.getHours();
                let min = simulatedDate.getMinutes();
                console.log(meshHits[0].uv);
                const click_uv = meshHits[0].uv;
                for(let keyx in $2b6e161c9edcf319$var$chTime_x_list){
                    console.log(keyx);
                    console.log($2b6e161c9edcf319$var$chTime_x_list[keyx]);
                    if ($2b6e161c9edcf319$var$chTime_x_list[keyx][0] < click_uv.x && click_uv.x < $2b6e161c9edcf319$var$chTime_x_list[keyx][1]) {
                        for(let keyy in $2b6e161c9edcf319$var$chTime_y_list)if ($2b6e161c9edcf319$var$chTime_y_list[keyy][0] > click_uv.y && click_uv.y > $2b6e161c9edcf319$var$chTime_y_list[keyy][1]) {
                            if ("up1" == keyy) {
                                console.log(keyy);
                                if (keyx.includes("y")) {
                                    const digit = Number(keyx.replace("y", ""));
                                    console.log("digit:", digit);
                                    if (digit == 5) {
                                        if ($2b6e161c9edcf319$var$CT_year >= 90000) $2b6e161c9edcf319$var$CT_year -= 90000;
                                        else $2b6e161c9edcf319$var$CT_year += 10000;
                                    } else if (digit == 4) {
                                        if ($2b6e161c9edcf319$var$CT_year % 10000 >= 9000) $2b6e161c9edcf319$var$CT_year -= 9000;
                                        else $2b6e161c9edcf319$var$CT_year += 1000;
                                    } else if (digit == 3) {
                                        if ($2b6e161c9edcf319$var$CT_year % 1000 >= 900) $2b6e161c9edcf319$var$CT_year -= 900;
                                        else $2b6e161c9edcf319$var$CT_year += 100;
                                    } else if (digit == 2) {
                                        if ($2b6e161c9edcf319$var$CT_year % 100 >= 90) $2b6e161c9edcf319$var$CT_year -= 90;
                                        else $2b6e161c9edcf319$var$CT_year += 10;
                                    } else if (digit == 1) {
                                        if ($2b6e161c9edcf319$var$CT_year % 10 >= 9) $2b6e161c9edcf319$var$CT_year -= 9;
                                        else $2b6e161c9edcf319$var$CT_year += 1;
                                    }
                                } else if (keyx.includes("m")) {
                                    let oldCT_month = $2b6e161c9edcf319$var$CT_month;
                                    const digit = Number(keyx.replace("m", ""));
                                    if (digit == 2) {
                                        if ($2b6e161c9edcf319$var$CT_month % 10 < 3) {
                                            if ($2b6e161c9edcf319$var$CT_month >= 10) $2b6e161c9edcf319$var$CT_month -= 10;
                                            else $2b6e161c9edcf319$var$CT_month += 10;
                                        }
                                    } else {
                                        if ($2b6e161c9edcf319$var$CT_month % 10 >= 9) $2b6e161c9edcf319$var$CT_month -= 8;
                                        else $2b6e161c9edcf319$var$CT_month += 1;
                                        if ($2b6e161c9edcf319$var$CT_month % 10 >= 3 && $2b6e161c9edcf319$var$CT_month >= 10) $2b6e161c9edcf319$var$CT_month -= 10;
                                    }
                                    if ($2b6e161c9edcf319$var$CT_month == 0) $2b6e161c9edcf319$var$CT_month = oldCT_month;
                                    let Max_day = $2b6e161c9edcf319$var$getMaxDay($2b6e161c9edcf319$var$CT_year, $2b6e161c9edcf319$var$CT_month);
                                    if (Max_day < $2b6e161c9edcf319$var$CT_day) $2b6e161c9edcf319$var$CT_day = Max_day;
                                } else if (keyx.includes("d")) {
                                    const digit = Number(keyx.replace("d", ""));
                                    let old_CT_day = $2b6e161c9edcf319$var$CT_day;
                                    if (digit == 2) {
                                        let m_Threshold;
                                        if ($2b6e161c9edcf319$var$CT_month == 2) m_Threshold = 20;
                                        else m_Threshold = 30;
                                        if ($2b6e161c9edcf319$var$CT_day >= m_Threshold) $2b6e161c9edcf319$var$CT_day -= m_Threshold;
                                        else $2b6e161c9edcf319$var$CT_day += 10;
                                    } else if ($2b6e161c9edcf319$var$CT_day % 10 >= 9) $2b6e161c9edcf319$var$CT_day -= 9;
                                    else $2b6e161c9edcf319$var$CT_day += 1;
                                    if (!$2b6e161c9edcf319$var$isValidDate($2b6e161c9edcf319$var$CT_year, $2b6e161c9edcf319$var$CT_month, $2b6e161c9edcf319$var$CT_day)) $2b6e161c9edcf319$var$CT_day = old_CT_day;
                                }
                            }
                            if ("down1" == keyy) {
                                if (keyx.includes("y")) {
                                    const digit = Number(keyx.replace("y", ""));
                                    console.log("digit:", digit);
                                    if (digit == 5) {
                                        if ($2b6e161c9edcf319$var$CT_year < 10000) $2b6e161c9edcf319$var$CT_year += 90000;
                                        else $2b6e161c9edcf319$var$CT_year -= 10000;
                                    } else if (digit == 4) {
                                        if ($2b6e161c9edcf319$var$CT_year % 10000 < 1000) $2b6e161c9edcf319$var$CT_year += 9000;
                                        else $2b6e161c9edcf319$var$CT_year -= 1000;
                                    } else if (digit == 3) {
                                        if ($2b6e161c9edcf319$var$CT_year % 1000 < 100) $2b6e161c9edcf319$var$CT_year += 900;
                                        else $2b6e161c9edcf319$var$CT_year -= 100;
                                    } else if (digit == 2) {
                                        if ($2b6e161c9edcf319$var$CT_year % 100 < 10) $2b6e161c9edcf319$var$CT_year += 90;
                                        else $2b6e161c9edcf319$var$CT_year -= 10;
                                    } else if (digit == 1) {
                                        if ($2b6e161c9edcf319$var$CT_year % 10 == 0) $2b6e161c9edcf319$var$CT_year += 9;
                                        else $2b6e161c9edcf319$var$CT_year -= 1;
                                    }
                                } else if (keyx.includes("m")) {
                                    let oldCT_month = $2b6e161c9edcf319$var$CT_month;
                                    const digit = Number(keyx.replace("m", ""));
                                    if (digit == 2) {
                                        if ($2b6e161c9edcf319$var$CT_month % 10 < 3) {
                                            if ($2b6e161c9edcf319$var$CT_month < 10) $2b6e161c9edcf319$var$CT_month += 10;
                                            else $2b6e161c9edcf319$var$CT_month -= 10;
                                        }
                                    } else {
                                        if ($2b6e161c9edcf319$var$CT_month % 10 == 1) $2b6e161c9edcf319$var$CT_month += 8;
                                        else $2b6e161c9edcf319$var$CT_month -= 1;
                                        if ($2b6e161c9edcf319$var$CT_month % 10 >= 3 && $2b6e161c9edcf319$var$CT_month >= 10) $2b6e161c9edcf319$var$CT_month -= 10;
                                    }
                                    if ($2b6e161c9edcf319$var$CT_month == 0) $2b6e161c9edcf319$var$CT_month = oldCT_month;
                                    let Max_day = $2b6e161c9edcf319$var$getMaxDay($2b6e161c9edcf319$var$CT_year, $2b6e161c9edcf319$var$CT_month);
                                    if (Max_day < $2b6e161c9edcf319$var$CT_day) $2b6e161c9edcf319$var$CT_day = Max_day;
                                } else if (keyx.includes("d")) {
                                    const digit = Number(keyx.replace("d", ""));
                                    let old_CT_day = $2b6e161c9edcf319$var$CT_day;
                                    if (digit == 2) {
                                        let m_Threshold;
                                        if ($2b6e161c9edcf319$var$CT_month == 2) m_Threshold = 20;
                                        else m_Threshold = 30;
                                        if ($2b6e161c9edcf319$var$CT_day < 10) $2b6e161c9edcf319$var$CT_day += m_Threshold;
                                        else $2b6e161c9edcf319$var$CT_day -= 10;
                                    } else if ($2b6e161c9edcf319$var$CT_day % 10 == 0) $2b6e161c9edcf319$var$CT_day += 9;
                                    else $2b6e161c9edcf319$var$CT_day -= 1;
                                    if (!$2b6e161c9edcf319$var$isValidDate($2b6e161c9edcf319$var$CT_year, $2b6e161c9edcf319$var$CT_month, $2b6e161c9edcf319$var$CT_day)) $2b6e161c9edcf319$var$CT_day = old_CT_day;
                                }
                            }
                            if ("up2" == keyy) {
                                if (keyx.includes("h")) {
                                    const digit = Number(keyx.replace("h", ""));
                                    let old_CT_hour = $2b6e161c9edcf319$var$CT_hour;
                                    if (digit == 2) {
                                        let max2;
                                        if ($2b6e161c9edcf319$var$CT_hour % 10 > 3) max2 = 10;
                                        else max2 = 20;
                                        if ($2b6e161c9edcf319$var$CT_hour >= max2) $2b6e161c9edcf319$var$CT_hour -= max2;
                                        else $2b6e161c9edcf319$var$CT_hour += 10;
                                    } else {
                                        if ($2b6e161c9edcf319$var$CT_hour % 10 == 9) $2b6e161c9edcf319$var$CT_hour -= 9;
                                        else $2b6e161c9edcf319$var$CT_hour += 1;
                                        if ($2b6e161c9edcf319$var$CT_hour % 10 >= 4 && $2b6e161c9edcf319$var$CT_hour >= 20) $2b6e161c9edcf319$var$CT_hour -= 20;
                                    }
                                    if ($2b6e161c9edcf319$var$CT_hour >= 24) $2b6e161c9edcf319$var$CT_hour = old_CT_hour;
                                }
                                if (keyx.includes("f")) {
                                    const digit = Number(keyx.replace("f", ""));
                                    if (digit == 2) {
                                        if ($2b6e161c9edcf319$var$CT_min >= 50) $2b6e161c9edcf319$var$CT_min -= 50;
                                        else $2b6e161c9edcf319$var$CT_min += 10;
                                    } else if ($2b6e161c9edcf319$var$CT_min % 10 == 9) $2b6e161c9edcf319$var$CT_min -= 9;
                                    else $2b6e161c9edcf319$var$CT_min += 1;
                                }
                            }
                            if ("down2" == keyy) {
                                if (keyx.includes("h")) {
                                    const digit = Number(keyx.replace("h", ""));
                                    if (digit == 2) {
                                        let max2;
                                        if ($2b6e161c9edcf319$var$CT_hour % 10 > 3) max2 = 10;
                                        else max2 = 20;
                                        if ($2b6e161c9edcf319$var$CT_hour < 10) $2b6e161c9edcf319$var$CT_hour += max2;
                                        else $2b6e161c9edcf319$var$CT_hour -= 10;
                                    } else {
                                        if ($2b6e161c9edcf319$var$CT_hour % 10 == 0) $2b6e161c9edcf319$var$CT_hour += 9;
                                        else $2b6e161c9edcf319$var$CT_hour -= 1;
                                        if ($2b6e161c9edcf319$var$CT_hour % 10 >= 4 && $2b6e161c9edcf319$var$CT_hour >= 20) $2b6e161c9edcf319$var$CT_hour -= 20;
                                    }
                                }
                                if (keyx.includes("f")) {
                                    const digit = Number(keyx.replace("f", ""));
                                    if (digit == 2) {
                                        if ($2b6e161c9edcf319$var$CT_min < 10) $2b6e161c9edcf319$var$CT_min += 50;
                                        else $2b6e161c9edcf319$var$CT_min -= 10;
                                    } else if ($2b6e161c9edcf319$var$CT_min % 10 == 0) $2b6e161c9edcf319$var$CT_min += 9;
                                    else $2b6e161c9edcf319$var$CT_min -= 1;
                                }
                            }
                            $2b6e161c9edcf319$var$change_show_time($2b6e161c9edcf319$var$CT_year, $2b6e161c9edcf319$var$CT_month, $2b6e161c9edcf319$var$CT_day, $2b6e161c9edcf319$var$CT_hour, $2b6e161c9edcf319$var$CT_min);
                        }
                    }
                }
            }
        }
    }
});
$2b6e161c9edcf319$var$canvas.addEventListener('mouseup', (event)=>{
    if (!$2b6e161c9edcf319$var$at_main_content) {
        const element = event.currentTarget;
        //canvas上のマウスのXY座標
        const x = event.clientX - element.offsetLeft;
        const y = event.clientY - element.offsetTop;
        //canvasの幅と高さを取得
        const w = element.offsetWidth;
        const h = element.offsetHeight;
        //マウス座標を-1〜1の範囲に変換
        $2b6e161c9edcf319$var$mouse.x = x / w * 2 - 1;
        $2b6e161c9edcf319$var$mouse.y = -(y / h) * 2 + 1;
        // マウス位置からRayを発射
        $2b6e161c9edcf319$var$scene.updateMatrixWorld(); // 必須: ワールド行列の更新
        $2b6e161c9edcf319$var$raycaster.setFromCamera($2b6e161c9edcf319$var$mouse, $2b6e161c9edcf319$var$camera);
        var allObjects;
        if (!$2b6e161c9edcf319$var$changing_time && !$2b6e161c9edcf319$var$moving_location && !$2b6e161c9edcf319$var$transitioning) allObjects = $2b6e161c9edcf319$var$scene.children.filter((obj)=>obj !== $2b6e161c9edcf319$var$panel && obj !== $2b6e161c9edcf319$var$star_panel && obj !== $2b6e161c9edcf319$var$star_panel_time); // panelを除外
        else allObjects = $2b6e161c9edcf319$var$scene.children.filter((obj)=>obj === $2b6e161c9edcf319$var$star_panel_time);
        if ($2b6e161c9edcf319$var$changing_location_Q != 0) allObjects = [];
        if ($2b6e161c9edcf319$var$telescope.visible == false || $2b6e161c9edcf319$var$in_transition_telescope) allObjects = allObjects.filter((obj)=>obj !== $2b6e161c9edcf319$var$telescope);
        // オブジェクトとの交差を検出
        const intersects = $2b6e161c9edcf319$var$raycaster.intersectObjects(allObjects, true);
        //console.log(intersects);
        const meshHits = intersects.filter((i)=>i.object.isMesh); //Points
        //console.log(meshHits);
        // 交差したオブジェクトがあればイベントを発火
        if (meshHits.length > 0) {
            const object = meshHits[0].object;
            if (!$2b6e161c9edcf319$var$changing_time) {
                let group = object;
                while(group.parent && !group.parent.name)group = group.parent;
                if (group.parent) group = group.parent;
                if (group.name == "\u671B\u9060\u93E1" && $2b6e161c9edcf319$var$mousedown_on_telescope == true) {
                    console.log("\u30AF\u30EA\u30C3\u30AF\u3055\u308C\u305F\u30B0\u30EB\u30FC\u30D7:", group.name);
                    $2b6e161c9edcf319$var$mousedown_on_telescope = false;
                    $2b6e161c9edcf319$var$into_telescope();
                //ここからメインコンテンツに移動する。
                //
                }
            }
        }
    }
});
let $2b6e161c9edcf319$var$geometry_hide_panel;
let $2b6e161c9edcf319$var$material_hide_panel;
let $2b6e161c9edcf319$var$hide_plane;
let $2b6e161c9edcf319$var$at_main_content = false;
const $2b6e161c9edcf319$var$show_time_and_location_ele = document.getElementById("show_time_and_location");
const $2b6e161c9edcf319$var$telescope_filter_img = document.getElementById("telescope_filter");
const $2b6e161c9edcf319$var$info_icon = document.getElementById("info_icon");
const $2b6e161c9edcf319$var$info_operate_ele = document.getElementById("info_operate");
const $2b6e161c9edcf319$var$close_parent_info_button = document.getElementById("close_parent_info");
const $2b6e161c9edcf319$var$galaxy_img = document.getElementById("galaxy_img");
const $2b6e161c9edcf319$var$select_galaxy_ele = document.getElementById("select_galaxy");
let $2b6e161c9edcf319$var$in_transition_telescope = false;
function $2b6e161c9edcf319$var$into_telescope() {
    $2b6e161c9edcf319$var$is_gyro = false;
    $2b6e161c9edcf319$var$gyro_setting_icon.style.display = "none";
    $2b6e161c9edcf319$var$gyro_settings_ele.style.display = "none";
    $2b6e161c9edcf319$var$reset_rotate_origin_button.style.display = "none";
    $2b6e161c9edcf319$var$geometry_hide_panel = new $dyjou.PlaneGeometry(10, 10); // 板のサイズ（カメラの前に大きく配置）
    $2b6e161c9edcf319$var$material_hide_panel = new $dyjou.MeshBasicMaterial({
        color: 0xffffff,
        opacity: 10,
        transparent: true // 透明にする
    });
    $2b6e161c9edcf319$var$hide_plane = new $dyjou.Mesh($2b6e161c9edcf319$var$geometry_hide_panel, $2b6e161c9edcf319$var$material_hide_panel);
    $2b6e161c9edcf319$var$in_transition_telescope = true;
    $2b6e161c9edcf319$var$at_main_content = true;
    $2b6e161c9edcf319$var$panel.visible = false;
    $2b6e161c9edcf319$var$allow_touch_move = false;
    $2b6e161c9edcf319$var$change_constellation_name_button.parentElement.style.display = "none";
    $2b6e161c9edcf319$var$change_location_button.parentElement.style.display = "none";
    $2b6e161c9edcf319$var$change_time_button.parentElement.style.display = "none";
    $2b6e161c9edcf319$var$show_time_and_location_ele.style.display = "none";
    $2b6e161c9edcf319$var$canvas.style.cursor = "auto";
    const tl = (0, $357b3f2d5f2ec9d5$export$99ee26438460406a).timeline();
    // 目標の回転（rad）
    console.log($2b6e161c9edcf319$var$camera.rotation.y / Math.PI * 180);
    $2b6e161c9edcf319$var$camera.rotation.y = $2b6e161c9edcf319$var$camera.rotation.y % (Math.PI * 2);
    if ($2b6e161c9edcf319$var$camera.rotation.y > 0) $2b6e161c9edcf319$var$camera.rotation.y -= Math.PI * 2;
    console.log($2b6e161c9edcf319$var$camera.rotation.y / Math.PI * 180);
    const targetRotation = {
        x: -30 * Math.PI / 180,
        y: -Math.PI / 2,
        z: 0
    };
    $2b6e161c9edcf319$var$camera.rotation.order = "YXZ";
    //camera.position.set(0.9,2.3,0)
    // アニメーション実行（2秒でイージング）
    tl.to($2b6e161c9edcf319$var$camera.rotation, {
        duration: 1,
        x: targetRotation.x,
        y: targetRotation.y,
        z: targetRotation.z,
        ease: "power3.out"
    });
    tl.to($2b6e161c9edcf319$var$camera.position, {
        x: 0.9,
        y: 2.3,
        z: 0,
        duration: 1,
        ease: "power2.inOut"
    });
    tl.to($2b6e161c9edcf319$var$camera, {
        zoom: 9,
        duration: 1,
        ease: "power2.inOut",
        onUpdate: ()=>{
            $2b6e161c9edcf319$var$camera.updateProjectionMatrix();
        },
        onComplete: ()=>{
            $2b6e161c9edcf319$var$hide_plane.position.set(1, 0, 0); // カメラの前に配置（距離を調整）
            $2b6e161c9edcf319$var$hide_plane.rotation.y = -Math.PI / 2;
            $2b6e161c9edcf319$var$scene.add($2b6e161c9edcf319$var$hide_plane);
            $2b6e161c9edcf319$var$hide_plane.visible = true;
            $2b6e161c9edcf319$var$hide_plane.material.transparent = true;
            $2b6e161c9edcf319$var$star_points.visible = false;
            $2b6e161c9edcf319$var$constellation_lines.forEach((element)=>{
                element.visible = false;
            });
        }
    });
    tl.to($2b6e161c9edcf319$var$camera.position, {
        x: 0,
        y: 1,
        z: 0,
        duration: 0
    });
    tl.to($2b6e161c9edcf319$var$camera, {
        zoom: 3,
        duration: 0,
        onUpdate: ()=>{
            $2b6e161c9edcf319$var$telescope.visible = false;
            $2b6e161c9edcf319$var$camera.updateProjectionMatrix();
        }
    });
    const targetRotation2 = {
        x: 45 * Math.PI / 180,
        y: -Math.PI / 2,
        z: 0
    };
    tl.to($2b6e161c9edcf319$var$camera.rotation, {
        duration: 0,
        x: targetRotation2.x,
        y: targetRotation2.y,
        z: targetRotation2.z
    });
    tl.to($2b6e161c9edcf319$var$hide_plane.material.color, {
        duration: 1,
        r: 0,
        g: 0,
        b: 0,
        //opacity: 0.3,
        onStart: ()=>{
            $2b6e161c9edcf319$var$telescope_filter_img.style.display = "block";
            //galaxy_img.style.display = "block";
            $2b6e161c9edcf319$var$telescope_filter_img.classList.add("opacity_animation");
        //galaxy_img.classList.add("opacity_animation");
        },
        onComplete: ()=>{
            $2b6e161c9edcf319$var$telescope_filter_img.classList.add("opacity_animation");
            $2b6e161c9edcf319$var$galaxy_img.classList.add("size_animation");
            $2b6e161c9edcf319$var$select_galaxy_ele.style.display = "block";
            //telescope_filter_img.classList.add("opacity_animation");
            $2b6e161c9edcf319$var$yaw = -Math.PI / 2; // 左右
            $2b6e161c9edcf319$var$pitch = 45 * Math.PI / 180; // 上下
            $2b6e161c9edcf319$var$scene.remove($2b6e161c9edcf319$var$hide_plane);
            $2b6e161c9edcf319$var$geometry_hide_panel.dispose();
            $2b6e161c9edcf319$var$material_hide_panel.dispose();
            $2b6e161c9edcf319$var$create_galaxy();
            $2b6e161c9edcf319$var$rotation_pase = 20;
            $2b6e161c9edcf319$var$always_GalaxyRotating = true;
        //scene.remove(hide_plane);
        //in_transition_telescope = false;
        }
    });
}
$2b6e161c9edcf319$var$info_icon.addEventListener("click", ()=>{
    $2b6e161c9edcf319$var$info_icon.style.display = "none";
    $2b6e161c9edcf319$var$info_operate_ele.style.display = "block";
});
$2b6e161c9edcf319$var$close_parent_info_button.addEventListener("click", ()=>{
    $2b6e161c9edcf319$var$info_icon.style.display = "block";
    $2b6e161c9edcf319$var$info_operate_ele.style.display = "none";
});
let $2b6e161c9edcf319$var$tanzaku_imgs_for_line = [
    (0, (/*@__PURE__*/$parcel$interopDefault($bff0ee7dd12d5fb4$exports))),
    (0, (/*@__PURE__*/$parcel$interopDefault($9752a241ba3ed1cd$exports))),
    (0, (/*@__PURE__*/$parcel$interopDefault($e67b450df87d6c6b$exports))),
    (0, (/*@__PURE__*/$parcel$interopDefault($c6ef9c97687cefd0$exports))),
    (0, (/*@__PURE__*/$parcel$interopDefault($5d65f570a481959a$exports))),
    (0, (/*@__PURE__*/$parcel$interopDefault($4a8393e7a08ded3d$exports))),
    (0, (/*@__PURE__*/$parcel$interopDefault($fe92ec6d8a56b4b9$exports)))
];
let $2b6e161c9edcf319$var$line_color_namme = [
    "\u30E9\u30F3\u30C0\u30E0",
    "\u6C34\u8272",
    "\u30AA\u30EC\u30F3\u30B8",
    "\u9EC4\u8272",
    "\u30D4\u30F3\u30AF",
    "\u8D64",
    "\u9752"
];
const $2b6e161c9edcf319$var$change_line_color_button = document.getElementById("change_line_color");
let $2b6e161c9edcf319$var$current_line_color_mode = 0;
const $2b6e161c9edcf319$var$color_mode_txt = document.getElementById("color_mode");
$2b6e161c9edcf319$var$change_line_color_button.addEventListener("click", ()=>{
    $2b6e161c9edcf319$var$current_line_color_mode++;
    $2b6e161c9edcf319$var$current_line_color_mode %= 7;
    document.body.style.setProperty("--bgimg3", `url("${$2b6e161c9edcf319$var$tanzaku_imgs_for_line[$2b6e161c9edcf319$var$current_line_color_mode % 7]}")`);
    document.body.style.setProperty("--bgimg4", `url("${$2b6e161c9edcf319$var$tanzaku_imgs_for_line[($2b6e161c9edcf319$var$current_line_color_mode + 1) % 7]}")`);
    $2b6e161c9edcf319$var$color_mode_txt.innerText = $2b6e161c9edcf319$var$line_color_namme[$2b6e161c9edcf319$var$current_line_color_mode];
});
const $2b6e161c9edcf319$var$canvas_star_panel = document.createElement('canvas');
const $2b6e161c9edcf319$var$ctx_star = $2b6e161c9edcf319$var$canvas_star_panel.getContext('2d');
$2b6e161c9edcf319$var$ctx_star.canvas.width = 960;
$2b6e161c9edcf319$var$ctx_star.canvas.height = 540;
const $2b6e161c9edcf319$var$img2 = new Image();
let $2b6e161c9edcf319$var$star_panel; // panelを外で定義しておく
let $2b6e161c9edcf319$var$texture_panel;
$2b6e161c9edcf319$var$img2.onload = ()=>{
    $2b6e161c9edcf319$var$ctx_star.drawImage($2b6e161c9edcf319$var$img2, 0, 0);
    // テキスト描画
    $2b6e161c9edcf319$var$ctx_star.fillStyle = 'lightblue';
    $2b6e161c9edcf319$var$ctx_star.textAlign = 'center';
    $2b6e161c9edcf319$var$ctx_star.textBaseline = 'middle';
    $2b6e161c9edcf319$var$ctx_star.font = '70px sans-serif';
    /* ctx_star.fillText('ああああああああ', 960/2+100, 540/2+100);
    ctx_star.fillText('あああああああ座', 960/2+100, 540/2-100); */ // Canvas を Three.js のテクスチャに変換
    $2b6e161c9edcf319$var$texture_panel = new $dyjou.CanvasTexture($2b6e161c9edcf319$var$canvas_star_panel);
    $2b6e161c9edcf319$var$texture_panel.needsUpdate = true;
    // 平面ジオメトリ（縦横比をキャンバスと一致させると綺麗）
    const geometry_panel = new $dyjou.PlaneGeometry(200, 100);
    geometry_panel.translate(100, 50, 0);
    const material_panel = new $dyjou.MeshBasicMaterial({
        map: $2b6e161c9edcf319$var$texture_panel,
        transparent: true,
        opacity: 0.7,
        side: $dyjou.DoubleSide,
        alphaTest: 0.1,
        depthWrite: false
    });
    $2b6e161c9edcf319$var$star_panel = new $dyjou.Mesh(geometry_panel, material_panel);
    $2b6e161c9edcf319$var$star_panel.position.set(700, 10, 0);
    $2b6e161c9edcf319$var$star_panel.rotation.y = -Math.PI / 2;
    $2b6e161c9edcf319$var$star_panel.visible = false;
    $2b6e161c9edcf319$var$scene.add($2b6e161c9edcf319$var$star_panel);
};
$2b6e161c9edcf319$var$img2.src = (0, (/*@__PURE__*/$parcel$interopDefault($ddf48f29f0c57660$exports)));
let $2b6e161c9edcf319$var$panel_pos = {
    x: 0,
    y: 0,
    z: 0
};
var $2b6e161c9edcf319$var$HIP2StarName;
fetch((0, (/*@__PURE__*/$parcel$interopDefault($c955cdd67aa99cf2$exports)))).then((res)=>res.json()).then((starnamejson)=>$2b6e161c9edcf319$var$HIP2StarName = starnamejson);
var $2b6e161c9edcf319$var$ConNative2JaName;
fetch((0, (/*@__PURE__*/$parcel$interopDefault($241c34d778a01174$exports)))).then((res)=>res.json()).then((conmejson)=>$2b6e161c9edcf319$var$ConNative2JaName = conmejson);
let $2b6e161c9edcf319$var$inmusicGalaxy = false;
$2b6e161c9edcf319$var$canvas.addEventListener('mousemove', (event)=>{
    if (!$2b6e161c9edcf319$var$at_main_content) {
        // マウス座標を正規化（-1から1の範囲に変換）
        const element = event.currentTarget;
        //canvas上のマウスのXY座標
        const x = event.clientX - element.offsetLeft;
        const y = event.clientY - element.offsetTop;
        //canvasの幅と高さを取得
        const w = element.offsetWidth;
        const h = element.offsetHeight;
        //マウス座標を-1〜1の範囲に変換
        $2b6e161c9edcf319$var$mouse.x = x / w * 2 - 1;
        $2b6e161c9edcf319$var$mouse.y = -(y / h) * 2 + 1;
        // ワールド行列の更新
        $2b6e161c9edcf319$var$scene.updateMatrixWorld(); // シーン内のオブジェクトのワールド行列を更新
        $2b6e161c9edcf319$var$raycaster.intersectObject($2b6e161c9edcf319$var$panel, false);
        // マウス位置からRayを発射
        $2b6e161c9edcf319$var$raycaster.setFromCamera($2b6e161c9edcf319$var$mouse, $2b6e161c9edcf319$var$camera);
        var allObjects;
        if (!$2b6e161c9edcf319$var$changing_time && !$2b6e161c9edcf319$var$moving_location && !$2b6e161c9edcf319$var$inmusicGalaxy) {
            allObjects = $2b6e161c9edcf319$var$scene.children.filter((obj)=>obj !== $2b6e161c9edcf319$var$panel && obj !== $2b6e161c9edcf319$var$star_panel && obj !== $2b6e161c9edcf319$var$star_panel_time); // panelを除外
            $2b6e161c9edcf319$var$particle_list.forEach((particles)=>{
                allObjects = allObjects.filter((obj)=>obj !== particles);
            });
        } else allObjects = $2b6e161c9edcf319$var$scene.children.filter((obj)=>obj === $2b6e161c9edcf319$var$star_panel_time);
        if ($2b6e161c9edcf319$var$changing_location_Q != 0) allObjects = [];
        if ($2b6e161c9edcf319$var$telescope.visible == false) {
            allObjects = allObjects.filter((obj)=>obj !== $2b6e161c9edcf319$var$telescope);
            $2b6e161c9edcf319$var$particle_list.forEach((particles)=>{
                allObjects = allObjects.filter((obj)=>obj !== particles);
            });
        }
        // オブジェクトとの交差を検出
        const intersects = $2b6e161c9edcf319$var$raycaster.intersectObjects(allObjects, true);
        const pointHits = intersects.filter((i)=>i.object.isPoints);
        const meshHits = intersects.filter((i)=>i.object.isMesh);
        //console.log(meshHits)
        //console.log(pointHits);
        // 交差したオブジェクトがあればカーソルをポインターに変更
        let hit_telescope = false;
        if (meshHits.length > 0) {
            const object = meshHits[0].object;
            let group = object;
            while(group.parent && !group.parent.name)group = group.parent;
            if (group.parent) group = group.parent;
            if (group.name == "\u671B\u9060\u93E1" && !$2b6e161c9edcf319$var$transitioning && !$2b6e161c9edcf319$var$moving_location) {
                console.log($2b6e161c9edcf319$var$transitioning);
                hit_telescope = true;
                $2b6e161c9edcf319$var$panel.visible = true;
                $2b6e161c9edcf319$var$star_panel.visible = false;
                //console.log(meshHits[0].point);
                //panel.position.set(meshHits[0].point.x,meshHits[0].point.y,meshHits[0].point.z);
                $2b6e161c9edcf319$var$panel_pos.x = meshHits[0].point.x;
                $2b6e161c9edcf319$var$panel_pos.y = meshHits[0].point.y;
                $2b6e161c9edcf319$var$panel_pos.z = meshHits[0].point.z;
                document.body.style.cursor = 'pointer'; // ポインターに変更
            } else {
                $2b6e161c9edcf319$var$panel.visible = false;
                document.body.style.cursor = 'auto'; // 通常のカーソルに戻す
            }
        } else {
            $2b6e161c9edcf319$var$panel.visible = false;
            document.body.style.cursor = 'auto'; // 通常のカーソルに戻す
        }
        if (pointHits.length > 0 && !hit_telescope) {
            let hit_constellations = [];
            pointHits.forEach((point)=>{
                //console.log(point.index);
                const index = point.index;
                const hip = $2b6e161c9edcf319$var$hipNumbers[index];
                //console.log(hip);
                const constellations = $2b6e161c9edcf319$var$constellations_stars[hip];
                //console.log(constellations);
                if (constellations) //console.log(point);
                hit_constellations.push([
                    point.distanceToRay,
                    hip,
                    constellations,
                    point
                ]);
            });
            if (hit_constellations.length > 0) {
                //console.log(hit_constellations);
                let min_dis = Infinity;
                let min_index;
                let index = 0;
                hit_constellations.forEach((element)=>{
                    let ray_distance = element[0];
                    if (min_dis > ray_distance) {
                        min_dis = ray_distance;
                        min_index = index;
                    }
                    index++;
                });
                //console.log(hit_constellations[min_index]);
                const hip = hit_constellations[min_index][1];
                const constellation = hit_constellations[min_index][2];
                const min_object = hit_constellations[min_index][3];
                $2b6e161c9edcf319$var$star_panel.position.set(min_object.point.x, min_object.point.y, min_object.point.z);
                $2b6e161c9edcf319$var$star_panel.visible = true;
                $2b6e161c9edcf319$var$ctx_star.clearRect(0, 0, $2b6e161c9edcf319$var$canvas_star_panel.width, $2b6e161c9edcf319$var$canvas_star_panel.height);
                $2b6e161c9edcf319$var$ctx_star.drawImage($2b6e161c9edcf319$var$img2, 0, 0);
                $2b6e161c9edcf319$var$ctx_star.fillStyle = 'lightblue';
                $2b6e161c9edcf319$var$ctx_star.textAlign = 'center';
                $2b6e161c9edcf319$var$ctx_star.textBaseline = 'middle';
                $2b6e161c9edcf319$var$ctx_star.font = '100px nikokaku';
                let star_name = "";
                let constellation_name = "";
                $2b6e161c9edcf319$var$HIP2StarName.forEach((element)=>{
                    const hip_num = element.hip_number;
                    if (hip_num == hip) {
                        star_name = element.name;
                        //console.log(star_name);
                        return;
                    }
                });
                constellation.forEach((element)=>{
                    if (constellation_name !== "") constellation_name += "/";
                    //console.log(element);
                    if ($2b6e161c9edcf319$var$conste_name_Ja) {
                        for (const item of $2b6e161c9edcf319$var$ConNative2JaName)if (item[element]) {
                            //console.log(item[element]);
                            constellation_name += item[element].JaName + "\u5EA7";
                            return;
                        }
                    } else constellation_name += element;
                });
                $2b6e161c9edcf319$var$ctx_star.fillText(star_name, 580, 170);
                $2b6e161c9edcf319$var$ctx_star.font = '130px nikokaku';
                if ($2b6e161c9edcf319$var$conste_name_Ja) {
                    if (constellation_name.length >= 7) {
                        let fonst_size = 130 - (constellation_name.length - 6) * 9;
                        $2b6e161c9edcf319$var$ctx_star.font = `${fonst_size}px nikokaku`;
                    //ctx_star.font = '75px nikokaku';
                    }
                } else if (constellation_name.length >= 9) {
                    let fonst_size = 130 - (constellation_name.length - 7) * 8;
                    $2b6e161c9edcf319$var$ctx_star.font = `${fonst_size}px nikokaku`;
                //ctx_star.font = '75px nikokaku';
                }
                $2b6e161c9edcf319$var$ctx_star.fillText(constellation_name, 580, 420);
                $2b6e161c9edcf319$var$texture_panel.needsUpdate = true;
            } else $2b6e161c9edcf319$var$star_panel.visible = false;
        }
    }
});
//ホイール動作によるズームイン/アウト
$2b6e161c9edcf319$var$canvas.addEventListener('wheel', (event)=>{
    event.preventDefault();
    if (!$2b6e161c9edcf319$var$at_main_content) {
        $2b6e161c9edcf319$var$camera.zoom += event.deltaY * -0.001;
        $2b6e161c9edcf319$var$camera.zoom = Math.max(0.9, Math.min(5, $2b6e161c9edcf319$var$camera.zoom));
        $2b6e161c9edcf319$var$camera.updateProjectionMatrix(); // ← これ大事！
    }
});
const $2b6e161c9edcf319$var$canvas_change_time = document.createElement('canvas');
const $2b6e161c9edcf319$var$ctx_change_time = $2b6e161c9edcf319$var$canvas_change_time.getContext('2d');
$2b6e161c9edcf319$var$ctx_change_time.canvas.width = 1390;
$2b6e161c9edcf319$var$ctx_change_time.canvas.height = 540;
var $2b6e161c9edcf319$var$star_panel_time;
const $2b6e161c9edcf319$var$img3_data = "data:image/png;base64,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";
const $2b6e161c9edcf319$var$fontPromise = new Promise((resolve, reject)=>{
    const font = new FontFace('MyFont', `url(${(0, (/*@__PURE__*/$parcel$interopDefault($39c43c2be5e16a01$exports)))})`);
    font.load().then((loadedFont)=>{
        document.fonts.add(loadedFont);
        resolve(); // フォント読み込み完了
    }).catch(reject);
});
// --- 画像を読み込む Promise ---
var $2b6e161c9edcf319$var$img3;
const $2b6e161c9edcf319$var$imagePromise = new Promise((resolve, reject)=>{
    $2b6e161c9edcf319$var$img3 = new Image();
    $2b6e161c9edcf319$var$img3.onload = ()=>resolve($2b6e161c9edcf319$var$img3);
    $2b6e161c9edcf319$var$img3.onerror = reject;
    $2b6e161c9edcf319$var$img3.src = $2b6e161c9edcf319$var$img3_data; // base64またはURL
});
function $2b6e161c9edcf319$var$change_show_time(year, month, day, hour, min) {
    console.log("clear");
    $2b6e161c9edcf319$var$ctx_change_time.clearRect(0, 0, $2b6e161c9edcf319$var$ctx_change_time.canvas.width, $2b6e161c9edcf319$var$ctx_change_time.canvas.height);
    $2b6e161c9edcf319$var$ctx_change_time.drawImage($2b6e161c9edcf319$var$img3, 0, 0);
    $2b6e161c9edcf319$var$ctx_change_time.font = '180px MyFont';
    $2b6e161c9edcf319$var$ctx_change_time.fillStyle = "#92c1e4";
    //数字から各桁の数字を取出す(絶対もっとスマートな方法あるって)
    const y5 = Math.floor(year / 10000);
    const y4 = Math.floor((year - y5 * 10000) / 1000);
    const y3 = Math.floor((year - y5 * 10000 - y4 * 1000) / 100);
    const y2 = Math.floor((year - y5 * 10000 - y4 * 1000 - y3 * 100) / 10);
    const y1 = Math.floor((year - y5 * 10000 - y4 * 1000 - y3 * 100 - y2 * 10) / 1);
    const m1 = Math.floor(month / 10);
    const m2 = Math.floor((month - m1 * 10) / 1);
    const d1 = Math.floor(day / 10);
    const d2 = Math.floor((day - d1 * 10) / 1);
    console.log("h:", hour);
    const h1 = Math.floor(hour / 10);
    const h2 = Math.floor((hour - h1 * 10) / 1);
    const min1 = Math.floor(min / 10);
    const min2 = Math.floor((min - min1 * 10) / 1);
    $2b6e161c9edcf319$var$ctx_change_time.fillText(y5, 60, 125);
    $2b6e161c9edcf319$var$ctx_change_time.fillText(y4, 190, 125);
    $2b6e161c9edcf319$var$ctx_change_time.fillText(y3, 310, 125);
    $2b6e161c9edcf319$var$ctx_change_time.fillText(y2, 440, 125);
    $2b6e161c9edcf319$var$ctx_change_time.fillText(y1, 560, 125);
    $2b6e161c9edcf319$var$ctx_change_time.fillText(m1, 780, 125);
    $2b6e161c9edcf319$var$ctx_change_time.fillText(m2, 900, 125);
    $2b6e161c9edcf319$var$ctx_change_time.fillText(d1, 1130, 125);
    $2b6e161c9edcf319$var$ctx_change_time.fillText(d2, 1250, 125);
    $2b6e161c9edcf319$var$ctx_change_time.fillStyle = "#4c59ab";
    $2b6e161c9edcf319$var$ctx_change_time.font = '160px MyFont';
    $2b6e161c9edcf319$var$ctx_change_time.fillText(h1, 560, 395);
    $2b6e161c9edcf319$var$ctx_change_time.fillText(h2, 670, 395);
    $2b6e161c9edcf319$var$ctx_change_time.fillText(min1, 900, 395);
    $2b6e161c9edcf319$var$ctx_change_time.fillText(min2, 1005, 395);
    if ($2b6e161c9edcf319$var$texture_panel_time) $2b6e161c9edcf319$var$texture_panel_time.needsUpdate = true;
}
var $2b6e161c9edcf319$var$texture_panel_time;
Promise.all([
    $2b6e161c9edcf319$var$fontPromise,
    $2b6e161c9edcf319$var$imagePromise
]).then(([_, img3])=>{
    $2b6e161c9edcf319$var$ctx_change_time.canvas.width = 1390;
    $2b6e161c9edcf319$var$ctx_change_time.canvas.height = 540;
    $2b6e161c9edcf319$var$ctx_change_time.fillStyle = "#92c1e4";
    $2b6e161c9edcf319$var$ctx_change_time.textAlign = 'center';
    $2b6e161c9edcf319$var$ctx_change_time.textBaseline = 'middle';
    let simulatedDate = $2b6e161c9edcf319$var$getSimulatedDate();
    simulatedDate = new Date(simulatedDate.getTime() + $2b6e161c9edcf319$var$offsetHours * 3600000);
    $2b6e161c9edcf319$var$year = simulatedDate.getFullYear();
    $2b6e161c9edcf319$var$month = simulatedDate.getMonth() + 1;
    $2b6e161c9edcf319$var$day = simulatedDate.getDate();
    $2b6e161c9edcf319$var$hour = simulatedDate.getHours();
    $2b6e161c9edcf319$var$min = simulatedDate.getMinutes();
    $2b6e161c9edcf319$var$sec = simulatedDate.getSeconds();
    $2b6e161c9edcf319$var$change_show_time($2b6e161c9edcf319$var$year, $2b6e161c9edcf319$var$month, $2b6e161c9edcf319$var$day, $2b6e161c9edcf319$var$hour, $2b6e161c9edcf319$var$min);
    $2b6e161c9edcf319$var$ctx_change_time.drawImage(img3, 0, 0);
    $2b6e161c9edcf319$var$texture_panel_time = new $dyjou.CanvasTexture($2b6e161c9edcf319$var$canvas_change_time);
    $2b6e161c9edcf319$var$texture_panel_time.needsUpdate = true;
    const geometry_panel_time = new $dyjou.PlaneGeometry(200, 100);
    //geometry_panel_time.translate(200 / 2-5, 100 / 2+10, 0);
    const material_panel_time = new $dyjou.MeshBasicMaterial({
        map: $2b6e161c9edcf319$var$texture_panel_time,
        //color:0xFFFFFF,
        transparent: true,
        opacity: 0.7,
        side: $dyjou.DoubleSide,
        alphaTest: 0.1
    });
    $2b6e161c9edcf319$var$star_panel_time = new $dyjou.Mesh(geometry_panel_time, material_panel_time);
    $2b6e161c9edcf319$var$star_panel_time.quaternion.copy($2b6e161c9edcf319$var$camera.quaternion);
    $2b6e161c9edcf319$var$star_panel_time.position.set(100, 0, 0);
    $2b6e161c9edcf319$var$star_panel_time.visible = false;
    $2b6e161c9edcf319$var$scene.add($2b6e161c9edcf319$var$star_panel_time);
});
let $2b6e161c9edcf319$var$changing_time = false;
const $2b6e161c9edcf319$var$set_now_button = document.getElementById("set_now");
const $2b6e161c9edcf319$var$change_time_button = document.getElementById("change_time");
const $2b6e161c9edcf319$var$return_set_time_button = document.getElementById("return_set_time");
const $2b6e161c9edcf319$var$warn_past_ele = document.getElementById("warn_past");
const $2b6e161c9edcf319$var$warn_close_button = document.getElementById("close_parent");
const $2b6e161c9edcf319$var$operate_button_text = document.getElementById("operate_button_text");
$2b6e161c9edcf319$var$change_time_button.addEventListener("click", ()=>{
    if (!$2b6e161c9edcf319$var$changing_time) {
        const dir = new $dyjou.Vector3();
        $2b6e161c9edcf319$var$camera.getWorldDirection(dir); // カメラの向いている方向ベクトル
        dir.multiplyScalar(100); // 距離100の位置にする
        const panelPosition = new $dyjou.Vector3().copy($2b6e161c9edcf319$var$camera.position).add(dir); // カメラ位置からdir方向に100進んだ点
        $2b6e161c9edcf319$var$star_panel_time.position.copy(panelPosition); // パネルをその位置へ
        $2b6e161c9edcf319$var$star_panel_time.quaternion.copy($2b6e161c9edcf319$var$camera.quaternion);
        let simulatedDate = $2b6e161c9edcf319$var$getSimulatedDate();
        console.log($2b6e161c9edcf319$var$offsetHours);
        simulatedDate = new Date(simulatedDate.getTime() + $2b6e161c9edcf319$var$offsetHours * 3600000);
        let year = simulatedDate.getFullYear();
        let month = simulatedDate.getMonth() + 1;
        let day = simulatedDate.getDate();
        let hour = simulatedDate.getHours();
        let min = simulatedDate.getMinutes();
        console.log("hour:", hour);
        if ($2b6e161c9edcf319$var$CT_year === undefined) $2b6e161c9edcf319$var$CT_year = year;
        if ($2b6e161c9edcf319$var$CT_month === undefined) $2b6e161c9edcf319$var$CT_month = month;
        if ($2b6e161c9edcf319$var$CT_day === undefined) $2b6e161c9edcf319$var$CT_day = day;
        if ($2b6e161c9edcf319$var$CT_hour === undefined) $2b6e161c9edcf319$var$CT_hour = hour;
        if ($2b6e161c9edcf319$var$CT_min === undefined) $2b6e161c9edcf319$var$CT_min = min;
        $2b6e161c9edcf319$var$change_show_time(year, month, day, hour, min);
        $2b6e161c9edcf319$var$star_panel_time.visible = true;
        $2b6e161c9edcf319$var$operate_button_text.innerText = "\u6C7A\u5B9A\uFF01\uFF01";
        //change_time_button.style.fontSize = "30pt";
        $2b6e161c9edcf319$var$change_time_button.classList.add("big_font");
        $2b6e161c9edcf319$var$set_now_button.style.display = "block";
        $2b6e161c9edcf319$var$set_now_button.parentElement.style.display = "block";
        $2b6e161c9edcf319$var$return_set_time_button.style.display = "block";
        $2b6e161c9edcf319$var$return_set_time_button.parentElement.style.display = "block";
        $2b6e161c9edcf319$var$change_location_button.parentElement.style.display = "none";
        $2b6e161c9edcf319$var$panel.visible = false;
        $2b6e161c9edcf319$var$star_panel.visible = false;
        $2b6e161c9edcf319$var$telescope.visible = false;
        $2b6e161c9edcf319$var$change_constellation_name_button.parentElement.style.display = "none";
        $2b6e161c9edcf319$var$changing_time = !$2b6e161c9edcf319$var$changing_time;
        $2b6e161c9edcf319$var$update_back_tanzaku();
    } else {
        let local_time = new Date($2b6e161c9edcf319$var$CT_year, $2b6e161c9edcf319$var$CT_month - 1, $2b6e161c9edcf319$var$CT_day, $2b6e161c9edcf319$var$CT_hour, $2b6e161c9edcf319$var$CT_min);
        if (local_time.getTime() <= new Date()) {
            $2b6e161c9edcf319$var$warn_past_ele.style.display = "block";
            $2b6e161c9edcf319$var$canvas.style.pointerEvents = "none";
            $2b6e161c9edcf319$var$return_set_time_button.style.pointerEvents = "none";
            $2b6e161c9edcf319$var$return_set_time_button.style.opacity = 0.3;
            $2b6e161c9edcf319$var$set_now_button.style.pointerEvents = "none";
            $2b6e161c9edcf319$var$set_now_button.style.opacity = 0.3;
            $2b6e161c9edcf319$var$change_time_button.style.pointerEvents = "none";
            $2b6e161c9edcf319$var$change_time_button.style.opacity = 0.3;
            $2b6e161c9edcf319$var$update_back_tanzaku();
        } else {
            $2b6e161c9edcf319$var$CT_year = $2b6e161c9edcf319$var$CT_month = $2b6e161c9edcf319$var$CT_day = $2b6e161c9edcf319$var$CT_hour = $2b6e161c9edcf319$var$CT_min = undefined;
            /* let offsetMinutes = new Date().getTimezoneOffset();
            let offsetHours = -offsetMinutes / 60;//現地時間とutcとの差をげっちゅ */ let offsetHours = 9; //ここは本題じゃないのでそんなに凝らないことにします。よってUTC+9で固定。
            console.log(offsetHours);
            // UTCに変換
            let utc = new Date(local_time.getTime() - offsetHours * 3600000); // -9時間
            let year = utc.getUTCFullYear();
            let month = utc.getUTCMonth() + 1;
            let day = utc.getUTCDate();
            let hour = utc.getUTCHours();
            let min = utc.getUTCMinutes();
            //baseDate = utc; // スタート時刻 (年, 月-1, 日, 時, 分, 秒)
            //startTime = performance.now(); // 実時間の開始点
            $2b6e161c9edcf319$var$move_time(year, month, day, hour, min);
            $2b6e161c9edcf319$var$star_panel_time.visible = false;
            $2b6e161c9edcf319$var$operate_button_text.innerText = "\u6642\u9593\u3092\u5909\u66F4\u3059\u308B";
            $2b6e161c9edcf319$var$change_time_button.classList.remove("big_font");
            //change_time_button.style.fontSize = "18pt";
            $2b6e161c9edcf319$var$set_now_button.style.display = "none";
            $2b6e161c9edcf319$var$set_now_button.parentElement.style.display = "none";
            $2b6e161c9edcf319$var$return_set_time_button.style.display = "none";
            $2b6e161c9edcf319$var$return_set_time_button.parentElement.style.display = "none";
            $2b6e161c9edcf319$var$change_location_button.parentElement.style.display = "block";
            $2b6e161c9edcf319$var$change_constellation_name_button.parentElement.style.display = "none";
            $2b6e161c9edcf319$var$telescope.visible = true;
            $2b6e161c9edcf319$var$changing_time = !$2b6e161c9edcf319$var$changing_time;
            $2b6e161c9edcf319$var$update_back_tanzaku();
        }
    }
});
$2b6e161c9edcf319$var$warn_close_button.addEventListener("click", ()=>{
    $2b6e161c9edcf319$var$warn_past_ele.style.display = "none";
    $2b6e161c9edcf319$var$canvas.style.pointerEvents = "auto";
    $2b6e161c9edcf319$var$return_set_time_button.style.pointerEvents = "auto";
    $2b6e161c9edcf319$var$return_set_time_button.style.opacity = 1;
    $2b6e161c9edcf319$var$set_now_button.style.pointerEvents = "auto";
    $2b6e161c9edcf319$var$set_now_button.style.opacity = 1;
    $2b6e161c9edcf319$var$change_time_button.style.pointerEvents = "auto";
    $2b6e161c9edcf319$var$change_time_button.style.opacity = 1;
});
$2b6e161c9edcf319$var$set_now_button.addEventListener("click", ()=>{
    let local_time = new Date();
    $2b6e161c9edcf319$var$CT_year = $2b6e161c9edcf319$var$CT_month = $2b6e161c9edcf319$var$CT_day = $2b6e161c9edcf319$var$CT_hour = $2b6e161c9edcf319$var$CT_min = undefined;
    // UTCに変換
    let utc = new Date(local_time.getTime() - $2b6e161c9edcf319$var$offsetHours * 3600000); // -9時間
    let year = utc.getUTCFullYear();
    let month = utc.getUTCMonth() + 1;
    let day = utc.getUTCDate();
    let hour = utc.getUTCHours();
    let min = utc.getUTCMinutes();
    //baseDate = utc; // スタート時刻 (年, 月-1, 日, 時, 分, 秒)
    //startTime = performance.now(); // 実時間の開始点
    $2b6e161c9edcf319$var$move_time(year, month, day, hour, min, true);
    $2b6e161c9edcf319$var$star_panel_time.visible = false;
    $2b6e161c9edcf319$var$operate_button_text.innerText = "\u6642\u9593\u3092\u5909\u66F4\u3059\u308B";
    //change_time_button.style.fontSize = "18pt";
    $2b6e161c9edcf319$var$change_time_button.classList.remove("big_font");
    $2b6e161c9edcf319$var$set_now_button.parentElement.style.display = "none";
    $2b6e161c9edcf319$var$return_set_time_button.parentElement.style.display = "none";
    $2b6e161c9edcf319$var$change_location_button.parentElement.style.display = "block";
    $2b6e161c9edcf319$var$change_constellation_name_button.parentElement.style.display = "block";
    $2b6e161c9edcf319$var$telescope.visible = true;
    $2b6e161c9edcf319$var$changing_time = !$2b6e161c9edcf319$var$changing_time;
    $2b6e161c9edcf319$var$update_back_tanzaku();
});
$2b6e161c9edcf319$var$return_set_time_button.addEventListener("click", ()=>{
    $2b6e161c9edcf319$var$star_panel_time.visible = false;
    $2b6e161c9edcf319$var$CT_year = $2b6e161c9edcf319$var$CT_month = $2b6e161c9edcf319$var$CT_day = $2b6e161c9edcf319$var$CT_hour = $2b6e161c9edcf319$var$CT_min = undefined;
    $2b6e161c9edcf319$var$operate_button_text.innerText = "\u6642\u9593\u3092\u5909\u66F4\u3059\u308B";
    //change_time_button.style.fontSize = "18pt";
    $2b6e161c9edcf319$var$change_time_button.classList.remove("big_font");
    $2b6e161c9edcf319$var$set_now_button.style.display = "none";
    $2b6e161c9edcf319$var$set_now_button.parentElement.style.display = "none";
    $2b6e161c9edcf319$var$return_set_time_button.style.display = "none";
    $2b6e161c9edcf319$var$return_set_time_button.parentElement.style.display = "none";
    $2b6e161c9edcf319$var$change_location_button.parentElement.style.display = "block";
    $2b6e161c9edcf319$var$telescope.visible = true;
    $2b6e161c9edcf319$var$change_constellation_name_button.parentElement.style.display = "block";
    $2b6e161c9edcf319$var$changing_time = !$2b6e161c9edcf319$var$changing_time;
    $2b6e161c9edcf319$var$update_back_tanzaku();
});
const $2b6e161c9edcf319$var$change_location_button = document.getElementById("change_location");
const $2b6e161c9edcf319$var$location_firstQ_ele = document.getElementById("location_firstQ");
const $2b6e161c9edcf319$var$return_change_location_button = document.getElementById("return_change_location");
const $2b6e161c9edcf319$var$firstQ_options = document.getElementsByClassName("firstQ_child");
const $2b6e161c9edcf319$var$japan_options = document.getElementsByClassName("japan_option_child");
const $2b6e161c9edcf319$var$world_options = document.getElementsByClassName("world_option_child");
const $2b6e161c9edcf319$var$japan_option_ele = document.getElementById("japan_option");
const $2b6e161c9edcf319$var$world_option_ele = document.getElementById("world_option");
let $2b6e161c9edcf319$var$changing_location_Q = 0; //地域変更の質問のレベル
//座標が取得できるまでは無効
$2b6e161c9edcf319$var$firstQ_options[0].style.opacity = 0.3;
$2b6e161c9edcf319$var$firstQ_options[0].style.pointerEvents = "none";
$2b6e161c9edcf319$var$change_location_button.addEventListener("click", ()=>{
    $2b6e161c9edcf319$var$location_firstQ_ele.style.display = "flex";
    $2b6e161c9edcf319$var$change_time_button.style.opacity = 0.3;
    $2b6e161c9edcf319$var$change_location_button.style.opacity = 0.3;
    $2b6e161c9edcf319$var$change_location_button.style.pointerEvents = "none";
    $2b6e161c9edcf319$var$change_time_button.style.pointerEvents = "none";
    $2b6e161c9edcf319$var$return_change_location_button.style.display = "block";
    $2b6e161c9edcf319$var$return_change_location_button.parentElement.style.display = "block";
    $2b6e161c9edcf319$var$change_constellation_name_button.parentElement.style.display = "none";
    $2b6e161c9edcf319$var$panel.visible = false;
    $2b6e161c9edcf319$var$star_panel.visible = false;
    $2b6e161c9edcf319$var$telescope.visible = false;
    $2b6e161c9edcf319$var$changing_location_Q = 1;
    $2b6e161c9edcf319$var$update_back_tanzaku();
});
$2b6e161c9edcf319$var$return_change_location_button.addEventListener("click", ()=>{
    $2b6e161c9edcf319$var$changing_location_Q -= 1;
    $2b6e161c9edcf319$var$change_Qnum();
});
function $2b6e161c9edcf319$var$change_Qnum() {
    if ($2b6e161c9edcf319$var$changing_location_Q == 0) {
        $2b6e161c9edcf319$var$change_time_button.style.opacity = 1;
        $2b6e161c9edcf319$var$change_location_button.style.opacity = 1;
        $2b6e161c9edcf319$var$change_location_button.style.pointerEvents = "auto";
        $2b6e161c9edcf319$var$change_time_button.style.pointerEvents = "auto";
        $2b6e161c9edcf319$var$return_change_location_button.parentElement.style.display = "none";
        $2b6e161c9edcf319$var$location_firstQ_ele.style.display = "none";
        $2b6e161c9edcf319$var$japan_option_ele.style.display = "none";
        $2b6e161c9edcf319$var$world_option_ele.style.display = "none";
        $2b6e161c9edcf319$var$panel.visible = true;
        $2b6e161c9edcf319$var$star_panel.visible = true;
        $2b6e161c9edcf319$var$telescope.visible = true;
        $2b6e161c9edcf319$var$change_constellation_name_button.parentElement.style.display = "block";
        $2b6e161c9edcf319$var$update_back_tanzaku();
    } else if ($2b6e161c9edcf319$var$changing_location_Q == 1) {
        $2b6e161c9edcf319$var$location_firstQ_ele.style.display = "flex";
        $2b6e161c9edcf319$var$japan_option_ele.style.display = "none";
        $2b6e161c9edcf319$var$world_option_ele.style.display = "none";
        $2b6e161c9edcf319$var$update_back_tanzaku();
    }
}
$2b6e161c9edcf319$var$location_firstQ_ele.addEventListener("click", (e)=>{
    if (e.target == $2b6e161c9edcf319$var$firstQ_options[1]) {
        $2b6e161c9edcf319$var$location_firstQ_ele.style.display = "none";
        $2b6e161c9edcf319$var$japan_option_ele.style.display = "flex";
        $2b6e161c9edcf319$var$changing_location_Q = 2;
    } else if (e.target == $2b6e161c9edcf319$var$firstQ_options[2]) {
        $2b6e161c9edcf319$var$location_firstQ_ele.style.display = "none";
        $2b6e161c9edcf319$var$world_option_ele.style.display = "flex";
        $2b6e161c9edcf319$var$changing_location_Q = 2;
    } else if (e.target == $2b6e161c9edcf319$var$firstQ_options[0]) {
        $2b6e161c9edcf319$var$location_ele.innerText = "\u3042\u306A\u305F\u306E\u5730\u57DF";
        $2b6e161c9edcf319$var$to_latitude = $2b6e161c9edcf319$var$user_lat;
        $2b6e161c9edcf319$var$to_longitude = $2b6e161c9edcf319$var$user_lon;
        $2b6e161c9edcf319$var$from_latitude = $2b6e161c9edcf319$var$latitude;
        $2b6e161c9edcf319$var$from_longitude = $2b6e161c9edcf319$var$longitude;
        $2b6e161c9edcf319$var$loc_move_start = performance.now();
        $2b6e161c9edcf319$var$moving_location = true;
        $2b6e161c9edcf319$var$changing_location_Q = 0;
        $2b6e161c9edcf319$var$change_Qnum();
    }
});
//各年の緯度経度。緯度は北緯が+,経度は東経が+。
const $2b6e161c9edcf319$var$location_list = {
    "\u672D\u5E4C": [
        43.06277778,
        141.355
    ],
    "\u4ED9\u53F0": [
        38.26808333,
        140.8695
    ],
    "\u6771\u4EAC": [
        35.68947222,
        139.69175
    ],
    "\u540D\u53E4\u5C4B": [
        35.18144722,
        136.90636667
    ],
    "\u5927\u962A": [
        34.7875,
        135.50172222
    ],
    "\u5E83\u5CF6": [
        34.38527778,
        132.455277778
    ],
    "\u798F\u5CA1": [
        33.59011111,
        130.401722222
    ],
    "\u90A3\u8987": [
        26.21222222,
        127.679166666
    ],
    "\u30A2\u30E1\u30EA\u30AB": [
        38.9041,
        -77.0171
    ],
    "\u4E2D\u56FD": [
        39.9035,
        116.388
    ],
    "\u30A4\u30F3\u30C9": [
        28.61,
        77.23
    ],
    "\u30AA\u30FC\u30B9\u30C8\u30E9\u30EA\u30A2": [
        -35.3081,
        149.124
    ],
    "\u30D6\u30E9\u30B8\u30EB": [
        -15.7801,
        -47.9292
    ],
    "\u30B1\u30CB\u30A2": [
        -1.29233,
        36.82
    ],
    "\u5317\u6975\u70B9": [
        89.99,
        0
    ],
    "\u5357\u6975\u70B9": [
        -89.99,
        0
    ],
    "\u30A4\u30AE\u30EA\u30B9": [
        58.1583333,
        0
    ]
};
let $2b6e161c9edcf319$var$latitude = $2b6e161c9edcf319$var$location_list["\u6771\u4EAC"][0];
let $2b6e161c9edcf319$var$longitude = $2b6e161c9edcf319$var$location_list["\u6771\u4EAC"][1];
let $2b6e161c9edcf319$var$user_lat = $2b6e161c9edcf319$var$location_list["\u6771\u4EAC"][0];
let $2b6e161c9edcf319$var$user_lon = $2b6e161c9edcf319$var$location_list["\u6771\u4EAC"][1];
let $2b6e161c9edcf319$var$enabled_user_location = false;
if (navigator.geolocation) navigator.geolocation.getCurrentPosition(function(position) {
    $2b6e161c9edcf319$var$user_lat = position.coords.latitude;
    $2b6e161c9edcf319$var$user_lon = position.coords.longitude;
    /* console.log("緯度:", latitude);
        console.log("経度:", longitude); */ $2b6e161c9edcf319$var$enabled_user_location = true;
    $2b6e161c9edcf319$var$firstQ_options[0].style.opacity = 1;
    $2b6e161c9edcf319$var$firstQ_options[0].style.pointerEvents = "auto";
}, function(error) {
    console.log("disenable");
    $2b6e161c9edcf319$var$enabled_user_location = false;
    $2b6e161c9edcf319$var$latitude = $2b6e161c9edcf319$var$location_list["\u6771\u4EAC"][0];
    $2b6e161c9edcf319$var$longitude = $2b6e161c9edcf319$var$location_list["\u6771\u4EAC"][1];
});
else {
    console.log("disenable2");
    $2b6e161c9edcf319$var$enabled_user_location = false;
    $2b6e161c9edcf319$var$latitude = $2b6e161c9edcf319$var$location_list["\u6771\u4EAC"][0];
    $2b6e161c9edcf319$var$longitude = $2b6e161c9edcf319$var$location_list["\u6771\u4EAC"][1];
}
let $2b6e161c9edcf319$var$to_latitude, $2b6e161c9edcf319$var$to_longitude;
let $2b6e161c9edcf319$var$from_latitude, $2b6e161c9edcf319$var$from_longitude;
const $2b6e161c9edcf319$var$location_ele = document.getElementById("location");
$2b6e161c9edcf319$var$japan_option_ele.addEventListener("click", (e)=>{
    if (Array.from($2b6e161c9edcf319$var$japan_options).includes(e.target)) {
        $2b6e161c9edcf319$var$location_ele.innerText = e.target.innerText;
        $2b6e161c9edcf319$var$to_latitude = $2b6e161c9edcf319$var$location_list[e.target.innerText][0];
        $2b6e161c9edcf319$var$to_longitude = $2b6e161c9edcf319$var$location_list[e.target.innerText][1];
        $2b6e161c9edcf319$var$from_latitude = $2b6e161c9edcf319$var$latitude;
        $2b6e161c9edcf319$var$from_longitude = $2b6e161c9edcf319$var$longitude;
        $2b6e161c9edcf319$var$loc_move_start = performance.now();
        $2b6e161c9edcf319$var$moving_location = true;
        $2b6e161c9edcf319$var$changing_location_Q = 0;
        $2b6e161c9edcf319$var$change_Qnum();
    }
});
$2b6e161c9edcf319$var$world_option_ele.addEventListener("click", (e)=>{
    if (Array.from($2b6e161c9edcf319$var$world_options).includes(e.target)) {
        $2b6e161c9edcf319$var$location_ele.innerText = e.target.innerText;
        $2b6e161c9edcf319$var$to_latitude = $2b6e161c9edcf319$var$location_list[e.target.innerText][0];
        $2b6e161c9edcf319$var$to_longitude = $2b6e161c9edcf319$var$location_list[e.target.innerText][1];
        $2b6e161c9edcf319$var$from_latitude = $2b6e161c9edcf319$var$latitude;
        $2b6e161c9edcf319$var$from_longitude = $2b6e161c9edcf319$var$longitude;
        $2b6e161c9edcf319$var$loc_move_start = performance.now();
        $2b6e161c9edcf319$var$moving_location = true;
        $2b6e161c9edcf319$var$changing_location_Q = 0;
        $2b6e161c9edcf319$var$change_Qnum();
    }
});
let $2b6e161c9edcf319$var$moving_location = false;
let $2b6e161c9edcf319$var$loc_move_start;
function $2b6e161c9edcf319$var$update_location() {
    if ($2b6e161c9edcf319$var$moving_location) {
        $2b6e161c9edcf319$var$change_time_button.parentElement.style.display = "none";
        $2b6e161c9edcf319$var$change_location_button.parentElement.style.display = "none";
        $2b6e161c9edcf319$var$change_constellation_name_button.parentElement.style.display = "none";
        $2b6e161c9edcf319$var$telescope.visible = false;
        const now = performance.now();
        const diff_lat = $2b6e161c9edcf319$var$to_latitude - $2b6e161c9edcf319$var$from_latitude; //緯度を動かす量
        const diff_lon = $2b6e161c9edcf319$var$to_longitude - $2b6e161c9edcf319$var$from_longitude; //経度を動かす量
        const prog = (now - $2b6e161c9edcf319$var$loc_move_start) / 1000; //時間的な進捗
        const easedprog = $2b6e161c9edcf319$var$easeInOutCubic(prog);
        $2b6e161c9edcf319$var$latitude = $2b6e161c9edcf319$var$from_latitude + diff_lat * easedprog;
        $2b6e161c9edcf319$var$longitude = $2b6e161c9edcf319$var$from_longitude + diff_lon * easedprog;
        if (prog >= 1) {
            $2b6e161c9edcf319$var$latitude = $2b6e161c9edcf319$var$to_latitude;
            $2b6e161c9edcf319$var$longitude = $2b6e161c9edcf319$var$to_longitude;
            $2b6e161c9edcf319$var$moving_location = false;
            $2b6e161c9edcf319$var$change_time_button.parentElement.style.display = "block";
            $2b6e161c9edcf319$var$change_location_button.parentElement.style.display = "block";
            $2b6e161c9edcf319$var$change_constellation_name_button.parentElement.style.display = "block";
            $2b6e161c9edcf319$var$telescope.visible = true;
        }
    }
}
const $2b6e161c9edcf319$var$change_constellation_name_button = document.getElementById("change_constellation_name");
const $2b6e161c9edcf319$var$constellation_name_ele = document.getElementById("constellation_name");
let $2b6e161c9edcf319$var$conste_name_Ja = true;
$2b6e161c9edcf319$var$change_constellation_name_button.addEventListener("click", ()=>{
    $2b6e161c9edcf319$var$conste_name_Ja = !$2b6e161c9edcf319$var$conste_name_Ja;
    if ($2b6e161c9edcf319$var$conste_name_Ja) $2b6e161c9edcf319$var$constellation_name_ele.innerText = "\u65E5\u672C\u8A9E";
    else $2b6e161c9edcf319$var$constellation_name_ele.innerText = "\u5B66\u540D";
});
// レンダリング
//renderer.render(scene, camera);
//const axesHelper = new THREE.AxesHelper( 1000 );
//scene.add( axesHelper );
// ブルームエフェクトの設定
const $2b6e161c9edcf319$var$renderScene = new (0, $f4d3a60efece63cd$export$f63ea822f020b5b0)($2b6e161c9edcf319$var$scene, $2b6e161c9edcf319$var$camera);
// UnrealBloomPassの作成
const $2b6e161c9edcf319$var$bloomPass = new (0, $ca010d9f34e35dc3$export$d4d608c865617544)(new $dyjou.Vector2($2b6e161c9edcf319$var$width, $2b6e161c9edcf319$var$height), 0.4, 0.1, 0.85 // 鮮明さ
);
$2b6e161c9edcf319$var$bloomPass.threshold = 0.0;
$2b6e161c9edcf319$var$renderer.sortObjects = false;
const $2b6e161c9edcf319$var$renderTarget = new $dyjou.WebGLRenderTarget($2b6e161c9edcf319$var$width, $2b6e161c9edcf319$var$height, {
    minFilter: $dyjou.LinearFilter,
    magFilter: $dyjou.LinearFilter,
    format: $dyjou.RGBAFormat
});
// EffectComposerを作成し、エフェクトを追加
const $2b6e161c9edcf319$var$composer = new (0, $1f89f80dfbd5e815$export$7fe01e6ab8aa748c)($2b6e161c9edcf319$var$renderer);
$2b6e161c9edcf319$var$composer.renderToScreen = true;
$2b6e161c9edcf319$var$composer.addPass($2b6e161c9edcf319$var$renderScene);
$2b6e161c9edcf319$var$composer.addPass($2b6e161c9edcf319$var$bloomPass);
$2b6e161c9edcf319$var$composer.render();
function $2b6e161c9edcf319$var$directionToCubeUV(dir) {
    const absX = Math.abs(dir.x);
    const absY = Math.abs(dir.y);
    const absZ = Math.abs(dir.z);
    let face, u, v;
    //とりあえず左上を(0,0)とする。
    // X軸に最も近い方向
    if (absX >= absY && absX >= absZ) {
        if (dir.x > 0) {
            face = 'px'; // +X方向
            u = dir.z / dir.x * 0.5 + 0.5; // Z方向をUVにマップ1
            v = 1 - (dir.y / dir.x * 0.5 + 0.5); // Y方向をUVにマップ1
        } else {
            face = 'nx'; // -X方向
            u = 1 - (dir.z / dir.x * -0.5 + 0.5); //1
            v = 1 - (dir.y / dir.x * -0.5 + 0.5); //1
        }
    } else if (absY >= absX && absY >= absZ) {
        if (dir.y > 0) {
            face = 'py'; // +Y方向
            u = dir.z / dir.y * 0.5 + 0.5;
            v = dir.x / dir.y * 0.5 + 0.5; //1
        } else {
            face = 'ny'; // -Y方向
            u = dir.z / dir.y * -0.5 + 0.5;
            v = 1 - (dir.x / dir.y * -0.5 + 0.5);
        }
    } else if (dir.z > 0) {
        face = 'pz'; // +Z方向
        u = 1 - (dir.x / dir.z * 0.5 + 0.5); //1
        v = 1 - (dir.y / dir.z * 0.5 + 0.5); //1
    } else {
        face = 'nz'; // -Z方向
        u = dir.x / dir.z * -0.5 + 0.5; //1
        v = 1 - (dir.y / dir.z * -0.5 + 0.5); //1
    }
    return {
        face: face,
        u: u,
        v: v
    };
}
function $2b6e161c9edcf319$var$getPixelFromFace(faceCanvas, u, v, face) {
    const ctx = faceCanvas.getContext('2d');
    const x = Math.min(Math.floor(u * faceCanvas.width), faceCanvas.width - 1);
    const y = Math.min(Math.floor(v * faceCanvas.height), faceCanvas.height - 1);
    /* console.log("f",face);
    console.log("x",x);
    console.log("y",y); */ return ctx.getImageData(x, y, 1, 1).data;
}
const $2b6e161c9edcf319$var$directions = [
    {
        name: 'px',
        lookAt: [
            1,
            0,
            0
        ],
        up: [
            0,
            1,
            0
        ]
    },
    {
        name: 'nx',
        lookAt: [
            -1,
            0,
            0
        ],
        up: [
            0,
            1,
            0
        ]
    },
    {
        name: 'py',
        lookAt: [
            0,
            1,
            0
        ],
        up: [
            -1,
            0,
            0
        ]
    },
    {
        name: 'ny',
        lookAt: [
            0,
            -1,
            0
        ],
        up: [
            1,
            0,
            0
        ]
    },
    {
        name: 'pz',
        lookAt: [
            0,
            0,
            1
        ],
        up: [
            0,
            1,
            0
        ]
    },
    {
        name: 'nz',
        lookAt: [
            0,
            0,
            -1
        ],
        up: [
            0,
            1,
            0
        ]
    }
];
const $2b6e161c9edcf319$var$size = 1536;
function $2b6e161c9edcf319$var$get_6dir_img() {
    const faceImages = [];
    const gl = $2b6e161c9edcf319$var$renderer.getContext();
    const originalPosition = $2b6e161c9edcf319$var$camera.position.clone();
    const originalUp = $2b6e161c9edcf319$var$camera.up.clone();
    const originalFov = $2b6e161c9edcf319$var$camera.fov;
    const originalAspect = $2b6e161c9edcf319$var$camera.aspect;
    const originalDirection = $2b6e161c9edcf319$var$camera.getWorldDirection(new $dyjou.Vector3()).clone();
    const originalLookAt = originalPosition.clone().add(originalDirection);
    const original_zoom = $2b6e161c9edcf319$var$camera.zoom;
    $2b6e161c9edcf319$var$camera.fov = 90;
    $2b6e161c9edcf319$var$camera.aspect = 1;
    $2b6e161c9edcf319$var$camera.zoom = 1;
    $2b6e161c9edcf319$var$camera.updateProjectionMatrix();
    for (const dir of $2b6e161c9edcf319$var$directions){
        // 新しいカメラを作成
        //const cam = new THREE.PerspectiveCamera(90, 1, 0.1, 10000);
        $2b6e161c9edcf319$var$camera.position.set(0, 0, 0);
        $2b6e161c9edcf319$var$camera.up.fromArray(dir.up);
        $2b6e161c9edcf319$var$camera.lookAt(new $dyjou.Vector3().fromArray(dir.lookAt));
        //camera.lookAt(lookAtVector);
        $2b6e161c9edcf319$var$renderer.setSize($2b6e161c9edcf319$var$size / window.devicePixelRatio, $2b6e161c9edcf319$var$size / window.devicePixelRatio);
        $2b6e161c9edcf319$var$composer.setSize($2b6e161c9edcf319$var$size / window.devicePixelRatio, $2b6e161c9edcf319$var$size / window.devicePixelRatio);
        //renderer.setSize(size, size, false); // 物理サイズとCSSサイズを一致させない
        $2b6e161c9edcf319$var$renderer.domElement.style.width = `${$2b6e161c9edcf319$var$size}px`;
        $2b6e161c9edcf319$var$renderer.domElement.style.height = `${$2b6e161c9edcf319$var$size}px`;
        // Composerのサイズをターゲットに合わせる
        // ピクセルデータを格納するための配列
        const pixels = new Uint8Array($2b6e161c9edcf319$var$size * $2b6e161c9edcf319$var$size * 4); // RGBA
        // レンダーターゲットを指定
        //const framebuffer = gl.createFramebuffer();
        $2b6e161c9edcf319$var$composer.render();
        const buffer = $2b6e161c9edcf319$var$composer.readBuffer;
        gl.bindFramebuffer(gl.FRAMEBUFFER, buffer.__webglFramebuffer);
        //gl.bindFramebuffer(gl.FRAMEBUFFER, framebuffer);
        //renderer.render()
        gl.readPixels(0, 0, $2b6e161c9edcf319$var$size, $2b6e161c9edcf319$var$size, gl.RGBA, gl.UNSIGNED_BYTE, pixels);
        const canvas = document.createElement('canvas');
        canvas.width = $2b6e161c9edcf319$var$size;
        canvas.height = $2b6e161c9edcf319$var$size;
        const ctx = canvas.getContext('2d');
        // imageData を作成して読み取ったピクセルデータを設定
        const imageData = ctx.createImageData($2b6e161c9edcf319$var$size, $2b6e161c9edcf319$var$size);
        canvas.dataset.name = dir.name;
        // ピクセルを上下反転してコピー
        for(let y = 0; y < $2b6e161c9edcf319$var$size; y++)for(let x = 0; x < $2b6e161c9edcf319$var$size; x++){
            const destIdx = (y * $2b6e161c9edcf319$var$size + x) * 4;
            const srcIdx = (($2b6e161c9edcf319$var$size - y - 1) * $2b6e161c9edcf319$var$size + x) * 4;
            imageData.data[destIdx] = pixels[srcIdx];
            imageData.data[destIdx + 1] = pixels[srcIdx + 1];
            imageData.data[destIdx + 2] = pixels[srcIdx + 2];
            imageData.data[destIdx + 3] = 255; // pixels[srcIdx + 3]; 透明度
        }
        ctx.putImageData(imageData, 0, 0);
        // 作成した画像をfaceImagesに追加
        //document.body.appendChild(canvas);
        faceImages.push(canvas);
    }
    const faceMap = {};
    for (const face of faceImages)faceMap[face.dataset.name] = face;
    $2b6e161c9edcf319$var$renderer.setSize($2b6e161c9edcf319$var$width, $2b6e161c9edcf319$var$height);
    $2b6e161c9edcf319$var$composer.setSize($2b6e161c9edcf319$var$width, $2b6e161c9edcf319$var$height);
    $2b6e161c9edcf319$var$composer.render();
    $2b6e161c9edcf319$var$camera.position.copy(originalPosition);
    $2b6e161c9edcf319$var$camera.up.copy(originalUp);
    $2b6e161c9edcf319$var$camera.fov = originalFov;
    $2b6e161c9edcf319$var$camera.aspect = originalAspect;
    $2b6e161c9edcf319$var$camera.lookAt(originalLookAt);
    $2b6e161c9edcf319$var$camera.zoom = original_zoom;
    $2b6e161c9edcf319$var$camera.updateProjectionMatrix();
    const outputCanvas = document.createElement('canvas');
    outputCanvas.width = $2b6e161c9edcf319$var$size * 2;
    outputCanvas.height = $2b6e161c9edcf319$var$size;
    const ctx = outputCanvas.getContext('2d');
    const outputImageData = ctx.createImageData(outputCanvas.width, outputCanvas.height);
    for(let y = 0; y < outputCanvas.height; y++)for(let x = 0; x < outputCanvas.width; x++){
        // 正距円筒におけるピクセルの方向ベクトルを計算
        const theta = x / outputCanvas.width * 2 * Math.PI - Math.PI;
        const phi = -(y / outputCanvas.height * Math.PI - 0.5 * Math.PI);
        const dir = new $dyjou.Vector3(Math.cos(theta) * Math.cos(phi), Math.sin(phi), Math.sin(theta) * Math.cos(phi));
        const { face: face, u: u, v: v } = $2b6e161c9edcf319$var$directionToCubeUV(dir);
        {
            const pixel = $2b6e161c9edcf319$var$getPixelFromFace(faceMap[face], u, v, face);
            const idx = (y * outputCanvas.width + x) * 4;
            outputImageData.data[idx + 0] = pixel[0];
            outputImageData.data[idx + 1] = pixel[1];
            outputImageData.data[idx + 2] = pixel[2];
            outputImageData.data[idx + 3] = 255;
        }
    }
    ctx.putImageData(outputImageData, 0, 0);
    const link = document.createElement('a');
    link.download = 'result1.png';
    link.href = outputCanvas.toDataURL('image/png');
    link.click();
    const outputCanvas2 = document.createElement('canvas');
    outputCanvas2.width = $2b6e161c9edcf319$var$size * 4;
    outputCanvas2.height = $2b6e161c9edcf319$var$size * 3;
    const ctx2 = outputCanvas2.getContext('2d');
    for (const dir of $2b6e161c9edcf319$var$directions){
        const face = faceMap[dir.name];
        if (dir.name == "px") {
            const imageData = face.getContext('2d').getImageData(0, 0, $2b6e161c9edcf319$var$size, $2b6e161c9edcf319$var$size);
            ctx2.putImageData(imageData, $2b6e161c9edcf319$var$size * 1.5, $2b6e161c9edcf319$var$size);
        } else if (dir.name == "py") {
            const imageData = face.getContext('2d').getImageData(0, 0, $2b6e161c9edcf319$var$size, $2b6e161c9edcf319$var$size);
            ctx2.putImageData(imageData, $2b6e161c9edcf319$var$size * 1.5, 0);
        } else if (dir.name == "pz") {
            const imageData = face.getContext('2d').getImageData(0, 0, $2b6e161c9edcf319$var$size, $2b6e161c9edcf319$var$size);
            ctx2.putImageData(imageData, $2b6e161c9edcf319$var$size * 1.5 + $2b6e161c9edcf319$var$size, $2b6e161c9edcf319$var$size);
        } else if (dir.name == "nz") {
            const imageData = face.getContext('2d').getImageData(0, 0, $2b6e161c9edcf319$var$size, $2b6e161c9edcf319$var$size);
            ctx2.putImageData(imageData, $2b6e161c9edcf319$var$size * 1.5 - $2b6e161c9edcf319$var$size, $2b6e161c9edcf319$var$size);
        } else if (dir.name == "nx") {
            const imageData = face.getContext('2d').getImageData(0, 0, $2b6e161c9edcf319$var$size, $2b6e161c9edcf319$var$size);
            ctx2.putImageData(imageData, $2b6e161c9edcf319$var$size * 1.5 - $2b6e161c9edcf319$var$size * 2, $2b6e161c9edcf319$var$size);
            ctx2.putImageData(imageData, $2b6e161c9edcf319$var$size * 1.5 + $2b6e161c9edcf319$var$size * 2, $2b6e161c9edcf319$var$size);
        } else {
            const imageData = face.getContext('2d').getImageData(0, 0, $2b6e161c9edcf319$var$size, $2b6e161c9edcf319$var$size);
            ctx2.putImageData(imageData, $2b6e161c9edcf319$var$size * 1.5, $2b6e161c9edcf319$var$size * 2);
        }
    }
    const link2 = document.createElement('a');
    link2.download = 'result2.png';
    link2.href = outputCanvas2.toDataURL('image/png');
    link2.click();
}
function $2b6e161c9edcf319$var$downloadComposerOutput() {
    const gl = $2b6e161c9edcf319$var$renderer.getContext();
    // 画像サイズを取得
    const width = $2b6e161c9edcf319$var$renderer.domElement.width;
    const height = $2b6e161c9edcf319$var$renderer.domElement.height;
    // ピクセルデータを格納するための配列
    const pixels = new Uint8Array(width * height * 4); // RGBA
    // レンダーターゲットを指定
    const framebuffer = gl.createFramebuffer();
    gl.bindFramebuffer(gl.FRAMEBUFFER, framebuffer);
    $2b6e161c9edcf319$var$composer.render();
    gl.readPixels(0, 0, width, height, gl.RGBA, gl.UNSIGNED_BYTE, pixels);
    const canvas = document.createElement('canvas');
    canvas.width = width;
    canvas.height = height;
    const ctx = canvas.getContext('2d');
    // imageData を作成して読み取ったピクセルデータを設定
    const imageData = ctx.createImageData(width, height);
    // ピクセルを上下反転してコピー
    for(let y = 0; y < height; y++)for(let x = 0; x < width; x++){
        const destIdx = (y * width + x) * 4;
        const srcIdx = ((height - y - 1) * width + x) * 4;
        imageData.data[destIdx] = pixels[srcIdx];
        imageData.data[destIdx + 1] = pixels[srcIdx + 1];
        imageData.data[destIdx + 2] = pixels[srcIdx + 2];
        imageData.data[destIdx + 3] = 255; // pixels[srcIdx + 3]; 透明度
    }
    ctx.putImageData(imageData, 0, 0);
    // ダウンロードリンク作成
    const link = document.createElement('a');
    link.download = 'output.png';
    link.href = canvas.toDataURL('image/png');
    link.click();
}
/* show_time_and_location_ele.addEventListener("click",()=>{
    //downloadComposerOutput();
    get_6dir_img();
})
 */ //リアルな星空の背景をヒッパルコス星表で作ろう！
//等級と大きさの変換
function $2b6e161c9edcf319$var$vmagToSize(vmag) {
    const minSize = 0.1;
    const maxSize = 42.25;
    return Math.max(minSize, maxSize - vmag * 6.5);
}
//B-V色指数から色温度(K)へ変換
function $2b6e161c9edcf319$var$bv2Temperature(bv) {
    return 4600 * (1 / (0.92 * bv + 1.7) + 1 / (0.92 * bv + 0.62));
}
//CIE xy 色度図なるものを用いて色空間の座標を求めるらしい
function $2b6e161c9edcf319$var$temperatureToXYZ(tempK) {
    let x, y;
    if (tempK >= 1667 && tempK <= 4000) x = -0.2661239 * 1e9 / tempK ** 3 - 234358 / tempK ** 2 + 877.6956 / tempK + 0.179910;
    else if (tempK > 4000 && tempK <= 25000) x = -3025846900 / tempK ** 3 + 2107037.9 / tempK ** 2 + 0.2226347 * 1e3 / tempK + 0.240390;
    else x = 0.31271;
    y = -3 * x ** 2 + 2.870 * x - 0.275;
    const Y = 1.0;
    const X = Y / y * x;
    const Z = Y / y * (1 - x - y);
    return [
        X,
        Y,
        Z
    ];
}
//座標からRGBに変換するらしい
function $2b6e161c9edcf319$var$xyzToRgb([X, Y, Z]) {
    let r = 3.2406 * X - 1.5372 * Y - 0.4986 * Z;
    let g = -0.9689 * X + 1.8758 * Y + 0.0415 * Z;
    let b = 0.0557 * X - 0.2040 * Y + 1.0570 * Z;
    // clamp
    return [
        Math.max(0, Math.min(1, r)),
        Math.max(0, Math.min(1, g)),
        Math.max(0, Math.min(1, b))
    ];
}
//彩度の補正
function $2b6e161c9edcf319$var$boostColor([r, g, b], factor = 2) {
    const avg = (r + g + b) / 3;
    r = avg + (r - avg) * factor * 1.8;
    g = avg + (g - avg) * factor * 0.2;
    b = avg + (b - avg) * factor * 0.2;
    return [
        Math.max(0, Math.min(1, r)),
        Math.max(0, Math.min(1, g)),
        Math.max(0, Math.min(1, b))
    ];
}
//まとめたもの
function $2b6e161c9edcf319$var$bvToRgb(bv) {
    const temp = $2b6e161c9edcf319$var$bv2Temperature(bv);
    const xyz = $2b6e161c9edcf319$var$temperatureToXYZ(temp);
    return $2b6e161c9edcf319$var$boostColor($2b6e161c9edcf319$var$xyzToRgb(xyz));
}
// ユリウス日を求める関数（UTC基準）
function $2b6e161c9edcf319$var$getJulianDate(year, month, day, hour, min, sec) {
    /* const year = date.getUTCFullYear();
    const month = date.getUTCMonth() + 1;
    const day = date.getUTCDate();
    const hour = date.getUTCHours();
    const min = date.getUTCMinutes();
    const sec = date.getUTCSeconds(); */ const targetDate = Date.UTC(year, month - 1, day, hour, min, sec);
    const baseDate = Date.UTC(2000, 0, 1, 12);
    const baseJD = 2451545.0; // 2000-01-01 12:00 UT
    const msPerDay = 86400000;
    const JD = baseJD + (targetDate - baseDate) / msPerDay;
    //console.log(JD)
    return JD;
}
//LST(地方恒星時を計算)
function $2b6e161c9edcf319$var$getLST(year, month, day, hour, min, sec, longitudeDeg) {
    // 1. 日付をUTCで取得
    const JD = $2b6e161c9edcf319$var$getJulianDate(year, month, day, hour, min, sec); // ユリウス日（UTC）
    const D = JD - 2451545.0; // J2000.0 からの経過日数
    // GSTの計算(度)
    let GST = 280.46061837 + D * 360.9856476; //280.46...が、J2000.0でのGST(らしい)
    //let GST = 24 * (0.671262 + 1.00273791 * (JD-2440000.5))*15;//1太陽日＝1.00273791恒星日(理科年表より)
    //console.log((GST % 360 + 360) % 360);
    // 経度を足してLSTに変換（東経はプラス、西経はマイナス）
    let LST = GST + longitudeDeg;
    // 0〜360度に正規化
    LST = (LST % 360 + 360) % 360;
    return LST;
}
const $2b6e161c9edcf319$var$time_ele = document.getElementById("time");
// 日本時間（例：2025年1月1日 23:00）
//const jst = new Date(year,month,day,hour,min,sec);
let $2b6e161c9edcf319$var$local_time = new Date();
$2b6e161c9edcf319$var$time_ele.innerText = `${$2b6e161c9edcf319$var$local_time.getFullYear()}\u{5E74}${$2b6e161c9edcf319$var$local_time.getMonth() + 1}\u{6708}${$2b6e161c9edcf319$var$local_time.getDate()}\u{65E5}${$2b6e161c9edcf319$var$local_time.getHours()}\u{6642}${$2b6e161c9edcf319$var$local_time.getMinutes()}\u{5206}`;
/* let offsetMinutes = new Date().getTimezoneOffset();
let offsetHours = -offsetMinutes / 60;//現地時間とutcとの差をげっちゅ */ let $2b6e161c9edcf319$var$offsetHours = 9; //ここは本題じゃないのでそんなに凝らないことにします。よってUTC+9で固定。
//console.log(offsetHours);
// UTCに変換
let $2b6e161c9edcf319$var$utc = new Date($2b6e161c9edcf319$var$local_time.getTime() - $2b6e161c9edcf319$var$offsetHours * 3600000); // -9時間
let $2b6e161c9edcf319$var$year = $2b6e161c9edcf319$var$utc.getUTCFullYear();
let $2b6e161c9edcf319$var$month = $2b6e161c9edcf319$var$utc.getUTCMonth() + 1;
let $2b6e161c9edcf319$var$day = $2b6e161c9edcf319$var$utc.getUTCDate();
let $2b6e161c9edcf319$var$hour = $2b6e161c9edcf319$var$utc.getUTCHours();
let $2b6e161c9edcf319$var$min = $2b6e161c9edcf319$var$utc.getUTCMinutes();
let $2b6e161c9edcf319$var$sec = $2b6e161c9edcf319$var$utc.getUTCSeconds();
let $2b6e161c9edcf319$var$baseDate = $2b6e161c9edcf319$var$utc; // スタート時刻 (年, 月-1, 日, 時, 分, 秒)
let $2b6e161c9edcf319$var$startTime = performance.now(); // 実時間の開始点
let $2b6e161c9edcf319$var$frameCount = 0;
let $2b6e161c9edcf319$var$rate_1ms = 1;
function $2b6e161c9edcf319$var$getSimulatedDate() {
    const now = performance.now();
    if ($2b6e161c9edcf319$var$transitioning) {
        $2b6e161c9edcf319$var$change_time_button.parentElement.style.display = "none";
        $2b6e161c9edcf319$var$change_location_button.parentElement.style.display = "none";
        $2b6e161c9edcf319$var$change_constellation_name_button.parentElement.style.display = "none";
        $2b6e161c9edcf319$var$telescope.visible = false;
        const elapsed = now - $2b6e161c9edcf319$var$transitionStartTime;
        let t = elapsed / $2b6e161c9edcf319$var$transitionDuration;
        if (t >= 1) {
            $2b6e161c9edcf319$var$transitioning = false;
            $2b6e161c9edcf319$var$baseDate = new Date($2b6e161c9edcf319$var$transitionToTime);
            $2b6e161c9edcf319$var$startTime = performance.now();
            $2b6e161c9edcf319$var$change_time_button.parentElement.style.display = "block";
            $2b6e161c9edcf319$var$change_location_button.parentElement.style.display = "block";
            $2b6e161c9edcf319$var$change_constellation_name_button.parentElement.style.display = "block";
            $2b6e161c9edcf319$var$telescope.visible = true;
            return $2b6e161c9edcf319$var$transitionToTime;
        }
        const easedT = $2b6e161c9edcf319$var$easeInOutCubic(t);
        const diffMs = $2b6e161c9edcf319$var$transitionToTime - $2b6e161c9edcf319$var$transitionFromTime;
        const simulatedTime = new Date($2b6e161c9edcf319$var$transitionFromTime.getTime() + diffMs * easedT);
        return simulatedTime;
    } else {
        // 通常の時間進行
        const elapsedMs = now - $2b6e161c9edcf319$var$startTime;
        return new Date($2b6e161c9edcf319$var$baseDate.getTime() + elapsedMs * $2b6e161c9edcf319$var$rate_1ms);
    }
//const simulatedYear = baseDate.getUTCFullYear() + frameCount*10;
//frameCount++;
//return new Date(Date.UTC(simulatedYear, 0, 1, 0, 0, 0));
}
//日時が更新されたらそこに天球を移動させる。
/* 
utcを渡しましょう。ややこしや。
*/ let $2b6e161c9edcf319$var$transitionDuration = 7000; // 7秒
let $2b6e161c9edcf319$var$transitionStartTime = null;
let $2b6e161c9edcf319$var$transitionFromTime = null;
let $2b6e161c9edcf319$var$transitionToTime = null;
let $2b6e161c9edcf319$var$transitioning = false;
function $2b6e161c9edcf319$var$move_time(n_year, n_month, n_day, n_hour, n_min, set_now = false) {
    $2b6e161c9edcf319$var$transitionStartTime = performance.now();
    $2b6e161c9edcf319$var$transitionFromTime = $2b6e161c9edcf319$var$getSimulatedDate();
    $2b6e161c9edcf319$var$transitionToTime = new Date(Date.UTC(n_year, n_month - 1, n_day, n_hour, n_min, 0));
    $2b6e161c9edcf319$var$transitioning = true;
    const thousandYears = 31557600000000; // ミリ秒
    const thirtyDays = 2592000000;
    if (Math.abs($2b6e161c9edcf319$var$transitionToTime - $2b6e161c9edcf319$var$transitionFromTime) >= thousandYears) $2b6e161c9edcf319$var$transitionDuration = 20000;
    else if (Math.abs($2b6e161c9edcf319$var$transitionToTime - $2b6e161c9edcf319$var$transitionFromTime) <= thirtyDays) $2b6e161c9edcf319$var$transitionDuration = 3000;
    else $2b6e161c9edcf319$var$transitionDuration = 7000;
    if (set_now) {
        $2b6e161c9edcf319$var$transitionToTime = new Date($2b6e161c9edcf319$var$transitionToTime.getTime() + $2b6e161c9edcf319$var$transitionDuration);
        const now = new Date(); // ローカルタイム
        const nowUTC = new Date(now.getTime() - $2b6e161c9edcf319$var$offsetHours * 3600000);
        $2b6e161c9edcf319$var$transitionToTime = new Date(nowUTC.getTime() + $2b6e161c9edcf319$var$transitionDuration);
    }
}
function $2b6e161c9edcf319$var$easeInOutCubic(x) {
    return x < 0.5 ? 4 * x * x * x : 1 - Math.pow(-2 * x + 2, 3) / 2;
}
var $2b6e161c9edcf319$var$stars_data, $2b6e161c9edcf319$var$constellations_data;
var $2b6e161c9edcf319$var$star_geometry;
var $2b6e161c9edcf319$var$line_geometorlies = [];
function $2b6e161c9edcf319$var$update_star() {
    if (!$2b6e161c9edcf319$var$at_main_content) {
        const simulatedDate = $2b6e161c9edcf319$var$getSimulatedDate();
        const local_time = new Date(simulatedDate.getTime() + $2b6e161c9edcf319$var$offsetHours * 3600000);
        $2b6e161c9edcf319$var$time_ele.innerText = `${local_time.getFullYear()}\u{5E74}${local_time.getMonth() + 1}\u{6708}${local_time.getDate()}\u{65E5}${local_time.getHours()}\u{6642}${local_time.getMinutes()}\u{5206}`;
        $2b6e161c9edcf319$var$update_location();
        $2b6e161c9edcf319$var$year = simulatedDate.getFullYear();
        $2b6e161c9edcf319$var$month = simulatedDate.getMonth() + 1;
        $2b6e161c9edcf319$var$day = simulatedDate.getDate();
        $2b6e161c9edcf319$var$hour = simulatedDate.getHours();
        $2b6e161c9edcf319$var$min = simulatedDate.getMinutes();
        $2b6e161c9edcf319$var$sec = simulatedDate.getSeconds();
        //console.log(year,month,day,hour,min,sec);
        const LST_Deg = $2b6e161c9edcf319$var$getLST($2b6e161c9edcf319$var$year, $2b6e161c9edcf319$var$month, $2b6e161c9edcf319$var$day, $2b6e161c9edcf319$var$hour, $2b6e161c9edcf319$var$min, $2b6e161c9edcf319$var$sec, $2b6e161c9edcf319$var$longitude);
        const LST_Rad = LST_Deg * Math.PI / 180;
        const lat_Deg = $2b6e161c9edcf319$var$latitude //35.6895014;//観測点の緯度(北緯)
        ;
        const lat_Rad = lat_Deg * Math.PI / 180;
        //let JD = getJulianDate(year,month,day,hour,min,sec);
        //console.log(JD)
        //console.log(JD2);
        //console.log(delta_RA_deg);
        const star_positions = $2b6e161c9edcf319$var$star_geometry.attributes.position.array;
        //console.log(star_positions);
        let star_index = 0;
        var raDec;
        var newRaDec;
        const year_diff = $2b6e161c9edcf319$var$year - 2000;
        $2b6e161c9edcf319$var$stars_data.forEach((star)=>{
            const RA_Deg = star.ra_deg; //RA(度数法)(春分点の赤経からの距離)(J.2000.0)
            //const RA_Deg = raw_RA_Deg + delta_RA_deg;
            const DEC_Deg = star.dec_deg; //DEC(度数法)(天の赤道からの距離)
            //固有運動を考慮
            const pm_dec_deg = star.pm_dec / 3600000;
            const new_dec_deg = star.dec_deg + pm_dec_deg * year_diff;
            const pm_ra_deg = star.pm_ra / 3600000 * Math.cos(new_dec_deg * Math.PI / 180); //ミリ秒角=>度
            const new_ra_deg = star.ra_deg + pm_ra_deg * year_diff;
            const new_ra_rad = new_ra_deg * Math.PI / 180;
            const new_dec_rad = new_dec_deg * Math.PI / 180;
            //ラジアンに変換
            //let RA_Rad = RA_Deg*Math.PI/180
            //let DEC_Rad = DEC_Deg*Math.PI/180
            let RA_Rad = new_ra_rad;
            let DEC_Rad = new_dec_rad;
            raDec = {
                ra: RA_Rad,
                dec: DEC_Rad
            };
            //console.log(raDec);
            //console.log(JD)
            newRaDec = (0, $7b9a9495915be746$export$2e2bcd8739ae039).position(raDec, 2000, $2b6e161c9edcf319$var$year, 0, 0); //歳差運動による誤差まで自力で求めたかったが力及ばず...無念...
            //console.log(newRaDec);
            //観測点からの高さを求める
            RA_Rad = newRaDec.ra;
            DEC_Rad = newRaDec.dec;
            const HA_Rad = LST_Rad - RA_Rad;
            const sinAlt = Math.sin(DEC_Rad) * Math.sin(lat_Rad) + Math.cos(DEC_Rad) * Math.cos(lat_Rad) * Math.cos(HA_Rad);
            //sinAlt = Math.max(-1, Math.min(1, sinAlt));
            const Alt_Rad = Math.asin(sinAlt);
            //観測点からの左右の角度を求める
            const cosAz = (Math.sin(DEC_Rad) - Math.sin(Alt_Rad) * Math.sin(lat_Rad)) / (Math.cos(Alt_Rad) * Math.cos(lat_Rad));
            const sinAz = -Math.cos(DEC_Rad) * Math.sin(HA_Rad) / Math.cos(Alt_Rad);
            const Az_Rad = Math.atan2(sinAz, cosAz);
            //let Az_Deg = 360-Az_RAD*180/Math.PI
            //console.log("Dec,RA:",DEC_Deg,RA_Deg);
            //console.log("Alt,Az:",Alt_Rad*180/Math.PI,Az_Rad*180/Math.PI);
            //赤道座標系から直交する空間座標系に変換
            /* const star_x = starDistance * Math.cos(DEC_Rad) * Math.cos(RA_Rad);
        const star_y = starDistance * Math.sin(DEC_Rad);
        const star_z = starDistance * Math.cos(DEC_Rad) * Math.sin(RA_Rad); */ const star_x = $2b6e161c9edcf319$var$starDistance * Math.cos(Alt_Rad) * Math.cos(Az_Rad);
            const star_y = $2b6e161c9edcf319$var$starDistance * Math.sin(Alt_Rad);
            const star_z = $2b6e161c9edcf319$var$starDistance * Math.cos(Alt_Rad) * Math.sin(Az_Rad);
            $2b6e161c9edcf319$var$hipPosition[star.hip_number] = new $dyjou.Vector3(star_x, star_y, star_z);
            star_positions[star_index] = star_x;
            star_positions[star_index + 1] = star_y;
            star_positions[star_index + 2] = star_z;
            star_index += 3;
        });
        //console.log(raDec.ra/Math.PI*180);
        //console.log(newRaDec.ra/Math.PI*180);
        //console.log(newRaDec.dec/Math.PI*180-raDec.dec/Math.PI*180);
        //console.log(delta_RA_deg);
        //console.log(Object.keys(hipPosition).length)
        //console.log(star_index);
        $2b6e161c9edcf319$var$star_geometry.attributes.position.needsUpdate = true;
        let constellations_index = 0;
        //console.log(line_geometorlies);
        let error_count = 0;
        $2b6e161c9edcf319$var$constellations_data.constellations.forEach((constellation)=>{
            constellation.lines.forEach((line)=>{
                //console.log(constellations_index);
                let line_geometory = $2b6e161c9edcf319$var$line_geometorlies[constellations_index];
                let line_geometory_pos = line_geometory.attributes.position.array;
                //console.log(line_geometory_pos.length);
                constellations_index += 1;
                //console.log(line)
                //const linePositions = [];
                //if(constellation.common_name.native=="Cassiopeia"){
                for(let i = 0; i < line.length - 1; i++){
                    const hip1 = line[i];
                    const hip2 = line[i + 1];
                    if (hip1 == "thin") continue;
                    const pos1 = $2b6e161c9edcf319$var$hipPosition[hip1];
                    const pos2 = $2b6e161c9edcf319$var$hipPosition[hip2];
                    if (pos1 && pos2) {
                        line_geometory_pos[i * 6 + 0] = pos1.x;
                        line_geometory_pos[i * 6 + 1] = pos1.y;
                        line_geometory_pos[i * 6 + 2] = pos1.z;
                        line_geometory_pos[i * 6 + 3] = pos2.x;
                        line_geometory_pos[i * 6 + 4] = pos2.y;
                        line_geometory_pos[i * 6 + 5] = pos2.z;
                    } else error_count++;
                }
                error_count;
                line_geometory.attributes.position.needsUpdate = true;
                line_geometory.computeBoundingSphere();
            //}
            });
        });
    }
    //console.log(error_count);
    requestAnimationFrame($2b6e161c9edcf319$var$update_star);
    $2b6e161c9edcf319$var$animate();
    $2b6e161c9edcf319$var$composer.render();
}
// 星を配置する距離(天球の半径)
let $2b6e161c9edcf319$var$starDistance = 600;
var $2b6e161c9edcf319$var$star_material;
const $2b6e161c9edcf319$var$hipPosition = {}; //HIP番号と位置を対応づける辞書
const $2b6e161c9edcf319$var$hipNumbers = [];
let $2b6e161c9edcf319$var$constellations_stars = {};
var $2b6e161c9edcf319$var$star_points;
var $2b6e161c9edcf319$var$constellation_lines = [];
//fetch(jsonurl)
//こうしないと読み込み完了の順番によっては星座が表示されないよねあはは
Promise.all([
    fetch((0, (/*@__PURE__*/$parcel$interopDefault($1dc737c91cb5f1fb$exports)))).then((res)=>res.json()),
    fetch((0, (/*@__PURE__*/$parcel$interopDefault($4812f2a55fcfa131$exports)))).then((res)=>res.json())
]).then(([stars, constellations])=>{
    $2b6e161c9edcf319$var$stars_data = stars;
    $2b6e161c9edcf319$var$constellations_data = constellations;
    const geometry = new $dyjou.BufferGeometry();
    const positions = [];
    const colors = [];
    const sizes = [];
    const intensities = [];
    const color = new $dyjou.Color();
    const simulatedDate = $2b6e161c9edcf319$var$getSimulatedDate();
    let year = simulatedDate.getFullYear();
    let month = simulatedDate.getMonth() + 1;
    let day = simulatedDate.getDate();
    let hour = simulatedDate.getHours();
    let min = simulatedDate.getMinutes();
    let sec = simulatedDate.getSeconds();
    // 日本時間（例：2025年1月1日 23:00）
    const jst = new Date(year, month, day, hour, min, sec);
    // UTCに変換
    const utc = new Date(jst.getTime() - 32400000); // -9時間
    year = utc.getUTCFullYear();
    month = utc.getUTCMonth() + 1;
    day = utc.getUTCDate();
    hour = utc.getUTCHours();
    min = utc.getUTCMinutes();
    sec = utc.getUTCSeconds();
    //console.log(getLST(year,month,day,hour,min,sec,139.75));
    const LST_Deg = $2b6e161c9edcf319$var$getLST(year, month, day, hour, min, sec, $2b6e161c9edcf319$var$longitude);
    const LST_Rad = LST_Deg * Math.PI / 180;
    const lat_Deg = $2b6e161c9edcf319$var$latitude; //観測点の緯度(北緯)
    const lat_Rad = lat_Deg * Math.PI / 180;
    const year_JD = $2b6e161c9edcf319$var$getJulianDate(year, month, day, hour, min, sec);
    //const delta_RA_deg = (360 / 25772) * (year_JD - 2451545.0)/365.25;
    //console.log(delta_RA_deg);
    stars.forEach((star)=>{
        const raw_RA_Deg = star.ra_deg; //RA(度数法)(春分点の赤経からの距離)(J.2000.0)
        const RA_Deg = raw_RA_Deg // + delta_RA_deg;
        ;
        const DEC_Deg = star.dec_deg; //DEC(度数法)(天の赤道からの距離)
        //ラジアンに変換
        let RA_Rad = RA_Deg * Math.PI / 180;
        let DEC_Rad = DEC_Deg * Math.PI / 180;
        let raDec = {
            ra: RA_Rad,
            dec: DEC_Rad
        };
        let newRaDec = (0, $7b9a9495915be746$export$2e2bcd8739ae039).position(raDec, 2000, year, 0, 0); //歳差運動による誤差まで自力で求めたかったが力及ばず...無念...
        RA_Rad = newRaDec.ra;
        DEC_Rad = newRaDec.dec;
        //観測点からの高さを求める
        const HA_Rad = LST_Rad - RA_Rad;
        const sinAlt = Math.sin(DEC_Rad) * Math.sin(lat_Rad) + Math.cos(DEC_Rad) * Math.cos(lat_Rad) * Math.cos(HA_Rad);
        const Alt_Rad = Math.asin(sinAlt);
        //観測点からの左右の角度を求める
        const cosAz = (Math.sin(DEC_Rad) - Math.sin(Alt_Rad) * Math.sin(lat_Rad)) / (Math.cos(Alt_Rad) * Math.cos(lat_Rad));
        const sinAz = -Math.cos(DEC_Rad) * Math.sin(HA_Rad) / Math.cos(Alt_Rad);
        let Az_Rad = Math.atan2(sinAz, cosAz);
        const star_x = $2b6e161c9edcf319$var$starDistance * Math.cos(Alt_Rad) * Math.cos(Az_Rad);
        const star_y = $2b6e161c9edcf319$var$starDistance * Math.sin(Alt_Rad);
        const star_z = $2b6e161c9edcf319$var$starDistance * Math.cos(Alt_Rad) * Math.sin(Az_Rad);
        //見かけの等級
        const vmag = star.vmag;
        positions.push(star_x, star_y, star_z);
        $2b6e161c9edcf319$var$hipPosition[star.hip_number] = new $dyjou.Vector3(star_x, star_y, star_z);
        $2b6e161c9edcf319$var$hipNumbers.push(star.hip_number);
        const star_intensity = Math.max(1.1 - star.vmag / 6.5, 0.0) + 9;
        //color.setRGB(star_intensity, star_intensity, star_intensity);
        intensities.push(star_intensity);
        const sRGB = $2b6e161c9edcf319$var$bvToRgb(star.bv_color);
        color.setRGB(sRGB[0], sRGB[1], sRGB[2]);
        colors.push(color.r, color.g, color.b);
        const size = $2b6e161c9edcf319$var$vmagToSize(vmag);
        sizes.push(size);
    //console.log(size);
    });
    geometry.setAttribute('position', new $dyjou.Float32BufferAttribute(positions, 3));
    geometry.setAttribute('customColor', new $dyjou.Float32BufferAttribute(colors, 3));
    geometry.setAttribute('size', new $dyjou.Float32BufferAttribute(sizes, 1));
    geometry.setAttribute('intensity', new $dyjou.Float32BufferAttribute(intensities, 1));
    geometry.setAttribute('hipNumbers', new $dyjou.Float32BufferAttribute($2b6e161c9edcf319$var$hipNumbers, 1));
    $2b6e161c9edcf319$var$star_geometry = geometry;
    const star_img = "data:image/png;base64,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";
    //ありがとうChatGPT
    $2b6e161c9edcf319$var$star_material = new $dyjou.ShaderMaterial({
        uniforms: {
            time: {
                value: 0.0
            },
            pointTexture: {
                value: new $dyjou.TextureLoader().load(star_img)
            } //円形の画像データ
        },
        vertexShader: `
            attribute float intensity;
            attribute float size;
            attribute vec3 customColor;
            attribute float hipNumbers;
            varying vec3 vColor;
            varying float vIntensity;
            varying float vRandom;
        
            void main() {
                vRandom = fract(sin(hipNumbers) * 43758.5453);
                vColor = customColor;
                vIntensity = intensity;
                vec4 mvPosition = modelViewMatrix * vec4(position, 1.0);
                gl_PointSize = size * (300.0 / -mvPosition.z); // \u{9060}\u{8FD1}\u{6CD5}\u{88DC}\u{6B63}
                //gl_PointSize = size;
                gl_Position = projectionMatrix * mvPosition;
            }
        `,
        fragmentShader: `
            uniform sampler2D pointTexture;
            uniform float time;
            varying vec3 vColor;
            varying float vIntensity;
            varying float vRandom;
        
            void main() {
                float speed = 1.0 + vRandom * 2.0; 
                float flicker = 0.6 + 0.4 * sin(time * speed + vRandom * 6.28);
                vec4 texColor = texture2D(pointTexture, gl_PointCoord);
                vec3 finalColor = vColor * vIntensity * flicker;
                gl_FragColor = vec4(finalColor, 1.0) * texColor;
            }
        `,
        transparent: true,
        depthWrite: false,
        sizeAttenuation: false,
        vertexColors: true
    });
    const points = new $dyjou.Points(geometry, $2b6e161c9edcf319$var$star_material);
    $2b6e161c9edcf319$var$star_points = points;
    $2b6e161c9edcf319$var$scene.add(points);
    const line_colors = [
        0x1df8de,
        0xd74443,
        0x70aeff,
        0xe0e34c,
        0xf89d1d,
        0xeccbdc
    ];
    constellations.constellations.forEach((constellation)=>{
        let line_color = line_colors[Math.floor(Math.random() * line_colors.length)];
        constellation.lines.forEach((line)=>{
            let error_count = 0;
            //console.log(line)
            const linePositions = [];
            //if(constellation.common_name.native=="Cassiopeia"){
            for(let i = 0; i < line.length - 1; i++){
                const hip1 = line[i];
                const hip2 = line[i + 1];
                if (!$2b6e161c9edcf319$var$constellations_stars[hip1]) $2b6e161c9edcf319$var$constellations_stars[hip1] = [];
                if (!$2b6e161c9edcf319$var$constellations_stars[hip2]) $2b6e161c9edcf319$var$constellations_stars[hip2] = [];
                if (!$2b6e161c9edcf319$var$constellations_stars[hip1].includes(constellation.common_name.native)) $2b6e161c9edcf319$var$constellations_stars[hip1].push(constellation.common_name.native);
                if (!$2b6e161c9edcf319$var$constellations_stars[hip2].includes(constellation.common_name.native)) $2b6e161c9edcf319$var$constellations_stars[hip2].push(constellation.common_name.native);
                const pos1 = $2b6e161c9edcf319$var$hipPosition[hip1];
                const pos2 = $2b6e161c9edcf319$var$hipPosition[hip2];
                if (pos1 && pos2) {
                    linePositions.push(pos1.x, pos1.y, pos1.z);
                    linePositions.push(pos2.x, pos2.y, pos2.z);
                } else {
                    console.log(hip1);
                    console.log(hip2);
                    error_count++;
                }
            }
            //}
            const lineGeometry = new $dyjou.BufferGeometry();
            lineGeometry.setAttribute('position', new $dyjou.Float32BufferAttribute(linePositions, 3));
            const lineMaterial = new $dyjou.LineBasicMaterial({
                color: line_color,
                transparent: true,
                opacity: 0.7,
                depthWrite: false,
                depthTest: true
            });
            const lineMesh = new $dyjou.LineSegments(lineGeometry, lineMaterial);
            $2b6e161c9edcf319$var$line_geometorlies.push(lineGeometry);
            if (error_count == 0) {
                $2b6e161c9edcf319$var$scene.add(lineMesh);
                $2b6e161c9edcf319$var$constellation_lines.push(lineMesh);
            }
        });
    });
    //console.log("1:",error_count);
    $2b6e161c9edcf319$var$update_star();
//get_6dir_img();
});
//星座の描画
/* fetch(constellationsurl)
.then(res => res.json())
.then(constellations => {
    
}) */ const $2b6e161c9edcf319$var$angle_parent = document.getElementById("angle_parent");
const $2b6e161c9edcf319$var$angle_45 = document.createElement("div");
$2b6e161c9edcf319$var$angle_45.innerText = "45";
$2b6e161c9edcf319$var$angle_45.classList.add("angles");
//angle_45.style.fontSize = "20pt"
$2b6e161c9edcf319$var$angle_45.style.top = "25%";
$2b6e161c9edcf319$var$angle_parent.appendChild($2b6e161c9edcf319$var$angle_45);
const $2b6e161c9edcf319$var$angle_90 = document.createElement("div");
$2b6e161c9edcf319$var$angle_90.innerText = "90";
$2b6e161c9edcf319$var$angle_90.classList.add("angles");
//angle_90.style.fontSize = "20pt"
$2b6e161c9edcf319$var$angle_90.style.top = "0%";
$2b6e161c9edcf319$var$angle_parent.appendChild($2b6e161c9edcf319$var$angle_90);
const $2b6e161c9edcf319$var$angle_0 = document.createElement("div");
$2b6e161c9edcf319$var$angle_0.innerText = "0";
$2b6e161c9edcf319$var$angle_0.classList.add("angles");
//angle_0.style.fontSize = "20pt"
$2b6e161c9edcf319$var$angle_0.style.top = "50%";
$2b6e161c9edcf319$var$angle_parent.appendChild($2b6e161c9edcf319$var$angle_0);
const $2b6e161c9edcf319$var$angle_m45 = document.createElement("div");
$2b6e161c9edcf319$var$angle_m45.innerText = "-45";
$2b6e161c9edcf319$var$angle_m45.classList.add("angles");
//angle_m45.style.fontSize = "20pt"
$2b6e161c9edcf319$var$angle_m45.style.top = "75%";
$2b6e161c9edcf319$var$angle_parent.appendChild($2b6e161c9edcf319$var$angle_m45);
const $2b6e161c9edcf319$var$angle_m90 = document.createElement("div");
$2b6e161c9edcf319$var$angle_m90.innerText = "-90";
$2b6e161c9edcf319$var$angle_m90.classList.add("angles");
//angle_m90.style.fontSize = "20pt"
$2b6e161c9edcf319$var$angle_m90.style.top = "100%";
$2b6e161c9edcf319$var$angle_parent.appendChild($2b6e161c9edcf319$var$angle_m90);
const $2b6e161c9edcf319$var$direction_parent = document.getElementById("direction_parent");
const $2b6e161c9edcf319$var$direction_N = document.createElement('img');
$2b6e161c9edcf319$var$direction_N.src = (0, (/*@__PURE__*/$parcel$interopDefault($d81e672b6d1344dd$exports)));
$2b6e161c9edcf319$var$direction_N.classList.add("directions");
$2b6e161c9edcf319$var$direction_N.style.left = '50%';
$2b6e161c9edcf319$var$direction_parent.appendChild($2b6e161c9edcf319$var$direction_N);
const $2b6e161c9edcf319$var$direction_E = document.createElement('img');
$2b6e161c9edcf319$var$direction_E.src = (0, (/*@__PURE__*/$parcel$interopDefault($2b394d55fe10f5be$exports)));
$2b6e161c9edcf319$var$direction_E.classList.add("directions");
$2b6e161c9edcf319$var$direction_E.style.left = '0%';
$2b6e161c9edcf319$var$direction_parent.appendChild($2b6e161c9edcf319$var$direction_E);
const $2b6e161c9edcf319$var$direction_S = document.createElement('img');
$2b6e161c9edcf319$var$direction_S.src = (0, (/*@__PURE__*/$parcel$interopDefault($572ae2c7d6f6d3ac$exports)));
$2b6e161c9edcf319$var$direction_S.classList.add("directions");
$2b6e161c9edcf319$var$direction_S.style.left = '150%';
$2b6e161c9edcf319$var$direction_parent.appendChild($2b6e161c9edcf319$var$direction_S);
const $2b6e161c9edcf319$var$direction_W = document.createElement('img');
$2b6e161c9edcf319$var$direction_W.src = (0, (/*@__PURE__*/$parcel$interopDefault($b3fd4caac830b527$exports)));
$2b6e161c9edcf319$var$direction_W.classList.add("directions");
$2b6e161c9edcf319$var$direction_W.style.left = '100%';
$2b6e161c9edcf319$var$direction_parent.appendChild($2b6e161c9edcf319$var$direction_W);
function $2b6e161c9edcf319$var$compute_left_rate_E(r) {
    let left_rate_E;
    if (r > 180) left_rate_E = 50 - (360 - r) / 90 * 50;
    else left_rate_E = 100 - (90 - r) / 90 * 50;
    return left_rate_E;
}
const $2b6e161c9edcf319$var$clock = new $dyjou.Clock();
function $2b6e161c9edcf319$var$animate() {
    //requestAnimationFrame(animate);
    $2b6e161c9edcf319$var$time += 0.01;
    //bloomPass.strength = 0.4 + 0.3 * Math.sin(time); // 0.2〜0.8くらい
    let panel_updown = 0.1 * Math.sin($2b6e161c9edcf319$var$time / 1.12);
    /* camera.zoom += 0.01;
    console.log(camera.zoom); */ //camera.updateProjectionMatrix(); 
    if ($2b6e161c9edcf319$var$star_material) $2b6e161c9edcf319$var$star_material.uniforms.time.value = performance.now() * 0.001;
    if ($2b6e161c9edcf319$var$panel) //console.log(panel_pos);
    $2b6e161c9edcf319$var$panel.position.set($2b6e161c9edcf319$var$panel_pos.x, $2b6e161c9edcf319$var$panel_pos.y + panel_updown, $2b6e161c9edcf319$var$panel_pos.z);
    if ($2b6e161c9edcf319$var$star_panel) //star_panel.up.copy(camera.up);
    //star_panel.lookAt(-3,3,-1);
    $2b6e161c9edcf319$var$star_panel.quaternion.copy($2b6e161c9edcf319$var$camera.quaternion);
    if ($2b6e161c9edcf319$var$cloudsprite && $2b6e161c9edcf319$var$cloudsprite.material) $2b6e161c9edcf319$var$cloudsprite.position.y += panel_updown * 3;
    /* if(star_panel_time){
        star_panel_time.quaternion.copy(camera.quaternion);
    } */ //console.log(camera.position.x,camera.position.y,camera.position.z);
    //renderer.render(scene, camera);
    const delta = $2b6e161c9edcf319$var$clock.getDelta();
    //console.log(delta);
    // パーティクル更新
    if ($2b6e161c9edcf319$var$explosions) for(let i = $2b6e161c9edcf319$var$explosions.length - 1; i >= 0; i--){
        $2b6e161c9edcf319$var$explosions[i].update(delta);
        if ($2b6e161c9edcf319$var$explosions[i].isDead()) {
            $2b6e161c9edcf319$var$explosions[i].dispose();
            $2b6e161c9edcf319$var$explosions.splice(i, 1); // 削除
        }
    }
    const rotate_y = ($2b6e161c9edcf319$var$camera.rotation.y / Math.PI * 180 % 360 + 360) % 360;
    //console.log(camera.rotation.y/Math.PI*180,rotate_y);
    let left_rate_N = 100 - (360 - rotate_y) / 180 * 100;
    $2b6e161c9edcf319$var$direction_N.style.left = `${left_rate_N}%`;
    let left_rate_W = 100 - (270 - rotate_y) / 180 * 100;
    $2b6e161c9edcf319$var$direction_W.style.left = `${left_rate_W}%`;
    let left_rate_S = 100 - (180 - rotate_y) / 180 * 100;
    $2b6e161c9edcf319$var$direction_S.style.left = `${left_rate_S}%`;
    let left_rate_E = $2b6e161c9edcf319$var$compute_left_rate_E(rotate_y);
    $2b6e161c9edcf319$var$direction_E.style.left = `${left_rate_E}%`;
    let rotate_x = ($2b6e161c9edcf319$var$camera.rotation.x / Math.PI * 180 % 360 + 360) % 360;
    while(rotate_x >= 180)rotate_x -= 360;
    const scaled_x = (rotate_x + 90) / 180 * 100;
    //console.log(rotate_x);
    $2b6e161c9edcf319$var$angle_45.style.top = `${scaled_x - 25}%`;
    $2b6e161c9edcf319$var$angle_0.style.top = `${scaled_x}%`;
    $2b6e161c9edcf319$var$angle_90.style.top = `${scaled_x - 50}%`;
    $2b6e161c9edcf319$var$angle_m45.style.top = `${scaled_x + 25}%`;
    $2b6e161c9edcf319$var$angle_m90.style.top = `${scaled_x + 50}%`;
    if ($2b6e161c9edcf319$var$InPreparationSong) {
        $2b6e161c9edcf319$var$changed_rotate_mode = false;
        $2b6e161c9edcf319$var$rotation_pase = 2;
    //galaxy_img_scale = Math.min(galaxy_img_scale,1.6);
    } else if ($2b6e161c9edcf319$var$InPreparationSong === false) {
        //console.log("music_num:",music_num);
        if (!$2b6e161c9edcf319$var$changed_rotate_mode && $2b6e161c9edcf319$var$music_num == 7) {
            $2b6e161c9edcf319$var$always_GalaxyRotating = false;
            $2b6e161c9edcf319$var$GalaxyRotateStart_time = undefined;
            $2b6e161c9edcf319$var$current_galaxy_rotate = $2b6e161c9edcf319$var$addition_angle;
            $2b6e161c9edcf319$var$GalaxyRotating = true;
            $2b6e161c9edcf319$var$changed_rotate_mode = true;
        } else if (!$2b6e161c9edcf319$var$changed_rotate_mode && !($2b6e161c9edcf319$var$music_num == 7)) {
            $2b6e161c9edcf319$var$prepareMVimg($2b6e161c9edcf319$var$music_num);
            $2b6e161c9edcf319$var$always_GalaxyRotating = false;
            $2b6e161c9edcf319$var$changed_rotate_mode = true;
        }
        if ($2b6e161c9edcf319$var$rotate_progress > 0.8 && $2b6e161c9edcf319$var$music_num == 7) {
            $2b6e161c9edcf319$var$InPreparationSong = undefined;
            //galaxy_img.style.display = "none";
            let tl = (0, $357b3f2d5f2ec9d5$export$99ee26438460406a).timeline();
            tl.to($2b6e161c9edcf319$var$camera, {
                duration: 1,
                onComplete: ()=>{
                    $2b6e161c9edcf319$var$star_points.visible = true;
                    $2b6e161c9edcf319$var$starDistance = 200;
                    $2b6e161c9edcf319$var$scene.add($2b6e161c9edcf319$var$hide_plane);
                }
            });
            /* tl.to(hide_plane.material.color,{
                duration: 1,
                r: 1,
                g: 1,
                b: 1,
                onComplete: () => {
                    //scene.remove("hide_plane");
                    galaxy_img.style.display = "none";
                }
            },1) */ tl.to($2b6e161c9edcf319$var$hide_plane.material, {
                duration: 1,
                opacity: 0,
                onComplete: ()=>{
                    $2b6e161c9edcf319$var$scene.remove($2b6e161c9edcf319$var$cloudsprite);
                    $2b6e161c9edcf319$var$cloudtexture.dispose();
                    $2b6e161c9edcf319$var$cloudmaterial.dispose();
                    $2b6e161c9edcf319$var$scene.remove($2b6e161c9edcf319$var$galaxy_star_points);
                    $2b6e161c9edcf319$var$galazy_star_material.dispose();
                    $2b6e161c9edcf319$var$galazy_star_geometory.dispose();
                    $2b6e161c9edcf319$var$hide_plane.visible = false;
                    $2b6e161c9edcf319$var$scene.remove($2b6e161c9edcf319$var$hide_plane);
                    $2b6e161c9edcf319$var$geometry_hide_panel.dispose();
                    $2b6e161c9edcf319$var$material_hide_panel.dispose();
                    $2b6e161c9edcf319$var$in_transition_telescope = false;
                    $2b6e161c9edcf319$var$start_observe_button.style.pointerEvents = "auto";
                    $2b6e161c9edcf319$var$start_observe_button.style.opacity = 1;
                    $2b6e161c9edcf319$var$start_observe_button.style.display = "flex";
                    $2b6e161c9edcf319$var$make_tanzaku_and_place();
                    $2b6e161c9edcf319$var$player.timer.seek(0);
                    $2b6e161c9edcf319$var$player.requestStop();
                    $2b6e161c9edcf319$var$update_gauge(0);
                    $2b6e161c9edcf319$var$observe_gauge_ele.style.display = "block";
                    $2b6e161c9edcf319$var$update_gauge(0);
                    $2b6e161c9edcf319$var$loading.style.display = "none";
                    $2b6e161c9edcf319$var$tanzaku_space.style.display = "block";
                    $2b6e161c9edcf319$var$name_galaxy.innerText = "\u89B3\u6E2C\u4E2D\u306E\u9280\u6CB3\uFF1A" + $2b6e161c9edcf319$var$player.data.song.name;
                    $2b6e161c9edcf319$var$introduce_ele.style.display = "block";
                    $2b6e161c9edcf319$var$info_icon.style.display = "block";
                }
            });
        } else if ($2b6e161c9edcf319$var$Transform_progress >= 0.9 && !($2b6e161c9edcf319$var$music_num == 7)) {
            //console.log("Transform Done")
            $2b6e161c9edcf319$var$InPreparationSong = undefined;
            let tl = (0, $357b3f2d5f2ec9d5$export$99ee26438460406a).timeline();
            tl.to($2b6e161c9edcf319$var$camera, {
                duration: 2,
                onComplete: ()=>{
                    //console.log("wait finished");
                    $2b6e161c9edcf319$var$GalaxyTransformStart_time = undefined;
                    $2b6e161c9edcf319$var$GalaxyTransforming = true;
                    $2b6e161c9edcf319$var$Transform_progress = 0;
                    $2b6e161c9edcf319$var$move_center = true;
                }
            }, 0);
            tl.to($2b6e161c9edcf319$var$camera, {
                duration: 4.5,
                onComplete: ()=>{
                    $2b6e161c9edcf319$var$star_points.visible = true;
                    $2b6e161c9edcf319$var$starDistance = 200;
                    $2b6e161c9edcf319$var$scene.add($2b6e161c9edcf319$var$hide_plane);
                }
            });
            tl.to($2b6e161c9edcf319$var$hide_plane.material, {
                duration: 1,
                opacity: 0,
                onComplete: ()=>{
                    $2b6e161c9edcf319$var$scene.remove($2b6e161c9edcf319$var$cloudsprite);
                    $2b6e161c9edcf319$var$cloudtexture.dispose();
                    $2b6e161c9edcf319$var$cloudmaterial.dispose();
                    $2b6e161c9edcf319$var$scene.remove($2b6e161c9edcf319$var$galaxy_star_points);
                    $2b6e161c9edcf319$var$galazy_star_material.dispose();
                    $2b6e161c9edcf319$var$galazy_star_geometory.dispose();
                    $2b6e161c9edcf319$var$hide_plane.visible = false;
                    $2b6e161c9edcf319$var$scene.remove($2b6e161c9edcf319$var$hide_plane);
                    $2b6e161c9edcf319$var$geometry_hide_panel.dispose();
                    $2b6e161c9edcf319$var$material_hide_panel.dispose();
                    $2b6e161c9edcf319$var$in_transition_telescope = false;
                    $2b6e161c9edcf319$var$start_observe_button.style.pointerEvents = "auto";
                    $2b6e161c9edcf319$var$start_observe_button.style.opacity = 1;
                    $2b6e161c9edcf319$var$start_observe_button.style.display = "flex";
                    $2b6e161c9edcf319$var$make_tanzaku_and_place();
                    $2b6e161c9edcf319$var$player.timer.seek(0);
                    $2b6e161c9edcf319$var$player.requestStop();
                    $2b6e161c9edcf319$var$update_gauge(0);
                    $2b6e161c9edcf319$var$observe_gauge_ele.style.display = "block";
                    $2b6e161c9edcf319$var$update_gauge(0);
                    $2b6e161c9edcf319$var$loading.style.display = "none";
                    $2b6e161c9edcf319$var$tanzaku_space.style.display = "block";
                    $2b6e161c9edcf319$var$name_galaxy.innerText = "\u89B3\u6E2C\u4E2D\u306E\u9280\u6CB3\uFF1A" + $2b6e161c9edcf319$var$player.data.song.name;
                    $2b6e161c9edcf319$var$info_icon.style.display = "block";
                    $2b6e161c9edcf319$var$introduce_ele.style.display = "block";
                }
            });
        }
    }
    $2b6e161c9edcf319$var$update_back_tanzaku();
    $2b6e161c9edcf319$var$rotate_galaxyStars();
    $2b6e161c9edcf319$var$always_rotate_galaxyStars();
    $2b6e161c9edcf319$var$transform_stars();
/* if(isGyro){
        controls.update();
    } */ //controls.update();
}
const $2b6e161c9edcf319$var$tanzaku_space = document.getElementById("tanzaku_space_wrapper");
const $2b6e161c9edcf319$var$start_observe_button = document.getElementById("start_observe");
const $2b6e161c9edcf319$var$observe_gauge_ele = document.getElementById("observe_gauge");
const $2b6e161c9edcf319$var$gauge_mask = document.getElementById("gauge_mask");
const $2b6e161c9edcf319$var$gauge_star = document.getElementById("gauge_star");
const $2b6e161c9edcf319$var$play_button = document.getElementById("play_button");
const $2b6e161c9edcf319$var$introduce_ele = document.getElementById("introduce");
$2b6e161c9edcf319$var$start_observe_button.addEventListener("click", ()=>{
    console.log($2b6e161c9edcf319$var$player.isPlaying);
    if (!$2b6e161c9edcf319$var$player.isPlaying) {
        $2b6e161c9edcf319$var$player.requestPlay();
        if (!$2b6e161c9edcf319$var$hasEverPlayed) $2b6e161c9edcf319$var$player.timer.seek(0);
        $2b6e161c9edcf319$var$hasEverPlayed = true;
        $2b6e161c9edcf319$var$started_byUser = true;
    } else {
        $2b6e161c9edcf319$var$player.requestPause();
        $2b6e161c9edcf319$var$started_byUser = false;
    /* play_button.src = play_button_img;
        start_dbserve_child.innerText = "観測を再開する"; */ }
});
function $2b6e161c9edcf319$var$update_gauge(progress) {
    $2b6e161c9edcf319$var$gauge_mask.style.height = `${100 - progress}%`;
    $2b6e161c9edcf319$var$gauge_star.style.top = `${100 - progress}%`;
}
const $2b6e161c9edcf319$var$back_star_count = 40;
const $2b6e161c9edcf319$var$filter_list = [
    "hue-rotate(270deg) saturate(7)",
    "hue-rotate(90deg) saturate(4)",
    "hue-rotate(330deg) saturate(3)",
    "hue-rotate(155deg) saturate(13)",
    "hue-rotate(38deg) saturate(3)",
    "hue-rotate(158deg) saturate(19)"
];
for(let i = 0; i < $2b6e161c9edcf319$var$back_star_count; i++){
    const img = document.createElement('img');
    img.classList.add("back_star");
    img.src = (0, (/*@__PURE__*/$parcel$interopDefault($86db31fcb6027a0b$exports)));
    img.style.top = Math.max(2, Math.min(90, Math.random() ** 1.5 * 100)) + '%';
    img.style.left = Math.max(20, Math.min(80, Math.random() * 100)) + '%';
    img.style.transform = `translate(-50%, -50%) rotate(${Math.random() * 360}deg) scale(${0.8 + Math.random()})`;
    img.style.filter = $2b6e161c9edcf319$var$filter_list[Math.floor(Math.random() * $2b6e161c9edcf319$var$filter_list.length)];
    $2b6e161c9edcf319$var$observe_gauge_ele.appendChild(img);
}
const $2b6e161c9edcf319$var$back_telescope_button = document.getElementById("back_telescope");
for(let i = 0; i < 12; i++){
    const img = document.createElement('img');
    img.src = (0, (/*@__PURE__*/$parcel$interopDefault($86db31fcb6027a0b$exports)));
    img.style.top = Math.random() * 100 + '%';
    img.style.left = Math.random() * 100 + '%';
    img.style.transform = ` rotate(${Math.random() * 360}deg) scale(${0.8 + Math.random()})`;
    img.style.filter = $2b6e161c9edcf319$var$filter_list[Math.floor(Math.random() * $2b6e161c9edcf319$var$filter_list.length)];
    $2b6e161c9edcf319$var$back_telescope_button.appendChild(img);
}
const $2b6e161c9edcf319$var$backTanzakus = document.getElementsByClassName("back_tanzaku");
const $2b6e161c9edcf319$var$back_song_buttons = document.getElementsByClassName("back_song_button");
function $2b6e161c9edcf319$var$update_back_tanzaku() {
    Array.from($2b6e161c9edcf319$var$backTanzakus).forEach((backTanzaku)=>{
        //console.log(backTanzaku.parentElement.children[0]);
        const rect = backTanzaku.parentElement.children[0].getBoundingClientRect();
        backTanzaku.style.width = rect.width + "px";
        backTanzaku.style.height = rect.height + "px";
        backTanzaku.style.left = backTanzaku.parentElement.children[0].offsetLeft + "px";
        backTanzaku.style.top = backTanzaku.parentElement.children[0].offsetTop + "px";
    });
    Array.from($2b6e161c9edcf319$var$back_song_buttons).forEach((back_song_button)=>{
        const rect = back_song_button.parentElement.children[0].getBoundingClientRect();
        back_song_button.style.width = rect.width + "px";
        back_song_button.style.height = rect.height + "px";
        back_song_button.style.left = back_song_button.parentElement.children[0].offsetLeft + "px";
        back_song_button.style.top = back_song_button.parentElement.children[0].offsetTop + "px";
    });
}
let $2b6e161c9edcf319$var$button_back_imgs = [
    (0, (/*@__PURE__*/$parcel$interopDefault($8735bc822ebea544$exports))),
    (0, (/*@__PURE__*/$parcel$interopDefault($27b5311fe55a1682$exports))),
    (0, (/*@__PURE__*/$parcel$interopDefault($e0065fe43859ca3b$exports))),
    (0, (/*@__PURE__*/$parcel$interopDefault($5d0d813a9d90d076$exports))),
    (0, (/*@__PURE__*/$parcel$interopDefault($5310eb25ec68b2aa$exports))),
    (0, (/*@__PURE__*/$parcel$interopDefault($3b3f596d115e6335$exports)))
];
const $2b6e161c9edcf319$var$operate_buttons = document.getElementsByClassName("operate_button");
const $2b6e161c9edcf319$var$song_buttons = document.getElementsByClassName("song_button");
const $2b6e161c9edcf319$var$back_song_button = document.getElementsByClassName("back_song_button");
Array.from($2b6e161c9edcf319$var$operate_buttons).concat(Array.from($2b6e161c9edcf319$var$song_buttons), Array.from($2b6e161c9edcf319$var$backTanzakus), Array.from($2b6e161c9edcf319$var$back_song_button)).forEach((button)=>{
    for(let i = 0; i < 6; i++){
        const img = document.createElement('img');
        img.classList.add("back_star");
        img.src = $2b6e161c9edcf319$var$button_back_imgs[Math.floor(Math.random() * $2b6e161c9edcf319$var$button_back_imgs.length)];
        img.style.top = Math.max(2, Math.min(90, Math.random() * 100)) + '%';
        img.style.left = Math.max(20, Math.min(80, Math.random() * 100)) + '%';
        img.style.transform = `translate(-50%, -50%) rotate(${Math.random() * 360}deg) scale(${0.8 + Math.random()})`;
        img.style.filter = $2b6e161c9edcf319$var$filter_list[Math.floor(Math.random() * $2b6e161c9edcf319$var$filter_list.length)];
        button.appendChild(img);
    }
    const img = document.createElement('img');
    img.classList.add("back_milkyway");
    img.src = (0, (/*@__PURE__*/$parcel$interopDefault($f443bc2d37eda7c6$exports)));
    img.style.top = Math.max(40, Math.min(80, Math.random() * 100)) + '%';
    img.style.left = Math.max(20, Math.min(90, Math.random() * 100)) + '%';
    img.style.transform = `translate(-50%, -50%) scale(${1.5 + Math.random()})`;
    img.style.filter = $2b6e161c9edcf319$var$filter_list[Math.floor(Math.random() * $2b6e161c9edcf319$var$filter_list.length)];
    button.appendChild(img);
});
const $2b6e161c9edcf319$var$Composers = [
    "\u52A0\u8CC0(\u30CD\u30AE\u30B7\u30E3\u30EF\u30FCP)",
    "\u96E8\u826F Amala",
    "99piano",
    "\u3069\uFF5E\u3071\u307F\u3093",
    "\u304D\u3055\u3089",
    "\u6D77\u98A8\u592A\u967D"
];
/* Array.from(backTanzakus).forEach(button=>{
    for(let i=0;i<6;i++){
    const img = document.createElement('img');
    img.classList.add("back_star");
    img.src = button_back_imgs[Math.floor(Math.random()*button_back_imgs.length)];
    img.style.top = Math.max(2, Math.min(90,Math.random() * 100 ))+ '%';
    img.style.left = Math.max(20, Math.min(80,Math.random() * 100 )) + '%';
    img.style.transform = `translate(-50%, -50%) rotate(${Math.random() * 360}deg) scale(${0.8 + Math.random()})`;
    img.style.filter = filter_list[Math.floor(Math.random()*filter_list.length)];
    button.appendChild(img);
    }
}); */ const $2b6e161c9edcf319$var$player = new (0, $af62ec6a841e10b9$export$2616165974278734)({
    app: {
        token: "DfQ7Ozb9tNOqKrHJ"
    },
    valenceArousalEnabled: true,
    vocalAmplitudeEnabled: true
});
//let rylic_ele = document.getElementById("rylic");
const $2b6e161c9edcf319$var$galaxy_container_song_ele = document.getElementById("galaxy_container_song");
$2b6e161c9edcf319$var$galaxy_container_song_ele.addEventListener("click", (e)=>{
    for(let i = 0; i < 6; i++)if (e.target === $2b6e161c9edcf319$var$song_buttons[i]) $2b6e161c9edcf319$var$load_music(i);
});
let $2b6e161c9edcf319$var$touching_button = null;
$2b6e161c9edcf319$var$galaxy_container_song_ele.addEventListener("touchstart", (e)=>{
    for(let i = 0; i < 6; i++)if (e.target === $2b6e161c9edcf319$var$song_buttons[i]) $2b6e161c9edcf319$var$touching_button = i;
});
$2b6e161c9edcf319$var$galaxy_container_song_ele.addEventListener("touchend", (e)=>{
    for(let i = 0; i < 6; i++){
        if (e.target === $2b6e161c9edcf319$var$song_buttons[i]) {
            if (i == $2b6e161c9edcf319$var$touching_button) {
                $2b6e161c9edcf319$var$load_music(i);
                $2b6e161c9edcf319$var$touching_button = null;
            }
        }
    }
});
function $2b6e161c9edcf319$var$load_music(num) {
    $2b6e161c9edcf319$var$started_byUser = false;
    $2b6e161c9edcf319$var$hasEverPlayed = false;
    // ストリートライト / 加賀(ネギシャワーP)
    if (num == 0) $2b6e161c9edcf319$var$player.createFromSongUrl("https://piapro.jp/t/ULcJ/20250205120202", {
        video: {
            beatId: 4694275,
            chordId: 2830730,
            repetitiveSegmentId: 2946478,
            lyricId: 67810,
            lyricDiffId: 20654
        }
    });
    else if (num == 1) //アリフレーション / 雨良 Amala
    $2b6e161c9edcf319$var$player.createFromSongUrl("https://piapro.jp/t/SuQO/20250127235813", {
        video: {
            // 音楽地図訂正履歴
            beatId: 4694276,
            chordId: 2830731,
            repetitiveSegmentId: 2946479,
            // 歌詞URL: https://piapro.jp/t/GbYz
            // 歌詞タイミング訂正履歴: https://textalive.jp/lyrics/piapro.jp%2Ft%2FSuQO%2F20250127235813
            lyricId: 67811,
            lyricDiffId: 20655
        }
    });
    else if (num == 2) // インフォーマルダイブ / 99piano
    $2b6e161c9edcf319$var$player.createFromSongUrl("https://piapro.jp/t/Ppc9/20241224135843", {
        video: {
            // 音楽地図訂正履歴
            beatId: 4694277,
            chordId: 2830732,
            repetitiveSegmentId: 2946480,
            // 歌詞URL: https://piapro.jp/t/77V2
            // 歌詞タイミング訂正履歴: https://textalive.jp/lyrics/piapro.jp%2Ft%2FPpc9%2F20241224135843
            lyricId: 67812,
            lyricDiffId: 20656
        }
    });
    else if (num == 3) // ハロー、フェルミ。 / ど～ぱみん
    $2b6e161c9edcf319$var$player.createFromSongUrl("https://piapro.jp/t/oTaJ/20250204234235", {
        video: {
            // 音楽地図訂正履歴
            beatId: 4694278,
            chordId: 2830733,
            repetitiveSegmentId: 2946481,
            // 歌詞URL: https://piapro.jp/t/lbO1
            // 歌詞タイミング訂正履歴: https://textalive.jp/lyrics/piapro.jp%2Ft%2FoTaJ%2F20250204234235
            lyricId: 67813,
            lyricDiffId: 20657
        }
    });
    else if (num == 4) // パレードレコード / きさら
    $2b6e161c9edcf319$var$player.createFromSongUrl("https://piapro.jp/t/GCgy/20250202202635", {
        video: {
            // 音楽地図訂正履歴
            beatId: 4694279,
            chordId: 2830734,
            repetitiveSegmentId: 2946482,
            // 歌詞URL: https://piapro.jp/t/FJ5N
            // 歌詞タイミング訂正履歴: https://textalive.jp/lyrics/piapro.jp%2Ft%2FGCgy%2F20250202202635
            lyricId: 67814,
            lyricDiffId: 20658
        }
    });
    else if (num == 5) // ロンリーラン / 海風太陽
    $2b6e161c9edcf319$var$player.createFromSongUrl("https://piapro.jp/t/CyPO/20250128183915", {
        video: {
            // 音楽地図訂正履歴
            beatId: 4694280,
            chordId: 2830735,
            repetitiveSegmentId: 2946483,
            // 歌詞URL: https://piapro.jp/t/jn89
            // 歌詞タイミング訂正履歴: https://textalive.jp/lyrics/piapro.jp%2Ft%2FCyPO%2F20250128183915
            lyricId: 67815,
            lyricDiffId: 20659
        }
    });
    $2b6e161c9edcf319$var$music_num = num;
    $2b6e161c9edcf319$var$InPreparationSong = true;
    $2b6e161c9edcf319$var$GalaxyRotateStart_time = undefined;
    $2b6e161c9edcf319$var$current_galaxy_rotate = $2b6e161c9edcf319$var$addition_angle;
    $2b6e161c9edcf319$var$select_galaxy_ele.style.display = "none";
    $2b6e161c9edcf319$var$loading.style.display = "block";
    $2b6e161c9edcf319$var$loading.style.transform = "translateX(-50%) scale(0.2)";
    $2b6e161c9edcf319$var$loading.style.top = "60%";
    $2b6e161c9edcf319$var$loading.style.left = "90%";
    $2b6e161c9edcf319$var$loading_txt.innerText = "\u79FB\u52D5\u4E2D...";
    $2b6e161c9edcf319$var$player.timer.seek(0);
    $2b6e161c9edcf319$var$fit_loading_parent();
}
function $2b6e161c9edcf319$var$fit_loading_parent() {
    const parent = document.getElementById("loading");
    const childs = Array.from(parent.children);
    let minX = Infinity, minY = Infinity, maxX = -Infinity, maxY = -Infinity;
    childs.forEach((child)=>{
        const rect = child.getBoundingClientRect();
        const parentRect = parent.getBoundingClientRect();
        const left = rect.left - parentRect.left;
        const top = rect.top - parentRect.top;
        const right = left + rect.width;
        const bottom = top + rect.height;
        minX = Math.min(minX, left);
        minY = Math.min(minY, top);
        maxX = Math.max(maxX, right);
        maxY = Math.max(maxY, bottom);
    });
    parent.style.width = maxX - minX + 'px';
    parent.style.height = maxY - minY + 'px';
}
$2b6e161c9edcf319$var$fit_loading_parent();
let $2b6e161c9edcf319$var$changed_rotate_mode = false;
let $2b6e161c9edcf319$var$music_num;
let $2b6e161c9edcf319$var$InPreparationSong;
let $2b6e161c9edcf319$var$galaxy_img_scale = 1;
let $2b6e161c9edcf319$var$last_pos = 0;
let $2b6e161c9edcf319$var$last_nomal_pos = 0;
let $2b6e161c9edcf319$var$updateCount = 0;
let $2b6e161c9edcf319$var$finished_loop = false;
let $2b6e161c9edcf319$var$medianVA;
let $2b6e161c9edcf319$var$max_A = -Infinity;
let $2b6e161c9edcf319$var$max_V = -Infinity;
let $2b6e161c9edcf319$var$min_A = Infinity;
let $2b6e161c9edcf319$var$min_V = Infinity;
//let rylic;
let $2b6e161c9edcf319$var$current;
let $2b6e161c9edcf319$var$prev;
let $2b6e161c9edcf319$var$last_beat;
let $2b6e161c9edcf319$var$change_duration_ms = 100;
let $2b6e161c9edcf319$var$change_from;
let $2b6e161c9edcf319$var$ignor_count;
let $2b6e161c9edcf319$var$appear_last_word = false;
let $2b6e161c9edcf319$var$beat_index = 0;
let $2b6e161c9edcf319$var$isStopped = true;
let $2b6e161c9edcf319$var$hasEverPlayed = false;
const $2b6e161c9edcf319$var$except_pos = [
    "P",
    "M"
];
const $2b6e161c9edcf319$var$back_list = [
    "!",
    "\uFF01",
    "?",
    "\uFF1F",
    ")",
    "\uFF09",
    "\u300D",
    "'",
    "\u3001",
    ","
];
const $2b6e161c9edcf319$var$front_list = [
    "(",
    "\uFF08",
    "\u300C"
];
const $2b6e161c9edcf319$var$middle_list = [
    "\u2019",
    "'"
];
const $2b6e161c9edcf319$var$S_except = [
    "\u201C",
    '"',
    "\u201D"
];
let $2b6e161c9edcf319$var$Max_Vo_A = -Infinity;
let $2b6e161c9edcf319$var$min_VO_A = Infinity;
const $2b6e161c9edcf319$var$loading_gray = document.getElementById("loading_gray");
const $2b6e161c9edcf319$var$loading = document.getElementById("loading");
const $2b6e161c9edcf319$var$loading_txt = document.getElementById("loading_txt");
let $2b6e161c9edcf319$var$current_wishList;
let $2b6e161c9edcf319$var$num_found_tanzaku;
const $2b6e161c9edcf319$var$name_galaxy = document.getElementById("name_galaxy");
const $2b6e161c9edcf319$var$finaly_tanzaku_num = document.getElementById("finaly_tanzaku_num");
$2b6e161c9edcf319$var$player.addListener({
    onAppReady: (app)=>{
        if (!app.managed) {
            //console.log("準備完了");
            //load_music(5);//デバッグ用
            $2b6e161c9edcf319$var$loading_gray.style.display = "none";
            $2b6e161c9edcf319$var$loading.style.display = "none";
            $2b6e161c9edcf319$var$first_explanation_ele.style.display = "block";
        }
    },
    onVideoReady: (video)=>{
        //console.log("動画情報:", video);
        $2b6e161c9edcf319$var$current = null;
        $2b6e161c9edcf319$var$prev = null;
        $2b6e161c9edcf319$var$last_beat = null;
        let temporary = $2b6e161c9edcf319$var$wishList.concat();
        $2b6e161c9edcf319$var$current_wishList = [];
        for(let i = 0; i < 30; i++){
            let rand_idx = Math.floor(Math.random() * temporary.length);
            $2b6e161c9edcf319$var$current_wishList.push(temporary[rand_idx]);
            //console.log(temporary[rand_idx]);
            temporary.splice(rand_idx, 1);
        //console.log(temporary.length);
        //console.log(temporary[rand_idx] in temporary);
        }
        $2b6e161c9edcf319$var$max_tanzaku_ele.innerText = "30";
        $2b6e161c9edcf319$var$InPreparationSong = false;
        $2b6e161c9edcf319$var$num_found_tanzaku = 0;
        $2b6e161c9edcf319$var$found_tanzaku.innerText = $2b6e161c9edcf319$var$num_found_tanzaku;
        $2b6e161c9edcf319$var$found_tanzaku.style.color = "white";
        $2b6e161c9edcf319$var$appear_last_word = false;
        $2b6e161c9edcf319$var$updateCount = 0;
    },
    onPlay: ()=>{
        //console.log("play");
        $2b6e161c9edcf319$var$isStopped = false;
        if ($2b6e161c9edcf319$var$hasEverPlayed) {
            $2b6e161c9edcf319$var$play_button.src = (0, (/*@__PURE__*/$parcel$interopDefault($bf7b41788c03325e$exports)));
            start_dbserve_child.innerText = "\u89B3\u6E2C\u3092\u4E2D\u65AD\u3059\u308B";
        }
    },
    onPause: ()=>{
        console.log("pause");
        const isEnd = $2b6e161c9edcf319$var$player.timer.position >= $2b6e161c9edcf319$var$player.video.duration - 100;
        if (!isEnd) {
            $2b6e161c9edcf319$var$play_button.src = (0, (/*@__PURE__*/$parcel$interopDefault($42c76402dafc120d$exports)));
            start_dbserve_child.innerText = "\u89B3\u6E2C\u3092\u518D\u958B\u3059\u308B";
        } else {
            start_dbserve_child.innerText = "\u89B3\u6E2C\u5B8C\u4E86\uFF01\uFF01\uFF01";
            $2b6e161c9edcf319$var$start_observe_button.style.pointerEvents = "none";
            $2b6e161c9edcf319$var$start_observe_button.style.opacity = 0.5;
            $2b6e161c9edcf319$var$finaly_tanzaku_num.innerText = $2b6e161c9edcf319$var$num_found_tanzaku;
            $2b6e161c9edcf319$var$back_telescope.style.display = "block";
            $2b6e161c9edcf319$var$all_wrapper.style.display = "block";
            $2b6e161c9edcf319$var$update_back_tanzaku();
            $2b6e161c9edcf319$var$player.timer.seek(0);
        }
        if (!$2b6e161c9edcf319$var$hasEverPlayed) {
            start_dbserve_child.innerText = "\u89B3\u6E2C\u3092\u958B\u59CB\u3059\u308B";
            $2b6e161c9edcf319$var$player.timer.seek(0);
        }
    },
    onStop: ()=>{
        //console.log("stop");
        $2b6e161c9edcf319$var$isStopped = true;
        //hasEverPlayed = false;
        $2b6e161c9edcf319$var$play_button.src = (0, (/*@__PURE__*/$parcel$interopDefault($42c76402dafc120d$exports)));
        start_dbserve_child.innerText = "\u89B3\u6E2C\u3092\u958B\u59CB\u3059\u308B";
    },
    onTimerReady: ()=>{
        //console.log("楽曲準備完了");
        //console.log(player);
        //console.log(player.data.song);
        $2b6e161c9edcf319$var$isStopped = true;
        $2b6e161c9edcf319$var$hasEverPlayed = false;
        $2b6e161c9edcf319$var$play_button.src = (0, (/*@__PURE__*/$parcel$interopDefault($42c76402dafc120d$exports)));
        start_dbserve_child.innerText = "\u89B3\u6E2C\u3092\u958B\u59CB\u3059\u308B";
        $2b6e161c9edcf319$var$player.timer.seek(0);
        $2b6e161c9edcf319$var$player.requestPause();
        $2b6e161c9edcf319$var$ignor_count = 0;
        let rylic = $2b6e161c9edcf319$var$player.video.firstWord;
        while(rylic){
            let v = $2b6e161c9edcf319$var$player.getValenceArousal(rylic.startTime).v;
            let a = $2b6e161c9edcf319$var$player.getValenceArousal(rylic.startTime).a;
            $2b6e161c9edcf319$var$max_A = Math.max($2b6e161c9edcf319$var$max_A, a);
            $2b6e161c9edcf319$var$min_A = Math.min($2b6e161c9edcf319$var$min_A, a);
            $2b6e161c9edcf319$var$max_V = Math.max($2b6e161c9edcf319$var$max_V, v);
            $2b6e161c9edcf319$var$min_V = Math.min($2b6e161c9edcf319$var$min_V, v);
            $2b6e161c9edcf319$var$min_VO_A = Math.min($2b6e161c9edcf319$var$min_VO_A, $2b6e161c9edcf319$var$player.getVocalAmplitude(rylic.startTime));
            $2b6e161c9edcf319$var$Max_Vo_A = Math.max($2b6e161c9edcf319$var$Max_Vo_A, $2b6e161c9edcf319$var$player.getVocalAmplitude(rylic.startTime));
            rylic = rylic.next;
        }
        //console.log(max_A,min_A,max_V,min_V);
        $2b6e161c9edcf319$var$finished_loop = true;
        //player.timer.seek(180000);
        $2b6e161c9edcf319$var$medianVA = $2b6e161c9edcf319$var$player.getMedianValenceArousal();
        console.log($2b6e161c9edcf319$var$Max_Vo_A, $2b6e161c9edcf319$var$min_VO_A);
        $2b6e161c9edcf319$var$player.timer.seek(0);
    },
    onTimeUpdate: (pos)=>{
        //found_tanzaku.innerText = pos;//デバッグ
        //console.log(pos);
        if ($2b6e161c9edcf319$var$started_byUser) {
            let bv;
            $2b6e161c9edcf319$var$updateCount++;
            //console.log("再生位置のアップデート:", pos, "ミリ秒");
            const duration = $2b6e161c9edcf319$var$player.video.duration;
            //console.log(pos);
            if (!(pos > 500 && $2b6e161c9edcf319$var$last_pos < 1000 && $2b6e161c9edcf319$var$updateCount <= 7)) {
                $2b6e161c9edcf319$var$update_gauge(pos / duration * 100);
                $2b6e161c9edcf319$var$last_pos = pos;
            }
            //console.log(currentChar)
            const beat = $2b6e161c9edcf319$var$player.findBeat(pos + 50);
            if (beat != $2b6e161c9edcf319$var$last_beat && $2b6e161c9edcf319$var$updateCount > 7) {
                //console.log(filter_list[beat_index%6]);
                //console.log(beat_index);
                $2b6e161c9edcf319$var$gauge_star.style.filter = $2b6e161c9edcf319$var$filter_list[$2b6e161c9edcf319$var$beat_index % 6];
                $2b6e161c9edcf319$var$change_from = performance.now();
                $2b6e161c9edcf319$var$beat_index++;
            }
            if ($2b6e161c9edcf319$var$change_from !== undefined && performance.now() - $2b6e161c9edcf319$var$change_from >= $2b6e161c9edcf319$var$change_duration_ms) {
                $2b6e161c9edcf319$var$change_from = undefined;
                $2b6e161c9edcf319$var$gauge_star.style.filter = "";
            }
            $2b6e161c9edcf319$var$last_beat = beat;
            //console.log(beat);
            if (!$2b6e161c9edcf319$var$appear_last_word) $2b6e161c9edcf319$var$current = $2b6e161c9edcf319$var$current || $2b6e161c9edcf319$var$player.video.firstWord //player.video.findWord(pos+100);
            ;
            //console.log("upDate_time");
            // current が前回の歌詞と異なる場合に処理を行う
            //console.log(current.startTime);
            //console.log("loop");
            //console.log(loop_count);
            // 新しい文字が発声されようとしている
            //console.log(current.text);
            //console.log(current.startTime);
            //console.log(finished_loop);
            /* if(!finished_loop){
            ignor_count = 0;
        }    */ while($2b6e161c9edcf319$var$current && $2b6e161c9edcf319$var$current.startTime < pos + 100 && $2b6e161c9edcf319$var$updateCount > 7){
                if (!$2b6e161c9edcf319$var$appear_last_word && $2b6e161c9edcf319$var$prev !== $2b6e161c9edcf319$var$current) {
                    if ($2b6e161c9edcf319$var$current == $2b6e161c9edcf319$var$player.video.lastWord) $2b6e161c9edcf319$var$appear_last_word = true;
                    if ($2b6e161c9edcf319$var$current && $2b6e161c9edcf319$var$current.text) {
                        const va = $2b6e161c9edcf319$var$player.getValenceArousal($2b6e161c9edcf319$var$current.startTime);
                        const v = va.v //Math.max(0,Math.min(1,va.v*1.2));
                        ;
                        const a = va.a //Math.max(0,Math.min(1,va.a*1.2));
                        ;
                        const normalizedA = (a - $2b6e161c9edcf319$var$min_A) / ($2b6e161c9edcf319$var$max_A - $2b6e161c9edcf319$var$min_A);
                        const normalizedV = (v - $2b6e161c9edcf319$var$min_V) / ($2b6e161c9edcf319$var$max_V - $2b6e161c9edcf319$var$min_V);
                        const VO_A = $2b6e161c9edcf319$var$player.getVocalAmplitude($2b6e161c9edcf319$var$current.startTime);
                        const normalized_VO_A = (VO_A - $2b6e161c9edcf319$var$min_VO_A) / ($2b6e161c9edcf319$var$Max_Vo_A - $2b6e161c9edcf319$var$min_V);
                        //console.log(normalizedV);
                        /* const v1 = (v + 1) / 2;
                    const a1 = (a + 1) / 2; */ const minBV = -0.4;
                        const maxBV = 2.0;
                        //const mixed = -centeredV + centeredA;
                        bv = minBV + (1 - normalizedA) * (maxBV - minBV) + 0.2;
                        const minbright = 0.5;
                        const maxbright = 2;
                        const bright = minbright + normalizedV * (maxbright - minbright);
                        const min_size = 0.7;
                        const max_siza = 1.4;
                        const size = min_size + normalized_VO_A * (max_siza - min_size);
                        //console.log(size);
                        //bv = minBV + (maxBV - minBV) * -1*centeredA;
                        //console.log(bv);
                        ///console.log(player.getVocalAmplitude(current.startTime));
                        $2b6e161c9edcf319$var$finished_loop = false;
                        //console.log(current);
                        //console.log(beat);
                        //console.log("チェック用");
                        let text = "";
                        if ($2b6e161c9edcf319$var$ignor_count > 0) {
                            //console.log("ignor", ignor_count, "現在のスキップ対象:", current.text);
                            $2b6e161c9edcf319$var$ignor_count--;
                            if ($2b6e161c9edcf319$var$current.next !== null) //console.log("next is existing");
                            {
                                if ($2b6e161c9edcf319$var$current.next.pos == "S" && $2b6e161c9edcf319$var$front_list.some((front)=>$2b6e161c9edcf319$var$current.next.text.includes(front))) //console.log("front_S");
                                $2b6e161c9edcf319$var$ignor_count += 1;
                            }
                        } else {
                            //console.log("not ignor");
                            if ($2b6e161c9edcf319$var$current.next !== null) //console.log("next is existing");
                            {
                                if ($2b6e161c9edcf319$var$current.next.pos == "S" && $2b6e161c9edcf319$var$front_list.some((front)=>$2b6e161c9edcf319$var$current.next.text.includes(front))) //console.log("front_S");
                                $2b6e161c9edcf319$var$ignor_count = 1;
                            }
                            if ($2b6e161c9edcf319$var$current?.next) {
                                //console.log("exists next");
                                if ($2b6e161c9edcf319$var$current?.next.pos == "S") {
                                    if ($2b6e161c9edcf319$var$current?.next.parent === $2b6e161c9edcf319$var$current.parent && !$2b6e161c9edcf319$var$front_list.some((front)=>$2b6e161c9edcf319$var$current?.next.text.includes(front))) {
                                        //console.log("現在の歌詞:",current.previous.text + current.text);
                                        if ($2b6e161c9edcf319$var$middle_list.some((middle)=>$2b6e161c9edcf319$var$current?.next.text.includes(middle))) {
                                            $2b6e161c9edcf319$var$ignor_count = 2;
                                            text = $2b6e161c9edcf319$var$current.text + $2b6e161c9edcf319$var$current?.next.text + $2b6e161c9edcf319$var$current?.next?.next.text;
                                        //console.log("middle_S2");
                                        } else {
                                            $2b6e161c9edcf319$var$ignor_count = 1;
                                            text = $2b6e161c9edcf319$var$current.text + $2b6e161c9edcf319$var$current?.next.text;
                                        //console.log("not_middle");
                                        }
                                    }
                                }
                                if ($2b6e161c9edcf319$var$current.next.pos == "N") {
                                    //console.log("NNNN");
                                    if ($2b6e161c9edcf319$var$middle_list.some((middle)=>$2b6e161c9edcf319$var$current.next.text.includes(middle))) {
                                        $2b6e161c9edcf319$var$ignor_count = 2;
                                        //console.log("middle_S1");
                                        text = $2b6e161c9edcf319$var$current.text + $2b6e161c9edcf319$var$current?.next.text + $2b6e161c9edcf319$var$current?.next?.next.text;
                                    }
                                    if ($2b6e161c9edcf319$var$current.pos == "N" && $2b6e161c9edcf319$var$current.parent == $2b6e161c9edcf319$var$current?.next.parent && $2b6e161c9edcf319$var$current.language == $2b6e161c9edcf319$var$current?.next.language) {
                                        //console.log("NN");
                                        const first_beat = $2b6e161c9edcf319$var$player.findBeat($2b6e161c9edcf319$var$current.startTime);
                                        const first_beat_idx = first_beat.index;
                                        let next_beat_idx = $2b6e161c9edcf319$var$player.findBeat($2b6e161c9edcf319$var$current.next.startTime).index;
                                        let next = $2b6e161c9edcf319$var$current.next.next;
                                        if (next_beat_idx - first_beat_idx <= first_beat.length) {
                                            if ($2b6e161c9edcf319$var$current.language == "en") text = $2b6e161c9edcf319$var$current.text + " " + $2b6e161c9edcf319$var$current.next.text;
                                            else text = $2b6e161c9edcf319$var$current.text + $2b6e161c9edcf319$var$current?.next.text;
                                            $2b6e161c9edcf319$var$ignor_count = 1;
                                            let next2 = next;
                                            while((next2.pos == "S" && $2b6e161c9edcf319$var$back_list.some((back)=>next2.text.includes(back)) || $2b6e161c9edcf319$var$except_pos.includes(next2.pos)) && next2.pos !== "N"){
                                                //console.log("next2");
                                                console.log(next2);
                                                if ($2b6e161c9edcf319$var$except_pos.includes(next2.pos)) {
                                                    next_beat_idx = $2b6e161c9edcf319$var$player.findBeat(next.startTime).index;
                                                    if (next_beat_idx - first_beat_idx <= first_beat.length - 1) {
                                                        text += next2.text;
                                                        $2b6e161c9edcf319$var$ignor_count += 1;
                                                        next2 = next2.next;
                                                    } else break;
                                                } else {
                                                    text += next2.text;
                                                    next2 = next2.next;
                                                    $2b6e161c9edcf319$var$ignor_count += 1;
                                                }
                                            //console.log("NNNS");
                                            }
                                        } else text = $2b6e161c9edcf319$var$current.text;
                                        while(next.pos == "N" && $2b6e161c9edcf319$var$current.parent == next.parent && $2b6e161c9edcf319$var$current.language == next.language){
                                            next_beat_idx = $2b6e161c9edcf319$var$player.findBeat(next.startTime).index;
                                            if (next_beat_idx - first_beat_idx <= Math.floor(first_beat.length / 2)) {
                                                if ($2b6e161c9edcf319$var$current.language == "en") text += " " + next.text;
                                                else text += next.text;
                                                $2b6e161c9edcf319$var$ignor_count += 1;
                                                next = next?.next;
                                                let next2 = next;
                                                while((next2.pos == "S" && $2b6e161c9edcf319$var$back_list.some((back)=>next2.text.includes(back)) || $2b6e161c9edcf319$var$except_pos.includes(next2.pos)) && next2.pos !== "N"){
                                                    //console.log("next2");
                                                    console.log(next2);
                                                    if ($2b6e161c9edcf319$var$except_pos.includes(next2.pos)) {
                                                        next_beat_idx = $2b6e161c9edcf319$var$player.findBeat(next.startTime).index;
                                                        if (next_beat_idx - first_beat_idx <= Math.floor(first_beat.length / 2)) {
                                                            text += next2.text;
                                                            $2b6e161c9edcf319$var$ignor_count += 1;
                                                            next2 = next2.next;
                                                        } else break;
                                                    } else {
                                                        text += next2.text;
                                                        next2 = next2.next;
                                                        $2b6e161c9edcf319$var$ignor_count += 1;
                                                    }
                                                //console.log("NNNS");
                                                }
                                                if (next2 !== next) break;
                                            } else break;
                                        //console.log("NNN");
                                        }
                                    }
                                }
                                if ($2b6e161c9edcf319$var$current.pos == "F" || $2b6e161c9edcf319$var$current.pos == "R" && $2b6e161c9edcf319$var$current.language == "ja") {
                                    const first_beat = $2b6e161c9edcf319$var$player.findBeat($2b6e161c9edcf319$var$current.startTime);
                                    const first_beat_idx = first_beat.index;
                                    const next_beat_index = $2b6e161c9edcf319$var$player.findBeat($2b6e161c9edcf319$var$current.next.startTime).index;
                                    if (next_beat_index - first_beat_idx < Math.floor(first_beat.length / 2)) {
                                        text = $2b6e161c9edcf319$var$current.text + $2b6e161c9edcf319$var$current.next.text;
                                        let next = $2b6e161c9edcf319$var$current.next;
                                        $2b6e161c9edcf319$var$ignor_count = 1;
                                        if (next.next !== null && next !== null) while(($2b6e161c9edcf319$var$except_pos.includes(next.next.pos) || next.next.pos == "S" && $2b6e161c9edcf319$var$back_list.some((back)=>next.text.includes(back))) && next.parent == next.next.parent){
                                            text += next.next.text;
                                            next = next.next;
                                            $2b6e161c9edcf319$var$ignor_count += 1;
                                            if (next.next !== null) break;
                                        }
                                    }
                                }
                            }
                            if ($2b6e161c9edcf319$var$current.previous) {
                                if ($2b6e161c9edcf319$var$current.previous.pos == "S") {
                                    if ($2b6e161c9edcf319$var$current.previous.parent === $2b6e161c9edcf319$var$current.parent && $2b6e161c9edcf319$var$front_list.some((front)=>$2b6e161c9edcf319$var$current.previous.text.includes(front))) {
                                        //console.log("現在の歌詞:", current.text + current.previous.text);
                                        if (text == "") text = $2b6e161c9edcf319$var$current.previous.text + $2b6e161c9edcf319$var$current.text;
                                        else text = $2b6e161c9edcf319$var$current.previous.text + text;
                                    }
                                }
                            }
                            if ($2b6e161c9edcf319$var$S_except.some((except)=>$2b6e161c9edcf319$var$current.text.includes(except))) //console.log("exception");
                            {
                                if ($2b6e161c9edcf319$var$current?.next) {
                                    let next = $2b6e161c9edcf319$var$current?.next;
                                    let exceptcount = 0;
                                    let tentative_text = "";
                                    while(next.parent === $2b6e161c9edcf319$var$current.parent && !$2b6e161c9edcf319$var$S_except.some((except)=>next.text.includes(except))){
                                        //console.log("ネクスト：",next.text);
                                        exceptcount += 1;
                                        tentative_text += next.text;
                                        next = next?.next;
                                        if (next == null) break;
                                    }
                                    if ($2b6e161c9edcf319$var$S_except.some((except)=>next.text.includes(except))) {
                                        $2b6e161c9edcf319$var$ignor_count = exceptcount + 1;
                                        //console.log("double");
                                        text = $2b6e161c9edcf319$var$current.text + tentative_text + next.text;
                                    }
                                }
                            }
                            if ($2b6e161c9edcf319$var$except_pos.includes($2b6e161c9edcf319$var$current.next.pos) && $2b6e161c9edcf319$var$current.next) //console.log("現在の歌詞:", current.text + current?.next.text);
                            {
                                if (text == "") {
                                    text = $2b6e161c9edcf319$var$current.text + $2b6e161c9edcf319$var$current?.next.text;
                                    let next = $2b6e161c9edcf319$var$current?.next;
                                    $2b6e161c9edcf319$var$ignor_count += 1;
                                    if (next !== null && next.next !== null) {
                                        if (next.next.pos == "S" && $2b6e161c9edcf319$var$back_list.some((back)=>next?.next.text.includes(back))) {
                                            text += next?.next.text;
                                            $2b6e161c9edcf319$var$ignor_count += 1;
                                        //console.log("exception S");
                                        }
                                        while($2b6e161c9edcf319$var$except_pos.includes(next.next.pos)){
                                            text += next.next.text;
                                            next = next.next;
                                            $2b6e161c9edcf319$var$ignor_count += 1;
                                            if (next.next.pos == "S" && $2b6e161c9edcf319$var$back_list.some((back)=>next.next.text.includes(back))) {
                                                text += next.next.text;
                                                $2b6e161c9edcf319$var$ignor_count += 1;
                                                break;
                                            }
                                        }
                                    }
                                }
                            } else if (!$2b6e161c9edcf319$var$except_pos.includes($2b6e161c9edcf319$var$current.next.pos) && $2b6e161c9edcf319$var$current) //if(!(except_pos.includes(current.pos)) && (current.pos !== "S")){
                            //console.log("現在の歌詞:", current.text);
                            {
                                if (text == "") //console.log("nomal");
                                text = $2b6e161c9edcf319$var$current.text;
                            }
                        }
                        $2b6e161c9edcf319$var$finished_loop = true;
                        //console.log("next ignor",ignor_count);
                        //console.log("本来の歌詞:",current.text);
                        //console.log("現在の歌詞:",text);
                        //rylic_ele.innerText += current.text;  // 現在の歌詞を即座に表示
                        if (text !== "") $2b6e161c9edcf319$var$placeTextSprite(text, bv, bright, size * 3 / 2);
                    //scene.add(text_obj);
                    //const dir = new THREE.Vector3();
                    //camera.getWorldDirection(dir);
                    //dir.multiplyScalar(40);
                    //const pos = get_lookat_pos();
                    //text_obj.position.copy(pos);
                    //placeTextSprite(current.text);
                    }
                }
                $2b6e161c9edcf319$var$prev = $2b6e161c9edcf319$var$current;
                $2b6e161c9edcf319$var$current = $2b6e161c9edcf319$var$current.next;
            /* if(current.next){
            //console.log("existe next");
            prev = current;
            current = current?.next;
        }else{
            console.log("not existe next");
            current = undefined;
            prev = current;
        }
    } */ }
        }
    }
});
function $2b6e161c9edcf319$var$createTextSprite(text, RGB, bright, size) {
    const canvas = document.createElement('canvas');
    const ctx = canvas.getContext('2d', {
        alpha: true
    });
    // Canvas サイズ
    canvas.width = 512 * text.length;
    canvas.height = 512;
    // 背景は透明
    ctx.clearRect(0, 0, canvas.width, canvas.height);
    //console.log(RGB);
    ctx.fillStyle = `rgb(${RGB.r * 255},${RGB.g * 255},${RGB.b * 255})`;
    // スタイル設定
    ctx.font = '512px nikokaku';
    //ctx.fillStyle = 'white';
    ctx.textAlign = 'center';
    ctx.textBaseline = 'middle';
    // テキスト描画
    ctx.fillText(text, canvas.width / 2, canvas.height / 2);
    // Canvas からテクスチャを作成
    const texture = new $dyjou.CanvasTexture(canvas);
    const material = new $dyjou.SpriteMaterial({
        map: texture,
        transparent: true,
        opacity: 0,
        alphaTest: 0.1
    });
    const sprite = new $dyjou.Sprite(material);
    // スケール調整（大きさ）
    sprite.scale.set(size * text.length * 0.01, size * 0.01, 1); // 横:縦の比率をCanvasと合わせると綺麗
    return {
        sprite: sprite,
        radius: text.length * size,
        texture: texture,
        material: material
    };
}
function $2b6e161c9edcf319$var$get_lookat_pos(dis = 40) {
    const dir = new $dyjou.Vector3();
    $2b6e161c9edcf319$var$camera.getWorldDirection(dir);
    dir.multiplyScalar(dis);
    const pos = $2b6e161c9edcf319$var$camera.position.clone().add(dir);
    return pos;
}
function $2b6e161c9edcf319$var$sphericalToCartesian(radius, latitude, longitude) {
    // 緯度(latitude)・経度(longitude) はラジアンで
    const x = radius * Math.cos(latitude) * Math.cos(longitude);
    const y = radius * Math.sin(latitude);
    const z = radius * Math.cos(latitude) * Math.sin(longitude);
    return new $dyjou.Vector3(x, y, z);
}
const $2b6e161c9edcf319$var$line_colors = [
    0x1df8de,
    0xd74443,
    0x70aeff,
    0xe0e34c,
    0xf89d1d,
    0xeccbdc
];
let $2b6e161c9edcf319$var$existingSprites = [];
let $2b6e161c9edcf319$var$starlines = [];
function $2b6e161c9edcf319$var$placeTextSprite(text, bv, bright, size) {
    //console.log(bv);
    const color_rgb = $2b6e161c9edcf319$var$bvToRgb(bv);
    const color = new $dyjou.Color();
    color.setRGB(color_rgb[0], color_rgb[1], color_rgb[2]);
    const { sprite: sprite, radius: radius, texture: texture, material: material } = $2b6e161c9edcf319$var$createTextSprite(text, color, bright, size);
    let basePos = $2b6e161c9edcf319$var$get_lookat_pos(40);
    const dir = new $dyjou.Vector3(0, 0, -1);
    dir.applyQuaternion($2b6e161c9edcf319$var$camera.quaternion);
    dir.normalize();
    const baseLat = Math.asin(dir.y) / Math.PI * 180;
    const baseLng = Math.atan2(dir.z, dir.x) / Math.PI * 180;
    let placed = false;
    let final_lat;
    let final_lng;
    let corrected_pos;
    //corrected_pos = basePos;
    for(let i = 0; i < 100; i++){
        let safe = true;
        const angle = Math.random() * 2 * Math.PI;
        const r = 0.12 * i * size;
        const latOffset = Math.sin(angle) * r;
        const lngOffset = Math.cos(angle) * r;
        //const latOffset = Math.sign((Math.random()) - 0.5) * 0.06*i; // 調整可
        //const lngOffset = Math.sign((Math.random()) - 0.5) * 0.06*i;
        const lat = (baseLat + latOffset) * Math.PI / 180;
        const lng = (baseLng + lngOffset) * Math.PI / 180;
        final_lat = lat;
        final_lng = lng;
        corrected_pos = $2b6e161c9edcf319$var$sphericalToCartesian(40, lat, lng);
        //corrected_pos = basePos.clone().add(offset);
        for (let other of $2b6e161c9edcf319$var$existingSprites){
            const minDist = radius + other.radius;
            //console.log(minDist);
            //console.log(corrected_pos.distanceTo(other.sprite.position));
            if (corrected_pos.distanceTo(other.sprite.position) < minDist / 3) {
                console.log("\u8FD1\u3059\u304E");
                safe = false;
                break;
            }
        }
        if (safe) {
            sprite.position.copy(corrected_pos);
            $2b6e161c9edcf319$var$existingSprites.push({
                sprite: sprite,
                radius: radius,
                texture: texture,
                material: material
            });
            $2b6e161c9edcf319$var$scene.add(sprite);
            placed = true;
            break;
        }
    }
    if (!placed) {
        final_lat = baseLat;
        final_lng = baseLng;
        sprite.position.copy(basePos);
        $2b6e161c9edcf319$var$existingSprites.push({
            sprite: sprite,
            radius: radius,
            texture: texture,
            material: material
        });
        $2b6e161c9edcf319$var$scene.add(sprite);
    //console.log("failed");
    }
    let tl = (0, $357b3f2d5f2ec9d5$export$99ee26438460406a).timeline();
    sprite.material.rotation = 0;
    tl.to(sprite.material, {
        rotation: Math.PI * 2,
        duration: 0.2
    }, 0);
    tl.to(sprite.scale, {
        x: size * text.length,
        y: size,
        duration: 0.2,
        ease: "power3.inOut"
    }, 0);
    tl.to(sprite.material, {
        opacity: bright,
        duration: 1
    }, 0);
    //短冊が近くにあったら処理
    const pos = sprite.position;
    $2b6e161c9edcf319$var$triggerExplosion(pos, final_lat, final_lng);
    $2b6e161c9edcf319$var$tanzaku_list.forEach((tanzaku)=>{
        const dis = pos.distanceTo(tanzaku.mesh.position);
        //console.log(dis);
        if (radius / 3 * 2 >= dis) //scene.remove(tanzaku);
        {
            if (!tanzaku.isAnimating) {
                $2b6e161c9edcf319$var$num_found_tanzaku++;
                if ($2b6e161c9edcf319$var$num_found_tanzaku >= 27) $2b6e161c9edcf319$var$found_tanzaku.style.color = "red";
                $2b6e161c9edcf319$var$get_tanzaku_animation(tanzaku.mesh, tanzaku.imgURL, tanzaku.users);
                tanzaku.isAnimating = true;
            }
        }
    });
    //ここで線を描画
    const len = $2b6e161c9edcf319$var$existingSprites.length;
    if (len >= 2) {
        let linePositions = [];
        const pos1 = $2b6e161c9edcf319$var$existingSprites[len - 2].sprite.position;
        const pos2 = $2b6e161c9edcf319$var$existingSprites[len - 1].sprite.position;
        //console.log(pos1);
        //console.log(pos2);
        linePositions.push(pos1.x, pos1.y, pos1.z, pos2.x, pos2.y, pos2.z);
        const lineGeometry = new $dyjou.BufferGeometry();
        lineGeometry.setAttribute('position', new $dyjou.Float32BufferAttribute(linePositions, 3));
        let line_color;
        //console.log(current_line_color_mode);
        if ($2b6e161c9edcf319$var$current_line_color_mode == 1) line_color = $2b6e161c9edcf319$var$line_colors[0];
        else if ($2b6e161c9edcf319$var$current_line_color_mode == 2) line_color = $2b6e161c9edcf319$var$line_colors[4];
        else if ($2b6e161c9edcf319$var$current_line_color_mode == 3) line_color = $2b6e161c9edcf319$var$line_colors[3];
        else if ($2b6e161c9edcf319$var$current_line_color_mode == 4) line_color = $2b6e161c9edcf319$var$line_colors[5];
        else if ($2b6e161c9edcf319$var$current_line_color_mode == 5) line_color = $2b6e161c9edcf319$var$line_colors[1];
        else if ($2b6e161c9edcf319$var$current_line_color_mode == 6) line_color = $2b6e161c9edcf319$var$line_colors[2];
        else line_color = $2b6e161c9edcf319$var$line_colors[Math.floor(Math.random() * $2b6e161c9edcf319$var$line_colors.length)];
        const lineMaterial = new $dyjou.LineBasicMaterial({
            color: line_color,
            transparent: true,
            depthWrite: false,
            depthTest: true,
            opacity: 0.5
        });
        lineMaterial.color.multiplyScalar(50);
        const lineMesh = new $dyjou.Line(lineGeometry, lineMaterial);
        $2b6e161c9edcf319$var$scene.add(lineMesh);
        $2b6e161c9edcf319$var$starlines.push(lineMesh);
    }
}
let $2b6e161c9edcf319$var$particle_list = [];
const $2b6e161c9edcf319$var$star_texture = $2b6e161c9edcf319$var$textureLoader.load((0, (/*@__PURE__*/$parcel$interopDefault($86db31fcb6027a0b$exports))));
class $2b6e161c9edcf319$var$ParticleExplosion {
    constructor(position, scene, num_found_tanzaku, lat, lng, count = 20, lifetime = 0.5){
        this.scene = scene;
        this.lifetime = lifetime;
        this.elapsed = 0;
        this.count = count;
        this.clear_border = 27;
        this.num_found_tanzaku = num_found_tanzaku;
        if (num_found_tanzaku >= this.clear_border) {
            this.color = $2b6e161c9edcf319$var$line_colors[Math.floor(Math.random() * $2b6e161c9edcf319$var$line_colors.length)];
            this.count = 60;
            this.lifetime = 0.5;
            const normal = new $dyjou.Vector3(position.x, position.y, position.z).normalize(); //(0,0,0)から目標座標への単位ベクトル
            const temp = new $dyjou.Vector3(0, 1, 0);
            if (Math.abs(normal.dot(temp)) > 0.99) temp.set(1, 0, 0); // ほぼ平行な場合は別の軸を使う
            this.axis1 = new $dyjou.Vector3().crossVectors(normal, temp).normalize();
            this.axis2 = new $dyjou.Vector3().crossVectors(normal, this.axis1).normalize();
        } else this.color = 0xffffaa;
        this.geometry = new $dyjou.BufferGeometry();
        this.positions = new Float32Array(this.count * 3);
        this.velocities = [];
        for(let i = 0; i < this.count; i++){
            this.positions[i * 3] = position.x;
            this.positions[i * 3 + 1] = position.y;
            this.positions[i * 3 + 2] = position.z;
            let dir;
            if (num_found_tanzaku < this.clear_border) dir = new $dyjou.Vector3((Math.random() - 0.5) * 0.05, (Math.random() - 0.5) * 0.05, (Math.random() - 0.5) * 0.05);
            else {
                if (i < 20) {
                    const angle = Math.PI * 2 / 20 * i;
                    const direction = new $dyjou.Vector3().addScaledVector(this.axis1, Math.cos(angle)).addScaledVector(this.axis2, Math.sin(angle));
                    dir = direction.clone().multiplyScalar(0.06);
                } else if (20 <= i && i < 40) {
                    const angle = Math.PI * 2 / 20 * (i - 20);
                    const direction = new $dyjou.Vector3().addScaledVector(this.axis1, Math.cos(angle)).addScaledVector(this.axis2, Math.sin(angle));
                    dir = direction.clone().multiplyScalar(0.12);
                } else {
                    const angle = Math.PI * 2 / 20 * (i - 40);
                    const direction = new $dyjou.Vector3().addScaledVector(this.axis1, Math.cos(angle)).addScaledVector(this.axis2, Math.sin(angle));
                    dir = direction.clone().multiplyScalar(0.09);
                }
            }
            this.velocities.push(dir);
        }
        this.geometry.setAttribute('position', new $dyjou.BufferAttribute(this.positions, 3));
        this.material = new $dyjou.PointsMaterial({
            map: $2b6e161c9edcf319$var$star_texture,
            size: 2,
            color: this.color,
            transparent: true,
            opacity: 0.5,
            depthWrite: false,
            alphaTest: 0.1
        });
        this.points = new $dyjou.Points(this.geometry, this.material);
        this.scene.add(this.points);
        $2b6e161c9edcf319$var$particle_list.push(this.points);
    }
    update(delta) {
        this.elapsed += delta;
        for(let i = 0; i < this.velocities.length; i++){
            this.positions[i * 3] += this.velocities[i].x;
            this.positions[i * 3 + 1] += this.velocities[i].y - 0.06 * this.elapsed;
            this.positions[i * 3 + 2] += this.velocities[i].z;
        }
        if (this.num_found_tanzaku < this.clear_border) this.material.opacity = Math.max(3 - 3 * this.elapsed / this.lifetime, 0);
        else if (this.elapsed / this.lifetime < 0.5) this.material.opacity = Math.min(10 * this.elapsed / this.lifetime * 2, 10);
        else this.material.opacity = Math.max(5 - 5 * this.elapsed / this.lifetime - 1, 0);
        this.geometry.attributes.position.needsUpdate = true;
    }
    isDead() {
        return this.elapsed >= this.lifetime;
    }
    dispose() {
        this.points.visible = false;
        this.scene.remove(this.points);
        this.geometry.dispose();
        this.material.dispose();
    }
}
const $2b6e161c9edcf319$var$explosions = [];
function $2b6e161c9edcf319$var$triggerExplosion(pos, lng, lat) {
    const explosion = new $2b6e161c9edcf319$var$ParticleExplosion(pos, $2b6e161c9edcf319$var$scene, $2b6e161c9edcf319$var$num_found_tanzaku, lng, lat);
    $2b6e161c9edcf319$var$explosions.push(explosion);
}
const $2b6e161c9edcf319$var$tanzaku_imgs = [
    (0, (/*@__PURE__*/$parcel$interopDefault($9752a241ba3ed1cd$exports))),
    (0, (/*@__PURE__*/$parcel$interopDefault($e67b450df87d6c6b$exports))),
    (0, (/*@__PURE__*/$parcel$interopDefault($c6ef9c97687cefd0$exports))),
    (0, (/*@__PURE__*/$parcel$interopDefault($5d65f570a481959a$exports))),
    (0, (/*@__PURE__*/$parcel$interopDefault($4a8393e7a08ded3d$exports))),
    (0, (/*@__PURE__*/$parcel$interopDefault($fe92ec6d8a56b4b9$exports)))
];
function $2b6e161c9edcf319$var$drawImageRotated(ctx, img, x, y, options = {}) {
    const { rotation: rotation = 0, scale: scale = 1.0, opacity: opacity = 1.0, width: width = img.width, height: height = img.height, filter: filter = null } = options;
    ctx.save(); // 現在の状態を保存
    ctx.globalAlpha = opacity;
    if (filter) ctx.filter = filter;
    ctx.translate(x, y);
    ctx.rotate(rotation);
    ctx.scale(scale, scale);
    ctx.drawImage(img, -width / 2, -height / 2, width, height);
    ctx.restore(); // 状態を元に戻す
}
const $2b6e161c9edcf319$var$tanzaku_back_ims = $2b6e161c9edcf319$var$button_back_imgs.concat([
    (0, (/*@__PURE__*/$parcel$interopDefault($f443bc2d37eda7c6$exports)))
]);
let $2b6e161c9edcf319$var$tanzaku_list = [];
let $2b6e161c9edcf319$var$original_tanzaku_list = [];
function $2b6e161c9edcf319$var$make_tanzaku_and_place(dis = 40, quantity_per_one = 6) {
    $2b6e161c9edcf319$var$original_tanzaku_list = [];
    $2b6e161c9edcf319$var$tanzaku_list = [];
    $2b6e161c9edcf319$var$tanzaku_imgs.forEach((tanzaku)=>{
        const img = new Image();
        img.src = tanzaku;
        img.onload = async ()=>{
            for(let i = 0; i < quantity_per_one; i++){
                const canvas = document.createElement('canvas');
                const ctx = canvas.getContext('2d');
                canvas.width = img.height;
                canvas.height = img.width;
                ctx.save();
                ctx.translate(canvas.width / 2, canvas.height / 2);
                ctx.rotate(90 * Math.PI / 180);
                ctx.drawImage(img, -img.width / 2, -img.height / 2);
                ctx.restore();
                const promises = [];
                for(let k = 0; k < 5; k++){
                    const img_src = $2b6e161c9edcf319$var$tanzaku_back_ims[Math.floor(Math.random() * $2b6e161c9edcf319$var$tanzaku_back_ims.length)];
                    const p = new Promise((resolve)=>{
                        const back_img = new Image();
                        back_img.src = img_src;
                        back_img.onload = ()=>{
                            resolve(back_img); // 読み込み完了したら渡す
                        };
                    });
                    promises.push(p);
                }
                const loaded_images = await Promise.all(promises); // 全部ロード完了を待つ
                loaded_images.forEach((back_img)=>{
                    const x = Math.random() * ctx.canvas.width;
                    const y = Math.max(Math.random(), 0.3) * ctx.canvas.height;
                    //console.log(x,y);
                    $2b6e161c9edcf319$var$drawImageRotated(ctx, back_img, x, y, {
                        rotation: Math.random() * Math.PI * 2,
                        scale: 0.5 + Math.random() * 1.0,
                        opacity: 0.4 + Math.random() * 0.5,
                        filter: 'blur(6px)'
                    });
                });
                const dataUrl = canvas.toDataURL();
                const texture = new $dyjou.CanvasTexture(canvas);
                const material = new $dyjou.MeshBasicMaterial({
                    map: texture,
                    transparent: true,
                    opacity: 0.4,
                    alphaTest: 0.1,
                    side: $dyjou.DoubleSide
                });
                const geometry = new $dyjou.PlaneGeometry(0.4, 2.0);
                const tanzaku_mesh = new $dyjou.Mesh(geometry, material);
                //tanzaku_mesh.position.set(Math.random()*10-5,2,Math.random()*10-5);
                const theta = Math.random() * Math.PI * 2; //短冊の緯度
                const phi = Math.asin(2 * Math.random() - 1); //短冊の経度//直接高さの角度を決めると偏るのでasinで逆算
                const x = dis * Math.cos(phi) * Math.cos(theta);
                const y = dis * Math.sin(phi);
                const z = dis * Math.cos(phi) * Math.sin(theta);
                tanzaku_mesh.position.set(x, y, z);
                tanzaku_mesh.lookAt(0, 0, 0);
                if (i < quantity_per_one - 1) {
                    $2b6e161c9edcf319$var$scene.add(tanzaku_mesh);
                    $2b6e161c9edcf319$var$tanzaku_list.push({
                        mesh: tanzaku_mesh,
                        isAnimating: false,
                        imgURL: dataUrl,
                        users: false,
                        geometry: geometry,
                        material: material,
                        texture: texture
                    });
                } else $2b6e161c9edcf319$var$original_tanzaku_list.push({
                    mesh: tanzaku_mesh,
                    imgURL: dataUrl,
                    URL4css: tanzaku,
                    geometry: geometry,
                    material: material,
                    texture: texture
                });
            }
        };
    });
}
const $2b6e161c9edcf319$var$wishList = [
    "\u53D7\u9A13\u306B\u5408\u683C\u3057\u307E\u3059\u3088\u3046\u306B",
    "\u53CB\u9054\u3068\u4EF2\u826F\u304F\u306A\u308A\u305F\u3044\u3067\u3059",
    "\u5168\u56FD\u5927\u4F1A\u306B\u51FA\u5834\u3067\u304D\u307E\u3059\u3088\u3046\u306B",
    "\u9060\u8DB3\u306E\u65E5\u306B\u6674\u308C\u3066\u304F\u308C\u307E\u3059\u3088\u3046\u306B",
    "\u5358\u4F4D\u304C\u5168\u90E8\u53D6\u308C\u307E\u3059\u3088\u3046\u306B",
    "\u514D\u8A31\u304C\u4E00\u767A\u3067\u53D6\u308C\u307E\u3059\u3088\u3046\u306B",
    "\u30D0\u30A4\u30C8\u5148\u304C\u898B\u3064\u304B\u308A\u307E\u3059\u3088\u3046\u306B",
    "\u5C31\u6D3B\u304C\u3046\u307E\u304F\u3044\u304D\u307E\u3059\u3088\u3046\u306B",
    "\u4ED5\u4E8B\u304C\u3046\u307E\u304F\u3044\u304D\u307E\u3059\u3088\u3046\u306B",
    "\u5065\u5EB7\u3067\u697D\u3057\u3044\u6BCE\u65E5\u3092\u9001\u308C\u307E\u3059\u3088\u3046\u306B",
    "\u5C0F\u3055\u306A\u5E78\u305B\u306B\u6C17\u3065\u3051\u307E\u3059\u3088\u3046\u306B",
    "\u89AA\u3068\u4EF2\u76F4\u308A\u3067\u304D\u307E\u3059\u3088\u3046\u306B",
    "\u5F8C\u6094\u306E\u306A\u3044\u9AD8\u6821\u751F\u6D3B\u304C\u9001\u308C\u307E\u3059\u3088\u3046\u306B",
    "\u5922\u3092\u3042\u304D\u3089\u3081\u305A\u306B\u9811\u5F35\u308C\u307E\u3059\u3088\u3046\u306B",
    "\u65B0\u3057\u3044\u6311\u6226\u306B\u6210\u529F\u3057\u307E\u3059\u3088\u3046\u306B",
    "\u4E00\u5EA6\u3067\u3044\u3044\u304B\u3089\u7A7A\u3092\u98DB\u3093\u3067\u307F\u305F\u3044",
    "\u53CB\u9054\u306E\u3053\u3068\u3092\u3082\u3063\u3068\u77E5\u308C\u307E\u3059\u3088\u3046\u306B",
    "\u304A\u91D1\u3068\u6642\u9593\u306B\u4F59\u88D5\u304C\u6301\u3066\u307E\u3059\u3088\u3046\u306B",
    "\u5B9D\u304F\u3058\u304C\u5F53\u305F\u308A\u307E\u3059\u3088\u3046\u306B",
    "\u81EA\u5206\u306E\u30DA\u30FC\u30B9\u3092\u5927\u5207\u306B\u3067\u304D\u307E\u3059\u3088\u3046\u306B",
    "\u30B9\u30C8\u30EC\u30B9\u3092\u4E0A\u624B\u306B\u767A\u6563\u3067\u304D\u307E\u3059\u3088\u3046\u306B",
    "\u597D\u304D\u306A\u4EBA\u306B\u60F3\u3044\u304C\u5C4A\u304D\u307E\u3059\u3088\u3046\u306B",
    "\u597D\u304D\u306A\u30D0\u30F3\u30C9\u306E\u30E9\u30A4\u30D6\u306B\u884C\u3051\u307E\u3059\u3088\u3046\u306B",
    "\u3067\u304D\u308B\u3060\u3051\u591A\u304F\u7686\u306E\u9858\u3044\u304C\u5C4A\u304D\u307E\u3059\u3088\u3046\u306B",
    "\u305A\u3063\u3068\u82E5\u3005\u3057\u304F\u3044\u3089\u308C\u307E\u3059\u3088\u3046\u306B",
    "\u53CB\u9054\u3068\u305A\u3063\u3068\u4EF2\u826F\u304F\u3044\u3089\u308C\u307E\u3059\u3088\u3046\u306B",
    "\u671D\u65E9\u304F\u8D77\u304D\u3089\u308C\u308B\u4F53\u306B\u306A\u308A\u307E\u3059\u3088\u3046\u306B",
    "\u4E00\u4EBA\u66AE\u3089\u3057\u3092\u3057\u3066\u307F\u305F\u3044\u306A\u3041",
    "\u7121\u4E8B\u306B\u5B9A\u6642\u3067\u5E30\u308C\u307E\u3059\u3088\u3046\u306B",
    "\u4F11\u65E5\u51FA\u52E4\u304C\u306A\u304F\u306A\u308A\u307E\u3059\u3088\u3046\u306B",
    "\u5E0C\u671B\u901A\u308A\u306E\u7814\u7A76\u5BA4\u306B\u884C\u3051\u307E\u3059\u3088\u3046\u306B",
    "\u30D7\u30EC\u30BC\u30F3\u304C\u6210\u529F\u3057\u307E\u3059\u3088\u3046\u306B",
    "\u602A\u6211\u7121\u304F\u4E00\u5E74\u3092\u904E\u3054\u305B\u307E\u3059\u3088\u3046\u306B",
    "\u8A66\u9A13\u304C\u795E\u983C\u307F\u306B\u306A\u308A\u307E\u305B\u3093\u3088\u3046\u306B",
    "\u2190\u3053\u306E\u4EBA\u306E\u9858\u3044\u304C\u53F6\u3044\u307E\u3059\u3088\u3046\u306B",
    "\u81EA\u5206\u306E\u6C17\u6301\u3061\u306B\u6B63\u76F4\u306B\u306A\u308C\u307E\u3059\u3088\u3046\u306B",
    "\u81EA\u5206\u306B\u3082\u3063\u3068\u81EA\u4FE1\u304C\u6301\u3066\u307E\u3059\u3088\u3046\u306B",
    "\u7A81\u7136IQ\u304C\u8DF3\u306D\u4E0A\u304C\u308A\u307E\u3059\u3088\u3046\u306B",
    "\u5148\u751F\u304C\u8A00\u3063\u3066\u308B\u3053\u3068\u304C\u7406\u89E3\u3067\u304D\u307E\u3059\u3088\u3046\u306B",
    "\u899A\u3048\u305F\u82F1\u5358\u8A9E\u3092\u305A\u3063\u3068\u899A\u3048\u3066\u3044\u3089\u308C\u307E\u3059\u3088\u3046\u306B",
    "\u901A\u52E4\u304C\u5FEB\u9069\u306B\u306A\u308A\u307E\u3059\u3088\u3046\u306B",
    "\u5065\u5EB7\u5BFF\u547D\u304C\u306E\u3073\u307E\u3059\u3088\u3046\u306B",
    "\u8DB3\u8170\u304C\u4E08\u592B\u3067\u3044\u3089\u308C\u307E\u3059\u3088\u3046\u306B",
    "\u4F55\u6B73\u306B\u306A\u3063\u3066\u3082\u597D\u5947\u5FC3\u3092\u5FD8\u308C\u307E\u305B\u3093\u3088\u3046\u306B",
    "\u5BB6\u65CF\u3068\u4EF2\u826F\u304F\u66AE\u3089\u305B\u307E\u3059\u3088\u3046\u306B",
    "\u30D0\u30B9\u505C\u304C\u5BB6\u306E\u76EE\u306E\u524D\u306B\u79FB\u52D5\u3057\u3066\u304D\u307E\u3059\u3088\u3046\u306B",
    "\u3044\u308D\u3093\u306A\u4EBA\u306B\u597D\u304B\u308C\u308B\u3088\u3046\u306B\u306A\u308A\u305F\u3044",
    "\u53EF\u611B\u304F\u306A\u308A\u305F\u3044",
    "\u5927\u91D1\u6301\u3061\u306B\u306A\u308C\u307E\u3059\u3088\u3046\u306B",
    "\u30AB\u30C3\u30B3\u3088\u304F\u306A\u308C\u307E\u3059\u3088\u3046\u306B",
    "\u5E38\u306B\u4ED6\u4EBA\u306B\u512A\u3057\u304F\u3042\u308C\u307E\u3059\u3088\u3046\u306B",
    "\u6065\u305A\u304B\u3057\u304C\u3089\u305A\u306B\u611F\u8B1D\u3092\u4F1D\u3048\u3089\u308C\u308B\u3088\u3046\u306B\u308C\u307E\u3059\u3088\u3046\u306B",
    "\u5149\u8EF8\u304C\u305A\u308C\u306A\u3044\u30EC\u30FC\u30B6\u30FC\u30AB\u30C3\u30BF\u30FC\u304C\u6B32\u3057\u3044",
    "\u30AE\u30BF\u30FC\u3092\u5F3E\u3051\u308B\u3088\u3046\u306B\u306A\u308C\u307E\u3059\u3088\u3046\u306B",
    "\u304D\u308C\u3044\u306A\u5B57\u3092\u66F8\u3051\u308B\u3088\u3046\u306B\u306A\u308C\u307E\u3059\u3088\u3046\u306B",
    "\u7D75\u3092\u3046\u307E\u304F\u66F8\u3051\u308B\u3088\u3046\u306B\u306A\u308C\u307E\u3059\u3088\u3046\u306B",
    "\u5468\u308A\u306E\u4EBA\u306B\u5FC3\u914D\u3055\u308C\u306A\u3044\u3088\u3046\u306B\u306A\u308C\u307E\u3059\u3088\u3046\u306B",
    "\u5E38\u306B\u8A87\u308C\u308B\u3088\u3046\u306A\u4EBA\u751F\u3067\u3042\u308A\u307E\u3059\u3088\u3046\u306B",
    "\u597D\u304D\u306A\u6F2B\u753B\u306E\u6700\u65B0\u5DFB\u304C\u65E9\u304F\u8AAD\u3081\u307E\u3059\u3088\u3046\u306B",
    "\u5C0A\u656C\u3055\u308C\u308B\u3088\u3046\u306A\u4EBA\u306B\u306A\u308C\u307E\u3059\u3088\u3046\u306B",
    "\u81EA\u5206\u306E\u9854\u304C\u304A\u672D\u306B\u8F09\u308A\u307E\u3059\u3088\u3046\u306B",
    "\u597D\u304D\u306A\u3053\u3068\u3092\u901A\u3057\u3066\u4E16\u754C\u4E2D\u3068\u7E4B\u304C\u308C\u307E\u3059\u3088\u3046\u306B",
    "\u30AB\u30CB\u98DF\u3079\u305F\u3044",
    "\u3057\u3083\u3063\u304F\u308A\u306E\u7D42\u308F\u308A\u3092\u898B\u5C4A\u3051\u305F\u3044",
    "\u7FA9\u52D9\u306E\u4EE3\u308F\u308A\u306B\u6A29\u5229\u304C\u6B32\u3057\u3044",
    "\u624B\u3054\u308D\u306A\u6CB9\u7530\u304C\u6B32\u3057\u3044",
    "\u30B9\u30B7\u306E\u30B7\u30E3\u30EA\u3092\u3046\u307E\u304F\u63E1\u308C\u308B\u3088\u3046\u306B\u306A\u308A\u305F\u3044",
    "\u6307\u304B\u3089\u304A\u83D3\u5B50\u3092\u767A\u5C04\u3057\u305F\u3044",
    "\u5927\u5B66\u5074\u304B\u3089\u6765\u3066\u307B\u3057\u3044",
    "\u898B\u305F\u30D5\u30A9\u30F3\u30C8\u540D\u304C\u3059\u3050\u308F\u304B\u308B\u80FD\u529B\u304C\u6B32\u3057\u3044",
    "\u30DE\u30DE\u304C\u3053\u308F\u304F\u306A\u304F\u306A\u308A\u307E\u3059\u3088\u3046\u306B",
    "\u4E03\u5915\u3068\u30AF\u30EA\u30B9\u30DE\u30B9\u3092\u6DF7\u540C\u3057\u3066\u308B\u4EBA\u304C\u3044\u306A\u304F\u306A\u308A\u307E\u3059\u3088\u3046\u306B"
];
const $2b6e161c9edcf319$var$fonts = [
    //"nikokaku",
    "Xim-Sans",
    "\u308C\u3044\u3053",
    "MyFont"
];
const $2b6e161c9edcf319$var$found_tanzaku = document.getElementById("found_tanzaku");
function $2b6e161c9edcf319$var$get_tanzaku_animation(tanzaku_mesh, imgURL, users) {
    let tl = (0, $357b3f2d5f2ec9d5$export$99ee26438460406a).timeline();
    const twist_z = Math.random() * 2 * Math.PI;
    const twist_x = Math.random() * 2 * Math.PI;
    tl.to(tanzaku_mesh.position, {
        duration: 0.5,
        y: "+=1"
    }, 0);
    tl.to(tanzaku_mesh.rotation, {
        duration: 1,
        x: tanzaku_mesh.rotation.x + twist_x,
        y: tanzaku_mesh.rotation.y + Math.PI * 2,
        z: tanzaku_mesh.rotation.z + twist_z
    }, 0);
    tl.to(tanzaku_mesh.material, {
        duration: 0.2,
        opacity: 5
    }, 0.8);
    tl.to(tanzaku_mesh.material, {
        duration: 0.5,
        opacity: 0,
        onComplete: ()=>{
            //scene.remove(tanzaku_mesh);
            const tanzaku_space = document.getElementById("tanzaku_space");
            const tanzaku_img_ele = document.createElement('img');
            tanzaku_img_ele.src = imgURL;
            const img_parent_ele = document.createElement('div');
            img_parent_ele.classList.add("slidedown");
            img_parent_ele.appendChild(tanzaku_img_ele);
            const tanzaku_txt = document.createElement('p');
            let current_wish;
            if (!users) {
                const wish_idx = Math.floor(Math.random() * $2b6e161c9edcf319$var$current_wishList.length);
                current_wish = $2b6e161c9edcf319$var$current_wishList[wish_idx];
                $2b6e161c9edcf319$var$current_wishList.splice(wish_idx, 1);
                tanzaku_txt.style.fontFamily = $2b6e161c9edcf319$var$fonts[Math.floor(Math.random() * $2b6e161c9edcf319$var$fonts.length)];
            } else {
                current_wish = $2b6e161c9edcf319$var$users_wish;
                tanzaku_txt.style.fontFamily = "\u308C\u3044\u3053";
            }
            tanzaku_txt.innerHTML = current_wish.replace(/=/g, '<span class="rotate">=</span>').replace(/－/g, '<span class="rotate">\uFF0D</span>').replace(/\)/g, '<span class="rotate">)</span>').replace(/\(/g, '<span class="rotate">(</span>').replace(/-/g, '<span class="rotate">-</span>');
            img_parent_ele.appendChild(tanzaku_txt);
            tanzaku_space.insertBefore(img_parent_ele, tanzaku_space.children[0]);
            $2b6e161c9edcf319$var$found_tanzaku.innerText = $2b6e161c9edcf319$var$num_found_tanzaku;
        }
    }, 1.0);
}
const $2b6e161c9edcf319$var$back_telescope = document.getElementById("back_telescope");
const $2b6e161c9edcf319$var$all_wrapper = document.getElementById("all_wrapper");
$2b6e161c9edcf319$var$back_telescope.addEventListener("click", ()=>{
    $2b6e161c9edcf319$var$all_wrapper.style.display = "block";
    $2b6e161c9edcf319$var$update_back_tanzaku();
});
const $2b6e161c9edcf319$var$disagree_return_button = document.getElementById("disagree_return");
$2b6e161c9edcf319$var$disagree_return_button.addEventListener("click", ()=>{
    $2b6e161c9edcf319$var$all_wrapper.style.display = "none";
});
const $2b6e161c9edcf319$var$return_hide_ele = document.getElementById("return_hide");
const $2b6e161c9edcf319$var$agree_return_button = document.getElementById("agree_return");
const $2b6e161c9edcf319$var$take_picture_button = document.getElementById("take_picture");
const $2b6e161c9edcf319$var$return_galaxy_button = document.getElementById("return_galaxy");
$2b6e161c9edcf319$var$agree_return_button.addEventListener("click", ()=>{
    $2b6e161c9edcf319$var$back_telescope.style.display = "none";
    $2b6e161c9edcf319$var$all_wrapper.style.display = "none";
    $2b6e161c9edcf319$var$return_hide_ele.style.display = "block";
    $2b6e161c9edcf319$var$return_hide_ele.classList.remove("opacity120");
    $2b6e161c9edcf319$var$return_hide_ele.classList.add("opacity021");
    $2b6e161c9edcf319$var$info_icon.style.display = "none";
    $2b6e161c9edcf319$var$gyro_setting_icon.style.display = "block";
    $2b6e161c9edcf319$var$starDistance = 600;
    /* constellation_lines.forEach(element => {
        element.visible = true;
    }); */ let tl = (0, $357b3f2d5f2ec9d5$export$99ee26438460406a).timeline();
    tl.to($2b6e161c9edcf319$var$camera, {
        duration: 0.5,
        onComplete: ()=>{
            const tanzaku_space_ch = document.getElementById("tanzaku_space");
            $2b6e161c9edcf319$var$telescope_filter_img.style.display = "none";
            tanzaku_space_ch.innerHTML = "";
            $2b6e161c9edcf319$var$tanzaku_space.style.display = "none";
            $2b6e161c9edcf319$var$update_gauge(0);
            $2b6e161c9edcf319$var$observe_gauge_ele.style.display = "none";
            $2b6e161c9edcf319$var$start_observe_button.style.display = "none";
            $2b6e161c9edcf319$var$camera.zoom = 1;
            $2b6e161c9edcf319$var$camera.updateProjectionMatrix();
        }
    });
    tl.to($2b6e161c9edcf319$var$camera, {
        duration: 0.5,
        onComplete: ()=>{
            $2b6e161c9edcf319$var$return_hide_ele.classList.remove("opacity021");
            $2b6e161c9edcf319$var$return_hide_ele.classList.add("opacity120");
        }
    });
    tl.to($2b6e161c9edcf319$var$camera, {
        duration: 0.5,
        onComplete: ()=>{
            $2b6e161c9edcf319$var$return_hide_ele.style.display = "none";
            $2b6e161c9edcf319$var$at_main_content = false;
            $2b6e161c9edcf319$var$inmusicGalaxy = true;
            $2b6e161c9edcf319$var$take_picture_button.style.display = "block";
            $2b6e161c9edcf319$var$return_galaxy_button.style.display = "block";
            $2b6e161c9edcf319$var$update_back_tanzaku();
        }
    });
});
$2b6e161c9edcf319$var$take_picture_button.addEventListener("click", ()=>{
    $2b6e161c9edcf319$var$save_record_ele.style.display = "block";
});
const $2b6e161c9edcf319$var$save_record_ele = document.getElementById("save_record");
const $2b6e161c9edcf319$var$save_return_button = document.getElementById("save_return");
$2b6e161c9edcf319$var$save_return_button.addEventListener("click", ()=>{
    $2b6e161c9edcf319$var$save_record_ele.style.display = "none";
});
const $2b6e161c9edcf319$var$run_save_button = document.getElementById("run_save");
const $2b6e161c9edcf319$var$switch1_background = document.getElementById("switch1");
const $2b6e161c9edcf319$var$switch2_tanzaku = document.getElementById("switch2");
$2b6e161c9edcf319$var$run_save_button.addEventListener("click", ()=>{
    if (!$2b6e161c9edcf319$var$switch1_background.checked) $2b6e161c9edcf319$var$star_points.visible = false;
    if (!$2b6e161c9edcf319$var$switch2_tanzaku.checked) $2b6e161c9edcf319$var$tanzaku_list.forEach((tanzaku)=>{
        tanzaku.mesh.visible = false;
    });
    $2b6e161c9edcf319$var$existingSprites.forEach((sprite)=>{
        sprite.sprite.matrixAutoUpdate = false;
        sprite.sprite.updateMatrix();
    });
    $2b6e161c9edcf319$var$get_6dir_img();
    $2b6e161c9edcf319$var$existingSprites.forEach((sprite)=>{
        sprite.sprite.matrixAutoUpdate = true;
        sprite.sprite.updateMatrix();
    });
    $2b6e161c9edcf319$var$star_points.visible = true;
    $2b6e161c9edcf319$var$tanzaku_list.forEach((tanzaku)=>{
        tanzaku.mesh.visible = true;
    });
});
const $2b6e161c9edcf319$var$realy_return_ele = document.getElementById("realy_return");
const $2b6e161c9edcf319$var$agree_return_galaxy_button = document.getElementById("agree_return_galaxy");
const $2b6e161c9edcf319$var$disagree_return_galaxy_button = document.getElementById("disagree_return_galaxy");
$2b6e161c9edcf319$var$return_galaxy_button.addEventListener("click", ()=>{
    $2b6e161c9edcf319$var$realy_return_ele.style.display = "block";
});
$2b6e161c9edcf319$var$agree_return_galaxy_button.addEventListener("click", ()=>{
    $2b6e161c9edcf319$var$realy_return_ele.style.display = "none";
    $2b6e161c9edcf319$var$take_picture_button.style.display = "none";
    $2b6e161c9edcf319$var$return_galaxy_button.style.display = "none";
    $2b6e161c9edcf319$var$return_hide_ele.style.display = "block";
    $2b6e161c9edcf319$var$return_hide_ele.classList.remove("opacity120");
    $2b6e161c9edcf319$var$return_hide_ele.classList.add("opacity021");
    let tl = (0, $357b3f2d5f2ec9d5$export$99ee26438460406a).timeline();
    tl.to($2b6e161c9edcf319$var$camera, {
        duration: 0.5,
        onComplete: ()=>{
            $2b6e161c9edcf319$var$camera.zoom = 1;
            $2b6e161c9edcf319$var$camera.updateProjectionMatrix();
        }
    });
    tl.to($2b6e161c9edcf319$var$camera, {
        duration: 0.5,
        onComplete: ()=>{
            $2b6e161c9edcf319$var$return_hide_ele.classList.remove("opacity021");
            $2b6e161c9edcf319$var$return_hide_ele.classList.add("opacity120");
            $2b6e161c9edcf319$var$camera.position.set(0, 3, 0);
            $2b6e161c9edcf319$var$yaw = -Math.PI / 2; // 左右
            $2b6e161c9edcf319$var$pitch = 0; // 上下
            $2b6e161c9edcf319$var$camera.rotation.y = $2b6e161c9edcf319$var$yaw;
            $2b6e161c9edcf319$var$camera.rotation.x = $2b6e161c9edcf319$var$pitch;
            $2b6e161c9edcf319$var$existingSprites.forEach((sprite)=>{
                sprite.sprite.visible = false;
                $2b6e161c9edcf319$var$scene.remove(sprite.sprite);
                sprite.texture.dispose();
                sprite.material.dispose();
            });
            $2b6e161c9edcf319$var$existingSprites = [];
            $2b6e161c9edcf319$var$tanzaku_list.forEach((tanzaku)=>{
                tanzaku.mesh.visible = false;
                $2b6e161c9edcf319$var$scene.remove(tanzaku.mesh);
                tanzaku.texture.dispose();
                tanzaku.material.dispose();
                tanzaku.geometry.dispose();
            });
            $2b6e161c9edcf319$var$original_tanzaku_list.forEach((tanzaku)=>{
                tanzaku.mesh.visible = false;
                $2b6e161c9edcf319$var$scene.remove(tanzaku.mesh);
                tanzaku.texture.dispose();
                tanzaku.material.dispose();
                tanzaku.geometry.dispose();
            });
            $2b6e161c9edcf319$var$tanzaku_list = [];
            $2b6e161c9edcf319$var$telescope.visible = true;
            $2b6e161c9edcf319$var$constellation_lines.forEach((element)=>{
                element.visible = true;
            });
            $2b6e161c9edcf319$var$starlines.forEach((starline)=>{
                starline.visible = false;
                $2b6e161c9edcf319$var$scene.remove(starline);
            });
        }
    });
    tl.to($2b6e161c9edcf319$var$camera, {
        duration: 0.5,
        onComplete: ()=>{
            $2b6e161c9edcf319$var$return_hide_ele.style.display = "none";
            $2b6e161c9edcf319$var$at_main_content = false;
            $2b6e161c9edcf319$var$inmusicGalaxy = true;
            $2b6e161c9edcf319$var$take_picture_button.style.display = "none";
            $2b6e161c9edcf319$var$return_galaxy_button.style.display = "none";
            $2b6e161c9edcf319$var$show_time_and_location_ele.style.display = "block";
            $2b6e161c9edcf319$var$change_constellation_name_button.parentElement.style.display = "block";
            $2b6e161c9edcf319$var$change_location_button.parentElement.style.display = "block";
            $2b6e161c9edcf319$var$change_time_button.parentElement.style.display = "block";
            $2b6e161c9edcf319$var$name_galaxy.innerText = "\u89B3\u6E2C\u4E2D\u306E\u9280\u6CB3\uFF1A\u5929\u306E\u5DDD\u9280\u6CB3";
            $2b6e161c9edcf319$var$inmusicGalaxy = false;
            $2b6e161c9edcf319$var$move_center = false;
            $2b6e161c9edcf319$var$update_back_tanzaku();
        }
    });
});
$2b6e161c9edcf319$var$disagree_return_galaxy_button.addEventListener("click", ()=>{
    $2b6e161c9edcf319$var$realy_return_ele.style.display = "none";
});
let $2b6e161c9edcf319$var$started_byUser = false;
function $2b6e161c9edcf319$var$waitForImages(count = 5, interval = 100) {
    return new Promise((resolve)=>{
        const check = setInterval(()=>{
            if ($2b6e161c9edcf319$var$original_tanzaku_list.length >= count) {
                clearInterval(check);
                resolve();
            }
        }, interval);
    });
}
const $2b6e161c9edcf319$var$go_observe_button = document.getElementById("go_observe");
const $2b6e161c9edcf319$var$write_wish_ele = document.getElementById("write_wish");
const $2b6e161c9edcf319$var$change_color_button = document.querySelector("#change_color");
const $2b6e161c9edcf319$var$change_color_back_ele = document.getElementById("change_color_back");
let $2b6e161c9edcf319$var$current_img_idx = 0;
const $2b6e161c9edcf319$var$tanzaku_back = document.createElement("img");
//make_tanzaku_and_place();
async function $2b6e161c9edcf319$var$set_tanzaku_img() {
    await $2b6e161c9edcf319$var$waitForImages();
    //console.log("Load_tanzaku");
    $2b6e161c9edcf319$var$tanzaku_back.src = $2b6e161c9edcf319$var$original_tanzaku_list[$2b6e161c9edcf319$var$current_img_idx].imgURL;
    $2b6e161c9edcf319$var$tanzaku_back.classList.add("back_tanzaku");
    document.getElementById("parent_write_tanzaku").appendChild($2b6e161c9edcf319$var$tanzaku_back);
    document.body.style.setProperty("--bgimg", `url("${$2b6e161c9edcf319$var$original_tanzaku_list[$2b6e161c9edcf319$var$current_img_idx].URL4css}")`);
    document.body.style.setProperty("--bgimg2", `url("${$2b6e161c9edcf319$var$original_tanzaku_list[($2b6e161c9edcf319$var$current_img_idx + 1) % 6].URL4css}")`);
}
$2b6e161c9edcf319$var$go_observe_button.addEventListener("click", ()=>{
    $2b6e161c9edcf319$var$introduce_ele.classList.add("fade_out");
    setTimeout(()=>{
        $2b6e161c9edcf319$var$introduce_ele.style.display = "none";
        $2b6e161c9edcf319$var$introduce_ele.classList.remove("fade_out");
    }, 1000);
    //original_tanzaku_list
    $2b6e161c9edcf319$var$set_tanzaku_img();
    //change_color_back_ele.style.backgroundImage = `url("${tanzaku_me_img}")`;
    // = tanzaku_imgs[Math.floor(Math.random()*tanzaku_imgs.length)];
    $2b6e161c9edcf319$var$write_wish_ele.style.display = "flex";
    $2b6e161c9edcf319$var$write_wish_ele.classList.add("fade_in");
});
$2b6e161c9edcf319$var$change_color_button.addEventListener("click", ()=>{
    $2b6e161c9edcf319$var$current_img_idx++;
    $2b6e161c9edcf319$var$current_img_idx %= 6;
    $2b6e161c9edcf319$var$set_tanzaku_img();
});
const $2b6e161c9edcf319$var$decide_tanzaku_button = document.getElementById("decide_tanzaku");
const $2b6e161c9edcf319$var$wish_ele = document.getElementById("wish");
const $2b6e161c9edcf319$var$max_tanzaku_ele = document.getElementById("max_tanzaku");
let $2b6e161c9edcf319$var$users_wish;
$2b6e161c9edcf319$var$decide_tanzaku_button.addEventListener("click", ()=>{
    //current_wishList.splice(0,1);
    //scene.remove(tanzaku_list[0].mesh);
    //tanzaku_list.splice(0,1);
    $2b6e161c9edcf319$var$users_wish = $2b6e161c9edcf319$var$wish_ele.value;
    if ($2b6e161c9edcf319$var$users_wish.length > 30) alert("\u5185\u5BB9\u306F30\u6587\u5B57\u4EE5\u4E0B\u306B\u3057\u3066\u304F\u3060\u3055\u3044\u3002");
    else {
        //
        $2b6e161c9edcf319$var$allow_touch_move = true;
        if ($2b6e161c9edcf319$var$switch3.checked) {
            $2b6e161c9edcf319$var$deviceorientation_count = 0;
            $2b6e161c9edcf319$var$is_gyro = true;
            $2b6e161c9edcf319$var$reset_rotate_origin_button.style.display = "block";
        }
        if ($2b6e161c9edcf319$var$users_wish !== "") {
            document.getElementById("parent_write_tanzaku").classList.add("go_above");
            setTimeout(()=>{
                $2b6e161c9edcf319$var$write_wish_ele.style.display = "none";
                document.getElementById("parent_write_tanzaku").classList.remove("go_above");
            }, 500);
            const theta = Math.random() * Math.PI * 2 /* *0 */ ; //短冊の緯度
            const phi = Math.asin(/* 1.41/2 */ 2 * Math.random() - 1); //短冊の経度//直接高さの角度を決めると偏るのでasinで逆算
            const x = 40 * Math.cos(phi) * Math.cos(theta);
            const y = 40 * Math.sin(phi);
            const z = 40 * Math.cos(phi) * Math.sin(theta);
            const tanzaku_mesh = $2b6e161c9edcf319$var$original_tanzaku_list[$2b6e161c9edcf319$var$current_img_idx].mesh;
            const imgURL = $2b6e161c9edcf319$var$original_tanzaku_list[$2b6e161c9edcf319$var$current_img_idx].imgURL;
            tanzaku_mesh.position.set(x, y, z);
            tanzaku_mesh.lookAt(0, 0, 0);
            $2b6e161c9edcf319$var$scene.add(tanzaku_mesh);
            let tl = (0, $357b3f2d5f2ec9d5$export$99ee26438460406a).timeline();
            const twist_z = Math.random() * 2 * Math.PI;
            const twist_x = Math.random() * 2 * Math.PI;
            const origin_Rotate_x = tanzaku_mesh.rotation.x;
            const origin_Rotate_y = tanzaku_mesh.rotation.y;
            const origin_Rotate_z = tanzaku_mesh.rotation.z;
            tanzaku_mesh.rotation.x += twist_x;
            tanzaku_mesh.rotation.z;
            tanzaku_mesh.rotation.y, Math.PI;
            tanzaku_mesh.position.y += 1;
            tanzaku_mesh.material.opacity = 0;
            tl.to(tanzaku_mesh.position, {
                duration: 0.5,
                y: "-=1"
            }, 0);
            tl.to(tanzaku_mesh.rotation, {
                duration: 1,
                x: origin_Rotate_x,
                y: origin_Rotate_y,
                z: origin_Rotate_z
            }, 0);
            tl.to(tanzaku_mesh.material, {
                duration: 0.2,
                opacity: 0.4
            }, 0.8);
            tl.to(tanzaku_mesh.material, {
                duration: 0.5,
                opacity: 5
            }, 0);
            $2b6e161c9edcf319$var$tanzaku_list.push({
                mesh: tanzaku_mesh,
                isAnimating: false,
                imgURL: imgURL,
                users: true,
                texture: $2b6e161c9edcf319$var$original_tanzaku_list[$2b6e161c9edcf319$var$current_img_idx].texture,
                geometry: $2b6e161c9edcf319$var$original_tanzaku_list[$2b6e161c9edcf319$var$current_img_idx].geometry,
                material: $2b6e161c9edcf319$var$original_tanzaku_list[$2b6e161c9edcf319$var$current_img_idx].material
            });
            $2b6e161c9edcf319$var$max_tanzaku_ele.innerText = "31";
            $2b6e161c9edcf319$var$wish_ele.value = "";
        } else $2b6e161c9edcf319$var$write_wish_ele.style.display = "none";
    }
});
function $2b6e161c9edcf319$var$random_spread(current, top = 60, count = 500) {
    return -((top - 10) * 4 / count ** 2) * (current - count / 2) ** 2 + top; //みんな大好き二次関数 上に凸の二次関数だね
}
//import { texture } from "three/tsl";
const $2b6e161c9edcf319$var$clouds = [
    (0, (/*@__PURE__*/$parcel$interopDefault($2533da9c927d3b25$exports))),
    (0, (/*@__PURE__*/$parcel$interopDefault($762662d96e2f204e$exports))),
    (0, (/*@__PURE__*/$parcel$interopDefault($3e749358f8f5ee23$exports))),
    (0, (/*@__PURE__*/$parcel$interopDefault($a1c6b99100043b95$exports))),
    (0, (/*@__PURE__*/$parcel$interopDefault($c2abe5adbe6f2dbc$exports)))
];
//ありがとうchatgpt(n度目)
function $2b6e161c9edcf319$var$loadImages(srcArray) {
    return Promise.all(srcArray.map((src)=>{
        return new Promise((resolve, reject)=>{
            const img = new Image();
            img.onload = ()=>resolve(img);
            img.onerror = reject;
            img.src = src;
        });
    }));
}
let $2b6e161c9edcf319$var$galazy_star_geometory;
let $2b6e161c9edcf319$var$galazy_star_material;
let $2b6e161c9edcf319$var$arms_data = [];
const $2b6e161c9edcf319$var$zRotation = -Math.PI / 4;
let $2b6e161c9edcf319$var$current_galaxy_rotate = 0;
let $2b6e161c9edcf319$var$cloudsprite;
let $2b6e161c9edcf319$var$cloudtexture;
let $2b6e161c9edcf319$var$cloudmaterial;
let $2b6e161c9edcf319$var$galaxy_star_points;
function $2b6e161c9edcf319$var$create_galaxy() {
    $2b6e161c9edcf319$var$arms_data = [];
    const count = 14400;
    const r_base = 400;
    const radiusStep = r_base / count;
    const angleStep = Math.PI * 2 / count * 0.8;
    let positions = [];
    const arms = 5;
    const geometry = new $dyjou.BufferGeometry();
    const center = new $dyjou.Vector3(1200, 1200, 0);
    const color_list = [
        0xbb99bb,
        0xbb9999,
        0x99bbbb,
        0xbb99aa,
        0x99bbdd,
        0xff6688,
        0x66ff88,
        0xff9966
    ];
    const color = new $dyjou.Color();
    let colors = [];
    for(let j = 0; j < arms; j++){
        const armOffset = Math.PI * 2 / arms * j;
        for(let i = 0; i < count; i++){
            const r = i * radiusStep;
            const theta = i * angleStep + armOffset;
            const spread_range = $2b6e161c9edcf319$var$random_spread(i, 70, count);
            let armz = r * Math.cos(theta) + (Math.random() - 0.5) * spread_range;
            let army = r * Math.sin(theta) + (Math.random() - 0.5) * spread_range;
            let armx = (Math.random() - 0.5) * spread_range; // 少し厚みを持たせる
            const rotatedX = army * Math.cos($2b6e161c9edcf319$var$zRotation);
            const rotatedY = army * Math.sin($2b6e161c9edcf319$var$zRotation);
            $2b6e161c9edcf319$var$arms_data.push([
                armx,
                army,
                armz,
                center.clone()
            ]);
            armx = rotatedX + center.x + armx;
            army = rotatedY + center.y;
            armz = armz + center.z;
            positions.push(armx, army, armz);
            if (i > count * 0.5) color.setHex(0x9999bb);
            else if (i <= count * 0.5 && i >= count * 0.05) color.setHex(color_list[Math.floor(Math.random() * color_list.length)]);
            else color.setHex(0xaaaaaa);
            colors.push(color.r, color.g, color.b);
        }
    }
    //console.log(colors);
    geometry.setAttribute("position", new $dyjou.Float32BufferAttribute(positions, 3));
    geometry.setAttribute("color", new $dyjou.Float32BufferAttribute(colors, 3));
    $2b6e161c9edcf319$var$galazy_star_geometory = geometry;
    const material = new $dyjou.PointsMaterial({
        size: 7,
        vertexColors: true,
        /* color: 0xbb99aa, */ transparent: true,
        opacity: 3,
        depthWrite: false,
        /* map: texture, */ alphaTest: 0.001,
        blending: $dyjou.AdditiveBlending
    });
    $2b6e161c9edcf319$var$galazy_star_material = material;
    const points = new $dyjou.Points(geometry, material);
    $2b6e161c9edcf319$var$galaxy_star_points = points;
    $2b6e161c9edcf319$var$scene.add(points);
    $2b6e161c9edcf319$var$loadImages($2b6e161c9edcf319$var$clouds).then((images)=>{
        const canvas = document.createElement('canvas');
        canvas.width = 800;
        canvas.height = 800;
        const ctx = canvas.getContext('2d');
        let weights = [];
        for(let i = 0; i < images.length - 1; i++){
            let total = weights.reduce((sum, element)=>sum + element, 0);
            weights.push(Math.random() * (1 - total));
        }
        let total = weights.reduce((sum, element)=>sum + element, 0);
        weights.push(1 - total);
        images.forEach((img, i)=>{
            //console.log(weights[i]);
            ctx.globalAlpha = weights[i];
            ctx.drawImage(img, 0, 0, canvas.width, canvas.height);
        });
        // CanvasからThree.js用のテクスチャに
        $2b6e161c9edcf319$var$cloudtexture = new $dyjou.CanvasTexture(canvas);
        //document.body.appendChild(canvas);
        $2b6e161c9edcf319$var$cloudmaterial = new $dyjou.SpriteMaterial({
            map: $2b6e161c9edcf319$var$cloudtexture,
            transparent: true,
            depthWrite: false,
            opacity: 0.5,
            color: 0x11ffff
        });
        $2b6e161c9edcf319$var$cloudsprite = new $dyjou.Sprite($2b6e161c9edcf319$var$cloudmaterial);
        $2b6e161c9edcf319$var$cloudsprite.scale.set(1000, 1000, 1);
        $2b6e161c9edcf319$var$cloudsprite.position.set(800, 800, 0);
        $2b6e161c9edcf319$var$scene.add($2b6e161c9edcf319$var$cloudsprite);
        $2b6e161c9edcf319$var$cloudsprite.lookAt(0, 0, 0);
    });
}
//create_galaxy();
const $2b6e161c9edcf319$var$total_addition_angle = -Math.PI * 2;
const $2b6e161c9edcf319$var$GalaxyRotate_duration = 5000;
let $2b6e161c9edcf319$var$GalaxyRotateStart_time = undefined;
let $2b6e161c9edcf319$var$GalaxyRotating = false;
let $2b6e161c9edcf319$var$rotate_progress = 0;
let $2b6e161c9edcf319$var$center_goal2 = new $dyjou.Vector3(50, 50, 0);
function $2b6e161c9edcf319$var$rotate_galaxyStars() {
    let addition_angle = 0;
    if ($2b6e161c9edcf319$var$GalaxyRotating) {
        if ($2b6e161c9edcf319$var$GalaxyRotateStart_time == undefined) $2b6e161c9edcf319$var$GalaxyRotateStart_time = performance.now();
        const now = performance.now();
        const galaxystar_positions = $2b6e161c9edcf319$var$galazy_star_geometory.attributes.position.array;
        const past_time_ms = now - $2b6e161c9edcf319$var$GalaxyRotateStart_time;
        $2b6e161c9edcf319$var$rotate_progress = past_time_ms / $2b6e161c9edcf319$var$GalaxyRotate_duration;
        if ($2b6e161c9edcf319$var$rotate_progress >= 1) {
            $2b6e161c9edcf319$var$rotate_progress = 0;
            $2b6e161c9edcf319$var$GalaxyRotateStart_time = undefined;
            $2b6e161c9edcf319$var$GalaxyRotating = false;
            return;
        }
        const eased_progress = $2b6e161c9edcf319$var$easeInOutCubic($2b6e161c9edcf319$var$rotate_progress);
        addition_angle = $2b6e161c9edcf319$var$total_addition_angle * eased_progress + $2b6e161c9edcf319$var$current_galaxy_rotate;
        let index = 0;
        $2b6e161c9edcf319$var$arms_data.forEach((arms)=>{
            let armx = arms[0];
            let army = arms[1];
            let armz = arms[2];
            let center = arms[3];
            let radius = Math.sqrt(army ** 2 + armz ** 2);
            const angleRad = Math.atan2(army, armz);
            const updated_angleRad = angleRad + addition_angle;
            army = radius * Math.sin(updated_angleRad);
            armz = radius * Math.cos(updated_angleRad);
            const rotatedX = army * Math.cos($2b6e161c9edcf319$var$zRotation);
            const rotatedY = army * Math.sin($2b6e161c9edcf319$var$zRotation);
            center = new $dyjou.Vector3().lerpVectors(center, $2b6e161c9edcf319$var$center_goal2, eased_progress);
            armx = rotatedX + center.x + armx;
            army = rotatedY + center.y;
            armz = armz + center.z;
            //arms[3] = center;
            galaxystar_positions[index * 3] = armx;
            galaxystar_positions[1 + index * 3] = army;
            galaxystar_positions[2 + index * 3] = armz;
            index++;
        });
        if ($2b6e161c9edcf319$var$cloudsprite && $2b6e161c9edcf319$var$cloudsprite.material) $2b6e161c9edcf319$var$cloudsprite.material.rotation = -addition_angle;
        $2b6e161c9edcf319$var$galazy_star_geometory.attributes.position.needsUpdate = true;
    } else if ($2b6e161c9edcf319$var$GalaxyRotateStart_time !== undefined) $2b6e161c9edcf319$var$current_galaxy_rotate = addition_angle;
}
let $2b6e161c9edcf319$var$always_GalaxyRotating = false;
let $2b6e161c9edcf319$var$rotation_pase = 5;
let $2b6e161c9edcf319$var$addition_angle = 0;
function $2b6e161c9edcf319$var$always_rotate_galaxyStars() {
    if ($2b6e161c9edcf319$var$always_GalaxyRotating) {
        if ($2b6e161c9edcf319$var$GalaxyRotateStart_time == undefined) $2b6e161c9edcf319$var$GalaxyRotateStart_time = performance.now();
        const now = performance.now();
        const galaxystar_positions = $2b6e161c9edcf319$var$galazy_star_geometory.attributes.position.array;
        const past_time_ms = now - $2b6e161c9edcf319$var$GalaxyRotateStart_time;
        const progress = past_time_ms % ($2b6e161c9edcf319$var$GalaxyRotate_duration * $2b6e161c9edcf319$var$rotation_pase) / ($2b6e161c9edcf319$var$GalaxyRotate_duration * $2b6e161c9edcf319$var$rotation_pase);
        $2b6e161c9edcf319$var$addition_angle = $2b6e161c9edcf319$var$total_addition_angle * progress;
        let index = 0;
        $2b6e161c9edcf319$var$arms_data.forEach((arms)=>{
            let armx = arms[0];
            let army = arms[1];
            let armz = arms[2];
            let center = arms[3];
            let radius = Math.sqrt(army ** 2 + armz ** 2);
            const angleRad = Math.atan2(army, armz);
            const updated_angleRad = angleRad + $2b6e161c9edcf319$var$addition_angle + $2b6e161c9edcf319$var$current_galaxy_rotate;
            army = radius * Math.sin(updated_angleRad);
            armz = radius * Math.cos(updated_angleRad);
            const rotatedX = army * Math.cos($2b6e161c9edcf319$var$zRotation);
            const rotatedY = army * Math.sin($2b6e161c9edcf319$var$zRotation);
            armx = rotatedX + center.x + armx;
            army = rotatedY + center.y;
            armz = armz + center.z;
            galaxystar_positions[index * 3] = armx;
            galaxystar_positions[1 + index * 3] = army;
            galaxystar_positions[2 + index * 3] = armz;
            index++;
        });
        if ($2b6e161c9edcf319$var$cloudsprite && $2b6e161c9edcf319$var$cloudsprite.material) $2b6e161c9edcf319$var$cloudsprite.material.rotation = -$2b6e161c9edcf319$var$addition_angle;
        $2b6e161c9edcf319$var$galazy_star_geometory.attributes.position.needsUpdate = true;
    } else if ($2b6e161c9edcf319$var$GalaxyRotateStart_time !== undefined) $2b6e161c9edcf319$var$current_galaxy_rotate = $2b6e161c9edcf319$var$addition_angle;
}
/* const thumbnails = {
    0:"https://i.ytimg.com/vi/NPOhKU5VTrQ/hqdefault.jpg",
    1:"https://i.ytimg.com/vi/4thcMKIMBYE/hqdefault.jpg",
    2:"https://i.ytimg.com/vi/H0JMACH0hy4/sddefault.jpg",
    3:"https://i.ytimg.com/vi/IN0PORisHSs/hq720.jpg",
    4:"https://i.ytimg.com/vi/Mzttgw4LuPA/hq720.jpg",
    5:"https://i.ytimg.com/vi/TjiNmDf9p0Y/sddefault.jpg"
} */ const $2b6e161c9edcf319$var$thumbnails = [
    (0, (/*@__PURE__*/$parcel$interopDefault($384ce38d072dc7f7$exports))),
    (0, (/*@__PURE__*/$parcel$interopDefault($3f6a90922b0842fa$exports))),
    (0, (/*@__PURE__*/$parcel$interopDefault($20393ec9509e964d$exports))),
    (0, (/*@__PURE__*/$parcel$interopDefault($d7ebf84f4c1dd3f5$exports))),
    (0, (/*@__PURE__*/$parcel$interopDefault($6c398bc4e99e73ee$exports))),
    (0, (/*@__PURE__*/$parcel$interopDefault($118dfab1de38582c$exports)))
];
let $2b6e161c9edcf319$var$move_target = [];
function $2b6e161c9edcf319$var$prepareMVimg(music_num) {
    $2b6e161c9edcf319$var$move_target = [];
    const img = new Image();
    //img.crossOrigin = 'Anonymous';
    console.log($2b6e161c9edcf319$var$thumbnails[music_num]);
    img.src = $2b6e161c9edcf319$var$thumbnails[music_num];
    img.onload = ()=>{
        const scale = 1;
        const scaledWidth = 160 * scale;
        const scaledHeight = 90 * scale;
        const canvas = document.createElement('canvas');
        const ctx = canvas.getContext("2d");
        const sourceWidth = img.width;
        const sourceHeight = img.height;
        // 上下をカットしたい → 中央部をトリミング
        const cropTop = 45; // 上からカット
        const cropBottom = 45; // 下からカット
        const cropHeight = sourceHeight - cropTop - cropBottom;
        // 出力サイズ
        const targetWidth = 160 * scale;
        const targetHeight = 90 * scale;
        canvas.width = targetWidth;
        canvas.height = targetHeight;
        // drawImage の第2引数以降でトリミング指定
        ctx.drawImage(img, 0, cropTop, sourceWidth, cropHeight, 0, 0, targetWidth, targetHeight // 出力先キャンバスの描画範囲
        );
        const imageData = ctx.getImageData(0, 0, scaledWidth, scaledHeight);
        const pixels = imageData.data;
        for(let y = 0; y < scaledHeight; y++)for(let x = 0; x < scaledWidth; x++){
            const i = (y * scaledWidth + x) * 4;
            const r = pixels[i];
            const g = pixels[i + 1];
            const b = pixels[i + 2];
            //console.log(`(${x}, ${y}) = rgb(${r}, ${g}, ${b})`);
            const center = new $dyjou.Vector3(1500, 1500, 0);
            for(let k = 0; k < 5; k++){
                let Adjusted_z = -((scaledWidth / 2 - x) * 5 + k);
                let Adjusted_y = -((scaledHeight / 2 - y) * 5 + k);
                const rotatedX = Adjusted_y * Math.cos(-Math.PI / 4);
                const rotatedY = Adjusted_y * Math.sin(-Math.PI / 4);
                $2b6e161c9edcf319$var$move_target.push({
                    "z": Adjusted_z,
                    "y": rotatedY,
                    "x": rotatedX,
                    "color": new $dyjou.Color(r / 255, g / 255, b / 255),
                    "center": center
                });
            }
        }
        $2b6e161c9edcf319$var$GalaxyTransforming = true;
    };
}
const $2b6e161c9edcf319$var$GalaxyTransform_duration = 5000;
let $2b6e161c9edcf319$var$GalaxyTransformStart_time = undefined;
let $2b6e161c9edcf319$var$GalaxyTransforming = false;
let $2b6e161c9edcf319$var$Transform_progress = 0;
let $2b6e161c9edcf319$var$start_pos;
let $2b6e161c9edcf319$var$start_color;
let $2b6e161c9edcf319$var$start_opacity;
let $2b6e161c9edcf319$var$start_opacity_cloud;
let $2b6e161c9edcf319$var$move_center = false;
let $2b6e161c9edcf319$var$center_goal = new $dyjou.Vector3(5, 5, 0);
function $2b6e161c9edcf319$var$transform_stars() {
    if ($2b6e161c9edcf319$var$GalaxyTransforming) {
        if ($2b6e161c9edcf319$var$GalaxyTransformStart_time === undefined) {
            $2b6e161c9edcf319$var$GalaxyTransformStart_time = performance.now();
            $2b6e161c9edcf319$var$start_pos = Array.from($2b6e161c9edcf319$var$galazy_star_geometory.attributes.position.array);
            $2b6e161c9edcf319$var$start_color = Array.from($2b6e161c9edcf319$var$galazy_star_geometory.attributes.color.array);
            $2b6e161c9edcf319$var$start_opacity = $2b6e161c9edcf319$var$galaxy_star_points.material.opacity;
            $2b6e161c9edcf319$var$start_opacity_cloud = $2b6e161c9edcf319$var$cloudsprite.material.opacity;
        }
        const now = performance.now();
        const galaxystar_positions = $2b6e161c9edcf319$var$galazy_star_geometory.attributes.position.array;
        const galaxystar_colors = $2b6e161c9edcf319$var$galazy_star_geometory.attributes.color.array;
        const past_time_ms = now - $2b6e161c9edcf319$var$GalaxyTransformStart_time;
        $2b6e161c9edcf319$var$Transform_progress = past_time_ms / $2b6e161c9edcf319$var$GalaxyTransform_duration;
        if ($2b6e161c9edcf319$var$Transform_progress >= 1) {
            $2b6e161c9edcf319$var$Transform_progress = 0;
            $2b6e161c9edcf319$var$GalaxyTransformStart_time = undefined;
            $2b6e161c9edcf319$var$GalaxyTransforming = false;
            $2b6e161c9edcf319$var$scene.remove($2b6e161c9edcf319$var$cloudsprite);
            $2b6e161c9edcf319$var$cloudtexture.dispose();
            $2b6e161c9edcf319$var$cloudmaterial.dispose();
            return;
        }
        const eased_progress = $2b6e161c9edcf319$var$easeInOutCubic($2b6e161c9edcf319$var$Transform_progress);
        let index = 0;
        $2b6e161c9edcf319$var$arms_data.forEach((arms)=>{
            //const target = move_target[Math.floor(index/5)];
            const target = $2b6e161c9edcf319$var$move_target[index];
            let center = target.center;
            if ($2b6e161c9edcf319$var$move_center) {
                center = new $dyjou.Vector3().lerpVectors(center, $2b6e161c9edcf319$var$center_goal, eased_progress);
                $2b6e161c9edcf319$var$galaxy_star_points.material.opacity = $2b6e161c9edcf319$var$start_opacity * (1 - eased_progress) + 0.2 * eased_progress;
            } else $2b6e161c9edcf319$var$galaxy_star_points.material.opacity = $2b6e161c9edcf319$var$start_opacity * (1 - eased_progress) + 0.015 * eased_progress;
            const start = new $dyjou.Vector3($2b6e161c9edcf319$var$start_pos[index * 3], $2b6e161c9edcf319$var$start_pos[index * 3 + 1], $2b6e161c9edcf319$var$start_pos[index * 3 + 2]);
            const end = new $dyjou.Vector3(target.x + center.x, target.y + center.y, target.z + center.z);
            const current = new $dyjou.Vector3().lerpVectors(start, end, eased_progress);
            galaxystar_positions[index * 3] = current.x;
            galaxystar_positions[index * 3 + 1] = current.y;
            galaxystar_positions[index * 3 + 2] = current.z;
            const r_start = $2b6e161c9edcf319$var$start_color[index * 3];
            const g_start = $2b6e161c9edcf319$var$start_color[index * 3 + 1];
            const b_start = $2b6e161c9edcf319$var$start_color[index * 3 + 2];
            const r_end = target.color.r * 35.7;
            const g_end = target.color.g * 35.7;
            const b_end = target.color.b * 35.7;
            galaxystar_colors[index * 3] = r_start * (1 - eased_progress) + r_end * eased_progress;
            galaxystar_colors[index * 3 + 1] = g_start * (1 - eased_progress) + g_end * eased_progress;
            galaxystar_colors[index * 3 + 2] = b_start * (1 - eased_progress) + b_end * eased_progress;
            $2b6e161c9edcf319$var$cloudsprite.material.opacity = $2b6e161c9edcf319$var$start_opacity_cloud * (1 - eased_progress) + 0 * eased_progress;
            index++;
        });
        $2b6e161c9edcf319$var$galazy_star_geometory.attributes.position.needsUpdate = true;
        $2b6e161c9edcf319$var$galazy_star_geometory.attributes.color.needsUpdate = true;
        $2b6e161c9edcf319$var$galaxy_star_points.material.needsUpdate = true;
    }
}
const $2b6e161c9edcf319$var$escape_explanation_button = document.getElementById("escape_explanation");
const $2b6e161c9edcf319$var$first_explanation_ele = document.getElementById("first_explanation");
$2b6e161c9edcf319$var$escape_explanation_button.addEventListener("click", ()=>{
    $2b6e161c9edcf319$var$first_explanation_ele.style.display = "none";
});
const $2b6e161c9edcf319$var$close_parent_settings_button = document.getElementById("close_parent_settings");
const $2b6e161c9edcf319$var$gyro_settings_ele = document.getElementById("gyro_settings");
const $2b6e161c9edcf319$var$gyro_setting_icon = document.getElementById("gyro_setting_icon");
$2b6e161c9edcf319$var$gyro_setting_icon.addEventListener("click", ()=>{
    $2b6e161c9edcf319$var$gyro_setting_icon.style.display = "none";
    $2b6e161c9edcf319$var$gyro_settings_ele.style.display = "block";
});
$2b6e161c9edcf319$var$close_parent_settings_button.addEventListener("click", ()=>{
    $2b6e161c9edcf319$var$gyro_settings_ele.style.display = "none";
    $2b6e161c9edcf319$var$gyro_setting_icon.style.display = "block";
});
const $2b6e161c9edcf319$var$switch_area3_ele = document.getElementById("switch_area3");
const $2b6e161c9edcf319$var$switch_area3_2_ele = document.getElementById("switch_area3_2");
const $2b6e161c9edcf319$var$switch3 = document.getElementById("switch3");
const $2b6e161c9edcf319$var$switch3_2 = document.getElementById("switch3_2");
const $2b6e161c9edcf319$var$reset_rotate_origin_button = document.getElementById("reset_rotate_origin");
$2b6e161c9edcf319$var$switch_area3_ele.addEventListener("click", ()=>{
    $2b6e161c9edcf319$var$switch3_2.checked = $2b6e161c9edcf319$var$switch3.checked;
    //is_gyro = switch3.checked;
    if ($2b6e161c9edcf319$var$switch3.checked) {
        $2b6e161c9edcf319$var$deviceorientation_count = 0;
        if (typeof DeviceOrientationEvent.requestPermission === 'function') DeviceOrientationEvent.requestPermission().then((permission)=>{
            if (permission === "granted") {
                $2b6e161c9edcf319$var$is_gyro = true;
                $2b6e161c9edcf319$var$reset_rotate_origin_button.style.display = "block";
            } else {
                $2b6e161c9edcf319$var$is_gyro = false;
                alert("\u30B8\u30E3\u30A4\u30ED\u30BB\u30F3\u30B5\u30FC\u3078\u306E\u30A2\u30AF\u30BB\u30B9\u304C\u62D2\u5426\u3055\u308C\u307E\u3057\u305F\u3002");
            }
        }).catch((error)=>{
            $2b6e161c9edcf319$var$is_gyro = false;
            alert("\u30B8\u30E3\u30A4\u30ED\u30BB\u30F3\u30B5\u30FC\u306E\u8A31\u53EF\u53D6\u5F97\u4E2D\u306B\u30A8\u30E9\u30FC\u304C\u767A\u751F\u3057\u307E\u3057\u305F: " + error);
        });
        else $2b6e161c9edcf319$var$is_gyro = true;
    } else $2b6e161c9edcf319$var$is_gyro = false;
    if (!$2b6e161c9edcf319$var$is_gyro) {
        $2b6e161c9edcf319$var$yaw = ($2b6e161c9edcf319$var$camera.rotation.y / Math.PI * 180 % 360 + 360) % 360 / 180 * Math.PI;
        $2b6e161c9edcf319$var$pitch = ($2b6e161c9edcf319$var$camera.rotation.x / Math.PI * 180 % 360 + 360) % 360 / 180 * Math.PI;
        $2b6e161c9edcf319$var$reset_rotate_origin_button.style.display = "none";
    } else $2b6e161c9edcf319$var$reset_rotate_origin_button.style.display = "block";
});
$2b6e161c9edcf319$var$switch_area3_2_ele.addEventListener("click", async ()=>{
    $2b6e161c9edcf319$var$switch3.checked = $2b6e161c9edcf319$var$switch3_2.checked;
    //is_gyro = switch3_2.checked;
    if ($2b6e161c9edcf319$var$switch3_2.checked) {
        $2b6e161c9edcf319$var$deviceorientation_count = 0;
        if (typeof DeviceOrientationEvent.requestPermission === 'function') DeviceOrientationEvent.requestPermission().then((permission)=>{
            if (permission === "granted") {
                $2b6e161c9edcf319$var$is_gyro = true;
                $2b6e161c9edcf319$var$reset_rotate_origin_button.style.display = "block";
            } else {
                $2b6e161c9edcf319$var$is_gyro = false;
                alert("\u30B8\u30E3\u30A4\u30ED\u30BB\u30F3\u30B5\u30FC\u3078\u306E\u30A2\u30AF\u30BB\u30B9\u304C\u62D2\u5426\u3055\u308C\u307E\u3057\u305F\u3002");
            }
        }).catch((error)=>{
            $2b6e161c9edcf319$var$is_gyro = false;
            alert("\u30B8\u30E3\u30A4\u30ED\u30BB\u30F3\u30B5\u30FC\u306E\u8A31\u53EF\u53D6\u5F97\u4E2D\u306B\u30A8\u30E9\u30FC\u304C\u767A\u751F\u3057\u307E\u3057\u305F: " + error);
        });
        else $2b6e161c9edcf319$var$is_gyro = true;
    } else $2b6e161c9edcf319$var$is_gyro = false;
    if (!$2b6e161c9edcf319$var$is_gyro) {
        $2b6e161c9edcf319$var$yaw = ($2b6e161c9edcf319$var$camera.rotation.y / Math.PI * 180 % 360 + 360) % 360 / 180 * Math.PI;
        $2b6e161c9edcf319$var$pitch = ($2b6e161c9edcf319$var$camera.rotation.x / Math.PI * 180 % 360 + 360) % 360 / 180 * Math.PI;
        $2b6e161c9edcf319$var$reset_rotate_origin_button.style.display = "none";
    } else $2b6e161c9edcf319$var$reset_rotate_origin_button.style.display = "block";
});
$2b6e161c9edcf319$var$reset_rotate_origin_button.addEventListener("click", ()=>{
    $2b6e161c9edcf319$var$deviceorientation_count = 0;
    $2b6e161c9edcf319$var$reset_offset = true;
}) //create_galaxy();
 //prepareMVimg(1);
;


//# sourceMappingURL=contest_2025.e1b32e89.js.map
